webpackJsonp([0],{

/***/ "+2NB":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gCWN");
__webpack_require__("tz60");
__webpack_require__("+3lO");
__webpack_require__("YMM6");
__webpack_require__("8knk");
__webpack_require__("Gcf6");
__webpack_require__("JmWi");
module.exports = __webpack_require__("iANj").Set;


/***/ }),

/***/ "+3lO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("abPz");
var global = __webpack_require__("YjQv");
var hide = __webpack_require__("aLzV");
var Iterators = __webpack_require__("yYxz");
var TO_STRING_TAG = __webpack_require__("hgbu")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "+GuK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__("Wdy1");
var core = __webpack_require__("iANj");
var global = __webpack_require__("YjQv");
var speciesConstructor = __webpack_require__("BfX3");
var promiseResolve = __webpack_require__("qC2Z");

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),

/***/ "+HRN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__("X3l8").Buffer;
var util = __webpack_require__(14);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),

/***/ "+MZ2":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "+SdG":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("a/OS")('keys');
var uid = __webpack_require__("GmwO");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "+VX5":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("W6Rd");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "+e0g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__("3PYz");
var curves = __webpack_require__("hQ80");
var utils = __webpack_require__("TkWM");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__("RzOE");
var Signature = __webpack_require__("hkfz");

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),

/***/ "+f9m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _merge = _interopRequireDefault(__webpack_require__("40O2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

module.exports = function (h) {
  var _this = this;

  return function (classes) {
    if (!_this.opts.filterByColumn || !_this.opts.filterable) return '';

    var textFilter = __webpack_require__("fum+").call(_this, h, classes.input);

    var dateFilter = __webpack_require__("GwML").call(_this, h);

    var listFilter = __webpack_require__("d1oy").call(_this, h, classes.select);

    var filters = [];
    var filter;
    if (_this.hasChildRow && _this.opts.childRowTogglerFirst && _this.opts.showChildRowToggler) filters.push(h("th"));

    _this.allColumns.map(function (column) {
      var filter = '';

      if (_this.filterable(column)) {
        switch (true) {
          case _this.isTextFilter(column):
            filter = textFilter(column);
            break;

          case _this.isDateFilter(column):
            filter = dateFilter(column);
            break;

          case _this.isListFilter(column):
            filter = listFilter(column);
            break;
        }
      }

      if (typeof _this.$slots["filter__".concat(column)] !== 'undefined') {
        filter = filter ? h("div", [filter, _this.$slots["filter__".concat(column)]]) : _this.$slots["filter__".concat(column)];
      }

      filters.push(h("th", {
        "class": _this.columnClass(column)
      }, [h("div", _defineProperty({
        "class": "VueTables__column-filter"
      }, "class", 'VueTables__' + column + '-filter-wrapper'), [filter])]));
    });

    if (_this.hasChildRow && !_this.opts.childRowTogglerFirst && _this.opts.showChildRowToggler) filters.push(h("th"));
    return h("tr", {
      "class": "VueTables__filters-row"
    }, [filters]);
  };
};

/***/ }),

/***/ "+iDZ":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("YjQv").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "+jDU":
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__("/y0r")
var Buffer = __webpack_require__("X3l8").Buffer
var MODES = __webpack_require__("BCiZ")
var StreamCipher = __webpack_require__("6hW9")
var Transform = __webpack_require__("z+8S")
var aes = __webpack_require__("BEbT")
var ebtk = __webpack_require__("Cgw8")
var inherits = __webpack_require__("LC74")

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),

/***/ "+zJ9":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("GmwO")('meta');
var isObject = __webpack_require__("8ANE");
var has = __webpack_require__("x//u");
var setDesc = __webpack_require__("GCs6").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("zyKz")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "/+iU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("iP15")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("xXuq");
/*</replacement>*/

var Buffer = __webpack_require__("EuP9").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__("EzfO");
var _require = __webpack_require__("hBHd"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__("WrlE").codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__("LC74")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("PBMQ");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__("PBMQ");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "//Fk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("x/31"), __esModule: true };

/***/ }),

/***/ "/MLu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cSWu").PassThrough


/***/ }),

/***/ "/OYm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = __webpack_require__("3U89").codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__("PhfM");
__webpack_require__("LC74")(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ "/PoJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var sortAll = typeof this.opts.sortable == 'boolean' && this.opts.sortable;
  if (sortAll) return true;
  return this.opts.sortable.indexOf(column) > -1;
};

/***/ }),

/***/ "/j9d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  if (this.opts.dateFormatPerColumn.hasOwnProperty(column)) {
    return this.opts.dateFormatPerColumn[column];
  }

  return this.opts.dateFormat;
};

/***/ }),

/***/ "/jav":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (name) {
  if (!name) return name;
  name = name.split('__');
  name.shift();
  return name.join('__').split('@@@').join('.');
};

/***/ }),

/***/ "/ocq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),

/***/ "/vd3":
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__("GUE9")
exports.pbkdf2Sync = __webpack_require__("Zq1s")


/***/ }),

/***/ "/y0r":
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__("BEbT")
var Buffer = __webpack_require__("X3l8").Buffer
var Transform = __webpack_require__("z+8S")
var inherits = __webpack_require__("LC74")
var GHASH = __webpack_require__("UPHp")
var xor = __webpack_require__("H2Pp")
var incr32 = __webpack_require__("4sPJ")

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),

/***/ "0/jl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("YjQv");
var has = __webpack_require__("x//u");
var DESCRIPTORS = __webpack_require__("qs+f");
var $export = __webpack_require__("Wdy1");
var redefine = __webpack_require__("1RnF");
var META = __webpack_require__("+zJ9").KEY;
var $fails = __webpack_require__("zyKz");
var shared = __webpack_require__("a/OS");
var setToStringTag = __webpack_require__("LhDF");
var uid = __webpack_require__("GmwO");
var wks = __webpack_require__("hgbu");
var wksExt = __webpack_require__("4DQ7");
var wksDefine = __webpack_require__("Ntt2");
var enumKeys = __webpack_require__("6rdy");
var isArray = __webpack_require__("NU0k");
var anObject = __webpack_require__("FKWp");
var isObject = __webpack_require__("8ANE");
var toObject = __webpack_require__("wXdB");
var toIObject = __webpack_require__("ksFB");
var toPrimitive = __webpack_require__("9MbE");
var createDesc = __webpack_require__("YTz9");
var _create = __webpack_require__("NZ8V");
var gOPNExt = __webpack_require__("6tLb");
var $GOPD = __webpack_require__("rjjF");
var $GOPS = __webpack_require__("THEY");
var $DP = __webpack_require__("GCs6");
var $keys = __webpack_require__("pEGt");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("2m2c").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("bSeU").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("c8Kh")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("aLzV")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "08Lv":
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),

/***/ "0BLp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) == -1 && !this.opts.listColumns.hasOwnProperty(column);
};

/***/ }),

/***/ "0IYo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "0Lvz":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("W6Rd");
var defined = __webpack_require__("+MZ2");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0i9N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h, classes, columns) {
  if (classes.framework === 'bulma') {
    return h("div", {
      "class": classes.dropdown.menu,
      style: this.displayColumnsDropdown ? 'display:block' : 'display:none'
    }, [h("div", {
      "class": classes.dropdown.content
    }, [columns])]);
  }

  if (classes.framework === 'bootstrap4') {
    return h("div", {
      "class": classes.dropdown.menu,
      style: this.displayColumnsDropdown ? 'display:block' : 'display:none'
    }, [columns]);
  }

  return h("ul", {
    "class": classes.dropdown.menu,
    style: this.displayColumnsDropdown ? 'display:block' : 'display:none'
  }, [columns]);
};

/***/ }),

/***/ "162o":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("mypn");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "16On":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



var inherits = __webpack_require__("LC74");

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null) state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err = void 0;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function (elem) {
      return '[' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial) throw err;

  if (!inherited) state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial) return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
}
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace) Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};

/***/ }),

/***/ "19bf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__("KDHK")

exports.certificate = __webpack_require__("lQBd")

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),

/***/ "1H6C":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__("HhN8");

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),

/***/ "1I8z":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__("c5AH")('WeakMap');


/***/ }),

/***/ "1I9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return directive; });
/* unused harmony export VueMaskPlugin */
function format (text, wholeMask) {
  if (!wholeMask) return text;
  var maskStartRegExp = /^([^#ANX]+)/;

  if (+text.length === 1 && maskStartRegExp.test(wholeMask)) {
    text = maskStartRegExp.exec(wholeMask)[0] + text;
  }

  var newText = '';
  var charOffset = 0;

  for (var maskIndex = 0; maskIndex < wholeMask.length; maskIndex += 1) {
    var mask = wholeMask.charAt(maskIndex);

    switch (mask) {
      case '#':
        break;

      case 'A':
        break;

      case '?':
        break;

      case 'N':
        break;

      case 'X':
        break;

      default:
        text = text.replace(mask, '');
    }
  }

  for (var _maskIndex = 0, x = 1; x && _maskIndex < wholeMask.length; _maskIndex += 1) {
    var char = text.charAt(_maskIndex - charOffset);

    var _mask = wholeMask.charAt(_maskIndex);

    switch (_mask) {
      case '#':
        /\d/.test(char) ? newText += char : x = 0;
        break;

      case 'A':
        /[a-z]/i.test(char) ? newText += char : x = 0;
        break;

      case 'N':
        /[a-z0-9]/i.test(char) ? newText += char : x = 0;
        break;

      case '?':
        charOffset += 1;
        break;

      case 'X':
        newText += char;
        break;

      default:
        newText += _mask;

        if (char && char !== _mask) {
          text = " ".concat(text);
        }

        break;
    }
  }

  return newText;
}

var trigger = function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};
var queryInputElementInside = function queryInputElementInside(el) {
  return el instanceof HTMLInputElement ? el : el.querySelector('input') || el;
};

var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = UA && UA.indexOf('android') > 0;
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

function updateValue(el) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var value = el.value,
      _el$dataset = el.dataset,
      _el$dataset$previousV = _el$dataset.previousValue,
      previousValue = _el$dataset$previousV === void 0 ? '' : _el$dataset$previousV,
      mask = _el$dataset.mask;

  if (force || value && value !== previousValue && value.length > previousValue.length) {
    el.value = format(value, mask);

    if (isAndroid && isChrome) {
      setTimeout(function () {
        return trigger(el, 'input');
      }, 0);
    } else {
      trigger(el, 'input');
    }
  }

  el.dataset.previousValue = value;
}

function updateMask(el, mask) {
  el.dataset.mask = mask;
}

var directive = {
  bind: function bind(el, _ref) {
    var value = _ref.value;
    el = queryInputElementInside(el);
    updateMask(el, value);
    updateValue(el);
  },
  componentUpdated: function componentUpdated(el, _ref2) {
    var value = _ref2.value,
        oldValue = _ref2.oldValue;
    el = queryInputElementInside(el);
    var isMaskChanged = value !== oldValue;

    if (isMaskChanged) {
      updateMask(el, value);
    }

    updateValue(el, isMaskChanged);
  }
};

var plugin = (function (Vue) {
  Vue.directive('mask', directive);
});

/* unused harmony default export */ var _unused_webpack_default_export = (plugin);



/***/ }),

/***/ "1RnF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("aLzV");


/***/ }),

/***/ "1Yoh":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "1h2p":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("xZ+b");
module.exports = __webpack_require__("iANj").Math.clz32;


/***/ }),

/***/ "1jZ2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("YjQv");
var $export = __webpack_require__("Wdy1");
var meta = __webpack_require__("+zJ9");
var fails = __webpack_require__("zyKz");
var hide = __webpack_require__("aLzV");
var redefineAll = __webpack_require__("nJ75");
var forOf = __webpack_require__("dudK");
var anInstance = __webpack_require__("4S0F");
var isObject = __webpack_require__("8ANE");
var setToStringTag = __webpack_require__("LhDF");
var dP = __webpack_require__("GCs6").f;
var each = __webpack_require__("eAa1")(0);
var DESCRIPTORS = __webpack_require__("qs+f");

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ "1lLf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");
var inherits = __webpack_require__("LC74");

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),

/***/ "1yV6":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("FHqv");
var ITERATOR = __webpack_require__("hgbu")('iterator');
var Iterators = __webpack_require__("yYxz");
module.exports = __webpack_require__("iANj").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "21It":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("FtD3");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "24Y6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("TkWM");
var BN = __webpack_require__("YP8Q");
var inherits = __webpack_require__("LC74");
var Base = __webpack_require__("B6Bn");

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  var e;
  var h;
  var j;
  if (this.curve.twisted) {
    // E = a * C
    e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      h = this.z.redSqr();
      // J = F - 2 * H
      j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    e = c.redAdd(d);
    // H = (c * Z1)^2
    h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),

/***/ "2Ejg":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(12).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "2JY6":
/***/ (function(module, exports) {

var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

module.exports = function (iterations, keylen) {
  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}


/***/ }),

/***/ "2OQD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (e, dateEvent) {
  // we need to handle the store this.query to make sure we're not mutating outside of it
  var query = this.vuex ? JSON.parse(JSON.stringify(this.query)) : this.query; // in case we pass an object manually (mostly used for init-date-filters should refactor

  if (Object.prototype.toString.call(e).slice(8, -1) == 'Object') {
    query = this.vuex ? JSON.parse(JSON.stringify(e)) : e;
    if (!this.vuex) this.query = query;
    var name = dateEvent.target.name;
    var value = dateEvent.target.value;

    if (name) {
      this.dispatch('filter', {
        name: name,
        value: value
      });
      this.dispatch("filter::".concat(name), value);
    } else {
      this.dispatch('filter', value);
    }

    this.updateState('query', query);
  } else if (e) {
    var _name = this.getName(e.target.name);

    var _value = e.target.value;

    if (_name) {
      query[_name] = _value;
    } else {
      query = _value;
    }

    if (!this.vuex) this.query = query;

    if (_name) {
      this.dispatch('filter', {
        name: _name,
        value: _value
      });
      this.dispatch("filter::".concat(_name), _value);
    } else {
      this.dispatch('filter', _value);
    }

    this.updateState('query', query);
  }

  return search(this, query);
};

function search(that, query) {
  if (that.vuex) {
    that.commit('SET_FILTER', query);
  } else {
    that.initPagination();

    if (that.opts.pagination.dropdown) {
      that.getData();
    }
  }
}

function noDebounce(e, name, opts) {
  return !e || name && (opts.dateColumns.indexOf(name) > -1 || Object.keys(opts.listColumns).indexOf(name) > -1);
}

/***/ }),

/***/ "2Wyf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h, right) {
  return function (column) {
    if (!this.sortable(column)) return '';
    return h("span", {
      "class": "VueTables__sort-icon ".concat(right, " ").concat(this.sortableChevronClass(column))
    });
  };
};

/***/ }),

/***/ "2dp2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (template, theme) {
  var themes = {
    bootstrap3: __webpack_require__("W52Q")(),
    bootstrap4: __webpack_require__("rp/e")(),
    bulma: __webpack_require__("nVNB")()
  };
  var templates = {
    "default": __webpack_require__("6WUN"),
    footerPagination: __webpack_require__("AZDW")
  };
  return function (h) {
    var modules = {
      rows: __webpack_require__("cKOs").call(this, h),
      normalFilter: __webpack_require__("FOZt").call(this, h),
      dropdownPagination: __webpack_require__("k4z0").call(this, h),
      dropdownPaginationCount: __webpack_require__("Mf+e").call(this, h),
      columnFilters: __webpack_require__("+f9m").call(this, h),
      pagination: __webpack_require__("BKcr").call(this, h),
      headings: __webpack_require__("l9cS").call(this, h),
      perPage: __webpack_require__("3Rl0").call(this, h),
      columnsDropdown: __webpack_require__("kGpW").call(this, h)
    };

    if (typeof template === 'string' && (!templates[template] || typeof templates[template] !== 'function')) {
      throw "vue-tables-2: Template \"".concat(template, "\" does not exist");
    }

    if (typeof theme === 'string' && (!themes[theme] || _typeof(themes[theme]) !== 'object')) {
      throw "vue-tables-2: Theme \"".concat(theme, "\" does not exist");
    }

    var tpl = typeof template === 'string' ? templates[template] : template;
    var thm = typeof theme === 'string' ? themes[theme] : theme();

    var slots = __webpack_require__("O70t").call(this);

    return tpl.call(this, h, modules, thm, slots);
  };
};

/***/ }),

/***/ "2kY9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("eaCm");
var validate = __webpack_require__("fTPD");
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__("1jZ2")(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),

/***/ "2m2c":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("DvwR");
var hiddenKeys = __webpack_require__("B5V0").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "30vf":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("Wdy1");
var core = __webpack_require__("iANj");
var fails = __webpack_require__("zyKz");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "31fY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __vue_component__$6; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan__ = __webpack_require__("MICi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_own_property_symbols__ = __webpack_require__("8hRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_is_iterable__ = __webpack_require__("us/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_is_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_is_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol__);














/**
 * vue-good-table v2.21.11
 * (c) 2018-present xaksis <shay@crayonbits.com>
 * https://github.com/xaksis/vue-good-table
 * Released under the MIT License.
 */

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol___default.a === "function" && __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_symbol_iterator___default.a) === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(obj);
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_define_property___default()(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol___default.a !== "undefined" && __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_is_iterable___default()(Object(iter))) return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from___default()(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof __WEBPACK_IMPORTED_MODULE_13_babel_runtime_core_js_symbol___default.a === "undefined" || !__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_is_iterable___default()(Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from___default()(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var DEFAULT_SORT_TYPE = 'asc';
var SORT_TYPES = {
  Ascending: 'asc',
  Descending: 'desc',
  None: 'none'
};
var PAGINATION_MODES = {
  Pages: 'pages',
  Records: 'records'
};
var DEFAULT_ROWS_PER_PAGE_DROPDOWN = [10, 20, 30, 40, 50];

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
  return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var lodash_isequal = createCommonjsModule(function (module, exports) {
  /**
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright JS Foundation and other contributors <https://js.foundation/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used as references for various `Number` constants. */
  var MAX_SAFE_INTEGER = 9007199254740991;

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = (typeof commonjsGlobal === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(commonjsGlobal)) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  /** Detect free variable `self`. */
  var freeSelf = (typeof self === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(self)) == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  /* Node.js helper references. */
  var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }

  /** Used for built-in method references. */
  var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;

  /** Used to detect overreaching core-js shims. */
  var coreJsData = root['__core-js_shared__'];

  /** Used to resolve the decompiled source of functions. */
  var funcToString = funcProto.toString;

  /** Used to check objects for own properties. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to detect methods masquerading as native. */
  var maskSrcKey = function () {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
  }();

  /**
   * Used to resolve the
   * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
   * of values.
   */
  var nativeObjectToString = objectProto.toString;

  /** Used to detect if a method is native. */
  var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

  /** Built-in value references. */
  var Buffer = moduleExports ? root.Buffer : undefined,
      _Symbol2 = root.Symbol,
      Uint8Array = root.Uint8Array,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      symToStringTag = _Symbol2 ? _Symbol2.toStringTag : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeGetSymbols = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_own_property_symbols___default.a,
      nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeKeys = overArg(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default.a, Object);

  /* Built-in method references that are verified to be native. */
  var DataView = getNative(root, 'DataView'),
      Map = getNative(root, 'Map'),
      Promise = getNative(root, 'Promise'),
      Set = getNative(root, 'Set'),
      WeakMap = getNative(root, 'WeakMap'),
      nativeCreate = getNative(Object, 'create');

  /** Used to detect maps, sets, and weakmaps. */
  var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);

  /** Used to convert symbols to primitives and strings. */
  var symbolProto = _Symbol2 ? _Symbol2.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

  /**
   * Creates a hash object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the hash.
   *
   * @private
   * @name clear
   * @memberOf Hash
   */
  function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the hash.
   *
   * @private
   * @name delete
   * @memberOf Hash
   * @param {Object} hash The hash to modify.
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
  }

  /**
   * Gets the hash value for `key`.
   *
   * @private
   * @name get
   * @memberOf Hash
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
      var result = data[key];
      return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
  }

  /**
   * Checks if a hash value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Hash
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
  }

  /**
   * Sets the hash `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Hash
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the hash instance.
   */
  function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
  }

  // Add methods to `Hash`.
  Hash.prototype.clear = hashClear;
  Hash.prototype['delete'] = hashDelete;
  Hash.prototype.get = hashGet;
  Hash.prototype.has = hashHas;
  Hash.prototype.set = hashSet;

  /**
   * Creates an list cache object.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the list cache.
   *
   * @private
   * @name clear
   * @memberOf ListCache
   */
  function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the list cache.
   *
   * @private
   * @name delete
   * @memberOf ListCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function listCacheDelete(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index == lastIndex) {
      data.pop();
    } else {
      splice.call(data, index, 1);
    }
    --this.size;
    return true;
  }

  /**
   * Gets the list cache value for `key`.
   *
   * @private
   * @name get
   * @memberOf ListCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function listCacheGet(key) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    return index < 0 ? undefined : data[index][1];
  }

  /**
   * Checks if a list cache value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf ListCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
  }

  /**
   * Sets the list cache `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf ListCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the list cache instance.
   */
  function listCacheSet(key, value) {
    var data = this.__data__,
        index = assocIndexOf(data, key);

    if (index < 0) {
      ++this.size;
      data.push([key, value]);
    } else {
      data[index][1] = value;
    }
    return this;
  }

  // Add methods to `ListCache`.
  ListCache.prototype.clear = listCacheClear;
  ListCache.prototype['delete'] = listCacheDelete;
  ListCache.prototype.get = listCacheGet;
  ListCache.prototype.has = listCacheHas;
  ListCache.prototype.set = listCacheSet;

  /**
   * Creates a map cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
      var entry = entries[index];
      this.set(entry[0], entry[1]);
    }
  }

  /**
   * Removes all key-value entries from the map.
   *
   * @private
   * @name clear
   * @memberOf MapCache
   */
  function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
      'hash': new Hash(),
      'map': new (Map || ListCache)(),
      'string': new Hash()
    };
  }

  /**
   * Removes `key` and its value from the map.
   *
   * @private
   * @name delete
   * @memberOf MapCache
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
  }

  /**
   * Gets the map value for `key`.
   *
   * @private
   * @name get
   * @memberOf MapCache
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function mapCacheGet(key) {
    return getMapData(this, key).get(key);
  }

  /**
   * Checks if a map value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf MapCache
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function mapCacheHas(key) {
    return getMapData(this, key).has(key);
  }

  /**
   * Sets the map `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf MapCache
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the map cache instance.
   */
  function mapCacheSet(key, value) {
    var data = getMapData(this, key),
        size = data.size;

    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
  }

  // Add methods to `MapCache`.
  MapCache.prototype.clear = mapCacheClear;
  MapCache.prototype['delete'] = mapCacheDelete;
  MapCache.prototype.get = mapCacheGet;
  MapCache.prototype.has = mapCacheHas;
  MapCache.prototype.set = mapCacheSet;

  /**
   *
   * Creates an array cache object to store unique values.
   *
   * @private
   * @constructor
   * @param {Array} [values] The values to cache.
   */
  function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
      this.add(values[index]);
    }
  }

  /**
   * Adds `value` to the array cache.
   *
   * @private
   * @name add
   * @memberOf SetCache
   * @alias push
   * @param {*} value The value to cache.
   * @returns {Object} Returns the cache instance.
   */
  function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
  }

  /**
   * Checks if `value` is in the array cache.
   *
   * @private
   * @name has
   * @memberOf SetCache
   * @param {*} value The value to search for.
   * @returns {number} Returns `true` if `value` is found, else `false`.
   */
  function setCacheHas(value) {
    return this.__data__.has(value);
  }

  // Add methods to `SetCache`.
  SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
  SetCache.prototype.has = setCacheHas;

  /**
   * Creates a stack cache object to store key-value pairs.
   *
   * @private
   * @constructor
   * @param {Array} [entries] The key-value pairs to cache.
   */
  function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
  }

  /**
   * Removes all key-value entries from the stack.
   *
   * @private
   * @name clear
   * @memberOf Stack
   */
  function stackClear() {
    this.__data__ = new ListCache();
    this.size = 0;
  }

  /**
   * Removes `key` and its value from the stack.
   *
   * @private
   * @name delete
   * @memberOf Stack
   * @param {string} key The key of the value to remove.
   * @returns {boolean} Returns `true` if the entry was removed, else `false`.
   */
  function stackDelete(key) {
    var data = this.__data__,
        result = data['delete'](key);

    this.size = data.size;
    return result;
  }

  /**
   * Gets the stack value for `key`.
   *
   * @private
   * @name get
   * @memberOf Stack
   * @param {string} key The key of the value to get.
   * @returns {*} Returns the entry value.
   */
  function stackGet(key) {
    return this.__data__.get(key);
  }

  /**
   * Checks if a stack value for `key` exists.
   *
   * @private
   * @name has
   * @memberOf Stack
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function stackHas(key) {
    return this.__data__.has(key);
  }

  /**
   * Sets the stack `key` to `value`.
   *
   * @private
   * @name set
   * @memberOf Stack
   * @param {string} key The key of the value to set.
   * @param {*} value The value to set.
   * @returns {Object} Returns the stack cache instance.
   */
  function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
      var pairs = data.__data__;
      if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key, value]);
        this.size = ++data.size;
        return this;
      }
      data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
  }

  // Add methods to `Stack`.
  Stack.prototype.clear = stackClear;
  Stack.prototype['delete'] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;

  /**
   * Creates an array of the enumerable property names of the array-like `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @param {boolean} inherited Specify returning inherited property names.
   * @returns {Array} Returns the array of property names.
   */
  function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;

    for (var key in value) {
      if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
      // Safari 9 has enumerable `arguments.length` in strict mode.
      key == 'length' ||
      // Node.js 0.10 has enumerable non-index properties on buffers.
      isBuff && (key == 'offset' || key == 'parent') ||
      // PhantomJS 2 has enumerable non-index properties on typed arrays.
      isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
      // Skip index properties.
      isIndex(key, length)))) {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * Gets the index at which the `key` is found in `array` of key-value pairs.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} key The key to search for.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function assocIndexOf(array, key) {
    var length = array.length;
    while (length--) {
      if (eq(array[length][0], key)) {
        return length;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
   * `keysFunc` and `symbolsFunc` to get the enumerable property names and
   * symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Function} keysFunc The function to get the keys of `object`.
   * @param {Function} symbolsFunc The function to get the symbols of `object`.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
  }

  /**
   * The base implementation of `getTag` without fallbacks for buggy environments.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  function baseGetTag(value) {
    if (value == null) {
      return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
  }

  /**
   * The base implementation of `_.isArguments`.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   */
  function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
  }

  /**
   * The base implementation of `_.isEqual` which supports partial comparisons
   * and tracks traversed objects.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @param {boolean} bitmask The bitmask flags.
   *  1 - Unordered comparison
   *  2 - Partial comparison
   * @param {Function} [customizer] The function to customize comparisons.
   * @param {Object} [stack] Tracks traversed `value` and `other` objects.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   */
  function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) {
      return true;
    }
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
      return value !== value && other !== other;
    }
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
  }

  /**
   * A specialized version of `baseIsEqual` for arrays and objects which performs
   * deep comparisons and tracks traversed objects enabling objects with circular
   * references to be compared.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} [stack] Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);

    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;

    var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;

    if (isSameTag && isBuffer(object)) {
      if (!isBuffer(other)) {
        return false;
      }
      objIsArr = true;
      objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
      stack || (stack = new Stack());
      return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
      var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

      if (objIsWrapped || othIsWrapped) {
        var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;

        stack || (stack = new Stack());
        return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
      }
    }
    if (!isSameTag) {
      return false;
    }
    stack || (stack = new Stack());
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
  }

  /**
   * The base implementation of `_.isNative` without bad shim checks.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a native function,
   *  else `false`.
   */
  function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) {
      return false;
    }
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
  }

  /**
   * The base implementation of `_.isTypedArray` without Node.js optimizations.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   */
  function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  }

  /**
   * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   */
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key in Object(object)) {
      if (hasOwnProperty.call(object, key) && key != 'constructor') {
        result.push(key);
      }
    }
    return result;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for arrays with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Array} array The array to compare.
   * @param {Array} other The other array to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `array` and `other` objects.
   * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
   */
  function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;

    if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
      return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

    stack.set(array, other);
    stack.set(other, array);

    // Ignore non-index properties.
    while (++index < arrLength) {
      var arrValue = array[index],
          othValue = other[index];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
      }
      if (compared !== undefined) {
        if (compared) {
          continue;
        }
        result = false;
        break;
      }
      // Recursively compare arrays (susceptible to call stack limits).
      if (seen) {
        if (!arraySome(other, function (othValue, othIndex) {
          if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            return seen.push(othIndex);
          }
        })) {
          result = false;
          break;
        }
      } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
        result = false;
        break;
      }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for comparing objects of
   * the same `toStringTag`.
   *
   * **Note:** This function only supports comparing values with tags of
   * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {string} tag The `toStringTag` of the objects to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch (tag) {
      case dataViewTag:
        if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
          return false;
        }
        object = object.buffer;
        other = other.buffer;

      case arrayBufferTag:
        if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
          return false;
        }
        return true;

      case boolTag:
      case dateTag:
      case numberTag:
        // Coerce booleans to `1` or `0` and dates to milliseconds.
        // Invalid dates are coerced to `NaN`.
        return eq(+object, +other);

      case errorTag:
        return object.name == other.name && object.message == other.message;

      case regexpTag:
      case stringTag:
        // Coerce regexes to strings and treat strings, primitives and objects,
        // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
        // for more details.
        return object == other + '';

      case mapTag:
        var convert = mapToArray;

      case setTag:
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
        convert || (convert = setToArray);

        if (object.size != other.size && !isPartial) {
          return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked) {
          return stacked == other;
        }
        bitmask |= COMPARE_UNORDERED_FLAG;

        // Recursively compare objects (susceptible to call stack limits).
        stack.set(object, other);
        var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
        stack['delete'](object);
        return result;

      case symbolTag:
        if (symbolValueOf) {
          return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
    }
    return false;
  }

  /**
   * A specialized version of `baseIsEqualDeep` for objects with support for
   * partial deep comparisons.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
   * @param {Function} customizer The function to customize comparisons.
   * @param {Function} equalFunc The function to determine equivalents of values.
   * @param {Object} stack Tracks traversed `object` and `other` objects.
   * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
   */
  function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;

    if (objLength != othLength && !isPartial) {
      return false;
    }
    var index = objLength;
    while (index--) {
      var key = objProps[index];
      if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
        return false;
      }
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) {
      return stacked == other;
    }
    var result = true;
    stack.set(object, other);
    stack.set(other, object);

    var skipCtor = isPartial;
    while (++index < objLength) {
      key = objProps[index];
      var objValue = object[key],
          othValue = other[key];

      if (customizer) {
        var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
      }
      // Recursively compare objects (susceptible to call stack limits).
      if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
        result = false;
        break;
      }
      skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
      var objCtor = object.constructor,
          othCtor = other.constructor;

      // Non `Object` object instances with different constructors are not equal.
      if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
        result = false;
      }
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
  }

  /**
   * Creates an array of own enumerable property names and symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names and symbols.
   */
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }

  /**
   * Gets the data for `map`.
   *
   * @private
   * @param {Object} map The map to query.
   * @param {string} key The reference key.
   * @returns {*} Returns the map data.
   */
  function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
  }

  /**
   * Gets the native function at `key` of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {string} key The key of the method to get.
   * @returns {*} Returns the function if it's native, else `undefined`.
   */
  function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
  }

  /**
   * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the raw `toStringTag`.
   */
  function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];

    try {
      value[symToStringTag] = undefined;
      var unmasked = true;
    } catch (e) {}

    var result = nativeObjectToString.call(value);
    if (unmasked) {
      if (isOwn) {
        value[symToStringTag] = tag;
      } else {
        delete value[symToStringTag];
      }
    }
    return result;
  }

  /**
   * Creates an array of the own enumerable symbols of `object`.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of symbols.
   */
  var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
    if (object == null) {
      return [];
    }
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function (symbol) {
      return propertyIsEnumerable.call(object, symbol);
    });
  };

  /**
   * Gets the `toStringTag` of `value`.
   *
   * @private
   * @param {*} value The value to query.
   * @returns {string} Returns the `toStringTag`.
   */
  var getTag = baseGetTag;

  // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
      var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';

      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }

  /**
   * Checks if `value` is a valid array-like index.
   *
   * @private
   * @param {*} value The value to check.
   * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
   * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
   */
  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
  }

  /**
   * Checks if `value` is suitable for use as unique object key.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
   */
  function isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
  }

  /**
   * Checks if `func` has its source masked.
   *
   * @private
   * @param {Function} func The function to check.
   * @returns {boolean} Returns `true` if `func` is masked, else `false`.
   */
  function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
  }

  /**
   * Checks if `value` is likely a prototype object.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
   */
  function isPrototype(value) {
    var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

    return value === proto;
  }

  /**
   * Converts `value` to a string using `Object.prototype.toString`.
   *
   * @private
   * @param {*} value The value to convert.
   * @returns {string} Returns the converted string.
   */
  function objectToString(value) {
    return nativeObjectToString.call(value);
  }

  /**
   * Converts `func` to its source code.
   *
   * @private
   * @param {Function} func The function to convert.
   * @returns {string} Returns the source code.
   */
  function toSource(func) {
    if (func != null) {
      try {
        return funcToString.call(func);
      } catch (e) {}
      try {
        return func + '';
      } catch (e) {}
    }
    return '';
  }

  /**
   * Performs a
   * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
   * comparison between two values to determine if they are equivalent.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.eq(object, object);
   * // => true
   *
   * _.eq(object, other);
   * // => false
   *
   * _.eq('a', 'a');
   * // => true
   *
   * _.eq('a', Object('a'));
   * // => false
   *
   * _.eq(NaN, NaN);
   * // => true
   */
  function eq(value, other) {
    return value === other || value !== value && other !== other;
  }

  /**
   * Checks if `value` is likely an `arguments` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an `arguments` object,
   *  else `false`.
   * @example
   *
   * _.isArguments(function() { return arguments; }());
   * // => true
   *
   * _.isArguments([1, 2, 3]);
   * // => false
   */
  var isArguments = baseIsArguments(function () {
    return arguments;
  }()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
  };

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */
  var isArray = Array.isArray;

  /**
   * Checks if `value` is array-like. A value is considered array-like if it's
   * not a function and has a `value.length` that's an integer greater than or
   * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
   * @example
   *
   * _.isArrayLike([1, 2, 3]);
   * // => true
   *
   * _.isArrayLike(document.body.children);
   * // => true
   *
   * _.isArrayLike('abc');
   * // => true
   *
   * _.isArrayLike(_.noop);
   * // => false
   */
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
  }

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse;

  /**
   * Performs a deep comparison between two values to determine if they are
   * equivalent.
   *
   * **Note:** This method supports comparing arrays, array buffers, booleans,
   * date objects, error objects, maps, numbers, `Object` objects, regexes,
   * sets, strings, symbols, and typed arrays. `Object` objects are compared
   * by their own, not inherited, enumerable properties. Functions and DOM
   * nodes are compared by strict equality, i.e. `===`.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
   * @example
   *
   * var object = { 'a': 1 };
   * var other = { 'a': 1 };
   *
   * _.isEqual(object, other);
   * // => true
   *
   * object === other;
   * // => false
   */
  function isEqual(value, other) {
    return baseIsEqual(value, other);
  }

  /**
   * Checks if `value` is classified as a `Function` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a function, else `false`.
   * @example
   *
   * _.isFunction(_);
   * // => true
   *
   * _.isFunction(/abc/);
   * // => false
   */
  function isFunction(value) {
    if (!isObject(value)) {
      return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  }

  /**
   * Checks if `value` is a valid array-like length.
   *
   * **Note:** This method is loosely based on
   * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
   * @example
   *
   * _.isLength(3);
   * // => true
   *
   * _.isLength(Number.MIN_VALUE);
   * // => false
   *
   * _.isLength(Infinity);
   * // => false
   *
   * _.isLength('3');
   * // => false
   */
  function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }

  /**
   * Checks if `value` is the
   * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
   * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an object, else `false`.
   * @example
   *
   * _.isObject({});
   * // => true
   *
   * _.isObject([1, 2, 3]);
   * // => true
   *
   * _.isObject(_.noop);
   * // => true
   *
   * _.isObject(null);
   * // => false
   */
  function isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(value);
    return value != null && (type == 'object' || type == 'function');
  }

  /**
   * Checks if `value` is object-like. A value is object-like if it's not `null`
   * and has a `typeof` result of "object".
   *
   * @static
   * @memberOf _
   * @since 4.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   * @example
   *
   * _.isObjectLike({});
   * // => true
   *
   * _.isObjectLike([1, 2, 3]);
   * // => true
   *
   * _.isObjectLike(_.noop);
   * // => false
   *
   * _.isObjectLike(null);
   * // => false
   */
  function isObjectLike(value) {
    return value != null && (typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(value)) == 'object';
  }

  /**
   * Checks if `value` is classified as a typed array.
   *
   * @static
   * @memberOf _
   * @since 3.0.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
   * @example
   *
   * _.isTypedArray(new Uint8Array);
   * // => true
   *
   * _.isTypedArray([]);
   * // => false
   */
  var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  /**
   * Creates an array of the own enumerable property names of `object`.
   *
   * **Note:** Non-object values are coerced to objects. See the
   * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
   * for more details.
   *
   * @static
   * @since 0.1.0
   * @memberOf _
   * @category Object
   * @param {Object} object The object to query.
   * @returns {Array} Returns the array of property names.
   * @example
   *
   * function Foo() {
   *   this.a = 1;
   *   this.b = 2;
   * }
   *
   * Foo.prototype.c = 3;
   *
   * _.keys(new Foo);
   * // => ['a', 'b'] (iteration order is not guaranteed)
   *
   * _.keys('hi');
   * // => ['0', '1']
   */
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }

  /**
   * This method returns a new empty array.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {Array} Returns the new empty array.
   * @example
   *
   * var arrays = _.times(2, _.stubArray);
   *
   * console.log(arrays);
   * // => [[], []]
   *
   * console.log(arrays[0] === arrays[1]);
   * // => false
   */
  function stubArray() {
    return [];
  }

  /**
   * This method returns `false`.
   *
   * @static
   * @memberOf _
   * @since 4.13.0
   * @category Util
   * @returns {boolean} Returns `false`.
   * @example
   *
   * _.times(2, _.stubFalse);
   * // => [false, false]
   */
  function stubFalse() {
    return false;
  }

  module.exports = isEqual;
});

// all diacritics
var diacritics = {
  a: ["a", "à", "á", "â", "ã", "ä", "å", "æ", "ā", "ă", "ą", "ǎ", "ǟ", "ǡ", "ǻ", "ȁ", "ȃ", "ȧ", "ɐ", "ɑ", "ɒ", "ͣ", "а", "ӑ", "ӓ", "ᵃ", "ᵄ", "ᶏ", "ḁ", "ẚ", "ạ", "ả", "ấ", "ầ", "ẩ", "ẫ", "ậ", "ắ", "ằ", "ẳ", "ẵ", "ặ", "ₐ", "ⱥ", "ａ"],
  b: ["b", "ƀ", "ƃ", "ɓ", "ᖯ", "ᵇ", "ᵬ", "ᶀ", "ḃ", "ḅ", "ḇ", "ｂ"],
  c: ["c", "ç", "ć", "ĉ", "ċ", "č", "ƈ", "ȼ", "ɕ", "ͨ", "ᴄ", "ᶜ", "ḉ", "ↄ", "ｃ"],
  d: ["d", "ď", "đ", "Ƌ", "ƌ", "ȡ", "ɖ", "ɗ", "ͩ", "ᵈ", "ᵭ", "ᶁ", "ᶑ", "ḋ", "ḍ", "ḏ", "ḑ", "ḓ", "ｄ"],
  e: ["e", "è", "é", "ê", "ë", "ē", "ĕ", "ė", "ę", "ě", "ǝ", "ȅ", "ȇ", "ȩ", "ɇ", "ɘ", "ͤ", "ᵉ", "ᶒ", "ḕ", "ḗ", "ḙ", "ḛ", "ḝ", "ẹ", "ẻ", "ẽ", "ế", "ề", "ể", "ễ", "ệ", "ₑ", "ｅ"],
  f: ["f", "ƒ", "ᵮ", "ᶂ", "ᶠ", "ḟ", "ｆ"],
  g: ["g", "ĝ", "ğ", "ġ", "ģ", "ǥ", "ǧ", "ǵ", "ɠ", "ɡ", "ᵍ", "ᵷ", "ᵹ", "ᶃ", "ᶢ", "ḡ", "ｇ"],
  h: ["h", "ĥ", "ħ", "ƕ", "ȟ", "ɥ", "ɦ", "ʮ", "ʯ", "ʰ", "ʱ", "ͪ", "Һ", "һ", "ᑋ", "ᶣ", "ḣ", "ḥ", "ḧ", "ḩ", "ḫ", "ⱨ", "ｈ"],
  i: ["i", "ì", "í", "î", "ï", "ĩ", "ī", "ĭ", "į", "ǐ", "ȉ", "ȋ", "ɨ", "ͥ", "ᴉ", "ᵎ", "ᵢ", "ᶖ", "ᶤ", "ḭ", "ḯ", "ỉ", "ị", "ｉ"],
  j: ["j", "ĵ", "ǰ", "ɉ", "ʝ", "ʲ", "ᶡ", "ᶨ", "ｊ"],
  k: ["k", "ķ", "ƙ", "ǩ", "ʞ", "ᵏ", "ᶄ", "ḱ", "ḳ", "ḵ", "ⱪ", "ｋ"],
  l: ["l", "ĺ", "ļ", "ľ", "ŀ", "ł", "ƚ", "ȴ", "ɫ", "ɬ", "ɭ", "ˡ", "ᶅ", "ᶩ", "ᶪ", "ḷ", "ḹ", "ḻ", "ḽ", "ℓ", "ⱡ"],
  m: ["m", "ɯ", "ɰ", "ɱ", "ͫ", "ᴟ", "ᵐ", "ᵚ", "ᵯ", "ᶆ", "ᶬ", "ᶭ", "ḿ", "ṁ", "ṃ", "㎡", "㎥", "ｍ"],
  n: ["n", "ñ", "ń", "ņ", "ň", "ŉ", "ƞ", "ǹ", "ȵ", "ɲ", "ɳ", "ᵰ", "ᶇ", "ᶮ", "ᶯ", "ṅ", "ṇ", "ṉ", "ṋ", "ⁿ", "ｎ"],
  o: ["o", "ò", "ó", "ô", "õ", "ö", "ø", "ō", "ŏ", "ő", "ơ", "ǒ", "ǫ", "ǭ", "ǿ", "ȍ", "ȏ", "ȫ", "ȭ", "ȯ", "ȱ", "ɵ", "ͦ", "о", "ӧ", "ө", "ᴏ", "ᴑ", "ᴓ", "ᴼ", "ᵒ", "ᶱ", "ṍ", "ṏ", "ṑ", "ṓ", "ọ", "ỏ", "ố", "ồ", "ổ", "ỗ", "ộ", "ớ", "ờ", "ở", "ỡ", "ợ", "ₒ", "ｏ", "𐐬"],
  p: ["p", "ᵖ", "ᵱ", "ᵽ", "ᶈ", "ṕ", "ṗ", "ｐ"],
  q: ["q", "ɋ", "ʠ", "ᛩ", "ｑ"],
  r: ["r", "ŕ", "ŗ", "ř", "ȑ", "ȓ", "ɍ", "ɹ", "ɻ", "ʳ", "ʴ", "ʵ", "ͬ", "ᵣ", "ᵲ", "ᶉ", "ṙ", "ṛ", "ṝ", "ṟ"],
  s: ["s", "ś", "ŝ", "ş", "š", "ș", "ʂ", "ᔆ", "ᶊ", "ṡ", "ṣ", "ṥ", "ṧ", "ṩ", "ｓ"],
  t: ["t", "ţ", "ť", "ŧ", "ƫ", "ƭ", "ț", "ʇ", "ͭ", "ᵀ", "ᵗ", "ᵵ", "ᶵ", "ṫ", "ṭ", "ṯ", "ṱ", "ẗ", "ｔ"],
  u: ["u", "ù", "ú", "û", "ü", "ũ", "ū", "ŭ", "ů", "ű", "ų", "ư", "ǔ", "ǖ", "ǘ", "ǚ", "ǜ", "ȕ", "ȗ", "ͧ", "ߎ", "ᵘ", "ᵤ", "ṳ", "ṵ", "ṷ", "ṹ", "ṻ", "ụ", "ủ", "ứ", "ừ", "ử", "ữ", "ự", "ｕ"],
  v: ["v", "ʋ", "ͮ", "ᵛ", "ᵥ", "ᶹ", "ṽ", "ṿ", "ⱱ", "ｖ", "ⱴ"],
  w: ["w", "ŵ", "ʷ", "ᵂ", "ẁ", "ẃ", "ẅ", "ẇ", "ẉ", "ẘ", "ⱳ", "ｗ"],
  x: ["x", "̽", "͓", "ᶍ", "ͯ", "ẋ", "ẍ", "ₓ", "ｘ"],
  y: ["y", "ý", "ÿ", "ŷ", "ȳ", "ɏ", "ʸ", "ẏ", "ỳ", "ỵ", "ỷ", "ỹ", "ｙ"],
  z: ["z", "ź", "ż", "ž", "ƶ", "ȥ", "ɀ", "ʐ", "ʑ", "ᙆ", "ᙇ", "ᶻ", "ᶼ", "ᶽ", "ẑ", "ẓ", "ẕ", "ⱬ", "ｚ"]
}; // Precompiled Object with { key = Diacritic, value = real-Character }

var compiledDiactitics = function () {
  var x = {};

  for (var key in diacritics) {
    var ok = diacritics[key];

    for (var rval in ok) {
      var val = ok[rval]; // Do not replace the char with itself

      if (val !== key) {
        x[val] = key;
      }
    }
  }

  return x;
}(); // Regex for detecting non-ASCII-Characters in String


var regexNonASCII = /[^a-z0-9\s,.-]/;
/*
 * Main function of the module which removes all diacritics from the received text
 */

var diacriticless = function diacriticless(text) {
  // When there are only ascii-Characters in the string, skip processing and return text right away
  if (text.search(regexNonASCII) === -1) {
    return text;
  }

  var result = "";
  var len = text.length;

  for (var i = 0; i < len; i++) {
    var searchChar = text.charAt(i); // If applicable replace the diacritic character with the real one or use the original value

    result += searchChar in compiledDiactitics ? compiledDiactitics[searchChar] : searchChar;
  }

  return result;
};

var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
};

var defaultType = {
  format: function format(x) {
    return x;
  },
  filterPredicate: function filterPredicate(rowval, filter) {
    var skipDiacritics = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var fromDropdown = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    // take care of nulls
    if (typeof rowval === 'undefined' || rowval === null) {
      return false;
    } // row value


    var rowValue = skipDiacritics ? String(rowval).toLowerCase() : diacriticless(escapeRegExp(String(rowval)).toLowerCase()); // search term

    var searchTerm = skipDiacritics ? filter.toLowerCase() : diacriticless(escapeRegExp(filter).toLowerCase()); // comparison

    return fromDropdown ? rowValue === searchTerm : rowValue.indexOf(searchTerm) > -1;
  },
  compare: function compare(x, y) {
    function cook(d) {
      if (typeof d === 'undefined' || d === null) return '';
      return diacriticless(String(d).toLowerCase());
    }

    x = cook(x);
    y = cook(y);
    if (x < y) return -1;
    if (x > y) return 1;
    return 0;
  }
};

//
var script = {
  name: 'VgtPaginationPageInfo',
  props: {
    currentPage: {
      "default": 1
    },
    lastPage: {
      "default": 1
    },
    totalRecords: {
      "default": 0
    },
    ofText: {
      "default": 'of',
      type: String
    },
    pageText: {
      "default": 'page',
      type: String
    },
    currentPerPage: {},
    mode: {
      "default": PAGINATION_MODES.Records
    },
    infoFn: {
      "default": null
    }
  },
  data: function data() {
    return {
      id: this.getId()
    };
  },
  computed: {
    pageInfo: function pageInfo() {
      return "".concat(this.ofText, " ").concat(this.lastPage);
    },
    firstRecordOnPage: function firstRecordOnPage() {
      return (this.currentPage - 1) * this.currentPerPage + 1;
    },
    lastRecordOnPage: function lastRecordOnPage() {
      // if the setting is set to 'all'
      if (this.currentPerPage === -1) {
        return this.totalRecords;
      }

      return Math.min(this.totalRecords, this.currentPage * this.currentPerPage);
    },
    recordInfo: function recordInfo() {
      var first = this.firstRecordOnPage;
      var last = this.lastRecordOnPage;

      if (last === 0) {
        first = 0;
      }

      return "".concat(first, " - ").concat(last, " ").concat(this.ofText, " ").concat(this.totalRecords);
    },
    infoParams: function infoParams() {
      var first = this.firstRecordOnPage;
      var last = this.lastRecordOnPage;

      if (last === 0) {
        first = 0;
      }

      return {
        firstRecordOnPage: first,
        lastRecordOnPage: last,
        totalRecords: this.totalRecords,
        currentPage: this.currentPage,
        totalPage: this.lastPage
      };
    }
  },
  methods: {
    getId: function getId() {
      return "vgt-page-input-".concat(Math.floor(Math.random() * Date.now()));
    },
    changePage: function changePage(event) {
      var value = parseInt(event.target.value, 10); //! invalid number

      if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_nan___default()(value) || value > this.lastPage || value < 1) {
        event.target.value = this.currentPage;
        return false;
      } //* valid number


      event.target.value = value;
      this.$emit('page-changed', value);
    }
  },
  mounted: function mounted() {},
  components: {}
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  }
  // Vue.extend constructor export interop.
  var options = typeof script === 'function' ? script.options : script;
  // render functions
  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true;
    // functional template
    if (isFunctionalTemplate) {
      options.functional = true;
    }
  }
  // scopedId
  if (scopeId) {
    options._scopeId = scopeId;
  }
  var hook = void 0;
  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      }
      // inject component styles
      if (style) {
        style.call(this, createInjectorSSR(context));
      }
      // register component module identifier for async chunk inference
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }
  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "footer__navigation__page-info"
  }, [_vm.infoFn ? _c('div', [_vm._v("\n    " + _vm._s(_vm.infoFn(_vm.infoParams)) + "\n  ")]) : _vm.mode === 'pages' ? _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('label', {
    staticClass: "page-info__label",
    attrs: {
      "for": _vm.id
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.pageText))]), _vm._v(" "), _c('input', {
    staticClass: "footer__navigation__page-info__current-entry",
    attrs: {
      "id": _vm.id,
      "aria-describedby": "change-page-hint",
      "aria-controls": "vgb-table",
      "type": "text"
    },
    domProps: {
      "value": _vm.currentPage
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        $event.stopPropagation();
        return _vm.changePage($event);
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pageInfo))])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "change-page-hint"
    }
  }, [_vm._v("\n      Type a page number and press Enter to change the page.\n    ")])]) : _c('div', [_vm._v("\n    " + _vm._s(_vm.recordInfo) + "\n  ")])]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = "data-v-347cbcfa";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

//
var script$1 = {
  name: 'VgtPagination',
  props: {
    styleClass: {
      "default": 'table table-bordered'
    },
    total: {
      "default": null
    },
    perPage: {},
    rtl: {
      "default": false
    },
    perPageDropdownEnabled: {
      "default": true
    },
    customRowsPerPageDropdown: {
      "default": function _default() {
        return [];
      }
    },
    paginateDropdownAllowAll: {
      "default": true
    },
    mode: {
      "default": PAGINATION_MODES.Records
    },
    jumpFirstOrLast: {
      "default": false
    },
    // text options
    firstText: {
      "default": "First"
    },
    lastText: {
      "default": "Last"
    },
    nextText: {
      "default": 'Next'
    },
    prevText: {
      "default": 'Prev'
    },
    rowsPerPageText: {
      "default": 'Rows per page:'
    },
    ofText: {
      "default": 'of'
    },
    pageText: {
      "default": 'page'
    },
    allText: {
      "default": 'All'
    },
    infoFn: {
      "default": null
    }
  },
  data: function data() {
    return {
      id: this.getId(),
      currentPage: 1,
      prevPage: 0,
      currentPerPage: 10,
      rowsPerPageOptions: []
    };
  },
  watch: {
    perPage: {
      handler: function handler(newValue, oldValue) {
        this.handlePerPage();
        this.perPageChanged(oldValue);
      },
      immediate: true
    },
    customRowsPerPageDropdown: function customRowsPerPageDropdown() {
      this.handlePerPage();
    },
    total: {
      handler: function handler(newValue, oldValue) {
        if (this.rowsPerPageOptions.indexOf(this.currentPerPage) === -1) {
          this.currentPerPage = newValue;
        }
      }
    }
  },
  computed: {
    // Number of pages
    pagesCount: function pagesCount() {
      // if the setting is set to 'all'
      if (this.currentPerPage === -1) {
        return 1;
      }

      var quotient = Math.floor(this.total / this.currentPerPage);
      var remainder = this.total % this.currentPerPage;
      return remainder === 0 ? quotient : quotient + 1;
    },
    // Can go to first page
    firstIsPossible: function firstIsPossible() {
      return this.currentPage > 1;
    },
    // Can go to last page
    lastIsPossible: function lastIsPossible() {
      return this.currentPage < Math.ceil(this.total / this.currentPerPage);
    },
    // Can go to next page
    nextIsPossible: function nextIsPossible() {
      return this.currentPage < this.pagesCount;
    },
    // Can go to previous page
    prevIsPossible: function prevIsPossible() {
      return this.currentPage > 1;
    }
  },
  methods: {
    getId: function getId() {
      return "vgt-select-rpp-".concat(Math.floor(Math.random() * Date.now()));
    },
    // Change current page
    changePage: function changePage(pageNumber) {
      var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (pageNumber > 0 && this.total > this.currentPerPage * (pageNumber - 1)) {
        this.prevPage = this.currentPage;
        this.currentPage = pageNumber;
        this.pageChanged(emit);
      }
    },
    // Go to first page
    firstPage: function firstPage() {
      if (this.firstIsPossible) {
        this.currentPage = 1;
        this.prevPage = 0;
        this.pageChanged();
      }
    },
    // Go to last page
    lastPage: function lastPage() {
      if (this.lastIsPossible) {
        this.currentPage = this.pagesCount;
        this.prev = this.currentPage - 1;
        this.pageChanged();
      }
    },
    // Go to next page
    nextPage: function nextPage() {
      if (this.nextIsPossible) {
        this.prevPage = this.currentPage;
        ++this.currentPage;
        this.pageChanged();
      }
    },
    // Go to previous page
    previousPage: function previousPage() {
      if (this.prevIsPossible) {
        this.prevPage = this.currentPage;
        --this.currentPage;
        this.pageChanged();
      }
    },
    // Indicate page changing
    pageChanged: function pageChanged() {
      var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var payload = {
        currentPage: this.currentPage,
        prevPage: this.prevPage
      };
      if (!emit) payload.noEmit = true;
      this.$emit('page-changed', payload);
    },
    // Indicate per page changing
    perPageChanged: function perPageChanged(oldValue) {
      // go back to first page
      if (oldValue) {
        //* only emit if this isn't first initialization
        this.$emit('per-page-changed', {
          currentPerPage: this.currentPerPage
        });
      }

      this.changePage(1, false);
    },
    // Handle per page changing
    handlePerPage: function handlePerPage() {
      //* if there's a custom dropdown then we use that
      if (this.customRowsPerPageDropdown !== null && Array.isArray(this.customRowsPerPageDropdown) && this.customRowsPerPageDropdown.length !== 0) {
        this.rowsPerPageOptions = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.customRowsPerPageDropdown));
      } else {
        //* otherwise we use the default rows per page dropdown
        this.rowsPerPageOptions = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(DEFAULT_ROWS_PER_PAGE_DROPDOWN));
      }

      if (this.perPage) {
        this.currentPerPage = this.perPage; // if perPage doesn't already exist, we add it

        var found = false;

        for (var i = 0; i < this.rowsPerPageOptions.length; i++) {
          if (this.rowsPerPageOptions[i] === this.perPage) {
            found = true;
          }
        }

        if (!found && this.perPage !== -1) {
          this.rowsPerPageOptions.unshift(this.perPage);
        }
      } else {
        // reset to default
        this.currentPerPage = 10;
      }
    }
  },
  mounted: function mounted() {},
  components: {
    'pagination-page-info': __vue_component__
  }
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vgt-wrap__footer vgt-clearfix"
  }, [_vm.perPageDropdownEnabled ? _c('div', {
    staticClass: "footer__row-count vgt-pull-left"
  }, [_c('form', [_c('label', {
    staticClass: "footer__row-count__label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.rowsPerPageText) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.currentPerPage,
      expression: "currentPerPage"
    }],
    staticClass: "footer__row-count__select",
    attrs: {
      "id": _vm.id,
      "autocomplete": "off",
      "name": "perPageSelect",
      "aria-controls": "vgt-table"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.currentPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }, _vm.perPageChanged]
    }
  }, [_vm._l(_vm.rowsPerPageOptions, function (option, idx) {
    return _c('option', {
      key: idx,
      domProps: {
        "value": option
      }
    }, [_vm._v("\n          " + _vm._s(option) + "\n        ")]);
  }), _vm._v(" "), _vm.paginateDropdownAllowAll ? _c('option', {
    domProps: {
      "value": -1
    }
  }, [_vm._v(_vm._s(_vm.allText))]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer__navigation vgt-pull-right"
  }, [_c('pagination-page-info', {
    attrs: {
      "total-records": _vm.total,
      "last-page": _vm.pagesCount,
      "current-page": _vm.currentPage,
      "current-per-page": _vm.currentPerPage,
      "of-text": _vm.ofText,
      "page-text": _vm.pageText,
      "info-fn": _vm.infoFn,
      "mode": _vm.mode
    },
    on: {
      "page-changed": _vm.changePage
    }
  }), _vm._v(" "), _vm.jumpFirstOrLast ? _c('button', {
    staticClass: "footer__navigation__page-btn",
    "class": {
      disabled: !_vm.firstIsPossible
    },
    attrs: {
      "type": "button",
      "aria-controls": "vgt-table"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.firstPage($event);
      }
    }
  }, [_c('span', {
    staticClass: "chevron",
    "class": {
      left: !_vm.rtl,
      right: _vm.rtl
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.firstText))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "footer__navigation__page-btn",
    "class": {
      disabled: !_vm.prevIsPossible
    },
    attrs: {
      "type": "button",
      "aria-controls": "vgt-table"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.previousPage($event);
      }
    }
  }, [_c('span', {
    staticClass: "chevron",
    "class": {
      'left': !_vm.rtl,
      'right': _vm.rtl
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.prevText))])]), _vm._v(" "), _c('button', {
    staticClass: "footer__navigation__page-btn",
    "class": {
      disabled: !_vm.nextIsPossible
    },
    attrs: {
      "type": "button",
      "aria-controls": "vgt-table"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.nextPage($event);
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.nextText))]), _vm._v(" "), _c('span', {
    staticClass: "chevron",
    "class": {
      'right': !_vm.rtl,
      'left': _vm.rtl
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm.jumpFirstOrLast ? _c('button', {
    staticClass: "footer__navigation__page-btn",
    "class": {
      disabled: !_vm.lastIsPossible
    },
    attrs: {
      "type": "button",
      "aria-controls": "vgt-table"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.lastPage($event);
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lastText))]), _vm._v(" "), _c('span', {
    staticClass: "chevron",
    "class": {
      right: !_vm.rtl,
      left: _vm.rtl
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1)]);
};

var __vue_staticRenderFns__$1 = [];
/* style */

var __vue_inject_styles__$1 = undefined;
/* scoped */

var __vue_scope_id__$1 = undefined;
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$2 = {
  name: 'VgtGlobalSearch',
  props: ['value', 'searchEnabled', 'globalSearchPlaceholder'],
  data: function data() {
    return {
      globalSearchTerm: null,
      id: this.getId()
    };
  },
  computed: {
    showControlBar: function showControlBar() {
      if (this.searchEnabled) return true;
      if (this.$slots && this.$slots['internal-table-actions']) return true;
      return false;
    }
  },
  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
      this.$emit('on-keyup', value);
    },
    entered: function entered(value) {
      this.$emit('on-enter', value);
    },
    getId: function getId() {
      return "vgt-search-".concat(Math.floor(Math.random() * Date.now()));
    }
  }
};

/* script */
var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.showControlBar ? _c('div', {
    staticClass: "vgt-global-search vgt-clearfix"
  }, [_c('div', {
    staticClass: "vgt-global-search__input vgt-pull-left"
  }, [_vm.searchEnabled ? _c('form', {
    attrs: {
      "role": "search"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c('label', {
    attrs: {
      "for": _vm.id
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Search")])]), _vm._v(" "), _c('input', {
    staticClass: "vgt-input vgt-pull-left",
    attrs: {
      "id": _vm.id,
      "type": "text",
      "placeholder": _vm.globalSearchPlaceholder
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function input($event) {
        return _vm.updateValue($event.target.value);
      },
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.entered($event.target.value);
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vgt-global-search__actions vgt-pull-right"
  }, [_vm._t("internal-table-actions")], 2)]) : _vm._e();
};

var __vue_staticRenderFns__$2 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "input__icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "magnifying-glass"
  })]);
}];
/* style */

var __vue_inject_styles__$2 = undefined;
/* scoped */

var __vue_scope_id__$2 = undefined;
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$3 = {
  name: 'VgtFilterRow',
  props: ['lineNumbers', 'columns', 'typedColumns', 'globalSearchEnabled', 'selectable', 'mode'],
  watch: {
    columns: {
      handler: function handler(newValue, oldValue) {
        this.populateInitialFilters();
      },
      deep: true,
      immediate: true
    }
  },
  data: function data() {
    return {
      columnFilters: {},
      timer: null
    };
  },
  computed: {
    // to create a filter row, we need to
    // make sure that there is atleast 1 column
    // that requires filtering
    hasFilterRow: function hasFilterRow() {
      // if (this.mode === 'remote' || !this.globalSearchEnabled) {
      for (var i = 0; i < this.columns.length; i++) {
        var col = this.columns[i];

        if (col.filterOptions && col.filterOptions.enabled) {
          return true;
        }
      } // }


      return false;
    }
  },
  methods: {
    fieldKey: function fieldKey(field) {
      if (typeof field === 'function' && field.name) {
        return field.name;
      }

      return field;
    },
    reset: function reset() {
      var emitEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.columnFilters = {};

      if (emitEvent) {
        this.$emit('filter-changed', this.columnFilters);
      }
    },
    isFilterable: function isFilterable(column) {
      return column.filterOptions && column.filterOptions.enabled;
    },
    isDropdown: function isDropdown(column) {
      return this.isFilterable(column) && column.filterOptions.filterDropdownItems && column.filterOptions.filterDropdownItems.length;
    },
    isDropdownObjects: function isDropdownObjects(column) {
      return this.isDropdown(column) && _typeof(column.filterOptions.filterDropdownItems[0]) === 'object';
    },
    isDropdownArray: function isDropdownArray(column) {
      return this.isDropdown(column) && _typeof(column.filterOptions.filterDropdownItems[0]) !== 'object';
    },
    getClasses: function getClasses(column) {
      var firstClass = 'filter-th';
      return column.filterOptions && column.filterOptions.styleClass ? [firstClass].concat(_toConsumableArray(column.filterOptions.styleClass.split(' '))).join(' ') : firstClass;
    },
    // get column's defined placeholder or default one
    getPlaceholder: function getPlaceholder(column) {
      var placeholder = this.isFilterable(column) && column.filterOptions.placeholder || "Filter ".concat(column.label);
      return placeholder;
    },
    getName: function getName(column) {
      return "vgt-".concat(this.fieldKey(column.field));
    },
    updateFiltersOnEnter: function updateFiltersOnEnter(column, value) {
      if (this.timer) clearTimeout(this.timer);
      this.updateFiltersImmediately(column.field, value);
    },
    updateFiltersOnKeyup: function updateFiltersOnKeyup(column, value) {
      // if the trigger is enter, we don't filter on keyup
      if (column.filterOptions.trigger === 'enter') return;
      this.updateFilters(column, value);
    },
    updateSlotFilter: function updateSlotFilter(column, value) {
      var fieldToFilter = column.filterOptions.slotFilterField || column.field;

      if (typeof column.filterOptions.formatValue === 'function') {
        value = column.filterOptions.formatValue(value);
      }

      this.updateFiltersImmediately(fieldToFilter, value);
    },
    // since vue doesn't detect property addition and deletion, we
    // need to create helper function to set property etc
    updateFilters: function updateFilters(column, value) {
      var _this = this;

      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this.updateFiltersImmediately(column.field, value);
      }, 400);
    },
    updateFiltersImmediately: function updateFiltersImmediately(field, value) {
      this.$set(this.columnFilters, this.fieldKey(field), value);
      this.$emit('filter-changed', this.columnFilters);
    },
    populateInitialFilters: function populateInitialFilters() {
      for (var i = 0; i < this.columns.length; i++) {
        var col = this.columns[i]; // lets see if there are initial
        // filters supplied by user

        if (this.isFilterable(col) && typeof col.filterOptions.filterValue !== 'undefined' && col.filterOptions.filterValue !== null) {
          this.$set(this.columnFilters, this.fieldKey(col.field), col.filterOptions.filterValue); // this.updateFilters(col, col.filterOptions.filterValue);
          // this.$set(col.filterOptions, 'filterValue', undefined);
        }
      } //* lets emit event once all filters are set


      this.$emit('filter-changed', this.columnFilters);
    }
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.hasFilterRow ? _c('tr', [_vm.lineNumbers ? _c('th') : _vm._e(), _vm._v(" "), _vm.selectable ? _c('th') : _vm._e(), _vm._v(" "), _vm._l(_vm.columns, function (column, index) {
    return !column.hidden ? _c('th', {
      key: index,
      "class": _vm.getClasses(column)
    }, [_vm._t("column-filter", [_vm.isFilterable(column) ? _c('div', [!_vm.isDropdown(column) ? _c('input', {
      staticClass: "vgt-input",
      attrs: {
        "name": _vm.getName(column),
        "type": "text",
        "placeholder": _vm.getPlaceholder(column)
      },
      domProps: {
        "value": _vm.columnFilters[_vm.fieldKey(column.field)]
      },
      on: {
        "keyup": function keyup($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }

          return _vm.updateFiltersOnEnter(column, $event.target.value);
        },
        "input": function input($event) {
          return _vm.updateFiltersOnKeyup(column, $event.target.value);
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm.isDropdownArray(column) ? _c('select', {
      staticClass: "vgt-select",
      attrs: {
        "name": _vm.getName(column)
      },
      domProps: {
        "value": _vm.columnFilters[_vm.fieldKey(column.field)]
      },
      on: {
        "change": function change($event) {
          return _vm.updateFiltersImmediately(column.field, $event.target.value);
        }
      }
    }, [_c('option', {
      key: "-1",
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.getPlaceholder(column)))]), _vm._v(" "), _vm._l(column.filterOptions.filterDropdownItems, function (option, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": option
        }
      }, [_vm._v("\n              " + _vm._s(option) + "\n            ")]);
    })], 2) : _vm._e(), _vm._v(" "), _vm.isDropdownObjects(column) ? _c('select', {
      staticClass: "vgt-select",
      attrs: {
        "name": _vm.getName(column)
      },
      domProps: {
        "value": _vm.columnFilters[_vm.fieldKey(column.field)]
      },
      on: {
        "change": function change($event) {
          return _vm.updateFiltersImmediately(column.field, $event.target.value);
        }
      }
    }, [_c('option', {
      key: "-1",
      attrs: {
        "value": ""
      }
    }, [_vm._v(_vm._s(_vm.getPlaceholder(column)))]), _vm._v(" "), _vm._l(column.filterOptions.filterDropdownItems, function (option, i) {
      return _c('option', {
        key: i,
        domProps: {
          "value": option.value
        }
      }, [_vm._v(_vm._s(option.text))]);
    })], 2) : _vm._e()]) : _vm._e()], {
      "column": column,
      "updateFilters": _vm.updateSlotFilter
    })], 2) : _vm._e();
  })], 2) : _vm._e();
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = undefined;
/* scoped */

var __vue_scope_id__$3 = "data-v-6869bf1c";
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);

function getColumnFirstSortType(column) {
  return column.firstSortType || DEFAULT_SORT_TYPE;
}

function getCurrentPrimarySort(sortArray, column) {
  return sortArray.length === 1 && sortArray[0].field === column.field ? sortArray[0].type : undefined;
}

function getNextSort(currentSort, column) {
  if (SORT_TYPES.Descending === getColumnFirstSortType(column) && currentSort === SORT_TYPES.Ascending) {
    return SORT_TYPES.None;
  } else if (currentSort === SORT_TYPES.Ascending) {
    return SORT_TYPES.Descending;
  }

  if (SORT_TYPES.Descending === getColumnFirstSortType(column) && currentSort === SORT_TYPES.Descending) {
    return SORT_TYPES.Ascending;
  } else if (currentSort === SORT_TYPES.Descending) {
    return SORT_TYPES.None;
  }

  if (SORT_TYPES.Descending === getColumnFirstSortType(column) && currentSort === SORT_TYPES.None) {
    return SORT_TYPES.Descending;
  } else {
    return SORT_TYPES.Ascending;
  }
}

function getIndex(sortArray, column) {
  for (var i = 0; i < sortArray.length; i++) {
    if (column.field === sortArray[i].field) return i;
  }

  return -1;
}

var primarySort = function primarySort(sortArray, column) {
  var currentPrimarySort = getCurrentPrimarySort(sortArray, column);
  var nextPrimarySort = getNextSort(currentPrimarySort, column);
  return [{
    field: column.field,
    type: currentPrimarySort ? nextPrimarySort : getColumnFirstSortType(column)
  }];
};

var secondarySort = function secondarySort(sortArray, column) {
  var index = getIndex(sortArray, column);

  if (index === -1) {
    sortArray.push({
      field: column.field,
      type: getColumnFirstSortType(column)
    });
  } else {
    sortArray[index].type = getNextSort(sortArray[index].type, column);
  }

  return sortArray;
};

//
var script$4 = {
  name: 'VgtTableHeader',
  props: {
    lineNumbers: {
      "default": false,
      type: Boolean
    },
    selectable: {
      "default": false,
      type: Boolean
    },
    allSelected: {
      "default": false,
      type: Boolean
    },
    allSelectedIndeterminate: {
      "default": false,
      type: Boolean
    },
    columns: {
      type: Array
    },
    mode: {
      type: String
    },
    typedColumns: {},
    //* Sort related
    sortable: {
      type: Boolean
    },
    multipleColumnSort: {
      type: Boolean,
      "default": true
    },
    getClasses: {
      type: Function
    },
    //* search related
    searchEnabled: {
      type: Boolean
    },
    tableRef: {},
    paginated: {}
  },
  watch: {
    columns: {
      handler: function handler() {
        this.setColumnStyles();
      },
      immediate: true
    },
    tableRef: {
      handler: function handler() {
        this.setColumnStyles();
      },
      immediate: true
    },
    paginated: {
      handler: function handler() {
        if (this.tableRef) {
          this.setColumnStyles();
        }
      },
      deep: true
    }
  },
  data: function data() {
    return {
      checkBoxThStyle: {},
      lineNumberThStyle: {},
      columnStyles: [],
      sorts: [],
      ro: null
    };
  },
  computed: {},
  methods: {
    reset: function reset() {
      this.$refs['filter-row'].reset(true);
    },
    toggleSelectAll: function toggleSelectAll() {
      this.$emit('on-toggle-select-all');
    },
    isSortableColumn: function isSortableColumn(column) {
      var sortable = column.sortable;
      var isSortable = typeof sortable === 'boolean' ? sortable : this.sortable;
      return isSortable;
    },
    sort: function sort(e, column) {
      //* if column is not sortable, return right here
      if (!this.isSortableColumn(column)) return;

      if (e.shiftKey && this.multipleColumnSort) {
        this.sorts = secondarySort(this.sorts, column);
      } else {
        this.sorts = primarySort(this.sorts, column);
      }

      this.$emit('on-sort-change', this.sorts);
    },
    setInitialSort: function setInitialSort(sorts) {
      this.sorts = sorts;
      this.$emit('on-sort-change', this.sorts);
    },
    getColumnSort: function getColumnSort(column) {
      for (var i = 0; i < this.sorts.length; i += 1) {
        if (this.sorts[i].field === column.field) {
          return this.sorts[i].type || 'asc';
        }
      }

      return null;
    },
    getColumnSortLong: function getColumnSortLong(column) {
      return this.getColumnSort(column) === 'asc' ? 'ascending' : 'descending';
    },
    getHeaderClasses: function getHeaderClasses(column, index) {
      var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.getClasses(index, 'th'), {
        sortable: this.isSortableColumn(column),
        'sorting sorting-desc': this.getColumnSort(column) === 'desc',
        'sorting sorting-asc': this.getColumnSort(column) === 'asc'
      });
      return classes;
    },
    filterRows: function filterRows(columnFilters) {
      this.$emit('filter-changed', columnFilters);
    },
    getWidthStyle: function getWidthStyle(dom) {
      if (window && window.getComputedStyle && dom) {
        var cellStyle = window.getComputedStyle(dom, null);
        return {
          width: cellStyle.width
        };
      }

      return {
        width: 'auto'
      };
    },
    setColumnStyles: function setColumnStyles() {
      var colStyles = [];

      for (var i = 0; i < this.columns.length; i++) {
        if (this.tableRef) {
          var skip = 0;
          if (this.selectable) skip++;
          if (this.lineNumbers) skip++;
          var cell = this.tableRef.rows[0].cells[i + skip];
          colStyles.push(this.getWidthStyle(cell));
        } else {
          colStyles.push({
            minWidth: this.columns[i].width ? this.columns[i].width : 'auto',
            maxWidth: this.columns[i].width ? this.columns[i].width : 'auto',
            width: this.columns[i].width ? this.columns[i].width : 'auto'
          });
        }
      }

      this.columnStyles = colStyles;
    },
    getColumnStyle: function getColumnStyle(column, index) {
      var styleObject = {
        minWidth: column.width ? column.width : 'auto',
        maxWidth: column.width ? column.width : 'auto',
        width: column.width ? column.width : 'auto'
      }; //* if fixed header we need to get width from original table

      if (this.tableRef) {
        if (this.selectable) index++;
        if (this.lineNumbers) index++;
        var cell = this.tableRef.rows[0].cells[index];
        var cellStyle = window.getComputedStyle(cell, null);
        styleObject.width = cellStyle.width;
      }

      return styleObject;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      // We're going to watch the parent element for resize events, and calculate column widths if it changes
      if ('ResizeObserver' in window) {
        _this.ro = new ResizeObserver(function () {
          _this.setColumnStyles();
        });

        _this.ro.observe(_this.$parent.$el); // If this is a fixed-header table, we want to observe each column header from the non-fixed header.
        // You can imagine two columns swapping widths, which wouldn't cause the above to trigger.
        // This gets the first tr element of the primary table header, and iterates through its children (the th elements)


        if (_this.tableRef) {
          __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_array_from___default()(_this.$parent.$refs['table-header-primary'].$el.children[0].children).forEach(function (header) {
            _this.ro.observe(header);
          });
        }
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.ro) {
      this.ro.disconnect();
    }
  },
  components: {
    'vgt-filter-row': __vue_component__$3
  }
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('thead', [_c('tr', [_vm.lineNumbers ? _c('th', {
    staticClass: "line-numbers",
    attrs: {
      "scope": "col"
    }
  }) : _vm._e(), _vm._v(" "), _vm.selectable ? _c('th', {
    staticClass: "vgt-checkbox-col",
    attrs: {
      "scope": "col"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.allSelected,
      "indeterminate": _vm.allSelectedIndeterminate
    },
    on: {
      "change": _vm.toggleSelectAll
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l(_vm.columns, function (column, index) {
    return !column.hidden ? _c('th', {
      key: index,
      "class": _vm.getHeaderClasses(column, index),
      style: _vm.columnStyles[index],
      attrs: {
        "scope": "col",
        "title": column.tooltip,
        "aria-sort": _vm.getColumnSortLong(column),
        "aria-controls": "col-" + index
      }
    }, [_vm._t("table-column", [_vm._v("\n        " + _vm._s(column.label) + "\n      ")], {
      "column": column
    }), _vm._v(" "), _vm.isSortableColumn(column) ? _c('button', {
      on: {
        "click": function click($event) {
          return _vm.sort($event, column);
        }
      }
    }, [_c('span', {
      staticClass: "sr-only"
    }, [_vm._v("\n          Sort table by " + _vm._s(column.label) + " in " + _vm._s(_vm.getColumnSortLong(column)) + " order\n          ")])]) : _vm._e()], 2) : _vm._e();
  })], 2), _vm._v(" "), _c("vgt-filter-row", {
    ref: "filter-row",
    tag: "tr",
    attrs: {
      "global-search-enabled": _vm.searchEnabled,
      "line-numbers": _vm.lineNumbers,
      "selectable": _vm.selectable,
      "columns": _vm.columns,
      "mode": _vm.mode,
      "typed-columns": _vm.typedColumns
    },
    on: {
      "filter-changed": _vm.filterRows
    },
    scopedSlots: _vm._u([{
      key: "column-filter",
      fn: function fn(props) {
        return [_vm._t("column-filter", null, {
          "column": props.column,
          "updateFilters": props.updateFilters
        })];
      }
    }], null, true)
  })], 1);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = undefined;
/* scoped */

var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$5 = {
  name: 'VgtHeaderRow',
  props: {
    headerRow: {
      type: Object
    },
    columns: {
      type: Array
    },
    lineNumbers: {
      type: Boolean
    },
    selectable: {
      type: Boolean
    },
    selectAllByGroup: {
      type: Boolean
    },
    collapsable: {
      type: [Boolean, Number],
      "default": false
    },
    collectFormatted: {
      type: Function
    },
    formattedRow: {
      type: Function
    },
    getClasses: {
      type: Function
    },
    fullColspan: {
      type: Number
    },
    groupIndex: {
      type: Number
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    allSelected: function allSelected() {
      var headerRow = this.headerRow,
          groupChildObject = this.groupChildObject;
      return headerRow.children.filter(function (row) {
        return row.vgtSelected;
      }).length === headerRow.children.length;
    }
  },
  methods: {
    columnCollapsable: function columnCollapsable(currentIndex) {
      if (this.collapsable === true) {
        return currentIndex === 0;
      }

      return currentIndex === this.collapsable;
    },
    toggleSelectGroup: function toggleSelectGroup(event) {
      this.$emit('on-select-group-change', {
        groupIndex: this.groupIndex,
        checked: event.target.checked
      });
    }
  },
  mounted: function mounted() {},
  components: {}
};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('tr', [_vm.headerRow.mode === 'span' ? _c('th', {
    staticClass: "vgt-left-align vgt-row-header",
    attrs: {
      "colspan": _vm.fullColspan
    }
  }, [_vm.selectAllByGroup ? [_vm._t("table-header-group-select", [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.allSelected
    },
    on: {
      "change": function change($event) {
        return _vm.toggleSelectGroup($event);
      }
    }
  })], {
    "columns": _vm.columns,
    "row": _vm.headerRow
  })] : _vm._e(), _vm._v(" "), _c('span', {
    on: {
      "click": function click($event) {
        _vm.collapsable ? _vm.$emit('vgtExpand', !_vm.headerRow.vgtIsExpanded) : function () {};
      }
    }
  }, [_vm.collapsable ? _c('span', {
    staticClass: "triangle",
    "class": {
      'expand': _vm.headerRow.vgtIsExpanded
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("table-header-row", [_vm.headerRow.html ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.headerRow.label)
    }
  }) : _c('span', [_vm._v("\n          " + _vm._s(_vm.headerRow.label) + "\n        ")])], {
    "row": _vm.headerRow
  })], 2)], 2) : _vm._e(), _vm._v(" "), _vm.headerRow.mode !== 'span' && _vm.lineNumbers ? _c('th', {
    staticClass: "vgt-row-header"
  }) : _vm._e(), _vm._v(" "), _vm.headerRow.mode !== 'span' && _vm.selectable ? _c('th', {
    staticClass: "vgt-row-header"
  }, [_vm.selectAllByGroup ? [_vm._t("table-header-group-select", [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.allSelected
    },
    on: {
      "change": function change($event) {
        return _vm.toggleSelectGroup($event);
      }
    }
  })], {
    "columns": _vm.columns,
    "row": _vm.headerRow
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm._l(_vm.columns, function (column, i) {
    return _vm.headerRow.mode !== 'span' && !column.hidden ? _c('th', {
      key: i,
      staticClass: "vgt-row-header",
      "class": _vm.getClasses(i, 'td'),
      on: {
        "click": function click($event) {
          _vm.columnCollapsable(i) ? _vm.$emit('vgtExpand', !_vm.headerRow.vgtIsExpanded) : function () {};
        }
      }
    }, [_vm.columnCollapsable(i) ? _c('span', {
      staticClass: "triangle",
      "class": {
        'expand': _vm.headerRow.vgtIsExpanded
      }
    }) : _vm._e(), _vm._v(" "), _vm._t("table-header-row", [!column.html ? _c('span', [_vm._v("\n        " + _vm._s(_vm.collectFormatted(_vm.headerRow, column, true)) + "\n      ")]) : _vm._e(), _vm._v(" "), column.html ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.collectFormatted(_vm.headerRow, column, true))
      }
    }) : _vm._e()], {
      "row": _vm.headerRow,
      "column": column,
      "formattedRow": _vm.formattedRow(_vm.headerRow, true)
    })], 2) : _vm._e();
  })], 2);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = undefined;
/* scoped */

var __vue_scope_id__$5 = undefined;
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || (typeof argument === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(argument)) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var MILLISECONDS_IN_MINUTE = 60000;

function getDateMillisecondsPart(date) {
  return date.getTime() % MILLISECONDS_IN_MINUTE;
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */

function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
  date.setSeconds(0, 0);
  var hasNegativeUTCOffset = baseTimezoneOffset > 0;
  var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? (MILLISECONDS_IN_MINUTE + getDateMillisecondsPart(date)) % MILLISECONDS_IN_MINUTE : getDateMillisecondsPart(date);
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return !isNaN(date);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0
    /* Sunday */

    , firstWeekContainsDate: 1
  }
};

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters$1 = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE$1 = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE$1 + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */

var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function set(date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function validate(_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function set(date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function validate(_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function set(date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function parse(string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function set(_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function parse(string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function set(date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function set(date, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function parse(string, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function parse(string, token, match, _options) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function set(date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function set(date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function set(date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function set(date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function parse(string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function validate(_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function parse(string, token, _match, _options) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function set(date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function parse(string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function set(date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function parse(string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function set(date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function parse(string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function set(_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function parse(string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function set(_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;

  if (!locale$1.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1 // If timezone isn't specified, it will be set to the system timezone

  };
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = parsers[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale$1.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString$1(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

var date = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, defaultType);
date.isRight = true;

date.compare = function (x, y, column) {
  function cook(d) {
    if (column && column.dateInputFormat) {
      return parse("".concat(d), "".concat(column.dateInputFormat), new Date());
    }

    return d;
  }

  x = cook(x);
  y = cook(y);

  if (!isValid(x)) {
    return -1;
  }

  if (!isValid(y)) {
    return 1;
  }

  return compareAsc(x, y);
};

date.format = function (v, column) {
  if (v === undefined || v === null) return ''; // convert to date

  var date = parse(v, column.dateInputFormat, new Date());

  if (isValid(date)) {
    return format(date, column.dateOutputFormat);
  }

  console.error("Not a valid date: \"".concat(v, "\""));
  return null;
};

var date$1 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
  __proto__: null,
  'default': date
});

var number = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, defaultType);
number.isRight = true;

number.filterPredicate = function (rowval, filter) {
  return number.compare(rowval, filter) === 0;
};

number.compare = function (x, y) {
  function cook(d) {
    // if d is null or undefined we give it the smallest
    // possible value
    if (d === undefined || d === null) return -Infinity;
    return d.indexOf('.') >= 0 ? parseFloat(d) : parseInt(d, 10);
  }

  x = typeof x === 'number' ? x : cook(x);
  y = typeof y === 'number' ? y : cook(y);
  if (x < y) return -1;
  if (x > y) return 1;
  return 0;
};

var number$1 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
  __proto__: null,
  'default': number
});

var decimal = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, number);

decimal.format = function (v) {
  if (v === undefined || v === null) return '';
  return parseFloat(Math.round(v * 100) / 100).toFixed(2);
};

var decimal$1 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
  __proto__: null,
  'default': decimal
});

var percentage = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, number);

percentage.format = function (v) {
  if (v === undefined || v === null) return '';
  return "".concat(parseFloat(v * 100).toFixed(2), "%");
};

var percentage$1 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
  __proto__: null,
  'default': percentage
});

var _boolean = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, defaultType);

_boolean.isRight = true;

_boolean.filterPredicate = function (rowval, filter) {
  return _boolean.compare(rowval, filter) === 0;
};

_boolean.compare = function (x, y) {
  function cook(d) {
    if (typeof d === 'boolean') return d ? 1 : 0;
    if (typeof d === 'string') return d === 'true' ? 1 : 0;
    return -Infinity;
  }

  x = cook(x);
  y = cook(y);
  if (x < y) return -1;
  if (x > y) return 1;
  return 0;
};

var _boolean$1 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()({
  __proto__: null,
  'default': _boolean
});

var index = {
  date: date$1,
  decimal: decimal$1,
  number: number$1,
  percentage: percentage$1,
  "boolean": _boolean$1
};

var dataTypes = {};
var coreDataTypes = index;
__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(coreDataTypes).forEach(function (key) {
  var compName = key.replace(/^\.\//, '').replace(/\.js/, '');
  dataTypes[compName] = coreDataTypes[key]["default"];
});
var script$6 = {
  name: 'vue-good-table',
  props: {
    isLoading: {
      "default": null,
      type: Boolean
    },
    maxHeight: {
      "default": null,
      type: String
    },
    fixedHeader: Boolean,
    theme: {
      "default": ''
    },
    mode: {
      "default": 'local'
    },
    // could be remote
    totalRows: {},
    // required if mode = 'remote'
    styleClass: {
      "default": 'vgt-table bordered'
    },
    columns: {},
    rows: {},
    lineNumbers: Boolean,
    responsive: {
      "default": true,
      type: Boolean
    },
    rtl: Boolean,
    rowStyleClass: {
      "default": null,
      type: [Function, String]
    },
    compactMode: Boolean,
    groupOptions: {
      "default": function _default() {
        return {
          enabled: false,
          collapsable: false,
          rowKey: null
        };
      }
    },
    selectOptions: {
      "default": function _default() {
        return {
          enabled: false,
          selectionInfoClass: '',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: false,
          selectAllByGroup: false
        };
      }
    },
    // sort
    sortOptions: {
      "default": function _default() {
        return {
          enabled: true,
          multipleColumns: true,
          initialSortBy: {}
        };
      }
    },
    // pagination
    paginationOptions: {
      "default": function _default() {
        var _ref;

        return _ref = {
          enabled: false,
          position: 'bottom',
          perPage: 10,
          perPageDropdown: null,
          perPageDropdownEnabled: true
        }, _defineProperty(_ref, "position", 'bottom'), _defineProperty(_ref, "dropdownAllowAll", true), _defineProperty(_ref, "mode", 'records'), _defineProperty(_ref, "infoFn", null), _defineProperty(_ref, "jumpFirstOrLast", false), _ref;
      }
    },
    searchOptions: {
      "default": function _default() {
        return {
          enabled: false,
          trigger: null,
          externalQuery: null,
          searchFn: null,
          placeholder: 'Search Table'
        };
      }
    }
  },
  data: function data() {
    return {
      // loading state for remote mode
      tableLoading: false,
      // text options
      firstText: "First",
      lastText: "Last",
      nextText: 'Next',
      prevText: 'Previous',
      rowsPerPageText: 'Rows per page',
      ofText: 'of',
      allText: 'All',
      pageText: 'page',
      // internal select options
      selectable: false,
      selectOnCheckboxOnly: false,
      selectAllByPage: true,
      disableSelectInfo: false,
      selectionInfoClass: '',
      selectionText: 'rows selected',
      clearSelectionText: 'clear',
      // keys for rows that are currently expanded
      maintainExpanded: true,
      expandedRowKeys: new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(),
      // internal sort options
      sortable: true,
      defaultSortBy: null,
      multipleColumnSort: true,
      // internal search options
      searchEnabled: false,
      searchTrigger: null,
      externalSearchQuery: null,
      searchFn: null,
      searchPlaceholder: 'Search Table',
      searchSkipDiacritics: false,
      // internal pagination options
      perPage: null,
      paginate: false,
      paginateOnTop: false,
      paginateOnBottom: true,
      customRowsPerPageDropdown: [],
      paginateDropdownAllowAll: true,
      paginationMode: 'records',
      paginationInfoFn: null,
      currentPage: 1,
      currentPerPage: 10,
      sorts: [],
      globalSearchTerm: '',
      filteredRows: [],
      columnFilters: {},
      forceSearch: false,
      sortChanged: false,
      dataTypes: dataTypes || {}
    };
  },
  watch: {
    rows: {
      handler: function handler() {
        this.$emit('update:isLoading', false);
        this.filterRows(this.columnFilters, false);
      },
      deep: true,
      immediate: true
    },
    selectOptions: {
      handler: function handler() {
        this.initializeSelect();
      },
      deep: true,
      immediate: true
    },
    paginationOptions: {
      handler: function handler(newValue, oldValue) {
        if (!lodash_isequal(newValue, oldValue)) {
          this.initializePagination();
        }
      },
      deep: true,
      immediate: true
    },
    searchOptions: {
      handler: function handler() {
        if (this.searchOptions.externalQuery !== undefined && this.searchOptions.externalQuery !== this.searchTerm) {
          //* we need to set searchTerm to externalQuery first.
          this.externalSearchQuery = this.searchOptions.externalQuery;
          this.handleSearch();
        }

        this.initializeSearch();
      },
      deep: true,
      immediate: true
    },
    sortOptions: {
      handler: function handler(newValue, oldValue) {
        if (!lodash_isequal(newValue, oldValue)) {
          this.initializeSort();
        }
      },
      deep: true
    },
    selectedRows: function selectedRows(newValue, oldValue) {
      if (!lodash_isequal(newValue, oldValue)) {
        this.$emit('on-selected-rows-change', {
          selectedRows: this.selectedRows
        });
      }
    }
  },
  computed: {
    tableStyles: function tableStyles() {
      if (this.compactMode) return this.tableStyleClasses + 'vgt-compact';else return this.tableStyleClasses;
    },
    hasFooterSlot: function hasFooterSlot() {
      return !!this.$slots['table-actions-bottom'];
    },
    wrapperStyles: function wrapperStyles() {
      return {
        overflow: 'scroll-y',
        maxHeight: this.maxHeight ? this.maxHeight : 'auto'
      };
    },
    rowKeyField: function rowKeyField() {
      return this.groupOptions.rowKey || 'vgt_header_id';
    },
    hasHeaderRowTemplate: function hasHeaderRowTemplate() {
      return !!this.$slots['table-header-row'] || !!this.$scopedSlots['table-header-row'];
    },
    showEmptySlot: function showEmptySlot() {
      if (!this.paginated.length) return true;

      if (this.paginated[0].label === 'no groups' && !this.paginated[0].children.length) {
        return true;
      }

      return false;
    },
    allSelected: function allSelected() {
      return this.selectedRowCount > 0 && (this.selectAllByPage && this.selectedPageRowsCount === this.totalPageRowCount || !this.selectAllByPage && this.selectedRowCount === this.totalRowCount);
    },
    allSelectedIndeterminate: function allSelectedIndeterminate() {
      return !this.allSelected && (this.selectAllByPage && this.selectedPageRowsCount > 0 || !this.selectAllByPage && this.selectedRowCount > 0);
    },
    selectionInfo: function selectionInfo() {
      return "".concat(this.selectedRowCount, " ").concat(this.selectionText);
    },
    selectedRowCount: function selectedRowCount() {
      return this.selectedRows.length;
    },
    selectedPageRowsCount: function selectedPageRowsCount() {
      return this.selectedPageRows.length;
    },
    selectedPageRows: function selectedPageRows() {
      var selectedRows = [];
      this.paginated.forEach(function (headerRow) {
        headerRow.children.forEach(function (row) {
          if (row.vgtSelected) {
            selectedRows.push(row);
          }
        });
      });
      return selectedRows;
    },
    selectedRows: function selectedRows() {
      var selectedRows = [];
      this.processedRows.forEach(function (headerRow) {
        headerRow.children.forEach(function (row) {
          if (row.vgtSelected) {
            selectedRows.push(row);
          }
        });
      });
      return selectedRows.sort(function (r1, r2) {
        return r1.originalIndex - r2.originalIndex;
      });
    },
    fullColspan: function fullColspan() {
      var fullColspan = 0;

      for (var i = 0; i < this.columns.length; i += 1) {
        if (!this.columns[i].hidden) {
          fullColspan += 1;
        }
      }

      if (this.lineNumbers) fullColspan++;
      if (this.selectable) fullColspan++;
      return fullColspan;
    },
    groupHeaderOnTop: function groupHeaderOnTop() {
      if (this.groupOptions && this.groupOptions.enabled && this.groupOptions.headerPosition && this.groupOptions.headerPosition === 'bottom') {
        return false;
      }

      if (this.groupOptions && this.groupOptions.enabled) return true; // will only get here if groupOptions is false

      return false;
    },
    groupHeaderOnBottom: function groupHeaderOnBottom() {
      if (this.groupOptions && this.groupOptions.enabled && this.groupOptions.headerPosition && this.groupOptions.headerPosition === 'bottom') {
        return true;
      }

      return false;
    },
    totalRowCount: function totalRowCount() {
      var total = this.processedRows.reduce(function (total, headerRow) {
        var childrenCount = headerRow.children ? headerRow.children.length : 0;
        return total + childrenCount;
      }, 0);
      return total;
    },
    totalPageRowCount: function totalPageRowCount() {
      var total = this.paginated.reduce(function (total, headerRow) {
        var childrenCount = headerRow.children ? headerRow.children.length : 0;
        return total + childrenCount;
      }, 0);
      return total;
    },
    wrapStyleClasses: function wrapStyleClasses() {
      var classes = 'vgt-wrap';
      if (this.rtl) classes += ' rtl';
      classes += " ".concat(this.theme);
      return classes;
    },
    tableStyleClasses: function tableStyleClasses() {
      var classes = this.styleClass;
      classes += " ".concat(this.theme);
      return classes;
    },
    searchTerm: function searchTerm() {
      return this.externalSearchQuery != null ? this.externalSearchQuery : this.globalSearchTerm;
    },
    //
    globalSearchAllowed: function globalSearchAllowed() {
      if (this.searchEnabled && !!this.globalSearchTerm && this.searchTrigger !== 'enter') {
        return true;
      }

      if (this.externalSearchQuery != null && this.searchTrigger !== 'enter') {
        return true;
      }

      if (this.forceSearch) {
        this.forceSearch = false;
        return true;
      }

      return false;
    },
    // this is done everytime sortColumn
    // or sort type changes
    //----------------------------------------
    processedRows: function processedRows() {
      var _this = this;

      // we only process rows when mode is local
      var computedRows = this.filteredRows;

      if (this.mode === 'remote') {
        return computedRows;
      } // take care of the global filter here also


      if (this.globalSearchAllowed) {
        // here also we need to de-construct and then
        // re-construct the rows.
        var allRows = [];
        this.filteredRows.forEach(function (headerRow) {
          allRows.push.apply(allRows, _toConsumableArray(headerRow.children));
        });
        var filteredRows = [];
        allRows.forEach(function (row) {
          for (var i = 0; i < _this.columns.length; i += 1) {
            var col = _this.columns[i]; // if col does not have search disabled,

            if (!col.globalSearchDisabled) {
              // if a search function is provided,
              // use that for searching, otherwise,
              // use the default search behavior
              if (_this.searchFn) {
                var foundMatch = _this.searchFn(row, col, _this.collectFormatted(row, col), _this.searchTerm);

                if (foundMatch) {
                  filteredRows.push(row);
                  break; // break the loop
                }
              } else {
                // comparison
                var matched = defaultType.filterPredicate(_this.collectFormatted(row, col), _this.searchTerm, _this.searchSkipDiacritics);

                if (matched) {
                  filteredRows.push(row);
                  break; // break loop
                }
              }
            }
          }
        }); // this is where we emit on search

        this.$emit('on-search', {
          searchTerm: this.searchTerm,
          rowCount: filteredRows.length
        }); // here we need to reconstruct the nested structure
        // of rows

        computedRows = [];
        this.filteredRows.forEach(function (headerRow) {
          var i = headerRow.vgt_header_id;
          var children = filteredRows.filter(function (r) {
            return r.vgt_id === i;
          });

          if (children.length) {
            var newHeaderRow = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(headerRow));
            newHeaderRow.children = children;
            computedRows.push(newHeaderRow);
          }
        });
      }

      if (this.sorts.length) {
        //* we need to sort
        computedRows.forEach(function (cRows) {
          cRows.children.sort(function (xRow, yRow) {
            //* we need to get column for each sort
            var sortValue;

            for (var i = 0; i < _this.sorts.length; i += 1) {
              var srt = _this.sorts[i];

              if (srt.type === SORT_TYPES.None) {
                //* if no sort, we need to use the original index to sort.
                sortValue = sortValue || xRow.originalIndex - yRow.originalIndex;
              } else {
                var column = _this.getColumnForField(srt.field);

                var xvalue = _this.collect(xRow, srt.field);

                var yvalue = _this.collect(yRow, srt.field); //* if a custom sort function has been provided we use that


                var sortFn = column.sortFn;

                if (sortFn && typeof sortFn === 'function') {
                  sortValue = sortValue || sortFn(xvalue, yvalue, column, xRow, yRow) * (srt.type === SORT_TYPES.Descending ? -1 : 1);
                } else {
                  //* else we use our own sort
                  sortValue = sortValue || column.typeDef.compare(xvalue, yvalue, column) * (srt.type === SORT_TYPES.Descending ? -1 : 1);
                }
              }
            }

            return sortValue;
          });
        });
      } // if the filtering is event based, we need to maintain filter
      // rows


      if (this.searchTrigger === 'enter') {
        this.filteredRows = computedRows;
      }

      return computedRows;
    },
    paginated: function paginated() {
      var _this2 = this;

      if (!this.processedRows.length) return [];

      if (this.mode === 'remote') {
        return this.processedRows;
      } //* flatten the rows for paging.


      var paginatedRows = [];
      this.processedRows.forEach(function (childRows) {
        var _paginatedRows;

        //* only add headers when group options are enabled.
        if (_this2.groupOptions.enabled) {
          paginatedRows.push(childRows);
        }

        (_paginatedRows = paginatedRows).push.apply(_paginatedRows, _toConsumableArray(childRows.children));
      });

      if (this.paginate) {
        var pageStart = (this.currentPage - 1) * this.currentPerPage; // in case of filtering we might be on a page that is
        // not relevant anymore
        // also, if setting to all, current page will not be valid

        if (pageStart >= paginatedRows.length || this.currentPerPage === -1) {
          this.currentPage = 1;
          pageStart = 0;
        } // calculate page end now


        var pageEnd = paginatedRows.length + 1; // if the setting is not set to 'all'

        if (this.currentPerPage !== -1) {
          pageEnd = this.currentPage * this.currentPerPage;
        }

        paginatedRows = paginatedRows.slice(pageStart, pageEnd);
      } // reconstruct paginated rows here


      var reconstructedRows = [];
      paginatedRows.forEach(function (flatRow) {
        //* header row?
        if (flatRow.vgt_header_id !== undefined) {
          _this2.handleExpanded(flatRow);

          var newHeaderRow = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(flatRow));
          newHeaderRow.children = [];
          reconstructedRows.push(newHeaderRow);
        } else {
          //* child row
          var hRow = reconstructedRows.find(function (r) {
            return r.vgt_header_id === flatRow.vgt_id;
          });

          if (!hRow) {
            hRow = _this2.processedRows.find(function (r) {
              return r.vgt_header_id === flatRow.vgt_id;
            });

            if (hRow) {
              hRow = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(hRow));
              hRow.children = [];
              reconstructedRows.push(hRow);
            }
          }

          hRow.children.push(flatRow);
        }
      });
      return reconstructedRows;
    },
    originalRows: function originalRows() {
      var rows = this.rows && this.rows.length ? JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.rows)) : [];
      var nestedRows = [];

      if (!this.groupOptions.enabled) {
        nestedRows = this.handleGrouped([{
          label: 'no groups',
          children: rows
        }]);
      } else {
        nestedRows = this.handleGrouped(rows);
      } // we need to preserve the original index of
      // rows so lets do that


      var index = 0;
      nestedRows.forEach(function (headerRow) {
        headerRow.children.forEach(function (row) {
          row.originalIndex = index++;
        });
      });
      return nestedRows;
    },
    typedColumns: function typedColumns() {
      var columns = this.columns;

      for (var i = 0; i < this.columns.length; i++) {
        var column = columns[i];
        column.typeDef = this.dataTypes[column.type] || defaultType;
      }

      return columns;
    },
    hasRowClickListener: function hasRowClickListener() {
      return this.$listeners && this.$listeners['on-row-click'];
    }
  },
  methods: {
    //* we need to check for expanded row state here
    //* to maintain it when sorting/filtering
    handleExpanded: function handleExpanded(headerRow) {
      if (this.maintainExpanded && this.expandedRowKeys.has(headerRow[this.rowKeyField])) {
        this.$set(headerRow, 'vgtIsExpanded', true);
      } else {
        this.$set(headerRow, 'vgtIsExpanded', false);
      }
    },
    toggleExpand: function toggleExpand(id) {
      var _this3 = this;

      var headerRow = this.filteredRows.find(function (r) {
        return r[_this3.rowKeyField] === id;
      });

      if (headerRow) {
        this.$set(headerRow, 'vgtIsExpanded', !headerRow.vgtIsExpanded);
      }

      if (this.maintainExpanded && headerRow.vgtIsExpanded) {
        this.expandedRowKeys.add(headerRow[this.rowKeyField]);
      } else {
        this.expandedRowKeys["delete"](headerRow[this.rowKeyField]);
      }
    },
    expandAll: function expandAll() {
      var _this4 = this;

      this.filteredRows.forEach(function (row) {
        _this4.$set(row, 'vgtIsExpanded', true);

        if (_this4.maintainExpanded) {
          _this4.expandedRowKeys.add(row[_this4.rowKeyField]);
        }
      });
    },
    collapseAll: function collapseAll() {
      var _this5 = this;

      this.filteredRows.forEach(function (row) {
        _this5.$set(row, 'vgtIsExpanded', false);

        _this5.expandedRowKeys.clear();
      });
    },
    getColumnForField: function getColumnForField(field) {
      for (var i = 0; i < this.typedColumns.length; i += 1) {
        if (this.typedColumns[i].field === field) return this.typedColumns[i];
      }
    },
    handleSearch: function handleSearch() {
      this.resetTable(); // for remote mode, we need to emit on-search

      if (this.mode === 'remote') {
        this.$emit('on-search', {
          searchTerm: this.searchTerm
        });
      }
    },
    reset: function reset() {
      this.initializeSort();
      this.changePage(1);
      this.$refs['table-header-primary'].reset(true);

      if (this.$refs['table-header-secondary']) {
        this.$refs['table-header-secondary'].reset(true);
      }
    },
    emitSelectedRows: function emitSelectedRows() {
      this.$emit('on-select-all', {
        selected: this.selectedRowCount === this.totalRowCount,
        selectedRows: this.selectedRows
      });
    },
    unselectAllInternal: function unselectAllInternal(forceAll) {
      var _this6 = this;

      var rows = this.selectAllByPage && !forceAll ? this.paginated : this.filteredRows;
      rows.forEach(function (headerRow, i) {
        headerRow.children.forEach(function (row, j) {
          _this6.$set(row, 'vgtSelected', false);
        });
      });
      this.emitSelectedRows();
    },
    toggleSelectAll: function toggleSelectAll() {
      var _this7 = this;

      if (this.allSelected) {
        this.unselectAllInternal();
        return;
      }

      var rows = this.selectAllByPage ? this.paginated : this.filteredRows;
      rows.forEach(function (headerRow) {
        headerRow.children.forEach(function (row) {
          _this7.$set(row, 'vgtSelected', true);
        });
      });
      this.emitSelectedRows();
    },
    toggleSelectGroup: function toggleSelectGroup(event, headerRow) {
      var _this8 = this;

      headerRow.children.forEach(function (row) {
        _this8.$set(row, 'vgtSelected', event.checked);
      });
    },
    changePage: function changePage(value) {
      var enabled = this.paginate;
      var _this$$refs = this.$refs,
          paginationBottom = _this$$refs.paginationBottom,
          paginationTop = _this$$refs.paginationTop;

      if (enabled) {
        if (this.paginateOnTop && paginationTop) {
          paginationTop.currentPage = value;
        }

        if (this.paginateOnBottom && paginationBottom) {
          paginationBottom.currentPage = value;
        } // we also need to set the currentPage
        // for table.


        this.currentPage = value;
      }
    },
    pageChangedEvent: function pageChangedEvent() {
      return {
        currentPage: this.currentPage,
        currentPerPage: this.currentPerPage,
        total: Math.floor(this.totalRowCount / this.currentPerPage)
      };
    },
    pageChanged: function pageChanged(pagination) {
      this.currentPage = pagination.currentPage;

      if (!pagination.noEmit) {
        var pageChangedEvent = this.pageChangedEvent();
        pageChangedEvent.prevPage = pagination.prevPage;
        this.$emit('on-page-change', pageChangedEvent);

        if (this.mode === 'remote') {
          this.$emit('update:isLoading', true);
        }
      }
    },
    perPageChanged: function perPageChanged(pagination) {
      this.currentPerPage = pagination.currentPerPage; // ensure that both sides of pagination are in agreement
      // this fixes changes during position = 'both'

      var paginationPosition = this.paginationOptions.position;

      if (this.$refs.paginationTop && (paginationPosition === 'top' || paginationPosition === 'both')) {
        this.$refs.paginationTop.currentPerPage = this.currentPerPage;
      }

      if (this.$refs.paginationBottom && (paginationPosition === 'bottom' || paginationPosition === 'both')) {
        this.$refs.paginationBottom.currentPerPage = this.currentPerPage;
      } //* update perPage also


      var perPageChangedEvent = this.pageChangedEvent();
      this.$emit('on-per-page-change', perPageChangedEvent);

      if (this.mode === 'remote') {
        this.$emit('update:isLoading', true);
      }
    },
    changeSort: function changeSort(sorts) {
      this.sorts = sorts;
      this.$emit('on-sort-change', sorts); // every time we change sort we need to reset to page 1

      this.changePage(1); // if the mode is remote, we don't need to do anything
      // after this. just set table loading to true

      if (this.mode === 'remote') {
        this.$emit('update:isLoading', true);
        return;
      }

      this.sortChanged = true;
    },
    // checkbox click should always do the following
    onCheckboxClicked: function onCheckboxClicked(row, index, event) {
      this.$set(row, 'vgtSelected', !row.vgtSelected);
      this.$emit('on-row-click', {
        row: row,
        pageIndex: index,
        selected: !!row.vgtSelected,
        event: event
      });
    },
    onRowDoubleClicked: function onRowDoubleClicked(row, index, event) {
      this.$emit('on-row-dblclick', {
        row: row,
        pageIndex: index,
        selected: !!row.vgtSelected,
        event: event
      });
    },
    onRowClicked: function onRowClicked(row, index, event) {
      if (this.selectable && !this.selectOnCheckboxOnly) {
        this.$set(row, 'vgtSelected', !row.vgtSelected);
      }

      this.$emit('on-row-click', {
        row: row,
        pageIndex: index,
        selected: !!row.vgtSelected,
        event: event
      });
    },
    onRowAuxClicked: function onRowAuxClicked(row, index, event) {
      this.$emit('on-row-aux-click', {
        row: row,
        pageIndex: index,
        selected: !!row.vgtSelected,
        event: event
      });
    },
    onCellClicked: function onCellClicked(row, column, rowIndex, event) {
      this.$emit('on-cell-click', {
        row: row,
        column: column,
        rowIndex: rowIndex,
        event: event
      });
    },
    onMouseenter: function onMouseenter(row, index) {
      this.$emit('on-row-mouseenter', {
        row: row,
        pageIndex: index
      });
    },
    onMouseleave: function onMouseleave(row, index) {
      this.$emit('on-row-mouseleave', {
        row: row,
        pageIndex: index
      });
    },
    searchTableOnEnter: function searchTableOnEnter() {
      if (this.searchTrigger === 'enter') {
        this.handleSearch(); // we reset the filteredRows here because
        // we want to search across everything.

        this.filteredRows = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.originalRows));
        this.forceSearch = true;
        this.sortChanged = true;
      }
    },
    searchTableOnKeyUp: function searchTableOnKeyUp() {
      if (this.searchTrigger !== 'enter') {
        this.handleSearch();
      }
    },
    resetTable: function resetTable() {
      this.unselectAllInternal(true); // every time we searchTable

      this.changePage(1);
    },
    // field can be:
    // 1. function (passed as a string using function.name. For example: 'bound myFunction')
    // 2. regular property - ex: 'prop'
    // 3. nested property path - ex: 'nested.prop'
    collect: function collect(obj, field) {
      // utility function to get nested property
      function dig(obj, selector) {
        var result = obj;
        var splitter = selector.split('.');

        for (var i = 0; i < splitter.length; i++) {
          if (typeof result === 'undefined' || result === null) {
            return undefined;
          }

          result = result[splitter[i]];
        }

        return result;
      }

      if (typeof field === 'function') return field(obj);
      if (typeof field === 'string') return dig(obj, field);
      return undefined;
    },
    collectFormatted: function collectFormatted(obj, column) {
      var headerRow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var value;

      if (headerRow && column.headerField) {
        value = this.collect(obj, column.headerField);
      } else {
        value = this.collect(obj, column.field);
      }

      if (value === undefined) return ''; // if user has supplied custom formatter,
      // use that here

      if (column.formatFn && typeof column.formatFn === 'function') {
        return column.formatFn(value, obj);
      } // lets format the resultant data


      var type = column.typeDef; // this will only happen if we try to collect formatted
      // before types have been initialized. for example: on
      // load when external query is specified.

      if (!type) {
        type = this.dataTypes[column.type] || defaultType;
      }

      var result = type.format(value, column); // we must have some values in compact mode

      if (this.compactMode && (result == '' || result == null)) return '-';
      return result;
    },
    formattedRow: function formattedRow(row) {
      var isHeaderRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var formattedRow = {};

      for (var i = 0; i < this.typedColumns.length; i++) {
        var col = this.typedColumns[i]; // what happens if field is

        if (col.field) {
          formattedRow[col.field] = this.collectFormatted(row, col, isHeaderRow);
        }
      }

      return formattedRow;
    },
    // Get classes for the given column index & element.
    getClasses: function getClasses(index, element, row) {
      var _this$typedColumns$in = this.typedColumns[index],
          typeDef = _this$typedColumns$in.typeDef,
          custom = _this$typedColumns$in["".concat(element, "Class")];

      var isRight = typeDef.isRight;
      if (this.rtl) isRight = true;
      var classes = {
        'vgt-right-align': isRight,
        'vgt-left-align': !isRight
      }; // for td we need to check if value is
      // a function.

      if (typeof custom === 'function') {
        classes[custom(row)] = true;
      } else if (typeof custom === 'string') {
        classes[custom] = true;
      }

      return classes;
    },
    // method to filter rows
    filterRows: function filterRows(columnFilters) {
      var _this9 = this;

      var fromFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // if (!this.rows.length) return;
      // this is invoked either as a result of changing filters
      // or as a result of modifying rows.
      this.columnFilters = columnFilters;
      var computedRows = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.originalRows));
      var instancesOfFiltering = false; // do we have a filter to care about?
      // if not we don't need to do anything

      if (this.columnFilters && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.columnFilters).length) {
        var _ret = function () {
          // every time we filter rows, we need to set current page
          // to 1
          // if the mode is remote, we only need to reset, if this is
          // being called from filter, not when rows are changing
          if (_this9.mode !== 'remote' || fromFilter) {
            _this9.changePage(1);
          } // we need to emit an event and that's that.
          // but this only needs to be invoked if filter is changing
          // not when row object is modified.


          if (fromFilter) {
            _this9.$emit('on-column-filter', {
              columnFilters: _this9.columnFilters
            });
          } // if mode is remote, we don't do any filtering here.


          if (_this9.mode === 'remote') {
            if (fromFilter) {
              _this9.$emit('update:isLoading', true);
            } else {
              // if remote filtering has already been taken care of.
              _this9.filteredRows = computedRows;
            }

            return {
              v: void 0
            };
          }

          var fieldKey = function fieldKey(field) {
            if (typeof field === 'function' && field.name) {
              return field.name;
            }

            return field;
          };

          var _loop = function _loop(i) {
            var col = _this9.typedColumns[i];

            if (_this9.columnFilters[fieldKey(col.field)]) {
              instancesOfFiltering = true;
              computedRows.forEach(function (headerRow) {
                var newChildren = headerRow.children.filter(function (row) {
                  // If column has a custom filter, use that.
                  if (col.filterOptions && typeof col.filterOptions.filterFn === 'function') {
                    return col.filterOptions.filterFn(_this9.collect(row, col.field), _this9.columnFilters[fieldKey(col.field)]);
                  } // Otherwise Use default filters


                  var typeDef = col.typeDef;
                  return typeDef.filterPredicate(_this9.collect(row, col.field), _this9.columnFilters[fieldKey(col.field)], false, col.filterOptions && _typeof(col.filterOptions.filterDropdownItems) === 'object');
                }); // should we remove the header?

                headerRow.children = newChildren;
              });
            }
          };

          for (var i = 0; i < _this9.typedColumns.length; i++) {
            _loop(i);
          }
        }();

        if (_typeof(_ret) === "object") return _ret.v;
      }

      if (instancesOfFiltering) {
        this.filteredRows = computedRows.filter(function (h) {
          return h.children && h.children.length;
        });
      } else {
        this.filteredRows = computedRows;
      }
    },
    getCurrentIndex: function getCurrentIndex(rowId) {
      var index = 0;
      var found = false;

      for (var i = 0; i < this.paginated.length; i += 1) {
        var headerRow = this.paginated[i];
        var children = headerRow.children;

        if (children && children.length) {
          for (var j = 0; j < children.length; j += 1) {
            var c = children[j];

            if (c.originalIndex === rowId) {
              found = true;
              break;
            }

            index += 1;
          }
        }

        if (found) break;
      }

      return (this.currentPage - 1) * this.currentPerPage + index + 1;
    },
    getRowStyleClass: function getRowStyleClass(row) {
      var classes = '';
      if (this.hasRowClickListener) classes += 'clickable';
      var rowStyleClasses;

      if (typeof this.rowStyleClass === 'function') {
        rowStyleClasses = this.rowStyleClass(row);
      } else {
        rowStyleClasses = this.rowStyleClass;
      }

      if (rowStyleClasses) {
        classes += " ".concat(rowStyleClasses);
      }

      return classes;
    },
    handleGrouped: function handleGrouped(originalRows) {
      var _this10 = this;

      originalRows.forEach(function (headerRow, i) {
        headerRow.vgt_header_id = i;

        if (_this10.groupOptions.maintainExpanded && _this10.expandedRowKeys.has(headerRow[_this10.groupOptions.rowKey])) {
          _this10.$set(headerRow, 'vgtIsExpanded', true);
        }

        headerRow.children.forEach(function (childRow) {
          childRow.vgt_id = i;
        });
      });
      return originalRows;
    },
    initializePagination: function initializePagination() {
      var _this11 = this;

      var _this$paginationOptio = this.paginationOptions,
          enabled = _this$paginationOptio.enabled,
          perPage = _this$paginationOptio.perPage,
          position = _this$paginationOptio.position,
          perPageDropdown = _this$paginationOptio.perPageDropdown,
          perPageDropdownEnabled = _this$paginationOptio.perPageDropdownEnabled,
          dropdownAllowAll = _this$paginationOptio.dropdownAllowAll,
          firstLabel = _this$paginationOptio.firstLabel,
          lastLabel = _this$paginationOptio.lastLabel,
          nextLabel = _this$paginationOptio.nextLabel,
          prevLabel = _this$paginationOptio.prevLabel,
          rowsPerPageLabel = _this$paginationOptio.rowsPerPageLabel,
          ofLabel = _this$paginationOptio.ofLabel,
          pageLabel = _this$paginationOptio.pageLabel,
          allLabel = _this$paginationOptio.allLabel,
          setCurrentPage = _this$paginationOptio.setCurrentPage,
          mode = _this$paginationOptio.mode,
          infoFn = _this$paginationOptio.infoFn;

      if (typeof enabled === 'boolean') {
        this.paginate = enabled;
      }

      if (typeof perPage === 'number') {
        this.perPage = perPage;
      }

      if (position === 'top') {
        this.paginateOnTop = true; // default is false

        this.paginateOnBottom = false; // default is true
      } else if (position === 'both') {
        this.paginateOnTop = true;
        this.paginateOnBottom = true;
      }

      if (Array.isArray(perPageDropdown) && perPageDropdown.length) {
        this.customRowsPerPageDropdown = perPageDropdown;

        if (!this.perPage) {
          var _perPageDropdown = _slicedToArray(perPageDropdown, 1);

          this.perPage = _perPageDropdown[0];
        }
      }

      if (typeof perPageDropdownEnabled === 'boolean') {
        this.perPageDropdownEnabled = perPageDropdownEnabled;
      }

      if (typeof dropdownAllowAll === 'boolean') {
        this.paginateDropdownAllowAll = dropdownAllowAll;
      }

      if (typeof mode === 'string') {
        this.paginationMode = mode;
      }

      if (typeof firstLabel === 'string') {
        this.firstText = firstLabel;
      }

      if (typeof lastLabel === 'string') {
        this.lastText = lastLabel;
      }

      if (typeof nextLabel === 'string') {
        this.nextText = nextLabel;
      }

      if (typeof prevLabel === 'string') {
        this.prevText = prevLabel;
      }

      if (typeof rowsPerPageLabel === 'string') {
        this.rowsPerPageText = rowsPerPageLabel;
      }

      if (typeof ofLabel === 'string') {
        this.ofText = ofLabel;
      }

      if (typeof pageLabel === 'string') {
        this.pageText = pageLabel;
      }

      if (typeof allLabel === 'string') {
        this.allText = allLabel;
      }

      if (typeof setCurrentPage === 'number') {
        setTimeout(function () {
          _this11.changePage(setCurrentPage);
        }, 500);
      }

      if (typeof infoFn === 'function') {
        this.paginationInfoFn = infoFn;
      }
    },
    initializeSearch: function initializeSearch() {
      var _this$searchOptions = this.searchOptions,
          enabled = _this$searchOptions.enabled,
          trigger = _this$searchOptions.trigger,
          externalQuery = _this$searchOptions.externalQuery,
          searchFn = _this$searchOptions.searchFn,
          placeholder = _this$searchOptions.placeholder,
          skipDiacritics = _this$searchOptions.skipDiacritics;

      if (typeof enabled === 'boolean') {
        this.searchEnabled = enabled;
      }

      if (trigger === 'enter') {
        this.searchTrigger = trigger;
      }

      if (typeof externalQuery === 'string') {
        this.externalSearchQuery = externalQuery;
      }

      if (typeof searchFn === 'function') {
        this.searchFn = searchFn;
      }

      if (typeof placeholder === 'string') {
        this.searchPlaceholder = placeholder;
      }

      if (typeof skipDiacritics === 'boolean') {
        this.searchSkipDiacritics = skipDiacritics;
      }
    },
    initializeSort: function initializeSort() {
      var _this$sortOptions = this.sortOptions,
          enabled = _this$sortOptions.enabled,
          initialSortBy = _this$sortOptions.initialSortBy,
          multipleColumns = _this$sortOptions.multipleColumns;
      var initSortBy = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(initialSortBy || {}));

      if (typeof enabled === 'boolean') {
        this.sortable = enabled;
      }

      if (typeof multipleColumns === 'boolean') {
        this.multipleColumnSort = multipleColumns;
      } //* initialSortBy can be an array or an object


      if (_typeof(initSortBy) === 'object') {
        var ref = this.fixedHeader ? this.$refs['table-header-secondary'] : this.$refs['table-header-primary'];

        if (Array.isArray(initSortBy)) {
          ref.setInitialSort(initSortBy);
        } else {
          var hasField = Object.prototype.hasOwnProperty.call(initSortBy, 'field');
          if (hasField) ref.setInitialSort([initSortBy]);
        }
      }
    },
    initializeSelect: function initializeSelect() {
      var _this$selectOptions = this.selectOptions,
          enabled = _this$selectOptions.enabled,
          selectionInfoClass = _this$selectOptions.selectionInfoClass,
          selectionText = _this$selectOptions.selectionText,
          clearSelectionText = _this$selectOptions.clearSelectionText,
          selectOnCheckboxOnly = _this$selectOptions.selectOnCheckboxOnly,
          selectAllByPage = _this$selectOptions.selectAllByPage,
          disableSelectInfo = _this$selectOptions.disableSelectInfo,
          selectAllByGroup = _this$selectOptions.selectAllByGroup;

      if (typeof enabled === 'boolean') {
        this.selectable = enabled;
      }

      if (typeof selectOnCheckboxOnly === 'boolean') {
        this.selectOnCheckboxOnly = selectOnCheckboxOnly;
      }

      if (typeof selectAllByPage === 'boolean') {
        this.selectAllByPage = selectAllByPage;
      }

      if (typeof selectAllByGroup === 'boolean') {
        this.selectAllByGroup = selectAllByGroup;
      }

      if (typeof disableSelectInfo === 'boolean') {
        this.disableSelectInfo = disableSelectInfo;
      }

      if (typeof selectionInfoClass === 'string') {
        this.selectionInfoClass = selectionInfoClass;
      }

      if (typeof selectionText === 'string') {
        this.selectionText = selectionText;
      }

      if (typeof clearSelectionText === 'string') {
        this.clearSelectionText = clearSelectionText;
      }
    }
  },
  mounted: function mounted() {
    if (this.perPage) {
      this.currentPerPage = this.perPage;
    }

    this.initializeSort();
  },
  components: {
    'vgt-pagination': __vue_component__$1,
    'vgt-global-search': __vue_component__$2,
    'vgt-header-row': __vue_component__$5,
    'vgt-table-header': __vue_component__$4
  }
};

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    "class": _vm.wrapStyleClasses
  }, [_vm.isLoading ? _c('div', {
    staticClass: "vgt-loading vgt-center-align"
  }, [_vm._t("loadingContent", [_c('span', {
    staticClass: "vgt-loading__content"
  }, [_vm._v("\n        Loading...\n      ")])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vgt-inner-wrap",
    "class": {
      'is-loading': _vm.isLoading
    }
  }, [_vm.paginate && _vm.paginateOnTop ? _vm._t("pagination-top", [_c('vgt-pagination', {
    ref: "paginationTop",
    attrs: {
      "perPage": _vm.perPage,
      "rtl": _vm.rtl,
      "total": _vm.totalRows || _vm.totalRowCount,
      "mode": _vm.paginationMode,
      "jumpFirstOrLast": _vm.paginationOptions.jumpFirstOrLast,
      "firstText": _vm.firstText,
      "lastText": _vm.lastText,
      "nextText": _vm.nextText,
      "prevText": _vm.prevText,
      "rowsPerPageText": _vm.rowsPerPageText,
      "perPageDropdownEnabled": _vm.paginationOptions.perPageDropdownEnabled,
      "customRowsPerPageDropdown": _vm.customRowsPerPageDropdown,
      "paginateDropdownAllowAll": _vm.paginateDropdownAllowAll,
      "ofText": _vm.ofText,
      "pageText": _vm.pageText,
      "allText": _vm.allText,
      "info-fn": _vm.paginationInfoFn
    },
    on: {
      "page-changed": _vm.pageChanged,
      "per-page-changed": _vm.perPageChanged
    }
  })], {
    "pageChanged": _vm.pageChanged,
    "perPageChanged": _vm.perPageChanged,
    "total": _vm.totalRows || _vm.totalRowCount
  }) : _vm._e(), _vm._v(" "), _c('vgt-global-search', {
    attrs: {
      "search-enabled": _vm.searchEnabled && _vm.externalSearchQuery == null,
      "global-search-placeholder": _vm.searchPlaceholder
    },
    on: {
      "on-keyup": _vm.searchTableOnKeyUp,
      "on-enter": _vm.searchTableOnEnter
    },
    model: {
      value: _vm.globalSearchTerm,
      callback: function callback($$v) {
        _vm.globalSearchTerm = $$v;
      },
      expression: "globalSearchTerm"
    }
  }, [_c('template', {
    slot: "internal-table-actions"
  }, [_vm._t("table-actions")], 2)], 2), _vm._v(" "), _vm.selectedRowCount && !_vm.disableSelectInfo ? _c('div', {
    staticClass: "vgt-selection-info-row clearfix",
    "class": _vm.selectionInfoClass
  }, [_vm._v("\n      " + _vm._s(_vm.selectionInfo) + "\n      "), _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.unselectAllInternal(true);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.clearSelectionText) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "vgt-selection-info-row__actions vgt-pull-right"
  }, [_vm._t("selected-row-actions")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vgt-fixed-header"
  }, [_vm.fixedHeader ? _c('table', {
    "class": _vm.tableStyleClasses,
    attrs: {
      "id": "vgt-table"
    }
  }, [_c('colgroup', _vm._l(_vm.columns, function (column, index) {
    return _c('col', {
      key: index,
      attrs: {
        "id": "col-" + index
      }
    });
  }), 0), _vm._v(" "), _c("vgt-table-header", {
    ref: "table-header-secondary",
    tag: "thead",
    attrs: {
      "columns": _vm.columns,
      "line-numbers": _vm.lineNumbers,
      "selectable": _vm.selectable,
      "all-selected": _vm.allSelected,
      "all-selected-indeterminate": _vm.allSelectedIndeterminate,
      "mode": _vm.mode,
      "sortable": _vm.sortable,
      "multiple-column-sort": _vm.multipleColumnSort,
      "typed-columns": _vm.typedColumns,
      "getClasses": _vm.getClasses,
      "searchEnabled": _vm.searchEnabled,
      "paginated": _vm.paginated,
      "table-ref": _vm.$refs.table
    },
    on: {
      "on-toggle-select-all": _vm.toggleSelectAll,
      "on-sort-change": _vm.changeSort,
      "filter-changed": _vm.filterRows
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function fn(props) {
        return [_vm._t("table-column", [_c('span', [_vm._v(_vm._s(props.column.label))])], {
          "column": props.column
        })];
      }
    }, {
      key: "column-filter",
      fn: function fn(props) {
        return [_vm._t("column-filter", null, {
          "column": props.column,
          "updateFilters": props.updateFilters
        })];
      }
    }], null, true)
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    "class": {
      'vgt-responsive': _vm.responsive
    },
    style: _vm.wrapperStyles
  }, [_c('table', {
    ref: "table",
    "class": _vm.tableStyles,
    attrs: {
      "id": "vgt-table"
    }
  }, [_c('colgroup', _vm._l(_vm.columns, function (column, index) {
    return _c('col', {
      key: index,
      attrs: {
        "id": "col-" + index
      }
    });
  }), 0), _vm._v(" "), _c("vgt-table-header", {
    ref: "table-header-primary",
    tag: "thead",
    attrs: {
      "columns": _vm.columns,
      "line-numbers": _vm.lineNumbers,
      "selectable": _vm.selectable,
      "all-selected": _vm.allSelected,
      "all-selected-indeterminate": _vm.allSelectedIndeterminate,
      "mode": _vm.mode,
      "sortable": _vm.sortable,
      "multiple-column-sort": _vm.multipleColumnSort,
      "typed-columns": _vm.typedColumns,
      "getClasses": _vm.getClasses,
      "searchEnabled": _vm.searchEnabled
    },
    on: {
      "on-toggle-select-all": _vm.toggleSelectAll,
      "on-sort-change": _vm.changeSort,
      "filter-changed": _vm.filterRows
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function fn(props) {
        return [_vm._t("table-column", [_c('span', [_vm._v(_vm._s(props.column.label))])], {
          "column": props.column
        })];
      }
    }, {
      key: "column-filter",
      fn: function fn(props) {
        return [_vm._t("column-filter", null, {
          "column": props.column,
          "updateFilters": props.updateFilters
        })];
      }
    }], null, true)
  }), _vm._v(" "), _vm._l(_vm.paginated, function (headerRow, hIndex) {
    return _c('tbody', {
      key: hIndex
    }, [_vm.groupHeaderOnTop ? _c('vgt-header-row', {
      "class": _vm.getRowStyleClass(headerRow),
      attrs: {
        "header-row": headerRow,
        "columns": _vm.columns,
        "line-numbers": _vm.lineNumbers,
        "selectable": _vm.selectable,
        "select-all-by-group": _vm.selectAllByGroup,
        "collapsable": _vm.groupOptions.collapsable,
        "collect-formatted": _vm.collectFormatted,
        "formatted-row": _vm.formattedRow,
        "get-classes": _vm.getClasses,
        "full-colspan": _vm.fullColspan,
        "groupIndex": hIndex
      },
      on: {
        "vgtExpand": function vgtExpand($event) {
          return _vm.toggleExpand(headerRow[_vm.rowKeyField]);
        },
        "on-select-group-change": function onSelectGroupChange($event) {
          return _vm.toggleSelectGroup($event, headerRow);
        }
      },
      scopedSlots: _vm._u([{
        key: "table-header-row",
        fn: function fn(props) {
          return _vm.hasHeaderRowTemplate ? [_vm._t("table-header-row", null, {
            "column": props.column,
            "formattedRow": props.formattedRow,
            "row": props.row
          })] : undefined;
        }
      }], null, true)
    }) : _vm._e(), _vm._v(" "), _vm._l(headerRow.children, function (row, index) {
      return (_vm.groupOptions.collapsable ? headerRow.vgtIsExpanded : true) ? _c('tr', {
        key: row.originalIndex,
        "class": _vm.getRowStyleClass(row),
        on: {
          "mouseenter": function mouseenter($event) {
            return _vm.onMouseenter(row, index);
          },
          "mouseleave": function mouseleave($event) {
            return _vm.onMouseleave(row, index);
          },
          "dblclick": function dblclick($event) {
            return _vm.onRowDoubleClicked(row, index, $event);
          },
          "click": function click($event) {
            return _vm.onRowClicked(row, index, $event);
          },
          "auxclick": function auxclick($event) {
            return _vm.onRowAuxClicked(row, index, $event);
          }
        }
      }, [_vm.lineNumbers ? _c('th', {
        staticClass: "line-numbers"
      }, [_vm._v("\n              " + _vm._s(_vm.getCurrentIndex(row.originalIndex)) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm.selectable ? _c('th', {
        staticClass: "vgt-checkbox-col",
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.onCheckboxClicked(row, index, $event);
          }
        }
      }, [_c('input', {
        attrs: {
          "type": "checkbox",
          "disabled": row.vgtDisabled
        },
        domProps: {
          "checked": row.vgtSelected
        }
      })]) : _vm._e(), _vm._v(" "), _vm._l(_vm.columns, function (column, i) {
        return !column.hidden && column.field ? _c('td', {
          key: i,
          "class": _vm.getClasses(i, 'td', row),
          attrs: {
            "data-label": _vm.compactMode ? column.label : undefined
          },
          on: {
            "click": function click($event) {
              return _vm.onCellClicked(row, column, index, $event);
            }
          }
        }, [_vm._t("table-row", [!column.html ? _c('span', [_vm._v("\n                  " + _vm._s(_vm.collectFormatted(row, column)) + "\n                ")]) : _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.collect(row, column.field))
          }
        })], {
          "row": row,
          "column": column,
          "formattedRow": _vm.formattedRow(row),
          "index": index
        })], 2) : _vm._e();
      })], 2) : _vm._e();
    }), _vm._v(" "), _vm.groupHeaderOnBottom ? _c('vgt-header-row', {
      attrs: {
        "header-row": headerRow,
        "columns": _vm.columns,
        "line-numbers": _vm.lineNumbers,
        "selectable": _vm.selectable,
        "select-all-by-group": _vm.selectAllByGroup,
        "collect-formatted": _vm.collectFormatted,
        "formatted-row": _vm.formattedRow,
        "get-classes": _vm.getClasses,
        "full-colspan": _vm.fullColspan,
        "groupIndex": _vm.index
      },
      on: {
        "on-select-group-change": function onSelectGroupChange($event) {
          return _vm.toggleSelectGroup($event, headerRow);
        }
      },
      scopedSlots: _vm._u([{
        key: "table-header-row",
        fn: function fn(props) {
          return _vm.hasHeaderRowTemplate ? [_vm._t("table-header-row", null, {
            "column": props.column,
            "formattedRow": props.formattedRow,
            "row": props.row
          })] : undefined;
        }
      }], null, true)
    }) : _vm._e()], 2);
  }), _vm._v(" "), _vm.showEmptySlot ? _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": _vm.fullColspan
    }
  }, [_vm._t("emptystate", [_c('div', {
    staticClass: "vgt-center-align vgt-text-disabled"
  }, [_vm._v("\n                  No data for table\n                ")])])], 2)])]) : _vm._e()], 2)]), _vm._v(" "), _vm.hasFooterSlot ? _c('div', {
    staticClass: "vgt-wrap__actions-footer"
  }, [_vm._t("table-actions-bottom")], 2) : _vm._e(), _vm._v(" "), _vm.paginate && _vm.paginateOnBottom ? _vm._t("pagination-bottom", [_c('vgt-pagination', {
    ref: "paginationBottom",
    attrs: {
      "perPage": _vm.perPage,
      "rtl": _vm.rtl,
      "total": _vm.totalRows || _vm.totalRowCount,
      "mode": _vm.paginationMode,
      "jumpFirstOrLast": _vm.paginationOptions.jumpFirstOrLast,
      "firstText": _vm.firstText,
      "lastText": _vm.lastText,
      "nextText": _vm.nextText,
      "prevText": _vm.prevText,
      "rowsPerPageText": _vm.rowsPerPageText,
      "perPageDropdownEnabled": _vm.paginationOptions.perPageDropdownEnabled,
      "customRowsPerPageDropdown": _vm.customRowsPerPageDropdown,
      "paginateDropdownAllowAll": _vm.paginateDropdownAllowAll,
      "ofText": _vm.ofText,
      "pageText": _vm.pageText,
      "allText": _vm.allText,
      "info-fn": _vm.paginationInfoFn
    },
    on: {
      "page-changed": _vm.pageChanged,
      "per-page-changed": _vm.perPageChanged
    }
  })], {
    "pageChanged": _vm.pageChanged,
    "perPageChanged": _vm.perPageChanged,
    "total": _vm.totalRows || _vm.totalRowCount
  }) : _vm._e()], 2)]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = undefined;
/* scoped */

var __vue_scope_id__$6 = undefined;
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);

var VueGoodTablePlugin = {
  install: function install(Vue, options) {
    Vue.component(__vue_component__$6.name, __vue_component__$6);
  }
}; // Automatic installation if Vue has been added to the global scope.

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueGoodTablePlugin);
}

/* unused harmony default export */ var _unused_webpack_default_export = (VueGoodTablePlugin);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "35aj":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var defaultEncoding
/* istanbul ignore next */
if (global.process && global.process.browser) {
  defaultEncoding = 'utf-8'
} else if (global.process && global.process.version) {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
} else {
  defaultEncoding = 'utf-8'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "3C96":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(__webpack_require__("40O2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _default(source) {
  var extra = source == 'server' ? serverExtra() : clientExtra();
  return _merge["default"].recursive(true, {
    props: {
      name: {
        type: String,
        required: true
      }
    },
    computed: {
      state: function state() {
        return this.$store.state[this.name];
      },
      Page: function Page() {
        return this.state.page;
      },
      count: function count() {
        return this.state.count;
      },
      Columns: function Columns() {
        return this.state.columns;
      },
      tableData: function tableData() {
        return this.state.data;
      },
      page: function page() {
        return this.state.page;
      },
      limit: function limit() {
        return this.state.limit;
      },
      customQueries: function customQueries() {
        return this.state.customQueries;
      },
      query: function query() {
        return this.state.query;
      },
      orderBy: function orderBy() {
        return {
          column: this.state.sortBy,
          ascending: this.state.ascending
        };
      }
    },
    methods: {
      commit: function commit(action, payload) {
        return this.$store.commit("".concat(this.name, "/").concat(action), payload);
      },
      orderByColumn: function orderByColumn(column, ev) {
        if (!this.sortable(column)) return;

        if (ev.shiftKey && this.orderBy.column && this.hasMultiSort) {
          this.setUserMultiSort(column);
        } else {
          var ascending = this.orderBy.column === column ? !this.orderBy.ascending : this._initialOrderAscending(column);
          var orderBy = {
            column: column,
            ascending: ascending
          };
          this.updateState('orderBy', orderBy);
          this.commit('SORT', orderBy);
          this.dispatch('sorted', orderBy);
        }
      },
      setLimit: function setLimit(e) {
        var limit = _typeof(e) === 'object' ? parseInt(e.target.value) : e;
        this.updateState('perPage', limit);
        this.commit("SET_LIMIT", limit);
        this.dispatch("limit", limit);
      },
      setOrder: function setOrder(column, ascending) {
        this.updateState('orderBy', {
          column: column,
          ascending: ascending
        });
        this.commit('SORT', {
          column: column,
          ascending: ascending
        });
      },
      setPage: function setPage(page) {
        if (!page) {
          page = this.$refs.page.value;
        }

        if (!this.opts.pagination.dropdown) this.$refs.pagination.Page = page;
        this.commit("PAGINATE", page);
      }
    }
  }, extra);
}

function serverExtra() {
  return {
    methods: {
      setData: function setData(data) {
        this.commit('SET_DATA', data);
        setTimeout(function () {
          this.dispatch('loaded', data);
        }.bind(this), 0);
      }
    }
  };
}

function clientExtra() {
  return {};
}

/***/ }),

/***/ "3HN9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("SWGL");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "3IRH":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "3PYz":
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__("1lLf");
hash.common = __webpack_require__("YSDb");
hash.sha = __webpack_require__("NCTB");
hash.ripemd = __webpack_require__("CKAI");
hash.hmac = __webpack_require__("3kRU");

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),

/***/ "3Rl0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h) {
  var _this = this;

  return function (perpageValues, cls, id) {
    return h("select", {
      "class": cls,
      attrs: {
        name: "limit",
        id: id
      },
      domProps: {
        "value": _this.limit
      },
      on: {
        "change": _this.setLimit.bind(_this)
      }
    }, [perpageValues]);
  };
};

/***/ }),

/***/ "3U89":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;


/***/ }),

/***/ "3UtB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base = exports;

base.Reporter = __webpack_require__("16On").Reporter;
base.DecoderBuffer = __webpack_require__("iTY7").DecoderBuffer;
base.EncoderBuffer = __webpack_require__("iTY7").EncoderBuffer;
base.Node = __webpack_require__("vugd");

/***/ }),

/***/ "3fMt":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("SWGL");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "3fzc":
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__("rOku");
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__("s83z");
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__("aK3A");
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),

/***/ "3ggi":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Ntt2")('asyncIterator');


/***/ }),

/***/ "3kRU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var assert = __webpack_require__("08Lv");

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),

/***/ "3nYK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),

/***/ "3nlR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var c = this.opts.columnsClasses;
  return c.hasOwnProperty(column) ? c[column] : '';
};

/***/ }),

/***/ "3vT9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  this.data.forEach(function (row, index) {
    this.opts.dateColumns.forEach(function (column) {
      row[column] = row[column] ? moment(row[column], this.opts.toMomentFormat) : '';
    }.bind(this));
  }.bind(this));
};

/***/ }),

/***/ "4/4u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("cSWu").Transform


/***/ }),

/***/ "40O2":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*!
 * @name JavaScript/NodeJS Merge v1.2.1
 * @author yeikos
 * @repository https://github.com/yeikos/js.merge

 * Copyright 2014 yeikos - MIT license
 * https://raw.github.com/yeikos/js.merge/master/LICENSE
 */

;(function(isNode) {

	/**
	 * Merge one or more objects 
	 * @param bool? clone
	 * @param mixed,... arguments
	 * @return object
	 */

	var Public = function(clone) {

		return merge(clone === true, false, arguments);

	}, publicName = 'merge';

	/**
	 * Merge two or more objects recursively 
	 * @param bool? clone
	 * @param mixed,... arguments
	 * @return object
	 */

	Public.recursive = function(clone) {

		return merge(clone === true, true, arguments);

	};

	/**
	 * Clone the input removing any reference
	 * @param mixed input
	 * @return mixed
	 */

	Public.clone = function(input) {

		var output = input,
			type = typeOf(input),
			index, size;

		if (type === 'array') {

			output = [];
			size = input.length;

			for (index=0;index<size;++index)

				output[index] = Public.clone(input[index]);

		} else if (type === 'object') {

			output = {};

			for (index in input)

				output[index] = Public.clone(input[index]);

		}

		return output;

	};

	/**
	 * Merge two objects recursively
	 * @param mixed input
	 * @param mixed extend
	 * @return mixed
	 */

	function merge_recursive(base, extend) {

		if (typeOf(base) !== 'object')

			return extend;

		for (var key in extend) {

			if (typeOf(base[key]) === 'object' && typeOf(extend[key]) === 'object') {

				base[key] = merge_recursive(base[key], extend[key]);

			} else {

				base[key] = extend[key];

			}

		}

		return base;

	}

	/**
	 * Merge two or more objects
	 * @param bool clone
	 * @param bool recursive
	 * @param array argv
	 * @return object
	 */

	function merge(clone, recursive, argv) {

		var result = argv[0],
			size = argv.length;

		if (clone || typeOf(result) !== 'object')

			result = {};

		for (var index=0;index<size;++index) {

			var item = argv[index],

				type = typeOf(item);

			if (type !== 'object') continue;

			for (var key in item) {

				if (key === '__proto__') continue;

				var sitem = clone ? Public.clone(item[key]) : item[key];

				if (recursive) {

					result[key] = merge_recursive(result[key], sitem);

				} else {

					result[key] = sitem;

				}

			}

		}

		return result;

	}

	/**
	 * Get type of variable
	 * @param mixed input
	 * @return string
	 *
	 * @see http://jsperf.com/typeofvar
	 */

	function typeOf(input) {

		return ({}).toString.call(input).slice(8, -1).toLowerCase();

	}

	if (isNode) {

		module.exports = Public;

	} else {

		window[publicName] = Public;

	}

})(typeof module === 'object' && module && typeof module.exports === 'object' && module.exports);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "4DQ7":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("hgbu");


/***/ }),

/***/ "4R/o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__("X3l8")
var randombytes = __webpack_require__("rOku")
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "4RmS":
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){ true?module.exports=n():"function"==typeof define&&define.amd?define(n):(e||self)["v-click-outside"]=n()}(this,function(){var e="__v-click-outside",n="undefined"!=typeof window,t="undefined"!=typeof navigator,r=n&&("ontouchstart"in window||t&&navigator.msMaxTouchPoints>0)?["touchstart"]:["click"];function i(e){var n=e.event,t=e.handler;(0,e.middleware)(n)&&t(n)}function a(n,t){var a=function(e){var n="function"==typeof e;if(!n&&"object"!=typeof e)throw new Error("v-click-outside: Binding value must be a function or an object");return{handler:n?e:e.handler,middleware:e.middleware||function(e){return e},events:e.events||r,isActive:!(!1===e.isActive),detectIframe:!(!1===e.detectIframe),capture:!!e.capture}}(t.value),d=a.handler,o=a.middleware,c=a.detectIframe,u=a.capture;if(a.isActive){if(n[e]=a.events.map(function(e){return{event:e,srcTarget:document.documentElement,handler:function(e){return function(e){var n=e.el,t=e.event,r=e.handler,a=e.middleware,d=t.composedPath&&t.composedPath()||t.path;(d?d.indexOf(n)<0:!n.contains(t.target))&&i({event:t,handler:r,middleware:a})}({el:n,event:e,handler:d,middleware:o})},capture:u}}),c){var l={event:"blur",srcTarget:window,handler:function(e){return function(e){var n=e.el,t=e.event,r=e.handler,a=e.middleware;setTimeout(function(){var e=document.activeElement;e&&"IFRAME"===e.tagName&&!n.contains(e)&&i({event:t,handler:r,middleware:a})},0)}({el:n,event:e,handler:d,middleware:o})},capture:u};n[e]=[].concat(n[e],[l])}n[e].forEach(function(t){var r=t.event,i=t.srcTarget,a=t.handler;return setTimeout(function(){n[e]&&i.addEventListener(r,a,u)},0)})}}function d(n){(n[e]||[]).forEach(function(e){return e.srcTarget.removeEventListener(e.event,e.handler,e.capture)}),delete n[e]}var o=n?{bind:a,update:function(e,n){var t=n.value,r=n.oldValue;JSON.stringify(t)!==JSON.stringify(r)&&(d(e),a(e,{value:t}))},unbind:d}:{};return{install:function(e){e.directive("click-outside",o)},directive:o}});
//# sourceMappingURL=v-click-outside.umd.js.map


/***/ }),

/***/ "4S0F":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "4ajQ":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Wdy1");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("qs+f"), 'Object', { defineProperty: __webpack_require__("GCs6").f });


/***/ }),

/***/ "4dmN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("c8Kh");
var $export = __webpack_require__("Wdy1");
var redefine = __webpack_require__("1RnF");
var hide = __webpack_require__("aLzV");
var Iterators = __webpack_require__("yYxz");
var $iterCreate = __webpack_require__("I7B8");
var setToStringTag = __webpack_require__("LhDF");
var getPrototypeOf = __webpack_require__("VD8v");
var ITERATOR = __webpack_require__("hgbu")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "4mbZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bus = _interopRequireDefault(__webpack_require__("jlkA"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (event, payload) {
  if (this.vuex) {
    if (event.split('::').length > 1) return;
    this.commit(event.toUpperCase().replace('-', '_'), payload);
  }

  this.$emit(event, payload);

  _bus["default"].$emit("vue-tables.".concat(event), payload);

  if (this.name) {
    _bus["default"].$emit("vue-tables.".concat(this.name, ".").concat(event), payload);
  }
};

/***/ }),

/***/ "4sPJ":
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),

/***/ "5Bi6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return Object.keys(this.opts.templates);
};

/***/ }),

/***/ "5Fj8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("YjQv");
var each = __webpack_require__("eAa1")(0);
var redefine = __webpack_require__("1RnF");
var meta = __webpack_require__("+zJ9");
var assign = __webpack_require__("xVc6");
var weak = __webpack_require__("74xK");
var isObject = __webpack_require__("8ANE");
var validate = __webpack_require__("fTPD");
var NATIVE_WEAK_MAP = __webpack_require__("fTPD");
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__("1jZ2")(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),

/***/ "5QAX":
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__("2Ejg")
var Buffer = __webpack_require__("X3l8").Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),

/***/ "5QVw":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("tYO1"), __esModule: true };

/***/ }),

/***/ "5VQ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "6TSN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value, column) {
  var list = this.listColumnsObject[column];
  if (typeof list[value] == 'undefined') return value;
  return list[value];
};

/***/ }),

/***/ "6WUN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _merge = _interopRequireDefault(__webpack_require__("40O2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (h, modules, classes, slots) {
  var filterId = "VueTables__search_" + this.id;
  var ddpId = "VueTables__dropdown-pagination_" + this.id;
  var perpageId = "VueTables__limit_" + this.id;

  var perpageValues = __webpack_require__("ic+9").call(this, h);

  var caption = this.opts.caption ? h("caption", [this.opts.caption]) : '';
  var genericFilter = this.hasGenericFilter ? h("div", {
    "class": "VueTables__search-field"
  }, [h("label", {
    attrs: {
      "for": filterId
    },
    "class": classes.label
  }, [this.display("filter")]), modules.normalFilter(classes, filterId)]) : "";
  var perpage = !this.opts.hidePerPageSelect && (perpageValues.length > 1 || this.opts.alwaysShowPerPageSelect) ? h("div", {
    "class": "VueTables__limit-field"
  }, [h("label", {
    "class": classes.label,
    attrs: {
      "for": perpageId
    }
  }, [this.display("limit")]), modules.perPage(perpageValues, classes.select, perpageId)]) : "";
  var dropdownPagination = this.opts.pagination && this.opts.pagination.dropdown ? h("div", {
    "class": "VueTables__pagination-wrapper"
  }, [h("div", {
    "class": "".concat(classes.field, " ").concat(classes.inline, " ").concat(classes.right, " VueTables__dropdown-pagination"),
    directives: [{
      name: "show",
      value: this.totalPages > 1
    }]
  }, [h("label", {
    attrs: {
      "for": ddpId
    }
  }, [this.display("page")]), modules.dropdownPagination(classes.select, ddpId)])]) : "";
  var columnsDropdown = this.opts.columnsDropdown ? h("div", {
    "class": "VueTables__columns-dropdown-wrapper"
  }, [modules.columnsDropdown(classes)]) : "";
  var footerHeadings = this.opts.footerHeadings ? h("tfoot", [h("tr", [modules.headings(classes.right)])]) : "";
  var shouldShowTop = genericFilter || perpage || dropdownPagination || columnsDropdown || slots.beforeFilter || slots.afterFilter || slots.beforeLimit || slots.afterLimit;
  var tableTop = h("div", {
    "class": classes.row,
    directives: [{
      name: "show",
      value: shouldShowTop
    }]
  }, [h("div", {
    "class": classes.column
  }, [h("div", {
    "class": "".concat(classes.field, " ").concat(classes.inline, " ").concat(classes.left, " VueTables__search")
  }, [slots.beforeFilter, genericFilter, slots.afterFilter]), slots.afterFilterWrapper, h("div", {
    "class": "".concat(classes.field, " ").concat(classes.inline, " ").concat(classes.right, " VueTables__limit")
  }, [slots.beforeLimit, perpage, slots.afterLimit]), dropdownPagination, columnsDropdown])]);
  return h("div", {
    "class": "VueTables VueTables--" + this.source
  }, [tableTop, slots.beforeTable, h("div", {
    "class": "table-responsive"
  }, [h("table", {
    "class": "VueTables__table ".concat(this.opts.skin ? this.opts.skin : classes.table),
    attrs: {
      summary: this.opts.summary
    }
  }, [caption, h("thead", [slots.prependHead, h("tr", [modules.headings(classes.right)]), slots.beforeFilters, modules.columnFilters(classes), slots.afterFilters]), footerHeadings, slots.beforeBody, h("tbody", [slots.prependBody, modules.rows(classes), slots.appendBody]), slots.afterBody])]), slots.afterTable, modules.pagination((0, _merge["default"])(classes.pagination, {
    wrapper: "".concat(classes.row, " ").concat(classes.column, " ").concat(classes.contentCenter),
    nav: classes.center,
    count: "".concat(classes.center, " ").concat(classes.column)
  })), modules.dropdownPaginationCount()]);
};

/***/ }),

/***/ "6hW9":
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__("BEbT")
var Buffer = __webpack_require__("X3l8").Buffer
var Transform = __webpack_require__("z+8S")
var inherits = __webpack_require__("LC74")

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),

/***/ "6rdy":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("pEGt");
var gOPS = __webpack_require__("THEY");
var pIE = __webpack_require__("bSeU");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "6tLb":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("ksFB");
var gOPN = __webpack_require__("2m2c").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "7+uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EffectScope", function() { return EffectScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computed", function() { return computed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customRef", function() { return customRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Vue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineAsyncComponent", function() { return defineAsyncComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineComponent", function() { return defineComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "del", function() { return del; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "effectScope", function() { return effectScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentInstance", function() { return getCurrentInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentScope", function() { return getCurrentScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inject", function() { return inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isProxy", function() { return isProxy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReactive", function() { return isReactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isReadonly", function() { return isReadonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isRef", function() { return isRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isShallow", function() { return isShallow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "markRaw", function() { return markRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeDefaults", function() { return mergeDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextTick", function() { return nextTick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onActivated", function() { return onActivated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeMount", function() { return onBeforeMount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeUnmount", function() { return onBeforeUnmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onBeforeUpdate", function() { return onBeforeUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onDeactivated", function() { return onDeactivated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onErrorCaptured", function() { return onErrorCaptured; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onMounted", function() { return onMounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onRenderTracked", function() { return onRenderTracked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onRenderTriggered", function() { return onRenderTriggered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onScopeDispose", function() { return onScopeDispose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onServerPrefetch", function() { return onServerPrefetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onUnmounted", function() { return onUnmounted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onUpdated", function() { return onUpdated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "provide", function() { return provide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "proxyRefs", function() { return proxyRefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reactive", function() { return reactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readonly", function() { return readonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ref", function() { return ref$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowReactive", function() { return shallowReactive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowReadonly", function() { return shallowReadonly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shallowRef", function() { return shallowRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRaw", function() { return toRaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRef", function() { return toRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRefs", function() { return toRefs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "triggerRef", function() { return triggerRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unref", function() { return unref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useAttrs", function() { return useAttrs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useCssModule", function() { return useCssModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useCssVars", function() { return useCssVars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useListeners", function() { return useListeners; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useSlots", function() { return useSlots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watch", function() { return watch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchEffect", function() { return watchEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchPostEffect", function() { return watchPostEffect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "watchSyncEffect", function() { return watchSyncEffect; });
/*!
 * Vue.js v2.7.14
 * (c) 2014-2022 Evan You
 * Released under the MIT License.
 */
var emptyObject = Object.freeze({});
var isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef(v) {
    return v === undefined || v === null;
}
function isDef(v) {
    return v !== undefined && v !== null;
}
function isTrue(v) {
    return v === true;
}
function isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isFunction(value) {
    return typeof value === 'function';
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;
function toRawType(value) {
    return _toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]';
}
function isRegExp(v) {
    return _toString.call(v) === '[object RegExp]';
}
/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function isPromise(val) {
    return (isDef(val) &&
        typeof val.then === 'function' &&
        typeof val.catch === 'function');
}
/**
 * Convert a value to a string that is actually rendered.
 */
function toString(val) {
    return val == null
        ? ''
        : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
            ? JSON.stringify(val, null, 2)
            : String(val);
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(',');
    for (var i = 0; i < list.length; i++) {
        map[list[i]] = true;
    }
    return expectsLowerCase ? function (val) { return map[val.toLowerCase()]; } : function (val) { return map[val]; };
}
/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);
/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');
/**
 * Remove an item from an array.
 */
function remove$2(arr, item) {
    var len = arr.length;
    if (len) {
        // fast path for the only / last item
        if (item === arr[len - 1]) {
            arr.length = len - 1;
            return;
        }
        var index = arr.indexOf(item);
        if (index > -1) {
            return arr.splice(index, 1);
        }
    }
}
/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn(obj, key) {
    return hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */
function cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
});
/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
    return str.replace(hyphenateRE, '-$1').toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */
/* istanbul ignore next */
function polyfillBind(fn, ctx) {
    function boundFn(a) {
        var l = arguments.length;
        return l
            ? l > 1
                ? fn.apply(ctx, arguments)
                : fn.call(ctx, a)
            : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
var bind$1 = Function.prototype.bind ? nativeBind : polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */
function toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while (i--) {
        ret[i] = list[i + start];
    }
    return ret;
}
/**
 * Mix properties into target object.
 */
function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */
function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            extend(res, arr[i]);
        }
    }
    return res;
}
/* eslint-disable no-unused-vars */
/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop(a, b, c) { }
/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };
/* eslint-enable no-unused-vars */
/**
 * Return the same value.
 */
var identity = function (_) { return _; };
/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys$1(modules) {
    return modules
        .reduce(function (keys, m) {
        return keys.concat(m.staticKeys || []);
    }, [])
        .join(',');
}
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual(a, b) {
    if (a === b)
        return true;
    var isObjectA = isObject(a);
    var isObjectB = isObject(b);
    if (isObjectA && isObjectB) {
        try {
            var isArrayA = Array.isArray(a);
            var isArrayB = Array.isArray(b);
            if (isArrayA && isArrayB) {
                return (a.length === b.length &&
                    a.every(function (e, i) {
                        return looseEqual(e, b[i]);
                    }));
            }
            else if (a instanceof Date && b instanceof Date) {
                return a.getTime() === b.getTime();
            }
            else if (!isArrayA && !isArrayB) {
                var keysA = Object.keys(a);
                var keysB = Object.keys(b);
                return (keysA.length === keysB.length &&
                    keysA.every(function (key) {
                        return looseEqual(a[key], b[key]);
                    }));
            }
            else {
                /* istanbul ignore next */
                return false;
            }
        }
        catch (e) {
            /* istanbul ignore next */
            return false;
        }
    }
    else if (!isObjectA && !isObjectB) {
        return String(a) === String(b);
    }
    else {
        return false;
    }
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf(arr, val) {
    for (var i = 0; i < arr.length; i++) {
        if (looseEqual(arr[i], val))
            return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */
function once(fn) {
    var called = false;
    return function () {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function hasChanged(x, y) {
    if (x === y) {
        return x === 0 && 1 / x !== 1 / y;
    }
    else {
        return x === x || y === y;
    }
}

var SSR_ATTR = 'data-server-rendered';
var ASSET_TYPES = ['component', 'directive', 'filter'];
var LIFECYCLE_HOOKS = [
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeUpdate',
    'updated',
    'beforeDestroy',
    'destroyed',
    'activated',
    'deactivated',
    'errorCaptured',
    'serverPrefetch',
    'renderTracked',
    'renderTriggered'
];

var config = {
    /**
     * Option merge strategies (used in core/util/options)
     */
    // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */
    silent: false,
    /**
     * Show production mode tip message on boot?
     */
    productionTip: "production" !== 'production',
    /**
     * Whether to enable devtools
     */
    devtools: "production" !== 'production',
    /**
     * Whether to record perf
     */
    performance: false,
    /**
     * Error handler for watcher errors
     */
    errorHandler: null,
    /**
     * Warn handler for watcher warns
     */
    warnHandler: null,
    /**
     * Ignore certain custom elements
     */
    ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */
    // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */
    isReservedTag: no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */
    isReservedAttr: no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */
    isUnknownElement: no,
    /**
     * Get the namespace of an element
     */
    getTagNamespace: noop,
    /**
     * Parse the real tag name for the specific platform.
     */
    parsePlatformTagName: identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */
    mustUseProp: no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */
    async: true,
    /**
     * Exposed for legacy reasons
     */
    _lifecycleHooks: LIFECYCLE_HOOKS
};

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */
function isReserved(str) {
    var c = (str + '').charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */
var bailRE = new RegExp("[^".concat(unicodeRegExp.source, ".$_\\d]"));
function parsePath(path) {
    if (bailRE.test(path)) {
        return;
    }
    var segments = path.split('.');
    return function (obj) {
        for (var i = 0; i < segments.length; i++) {
            if (!obj)
                return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}

// can we use __proto__?
var hasProto = '__proto__' in {};
// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
UA && UA.indexOf('android') > 0;
var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);
UA && /chrome\/\d+/.test(UA) && !isEdge;
UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
var nativeWatch = {}.watch;
var supportsPassive = false;
if (inBrowser) {
    try {
        var opts = {};
        Object.defineProperty(opts, 'passive', {
            get: function () {
                /* istanbul ignore next */
                supportsPassive = true;
            }
        }); // https://github.com/facebook/flow/issues/285
        window.addEventListener('test-passive', null, opts);
    }
    catch (e) { }
}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
    if (_isServer === undefined) {
        /* istanbul ignore if */
        if (!inBrowser && typeof global !== 'undefined') {
            // detect presence of vue-server-renderer and avoid
            // Webpack shimming the process
            _isServer =
                global['process'] && global['process'].env.VUE_ENV === 'server';
        }
        else {
            _isServer = false;
        }
    }
    return _isServer;
};
// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var _Set; // $flow-disable-line
/* istanbul ignore if */ if (typeof Set !== 'undefined' && isNative(Set)) {
    // use native Set when available.
    _Set = Set;
}
else {
    // a non-standard Set polyfill that only works with primitive keys.
    _Set = /** @class */ (function () {
        function Set() {
            this.set = Object.create(null);
        }
        Set.prototype.has = function (key) {
            return this.set[key] === true;
        };
        Set.prototype.add = function (key) {
            this.set[key] = true;
        };
        Set.prototype.clear = function () {
            this.set = Object.create(null);
        };
        return Set;
    }());
}

var currentInstance = null;
/**
 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
 * relies on it). Do not use this internally, just use `currentInstance`.
 *
 * @internal this function needs manual type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function getCurrentInstance() {
    return currentInstance && { proxy: currentInstance };
}
/**
 * @internal
 */
function setCurrentInstance(vm) {
    if (vm === void 0) { vm = null; }
    if (!vm)
        currentInstance && currentInstance._scope.off();
    currentInstance = vm;
    vm && vm._scope.on();
}

/**
 * @internal
 */
var VNode = /** @class */ (function () {
    function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    Object.defineProperty(VNode.prototype, "child", {
        // DEPRECATED: alias for componentInstance for backwards compat.
        /* istanbul ignore next */
        get: function () {
            return this.componentInstance;
        },
        enumerable: false,
        configurable: true
    });
    return VNode;
}());
var createEmptyVNode = function (text) {
    if (text === void 0) { text = ''; }
    var node = new VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function createTextVNode(val) {
    return new VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode(vnode) {
    var cloned = new VNode(vnode.tag, vnode.data, 
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}

/* not type checking this file because flow doesn't play well with Proxy */
var initProxy;
if (false) {
    var allowedGlobals_1 = makeMap('Infinity,undefined,NaN,isFinite,isNaN,' +
        'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
        'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,' +
        'require' // for Webpack/Browserify
    );
    var warnNonPresent_1 = function (target, key) {
        warn$2("Property or method \"".concat(key, "\" is not defined on the instance but ") +
            'referenced during render. Make sure that this property is reactive, ' +
            'either in the data option, or for class-based components, by ' +
            'initializing the property. ' +
            'See: https://v2.vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.', target);
    };
    var warnReservedPrefix_1 = function (target, key) {
        warn$2("Property \"".concat(key, "\" must be accessed with \"$data.").concat(key, "\" because ") +
            'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
            'prevent conflicts with Vue internals. ' +
            'See: https://v2.vuejs.org/v2/api/#data', target);
    };
    var hasProxy_1 = typeof Proxy !== 'undefined' && isNative(Proxy);
    if (hasProxy_1) {
        var isBuiltInModifier_1 = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
        config.keyCodes = new Proxy(config.keyCodes, {
            set: function (target, key, value) {
                if (isBuiltInModifier_1(key)) {
                    warn$2("Avoid overwriting built-in modifier in config.keyCodes: .".concat(key));
                    return false;
                }
                else {
                    target[key] = value;
                    return true;
                }
            }
        });
    }
    var hasHandler_1 = {
        has: function (target, key) {
            var has = key in target;
            var isAllowed = allowedGlobals_1(key) ||
                (typeof key === 'string' &&
                    key.charAt(0) === '_' &&
                    !(key in target.$data));
            if (!has && !isAllowed) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return has || !isAllowed;
        }
    };
    var getHandler_1 = {
        get: function (target, key) {
            if (typeof key === 'string' && !(key in target)) {
                if (key in target.$data)
                    warnReservedPrefix_1(target, key);
                else
                    warnNonPresent_1(target, key);
            }
            return target[key];
        }
    };
    initProxy = function initProxy(vm) {
        if (hasProxy_1) {
            // determine which proxy handler to use
            var options = vm.$options;
            var handlers = options.render && options.render._withStripped ? getHandler_1 : hasHandler_1;
            vm._renderProxy = new Proxy(vm, handlers);
        }
        else {
            vm._renderProxy = vm;
        }
    };
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var uid$2 = 0;
var pendingCleanupDeps = [];
var cleanupDeps = function () {
    for (var i = 0; i < pendingCleanupDeps.length; i++) {
        var dep = pendingCleanupDeps[i];
        dep.subs = dep.subs.filter(function (s) { return s; });
        dep._pending = false;
    }
    pendingCleanupDeps.length = 0;
};
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */
var Dep = /** @class */ (function () {
    function Dep() {
        // pending subs cleanup
        this._pending = false;
        this.id = uid$2++;
        this.subs = [];
    }
    Dep.prototype.addSub = function (sub) {
        this.subs.push(sub);
    };
    Dep.prototype.removeSub = function (sub) {
        // #12696 deps with massive amount of subscribers are extremely slow to
        // clean up in Chromium
        // to workaround this, we unset the sub for now, and clear them on
        // next scheduler flush.
        this.subs[this.subs.indexOf(sub)] = null;
        if (!this._pending) {
            this._pending = true;
            pendingCleanupDeps.push(this);
        }
    };
    Dep.prototype.depend = function (info) {
        if (Dep.target) {
            Dep.target.addDep(this);
            if (false) {
                Dep.target.onTrack(__assign({ effect: Dep.target }, info));
            }
        }
    };
    Dep.prototype.notify = function (info) {
        // stabilize the subscriber list first
        var subs = this.subs.filter(function (s) { return s; });
        if (false) {
            // subs aren't sorted in scheduler if not running async
            // we need to sort them now to make sure they fire in correct
            // order
            subs.sort(function (a, b) { return a.id - b.id; });
        }
        for (var i = 0, l = subs.length; i < l; i++) {
            var sub = subs[i];
            if (false) {
                sub.onTrigger &&
                    sub.onTrigger(__assign({ effect: subs[i] }, info));
            }
            sub.update();
        }
    };
    return Dep;
}());
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];
function pushTarget(target) {
    targetStack.push(target);
    Dep.target = target;
}
function popTarget() {
    targetStack.pop();
    Dep.target = targetStack[targetStack.length - 1];
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */
var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);
var methodsToPatch = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
];
/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
    // cache original method
    var original = arrayProto[method];
    def(arrayMethods, method, function mutator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch (method) {
            case 'push':
            case 'unshift':
                inserted = args;
                break;
            case 'splice':
                inserted = args.slice(2);
                break;
        }
        if (inserted)
            ob.observeArray(inserted);
        // notify change
        if (false) {
            ob.dep.notify({
                type: "array mutation" /* TriggerOpTypes.ARRAY_MUTATION */,
                target: this,
                key: method
            });
        }
        else {
            ob.dep.notify();
        }
        return result;
    });
});

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);
var NO_INIITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;
function toggleObserving(value) {
    shouldObserve = value;
}
// ssr mock dep
var mockDep = {
    notify: noop,
    depend: noop,
    addSub: noop,
    removeSub: noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = /** @class */ (function () {
    function Observer(value, shallow, mock) {
        if (shallow === void 0) { shallow = false; }
        if (mock === void 0) { mock = false; }
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? mockDep : new Dep();
        this.vmCount = 0;
        def(value, '__ob__', this);
        if (isArray(value)) {
            if (!mock) {
                if (hasProto) {
                    value.__proto__ = arrayMethods;
                    /* eslint-enable no-proto */
                }
                else {
                    for (var i = 0, l = arrayKeys.length; i < l; i++) {
                        var key = arrayKeys[i];
                        def(value, key, arrayMethods[key]);
                    }
                }
            }
            if (!shallow) {
                this.observeArray(value);
            }
        }
        else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */
            var keys = Object.keys(value);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                defineReactive(value, key, NO_INIITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */
    Observer.prototype.observeArray = function (value) {
        for (var i = 0, l = value.length; i < l; i++) {
            observe(value[i], false, this.mock);
        }
    };
    return Observer;
}());
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe(value, shallow, ssrMockReactivity) {
    if (value && hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
        return value.__ob__;
    }
    if (shouldObserve &&
        (ssrMockReactivity || !isServerRendering()) &&
        (isArray(value) || isPlainObject(value)) &&
        Object.isExtensible(value) &&
        !value.__v_skip /* ReactiveFlags.SKIP */ &&
        !isRef(value) &&
        !(value instanceof VNode)) {
        return new Observer(value, shallow, ssrMockReactivity);
    }
}
/**
 * Define a reactive property on an Object.
 */
function defineReactive(obj, key, val, customSetter, shallow, mock) {
    var dep = new Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) {
        return;
    }
    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) &&
        (val === NO_INIITIAL_VALUE || arguments.length === 2)) {
        val = obj[key];
    }
    var childOb = !shallow && observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if (Dep.target) {
                if (false) {
                    dep.depend({
                        target: obj,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                else {
                    dep.depend();
                }
                if (childOb) {
                    childOb.dep.depend();
                    if (isArray(value)) {
                        dependArray(value);
                    }
                }
            }
            return isRef(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal) {
            var value = getter ? getter.call(obj) : val;
            if (!hasChanged(value, newVal)) {
                return;
            }
            if (false) {
                customSetter();
            }
            if (setter) {
                setter.call(obj, newVal);
            }
            else if (getter) {
                // #7981: for accessor properties without setter
                return;
            }
            else if (!shallow && isRef(value) && !isRef(newVal)) {
                value.value = newVal;
                return;
            }
            else {
                val = newVal;
            }
            childOb = !shallow && observe(newVal, false, mock);
            if (false) {
                dep.notify({
                    type: "set" /* TriggerOpTypes.SET */,
                    target: obj,
                    key: key,
                    newValue: newVal,
                    oldValue: value
                });
            }
            else {
                dep.notify();
            }
        }
    });
    return dep;
}
function set(target, key, val) {
    if (false) {
        warn$2("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isReadonly(target)) {
        "production" !== 'production' && warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    var ob = target.__ob__;
    if (isArray(target) && isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) {
            observe(val, false, true);
        }
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        "production" !== 'production' &&
            warn$2('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    if (false) {
        ob.dep.notify({
            type: "add" /* TriggerOpTypes.ADD */,
            target: target,
            key: key,
            newValue: val,
            oldValue: undefined
        });
    }
    else {
        ob.dep.notify();
    }
    return val;
}
function del(target, key) {
    if (false) {
        warn$2("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        "production" !== 'production' &&
            warn$2('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (isReadonly(target)) {
        "production" !== 'production' &&
            warn$2("Delete operation on key \"".concat(key, "\" failed: target is readonly."));
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    if (false) {
        ob.dep.notify({
            type: "delete" /* TriggerOpTypes.DELETE */,
            target: target,
            key: key
        });
    }
    else {
        ob.dep.notify();
    }
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray(value) {
    for (var e = void 0, i = 0, l = value.length; i < l; i++) {
        e = value[i];
        if (e && e.__ob__) {
            e.__ob__.dep.depend();
        }
        if (isArray(e)) {
            dependArray(e);
        }
    }
}

function reactive(target) {
    makeReactive(target, false);
    return target;
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */
function shallowReactive(target) {
    makeReactive(target, true);
    def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    return target;
}
function makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!isReadonly(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Avoid using Array as root value for ".concat(shallow ? "shallowReactive()" : "reactive()", " as it cannot be tracked in watch() or watchEffect(). Use ").concat(shallow ? "shallowRef()" : "ref()", " instead. This is a Vue-2-only limitation."));
            }
            var existingOb = target && target.__ob__;
            if (existingOb && existingOb.shallow !== shallow) {
                warn$2("Target is already a ".concat(existingOb.shallow ? "" : "non-", "shallow reactive object, and cannot be converted to ").concat(shallow ? "" : "non-", "shallow."));
            }
        }
        var ob = observe(target, shallow, isServerRendering() /* ssr mock reactivity */);
        if (false) {
            if (target == null || isPrimitive(target)) {
                warn$2("value cannot be made reactive: ".concat(String(target)));
            }
            if (isCollectionType(target)) {
                warn$2("Vue 2 does not support reactive collection types such as Map or Set.");
            }
        }
    }
}
function isReactive(value) {
    if (isReadonly(value)) {
        return isReactive(value["__v_raw" /* ReactiveFlags.RAW */]);
    }
    return !!(value && value.__ob__);
}
function isShallow(value) {
    return !!(value && value.__v_isShallow);
}
function isReadonly(value) {
    return !!(value && value.__v_isReadonly);
}
function isProxy(value) {
    return isReactive(value) || isReadonly(value);
}
function toRaw(observed) {
    var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    // non-extensible objects won't be observed anyway
    if (Object.isExtensible(value)) {
        def(value, "__v_skip" /* ReactiveFlags.SKIP */, true);
    }
    return value;
}
/**
 * @internal
 */
function isCollectionType(value) {
    var type = toRawType(value);
    return (type === 'Map' || type === 'WeakMap' || type === 'Set' || type === 'WeakSet');
}

/**
 * @internal
 */
var RefFlag = "__v_isRef";
function isRef(r) {
    return !!(r && r.__v_isRef === true);
}
function ref$1(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) {
        return rawValue;
    }
    var ref = {};
    def(ref, RefFlag, true);
    def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, shallow);
    def(ref, 'dep', defineReactive(ref, 'value', rawValue, null, shallow, isServerRendering()));
    return ref;
}
function triggerRef(ref) {
    if (false) {
        warn$2("received object is not a triggerable ref.");
    }
    if (false) {
        ref.dep &&
            ref.dep.notify({
                type: "set" /* TriggerOpTypes.SET */,
                target: ref,
                key: 'value'
            });
    }
    else {
        ref.dep && ref.dep.notify();
    }
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function proxyRefs(objectWithRefs) {
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var proxy = {};
    var keys = Object.keys(objectWithRefs);
    for (var i = 0; i < keys.length; i++) {
        proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
    }
    return proxy;
}
function proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = source[key];
            if (isRef(val)) {
                return val.value;
            }
            else {
                var ob = val && val.__ob__;
                if (ob)
                    ob.dep.depend();
                return val;
            }
        },
        set: function (value) {
            var oldValue = source[key];
            if (isRef(oldValue) && !isRef(value)) {
                oldValue.value = value;
            }
            else {
                source[key] = value;
            }
        }
    });
}
function customRef(factory) {
    var dep = new Dep();
    var _a = factory(function () {
        if (false) {
            dep.depend({
                target: ref,
                type: "get" /* TrackOpTypes.GET */,
                key: 'value'
            });
        }
        else {
            dep.depend();
        }
    }, function () {
        if (false) {
            dep.notify({
                target: ref,
                type: "set" /* TriggerOpTypes.SET */,
                key: 'value'
            });
        }
        else {
            dep.notify();
        }
    }), get = _a.get, set = _a.set;
    var ref = {
        get value() {
            return get();
        },
        set value(newVal) {
            set(newVal);
        }
    };
    def(ref, RefFlag, true);
    return ref;
}
function toRefs(object) {
    if (false) {
        warn$2("toRefs() expects a reactive object but received a plain one.");
    }
    var ret = isArray(object) ? new Array(object.length) : {};
    for (var key in object) {
        ret[key] = toRef(object, key);
    }
    return ret;
}
function toRef(object, key, defaultValue) {
    var val = object[key];
    if (isRef(val)) {
        return val;
    }
    var ref = {
        get value() {
            var val = object[key];
            return val === undefined ? defaultValue : val;
        },
        set value(newVal) {
            object[key] = newVal;
        }
    };
    def(ref, RefFlag, true);
    return ref;
}

var rawToReadonlyFlag = "__v_rawToReadonly";
var rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
function readonly(target) {
    return createReadonly(target, false);
}
function createReadonly(target, shallow) {
    if (!isPlainObject(target)) {
        if (false) {
            if (isArray(target)) {
                warn$2("Vue 2 does not support readonly arrays.");
            }
            else if (isCollectionType(target)) {
                warn$2("Vue 2 does not support readonly collection types such as Map or Set.");
            }
            else {
                warn$2("value cannot be made readonly: ".concat(typeof target));
            }
        }
        return target;
    }
    if (false) {
        warn$2("Vue 2 does not support creating readonly proxy for non-extensible object.");
    }
    // already a readonly object
    if (isReadonly(target)) {
        return target;
    }
    // already has a readonly proxy
    var existingFlag = shallow ? rawToShallowReadonlyFlag : rawToReadonlyFlag;
    var existingProxy = target[existingFlag];
    if (existingProxy) {
        return existingProxy;
    }
    var proxy = Object.create(Object.getPrototypeOf(target));
    def(target, existingFlag, proxy);
    def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, true);
    def(proxy, "__v_raw" /* ReactiveFlags.RAW */, target);
    if (isRef(target)) {
        def(proxy, RefFlag, true);
    }
    if (shallow || isShallow(target)) {
        def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */, true);
    }
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineReadonlyProperty(proxy, target, keys[i], shallow);
    }
    return proxy;
}
function defineReadonlyProperty(proxy, target, key, shallow) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            var val = target[key];
            return shallow || !isPlainObject(val) ? val : readonly(val);
        },
        set: function () {
            "production" !== 'production' &&
                warn$2("Set operation on key \"".concat(key, "\" failed: target is readonly."));
        }
    });
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */
function shallowReadonly(target) {
    return createReadonly(target, true);
}

function computed(getterOrOptions, debugOptions) {
    var getter;
    var setter;
    var onlyGetter = isFunction(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter =  false
            ? function () {
                warn$2('Write operation failed: computed value is readonly');
            }
            : noop;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var watcher = isServerRendering()
        ? null
        : new Watcher(currentInstance, getter, noop, { lazy: true });
    if (false) {
        watcher.onTrack = debugOptions.onTrack;
        watcher.onTrigger = debugOptions.onTrigger;
    }
    var ref = {
        // some libs rely on the presence effect for checking computed refs
        // from normal refs, but the implementation doesn't matter
        effect: watcher,
        get value() {
            if (watcher) {
                if (watcher.dirty) {
                    watcher.evaluate();
                }
                if (Dep.target) {
                    if (false) {
                        Dep.target.onTrack({
                            effect: Dep.target,
                            target: ref,
                            type: "get" /* TrackOpTypes.GET */,
                            key: 'value'
                        });
                    }
                    watcher.depend();
                }
                return watcher.value;
            }
            else {
                return getter();
            }
        },
        set value(newVal) {
            setter(newVal);
        }
    };
    def(ref, RefFlag, true);
    def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */, onlyGetter);
    return ref;
}

var mark;
var measure;
if (false) {
    var perf_1 = inBrowser && window.performance;
    /* istanbul ignore if */
    if (perf_1 &&
        // @ts-ignore
        perf_1.mark &&
        // @ts-ignore
        perf_1.measure &&
        // @ts-ignore
        perf_1.clearMarks &&
        // @ts-ignore
        perf_1.clearMeasures) {
        mark = function (tag) { return perf_1.mark(tag); };
        measure = function (name, startTag, endTag) {
            perf_1.measure(name, startTag, endTag);
            perf_1.clearMarks(startTag);
            perf_1.clearMarks(endTag);
            // perf.clearMeasures(name)
        };
    }
}

var normalizeEvent = cached(function (name) {
    var passive = name.charAt(0) === '&';
    name = passive ? name.slice(1) : name;
    var once = name.charAt(0) === '~'; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    var capture = name.charAt(0) === '!';
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function createFnInvoker(fns, vm) {
    function invoker() {
        var fns = invoker.fns;
        if (isArray(fns)) {
            var cloned = fns.slice();
            for (var i = 0; i < cloned.length; i++) {
                invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
            }
        }
        else {
            // return handler return value for single handlers
            return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
        }
    }
    invoker.fns = fns;
    return invoker;
}
function updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    var name, cur, old, event;
    for (name in on) {
        cur = on[name];
        old = oldOn[name];
        event = normalizeEvent(name);
        if (isUndef(cur)) {
            "production" !== 'production' &&
                warn$2("Invalid handler for event \"".concat(event.name, "\": got ") + String(cur), vm);
        }
        else if (isUndef(old)) {
            if (isUndef(cur.fns)) {
                cur = on[name] = createFnInvoker(cur, vm);
            }
            if (isTrue(event.once)) {
                cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            }
            add(event.name, cur, event.capture, event.passive, event.params);
        }
        else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for (name in oldOn) {
        if (isUndef(on[name])) {
            event = normalizeEvent(name);
            remove(event.name, oldOn[name], event.capture);
        }
    }
}

function mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof VNode) {
        def = def.data.hook || (def.data.hook = {});
    }
    var invoker;
    var oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        remove$2(invoker.fns, wrappedHook);
    }
    if (isUndef(oldHook)) {
        // no existing hook
        invoker = createFnInvoker([wrappedHook]);
    }
    else {
        /* istanbul ignore if */
        if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
            // already a merged invoker
            invoker = oldHook;
            invoker.fns.push(wrappedHook);
        }
        else {
            // existing plain hook
            invoker = createFnInvoker([oldHook, wrappedHook]);
        }
    }
    invoker.merged = true;
    def[hookKey] = invoker;
}

function extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if (isUndef(propOptions)) {
        return;
    }
    var res = {};
    var attrs = data.attrs, props = data.props;
    if (isDef(attrs) || isDef(props)) {
        for (var key in propOptions) {
            var altKey = hyphenate(key);
            if (false) {
                var keyInLowerCase = key.toLowerCase();
                if (key !== keyInLowerCase && attrs && hasOwn(attrs, keyInLowerCase)) {
                    tip("Prop \"".concat(keyInLowerCase, "\" is passed to component ") +
                        "".concat(formatComponentName(
                        // @ts-expect-error tag is string
                        tag || Ctor), ", but the declared prop name is") +
                        " \"".concat(key, "\". ") +
                        "Note that HTML attributes are case-insensitive and camelCased " +
                        "props need to use their kebab-case equivalents when using in-DOM " +
                        "templates. You should probably use \"".concat(altKey, "\" instead of \"").concat(key, "\"."));
                }
            }
            checkProp(res, props, key, altKey, true) ||
                checkProp(res, attrs, key, altKey, false);
        }
    }
    return res;
}
function checkProp(res, hash, key, altKey, preserve) {
    if (isDef(hash)) {
        if (hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) {
                delete hash[key];
            }
            return true;
        }
        else if (hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) {
                delete hash[altKey];
            }
            return true;
        }
    }
    return false;
}

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren(children) {
    for (var i = 0; i < children.length; i++) {
        if (isArray(children[i])) {
            return Array.prototype.concat.apply([], children);
        }
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren(children) {
    return isPrimitive(children)
        ? [createTextVNode(children)]
        : isArray(children)
            ? normalizeArrayChildren(children)
            : undefined;
}
function isTextNode(node) {
    return isDef(node) && isDef(node.text) && isFalse(node.isComment);
}
function normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for (i = 0; i < children.length; i++) {
        c = children[i];
        if (isUndef(c) || typeof c === 'boolean')
            continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if (isArray(c)) {
            if (c.length > 0) {
                c = normalizeArrayChildren(c, "".concat(nestedIndex || '', "_").concat(i));
                // merge adjacent text nodes
                if (isTextNode(c[0]) && isTextNode(last)) {
                    res[lastIndex] = createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        }
        else if (isPrimitive(c)) {
            if (isTextNode(last)) {
                // merge adjacent text nodes
                // this is necessary for SSR hydration because text nodes are
                // essentially merged when rendered to HTML strings
                res[lastIndex] = createTextVNode(last.text + c);
            }
            else if (c !== '') {
                // convert primitive to vnode
                res.push(createTextVNode(c));
            }
        }
        else {
            if (isTextNode(c) && isTextNode(last)) {
                // merge adjacent text nodes
                res[lastIndex] = createTextVNode(last.text + c.text);
            }
            else {
                // default key for nested array children (likely generated by v-for)
                if (isTrue(children._isVList) &&
                    isDef(c.tag) &&
                    isUndef(c.key) &&
                    isDef(nestedIndex)) {
                    c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
                }
                res.push(c);
            }
        }
    }
    return res;
}

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if (isArray(data) || isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if (isTrue(alwaysNormalize)) {
        normalizationType = ALWAYS_NORMALIZE;
    }
    return _createElement(context, tag, data, children, normalizationType);
}
function _createElement(context, tag, data, children, normalizationType) {
    if (isDef(data) && isDef(data.__ob__)) {
        "production" !== 'production' &&
            warn$2("Avoid using observed data object as vnode data: ".concat(JSON.stringify(data), "\n") + 'Always create fresh vnode data objects in each render!', context);
        return createEmptyVNode();
    }
    // object syntax in v-bind
    if (isDef(data) && isDef(data.is)) {
        tag = data.is;
    }
    if (!tag) {
        // in case of component :is set to falsy value
        return createEmptyVNode();
    }
    // warn against non-primitive key
    if (false) {
        warn$2('Avoid using non-primitive value as key, ' +
            'use string/number value instead.', context);
    }
    // support single function children as default scoped slot
    if (isArray(children) && isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = { default: children[0] };
        children.length = 0;
    }
    if (normalizationType === ALWAYS_NORMALIZE) {
        children = normalizeChildren(children);
    }
    else if (normalizationType === SIMPLE_NORMALIZE) {
        children = simpleNormalizeChildren(children);
    }
    var vnode, ns;
    if (typeof tag === 'string') {
        var Ctor = void 0;
        ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
        if (config.isReservedTag(tag)) {
            // platform built-in elements
            if (false) {
                warn$2("The .native modifier for v-on is only valid on components but it was used on <".concat(tag, ">."), context);
            }
            vnode = new VNode(config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        }
        else if ((!data || !data.pre) &&
            isDef((Ctor = resolveAsset(context.$options, 'components', tag)))) {
            // component
            vnode = createComponent(Ctor, data, context, children, tag);
        }
        else {
            // unknown or unlisted namespaced elements
            // check at runtime because it may get assigned a namespace when its
            // parent normalizes children
            vnode = new VNode(tag, data, children, undefined, undefined, context);
        }
    }
    else {
        // direct component options / constructor
        vnode = createComponent(tag, data, context, children);
    }
    if (isArray(vnode)) {
        return vnode;
    }
    else if (isDef(vnode)) {
        if (isDef(ns))
            applyNS(vnode, ns);
        if (isDef(data))
            registerDeepBindings(data);
        return vnode;
    }
    else {
        return createEmptyVNode();
    }
}
function applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === 'foreignObject') {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if (isDef(vnode.children)) {
        for (var i = 0, l = vnode.children.length; i < l; i++) {
            var child = vnode.children[i];
            if (isDef(child.tag) &&
                (isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
                applyNS(child, ns, force);
            }
        }
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings(data) {
    if (isObject(data.style)) {
        traverse(data.style);
    }
    if (isObject(data.class)) {
        traverse(data.class);
    }
}

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList(val, render) {
    var ret = null, i, l, keys, key;
    if (isArray(val) || typeof val === 'string') {
        ret = new Array(val.length);
        for (i = 0, l = val.length; i < l; i++) {
            ret[i] = render(val[i], i);
        }
    }
    else if (typeof val === 'number') {
        ret = new Array(val);
        for (i = 0; i < val; i++) {
            ret[i] = render(i + 1, i);
        }
    }
    else if (isObject(val)) {
        if (hasSymbol && val[Symbol.iterator]) {
            ret = [];
            var iterator = val[Symbol.iterator]();
            var result = iterator.next();
            while (!result.done) {
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        }
        else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for (i = 0, l = keys.length; i < l; i++) {
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!isDef(ret)) {
        ret = [];
    }
    ret._isVList = true;
    return ret;
}

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) {
            if (false) {
                warn$2('slot v-bind without argument expects an Object', this);
            }
            props = extend(extend({}, bindObject), props);
        }
        nodes =
            scopedSlotFn(props) ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    else {
        nodes =
            this.$slots[name] ||
                (isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    }
    var target = props && props.slot;
    if (target) {
        return this.$createElement('template', { slot: target }, nodes);
    }
    else {
        return nodes;
    }
}

/**
 * Runtime helper for resolving filters
 */
function resolveFilter(id) {
    return resolveAsset(this.$options, 'filters', id, true) || identity;
}

function isKeyNotMatch(expect, actual) {
    if (isArray(expect)) {
        return expect.indexOf(actual) === -1;
    }
    else {
        return expect !== actual;
    }
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
        return isKeyNotMatch(builtInKeyName, eventKeyName);
    }
    else if (mappedKeyCode) {
        return isKeyNotMatch(mappedKeyCode, eventKeyCode);
    }
    else if (eventKeyName) {
        return hyphenate(eventKeyName) !== key;
    }
    return eventKeyCode === undefined;
}

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!isObject(value)) {
            "production" !== 'production' &&
                warn$2('v-bind without argument expects an Object or Array value', this);
        }
        else {
            if (isArray(value)) {
                value = toObject(value);
            }
            var hash = void 0;
            var _loop_1 = function (key) {
                if (key === 'class' || key === 'style' || isReservedAttribute(key)) {
                    hash = data;
                }
                else {
                    var type = data.attrs && data.attrs.type;
                    hash =
                        asProp || config.mustUseProp(tag, type, key)
                            ? data.domProps || (data.domProps = {})
                            : data.attrs || (data.attrs = {});
                }
                var camelizedKey = camelize(key);
                var hyphenatedKey = hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        var on = data.on || (data.on = {});
                        on["update:".concat(key)] = function ($event) {
                            value[key] = $event;
                        };
                    }
                }
            };
            for (var key in value) {
                _loop_1(key);
            }
        }
    }
    return data;
}

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) {
        return tree;
    }
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    markStatic$1(tree, "__static__".concat(index), false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce(tree, index, key) {
    markStatic$1(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
    return tree;
}
function markStatic$1(tree, key, isOnce) {
    if (isArray(tree)) {
        for (var i = 0; i < tree.length; i++) {
            if (tree[i] && typeof tree[i] !== 'string') {
                markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
            }
        }
    }
    else {
        markStaticNode(tree, key, isOnce);
    }
}
function markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}

function bindObjectListeners(data, value) {
    if (value) {
        if (!isPlainObject(value)) {
            "production" !== 'production' && warn$2('v-on without argument expects an Object value', this);
        }
        else {
            var on = (data.on = data.on ? extend({}, data.on) : {});
            for (var key in value) {
                var existing = on[key];
                var ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}

function resolveScopedSlots(fns, res, 
// the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || { $stable: !hasDynamicKeys };
    for (var i = 0; i < fns.length; i++) {
        var slot = fns[i];
        if (isArray(slot)) {
            resolveScopedSlots(slot, res, hasDynamicKeys);
        }
        else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) {
                // @ts-expect-error
                slot.fn.proxy = true;
            }
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) {
        res.$key = contentHashKey;
    }
    return res;
}

// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function bindDynamicKeys(baseObj, values) {
    for (var i = 0; i < values.length; i += 2) {
        var key = values[i];
        if (typeof key === 'string' && key) {
            baseObj[values[i]] = values[i + 1];
        }
        else if (false) {
            // null is a special value for explicitly removing a binding
            warn$2("Invalid value for dynamic directive argument (expected string or null): ".concat(key), this);
        }
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier(value, symbol) {
    return typeof value === 'string' ? symbol + value : value;
}

function installRenderHelpers(target) {
    target._o = markOnce;
    target._n = toNumber;
    target._s = toString;
    target._l = renderList;
    target._t = renderSlot;
    target._q = looseEqual;
    target._i = looseIndexOf;
    target._m = renderStatic;
    target._f = resolveFilter;
    target._k = checkKeyCodes;
    target._b = bindObjectProps;
    target._v = createTextVNode;
    target._e = createEmptyVNode;
    target._u = resolveScopedSlots;
    target._g = bindObjectListeners;
    target._d = bindDynamicKeys;
    target._p = prependModifier;
}

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots(children, context) {
    if (!children || !children.length) {
        return {};
    }
    var slots = {};
    for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
        }
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) &&
            data &&
            data.slot != null) {
            var name_1 = data.slot;
            var slot = slots[name_1] || (slots[name_1] = []);
            if (child.tag === 'template') {
                slot.push.apply(slot, child.children || []);
            }
            else {
                slot.push(child);
            }
        }
        else {
            (slots.default || (slots.default = [])).push(child);
        }
    }
    // ignore slots that contains only whitespace
    for (var name_2 in slots) {
        if (slots[name_2].every(isWhitespace)) {
            delete slots[name_2];
        }
    }
    return slots;
}
function isWhitespace(node) {
    return (node.isComment && !node.asyncFactory) || node.text === ' ';
}

function isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}

function normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    var key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) {
        res = {};
    }
    else if (scopedSlots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return scopedSlots._normalized;
    }
    else if (isStable &&
        prevScopedSlots &&
        prevScopedSlots !== emptyObject &&
        key === prevScopedSlots.$key &&
        !hasNormalSlots &&
        !prevScopedSlots.$hasNormal) {
        // fast path 2: stable scoped slots w/ no normal slots to proxy,
        // only need to normalize once
        return prevScopedSlots;
    }
    else {
        res = {};
        for (var key_1 in scopedSlots) {
            if (scopedSlots[key_1] && key_1[0] !== '$') {
                res[key_1] = normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key_2 in normalSlots) {
        if (!(key_2 in res)) {
            res[key_2] = proxyNormalSlot(normalSlots, key_2);
        }
    }
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) {
        scopedSlots._normalized = res;
    }
    def(res, '$stable', isStable);
    def(res, '$key', key);
    def(res, '$hasNormal', hasNormalSlots);
    return res;
}
function normalizeScopedSlot(vm, normalSlots, key, fn) {
    var normalized = function () {
        var cur = currentInstance;
        setCurrentInstance(vm);
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res =
            res && typeof res === 'object' && !isArray(res)
                ? [res] // single vnode
                : normalizeChildren(res);
        var vnode = res && res[0];
        setCurrentInstance(cur);
        return res &&
            (!vnode ||
                (res.length === 1 && vnode.isComment && !isAsyncPlaceholder(vnode))) // #9658, #10391
            ? undefined
            : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) {
        Object.defineProperty(normalSlots, key, {
            get: normalized,
            enumerable: true,
            configurable: true
        });
    }
    return normalized;
}
function proxyNormalSlot(slots, key) {
    return function () { return slots[key]; };
}

function initSetup(vm) {
    var options = vm.$options;
    var setup = options.setup;
    if (setup) {
        var ctx = (vm._setupContext = createSetupContext(vm));
        setCurrentInstance(vm);
        pushTarget();
        var setupResult = invokeWithErrorHandling(setup, null, [vm._props || shallowReactive({}), ctx], vm, "setup");
        popTarget();
        setCurrentInstance();
        if (isFunction(setupResult)) {
            // render function
            // @ts-ignore
            options.render = setupResult;
        }
        else if (isObject(setupResult)) {
            // bindings
            if (false) {
                warn$2("setup() should not return VNodes directly - " +
                    "return a render function instead.");
            }
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for (var key in setupResult) {
                    if (!isReserved(key)) {
                        proxyWithRefUnwrap(vm, setupResult, key);
                    }
                    else if (false) {
                        warn$2("Avoid using variables that start with _ or $ in setup().");
                    }
                }
            }
            else {
                // exposed for compiled render fn
                var proxy = (vm._setupProxy = {});
                for (var key in setupResult) {
                    if (key !== '__sfc') {
                        proxyWithRefUnwrap(proxy, setupResult, key);
                    }
                }
            }
        }
        else if (false) {
            warn$2("setup() should return an object. Received: ".concat(setupResult === null ? 'null' : typeof setupResult));
        }
    }
}
function createSetupContext(vm) {
    var exposeCalled = false;
    return {
        get attrs() {
            if (!vm._attrsProxy) {
                var proxy = (vm._attrsProxy = {});
                def(proxy, '_v_attr_proxy', true);
                syncSetupProxy(proxy, vm.$attrs, emptyObject, vm, '$attrs');
            }
            return vm._attrsProxy;
        },
        get listeners() {
            if (!vm._listenersProxy) {
                var proxy = (vm._listenersProxy = {});
                syncSetupProxy(proxy, vm.$listeners, emptyObject, vm, '$listeners');
            }
            return vm._listenersProxy;
        },
        get slots() {
            return initSlotsProxy(vm);
        },
        emit: bind$1(vm.$emit, vm),
        expose: function (exposed) {
            if (false) {
                if (exposeCalled) {
                    warn$2("expose() should be called only once per setup().", vm);
                }
                exposeCalled = true;
            }
            if (exposed) {
                Object.keys(exposed).forEach(function (key) {
                    return proxyWithRefUnwrap(vm, exposed, key);
                });
            }
        }
    };
}
function syncSetupProxy(to, from, prev, instance, type) {
    var changed = false;
    for (var key in from) {
        if (!(key in to)) {
            changed = true;
            defineProxyAttr(to, key, instance, type);
        }
        else if (from[key] !== prev[key]) {
            changed = true;
        }
    }
    for (var key in to) {
        if (!(key in from)) {
            changed = true;
            delete to[key];
        }
    }
    return changed;
}
function defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function () {
            return instance[type][key];
        }
    });
}
function initSlotsProxy(vm) {
    if (!vm._slotsProxy) {
        syncSetupSlots((vm._slotsProxy = {}), vm.$scopedSlots);
    }
    return vm._slotsProxy;
}
function syncSetupSlots(to, from) {
    for (var key in from) {
        to[key] = from[key];
    }
    for (var key in to) {
        if (!(key in from)) {
            delete to[key];
        }
    }
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useSlots() {
    return getContext().slots;
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useAttrs() {
    return getContext().attrs;
}
/**
 * Vue 2 only
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */
function useListeners() {
    return getContext().listeners;
}
function getContext() {
    if (false) {
        warn$2("useContext() called without active instance.");
    }
    var vm = currentInstance;
    return vm._setupContext || (vm._setupContext = createSetupContext(vm));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */
function mergeDefaults(raw, defaults) {
    var props = isArray(raw)
        ? raw.reduce(function (normalized, p) { return ((normalized[p] = {}), normalized); }, {})
        : raw;
    for (var key in defaults) {
        var opt = props[key];
        if (opt) {
            if (isArray(opt) || isFunction(opt)) {
                props[key] = { type: opt, default: defaults[key] };
            }
            else {
                opt.default = defaults[key];
            }
        }
        else if (opt === null) {
            props[key] = { default: defaults[key] };
        }
        else if (false) {
            warn$2("props default key \"".concat(key, "\" has no corresponding declaration."));
        }
    }
    return props;
}

function initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = (vm.$vnode = options._parentVnode); // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode
        ? normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots)
        : emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, false); };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = function (a, b, c, d) { return createElement$1(vm, a, b, c, d, true); };
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;
    /* istanbul ignore else */
    if (false) {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$attrs is readonly.", vm);
        }, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
            !isUpdatingChildComponent && warn$2("$listeners is readonly.", vm);
        }, true);
    }
    else {
        defineReactive(vm, '$attrs', (parentData && parentData.attrs) || emptyObject, null, true);
        defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
    }
}
var currentRenderingInstance = null;
function renderMixin(Vue) {
    // install runtime convenience helpers
    installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function (fn) {
        return nextTick(fn, this);
    };
    Vue.prototype._render = function () {
        var vm = this;
        var _a = vm.$options, render = _a.render, _parentVnode = _a._parentVnode;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) {
                syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
            }
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var vnode;
        try {
            // There's no need to maintain a stack because all render fns are called
            // separately from one another. Nested component's render fns are called
            // when parent component is patched.
            setCurrentInstance(vm);
            currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        }
        catch (e) {
            handleError(e, vm, "render");
            // return error render result,
            // or previous vnode to prevent render error causing blank component
            /* istanbul ignore else */
            if (false) {
                try {
                    vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
                }
                catch (e) {
                    handleError(e, vm, "renderError");
                    vnode = vm._vnode;
                }
            }
            else {
                vnode = vm._vnode;
            }
        }
        finally {
            currentRenderingInstance = null;
            setCurrentInstance();
        }
        // if the returned array contains only a single node, allow it
        if (isArray(vnode) && vnode.length === 1) {
            vnode = vnode[0];
        }
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof VNode)) {
            if (false) {
                warn$2('Multiple root nodes returned from render function. Render function ' +
                    'should return a single root node.', vm);
            }
            vnode = createEmptyVNode();
        }
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}

function ensureCtor(comp, base) {
    if (comp.__esModule || (hasSymbol && comp[Symbol.toStringTag] === 'Module')) {
        comp = comp.default;
    }
    return isObject(comp) ? base.extend(comp) : comp;
}
function createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = { data: data, context: context, children: children, tag: tag };
    return node;
}
function resolveAsyncComponent(factory, baseCtor) {
    if (isTrue(factory.error) && isDef(factory.errorComp)) {
        return factory.errorComp;
    }
    if (isDef(factory.resolved)) {
        return factory.resolved;
    }
    var owner = currentRenderingInstance;
    if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
        // already pending
        factory.owners.push(owner);
    }
    if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
        return factory.loadingComp;
    }
    if (owner && !isDef(factory.owners)) {
        var owners_1 = (factory.owners = [owner]);
        var sync_1 = true;
        var timerLoading_1 = null;
        var timerTimeout_1 = null;
        owner.$on('hook:destroyed', function () { return remove$2(owners_1, owner); });
        var forceRender_1 = function (renderCompleted) {
            for (var i = 0, l = owners_1.length; i < l; i++) {
                owners_1[i].$forceUpdate();
            }
            if (renderCompleted) {
                owners_1.length = 0;
                if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                }
                if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                }
            }
        };
        var resolve = once(function (res) {
            // cache resolved
            factory.resolved = ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync_1) {
                forceRender_1(true);
            }
            else {
                owners_1.length = 0;
            }
        });
        var reject_1 = once(function (reason) {
            "production" !== 'production' &&
                warn$2("Failed to resolve async component: ".concat(String(factory)) +
                    (reason ? "\nReason: ".concat(reason) : ''));
            if (isDef(factory.errorComp)) {
                factory.error = true;
                forceRender_1(true);
            }
        });
        var res_1 = factory(resolve, reject_1);
        if (isObject(res_1)) {
            if (isPromise(res_1)) {
                // () => Promise
                if (isUndef(factory.resolved)) {
                    res_1.then(resolve, reject_1);
                }
            }
            else if (isPromise(res_1.component)) {
                res_1.component.then(resolve, reject_1);
                if (isDef(res_1.error)) {
                    factory.errorComp = ensureCtor(res_1.error, baseCtor);
                }
                if (isDef(res_1.loading)) {
                    factory.loadingComp = ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) {
                        factory.loading = true;
                    }
                    else {
                        // @ts-expect-error NodeJS timeout type
                        timerLoading_1 = setTimeout(function () {
                            timerLoading_1 = null;
                            if (isUndef(factory.resolved) && isUndef(factory.error)) {
                                factory.loading = true;
                                forceRender_1(false);
                            }
                        }, res_1.delay || 200);
                    }
                }
                if (isDef(res_1.timeout)) {
                    // @ts-expect-error NodeJS timeout type
                    timerTimeout_1 = setTimeout(function () {
                        timerTimeout_1 = null;
                        if (isUndef(factory.resolved)) {
                            reject_1( false ? "timeout (".concat(res_1.timeout, "ms)") : null);
                        }
                    }, res_1.timeout);
                }
            }
        }
        sync_1 = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}

function getFirstComponentChild(children) {
    if (isArray(children)) {
        for (var i = 0; i < children.length; i++) {
            var c = children[i];
            if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
                return c;
            }
        }
    }
}

function initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) {
        updateComponentListeners(vm, listeners);
    }
}
var target$1;
function add$1(event, fn) {
    target$1.$on(event, fn);
}
function remove$1(event, fn) {
    target$1.$off(event, fn);
}
function createOnceHandler$1(event, fn) {
    var _target = target$1;
    return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) {
            _target.$off(event, onceHandler);
        }
    };
}
function updateComponentListeners(vm, listeners, oldListeners) {
    target$1 = vm;
    updateListeners(listeners, oldListeners || {}, add$1, remove$1, createOnceHandler$1, vm);
    target$1 = undefined;
}
function eventsMixin(Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function (event, fn) {
        var vm = this;
        if (isArray(event)) {
            for (var i = 0, l = event.length; i < l; i++) {
                vm.$on(event[i], fn);
            }
        }
        else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) {
                vm._hasHookEvent = true;
            }
        }
        return vm;
    };
    Vue.prototype.$once = function (event, fn) {
        var vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function (event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if (isArray(event)) {
            for (var i_1 = 0, l = event.length; i_1 < l; i_1++) {
                vm.$off(event[i_1], fn);
            }
            return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) {
            return vm;
        }
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while (i--) {
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function (event) {
        var vm = this;
        if (false) {
            var lowerCaseEvent = event.toLowerCase();
            if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
                tip("Event \"".concat(lowerCaseEvent, "\" is emitted in component ") +
                    "".concat(formatComponentName(vm), " but the handler is registered for \"").concat(event, "\". ") +
                    "Note that HTML attributes are case-insensitive and you cannot use " +
                    "v-on to listen to camelCase events when using in-DOM templates. " +
                    "You should probably use \"".concat(hyphenate(event), "\" instead of \"").concat(event, "\"."));
            }
        }
        var cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? toArray(cbs) : cbs;
            var args = toArray(arguments, 1);
            var info = "event handler for \"".concat(event, "\"");
            for (var i = 0, l = cbs.length; i < l; i++) {
                invokeWithErrorHandling(cbs[i], vm, args, vm, info);
            }
        }
        return vm;
    };
}

var activeInstance = null;
var isUpdatingChildComponent = false;
function setActiveInstance(vm) {
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    return function () {
        activeInstance = prevActiveInstance;
    };
}
function initLifecycle(vm) {
    var options = vm.$options;
    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
        while (parent.$options.abstract && parent.$parent) {
            parent = parent.$parent;
        }
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function lifecycleMixin(Vue) {
    Vue.prototype._update = function (vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) {
            // initial render
            vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
        }
        else {
            // updates
            vm.$el = vm.__patch__(prevVnode, vnode);
        }
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) {
            prevEl.__vue__ = null;
        }
        if (vm.$el) {
            vm.$el.__vue__ = vm;
        }
        // if parent is an HOC, update its $el as well
        var wrapper = vm;
        while (wrapper &&
            wrapper.$vnode &&
            wrapper.$parent &&
            wrapper.$vnode === wrapper.$parent._vnode) {
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
        // updated hook is called by the scheduler to ensure that children are
        // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function () {
        var vm = this;
        if (vm._watcher) {
            vm._watcher.update();
        }
    };
    Vue.prototype.$destroy = function () {
        var vm = this;
        if (vm._isBeingDestroyed) {
            return;
        }
        callHook$1(vm, 'beforeDestroy');
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
            remove$2(parent.$children, vm);
        }
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) {
            vm._data.__ob__.vmCount--;
        }
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        callHook$1(vm, 'destroyed');
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) {
            vm.$el.__vue__ = null;
        }
        // release circular reference (#6759)
        if (vm.$vnode) {
            vm.$vnode.parent = null;
        }
    };
}
function mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) {
        // @ts-expect-error invalid type
        vm.$options.render = createEmptyVNode;
        if (false) {
            /* istanbul ignore if */
            if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
                vm.$options.el ||
                el) {
                warn$2('You are using the runtime-only build of Vue where the template ' +
                    'compiler is not available. Either pre-compile the templates into ' +
                    'render functions, or use the compiler-included build.', vm);
            }
            else {
                warn$2('Failed to mount component: template or render function not defined.', vm);
            }
        }
    }
    callHook$1(vm, 'beforeMount');
    var updateComponent;
    /* istanbul ignore if */
    if (false) {
        updateComponent = function () {
            var name = vm._name;
            var id = vm._uid;
            var startTag = "vue-perf-start:".concat(id);
            var endTag = "vue-perf-end:".concat(id);
            mark(startTag);
            var vnode = vm._render();
            mark(endTag);
            measure("vue ".concat(name, " render"), startTag, endTag);
            mark(startTag);
            vm._update(vnode, hydrating);
            mark(endTag);
            measure("vue ".concat(name, " patch"), startTag, endTag);
        };
    }
    else {
        updateComponent = function () {
            vm._update(vm._render(), hydrating);
        };
    }
    var watcherOptions = {
        before: function () {
            if (vm._isMounted && !vm._isDestroyed) {
                callHook$1(vm, 'beforeUpdate');
            }
        }
    };
    if (false) {
        watcherOptions.onTrack = function (e) { return callHook$1(vm, 'renderTracked', [e]); };
        watcherOptions.onTrigger = function (e) { return callHook$1(vm, 'renderTriggered', [e]); };
    }
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new Watcher(vm, updateComponent, noop, watcherOptions, true /* isRenderWatcher */);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    var preWatchers = vm._preWatchers;
    if (preWatchers) {
        for (var i = 0; i < preWatchers.length; i++) {
            preWatchers[i].run();
        }
    }
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        callHook$1(vm, 'mounted');
    }
    return vm;
}
function updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    if (false) {
        isUpdatingChildComponent = true;
    }
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!((newScopedSlots && !newScopedSlots.$stable) ||
        (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
        (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key) ||
        (!newScopedSlots && vm.$scopedSlots.$key));
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(renderChildren || // has new static slots
        vm.$options._renderChildren || // has old static slots
        hasDynamicScopedSlot);
    var prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) {
        // update child tree's parent
        vm._vnode.parent = parentVnode;
    }
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    var attrs = parentVnode.data.attrs || emptyObject;
    if (vm._attrsProxy) {
        // force update if attrs are accessed and has changed since it may be
        // passed to a child component.
        if (syncSetupProxy(vm._attrsProxy, attrs, (prevVNode.data && prevVNode.data.attrs) || emptyObject, vm, '$attrs')) {
            needsForceUpdate = true;
        }
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || emptyObject;
    var prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) {
        syncSetupProxy(vm._listenersProxy, listeners, prevListeners || emptyObject, vm, '$listeners');
    }
    vm.$listeners = vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for (var i = 0; i < propKeys.length; i++) {
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = validateProp(key, propOptions, propsData, vm);
        }
        toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
    if (false) {
        isUpdatingChildComponent = false;
    }
}
function isInInactiveTree(vm) {
    while (vm && (vm = vm.$parent)) {
        if (vm._inactive)
            return true;
    }
    return false;
}
function activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    else if (vm._directInactive) {
        return;
    }
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for (var i = 0; i < vm.$children.length; i++) {
            activateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'activated');
    }
}
function deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if (isInInactiveTree(vm)) {
            return;
        }
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for (var i = 0; i < vm.$children.length; i++) {
            deactivateChildComponent(vm.$children[i]);
        }
        callHook$1(vm, 'deactivated');
    }
}
function callHook$1(vm, hook, args, setContext) {
    if (setContext === void 0) { setContext = true; }
    // #7573 disable dep collection when invoking lifecycle hooks
    pushTarget();
    var prev = currentInstance;
    setContext && setCurrentInstance(vm);
    var handlers = vm.$options[hook];
    var info = "".concat(hook, " hook");
    if (handlers) {
        for (var i = 0, j = handlers.length; i < j; i++) {
            invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
        }
    }
    if (vm._hasHookEvent) {
        vm.$emit('hook:' + hook);
    }
    setContext && setCurrentInstance(prev);
    popTarget();
}

var MAX_UPDATE_COUNT = 100;
var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index$1 = 0;
/**
 * Reset the scheduler's state.
 */
function resetSchedulerState() {
    index$1 = queue.length = activatedChildren.length = 0;
    has = {};
    if (false) {
        circular = {};
    }
    waiting = flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
    var performance_1 = window.performance;
    if (performance_1 &&
        typeof performance_1.now === 'function' &&
        getNow() > document.createEvent('Event').timeStamp) {
        // if the event timestamp, although evaluated AFTER the Date.now(), is
        // smaller than it, it means the event is using a hi-res timestamp,
        // and we need to use the hi-res version for event listener timestamps as
        // well.
        getNow = function () { return performance_1.now(); };
    }
}
var sortCompareFn = function (a, b) {
    if (a.post) {
        if (!b.post)
            return 1;
    }
    else if (b.post) {
        return -1;
    }
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue() {
    currentFlushTimestamp = getNow();
    flushing = true;
    var watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    queue.sort(sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for (index$1 = 0; index$1 < queue.length; index$1++) {
        watcher = queue[index$1];
        if (watcher.before) {
            watcher.before();
        }
        id = watcher.id;
        has[id] = null;
        watcher.run();
        // in dev build, check and stop circular updates.
        if (false) {
            circular[id] = (circular[id] || 0) + 1;
            if (circular[id] > MAX_UPDATE_COUNT) {
                warn$2('You may have an infinite update loop ' +
                    (watcher.user
                        ? "in watcher with expression \"".concat(watcher.expression, "\"")
                        : "in a component render function."), watcher.vm);
                break;
            }
        }
    }
    // keep copies of post queues before resetting state
    var activatedQueue = activatedChildren.slice();
    var updatedQueue = queue.slice();
    resetSchedulerState();
    // call component updated and activated hooks
    callActivatedHooks(activatedQueue);
    callUpdatedHooks(updatedQueue);
    cleanupDeps();
    // devtool hook
    /* istanbul ignore if */
    if (devtools && config.devtools) {
        devtools.emit('flush');
    }
}
function callUpdatedHooks(queue) {
    var i = queue.length;
    while (i--) {
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
            callHook$1(vm, 'updated');
        }
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    activatedChildren.push(vm);
}
function callActivatedHooks(queue) {
    for (var i = 0; i < queue.length; i++) {
        queue[i]._inactive = true;
        activateChildComponent(queue[i], true /* true */);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher(watcher) {
    var id = watcher.id;
    if (has[id] != null) {
        return;
    }
    if (watcher === Dep.target && watcher.noRecurse) {
        return;
    }
    has[id] = true;
    if (!flushing) {
        queue.push(watcher);
    }
    else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = queue.length - 1;
        while (i > index$1 && queue[i].id > watcher.id) {
            i--;
        }
        queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
        waiting = true;
        if (false) {
            flushSchedulerQueue();
            return;
        }
        nextTick(flushSchedulerQueue);
    }
}

var WATCHER = "watcher";
var WATCHER_CB = "".concat(WATCHER, " callback");
var WATCHER_GETTER = "".concat(WATCHER, " getter");
var WATCHER_CLEANUP = "".concat(WATCHER, " cleanup");
// Simple effect.
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? __assign(__assign({}, options), { flush: 'post' }) : { flush: 'post' }));
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, ( false
        ? __assign(__assign({}, options), { flush: 'sync' }) : { flush: 'sync' }));
}
// initial value for watchers to trigger on undefined initial values
var INITIAL_WATCHER_VALUE = {};
// implementation
function watch(source, cb, options) {
    if (false) {
        warn$2("`watch(fn, options?)` signature has been moved to a separate API. " +
            "Use `watchEffect(fn, options?)` instead. `watch` now only " +
            "supports `watch(source, cb, options?) signature.");
    }
    return doWatch(source, cb, options);
}
function doWatch(source, cb, _a) {
    var _b = _a === void 0 ? emptyObject : _a, immediate = _b.immediate, deep = _b.deep, _c = _b.flush, flush = _c === void 0 ? 'pre' : _c, onTrack = _b.onTrack, onTrigger = _b.onTrigger;
    if (false) {
        if (immediate !== undefined) {
            warn$2("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (deep !== undefined) {
            warn$2("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var warnInvalidSource = function (s) {
        warn$2("Invalid watch source: ".concat(s, ". A watch source can only be a getter/effect ") +
            "function, a ref, a reactive object, or an array of these types.");
    };
    var instance = currentInstance;
    var call = function (fn, type, args) {
        if (args === void 0) { args = null; }
        return invokeWithErrorHandling(fn, null, args, instance, type);
    };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if (isRef(source)) {
        getter = function () { return source.value; };
        forceTrigger = isShallow(source);
    }
    else if (isReactive(source)) {
        getter = function () {
            source.__ob__.dep.depend();
            return source;
        };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function (s) { return isReactive(s) || isShallow(s); });
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return call(s, WATCHER_GETTER);
                }
                else {
                    "production" !== 'production' && warnInvalidSource(s);
                }
            });
        };
    }
    else if (isFunction(source)) {
        if (cb) {
            // getter with cb
            getter = function () { return call(source, WATCHER_GETTER); };
        }
        else {
            // no cb -> simple effect
            getter = function () {
                if (instance && instance._isDestroyed) {
                    return;
                }
                if (cleanup) {
                    cleanup();
                }
                return call(source, WATCHER, [onCleanup]);
            };
        }
    }
    else {
        getter = noop;
        "production" !== 'production' && warnInvalidSource(source);
    }
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var cleanup;
    var onCleanup = function (fn) {
        cleanup = watcher.onStop = function () {
            call(fn, WATCHER_CLEANUP);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if (isServerRendering()) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = noop;
        if (!cb) {
            getter();
        }
        else if (immediate) {
            call(cb, WATCHER_CB, [
                getter(),
                isMultiSource ? [] : undefined,
                onCleanup
            ]);
        }
        return noop;
    }
    var watcher = new Watcher(currentInstance, getter, noop, {
        lazy: true
    });
    watcher.noRecurse = !cb;
    var oldValue = isMultiSource ? [] : INITIAL_WATCHER_VALUE;
    // overwrite default run
    watcher.run = function () {
        if (!watcher.active) {
            return;
        }
        if (cb) {
            // watch(source, cb)
            var newValue = watcher.get();
            if (deep ||
                forceTrigger ||
                (isMultiSource
                    ? newValue.some(function (v, i) {
                        return hasChanged(v, oldValue[i]);
                    })
                    : hasChanged(newValue, oldValue))) {
                // cleanup before running cb again
                if (cleanup) {
                    cleanup();
                }
                call(cb, WATCHER_CB, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        }
        else {
            // watchEffect
            watcher.get();
        }
    };
    if (flush === 'sync') {
        watcher.update = watcher.run;
    }
    else if (flush === 'post') {
        watcher.post = true;
        watcher.update = function () { return queueWatcher(watcher); };
    }
    else {
        // pre
        watcher.update = function () {
            if (instance && instance === currentInstance && !instance._isMounted) {
                // pre-watcher triggered before
                var buffer = instance._preWatchers || (instance._preWatchers = []);
                if (buffer.indexOf(watcher) < 0)
                    buffer.push(watcher);
            }
            else {
                queueWatcher(watcher);
            }
        };
    }
    if (false) {
        watcher.onTrack = onTrack;
        watcher.onTrigger = onTrigger;
    }
    // initial run
    if (cb) {
        if (immediate) {
            watcher.run();
        }
        else {
            oldValue = watcher.get();
        }
    }
    else if (flush === 'post' && instance) {
        instance.$once('hook:mounted', function () { return watcher.get(); });
    }
    else {
        watcher.get();
    }
    return function () {
        watcher.teardown();
    };
}

var activeEffectScope;
var EffectScope = /** @class */ (function () {
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        this.detached = detached;
        /**
         * @internal
         */
        this.active = true;
        /**
         * @internal
         */
        this.effects = [];
        /**
         * @internal
         */
        this.cleanups = [];
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) {
            this.index =
                (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
        }
    }
    EffectScope.prototype.run = function (fn) {
        if (this.active) {
            var currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            }
            finally {
                activeEffectScope = currentEffectScope;
            }
        }
        else if (false) {
            warn$2("cannot run an inactive effect scope.");
        }
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.on = function () {
        activeEffectScope = this;
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */
    EffectScope.prototype.off = function () {
        activeEffectScope = this.parent;
    };
    EffectScope.prototype.stop = function (fromParent) {
        if (this.active) {
            var i = void 0, l = void 0;
            for (i = 0, l = this.effects.length; i < l; i++) {
                this.effects[i].teardown();
            }
            for (i = 0, l = this.cleanups.length; i < l; i++) {
                this.cleanups[i]();
            }
            if (this.scopes) {
                for (i = 0, l = this.scopes.length; i < l; i++) {
                    this.scopes[i].stop(true);
                }
            }
            // nested scope, dereference from parent to avoid memory leaks
            if (!this.detached && this.parent && !fromParent) {
                // optimized O(1) removal
                var last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = undefined;
            this.active = false;
        }
    };
    return EffectScope;
}());
function effectScope(detached) {
    return new EffectScope(detached);
}
/**
 * @internal
 */
function recordEffectScope(effect, scope) {
    if (scope === void 0) { scope = activeEffectScope; }
    if (scope && scope.active) {
        scope.effects.push(effect);
    }
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if (false) {
        warn$2("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}

function provide(key, value) {
    if (!currentInstance) {
        if (false) {
            warn$2("provide() can only be used inside setup().");
        }
    }
    else {
        // TS doesn't allow symbol as index type
        resolveProvided(currentInstance)[key] = value;
    }
}
function resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    var existing = vm._provided;
    var parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) {
        return (vm._provided = Object.create(parentProvides));
    }
    else {
        return existing;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    var instance = currentInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        var provides = instance.$parent && instance.$parent._provided;
        if (provides && key in provides) {
            // TS doesn't allow symbol as index type
            return provides[key];
        }
        else if (arguments.length > 1) {
            return treatDefaultAsFactory && isFunction(defaultValue)
                ? defaultValue.call(instance)
                : defaultValue;
        }
        else if (false) {
            warn$2("injection \"".concat(String(key), "\" not found."));
        }
    }
    else if (false) {
        warn$2("inject() can only be used inside setup() or functional components.");
    }
}

/**
 * @internal this function needs manual public type declaration because it relies
 * on previously manually authored types from Vue 2
 */
function h(type, props, children) {
    if (!currentInstance) {
        "production" !== 'production' &&
            warn$2("globally imported h() can only be invoked when there is an active " +
                "component instance, e.g. synchronously in a component's render or setup function.");
    }
    return createElement$1(currentInstance, type, props, children, 2, true);
}

function handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    pushTarget();
    try {
        if (vm) {
            var cur = vm;
            while ((cur = cur.$parent)) {
                var hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for (var i = 0; i < hooks.length; i++) {
                        try {
                            var capture = hooks[i].call(cur, err, vm, info) === false;
                            if (capture)
                                return;
                        }
                        catch (e) {
                            globalHandleError(e, cur, 'errorCaptured hook');
                        }
                    }
                }
            }
        }
        globalHandleError(err, vm, info);
    }
    finally {
        popTarget();
    }
}
function invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && isPromise(res) && !res._handled) {
            res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
            res._handled = true;
        }
    }
    catch (e) {
        handleError(e, vm, info);
    }
    return res;
}
function globalHandleError(err, vm, info) {
    if (config.errorHandler) {
        try {
            return config.errorHandler.call(null, err, vm, info);
        }
        catch (e) {
            // if the user intentionally throws the original error in the handler,
            // do not log it twice
            if (e !== err) {
                logError(e, null, 'config.errorHandler');
            }
        }
    }
    logError(err, vm, info);
}
function logError(err, vm, info) {
    if (false) {
        warn$2("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    /* istanbul ignore else */
    if (inBrowser && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}

/* globals MutationObserver */
var isUsingMicroTask = false;
var callbacks = [];
var pending = false;
function flushCallbacks() {
    pending = false;
    var copies = callbacks.slice(0);
    callbacks.length = 0;
    for (var i = 0; i < copies.length; i++) {
        copies[i]();
    }
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
    var p_1 = Promise.resolve();
    timerFunc = function () {
        p_1.then(flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if (isIOS)
            setTimeout(noop);
    };
    isUsingMicroTask = true;
}
else if (!isIE &&
    typeof MutationObserver !== 'undefined' &&
    (isNative(MutationObserver) ||
        // PhantomJS and iOS 7.x
        MutationObserver.toString() === '[object MutationObserverConstructor]')) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var counter_1 = 1;
    var observer = new MutationObserver(flushCallbacks);
    var textNode_1 = document.createTextNode(String(counter_1));
    observer.observe(textNode_1, {
        characterData: true
    });
    timerFunc = function () {
        counter_1 = (counter_1 + 1) % 2;
        textNode_1.data = String(counter_1);
    };
    isUsingMicroTask = true;
}
else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
    // Fallback to setImmediate.
    // Technically it leverages the (macro) task queue,
    // but it is still a better choice than setTimeout.
    timerFunc = function () {
        setImmediate(flushCallbacks);
    };
}
else {
    // Fallback to setTimeout.
    timerFunc = function () {
        setTimeout(flushCallbacks, 0);
    };
}
/**
 * @internal
 */
function nextTick(cb, ctx) {
    var _resolve;
    callbacks.push(function () {
        if (cb) {
            try {
                cb.call(ctx);
            }
            catch (e) {
                handleError(e, ctx, 'nextTick');
            }
        }
        else if (_resolve) {
            _resolve(ctx);
        }
    });
    if (!pending) {
        pending = true;
        timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== 'undefined') {
        return new Promise(function (resolve) {
            _resolve = resolve;
        });
    }
}

function useCssModule(name) {
    if (name === void 0) { name = '$style'; }
    /* istanbul ignore else */
    {
        if (!currentInstance) {
            "production" !== 'production' && warn$2("useCssModule must be called inside setup()");
            return emptyObject;
        }
        var mod = currentInstance[name];
        if (!mod) {
            "production" !== 'production' &&
                warn$2("Current instance does not have CSS module named \"".concat(name, "\"."));
            return emptyObject;
        }
        return mod;
    }
}

/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */
function useCssVars(getter) {
    if (!inBrowser && !false)
        return;
    var instance = currentInstance;
    if (!instance) {
        "production" !== 'production' &&
            warn$2("useCssVars is called without current active component instance.");
        return;
    }
    watchPostEffect(function () {
        var el = instance.$el;
        var vars = getter(instance, instance._setupProxy);
        if (el && el.nodeType === 1) {
            var style = el.style;
            for (var key in vars) {
                style.setProperty("--".concat(key), vars[key]);
            }
        }
    });
}

/**
 * v3-compatible async component API.
 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
 * because it relies on existing manual types
 */
function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn$2("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn$2("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent
        };
    };
}

function createLifeCycle(hookName) {
    return function (fn, target) {
        if (target === void 0) { target = currentInstance; }
        if (!target) {
            "production" !== 'production' &&
                warn$2("".concat(formatName(hookName), " is called when there is no active component instance to be ") +
                    "associated with. " +
                    "Lifecycle injection APIs can only be used during execution of setup().");
            return;
        }
        return injectHook(target, hookName, fn);
    };
}
function formatName(name) {
    if (name === 'beforeDestroy') {
        name = 'beforeUnmount';
    }
    else if (name === 'destroyed') {
        name = 'unmounted';
    }
    return "on".concat(name[0].toUpperCase() + name.slice(1));
}
function injectHook(instance, hookName, fn) {
    var options = instance.$options;
    options[hookName] = mergeLifecycleHook(options[hookName], fn);
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');
var onRenderTracked = createLifeCycle('renderTracked');
var onRenderTriggered = createLifeCycle('renderTriggered');
var injectErrorCapturedHook = createLifeCycle('errorCaptured');
function onErrorCaptured(hook, target) {
    if (target === void 0) { target = currentInstance; }
    injectErrorCapturedHook(hook, target);
}

/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */
var version = '2.7.14';
/**
 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
 */
function defineComponent(options) {
    return options;
}

var seenObjects = new _Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse(val) {
    _traverse(val, seenObjects);
    seenObjects.clear();
    return val;
}
function _traverse(val, seen) {
    var i, keys;
    var isA = isArray(val);
    if ((!isA && !isObject(val)) ||
        val.__v_skip /* ReactiveFlags.SKIP */ ||
        Object.isFrozen(val) ||
        val instanceof VNode) {
        return;
    }
    if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) {
            return;
        }
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while (i--)
            _traverse(val[i], seen);
    }
    else if (isRef(val)) {
        _traverse(val.value, seen);
    }
    else {
        keys = Object.keys(val);
        i = keys.length;
        while (i--)
            _traverse(val[keys[i]], seen);
    }
}

var uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */
var Watcher = /** @class */ (function () {
    function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        recordEffectScope(this, 
        // if the active effect scope is manually created (not a component scope),
        // prioritize it
        activeEffectScope && !activeEffectScope._vm
            ? activeEffectScope
            : vm
                ? vm._scope
                : undefined);
        if ((this.vm = vm) && isRenderWatcher) {
            vm._watcher = this;
        }
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
            if (false) {
                this.onTrack = options.onTrack;
                this.onTrigger = options.onTrigger;
            }
        }
        else {
            this.deep = this.user = this.lazy = this.sync = false;
        }
        this.cb = cb;
        this.id = ++uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new _Set();
        this.newDepIds = new _Set();
        this.expression =  false ? expOrFn.toString() : '';
        // parse expression for getter
        if (isFunction(expOrFn)) {
            this.getter = expOrFn;
        }
        else {
            this.getter = parsePath(expOrFn);
            if (!this.getter) {
                this.getter = noop;
                "production" !== 'production' &&
                    warn$2("Failed watching path: \"".concat(expOrFn, "\" ") +
                        'Watcher only accepts simple dot-delimited paths. ' +
                        'For full control, use a function instead.', vm);
            }
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */
    Watcher.prototype.get = function () {
        pushTarget(this);
        var value;
        var vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        }
        catch (e) {
            if (this.user) {
                handleError(e, vm, "getter for watcher \"".concat(this.expression, "\""));
            }
            else {
                throw e;
            }
        }
        finally {
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) {
                traverse(value);
            }
            popTarget();
            this.cleanupDeps();
        }
        return value;
    };
    /**
     * Add a dependency to this directive.
     */
    Watcher.prototype.addDep = function (dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) {
                dep.addSub(this);
            }
        }
    };
    /**
     * Clean up for dependency collection.
     */
    Watcher.prototype.cleanupDeps = function () {
        var i = this.deps.length;
        while (i--) {
            var dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) {
                dep.removeSub(this);
            }
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    };
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */
    Watcher.prototype.update = function () {
        /* istanbul ignore else */
        if (this.lazy) {
            this.dirty = true;
        }
        else if (this.sync) {
            this.run();
        }
        else {
            queueWatcher(this);
        }
    };
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */
    Watcher.prototype.run = function () {
        if (this.active) {
            var value = this.get();
            if (value !== this.value ||
                // Deep watchers and watchers on Object/Arrays should fire even
                // when the value is the same, because the value may
                // have mutated.
                isObject(value) ||
                this.deep) {
                // set new value
                var oldValue = this.value;
                this.value = value;
                if (this.user) {
                    var info = "callback for watcher \"".concat(this.expression, "\"");
                    invokeWithErrorHandling(this.cb, this.vm, [value, oldValue], this.vm, info);
                }
                else {
                    this.cb.call(this.vm, value, oldValue);
                }
            }
        }
    };
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */
    Watcher.prototype.evaluate = function () {
        this.value = this.get();
        this.dirty = false;
    };
    /**
     * Depend on all deps collected by this watcher.
     */
    Watcher.prototype.depend = function () {
        var i = this.deps.length;
        while (i--) {
            this.deps[i].depend();
        }
    };
    /**
     * Remove self from all dependencies' subscriber list.
     */
    Watcher.prototype.teardown = function () {
        if (this.vm && !this.vm._isBeingDestroyed) {
            remove$2(this.vm._scope.effects, this);
        }
        if (this.active) {
            var i = this.deps.length;
            while (i--) {
                this.deps[i].removeSub(this);
            }
            this.active = false;
            if (this.onStop) {
                this.onStop();
            }
        }
    };
    return Watcher;
}());

var sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: noop,
    set: noop
};
function proxy(target, sourceKey, key) {
    sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function initState(vm) {
    var opts = vm.$options;
    if (opts.props)
        initProps$1(vm, opts.props);
    // Composition API
    initSetup(vm);
    if (opts.methods)
        initMethods(vm, opts.methods);
    if (opts.data) {
        initData(vm);
    }
    else {
        var ob = observe((vm._data = {}));
        ob && ob.vmCount++;
    }
    if (opts.computed)
        initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== nativeWatch) {
        initWatch(vm, opts.watch);
    }
}
function initProps$1(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = (vm._props = shallowReactive({}));
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = (vm.$options._propKeys = []);
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) {
        toggleObserving(false);
    }
    var _loop_1 = function (key) {
        keys.push(key);
        var value = validateProp(key, propsOptions, propsData, vm);
        /* istanbul ignore else */
        if (false) {
            var hyphenatedKey = hyphenate(key);
            if (isReservedAttribute(hyphenatedKey) ||
                config.isReservedAttr(hyphenatedKey)) {
                warn$2("\"".concat(hyphenatedKey, "\" is a reserved attribute and cannot be used as component prop."), vm);
            }
            defineReactive(props, key, value, function () {
                if (!isRoot && !isUpdatingChildComponent) {
                    warn$2("Avoid mutating a prop directly since the value will be " +
                        "overwritten whenever the parent component re-renders. " +
                        "Instead, use a data or computed property based on the prop's " +
                        "value. Prop being mutated: \"".concat(key, "\""), vm);
                }
            });
        }
        else {
            defineReactive(props, key, value);
        }
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) {
            proxy(vm, "_props", key);
        }
    };
    for (var key in propsOptions) {
        _loop_1(key);
    }
    toggleObserving(true);
}
function initData(vm) {
    var data = vm.$options.data;
    data = vm._data = isFunction(data) ? getData(data, vm) : data || {};
    if (!isPlainObject(data)) {
        data = {};
        "production" !== 'production' &&
            warn$2('data functions should return an object:\n' +
                'https://v2.vuejs.org/v2/guide/components.html#data-Must-Be-a-Function', vm);
    }
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while (i--) {
        var key = keys[i];
        if (false) {
            if (methods && hasOwn(methods, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a data property."), vm);
            }
        }
        if (props && hasOwn(props, key)) {
            "production" !== 'production' &&
                warn$2("The data property \"".concat(key, "\" is already declared as a prop. ") +
                    "Use prop default value instead.", vm);
        }
        else if (!isReserved(key)) {
            proxy(vm, "_data", key);
        }
    }
    // observe data
    var ob = observe(data);
    ob && ob.vmCount++;
}
function getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    pushTarget();
    try {
        return data.call(vm, vm);
    }
    catch (e) {
        handleError(e, vm, "data()");
        return {};
    }
    finally {
        popTarget();
    }
}
var computedWatcherOptions = { lazy: true };
function initComputed$1(vm, computed) {
    // $flow-disable-line
    var watchers = (vm._computedWatchers = Object.create(null));
    // computed properties are just getters during SSR
    var isSSR = isServerRendering();
    for (var key in computed) {
        var userDef = computed[key];
        var getter = isFunction(userDef) ? userDef : userDef.get;
        if (false) {
            warn$2("Getter is missing for computed property \"".concat(key, "\"."), vm);
        }
        if (!isSSR) {
            // create internal watcher for the computed property.
            watchers[key] = new Watcher(vm, getter || noop, noop, computedWatcherOptions);
        }
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) {
            defineComputed(vm, key, userDef);
        }
        else if (false) {
            if (key in vm.$data) {
                warn$2("The computed property \"".concat(key, "\" is already defined in data."), vm);
            }
            else if (vm.$options.props && key in vm.$options.props) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a prop."), vm);
            }
            else if (vm.$options.methods && key in vm.$options.methods) {
                warn$2("The computed property \"".concat(key, "\" is already defined as a method."), vm);
            }
        }
    }
}
function defineComputed(target, key, userDef) {
    var shouldCache = !isServerRendering();
    if (isFunction(userDef)) {
        sharedPropertyDefinition.get = shouldCache
            ? createComputedGetter(key)
            : createGetterInvoker(userDef);
        sharedPropertyDefinition.set = noop;
    }
    else {
        sharedPropertyDefinition.get = userDef.get
            ? shouldCache && userDef.cache !== false
                ? createComputedGetter(key)
                : createGetterInvoker(userDef.get)
            : noop;
        sharedPropertyDefinition.set = userDef.set || noop;
    }
    if (false) {
        sharedPropertyDefinition.set = function () {
            warn$2("Computed property \"".concat(key, "\" was assigned to but it has no setter."), this);
        };
    }
    Object.defineProperty(target, key, sharedPropertyDefinition);
}
function createComputedGetter(key) {
    return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) {
                watcher.evaluate();
            }
            if (Dep.target) {
                if (false) {
                    Dep.target.onTrack({
                        effect: Dep.target,
                        target: this,
                        type: "get" /* TrackOpTypes.GET */,
                        key: key
                    });
                }
                watcher.depend();
            }
            return watcher.value;
        }
    };
}
function createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function initMethods(vm, methods) {
    var props = vm.$options.props;
    for (var key in methods) {
        if (false) {
            if (typeof methods[key] !== 'function') {
                warn$2("Method \"".concat(key, "\" has type \"").concat(typeof methods[key], "\" in the component definition. ") +
                    "Did you reference the function correctly?", vm);
            }
            if (props && hasOwn(props, key)) {
                warn$2("Method \"".concat(key, "\" has already been defined as a prop."), vm);
            }
            if (key in vm && isReserved(key)) {
                warn$2("Method \"".concat(key, "\" conflicts with an existing Vue instance method. ") +
                    "Avoid defining component methods that start with _ or $.");
            }
        }
        vm[key] = typeof methods[key] !== 'function' ? noop : bind$1(methods[key], vm);
    }
}
function initWatch(vm, watch) {
    for (var key in watch) {
        var handler = watch[key];
        if (isArray(handler)) {
            for (var i = 0; i < handler.length; i++) {
                createWatcher(vm, key, handler[i]);
            }
        }
        else {
            createWatcher(vm, key, handler);
        }
    }
}
function createWatcher(vm, expOrFn, handler, options) {
    if (isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === 'string') {
        handler = vm[handler];
    }
    return vm.$watch(expOrFn, handler, options);
}
function stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function () {
        return this._data;
    };
    var propsDef = {};
    propsDef.get = function () {
        return this._props;
    };
    if (false) {
        dataDef.set = function () {
            warn$2('Avoid replacing instance root $data. ' +
                'Use nested data properties instead.', this);
        };
        propsDef.set = function () {
            warn$2("$props is readonly.", this);
        };
    }
    Object.defineProperty(Vue.prototype, '$data', dataDef);
    Object.defineProperty(Vue.prototype, '$props', propsDef);
    Vue.prototype.$set = set;
    Vue.prototype.$delete = del;
    Vue.prototype.$watch = function (expOrFn, cb, options) {
        var vm = this;
        if (isPlainObject(cb)) {
            return createWatcher(vm, expOrFn, cb, options);
        }
        options = options || {};
        options.user = true;
        var watcher = new Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            var info = "callback for immediate watcher \"".concat(watcher.expression, "\"");
            pushTarget();
            invokeWithErrorHandling(cb, vm, [watcher.value], vm, info);
            popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}

function initProvide(vm) {
    var provideOption = vm.$options.provide;
    if (provideOption) {
        var provided = isFunction(provideOption)
            ? provideOption.call(vm)
            : provideOption;
        if (!isObject(provided)) {
            return;
        }
        var source = resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        var keys = hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function initInjections(vm) {
    var result = resolveInject(vm.$options.inject, vm);
    if (result) {
        toggleObserving(false);
        Object.keys(result).forEach(function (key) {
            /* istanbul ignore else */
            if (false) {
                defineReactive(vm, key, result[key], function () {
                    warn$2("Avoid mutating an injected value directly since the changes will be " +
                        "overwritten whenever the provided component re-renders. " +
                        "injection being mutated: \"".concat(key, "\""), vm);
                });
            }
            else {
                defineReactive(vm, key, result[key]);
            }
        });
        toggleObserving(true);
    }
}
function resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === '__ob__')
                continue;
            var provideKey = inject[key].from;
            if (provideKey in vm._provided) {
                result[key] = vm._provided[provideKey];
            }
            else if ('default' in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = isFunction(provideDefault)
                    ? provideDefault.call(vm)
                    : provideDefault;
            }
            else if (false) {
                warn$2("Injection \"".concat(key, "\" not found"), vm);
            }
        }
        return result;
    }
}

var uid = 0;
function initMixin$1(Vue) {
    Vue.prototype._init = function (options) {
        var vm = this;
        // a uid
        vm._uid = uid++;
        var startTag, endTag;
        /* istanbul ignore if */
        if (false) {
            startTag = "vue-perf-start:".concat(vm._uid);
            endTag = "vue-perf-end:".concat(vm._uid);
            mark(startTag);
        }
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new EffectScope(true /* detached */);
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) {
            // optimize internal component instantiation
            // since dynamic options merging is pretty slow, and none of the
            // internal component options needs special treatment.
            initInternalComponent(vm, options);
        }
        else {
            vm.$options = mergeOptions(resolveConstructorOptions(vm.constructor), options || {}, vm);
        }
        /* istanbul ignore else */
        if (false) {
            initProxy(vm);
        }
        else {
            vm._renderProxy = vm;
        }
        // expose real self
        vm._self = vm;
        initLifecycle(vm);
        initEvents(vm);
        initRender(vm);
        callHook$1(vm, 'beforeCreate', undefined, false /* setContext */);
        initInjections(vm); // resolve injections before data/props
        initState(vm);
        initProvide(vm); // resolve provide after data/props
        callHook$1(vm, 'created');
        /* istanbul ignore if */
        if (false) {
            vm._name = formatComponentName(vm, false);
            mark(endTag);
            measure("vue ".concat(vm._name, " init"), startTag, endTag);
        }
        if (vm.$options.el) {
            vm.$mount(vm.$options.el);
        }
    };
}
function initInternalComponent(vm, options) {
    var opts = (vm.$options = Object.create(vm.constructor.options));
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function resolveConstructorOptions(Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
        var superOptions = resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) {
                extend(Ctor.extendOptions, modifiedOptions);
            }
            options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) {
                options.components[options.name] = Ctor;
            }
        }
    }
    return options;
}
function resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for (var key in latest) {
        if (latest[key] !== sealed[key]) {
            if (!modified)
                modified = {};
            modified[key] = latest[key];
        }
    }
    return modified;
}

function FunctionalRenderContext(data, props, children, parent, Ctor) {
    var _this = this;
    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if (hasOwn(parent, '_uid')) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    }
    else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    var isCompiled = isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || emptyObject;
    this.injections = resolveInject(options.inject, parent);
    this.slots = function () {
        if (!_this.$slots) {
            normalizeScopedSlots(parent, data.scopedSlots, (_this.$slots = resolveSlots(children, parent)));
        }
        return _this.$slots;
    };
    Object.defineProperty(this, 'scopedSlots', {
        enumerable: true,
        get: function () {
            return normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) {
        this._c = function (a, b, c, d) {
            var vnode = createElement$1(contextVm, a, b, c, d, needNormalization);
            if (vnode && !isArray(vnode)) {
                vnode.fnScopeId = options._scopeId;
                vnode.fnContext = parent;
            }
            return vnode;
        };
    }
    else {
        this._c = function (a, b, c, d) {
            return createElement$1(contextVm, a, b, c, d, needNormalization);
        };
    }
}
installRenderHelpers(FunctionalRenderContext.prototype);
function createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if (isDef(propOptions)) {
        for (var key in propOptions) {
            props[key] = validateProp(key, propOptions, propsData || emptyObject);
        }
    }
    else {
        if (isDef(data.attrs))
            mergeProps(props, data.attrs);
        if (isDef(data.props))
            mergeProps(props, data.props);
    }
    var renderContext = new FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof VNode) {
        return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    }
    else if (isArray(vnode)) {
        var vnodes = normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for (var i = 0; i < vnodes.length; i++) {
            res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        }
        return res;
    }
}
function cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    if (false) {
        (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext =
            renderContext;
    }
    if (data.slot) {
        (clone.data || (clone.data = {})).slot = data.slot;
    }
    return clone;
}
function mergeProps(to, from) {
    for (var key in from) {
        to[camelize(key)] = from[key];
    }
}

function getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
    init: function (vnode, hydrating) {
        if (vnode.componentInstance &&
            !vnode.componentInstance._isDestroyed &&
            vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            componentVNodeHooks.prepatch(mountedNode, mountedNode);
        }
        else {
            var child = (vnode.componentInstance = createComponentInstanceForVnode(vnode, activeInstance));
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch: function (oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = (vnode.componentInstance = oldVnode.componentInstance);
        updateChildComponent(child, options.propsData, // updated props
        options.listeners, // updated listeners
        vnode, // new parent vnode
        options.children // new children
        );
    },
    insert: function (vnode) {
        var context = vnode.context, componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            callHook$1(componentInstance, 'mounted');
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) {
                // vue-router#1212
                // During updates, a kept-alive component's child components may
                // change, so directly walking the tree here may call activated hooks
                // on incorrect children. Instead we push them into a queue which will
                // be processed after the whole patch process ended.
                queueActivatedComponent(componentInstance);
            }
            else {
                activateChildComponent(componentInstance, true /* direct */);
            }
        }
    },
    destroy: function (vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) {
                componentInstance.$destroy();
            }
            else {
                deactivateChildComponent(componentInstance, true /* direct */);
            }
        }
    }
};
var hooksToMerge = Object.keys(componentVNodeHooks);
function createComponent(Ctor, data, context, children, tag) {
    if (isUndef(Ctor)) {
        return;
    }
    var baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if (isObject(Ctor)) {
        Ctor = baseCtor.extend(Ctor);
    }
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== 'function') {
        if (false) {
            warn$2("Invalid Component definition: ".concat(String(Ctor)), context);
        }
        return;
    }
    // async component
    var asyncFactory;
    // @ts-expect-error
    if (isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) {
            // return a placeholder node for async component, which is rendered
            // as a comment node but preserves all the raw information for the node.
            // the information will be used for async server-rendering and hydration.
            return createAsyncPlaceholder(asyncFactory, data, context, children, tag);
        }
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if (isDef(data.model)) {
        // @ts-expect-error
        transformModel(Ctor.options, data);
    }
    // extract props
    // @ts-expect-error
    var propsData = extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if (isTrue(Ctor.options.functional)) {
        return createFunctionalComponent(Ctor, propsData, data, context, children);
    }
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if (isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) {
            data.slot = slot;
        }
    }
    // install component management hooks onto the placeholder node
    installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    var name = getComponentName(Ctor.options) || tag;
    var vnode = new VNode(
    // @ts-expect-error
    "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ''), data, undefined, undefined, undefined, context, 
    // @ts-expect-error
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children }, asyncFactory);
    return vnode;
}
function createComponentInstanceForVnode(
// we know it's MountedComponentVNode but flow doesn't
vnode, 
// activeInstance in lifecycle state
parent) {
    var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if (isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});
    for (var i = 0; i < hooksToMerge.length; i++) {
        var key = hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) {
            hooks[key] = existing ? mergeHook(toMerge, existing) : toMerge;
        }
    }
}
function mergeHook(f1, f2) {
    var merged = function (a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel(options, data) {
    var prop = (options.model && options.model.prop) || 'value';
    var event = (options.model && options.model.event) || 'input';
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if (isDef(existing)) {
        if (isArray(existing)
            ? existing.indexOf(callback) === -1
            : existing !== callback) {
            on[event] = [callback].concat(existing);
        }
    }
    else {
        on[event] = callback;
    }
}

var warn$2 = noop;
var tip = noop;
var generateComponentTrace; // work around flow check
var formatComponentName;
if (false) {
    var hasConsole_1 = typeof console !== 'undefined';
    var classifyRE_1 = /(?:^|[-_])(\w)/g;
    var classify_1 = function (str) {
        return str.replace(classifyRE_1, function (c) { return c.toUpperCase(); }).replace(/[-_]/g, '');
    };
    warn$2 = function (msg, vm) {
        if (vm === void 0) { vm = currentInstance; }
        var trace = vm ? generateComponentTrace(vm) : '';
        if (config.warnHandler) {
            config.warnHandler.call(null, msg, vm, trace);
        }
        else if (hasConsole_1 && !config.silent) {
            console.error("[Vue warn]: ".concat(msg).concat(trace));
        }
    };
    tip = function (msg, vm) {
        if (hasConsole_1 && !config.silent) {
            console.warn("[Vue tip]: ".concat(msg) + (vm ? generateComponentTrace(vm) : ''));
        }
    };
    formatComponentName = function (vm, includeFile) {
        if (vm.$root === vm) {
            return '<Root>';
        }
        var options = isFunction(vm) && vm.cid != null
            ? vm.options
            : vm._isVue
                ? vm.$options || vm.constructor.options
                : vm;
        var name = getComponentName(options);
        var file = options.__file;
        if (!name && file) {
            var match = file.match(/([^/\\]+)\.vue$/);
            name = match && match[1];
        }
        return ((name ? "<".concat(classify_1(name), ">") : "<Anonymous>") +
            (file && includeFile !== false ? " at ".concat(file) : ''));
    };
    var repeat_1 = function (str, n) {
        var res = '';
        while (n) {
            if (n % 2 === 1)
                res += str;
            if (n > 1)
                str += str;
            n >>= 1;
        }
        return res;
    };
    generateComponentTrace = function (vm) {
        if (vm._isVue && vm.$parent) {
            var tree = [];
            var currentRecursiveSequence = 0;
            while (vm) {
                if (tree.length > 0) {
                    var last = tree[tree.length - 1];
                    if (last.constructor === vm.constructor) {
                        currentRecursiveSequence++;
                        vm = vm.$parent;
                        continue;
                    }
                    else if (currentRecursiveSequence > 0) {
                        tree[tree.length - 1] = [last, currentRecursiveSequence];
                        currentRecursiveSequence = 0;
                    }
                }
                tree.push(vm);
                vm = vm.$parent;
            }
            return ('\n\nfound in\n\n' +
                tree
                    .map(function (vm, i) {
                    return "".concat(i === 0 ? '---> ' : repeat_1(' ', 5 + i * 2)).concat(isArray(vm)
                        ? "".concat(formatComponentName(vm[0]), "... (").concat(vm[1], " recursive calls)")
                        : formatComponentName(vm));
                })
                    .join('\n'));
        }
        else {
            return "\n\n(found in ".concat(formatComponentName(vm), ")");
        }
    };
}

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;
/**
 * Options with restrictions
 */
if (false) {
    strats.el = strats.propsData = function (parent, child, vm, key) {
        if (!vm) {
            warn$2("option \"".concat(key, "\" can only be used during instance ") +
                'creation with the `new` keyword.');
        }
        return defaultStrat(parent, child);
    };
}
/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(to, from, recursive) {
    if (recursive === void 0) { recursive = true; }
    if (!from)
        return to;
    var key, toVal, fromVal;
    var keys = hasSymbol
        ? Reflect.ownKeys(from)
        : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!recursive || !hasOwn(to, key)) {
            set(to, key, fromVal);
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            isPlainObject(fromVal)) {
            mergeData(toVal, fromVal);
        }
    }
    return to;
}
/**
 * Data
 */
function mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) {
            return parentVal;
        }
        if (!parentVal) {
            return childVal;
        }
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return mergeData(isFunction(childVal) ? childVal.call(this, this) : childVal, isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    }
    else {
        return function mergedInstanceDataFn() {
            // instance merge
            var instanceData = isFunction(childVal)
                ? childVal.call(vm, vm)
                : childVal;
            var defaultData = isFunction(parentVal)
                ? parentVal.call(vm, vm)
                : parentVal;
            if (instanceData) {
                return mergeData(instanceData, defaultData);
            }
            else {
                return defaultData;
            }
        };
    }
}
strats.data = function (parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== 'function') {
            "production" !== 'production' &&
                warn$2('The "data" option should be a function ' +
                    'that returns a per-instance value in component ' +
                    'definitions.', vm);
            return parentVal;
        }
        return mergeDataOrFn(parentVal, childVal);
    }
    return mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */
function mergeLifecycleHook(parentVal, childVal) {
    var res = childVal
        ? parentVal
            ? parentVal.concat(childVal)
            : isArray(childVal)
                ? childVal
                : [childVal]
        : parentVal;
    return res ? dedupeHooks(res) : res;
}
function dedupeHooks(hooks) {
    var res = [];
    for (var i = 0; i < hooks.length; i++) {
        if (res.indexOf(hooks[i]) === -1) {
            res.push(hooks[i]);
        }
    }
    return res;
}
LIFECYCLE_HOOKS.forEach(function (hook) {
    strats[hook] = mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);
    if (childVal) {
        "production" !== 'production' && assertObjectType(key, childVal, vm);
        return extend(res, childVal);
    }
    else {
        return res;
    }
}
ASSET_TYPES.forEach(function (type) {
    strats[type + 's'] = mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === nativeWatch)
        parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === nativeWatch)
        childVal = undefined;
    /* istanbul ignore if */
    if (!childVal)
        return Object.create(parentVal || null);
    if (false) {
        assertObjectType(key, childVal, vm);
    }
    if (!parentVal)
        return childVal;
    var ret = {};
    extend(ret, parentVal);
    for (var key_1 in childVal) {
        var parent_1 = ret[key_1];
        var child = childVal[key_1];
        if (parent_1 && !isArray(parent_1)) {
            parent_1 = [parent_1];
        }
        ret[key_1] = parent_1 ? parent_1.concat(child) : isArray(child) ? child : [child];
    }
    return ret;
};
/**
 * Other object hashes.
 */
strats.props =
    strats.methods =
        strats.inject =
            strats.computed =
                function (parentVal, childVal, vm, key) {
                    if (childVal && "production" !== 'production') {
                        assertObjectType(key, childVal, vm);
                    }
                    if (!parentVal)
                        return childVal;
                    var ret = Object.create(null);
                    extend(ret, parentVal);
                    if (childVal)
                        extend(ret, childVal);
                    return ret;
                };
strats.provide = function (parentVal, childVal) {
    if (!parentVal)
        return childVal;
    return function () {
        var ret = Object.create(null);
        mergeData(ret, isFunction(parentVal) ? parentVal.call(this) : parentVal);
        if (childVal) {
            mergeData(ret, isFunction(childVal) ? childVal.call(this) : childVal, false // non-recursive
            );
        }
        return ret;
    };
};
/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */
function checkComponents(options) {
    for (var key in options.components) {
        validateComponentName(key);
    }
}
function validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat(unicodeRegExp.source, "]*$")).test(name)) {
        warn$2('Invalid component name: "' +
            name +
            '". Component names ' +
            'should conform to valid custom element name in html5 specification.');
    }
    if (isBuiltInTag(name) || config.isReservedTag(name)) {
        warn$2('Do not use built-in or reserved HTML elements as component ' +
            'id: ' +
            name);
    }
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps(options, vm) {
    var props = options.props;
    if (!props)
        return;
    var res = {};
    var i, val, name;
    if (isArray(props)) {
        i = props.length;
        while (i--) {
            val = props[i];
            if (typeof val === 'string') {
                name = camelize(val);
                res[name] = { type: null };
            }
            else if (false) {
                warn$2('props must be strings when using array syntax.');
            }
        }
    }
    else if (isPlainObject(props)) {
        for (var key in props) {
            val = props[key];
            name = camelize(key);
            res[name] = isPlainObject(val) ? val : { type: val };
        }
    }
    else if (false) {
        warn$2("Invalid value for option \"props\": expected an Array or an Object, " +
            "but got ".concat(toRawType(props), "."), vm);
    }
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */
function normalizeInject(options, vm) {
    var inject = options.inject;
    if (!inject)
        return;
    var normalized = (options.inject = {});
    if (isArray(inject)) {
        for (var i = 0; i < inject.length; i++) {
            normalized[inject[i]] = { from: inject[i] };
        }
    }
    else if (isPlainObject(inject)) {
        for (var key in inject) {
            var val = inject[key];
            normalized[key] = isPlainObject(val)
                ? extend({ from: key }, val)
                : { from: val };
        }
    }
    else if (false) {
        warn$2("Invalid value for option \"inject\": expected an Array or an Object, " +
            "but got ".concat(toRawType(inject), "."), vm);
    }
}
/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives$1(options) {
    var dirs = options.directives;
    if (dirs) {
        for (var key in dirs) {
            var def = dirs[key];
            if (isFunction(def)) {
                dirs[key] = { bind: def, update: def };
            }
        }
    }
}
function assertObjectType(name, value, vm) {
    if (!isPlainObject(value)) {
        warn$2("Invalid value for option \"".concat(name, "\": expected an Object, ") +
            "but got ".concat(toRawType(value), "."), vm);
    }
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions(parent, child, vm) {
    if (false) {
        checkComponents(child);
    }
    if (isFunction(child)) {
        // @ts-expect-error
        child = child.options;
    }
    normalizeProps(child, vm);
    normalizeInject(child, vm);
    normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) {
            parent = mergeOptions(parent, child.extends, vm);
        }
        if (child.mixins) {
            for (var i = 0, l = child.mixins.length; i < l; i++) {
                parent = mergeOptions(parent, child.mixins[i], vm);
            }
        }
    }
    var options = {};
    var key;
    for (key in parent) {
        mergeField(key);
    }
    for (key in child) {
        if (!hasOwn(parent, key)) {
            mergeField(key);
        }
    }
    function mergeField(key) {
        var strat = strats[key] || defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */
    if (typeof id !== 'string') {
        return;
    }
    var assets = options[type];
    // check local registration variations first
    if (hasOwn(assets, id))
        return assets[id];
    var camelizedId = camelize(id);
    if (hasOwn(assets, camelizedId))
        return assets[camelizedId];
    var PascalCaseId = capitalize(camelizedId);
    if (hasOwn(assets, PascalCaseId))
        return assets[PascalCaseId];
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    if (false) {
        warn$2('Failed to resolve ' + type.slice(0, -1) + ': ' + id);
    }
    return res;
}

function validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !hasOwn(prop, 'default')) {
            value = false;
        }
        else if (value === '' || value === hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) {
                value = true;
            }
        }
    }
    // check default value
    if (value === undefined) {
        value = getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = shouldObserve;
        toggleObserving(true);
        observe(value);
        toggleObserving(prevShouldObserve);
    }
    if (false) {
        assertProp(prop, key, value, vm, absent);
    }
    return value;
}
/**
 * Get the default value of a prop.
 */
function getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!hasOwn(prop, 'default')) {
        return undefined;
    }
    var def = prop.default;
    // warn against non-factory defaults for Object & Array
    if (false) {
        warn$2('Invalid default value for prop "' +
            key +
            '": ' +
            'Props with type Object/Array must use a factory function ' +
            'to return the default value.', vm);
    }
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm &&
        vm.$options.propsData &&
        vm.$options.propsData[key] === undefined &&
        vm._props[key] !== undefined) {
        return vm._props[key];
    }
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return isFunction(def) && getType(prop.type) !== 'Function'
        ? def.call(vm)
        : def;
}
/**
 * Assert whether a prop is valid.
 */
function assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        warn$2('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) {
        return;
    }
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!isArray(type)) {
            type = [type];
        }
        for (var i = 0; i < type.length && !valid; i++) {
            var assertedType = assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || '');
            valid = assertedType.valid;
        }
    }
    var haveExpectedTypes = expectedTypes.some(function (t) { return t; });
    if (!valid && haveExpectedTypes) {
        warn$2(getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    var validator = prop.validator;
    if (validator) {
        if (!validator(value)) {
            warn$2('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
        }
    }
}
var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function assertType(value, type, vm) {
    var valid;
    var expectedType = getType(type);
    if (simpleCheckRE.test(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === 'object') {
            valid = value instanceof type;
        }
    }
    else if (expectedType === 'Object') {
        valid = isPlainObject(value);
    }
    else if (expectedType === 'Array') {
        valid = isArray(value);
    }
    else {
        try {
            valid = value instanceof type;
        }
        catch (e) {
            warn$2('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
            valid = false;
        }
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
var functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType(fn) {
    var match = fn && fn.toString().match(functionTypeCheckRE);
    return match ? match[1] : '';
}
function isSameType(a, b) {
    return getType(a) === getType(b);
}
function getTypeIndex(type, expectedTypes) {
    if (!isArray(expectedTypes)) {
        return isSameType(expectedTypes, type) ? 0 : -1;
    }
    for (var i = 0, len = expectedTypes.length; i < len; i++) {
        if (isSameType(expectedTypes[i], type)) {
            return i;
        }
    }
    return -1;
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    var message = "Invalid prop: type check failed for prop \"".concat(name, "\".") +
        " Expected ".concat(expectedTypes.map(capitalize).join(', '));
    var expectedType = expectedTypes[0];
    var receivedType = toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 &&
        isExplicable(expectedType) &&
        isExplicable(typeof value) &&
        !isBoolean(expectedType, receivedType)) {
        message += " with value ".concat(styleValue(value, expectedType));
    }
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if (isExplicable(receivedType)) {
        message += "with value ".concat(styleValue(value, receivedType), ".");
    }
    return message;
}
function styleValue(value, type) {
    if (type === 'String') {
        return "\"".concat(value, "\"");
    }
    else if (type === 'Number') {
        return "".concat(Number(value));
    }
    else {
        return "".concat(value);
    }
}
var EXPLICABLE_TYPES = ['string', 'number', 'boolean'];
function isExplicable(value) {
    return EXPLICABLE_TYPES.some(function (elem) { return value.toLowerCase() === elem; });
}
function isBoolean() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; });
}

function Vue(options) {
    if (false) {
        warn$2('Vue is a constructor and should be called with the `new` keyword');
    }
    this._init(options);
}
//@ts-expect-error Vue has function type
initMixin$1(Vue);
//@ts-expect-error Vue has function type
stateMixin(Vue);
//@ts-expect-error Vue has function type
eventsMixin(Vue);
//@ts-expect-error Vue has function type
lifecycleMixin(Vue);
//@ts-expect-error Vue has function type
renderMixin(Vue);

function initUse(Vue) {
    Vue.use = function (plugin) {
        var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) {
            return this;
        }
        // additional parameters
        var args = toArray(arguments, 1);
        args.unshift(this);
        if (isFunction(plugin.install)) {
            plugin.install.apply(plugin, args);
        }
        else if (isFunction(plugin)) {
            plugin.apply(null, args);
        }
        installedPlugins.push(plugin);
        return this;
    };
}

function initMixin(Vue) {
    Vue.mixin = function (mixin) {
        this.options = mergeOptions(this.options, mixin);
        return this;
    };
}

function initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */
    Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */
    Vue.extend = function (extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) {
            return cachedCtors[SuperId];
        }
        var name = getComponentName(extendOptions) || getComponentName(Super.options);
        if (false) {
            validateComponentName(name);
        }
        var Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = mergeOptions(Super.options, extendOptions);
        Sub['super'] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) {
            initProps(Sub);
        }
        if (Sub.options.computed) {
            initComputed(Sub);
        }
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        ASSET_TYPES.forEach(function (type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) {
            Sub.options.components[name] = Sub;
        }
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function initProps(Comp) {
    var props = Comp.options.props;
    for (var key in props) {
        proxy(Comp.prototype, "_props", key);
    }
}
function initComputed(Comp) {
    var computed = Comp.options.computed;
    for (var key in computed) {
        defineComputed(Comp.prototype, key, computed[key]);
    }
}

function initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */
    ASSET_TYPES.forEach(function (type) {
        // @ts-expect-error function is not exact same type
        Vue[type] = function (id, definition) {
            if (!definition) {
                return this.options[type + 's'][id];
            }
            else {
                /* istanbul ignore if */
                if (false) {
                    validateComponentName(id);
                }
                if (type === 'component' && isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === 'directive' && isFunction(definition)) {
                    definition = { bind: definition, update: definition };
                }
                this.options[type + 's'][id] = definition;
                return definition;
            }
        };
    });
}

function _getComponentName(opts) {
    return opts && (getComponentName(opts.Ctor.options) || opts.tag);
}
function matches(pattern, name) {
    if (isArray(pattern)) {
        return pattern.indexOf(name) > -1;
    }
    else if (typeof pattern === 'string') {
        return pattern.split(',').indexOf(name) > -1;
    }
    else if (isRegExp(pattern)) {
        return pattern.test(name);
    }
    /* istanbul ignore next */
    return false;
}
function pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache, keys = keepAliveInstance.keys, _vnode = keepAliveInstance._vnode;
    for (var key in cache) {
        var entry = cache[key];
        if (entry) {
            var name_1 = entry.name;
            if (name_1 && !filter(name_1)) {
                pruneCacheEntry(cache, key, keys, _vnode);
            }
        }
    }
}
function pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) {
        // @ts-expect-error can be undefined
        entry.componentInstance.$destroy();
    }
    cache[key] = null;
    remove$2(keys, key);
}
var patternTypes = [String, RegExp, Array];
// TODO defineComponent
var KeepAlive = {
    name: 'keep-alive',
    abstract: true,
    props: {
        include: patternTypes,
        exclude: patternTypes,
        max: [String, Number]
    },
    methods: {
        cacheVNode: function () {
            var _a = this, cache = _a.cache, keys = _a.keys, vnodeToCache = _a.vnodeToCache, keyToCache = _a.keyToCache;
            if (vnodeToCache) {
                var tag = vnodeToCache.tag, componentInstance = vnodeToCache.componentInstance, componentOptions = vnodeToCache.componentOptions;
                cache[keyToCache] = {
                    name: _getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) {
                    pruneCacheEntry(cache, keys[0], keys, this._vnode);
                }
                this.vnodeToCache = null;
            }
        }
    },
    created: function () {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed: function () {
        for (var key in this.cache) {
            pruneCacheEntry(this.cache, key, this.keys);
        }
    },
    mounted: function () {
        var _this = this;
        this.cacheVNode();
        this.$watch('include', function (val) {
            pruneCache(_this, function (name) { return matches(val, name); });
        });
        this.$watch('exclude', function (val) {
            pruneCache(_this, function (name) { return !matches(val, name); });
        });
    },
    updated: function () {
        this.cacheVNode();
    },
    render: function () {
        var slot = this.$slots.default;
        var vnode = getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            var name_2 = _getComponentName(componentOptions);
            var _a = this, include = _a.include, exclude = _a.exclude;
            if (
            // not included
            (include && (!name_2 || !matches(include, name_2))) ||
                // excluded
                (exclude && name_2 && matches(exclude, name_2))) {
                return vnode;
            }
            var _b = this, cache = _b.cache, keys = _b.keys;
            var key = vnode.key == null
                ? // same constructor may get registered as different local components
                    // so cid alone is not enough (#3269)
                    componentOptions.Ctor.cid +
                        (componentOptions.tag ? "::".concat(componentOptions.tag) : '')
                : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                remove$2(keys, key);
                keys.push(key);
            }
            else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || (slot && slot[0]);
    }
};

var builtInComponents = {
    KeepAlive: KeepAlive
};

function initGlobalAPI(Vue) {
    // config
    var configDef = {};
    configDef.get = function () { return config; };
    if (false) {
        configDef.set = function () {
            warn$2('Do not replace the Vue.config object, set individual fields instead.');
        };
    }
    Object.defineProperty(Vue, 'config', configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: warn$2,
        extend: extend,
        mergeOptions: mergeOptions,
        defineReactive: defineReactive
    };
    Vue.set = set;
    Vue.delete = del;
    Vue.nextTick = nextTick;
    // 2.6 explicit observable API
    Vue.observable = function (obj) {
        observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    ASSET_TYPES.forEach(function (type) {
        Vue.options[type + 's'] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    extend(Vue.options.components, builtInComponents);
    initUse(Vue);
    initMixin(Vue);
    initExtend(Vue);
    initAssetRegisters(Vue);
}

initGlobalAPI(Vue);
Object.defineProperty(Vue.prototype, '$isServer', {
    get: isServerRendering
});
Object.defineProperty(Vue.prototype, '$ssrContext', {
    get: function () {
        /* istanbul ignore next */
        return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
    value: FunctionalRenderContext
});
Vue.version = version;

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');
// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
    return ((attr === 'value' && acceptValue(tag) && type !== 'button') ||
        (attr === 'selected' && tag === 'option') ||
        (attr === 'checked' && tag === 'input') ||
        (attr === 'muted' && tag === 'video'));
};
var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');
var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');
var convertEnumeratedValue = function (key, value) {
    return isFalsyAttrValue(value) || value === 'false'
        ? 'false'
        : // allow arbitrary string value for contenteditable
            key === 'contenteditable' && isValidContentEditableValue(value)
                ? value
                : 'true';
};
var isBooleanAttr = makeMap('allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
    'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
    'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
    'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
    'required,reversed,scoped,seamless,selected,sortable,' +
    'truespeed,typemustmatch,visible');
var xlinkNS = 'http://www.w3.org/1999/xlink';
var isXlink = function (name) {
    return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink';
};
var getXlinkProp = function (name) {
    return isXlink(name) ? name.slice(6, name.length) : '';
};
var isFalsyAttrValue = function (val) {
    return val == null || val === false;
};

function genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while (isDef(childNode.componentInstance)) {
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) {
            data = mergeClassData(childNode.data, data);
        }
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while (isDef((parentNode = parentNode.parent))) {
        if (parentNode && parentNode.data) {
            data = mergeClassData(data, parentNode.data);
        }
    }
    return renderClass(data.staticClass, data.class);
}
function mergeClassData(child, parent) {
    return {
        staticClass: concat(child.staticClass, parent.staticClass),
        class: isDef(child.class) ? [child.class, parent.class] : parent.class
    };
}
function renderClass(staticClass, dynamicClass) {
    if (isDef(staticClass) || isDef(dynamicClass)) {
        return concat(staticClass, stringifyClass(dynamicClass));
    }
    /* istanbul ignore next */
    return '';
}
function concat(a, b) {
    return a ? (b ? a + ' ' + b : a) : b || '';
}
function stringifyClass(value) {
    if (Array.isArray(value)) {
        return stringifyArray(value);
    }
    if (isObject(value)) {
        return stringifyObject(value);
    }
    if (typeof value === 'string') {
        return value;
    }
    /* istanbul ignore next */
    return '';
}
function stringifyArray(value) {
    var res = '';
    var stringified;
    for (var i = 0, l = value.length; i < l; i++) {
        if (isDef((stringified = stringifyClass(value[i]))) && stringified !== '') {
            if (res)
                res += ' ';
            res += stringified;
        }
    }
    return res;
}
function stringifyObject(value) {
    var res = '';
    for (var key in value) {
        if (value[key]) {
            if (res)
                res += ' ';
            res += key;
        }
    }
    return res;
}

var namespaceMap = {
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
var isHTMLTag = makeMap('html,body,base,head,link,meta,style,title,' +
    'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
    'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
    'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
    's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
    'embed,object,param,source,canvas,script,noscript,del,ins,' +
    'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
    'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
    'output,progress,select,textarea,' +
    'details,dialog,menu,menuitem,summary,' +
    'content,element,shadow,template,blockquote,iframe,tfoot');
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap('svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
    'foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
    'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view', true);
var isPreTag = function (tag) { return tag === 'pre'; };
var isReservedTag = function (tag) {
    return isHTMLTag(tag) || isSVG(tag);
};
function getTagNamespace(tag) {
    if (isSVG(tag)) {
        return 'svg';
    }
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === 'math') {
        return 'math';
    }
}
var unknownElementCache = Object.create(null);
function isUnknownElement(tag) {
    /* istanbul ignore if */
    if (!inBrowser) {
        return true;
    }
    if (isReservedTag(tag)) {
        return false;
    }
    tag = tag.toLowerCase();
    /* istanbul ignore if */
    if (unknownElementCache[tag] != null) {
        return unknownElementCache[tag];
    }
    var el = document.createElement(tag);
    if (tag.indexOf('-') > -1) {
        // http://stackoverflow.com/a/28210364/1070244
        return (unknownElementCache[tag] =
            el.constructor === window.HTMLUnknownElement ||
                el.constructor === window.HTMLElement);
    }
    else {
        return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()));
    }
}
var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/**
 * Query an element selector if it's not an element already.
 */
function query(el) {
    if (typeof el === 'string') {
        var selected = document.querySelector(el);
        if (!selected) {
            "production" !== 'production' && warn$2('Cannot find element: ' + el);
            return document.createElement('div');
        }
        return selected;
    }
    else {
        return el;
    }
}

function createElement(tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== 'select') {
        return elm;
    }
    // false or null will remove the attribute but undefined will not
    if (vnode.data &&
        vnode.data.attrs &&
        vnode.data.attrs.multiple !== undefined) {
        elm.setAttribute('multiple', 'multiple');
    }
    return elm;
}
function createElementNS(namespace, tagName) {
    return document.createElementNS(namespaceMap[namespace], tagName);
}
function createTextNode(text) {
    return document.createTextNode(text);
}
function createComment(text) {
    return document.createComment(text);
}
function insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function removeChild(node, child) {
    node.removeChild(child);
}
function appendChild(node, child) {
    node.appendChild(child);
}
function parentNode(node) {
    return node.parentNode;
}
function nextSibling(node) {
    return node.nextSibling;
}
function tagName(node) {
    return node.tagName;
}
function setTextContent(node, text) {
    node.textContent = text;
}
function setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createElement: createElement,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

var ref = {
    create: function (_, vnode) {
        registerRef(vnode);
    },
    update: function (oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            registerRef(oldVnode, true);
            registerRef(vnode);
        }
    },
    destroy: function (vnode) {
        registerRef(vnode, true);
    }
};
function registerRef(vnode, isRemoval) {
    var ref = vnode.data.ref;
    if (!isDef(ref))
        return;
    var vm = vnode.context;
    var refValue = vnode.componentInstance || vnode.elm;
    var value = isRemoval ? null : refValue;
    var $refsValue = isRemoval ? undefined : refValue;
    if (isFunction(ref)) {
        invokeWithErrorHandling(ref, vm, [value], vm, "template ref function");
        return;
    }
    var isFor = vnode.data.refInFor;
    var _isString = typeof ref === 'string' || typeof ref === 'number';
    var _isRef = isRef(ref);
    var refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            var existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) {
                isArray(existing) && remove$2(existing, refValue);
            }
            else {
                if (!isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [refValue];
                        setSetupRef(vm, ref, refs[ref]);
                    }
                    else {
                        ref.value = [refValue];
                    }
                }
                else if (!existing.includes(refValue)) {
                    existing.push(refValue);
                }
            }
        }
        else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) {
                return;
            }
            refs[ref] = $refsValue;
            setSetupRef(vm, ref, value);
        }
        else if (_isRef) {
            if (isRemoval && ref.value !== refValue) {
                return;
            }
            ref.value = value;
        }
        else if (false) {
            warn$2("Invalid template ref type: ".concat(typeof ref));
        }
    }
}
function setSetupRef(_a, key, val) {
    var _setupState = _a._setupState;
    if (_setupState && hasOwn(_setupState, key)) {
        if (isRef(_setupState[key])) {
            _setupState[key].value = val;
        }
        else {
            _setupState[key] = val;
        }
    }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */
var emptyNode = new VNode('', {}, []);
var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];
function sameVnode(a, b) {
    return (a.key === b.key &&
        a.asyncFactory === b.asyncFactory &&
        ((a.tag === b.tag &&
            a.isComment === b.isComment &&
            isDef(a.data) === isDef(b.data) &&
            sameInputType(a, b)) ||
            (isTrue(a.isAsyncPlaceholder) && isUndef(b.asyncFactory.error))));
}
function sameInputType(a, b) {
    if (a.tag !== 'input')
        return true;
    var i;
    var typeA = isDef((i = a.data)) && isDef((i = i.attrs)) && i.type;
    var typeB = isDef((i = b.data)) && isDef((i = i.attrs)) && i.type;
    return typeA === typeB || (isTextInputType(typeA) && isTextInputType(typeB));
}
function createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for (i = beginIdx; i <= endIdx; ++i) {
        key = children[i].key;
        if (isDef(key))
            map[key] = i;
    }
    return map;
}
function createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules, nodeOps = backend.nodeOps;
    for (i = 0; i < hooks.length; ++i) {
        cbs[hooks[i]] = [];
        for (j = 0; j < modules.length; ++j) {
            if (isDef(modules[j][hooks[i]])) {
                cbs[hooks[i]].push(modules[j][hooks[i]]);
            }
        }
    }
    function emptyNodeAt(elm) {
        return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) {
                removeNode(childElm);
            }
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if (isDef(parent)) {
            nodeOps.removeChild(parent, el);
        }
    }
    function isUnknownElement(vnode, inVPre) {
        return (!inVPre &&
            !vnode.ns &&
            !(config.ignoredElements.length &&
                config.ignoredElements.some(function (ignore) {
                    return isRegExp(ignore)
                        ? ignore.test(vnode.tag)
                        : ignore === vnode.tag;
                })) &&
            config.isUnknownElement(vnode.tag));
    }
    var creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // This vnode was used in a previous render!
            // now it's used as a new node, overwriting its elm would cause
            // potential patch errors down the road when it's used as an insertion
            // reference node. Instead, we clone the node on-demand before creating
            // associated DOM element for it.
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
            return;
        }
        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if (isDef(tag)) {
            if (false) {
                if (data && data.pre) {
                    creatingElmInVPre++;
                }
                if (isUnknownElement(vnode, creatingElmInVPre)) {
                    warn$2('Unknown custom element: <' +
                        tag +
                        '> - did you ' +
                        'register the component correctly? For recursive components, ' +
                        'make sure to provide the "name" option.', vnode.context);
                }
            }
            vnode.elm = vnode.ns
                ? nodeOps.createElementNS(vnode.ns, tag)
                : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if (isDef(data)) {
                invokeCreateHooks(vnode, insertedVnodeQueue);
            }
            insert(parentElm, vnode.elm, refElm);
            if (false) {
                creatingElmInVPre--;
            }
        }
        else if (isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
        else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if (isDef(i)) {
            var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
            if (isDef((i = i.hook)) && isDef((i = i.init))) {
                i(vnode, false /* hydrating */);
            }
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if (isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if (isTrue(isReactivated)) {
                    reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                }
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if (isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        }
        else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while (innerNode.componentInstance) {
            innerNode = innerNode.componentInstance._vnode;
            if (isDef((i = innerNode.data)) && isDef((i = i.transition))) {
                for (i = 0; i < cbs.activate.length; ++i) {
                    cbs.activate[i](emptyNode, innerNode);
                }
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if (isDef(parent)) {
            if (isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) {
                    nodeOps.insertBefore(parent, elm, ref);
                }
            }
            else {
                nodeOps.appendChild(parent, elm);
            }
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if (isArray(children)) {
            if (false) {
                checkDuplicateKeys(children);
            }
            for (var i_1 = 0; i_1 < children.length; ++i_1) {
                createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
            }
        }
        else if (isPrimitive(vnode.text)) {
            nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
        }
    }
    function isPatchable(vnode) {
        while (vnode.componentInstance) {
            vnode = vnode.componentInstance._vnode;
        }
        return isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for (var i_2 = 0; i_2 < cbs.create.length; ++i_2) {
            cbs.create[i_2](emptyNode, vnode);
        }
        i = vnode.data.hook; // Reuse variable
        if (isDef(i)) {
            if (isDef(i.create))
                i.create(emptyNode, vnode);
            if (isDef(i.insert))
                insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        var i;
        if (isDef((i = vnode.fnScopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
        else {
            var ancestor = vnode;
            while (ancestor) {
                if (isDef((i = ancestor.context)) && isDef((i = i.$options._scopeId))) {
                    nodeOps.setStyleScope(vnode.elm, i);
                }
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if (isDef((i = activeInstance)) &&
            i !== vnode.context &&
            i !== vnode.fnContext &&
            isDef((i = i.$options._scopeId))) {
            nodeOps.setStyleScope(vnode.elm, i);
        }
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for (; startIdx <= endIdx; ++startIdx) {
            createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
        }
    }
    function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.destroy)))
                i(vnode);
            for (i = 0; i < cbs.destroy.length; ++i)
                cbs.destroy[i](vnode);
        }
        if (isDef((i = vnode.children))) {
            for (j = 0; j < vnode.children.length; ++j) {
                invokeDestroyHook(vnode.children[j]);
            }
        }
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for (; startIdx <= endIdx; ++startIdx) {
            var ch = vnodes[startIdx];
            if (isDef(ch)) {
                if (isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                }
                else {
                    // Text node
                    removeNode(ch.elm);
                }
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if (isDef(rm) || isDef(vnode.data)) {
            var i_3;
            var listeners = cbs.remove.length + 1;
            if (isDef(rm)) {
                // we have a recursively passed down rm callback
                // increase the listeners count
                rm.listeners += listeners;
            }
            else {
                // directly removing
                rm = createRmCb(vnode.elm, listeners);
            }
            // recursively invoke hooks on child component root node
            if (isDef((i_3 = vnode.componentInstance)) &&
                isDef((i_3 = i_3._vnode)) &&
                isDef(i_3.data)) {
                removeAndInvokeRemoveHook(i_3, rm);
            }
            for (i_3 = 0; i_3 < cbs.remove.length; ++i_3) {
                cbs.remove[i_3](vnode, rm);
            }
            if (isDef((i_3 = vnode.data.hook)) && isDef((i_3 = i_3.remove))) {
                i_3(vnode, rm);
            }
            else {
                rm();
            }
        }
        else {
            removeNode(vnode.elm);
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;
        if (false) {
            checkDuplicateKeys(newCh);
        }
        while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
            if (isUndef(oldStartVnode)) {
                oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            }
            else if (isUndef(oldEndVnode)) {
                oldEndVnode = oldCh[--oldEndIdx];
            }
            else if (sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else if (sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            }
            else if (sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove &&
                    nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            }
            else {
                if (isUndef(oldKeyToIdx))
                    oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = isDef(newStartVnode.key)
                    ? oldKeyToIdx[newStartVnode.key]
                    : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if (isUndef(idxInOld)) {
                    // New element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                }
                else {
                    vnodeToMove = oldCh[idxInOld];
                    if (sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove &&
                            nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    }
                    else {
                        // same key but different element. treat as new element
                        createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                    }
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        }
        else if (newStartIdx > newEndIdx) {
            removeVnodes(oldCh, oldStartIdx, oldEndIdx);
        }
    }
    function checkDuplicateKeys(children) {
        var seenKeys = {};
        for (var i_4 = 0; i_4 < children.length; i_4++) {
            var vnode = children[i_4];
            var key = vnode.key;
            if (isDef(key)) {
                if (seenKeys[key]) {
                    warn$2("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                }
                else {
                    seenKeys[key] = true;
                }
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for (var i_5 = start; i_5 < end; i_5++) {
            var c = oldCh[i_5];
            if (isDef(c) && sameVnode(node, c))
                return i_5;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) {
            return;
        }
        if (isDef(vnode.elm) && isDef(ownerArray)) {
            // clone reused vnode
            vnode = ownerArray[index] = cloneVNode(vnode);
        }
        var elm = (vnode.elm = oldVnode.elm);
        if (isTrue(oldVnode.isAsyncPlaceholder)) {
            if (isDef(vnode.asyncFactory.resolved)) {
                hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            }
            else {
                vnode.isAsyncPlaceholder = true;
            }
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if (isTrue(vnode.isStatic) &&
            isTrue(oldVnode.isStatic) &&
            vnode.key === oldVnode.key &&
            (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        var i;
        var data = vnode.data;
        if (isDef(data) && isDef((i = data.hook)) && isDef((i = i.prepatch))) {
            i(oldVnode, vnode);
        }
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if (isDef(data) && isPatchable(vnode)) {
            for (i = 0; i < cbs.update.length; ++i)
                cbs.update[i](oldVnode, vnode);
            if (isDef((i = data.hook)) && isDef((i = i.update)))
                i(oldVnode, vnode);
        }
        if (isUndef(vnode.text)) {
            if (isDef(oldCh) && isDef(ch)) {
                if (oldCh !== ch)
                    updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            }
            else if (isDef(ch)) {
                if (false) {
                    checkDuplicateKeys(ch);
                }
                if (isDef(oldVnode.text))
                    nodeOps.setTextContent(elm, '');
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            }
            else if (isDef(oldCh)) {
                removeVnodes(oldCh, 0, oldCh.length - 1);
            }
            else if (isDef(oldVnode.text)) {
                nodeOps.setTextContent(elm, '');
            }
        }
        else if (oldVnode.text !== vnode.text) {
            nodeOps.setTextContent(elm, vnode.text);
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.postpatch)))
                i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if (isTrue(initial) && isDef(vnode.parent)) {
            vnode.parent.data.pendingInsert = queue;
        }
        else {
            for (var i_6 = 0; i_6 < queue.length; ++i_6) {
                queue[i_6].data.hook.insert(queue[i_6]);
            }
        }
    }
    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag, data = vnode.data, children = vnode.children;
        inVPre = inVPre || (data && data.pre);
        vnode.elm = elm;
        if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        // assert node match
        if (false) {
            if (!assertNodeMatch(elm, vnode, inVPre)) {
                return false;
            }
        }
        if (isDef(data)) {
            if (isDef((i = data.hook)) && isDef((i = i.init)))
                i(vnode, true /* hydrating */);
            if (isDef((i = vnode.componentInstance))) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if (isDef(tag)) {
            if (isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) {
                    createChildren(vnode, children, insertedVnodeQueue);
                }
                else {
                    // v-html and domProps: innerHTML
                    if (isDef((i = data)) &&
                        isDef((i = i.domProps)) &&
                        isDef((i = i.innerHTML))) {
                        if (i !== elm.innerHTML) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('server innerHTML: ', i);
                                console.warn('client innerHTML: ', elm.innerHTML);
                            }
                            return false;
                        }
                    }
                    else {
                        // iterate and compare children lists
                        var childrenMatch = true;
                        var childNode = elm.firstChild;
                        for (var i_7 = 0; i_7 < children.length; i_7++) {
                            if (!childNode ||
                                !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                                childrenMatch = false;
                                break;
                            }
                            childNode = childNode.nextSibling;
                        }
                        // if childNode is not null, it means the actual childNodes list is
                        // longer than the virtual children list.
                        if (!childrenMatch || childNode) {
                            /* istanbul ignore if */
                            if (false) {
                                hydrationBailed = true;
                                console.warn('Parent: ', elm);
                                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
                            }
                            return false;
                        }
                    }
                }
            }
            if (isDef(data)) {
                var fullInvoke = false;
                for (var key in data) {
                    if (!isRenderedModule(key)) {
                        fullInvoke = true;
                        invokeCreateHooks(vnode, insertedVnodeQueue);
                        break;
                    }
                }
                if (!fullInvoke && data['class']) {
                    // ensure collecting deps for deep class bindings for future updates
                    traverse(data['class']);
                }
            }
        }
        else if (elm.data !== vnode.text) {
            elm.data = vnode.text;
        }
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if (isDef(vnode.tag)) {
            return (vnode.tag.indexOf('vue-component') === 0 ||
                (!isUnknownElement(vnode, inVPre) &&
                    vnode.tag.toLowerCase() ===
                        (node.tagName && node.tagName.toLowerCase())));
        }
        else {
            return node.nodeType === (vnode.isComment ? 8 : 3);
        }
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if (isUndef(vnode)) {
            if (isDef(oldVnode))
                invokeDestroyHook(oldVnode);
            return;
        }
        var isInitialPatch = false;
        var insertedVnodeQueue = [];
        if (isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        }
        else {
            var isRealElement = isDef(oldVnode.nodeType);
            if (!isRealElement && sameVnode(oldVnode, vnode)) {
                // patch existing root node
                patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            }
            else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
                        oldVnode.removeAttribute(SSR_ATTR);
                        hydrating = true;
                    }
                    if (isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        }
                        else if (false) {
                            warn$2('The client-side rendered virtual DOM tree is not matching ' +
                                'server-rendered content. This is likely caused by incorrect ' +
                                'HTML markup, for example nesting block-level elements inside ' +
                                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                                'full client-side render.');
                        }
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                var oldElm = oldVnode.elm;
                var parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue, 
                // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if (isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while (ancestor) {
                        for (var i_8 = 0; i_8 < cbs.destroy.length; ++i_8) {
                            cbs.destroy[i_8](ancestor);
                        }
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for (var i_9 = 0; i_9 < cbs.create.length; ++i_9) {
                                cbs.create[i_9](emptyNode, ancestor);
                            }
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            var insert_1 = ancestor.data.hook.insert;
                            if (insert_1.merged) {
                                // start at index 1 to avoid re-invoking component mounted hook
                                for (var i_10 = 1; i_10 < insert_1.fns.length; i_10++) {
                                    insert_1.fns[i_10]();
                                }
                            }
                        }
                        else {
                            registerRef(ancestor);
                        }
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if (isDef(parentElm)) {
                    removeVnodes([oldVnode], 0, 0);
                }
                else if (isDef(oldVnode.tag)) {
                    invokeDestroyHook(oldVnode);
                }
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}

var directives$1 = {
    create: updateDirectives,
    update: updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        updateDirectives(vnode, emptyNode);
    }
};
function updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) {
        _update(oldVnode, vnode);
    }
}
function _update(oldVnode, vnode) {
    var isCreate = oldVnode === emptyNode;
    var isDestroy = vnode === emptyNode;
    var oldDirs = normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    var newDirs = normalizeDirectives(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;
    for (key in newDirs) {
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            callHook(dir, 'bind', vnode, oldVnode);
            if (dir.def && dir.def.inserted) {
                dirsWithInsert.push(dir);
            }
        }
        else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            callHook(dir, 'update', vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) {
                dirsWithPostpatch.push(dir);
            }
        }
    }
    if (dirsWithInsert.length) {
        var callInsert = function () {
            for (var i = 0; i < dirsWithInsert.length; i++) {
                callHook(dirsWithInsert[i], 'inserted', vnode, oldVnode);
            }
        };
        if (isCreate) {
            mergeVNodeHook(vnode, 'insert', callInsert);
        }
        else {
            callInsert();
        }
    }
    if (dirsWithPostpatch.length) {
        mergeVNodeHook(vnode, 'postpatch', function () {
            for (var i = 0; i < dirsWithPostpatch.length; i++) {
                callHook(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
            }
        });
    }
    if (!isCreate) {
        for (key in oldDirs) {
            if (!newDirs[key]) {
                // no longer present, unbind
                callHook(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
            }
        }
    }
}
var emptyModifiers = Object.create(null);
function normalizeDirectives(dirs, vm) {
    var res = Object.create(null);
    if (!dirs) {
        // $flow-disable-line
        return res;
    }
    var i, dir;
    for (i = 0; i < dirs.length; i++) {
        dir = dirs[i];
        if (!dir.modifiers) {
            // $flow-disable-line
            dir.modifiers = emptyModifiers;
        }
        res[getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            var setupDef = dir.def || resolveAsset(vm, '_setupState', 'v-' + dir.name);
            if (typeof setupDef === 'function') {
                dir.def = {
                    bind: setupDef,
                    update: setupDef,
                };
            }
            else {
                dir.def = setupDef;
            }
        }
        dir.def = dir.def || resolveAsset(vm.$options, 'directives', dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function getRawDirName(dir) {
    return (dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join('.')));
}
function callHook(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) {
        try {
            fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
        }
        catch (e) {
            handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
        }
    }
}

var baseModules = [ref, directives$1];

function updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
        return;
    }
    if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
        return;
    }
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(attrs.__ob__) || isTrue(attrs._v_attr_proxy)) {
        attrs = vnode.data.attrs = extend({}, attrs);
    }
    for (key in attrs) {
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) {
            setAttr(elm, key, cur, vnode.data.pre);
        }
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */
    if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
        setAttr(elm, 'value', attrs.value);
    }
    for (key in oldAttrs) {
        if (isUndef(attrs[key])) {
            if (isXlink(key)) {
                elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
            }
            else if (!isEnumeratedAttr(key)) {
                elm.removeAttribute(key);
            }
        }
    }
}
function setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf('-') > -1) {
        baseSetAttr(el, key, value);
    }
    else if (isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if (isFalsyAttrValue(value)) {
            el.removeAttribute(key);
        }
        else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === 'allowfullscreen' && el.tagName === 'EMBED' ? 'true' : key;
            el.setAttribute(key, value);
        }
    }
    else if (isEnumeratedAttr(key)) {
        el.setAttribute(key, convertEnumeratedValue(key, value));
    }
    else if (isXlink(key)) {
        if (isFalsyAttrValue(value)) {
            el.removeAttributeNS(xlinkNS, getXlinkProp(key));
        }
        else {
            el.setAttributeNS(xlinkNS, key, value);
        }
    }
    else {
        baseSetAttr(el, key, value);
    }
}
function baseSetAttr(el, key, value) {
    if (isFalsyAttrValue(value)) {
        el.removeAttribute(key);
    }
    else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */
        if (isIE &&
            !isIE9 &&
            el.tagName === 'TEXTAREA' &&
            key === 'placeholder' &&
            value !== '' &&
            !el.__ieph) {
            var blocker_1 = function (e) {
                e.stopImmediatePropagation();
                el.removeEventListener('input', blocker_1);
            };
            el.addEventListener('input', blocker_1);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */
        }
        el.setAttribute(key, value);
    }
}
var attrs = {
    create: updateAttrs,
    update: updateAttrs
};

function updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticClass) &&
        isUndef(data.class) &&
        (isUndef(oldData) ||
            (isUndef(oldData.staticClass) && isUndef(oldData.class)))) {
        return;
    }
    var cls = genClassForVnode(vnode);
    // handle transition classes
    var transitionClass = el._transitionClasses;
    if (isDef(transitionClass)) {
        cls = concat(cls, stringifyClass(transitionClass));
    }
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute('class', cls);
        el._prevClass = cls;
    }
}
var klass$1 = {
    create: updateClass,
    update: updateClass
};

var validDivisionCharRE = /[\w).+\-_$\]]/;
function parseFilters(exp) {
    var inSingle = false;
    var inDouble = false;
    var inTemplateString = false;
    var inRegex = false;
    var curly = 0;
    var square = 0;
    var paren = 0;
    var lastFilterIndex = 0;
    var c, prev, i, expression, filters;
    for (i = 0; i < exp.length; i++) {
        prev = c;
        c = exp.charCodeAt(i);
        if (inSingle) {
            if (c === 0x27 && prev !== 0x5c)
                inSingle = false;
        }
        else if (inDouble) {
            if (c === 0x22 && prev !== 0x5c)
                inDouble = false;
        }
        else if (inTemplateString) {
            if (c === 0x60 && prev !== 0x5c)
                inTemplateString = false;
        }
        else if (inRegex) {
            if (c === 0x2f && prev !== 0x5c)
                inRegex = false;
        }
        else if (c === 0x7c && // pipe
            exp.charCodeAt(i + 1) !== 0x7c &&
            exp.charCodeAt(i - 1) !== 0x7c &&
            !curly &&
            !square &&
            !paren) {
            if (expression === undefined) {
                // first filter, end of expression
                lastFilterIndex = i + 1;
                expression = exp.slice(0, i).trim();
            }
            else {
                pushFilter();
            }
        }
        else {
            switch (c) {
                case 0x22:
                    inDouble = true;
                    break; // "
                case 0x27:
                    inSingle = true;
                    break; // '
                case 0x60:
                    inTemplateString = true;
                    break; // `
                case 0x28:
                    paren++;
                    break; // (
                case 0x29:
                    paren--;
                    break; // )
                case 0x5b:
                    square++;
                    break; // [
                case 0x5d:
                    square--;
                    break; // ]
                case 0x7b:
                    curly++;
                    break; // {
                case 0x7d:
                    curly--;
                    break; // }
            }
            if (c === 0x2f) {
                // /
                var j = i - 1;
                var p 
                // find first non-whitespace prev char
                = void 0;
                // find first non-whitespace prev char
                for (; j >= 0; j--) {
                    p = exp.charAt(j);
                    if (p !== ' ')
                        break;
                }
                if (!p || !validDivisionCharRE.test(p)) {
                    inRegex = true;
                }
            }
        }
    }
    if (expression === undefined) {
        expression = exp.slice(0, i).trim();
    }
    else if (lastFilterIndex !== 0) {
        pushFilter();
    }
    function pushFilter() {
        (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
        lastFilterIndex = i + 1;
    }
    if (filters) {
        for (i = 0; i < filters.length; i++) {
            expression = wrapFilter(expression, filters[i]);
        }
    }
    return expression;
}
function wrapFilter(exp, filter) {
    var i = filter.indexOf('(');
    if (i < 0) {
        // _f: resolveFilter
        return "_f(\"".concat(filter, "\")(").concat(exp, ")");
    }
    else {
        var name_1 = filter.slice(0, i);
        var args = filter.slice(i + 1);
        return "_f(\"".concat(name_1, "\")(").concat(exp).concat(args !== ')' ? ',' + args : args);
    }
}

/* eslint-disable no-unused-vars */
function baseWarn(msg, range) {
    console.error("[Vue compiler]: ".concat(msg));
}
/* eslint-enable no-unused-vars */
function pluckModuleFunction(modules, key) {
    return modules ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; }) : [];
}
function addProp(el, name, value, range, dynamic) {
    (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
function addAttr(el, name, value, range, dynamic) {
    var attrs = dynamic
        ? el.dynamicAttrs || (el.dynamicAttrs = [])
        : el.attrs || (el.attrs = []);
    attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
    el.plain = false;
}
// add a raw attr (use this in preTransforms)
function addRawAttr(el, name, value, range) {
    el.attrsMap[name] = value;
    el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}
function addDirective(el, name, rawName, value, arg, isDynamicArg, modifiers, range) {
    (el.directives || (el.directives = [])).push(rangeSetItem({
        name: name,
        rawName: rawName,
        value: value,
        arg: arg,
        isDynamicArg: isDynamicArg,
        modifiers: modifiers
    }, range));
    el.plain = false;
}
function prependModifierMarker(symbol, name, dynamic) {
    return dynamic ? "_p(".concat(name, ",\"").concat(symbol, "\")") : symbol + name; // mark the event as captured
}
function addHandler(el, name, value, modifiers, important, warn, range, dynamic) {
    modifiers = modifiers || emptyObject;
    // warn prevent and passive modifier
    /* istanbul ignore if */
    if (false) {
        warn("passive and prevent can't be used together. " +
            "Passive handler can't prevent default event.", range);
    }
    // normalize click.right and click.middle since they don't actually fire
    // this is technically browser-specific, but at least for now browsers are
    // the only target envs that have right/middle clicks.
    if (modifiers.right) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'contextmenu':(").concat(name, ")");
        }
        else if (name === 'click') {
            name = 'contextmenu';
            delete modifiers.right;
        }
    }
    else if (modifiers.middle) {
        if (dynamic) {
            name = "(".concat(name, ")==='click'?'mouseup':(").concat(name, ")");
        }
        else if (name === 'click') {
            name = 'mouseup';
        }
    }
    // check capture modifier
    if (modifiers.capture) {
        delete modifiers.capture;
        name = prependModifierMarker('!', name, dynamic);
    }
    if (modifiers.once) {
        delete modifiers.once;
        name = prependModifierMarker('~', name, dynamic);
    }
    /* istanbul ignore if */
    if (modifiers.passive) {
        delete modifiers.passive;
        name = prependModifierMarker('&', name, dynamic);
    }
    var events;
    if (modifiers.native) {
        delete modifiers.native;
        events = el.nativeEvents || (el.nativeEvents = {});
    }
    else {
        events = el.events || (el.events = {});
    }
    var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
    if (modifiers !== emptyObject) {
        newHandler.modifiers = modifiers;
    }
    var handlers = events[name];
    /* istanbul ignore if */
    if (Array.isArray(handlers)) {
        important ? handlers.unshift(newHandler) : handlers.push(newHandler);
    }
    else if (handlers) {
        events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
    }
    else {
        events[name] = newHandler;
    }
    el.plain = false;
}
function getRawBindingAttr(el, name) {
    return (el.rawAttrsMap[':' + name] ||
        el.rawAttrsMap['v-bind:' + name] ||
        el.rawAttrsMap[name]);
}
function getBindingAttr(el, name, getStatic) {
    var dynamicValue = getAndRemoveAttr(el, ':' + name) || getAndRemoveAttr(el, 'v-bind:' + name);
    if (dynamicValue != null) {
        return parseFilters(dynamicValue);
    }
    else if (getStatic !== false) {
        var staticValue = getAndRemoveAttr(el, name);
        if (staticValue != null) {
            return JSON.stringify(staticValue);
        }
    }
}
// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr(el, name, removeFromMap) {
    var val;
    if ((val = el.attrsMap[name]) != null) {
        var list = el.attrsList;
        for (var i = 0, l = list.length; i < l; i++) {
            if (list[i].name === name) {
                list.splice(i, 1);
                break;
            }
        }
    }
    if (removeFromMap) {
        delete el.attrsMap[name];
    }
    return val;
}
function getAndRemoveAttrByRegex(el, name) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
        var attr = list[i];
        if (name.test(attr.name)) {
            list.splice(i, 1);
            return attr;
        }
    }
}
function rangeSetItem(item, range) {
    if (range) {
        if (range.start != null) {
            item.start = range.start;
        }
        if (range.end != null) {
            item.end = range.end;
        }
    }
    return item;
}

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel(el, value, modifiers) {
    var _a = modifiers || {}, number = _a.number, trim = _a.trim;
    var baseValueExpression = '$$v';
    var valueExpression = baseValueExpression;
    if (trim) {
        valueExpression =
            "(typeof ".concat(baseValueExpression, " === 'string'") +
                "? ".concat(baseValueExpression, ".trim()") +
                ": ".concat(baseValueExpression, ")");
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var assignment = genAssignmentCode(value, valueExpression);
    el.model = {
        value: "(".concat(value, ")"),
        expression: JSON.stringify(value),
        callback: "function (".concat(baseValueExpression, ") {").concat(assignment, "}")
    };
}
/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode(value, assignment) {
    var res = parseModel(value);
    if (res.key === null) {
        return "".concat(value, "=").concat(assignment);
    }
    else {
        return "$set(".concat(res.exp, ", ").concat(res.key, ", ").concat(assignment, ")");
    }
}
/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */
var len, str, chr, index, expressionPos, expressionEndPos;
function parseModel(val) {
    // Fix https://github.com/vuejs/vue/pull/7730
    // allow v-model="obj.val " (trailing whitespace)
    val = val.trim();
    len = val.length;
    if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
        index = val.lastIndexOf('.');
        if (index > -1) {
            return {
                exp: val.slice(0, index),
                key: '"' + val.slice(index + 1) + '"'
            };
        }
        else {
            return {
                exp: val,
                key: null
            };
        }
    }
    str = val;
    index = expressionPos = expressionEndPos = 0;
    while (!eof()) {
        chr = next();
        /* istanbul ignore if */
        if (isStringStart(chr)) {
            parseString(chr);
        }
        else if (chr === 0x5b) {
            parseBracket(chr);
        }
    }
    return {
        exp: val.slice(0, expressionPos),
        key: val.slice(expressionPos + 1, expressionEndPos)
    };
}
function next() {
    return str.charCodeAt(++index);
}
function eof() {
    return index >= len;
}
function isStringStart(chr) {
    return chr === 0x22 || chr === 0x27;
}
function parseBracket(chr) {
    var inBracket = 1;
    expressionPos = index;
    while (!eof()) {
        chr = next();
        if (isStringStart(chr)) {
            parseString(chr);
            continue;
        }
        if (chr === 0x5b)
            inBracket++;
        if (chr === 0x5d)
            inBracket--;
        if (inBracket === 0) {
            expressionEndPos = index;
            break;
        }
    }
}
function parseString(chr) {
    var stringQuote = chr;
    while (!eof()) {
        chr = next();
        if (chr === stringQuote) {
            break;
        }
    }
}

var warn$1;
// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';
function model$1(el, dir, _warn) {
    warn$1 = _warn;
    var value = dir.value;
    var modifiers = dir.modifiers;
    var tag = el.tag;
    var type = el.attrsMap.type;
    if (false) {
        // inputs with type="file" are read only and setting the input's
        // value will throw an error.
        if (tag === 'input' && type === 'file') {
            warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\" type=\"file\">:\n") +
                "File inputs are read only. Use a v-on:change listener instead.", el.rawAttrsMap['v-model']);
        }
    }
    if (el.component) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    }
    else if (tag === 'select') {
        genSelect(el, value, modifiers);
    }
    else if (tag === 'input' && type === 'checkbox') {
        genCheckboxModel(el, value, modifiers);
    }
    else if (tag === 'input' && type === 'radio') {
        genRadioModel(el, value, modifiers);
    }
    else if (tag === 'input' || tag === 'textarea') {
        genDefaultModel(el, value, modifiers);
    }
    else if (!config.isReservedTag(tag)) {
        genComponentModel(el, value, modifiers);
        // component v-model doesn't need extra runtime
        return false;
    }
    else if (false) {
        warn$1("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
            "v-model is not supported on this element type. " +
            "If you are working with contenteditable, it's recommended to " +
            'wrap a library dedicated for that purpose inside a custom component.', el.rawAttrsMap['v-model']);
    }
    // ensure runtime directive metadata
    return true;
}
function genCheckboxModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
    var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
    addProp(el, 'checked', "Array.isArray(".concat(value, ")") +
        "?_i(".concat(value, ",").concat(valueBinding, ")>-1") +
        (trueValueBinding === 'true'
            ? ":(".concat(value, ")")
            : ":_q(".concat(value, ",").concat(trueValueBinding, ")")));
    addHandler(el, 'change', "var $$a=".concat(value, ",") +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(".concat(trueValueBinding, "):(").concat(falseValueBinding, ");") +
        'if(Array.isArray($$a)){' +
        "var $$v=".concat(number ? '_n(' + valueBinding + ')' : valueBinding, ",") +
        '$$i=_i($$a,$$v);' +
        "if($$el.checked){$$i<0&&(".concat(genAssignmentCode(value, '$$a.concat([$$v])'), ")}") +
        "else{$$i>-1&&(".concat(genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))'), ")}") +
        "}else{".concat(genAssignmentCode(value, '$$c'), "}"), null, true);
}
function genRadioModel(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var valueBinding = getBindingAttr(el, 'value') || 'null';
    valueBinding = number ? "_n(".concat(valueBinding, ")") : valueBinding;
    addProp(el, 'checked', "_q(".concat(value, ",").concat(valueBinding, ")"));
    addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}
function genSelect(el, value, modifiers) {
    var number = modifiers && modifiers.number;
    var selectedVal = "Array.prototype.filter" +
        ".call($event.target.options,function(o){return o.selected})" +
        ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
        "return ".concat(number ? '_n(val)' : 'val', "})");
    var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
    var code = "var $$selectedVal = ".concat(selectedVal, ";");
    code = "".concat(code, " ").concat(genAssignmentCode(value, assignment));
    addHandler(el, 'change', code, null, true);
}
function genDefaultModel(el, value, modifiers) {
    var type = el.attrsMap.type;
    // warn if v-bind:value conflicts with v-model
    // except for inputs with v-bind:type
    if (false) {
        var value_1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
        var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
        if (value_1 && !typeBinding) {
            var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
            warn$1("".concat(binding, "=\"").concat(value_1, "\" conflicts with v-model on the same element ") +
                'because the latter already expands to a value binding internally', el.rawAttrsMap[binding]);
        }
    }
    var _a = modifiers || {}, lazy = _a.lazy, number = _a.number, trim = _a.trim;
    var needCompositionGuard = !lazy && type !== 'range';
    var event = lazy ? 'change' : type === 'range' ? RANGE_TOKEN : 'input';
    var valueExpression = '$event.target.value';
    if (trim) {
        valueExpression = "$event.target.value.trim()";
    }
    if (number) {
        valueExpression = "_n(".concat(valueExpression, ")");
    }
    var code = genAssignmentCode(value, valueExpression);
    if (needCompositionGuard) {
        code = "if($event.target.composing)return;".concat(code);
    }
    addProp(el, 'value', "(".concat(value, ")"));
    addHandler(el, event, code, null, true);
    if (trim || number) {
        addHandler(el, 'blur', '$forceUpdate()');
    }
}

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents(on) {
    /* istanbul ignore if */
    if (isDef(on[RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event_1 = isIE ? 'change' : 'input';
        on[event_1] = [].concat(on[RANGE_TOKEN], on[event_1] || []);
        delete on[RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */
    if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[CHECKBOX_RADIO_TOKEN];
    }
}
var target;
function createOnceHandler(event, handler, capture) {
    var _target = target; // save current target element in closure
    return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) {
            remove(event, onceHandler, capture, _target);
        }
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);
function add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if (useMicrotaskFix) {
        var attachedTimestamp_1 = currentFlushTimestamp;
        var original_1 = handler;
        //@ts-expect-error
        handler = original_1._wrapper = function (e) {
            if (
            // no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget ||
                // event is fired after handler attachment
                e.timeStamp >= attachedTimestamp_1 ||
                // bail for environments that have buggy event.timeStamp implementations
                // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
                // #9681 QtWebEngine event.timeStamp is negative value
                e.timeStamp <= 0 ||
                // #9448 bail if event is fired in another document in a multi-page
                // electron/nw.js app, since event.timeStamp will be using a different
                // starting reference
                e.target.ownerDocument !== document) {
                return original_1.apply(this, arguments);
            }
        };
    }
    target.addEventListener(name, handler, supportsPassive ? { capture: capture, passive: passive } : capture);
}
function remove(name, handler, capture, _target) {
    (_target || target).removeEventListener(name, 
    //@ts-expect-error
    handler._wrapper || handler, capture);
}
function updateDOMListeners(oldVnode, vnode) {
    if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
        return;
    }
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    target = vnode.elm || oldVnode.elm;
    normalizeEvents(on);
    updateListeners(on, oldOn, add, remove, createOnceHandler, vnode.context);
    target = undefined;
}
var events = {
    create: updateDOMListeners,
    update: updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: function (vnode) { return updateDOMListeners(vnode, emptyNode); }
};

var svgContainer;
function updateDOMProps(oldVnode, vnode) {
    if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
        return;
    }
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if (isDef(props.__ob__) || isTrue(props._v_attr_proxy)) {
        props = vnode.data.domProps = extend({}, props);
    }
    for (key in oldProps) {
        if (!(key in props)) {
            elm[key] = '';
        }
    }
    for (key in props) {
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === 'textContent' || key === 'innerHTML') {
            if (vnode.children)
                vnode.children.length = 0;
            if (cur === oldProps[key])
                continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) {
                elm.removeChild(elm.childNodes[0]);
            }
        }
        if (key === 'value' && elm.tagName !== 'PROGRESS') {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = isUndef(cur) ? '' : String(cur);
            if (shouldUpdateValue(elm, strCur)) {
                elm.value = strCur;
            }
        }
        else if (key === 'innerHTML' &&
            isSVG(elm.tagName) &&
            isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            svgContainer = svgContainer || document.createElement('div');
            svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
            var svg = svgContainer.firstChild;
            while (elm.firstChild) {
                elm.removeChild(elm.firstChild);
            }
            while (svg.firstChild) {
                elm.appendChild(svg.firstChild);
            }
        }
        else if (
        // skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) {
            // some property updates can throw
            // e.g. `value` on <progress> w/ non-finite value
            try {
                elm[key] = cur;
            }
            catch (e) { }
        }
    }
}
function shouldUpdateValue(elm, checkVal) {
    return (
    //@ts-expect-error
    !elm.composing &&
        (elm.tagName === 'OPTION' ||
            isNotInFocusAndDirty(elm, checkVal) ||
            isDirtyWithModifiers(elm, checkVal)));
}
function isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    }
    catch (e) { }
    return notInFocus && elm.value !== checkVal;
}
function isDirtyWithModifiers(elm, newVal) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if (isDef(modifiers)) {
        if (modifiers.number) {
            return toNumber(value) !== toNumber(newVal);
        }
        if (modifiers.trim) {
            return value.trim() !== newVal.trim();
        }
    }
    return value !== newVal;
}
var domProps = {
    create: updateDOMProps,
    update: updateDOMProps
};

var parseStyleText = cached(function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function normalizeStyleData(data) {
    var style = normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle(vnode, checkChild) {
    var res = {};
    var styleData;
    if (checkChild) {
        var childNode = vnode;
        while (childNode.componentInstance) {
            childNode = childNode.componentInstance._vnode;
            if (childNode &&
                childNode.data &&
                (styleData = normalizeStyleData(childNode.data))) {
                extend(res, styleData);
            }
        }
    }
    if ((styleData = normalizeStyleData(vnode.data))) {
        extend(res, styleData);
    }
    var parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while ((parentNode = parentNode.parent)) {
        if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
            extend(res, styleData);
        }
    }
    return res;
}

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
    /* istanbul ignore if */
    if (cssVarRE.test(name)) {
        el.style.setProperty(name, val);
    }
    else if (importantRE.test(val)) {
        el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
    }
    else {
        var normalizedName = normalize(name);
        if (Array.isArray(val)) {
            // Support values array created by autoprefixer, e.g.
            // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
            // Set them one by one, and the browser will only set those it can recognize
            for (var i = 0, len = val.length; i < len; i++) {
                el.style[normalizedName] = val[i];
            }
        }
        else {
            el.style[normalizedName] = val;
        }
    }
};
var vendorNames = ['Webkit', 'Moz', 'ms'];
var emptyStyle;
var normalize = cached(function (prop) {
    emptyStyle = emptyStyle || document.createElement('div').style;
    prop = camelize(prop);
    if (prop !== 'filter' && prop in emptyStyle) {
        return prop;
    }
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (var i = 0; i < vendorNames.length; i++) {
        var name_1 = vendorNames[i] + capName;
        if (name_1 in emptyStyle) {
            return name_1;
        }
    }
});
function updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;
    if (isUndef(data.staticStyle) &&
        isUndef(data.style) &&
        isUndef(oldData.staticStyle) &&
        isUndef(oldData.style)) {
        return;
    }
    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = isDef(style.__ob__) ? extend({}, style) : style;
    var newStyle = getStyle(vnode, true);
    for (name in oldStyle) {
        if (isUndef(newStyle[name])) {
            setProp(el, name, '');
        }
    }
    for (name in newStyle) {
        cur = newStyle[name];
        if (cur !== oldStyle[name]) {
            // ie9 setting to null has no effect, must use empty string
            setProp(el, name, cur == null ? '' : cur);
        }
    }
}
var style$1 = {
    create: updateStyle,
    update: updateStyle
};

var whitespaceRE$1 = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.add(c); });
        }
        else {
            el.classList.add(cls);
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        if (cur.indexOf(' ' + cls + ' ') < 0) {
            el.setAttribute('class', (cur + cls).trim());
        }
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass(el, cls) {
    /* istanbul ignore if */
    if (!cls || !(cls = cls.trim())) {
        return;
    }
    /* istanbul ignore else */
    if (el.classList) {
        if (cls.indexOf(' ') > -1) {
            cls.split(whitespaceRE$1).forEach(function (c) { return el.classList.remove(c); });
        }
        else {
            el.classList.remove(cls);
        }
        if (!el.classList.length) {
            el.removeAttribute('class');
        }
    }
    else {
        var cur = " ".concat(el.getAttribute('class') || '', " ");
        var tar = ' ' + cls + ' ';
        while (cur.indexOf(tar) >= 0) {
            cur = cur.replace(tar, ' ');
        }
        cur = cur.trim();
        if (cur) {
            el.setAttribute('class', cur);
        }
        else {
            el.removeAttribute('class');
        }
    }
}

function resolveTransition(def) {
    if (!def) {
        return;
    }
    /* istanbul ignore else */
    if (typeof def === 'object') {
        var res = {};
        if (def.css !== false) {
            extend(res, autoCssTransition(def.name || 'v'));
        }
        extend(res, def);
        return res;
    }
    else if (typeof def === 'string') {
        return autoCssTransition(def);
    }
}
var autoCssTransition = cached(function (name) {
    return {
        enterClass: "".concat(name, "-enter"),
        enterToClass: "".concat(name, "-enter-to"),
        enterActiveClass: "".concat(name, "-enter-active"),
        leaveClass: "".concat(name, "-leave"),
        leaveToClass: "".concat(name, "-leave-to"),
        leaveActiveClass: "".concat(name, "-leave-active")
    };
});
var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';
// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
    /* istanbul ignore if */
    if (window.ontransitionend === undefined &&
        window.onwebkittransitionend !== undefined) {
        transitionProp = 'WebkitTransition';
        transitionEndEvent = 'webkitTransitionEnd';
    }
    if (window.onanimationend === undefined &&
        window.onwebkitanimationend !== undefined) {
        animationProp = 'WebkitAnimation';
        animationEndEvent = 'webkitAnimationEnd';
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
    ? window.requestAnimationFrame
        ? window.requestAnimationFrame.bind(window)
        : setTimeout
    : /* istanbul ignore next */ function (/* istanbul ignore next */ fn) { return fn(); };
function nextFrame(fn) {
    raf(function () {
        // @ts-expect-error
        raf(fn);
    });
}
function addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        addClass(el, cls);
    }
}
function removeTransitionClass(el, cls) {
    if (el._transitionClasses) {
        remove$2(el._transitionClasses, cls);
    }
    removeClass(el, cls);
}
function whenTransitionEnds(el, expectedType, cb) {
    var _a = getTransitionInfo(el, expectedType), type = _a.type, timeout = _a.timeout, propCount = _a.propCount;
    if (!type)
        return cb();
    var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
    var ended = 0;
    var end = function () {
        el.removeEventListener(event, onEnd);
        cb();
    };
    var onEnd = function (e) {
        if (e.target === el) {
            if (++ended >= propCount) {
                end();
            }
        }
    };
    setTimeout(function () {
        if (ended < propCount) {
            end();
        }
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
var transformRE = /\b(transform|all)(,|$)/;
function getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
    var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
    var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
    var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
    var animationTimeout = getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    }
    else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    }
    else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type =
            timeout > 0
                ? transitionTimeout > animationTimeout
                    ? TRANSITION
                    : ANIMATION
                : null;
        propCount = type
            ? type === TRANSITION
                ? transitionDurations.length
                : animationDurations.length
            : 0;
    }
    var hasTransform = type === TRANSITION && transformRE.test(styles[transitionProp + 'Property']);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function getTimeout(delays, durations) {
    /* istanbul ignore next */
    while (delays.length < durations.length) {
        delays = delays.concat(delays);
    }
    return Math.max.apply(null, durations.map(function (d, i) {
        return toMs(d) + toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs(s) {
    return Number(s.slice(0, -1).replace(',', '.')) * 1000;
}

function enter(vnode, toggleDisplay) {
    var el = vnode.elm;
    // call leave callback now
    if (isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data)) {
        return;
    }
    /* istanbul ignore if */
    if (isDef(el._enterCb) || el.nodeType !== 1) {
        return;
    }
    var css = data.css, type = data.type, enterClass = data.enterClass, enterToClass = data.enterToClass, enterActiveClass = data.enterActiveClass, appearClass = data.appearClass, appearToClass = data.appearToClass, appearActiveClass = data.appearActiveClass, beforeEnter = data.beforeEnter, enter = data.enter, afterEnter = data.afterEnter, enterCancelled = data.enterCancelled, beforeAppear = data.beforeAppear, appear = data.appear, afterAppear = data.afterAppear, appearCancelled = data.appearCancelled, duration = data.duration;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = activeInstance;
    var transitionNode = activeInstance.$vnode;
    while (transitionNode && transitionNode.parent) {
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    var isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== '') {
        return;
    }
    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? (isFunction(appear) ? appear : enter) : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear
        ? appearCancelled || enterCancelled
        : enterCancelled;
    var explicitEnterDuration = toNumber(isObject(duration) ? duration.enter : duration);
    if (false) {
        checkDuration(explicitEnterDuration, 'enter', vnode);
    }
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(enterHook);
    var cb = (el._enterCb = once(function () {
        if (expectsCSS) {
            removeTransitionClass(el, toClass);
            removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, startClass);
            }
            enterCancelledHook && enterCancelledHook(el);
        }
        else {
            afterEnterHook && afterEnterHook(el);
        }
        el._enterCb = null;
    }));
    if (!vnode.data.show) {
        // remove pending leave element on enter by injecting an insert hook
        mergeVNodeHook(vnode, 'insert', function () {
            var parent = el.parentNode;
            var pendingNode = parent && parent._pending && parent._pending[vnode.key];
            if (pendingNode &&
                pendingNode.tag === vnode.tag &&
                pendingNode.elm._leaveCb) {
                pendingNode.elm._leaveCb();
            }
            enterHook && enterHook(el, cb);
        });
    }
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        addTransitionClass(el, startClass);
        addTransitionClass(el, activeClass);
        nextFrame(function () {
            removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if (isValidDuration(explicitEnterDuration)) {
                        setTimeout(cb, explicitEnterDuration);
                    }
                    else {
                        whenTransitionEnds(el, type, cb);
                    }
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) {
        cb();
    }
}
function leave(vnode, rm) {
    var el = vnode.elm;
    // call enter callback now
    if (isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    var data = resolveTransition(vnode.data.transition);
    if (isUndef(data) || el.nodeType !== 1) {
        return rm();
    }
    /* istanbul ignore if */
    if (isDef(el._leaveCb)) {
        return;
    }
    var css = data.css, type = data.type, leaveClass = data.leaveClass, leaveToClass = data.leaveToClass, leaveActiveClass = data.leaveActiveClass, beforeLeave = data.beforeLeave, leave = data.leave, afterLeave = data.afterLeave, leaveCancelled = data.leaveCancelled, delayLeave = data.delayLeave, duration = data.duration;
    var expectsCSS = css !== false && !isIE9;
    var userWantsControl = getHookArgumentsLength(leave);
    var explicitLeaveDuration = toNumber(isObject(duration) ? duration.leave : duration);
    if (false) {
        checkDuration(explicitLeaveDuration, 'leave', vnode);
    }
    var cb = (el._leaveCb = once(function () {
        if (el.parentNode && el.parentNode._pending) {
            el.parentNode._pending[vnode.key] = null;
        }
        if (expectsCSS) {
            removeTransitionClass(el, leaveToClass);
            removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) {
                removeTransitionClass(el, leaveClass);
            }
            leaveCancelled && leaveCancelled(el);
        }
        else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    }));
    if (delayLeave) {
        delayLeave(performLeave);
    }
    else {
        performLeave();
    }
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) {
            return;
        }
        // record leaving element
        if (!vnode.data.show && el.parentNode) {
            (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] =
                vnode;
        }
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            addTransitionClass(el, leaveClass);
            addTransitionClass(el, leaveActiveClass);
            nextFrame(function () {
                removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if (isValidDuration(explicitLeaveDuration)) {
                            setTimeout(cb, explicitLeaveDuration);
                        }
                        else {
                            whenTransitionEnds(el, type, cb);
                        }
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) {
            cb();
        }
    }
}
// only used in dev mode
function checkDuration(val, name, vnode) {
    if (typeof val !== 'number') {
        warn$2("<transition> explicit ".concat(name, " duration is not a valid number - ") +
            "got ".concat(JSON.stringify(val), "."), vnode.context);
    }
    else if (isNaN(val)) {
        warn$2("<transition> explicit ".concat(name, " duration is NaN - ") +
            'the duration expression might be incorrect.', vnode.context);
    }
}
function isValidDuration(val) {
    return typeof val === 'number' && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength(fn) {
    if (isUndef(fn)) {
        return false;
    }
    // @ts-expect-error
    var invokerFns = fn.fns;
    if (isDef(invokerFns)) {
        // invoker
        return getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    }
    else {
        // @ts-expect-error
        return (fn._length || fn.length) > 1;
    }
}
function _enter(_, vnode) {
    if (vnode.data.show !== true) {
        enter(vnode);
    }
}
var transition = inBrowser
    ? {
        create: _enter,
        activate: _enter,
        remove: function (vnode, rm) {
            /* istanbul ignore else */
            if (vnode.data.show !== true) {
                // @ts-expect-error
                leave(vnode, rm);
            }
            else {
                rm();
            }
        }
    }
    : {};

var platformModules = [attrs, klass$1, events, domProps, style$1, transition];

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules$1 = platformModules.concat(baseModules);
var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules$1 });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */
/* istanbul ignore if */
if (isIE9) {
    // http://www.matts411.com/post/internet-explorer-9-oninput/
    document.addEventListener('selectionchange', function () {
        var el = document.activeElement;
        // @ts-expect-error
        if (el && el.vmodel) {
            trigger(el, 'input');
        }
    });
}
var directive = {
    inserted: function (el, binding, vnode, oldVnode) {
        if (vnode.tag === 'select') {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) {
                mergeVNodeHook(vnode, 'postpatch', function () {
                    directive.componentUpdated(el, binding, vnode);
                });
            }
            else {
                setSelected(el, binding, vnode.context);
            }
            el._vOptions = [].map.call(el.options, getValue);
        }
        else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener('compositionstart', onCompositionStart);
                el.addEventListener('compositionend', onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener('change', onCompositionEnd);
                /* istanbul ignore if */
                if (isIE9) {
                    el.vmodel = true;
                }
            }
        }
    },
    componentUpdated: function (el, binding, vnode) {
        if (vnode.tag === 'select') {
            setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions_1 = el._vOptions;
            var curOptions_1 = (el._vOptions = [].map.call(el.options, getValue));
            if (curOptions_1.some(function (o, i) { return !looseEqual(o, prevOptions_1[i]); })) {
                // trigger change event if
                // no matching option found for at least one value
                var needReset = el.multiple
                    ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions_1); })
                    : binding.value !== binding.oldValue &&
                        hasNoMatchingOption(binding.value, curOptions_1);
                if (needReset) {
                    trigger(el, 'change');
                }
            }
        }
    }
};
function setSelected(el, binding, vm) {
    actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */
    if (isIE || isEdge) {
        setTimeout(function () {
            actuallySetSelected(el, binding, vm);
        }, 0);
    }
}
function actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) {
        "production" !== 'production' &&
            warn$2("<select multiple v-model=\"".concat(binding.expression, "\"> ") +
                "expects an Array value for its binding, but got ".concat(Object.prototype.toString
                    .call(value)
                    .slice(8, -1)), vm);
        return;
    }
    var selected, option;
    for (var i = 0, l = el.options.length; i < l; i++) {
        option = el.options[i];
        if (isMultiple) {
            selected = looseIndexOf(value, getValue(option)) > -1;
            if (option.selected !== selected) {
                option.selected = selected;
            }
        }
        else {
            if (looseEqual(getValue(option), value)) {
                if (el.selectedIndex !== i) {
                    el.selectedIndex = i;
                }
                return;
            }
        }
    }
    if (!isMultiple) {
        el.selectedIndex = -1;
    }
}
function hasNoMatchingOption(value, options) {
    return options.every(function (o) { return !looseEqual(o, value); });
}
function getValue(option) {
    return '_value' in option ? option._value : option.value;
}
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing)
        return;
    e.target.composing = false;
    trigger(e.target, 'input');
}
function trigger(el, type) {
    var e = document.createEvent('HTMLEvents');
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}

// recursively search for possible transition defined inside the component root
function locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
        ? locateNode(vnode.componentInstance._vnode)
        : vnode;
}
var show = {
    bind: function (el, _a, vnode) {
        var value = _a.value;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        var originalDisplay = (el.__vOriginalDisplay =
            el.style.display === 'none' ? '' : el.style.display);
        if (value && transition) {
            vnode.data.show = true;
            enter(vnode, function () {
                el.style.display = originalDisplay;
            });
        }
        else {
            el.style.display = value ? originalDisplay : 'none';
        }
    },
    update: function (el, _a, vnode) {
        var value = _a.value, oldValue = _a.oldValue;
        /* istanbul ignore if */
        if (!value === !oldValue)
            return;
        vnode = locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) {
                enter(vnode, function () {
                    el.style.display = el.__vOriginalDisplay;
                });
            }
            else {
                leave(vnode, function () {
                    el.style.display = 'none';
                });
            }
        }
        else {
            el.style.display = value ? el.__vOriginalDisplay : 'none';
        }
    },
    unbind: function (el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) {
            el.style.display = el.__vOriginalDisplay;
        }
    }
};

var platformDirectives = {
    model: directive,
    show: show
};

// Provides transition support for a single element/component.
var transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [Number, String, Object]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) {
        return getRealChild(getFirstComponentChild(compOptions.children));
    }
    else {
        return vnode;
    }
}
function extractTransitionData(comp) {
    var data = {};
    var options = comp.$options;
    // props
    for (var key in options.propsData) {
        data[key] = comp[key];
    }
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for (var key in listeners) {
        data[camelize(key)] = listeners[key];
    }
    return data;
}
function placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) {
        return h('keep-alive', {
            props: rawChild.componentOptions.propsData
        });
    }
}
function hasParentTransition(vnode) {
    while ((vnode = vnode.parent)) {
        if (vnode.data.transition) {
            return true;
        }
    }
}
function isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };
var isVShowDirective = function (d) { return d.name === 'show'; };
var Transition = {
    name: 'transition',
    props: transitionProps,
    abstract: true,
    render: function (h) {
        var _this = this;
        var children = this.$slots.default;
        if (!children) {
            return;
        }
        // filter out text nodes (possible whitespaces)
        children = children.filter(isNotTextNode);
        /* istanbul ignore if */
        if (!children.length) {
            return;
        }
        // warn multiple elements
        if (false) {
            warn$2('<transition> can only be used on a single element. Use ' +
                '<transition-group> for lists.', this.$parent);
        }
        var mode = this.mode;
        // warn invalid mode
        if (false) {
            warn$2('invalid <transition> mode: ' + mode, this.$parent);
        }
        var rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if (hasParentTransition(this.$vnode)) {
            return rawChild;
        }
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = getRealChild(rawChild);
        /* istanbul ignore if */
        if (!child) {
            return rawChild;
        }
        if (this._leaving) {
            return placeholder(h, rawChild);
        }
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-".concat(this._uid, "-");
        child.key =
            child.key == null
                ? child.isComment
                    ? id + 'comment'
                    : id + child.tag
                : isPrimitive(child.key)
                    ? String(child.key).indexOf(id) === 0
                        ? child.key
                        : id + child.key
                    : child.key;
        var data = ((child.data || (child.data = {})).transition =
            extractTransitionData(this));
        var oldRawChild = this._vnode;
        var oldChild = getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some(isVShowDirective)) {
            child.data.show = true;
        }
        if (oldChild &&
            oldChild.data &&
            !isSameChild(child, oldChild) &&
            !isAsyncPlaceholder(oldChild) &&
            // #6687 component root is a comment node
            !(oldChild.componentInstance &&
                oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = (oldChild.data.transition = extend({}, data));
            // handle transition mode
            if (mode === 'out-in') {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                mergeVNodeHook(oldData, 'afterLeave', function () {
                    _this._leaving = false;
                    _this.$forceUpdate();
                });
                return placeholder(h, rawChild);
            }
            else if (mode === 'in-out') {
                if (isAsyncPlaceholder(child)) {
                    return oldRawChild;
                }
                var delayedLeave_1;
                var performLeave = function () {
                    delayedLeave_1();
                };
                mergeVNodeHook(data, 'afterEnter', performLeave);
                mergeVNodeHook(data, 'enterCancelled', performLeave);
                mergeVNodeHook(oldData, 'delayLeave', function (leave) {
                    delayedLeave_1 = leave;
                });
            }
        }
        return rawChild;
    }
};

// Provides transition support for list items.
var props = extend({
    tag: String,
    moveClass: String
}, transitionProps);
delete props.mode;
var TransitionGroup = {
    props: props,
    beforeMount: function () {
        var _this = this;
        var update = this._update;
        this._update = function (vnode, hydrating) {
            var restoreActiveInstance = setActiveInstance(_this);
            // force removing pass
            _this.__patch__(_this._vnode, _this.kept, false, // hydrating
            true // removeOnly (!important, avoids unnecessary moves)
            );
            _this._vnode = _this.kept;
            restoreActiveInstance();
            update.call(_this, vnode, hydrating);
        };
    },
    render: function (h) {
        var tag = this.tag || this.$vnode.data.tag || 'span';
        var map = Object.create(null);
        var prevChildren = (this.prevChildren = this.children);
        var rawChildren = this.$slots.default || [];
        var children = (this.children = []);
        var transitionData = extractTransitionData(this);
        for (var i = 0; i < rawChildren.length; i++) {
            var c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                }
                else if (false) {
                    var opts = c.componentOptions;
                    var name_1 = opts
                        ? getComponentName(opts.Ctor.options) || opts.tag || ''
                        : c.tag;
                    warn$2("<transition-group> children must be keyed: <".concat(name_1, ">"));
                }
            }
        }
        if (prevChildren) {
            var kept = [];
            var removed = [];
            for (var i = 0; i < prevChildren.length; i++) {
                var c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) {
                    kept.push(c);
                }
                else {
                    removed.push(c);
                }
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated: function () {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || 'v') + '-move';
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
            return;
        }
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach(callPendingCbs);
        children.forEach(recordPosition);
        children.forEach(applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach(function (c) {
            if (c.data.moved) {
                var el_1 = c.elm;
                var s = el_1.style;
                addTransitionClass(el_1, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = '';
                el_1.addEventListener(transitionEndEvent, (el_1._moveCb = function cb(e) {
                    if (e && e.target !== el_1) {
                        return;
                    }
                    if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener(transitionEndEvent, cb);
                        el_1._moveCb = null;
                        removeTransitionClass(el_1, moveClass);
                    }
                }));
            }
        });
    },
    methods: {
        hasMove: function (el, moveClass) {
            /* istanbul ignore if */
            if (!hasTransition) {
                return false;
            }
            /* istanbul ignore if */
            if (this._hasMove) {
                return this._hasMove;
            }
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) {
                el._transitionClasses.forEach(function (cls) {
                    removeClass(clone, cls);
                });
            }
            addClass(clone, moveClass);
            clone.style.display = 'none';
            this.$el.appendChild(clone);
            var info = getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return (this._hasMove = info.hasTransform);
        }
    }
};
function callPendingCbs(c) {
    /* istanbul ignore if */
    if (c.elm._moveCb) {
        c.elm._moveCb();
    }
    /* istanbul ignore if */
    if (c.elm._enterCb) {
        c.elm._enterCb();
    }
}
function recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = '0s';
    }
}

var platformComponents = {
    Transition: Transition,
    TransitionGroup: TransitionGroup
};

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;
// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);
// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;
// public mount method
Vue.prototype.$mount = function (el, hydrating) {
    el = el && inBrowser ? query(el) : undefined;
    return mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
    setTimeout(function () {
        if (config.devtools) {
            if (devtools) {
                devtools.emit('init', Vue);
            }
            else if (false) {
                // @ts-expect-error
                console[console.info ? 'info' : 'log']('Download the Vue Devtools extension for a better development experience:\n' +
                    'https://github.com/vuejs/vue-devtools');
            }
        }
        if (false) {
            // @ts-expect-error
            console[console.info ? 'info' : 'log']("You are running Vue in development mode.\n" +
                "Make sure to turn on production mode when deploying for production.\n" +
                "See more tips at https://vuejs.org/guide/deployment.html");
        }
    }, 0);
}

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;
var buildRegex = cached(function (delimiters) {
    var open = delimiters[0].replace(regexEscapeRE, '\\$&');
    var close = delimiters[1].replace(regexEscapeRE, '\\$&');
    return new RegExp(open + '((?:.|\\n)+?)' + close, 'g');
});
function parseText(text, delimiters) {
    //@ts-expect-error
    var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
    if (!tagRE.test(text)) {
        return;
    }
    var tokens = [];
    var rawTokens = [];
    var lastIndex = (tagRE.lastIndex = 0);
    var match, index, tokenValue;
    while ((match = tagRE.exec(text))) {
        index = match.index;
        // push text token
        if (index > lastIndex) {
            rawTokens.push((tokenValue = text.slice(lastIndex, index)));
            tokens.push(JSON.stringify(tokenValue));
        }
        // tag token
        var exp = parseFilters(match[1].trim());
        tokens.push("_s(".concat(exp, ")"));
        rawTokens.push({ '@binding': exp });
        lastIndex = index + match[0].length;
    }
    if (lastIndex < text.length) {
        rawTokens.push((tokenValue = text.slice(lastIndex)));
        tokens.push(JSON.stringify(tokenValue));
    }
    return {
        expression: tokens.join('+'),
        tokens: rawTokens
    };
}

function transformNode$1(el, options) {
    var warn = options.warn || baseWarn;
    var staticClass = getAndRemoveAttr(el, 'class');
    if (false) {
        var res = parseText(staticClass, options.delimiters);
        if (res) {
            warn("class=\"".concat(staticClass, "\": ") +
                'Interpolation inside attributes has been removed. ' +
                'Use v-bind or the colon shorthand instead. For example, ' +
                'instead of <div class="{{ val }}">, use <div :class="val">.', el.rawAttrsMap['class']);
        }
    }
    if (staticClass) {
        el.staticClass = JSON.stringify(staticClass.replace(/\s+/g, ' ').trim());
    }
    var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
    if (classBinding) {
        el.classBinding = classBinding;
    }
}
function genData$2(el) {
    var data = '';
    if (el.staticClass) {
        data += "staticClass:".concat(el.staticClass, ",");
    }
    if (el.classBinding) {
        data += "class:".concat(el.classBinding, ",");
    }
    return data;
}
var klass = {
    staticKeys: ['staticClass'],
    transformNode: transformNode$1,
    genData: genData$2
};

function transformNode(el, options) {
    var warn = options.warn || baseWarn;
    var staticStyle = getAndRemoveAttr(el, 'style');
    if (staticStyle) {
        /* istanbul ignore if */
        if (false) {
            var res = parseText(staticStyle, options.delimiters);
            if (res) {
                warn("style=\"".concat(staticStyle, "\": ") +
                    'Interpolation inside attributes has been removed. ' +
                    'Use v-bind or the colon shorthand instead. For example, ' +
                    'instead of <div style="{{ val }}">, use <div :style="val">.', el.rawAttrsMap['style']);
            }
        }
        el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
    }
    var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
    if (styleBinding) {
        el.styleBinding = styleBinding;
    }
}
function genData$1(el) {
    var data = '';
    if (el.staticStyle) {
        data += "staticStyle:".concat(el.staticStyle, ",");
    }
    if (el.styleBinding) {
        data += "style:(".concat(el.styleBinding, "),");
    }
    return data;
}
var style = {
    staticKeys: ['staticStyle'],
    transformNode: transformNode,
    genData: genData$1
};

var decoder;
var he = {
    decode: function (html) {
        decoder = decoder || document.createElement('div');
        decoder.innerHTML = html;
        return decoder.textContent;
    }
};

var isUnaryTag = makeMap('area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
    'link,meta,param,source,track,wbr');
// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap('colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source');
// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap('address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
    'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
    'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
    'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
    'title,tr,track');

/**
 * Not type-checking this file because it's mostly vendor code.
 */
// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z".concat(unicodeRegExp.source, "]*");
var qnameCapture = "((?:".concat(ncname, "\\:)?").concat(ncname, ")");
var startTagOpen = new RegExp("^<".concat(qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp("^<\\/".concat(qnameCapture, "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;
// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};
var decodingMap = {
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&amp;': '&',
    '&#10;': '\n',
    '&#9;': '\t',
    '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;
// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) {
    return tag && isIgnoreNewlineTag(tag) && html[0] === '\n';
};
function decodeAttr(value, shouldDecodeNewlines) {
    var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
    return value.replace(re, function (match) { return decodingMap[match]; });
}
function parseHTML(html, options) {
    var stack = [];
    var expectHTML = options.expectHTML;
    var isUnaryTag = options.isUnaryTag || no;
    var canBeLeftOpenTag = options.canBeLeftOpenTag || no;
    var index = 0;
    var last, lastTag;
    var _loop_1 = function () {
        last = html;
        // Make sure we're not in a plaintext content element like script/style
        if (!lastTag || !isPlainTextElement(lastTag)) {
            var textEnd = html.indexOf('<');
            if (textEnd === 0) {
                // Comment:
                if (comment.test(html)) {
                    var commentEnd = html.indexOf('-->');
                    if (commentEnd >= 0) {
                        if (options.shouldKeepComment && options.comment) {
                            options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
                        }
                        advance(commentEnd + 3);
                        return "continue";
                    }
                }
                // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
                if (conditionalComment.test(html)) {
                    var conditionalEnd = html.indexOf(']>');
                    if (conditionalEnd >= 0) {
                        advance(conditionalEnd + 2);
                        return "continue";
                    }
                }
                // Doctype:
                var doctypeMatch = html.match(doctype);
                if (doctypeMatch) {
                    advance(doctypeMatch[0].length);
                    return "continue";
                }
                // End tag:
                var endTagMatch = html.match(endTag);
                if (endTagMatch) {
                    var curIndex = index;
                    advance(endTagMatch[0].length);
                    parseEndTag(endTagMatch[1], curIndex, index);
                    return "continue";
                }
                // Start tag:
                var startTagMatch = parseStartTag();
                if (startTagMatch) {
                    handleStartTag(startTagMatch);
                    if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
                        advance(1);
                    }
                    return "continue";
                }
            }
            var text = void 0, rest = void 0, next = void 0;
            if (textEnd >= 0) {
                rest = html.slice(textEnd);
                while (!endTag.test(rest) &&
                    !startTagOpen.test(rest) &&
                    !comment.test(rest) &&
                    !conditionalComment.test(rest)) {
                    // < in plain text, be forgiving and treat it as text
                    next = rest.indexOf('<', 1);
                    if (next < 0)
                        break;
                    textEnd += next;
                    rest = html.slice(textEnd);
                }
                text = html.substring(0, textEnd);
            }
            if (textEnd < 0) {
                text = html;
            }
            if (text) {
                advance(text.length);
            }
            if (options.chars && text) {
                options.chars(text, index - text.length, index);
            }
        }
        else {
            var endTagLength_1 = 0;
            var stackedTag_1 = lastTag.toLowerCase();
            var reStackedTag = reCache[stackedTag_1] ||
                (reCache[stackedTag_1] = new RegExp('([\\s\\S]*?)(</' + stackedTag_1 + '[^>]*>)', 'i'));
            var rest = html.replace(reStackedTag, function (all, text, endTag) {
                endTagLength_1 = endTag.length;
                if (!isPlainTextElement(stackedTag_1) && stackedTag_1 !== 'noscript') {
                    text = text
                        .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
                        .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
                }
                if (shouldIgnoreFirstNewline(stackedTag_1, text)) {
                    text = text.slice(1);
                }
                if (options.chars) {
                    options.chars(text);
                }
                return '';
            });
            index += html.length - rest.length;
            html = rest;
            parseEndTag(stackedTag_1, index - endTagLength_1, index);
        }
        if (html === last) {
            options.chars && options.chars(html);
            if (false) {
                options.warn("Mal-formatted tag at end of template: \"".concat(html, "\""), {
                    start: index + html.length
                });
            }
            return "break";
        }
    };
    while (html) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
    // Clean up any remaining tags
    parseEndTag();
    function advance(n) {
        index += n;
        html = html.substring(n);
    }
    function parseStartTag() {
        var start = html.match(startTagOpen);
        if (start) {
            var match = {
                tagName: start[1],
                attrs: [],
                start: index
            };
            advance(start[0].length);
            var end = void 0, attr = void 0;
            while (!(end = html.match(startTagClose)) &&
                (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
                attr.start = index;
                advance(attr[0].length);
                attr.end = index;
                match.attrs.push(attr);
            }
            if (end) {
                match.unarySlash = end[1];
                advance(end[0].length);
                match.end = index;
                return match;
            }
        }
    }
    function handleStartTag(match) {
        var tagName = match.tagName;
        var unarySlash = match.unarySlash;
        if (expectHTML) {
            if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
                parseEndTag(lastTag);
            }
            if (canBeLeftOpenTag(tagName) && lastTag === tagName) {
                parseEndTag(tagName);
            }
        }
        var unary = isUnaryTag(tagName) || !!unarySlash;
        var l = match.attrs.length;
        var attrs = new Array(l);
        for (var i = 0; i < l; i++) {
            var args = match.attrs[i];
            var value = args[3] || args[4] || args[5] || '';
            var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
                ? options.shouldDecodeNewlinesForHref
                : options.shouldDecodeNewlines;
            attrs[i] = {
                name: args[1],
                value: decodeAttr(value, shouldDecodeNewlines)
            };
            if (false) {
                attrs[i].start = args.start + args[0].match(/^\s*/).length;
                attrs[i].end = args.end;
            }
        }
        if (!unary) {
            stack.push({
                tag: tagName,
                lowerCasedTag: tagName.toLowerCase(),
                attrs: attrs,
                start: match.start,
                end: match.end
            });
            lastTag = tagName;
        }
        if (options.start) {
            options.start(tagName, attrs, unary, match.start, match.end);
        }
    }
    function parseEndTag(tagName, start, end) {
        var pos, lowerCasedTagName;
        if (start == null)
            start = index;
        if (end == null)
            end = index;
        // Find the closest opened tag of the same type
        if (tagName) {
            lowerCasedTagName = tagName.toLowerCase();
            for (pos = stack.length - 1; pos >= 0; pos--) {
                if (stack[pos].lowerCasedTag === lowerCasedTagName) {
                    break;
                }
            }
        }
        else {
            // If no tag name is provided, clean shop
            pos = 0;
        }
        if (pos >= 0) {
            // Close all the open elements, up the stack
            for (var i = stack.length - 1; i >= pos; i--) {
                if (false) {
                    options.warn("tag <".concat(stack[i].tag, "> has no matching end tag."), {
                        start: stack[i].start,
                        end: stack[i].end
                    });
                }
                if (options.end) {
                    options.end(stack[i].tag, start, end);
                }
            }
            // Remove the open elements from the stack
            stack.length = pos;
            lastTag = pos && stack[pos - 1].tag;
        }
        else if (lowerCasedTagName === 'br') {
            if (options.start) {
                options.start(tagName, [], true, start, end);
            }
        }
        else if (lowerCasedTagName === 'p') {
            if (options.start) {
                options.start(tagName, [], false, start, end);
            }
            if (options.end) {
                options.end(tagName, start, end);
            }
        }
    }
}

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;
var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;
var slotRE = /^v-slot(:|$)|^#/;
var lineBreakRE = /[\r\n]/;
var whitespaceRE = /[ \f\t\r\n]+/g;
var invalidAttributeRE = /[\s"'<>\/=]/;
var decodeHTMLCached = cached(he.decode);
var emptySlotScopeToken = "_empty_";
// configurable state
var warn;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;
function createASTElement(tag, attrs, parent) {
    return {
        type: 1,
        tag: tag,
        attrsList: attrs,
        attrsMap: makeAttrsMap(attrs),
        rawAttrsMap: {},
        parent: parent,
        children: []
    };
}
/**
 * Convert HTML string to AST.
 */
function parse(template, options) {
    warn = options.warn || baseWarn;
    platformIsPreTag = options.isPreTag || no;
    platformMustUseProp = options.mustUseProp || no;
    platformGetTagNamespace = options.getTagNamespace || no;
    var isReservedTag = options.isReservedTag || no;
    maybeComponent = function (el) {
        return !!(el.component ||
            el.attrsMap[':is'] ||
            el.attrsMap['v-bind:is'] ||
            !(el.attrsMap.is ? isReservedTag(el.attrsMap.is) : isReservedTag(el.tag)));
    };
    transforms = pluckModuleFunction(options.modules, 'transformNode');
    preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
    postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');
    delimiters = options.delimiters;
    var stack = [];
    var preserveWhitespace = options.preserveWhitespace !== false;
    var whitespaceOption = options.whitespace;
    var root;
    var currentParent;
    var inVPre = false;
    var inPre = false;
    var warned = false;
    function warnOnce(msg, range) {
        if (!warned) {
            warned = true;
            warn(msg, range);
        }
    }
    function closeElement(element) {
        trimEndingWhitespace(element);
        if (!inVPre && !element.processed) {
            element = processElement(element, options);
        }
        // tree management
        if (!stack.length && element !== root) {
            // allow root elements with v-if, v-else-if and v-else
            if (root.if && (element.elseif || element.else)) {
                if (false) {
                    checkRootConstraints(element);
                }
                addIfCondition(root, {
                    exp: element.elseif,
                    block: element
                });
            }
            else if (false) {
                warnOnce("Component template should contain exactly one root element. " +
                    "If you are using v-if on multiple elements, " +
                    "use v-else-if to chain them instead.", { start: element.start });
            }
        }
        if (currentParent && !element.forbidden) {
            if (element.elseif || element.else) {
                processIfConditions(element, currentParent);
            }
            else {
                if (element.slotScope) {
                    // scoped slot
                    // keep it in the children list so that v-else(-if) conditions can
                    // find it as the prev node.
                    var name_1 = element.slotTarget || '"default"';
                    (currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name_1] = element;
                }
                currentParent.children.push(element);
                element.parent = currentParent;
            }
        }
        // final children cleanup
        // filter out scoped slots
        element.children = element.children.filter(function (c) { return !c.slotScope; });
        // remove trailing whitespace node again
        trimEndingWhitespace(element);
        // check pre state
        if (element.pre) {
            inVPre = false;
        }
        if (platformIsPreTag(element.tag)) {
            inPre = false;
        }
        // apply post-transforms
        for (var i = 0; i < postTransforms.length; i++) {
            postTransforms[i](element, options);
        }
    }
    function trimEndingWhitespace(el) {
        // remove trailing whitespace node
        if (!inPre) {
            var lastNode = void 0;
            while ((lastNode = el.children[el.children.length - 1]) &&
                lastNode.type === 3 &&
                lastNode.text === ' ') {
                el.children.pop();
            }
        }
    }
    function checkRootConstraints(el) {
        if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce("Cannot use <".concat(el.tag, "> as component root element because it may ") +
                'contain multiple nodes.', { start: el.start });
        }
        if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce('Cannot use v-for on stateful component root element because ' +
                'it renders multiple elements.', el.rawAttrsMap['v-for']);
        }
    }
    parseHTML(template, {
        warn: warn,
        expectHTML: options.expectHTML,
        isUnaryTag: options.isUnaryTag,
        canBeLeftOpenTag: options.canBeLeftOpenTag,
        shouldDecodeNewlines: options.shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
        shouldKeepComment: options.comments,
        outputSourceRange: options.outputSourceRange,
        start: function (tag, attrs, unary, start, end) {
            // check namespace.
            // inherit parent ns if there is one
            var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);
            // handle IE svg bug
            /* istanbul ignore if */
            if (isIE && ns === 'svg') {
                attrs = guardIESVGBug(attrs);
            }
            var element = createASTElement(tag, attrs, currentParent);
            if (ns) {
                element.ns = ns;
            }
            if (false) {
                if (options.outputSourceRange) {
                    element.start = start;
                    element.end = end;
                    element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
                        cumulated[attr.name] = attr;
                        return cumulated;
                    }, {});
                }
                attrs.forEach(function (attr) {
                    if (invalidAttributeRE.test(attr.name)) {
                        warn("Invalid dynamic argument expression: attribute names cannot contain " +
                            "spaces, quotes, <, >, / or =.", options.outputSourceRange
                            ? {
                                start: attr.start + attr.name.indexOf("["),
                                end: attr.start + attr.name.length
                            }
                            : undefined);
                    }
                });
            }
            if (isForbiddenTag(element) && !isServerRendering()) {
                element.forbidden = true;
                "production" !== 'production' &&
                    warn('Templates should only be responsible for mapping the state to the ' +
                        'UI. Avoid placing tags with side-effects in your templates, such as ' +
                        "<".concat(tag, ">") +
                        ', as they will not be parsed.', { start: element.start });
            }
            // apply pre-transforms
            for (var i = 0; i < preTransforms.length; i++) {
                element = preTransforms[i](element, options) || element;
            }
            if (!inVPre) {
                processPre(element);
                if (element.pre) {
                    inVPre = true;
                }
            }
            if (platformIsPreTag(element.tag)) {
                inPre = true;
            }
            if (inVPre) {
                processRawAttrs(element);
            }
            else if (!element.processed) {
                // structural directives
                processFor(element);
                processIf(element);
                processOnce(element);
            }
            if (!root) {
                root = element;
                if (false) {
                    checkRootConstraints(root);
                }
            }
            if (!unary) {
                currentParent = element;
                stack.push(element);
            }
            else {
                closeElement(element);
            }
        },
        end: function (tag, start, end) {
            var element = stack[stack.length - 1];
            // pop stack
            stack.length -= 1;
            currentParent = stack[stack.length - 1];
            if (false) {
                element.end = end;
            }
            closeElement(element);
        },
        chars: function (text, start, end) {
            if (!currentParent) {
                if (false) {
                    if (text === template) {
                        warnOnce('Component template requires a root element, rather than just text.', { start: start });
                    }
                    else if ((text = text.trim())) {
                        warnOnce("text \"".concat(text, "\" outside root element will be ignored."), {
                            start: start
                        });
                    }
                }
                return;
            }
            // IE textarea placeholder bug
            /* istanbul ignore if */
            if (isIE &&
                currentParent.tag === 'textarea' &&
                currentParent.attrsMap.placeholder === text) {
                return;
            }
            var children = currentParent.children;
            if (inPre || text.trim()) {
                text = isTextTag(currentParent)
                    ? text
                    : decodeHTMLCached(text);
            }
            else if (!children.length) {
                // remove the whitespace-only node right after an opening tag
                text = '';
            }
            else if (whitespaceOption) {
                if (whitespaceOption === 'condense') {
                    // in condense mode, remove the whitespace node if it contains
                    // line break, otherwise condense to a single space
                    text = lineBreakRE.test(text) ? '' : ' ';
                }
                else {
                    text = ' ';
                }
            }
            else {
                text = preserveWhitespace ? ' ' : '';
            }
            if (text) {
                if (!inPre && whitespaceOption === 'condense') {
                    // condense consecutive whitespaces into single space
                    text = text.replace(whitespaceRE, ' ');
                }
                var res = void 0;
                var child = void 0;
                if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
                    child = {
                        type: 2,
                        expression: res.expression,
                        tokens: res.tokens,
                        text: text
                    };
                }
                else if (text !== ' ' ||
                    !children.length ||
                    children[children.length - 1].text !== ' ') {
                    child = {
                        type: 3,
                        text: text
                    };
                }
                if (child) {
                    if (false) {
                        child.start = start;
                        child.end = end;
                    }
                    children.push(child);
                }
            }
        },
        comment: function (text, start, end) {
            // adding anything as a sibling to the root node is forbidden
            // comments should still be allowed, but ignored
            if (currentParent) {
                var child = {
                    type: 3,
                    text: text,
                    isComment: true
                };
                if (false) {
                    child.start = start;
                    child.end = end;
                }
                currentParent.children.push(child);
            }
        }
    });
    return root;
}
function processPre(el) {
    if (getAndRemoveAttr(el, 'v-pre') != null) {
        el.pre = true;
    }
}
function processRawAttrs(el) {
    var list = el.attrsList;
    var len = list.length;
    if (len) {
        var attrs = (el.attrs = new Array(len));
        for (var i = 0; i < len; i++) {
            attrs[i] = {
                name: list[i].name,
                value: JSON.stringify(list[i].value)
            };
            if (list[i].start != null) {
                attrs[i].start = list[i].start;
                attrs[i].end = list[i].end;
            }
        }
    }
    else if (!el.pre) {
        // non root node in pre blocks with no attributes
        el.plain = true;
    }
}
function processElement(element, options) {
    processKey(element);
    // determine whether this is a plain element after
    // removing structural attributes
    element.plain =
        !element.key && !element.scopedSlots && !element.attrsList.length;
    processRef(element);
    processSlotContent(element);
    processSlotOutlet(element);
    processComponent(element);
    for (var i = 0; i < transforms.length; i++) {
        element = transforms[i](element, options) || element;
    }
    processAttrs(element);
    return element;
}
function processKey(el) {
    var exp = getBindingAttr(el, 'key');
    if (exp) {
        if (false) {
            if (el.tag === 'template') {
                warn("<template> cannot be keyed. Place the key on real elements instead.", getRawBindingAttr(el, 'key'));
            }
            if (el.for) {
                var iterator = el.iterator2 || el.iterator1;
                var parent_1 = el.parent;
                if (iterator &&
                    iterator === exp &&
                    parent_1 &&
                    parent_1.tag === 'transition-group') {
                    warn("Do not use v-for index as key on <transition-group> children, " +
                        "this is the same as not using keys.", getRawBindingAttr(el, 'key'), true /* tip */);
                }
            }
        }
        el.key = exp;
    }
}
function processRef(el) {
    var ref = getBindingAttr(el, 'ref');
    if (ref) {
        el.ref = ref;
        el.refInFor = checkInFor(el);
    }
}
function processFor(el) {
    var exp;
    if ((exp = getAndRemoveAttr(el, 'v-for'))) {
        var res = parseFor(exp);
        if (res) {
            extend(el, res);
        }
        else if (false) {
            warn("Invalid v-for expression: ".concat(exp), el.rawAttrsMap['v-for']);
        }
    }
}
function parseFor(exp) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch)
        return;
    var res = {};
    res.for = inMatch[2].trim();
    var alias = inMatch[1].trim().replace(stripParensRE, '');
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
        res.alias = alias.replace(forIteratorRE, '').trim();
        res.iterator1 = iteratorMatch[1].trim();
        if (iteratorMatch[2]) {
            res.iterator2 = iteratorMatch[2].trim();
        }
    }
    else {
        res.alias = alias;
    }
    return res;
}
function processIf(el) {
    var exp = getAndRemoveAttr(el, 'v-if');
    if (exp) {
        el.if = exp;
        addIfCondition(el, {
            exp: exp,
            block: el
        });
    }
    else {
        if (getAndRemoveAttr(el, 'v-else') != null) {
            el.else = true;
        }
        var elseif = getAndRemoveAttr(el, 'v-else-if');
        if (elseif) {
            el.elseif = elseif;
        }
    }
}
function processIfConditions(el, parent) {
    var prev = findPrevElement(parent.children);
    if (prev && prev.if) {
        addIfCondition(prev, {
            exp: el.elseif,
            block: el
        });
    }
    else if (false) {
        warn("v-".concat(el.elseif ? 'else-if="' + el.elseif + '"' : 'else', " ") +
            "used on element <".concat(el.tag, "> without corresponding v-if."), el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']);
    }
}
function findPrevElement(children) {
    var i = children.length;
    while (i--) {
        if (children[i].type === 1) {
            return children[i];
        }
        else {
            if (false) {
                warn("text \"".concat(children[i].text.trim(), "\" between v-if and v-else(-if) ") +
                    "will be ignored.", children[i]);
            }
            children.pop();
        }
    }
}
function addIfCondition(el, condition) {
    if (!el.ifConditions) {
        el.ifConditions = [];
    }
    el.ifConditions.push(condition);
}
function processOnce(el) {
    var once = getAndRemoveAttr(el, 'v-once');
    if (once != null) {
        el.once = true;
    }
}
// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent(el) {
    var slotScope;
    if (el.tag === 'template') {
        slotScope = getAndRemoveAttr(el, 'scope');
        /* istanbul ignore if */
        if (false) {
            warn("the \"scope\" attribute for scoped slots have been deprecated and " +
                "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
                "can also be used on plain elements in addition to <template> to " +
                "denote scoped slots.", el.rawAttrsMap['scope'], true);
        }
        el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    }
    else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
        /* istanbul ignore if */
        if (false) {
            warn("Ambiguous combined usage of slot-scope and v-for on <".concat(el.tag, "> ") +
                "(v-for takes higher priority). Use a wrapper <template> for the " +
                "scoped slot to make it clearer.", el.rawAttrsMap['slot-scope'], true);
        }
        el.slotScope = slotScope;
    }
    // slot="xxx"
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
        el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
        el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
        // preserve slot as an attribute for native shadow DOM compat
        // only for non-scoped slots.
        if (el.tag !== 'template' && !el.slotScope) {
            addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
        }
    }
    // 2.6 v-slot syntax
    {
        if (el.tag === 'template') {
            // v-slot on <template>
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (el.slotTarget || el.slotScope) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.parent && !maybeComponent(el.parent)) {
                        warn("<template v-slot> can only appear at the root level inside " +
                            "the receiving component", el);
                    }
                }
                var _a = getSlotName(slotBinding), name_2 = _a.name, dynamic = _a.dynamic;
                el.slotTarget = name_2;
                el.slotTargetDynamic = dynamic;
                el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
            }
        }
        else {
            // v-slot on component, denotes default slot
            var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
            if (slotBinding) {
                if (false) {
                    if (!maybeComponent(el)) {
                        warn("v-slot can only be used on components or <template>.", slotBinding);
                    }
                    if (el.slotScope || el.slotTarget) {
                        warn("Unexpected mixed usage of different slot syntaxes.", el);
                    }
                    if (el.scopedSlots) {
                        warn("To avoid scope ambiguity, the default slot should also use " +
                            "<template> syntax when there are other named slots.", slotBinding);
                    }
                }
                // add the component's children to its default slot
                var slots = el.scopedSlots || (el.scopedSlots = {});
                var _b = getSlotName(slotBinding), name_3 = _b.name, dynamic = _b.dynamic;
                var slotContainer_1 = (slots[name_3] = createASTElement('template', [], el));
                slotContainer_1.slotTarget = name_3;
                slotContainer_1.slotTargetDynamic = dynamic;
                slotContainer_1.children = el.children.filter(function (c) {
                    if (!c.slotScope) {
                        c.parent = slotContainer_1;
                        return true;
                    }
                });
                slotContainer_1.slotScope = slotBinding.value || emptySlotScopeToken;
                // remove children as they are returned from scopedSlots now
                el.children = [];
                // mark el non-plain so data gets generated
                el.plain = false;
            }
        }
    }
}
function getSlotName(binding) {
    var name = binding.name.replace(slotRE, '');
    if (!name) {
        if (binding.name[0] !== '#') {
            name = 'default';
        }
        else if (false) {
            warn("v-slot shorthand syntax requires a slot name.", binding);
        }
    }
    return dynamicArgRE.test(name)
        ? // dynamic [name]
            { name: name.slice(1, -1), dynamic: true }
        : // static name
            { name: "\"".concat(name, "\""), dynamic: false };
}
// handle <slot/> outlets
function processSlotOutlet(el) {
    if (el.tag === 'slot') {
        el.slotName = getBindingAttr(el, 'name');
        if (false) {
            warn("`key` does not work on <slot> because slots are abstract outlets " +
                "and can possibly expand into multiple elements. " +
                "Use the key on a wrapping element instead.", getRawBindingAttr(el, 'key'));
        }
    }
}
function processComponent(el) {
    var binding;
    if ((binding = getBindingAttr(el, 'is'))) {
        el.component = binding;
    }
    if (getAndRemoveAttr(el, 'inline-template') != null) {
        el.inlineTemplate = true;
    }
}
function processAttrs(el) {
    var list = el.attrsList;
    var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
    for (i = 0, l = list.length; i < l; i++) {
        name = rawName = list[i].name;
        value = list[i].value;
        if (dirRE.test(name)) {
            // mark element as dynamic
            el.hasBindings = true;
            // modifiers
            modifiers = parseModifiers(name.replace(dirRE, ''));
            // support .foo shorthand syntax for the .prop modifier
            if (modifiers) {
                name = name.replace(modifierRE, '');
            }
            if (bindRE.test(name)) {
                // v-bind
                name = name.replace(bindRE, '');
                value = parseFilters(value);
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                if (false) {
                    warn("The value for a v-bind expression cannot be empty. Found in \"v-bind:".concat(name, "\""));
                }
                if (modifiers) {
                    if (modifiers.prop && !isDynamic) {
                        name = camelize(name);
                        if (name === 'innerHtml')
                            name = 'innerHTML';
                    }
                    if (modifiers.camel && !isDynamic) {
                        name = camelize(name);
                    }
                    if (modifiers.sync) {
                        syncGen = genAssignmentCode(value, "$event");
                        if (!isDynamic) {
                            addHandler(el, "update:".concat(camelize(name)), syncGen, null, false, warn, list[i]);
                            if (hyphenate(name) !== camelize(name)) {
                                addHandler(el, "update:".concat(hyphenate(name)), syncGen, null, false, warn, list[i]);
                            }
                        }
                        else {
                            // handler w/ dynamic event name
                            addHandler(el, "\"update:\"+(".concat(name, ")"), syncGen, null, false, warn, list[i], true // dynamic
                            );
                        }
                    }
                }
                if ((modifiers && modifiers.prop) ||
                    (!el.component && platformMustUseProp(el.tag, el.attrsMap.type, name))) {
                    addProp(el, name, value, list[i], isDynamic);
                }
                else {
                    addAttr(el, name, value, list[i], isDynamic);
                }
            }
            else if (onRE.test(name)) {
                // v-on
                name = name.replace(onRE, '');
                isDynamic = dynamicArgRE.test(name);
                if (isDynamic) {
                    name = name.slice(1, -1);
                }
                addHandler(el, name, value, modifiers, false, warn, list[i], isDynamic);
            }
            else {
                // normal directives
                name = name.replace(dirRE, '');
                // parse arg
                var argMatch = name.match(argRE);
                var arg = argMatch && argMatch[1];
                isDynamic = false;
                if (arg) {
                    name = name.slice(0, -(arg.length + 1));
                    if (dynamicArgRE.test(arg)) {
                        arg = arg.slice(1, -1);
                        isDynamic = true;
                    }
                }
                addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
                if (false) {
                    checkForAliasModel(el, value);
                }
            }
        }
        else {
            // literal attribute
            if (false) {
                var res = parseText(value, delimiters);
                if (res) {
                    warn("".concat(name, "=\"").concat(value, "\": ") +
                        'Interpolation inside attributes has been removed. ' +
                        'Use v-bind or the colon shorthand instead. For example, ' +
                        'instead of <div id="{{ val }}">, use <div :id="val">.', list[i]);
                }
            }
            addAttr(el, name, JSON.stringify(value), list[i]);
            // #6887 firefox doesn't update muted state if set via attribute
            // even immediately after element creation
            if (!el.component &&
                name === 'muted' &&
                platformMustUseProp(el.tag, el.attrsMap.type, name)) {
                addProp(el, name, 'true', list[i]);
            }
        }
    }
}
function checkInFor(el) {
    var parent = el;
    while (parent) {
        if (parent.for !== undefined) {
            return true;
        }
        parent = parent.parent;
    }
    return false;
}
function parseModifiers(name) {
    var match = name.match(modifierRE);
    if (match) {
        var ret_1 = {};
        match.forEach(function (m) {
            ret_1[m.slice(1)] = true;
        });
        return ret_1;
    }
}
function makeAttrsMap(attrs) {
    var map = {};
    for (var i = 0, l = attrs.length; i < l; i++) {
        if (false) {
            warn('duplicate attribute: ' + attrs[i].name, attrs[i]);
        }
        map[attrs[i].name] = attrs[i].value;
    }
    return map;
}
// for script (e.g. type="x/template") or style, do not decode content
function isTextTag(el) {
    return el.tag === 'script' || el.tag === 'style';
}
function isForbiddenTag(el) {
    return (el.tag === 'style' ||
        (el.tag === 'script' &&
            (!el.attrsMap.type || el.attrsMap.type === 'text/javascript')));
}
var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;
/* istanbul ignore next */
function guardIESVGBug(attrs) {
    var res = [];
    for (var i = 0; i < attrs.length; i++) {
        var attr = attrs[i];
        if (!ieNSBug.test(attr.name)) {
            attr.name = attr.name.replace(ieNSPrefix, '');
            res.push(attr);
        }
    }
    return res;
}
function checkForAliasModel(el, value) {
    var _el = el;
    while (_el) {
        if (_el.for && _el.alias === value) {
            warn("<".concat(el.tag, " v-model=\"").concat(value, "\">: ") +
                "You are binding v-model directly to a v-for iteration alias. " +
                "This will not be able to modify the v-for source array because " +
                "writing to the alias is like modifying a function local variable. " +
                "Consider using an array of objects and use v-model on an object property instead.", el.rawAttrsMap['v-model']);
        }
        _el = _el.parent;
    }
}

/**
 * Expand input[v-model] with dynamic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */
function preTransformNode(el, options) {
    if (el.tag === 'input') {
        var map = el.attrsMap;
        if (!map['v-model']) {
            return;
        }
        var typeBinding = void 0;
        if (map[':type'] || map['v-bind:type']) {
            typeBinding = getBindingAttr(el, 'type');
        }
        if (!map.type && !typeBinding && map['v-bind']) {
            typeBinding = "(".concat(map['v-bind'], ").type");
        }
        if (typeBinding) {
            var ifCondition = getAndRemoveAttr(el, 'v-if', true);
            var ifConditionExtra = ifCondition ? "&&(".concat(ifCondition, ")") : "";
            var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
            var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
            // 1. checkbox
            var branch0 = cloneASTElement(el);
            // process for on the main node
            processFor(branch0);
            addRawAttr(branch0, 'type', 'checkbox');
            processElement(branch0, options);
            branch0.processed = true; // prevent it from double-processed
            branch0.if = "(".concat(typeBinding, ")==='checkbox'") + ifConditionExtra;
            addIfCondition(branch0, {
                exp: branch0.if,
                block: branch0
            });
            // 2. add radio else-if condition
            var branch1 = cloneASTElement(el);
            getAndRemoveAttr(branch1, 'v-for', true);
            addRawAttr(branch1, 'type', 'radio');
            processElement(branch1, options);
            addIfCondition(branch0, {
                exp: "(".concat(typeBinding, ")==='radio'") + ifConditionExtra,
                block: branch1
            });
            // 3. other
            var branch2 = cloneASTElement(el);
            getAndRemoveAttr(branch2, 'v-for', true);
            addRawAttr(branch2, ':type', typeBinding);
            processElement(branch2, options);
            addIfCondition(branch0, {
                exp: ifCondition,
                block: branch2
            });
            if (hasElse) {
                branch0.else = true;
            }
            else if (elseIfCondition) {
                branch0.elseif = elseIfCondition;
            }
            return branch0;
        }
    }
}
function cloneASTElement(el) {
    return createASTElement(el.tag, el.attrsList.slice(), el.parent);
}
var model = {
    preTransformNode: preTransformNode
};

var modules = [klass, style, model];

function text(el, dir) {
    if (dir.value) {
        addProp(el, 'textContent', "_s(".concat(dir.value, ")"), dir);
    }
}

function html(el, dir) {
    if (dir.value) {
        addProp(el, 'innerHTML', "_s(".concat(dir.value, ")"), dir);
    }
}

var directives = {
    model: model$1,
    text: text,
    html: html
};

var baseOptions = {
    expectHTML: true,
    modules: modules,
    directives: directives,
    isPreTag: isPreTag,
    isUnaryTag: isUnaryTag,
    mustUseProp: mustUseProp,
    canBeLeftOpenTag: canBeLeftOpenTag,
    isReservedTag: isReservedTag,
    getTagNamespace: getTagNamespace,
    staticKeys: genStaticKeys$1(modules)
};

var isStaticKey;
var isPlatformReservedTag;
var genStaticKeysCached = cached(genStaticKeys);
/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize(root, options) {
    if (!root)
        return;
    isStaticKey = genStaticKeysCached(options.staticKeys || '');
    isPlatformReservedTag = options.isReservedTag || no;
    // first pass: mark all non-static nodes.
    markStatic(root);
    // second pass: mark static roots.
    markStaticRoots(root, false);
}
function genStaticKeys(keys) {
    return makeMap('type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
        (keys ? ',' + keys : ''));
}
function markStatic(node) {
    node.static = isStatic(node);
    if (node.type === 1) {
        // do not make component slot content static. this avoids
        // 1. components not able to mutate slot nodes
        // 2. static slot content fails for hot-reloading
        if (!isPlatformReservedTag(node.tag) &&
            node.tag !== 'slot' &&
            node.attrsMap['inline-template'] == null) {
            return;
        }
        for (var i = 0, l = node.children.length; i < l; i++) {
            var child = node.children[i];
            markStatic(child);
            if (!child.static) {
                node.static = false;
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                var block = node.ifConditions[i].block;
                markStatic(block);
                if (!block.static) {
                    node.static = false;
                }
            }
        }
    }
}
function markStaticRoots(node, isInFor) {
    if (node.type === 1) {
        if (node.static || node.once) {
            node.staticInFor = isInFor;
        }
        // For a node to qualify as a static root, it should have children that
        // are not just static text. Otherwise the cost of hoisting out will
        // outweigh the benefits and it's better off to just always render it fresh.
        if (node.static &&
            node.children.length &&
            !(node.children.length === 1 && node.children[0].type === 3)) {
            node.staticRoot = true;
            return;
        }
        else {
            node.staticRoot = false;
        }
        if (node.children) {
            for (var i = 0, l = node.children.length; i < l; i++) {
                markStaticRoots(node.children[i], isInFor || !!node.for);
            }
        }
        if (node.ifConditions) {
            for (var i = 1, l = node.ifConditions.length; i < l; i++) {
                markStaticRoots(node.ifConditions[i].block, isInFor);
            }
        }
    }
}
function isStatic(node) {
    if (node.type === 2) {
        // expression
        return false;
    }
    if (node.type === 3) {
        // text
        return true;
    }
    return !!(node.pre ||
        (!node.hasBindings && // no dynamic bindings
            !node.if &&
            !node.for && // not v-if or v-for or v-else
            !isBuiltInTag(node.tag) && // not a built-in
            isPlatformReservedTag(node.tag) && // not a component
            !isDirectChildOfTemplateFor(node) &&
            Object.keys(node).every(isStaticKey)));
}
function isDirectChildOfTemplateFor(node) {
    while (node.parent) {
        node = node.parent;
        if (node.tag !== 'template') {
            return false;
        }
        if (node.for) {
            return true;
        }
    }
    return false;
}

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
// KeyboardEvent.keyCode aliases
var keyCodes = {
    esc: 27,
    tab: 9,
    enter: 13,
    space: 32,
    up: 38,
    left: 37,
    right: 39,
    down: 40,
    delete: [8, 46]
};
// KeyboardEvent.key aliases
var keyNames = {
    // #7880: IE11 and Edge use `Esc` for Escape key name.
    esc: ['Esc', 'Escape'],
    tab: 'Tab',
    enter: 'Enter',
    // #9112: IE11 uses `Spacebar` for Space key name.
    space: [' ', 'Spacebar'],
    // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
    up: ['Up', 'ArrowUp'],
    left: ['Left', 'ArrowLeft'],
    right: ['Right', 'ArrowRight'],
    down: ['Down', 'ArrowDown'],
    // #9112: IE11 uses `Del` for Delete key name.
    delete: ['Backspace', 'Delete', 'Del']
};
// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return "if(".concat(condition, ")return null;"); };
var modifierCode = {
    stop: '$event.stopPropagation();',
    prevent: '$event.preventDefault();',
    self: genGuard("$event.target !== $event.currentTarget"),
    ctrl: genGuard("!$event.ctrlKey"),
    shift: genGuard("!$event.shiftKey"),
    alt: genGuard("!$event.altKey"),
    meta: genGuard("!$event.metaKey"),
    left: genGuard("'button' in $event && $event.button !== 0"),
    middle: genGuard("'button' in $event && $event.button !== 1"),
    right: genGuard("'button' in $event && $event.button !== 2")
};
function genHandlers(events, isNative) {
    var prefix = isNative ? 'nativeOn:' : 'on:';
    var staticHandlers = "";
    var dynamicHandlers = "";
    for (var name_1 in events) {
        var handlerCode = genHandler(events[name_1]);
        //@ts-expect-error
        if (events[name_1] && events[name_1].dynamic) {
            dynamicHandlers += "".concat(name_1, ",").concat(handlerCode, ",");
        }
        else {
            staticHandlers += "\"".concat(name_1, "\":").concat(handlerCode, ",");
        }
    }
    staticHandlers = "{".concat(staticHandlers.slice(0, -1), "}");
    if (dynamicHandlers) {
        return prefix + "_d(".concat(staticHandlers, ",[").concat(dynamicHandlers.slice(0, -1), "])");
    }
    else {
        return prefix + staticHandlers;
    }
}
function genHandler(handler) {
    if (!handler) {
        return 'function(){}';
    }
    if (Array.isArray(handler)) {
        return "[".concat(handler.map(function (handler) { return genHandler(handler); }).join(','), "]");
    }
    var isMethodPath = simplePathRE.test(handler.value);
    var isFunctionExpression = fnExpRE.test(handler.value);
    var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));
    if (!handler.modifiers) {
        if (isMethodPath || isFunctionExpression) {
            return handler.value;
        }
        return "function($event){".concat(isFunctionInvocation ? "return ".concat(handler.value) : handler.value, "}"); // inline statement
    }
    else {
        var code = '';
        var genModifierCode = '';
        var keys = [];
        var _loop_1 = function (key) {
            if (modifierCode[key]) {
                genModifierCode += modifierCode[key];
                // left/right
                if (keyCodes[key]) {
                    keys.push(key);
                }
            }
            else if (key === 'exact') {
                var modifiers_1 = handler.modifiers;
                genModifierCode += genGuard(['ctrl', 'shift', 'alt', 'meta']
                    .filter(function (keyModifier) { return !modifiers_1[keyModifier]; })
                    .map(function (keyModifier) { return "$event.".concat(keyModifier, "Key"); })
                    .join('||'));
            }
            else {
                keys.push(key);
            }
        };
        for (var key in handler.modifiers) {
            _loop_1(key);
        }
        if (keys.length) {
            code += genKeyFilter(keys);
        }
        // Make sure modifiers like prevent and stop get executed after key filtering
        if (genModifierCode) {
            code += genModifierCode;
        }
        var handlerCode = isMethodPath
            ? "return ".concat(handler.value, ".apply(null, arguments)")
            : isFunctionExpression
                ? "return (".concat(handler.value, ").apply(null, arguments)")
                : isFunctionInvocation
                    ? "return ".concat(handler.value)
                    : handler.value;
        return "function($event){".concat(code).concat(handlerCode, "}");
    }
}
function genKeyFilter(keys) {
    return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
        "".concat(keys.map(genFilterCode).join('&&'), ")return null;"));
}
function genFilterCode(key) {
    var keyVal = parseInt(key, 10);
    if (keyVal) {
        return "$event.keyCode!==".concat(keyVal);
    }
    var keyCode = keyCodes[key];
    var keyName = keyNames[key];
    return ("_k($event.keyCode," +
        "".concat(JSON.stringify(key), ",") +
        "".concat(JSON.stringify(keyCode), ",") +
        "$event.key," +
        "".concat(JSON.stringify(keyName)) +
        ")");
}

function on(el, dir) {
    if (false) {
        warn$2("v-on without argument does not support modifiers.");
    }
    el.wrapListeners = function (code) { return "_g(".concat(code, ",").concat(dir.value, ")"); };
}

function bind(el, dir) {
    el.wrapData = function (code) {
        return "_b(".concat(code, ",'").concat(el.tag, "',").concat(dir.value, ",").concat(dir.modifiers && dir.modifiers.prop ? 'true' : 'false').concat(dir.modifiers && dir.modifiers.sync ? ',true' : '', ")");
    };
}

var baseDirectives = {
    on: on,
    bind: bind,
    cloak: noop
};

var CodegenState = /** @class */ (function () {
    function CodegenState(options) {
        this.options = options;
        this.warn = options.warn || baseWarn;
        this.transforms = pluckModuleFunction(options.modules, 'transformCode');
        this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
        this.directives = extend(extend({}, baseDirectives), options.directives);
        var isReservedTag = options.isReservedTag || no;
        this.maybeComponent = function (el) {
            return !!el.component || !isReservedTag(el.tag);
        };
        this.onceId = 0;
        this.staticRenderFns = [];
        this.pre = false;
    }
    return CodegenState;
}());
function generate(ast, options) {
    var state = new CodegenState(options);
    // fix #11483, Root level <script> tags should not be rendered.
    var code = ast
        ? ast.tag === 'script'
            ? 'null'
            : genElement(ast, state)
        : '_c("div")';
    return {
        render: "with(this){return ".concat(code, "}"),
        staticRenderFns: state.staticRenderFns
    };
}
function genElement(el, state) {
    if (el.parent) {
        el.pre = el.pre || el.parent.pre;
    }
    if (el.staticRoot && !el.staticProcessed) {
        return genStatic(el, state);
    }
    else if (el.once && !el.onceProcessed) {
        return genOnce(el, state);
    }
    else if (el.for && !el.forProcessed) {
        return genFor(el, state);
    }
    else if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    }
    else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
        return genChildren(el, state) || 'void 0';
    }
    else if (el.tag === 'slot') {
        return genSlot(el, state);
    }
    else {
        // component or element
        var code = void 0;
        if (el.component) {
            code = genComponent(el.component, el, state);
        }
        else {
            var data = void 0;
            var maybeComponent = state.maybeComponent(el);
            if (!el.plain || (el.pre && maybeComponent)) {
                data = genData(el, state);
            }
            var tag 
            // check if this is a component in <script setup>
            = void 0;
            // check if this is a component in <script setup>
            var bindings = state.options.bindings;
            if (maybeComponent && bindings && bindings.__isScriptSetup !== false) {
                tag = checkBindingType(bindings, el.tag);
            }
            if (!tag)
                tag = "'".concat(el.tag, "'");
            var children = el.inlineTemplate ? null : genChildren(el, state, true);
            code = "_c(".concat(tag).concat(data ? ",".concat(data) : '' // data
            ).concat(children ? ",".concat(children) : '' // children
            , ")");
        }
        // module transforms
        for (var i = 0; i < state.transforms.length; i++) {
            code = state.transforms[i](el, code);
        }
        return code;
    }
}
function checkBindingType(bindings, key) {
    var camelName = camelize(key);
    var PascalName = capitalize(camelName);
    var checkType = function (type) {
        if (bindings[key] === type) {
            return key;
        }
        if (bindings[camelName] === type) {
            return camelName;
        }
        if (bindings[PascalName] === type) {
            return PascalName;
        }
    };
    var fromConst = checkType("setup-const" /* BindingTypes.SETUP_CONST */) ||
        checkType("setup-reactive-const" /* BindingTypes.SETUP_REACTIVE_CONST */);
    if (fromConst) {
        return fromConst;
    }
    var fromMaybeRef = checkType("setup-let" /* BindingTypes.SETUP_LET */) ||
        checkType("setup-ref" /* BindingTypes.SETUP_REF */) ||
        checkType("setup-maybe-ref" /* BindingTypes.SETUP_MAYBE_REF */);
    if (fromMaybeRef) {
        return fromMaybeRef;
    }
}
// hoist static sub-trees out
function genStatic(el, state) {
    el.staticProcessed = true;
    // Some elements (templates) need to behave differently inside of a v-pre
    // node.  All pre nodes are static roots, so we can use this as a location to
    // wrap a state change and reset it upon exiting the pre node.
    var originalPreState = state.pre;
    if (el.pre) {
        state.pre = el.pre;
    }
    state.staticRenderFns.push("with(this){return ".concat(genElement(el, state), "}"));
    state.pre = originalPreState;
    return "_m(".concat(state.staticRenderFns.length - 1).concat(el.staticInFor ? ',true' : '', ")");
}
// v-once
function genOnce(el, state) {
    el.onceProcessed = true;
    if (el.if && !el.ifProcessed) {
        return genIf(el, state);
    }
    else if (el.staticInFor) {
        var key = '';
        var parent_1 = el.parent;
        while (parent_1) {
            if (parent_1.for) {
                key = parent_1.key;
                break;
            }
            parent_1 = parent_1.parent;
        }
        if (!key) {
            "production" !== 'production' &&
                state.warn("v-once can only be used inside v-for that is keyed. ", el.rawAttrsMap['v-once']);
            return genElement(el, state);
        }
        return "_o(".concat(genElement(el, state), ",").concat(state.onceId++, ",").concat(key, ")");
    }
    else {
        return genStatic(el, state);
    }
}
function genIf(el, state, altGen, altEmpty) {
    el.ifProcessed = true; // avoid recursion
    return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty);
}
function genIfConditions(conditions, state, altGen, altEmpty) {
    if (!conditions.length) {
        return altEmpty || '_e()';
    }
    var condition = conditions.shift();
    if (condition.exp) {
        return "(".concat(condition.exp, ")?").concat(genTernaryExp(condition.block), ":").concat(genIfConditions(conditions, state, altGen, altEmpty));
    }
    else {
        return "".concat(genTernaryExp(condition.block));
    }
    // v-if with v-once should generate code like (a)?_m(0):_m(1)
    function genTernaryExp(el) {
        return altGen
            ? altGen(el, state)
            : el.once
                ? genOnce(el, state)
                : genElement(el, state);
    }
}
function genFor(el, state, altGen, altHelper) {
    var exp = el.for;
    var alias = el.alias;
    var iterator1 = el.iterator1 ? ",".concat(el.iterator1) : '';
    var iterator2 = el.iterator2 ? ",".concat(el.iterator2) : '';
    if (false) {
        state.warn("<".concat(el.tag, " v-for=\"").concat(alias, " in ").concat(exp, "\">: component lists rendered with ") +
            "v-for should have explicit keys. " +
            "See https://v2.vuejs.org/v2/guide/list.html#key for more info.", el.rawAttrsMap['v-for'], true /* tip */);
    }
    el.forProcessed = true; // avoid recursion
    return ("".concat(altHelper || '_l', "((").concat(exp, "),") +
        "function(".concat(alias).concat(iterator1).concat(iterator2, "){") +
        "return ".concat((altGen || genElement)(el, state)) +
        '})');
}
function genData(el, state) {
    var data = '{';
    // directives first.
    // directives may mutate the el's other properties before they are generated.
    var dirs = genDirectives(el, state);
    if (dirs)
        data += dirs + ',';
    // key
    if (el.key) {
        data += "key:".concat(el.key, ",");
    }
    // ref
    if (el.ref) {
        data += "ref:".concat(el.ref, ",");
    }
    if (el.refInFor) {
        data += "refInFor:true,";
    }
    // pre
    if (el.pre) {
        data += "pre:true,";
    }
    // record original tag name for components using "is" attribute
    if (el.component) {
        data += "tag:\"".concat(el.tag, "\",");
    }
    // module data generation functions
    for (var i = 0; i < state.dataGenFns.length; i++) {
        data += state.dataGenFns[i](el);
    }
    // attributes
    if (el.attrs) {
        data += "attrs:".concat(genProps(el.attrs), ",");
    }
    // DOM props
    if (el.props) {
        data += "domProps:".concat(genProps(el.props), ",");
    }
    // event handlers
    if (el.events) {
        data += "".concat(genHandlers(el.events, false), ",");
    }
    if (el.nativeEvents) {
        data += "".concat(genHandlers(el.nativeEvents, true), ",");
    }
    // slot target
    // only for non-scoped slots
    if (el.slotTarget && !el.slotScope) {
        data += "slot:".concat(el.slotTarget, ",");
    }
    // scoped slots
    if (el.scopedSlots) {
        data += "".concat(genScopedSlots(el, el.scopedSlots, state), ",");
    }
    // component v-model
    if (el.model) {
        data += "model:{value:".concat(el.model.value, ",callback:").concat(el.model.callback, ",expression:").concat(el.model.expression, "},");
    }
    // inline-template
    if (el.inlineTemplate) {
        var inlineTemplate = genInlineTemplate(el, state);
        if (inlineTemplate) {
            data += "".concat(inlineTemplate, ",");
        }
    }
    data = data.replace(/,$/, '') + '}';
    // v-bind dynamic argument wrap
    // v-bind with dynamic arguments must be applied using the same v-bind object
    // merge helper so that class/style/mustUseProp attrs are handled correctly.
    if (el.dynamicAttrs) {
        data = "_b(".concat(data, ",\"").concat(el.tag, "\",").concat(genProps(el.dynamicAttrs), ")");
    }
    // v-bind data wrap
    if (el.wrapData) {
        data = el.wrapData(data);
    }
    // v-on data wrap
    if (el.wrapListeners) {
        data = el.wrapListeners(data);
    }
    return data;
}
function genDirectives(el, state) {
    var dirs = el.directives;
    if (!dirs)
        return;
    var res = 'directives:[';
    var hasRuntime = false;
    var i, l, dir, needRuntime;
    for (i = 0, l = dirs.length; i < l; i++) {
        dir = dirs[i];
        needRuntime = true;
        var gen = state.directives[dir.name];
        if (gen) {
            // compile-time directive that manipulates AST.
            // returns true if it also needs a runtime counterpart.
            needRuntime = !!gen(el, dir, state.warn);
        }
        if (needRuntime) {
            hasRuntime = true;
            res += "{name:\"".concat(dir.name, "\",rawName:\"").concat(dir.rawName, "\"").concat(dir.value
                ? ",value:(".concat(dir.value, "),expression:").concat(JSON.stringify(dir.value))
                : '').concat(dir.arg ? ",arg:".concat(dir.isDynamicArg ? dir.arg : "\"".concat(dir.arg, "\"")) : '').concat(dir.modifiers ? ",modifiers:".concat(JSON.stringify(dir.modifiers)) : '', "},");
        }
    }
    if (hasRuntime) {
        return res.slice(0, -1) + ']';
    }
}
function genInlineTemplate(el, state) {
    var ast = el.children[0];
    if (false) {
        state.warn('Inline-template components must have exactly one child element.', { start: el.start });
    }
    if (ast && ast.type === 1) {
        var inlineRenderFns = generate(ast, state.options);
        return "inlineTemplate:{render:function(){".concat(inlineRenderFns.render, "},staticRenderFns:[").concat(inlineRenderFns.staticRenderFns
            .map(function (code) { return "function(){".concat(code, "}"); })
            .join(','), "]}");
    }
}
function genScopedSlots(el, slots, state) {
    // by default scoped slots are considered "stable", this allows child
    // components with only scoped slots to skip forced updates from parent.
    // but in some cases we have to bail-out of this optimization
    // for example if the slot contains dynamic names, has v-if or v-for on them...
    var needsForceUpdate = el.for ||
        Object.keys(slots).some(function (key) {
            var slot = slots[key];
            return (slot.slotTargetDynamic || slot.if || slot.for || containsSlotChild(slot) // is passing down slot from parent which may be dynamic
            );
        });
    // #9534: if a component with scoped slots is inside a conditional branch,
    // it's possible for the same component to be reused but with different
    // compiled slot content. To avoid that, we generate a unique key based on
    // the generated code of all the slot contents.
    var needsKey = !!el.if;
    // OR when it is inside another scoped slot or v-for (the reactivity may be
    // disconnected due to the intermediate scope variable)
    // #9438, #9506
    // TODO: this can be further optimized by properly analyzing in-scope bindings
    // and skip force updating ones that do not actually use scope variables.
    if (!needsForceUpdate) {
        var parent_2 = el.parent;
        while (parent_2) {
            if ((parent_2.slotScope && parent_2.slotScope !== emptySlotScopeToken) ||
                parent_2.for) {
                needsForceUpdate = true;
                break;
            }
            if (parent_2.if) {
                needsKey = true;
            }
            parent_2 = parent_2.parent;
        }
    }
    var generatedSlots = Object.keys(slots)
        .map(function (key) { return genScopedSlot(slots[key], state); })
        .join(',');
    return "scopedSlots:_u([".concat(generatedSlots, "]").concat(needsForceUpdate ? ",null,true" : "").concat(!needsForceUpdate && needsKey ? ",null,false,".concat(hash(generatedSlots)) : "", ")");
}
function hash(str) {
    var hash = 5381;
    var i = str.length;
    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    return hash >>> 0;
}
function containsSlotChild(el) {
    if (el.type === 1) {
        if (el.tag === 'slot') {
            return true;
        }
        return el.children.some(containsSlotChild);
    }
    return false;
}
function genScopedSlot(el, state) {
    var isLegacySyntax = el.attrsMap['slot-scope'];
    if (el.if && !el.ifProcessed && !isLegacySyntax) {
        return genIf(el, state, genScopedSlot, "null");
    }
    if (el.for && !el.forProcessed) {
        return genFor(el, state, genScopedSlot);
    }
    var slotScope = el.slotScope === emptySlotScopeToken ? "" : String(el.slotScope);
    var fn = "function(".concat(slotScope, "){") +
        "return ".concat(el.tag === 'template'
            ? el.if && isLegacySyntax
                ? "(".concat(el.if, ")?").concat(genChildren(el, state) || 'undefined', ":undefined")
                : genChildren(el, state) || 'undefined'
            : genElement(el, state), "}");
    // reverse proxy v-slot without scope on this.$slots
    var reverseProxy = slotScope ? "" : ",proxy:true";
    return "{key:".concat(el.slotTarget || "\"default\"", ",fn:").concat(fn).concat(reverseProxy, "}");
}
function genChildren(el, state, checkSkip, altGenElement, altGenNode) {
    var children = el.children;
    if (children.length) {
        var el_1 = children[0];
        // optimize single v-for
        if (children.length === 1 &&
            el_1.for &&
            el_1.tag !== 'template' &&
            el_1.tag !== 'slot') {
            var normalizationType_1 = checkSkip
                ? state.maybeComponent(el_1)
                    ? ",1"
                    : ",0"
                : "";
            return "".concat((altGenElement || genElement)(el_1, state)).concat(normalizationType_1);
        }
        var normalizationType = checkSkip
            ? getNormalizationType(children, state.maybeComponent)
            : 0;
        var gen_1 = altGenNode || genNode;
        return "[".concat(children.map(function (c) { return gen_1(c, state); }).join(','), "]").concat(normalizationType ? ",".concat(normalizationType) : '');
    }
}
// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType(children, maybeComponent) {
    var res = 0;
    for (var i = 0; i < children.length; i++) {
        var el = children[i];
        if (el.type !== 1) {
            continue;
        }
        if (needsNormalization(el) ||
            (el.ifConditions &&
                el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
            res = 2;
            break;
        }
        if (maybeComponent(el) ||
            (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
            res = 1;
        }
    }
    return res;
}
function needsNormalization(el) {
    return el.for !== undefined || el.tag === 'template' || el.tag === 'slot';
}
function genNode(node, state) {
    if (node.type === 1) {
        return genElement(node, state);
    }
    else if (node.type === 3 && node.isComment) {
        return genComment(node);
    }
    else {
        return genText(node);
    }
}
function genText(text) {
    return "_v(".concat(text.type === 2
        ? text.expression // no need for () because already wrapped in _s()
        : transformSpecialNewlines(JSON.stringify(text.text)), ")");
}
function genComment(comment) {
    return "_e(".concat(JSON.stringify(comment.text), ")");
}
function genSlot(el, state) {
    var slotName = el.slotName || '"default"';
    var children = genChildren(el, state);
    var res = "_t(".concat(slotName).concat(children ? ",function(){return ".concat(children, "}") : '');
    var attrs = el.attrs || el.dynamicAttrs
        ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
            // slot props are camelized
            name: camelize(attr.name),
            value: attr.value,
            dynamic: attr.dynamic
        }); }))
        : null;
    var bind = el.attrsMap['v-bind'];
    if ((attrs || bind) && !children) {
        res += ",null";
    }
    if (attrs) {
        res += ",".concat(attrs);
    }
    if (bind) {
        res += "".concat(attrs ? '' : ',null', ",").concat(bind);
    }
    return res + ')';
}
// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent(componentName, el, state) {
    var children = el.inlineTemplate ? null : genChildren(el, state, true);
    return "_c(".concat(componentName, ",").concat(genData(el, state)).concat(children ? ",".concat(children) : '', ")");
}
function genProps(props) {
    var staticProps = "";
    var dynamicProps = "";
    for (var i = 0; i < props.length; i++) {
        var prop = props[i];
        var value = transformSpecialNewlines(prop.value);
        if (prop.dynamic) {
            dynamicProps += "".concat(prop.name, ",").concat(value, ",");
        }
        else {
            staticProps += "\"".concat(prop.name, "\":").concat(value, ",");
        }
    }
    staticProps = "{".concat(staticProps.slice(0, -1), "}");
    if (dynamicProps) {
        return "_d(".concat(staticProps, ",[").concat(dynamicProps.slice(0, -1), "])");
    }
    else {
        return staticProps;
    }
}
// #3895, #4268
function transformSpecialNewlines(text) {
    return text.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' +
    ('do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
        'super,throw,while,yield,delete,export,import,return,switch,default,' +
        'extends,finally,continue,debugger,function,arguments')
        .split(',')
        .join('\\b|\\b') +
    '\\b');
// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' +
    'delete,typeof,void'.split(',').join('\\s*\\([^\\)]*\\)|\\b') +
    '\\s*\\([^\\)]*\\)');
// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;
// detect problematic expressions in a template
function detectErrors(ast, warn) {
    if (ast) {
        checkNode(ast, warn);
    }
}
function checkNode(node, warn) {
    if (node.type === 1) {
        for (var name_1 in node.attrsMap) {
            if (dirRE.test(name_1)) {
                var value = node.attrsMap[name_1];
                if (value) {
                    var range = node.rawAttrsMap[name_1];
                    if (name_1 === 'v-for') {
                        checkFor(node, "v-for=\"".concat(value, "\""), warn, range);
                    }
                    else if (name_1 === 'v-slot' || name_1[0] === '#') {
                        checkFunctionParameterExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                    else if (onRE.test(name_1)) {
                        checkEvent(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                    else {
                        checkExpression(value, "".concat(name_1, "=\"").concat(value, "\""), warn, range);
                    }
                }
            }
        }
        if (node.children) {
            for (var i = 0; i < node.children.length; i++) {
                checkNode(node.children[i], warn);
            }
        }
    }
    else if (node.type === 2) {
        checkExpression(node.expression, node.text, warn, node);
    }
}
function checkEvent(exp, text, warn, range) {
    var stripped = exp.replace(stripStringRE, '');
    var keywordMatch = stripped.match(unaryOperatorsRE);
    if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
        warn("avoid using JavaScript unary operator as property name: " +
            "\"".concat(keywordMatch[0], "\" in expression ").concat(text.trim()), range);
    }
    checkExpression(exp, text, warn, range);
}
function checkFor(node, text, warn, range) {
    checkExpression(node.for || '', text, warn, range);
    checkIdentifier(node.alias, 'v-for alias', text, warn, range);
    checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
    checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}
function checkIdentifier(ident, type, text, warn, range) {
    if (typeof ident === 'string') {
        try {
            new Function("var ".concat(ident, "=_"));
        }
        catch (e) {
            warn("invalid ".concat(type, " \"").concat(ident, "\" in expression: ").concat(text.trim()), range);
        }
    }
}
function checkExpression(exp, text, warn, range) {
    try {
        new Function("return ".concat(exp));
    }
    catch (e) {
        var keywordMatch = exp
            .replace(stripStringRE, '')
            .match(prohibitedKeywordRE);
        if (keywordMatch) {
            warn("avoid using JavaScript keyword as property name: " +
                "\"".concat(keywordMatch[0], "\"\n  Raw expression: ").concat(text.trim()), range);
        }
        else {
            warn("invalid expression: ".concat(e.message, " in\n\n") +
                "    ".concat(exp, "\n\n") +
                "  Raw expression: ".concat(text.trim(), "\n"), range);
        }
    }
}
function checkFunctionParameterExpression(exp, text, warn, range) {
    try {
        new Function(exp, '');
    }
    catch (e) {
        warn("invalid function parameter expression: ".concat(e.message, " in\n\n") +
            "    ".concat(exp, "\n\n") +
            "  Raw expression: ".concat(text.trim(), "\n"), range);
    }
}

var range = 2;
function generateCodeFrame(source, start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = source.length; }
    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];
    for (var i = 0; i < lines.length; i++) {
        count += lines[i].length + 1;
        if (count >= start) {
            for (var j = i - range; j <= i + range || end > count; j++) {
                if (j < 0 || j >= lines.length)
                    continue;
                res.push("".concat(j + 1).concat(repeat(" ", 3 - String(j + 1).length), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    var pad = start - (count - lineLength) + 1;
                    var length_1 = end > count ? lineLength - pad : end - start;
                    res.push("   |  " + repeat(" ", pad) + repeat("^", length_1));
                }
                else if (j > i) {
                    if (end > count) {
                        var length_2 = Math.min(end - count, lineLength);
                        res.push("   |  " + repeat("^", length_2));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join('\n');
}
function repeat(str, n) {
    var result = '';
    if (n > 0) {
        // eslint-disable-next-line no-constant-condition
        while (true) {
            // eslint-disable-line
            if (n & 1)
                result += str;
            n >>>= 1;
            if (n <= 0)
                break;
            str += str;
        }
    }
    return result;
}

function createFunction(code, errors) {
    try {
        return new Function(code);
    }
    catch (err) {
        errors.push({ err: err, code: code });
        return noop;
    }
}
function createCompileToFunctionFn(compile) {
    var cache = Object.create(null);
    return function compileToFunctions(template, options, vm) {
        options = extend({}, options);
        var warn = options.warn || warn$2;
        delete options.warn;
        /* istanbul ignore if */
        if (false) {
            // detect possible CSP restriction
            try {
                new Function('return 1');
            }
            catch (e) {
                if (e.toString().match(/unsafe-eval|CSP/)) {
                    warn('It seems you are using the standalone build of Vue.js in an ' +
                        'environment with Content Security Policy that prohibits unsafe-eval. ' +
                        'The template compiler cannot work in this environment. Consider ' +
                        'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
                        'templates into render functions.');
                }
            }
        }
        // check cache
        var key = options.delimiters
            ? String(options.delimiters) + template
            : template;
        if (cache[key]) {
            return cache[key];
        }
        // compile
        var compiled = compile(template, options);
        // check compilation errors/tips
        if (false) {
            if (compiled.errors && compiled.errors.length) {
                if (options.outputSourceRange) {
                    compiled.errors.forEach(function (e) {
                        warn("Error compiling template:\n\n".concat(e.msg, "\n\n") +
                            generateCodeFrame(template, e.start, e.end), vm);
                    });
                }
                else {
                    warn("Error compiling template:\n\n".concat(template, "\n\n") +
                        compiled.errors.map(function (e) { return "- ".concat(e); }).join('\n') +
                        '\n', vm);
                }
            }
            if (compiled.tips && compiled.tips.length) {
                if (options.outputSourceRange) {
                    compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
                }
                else {
                    compiled.tips.forEach(function (msg) { return tip(msg, vm); });
                }
            }
        }
        // turn code into functions
        var res = {};
        var fnGenErrors = [];
        res.render = createFunction(compiled.render, fnGenErrors);
        res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
            return createFunction(code, fnGenErrors);
        });
        // check function generation errors.
        // this should only happen if there is a bug in the compiler itself.
        // mostly for codegen development use
        /* istanbul ignore if */
        if (false) {
            if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
                warn("Failed to generate render function:\n\n" +
                    fnGenErrors
                        .map(function (_a) {
                        var err = _a.err, code = _a.code;
                        return "".concat(err.toString(), " in\n\n").concat(code, "\n");
                    })
                        .join('\n'), vm);
            }
        }
        return (cache[key] = res);
    };
}

function createCompilerCreator(baseCompile) {
    return function createCompiler(baseOptions) {
        function compile(template, options) {
            var finalOptions = Object.create(baseOptions);
            var errors = [];
            var tips = [];
            var warn = function (msg, range, tip) {
                (tip ? tips : errors).push(msg);
            };
            if (options) {
                if (false) {
                    // $flow-disable-line
                    var leadingSpaceLength_1 = template.match(/^\s*/)[0].length;
                    warn = function (msg, range, tip) {
                        var data = typeof msg === 'string' ? { msg: msg } : msg;
                        if (range) {
                            if (range.start != null) {
                                data.start = range.start + leadingSpaceLength_1;
                            }
                            if (range.end != null) {
                                data.end = range.end + leadingSpaceLength_1;
                            }
                        }
                        (tip ? tips : errors).push(data);
                    };
                }
                // merge custom modules
                if (options.modules) {
                    finalOptions.modules = (baseOptions.modules || []).concat(options.modules);
                }
                // merge custom directives
                if (options.directives) {
                    finalOptions.directives = extend(Object.create(baseOptions.directives || null), options.directives);
                }
                // copy other options
                for (var key in options) {
                    if (key !== 'modules' && key !== 'directives') {
                        finalOptions[key] = options[key];
                    }
                }
            }
            finalOptions.warn = warn;
            var compiled = baseCompile(template.trim(), finalOptions);
            if (false) {
                detectErrors(compiled.ast, warn);
            }
            compiled.errors = errors;
            compiled.tips = tips;
            return compiled;
        }
        return {
            compile: compile,
            compileToFunctions: createCompileToFunctionFn(compile)
        };
    };
}

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile(template, options) {
    var ast = parse(template.trim(), options);
    if (options.optimize !== false) {
        optimize(ast, options);
    }
    var code = generate(ast, options);
    return {
        ast: ast,
        render: code.render,
        staticRenderFns: code.staticRenderFns
    };
});

var _a = createCompiler(baseOptions), compileToFunctions = _a.compileToFunctions;

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode(href) {
    div = div || document.createElement('div');
    div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
    return div.innerHTML.indexOf('&#10;') > 0;
}
// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser
    ? getShouldDecode(true)
    : false;

var idToTemplate = cached(function (id) {
    var el = query(id);
    return el && el.innerHTML;
});
var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (el, hydrating) {
    el = el && query(el);
    /* istanbul ignore if */
    if (el === document.body || el === document.documentElement) {
        "production" !== 'production' &&
            warn$2("Do not mount Vue to <html> or <body> - mount to normal elements instead.");
        return this;
    }
    var options = this.$options;
    // resolve template/el and convert to render function
    if (!options.render) {
        var template = options.template;
        if (template) {
            if (typeof template === 'string') {
                if (template.charAt(0) === '#') {
                    template = idToTemplate(template);
                    /* istanbul ignore if */
                    if (false) {
                        warn$2("Template element not found or is empty: ".concat(options.template), this);
                    }
                }
            }
            else if (template.nodeType) {
                template = template.innerHTML;
            }
            else {
                if (false) {
                    warn$2('invalid template option:' + template, this);
                }
                return this;
            }
        }
        else if (el) {
            // @ts-expect-error
            template = getOuterHTML(el);
        }
        if (template) {
            /* istanbul ignore if */
            if (false) {
                mark('compile');
            }
            var _a = compileToFunctions(template, {
                outputSourceRange: "production" !== 'production',
                shouldDecodeNewlines: shouldDecodeNewlines,
                shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
                delimiters: options.delimiters,
                comments: options.comments
            }, this), render = _a.render, staticRenderFns = _a.staticRenderFns;
            options.render = render;
            options.staticRenderFns = staticRenderFns;
            /* istanbul ignore if */
            if (false) {
                mark('compile end');
                measure("vue ".concat(this._name, " compile"), 'compile', 'compile end');
            }
        }
    }
    return mount.call(this, el, hydrating);
};
/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML(el) {
    if (el.outerHTML) {
        return el.outerHTML;
    }
    else {
        var container = document.createElement('div');
        container.appendChild(el.cloneNode(true));
        return container.innerHTML;
    }
}
Vue.compile = compileToFunctions;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "74xK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__("nJ75");
var getWeak = __webpack_require__("+zJ9").getWeak;
var anObject = __webpack_require__("FKWp");
var isObject = __webpack_require__("8ANE");
var anInstance = __webpack_require__("4S0F");
var forOf = __webpack_require__("dudK");
var createArrayMethod = __webpack_require__("eAa1");
var $has = __webpack_require__("x//u");
var validate = __webpack_require__("fTPD");
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),

/***/ "76UX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__("9MlZ");

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ "7GwW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var settle = __webpack_require__("21It");
var buildURL = __webpack_require__("DQCr");
var parseHeaders = __webpack_require__("oJlt");
var isURLSameOrigin = __webpack_require__("GHBc");
var createError = __webpack_require__("FtD3");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("thJu");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("p1b6");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "7LGX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) > -1;
};

/***/ }),

/***/ "7VT+":
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m
var evp = __webpack_require__("Cgw8")
var ciphers = __webpack_require__("tXf9")
var Buffer = __webpack_require__("X3l8").Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),

/***/ "7ar3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__("76UX")();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

try {
	null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
	// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
	var errorProto = getProto(getProto(e));
	INTRINSICS['%Error.prototype%'] = errorProto;
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__("PiFy");
var hasOwn = __webpack_require__("XfW5");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ "7dSG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__("ypnx");
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__("jOgh"));
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("iP15")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("UcPO");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("X3l8").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__("x0Ha");

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__("DsFX");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__("DsFX");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU"), __webpack_require__("162o").setImmediate, __webpack_require__("DuR2")))

/***/ }),

/***/ "8/0b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var common = __webpack_require__("YSDb");
var assert = __webpack_require__("08Lv");

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),

/***/ "87vf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("7dSG");


/***/ }),

/***/ "8ANE":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "8MO0":
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__("dudK");

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ "8hRR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("szDu"), __esModule: true };

/***/ }),

/***/ "8knk":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("Wdy1");

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__("9h1I")('Set') });


/***/ }),

/***/ "8p3e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    alwaysShowPerPageSelect: false,
    hidePerPageSelect: false,
    dateColumns: [],
    listColumns: {},
    datepickerOptions: {
      locale: {
        cancelLabel: "Clear"
      }
    },
    datepickerPerColumnOptions: {},
    initialPage: 1,
    perPage: 10,
    perPageValues: [10, 25, 50, 100],
    groupBy: false,
    collapseGroups: false,
    destroyEventBus: false,
    sendEmptyFilters: false,
    params: {},
    sortable: true,
    filterable: true,
    groupMeta: [],
    initFilters: {},
    sendInitialRequest: true,
    customFilters: [],
    templates: {},
    debounce: 250,
    dateFormat: "DD/MM/YYYY",
    dateFormatPerColumn: {},
    toMomentFormat: false,
    skin: false,
    columnsDisplay: {},
    columnsDropdown: false,
    texts: {
      count: "Showing {from} to {to} of {count} records|{count} records|One record",
      first: "First",
      last: "Last",
      filter: "Filter:",
      filterPlaceholder: "Search query",
      limit: "Records:",
      page: "Page:",
      noResults: "No matching records",
      filterBy: "Filter by {column}",
      loading: "Loading...",
      defaultOption: "Select {column}",
      columns: "Columns"
    },
    sortIcon: {
      is: "glyphicon-sort",
      base: "glyphicon",
      up: "glyphicon-chevron-up",
      down: "glyphicon-chevron-down"
    },
    sortingAlgorithm: function sortingAlgorithm(data, column) {
      return data.sort(this.getSortFn(column));
    },
    filterAlgorithm: {},
    customSorting: {},
    multiSorting: {},
    clientMultiSorting: true,
    serverMultiSorting: false,
    filterByColumn: false,
    highlightMatches: false,
    orderBy: false,
    descOrderColumns: [],
    footerHeadings: false,
    headings: {},
    headingsTooltips: {},
    pagination: {
      dropdown: false,
      chunk: 10,
      edge: false,
      align: "center",
      nav: "fixed"
    },
    childRow: false,
    childRowTogglerFirst: true,
    showChildRowToggler: true,
    uniqueKey: "id",
    requestFunction: false,
    requestAdapter: function requestAdapter(data) {
      return data;
    },
    responseAdapter: function responseAdapter(resp) {
      var data = this.getResponseData(resp);
      return {
        data: data.data,
        count: data.count
      };
    },
    requestKeys: {
      query: "query",
      limit: "limit",
      orderBy: "orderBy",
      ascending: "ascending",
      page: "page",
      byColumn: "byColumn"
    },
    rowClassCallback: false,
    preserveState: false,
    saveState: false,
    storage: "local",
    columnsClasses: {},
    summary: false,
    caption: false,
    cellClasses: {},
    visibleColumns: false,
    hiddenColumns: false,
    resizableColumns: true,
    editableColumns: []
  };
};

/***/ }),

/***/ "8qoP":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer
var xor = __webpack_require__("H2Pp")

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),

/***/ "94zm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__("40O2");

module.exports = function (defaults, globalOptions, localOptions) {
  if (globalOptions) defaults = merge.recursive(defaults, globalOptions);
  localOptions = merge.recursive(defaults, localOptions);
  return localOptions;
};

/***/ }),

/***/ "9DG0":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__("vzCy").EventEmitter;
var inherits = __webpack_require__("LC74");

inherits(Stream, EE);
Stream.Readable = __webpack_require__("cSWu");
Stream.Writable = __webpack_require__("87vf");
Stream.Duplex = __webpack_require__("SDM6");
Stream.Transform = __webpack_require__("4/4u");
Stream.PassThrough = __webpack_require__("/MLu");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ "9MbE":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("8ANE");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "9MlZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ "9P96":
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__("9hYg")
exports.privateDecrypt = __webpack_require__("fxuI")

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),

/***/ "9Urd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return JSON.stringify(this.customQueries);
};

/***/ }),

/***/ "9bI3":
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
      ],
    ],
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
      ],
    ],
  },
};


/***/ }),

/***/ "9h1I":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__("FHqv");
var from = __webpack_require__("8MO0");
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ "9hYg":
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__("jkjm")
var randomBytes = __webpack_require__("rOku")
var createHash = __webpack_require__("BVsN")
var mgf = __webpack_require__("Cua8")
var xor = __webpack_require__("zOO0")
var BN = __webpack_require__("2Ejg")
var withPublic = __webpack_require__("5QAX")
var crt = __webpack_require__("jSRM")
var Buffer = __webpack_require__("X3l8").Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),

/***/ "9uBv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__("3fMt");
var $export = __webpack_require__("Wdy1");
var toObject = __webpack_require__("wXdB");
var call = __webpack_require__("tn1D");
var isArrayIter = __webpack_require__("yuYM");
var toLength = __webpack_require__("GhAV");
var createProperty = __webpack_require__("Uy0O");
var getIterFn = __webpack_require__("1yV6");

$export($export.S + $export.F * !__webpack_require__("wWcv")(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ "A1Hb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("Wdy1");
var aFunction = __webpack_require__("SWGL");
var ctx = __webpack_require__("3fMt");
var forOf = __webpack_require__("dudK");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ "AFOY":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("CZee");
var $Object = __webpack_require__("iANj").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "ARY+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("LC74")
var Legacy = __webpack_require__("YQyn")
var Base = __webpack_require__("z+8S")
var Buffer = __webpack_require__("X3l8").Buffer
var md5 = __webpack_require__("EXeW")
var RIPEMD160 = __webpack_require__("LYGd")

var sha = __webpack_require__("JaR3")

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),

/***/ "AWjC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),

/***/ "AZDW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _merge = _interopRequireDefault(__webpack_require__("40O2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (h, modules, classes, slots) {
  var filterId = 'VueTables__search_' + this.id;
  var perpageId = 'VueTables__limit_' + this.id;

  var perpageValues = __webpack_require__("ic+9").call(this, h);

  var caption = this.opts.caption ? h("caption", [this.opts.caption]) : '';
  var genericFilter = this.hasGenericFilter ? h("div", {
    "class": "VueTables__search-field"
  }, [h("label", {
    attrs: {
      "for": filterId
    },
    "class": classes.label
  }, [this.display('filter')]), modules.normalFilter(classes, filterId)]) : '';
  var perpage = perpageValues.length > 1 ? h("div", {
    "class": "VueTables__limit-field"
  }, [h("label", {
    "class": classes.label,
    attrs: {
      "for": perpageId
    }
  }, [this.display('limit')]), modules.perPage(perpageValues, classes.select, perpageId)]) : '';
  var columnsDropdown = this.opts.columnsDropdown ? h("div", {
    "class": "VueTables__columns-dropdown-wrapper"
  }, [modules.columnsDropdown(classes)]) : '';
  var shouldShowTop = genericFilter || perpage || columnsDropdown || slots.beforeFilter || slots.afterFilter || slots.beforeLimit || slots.afterLimit;
  var tableTop = h("div", {
    "class": classes.row,
    directives: [{
      name: "show",
      value: shouldShowTop
    }]
  }, [h("div", {
    "class": classes.column
  }, [h("div", {
    "class": "".concat(classes.field, " ").concat(classes.inline, " ").concat(classes.left, " VueTables__search")
  }, [slots.beforeFilter, genericFilter, slots.afterFilter]), slots.afterFilterWrapper, h("div", {
    "class": "".concat(classes.field, " ").concat(classes.inline, " ").concat(classes.right, " VueTables__limit")
  }, [slots.beforeLimit, perpage, slots.afterLimit]), columnsDropdown])]);
  return h("div", {
    "class": "VueTables VueTables--" + this.source
  }, [tableTop, slots.beforeTable, h("div", {
    "class": "table-responsive"
  }, [h("table", {
    "class": "VueTables__table ".concat(this.opts.skin ? this.opts.skin : classes.table),
    attrs: {
      summary: this.opts.summary
    }
  }, [caption, h("thead", [slots.prependHead, h("tr", [modules.headings(classes.right)]), slots.beforeFilters, modules.columnFilters(classes), slots.afterFilters]), h("tfoot", [h("tr", [h("td", {
    attrs: {
      colspan: this.colspan
    }
  }, [modules.pagination((0, _merge["default"])(classes.pagination, {
    list: "".concat(classes.pagination.list, " ").concat(classes.right, " ").concat(classes.nomargin),
    count: "".concat(classes.left)
  }))])])]), slots.beforeBody, h("tbody", [slots.prependBody, modules.rows(classes), slots.appendBody]), slots.afterBody])]), slots.afterTable]);
};

/***/ }),

/***/ "Afcx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return {
        format: true,
        chunk: 10,
        chunksNavigation: 'fixed',
        edgeNavigation: false,
        theme: 'bootstrap3',
        texts: {
            count: 'Showing {from} to {to} of {count} records|{count} records|One record',
            first: 'First',
            last: 'Last'
        }
    };
};

/***/ }),

/***/ "AgWD":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "Aq0r":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "B5V0":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "B6Bn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("YP8Q");
var utils = __webpack_require__("TkWM");
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),

/***/ "BCiZ":
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__("U6yG"),
  CBC: __webpack_require__("lUSU"),
  CFB: __webpack_require__("8qoP"),
  CFB8: __webpack_require__("Z7yx"),
  CFB1: __webpack_require__("k2Sm"),
  OFB: __webpack_require__("H1q7"),
  CTR: __webpack_require__("SsjP"),
  GCM: __webpack_require__("SsjP")
}

var modes = __webpack_require__("6ZSt")

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),

/***/ "BEbT":
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__("X3l8").Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),

/***/ "BKcr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h) {
  var _this = this;

  return function (theme) {
    if (_this.opts.pagination && _this.opts.pagination.dropdown) return '';
    var options = {
      theme: theme,
      chunk: _this.opts.pagination.chunk,
      chunksNavigation: _this.opts.pagination.nav,
      edgeNavigation: _this.opts.pagination.edge,
      texts: {
        count: _this.opts.texts.count,
        first: _this.opts.texts.first,
        last: _this.opts.texts.last
      }
    };
    var name = _this.vuex ? _this.name : _this.id;
    return h("pagination", {
      ref: "pagination",
      attrs: {
        options: options,
        "for": name,
        vuex: _this.vuex,
        records: _this.count,
        "per-page": parseInt(_this.limit)
      },
      on: {
        "paginate": _this._onPagination.bind(_this)
      }
    });
  };
};

/***/ }),

/***/ "BO1k":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("oY0/"), __esModule: true };

/***/ }),

/***/ "BO8W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__("iNQt");
exports.Cipher = __webpack_require__("AWjC");
exports.DES = __webpack_require__("Icsf");
exports.CBC = __webpack_require__("nyV4");
exports.EDE = __webpack_require__("YePo");


/***/ }),

/***/ "BQO6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("tz60");
__webpack_require__("+3lO");
module.exports = __webpack_require__("4DQ7").f('iterator');


/***/ }),

/***/ "BVsN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("LC74")
var MD5 = __webpack_require__("eCz2")
var RIPEMD160 = __webpack_require__("LYGd")
var sha = __webpack_require__("JaR3")
var Base = __webpack_require__("z+8S")

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),

/***/ "Bbd/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__("DvOT");
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "BdLN":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__("Wdy1");
var ownKeys = __webpack_require__("X+jS");
var toIObject = __webpack_require__("ksFB");
var gOPD = __webpack_require__("rjjF");
var createProperty = __webpack_require__("Uy0O");

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),

/***/ "BfX3":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("FKWp");
var aFunction = __webpack_require__("SWGL");
var SPECIES = __webpack_require__("hgbu")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "BwU2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var state = {
    page: 1,
    query: this.query,
    orderBy: this.orderBy,
    perPage: this.opts.perPage,
    customQueries: this.customQueries
  };
  this.storage.setItem(this.stateKey, JSON.stringify(state));
  return state;
};

/***/ }),

/***/ "BzqH":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("nclR");
module.exports = __webpack_require__("iANj").Object.setPrototypeOf;


/***/ }),

/***/ "C015":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74")
var Hash = __webpack_require__("CzQx")
var Buffer = __webpack_require__("X3l8").Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),

/***/ "C1C2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);


// Helper


function reverse(map) {
  var res = {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(map).forEach(function (key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key) key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
}

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = reverse(exports.tag);

/***/ }),

/***/ "C301":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (key, value) {
  if (!this.opts.saveState || !this.activeState) return;

  try {
    var currentState = JSON.parse(this.storage.getItem(this.stateKey));
  } catch (e) {
    var currentState = this.initState();
  }

  currentState[key] = value;
  this.storage.setItem(this.stateKey, JSON.stringify(currentState));
};

/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("rKx+"), __esModule: true };

/***/ }),

/***/ "C84k":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__("Wdy1");
var $values = __webpack_require__("uQcH")(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),

/***/ "CGGg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CsvConfigConsts = (function () {
    function CsvConfigConsts() {
    }
    CsvConfigConsts.EOL = "\r\n";
    CsvConfigConsts.BOM = "\ufeff";
    CsvConfigConsts.DEFAULT_FIELD_SEPARATOR = ',';
    CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR = '.';
    CsvConfigConsts.DEFAULT_QUOTE = '"';
    CsvConfigConsts.DEFAULT_SHOW_TITLE = false;
    CsvConfigConsts.DEFAULT_TITLE = 'My Generated Report';
    CsvConfigConsts.DEFAULT_FILENAME = 'generated';
    CsvConfigConsts.DEFAULT_SHOW_LABELS = false;
    CsvConfigConsts.DEFAULT_USE_TEXT_FILE = false;
    CsvConfigConsts.DEFAULT_USE_BOM = true;
    CsvConfigConsts.DEFAULT_HEADER = [];
    CsvConfigConsts.DEFAULT_KEYS_AS_HEADERS = false;
    return CsvConfigConsts;
}());
exports.CsvConfigConsts = CsvConfigConsts;
exports.ConfigDefaults = {
    filename: CsvConfigConsts.DEFAULT_FILENAME,
    fieldSeparator: CsvConfigConsts.DEFAULT_FIELD_SEPARATOR,
    quoteStrings: CsvConfigConsts.DEFAULT_QUOTE,
    decimalSeparator: CsvConfigConsts.DEFAULT_DECIMAL_SEPARATOR,
    showLabels: CsvConfigConsts.DEFAULT_SHOW_LABELS,
    showTitle: CsvConfigConsts.DEFAULT_SHOW_TITLE,
    title: CsvConfigConsts.DEFAULT_TITLE,
    useTextFile: CsvConfigConsts.DEFAULT_USE_TEXT_FILE,
    useBom: CsvConfigConsts.DEFAULT_USE_BOM,
    headers: CsvConfigConsts.DEFAULT_HEADER,
    useKeysAsHeaders: CsvConfigConsts.DEFAULT_KEYS_AS_HEADERS,
};
var ExportToCsv = (function () {
    function ExportToCsv(options) {
        this._csv = "";
        var config = options || {};
        this._options = objectAssign({}, exports.ConfigDefaults, config);
        if (this._options.useKeysAsHeaders
            && this._options.headers
            && this._options.headers.length > 0) {
            console.warn('Option to use object keys as headers was set, but headers were still passed!');
        }
    }
    Object.defineProperty(ExportToCsv.prototype, "options", {
        get: function () {
            return this._options;
        },
        set: function (options) {
            this._options = objectAssign({}, exports.ConfigDefaults, options);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Generate and Download Csv
     */
    ExportToCsv.prototype.generateCsv = function (jsonData, shouldReturnCsv) {
        if (shouldReturnCsv === void 0) { shouldReturnCsv = false; }
        // Make sure to reset csv data on each run
        this._csv = '';
        this._parseData(jsonData);
        if (this._options.useBom) {
            this._csv += CsvConfigConsts.BOM;
        }
        if (this._options.showTitle) {
            this._csv += this._options.title + '\r\n\n';
        }
        this._getHeaders();
        this._getBody();
        if (this._csv == '') {
            console.log("Invalid data");
            return;
        }
        // When the consumer asks for the data, exit the function
        // by returning the CSV data built at this point
        if (shouldReturnCsv) {
            return this._csv;
        }
        // Create CSV blob to download if requesting in the browser and the
        // consumer doesn't set the shouldReturnCsv param
        var FileType = this._options.useTextFile ? 'plain' : 'csv';
        var fileExtension = this._options.useTextFile ? '.txt' : '.csv';
        var blob = new Blob([this._csv], { "type": "text/" + FileType + ";charset=utf8;" });
        if (navigator.msSaveBlob) {
            var filename = this._options.filename.replace(/ /g, "_") + fileExtension;
            navigator.msSaveBlob(blob, filename);
        }
        else {
            var attachmentType = this._options.useTextFile ? 'text' : 'csv';
            var uri = 'data:attachment/' + attachmentType + ';charset=utf-8,' + encodeURI(this._csv);
            var link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute('visibility', 'hidden');
            link.download = this._options.filename.replace(/ /g, "_") + fileExtension;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };
    /**
     * Create Headers
     */
    ExportToCsv.prototype._getHeaders = function () {
        if (!this._options.showLabels && !this._options.useKeysAsHeaders) {
            return;
        }
        var useKeysAsHeaders = this._options.useKeysAsHeaders;
        var headers = useKeysAsHeaders ? Object.keys(this._data[0]) : this._options.headers;
        if (headers.length > 0) {
            var row = "";
            for (var keyPos = 0; keyPos < headers.length; keyPos++) {
                row += headers[keyPos] + this._options.fieldSeparator;
            }
            row = row.slice(0, -1);
            this._csv += row + CsvConfigConsts.EOL;
        }
    };
    /**
     * Create Body
     */
    ExportToCsv.prototype._getBody = function () {
        var keys = Object.keys(this._data[0]);
        for (var i = 0; i < this._data.length; i++) {
            var row = "";
            for (var keyPos = 0; keyPos < keys.length; keyPos++) {
                var key = keys[keyPos];
                row += this._formatData(this._data[i][key]) + this._options.fieldSeparator;
            }
            row = row.slice(0, -1);
            this._csv += row + CsvConfigConsts.EOL;
        }
    };
    /**
     * Format Data
     * @param {any} data
     */
    ExportToCsv.prototype._formatData = function (data) {
        if (this._options.decimalSeparator === 'locale' && this._isFloat(data)) {
            return data.toLocaleString();
        }
        if (this._options.decimalSeparator !== '.' && this._isFloat(data)) {
            return data.toString().replace('.', this._options.decimalSeparator);
        }
        if (typeof data === 'string') {
            data = data.replace(/"/g, '""');
            if (this._options.quoteStrings || data.indexOf(',') > -1 || data.indexOf('\n') > -1 || data.indexOf('\r') > -1) {
                data = this._options.quoteStrings + data + this._options.quoteStrings;
            }
            return data;
        }
        if (typeof data === 'boolean') {
            return data ? 'TRUE' : 'FALSE';
        }
        return data;
    };
    /**
     * Check if is Float
     * @param {any} input
     */
    ExportToCsv.prototype._isFloat = function (input) {
        return +input === input && (!isFinite(input) || Boolean(input % 1));
    };
    /**
     * Parse the collection given to it
     *
     * @private
     * @param {*} jsonData
     * @returns {any[]}
     * @memberof ExportToCsv
     */
    ExportToCsv.prototype._parseData = function (jsonData) {
        this._data = typeof jsonData != 'object' ? JSON.parse(jsonData) : jsonData;
        return this._data;
    };
    return ExportToCsv;
}());
exports.ExportToCsv = ExportToCsv;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
/**
 * Convet to Object
 * @param {any} val
 */
function toObject(val) {
    if (val === null || val === undefined) {
        throw new TypeError('Object.assign cannot be called with null or undefined');
    }
    return Object(val);
}
/**
 * Assign data  to new Object
 * @param {any}   target
 * @param {any[]} ...source
 */
function objectAssign(target) {
    var source = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        source[_i - 1] = arguments[_i];
    }
    var from;
    var to = toObject(target);
    var symbols;
    for (var s = 1; s < arguments.length; s++) {
        from = Object(arguments[s]);
        for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
            }
        }
        if (Object.getOwnPropertySymbols) {
            symbols = Object.getOwnPropertySymbols(from);
            for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                    to[symbols[i]] = from[symbols[i]];
                }
            }
        }
    }
    return to;
}
//# sourceMappingURL=export-to-csv.js.map

/***/ }),

/***/ "CKAI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var common = __webpack_require__("YSDb");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),

/***/ "CM7m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    nav: '',
    count: '',
    wrapper: 'pagination',
    list: 'pagination-list',
    item: '',
    link: 'pagination-link',
    next: '',
    prev: '',
    active: 'is-current',
    disabled: '' // uses the disabled HTML attirbute
};

/***/ }),

/***/ "CVWE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("vzCy").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("qOYl");
/*</replacement>*/

var Buffer = __webpack_require__("EuP9").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(8);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__("ZEc8");
var destroyImpl = __webpack_require__("0IYo");
var _require = __webpack_require__("iqpV"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__("3U89").codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__("LC74")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("PhfM");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("X4X3").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__("PhfM");
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("X4X3").StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__("Bbd/");
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__("r9kI");
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "CZee":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Wdy1");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("NZ8V") });


/***/ }),

/***/ "Cgw8":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer
var MD5 = __webpack_require__("eCz2")

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),

/***/ "Cua8":
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__("BVsN")
var Buffer = __webpack_require__("X3l8").Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),

/***/ "CwSZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__("Zoe1");
var utils = __webpack_require__("p8xL");
var formats = __webpack_require__("XgCd");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            strictNullHandling,
            skipNulls,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "CzQx":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),

/***/ "D0f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var intersection = __webpack_require__("qmw1")["default"];

module.exports = function () {
  var opts = this.opts;
  return opts.dateColumns.length && opts.filterByColumn && (typeof opts.filterable == 'boolean' && opts.filterable || _typeof(opts.filterable) == 'object' && intersection(opts.filterable, opts.dateColumns).length);
};

/***/ }),

/***/ "D1/s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var object_filled_keys_count = __webpack_require__("dA1D");

var is_valid_moment_object = __webpack_require__("xd7m");

var filterByCustomFilters = __webpack_require__("ZBoF");

module.exports = function (data, e) {
  if (e) {
    var _query = this.query;
    this.setPage(1, true);
    var name = this.getName(e.target.name);
    var value = _typeof(e.target.value) === 'object' ? e.target.value : '' + e.target.value;

    if (name) {
      _query[name] = value;
    } else {
      _query = value;
    }

    this.vuex ? this.commit('SET_FILTER', _query) : this.query = _query;
    this.updateState('query', _query);

    if (name) {
      this.dispatch('filter', {
        name: name,
        value: value
      });
      this.dispatch("filter::".concat(name), value);
    } else {
      this.dispatch('filter', value);
    }
  }

  var query = this.query;
  var totalQueries = !query ? 0 : 1;
  if (!this.opts) return data;

  if (this.opts.filterByColumn) {
    totalQueries = object_filled_keys_count(query);
  }

  var value;
  var found;
  var currentQuery;
  var dateFormat;
  var filterByDate;
  var isListFilter;
  var data = filterByCustomFilters(data, this.opts.customFilters, this.customQueries);
  if (!totalQueries) return data;
  return data.filter(function (row, index) {
    found = 0;
    this.filterableColumns.forEach(function (column) {
      filterByDate = this.opts.dateColumns.indexOf(column) > -1 && this.opts.filterByColumn;
      isListFilter = this.isListFilter(column) && this.opts.filterByColumn;
      dateFormat = this.dateFormat(column);
      value = this._getValue(row, column);

      if (is_valid_moment_object(value) && !filterByDate) {
        value = value.format(dateFormat);
      }

      currentQuery = this.opts.filterByColumn ? query[column] : query;
      currentQuery = setCurrentQuery(currentQuery);

      if (currentQuery) {
        if (this.opts.filterAlgorithm[column]) {
          if (this.opts.filterAlgorithm[column](row, this.opts.filterByColumn ? query[column] : query)) found++;
        } else {
          if (foundMatch(currentQuery, value, isListFilter)) found++;
        }
      }
    }.bind(this));
    return found >= totalQueries;
  }.bind(this));
};

function setCurrentQuery(query) {
  if (!query) return '';
  if (typeof query == 'string') return query.toLowerCase(); // Date Range

  return query;
}

function foundMatch(query, value, isListFilter) {
  if (['string', 'number', 'boolean'].indexOf(_typeof(value)) > -1) {
    value = String(value).toLowerCase();
  } // List Filter


  if (isListFilter) {
    return value == query;
  } //Text Filter


  if (typeof value === 'string') {
    return value.indexOf(query) > -1;
  } // Date range


  if (is_valid_moment_object(value)) {
    var start = moment(query.start, 'YYYY-MM-DD HH:mm:ss');
    var end = moment(query.end, 'YYYY-MM-DD HH:mm:ss');
    return value >= start && value <= end;
  }

  if (_typeof(value) === 'object') {
    for (var key in value) {
      if (foundMatch(query, value[key])) return true;
    }

    return false;
  }

  return value >= start && value <= end;
}

/***/ }),

/***/ "D1Va":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__("DsFX");

/*<replacement>*/
var util = Object.create(__webpack_require__("jOgh"));
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),

/***/ "DDCP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("p8xL");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "DEJF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  this.page = 1;

  if (!this.opts.pagination.dropdown) {
    this.$refs.pagination.setPage(1);
  }
};

/***/ }),

/***/ "DQCr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "DY0S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(__webpack_require__("40O2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(self) {
  var _ref, _merge$recursive;

  var extra = self.source == 'server' ? (_ref = {}, _defineProperty(_ref, "".concat(self.name, "/SET_DATA"), function SET_DATA(state, response) {
    var data = self.opts.responseAdapter.call(self, response);
    state.data = data.data;
    state.count = parseInt(data.count);
  }), _defineProperty(_ref, "".concat(self.name, "/LOADING"), function LOADING(state, payload) {}), _defineProperty(_ref, "".concat(self.name, "/LOADED"), function LOADED(state, payload) {}), _defineProperty(_ref, "".concat(self.name, "/ERROR"), function ERROR(state, payload) {}), _defineProperty(_ref, "".concat(self.name, "/SET_COUNT"), function SET_COUNT(state, count) {
    state.count = count;
  }), _ref) : _defineProperty({}, "".concat(self.name, "/SET_COUNT"), function SET_COUNT(state, count) {
    state.count = count;
  });
  return _merge["default"].recursive(true, (_merge$recursive = {}, _defineProperty(_merge$recursive, "".concat(self.name, "/PAGINATE"), function PAGINATE(state, page) {
    state.page = page;
    self.updateState('page', page);
    if (self.source == 'server') self.getData();
    self.commit('PAGINATION', page);
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_FILTER"), function SET_FILTER(state, filter) {
    state.page = 1;
    self.updateState('page', 1);
    state.query = filter;

    if (self.source == 'server') {
      self.getData();
    }
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/PAGINATION"), function PAGINATION(state, page) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_CUSTOM_FILTER"), function SET_CUSTOM_FILTER(state, _ref3) {
    var filter = _ref3.filter,
        value = _ref3.value;
    state.customQueries[filter] = value;
    state.page = 1;
    self.updateState('page', 1);
    self.updateState('customQueries', state.customQueries);

    if (self.source == 'server') {
      self.getData();
    }
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_STATE"), function SET_STATE(state, _ref4) {
    var page = _ref4.page,
        query = _ref4.query,
        customQueries = _ref4.customQueries,
        limit = _ref4.limit,
        orderBy = _ref4.orderBy;
    state.customQueries = customQueries;
    state.query = query;
    state.page = page;
    state.limit = limit;
    state.ascending = orderBy.ascending;
    state.sortBy = orderBy.column;
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_LIMIT"), function SET_LIMIT(state, limit) {
    state.page = 1;
    self.updateState('page', 1);
    state.limit = limit;
    if (self.source == 'server') self.getData();
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SORT"), function SORT(state, _ref5) {
    var column = _ref5.column,
        ascending = _ref5.ascending;
    state.ascending = ascending;
    state.sortBy = column;
    if (self.source == 'server') self.getData();
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SORTED"), function SORTED(state, data) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/ROW_CLICK"), function ROW_CLICK(state, row) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/FILTER"), function FILTER(state, row) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/LIMIT"), function LIMIT(state, limit) {}), _merge$recursive), extra);
}

/***/ }),

/***/ "Dl99":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("FHqv");
var ITERATOR = __webpack_require__("hgbu")('iterator');
var Iterators = __webpack_require__("yYxz");
module.exports = __webpack_require__("iANj").isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ "DsFX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__("ypnx");
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__("jOgh"));
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

var Readable = __webpack_require__("Rt1F");
var Writable = __webpack_require__("7dSG");

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "DvOT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__("3U89").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ "DvwR":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("x//u");
var toIObject = __webpack_require__("ksFB");
var arrayIndexOf = __webpack_require__("PbQV")(false);
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "EFoD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var dP = __webpack_require__("GCs6");
var DESCRIPTORS = __webpack_require__("qs+f");
var SPECIES = __webpack_require__("hgbu")('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "EH7o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");

var SHA512 = __webpack_require__("8/0b");

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),

/***/ "EKta":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "EXeW":
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__("eCz2")

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),

/***/ "EdxU":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Wdy1");
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__("qs+f"), 'Object', { defineProperties: __webpack_require__("r3+g") });


/***/ }),

/***/ "Eif7":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("JyN8");
module.exports = __webpack_require__("iANj").Object.assign;


/***/ }),

/***/ "Ep4u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = __webpack_require__("WrlE").codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__("PcVv");
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ "EqE1":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__("A1Hb")('WeakMap');


/***/ }),

/***/ "Er1F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  if (this.orderBy.column != this.opts.groupBy) {
    this.setOrder(this.opts.groupBy, true);
  } else {
    this.setOrder(this.opts.groupBy, !this.orderBy.ascending);
  }
};

/***/ }),

/***/ "EuP9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("EKta")
var ieee754 = __webpack_require__("ujcs")
var isArray = __webpack_require__("sOR5")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "EzfO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;
  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;
  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        process.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        process.nextTick(emitErrorNT, this, err);
      }
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }
  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        process.nextTick(emitErrorAndCloseNT, _this, err);
      } else {
        process.nextTick(emitCloseNT, _this);
      }
    } else if (cb) {
      process.nextTick(emitCloseNT, _this);
      cb(err);
    } else {
      process.nextTick(emitCloseNT, _this);
    }
  });
  return this;
}
function emitErrorAndCloseNT(self, err) {
  emitErrorNT(self, err);
  emitCloseNT(self);
}
function emitCloseNT(self) {
  if (self._writableState && !self._writableState.emitClose) return;
  if (self._readableState && !self._readableState.emitClose) return;
  self.emit('close');
}
function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }
  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}
function emitErrorNT(self, err) {
  self.emit('error', err);
}
function errorOrDestroy(stream, err) {
  // We have tests that rely on errors being emitted
  // in the same tick, so changing this is semver major.
  // For now when you opt-in to autoDestroy we allow
  // the error to be emitted nextTick. In a future
  // semver major update we should change the default to this.

  var rState = stream._readableState;
  var wState = stream._writableState;
  if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);else stream.emit('error', err);
}
module.exports = {
  destroy: destroy,
  undestroy: undestroy,
  errorOrDestroy: errorOrDestroy
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "F11g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("YP8Q");
var HmacDRBG = __webpack_require__("HzeT");
var utils = __webpack_require__("TkWM");
var curves = __webpack_require__("hQ80");
var rand = __webpack_require__("txgm");
var assert = utils.assert;

var KeyPair = __webpack_require__("yMmo");
var Signature = __webpack_require__("NMED");

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(Object.prototype.hasOwnProperty.call(curves, options),
      'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  for (;;) {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
  var delta = msg.byteLength() * 8 - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(new BN(msg, 16));

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc) {
  msg = this._truncateToN(new BN(msg, 16));
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),

/***/ "F9i8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__("40O2");

module.exports = function (filter) {
  if (!this.opts.filterable) {
    console.warn("vue-tables-2: Unable to set filter. Filtering is disabled (filterable: false)");
    return;
  }

  ;

  if (this.opts.filterByColumn && typeof filter === 'string') {
    console.warn("vue-tables-2: Unable to set filter. Filter value must be an object (`filterByColumn` is set to `true`)");
    return;
  }

  ;

  if (!this.opts.filterByColumn && typeof filter !== 'string') {
    console.warn("vue-tables-2: Unable to set filter. Filter value must be a string (`filterByColumn` is set to `false`)");
    return;
  }

  ;
  var mergedFilter = this.opts.filterByColumn ? merge(this.query, filter) : filter;

  if (this.vuex) {
    this.commit('SET_FILTER', mergedFilter);
  } else {
    this.query = mergedFilter;
    this.setPage(1, true);
  }

  this.updateState('query', mergedFilter);

  this._setFiltersDOM(filter);

  if (this.source == 'server') {
    this.getData();
  }
};

/***/ }),

/***/ "FHqv":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("NZra");
var TAG = __webpack_require__("hgbu")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "FKWp":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "FOZt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var debounce = __webpack_require__("HhAh");

module.exports = function (h) {
  var _this = this;

  return function (classes, id) {
    var search = _this.source == 'client' ? _this.search.bind(_this, _this.data) : _this.serverSearch.bind(_this);
    return h("input", {
      "class": "VueTables__search__input ".concat(classes.input, " ").concat(classes.small),
      attrs: {
        type: "text",
        placeholder: _this.display('filterPlaceholder'),
        id: id,
        autocomplete: "off"
      },
      on: {
        "keyup": _this.opts.debounce ? debounce(search, _this.opts.debounce) : search
      }
    });
  };
};

/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ "Fla3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function () {
  var init = this.opts.initFilters;
  if (!this.opts.filterByColumn) return init.hasOwnProperty('GENERIC') ? init.GENERIC : '';
  var query = {};
  var filterable = this.opts.filterable && _typeof(this.opts.filterable) == 'object' ? this.opts.filterable : this.columns;
  filterable.forEach(function (column) {
    query[column] = getInitialValue(init, column);
  }.bind(this));
  return query;
};

function getInitialValue(init, column) {
  if (!init.hasOwnProperty(column)) return '';
  if (typeof init[column].start == 'undefined') return init[column];
  return {
    start: init[column].start.format('YYYY-MM-DD HH:mm:ss'),
    end: init[column].end.format('YYYY-MM-DD HH:mm:ss')
  };
}

/***/ }),

/***/ "FtD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("t8qj");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "GCs6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("FKWp");
var IE8_DOM_DEFINE = __webpack_require__("LocR");
var toPrimitive = __webpack_require__("9MbE");
var dP = Object.defineProperty;

exports.f = __webpack_require__("qs+f") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "GHBc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "GRIg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("CGGg"));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "GUE9":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var Buffer = __webpack_require__("X3l8").Buffer

var checkParameters = __webpack_require__("2JY6")
var defaultEncoding = __webpack_require__("35aj")
var sync = __webpack_require__("Zq1s")
var toBuffer = __webpack_require__("Ml+W")

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  sha: 'SHA-1',
  'sha-1': 'SHA-1',
  sha1: 'SHA-1',
  sha256: 'SHA-256',
  'sha-256': 'SHA-256',
  sha384: 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  sha512: 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}
var nextTick
function getNextTick () {
  if (nextTick) {
    return nextTick
  }
  if (global.process && global.process.nextTick) {
    nextTick = global.process.nextTick
  } else if (global.queueMicrotask) {
    nextTick = global.queueMicrotask
  } else if (global.setImmediate) {
    nextTick = global.setImmediate
  } else {
    nextTick = global.setTimeout
  }
  return nextTick
}
function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, { name: 'PBKDF2' }, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    getNextTick()(function () {
      callback(null, out)
    })
  }, function (e) {
    getNextTick()(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    getNextTick()(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
    return
  }

  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "GX0J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var c = this.sortable(column) ? 'VueTables__sortable ' : '';
  c += this.columnClass(column);
  return c;
};

/***/ }),

/***/ "Gcf6":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__("c5AH")('Set');


/***/ }),

/***/ "GhAV":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("W6Rd");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "GmwO":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "Gu7T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ "GwML":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h) {
  var _this = this;

  return function (column) {
    return h("div", {
      "class": "VueTables__date-filter",
      attrs: {
        id: 'VueTables__' + column + '-filter'
      }
    }, [h("span", {
      "class": "VueTables__filter-placeholder"
    }, [_this.display('filterBy', {
      column: _this.getHeading(column)
    })])]);
  };
};

/***/ }),

/***/ "Gwf5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (rowId) {
  return this.openChildRows.includes(rowId) ? 'VueTables__child-row-toggler--open' : 'VueTables__child-row-toggler--closed';
};

/***/ }),

/***/ "GybJ":
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(11);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ "H1q7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__("H2Pp")

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "H2Pp":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "HSQo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("RP0y"), __esModule: true };

/***/ }),

/***/ "HTMB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h, classes, item) {
  if (classes.framework === 'bulma') {
    return item;
  }

  return h("li", [item]);
};

/***/ }),

/***/ "HUgc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (response) {
  var data = this.opts.responseAdapter.call(this, response);
  this.data = this.applyFilters(data.data);

  if (isNaN(data.count)) {
    console.error("vue-tables-2: invalid 'count' property. Expected number, got ".concat(_typeof(data.count)));
    console.error('count equals', data.count);
    throw new Error();
  }

  this.count = parseInt(data.count);
  setTimeout(function () {
    this.dispatch('loaded', response);
  }.bind(this), 0);
};

/***/ }),

/***/ "HWUO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ucfirst = _interopRequireDefault(__webpack_require__("sbXZ"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (value, h) {
  if (typeof value !== 'string') return '';

  if (typeof this.$slots["h__".concat(value)] !== 'undefined') {
    return this.$slots["h__".concat(value)];
  }

  var derivedHeading = (0, _ucfirst["default"])(value.split("_").join(" "));
  if (!this.opts.headings.hasOwnProperty(value)) return derivedHeading;

  if (typeof this.opts.headings[value] === 'function') {
    if (h) return this.opts.headings[value].call(this.$parent, h);
    return derivedHeading;
  }

  return this.opts.headings[value];
};

/***/ }),

/***/ "HhAh":
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),

/***/ "HhN8":
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),

/***/ "Hwfm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* eslint-disable node/no-deprecated-api */



var buffer = __webpack_require__("EuP9")
var Buffer = buffer.Buffer

var safer = {}

var key

for (key in buffer) {
  if (!buffer.hasOwnProperty(key)) continue
  if (key === 'SlowBuffer' || key === 'Buffer') continue
  safer[key] = buffer[key]
}

var Safer = safer.Buffer = {}
for (key in Buffer) {
  if (!Buffer.hasOwnProperty(key)) continue
  if (key === 'allocUnsafe' || key === 'allocUnsafeSlow') continue
  Safer[key] = Buffer[key]
}

safer.Buffer.prototype = Buffer.prototype

if (!Safer.from || Safer.from === Uint8Array.from) {
  Safer.from = function (value, encodingOrOffset, length) {
    if (typeof value === 'number') {
      throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value)
    }
    if (value && typeof value.length === 'undefined') {
      throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value)
    }
    return Buffer(value, encodingOrOffset, length)
  }
}

if (!Safer.alloc) {
  Safer.alloc = function (size, fill, encoding) {
    if (typeof size !== 'number') {
      throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size)
    }
    if (size < 0 || size >= 2 * (1 << 30)) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
    var buf = Buffer(size)
    if (!fill || fill.length === 0) {
      buf.fill(0)
    } else if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
    return buf
  }
}

if (!safer.kStringMaxLength) {
  try {
    safer.kStringMaxLength = process.binding('buffer').kStringMaxLength
  } catch (e) {
    // we can't determine kStringMaxLength in environments where process.binding
    // is unsupported, so let's not set it
  }
}

if (!safer.constants) {
  safer.constants = {
    MAX_LENGTH: safer.kMaxLength
  }
  if (safer.kStringMaxLength) {
    safer.constants.MAX_STRING_LENGTH = safer.kStringMaxLength
  }
}

module.exports = safer

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "HzeT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__("3PYz");
var utils = __webpack_require__("tpuU");
var assert = __webpack_require__("08Lv");

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),

/***/ "I7B8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("NZ8V");
var descriptor = __webpack_require__("YTz9");
var setToStringTag = __webpack_require__("LhDF");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("aLzV")(IteratorPrototype, __webpack_require__("hgbu")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "IQ8V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.opts.filterByColumn ? JSON.stringify(this.query) : this.query;
};

/***/ }),

/***/ "IRek":
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__("z+8S")
var des = __webpack_require__("BO8W")
var inherits = __webpack_require__("LC74")
var Buffer = __webpack_require__("X3l8").Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),

/***/ "Icsf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");
var inherits = __webpack_require__("LC74");

var utils = __webpack_require__("iNQt");
var Cipher = __webpack_require__("AWjC");

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),

/***/ "Ilu2":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.Primafacie=e():t.Primafacie=e()}("undefined"!=typeof self?self:this,function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var a=e[i]={i:i,l:!1,exports:{}};return t[i].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{configurable:!1,enumerable:!0,get:i})},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s="NHnr")}({"+27R":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){var a={s:["thoddea sekondamni","thodde sekond"],ss:[t+" sekondamni",t+" sekond"],m:["eka mintan","ek minut"],mm:[t+" mintamni",t+" mintam"],h:["eka voran","ek vor"],hh:[t+" voramni",t+" voram"],d:["eka disan","ek dis"],dd:[t+" disamni",t+" dis"],M:["eka mhoinean","ek mhoino"],MM:[t+" mhoineamni",t+" mhoine"],y:["eka vorsan","ek voros"],yy:[t+" vorsamni",t+" vorsam"]};return i?a[n][0]:a[n][1]}t.defineLocale("gom-latn",{months:{standalone:"Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split("_"),format:"Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split("_"),isFormat:/MMMM(\s)+D[oD]?/},monthsShort:"Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),weekdaysShort:"Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),weekdaysMin:"Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [vazta]",LTS:"A h:mm:ss [vazta]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [vazta]",LLLL:"dddd, MMMM Do, YYYY, A h:mm [vazta]",llll:"ddd, D MMM YYYY, A h:mm [vazta]"},calendar:{sameDay:"[Aiz] LT",nextDay:"[Faleam] LT",nextWeek:"[Fuddlo] dddd[,] LT",lastDay:"[Kal] LT",lastWeek:"[Fattlo] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s adim",s:e,ss:e,m:e,mm:e,h:e,hh:e,d:e,dd:e,M:e,MM:e,y:e,yy:e},dayOfMonthOrdinalParse:/\d{1,2}(er)/,ordinal:function(t,e){switch(e){case"D":return t+"er";default:case"M":case"Q":case"DDD":case"d":case"w":case"W":return t}},week:{dow:0,doy:3},meridiemParse:/rati|sokallim|donparam|sanje/,meridiemHour:function(t,e){return 12===t&&(t=0),"rati"===e?t<4?t:t+12:"sokallim"===e?t:"donparam"===e?t>12?t:t+12:"sanje"===e?t+12:void 0},meridiem:function(t,e,n){return t<4?"rati":t<12?"sokallim":t<16?"donparam":t<20?"sanje":"rati"}})})(n("PJh5"))},"+3MK":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-fb0144a4] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-fb0144a4]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-fb0144a4] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-fb0144a4] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-fb0144a4] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-fb0144a4] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-fb0144a4] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-fb0144a4] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-fb0144a4] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-fb0144a4] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-fb0144a4] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-fb0144a4] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-fb0144a4] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-fb0144a4] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-fb0144a4] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-fb0144a4] {\n  margin-right: 0px;\n}\n.newItem[data-v-fb0144a4] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-fb0144a4] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-fb0144a4] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-fb0144a4] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-fb0144a4] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-fb0144a4] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-fb0144a4] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-fb0144a4] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-fb0144a4] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-fb0144a4] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-fb0144a4]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-fb0144a4] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-fb0144a4] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-fb0144a4] {\n  color: red;\n}\n.showMore[data-v-fb0144a4]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-fb0144a4] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-fb0144a4] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-fb0144a4] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-fb0144a4 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-fb0144a4 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-fb0144a4] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-fb0144a4 3s infinite;\n  animation: bit-data-v-fb0144a4 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-fb0144a4] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-fb0144a4]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-fb0144a4]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-fb0144a4]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-fb0144a4]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-fb0144a4]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-fb0144a4]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-fb0144a4] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-fb0144a4]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-fb0144a4] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-fb0144a4] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-fb0144a4] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-fb0144a4] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-fb0144a4] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-fb0144a4] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-fb0144a4] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-fb0144a4] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-fb0144a4] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-fb0144a4] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-fb0144a4] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-fb0144a4] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-fb0144a4] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-fb0144a4] {\n  margin-right: 0px;\n}\n.newItem[data-v-fb0144a4] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-fb0144a4] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-fb0144a4] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-fb0144a4] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-fb0144a4] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-fb0144a4] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-fb0144a4] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-fb0144a4] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-fb0144a4] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-fb0144a4] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-fb0144a4]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-fb0144a4] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-fb0144a4] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-fb0144a4] {\n  color: red;\n}\n.showMore[data-v-fb0144a4]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-fb0144a4] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-fb0144a4] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-fb0144a4] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-fb0144a4 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-fb0144a4 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-fb0144a4] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-fb0144a4 3s infinite;\n  animation: bit-data-v-fb0144a4 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-fb0144a4] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-fb0144a4]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-fb0144a4]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-fb0144a4]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-fb0144a4]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-fb0144a4]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-fb0144a4]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},"+3lO":function(t,e,n){n("abPz");for(var i=n("YjQv"),a=n("aLzV"),o=n("yYxz"),r=n("hgbu")("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),l=0;l<s.length;l++){var d=s[l],c=i[d],h=c&&c.prototype;h&&!h[r]&&a(h,r,d),o[d]=o.Array}},"+5O3":function(t,e,n){var i=n("D10a");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("02a4f2e2",i,!0,{})},"+6As":function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAGAIABAFeayPr6+iH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTQgNzkuMTUxNDgxLCAyMDEzLzAzLzEzLTEyOjA5OjE1ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjU4NkM5NjEyQTkzMDExRTNBMUY1QjM0QkZBODkyMEZCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjU4NkM5NjEzQTkzMDExRTNBMUY1QjM0QkZBODkyMEZCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTg2Qzk2MTBBOTMwMTFFM0ExRjVCMzRCRkE4OTIwRkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTg2Qzk2MTFBOTMwMTFFM0ExRjVCMzRCRkE4OTIwRkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQBAAABACwAAAAABgAGAAACCoQfZ5HI/gCboAAAOw=="},"+7/x":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"௧",2:"௨",3:"௩",4:"௪",5:"௫",6:"௬",7:"௭",8:"௮",9:"௯",0:"௦"},n={"௧":"1","௨":"2","௩":"3","௪":"4","௫":"5","௬":"6","௭":"7","௮":"8","௯":"9","௦":"0"};t.defineLocale("ta",{months:"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),monthsShort:"ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split("_"),weekdays:"ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை".split("_"),weekdaysShort:"ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி".split("_"),weekdaysMin:"ஞா_தி_செ_பு_வி_வெ_ச".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, HH:mm",LLLL:"dddd, D MMMM YYYY, HH:mm"},calendar:{sameDay:"[இன்று] LT",nextDay:"[நாளை] LT",nextWeek:"dddd, LT",lastDay:"[நேற்று] LT",lastWeek:"[கடந்த வாரம்] dddd, LT",sameElse:"L"},relativeTime:{future:"%s இல்",past:"%s முன்",s:"ஒரு சில விநாடிகள்",ss:"%d விநாடிகள்",m:"ஒரு நிமிடம்",mm:"%d நிமிடங்கள்",h:"ஒரு மணி நேரம்",hh:"%d மணி நேரம்",d:"ஒரு நாள்",dd:"%d நாட்கள்",M:"ஒரு மாதம்",MM:"%d மாதங்கள்",y:"ஒரு வருடம்",yy:"%d ஆண்டுகள்"},dayOfMonthOrdinalParse:/\d{1,2}வது/,ordinal:function(t){return t+"வது"},preparse:function(t){return t.replace(/[௧௨௩௪௫௬௭௮௯௦]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,meridiem:function(t,e,n){return t<2?" யாமம்":t<6?" வைகறை":t<10?" காலை":t<14?" நண்பகல்":t<18?" எற்பாடு":t<22?" மாலை":" யாமம்"},meridiemHour:function(t,e){return 12===t&&(t=0),"யாமம்"===e?t<2?t:t+12:"வைகறை"===e||"காலை"===e?t:"நண்பகல்"===e&&t>=10?t:t+12},week:{dow:0,doy:6}})})(n("PJh5"))},"+GuK":function(t,e,n){"use strict";var i=n("Wdy1"),a=n("iANj"),o=n("YjQv"),r=n("BfX3"),s=n("qC2Z");i(i.P+i.R,"Promise",{finally:function(t){var e=r(this,a.Promise||o.Promise),n="function"==typeof t;return this.then(n?function(n){return s(e,t()).then(function(){return n})}:t,n?function(n){return s(e,t()).then(function(){throw n})}:t)}})},"+MZ2":function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},"+SdG":function(t,e,n){var i=n("a/OS")("keys"),a=n("GmwO");t.exports=function(t){return i[t]||(i[t]=a(t))}},"+VX5":function(t,e,n){var i=n("W6Rd"),a=Math.max,o=Math.min;t.exports=function(t,e){return(t=i(t))<0?a(t+e,0):o(t,e)}},"+WA1":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("zh-mo",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日dddd HH:mm",l:"D/M/YYYY",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(t,e){return 12===t&&(t=0),"凌晨"===e||"早上"===e||"上午"===e?t:"中午"===e?t>=11?t:t+12:"下午"===e||"晚上"===e?t+12:void 0},meridiem:function(t,e,n){var i=100*t+e;return i<600?"凌晨":i<900?"早上":i<1130?"上午":i<1230?"中午":i<1800?"下午":"晚上"},calendar:{sameDay:"[今天] LT",nextDay:"[明天] LT",nextWeek:"[下]dddd LT",lastDay:"[昨天] LT",lastWeek:"[上]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|週)/,ordinal:function(t,e){switch(e){case"d":case"D":case"DDD":return t+"日";case"M":return t+"月";case"w":case"W":return t+"週";default:return t}},relativeTime:{future:"%s內",past:"%s前",s:"幾秒",ss:"%d 秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}})})(n("PJh5"))},"+WRH":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"'inji",5:"'inji",8:"'inji",70:"'inji",80:"'inji",2:"'nji",7:"'nji",20:"'nji",50:"'nji",3:"'ünji",4:"'ünji",100:"'ünji",6:"'njy",9:"'unjy",10:"'unjy",30:"'unjy",60:"'ynjy",90:"'ynjy"};t.defineLocale("tk",{months:"Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr".split("_"),monthsShort:"Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek".split("_"),weekdays:"Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe".split("_"),weekdaysShort:"Ýek_Duş_Siş_Çar_Pen_Ann_Şen".split("_"),weekdaysMin:"Ýk_Dş_Sş_Çr_Pn_An_Şn".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün sagat] LT",nextDay:"[ertir sagat] LT",nextWeek:"[indiki] dddd [sagat] LT",lastDay:"[düýn] LT",lastWeek:"[geçen] dddd [sagat] LT",sameElse:"L"},relativeTime:{future:"%s soň",past:"%s öň",s:"birnäçe sekunt",m:"bir minut",mm:"%d minut",h:"bir sagat",hh:"%d sagat",d:"bir gün",dd:"%d gün",M:"bir aý",MM:"%d aý",y:"bir ýyl",yy:"%d ýyl"},ordinal:function(t,n){switch(n){case"d":case"D":case"Do":case"DD":return t;default:if(0===t)return t+"'unjy";var i=t%10;return t+(e[i]||e[t%100-i]||e[t>=100?100:null])}},week:{dow:1,doy:7}})})(n("PJh5"))},"+Zpa":function(t,e,n){var i=n("0hSb");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("66e33c81",i,!0,{})},"+iDZ":function(t,e,n){var i=n("YjQv").document;t.exports=i&&i.documentElement},"+zJ9":function(t,e,n){var i=n("GmwO")("meta"),a=n("8ANE"),o=n("x//u"),r=n("GCs6").f,s=0,l=Object.isExtensible||function(){return!0},d=!n("zyKz")(function(){return l(Object.preventExtensions({}))}),c=function(t){r(t,i,{value:{i:"O"+ ++s,w:{}}})},h=t.exports={KEY:i,NEED:!1,fastKey:function(t,e){if(!a(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!o(t,i)){if(!l(t))return"F";if(!e)return"E";c(t)}return t[i].i},getWeak:function(t,e){if(!o(t,i)){if(!l(t))return!0;if(!e)return!1;c(t)}return t[i].w},onFreeze:function(t){return d&&h.NEED&&l(t)&&!o(t,i)&&c(t),t}}},"//Fk":function(t,e,n){t.exports={default:n("x/31"),__esModule:!0}},"/4bJ":function(t,e,n){var i=n("vgcB");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("eed18eb8",i,!0,{})},"/6P1":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={ss:"sekundė_sekundžių_sekundes",m:"minutė_minutės_minutę",mm:"minutės_minučių_minutes",h:"valanda_valandos_valandą",hh:"valandos_valandų_valandas",d:"diena_dienos_dieną",dd:"dienos_dienų_dienas",M:"mėnuo_mėnesio_mėnesį",MM:"mėnesiai_mėnesių_mėnesius",y:"metai_metų_metus",yy:"metai_metų_metus"};function n(t,e,n,i){return e?a(n)[0]:i?a(n)[1]:a(n)[2]}function i(t){return t%10==0||t>10&&t<20}function a(t){return e[t].split("_")}function o(t,e,o,r){var s=t+" ";return 1===t?s+n(0,e,o[0],r):e?s+(i(t)?a(o)[1]:a(o)[0]):r?s+a(o)[1]:s+(i(t)?a(o)[1]:a(o)[2])}t.defineLocale("lt",{months:{format:"sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),standalone:"sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split("_"),isFormat:/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/},monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:{format:"sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split("_"),standalone:"sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_"),isFormat:/dddd HH:mm/},weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),weekdaysMin:"S_P_A_T_K_Pn_Š".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], HH:mm [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], HH:mm [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"},calendar:{sameDay:"[Šiandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Praėjusį] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prieš %s",s:function(t,e,n,i){return e?"kelios sekundės":i?"kelių sekundžių":"kelias sekundes"},ss:o,m:n,mm:o,h:n,hh:o,d:n,dd:o,M:n,MM:o,y:n,yy:o},dayOfMonthOrdinalParse:/\d{1,2}-oji/,ordinal:function(t){return t+"-oji"},week:{dow:1,doy:4}})})(n("PJh5"))},"/E8D":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("it-ch",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(t){return(/^[0-9].+$/.test(t)?"tra":"in")+" "+t},past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})(n("PJh5"))},"/FHD":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-31d7a0b6]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-31d7a0b6]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-31d7a0b6]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-31d7a0b6]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-31d7a0b6] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-31d7a0b6]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-31d7a0b6] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-31d7a0b6]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-31d7a0b6]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-31d7a0b6]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-31d7a0b6]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-31d7a0b6]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-31d7a0b6]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-31d7a0b6] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-31d7a0b6]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-31d7a0b6] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-31d7a0b6]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-31d7a0b6]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},"/YpR":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.paddingBottomZero {\n  padding-bottom: 0px;\n}\n.checkabso {\n  position: absolute;\n}\n.left-check {\n  padding-left: 30px;\n  line-height: 1.5;\n  margin-top: -24px;\n  padding-bottom: 10px;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfUsEntries/PfUsEntry/PfUsEntry.css"],names:[],mappings:";AACA;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;CACtB",file:"PfUsEntry.css",sourcesContent:["\n.paddingBottomZero {\n  padding-bottom: 0px;\n}\n.checkabso {\n  position: absolute;\n}\n.left-check {\n  padding-left: 30px;\n  line-height: 1.5;\n  margin-top: -24px;\n  padding-bottom: 10px;\n}\n"],sourceRoot:""}])},"/bsm":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("uz-latn",{months:"Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split("_"),monthsShort:"Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),weekdays:"Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split("_"),weekdaysShort:"Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),weekdaysMin:"Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[Bugun soat] LT [da]",nextDay:"[Ertaga] LT [da]",nextWeek:"dddd [kuni soat] LT [da]",lastDay:"[Kecha soat] LT [da]",lastWeek:"[O'tgan] dddd [kuni soat] LT [da]",sameElse:"L"},relativeTime:{future:"Yaqin %s ichida",past:"Bir necha %s oldin",s:"soniya",ss:"%d soniya",m:"bir daqiqa",mm:"%d daqiqa",h:"bir soat",hh:"%d soat",d:"bir kun",dd:"%d kun",M:"bir oy",MM:"%d oy",y:"bir yil",yy:"%d yil"},week:{dow:1,doy:7}})})(n("PJh5"))},"/dO2":function(t,e,n){"use strict";
/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function a(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function o(){return(o=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var i in n)Object.prototype.hasOwnProperty.call(n,i)&&(t[i]=n[i])}return t}).apply(this,arguments)}function r(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),i.forEach(function(e){a(t,e,n[e])})}return t}function s(t,e){if(null==t)return{};var n,i,a=function(t,e){if(null==t)return{};var n,i,a={},o=Object.keys(t);for(i=0;i<o.length;i++)n=o[i],e.indexOf(n)>=0||(a[n]=t[n]);return a}(t,e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(t);for(i=0;i<o.length;i++)n=o[i],e.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(t,n)&&(a[n]=t[n])}return a}function l(t){return function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}(t)||function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}Object.defineProperty(e,"__esModule",{value:!0}),n.d(e,"MultiDrag",function(){return xe}),n.d(e,"Sortable",function(){return Rt}),n.d(e,"Swap",function(){return le});function d(t){if("undefined"!=typeof window&&window.navigator)return!!navigator.userAgent.match(t)}var c=d(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i),h=d(/Edge/i),u=d(/firefox/i),m=d(/safari/i)&&!d(/chrome/i)&&!d(/android/i),f=d(/iP(ad|od|hone)/i),p=d(/chrome/i)&&d(/android/i),_={capture:!1,passive:!1};function A(t,e,n){t.addEventListener(e,n,!c&&_)}function b(t,e,n){t.removeEventListener(e,n,!c&&_)}function x(t,e){if(e){if(">"===e[0]&&(e=e.substring(1)),t)try{if(t.matches)return t.matches(e);if(t.msMatchesSelector)return t.msMatchesSelector(e);if(t.webkitMatchesSelector)return t.webkitMatchesSelector(e)}catch(t){return!1}return!1}}function g(t){return t.host&&t!==document&&t.host.nodeType?t.host:t.parentNode}function v(t,e,n,i){if(t){n=n||document;do{if(null!=e&&(">"===e[0]?t.parentNode===n&&x(t,e):x(t,e))||i&&t===n)return t;if(t===n)break}while(t=g(t))}return null}var C,y=/\s+/g;function w(t,e,n){if(t&&e)if(t.classList)t.classList[n?"add":"remove"](e);else{var i=(" "+t.className+" ").replace(y," ").replace(" "+e+" "," ");t.className=(i+(n?" "+e:"")).replace(y," ")}}function B(t,e,n){var i=t&&t.style;if(i){if(void 0===n)return document.defaultView&&document.defaultView.getComputedStyle?n=document.defaultView.getComputedStyle(t,""):t.currentStyle&&(n=t.currentStyle),void 0===e?n:n[e];e in i||-1!==e.indexOf("webkit")||(e="-webkit-"+e),i[e]=n+("string"==typeof n?"":"px")}}function k(t,e){var n="";if("string"==typeof t)n=t;else do{var i=B(t,"transform");i&&"none"!==i&&(n=i+" "+n)}while(!e&&(t=t.parentNode));var a=window.DOMMatrix||window.WebKitCSSMatrix||window.CSSMatrix||window.MSCSSMatrix;return a&&new a(n)}function E(t,e,n){if(t){var i=t.getElementsByTagName(e),a=0,o=i.length;if(n)for(;a<o;a++)n(i[a],a);return i}return[]}function I(){var t=document.scrollingElement;return t||document.documentElement}function D(t,e,n,i,a){if(t.getBoundingClientRect||t===window){var o,r,s,l,d,h,u;if(t!==window&&t!==I()?(r=(o=t.getBoundingClientRect()).top,s=o.left,l=o.bottom,d=o.right,h=o.height,u=o.width):(r=0,s=0,l=window.innerHeight,d=window.innerWidth,h=window.innerHeight,u=window.innerWidth),(e||n)&&t!==window&&(a=a||t.parentNode,!c))do{if(a&&a.getBoundingClientRect&&("none"!==B(a,"transform")||n&&"static"!==B(a,"position"))){var m=a.getBoundingClientRect();r-=m.top+parseInt(B(a,"border-top-width")),s-=m.left+parseInt(B(a,"border-left-width")),l=r+o.height,d=s+o.width;break}}while(a=a.parentNode);if(i&&t!==window){var f=k(a||t),p=f&&f.a,_=f&&f.d;f&&(l=(r/=_)+(h/=_),d=(s/=p)+(u/=p))}return{top:r,left:s,bottom:l,right:d,width:u,height:h}}}function S(t,e,n){for(var i=L(t,!0),a=D(t)[e];i;){var o=D(i)[n];if(!("top"===n||"left"===n?a>=o:a<=o))return i;if(i===I())break;i=L(i,!1)}return!1}function N(t,e,n){for(var i=0,a=0,o=t.children;a<o.length;){if("none"!==o[a].style.display&&o[a]!==Rt.ghost&&o[a]!==Rt.dragged&&v(o[a],n.draggable,t,!1)){if(i===e)return o[a];i++}a++}return null}function M(t,e){for(var n=t.lastElementChild;n&&(n===Rt.ghost||"none"===B(n,"display")||e&&!x(n,e));)n=n.previousElementSibling;return n||null}function O(t,e){var n=0;if(!t||!t.parentNode)return-1;for(;t=t.previousElementSibling;)"TEMPLATE"===t.nodeName.toUpperCase()||t===Rt.clone||e&&!x(t,e)||n++;return n}function T(t){var e=0,n=0,i=I();if(t)do{var a=k(t),o=a.a,r=a.d;e+=t.scrollLeft*o,n+=t.scrollTop*r}while(t!==i&&(t=t.parentNode));return[e,n]}function L(t,e){if(!t||!t.getBoundingClientRect)return I();var n=t,i=!1;do{if(n.clientWidth<n.scrollWidth||n.clientHeight<n.scrollHeight){var a=B(n);if(n.clientWidth<n.scrollWidth&&("auto"==a.overflowX||"scroll"==a.overflowX)||n.clientHeight<n.scrollHeight&&("auto"==a.overflowY||"scroll"==a.overflowY)){if(!n.getBoundingClientRect||n===document.body)return I();if(i||e)return n;i=!0}}}while(n=n.parentNode);return I()}function j(t,e){return Math.round(t.top)===Math.round(e.top)&&Math.round(t.left)===Math.round(e.left)&&Math.round(t.height)===Math.round(e.height)&&Math.round(t.width)===Math.round(e.width)}function P(t,e){return function(){if(!C){var n=arguments;1===n.length?t.call(this,n[0]):t.apply(this,n),C=setTimeout(function(){C=void 0},e)}}}function F(t,e,n){t.scrollLeft+=e,t.scrollTop+=n}function Y(t){var e=window.Polymer,n=window.jQuery||window.Zepto;return e&&e.dom?e.dom(t).cloneNode(!0):n?n(t).clone(!0)[0]:t.cloneNode(!0)}function R(t,e){B(t,"position","absolute"),B(t,"top",e.top),B(t,"left",e.left),B(t,"width",e.width),B(t,"height",e.height)}function H(t){B(t,"position",""),B(t,"top",""),B(t,"left",""),B(t,"width",""),B(t,"height","")}var $="Sortable"+(new Date).getTime();function z(){var t,e=[];return{captureAnimationState:function(){(e=[],this.options.animation)&&[].slice.call(this.el.children).forEach(function(t){if("none"!==B(t,"display")&&t!==Rt.ghost){e.push({target:t,rect:D(t)});var n=r({},e[e.length-1].rect);if(t.thisAnimationDuration){var i=k(t,!0);i&&(n.top-=i.f,n.left-=i.e)}t.fromRect=n}})},addAnimationState:function(t){e.push(t)},removeAnimationState:function(t){e.splice(function(t,e){for(var n in t)if(t.hasOwnProperty(n))for(var i in e)if(e.hasOwnProperty(i)&&e[i]===t[n][i])return Number(n);return-1}(e,{target:t}),1)},animateAll:function(n){var i=this;if(!this.options.animation)return clearTimeout(t),void("function"==typeof n&&n());var a=!1,o=0;e.forEach(function(t){var e=0,n=t.target,r=n.fromRect,s=D(n),l=n.prevFromRect,d=n.prevToRect,c=t.rect,h=k(n,!0);h&&(s.top-=h.f,s.left-=h.e),n.toRect=s,n.thisAnimationDuration&&j(l,s)&&!j(r,s)&&(c.top-s.top)/(c.left-s.left)==(r.top-s.top)/(r.left-s.left)&&(e=function(t,e,n,i){return Math.sqrt(Math.pow(e.top-t.top,2)+Math.pow(e.left-t.left,2))/Math.sqrt(Math.pow(e.top-n.top,2)+Math.pow(e.left-n.left,2))*i.animation}(c,l,d,i.options)),j(s,r)||(n.prevFromRect=r,n.prevToRect=s,e||(e=i.options.animation),i.animate(n,c,s,e)),e&&(a=!0,o=Math.max(o,e),clearTimeout(n.animationResetTimer),n.animationResetTimer=setTimeout(function(){n.animationTime=0,n.prevFromRect=null,n.fromRect=null,n.prevToRect=null,n.thisAnimationDuration=null},e),n.thisAnimationDuration=e)}),clearTimeout(t),a?t=setTimeout(function(){"function"==typeof n&&n()},o):"function"==typeof n&&n(),e=[]},animate:function(t,e,n,i){if(i){B(t,"transition",""),B(t,"transform","");var a=k(this.el),o=a&&a.a,r=a&&a.d,s=(e.left-n.left)/(o||1),l=(e.top-n.top)/(r||1);t.animatingX=!!s,t.animatingY=!!l,B(t,"transform","translate3d("+s+"px,"+l+"px,0)"),function(t){t.offsetWidth}(t),B(t,"transition","transform "+i+"ms"+(this.options.easing?" "+this.options.easing:"")),B(t,"transform","translate3d(0,0,0)"),"number"==typeof t.animated&&clearTimeout(t.animated),t.animated=setTimeout(function(){B(t,"transition",""),B(t,"transform",""),t.animated=!1,t.animatingX=!1,t.animatingY=!1},i)}}}}var X=[],V={initializeByDefault:!0},q={mount:function(t){for(var e in V)!V.hasOwnProperty(e)||e in t||(t[e]=V[e]);X.push(t)},pluginEvent:function(t,e,n){var i=this;this.eventCanceled=!1,n.cancel=function(){i.eventCanceled=!0};var a=t+"Global";X.forEach(function(i){e[i.pluginName]&&(e[i.pluginName][a]&&e[i.pluginName][a](r({sortable:e},n)),e.options[i.pluginName]&&e[i.pluginName][t]&&e[i.pluginName][t](r({sortable:e},n)))})},initializePlugins:function(t,e,n,i){for(var a in X.forEach(function(i){var a=i.pluginName;if(t.options[a]||i.initializeByDefault){var r=new i(t,e,t.options);r.sortable=t,r.options=t.options,t[a]=r,o(n,r.defaults)}}),t.options)if(t.options.hasOwnProperty(a)){var r=this.modifyOption(t,a,t.options[a]);void 0!==r&&(t.options[a]=r)}},getEventProperties:function(t,e){var n={};return X.forEach(function(i){"function"==typeof i.eventProperties&&o(n,i.eventProperties.call(e[i.pluginName],t))}),n},modifyOption:function(t,e,n){var i;return X.forEach(function(a){t[a.pluginName]&&a.optionListeners&&"function"==typeof a.optionListeners[e]&&(i=a.optionListeners[e].call(t[a.pluginName],n))}),i}};function W(t){var e=t.sortable,n=t.rootEl,i=t.name,a=t.targetEl,o=t.cloneEl,s=t.toEl,l=t.fromEl,d=t.oldIndex,u=t.newIndex,m=t.oldDraggableIndex,f=t.newDraggableIndex,p=t.originalEvent,_=t.putSortable,A=t.extraEventProperties;if(e=e||n&&n[$]){var b,x=e.options,g="on"+i.charAt(0).toUpperCase()+i.substr(1);!window.CustomEvent||c||h?(b=document.createEvent("Event")).initEvent(i,!0,!0):b=new CustomEvent(i,{bubbles:!0,cancelable:!0}),b.to=s||n,b.from=l||n,b.item=a||n,b.clone=o,b.oldIndex=d,b.newIndex=u,b.oldDraggableIndex=m,b.newDraggableIndex=f,b.originalEvent=p,b.pullMode=_?_.lastPutMode:void 0;var v=r({},A,q.getEventProperties(i,e));for(var C in v)b[C]=v[C];n&&n.dispatchEvent(b),x[g]&&x[g].call(e,b)}}var U=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},i=n.evt,a=s(n,["evt"]);q.pluginEvent.bind(Rt)(t,e,r({dragEl:Z,parentEl:J,ghostEl:Q,rootEl:K,nextEl:tt,lastDownEl:et,cloneEl:nt,cloneHidden:it,dragStarted:_t,putSortable:dt,activeSortable:Rt.active,originalEvent:i,oldIndex:at,oldDraggableIndex:rt,newIndex:ot,newDraggableIndex:st,hideGhostForTarget:jt,unhideGhostForTarget:Pt,cloneNowHidden:function(){it=!0},cloneNowShown:function(){it=!1},dispatchSortableEvent:function(t){G({sortable:e,name:t,originalEvent:i})}},a))};function G(t){W(r({putSortable:dt,cloneEl:nt,targetEl:Z,rootEl:K,oldIndex:at,oldDraggableIndex:rt,newIndex:ot,newDraggableIndex:st},t))}var Z,J,Q,K,tt,et,nt,it,at,ot,rt,st,lt,dt,ct,ht,ut,mt,ft,pt,_t,At,bt,xt,gt,vt=!1,Ct=!1,yt=[],wt=!1,Bt=!1,kt=[],Et=!1,It=[],Dt="undefined"!=typeof document,St=f,Nt=h||c?"cssFloat":"float",Mt=Dt&&!p&&!f&&"draggable"in document.createElement("div"),Ot=function(){if(Dt){if(c)return!1;var t=document.createElement("x");return t.style.cssText="pointer-events:auto","auto"===t.style.pointerEvents}}(),Tt=function(t,e){var n=B(t),i=parseInt(n.width)-parseInt(n.paddingLeft)-parseInt(n.paddingRight)-parseInt(n.borderLeftWidth)-parseInt(n.borderRightWidth),a=N(t,0,e),o=N(t,1,e),r=a&&B(a),s=o&&B(o),l=r&&parseInt(r.marginLeft)+parseInt(r.marginRight)+D(a).width,d=s&&parseInt(s.marginLeft)+parseInt(s.marginRight)+D(o).width;if("flex"===n.display)return"column"===n.flexDirection||"column-reverse"===n.flexDirection?"vertical":"horizontal";if("grid"===n.display)return n.gridTemplateColumns.split(" ").length<=1?"vertical":"horizontal";if(a&&r.float&&"none"!==r.float){var c="left"===r.float?"left":"right";return!o||"both"!==s.clear&&s.clear!==c?"horizontal":"vertical"}return a&&("block"===r.display||"flex"===r.display||"table"===r.display||"grid"===r.display||l>=i&&"none"===n[Nt]||o&&"none"===n[Nt]&&l+d>i)?"vertical":"horizontal"},Lt=function(t){function e(t,n){return function(i,a,o,r){var s=i.options.group.name&&a.options.group.name&&i.options.group.name===a.options.group.name;if(null==t&&(n||s))return!0;if(null==t||!1===t)return!1;if(n&&"clone"===t)return t;if("function"==typeof t)return e(t(i,a,o,r),n)(i,a,o,r);var l=(n?i:a).options.group.name;return!0===t||"string"==typeof t&&t===l||t.join&&t.indexOf(l)>-1}}var n={},a=t.group;a&&"object"==i(a)||(a={name:a}),n.name=a.name,n.checkPull=e(a.pull,!0),n.checkPut=e(a.put),n.revertClone=a.revertClone,t.group=n},jt=function(){!Ot&&Q&&B(Q,"display","none")},Pt=function(){!Ot&&Q&&B(Q,"display","")};Dt&&document.addEventListener("click",function(t){if(Ct)return t.preventDefault(),t.stopPropagation&&t.stopPropagation(),t.stopImmediatePropagation&&t.stopImmediatePropagation(),Ct=!1,!1},!0);var Ft=function(t){if(Z){t=t.touches?t.touches[0]:t;var e=(a=t.clientX,o=t.clientY,yt.some(function(t){if(!M(t)){var e=D(t),n=t[$].options.emptyInsertThreshold,i=a>=e.left-n&&a<=e.right+n,s=o>=e.top-n&&o<=e.bottom+n;return n&&i&&s?r=t:void 0}}),r);if(e){var n={};for(var i in t)t.hasOwnProperty(i)&&(n[i]=t[i]);n.target=n.rootEl=e,n.preventDefault=void 0,n.stopPropagation=void 0,e[$]._onDragOver(n)}}var a,o,r},Yt=function(t){Z&&Z.parentNode[$]._isOutsideThisEl(t.target)};function Rt(t,e){if(!t||!t.nodeType||1!==t.nodeType)throw"Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t));this.el=t,this.options=e=o({},e),t[$]=this;var n={group:null,sort:!0,disabled:!1,store:null,handle:null,draggable:/^[uo]l$/i.test(t.nodeName)?">li":">*",swapThreshold:1,invertSwap:!1,invertedSwapThreshold:null,removeCloneOnHide:!0,direction:function(){return Tt(t,this.options)},ghostClass:"sortable-ghost",chosenClass:"sortable-chosen",dragClass:"sortable-drag",ignore:"a, img",filter:null,preventOnFilter:!0,animation:0,easing:null,setData:function(t,e){t.setData("Text",e.textContent)},dropBubble:!1,dragoverBubble:!1,dataIdAttr:"data-id",delay:0,delayOnTouchOnly:!1,touchStartThreshold:(Number.parseInt?Number:window).parseInt(window.devicePixelRatio,10)||1,forceFallback:!1,fallbackClass:"sortable-fallback",fallbackOnBody:!1,fallbackTolerance:0,fallbackOffset:{x:0,y:0},supportPointer:!1!==Rt.supportPointer&&"PointerEvent"in window,emptyInsertThreshold:5};for(var i in q.initializePlugins(this,t,n),n)!(i in e)&&(e[i]=n[i]);for(var a in Lt(e),this)"_"===a.charAt(0)&&"function"==typeof this[a]&&(this[a]=this[a].bind(this));this.nativeDraggable=!e.forceFallback&&Mt,this.nativeDraggable&&(this.options.touchStartThreshold=1),e.supportPointer?A(t,"pointerdown",this._onTapStart):(A(t,"mousedown",this._onTapStart),A(t,"touchstart",this._onTapStart)),this.nativeDraggable&&(A(t,"dragover",this),A(t,"dragenter",this)),yt.push(this.el),e.store&&e.store.get&&this.sort(e.store.get(this)||[]),o(this,z())}function Ht(t,e,n,i,a,o,r,s){var l,d,u=t[$],m=u.options.onMove;return!window.CustomEvent||c||h?(l=document.createEvent("Event")).initEvent("move",!0,!0):l=new CustomEvent("move",{bubbles:!0,cancelable:!0}),l.to=e,l.from=t,l.dragged=n,l.draggedRect=i,l.related=a||e,l.relatedRect=o||D(e),l.willInsertAfter=s,l.originalEvent=r,t.dispatchEvent(l),m&&(d=m.call(u,l,r)),d}function $t(t){t.draggable=!1}function zt(){Et=!1}function Xt(t){for(var e=t.tagName+t.className+t.src+t.href+t.textContent,n=e.length,i=0;n--;)i+=e.charCodeAt(n);return i.toString(36)}function Vt(t){return setTimeout(t,0)}function qt(t){return clearTimeout(t)}Rt.prototype={constructor:Rt,_isOutsideThisEl:function(t){this.el.contains(t)||t===this.el||(At=null)},_getDirection:function(t,e){return"function"==typeof this.options.direction?this.options.direction.call(this,t,e,Z):this.options.direction},_onTapStart:function(t){if(t.cancelable){var e=this,n=this.el,i=this.options,a=i.preventOnFilter,o=t.type,r=t.touches&&t.touches[0]||t.pointerType&&"touch"===t.pointerType&&t,s=(r||t).target,l=t.target.shadowRoot&&(t.path&&t.path[0]||t.composedPath&&t.composedPath()[0])||s,d=i.filter;if(function(t){It.length=0;var e=t.getElementsByTagName("input"),n=e.length;for(;n--;){var i=e[n];i.checked&&It.push(i)}}(n),!Z&&!(/mousedown|pointerdown/.test(o)&&0!==t.button||i.disabled||l.isContentEditable||(s=v(s,i.draggable,n,!1))&&s.animated||et===s)){if(at=O(s),rt=O(s,i.draggable),"function"==typeof d){if(d.call(this,t,s,this))return G({sortable:e,rootEl:l,name:"filter",targetEl:s,toEl:n,fromEl:n}),U("filter",e,{evt:t}),void(a&&t.cancelable&&t.preventDefault())}else if(d&&(d=d.split(",").some(function(i){if(i=v(l,i.trim(),n,!1))return G({sortable:e,rootEl:i,name:"filter",targetEl:s,fromEl:n,toEl:n}),U("filter",e,{evt:t}),!0})))return void(a&&t.cancelable&&t.preventDefault());i.handle&&!v(l,i.handle,n,!1)||this._prepareDragStart(t,r,s)}}},_prepareDragStart:function(t,e,n){var i,a=this,o=a.el,r=a.options,s=o.ownerDocument;if(n&&!Z&&n.parentNode===o){var l=D(n);if(K=o,J=(Z=n).parentNode,tt=Z.nextSibling,et=n,lt=r.group,Rt.dragged=Z,ct={target:Z,clientX:(e||t).clientX,clientY:(e||t).clientY},ft=ct.clientX-l.left,pt=ct.clientY-l.top,this._lastX=(e||t).clientX,this._lastY=(e||t).clientY,Z.style["will-change"]="all",i=function(){U("delayEnded",a,{evt:t}),Rt.eventCanceled?a._onDrop():(a._disableDelayedDragEvents(),!u&&a.nativeDraggable&&(Z.draggable=!0),a._triggerDragStart(t,e),G({sortable:a,name:"choose",originalEvent:t}),w(Z,r.chosenClass,!0))},r.ignore.split(",").forEach(function(t){E(Z,t.trim(),$t)}),A(s,"dragover",Ft),A(s,"mousemove",Ft),A(s,"touchmove",Ft),A(s,"mouseup",a._onDrop),A(s,"touchend",a._onDrop),A(s,"touchcancel",a._onDrop),u&&this.nativeDraggable&&(this.options.touchStartThreshold=4,Z.draggable=!0),U("delayStart",this,{evt:t}),!r.delay||r.delayOnTouchOnly&&!e||this.nativeDraggable&&(h||c))i();else{if(Rt.eventCanceled)return void this._onDrop();A(s,"mouseup",a._disableDelayedDrag),A(s,"touchend",a._disableDelayedDrag),A(s,"touchcancel",a._disableDelayedDrag),A(s,"mousemove",a._delayedDragTouchMoveHandler),A(s,"touchmove",a._delayedDragTouchMoveHandler),r.supportPointer&&A(s,"pointermove",a._delayedDragTouchMoveHandler),a._dragStartTimer=setTimeout(i,r.delay)}}},_delayedDragTouchMoveHandler:function(t){var e=t.touches?t.touches[0]:t;Math.max(Math.abs(e.clientX-this._lastX),Math.abs(e.clientY-this._lastY))>=Math.floor(this.options.touchStartThreshold/(this.nativeDraggable&&window.devicePixelRatio||1))&&this._disableDelayedDrag()},_disableDelayedDrag:function(){Z&&$t(Z),clearTimeout(this._dragStartTimer),this._disableDelayedDragEvents()},_disableDelayedDragEvents:function(){var t=this.el.ownerDocument;b(t,"mouseup",this._disableDelayedDrag),b(t,"touchend",this._disableDelayedDrag),b(t,"touchcancel",this._disableDelayedDrag),b(t,"mousemove",this._delayedDragTouchMoveHandler),b(t,"touchmove",this._delayedDragTouchMoveHandler),b(t,"pointermove",this._delayedDragTouchMoveHandler)},_triggerDragStart:function(t,e){e=e||"touch"==t.pointerType&&t,!this.nativeDraggable||e?this.options.supportPointer?A(document,"pointermove",this._onTouchMove):A(document,e?"touchmove":"mousemove",this._onTouchMove):(A(Z,"dragend",this),A(K,"dragstart",this._onDragStart));try{document.selection?Vt(function(){document.selection.empty()}):window.getSelection().removeAllRanges()}catch(t){}},_dragStarted:function(t,e){if(vt=!1,K&&Z){U("dragStarted",this,{evt:e}),this.nativeDraggable&&A(document,"dragover",Yt);var n=this.options;!t&&w(Z,n.dragClass,!1),w(Z,n.ghostClass,!0),Rt.active=this,t&&this._appendGhost(),G({sortable:this,name:"start",originalEvent:e})}else this._nulling()},_emulateDragOver:function(){if(ht){this._lastX=ht.clientX,this._lastY=ht.clientY,jt();for(var t=document.elementFromPoint(ht.clientX,ht.clientY),e=t;t&&t.shadowRoot&&(t=t.shadowRoot.elementFromPoint(ht.clientX,ht.clientY))!==e;)e=t;if(Z.parentNode[$]._isOutsideThisEl(t),e)do{if(e[$]){if(e[$]._onDragOver({clientX:ht.clientX,clientY:ht.clientY,target:t,rootEl:e})&&!this.options.dragoverBubble)break}t=e}while(e=e.parentNode);Pt()}},_onTouchMove:function(t){if(ct){var e=this.options,n=e.fallbackTolerance,i=e.fallbackOffset,a=t.touches?t.touches[0]:t,o=Q&&k(Q,!0),r=Q&&o&&o.a,s=Q&&o&&o.d,l=St&&gt&&T(gt),d=(a.clientX-ct.clientX+i.x)/(r||1)+(l?l[0]-kt[0]:0)/(r||1),c=(a.clientY-ct.clientY+i.y)/(s||1)+(l?l[1]-kt[1]:0)/(s||1);if(!Rt.active&&!vt){if(n&&Math.max(Math.abs(a.clientX-this._lastX),Math.abs(a.clientY-this._lastY))<n)return;this._onDragStart(t,!0)}if(Q){o?(o.e+=d-(ut||0),o.f+=c-(mt||0)):o={a:1,b:0,c:0,d:1,e:d,f:c};var h="matrix(".concat(o.a,",").concat(o.b,",").concat(o.c,",").concat(o.d,",").concat(o.e,",").concat(o.f,")");B(Q,"webkitTransform",h),B(Q,"mozTransform",h),B(Q,"msTransform",h),B(Q,"transform",h),ut=d,mt=c,ht=a}t.cancelable&&t.preventDefault()}},_appendGhost:function(){if(!Q){var t=this.options.fallbackOnBody?document.body:K,e=D(Z,!0,St,!0,t),n=this.options;if(St){for(gt=t;"static"===B(gt,"position")&&"none"===B(gt,"transform")&&gt!==document;)gt=gt.parentNode;gt!==document.body&&gt!==document.documentElement?(gt===document&&(gt=I()),e.top+=gt.scrollTop,e.left+=gt.scrollLeft):gt=I(),kt=T(gt)}w(Q=Z.cloneNode(!0),n.ghostClass,!1),w(Q,n.fallbackClass,!0),w(Q,n.dragClass,!0),B(Q,"transition",""),B(Q,"transform",""),B(Q,"box-sizing","border-box"),B(Q,"margin",0),B(Q,"top",e.top),B(Q,"left",e.left),B(Q,"width",e.width),B(Q,"height",e.height),B(Q,"opacity","0.8"),B(Q,"position",St?"absolute":"fixed"),B(Q,"zIndex","100000"),B(Q,"pointerEvents","none"),Rt.ghost=Q,t.appendChild(Q),B(Q,"transform-origin",ft/parseInt(Q.style.width)*100+"% "+pt/parseInt(Q.style.height)*100+"%")}},_onDragStart:function(t,e){var n=this,i=t.dataTransfer,a=n.options;U("dragStart",this,{evt:t}),Rt.eventCanceled?this._onDrop():(U("setupClone",this),Rt.eventCanceled||((nt=Y(Z)).draggable=!1,nt.style["will-change"]="",this._hideClone(),w(nt,this.options.chosenClass,!1),Rt.clone=nt),n.cloneId=Vt(function(){U("clone",n),Rt.eventCanceled||(n.options.removeCloneOnHide||K.insertBefore(nt,Z),n._hideClone(),G({sortable:n,name:"clone"}))}),!e&&w(Z,a.dragClass,!0),e?(Ct=!0,n._loopId=setInterval(n._emulateDragOver,50)):(b(document,"mouseup",n._onDrop),b(document,"touchend",n._onDrop),b(document,"touchcancel",n._onDrop),i&&(i.effectAllowed="move",a.setData&&a.setData.call(n,i,Z)),A(document,"drop",n),B(Z,"transform","translateZ(0)")),vt=!0,n._dragStartId=Vt(n._dragStarted.bind(n,e,t)),A(document,"selectstart",n),_t=!0,m&&B(document.body,"user-select","none"))},_onDragOver:function(t){var e,n,i,a,o=this.el,s=t.target,l=this.options,d=l.group,c=Rt.active,h=lt===d,u=l.sort,m=dt||c,f=this,p=!1;if(!Et){if(void 0!==t.preventDefault&&t.cancelable&&t.preventDefault(),s=v(s,l.draggable,o,!0),j("dragOver"),Rt.eventCanceled)return p;if(Z.contains(t.target)||s.animated&&s.animatingX&&s.animatingY||f._ignoreWhileAnimating===s)return Y(!1);if(Ct=!1,c&&!l.disabled&&(h?u||(i=!K.contains(Z)):dt===this||(this.lastPutMode=lt.checkPull(this,c,Z,t))&&d.checkPut(this,c,Z,t))){if(a="vertical"===this._getDirection(t,s),e=D(Z),j("dragOverValid"),Rt.eventCanceled)return p;if(i)return J=K,P(),this._hideClone(),j("revert"),Rt.eventCanceled||(tt?K.insertBefore(Z,tt):K.appendChild(Z)),Y(!0);var _=M(o,l.draggable);if(!_||function(t,e,n){var i=D(M(n.el,n.options.draggable));return e?t.clientX>i.right+10||t.clientX<=i.right&&t.clientY>i.bottom&&t.clientX>=i.left:t.clientX>i.right&&t.clientY>i.top||t.clientX<=i.right&&t.clientY>i.bottom+10}(t,a,this)&&!_.animated){if(_===Z)return Y(!1);if(_&&o===t.target&&(s=_),s&&(n=D(s)),!1!==Ht(K,o,Z,e,s,n,t,!!s))return P(),o.appendChild(Z),J=o,R(),Y(!0)}else if(s.parentNode===o){n=D(s);var A,b,x,g=Z.parentNode!==o,C=!function(t,e,n){var i=n?t.left:t.top,a=n?t.right:t.bottom,o=n?t.width:t.height,r=n?e.left:e.top,s=n?e.right:e.bottom,l=n?e.width:e.height;return i===r||a===s||i+o/2===r+l/2}(Z.animated&&Z.toRect||e,s.animated&&s.toRect||n,a),y=a?"top":"left",k=S(s,"top","top")||S(Z,"top","top"),E=k?k.scrollTop:void 0;if(At!==s&&(b=n[y],wt=!1,Bt=!C&&l.invertSwap||g),0!==(A=function(t,e,n,i,a,o,r,s){var l=i?t.clientY:t.clientX,d=i?n.height:n.width,c=i?n.top:n.left,h=i?n.bottom:n.right,u=!1;if(!r)if(s&&xt<d*a){if(!wt&&(1===bt?l>c+d*o/2:l<h-d*o/2)&&(wt=!0),wt)u=!0;else if(1===bt?l<c+xt:l>h-xt)return-bt}else if(l>c+d*(1-a)/2&&l<h-d*(1-a)/2)return function(t){return O(Z)<O(t)?1:-1}(e);if((u=u||r)&&(l<c+d*o/2||l>h-d*o/2))return l>c+d/2?1:-1;return 0}(t,s,n,a,C?1:l.swapThreshold,null==l.invertedSwapThreshold?l.swapThreshold:l.invertedSwapThreshold,Bt,At===s))){var I=O(Z);do{I-=A,x=J.children[I]}while(x&&("none"===B(x,"display")||x===Q))}if(0===A||x===s)return Y(!1);At=s,bt=A;var N=s.nextElementSibling,T=!1,L=Ht(K,o,Z,e,s,n,t,T=1===A);if(!1!==L)return 1!==L&&-1!==L||(T=1===L),Et=!0,setTimeout(zt,30),P(),T&&!N?o.appendChild(Z):s.parentNode.insertBefore(Z,T?N:s),k&&F(k,0,E-k.scrollTop),J=Z.parentNode,void 0===b||Bt||(xt=Math.abs(b-D(s)[y])),R(),Y(!0)}if(o.contains(Z))return Y(!1)}return!1}function j(l,d){U(l,f,r({evt:t,isOwner:h,axis:a?"vertical":"horizontal",revert:i,dragRect:e,targetRect:n,canSort:u,fromSortable:m,target:s,completed:Y,onMove:function(n,i){return Ht(K,o,Z,e,n,D(n),t,i)},changed:R},d))}function P(){j("dragOverAnimationCapture"),f.captureAnimationState(),f!==m&&m.captureAnimationState()}function Y(e){return j("dragOverCompleted",{insertion:e}),e&&(h?c._hideClone():c._showClone(f),f!==m&&(w(Z,dt?dt.options.ghostClass:c.options.ghostClass,!1),w(Z,l.ghostClass,!0)),dt!==f&&f!==Rt.active?dt=f:f===Rt.active&&dt&&(dt=null),m===f&&(f._ignoreWhileAnimating=s),f.animateAll(function(){j("dragOverAnimationComplete"),f._ignoreWhileAnimating=null}),f!==m&&(m.animateAll(),m._ignoreWhileAnimating=null)),(s===Z&&!Z.animated||s===o&&!s.animated)&&(At=null),l.dragoverBubble||t.rootEl||s===document||(Z.parentNode[$]._isOutsideThisEl(t.target),!e&&Ft(t)),!l.dragoverBubble&&t.stopPropagation&&t.stopPropagation(),p=!0}function R(){ot=O(Z),st=O(Z,l.draggable),G({sortable:f,name:"change",toEl:o,newIndex:ot,newDraggableIndex:st,originalEvent:t})}},_ignoreWhileAnimating:null,_offMoveEvents:function(){b(document,"mousemove",this._onTouchMove),b(document,"touchmove",this._onTouchMove),b(document,"pointermove",this._onTouchMove),b(document,"dragover",Ft),b(document,"mousemove",Ft),b(document,"touchmove",Ft)},_offUpEvents:function(){var t=this.el.ownerDocument;b(t,"mouseup",this._onDrop),b(t,"touchend",this._onDrop),b(t,"pointerup",this._onDrop),b(t,"touchcancel",this._onDrop),b(document,"selectstart",this)},_onDrop:function(t){var e=this.el,n=this.options;ot=O(Z),st=O(Z,n.draggable),U("drop",this,{evt:t}),J=Z&&Z.parentNode,ot=O(Z),st=O(Z,n.draggable),Rt.eventCanceled?this._nulling():(vt=!1,Bt=!1,wt=!1,clearInterval(this._loopId),clearTimeout(this._dragStartTimer),qt(this.cloneId),qt(this._dragStartId),this.nativeDraggable&&(b(document,"drop",this),b(e,"dragstart",this._onDragStart)),this._offMoveEvents(),this._offUpEvents(),m&&B(document.body,"user-select",""),B(Z,"transform",""),t&&(_t&&(t.cancelable&&t.preventDefault(),!n.dropBubble&&t.stopPropagation()),Q&&Q.parentNode&&Q.parentNode.removeChild(Q),(K===J||dt&&"clone"!==dt.lastPutMode)&&nt&&nt.parentNode&&nt.parentNode.removeChild(nt),Z&&(this.nativeDraggable&&b(Z,"dragend",this),$t(Z),Z.style["will-change"]="",_t&&!vt&&w(Z,dt?dt.options.ghostClass:this.options.ghostClass,!1),w(Z,this.options.chosenClass,!1),G({sortable:this,name:"unchoose",toEl:J,newIndex:null,newDraggableIndex:null,originalEvent:t}),K!==J?(ot>=0&&(G({rootEl:J,name:"add",toEl:J,fromEl:K,originalEvent:t}),G({sortable:this,name:"remove",toEl:J,originalEvent:t}),G({rootEl:J,name:"sort",toEl:J,fromEl:K,originalEvent:t}),G({sortable:this,name:"sort",toEl:J,originalEvent:t})),dt&&dt.save()):ot!==at&&ot>=0&&(G({sortable:this,name:"update",toEl:J,originalEvent:t}),G({sortable:this,name:"sort",toEl:J,originalEvent:t})),Rt.active&&(null!=ot&&-1!==ot||(ot=at,st=rt),G({sortable:this,name:"end",toEl:J,originalEvent:t}),this.save()))),this._nulling())},_nulling:function(){U("nulling",this),K=Z=J=Q=tt=nt=et=it=ct=ht=_t=ot=st=at=rt=At=bt=dt=lt=Rt.dragged=Rt.ghost=Rt.clone=Rt.active=null,It.forEach(function(t){t.checked=!0}),It.length=ut=mt=0},handleEvent:function(t){switch(t.type){case"drop":case"dragend":this._onDrop(t);break;case"dragenter":case"dragover":Z&&(this._onDragOver(t),function(t){t.dataTransfer&&(t.dataTransfer.dropEffect="move");t.cancelable&&t.preventDefault()}(t));break;case"selectstart":t.preventDefault()}},toArray:function(){for(var t,e=[],n=this.el.children,i=0,a=n.length,o=this.options;i<a;i++)v(t=n[i],o.draggable,this.el,!1)&&e.push(t.getAttribute(o.dataIdAttr)||Xt(t));return e},sort:function(t){var e={},n=this.el;this.toArray().forEach(function(t,i){var a=n.children[i];v(a,this.options.draggable,n,!1)&&(e[t]=a)},this),t.forEach(function(t){e[t]&&(n.removeChild(e[t]),n.appendChild(e[t]))})},save:function(){var t=this.options.store;t&&t.set&&t.set(this)},closest:function(t,e){return v(t,e||this.options.draggable,this.el,!1)},option:function(t,e){var n=this.options;if(void 0===e)return n[t];var i=q.modifyOption(this,t,e);n[t]=void 0!==i?i:e,"group"===t&&Lt(n)},destroy:function(){U("destroy",this);var t=this.el;t[$]=null,b(t,"mousedown",this._onTapStart),b(t,"touchstart",this._onTapStart),b(t,"pointerdown",this._onTapStart),this.nativeDraggable&&(b(t,"dragover",this),b(t,"dragenter",this)),Array.prototype.forEach.call(t.querySelectorAll("[draggable]"),function(t){t.removeAttribute("draggable")}),this._onDrop(),this._disableDelayedDragEvents(),yt.splice(yt.indexOf(this.el),1),this.el=t=null},_hideClone:function(){if(!it){if(U("hideClone",this),Rt.eventCanceled)return;B(nt,"display","none"),this.options.removeCloneOnHide&&nt.parentNode&&nt.parentNode.removeChild(nt),it=!0}},_showClone:function(t){if("clone"===t.lastPutMode){if(it){if(U("showClone",this),Rt.eventCanceled)return;K.contains(Z)&&!this.options.group.revertClone?K.insertBefore(nt,Z):tt?K.insertBefore(nt,tt):K.appendChild(nt),this.options.group.revertClone&&this.animate(Z,nt),B(nt,"display",""),it=!1}}else this._hideClone()}},Dt&&A(document,"touchmove",function(t){(Rt.active||vt)&&t.cancelable&&t.preventDefault()}),Rt.utils={on:A,off:b,css:B,find:E,is:function(t,e){return!!v(t,e,t,!1)},extend:function(t,e){if(t&&e)for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n]);return t},throttle:P,closest:v,toggleClass:w,clone:Y,index:O,nextTick:Vt,cancelNextTick:qt,detectDirection:Tt,getChild:N},Rt.get=function(t){return t[$]},Rt.mount=function(){for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];e[0].constructor===Array&&(e=e[0]),e.forEach(function(t){if(!t.prototype||!t.prototype.constructor)throw"Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(t));t.utils&&(Rt.utils=r({},Rt.utils,t.utils)),q.mount(t)})},Rt.create=function(t,e){return new Rt(t,e)},Rt.version="1.10.2";var Wt,Ut,Gt,Zt,Jt,Qt,Kt=[],te=!1;function ee(){Kt.forEach(function(t){clearInterval(t.pid)}),Kt=[]}function ne(){clearInterval(Qt)}var ie,ae=P(function(t,e,n,i){if(e.scroll){var a,o=(t.touches?t.touches[0]:t).clientX,r=(t.touches?t.touches[0]:t).clientY,s=e.scrollSensitivity,l=e.scrollSpeed,d=I(),c=!1;Ut!==n&&(Ut=n,ee(),Wt=e.scroll,a=e.scrollFn,!0===Wt&&(Wt=L(n,!0)));var h=0,u=Wt;do{var m=u,f=D(m),p=f.top,_=f.bottom,A=f.left,b=f.right,x=f.width,g=f.height,v=void 0,C=void 0,y=m.scrollWidth,w=m.scrollHeight,k=B(m),E=m.scrollLeft,S=m.scrollTop;m===d?(v=x<y&&("auto"===k.overflowX||"scroll"===k.overflowX||"visible"===k.overflowX),C=g<w&&("auto"===k.overflowY||"scroll"===k.overflowY||"visible"===k.overflowY)):(v=x<y&&("auto"===k.overflowX||"scroll"===k.overflowX),C=g<w&&("auto"===k.overflowY||"scroll"===k.overflowY));var N=v&&(Math.abs(b-o)<=s&&E+x<y)-(Math.abs(A-o)<=s&&!!E),M=C&&(Math.abs(_-r)<=s&&S+g<w)-(Math.abs(p-r)<=s&&!!S);if(!Kt[h])for(var O=0;O<=h;O++)Kt[O]||(Kt[O]={});Kt[h].vx==N&&Kt[h].vy==M&&Kt[h].el===m||(Kt[h].el=m,Kt[h].vx=N,Kt[h].vy=M,clearInterval(Kt[h].pid),0==N&&0==M||(c=!0,Kt[h].pid=setInterval(function(){i&&0===this.layer&&Rt.active._onTouchMove(Jt);var e=Kt[this.layer].vy?Kt[this.layer].vy*l:0,n=Kt[this.layer].vx?Kt[this.layer].vx*l:0;"function"==typeof a&&"continue"!==a.call(Rt.dragged.parentNode[$],n,e,t,Jt,Kt[this.layer].el)||F(Kt[this.layer].el,n,e)}.bind({layer:h}),24))),h++}while(e.bubbleScroll&&u!==d&&(u=L(u,!1)));te=c}},30),oe=function(t){var e=t.originalEvent,n=t.putSortable,i=t.dragEl,a=t.activeSortable,o=t.dispatchSortableEvent,r=t.hideGhostForTarget,s=t.unhideGhostForTarget;if(e){var l=n||a;r();var d=e.changedTouches&&e.changedTouches.length?e.changedTouches[0]:e,c=document.elementFromPoint(d.clientX,d.clientY);s(),l&&!l.el.contains(c)&&(o("spill"),this.onSpill({dragEl:i,putSortable:n}))}};function re(){}function se(){}function le(){function t(){this.defaults={swapClass:"sortable-swap-highlight"}}return t.prototype={dragStart:function(t){var e=t.dragEl;ie=e},dragOverValid:function(t){var e=t.completed,n=t.target,i=t.onMove,a=t.activeSortable,o=t.changed,r=t.cancel;if(a.options.swap){var s=this.sortable.el,l=this.options;if(n&&n!==s){var d=ie;!1!==i(n)?(w(n,l.swapClass,!0),ie=n):ie=null,d&&d!==ie&&w(d,l.swapClass,!1)}o(),e(!0),r()}},drop:function(t){var e=t.activeSortable,n=t.putSortable,i=t.dragEl,a=n||this.sortable,o=this.options;ie&&w(ie,o.swapClass,!1),ie&&(o.swap||n&&n.options.swap)&&i!==ie&&(a.captureAnimationState(),a!==e&&e.captureAnimationState(),function(t,e){var n,i,a=t.parentNode,o=e.parentNode;if(!a||!o||a.isEqualNode(e)||o.isEqualNode(t))return;n=O(t),i=O(e),a.isEqualNode(o)&&n<i&&i++;a.insertBefore(e,a.children[n]),o.insertBefore(t,o.children[i])}(i,ie),a.animateAll(),a!==e&&e.animateAll())},nulling:function(){ie=null}},o(t,{pluginName:"swap",eventProperties:function(){return{swapItem:ie}}})}re.prototype={startIndex:null,dragStart:function(t){var e=t.oldDraggableIndex;this.startIndex=e},onSpill:function(t){var e=t.dragEl,n=t.putSortable;this.sortable.captureAnimationState(),n&&n.captureAnimationState();var i=N(this.sortable.el,this.startIndex,this.options);i?this.sortable.el.insertBefore(e,i):this.sortable.el.appendChild(e),this.sortable.animateAll(),n&&n.animateAll()},drop:oe},o(re,{pluginName:"revertOnSpill"}),se.prototype={onSpill:function(t){var e=t.dragEl,n=t.putSortable||this.sortable;n.captureAnimationState(),e.parentNode&&e.parentNode.removeChild(e),n.animateAll()},drop:oe},o(se,{pluginName:"removeOnSpill"});var de,ce,he,ue,me,fe=[],pe=[],_e=!1,Ae=!1,be=!1;function xe(){function t(t){for(var e in this)"_"===e.charAt(0)&&"function"==typeof this[e]&&(this[e]=this[e].bind(this));t.options.supportPointer?A(document,"pointerup",this._deselectMultiDrag):(A(document,"mouseup",this._deselectMultiDrag),A(document,"touchend",this._deselectMultiDrag)),A(document,"keydown",this._checkKeyDown),A(document,"keyup",this._checkKeyUp),this.defaults={selectedClass:"sortable-selected",multiDragKey:null,setData:function(e,n){var i="";fe.length&&ce===t?fe.forEach(function(t,e){i+=(e?", ":"")+t.textContent}):i=n.textContent,e.setData("Text",i)}}}return t.prototype={multiDragKeyDown:!1,isMultiDrag:!1,delayStartGlobal:function(t){var e=t.dragEl;he=e},delayEnded:function(){this.isMultiDrag=~fe.indexOf(he)},setupClone:function(t){var e=t.sortable,n=t.cancel;if(this.isMultiDrag){for(var i=0;i<fe.length;i++)pe.push(Y(fe[i])),pe[i].sortableIndex=fe[i].sortableIndex,pe[i].draggable=!1,pe[i].style["will-change"]="",w(pe[i],this.options.selectedClass,!1),fe[i]===he&&w(pe[i],this.options.chosenClass,!1);e._hideClone(),n()}},clone:function(t){var e=t.sortable,n=t.rootEl,i=t.dispatchSortableEvent,a=t.cancel;this.isMultiDrag&&(this.options.removeCloneOnHide||fe.length&&ce===e&&(ge(!0,n),i("clone"),a()))},showClone:function(t){var e=t.cloneNowShown,n=t.rootEl,i=t.cancel;this.isMultiDrag&&(ge(!1,n),pe.forEach(function(t){B(t,"display","")}),e(),me=!1,i())},hideClone:function(t){var e=this,n=(t.sortable,t.cloneNowHidden),i=t.cancel;this.isMultiDrag&&(pe.forEach(function(t){B(t,"display","none"),e.options.removeCloneOnHide&&t.parentNode&&t.parentNode.removeChild(t)}),n(),me=!0,i())},dragStartGlobal:function(t){t.sortable;!this.isMultiDrag&&ce&&ce.multiDrag._deselectMultiDrag(),fe.forEach(function(t){t.sortableIndex=O(t)}),fe=fe.sort(function(t,e){return t.sortableIndex-e.sortableIndex}),be=!0},dragStarted:function(t){var e=this,n=t.sortable;if(this.isMultiDrag){if(this.options.sort&&(n.captureAnimationState(),this.options.animation)){fe.forEach(function(t){t!==he&&B(t,"position","absolute")});var i=D(he,!1,!0,!0);fe.forEach(function(t){t!==he&&R(t,i)}),Ae=!0,_e=!0}n.animateAll(function(){Ae=!1,_e=!1,e.options.animation&&fe.forEach(function(t){H(t)}),e.options.sort&&ve()})}},dragOver:function(t){var e=t.target,n=t.completed,i=t.cancel;Ae&&~fe.indexOf(e)&&(n(!1),i())},revert:function(t){var e=t.fromSortable,n=t.rootEl,i=t.sortable,a=t.dragRect;fe.length>1&&(fe.forEach(function(t){i.addAnimationState({target:t,rect:Ae?D(t):a}),H(t),t.fromRect=a,e.removeAnimationState(t)}),Ae=!1,function(t,e){fe.forEach(function(n,i){var a=e.children[n.sortableIndex+(t?Number(i):0)];a?e.insertBefore(n,a):e.appendChild(n)})}(!this.options.removeCloneOnHide,n))},dragOverCompleted:function(t){var e=t.sortable,n=t.isOwner,i=t.insertion,a=t.activeSortable,o=t.parentEl,r=t.putSortable,s=this.options;if(i){if(n&&a._hideClone(),_e=!1,s.animation&&fe.length>1&&(Ae||!n&&!a.options.sort&&!r)){var l=D(he,!1,!0,!0);fe.forEach(function(t){t!==he&&(R(t,l),o.appendChild(t))}),Ae=!0}if(!n)if(Ae||ve(),fe.length>1){var d=me;a._showClone(e),a.options.animation&&!me&&d&&pe.forEach(function(t){a.addAnimationState({target:t,rect:ue}),t.fromRect=ue,t.thisAnimationDuration=null})}else a._showClone(e)}},dragOverAnimationCapture:function(t){var e=t.dragRect,n=t.isOwner,i=t.activeSortable;if(fe.forEach(function(t){t.thisAnimationDuration=null}),i.options.animation&&!n&&i.multiDrag.isMultiDrag){ue=o({},e);var a=k(he,!0);ue.top-=a.f,ue.left-=a.e}},dragOverAnimationComplete:function(){Ae&&(Ae=!1,ve())},drop:function(t){var e=t.originalEvent,n=t.rootEl,i=t.parentEl,a=t.sortable,o=t.dispatchSortableEvent,r=t.oldIndex,s=t.putSortable,l=s||this.sortable;if(e){var d=this.options,c=i.children;if(!be)if(d.multiDragKey&&!this.multiDragKeyDown&&this._deselectMultiDrag(),w(he,d.selectedClass,!~fe.indexOf(he)),~fe.indexOf(he))fe.splice(fe.indexOf(he),1),de=null,W({sortable:a,rootEl:n,name:"deselect",targetEl:he,originalEvt:e});else{if(fe.push(he),W({sortable:a,rootEl:n,name:"select",targetEl:he,originalEvt:e}),e.shiftKey&&de&&a.el.contains(de)){var h,u,m=O(de),f=O(he);if(~m&&~f&&m!==f)for(f>m?(u=m,h=f):(u=f,h=m+1);u<h;u++)~fe.indexOf(c[u])||(w(c[u],d.selectedClass,!0),fe.push(c[u]),W({sortable:a,rootEl:n,name:"select",targetEl:c[u],originalEvt:e}))}else de=he;ce=l}if(be&&this.isMultiDrag){if((i[$].options.sort||i!==n)&&fe.length>1){var p=D(he),_=O(he,":not(."+this.options.selectedClass+")");if(!_e&&d.animation&&(he.thisAnimationDuration=null),l.captureAnimationState(),!_e&&(d.animation&&(he.fromRect=p,fe.forEach(function(t){if(t.thisAnimationDuration=null,t!==he){var e=Ae?D(t):p;t.fromRect=e,l.addAnimationState({target:t,rect:e})}})),ve(),fe.forEach(function(t){c[_]?i.insertBefore(t,c[_]):i.appendChild(t),_++}),r===O(he))){var A=!1;fe.forEach(function(t){t.sortableIndex===O(t)||(A=!0)}),A&&o("update")}fe.forEach(function(t){H(t)}),l.animateAll()}ce=l}(n===i||s&&"clone"!==s.lastPutMode)&&pe.forEach(function(t){t.parentNode&&t.parentNode.removeChild(t)})}},nullingGlobal:function(){this.isMultiDrag=be=!1,pe.length=0},destroyGlobal:function(){this._deselectMultiDrag(),b(document,"pointerup",this._deselectMultiDrag),b(document,"mouseup",this._deselectMultiDrag),b(document,"touchend",this._deselectMultiDrag),b(document,"keydown",this._checkKeyDown),b(document,"keyup",this._checkKeyUp)},_deselectMultiDrag:function(t){if(!(void 0!==be&&be||ce!==this.sortable||t&&v(t.target,this.options.draggable,this.sortable.el,!1)||t&&0!==t.button))for(;fe.length;){var e=fe[0];w(e,this.options.selectedClass,!1),fe.shift(),W({sortable:this.sortable,rootEl:this.sortable.el,name:"deselect",targetEl:e,originalEvt:t})}},_checkKeyDown:function(t){t.key===this.options.multiDragKey&&(this.multiDragKeyDown=!0)},_checkKeyUp:function(t){t.key===this.options.multiDragKey&&(this.multiDragKeyDown=!1)}},o(t,{pluginName:"multiDrag",utils:{select:function(t){var e=t.parentNode[$];e&&e.options.multiDrag&&!~fe.indexOf(t)&&(ce&&ce!==e&&(ce.multiDrag._deselectMultiDrag(),ce=e),w(t,e.options.selectedClass,!0),fe.push(t))},deselect:function(t){var e=t.parentNode[$],n=fe.indexOf(t);e&&e.options.multiDrag&&~n&&(w(t,e.options.selectedClass,!1),fe.splice(n,1))}},eventProperties:function(){var t=this,e=[],n=[];return fe.forEach(function(i){var a;e.push({multiDragElement:i,index:i.sortableIndex}),a=Ae&&i!==he?-1:Ae?O(i,":not(."+t.options.selectedClass+")"):O(i),n.push({multiDragElement:i,index:a})}),{items:l(fe),clones:[].concat(pe),oldIndicies:e,newIndicies:n}},optionListeners:{multiDragKey:function(t){return"ctrl"===(t=t.toLowerCase())?t="Control":t.length>1&&(t=t.charAt(0).toUpperCase()+t.substr(1)),t}}})}function ge(t,e){pe.forEach(function(n,i){var a=e.children[n.sortableIndex+(t?Number(i):0)];a?e.insertBefore(n,a):e.appendChild(n)})}function ve(){fe.forEach(function(t){t!==he&&t.parentNode&&t.parentNode.removeChild(t)})}Rt.mount(new function(){function t(){for(var t in this.defaults={scroll:!0,scrollSensitivity:30,scrollSpeed:10,bubbleScroll:!0},this)"_"===t.charAt(0)&&"function"==typeof this[t]&&(this[t]=this[t].bind(this))}return t.prototype={dragStarted:function(t){var e=t.originalEvent;this.sortable.nativeDraggable?A(document,"dragover",this._handleAutoScroll):this.options.supportPointer?A(document,"pointermove",this._handleFallbackAutoScroll):e.touches?A(document,"touchmove",this._handleFallbackAutoScroll):A(document,"mousemove",this._handleFallbackAutoScroll)},dragOverCompleted:function(t){var e=t.originalEvent;this.options.dragOverBubble||e.rootEl||this._handleAutoScroll(e)},drop:function(){this.sortable.nativeDraggable?b(document,"dragover",this._handleAutoScroll):(b(document,"pointermove",this._handleFallbackAutoScroll),b(document,"touchmove",this._handleFallbackAutoScroll),b(document,"mousemove",this._handleFallbackAutoScroll)),ne(),ee(),clearTimeout(C),C=void 0},nulling:function(){Jt=Ut=Wt=te=Qt=Gt=Zt=null,Kt.length=0},_handleFallbackAutoScroll:function(t){this._handleAutoScroll(t,!0)},_handleAutoScroll:function(t,e){var n=this,i=(t.touches?t.touches[0]:t).clientX,a=(t.touches?t.touches[0]:t).clientY,o=document.elementFromPoint(i,a);if(Jt=t,e||h||c||m){ae(t,this.options,o,e);var r=L(o,!0);!te||Qt&&i===Gt&&a===Zt||(Qt&&ne(),Qt=setInterval(function(){var o=L(document.elementFromPoint(i,a),!0);o!==r&&(r=o,ee()),ae(t,n.options,o,e)},10),Gt=i,Zt=a)}else{if(!this.options.bubbleScroll||L(o,!0)===I())return void ee();ae(t,this.options,L(o,!1),!1)}}},o(t,{pluginName:"scroll",initializeByDefault:!0})}),Rt.mount(se,re),e.default=Rt},"/mhn":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},n={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"};t.defineLocale("ne",{months:"जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर".split("_"),monthsShort:"जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.".split("_"),monthsParseExact:!0,weekdays:"आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार".split("_"),weekdaysShort:"आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.".split("_"),weekdaysMin:"आ._सो._मं._बु._बि._शु._श.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"Aको h:mm बजे",LTS:"Aको h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, Aको h:mm बजे",LLLL:"dddd, D MMMM YYYY, Aको h:mm बजे"},preparse:function(t){return t.replace(/[१२३४५६७८९०]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/राति|बिहान|दिउँसो|साँझ/,meridiemHour:function(t,e){return 12===t&&(t=0),"राति"===e?t<4?t:t+12:"बिहान"===e?t:"दिउँसो"===e?t>=10?t:t+12:"साँझ"===e?t+12:void 0},meridiem:function(t,e,n){return t<3?"राति":t<12?"बिहान":t<16?"दिउँसो":t<20?"साँझ":"राति"},calendar:{sameDay:"[आज] LT",nextDay:"[भोलि] LT",nextWeek:"[आउँदो] dddd[,] LT",lastDay:"[हिजो] LT",lastWeek:"[गएको] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%sमा",past:"%s अगाडि",s:"केही क्षण",ss:"%d सेकेण्ड",m:"एक मिनेट",mm:"%d मिनेट",h:"एक घण्टा",hh:"%d घण्टा",d:"एक दिन",dd:"%d दिन",M:"एक महिना",MM:"%d महिना",y:"एक बर्ष",yy:"%d बर्ष"},week:{dow:0,doy:6}})})(n("PJh5"))},0:function(t,e){},"0/jl":function(t,e,n){"use strict";var i=n("YjQv"),a=n("x//u"),o=n("qs+f"),r=n("Wdy1"),s=n("1RnF"),l=n("+zJ9").KEY,d=n("zyKz"),c=n("a/OS"),h=n("LhDF"),u=n("GmwO"),m=n("hgbu"),f=n("4DQ7"),p=n("Ntt2"),_=n("6rdy"),A=n("NU0k"),b=n("FKWp"),x=n("8ANE"),g=n("wXdB"),v=n("ksFB"),C=n("9MbE"),y=n("YTz9"),w=n("NZ8V"),B=n("6tLb"),k=n("rjjF"),E=n("THEY"),I=n("GCs6"),D=n("pEGt"),S=k.f,N=I.f,M=B.f,O=i.Symbol,T=i.JSON,L=T&&T.stringify,j=m("_hidden"),P=m("toPrimitive"),F={}.propertyIsEnumerable,Y=c("symbol-registry"),R=c("symbols"),H=c("op-symbols"),$=Object.prototype,z="function"==typeof O&&!!E.f,X=i.QObject,V=!X||!X.prototype||!X.prototype.findChild,q=o&&d(function(){return 7!=w(N({},"a",{get:function(){return N(this,"a",{value:7}).a}})).a})?function(t,e,n){var i=S($,e);i&&delete $[e],N(t,e,n),i&&t!==$&&N($,e,i)}:N,W=function(t){var e=R[t]=w(O.prototype);return e._k=t,e},U=z&&"symbol"==typeof O.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof O},G=function(t,e,n){return t===$&&G(H,e,n),b(t),e=C(e,!0),b(n),a(R,e)?(n.enumerable?(a(t,j)&&t[j][e]&&(t[j][e]=!1),n=w(n,{enumerable:y(0,!1)})):(a(t,j)||N(t,j,y(1,{})),t[j][e]=!0),q(t,e,n)):N(t,e,n)},Z=function(t,e){b(t);for(var n,i=_(e=v(e)),a=0,o=i.length;o>a;)G(t,n=i[a++],e[n]);return t},J=function(t){var e=F.call(this,t=C(t,!0));return!(this===$&&a(R,t)&&!a(H,t))&&(!(e||!a(this,t)||!a(R,t)||a(this,j)&&this[j][t])||e)},Q=function(t,e){if(t=v(t),e=C(e,!0),t!==$||!a(R,e)||a(H,e)){var n=S(t,e);return!n||!a(R,e)||a(t,j)&&t[j][e]||(n.enumerable=!0),n}},K=function(t){for(var e,n=M(v(t)),i=[],o=0;n.length>o;)a(R,e=n[o++])||e==j||e==l||i.push(e);return i},tt=function(t){for(var e,n=t===$,i=M(n?H:v(t)),o=[],r=0;i.length>r;)!a(R,e=i[r++])||n&&!a($,e)||o.push(R[e]);return o};z||(s((O=function(){if(this instanceof O)throw TypeError("Symbol is not a constructor!");var t=u(arguments.length>0?arguments[0]:void 0),e=function(n){this===$&&e.call(H,n),a(this,j)&&a(this[j],t)&&(this[j][t]=!1),q(this,t,y(1,n))};return o&&V&&q($,t,{configurable:!0,set:e}),W(t)}).prototype,"toString",function(){return this._k}),k.f=Q,I.f=G,n("2m2c").f=B.f=K,n("bSeU").f=J,E.f=tt,o&&!n("c8Kh")&&s($,"propertyIsEnumerable",J,!0),f.f=function(t){return W(m(t))}),r(r.G+r.W+r.F*!z,{Symbol:O});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)m(et[nt++]);for(var it=D(m.store),at=0;it.length>at;)p(it[at++]);r(r.S+r.F*!z,"Symbol",{for:function(t){return a(Y,t+="")?Y[t]:Y[t]=O(t)},keyFor:function(t){if(!U(t))throw TypeError(t+" is not a symbol!");for(var e in Y)if(Y[e]===t)return e},useSetter:function(){V=!0},useSimple:function(){V=!1}}),r(r.S+r.F*!z,"Object",{create:function(t,e){return void 0===e?w(t):Z(w(t),e)},defineProperty:G,defineProperties:Z,getOwnPropertyDescriptor:Q,getOwnPropertyNames:K,getOwnPropertySymbols:tt});var ot=d(function(){E.f(1)});r(r.S+r.F*ot,"Object",{getOwnPropertySymbols:function(t){return E.f(g(t))}}),T&&r(r.S+r.F*(!z||d(function(){var t=O();return"[null]"!=L([t])||"{}"!=L({a:t})||"{}"!=L(Object(t))})),"JSON",{stringify:function(t){for(var e,n,i=[t],a=1;arguments.length>a;)i.push(arguments[a++]);if(n=e=i[1],(x(e)||void 0!==t)&&!U(t))return A(e)||(e=function(t,e){if("function"==typeof n&&(e=n.call(this,t,e)),!U(e))return e}),i[1]=e,L.apply(T,i)}}),O.prototype[P]||n("aLzV")(O.prototype,P,O.prototype.valueOf),h(O,"Symbol"),h(Math,"Math",!0),h(i.JSON,"JSON",!0)},"0/sM":function(t,e,n){var i=n("01I9");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("58b98179",i,!0,{})},"01I9":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n#link11:checked ~ #person,\n#link22:checked ~ #company {\n  display: block !important;\n}\n.content {\n  display: none;\n}\n.formGeneralInfor {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n.marginLeft15 {\n  margin-left: 15px !important;\n}\n.marginRight10 {\n  margin-right: 10px;\n}\n.radio-inline {\n  margin-top: 0;\n  margin-left: 0px !important;\n}\n.boxPersonal {\n  border-radius: 5px !important;\n}\ninput:checked + label {\n  font-weight: bold;\n}\n.mediumSize {\n  font-size: medium !important;\n}\n.marginCustomLabel {\n  margin-top: 2px;\n}\n.titlesContact {\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfContacts/PfContact/PfContact.css"],names:[],mappings:";AACA;;EAEE,0BAA0B;CAC3B;AACD;EACE,cAAc;CACf;AACD;EACE,6BAA6B;EAC7B,8BAA8B;CAC/B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,cAAc;EACd,4BAA4B;CAC7B;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,kBAAkB;CACnB;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,gBAAgB;CACjB;AACD;EACE,2BAA2B;EAC3B,4BAA4B;CAC7B",file:"PfContact.css",sourcesContent:["\n#link11:checked ~ #person,\n#link22:checked ~ #company {\n  display: block !important;\n}\n.content {\n  display: none;\n}\n.formGeneralInfor {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n.marginLeft15 {\n  margin-left: 15px !important;\n}\n.marginRight10 {\n  margin-right: 10px;\n}\n.radio-inline {\n  margin-top: 0;\n  margin-left: 0px !important;\n}\n.boxPersonal {\n  border-radius: 5px !important;\n}\ninput:checked + label {\n  font-weight: bold;\n}\n.mediumSize {\n  font-size: medium !important;\n}\n.marginCustomLabel {\n  margin-top: 2px;\n}\n.titlesContact {\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n}\n"],sourceRoot:""}])},"0Lvz":function(t,e,n){var i=n("W6Rd"),a=n("+MZ2");t.exports=function(t){return function(e,n){var o,r,s=String(a(e)),l=i(n),d=s.length;return l<0||l>=d?t?"":void 0:(o=s.charCodeAt(l))<55296||o>56319||l+1===d||(r=s.charCodeAt(l+1))<56320||r>57343?t?s.charAt(l):o:t?s.slice(l,l+2):r-56320+(o-55296<<10)+65536}}},"0U3T":function(t,e,n){var i=n("3Atc");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("20d31086",i,!0,{})},"0X8Q":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("vi",{months:"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),monthsShort:"Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split("_"),monthsParseExact:!0,weekdays:"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysParseExact:!0,meridiemParse:/sa|ch/i,isPM:function(t){return/^ch$/i.test(t)},meridiem:function(t,e,n){return t<12?n?"sa":"SA":n?"ch":"CH"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [năm] YYYY",LLL:"D MMMM [năm] YYYY HH:mm",LLLL:"dddd, D MMMM [năm] YYYY HH:mm",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[Hôm nay lúc] LT",nextDay:"[Ngày mai lúc] LT",nextWeek:"dddd [tuần tới lúc] LT",lastDay:"[Hôm qua lúc] LT",lastWeek:"dddd [tuần trước lúc] LT",sameElse:"L"},relativeTime:{future:"%s tới",past:"%s trước",s:"vài giây",ss:"%d giây",m:"một phút",mm:"%d phút",h:"một giờ",hh:"%d giờ",d:"một ngày",dd:"%d ngày",w:"một tuần",ww:"%d tuần",M:"một tháng",MM:"%d tháng",y:"một năm",yy:"%d năm"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(t){return t},week:{dow:1,doy:4}})})(n("PJh5"))},"0bxm":function(t,e,n){var i=n("vLy8");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("0be69319",i,!0,{})},"0hSb":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-5e407ef2] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-5e407ef2]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-5e407ef2] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-5e407ef2] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-5e407ef2] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-5e407ef2] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-5e407ef2] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-5e407ef2] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-5e407ef2] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-5e407ef2] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-5e407ef2] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-5e407ef2] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-5e407ef2] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-5e407ef2] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-5e407ef2] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-5e407ef2] {\n  margin-right: 0px;\n}\n.newItem[data-v-5e407ef2] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-5e407ef2] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-5e407ef2] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-5e407ef2] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-5e407ef2] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-5e407ef2] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-5e407ef2] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-5e407ef2] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-5e407ef2] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-5e407ef2] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-5e407ef2]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-5e407ef2] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-5e407ef2] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-5e407ef2] {\n  color: red;\n}\n.showMore[data-v-5e407ef2]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-5e407ef2] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-5e407ef2] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-5e407ef2] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-5e407ef2 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-5e407ef2 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-5e407ef2] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-5e407ef2 3s infinite;\n  animation: bit-data-v-5e407ef2 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-5e407ef2] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-5e407ef2]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-5e407ef2]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-5e407ef2]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-5e407ef2]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-5e407ef2]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-5e407ef2]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-5e407ef2] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-5e407ef2]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-5e407ef2] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-5e407ef2] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-5e407ef2] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-5e407ef2] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-5e407ef2] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-5e407ef2] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-5e407ef2] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-5e407ef2] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-5e407ef2] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-5e407ef2] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-5e407ef2] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-5e407ef2] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-5e407ef2] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-5e407ef2] {\n  margin-right: 0px;\n}\n.newItem[data-v-5e407ef2] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-5e407ef2] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-5e407ef2] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-5e407ef2] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-5e407ef2] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-5e407ef2] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-5e407ef2] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-5e407ef2] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-5e407ef2] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-5e407ef2] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-5e407ef2]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-5e407ef2] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-5e407ef2] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-5e407ef2] {\n  color: red;\n}\n.showMore[data-v-5e407ef2]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-5e407ef2] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-5e407ef2] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-5e407ef2] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-5e407ef2 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-5e407ef2 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-5e407ef2] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-5e407ef2 3s infinite;\n  animation: bit-data-v-5e407ef2 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-5e407ef2] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-5e407ef2]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-5e407ef2]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-5e407ef2]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-5e407ef2]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-5e407ef2]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-5e407ef2]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},"0pHi":function(t,e){t.exports="data:image/gif;base64,R0lGODlhCgAMAMQUAFZWVoiIiOLi4nx8fF1dXePj41JSUqioqKCgoF9fX8TExG1tbcnJyUtLS2tra1VVVcXFxU5OTvT09FdXV/r6+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTQgNzkuMTUxNDgxLCAyMDEzLzAzLzEzLTEyOjA5OjE1ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjcwMjE0OTM5QTkxMzExRTNBQUVDQkZEQUJBRDNBRkVDIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjcwMjE0OTNBQTkxMzExRTNBQUVDQkZEQUJBRDNBRkVDIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzAyMTQ5MzdBOTEzMTFFM0FBRUNCRkRBQkFEM0FGRUMiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NzAyMTQ5MzhBOTEzMTFFM0FBRUNCRkRBQkFEM0FGRUMiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQBAAAUACwAAAAACgAMAAAFLyAljqIwkKKERAaqJBEwjWbzTDilsnj/xr0exBEM6g6E4kxUCBRRjEUPdUxSmYEQADs="},"19IS":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-6fd46207] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6fd46207]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6fd46207] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6fd46207] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6fd46207] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6fd46207] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6fd46207] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6fd46207] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6fd46207] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6fd46207] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6fd46207] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6fd46207] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6fd46207] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6fd46207] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6fd46207] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6fd46207] {\n  margin-right: 0px;\n}\n.newItem[data-v-6fd46207] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6fd46207] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6fd46207] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6fd46207] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6fd46207] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6fd46207] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6fd46207] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6fd46207] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6fd46207] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6fd46207] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6fd46207]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6fd46207] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6fd46207] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6fd46207] {\n  color: red;\n}\n.showMore[data-v-6fd46207]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6fd46207] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6fd46207] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6fd46207] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6fd46207 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6fd46207 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6fd46207] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6fd46207 3s infinite;\n  animation: bit-data-v-6fd46207 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6fd46207] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6fd46207]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6fd46207]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6fd46207]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6fd46207]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6fd46207]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6fd46207]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-6fd46207] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6fd46207]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6fd46207] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6fd46207] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6fd46207] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6fd46207] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6fd46207] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6fd46207] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6fd46207] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6fd46207] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6fd46207] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6fd46207] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6fd46207] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6fd46207] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6fd46207] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6fd46207] {\n  margin-right: 0px;\n}\n.newItem[data-v-6fd46207] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6fd46207] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6fd46207] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6fd46207] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6fd46207] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6fd46207] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6fd46207] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6fd46207] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6fd46207] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6fd46207] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6fd46207]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6fd46207] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6fd46207] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6fd46207] {\n  color: red;\n}\n.showMore[data-v-6fd46207]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6fd46207] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6fd46207] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6fd46207] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6fd46207 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6fd46207 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6fd46207] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6fd46207 3s infinite;\n  animation: bit-data-v-6fd46207 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6fd46207] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6fd46207]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6fd46207]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6fd46207]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6fd46207]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6fd46207]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6fd46207]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},"1C9R":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"১",2:"২",3:"৩",4:"৪",5:"৫",6:"৬",7:"৭",8:"৮",9:"৯",0:"০"},n={"১":"1","২":"2","৩":"3","৪":"4","৫":"5","৬":"6","৭":"7","৮":"8","৯":"9","০":"0"};t.defineLocale("bn-bd",{months:"জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),monthsShort:"জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),weekdays:"রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),weekdaysShort:"রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),weekdaysMin:"রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),longDateFormat:{LT:"A h:mm সময়",LTS:"A h:mm:ss সময়",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm সময়",LLLL:"dddd, D MMMM YYYY, A h:mm সময়"},calendar:{sameDay:"[আজ] LT",nextDay:"[আগামীকাল] LT",nextWeek:"dddd, LT",lastDay:"[গতকাল] LT",lastWeek:"[গত] dddd, LT",sameElse:"L"},relativeTime:{future:"%s পরে",past:"%s আগে",s:"কয়েক সেকেন্ড",ss:"%d সেকেন্ড",m:"এক মিনিট",mm:"%d মিনিট",h:"এক ঘন্টা",hh:"%d ঘন্টা",d:"এক দিন",dd:"%d দিন",M:"এক মাস",MM:"%d মাস",y:"এক বছর",yy:"%d বছর"},preparse:function(t){return t.replace(/[১২৩৪৫৬৭৮৯০]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,meridiemHour:function(t,e){return 12===t&&(t=0),"রাত"===e?t<4?t:t+12:"ভোর"===e?t:"সকাল"===e?t:"দুপুর"===e?t>=3?t:t+12:"বিকাল"===e?t+12:"সন্ধ্যা"===e?t+12:void 0},meridiem:function(t,e,n){return t<4?"রাত":t<6?"ভোর":t<12?"সকাল":t<15?"দুপুর":t<18?"বিকাল":t<20?"সন্ধ্যা":"রাত"},week:{dow:0,doy:6}})})(n("PJh5"))},"1H3f":function(t,e){t.exports="data:image/png;base64,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"},"1H6C":function(t,e,n){var i=function(){return this}()||Function("return this")(),a=i.regeneratorRuntime&&Object.getOwnPropertyNames(i).indexOf("regeneratorRuntime")>=0,o=a&&i.regeneratorRuntime;if(i.regeneratorRuntime=void 0,t.exports=n("HhN8"),a)i.regeneratorRuntime=o;else try{delete i.regeneratorRuntime}catch(t){i.regeneratorRuntime=void 0}},"1Kqf":function(t,e,n){var i=n("kxFB");(t.exports=n("FZ+f")(!0)).push([t.i,"/*\nProduct Name: dhtmlxSuite \nVersion: 5.1.0 \nEdition: Standard \nLicense: content of this file is covered by DHTMLX Commercial or enterpri. Usage outside GPL terms is prohibited. To obtain Commercial or Enterprise license contact sales@dhtmlx.com\nCopyright UAB Dinamenta http://www.dhtmlx.com\n*/\n\n/*\n\tskin detected: dhx_web\n\tinclude extra file: skins/dhx_web.less\n*/\n.dhtmlxcalendar_dhx_web {\n\tposition: absolute;\n\tdisplay: block;\n\tbackground-color: #ffffff;\n\tfont-family: Tahoma, Helvetica;\n\tfont-size: 12px;\n\tcolor: #000000;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n\t-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.25);\n\t        box-shadow: 0 0 6px rgba(0,0,0,0.25);\n}\n.dhtmlxcalendar_ifr {\n\tposition: absolute;\n\toverflow: hidden;\n\tbackground-color: white;\n}\n.dhtmlxcalendar_dhx_web ul.dhtmlxcalendar_line {\n\tposition: relative;\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\twidth: 225px;\n}\n.dhtmlxcalendar_dhx_web ul.dhtmlxcalendar_line li {\n\tfloat: left;\n\tposition: relative;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcursor: default;\n\toverflow: hidden;\n\tmargin: 0px;\n\tpadding: 0px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 227px;\n\theight: 27px;\n\tmargin: 0px;\n\tbackground-color: #3da0e3;\n\toverflow: hidden;\n\tcolor: #ffffff;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr {\n\twidth: 227px;\n\theight: 27px;\n\tline-height: 27px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow {\n\tposition: absolute;\n\ttop: 0px;\n\twidth: 18px;\n\theight: 27px;\n\tcolor: inherit;\n\ttext-align: center;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left {\n\tleft: 4px;\n\tbackground-image: url("+i(n("Jk0y"))+");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left_hover {\n\tleft: 4px;\n\tbackground-image: url("+i(n("Jk0y"))+");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right {\n\tright: 4px;\n\tbackground-image: url("+i(n("GNW+"))+");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right_hover {\n\tright: 4px;\n\tbackground-image: url("+i(n("GNW+"))+");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_month,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_year {\n\tposition: relative;\n\tfont-weight: bold;\n\tcolor: inherit;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 74px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 11px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 225px;\n\tmargin: 0px;\n\tborder-left: 1px solid #c7c7c7;\n\tborder-right: 1px solid #c7c7c7;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line {\n\theight: 23px;\n\tbackground-color: #f4f4f4;\n\tborder-bottom: 2px solid #3da0e3;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li {\n\tcolor: #000000;\n\twidth: 31px;\n\theight: 23px;\n\tline-height: 23px;\n\tborder-left: 1px solid #d5d5d5;\n\tbackground-color: #f4f4f4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first {\n\tborder-left: 1px solid #f4f4f4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell_first {\n\tcolor: #f1586a;\n\tborder-left: 1px solid #f4f4f4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 225px;\n\tmargin: 0px;\n\tpadding-bottom: 1px;\n\tborder-left: 1px solid #c7c7c7;\n\tborder-right: 1px solid #c7c7c7;\n\tborder-bottom: 1px solid #c7c7c7;\n\tbackground-color: #ffffff;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line {\n\tborder-top: 1px solid #ffffff;\n\tmargin-left: 1px;\n\tmargin-right: 1px;\n\theight: 26px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li {\n\tcolor: #909090;\n\twidth: 31px;\n\theight: 26px;\n\tline-height: 26px;\n\tmargin-right: 1px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label {\n\twidth: 100%;\n\theight: 100%;\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend {\n\tbackground-color: #d6d6d6;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_dis {\n\tcolor: #c4c4c4;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday {\n\tcolor: #f1586a;\n\tbackground-color: #d6d6d6;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_dis {\n\tcolor: #f1586a;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_hover {\n\tbackground-color: #d6d6d6;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #d6d6d6;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month {\n\tcolor: #000000;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date {\n\tcolor: #000000;\n\tbackground-color: #85d3ff;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_dis {\n\tcolor: #c4c4c4;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_dis {\n\tcolor: #f1586a;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_hover {\n\tcolor: #000000;\n\tbackground-color: #c7ebff;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffe7e4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_hover {\n\tcolor: #000000;\n\tbackground-color: #85d3ff;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffe7e4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffe7e4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line div.dhtmlxcalendar_label.dhtmlxcalendar_label_title {\n\tbackground-image: url("+i(n("KQCk"))+");\n\tbackground-position: top right;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 227px;\n\theight: 27px;\n\tmargin-top: -1px;\n\tbackground-color: #3da0e3;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tcolor: #ffffff;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li {\n\twidth: 227px;\n\theight: 27px;\n\tline-height: 25px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: left;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tposition: absolute;\n\tleft: 11px;\n\ttop: 7px;\n\twidth: 13px;\n\theight: 13px;\n\tbackground-image: url("+i(n("dOPq"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 30px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tleft: 75px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 0px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr div.dhtmlxcalendar_time_img,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_minutes,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_colon {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_web span.dhtmlxcalendar_label_colon {\n\tpadding: 0px 4px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_cover {\n\tposition: absolute;\n\tleft: 1px;\n\tbackground-color: white;\n\topacity: 0.5;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj {\n\tposition: absolute;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_selector_obj_arrow {\n\tposition: absolute;\n\tbottom: auto;\n\ttop: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 9px;\n\toverflow: hidden;\n\tbackground-image: url("+i(n("cDpM"))+");\n\tbackground-position: top center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -13px top;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -53px top;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -51px top;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table {\n\tborder: 1px solid #c7c7c7;\n\tbackground-color: white;\n\tborder-top: none;\n\tmargin-top: 9px;\n\t-webkit-box-shadow: 0 0 3px rgba(0,0,0,0.35);\n\t        box-shadow: 0 0 3px rgba(0,0,0,0.35);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: white 1px solid;\n\tpadding: 0px;\n\tmargin: 0px;\n\tbackground-color: #ededed;\n\tbackground-image: url("+i(n("gzVG"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left.dhtmlxcalendar_selector_cell_left_hover {\n\tbackground-image: url("+i(n("gzVG"))+");\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle {\n\tborder-top: 1px solid white;\n\tborder-width: 1px 0px 0px 0px;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid white;\n\tborder-width: 1px 0px 0px 0px;\n\tbackground-color: #ededed;\n\tbackground-image: url("+i(n("stgA"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right.dhtmlxcalendar_selector_cell_right_hover {\n\tbackground-image: url("+i(n("stgA"))+");\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul {\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px 0px 0px 1px;\n\tpadding: 0px;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li {\n\tfloat: left;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmargin: 0px 1px 0px 0px;\n\tpadding: 0px;\n\tbackground-color: #ededed;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tcursor: default;\n\tfont-family: Tahoma, Helvetica;\n\tfont-size: 11px;\n\tcolor: #000000;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_active {\n\tbackground-color: #85d3ff;\n\tcolor: #000000;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_hover {\n\tbackground-color: #c7ebff;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n\tborder: 0px solid white;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 24px;\n\tborder-top: none;\n\tborder-bottom: 1px solid white;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 35px;\n\theight: 24px;\n\tline-height: 24px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\ttop: auto;\n\tbottom: 0px;\n\tbackground-image: url("+i(n("SFAD"))+");\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 22px;\n\tborder-top: none;\n\tborder-bottom: 1px solid white;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 24px;\n\theight: 22px;\n\tline-height: 22px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table {\n\tmargin-top: 0px;\n\tmargin-bottom: 9px;\n\tborder-top: 1px solid #c7c7c7;\n\tborder-bottom: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours2,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_year div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: block;\n}\n.dhtmlxcalendar_dhx_web span.dhtmlxcalendar_label_minutes span.dhtmlxcalendar_selected_date {\n\tborder-bottom: 2px solid red;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color: #f4f4f4;\n\tborder-left: 1px solid #f4f4f4;\n\tborder-right: 1px solid #d5d5d5;\n\tmargin-right: 0px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color: #f4f4f4;\n}\ndiv.dhtmlxcalendar_skin_detect {\n\tposition: absolute;\n\tdisplay: block;\n\tvisibility: hidden;\n\tleft: -100px;\n\ttop: 0px;\n\twidth: 20px;\n\theight: 10px;\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder: none;\n\toverflow: hidden;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/dhx/calendar/skins/dhtmlxcalendar_dhx_web.css"],names:[],mappings:"AAAA;;;;;;EAME;;AAEF;;;EAGE;AACF;CACC,mBAAmB;CACnB,eAAe;CACf,0BAA0B;CAC1B,+BAA+B;CAC/B,gBAAgB;CAChB,eAAe;CACf;AACD;CACC,6CAA6C;SACrC,qCAAqC;CAC7C;AACD;CACC,mBAAmB;CACnB,iBAAiB;CACjB,wBAAwB;CACxB;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,aAAa;CACb;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;CACZ,aAAa;CACb;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,aAAa;CACb,YAAY;CACZ,0BAA0B;CAC1B,iBAAiB;CACjB,eAAe;CACf,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,mBAAmB;CACnB,SAAS;CACT,YAAY;CACZ,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,mCAAmC;CACnC,6BAA6B;CAC7B;AACD;CACC,UAAU;CACV,gDAA4E;CAC5E,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,UAAU;CACV,gDAA4E;CAC5E,WAAW;CACX,6DAA6D;CAC7D;AACD;CACC,WAAW;CACX,gDAA6E;CAC7E,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,WAAW;CACX,gDAA6E;CAC7E,WAAW;CACX,6DAA6D;CAC7D;AACD;;CAEC,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf;AACD;;CAEC,cAAc;CACd;AACD;CACC,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,mBAAmB;CACnB;AACD;CACC,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,mBAAmB;CACnB;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,+BAA+B;CAC/B,gCAAgC;CAChC,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B,iCAAiC;CACjC;AACD;CACC,eAAe;CACf,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,+BAA+B;CAC/B,0BAA0B;CAC1B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf,+BAA+B;CAC/B;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,oBAAoB;CACpB,+BAA+B;CAC/B,gCAAgC;CAChC,iCAAiC;CACjC,0BAA0B;CAC1B,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;CACC,8BAA8B;CAC9B,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb;AACD;CACC,eAAe;CACf,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB;AACD;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB;AACD;;CAEC,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;;CAEC,eAAe;CACf;AACD;;CAEC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,gDAAsE;CACtE,+BAA+B;CAC/B,6BAA6B;CAC7B;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,aAAa;CACb,iBAAiB;CACjB,0BAA0B;CAC1B,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB;AACD;CACC,aAAa;CACb,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,iBAAiB;CACjB;AACD;CACC,mBAAmB;CACnB,WAAW;CACX,SAAS;CACT,YAAY;CACZ,aAAa;CACb,gDAAuE;CACvE,mCAAmC;CACnC,6BAA6B;CAC7B;AACD;CACC,kBAAkB;CAClB;AACD;CACC,WAAW;CACX;AACD;CACC,mBAAmB;CACnB;AACD;CACC,iBAAiB;CACjB;AACD;;;;CAIC,cAAc;CACd;AACD;CACC,iBAAiB;CACjB;AACD;CACC,mBAAmB;CACnB,UAAU;CACV,wBAAwB;CACxB,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,mBAAmB;CACnB;AACD;CACC,mBAAmB;CACnB,aAAa;CACb,SAAS;CACT,UAAU;CACV,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,gDAA8E;CAC9E,gCAAgC;CAChC,6BAA6B;CAC7B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,0BAA0B;CAC1B,wBAAwB;CACxB,iBAAiB;CACjB,gBAAgB;CAChB,6CAA6C;SACrC,qCAAqC;CAC7C;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,4BAA4B;CAC5B,aAAa;CACb,YAAY;CACZ,0BAA0B;CAC1B,gDAA6E;CAC7E,mCAAmC;CACnC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;CACC,gDAA6E;CAC7E;AACD;CACC,4BAA4B;CAC5B,8BAA8B;CAC9B,gBAAgB;CAChB;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,4BAA4B;CAC5B,8BAA8B;CAC9B,0BAA0B;CAC1B,gDAA8E;CAC9E,mCAAmC;CACnC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;CACC,iDAA8E;CAC9E;AACD;CACC,eAAe;CACf,YAAY;CACZ,wBAAwB;CACxB,aAAa;CACb,iBAAiB;CACjB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,YAAY;CACZ,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,wBAAwB;CACxB,aAAa;CACb,0BAA0B;CAC1B,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,+BAA+B;CAC/B,gBAAgB;CAChB,eAAe;CACf;AACD;CACC,0BAA0B;CAC1B,eAAe;CACf;AACD;CACC,0BAA0B;CAC1B;AACD;;CAEC,cAAc;CACd,WAAW;CACX,wBAAwB;CACxB;AACD;CACC,aAAa;CACb,iBAAiB;CACjB,+BAA+B;CAC/B;AACD;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB;AACD;;;CAGC,UAAU;CACV,YAAY;CACZ,iDAAiF;CACjF;AACD;;;CAGC,aAAa;CACb,iBAAiB;CACjB,+BAA+B;CAC/B;AACD;;;CAGC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB;AACD;;;;;;CAMC,cAAc;CACd,WAAW;CACX;AACD;;;CAGC,gBAAgB;CAChB,mBAAmB;CACnB,8BAA8B;CAC9B,oBAAoB;CACpB;AACD;;;;;;;CAOC,cAAc;CACd;AACD;;;;;;;CAOC,eAAe;CACf;AACD;CACC,6BAA6B;CAC7B;AACD;;CAEC,cAAc;CACd;AACD;CACC,YAAY;CACZ;AACD;CACC,YAAY;CACZ;AACD;;CAEC,YAAY;CACZ;AACD;CACC,eAAe;CACf,YAAY;CACZ,eAAe;CACf,0BAA0B;CAC1B,+BAA+B;CAC/B,gCAAgC;CAChC,kBAAkB;CAClB;AACD;CACC,eAAe;CACf,YAAY;CACZ,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,aAAa;CACb,SAAS;CACT,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,aAAa;CACb,aAAa;CACb,iBAAiB;CACjB",file:"dhtmlxcalendar_dhx_web.css",sourcesContent:['/*\nProduct Name: dhtmlxSuite \nVersion: 5.1.0 \nEdition: Standard \nLicense: content of this file is covered by DHTMLX Commercial or enterpri. Usage outside GPL terms is prohibited. To obtain Commercial or Enterprise license contact sales@dhtmlx.com\nCopyright UAB Dinamenta http://www.dhtmlx.com\n*/\n\n/*\n\tskin detected: dhx_web\n\tinclude extra file: skins/dhx_web.less\n*/\n.dhtmlxcalendar_dhx_web {\n\tposition: absolute;\n\tdisplay: block;\n\tbackground-color: #ffffff;\n\tfont-family: Tahoma, Helvetica;\n\tfont-size: 12px;\n\tcolor: #000000;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n\t-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.25);\n\t        box-shadow: 0 0 6px rgba(0,0,0,0.25);\n}\n.dhtmlxcalendar_ifr {\n\tposition: absolute;\n\toverflow: hidden;\n\tbackground-color: white;\n}\n.dhtmlxcalendar_dhx_web ul.dhtmlxcalendar_line {\n\tposition: relative;\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\twidth: 225px;\n}\n.dhtmlxcalendar_dhx_web ul.dhtmlxcalendar_line li {\n\tfloat: left;\n\tposition: relative;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcursor: default;\n\toverflow: hidden;\n\tmargin: 0px;\n\tpadding: 0px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 227px;\n\theight: 27px;\n\tmargin: 0px;\n\tbackground-color: #3da0e3;\n\toverflow: hidden;\n\tcolor: #ffffff;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr {\n\twidth: 227px;\n\theight: 27px;\n\tline-height: 27px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow {\n\tposition: absolute;\n\ttop: 0px;\n\twidth: 18px;\n\theight: 27px;\n\tcolor: inherit;\n\ttext-align: center;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left {\n\tleft: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_arrow_left.gif");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left_hover {\n\tleft: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_arrow_left.gif");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right {\n\tright: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_arrow_right.gif");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right_hover {\n\tright: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_arrow_right.gif");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_month,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_year {\n\tposition: relative;\n\tfont-weight: bold;\n\tcolor: inherit;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 74px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 11px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 225px;\n\tmargin: 0px;\n\tborder-left: 1px solid #c7c7c7;\n\tborder-right: 1px solid #c7c7c7;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line {\n\theight: 23px;\n\tbackground-color: #f4f4f4;\n\tborder-bottom: 2px solid #3da0e3;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li {\n\tcolor: #000000;\n\twidth: 31px;\n\theight: 23px;\n\tline-height: 23px;\n\tborder-left: 1px solid #d5d5d5;\n\tbackground-color: #f4f4f4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first {\n\tborder-left: 1px solid #f4f4f4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell_first {\n\tcolor: #f1586a;\n\tborder-left: 1px solid #f4f4f4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 225px;\n\tmargin: 0px;\n\tpadding-bottom: 1px;\n\tborder-left: 1px solid #c7c7c7;\n\tborder-right: 1px solid #c7c7c7;\n\tborder-bottom: 1px solid #c7c7c7;\n\tbackground-color: #ffffff;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line {\n\tborder-top: 1px solid #ffffff;\n\tmargin-left: 1px;\n\tmargin-right: 1px;\n\theight: 26px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li {\n\tcolor: #909090;\n\twidth: 31px;\n\theight: 26px;\n\tline-height: 26px;\n\tmargin-right: 1px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label {\n\twidth: 100%;\n\theight: 100%;\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend {\n\tbackground-color: #d6d6d6;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_dis {\n\tcolor: #c4c4c4;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday {\n\tcolor: #f1586a;\n\tbackground-color: #d6d6d6;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_dis {\n\tcolor: #f1586a;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_hover {\n\tbackground-color: #d6d6d6;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_hover,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #d6d6d6;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month {\n\tcolor: #000000;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date {\n\tcolor: #000000;\n\tbackground-color: #85d3ff;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_dis {\n\tcolor: #c4c4c4;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday {\n\tcolor: #f1586a;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_dis,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_dis {\n\tcolor: #f1586a;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_hover {\n\tcolor: #000000;\n\tbackground-color: #c7ebff;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffe7e4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_hover {\n\tcolor: #000000;\n\tbackground-color: #85d3ff;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffe7e4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffe7e4;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_hover {\n\tcolor: #f1586a;\n\tbackground-color: #ffd1cc;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line div.dhtmlxcalendar_label.dhtmlxcalendar_label_title {\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_mark.gif");\n\tbackground-position: top right;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 227px;\n\theight: 27px;\n\tmargin-top: -1px;\n\tbackground-color: #3da0e3;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tcolor: #ffffff;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li {\n\twidth: 227px;\n\theight: 27px;\n\tline-height: 25px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: left;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tposition: absolute;\n\tleft: 11px;\n\ttop: 7px;\n\twidth: 13px;\n\theight: 13px;\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_clock.gif");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 30px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tleft: 75px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 0px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr div.dhtmlxcalendar_time_img,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_minutes,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_colon {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_web span.dhtmlxcalendar_label_colon {\n\tpadding: 0px 4px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_cover {\n\tposition: absolute;\n\tleft: 1px;\n\tbackground-color: white;\n\topacity: 0.5;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj {\n\tposition: absolute;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_selector_obj_arrow {\n\tposition: absolute;\n\tbottom: auto;\n\ttop: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 9px;\n\toverflow: hidden;\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_selector_top.gif");\n\tbackground-position: top center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -13px top;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -53px top;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -51px top;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table {\n\tborder: 1px solid #c7c7c7;\n\tbackground-color: white;\n\tborder-top: none;\n\tmargin-top: 9px;\n\t-webkit-box-shadow: 0 0 3px rgba(0,0,0,0.35);\n\t        box-shadow: 0 0 3px rgba(0,0,0,0.35);\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: white 1px solid;\n\tpadding: 0px;\n\tmargin: 0px;\n\tbackground-color: #ededed;\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_arrow_left2.gif");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left.dhtmlxcalendar_selector_cell_left_hover {\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_arrow_left2.gif");\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle {\n\tborder-top: 1px solid white;\n\tborder-width: 1px 0px 0px 0px;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid white;\n\tborder-width: 1px 0px 0px 0px;\n\tbackground-color: #ededed;\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_arrow_right2.gif");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right.dhtmlxcalendar_selector_cell_right_hover {\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_arrow_right2.gif");\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul {\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px 0px 0px 1px;\n\tpadding: 0px;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li {\n\tfloat: left;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmargin: 0px 1px 0px 0px;\n\tpadding: 0px;\n\tbackground-color: #ededed;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tcursor: default;\n\tfont-family: Tahoma, Helvetica;\n\tfont-size: 11px;\n\tcolor: #000000;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_active {\n\tbackground-color: #85d3ff;\n\tcolor: #000000;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_hover {\n\tbackground-color: #c7ebff;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n\tborder: 0px solid white;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 24px;\n\tborder-top: none;\n\tborder-bottom: 1px solid white;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 35px;\n\theight: 24px;\n\tline-height: 24px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\ttop: auto;\n\tbottom: 0px;\n\tbackground-image: url("../imgs/dhxcalendar_web/dhxcalendar_selector_bottom.gif");\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 22px;\n\tborder-top: none;\n\tborder-bottom: 1px solid white;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 24px;\n\theight: 22px;\n\tline-height: 22px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table {\n\tmargin-top: 0px;\n\tmargin-bottom: 9px;\n\tborder-top: 1px solid #c7c7c7;\n\tborder-bottom: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours2,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_year div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: block;\n}\n.dhtmlxcalendar_dhx_web span.dhtmlxcalendar_label_minutes span.dhtmlxcalendar_selected_date {\n\tborder-bottom: 2px solid red;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first,\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color: #f4f4f4;\n\tborder-left: 1px solid #f4f4f4;\n\tborder-right: 1px solid #d5d5d5;\n\tmargin-right: 0px;\n}\n.dhtmlxcalendar_dhx_web div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color: #f4f4f4;\n}\ndiv.dhtmlxcalendar_skin_detect {\n\tposition: absolute;\n\tdisplay: block;\n\tvisibility: hidden;\n\tleft: -100px;\n\ttop: 0px;\n\twidth: 20px;\n\theight: 10px;\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder: none;\n\toverflow: hidden;\n}\n'],sourceRoot:""}])},"1RnF":function(t,e,n){t.exports=n("aLzV")},"1yV6":function(t,e,n){var i=n("FHqv"),a=n("hgbu")("iterator"),o=n("yYxz");t.exports=n("iANj").getIteratorMethod=function(t){if(void 0!=t)return t[a]||t["@@iterator"]||o[i(t)]}},"21It":function(t,e,n){"use strict";var i=n("FtD3");t.exports=function(t,e,n){var a=n.config.validateStatus;n.status&&a&&!a(n.status)?e(i("Request failed with status code "+n.status,n.config,null,n.request,n)):t(n)}},"2cLf":function(t,e,n){var i=n("SCiL");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("e6735e0a",i,!0,{})},"2fQW":function(t,e,n){var i=n("vzRJ");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("39fc87be",i,!0,{})},"2m2c":function(t,e,n){var i=n("DvwR"),a=n("B5V0").concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return i(t,a)}},"2pmY":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"۱",2:"۲",3:"۳",4:"۴",5:"۵",6:"۶",7:"۷",8:"۸",9:"۹",0:"۰"},n={"۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","۰":"0"};t.defineLocale("fa",{months:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),monthsShort:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),weekdays:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysShort:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysMin:"ی_د_س_چ_پ_ج_ش".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/قبل از ظهر|بعد از ظهر/,isPM:function(t){return/بعد از ظهر/.test(t)},meridiem:function(t,e,n){return t<12?"قبل از ظهر":"بعد از ظهر"},calendar:{sameDay:"[امروز ساعت] LT",nextDay:"[فردا ساعت] LT",nextWeek:"dddd [ساعت] LT",lastDay:"[دیروز ساعت] LT",lastWeek:"dddd [پیش] [ساعت] LT",sameElse:"L"},relativeTime:{future:"در %s",past:"%s پیش",s:"چند ثانیه",ss:"%d ثانیه",m:"یک دقیقه",mm:"%d دقیقه",h:"یک ساعت",hh:"%d ساعت",d:"یک روز",dd:"%d روز",M:"یک ماه",MM:"%d ماه",y:"یک سال",yy:"%d سال"},preparse:function(t){return t.replace(/[۰-۹]/g,function(t){return n[t]}).replace(/،/g,",")},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]}).replace(/,/g,"،")},dayOfMonthOrdinalParse:/\d{1,2}م/,ordinal:"%dم",week:{dow:6,doy:12}})})(n("PJh5"))},"2s1U":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){var a=t+" ";switch(n){case"s":return e||i?"nekaj sekund":"nekaj sekundami";case"ss":return a+=1===t?e?"sekundo":"sekundi":2===t?e||i?"sekundi":"sekundah":t<5?e||i?"sekunde":"sekundah":"sekund";case"m":return e?"ena minuta":"eno minuto";case"mm":return a+=1===t?e?"minuta":"minuto":2===t?e||i?"minuti":"minutama":t<5?e||i?"minute":"minutami":e||i?"minut":"minutami";case"h":return e?"ena ura":"eno uro";case"hh":return a+=1===t?e?"ura":"uro":2===t?e||i?"uri":"urama":t<5?e||i?"ure":"urami":e||i?"ur":"urami";case"d":return e||i?"en dan":"enim dnem";case"dd":return a+=1===t?e||i?"dan":"dnem":2===t?e||i?"dni":"dnevoma":e||i?"dni":"dnevi";case"M":return e||i?"en mesec":"enim mesecem";case"MM":return a+=1===t?e||i?"mesec":"mesecem":2===t?e||i?"meseca":"mesecema":t<5?e||i?"mesece":"meseci":e||i?"mesecev":"meseci";case"y":return e||i?"eno leto":"enim letom";case"yy":return a+=1===t?e||i?"leto":"letom":2===t?e||i?"leti":"letoma":t<5?e||i?"leta":"leti":e||i?"let":"leti"}}t.defineLocale("sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._čet._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_če_pe_so".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[včeraj ob] LT",lastWeek:function(){switch(this.day()){case 0:return"[prejšnjo] [nedeljo] [ob] LT";case 3:return"[prejšnjo] [sredo] [ob] LT";case 6:return"[prejšnjo] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[prejšnji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"čez %s",past:"pred %s",s:e,ss:e,m:e,mm:e,h:e,hh:e,d:e,dd:e,M:e,MM:e,y:e,yy:e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})(n("PJh5"))},"2v0O":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.widthchecktable {\n  width: 17px;\n}\n.checktable {\n  margin-left: 0rem !important;\n}\n.bgcolorhead2 {\n  background-color: #ececece6;\n}\n.scrollTable {\n  overflow: auto;\n}\n@media (max-width: 560px) {\n.spaaceResponsiveTop {\n    margin-top: 15px;\n}\n}\n.updateFormGroup {\n  margin-bottom: 0px !important;\n  margin-right: -8px;\n}\n.spacetd th, .spacetd td {\n  font-size: 14px !important;\n  padding: 0.25rem 0.75rem !important;\n}\n.myTabletd th, .myTabletd td {\n  padding: 0.45rem 0.75rem !important;\n}\n.myTable th {\n  border-top: none !important;\n}\n.myTable td {\n  border-top: 1px solid #dee2e6 !important;\n}\n.myTable td:first-child {\n  border-right: 1px solid #dee2e6 !important;\n}\n.myTable {\n  border: 1px solid gray !important;\n  z-index: 182;\n}\n.myTable tbody tr:hover td {\n  background-color: #a8a8a81a !important;\n}\n.widthTableHeader {\n  width: 32% !important;\n}\ninput:checked + label {\n  font-weight: bold;\n}\n.myTable .form-check-label.checkbox-custom-label.myLabel {\n  padding-top: 2px;\n}\n.myTabletd thead th {\n  vertical-align: middle !important;\n}\n.myTable thead th {\n  vertical-align: middle !important;\n}\n.showMoreMain {\n  color: #428bca !important;\n}\n.showMoreMain:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.textColorSuccess {\n  color: #299e73 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfQuestionnaire/PfQuestionnaire.css"],names:[],mappings:";AACA;EACE,YAAY;CACb;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,eAAe;CAChB;AACD;AACA;IACI,iBAAiB;CACpB;CACA;AACD;EACE,8BAA8B;EAC9B,mBAAmB;CACpB;AACD;EACE,2BAA2B;EAC3B,oCAAoC;CACrC;AACD;EACE,oCAAoC;CACrC;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,yCAAyC;CAC1C;AACD;EACE,2CAA2C;CAC5C;AACD;EACE,kCAAkC;EAClC,aAAa;CACd;AACD;EACE,uCAAuC;CACxC;AACD;EACE,sBAAsB;CACvB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,kCAAkC;CACnC;AACD;EACE,kCAAkC;CACnC;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,0BAA0B;CAC3B",file:"PfQuestionnaire.css",sourcesContent:["\n.widthchecktable {\n  width: 17px;\n}\n.checktable {\n  margin-left: 0rem !important;\n}\n.bgcolorhead2 {\n  background-color: #ececece6;\n}\n.scrollTable {\n  overflow: auto;\n}\n@media (max-width: 560px) {\n.spaaceResponsiveTop {\n    margin-top: 15px;\n}\n}\n.updateFormGroup {\n  margin-bottom: 0px !important;\n  margin-right: -8px;\n}\n.spacetd th, .spacetd td {\n  font-size: 14px !important;\n  padding: 0.25rem 0.75rem !important;\n}\n.myTabletd th, .myTabletd td {\n  padding: 0.45rem 0.75rem !important;\n}\n.myTable th {\n  border-top: none !important;\n}\n.myTable td {\n  border-top: 1px solid #dee2e6 !important;\n}\n.myTable td:first-child {\n  border-right: 1px solid #dee2e6 !important;\n}\n.myTable {\n  border: 1px solid gray !important;\n  z-index: 182;\n}\n.myTable tbody tr:hover td {\n  background-color: #a8a8a81a !important;\n}\n.widthTableHeader {\n  width: 32% !important;\n}\ninput:checked + label {\n  font-weight: bold;\n}\n.myTable .form-check-label.checkbox-custom-label.myLabel {\n  padding-top: 2px;\n}\n.myTabletd thead th {\n  vertical-align: middle !important;\n}\n.myTable thead th {\n  vertical-align: middle !important;\n}\n.showMoreMain {\n  color: #428bca !important;\n}\n.showMoreMain:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.textColorSuccess {\n  color: #299e73 !important;\n}\n"],sourceRoot:""}])},"2v89":function(t,e,n){var i=n("AFvW");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("331dd55c",i,!0,{})},"2zL7":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfPhone.css",sourceRoot:""}])},"30vf":function(t,e,n){var i=n("Wdy1"),a=n("iANj"),o=n("zyKz");t.exports=function(t,e){var n=(a.Object||{})[t]||Object[t],r={};r[t]=e(n),i(i.S+i.F*o(function(){n(1)}),"Object",r)}},"3Atc":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfTravelHistory.css",sourceRoot:""}])},"3CJN":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("af",{months:"Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),weekdays:"Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split("_"),weekdaysShort:"Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),weekdaysMin:"So_Ma_Di_Wo_Do_Vr_Sa".split("_"),meridiemParse:/vm|nm/i,isPM:function(t){return/^nm$/i.test(t)},meridiem:function(t,e,n){return t<12?n?"vm":"VM":n?"nm":"NM"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Vandag om] LT",nextDay:"[Môre om] LT",nextWeek:"dddd [om] LT",lastDay:"[Gister om] LT",lastWeek:"[Laas] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oor %s",past:"%s gelede",s:"'n paar sekondes",ss:"%d sekondes",m:"'n minuut",mm:"%d minute",h:"'n uur",hh:"%d ure",d:"'n dag",dd:"%d dae",M:"'n maand",MM:"%d maande",y:"'n jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(t){return t+(1===t||8===t||t>=20?"ste":"de")},week:{dow:1,doy:4}})})(n("PJh5"))},"3HN9":function(t,e,n){"use strict";var i=n("SWGL");t.exports.f=function(t){return new function(t){var e,n;this.promise=new t(function(t,i){if(void 0!==e||void 0!==n)throw TypeError("Bad Promise constructor");e=t,n=i}),this.resolve=i(e),this.reject=i(n)}(t)}},"3Ht3":function(t,e,n){var i=n("s/YK");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("3ea6b88b",i,!0,{})},"3IRH":function(t,e){t.exports=function(t){return t.webpackPolyfill||(t.deprecate=function(){},t.paths=[],t.children||(t.children=[]),Object.defineProperty(t,"loaded",{enumerable:!0,get:function(){return t.l}}),Object.defineProperty(t,"id",{enumerable:!0,get:function(){return t.i}}),t.webpackPolyfill=1),t}},"3K28":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),n="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),i=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],a=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;t.defineLocale("nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(t,i){return t?/-MMM-/.test(i)?n[t.month()]:e[t.month()]:e},monthsRegex:a,monthsShortRegex:a,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:i,longMonthsParse:i,shortMonthsParse:i,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",w:"één week",ww:"%d weken",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(t){return t+(1===t||8===t||t>=20?"ste":"de")},week:{dow:1,doy:4}})})(n("PJh5"))},"3LKG":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("tl-ph",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(t){return t},week:{dow:1,doy:4}})})(n("PJh5"))},"3MVc":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},i=function(t){return 0===t?0:1===t?1:2===t?2:t%100>=3&&t%100<=10?3:t%100>=11?4:5},a={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},o=function(t){return function(e,n,o,r){var s=i(e),l=a[t][i(e)];return 2===s&&(l=l[n?0:1]),l.replace(/%d/i,e)}},r=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];t.defineLocale("ar",{months:r,monthsShort:r,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(t){return"م"===t},meridiem:function(t,e,n){return t<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:o("s"),ss:o("s"),m:o("m"),mm:o("m"),h:o("h"),hh:o("h"),d:o("d"),dd:o("d"),M:o("M"),MM:o("M"),y:o("y"),yy:o("y")},preparse:function(t){return t.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(t){return n[t]}).replace(/،/g,",")},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]}).replace(/,/g,"،")},week:{dow:6,doy:12}})})(n("PJh5"))},"3fMt":function(t,e,n){var i=n("SWGL");t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,a){return t.call(e,n,i,a)}}return function(){return t.apply(e,arguments)}}},"3ggi":function(t,e,n){n("Ntt2")("asyncIterator")},"3hfc":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n){var i,a;return"m"===n?e?"хвіліна":"хвіліну":"h"===n?e?"гадзіна":"гадзіну":t+" "+(i=+t,a={ss:e?"секунда_секунды_секунд":"секунду_секунды_секунд",mm:e?"хвіліна_хвіліны_хвілін":"хвіліну_хвіліны_хвілін",hh:e?"гадзіна_гадзіны_гадзін":"гадзіну_гадзіны_гадзін",dd:"дзень_дні_дзён",MM:"месяц_месяцы_месяцаў",yy:"год_гады_гадоў"}[n].split("_"),i%10==1&&i%100!=11?a[0]:i%10>=2&&i%10<=4&&(i%100<10||i%100>=20)?a[1]:a[2])}t.defineLocale("be",{months:{format:"студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня".split("_"),standalone:"студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань".split("_")},monthsShort:"студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж".split("_"),weekdays:{format:"нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу".split("_"),standalone:"нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота".split("_"),isFormat:/\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/},weekdaysShort:"нд_пн_ат_ср_чц_пт_сб".split("_"),weekdaysMin:"нд_пн_ат_ср_чц_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., HH:mm",LLLL:"dddd, D MMMM YYYY г., HH:mm"},calendar:{sameDay:"[Сёння ў] LT",nextDay:"[Заўтра ў] LT",lastDay:"[Учора ў] LT",nextWeek:function(){return"[У] dddd [ў] LT"},lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return"[У мінулую] dddd [ў] LT";case 1:case 2:case 4:return"[У мінулы] dddd [ў] LT"}},sameElse:"L"},relativeTime:{future:"праз %s",past:"%s таму",s:"некалькі секунд",m:e,mm:e,h:e,hh:e,d:"дзень",dd:e,M:"месяц",MM:e,y:"год",yy:e},meridiemParse:/ночы|раніцы|дня|вечара/,isPM:function(t){return/^(дня|вечара)$/.test(t)},meridiem:function(t,e,n){return t<4?"ночы":t<12?"раніцы":t<17?"дня":"вечара"},dayOfMonthOrdinalParse:/\d{1,2}-(і|ы|га)/,ordinal:function(t,e){switch(e){case"M":case"d":case"DDD":case"w":case"W":return t%10!=2&&t%10!=3||t%100==12||t%100==13?t+"-ы":t+"-і";case"D":return t+"-га";default:return t}},week:{dow:1,doy:7}})})(n("PJh5"))},"44uN":function(t,e,n){var i=n("wpe0");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("3aa56f4e",i,!0,{})},"4DQ7":function(t,e,n){e.f=n("hgbu")},"4EqQ":function(t,e,n){var i=n("WJV6");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("6aeab87c",i,!0,{})},"4MIE":function(t,e,n){var i=n("KHvr");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("cdb75d92",i,!0,{})},"4Nho":function(t,e,n){var i=n("D4/P");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("04a878cc",i,!0,{})},"4S0F":function(t,e){t.exports=function(t,e,n,i){if(!(t instanceof e)||void 0!==i&&i in t)throw TypeError(n+": incorrect invocation!");return t}},"4VBb":function(t,e){t.exports="data:image/gif;base64,R0lGODlhDQANAMQfAPb29qmpqWlpaUhISEVFRWpqaoeHh4GBgczMzG5ubtbW1mJiYvf39+/v78nJyenp6e7u7sXFxaGhoXZ2dkdHR2tra4aGhkxMTKqqqktLS8vLy/Dw8Hh4eOPj4zMzM/r6+iH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTQgNzkuMTUxNDgxLCAyMDEzLzAzLzEzLTEyOjA5OjE1ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjA5QzYzN0YwQTkxNjExRTM4NTZCQkY4OEVFMjE1QkEwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjA5QzYzN0YxQTkxNjExRTM4NTZCQkY4OEVFMjE1QkEwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDlDNjM3RUVBOTE2MTFFMzg1NkJCRjg4RUUyMTVCQTAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDlDNjM3RUZBOTE2MTFFMzg1NkJCRjg4RUUyMTVCQTAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQBAAAfACwAAAAADQANAAAFW+AnatzgDZwmioyVBZ3QBZkFiEe1reJWHR/EpbGarDYXBAfDW/ACHEKHl+F1KJ7CSuFxrAoeKS+SgIiuS97nIRFhUped+oNUGXRqn0EEcGFiHRg1NyskWBQpKyEAOw=="},"4ajQ":function(t,e,n){var i=n("Wdy1");i(i.S+i.F*!n("qs+f"),"Object",{defineProperty:n("GCs6").f})},"4dmN":function(t,e,n){"use strict";var i=n("c8Kh"),a=n("Wdy1"),o=n("1RnF"),r=n("aLzV"),s=n("yYxz"),l=n("I7B8"),d=n("LhDF"),c=n("VD8v"),h=n("hgbu")("iterator"),u=!([].keys&&"next"in[].keys()),m=function(){return this};t.exports=function(t,e,n,f,p,_,A){l(n,e,f);var b,x,g,v=function(t){if(!u&&t in B)return B[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},C=e+" Iterator",y="values"==p,w=!1,B=t.prototype,k=B[h]||B["@@iterator"]||p&&B[p],E=k||v(p),I=p?y?v("entries"):E:void 0,D="Array"==e&&B.entries||k;if(D&&(g=c(D.call(new t)))!==Object.prototype&&g.next&&(d(g,C,!0),i||"function"==typeof g[h]||r(g,h,m)),y&&k&&"values"!==k.name&&(w=!0,E=function(){return k.call(this)}),i&&!A||!u&&!w&&B[h]||r(B,h,E),s[e]=E,s[C]=m,p)if(b={values:y?E:v("values"),keys:_?E:v("keys"),entries:I},A)for(x in b)x in B||o(B,x,b[x]);else a(a.P+a.F*(u||w),e,b);return b}},"4tom":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,".v-select{position:relative;font-family:inherit}.v-select,.v-select *{-webkit-box-sizing:border-box;box-sizing:border-box}@-webkit-keyframes vSelectSpinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes vSelectSpinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.vs__fade-enter-active,.vs__fade-leave-active{pointer-events:none;-webkit-transition:opacity .15s cubic-bezier(1,.5,.8,1);transition:opacity .15s cubic-bezier(1,.5,.8,1)}.vs__fade-enter,.vs__fade-leave-to{opacity:0}.vs--disabled .vs__clear,.vs--disabled .vs__dropdown-toggle,.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected{cursor:not-allowed;background-color:#f8f8f8}.v-select[dir=rtl] .vs__actions{padding:0 3px 0 6px}.v-select[dir=rtl] .vs__clear{margin-left:6px;margin-right:0}.v-select[dir=rtl] .vs__deselect{margin-left:0;margin-right:2px}.v-select[dir=rtl] .vs__dropdown-menu{text-align:right}.vs__dropdown-toggle{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 0 4px;background:none;border:1px solid rgba(60,60,60,.26);border-radius:4px;white-space:normal}.vs__selected-options{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-preferred-size:100%;flex-basis:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-wrap:wrap;flex-wrap:wrap;padding:0 2px;position:relative}.vs__actions{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:4px 6px 0 3px}.vs--searchable .vs__dropdown-toggle{cursor:text}.vs--unsearchable .vs__dropdown-toggle{cursor:pointer}.vs--open .vs__dropdown-toggle{border-bottom-color:transparent;border-bottom-left-radius:0;border-bottom-right-radius:0}.vs__open-indicator{fill:rgba(60,60,60,.5);-webkit-transform:scale(1);transform:scale(1);-webkit-transition:-webkit-transform .15s cubic-bezier(1,-.115,.975,.855);transition:-webkit-transform .15s cubic-bezier(1,-.115,.975,.855);transition:transform .15s cubic-bezier(1,-.115,.975,.855);transition:transform .15s cubic-bezier(1,-.115,.975,.855), -webkit-transform .15s cubic-bezier(1,-.115,.975,.855);-webkit-transition-timing-function:cubic-bezier(1,-.115,.975,.855);transition-timing-function:cubic-bezier(1,-.115,.975,.855)}.vs--open .vs__open-indicator{-webkit-transform:rotate(180deg) scale(1);transform:rotate(180deg) scale(1)}.vs--loading .vs__open-indicator{opacity:0}.vs__clear{fill:rgba(60,60,60,.5);padding:0;border:0;background-color:transparent;cursor:pointer;margin-right:8px}.vs__dropdown-menu{display:block;-webkit-box-sizing:border-box;box-sizing:border-box;position:absolute;top:calc(100% - 1px);left:0;z-index:1000;padding:5px 0;margin:0;width:100%;max-height:350px;min-width:160px;overflow-y:auto;-webkit-box-shadow:0 3px 6px 0 rgba(0,0,0,.15);box-shadow:0 3px 6px 0 rgba(0,0,0,.15);border:1px solid rgba(60,60,60,.26);border-top-style:none;border-radius:0 0 4px 4px;text-align:left;list-style:none;background:#fff}.vs__no-options{text-align:center}.vs__dropdown-option{line-height:1.42857143;display:block;padding:3px 20px;clear:both;color:#333;white-space:nowrap;cursor:pointer}.vs__dropdown-option--highlight{background:#5897fb;color:#fff}.vs__dropdown-option--disabled{background:inherit;color:rgba(60,60,60,.5);cursor:inherit}.vs__selected{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:#f0f0f0;border:1px solid rgba(60,60,60,.26);border-radius:4px;color:#333;line-height:1.4;margin:4px 2px 0;padding:0 .25em;z-index:0}.vs__deselect{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-appearance:none;-moz-appearance:none;appearance:none;margin-left:4px;padding:0;border:0;cursor:pointer;background:none;fill:rgba(60,60,60,.5);text-shadow:0 1px 0 #fff}.vs--single .vs__selected{background-color:transparent;border-color:transparent}.vs--single.vs--open .vs__selected{position:absolute;opacity:.4}.vs--single.vs--searching .vs__selected{display:none}.vs__search::-webkit-search-cancel-button{display:none}.vs__search::-ms-clear,.vs__search::-webkit-search-decoration,.vs__search::-webkit-search-results-button,.vs__search::-webkit-search-results-decoration{display:none}.vs__search,.vs__search:focus{-webkit-appearance:none;-moz-appearance:none;appearance:none;line-height:1.4;font-size:1em;border:1px solid transparent;border-left:none;outline:none;margin:4px 0 0;padding:0 7px;background:none;-webkit-box-shadow:none;box-shadow:none;width:0;max-width:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;z-index:1}.vs__search::-webkit-input-placeholder{color:inherit}.vs__search::-moz-placeholder{color:inherit}.vs__search:-ms-input-placeholder{color:inherit}.vs__search::-ms-input-placeholder{color:inherit}.vs__search::placeholder{color:inherit}.vs--unsearchable .vs__search{opacity:1}.vs--unsearchable:not(.vs--disabled) .vs__search:hover{cursor:pointer}.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search{opacity:.2}.vs__spinner{-ms-flex-item-align:center;align-self:center;opacity:0;font-size:5px;text-indent:-9999em;overflow:hidden;border:.9em solid hsla(0,0%,39.2%,.1);border-left-color:rgba(60,60,60,.45);-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-animation:vSelectSpinner 1.1s linear infinite;animation:vSelectSpinner 1.1s linear infinite;-webkit-transition:opacity .1s;transition:opacity .1s}.vs__spinner,.vs__spinner:after{border-radius:50%;width:5em;height:5em}.vs--loading .vs__spinner{opacity:1}/*# sourceMappingURL=vue-select.css.map*/","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/webpack:/VueSelect/src/components/Select.vue?93ea","/home/jonathanwick/projects/BrevortRiverStudios/vue-core/node_modules/vue-select/dist/vue-select.css"],names:[],mappings:"AAAA,UAAU,kBAAkB,mBAAA,CAAoB,sBAAsB,8BAAA,qBAAA,CAAsB,kCAAkC,GAAG,+BAAA,sBAAA,CAAuB,GAAG,gCAAA,uBAAA,CAAA,CAAyB,0BAA0B,GAAG,+BAAA,sBAAA,CAAuB,GAAG,gCAAA,uBAAA,CAAA,CAAyB,8CAA8C,oBAAoB,wDAAA,+CAAA,CAAgD,mCAAmC,SAAA,CAAU,oJAAoJ,mBAAmB,wBAAA,CAAyB,gCAAgC,mBAAA,CAAoB,8BAA8B,gBAAgB,cAAA,CAAe,iCAAiC,cAAc,gBAAA,CAAiB,sCAAsC,gBAAA,CAAiB,qBAAqB,wBAAwB,qBAAqB,gBAAgB,oBAAA,oBAAA,aAAa,gBAAgB,gBAAgB,oCAAoC,kBAAkB,kBAAA,CAAmB,sBAAsB,oBAAA,oBAAA,aAAa,6BAAA,gBAAgB,mBAAA,oBAAA,YAAY,mBAAA,eAAe,cAAc,iBAAA,CAAkB,aAAa,oBAAA,oBAAA,aAAa,yBAAA,sBAAA,mBAAmB,qBAAA,CAAsB,qCAAqC,WAAA,CAAY,uCAAuC,cAAA,CAAe,+BAA+B,gCAAgC,4BAA4B,4BAAA,CAA6B,oBAAoB,uBAAuB,2BAAA,mBAAmB,0EAAA,kEAAA,0DAAA,kHAA0D,mEAAA,0DAAA,CAA2D,8BAA8B,0CAAA,iCAAA,CAAkC,iCAAiC,SAAA,CAAU,WAAW,uBAAuB,UAAU,SAAS,6BAA6B,eAAe,gBAAA,CAAiB,mBAAmB,cAAc,8BAAA,sBAAsB,kBAAkB,qBAAqB,OAAO,aAAa,cAAc,SAAS,WAAW,iBAAiB,gBAAgB,gBAAgB,+CAAA,uCAAuC,oCAAoC,sBAAsB,0BAA0B,gBAAgB,gBAAgB,eAAA,CAAgB,gBAAgB,iBAAA,CAAkB,qBAAqB,uBAAuB,cAAc,iBAAiB,WAAW,WAAW,mBAAmB,cAAA,CAAe,gCAAgC,mBAAmB,UAAA,CAAW,+BAA+B,mBAAmB,wBAAwB,cAAA,CAAe,cAAc,oBAAA,oBAAA,aAAa,yBAAA,sBAAA,mBAAmB,yBAAyB,oCAAoC,kBAAkB,WAAW,gBAAgB,iBAAiB,gBAAgB,SAAA,CAAU,cAAc,2BAAA,2BAAA,oBAAoB,wBAAwB,qBAAqB,gBAAgB,gBAAgB,UAAU,SAAS,eAAe,gBAAgB,uBAAuB,wBAAA,CAAyB,0BAA0B,6BAA6B,wBAAA,CAAyB,mCAAmC,kBAAkB,UAAA,CAAW,wCAAwC,YAAA,CAAa,0CAA0C,YAAA,CAAa,wJAAwJ,YAAA,CAAa,8BAA8B,wBAAwB,qBAAqB,gBAAgB,gBAAgB,cAAc,6BAA6B,iBAAiB,aAAa,eAAe,cAAc,gBAAgB,wBAAA,gBAAgB,QAAQ,eAAe,mBAAA,oBAAA,YAAY,SAAA,CAAU,uCAAuC,aAAA,CAAc,8BAA8B,aAAA,CAAc,kCAAkC,aAAA,CAAc,mCAAmC,aAAA,CAAc,yBAAyB,aAAA,CAAc,8BAA8B,SAAA,CAAU,uDAAuD,cAAA,CAAe,uEAAuE,UAAA,CAAW,aAAa,2BAAA,kBAAkB,UAAU,cAAc,oBAAoB,gBAAgB,sCAAsC,qCAAqC,gCAAA,wBAAwB,sDAAsD,8CAA8C,+BAAA,sBAAA,CAAuB,gCAAgC,kBAAkB,UAAU,UAAA,CAAW,0BAA0B,SAAA,CCAU,yCAEt1I",file:"vue-select.css",sourcesContent:[".v-select{position:relative;font-family:inherit}.v-select,.v-select *{box-sizing:border-box}@-webkit-keyframes vSelectSpinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes vSelectSpinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.vs__fade-enter-active,.vs__fade-leave-active{pointer-events:none;transition:opacity .15s cubic-bezier(1,.5,.8,1)}.vs__fade-enter,.vs__fade-leave-to{opacity:0}.vs--disabled .vs__clear,.vs--disabled .vs__dropdown-toggle,.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected{cursor:not-allowed;background-color:#f8f8f8}.v-select[dir=rtl] .vs__actions{padding:0 3px 0 6px}.v-select[dir=rtl] .vs__clear{margin-left:6px;margin-right:0}.v-select[dir=rtl] .vs__deselect{margin-left:0;margin-right:2px}.v-select[dir=rtl] .vs__dropdown-menu{text-align:right}.vs__dropdown-toggle{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:flex;padding:0 0 4px;background:none;border:1px solid rgba(60,60,60,.26);border-radius:4px;white-space:normal}.vs__selected-options{display:flex;flex-basis:100%;flex-grow:1;flex-wrap:wrap;padding:0 2px;position:relative}.vs__actions{display:flex;align-items:center;padding:4px 6px 0 3px}.vs--searchable .vs__dropdown-toggle{cursor:text}.vs--unsearchable .vs__dropdown-toggle{cursor:pointer}.vs--open .vs__dropdown-toggle{border-bottom-color:transparent;border-bottom-left-radius:0;border-bottom-right-radius:0}.vs__open-indicator{fill:rgba(60,60,60,.5);transform:scale(1);transition:transform .15s cubic-bezier(1,-.115,.975,.855);transition-timing-function:cubic-bezier(1,-.115,.975,.855)}.vs--open .vs__open-indicator{transform:rotate(180deg) scale(1)}.vs--loading .vs__open-indicator{opacity:0}.vs__clear{fill:rgba(60,60,60,.5);padding:0;border:0;background-color:transparent;cursor:pointer;margin-right:8px}.vs__dropdown-menu{display:block;box-sizing:border-box;position:absolute;top:calc(100% - 1px);left:0;z-index:1000;padding:5px 0;margin:0;width:100%;max-height:350px;min-width:160px;overflow-y:auto;box-shadow:0 3px 6px 0 rgba(0,0,0,.15);border:1px solid rgba(60,60,60,.26);border-top-style:none;border-radius:0 0 4px 4px;text-align:left;list-style:none;background:#fff}.vs__no-options{text-align:center}.vs__dropdown-option{line-height:1.42857143;display:block;padding:3px 20px;clear:both;color:#333;white-space:nowrap;cursor:pointer}.vs__dropdown-option--highlight{background:#5897fb;color:#fff}.vs__dropdown-option--disabled{background:inherit;color:rgba(60,60,60,.5);cursor:inherit}.vs__selected{display:flex;align-items:center;background-color:#f0f0f0;border:1px solid rgba(60,60,60,.26);border-radius:4px;color:#333;line-height:1.4;margin:4px 2px 0;padding:0 .25em;z-index:0}.vs__deselect{display:inline-flex;-webkit-appearance:none;-moz-appearance:none;appearance:none;margin-left:4px;padding:0;border:0;cursor:pointer;background:none;fill:rgba(60,60,60,.5);text-shadow:0 1px 0 #fff}.vs--single .vs__selected{background-color:transparent;border-color:transparent}.vs--single.vs--open .vs__selected{position:absolute;opacity:.4}.vs--single.vs--searching .vs__selected{display:none}.vs__search::-webkit-search-cancel-button{display:none}.vs__search::-ms-clear,.vs__search::-webkit-search-decoration,.vs__search::-webkit-search-results-button,.vs__search::-webkit-search-results-decoration{display:none}.vs__search,.vs__search:focus{-webkit-appearance:none;-moz-appearance:none;appearance:none;line-height:1.4;font-size:1em;border:1px solid transparent;border-left:none;outline:none;margin:4px 0 0;padding:0 7px;background:none;box-shadow:none;width:0;max-width:100%;flex-grow:1;z-index:1}.vs__search::-webkit-input-placeholder{color:inherit}.vs__search::-moz-placeholder{color:inherit}.vs__search:-ms-input-placeholder{color:inherit}.vs__search::-ms-input-placeholder{color:inherit}.vs__search::placeholder{color:inherit}.vs--unsearchable .vs__search{opacity:1}.vs--unsearchable:not(.vs--disabled) .vs__search:hover{cursor:pointer}.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search{opacity:.2}.vs__spinner{align-self:center;opacity:0;font-size:5px;text-indent:-9999em;overflow:hidden;border:.9em solid hsla(0,0%,39.2%,.1);border-left-color:rgba(60,60,60,.45);transform:translateZ(0);-webkit-animation:vSelectSpinner 1.1s linear infinite;animation:vSelectSpinner 1.1s linear infinite;transition:opacity .1s}.vs__spinner,.vs__spinner:after{border-radius:50%;width:5em;height:5em}.vs--loading .vs__spinner{opacity:1}",".v-select{position:relative;font-family:inherit}.v-select,.v-select *{box-sizing:border-box}@-webkit-keyframes vSelectSpinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes vSelectSpinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.vs__fade-enter-active,.vs__fade-leave-active{pointer-events:none;transition:opacity .15s cubic-bezier(1,.5,.8,1)}.vs__fade-enter,.vs__fade-leave-to{opacity:0}.vs--disabled .vs__clear,.vs--disabled .vs__dropdown-toggle,.vs--disabled .vs__open-indicator,.vs--disabled .vs__search,.vs--disabled .vs__selected{cursor:not-allowed;background-color:#f8f8f8}.v-select[dir=rtl] .vs__actions{padding:0 3px 0 6px}.v-select[dir=rtl] .vs__clear{margin-left:6px;margin-right:0}.v-select[dir=rtl] .vs__deselect{margin-left:0;margin-right:2px}.v-select[dir=rtl] .vs__dropdown-menu{text-align:right}.vs__dropdown-toggle{-webkit-appearance:none;-moz-appearance:none;appearance:none;display:flex;padding:0 0 4px;background:none;border:1px solid rgba(60,60,60,.26);border-radius:4px;white-space:normal}.vs__selected-options{display:flex;flex-basis:100%;flex-grow:1;flex-wrap:wrap;padding:0 2px;position:relative}.vs__actions{display:flex;align-items:center;padding:4px 6px 0 3px}.vs--searchable .vs__dropdown-toggle{cursor:text}.vs--unsearchable .vs__dropdown-toggle{cursor:pointer}.vs--open .vs__dropdown-toggle{border-bottom-color:transparent;border-bottom-left-radius:0;border-bottom-right-radius:0}.vs__open-indicator{fill:rgba(60,60,60,.5);transform:scale(1);transition:transform .15s cubic-bezier(1,-.115,.975,.855);transition-timing-function:cubic-bezier(1,-.115,.975,.855)}.vs--open .vs__open-indicator{transform:rotate(180deg) scale(1)}.vs--loading .vs__open-indicator{opacity:0}.vs__clear{fill:rgba(60,60,60,.5);padding:0;border:0;background-color:transparent;cursor:pointer;margin-right:8px}.vs__dropdown-menu{display:block;box-sizing:border-box;position:absolute;top:calc(100% - 1px);left:0;z-index:1000;padding:5px 0;margin:0;width:100%;max-height:350px;min-width:160px;overflow-y:auto;box-shadow:0 3px 6px 0 rgba(0,0,0,.15);border:1px solid rgba(60,60,60,.26);border-top-style:none;border-radius:0 0 4px 4px;text-align:left;list-style:none;background:#fff}.vs__no-options{text-align:center}.vs__dropdown-option{line-height:1.42857143;display:block;padding:3px 20px;clear:both;color:#333;white-space:nowrap;cursor:pointer}.vs__dropdown-option--highlight{background:#5897fb;color:#fff}.vs__dropdown-option--disabled{background:inherit;color:rgba(60,60,60,.5);cursor:inherit}.vs__selected{display:flex;align-items:center;background-color:#f0f0f0;border:1px solid rgba(60,60,60,.26);border-radius:4px;color:#333;line-height:1.4;margin:4px 2px 0;padding:0 .25em;z-index:0}.vs__deselect{display:inline-flex;-webkit-appearance:none;-moz-appearance:none;appearance:none;margin-left:4px;padding:0;border:0;cursor:pointer;background:none;fill:rgba(60,60,60,.5);text-shadow:0 1px 0 #fff}.vs--single .vs__selected{background-color:transparent;border-color:transparent}.vs--single.vs--open .vs__selected{position:absolute;opacity:.4}.vs--single.vs--searching .vs__selected{display:none}.vs__search::-webkit-search-cancel-button{display:none}.vs__search::-ms-clear,.vs__search::-webkit-search-decoration,.vs__search::-webkit-search-results-button,.vs__search::-webkit-search-results-decoration{display:none}.vs__search,.vs__search:focus{-webkit-appearance:none;-moz-appearance:none;appearance:none;line-height:1.4;font-size:1em;border:1px solid transparent;border-left:none;outline:none;margin:4px 0 0;padding:0 7px;background:none;box-shadow:none;width:0;max-width:100%;flex-grow:1;z-index:1}.vs__search::-webkit-input-placeholder{color:inherit}.vs__search::-moz-placeholder{color:inherit}.vs__search:-ms-input-placeholder{color:inherit}.vs__search::-ms-input-placeholder{color:inherit}.vs__search::placeholder{color:inherit}.vs--unsearchable .vs__search{opacity:1}.vs--unsearchable:not(.vs--disabled) .vs__search:hover{cursor:pointer}.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search{opacity:.2}.vs__spinner{align-self:center;opacity:0;font-size:5px;text-indent:-9999em;overflow:hidden;border:.9em solid hsla(0,0%,39.2%,.1);border-left-color:rgba(60,60,60,.45);transform:translateZ(0);-webkit-animation:vSelectSpinner 1.1s linear infinite;animation:vSelectSpinner 1.1s linear infinite;transition:opacity .1s}.vs__spinner,.vs__spinner:after{border-radius:50%;width:5em;height:5em}.vs--loading .vs__spinner{opacity:1}\n\n/*# sourceMappingURL=vue-select.css.map*/"],sourceRoot:""}])},"5Fck":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-6b9d2da6]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-6b9d2da6]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6b9d2da6]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6b9d2da6]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-6b9d2da6] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-6b9d2da6]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-6b9d2da6] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-6b9d2da6]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-6b9d2da6]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-6b9d2da6]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-6b9d2da6]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6b9d2da6]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6b9d2da6]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-6b9d2da6] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-6b9d2da6]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-6b9d2da6] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-6b9d2da6]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-6b9d2da6]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},"5Omq":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("se",{months:"ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu".split("_"),monthsShort:"ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov".split("_"),weekdays:"sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat".split("_"),weekdaysShort:"sotn_vuos_maŋ_gask_duor_bear_láv".split("_"),weekdaysMin:"s_v_m_g_d_b_L".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"MMMM D. [b.] YYYY",LLL:"MMMM D. [b.] YYYY [ti.] HH:mm",LLLL:"dddd, MMMM D. [b.] YYYY [ti.] HH:mm"},calendar:{sameDay:"[otne ti] LT",nextDay:"[ihttin ti] LT",nextWeek:"dddd [ti] LT",lastDay:"[ikte ti] LT",lastWeek:"[ovddit] dddd [ti] LT",sameElse:"L"},relativeTime:{future:"%s geažes",past:"maŋit %s",s:"moadde sekunddat",ss:"%d sekunddat",m:"okta minuhta",mm:"%d minuhtat",h:"okta diimmu",hh:"%d diimmut",d:"okta beaivi",dd:"%d beaivvit",M:"okta mánnu",MM:"%d mánut",y:"okta jahki",yy:"%d jagit"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},"5P0+":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfAdvanceParole.css",sourceRoot:""}])},"5QVw":function(t,e,n){t.exports={default:n("tYO1"),__esModule:!0}},"5SNd":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={0:"-ум",1:"-ум",2:"-юм",3:"-юм",4:"-ум",5:"-ум",6:"-ум",7:"-ум",8:"-ум",9:"-ум",10:"-ум",12:"-ум",13:"-ум",20:"-ум",30:"-юм",40:"-ум",50:"-ум",60:"-ум",70:"-ум",80:"-ум",90:"-ум",100:"-ум"};t.defineLocale("tg",{months:{format:"январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри".split("_"),standalone:"январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_")},monthsShort:"янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),weekdays:"якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе".split("_"),weekdaysShort:"яшб_дшб_сшб_чшб_пшб_ҷум_шнб".split("_"),weekdaysMin:"яш_дш_сш_чш_пш_ҷм_шб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Имрӯз соати] LT",nextDay:"[Фардо соати] LT",lastDay:"[Дирӯз соати] LT",nextWeek:"dddd[и] [ҳафтаи оянда соати] LT",lastWeek:"dddd[и] [ҳафтаи гузашта соати] LT",sameElse:"L"},relativeTime:{future:"баъди %s",past:"%s пеш",s:"якчанд сония",m:"як дақиқа",mm:"%d дақиқа",h:"як соат",hh:"%d соат",d:"як рӯз",dd:"%d рӯз",M:"як моҳ",MM:"%d моҳ",y:"як сол",yy:"%d сол"},meridiemParse:/шаб|субҳ|рӯз|бегоҳ/,meridiemHour:function(t,e){return 12===t&&(t=0),"шаб"===e?t<4?t:t+12:"субҳ"===e?t:"рӯз"===e?t>=11?t:t+12:"бегоҳ"===e?t+12:void 0},meridiem:function(t,e,n){return t<4?"шаб":t<11?"субҳ":t<16?"рӯз":t<19?"бегоҳ":"шаб"},dayOfMonthOrdinalParse:/\d{1,2}-(ум|юм)/,ordinal:function(t){return t+(e[t]||e[t%10]||e[t>=100?100:null])},week:{dow:1,doy:7}})})(n("PJh5"))},"5VQ+":function(t,e,n){"use strict";var i=n("cGG2");t.exports=function(t,e){i.forEach(t,function(n,i){i!==e&&i.toUpperCase()===e.toUpperCase()&&(t[e]=n,delete t[i])})}},"5j66":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"១",2:"២",3:"៣",4:"៤",5:"៥",6:"៦",7:"៧",8:"៨",9:"៩",0:"០"},n={"១":"1","២":"2","៣":"3","៤":"4","៥":"5","៦":"6","៧":"7","៨":"8","៩":"9","០":"0"};t.defineLocale("km",{months:"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),monthsShort:"មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split("_"),weekdays:"អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split("_"),weekdaysShort:"អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),weekdaysMin:"អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/ព្រឹក|ល្ងាច/,isPM:function(t){return"ល្ងាច"===t},meridiem:function(t,e,n){return t<12?"ព្រឹក":"ល្ងាច"},calendar:{sameDay:"[ថ្ងៃនេះ ម៉ោង] LT",nextDay:"[ស្អែក ម៉ោង] LT",nextWeek:"dddd [ម៉ោង] LT",lastDay:"[ម្សិលមិញ ម៉ោង] LT",lastWeek:"dddd [សប្តាហ៍មុន] [ម៉ោង] LT",sameElse:"L"},relativeTime:{future:"%sទៀត",past:"%sមុន",s:"ប៉ុន្មានវិនាទី",ss:"%d វិនាទី",m:"មួយនាទី",mm:"%d នាទី",h:"មួយម៉ោង",hh:"%d ម៉ោង",d:"មួយថ្ងៃ",dd:"%d ថ្ងៃ",M:"មួយខែ",MM:"%d ខែ",y:"មួយឆ្នាំ",yy:"%d ឆ្នាំ"},dayOfMonthOrdinalParse:/ទី\d{1,2}/,ordinal:"ទី%d",preparse:function(t){return t.replace(/[១២៣៤៥៦៧៨៩០]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},week:{dow:1,doy:4}})})(n("PJh5"))},"5pPm":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.form-content {\n  text-align: center;\n}\n.fade-enter-active, .fade-leave-active {\n  -webkit-transition: opacity .2s;\n  transition: opacity .2s\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {\n  opacity: 0\n}\n.itemContext {\n  cursor: pointer;\n}\n.itemContext:hover {\n  background-color: rgb(245, 214, 255);\n}","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfForm/PfFormContent/PfFormContent.css"],names:[],mappings:";AACA;EACE,mBAAmB;CACpB;AACD;EACE,gCAAgC;EAChC,uBAAuB;CACxB;AACD;EACE,UAAU;CACX;AACD;EACE,gBAAgB;CACjB;AACD;EACE,qCAAqC;CACtC",file:"PfFormContent.css",sourcesContent:["\n.form-content {\n  text-align: center;\n}\n.fade-enter-active, .fade-leave-active {\n  -webkit-transition: opacity .2s;\n  transition: opacity .2s\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {\n  opacity: 0\n}\n.itemContext {\n  cursor: pointer;\n}\n.itemContext:hover {\n  background-color: rgb(245, 214, 255);\n}"],sourceRoot:""}])},"5vPg":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},n={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"};function i(t,e,n,i){var a="";if(e)switch(n){case"s":a="काही सेकंद";break;case"ss":a="%d सेकंद";break;case"m":a="एक मिनिट";break;case"mm":a="%d मिनिटे";break;case"h":a="एक तास";break;case"hh":a="%d तास";break;case"d":a="एक दिवस";break;case"dd":a="%d दिवस";break;case"M":a="एक महिना";break;case"MM":a="%d महिने";break;case"y":a="एक वर्ष";break;case"yy":a="%d वर्षे"}else switch(n){case"s":a="काही सेकंदां";break;case"ss":a="%d सेकंदां";break;case"m":a="एका मिनिटा";break;case"mm":a="%d मिनिटां";break;case"h":a="एका तासा";break;case"hh":a="%d तासां";break;case"d":a="एका दिवसा";break;case"dd":a="%d दिवसां";break;case"M":a="एका महिन्या";break;case"MM":a="%d महिन्यां";break;case"y":a="एका वर्षा";break;case"yy":a="%d वर्षां"}return a.replace(/%d/i,t)}t.defineLocale("mr",{months:"जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),monthsShort:"जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),monthsParseExact:!0,weekdays:"रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm वाजता",LTS:"A h:mm:ss वाजता",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm वाजता",LLLL:"dddd, D MMMM YYYY, A h:mm वाजता"},calendar:{sameDay:"[आज] LT",nextDay:"[उद्या] LT",nextWeek:"dddd, LT",lastDay:"[काल] LT",lastWeek:"[मागील] dddd, LT",sameElse:"L"},relativeTime:{future:"%sमध्ये",past:"%sपूर्वी",s:i,ss:i,m:i,mm:i,h:i,hh:i,d:i,dd:i,M:i,MM:i,y:i,yy:i},preparse:function(t){return t.replace(/[१२३४५६७८९०]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,meridiemHour:function(t,e){return 12===t&&(t=0),"पहाटे"===e||"सकाळी"===e?t:"दुपारी"===e||"सायंकाळी"===e||"रात्री"===e?t>=12?t:t+12:void 0},meridiem:function(t,e,n){return t>=0&&t<6?"पहाटे":t<12?"सकाळी":t<17?"दुपारी":t<20?"सायंकाळी":"रात्री"},week:{dow:0,doy:6}})})(n("PJh5"))},"69pR":function(t,e,n){var i=n("t05+");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("b5d8f6b6",i,!0,{})},"6cf8":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={0:"-чү",1:"-чи",2:"-чи",3:"-чү",4:"-чү",5:"-чи",6:"-чы",7:"-чи",8:"-чи",9:"-чу",10:"-чу",20:"-чы",30:"-чу",40:"-чы",50:"-чү",60:"-чы",70:"-чи",80:"-чи",90:"-чу",100:"-чү"};t.defineLocale("ky",{months:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),monthsShort:"янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек".split("_"),weekdays:"Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби".split("_"),weekdaysShort:"Жек_Дүй_Шей_Шар_Бей_Жум_Ише".split("_"),weekdaysMin:"Жк_Дй_Шй_Шр_Бй_Жм_Иш".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Бүгүн саат] LT",nextDay:"[Эртең саат] LT",nextWeek:"dddd [саат] LT",lastDay:"[Кечээ саат] LT",lastWeek:"[Өткөн аптанын] dddd [күнү] [саат] LT",sameElse:"L"},relativeTime:{future:"%s ичинде",past:"%s мурун",s:"бирнече секунд",ss:"%d секунд",m:"бир мүнөт",mm:"%d мүнөт",h:"бир саат",hh:"%d саат",d:"бир күн",dd:"%d күн",M:"бир ай",MM:"%d ай",y:"бир жыл",yy:"%d жыл"},dayOfMonthOrdinalParse:/\d{1,2}-(чи|чы|чү|чу)/,ordinal:function(t){return t+(e[t]||e[t%10]||e[t>=100?100:null])},week:{dow:1,doy:7}})})(n("PJh5"))},"6mhB":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfEducationalHistory.css",sourceRoot:""}])},"6rdy":function(t,e,n){var i=n("pEGt"),a=n("THEY"),o=n("bSeU");t.exports=function(t){var e=i(t),n=a.f;if(n)for(var r,s=n(t),l=o.f,d=0;s.length>d;)l.call(t,r=s[d++])&&e.push(r);return e}},"6tLb":function(t,e,n){var i=n("ksFB"),a=n("2m2c").f,o={}.toString,r="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];t.exports.f=function(t){return r&&"[object Window]"==o.call(t)?function(t){try{return a(t)}catch(t){return r.slice()}}(t):a(i(t))}},"7+uW":function(t,e,n){"use strict";(function(t){
/*!
 * Vue.js v2.6.14
 * (c) 2014-2021 Evan You
 * Released under the MIT License.
 */
var n=Object.freeze({});function i(t){return void 0===t||null===t}function a(t){return void 0!==t&&null!==t}function o(t){return!0===t}function r(t){return"string"==typeof t||"number"==typeof t||"symbol"==typeof t||"boolean"==typeof t}function s(t){return null!==t&&"object"==typeof t}var l=Object.prototype.toString;function d(t){return"[object Object]"===l.call(t)}function c(t){return"[object RegExp]"===l.call(t)}function h(t){var e=parseFloat(String(t));return e>=0&&Math.floor(e)===e&&isFinite(t)}function u(t){return a(t)&&"function"==typeof t.then&&"function"==typeof t.catch}function m(t){return null==t?"":Array.isArray(t)||d(t)&&t.toString===l?JSON.stringify(t,null,2):String(t)}function f(t){var e=parseFloat(t);return isNaN(e)?t:e}function p(t,e){for(var n=Object.create(null),i=t.split(","),a=0;a<i.length;a++)n[i[a]]=!0;return e?function(t){return n[t.toLowerCase()]}:function(t){return n[t]}}var _=p("slot,component",!0),A=p("key,ref,slot,slot-scope,is");function b(t,e){if(t.length){var n=t.indexOf(e);if(n>-1)return t.splice(n,1)}}var x=Object.prototype.hasOwnProperty;function g(t,e){return x.call(t,e)}function v(t){var e=Object.create(null);return function(n){return e[n]||(e[n]=t(n))}}var C=/-(\w)/g,y=v(function(t){return t.replace(C,function(t,e){return e?e.toUpperCase():""})}),w=v(function(t){return t.charAt(0).toUpperCase()+t.slice(1)}),B=/\B([A-Z])/g,k=v(function(t){return t.replace(B,"-$1").toLowerCase()});var E=Function.prototype.bind?function(t,e){return t.bind(e)}:function(t,e){function n(n){var i=arguments.length;return i?i>1?t.apply(e,arguments):t.call(e,n):t.call(e)}return n._length=t.length,n};function I(t,e){e=e||0;for(var n=t.length-e,i=new Array(n);n--;)i[n]=t[n+e];return i}function D(t,e){for(var n in e)t[n]=e[n];return t}function S(t){for(var e={},n=0;n<t.length;n++)t[n]&&D(e,t[n]);return e}function N(t,e,n){}var M=function(t,e,n){return!1},O=function(t){return t};function T(t,e){if(t===e)return!0;var n=s(t),i=s(e);if(!n||!i)return!n&&!i&&String(t)===String(e);try{var a=Array.isArray(t),o=Array.isArray(e);if(a&&o)return t.length===e.length&&t.every(function(t,n){return T(t,e[n])});if(t instanceof Date&&e instanceof Date)return t.getTime()===e.getTime();if(a||o)return!1;var r=Object.keys(t),l=Object.keys(e);return r.length===l.length&&r.every(function(n){return T(t[n],e[n])})}catch(t){return!1}}function L(t,e){for(var n=0;n<t.length;n++)if(T(t[n],e))return n;return-1}function j(t){var e=!1;return function(){e||(e=!0,t.apply(this,arguments))}}var P="data-server-rendered",F=["component","directive","filter"],Y=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],R={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:M,isReservedAttr:M,isUnknownElement:M,getTagNamespace:N,parsePlatformTagName:O,mustUseProp:M,async:!0,_lifecycleHooks:Y},H=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function $(t){var e=(t+"").charCodeAt(0);return 36===e||95===e}function z(t,e,n,i){Object.defineProperty(t,e,{value:n,enumerable:!!i,writable:!0,configurable:!0})}var X=new RegExp("[^"+H.source+".$_\\d]");var V,q="__proto__"in{},W="undefined"!=typeof window,U="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,G=U&&WXEnvironment.platform.toLowerCase(),Z=W&&window.navigator.userAgent.toLowerCase(),J=Z&&/msie|trident/.test(Z),Q=Z&&Z.indexOf("msie 9.0")>0,K=Z&&Z.indexOf("edge/")>0,tt=(Z&&Z.indexOf("android"),Z&&/iphone|ipad|ipod|ios/.test(Z)||"ios"===G),et=(Z&&/chrome\/\d+/.test(Z),Z&&/phantomjs/.test(Z),Z&&Z.match(/firefox\/(\d+)/)),nt={}.watch,it=!1;if(W)try{var at={};Object.defineProperty(at,"passive",{get:function(){it=!0}}),window.addEventListener("test-passive",null,at)}catch(t){}var ot=function(){return void 0===V&&(V=!W&&!U&&void 0!==t&&(t.process&&"server"===t.process.env.VUE_ENV)),V},rt=W&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function st(t){return"function"==typeof t&&/native code/.test(t.toString())}var lt,dt="undefined"!=typeof Symbol&&st(Symbol)&&"undefined"!=typeof Reflect&&st(Reflect.ownKeys);lt="undefined"!=typeof Set&&st(Set)?Set:function(){function t(){this.set=Object.create(null)}return t.prototype.has=function(t){return!0===this.set[t]},t.prototype.add=function(t){this.set[t]=!0},t.prototype.clear=function(){this.set=Object.create(null)},t}();var ct=N,ht=0,ut=function(){this.id=ht++,this.subs=[]};ut.prototype.addSub=function(t){this.subs.push(t)},ut.prototype.removeSub=function(t){b(this.subs,t)},ut.prototype.depend=function(){ut.target&&ut.target.addDep(this)},ut.prototype.notify=function(){var t=this.subs.slice();for(var e=0,n=t.length;e<n;e++)t[e].update()},ut.target=null;var mt=[];function ft(t){mt.push(t),ut.target=t}function pt(){mt.pop(),ut.target=mt[mt.length-1]}var _t=function(t,e,n,i,a,o,r,s){this.tag=t,this.data=e,this.children=n,this.text=i,this.elm=a,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=e&&e.key,this.componentOptions=r,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},At={child:{configurable:!0}};At.child.get=function(){return this.componentInstance},Object.defineProperties(_t.prototype,At);var bt=function(t){void 0===t&&(t="");var e=new _t;return e.text=t,e.isComment=!0,e};function xt(t){return new _t(void 0,void 0,void 0,String(t))}function gt(t){var e=new _t(t.tag,t.data,t.children&&t.children.slice(),t.text,t.elm,t.context,t.componentOptions,t.asyncFactory);return e.ns=t.ns,e.isStatic=t.isStatic,e.key=t.key,e.isComment=t.isComment,e.fnContext=t.fnContext,e.fnOptions=t.fnOptions,e.fnScopeId=t.fnScopeId,e.asyncMeta=t.asyncMeta,e.isCloned=!0,e}var vt=Array.prototype,Ct=Object.create(vt);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(t){var e=vt[t];z(Ct,t,function(){for(var n=[],i=arguments.length;i--;)n[i]=arguments[i];var a,o=e.apply(this,n),r=this.__ob__;switch(t){case"push":case"unshift":a=n;break;case"splice":a=n.slice(2)}return a&&r.observeArray(a),r.dep.notify(),o})});var yt=Object.getOwnPropertyNames(Ct),wt=!0;function Bt(t){wt=t}var kt=function(t){var e;this.value=t,this.dep=new ut,this.vmCount=0,z(t,"__ob__",this),Array.isArray(t)?(q?(e=Ct,t.__proto__=e):function(t,e,n){for(var i=0,a=n.length;i<a;i++){var o=n[i];z(t,o,e[o])}}(t,Ct,yt),this.observeArray(t)):this.walk(t)};function Et(t,e){var n;if(s(t)&&!(t instanceof _t))return g(t,"__ob__")&&t.__ob__ instanceof kt?n=t.__ob__:wt&&!ot()&&(Array.isArray(t)||d(t))&&Object.isExtensible(t)&&!t._isVue&&(n=new kt(t)),e&&n&&n.vmCount++,n}function It(t,e,n,i,a){var o=new ut,r=Object.getOwnPropertyDescriptor(t,e);if(!r||!1!==r.configurable){var s=r&&r.get,l=r&&r.set;s&&!l||2!==arguments.length||(n=t[e]);var d=!a&&Et(n);Object.defineProperty(t,e,{enumerable:!0,configurable:!0,get:function(){var e=s?s.call(t):n;return ut.target&&(o.depend(),d&&(d.dep.depend(),Array.isArray(e)&&function t(e){for(var n=void 0,i=0,a=e.length;i<a;i++)(n=e[i])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&t(n)}(e))),e},set:function(e){var i=s?s.call(t):n;e===i||e!=e&&i!=i||s&&!l||(l?l.call(t,e):n=e,d=!a&&Et(e),o.notify())}})}}function Dt(t,e,n){if(Array.isArray(t)&&h(e))return t.length=Math.max(t.length,e),t.splice(e,1,n),n;if(e in t&&!(e in Object.prototype))return t[e]=n,n;var i=t.__ob__;return t._isVue||i&&i.vmCount?n:i?(It(i.value,e,n),i.dep.notify(),n):(t[e]=n,n)}function St(t,e){if(Array.isArray(t)&&h(e))t.splice(e,1);else{var n=t.__ob__;t._isVue||n&&n.vmCount||g(t,e)&&(delete t[e],n&&n.dep.notify())}}kt.prototype.walk=function(t){for(var e=Object.keys(t),n=0;n<e.length;n++)It(t,e[n])},kt.prototype.observeArray=function(t){for(var e=0,n=t.length;e<n;e++)Et(t[e])};var Nt=R.optionMergeStrategies;function Mt(t,e){if(!e)return t;for(var n,i,a,o=dt?Reflect.ownKeys(e):Object.keys(e),r=0;r<o.length;r++)"__ob__"!==(n=o[r])&&(i=t[n],a=e[n],g(t,n)?i!==a&&d(i)&&d(a)&&Mt(i,a):Dt(t,n,a));return t}function Ot(t,e,n){return n?function(){var i="function"==typeof e?e.call(n,n):e,a="function"==typeof t?t.call(n,n):t;return i?Mt(i,a):a}:e?t?function(){return Mt("function"==typeof e?e.call(this,this):e,"function"==typeof t?t.call(this,this):t)}:e:t}function Tt(t,e){var n=e?t?t.concat(e):Array.isArray(e)?e:[e]:t;return n?function(t){for(var e=[],n=0;n<t.length;n++)-1===e.indexOf(t[n])&&e.push(t[n]);return e}(n):n}function Lt(t,e,n,i){var a=Object.create(t||null);return e?D(a,e):a}Nt.data=function(t,e,n){return n?Ot(t,e,n):e&&"function"!=typeof e?t:Ot(t,e)},Y.forEach(function(t){Nt[t]=Tt}),F.forEach(function(t){Nt[t+"s"]=Lt}),Nt.watch=function(t,e,n,i){if(t===nt&&(t=void 0),e===nt&&(e=void 0),!e)return Object.create(t||null);if(!t)return e;var a={};for(var o in D(a,t),e){var r=a[o],s=e[o];r&&!Array.isArray(r)&&(r=[r]),a[o]=r?r.concat(s):Array.isArray(s)?s:[s]}return a},Nt.props=Nt.methods=Nt.inject=Nt.computed=function(t,e,n,i){if(!t)return e;var a=Object.create(null);return D(a,t),e&&D(a,e),a},Nt.provide=Ot;var jt=function(t,e){return void 0===e?t:e};function Pt(t,e,n){if("function"==typeof e&&(e=e.options),function(t,e){var n=t.props;if(n){var i,a,o={};if(Array.isArray(n))for(i=n.length;i--;)"string"==typeof(a=n[i])&&(o[y(a)]={type:null});else if(d(n))for(var r in n)a=n[r],o[y(r)]=d(a)?a:{type:a};t.props=o}}(e),function(t,e){var n=t.inject;if(n){var i=t.inject={};if(Array.isArray(n))for(var a=0;a<n.length;a++)i[n[a]]={from:n[a]};else if(d(n))for(var o in n){var r=n[o];i[o]=d(r)?D({from:o},r):{from:r}}}}(e),function(t){var e=t.directives;if(e)for(var n in e){var i=e[n];"function"==typeof i&&(e[n]={bind:i,update:i})}}(e),!e._base&&(e.extends&&(t=Pt(t,e.extends,n)),e.mixins))for(var i=0,a=e.mixins.length;i<a;i++)t=Pt(t,e.mixins[i],n);var o,r={};for(o in t)s(o);for(o in e)g(t,o)||s(o);function s(i){var a=Nt[i]||jt;r[i]=a(t[i],e[i],n,i)}return r}function Ft(t,e,n,i){if("string"==typeof n){var a=t[e];if(g(a,n))return a[n];var o=y(n);if(g(a,o))return a[o];var r=w(o);return g(a,r)?a[r]:a[n]||a[o]||a[r]}}function Yt(t,e,n,i){var a=e[t],o=!g(n,t),r=n[t],s=zt(Boolean,a.type);if(s>-1)if(o&&!g(a,"default"))r=!1;else if(""===r||r===k(t)){var l=zt(String,a.type);(l<0||s<l)&&(r=!0)}if(void 0===r){r=function(t,e,n){if(!g(e,"default"))return;var i=e.default;0;if(t&&t.$options.propsData&&void 0===t.$options.propsData[n]&&void 0!==t._props[n])return t._props[n];return"function"==typeof i&&"Function"!==Ht(e.type)?i.call(t):i}(i,a,t);var d=wt;Bt(!0),Et(r),Bt(d)}return r}var Rt=/^\s*function (\w+)/;function Ht(t){var e=t&&t.toString().match(Rt);return e?e[1]:""}function $t(t,e){return Ht(t)===Ht(e)}function zt(t,e){if(!Array.isArray(e))return $t(e,t)?0:-1;for(var n=0,i=e.length;n<i;n++)if($t(e[n],t))return n;return-1}function Xt(t,e,n){ft();try{if(e)for(var i=e;i=i.$parent;){var a=i.$options.errorCaptured;if(a)for(var o=0;o<a.length;o++)try{if(!1===a[o].call(i,t,e,n))return}catch(t){qt(t,i,"errorCaptured hook")}}qt(t,e,n)}finally{pt()}}function Vt(t,e,n,i,a){var o;try{(o=n?t.apply(e,n):t.call(e))&&!o._isVue&&u(o)&&!o._handled&&(o.catch(function(t){return Xt(t,i,a+" (Promise/async)")}),o._handled=!0)}catch(t){Xt(t,i,a)}return o}function qt(t,e,n){if(R.errorHandler)try{return R.errorHandler.call(null,t,e,n)}catch(e){e!==t&&Wt(e,null,"config.errorHandler")}Wt(t,e,n)}function Wt(t,e,n){if(!W&&!U||"undefined"==typeof console)throw t;console.error(t)}var Ut,Gt=!1,Zt=[],Jt=!1;function Qt(){Jt=!1;var t=Zt.slice(0);Zt.length=0;for(var e=0;e<t.length;e++)t[e]()}if("undefined"!=typeof Promise&&st(Promise)){var Kt=Promise.resolve();Ut=function(){Kt.then(Qt),tt&&setTimeout(N)},Gt=!0}else if(J||"undefined"==typeof MutationObserver||!st(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())Ut="undefined"!=typeof setImmediate&&st(setImmediate)?function(){setImmediate(Qt)}:function(){setTimeout(Qt,0)};else{var te=1,ee=new MutationObserver(Qt),ne=document.createTextNode(String(te));ee.observe(ne,{characterData:!0}),Ut=function(){te=(te+1)%2,ne.data=String(te)},Gt=!0}function ie(t,e){var n;if(Zt.push(function(){if(t)try{t.call(e)}catch(t){Xt(t,e,"nextTick")}else n&&n(e)}),Jt||(Jt=!0,Ut()),!t&&"undefined"!=typeof Promise)return new Promise(function(t){n=t})}var ae=new lt;function oe(t){!function t(e,n){var i,a;var o=Array.isArray(e);if(!o&&!s(e)||Object.isFrozen(e)||e instanceof _t)return;if(e.__ob__){var r=e.__ob__.dep.id;if(n.has(r))return;n.add(r)}if(o)for(i=e.length;i--;)t(e[i],n);else for(a=Object.keys(e),i=a.length;i--;)t(e[a[i]],n)}(t,ae),ae.clear()}var re=v(function(t){var e="&"===t.charAt(0),n="~"===(t=e?t.slice(1):t).charAt(0),i="!"===(t=n?t.slice(1):t).charAt(0);return{name:t=i?t.slice(1):t,once:n,capture:i,passive:e}});function se(t,e){function n(){var t=arguments,i=n.fns;if(!Array.isArray(i))return Vt(i,null,arguments,e,"v-on handler");for(var a=i.slice(),o=0;o<a.length;o++)Vt(a[o],null,t,e,"v-on handler")}return n.fns=t,n}function le(t,e,n,a,r,s){var l,d,c,h;for(l in t)d=t[l],c=e[l],h=re(l),i(d)||(i(c)?(i(d.fns)&&(d=t[l]=se(d,s)),o(h.once)&&(d=t[l]=r(h.name,d,h.capture)),n(h.name,d,h.capture,h.passive,h.params)):d!==c&&(c.fns=d,t[l]=c));for(l in e)i(t[l])&&a((h=re(l)).name,e[l],h.capture)}function de(t,e,n){var r;t instanceof _t&&(t=t.data.hook||(t.data.hook={}));var s=t[e];function l(){n.apply(this,arguments),b(r.fns,l)}i(s)?r=se([l]):a(s.fns)&&o(s.merged)?(r=s).fns.push(l):r=se([s,l]),r.merged=!0,t[e]=r}function ce(t,e,n,i,o){if(a(e)){if(g(e,n))return t[n]=e[n],o||delete e[n],!0;if(g(e,i))return t[n]=e[i],o||delete e[i],!0}return!1}function he(t){return r(t)?[xt(t)]:Array.isArray(t)?function t(e,n){var s=[];var l,d,c,h;for(l=0;l<e.length;l++)i(d=e[l])||"boolean"==typeof d||(c=s.length-1,h=s[c],Array.isArray(d)?d.length>0&&(ue((d=t(d,(n||"")+"_"+l))[0])&&ue(h)&&(s[c]=xt(h.text+d[0].text),d.shift()),s.push.apply(s,d)):r(d)?ue(h)?s[c]=xt(h.text+d):""!==d&&s.push(xt(d)):ue(d)&&ue(h)?s[c]=xt(h.text+d.text):(o(e._isVList)&&a(d.tag)&&i(d.key)&&a(n)&&(d.key="__vlist"+n+"_"+l+"__"),s.push(d)));return s}(t):void 0}function ue(t){return a(t)&&a(t.text)&&!1===t.isComment}function me(t,e){if(t){for(var n=Object.create(null),i=dt?Reflect.ownKeys(t):Object.keys(t),a=0;a<i.length;a++){var o=i[a];if("__ob__"!==o){for(var r=t[o].from,s=e;s;){if(s._provided&&g(s._provided,r)){n[o]=s._provided[r];break}s=s.$parent}if(!s)if("default"in t[o]){var l=t[o].default;n[o]="function"==typeof l?l.call(e):l}else 0}}return n}}function fe(t,e){if(!t||!t.length)return{};for(var n={},i=0,a=t.length;i<a;i++){var o=t[i],r=o.data;if(r&&r.attrs&&r.attrs.slot&&delete r.attrs.slot,o.context!==e&&o.fnContext!==e||!r||null==r.slot)(n.default||(n.default=[])).push(o);else{var s=r.slot,l=n[s]||(n[s]=[]);"template"===o.tag?l.push.apply(l,o.children||[]):l.push(o)}}for(var d in n)n[d].every(pe)&&delete n[d];return n}function pe(t){return t.isComment&&!t.asyncFactory||" "===t.text}function _e(t){return t.isComment&&t.asyncFactory}function Ae(t,e,i){var a,o=Object.keys(e).length>0,r=t?!!t.$stable:!o,s=t&&t.$key;if(t){if(t._normalized)return t._normalized;if(r&&i&&i!==n&&s===i.$key&&!o&&!i.$hasNormal)return i;for(var l in a={},t)t[l]&&"$"!==l[0]&&(a[l]=be(e,l,t[l]))}else a={};for(var d in e)d in a||(a[d]=xe(e,d));return t&&Object.isExtensible(t)&&(t._normalized=a),z(a,"$stable",r),z(a,"$key",s),z(a,"$hasNormal",o),a}function be(t,e,n){var i=function(){var t=arguments.length?n.apply(null,arguments):n({}),e=(t=t&&"object"==typeof t&&!Array.isArray(t)?[t]:he(t))&&t[0];return t&&(!e||1===t.length&&e.isComment&&!_e(e))?void 0:t};return n.proxy&&Object.defineProperty(t,e,{get:i,enumerable:!0,configurable:!0}),i}function xe(t,e){return function(){return t[e]}}function ge(t,e){var n,i,o,r,l;if(Array.isArray(t)||"string"==typeof t)for(n=new Array(t.length),i=0,o=t.length;i<o;i++)n[i]=e(t[i],i);else if("number"==typeof t)for(n=new Array(t),i=0;i<t;i++)n[i]=e(i+1,i);else if(s(t))if(dt&&t[Symbol.iterator]){n=[];for(var d=t[Symbol.iterator](),c=d.next();!c.done;)n.push(e(c.value,n.length)),c=d.next()}else for(r=Object.keys(t),n=new Array(r.length),i=0,o=r.length;i<o;i++)l=r[i],n[i]=e(t[l],l,i);return a(n)||(n=[]),n._isVList=!0,n}function ve(t,e,n,i){var a,o=this.$scopedSlots[t];o?(n=n||{},i&&(n=D(D({},i),n)),a=o(n)||("function"==typeof e?e():e)):a=this.$slots[t]||("function"==typeof e?e():e);var r=n&&n.slot;return r?this.$createElement("template",{slot:r},a):a}function Ce(t){return Ft(this.$options,"filters",t)||O}function ye(t,e){return Array.isArray(t)?-1===t.indexOf(e):t!==e}function we(t,e,n,i,a){var o=R.keyCodes[e]||n;return a&&i&&!R.keyCodes[e]?ye(a,i):o?ye(o,t):i?k(i)!==e:void 0===t}function Be(t,e,n,i,a){if(n)if(s(n)){var o;Array.isArray(n)&&(n=S(n));var r=function(r){if("class"===r||"style"===r||A(r))o=t;else{var s=t.attrs&&t.attrs.type;o=i||R.mustUseProp(e,s,r)?t.domProps||(t.domProps={}):t.attrs||(t.attrs={})}var l=y(r),d=k(r);l in o||d in o||(o[r]=n[r],a&&((t.on||(t.on={}))["update:"+r]=function(t){n[r]=t}))};for(var l in n)r(l)}else;return t}function ke(t,e){var n=this._staticTrees||(this._staticTrees=[]),i=n[t];return i&&!e?i:(Ie(i=n[t]=this.$options.staticRenderFns[t].call(this._renderProxy,null,this),"__static__"+t,!1),i)}function Ee(t,e,n){return Ie(t,"__once__"+e+(n?"_"+n:""),!0),t}function Ie(t,e,n){if(Array.isArray(t))for(var i=0;i<t.length;i++)t[i]&&"string"!=typeof t[i]&&De(t[i],e+"_"+i,n);else De(t,e,n)}function De(t,e,n){t.isStatic=!0,t.key=e,t.isOnce=n}function Se(t,e){if(e)if(d(e)){var n=t.on=t.on?D({},t.on):{};for(var i in e){var a=n[i],o=e[i];n[i]=a?[].concat(a,o):o}}else;return t}function Ne(t,e,n,i){e=e||{$stable:!n};for(var a=0;a<t.length;a++){var o=t[a];Array.isArray(o)?Ne(o,e,n):o&&(o.proxy&&(o.fn.proxy=!0),e[o.key]=o.fn)}return i&&(e.$key=i),e}function Me(t,e){for(var n=0;n<e.length;n+=2){var i=e[n];"string"==typeof i&&i&&(t[e[n]]=e[n+1])}return t}function Oe(t,e){return"string"==typeof t?e+t:t}function Te(t){t._o=Ee,t._n=f,t._s=m,t._l=ge,t._t=ve,t._q=T,t._i=L,t._m=ke,t._f=Ce,t._k=we,t._b=Be,t._v=xt,t._e=bt,t._u=Ne,t._g=Se,t._d=Me,t._p=Oe}function Le(t,e,i,a,r){var s,l=this,d=r.options;g(a,"_uid")?(s=Object.create(a))._original=a:(s=a,a=a._original);var c=o(d._compiled),h=!c;this.data=t,this.props=e,this.children=i,this.parent=a,this.listeners=t.on||n,this.injections=me(d.inject,a),this.slots=function(){return l.$slots||Ae(t.scopedSlots,l.$slots=fe(i,a)),l.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return Ae(t.scopedSlots,this.slots())}}),c&&(this.$options=d,this.$slots=this.slots(),this.$scopedSlots=Ae(t.scopedSlots,this.$slots)),d._scopeId?this._c=function(t,e,n,i){var o=Xe(s,t,e,n,i,h);return o&&!Array.isArray(o)&&(o.fnScopeId=d._scopeId,o.fnContext=a),o}:this._c=function(t,e,n,i){return Xe(s,t,e,n,i,h)}}function je(t,e,n,i,a){var o=gt(t);return o.fnContext=n,o.fnOptions=i,e.slot&&((o.data||(o.data={})).slot=e.slot),o}function Pe(t,e){for(var n in e)t[y(n)]=e[n]}Te(Le.prototype);var Fe={init:function(t,e){if(t.componentInstance&&!t.componentInstance._isDestroyed&&t.data.keepAlive){var n=t;Fe.prepatch(n,n)}else{(t.componentInstance=function(t,e){var n={_isComponent:!0,_parentVnode:t,parent:e},i=t.data.inlineTemplate;a(i)&&(n.render=i.render,n.staticRenderFns=i.staticRenderFns);return new t.componentOptions.Ctor(n)}(t,Ke)).$mount(e?t.elm:void 0,e)}},prepatch:function(t,e){var i=e.componentOptions;!function(t,e,i,a,o){0;var r=a.data.scopedSlots,s=t.$scopedSlots,l=!!(r&&!r.$stable||s!==n&&!s.$stable||r&&t.$scopedSlots.$key!==r.$key||!r&&t.$scopedSlots.$key),d=!!(o||t.$options._renderChildren||l);t.$options._parentVnode=a,t.$vnode=a,t._vnode&&(t._vnode.parent=a);if(t.$options._renderChildren=o,t.$attrs=a.data.attrs||n,t.$listeners=i||n,e&&t.$options.props){Bt(!1);for(var c=t._props,h=t.$options._propKeys||[],u=0;u<h.length;u++){var m=h[u],f=t.$options.props;c[m]=Yt(m,f,e,t)}Bt(!0),t.$options.propsData=e}i=i||n;var p=t.$options._parentListeners;t.$options._parentListeners=i,Qe(t,i,p),d&&(t.$slots=fe(o,a.context),t.$forceUpdate());0}(e.componentInstance=t.componentInstance,i.propsData,i.listeners,e,i.children)},insert:function(t){var e,n=t.context,i=t.componentInstance;i._isMounted||(i._isMounted=!0,an(i,"mounted")),t.data.keepAlive&&(n._isMounted?((e=i)._inactive=!1,rn.push(e)):nn(i,!0))},destroy:function(t){var e=t.componentInstance;e._isDestroyed||(t.data.keepAlive?function t(e,n){if(n&&(e._directInactive=!0,en(e)))return;if(!e._inactive){e._inactive=!0;for(var i=0;i<e.$children.length;i++)t(e.$children[i]);an(e,"deactivated")}}(e,!0):e.$destroy())}},Ye=Object.keys(Fe);function Re(t,e,r,l,d){if(!i(t)){var c=r.$options._base;if(s(t)&&(t=c.extend(t)),"function"==typeof t){var h;if(i(t.cid)&&void 0===(t=function(t,e){if(o(t.error)&&a(t.errorComp))return t.errorComp;if(a(t.resolved))return t.resolved;var n=qe;n&&a(t.owners)&&-1===t.owners.indexOf(n)&&t.owners.push(n);if(o(t.loading)&&a(t.loadingComp))return t.loadingComp;if(n&&!a(t.owners)){var r=t.owners=[n],l=!0,d=null,c=null;n.$on("hook:destroyed",function(){return b(r,n)});var h=function(t){for(var e=0,n=r.length;e<n;e++)r[e].$forceUpdate();t&&(r.length=0,null!==d&&(clearTimeout(d),d=null),null!==c&&(clearTimeout(c),c=null))},m=j(function(n){t.resolved=We(n,e),l?r.length=0:h(!0)}),f=j(function(e){a(t.errorComp)&&(t.error=!0,h(!0))}),p=t(m,f);return s(p)&&(u(p)?i(t.resolved)&&p.then(m,f):u(p.component)&&(p.component.then(m,f),a(p.error)&&(t.errorComp=We(p.error,e)),a(p.loading)&&(t.loadingComp=We(p.loading,e),0===p.delay?t.loading=!0:d=setTimeout(function(){d=null,i(t.resolved)&&i(t.error)&&(t.loading=!0,h(!1))},p.delay||200)),a(p.timeout)&&(c=setTimeout(function(){c=null,i(t.resolved)&&f(null)},p.timeout)))),l=!1,t.loading?t.loadingComp:t.resolved}}(h=t,c)))return function(t,e,n,i,a){var o=bt();return o.asyncFactory=t,o.asyncMeta={data:e,context:n,children:i,tag:a},o}(h,e,r,l,d);e=e||{},kn(t),a(e.model)&&function(t,e){var n=t.model&&t.model.prop||"value",i=t.model&&t.model.event||"input";(e.attrs||(e.attrs={}))[n]=e.model.value;var o=e.on||(e.on={}),r=o[i],s=e.model.callback;a(r)?(Array.isArray(r)?-1===r.indexOf(s):r!==s)&&(o[i]=[s].concat(r)):o[i]=s}(t.options,e);var m=function(t,e,n){var o=e.options.props;if(!i(o)){var r={},s=t.attrs,l=t.props;if(a(s)||a(l))for(var d in o){var c=k(d);ce(r,l,d,c,!0)||ce(r,s,d,c,!1)}return r}}(e,t);if(o(t.options.functional))return function(t,e,i,o,r){var s=t.options,l={},d=s.props;if(a(d))for(var c in d)l[c]=Yt(c,d,e||n);else a(i.attrs)&&Pe(l,i.attrs),a(i.props)&&Pe(l,i.props);var h=new Le(i,l,r,o,t),u=s.render.call(null,h._c,h);if(u instanceof _t)return je(u,i,h.parent,s);if(Array.isArray(u)){for(var m=he(u)||[],f=new Array(m.length),p=0;p<m.length;p++)f[p]=je(m[p],i,h.parent,s);return f}}(t,m,e,r,l);var f=e.on;if(e.on=e.nativeOn,o(t.options.abstract)){var p=e.slot;e={},p&&(e.slot=p)}!function(t){for(var e=t.hook||(t.hook={}),n=0;n<Ye.length;n++){var i=Ye[n],a=e[i],o=Fe[i];a===o||a&&a._merged||(e[i]=a?He(o,a):o)}}(e);var _=t.options.name||d;return new _t("vue-component-"+t.cid+(_?"-"+_:""),e,void 0,void 0,void 0,r,{Ctor:t,propsData:m,listeners:f,tag:d,children:l},h)}}}function He(t,e){var n=function(n,i){t(n,i),e(n,i)};return n._merged=!0,n}var $e=1,ze=2;function Xe(t,e,n,l,d,c){return(Array.isArray(n)||r(n))&&(d=l,l=n,n=void 0),o(c)&&(d=ze),function(t,e,n,r,l){if(a(n)&&a(n.__ob__))return bt();a(n)&&a(n.is)&&(e=n.is);if(!e)return bt();0;Array.isArray(r)&&"function"==typeof r[0]&&((n=n||{}).scopedSlots={default:r[0]},r.length=0);l===ze?r=he(r):l===$e&&(r=function(t){for(var e=0;e<t.length;e++)if(Array.isArray(t[e]))return Array.prototype.concat.apply([],t);return t}(r));var d,c;if("string"==typeof e){var h;c=t.$vnode&&t.$vnode.ns||R.getTagNamespace(e),d=R.isReservedTag(e)?new _t(R.parsePlatformTagName(e),n,r,void 0,void 0,t):n&&n.pre||!a(h=Ft(t.$options,"components",e))?new _t(e,n,r,void 0,void 0,t):Re(h,n,t,r,e)}else d=Re(e,n,t,r);return Array.isArray(d)?d:a(d)?(a(c)&&function t(e,n,r){e.ns=n;"foreignObject"===e.tag&&(n=void 0,r=!0);if(a(e.children))for(var s=0,l=e.children.length;s<l;s++){var d=e.children[s];a(d.tag)&&(i(d.ns)||o(r)&&"svg"!==d.tag)&&t(d,n,r)}}(d,c),a(n)&&function(t){s(t.style)&&oe(t.style);s(t.class)&&oe(t.class)}(n),d):bt()}(t,e,n,l,d)}var Ve,qe=null;function We(t,e){return(t.__esModule||dt&&"Module"===t[Symbol.toStringTag])&&(t=t.default),s(t)?e.extend(t):t}function Ue(t){if(Array.isArray(t))for(var e=0;e<t.length;e++){var n=t[e];if(a(n)&&(a(n.componentOptions)||_e(n)))return n}}function Ge(t,e){Ve.$on(t,e)}function Ze(t,e){Ve.$off(t,e)}function Je(t,e){var n=Ve;return function i(){null!==e.apply(null,arguments)&&n.$off(t,i)}}function Qe(t,e,n){Ve=t,le(e,n||{},Ge,Ze,Je,t),Ve=void 0}var Ke=null;function tn(t){var e=Ke;return Ke=t,function(){Ke=e}}function en(t){for(;t&&(t=t.$parent);)if(t._inactive)return!0;return!1}function nn(t,e){if(e){if(t._directInactive=!1,en(t))return}else if(t._directInactive)return;if(t._inactive||null===t._inactive){t._inactive=!1;for(var n=0;n<t.$children.length;n++)nn(t.$children[n]);an(t,"activated")}}function an(t,e){ft();var n=t.$options[e],i=e+" hook";if(n)for(var a=0,o=n.length;a<o;a++)Vt(n[a],t,null,t,i);t._hasHookEvent&&t.$emit("hook:"+e),pt()}var on=[],rn=[],sn={},ln=!1,dn=!1,cn=0;var hn=0,un=Date.now;if(W&&!J){var mn=window.performance;mn&&"function"==typeof mn.now&&un()>document.createEvent("Event").timeStamp&&(un=function(){return mn.now()})}function fn(){var t,e;for(hn=un(),dn=!0,on.sort(function(t,e){return t.id-e.id}),cn=0;cn<on.length;cn++)(t=on[cn]).before&&t.before(),e=t.id,sn[e]=null,t.run();var n=rn.slice(),i=on.slice();cn=on.length=rn.length=0,sn={},ln=dn=!1,function(t){for(var e=0;e<t.length;e++)t[e]._inactive=!0,nn(t[e],!0)}(n),function(t){var e=t.length;for(;e--;){var n=t[e],i=n.vm;i._watcher===n&&i._isMounted&&!i._isDestroyed&&an(i,"updated")}}(i),rt&&R.devtools&&rt.emit("flush")}var pn=0,_n=function(t,e,n,i,a){this.vm=t,a&&(t._watcher=this),t._watchers.push(this),i?(this.deep=!!i.deep,this.user=!!i.user,this.lazy=!!i.lazy,this.sync=!!i.sync,this.before=i.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++pn,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new lt,this.newDepIds=new lt,this.expression="","function"==typeof e?this.getter=e:(this.getter=function(t){if(!X.test(t)){var e=t.split(".");return function(t){for(var n=0;n<e.length;n++){if(!t)return;t=t[e[n]]}return t}}}(e),this.getter||(this.getter=N)),this.value=this.lazy?void 0:this.get()};_n.prototype.get=function(){var t;ft(this);var e=this.vm;try{t=this.getter.call(e,e)}catch(t){if(!this.user)throw t;Xt(t,e,'getter for watcher "'+this.expression+'"')}finally{this.deep&&oe(t),pt(),this.cleanupDeps()}return t},_n.prototype.addDep=function(t){var e=t.id;this.newDepIds.has(e)||(this.newDepIds.add(e),this.newDeps.push(t),this.depIds.has(e)||t.addSub(this))},_n.prototype.cleanupDeps=function(){for(var t=this.deps.length;t--;){var e=this.deps[t];this.newDepIds.has(e.id)||e.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},_n.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(t){var e=t.id;if(null==sn[e]){if(sn[e]=!0,dn){for(var n=on.length-1;n>cn&&on[n].id>t.id;)n--;on.splice(n+1,0,t)}else on.push(t);ln||(ln=!0,ie(fn))}}(this)},_n.prototype.run=function(){if(this.active){var t=this.get();if(t!==this.value||s(t)||this.deep){var e=this.value;if(this.value=t,this.user){var n='callback for watcher "'+this.expression+'"';Vt(this.cb,this.vm,[t,e],this.vm,n)}else this.cb.call(this.vm,t,e)}}},_n.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},_n.prototype.depend=function(){for(var t=this.deps.length;t--;)this.deps[t].depend()},_n.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||b(this.vm._watchers,this);for(var t=this.deps.length;t--;)this.deps[t].removeSub(this);this.active=!1}};var An={enumerable:!0,configurable:!0,get:N,set:N};function bn(t,e,n){An.get=function(){return this[e][n]},An.set=function(t){this[e][n]=t},Object.defineProperty(t,n,An)}function xn(t){t._watchers=[];var e=t.$options;e.props&&function(t,e){var n=t.$options.propsData||{},i=t._props={},a=t.$options._propKeys=[],o=!t.$parent;o||Bt(!1);var r=function(o){a.push(o);var r=Yt(o,e,n,t);It(i,o,r),o in t||bn(t,"_props",o)};for(var s in e)r(s);Bt(!0)}(t,e.props),e.methods&&function(t,e){t.$options.props;for(var n in e)t[n]="function"!=typeof e[n]?N:E(e[n],t)}(t,e.methods),e.data?function(t){var e=t.$options.data;d(e=t._data="function"==typeof e?function(t,e){ft();try{return t.call(e,e)}catch(t){return Xt(t,e,"data()"),{}}finally{pt()}}(e,t):e||{})||(e={});var n=Object.keys(e),i=t.$options.props,a=(t.$options.methods,n.length);for(;a--;){var o=n[a];0,i&&g(i,o)||$(o)||bn(t,"_data",o)}Et(e,!0)}(t):Et(t._data={},!0),e.computed&&function(t,e){var n=t._computedWatchers=Object.create(null),i=ot();for(var a in e){var o=e[a],r="function"==typeof o?o:o.get;0,i||(n[a]=new _n(t,r||N,N,gn)),a in t||vn(t,a,o)}}(t,e.computed),e.watch&&e.watch!==nt&&function(t,e){for(var n in e){var i=e[n];if(Array.isArray(i))for(var a=0;a<i.length;a++)wn(t,n,i[a]);else wn(t,n,i)}}(t,e.watch)}var gn={lazy:!0};function vn(t,e,n){var i=!ot();"function"==typeof n?(An.get=i?Cn(e):yn(n),An.set=N):(An.get=n.get?i&&!1!==n.cache?Cn(e):yn(n.get):N,An.set=n.set||N),Object.defineProperty(t,e,An)}function Cn(t){return function(){var e=this._computedWatchers&&this._computedWatchers[t];if(e)return e.dirty&&e.evaluate(),ut.target&&e.depend(),e.value}}function yn(t){return function(){return t.call(this,this)}}function wn(t,e,n,i){return d(n)&&(i=n,n=n.handler),"string"==typeof n&&(n=t[n]),t.$watch(e,n,i)}var Bn=0;function kn(t){var e=t.options;if(t.super){var n=kn(t.super);if(n!==t.superOptions){t.superOptions=n;var i=function(t){var e,n=t.options,i=t.sealedOptions;for(var a in n)n[a]!==i[a]&&(e||(e={}),e[a]=n[a]);return e}(t);i&&D(t.extendOptions,i),(e=t.options=Pt(n,t.extendOptions)).name&&(e.components[e.name]=t)}}return e}function En(t){this._init(t)}function In(t){t.cid=0;var e=1;t.extend=function(t){t=t||{};var n=this,i=n.cid,a=t._Ctor||(t._Ctor={});if(a[i])return a[i];var o=t.name||n.options.name;var r=function(t){this._init(t)};return(r.prototype=Object.create(n.prototype)).constructor=r,r.cid=e++,r.options=Pt(n.options,t),r.super=n,r.options.props&&function(t){var e=t.options.props;for(var n in e)bn(t.prototype,"_props",n)}(r),r.options.computed&&function(t){var e=t.options.computed;for(var n in e)vn(t.prototype,n,e[n])}(r),r.extend=n.extend,r.mixin=n.mixin,r.use=n.use,F.forEach(function(t){r[t]=n[t]}),o&&(r.options.components[o]=r),r.superOptions=n.options,r.extendOptions=t,r.sealedOptions=D({},r.options),a[i]=r,r}}function Dn(t){return t&&(t.Ctor.options.name||t.tag)}function Sn(t,e){return Array.isArray(t)?t.indexOf(e)>-1:"string"==typeof t?t.split(",").indexOf(e)>-1:!!c(t)&&t.test(e)}function Nn(t,e){var n=t.cache,i=t.keys,a=t._vnode;for(var o in n){var r=n[o];if(r){var s=r.name;s&&!e(s)&&Mn(n,o,i,a)}}}function Mn(t,e,n,i){var a=t[e];!a||i&&a.tag===i.tag||a.componentInstance.$destroy(),t[e]=null,b(n,e)}!function(t){t.prototype._init=function(t){var e=this;e._uid=Bn++,e._isVue=!0,t&&t._isComponent?function(t,e){var n=t.$options=Object.create(t.constructor.options),i=e._parentVnode;n.parent=e.parent,n._parentVnode=i;var a=i.componentOptions;n.propsData=a.propsData,n._parentListeners=a.listeners,n._renderChildren=a.children,n._componentTag=a.tag,e.render&&(n.render=e.render,n.staticRenderFns=e.staticRenderFns)}(e,t):e.$options=Pt(kn(e.constructor),t||{},e),e._renderProxy=e,e._self=e,function(t){var e=t.$options,n=e.parent;if(n&&!e.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(t)}t.$parent=n,t.$root=n?n.$root:t,t.$children=[],t.$refs={},t._watcher=null,t._inactive=null,t._directInactive=!1,t._isMounted=!1,t._isDestroyed=!1,t._isBeingDestroyed=!1}(e),function(t){t._events=Object.create(null),t._hasHookEvent=!1;var e=t.$options._parentListeners;e&&Qe(t,e)}(e),function(t){t._vnode=null,t._staticTrees=null;var e=t.$options,i=t.$vnode=e._parentVnode,a=i&&i.context;t.$slots=fe(e._renderChildren,a),t.$scopedSlots=n,t._c=function(e,n,i,a){return Xe(t,e,n,i,a,!1)},t.$createElement=function(e,n,i,a){return Xe(t,e,n,i,a,!0)};var o=i&&i.data;It(t,"$attrs",o&&o.attrs||n,null,!0),It(t,"$listeners",e._parentListeners||n,null,!0)}(e),an(e,"beforeCreate"),function(t){var e=me(t.$options.inject,t);e&&(Bt(!1),Object.keys(e).forEach(function(n){It(t,n,e[n])}),Bt(!0))}(e),xn(e),function(t){var e=t.$options.provide;e&&(t._provided="function"==typeof e?e.call(t):e)}(e),an(e,"created"),e.$options.el&&e.$mount(e.$options.el)}}(En),function(t){var e={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(t.prototype,"$data",e),Object.defineProperty(t.prototype,"$props",n),t.prototype.$set=Dt,t.prototype.$delete=St,t.prototype.$watch=function(t,e,n){if(d(e))return wn(this,t,e,n);(n=n||{}).user=!0;var i=new _n(this,t,e,n);if(n.immediate){var a='callback for immediate watcher "'+i.expression+'"';ft(),Vt(e,this,[i.value],this,a),pt()}return function(){i.teardown()}}}(En),function(t){var e=/^hook:/;t.prototype.$on=function(t,n){var i=this;if(Array.isArray(t))for(var a=0,o=t.length;a<o;a++)i.$on(t[a],n);else(i._events[t]||(i._events[t]=[])).push(n),e.test(t)&&(i._hasHookEvent=!0);return i},t.prototype.$once=function(t,e){var n=this;function i(){n.$off(t,i),e.apply(n,arguments)}return i.fn=e,n.$on(t,i),n},t.prototype.$off=function(t,e){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(t)){for(var i=0,a=t.length;i<a;i++)n.$off(t[i],e);return n}var o,r=n._events[t];if(!r)return n;if(!e)return n._events[t]=null,n;for(var s=r.length;s--;)if((o=r[s])===e||o.fn===e){r.splice(s,1);break}return n},t.prototype.$emit=function(t){var e=this,n=e._events[t];if(n){n=n.length>1?I(n):n;for(var i=I(arguments,1),a='event handler for "'+t+'"',o=0,r=n.length;o<r;o++)Vt(n[o],e,i,e,a)}return e}}(En),function(t){t.prototype._update=function(t,e){var n=this,i=n.$el,a=n._vnode,o=tn(n);n._vnode=t,n.$el=a?n.__patch__(a,t):n.__patch__(n.$el,t,e,!1),o(),i&&(i.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},t.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},t.prototype.$destroy=function(){var t=this;if(!t._isBeingDestroyed){an(t,"beforeDestroy"),t._isBeingDestroyed=!0;var e=t.$parent;!e||e._isBeingDestroyed||t.$options.abstract||b(e.$children,t),t._watcher&&t._watcher.teardown();for(var n=t._watchers.length;n--;)t._watchers[n].teardown();t._data.__ob__&&t._data.__ob__.vmCount--,t._isDestroyed=!0,t.__patch__(t._vnode,null),an(t,"destroyed"),t.$off(),t.$el&&(t.$el.__vue__=null),t.$vnode&&(t.$vnode.parent=null)}}}(En),function(t){Te(t.prototype),t.prototype.$nextTick=function(t){return ie(t,this)},t.prototype._render=function(){var t,e=this,n=e.$options,i=n.render,a=n._parentVnode;a&&(e.$scopedSlots=Ae(a.data.scopedSlots,e.$slots,e.$scopedSlots)),e.$vnode=a;try{qe=e,t=i.call(e._renderProxy,e.$createElement)}catch(n){Xt(n,e,"render"),t=e._vnode}finally{qe=null}return Array.isArray(t)&&1===t.length&&(t=t[0]),t instanceof _t||(t=bt()),t.parent=a,t}}(En);var On=[String,RegExp,Array],Tn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:On,exclude:On,max:[String,Number]},methods:{cacheVNode:function(){var t=this.cache,e=this.keys,n=this.vnodeToCache,i=this.keyToCache;if(n){var a=n.tag,o=n.componentInstance,r=n.componentOptions;t[i]={name:Dn(r),tag:a,componentInstance:o},e.push(i),this.max&&e.length>parseInt(this.max)&&Mn(t,e[0],e,this._vnode),this.vnodeToCache=null}}},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var t in this.cache)Mn(this.cache,t,this.keys)},mounted:function(){var t=this;this.cacheVNode(),this.$watch("include",function(e){Nn(t,function(t){return Sn(e,t)})}),this.$watch("exclude",function(e){Nn(t,function(t){return!Sn(e,t)})})},updated:function(){this.cacheVNode()},render:function(){var t=this.$slots.default,e=Ue(t),n=e&&e.componentOptions;if(n){var i=Dn(n),a=this.include,o=this.exclude;if(a&&(!i||!Sn(a,i))||o&&i&&Sn(o,i))return e;var r=this.cache,s=this.keys,l=null==e.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):e.key;r[l]?(e.componentInstance=r[l].componentInstance,b(s,l),s.push(l)):(this.vnodeToCache=e,this.keyToCache=l),e.data.keepAlive=!0}return e||t&&t[0]}}};!function(t){var e={get:function(){return R}};Object.defineProperty(t,"config",e),t.util={warn:ct,extend:D,mergeOptions:Pt,defineReactive:It},t.set=Dt,t.delete=St,t.nextTick=ie,t.observable=function(t){return Et(t),t},t.options=Object.create(null),F.forEach(function(e){t.options[e+"s"]=Object.create(null)}),t.options._base=t,D(t.options.components,Tn),function(t){t.use=function(t){var e=this._installedPlugins||(this._installedPlugins=[]);if(e.indexOf(t)>-1)return this;var n=I(arguments,1);return n.unshift(this),"function"==typeof t.install?t.install.apply(t,n):"function"==typeof t&&t.apply(null,n),e.push(t),this}}(t),function(t){t.mixin=function(t){return this.options=Pt(this.options,t),this}}(t),In(t),function(t){F.forEach(function(e){t[e]=function(t,n){return n?("component"===e&&d(n)&&(n.name=n.name||t,n=this.options._base.extend(n)),"directive"===e&&"function"==typeof n&&(n={bind:n,update:n}),this.options[e+"s"][t]=n,n):this.options[e+"s"][t]}})}(t)}(En),Object.defineProperty(En.prototype,"$isServer",{get:ot}),Object.defineProperty(En.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(En,"FunctionalRenderContext",{value:Le}),En.version="2.6.14";var Ln=p("style,class"),jn=p("input,textarea,option,select,progress"),Pn=function(t,e,n){return"value"===n&&jn(t)&&"button"!==e||"selected"===n&&"option"===t||"checked"===n&&"input"===t||"muted"===n&&"video"===t},Fn=p("contenteditable,draggable,spellcheck"),Yn=p("events,caret,typing,plaintext-only"),Rn=function(t,e){return Vn(e)||"false"===e?"false":"contenteditable"===t&&Yn(e)?e:"true"},Hn=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible"),$n="http://www.w3.org/1999/xlink",zn=function(t){return":"===t.charAt(5)&&"xlink"===t.slice(0,5)},Xn=function(t){return zn(t)?t.slice(6,t.length):""},Vn=function(t){return null==t||!1===t};function qn(t){for(var e=t.data,n=t,i=t;a(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(e=Wn(i.data,e));for(;a(n=n.parent);)n&&n.data&&(e=Wn(e,n.data));return function(t,e){if(a(t)||a(e))return Un(t,Gn(e));return""}(e.staticClass,e.class)}function Wn(t,e){return{staticClass:Un(t.staticClass,e.staticClass),class:a(t.class)?[t.class,e.class]:e.class}}function Un(t,e){return t?e?t+" "+e:t:e||""}function Gn(t){return Array.isArray(t)?function(t){for(var e,n="",i=0,o=t.length;i<o;i++)a(e=Gn(t[i]))&&""!==e&&(n&&(n+=" "),n+=e);return n}(t):s(t)?function(t){var e="";for(var n in t)t[n]&&(e&&(e+=" "),e+=n);return e}(t):"string"==typeof t?t:""}var Zn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Jn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Qn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Kn=function(t){return Jn(t)||Qn(t)};function ti(t){return Qn(t)?"svg":"math"===t?"math":void 0}var ei=Object.create(null);var ni=p("text,number,password,search,email,tel,url");function ii(t){if("string"==typeof t){var e=document.querySelector(t);return e||document.createElement("div")}return t}var ai=Object.freeze({createElement:function(t,e){var n=document.createElement(t);return"select"!==t?n:(e.data&&e.data.attrs&&void 0!==e.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(t,e){return document.createElementNS(Zn[t],e)},createTextNode:function(t){return document.createTextNode(t)},createComment:function(t){return document.createComment(t)},insertBefore:function(t,e,n){t.insertBefore(e,n)},removeChild:function(t,e){t.removeChild(e)},appendChild:function(t,e){t.appendChild(e)},parentNode:function(t){return t.parentNode},nextSibling:function(t){return t.nextSibling},tagName:function(t){return t.tagName},setTextContent:function(t,e){t.textContent=e},setStyleScope:function(t,e){t.setAttribute(e,"")}}),oi={create:function(t,e){ri(e)},update:function(t,e){t.data.ref!==e.data.ref&&(ri(t,!0),ri(e))},destroy:function(t){ri(t,!0)}};function ri(t,e){var n=t.data.ref;if(a(n)){var i=t.context,o=t.componentInstance||t.elm,r=i.$refs;e?Array.isArray(r[n])?b(r[n],o):r[n]===o&&(r[n]=void 0):t.data.refInFor?Array.isArray(r[n])?r[n].indexOf(o)<0&&r[n].push(o):r[n]=[o]:r[n]=o}}var si=new _t("",{},[]),li=["create","activate","update","remove","destroy"];function di(t,e){return t.key===e.key&&t.asyncFactory===e.asyncFactory&&(t.tag===e.tag&&t.isComment===e.isComment&&a(t.data)===a(e.data)&&function(t,e){if("input"!==t.tag)return!0;var n,i=a(n=t.data)&&a(n=n.attrs)&&n.type,o=a(n=e.data)&&a(n=n.attrs)&&n.type;return i===o||ni(i)&&ni(o)}(t,e)||o(t.isAsyncPlaceholder)&&i(e.asyncFactory.error))}function ci(t,e,n){var i,o,r={};for(i=e;i<=n;++i)a(o=t[i].key)&&(r[o]=i);return r}var hi={create:ui,update:ui,destroy:function(t){ui(t,si)}};function ui(t,e){(t.data.directives||e.data.directives)&&function(t,e){var n,i,a,o=t===si,r=e===si,s=fi(t.data.directives,t.context),l=fi(e.data.directives,e.context),d=[],c=[];for(n in l)i=s[n],a=l[n],i?(a.oldValue=i.value,a.oldArg=i.arg,_i(a,"update",e,t),a.def&&a.def.componentUpdated&&c.push(a)):(_i(a,"bind",e,t),a.def&&a.def.inserted&&d.push(a));if(d.length){var h=function(){for(var n=0;n<d.length;n++)_i(d[n],"inserted",e,t)};o?de(e,"insert",h):h()}c.length&&de(e,"postpatch",function(){for(var n=0;n<c.length;n++)_i(c[n],"componentUpdated",e,t)});if(!o)for(n in s)l[n]||_i(s[n],"unbind",t,t,r)}(t,e)}var mi=Object.create(null);function fi(t,e){var n,i,a=Object.create(null);if(!t)return a;for(n=0;n<t.length;n++)(i=t[n]).modifiers||(i.modifiers=mi),a[pi(i)]=i,i.def=Ft(e.$options,"directives",i.name);return a}function pi(t){return t.rawName||t.name+"."+Object.keys(t.modifiers||{}).join(".")}function _i(t,e,n,i,a){var o=t.def&&t.def[e];if(o)try{o(n.elm,t,n,i,a)}catch(i){Xt(i,n.context,"directive "+t.name+" "+e+" hook")}}var Ai=[oi,hi];function bi(t,e){var n=e.componentOptions;if(!(a(n)&&!1===n.Ctor.options.inheritAttrs||i(t.data.attrs)&&i(e.data.attrs))){var o,r,s=e.elm,l=t.data.attrs||{},d=e.data.attrs||{};for(o in a(d.__ob__)&&(d=e.data.attrs=D({},d)),d)r=d[o],l[o]!==r&&xi(s,o,r,e.data.pre);for(o in(J||K)&&d.value!==l.value&&xi(s,"value",d.value),l)i(d[o])&&(zn(o)?s.removeAttributeNS($n,Xn(o)):Fn(o)||s.removeAttribute(o))}}function xi(t,e,n,i){i||t.tagName.indexOf("-")>-1?gi(t,e,n):Hn(e)?Vn(n)?t.removeAttribute(e):(n="allowfullscreen"===e&&"EMBED"===t.tagName?"true":e,t.setAttribute(e,n)):Fn(e)?t.setAttribute(e,Rn(e,n)):zn(e)?Vn(n)?t.removeAttributeNS($n,Xn(e)):t.setAttributeNS($n,e,n):gi(t,e,n)}function gi(t,e,n){if(Vn(n))t.removeAttribute(e);else{if(J&&!Q&&"TEXTAREA"===t.tagName&&"placeholder"===e&&""!==n&&!t.__ieph){var i=function(e){e.stopImmediatePropagation(),t.removeEventListener("input",i)};t.addEventListener("input",i),t.__ieph=!0}t.setAttribute(e,n)}}var vi={create:bi,update:bi};function Ci(t,e){var n=e.elm,o=e.data,r=t.data;if(!(i(o.staticClass)&&i(o.class)&&(i(r)||i(r.staticClass)&&i(r.class)))){var s=qn(e),l=n._transitionClasses;a(l)&&(s=Un(s,Gn(l))),s!==n._prevClass&&(n.setAttribute("class",s),n._prevClass=s)}}var yi,wi,Bi,ki,Ei,Ii,Di={create:Ci,update:Ci},Si=/[\w).+\-_$\]]/;function Ni(t){var e,n,i,a,o,r=!1,s=!1,l=!1,d=!1,c=0,h=0,u=0,m=0;for(i=0;i<t.length;i++)if(n=e,e=t.charCodeAt(i),r)39===e&&92!==n&&(r=!1);else if(s)34===e&&92!==n&&(s=!1);else if(l)96===e&&92!==n&&(l=!1);else if(d)47===e&&92!==n&&(d=!1);else if(124!==e||124===t.charCodeAt(i+1)||124===t.charCodeAt(i-1)||c||h||u){switch(e){case 34:s=!0;break;case 39:r=!0;break;case 96:l=!0;break;case 40:u++;break;case 41:u--;break;case 91:h++;break;case 93:h--;break;case 123:c++;break;case 125:c--}if(47===e){for(var f=i-1,p=void 0;f>=0&&" "===(p=t.charAt(f));f--);p&&Si.test(p)||(d=!0)}}else void 0===a?(m=i+1,a=t.slice(0,i).trim()):_();function _(){(o||(o=[])).push(t.slice(m,i).trim()),m=i+1}if(void 0===a?a=t.slice(0,i).trim():0!==m&&_(),o)for(i=0;i<o.length;i++)a=Mi(a,o[i]);return a}function Mi(t,e){var n=e.indexOf("(");if(n<0)return'_f("'+e+'")('+t+")";var i=e.slice(0,n),a=e.slice(n+1);return'_f("'+i+'")('+t+(")"!==a?","+a:a)}function Oi(t,e){console.error("[Vue compiler]: "+t)}function Ti(t,e){return t?t.map(function(t){return t[e]}).filter(function(t){return t}):[]}function Li(t,e,n,i,a){(t.props||(t.props=[])).push(Vi({name:e,value:n,dynamic:a},i)),t.plain=!1}function ji(t,e,n,i,a){(a?t.dynamicAttrs||(t.dynamicAttrs=[]):t.attrs||(t.attrs=[])).push(Vi({name:e,value:n,dynamic:a},i)),t.plain=!1}function Pi(t,e,n,i){t.attrsMap[e]=n,t.attrsList.push(Vi({name:e,value:n},i))}function Fi(t,e,n,i,a,o,r,s){(t.directives||(t.directives=[])).push(Vi({name:e,rawName:n,value:i,arg:a,isDynamicArg:o,modifiers:r},s)),t.plain=!1}function Yi(t,e,n){return n?"_p("+e+',"'+t+'")':t+e}function Ri(t,e,i,a,o,r,s,l){var d;(a=a||n).right?l?e="("+e+")==='click'?'contextmenu':("+e+")":"click"===e&&(e="contextmenu",delete a.right):a.middle&&(l?e="("+e+")==='click'?'mouseup':("+e+")":"click"===e&&(e="mouseup")),a.capture&&(delete a.capture,e=Yi("!",e,l)),a.once&&(delete a.once,e=Yi("~",e,l)),a.passive&&(delete a.passive,e=Yi("&",e,l)),a.native?(delete a.native,d=t.nativeEvents||(t.nativeEvents={})):d=t.events||(t.events={});var c=Vi({value:i.trim(),dynamic:l},s);a!==n&&(c.modifiers=a);var h=d[e];Array.isArray(h)?o?h.unshift(c):h.push(c):d[e]=h?o?[c,h]:[h,c]:c,t.plain=!1}function Hi(t,e){return t.rawAttrsMap[":"+e]||t.rawAttrsMap["v-bind:"+e]||t.rawAttrsMap[e]}function $i(t,e,n){var i=zi(t,":"+e)||zi(t,"v-bind:"+e);if(null!=i)return Ni(i);if(!1!==n){var a=zi(t,e);if(null!=a)return JSON.stringify(a)}}function zi(t,e,n){var i;if(null!=(i=t.attrsMap[e]))for(var a=t.attrsList,o=0,r=a.length;o<r;o++)if(a[o].name===e){a.splice(o,1);break}return n&&delete t.attrsMap[e],i}function Xi(t,e){for(var n=t.attrsList,i=0,a=n.length;i<a;i++){var o=n[i];if(e.test(o.name))return n.splice(i,1),o}}function Vi(t,e){return e&&(null!=e.start&&(t.start=e.start),null!=e.end&&(t.end=e.end)),t}function qi(t,e,n){var i=n||{},a=i.number,o="$$v";i.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),a&&(o="_n("+o+")");var r=Wi(e,o);t.model={value:"("+e+")",expression:JSON.stringify(e),callback:"function ($$v) {"+r+"}"}}function Wi(t,e){var n=function(t){if(t=t.trim(),yi=t.length,t.indexOf("[")<0||t.lastIndexOf("]")<yi-1)return(ki=t.lastIndexOf("."))>-1?{exp:t.slice(0,ki),key:'"'+t.slice(ki+1)+'"'}:{exp:t,key:null};wi=t,ki=Ei=Ii=0;for(;!Gi();)Zi(Bi=Ui())?Qi(Bi):91===Bi&&Ji(Bi);return{exp:t.slice(0,Ei),key:t.slice(Ei+1,Ii)}}(t);return null===n.key?t+"="+e:"$set("+n.exp+", "+n.key+", "+e+")"}function Ui(){return wi.charCodeAt(++ki)}function Gi(){return ki>=yi}function Zi(t){return 34===t||39===t}function Ji(t){var e=1;for(Ei=ki;!Gi();)if(Zi(t=Ui()))Qi(t);else if(91===t&&e++,93===t&&e--,0===e){Ii=ki;break}}function Qi(t){for(var e=t;!Gi()&&(t=Ui())!==e;);}var Ki,ta="__r",ea="__c";function na(t,e,n){var i=Ki;return function a(){null!==e.apply(null,arguments)&&oa(t,a,n,i)}}var ia=Gt&&!(et&&Number(et[1])<=53);function aa(t,e,n,i){if(ia){var a=hn,o=e;e=o._wrapper=function(t){if(t.target===t.currentTarget||t.timeStamp>=a||t.timeStamp<=0||t.target.ownerDocument!==document)return o.apply(this,arguments)}}Ki.addEventListener(t,e,it?{capture:n,passive:i}:n)}function oa(t,e,n,i){(i||Ki).removeEventListener(t,e._wrapper||e,n)}function ra(t,e){if(!i(t.data.on)||!i(e.data.on)){var n=e.data.on||{},o=t.data.on||{};Ki=e.elm,function(t){if(a(t[ta])){var e=J?"change":"input";t[e]=[].concat(t[ta],t[e]||[]),delete t[ta]}a(t[ea])&&(t.change=[].concat(t[ea],t.change||[]),delete t[ea])}(n),le(n,o,aa,oa,na,e.context),Ki=void 0}}var sa,la={create:ra,update:ra};function da(t,e){if(!i(t.data.domProps)||!i(e.data.domProps)){var n,o,r=e.elm,s=t.data.domProps||{},l=e.data.domProps||{};for(n in a(l.__ob__)&&(l=e.data.domProps=D({},l)),s)n in l||(r[n]="");for(n in l){if(o=l[n],"textContent"===n||"innerHTML"===n){if(e.children&&(e.children.length=0),o===s[n])continue;1===r.childNodes.length&&r.removeChild(r.childNodes[0])}if("value"===n&&"PROGRESS"!==r.tagName){r._value=o;var d=i(o)?"":String(o);ca(r,d)&&(r.value=d)}else if("innerHTML"===n&&Qn(r.tagName)&&i(r.innerHTML)){(sa=sa||document.createElement("div")).innerHTML="<svg>"+o+"</svg>";for(var c=sa.firstChild;r.firstChild;)r.removeChild(r.firstChild);for(;c.firstChild;)r.appendChild(c.firstChild)}else if(o!==s[n])try{r[n]=o}catch(t){}}}}function ca(t,e){return!t.composing&&("OPTION"===t.tagName||function(t,e){var n=!0;try{n=document.activeElement!==t}catch(t){}return n&&t.value!==e}(t,e)||function(t,e){var n=t.value,i=t._vModifiers;if(a(i)){if(i.number)return f(n)!==f(e);if(i.trim)return n.trim()!==e.trim()}return n!==e}(t,e))}var ha={create:da,update:da},ua=v(function(t){var e={},n=/:(.+)/;return t.split(/;(?![^(]*\))/g).forEach(function(t){if(t){var i=t.split(n);i.length>1&&(e[i[0].trim()]=i[1].trim())}}),e});function ma(t){var e=fa(t.style);return t.staticStyle?D(t.staticStyle,e):e}function fa(t){return Array.isArray(t)?S(t):"string"==typeof t?ua(t):t}var pa,_a=/^--/,Aa=/\s*!important$/,ba=function(t,e,n){if(_a.test(e))t.style.setProperty(e,n);else if(Aa.test(n))t.style.setProperty(k(e),n.replace(Aa,""),"important");else{var i=ga(e);if(Array.isArray(n))for(var a=0,o=n.length;a<o;a++)t.style[i]=n[a];else t.style[i]=n}},xa=["Webkit","Moz","ms"],ga=v(function(t){if(pa=pa||document.createElement("div").style,"filter"!==(t=y(t))&&t in pa)return t;for(var e=t.charAt(0).toUpperCase()+t.slice(1),n=0;n<xa.length;n++){var i=xa[n]+e;if(i in pa)return i}});function va(t,e){var n=e.data,o=t.data;if(!(i(n.staticStyle)&&i(n.style)&&i(o.staticStyle)&&i(o.style))){var r,s,l=e.elm,d=o.staticStyle,c=o.normalizedStyle||o.style||{},h=d||c,u=fa(e.data.style)||{};e.data.normalizedStyle=a(u.__ob__)?D({},u):u;var m=function(t,e){var n,i={};if(e)for(var a=t;a.componentInstance;)(a=a.componentInstance._vnode)&&a.data&&(n=ma(a.data))&&D(i,n);(n=ma(t.data))&&D(i,n);for(var o=t;o=o.parent;)o.data&&(n=ma(o.data))&&D(i,n);return i}(e,!0);for(s in h)i(m[s])&&ba(l,s,"");for(s in m)(r=m[s])!==h[s]&&ba(l,s,null==r?"":r)}}var Ca={create:va,update:va},ya=/\s+/;function wa(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(ya).forEach(function(e){return t.classList.add(e)}):t.classList.add(e);else{var n=" "+(t.getAttribute("class")||"")+" ";n.indexOf(" "+e+" ")<0&&t.setAttribute("class",(n+e).trim())}}function Ba(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(ya).forEach(function(e){return t.classList.remove(e)}):t.classList.remove(e),t.classList.length||t.removeAttribute("class");else{for(var n=" "+(t.getAttribute("class")||"")+" ",i=" "+e+" ";n.indexOf(i)>=0;)n=n.replace(i," ");(n=n.trim())?t.setAttribute("class",n):t.removeAttribute("class")}}function ka(t){if(t){if("object"==typeof t){var e={};return!1!==t.css&&D(e,Ea(t.name||"v")),D(e,t),e}return"string"==typeof t?Ea(t):void 0}}var Ea=v(function(t){return{enterClass:t+"-enter",enterToClass:t+"-enter-to",enterActiveClass:t+"-enter-active",leaveClass:t+"-leave",leaveToClass:t+"-leave-to",leaveActiveClass:t+"-leave-active"}}),Ia=W&&!Q,Da="transition",Sa="animation",Na="transition",Ma="transitionend",Oa="animation",Ta="animationend";Ia&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(Na="WebkitTransition",Ma="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Oa="WebkitAnimation",Ta="webkitAnimationEnd"));var La=W?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(t){return t()};function ja(t){La(function(){La(t)})}function Pa(t,e){var n=t._transitionClasses||(t._transitionClasses=[]);n.indexOf(e)<0&&(n.push(e),wa(t,e))}function Fa(t,e){t._transitionClasses&&b(t._transitionClasses,e),Ba(t,e)}function Ya(t,e,n){var i=Ha(t,e),a=i.type,o=i.timeout,r=i.propCount;if(!a)return n();var s=a===Da?Ma:Ta,l=0,d=function(){t.removeEventListener(s,c),n()},c=function(e){e.target===t&&++l>=r&&d()};setTimeout(function(){l<r&&d()},o+1),t.addEventListener(s,c)}var Ra=/\b(transform|all)(,|$)/;function Ha(t,e){var n,i=window.getComputedStyle(t),a=(i[Na+"Delay"]||"").split(", "),o=(i[Na+"Duration"]||"").split(", "),r=$a(a,o),s=(i[Oa+"Delay"]||"").split(", "),l=(i[Oa+"Duration"]||"").split(", "),d=$a(s,l),c=0,h=0;return e===Da?r>0&&(n=Da,c=r,h=o.length):e===Sa?d>0&&(n=Sa,c=d,h=l.length):h=(n=(c=Math.max(r,d))>0?r>d?Da:Sa:null)?n===Da?o.length:l.length:0,{type:n,timeout:c,propCount:h,hasTransform:n===Da&&Ra.test(i[Na+"Property"])}}function $a(t,e){for(;t.length<e.length;)t=t.concat(t);return Math.max.apply(null,e.map(function(e,n){return za(e)+za(t[n])}))}function za(t){return 1e3*Number(t.slice(0,-1).replace(",","."))}function Xa(t,e){var n=t.elm;a(n._leaveCb)&&(n._leaveCb.cancelled=!0,n._leaveCb());var o=ka(t.data.transition);if(!i(o)&&!a(n._enterCb)&&1===n.nodeType){for(var r=o.css,l=o.type,d=o.enterClass,c=o.enterToClass,h=o.enterActiveClass,u=o.appearClass,m=o.appearToClass,p=o.appearActiveClass,_=o.beforeEnter,A=o.enter,b=o.afterEnter,x=o.enterCancelled,g=o.beforeAppear,v=o.appear,C=o.afterAppear,y=o.appearCancelled,w=o.duration,B=Ke,k=Ke.$vnode;k&&k.parent;)B=k.context,k=k.parent;var E=!B._isMounted||!t.isRootInsert;if(!E||v||""===v){var I=E&&u?u:d,D=E&&p?p:h,S=E&&m?m:c,N=E&&g||_,M=E&&"function"==typeof v?v:A,O=E&&C||b,T=E&&y||x,L=f(s(w)?w.enter:w);0;var P=!1!==r&&!Q,F=Wa(M),Y=n._enterCb=j(function(){P&&(Fa(n,S),Fa(n,D)),Y.cancelled?(P&&Fa(n,I),T&&T(n)):O&&O(n),n._enterCb=null});t.data.show||de(t,"insert",function(){var e=n.parentNode,i=e&&e._pending&&e._pending[t.key];i&&i.tag===t.tag&&i.elm._leaveCb&&i.elm._leaveCb(),M&&M(n,Y)}),N&&N(n),P&&(Pa(n,I),Pa(n,D),ja(function(){Fa(n,I),Y.cancelled||(Pa(n,S),F||(qa(L)?setTimeout(Y,L):Ya(n,l,Y)))})),t.data.show&&(e&&e(),M&&M(n,Y)),P||F||Y()}}}function Va(t,e){var n=t.elm;a(n._enterCb)&&(n._enterCb.cancelled=!0,n._enterCb());var o=ka(t.data.transition);if(i(o)||1!==n.nodeType)return e();if(!a(n._leaveCb)){var r=o.css,l=o.type,d=o.leaveClass,c=o.leaveToClass,h=o.leaveActiveClass,u=o.beforeLeave,m=o.leave,p=o.afterLeave,_=o.leaveCancelled,A=o.delayLeave,b=o.duration,x=!1!==r&&!Q,g=Wa(m),v=f(s(b)?b.leave:b);0;var C=n._leaveCb=j(function(){n.parentNode&&n.parentNode._pending&&(n.parentNode._pending[t.key]=null),x&&(Fa(n,c),Fa(n,h)),C.cancelled?(x&&Fa(n,d),_&&_(n)):(e(),p&&p(n)),n._leaveCb=null});A?A(y):y()}function y(){C.cancelled||(!t.data.show&&n.parentNode&&((n.parentNode._pending||(n.parentNode._pending={}))[t.key]=t),u&&u(n),x&&(Pa(n,d),Pa(n,h),ja(function(){Fa(n,d),C.cancelled||(Pa(n,c),g||(qa(v)?setTimeout(C,v):Ya(n,l,C)))})),m&&m(n,C),x||g||C())}}function qa(t){return"number"==typeof t&&!isNaN(t)}function Wa(t){if(i(t))return!1;var e=t.fns;return a(e)?Wa(Array.isArray(e)?e[0]:e):(t._length||t.length)>1}function Ua(t,e){!0!==e.data.show&&Xa(e)}var Ga=function(t){var e,n,s={},l=t.modules,d=t.nodeOps;for(e=0;e<li.length;++e)for(s[li[e]]=[],n=0;n<l.length;++n)a(l[n][li[e]])&&s[li[e]].push(l[n][li[e]]);function c(t){var e=d.parentNode(t);a(e)&&d.removeChild(e,t)}function h(t,e,n,i,r,l,c){if(a(t.elm)&&a(l)&&(t=l[c]=gt(t)),t.isRootInsert=!r,!function(t,e,n,i){var r=t.data;if(a(r)){var l=a(t.componentInstance)&&r.keepAlive;if(a(r=r.hook)&&a(r=r.init)&&r(t,!1),a(t.componentInstance))return u(t,e),m(n,t.elm,i),o(l)&&function(t,e,n,i){for(var o,r=t;r.componentInstance;)if(r=r.componentInstance._vnode,a(o=r.data)&&a(o=o.transition)){for(o=0;o<s.activate.length;++o)s.activate[o](si,r);e.push(r);break}m(n,t.elm,i)}(t,e,n,i),!0}}(t,e,n,i)){var h=t.data,p=t.children,_=t.tag;a(_)?(t.elm=t.ns?d.createElementNS(t.ns,_):d.createElement(_,t),b(t),f(t,p,e),a(h)&&A(t,e),m(n,t.elm,i)):o(t.isComment)?(t.elm=d.createComment(t.text),m(n,t.elm,i)):(t.elm=d.createTextNode(t.text),m(n,t.elm,i))}}function u(t,e){a(t.data.pendingInsert)&&(e.push.apply(e,t.data.pendingInsert),t.data.pendingInsert=null),t.elm=t.componentInstance.$el,_(t)?(A(t,e),b(t)):(ri(t),e.push(t))}function m(t,e,n){a(t)&&(a(n)?d.parentNode(n)===t&&d.insertBefore(t,e,n):d.appendChild(t,e))}function f(t,e,n){if(Array.isArray(e))for(var i=0;i<e.length;++i)h(e[i],n,t.elm,null,!0,e,i);else r(t.text)&&d.appendChild(t.elm,d.createTextNode(String(t.text)))}function _(t){for(;t.componentInstance;)t=t.componentInstance._vnode;return a(t.tag)}function A(t,n){for(var i=0;i<s.create.length;++i)s.create[i](si,t);a(e=t.data.hook)&&(a(e.create)&&e.create(si,t),a(e.insert)&&n.push(t))}function b(t){var e;if(a(e=t.fnScopeId))d.setStyleScope(t.elm,e);else for(var n=t;n;)a(e=n.context)&&a(e=e.$options._scopeId)&&d.setStyleScope(t.elm,e),n=n.parent;a(e=Ke)&&e!==t.context&&e!==t.fnContext&&a(e=e.$options._scopeId)&&d.setStyleScope(t.elm,e)}function x(t,e,n,i,a,o){for(;i<=a;++i)h(n[i],o,t,e,!1,n,i)}function g(t){var e,n,i=t.data;if(a(i))for(a(e=i.hook)&&a(e=e.destroy)&&e(t),e=0;e<s.destroy.length;++e)s.destroy[e](t);if(a(e=t.children))for(n=0;n<t.children.length;++n)g(t.children[n])}function v(t,e,n){for(;e<=n;++e){var i=t[e];a(i)&&(a(i.tag)?(C(i),g(i)):c(i.elm))}}function C(t,e){if(a(e)||a(t.data)){var n,i=s.remove.length+1;for(a(e)?e.listeners+=i:e=function(t,e){function n(){0==--n.listeners&&c(t)}return n.listeners=e,n}(t.elm,i),a(n=t.componentInstance)&&a(n=n._vnode)&&a(n.data)&&C(n,e),n=0;n<s.remove.length;++n)s.remove[n](t,e);a(n=t.data.hook)&&a(n=n.remove)?n(t,e):e()}else c(t.elm)}function y(t,e,n,i){for(var o=n;o<i;o++){var r=e[o];if(a(r)&&di(t,r))return o}}function w(t,e,n,r,l,c){if(t!==e){a(e.elm)&&a(r)&&(e=r[l]=gt(e));var u=e.elm=t.elm;if(o(t.isAsyncPlaceholder))a(e.asyncFactory.resolved)?E(t.elm,e,n):e.isAsyncPlaceholder=!0;else if(o(e.isStatic)&&o(t.isStatic)&&e.key===t.key&&(o(e.isCloned)||o(e.isOnce)))e.componentInstance=t.componentInstance;else{var m,f=e.data;a(f)&&a(m=f.hook)&&a(m=m.prepatch)&&m(t,e);var p=t.children,A=e.children;if(a(f)&&_(e)){for(m=0;m<s.update.length;++m)s.update[m](t,e);a(m=f.hook)&&a(m=m.update)&&m(t,e)}i(e.text)?a(p)&&a(A)?p!==A&&function(t,e,n,o,r){for(var s,l,c,u=0,m=0,f=e.length-1,p=e[0],_=e[f],A=n.length-1,b=n[0],g=n[A],C=!r;u<=f&&m<=A;)i(p)?p=e[++u]:i(_)?_=e[--f]:di(p,b)?(w(p,b,o,n,m),p=e[++u],b=n[++m]):di(_,g)?(w(_,g,o,n,A),_=e[--f],g=n[--A]):di(p,g)?(w(p,g,o,n,A),C&&d.insertBefore(t,p.elm,d.nextSibling(_.elm)),p=e[++u],g=n[--A]):di(_,b)?(w(_,b,o,n,m),C&&d.insertBefore(t,_.elm,p.elm),_=e[--f],b=n[++m]):(i(s)&&(s=ci(e,u,f)),i(l=a(b.key)?s[b.key]:y(b,e,u,f))?h(b,o,t,p.elm,!1,n,m):di(c=e[l],b)?(w(c,b,o,n,m),e[l]=void 0,C&&d.insertBefore(t,c.elm,p.elm)):h(b,o,t,p.elm,!1,n,m),b=n[++m]);u>f?x(t,i(n[A+1])?null:n[A+1].elm,n,m,A,o):m>A&&v(e,u,f)}(u,p,A,n,c):a(A)?(a(t.text)&&d.setTextContent(u,""),x(u,null,A,0,A.length-1,n)):a(p)?v(p,0,p.length-1):a(t.text)&&d.setTextContent(u,""):t.text!==e.text&&d.setTextContent(u,e.text),a(f)&&a(m=f.hook)&&a(m=m.postpatch)&&m(t,e)}}}function B(t,e,n){if(o(n)&&a(t.parent))t.parent.data.pendingInsert=e;else for(var i=0;i<e.length;++i)e[i].data.hook.insert(e[i])}var k=p("attrs,class,staticClass,staticStyle,key");function E(t,e,n,i){var r,s=e.tag,l=e.data,d=e.children;if(i=i||l&&l.pre,e.elm=t,o(e.isComment)&&a(e.asyncFactory))return e.isAsyncPlaceholder=!0,!0;if(a(l)&&(a(r=l.hook)&&a(r=r.init)&&r(e,!0),a(r=e.componentInstance)))return u(e,n),!0;if(a(s)){if(a(d))if(t.hasChildNodes())if(a(r=l)&&a(r=r.domProps)&&a(r=r.innerHTML)){if(r!==t.innerHTML)return!1}else{for(var c=!0,h=t.firstChild,m=0;m<d.length;m++){if(!h||!E(h,d[m],n,i)){c=!1;break}h=h.nextSibling}if(!c||h)return!1}else f(e,d,n);if(a(l)){var p=!1;for(var _ in l)if(!k(_)){p=!0,A(e,n);break}!p&&l.class&&oe(l.class)}}else t.data!==e.text&&(t.data=e.text);return!0}return function(t,e,n,r){if(!i(e)){var l,c=!1,u=[];if(i(t))c=!0,h(e,u);else{var m=a(t.nodeType);if(!m&&di(t,e))w(t,e,u,null,null,r);else{if(m){if(1===t.nodeType&&t.hasAttribute(P)&&(t.removeAttribute(P),n=!0),o(n)&&E(t,e,u))return B(e,u,!0),t;l=t,t=new _t(d.tagName(l).toLowerCase(),{},[],void 0,l)}var f=t.elm,p=d.parentNode(f);if(h(e,u,f._leaveCb?null:p,d.nextSibling(f)),a(e.parent))for(var A=e.parent,b=_(e);A;){for(var x=0;x<s.destroy.length;++x)s.destroy[x](A);if(A.elm=e.elm,b){for(var C=0;C<s.create.length;++C)s.create[C](si,A);var y=A.data.hook.insert;if(y.merged)for(var k=1;k<y.fns.length;k++)y.fns[k]()}else ri(A);A=A.parent}a(p)?v([t],0,0):a(t.tag)&&g(t)}}return B(e,u,c),e.elm}a(t)&&g(t)}}({nodeOps:ai,modules:[vi,Di,la,ha,Ca,W?{create:Ua,activate:Ua,remove:function(t,e){!0!==t.data.show?Va(t,e):e()}}:{}].concat(Ai)});Q&&document.addEventListener("selectionchange",function(){var t=document.activeElement;t&&t.vmodel&&io(t,"input")});var Za={inserted:function(t,e,n,i){"select"===n.tag?(i.elm&&!i.elm._vOptions?de(n,"postpatch",function(){Za.componentUpdated(t,e,n)}):Ja(t,e,n.context),t._vOptions=[].map.call(t.options,to)):("textarea"===n.tag||ni(t.type))&&(t._vModifiers=e.modifiers,e.modifiers.lazy||(t.addEventListener("compositionstart",eo),t.addEventListener("compositionend",no),t.addEventListener("change",no),Q&&(t.vmodel=!0)))},componentUpdated:function(t,e,n){if("select"===n.tag){Ja(t,e,n.context);var i=t._vOptions,a=t._vOptions=[].map.call(t.options,to);if(a.some(function(t,e){return!T(t,i[e])}))(t.multiple?e.value.some(function(t){return Ka(t,a)}):e.value!==e.oldValue&&Ka(e.value,a))&&io(t,"change")}}};function Ja(t,e,n){Qa(t,e,n),(J||K)&&setTimeout(function(){Qa(t,e,n)},0)}function Qa(t,e,n){var i=e.value,a=t.multiple;if(!a||Array.isArray(i)){for(var o,r,s=0,l=t.options.length;s<l;s++)if(r=t.options[s],a)o=L(i,to(r))>-1,r.selected!==o&&(r.selected=o);else if(T(to(r),i))return void(t.selectedIndex!==s&&(t.selectedIndex=s));a||(t.selectedIndex=-1)}}function Ka(t,e){return e.every(function(e){return!T(e,t)})}function to(t){return"_value"in t?t._value:t.value}function eo(t){t.target.composing=!0}function no(t){t.target.composing&&(t.target.composing=!1,io(t.target,"input"))}function io(t,e){var n=document.createEvent("HTMLEvents");n.initEvent(e,!0,!0),t.dispatchEvent(n)}function ao(t){return!t.componentInstance||t.data&&t.data.transition?t:ao(t.componentInstance._vnode)}var oo={model:Za,show:{bind:function(t,e,n){var i=e.value,a=(n=ao(n)).data&&n.data.transition,o=t.__vOriginalDisplay="none"===t.style.display?"":t.style.display;i&&a?(n.data.show=!0,Xa(n,function(){t.style.display=o})):t.style.display=i?o:"none"},update:function(t,e,n){var i=e.value;!i!=!e.oldValue&&((n=ao(n)).data&&n.data.transition?(n.data.show=!0,i?Xa(n,function(){t.style.display=t.__vOriginalDisplay}):Va(n,function(){t.style.display="none"})):t.style.display=i?t.__vOriginalDisplay:"none")},unbind:function(t,e,n,i,a){a||(t.style.display=t.__vOriginalDisplay)}}},ro={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function so(t){var e=t&&t.componentOptions;return e&&e.Ctor.options.abstract?so(Ue(e.children)):t}function lo(t){var e={},n=t.$options;for(var i in n.propsData)e[i]=t[i];var a=n._parentListeners;for(var o in a)e[y(o)]=a[o];return e}function co(t,e){if(/\d-keep-alive$/.test(e.tag))return t("keep-alive",{props:e.componentOptions.propsData})}var ho=function(t){return t.tag||_e(t)},uo=function(t){return"show"===t.name},mo={name:"transition",props:ro,abstract:!0,render:function(t){var e=this,n=this.$slots.default;if(n&&(n=n.filter(ho)).length){0;var i=this.mode;0;var a=n[0];if(function(t){for(;t=t.parent;)if(t.data.transition)return!0}(this.$vnode))return a;var o=so(a);if(!o)return a;if(this._leaving)return co(t,a);var s="__transition-"+this._uid+"-";o.key=null==o.key?o.isComment?s+"comment":s+o.tag:r(o.key)?0===String(o.key).indexOf(s)?o.key:s+o.key:o.key;var l=(o.data||(o.data={})).transition=lo(this),d=this._vnode,c=so(d);if(o.data.directives&&o.data.directives.some(uo)&&(o.data.show=!0),c&&c.data&&!function(t,e){return e.key===t.key&&e.tag===t.tag}(o,c)&&!_e(c)&&(!c.componentInstance||!c.componentInstance._vnode.isComment)){var h=c.data.transition=D({},l);if("out-in"===i)return this._leaving=!0,de(h,"afterLeave",function(){e._leaving=!1,e.$forceUpdate()}),co(t,a);if("in-out"===i){if(_e(o))return d;var u,m=function(){u()};de(l,"afterEnter",m),de(l,"enterCancelled",m),de(h,"delayLeave",function(t){u=t})}}return a}}},fo=D({tag:String,moveClass:String},ro);function po(t){t.elm._moveCb&&t.elm._moveCb(),t.elm._enterCb&&t.elm._enterCb()}function _o(t){t.data.newPos=t.elm.getBoundingClientRect()}function Ao(t){var e=t.data.pos,n=t.data.newPos,i=e.left-n.left,a=e.top-n.top;if(i||a){t.data.moved=!0;var o=t.elm.style;o.transform=o.WebkitTransform="translate("+i+"px,"+a+"px)",o.transitionDuration="0s"}}delete fo.mode;var bo={Transition:mo,TransitionGroup:{props:fo,beforeMount:function(){var t=this,e=this._update;this._update=function(n,i){var a=tn(t);t.__patch__(t._vnode,t.kept,!1,!0),t._vnode=t.kept,a(),e.call(t,n,i)}},render:function(t){for(var e=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),i=this.prevChildren=this.children,a=this.$slots.default||[],o=this.children=[],r=lo(this),s=0;s<a.length;s++){var l=a[s];if(l.tag)if(null!=l.key&&0!==String(l.key).indexOf("__vlist"))o.push(l),n[l.key]=l,(l.data||(l.data={})).transition=r;else;}if(i){for(var d=[],c=[],h=0;h<i.length;h++){var u=i[h];u.data.transition=r,u.data.pos=u.elm.getBoundingClientRect(),n[u.key]?d.push(u):c.push(u)}this.kept=t(e,null,d),this.removed=c}return t(e,null,o)},updated:function(){var t=this.prevChildren,e=this.moveClass||(this.name||"v")+"-move";t.length&&this.hasMove(t[0].elm,e)&&(t.forEach(po),t.forEach(_o),t.forEach(Ao),this._reflow=document.body.offsetHeight,t.forEach(function(t){if(t.data.moved){var n=t.elm,i=n.style;Pa(n,e),i.transform=i.WebkitTransform=i.transitionDuration="",n.addEventListener(Ma,n._moveCb=function t(i){i&&i.target!==n||i&&!/transform$/.test(i.propertyName)||(n.removeEventListener(Ma,t),n._moveCb=null,Fa(n,e))})}}))},methods:{hasMove:function(t,e){if(!Ia)return!1;if(this._hasMove)return this._hasMove;var n=t.cloneNode();t._transitionClasses&&t._transitionClasses.forEach(function(t){Ba(n,t)}),wa(n,e),n.style.display="none",this.$el.appendChild(n);var i=Ha(n);return this.$el.removeChild(n),this._hasMove=i.hasTransform}}}};En.config.mustUseProp=Pn,En.config.isReservedTag=Kn,En.config.isReservedAttr=Ln,En.config.getTagNamespace=ti,En.config.isUnknownElement=function(t){if(!W)return!0;if(Kn(t))return!1;if(t=t.toLowerCase(),null!=ei[t])return ei[t];var e=document.createElement(t);return t.indexOf("-")>-1?ei[t]=e.constructor===window.HTMLUnknownElement||e.constructor===window.HTMLElement:ei[t]=/HTMLUnknownElement/.test(e.toString())},D(En.options.directives,oo),D(En.options.components,bo),En.prototype.__patch__=W?Ga:N,En.prototype.$mount=function(t,e){return function(t,e,n){return t.$el=e,t.$options.render||(t.$options.render=bt),an(t,"beforeMount"),new _n(t,function(){t._update(t._render(),n)},N,{before:function(){t._isMounted&&!t._isDestroyed&&an(t,"beforeUpdate")}},!0),n=!1,null==t.$vnode&&(t._isMounted=!0,an(t,"mounted")),t}(this,t=t&&W?ii(t):void 0,e)},W&&setTimeout(function(){R.devtools&&rt&&rt.emit("init",En)},0);var xo=/\{\{((?:.|\r?\n)+?)\}\}/g,go=/[-.*+?^${}()|[\]\/\\]/g,vo=v(function(t){var e=t[0].replace(go,"\\$&"),n=t[1].replace(go,"\\$&");return new RegExp(e+"((?:.|\\n)+?)"+n,"g")});function Co(t,e){var n=e?vo(e):xo;if(n.test(t)){for(var i,a,o,r=[],s=[],l=n.lastIndex=0;i=n.exec(t);){(a=i.index)>l&&(s.push(o=t.slice(l,a)),r.push(JSON.stringify(o)));var d=Ni(i[1].trim());r.push("_s("+d+")"),s.push({"@binding":d}),l=a+i[0].length}return l<t.length&&(s.push(o=t.slice(l)),r.push(JSON.stringify(o))),{expression:r.join("+"),tokens:s}}}var yo={staticKeys:["staticClass"],transformNode:function(t,e){e.warn;var n=zi(t,"class");n&&(t.staticClass=JSON.stringify(n));var i=$i(t,"class",!1);i&&(t.classBinding=i)},genData:function(t){var e="";return t.staticClass&&(e+="staticClass:"+t.staticClass+","),t.classBinding&&(e+="class:"+t.classBinding+","),e}};var wo,Bo={staticKeys:["staticStyle"],transformNode:function(t,e){e.warn;var n=zi(t,"style");n&&(t.staticStyle=JSON.stringify(ua(n)));var i=$i(t,"style",!1);i&&(t.styleBinding=i)},genData:function(t){var e="";return t.staticStyle&&(e+="staticStyle:"+t.staticStyle+","),t.styleBinding&&(e+="style:("+t.styleBinding+"),"),e}},ko=function(t){return(wo=wo||document.createElement("div")).innerHTML=t,wo.textContent},Eo=p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),Io=p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),Do=p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),So=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,No=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+?\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,Mo="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+H.source+"]*",Oo="((?:"+Mo+"\\:)?"+Mo+")",To=new RegExp("^<"+Oo),Lo=/^\s*(\/?)>/,jo=new RegExp("^<\\/"+Oo+"[^>]*>"),Po=/^<!DOCTYPE [^>]+>/i,Fo=/^<!\--/,Yo=/^<!\[/,Ro=p("script,style,textarea",!0),Ho={},$o={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},zo=/&(?:lt|gt|quot|amp|#39);/g,Xo=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,Vo=p("pre,textarea",!0),qo=function(t,e){return t&&Vo(t)&&"\n"===e[0]};function Wo(t,e){var n=e?Xo:zo;return t.replace(n,function(t){return $o[t]})}var Uo,Go,Zo,Jo,Qo,Ko,tr,er,nr=/^@|^v-on:/,ir=/^v-|^@|^:|^#/,ar=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,or=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,rr=/^\(|\)$/g,sr=/^\[.*\]$/,lr=/:(.*)$/,dr=/^:|^\.|^v-bind:/,cr=/\.[^.\]]+(?=[^\]]*$)/g,hr=/^v-slot(:|$)|^#/,ur=/[\r\n]/,mr=/[ \f\t\r\n]+/g,fr=v(ko),pr="_empty_";function _r(t,e,n){return{type:1,tag:t,attrsList:e,attrsMap:function(t){for(var e={},n=0,i=t.length;n<i;n++)e[t[n].name]=t[n].value;return e}(e),rawAttrsMap:{},parent:n,children:[]}}function Ar(t,e){Uo=e.warn||Oi,Ko=e.isPreTag||M,tr=e.mustUseProp||M,er=e.getTagNamespace||M;var n=e.isReservedTag||M;(function(t){return!(!(t.component||t.attrsMap[":is"]||t.attrsMap["v-bind:is"])&&(t.attrsMap.is?n(t.attrsMap.is):n(t.tag)))}),Zo=Ti(e.modules,"transformNode"),Jo=Ti(e.modules,"preTransformNode"),Qo=Ti(e.modules,"postTransformNode"),Go=e.delimiters;var i,a,o=[],r=!1!==e.preserveWhitespace,s=e.whitespace,l=!1,d=!1;function c(t){if(h(t),l||t.processed||(t=br(t,e)),o.length||t===i||i.if&&(t.elseif||t.else)&&gr(i,{exp:t.elseif,block:t}),a&&!t.forbidden)if(t.elseif||t.else)r=t,(s=function(t){var e=t.length;for(;e--;){if(1===t[e].type)return t[e];t.pop()}}(a.children))&&s.if&&gr(s,{exp:r.elseif,block:r});else{if(t.slotScope){var n=t.slotTarget||'"default"';(a.scopedSlots||(a.scopedSlots={}))[n]=t}a.children.push(t),t.parent=a}var r,s;t.children=t.children.filter(function(t){return!t.slotScope}),h(t),t.pre&&(l=!1),Ko(t.tag)&&(d=!1);for(var c=0;c<Qo.length;c++)Qo[c](t,e)}function h(t){if(!d)for(var e;(e=t.children[t.children.length-1])&&3===e.type&&" "===e.text;)t.children.pop()}return function(t,e){for(var n,i,a=[],o=e.expectHTML,r=e.isUnaryTag||M,s=e.canBeLeftOpenTag||M,l=0;t;){if(n=t,i&&Ro(i)){var d=0,c=i.toLowerCase(),h=Ho[c]||(Ho[c]=new RegExp("([\\s\\S]*?)(</"+c+"[^>]*>)","i")),u=t.replace(h,function(t,n,i){return d=i.length,Ro(c)||"noscript"===c||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),qo(c,n)&&(n=n.slice(1)),e.chars&&e.chars(n),""});l+=t.length-u.length,t=u,k(c,l-d,l)}else{var m=t.indexOf("<");if(0===m){if(Fo.test(t)){var f=t.indexOf("--\x3e");if(f>=0){e.shouldKeepComment&&e.comment(t.substring(4,f),l,l+f+3),y(f+3);continue}}if(Yo.test(t)){var p=t.indexOf("]>");if(p>=0){y(p+2);continue}}var _=t.match(Po);if(_){y(_[0].length);continue}var A=t.match(jo);if(A){var b=l;y(A[0].length),k(A[1],b,l);continue}var x=w();if(x){B(x),qo(x.tagName,t)&&y(1);continue}}var g=void 0,v=void 0,C=void 0;if(m>=0){for(v=t.slice(m);!(jo.test(v)||To.test(v)||Fo.test(v)||Yo.test(v)||(C=v.indexOf("<",1))<0);)m+=C,v=t.slice(m);g=t.substring(0,m)}m<0&&(g=t),g&&y(g.length),e.chars&&g&&e.chars(g,l-g.length,l)}if(t===n){e.chars&&e.chars(t);break}}function y(e){l+=e,t=t.substring(e)}function w(){var e=t.match(To);if(e){var n,i,a={tagName:e[1],attrs:[],start:l};for(y(e[0].length);!(n=t.match(Lo))&&(i=t.match(No)||t.match(So));)i.start=l,y(i[0].length),i.end=l,a.attrs.push(i);if(n)return a.unarySlash=n[1],y(n[0].length),a.end=l,a}}function B(t){var n=t.tagName,l=t.unarySlash;o&&("p"===i&&Do(n)&&k(i),s(n)&&i===n&&k(n));for(var d=r(n)||!!l,c=t.attrs.length,h=new Array(c),u=0;u<c;u++){var m=t.attrs[u],f=m[3]||m[4]||m[5]||"",p="a"===n&&"href"===m[1]?e.shouldDecodeNewlinesForHref:e.shouldDecodeNewlines;h[u]={name:m[1],value:Wo(f,p)}}d||(a.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:h,start:t.start,end:t.end}),i=n),e.start&&e.start(n,h,d,t.start,t.end)}function k(t,n,o){var r,s;if(null==n&&(n=l),null==o&&(o=l),t)for(s=t.toLowerCase(),r=a.length-1;r>=0&&a[r].lowerCasedTag!==s;r--);else r=0;if(r>=0){for(var d=a.length-1;d>=r;d--)e.end&&e.end(a[d].tag,n,o);a.length=r,i=r&&a[r-1].tag}else"br"===s?e.start&&e.start(t,[],!0,n,o):"p"===s&&(e.start&&e.start(t,[],!1,n,o),e.end&&e.end(t,n,o))}k()}(t,{warn:Uo,expectHTML:e.expectHTML,isUnaryTag:e.isUnaryTag,canBeLeftOpenTag:e.canBeLeftOpenTag,shouldDecodeNewlines:e.shouldDecodeNewlines,shouldDecodeNewlinesForHref:e.shouldDecodeNewlinesForHref,shouldKeepComment:e.comments,outputSourceRange:e.outputSourceRange,start:function(t,n,r,s,h){var u=a&&a.ns||er(t);J&&"svg"===u&&(n=function(t){for(var e=[],n=0;n<t.length;n++){var i=t[n];yr.test(i.name)||(i.name=i.name.replace(wr,""),e.push(i))}return e}(n));var m,f=_r(t,n,a);u&&(f.ns=u),"style"!==(m=f).tag&&("script"!==m.tag||m.attrsMap.type&&"text/javascript"!==m.attrsMap.type)||ot()||(f.forbidden=!0);for(var p=0;p<Jo.length;p++)f=Jo[p](f,e)||f;l||(!function(t){null!=zi(t,"v-pre")&&(t.pre=!0)}(f),f.pre&&(l=!0)),Ko(f.tag)&&(d=!0),l?function(t){var e=t.attrsList,n=e.length;if(n)for(var i=t.attrs=new Array(n),a=0;a<n;a++)i[a]={name:e[a].name,value:JSON.stringify(e[a].value)},null!=e[a].start&&(i[a].start=e[a].start,i[a].end=e[a].end);else t.pre||(t.plain=!0)}(f):f.processed||(xr(f),function(t){var e=zi(t,"v-if");if(e)t.if=e,gr(t,{exp:e,block:t});else{null!=zi(t,"v-else")&&(t.else=!0);var n=zi(t,"v-else-if");n&&(t.elseif=n)}}(f),function(t){null!=zi(t,"v-once")&&(t.once=!0)}(f)),i||(i=f),r?c(f):(a=f,o.push(f))},end:function(t,e,n){var i=o[o.length-1];o.length-=1,a=o[o.length-1],c(i)},chars:function(t,e,n){if(a&&(!J||"textarea"!==a.tag||a.attrsMap.placeholder!==t)){var i,o,c,h=a.children;if(t=d||t.trim()?"script"===(i=a).tag||"style"===i.tag?t:fr(t):h.length?s?"condense"===s&&ur.test(t)?"":" ":r?" ":"":"")d||"condense"!==s||(t=t.replace(mr," ")),!l&&" "!==t&&(o=Co(t,Go))?c={type:2,expression:o.expression,tokens:o.tokens,text:t}:" "===t&&h.length&&" "===h[h.length-1].text||(c={type:3,text:t}),c&&h.push(c)}},comment:function(t,e,n){if(a){var i={type:3,text:t,isComment:!0};0,a.children.push(i)}}}),i}function br(t,e){var n,i;!function(t){var e=$i(t,"key");if(e){t.key=e}}(t),t.plain=!t.key&&!t.scopedSlots&&!t.attrsList.length,(i=$i(n=t,"ref"))&&(n.ref=i,n.refInFor=function(t){for(var e=t;e;){if(void 0!==e.for)return!0;e=e.parent}return!1}(n)),function(t){var e;"template"===t.tag?(e=zi(t,"scope"),t.slotScope=e||zi(t,"slot-scope")):(e=zi(t,"slot-scope"))&&(t.slotScope=e);var n=$i(t,"slot");n&&(t.slotTarget='""'===n?'"default"':n,t.slotTargetDynamic=!(!t.attrsMap[":slot"]&&!t.attrsMap["v-bind:slot"]),"template"===t.tag||t.slotScope||ji(t,"slot",n,Hi(t,"slot")));if("template"===t.tag){var i=Xi(t,hr);if(i){0;var a=vr(i),o=a.name,r=a.dynamic;t.slotTarget=o,t.slotTargetDynamic=r,t.slotScope=i.value||pr}}else{var s=Xi(t,hr);if(s){0;var l=t.scopedSlots||(t.scopedSlots={}),d=vr(s),c=d.name,h=d.dynamic,u=l[c]=_r("template",[],t);u.slotTarget=c,u.slotTargetDynamic=h,u.children=t.children.filter(function(t){if(!t.slotScope)return t.parent=u,!0}),u.slotScope=s.value||pr,t.children=[],t.plain=!1}}}(t),function(t){"slot"===t.tag&&(t.slotName=$i(t,"name"))}(t),function(t){var e;(e=$i(t,"is"))&&(t.component=e);null!=zi(t,"inline-template")&&(t.inlineTemplate=!0)}(t);for(var a=0;a<Zo.length;a++)t=Zo[a](t,e)||t;return function(t){var e,n,i,a,o,r,s,l,d=t.attrsList;for(e=0,n=d.length;e<n;e++){if(i=a=d[e].name,o=d[e].value,ir.test(i))if(t.hasBindings=!0,(r=Cr(i.replace(ir,"")))&&(i=i.replace(cr,"")),dr.test(i))i=i.replace(dr,""),o=Ni(o),(l=sr.test(i))&&(i=i.slice(1,-1)),r&&(r.prop&&!l&&"innerHtml"===(i=y(i))&&(i="innerHTML"),r.camel&&!l&&(i=y(i)),r.sync&&(s=Wi(o,"$event"),l?Ri(t,'"update:"+('+i+")",s,null,!1,0,d[e],!0):(Ri(t,"update:"+y(i),s,null,!1,0,d[e]),k(i)!==y(i)&&Ri(t,"update:"+k(i),s,null,!1,0,d[e])))),r&&r.prop||!t.component&&tr(t.tag,t.attrsMap.type,i)?Li(t,i,o,d[e],l):ji(t,i,o,d[e],l);else if(nr.test(i))i=i.replace(nr,""),(l=sr.test(i))&&(i=i.slice(1,-1)),Ri(t,i,o,r,!1,0,d[e],l);else{var c=(i=i.replace(ir,"")).match(lr),h=c&&c[1];l=!1,h&&(i=i.slice(0,-(h.length+1)),sr.test(h)&&(h=h.slice(1,-1),l=!0)),Fi(t,i,a,o,h,l,r,d[e])}else ji(t,i,JSON.stringify(o),d[e]),!t.component&&"muted"===i&&tr(t.tag,t.attrsMap.type,i)&&Li(t,i,"true",d[e])}}(t),t}function xr(t){var e;if(e=zi(t,"v-for")){var n=function(t){var e=t.match(ar);if(!e)return;var n={};n.for=e[2].trim();var i=e[1].trim().replace(rr,""),a=i.match(or);a?(n.alias=i.replace(or,"").trim(),n.iterator1=a[1].trim(),a[2]&&(n.iterator2=a[2].trim())):n.alias=i;return n}(e);n&&D(t,n)}}function gr(t,e){t.ifConditions||(t.ifConditions=[]),t.ifConditions.push(e)}function vr(t){var e=t.name.replace(hr,"");return e||"#"!==t.name[0]&&(e="default"),sr.test(e)?{name:e.slice(1,-1),dynamic:!0}:{name:'"'+e+'"',dynamic:!1}}function Cr(t){var e=t.match(cr);if(e){var n={};return e.forEach(function(t){n[t.slice(1)]=!0}),n}}var yr=/^xmlns:NS\d+/,wr=/^NS\d+:/;function Br(t){return _r(t.tag,t.attrsList.slice(),t.parent)}var kr=[yo,Bo,{preTransformNode:function(t,e){if("input"===t.tag){var n,i=t.attrsMap;if(!i["v-model"])return;if((i[":type"]||i["v-bind:type"])&&(n=$i(t,"type")),i.type||n||!i["v-bind"]||(n="("+i["v-bind"]+").type"),n){var a=zi(t,"v-if",!0),o=a?"&&("+a+")":"",r=null!=zi(t,"v-else",!0),s=zi(t,"v-else-if",!0),l=Br(t);xr(l),Pi(l,"type","checkbox"),br(l,e),l.processed=!0,l.if="("+n+")==='checkbox'"+o,gr(l,{exp:l.if,block:l});var d=Br(t);zi(d,"v-for",!0),Pi(d,"type","radio"),br(d,e),gr(l,{exp:"("+n+")==='radio'"+o,block:d});var c=Br(t);return zi(c,"v-for",!0),Pi(c,":type",n),br(c,e),gr(l,{exp:a,block:c}),r?l.else=!0:s&&(l.elseif=s),l}}}}];var Er,Ir,Dr={expectHTML:!0,modules:kr,directives:{model:function(t,e,n){n;var i=e.value,a=e.modifiers,o=t.tag,r=t.attrsMap.type;if(t.component)return qi(t,i,a),!1;if("select"===o)!function(t,e,n){var i='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(n&&n.number?"_n(val)":"val")+"});";i=i+" "+Wi(e,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),Ri(t,"change",i,null,!0)}(t,i,a);else if("input"===o&&"checkbox"===r)!function(t,e,n){var i=n&&n.number,a=$i(t,"value")||"null",o=$i(t,"true-value")||"true",r=$i(t,"false-value")||"false";Li(t,"checked","Array.isArray("+e+")?_i("+e+","+a+")>-1"+("true"===o?":("+e+")":":_q("+e+","+o+")")),Ri(t,"change","var $$a="+e+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+r+");if(Array.isArray($$a)){var $$v="+(i?"_n("+a+")":a)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Wi(e,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Wi(e,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Wi(e,"$$c")+"}",null,!0)}(t,i,a);else if("input"===o&&"radio"===r)!function(t,e,n){var i=n&&n.number,a=$i(t,"value")||"null";Li(t,"checked","_q("+e+","+(a=i?"_n("+a+")":a)+")"),Ri(t,"change",Wi(e,a),null,!0)}(t,i,a);else if("input"===o||"textarea"===o)!function(t,e,n){var i=t.attrsMap.type,a=n||{},o=a.lazy,r=a.number,s=a.trim,l=!o&&"range"!==i,d=o?"change":"range"===i?ta:"input",c="$event.target.value";s&&(c="$event.target.value.trim()"),r&&(c="_n("+c+")");var h=Wi(e,c);l&&(h="if($event.target.composing)return;"+h),Li(t,"value","("+e+")"),Ri(t,d,h,null,!0),(s||r)&&Ri(t,"blur","$forceUpdate()")}(t,i,a);else if(!R.isReservedTag(o))return qi(t,i,a),!1;return!0},text:function(t,e){e.value&&Li(t,"textContent","_s("+e.value+")",e)},html:function(t,e){e.value&&Li(t,"innerHTML","_s("+e.value+")",e)}},isPreTag:function(t){return"pre"===t},isUnaryTag:Eo,mustUseProp:Pn,canBeLeftOpenTag:Io,isReservedTag:Kn,getTagNamespace:ti,staticKeys:function(t){return t.reduce(function(t,e){return t.concat(e.staticKeys||[])},[]).join(",")}(kr)},Sr=v(function(t){return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(t?","+t:""))});function Nr(t,e){t&&(Er=Sr(e.staticKeys||""),Ir=e.isReservedTag||M,function t(e){e.static=function(t){if(2===t.type)return!1;if(3===t.type)return!0;return!(!t.pre&&(t.hasBindings||t.if||t.for||_(t.tag)||!Ir(t.tag)||function(t){for(;t.parent;){if("template"!==(t=t.parent).tag)return!1;if(t.for)return!0}return!1}(t)||!Object.keys(t).every(Er)))}(e);if(1===e.type){if(!Ir(e.tag)&&"slot"!==e.tag&&null==e.attrsMap["inline-template"])return;for(var n=0,i=e.children.length;n<i;n++){var a=e.children[n];t(a),a.static||(e.static=!1)}if(e.ifConditions)for(var o=1,r=e.ifConditions.length;o<r;o++){var s=e.ifConditions[o].block;t(s),s.static||(e.static=!1)}}}(t),function t(e,n){if(1===e.type){if((e.static||e.once)&&(e.staticInFor=n),e.static&&e.children.length&&(1!==e.children.length||3!==e.children[0].type))return void(e.staticRoot=!0);if(e.staticRoot=!1,e.children)for(var i=0,a=e.children.length;i<a;i++)t(e.children[i],n||!!e.for);if(e.ifConditions)for(var o=1,r=e.ifConditions.length;o<r;o++)t(e.ifConditions[o].block,n)}}(t,!1))}var Mr=/^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,Or=/\([^)]*?\);*$/,Tr=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Lr={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},jr={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},Pr=function(t){return"if("+t+")return null;"},Fr={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:Pr("$event.target !== $event.currentTarget"),ctrl:Pr("!$event.ctrlKey"),shift:Pr("!$event.shiftKey"),alt:Pr("!$event.altKey"),meta:Pr("!$event.metaKey"),left:Pr("'button' in $event && $event.button !== 0"),middle:Pr("'button' in $event && $event.button !== 1"),right:Pr("'button' in $event && $event.button !== 2")};function Yr(t,e){var n=e?"nativeOn:":"on:",i="",a="";for(var o in t){var r=Rr(t[o]);t[o]&&t[o].dynamic?a+=o+","+r+",":i+='"'+o+'":'+r+","}return i="{"+i.slice(0,-1)+"}",a?n+"_d("+i+",["+a.slice(0,-1)+"])":n+i}function Rr(t){if(!t)return"function(){}";if(Array.isArray(t))return"["+t.map(function(t){return Rr(t)}).join(",")+"]";var e=Tr.test(t.value),n=Mr.test(t.value),i=Tr.test(t.value.replace(Or,""));if(t.modifiers){var a="",o="",r=[];for(var s in t.modifiers)if(Fr[s])o+=Fr[s],Lr[s]&&r.push(s);else if("exact"===s){var l=t.modifiers;o+=Pr(["ctrl","shift","alt","meta"].filter(function(t){return!l[t]}).map(function(t){return"$event."+t+"Key"}).join("||"))}else r.push(s);return r.length&&(a+=function(t){return"if(!$event.type.indexOf('key')&&"+t.map(Hr).join("&&")+")return null;"}(r)),o&&(a+=o),"function($event){"+a+(e?"return "+t.value+".apply(null, arguments)":n?"return ("+t.value+").apply(null, arguments)":i?"return "+t.value:t.value)+"}"}return e||n?t.value:"function($event){"+(i?"return "+t.value:t.value)+"}"}function Hr(t){var e=parseInt(t,10);if(e)return"$event.keyCode!=="+e;var n=Lr[t],i=jr[t];return"_k($event.keyCode,"+JSON.stringify(t)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(i)+")"}var $r={on:function(t,e){t.wrapListeners=function(t){return"_g("+t+","+e.value+")"}},bind:function(t,e){t.wrapData=function(n){return"_b("+n+",'"+t.tag+"',"+e.value+","+(e.modifiers&&e.modifiers.prop?"true":"false")+(e.modifiers&&e.modifiers.sync?",true":"")+")"}},cloak:N},zr=function(t){this.options=t,this.warn=t.warn||Oi,this.transforms=Ti(t.modules,"transformCode"),this.dataGenFns=Ti(t.modules,"genData"),this.directives=D(D({},$r),t.directives);var e=t.isReservedTag||M;this.maybeComponent=function(t){return!!t.component||!e(t.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Xr(t,e){var n=new zr(e);return{render:"with(this){return "+(t?"script"===t.tag?"null":Vr(t,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function Vr(t,e){if(t.parent&&(t.pre=t.pre||t.parent.pre),t.staticRoot&&!t.staticProcessed)return qr(t,e);if(t.once&&!t.onceProcessed)return Wr(t,e);if(t.for&&!t.forProcessed)return Gr(t,e);if(t.if&&!t.ifProcessed)return Ur(t,e);if("template"!==t.tag||t.slotTarget||e.pre){if("slot"===t.tag)return function(t,e){var n=t.slotName||'"default"',i=Kr(t,e),a="_t("+n+(i?",function(){return "+i+"}":""),o=t.attrs||t.dynamicAttrs?ns((t.attrs||[]).concat(t.dynamicAttrs||[]).map(function(t){return{name:y(t.name),value:t.value,dynamic:t.dynamic}})):null,r=t.attrsMap["v-bind"];!o&&!r||i||(a+=",null");o&&(a+=","+o);r&&(a+=(o?"":",null")+","+r);return a+")"}(t,e);var n;if(t.component)n=function(t,e,n){var i=e.inlineTemplate?null:Kr(e,n,!0);return"_c("+t+","+Zr(e,n)+(i?","+i:"")+")"}(t.component,t,e);else{var i;(!t.plain||t.pre&&e.maybeComponent(t))&&(i=Zr(t,e));var a=t.inlineTemplate?null:Kr(t,e,!0);n="_c('"+t.tag+"'"+(i?","+i:"")+(a?","+a:"")+")"}for(var o=0;o<e.transforms.length;o++)n=e.transforms[o](t,n);return n}return Kr(t,e)||"void 0"}function qr(t,e){t.staticProcessed=!0;var n=e.pre;return t.pre&&(e.pre=t.pre),e.staticRenderFns.push("with(this){return "+Vr(t,e)+"}"),e.pre=n,"_m("+(e.staticRenderFns.length-1)+(t.staticInFor?",true":"")+")"}function Wr(t,e){if(t.onceProcessed=!0,t.if&&!t.ifProcessed)return Ur(t,e);if(t.staticInFor){for(var n="",i=t.parent;i;){if(i.for){n=i.key;break}i=i.parent}return n?"_o("+Vr(t,e)+","+e.onceId+++","+n+")":Vr(t,e)}return qr(t,e)}function Ur(t,e,n,i){return t.ifProcessed=!0,function t(e,n,i,a){if(!e.length)return a||"_e()";var o=e.shift();return o.exp?"("+o.exp+")?"+r(o.block)+":"+t(e,n,i,a):""+r(o.block);function r(t){return i?i(t,n):t.once?Wr(t,n):Vr(t,n)}}(t.ifConditions.slice(),e,n,i)}function Gr(t,e,n,i){var a=t.for,o=t.alias,r=t.iterator1?","+t.iterator1:"",s=t.iterator2?","+t.iterator2:"";return t.forProcessed=!0,(i||"_l")+"(("+a+"),function("+o+r+s+"){return "+(n||Vr)(t,e)+"})"}function Zr(t,e){var n="{",i=function(t,e){var n=t.directives;if(!n)return;var i,a,o,r,s="directives:[",l=!1;for(i=0,a=n.length;i<a;i++){o=n[i],r=!0;var d=e.directives[o.name];d&&(r=!!d(t,o,e.warn)),r&&(l=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(l)return s.slice(0,-1)+"]"}(t,e);i&&(n+=i+","),t.key&&(n+="key:"+t.key+","),t.ref&&(n+="ref:"+t.ref+","),t.refInFor&&(n+="refInFor:true,"),t.pre&&(n+="pre:true,"),t.component&&(n+='tag:"'+t.tag+'",');for(var a=0;a<e.dataGenFns.length;a++)n+=e.dataGenFns[a](t);if(t.attrs&&(n+="attrs:"+ns(t.attrs)+","),t.props&&(n+="domProps:"+ns(t.props)+","),t.events&&(n+=Yr(t.events,!1)+","),t.nativeEvents&&(n+=Yr(t.nativeEvents,!0)+","),t.slotTarget&&!t.slotScope&&(n+="slot:"+t.slotTarget+","),t.scopedSlots&&(n+=function(t,e,n){var i=t.for||Object.keys(e).some(function(t){var n=e[t];return n.slotTargetDynamic||n.if||n.for||Jr(n)}),a=!!t.if;if(!i)for(var o=t.parent;o;){if(o.slotScope&&o.slotScope!==pr||o.for){i=!0;break}o.if&&(a=!0),o=o.parent}var r=Object.keys(e).map(function(t){return Qr(e[t],n)}).join(",");return"scopedSlots:_u(["+r+"]"+(i?",null,true":"")+(!i&&a?",null,false,"+function(t){var e=5381,n=t.length;for(;n;)e=33*e^t.charCodeAt(--n);return e>>>0}(r):"")+")"}(t,t.scopedSlots,e)+","),t.model&&(n+="model:{value:"+t.model.value+",callback:"+t.model.callback+",expression:"+t.model.expression+"},"),t.inlineTemplate){var o=function(t,e){var n=t.children[0];0;if(n&&1===n.type){var i=Xr(n,e.options);return"inlineTemplate:{render:function(){"+i.render+"},staticRenderFns:["+i.staticRenderFns.map(function(t){return"function(){"+t+"}"}).join(",")+"]}"}}(t,e);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",t.dynamicAttrs&&(n="_b("+n+',"'+t.tag+'",'+ns(t.dynamicAttrs)+")"),t.wrapData&&(n=t.wrapData(n)),t.wrapListeners&&(n=t.wrapListeners(n)),n}function Jr(t){return 1===t.type&&("slot"===t.tag||t.children.some(Jr))}function Qr(t,e){var n=t.attrsMap["slot-scope"];if(t.if&&!t.ifProcessed&&!n)return Ur(t,e,Qr,"null");if(t.for&&!t.forProcessed)return Gr(t,e,Qr);var i=t.slotScope===pr?"":String(t.slotScope),a="function("+i+"){return "+("template"===t.tag?t.if&&n?"("+t.if+")?"+(Kr(t,e)||"undefined")+":undefined":Kr(t,e)||"undefined":Vr(t,e))+"}",o=i?"":",proxy:true";return"{key:"+(t.slotTarget||'"default"')+",fn:"+a+o+"}"}function Kr(t,e,n,i,a){var o=t.children;if(o.length){var r=o[0];if(1===o.length&&r.for&&"template"!==r.tag&&"slot"!==r.tag){var s=n?e.maybeComponent(r)?",1":",0":"";return""+(i||Vr)(r,e)+s}var l=n?function(t,e){for(var n=0,i=0;i<t.length;i++){var a=t[i];if(1===a.type){if(ts(a)||a.ifConditions&&a.ifConditions.some(function(t){return ts(t.block)})){n=2;break}(e(a)||a.ifConditions&&a.ifConditions.some(function(t){return e(t.block)}))&&(n=1)}}return n}(o,e.maybeComponent):0,d=a||es;return"["+o.map(function(t){return d(t,e)}).join(",")+"]"+(l?","+l:"")}}function ts(t){return void 0!==t.for||"template"===t.tag||"slot"===t.tag}function es(t,e){return 1===t.type?Vr(t,e):3===t.type&&t.isComment?(i=t,"_e("+JSON.stringify(i.text)+")"):"_v("+(2===(n=t).type?n.expression:is(JSON.stringify(n.text)))+")";var n,i}function ns(t){for(var e="",n="",i=0;i<t.length;i++){var a=t[i],o=is(a.value);a.dynamic?n+=a.name+","+o+",":e+='"'+a.name+'":'+o+","}return e="{"+e.slice(0,-1)+"}",n?"_d("+e+",["+n.slice(0,-1)+"])":e}function is(t){return t.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b"),new RegExp("\\b"+"delete,typeof,void".split(",").join("\\s*\\([^\\)]*\\)|\\b")+"\\s*\\([^\\)]*\\)");function as(t,e){try{return new Function(t)}catch(n){return e.push({err:n,code:t}),N}}function os(t){var e=Object.create(null);return function(n,i,a){(i=D({},i)).warn;delete i.warn;var o=i.delimiters?String(i.delimiters)+n:n;if(e[o])return e[o];var r=t(n,i);var s={},l=[];return s.render=as(r.render,l),s.staticRenderFns=r.staticRenderFns.map(function(t){return as(t,l)}),e[o]=s}}var rs,ss,ls=(rs=function(t,e){var n=Ar(t.trim(),e);!1!==e.optimize&&Nr(n,e);var i=Xr(n,e);return{ast:n,render:i.render,staticRenderFns:i.staticRenderFns}},function(t){function e(e,n){var i=Object.create(t),a=[],o=[],r=function(t,e,n){(n?o:a).push(t)};if(n)for(var s in n.modules&&(i.modules=(t.modules||[]).concat(n.modules)),n.directives&&(i.directives=D(Object.create(t.directives||null),n.directives)),n)"modules"!==s&&"directives"!==s&&(i[s]=n[s]);i.warn=r;var l=rs(e.trim(),i);return l.errors=a,l.tips=o,l}return{compile:e,compileToFunctions:os(e)}})(Dr),ds=(ls.compile,ls.compileToFunctions);function cs(t){return(ss=ss||document.createElement("div")).innerHTML=t?'<a href="\n"/>':'<div a="\n"/>',ss.innerHTML.indexOf("&#10;")>0}var hs=!!W&&cs(!1),us=!!W&&cs(!0),ms=v(function(t){var e=ii(t);return e&&e.innerHTML}),fs=En.prototype.$mount;En.prototype.$mount=function(t,e){if((t=t&&ii(t))===document.body||t===document.documentElement)return this;var n=this.$options;if(!n.render){var i=n.template;if(i)if("string"==typeof i)"#"===i.charAt(0)&&(i=ms(i));else{if(!i.nodeType)return this;i=i.innerHTML}else t&&(i=function(t){if(t.outerHTML)return t.outerHTML;var e=document.createElement("div");return e.appendChild(t.cloneNode(!0)),e.innerHTML}(t));if(i){0;var a=ds(i,{outputSourceRange:!1,shouldDecodeNewlines:hs,shouldDecodeNewlinesForHref:us,delimiters:n.delimiters,comments:n.comments},this),o=a.render,r=a.staticRenderFns;n.render=o,n.staticRenderFns=r}}return fs.call(this,t,e)},En.compile=ds,e.a=En}).call(e,n("DuR2"))},"76UX":function(t,e,n){"use strict";var i="undefined"!=typeof Symbol&&Symbol,a=n("9MlZ");t.exports=function(){return"function"==typeof i&&("function"==typeof Symbol&&("symbol"==typeof i("foo")&&("symbol"==typeof Symbol("bar")&&a())))}},"78S2":function(t,e,n){var i=n("gkB7");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("3427c764",i,!0,{})},"79J4":function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAJAIABAAAAAP///yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAAEALAAAAAAGAAkAAAINjAOHkNv8mIJTHnpDAQA7"},"7GKi":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-5e407ef2]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-5e407ef2]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-5e407ef2]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-5e407ef2]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-5e407ef2] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-5e407ef2]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-5e407ef2] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-5e407ef2]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-5e407ef2]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-5e407ef2]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-5e407ef2]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-5e407ef2]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-5e407ef2]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-5e407ef2] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-5e407ef2]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-5e407ef2] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-5e407ef2]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-5e407ef2]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},"7GwW":function(t,e,n){"use strict";var i=n("cGG2"),a=n("21It"),o=n("DQCr"),r=n("oJlt"),s=n("GHBc"),l=n("FtD3");t.exports=function(t){return new Promise(function(e,d){var c=t.data,h=t.headers;i.isFormData(c)&&delete h["Content-Type"];var u=new XMLHttpRequest;if(t.auth){var m=t.auth.username||"",f=t.auth.password||"";h.Authorization="Basic "+btoa(m+":"+f)}if(u.open(t.method.toUpperCase(),o(t.url,t.params,t.paramsSerializer),!0),u.timeout=t.timeout,u.onreadystatechange=function(){if(u&&4===u.readyState&&(0!==u.status||u.responseURL&&0===u.responseURL.indexOf("file:"))){var n="getAllResponseHeaders"in u?r(u.getAllResponseHeaders()):null,i={data:t.responseType&&"text"!==t.responseType?u.response:u.responseText,status:u.status,statusText:u.statusText,headers:n,config:t,request:u};a(e,d,i),u=null}},u.onerror=function(){d(l("Network Error",t,null,u)),u=null},u.ontimeout=function(){d(l("timeout of "+t.timeout+"ms exceeded",t,"ECONNABORTED",u)),u=null},i.isStandardBrowserEnv()){var p=n("p1b6"),_=(t.withCredentials||s(t.url))&&t.xsrfCookieName?p.read(t.xsrfCookieName):void 0;_&&(h[t.xsrfHeaderName]=_)}if("setRequestHeader"in u&&i.forEach(h,function(t,e){void 0===c&&"content-type"===e.toLowerCase()?delete h[e]:u.setRequestHeader(e,t)}),t.withCredentials&&(u.withCredentials=!0),t.responseType)try{u.responseType=t.responseType}catch(e){if("json"!==t.responseType)throw e}"function"==typeof t.onDownloadProgress&&u.addEventListener("progress",t.onDownloadProgress),"function"==typeof t.onUploadProgress&&u.upload&&u.upload.addEventListener("progress",t.onUploadProgress),t.cancelToken&&t.cancelToken.promise.then(function(t){u&&(u.abort(),d(t),u=null)}),void 0===c&&(c=null),u.send(c)})}},"7LV+":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),n="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_"),i=[/^sty/i,/^lut/i,/^mar/i,/^kwi/i,/^maj/i,/^cze/i,/^lip/i,/^sie/i,/^wrz/i,/^paź/i,/^lis/i,/^gru/i];function a(t){return t%10<5&&t%10>1&&~~(t/10)%10!=1}function o(t,e,n){var i=t+" ";switch(n){case"ss":return i+(a(t)?"sekundy":"sekund");case"m":return e?"minuta":"minutę";case"mm":return i+(a(t)?"minuty":"minut");case"h":return e?"godzina":"godzinę";case"hh":return i+(a(t)?"godziny":"godzin");case"ww":return i+(a(t)?"tygodnie":"tygodni");case"MM":return i+(a(t)?"miesiące":"miesięcy");case"yy":return i+(a(t)?"lata":"lat")}}t.defineLocale("pl",{months:function(t,i){return t?/D MMMM/.test(i)?n[t.month()]:e[t.month()]:e},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),monthsParse:i,longMonthsParse:i,shortMonthsParse:i,weekdays:"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),weekdaysShort:"ndz_pon_wt_śr_czw_pt_sob".split("_"),weekdaysMin:"Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Dziś o] LT",nextDay:"[Jutro o] LT",nextWeek:function(){switch(this.day()){case 0:return"[W niedzielę o] LT";case 2:return"[We wtorek o] LT";case 3:return"[W środę o] LT";case 6:return"[W sobotę o] LT";default:return"[W] dddd [o] LT"}},lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zeszłą niedzielę o] LT";case 3:return"[W zeszłą środę o] LT";case 6:return"[W zeszłą sobotę o] LT";default:return"[W zeszły] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",ss:o,m:o,mm:o,h:o,hh:o,d:"1 dzień",dd:"%d dni",w:"tydzień",ww:o,M:"miesiąc",MM:o,y:"rok",yy:o},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},"7MHZ":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),i=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],a=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;t.defineLocale("es-do",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(t,i){return t?/-MMM-/.test(i)?n[t.month()]:e[t.month()]:e},monthsRegex:a,monthsShortRegex:a,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:i,longMonthsParse:i,shortMonthsParse:i,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})(n("PJh5"))},"7OnE":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"};t.defineLocale("ar-sa",{months:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(t){return"م"===t},meridiem:function(t,e,n){return t<12?"ص":"م"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},preparse:function(t){return t.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(t){return n[t]}).replace(/،/g,",")},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]}).replace(/,/g,"،")},week:{dow:0,doy:6}})})(n("PJh5"))},"7Q8x":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ss",{months:"Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split("_"),monthsShort:"Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),weekdays:"Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split("_"),weekdaysShort:"Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),weekdaysMin:"Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Namuhla nga] LT",nextDay:"[Kusasa nga] LT",nextWeek:"dddd [nga] LT",lastDay:"[Itolo nga] LT",lastWeek:"dddd [leliphelile] [nga] LT",sameElse:"L"},relativeTime:{future:"nga %s",past:"wenteka nga %s",s:"emizuzwana lomcane",ss:"%d mzuzwana",m:"umzuzu",mm:"%d emizuzu",h:"lihora",hh:"%d emahora",d:"lilanga",dd:"%d emalanga",M:"inyanga",MM:"%d tinyanga",y:"umnyaka",yy:"%d iminyaka"},meridiemParse:/ekuseni|emini|entsambama|ebusuku/,meridiem:function(t,e,n){return t<11?"ekuseni":t<15?"emini":t<19?"entsambama":"ebusuku"},meridiemHour:function(t,e){return 12===t&&(t=0),"ekuseni"===e?t:"emini"===e?t>=11?t:t+12:"entsambama"===e||"ebusuku"===e?0===t?0:t+12:void 0},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:"%d",week:{dow:1,doy:4}})})(n("PJh5"))},"7V7F":function(t,e,n){var i=n("OuA/");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("1b5e80d1",i,!0,{})},"7XDv":function(t,e,n){var i=n("wfTn");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("426f732d",i,!0,{})},"7ar3":function(t,e,n){"use strict";var i=SyntaxError,a=Function,o=TypeError,r=function(t){try{return a('"use strict"; return ('+t+").constructor;")()}catch(t){}},s=Object.getOwnPropertyDescriptor;if(s)try{s({},"")}catch(t){s=null}var l=function(){throw new o},d=s?function(){try{return arguments.callee,l}catch(t){try{return s(arguments,"callee").get}catch(t){return l}}}():l,c=n("76UX")(),h=Object.getPrototypeOf||function(t){return t.__proto__},u={},m="undefined"==typeof Uint8Array?void 0:h(Uint8Array),f={"%AggregateError%":"undefined"==typeof AggregateError?void 0:AggregateError,"%Array%":Array,"%ArrayBuffer%":"undefined"==typeof ArrayBuffer?void 0:ArrayBuffer,"%ArrayIteratorPrototype%":c?h([][Symbol.iterator]()):void 0,"%AsyncFromSyncIteratorPrototype%":void 0,"%AsyncFunction%":u,"%AsyncGenerator%":u,"%AsyncGeneratorFunction%":u,"%AsyncIteratorPrototype%":u,"%Atomics%":"undefined"==typeof Atomics?void 0:Atomics,"%BigInt%":"undefined"==typeof BigInt?void 0:BigInt,"%Boolean%":Boolean,"%DataView%":"undefined"==typeof DataView?void 0:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":"undefined"==typeof Float32Array?void 0:Float32Array,"%Float64Array%":"undefined"==typeof Float64Array?void 0:Float64Array,"%FinalizationRegistry%":"undefined"==typeof FinalizationRegistry?void 0:FinalizationRegistry,"%Function%":a,"%GeneratorFunction%":u,"%Int8Array%":"undefined"==typeof Int8Array?void 0:Int8Array,"%Int16Array%":"undefined"==typeof Int16Array?void 0:Int16Array,"%Int32Array%":"undefined"==typeof Int32Array?void 0:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":c?h(h([][Symbol.iterator]())):void 0,"%JSON%":"object"==typeof JSON?JSON:void 0,"%Map%":"undefined"==typeof Map?void 0:Map,"%MapIteratorPrototype%":"undefined"!=typeof Map&&c?h((new Map)[Symbol.iterator]()):void 0,"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":"undefined"==typeof Promise?void 0:Promise,"%Proxy%":"undefined"==typeof Proxy?void 0:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":"undefined"==typeof Reflect?void 0:Reflect,"%RegExp%":RegExp,"%Set%":"undefined"==typeof Set?void 0:Set,"%SetIteratorPrototype%":"undefined"!=typeof Set&&c?h((new Set)[Symbol.iterator]()):void 0,"%SharedArrayBuffer%":"undefined"==typeof SharedArrayBuffer?void 0:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":c?h(""[Symbol.iterator]()):void 0,"%Symbol%":c?Symbol:void 0,"%SyntaxError%":i,"%ThrowTypeError%":d,"%TypedArray%":m,"%TypeError%":o,"%Uint8Array%":"undefined"==typeof Uint8Array?void 0:Uint8Array,"%Uint8ClampedArray%":"undefined"==typeof Uint8ClampedArray?void 0:Uint8ClampedArray,"%Uint16Array%":"undefined"==typeof Uint16Array?void 0:Uint16Array,"%Uint32Array%":"undefined"==typeof Uint32Array?void 0:Uint32Array,"%URIError%":URIError,"%WeakMap%":"undefined"==typeof WeakMap?void 0:WeakMap,"%WeakRef%":"undefined"==typeof WeakRef?void 0:WeakRef,"%WeakSet%":"undefined"==typeof WeakSet?void 0:WeakSet},p={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]},_=n("PiFy"),A=n("XfW5"),b=_.call(Function.call,Array.prototype.concat),x=_.call(Function.apply,Array.prototype.splice),g=_.call(Function.call,String.prototype.replace),v=_.call(Function.call,String.prototype.slice),C=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g,y=/\\(\\)?/g,w=function(t,e){var n,a=t;if(A(p,a)&&(a="%"+(n=p[a])[0]+"%"),A(f,a)){var s=f[a];if(s===u&&(s=function t(e){var n;if("%AsyncFunction%"===e)n=r("async function () {}");else if("%GeneratorFunction%"===e)n=r("function* () {}");else if("%AsyncGeneratorFunction%"===e)n=r("async function* () {}");else if("%AsyncGenerator%"===e){var i=t("%AsyncGeneratorFunction%");i&&(n=i.prototype)}else if("%AsyncIteratorPrototype%"===e){var a=t("%AsyncGenerator%");a&&(n=h(a.prototype))}return f[e]=n,n}(a)),void 0===s&&!e)throw new o("intrinsic "+t+" exists, but is not available. Please file an issue!");return{alias:n,name:a,value:s}}throw new i("intrinsic "+t+" does not exist!")};t.exports=function(t,e){if("string"!=typeof t||0===t.length)throw new o("intrinsic name must be a non-empty string");if(arguments.length>1&&"boolean"!=typeof e)throw new o('"allowMissing" argument must be a boolean');var n=function(t){var e=v(t,0,1),n=v(t,-1);if("%"===e&&"%"!==n)throw new i("invalid intrinsic syntax, expected closing `%`");if("%"===n&&"%"!==e)throw new i("invalid intrinsic syntax, expected opening `%`");var a=[];return g(t,C,function(t,e,n,i){a[a.length]=n?g(i,y,"$1"):e||t}),a}(t),a=n.length>0?n[0]:"",r=w("%"+a+"%",e),l=r.name,d=r.value,c=!1,h=r.alias;h&&(a=h[0],x(n,b([0,1],h)));for(var u=1,m=!0;u<n.length;u+=1){var p=n[u],_=v(p,0,1),B=v(p,-1);if(('"'===_||"'"===_||"`"===_||'"'===B||"'"===B||"`"===B)&&_!==B)throw new i("property names with quotes must have matching quotes");if("constructor"!==p&&m||(c=!0),A(f,l="%"+(a+="."+p)+"%"))d=f[l];else if(null!=d){if(!(p in d)){if(!e)throw new o("base intrinsic for "+t+" exists, but the property is not available.");return}if(s&&u+1>=n.length){var k=s(d,p);d=(m=!!k)&&"get"in k&&!("originalValue"in k.get)?k.get:d[p]}else m=A(d,p),d=d[p];m&&!c&&(f[l]=d)}}return d}},"8ANE":function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},"8JLF":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"/* OLD CONCEPT STYLE */\n.borderCard {\n  border-color: #bce8f1;\n}\n.headerColorCard {\n   background-color: #d9edf7;\n   color: #31708f;\n   border-color: #bce8f1;\n   padding: 0.25rem 1.25rem;\n}\n.headertop {\n    margin-top: 5px;\n    padding-left: 0px !important;\n}\n.bodyColorCard {\n   background-color: #f5fcfe;\n}\n.footerCard{\n  background-color: #f5fcfe;\n  border-top: 1px #b5e4ff solid;\n}\n.font13{\n  font-size: 13px !important;\n}\n.My-radio-btn {\n  background-color: #EBEBEB !important;\n  color: black !important;\n  opacity: 0.5;\n  padding: 0.45rem .5rem !important;\n}\n.My-radio-btn.active {\n  background-color: #3276B1 !important;\n  color: white !important;\n  border: 1px solid #DDDDDD;\n  opacity: 1.0;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n.footable-pagination-wrapper  {\n  text-align: right !important;\n}\n.footable-pagination-wrapper .pagination {\n  -webkit-box-pack: end !important;\n      -ms-flex-pack: end !important;\n          justify-content: flex-end !important;\n}\n.pagination li a {\n  padding: .5rem .75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #323a46;\n  background-color: #fff;\n  display: block;\n  border: 1px solid #dee2e6;\n  border-radius: .25rem;\n}\n.pagination li.active a {\n  color: #fff !important;\n  background-color: #6658dd !important;\n  border-color: #6658dd !important;\n}\nth.footable-visible.footable-sortable span {\n  float: right !important;\n  margin-top: 4px;\n}\n.tox-tinymce-aux {\n  z-index: 9999 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfNotes/PfNotes.css"],names:[],mappings:"AAAA,uBAAuB;AACvB;EACE,sBAAsB;CACvB;AACD;GACG,0BAA0B;GAC1B,eAAe;GACf,sBAAsB;GACtB,yBAAyB;CAC3B;AACD;IACI,gBAAgB;IAChB,6BAA6B;CAChC;AACD;GACG,0BAA0B;CAC5B;AACD;EACE,0BAA0B;EAC1B,8BAA8B;CAC/B;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,aAAa;EACb,kCAAkC;CACnC;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;EACb,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,iCAAiC;MAC7B,8BAA8B;UAC1B,qCAAqC;CAC9C;AACD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,gBAAgB;CACjB;AACD;EACE,yBAAyB;CAC1B",file:"PfNotes.css",sourcesContent:["/* OLD CONCEPT STYLE */\n.borderCard {\n  border-color: #bce8f1;\n}\n.headerColorCard {\n   background-color: #d9edf7;\n   color: #31708f;\n   border-color: #bce8f1;\n   padding: 0.25rem 1.25rem;\n}\n.headertop {\n    margin-top: 5px;\n    padding-left: 0px !important;\n}\n.bodyColorCard {\n   background-color: #f5fcfe;\n}\n.footerCard{\n  background-color: #f5fcfe;\n  border-top: 1px #b5e4ff solid;\n}\n.font13{\n  font-size: 13px !important;\n}\n.My-radio-btn {\n  background-color: #EBEBEB !important;\n  color: black !important;\n  opacity: 0.5;\n  padding: 0.45rem .5rem !important;\n}\n.My-radio-btn.active {\n  background-color: #3276B1 !important;\n  color: white !important;\n  border: 1px solid #DDDDDD;\n  opacity: 1.0;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n.footable-pagination-wrapper  {\n  text-align: right !important;\n}\n.footable-pagination-wrapper .pagination {\n  -webkit-box-pack: end !important;\n      -ms-flex-pack: end !important;\n          justify-content: flex-end !important;\n}\n.pagination li a {\n  padding: .5rem .75rem;\n  margin-left: -1px;\n  line-height: 1.25;\n  color: #323a46;\n  background-color: #fff;\n  display: block;\n  border: 1px solid #dee2e6;\n  border-radius: .25rem;\n}\n.pagination li.active a {\n  color: #fff !important;\n  background-color: #6658dd !important;\n  border-color: #6658dd !important;\n}\nth.footable-visible.footable-sortable span {\n  float: right !important;\n  margin-top: 4px;\n}\n.tox-tinymce-aux {\n  z-index: 9999 !important;\n}\n"],sourceRoot:""}])},"8Kpv":function(t,e,n){var i=n("HLWZ");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("41f35c30",i,!0,{})},"8YdS":function(t,e){t.exports="data:image/gif;base64,R0lGODlh9AEJAJEDAPPz89/f3////////yH5BAEAAAMALAAAAAD0AQkAAAJ/nI+py+0Po5y02ouzDbr7D4biSJbmiabqCgYAx8byTNf2jee65grvDgwKh8Si8VjpCXwwpPMJjUqnUuWSSc1qt9yuV2K9Yr/ksvmMloXF47T7DY/LB2t2e473Bvb8vv8PGCg4SFhoeIiYqLjI2OhICGAn+fJYaXmJmam5yRlYAAA7"},"8rKe":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.rowhelpItemModal[data-v-795ea1dc] {\n  margin-right: 15px;\n  margin-left: 15px;\n  margin-top: 15px;\n}\n.helpItemModal[data-v-795ea1dc] {\n  background-color: #f1f189 !important;\n  text-align: center;\n  font-size: 13px;\n  padding: 0.8rem !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfQuestionnaireModal/PfQuestionnaireModal.css"],names:[],mappings:";AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;CAC5B",file:"PfQuestionnaireModal.css",sourcesContent:["\n.rowhelpItemModal[data-v-795ea1dc] {\n  margin-right: 15px;\n  margin-left: 15px;\n  margin-top: 15px;\n}\n.helpItemModal[data-v-795ea1dc] {\n  background-color: #f1f189 !important;\n  text-align: center;\n  font-size: 13px;\n  padding: 0.8rem !important;\n}\n"],sourceRoot:""}])},"8tXo":function(t,e,n){var i=n("fAdt");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("0398ff02",i,!0,{})},"8v14":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){var a={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[t+" Tage",t+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[t+" Monate",t+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[t+" Jahre",t+" Jahren"]};return e?a[n][0]:a[n][1]}t.defineLocale("de-at",{months:"Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:e,mm:"%d Minuten",h:e,hh:"%d Stunden",d:e,dd:e,w:e,ww:"%d Wochen",M:e,MM:e,y:e,yy:e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},"8vWw":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.select-css[data-v-25e46b60] {\n  display: block;\n  font-size: 10px !important;\n  /* font-family: sans-serif; */\n  /* font-weight: 700; */\n  color: #444;\n  /* line-height: 1.3; */\n  padding: 0px;\n  /* width: 100%; */\n  max-width: 100%; \n  -webkit-box-sizing: border-box; \n          box-sizing: border-box;\n  margin: 0;\n  border: 1px solid #aaa;\n  -webkit-box-shadow: 0 1px 0 1px rgba(0,0,0,.04);\n          box-shadow: 0 1px 0 1px rgba(0,0,0,.04);\n  /* border-radius: .5em; */\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  /* background-color: #fff; */\n  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\n  /* linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%); */\n  background-repeat: no-repeat, repeat;\n  background-position: right 0.2em top 50%, 0 0;\n  background-size: .65em auto, 100%;\n}\n.select-css[data-v-25e46b60]::-ms-expand {\n  display: none;\n}\n.select-css[data-v-25e46b60]:hover {\n  border-color: #888;\n}\n.select-css[data-v-25e46b60]:focus {\n  border-color: #aaa;\n  -webkit-box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);\n          box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);\n  box-shadow: 0 0 0 3px -moz-mac-focusring;\n  color: #222; \n  outline: none;\n}\n.select-css option[data-v-25e46b60] {\n  font-weight:normal;\n}\n.select-jona[data-v-25e46b60]{\n  font-size: 15px !important;\n  font-family: 'Open Sans', sans-serif !important;\n  font-weight: 400 !important;\n  color: #444 !important;\n  line-height: 1.3 !important;\n  padding: .4em 1.4em .3em .8em !important;\n  border: 1px solid #aaa !important;\n  border-color: #80bdff;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfSelect/PfSelect.css"],names:[],mappings:";AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;UACvB,uBAAuB;EAC/B,UAAU;EACV,uBAAuB;EACvB,gDAAgD;UACxC,wCAAwC;EAChD,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;EAC7B,qfAAqf;EACrf,0DAA0D;EAC1D,qCAAqC;EACrC,8CAA8C;EAC9C,kCAAkC;CACnC;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,uDAAuD;UAC/C,+CAA+C;EACvD,yCAAyC;EACzC,YAAY;EACZ,cAAc;CACf;AACD;EACE,mBAAmB;CACpB;AACD;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,4BAA4B;EAC5B,uBAAuB;EACvB,4BAA4B;EAC5B,yCAAyC;EACzC,kCAAkC;EAClC,sBAAsB;CACvB",file:"PfSelect.css",sourcesContent:["\n.select-css[data-v-25e46b60] {\n  display: block;\n  font-size: 10px !important;\n  /* font-family: sans-serif; */\n  /* font-weight: 700; */\n  color: #444;\n  /* line-height: 1.3; */\n  padding: 0px;\n  /* width: 100%; */\n  max-width: 100%; \n  -webkit-box-sizing: border-box; \n          box-sizing: border-box;\n  margin: 0;\n  border: 1px solid #aaa;\n  -webkit-box-shadow: 0 1px 0 1px rgba(0,0,0,.04);\n          box-shadow: 0 1px 0 1px rgba(0,0,0,.04);\n  /* border-radius: .5em; */\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  /* background-color: #fff; */\n  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\n  /* linear-gradient(to bottom, #ffffff 0%,#e5e5e5 100%); */\n  background-repeat: no-repeat, repeat;\n  background-position: right 0.2em top 50%, 0 0;\n  background-size: .65em auto, 100%;\n}\n.select-css[data-v-25e46b60]::-ms-expand {\n  display: none;\n}\n.select-css[data-v-25e46b60]:hover {\n  border-color: #888;\n}\n.select-css[data-v-25e46b60]:focus {\n  border-color: #aaa;\n  -webkit-box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);\n          box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);\n  box-shadow: 0 0 0 3px -moz-mac-focusring;\n  color: #222; \n  outline: none;\n}\n.select-css option[data-v-25e46b60] {\n  font-weight:normal;\n}\n.select-jona[data-v-25e46b60]{\n  font-size: 15px !important;\n  font-family: 'Open Sans', sans-serif !important;\n  font-weight: 400 !important;\n  color: #444 !important;\n  line-height: 1.3 !important;\n  padding: .4em 1.4em .3em .8em !important;\n  border: 1px solid #aaa !important;\n  border-color: #80bdff;\n}\n"],sourceRoot:""}])},"9FU3":function(t,e,n){var i=n("IicD");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("5f3b5599",i,!0,{})},"9H6R":function(t,e,n){var i=n("2v0O");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("b051fc10",i,!0,{})},"9MbE":function(t,e,n){var i=n("8ANE");t.exports=function(t,e){if(!i(t))return t;var n,a;if(e&&"function"==typeof(n=t.toString)&&!i(a=n.call(t)))return a;if("function"==typeof(n=t.valueOf)&&!i(a=n.call(t)))return a;if(!e&&"function"==typeof(n=t.toString)&&!i(a=n.call(t)))return a;throw TypeError("Can't convert object to primitive value")}},"9MlZ":function(t,e,n){"use strict";t.exports=function(){if("function"!=typeof Symbol||"function"!=typeof Object.getOwnPropertySymbols)return!1;if("symbol"==typeof Symbol.iterator)return!0;var t={},e=Symbol("test"),n=Object(e);if("string"==typeof e)return!1;if("[object Symbol]"!==Object.prototype.toString.call(e))return!1;if("[object Symbol]"!==Object.prototype.toString.call(n))return!1;for(e in t[e]=42,t)return!1;if("function"==typeof Object.keys&&0!==Object.keys(t).length)return!1;if("function"==typeof Object.getOwnPropertyNames&&0!==Object.getOwnPropertyNames(t).length)return!1;var i=Object.getOwnPropertySymbols(t);if(1!==i.length||i[0]!==e)return!1;if(!Object.prototype.propertyIsEnumerable.call(t,e))return!1;if("function"==typeof Object.getOwnPropertyDescriptor){var a=Object.getOwnPropertyDescriptor(t,e);if(42!==a.value||!0!==a.enumerable)return!1}return!0}},"9kVg":function(t,e,n){var i=n("vkJh");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("142b41b8",i,!0,{})},AFvW:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-3638aff0] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-3638aff0]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-3638aff0] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-3638aff0] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-3638aff0] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-3638aff0] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-3638aff0] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-3638aff0] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-3638aff0] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-3638aff0] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-3638aff0] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-3638aff0] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-3638aff0] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-3638aff0] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-3638aff0] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-3638aff0] {\n  margin-right: 0px;\n}\n.newItem[data-v-3638aff0] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-3638aff0] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-3638aff0] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-3638aff0] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-3638aff0] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-3638aff0] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-3638aff0] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-3638aff0] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-3638aff0] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-3638aff0] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-3638aff0]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-3638aff0] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-3638aff0] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-3638aff0] {\n  color: red;\n}\n.showMore[data-v-3638aff0]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-3638aff0] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-3638aff0] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-3638aff0] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-3638aff0 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-3638aff0 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-3638aff0] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-3638aff0 3s infinite;\n  animation: bit-data-v-3638aff0 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-3638aff0] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-3638aff0]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-3638aff0]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-3638aff0]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-3638aff0]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-3638aff0]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-3638aff0]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-3638aff0] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-3638aff0]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-3638aff0] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-3638aff0] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-3638aff0] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-3638aff0] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-3638aff0] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-3638aff0] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-3638aff0] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-3638aff0] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-3638aff0] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-3638aff0] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-3638aff0] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-3638aff0] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-3638aff0] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-3638aff0] {\n  margin-right: 0px;\n}\n.newItem[data-v-3638aff0] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-3638aff0] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-3638aff0] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-3638aff0] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-3638aff0] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-3638aff0] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-3638aff0] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-3638aff0] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-3638aff0] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-3638aff0] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-3638aff0]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-3638aff0] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-3638aff0] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-3638aff0] {\n  color: red;\n}\n.showMore[data-v-3638aff0]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-3638aff0] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-3638aff0] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-3638aff0] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-3638aff0 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-3638aff0 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-3638aff0] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-3638aff0 3s infinite;\n  animation: bit-data-v-3638aff0 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-3638aff0] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-3638aff0]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-3638aff0]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-3638aff0]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-3638aff0]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-3638aff0]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-3638aff0]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},ALEw:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("en-ie",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")},week:{dow:1,doy:4}})})(n("PJh5"))},ANi1:function(t,e,n){var i=n("wQaC");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("2dbffe6a",i,!0,{})},Ab7C:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("mk",{months:"јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split("_"),monthsShort:"јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),weekdays:"недела_понеделник_вторник_среда_четврток_петок_сабота".split("_"),weekdaysShort:"нед_пон_вто_сре_чет_пет_саб".split("_"),weekdaysMin:"нe_пo_вт_ср_че_пе_сa".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Денес во] LT",nextDay:"[Утре во] LT",nextWeek:"[Во] dddd [во] LT",lastDay:"[Вчера во] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[Изминатата] dddd [во] LT";case 1:case 2:case 4:case 5:return"[Изминатиот] dddd [во] LT"}},sameElse:"L"},relativeTime:{future:"за %s",past:"пред %s",s:"неколку секунди",ss:"%d секунди",m:"една минута",mm:"%d минути",h:"еден час",hh:"%d часа",d:"еден ден",dd:"%d дена",M:"еден месец",MM:"%d месеци",y:"една година",yy:"%d години"},dayOfMonthOrdinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(t){var e=t%10,n=t%100;return 0===t?t+"-ев":0===n?t+"-ен":n>10&&n<20?t+"-ти":1===e?t+"-ви":2===e?t+"-ри":7===e||8===e?t+"-ми":t+"-ти"},week:{dow:1,doy:7}})})(n("PJh5"))},AgWD:function(t,e){t.exports=function(t){try{return{e:!1,v:t()}}catch(t){return{e:!0,v:t}}}},"Ahh+":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.new-information[data-v-791025c1] {\n  border: 2px solid #00751b66 !important;\n  background-color: #00751b1a !important;\n}\n.new-information[data-v-791025c1]:focus {\n  color: #495057;\n  background-color: #00751b1a !important;\n  border-color: #00751b66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n}\n.updated-information[data-v-791025c1] {\n  border: 2px solid #034aff66 !important;\n  background-color: #074dff1a !important;\n}\n.updated-information[data-v-791025c1]:focus {\n  color: #495057;\n  background-color: #074dff1a !important;\n  border-color: #034aff66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n}\n.deleted-information[data-v-791025c1] {\n  border: 2px solid #dc354566 !important;\n  background-color: #dc35451a !important;\n}\n.deleted-information[data-v-791025c1]:focus {\n  color: #495057;\n  background-color: #dc35451a !important;\n  border-color: #dc354566 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/comparing.css"],names:[],mappings:";AACA;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,0DAA0D;EAC1D,kDAAkD;CACnD;AACD;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,yDAAyD;EACzD,iDAAiD;CAClD;AACD;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,sDAAsD;EACtD,8CAA8C;CAC/C",file:"comparing.css",sourcesContent:["\n.new-information[data-v-791025c1] {\n  border: 2px solid #00751b66 !important;\n  background-color: #00751b1a !important;\n}\n.new-information[data-v-791025c1]:focus {\n  color: #495057;\n  background-color: #00751b1a !important;\n  border-color: #00751b66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n}\n.updated-information[data-v-791025c1] {\n  border: 2px solid #034aff66 !important;\n  background-color: #074dff1a !important;\n}\n.updated-information[data-v-791025c1]:focus {\n  color: #495057;\n  background-color: #074dff1a !important;\n  border-color: #034aff66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n}\n.deleted-information[data-v-791025c1] {\n  border: 2px solid #dc354566 !important;\n  background-color: #dc35451a !important;\n}\n.deleted-information[data-v-791025c1]:focus {\n  color: #495057;\n  background-color: #dc35451a !important;\n  border-color: #dc354566 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n}\n"],sourceRoot:""}])},AoDM:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("pt-br",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),weekdaysShort:"dom_seg_ter_qua_qui_sex_sáb".split("_"),weekdaysMin:"do_2ª_3ª_4ª_5ª_6ª_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [às] HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY [às] HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"poucos segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",invalidDate:"Data inválida"})})(n("PJh5"))},Aq0r:function(t,e){t.exports=function(){}},B5V0:function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},B75I:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-6b9d2da6] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6b9d2da6]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6b9d2da6] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6b9d2da6] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6b9d2da6] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6b9d2da6] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6b9d2da6] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6b9d2da6] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6b9d2da6] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6b9d2da6] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6b9d2da6] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6b9d2da6] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6b9d2da6] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6b9d2da6] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6b9d2da6] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6b9d2da6] {\n  margin-right: 0px;\n}\n.newItem[data-v-6b9d2da6] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6b9d2da6] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6b9d2da6] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6b9d2da6] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6b9d2da6] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6b9d2da6] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6b9d2da6] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6b9d2da6] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6b9d2da6] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6b9d2da6] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6b9d2da6]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6b9d2da6] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6b9d2da6] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6b9d2da6] {\n  color: red;\n}\n.showMore[data-v-6b9d2da6]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6b9d2da6] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6b9d2da6] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6b9d2da6] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6b9d2da6 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6b9d2da6 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6b9d2da6] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6b9d2da6 3s infinite;\n  animation: bit-data-v-6b9d2da6 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6b9d2da6] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6b9d2da6]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6b9d2da6]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6b9d2da6]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6b9d2da6]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6b9d2da6]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6b9d2da6]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-6b9d2da6] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6b9d2da6]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6b9d2da6] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6b9d2da6] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6b9d2da6] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6b9d2da6] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6b9d2da6] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6b9d2da6] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6b9d2da6] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6b9d2da6] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6b9d2da6] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6b9d2da6] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6b9d2da6] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6b9d2da6] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6b9d2da6] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6b9d2da6] {\n  margin-right: 0px;\n}\n.newItem[data-v-6b9d2da6] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6b9d2da6] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6b9d2da6] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6b9d2da6] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6b9d2da6] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6b9d2da6] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6b9d2da6] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6b9d2da6] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6b9d2da6] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6b9d2da6] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6b9d2da6]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6b9d2da6] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6b9d2da6] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6b9d2da6] {\n  color: red;\n}\n.showMore[data-v-6b9d2da6]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6b9d2da6] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6b9d2da6] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6b9d2da6] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6b9d2da6 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6b9d2da6 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6b9d2da6] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6b9d2da6 3s infinite;\n  animation: bit-data-v-6b9d2da6 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6b9d2da6] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6b9d2da6]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6b9d2da6]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6b9d2da6]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6b9d2da6]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6b9d2da6]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6b9d2da6]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},BDVP:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-2b3201c5] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-2b3201c5]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-2b3201c5] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-2b3201c5] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-2b3201c5] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-2b3201c5] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-2b3201c5] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-2b3201c5] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-2b3201c5] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-2b3201c5] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-2b3201c5] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-2b3201c5] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-2b3201c5] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-2b3201c5] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-2b3201c5] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-2b3201c5] {\n  margin-right: 0px;\n}\n.newItem[data-v-2b3201c5] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-2b3201c5] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-2b3201c5] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-2b3201c5] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-2b3201c5] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-2b3201c5] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-2b3201c5] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-2b3201c5] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-2b3201c5] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-2b3201c5] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-2b3201c5]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-2b3201c5] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-2b3201c5] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-2b3201c5] {\n  color: red;\n}\n.showMore[data-v-2b3201c5]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-2b3201c5] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-2b3201c5] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-2b3201c5] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-2b3201c5 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-2b3201c5 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-2b3201c5] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-2b3201c5 3s infinite;\n  animation: bit-data-v-2b3201c5 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-2b3201c5] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-2b3201c5]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-2b3201c5]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-2b3201c5]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-2b3201c5]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-2b3201c5]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-2b3201c5]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-2b3201c5] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-2b3201c5]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-2b3201c5] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-2b3201c5] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-2b3201c5] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-2b3201c5] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-2b3201c5] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-2b3201c5] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-2b3201c5] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-2b3201c5] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-2b3201c5] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-2b3201c5] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-2b3201c5] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-2b3201c5] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-2b3201c5] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-2b3201c5] {\n  margin-right: 0px;\n}\n.newItem[data-v-2b3201c5] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-2b3201c5] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-2b3201c5] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-2b3201c5] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-2b3201c5] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-2b3201c5] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-2b3201c5] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-2b3201c5] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-2b3201c5] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-2b3201c5] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-2b3201c5]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-2b3201c5] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-2b3201c5] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-2b3201c5] {\n  color: red;\n}\n.showMore[data-v-2b3201c5]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-2b3201c5] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-2b3201c5] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-2b3201c5] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-2b3201c5 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-2b3201c5 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-2b3201c5] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-2b3201c5 3s infinite;\n  animation: bit-data-v-2b3201c5 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-2b3201c5] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-2b3201c5]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-2b3201c5]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-2b3201c5]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-2b3201c5]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-2b3201c5]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-2b3201c5]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},BEem:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ar-tn",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:1,doy:4}})})(n("PJh5"))},BIZ8:function(t,e,n){var i=n("ihmg");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("1789fc2a",i,!0,{})},BO1k:function(t,e,n){t.exports={default:n("oY0/"),__esModule:!0}},BQO6:function(t,e,n){n("tz60"),n("+3lO"),t.exports=n("4DQ7").f("iterator")},BS92:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.scroll {\n  overflow-y: auto;\n}\n.widthTh {\n  width: 150px;\n}\n.firmName {\n  font-size: 25px;\n}\n.mBt {\n  margin-bottom: 0px;\n}\n.myText {\n  margin-left: 35px;\n}\n.myText2 {\n  margin-left: 3px;\n}\n.myText3 {\n  /* margin-left: 30px */\n}\n.myText4 {\n  margin-left: 8px;\n}\n.myText5 {\n  margin-left: 8px;\n}\n.hrLanding {\n  border-top: 2px solid #dee2e6;\n  margin-bottom: 22px;\n}\n.shadowBox {\n  -webkit-box-shadow: 1px 4px 8px -4px rgba(0, 0, 0, 0.7);\n  box-shadow: 1px 4px 8px -4px rgba(0, 0, 0, 0.7);\n}\n.scroll {\n  margin-top: 5px;\n}\n.fileOne {\n  font-size: 17px;\n  margin-top: 22px;\n  margin-bottom: 20px;\n}\n.rolForm {\n  background-color: #8cbff1;\n  color: black;\n}\n.itemBadge {\n  margin-top: -5px;\n  margin-bottom: 7px;\n}\n.animationBoxheight {\n  opacity: 1 !important;\n  display: block !important;\n  -webkit-transition: height 0.5s ease-in;\n  -webkit-transition: height 0.5s ease-in, opacity 8s ease-in-out;\n  transition: height 0.5s ease-in, opacity 8s ease-in-out;\n}\n.bounce-enter-active, .bounce-leave-active {\n  -webkit-transition: all 2s;\n  transition: all 2s;\n}\n.bounce-enter, .bounce-leave-to {\n  -webkit-transform: scale(0);\n  transform: scale(0);\n}\nh6.cscs {\n  display: inline-block !important;\n}\n.cc {\n  font-size: 16px;\n}\n.btnFill {\n  width: 135px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.divButtons {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.divButtons2 {\n  margin-top: 15px;\n  margin-bottom: 13px;\n}\n@media (max-width: 767px) {\n.contentFirm {\n    text-align: center;\n}\n.imgFirm {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.myText {\n    margin-left: 0px;\n}\n.myText2 {\n    margin-left: 0px;\n}\n.boxcontainerForm {\n    border: 2px solid black;\n    margin-bottom: 16px;\n    border-radius: 5px 5px 5px 5px;\n    font-family: "Open Sans", sans-serif;\n    font-size: medium;\n    -webkit-transition: all 0.3s linear;\n    transition: all 0.3s linear;\n    background-color: #f9f9f9;\n}\n.shadowBoxFirm {\n    -webkit-box-shadow: 1px 4px 8px -4px rgba(0, 0, 0, 0.7);\n    box-shadow: 1px 4px 8px -4px rgba(0, 0, 0, 0.7);\n}\n.scroll {\n    margin-top: 2px !important;\n}\n}\n@media (max-width: 437px) {\n.btnFill {\n    width: 100%;\n}\n}\n.shutter-out-horizontalCompleted {\n  -webkit-transition: color 300ms;\n  transition: color 300ms;\n  position: relative;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -moz-osx-font-smoothing: grayscale;\n}\n.shutter-out-horizontalCompleted:before {\n  content: "";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #1f7532;\n  -webkit-transform: scaleX(0);\n  transform: scaleX(0);\n  -webkit-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-transition-property: transform;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition: 300ms ease-out;\n  transition: 300ms ease-out;\n}\n.shutter-out-horizontalCompleted:hover:before {\n  -webkit-transform: scaleX(1);\n  transform: scaleX(1);\n}\n.shutter-out-horizontalCompletedA {\n  -webkit-transition: color 300ms;\n  transition: color 300ms;\n  position: relative;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -moz-osx-font-smoothing: grayscale;\n}\n.shutter-out-horizontalCompletedA:before {\n  content: "";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #269930 !important;\n  -webkit-transform: scaleX(0);\n  transform: scaleX(0);\n  -webkit-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-transition-property: transform;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition: 300ms ease-out;\n  transition: 300ms ease-out;\n}\n.shutter-out-horizontalCompletedA:hover:before {\n  -webkit-transform: scaleX(1);\n  transform: scaleX(1);\n}\n.shutter-in-horizontalEdit {\n  background-color: #0063cc !important;\n  -webkit-transition: color 300ms;\n  transition: color 300ms;\n  position: relative;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -moz-osx-font-smoothing: grayscale;\n}\n.shutter-in-horizontalEdit:before {\n  content: "";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #007bff;\n  -webkit-transform: scaleX(1);\n  transform: scaleX(1);\n  -webkit-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-transition-property: transform;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition: 300ms ease-out;\n  transition: 300ms ease-out;\n}\n.shutter-in-horizontalEdit:hover:before {\n  -webkit-transform: scaleX(0);\n  transform: scaleX(0);\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfLandingPage/PfLandingPage.css"],names:[],mappings:";AACA;EACE,iBAAiB;CAClB;AACD;EACE,aAAa;CACd;AACD;EACE,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,uBAAuB;CACxB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,8BAA8B;EAC9B,oBAAoB;CACrB;AACD;EACE,wDAAwD;EACxD,gDAAgD;CACjD;AACD;EACE,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,0BAA0B;EAC1B,aAAa;CACd;AACD;EACE,iBAAiB;EACjB,mBAAmB;CACpB;AACD;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,wCAAwC;EACxC,gEAAgE;EAChE,wDAAwD;CACzD;AACD;EACE,2BAA2B;EAC3B,mBAAmB;CACpB;AACD;EACE,4BAA4B;EAC5B,oBAAoB;CACrB;AACD;EACE,iCAAiC;CAClC;AACD;EACE,gBAAgB;CACjB;AACD;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,oBAAoB;CACrB;AACD;AACA;IACI,mBAAmB;CACtB;AACD;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;IACpB,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,iBAAiB;CACpB;AACD;IACI,wBAAwB;IACxB,oBAAoB;IACpB,+BAA+B;IAC/B,qCAAqC;IACrC,kBAAkB;IAClB,oCAAoC;IACpC,4BAA4B;IAC5B,0BAA0B;CAC7B;AACD;IACI,wDAAwD;IACxD,gDAAgD;CACnD;AACD;IACI,2BAA2B;CAC9B;CACA;AACD;AACA;IACI,YAAY;CACf;CACA;AACD;EACE,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;EAC5B,mCAAmC;CACpC;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,UAAU;EACV,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;EACtB,uCAAuC;EACvC,+CAA+C;EAC/C,uCAAuC;EACvC,+BAA+B;EAC/B,kDAAkD;EAClD,mCAAmC;EACnC,2BAA2B;CAC5B;AACD;EACE,6BAA6B;EAC7B,qBAAqB;CACtB;AACD;EACE,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;EAC5B,mCAAmC;CACpC;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,UAAU;EACV,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;EACtB,uCAAuC;EACvC,+CAA+C;EAC/C,uCAAuC;EACvC,+BAA+B;EAC/B,kDAAkD;EAClD,mCAAmC;EACnC,2BAA2B;CAC5B;AACD;EACE,6BAA6B;EAC7B,qBAAqB;CACtB;AACD;EACE,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;EAC5B,mCAAmC;CACpC;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,OAAO;EACP,UAAU;EACV,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,6BAA6B;EAC7B,qBAAqB;EACrB,8BAA8B;EAC9B,sBAAsB;EACtB,uCAAuC;EACvC,+CAA+C;EAC/C,uCAAuC;EACvC,+BAA+B;EAC/B,kDAAkD;EAClD,mCAAmC;EACnC,2BAA2B;CAC5B;AACD;EACE,6BAA6B;EAC7B,qBAAqB;CACtB",file:"PfLandingPage.css",sourcesContent:['\n.scroll {\n  overflow-y: auto;\n}\n.widthTh {\n  width: 150px;\n}\n.firmName {\n  font-size: 25px;\n}\n.mBt {\n  margin-bottom: 0px;\n}\n.myText {\n  margin-left: 35px;\n}\n.myText2 {\n  margin-left: 3px;\n}\n.myText3 {\n  /* margin-left: 30px */\n}\n.myText4 {\n  margin-left: 8px;\n}\n.myText5 {\n  margin-left: 8px;\n}\n.hrLanding {\n  border-top: 2px solid #dee2e6;\n  margin-bottom: 22px;\n}\n.shadowBox {\n  -webkit-box-shadow: 1px 4px 8px -4px rgba(0, 0, 0, 0.7);\n  box-shadow: 1px 4px 8px -4px rgba(0, 0, 0, 0.7);\n}\n.scroll {\n  margin-top: 5px;\n}\n.fileOne {\n  font-size: 17px;\n  margin-top: 22px;\n  margin-bottom: 20px;\n}\n.rolForm {\n  background-color: #8cbff1;\n  color: black;\n}\n.itemBadge {\n  margin-top: -5px;\n  margin-bottom: 7px;\n}\n.animationBoxheight {\n  opacity: 1 !important;\n  display: block !important;\n  -webkit-transition: height 0.5s ease-in;\n  -webkit-transition: height 0.5s ease-in, opacity 8s ease-in-out;\n  transition: height 0.5s ease-in, opacity 8s ease-in-out;\n}\n.bounce-enter-active, .bounce-leave-active {\n  -webkit-transition: all 2s;\n  transition: all 2s;\n}\n.bounce-enter, .bounce-leave-to {\n  -webkit-transform: scale(0);\n  transform: scale(0);\n}\nh6.cscs {\n  display: inline-block !important;\n}\n.cc {\n  font-size: 16px;\n}\n.btnFill {\n  width: 135px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.divButtons {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.divButtons2 {\n  margin-top: 15px;\n  margin-bottom: 13px;\n}\n@media (max-width: 767px) {\n.contentFirm {\n    text-align: center;\n}\n.imgFirm {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.myText {\n    margin-left: 0px;\n}\n.myText2 {\n    margin-left: 0px;\n}\n.boxcontainerForm {\n    border: 2px solid black;\n    margin-bottom: 16px;\n    border-radius: 5px 5px 5px 5px;\n    font-family: "Open Sans", sans-serif;\n    font-size: medium;\n    -webkit-transition: all 0.3s linear;\n    transition: all 0.3s linear;\n    background-color: #f9f9f9;\n}\n.shadowBoxFirm {\n    -webkit-box-shadow: 1px 4px 8px -4px rgba(0, 0, 0, 0.7);\n    box-shadow: 1px 4px 8px -4px rgba(0, 0, 0, 0.7);\n}\n.scroll {\n    margin-top: 2px !important;\n}\n}\n@media (max-width: 437px) {\n.btnFill {\n    width: 100%;\n}\n}\n.shutter-out-horizontalCompleted {\n  -webkit-transition: color 300ms;\n  transition: color 300ms;\n  position: relative;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -moz-osx-font-smoothing: grayscale;\n}\n.shutter-out-horizontalCompleted:before {\n  content: "";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #1f7532;\n  -webkit-transform: scaleX(0);\n  transform: scaleX(0);\n  -webkit-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-transition-property: transform;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition: 300ms ease-out;\n  transition: 300ms ease-out;\n}\n.shutter-out-horizontalCompleted:hover:before {\n  -webkit-transform: scaleX(1);\n  transform: scaleX(1);\n}\n.shutter-out-horizontalCompletedA {\n  -webkit-transition: color 300ms;\n  transition: color 300ms;\n  position: relative;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -moz-osx-font-smoothing: grayscale;\n}\n.shutter-out-horizontalCompletedA:before {\n  content: "";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #269930 !important;\n  -webkit-transform: scaleX(0);\n  transform: scaleX(0);\n  -webkit-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-transition-property: transform;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition: 300ms ease-out;\n  transition: 300ms ease-out;\n}\n.shutter-out-horizontalCompletedA:hover:before {\n  -webkit-transform: scaleX(1);\n  transform: scaleX(1);\n}\n.shutter-in-horizontalEdit {\n  background-color: #0063cc !important;\n  -webkit-transition: color 300ms;\n  transition: color 300ms;\n  position: relative;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  -moz-osx-font-smoothing: grayscale;\n}\n.shutter-in-horizontalEdit:before {\n  content: "";\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: #007bff;\n  -webkit-transform: scaleX(1);\n  transform: scaleX(1);\n  -webkit-transform-origin: 50%;\n  transform-origin: 50%;\n  -webkit-transition-property: transform;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition: 300ms ease-out;\n  transition: 300ms ease-out;\n}\n.shutter-in-horizontalEdit:hover:before {\n  -webkit-transform: scaleX(0);\n  transform: scaleX(0);\n}\n'],sourceRoot:""}])},BbgG:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("zh-tw",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日dddd HH:mm",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(t,e){return 12===t&&(t=0),"凌晨"===e||"早上"===e||"上午"===e?t:"中午"===e?t>=11?t:t+12:"下午"===e||"晚上"===e?t+12:void 0},meridiem:function(t,e,n){var i=100*t+e;return i<600?"凌晨":i<900?"早上":i<1130?"上午":i<1230?"中午":i<1800?"下午":"晚上"},calendar:{sameDay:"[今天] LT",nextDay:"[明天] LT",nextWeek:"[下]dddd LT",lastDay:"[昨天] LT",lastWeek:"[上]dddd LT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|週)/,ordinal:function(t,e){switch(e){case"d":case"D":case"DDD":return t+"日";case"M":return t+"月";case"w":case"W":return t+"週";default:return t}},relativeTime:{future:"%s後",past:"%s前",s:"幾秒",ss:"%d 秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}})})(n("PJh5"))},BfX3:function(t,e,n){var i=n("FKWp"),a=n("SWGL"),o=n("hgbu")("species");t.exports=function(t,e){var n,r=i(t).constructor;return void 0===r||void 0==(n=i(r)[o])?e:a(n)}},Bp2f:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),n="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),i=[/^jan/i,/^feb/i,/^maart|mrt.?$/i,/^apr/i,/^mei$/i,/^jun[i.]?$/i,/^jul[i.]?$/i,/^aug/i,/^sep/i,/^okt/i,/^nov/i,/^dec/i],a=/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;t.defineLocale("nl-be",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(t,i){return t?/-MMM-/.test(i)?n[t.month()]:e[t.month()]:e},monthsRegex:a,monthsShortRegex:a,monthsStrictRegex:/^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,monthsShortStrictRegex:/^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,monthsParse:i,longMonthsParse:i,shortMonthsParse:i,weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"zo_ma_di_wo_do_vr_za".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",ss:"%d seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(t){return t+(1===t||8===t||t>=20?"ste":"de")},week:{dow:1,doy:4}})})(n("PJh5"))},C4MV:function(t,e,n){t.exports={default:n("rKx+"),__esModule:!0}},C7av:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("nn",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),weekdaysShort:"su._må._ty._on._to._fr._lau.".split("_"),weekdaysMin:"su_må_ty_on_to_fr_la".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[I dag klokka] LT",nextDay:"[I morgon klokka] LT",nextWeek:"dddd [klokka] LT",lastDay:"[I går klokka] LT",lastWeek:"[Føregåande] dddd [klokka] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s sidan",s:"nokre sekund",ss:"%d sekund",m:"eit minutt",mm:"%d minutt",h:"ein time",hh:"%d timar",d:"ein dag",dd:"%d dagar",w:"ei veke",ww:"%d veker",M:"ein månad",MM:"%d månader",y:"eit år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},C84k:function(t,e,n){var i=n("Wdy1"),a=n("uQcH")(!1);i(i.S,"Object",{values:function(t){return a(t)}})},CFqe:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("el",{monthsNominativeEl:"Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),monthsGenitiveEl:"Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),months:function(t,e){return t?"string"==typeof e&&/D/.test(e.substring(0,e.indexOf("MMMM")))?this._monthsGenitiveEl[t.month()]:this._monthsNominativeEl[t.month()]:this._monthsNominativeEl},monthsShort:"Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),weekdays:"Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),weekdaysShort:"Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),weekdaysMin:"Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),meridiem:function(t,e,n){return t>11?n?"μμ":"ΜΜ":n?"πμ":"ΠΜ"},isPM:function(t){return"μ"===(t+"").toLowerCase()[0]},meridiemParse:/[ΠΜ]\.?Μ?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendarEl:{sameDay:"[Σήμερα {}] LT",nextDay:"[Αύριο {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[Χθες {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[το προηγούμενο] dddd [{}] LT";default:return"[την προηγούμενη] dddd [{}] LT"}},sameElse:"L"},calendar:function(t,e){var n,i=this._calendarEl[t],a=e&&e.hours();return n=i,("undefined"!=typeof Function&&n instanceof Function||"[object Function]"===Object.prototype.toString.call(n))&&(i=i.apply(e)),i.replace("{}",a%12==1?"στη":"στις")},relativeTime:{future:"σε %s",past:"%s πριν",s:"λίγα δευτερόλεπτα",ss:"%d δευτερόλεπτα",m:"ένα λεπτό",mm:"%d λεπτά",h:"μία ώρα",hh:"%d ώρες",d:"μία μέρα",dd:"%d μέρες",M:"ένας μήνας",MM:"%d μήνες",y:"ένας χρόνος",yy:"%d χρόνια"},dayOfMonthOrdinalParse:/\d{1,2}η/,ordinal:"%dη",week:{dow:1,doy:4}})})(n("PJh5"))},CfkD:function(t,e,n){var i=n("O82h");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("6378cd10",i,!0,{})},CqHt:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){switch(n){case"s":return e?"хэдхэн секунд":"хэдхэн секундын";case"ss":return t+(e?" секунд":" секундын");case"m":case"mm":return t+(e?" минут":" минутын");case"h":case"hh":return t+(e?" цаг":" цагийн");case"d":case"dd":return t+(e?" өдөр":" өдрийн");case"M":case"MM":return t+(e?" сар":" сарын");case"y":case"yy":return t+(e?" жил":" жилийн");default:return t}}t.defineLocale("mn",{months:"Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар".split("_"),monthsShort:"1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар".split("_"),monthsParseExact:!0,weekdays:"Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба".split("_"),weekdaysShort:"Ням_Дав_Мяг_Лха_Пүр_Баа_Бям".split("_"),weekdaysMin:"Ня_Да_Мя_Лх_Пү_Ба_Бя".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY оны MMMMын D",LLL:"YYYY оны MMMMын D HH:mm",LLLL:"dddd, YYYY оны MMMMын D HH:mm"},meridiemParse:/ҮӨ|ҮХ/i,isPM:function(t){return"ҮХ"===t},meridiem:function(t,e,n){return t<12?"ҮӨ":"ҮХ"},calendar:{sameDay:"[Өнөөдөр] LT",nextDay:"[Маргааш] LT",nextWeek:"[Ирэх] dddd LT",lastDay:"[Өчигдөр] LT",lastWeek:"[Өнгөрсөн] dddd LT",sameElse:"L"},relativeTime:{future:"%s дараа",past:"%s өмнө",s:e,ss:e,m:e,mm:e,h:e,hh:e,d:e,dd:e,M:e,MM:e,y:e,yy:e},dayOfMonthOrdinalParse:/\d{1,2} өдөр/,ordinal:function(t,e){switch(e){case"d":case"D":case"DDD":return t+" өдөр";default:return t}}})})(n("PJh5"))},CwKP:function(t,e,n){var i=n("/YpR");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("468c6717",i,!0,{})},CwSZ:function(t,e,n){"use strict";var i=n("Zoe1"),a=n("p8xL"),o=n("XgCd"),r=Object.prototype.hasOwnProperty,s={brackets:function(t){return t+"[]"},comma:"comma",indices:function(t,e){return t+"["+e+"]"},repeat:function(t){return t}},l=Array.isArray,d=Array.prototype.push,c=function(t,e){d.apply(t,l(e)?e:[e])},h=Date.prototype.toISOString,u=o.default,m={addQueryPrefix:!1,allowDots:!1,charset:"utf-8",charsetSentinel:!1,delimiter:"&",encode:!0,encoder:a.encode,encodeValuesOnly:!1,format:u,formatter:o.formatters[u],indices:!1,serializeDate:function(t){return h.call(t)},skipNulls:!1,strictNullHandling:!1},f=function t(e,n,o,r,s,d,h,u,f,p,_,A,b,x,g){var v,C=e;if(g.has(e))throw new RangeError("Cyclic object value");if("function"==typeof h?C=h(n,C):C instanceof Date?C=p(C):"comma"===o&&l(C)&&(C=a.maybeMap(C,function(t){return t instanceof Date?p(t):t})),null===C){if(r)return d&&!b?d(n,m.encoder,x,"key",_):n;C=""}if("string"==typeof(v=C)||"number"==typeof v||"boolean"==typeof v||"symbol"==typeof v||"bigint"==typeof v||a.isBuffer(C))return d?[A(b?n:d(n,m.encoder,x,"key",_))+"="+A(d(C,m.encoder,x,"value",_))]:[A(n)+"="+A(String(C))];var y,w=[];if(void 0===C)return w;if("comma"===o&&l(C))y=[{value:C.length>0?C.join(",")||null:void 0}];else if(l(h))y=h;else{var B=Object.keys(C);y=u?B.sort(u):B}for(var k=0;k<y.length;++k){var E=y[k],I="object"==typeof E&&void 0!==E.value?E.value:C[E];if(!s||null!==I){var D=l(C)?"function"==typeof o?o(n,E):n:n+(f?"."+E:"["+E+"]");g.set(e,!0);var S=i();c(w,t(I,D,o,r,s,d,h,u,f,p,_,A,b,x,S))}}return w};t.exports=function(t,e){var n,a=t,d=function(t){if(!t)return m;if(null!==t.encoder&&void 0!==t.encoder&&"function"!=typeof t.encoder)throw new TypeError("Encoder has to be a function.");var e=t.charset||m.charset;if(void 0!==t.charset&&"utf-8"!==t.charset&&"iso-8859-1"!==t.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var n=o.default;if(void 0!==t.format){if(!r.call(o.formatters,t.format))throw new TypeError("Unknown format option provided.");n=t.format}var i=o.formatters[n],a=m.filter;return("function"==typeof t.filter||l(t.filter))&&(a=t.filter),{addQueryPrefix:"boolean"==typeof t.addQueryPrefix?t.addQueryPrefix:m.addQueryPrefix,allowDots:void 0===t.allowDots?m.allowDots:!!t.allowDots,charset:e,charsetSentinel:"boolean"==typeof t.charsetSentinel?t.charsetSentinel:m.charsetSentinel,delimiter:void 0===t.delimiter?m.delimiter:t.delimiter,encode:"boolean"==typeof t.encode?t.encode:m.encode,encoder:"function"==typeof t.encoder?t.encoder:m.encoder,encodeValuesOnly:"boolean"==typeof t.encodeValuesOnly?t.encodeValuesOnly:m.encodeValuesOnly,filter:a,format:n,formatter:i,serializeDate:"function"==typeof t.serializeDate?t.serializeDate:m.serializeDate,skipNulls:"boolean"==typeof t.skipNulls?t.skipNulls:m.skipNulls,sort:"function"==typeof t.sort?t.sort:null,strictNullHandling:"boolean"==typeof t.strictNullHandling?t.strictNullHandling:m.strictNullHandling}}(e);"function"==typeof d.filter?a=(0,d.filter)("",a):l(d.filter)&&(n=d.filter);var h,u=[];if("object"!=typeof a||null===a)return"";h=e&&e.arrayFormat in s?e.arrayFormat:e&&"indices"in e?e.indices?"indices":"repeat":"indices";var p=s[h];n||(n=Object.keys(a)),d.sort&&n.sort(d.sort);for(var _=i(),A=0;A<n.length;++A){var b=n[A];d.skipNulls&&null===a[b]||c(u,f(a[b],b,p,d.strictNullHandling,d.skipNulls,d.encode?d.encoder:null,d.filter,d.sort,d.allowDots,d.serializeDate,d.format,d.formatter,d.encodeValuesOnly,d.charset,_))}var x=u.join(d.delimiter),g=!0===d.addQueryPrefix?"?":"";return d.charsetSentinel&&("iso-8859-1"===d.charset?g+="utf8=%26%2310003%3B&":g+="utf8=%E2%9C%93&"),x.length>0?g+x:""}},D10a:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-31d7a0b6] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-31d7a0b6]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-31d7a0b6] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-31d7a0b6] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-31d7a0b6] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-31d7a0b6] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-31d7a0b6] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-31d7a0b6] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-31d7a0b6] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-31d7a0b6] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-31d7a0b6] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-31d7a0b6] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-31d7a0b6] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-31d7a0b6] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-31d7a0b6] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-31d7a0b6] {\n  margin-right: 0px;\n}\n.newItem[data-v-31d7a0b6] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-31d7a0b6] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-31d7a0b6] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-31d7a0b6] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-31d7a0b6] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-31d7a0b6] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-31d7a0b6] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-31d7a0b6] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-31d7a0b6] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-31d7a0b6] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-31d7a0b6]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-31d7a0b6] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-31d7a0b6] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-31d7a0b6] {\n  color: red;\n}\n.showMore[data-v-31d7a0b6]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-31d7a0b6] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-31d7a0b6] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-31d7a0b6] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-31d7a0b6 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-31d7a0b6 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-31d7a0b6] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-31d7a0b6 3s infinite;\n  animation: bit-data-v-31d7a0b6 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-31d7a0b6] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-31d7a0b6]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-31d7a0b6]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-31d7a0b6]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-31d7a0b6]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-31d7a0b6]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-31d7a0b6]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-31d7a0b6] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-31d7a0b6]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-31d7a0b6] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-31d7a0b6] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-31d7a0b6] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-31d7a0b6] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-31d7a0b6] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-31d7a0b6] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-31d7a0b6] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-31d7a0b6] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-31d7a0b6] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-31d7a0b6] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-31d7a0b6] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-31d7a0b6] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-31d7a0b6] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-31d7a0b6] {\n  margin-right: 0px;\n}\n.newItem[data-v-31d7a0b6] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-31d7a0b6] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-31d7a0b6] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-31d7a0b6] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-31d7a0b6] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-31d7a0b6] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-31d7a0b6] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-31d7a0b6] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-31d7a0b6] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-31d7a0b6] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-31d7a0b6]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-31d7a0b6] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-31d7a0b6] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-31d7a0b6] {\n  color: red;\n}\n.showMore[data-v-31d7a0b6]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-31d7a0b6] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-31d7a0b6] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-31d7a0b6] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-31d7a0b6 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-31d7a0b6 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-31d7a0b6] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-31d7a0b6 3s infinite;\n  animation: bit-data-v-31d7a0b6 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-31d7a0b6] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-31d7a0b6]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-31d7a0b6]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-31d7a0b6]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-31d7a0b6]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-31d7a0b6]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-31d7a0b6]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},"D4/P":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-488344bb] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-488344bb]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-488344bb] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-488344bb] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-488344bb] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-488344bb] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-488344bb] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-488344bb] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-488344bb] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-488344bb] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-488344bb] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-488344bb] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-488344bb] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-488344bb] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-488344bb] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-488344bb] {\n  margin-right: 0px;\n}\n.newItem[data-v-488344bb] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-488344bb] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-488344bb] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-488344bb] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-488344bb] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-488344bb] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-488344bb] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-488344bb] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-488344bb] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-488344bb] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-488344bb]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-488344bb] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-488344bb] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-488344bb] {\n  color: red;\n}\n.showMore[data-v-488344bb]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-488344bb] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-488344bb] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-488344bb] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-488344bb {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-488344bb {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-488344bb] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-488344bb 3s infinite;\n  animation: bit-data-v-488344bb 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-488344bb] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-488344bb]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-488344bb]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-488344bb]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-488344bb]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-488344bb]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-488344bb]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-488344bb] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-488344bb]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-488344bb] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-488344bb] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-488344bb] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-488344bb] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-488344bb] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-488344bb] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-488344bb] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-488344bb] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-488344bb] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-488344bb] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-488344bb] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-488344bb] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-488344bb] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-488344bb] {\n  margin-right: 0px;\n}\n.newItem[data-v-488344bb] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-488344bb] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-488344bb] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-488344bb] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-488344bb] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-488344bb] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-488344bb] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-488344bb] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-488344bb] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-488344bb] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-488344bb]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-488344bb] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-488344bb] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-488344bb] {\n  color: red;\n}\n.showMore[data-v-488344bb]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-488344bb] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-488344bb] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-488344bb] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-488344bb {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-488344bb {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-488344bb] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-488344bb 3s infinite;\n  animation: bit-data-v-488344bb 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-488344bb] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-488344bb]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-488344bb]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-488344bb]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-488344bb]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-488344bb]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-488344bb]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},DDCP:function(t,e,n){"use strict";var i=n("p8xL"),a=Object.prototype.hasOwnProperty,o=Array.isArray,r={allowDots:!1,allowPrototypes:!1,allowSparse:!1,arrayLimit:20,charset:"utf-8",charsetSentinel:!1,comma:!1,decoder:i.decode,delimiter:"&",depth:5,ignoreQueryPrefix:!1,interpretNumericEntities:!1,parameterLimit:1e3,parseArrays:!0,plainObjects:!1,strictNullHandling:!1},s=function(t){return t.replace(/&#(\d+);/g,function(t,e){return String.fromCharCode(parseInt(e,10))})},l=function(t,e){return t&&"string"==typeof t&&e.comma&&t.indexOf(",")>-1?t.split(","):t},d=function(t,e,n,i){if(t){var o=n.allowDots?t.replace(/\.([^.[]+)/g,"[$1]"):t,r=/(\[[^[\]]*])/g,s=n.depth>0&&/(\[[^[\]]*])/.exec(o),d=s?o.slice(0,s.index):o,c=[];if(d){if(!n.plainObjects&&a.call(Object.prototype,d)&&!n.allowPrototypes)return;c.push(d)}for(var h=0;n.depth>0&&null!==(s=r.exec(o))&&h<n.depth;){if(h+=1,!n.plainObjects&&a.call(Object.prototype,s[1].slice(1,-1))&&!n.allowPrototypes)return;c.push(s[1])}return s&&c.push("["+o.slice(s.index)+"]"),function(t,e,n,i){for(var a=i?e:l(e,n),o=t.length-1;o>=0;--o){var r,s=t[o];if("[]"===s&&n.parseArrays)r=[].concat(a);else{r=n.plainObjects?Object.create(null):{};var d="["===s.charAt(0)&&"]"===s.charAt(s.length-1)?s.slice(1,-1):s,c=parseInt(d,10);n.parseArrays||""!==d?!isNaN(c)&&s!==d&&String(c)===d&&c>=0&&n.parseArrays&&c<=n.arrayLimit?(r=[])[c]=a:r[d]=a:r={0:a}}a=r}return a}(c,e,n,i)}};t.exports=function(t,e){var n=function(t){if(!t)return r;if(null!==t.decoder&&void 0!==t.decoder&&"function"!=typeof t.decoder)throw new TypeError("Decoder has to be a function.");if(void 0!==t.charset&&"utf-8"!==t.charset&&"iso-8859-1"!==t.charset)throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");var e=void 0===t.charset?r.charset:t.charset;return{allowDots:void 0===t.allowDots?r.allowDots:!!t.allowDots,allowPrototypes:"boolean"==typeof t.allowPrototypes?t.allowPrototypes:r.allowPrototypes,allowSparse:"boolean"==typeof t.allowSparse?t.allowSparse:r.allowSparse,arrayLimit:"number"==typeof t.arrayLimit?t.arrayLimit:r.arrayLimit,charset:e,charsetSentinel:"boolean"==typeof t.charsetSentinel?t.charsetSentinel:r.charsetSentinel,comma:"boolean"==typeof t.comma?t.comma:r.comma,decoder:"function"==typeof t.decoder?t.decoder:r.decoder,delimiter:"string"==typeof t.delimiter||i.isRegExp(t.delimiter)?t.delimiter:r.delimiter,depth:"number"==typeof t.depth||!1===t.depth?+t.depth:r.depth,ignoreQueryPrefix:!0===t.ignoreQueryPrefix,interpretNumericEntities:"boolean"==typeof t.interpretNumericEntities?t.interpretNumericEntities:r.interpretNumericEntities,parameterLimit:"number"==typeof t.parameterLimit?t.parameterLimit:r.parameterLimit,parseArrays:!1!==t.parseArrays,plainObjects:"boolean"==typeof t.plainObjects?t.plainObjects:r.plainObjects,strictNullHandling:"boolean"==typeof t.strictNullHandling?t.strictNullHandling:r.strictNullHandling}}(e);if(""===t||null===t||void 0===t)return n.plainObjects?Object.create(null):{};for(var c="string"==typeof t?function(t,e){var n,d={},c=e.ignoreQueryPrefix?t.replace(/^\?/,""):t,h=e.parameterLimit===1/0?void 0:e.parameterLimit,u=c.split(e.delimiter,h),m=-1,f=e.charset;if(e.charsetSentinel)for(n=0;n<u.length;++n)0===u[n].indexOf("utf8=")&&("utf8=%E2%9C%93"===u[n]?f="utf-8":"utf8=%26%2310003%3B"===u[n]&&(f="iso-8859-1"),m=n,n=u.length);for(n=0;n<u.length;++n)if(n!==m){var p,_,A=u[n],b=A.indexOf("]="),x=-1===b?A.indexOf("="):b+1;-1===x?(p=e.decoder(A,r.decoder,f,"key"),_=e.strictNullHandling?null:""):(p=e.decoder(A.slice(0,x),r.decoder,f,"key"),_=i.maybeMap(l(A.slice(x+1),e),function(t){return e.decoder(t,r.decoder,f,"value")})),_&&e.interpretNumericEntities&&"iso-8859-1"===f&&(_=s(_)),A.indexOf("[]=")>-1&&(_=o(_)?[_]:_),a.call(d,p)?d[p]=i.combine(d[p],_):d[p]=_}return d}(t,n):t,h=n.plainObjects?Object.create(null):{},u=Object.keys(c),m=0;m<u.length;++m){var f=u[m],p=d(f,c[f],n,"string"==typeof t);h=i.merge(h,p,n)}return!0===n.allowSparse?h:i.compact(h)}},DEnR:function(t,e,n){var i=n("8JLF");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("b189a7ac",i,!0,{})},DH7i:function(t,e,n){var i=n("/FHD");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("5e472cf2",i,!0,{})},DOkx:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){var a={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[t+" Tage",t+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[t+" Monate",t+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[t+" Jahre",t+" Jahren"]};return e?a[n][0]:a[n][1]}t.defineLocale("de",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:e,mm:"%d Minuten",h:e,hh:"%d Stunden",d:e,dd:e,w:e,ww:"%d Wochen",M:e,MM:e,y:e,yy:e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},DQCr:function(t,e,n){"use strict";var i=n("cGG2");function a(t){return encodeURIComponent(t).replace(/%40/gi,"@").replace(/%3A/gi,":").replace(/%24/g,"$").replace(/%2C/gi,",").replace(/%20/g,"+").replace(/%5B/gi,"[").replace(/%5D/gi,"]")}t.exports=function(t,e,n){if(!e)return t;var o;if(n)o=n(e);else if(i.isURLSearchParams(e))o=e.toString();else{var r=[];i.forEach(e,function(t,e){null!==t&&void 0!==t&&(i.isArray(t)?e+="[]":t=[t],i.forEach(t,function(t){i.isDate(t)?t=t.toISOString():i.isObject(t)&&(t=JSON.stringify(t)),r.push(a(e)+"="+a(t))}))}),o=r.join("&")}return o&&(t+=(-1===t.indexOf("?")?"?":"&")+o),t}},DSXN:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("sw",{months:"Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),weekdays:"Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split("_"),weekdaysShort:"Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),weekdaysMin:"J2_J3_J4_J5_Al_Ij_J1".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"hh:mm A",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[leo saa] LT",nextDay:"[kesho saa] LT",nextWeek:"[wiki ijayo] dddd [saat] LT",lastDay:"[jana] LT",lastWeek:"[wiki iliyopita] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s baadaye",past:"tokea %s",s:"hivi punde",ss:"sekunde %d",m:"dakika moja",mm:"dakika %d",h:"saa limoja",hh:"masaa %d",d:"siku moja",dd:"siku %d",M:"mwezi mmoja",MM:"miezi %d",y:"mwaka mmoja",yy:"miaka %d"},week:{dow:1,doy:7}})})(n("PJh5"))},DuR2:function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},DvwR:function(t,e,n){var i=n("x//u"),a=n("ksFB"),o=n("PbQV")(!1),r=n("+SdG")("IE_PROTO");t.exports=function(t,e){var n,s=a(t),l=0,d=[];for(n in s)n!=r&&i(s,n)&&d.push(n);for(;e.length>l;)i(s,n=e[l++])&&(~o(d,n)||d.push(n));return d}},EFoD:function(t,e,n){"use strict";var i=n("YjQv"),a=n("iANj"),o=n("GCs6"),r=n("qs+f"),s=n("hgbu")("species");t.exports=function(t){var e="function"==typeof a[t]?a[t]:i[t];r&&e&&!e[s]&&o.f(e,s,{configurable:!0,get:function(){return this}})}},ETHv:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},n={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"},i=[/^जन/i,/^फ़र|फर/i,/^मार्च/i,/^अप्रै/i,/^मई/i,/^जून/i,/^जुल/i,/^अग/i,/^सितं|सित/i,/^अक्टू/i,/^नव|नवं/i,/^दिसं|दिस/i];t.defineLocale("hi",{months:{format:"जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),standalone:"जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर".split("_")},monthsShort:"जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),weekdays:"रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm बजे",LTS:"A h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm बजे",LLLL:"dddd, D MMMM YYYY, A h:mm बजे"},monthsParse:i,longMonthsParse:i,shortMonthsParse:[/^जन/i,/^फ़र/i,/^मार्च/i,/^अप्रै/i,/^मई/i,/^जून/i,/^जुल/i,/^अग/i,/^सित/i,/^अक्टू/i,/^नव/i,/^दिस/i],monthsRegex:/^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,monthsShortRegex:/^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,monthsStrictRegex:/^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,monthsShortStrictRegex:/^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,calendar:{sameDay:"[आज] LT",nextDay:"[कल] LT",nextWeek:"dddd, LT",lastDay:"[कल] LT",lastWeek:"[पिछले] dddd, LT",sameElse:"L"},relativeTime:{future:"%s में",past:"%s पहले",s:"कुछ ही क्षण",ss:"%d सेकंड",m:"एक मिनट",mm:"%d मिनट",h:"एक घंटा",hh:"%d घंटे",d:"एक दिन",dd:"%d दिन",M:"एक महीने",MM:"%d महीने",y:"एक वर्ष",yy:"%d वर्ष"},preparse:function(t){return t.replace(/[१२३४५६७८९०]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/रात|सुबह|दोपहर|शाम/,meridiemHour:function(t,e){return 12===t&&(t=0),"रात"===e?t<4?t:t+12:"सुबह"===e?t:"दोपहर"===e?t>=10?t:t+12:"शाम"===e?t+12:void 0},meridiem:function(t,e,n){return t<4?"रात":t<10?"सुबह":t<17?"दोपहर":t<20?"शाम":"रात"},week:{dow:0,doy:6}})})(n("PJh5"))},EcXd:function(t,e,n){var i=n("tsdW");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("dcccbc50",i,!0,{})},Eif7:function(t,e,n){n("JyN8"),t.exports=n("iANj").Object.assign},ErGL:function(t,e,n){var i=n("GyD7");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("70c0cc0c",i,!0,{})},EtYn:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-488344bb]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-488344bb]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-488344bb]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-488344bb]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-488344bb] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-488344bb]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-488344bb] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-488344bb]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-488344bb]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-488344bb]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-488344bb]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-488344bb]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-488344bb]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-488344bb] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-488344bb]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-488344bb] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-488344bb]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-488344bb]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},"F+2e":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"၁",2:"၂",3:"၃",4:"၄",5:"၅",6:"၆",7:"၇",8:"၈",9:"၉",0:"၀"},n={"၁":"1","၂":"2","၃":"3","၄":"4","၅":"5","၆":"6","၇":"7","၈":"8","၉":"9","၀":"0"};t.defineLocale("my",{months:"ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ".split("_"),monthsShort:"ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ".split("_"),weekdays:"တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ".split("_"),weekdaysShort:"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),weekdaysMin:"နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[ယနေ.] LT [မှာ]",nextDay:"[မနက်ဖြန်] LT [မှာ]",nextWeek:"dddd LT [မှာ]",lastDay:"[မနေ.က] LT [မှာ]",lastWeek:"[ပြီးခဲ့သော] dddd LT [မှာ]",sameElse:"L"},relativeTime:{future:"လာမည့် %s မှာ",past:"လွန်ခဲ့သော %s က",s:"စက္ကန်.အနည်းငယ်",ss:"%d စက္ကန့်",m:"တစ်မိနစ်",mm:"%d မိနစ်",h:"တစ်နာရီ",hh:"%d နာရီ",d:"တစ်ရက်",dd:"%d ရက်",M:"တစ်လ",MM:"%d လ",y:"တစ်နှစ်",yy:"%d နှစ်"},preparse:function(t){return t.replace(/[၁၂၃၄၅၆၇၈၉၀]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},week:{dow:1,doy:4}})})(n("PJh5"))},F90K:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.ImmigrationConsiderationsPT {\n  padding-top: 25px;\n}\n.ImmigrationConsiderationsMB {\n  margin-bottom: -6px;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfCriminalHistory/PfCrime/PfCrime.css"],names:[],mappings:";AACA;EACE,kBAAkB;CACnB;AACD;EACE,oBAAoB;CACrB",file:"PfCrime.css",sourcesContent:["\n.ImmigrationConsiderationsPT {\n  padding-top: 25px;\n}\n.ImmigrationConsiderationsMB {\n  margin-bottom: -6px;\n}\n"],sourceRoot:""}])},FHqv:function(t,e,n){var i=n("NZra"),a=n("hgbu")("toStringTag"),o="Arguments"==i(function(){return arguments}());t.exports=function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),a))?n:o?i(e):"Object"==(r=i(e))&&"function"==typeof e.callee?"Arguments":r}},FKWp:function(t,e,n){var i=n("8ANE");t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},FKXc:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),weekdaysShort:"dom_lun_mar_mer_gio_ven_sab".split("_"),weekdaysMin:"do_lu_ma_me_gi_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:function(){return"[Oggi a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"},nextDay:function(){return"[Domani a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"},nextWeek:function(){return"dddd [a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"},lastDay:function(){return"[Ieri a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"},lastWeek:function(){switch(this.day()){case 0:return"[La scorsa] dddd [a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT";default:return"[Lo scorso] dddd [a"+(this.hours()>1?"lle ":0===this.hours()?" ":"ll'")+"]LT"}},sameElse:"L"},relativeTime:{future:"tra %s",past:"%s fa",s:"alcuni secondi",ss:"%d secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",w:"una settimana",ww:"%d settimane",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})(n("PJh5"))},FLNZ:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfAddress.css",sourceRoot:""}])},FRPF:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("tzm",{months:"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),monthsShort:"ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split("_"),weekdays:"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),weekdaysShort:"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),weekdaysMin:"ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[ⴰⵙⴷⵅ ⴴ] LT",nextDay:"[ⴰⵙⴽⴰ ⴴ] LT",nextWeek:"dddd [ⴴ] LT",lastDay:"[ⴰⵚⴰⵏⵜ ⴴ] LT",lastWeek:"dddd [ⴴ] LT",sameElse:"L"},relativeTime:{future:"ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s",past:"ⵢⴰⵏ %s",s:"ⵉⵎⵉⴽ",ss:"%d ⵉⵎⵉⴽ",m:"ⵎⵉⵏⵓⴺ",mm:"%d ⵎⵉⵏⵓⴺ",h:"ⵙⴰⵄⴰ",hh:"%d ⵜⴰⵙⵙⴰⵄⵉⵏ",d:"ⴰⵙⵙ",dd:"%d oⵙⵙⴰⵏ",M:"ⴰⵢoⵓⵔ",MM:"%d ⵉⵢⵢⵉⵔⵏ",y:"ⴰⵙⴳⴰⵙ",yy:"%d ⵉⵙⴳⴰⵙⵏ"},week:{dow:6,doy:12}})})(n("PJh5"))},"FZ+f":function(t,e){t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var n=function(t,e){var n=t[1]||"",i=t[3];if(!i)return n;if(e&&"function"==typeof btoa){var a=(r=i,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */"),o=i.sources.map(function(t){return"/*# sourceURL="+i.sourceRoot+t+" */"});return[n].concat(o).concat([a]).join("\n")}var r;return[n].join("\n")}(e,t);return e[2]?"@media "+e[2]+"{"+n+"}":n}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var i={},a=0;a<this.length;a++){var o=this[a][0];"number"==typeof o&&(i[o]=!0)}for(a=0;a<t.length;a++){var r=t[a];"number"==typeof r[0]&&i[r[0]]||(n&&!r[2]?r[2]=n:n&&(r[2]="("+r[2]+") and ("+n+")"),e.push(r))}},e}},Fa60:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfMarriageHistory.css",sourceRoot:""}])},FbSQ:function(t,e){t.exports="data:image/gif;base64,R0lGODlh3gAJAKECAMzMzPPz8////////yH5BAEKAAMALAAAAADeAAkAAAJZhI+py+0PUxC02hqi3rz7Dw3iSJbmiabqypbAdF1ZS9f2jef6zvfqG8MAfMSi8YhM7oCxmfIJjUqnP5iQis1qtzmmwMkNi8daIJiMTquJr+H6DY+33PK6rgAAOw=="},FlzV:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),monthsParseExact:!0,weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"sø._ma._ti._on._to._fr._lø.".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] HH:mm",LLLL:"dddd D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"noen sekunder",ss:"%d sekunder",m:"ett minutt",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dager",w:"en uke",ww:"%d uker",M:"en måned",MM:"%d måneder",y:"ett år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},FpGi:function(t,e,n){var i=n("fVkZ");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("55e7b85f",i,!0,{})},Fpqq:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),weekdaysShort:"sön_mån_tis_ons_tor_fre_lör".split("_"),weekdaysMin:"sö_må_ti_on_to_fr_lö".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [kl.] HH:mm",LLLL:"dddd D MMMM YYYY [kl.] HH:mm",lll:"D MMM YYYY HH:mm",llll:"ddd D MMM YYYY HH:mm"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Igår] LT",nextWeek:"[På] dddd LT",lastWeek:"[I] dddd[s] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"för %s sedan",s:"några sekunder",ss:"%d sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en månad",MM:"%d månader",y:"ett år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}(\:e|\:a)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?":e":1===e?":a":2===e?":a":":e")},week:{dow:1,doy:4}})})(n("PJh5"))},Frex:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){var a={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[t+" Tage",t+" Tagen"],w:["eine Woche","einer Woche"],M:["ein Monat","einem Monat"],MM:[t+" Monate",t+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[t+" Jahre",t+" Jahren"]};return e?a[n][0]:a[n][1]}t.defineLocale("de-ch",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},calendar:{sameDay:"[heute um] LT [Uhr]",sameElse:"L",nextDay:"[morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",ss:"%d Sekunden",m:e,mm:"%d Minuten",h:e,hh:"%d Stunden",d:e,dd:e,w:e,ww:"%d Wochen",M:e,MM:e,y:e,yy:e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},FtD3:function(t,e,n){"use strict";var i=n("t8qj");t.exports=function(t,e,n,a,o){var r=new Error(t);return i(r,e,n,a,o)}},FuaP:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("gl",{months:"xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro".split("_"),monthsShort:"xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"domingo_luns_martes_mércores_xoves_venres_sábado".split("_"),weekdaysShort:"dom._lun._mar._mér._xov._ven._sáb.".split("_"),weekdaysMin:"do_lu_ma_mé_xo_ve_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoxe "+(1!==this.hours()?"ás":"á")+"] LT"},nextDay:function(){return"[mañá "+(1!==this.hours()?"ás":"á")+"] LT"},nextWeek:function(){return"dddd ["+(1!==this.hours()?"ás":"a")+"] LT"},lastDay:function(){return"[onte "+(1!==this.hours()?"á":"a")+"] LT"},lastWeek:function(){return"[o] dddd [pasado "+(1!==this.hours()?"ás":"a")+"] LT"},sameElse:"L"},relativeTime:{future:function(t){return 0===t.indexOf("un")?"n"+t:"en "+t},past:"hai %s",s:"uns segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"unha hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})(n("PJh5"))},"G++c":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ms-my",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(t,e){return 12===t&&(t=0),"pagi"===e?t:"tengahari"===e?t>=11?t:t+12:"petang"===e||"malam"===e?t+12:void 0},meridiem:function(t,e,n){return t<11?"pagi":t<15?"tengahari":t<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})})(n("PJh5"))},GCs6:function(t,e,n){var i=n("FKWp"),a=n("LocR"),o=n("9MbE"),r=Object.defineProperty;e.f=n("qs+f")?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),a)try{return r(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},GHBc:function(t,e,n){"use strict";var i=n("cGG2");t.exports=i.isStandardBrowserEnv()?function(){var t,e=/(msie|trident)/i.test(navigator.userAgent),n=document.createElement("a");function a(t){var i=t;return e&&(n.setAttribute("href",i),i=n.href),n.setAttribute("href",i),{href:n.href,protocol:n.protocol?n.protocol.replace(/:$/,""):"",host:n.host,search:n.search?n.search.replace(/^\?/,""):"",hash:n.hash?n.hash.replace(/^#/,""):"",hostname:n.hostname,port:n.port,pathname:"/"===n.pathname.charAt(0)?n.pathname:"/"+n.pathname}}return t=a(window.location.href),function(e){var n=i.isString(e)?a(e):e;return n.protocol===t.protocol&&n.host===t.host}}():function(){return!0}},GKAa:function(t,e,n){var i=n("VdPK");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("2bb1b776",i,!0,{})},"GNW+":function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAJAIAAAP///////yH5BAEKAAEALAAAAAAGAAkAAAINDIIGl8vokmJxwiVfKAA7"},GhAV:function(t,e,n){var i=n("W6Rd"),a=Math.min;t.exports=function(t){return t>0?a(i(t),9007199254740991):0}},GmwO:function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},GrS7:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("hy-am",{months:{format:"հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի".split("_"),standalone:"հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր".split("_")},monthsShort:"հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ".split("_"),weekdays:"կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ".split("_"),weekdaysShort:"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),weekdaysMin:"կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY թ.",LLL:"D MMMM YYYY թ., HH:mm",LLLL:"dddd, D MMMM YYYY թ., HH:mm"},calendar:{sameDay:"[այսօր] LT",nextDay:"[վաղը] LT",lastDay:"[երեկ] LT",nextWeek:function(){return"dddd [օրը ժամը] LT"},lastWeek:function(){return"[անցած] dddd [օրը ժամը] LT"},sameElse:"L"},relativeTime:{future:"%s հետո",past:"%s առաջ",s:"մի քանի վայրկյան",ss:"%d վայրկյան",m:"րոպե",mm:"%d րոպե",h:"ժամ",hh:"%d ժամ",d:"օր",dd:"%d օր",M:"ամիս",MM:"%d ամիս",y:"տարի",yy:"%d տարի"},meridiemParse:/գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,isPM:function(t){return/^(ցերեկվա|երեկոյան)$/.test(t)},meridiem:function(t){return t<4?"գիշերվա":t<12?"առավոտվա":t<17?"ցերեկվա":"երեկոյան"},dayOfMonthOrdinalParse:/\d{1,2}|\d{1,2}-(ին|րդ)/,ordinal:function(t,e){switch(e){case"DDD":case"w":case"W":case"DDDo":return 1===t?t+"-ին":t+"-րդ";default:return t}},week:{dow:1,doy:7}})})(n("PJh5"))},GyD7:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-665854a0] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-665854a0]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-665854a0] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-665854a0] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-665854a0] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-665854a0] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-665854a0] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-665854a0] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-665854a0] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-665854a0] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-665854a0] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-665854a0] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-665854a0] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-665854a0] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-665854a0] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-665854a0] {\n  margin-right: 0px;\n}\n.newItem[data-v-665854a0] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-665854a0] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-665854a0] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-665854a0] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-665854a0] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-665854a0] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-665854a0] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-665854a0] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-665854a0] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-665854a0] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-665854a0]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-665854a0] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-665854a0] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-665854a0] {\n  color: red;\n}\n.showMore[data-v-665854a0]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-665854a0] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-665854a0] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-665854a0] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-665854a0 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-665854a0 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-665854a0] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-665854a0 3s infinite;\n  animation: bit-data-v-665854a0 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-665854a0] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-665854a0]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-665854a0]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-665854a0]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-665854a0]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-665854a0]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-665854a0]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-665854a0] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-665854a0]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-665854a0] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-665854a0] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-665854a0] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-665854a0] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-665854a0] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-665854a0] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-665854a0] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-665854a0] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-665854a0] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-665854a0] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-665854a0] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-665854a0] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-665854a0] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-665854a0] {\n  margin-right: 0px;\n}\n.newItem[data-v-665854a0] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-665854a0] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-665854a0] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-665854a0] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-665854a0] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-665854a0] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-665854a0] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-665854a0] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-665854a0] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-665854a0] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-665854a0]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-665854a0] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-665854a0] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-665854a0] {\n  color: red;\n}\n.showMore[data-v-665854a0]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-665854a0] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-665854a0] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-665854a0] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-665854a0 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-665854a0 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-665854a0] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-665854a0 3s infinite;\n  animation: bit-data-v-665854a0 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-665854a0] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-665854a0]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-665854a0]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-665854a0]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-665854a0]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-665854a0]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-665854a0]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},GybJ:function(t,e,n){var i="function"==typeof Map&&Map.prototype,a=Object.getOwnPropertyDescriptor&&i?Object.getOwnPropertyDescriptor(Map.prototype,"size"):null,o=i&&a&&"function"==typeof a.get?a.get:null,r=i&&Map.prototype.forEach,s="function"==typeof Set&&Set.prototype,l=Object.getOwnPropertyDescriptor&&s?Object.getOwnPropertyDescriptor(Set.prototype,"size"):null,d=s&&l&&"function"==typeof l.get?l.get:null,c=s&&Set.prototype.forEach,h="function"==typeof WeakMap&&WeakMap.prototype?WeakMap.prototype.has:null,u="function"==typeof WeakSet&&WeakSet.prototype?WeakSet.prototype.has:null,m="function"==typeof WeakRef&&WeakRef.prototype?WeakRef.prototype.deref:null,f=Boolean.prototype.valueOf,p=Object.prototype.toString,_=Function.prototype.toString,A=String.prototype.match,b="function"==typeof BigInt?BigInt.prototype.valueOf:null,x=Object.getOwnPropertySymbols,g="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?Symbol.prototype.toString:null,v="function"==typeof Symbol&&"object"==typeof Symbol.iterator,C=Object.prototype.propertyIsEnumerable,y=("function"==typeof Reflect?Reflect.getPrototypeOf:Object.getPrototypeOf)||([].__proto__===Array.prototype?function(t){return t.__proto__}:null),w=n(0).custom,B=w&&S(w)?w:null,k="function"==typeof Symbol&&void 0!==Symbol.toStringTag?Symbol.toStringTag:null;function E(t,e,n){var i="double"===(n.quoteStyle||e)?'"':"'";return i+t+i}function I(t){return String(t).replace(/"/g,"&quot;")}function D(t){return!("[object Array]"!==O(t)||k&&"object"==typeof t&&k in t)}function S(t){if(v)return t&&"object"==typeof t&&t instanceof Symbol;if("symbol"==typeof t)return!0;if(!t||"object"!=typeof t||!g)return!1;try{return g.call(t),!0}catch(t){}return!1}t.exports=function t(e,n,i,a){var s=n||{};if(M(s,"quoteStyle")&&"single"!==s.quoteStyle&&"double"!==s.quoteStyle)throw new TypeError('option "quoteStyle" must be "single" or "double"');if(M(s,"maxStringLength")&&("number"==typeof s.maxStringLength?s.maxStringLength<0&&s.maxStringLength!==1/0:null!==s.maxStringLength))throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');var l=!M(s,"customInspect")||s.customInspect;if("boolean"!=typeof l&&"symbol"!==l)throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");if(M(s,"indent")&&null!==s.indent&&"\t"!==s.indent&&!(parseInt(s.indent,10)===s.indent&&s.indent>0))throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');if(void 0===e)return"undefined";if(null===e)return"null";if("boolean"==typeof e)return e?"true":"false";if("string"==typeof e)return function t(e,n){if(e.length>n.maxStringLength){var i=e.length-n.maxStringLength,a="... "+i+" more character"+(i>1?"s":"");return t(e.slice(0,n.maxStringLength),n)+a}var o=e.replace(/(['\\])/g,"\\$1").replace(/[\x00-\x1f]/g,L);return E(o,"single",n)}(e,s);if("number"==typeof e)return 0===e?1/0/e>0?"0":"-0":String(e);if("bigint"==typeof e)return String(e)+"n";var p=void 0===s.depth?5:s.depth;if(void 0===i&&(i=0),i>=p&&p>0&&"object"==typeof e)return D(e)?"[Array]":"[Object]";var x=function(t,e){var n;if("\t"===t.indent)n="\t";else{if(!("number"==typeof t.indent&&t.indent>0))return null;n=Array(t.indent+1).join(" ")}return{base:n,prev:Array(e+1).join(n)}}(s,i);if(void 0===a)a=[];else if(T(a,e)>=0)return"[Circular]";function C(e,n,o){if(n&&(a=a.slice()).push(n),o){var r={depth:s.depth};return M(s,"quoteStyle")&&(r.quoteStyle=s.quoteStyle),t(e,r,i+1,a)}return t(e,s,i+1,a)}if("function"==typeof e){var w=function(t){if(t.name)return t.name;var e=A.call(_.call(t),/^function\s*([\w$]+)/);if(e)return e[1];return null}(e),N=R(e,C);return"[Function"+(w?": "+w:" (anonymous)")+"]"+(N.length>0?" { "+N.join(", ")+" }":"")}if(S(e)){var H=v?String(e).replace(/^(Symbol\(.*\))_[^)]*$/,"$1"):g.call(e);return"object"!=typeof e||v?H:j(H)}if(function(t){if(!t||"object"!=typeof t)return!1;if("undefined"!=typeof HTMLElement&&t instanceof HTMLElement)return!0;return"string"==typeof t.nodeName&&"function"==typeof t.getAttribute}(e)){for(var $="<"+String(e.nodeName).toLowerCase(),z=e.attributes||[],X=0;X<z.length;X++)$+=" "+z[X].name+"="+E(I(z[X].value),"double",s);return $+=">",e.childNodes&&e.childNodes.length&&($+="..."),$+="</"+String(e.nodeName).toLowerCase()+">"}if(D(e)){if(0===e.length)return"[]";var V=R(e,C);return x&&!function(t){for(var e=0;e<t.length;e++)if(T(t[e],"\n")>=0)return!1;return!0}(V)?"["+Y(V,x)+"]":"[ "+V.join(", ")+" ]"}if(function(t){return!("[object Error]"!==O(t)||k&&"object"==typeof t&&k in t)}(e)){var q=R(e,C);return 0===q.length?"["+String(e)+"]":"{ ["+String(e)+"] "+q.join(", ")+" }"}if("object"==typeof e&&l){if(B&&"function"==typeof e[B])return e[B]();if("symbol"!==l&&"function"==typeof e.inspect)return e.inspect()}if(function(t){if(!o||!t||"object"!=typeof t)return!1;try{o.call(t);try{d.call(t)}catch(t){return!0}return t instanceof Map}catch(t){}return!1}(e)){var W=[];return r.call(e,function(t,n){W.push(C(n,e,!0)+" => "+C(t,e))}),F("Map",o.call(e),W,x)}if(function(t){if(!d||!t||"object"!=typeof t)return!1;try{d.call(t);try{o.call(t)}catch(t){return!0}return t instanceof Set}catch(t){}return!1}(e)){var U=[];return c.call(e,function(t){U.push(C(t,e))}),F("Set",d.call(e),U,x)}if(function(t){if(!h||!t||"object"!=typeof t)return!1;try{h.call(t,h);try{u.call(t,u)}catch(t){return!0}return t instanceof WeakMap}catch(t){}return!1}(e))return P("WeakMap");if(function(t){if(!u||!t||"object"!=typeof t)return!1;try{u.call(t,u);try{h.call(t,h)}catch(t){return!0}return t instanceof WeakSet}catch(t){}return!1}(e))return P("WeakSet");if(function(t){if(!m||!t||"object"!=typeof t)return!1;try{return m.call(t),!0}catch(t){}return!1}(e))return P("WeakRef");if(function(t){return!("[object Number]"!==O(t)||k&&"object"==typeof t&&k in t)}(e))return j(C(Number(e)));if(function(t){if(!t||"object"!=typeof t||!b)return!1;try{return b.call(t),!0}catch(t){}return!1}(e))return j(C(b.call(e)));if(function(t){return!("[object Boolean]"!==O(t)||k&&"object"==typeof t&&k in t)}(e))return j(f.call(e));if(function(t){return!("[object String]"!==O(t)||k&&"object"==typeof t&&k in t)}(e))return j(C(String(e)));if(!function(t){return!("[object Date]"!==O(t)||k&&"object"==typeof t&&k in t)}(e)&&!function(t){return!("[object RegExp]"!==O(t)||k&&"object"==typeof t&&k in t)}(e)){var G=R(e,C),Z=y?y(e)===Object.prototype:e instanceof Object||e.constructor===Object,J=e instanceof Object?"":"null prototype",Q=!Z&&k&&Object(e)===e&&k in e?O(e).slice(8,-1):J?"Object":"",K=(Z||"function"!=typeof e.constructor?"":e.constructor.name?e.constructor.name+" ":"")+(Q||J?"["+[].concat(Q||[],J||[]).join(": ")+"] ":"");return 0===G.length?K+"{}":x?K+"{"+Y(G,x)+"}":K+"{ "+G.join(", ")+" }"}return String(e)};var N=Object.prototype.hasOwnProperty||function(t){return t in this};function M(t,e){return N.call(t,e)}function O(t){return p.call(t)}function T(t,e){if(t.indexOf)return t.indexOf(e);for(var n=0,i=t.length;n<i;n++)if(t[n]===e)return n;return-1}function L(t){var e=t.charCodeAt(0),n={8:"b",9:"t",10:"n",12:"f",13:"r"}[e];return n?"\\"+n:"\\x"+(e<16?"0":"")+e.toString(16).toUpperCase()}function j(t){return"Object("+t+")"}function P(t){return t+" { ? }"}function F(t,e,n,i){return t+" ("+e+") {"+(i?Y(n,i):n.join(", "))+"}"}function Y(t,e){if(0===t.length)return"";var n="\n"+e.prev+e.base;return n+t.join(","+n)+"\n"+e.prev}function R(t,e){var n=D(t),i=[];if(n){i.length=t.length;for(var a=0;a<t.length;a++)i[a]=M(t,a)?e(t[a],t):""}var o,r="function"==typeof x?x(t):[];if(v){o={};for(var s=0;s<r.length;s++)o["$"+r[s]]=r[s]}for(var l in t)M(t,l)&&(n&&String(Number(l))===l&&l<t.length||v&&o["$"+l]instanceof Symbol||(/[^\w$]/.test(l)?i.push(e(l,t)+": "+e(t[l],t)):i.push(l+": "+e(t[l],t))));if("function"==typeof x)for(var d=0;d<r.length;d++)C.call(t,r[d])&&i.push("["+e(r[d])+"]: "+e(t[r[d]],t));return i}},H7xL:function(t,e,n){"use strict";(function(t){n.d(e,"a",function(){return a});var i=function(){return"undefined"!=typeof window?window:t},a=function(){var t=i();return t&&t.tinymce?t.tinymce:null}}).call(e,n("DuR2"))},H9AQ:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-26fd3c9c]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-26fd3c9c]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-26fd3c9c]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-26fd3c9c]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-26fd3c9c] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-26fd3c9c]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-26fd3c9c] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-26fd3c9c]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-26fd3c9c]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-26fd3c9c]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-26fd3c9c]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-26fd3c9c]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-26fd3c9c]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-26fd3c9c] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-26fd3c9c]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-26fd3c9c] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-26fd3c9c]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-26fd3c9c]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},"HC5+":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-38d27d18]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-38d27d18]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-38d27d18]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-38d27d18]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-38d27d18] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-38d27d18]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-38d27d18] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-38d27d18]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-38d27d18]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-38d27d18]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-38d27d18]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-38d27d18]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-38d27d18]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-38d27d18] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-38d27d18]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-38d27d18] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-38d27d18]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-38d27d18]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},HILN:function(t,e,n){var i=n("JMgX");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("4ed0260f",i,!0,{})},HLWZ:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.myLabelRad[data-v-f51d4602]::before {\n  position: absolute;\n  top: 0.25rem;\n  left: 0;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: "";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: #e6e6e6;\n  border: 1px solid black;\n}\n.myRad .myInputRad:checked ~ .myLabelRad[data-v-f51d4602]::before {\n  background-color: #4bc54b;\n  border: 1px solid #0e480f;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myRad .myInputRad.myInputRadUpdated:checked ~ .myLabelRad[data-v-f51d4602]::before {\n  background-color: #5aa0e9 !important;\n  border: 1px solid #033ba2;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myRad .myInputRad.myInput12:checked ~ .myLabelRad[data-v-f51d4602]::before {\n  background-color: lightgreen !important;\n  border: 5px solid green;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myRad .myLabelRad[data-v-f51d4602]::before {\n  border-radius: 1.25rem;\n  -webkit-transition: all 0.2s linear;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.myRad:hover input ~ .myInputRadUpdated:checked ~ .myLabelRad[data-v-f51d4602]::before {\n  background-color: red;\n  border: 2px solid red !important;\n}\n.myRad .myInputRad:checked ~ .myLabelRad[data-v-f51d4602]::after {\n  top: 8px;\n  left: 4px;\n  width: 8px;\n  height: 8px;\n  border-radius: 100%;\n  background: white;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n  position: absolute;\n}\n.myLabelRad[data-v-f51d4602]::after {\n  position: absolute;\n  top: 0.25rem;\n  left: 0;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: "";\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 50% 50%;\n}\n.myInputRad[data-v-f51d4602] {\n  z-index: -1;\n  opacity: 0;\n}\n.myLabelRad[data-v-f51d4602] {\n  margin-left: 5px;\n  cursor: pointer;\n}\n.classMbottom[data-v-f51d4602] {\n  margin-bottom: 15px;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfRadio/PfRadio.css"],names:[],mappings:";AACA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;CACzB;AACD;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,wCAAwC;EACxC,wBAAwB;EACxB,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,uBAAuB;EACvB,oCAAoC;EACpC,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,sBAAsB;EACtB,iCAAiC;CAClC;AACD;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,yBAAyB;CAC1B;AACD;EACE,YAAY;EACZ,WAAW;CACZ;AACD;EACE,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,oBAAoB;CACrB",file:"PfRadio.css",sourcesContent:['\n.myLabelRad[data-v-f51d4602]::before {\n  position: absolute;\n  top: 0.25rem;\n  left: 0;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: "";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: #e6e6e6;\n  border: 1px solid black;\n}\n.myRad .myInputRad:checked ~ .myLabelRad[data-v-f51d4602]::before {\n  background-color: #4bc54b;\n  border: 1px solid #0e480f;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myRad .myInputRad.myInputRadUpdated:checked ~ .myLabelRad[data-v-f51d4602]::before {\n  background-color: #5aa0e9 !important;\n  border: 1px solid #033ba2;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myRad .myInputRad.myInput12:checked ~ .myLabelRad[data-v-f51d4602]::before {\n  background-color: lightgreen !important;\n  border: 5px solid green;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myRad .myLabelRad[data-v-f51d4602]::before {\n  border-radius: 1.25rem;\n  -webkit-transition: all 0.2s linear;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n}\n.myRad:hover input ~ .myInputRadUpdated:checked ~ .myLabelRad[data-v-f51d4602]::before {\n  background-color: red;\n  border: 2px solid red !important;\n}\n.myRad .myInputRad:checked ~ .myLabelRad[data-v-f51d4602]::after {\n  top: 8px;\n  left: 4px;\n  width: 8px;\n  height: 8px;\n  border-radius: 100%;\n  background: white;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n  position: absolute;\n}\n.myLabelRad[data-v-f51d4602]::after {\n  position: absolute;\n  top: 0.25rem;\n  left: 0;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: "";\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 50% 50%;\n}\n.myInputRad[data-v-f51d4602] {\n  z-index: -1;\n  opacity: 0;\n}\n.myLabelRad[data-v-f51d4602] {\n  margin-left: 5px;\n  cursor: pointer;\n}\n.classMbottom[data-v-f51d4602] {\n  margin-bottom: 15px;\n}\n'],sourceRoot:""}])},HSJk:function(t,e,n){var i=n("eWGY");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("be26f076",i,!0,{})},HhN8:function(t,e){!function(e){"use strict";var n,i=Object.prototype,a=i.hasOwnProperty,o="function"==typeof Symbol?Symbol:{},r=o.iterator||"@@iterator",s=o.asyncIterator||"@@asyncIterator",l=o.toStringTag||"@@toStringTag",d="object"==typeof t,c=e.regeneratorRuntime;if(c)d&&(t.exports=c);else{(c=e.regeneratorRuntime=d?t.exports:{}).wrap=g;var h="suspendedStart",u="suspendedYield",m="executing",f="completed",p={},_={};_[r]=function(){return this};var A=Object.getPrototypeOf,b=A&&A(A(N([])));b&&b!==i&&a.call(b,r)&&(_=b);var x=w.prototype=C.prototype=Object.create(_);y.prototype=x.constructor=w,w.constructor=y,w[l]=y.displayName="GeneratorFunction",c.isGeneratorFunction=function(t){var e="function"==typeof t&&t.constructor;return!!e&&(e===y||"GeneratorFunction"===(e.displayName||e.name))},c.mark=function(t){return Object.setPrototypeOf?Object.setPrototypeOf(t,w):(t.__proto__=w,l in t||(t[l]="GeneratorFunction")),t.prototype=Object.create(x),t},c.awrap=function(t){return{__await:t}},B(k.prototype),k.prototype[s]=function(){return this},c.AsyncIterator=k,c.async=function(t,e,n,i){var a=new k(g(t,e,n,i));return c.isGeneratorFunction(e)?a:a.next().then(function(t){return t.done?t.value:a.next()})},B(x),x[l]="Generator",x[r]=function(){return this},x.toString=function(){return"[object Generator]"},c.keys=function(t){var e=[];for(var n in t)e.push(n);return e.reverse(),function n(){for(;e.length;){var i=e.pop();if(i in t)return n.value=i,n.done=!1,n}return n.done=!0,n}},c.values=N,S.prototype={constructor:S,reset:function(t){if(this.prev=0,this.next=0,this.sent=this._sent=n,this.done=!1,this.delegate=null,this.method="next",this.arg=n,this.tryEntries.forEach(D),!t)for(var e in this)"t"===e.charAt(0)&&a.call(this,e)&&!isNaN(+e.slice(1))&&(this[e]=n)},stop:function(){this.done=!0;var t=this.tryEntries[0].completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(t){if(this.done)throw t;var e=this;function i(i,a){return s.type="throw",s.arg=t,e.next=i,a&&(e.method="next",e.arg=n),!!a}for(var o=this.tryEntries.length-1;o>=0;--o){var r=this.tryEntries[o],s=r.completion;if("root"===r.tryLoc)return i("end");if(r.tryLoc<=this.prev){var l=a.call(r,"catchLoc"),d=a.call(r,"finallyLoc");if(l&&d){if(this.prev<r.catchLoc)return i(r.catchLoc,!0);if(this.prev<r.finallyLoc)return i(r.finallyLoc)}else if(l){if(this.prev<r.catchLoc)return i(r.catchLoc,!0)}else{if(!d)throw new Error("try statement without catch or finally");if(this.prev<r.finallyLoc)return i(r.finallyLoc)}}}},abrupt:function(t,e){for(var n=this.tryEntries.length-1;n>=0;--n){var i=this.tryEntries[n];if(i.tryLoc<=this.prev&&a.call(i,"finallyLoc")&&this.prev<i.finallyLoc){var o=i;break}}o&&("break"===t||"continue"===t)&&o.tryLoc<=e&&e<=o.finallyLoc&&(o=null);var r=o?o.completion:{};return r.type=t,r.arg=e,o?(this.method="next",this.next=o.finallyLoc,p):this.complete(r)},complete:function(t,e){if("throw"===t.type)throw t.arg;return"break"===t.type||"continue"===t.type?this.next=t.arg:"return"===t.type?(this.rval=this.arg=t.arg,this.method="return",this.next="end"):"normal"===t.type&&e&&(this.next=e),p},finish:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.finallyLoc===t)return this.complete(n.completion,n.afterLoc),D(n),p}},catch:function(t){for(var e=this.tryEntries.length-1;e>=0;--e){var n=this.tryEntries[e];if(n.tryLoc===t){var i=n.completion;if("throw"===i.type){var a=i.arg;D(n)}return a}}throw new Error("illegal catch attempt")},delegateYield:function(t,e,i){return this.delegate={iterator:N(t),resultName:e,nextLoc:i},"next"===this.method&&(this.arg=n),p}}}function g(t,e,n,i){var a=e&&e.prototype instanceof C?e:C,o=Object.create(a.prototype),r=new S(i||[]);return o._invoke=function(t,e,n){var i=h;return function(a,o){if(i===m)throw new Error("Generator is already running");if(i===f){if("throw"===a)throw o;return M()}for(n.method=a,n.arg=o;;){var r=n.delegate;if(r){var s=E(r,n);if(s){if(s===p)continue;return s}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(i===h)throw i=f,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);i=m;var l=v(t,e,n);if("normal"===l.type){if(i=n.done?f:u,l.arg===p)continue;return{value:l.arg,done:n.done}}"throw"===l.type&&(i=f,n.method="throw",n.arg=l.arg)}}}(t,n,r),o}function v(t,e,n){try{return{type:"normal",arg:t.call(e,n)}}catch(t){return{type:"throw",arg:t}}}function C(){}function y(){}function w(){}function B(t){["next","throw","return"].forEach(function(e){t[e]=function(t){return this._invoke(e,t)}})}function k(t){var e;this._invoke=function(n,i){function o(){return new Promise(function(e,o){!function e(n,i,o,r){var s=v(t[n],t,i);if("throw"!==s.type){var l=s.arg,d=l.value;return d&&"object"==typeof d&&a.call(d,"__await")?Promise.resolve(d.__await).then(function(t){e("next",t,o,r)},function(t){e("throw",t,o,r)}):Promise.resolve(d).then(function(t){l.value=t,o(l)},r)}r(s.arg)}(n,i,e,o)})}return e=e?e.then(o,o):o()}}function E(t,e){var i=t.iterator[e.method];if(i===n){if(e.delegate=null,"throw"===e.method){if(t.iterator.return&&(e.method="return",e.arg=n,E(t,e),"throw"===e.method))return p;e.method="throw",e.arg=new TypeError("The iterator does not provide a 'throw' method")}return p}var a=v(i,t.iterator,e.arg);if("throw"===a.type)return e.method="throw",e.arg=a.arg,e.delegate=null,p;var o=a.arg;return o?o.done?(e[t.resultName]=o.value,e.next=t.nextLoc,"return"!==e.method&&(e.method="next",e.arg=n),e.delegate=null,p):o:(e.method="throw",e.arg=new TypeError("iterator result is not an object"),e.delegate=null,p)}function I(t){var e={tryLoc:t[0]};1 in t&&(e.catchLoc=t[1]),2 in t&&(e.finallyLoc=t[2],e.afterLoc=t[3]),this.tryEntries.push(e)}function D(t){var e=t.completion||{};e.type="normal",delete e.arg,t.completion=e}function S(t){this.tryEntries=[{tryLoc:"root"}],t.forEach(I,this),this.reset(!0)}function N(t){if(t){var e=t[r];if(e)return e.call(t);if("function"==typeof t.next)return t;if(!isNaN(t.length)){var i=-1,o=function e(){for(;++i<t.length;)if(a.call(t,i))return e.value=t[i],e.done=!1,e;return e.value=n,e.done=!0,e};return o.next=o}}return{next:M}}function M(){return{value:n,done:!0}}}(function(){return this}()||Function("return this")())},"I+mV":function(t,e,n){var i=n("5P0+");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("a6680124",i,!0,{})},I7B8:function(t,e,n){"use strict";var i=n("NZ8V"),a=n("YTz9"),o=n("LhDF"),r={};n("aLzV")(r,n("hgbu")("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(r,{next:a(1,n)}),o(t,e+" Iterator")}},IC4K:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfBiographicInformation.css",sourceRoot:""}])},ICpA:function(t,e,n){var i=n("gOOk");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("6b484b70",i,!0,{})},IKUT:function(t,e,n){var i=n("SqRC");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("0c3604e2",i,!0,{})},INcR:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),i=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],a=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;t.defineLocale("es-us",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(t,i){return t?/-MMM-/.test(i)?n[t.month()]:e[t.month()]:e},monthsRegex:a,monthsShortRegex:a,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:i,longMonthsParse:i,shortMonthsParse:i,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"MM/DD/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY h:mm A",LLLL:"dddd, D [de] MMMM [de] YYYY h:mm A"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:0,doy:6}})})(n("PJh5"))},IXY5:function(t,e){t.exports="data:image/gif;base64,R0lGODlhDQANANUkAKW0xdbm/Ka1x4+eraW0xouZqWVzf7vL3md1gbbG2aKxw4aUo8fX7MjZ7bnJ3NHh96CvwMHS5naEks3e83+Nm8jY7dHi99bn/Wp3hMna7sra72d0gH6Mmo6drWl3g4uaqVpncrrK3oWUo9Li+Njp/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTQgNzkuMTUxNDgxLCAyMDEzLzAzLzEzLTEyOjA5OjE1ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkJBODNCNDc1QTNBNzExRTM5MkMyQzZFRTIxQjZEMjNGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkJBODNCNDc2QTNBNzExRTM5MkMyQzZFRTIxQjZEMjNGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QkE4M0I0NzNBM0E3MTFFMzkyQzJDNkVFMjFCNkQyM0YiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QkE4M0I0NzRBM0E3MTFFMzkyQzJDNkVFMjFCNkQyM0YiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQBAAAkACwAAAAADQANAAAGakCSMCRCgBCikFB46XgAmU8G4OkEhB/OSJgQjjgf0gFjWSqWI8xhIViSwkuAyKBxS9yZDahQEUZADkINBSB0bgkUD0J5Im1uExBCAkkYW25eGEoDWkIMXhwDQgFOBBofGgRVV0tEehtJS0EAOw=="},IaZh:function(t,e,n){var i;window,i=function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var a=e[i]={i:i,l:!1,exports:{}};return t[i].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var a in t)n.d(i,a,function(e){return t[e]}.bind(null,a));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s=2)}([function(t,e,n){t.exports=n(3)},function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){t.exports=n(7)},function(t,e,n){"use strict";(function(e,n){var i=Object.freeze({});function a(t){return null==t}function o(t){return null!=t}function r(t){return!0===t}function s(t){return"string"==typeof t||"number"==typeof t||"symbol"==typeof t||"boolean"==typeof t}function l(t){return null!==t&&"object"==typeof t}var d=Object.prototype.toString;function c(t){return"[object Object]"===d.call(t)}function h(t){var e=parseFloat(String(t));return e>=0&&Math.floor(e)===e&&isFinite(t)}function u(t){return o(t)&&"function"==typeof t.then&&"function"==typeof t.catch}function m(t){return null==t?"":Array.isArray(t)||c(t)&&t.toString===d?JSON.stringify(t,null,2):String(t)}function f(t){var e=parseFloat(t);return isNaN(e)?t:e}function p(t,e){for(var n=Object.create(null),i=t.split(","),a=0;a<i.length;a++)n[i[a]]=!0;return e?function(t){return n[t.toLowerCase()]}:function(t){return n[t]}}var _=p("slot,component",!0),A=p("key,ref,slot,slot-scope,is");function b(t,e){if(t.length){var n=t.indexOf(e);if(n>-1)return t.splice(n,1)}}var x=Object.prototype.hasOwnProperty;function g(t,e){return x.call(t,e)}function v(t){var e=Object.create(null);return function(n){return e[n]||(e[n]=t(n))}}var C=/-(\w)/g,y=v(function(t){return t.replace(C,function(t,e){return e?e.toUpperCase():""})}),w=v(function(t){return t.charAt(0).toUpperCase()+t.slice(1)}),B=/\B([A-Z])/g,k=v(function(t){return t.replace(B,"-$1").toLowerCase()}),E=Function.prototype.bind?function(t,e){return t.bind(e)}:function(t,e){function n(n){var i=arguments.length;return i?i>1?t.apply(e,arguments):t.call(e,n):t.call(e)}return n._length=t.length,n};function I(t,e){e=e||0;for(var n=t.length-e,i=new Array(n);n--;)i[n]=t[n+e];return i}function D(t,e){for(var n in e)t[n]=e[n];return t}function S(t){for(var e={},n=0;n<t.length;n++)t[n]&&D(e,t[n]);return e}function N(t,e,n){}var M=function(t,e,n){return!1},O=function(t){return t};function T(t,e){if(t===e)return!0;var n=l(t),i=l(e);if(!n||!i)return!n&&!i&&String(t)===String(e);try{var a=Array.isArray(t),o=Array.isArray(e);if(a&&o)return t.length===e.length&&t.every(function(t,n){return T(t,e[n])});if(t instanceof Date&&e instanceof Date)return t.getTime()===e.getTime();if(a||o)return!1;var r=Object.keys(t),s=Object.keys(e);return r.length===s.length&&r.every(function(n){return T(t[n],e[n])})}catch(t){return!1}}function L(t,e){for(var n=0;n<t.length;n++)if(T(t[n],e))return n;return-1}function j(t){var e=!1;return function(){e||(e=!0,t.apply(this,arguments))}}var P="data-server-rendered",F=["component","directive","filter"],Y=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],R={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:M,isReservedAttr:M,isUnknownElement:M,getTagNamespace:N,parsePlatformTagName:O,mustUseProp:M,async:!0,_lifecycleHooks:Y},H=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function $(t,e,n,i){Object.defineProperty(t,e,{value:n,enumerable:!!i,writable:!0,configurable:!0})}var z,X=new RegExp("[^"+H.source+".$_\\d]"),V="__proto__"in{},q="undefined"!=typeof window,W="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,U=W&&WXEnvironment.platform.toLowerCase(),G=q&&window.navigator.userAgent.toLowerCase(),Z=G&&/msie|trident/.test(G),J=G&&G.indexOf("msie 9.0")>0,Q=G&&G.indexOf("edge/")>0,K=(G&&G.indexOf("android"),G&&/iphone|ipad|ipod|ios/.test(G)||"ios"===U),tt=(G&&/chrome\/\d+/.test(G),G&&/phantomjs/.test(G),G&&G.match(/firefox\/(\d+)/)),et={}.watch,nt=!1;if(q)try{var it={};Object.defineProperty(it,"passive",{get:function(){nt=!0}}),window.addEventListener("test-passive",null,it)}catch(i){}var at=function(){return void 0===z&&(z=!q&&!W&&void 0!==e&&e.process&&"server"===e.process.env.VUE_ENV),z},ot=q&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function rt(t){return"function"==typeof t&&/native code/.test(t.toString())}var st,lt="undefined"!=typeof Symbol&&rt(Symbol)&&"undefined"!=typeof Reflect&&rt(Reflect.ownKeys);st="undefined"!=typeof Set&&rt(Set)?Set:function(){function t(){this.set=Object.create(null)}return t.prototype.has=function(t){return!0===this.set[t]},t.prototype.add=function(t){this.set[t]=!0},t.prototype.clear=function(){this.set=Object.create(null)},t}();var dt=N,ct=0,ht=function(){this.id=ct++,this.subs=[]};ht.prototype.addSub=function(t){this.subs.push(t)},ht.prototype.removeSub=function(t){b(this.subs,t)},ht.prototype.depend=function(){ht.target&&ht.target.addDep(this)},ht.prototype.notify=function(){for(var t=this.subs.slice(),e=0,n=t.length;e<n;e++)t[e].update()},ht.target=null;var ut=[];function mt(t){ut.push(t),ht.target=t}function ft(){ut.pop(),ht.target=ut[ut.length-1]}var pt=function(t,e,n,i,a,o,r,s){this.tag=t,this.data=e,this.children=n,this.text=i,this.elm=a,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=e&&e.key,this.componentOptions=r,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},_t={child:{configurable:!0}};_t.child.get=function(){return this.componentInstance},Object.defineProperties(pt.prototype,_t);var At=function(t){void 0===t&&(t="");var e=new pt;return e.text=t,e.isComment=!0,e};function bt(t){return new pt(void 0,void 0,void 0,String(t))}function xt(t){var e=new pt(t.tag,t.data,t.children&&t.children.slice(),t.text,t.elm,t.context,t.componentOptions,t.asyncFactory);return e.ns=t.ns,e.isStatic=t.isStatic,e.key=t.key,e.isComment=t.isComment,e.fnContext=t.fnContext,e.fnOptions=t.fnOptions,e.fnScopeId=t.fnScopeId,e.asyncMeta=t.asyncMeta,e.isCloned=!0,e}var gt=Array.prototype,vt=Object.create(gt);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(t){var e=gt[t];$(vt,t,function(){for(var n=[],i=arguments.length;i--;)n[i]=arguments[i];var a,o=e.apply(this,n),r=this.__ob__;switch(t){case"push":case"unshift":a=n;break;case"splice":a=n.slice(2)}return a&&r.observeArray(a),r.dep.notify(),o})});var Ct=Object.getOwnPropertyNames(vt),yt=!0;function wt(t){yt=t}var Bt=function(t){var e;this.value=t,this.dep=new ht,this.vmCount=0,$(t,"__ob__",this),Array.isArray(t)?(V?(e=vt,t.__proto__=e):function(t,e,n){for(var i=0,a=n.length;i<a;i++){var o=n[i];$(t,o,e[o])}}(t,vt,Ct),this.observeArray(t)):this.walk(t)};function kt(t,e){var n;if(l(t)&&!(t instanceof pt))return g(t,"__ob__")&&t.__ob__ instanceof Bt?n=t.__ob__:yt&&!at()&&(Array.isArray(t)||c(t))&&Object.isExtensible(t)&&!t._isVue&&(n=new Bt(t)),e&&n&&n.vmCount++,n}function Et(t,e,n,i,a){var o=new ht,r=Object.getOwnPropertyDescriptor(t,e);if(!r||!1!==r.configurable){var s=r&&r.get,l=r&&r.set;s&&!l||2!==arguments.length||(n=t[e]);var d=!a&&kt(n);Object.defineProperty(t,e,{enumerable:!0,configurable:!0,get:function(){var e=s?s.call(t):n;return ht.target&&(o.depend(),d&&(d.dep.depend(),Array.isArray(e)&&function t(e){for(var n=void 0,i=0,a=e.length;i<a;i++)(n=e[i])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&t(n)}(e))),e},set:function(e){var i=s?s.call(t):n;e===i||e!=e&&i!=i||s&&!l||(l?l.call(t,e):n=e,d=!a&&kt(e),o.notify())}})}}function It(t,e,n){if(Array.isArray(t)&&h(e))return t.length=Math.max(t.length,e),t.splice(e,1,n),n;if(e in t&&!(e in Object.prototype))return t[e]=n,n;var i=t.__ob__;return t._isVue||i&&i.vmCount?n:i?(Et(i.value,e,n),i.dep.notify(),n):(t[e]=n,n)}function Dt(t,e){if(Array.isArray(t)&&h(e))t.splice(e,1);else{var n=t.__ob__;t._isVue||n&&n.vmCount||g(t,e)&&(delete t[e],n&&n.dep.notify())}}Bt.prototype.walk=function(t){for(var e=Object.keys(t),n=0;n<e.length;n++)Et(t,e[n])},Bt.prototype.observeArray=function(t){for(var e=0,n=t.length;e<n;e++)kt(t[e])};var St=R.optionMergeStrategies;function Nt(t,e){if(!e)return t;for(var n,i,a,o=lt?Reflect.ownKeys(e):Object.keys(e),r=0;r<o.length;r++)"__ob__"!==(n=o[r])&&(i=t[n],a=e[n],g(t,n)?i!==a&&c(i)&&c(a)&&Nt(i,a):It(t,n,a));return t}function Mt(t,e,n){return n?function(){var i="function"==typeof e?e.call(n,n):e,a="function"==typeof t?t.call(n,n):t;return i?Nt(i,a):a}:e?t?function(){return Nt("function"==typeof e?e.call(this,this):e,"function"==typeof t?t.call(this,this):t)}:e:t}function Ot(t,e){var n=e?t?t.concat(e):Array.isArray(e)?e:[e]:t;return n?function(t){for(var e=[],n=0;n<t.length;n++)-1===e.indexOf(t[n])&&e.push(t[n]);return e}(n):n}function Tt(t,e,n,i){var a=Object.create(t||null);return e?D(a,e):a}St.data=function(t,e,n){return n?Mt(t,e,n):e&&"function"!=typeof e?t:Mt(t,e)},Y.forEach(function(t){St[t]=Ot}),F.forEach(function(t){St[t+"s"]=Tt}),St.watch=function(t,e,n,i){if(t===et&&(t=void 0),e===et&&(e=void 0),!e)return Object.create(t||null);if(!t)return e;var a={};for(var o in D(a,t),e){var r=a[o],s=e[o];r&&!Array.isArray(r)&&(r=[r]),a[o]=r?r.concat(s):Array.isArray(s)?s:[s]}return a},St.props=St.methods=St.inject=St.computed=function(t,e,n,i){if(!t)return e;var a=Object.create(null);return D(a,t),e&&D(a,e),a},St.provide=Mt;var Lt=function(t,e){return void 0===e?t:e};function jt(t,e,n){if("function"==typeof e&&(e=e.options),function(t,e){var n=t.props;if(n){var i,a,o={};if(Array.isArray(n))for(i=n.length;i--;)"string"==typeof(a=n[i])&&(o[y(a)]={type:null});else if(c(n))for(var r in n)a=n[r],o[y(r)]=c(a)?a:{type:a};t.props=o}}(e),function(t,e){var n=t.inject;if(n){var i=t.inject={};if(Array.isArray(n))for(var a=0;a<n.length;a++)i[n[a]]={from:n[a]};else if(c(n))for(var o in n){var r=n[o];i[o]=c(r)?D({from:o},r):{from:r}}}}(e),function(t){var e=t.directives;if(e)for(var n in e){var i=e[n];"function"==typeof i&&(e[n]={bind:i,update:i})}}(e),!e._base&&(e.extends&&(t=jt(t,e.extends,n)),e.mixins))for(var i=0,a=e.mixins.length;i<a;i++)t=jt(t,e.mixins[i],n);var o,r={};for(o in t)s(o);for(o in e)g(t,o)||s(o);function s(i){var a=St[i]||Lt;r[i]=a(t[i],e[i],n,i)}return r}function Pt(t,e,n,i){if("string"==typeof n){var a=t[e];if(g(a,n))return a[n];var o=y(n);if(g(a,o))return a[o];var r=w(o);return g(a,r)?a[r]:a[n]||a[o]||a[r]}}function Ft(t,e,n,i){var a=e[t],o=!g(n,t),r=n[t],s=Ht(Boolean,a.type);if(s>-1)if(o&&!g(a,"default"))r=!1;else if(""===r||r===k(t)){var l=Ht(String,a.type);(l<0||s<l)&&(r=!0)}if(void 0===r){r=function(t,e,n){if(g(e,"default")){var i=e.default;return t&&t.$options.propsData&&void 0===t.$options.propsData[n]&&void 0!==t._props[n]?t._props[n]:"function"==typeof i&&"Function"!==Yt(e.type)?i.call(t):i}}(i,a,t);var d=yt;wt(!0),kt(r),wt(d)}return r}function Yt(t){var e=t&&t.toString().match(/^\s*function (\w+)/);return e?e[1]:""}function Rt(t,e){return Yt(t)===Yt(e)}function Ht(t,e){if(!Array.isArray(e))return Rt(e,t)?0:-1;for(var n=0,i=e.length;n<i;n++)if(Rt(e[n],t))return n;return-1}function $t(t,e,n){mt();try{if(e)for(var i=e;i=i.$parent;){var a=i.$options.errorCaptured;if(a)for(var o=0;o<a.length;o++)try{if(!1===a[o].call(i,t,e,n))return}catch(t){Xt(t,i,"errorCaptured hook")}}Xt(t,e,n)}finally{ft()}}function zt(t,e,n,i,a){var o;try{(o=n?t.apply(e,n):t.call(e))&&!o._isVue&&u(o)&&!o._handled&&(o.catch(function(t){return $t(t,i,a+" (Promise/async)")}),o._handled=!0)}catch(t){$t(t,i,a)}return o}function Xt(t,e,n){if(R.errorHandler)try{return R.errorHandler.call(null,t,e,n)}catch(e){e!==t&&Vt(e,null,"config.errorHandler")}Vt(t,e,n)}function Vt(t,e,n){if(!q&&!W||"undefined"==typeof console)throw t;console.error(t)}var qt,Wt=!1,Ut=[],Gt=!1;function Zt(){Gt=!1;var t=Ut.slice(0);Ut.length=0;for(var e=0;e<t.length;e++)t[e]()}if("undefined"!=typeof Promise&&rt(Promise)){var Jt=Promise.resolve();qt=function(){Jt.then(Zt),K&&setTimeout(N)},Wt=!0}else if(Z||"undefined"==typeof MutationObserver||!rt(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())qt=void 0!==n&&rt(n)?function(){n(Zt)}:function(){setTimeout(Zt,0)};else{var Qt=1,Kt=new MutationObserver(Zt),te=document.createTextNode(String(Qt));Kt.observe(te,{characterData:!0}),qt=function(){Qt=(Qt+1)%2,te.data=String(Qt)},Wt=!0}function ee(t,e){var n;if(Ut.push(function(){if(t)try{t.call(e)}catch(t){$t(t,e,"nextTick")}else n&&n(e)}),Gt||(Gt=!0,qt()),!t&&"undefined"!=typeof Promise)return new Promise(function(t){n=t})}var ne=new st;function ie(t){!function t(e,n){var i,a,o=Array.isArray(e);if(!(!o&&!l(e)||Object.isFrozen(e)||e instanceof pt)){if(e.__ob__){var r=e.__ob__.dep.id;if(n.has(r))return;n.add(r)}if(o)for(i=e.length;i--;)t(e[i],n);else for(i=(a=Object.keys(e)).length;i--;)t(e[a[i]],n)}}(t,ne),ne.clear()}var ae=v(function(t){var e="&"===t.charAt(0),n="~"===(t=e?t.slice(1):t).charAt(0),i="!"===(t=n?t.slice(1):t).charAt(0);return{name:t=i?t.slice(1):t,once:n,capture:i,passive:e}});function oe(t,e){function n(){var t=arguments,i=n.fns;if(!Array.isArray(i))return zt(i,null,arguments,e,"v-on handler");for(var a=i.slice(),o=0;o<a.length;o++)zt(a[o],null,t,e,"v-on handler")}return n.fns=t,n}function re(t,e,n,i,o,s){var l,d,c,h;for(l in t)d=t[l],c=e[l],h=ae(l),a(d)||(a(c)?(a(d.fns)&&(d=t[l]=oe(d,s)),r(h.once)&&(d=t[l]=o(h.name,d,h.capture)),n(h.name,d,h.capture,h.passive,h.params)):d!==c&&(c.fns=d,t[l]=c));for(l in e)a(t[l])&&i((h=ae(l)).name,e[l],h.capture)}function se(t,e,n){var i;t instanceof pt&&(t=t.data.hook||(t.data.hook={}));var s=t[e];function l(){n.apply(this,arguments),b(i.fns,l)}a(s)?i=oe([l]):o(s.fns)&&r(s.merged)?(i=s).fns.push(l):i=oe([s,l]),i.merged=!0,t[e]=i}function le(t,e,n,i,a){if(o(e)){if(g(e,n))return t[n]=e[n],a||delete e[n],!0;if(g(e,i))return t[n]=e[i],a||delete e[i],!0}return!1}function de(t){return s(t)?[bt(t)]:Array.isArray(t)?function t(e,n){var i,l,d,c,h=[];for(i=0;i<e.length;i++)a(l=e[i])||"boolean"==typeof l||(c=h[d=h.length-1],Array.isArray(l)?l.length>0&&(ce((l=t(l,(n||"")+"_"+i))[0])&&ce(c)&&(h[d]=bt(c.text+l[0].text),l.shift()),h.push.apply(h,l)):s(l)?ce(c)?h[d]=bt(c.text+l):""!==l&&h.push(bt(l)):ce(l)&&ce(c)?h[d]=bt(c.text+l.text):(r(e._isVList)&&o(l.tag)&&a(l.key)&&o(n)&&(l.key="__vlist"+n+"_"+i+"__"),h.push(l)));return h}(t):void 0}function ce(t){return o(t)&&o(t.text)&&!1===t.isComment}function he(t,e){if(t){for(var n=Object.create(null),i=lt?Reflect.ownKeys(t):Object.keys(t),a=0;a<i.length;a++){var o=i[a];if("__ob__"!==o){for(var r=t[o].from,s=e;s;){if(s._provided&&g(s._provided,r)){n[o]=s._provided[r];break}s=s.$parent}if(!s&&"default"in t[o]){var l=t[o].default;n[o]="function"==typeof l?l.call(e):l}}}return n}}function ue(t,e){if(!t||!t.length)return{};for(var n={},i=0,a=t.length;i<a;i++){var o=t[i],r=o.data;if(r&&r.attrs&&r.attrs.slot&&delete r.attrs.slot,o.context!==e&&o.fnContext!==e||!r||null==r.slot)(n.default||(n.default=[])).push(o);else{var s=r.slot,l=n[s]||(n[s]=[]);"template"===o.tag?l.push.apply(l,o.children||[]):l.push(o)}}for(var d in n)n[d].every(me)&&delete n[d];return n}function me(t){return t.isComment&&!t.asyncFactory||" "===t.text}function fe(t,e,n){var a,o=Object.keys(e).length>0,r=t?!!t.$stable:!o,s=t&&t.$key;if(t){if(t._normalized)return t._normalized;if(r&&n&&n!==i&&s===n.$key&&!o&&!n.$hasNormal)return n;for(var l in a={},t)t[l]&&"$"!==l[0]&&(a[l]=pe(e,l,t[l]))}else a={};for(var d in e)d in a||(a[d]=_e(e,d));return t&&Object.isExtensible(t)&&(t._normalized=a),$(a,"$stable",r),$(a,"$key",s),$(a,"$hasNormal",o),a}function pe(t,e,n){var i=function(){var t=arguments.length?n.apply(null,arguments):n({});return(t=t&&"object"==typeof t&&!Array.isArray(t)?[t]:de(t))&&(0===t.length||1===t.length&&t[0].isComment)?void 0:t};return n.proxy&&Object.defineProperty(t,e,{get:i,enumerable:!0,configurable:!0}),i}function _e(t,e){return function(){return t[e]}}function Ae(t,e){var n,i,a,r,s;if(Array.isArray(t)||"string"==typeof t)for(n=new Array(t.length),i=0,a=t.length;i<a;i++)n[i]=e(t[i],i);else if("number"==typeof t)for(n=new Array(t),i=0;i<t;i++)n[i]=e(i+1,i);else if(l(t))if(lt&&t[Symbol.iterator]){n=[];for(var d=t[Symbol.iterator](),c=d.next();!c.done;)n.push(e(c.value,n.length)),c=d.next()}else for(r=Object.keys(t),n=new Array(r.length),i=0,a=r.length;i<a;i++)s=r[i],n[i]=e(t[s],s,i);return o(n)||(n=[]),n._isVList=!0,n}function be(t,e,n,i){var a,o=this.$scopedSlots[t];o?(n=n||{},i&&(n=D(D({},i),n)),a=o(n)||e):a=this.$slots[t]||e;var r=n&&n.slot;return r?this.$createElement("template",{slot:r},a):a}function xe(t){return Pt(this.$options,"filters",t)||O}function ge(t,e){return Array.isArray(t)?-1===t.indexOf(e):t!==e}function ve(t,e,n,i,a){var o=R.keyCodes[e]||n;return a&&i&&!R.keyCodes[e]?ge(a,i):o?ge(o,t):i?k(i)!==e:void 0}function Ce(t,e,n,i,a){if(n&&l(n)){var o;Array.isArray(n)&&(n=S(n));var r=function(r){if("class"===r||"style"===r||A(r))o=t;else{var s=t.attrs&&t.attrs.type;o=i||R.mustUseProp(e,s,r)?t.domProps||(t.domProps={}):t.attrs||(t.attrs={})}var l=y(r),d=k(r);l in o||d in o||(o[r]=n[r],a&&((t.on||(t.on={}))["update:"+r]=function(t){n[r]=t}))};for(var s in n)r(s)}return t}function ye(t,e){var n=this._staticTrees||(this._staticTrees=[]),i=n[t];return i&&!e?i:(Be(i=n[t]=this.$options.staticRenderFns[t].call(this._renderProxy,null,this),"__static__"+t,!1),i)}function we(t,e,n){return Be(t,"__once__"+e+(n?"_"+n:""),!0),t}function Be(t,e,n){if(Array.isArray(t))for(var i=0;i<t.length;i++)t[i]&&"string"!=typeof t[i]&&ke(t[i],e+"_"+i,n);else ke(t,e,n)}function ke(t,e,n){t.isStatic=!0,t.key=e,t.isOnce=n}function Ee(t,e){if(e&&c(e)){var n=t.on=t.on?D({},t.on):{};for(var i in e){var a=n[i],o=e[i];n[i]=a?[].concat(a,o):o}}return t}function Ie(t,e,n,i){e=e||{$stable:!n};for(var a=0;a<t.length;a++){var o=t[a];Array.isArray(o)?Ie(o,e,n):o&&(o.proxy&&(o.fn.proxy=!0),e[o.key]=o.fn)}return i&&(e.$key=i),e}function De(t,e){for(var n=0;n<e.length;n+=2){var i=e[n];"string"==typeof i&&i&&(t[e[n]]=e[n+1])}return t}function Se(t,e){return"string"==typeof t?e+t:t}function Ne(t){t._o=we,t._n=f,t._s=m,t._l=Ae,t._t=be,t._q=T,t._i=L,t._m=ye,t._f=xe,t._k=ve,t._b=Ce,t._v=bt,t._e=At,t._u=Ie,t._g=Ee,t._d=De,t._p=Se}function Me(t,e,n,a,o){var s,l=this,d=o.options;g(a,"_uid")?(s=Object.create(a))._original=a:(s=a,a=a._original);var c=r(d._compiled),h=!c;this.data=t,this.props=e,this.children=n,this.parent=a,this.listeners=t.on||i,this.injections=he(d.inject,a),this.slots=function(){return l.$slots||fe(t.scopedSlots,l.$slots=ue(n,a)),l.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return fe(t.scopedSlots,this.slots())}}),c&&(this.$options=d,this.$slots=this.slots(),this.$scopedSlots=fe(t.scopedSlots,this.$slots)),d._scopeId?this._c=function(t,e,n,i){var o=He(s,t,e,n,i,h);return o&&!Array.isArray(o)&&(o.fnScopeId=d._scopeId,o.fnContext=a),o}:this._c=function(t,e,n,i){return He(s,t,e,n,i,h)}}function Oe(t,e,n,i,a){var o=xt(t);return o.fnContext=n,o.fnOptions=i,e.slot&&((o.data||(o.data={})).slot=e.slot),o}function Te(t,e){for(var n in e)t[y(n)]=e[n]}Ne(Me.prototype);var Le={init:function(t,e){if(t.componentInstance&&!t.componentInstance._isDestroyed&&t.data.keepAlive){var n=t;Le.prepatch(n,n)}else(t.componentInstance=function(t,e){var n={_isComponent:!0,_parentVnode:t,parent:Je},i=t.data.inlineTemplate;return o(i)&&(n.render=i.render,n.staticRenderFns=i.staticRenderFns),new t.componentOptions.Ctor(n)}(t)).$mount(e?t.elm:void 0,e)},prepatch:function(t,e){var n=e.componentOptions;!function(t,e,n,a,o){var r=a.data.scopedSlots,s=t.$scopedSlots,l=!!(r&&!r.$stable||s!==i&&!s.$stable||r&&t.$scopedSlots.$key!==r.$key),d=!!(o||t.$options._renderChildren||l);if(t.$options._parentVnode=a,t.$vnode=a,t._vnode&&(t._vnode.parent=a),t.$options._renderChildren=o,t.$attrs=a.data.attrs||i,t.$listeners=n||i,e&&t.$options.props){wt(!1);for(var c=t._props,h=t.$options._propKeys||[],u=0;u<h.length;u++){var m=h[u],f=t.$options.props;c[m]=Ft(m,f,e,t)}wt(!0),t.$options.propsData=e}n=n||i;var p=t.$options._parentListeners;t.$options._parentListeners=n,Ze(t,n,p),d&&(t.$slots=ue(o,a.context),t.$forceUpdate())}(e.componentInstance=t.componentInstance,n.propsData,n.listeners,e,n.children)},insert:function(t){var e,n=t.context,i=t.componentInstance;i._isMounted||(i._isMounted=!0,en(i,"mounted")),t.data.keepAlive&&(n._isMounted?((e=i)._inactive=!1,an.push(e)):tn(i,!0))},destroy:function(t){var e=t.componentInstance;e._isDestroyed||(t.data.keepAlive?function t(e,n){if(!(n&&(e._directInactive=!0,Ke(e))||e._inactive)){e._inactive=!0;for(var i=0;i<e.$children.length;i++)t(e.$children[i]);en(e,"deactivated")}}(e,!0):e.$destroy())}},je=Object.keys(Le);function Pe(t,e,n,s,d){if(!a(t)){var c=n.$options._base;if(l(t)&&(t=c.extend(t)),"function"==typeof t){var h;if(a(t.cid)&&void 0===(t=function(t,e){if(r(t.error)&&o(t.errorComp))return t.errorComp;if(o(t.resolved))return t.resolved;var n=ze;if(n&&o(t.owners)&&-1===t.owners.indexOf(n)&&t.owners.push(n),r(t.loading)&&o(t.loadingComp))return t.loadingComp;if(n&&!o(t.owners)){var i=t.owners=[n],s=!0,d=null,c=null;n.$on("hook:destroyed",function(){return b(i,n)});var h=function(t){for(var e=0,n=i.length;e<n;e++)i[e].$forceUpdate();t&&(i.length=0,null!==d&&(clearTimeout(d),d=null),null!==c&&(clearTimeout(c),c=null))},m=j(function(n){t.resolved=Xe(n,e),s?i.length=0:h(!0)}),f=j(function(e){o(t.errorComp)&&(t.error=!0,h(!0))}),p=t(m,f);return l(p)&&(u(p)?a(t.resolved)&&p.then(m,f):u(p.component)&&(p.component.then(m,f),o(p.error)&&(t.errorComp=Xe(p.error,e)),o(p.loading)&&(t.loadingComp=Xe(p.loading,e),0===p.delay?t.loading=!0:d=setTimeout(function(){d=null,a(t.resolved)&&a(t.error)&&(t.loading=!0,h(!1))},p.delay||200)),o(p.timeout)&&(c=setTimeout(function(){c=null,a(t.resolved)&&f(null)},p.timeout)))),s=!1,t.loading?t.loadingComp:t.resolved}}(h=t,c)))return function(t,e,n,i,a){var o=At();return o.asyncFactory=t,o.asyncMeta={data:e,context:n,children:i,tag:a},o}(h,e,n,s,d);e=e||{},yn(t),o(e.model)&&function(t,e){var n=t.model&&t.model.prop||"value",i=t.model&&t.model.event||"input";(e.attrs||(e.attrs={}))[n]=e.model.value;var a=e.on||(e.on={}),r=a[i],s=e.model.callback;o(r)?(Array.isArray(r)?-1===r.indexOf(s):r!==s)&&(a[i]=[s].concat(r)):a[i]=s}(t.options,e);var m=function(t,e,n){var i=e.options.props;if(!a(i)){var r={},s=t.attrs,l=t.props;if(o(s)||o(l))for(var d in i){var c=k(d);le(r,l,d,c,!0)||le(r,s,d,c,!1)}return r}}(e,t);if(r(t.options.functional))return function(t,e,n,a,r){var s=t.options,l={},d=s.props;if(o(d))for(var c in d)l[c]=Ft(c,d,e||i);else o(n.attrs)&&Te(l,n.attrs),o(n.props)&&Te(l,n.props);var h=new Me(n,l,r,a,t),u=s.render.call(null,h._c,h);if(u instanceof pt)return Oe(u,n,h.parent,s);if(Array.isArray(u)){for(var m=de(u)||[],f=new Array(m.length),p=0;p<m.length;p++)f[p]=Oe(m[p],n,h.parent,s);return f}}(t,m,e,n,s);var f=e.on;if(e.on=e.nativeOn,r(t.options.abstract)){var p=e.slot;e={},p&&(e.slot=p)}!function(t){for(var e=t.hook||(t.hook={}),n=0;n<je.length;n++){var i=je[n],a=e[i],o=Le[i];a===o||a&&a._merged||(e[i]=a?Fe(o,a):o)}}(e);var _=t.options.name||d;return new pt("vue-component-"+t.cid+(_?"-"+_:""),e,void 0,void 0,void 0,n,{Ctor:t,propsData:m,listeners:f,tag:d,children:s},h)}}}function Fe(t,e){var n=function(n,i){t(n,i),e(n,i)};return n._merged=!0,n}var Ye=1,Re=2;function He(t,e,n,i,d,c){return(Array.isArray(n)||s(n))&&(d=i,i=n,n=void 0),r(c)&&(d=Re),function(t,e,n,i,s){return o(n)&&o(n.__ob__)?At():(o(n)&&o(n.is)&&(e=n.is),e?(Array.isArray(i)&&"function"==typeof i[0]&&((n=n||{}).scopedSlots={default:i[0]},i.length=0),s===Re?i=de(i):s===Ye&&(i=function(t){for(var e=0;e<t.length;e++)if(Array.isArray(t[e]))return Array.prototype.concat.apply([],t);return t}(i)),"string"==typeof e?(c=t.$vnode&&t.$vnode.ns||R.getTagNamespace(e),d=R.isReservedTag(e)?new pt(R.parsePlatformTagName(e),n,i,void 0,void 0,t):n&&n.pre||!o(h=Pt(t.$options,"components",e))?new pt(e,n,i,void 0,void 0,t):Pe(h,n,t,i,e)):d=Pe(e,n,t,i),Array.isArray(d)?d:o(d)?(o(c)&&function t(e,n,i){if(e.ns=n,"foreignObject"===e.tag&&(n=void 0,i=!0),o(e.children))for(var s=0,l=e.children.length;s<l;s++){var d=e.children[s];o(d.tag)&&(a(d.ns)||r(i)&&"svg"!==d.tag)&&t(d,n,i)}}(d,c),o(n)&&function(t){l(t.style)&&ie(t.style),l(t.class)&&ie(t.class)}(n),d):At()):At());var d,c,h}(t,e,n,i,d)}var $e,ze=null;function Xe(t,e){return(t.__esModule||lt&&"Module"===t[Symbol.toStringTag])&&(t=t.default),l(t)?e.extend(t):t}function Ve(t){return t.isComment&&t.asyncFactory}function qe(t){if(Array.isArray(t))for(var e=0;e<t.length;e++){var n=t[e];if(o(n)&&(o(n.componentOptions)||Ve(n)))return n}}function We(t,e){$e.$on(t,e)}function Ue(t,e){$e.$off(t,e)}function Ge(t,e){var n=$e;return function i(){null!==e.apply(null,arguments)&&n.$off(t,i)}}function Ze(t,e,n){$e=t,re(e,n||{},We,Ue,Ge,t),$e=void 0}var Je=null;function Qe(t){var e=Je;return Je=t,function(){Je=e}}function Ke(t){for(;t&&(t=t.$parent);)if(t._inactive)return!0;return!1}function tn(t,e){if(e){if(t._directInactive=!1,Ke(t))return}else if(t._directInactive)return;if(t._inactive||null===t._inactive){t._inactive=!1;for(var n=0;n<t.$children.length;n++)tn(t.$children[n]);en(t,"activated")}}function en(t,e){mt();var n=t.$options[e],i=e+" hook";if(n)for(var a=0,o=n.length;a<o;a++)zt(n[a],t,null,t,i);t._hasHookEvent&&t.$emit("hook:"+e),ft()}var nn=[],an=[],on={},rn=!1,sn=!1,ln=0,dn=0,cn=Date.now;if(q&&!Z){var hn=window.performance;hn&&"function"==typeof hn.now&&cn()>document.createEvent("Event").timeStamp&&(cn=function(){return hn.now()})}function un(){var t,e;for(dn=cn(),sn=!0,nn.sort(function(t,e){return t.id-e.id}),ln=0;ln<nn.length;ln++)(t=nn[ln]).before&&t.before(),e=t.id,on[e]=null,t.run();var n=an.slice(),i=nn.slice();ln=nn.length=an.length=0,on={},rn=sn=!1,function(t){for(var e=0;e<t.length;e++)t[e]._inactive=!0,tn(t[e],!0)}(n),function(t){for(var e=t.length;e--;){var n=t[e],i=n.vm;i._watcher===n&&i._isMounted&&!i._isDestroyed&&en(i,"updated")}}(i),ot&&R.devtools&&ot.emit("flush")}var mn=0,fn=function(t,e,n,i,a){this.vm=t,a&&(t._watcher=this),t._watchers.push(this),i?(this.deep=!!i.deep,this.user=!!i.user,this.lazy=!!i.lazy,this.sync=!!i.sync,this.before=i.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++mn,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new st,this.newDepIds=new st,this.expression="","function"==typeof e?this.getter=e:(this.getter=function(t){if(!X.test(t)){var e=t.split(".");return function(t){for(var n=0;n<e.length;n++){if(!t)return;t=t[e[n]]}return t}}}(e),this.getter||(this.getter=N)),this.value=this.lazy?void 0:this.get()};fn.prototype.get=function(){var t;mt(this);var e=this.vm;try{t=this.getter.call(e,e)}catch(t){if(!this.user)throw t;$t(t,e,'getter for watcher "'+this.expression+'"')}finally{this.deep&&ie(t),ft(),this.cleanupDeps()}return t},fn.prototype.addDep=function(t){var e=t.id;this.newDepIds.has(e)||(this.newDepIds.add(e),this.newDeps.push(t),this.depIds.has(e)||t.addSub(this))},fn.prototype.cleanupDeps=function(){for(var t=this.deps.length;t--;){var e=this.deps[t];this.newDepIds.has(e.id)||e.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},fn.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(t){var e=t.id;if(null==on[e]){if(on[e]=!0,sn){for(var n=nn.length-1;n>ln&&nn[n].id>t.id;)n--;nn.splice(n+1,0,t)}else nn.push(t);rn||(rn=!0,ee(un))}}(this)},fn.prototype.run=function(){if(this.active){var t=this.get();if(t!==this.value||l(t)||this.deep){var e=this.value;if(this.value=t,this.user)try{this.cb.call(this.vm,t,e)}catch(t){$t(t,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,t,e)}}},fn.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},fn.prototype.depend=function(){for(var t=this.deps.length;t--;)this.deps[t].depend()},fn.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||b(this.vm._watchers,this);for(var t=this.deps.length;t--;)this.deps[t].removeSub(this);this.active=!1}};var pn={enumerable:!0,configurable:!0,get:N,set:N};function _n(t,e,n){pn.get=function(){return this[e][n]},pn.set=function(t){this[e][n]=t},Object.defineProperty(t,n,pn)}var An={lazy:!0};function bn(t,e,n){var i=!at();"function"==typeof n?(pn.get=i?xn(e):gn(n),pn.set=N):(pn.get=n.get?i&&!1!==n.cache?xn(e):gn(n.get):N,pn.set=n.set||N),Object.defineProperty(t,e,pn)}function xn(t){return function(){var e=this._computedWatchers&&this._computedWatchers[t];if(e)return e.dirty&&e.evaluate(),ht.target&&e.depend(),e.value}}function gn(t){return function(){return t.call(this,this)}}function vn(t,e,n,i){return c(n)&&(i=n,n=n.handler),"string"==typeof n&&(n=t[n]),t.$watch(e,n,i)}var Cn=0;function yn(t){var e=t.options;if(t.super){var n=yn(t.super);if(n!==t.superOptions){t.superOptions=n;var i=function(t){var e,n=t.options,i=t.sealedOptions;for(var a in n)n[a]!==i[a]&&(e||(e={}),e[a]=n[a]);return e}(t);i&&D(t.extendOptions,i),(e=t.options=jt(n,t.extendOptions)).name&&(e.components[e.name]=t)}}return e}function wn(t){this._init(t)}function Bn(t){return t&&(t.Ctor.options.name||t.tag)}function kn(t,e){return Array.isArray(t)?t.indexOf(e)>-1:"string"==typeof t?t.split(",").indexOf(e)>-1:(n=t,"[object RegExp]"===d.call(n)&&t.test(e));var n}function En(t,e){var n=t.cache,i=t.keys,a=t._vnode;for(var o in n){var r=n[o];if(r){var s=Bn(r.componentOptions);s&&!e(s)&&In(n,o,i,a)}}}function In(t,e,n,i){var a=t[e];!a||i&&a.tag===i.tag||a.componentInstance.$destroy(),t[e]=null,b(n,e)}wn.prototype._init=function(t){var e=this;e._uid=Cn++,e._isVue=!0,t&&t._isComponent?function(t,e){var n=t.$options=Object.create(t.constructor.options),i=e._parentVnode;n.parent=e.parent,n._parentVnode=i;var a=i.componentOptions;n.propsData=a.propsData,n._parentListeners=a.listeners,n._renderChildren=a.children,n._componentTag=a.tag,e.render&&(n.render=e.render,n.staticRenderFns=e.staticRenderFns)}(e,t):e.$options=jt(yn(e.constructor),t||{},e),e._renderProxy=e,e._self=e,function(t){var e=t.$options,n=e.parent;if(n&&!e.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(t)}t.$parent=n,t.$root=n?n.$root:t,t.$children=[],t.$refs={},t._watcher=null,t._inactive=null,t._directInactive=!1,t._isMounted=!1,t._isDestroyed=!1,t._isBeingDestroyed=!1}(e),function(t){t._events=Object.create(null),t._hasHookEvent=!1;var e=t.$options._parentListeners;e&&Ze(t,e)}(e),function(t){t._vnode=null,t._staticTrees=null;var e=t.$options,n=t.$vnode=e._parentVnode,a=n&&n.context;t.$slots=ue(e._renderChildren,a),t.$scopedSlots=i,t._c=function(e,n,i,a){return He(t,e,n,i,a,!1)},t.$createElement=function(e,n,i,a){return He(t,e,n,i,a,!0)};var o=n&&n.data;Et(t,"$attrs",o&&o.attrs||i,null,!0),Et(t,"$listeners",e._parentListeners||i,null,!0)}(e),en(e,"beforeCreate"),function(t){var e=he(t.$options.inject,t);e&&(wt(!1),Object.keys(e).forEach(function(n){Et(t,n,e[n])}),wt(!0))}(e),function(t){t._watchers=[];var e=t.$options;e.props&&function(t,e){var n=t.$options.propsData||{},i=t._props={},a=t.$options._propKeys=[];t.$parent&&wt(!1);var o=function(o){a.push(o);var r=Ft(o,e,n,t);Et(i,o,r),o in t||_n(t,"_props",o)};for(var r in e)o(r);wt(!0)}(t,e.props),e.methods&&function(t,e){for(var n in t.$options.props,e)t[n]="function"!=typeof e[n]?N:E(e[n],t)}(t,e.methods),e.data?function(t){var e=t.$options.data;c(e=t._data="function"==typeof e?function(t,e){mt();try{return t.call(e,e)}catch(t){return $t(t,e,"data()"),{}}finally{ft()}}(e,t):e||{})||(e={});for(var n,i=Object.keys(e),a=t.$options.props,o=(t.$options.methods,i.length);o--;){var r=i[o];a&&g(a,r)||36!==(n=(r+"").charCodeAt(0))&&95!==n&&_n(t,"_data",r)}kt(e,!0)}(t):kt(t._data={},!0),e.computed&&function(t,e){var n=t._computedWatchers=Object.create(null),i=at();for(var a in e){var o=e[a],r="function"==typeof o?o:o.get;i||(n[a]=new fn(t,r||N,N,An)),a in t||bn(t,a,o)}}(t,e.computed),e.watch&&e.watch!==et&&function(t,e){for(var n in e){var i=e[n];if(Array.isArray(i))for(var a=0;a<i.length;a++)vn(t,n,i[a]);else vn(t,n,i)}}(t,e.watch)}(e),function(t){var e=t.$options.provide;e&&(t._provided="function"==typeof e?e.call(t):e)}(e),en(e,"created"),e.$options.el&&e.$mount(e.$options.el)},function(t){Object.defineProperty(t.prototype,"$data",{get:function(){return this._data}}),Object.defineProperty(t.prototype,"$props",{get:function(){return this._props}}),t.prototype.$set=It,t.prototype.$delete=Dt,t.prototype.$watch=function(t,e,n){if(c(e))return vn(this,t,e,n);(n=n||{}).user=!0;var i=new fn(this,t,e,n);if(n.immediate)try{e.call(this,i.value)}catch(t){$t(t,this,'callback for immediate watcher "'+i.expression+'"')}return function(){i.teardown()}}}(wn),function(t){var e=/^hook:/;t.prototype.$on=function(t,n){var i=this;if(Array.isArray(t))for(var a=0,o=t.length;a<o;a++)i.$on(t[a],n);else(i._events[t]||(i._events[t]=[])).push(n),e.test(t)&&(i._hasHookEvent=!0);return i},t.prototype.$once=function(t,e){var n=this;function i(){n.$off(t,i),e.apply(n,arguments)}return i.fn=e,n.$on(t,i),n},t.prototype.$off=function(t,e){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(t)){for(var i=0,a=t.length;i<a;i++)n.$off(t[i],e);return n}var o,r=n._events[t];if(!r)return n;if(!e)return n._events[t]=null,n;for(var s=r.length;s--;)if((o=r[s])===e||o.fn===e){r.splice(s,1);break}return n},t.prototype.$emit=function(t){var e=this._events[t];if(e){e=e.length>1?I(e):e;for(var n=I(arguments,1),i='event handler for "'+t+'"',a=0,o=e.length;a<o;a++)zt(e[a],this,n,this,i)}return this}}(wn),function(t){t.prototype._update=function(t,e){var n=this,i=n.$el,a=n._vnode,o=Qe(n);n._vnode=t,n.$el=a?n.__patch__(a,t):n.__patch__(n.$el,t,e,!1),o(),i&&(i.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},t.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},t.prototype.$destroy=function(){var t=this;if(!t._isBeingDestroyed){en(t,"beforeDestroy"),t._isBeingDestroyed=!0;var e=t.$parent;!e||e._isBeingDestroyed||t.$options.abstract||b(e.$children,t),t._watcher&&t._watcher.teardown();for(var n=t._watchers.length;n--;)t._watchers[n].teardown();t._data.__ob__&&t._data.__ob__.vmCount--,t._isDestroyed=!0,t.__patch__(t._vnode,null),en(t,"destroyed"),t.$off(),t.$el&&(t.$el.__vue__=null),t.$vnode&&(t.$vnode.parent=null)}}}(wn),function(t){Ne(t.prototype),t.prototype.$nextTick=function(t){return ee(t,this)},t.prototype._render=function(){var t,e=this,n=e.$options,i=n.render,a=n._parentVnode;a&&(e.$scopedSlots=fe(a.data.scopedSlots,e.$slots,e.$scopedSlots)),e.$vnode=a;try{ze=e,t=i.call(e._renderProxy,e.$createElement)}catch(n){$t(n,e,"render"),t=e._vnode}finally{ze=null}return Array.isArray(t)&&1===t.length&&(t=t[0]),t instanceof pt||(t=At()),t.parent=a,t}}(wn);var Dn=[String,RegExp,Array],Sn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:Dn,exclude:Dn,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var t in this.cache)In(this.cache,t,this.keys)},mounted:function(){var t=this;this.$watch("include",function(e){En(t,function(t){return kn(e,t)})}),this.$watch("exclude",function(e){En(t,function(t){return!kn(e,t)})})},render:function(){var t=this.$slots.default,e=qe(t),n=e&&e.componentOptions;if(n){var i=Bn(n),a=this.include,o=this.exclude;if(a&&(!i||!kn(a,i))||o&&i&&kn(o,i))return e;var r=this.cache,s=this.keys,l=null==e.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):e.key;r[l]?(e.componentInstance=r[l].componentInstance,b(s,l),s.push(l)):(r[l]=e,s.push(l),this.max&&s.length>parseInt(this.max)&&In(r,s[0],s,this._vnode)),e.data.keepAlive=!0}return e||t&&t[0]}}};!function(t){var e={get:function(){return R}};Object.defineProperty(t,"config",e),t.util={warn:dt,extend:D,mergeOptions:jt,defineReactive:Et},t.set=It,t.delete=Dt,t.nextTick=ee,t.observable=function(t){return kt(t),t},t.options=Object.create(null),F.forEach(function(e){t.options[e+"s"]=Object.create(null)}),t.options._base=t,D(t.options.components,Sn),function(t){t.use=function(t){var e=this._installedPlugins||(this._installedPlugins=[]);if(e.indexOf(t)>-1)return this;var n=I(arguments,1);return n.unshift(this),"function"==typeof t.install?t.install.apply(t,n):"function"==typeof t&&t.apply(null,n),e.push(t),this}}(t),function(t){t.mixin=function(t){return this.options=jt(this.options,t),this}}(t),function(t){t.cid=0;var e=1;t.extend=function(t){t=t||{};var n=this,i=n.cid,a=t._Ctor||(t._Ctor={});if(a[i])return a[i];var o=t.name||n.options.name,r=function(t){this._init(t)};return(r.prototype=Object.create(n.prototype)).constructor=r,r.cid=e++,r.options=jt(n.options,t),r.super=n,r.options.props&&function(t){var e=t.options.props;for(var n in e)_n(t.prototype,"_props",n)}(r),r.options.computed&&function(t){var e=t.options.computed;for(var n in e)bn(t.prototype,n,e[n])}(r),r.extend=n.extend,r.mixin=n.mixin,r.use=n.use,F.forEach(function(t){r[t]=n[t]}),o&&(r.options.components[o]=r),r.superOptions=n.options,r.extendOptions=t,r.sealedOptions=D({},r.options),a[i]=r,r}}(t),function(t){F.forEach(function(e){t[e]=function(t,n){return n?("component"===e&&c(n)&&(n.name=n.name||t,n=this.options._base.extend(n)),"directive"===e&&"function"==typeof n&&(n={bind:n,update:n}),this.options[e+"s"][t]=n,n):this.options[e+"s"][t]}})}(t)}(wn),Object.defineProperty(wn.prototype,"$isServer",{get:at}),Object.defineProperty(wn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(wn,"FunctionalRenderContext",{value:Me}),wn.version="2.6.10";var Nn=p("style,class"),Mn=p("input,textarea,option,select,progress"),On=function(t,e,n){return"value"===n&&Mn(t)&&"button"!==e||"selected"===n&&"option"===t||"checked"===n&&"input"===t||"muted"===n&&"video"===t},Tn=p("contenteditable,draggable,spellcheck"),Ln=p("events,caret,typing,plaintext-only"),jn=function(t,e){return Hn(e)||"false"===e?"false":"contenteditable"===t&&Ln(e)?e:"true"},Pn=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),Fn="http://www.w3.org/1999/xlink",Yn=function(t){return":"===t.charAt(5)&&"xlink"===t.slice(0,5)},Rn=function(t){return Yn(t)?t.slice(6,t.length):""},Hn=function(t){return null==t||!1===t};function $n(t,e){return{staticClass:zn(t.staticClass,e.staticClass),class:o(t.class)?[t.class,e.class]:e.class}}function zn(t,e){return t?e?t+" "+e:t:e||""}function Xn(t){return Array.isArray(t)?function(t){for(var e,n="",i=0,a=t.length;i<a;i++)o(e=Xn(t[i]))&&""!==e&&(n&&(n+=" "),n+=e);return n}(t):l(t)?function(t){var e="";for(var n in t)t[n]&&(e&&(e+=" "),e+=n);return e}(t):"string"==typeof t?t:""}var Vn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},qn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),Wn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Un=function(t){return qn(t)||Wn(t)};function Gn(t){return Wn(t)?"svg":"math"===t?"math":void 0}var Zn=Object.create(null),Jn=p("text,number,password,search,email,tel,url");function Qn(t){return"string"==typeof t?document.querySelector(t)||document.createElement("div"):t}var Kn=Object.freeze({createElement:function(t,e){var n=document.createElement(t);return"select"!==t?n:(e.data&&e.data.attrs&&void 0!==e.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(t,e){return document.createElementNS(Vn[t],e)},createTextNode:function(t){return document.createTextNode(t)},createComment:function(t){return document.createComment(t)},insertBefore:function(t,e,n){t.insertBefore(e,n)},removeChild:function(t,e){t.removeChild(e)},appendChild:function(t,e){t.appendChild(e)},parentNode:function(t){return t.parentNode},nextSibling:function(t){return t.nextSibling},tagName:function(t){return t.tagName},setTextContent:function(t,e){t.textContent=e},setStyleScope:function(t,e){t.setAttribute(e,"")}}),ti={create:function(t,e){ei(e)},update:function(t,e){t.data.ref!==e.data.ref&&(ei(t,!0),ei(e))},destroy:function(t){ei(t,!0)}};function ei(t,e){var n=t.data.ref;if(o(n)){var i=t.context,a=t.componentInstance||t.elm,r=i.$refs;e?Array.isArray(r[n])?b(r[n],a):r[n]===a&&(r[n]=void 0):t.data.refInFor?Array.isArray(r[n])?r[n].indexOf(a)<0&&r[n].push(a):r[n]=[a]:r[n]=a}}var ni=new pt("",{},[]),ii=["create","activate","update","remove","destroy"];function ai(t,e){return t.key===e.key&&(t.tag===e.tag&&t.isComment===e.isComment&&o(t.data)===o(e.data)&&function(t,e){if("input"!==t.tag)return!0;var n,i=o(n=t.data)&&o(n=n.attrs)&&n.type,a=o(n=e.data)&&o(n=n.attrs)&&n.type;return i===a||Jn(i)&&Jn(a)}(t,e)||r(t.isAsyncPlaceholder)&&t.asyncFactory===e.asyncFactory&&a(e.asyncFactory.error))}function oi(t,e,n){var i,a,r={};for(i=e;i<=n;++i)o(a=t[i].key)&&(r[a]=i);return r}var ri={create:si,update:si,destroy:function(t){si(t,ni)}};function si(t,e){(t.data.directives||e.data.directives)&&function(t,e){var n,i,a,o=t===ni,r=e===ni,s=di(t.data.directives,t.context),l=di(e.data.directives,e.context),d=[],c=[];for(n in l)i=s[n],a=l[n],i?(a.oldValue=i.value,a.oldArg=i.arg,hi(a,"update",e,t),a.def&&a.def.componentUpdated&&c.push(a)):(hi(a,"bind",e,t),a.def&&a.def.inserted&&d.push(a));if(d.length){var h=function(){for(var n=0;n<d.length;n++)hi(d[n],"inserted",e,t)};o?se(e,"insert",h):h()}if(c.length&&se(e,"postpatch",function(){for(var n=0;n<c.length;n++)hi(c[n],"componentUpdated",e,t)}),!o)for(n in s)l[n]||hi(s[n],"unbind",t,t,r)}(t,e)}var li=Object.create(null);function di(t,e){var n,i,a=Object.create(null);if(!t)return a;for(n=0;n<t.length;n++)(i=t[n]).modifiers||(i.modifiers=li),a[ci(i)]=i,i.def=Pt(e.$options,"directives",i.name);return a}function ci(t){return t.rawName||t.name+"."+Object.keys(t.modifiers||{}).join(".")}function hi(t,e,n,i,a){var o=t.def&&t.def[e];if(o)try{o(n.elm,t,n,i,a)}catch(i){$t(i,n.context,"directive "+t.name+" "+e+" hook")}}var ui=[ti,ri];function mi(t,e){var n=e.componentOptions;if(!(o(n)&&!1===n.Ctor.options.inheritAttrs||a(t.data.attrs)&&a(e.data.attrs))){var i,r,s=e.elm,l=t.data.attrs||{},d=e.data.attrs||{};for(i in o(d.__ob__)&&(d=e.data.attrs=D({},d)),d)r=d[i],l[i]!==r&&fi(s,i,r);for(i in(Z||Q)&&d.value!==l.value&&fi(s,"value",d.value),l)a(d[i])&&(Yn(i)?s.removeAttributeNS(Fn,Rn(i)):Tn(i)||s.removeAttribute(i))}}function fi(t,e,n){t.tagName.indexOf("-")>-1?pi(t,e,n):Pn(e)?Hn(n)?t.removeAttribute(e):(n="allowfullscreen"===e&&"EMBED"===t.tagName?"true":e,t.setAttribute(e,n)):Tn(e)?t.setAttribute(e,jn(e,n)):Yn(e)?Hn(n)?t.removeAttributeNS(Fn,Rn(e)):t.setAttributeNS(Fn,e,n):pi(t,e,n)}function pi(t,e,n){if(Hn(n))t.removeAttribute(e);else{if(Z&&!J&&"TEXTAREA"===t.tagName&&"placeholder"===e&&""!==n&&!t.__ieph){var i=function(e){e.stopImmediatePropagation(),t.removeEventListener("input",i)};t.addEventListener("input",i),t.__ieph=!0}t.setAttribute(e,n)}}var _i={create:mi,update:mi};function Ai(t,e){var n=e.elm,i=e.data,r=t.data;if(!(a(i.staticClass)&&a(i.class)&&(a(r)||a(r.staticClass)&&a(r.class)))){var s=function(t){for(var e=t.data,n=t,i=t;o(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(e=$n(i.data,e));for(;o(n=n.parent);)n&&n.data&&(e=$n(e,n.data));return function(t,e){return o(t)||o(e)?zn(t,Xn(e)):""}(e.staticClass,e.class)}(e),l=n._transitionClasses;o(l)&&(s=zn(s,Xn(l))),s!==n._prevClass&&(n.setAttribute("class",s),n._prevClass=s)}}var bi,xi,gi,vi,Ci,yi,wi={create:Ai,update:Ai},Bi=/[\w).+\-_$\]]/;function ki(t){var e,n,i,a,o,r=!1,s=!1,l=!1,d=!1,c=0,h=0,u=0,m=0;for(i=0;i<t.length;i++)if(n=e,e=t.charCodeAt(i),r)39===e&&92!==n&&(r=!1);else if(s)34===e&&92!==n&&(s=!1);else if(l)96===e&&92!==n&&(l=!1);else if(d)47===e&&92!==n&&(d=!1);else if(124!==e||124===t.charCodeAt(i+1)||124===t.charCodeAt(i-1)||c||h||u){switch(e){case 34:s=!0;break;case 39:r=!0;break;case 96:l=!0;break;case 40:u++;break;case 41:u--;break;case 91:h++;break;case 93:h--;break;case 123:c++;break;case 125:c--}if(47===e){for(var f=i-1,p=void 0;f>=0&&" "===(p=t.charAt(f));f--);p&&Bi.test(p)||(d=!0)}}else void 0===a?(m=i+1,a=t.slice(0,i).trim()):_();function _(){(o||(o=[])).push(t.slice(m,i).trim()),m=i+1}if(void 0===a?a=t.slice(0,i).trim():0!==m&&_(),o)for(i=0;i<o.length;i++)a=Ei(a,o[i]);return a}function Ei(t,e){var n=e.indexOf("(");if(n<0)return'_f("'+e+'")('+t+")";var i=e.slice(0,n),a=e.slice(n+1);return'_f("'+i+'")('+t+(")"!==a?","+a:a)}function Ii(t,e){console.error("[Vue compiler]: "+t)}function Di(t,e){return t?t.map(function(t){return t[e]}).filter(function(t){return t}):[]}function Si(t,e,n,i,a){(t.props||(t.props=[])).push(Yi({name:e,value:n,dynamic:a},i)),t.plain=!1}function Ni(t,e,n,i,a){(a?t.dynamicAttrs||(t.dynamicAttrs=[]):t.attrs||(t.attrs=[])).push(Yi({name:e,value:n,dynamic:a},i)),t.plain=!1}function Mi(t,e,n,i){t.attrsMap[e]=n,t.attrsList.push(Yi({name:e,value:n},i))}function Oi(t,e,n,i,a,o,r,s){(t.directives||(t.directives=[])).push(Yi({name:e,rawName:n,value:i,arg:a,isDynamicArg:o,modifiers:r},s)),t.plain=!1}function Ti(t,e,n){return n?"_p("+e+',"'+t+'")':t+e}function Li(t,e,n,a,o,r,s,l){var d;(a=a||i).right?l?e="("+e+")==='click'?'contextmenu':("+e+")":"click"===e&&(e="contextmenu",delete a.right):a.middle&&(l?e="("+e+")==='click'?'mouseup':("+e+")":"click"===e&&(e="mouseup")),a.capture&&(delete a.capture,e=Ti("!",e,l)),a.once&&(delete a.once,e=Ti("~",e,l)),a.passive&&(delete a.passive,e=Ti("&",e,l)),a.native?(delete a.native,d=t.nativeEvents||(t.nativeEvents={})):d=t.events||(t.events={});var c=Yi({value:n.trim(),dynamic:l},s);a!==i&&(c.modifiers=a);var h=d[e];Array.isArray(h)?o?h.unshift(c):h.push(c):d[e]=h?o?[c,h]:[h,c]:c,t.plain=!1}function ji(t,e,n){var i=Pi(t,":"+e)||Pi(t,"v-bind:"+e);if(null!=i)return ki(i);if(!1!==n){var a=Pi(t,e);if(null!=a)return JSON.stringify(a)}}function Pi(t,e,n){var i;if(null!=(i=t.attrsMap[e]))for(var a=t.attrsList,o=0,r=a.length;o<r;o++)if(a[o].name===e){a.splice(o,1);break}return n&&delete t.attrsMap[e],i}function Fi(t,e){for(var n=t.attrsList,i=0,a=n.length;i<a;i++){var o=n[i];if(e.test(o.name))return n.splice(i,1),o}}function Yi(t,e){return e&&(null!=e.start&&(t.start=e.start),null!=e.end&&(t.end=e.end)),t}function Ri(t,e,n){var i=n||{},a=i.number,o="$$v";i.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),a&&(o="_n("+o+")");var r=Hi(e,o);t.model={value:"("+e+")",expression:JSON.stringify(e),callback:"function ($$v) {"+r+"}"}}function Hi(t,e){var n=function(t){if(t=t.trim(),bi=t.length,t.indexOf("[")<0||t.lastIndexOf("]")<bi-1)return(vi=t.lastIndexOf("."))>-1?{exp:t.slice(0,vi),key:'"'+t.slice(vi+1)+'"'}:{exp:t,key:null};for(xi=t,vi=Ci=yi=0;!zi();)Xi(gi=$i())?qi(gi):91===gi&&Vi(gi);return{exp:t.slice(0,Ci),key:t.slice(Ci+1,yi)}}(t);return null===n.key?t+"="+e:"$set("+n.exp+", "+n.key+", "+e+")"}function $i(){return xi.charCodeAt(++vi)}function zi(){return vi>=bi}function Xi(t){return 34===t||39===t}function Vi(t){var e=1;for(Ci=vi;!zi();)if(Xi(t=$i()))qi(t);else if(91===t&&e++,93===t&&e--,0===e){yi=vi;break}}function qi(t){for(var e=t;!zi()&&(t=$i())!==e;);}var Wi,Ui="__r",Gi="__c";function Zi(t,e,n){var i=Wi;return function a(){null!==e.apply(null,arguments)&&Ki(t,a,n,i)}}var Ji=Wt&&!(tt&&Number(tt[1])<=53);function Qi(t,e,n,i){if(Ji){var a=dn,o=e;e=o._wrapper=function(t){if(t.target===t.currentTarget||t.timeStamp>=a||t.timeStamp<=0||t.target.ownerDocument!==document)return o.apply(this,arguments)}}Wi.addEventListener(t,e,nt?{capture:n,passive:i}:n)}function Ki(t,e,n,i){(i||Wi).removeEventListener(t,e._wrapper||e,n)}function ta(t,e){if(!a(t.data.on)||!a(e.data.on)){var n=e.data.on||{},i=t.data.on||{};Wi=e.elm,function(t){if(o(t[Ui])){var e=Z?"change":"input";t[e]=[].concat(t[Ui],t[e]||[]),delete t[Ui]}o(t[Gi])&&(t.change=[].concat(t[Gi],t.change||[]),delete t[Gi])}(n),re(n,i,Qi,Ki,Zi,e.context),Wi=void 0}}var ea,na={create:ta,update:ta};function ia(t,e){if(!a(t.data.domProps)||!a(e.data.domProps)){var n,i,r=e.elm,s=t.data.domProps||{},l=e.data.domProps||{};for(n in o(l.__ob__)&&(l=e.data.domProps=D({},l)),s)n in l||(r[n]="");for(n in l){if(i=l[n],"textContent"===n||"innerHTML"===n){if(e.children&&(e.children.length=0),i===s[n])continue;1===r.childNodes.length&&r.removeChild(r.childNodes[0])}if("value"===n&&"PROGRESS"!==r.tagName){r._value=i;var d=a(i)?"":String(i);aa(r,d)&&(r.value=d)}else if("innerHTML"===n&&Wn(r.tagName)&&a(r.innerHTML)){(ea=ea||document.createElement("div")).innerHTML="<svg>"+i+"</svg>";for(var c=ea.firstChild;r.firstChild;)r.removeChild(r.firstChild);for(;c.firstChild;)r.appendChild(c.firstChild)}else if(i!==s[n])try{r[n]=i}catch(t){}}}}function aa(t,e){return!t.composing&&("OPTION"===t.tagName||function(t,e){var n=!0;try{n=document.activeElement!==t}catch(t){}return n&&t.value!==e}(t,e)||function(t,e){var n=t.value,i=t._vModifiers;if(o(i)){if(i.number)return f(n)!==f(e);if(i.trim)return n.trim()!==e.trim()}return n!==e}(t,e))}var oa={create:ia,update:ia},ra=v(function(t){var e={},n=/:(.+)/;return t.split(/;(?![^(]*\))/g).forEach(function(t){if(t){var i=t.split(n);i.length>1&&(e[i[0].trim()]=i[1].trim())}}),e});function sa(t){var e=la(t.style);return t.staticStyle?D(t.staticStyle,e):e}function la(t){return Array.isArray(t)?S(t):"string"==typeof t?ra(t):t}var da,ca=/^--/,ha=/\s*!important$/,ua=function(t,e,n){if(ca.test(e))t.style.setProperty(e,n);else if(ha.test(n))t.style.setProperty(k(e),n.replace(ha,""),"important");else{var i=fa(e);if(Array.isArray(n))for(var a=0,o=n.length;a<o;a++)t.style[i]=n[a];else t.style[i]=n}},ma=["Webkit","Moz","ms"],fa=v(function(t){if(da=da||document.createElement("div").style,"filter"!==(t=y(t))&&t in da)return t;for(var e=t.charAt(0).toUpperCase()+t.slice(1),n=0;n<ma.length;n++){var i=ma[n]+e;if(i in da)return i}});function pa(t,e){var n=e.data,i=t.data;if(!(a(n.staticStyle)&&a(n.style)&&a(i.staticStyle)&&a(i.style))){var r,s,l=e.elm,d=i.staticStyle,c=i.normalizedStyle||i.style||{},h=d||c,u=la(e.data.style)||{};e.data.normalizedStyle=o(u.__ob__)?D({},u):u;var m=function(t,e){for(var n,i={},a=t;a.componentInstance;)(a=a.componentInstance._vnode)&&a.data&&(n=sa(a.data))&&D(i,n);(n=sa(t.data))&&D(i,n);for(var o=t;o=o.parent;)o.data&&(n=sa(o.data))&&D(i,n);return i}(e);for(s in h)a(m[s])&&ua(l,s,"");for(s in m)(r=m[s])!==h[s]&&ua(l,s,null==r?"":r)}}var _a={create:pa,update:pa},Aa=/\s+/;function ba(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(Aa).forEach(function(e){return t.classList.add(e)}):t.classList.add(e);else{var n=" "+(t.getAttribute("class")||"")+" ";n.indexOf(" "+e+" ")<0&&t.setAttribute("class",(n+e).trim())}}function xa(t,e){if(e&&(e=e.trim()))if(t.classList)e.indexOf(" ")>-1?e.split(Aa).forEach(function(e){return t.classList.remove(e)}):t.classList.remove(e),t.classList.length||t.removeAttribute("class");else{for(var n=" "+(t.getAttribute("class")||"")+" ",i=" "+e+" ";n.indexOf(i)>=0;)n=n.replace(i," ");(n=n.trim())?t.setAttribute("class",n):t.removeAttribute("class")}}function ga(t){if(t){if("object"==typeof t){var e={};return!1!==t.css&&D(e,va(t.name||"v")),D(e,t),e}return"string"==typeof t?va(t):void 0}}var va=v(function(t){return{enterClass:t+"-enter",enterToClass:t+"-enter-to",enterActiveClass:t+"-enter-active",leaveClass:t+"-leave",leaveToClass:t+"-leave-to",leaveActiveClass:t+"-leave-active"}}),Ca=q&&!J,ya="transition",wa="animation",Ba="transition",ka="transitionend",Ea="animation",Ia="animationend";Ca&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(Ba="WebkitTransition",ka="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Ea="WebkitAnimation",Ia="webkitAnimationEnd"));var Da=q?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(t){return t()};function Sa(t){Da(function(){Da(t)})}function Na(t,e){var n=t._transitionClasses||(t._transitionClasses=[]);n.indexOf(e)<0&&(n.push(e),ba(t,e))}function Ma(t,e){t._transitionClasses&&b(t._transitionClasses,e),xa(t,e)}function Oa(t,e,n){var i=La(t,e),a=i.type,o=i.timeout,r=i.propCount;if(!a)return n();var s=a===ya?ka:Ia,l=0,d=function(){t.removeEventListener(s,c),n()},c=function(e){e.target===t&&++l>=r&&d()};setTimeout(function(){l<r&&d()},o+1),t.addEventListener(s,c)}var Ta=/\b(transform|all)(,|$)/;function La(t,e){var n,i=window.getComputedStyle(t),a=(i[Ba+"Delay"]||"").split(", "),o=(i[Ba+"Duration"]||"").split(", "),r=ja(a,o),s=(i[Ea+"Delay"]||"").split(", "),l=(i[Ea+"Duration"]||"").split(", "),d=ja(s,l),c=0,h=0;return e===ya?r>0&&(n=ya,c=r,h=o.length):e===wa?d>0&&(n=wa,c=d,h=l.length):h=(n=(c=Math.max(r,d))>0?r>d?ya:wa:null)?n===ya?o.length:l.length:0,{type:n,timeout:c,propCount:h,hasTransform:n===ya&&Ta.test(i[Ba+"Property"])}}function ja(t,e){for(;t.length<e.length;)t=t.concat(t);return Math.max.apply(null,e.map(function(e,n){return Pa(e)+Pa(t[n])}))}function Pa(t){return 1e3*Number(t.slice(0,-1).replace(",","."))}function Fa(t,e){var n=t.elm;o(n._leaveCb)&&(n._leaveCb.cancelled=!0,n._leaveCb());var i=ga(t.data.transition);if(!a(i)&&!o(n._enterCb)&&1===n.nodeType){for(var r=i.css,s=i.type,d=i.enterClass,c=i.enterToClass,h=i.enterActiveClass,u=i.appearClass,m=i.appearToClass,p=i.appearActiveClass,_=i.beforeEnter,A=i.enter,b=i.afterEnter,x=i.enterCancelled,g=i.beforeAppear,v=i.appear,C=i.afterAppear,y=i.appearCancelled,w=i.duration,B=Je,k=Je.$vnode;k&&k.parent;)B=k.context,k=k.parent;var E=!B._isMounted||!t.isRootInsert;if(!E||v||""===v){var I=E&&u?u:d,D=E&&p?p:h,S=E&&m?m:c,N=E&&g||_,M=E&&"function"==typeof v?v:A,O=E&&C||b,T=E&&y||x,L=f(l(w)?w.enter:w),P=!1!==r&&!J,F=Ha(M),Y=n._enterCb=j(function(){P&&(Ma(n,S),Ma(n,D)),Y.cancelled?(P&&Ma(n,I),T&&T(n)):O&&O(n),n._enterCb=null});t.data.show||se(t,"insert",function(){var e=n.parentNode,i=e&&e._pending&&e._pending[t.key];i&&i.tag===t.tag&&i.elm._leaveCb&&i.elm._leaveCb(),M&&M(n,Y)}),N&&N(n),P&&(Na(n,I),Na(n,D),Sa(function(){Ma(n,I),Y.cancelled||(Na(n,S),F||(Ra(L)?setTimeout(Y,L):Oa(n,s,Y)))})),t.data.show&&(e&&e(),M&&M(n,Y)),P||F||Y()}}}function Ya(t,e){var n=t.elm;o(n._enterCb)&&(n._enterCb.cancelled=!0,n._enterCb());var i=ga(t.data.transition);if(a(i)||1!==n.nodeType)return e();if(!o(n._leaveCb)){var r=i.css,s=i.type,d=i.leaveClass,c=i.leaveToClass,h=i.leaveActiveClass,u=i.beforeLeave,m=i.leave,p=i.afterLeave,_=i.leaveCancelled,A=i.delayLeave,b=i.duration,x=!1!==r&&!J,g=Ha(m),v=f(l(b)?b.leave:b),C=n._leaveCb=j(function(){n.parentNode&&n.parentNode._pending&&(n.parentNode._pending[t.key]=null),x&&(Ma(n,c),Ma(n,h)),C.cancelled?(x&&Ma(n,d),_&&_(n)):(e(),p&&p(n)),n._leaveCb=null});A?A(y):y()}function y(){C.cancelled||(!t.data.show&&n.parentNode&&((n.parentNode._pending||(n.parentNode._pending={}))[t.key]=t),u&&u(n),x&&(Na(n,d),Na(n,h),Sa(function(){Ma(n,d),C.cancelled||(Na(n,c),g||(Ra(v)?setTimeout(C,v):Oa(n,s,C)))})),m&&m(n,C),x||g||C())}}function Ra(t){return"number"==typeof t&&!isNaN(t)}function Ha(t){if(a(t))return!1;var e=t.fns;return o(e)?Ha(Array.isArray(e)?e[0]:e):(t._length||t.length)>1}function $a(t,e){!0!==e.data.show&&Fa(e)}var za=function(t){var e,n,i={},l=t.modules,d=t.nodeOps;for(e=0;e<ii.length;++e)for(i[ii[e]]=[],n=0;n<l.length;++n)o(l[n][ii[e]])&&i[ii[e]].push(l[n][ii[e]]);function c(t){var e=d.parentNode(t);o(e)&&d.removeChild(e,t)}function h(t,e,n,a,s,l,c){if(o(t.elm)&&o(l)&&(t=l[c]=xt(t)),t.isRootInsert=!s,!function(t,e,n,a){var s=t.data;if(o(s)){var l=o(t.componentInstance)&&s.keepAlive;if(o(s=s.hook)&&o(s=s.init)&&s(t,!1),o(t.componentInstance))return u(t,e),m(n,t.elm,a),r(l)&&function(t,e,n,a){for(var r,s=t;s.componentInstance;)if(o(r=(s=s.componentInstance._vnode).data)&&o(r=r.transition)){for(r=0;r<i.activate.length;++r)i.activate[r](ni,s);e.push(s);break}m(n,t.elm,a)}(t,e,n,a),!0}}(t,e,n,a)){var h=t.data,p=t.children,_=t.tag;o(_)?(t.elm=t.ns?d.createElementNS(t.ns,_):d.createElement(_,t),b(t),f(t,p,e),o(h)&&A(t,e),m(n,t.elm,a)):r(t.isComment)?(t.elm=d.createComment(t.text),m(n,t.elm,a)):(t.elm=d.createTextNode(t.text),m(n,t.elm,a))}}function u(t,e){o(t.data.pendingInsert)&&(e.push.apply(e,t.data.pendingInsert),t.data.pendingInsert=null),t.elm=t.componentInstance.$el,_(t)?(A(t,e),b(t)):(ei(t),e.push(t))}function m(t,e,n){o(t)&&(o(n)?d.parentNode(n)===t&&d.insertBefore(t,e,n):d.appendChild(t,e))}function f(t,e,n){if(Array.isArray(e))for(var i=0;i<e.length;++i)h(e[i],n,t.elm,null,!0,e,i);else s(t.text)&&d.appendChild(t.elm,d.createTextNode(String(t.text)))}function _(t){for(;t.componentInstance;)t=t.componentInstance._vnode;return o(t.tag)}function A(t,n){for(var a=0;a<i.create.length;++a)i.create[a](ni,t);o(e=t.data.hook)&&(o(e.create)&&e.create(ni,t),o(e.insert)&&n.push(t))}function b(t){var e;if(o(e=t.fnScopeId))d.setStyleScope(t.elm,e);else for(var n=t;n;)o(e=n.context)&&o(e=e.$options._scopeId)&&d.setStyleScope(t.elm,e),n=n.parent;o(e=Je)&&e!==t.context&&e!==t.fnContext&&o(e=e.$options._scopeId)&&d.setStyleScope(t.elm,e)}function x(t,e,n,i,a,o){for(;i<=a;++i)h(n[i],o,t,e,!1,n,i)}function g(t){var e,n,a=t.data;if(o(a))for(o(e=a.hook)&&o(e=e.destroy)&&e(t),e=0;e<i.destroy.length;++e)i.destroy[e](t);if(o(e=t.children))for(n=0;n<t.children.length;++n)g(t.children[n])}function v(t,e,n,i){for(;n<=i;++n){var a=e[n];o(a)&&(o(a.tag)?(C(a),g(a)):c(a.elm))}}function C(t,e){if(o(e)||o(t.data)){var n,a=i.remove.length+1;for(o(e)?e.listeners+=a:e=function(t,e){function n(){0==--n.listeners&&c(t)}return n.listeners=e,n}(t.elm,a),o(n=t.componentInstance)&&o(n=n._vnode)&&o(n.data)&&C(n,e),n=0;n<i.remove.length;++n)i.remove[n](t,e);o(n=t.data.hook)&&o(n=n.remove)?n(t,e):e()}else c(t.elm)}function y(t,e,n,i){for(var a=n;a<i;a++){var r=e[a];if(o(r)&&ai(t,r))return a}}function w(t,e,n,s,l,c){if(t!==e){o(e.elm)&&o(s)&&(e=s[l]=xt(e));var u=e.elm=t.elm;if(r(t.isAsyncPlaceholder))o(e.asyncFactory.resolved)?E(t.elm,e,n):e.isAsyncPlaceholder=!0;else if(r(e.isStatic)&&r(t.isStatic)&&e.key===t.key&&(r(e.isCloned)||r(e.isOnce)))e.componentInstance=t.componentInstance;else{var m,f=e.data;o(f)&&o(m=f.hook)&&o(m=m.prepatch)&&m(t,e);var p=t.children,A=e.children;if(o(f)&&_(e)){for(m=0;m<i.update.length;++m)i.update[m](t,e);o(m=f.hook)&&o(m=m.update)&&m(t,e)}a(e.text)?o(p)&&o(A)?p!==A&&function(t,e,n,i,r){for(var s,l,c,u=0,m=0,f=e.length-1,p=e[0],_=e[f],A=n.length-1,b=n[0],g=n[A],C=!r;u<=f&&m<=A;)a(p)?p=e[++u]:a(_)?_=e[--f]:ai(p,b)?(w(p,b,i,n,m),p=e[++u],b=n[++m]):ai(_,g)?(w(_,g,i,n,A),_=e[--f],g=n[--A]):ai(p,g)?(w(p,g,i,n,A),C&&d.insertBefore(t,p.elm,d.nextSibling(_.elm)),p=e[++u],g=n[--A]):ai(_,b)?(w(_,b,i,n,m),C&&d.insertBefore(t,_.elm,p.elm),_=e[--f],b=n[++m]):(a(s)&&(s=oi(e,u,f)),a(l=o(b.key)?s[b.key]:y(b,e,u,f))?h(b,i,t,p.elm,!1,n,m):ai(c=e[l],b)?(w(c,b,i,n,m),e[l]=void 0,C&&d.insertBefore(t,c.elm,p.elm)):h(b,i,t,p.elm,!1,n,m),b=n[++m]);u>f?x(t,a(n[A+1])?null:n[A+1].elm,n,m,A,i):m>A&&v(0,e,u,f)}(u,p,A,n,c):o(A)?(o(t.text)&&d.setTextContent(u,""),x(u,null,A,0,A.length-1,n)):o(p)?v(0,p,0,p.length-1):o(t.text)&&d.setTextContent(u,""):t.text!==e.text&&d.setTextContent(u,e.text),o(f)&&o(m=f.hook)&&o(m=m.postpatch)&&m(t,e)}}}function B(t,e,n){if(r(n)&&o(t.parent))t.parent.data.pendingInsert=e;else for(var i=0;i<e.length;++i)e[i].data.hook.insert(e[i])}var k=p("attrs,class,staticClass,staticStyle,key");function E(t,e,n,i){var a,s=e.tag,l=e.data,d=e.children;if(i=i||l&&l.pre,e.elm=t,r(e.isComment)&&o(e.asyncFactory))return e.isAsyncPlaceholder=!0,!0;if(o(l)&&(o(a=l.hook)&&o(a=a.init)&&a(e,!0),o(a=e.componentInstance)))return u(e,n),!0;if(o(s)){if(o(d))if(t.hasChildNodes())if(o(a=l)&&o(a=a.domProps)&&o(a=a.innerHTML)){if(a!==t.innerHTML)return!1}else{for(var c=!0,h=t.firstChild,m=0;m<d.length;m++){if(!h||!E(h,d[m],n,i)){c=!1;break}h=h.nextSibling}if(!c||h)return!1}else f(e,d,n);if(o(l)){var p=!1;for(var _ in l)if(!k(_)){p=!0,A(e,n);break}!p&&l.class&&ie(l.class)}}else t.data!==e.text&&(t.data=e.text);return!0}return function(t,e,n,s){if(!a(e)){var l,c=!1,u=[];if(a(t))c=!0,h(e,u);else{var m=o(t.nodeType);if(!m&&ai(t,e))w(t,e,u,null,null,s);else{if(m){if(1===t.nodeType&&t.hasAttribute(P)&&(t.removeAttribute(P),n=!0),r(n)&&E(t,e,u))return B(e,u,!0),t;l=t,t=new pt(d.tagName(l).toLowerCase(),{},[],void 0,l)}var f=t.elm,p=d.parentNode(f);if(h(e,u,f._leaveCb?null:p,d.nextSibling(f)),o(e.parent))for(var A=e.parent,b=_(e);A;){for(var x=0;x<i.destroy.length;++x)i.destroy[x](A);if(A.elm=e.elm,b){for(var C=0;C<i.create.length;++C)i.create[C](ni,A);var y=A.data.hook.insert;if(y.merged)for(var k=1;k<y.fns.length;k++)y.fns[k]()}else ei(A);A=A.parent}o(p)?v(0,[t],0,0):o(t.tag)&&g(t)}}return B(e,u,c),e.elm}o(t)&&g(t)}}({nodeOps:Kn,modules:[_i,wi,na,oa,_a,q?{create:$a,activate:$a,remove:function(t,e){!0!==t.data.show?Ya(t,e):e()}}:{}].concat(ui)});J&&document.addEventListener("selectionchange",function(){var t=document.activeElement;t&&t.vmodel&&Ja(t,"input")});var Xa={inserted:function(t,e,n,i){"select"===n.tag?(i.elm&&!i.elm._vOptions?se(n,"postpatch",function(){Xa.componentUpdated(t,e,n)}):Va(t,e,n.context),t._vOptions=[].map.call(t.options,Ua)):("textarea"===n.tag||Jn(t.type))&&(t._vModifiers=e.modifiers,e.modifiers.lazy||(t.addEventListener("compositionstart",Ga),t.addEventListener("compositionend",Za),t.addEventListener("change",Za),J&&(t.vmodel=!0)))},componentUpdated:function(t,e,n){if("select"===n.tag){Va(t,e,n.context);var i=t._vOptions,a=t._vOptions=[].map.call(t.options,Ua);a.some(function(t,e){return!T(t,i[e])})&&(t.multiple?e.value.some(function(t){return Wa(t,a)}):e.value!==e.oldValue&&Wa(e.value,a))&&Ja(t,"change")}}};function Va(t,e,n){qa(t,e,n),(Z||Q)&&setTimeout(function(){qa(t,e,n)},0)}function qa(t,e,n){var i=e.value,a=t.multiple;if(!a||Array.isArray(i)){for(var o,r,s=0,l=t.options.length;s<l;s++)if(r=t.options[s],a)o=L(i,Ua(r))>-1,r.selected!==o&&(r.selected=o);else if(T(Ua(r),i))return void(t.selectedIndex!==s&&(t.selectedIndex=s));a||(t.selectedIndex=-1)}}function Wa(t,e){return e.every(function(e){return!T(e,t)})}function Ua(t){return"_value"in t?t._value:t.value}function Ga(t){t.target.composing=!0}function Za(t){t.target.composing&&(t.target.composing=!1,Ja(t.target,"input"))}function Ja(t,e){var n=document.createEvent("HTMLEvents");n.initEvent(e,!0,!0),t.dispatchEvent(n)}function Qa(t){return!t.componentInstance||t.data&&t.data.transition?t:Qa(t.componentInstance._vnode)}var Ka={model:Xa,show:{bind:function(t,e,n){var i=e.value,a=(n=Qa(n)).data&&n.data.transition,o=t.__vOriginalDisplay="none"===t.style.display?"":t.style.display;i&&a?(n.data.show=!0,Fa(n,function(){t.style.display=o})):t.style.display=i?o:"none"},update:function(t,e,n){var i=e.value;!i!=!e.oldValue&&((n=Qa(n)).data&&n.data.transition?(n.data.show=!0,i?Fa(n,function(){t.style.display=t.__vOriginalDisplay}):Ya(n,function(){t.style.display="none"})):t.style.display=i?t.__vOriginalDisplay:"none")},unbind:function(t,e,n,i,a){a||(t.style.display=t.__vOriginalDisplay)}}},to={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function eo(t){var e=t&&t.componentOptions;return e&&e.Ctor.options.abstract?eo(qe(e.children)):t}function no(t){var e={},n=t.$options;for(var i in n.propsData)e[i]=t[i];var a=n._parentListeners;for(var o in a)e[y(o)]=a[o];return e}function io(t,e){if(/\d-keep-alive$/.test(e.tag))return t("keep-alive",{props:e.componentOptions.propsData})}var ao=function(t){return t.tag||Ve(t)},oo=function(t){return"show"===t.name},ro={name:"transition",props:to,abstract:!0,render:function(t){var e=this,n=this.$slots.default;if(n&&(n=n.filter(ao)).length){var i=this.mode,a=n[0];if(function(t){for(;t=t.parent;)if(t.data.transition)return!0}(this.$vnode))return a;var o=eo(a);if(!o)return a;if(this._leaving)return io(t,a);var r="__transition-"+this._uid+"-";o.key=null==o.key?o.isComment?r+"comment":r+o.tag:s(o.key)?0===String(o.key).indexOf(r)?o.key:r+o.key:o.key;var l=(o.data||(o.data={})).transition=no(this),d=this._vnode,c=eo(d);if(o.data.directives&&o.data.directives.some(oo)&&(o.data.show=!0),c&&c.data&&!function(t,e){return e.key===t.key&&e.tag===t.tag}(o,c)&&!Ve(c)&&(!c.componentInstance||!c.componentInstance._vnode.isComment)){var h=c.data.transition=D({},l);if("out-in"===i)return this._leaving=!0,se(h,"afterLeave",function(){e._leaving=!1,e.$forceUpdate()}),io(t,a);if("in-out"===i){if(Ve(o))return d;var u,m=function(){u()};se(l,"afterEnter",m),se(l,"enterCancelled",m),se(h,"delayLeave",function(t){u=t})}}return a}}},so=D({tag:String,moveClass:String},to);function lo(t){t.elm._moveCb&&t.elm._moveCb(),t.elm._enterCb&&t.elm._enterCb()}function co(t){t.data.newPos=t.elm.getBoundingClientRect()}function ho(t){var e=t.data.pos,n=t.data.newPos,i=e.left-n.left,a=e.top-n.top;if(i||a){t.data.moved=!0;var o=t.elm.style;o.transform=o.WebkitTransform="translate("+i+"px,"+a+"px)",o.transitionDuration="0s"}}delete so.mode;var uo={Transition:ro,TransitionGroup:{props:so,beforeMount:function(){var t=this,e=this._update;this._update=function(n,i){var a=Qe(t);t.__patch__(t._vnode,t.kept,!1,!0),t._vnode=t.kept,a(),e.call(t,n,i)}},render:function(t){for(var e=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),i=this.prevChildren=this.children,a=this.$slots.default||[],o=this.children=[],r=no(this),s=0;s<a.length;s++){var l=a[s];l.tag&&null!=l.key&&0!==String(l.key).indexOf("__vlist")&&(o.push(l),n[l.key]=l,(l.data||(l.data={})).transition=r)}if(i){for(var d=[],c=[],h=0;h<i.length;h++){var u=i[h];u.data.transition=r,u.data.pos=u.elm.getBoundingClientRect(),n[u.key]?d.push(u):c.push(u)}this.kept=t(e,null,d),this.removed=c}return t(e,null,o)},updated:function(){var t=this.prevChildren,e=this.moveClass||(this.name||"v")+"-move";t.length&&this.hasMove(t[0].elm,e)&&(t.forEach(lo),t.forEach(co),t.forEach(ho),this._reflow=document.body.offsetHeight,t.forEach(function(t){if(t.data.moved){var n=t.elm,i=n.style;Na(n,e),i.transform=i.WebkitTransform=i.transitionDuration="",n.addEventListener(ka,n._moveCb=function t(i){i&&i.target!==n||i&&!/transform$/.test(i.propertyName)||(n.removeEventListener(ka,t),n._moveCb=null,Ma(n,e))})}}))},methods:{hasMove:function(t,e){if(!Ca)return!1;if(this._hasMove)return this._hasMove;var n=t.cloneNode();t._transitionClasses&&t._transitionClasses.forEach(function(t){xa(n,t)}),ba(n,e),n.style.display="none",this.$el.appendChild(n);var i=La(n);return this.$el.removeChild(n),this._hasMove=i.hasTransform}}}};wn.config.mustUseProp=On,wn.config.isReservedTag=Un,wn.config.isReservedAttr=Nn,wn.config.getTagNamespace=Gn,wn.config.isUnknownElement=function(t){if(!q)return!0;if(Un(t))return!1;if(t=t.toLowerCase(),null!=Zn[t])return Zn[t];var e=document.createElement(t);return t.indexOf("-")>-1?Zn[t]=e.constructor===window.HTMLUnknownElement||e.constructor===window.HTMLElement:Zn[t]=/HTMLUnknownElement/.test(e.toString())},D(wn.options.directives,Ka),D(wn.options.components,uo),wn.prototype.__patch__=q?za:N,wn.prototype.$mount=function(t,e){return function(t,e,n){return t.$el=e,t.$options.render||(t.$options.render=At),en(t,"beforeMount"),new fn(t,function(){t._update(t._render(),n)},N,{before:function(){t._isMounted&&!t._isDestroyed&&en(t,"beforeUpdate")}},!0),n=!1,null==t.$vnode&&(t._isMounted=!0,en(t,"mounted")),t}(this,t=t&&q?Qn(t):void 0,e)},q&&setTimeout(function(){R.devtools&&ot&&ot.emit("init",wn)},0);var mo,fo=/\{\{((?:.|\r?\n)+?)\}\}/g,po=/[-.*+?^${}()|[\]\/\\]/g,_o=v(function(t){var e=t[0].replace(po,"\\$&"),n=t[1].replace(po,"\\$&");return new RegExp(e+"((?:.|\\n)+?)"+n,"g")}),Ao={staticKeys:["staticClass"],transformNode:function(t,e){e.warn;var n=Pi(t,"class");n&&(t.staticClass=JSON.stringify(n));var i=ji(t,"class",!1);i&&(t.classBinding=i)},genData:function(t){var e="";return t.staticClass&&(e+="staticClass:"+t.staticClass+","),t.classBinding&&(e+="class:"+t.classBinding+","),e}},bo={staticKeys:["staticStyle"],transformNode:function(t,e){e.warn;var n=Pi(t,"style");n&&(t.staticStyle=JSON.stringify(ra(n)));var i=ji(t,"style",!1);i&&(t.styleBinding=i)},genData:function(t){var e="";return t.staticStyle&&(e+="staticStyle:"+t.staticStyle+","),t.styleBinding&&(e+="style:("+t.styleBinding+"),"),e}},xo=p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),go=p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),vo=p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),Co=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,yo=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,wo="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+H.source+"]*",Bo="((?:"+wo+"\\:)?"+wo+")",ko=new RegExp("^<"+Bo),Eo=/^\s*(\/?)>/,Io=new RegExp("^<\\/"+Bo+"[^>]*>"),Do=/^<!DOCTYPE [^>]+>/i,So=/^<!\--/,No=/^<!\[/,Mo=p("script,style,textarea",!0),Oo={},To={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},Lo=/&(?:lt|gt|quot|amp|#39);/g,jo=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,Po=p("pre,textarea",!0),Fo=function(t,e){return t&&Po(t)&&"\n"===e[0]};function Yo(t,e){var n=e?jo:Lo;return t.replace(n,function(t){return To[t]})}var Ro,Ho,$o,zo,Xo,Vo,qo,Wo,Uo=/^@|^v-on:/,Go=/^v-|^@|^:/,Zo=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,Jo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,Qo=/^\(|\)$/g,Ko=/^\[.*\]$/,tr=/:(.*)$/,er=/^:|^\.|^v-bind:/,nr=/\.[^.\]]+(?=[^\]]*$)/g,ir=/^v-slot(:|$)|^#/,ar=/[\r\n]/,or=/\s+/g,rr=v(function(t){return(mo=mo||document.createElement("div")).innerHTML=t,mo.textContent}),sr="_empty_";function lr(t,e,n){return{type:1,tag:t,attrsList:e,attrsMap:function(t){for(var e={},n=0,i=t.length;n<i;n++)e[t[n].name]=t[n].value;return e}(e),rawAttrsMap:{},parent:n,children:[]}}function dr(t,e){var n,i;(i=ji(n=t,"key"))&&(n.key=i),t.plain=!t.key&&!t.scopedSlots&&!t.attrsList.length,function(t){var e=ji(t,"ref");e&&(t.ref=e,t.refInFor=function(t){for(var e=t;e;){if(void 0!==e.for)return!0;e=e.parent}return!1}(t))}(t),function(t){var e;"template"===t.tag?(e=Pi(t,"scope"),t.slotScope=e||Pi(t,"slot-scope")):(e=Pi(t,"slot-scope"))&&(t.slotScope=e);var n=ji(t,"slot");if(n&&(t.slotTarget='""'===n?'"default"':n,t.slotTargetDynamic=!(!t.attrsMap[":slot"]&&!t.attrsMap["v-bind:slot"]),"template"===t.tag||t.slotScope||Ni(t,"slot",n,function(t,e){return t.rawAttrsMap[":"+e]||t.rawAttrsMap["v-bind:"+e]||t.rawAttrsMap[e]}(t,"slot"))),"template"===t.tag){var i=Fi(t,ir);if(i){var a=ur(i),o=a.name,r=a.dynamic;t.slotTarget=o,t.slotTargetDynamic=r,t.slotScope=i.value||sr}}else{var s=Fi(t,ir);if(s){var l=t.scopedSlots||(t.scopedSlots={}),d=ur(s),c=d.name,h=d.dynamic,u=l[c]=lr("template",[],t);u.slotTarget=c,u.slotTargetDynamic=h,u.children=t.children.filter(function(t){if(!t.slotScope)return t.parent=u,!0}),u.slotScope=s.value||sr,t.children=[],t.plain=!1}}}(t),function(t){"slot"===t.tag&&(t.slotName=ji(t,"name"))}(t),function(t){var e;(e=ji(t,"is"))&&(t.component=e),null!=Pi(t,"inline-template")&&(t.inlineTemplate=!0)}(t);for(var a=0;a<$o.length;a++)t=$o[a](t,e)||t;return function(t){var e,n,i,a,o,r,s,l,d=t.attrsList;for(e=0,n=d.length;e<n;e++)if(i=a=d[e].name,o=d[e].value,Go.test(i))if(t.hasBindings=!0,(r=mr(i.replace(Go,"")))&&(i=i.replace(nr,"")),er.test(i))i=i.replace(er,""),o=ki(o),(l=Ko.test(i))&&(i=i.slice(1,-1)),r&&(r.prop&&!l&&"innerHtml"===(i=y(i))&&(i="innerHTML"),r.camel&&!l&&(i=y(i)),r.sync&&(s=Hi(o,"$event"),l?Li(t,'"update:"+('+i+")",s,null,!1,0,d[e],!0):(Li(t,"update:"+y(i),s,null,!1,0,d[e]),k(i)!==y(i)&&Li(t,"update:"+k(i),s,null,!1,0,d[e])))),r&&r.prop||!t.component&&qo(t.tag,t.attrsMap.type,i)?Si(t,i,o,d[e],l):Ni(t,i,o,d[e],l);else if(Uo.test(i))i=i.replace(Uo,""),(l=Ko.test(i))&&(i=i.slice(1,-1)),Li(t,i,o,r,!1,0,d[e],l);else{var c=(i=i.replace(Go,"")).match(tr),h=c&&c[1];l=!1,h&&(i=i.slice(0,-(h.length+1)),Ko.test(h)&&(h=h.slice(1,-1),l=!0)),Oi(t,i,a,o,h,l,r,d[e])}else Ni(t,i,JSON.stringify(o),d[e]),!t.component&&"muted"===i&&qo(t.tag,t.attrsMap.type,i)&&Si(t,i,"true",d[e])}(t),t}function cr(t){var e;if(e=Pi(t,"v-for")){var n=function(t){var e=t.match(Zo);if(e){var n={};n.for=e[2].trim();var i=e[1].trim().replace(Qo,""),a=i.match(Jo);return a?(n.alias=i.replace(Jo,"").trim(),n.iterator1=a[1].trim(),a[2]&&(n.iterator2=a[2].trim())):n.alias=i,n}}(e);n&&D(t,n)}}function hr(t,e){t.ifConditions||(t.ifConditions=[]),t.ifConditions.push(e)}function ur(t){var e=t.name.replace(ir,"");return e||"#"!==t.name[0]&&(e="default"),Ko.test(e)?{name:e.slice(1,-1),dynamic:!0}:{name:'"'+e+'"',dynamic:!1}}function mr(t){var e=t.match(nr);if(e){var n={};return e.forEach(function(t){n[t.slice(1)]=!0}),n}}var fr=/^xmlns:NS\d+/,pr=/^NS\d+:/;function _r(t){return lr(t.tag,t.attrsList.slice(),t.parent)}var Ar,br,xr=[Ao,bo,{preTransformNode:function(t,e){if("input"===t.tag){var n,i=t.attrsMap;if(!i["v-model"])return;if((i[":type"]||i["v-bind:type"])&&(n=ji(t,"type")),i.type||n||!i["v-bind"]||(n="("+i["v-bind"]+").type"),n){var a=Pi(t,"v-if",!0),o=a?"&&("+a+")":"",r=null!=Pi(t,"v-else",!0),s=Pi(t,"v-else-if",!0),l=_r(t);cr(l),Mi(l,"type","checkbox"),dr(l,e),l.processed=!0,l.if="("+n+")==='checkbox'"+o,hr(l,{exp:l.if,block:l});var d=_r(t);Pi(d,"v-for",!0),Mi(d,"type","radio"),dr(d,e),hr(l,{exp:"("+n+")==='radio'"+o,block:d});var c=_r(t);return Pi(c,"v-for",!0),Mi(c,":type",n),dr(c,e),hr(l,{exp:a,block:c}),r?l.else=!0:s&&(l.elseif=s),l}}}}],gr={expectHTML:!0,modules:xr,directives:{model:function(t,e,n){var i=e.value,a=e.modifiers,o=t.tag,r=t.attrsMap.type;if(t.component)return Ri(t,i,a),!1;if("select"===o)!function(t,e,n){var i='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(a&&a.number?"_n(val)":"val")+"});";Li(t,"change",i=i+" "+Hi(e,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),null,!0)}(t,i);else if("input"===o&&"checkbox"===r)!function(t,e,n){var i=n&&n.number,a=ji(t,"value")||"null",o=ji(t,"true-value")||"true",r=ji(t,"false-value")||"false";Si(t,"checked","Array.isArray("+e+")?_i("+e+","+a+")>-1"+("true"===o?":("+e+")":":_q("+e+","+o+")")),Li(t,"change","var $$a="+e+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+r+");if(Array.isArray($$a)){var $$v="+(i?"_n("+a+")":a)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Hi(e,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Hi(e,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Hi(e,"$$c")+"}",null,!0)}(t,i,a);else if("input"===o&&"radio"===r)!function(t,e,n){var i=n&&n.number,a=ji(t,"value")||"null";Si(t,"checked","_q("+e+","+(a=i?"_n("+a+")":a)+")"),Li(t,"change",Hi(e,a),null,!0)}(t,i,a);else if("input"===o||"textarea"===o)!function(t,e,n){var i=t.attrsMap.type,a=n||{},o=a.lazy,r=a.number,s=a.trim,l=!o&&"range"!==i,d=o?"change":"range"===i?Ui:"input",c="$event.target.value";s&&(c="$event.target.value.trim()"),r&&(c="_n("+c+")");var h=Hi(e,c);l&&(h="if($event.target.composing)return;"+h),Si(t,"value","("+e+")"),Li(t,d,h,null,!0),(s||r)&&Li(t,"blur","$forceUpdate()")}(t,i,a);else if(!R.isReservedTag(o))return Ri(t,i,a),!1;return!0},text:function(t,e){e.value&&Si(t,"textContent","_s("+e.value+")",e)},html:function(t,e){e.value&&Si(t,"innerHTML","_s("+e.value+")",e)}},isPreTag:function(t){return"pre"===t},isUnaryTag:xo,mustUseProp:On,canBeLeftOpenTag:go,isReservedTag:Un,getTagNamespace:Gn,staticKeys:xr.reduce(function(t,e){return t.concat(e.staticKeys||[])},[]).join(",")},vr=v(function(t){return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(t?","+t:""))}),Cr=/^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/,yr=/\([^)]*?\);*$/,wr=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Br={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},kr={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},Er=function(t){return"if("+t+")return null;"},Ir={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:Er("$event.target !== $event.currentTarget"),ctrl:Er("!$event.ctrlKey"),shift:Er("!$event.shiftKey"),alt:Er("!$event.altKey"),meta:Er("!$event.metaKey"),left:Er("'button' in $event && $event.button !== 0"),middle:Er("'button' in $event && $event.button !== 1"),right:Er("'button' in $event && $event.button !== 2")};function Dr(t,e){var n=e?"nativeOn:":"on:",i="",a="";for(var o in t){var r=Sr(t[o]);t[o]&&t[o].dynamic?a+=o+","+r+",":i+='"'+o+'":'+r+","}return i="{"+i.slice(0,-1)+"}",a?n+"_d("+i+",["+a.slice(0,-1)+"])":n+i}function Sr(t){if(!t)return"function(){}";if(Array.isArray(t))return"["+t.map(function(t){return Sr(t)}).join(",")+"]";var e=wr.test(t.value),n=Cr.test(t.value),i=wr.test(t.value.replace(yr,""));if(t.modifiers){var a="",o="",r=[];for(var s in t.modifiers)if(Ir[s])o+=Ir[s],Br[s]&&r.push(s);else if("exact"===s){var l=t.modifiers;o+=Er(["ctrl","shift","alt","meta"].filter(function(t){return!l[t]}).map(function(t){return"$event."+t+"Key"}).join("||"))}else r.push(s);return r.length&&(a+="if(!$event.type.indexOf('key')&&"+r.map(Nr).join("&&")+")return null;"),o&&(a+=o),"function($event){"+a+(e?"return "+t.value+"($event)":n?"return ("+t.value+")($event)":i?"return "+t.value:t.value)+"}"}return e||n?t.value:"function($event){"+(i?"return "+t.value:t.value)+"}"}function Nr(t){var e=parseInt(t,10);if(e)return"$event.keyCode!=="+e;var n=Br[t],i=kr[t];return"_k($event.keyCode,"+JSON.stringify(t)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(i)+")"}var Mr={on:function(t,e){t.wrapListeners=function(t){return"_g("+t+","+e.value+")"}},bind:function(t,e){t.wrapData=function(n){return"_b("+n+",'"+t.tag+"',"+e.value+","+(e.modifiers&&e.modifiers.prop?"true":"false")+(e.modifiers&&e.modifiers.sync?",true":"")+")"}},cloak:N},Or=function(t){this.options=t,this.warn=t.warn||Ii,this.transforms=Di(t.modules,"transformCode"),this.dataGenFns=Di(t.modules,"genData"),this.directives=D(D({},Mr),t.directives);var e=t.isReservedTag||M;this.maybeComponent=function(t){return!!t.component||!e(t.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Tr(t,e){var n=new Or(e);return{render:"with(this){return "+(t?Lr(t,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function Lr(t,e){if(t.parent&&(t.pre=t.pre||t.parent.pre),t.staticRoot&&!t.staticProcessed)return jr(t,e);if(t.once&&!t.onceProcessed)return Pr(t,e);if(t.for&&!t.forProcessed)return Yr(t,e);if(t.if&&!t.ifProcessed)return Fr(t,e);if("template"!==t.tag||t.slotTarget||e.pre){if("slot"===t.tag)return function(t,e){var n=t.slotName||'"default"',i=zr(t,e),a="_t("+n+(i?","+i:""),o=t.attrs||t.dynamicAttrs?qr((t.attrs||[]).concat(t.dynamicAttrs||[]).map(function(t){return{name:y(t.name),value:t.value,dynamic:t.dynamic}})):null,r=t.attrsMap["v-bind"];return!o&&!r||i||(a+=",null"),o&&(a+=","+o),r&&(a+=(o?"":",null")+","+r),a+")"}(t,e);var n;if(t.component)n=function(t,e,n){var i=e.inlineTemplate?null:zr(e,n,!0);return"_c("+t+","+Rr(e,n)+(i?","+i:"")+")"}(t.component,t,e);else{var i;(!t.plain||t.pre&&e.maybeComponent(t))&&(i=Rr(t,e));var a=t.inlineTemplate?null:zr(t,e,!0);n="_c('"+t.tag+"'"+(i?","+i:"")+(a?","+a:"")+")"}for(var o=0;o<e.transforms.length;o++)n=e.transforms[o](t,n);return n}return zr(t,e)||"void 0"}function jr(t,e){t.staticProcessed=!0;var n=e.pre;return t.pre&&(e.pre=t.pre),e.staticRenderFns.push("with(this){return "+Lr(t,e)+"}"),e.pre=n,"_m("+(e.staticRenderFns.length-1)+(t.staticInFor?",true":"")+")"}function Pr(t,e){if(t.onceProcessed=!0,t.if&&!t.ifProcessed)return Fr(t,e);if(t.staticInFor){for(var n="",i=t.parent;i;){if(i.for){n=i.key;break}i=i.parent}return n?"_o("+Lr(t,e)+","+e.onceId+++","+n+")":Lr(t,e)}return jr(t,e)}function Fr(t,e,n,i){return t.ifProcessed=!0,function t(e,n,i,a){if(!e.length)return a||"_e()";var o=e.shift();return o.exp?"("+o.exp+")?"+r(o.block)+":"+t(e,n,i,a):""+r(o.block);function r(t){return i?i(t,n):t.once?Pr(t,n):Lr(t,n)}}(t.ifConditions.slice(),e,n,i)}function Yr(t,e,n,i){var a=t.for,o=t.alias,r=t.iterator1?","+t.iterator1:"",s=t.iterator2?","+t.iterator2:"";return t.forProcessed=!0,(i||"_l")+"(("+a+"),function("+o+r+s+"){return "+(n||Lr)(t,e)+"})"}function Rr(t,e){var n="{",i=function(t,e){var n=t.directives;if(n){var i,a,o,r,s="directives:[",l=!1;for(i=0,a=n.length;i<a;i++){o=n[i],r=!0;var d=e.directives[o.name];d&&(r=!!d(t,o,e.warn)),r&&(l=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}return l?s.slice(0,-1)+"]":void 0}}(t,e);i&&(n+=i+","),t.key&&(n+="key:"+t.key+","),t.ref&&(n+="ref:"+t.ref+","),t.refInFor&&(n+="refInFor:true,"),t.pre&&(n+="pre:true,"),t.component&&(n+='tag:"'+t.tag+'",');for(var a=0;a<e.dataGenFns.length;a++)n+=e.dataGenFns[a](t);if(t.attrs&&(n+="attrs:"+qr(t.attrs)+","),t.props&&(n+="domProps:"+qr(t.props)+","),t.events&&(n+=Dr(t.events,!1)+","),t.nativeEvents&&(n+=Dr(t.nativeEvents,!0)+","),t.slotTarget&&!t.slotScope&&(n+="slot:"+t.slotTarget+","),t.scopedSlots&&(n+=function(t,e,n){var i=t.for||Object.keys(e).some(function(t){var n=e[t];return n.slotTargetDynamic||n.if||n.for||Hr(n)}),a=!!t.if;if(!i)for(var o=t.parent;o;){if(o.slotScope&&o.slotScope!==sr||o.for){i=!0;break}o.if&&(a=!0),o=o.parent}var r=Object.keys(e).map(function(t){return $r(e[t],n)}).join(",");return"scopedSlots:_u(["+r+"]"+(i?",null,true":"")+(!i&&a?",null,false,"+function(t){for(var e=5381,n=t.length;n;)e=33*e^t.charCodeAt(--n);return e>>>0}(r):"")+")"}(t,t.scopedSlots,e)+","),t.model&&(n+="model:{value:"+t.model.value+",callback:"+t.model.callback+",expression:"+t.model.expression+"},"),t.inlineTemplate){var o=function(t,e){var n=t.children[0];if(n&&1===n.type){var i=Tr(n,e.options);return"inlineTemplate:{render:function(){"+i.render+"},staticRenderFns:["+i.staticRenderFns.map(function(t){return"function(){"+t+"}"}).join(",")+"]}"}}(t,e);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",t.dynamicAttrs&&(n="_b("+n+',"'+t.tag+'",'+qr(t.dynamicAttrs)+")"),t.wrapData&&(n=t.wrapData(n)),t.wrapListeners&&(n=t.wrapListeners(n)),n}function Hr(t){return 1===t.type&&("slot"===t.tag||t.children.some(Hr))}function $r(t,e){var n=t.attrsMap["slot-scope"];if(t.if&&!t.ifProcessed&&!n)return Fr(t,e,$r,"null");if(t.for&&!t.forProcessed)return Yr(t,e,$r);var i=t.slotScope===sr?"":String(t.slotScope),a="function("+i+"){return "+("template"===t.tag?t.if&&n?"("+t.if+")?"+(zr(t,e)||"undefined")+":undefined":zr(t,e)||"undefined":Lr(t,e))+"}",o=i?"":",proxy:true";return"{key:"+(t.slotTarget||'"default"')+",fn:"+a+o+"}"}function zr(t,e,n,i,a){var o=t.children;if(o.length){var r=o[0];if(1===o.length&&r.for&&"template"!==r.tag&&"slot"!==r.tag){var s=n?e.maybeComponent(r)?",1":",0":"";return""+(i||Lr)(r,e)+s}var l=n?function(t,e){for(var n=0,i=0;i<t.length;i++){var a=t[i];if(1===a.type){if(Xr(a)||a.ifConditions&&a.ifConditions.some(function(t){return Xr(t.block)})){n=2;break}(e(a)||a.ifConditions&&a.ifConditions.some(function(t){return e(t.block)}))&&(n=1)}}return n}(o,e.maybeComponent):0,d=a||Vr;return"["+o.map(function(t){return d(t,e)}).join(",")+"]"+(l?","+l:"")}}function Xr(t){return void 0!==t.for||"template"===t.tag||"slot"===t.tag}function Vr(t,e){return 1===t.type?Lr(t,e):3===t.type&&t.isComment?(i=t,"_e("+JSON.stringify(i.text)+")"):"_v("+(2===(n=t).type?n.expression:Wr(JSON.stringify(n.text)))+")";var n,i}function qr(t){for(var e="",n="",i=0;i<t.length;i++){var a=t[i],o=Wr(a.value);a.dynamic?n+=a.name+","+o+",":e+='"'+a.name+'":'+o+","}return e="{"+e.slice(0,-1)+"}",n?"_d("+e+",["+n.slice(0,-1)+"])":e}function Wr(t){return t.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}function Ur(t,e){try{return new Function(t)}catch(n){return e.push({err:n,code:t}),N}}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b");var Gr,Zr,Jr=(Gr=function(t,e){var n=function(t,e){Ro=e.warn||Ii,Vo=e.isPreTag||M,qo=e.mustUseProp||M,Wo=e.getTagNamespace||M,e.isReservedTag,$o=Di(e.modules,"transformNode"),zo=Di(e.modules,"preTransformNode"),Xo=Di(e.modules,"postTransformNode"),Ho=e.delimiters;var n,i,a=[],o=!1!==e.preserveWhitespace,r=e.whitespace,s=!1,l=!1;function d(t){if(c(t),s||t.processed||(t=dr(t,e)),a.length||t===n||n.if&&(t.elseif||t.else)&&hr(n,{exp:t.elseif,block:t}),i&&!t.forbidden)if(t.elseif||t.else)r=t,(d=function(t){for(var e=t.length;e--;){if(1===t[e].type)return t[e];t.pop()}}(i.children))&&d.if&&hr(d,{exp:r.elseif,block:r});else{if(t.slotScope){var o=t.slotTarget||'"default"';(i.scopedSlots||(i.scopedSlots={}))[o]=t}i.children.push(t),t.parent=i}var r,d;t.children=t.children.filter(function(t){return!t.slotScope}),c(t),t.pre&&(s=!1),Vo(t.tag)&&(l=!1);for(var h=0;h<Xo.length;h++)Xo[h](t,e)}function c(t){if(!l)for(var e;(e=t.children[t.children.length-1])&&3===e.type&&" "===e.text;)t.children.pop()}return function(t,e){for(var n,i,a=[],o=e.expectHTML,r=e.isUnaryTag||M,s=e.canBeLeftOpenTag||M,l=0;t;){if(n=t,i&&Mo(i)){var d=0,c=i.toLowerCase(),h=Oo[c]||(Oo[c]=new RegExp("([\\s\\S]*?)(</"+c+"[^>]*>)","i")),u=t.replace(h,function(t,n,i){return d=i.length,Mo(c)||"noscript"===c||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Fo(c,n)&&(n=n.slice(1)),e.chars&&e.chars(n),""});l+=t.length-u.length,t=u,k(c,l-d,l)}else{var m=t.indexOf("<");if(0===m){if(So.test(t)){var f=t.indexOf("--\x3e");if(f>=0){e.shouldKeepComment&&e.comment(t.substring(4,f),l,l+f+3),y(f+3);continue}}if(No.test(t)){var p=t.indexOf("]>");if(p>=0){y(p+2);continue}}var _=t.match(Do);if(_){y(_[0].length);continue}var A=t.match(Io);if(A){var b=l;y(A[0].length),k(A[1],b,l);continue}var x=w();if(x){B(x),Fo(x.tagName,t)&&y(1);continue}}var g=void 0,v=void 0,C=void 0;if(m>=0){for(v=t.slice(m);!(Io.test(v)||ko.test(v)||So.test(v)||No.test(v)||(C=v.indexOf("<",1))<0);)m+=C,v=t.slice(m);g=t.substring(0,m)}m<0&&(g=t),g&&y(g.length),e.chars&&g&&e.chars(g,l-g.length,l)}if(t===n){e.chars&&e.chars(t);break}}function y(e){l+=e,t=t.substring(e)}function w(){var e=t.match(ko);if(e){var n,i,a={tagName:e[1],attrs:[],start:l};for(y(e[0].length);!(n=t.match(Eo))&&(i=t.match(yo)||t.match(Co));)i.start=l,y(i[0].length),i.end=l,a.attrs.push(i);if(n)return a.unarySlash=n[1],y(n[0].length),a.end=l,a}}function B(t){var n=t.tagName,l=t.unarySlash;o&&("p"===i&&vo(n)&&k(i),s(n)&&i===n&&k(n));for(var d=r(n)||!!l,c=t.attrs.length,h=new Array(c),u=0;u<c;u++){var m=t.attrs[u],f=m[3]||m[4]||m[5]||"",p="a"===n&&"href"===m[1]?e.shouldDecodeNewlinesForHref:e.shouldDecodeNewlines;h[u]={name:m[1],value:Yo(f,p)}}d||(a.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:h,start:t.start,end:t.end}),i=n),e.start&&e.start(n,h,d,t.start,t.end)}function k(t,n,o){var r,s;if(null==n&&(n=l),null==o&&(o=l),t)for(s=t.toLowerCase(),r=a.length-1;r>=0&&a[r].lowerCasedTag!==s;r--);else r=0;if(r>=0){for(var d=a.length-1;d>=r;d--)e.end&&e.end(a[d].tag,n,o);a.length=r,i=r&&a[r-1].tag}else"br"===s?e.start&&e.start(t,[],!0,n,o):"p"===s&&(e.start&&e.start(t,[],!1,n,o),e.end&&e.end(t,n,o))}k()}(t,{warn:Ro,expectHTML:e.expectHTML,isUnaryTag:e.isUnaryTag,canBeLeftOpenTag:e.canBeLeftOpenTag,shouldDecodeNewlines:e.shouldDecodeNewlines,shouldDecodeNewlinesForHref:e.shouldDecodeNewlinesForHref,shouldKeepComment:e.comments,outputSourceRange:e.outputSourceRange,start:function(t,o,r,c,h){var u=i&&i.ns||Wo(t);Z&&"svg"===u&&(o=function(t){for(var e=[],n=0;n<t.length;n++){var i=t[n];fr.test(i.name)||(i.name=i.name.replace(pr,""),e.push(i))}return e}(o));var m,f=lr(t,o,i);u&&(f.ns=u),"style"!==(m=f).tag&&("script"!==m.tag||m.attrsMap.type&&"text/javascript"!==m.attrsMap.type)||at()||(f.forbidden=!0);for(var p=0;p<zo.length;p++)f=zo[p](f,e)||f;s||(function(t){null!=Pi(t,"v-pre")&&(t.pre=!0)}(f),f.pre&&(s=!0)),Vo(f.tag)&&(l=!0),s?function(t){var e=t.attrsList,n=e.length;if(n)for(var i=t.attrs=new Array(n),a=0;a<n;a++)i[a]={name:e[a].name,value:JSON.stringify(e[a].value)},null!=e[a].start&&(i[a].start=e[a].start,i[a].end=e[a].end);else t.pre||(t.plain=!0)}(f):f.processed||(cr(f),function(t){var e=Pi(t,"v-if");if(e)t.if=e,hr(t,{exp:e,block:t});else{null!=Pi(t,"v-else")&&(t.else=!0);var n=Pi(t,"v-else-if");n&&(t.elseif=n)}}(f),function(t){null!=Pi(t,"v-once")&&(t.once=!0)}(f)),n||(n=f),r?d(f):(i=f,a.push(f))},end:function(t,e,n){var o=a[a.length-1];a.length-=1,i=a[a.length-1],d(o)},chars:function(t,e,n){if(i&&(!Z||"textarea"!==i.tag||i.attrsMap.placeholder!==t)){var a,d,c,h=i.children;(t=l||t.trim()?"script"===(a=i).tag||"style"===a.tag?t:rr(t):h.length?r?"condense"===r&&ar.test(t)?"":" ":o?" ":"":"")&&(l||"condense"!==r||(t=t.replace(or," ")),!s&&" "!==t&&(d=function(t,e){var n=Ho?_o(Ho):fo;if(n.test(t)){for(var i,a,o,r=[],s=[],l=n.lastIndex=0;i=n.exec(t);){(a=i.index)>l&&(s.push(o=t.slice(l,a)),r.push(JSON.stringify(o)));var d=ki(i[1].trim());r.push("_s("+d+")"),s.push({"@binding":d}),l=a+i[0].length}return l<t.length&&(s.push(o=t.slice(l)),r.push(JSON.stringify(o))),{expression:r.join("+"),tokens:s}}}(t))?c={type:2,expression:d.expression,tokens:d.tokens,text:t}:" "===t&&h.length&&" "===h[h.length-1].text||(c={type:3,text:t}),c&&h.push(c))}},comment:function(t,e,n){if(i){var a={type:3,text:t,isComment:!0};i.children.push(a)}}}),n}(t.trim(),e);!1!==e.optimize&&function(t,e){t&&(Ar=vr(e.staticKeys||""),br=e.isReservedTag||M,function t(e){if(e.static=function(t){return 2!==t.type&&(3===t.type||!(!t.pre&&(t.hasBindings||t.if||t.for||_(t.tag)||!br(t.tag)||function(t){for(;t.parent;){if("template"!==(t=t.parent).tag)return!1;if(t.for)return!0}return!1}(t)||!Object.keys(t).every(Ar))))}(e),1===e.type){if(!br(e.tag)&&"slot"!==e.tag&&null==e.attrsMap["inline-template"])return;for(var n=0,i=e.children.length;n<i;n++){var a=e.children[n];t(a),a.static||(e.static=!1)}if(e.ifConditions)for(var o=1,r=e.ifConditions.length;o<r;o++){var s=e.ifConditions[o].block;t(s),s.static||(e.static=!1)}}}(t),function t(e,n){if(1===e.type){if((e.static||e.once)&&(e.staticInFor=n),e.static&&e.children.length&&(1!==e.children.length||3!==e.children[0].type))return void(e.staticRoot=!0);if(e.staticRoot=!1,e.children)for(var i=0,a=e.children.length;i<a;i++)t(e.children[i],n||!!e.for);if(e.ifConditions)for(var o=1,r=e.ifConditions.length;o<r;o++)t(e.ifConditions[o].block,n)}}(t,!1))}(n,e);var i=Tr(n,e);return{ast:n,render:i.render,staticRenderFns:i.staticRenderFns}},function(t){function e(e,n){var i=Object.create(t),a=[],o=[];if(n)for(var r in n.modules&&(i.modules=(t.modules||[]).concat(n.modules)),n.directives&&(i.directives=D(Object.create(t.directives||null),n.directives)),n)"modules"!==r&&"directives"!==r&&(i[r]=n[r]);i.warn=function(t,e,n){(n?o:a).push(t)};var s=Gr(e.trim(),i);return s.errors=a,s.tips=o,s}return{compile:e,compileToFunctions:function(t){var e=Object.create(null);return function(n,i,a){(i=D({},i)).warn,delete i.warn;var o=i.delimiters?String(i.delimiters)+n:n;if(e[o])return e[o];var r=t(n,i),s={},l=[];return s.render=Ur(r.render,l),s.staticRenderFns=r.staticRenderFns.map(function(t){return Ur(t,l)}),e[o]=s}}(e)}})(gr),Qr=(Jr.compile,Jr.compileToFunctions);function Kr(t){return(Zr=Zr||document.createElement("div")).innerHTML=t?'<a href="\n"/>':'<div a="\n"/>',Zr.innerHTML.indexOf("&#10;")>0}var ts=!!q&&Kr(!1),es=!!q&&Kr(!0),ns=v(function(t){var e=Qn(t);return e&&e.innerHTML}),is=wn.prototype.$mount;wn.prototype.$mount=function(t,e){if((t=t&&Qn(t))===document.body||t===document.documentElement)return this;var n=this.$options;if(!n.render){var i=n.template;if(i)if("string"==typeof i)"#"===i.charAt(0)&&(i=ns(i));else{if(!i.nodeType)return this;i=i.innerHTML}else t&&(i=function(t){if(t.outerHTML)return t.outerHTML;var e=document.createElement("div");return e.appendChild(t.cloneNode(!0)),e.innerHTML}(t));if(i){var a=Qr(i,{outputSourceRange:!1,shouldDecodeNewlines:ts,shouldDecodeNewlinesForHref:es,delimiters:n.delimiters,comments:n.comments},this),o=a.render,r=a.staticRenderFns;n.render=o,n.staticRenderFns=r}}return is.call(this,t,e)},wn.compile=Qr,t.exports=wn}).call(this,n(1),n(4).setImmediate)},function(t,e,n){(function(t){var i=void 0!==t&&t||"undefined"!=typeof self&&self||window,a=Function.prototype.apply;function o(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new o(a.call(setTimeout,i,arguments),clearTimeout)},e.setInterval=function(){return new o(a.call(setInterval,i,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(i,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(5),e.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(this,n(1))},function(t,e,n){(function(t,e){!function(t,n){"use strict";if(!t.setImmediate){var i,a,o,r,s,l=1,d={},c=!1,h=t.document,u=Object.getPrototypeOf&&Object.getPrototypeOf(t);u=u&&u.setTimeout?u:t,"[object process]"==={}.toString.call(t.process)?i=function(t){e.nextTick(function(){f(t)})}:function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?(r="setImmediate$"+Math.random()+"$",s=function(e){e.source===t&&"string"==typeof e.data&&0===e.data.indexOf(r)&&f(+e.data.slice(r.length))},t.addEventListener?t.addEventListener("message",s,!1):t.attachEvent("onmessage",s),i=function(e){t.postMessage(r+e,"*")}):t.MessageChannel?((o=new MessageChannel).port1.onmessage=function(t){f(t.data)},i=function(t){o.port2.postMessage(t)}):h&&"onreadystatechange"in h.createElement("script")?(a=h.documentElement,i=function(t){var e=h.createElement("script");e.onreadystatechange=function(){f(t),e.onreadystatechange=null,a.removeChild(e),e=null},a.appendChild(e)}):i=function(t){setTimeout(f,0,t)},u.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var a={callback:t,args:e};return d[l]=a,i(l),l++},u.clearImmediate=m}function m(t){delete d[t]}function f(t){if(c)setTimeout(f,0,t);else{var e=d[t];if(e){c=!0;try{!function(t){var e=t.callback,i=t.args;switch(i.length){case 0:e();break;case 1:e(i[0]);break;case 2:e(i[0],i[1]);break;case 3:e(i[0],i[1],i[2]);break;default:e.apply(n,i)}}(e)}finally{m(t),c=!1}}}}}("undefined"==typeof self?void 0===t?this:t:self)}).call(this,n(1),n(6))},function(t,e){var n,i,a=t.exports={};function o(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function s(t){if(n===setTimeout)return setTimeout(t,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(t){n=o}try{i="function"==typeof clearTimeout?clearTimeout:r}catch(t){i=r}}();var l,d=[],c=!1,h=-1;function u(){c&&l&&(c=!1,l.length?d=l.concat(d):h=-1,d.length&&m())}function m(){if(!c){var t=s(u);c=!0;for(var e=d.length;e;){for(l=d,d=[];++h<e;)l&&l[h].run();h=-1,e=d.length}l=null,c=!1,function(t){if(i===clearTimeout)return clearTimeout(t);if((i===r||!i)&&clearTimeout)return i=clearTimeout,clearTimeout(t);try{i(t)}catch(e){try{return i.call(null,t)}catch(e){return i.call(this,t)}}}(t)}}function f(t,e){this.fun=t,this.array=e}function p(){}a.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];d.push(new f(t,e)),1!==d.length||c||s(m)},f.prototype.run=function(){this.fun.apply(null,this.array)},a.title="browser",a.browser=!0,a.env={},a.argv=[],a.version="",a.versions={},a.on=p,a.addListener=p,a.once=p,a.off=p,a.removeListener=p,a.removeAllListeners=p,a.emit=p,a.prependListener=p,a.prependOnceListener=p,a.listeners=function(t){return[]},a.binding=function(t){throw new Error("process.binding is not supported")},a.cwd=function(){return"/"},a.chdir=function(t){throw new Error("process.chdir is not supported")},a.umask=function(){return 0}},function(t,e,n){"use strict";n.r(e);var i=n(0),a=n.n(i);/^2\./.test(a.a.version)||a.a.util.warn("VueClickaway 2.2.2 only supports Vue 2.x, and does not support Vue "+a.a.version);var o="_vue_clickaway_handler";function r(t,e,n){s(t);var i=n.context,a=e.value;if("function"==typeof a){var r=!1;setTimeout(function(){r=!0},0),t[o]=function(e){var n=e.path||(e.composedPath?e.composedPath():void 0);if(r&&(n?n.indexOf(t)<0:!t.contains(e.target)))return a.call(i,e)},document.documentElement.addEventListener("click",t[o],!1)}}function s(t){document.documentElement.removeEventListener("click",t[o],!1),delete t[o]}var l={bind:r,update:function(t,e){e.value!==e.oldValue&&r(t,e)},unbind:s};Array.from||(Array.from=function(t){return[].slice.call(t)}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)});var d=Array.from,c=Array.isArray,h=function(t){return Boolean(t&&t.nodeType===Node.ELEMENT_NODE)},u=function(t){if(!h(t)||(n=t,!(e=document.body)||"function"!=typeof e.contains||!e.contains(n)))return!1;var e,n;if("none"===t.style.display)return!1;var i=function(t){return h(t)?t.getBoundingClientRect():null}(t);return Boolean(i&&i.height>0&&i.width>0)},m=function(t,e){return d((h(e)?e:document).querySelectorAll(t))},f=function(t,e,n){e&&h(t)&&t.setAttribute(e,n)},p={directives:{onClickaway:l},props:{closeOnClick:{type:Boolean,default:!0},closeOnScroll:{type:Boolean,default:!0},lazy:{type:Boolean,default:!1},itemSelector:{type:[String,Array],default:function(){return[".v-context-item",".v-context > li > a"]}},role:{type:String,default:"menu"},tag:{type:String,default:"ul"}},computed:{style:function(){return this.show?{top:"".concat(this.top,"px"),left:"".concat(this.left,"px")}:null}},data:function(){return{top:null,left:null,show:!1,data:null,localItemSelector:""}},created:function(){this.localItemSelector=this.mapItemSelector(this.itemSelector)},beforeDestroy:function(){this.closeOnScroll&&this.removeScrollEventListener()},methods:{addScrollEventListener:function(){var t,e,n;t=window,e="scroll",n=this.close,t&&t.addEventListener&&t.addEventListener(e,n)},close:function(){this.show&&(this.resetData(),this.closeOnScroll&&this.removeScrollEventListener(),this.$emit("close"))},focusItem:function(t,e){var n=e.find(function(e,n){return n===t});n&&n.focus&&n.focus()},focusNext:function(t,e){var n=this;this.show&&(t.preventDefault(),t.stopPropagation(),this.$nextTick(function(){var i=n.getItems();if(!(i.length<1)){var a=i.indexOf(t.target);e&&a>0?a--:!e&&a<i.length-1&&a++,a<0&&(a=0),n.focusItem(a,i)}}))},getItems:function(){return(m(this.localItemSelector,this.$el)||[]).filter(u)},mapItemSelector:function(t){return c(t)&&(t=t.map(function(t){return"".concat(t,":not(.disabled):not([disabled])")}).join(", ")),t},onClick:function(){this.close()},onKeydown:function(t){var e=t.keyCode;27===e?this.close():40===e?this.focusNext(t,!1):38===e&&this.focusNext(t,!0)},open:function(t,e){var n=this;this.data=e,this.show=!0,this.$nextTick(function(){n.positionMenu(t.clientY,t.clientX),n.$el.focus(),n.setItemRoles(),n.closeOnScroll&&n.addScrollEventListener(),n.$emit("open",t,n.data,n.top,n.left)})},positionMenu:function(t,e){var n=window.innerHeight-this.$el.offsetHeight-25,i=window.innerWidth-this.$el.offsetWidth-25;t>n&&(t=n),e>i&&(e=i),this.top=t,this.left=e},removeScrollEventListener:function(){var t,e,n;t=window,e="scroll",n=this.close,t&&t.removeEventListener&&t.removeEventListener(e,n)},resetData:function(){this.top=null,this.left=null,this.data=null,this.show=!1},setItemRoles:function(){m(this.localItemSelector,this.$el).forEach(function(t){f(t,"role","menuitem"),f(t,"tabindex","-1")})}},watch:{closeOnScroll:function(t,e){t!==e&&(t&&this.show?this.addScrollEventListener():this.removeScrollEventListener())},itemSelector:function(t,e){t!==e&&(this.localItemSelector=this.mapItemSelector(t))}},render:function(t){if(this.lazy&&!this.show)return t(!1);var e={"!contextmenu":function(t){t.preventDefault()},keydown:this.onKeydown};this.closeOnClick&&(e.click=this.onClick);var n=[{name:"on-clickaway",value:this.close,rawName:"v-on-clickaway"}];return this.lazy||n.push({name:"show",value:this.show,rawName:"v-show",expression:"show"}),t(this.tag,{staticClass:"v-context",style:this.style,attrs:{tabindex:"-1",role:this.role,"aria-hidden":this.lazy?null:String(!this.show)},on:e,directives:n},[function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{},a=n[t]||i[t];return"function"==typeof a?a(e):a}("default",{data:this.data},this.$scopedSlots,this.$slots)])}};n.d(e,"VueContext",function(){return p})}])},t.exports=i()},IicD:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-6c9f16be]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-6c9f16be]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6c9f16be]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6c9f16be]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-6c9f16be] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-6c9f16be]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-6c9f16be] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-6c9f16be]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-6c9f16be]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-6c9f16be]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-6c9f16be]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6c9f16be]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6c9f16be]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-6c9f16be] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-6c9f16be]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-6c9f16be] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-6c9f16be]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-6c9f16be]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},IjKY:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfAdvance.css",sourceRoot:""}])},JGZ4:function(t,e,n){var i=n("cDwS");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("72b4311c",i,!0,{})},JMgX:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.topCheck[data-v-fb0144a4] {\n  margin-top: 3px !important;\n}\n.hrFlow[data-v-fb0144a4] {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n@media (max-width: 767px) {\n.spaceBotton[data-v-fb0144a4] {\n    margin-bottom: .25rem !important;\n}\n.topCheck[data-v-fb0144a4] {\n    margin-top: -4px !important;\n}\n}\ninput:checked + label[data-v-fb0144a4] {\n  font-weight: bold !important;\n}\n.inputLine:checked + .line-through[data-v-fb0144a4] {\n  color: #34bf6e !important;\n  text-decoration: line-through !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfFlow/PfFlow.css"],names:[],mappings:";AACA;EACE,2BAA2B;CAC5B;AACD;EACE,8BAA8B;EAC9B,iCAAiC;CAClC;AACD;AACA;IACI,iCAAiC;CACpC;AACD;IACI,4BAA4B;CAC/B;CACA;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,0BAA0B;EAC1B,yCAAyC;CAC1C",file:"PfFlow.css",sourcesContent:["\n.topCheck[data-v-fb0144a4] {\n  margin-top: 3px !important;\n}\n.hrFlow[data-v-fb0144a4] {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n@media (max-width: 767px) {\n.spaceBotton[data-v-fb0144a4] {\n    margin-bottom: .25rem !important;\n}\n.topCheck[data-v-fb0144a4] {\n    margin-top: -4px !important;\n}\n}\ninput:checked + label[data-v-fb0144a4] {\n  font-weight: bold !important;\n}\n.inputLine:checked + .line-through[data-v-fb0144a4] {\n  color: #34bf6e !important;\n  text-decoration: line-through !important;\n}\n"],sourceRoot:""}])},"JP+z":function(t,e,n){"use strict";t.exports=function(t,e){return function(){for(var n=new Array(arguments.length),i=0;i<n.length;i++)n[i]=arguments[i];return t.apply(e,n)}}},JPsq:function(t,e,n){var i=n("8vWw");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("77302c99",i,!0,{})},JSOS:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-091af5d8] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-091af5d8]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-091af5d8] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-091af5d8] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-091af5d8] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-091af5d8] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-091af5d8] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-091af5d8] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-091af5d8] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-091af5d8] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-091af5d8] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-091af5d8] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-091af5d8] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-091af5d8] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-091af5d8] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-091af5d8] {\n  margin-right: 0px;\n}\n.newItem[data-v-091af5d8] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-091af5d8] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-091af5d8] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-091af5d8] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-091af5d8] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-091af5d8] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-091af5d8] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-091af5d8] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-091af5d8] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-091af5d8] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-091af5d8]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-091af5d8] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-091af5d8] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-091af5d8] {\n  color: red;\n}\n.showMore[data-v-091af5d8]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-091af5d8] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-091af5d8] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-091af5d8] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-091af5d8 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-091af5d8 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-091af5d8] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-091af5d8 3s infinite;\n  animation: bit-data-v-091af5d8 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-091af5d8] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-091af5d8]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-091af5d8]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-091af5d8]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-091af5d8]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-091af5d8]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-091af5d8]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-091af5d8] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-091af5d8]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-091af5d8] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-091af5d8] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-091af5d8] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-091af5d8] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-091af5d8] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-091af5d8] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-091af5d8] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-091af5d8] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-091af5d8] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-091af5d8] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-091af5d8] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-091af5d8] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-091af5d8] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-091af5d8] {\n  margin-right: 0px;\n}\n.newItem[data-v-091af5d8] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-091af5d8] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-091af5d8] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-091af5d8] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-091af5d8] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-091af5d8] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-091af5d8] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-091af5d8] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-091af5d8] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-091af5d8] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-091af5d8]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-091af5d8] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-091af5d8] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-091af5d8] {\n  color: red;\n}\n.showMore[data-v-091af5d8]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-091af5d8] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-091af5d8] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-091af5d8] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-091af5d8 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-091af5d8 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-091af5d8] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-091af5d8 3s infinite;\n  animation: bit-data-v-091af5d8 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-091af5d8] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-091af5d8]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-091af5d8]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-091af5d8]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-091af5d8]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-091af5d8]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-091af5d8]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},JTtw:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfUsEntries.css",sourceRoot:""}])},Jk0y:function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAJAIAAAP///////yH5BAEKAAEALAAAAAAGAAkAAAINjAOHkNv8mIJTHnpDAQA7"},Jneh:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfNewCategoryModal.css",sourceRoot:""}])},JwiF:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("jv",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),weekdays:"Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),weekdaysShort:"Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/enjing|siyang|sonten|ndalu/,meridiemHour:function(t,e){return 12===t&&(t=0),"enjing"===e?t:"siyang"===e?t>=11?t:t+12:"sonten"===e||"ndalu"===e?t+12:void 0},meridiem:function(t,e,n){return t<11?"enjing":t<15?"siyang":t<19?"sonten":"ndalu"},calendar:{sameDay:"[Dinten puniko pukul] LT",nextDay:"[Mbenjang pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kala wingi pukul] LT",lastWeek:"dddd [kepengker pukul] LT",sameElse:"L"},relativeTime:{future:"wonten ing %s",past:"%s ingkang kepengker",s:"sawetawis detik",ss:"%d detik",m:"setunggal menit",mm:"%d menit",h:"setunggal jam",hh:"%d jam",d:"sedinten",dd:"%d dinten",M:"sewulan",MM:"%d wulan",y:"setaun",yy:"%d taun"},week:{dow:1,doy:7}})})(n("PJh5"))},JyN8:function(t,e,n){var i=n("Wdy1");i(i.S+i.F,"Object",{assign:n("xVc6")})},KCLY:function(t,e,n){"use strict";(function(e){var i=n("cGG2"),a=n("5VQ+"),o={"Content-Type":"application/x-www-form-urlencoded"};function r(t,e){!i.isUndefined(t)&&i.isUndefined(t["Content-Type"])&&(t["Content-Type"]=e)}var s,l={adapter:("undefined"!=typeof XMLHttpRequest?s=n("7GwW"):void 0!==e&&(s=n("7GwW")),s),transformRequest:[function(t,e){return a(e,"Content-Type"),i.isFormData(t)||i.isArrayBuffer(t)||i.isBuffer(t)||i.isStream(t)||i.isFile(t)||i.isBlob(t)?t:i.isArrayBufferView(t)?t.buffer:i.isURLSearchParams(t)?(r(e,"application/x-www-form-urlencoded;charset=utf-8"),t.toString()):i.isObject(t)?(r(e,"application/json;charset=utf-8"),JSON.stringify(t)):t}],transformResponse:[function(t){if("string"==typeof t)try{t=JSON.parse(t)}catch(t){}return t}],timeout:0,xsrfCookieName:"XSRF-TOKEN",xsrfHeaderName:"X-XSRF-TOKEN",maxContentLength:-1,validateStatus:function(t){return t>=200&&t<300}};l.headers={common:{Accept:"application/json, text/plain, */*"}},i.forEach(["delete","get","head"],function(t){l.headers[t]={}}),i.forEach(["post","put","patch"],function(t){l.headers[t]=i.merge(o)}),t.exports=l}).call(e,n("W2nU"))},KHvr:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.spinner {\n  /* width: 70px;\n  text-align: center;\n  -webkit-transform: translate(-50%);\n  -ms-transform: translate(-50%);\n  transform: translate(-50%);\n  margin-left: 50%;  */\n}\n.spinner > div {\n  /* width: 18px;\n  height: 18px;\n  background-color: #FFFFFF;\n  border-radius: 100% !important;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;  */\n}\n.spinner .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n.spinner .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n@-webkit-keyframes sk-bouncedelay {\n0%, 80%, 100% {\n    -webkit-transform: scale(0);\n}\n40% {\n    -webkit-transform: scale(1);\n}\n}\n@keyframes sk-bouncedelay {\n0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n}\n40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n}\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/utils/PfSpinner/PfSpinner.css"],names:[],mappings:";AACA;EACE;;;;;uBAKqB;CACtB;AACD;EACE;;;;;;+DAM6D;CAC9D;AACD;EACE,gCAAgC;EAChC,wBAAwB;CACzB;AACD;EACE,gCAAgC;EAChC,wBAAwB;CACzB;AACD;AACA;IACI,4BAA4B;CAC/B;AACD;IACI,4BAA4B;CAC/B;CACA;AACD;AACA;IACI,4BAA4B;IAC5B,oBAAoB;CACvB;AACD;IACI,4BAA4B;IAC5B,oBAAoB;CACvB;CACA",file:"PfSpinner.css",sourcesContent:["\n.spinner {\n  /* width: 70px;\n  text-align: center;\n  -webkit-transform: translate(-50%);\n  -ms-transform: translate(-50%);\n  transform: translate(-50%);\n  margin-left: 50%;  */\n}\n.spinner > div {\n  /* width: 18px;\n  height: 18px;\n  background-color: #FFFFFF;\n  border-radius: 100% !important;\n  display: inline-block;\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;  */\n}\n.spinner .bounce1 {\n  -webkit-animation-delay: -0.32s;\n  animation-delay: -0.32s;\n}\n.spinner .bounce2 {\n  -webkit-animation-delay: -0.16s;\n  animation-delay: -0.16s;\n}\n@-webkit-keyframes sk-bouncedelay {\n0%, 80%, 100% {\n    -webkit-transform: scale(0);\n}\n40% {\n    -webkit-transform: scale(1);\n}\n}\n@keyframes sk-bouncedelay {\n0%, 80%, 100% {\n    -webkit-transform: scale(0);\n    transform: scale(0);\n}\n40% {\n    -webkit-transform: scale(1);\n    transform: scale(1);\n}\n}\n"],sourceRoot:""}])},KOFO:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("oc-lnc",{months:{standalone:"genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre".split("_"),format:"de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dm._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dm_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:"[uèi a] LT",nextDay:"[deman a] LT",nextWeek:"dddd [a] LT",lastDay:"[ièr a] LT",lastWeek:"dddd [passat a] LT",sameElse:"L"},relativeTime:{future:"d'aquí %s",past:"fa %s",s:"unas segondas",ss:"%d segondas",m:"una minuta",mm:"%d minutas",h:"una ora",hh:"%d oras",d:"un jorn",dd:"%d jorns",M:"un mes",MM:"%d meses",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|è|a)/,ordinal:function(t,e){var n=1===t?"r":2===t?"n":3===t?"r":4===t?"t":"è";return"w"!==e&&"W"!==e||(n="a"),t+n},week:{dow:1,doy:4}})})(n("PJh5"))},KQCk:function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAGAIABAD2g493d3SH5BAEKAAEALAAAAAAGAAYAAAIKhB9nkcj+AJugAAA7"},KT6R:function(t,e,n){var i=n("1Kqf");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("2cf3d5d7",i,!0,{})},KbHb:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-8bc96722]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-8bc96722]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-8bc96722]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-8bc96722]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-8bc96722] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-8bc96722]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-8bc96722] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-8bc96722]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-8bc96722]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-8bc96722]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-8bc96722]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-8bc96722]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-8bc96722]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-8bc96722] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-8bc96722]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-8bc96722] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-8bc96722]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-8bc96722]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},L8tt:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.new-information[data-v-3de625d5] {\n  border: 2px solid #00751b66 !important;\n  background-color: #00751b1a !important;\n}\n.new-information[data-v-3de625d5]:focus {\n  color: #495057;\n  background-color: #00751b1a !important;\n  border-color: #00751b66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n}\n.updated-information[data-v-3de625d5] {\n  border: 2px solid #034aff66 !important;\n  background-color: #074dff1a !important;\n}\n.updated-information[data-v-3de625d5]:focus {\n  color: #495057;\n  background-color: #074dff1a !important;\n  border-color: #034aff66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n}\n.deleted-information[data-v-3de625d5] {\n  border: 2px solid #dc354566 !important;\n  background-color: #dc35451a !important;\n}\n.deleted-information[data-v-3de625d5]:focus {\n  color: #495057;\n  background-color: #dc35451a !important;\n  border-color: #dc354566 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/comparing.css"],names:[],mappings:";AACA;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,0DAA0D;EAC1D,kDAAkD;CACnD;AACD;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,yDAAyD;EACzD,iDAAiD;CAClD;AACD;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,sDAAsD;EACtD,8CAA8C;CAC/C",file:"comparing.css",sourcesContent:["\n.new-information[data-v-3de625d5] {\n  border: 2px solid #00751b66 !important;\n  background-color: #00751b1a !important;\n}\n.new-information[data-v-3de625d5]:focus {\n  color: #495057;\n  background-color: #00751b1a !important;\n  border-color: #00751b66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n}\n.updated-information[data-v-3de625d5] {\n  border: 2px solid #034aff66 !important;\n  background-color: #074dff1a !important;\n}\n.updated-information[data-v-3de625d5]:focus {\n  color: #495057;\n  background-color: #074dff1a !important;\n  border-color: #034aff66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n}\n.deleted-information[data-v-3de625d5] {\n  border: 2px solid #dc354566 !important;\n  background-color: #dc35451a !important;\n}\n.deleted-information[data-v-3de625d5]:focus {\n  color: #495057;\n  background-color: #dc35451a !important;\n  border-color: #dc354566 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n}\n"],sourceRoot:""}])},LGqs:function(t,e,n){var i=n("WQYT");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("b9554926",i,!0,{})},LKnP:function(t,e,n){var i=n("YjQv"),a=n("kkvn").set,o=i.MutationObserver||i.WebKitMutationObserver,r=i.process,s=i.Promise,l="process"==n("NZra")(r);t.exports=function(){var t,e,n,d=function(){var i,a;for(l&&(i=r.domain)&&i.exit();t;){a=t.fn,t=t.next;try{a()}catch(i){throw t?n():e=void 0,i}}e=void 0,i&&i.enter()};if(l)n=function(){r.nextTick(d)};else if(!o||i.navigator&&i.navigator.standalone)if(s&&s.resolve){var c=s.resolve(void 0);n=function(){c.then(d)}}else n=function(){a.call(i,d)};else{var h=!0,u=document.createTextNode("");new o(d).observe(u,{characterData:!0}),n=function(){u.data=h=!h}}return function(i){var a={fn:i,next:void 0};e&&(e.next=a),t||(t=a,n()),e=a}}},LT9G:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),i=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],a=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;t.defineLocale("es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(t,i){return t?/-MMM-/.test(i)?n[t.month()]:e[t.month()]:e},monthsRegex:a,monthsShortRegex:a,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:i,longMonthsParse:i,shortMonthsParse:i,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4},invalidDate:"Fecha inválida"})})(n("PJh5"))},Lgqo:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("si",{months:"ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්".split("_"),monthsShort:"ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ".split("_"),weekdays:"ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා".split("_"),weekdaysShort:"ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන".split("_"),weekdaysMin:"ඉ_ස_අ_බ_බ්‍ර_සි_සෙ".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"a h:mm",LTS:"a h:mm:ss",L:"YYYY/MM/DD",LL:"YYYY MMMM D",LLL:"YYYY MMMM D, a h:mm",LLLL:"YYYY MMMM D [වැනි] dddd, a h:mm:ss"},calendar:{sameDay:"[අද] LT[ට]",nextDay:"[හෙට] LT[ට]",nextWeek:"dddd LT[ට]",lastDay:"[ඊයේ] LT[ට]",lastWeek:"[පසුගිය] dddd LT[ට]",sameElse:"L"},relativeTime:{future:"%sකින්",past:"%sකට පෙර",s:"තත්පර කිහිපය",ss:"තත්පර %d",m:"මිනිත්තුව",mm:"මිනිත්තු %d",h:"පැය",hh:"පැය %d",d:"දිනය",dd:"දින %d",M:"මාසය",MM:"මාස %d",y:"වසර",yy:"වසර %d"},dayOfMonthOrdinalParse:/\d{1,2} වැනි/,ordinal:function(t){return t+" වැනි"},meridiemParse:/පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,isPM:function(t){return"ප.ව."===t||"පස් වරු"===t},meridiem:function(t,e,n){return t>11?n?"ප.ව.":"පස් වරු":n?"පෙ.ව.":"පෙර වරු"}})})(n("PJh5"))},LhDF:function(t,e,n){var i=n("GCs6").f,a=n("x//u"),o=n("hgbu")("toStringTag");t.exports=function(t,e,n){t&&!a(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},LmT1:function(t,e,n){var i=n("Vzoy");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("49abd582",i,!0,{})},LnJb:function(t,e,n){var i=n("XkCQ");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("5415103e",i,!0,{})},LocR:function(t,e,n){t.exports=!n("qs+f")&&!n("zyKz")(function(){return 7!=Object.defineProperty(n("PY1i")("div"),"a",{get:function(){return 7}}).a})},Mm7y:function(t,e,n){var i=n("JTtw");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("4b28cf17",i,!0,{})},N3vo:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("cv",{months:"кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав".split("_"),monthsShort:"кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш".split("_"),weekdays:"вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун".split("_"),weekdaysShort:"выр_тун_ытл_юн_кӗҫ_эрн_шӑм".split("_"),weekdaysMin:"вр_тн_ыт_юн_кҫ_эр_шм".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]",LLL:"YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm",LLLL:"dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm"},calendar:{sameDay:"[Паян] LT [сехетре]",nextDay:"[Ыран] LT [сехетре]",lastDay:"[Ӗнер] LT [сехетре]",nextWeek:"[Ҫитес] dddd LT [сехетре]",lastWeek:"[Иртнӗ] dddd LT [сехетре]",sameElse:"L"},relativeTime:{future:function(t){return t+(/сехет$/i.exec(t)?"рен":/ҫул$/i.exec(t)?"тан":"ран")},past:"%s каялла",s:"пӗр-ик ҫеккунт",ss:"%d ҫеккунт",m:"пӗр минут",mm:"%d минут",h:"пӗр сехет",hh:"%d сехет",d:"пӗр кун",dd:"%d кун",M:"пӗр уйӑх",MM:"%d уйӑх",y:"пӗр ҫул",yy:"%d ҫул"},dayOfMonthOrdinalParse:/\d{1,2}-мӗш/,ordinal:"%d-мӗш",week:{dow:1,doy:7}})})(n("PJh5"))},NA7F:function(t,e,n){var i=n("TO4G");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("487ec6d9",i,!0,{})},NHnr:function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var i={data:function(){return{isTitle:!1,isFocus:!1,timeValue:null}},props:{accesskey:{type:String},classElement:{},contenteditable:{type:Boolean,default:!1},dir:{type:String},draggable:{type:Boolean},hidden:{type:Boolean,default:!1},id:{type:String,default:"elementId"},lang:{type:String},spellcheck:{type:Boolean,default:!1},styleElement:{type:String},tabindex:{},title:{type:String},indexItem:{type:Number,default:-1},isForm:{type:Boolean,default:!1},isShareField:{type:Boolean,default:!1},isReverse:{type:Boolean,default:!0}},computed:{setInputClass:function(){return this.inputClass},setInputStyle:function(){return this.inputStyle}},created:function(){HTMLElement.prototype.pseudoStyleFocus=function(t){var e=document.head||document.getElementsByTagName("head")[0],n=document.getElementById("pseudoStyles")||document.createElement("style");return n.id="pseudoStyles",this.className+=" "+t.className,n.innerHTML+=" ."+t.className+":"+t.element+"{"+t.prop+"}",e.appendChild(n),this}},mounted:function(){var t=this;""!==this.inputTitle&&(this.isTitle=!0);var e=document.getElementById(this.id);null!==e&&(e.addEventListener("focus",function(){if(!0===t.isForm)if("radio"===this.type||"checkbox"===this.type){var e="pseudoStyleFocus"+Math.round(999999*Math.random());document.getElementById("label"+this.id).pseudoStyleFocus({element:"before",prop:"border: 2px solid red !important;",className:e})}else this.style.outline="2px solid red"}),e.addEventListener("blur",function(){if(!0===t.isForm)if("radio"===this.type||"checkbox"===this.type){var e="pseudoStyleFocus"+Math.round(999999*Math.random());document.getElementById("label"+this.id).pseudoStyleFocus({element:"before",prop:"border: 1px solid black !important;",className:e})}else this.style.outline=""}))},methods:{calculateMaxLength:function(){"text"===this.type?(this.value&&null!==this.value&&this.value.length>Math.ceil(1.6*this.fData.width/this.fontSize)?this.maxlengthExceeded=!0:this.maxlengthExceeded=!1,(!0===this.maxlengthExceeded||this.fData.textNotFit)&&(this.fData.textNotFit=this.maxlengthExceeded,this.$emit("update-field-db",this.fData))):"textarea"===this.type&&(this.value&&null!==this.value&&this.value.length>Math.ceil(1.9*this.fData.width*(this.fData.height/15.4)/this.fontSize)?this.maxlengthExceeded=!0:this.maxlengthExceeded=!1,(!0===this.maxlengthExceeded||this.fData.textNotFit)&&(this.fData.textNotFit=this.maxlengthExceeded,this.$emit("update-field-db",this.fData)))}}},a={name:"pf-spinner",props:{color:{type:String},size:{type:Number},styleSp:{type:String}},computed:{setColor:function(){var t="background-color:";return"blue"===this.color?t+"#1976D2;width:"+this.size+"px;height:"+this.size+"px;":"red"===this.color?t+"#E53935;width:"+this.size+"px;height:"+this.size+"px;":"green"===this.color?t+"#2b8b3a;width:"+this.size+"px;height:"+this.size+"px;":"black"===this.color?t+"#000000;width:"+this.size+"px;height:"+this.size+"px;":"gray"===this.color?t+"#B0BEC5;width:"+this.size+"px;height:"+this.size+"px;":"width:"+this.size+"px;height:"+this.size+"px;"},setStyle:function(){return this.styleSp?this.styleSp:this.size?"width:"+5*this.size+"px;":""}}},o={render:function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"spinner",style:this.setStyle},[e("div",{staticClass:"bounce1",style:this.setColor}),this._v(" "),e("div",{staticClass:"bounce2",style:this.setColor}),this._v(" "),e("div",{staticClass:"bounce3",style:this.setColor})])},staticRenderFns:[]};var r=n("VU/8")(a,o,!1,function(t){n("4MIE")},null,null).exports,s={name:"pf-button",props:{id:{type:String},label:{type:String,default:""},styleButton:{type:String},classButton:{},logo:{type:String},disabled:{type:Boolean,default:!1},isSuccess:{type:Boolean,default:!1},contentStyle:{type:String},isAction:{type:Boolean},noFadeOut:{type:Boolean}},components:{PfSpinner:r},mounted:function(){var t=this;setTimeout(function(){null!==document.getElementById(t.id)&&document.getElementById(t.id).classList.add("fadeIn")},300)}},l={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{style:t.contentStyle},[!0===t.isSuccess?n("button",{staticClass:"btn btn-sm fadeOut",class:t.classButton,staticStyle:{color:"white"},style:t.styleButton,attrs:{id:t.id,disabled:t.disabled||t.isAction},on:{click:function(e){return t.$emit("click")},mouseover:function(e){return t.$emit("mouseover")},mouseleave:function(e){return t.$emit("mouseleave")}}},[!0===t.isAction?n("span",[n("span",{staticClass:"spinner-border spinner-border-sm mr-1",attrs:{role:"status","aria-hidden":"true"}}),t._v("\n      Loading...\n    ")]):n("span",[t._v("\n      "+t._s(t.label)),void 0!==t.logo?n("i",{class:t.logo}):t._e()])]):!0===t.noFadeOut?n("button",{staticClass:"btn btn-sm",class:t.classButton,staticStyle:{color:"white"},style:t.styleButton,attrs:{id:t.id,disabled:t.disabled||t.isAction},on:{click:function(e){return t.$emit("click")},mouseover:function(e){return t.$emit("mouseover")},mouseleave:function(e){return t.$emit("mouseleave")}}},[!0===t.isAction?n("span",[n("span",{staticClass:"spinner-border spinner-border-sm mr-1",attrs:{role:"status","aria-hidden":"true"}}),t._v("\n      Loading...\n    ")]):n("span",[t._v("\n      "+t._s(t.label)),void 0!==t.logo?n("i",{class:t.logo}):t._e()])]):n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 text-right pr-0 pl-0"},[n("button",{staticClass:"btn btn-sm fadeOut",class:t.classButton,style:t.styleButton,attrs:{id:t.id,disabled:t.disabled||t.isAction},on:{click:function(e){return t.$emit("click")},mouseover:function(e){return t.$emit("mouseover")},mouseleave:function(e){return t.$emit("mouseleave")}}},[!0===t.isAction?n("span",[n("span",{staticClass:"spinner-border spinner-border-sm mr-1",attrs:{role:"status","aria-hidden":"true"}}),t._v("\n          Loading...\n        ")]):n("span",[t._v("\n          "+t._s(t.label)),void 0!==t.logo?n("i",{class:t.logo}):t._e()])])])])])},staticRenderFns:[]};var d=n("VU/8")(s,l,!1,function(t){n("ANi1"),n("eI/k")},"data-v-0e439f4c",null).exports,c={name:"pf-input",data:function(){return{maxlengthExceeded:!1}},mixins:[i],props:{accept:{type:String},align:{type:String},alt:{type:String},autocomplete:{type:String},autofocus:{type:Boolean,default:!1},checked:{type:Boolean,default:!1},dirname:{type:String},disabled:{type:Boolean,default:!1},form:{type:String},formaction:{type:String},formenctype:{type:String},formmethod:{type:String},formnovalidate:{type:Boolean,default:!1},formtarget:{type:String},height:{type:Number},list:{type:String},max:{type:Number},maxlength:{type:Number},min:{type:Number},multiple:{type:Boolean,default:!1},name:{type:String},pattern:{type:String},placeholder:{type:String},readonly:{type:Boolean,default:!1},required:{type:Boolean,default:!1},size:{type:Number},src:{type:String},step:{type:Number},type:{type:String,default:"text"},value:{},width:{type:Number},label:{type:String},divInput:{type:String},mask:{type:String,default:""},validate:{},labelStyle:{type:String},fData:{type:Object},fontSize:{type:Number},textInputGroup:{type:String},textInputGroupEnd:{type:String},isObligatory:{type:Boolean},btnInputGroupEnd:{type:String},btnInputGroupEndId:{type:String}},components:{PfButton:d}},h={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"form-group",class:t.divInput,attrs:{"data-toggle":"tooltip","data-placement":"top",title:!0===t.maxlengthExceeded?"Max Length Exceeded":""}},[n("label",{directives:[{name:"show",rawName:"v-show",value:void 0!==t.label,expression:"label !== undefined"}],staticClass:"labelInputs",style:t.labelStyle,attrs:{for:""}},[t._v(t._s(t.label))]),t._v(" "),n("div",{staticClass:"input-group input-group-sm"},[void 0!==t.textInputGroup?n("div",{staticClass:"input-group-prepend textInputGroup"},[n("div",{staticClass:"input-group-text"},[t._v(t._s(t.textInputGroup))])]):t._e(),t._v(" "),void 0!==t.validate?n("input",{directives:[{name:"validate",rawName:"v-validate",value:t.validate,expression:"validate"},{name:"mask",rawName:"v-mask",value:t.mask,expression:"mask"}],staticClass:"form-control form-control-sm",class:"myInputUpdated"===t.classElement?"updated-information":t.classElement,style:t.styleElement,attrs:{accesskey:t.accesskey,contenteditable:t.contenteditable,dir:t.dir,draggable:t.draggable,hidden:t.hidden,lang:t.lang,spellcheck:t.spellcheck,tabindex:!0!==t.readonly?t.tabindex:-1,title:t.title,type:t.type,name:t.name,id:t.id,accept:t.accept,align:t.align,alt:t.alt,autocomplete:t.autocomplete,autofocus:t.autofocus,dirname:t.dirname,disabled:t.disabled,form:t.form,formaction:t.formaction,formenctype:t.formenctype,formmethod:t.formmethod,formnovalidate:t.formnovalidate,formtarget:t.formtarget,height:t.height,list:t.list,max:t.max,maxlength:t.maxlength,min:t.min,multiple:t.multiple,pattern:t.pattern,placeholder:t.placeholder,readonly:t.readonly,required:t.required,size:t.size,src:t.src,step:t.step,width:t.width},domProps:{value:t.value,checked:t.checked},on:{input:function(e){return t.$emit("input",e.target.value)},change:function(e){return t.$emit("change")},click:function(e){return t.$emit("click")},contextmenu:function(e){return e.preventDefault(),t.$emit("context")},blur:function(e){return t.$emit("blur")},focus:function(e){return t.$emit("focus")},keyup:function(e){return t.$emit("keyup")},keydown:function(e){return!e.type.indexOf("key")&&t._k(e.keyCode,"tab",9,e.key,"Tab")?null:t.$emit("keytab")}}}):n("input",{directives:[{name:"mask",rawName:"v-mask",value:t.mask,expression:"mask"}],staticClass:"form-control form-control-sm",class:"myInputUpdated"===t.classElement?"updated-information":t.classElement,style:!0===t.maxlengthExceeded?t.styleElement+"border: 2px solid red !important;":t.styleElement,attrs:{accesskey:t.accesskey,contenteditable:t.contenteditable,dir:t.dir,draggable:t.draggable,hidden:t.hidden,lang:t.lang,spellcheck:t.spellcheck,tabindex:!0!==t.readonly?t.tabindex:-1,title:t.title,type:t.type,name:t.name,id:t.id,accept:t.accept,align:t.align,alt:t.alt,autocomplete:t.autocomplete,autofocus:t.autofocus,dirname:t.dirname,disabled:t.disabled,form:t.form,formaction:t.formaction,formenctype:t.formenctype,formmethod:t.formmethod,formnovalidate:t.formnovalidate,formtarget:t.formtarget,height:t.height,list:t.list,max:t.max,maxlength:t.maxlength,min:t.min,multiple:t.multiple,pattern:t.pattern,placeholder:t.placeholder,readonly:t.readonly,required:t.required,size:t.size,src:t.src,step:t.step,width:t.width},domProps:{value:t.value,checked:t.checked},on:{input:function(e){return t.$emit("input",e.target.value)},change:function(e){return t.$emit("change")},click:function(e){return t.$emit("click")},contextmenu:function(e){return e.preventDefault(),t.$emit("context")},blur:function(e){return t.$emit("blur")},focus:function(e){return t.$emit("focus")},keyup:function(e){!0===t.isForm&&t.$emit("keyup")},keydown:function(e){if(!e.type.indexOf("key")&&t._k(e.keyCode,"tab",9,e.key,"Tab"))return null;!0===t.isForm&&t.$emit("keytab")}}}),t._v(" "),void 0!==t.textInputGroupEnd?n("div",{staticClass:"input-group-prepend textInputGroup"},[n("div",{staticClass:"input-group-text"},[t._v(t._s(t.textInputGroupEnd))])]):t._e(),t._v(" "),void 0!==t.btnInputGroupEnd?n("div",{staticClass:"input-group-prepend textInputGroup"},[n("pf-button",{attrs:{id:t.btnInputGroupEndId,label:t.btnInputGroupEnd,classButton:"btn btn-outline-secondary",contentStyle:"display:inline;",noFadeOut:!0}})],1):t._e(),t._v(" "),!0===t.isObligatory?n("div",{staticClass:"invalid-feedback d-block fieldObli"},[t._v("Required Field")]):t._e()]),t._v(" "),!0===t.maxlengthExceeded?n("span",{staticStyle:{"font-size":"7pt",color:"red",right:"0","text-align":"initial",position:"absolute",width:"50px","background-color":"white","margin-top":"-16px","z-index":"9999",opacity:"0.8"}},[t._v("\n    Text Not Fit\n  ")]):t._e(),t._v(" "),void 0!==t.name&&t.errors.first(t.name)?n("span",{staticStyle:{"font-size":"8pt",color:"red","margin-bottom":"0px"}},[t._v("\n  "+t._s(t.errors.first(t.name).replace(t.name,"")))]):t._e()])},staticRenderFns:[]};var u,m=n("VU/8")(c,h,!1,function(t){n("QbpY"),n("sAoL")},"data-v-791025c1",null).exports,f=n("bOdI"),p=n.n(f),_={name:"pf-checkbox",data:function(){return{customCheckbox:0,tmpCss:"",classLabelOwn:null}},mixins:[i],props:(u={align:{type:String},alt:{type:String},autofocus:{type:Boolean,default:!1},checked:{type:Boolean,default:!1},dirname:{type:String},disabled:{type:Boolean,default:!1},form:{type:String},formaction:{type:String},formenctype:{type:String},formmethod:{type:String},formnovalidate:{type:Boolean,default:!1},formtarget:{type:String},height:{type:Number},name:{type:String,default:"inputName"},readonly:{type:Boolean,default:!1},size:{type:Number},value:{type:String},width:{type:Number},label:{type:String,default:""},classComponent:{},classComponentGlobal:{},classLabel:{},customLabel:{type:Boolean,default:!1},customMessage:{type:String},classCustom:{},classUpdate:{},styleComponent:{type:String,default:""},styleLabel:{},logo:{type:String},uniAfter:{type:Number},isShare:{type:Boolean},model:{type:String},isEditShare:{type:Boolean},isClient:{type:Boolean}},p()(u,"width",{type:Number}),p()(u,"customLabel",{type:String}),p()(u,"styleCustomLabel",{type:String}),p()(u,"styleComponentGlobal",{type:String}),p()(u,"styleDivThree",{type:String}),u),watch:{styleElement:function(t){!0===this.isForm&&(!0===this.isEditShare?!0===this.isShareField?(this.classLabelOwn="pseudoStyleCheckShareColor"+Math.floor(this.width),this.$emit("set-pseudo-share:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleCheckNoShareColor"+Math.floor(this.width),this.$emit("set-pseudo-noshare:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):!0===this.isReverse&&""!==this.model&&-1===this.model.indexOf("#")&&-1===this.model.indexOf("+")&&-1===this.model.indexOf("(")&&-1===this.model.indexOf(")")&&-1===this.model.indexOf(",")&&-1===this.model.indexOf("attorney")?!0===this.readonly?(this.classLabelOwn="pseudoStyleCheckReverseColorSide"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleReverseCheckColor"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):""!==this.model||!0===this.isClient&&!1===this.readonly?!0===this.readonly?(this.classLabelOwn="pseudoStyleCheckColorSide"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleCheckColor"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):!0===this.readonly?(this.classLabelOwn="pseudoStyleCheckSide"+Math.floor(this.width),this.$emit("set-pseudo",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleCheck"+Math.floor(this.width),this.$emit("set-pseudo",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})))},classLabel:function(t){this.classLabelOwn=t}},mounted:function(){this.classLabelOwn=this.classLabel,this.assignPseudo(this.styleElement)},methods:{assignPseudo:function(t){!0===this.isForm&&(!0===this.isEditShare?!0===this.isShareField?(this.classLabelOwn="pseudoStyleCheckShareColor"+Math.floor(this.width),this.$emit("set-pseudo-share:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleCheckNoShareColor"+Math.floor(this.width),this.$emit("set-pseudo-noshare:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):!0===this.isReverse&&""!==this.model&&-1===this.model.indexOf("#")&&-1===this.model.indexOf("+")&&-1===this.model.indexOf("(")&&-1===this.model.indexOf(")")&&-1===this.model.indexOf(",")&&-1===this.model.indexOf("attorney")?!0===this.readonly?(this.classLabelOwn="pseudoStyleCheckReverseColorSide"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleReverseCheckColor"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):""!==this.model||!0===this.isClient&&!1===this.readonly?!0===this.readonly?(this.classLabelOwn="pseudoStyleCheckColorSide"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleCheckColor"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):!0===this.readonly?(this.classLabelOwn="pseudoStyleCheckSide"+Math.floor(this.width),this.$emit("set-pseudo",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleCheck"+Math.floor(this.width),this.$emit("set-pseudo",{css:t,unidad:this.uniAfter,id:this.id,checkbox:!0,className:this.classLabelOwn})))}}},A={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:t.classComponentGlobal,style:t.styleComponentGlobal},[n("div",{class:t.classComponent},[n("div",{staticClass:"form-check myCheck",class:t.classUpdate,style:!0===t.isShare||!0===t.readonly?"pointer-events: none !important;":void 0!==t.styleDivThree?t.styleDivThree:"",attrs:{id:!0===t.readonly?"origincustomcheck"+t.id:"customcheck"+t.id}},[n("input",{staticClass:"form-check-input checkbox-custom myInput",class:"updated-information"===t.classElement||"new-information"===t.classElement||"myInputUpdated"===t.classElement?"myInputUpdated":t.classElement,style:t.styleElement,attrs:{accesskey:t.accesskey,contenteditable:t.contenteditable,dir:t.dir,draggable:t.draggable,hidden:t.hidden,id:t.id,lang:t.lang,spellcheck:t.spellcheck,tabindex:!0!==t.readonly?t.tabindex:-1,title:t.title,type:"checkbox",align:t.align,alt:t.alt,autofocus:t.autofocus,dirname:t.dirname,disabled:t.disabled,form:t.form,formaction:t.formaction,formenctype:t.formenctype,formmethod:t.formmethod,formnovalidate:t.formnovalidate,formtarget:t.formtarget,height:t.height,readonly:t.readonly,size:t.size,width:t.width,name:t.name},domProps:{checked:t.checked,value:t.value},on:{change:function(e){return t.$emit("change")},click:function(e){return t.$emit("click")},contextmenu:function(e){return e.preventDefault(),t.$emit("context")},focus:function(e){!0!==t.isShareField&&(t.isFocus=!0)},blur:function(e){!0!==t.isShareField&&(t.isFocus=!1)},keyup:function(e){!0===t.isForm&&t.$emit("keyup")},keydown:function(e){if(!e.type.indexOf("key")&&t._k(e.keyCode,"tab",9,e.key,"Tab"))return null;!0===t.isForm&&t.$emit("keytab")}}}),t._v(" "),n("label",{staticClass:"form-check-label checkbox-custom-label myLabel",class:t.classLabelOwn,style:!0===t.readonly?"pointer-events: none !important;cursor: not-allowed;":t.styleLabel,attrs:{id:"label"+t.id,for:t.id},on:{contextmenu:function(e){return e.preventDefault(),t.$emit("context")}}},[t._v(t._s(t.label)+" "),void 0!==t.logo?n("i",{class:t.logo}):t._e(),t._v(" "),void 0!==t.customLabel&&""!==t.customLabel?n("span",{style:t.styleCustomLabel},[t._v(t._s(t.customLabel)+"\n        ")]):t._e()])])])])},staticRenderFns:[]};var b,x=n("VU/8")(_,A,!1,function(t){n("flCC")},"data-v-1791480a",null).exports,g=n("pFYg"),v=n.n(g),C=n("T1ft"),y=n.n(C),w={name:"pf-select",data:function(){return{modelVSelect:null,translateChange:""}},mixins:[i],props:(b={disabled:{type:Boolean,default:!1},autofocus:{type:Boolean,default:!1},multiple:{type:Boolean,default:!1},name:{type:String},required:{type:Boolean,default:!1},size:{type:Number},label:{type:String},options:{},value:{},divSelect:{type:String},model:{type:String},field:{type:String},fieldType:{type:Number},formModel:{type:String},caseFormId:{},labelStyle:{type:String},isObligatory:{type:Boolean},isSearchSelect:{type:Boolean},placeholder:{type:String}},p()(b,"required",{type:Boolean}),p()(b,"isAddNew",{type:Boolean}),p()(b,"clearable",{type:Boolean,default:!0}),p()(b,"translate",{type:String}),b),components:{VSelect:y.a},computed:{setValue:function(){var t="";if("object"===v()(this.options)&&void 0!==this.options)return this.options.forEach(function(e){!0===e.selected&&(t=e.value)}),void 0!==this.options[0]&&""!==this.options[0].value&&""===t&&(t=this.options[0].value),t}},watch:{value:function(t){this.$emit("action-full:page"),this.modelVSelect=t}},mounted:function(){this.modelVSelect=this.value,this.translateChange=this.translate},methods:{openSelect:function(){var t=document.getElementById(this.id),e=new MouseEvent("mousedown");t.dispatchEvent(e)},search:function(t,e){this.$emit("search",t,e)}}},B={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"form-group myClassVselect",class:t.divSelect},[void 0!==t.label?n("label",{staticClass:"labelInputs",style:t.labelStyle},[t._v(t._s(t.label))]):t._e(),t._v(" "),!0===t.isSearchSelect?n("v-select",{staticClass:"form-control form-control-sm select-search-css",class:t.classElement,style:t.styleElement,attrs:{id:t.id,options:t.options,label:"fullName",placeholder:t.placeholder,required:t.required,disabled:t.disabled,clearable:t.clearable},on:{input:function(e){return t.$emit("input",t.modelVSelect)},search:t.search},scopedSlots:t._u([{key:"option",fn:function(e){return[!0===e.addNew?n("a",{staticStyle:{"margin-left":"-20px"},attrs:{href:"#"}},[n("i",{staticClass:"fas fa-plus"}),t._v(" "+t._s(e.fullName)+" ")]):n("span",[t._v("\n        "+t._s(e.fullName)+"\n        "),n("small",{staticStyle:{color:"red"}},[t._v(t._s(e.disabledMessage))])])]}}],null,!1,360420919),model:{value:t.modelVSelect,callback:function(e){t.modelVSelect=e},expression:"modelVSelect"}}):n("select",{staticClass:"form-control form-control-sm select-css",class:t.classElement,style:t.styleElement,attrs:{accesskey:t.accesskey,contenteditable:t.contenteditable,dir:t.dir,draggable:t.draggable,hidden:t.hidden,lang:t.lang,spellcheck:t.spellcheck,tabindex:!1===t.disabled?t.tabindex:-1,title:t.title,name:t.name,id:t.id,disabled:t.disabled,autofocus:t.autofocus,multiple:t.multiple,required:t.required,size:t.size,translate:"no"===t.translateChange?"no":""},domProps:{value:void 0!==t.value?t.value:t.setValue},on:{contextmenu:function(e){return e.preventDefault(),t.$emit("context")},change:function(e){return t.$emit("change",{value:e.target.value,model:t.model,field:t.field,id:t.id,fieldType:t.fieldType,formModel:t.formModel,caseFormId:t.caseFormId})},keyup:function(e){!0===t.isForm&&t.$emit("keyup")},keydown:function(e){if(!e.type.indexOf("key")&&t._k(e.keyCode,"tab",9,e.key,"Tab"))return null;!0===t.isForm&&t.$emit("keytab")},click:function(e){return t.$emit("click")},search:t.search}},[n("option"),t._v(" "),n("option",{attrs:{selected:"true",disabled:""}},[t._v(t._s(t.value))]),t._v(" "),t._l(t.options,function(e,i){return n("option",{key:i,domProps:{value:void 0!==e.value?e.value:e,selected:void 0!==e.selected?e.selected:e===t.value}},[t._v(t._s(void 0!==e.name?e.name:e)+"\n    ")])})],2),t._v(" "),!0===t.isObligatory?n("div",{staticClass:"invalid-feedback d-block fieldObli"},[t._v("Required Field")]):t._e()],1)},staticRenderFns:[]};var k=n("VU/8")(w,B,!1,function(t){n("JPsq"),n("UyrU"),n("7XDv")},"data-v-25e46b60",null).exports;function E(t,e){this.cell=document.createElement("DIV"),this.cell.className="dhx_cell"+(e||""),this._idd=t,this._isCell=!0,this.conf={borders:!0,idx:{},css:e||"",idx_data:{cont:"dhx_cell_cont",pr1:"dhx_cell_progress_bar",pr2:"dhx_cell_progress_img",pr3:"dhx_cell_progress_svg",menu:"dhx_cell_menu",toolbar:"dhx_cell_toolbar",ribbon:"dhx_cell_ribbon",sb:"dhx_cell_statusbar",cover:"dhx_cell_cover"},ofs_nodes:{t:{},b:{}}},this.dataNodes={},this.views={};var n=document.createElement("DIV");return n.className="dhx_cell_cont"+this.conf.css,this.cell.appendChild(n),n=null,this._updateIdx=function(){for(var t in this.conf.idx)this.conf.idx[t]=null,delete this.conf.idx[t];for(var e=0;e<this.cell.childNodes.length;e++){var n=this.cell.childNodes[e].className;for(var t in this.conf.idx_data){var i=new RegExp(this.conf.idx_data[t]);null!=n.match(i)&&(this.conf.idx[t]=e)}}this.callEvent("_onIdxUpdated",[])},this._adjustAttached=function(){for(var t in this.dataNodes)null!=this.dataNodes[t]&&"function"==typeof this.dataNodes[t].setSizes&&this.dataNodes[t].setSizes();if(null!=this.dataObj&&"function"==typeof this.dataObj.setSizes){if("layout"==this.dataType&&"function"==typeof window.dhtmlXLayoutCell&&this instanceof window.dhtmlXLayoutCell&&this.dataObj._getMainInst()!=this.layout._getMainInst())return void this.dataObj.setSizes();this.dataObj.setSizes.apply(this.dataObj,arguments)}},this._setSize=function(t,e,n,i,a,o,r,s){null==this.conf.size&&(this.conf.size={}),null==s&&(s={});var l={left:"x",top:"y",width:"w",height:"h"};for(var d in this.conf.size.x=t,this.conf.size.y=e,this.conf.size.w=Math.max(n,0),this.conf.size.h=Math.max(i,0),l){var c=s[d]||d;this.cell.style[c]=this.conf.size[l[d]]+"px"}this.callEvent("_onSetSize",[]),!0!==o?this._adjustCont(a,r):this._adjustAttached(a),this._adjustProgress()},this._adjustCont=function(t,e){var n=this.cell.childNodes[this.conf.idx.cont];if("function"==typeof window.dhtmlXLayoutCell&&this instanceof window.dhtmlXLayoutCell&&1==this.conf.collapsed)return n.style.left=n.style.top="0px",n.style.width=n.style.height="200px",void(n=null);var i=0;for(var a in this.conf.ofs_nodes.t){i+="func"==(r=this.conf.ofs_nodes.t[a])?this[a]():1==r?this.cell.childNodes[this.conf.idx[a]].offsetHeight:0}var o=0;for(var a in this.conf.ofs_nodes.b){var r;o+="func"==(r=this.conf.ofs_nodes.b[a])?this[a]():1==r?this.cell.childNodes[this.conf.idx[a]].offsetHeight:0}n.style.left="0px",n.style.top=i+"px",null==this.conf.cells_cont&&(this.conf.cells_cont={},n.style.width=this.cell.offsetWidth+"px",n.style.height=Math.max(this.cell.offsetHeight-i-o,0)+"px",this.conf.cells_cont.w=parseInt(n.style.width)-n.offsetWidth,this.conf.cells_cont.h=parseInt(n.style.height)-n.offsetHeight),n.style.left="0px",n.style.top=i+"px",n.style.width=Math.max(this.cell.offsetWidth+this.conf.cells_cont.w,0)+"px",n.style.height=Math.max(this.conf.size.h-i-o+this.conf.cells_cont.h,0)+"px",n=null,this._adjustAttached(t),"expand"==e&&"editor"==this.dataType&&null!=this.dataObj&&this.dataObj._prepareContent(!0)},this._mtbUpdBorder=function(){for(var t=["menu","toolbar","ribbon"],e=0;e<t.length;e++)if(null!=this.conf.idx[t[e]]){var n=this.cell.childNodes[this.conf.idx[t[e]]],i="dhx_cell_"+t[e]+"_no_borders",a="dhx_cell_"+t[e]+"_def";n.className=n.className.replace(new RegExp(this.conf.borders?i:a),this.conf.borders?a:i),n=null}},this._resetSizeState=function(){this.conf.cells_cont=null},this.conf.view="def",this.conf.views_loaded={},this.conf.views_loaded[this.conf.view]=!0,this._viewSave=function(t){this.views[t]={borders:this.conf.borders,ofs_nodes:{t:{},b:{}},url_data:this.conf.url_data,dataType:this.dataType,dataObj:this.dataObj,cellCont:[],dataNodes:{},dataNodesCont:{}};for(var e=this.cell.childNodes[this.conf.idx.cont];e.childNodes.length>0;)this.views[t].cellCont.push(e.firstChild),e.removeChild(e.firstChild);for(var n in e=null,this.dataType=null,this.dataObj=null,this.conf.url_data=null,this.dataNodes){for(var i in this.conf.ofs_nodes)void 0!==this.conf.ofs_nodes[i][n]&&(this.views[t].ofs_nodes[i][n]=this.conf.ofs_nodes[i][n],this.conf.ofs_nodes[i][n]=null,delete this.conf.ofs_nodes[i][n]);this.views[t].dataNodesCont[n]=this.cell.childNodes[this.conf.idx[n]],this.cell.removeChild(this.cell.childNodes[this.conf.idx[n]]),this.views[t].dataNodes[n]=this.dataNodes[n],this.dataNodes[n]=null,delete this.dataNodes[n],this._updateIdx()}this.callEvent("_onViewSave",[t])},this._viewRestore=function(t){if(null!=this.views[t]){this.dataObj=this.views[t].dataObj,this.dataType=this.views[t].dataType,this.conf.url_data=this.views[t].url_data;for(var e=0;e<this.views[t].cellCont.length;e++)this.cell.childNodes[this.conf.idx.cont].appendChild(this.views[t].cellCont[e]);for(var n in this.views[t].dataNodes)this.dataNodes[n]=this.views[t].dataNodes[n],"menu"==n&&this.cell.insertBefore(this.views[t].dataNodesCont[n],this.cell.childNodes[this.conf.idx.toolbar||this.conf.idx.cont]),"toolbar"==n&&this.cell.insertBefore(this.views[t].dataNodesCont[n],this.cell.childNodes[this.conf.idx.cont]),"ribbon"==n&&this.cell.insertBefore(this.views[t].dataNodesCont[n],this.cell.childNodes[this.conf.idx.cont]),"sb"==n&&this.cell.appendChild(this.views[t].dataNodesCont[n]),this._updateIdx();for(var n in this.views[t].ofs_nodes)for(var i in this.views[t].ofs_nodes[n])this.conf.ofs_nodes[n][i]=this.views[t].ofs_nodes[n][i];this.conf.borders!=this.views[t].borders&&this[this.views[t].borders?"_showBorders":"_hideBorders"](!0),"url"==this.dataType&&null!=this.conf.url_data&&0==this.conf.url_data.ajax&&null!=this.conf.url_data.post_data&&this.reloadURL(),this.callEvent("_onViewRestore",[t]),this._viewDelete(t)}},this._viewDelete=function(t){if(null!=this.views[t]){for(var e in this.views[t].borders=null,this.views[t].ofs_nodes){for(var n in this.views[t].ofs_nodes[e])this.views[t].ofs_nodes[e][n]=null;this.views[t].ofs_nodes[e]=null}this.views[t].dataType=null,this.views[t].dataObj=null,this.views[t].url_data=null;for(var i=0;i<this.views[t].cellCont.length;i++)this.views[t].cellCont[i]=null;for(var e in this.views[t].cellCont=null,this.views[t].dataNodes)this.views[t].dataNodes[e]=null,this.views[t].dataNodesCont[e]=null;this.views[t].dataNodes=this.views[t].dataNodesCont=null,this.views[t]=null,delete this.views[t]}},window.dhx4._eventable(this),this._updateIdx(),this}function I(t,e){if(0!=arguments.length&&void 0!==t){var n=this;if(this.dataNodes={},this.conf.ofs={t:0,b:0,l:0,r:0},this.conf.ofs_nodes={t:{},b:{}},this.conf.progress=!1,this.conf.fs_mode=!1,this.conf.fs_tm=null,this.conf.fs_resize=!1,t==document.body){if(this.conf.fs_mode=!0,this.base=t,this.base==document.body){var i={dhx_skyblue:{t:2,b:2,l:2,r:2},dhx_web:{t:8,b:8,l:8,r:8},dhx_terrace:{t:9,b:9,l:8,r:8},material:{t:9,b:9,l:8,r:8}};this.conf.ofs=null!=i[this.conf.skin]?i[this.conf.skin]:i.dhx_skyblue}}else this.base="string"==typeof t?document.getElementById(t):t;if(this.base.className+=" "+this.conf.css+"_base_"+this.conf.skin,this.cont=document.createElement("DIV"),this.cont.className=this.conf.css+"_cont",this.base.appendChild(this.cont),null!=e)this.setOffsets(e,!1);else if(null!=this.base._ofs){this.setOffsets(this.base._ofs,!1),this.base._ofs=null;try{delete this.base._ofs}catch(t){}}this._adjustCont=function(){var t=this.conf.ofs.t;for(var e in this.conf.ofs_nodes.t)t+=1==this.conf.ofs_nodes.t[e]?this.dataNodes[e].offsetHeight:0;var n=this.conf.ofs.b;for(var e in this.conf.ofs_nodes.b)n+=1==this.conf.ofs_nodes.b[e]?this.dataNodes[e].offsetHeight:0;this.cont.style.left=this.conf.ofs.l+"px",this.cont.style.width=this.base.clientWidth-this.conf.ofs.l-this.conf.ofs.r+"px",this.cont.style.top=t+"px",this.cont.style.height=this.base.clientHeight-t-n+"px"},this._setBaseSkin=function(t){this.base.className=this.base.className.replace(new RegExp(this.conf.css+"_base_"+this.conf.skin,"gi"),this.conf.css+"_base_"+t)},this._initFSResize=function(){1!=this.conf.fs_resize&&(this._doOnResizeStart=function(){window.clearTimeout(n.conf.fs_tm),n.conf.fs_tm=window.setTimeout(n._doOnResizeEnd,200)},this._doOnResizeEnd=function(){n.setSizes()},"function"==typeof window.addEventListener?window.addEventListener("resize",this._doOnResizeStart,!1):window.attachEvent("onresize",this._doOnResizeStart),this.conf.fs_resize=!0)},1==this.conf.fs_mode&&this._initFSResize(),this._unloadTop=function(){this._mtbUnload(),this.detachHeader(),this.detachFooter(),1==this.conf.fs_mode&&("function"==typeof window.addEventListener?window.removeEventListener("resize",this._doOnResizeStart,!1):window.detachEvent("onresize",this._doOnResizeStart)),this.base.removeChild(this.cont);var t=new RegExp("s{0,}"+this.conf.css+"_base_"+this.conf.skin,"gi");this.base.className=this.base.className.replace(t,""),this.cont=this.base=null,n=null},t=null}}E.prototype.showView=function(t){if(this.conf.view==t)return!1;this._viewSave(this.conf.view),this._viewRestore(t),this._updateIdx(),this._adjustCont(),this.conf.view=t;var e=void 0===this.conf.views_loaded[this.conf.view];return this.conf.views_loaded[this.conf.view]=!0,e},E.prototype.getViewName=function(){return this.conf.view},E.prototype.unloadView=function(t){if(t==this.conf.view){var e=this.conf.unloading;return this.conf.unloading=!0,"function"==typeof this.detachMenu&&this.detachMenu(),"function"==typeof this.detachToolbar&&this.detachToolbar(),"function"==typeof this.detachRibbon&&this.detachRibbon(),this.detachStatusBar(),this._detachObject(null,!0),this.conf.unloading=e,void(this.conf.unloading||this._adjustCont(this._idd))}if(null!=this.views[t]){var n=this.views[t];for(var i in n.dataNodes)"function"==typeof n.dataNodes[i].unload&&n.dataNodes[i].unload(),n.dataNodes[i]=null,n.dataNodesCont[i]=null;"url"==n.dataType?null!=n.cellCont&&"null"!=n.cellCont[0]&&this._detachURLEvents(n.cellCont[0]):null!=n.dataObj&&("function"==typeof n.dataObj.unload?n.dataObj.unload():"function"==typeof n.dataObj.destructor&&n.dataObj.destructor(),n.dataObj=null),n=null,this._viewDelete(t),void 0!==this.conf.views_loaded[t]&&delete this.conf.views_loaded[t]}},E.prototype.getId=function(){return this._idd},E.prototype.progressOn=function(){if(1!=this.conf.progress){this.conf.progress=!0;var t=document.createElement("DIV");t.className=this.conf.idx_data.pr1;var e=document.createElement("DIV");"material"==this.conf.skin&&(window.dhx4.isFF||window.dhx4.isChrome||window.dhx4.isOpera||window.dhx4.isEdge)?(e.className=this.conf.idx_data.pr3,e.innerHTML='<svg class="dhx_cell_prsvg" viewBox="25 25 50 50"><circle class="dhx_cell_prcircle" cx="50" cy="50" r="20"/></svg>'):e.className=this.conf.idx_data.pr2,null!=this.conf.idx.cover?this.cell.insertBefore(e,this.cell.childNodes[this.conf.idx.cover]):this.cell.appendChild(e),this.cell.insertBefore(t,e),t=e=null,this._updateIdx(),this._adjustProgress()}},E.prototype.progressOff=function(){if(1==this.conf.progress){for(var t in{pr3:3,pr2:2,pr1:1}){var e=this.cell.childNodes[this.conf.idx[t]];null!=e&&e.parentNode.removeChild(e),e=null}this.conf.progress=!1,this._updateIdx()}},E.prototype._adjustProgress=function(){if(null!=this.conf.idx.pr1){this.conf.pr||(this.conf.pr={});var t=this.cell.childNodes[this.conf.idx.pr1],e=this.cell.childNodes[this.conf.idx.pr2]||this.cell.childNodes[this.conf.idx.pr3];this.conf.pr.ofs||(e.style.width=t.offsetWidth+"px",e.style.height=t.offsetHeight+"px",this.conf.pr.ofs={w:e.offsetWidth-e.clientWidth,h:e.offsetHeight-e.clientHeight}),e.style.width=t.offsetWidth-this.conf.pr.ofs.w+"px",e.style.height=t.offsetHeight-this.conf.pr.ofs.h+"px",t=e=null}},E.prototype._showCellCover=function(){if(1!=this.conf.cover){this.conf.cover=!0;var t=document.createElement("DIV");t.className=this.conf.idx_data.cover,this.cell.appendChild(t),t=null,this._updateIdx()}},E.prototype._hideCellCover=function(){1==this.conf.cover&&(this.cell.removeChild(this.cell.childNodes[this.conf.idx.cover]),this._updateIdx(),this.conf.cover=!1)},E.prototype._showBorders=function(t){this.conf.borders||(this.conf.borders=!0,this.cell.childNodes[this.conf.idx.cont].className="dhx_cell_cont"+this.conf.css,this.conf.cells_cont=null,this._mtbUpdBorder(),this.callEvent("_onBorderChange",[!0]),!0!==t&&this._adjustCont(this._idd))},E.prototype._hideBorders=function(t){this.conf.borders&&(this.conf.borders=!1,this.cell.childNodes[this.conf.idx.cont].className="dhx_cell_cont"+this.conf.css+" dhx_cell_cont_no_borders",this.conf.cells_cont=null,this._mtbUpdBorder(),this.callEvent("_onBorderChange",[!1]),!0!==t&&this._adjustCont(this._idd))},E.prototype._getWidth=function(){return this.cell.offsetWidth},E.prototype._getHeight=function(){return this.cell.offsetHeight},E.prototype.showInnerScroll=function(){this.cell.childNodes[this.conf.idx.cont].style.overflow="auto"},E.prototype._unload=function(){for(var t in this.conf.unloading=!0,this.callEvent("_onCellUnload",[]),this.progressOff(),this.unloadView(this.conf.view),this.dataNodes=null,this.cell.parentNode.removeChild(this.cell),this.cell=null,window.dhx4._eventable(this,"clear"),this.views)this.unloadView(t);for(var t in this.conf=null,this)this[t]=null},E.prototype.attachObject=function(t,e){if(!window.dhx4.s2b(e)||"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell||(e=!1),"string"==typeof t&&(t=document.getElementById(t)),t.parentNode!=this.cell.childNodes[this.conf.idx.cont]){if(e){t.style.display="";var n=t.offsetWidth,i=t.offsetHeight}this._attachObject(t),this.dataType="obj",t.style.display="",t=null,e&&this._adjustByCont(n,i)}else t=null},E.prototype.appendObject=function(t){"string"==typeof t&&(t=document.getElementById(t)),t.parentNode!=this.cell.childNodes[this.conf.idx.cont]?(this.conf.append_mode||(this.cell.childNodes[this.conf.idx.cont].style.overflow="auto",this.conf.append_mode=!0),this._attachObject(t,null,null,!0),this.dataType="obj",t.style.display="",t=null):t=null},E.prototype.detachObject=function(t,e){this._detachObject(null,t,e)},E.prototype.getAttachedStatusBar=function(){return this.dataNodes.sb},E.prototype.getAttachedObject=function(){return"obj"==this.dataType||"url"==this.dataType||"url-ajax"==this.dataType?this.cell.childNodes[this.conf.idx.cont].firstChild:this.dataObj},E.prototype.attachURL=function(t,e,n){1==n&&(n={});var i=void 0!==n&&0!=n&&null!=n;if(null==this.conf.url_data&&(this.conf.url_data={}),this.conf.url_data.url=t,this.conf.url_data.ajax=1==e,this.conf.url_data.post_data=1==n?{}:n||null,null!=this.conf.url_data.xml_doc){try{this.conf.url_data.xml_doc.xmlDoc.abort()}catch(t){}this.conf.url_data.xml_doc.xmlDoc=null,this.conf.url_data.xml_doc=null}if(1==e){var a=this;if(i){var o="";for(var r in n)o+="&"+encodeURIComponent(r)+"="+encodeURIComponent(n[r]);this.conf.url_data.xml_doc=dhx4.ajax.post(t,o,function(t){null!=a.attachHTMLString&&"string"==typeof t.xmlDoc.responseText&&(a.attachHTMLString("<div style='position:relative;width:100%;height:100%;overflow:auto;'>"+t.xmlDoc.responseText+"</div>"),"function"==typeof a._doOnFrameContentLoaded&&a._doOnFrameContentLoaded(),a.dataType="url-ajax"),a=t=null})}else this.conf.url_data.xml_doc=dhx4.ajax.get(t,function(t){null!=a.attachHTMLString&&"string"==typeof t.xmlDoc.responseText&&(a.attachHTMLString("<div style='position:relative;width:100%;height:100%;overflow:auto;'>"+t.xmlDoc.responseText+"</div>"),"function"==typeof a._doOnFrameContentLoaded&&a._doOnFrameContentLoaded(),a.dataType="url-ajax"),a=t=null})}else{if("url"==this.dataType)var s=this.getFrame();else(s=document.createElement("IFRAME")).frameBorder=0,s.border=0,s.style.width="100%",s.style.height="100%",s.style.position="relative",this._attachObject(s),this.dataType="url",this._attachURLEvents();if(i){var l=void 0===this.conf.url_data.post_ifr;this.conf.url_data.post_ifr=!0,l&&this._attachURLEvents(),s.src="about:blank"}else s.src=t+window.dhx4.ajax._dhxr(t);s=null}s=null},E.prototype.reloadURL=function(){"url"!=this.dataType&&"url-ajax"!=this.dataType||null!=this.conf.url_data&&this.attachURL(this.conf.url_data.url,this.conf.url_data.ajax,this.conf.url_data.post_data)},E.prototype.attachHTMLString=function(t){this._attachObject(null,null,t);for(var e=t.match(/<script[^>]*>[^\f]*?<\/script>/g)||[],n=0;n<e.length;n++){var i=e[n].replace(/<([\/]{0,1})script[^>]*>/gi,"");i&&(window.execScript?window.execScript(i):window.eval(i))}},E.prototype.attachScheduler=function(t,e,n,i){i=i||window.scheduler;var a=!1;n&&((o=document.getElementById(n))&&(a=!0));if(!a){var o,r=n||'<div class="dhx_cal_tab" name="day_tab" style="right:204px;"></div><div class="dhx_cal_tab" name="week_tab" style="right:140px;"></div><div class="dhx_cal_tab" name="month_tab" style="right:76px;"></div>';(o=document.createElement("DIV")).id="dhxSchedObj_"+(new Date).getTime(),o.style.width="100%",o.style.height="100%",o.style.position="relative",o.style.overflow="hidden",o.className="dhx_cal_container",o.innerHTML='<div class="dhx_cal_navline"><div class="dhx_cal_prev_button">&nbsp;</div><div class="dhx_cal_next_button">&nbsp;</div><div class="dhx_cal_today_button"></div><div class="dhx_cal_date"></div>'+r+'</div><div class="dhx_cal_header"></div><div class="dhx_cal_data"></div>'}return this._attachObject(o),this.dataType="scheduler",this.dataObj=i,this.dataObj.setSizes=function(){this.update_view()},i.init(o.id,t,e),o=null,this.callEvent("_onContentAttach",[]),this.dataObj},E.prototype.attachMap=function(t){var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden",this._attachObject(e),t||(t={center:new google.maps.LatLng(40.719837,-73.992348),zoom:11,mapTypeId:google.maps.MapTypeId.ROADMAP}),this.dataType="maps",this.dataObj=new google.maps.Map(e,t),this.dataObj.setSizes=function(){google.maps.event.trigger(this,"resize")},e=null,this.callEvent("_onContentAttach",[]),this.dataObj},E.prototype._createNode_sb=function(t,e,n,i,a){if(void 0!==a)t=a;else{var o=e||{},r="string"==typeof o.text&&o.text.length>0?o.text:"&nbsp;",s="number"==typeof o.height&&o.height;(t=document.createElement("DIV")).className="dhx_cell_statusbar_def",t.innerHTML="<div class='"+(1==o.paging?"dhx_cell_statusbar_paging":"dhx_cell_statusbar_text")+"'>"+r+"</div>",0!=s&&(t.firstChild.style.height=t.firstChild.style.lineHeight=s+"px")}return null!=this.conf.idx.pr1?this.cell.insertBefore(t,this.cell.childNodes[this.conf.idx.pr1]):this.cell.appendChild(t),this.conf.ofs_nodes.b.sb=!0,this._updateIdx(),this._adjustCont(this._idd),t},E.prototype.attachStatusBar=function(t){if(!this.dataNodes.sb)return null!=t&&1==window.dhx4.s2b(t.paging)&&(t.height=null),"dhx_skyblue"==this.conf.skin&&"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell&&(this.cell.childNodes[this.conf.idx.cont].className+=" dhx_cell_statusbar_attached"),this.dataNodes.sb=this._attachObject("sb",t),this.dataNodes.sb.setText=function(t){this.childNodes[0].innerHTML=t},this.dataNodes.sb.getText=function(){return this.childNodes[0].innerHTML},this.dataNodes.sb.onselectstart=function(t){return!1},this.dataNodes.sb},E.prototype.detachStatusBar=function(){this.dataNodes.sb&&("dhx_skyblue"==this.conf.skin&&"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell&&(this.cell.childNodes[this.conf.idx.cont].className=this.cell.childNodes[this.conf.idx.cont].className.replace(/\s{0,}dhx_cell_statusbar_attached/,"")),this.dataNodes.sb.setText=this.dataNodes.sb.getText=this.dataNodes.sb.onselectstart=null,this.dataNodes.sb=null,delete this.dataNodes.sb,this._detachObject("sb"))},E.prototype.showStatusBar=function(){this._mtbShowHide("sb","")},E.prototype.hideStatusBar=function(){this._mtbShowHide("sb","none")},E.prototype._mtbShowHide=function(t,e){this.dataNodes[t]&&(this.cell.childNodes[this.conf.idx[t]].style.display=e,this._adjustCont())},E.prototype.getFrame=E.prototype._getFrame=function(){return"url"!=this.dataType?null:this.cell.childNodes[this.conf.idx.cont].firstChild},E.prototype._attachURLEvents=function(){if("url"==this.dataType){var t=this,e=this._idd,n=this.cell.childNodes[this.conf.idx.cont].firstChild;"function"!=typeof this._doOnFrameMouseDown&&(this._doOnFrameMouseDown=function(n){t.callEvent("_onContentMouseDown",[e,n||event])}),"function"==typeof window.addEventListener?n.onload=function(){try{"function"==typeof t._doOnFrameMouseDown&&this.contentWindow.document.body.addEventListener("mousedown",t._doOnFrameMouseDown,!1)}catch(t){}try{"function"==typeof t._doOnFrameContentLoaded&&t._doOnFrameContentLoaded()}catch(t){}}:n.onreadystatechange=function(e){if("complete"==this.readyState){try{"function"==typeof t._doOnFrameMouseDown&&this.contentWindow.document.body.attachEvent("onmousedown",t._doOnFrameMouseDown)}catch(t){}try{"function"==typeof t._doOnFrameContentLoaded&&t._doOnFrameContentLoaded()}catch(t){}}}}},E.prototype._doOnFrameContentLoaded=function(){if(1==this.conf.url_data.post_ifr){var t=this.getFrame().contentWindow.document,e=t.createElement("FORM");e.method="POST",e.action=this.conf.url_data.url,t.body.appendChild(e);var n={};for(var i in 1!=window.dhx4.ajax.cache&&(n["dhxr"+(new Date).getTime()]="1"),this.conf.url_data.post_data)n[i]=this.conf.url_data.post_data[i];for(var i in n){var a=t.createElement("INPUT");a.type="hidden",a.name=i,a.value=n[i],e.appendChild(a),a=null}this.conf.url_data.post_ifr=!1,e.submit()}else this.callEvent("_onContentLoaded",[this._idd])},E.prototype._detachURLEvents=function(t){if(null==t){if("url"!=this.dataType)return;t=this.cell.childNodes[this.conf.idx.cont].firstChild}if(t){if("function"==typeof window.addEventListener){t.onload=null;try{t.contentWindow.document.body.removeEventListener("mousedown",this._doOnFrameMouseDown,!1)}catch(t){}}else{t.onreadystatechange=null;try{t.contentWindow.document.body.detachEvent("onmousedown",this._doOnFrameMouseDown)}catch(t){}}t=null}},E.prototype._attachObject=function(t,e,n,i,a){if("string"==typeof t&&1=={menu:1,toolbar:1,ribbon:1,sb:1}[t])return this["_createNode_"+t].apply(this,arguments);1!=i&&this._detachObject(null,!0,null),"string"==typeof n?this.cell.childNodes[this.conf.idx.cont].innerHTML=n:this.cell.childNodes[this.conf.idx.cont].appendChild(t),t=null},E.prototype._detachObject=function(t,e,n){if(this.callEvent("_onBeforeContentDetach",[]),"menu"==t||"toolbar"==t||"ribbon"==t||"sb"==t)return(i=this.cell.childNodes[this.conf.idx[t]]).parentNode.removeChild(i),i=null,this.conf.ofs_nodes["sb"==t?"b":"t"][t]=!1,this._updateIdx(),void(this.conf.unloading||this._adjustCont(this._idd));if(1==e?n=!1:void 0===n?n=document.body:"string"==typeof n&&(n=document.getElementById(n)),!1===n){if(1==this.conf.unloading&&null!=String(this.dataType).match(/ajax/)&&null!=this.conf.url_data&&null!=this.conf.url_data.xml_doc){try{this.conf.url_data.xml_doc.xmlDoc.abort()}catch(t){}this.conf.url_data.xml_doc.xmlDoc=null,this.conf.url_data.xml_doc=null}"url"==this.dataType?this._detachURLEvents():null!=this.dataObj&&("function"==typeof this.dataObj.unload?this.dataObj.unload():"function"==typeof this.dataObj.destructor&&this.dataObj.destructor())}for(var i=this.cell.childNodes[this.conf.idx.cont];i.childNodes.length>0;)!1===n?i.removeChild(i.lastChild):(i.firstChild.style.display="none",n.appendChild(i.firstChild));this.conf.append_mode&&(i.style.overflow="",this.conf.append_mode=!1);var a="tabbar"==this.dataType;this.dataObj=null,this.dataType=null,n=i=null,1!=this.conf.unloading&&a&&(this.showHeader(!0),this._showBorders())},E.prototype._attachFromCell=function(t){this.detachObject(!0);var e="layout";for(var n in"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell&&(e="window"),"function"==typeof window.dhtmlXWindowsCell&&t instanceof window.dhtmlXWindowsCell&&1==t.wins.w[t._idd].conf.parked&&t.wins._winCellSetOpacity(t._idd,"open",!1),"function"==typeof window.dhtmlXAccordionCell&&t instanceof window.dhtmlXAccordionCell&&0==t.conf.opened&&t._cellSetOpacity("open",!1),t.dataNodes)this._attachObject(n,null,null,null,t.cell.childNodes[t.conf.idx[n]]),this.dataNodes[n]=t.dataNodes[n],t.dataNodes[n]=null,t.conf.ofs_nodes["sb"==n?"b":"t"][n]=!1,t._updateIdx();if(this._mtbUpdBorder(),null!=t.dataType&&null!=t.dataObj){for(this.dataType=t.dataType,this.dataObj=t.dataObj;t.cell.childNodes[t.conf.idx.cont].childNodes.length>0;)this.cell.childNodes[this.conf.idx.cont].appendChild(t.cell.childNodes[t.conf.idx.cont].firstChild);t.dataType=null,t.dataObj=null,"grid"==this.dataType&&("window"==e&&"dhx_skyblue"==this.conf.skin?(this.dataObj.entBox.style.border="1px solid #a4bed4",this.dataObj._sizeFix=0):(this.dataObj.entBox.style.border="0px solid white",this.dataObj._sizeFix=2))}else for(;t.cell.childNodes[t.conf.idx.cont].childNodes.length>0;)this.cell.childNodes[this.conf.idx.cont].appendChild(t.cell.childNodes[t.conf.idx.cont].firstChild);for(var n in this.conf.view=t.conf.view,t.conf.view="def",t.views)this.views[n]=t.views[n],t.views[n]=null,delete t.views[n];t._updateIdx(),t._adjustCont(),this._updateIdx(),this._adjustCont(),1==t.conf.progress?(t.progressOff(),this.progressOn()):this.progressOff(),"window"==e&&this.wins.w[this._idd].conf.parked&&this.wins._winCellSetOpacity(this._idd,"close",!1)},I.prototype.setOffsets=function(t,e){var n=!1;for(var i in t){var a=i.charAt(0);void 0===this.conf.ofs[a]||isNaN(t[i])||(this.conf.ofs[a]=parseInt(t[i]),n=!0)}!1!==e&&"function"==typeof this.setSizes&&1==n&&this.setSizes()},I.prototype.attachMenu=function(t){if(null==this.dataNodes.menu)return this.dataNodes.menuObj=document.createElement("DIV"),this.dataNodes.menuObj.className="dhxcelltop_menu",this.base.insertBefore(this.dataNodes.menuObj,this.dataNodes.toolbarObj||this.dataNodes.ribbonObj||this.cont),"object"==typeof t&&null!=t||(t={}),t.skin=this.conf.skin,t.parent=this.dataNodes.menuObj,this.dataNodes.menu=new dhtmlXMenuObject(t),this.dataNodes.menuEv=this.attachEvent("_onSetSizes",function(){"none"!=this.dataNodes.menuObj.style.display&&(null==this.conf.ofs_menu&&(this.dataNodes.menuObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px",this.conf.ofs_menu={w:this.dataNodes.menuObj.offsetWidth-parseInt(this.dataNodes.menuObj.style.width)}),this.dataNodes.menuObj.style.left=this.conf.ofs.l+"px",this.dataNodes.menuObj.style.marginTop=(null!=this.dataNodes.haObj?0:this.conf.ofs.t)+"px",this.dataNodes.menuObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r-this.conf.ofs_menu.w+"px")}),this.conf.ofs_nodes.t.menuObj=!0,this.setSizes(),t.parnt=null,t=null,this.dataNodes.menu},I.prototype.detachMenu=function(){null!=this.dataNodes.menu&&(this.dataNodes.menu.unload(),this.dataNodes.menu=null,this.dataNodes.menuObj.parentNode.removeChild(this.dataNodes.menuObj),this.dataNodes.menuObj=null,this.detachEvent(this.dataNodes.menuEv),this.dataNodes.menuEv=null,delete this.dataNodes.menu,delete this.dataNodes.menuObj,delete this.dataNodes.menuEv,this.conf.ofs_nodes.t.menuObj=!1,this.conf.unloading||this.setSizes())},I.prototype.attachToolbar=function(t){if(null==this.dataNodes.ribbon&&null==this.dataNodes.toolbar)return this.dataNodes.toolbarObj=document.createElement("DIV"),this.dataNodes.toolbarObj.className="dhxcelltop_toolbar",this.base.insertBefore(this.dataNodes.toolbarObj,this.cont),this.dataNodes.toolbarObj.appendChild(document.createElement("DIV")),"object"==typeof t&&null!=t||(t={}),t.skin=this.conf.skin,t.parent=this.dataNodes.toolbarObj.firstChild,this.dataNodes.toolbar=new dhtmlXToolbarObject(t),this.dataNodes.toolbarEv=this.attachEvent("_onSetSizes",function(){"none"!=this.dataNodes.toolbarObj.style.display&&(this.dataNodes.toolbarObj.style.left=this.conf.ofs.l+"px",this.dataNodes.toolbarObj.style.marginTop=(null!=this.dataNodes.haObj||null!=this.dataNodes.menuObj?0:this.conf.ofs.t)+"px",this.dataNodes.toolbarObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px")}),this.dataNodes.toolbar._masterCell=this,this.dataNodes.toolbar.attachEvent("_onIconSizeChange",function(){this._masterCell.setSizes()}),this.conf.ofs_nodes.t.toolbarObj=!0,this.setSizes(),t.parnt=null,t=null,this.dataNodes.toolbar},I.prototype.detachToolbar=function(){null!=this.dataNodes.toolbar&&(this.dataNodes.toolbar._masterCell=null,this.dataNodes.toolbar.unload(),this.dataNodes.toolbar=null,this.dataNodes.toolbarObj.parentNode.removeChild(this.dataNodes.toolbarObj),this.dataNodes.toolbarObj=null,this.detachEvent(this.dataNodes.toolbarEv),this.dataNodes.toolbarEv=null,this.conf.ofs_nodes.t.toolbarObj=!1,delete this.dataNodes.toolbar,delete this.dataNodes.toolbarObj,delete this.dataNodes.toolbarEv,this.conf.unloading||this.setSizes())},I.prototype.attachRibbon=function(t){if(null==this.dataNodes.ribbon&&null==this.dataNodes.toolbar){this.dataNodes.ribbonObj=document.createElement("DIV"),this.dataNodes.ribbonObj.className="dhxcelltop_ribbon",this.base.insertBefore(this.dataNodes.ribbonObj,this.cont),this.dataNodes.ribbonObj.appendChild(document.createElement("DIV")),"object"==typeof t&&null!=t||(t={}),t.skin=this.conf.skin,t.parent=this.dataNodes.ribbonObj.firstChild,this.dataNodes.ribbon=new dhtmlXRibbon(t),this.dataNodes.ribbonEv=this.attachEvent("_onSetSizes",function(){"none"!=this.dataNodes.ribbonObj.style.display&&(this.dataNodes.ribbonObj.style.left=this.conf.ofs.l+"px",this.dataNodes.ribbonObj.style.marginTop=(null!=this.dataNodes.haObj||null!=this.dataNodes.menuObj?0:this.conf.ofs.t)+"px",this.dataNodes.ribbonObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px",this.dataNodes.ribbon.setSizes())}),this.conf.ofs_nodes.t.ribbonObj=!0;var e=this;return this.dataNodes.ribbon.attachEvent("_onHeightChanged",function(){e.setSizes()}),this.setSizes(),t.parnt=null,t=null,this.dataNodes.ribbon}},I.prototype.detachRibbon=function(){null!=this.dataNodes.ribbon&&(this.dataNodes.ribbon.unload(),this.dataNodes.ribbon=null,this.dataNodes.ribbonObj.parentNode.removeChild(this.dataNodes.ribbonObj),this.dataNodes.ribbonObj=null,this.detachEvent(this.dataNodes.ribbonEv),this.dataNodes.ribbonEv=null,this.conf.ofs_nodes.t.ribbonObj=!1,delete this.dataNodes.ribbon,delete this.dataNodes.ribbonObj,delete this.dataNodes.ribbonEv,this.conf.unloading||this.setSizes())},I.prototype.attachStatusBar=function(t){if(!this.dataNodes.sbObj)return void 0===t&&(t={}),this.dataNodes.sbObj=document.createElement("DIV"),this.dataNodes.sbObj.className="dhxcelltop_statusbar",null!=this.cont.nextSibling?this.base.insertBefore(this.dataNodes.sbObj,this.cont.nextSibling):this.base.appendChild(this.dataNodes.sbObj),this.dataNodes.sbObj.innerHTML="<div class='dhxcont_statusbar'>"+("string"==typeof t.text&&t.text.length>0?t.text:"&nbsp;")+"</div>","number"==typeof t.height&&(this.dataNodes.sbObj.firstChild.style.height=this.dataNodes.sbObj.firstChild.style.lineHeight=t.height+"px"),this.dataNodes.sbObj.setText=function(t){this.childNodes[0].innerHTML=t},this.dataNodes.sbObj.getText=function(){return this.childNodes[0].innerHTML},this.dataNodes.sbObj.onselectstart=function(t){return!1},this.dataNodes.sbEv=this.attachEvent("_onSetSizes",function(){"none"!=this.dataNodes.sbObj.style.display&&(this.dataNodes.sbObj.style.left=this.conf.ofs.l+"px",this.dataNodes.sbObj.style.bottom=(null!=this.dataNodes.faObj?this.dataNodes.faObj.offsetHeight:0)+this.conf.ofs.t+"px",this.dataNodes.sbObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px")}),this.conf.ofs_nodes.b.sbObj=!0,this.setSizes(),this.dataNodes.sbObj},I.prototype.detachStatusBar=function(){this.dataNodes.sbObj&&(this.dataNodes.sbObj.setText=this.dataNodes.sbObj.getText=this.dataNodes.sbObj.onselectstart=null,this.dataNodes.sbObj.parentNode.removeChild(this.dataNodes.sbObj),this.dataNodes.sbObj=null,this.detachEvent(this.dataNodes.sbEv),this.dataNodes.sbEv=null,this.conf.ofs_nodes.b.sbObj=!1,delete this.dataNodes.sb,delete this.dataNodes.sbObj,delete this.dataNodes.sbEv,this.conf.unloading||this.setSizes())},I.prototype.showMenu=function(){this._mtbShowHide("menuObj","")},I.prototype.hideMenu=function(){this._mtbShowHide("menuObj","none")},I.prototype.showToolbar=function(){this._mtbShowHide("toolbarObj","")},I.prototype.hideToolbar=function(){this._mtbShowHide("toolbarObj","none")},I.prototype.showRibbon=function(){this._mtbShowHide("ribbonObj","")},I.prototype.hideRibbon=function(){this._mtbShowHide("ribbonObj","none")},I.prototype.showStatusBar=function(){this._mtbShowHide("sbObj","")},I.prototype.hideStatusBar=function(){this._mtbShowHide("sbObj","none")},I.prototype._mtbShowHide=function(t,e){null!=this.dataNodes[t]&&(this.dataNodes[t].style.display=e,this.setSizes())},I.prototype._mtbUnload=function(t,e){this.detachMenu(),this.detachToolbar(),this.detachStatusBar(),this.detachRibbon()},I.prototype.getAttachedMenu=function(){return this.dataNodes.menu},I.prototype.getAttachedToolbar=function(){return this.dataNodes.toolbar},I.prototype.getAttachedRibbon=function(){return this.dataNodes.ribbon},I.prototype.getAttachedStatusBar=function(){return this.dataNodes.sbObj},I.prototype.progressOn=function(){if(!this.conf.progress){this.conf.progress=!0;var t=document.createElement("DIV");t.className="dhxcelltop_progress",this.base.appendChild(t);var e=document.createElement("DIV");if("material"==this.conf.skin&&(window.dhx4.isFF||window.dhx4.isChrome||window.dhx4.isOpera||window.dhx4.isEdge))e.className="dhxcelltop_progress_svg",e.innerHTML='<svg class="dhx_cell_prsvg" viewBox="25 25 50 50"><circle class="dhx_cell_prcircle" cx="50" cy="50" r="20"/></svg>';else(e=document.createElement("DIV")).className="dhxcelltop_progress_img";this.base.appendChild(e),t=e=null}},I.prototype.progressOff=function(){if(this.conf.progress){for(var t={dhxcelltop_progress:!0,dhxcelltop_progress_img:!0,dhxcelltop_progress_svg:!0},e=0;e<this.base.childNodes.length;e++)void 0!==this.base.childNodes[e].className&&1==t[this.base.childNodes[e].className]&&(t[this.base.childNodes[e].className]=this.base.childNodes[e]);for(var n in t)1!=t[n]&&this.base.removeChild(t[n]),t[n]=null;this.conf.progress=!1,t=null}},I.prototype.attachHeader=function(t,e){null==this.dataNodes.haObj&&("object"!=typeof t&&(t=document.getElementById(t)),this.dataNodes.haObj=document.createElement("DIV"),this.dataNodes.haObj.className="dhxcelltop_hdr",this.dataNodes.haObj.style.height=(e||t.offsetHeight)+"px",this.base.insertBefore(this.dataNodes.haObj,this.dataNodes.menuObj||this.dataNodes.toolbarObj||this.cont),this.dataNodes.haObj.appendChild(t),t.style.visibility="visible",t=null,this.dataNodes.haEv=this.attachEvent("_onSetSizes",function(){this.dataNodes.haObj.style.left=this.conf.ofs.l+"px",this.dataNodes.haObj.style.marginTop=this.conf.ofs.t+"px",this.dataNodes.haObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px"}),this.conf.ofs_nodes.t.haObj=!0,this.setSizes())},I.prototype.detachHeader=function(){if(this.dataNodes.haObj){for(;this.dataNodes.haObj.childNodes.length>0;)this.dataNodes.haObj.lastChild.style.visibility="hidden",document.body.appendChild(this.dataNodes.haObj.lastChild);this.dataNodes.haObj.parentNode.removeChild(this.dataNodes.haObj),this.dataNodes.haObj=null,this.detachEvent(this.dataNodes.haEv),this.dataNodes.haEv=null,this.conf.ofs_nodes.t.haObj=!1,delete this.dataNodes.haEv,delete this.dataNodes.haObj,this.conf.unloading||this.setSizes()}},I.prototype.attachFooter=function(t,e){if(null==this.dataNodes.faObj){"object"!=typeof t&&(t=document.getElementById(t)),this.dataNodes.faObj=document.createElement("DIV"),this.dataNodes.faObj.className="dhxcelltop_ftr",this.dataNodes.faObj.style.height=(e||t.offsetHeight)+"px";var n=this.dataNodes.sbObj||this.cont;this.base.lastChild==n?this.base.appendChild(this.dataNodes.faObj):this.base.insertBefore(this.dataNodes.faObj,n.nextSibling),this.dataNodes.faEv=this.attachEvent("_onSetSizes",function(){this.dataNodes.faObj.style.left=this.conf.ofs.l+"px",this.dataNodes.faObj.style.bottom=this.conf.ofs.b+"px",this.dataNodes.faObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px"}),this.dataNodes.faObj.appendChild(t),t.style.visibility="visible",n=t=null,this.conf.ofs_nodes.b.faObj=!0,this.setSizes()}},I.prototype.detachFooter=function(){if(this.dataNodes.faObj){for(;this.dataNodes.faObj.childNodes.length>0;)this.dataNodes.faObj.lastChild.style.visibility="hidden",document.body.appendChild(this.dataNodes.faObj.lastChild);this.dataNodes.faObj.parentNode.removeChild(this.dataNodes.faObj),this.dataNodes.faObj=null,this.detachEvent(this.dataNodes.faEv),this.dataNodes.faEv=null,this.conf.ofs_nodes.b.faObj=!1,delete this.dataNodes.faEv,delete this.dataNodes.faObj,this.conf.unloading||this.setSizes()}};var D=E;n("ugSv");function S(t,e){var n=this;for(this.conf={content:"",contentHTML:"",resizeTM:null,resizeTMTime:100,roMode:!1,toolbar:!1,iconsPath:"",evs:["focus","blur","keydown","keyup","keypress","mouseup","mousedown","click","touchend"],iOSfix:null!=navigator.userAgent.match(/Mobile/gi)&&null!=navigator.userAgent.match(/iPad/gi)&&null!=navigator.userAgent.match(/AppleWebKit/gi),extra_css:"",font:{family:"Tahoma",size:"12px",color:"black"}},this._doOnFocusChanged=null,this._doOnAccess=null,"object"==typeof t&&null!=t&&null==t.tagName&&(e=t.skin,null!=t.content&&(this.conf.content=t.content),null!=t.contentHTML&&(this.conf.contentHTML=t.contentHTML),null!=t.iconsPath&&(this.conf.iconsPath=t.iconsPath),null!=t.extraCss&&(this.conf.extra_css=t.extraCss),null!=t.toolbar&&(this.conf.toolbar=window.dhx4.s2b(t.toolbar)),null!=t.onFocusChanged&&(this._doOnFocusChanged=t.onFocusChanged),null!=t.onAccess&&(this._doOnAccess=t.onAccess),t=t.parent),this.conf.skin=e||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxeditor")||"material","string"==typeof t&&(t=document.getElementById(t)),this.base=t,this.base.className+=" dhxeditor_"+this.conf.skin;this.base.childNodes.length>0;)this.base.removeChild(this.base.childNodes[0]);var i=window.dhx4.isIE?this.base.currentStyle.position:null!=window.getComputedStyle?window.getComputedStyle(this.base,null).getPropertyValue("position"):"";"relative"!=i&&"absolute"!=i&&(this.base.style.position="relative"),this.cell=new dhtmlXEditorCell(window.dhx4.newId(),this),this.base.appendChild(this.cell.cell),this.cBlock=document.createElement("DIV"),this.cBlock.className="dhxcont_content_blocker",this.cBlock.style.display="none",this.base.appendChild(this.cBlock),this.editor=document.createElement("IFRAME"),this.editor.className="dhxeditor_mainiframe",this.editor.frameBorder=0,window.dhx4.isOpera&&(this.editor.scrolling="yes"),this.setSizes();var a=this.editor;return void 0!==window.addEventListener?a.onload=function(){for(var t=0;t<n.conf.evs.length;t++)a.contentWindow.addEventListener(n.conf.evs[t],n._ev,!1)}:a.onreadystatechange=function(t){if(void 0!==a.readyState&&"complete"==a.readyState)try{for(var e=0;e<n.conf.evs.length;e++)a.contentWindow.document.body.attachEvent("on"+n.conf.evs[e],n._ev)}catch(t){}},this._ev=function(t){var e=(t=t||event).type;1!=n.conf.iOSfix||"touchend"!=e?(n.callEvent("onAccess",[e,t]),"function"==typeof n._doOnAccess?n._doOnAccess(e,t):"string"==typeof n._doOnAccess&&"function"==typeof window[n._doOnAccess]&&window[n._doOnAccess](e,t)):n.editor.contentWindow.focus()},this._focus=function(){window.dhx4.isIE?this.editor.contentWindow.document.body.focus():this.editor.contentWindow.focus()},this.cell.attachObject(this.editor),this.edWin=this.editor.contentWindow,this.edDoc=this.edWin.document,this._prepareContent=function(t,e){var n="";!0===t&&null!=this.getContent&&(n=this.getContent());var i=this.editor.contentWindow.document;if(i.open("text/html","replace"),window.dhx4.isOpera?i.write("<html><head>"+this.conf.extra_css+"<style> html, body { overflow:auto;-webkit-overflow-scrolling: touch; padding:0px; height:100%; margin:0px; background-color:#ffffff; "+this._fontConf()+"} </style></head><body "+(!0!==e?"contenteditable='true'":"")+" tabindex='0'></body></html>"):window.dhx4.isKHTML?i.write("<html><head>"+this.conf.extra_css+"<style> html {overflow-x: auto;-webkit-overflow-scrolling: touch; overflow-y: auto;} body { overflow: auto; overflow-y: scroll;} html,body { padding:0px; height:100%; margin:0px; background-color:#ffffff; "+this._fontConf()+"} </style></head><body "+(!0!==e?"contenteditable='true'":"")+" tabindex='0'></body></html>"):window.dhx4.isIE?i.write("<html><head>"+this.conf.extra_css+"<style> html {overflow-y: auto;} body {overflow-y: scroll;-webkit-overflow-scrolling: touch;} html,body { overflow-x: auto; padding:0px; height:100%; margin:0px; background-color: #ffffff; outline: none; "+this._fontConf()+"} </style></head><body "+(!0!==e?"contenteditable='true'":"")+" tabindex='0'></body></html>"):i.write("<html><head>"+this.conf.extra_css+"<style> html,body { overflow-x: auto; overflow-y:-webkit-overflow-scrolling: touch; scroll; padding:0px; height:100%; margin:0px; background-color:#ffffff; "+this._fontConf()+"} </style></head><body "+(!0!==e?"contenteditable='true'":"")+" tabindex='0'></body></html>"),i.close(),window.dhx4.isIE?i.contentEditable=!0!==e:i.designMode=!0!==e?"On":"Off",window.dhx4.isFF)try{i.execCommand("useCSS",!1,!0)}catch(t){}!0===t&&null!=this.setContent&&this.setContent(n)},this._prepareContent(),this._doOnResize=function(){window.clearTimeout(n.conf.resizeTM),n.conf.resizeTM=window.setTimeout(function(){n.setSizes&&n.setSizes()},n.conf.resizeTMTime)},this._runCommand=function(t,e){if(!0!==this.conf.roMode){arguments.length<2&&(e=null),window.dhx4.isIE&&this.edWin.focus();try{this.editor.contentWindow.document.execCommand(t,!1,e)}catch(t){}if(window.dhx4.isIE){this.edWin.focus();var n=this;window.setTimeout(function(){n.edWin.focus(),n=null},1)}}},this.applyBold=function(){this._runCommand("Bold")},this.applyItalic=function(){this._runCommand("Italic")},this.applyUnderscore=function(){this._runCommand("Underline")},this.clearFormatting=function(){this._runCommand("RemoveFormat");var t=this.getContent();t=t.replace(/<\/?h\d>/gi,""),this.setContent(t)},this._doOnClick=function(t){var e=t||window.event,i=e.target||e.srcElement;n._showInfo(i)},this._doOnMouseDown=function(t){var e=t||window.event,i=e.target||e.srcElement;n._showInfo(i)},this._doOnKeyUp=function(t){var e=t||window.event,i=e.keyCode,a=e.target||e.srcElement;1=={37:1,38:1,39:1,40:1,13:1}[i]&&n._showInfo(a)},this._getParentByTag=function(t,e){e=e.toLowerCase();var n=t;do{if(""==e||n.nodeName.toLowerCase()==e)return n}while(n=n.parentNode);return t},this._isStyleProperty=function(t,e,n,i){e=e.toLowerCase();var a=t;do{if(a.nodeName.toLowerCase()==e&&a.style[n]==i)return!0}while(a=a.parentNode);return!1},this._setStyleProperty=function(t,e){this.style[e]=!1;var n=this._getParentByTag(t,e);n&&n.tagName.toLowerCase()==e&&(this.style[e]=!0),"del"==e&&this._getParentByTag(t,"strike")&&"strike"==this._getParentByTag(t,"strike").tagName.toLowerCase()&&(this.style.del=!0)},this._showInfo=function(t){if((t=this._getSelectionBounds().end?this._getSelectionBounds().end:t)&&this._setStyleProperty)try{if(this.edWin.getComputedStyle){var e=401==(n=this.edWin.getComputedStyle(t,null)).getPropertyValue("font-weight")?700:n.getPropertyValue("font-weight");this.style={fontStyle:n.getPropertyValue("font-style"),fontSize:n.getPropertyValue("font-size"),textDecoration:n.getPropertyValue("text-decoration"),fontWeight:e,fontFamily:n.getPropertyValue("font-family"),textAlign:n.getPropertyValue("text-align")},window.dhx4.isKHTML&&(this.style.fontStyle=n.getPropertyValue("font-style"),this.style.vAlign=n.getPropertyValue("vertical-align"),this.style.del=this._isStyleProperty(t,"span","textDecoration","line-through"),this.style.u=this._isStyleProperty(t,"span","textDecoration","underline"))}else{var n=t.currentStyle;this.style={fontStyle:n.fontStyle,fontSize:n.fontSize,textDecoration:n.textDecoration,fontWeight:n.fontWeight,fontFamily:n.fontFamily,textAlign:n.textAlign}}this._setStyleProperty(t,"h1"),this._setStyleProperty(t,"h2"),this._setStyleProperty(t,"h3"),this._setStyleProperty(t,"h4"),window.dhx4.isKHTML||(this._setStyleProperty(t,"del"),this._setStyleProperty(t,"sub"),this._setStyleProperty(t,"sup"),this._setStyleProperty(t,"u")),this.callEvent("onFocusChanged",[this.style,n])}catch(t){return null}},this._getSelectionBounds=function(){var t,e,n,i;if(this.edWin.getSelection){var a=this.edWin.getSelection();return window.dhx4.isEdge&&0==a.rangeCount?{root:null,start:null,end:null}:(n=(t=a.getRangeAt(a.rangeCount-1)).startContainer,i=t.endContainer,e=t.commonAncestorContainer,"#text"==n.nodeName&&(e=e.parentNode),"#text"==n.nodeName&&(n=n.parentNode),"body"==n.nodeName.toLowerCase()&&(n=n.firstChild),"#text"==i.nodeName&&(i=i.parentNode),"body"==i.nodeName.toLowerCase()&&(i=i.lastChild),n==i&&(e=n),{root:e,start:n,end:i})}if(this.edWin.document.selection){if(!(t=this.edDoc.selection.createRange()).duplicate)return null;e=t.parentElement();var o=t.duplicate(),r=t.duplicate();return o.collapse(!0),r.moveToElementText(o.parentElement()),r.setEndPoint("EndToStart",o),n=o.parentElement(),o=t.duplicate(),(r=t.duplicate()).collapse(!1),o.moveToElementText(r.parentElement()),o.setEndPoint("StartToEnd",r),i=r.parentElement(),"body"==n.nodeName.toLowerCase()&&(n=n.firstChild),"body"==i.nodeName.toLowerCase()&&(i=i.lastChild),n==i&&(e=n),{root:e,start:n,end:i}}return null},this.getContent=function(){return this.edDoc.body?window.dhx4.isFF||window.dhx4.isChrome?this.editor.contentWindow.document.body.innerHTML.replace(/<\/{0,}br\/{0,}>\s{0,}$/gi,""):window.dhx4.isIE&&0==this.edDoc.body.innerText.length?"":this.edDoc.body.innerHTML:""},this.setContent=function(t){if(t=t||"",this.edDoc.body){var e=!1;if(window.dhx4.isFF){var i=navigator.userAgent.match(/Firefox\/(\d*)/);e=null!=i&&i[1]<28}e?(void 0===this.conf.ffTest&&(this.editor.contentWindow.document.body.innerHTML="",this._runCommand("InsertHTML","test"),this.conf.ffTest=this.editor.contentWindow.document.body.innerHTML.length>0),this.conf.ffTest?this.editor.contentWindow.document.body.innerHTML=t:(this.editor.contentWindow.document.body.innerHTML="",0==t.length&&(t=" "),this._runCommand("InsertHTML",t))):this.editor.contentWindow.document.body.innerHTML=t,this.callEvent("onContentSet",[])}else this.conf.firstLoadEv||(this.conf.firstLoadEv=!0,this.conf.firstLoadData=t,this._onFirstLoad=function(){n.setContent(n.conf.firstLoadData),"function"==typeof window.addEventListener?n.edWin.removeEventListener("load",n._onFirstLoad,!1):n.edWin.detachEvent("onload",n._onFirstLoad),n.conf.firstLoadData=null,n.conf.firstLoadEv=!1,n._onFirstLoad=null},"function"==typeof window.addEventListener?this.edWin.addEventListener("load",this._onFirstLoad,!1):this.edWin.attachEvent("onload",this._onFirstLoad))},this.setContentHTML=function(t){window.dhx4.ajax.get(t,function(t){null!=t.xmlDoc.responseText&&n.setContent(t.xmlDoc.responseText)})},window.dhx4._eventable(this),this.attachEvent("onFocusChanged",function(t){"function"==typeof this._doOnFocusChanged?this._doOnFocusChanged(t):"string"==typeof this._doOnFocusChanged&&"function"==typeof window[this._doOnFocusChanged]&&window[this._doOnFocusChanged](t)}),"function"==typeof window.addEventListener?(window.addEventListener("resize",this._doOnResize,!1),this.edDoc.addEventListener("click",this._doOnClick,!1),this.edDoc.addEventListener("keyup",this._doOnKeyUp,!1),window.dhx4.isOpera&&this.edDoc.addEventListener("mousedown",this._doOnMouseDown,!1)):(window.attachEvent("onresize",this._doOnResize),this.edDoc.attachEvent("onclick",this._doOnClick),this.edDoc.attachEvent("onkeyup",this._doOnKeyUp)),this.unload=function(){if("function"==typeof window.addEventListener){window.removeEventListener("resize",this._doOnResize,!1),this.edDoc.removeEventListener("click",this._doOnClick,!1),this.edDoc.removeEventListener("keyup",this._doOnKeyUp,!1),window.dhx4.isOpera&&this.edDoc.removeEventListener("mousedown",this._doOnMouseDown,!1);for(var t=0;t<n.conf.evs.length;t++)a.contentWindow.removeEventListener(n.conf.evs[t],n._ev,!1);null!=this.tb&&1==this.conf.iOSfix&&(this.tb.cont.removeEventListener("touchend",this._doOnIOSFix,!1),this._doOnIOSFix=null)}else{window.detachEvent("onresize",this._doOnResize,!1),this.edDoc.detachEvent("onclick",this._doOnClick),this.edDoc.detachEvent("onkeyup",this._doOnKeyUp);for(t=0;t<n.conf.evs.length;t++)a.contentWindow.document.body.detachEvent("on"+n.conf.evs[t],n._ev)}for(this._doOnAccess=null,this._doOnFocusChanged=null,"function"==typeof window.addEventListener?this.editor.onload=null:this.editor.onreadystatechange=null,this.editor.parentNode.removeChild(this.editor),this.editor=null,this.edDoc=null,this.edWin=null,this.cell._unload(),this.cell=null,this.tb=null,window.dhx4._eventable(this,"clear"),this.cBlock.parentNode.removeChild(this.cBlock),this.cBlock=null,this.base.className=String(this.base.className).replace(new RegExp("\\s{0,}dhxeditor_"+this.conf.skin),"");this.base.childNodes.length>0;)this.base.removeChild(this.base.childNodes[0]);this.base=null,this._doOnClick=null,this._doOnKeyUp=null,this._doOnMouseDown=null,this._ev=null,this._focus=null,this._prepareContent=null,this._doOnResize=null,this.setIconsPath=null,this.init=null,this.setSizes=null,this._runCommand=null,this.applyBold=null,this.applyItalic=null,this.applyUnderscore=null,this.clearFormatting=null,this._showInfo=null,this._getSelectionBounds=null,this.getContent=null,this.setContent=null,this.setContentHTML=null,this.setReadonly=null,this.isReadonly=null,this.unload=null,n=a=null},1==this.conf.toolbar&&"function"==typeof this.attachToolbar&&"function"==typeof window.dhtmlXToolbarObject&&(this.attachToolbar(this.conf.iconsPath),1==this.conf.iOSfix&&(this._doOnIOSFix=function(){n.editor.contentWindow.focus()},this.tb.cont.addEventListener("touchend",this._doOnIOSFix,!1))),this.setIconsPath=function(t){this.conf.iconsPath=t},this.conf.content.length>0?(this.setContent(this.conf.content),this.conf.content=""):this.conf.contentHTML.length>0&&(this.setContentHTML(this.conf.contentHTML),this.conf.contentHTML=""),this}S.prototype.setSizes=function(){this.cell._setSize(0,0,this.base.clientWidth,this.base.clientHeight),null!=this.editor&&(this.editor.style.left="5px",this.editor.style.width=this.base.clientWidth-5+"px")},S.prototype.setReadonly=function(t){this.conf.roMode=!0===t,this._prepareContent(!0,this.conf.roMode),this.cBlock.style.display=this.conf.roMode?"":"none"},S.prototype.isReadonly=function(t){return this.conf.roMode||!1},S.prototype.setSkin=function(t){this.base.className=String(this.base.className).replace(new RegExp("dhxeditor_"+this.conf.skin),"dhxeditor_"+t),this.conf.skin=this.cell.conf.skin=t,this.tb&&(this.cell.detachToolbar(t),this.tb=null,this.attachToolbar()),this.setSizes()},S.prototype._fontConf=function(){if(""==this.conf.skin)var t={family:this.conf.font.family,size:this.conf.font.size,color:this.conf.font.color};else t={family:"Roboto, Arial, Helvetica",size:"14px",color:"#404040"};return window.dhx4.template("font-size: #size#; font-family: #family#; color: #color#;",t)},window.dhtmlXEditorCell=function(t,e){D.apply(this,[t,"_editor"]);return this.editor=e,this.conf.skin=this.editor.conf.skin,this.attachEvent("_onCellUnload",function(){this._stbUnload(),this.editor=null,null}),this._stbInit(),this},dhtmlXEditorCell.prototype=new D,dhtmlXEditorCell.prototype._stbInit=function(){var t=this,e=document.createElement("DIV");e.className="dhx_cell_stb"+(dhx4.isIE6||dhx4.isIE7||dhx4.isIE8?"":" dhx_cell_stb_shadow"),this.cell.insertBefore(e,this.cell.childNodes[this.conf.idx.cont]),e.onselectstart=function(t){return(t=t||event).cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1};var n={bold:"applyBold",italic:"applyItalic",underline:"applyUnderscore",clearformat:"clearFormatting"};for(var i in n){var a=document.createElement("A");a.href="javascript:void(0);",a.tabIndex=-1,e.appendChild(a),a.onmousedown=a.onclick=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1};var o=document.createElement("DIV");o.className="dhx_cell_stb_button btn_"+i,o._actv=i.charAt(0),o._cmd=n[i],a.appendChild(o),o.onclick=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},o.onmousedown=function(e){(e=e||event).preventDefault?e.preventDefault():e.returnValue=!1,t.editor[this._cmd](),t.editor.callEvent("onToolbarClick",[this._actv])},o=a=null}e=null,this._stbUnload=function(){var e=this.cell.childNodes[this.conf.idx.stb];for(e.onselectstart=null;e.childNodes.length>0;)e.lastChild.onmousedown=e.lastChild.onclick=null,e.lastChild.firstChild.onmousedown=e.lastChild.firstChild.onclick=null,e.lastChild.firstChild._actv=e.lastChild.firstChild._cmd=null,e.lastChild.removeChild(e.lastChild.firstChild),e.removeChild(e.lastChild);e.parentNode.removeChild(e),e=t=null,this.conf.idx_data.stb=this.conf.ofs_nodes.t._getStbHeight=null,delete this.conf.ofs_nodes.t._getStbHeight,delete this.conf.idx_data.stb,this._updateIdx()},this.conf.stb_visible=!0,this.conf.ofs_nodes.t._getStbHeight="func",this.conf.idx_data.stb="dhx_cell_stb",this._updateIdx()},dhtmlXEditorCell.prototype._stbHide=function(){this.cell.childNodes[this.conf.idx.stb].style.display="none",this.conf.stb_visible=!1},dhtmlXEditorCell.prototype._getStbHeight=function(){return 1==this.conf.stb_visible&&"material"==this.conf.skin?(null==this.conf.stb_height&&(this.conf.stb_height=window.dhx4.readFromCss("dhxeditor_material stb_height_detect","scrollHeight","<div class='dhx_cell_editor'><div class='dhx_cell_stb'></div></div>")),this.conf.stb_height):this.cell.childNodes[this.conf.idx.stb].offsetHeight},D.prototype.attachEditor=function(t){this.callEvent("_onBeforeContentAttach",["editor"]);var e=document.createElement("DIV");if(e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden",this._attachObject(e),"object"==typeof t&&null!=t||(t={}),t.parent=e,this.dataType="editor",this.dataObj=new S(t),e=null,t.parent=null,t=null,"function"==typeof window.dhtmlXPortalCell&&this instanceof window.dhtmlXPortalCell){if(null==this.portal.conf.editor_ev){var n=this.portal.attachEvent("onBeforeDrag",function(t){return"editor"==this.cdata[t].dataType&&(this.cdata[t].conf.editor_cont=this.cdata[t].dataObj.getContent()),!0}),i=this.portal.attachEvent("onDrop",function(t){"editor"==this.cdata[t].dataType&&(this.cdata[t].dataObj.setContent(this.cdata[t].conf.editor_cont),this.cdata[t].dataObj._prepareContent(!0),this.cdata[t].conf.editor_cont=null)});this.portal.conf.editor_ev=[n,i]}this.conf.editor_ev=this.attachEvent("_onBeforeContentDetach",function(){if(this.detachEvent(this.conf.editor_ev),this.conf.editor_ev=null,this instanceof window.dhtmlXPortalCell){var t=!1;for(var e in this.portal.cdata)this.portal.cdata[e]!=this&&"editor"==this.portal.cdata[e].dataType&&(t=!0);if(0==t){for(var n=0;n<this.portal.conf.editor_ev.length;n++)this.portal.detachEvent(this.portal.conf.editor_ev[n]);this.portal.conf.editor_ev=null}}})}return this.callEvent("_onContentAttach",[]),this.dataObj};var N=S,M={name:"pf-text-area",data:function(){return{pfEditor:null,maxlengthExceeded:!1}},mixins:[i],props:{id:{type:String,default:"textAreaId"},editor:{type:Boolean,default:!1},autofocus:{type:Boolean,default:!1},cols:{type:Number,default:4},dirname:{type:String},disabled:{type:Boolean,default:!1},form:{type:String},maxlength:{type:Number},name:{type:String,default:"textAreaName"},placeholder:{type:String},readonly:{type:Boolean,default:!1},required:{type:Boolean,default:!1},rows:{type:Number,default:4},wrap:{type:String,default:"hard"},label:{type:String},value:{type:String},type:{type:String},classLabel:{},fData:{type:Object},fontSize:{type:Number},labelStyle:{type:String}},mounted:function(){!0===this.editor&&(document.getElementById("editor").onload=this.loadArea())},methods:{loadArea:function(){this.pfEditor=new N({parent:"editor",toolbar:!0,iconsPath:"../../../dhx/codebase/imgs/",content:"<b>Lorem ipsum </b>dolor sit amet."})}}},O={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"form-group"},[n("label",{directives:[{name:"show",rawName:"v-show",value:void 0!==t.label,expression:"label !== undefined"}],staticClass:"labelInputs",class:t.classLabel,style:t.labelStyle,attrs:{for:""}},[t._v(t._s(t.label))]),t._v(" "),!1===t.editor?n("textarea",{staticClass:"form-control form-control-sm ",class:t.classElement,style:!0===t.isForm&&!0===t.maxlengthExceeded?t.styleElement+"border: 2px solid red !important;":!0===t.isForm?t.styleElement+"resize:none !important;":t.styleElement,attrs:{accesskey:t.accesskey,contenteditable:t.contenteditable,dir:t.dir,draggable:t.draggable,hidden:t.hidden,lang:t.lang,spellcheck:t.spellcheck,tabindex:!0!==t.readonly?t.tabindex:-1,title:t.title,autofocus:t.autofocus,name:t.name,id:t.id,rows:t.rows,cols:t.cols,dirname:t.dirname,disabled:t.disabled,form:t.form,maxlength:t.maxlength,placeholder:t.placeholder,readonly:t.readonly,required:t.required,wrap:t.wrap},domProps:{value:t.value},on:{input:function(e){return t.$emit("input",e.target.value)},change:function(e){return t.$emit("change")},contextmenu:function(e){return e.preventDefault(),t.$emit("context")},keyup:function(e){!0===t.isForm&&t.$emit("keyup")},keydown:function(e){if(!e.type.indexOf("key")&&t._k(e.keyCode,"tab",9,e.key,"Tab"))return null;!0===t.isForm&&t.$emit("keytab")},click:function(e){return t.$emit("click")}}}):n("div",{attrs:{id:"editor"}}),t._v(" "),!0===t.maxlengthExceeded?n("span",{staticStyle:{"font-size":"7pt",color:"red",right:"0","text-align":"initial",position:"absolute",width:"50px","background-color":"white","margin-top":"-16px","z-index":"9999",opacity:"0.8"}},[t._v("\n    Text Not Fit\n  ")]):t._e()])},staticRenderFns:[]};var T=n("VU/8")(M,O,!1,function(t){n("xLnA")},"data-v-3de625d5",null).exports,L={name:"pf-radio",data:function(){return{classLabelOwn:null}},mixins:[i],props:{align:{type:String},autofocus:{type:Boolean,default:!1},checked:{type:Boolean,default:!1},dirname:{type:String},disabled:{type:Boolean,default:!1},form:{type:String},formaction:{type:String},formenctype:{type:String},formmethod:{type:String},formnovalidate:{type:Boolean,default:!1},formtarget:{type:String},height:{type:Number},name:{type:String,default:"inputRadio"},readonly:{type:Boolean,default:!1},required:{type:Boolean,default:!1},size:{type:Number},value:{type:String},width:{type:Number},label:{type:String,default:""},classLabel:{},classComponent:{},customLabel:{type:Boolean,default:!1},customMessage:{type:String},classCustom:{},classUpdate:{},styleComponent:{type:String,default:""},styleLabel:{},logo:{type:String},uniAfter:{type:Number},model:{type:String},isEditShare:{type:Boolean},isClient:{type:Boolean}},watch:{isShareField:function(t){var e=document.getElementById("customcheck"+this.id);null!==e&&(-1!==e.style.outline.indexOf("blue")?e.style.outline="2px solid red":e.style.outline="2px solid blue")},styleElement:function(t){!0===this.isForm&&(!0===this.isEditShare?!0===this.isShareField?(this.classLabelOwn="pseudoStyleRadioShareColor"+Math.floor(this.width),this.$emit("set-pseudo-share:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleRadioNoShareColor"+Math.floor(this.width),this.$emit("set-pseudo-noshare:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):!0===this.isReverse&&""!==this.model&&-1===this.model.indexOf("#")&&-1===this.model.indexOf("+")&&-1===this.model.indexOf("(")&&-1===this.model.indexOf(")")&&-1===this.model.indexOf(",")&&-1===this.model.indexOf("attorney")?!0===this.readonly?(this.classLabelOwn="pseudoStyleRadioReverseColorSide"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleReverseRadioColor"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):""!==this.model||!0===this.isClient&&!1===this.readonly?!0===this.readonly?(this.classLabelOwn="pseudoStyleRadioColorSide"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleRadioColor"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):!0===this.readonly?(this.classLabelOwn="pseudoStyleRadioSide"+Math.floor(this.width),this.$emit("set-pseudo",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleRadio"+Math.floor(this.width),this.$emit("set-pseudo",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})))},classLabel:function(t){this.classLabelOwn=t}},mounted:function(){this.classLabelOwn=this.classLabel,this.assignPseudo(this.styleElement)},methods:{assignPseudo:function(t){!0===this.isForm&&(!0===this.isEditShare?!0===this.isShareField?(this.classLabelOwn="pseudoStyleRadioShareColor"+Math.floor(this.width),this.$emit("set-pseudo-share:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleRadioNoShareColor"+Math.floor(this.width),this.$emit("set-pseudo-noshare:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):!0===this.isReverse&&""!==this.model&&-1===this.model.indexOf("#")&&-1===this.model.indexOf("+")&&-1===this.model.indexOf("(")&&-1===this.model.indexOf(")")&&-1===this.model.indexOf(",")&&-1===this.model.indexOf("attorney")?!0===this.readonly?(this.classLabelOwn="pseudoStyleRadioReverseColorSide"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleReverseRadioColor"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):""!==this.model||!0===this.isClient&&!1===this.readonly?!0===this.readonly?(this.classLabelOwn="pseudoStyleRadioColorSide"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleRadioColor"+Math.floor(this.width),this.$emit("set-pseudo:color",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):!0===this.readonly?(this.classLabelOwn="pseudoStyleRadioSide"+Math.floor(this.width),this.$emit("set-pseudo",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})):(this.classLabelOwn="pseudoStyleRadio"+Math.floor(this.width),this.$emit("set-pseudo",{css:t,unidad:this.uniAfter,id:this.id,radio:!0,className:this.classLabelOwn})))}}},j={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"form-check form-check-inline myRad",class:t.classComponent,style:!0===t.isForm&&!0===t.isFocus?t.styleElement+"outline:2px solid red !important;":t.styleElement+"outline:none !important;",attrs:{id:!0===t.readonly?"origincustomradio"+t.id:"customradio"+t.id}},[n("input",{staticClass:"form-check-input checkbox-custom myInputRad",class:"updated-information"===t.classElement||"deleted-information"===t.classElement||"new-information"===t.classElement||"myInputUpdated"===t.classElement||"myInputRadUpdated"===t.classElement?"myInputRadUpdated":"",style:t.styleElement,attrs:{accesskey:t.accesskey,contenteditable:t.contenteditable,dir:t.dir,draggable:t.draggable,hidden:t.hidden,lang:t.lang,spellcheck:t.spellcheck,tabindex:!0!==t.readonly?t.tabindex:-1,title:t.title,type:"radio",align:t.align,autofocus:t.autofocus,dirname:t.dirname,disabled:t.disabled,form:t.form,formaction:t.formaction,formenctype:t.formenctype,formmethod:t.formmethod,formnovalidate:t.formnovalidate,formtarget:t.formtarget,height:t.height,readonly:t.readonly,required:t.required,size:t.size,width:t.width,name:t.name,id:t.id},domProps:{checked:t.checked,value:t.value},on:{change:function(e){return t.$emit("change")},click:function(e){return t.$emit("click")},contextmenu:function(e){return e.preventDefault(),t.$emit("context")}}}),t._v(" "),n("label",{staticClass:"form-check-label checkbox-custom-label myLabelRad myLabelRadUpdated",class:t.classLabelOwn,style:!0===t.readonly?"pointer-events: none !important;cursor: not-allowed;":"",attrs:{id:"label"+t.id,for:t.id},on:{contextmenu:function(e){return e.preventDefault(),t.$emit("context")}}},[t._v(t._s(t.label)+"\n  ")])])},staticRenderFns:[]};var P=n("VU/8")(L,j,!1,function(t){n("8Kpv")},"data-v-f51d4602",null).exports,F=n("fZjL"),Y=n.n(F),R={name:"pf-pop-up-remove",data:function(){return{isTwoConfirmation:!1,isAction:!1}},mixins:[i],props:{title:{type:String,default:"Pop Up Title"},message:{type:String,default:""},type:{type:String,default:"danger"},logo:{type:Boolean,default:!1},counter:{type:String},isform:{type:Boolean},blackMessage:{type:String},redMessage:{type:String},messageTwoConfirmation:{type:String}},components:{PfSpinner:r,PfCheckbox:x},created:function(){window.addEventListener("keypress",this.keyDown)},destroyed:function(){window.removeEventListener("keypress",this.keyDown)},mounted:function(){!0===this.isform?document.getElementById("contentPopUp").classList.add("fadeIn"):setTimeout(function(){document.getElementById("contentPopUp").classList.add("fadeIn")},500)},methods:{keyDown:function(t){"Enter"==t.key&&this.$emit("action")}}},H={render:function(){var t=this,e=t.$createElement,i=t._self._c||e;return i("transition",{attrs:{name:"modal"}},[i("div",{staticClass:"modal-mask"},[i("div",{staticClass:"modal-wrapper"},[i("div",{staticClass:"modal-container fadeOut",style:"autofill-official"===t.type||"delete-official"===t.type?"width:430px !important;":"",attrs:{id:"contentPopUp"}},[i("div",{staticClass:"row"},[i("div",{staticClass:"container"},[i("div",{staticClass:"col-12 login text-center"},[void 0!==t.counter&&""!==t.counter?i("h5",{staticStyle:{"font-weight":"normal"}},[t._v(t._s(t.counter)+"\n              ")]):t._e(),t._v(" "),i("h4",{staticClass:"textTitle"},[t._v("\n                "+t._s(t.title)+"  "),"info"!==t.type&&"loading"!==t.type?i("i",{staticClass:"fas fa-times-circle btn-close",style:void 0!==t.counter&&""!==t.counter?"top:-25px;":"",on:{click:function(e){return t.$emit("close")}}}):t._e()]),t._v(" "),!0===t.logo?i("img",{attrs:{src:n("1H3f"),width:"100px"}}):t._e(),t._v(" "),t.blackMessage&&""!==t.blackMessage?i("div",{staticClass:"marginTop"},[i("h6",{staticClass:"font-weight-bold"},[t._v(t._s(t.blackMessage))])]):t._e(),t._v(" "),t.redMessage&&""!==t.redMessage?i("div",{staticClass:"marginTop"},[i("h6",{staticClass:"font-weight-bold",staticStyle:{color:"red"}},[t._v(t._s(t.redMessage))])]):t._e(),t._v(" "),i("div",{staticClass:"marginTop"},[i("h6",{staticClass:"text-secondary"},[t._v(t._s(t.message))])]),t._v(" "),t.messageTwoConfirmation&&null!==t.messageTwoConfirmation?i("div",{staticClass:"row mb-4"},[i("pf-checkbox",{attrs:{id:"two-confirmation",label:t.messageTwoConfirmation,checked:t.isTwoConfirmation},on:{click:function(e){t.isTwoConfirmation=!t.isTwoConfirmation}}})],1):t._e(),t._v(" "),"danger"===t.type?i("div",{staticClass:"row"},[i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-secondary float-right",attrs:{disabled:t.isAction},on:{click:function(e){return t.$emit("close")}}},[t._v("Cancel")])]),t._v(" "),i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-danger float-left",attrs:{disabled:!(!t.messageTwoConfirmation||null===t.messageTwoConfirmation||t.isTwoConfirmation)||!!t.isAction},on:{click:function(e){t.$emit("action"),t.isAction=!0}}},[!0===t.isAction?i("span",[i("span",{staticClass:"spinner-border spinner-border-sm mr-1",attrs:{role:"status","aria-hidden":"true",disabled:t.isAction}}),t._v("\n                      Loading...\n                    ")]):i("span",[t._v("Delete")])])])]):t._e(),t._v(" "),"void"===t.type?i("div",{staticClass:"row"},[i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-secondary float-right",attrs:{disabled:t.isAction},on:{click:function(e){return t.$emit("close")}}},[t._v("\n                    Cancel\n                  ")])]),t._v(" "),i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-danger float-left",attrs:{disabled:t.isAction},on:{click:function(e){t.$emit("action"),t.isAction=!0}}},[!0===t.isAction?i("span",[i("span",{staticClass:"spinner-border spinner-border-sm mr-1",attrs:{role:"status","aria-hidden":"true"}}),t._v("\n                      Loading...\n                    ")]):i("span",[t._v("Void")])])])]):t._e(),t._v(" "),"info"===t.type?i("div",{staticClass:"row"},[i("div",{staticClass:"col-12 text-center"},[i("button",{staticClass:"btn btn-primary",on:{click:function(e){return t.$emit("action")}}},[t._v("Ok")])])]):t._e(),t._v(" "),"confirm"===t.type?i("div",{staticClass:"row"},[i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-secondary float-right",on:{click:function(e){return t.$emit("close")}}},[t._v("No")])]),t._v(" "),i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-success float-left",on:{click:function(e){return t.$emit("action")}}},[t._v("Yes")])])]):t._e(),t._v(" "),"loading"===t.type?i("div",{staticClass:"row"},[i("pf-spinner",{attrs:{color:"black"}})],1):t._e(),t._v(" "),"autofill-official"===t.type?i("div",{staticClass:"row"},[i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-danger float-left",on:{click:function(e){return t.$emit("action")}}},[t._v("Yes, Change it!")])]),t._v(" "),i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-secondary float-right",staticStyle:{width:"130px"},on:{click:function(e){return t.$emit("close")}}},[t._v("Cancel")])])]):t._e(),t._v(" "),"delete-official"===t.type?i("div",{staticClass:"row"},[i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-danger float-left",on:{click:function(e){return t.$emit("action")}}},[t._v("Yes, delete it!")])]),t._v(" "),i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-secondary float-right",staticStyle:{width:"130px"},on:{click:function(e){return t.$emit("close")}}},[t._v("Cancel")])])]):t._e()]),t._v(" "),i("div",{staticClass:"col-12 login"},["import-review"===t.type?i("div",[i("br"),t._v(" "),i("pf-checkbox",{attrs:{id:"reverse-data",label:"Import data into contact profile",customLabel:"(Reverse autofill)",styleCustomLabel:"color:purple;"},on:{change:function(e){return t.$emit("reverse:data")}}}),t._v(" "),i("br"),t._v(" "),i("hr"),t._v(" "),i("div",{staticClass:"row"},[i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-danger float-right",on:{click:function(e){return t.$emit("action")}}},[t._v("Confirm")])]),t._v(" "),i("div",{staticClass:"col-6"},[i("button",{staticClass:"btn btn-secondary",on:{click:function(e){return t.$emit("close")}}},[t._v("Cancel")])])])],1):t._e()])])])])])])])},staticRenderFns:[]};var $=n("VU/8")(R,H,!1,function(t){n("WMVW"),n("3Ht3")},"data-v-3f772e7a",null).exports,z=n("Xxa5"),X=n.n(z),V=n("exGp"),q=n.n(V),W=n("mvHQ"),U=n.n(W);var G=function(t,e){var n=document.createEvent("HTMLEvents");n.initEvent(e,!0,!0),t.dispatchEvent(n)},Z=function(t){return t instanceof HTMLInputElement?t:t.querySelector("input")||t},J="undefined"!=typeof window&&window.navigator.userAgent.toLowerCase(),Q=J&&J.indexOf("edge/")>0,K=J&&J.indexOf("android")>0,tt=J&&/chrome\/\d+/.test(J)&&!Q;function et(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=t.value,i=t.dataset,a=i.previousValue,o=void 0===a?"":a,r=i.mask;(e||n&&n!==o&&n.length>o.length)&&(t.value=function(t,e){if(!e)return t;var n=/^([^#ANX]+)/;1==+t.length&&n.test(e)&&(t=n.exec(e)[0]+t);for(var i="",a=0,o=0;o<e.length;o+=1){var r=e.charAt(o);switch(r){case"#":case"A":case"?":case"N":case"X":break;default:t=t.replace(r,"")}}for(var s=0,l=1;l&&s<e.length;s+=1){var d=t.charAt(s-a),c=e.charAt(s);switch(c){case"#":/\d/.test(d)?i+=d:l=0;break;case"A":/[a-z]/i.test(d)?i+=d:l=0;break;case"N":/[a-z0-9]/i.test(d)?i+=d:l=0;break;case"?":a+=1;break;case"X":i+=d;break;default:i+=c,d&&d!==c&&(t=" ".concat(t))}}return i}(n,r),K&&tt?setTimeout(function(){return G(t,"input")},0):G(t,"input")),t.dataset.previousValue=n}function nt(t,e){t.dataset.mask=e}var it={bind:function(t,e){var n=e.value;nt(t=Z(t),n),et(t)},componentUpdated:function(t,e){var n=e.value,i=e.oldValue;t=Z(t);var a=n!==i;a&&nt(t,n),et(t,a)}};function at(t,e){this.i={};var n=null;if("string"==typeof t)var i=document.getElementById(t);else i=t;i&&"object"==typeof i&&i.tagName&&"input"!=String(i.tagName).toLowerCase()&&(n=i),i=null,"object"==typeof t&&t.length||(t=[t]);for(var a=0;a<t.length;a++)"string"==typeof t[a]&&(t[a]=document.getElementById(t[a])||null),null!=t[a]&&t[a].tagName&&"input"==String(t[a].tagName).toLowerCase()?this.i[window.dhx4.newId()]={input:t[a]}:t[a]instanceof Array||!(t[a]instanceof Object)||null==t[a].input&&null==t[a].button||(null!=t[a].input&&"string"==typeof t[a].input&&(t[a].input=document.getElementById(t[a].input)),null!=t[a].button&&"string"==typeof t[a].button&&(t[a].button=document.getElementById(t[a].button)),this.i[window.dhx4.newId()]=t[a]),t[a]=null;this.conf={skin:e||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhtmlxcalendar")||"material",zi:window.dhx4.newId(),touch:!window.dhx4.isIE,time:!0,today:!1,ws_first:!0},this.setSkin=function(t,e){(this.conf.skin!=t||e)&&(this.conf.skin=t,this.base.className="dhtmlxcalendar_"+this.conf.skin,this._ifrSize())},this.base=document.createElement("DIV"),this.base.style.display="none",this.base.appendChild(document.createElement("DIV")),null!=n?(this._hasParent=!0,n.appendChild(this.base),n=null):document.body.appendChild(this.base),this.setParent=function(t){this._hasParent&&("object"==typeof t?t.appendChild(this.base):"string"==typeof t&&document.getElementById(t).appendChild(this.base))},this.setSkin(this.conf.skin,!0),this.base.onclick=function(t){(t=t||event).preventDefault&&t.preventDefault(),t.cancelBubble=!0},this.base.onmousedown=function(){return!1},this.conf.touch&&(this.base.ontouchstart=this.base.onclick),this.loadUserLanguage=function(t){if(this.langData[t]){if(this.lang=t,this.setWeekStartDay(this.langData[this.lang].weekstart),this.setDateFormat(this.langData[this.lang].dateformat||"%Y-%m-%d"),this.msCont)for(var e=0,n=0;n<this.msCont.childNodes.length;n++)for(var i=0;i<this.msCont.childNodes[n].childNodes.length;i++)this.msCont.childNodes[n].childNodes[i].innerHTML=this.langData[this.lang].monthesSNames[e++];this.contTime.childNodes[0].childNodes[0].childNodes[5].innerHTML=this.langData[this.lang].today,this.contTime.childNodes[0].childNodes[0].childNodes[4].innerHTML=this.langData[this.lang].clear}},this.contMonth=document.createElement("DIV"),this.contMonth.className="dhtmlxcalendar_month_cont",this.contMonth.onselectstart=function(t){return(t=t||event).cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1},this.base.firstChild.appendChild(this.contMonth),(r=document.createElement("UL")).className="dhtmlxcalendar_line",this.contMonth.appendChild(r),(l=document.createElement("LI")).className="dhtmlxcalendar_cell dhtmlxcalendar_month_hdr",l.innerHTML="<div class='dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left' onmouseover='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left_hover\";' onmouseout='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left\";'></div><span></span><div class='dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right' onmouseover='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right_hover\";' onmouseout='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right\";'></div>",r.appendChild(l);var o=this;l.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;if(e.className&&0===e.className.indexOf("dhtmlxcalendar_month_arrow")){o._hideSelector();var n=e.parentNode.firstChild==e?-1:1,i=new Date(o._activeMonth);return o._drawMonth(new Date(o._activeMonth.getFullYear(),o._activeMonth.getMonth()+n,1,0,0,0,0)),void o._evOnArrowClick([i,new Date(o._activeMonth)])}return e.className&&"dhtmlxcalendar_month_label_month"==e.className?(t.cancelBubble=!0,void o._showSelector("month",Math.round(e.offsetLeft+e.offsetWidth/2),e.offsetTop+e.offsetHeight+2,"selector_month",!0)):e.className&&"dhtmlxcalendar_month_label_year"==e.className?(t.cancelBubble=!0,void o._showSelector("year",Math.round(e.offsetLeft+e.offsetWidth/2),e.offsetTop+e.offsetHeight+2,"selector_year",!0)):void o._hideSelector()},1==this.conf.touch&&(l.ontouchstart=l.onclick),this.contDays=document.createElement("DIV"),this.contDays.className="dhtmlxcalendar_days_cont",this.base.firstChild.appendChild(this.contDays),this.setWeekStartDay=function(t){0==t&&(t=7),this._wStart=Math.min(Math.max(isNaN(t)?1:t,1),7),this._drawDaysOfWeek()},this._drawDaysOfWeek=function(){if(0==this.contDays.childNodes.length)(t=document.createElement("UL")).className="dhtmlxcalendar_line",this.contDays.appendChild(t);else var t=this.contDays.firstChild;var e=this._wStart,n=this.langData[this.lang].daysSNames;n.push(String(this.langData[this.lang].daysSNames[0]).valueOf());for(var i=0;i<8;i++){if(null==t.childNodes[i]){var a=document.createElement("LI");t.appendChild(a)}else a=t.childNodes[i];0==i?(a.className="dhtmlxcalendar_cell_wn",a.innerHTML="<div class='dhtmlxcalendar_label'>"+(this.langData[this.lang].weekname||"w")+"</div>"):(a.className="dhtmlxcalendar_cell"+(e>=6?" dhtmlxcalendar_day_weekday_cell":"")+(1==i?"_first":""),a.innerHTML=n[e],++e>7&&(e=1))}null!=this._activeMonth&&this._drawMonth(this._activeMonth)},this._wStart=this.langData[this.lang].weekstart,this.setWeekStartDay(this._wStart),this.contDates=document.createElement("DIV"),this.contDates.className="dhtmlxcalendar_dates_cont",this.base.firstChild.appendChild(this.contDates),this.contDates.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;if(null!=e.parentNode&&null!=e.parentNode._date&&(e=e.parentNode),null!=e._date&&!e._css_dis){var n=o._activeDate.getHours(),i=o._activeDate.getMinutes(),a=e._date;if(o.checkEvent("onBeforeChange")&&!o.callEvent("onBeforeChange",[new Date(e._date.getFullYear(),e._date.getMonth(),e._date.getDate(),n,i)]))return;null!=o._activeDateCell&&(o._activeDateCell._css_date=!1,o._updateCellStyle(o._activeDateCell._q,o._activeDateCell._w));var r=o._activeDate.getFullYear()+"_"+o._activeDate.getMonth()!=a.getFullYear()+"_"+a.getMonth();o._nullDate=!1,o._activeDate=new Date(a.getFullYear(),a.getMonth(),a.getDate(),n,i),o._activeDateCell=e,o._activeDateCell._css_date=!0,o._activeDateCell._css_hover=!1,o._updateCellStyle(o._activeDateCell._q,o._activeDateCell._w),r&&o._drawMonth(o._activeDate),o._updateInp(),o._hasParent||("touchstart"==t.type?window.setTimeout(function(){o._hide()},400):o._hide()),o._evOnClick([new Date(o._activeDate.getTime())]),o._doOnSelectorChange(!0)}},1==this.conf.touch&&(this.contDates.ontouchstart=this.contDates.onclick),this.contDates.onmouseover=function(t){var e=(t=t||event).target||t.srcElement;if(null!=e.parentNode&&null!=e.parentNode._date&&(e=e.parentNode),null!=e._date){if(o._lastHover==e||e._css_hover)return;e._css_hover=!0,o._updateCellStyle(e._q,e._w),o._lastHover=e,o._evOnMouseOver([new Date(e._date.getFullYear(),e._date.getMonth(),e._date.getDate(),0,0,0,0),t]),e=null}},this.contDates.onmouseout=function(t){o._clearDayHover(t||event)},this._lastHover=null,this._clearDayHover=function(t){this._lastHover&&(this._lastHover._css_hover=!1,this._updateCellStyle(this._lastHover._q,this._lastHover._w),null!=t&&o._evOnMouseOut([new Date(this._lastHover._date.getFullYear(),this._lastHover._date.getMonth(),this._lastHover._date.getDate(),0,0,0,0),t]),this._lastHover=null)};for(a=0;a<6;a++){var r;(r=document.createElement("UL")).className="dhtmlxcalendar_line",this.contDates.appendChild(r);for(var s=0;s<=7;s++){(l=document.createElement("LI")).className=0==s?"dhtmlxcalendar_cell_wn":"dhtmlxcalendar_cell",r.appendChild(l)}}this.contTime=document.createElement("DIV"),this.contTime.className="dhtmlxcalendar_time_cont",this.contTime.style.display="none",this.base.firstChild.appendChild(this.contTime),this.showTime=function(){1!=this.conf.time&&(this.conf.time=!0,this._adjustTimeCont())},this.hideTime=function(){1==this.conf.time&&(this.conf.time=!1,this._adjustTimeCont())},this.showToday=function(){1!=this.conf.today&&(this.conf.today=!0,this._adjustTimeCont())},this.hideToday=function(){1==this.conf.today&&(this.conf.today=!1,this._adjustTimeCont())},this._adjustTimeCont=function(){var t="";1==this.conf.time&&(t+="_time"),1==this.conf.today&&(t+="_today"),""==t?this.contTime.style.display="none":(this.contTime.className="dhtmlxcalendar_time_cont dhtmlxcalendar_mode"+t,this.contTime.style.display=""),this._ifrSize()},this._adjustTimeCont(),(r=document.createElement("UL")).className="dhtmlxcalendar_line",this.contTime.appendChild(r);var l=document.createElement("LI");for(var d in l.className="dhtmlxcalendar_cell dhtmlxcalendar_time_hdr",l.innerHTML="<div class='dhtmlxcalendar_time_img'></div><span class='dhtmlxcalendar_label_hours'></span><span class='dhtmlxcalendar_label_colon'>:</span><span class='dhtmlxcalendar_label_minutes'></span><span class='dhtmlxcalendar_label_clear'>"+this.langData[this.lang].clear+"</span><span class='dhtmlxcalendar_label_today'>"+this.langData[this.lang].today+"</span>",r.appendChild(l),l.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;if(null!=e.tagName&&"span"==e.tagName.toLowerCase()&&1==e._par&&null!=e.parentNode&&(e=e.parentNode),e.className&&"dhtmlxcalendar_label_hours"==e.className){t.cancelBubble=!0;var n=o.contMonth.offsetHeight+o.contDays.offsetHeight+o.contDates.offsetHeight+e.offsetTop;o._showSelector("hours",Math.round(e.offsetLeft+e.offsetWidth/2),n-2,"selector_hours",!0)}else if(e.className&&"dhtmlxcalendar_label_minutes"==e.className){if(t.cancelBubble=!0,1==o._minutesInterval){var i=o.getFormatedDate("%i");e.innerHTML="<span class='dhtmlxcalendar_selected_date'>"+i.charAt(0)+"</span>"+i.charAt(1),e.firstChild._par=!0,o._selectorMode=1}n=o.contMonth.offsetHeight+o.contDays.offsetHeight+o.contDates.offsetHeight+e.offsetTop;o._showSelector("minutes",Math.round(e.offsetLeft+e.offsetWidth/2),n-2,"selector_minutes",!0)}else{if(o._hideSelector(),e.className&&"dhtmlxcalendar_label_today"==e.className){i=new Date;i=new Date(i.getFullYear(),i.getMonth(),i.getDate(),o._activeDate.getHours(),o._activeDate.getMinutes(),o._activeDate.getSeconds(),o._activeDate.getMilliseconds()),o.setDate(i),o._updateInp(),o.callEvent("onButtonClick",[i])}e.className&&"dhtmlxcalendar_label_clear"==e.className&&(o._nullDate=!0,o._drawMonth(new Date),o._updateInp(),o.callEvent("onButtonClick",[null]))}},1==this.conf.touch&&(l.ontouchstart=l.onclick),this._activeMonth=null,this._activeDate=new Date,this._activeDateCell=null,this.setDate=function(t){window.dhx4.temp_calendar={tz:null},this._nullDate=void 0===t||""===t||!t,t instanceof Date||("Invalid Date"==(t=this._strToDate(String(t||"")))?t=new Date:this.conf.tz=window.dhx4.temp_calendar.tz,window.dhx4.temp_calendar=null),null==this.conf.tz&&(this.conf.tz=window.dhx4.date2str(t,"%P"));var e=t.getTime();this._isOutOfRange(e)||(this._activeDate=new Date(e),this._drawMonth(this._nullDate?new Date:this._activeDate),this._updateVisibleHours(),this._updateVisibleMinutes())},this.getDate=function(t){if(this._nullDate)return null;var e=new Date(this._activeDate.getTime());if(t){window.dhx4.temp_calendar={tz:this.conf.tz};var n=this._dateToStr(e);return window.dhx4.temp_calendar=null,n}return e},this._drawMonth=function(t){if(t instanceof Date){isNaN(t.getFullYear())&&(t=new Date(this._activeMonth.getFullYear(),this._activeMonth.getMonth(),1,0,0,0,0)),this._activeMonth=new Date(t.getFullYear(),t.getMonth(),1,0,0,0,0),this._activeDateCell=null;var e=new Date(this._activeMonth.getTime()),n=e.getDay()-this._wStart;n<0&&(n+=7),e.setDate(e.getDate()-n);for(var i=t.getMonth(),a=new Date(this._activeDate.getFullYear(),this._activeDate.getMonth(),this._activeDate.getDate(),0,0,0,0).getTime(),o=0,r=0;r<6;r++)for(var s=this._wStart,l=0;l<=7;l++)if(0==l){var d=this.getWeekNumber(new Date(e.getFullYear(),e.getMonth(),e.getDate()+o,0,0,0,0));if(d>=52&&1==this.conf.ws_first&&0==this._activeMonth.getMonth())(c=this.getWeekNumber(new Date(e.getFullYear(),e.getMonth(),e.getDate()+o+7,0,0,0,0)))<d&&c>1&&(d=1);else if(d>52&&11==this._activeMonth.getMonth()){var c;1==(c=this.getWeekNumber(new Date(e.getFullYear()+1,0,1)))&&(d=1)}this.contDates.childNodes[r].childNodes[l].innerHTML="<div class='dhtmlxcalendar_label'>"+d+"</div>"}else{var h=new Date(e.getFullYear(),e.getMonth(),e.getDate()+o,0,0,0,0);if(0!=h.getHours()){var u=h.getHours()>12?24-h.getHours():h.getHours();h.setTime(h.getTime()+36e5*u)}h.getDay();var m=h.getTime(),f="dhtmlxcalendar_label";null!=this._tipData[m]?(this._tipData[m].usePopup&&"function"==typeof window.dhtmlXPopup?(this.contDates.childNodes[r].childNodes[l].removeAttribute("title"),this._initTooltipPopup()):this.contDates.childNodes[r].childNodes[l].setAttribute("title",this._tipData[m].text),this._tipData[m].showIcon&&(f+=" dhtmlxcalendar_label_title")):this.contDates.childNodes[r].childNodes[l].removeAttribute("title"),this.contDates.childNodes[r].childNodes[l].innerHTML="<div class='"+f+"'>"+h.getDate()+"</div>",this.contDates.childNodes[r].childNodes[l]._date=new Date(m),this.contDates.childNodes[r].childNodes[l]._q=r,this.contDates.childNodes[r].childNodes[l]._w=l,this.contDates.childNodes[r].childNodes[l]._css_month=h.getMonth()==i,this.contDates.childNodes[r].childNodes[l]._css_date=!this._nullDate&&m==a,this.contDates.childNodes[r].childNodes[l]._css_weekend=s>=6,this.contDates.childNodes[r].childNodes[l]._css_dis=this._isOutOfRange(m),this.contDates.childNodes[r].childNodes[l]._css_holiday=1==this._holidays[m],this._updateCellStyle(r,l),m==a&&(this._activeDateCell=this.contDates.childNodes[r].childNodes[l]),++s>7&&(s=1),o++}this.contMonth.firstChild.firstChild.childNodes[1].innerHTML=this._buildMonthHdr(t)}},this._updateCellStyle=function(t,e){var n=this.contDates.childNodes[t].childNodes[e],i="dhtmlxcalendar_cell dhtmlxcalendar_cell";i+=n._css_month?"_month":"",i+=n._css_date?"_date":"",i+=n._css_weekend?"_weekend":"",i+=n._css_holiday?"_holiday":"",i+=n._css_dis?"_dis":"",i+=n._css_hover&&!n._css_dis?"_hover":"",n.className=i,n=null},this._minutesInterval=5,this._initSelector=function(t,e){if(this._selCover||(this._selCover=document.createElement("DIV"),this._selCover.className="dhtmlxcalendar_selector_cover",this.base.firstChild.appendChild(this._selCover)),this._sel||(this._sel=document.createElement("DIV"),this._sel.className="dhtmlxcalendar_selector_obj",this.base.firstChild.appendChild(this._sel),this._sel.appendChild(document.createElement("TABLE")),this._sel.firstChild.className="dhtmlxcalendar_selector_table",this._sel.firstChild.cellSpacing=0,this._sel.firstChild.cellPadding=0,this._sel.firstChild.border=0,this._sel.firstChild.appendChild(document.createElement("TBODY")),this._sel.firstChild.firstChild.appendChild(document.createElement("TR")),this._sel.firstChild.firstChild.firstChild.appendChild(document.createElement("TD")),this._sel.firstChild.firstChild.firstChild.appendChild(document.createElement("TD")),this._sel.firstChild.firstChild.firstChild.appendChild(document.createElement("TD")),this._sel.firstChild.firstChild.firstChild.childNodes[0].className="dhtmlxcalendar_selector_cell_left",this._sel.firstChild.firstChild.firstChild.childNodes[1].className="dhtmlxcalendar_selector_cell_middle",this._sel.firstChild.firstChild.firstChild.childNodes[2].className="dhtmlxcalendar_selector_cell_right",this._sel.firstChild.firstChild.firstChild.childNodes[0].innerHTML="&nbsp;",this._sel.firstChild.firstChild.firstChild.childNodes[2].innerHTML="&nbsp;",this._sel.firstChild.firstChild.firstChild.childNodes[0].onmouseover=function(){this.className="dhtmlxcalendar_selector_cell_left dhtmlxcalendar_selector_cell_left_hover"},this._sel.firstChild.firstChild.firstChild.childNodes[0].onmouseout=function(){this.className="dhtmlxcalendar_selector_cell_left"},this._sel.firstChild.firstChild.firstChild.childNodes[2].onmouseover=function(){this.className="dhtmlxcalendar_selector_cell_right dhtmlxcalendar_selector_cell_right_hover"},this._sel.firstChild.firstChild.firstChild.childNodes[2].onmouseout=function(){this.className="dhtmlxcalendar_selector_cell_right"},this._sel.onmouseover=function(t){var e=(t=t||event).target||t.srcElement;!0===e._cell&&(o._selHover!=e&&o._clearSelHover(),null!=String(e.className).match(/^\s{0,}dhtmlxcalendar_selector_cell\s{0,}$/gi)&&(e.className+=" dhtmlxcalendar_selector_cell_hover",o._selHover=e))},this._sel.onmouseout=function(){o._clearSelHover()},this._sel.firstChild.firstChild.firstChild.childNodes[0].onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0,o._scrollYears(-1)},this._sel.firstChild.firstChild.firstChild.childNodes[2].onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0,o._scrollYears(1)},1==this.conf.touch&&(this._sel.firstChild.firstChild.firstChild.childNodes[0].ontouchstart=this._sel.firstChild.firstChild.firstChild.childNodes[0].onclick,this._sel.firstChild.firstChild.firstChild.childNodes[2].ontouchstart=this._sel.firstChild.firstChild.firstChild.childNodes[2].onclick),this._sel._ta={},this._selHover=null,this._sel.appendChild(document.createElement("DIV")),this._sel.lastChild.className="dhtmlxcalendar_selector_obj_arrow"),1!=this._sel._ta[t]){if("month"==t){this._msCells={},this.msCont=document.createElement("DIV"),this.msCont.className="dhtmlxcalendar_area_"+e,this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.msCont);for(var n=0,i=0;i<4;i++){(d=document.createElement("UL")).className="dhtmlxcalendar_selector_line",this.msCont.appendChild(d);for(var a=0;a<3;a++){(c=document.createElement("LI")).innerHTML=this.langData[this.lang].monthesSNames[n],c.className="dhtmlxcalendar_selector_cell",d.appendChild(c),c._month=n,c._cell=!0,this._msCells[n++]=c}}this.msCont.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0;var e=t.target||t.srcElement;null!=e._month&&(o._hideSelector(),o._updateActiveMonth(),o._drawMonth(new Date(o._activeMonth.getFullYear(),e._month,1,0,0,0,0)),o._doOnSelectorChange())},1==this.conf.touch&&(this.msCont.ontouchstart=this.msCont.onclick)}if("year"==t){this._ysCells={},this.ysCont=document.createElement("DIV"),this.ysCont.className="dhtmlxcalendar_area_"+e,this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.ysCont);for(i=0;i<4;i++){(d=document.createElement("UL")).className="dhtmlxcalendar_selector_line",this.ysCont.appendChild(d);for(a=0;a<3;a++){(c=document.createElement("LI")).className="dhtmlxcalendar_selector_cell",c._cell=!0,d.appendChild(c)}}this.ysCont.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0;var e=t.target||t.srcElement;null!=e._year&&(o._hideSelector(),o._drawMonth(new Date(e._year,o._activeMonth.getMonth(),1,0,0,0,0)),o._doOnSelectorChange())},1==this.conf.touch&&(this.ysCont.ontouchstart=this.ysCont.onclick)}if("hours"==t){this._hsCells={},this.hsCont=document.createElement("DIV"),this.hsCont.className="dhtmlxcalendar_area_"+e,this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.hsCont);for(n=0,i=0;i<4;i++){(d=document.createElement("UL")).className="dhtmlxcalendar_selector_line",this.hsCont.appendChild(d);for(a=0;a<6;a++){(c=document.createElement("LI")).innerHTML=this._fixLength(n,2),c.className="dhtmlxcalendar_selector_cell",d.appendChild(c),c._hours=n,c._cell=!0,this._hsCells[n++]=c}}this.hsCont.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0;var e=t.target||t.srcElement;null!=e._hours&&(o._hideSelector(),o._activeDate.setHours(e._hours),o._updateActiveHours(),o._updateVisibleHours(),o._doOnSelectorChange(),o.callEvent("onTimeChange",[new Date(o._activeDate.getTime())]))},1==this.conf.touch&&(this.hsCont.ontouchstart=this.hsCont.onclick)}if("minutes"==t){var r=4,s=3,l=2;1==this._minutesInterval&&(1==this._selectorMode?(r=2,s=3,l=1):(r=2,s=5,l=1,e+="5")),10==this._minutesInterval&&(r=2),15==this._minutesInterval&&(r=1,s=4,e+="4"),this._rsCells={},this.rsCont=document.createElement("DIV"),this.rsCont.className="dhtmlxcalendar_area_"+e,this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.rsCont);for(n=0,i=0;i<r;i++){var d;(d=document.createElement("UL")).className="dhtmlxcalendar_selector_line",this.rsCont.appendChild(d);for(a=0;a<s;a++){var c;(c=document.createElement("LI")).innerHTML=l>1?this._fixLength(n,l):n,c.className="dhtmlxcalendar_selector_cell",d.appendChild(c),c._minutes=n,c._cell=!0,this._rsCells[n]=c,n+=this._minutesInterval}}this.rsCont.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0;var e=t.target||t.srcElement;if(null!=e._minutes){if(1==o._minutesInterval){var n=o.getFormatedDate("%i");if(n=1==o._selectorMode?e._minutes.toString()+n.charAt(1):n.charAt(0)+e._minutes.toString(),o._activeDate.setMinutes(Number(n)),o.callEvent("onTimeChange",[new Date(o._activeDate.getTime())]),o._hideSelector(),1==o._selectorMode)return o._updateVisibleMinutes(!0),o._selectorMode=2,o._showSelector("minutes",o._sel._x,o._sel._y,"selector_minutes",!0),void o._updateActiveMinutes();o._selectorMode=1}else o._hideSelector(),o._activeDate.setMinutes(e._minutes),o._updateActiveMinutes(),o.callEvent("onTimeChange",[new Date(o._activeDate.getTime())]);o._updateVisibleMinutes(),o._doOnSelectorChange()}},1==this.conf.touch&&(this.rsCont.ontouchstart=this.rsCont.onclick)}this._sel._ta[t]=!0}},this._showSelector=function(t,e,n,i,a){if(!0===a&&null!=this._sel&&this._isSelectorVisible()&&t==this._sel._t)this._hideSelector();else{"dhx_terrace"==this.conf.skin&&(e+=12),this._sel&&this._sel._ta[t]||this._initSelector(t,i),t!=this._sel._t&&"minutes"==this._sel._t&&1==this._minutesInterval&&(this.contTime.firstChild.firstChild.childNodes[3].innerHTML=this.getFormatedDate("%i")),this._sel._x=e,this._sel._y=n,this._sel.style.visibility="hidden",this._sel.style.display="",this._selCover.style.width=this.base.offsetWidth-2+"px",this._selCover.style.top=this.contMonth.offsetHeight+"px",this._selCover.style.height=this.contDates.offsetHeight+this.contDays.offsetHeight-1+"px",this._selCover.style.display="",this._sel._t=t,this._sel.className="dhtmlxcalendar_selector_obj dhtmlxcalendar_"+i+("hours"==t&&1==this.conf.today?"2":""),this._sel.childNodes[0].firstChild.firstChild.childNodes[0].style.display=this._sel.childNodes[0].firstChild.firstChild.childNodes[2].style.display="year"==t?"":"none";var o=Math.max(0,e-Math.round(this._sel.offsetWidth/2));o+this._sel.offsetWidth>this._sel.parentNode.offsetWidth&&(o=this._sel.parentNode.offsetWidth-this._sel.offsetWidth),this._sel.style.left=o+"px",this._sel.style.top="hours"==t||"minutes"==t?n-this._sel.offsetHeight+"px":n+"px",this._sel.childNodes[1].style.width=this._sel.childNodes[0].offsetWidth+"px",this._sel.style.visibility="visible",this._doOnSelectorShow(t)}},this._doOnSelectorShow=function(t){"month"==t&&this._updateActiveMonth(),"year"==t&&this._updateYearsList(this._activeMonth),"hours"==t&&this._updateActiveHours(),"minutes"==t&&this._updateActiveMinutes()},this._hideSelector=function(t){this._sel&&(this._sel.style.display="none",this._sel.style.visible="hidden",this._selCover.style.display="none","minutes"==this._sel._t&&1==this._minutesInterval&&(this.contTime.firstChild.firstChild.childNodes[3].innerHTML=this.getFormatedDate("%i"),this._unloadSelector("minutes")))},this._isSelectorVisible=function(){return!!this._sel&&"none"!=this._sel.style.display},this._doOnSelectorChange=function(t){this.callEvent("onChange",[new Date(this._activeMonth.getFullYear(),this._activeMonth.getMonth(),this._activeDate.getDate(),this._activeDate.getHours(),this._activeDate.getMinutes(),this._activeDate.getSeconds()),!0===t])},this._clearSelHover=function(){this._selHover&&(this._selHover.className=String(this._selHover.className.replace(/dhtmlxcalendar_selector_cell_hover/gi,"")),this._selHover=null)},this._unloadSelector=function(t){if(this._sel&&this._sel._ta[t]){if("month"==t){for(var e in this.msCont.onclick=this.msCont.ontouchstart=null,this._msActive=null,this._msCells)this._msCells[e]._cell=null,this._msCells[e]._month=null,this._msCells[e].parentNode.removeChild(this._msCells[e]),this._msCells[e]=null;for(this._msCells=null;this.msCont.childNodes.length>0;)this.msCont.removeChild(this.msCont.lastChild);this.msCont.parentNode.removeChild(this.msCont),this.msCont=null}if("year"==t){for(var e in this.ysCont.onclick=this.ysCont.ontouchstart=null,this._ysCells)this._ysCells[e]._cell=null,this._ysCells[e]._year=null,this._ysCells[e].parentNode.removeChild(this._ysCells[e]),this._ysCells[e]=null;for(this._ysCells=null;this.ysCont.childNodes.length>0;)this.ysCont.removeChild(this.ysCont.lastChild);this.ysCont.parentNode.removeChild(this.ysCont),this.ysCont=null}if("hours"==t){for(var e in this.hsCont.onclick=this.hsCont.ontouchstart=null,this._hsActive=null,this._hsCells)this._hsCells[e]._cell=null,this._hsCells[e]._hours=null,this._hsCells[e].parentNode.removeChild(this._hsCells[e]),this._hsCells[e]=null;for(this._hsCells=null;this.hsCont.childNodes.length>0;)this.hsCont.removeChild(this.hsCont.lastChild);this.hsCont.parentNode.removeChild(this.hsCont),this.hsCont=null}if("minutes"==t){for(var e in this.rsCont.onclick=this.rsCont.ontouchstart=null,this._rsActive=null,this._rsCells)this._rsCells[e]._cell=null,this._rsCells[e]._minutes=null,this._rsCells[e].parentNode.removeChild(this._rsCells[e]),this._rsCells[e]=null;for(this._rsCells=null;this.rsCont.childNodes.length>0;)this.rsCont.removeChild(this.rsCont.lastChild);this.rsCont.parentNode.removeChild(this.rsCont),this.rsCont=null}this._sel._ta[t]=null}},this.setMinutesInterval=function(t){1!=t&&5!=t&&10!=t&&15!=t||(this._minutesInterval=t,this._unloadSelector("minutes"))},this._updateActiveMonth=function(){void 0!==this._msActive&&void 0!==this._msCells[this._msActive]&&(this._msCells[this._msActive].className="dhtmlxcalendar_selector_cell"),this._msActive=this._activeMonth.getMonth(),this._msCells[this._msActive].className="dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active"},this._updateActiveYear=function(){var t=this._activeMonth.getFullYear();this._ysCells[t]&&(this._ysCells[t].className="dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active")},this._updateYearsList=function(t){for(var e in this._ysCells)this._ysCells[e]=null,delete this._ysCells[e];for(var n=12*Math.floor(t.getFullYear()/12),i=0;i<4;i++)for(var a=0;a<3;a++)this.ysCont.childNodes[i].childNodes[a].innerHTML=n,this.ysCont.childNodes[i].childNodes[a]._year=n,this.ysCont.childNodes[i].childNodes[a].className="dhtmlxcalendar_selector_cell",this._ysCells[n++]=this.ysCont.childNodes[i].childNodes[a];this._updateActiveYear()},this._scrollYears=function(t){var e=(t<0?this.ysCont.firstChild.firstChild._year:this.ysCont.lastChild.lastChild._year)+t,n=new Date(e,this._activeMonth.getMonth(),1,0,0,0,0);this._updateYearsList(n)},this._updateActiveHours=function(){void 0!==this._hsActive&&void 0!==this._hsCells[this._hsActive]&&(this._hsCells[this._hsActive].className="dhtmlxcalendar_selector_cell"),this._hsActive=this._activeDate.getHours(),this._hsCells[this._hsActive].className="dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active"},this._updateVisibleHours=function(){this.contTime.firstChild.firstChild.childNodes[1].innerHTML=this._fixLength(this._activeDate.getHours(),2)},this._updateActiveMinutes=function(){null!=this._rsActive&&void 0!==this._rsActive&&void 0!==this._rsCells[this._rsActive]&&(this._rsCells[this._rsActive].className="dhtmlxcalendar_selector_cell"),1==this._minutesInterval?this._rsActive=this.getFormatedDate("%i").toString().charAt(1==this._selectorMode?0:1):this._rsActive=this._activeDate.getMinutes(),void 0!==this._rsCells[this._rsActive]&&(this._rsCells[this._rsActive].className="dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active")},this._updateVisibleMinutes=function(t){var e=this._fixLength(this._activeDate.getMinutes(),2).toString();1==t&&(e=e.charAt(0)+"<span class='dhtmlxcalendar_selected_date'>"+e.charAt(1)+"</span>"),this.contTime.firstChild.firstChild.childNodes[3].innerHTML=e,1==t&&(this.contTime.firstChild.firstChild.childNodes[3].lastChild._par=!0)},this._fixLength=function(t,e){for(;String(t).length<e;)t="0"+String(t);return t},this._dateFormat="",this._dateFormatRE=null,this.setDateFormat=function(t){var e={};if(null!=this._strToDate)for(var n in this.i)if(null!=this.i[n].input&&this.i[n].input.value.length>0){var i=this._strToDate(this.i[n].input.value,this._dateFormat||this.langData[this.lang].dateformat||"%Y-%m-%d");i instanceof Date&&(e[n]=i)}this._dateFormat=t;var a=String(this._dateFormat).replace(/%[a-zA-Z]+/g,function(t){switch(t.replace(/%/,"")){case"n":case"h":case"j":case"g":case"G":return"\\d{1,2}";case"m":case"d":case"H":case"i":case"s":case"y":return"\\d{2}";case"Y":return"\\d{4}";case"M":return"("+o.langData[o.lang].monthesSNames.join("|").toLowerCase()+"){1,}";case"F":return"("+o.langData[o.lang].monthesFNames.join("|").toLowerCase()+"){1,}";case"D":return"[a-z]{2}";case"a":case"A":return"AM|PM";case"u":return"\\d{1,6}";case"P":return"[\\+\\-]\\d{1,2}\\:\\d{1,2}"}return t});for(var n in this._dateFormatRE=new RegExp(a,"i"),e)this.i[n].input.value=this._dateToStr(e[n]);e=null},this.setDateFormat(this.langData[this.lang].dateformat||"%Y-%m-%d"),this._updateDateStr=function(t){if(this._dateFormatRE&&t.match(this._dateFormatRE)&&t!=this.getFormatedDate()){var e=this._strToDate(t);e instanceof Date&&(!this.checkEvent("onBeforeChange")||this.callEvent("onBeforeChange",[new Date(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds())])?(this._nullDate=!1,this._activeDate=e,this._drawMonth(this._nullDate?new Date:this._activeDate),this._updateVisibleMinutes(),this._updateVisibleHours(),this._sel&&this._isSelectorVisible()&&this._doOnSelectorShow(this._sel._t),this._doOnSelectorChange(!0)):this._updateInp())}},this.showMonth=function(t){"string"==typeof t&&(t=this._strToDate(t)),t instanceof Date&&this._drawMonth(t)},this.setFormatedDate=function(t,e,n,i){var a=this._strToDate(e,t);if(i)return a;this.setDate(a)},this.getFormatedDate=function(t,e){if(!(e&&e instanceof Date)){if(this._nullDate)return"";e=new Date(this._activeDate)}return this._dateToStr(e,t)},this.getWeekNumber=function(t){if("string"==typeof t&&(t=this._strToDate(t)),!(t instanceof Date))return"Invalid Date";var e=t.getDay();0===e&&(e=7);var n=new Date(t.valueOf());n.setDate(t.getDate()+(4-e));var i=n.getFullYear(),a=Math.round((n.getTime()-new Date(i,0,1).getTime())/864e5);return 1+Math.floor(a/7)},this.showWeekNumbers=function(){this.base.firstChild.className="dhtmlxcalendar_wn"},this.hideWeekNumbers=function(){this.base.firstChild.className=""},this.show=function(t){if(t||!this._hasParent){if("string"==typeof t){var e=document.getElementById(t);if(null!=e&&void 0!==e._dhtmlxcalendar_uid&&null!=this.i[e._dhtmlxcalendar_uid])return void this._show(e._dhtmlxcalendar_uid)}if("object"!=typeof t||void 0===t._dhtmlxcalendar_uid||this.i[t._dhtmlxcalendar_uid]!=t){if(void 0===t)for(var n in this.i)t||(t=n);t&&this._show(t)}else this._show(t._dhtmlxcalendar_uid)}else this._show()},this.hide=function(){this._isVisible()&&this._hide()},this.isVisible=function(){return this._isVisible()},this._activeInp=null,this.pos="bottom",this.setPosition=function(t,e){this._px=null,this._py=null,"right"==t||"bottom"==t?this.pos=t:(this.pos="int",void 0===t||isNaN(t)||(this.base.style.left=t+"px",this._px=t),void 0===e||isNaN(e)||(this.base.style.top=e+"px",this._py=e),this._ifrSize())},this._show=function(t,e){if(!0===e&&this._activeInp==t&&this._isVisible())this._hide();else{if(this.base.style.visibility="hidden",this.base.style.display="",t){-1==this.base.className.indexOf("dhtmlxcalendar_in_input")&&(this.base.className+=" dhtmlxcalendar_in_input");var n=this.i[t].input||this.i[t].button,i=window.dhx4.screenDim(),a={top:window.dhx4.absTop(n),left:window.dhx4.absLeft(n)};if("right"==this.pos)this.base.style.left=a.left+n.offsetWidth+"px",this.base.style.top=Math.min(a.top,i.bottom-this.base.offsetHeight)+"px";else if("bottom"==this.pos){var o=a.top+n.offsetHeight+1;if(o+this.base.offsetHeight>i.bottom){var r=a.top-this.base.offsetHeight;r>=-20&&(o=r)}var s=a.left;s+this.base.offsetWidth>i.right&&(s=Math.max(0,a.left+n.offsetWidth-this.base.offsetWidth)),this.base.style.left=s+"px",this.base.style.top=o+"px"}else this.base.style.left=(this._px||0)+"px",this.base.style.top=(this._py||0)+"px";this._activeInp=t,n=null}else null!=this._px&&null!=this._py?(this.base.style.left=this._px+"px",this.base.style.top=this._py+"px"):(this.base.style.left="0px",this.base.style.top="0px");this._hideSelector(),this.base.style.visibility="visible",this.base.style.zIndex=window.dhx4.zim.reserve(this.conf.zi),this._ifrSize(),this._ifr&&(this._ifr.style.display=""),this.callEvent("onShow",[])}},this._hide=function(){null!=this._lastHover&&this._clearDayHover(),this._hideSelector(),this.base.style.display="none",window.dhx4.zim.clear(this.conf.zi),this.base.className.indexOf("dhtmlxcalendar_in_input")>=0&&(this.base.className=this.base.className.replace(/\s{0,}dhtmlxcalendar_in_input/gi,"")),this._activeInp=null,this._ifr&&(this._ifr.style.display="none"),this.callEvent("onHide",[])},this._isVisible=function(){return"none"!=this.base.style.display},this._rangeActive=!1,this._rangeFrom=null,this._rangeTo=null,this._rangeSet={},this.setInsensitiveDays=function(t){for(var e=this._extractDates(t),n=0;n<e.length;n++)this._rangeSet[new Date(e[n].getFullYear(),e[n].getMonth(),e[n].getDate(),0,0,0,0).getTime()]=!0;this._drawMonth(this._activeMonth)},this.clearInsensitiveDays=function(){this._clearRangeSet(),this._drawMonth(this._activeMonth)},this._holidays={},this.setHolidays=function(t){if(null==t)this._clearHolidays();else if(null!=t)for(var e=this._extractDates(t),n=0;n<e.length;n++)this._holidays[new Date(e[n].getFullYear(),e[n].getMonth(),e[n].getDate(),0,0,0,0).getTime()]=!0;this._drawMonth(this._activeMonth)},this._extractDates=function(t){("string"==typeof t||t instanceof Date)&&(t=[t]);for(var e=[],n=0;n<t.length;n++)if("string"==typeof t[n])for(var i=t[n].split(","),a=0;a<i.length;a++)e.push(this._strToDate(i[a]));else t[n]instanceof Date&&e.push(t[n]);return e},this._clearRange=function(){this._rangeActive=!1,this._rangeType=null,this._rangeFrom=null,this._rangeTo=null},this._clearRangeSet=function(){for(var t in this._rangeSet)this._rangeSet[t]=null,delete this._rangeSet[t]},this._clearHolidays=function(){for(var t in this._holidays)this._holidays[t]=null,delete this._holidays[t]},this._isOutOfRange=function(t){if(1==this._rangeSet[t])return!0;if(this._rangeActive){if("in"==this._rangeType&&(t<this._rangeFrom||t>this._rangeTo))return!0;if("out"==this._rangeType&&t>=this._rangeFrom&&t<=this._rangeTo)return!0;if("from"==this._rangeType&&t<this._rangeFrom)return!0;if("to"==this._rangeType&&t>this._rangeTo)return!0}var e=new Date(t);return!(!this._rangeWeek||!0!==this._rangeWeekData[e.getDay()])||(!(!this._rangeMonth||!0!==this._rangeMonthData[e.getDate()])||!(!this._rangeYear||!0!==this._rangeYearData[e.getMonth()+"_"+e.getDate()]))},this.clearSensitiveRange=function(){this._clearRange(),this._drawMonth(this._activeMonth)},this.setSensitiveRange=function(t,e,n){var i=!1;if(null!=t&&null!=e){if(t instanceof Date||(t=this._strToDate(t)),e instanceof Date||(e=this._strToDate(e)),t.getTime()>e.getTime())return;this._rangeFrom=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime(),this._rangeTo=new Date(e.getFullYear(),e.getMonth(),e.getDate(),0,0,0,0).getTime(),this._rangeActive=!0,this._rangeType="in",i=!0}i||null==t||null!=e||(t instanceof Date||(t=this._strToDate(t)),this._rangeFrom=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime(),this._rangeTo=null,!0===n&&this._rangeFrom++,this._rangeActive=!0,this._rangeType="from",i=!0),i||null!=t||null==e||(e instanceof Date||(e=this._strToDate(e)),this._rangeFrom=null,this._rangeTo=new Date(e.getFullYear(),e.getMonth(),e.getDate(),0,0,0,0).getTime(),!0===n&&this._rangeTo--,this._rangeActive=!0,this._rangeType="to",i=!0),i&&this._drawMonth(this._activeMonth)},this.setInsensitiveRange=function(t,e){if(null!=t&&null!=e){if(t instanceof Date||(t=this._strToDate(t)),e instanceof Date||(e=this._strToDate(e)),t.getTime()>e.getTime())return;return this._rangeFrom=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime(),this._rangeTo=new Date(e.getFullYear(),e.getMonth(),e.getDate(),0,0,0,0).getTime(),this._rangeActive=!0,this._rangeType="out",void this._drawMonth(this._activeMonth)}null==t||null!=e?null!=t||null==e||this.setSensitiveRange(e,null,!0):this.setSensitiveRange(null,t,!0)},this.disableDays=function(t,e){if("week"==t){for(var n in"object"!=typeof e&&void 0===e.length&&(e=[e]),this._rangeWeekData||(this._rangeWeekData={}),this._rangeWeekData)this._rangeWeekData[n]=!1,delete this._rangeWeekData[n];for(var i=0;i<e.length;i++)this._rangeWeekData[e[i]]=!0,7==e[i]&&(this._rangeWeekData[0]=!0);this._rangeWeek=!0}if("month"==t){for(var n in"object"!=typeof e&&void 0===e.length&&(e=[e]),this._rangeMonthData||(this._rangeMonthData={}),this._rangeMonthData)this._rangeMonthData[n]=!1,delete this._rangeMonthData[n];for(i=0;i<e.length;i++)this._rangeMonthData[e[i]]=!0;this._rangeMonth=!0}if("year"==t){var a=this._extractDates(e);for(var n in this._rangeYearData||(this._rangeYearData={}),this._rangeYearData)this._rangeYearData[n]=!1,delete this._rangeYearData[n];for(i=0;i<a.length;i++)this._rangeYearData[a[i].getMonth()+"_"+a[i].getDate()]=!0;this._rangeYear=!0}this._drawMonth(this._activeMonth)},this.enableDays=function(t){"week"==t&&(this._rangeWeek=!1),"month"==t&&(this._rangeMonth=!1),"year"==t&&(this._rangeYear=!1),this._drawMonth(this._activeMonth)},this._tipData={},this._tipTM=null,this._tipTMTime=400,this._tipEvs=!1,this._tipPopup=null,this._tipCellDate=null,this._tipCellDim=null,this.setTooltip=function(t,e,n,i){for(var a=this._extractDates(t),o=0;o<a.length;o++){var r=new Date(a[o].getFullYear(),a[o].getMonth(),a[o].getDate(),0,0,0,0).getTime();this._tipData[r]={text:e,showIcon:n,usePopup:i}}this._drawMonth(this._activeMonth)},this.clearTooltip=function(t){for(var e=this._extractDates(t),n=0;n<e.length;n++){var i=new Date(e[n].getFullYear(),e[n].getMonth(),e[n].getDate(),0,0,0,0).getTime();this._tipData[i]=null,delete this._tipData[i]}this._drawMonth(this._activeMonth)},this._initTooltipPopup=function(){this._tipEvs||(this.attachEvent("onMouseOver",function(t){var e=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime();null!=this._tipData[e]&&(this._tipTM&&window.clearTimeout(this._tipTM),this._tipCellDate=t,this._tipCellDim=this.getCellDimension(t),this._tipText=this._tipData[e].text,this._tipTM=window.setTimeout(this._showTooltipPopup,this._tipTMTime))}),this.attachEvent("onMouseOut",this._hideTooltipPopup),this._tipEvs=!0)},this._showTooltipPopup=function(t,e,n,i,a){o._tipPopup||(o._tipPopup=new dhtmlXPopup({mode:"top"})),o._tipPopup.attachHTML(o._tipText),o._tipPopup.show(o._tipCellDim.x,o._tipCellDim.y,o._tipCellDim.w,o._tipCellDim.h),o.callEvent("onPopupShow",[o._tipCellDate])},this._hideTooltipPopup=function(){this._tipTM&&window.clearTimeout(this._tipTM),null!=this._tipPopup&&this._tipPopup.isVisible()&&(this._tipPopup.hide(),this.callEvent("onPopupHide",[this._tipCellDate]))},this.getPopup=function(){return this._tipPopup},this.getCellDimension=function(t){if("string"==typeof t&&(t=this._strToDate(t)),!(t instanceof Date))return null;for(var e=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime(),n=null,i=0;i<this.contDates.childNodes.length;i++)for(var a=0;a<this.contDates.childNodes[i].childNodes.length;a++){var o=this.contDates.childNodes[i].childNodes[a];null!=o._date&&o._date.getTime()==e&&(n={x:window.dhx4.absLeft(o),y:window.dhx4.absTop(o),w:o.offsetWidth,h:o.offsetHeight}),o=null}return n},this._updateFromInput=function(t){if(this._nullInInput&&0==t.value.replace(/\s/g,"").length){if(this.checkEvent("onBeforeChange")&&!this.callEvent("onBeforeChange",[null]))return void this._updateInp();this.setDate(null)}else this._updateDateStr(t.value);t=null},this._doOnClick=function(t){var e=(t=t||event).target||t.srcElement;e._dhtmlxcalendar_uid&&e._dhtmlxcalendar_uid!=o._activeInp&&o._isVisible()&&o._activeInp?o._hide():e._dhtmlxcalendar_uid&&o.i[e._dhtmlxcalendar_uid]||(o._isSelectorVisible()?o._hideSelector():!o._hasParent&&o._isVisible()&&o._hide())},this._doOnKeyDown=function(t){27!=(t=t||event).keyCode&&13!=t.keyCode||(o._isSelectorVisible()?o._hideSelector():o._isVisible()&&!o._hasParent&&o._hide())},this._doOnInpClick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;e._dhtmlxcalendar_uid&&(o._listenerEnabled||o._updateFromInput(e),o._show(e._dhtmlxcalendar_uid,!0))},this._doOnInpKeyUp=function(t){var e=(t=t||event).target||t.srcElement;13!=t.keyCode&&e._dhtmlxcalendar_uid&&(o._listenerEnabled||o._updateFromInput(e))},this._doOnBtnClick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;e._dhtmlxcalendar_uid&&(null!=o.i[e._dhtmlxcalendar_uid].input&&o._updateFromInput(o.i[e._dhtmlxcalendar_uid].input),o._show(e._dhtmlxcalendar_uid,!0))},this._doOnUnload=function(){o&&o.unload&&o.unload()},"function"==typeof window.addEventListener?(document.body.addEventListener("click",o._doOnClick,!1),window.addEventListener("keydown",o._doOnKeyDown,!1),window.addEventListener("unload",o._doOnUnload,!1),1==this.conf.touch&&document.body.addEventListener("touchstart",o._doOnClick,!1)):(document.body.attachEvent("onclick",o._doOnClick),document.body.attachEvent("onkeydown",o._doOnKeyDown),window.attachEvent("onunload",o._doOnUnload)),this.attachObj=function(t){var e=window.dhx4.newId();return"string"==typeof t?this.i[e]={input:document.getElementById(t)}:void 0!==t.tagName?this.i[e]={input:t}:"object"!=typeof t||null==t.input&&null==t.button||(this.i[e]={},null!=t.input&&(this.i[e].input="string"==typeof t.input?document.getElementById(t.input):t.input),null!=t.button&&(this.i[e].button="string"==typeof t.button?document.getElementById(t.button):t.button)),this._attachEventsToObject(e),e},this.detachObj=function(t){var e=null;if(null!=this.i[t]?e=t:"string"==typeof t?e=(t=document.getElementById(t))._dhtmlxcalendar_uid:void 0!==t.tagName?e=t._dhtmlxcalendar_uid:"object"!=typeof t||null==t.input&&null==t.button||(null==e&&null!=t.input&&(e=("string"==typeof t.input?document.getElementById(t.input):t.input)._dhtmlxcalendar_uid),null==e&&null!=t.button&&(e=("string"==typeof t.button?document.getElementById(t.button):t.button)._dhtmlxcalendar_uid)),null!=e&&null!=this.i[e]){for(var n in this._detachEventsFromObject(e),this.i[n])this.i[e][n]._dhtmlxcalendar_uid=null,this.i[e][n]=null,delete this.i[e][n];return this.i[e]=null,delete this.i[e],!0}return!1},this._attachEventsToObject=function(t){null!=this.i[t].button?(this.i[t].button._dhtmlxcalendar_uid=t,"function"==typeof window.addEventListener?(this.i[t].button.addEventListener("click",o._doOnBtnClick,!1),1==this.conf.touch&&this.i[t].button.addEventListener("touchstart",o._doOnBtnClick,!1)):this.i[t].button.attachEvent("onclick",o._doOnBtnClick)):null!=this.i[t].input&&(this.i[t].input._dhtmlxcalendar_uid=t,"function"==typeof window.addEventListener?(this.i[t].input.addEventListener("click",o._doOnInpClick,!1),this.i[t].input.addEventListener("keyup",o._doOnInpKeyUp,!1),1==this.conf.touch&&this.i[t].input.addEventListener("touchstart",o._doOnInpClick,!1)):(this.i[t].input.attachEvent("onclick",o._doOnInpClick),this.i[t].input.attachEvent("onkeyup",o._doOnInpKeyUp)))},this._detachEventsFromObject=function(t){null!=this.i[t].button?"function"==typeof window.addEventListener?(this.i[t].button.removeEventListener("click",o._doOnBtnClick,!1),1==this.conf.touch&&this.i[t].button.removeEventListener("touchstart",o._doOnBtnClick,!1)):this.i[t].button.detachEvent("onclick",o._doOnBtnClick):null!=this.i[t].input&&("function"==typeof window.addEventListener?(this.i[t].input.removeEventListener("click",o._doOnInpClick,!1),this.i[t].input.removeEventListener("keyup",o._doOnInpKeyUp,!1),1==this.conf.touch&&this.i[t].input.removeEventListener("touchstart",o._doOnInpClick,!1)):(this.i[t].input.detachEvent("onclick",o._doOnInpClick),this.i[t].input.detachEvent("onkeyup",o._doOnInpKeyUp)))},this._updateInp=function(){null!=this.i&&null!=this._activeInp&&null!=this.i[this._activeInp]&&null!=this.i[this._activeInp].input&&(this.i[this._activeInp].input.value=this.getFormatedDate())},this.enableListener=function(t){t&&("function"==typeof window.addEventListener?(t.addEventListener("focus",o._listenerEvFocus,!1),t.addEventListener("blur",o._listenerEvBlur,!1)):(t.attachEvent("onfocus",o._listenerEvFocus),t.attachEvent("onblur",o._listenerEvBlur)),t=null)},this.disableListener=function(t){t&&(t._f0=!1,this._tmListener&&window.clearTimeout(this._tmListener),"function"==typeof window.addEventListener?(t.removeEventListener("focus",o._listenerEvFocus,!1),t.removeEventListener("blur",o._listenerEvBlur,!1)):(t.detachEvent("onfocus",o._listenerEvFocus),t.detachEvent("onblur",o._listenerEvBlur)),t=null)},this._startListener=function(t){this._tmListener&&window.clearTimeout(this._tmListener),void 0===t._v1&&(t._v1=t.value),t._v1!=t.value&&(this._updateFromInput(t),t._v1=t.value),t._f0&&(this._tmListener=window.setTimeout(function(){o._startListener(t)},100))},this._listenerEvFocus=function(t){var e=(t=t||event).target||t.srcElement;e._f0=!0,o._startListener(e),e=null},this._listenerEvBlur=function(t){var e=(t=t||event).target||t.srcElement;e._f0=!1,e=null},this.i)this._attachEventsToObject(d);return window.dhx4._eventable(this),this._evOnArrowClick=function(t){return this.callEvent("onArrowClick",t)},this._evOnClick=function(t){return this.callEvent("onClick",t)},this._evOnMouseOut=function(t){return this.callEvent("onMouseOut",t)},this._evOnMouseOver=function(t){return this.callEvent("onMouseOver",t)},this.unload=function(){for(var t in this._activeDate=null,this._activeDateCell=null,this._activeInp=null,this._activeMonth=null,this._dateFormat=null,this._dateFormatRE=null,this._lastHover=null,this._tmListener&&window.clearTimeout(this._tmListener),this._tmListener=null,"function"==typeof window.addEventListener?(document.body.removeEventListener("click",o._doOnClick,!1),window.removeEventListener("keydown",o._doOnKeyDown,!1),window.removeEventListener("unload",o._doOnUnload,!1),1==this.conf.touch&&document.body.removeEventListener("touchstart",o._doOnClick,!1)):(document.body.detachEvent("onclick",o._doOnClick),document.body.detachEvent("onkeydown",o._doOnKeyDown),window.detachEvent("onunload",o._doOnKeyDown)),this._doOnClick=null,this._doOnKeyDown=null,this._doOnUnload=null,this.i)this.i[t]._dhtmlxcalendar_uid=null,this._detachEventsFromObject(t),this.disableListener(this.i[t].input),this.i[t]=null,delete this.i[t];for(this.i=null,this._doOnInpClick=null,this._doOnInpKeyUp=null,window.dhx4._eventable(this,"clear"),this.contMonth.onselectstart=null,this.contMonth.firstChild.firstChild.onclick=null,this.contMonth.firstChild.firstChild.ontouchstart=null,this.contMonth.firstChild.firstChild.firstChild.onmouseover=null,this.contMonth.firstChild.firstChild.firstChild.onmouseout=null,this.contMonth.firstChild.firstChild.lastChild.onmouseover=null,this.contMonth.firstChild.firstChild.lastChild.onmouseout=null;this.contMonth.firstChild.firstChild.childNodes.length>0;)this.contMonth.firstChild.firstChild.removeChild(this.contMonth.firstChild.firstChild.lastChild);for(this.contMonth.firstChild.removeChild(this.contMonth.firstChild.firstChild),this.contMonth.removeChild(this.contMonth.firstChild),this.contMonth.parentNode.removeChild(this.contMonth),this.contMonth=null;this.contDays.firstChild.childNodes.length>0;)this.contDays.firstChild.removeChild(this.contDays.firstChild.lastChild);for(this.contDays.removeChild(this.contDays.firstChild),this.contDays.parentNode.removeChild(this.contDays),this.contDays=null,this.contDates.onclick=null,this.contDates.ontouchstart=null,this.contDates.onmouseover=null,this.contDates.onmouseout=null;this.contDates.childNodes.length>0;){for(;this.contDates.lastChild.childNodes.length>0;)this.contDates.lastChild.lastChild._css_date=null,this.contDates.lastChild.lastChild._css_month=null,this.contDates.lastChild.lastChild._css_weekend=null,this.contDates.lastChild.lastChild._css_hover=null,this.contDates.lastChild.lastChild._date=null,this.contDates.lastChild.lastChild._q=null,this.contDates.lastChild.lastChild._w=null,this.contDates.lastChild.removeChild(this.contDates.lastChild.lastChild);this.contDates.removeChild(this.contDates.lastChild)}for(this.contDates.parentNode.removeChild(this.contDates),this.contDates=null,this.contTime.firstChild.firstChild.onclick=null,this.contTime.firstChild.firstChild.ontouchstart=null;this.contTime.firstChild.firstChild.childNodes.length>0;)this.contTime.firstChild.firstChild.removeChild(this.contTime.firstChild.firstChild.lastChild);if(this.contTime.firstChild.removeChild(this.contTime.firstChild.firstChild),this.contTime.removeChild(this.contTime.firstChild),this.contTime.parentNode.removeChild(this.contTime),this.contTime=null,this._lastHover=null,this._unloadSelector("month"),this._unloadSelector("year"),this._unloadSelector("hours"),this._unloadSelector("minutes"),this._selCover&&(this._selCover.parentNode.removeChild(this._selCover),this._selCover=null),this._sel){for(var t in this._sel._ta)this._sel._ta[t]=null;for(this._sel._ta=null,this._sel._t=null,this._sel.onmouseover=null,this._sel.onmouseout=null;this._sel.firstChild.firstChild.firstChild.childNodes.length>0;)this._sel.firstChild.firstChild.firstChild.lastChild.onclick=null,this._sel.firstChild.firstChild.firstChild.lastChild.onmouseover=null,this._sel.firstChild.firstChild.firstChild.lastChild.onmouseout=null,this._sel.firstChild.firstChild.firstChild.removeChild(this._sel.firstChild.firstChild.firstChild.lastChild);for(this._sel.firstChild.firstChild.removeChild(this._sel.firstChild.firstChild.firstChild),this._sel.firstChild.removeChild(this._sel.firstChild.firstChild);this._sel.childNodes.length>0;)this._sel.removeChild(this._sel.lastChild);this._sel.parentNode.removeChild(this._sel),this._sel=null}for(var t in this.base.onclick=null,this.base.onmousedown=null,this.base.ontouchstart=null,this.base.onmouseout=null,this.base.parentNode.removeChild(this.base),this.base=null,this._clearDayHover=null,this._clearSelHover=null,this._doOnSelectorChange=null,this._doOnSelectorShow=null,this._drawMonth=null,this._fixLength=null,this._ifrSize=null,this._hide=null,this._hideSelector=null,this._initSelector=null,this._isSelectorVisible=null,this._isVisible=null,this._scrollYears=null,this._show=null,this._showSelector=null,this._strToDate=null,this._updateActiveHours=null,this._updateActiveMinutes=null,this._updateActiveMonth=null,this._updateActiveYear=null,this._updateCellStyle=null,this._updateDateStr=null,this._updateVisibleHours=null,this._updateVisibleMinutes=null,this._updateYearsList=null,this.enableIframe=null,this.hide=null,this.hideTime=null,this.setDate=null,this.setDateFormat=null,this.setYearsRange=null,this.show=null,this.showTime=null,this.unload=null,null!=this._tipPopup&&(this._tipPopup.unload(),this._tipPopup=null),this)delete this[t];t=o=null},this.setDate(this._activeDate),this}at.prototype.lang="en",at.prototype.langData={en:{dateformat:"%Y-%m-%d",hdrformat:"%F %Y",monthesFNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthesSNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],daysFNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysSNames:["Su","Mo","Tu","We","Th","Fr","Sa"],weekstart:1,weekname:"w",today:"Today",clear:"Clear"}},at.prototype._buildMonthHdr=function(t){var e=this,n=function(t){return 1==String(t).length?"0"+String(t):t},i=function(t,e){return"<span class='dhtmlxcalendar_month_label_"+t+"'>"+e+"</span>"},a=String(this.langData[this.lang].hdrformat||"%F %Y").replace(/%[a-z]/gi,function(a){switch(a){case"%m":return i("month",n(t.getMonth()+1));case"%n":return i("month",t.getMonth()+1);case"%M":return i("month",e.langData[e.lang].monthesSNames[t.getMonth()]);case"%F":return i("month",e.langData[e.lang].monthesFNames[t.getMonth()]);case"%y":return i("year",n(t.getYear()%100));case"%Y":return i("year",t.getFullYear());case"%%":return"%";default:return a}});return e=n=i=null,a},at.prototype.enableIframe=function(t){1==t?this._ifr||(this._ifr=document.createElement("IFRAME"),this._ifr.frameBorder=0,this._ifr.border=0,this._ifr.setAttribute("src","javascript:false;"),this._ifr.className="dhtmlxcalendar_ifr",this._ifr.onload=function(){this.onload=null,this.contentWindow.document.open("text/html","replace"),this.contentWindow.document.write("<html><head><style>html,body{width:100%;height:100%;overflow:hidden;margin:0px;}</style></head><body</body></html>")},this.base.parentNode.insertBefore(this._ifr,this.base),this._ifrSize()):this._ifr&&(this._ifr.parentNode.removeChild(this._ifr),this._ifr=null)},at.prototype._ifrSize=function(){this._ifr&&(this._ifr.style.left=this.base.style.left,this._ifr.style.top=this.base.style.top,this._ifr.style.width=this.base.offsetWidth+"px",this._ifr.style.height=this.base.offsetHeight+"px")},at.prototype._dateStrings=function(){var t=this.langData[this.lang];return{monthFullName:t.monthesFNames,monthShortName:t.monthesSNames,dayFullName:t.daysFNames,dayShortName:t.daysSNames}},at.prototype._strToDate=function(t,e){return window.dhx4.str2date(t,e||this._dateFormat,this._dateStrings())},at.prototype._dateToStr=function(t,e){return window.dhx4.date2str(t,e||this._dateFormat,this._dateStrings())};var ot=at,rt={name:"pf-calendar-component",data:function(){return{pfCalendar:null}},mixins:[i],directives:{VueMaskDirective:it},props:["date","sensitiveRange","sensitiveDays","disableMode","theme","language","startDay","init","today","time","week","tooltip","label","id","mask","value","readonly","classElement","validate","name","labelStyle","divCalendar","model","field","tabindex","isObligatory"],mounted:function(){!0!==this.readonly&&null!==document.getElementById(this.id)&&(document.getElementById(this.id).onload=this.loadCalendar())},methods:{loadCalendar:function(){ot.prototype.langData.es={dateformat:"%m-%d-%Y",monthesFNames:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],monthesSNames:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],daysFNames:["Domingo","Lunes","Martes","Miercoles","Jueves","Viernes","Sabado"],daysSNames:["Do","Lu","Ma","Mi","Ju","Vi","Sa"],weekstart:1,weekname:"s",today:"Hoy",clear:"Limpiar"},this.pfCalendar=new ot({input:"input-"+this.id,button:"icon-"+this.id}),this.pfCalendar.setDateFormat("%m/%d/%Y"),"string"==typeof this.date&&this.pfCalendar.setDate(this.date),"object"===v()(this.sensitiveRange)&&("[object Array]"===Object.prototype.toString.call(this.sensitiveRange)&&(this.sensitiveRange[2]&&"out"===this.sensitiveRange[2]?this.pfCalendar.setInsensitiveRange(this.sensitiveRange[0],this.sensitiveRange[1]):this.pfCalendar.setSensitiveRange(this.sensitiveRange[0],this.sensitiveRange[1])),"[object Object]"===Object.prototype.toString.call(this.sensitiveRange)&&(this.sensitiveRange.out&&!0===this.sensitiveRange.out?this.pfCalendar.setInsensitiveRange(this.sensitiveRange.from?this.sensitiveRange.from:null,this.sensitiveRange.to?this.sensitiveRange.to:null):this.pfCalendar.setSensitiveRange(this.sensitiveRange.from?this.sensitiveRange.from:null,this.sensitiveRange.to?this.sensitiveRange.to:null))),"[object Array]"===Object.prototype.toString.call(this.sensitiveDays)&&this.pfCalendar.setInsensitiveDays(this.sensitiveDays),"[object Object]"===Object.prototype.toString.call(this.disableMode)&&this.pfCalendar.disableDays(this.disableMode.mode?this.disableMode.mode:"",this.disableMode.d?this.disableMode.d:[]),"string"==typeof this.theme&&this.pfCalendar.setSkin("material"===this.theme?this.theme:"dhx_"+this.theme),"string"==typeof this.language&&this.pfCalendar.loadUserLanguage(this.language),"number"==typeof this.startDay&&this.pfCalendar.setWeekStartDay(this.startDay),"string"==typeof this.init&&this.pfCalendar.showMonth(new Date(this.init)),"boolean"==typeof this.today&&(!0===this.today?this.pfCalendar.showToday():this.pfCalendar.hideToday()),"boolean"==typeof this.time&&(!1===this.time?this.pfCalendar.hideTime():this.pfCalendar.showTime()),"boolean"==typeof this.week&&(!1===this.week?this.pfCalendar.hideWeekNumbers():this.pfCalendar.showWeekNumbers()),"object"===v()(this.tooltip)&&("[object Array]"===Object.prototype.toString.call(this.tooltip)&&this.pfCalendar.setTooltip(this.tooltip[0]?this.tooltip[0]:"",this.tooltip[1]?this.tooltip[1]:"",this.tooltip[2]?this.tooltip[2]:"",this.tooltip[3]?this.tooltip[3]:""),"[object Object]"===Object.prototype.toString.call(this.tooltip)&&this.pfCalendar.setTooltip(this.tooltip.date?this.tooltip.date:"",this.tooltip.message?this.tooltip.message:"",this.tooltip.icon?this.tooltip.icon:"",this.tooltip.pop?this.tooltip.pop:""));var t=this;this.pfCalendar.attachEvent("onChange",function(e){var n,i="",a="";i=e.getDate(),a=e.getMonth()+1,i<10&&(i="0"+i),a<10&&(a="0"+a),n=a+"/"+i+"/"+e.getFullYear(),t.$emit("change",{shortDate:n,id:"input-"+t.id,field:t.field,model:t.model})})}}},st={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"form-group",class:t.divCalendar,attrs:{id:t.id}},[n("label",{directives:[{name:"show",rawName:"v-show",value:void 0!==t.label,expression:"label !== undefined"}],style:t.labelStyle,attrs:{for:""}},[t._v(t._s(t.label))]),t._v(" "),void 0!==t.validate?n("input",{directives:[{name:"validate",rawName:"v-validate",value:t.validate,expression:"validate"},{name:"mask",rawName:"v-mask",value:t.mask,expression:"mask"}],staticClass:"form-control form-control-sm",class:t.classElement,style:!0===t.readonly?"pointer-events: none;":"",attrs:{type:"text",id:"input-"+t.id,readonly:t.readonly,name:t.name,tabindex:!1===t.readonly?t.tabindex:-1,placeholder:"mm / dd / yyyy"},domProps:{value:t.value},on:{change:function(e){return t.$emit("change",{shortDate:e.target.value,id:"input-"+t.id,field:t.field,model:t.model})},input:function(e){return t.$emit("input",e.target.value)},contextmenu:function(e){return e.preventDefault(),t.$emit("context")},focus:function(e){return t.$emit("focus")}}}):!1===t.readonly||void 0===t.readonly?n("input",{directives:[{name:"mask",rawName:"v-mask",value:t.mask,expression:"mask"}],staticClass:"form-control form-control-sm",class:t.classElement,style:!0===t.readonly?"pointer-events: none;":"",attrs:{type:"text",id:"input-"+t.id,readonly:t.readonly,tabindex:!1===t.readonly?t.tabindex:-1,placeholder:"mm / dd / yyyy"},domProps:{value:t.value},on:{change:function(e){return t.$emit("change",{shortDate:e.target.value,id:"input-"+t.id,field:t.field,model:t.model})},input:function(e){return t.$emit("input",e.target.value)},contextmenu:function(e){return e.preventDefault(),t.$emit("context")},focus:function(e){return t.$emit("focus")}}}):!0===t.readonly?n("input",{directives:[{name:"mask",rawName:"v-mask",value:t.mask,expression:"mask"}],staticClass:"form-control form-control-sm",class:t.classElement,style:!0===t.readonly?"pointer-events: none;":"",attrs:{type:"text",id:"input-"+t.id,readonly:t.readonly,tabindex:!1===t.readonly?t.tabindex:-1,placeholder:"mm / dd / yyyy"},domProps:{value:t.value},on:{input:function(e){return t.$emit("input",e.target.value)},contextmenu:function(e){return e.preventDefault(),t.$emit("context")},focus:function(e){return t.$emit("focus")}}}):t._e(),t._v(" "),!0===t.isObligatory?n("div",{staticClass:"invalid-feedback d-block fieldObli"},[t._v("Required Field")]):t._e(),t._v(" "),void 0!==t.name&&t.errors.first(t.name)?n("span",{staticStyle:{"font-size":"8pt",color:"red","margin-bottom":"0px"}},[t._v("\n  "+t._s(t.errors.first(t.name).replace(t.name,"")))]):t._e(),t._v(" "),n("span",[!1===t.readonly?n("i",{staticClass:"far fa-calendar-alt",staticStyle:{position:"absolute",cursor:"pointer",right:"20px","margin-top":"-26px","z-index":"200"},attrs:{id:"icon-"+t.id}}):t._e()])])},staticRenderFns:[]};var lt=n("VU/8")(rt,st,!1,function(t){n("clUQ"),n("zVSE"),n("cOrP"),n("69pR"),n("SL+L"),n("KT6R")},null,null).exports,dt=n("PJh5"),ct=n.n(dt),ht={data:function(){return{idComponent:"",isPopUp:!1,messageModal:"",requiredMesssage:"The red fields are Required.",radioGroups:{ethnicity:["hisp","nothisp"],race:["white","asian","black","amind","hawaii"],eyeColor:["eyeBlack","eyeGray","eyeMaroon","eyeBlue","eyeGreen","eyePink","eyeBrown","eyeHazel","eyeUnk"],hair:["hairBald","hairBrown","hairSandy","hairBlack","hairWhite","hairBlond","hairRed","hairUnk"],usCitizen:["uscYes","uscNo"],usLegalPermanentResident:["lprYes","lprNo"],usCitizenThrough:["uscNat","uscBirth","uscParents"],sexBiographic:["sexFemale","sexMale"],isAptSteFlr:["apt","ste","flr"],isAptSteFlrJob:["aptCk","steCk","floorCk"],didtriplast6months:["sixMy","sixMn"],travelwithauthorization:["authYes","authNo"],inspectedandAdmitted:["inyes","inno"],marriageGroup:["placeOfResidenceApt","placeOfResidenceSte","placeOfResidenceFlr"],sexMarriage:["sexFemaleCk","sexMaleCk"],inimmigrationcourtproceedings:["immigrationCourtProceedingsYes","immigrationCourtProceedingsNo"],thispersonisintheUS:["inTheUsYes","inTheUsNo"],maritalStatus:["maritalStatusMarried","maritalStatusSingle","maritalStatusDivorced","maritalStatusWidow","maritalStatusSeparated","maritalStatusAnnulled"]}}},props:{information:{type:Object},comparing:{type:Boolean,default:!1},readonly:{type:Boolean,default:!1},indexItem:{type:String,default:""},index:{type:Number},token:{type:String,default:""},apiService:{type:Object},viewer:{type:Boolean,default:!1},questionnaireid:{type:String},contactId:{type:Number},infoChangeValue:{type:Object},uniqueIndex:{type:Number}},components:{PfInput:m,PfCalendar:lt},watch:{infoChangeValue:function(t){var e=this;if(void 0!==t&&void 0!==t.value&&-1!==this.indexItem.indexOf("manual")&&this.uniqueIndex===t.index){var n=this.information;Y()(n).forEach(function(i){if(i===t.fieldId){n[i]=t.value,n.threeValues[i].manual=t.value;var a=document.getElementById(t.id),o=document.getElementById(t.id.replace("manual","edit"));"radio"===a.type&&"on"===t.value?e.setInfoRadios(t,n):"text"===a.type||"email"===a.type||"select-one"===a.type||"tel"===a.type||"number"===a.type||"textarea"===a.type?e.setInfoText(t):"checkbox"===a.type&&e.setInfoCheck(t);var r=e.information.threeValues[t.fieldId].origin,s=e.information.threeValues[t.fieldId].manual;if(r!==s)if("radio"===a.type)a.classList.add("myInputRadUpdated"),o.classList.add("myInputRadUpdated");else if("text"===a.type||"email"===a.type||"select-one"===a.type||"tel"===a.type||"number"===a.type||"textarea"===a.type){var l=""===s?"deleted-information":""===r?"new-information":"updated-information";a.classList.add(l),o.classList.add(l)}else"checkbox"===a.type&&(a.classList.add("myInputUpdated"),o.classList.add("myInputUpdated"));else"radio"===a.type?(a.classList.remove("myInputRadUpdated"),o.classList.remove("myInputRadUpdated")):"text"===a.type||"email"===a.type||"select-one"===a.type||"tel"===a.type||"number"===a.type||"textarea"===a.type?(a.classList.remove("deleted-information","new-information","updated-information"),o.classList.remove("deleted-information","new-information","updated-information")):"checkbox"===a.type&&(a.classList.remove("myInputUpdated"),o.classList.remove("myInputUpdated"))}})}}},mounted:function(){this.getCode()},methods:{setInfoCheck:function(t){this.updateModel({model:t.model,field:t.fieldId,value:null===t.value||""===t.value?"off":t.value,id:t.id})},setInfoText:function(t){this.updateModel({model:t.model,field:t.fieldId,value:null!==t.value?t.value:"",id:t.id})},setInfoRadios:function(t,e){var n=this;Y()(this.radioGroups).forEach(function(i){-1!==n.radioGroups[i].indexOf(t.fieldId)&&n.radioGroups[i].forEach(function(i){i!==t.fieldId&&"on"===n.information[i]&&"on"===t.value?(e[i]="off",!0===n.comparing&&(e.threeValues[i].manual="off"),n.updateModel({model:t.model,field:i,value:"off",id:t.id})):i===t.fieldId&&(e[i]=null!==t.value?t.value:"off",!0===n.comparing&&(e.threeValues[i].manual=null!==t.value?t.value:"off"),n.updateModel({model:t.model,field:t.fieldId,value:null!==t.value?t.value:"off",id:t.id}))})}),this.information={},this.information=JSON.parse(U()(e))},getCode:function(){this.idComponent="";for(var t="",e="0123456789".length,n=0;n<=3;++n)t+="0123456789"[this.getRandomInt(0,e-1)];this.idComponent=t},getRandomInt:function(t,e){return Math.floor(Math.random()*(e-t+1))+t},setHover:function(t){var e=t+this.idComponent;document.getElementById(e).classList.add("btnBloodClass"),e="#"+t+this.idComponent;var n=document.querySelector(e);n.querySelectorAll(".backgroundTitlesBox").forEach(function(t){t.classList.add("backgroundTitlesBoxDeleted")}),n.querySelectorAll(".backgroundTitlesBoxNoBorder").forEach(function(t){t.classList.add("backgroundTitlesBoxDeletedNoborder")})},removeHover:function(t){var e=t+this.idComponent;document.getElementById(e).classList.remove("btnBloodClass"),e="#"+t+this.idComponent;var n=document.querySelector(e);n.querySelectorAll(".backgroundTitlesBox").forEach(function(t){t.classList.remove("backgroundTitlesBoxDeleted")}),n.querySelectorAll(".backgroundTitlesBoxNoBorder").forEach(function(t){t.classList.remove("backgroundTitlesBoxDeletedNoborder")})},changeCalendar:function(t){this.information[t.field]=t.shortDate,""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing&&this.$emit("change-calendar",t);var e={model:t.model,value:null===t.shortDate?"":t.shortDate,field:t.field,id:t.id};this.updateModel(e)},updateModel:function(t){if(void 0===this.information.newItem&&!0===this.validateField(t.id)){this.information[t.field]=t.value,!0===this.comparing&&(void 0!==this.information.threeValues[t.field]&&(this.information.threeValues[t.field].manual=t.value),this.$emit("change-color",t));var e={token:this.token,where:{questionnaireId:this.questionnaireid,model:t.model,modelId:this.information.id,field:t.field},value:null===t.value?"":t.value};!0!==this.viewer&&!0!==this.comparing||this.updateCaseQuestionnaire({data:e,fieldId:t.id})}},updateForm:function(t){var e=this;return q()(X.a.mark(function n(){var i,a,o;return X.a.wrap(function(n){for(;;)switch(n.prev=n.next){case 0:if(e.comparing&&e.setContextMenuValue(t),t.field=t.field.replace(/]_/g,"]."),e.$emit("change-color",t),i="",i=-1!==e.currentFormId.indexOf("-")?e.currentFormId.split("-")[0]:e.currentFormId,a={token:e.token,where:{questionnaireId:e.questionnaireid,formId:i,field:t.field,fieldType:t.fieldType,formModel:t.formModel,caseFormId:t.caseFormId},value:t.value?t.value:""},!e.viewer&&!e.comparing){n.next=11;break}return n.next=9,e.updateCaseQuestionnaire({data:a,fieldId:t.id});case 9:return o=n.sent,n.abrupt("return",o);case 11:case"end":return n.stop()}},n,e)}))()},deleteItem:function(t){var e={token:this.token,where:{questionnaireId:this.questionnaireid,model:t.model,modelId:this.information.id,field:"deletedAt"},value:ct()().format("MM/DD/YYYY")};this.updateCaseQuestionnaire({data:e,deleteItem:t.item})},updateCaseQuestionnaire:function(t){var e=this;return q()(X.a.mark(function n(){var i,a,o,r,s;return X.a.wrap(function(n){for(;;)switch(n.prev=n.next){case 0:return i="",a="",e.viewer?(i="UpdateCaseQuestionnaire",a="caseQuestionnaireEdit"):e.comparing&&(i="updateCaseQuestionnaireManual",a="caseQuestionnaireManual"),n.prev=3,n.next=6,e.apiService[i](t.data);case 6:return o=n.sent,e.comparing&&(e.$emit("return-info-qf",o),e.$emit("set-badges")),r=document.getElementById(t.fieldId),s="",s=o&&o[a]?"updated":"error",null!==r?e.setFlash({el:r,action:s}):"updated"===s&&t.deleteItem&&(e.viewer?e.$emit(t.deleteItem):e.comparing&&(e.information.deletedAt=t.data.value,e.comparing&&e.$emit("set-badges"))),n.abrupt("return",o);case 15:return n.prev=15,n.t0=n.catch(3),console.error(n.t0),n.abrupt("return",!1);case 19:case"end":return n.stop()}},n,e,[[3,15]])}))()},changeSelect:function(t){this.information[t.field]=t.value,this.updateModel(t)},handleSubmit:function(t){var e=document.querySelector("#"+t),n=!0;new URLSearchParams(new FormData(e)).toString().split("&").forEach(function(t){var e=t.split("=");null!==document.getElementById(e[0])&&document.getElementById(e[0]).classList.forEach(function(t){"is-invalid"===t?(!0===n&&(document.getElementById(e[0]).focus(),document.getElementById(e[0]).scrollIntoView({behavior:"smooth",block:"center",inline:"nearest"})),n=!1):""===e[1]&&-1===e[0].indexOf("hide")&&null!==document.getElementById(e[0])&&(document.getElementById(e[0]).classList.add("is-invalid"),!0===n&&(document.getElementById(e[0]).focus(),document.getElementById(e[0]).scrollIntoView({behavior:"smooth",block:"center",inline:"nearest"})),n=!1)})}),!0===n&&this.$emit("save-new-item",this.information)},validateField:function(t){if(this.information.newItem)return!1;var e=document.getElementById(t),n=!0;return null!==e&&(e.classList.forEach(function(t){"is-invalid"===t&&(n=!1)}),!0===n)},setFlash:function(t){var e="updated"===t.action?"flashitInput":"error"===t.action?"flashitInputError":"";t.el.classList.add(e),setTimeout(function(){t.el.classList.remove(e)},400)}}},ut=n("Zrlr"),mt=n.n(ut),ft=function t(){mt()(this,t)};ft.COUNTRIES=[{name:"Afghanistan",value:"Afghanistan",selected:!1},{name:"Albania",value:"Albania",selected:!1},{name:"Algeria",value:"Algeria",selected:!1},{name:"American Samoa",value:"American Samoa",selected:!1},{name:"Andorra",value:"Andorra",selected:!1},{name:"Angola",value:"Angola",selected:!1},{name:"Anguilla",value:"Anguilla",selected:!1},{name:"Antarctica",value:"Antarctica",selected:!1},{name:"Antigua and Barbuda",value:"Antigua and Barbuda",selected:!1},{name:"Argentina",value:"Argentina",selected:!1},{name:"Armenia",value:"Armenia",selected:!1},{name:"Aruba",value:"Aruba",selected:!1},{name:"Australia",value:"Australia",selected:!1},{name:"Austria",value:"Austria",selected:!1},{name:"Azerbaijan",value:"Azerbaijan",selected:!1},{name:"The Bahamas",value:"The Bahamas",selected:!1},{name:"Bahrain",value:"Bahrain",selected:!1},{name:"Bangladesh",value:"Bangladesh",selected:!1},{name:"Barbados",value:"Barbados",selected:!1},{name:"Belarus",value:"Belarus",selected:!1},{name:"Belgium",value:"Belgium",selected:!1},{name:"Belize",value:"Belize",selected:!1},{name:"Benin",value:"Benin",selected:!1},{name:"Bermuda",value:"Bermuda",selected:!1},{name:"Bhutan",value:"Bhutan",selected:!1},{name:"Bolivia",value:"Bolivia",selected:!1},{name:"Bonaire, Sint Eustatius, and Saba",value:"Bonaire, Sint Eustatius, and Saba",selected:!1},{name:"Bosnia and Herzegovina",value:"Bosnia and Herzegovina",selected:!1},{name:"Botswana",value:"Botswana",selected:!1},{name:"Bouvet Island",value:"Bouvet Island",selected:!1},{name:"Brazil",value:"Brazil",selected:!1},{name:"British Indian Ocean Territory",value:"British Indian Ocean Territory",selected:!1},{name:"British Virgin Islands",value:"British Virgin Islands",selected:!1},{name:"Brunei",value:"Brunei",selected:!1},{name:"Bulgaria",value:"Bulgaria",selected:!1},{name:"Burkina Faso",value:"Burkina Faso",selected:!1},{name:"Burma (Myanmar)",value:"Burma (Myanmar)",selected:!1},{name:"Burundi",value:"Burundi",selected:!1},{name:"Cambodia",value:"Cambodia",selected:!1},{name:"Cameroon",value:"Cameroon",selected:!1},{name:"Canada",value:"Canada",selected:!1},{name:"Canton and Enderbury Islands",value:"Canton and Enderbury Islands",selected:!1},{name:"Cape Verde",value:"Cape Verde",selected:!1},{name:"Cayman Islands",value:"Cayman Islands",selected:!1},{name:"Central African Republic",value:"Central African Republic",selected:!1},{name:"Chad",value:"Chad",selected:!1},{name:"Chile",value:"Chile",selected:!1},{name:"China",value:"China",selected:!1},{name:"Christmas Island",value:"Christmas Island",selected:!1},{name:"Cocos (Keeling) Islands",value:"Cocos (Keeling) Islands",selected:!1},{name:"Colombia",value:"Colombia",selected:!1},{name:"Comoros",value:"Comoros",selected:!1},{name:"Congo, Democratic Republic of the",value:"Congo, Democratic Republic of the",selected:!1},{name:"Congo, Republic of the",value:"Congo, Republic of the",selected:!1},{name:"Cook Islands",value:"Cook Islands",selected:!1},{name:"Costa Rica",value:"Costa Rica",selected:!1},{name:"Cote d'Ivoire",value:"Cote d'Ivoire",selected:!1},{name:"Croatia",value:"Croatia",selected:!1},{name:"Cuba",value:"Cuba",selected:!1},{name:"Curacao",value:"Curacao",selected:!1},{name:"Cyprus",value:"Cyprus",selected:!1},{name:"Czech Republic",value:"Czech Republic",selected:!1},{name:"Democratic Yemen",value:"Democratic Yemen",selected:!1},{name:"Denmark",value:"Denmark",selected:!1},{name:"Djibouti",value:"Djibouti",selected:!1},{name:"Dominica",value:"Dominica",selected:!1},{name:"Dominican Republic",value:"Dominican Republic",selected:!1},{name:"Dronning Maud Land",value:"Dronning Maud Land",selected:!1},{name:"East Timor",value:"East Timor",selected:!1},{name:"Ecuador",value:"Ecuador",selected:!1},{name:"Egypt",value:"Egypt",selected:!1},{name:"El Salvador",value:"El Salvador",selected:!1},{name:"Equatorial Guinea",value:"Equatorial Guinea",selected:!1},{name:"Eritrea",value:"Eritrea",selected:!1},{name:"Estonia",value:"Estonia",selected:!1},{name:"Ethiopia",value:"Ethiopia",selected:!1},{name:"Falkland Islands (Islas Malvinas)",value:"Falkland Islands (Islas Malvinas)",selected:!1},{name:"Faroe Islands",value:"Faroe Islands",selected:!1},{name:"Fiji",value:"Fiji",selected:!1},{name:"Finland",value:"Finland",selected:!1},{name:"France",value:"France",selected:!1},{name:"France, Metropolitan",value:"France, Metropolitan",selected:!1},{name:"French Guiana",value:"French Guiana",selected:!1},{name:"French Polynesia",value:"French Polynesia",selected:!1},{name:"Gabon",value:"Gabon",selected:!1},{name:"The Gambia",value:"The Gambia",selected:!1},{name:"Georgia",value:"Georgia",selected:!1},{name:"Georgia Status Neutral Travel Document",value:"Georgia Status Neutral Travel Document",selected:!1},{name:"Germany",value:"Germany",selected:!1},{name:"Ghana",value:"Ghana",selected:!1},{name:"Gibraltar",value:"Gibraltar",selected:!1},{name:"Greece",value:"Greece",selected:!1},{name:"Greenland",value:"Greenland",selected:!1},{name:"Grenada",value:"Grenada",selected:!1},{name:"Guadeloupe",value:"Guadeloupe",selected:!1},{name:"Guam",value:"Guam",selected:!1},{name:"Guatemala",value:"Guatemala",selected:!1},{name:"Guinea",value:"Guinea",selected:!1},{name:"Guinea-Bissau",value:"Guinea-Bissau",selected:!1},{name:"Guyana",value:"Guyana",selected:!1},{name:"Haiti",value:"Haiti",selected:!1},{name:"Heard Island and McDonald Islands",value:"Heard Island and McDonald Islands",selected:!1},{name:"Holy See (Vatican City)",value:"Holy See (Vatican City)",selected:!1},{name:"Honduras",value:"Honduras",selected:!1},{name:"Hong Kong",value:"Hong Kong",selected:!1},{name:"Hungary",value:"Hungary",selected:!1},{name:"Iceland",value:"Iceland",selected:!1},{name:"India",value:"India",selected:!1},{name:"Indonesia",value:"Indonesia",selected:!1},{name:"Iran",value:"Iran",selected:!1},{name:"Iraq",value:"Iraq",selected:!1},{name:"Ireland",value:"Ireland",selected:!1},{name:"Isle of Man",value:"Isle of Man",selected:!1},{name:"Israel",value:"Israel",selected:!1},{name:"Italy",value:"Italy",selected:!1},{name:"Jamaica",value:"Jamaica",selected:!1},{name:"Japan",value:"Japan",selected:!1},{name:"Jordan",value:"Jordan",selected:!1},{name:"Kazakhstan",value:"Kazakhstan",selected:!1},{name:"Kenya",value:"Kenya",selected:!1},{name:"Kiribati",value:"Kiribati",selected:!1},{name:"Korea, North",value:"Korea, North",selected:!1},{name:"Korea, South",value:"Korea, South",selected:!1},{name:"Kosovo",value:"Kosovo",selected:!1},{name:"Kuwait",value:"Kuwait",selected:!1},{name:"Kyrgyzstan",value:"Kyrgyzstan",selected:!1},{name:"Laos",value:"Laos",selected:!1},{name:"Latvia",value:"Latvia",selected:!1},{name:"Lebanon",value:"Lebanon",selected:!1},{name:"Lesotho",value:"Lesotho",selected:!1},{name:"Liberia",value:"Liberia",selected:!1},{name:"Libya",value:"Libya",selected:!1},{name:"Liechtenstein",value:"Liechtenstein",selected:!1},{name:"Lithuania",value:"Lithuania",selected:!1},{name:"Luxembourg",value:"Luxembourg",selected:!1},{name:"Macau",value:"Macau",selected:!1},{name:"Macedonia",value:"Macedonia",selected:!1},{name:"Madagascar",value:"Madagascar",selected:!1},{name:"Malawi",value:"Malawi",selected:!1},{name:"Malaysia",value:"Malaysia",selected:!1},{name:"Maldives",value:"Maldives",selected:!1},{name:"Mali",value:"Mali",selected:!1},{name:"Malta",value:"Malta",selected:!1},{name:"Marshall Islands",value:"Marshall Islands",selected:!1},{name:"Martinique",value:"Martinique",selected:!1},{name:"Mauritania",value:"Mauritania",selected:!1},{name:"Mauritius",value:"Mauritius",selected:!1},{name:"Mayotte",value:"Mayotte",selected:!1},{name:"Mexico",value:"Mexico",selected:!1},{name:"Micronesia, Federated States of",value:"Micronesia, Federated States of",selected:!1},{name:"Moldova",value:"Moldova",selected:!1},{name:"Monaco",value:"Monaco",selected:!1},{name:"Mongolia",value:"Mongolia",selected:!1},{name:"Montenegro",value:"Montenegro",selected:!1},{name:"New Zealand",value:"New Zealand",selected:!1},{name:"Nicaragua",value:"Nicaragua",selected:!1},{name:"Niger",value:"Niger",selected:!1},{name:"Nigeria",value:"Nigeria",selected:!1},{name:"Niue",value:"Niue",selected:!1},{name:"Norfolk Island",value:"Norfolk Island",selected:!1},{name:"Northern Mariana Islands",value:"Northern Mariana Islands",selected:!1},{name:"Norway",value:"Norway",selected:!1},{name:"Oman",value:"Oman",selected:!1},{name:"Pakistan",value:"Pakistan",selected:!1},{name:"Palau",value:"Palau",selected:!1},{name:"Palestine",value:"Palestine",selected:!1},{name:"Panama",value:"Panama",selected:!1},{name:"Papua New Guinea",value:"Papua New Guinea",selected:!1},{name:"Paraguay",value:"Paraguay",selected:!1},{name:"Peru",value:"Peru",selected:!1},{name:"Philippines",value:"Philippines",selected:!1},{name:"Pitcairn Islands",value:"Pitcairn Islands",selected:!1},{name:"Poland",value:"Poland",selected:!1},{name:"Portugal",value:"Portugal",selected:!1},{name:"Puerto Rico",value:"Puerto Rico",selected:!1},{name:"Qatar",value:"Qatar",selected:!1},{name:"Reunion",value:"Reunion",selected:!1},{name:"Romania",value:"Romania",selected:!1},{name:"Russia",value:"Russia",selected:!1},{name:"Rwanda",value:"Rwanda",selected:!1},{name:"Saint Barthelemy",value:"Saint Barthelemy",selected:!1},{name:"Saint Helena",value:"Saint Helena",selected:!1},{name:"Saint Kitts and Nevis",value:"Saint Kitts and Nevis",selected:!1},{name:"Saint Lucia",value:"Saint Lucia",selected:!1},{name:"Saint Martin",value:"Saint Martin",selected:!1},{name:"Saint Pierre and Miquelon",value:"Saint Pierre and Miquelon",selected:!1},{name:"Saint Vincent and the Grenadines",value:"Saint Vincent and the Grenadines",selected:!1},{name:"Samoa",value:"Samoa",selected:!1},{name:"San Marino",value:"San Marino",selected:!1},{name:"Sao Tome and Principe",value:"Sao Tome and Principe",selected:!1},{name:"Saudi Arabia",value:"Saudi Arabia",selected:!1},{name:"Senegal",value:"Senegal",selected:!1},{name:"Serbia",value:"Serbia",selected:!1},{name:"Seychelles",value:"Seychelles",selected:!1},{name:"Sierra Leone",value:"Sierra Leone",selected:!1},{name:"Singapore",value:"Singapore",selected:!1},{name:"Sint Maarten",value:"Sint Maarten",selected:!1},{name:"Slovakia",value:"Slovakia",selected:!1},{name:"Slovenia",value:"Slovenia",selected:!1},{name:"Solomon Islands",value:"Solomon Islands",selected:!1},{name:"Somalia",value:"Somalia",selected:!1},{name:"South Africa",value:"South Africa",selected:!1},{name:"South Sudan",value:"South Sudan",selected:!1},{name:"Spain",value:"Spain",selected:!1},{name:"Sri Lanka",value:"Sri Lanka",selected:!1},{name:"Sudan",value:"Sudan",selected:!1},{name:"Suriname",value:"Suriname",selected:!1},{name:"Svalbard",value:"Svalbard",selected:!1},{name:"Swaziland",value:"Swaziland",selected:!1},{name:"Sweden",value:"Sweden",selected:!1},{name:"Switzerland",value:"Switzerland",selected:!1},{name:"Syria",value:"Syria",selected:!1},{name:"Taiwan",value:"Taiwan",selected:!1},{name:"Tajikistan",value:"Tajikistan",selected:!1},{name:"Tanzania",value:"Tanzania",selected:!1},{name:"Thailand",value:"Thailand",selected:!1},{name:"Timor-Leste",value:"Timor-Leste",selected:!1},{name:"Togo",value:"Togo",selected:!1},{name:"Tokelau",value:"Tokelau",selected:!1},{name:"Tonga",value:"Tonga",selected:!1},{name:"Trinidad and Tobago",value:"Trinidad and Tobago",selected:!1},{name:"Tunisia",value:"Tunisia",selected:!1},{name:"Turkey",value:"Turkey",selected:!1},{name:"Turkmenistan",value:"Turkmenistan",selected:!1},{name:"Turks and Caicos Islands",value:"Turks and Caicos Islands",selected:!1},{name:"Tuvalu",value:"Tuvalu",selected:!1},{name:"Uganda",value:"Uganda",selected:!1},{name:"Ukraine",value:"Ukraine",selected:!1},{name:"United Arab Emirates",value:"United Arab Emirates",selected:!1},{name:"United Kingdom",value:"United Kingdom",selected:!1},{name:"United States",value:"United States",selected:!1},{name:"United Kingdom",value:"United Kingdom",selected:!1},{name:"United States",value:"United States",selected:!1},{name:"United States Minor Outlying Islands",value:"United States Minor Outlying Islands",selected:!1},{name:"United States Minor Outlying Islands",value:"United States Minor Outlying Islands",selected:!1},{name:"Uruguay",value:"Uruguay",selected:!1},{name:"Uruguay",value:"Uruguay",selected:!1},{name:"Uzbekistan",value:"Uzbekistan",selected:!1},{name:"Vanuatu",value:"Vanuatu",selected:!1},{name:"Venezuela",value:"Venezuela",selected:!1},{name:"Vietnam",value:"Vietnam",selected:!1},{name:"Virgin Islands",value:"Virgin Islands",selected:!1},{name:"Wake Island",value:"Wake Island",selected:!1},{name:"Wallis and Futuna",value:"Wallis and Futuna",selected:!1},{name:"Western Sahara",value:"Western Sahara",selected:!1},{name:"Yemen",value:"Yemen",selected:!1},{name:"Zaire",value:"Zaire",selected:!1},{name:"Zambia",value:"Zambia",selected:!1},{name:"Zimbabwe",value:"Zimbabwe",selected:!1}],ft.STATES=[{name:"AL",value:"AL",selected:!1},{name:"AK",value:"AK",selected:!1},{name:"AZ",value:"AZ",selected:!1},{name:"AR",value:"AR",selected:!1},{name:"CA",value:"CA",selected:!1},{name:"CO",value:"CO",selected:!1},{name:"CT",value:"CT",selected:!1},{name:"DE",value:"DE",selected:!1},{name:"FL",value:"FL",selected:!1},{name:"GA",value:"GA",selected:!1},{name:"HI",value:"HI",selected:!1},{name:"ID",value:"ID",selected:!1},{name:"IL",value:"IL",selected:!1},{name:"IN",value:"IN",selected:!1},{name:"IA",value:"IA",selected:!1},{name:"KS",value:"KS",selected:!1},{name:"KY",value:"KY",selected:!1},{name:"LA",value:"LA",selected:!1},{name:"ME",value:"ME",selected:!1},{name:"MD",value:"MD",selected:!1},{name:"MA",value:"MA",selected:!1},{name:"MI",value:"MI",selected:!1},{name:"MN",value:"MN",selected:!1},{name:"MS",value:"MS",selected:!1},{name:"MO",value:"MO",selected:!1},{name:"MT",value:"MT",selected:!1},{name:"NE",value:"NE",selected:!1},{name:"NV",value:"NV",selected:!1},{name:"NH",value:"NH",selected:!1},{name:"NJ",value:"NJ",selected:!1},{name:"NM",value:"NM",selected:!1},{name:"NY",value:"NY",selected:!1},{name:"NC",value:"NC",selected:!1},{name:"ND",value:"ND",selected:!1},{name:"OH",value:"OH",selected:!1},{name:"OK",value:"OK",selected:!1},{name:"OR",value:"OR",selected:!1},{name:"PA",value:"PA",selected:!1},{name:"RI",value:"RI",selected:!1},{name:"SC",value:"SC",selected:!1},{name:"SD",value:"SD",selected:!1},{name:"TN",value:"TN",selected:!1},{name:"TX",value:"TX",selected:!1},{name:"UT",value:"UT",selected:!1},{name:"VT",value:"VT",selected:!1},{name:"VA",value:"VA",selected:!1},{name:"WA",value:"WA",selected:!1},{name:"WV",value:"WV",selected:!1},{name:"WI",value:"WI",selected:!1},{name:"WY",value:"WY",selected:!1}];var pt={name:"pf-address",data:function(){return{idP:"",countries:ft.COUNTRIES,messageAccordion:"Show More...",isShow:!1}},mixins:[ht],props:{previous:{type:Boolean,default:!1}},components:{PfRadio:P,PfCheckbox:x,PfSelect:k,PfPopUp:$},created:function(){!0===this.previous&&(this.idP="previous")},mounted:function(){this.messageModal="Are you really sure delete this address?",void 0!==this.information&&!0===this.information.newItem&&void 0!==this.information.state&&(this.information.state=this.states[0].value,this.information.country=this.countries[0].value)},methods:{setState:function(t){this.information.state=t,this.updateAddress(""!==this.indexItem?"addressState"+this.indexItem+this.idP:"addressState"+this.index+this.idP)},setCountry:function(t){this.information.country=t,this.updateAddress(""!==this.indexItem?"addressCountry"+this.indexItem+this.idP:"addressCountry"+this.index+this.idP)},deleteAddress:function(){this.deleteItem({model:"previous"===this.idP?"previousAddresses":"addresses",item:"delete-address"}),this.isPopUp=!1},updateAddress:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editAddress(this.information).then(function(n){var i=document.getElementById(t),a="updated";void 0!==n&&n.addressEdit?n.addressEdit&&(a="updated"):a="error",e.setFlash({el:i,action:a})}))},changeRadio:function(t){var e=this;this.information.isAptSteFlr=t.type;var n=this.information;Y()(this.radioGroups).forEach(function(i){-1!==e.radioGroups[i].indexOf(t.keyThree)&&e.radioGroups[i].forEach(function(i){i!==t.keyThree?(n[i]="off",!0===e.comparing&&(n.threeValues[i].manual="off")):(n[i]="on",!0===e.comparing&&(n.threeValues[i].manual="on"))})}),this.information={},this.information=n,this.updateModel({model:t.model,field:t.key,value:t.type,id:t.id})},setTypeAddress:function(t){("isPrimary"===t.key&&"on"===t.type||"isMailing"===t.key&&"on"===t.type||"isForeing"===t.key&&"on"===t.type)&&this.$emit("settypeaddress",t),this.information[t.key]=t.type},changeCheckbox:function(t){this.information[t.key]=t.type,this.setTypeAddress(t),this.updateModel({model:"previous"===this.idP?"previousAddresses":"addresses",field:t.key,value:t.type,id:t.id})},changeCalendarAddress:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateAddress(t.id)}},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},_t={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("address")},mouseleave:function(e){return t.removeHover("address")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:!1===t.previous?"addressForm"+t.index:"prevAddressForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"address"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Dates":"Address")+" ")])])]),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{id:""!==t.indexItem?"addressAddressp-hide"+t.indexItem+t.idP:"addressAddressp-hide"+t.index+t.idP,name:""!==t.indexItem?"addressAddressp-hide"+t.indexItem+t.idP:"addressAddressp-hide"+t.index+t.idP,label:"Address:",validate:"required",labelStyle:!0===t.information.newItem?"color:red;":"",readonly:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.address?t.information.class.address:""},on:{change:function(e){return t.updateModel({model:"previous"===t.idP?"previousAddresses":"addresses",field:"address",value:t.information.address,id:""!==t.indexItem?"addressAddressp-hide"+t.indexItem+t.idP:"addressAddressp-hide"+t.index+t.idP})}},model:{value:t.information.address,callback:function(e){t.$set(t.information,"address",e)},expression:"information.address"}})],1),t._v(" "),"previous"!==t.idP?n("div",{staticClass:"col-md-4 mb-1"},[n("div",{staticClass:"form-group marginBotZero mb-1"},[n("label",{staticClass:"w-100",attrs:{for:"currentSp"}},[t._v("Type:")]),t._v(" "),n("div",{staticClass:"checkbox form-check form-check-inline"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.isPrimary?t.information.class.isPrimary:"",checked:"on"===t.information.isPrimary,readonly:t.readonly,id:void 0!==t.index?"isPrimary"+t.index+t.idP:"isPrimary"+t.indexItem+t.idP,label:"Physical",logo:"fas fa-map-marker"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.isPrimary,fieldId:"isPrimary",type:"previous"===t.idP?"previousAddresses":"addresses",id:void 0!==t.index?"isPrimary"+t.index+t.idP:"isPrimary"+t.indexItem+t.idP})},click:function(e){return t.changeCheckbox({type:"on"===t.information.isPrimary?"off":"on",id:void 0!==t.index?"isPrimary"+t.index+t.idP:"isPrimary"+t.indexItem+t.idP,key:"isPrimary"})}}})],1),t._v(" "),n("div",{staticClass:"checkbox form-check form-check-inline"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.isMailing?t.information.class.isMailing:"",checked:"on"===t.information.isMailing,readonly:t.readonly,id:void 0!==t.index?"isMailing"+t.index+t.idP:"isMailing"+t.indexItem+t.idP,label:"Mailing",logo:"fas fa-truck"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.isForeing,fieldId:"isMailing",type:"previous"===t.idP?"previousAddresses":"addresses",id:void 0!==t.index?"isMailing"+t.index+t.idP:"isMailing"+t.indexItem+t.idP})},click:function(e){return t.changeCheckbox({type:"on"===t.information.isMailing?"off":"on",id:void 0!==t.index?"isMailing"+t.index+t.idP:"isMailing"+t.indexItem+t.idP,key:"isMailing"})}}})],1),t._v(" "),n("div",{staticClass:"checkbox form-check form-check-inline"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.isForeing?t.information.class.isForeing:"",checked:"on"===t.information.isForeing,readonly:t.readonly,id:void 0!==t.index?"isForeing"+t.index+t.idP:"isForeing"+t.indexItem+t.idP,label:"Foreign",logo:"fas fa-globe"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.isForeing,fieldId:"isForeing",type:"previous"===t.idP?"previousAddresses":"addresses",id:void 0!==t.index?"isForeing"+t.index+t.idP:"isForeing"+t.indexItem+t.idP})},click:function(e){return t.changeCheckbox({type:"on"===t.information.isForeing?"off":"on",id:void 0!==t.index?"isForeing"+t.index+t.idP:"isForeing"+t.indexItem+t.idP,key:"isForeing"})}}})],1)])]):t._e(),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.liveFrom?t.information.class.liveFrom:"",readonly:t.readonly,label:"Lived From:",id:""!==t.indexItem?"liveFrom-"+t.indexItem+t.idP:"liveFrom-"+t.index+t.idP,mask:"##/##/####",divCalendar:"marginBotZero",model:"previous"===t.idP?"previousAddresses":"addresses",field:"liveFrom"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.liveFrom,fieldId:"liveFrom",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"input-liveFrom-"+t.indexItem+t.idP:"input-liveFrom-"+t.index+t.idP})},change:t.changeCalendar},model:{value:t.information.liveFrom,callback:function(e){t.$set(t.information,"liveFrom",e)},expression:"information.liveFrom"}})],1),t._v(" "),"previous"===t.idP?n("div",{staticClass:"col-md-4 spaceShowMore"},[!0===t.previous?n("pf-calendar",{attrs:{validate:"required",classElement:void 0===t.information.class?"":void 0!==t.information.class.liveTo?t.information.class.liveTo:"",readonly:t.readonly,label:"Lived To:",labelStyle:!0===t.information.newItem?"color:red;":"",id:void 0!==t.index?"liveTo-"+t.index+t.idP:"liveTo-"+t.indexItem+t.idP,mask:"##/##/####",divCalendar:"marginBotZero",name:void 0!==t.index?"input-liveTo-"+t.index+t.idP:"input-liveTo-"+t.indexItem+t.idP,model:"previous"===t.idP?"previousAddresses":"addresses",field:"liveTo"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.liveTo,fieldId:"liveTo",type:"previous"===t.idP?"previousAddresses":"addresses",id:void 0!==t.index?"input-liveTo-"+t.index+t.idP:"input-liveTo-"+t.indexItem+t.idP})},change:t.changeCalendar},model:{value:t.information.liveTo,callback:function(e){t.$set(t.information,"liveTo",e)},expression:"information.liveTo"}}):n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.liveTo?t.information.class.liveTo:"",readonly:!0,label:"Lived To:",id:void 0!==t.index?"liveTo-"+t.index+t.idP:"liveTo-"+t.indexItem+t.idP,mask:"##/##/####",divCalendar:"marginBotZero",model:"previous"===t.idP?"previousAddresses":"addresses",field:"liveTo"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.liveTo,fieldId:"liveTo",type:"previous"===t.idP?"previousAddresses":"addresses",id:void 0!==t.index?"input-liveTo-"+t.index+t.idP:"input-liveTo-"+t.indexItem+t.idP})},change:t.changeCalendar},model:{value:t.information.liveTo,callback:function(e){t.$set(t.information,"liveTo",e)},expression:"information.liveTo"}})],1):t._e()]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionAddress"+t.indexItem+t.idP:"#accordionAddress"+t.index+t.idP},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionAddress"+t.indexItem+t.idP:"#accordionAddress"+t.index+t.idP}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeletedNoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"addressInCareOf"+t.indexItem+t.idP:"addressInCareOf"+t.index+t.idP,label:"In care of:",readonly:t.readonly,classElement:"select-jona"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.inCareOf,fieldId:"inCareOf",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"addressInCareOf"+t.indexItem+t.idP:"addressInCareOf"+t.index+t.idP})},change:function(e){return t.updateModel({model:"previous"===t.idP?"previousAddresses":"addresses",field:"inCareOf",value:t.information.inCareOf,id:""!==t.indexItem?"addressInCareOf"+t.indexItem+t.idP:"addressInCareOf"+t.index+t.idP})}},model:{value:t.information.inCareOf,callback:function(e){t.$set(t.information,"inCareOf",e)},expression:"information.inCareOf"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"addressAddress"+t.indexItem+t.idP:"addressAddress"+t.index+t.idP,name:""!==t.indexItem?"addressAddress"+t.indexItem+t.idP:"addressAddress"+t.index+t.idP,label:"Address:",validate:"required",labelStyle:!0===t.information.newItem?"color:red;":"",readonly:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.address?t.information.class.address:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.address,fieldId:"address",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"addressAddress"+t.indexItem+t.idP:"addressAddress"+t.index+t.idP})},change:function(e){return t.updateModel({model:"previous"===t.idP?"previousAddresses":"addresses",field:"address",value:t.information.address,id:""!==t.indexItem?"addressAddress"+t.indexItem+t.idP:"addressAddress"+t.index+t.idP})}},model:{value:t.information.address,callback:function(e){t.$set(t.information,"address",e)},expression:"information.address"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("div",{staticClass:"form-check form-check-inline marginBotRem"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.apt?t.information.class.apt:"",checked:"on"===t.information.apt,readonly:t.readonly,label:"APT",name:"inlineRadioOptions"+t.indexItem,id:""!==t.indexItem?"apt"+t.indexItem+t.idP:"apt"+t.index+t.idP,value:"apt"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.apt,fieldId:"apt",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"apt"+t.indexItem+t.idP:"apt"+t.index+t.idP})},click:function(e){return t.changeRadio({type:"APT",id:""!==t.indexItem?"apt"+t.indexItem+t.idP:"apt"+t.index+t.idP,key:"isAptSteFlr",model:"previous"===t.idP?"previousAddresses":"addresses",keyThree:"apt"})}}})],1),t._v(" "),n("div",{staticClass:"form-check form-check-inline"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.ste?t.information.class.ste:"",checked:"on"===t.information.ste,readonly:t.readonly,label:"STE",name:"inlineRadioOptions"+t.indexItem,id:""!==t.indexItem?"ste"+t.indexItem+t.idP:"ste"+t.index+t.idP,value:"ste"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.ste,fieldId:"ste",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"ste"+t.indexItem+t.idP:"ste"+t.index+t.idP})},click:function(e){return t.changeRadio({type:"STE",id:""!==t.indexItem?"ste"+t.indexItem+t.idP:"ste"+t.index+t.idP,key:"isAptSteFlr",model:"previous"===t.idP?"previousAddresses":"addresses",keyThree:"ste"})}}})],1),t._v(" "),n("div",{staticClass:"form-check form-check-inline"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.flr?t.information.class.flr:"",checked:"on"===t.information.flr,readonly:t.readonly,label:"FLOOR",name:"inlineRadioOptions"+t.indexItem,id:""!==t.indexItem?"flr"+t.indexItem+t.idP:"flr"+t.index+t.idP,value:"flr"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.flr,fieldId:"flr",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"flr"+t.indexItem+t.idP:"flr"+t.index+t.idP})},click:function(e){return t.changeRadio({type:"FLR",id:""!==t.indexItem?"flr"+t.indexItem+t.idP:"flr"+t.index+t.idP,key:"isAptSteFlr",model:"previous"===t.idP?"previousAddresses":"addresses",keyThree:"flr"})}}})],1),t._v(" "),n("pf-input",{attrs:{id:""!==t.indexItem?"addressAptSteFlrNumbertxt"+t.indexItem+t.idP:"addressAptSteFlrNumbertxt"+t.index+t.idP,readonly:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.aptSteFlrNumbertxt?t.information.class.aptSteFlrNumbertxt:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.aptSteFlrNumbertxt,fieldId:"aptSteFlrNumbertxt",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"addressAptSteFlrNumbertxt"+t.indexItem+t.idP:"addressAptSteFlrNumbertxt"+t.index+t.idP})},change:function(e){return t.updateModel({model:"previous"===t.idP?"previousAddresses":"addresses",field:"aptSteFlrNumbertxt",value:t.information.aptSteFlrNumbertxt,id:""!==t.indexItem?"addressAptSteFlrNumbertxt"+t.indexItem+t.idP:"addressAptSteFlrNumbertxt"+t.index+t.idP})}},model:{value:t.information.aptSteFlrNumbertxt,callback:function(e){t.$set(t.information,"aptSteFlrNumbertxt",e)},expression:"information.aptSteFlrNumbertxt"}})],1)])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"addressCity"+t.indexItem+t.idP:"addressCity"+t.index+t.idP,name:""!==t.indexItem?"addressCity"+t.indexItem+t.idP:"addressCity"+t.index+t.idP,validate:"required",label:"City:",labelStyle:!0===t.information.newItem?"color:red;":"",readonly:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.city?t.information.class.city:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.city,fieldId:"city",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"addressCity"+t.indexItem+t.idP:"addressCity"+t.index+t.idP})},change:function(e){return t.updateModel({model:"previous"===t.idP?"previousAddresses":"addresses",field:"city",value:t.information.city,id:""!==t.indexItem?"addressCity"+t.indexItem+t.idP:"addressCity"+t.index+t.idP})}},model:{value:t.information.city,callback:function(e){t.$set(t.information,"city",e)},expression:"information.city"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{translate:"no",field:"state",id:""!==t.indexItem?"addressState"+t.indexItem+t.idP:"addressState"+t.index+t.idP,model:"previous"===t.idP?"previousAddresses":"addresses",label:"State:",disabled:t.readonly,classElement:"select-jona",value:"Select State",options:[{name:"AL",value:"AL",selected:void 0!==this.information&&"AL"===this.information.state},{name:"AK",value:"AK",selected:void 0!==this.information&&"AK"===this.information.state},{name:"AZ",value:"AZ",selected:void 0!==this.information&&"AZ"===this.information.state},{name:"AR",value:"AR",selected:void 0!==this.information&&"AR"===this.information.state},{name:"CA",value:"CA",selected:void 0!==this.information&&"CA"===this.information.state},{name:"CO",value:"CO",selected:void 0!==this.information&&"CO"===this.information.state},{name:"CT",value:"CT",selected:void 0!==this.information&&"CT"===this.information.state},{name:"DE",value:"DE",selected:void 0!==this.information&&"DE"===this.information.state},{name:"FL",value:"FL",selected:void 0!==this.information&&"FL"===this.information.state},{name:"GA",value:"GA",selected:void 0!==this.information&&"GA"===this.information.state},{name:"HI",value:"HI",selected:void 0!==this.information&&"HI"===this.information.state},{name:"ID",value:"ID",selected:void 0!==this.information&&"ID"===this.information.state},{name:"IL",value:"IL",selected:void 0!==this.information&&"IL"===this.information.state},{name:"IN",value:"IN",selected:void 0!==this.information&&"IN"===this.information.state},{name:"IA",value:"IA",selected:void 0!==this.information&&"IA"===this.information.state},{name:"KS",value:"KS",selected:void 0!==this.information&&"KS"===this.information.state},{name:"KY",value:"KY",selected:void 0!==this.information&&"KY"===this.information.state},{name:"LA",value:"LA",selected:void 0!==this.information&&"LA"===this.information.state},{name:"ME",value:"ME",selected:void 0!==this.information&&"ME"===this.information.state},{name:"MD",value:"MD",selected:void 0!==this.information&&"MD"===this.information.state},{name:"MA",value:"MA",selected:void 0!==this.information&&"MA"===this.information.state},{name:"MI",value:"MI",selected:void 0!==this.information&&"MI"===this.information.state},{name:"MN",value:"MN",selected:void 0!==this.information&&"MN"===this.information.state},{name:"MS",value:"MS",selected:void 0!==this.information&&"MS"===this.information.state},{name:"MO",value:"MO",selected:void 0!==this.information&&"MO"===this.information.state},{name:"MT",value:"MT",selected:void 0!==this.information&&"MT"===this.information.state},{name:"NE",value:"NE",selected:void 0!==this.information&&"NE"===this.information.state},{name:"NV",value:"NV",selected:void 0!==this.information&&"NV"===this.information.state},{name:"NH",value:"NH",selected:void 0!==this.information&&"NH"===this.information.state},{name:"NJ",value:"NJ",selected:void 0!==this.information&&"NJ"===this.information.state},{name:"NM",value:"NM",selected:void 0!==this.information&&"NM"===this.information.state},{name:"NY",value:"NY",selected:void 0!==this.information&&"NY"===this.information.state},{name:"NC",value:"NC",selected:void 0!==this.information&&"NC"===this.information.state},{name:"ND",value:"ND",selected:void 0!==this.information&&"ND"===this.information.state},{name:"OH",value:"OH",selected:void 0!==this.information&&"OH"===this.information.state},{name:"OK",value:"OK",selected:void 0!==this.information&&"OK"===this.information.state},{name:"OR",value:"OR",selected:void 0!==this.information&&"OR"===this.information.state},{name:"PA",value:"PA",selected:void 0!==this.information&&"PA"===this.information.state},{name:"RI",value:"RI",selected:void 0!==this.information&&"RI"===this.information.state},{name:"SC",value:"SC",selected:void 0!==this.information&&"SC"===this.information.state},{name:"SD",value:"SD",selected:void 0!==this.information&&"SD"===this.information.state},{name:"TN",value:"TN",selected:void 0!==this.information&&"TN"===this.information.state},{name:"TX",value:"TX",selected:void 0!==this.information&&"TX"===this.information.state},{name:"UT",value:"UT",selected:void 0!==this.information&&"UT"===this.information.state},{name:"VT",value:"VT",selected:void 0!==this.information&&"VT"===this.information.state},{name:"VA",value:"VA",selected:void 0!==this.information&&"VA"===this.information.state},{name:"WA",value:"WA",selected:void 0!==this.information&&"WA"===this.information.state},{name:"WV",value:"WV",selected:void 0!==this.information&&"WV"===this.information.state},{name:"WI",value:"WI",selected:void 0!==this.information&&"WI"===this.information.state},{name:"WY",value:"WY",selected:void 0!==this.information&&"WY"===this.information.state}]},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.state,fieldId:"state",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"addressState"+t.indexItem+t.idP:"addressState"+t.index+t.idP})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"addressZipCode"+t.indexItem+t.idP:"addressZipCode"+t.index+t.idP,label:"ZIP Code:",readonly:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.zipCode?t.information.class.zipCode:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.zipCode,fieldId:"zipCode",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"addressZipCode"+t.indexItem+t.idP:"addressZipCode"+t.index+t.idP})},change:function(e){return t.updateModel({model:"previous"===t.idP?"previousAddresses":"addresses",field:"zipCode",value:t.information.zipCode,id:""!==t.indexItem?"addressZipCode"+t.indexItem+t.idP:"addressZipCode"+t.index+t.idP})}},model:{value:t.information.zipCode,callback:function(e){t.$set(t.information,"zipCode",e)},expression:"information.zipCode"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeletedNoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"country",id:""!==t.indexItem?"addressCountry"+t.indexItem+t.idP:"addressCountry"+t.index+t.idP,model:"previous"===t.idP?"previousAddresses":"addresses",label:"Country:",disabled:t.readonly,classElement:"select-jona",value:"Select Country",options:t.countries},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.country,fieldId:"country",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"addressCountry"+t.indexItem+t.idP:"addressCountry"+t.index+t.idP})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"addressForeingProvince"+t.indexItem+t.idP:"addressForeingProvince"+t.index+t.idP,label:"Foreign Province:",readonly:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.foreignProvince?t.information.class.foreignProvince:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.foreignProvince,fieldId:"foreignProvince",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"addressForeingProvince"+t.indexItem+t.idP:"addressForeingProvince"+t.index+t.idP})},change:function(e){return t.updateModel({model:"previous"===t.idP?"previousAddresses":"addresses",field:"foreignProvince",value:t.information.foreignProvince,id:""!==t.indexItem?"addressForeingProvince"+t.indexItem+t.idP:"addressForeingProvince"+t.index+t.idP})}},model:{value:t.information.foreignProvince,callback:function(e){t.$set(t.information,"foreignProvince",e)},expression:"information.foreignProvince"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"addressPostalCode"+t.indexItem+t.idP:"addressPostalCode"+t.index+t.idP,label:"Postal Code:",readonly:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.postalCode?t.information.class.postalCode:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.postalCode,fieldId:"postalCode",type:"previous"===t.idP?"previousAddresses":"addresses",id:""!==t.indexItem?"addressPostalCode"+t.indexItem+t.idP:"addressPostalCode"+t.index+t.idP})},change:function(e){return t.updateModel({model:"previous"===t.idP?"previousAddresses":"addresses",field:"postalCode",value:t.information.postalCode,id:""!==t.indexItem?"addressPostalCode"+t.indexItem+t.idP:"addressPostalCode"+t.index+t.idP})}},model:{value:t.information.postalCode,callback:function(e){t.$set(t.information,"postalCode",e)},expression:"information.postalCode"}})],1),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit(!1===t.previous?"addressForm"+t.index:"prevAddressForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this address?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteAddress}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. Address")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. International")])])}]};var At,bt,xt,gt=n("VU/8")(pt,_t,!1,function(t){n("l7WR"),n("WLM9"),n("2v89")},"data-v-3638aff0",null).exports,vt=n("gRE1"),Ct=n.n(vt),yt=n("mtWM"),wt=n.n(yt),Bt=n("mw3O"),kt=n.n(Bt),Et=this,It=window.primaApiUrl,Dt=window.graphApiUrl,St=Dt+"oauth2",Nt=Dt+"graphql",Mt=Dt+"querys",Ot={};Ot.refreshTokenDb=function(t){var e={grant_type:"refresh_token",refresh_token:t.refreshToken,client_id:t.clientId},n=wt.a.create({headers:{"Access-Control-Allow-Origin":"*","Content-Type":"application/x-www-form-urlencoded"}});return e=kt.a.stringify(e),n.post(St+"token",e).then(function(t){return t.data}).catch(function(t){return t})},Ot.getContact=function(t){return wt.a.create({headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*","Content-Type":"application/x-www-form-urlencoded"}}).get(It+"contacts/"+t.contactId).then(function(t){return t.data}).catch(function(t){return t})},Ot.getGraphContact=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          getContact: contacts(search:{filter: [{field: "+t.field+", value: "+t.value+"}]}) {\n            id\n            firstName\n            lastName\n            middleName\n            email\n            createdById\n            birthDate\n            notifications\n            potencialClient\n            createdAt\n            updatedAt\n            subcontactId\n            fullName\n            picture\n            isSubcontact\n            othersNamesUsed\n            socialSecurityNumber\n            alienNumber\n            pobCity\n            pobState\n            pobCountry\n            marriageDate\n            marriagePlace\n            spouseFirstName\n            spouseLastName\n            spouseDob\n            spousePlaceOfBirth\n            spouseSocialSecurityNumber\n            spouseAlien\n            spouseOthersNames\n            i94\n            passportNumber\n            passportCountry\n            currentImmigrationStatus\n            maritalStatus\n            placeOfLastEntryToUs\n            dateOfLastEntryToUs\n            citizenship\n            crExp\n            lprExp\n            maritalStatusMarried\n            maritalStatusSingle\n            maritalStatusDivorced\n            maritalStatusWidow\n            elis\n            nvcDosCaseNum\n            sexMale\n            sexFemale\n            companyName\n            pdFamilyPetitionDate\n            pdFamilyPetitionCountry\n            pdFamilyPetitionCategory\n            pdEmploymentDate\n            pdEmploymentPetitionCountry\n            pdEmploymentPetitionCategory\n            pbRemoveFromReport\n            dropboxFolder\n            relationship\n            relatedContactId\n            occupation\n            salutation\n            driverLicence\n            nationality\n            clanTribeName\n            nativeLangName\n            active\n            i94passport\n            i94passportCountry\n            i94Number\n            i94arrivalDate\n            i94admitUntil\n            i94classOfAdmission\n            companyIrsTaxId\n            companyBusinessType\n            companyNaics\n            companyYearEstablished\n            companyTotalNumberEmployees\n            companyUsNumberEmployees\n            companyGrossAnnualIncome\n            companyNetAnnualIncome\n            isCompany\n            companyDateStabilised\n            companyDolEtaCaseNumber\n            companyLaborCertFilingDate\n            companyLaborCertExpirationDate\n            separated\n            annulled\n            itin\n            otherFirst1\n            otherMiddle1\n            otherLast1\n            otherFirst2\n            otherMiddle2\n            otherLast2\n            firstNameNativeAlpha\n            lastNameNativeAlpha\n            middleNameNativeAlpha\n            hisp\n            nothisp\n            white\n            asian\n            black\n            amind\n            hawaii\n            heightFt\n            heightIn\n            weight1\n            weightFull\n            weight2\n            weight3\n            eyeBlack\n            eyeGray\n            eyeMaroon\n            eyeBlue\n            eyeGreen\n            eyePink\n            eyeBrown\n            eyeHazel\n            eyeUnk\n            hairBald\n            hairBrown\n            hairSandy\n            hairBlack\n            hairGray\n            hairWhite\n            hairBlond\n            hairRed\n            hairUnk\n            uscYes\n            uscNo\n            lprYes\n            lprNo\n            uscNat\n            uscBirth\n            uscParents\n            maritalStatusAnnulled\n            maritalStatusSeparated\n            numberOfMarriages\n            clientPortalLanguage\n            allowShowCaseDocument\n            classAdmissionLpr\n            dateAdmissionLpr\n            otherFirst3\n            otherLast3\n            otherMiddle3\n            userId\n            phones {\n              id\n              name\n              number\n              annotation\n              availableAt\n              type\n              activeType\n              countryAreaCode\n              ext\n              iswork\n              ishome\n              ismobile\n              isfax\n              ispager\n              isskype\n              isother\n              createdAt\n              updatedAt\n              userId\n              objectId\n            }\n            address {\n              id\n              name\n              address\n              line2\n              apt\n              ste\n              flr\n              aptSteFlrNumbertxt\n              isForeing\n              isMailing\n              isPrimary\n              isCurrent\n              liveFrom\n              liveTo\n              order\n              city\n              state\n              country\n              zipCode\n              inCareOf\n              createdAt\n              updatedAt\n              foreignProvince\n              postalCode\n            }\n            cases {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n              area\n              caseStatusId\n              createdAt\n              updatedAt\n              beneficiaryId\n              practiceAreaId\n              paymentTypeId\n              recieptNumber\n              dropboxFolder\n              attorneyId\n              attorneyType\n              plantiffId\n              plantiffType\n              fillingId\n              fillingType\n              courtId\n              number\n              matterOf\n              filingDate\n              defendantType\n              defendantId\n              judgeId\n              plantiffClient\n              defendantClient\n              prosecutorId\n              fcourtId\n              expire\n              assistant1\n              assistant2\n              secondaryAttorney\n              retainerAmount\n              amountPaidToday\n              attorneyHourlyRate\n              paralegalHourlyRate\n              payEveryXDays\n              firstPaymentDay\n              lastPaymentDay\n              fileCopyAmount\n              completeGoalDate\n              userId\n              regularPaymentAmount\n              numberOfPayments\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getPackageAssembly=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query caseQuery {\n\n          cases(id: "+t.caseId+") {\n            packages {\n              _id\n              caseId\n              storageName\n              file\n              createdAt\n              updatedAt\n              status\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deletePackageAssembly=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        mutation deletePackageMutation {\n\n          packageDelete(_id: "'+t.packageId+'") {\n            _id\n            caseId\n            package\n            createdAt\n            updatedAt\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.downloadPackageAssembly=function(t){window.open(Dt+"download/package/"+t.packageId+"?token="+t.token).then(function(t){return t})},Ot.graphForms=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n      query formQuery {\n  \n        forms(primaId: "+t.primaId+") {\n          _id\n          name\n          primaId\n          viewer_url\n          font {\n            size\n          }\n          casesFormsData {\n            id\n            formId\n            field\n            value\n            model\n            fieldType\n          }\n          templates {\n            _id\n            name\n            checkboxGroups\n            chGroups\n            pages\n          }\n        }\n        models {\n          _id\n          type\n          prefix\n          field\n          route\n        }\n        casesForms(id: "+t.primaId+") {\n          reverseAutofillEnable\n        }\n      }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.graphFormList=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query formList {\n          forms {\n            _id\n            name\n            primaId\n            title\n            revisionDate\n            expirationDate\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.graphFormListPA=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query formList {\n          forms(\n            practiceArea: "'+t.practiceArea+'"\n            section: "'+t.section+'"\n            status: "enabled"\n          ) {\n            _id\n            name\n            primaId\n            title\n            revisionDate\n            expirationDate\n            status\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.graphFormListNT=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query formList {\n          forms(\n            nameTitle: "'+t.nameTitle+'"\n            practiceArea: "'+t.practiceArea+'"\n            status: "enabled"\n          ) {\n            _id\n            name\n            primaId\n            title\n            revisionDate\n            expirationDate\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getContactsRelationed=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query contactsRelations {\n    \n          contactsRelationed(contactId: "+t.contactId+") {\n            id\n            contactId\n            relatedContactId\n            relation\n            userId\n            createdAt\n            updatedAt\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.graphCaseForms=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query formQuery {\n          casesForms(caseId: "+t.caseId+") {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            revisionDate\n            expireDate\n            properties\n            fields\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n            flag\n            order\n            form {\n              properties\n              status\n              revisionDate\n              expirationDate\n              practiceArea\n            }\n            clientPortal\n            isNa\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getAllPracticeArea=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query practiceAreaQuery {\n\n          practiceArea {\n            id\n            name\n            sections\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getPracticeAreaId=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query practiceAreaIdQuery {\n\n          practiceAreas(primaId: "+t.practiceAreaId+") {\n            _id\n            primaId\n            name\n            sections\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getRoleList=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query rolesQuery {\n    \n          roles {\n            _id\n            name\n            type\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.graphCaseFormForId=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query formQuery {\n    \n          casesForms(_id: "'+t.caseFormId+'") {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            revisionDate\n            expireDate\n            properties\n            fields\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n            flag\n            order\n            form {\n              properties\n              revisionDate\n              status\n              expirationDate\n              practiceArea\n            }\n            clientPortal\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.insertCaseForm=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation insertCaseForm($caseId: Int!, $formId: String!, $order: Int) {\n          caseFormAdd(newCaseForm: {\n            caseId: $caseId\n            formId: $formId\n            order: $order\n          })\n          {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            revisionDate\n            expireDate\n            properties\n            fields\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n            order\n            form {\n              properties\n              revisionDate\n              status\n              expirationDate\n              practiceArea\n            }\n            clientPortal\n          }\n        }\n      ",variables:{caseId:t.caseId,formId:t.formId,order:t.order}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.autofillCaseForm=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation autofillCaseForm($caseFormId: String!) {\n          caseFormAutofill(caseFormId: $caseFormId) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            revisionDate\n            expireDate\n            properties\n            fields\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n            order\n            form {\n              properties\n              revisionDate\n              status\n              expirationDate\n              practiceArea\n            }\n            clientPortal\n          }\n        }\n      ",variables:{caseFormId:t.caseFormId}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.setRolCaseForm=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation setRolCaseForm($caseFormId: String!, $role: String!, $contactId: Int!) {\n          caseFormAssignRole(assignRole: {\n            caseFormId: $caseFormId\n            role: $role\n            contactId: $contactId\n          }\n          ) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            revisionDate\n            expireDate\n            properties\n            fields\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n            order\n            form {\n              properties\n              revisionDate\n              status\n              expirationDate\n              practiceArea\n            }\n            clientPortal\n          }\n        }\n      ",variables:{caseFormId:t.caseFormId,role:t.role,contactId:t.contactId}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteCaseForm=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteCaseForm($_id: String!) {\n          caseFormDelete(_id: $_id\n          ) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            revisionDate\n            expireDate\n            properties\n            fields\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n            order\n            form {\n              properties\n              revisionDate\n              status\n              expirationDate\n              practiceArea\n            }\n            clientPortal\n          }\n        }\n      ",variables:{_id:t._id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getInterpreters=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query getInterpreters {\n          interpreters{\n            id\n            lastName\n            middleName\n            firstName\n            businessName\n            address\n            addressAptCk\n            addressSteCk\n            addressFloorCk\n            addressAptSteFlrNumbertxt\n            city\n            state\n            zipCode\n            foreignProvince\n            foreignPostalCode\n            country\n            phone\n            email\n            language\n            createdAt\n            updatedAt\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateField=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n       mutation FormFieldMutation($formId: Int!, $field: String!, $value: String!, $fieldType: Int!) {\n          questionnaireFieldsAdd(field: {\n            formId: $formId,\n            field: $field,\n            value: $value,\n            fieldType: $fieldType\n          }) {\n            id\n            formId\n            field\n            value\n            model\n            updatedAt\n          }\n        }\n      ",variables:{formId:t.data.formId,field:t.data.field,value:t.data.value,fieldType:t.data.fieldType}}}).then(function(t){return t.data.data.questionnaireFieldsAdd}).catch(function(t){return t})},Ot.setFontSize=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation FontSizeMutation($questionnaire_id: Int!, $size: Float!) {\n          formsFontSizeAdd(fontSize: {\n              questionnaire_id: $questionnaire_id,\n              size: $size\n            }) {\n              questionnaire_id\n              size\n            }\n          }\n      ",variables:{questionnaire_id:t.data.questionnaire_id,size:t.data.size}}}).then(function(t){return t}).catch(function(t){return t})},Ot.setReverseAF=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n       mutation ReverseAFMutation($id: Int!, $reverseAutofill: String!) {\n        questionnairesReverseAutofill(reverse: {\n            id: $id,\n            reverseAutofill: $reverseAutofill\n          }) {\n            id\n            reverseAutofillEnable\n          }\n        }\n      ",variables:{id:t.data.id,reverseAutofill:t.data.reverseAutofill}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.graphTemplates=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n          templates(formIdMongo: "'+t.formId+'") {\n            _id\n            name\n            chGroups\n            checkboxGroups\n            widgetLabels\n            pages\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getQuestionnaire=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n          questionnaires(templateId: "'+t.templateId+'") {\n            _id\n            templateId\n            data\n            properties\n            updatedAt\n            deletedAt\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.graphTemplatesCT=function(t){return wt()({url:Mt,method:"post",headers:{authorization:t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n          templates(formIdMongo: "'+t.formId+'") {\n            _id\n            name\n            chGroups\n            checkboxGroups\n            widgetLabels\n            pages\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getQuestionnaireCT=function(t){return wt()({url:Mt,method:"post",headers:{authorization:t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n          questionnaires(templateId: "'+t.templateId+'") {\n            _id\n            templateId\n            data\n            properties\n            updatedAt\n            deletedAt\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getListForQuestionnaire=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          rolesAssigneds(caseId: "+t.caseId+") {\n            caseId\n            caseFormId\n            formId\n            formName\n            enableForQuestionnaire\n            roles\n            contacts\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addQuestionnaires=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewQuestionnaire($generate: Array!) {\n          caseQuestionnairesAdd(generate: $generate) {\n            _id\n            models\n            forms\n            caseId\n            contactId\n            status\n            lastActivity\n            roleType\n            createdAt\n            updatedAt\n            clientPortal\n          }\n        }\n      ",variables:{generate:t.questionnaires}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getListCaseQuestionnaires=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          caseQuestionnaires(caseId: "+t.caseId+") {\n            _id\n            models\n            forms\n            caseId\n            contactId\n            status\n            lastActivity\n            roleType\n            createdAt\n            updatedAt\n            token {\n              accessToken\n            }\n            clientPortal\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseQuestionnaireCT=function(t){return wt()({url:Mt,method:"post",headers:{authorization:t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n          caseQuestionnaires(_id: "'+t.questionnaireId+'") {\n            _id\n            models\n            forms\n            caseId\n            contactId\n            status\n            lastActivity\n            roleType\n            createdAt\n            expireDate\n            complete\n            onlyGeneral\n            onlyForms\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseQuestionnaire=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n          caseQuestionnaires(_id: "'+t.questionnaireId+'") {\n            _id\n            models\n            forms\n            caseId\n            contactId\n            status\n            lastActivity\n            roleType\n            createdAt\n            onlyGeneral\n            onlyForms\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.UpdateCaseQuestionnaire=function(t){return wt()({url:Mt,method:"post",headers:{authorization:t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation updateCaseQuestionnaire($where: JSON!, $value: Value!) {\n          caseQuestionnaireEdit(where: $where, value: $value) {\n            _id\n            models\n            forms\n            caseId\n            contactId\n            status\n            lastActivity\n            roleType\n            createdAt\n          }\n        }\n      ",variables:{where:t.where,value:t.value}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.sendCaseQuestionnaires=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation sendCaseQuestionnaire($dataToSend: JSON!) {\n          sendCaseQuestionnaires(dataToSend: $dataToSend) {\n            token\n            scope\n          }\n        }\n      ",variables:{dataToSend:t.data}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getScope=function(t){return wt()({url:Mt,method:"post",headers:{authorization:t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          scope {\n            scope\n            dataFirm\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateCaseQuestionnairesStatusTC=function(t){return wt()({url:Mt,method:"post",headers:{authorization:t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation sendToAttorney($questionnaireIds: Array!, $status: String!) {\n          caseQuestionnaireChangeStatus(questionnaireIds: $questionnaireIds, status: $status) {\n            _id\n            status\n          }\n        }\n      ",variables:{questionnaireIds:t.questionnaireIds,status:t.status}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateCaseQuestionnairesStatus=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation sendStatus($questionnaireIds: Array!, $status: String!) {\n          caseQuestionnaireChangeStatus(questionnaireIds: $questionnaireIds, status: $status) {\n            _id\n            status\n          }\n        }\n      ",variables:{questionnaireIds:t.questionnaireIds,status:t.status}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteCaseQuestionnaires=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteQuestionnaires($questionnaireIds: Array!) {\n          caseQuestionnaireDelete(questionnaireIds: $questionnaireIds) {\n            _id\n            status\n          }\n        }\n      ",variables:{questionnaireIds:t.questionnaireIds}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.markAsCompleteCaseQuestionnaires=function(t){return wt()({url:Mt,method:"post",headers:{authorization:t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation markAsCompleteQuestionnaires($questionnaireIds: Array!, $complete: Boolean!) {\n          caseQuestionnaireAsComplete(questionnaireIds: $questionnaireIds, complete: $complete) {\n            _id\n            complete\n          }\n        }\n      ",variables:{questionnaireIds:t.questionnaireIds,complete:t.complete}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateCaseQuestionnaireManual=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation updateManual($where: JSON!, $value: Value!) {\n          caseQuestionnaireManual(where: $where, value: $value) {\n            _id\n            models\n            forms\n            caseId\n            contactId\n            status\n            lastActivity\n            roleType\n            note\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{where:t.where,value:t.value}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getEmailsPhones=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          emailsMobilePhoneContactsRelationed(contactId: "+t.contactId+") {\n            id\n            name\n            email\n            phone\n            isMobile\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseQuestionnaireWT=function(t){return wt()({url:Dt+"questionnaire/viewer/"+t.questionnaireId,method:"get",headers:{"Access-Control-Allow-Origin":"*"}}).then(function(t){return t}).catch(function(t){return t})},Ot.UpdateCaseQuestionnaireWT=function(t){return wt()({url:Dt+"questionnaire/client",method:"put",headers:{"Access-Control-Allow-Origin":"*"},data:t}).then(function(t){return t}).catch(function(t){return t})},Ot.getAddendums=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n          addendums (caseFormId: "'+t.caseFormId+'") {\n            _id\n            caseFormId\n            body\n            title\n            tenantCode\n            createdAt\n            updatedAt\n            model\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addAddendum=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addAddendum($caseFormId: String!, $title: String, $body: String!) {\n          addendumsAdd(caseFormId: $caseFormId, title: $title, body: $body) {\n            _id\n            caseFormId\n            body\n            title\n            tenantCode\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{caseFormId:t.caseFormId,body:t.body,title:t.title}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editAddendum=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editAddendum($addendumId: String!, $title: String, $body: String!) {\n          addendumsEdit(addendumId: $addendumId, title: $title, body: $body) {\n            _id\n            caseFormId\n            body\n            title\n            tenantCode\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{addendumId:t.addendumId,body:t.body,title:t.title}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteAddendum=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteAddendum($addendumId: String!) {\n          addendumsDelete(addendumId: $addendumId) {\n            _id\n            caseFormId\n            body\n            title\n            tenantCode\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{addendumId:t.addendumId}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.generateAddendum=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation generateAddendum($caseFormId: String!) {\n          addendumsGenerate(caseFormId: $caseFormId) {\n            _id\n            caseFormId\n            body\n            title\n            tenantCode\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{caseFormId:t.caseFormId}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getNotesContact=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          notes (contactId: "+t.contactId+") {\n            _id\n            body\n            createdAt\n            updatedAt\n            userId\n            caseId\n            contactId\n            subject\n            regardingId\n            regardingType\n            date\n            visibleOnClientPortal\n            user{\n              id\n              firstName\n              middleName\n              lastName\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getNotesCase=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          notes (caseId: "+t.caseId+") {\n            _id\n            body\n            createdAt\n            updatedAt\n            userId\n            caseId\n            contactId\n            subject\n            regardingId\n            regardingType\n            date\n            visibleOnClientPortal\n            user{\n              id\n              firstName\n              middleName\n              lastName\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addNote=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation noteAdd($newNote: newNote!) {\n          noteAdd(newNote: $newNote) {\n            _id\n            body\n            createdAt\n            updatedAt\n            userId\n            caseId\n            contactId\n            subject\n            regardingId\n            regardingType\n            date\n            visibleOnClientPortal\n            user{\n              id\n              firstName\n              middleName\n              lastName\n            }\n          }\n        }\n      ",variables:{newNote:t.newNote}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editNote=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation noteEdit($_id: String!, $editNote: editNote!) {\n          noteEdit(_id: $_id, editNote: $editNote) {\n            _id\n            body\n            caseId\n            contactId\n            subject\n            regardingId\n            regardingType\n            date\n            visibleOnClientPortal\n            user{\n              id\n              firstName\n              middleName\n              lastName\n            }\n          }\n        }\n      ",variables:{_id:t._id,editNote:t.editNote}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteNote=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation noteDelete($_id: String!) {\n          noteDelete(_id: $_id) {\n            _id\n            body\n            caseId\n            contactId\n            subject\n            regardingId\n            regardingType\n            date\n            visibleOnClientPortal\n          }\n        }\n      ",variables:{_id:t._id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCasesContact=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          contacts(search:{filter: [{field: "+t.field+", value: "+t.value+"}]}) {\n            id\n            fullName\n            cases {\n              id\n              name\n              caseType {\n                id\n                name\n              }\n            }\n            user {\n              id\n              firstName\n              middleName\n              lastName\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getAddresses=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listAddresses: contacts(search:{filter: [{field: id, value: "+t.contactId+"}]}) {\n            address {\n              id\n              name\n              address\n              line2\n              apt\n              ste\n              flr\n              aptSteFlrNumbertxt\n              isForeing\n              isMailing\n              isPrimary\n              isCurrent\n              liveFrom\n              liveTo\n              order\n              city\n              state\n              country\n              zipCode\n              inCareOf\n              createdAt\n              updatedAt\n              foreignProvince\n              postalCode\n              objectId\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addAddress=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewAddress($name: String, $address: String, $line2: String, $isAptSteFlr: String, $aptSteFlrNumbertxt: String, $isForeing: String, $isMailing: String, $isPrimary: String, $isCurrent: String, $liveFrom: String, $liveTo: String, $order: String, $objectId: Int, $city: String, $state: String, $country: String, $zipCode: String, $inCareOf: String, $foreignProvince: String, $postalCode: String) {\n          addressAdd(newAddress: {name: $name, address: $address, line2: $line2, isAptSteFlr: $isAptSteFlr, aptSteFlrNumbertxt: $aptSteFlrNumbertxt, isForeing: $isForeing, isMailing: $isMailing, isPrimary: $isPrimary, isCurrent: $isCurrent, liveFrom: $liveFrom, liveTo: $liveTo, order: $order, objectId: $objectId, city: $city, state: $state, country: $country, zipCode: $zipCode, inCareOf: $inCareOf, foreignProvince: $foreignProvince, postalCode: $postalCode}) {\n            id\n            name\n            address\n            line2\n            apt\n            ste\n            flr\n            aptSteFlrNumbertxt\n            isForeing\n            isMailing\n            isPrimary\n            isCurrent\n            liveFrom\n            liveTo\n            order\n            city\n            state\n            country\n            zipCode\n            inCareOf\n            foreignProvince\n            postalCode\n            objectId\n          }\n        }\n      ",variables:{name:t.name,address:t.address,line2:t.line2,isAptSteFlr:t.isAptSteFlr,aptSteFlrNumbertxt:t.aptSteFlrNumbertxt,isForeing:t.isForeing,isMailing:t.isMailing,isPrimary:t.isPrimary,isCurrent:t.isCurrent,liveFrom:t.liveFrom,liveTo:t.liveTo,order:t.order,objectId:t.objectId,city:t.city,state:t.state,country:t.country,zipCode:t.zipCode,inCareOf:t.inCareOf,foreignProvince:t.foreignProvince,postalCode:t.postalCode}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editAddress=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editAddress($id: Int!, $name: String, $address: String, $line2: String, $isAptSteFlr: String, $aptSteFlrNumbertxt: String, $isForeing: String, $isMailing: String, $isPrimary: String, $isCurrent: String, $liveFrom: String, $liveTo: String, $order: String, $objectId: Int, $city: String, $state: String, $country: String, $zipCode: String, $inCareOf: String, $foreignProvince: String, $postalCode: String) {\n          addressEdit(id: $id, editAddress: {name: $name, address: $address, line2: $line2, isAptSteFlr: $isAptSteFlr, aptSteFlrNumbertxt: $aptSteFlrNumbertxt, isForeing: $isForeing, isMailing: $isMailing, isPrimary: $isPrimary, isCurrent: $isCurrent, liveFrom: $liveFrom, liveTo: $liveTo, order: $order, objectId: $objectId, city: $city, state: $state, country: $country, zipCode: $zipCode, inCareOf: $inCareOf, foreignProvince: $foreignProvince, postalCode: $postalCode}) {\n            id\n            name\n            address\n            line2\n            apt\n            ste\n            flr\n            aptSteFlrNumbertxt\n            isForeing\n            isMailing\n            isPrimary\n            isCurrent\n            liveFrom\n            liveTo\n            order\n            city\n            state\n            country\n            zipCode\n            inCareOf\n            foreignProvince\n            postalCode\n            objectId\n          }\n        }\n      ",variables:{id:t.id,name:t.name,address:t.address,line2:t.line2,isAptSteFlr:t.isAptSteFlr,aptSteFlrNumbertxt:t.aptSteFlrNumbertxt,isForeing:t.isForeing,isMailing:t.isMailing,isPrimary:t.isPrimary,isCurrent:t.isCurrent,liveFrom:t.liveFrom,liveTo:t.liveTo,order:t.order,objectId:t.objectId,city:t.city,state:t.state,country:t.country,zipCode:t.zipCode,inCareOf:t.inCareOf,foreignProvince:t.foreignProvince,postalCode:t.postalCode}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteAddress=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteAddress($id: Int!) {\n          addressDelete(id: $id) {\n            name\n            address\n            line2\n            aptSteFlrNumbertxt\n            isForeing\n            isMailing\n            isPrimary\n            isCurrent\n            liveFrom\n            liveTo\n            order\n            city\n            state\n            country\n            zipCode\n            inCareOf\n            foreignProvince\n            postalCode\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getPhones=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listPhones: contacts(search:{filter: [{field: id, value: "+t.contactId+"}]}) {\n            phones {\n              id\n              name\n              number\n              annotation\n              availableAt\n              type\n              countryAreaCode\n              ext\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addPhone=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewPhone($name: String, $number: String!, $annotation: String, $availableAt: String, $objectId: Int, $type: String!, $countryAreaCode: String, $ext: String) {\n          phoneAdd(newPhone: {name: $name, number: $number, annotation: $annotation, availableAt: $availableAt, objectId: $objectId, type: $type, countryAreaCode: $countryAreaCode, ext: $ext}) {\n            id\n            name\n            number\n            annotation\n            availableAt\n            objectId\n            type\n            countryAreaCode\n            ext\n          }\n        }\n      ",variables:{name:t.name,number:t.number,annotation:t.annotation,availableAt:t.availableAt,objectId:t.objectId,type:t.type,countryAreaCode:t.countryAreaCode,ext:t.ext}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editPhone=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation phoneEdit($id: Int!, $name: String, $number: String!, $annotation: String, $availableAt: String, $objectId: Int!, $type: String!, $countryAreaCode: String, $ext: String) {\n          phoneEdit(id: $id, editPhone: {name: $name, number: $number, annotation: $annotation, availableAt: $availableAt, objectId: $objectId, type: $type, countryAreaCode: $countryAreaCode, ext: $ext}) {\n            name\n            number\n            annotation\n            availableAt\n            objectId\n            type\n            countryAreaCode\n            ext\n          }\n        }\n      ",variables:{id:t.id,name:t.name,number:t.number,annotation:t.annotation,availableAt:t.availableAt,objectId:t.objectId,type:t.type,countryAreaCode:t.countryAreaCode,ext:t.ext}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deletePhone=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deletePhone($id: Int!) {\n          phoneDelete(id: $id) {\n            name\n            number\n            annotation\n            availableAt\n            objectId\n            type\n            countryAreaCode\n            ext\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getJobs=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listJobs: jobs(contactId: "+t.contactId+") {\n            id\n            job\n            contactId\n            begin\n            end\n            company\n            street\n            city\n            state\n            zip\n            duties\n            phone\n            supervisor\n            moneyWeek\n            moneyMonth\n            moneyYear\n            title\n            country\n            createdBy\n            createdAt\n            updatedAt\n            aptCk\n            steCk\n            floorCk\n            aptSteFlrNumbertxt\n            addressLine2\n            typeOfBusiness\n            hoursWorkedPerWeek\n            details\n            province\n            postalCode\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addJob=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewJob($contactId: Int!, $job: String, $begin: String, $end: String, $company: String!, $street: String, $city: String, $state: String, $zip: String, $duties: String, $phone: String, $supervisor: String, $moneyWeek: String, $moneyMonth: String, $moneyYear: String, $title: String, $country: String, $isAptSteFlr: String, $aptSteFlrNumbertxt: String, $addressLine2: String, $typeOfBusiness: String, $hoursWorkedPerWeek: String, $details: String, $province: String, $postalCode: String) {\n          jobAdd(newJob: {contactId: $contactId, job: $job, begin: $begin, end: $end, company: $company, street: $street, city: $city, state: $state, zip: $zip, duties: $duties, phone: $phone, supervisor: $supervisor, moneyWeek: $moneyWeek, moneyMonth: $moneyMonth, moneyYear: $moneyYear, title: $title, country: $country, isAptSteFlr: $isAptSteFlr, aptSteFlrNumbertxt: $aptSteFlrNumbertxt, addressLine2: $addressLine2, typeOfBusiness: $typeOfBusiness, hoursWorkedPerWeek: $hoursWorkedPerWeek, details: $details, province: $province, postalCode: $postalCode}) {\n            id\n            job\n            contactId\n            begin\n            end\n            company\n            street\n            city\n            state\n            zip\n            duties\n            phone\n            supervisor\n            moneyWeek\n            moneyMonth\n            moneyYear\n            title\n            country\n            createdBy\n            createdAt\n            updatedAt\n            aptCk\n            steCk\n            floorCk\n            aptSteFlrNumbertxt\n            addressLine2\n            typeOfBusiness\n            hoursWorkedPerWeek\n            details\n            province\n            postalCode\n          }\n        }\n      ",variables:{contactId:t.contactId,job:t.job,begin:t.begin,end:t.end,company:t.company,street:t.street,city:t.city,state:t.state,zip:t.zip,duties:t.duties,phone:t.phone,supervisor:t.supervisor,moneyWeek:t.moneyWeek,moneyMonth:t.moneyMonth,moneyYear:t.moneyYear,title:t.title,country:t.country,isAptSteFlr:t.isAptSteFlr,aptSteFlrNumbertxt:t.aptSteFlrNumbertxt,addressLine2:t.addressLine2,typeOfBusiness:t.typeOfBusiness,hoursWorkedPerWeek:t.hoursWorkedPerWeek,details:t.details,province:t.province,postalCode:t.postalCode}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editJob=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editJob($id: Int!, $contactId: Int!, $job: String, $begin: String, $end: String, $company: String!, $street: String, $city: String, $state: String, $zip: String, $duties: String, $phone: String, $supervisor: String, $moneyWeek: String, $moneyMonth: String, $moneyYear: String, $title: String, $country: String, $isAptSteFlr: String, $aptSteFlrNumbertxt: String, $addressLine2: String, $typeOfBusiness: String, $hoursWorkedPerWeek: String, $details: String, $province: String, $postalCode: String) {\n          jobEdit(id: $id, editJob: {contactId: $contactId, job: $job, begin: $begin, end: $end, company: $company, street: $street, city: $city, state: $state, zip: $zip, duties: $duties, phone: $phone, supervisor: $supervisor, moneyWeek: $moneyWeek, moneyMonth: $moneyMonth, moneyYear: $moneyYear, title: $title, country: $country, isAptSteFlr: $isAptSteFlr, aptSteFlrNumbertxt: $aptSteFlrNumbertxt, addressLine2: $addressLine2, typeOfBusiness: $typeOfBusiness, hoursWorkedPerWeek: $hoursWorkedPerWeek, details: $details, province: $province, postalCode: $postalCode}) {\n            id\n            job\n            contactId\n            begin\n            end\n            company\n            street\n            city\n            state\n            zip\n            duties\n            phone\n            supervisor\n            moneyWeek\n            moneyMonth\n            moneyYear\n            title\n            country\n            createdBy\n            createdAt\n            updatedAt\n            aptCk\n            steCk\n            floorCk\n            aptSteFlrNumbertxt\n            addressLine2\n            typeOfBusiness\n            hoursWorkedPerWeek\n            details\n            province\n            postalCode\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,job:t.job,begin:t.begin,end:t.end,company:t.company,street:t.street,city:t.city,state:t.state,zip:t.zip,duties:t.duties,phone:t.phone,supervisor:t.supervisor,moneyWeek:t.moneyWeek,moneyMonth:t.moneyMonth,moneyYear:t.moneyYear,title:t.title,country:t.country,isAptSteFlr:t.isAptSteFlr,aptSteFlrNumbertxt:t.aptSteFlrNumbertxt,addressLine2:t.addressLine2,typeOfBusiness:t.typeOfBusiness,hoursWorkedPerWeek:t.hoursWorkedPerWeek,details:t.details,province:t.province,postalCode:t.postalCode}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteJob=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteJob($id: Int!) {\n          jobDelete(id: $id) {\n            id\n            job\n            begin\n            end\n            company\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getEducational=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listEducational: educationalHistory(contactId: "+t.contactId+") {\n            id\n            contactId\n            schoolName\n            begin\n            end\n            graduation\n            degree\n            level\n            street\n            city\n            state\n            zip\n            country\n            phone\n            createdBy\n            createdAt\n            updatedAt\n            aptCk\n            steCk\n            floorCk\n            aptSteFlrNumbertxt\n            addressLine2\n            educationalHistory\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addEducational=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewEducational($contactId: Int!, $schoolName: String!, $begin: String, $end: String, $graduation: String, $degree: String, $level: String, $street: String, $city: String, $state: String, $zip: String, $country: String, $phone: String, $createdBy: Int, $isAptSteFlr: String, $aptSteFlrNumbertxt: String, $addressLine2: String, $educationalHistory: String) {\n          educationalHistoryAdd(newEduHistory: {contactId: $contactId, schoolName: $schoolName, begin: $begin, end: $end, graduation: $graduation, degree: $degree, level: $level, street: $street, city: $city, state: $state, zip: $zip, country: $country, phone: $phone, createdBy: $createdBy, isAptSteFlr: $isAptSteFlr, aptSteFlrNumbertxt: $aptSteFlrNumbertxt, addressLine2: $addressLine2, educationalHistory: $educationalHistory}) {\n            id\n            contactId\n            schoolName\n            begin\n            end\n            graduation\n            degree\n            level\n            street\n            city\n            state\n            zip\n            country\n            phone\n            createdBy\n            createdAt\n            updatedAt\n            aptCk\n            steCk\n            floorCk\n            aptSteFlrNumbertxt\n            addressLine2\n            educationalHistory\n          }\n        }\n      ",variables:{contactId:t.contactId,schoolName:t.schoolName,begin:t.begin,end:t.end,graduation:t.graduation,degree:t.degree,level:t.level,street:t.street,city:t.city,state:t.state,zip:t.zip,country:t.country,phone:t.phone,createdBy:t.createdBy,isAptSteFlr:t.isAptSteFlr,aptSteFlrNumbertxt:t.aptSteFlrNumbertxt,addressLine2:t.addressLine2,educationalHistory:t.educationalHistory}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editEducational=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editEducational($id: Int!, $contactId: Int, $schoolName: String, $begin: String, $end: String, $graduation: String, $degree: String, $level: String, $street: String, $city: String, $state: String, $zip: String, $country: String, $phone: String, $createdBy: Int, $isAptSteFlr: String, $aptSteFlrNumbertxt: String, $addressLine2: String, $educationalHistory: String) {\n          educationalHistoryEdit(id: $id, editEduHistory: {contactId: $contactId, schoolName: $schoolName, begin: $begin, end: $end, graduation: $graduation, degree: $degree, level: $level, street: $street, city: $city, state: $state, zip: $zip, country: $country, phone: $phone, createdBy: $createdBy, isAptSteFlr: $isAptSteFlr, aptSteFlrNumbertxt: $aptSteFlrNumbertxt, addressLine2: $addressLine2, educationalHistory: $educationalHistory}) {\n            id\n            contactId\n            schoolName\n            begin\n            end\n            graduation\n            degree\n            level\n            street\n            city\n            state\n            zip\n            country\n            phone\n            createdBy\n            createdAt\n            updatedAt\n            aptCk\n            steCk\n            floorCk\n            aptSteFlrNumbertxt\n            addressLine2\n            educationalHistory\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,schoolName:t.schoolName,begin:t.begin,end:t.end,graduation:t.graduation,degree:t.degree,level:t.level,street:t.street,city:t.city,state:t.state,zip:t.zip,country:t.country,phone:t.phone,createdBy:t.createdBy,isAptSteFlr:t.isAptSteFlr,aptSteFlrNumbertxt:t.aptSteFlrNumbertxt,addressLine2:t.addressLine2,educationalHistory:t.educationalHistory}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteEducational=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteEducational($id: Int!) {\n          educationalHistoryDelete(id: $id) {\n            id\n            contactId\n            schoolName\n            begin\n            end\n            graduation\n            degree\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCriminal=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listCriminal: criminalHistory(contactId: "+t.contactId+") {\n            id\n            contactId\n            dateOfArrest\n            dateOfConvinction\n            districtCourtName\n            courtOfConviction\n            statutoryNameOfConviction\n            statutoryCitationOfConviction\n            padillaWarningsReceivedAndDocumented\n            courtOfConvictionAddress\n            courtOfConvictionPhone\n            courtOfConvictionEmail\n            courtOfConvictionFax\n            classOfCrime\n            crimeOfMoralTurpitude\n            crimeOfMoralTurpitudeExplanation\n            aggravatedFelony\n            aggravatedFelonyExplanation\n            controlledSubstanceCrime\n            controlledSubstanceCrimeExplanation\n            crimeOfDomesticViolence\n            crimeOfDomesticViolenceExplanation\n            violationOfPersonalProtectionOrder\n            violationOfPersonalProtectionOrderExplanation\n            otherImmigrationConsequences\n            result\n            sentenceTermsProbation\n            sentenceTermsProbationDetails\n            sentenceTermsFines\n            sentenceTermsFinesDetails\n            sentenceTermsCosts\n            sentenceTermsCostsDetails\n            sentenceTermsRestitution\n            sentenceTermsRestitutionDetails\n            sentenceTermsJailPrison\n            sentenceTermsJailPrisonDetails\n            sentenceTermsOther\n            sentenceTermsOtherDetails\n            representedByAttorney\n            attorneyName\n            attorneyAddress\n            attorneyPhone\n            removableOffense\n            inadmissibleOffense\n            possibleWaiver\n            createdAt\n            updatedAt\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addCriminal=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewCriminal($contactId: Int!, $dateOfArrest: String!, $dateOfConvinction: String, $districtCourtName: String, $courtOfConviction: String, $statutoryNameOfConviction: String, $statutoryCitationOfConviction: String, $padillaWarningsReceivedAndDocumented: String, $courtOfConvictionAddress: String, $courtOfConvictionPhone: String, $courtOfConvictionEmail: String, $courtOfConvictionFax: String, $classOfCrime: String, $crimeOfMoralTurpitude: String, $crimeOfMoralTurpitudeExplanation: String, $aggravatedFelony: String, $aggravatedFelonyExplanation: String, $controlledSubstanceCrime: String, $controlledSubstanceCrimeExplanation: String, $crimeOfDomesticViolence: String, $crimeOfDomesticViolenceExplanation: String, $violationOfPersonalProtectionOrder: String, $violationOfPersonalProtectionOrderExplanation: String, $otherImmigrationConsequences: String, $result: String, $sentenceTermsProbation: String, $sentenceTermsProbationDetails: String, $sentenceTermsFines: String, $sentenceTermsFinesDetails: String, $sentenceTermsCosts: String, $sentenceTermsCostsDetails: String, $sentenceTermsRestitution: String, $sentenceTermsRestitutionDetails: String, $sentenceTermsJailPrison: String, $sentenceTermsJailPrisonDetails: String, $sentenceTermsOther: String, $sentenceTermsOtherDetails: String, $representedByAttorney: String, $attorneyName: String, $attorneyAddress: String, $attorneyPhone: String, $removableOffense: String, $inadmissibleOffense: String, $possibleWaiver: String) {\n          criminalHistoryAdd(newCriminalHistory: {contactId: $contactId,dateOfArrest: $dateOfArrest,dateOfConvinction: $dateOfConvinction,districtCourtName: $districtCourtName,courtOfConviction: $courtOfConviction,statutoryNameOfConviction: $statutoryNameOfConviction,statutoryCitationOfConviction: $statutoryCitationOfConviction,padillaWarningsReceivedAndDocumented: $padillaWarningsReceivedAndDocumented,courtOfConvictionAddress: $courtOfConvictionAddress,courtOfConvictionPhone: $courtOfConvictionPhone,courtOfConvictionEmail: $courtOfConvictionEmail,courtOfConvictionFax: $courtOfConvictionFax,classOfCrime: $classOfCrime,crimeOfMoralTurpitude: $crimeOfMoralTurpitude,crimeOfMoralTurpitudeExplanation: $crimeOfMoralTurpitudeExplanation,aggravatedFelony: $aggravatedFelony,aggravatedFelonyExplanation: $aggravatedFelonyExplanation,controlledSubstanceCrime: $controlledSubstanceCrime,controlledSubstanceCrimeExplanation: $controlledSubstanceCrimeExplanation,crimeOfDomesticViolence: $crimeOfDomesticViolence,crimeOfDomesticViolenceExplanation: $crimeOfDomesticViolenceExplanation,violationOfPersonalProtectionOrder: $violationOfPersonalProtectionOrder,violationOfPersonalProtectionOrderExplanation: $violationOfPersonalProtectionOrderExplanation,otherImmigrationConsequences: $otherImmigrationConsequences,result: $result,sentenceTermsProbation: $sentenceTermsProbation,sentenceTermsProbationDetails: $sentenceTermsProbationDetails,sentenceTermsFines: $sentenceTermsFines,sentenceTermsFinesDetails: $sentenceTermsFinesDetails,sentenceTermsCosts: $sentenceTermsCosts,sentenceTermsCostsDetails: $sentenceTermsCostsDetails,sentenceTermsRestitution: $sentenceTermsRestitution,sentenceTermsRestitutionDetails: $sentenceTermsRestitutionDetails,sentenceTermsJailPrison: $sentenceTermsJailPrison,sentenceTermsJailPrisonDetails: $sentenceTermsJailPrisonDetails,sentenceTermsOther: $sentenceTermsOther,sentenceTermsOtherDetails: $sentenceTermsOtherDetails,representedByAttorney: $representedByAttorney,attorneyName: $attorneyName,attorneyAddress: $attorneyAddress,attorneyPhone: $attorneyPhone,removableOffense: $removableOffense,inadmissibleOffense: $inadmissibleOffense,possibleWaiver: $possibleWaiver}) {\n            id\n            contactId\n            dateOfArrest\n            dateOfConvinction\n            districtCourtName\n            courtOfConviction\n            statutoryNameOfConviction\n            statutoryCitationOfConviction\n            padillaWarningsReceivedAndDocumented\n            courtOfConvictionAddress\n            courtOfConvictionPhone\n            courtOfConvictionEmail\n            courtOfConvictionFax\n            classOfCrime\n            crimeOfMoralTurpitude\n            crimeOfMoralTurpitudeExplanation\n            aggravatedFelony\n            aggravatedFelonyExplanation\n            controlledSubstanceCrime\n            controlledSubstanceCrimeExplanation\n            crimeOfDomesticViolence\n            crimeOfDomesticViolenceExplanation\n            violationOfPersonalProtectionOrder\n            violationOfPersonalProtectionOrderExplanation\n            otherImmigrationConsequences\n            result\n            sentenceTermsProbation\n            sentenceTermsProbationDetails\n            sentenceTermsFines\n            sentenceTermsFinesDetails\n            sentenceTermsCosts\n            sentenceTermsCostsDetails\n            sentenceTermsRestitution\n            sentenceTermsRestitutionDetails\n            sentenceTermsJailPrison\n            sentenceTermsJailPrisonDetails\n            sentenceTermsOther\n            sentenceTermsOtherDetails\n            representedByAttorney\n            attorneyName\n            attorneyAddress\n            attorneyPhone\n            removableOffense\n            inadmissibleOffense\n            possibleWaiver\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{contactId:t.contactId,dateOfArrest:t.dateOfArrest,dateOfConvinction:t.dateOfConvinction,districtCourtName:t.districtCourtName,courtOfConviction:t.courtOfConviction,statutoryNameOfConviction:t.statutoryNameOfConviction,statutoryCitationOfConviction:t.statutoryCitationOfConviction,padillaWarningsReceivedAndDocumented:t.padillaWarningsReceivedAndDocumented,courtOfConvictionAddress:t.courtOfConvictionAddress,courtOfConvictionPhone:t.courtOfConvictionPhone,courtOfConvictionEmail:t.courtOfConvictionEmail,courtOfConvictionFax:t.courtOfConvictionFax,classOfCrime:t.classOfCrime,crimeOfMoralTurpitude:t.crimeOfMoralTurpitude,crimeOfMoralTurpitudeExplanation:t.crimeOfMoralTurpitudeExplanation,aggravatedFelony:t.aggravatedFelony,aggravatedFelonyExplanation:t.aggravatedFelonyExplanation,controlledSubstanceCrime:t.controlledSubstanceCrime,controlledSubstanceCrimeExplanation:t.controlledSubstanceCrimeExplanation,crimeOfDomesticViolence:t.crimeOfDomesticViolence,crimeOfDomesticViolenceExplanation:t.crimeOfDomesticViolenceExplanation,violationOfPersonalProtectionOrder:t.violationOfPersonalProtectionOrder,violationOfPersonalProtectionOrderExplanation:t.violationOfPersonalProtectionOrderExplanation,otherImmigrationConsequences:t.otherImmigrationConsequences,result:t.result,sentenceTermsProbation:t.sentenceTermsProbation,sentenceTermsProbationDetails:t.sentenceTermsProbationDetails,sentenceTermsFines:t.sentenceTermsFines,sentenceTermsFinesDetails:t.sentenceTermsFinesDetails,sentenceTermsCosts:t.sentenceTermsCosts,sentenceTermsCostsDetails:t.sentenceTermsCostsDetails,sentenceTermsRestitution:t.sentenceTermsRestitution,sentenceTermsRestitutionDetails:t.sentenceTermsRestitutionDetails,sentenceTermsJailPrison:t.sentenceTermsJailPrison,sentenceTermsJailPrisonDetails:t.sentenceTermsJailPrisonDetails,sentenceTermsOther:t.sentenceTermsOther,sentenceTermsOtherDetails:t.sentenceTermsOtherDetails,representedByAttorney:t.representedByAttorney,attorneyName:t.attorneyName,attorneyAddress:t.attorneyAddress,attorneyPhone:t.attorneyPhone,removableOffense:t.removableOffense,inadmissibleOffense:t.inadmissibleOffense,possibleWaiver:t.possibleWaiver}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editCriminal=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editCriminal($id: Int!, $contactId: Int, $dateOfArrest: String, $dateOfConvinction: String, $districtCourtName: String, $courtOfConviction: String, $statutoryNameOfConviction: String, $statutoryCitationOfConviction: String, $padillaWarningsReceivedAndDocumented: String, $courtOfConvictionAddress: String, $courtOfConvictionPhone: String, $courtOfConvictionEmail: String, $courtOfConvictionFax: String, $classOfCrime: String, $crimeOfMoralTurpitude: String, $crimeOfMoralTurpitudeExplanation: String, $aggravatedFelony: String, $aggravatedFelonyExplanation: String, $controlledSubstanceCrime: String, $controlledSubstanceCrimeExplanation: String, $crimeOfDomesticViolence: String, $crimeOfDomesticViolenceExplanation: String, $violationOfPersonalProtectionOrder: String, $violationOfPersonalProtectionOrderExplanation: String, $otherImmigrationConsequences: String, $result: String, $sentenceTermsProbation: String, $sentenceTermsProbationDetails: String, $sentenceTermsFines: String, $sentenceTermsFinesDetails: String, $sentenceTermsCosts: String, $sentenceTermsCostsDetails: String, $sentenceTermsRestitution: String, $sentenceTermsRestitutionDetails: String, $sentenceTermsJailPrison: String, $sentenceTermsJailPrisonDetails: String, $sentenceTermsOther: String, $sentenceTermsOtherDetails: String, $representedByAttorney: String, $attorneyName: String, $attorneyAddress: String, $attorneyPhone: String, $removableOffense: String, $inadmissibleOffense: String, $possibleWaiver: String) {\n          criminalHistoryEdit(id: $id, editCriminalHistory: {contactId: $contactId,dateOfArrest: $dateOfArrest,dateOfConvinction: $dateOfConvinction,districtCourtName: $districtCourtName,courtOfConviction: $courtOfConviction,statutoryNameOfConviction: $statutoryNameOfConviction,statutoryCitationOfConviction: $statutoryCitationOfConviction,padillaWarningsReceivedAndDocumented: $padillaWarningsReceivedAndDocumented,courtOfConvictionAddress: $courtOfConvictionAddress,courtOfConvictionPhone: $courtOfConvictionPhone,courtOfConvictionEmail: $courtOfConvictionEmail,courtOfConvictionFax: $courtOfConvictionFax,classOfCrime: $classOfCrime,crimeOfMoralTurpitude: $crimeOfMoralTurpitude,crimeOfMoralTurpitudeExplanation: $crimeOfMoralTurpitudeExplanation,aggravatedFelony: $aggravatedFelony,aggravatedFelonyExplanation: $aggravatedFelonyExplanation,controlledSubstanceCrime: $controlledSubstanceCrime,controlledSubstanceCrimeExplanation: $controlledSubstanceCrimeExplanation,crimeOfDomesticViolence: $crimeOfDomesticViolence,crimeOfDomesticViolenceExplanation: $crimeOfDomesticViolenceExplanation,violationOfPersonalProtectionOrder: $violationOfPersonalProtectionOrder,violationOfPersonalProtectionOrderExplanation: $violationOfPersonalProtectionOrderExplanation,otherImmigrationConsequences: $otherImmigrationConsequences,result: $result,sentenceTermsProbation: $sentenceTermsProbation,sentenceTermsProbationDetails: $sentenceTermsProbationDetails,sentenceTermsFines: $sentenceTermsFines,sentenceTermsFinesDetails: $sentenceTermsFinesDetails,sentenceTermsCosts: $sentenceTermsCosts,sentenceTermsCostsDetails: $sentenceTermsCostsDetails,sentenceTermsRestitution: $sentenceTermsRestitution,sentenceTermsRestitutionDetails: $sentenceTermsRestitutionDetails,sentenceTermsJailPrison: $sentenceTermsJailPrison,sentenceTermsJailPrisonDetails: $sentenceTermsJailPrisonDetails,sentenceTermsOther: $sentenceTermsOther,sentenceTermsOtherDetails: $sentenceTermsOtherDetails,representedByAttorney: $representedByAttorney,attorneyName: $attorneyName,attorneyAddress: $attorneyAddress,attorneyPhone: $attorneyPhone,removableOffense: $removableOffense,inadmissibleOffense: $inadmissibleOffense,possibleWaiver: $possibleWaiver}) {\n            id\n            contactId\n            dateOfArrest\n            dateOfConvinction\n            districtCourtName\n            courtOfConviction\n            statutoryNameOfConviction\n            statutoryCitationOfConviction\n            padillaWarningsReceivedAndDocumented\n            courtOfConvictionAddress\n            courtOfConvictionPhone\n            courtOfConvictionEmail\n            courtOfConvictionFax\n            classOfCrime\n            crimeOfMoralTurpitude\n            crimeOfMoralTurpitudeExplanation\n            aggravatedFelony\n            aggravatedFelonyExplanation\n            controlledSubstanceCrime\n            controlledSubstanceCrimeExplanation\n            crimeOfDomesticViolence\n            crimeOfDomesticViolenceExplanation\n            violationOfPersonalProtectionOrder\n            violationOfPersonalProtectionOrderExplanation\n            otherImmigrationConsequences\n            result\n            sentenceTermsProbation\n            sentenceTermsProbationDetails\n            sentenceTermsFines\n            sentenceTermsFinesDetails\n            sentenceTermsCosts\n            sentenceTermsCostsDetails\n            sentenceTermsRestitution\n            sentenceTermsRestitutionDetails\n            sentenceTermsJailPrison\n            sentenceTermsJailPrisonDetails\n            sentenceTermsOther\n            sentenceTermsOtherDetails\n            representedByAttorney\n            attorneyName\n            attorneyAddress\n            attorneyPhone\n            removableOffense\n            inadmissibleOffense\n            possibleWaiver\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,dateOfArrest:t.dateOfArrest,dateOfConvinction:t.dateOfConvinction,districtCourtName:t.districtCourtName,courtOfConviction:t.courtOfConviction,statutoryNameOfConviction:t.statutoryNameOfConviction,statutoryCitationOfConviction:t.statutoryCitationOfConviction,padillaWarningsReceivedAndDocumented:t.padillaWarningsReceivedAndDocumented,courtOfConvictionAddress:t.courtOfConvictionAddress,courtOfConvictionPhone:t.courtOfConvictionPhone,courtOfConvictionEmail:t.courtOfConvictionEmail,courtOfConvictionFax:t.courtOfConvictionFax,classOfCrime:t.classOfCrime,crimeOfMoralTurpitude:t.crimeOfMoralTurpitude,crimeOfMoralTurpitudeExplanation:t.crimeOfMoralTurpitudeExplanation,aggravatedFelony:t.aggravatedFelony,aggravatedFelonyExplanation:t.aggravatedFelonyExplanation,controlledSubstanceCrime:t.controlledSubstanceCrime,controlledSubstanceCrimeExplanation:t.controlledSubstanceCrimeExplanation,crimeOfDomesticViolence:t.crimeOfDomesticViolence,crimeOfDomesticViolenceExplanation:t.crimeOfDomesticViolenceExplanation,violationOfPersonalProtectionOrder:t.violationOfPersonalProtectionOrder,violationOfPersonalProtectionOrderExplanation:t.violationOfPersonalProtectionOrderExplanation,otherImmigrationConsequences:t.otherImmigrationConsequences,result:t.result,sentenceTermsProbation:t.sentenceTermsProbation,sentenceTermsProbationDetails:t.sentenceTermsProbationDetails,sentenceTermsFines:t.sentenceTermsFines,sentenceTermsFinesDetails:t.sentenceTermsFinesDetails,sentenceTermsCosts:t.sentenceTermsCosts,sentenceTermsCostsDetails:t.sentenceTermsCostsDetails,sentenceTermsRestitution:t.sentenceTermsRestitution,sentenceTermsRestitutionDetails:t.sentenceTermsRestitutionDetails,sentenceTermsJailPrison:t.sentenceTermsJailPrison,sentenceTermsJailPrisonDetails:t.sentenceTermsJailPrisonDetails,sentenceTermsOther:t.sentenceTermsOther,sentenceTermsOtherDetails:t.sentenceTermsOtherDetails,representedByAttorney:t.representedByAttorney,attorneyName:t.attorneyName,attorneyAddress:t.attorneyAddress,attorneyPhone:t.attorneyPhone,removableOffense:t.removableOffense,inadmissibleOffense:t.inadmissibleOffense,possibleWaiver:t.possibleWaiver}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteCriminal=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteCriminal($id: Int!) {\n          criminalHistoryDelete(id: $id) {\n            id\n            contactId\n            dateOfArrest\n            dateOfConvinction\n            districtCourtName\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getEad=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listEad: EAD(contactId: "+t.contactId+") {\n            id\n            contactId\n            surname\n            givenname\n            anum\n            cat\n            cardnum\n            cbirth\n            tc\n            dob\n            sex\n            valid\n            exp\n            travel\n            notes\n            renew5\n            renew4\n            renew3\n            renew2\n            renew1\n            expwarn\n            createdAt\n            updatedAt\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addEad=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewEad($contactId: Int!, $surname: String!, $givenname: String, $anum: String, $cat: String, $cardnum: String, $cbirth: String, $tc: String, $dob: String, $sex: String, $valid: String, $exp: String, $travel: String, $notes: String, $renew5: String, $renew4: String, $renew3: String, $renew2: String, $renew1: String, $expwarn: String) {\n          EADAdd(newEAD: {contactId: $contactId, surname: $surname, givenname: $givenname, anum: $anum, cat: $cat, cardnum: $cardnum, cbirth: $cbirth, tc: $tc, dob: $dob, sex: $sex, valid: $valid, exp: $exp, travel: $travel, notes: $notes, renew5: $renew5, renew4: $renew4, renew3: $renew3, renew2: $renew2, renew1: $renew1, expwarn: $expwarn}) {\n            id\n            contactId\n            surname\n            givenname\n            anum\n            cat\n            cardnum\n            cbirth\n            tc\n            dob\n            sex\n            valid\n            exp\n            travel\n            notes\n            renew5\n            renew4\n            renew3\n            renew2\n            renew1\n            expwarn\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{contactId:t.contactId,surname:t.surname,givenname:t.givenname,anum:t.anum,cat:t.cat,cardnum:t.cardnum,cbirth:t.cbirth,tc:t.tc,dob:t.dob,sex:t.sex,valid:t.valid,exp:t.exp,travel:t.travel,notes:t.notes,renew5:t.renew5,renew4:t.renew4,renew3:t.renew3,renew2:t.renew2,renew1:t.renew1,expwarn:t.expwarn}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editEad=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editEad($id: Int!, $contactId: Int, $surname: String, $givenname: String, $anum: String, $cat: String, $cardnum: String, $cbirth: String, $tc: String, $dob: String, $sex: String, $valid: String, $exp: String, $travel: String, $notes: String, $renew5: String, $renew4: String, $renew3: String, $renew2: String, $renew1: String, $expwarn: String) {\n          EADEdit(id: $id, editEAD: {contactId: $contactId, surname: $surname, givenname: $givenname, anum: $anum, cat: $cat, cardnum: $cardnum, cbirth: $cbirth, tc: $tc, dob: $dob, sex: $sex, valid: $valid, exp: $exp, travel: $travel, notes: $notes, renew5: $renew5, renew4: $renew4, renew3: $renew3, renew2: $renew2, renew1: $renew1, expwarn: $expwarn}) {\n            id\n            contactId\n            surname\n            givenname\n            anum\n            cat\n            cardnum\n            cbirth\n            tc\n            dob\n            sex\n            valid\n            exp\n            travel\n            notes\n            renew5\n            renew4\n            renew3\n            renew2\n            renew1\n            expwarn\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,surname:t.surname,givenname:t.givenname,anum:t.anum,cat:t.cat,cardnum:t.cardnum,cbirth:t.cbirth,tc:t.tc,dob:t.dob,sex:t.sex,valid:t.valid,exp:t.exp,travel:t.travel,notes:t.notes,renew5:t.renew5,renew4:t.renew4,renew3:t.renew3,renew2:t.renew2,renew1:t.renew1,expwarn:t.expwarn}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteEad=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteEad($id: Int!) {\n          EADDelete(id: $id) {\n            id\n            contactId\n            surname\n            givenname\n            anum\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getPassports=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listPassports: passports(contactId: "+t.contactId+") {\n            id\n            contactId\n            givenname\n            lastname\n            marriedname\n            country\n            poi\n            doi\n            doe\n            ppn\n            natid\n            dob\n            sob\n            cob\n            sex\n            other1\n            other2\n            other3\n            notes\n            createdAt\n            updatedAt\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addPassports=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewPassports($contactId: Int!, $givenname: String, $lastname: String, $marriedname: String, $country: String, $poi: String, $doi: String, $doe: String, $ppn: String!, $natid: String, $dob: String, $sob: String, $cob: String, $sex: String, $other1: String, $other2: String, $other3: String, $notes: String) {\n          passportAdd(newPassport: {contactId: $contactId, givenname: $givenname, lastname: $lastname, marriedname: $marriedname, country: $country, poi: $poi, doi: $doi, doe: $doe, ppn: $ppn, natid: $natid, dob: $dob, sob: $sob, cob: $cob, sex: $sex, other1: $other1, other2: $other2, other3: $other3, notes: $notes}) {\n            id\n            contactId\n            givenname\n            lastname\n            marriedname\n            country\n            poi\n            doi\n            doe\n            ppn\n            natid\n            dob\n            sob\n            cob\n            sex\n            other1\n            other2\n            other3\n            notes\n          }\n        }\n      ",variables:{contactId:t.contactId,givenname:t.givenname,lastname:t.lastname,marriedname:t.marriedname,country:t.country,poi:t.poi,doi:t.doi,doe:t.doe,ppn:t.ppn,natid:t.natid,dob:t.dob,sob:t.sob,cob:t.cob,sex:t.sex,other1:t.other1,other2:t.other2,other3:t.other3,notes:t.notes}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editPassports=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editPassports($id: Int!, $contactId: Int, $givenname: String, $lastname: String, $marriedname: String, $country: String, $poi: String, $doi: String, $doe: String, $ppn: String, $natid: String, $dob: String, $sob: String, $cob: String, $sex: String, $other1: String, $other2: String, $other3: String, $notes: String) {\n          passportEdit(id: $id, editPassport: {contactId: $contactId, givenname: $givenname, lastname: $lastname, marriedname: $marriedname, country: $country, poi: $poi, doi: $doi, doe: $doe, ppn: $ppn, natid: $natid, dob: $dob, sob: $sob, cob: $cob, sex: $sex, other1: $other1, other2: $other2, other3: $other3, notes: $notes}) {\n            id\n            contactId\n            givenname\n            lastname\n            marriedname\n            country\n            poi\n            doi\n            doe\n            ppn\n            natid\n            dob\n            sob\n            cob\n            sex\n            other1\n            other2\n            other3\n            notes\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,givenname:t.givenname,lastname:t.lastname,marriedname:t.marriedname,country:t.country,poi:t.poi,doi:t.doi,doe:t.doe,ppn:t.ppn,natid:t.natid,dob:t.dob,sob:t.sob,cob:t.cob,sex:t.sex,other1:t.other1,other2:t.other2,other3:t.other3,notes:t.notes}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deletePassports=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deletePassports($id: Int!) {\n          passportDelete(id: $id) {\n            id\n            contactId\n            givenname\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getTravelHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listTravelHistory: travelHistory(contactId: "+t.contactId+") {\n            id\n            contactId\n            from\n            to\n            dur\n            sixMy\n            sixMn\n            countries\n            purpose\n            authYes\n            destination\n            manner\n            inyes\n            inno\n            notes\n            authNo\n            createdAt\n            updatedAt\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addTravelHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewTravelHistory($contactId: Int!, $from: String!, $to: String!, $dur: String, $sixMyMn: String, $countries: String, $purpose: String, $authYesNo: String, $destination: String, $manner: String!, $inYesNo: String, $notes: String) {\n          travelHistoryAdd(newTravelHistory: {contactId: $contactId, from: $from, to: $to, dur: $dur, sixMyMn: $sixMyMn, countries: $countries, purpose: $purpose, authYesNo: $authYesNo, destination: $destination, manner: $manner, inYesNo: $inYesNo, notes: $notes}) {\n            id\n            contactId\n            from\n            to\n            dur\n            sixMy\n            sixMn\n            countries\n            purpose\n            authYes\n            destination\n            manner\n            inyes\n            inno\n            notes\n            authNo\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{contactId:t.contactId,from:t.from,to:t.to,dur:t.dur,sixMyMn:t.sixMyMn,countries:t.countries,purpose:t.purpose,authYesNo:t.authYesNo,destination:t.destination,manner:t.manner,inYesNo:t.inYesNo,notes:t.notes}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editTravelHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editTravelHistory($id: Int!, $contactId: Int, $from: String, $to: String, $dur: String, $sixMyMn: String, $countries: String, $purpose: String, $authYesNo: String, $destination: String, $manner: String, $inYesNo: String, $notes: String) {\n          travelHistoryEdit(id: $id, editTravelHistory: {contactId: $contactId, from: $from, to: $to, dur: $dur, sixMyMn: $sixMyMn, countries: $countries, purpose: $purpose, authYesNo: $authYesNo, destination: $destination, manner: $manner, inYesNo: $inYesNo, notes: $notes}) {\n            id\n            contactId\n            from\n            to\n            dur\n            sixMy\n            sixMn\n            countries\n            purpose\n            authYes\n            destination\n            manner\n            inyes\n            inno\n            notes\n            authNo\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,from:t.from,to:t.to,dur:t.dur,sixMyMn:t.sixMyMn,countries:t.countries,purpose:t.purpose,authYesNo:t.authYesNo,destination:t.destination,manner:t.manner,inYesNo:t.inYesNo,notes:t.notes}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteTravelHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteTravelHistory($id: Int!) {\n          travelHistoryDelete(id: $id) {\n            id\n            contactId\n            from\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getUsEntry=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listUsEntry: USEntry(contactId: "+t.contactId+") {\n            id\n            contactId\n            enterDate\n            departDate\n            statusAtEntry\n            locationOfEntry\n            locationOfDeparture\n            usCityLived\n            stoppedByCbp\n            numberOfCbpStops\n            removal\n            volReturn\n            reasonDeparture\n            duration\n            locationOfEntryCity\n            locationOfEntryState\n            classOfAdmision\n            i94\n            dateOfArrival\n            dateStayExpire\n            passportNumber\n            travelDocumentNumber\n            countryOfIssuancePassport\n            expirationDateTravelDocument\n            firstEntryEver\n            mostRecentEntry\n            destinationUponDeparture\n            mannerOfEntry\n            inspected\n            portOfDepartureCity\n            portOfDepartureState\n            createdAt\n            updatedAt\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addUsEntry=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewUsEntry($contactId: Int!, $enterDate: String!, $departDate: String, $statusAtEntry: String, $locationOfDeparture: String, $usCityLived: String, $stoppedByCbp: String, $numberOfCbpStops: String, $removal: String, $volReturn: String, $reasonDeparture: String, $duration: String, $locationOfEntryCity: String!, $locationOfEntryState: String!, $classOfAdmision: String, $i94: String, $dateOfArrival: String, $dateStayExpire: String, $passportNumber: String, $travelDocumentNumber: String, $countryOfIssuancePassport: String, $expirationDateTravelDocument: String, $firstEntryEver: String, $mostRecentEntry: String, $destinationUponDeparture: String, $mannerOfEntry: String, $inspected: String, $portOfDepartureCity: String, $portOfDepartureState: String) {\n          USEntryAdd(newUSEntry: {contactId: $contactId, enterDate: $enterDate, departDate: $departDate, statusAtEntry: $statusAtEntry, locationOfDeparture: $locationOfDeparture, usCityLived: $usCityLived, stoppedByCbp: $stoppedByCbp, numberOfCbpStops: $numberOfCbpStops, removal: $removal, volReturn: $volReturn, reasonDeparture: $reasonDeparture, duration: $duration, locationOfEntryCity: $locationOfEntryCity, locationOfEntryState: $locationOfEntryState, classOfAdmision: $classOfAdmision, i94: $i94, dateOfArrival: $dateOfArrival, dateStayExpire: $dateStayExpire, passportNumber: $passportNumber, travelDocumentNumber: $travelDocumentNumber, countryOfIssuancePassport: $countryOfIssuancePassport, expirationDateTravelDocument: $expirationDateTravelDocument, firstEntryEver: $firstEntryEver, mostRecentEntry: $mostRecentEntry, destinationUponDeparture: $destinationUponDeparture, mannerOfEntry: $mannerOfEntry, inspected: $inspected, portOfDepartureCity: $portOfDepartureCity, portOfDepartureState: $portOfDepartureState}) {\n            id\n            contactId\n            enterDate\n            departDate\n            statusAtEntry\n            locationOfDeparture\n            usCityLived\n            stoppedByCbp\n            numberOfCbpStops\n            removal\n            volReturn\n            reasonDeparture\n            duration\n            locationOfEntryCity\n            locationOfEntryState\n            classOfAdmision\n            i94\n            dateOfArrival\n            dateStayExpire\n            passportNumber\n            travelDocumentNumber\n            countryOfIssuancePassport\n            expirationDateTravelDocument\n            firstEntryEver\n            mostRecentEntry\n            destinationUponDeparture\n            mannerOfEntry\n            inspected\n            portOfDepartureCity\n            portOfDepartureState\n          }\n        }\n      ",variables:{contactId:t.contactId,enterDate:t.enterDate,departDate:t.departDate,statusAtEntry:t.statusAtEntry,locationOfDeparture:t.locationOfDeparture,usCityLived:t.usCityLived,stoppedByCbp:t.stoppedByCbp,numberOfCbpStops:t.numberOfCbpStops,removal:t.removal,volReturn:t.volReturn,reasonDeparture:t.reasonDeparture,duration:t.duration,locationOfEntryCity:t.locationOfEntryCity,locationOfEntryState:t.locationOfEntryState,classOfAdmision:t.classOfAdmision,i94:t.i94,dateOfArrival:t.dateOfArrival,dateStayExpire:t.dateStayExpire,passportNumber:t.passportNumber,travelDocumentNumber:t.travelDocumentNumber,countryOfIssuancePassport:t.countryOfIssuancePassport,expirationDateTravelDocument:t.expirationDateTravelDocument,firstEntryEver:t.firstEntryEver,mostRecentEntry:t.mostRecentEntry,destinationUponDeparture:t.destinationUponDeparture,mannerOfEntry:t.mannerOfEntry,inspected:t.inspected,portOfDepartureCity:t.portOfDepartureCity,portOfDepartureState:t.portOfDepartureState}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editUsEntry=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editUsEntry($id: Int!, $contactId: Int, $enterDate: String, $departDate: String, $statusAtEntry: String, $locationOfDeparture: String, $usCityLived: String, $stoppedByCbp: String, $numberOfCbpStops: String, $removal: String, $volReturn: String, $reasonDeparture: String, $duration: String, $locationOfEntryCity: String, $locationOfEntryState: String, $classOfAdmision: String, $i94: String, $dateOfArrival: String, $dateStayExpire: String, $passportNumber: String, $travelDocumentNumber: String, $countryOfIssuancePassport: String, $expirationDateTravelDocument: String, $firstEntryEver: String, $mostRecentEntry: String, $destinationUponDeparture: String, $mannerOfEntry: String, $inspected: String, $portOfDepartureCity: String, $portOfDepartureState: String) {\n          USEntryEdit(id: $id, editUSEntry: {contactId: $contactId, enterDate: $enterDate, departDate: $departDate, statusAtEntry: $statusAtEntry, locationOfDeparture: $locationOfDeparture, usCityLived: $usCityLived, stoppedByCbp: $stoppedByCbp, numberOfCbpStops: $numberOfCbpStops, removal: $removal, volReturn: $volReturn, reasonDeparture: $reasonDeparture, duration: $duration, locationOfEntryCity: $locationOfEntryCity, locationOfEntryState: $locationOfEntryState, classOfAdmision: $classOfAdmision, i94: $i94, dateOfArrival: $dateOfArrival, dateStayExpire: $dateStayExpire, passportNumber: $passportNumber, travelDocumentNumber: $travelDocumentNumber, countryOfIssuancePassport: $countryOfIssuancePassport, expirationDateTravelDocument: $expirationDateTravelDocument, firstEntryEver: $firstEntryEver, mostRecentEntry: $mostRecentEntry, destinationUponDeparture: $destinationUponDeparture, mannerOfEntry: $mannerOfEntry, inspected: $inspected, portOfDepartureCity: $portOfDepartureCity, portOfDepartureState: $portOfDepartureState}) {\n            id\n            contactId\n            enterDate\n            departDate\n            statusAtEntry\n            locationOfDeparture\n            usCityLived\n            stoppedByCbp\n            numberOfCbpStops\n            removal\n            volReturn\n            reasonDeparture\n            duration\n            locationOfEntryCity\n            locationOfEntryState\n            classOfAdmision\n            i94\n            dateOfArrival\n            dateStayExpire\n            passportNumber\n            travelDocumentNumber\n            countryOfIssuancePassport\n            expirationDateTravelDocument\n            firstEntryEver\n            mostRecentEntry\n            destinationUponDeparture\n            mannerOfEntry\n            inspected\n            portOfDepartureCity\n            portOfDepartureState\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,enterDate:t.enterDate,departDate:t.departDate,statusAtEntry:t.statusAtEntry,locationOfDeparture:t.locationOfDeparture,usCityLived:t.usCityLived,stoppedByCbp:t.stoppedByCbp,numberOfCbpStops:t.numberOfCbpStops,removal:t.removal,volReturn:t.volReturn,reasonDeparture:t.reasonDeparture,duration:t.duration,locationOfEntryCity:t.locationOfEntryCity,locationOfEntryState:t.locationOfEntryState,classOfAdmision:t.classOfAdmision,i94:t.i94,dateOfArrival:t.dateOfArrival,dateStayExpire:t.dateStayExpire,passportNumber:t.passportNumber,travelDocumentNumber:t.travelDocumentNumber,countryOfIssuancePassport:t.countryOfIssuancePassport,expirationDateTravelDocument:t.expirationDateTravelDocument,firstEntryEver:t.firstEntryEver,mostRecentEntry:t.mostRecentEntry,destinationUponDeparture:t.destinationUponDeparture,mannerOfEntry:t.mannerOfEntry,inspected:t.inspected,portOfDepartureCity:t.portOfDepartureCity,portOfDepartureState:t.portOfDepartureState}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteUsEntry=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteUsEntry($id: Int!) {\n          USEntryDelete(id: $id) {\n            id\n            contactId\n            enterDate\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getVisaHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listVisaHistory: visaHistory(contactId: "+t.contactId+") {\n            id\n            contactId\n            first\n            last\n            cat\n            number\n            issue\n            exp\n            poissue\n            notes\n            dosnum\n            anumber\n            renew5\n            renew4\n            renew3\n            renew2\n            renew1\n            expwarn\n            createdAt\n            updatedAt\n            statusExpires\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addVisaHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewVisaHistory($contactId: Int!, $first: String!, $last: String!, $cat: String!, $number: String!, $issue: String,$exp: String, $poissue: String, $notes: String, $dosnum: String, $anumber: String, $renew5: String, $renew4: String, $renew3: String, $renew2: String, $renew1: String, $expwarn: String, $statusExpires: String) {\n          visaHistoryAdd(newVisaHistory: {contactId: $contactId, first: $first, last: $last, cat: $cat, number: $number, issue: $issue, exp: $exp, poissue: $poissue, notes: $notes, dosnum: $dosnum, anumber: $anumber, renew5: $renew5, renew4: $renew4, renew3: $renew3, renew2: $renew2, renew1: $renew1, expwarn: $expwarn, statusExpires: $statusExpires}) {\n            id\n            contactId\n            first\n            last\n            cat\n            number\n            issue\n            exp\n            poissue\n            notes\n            dosnum\n            anumber\n            renew5\n            renew4\n            renew3\n            renew2\n            renew1\n            expwarn\n            statusExpires\n          }\n        }\n      ",variables:{contactId:t.contactId,first:t.first,last:t.last,cat:t.cat,number:t.number,issue:t.issue,exp:t.exp,poissue:t.poissue,notes:t.notes,dosnum:t.dosnum,anumber:t.anumber,renew5:t.renew5,renew4:t.renew4,renew3:t.renew3,renew2:t.renew2,renew1:t.renew1,expwarn:t.expwarn,statusExpires:t.statusExpires}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editVisaHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editVisaHistory($id: Int!, $contactId: Int, $first: String, $last: String, $cat: String, $number: String, $issue: String, $exp: String, $poissue: String, $notes: String, $dosnum: String, $anumber: String, $renew5: String, $renew4: String, $renew3: String, $renew2: String, $renew1: String, $expwarn: String, $statusExpires: String) {\n          visaHistoryEdit(id: $id, editVisaHistory: {contactId: $contactId, first: $first, last: $last, cat: $cat, number: $number, issue: $issue, exp: $exp, poissue: $poissue, notes: $notes, dosnum: $dosnum, anumber: $anumber, renew5: $renew5, renew4: $renew4, renew3: $renew3, renew2: $renew2, renew1: $renew1, expwarn: $expwarn, statusExpires: $statusExpires}) {\n            id\n            contactId\n            first\n            last\n            cat\n            number\n            issue\n            exp\n            poissue\n            notes\n            dosnum\n            anumber\n            renew5\n            renew4\n            renew3\n            renew2\n            renew1\n            expwarn\n            statusExpires\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,first:t.first,last:t.last,cat:t.cat,number:t.number,issue:t.issue,exp:t.exp,poissue:t.poissue,notes:t.notes,dosnum:t.dosnum,anumber:t.anumber,renew5:t.renew5,renew4:t.renew4,renew3:t.renew3,renew2:t.renew2,renew1:t.renew1,expwarn:t.expwarn,statusExpires:t.statusExpires}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteVisaHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteVisaHistory($id: Int!) {\n          visaHistoryDelete(id: $id) {\n            id\n            contactId\n            first\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getMarriageHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listMarriageHistory: marriageHistory(contactId: "+t.contactId+") {\n            id\n            contactId\n            firstName\n            lastName\n            middleName\n            maidenName\n            dateMarriage\n            dateOfSeparation\n            dateOfDivorce\n            dateOfDeath\n            placeMarriageCity\n            placeMarriageState\n            placeDivorceCity\n            placeDivorceState\n            notes\n            createdAt\n            updatedAt\n            placeMarriageProvince\n            placeMarriageCountry\n            placeOfBirthCity\n            placeOfBirthState\n            placeOfBirthCountry\n            dateOfBirth\n            citizenship\n            dateOfTermination\n            placeMarriageEndedCity\n            placeMarriageEndedState\n            placeMarriageEndedCountry\n            mannerMarriageEnded\n            isCurrent\n            placeOfResidenceAddress\n            placeOfResidenceLine2\n            placeOfResidenceApt\n            placeOfResidenceSte\n            placeOfResidenceFlr\n            placeOfResidenceAptSteFlrNumbertxt\n            placeOfResidenceCity\n            placeOfResidenceState\n            placeOfResidenceCountry\n            placeOfResidenceZipCode\n            placeOfResidenceForeignProvince\n            placeOfResidencePostalCode\n            passportNumber\n            socialSecurityNumber\n            nationality\n            race\n            inTheUsYes\n            inTheUsNo\n            lastEntryCity\n            lastEntryState\n            lastEntryDate\n            i94\n            lastEntryStatus\n            expirationAuthorizedStay\n            immigrationCourtProceedingsYes\n            immigrationCourtProceedingsNo\n            aNumber\n            sexMaleCk\n            sexFemaleCk\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addMarriageHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addMarriageHistory($contactId: Int!, $firstName: String!, $lastName: String!, $middleName: String, $maidenName: String, $dateMarriage: String, $dateOfSeparation: String, $dateOfDivorce: String, $dateOfDeath: String, $placeMarriageCity: String, $placeMarriageState: String, $placeDivorceCity: String, $placeDivorceState: String, $notes: String, $placeMarriageProvince: String, $placeMarriageCountry: String, $placeOfBirthCity: String, $placeOfBirthState: String, $placeOfBirthCountry: String, $dateOfBirth: String, $citizenship: String, $dateOfTermination: String, $placeMarriageEndedCity: String, $placeMarriageEndedState: String, $placeMarriageEndedCountry: String, $mannerMarriageEnded: String, $isCurrent: String, $placeOfResidenceAddress: String, $placeOfResidenceLine2: String, $isAptSteFloor: String, $placeOfResidenceAptSteFlrNumbertxt: String, $placeOfResidenceCity: String, $placeOfResidenceState: String, $placeOfResidenceCountry: String, $placeOfResidenceZipCode: String, $placeOfResidenceForeignProvince: String, $placeOfResidencePostalCode: String, $passportNumber: String, $socialSecurityNumber: String, $nationality: String, $race: String, $inTheUsYesNo: String, $lastEntryCity: String, $lastEntryState: String, $lastEntryDate: String, $i94: String, $lastEntryStatus: String, $expirationAuthorizedStay: String, $immigrationCourtProceedingsYesNo: String, $aNumber: String, $sex: String) {\n          marriageHistoryAdd(newMarriageHistory: {contactId: $contactId,firstName: $firstName,lastName: $lastName,middleName: $middleName,maidenName: $maidenName,dateMarriage: $dateMarriage,dateOfSeparation: $dateOfSeparation,dateOfDivorce: $dateOfDivorce,dateOfDeath: $dateOfDeath,placeMarriageCity: $placeMarriageCity,placeMarriageState: $placeMarriageState,placeDivorceCity: $placeDivorceCity,placeDivorceState: $placeDivorceState,notes: $notes,placeMarriageProvince: $placeMarriageProvince,placeMarriageCountry: $placeMarriageCountry,placeOfBirthCity: $placeOfBirthCity,placeOfBirthState: $placeOfBirthState,placeOfBirthCountry: $placeOfBirthCountry,dateOfBirth: $dateOfBirth,citizenship: $citizenship,dateOfTermination: $dateOfTermination,placeMarriageEndedCity: $placeMarriageEndedCity,placeMarriageEndedState: $placeMarriageEndedState,placeMarriageEndedCountry: $placeMarriageEndedCountry,mannerMarriageEnded: $mannerMarriageEnded,isCurrent: $isCurrent,placeOfResidenceAddress: $placeOfResidenceAddress,placeOfResidenceLine2: $placeOfResidenceLine2,isAptSteFloor: $isAptSteFloor,placeOfResidenceAptSteFlrNumbertxt: $placeOfResidenceAptSteFlrNumbertxt,placeOfResidenceCity: $placeOfResidenceCity,placeOfResidenceState: $placeOfResidenceState,placeOfResidenceCountry: $placeOfResidenceCountry,placeOfResidenceZipCode: $placeOfResidenceZipCode,placeOfResidenceForeignProvince: $placeOfResidenceForeignProvince,placeOfResidencePostalCode: $placeOfResidencePostalCode,passportNumber: $passportNumber,socialSecurityNumber: $socialSecurityNumber,nationality: $nationality,race: $race,inTheUsYesNo: $inTheUsYesNo,lastEntryCity: $lastEntryCity,lastEntryState: $lastEntryState,lastEntryDate: $lastEntryDate,i94: $i94,lastEntryStatus: $lastEntryStatus,expirationAuthorizedStay: $expirationAuthorizedStay,immigrationCourtProceedingsYesNo: $immigrationCourtProceedingsYesNo,aNumber: $aNumber,sex: $sex}) {\n            id\n            contactId\n            firstName\n            lastName\n            middleName\n            maidenName\n            dateMarriage\n            dateOfSeparation\n            dateOfDivorce\n            dateOfDeath\n            placeMarriageCity\n            placeMarriageState\n            placeDivorceCity\n            placeDivorceState\n            notes\n            createdAt\n            updatedAt\n            placeMarriageProvince\n            placeMarriageCountry\n            placeOfBirthCity\n            placeOfBirthState\n            placeOfBirthCountry\n            dateOfBirth\n            citizenship\n            dateOfTermination\n            placeMarriageEndedCity\n            placeMarriageEndedState\n            placeMarriageEndedCountry\n            mannerMarriageEnded\n            isCurrent\n            placeOfResidenceAddress\n            placeOfResidenceLine2\n            placeOfResidenceApt\n            placeOfResidenceSte\n            placeOfResidenceFlr\n            placeOfResidenceAptSteFlrNumbertxt\n            placeOfResidenceCity\n            placeOfResidenceState\n            placeOfResidenceCountry\n            placeOfResidenceZipCode\n            placeOfResidenceForeignProvince\n            placeOfResidencePostalCode\n            passportNumber\n            socialSecurityNumber\n            nationality\n            race\n            inTheUsYes\n            inTheUsNo\n            lastEntryCity\n            lastEntryState\n            lastEntryDate\n            i94\n            lastEntryStatus\n            expirationAuthorizedStay\n            immigrationCourtProceedingsYes\n            immigrationCourtProceedingsNo\n            aNumber\n            sexMaleCk\n            sexFemaleCk\n          }\n        }\n      ",variables:{contactId:t.contactId,firstName:t.firstName,lastName:t.lastName,middleName:t.middleName,maidenName:t.maidenName,dateMarriage:t.dateMarriage,dateOfSeparation:t.dateOfSeparation,dateOfDivorce:t.dateOfDivorce,dateOfDeath:t.dateOfDeath,placeMarriageCity:t.placeMarriageCity,placeMarriageState:t.placeMarriageState,placeDivorceCity:t.placeDivorceCity,placeDivorceState:t.placeDivorceState,notes:t.notes,placeMarriageProvince:t.placeMarriageProvince,placeMarriageCountry:t.placeMarriageCountry,placeOfBirthCity:t.placeOfBirthCity,placeOfBirthState:t.placeOfBirthState,placeOfBirthCountry:t.placeOfBirthCountry,dateOfBirth:t.dateOfBirth,citizenship:t.citizenship,dateOfTermination:t.dateOfTermination,placeMarriageEndedCity:t.placeMarriageEndedCity,placeMarriageEndedState:t.placeMarriageEndedState,placeMarriageEndedCountry:t.placeMarriageEndedCountry,mannerMarriageEnded:t.mannerMarriageEnded,isCurrent:t.isCurrent,placeOfResidenceAddress:t.placeOfResidenceAddress,placeOfResidenceLine2:t.placeOfResidenceLine2,isAptSteFloor:t.isAptSteFloor,placeOfResidenceAptSteFlrNumbertxt:t.placeOfResidenceAptSteFlrNumbertxt,placeOfResidenceCity:t.placeOfResidenceCity,placeOfResidenceState:t.placeOfResidenceState,placeOfResidenceCountry:t.placeOfResidenceCountry,placeOfResidenceZipCode:t.placeOfResidenceZipCode,placeOfResidenceForeignProvince:t.placeOfResidenceForeignProvince,placeOfResidencePostalCode:t.placeOfResidencePostalCode,passportNumber:t.passportNumber,socialSecurityNumber:t.socialSecurityNumber,nationality:t.nationality,race:t.race,inTheUsYesNo:t.inTheUsYesNo,lastEntryCity:t.lastEntryCity,lastEntryState:t.lastEntryState,lastEntryDate:t.lastEntryDate,i94:t.i94,lastEntryStatus:t.lastEntryStatus,expirationAuthorizedStay:t.expirationAuthorizedStay,immigrationCourtProceedingsYesNo:t.immigrationCourtProceedingsYesNo,aNumber:t.aNumber,sex:t.sex}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editMarriageHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editMarriageHistory($id: Int!, $contactId: Int, $firstName: String, $lastName: String, $middleName: String, $maidenName: String, $dateMarriage: String, $dateOfSeparation: String, $dateOfDivorce: String, $dateOfDeath: String, $placeMarriageCity: String, $placeMarriageState: String, $placeDivorceCity: String, $placeDivorceState: String, $notes: String, $placeMarriageProvince: String, $placeMarriageCountry: String, $placeOfBirthCity: String, $placeOfBirthState: String, $placeOfBirthCountry: String, $dateOfBirth: String, $citizenship: String, $dateOfTermination: String, $placeMarriageEndedCity: String, $placeMarriageEndedState: String, $placeMarriageEndedCountry: String, $mannerMarriageEnded: String, $isCurrent: String, $placeOfResidenceAddress: String, $placeOfResidenceLine2: String, $isAptSteFloor: String, $placeOfResidenceAptSteFlrNumbertxt: String, $placeOfResidenceCity: String, $placeOfResidenceState: String, $placeOfResidenceCountry: String, $placeOfResidenceZipCode: String, $placeOfResidenceForeignProvince: String, $placeOfResidencePostalCode: String, $passportNumber: String, $socialSecurityNumber: String, $nationality: String, $race: String, $inTheUsYesNo: String, $lastEntryCity: String, $lastEntryState: String, $lastEntryDate: String, $i94: String, $lastEntryStatus: String, $expirationAuthorizedStay: String, $immigrationCourtProceedingsYesNo: String, $aNumber: String, $sex: String) {\n          marriageHistoryEdit(id: $id, editMarriageHistory: {contactId: $contactId,firstName: $firstName,lastName: $lastName,middleName: $middleName,maidenName: $maidenName,dateMarriage: $dateMarriage,dateOfSeparation: $dateOfSeparation,dateOfDivorce: $dateOfDivorce,dateOfDeath: $dateOfDeath,placeMarriageCity: $placeMarriageCity,placeMarriageState: $placeMarriageState,placeDivorceCity: $placeDivorceCity,placeDivorceState: $placeDivorceState,notes: $notes,placeMarriageProvince: $placeMarriageProvince,placeMarriageCountry: $placeMarriageCountry,placeOfBirthCity: $placeOfBirthCity,placeOfBirthState: $placeOfBirthState,placeOfBirthCountry: $placeOfBirthCountry,dateOfBirth: $dateOfBirth,citizenship: $citizenship,dateOfTermination: $dateOfTermination,placeMarriageEndedCity: $placeMarriageEndedCity,placeMarriageEndedState: $placeMarriageEndedState,placeMarriageEndedCountry: $placeMarriageEndedCountry,mannerMarriageEnded: $mannerMarriageEnded,isCurrent: $isCurrent,placeOfResidenceAddress: $placeOfResidenceAddress,placeOfResidenceLine2: $placeOfResidenceLine2,isAptSteFloor: $isAptSteFloor,placeOfResidenceAptSteFlrNumbertxt: $placeOfResidenceAptSteFlrNumbertxt,placeOfResidenceCity: $placeOfResidenceCity,placeOfResidenceState: $placeOfResidenceState,placeOfResidenceCountry: $placeOfResidenceCountry,placeOfResidenceZipCode: $placeOfResidenceZipCode,placeOfResidenceForeignProvince: $placeOfResidenceForeignProvince,placeOfResidencePostalCode: $placeOfResidencePostalCode,passportNumber: $passportNumber,socialSecurityNumber: $socialSecurityNumber,nationality: $nationality,race: $race,inTheUsYesNo: $inTheUsYesNo,lastEntryCity: $lastEntryCity,lastEntryState: $lastEntryState,lastEntryDate: $lastEntryDate,i94: $i94,lastEntryStatus: $lastEntryStatus,expirationAuthorizedStay: $expirationAuthorizedStay,immigrationCourtProceedingsYesNo: $immigrationCourtProceedingsYesNo,aNumber: $aNumber,sex: $sex}) {\n            id\n            contactId\n            firstName\n            lastName\n            middleName\n            maidenName\n            dateMarriage\n            dateOfSeparation\n            dateOfDivorce\n            dateOfDeath\n            placeMarriageCity\n            placeMarriageState\n            placeDivorceCity\n            placeDivorceState\n            notes\n            createdAt\n            updatedAt\n            placeMarriageProvince\n            placeMarriageCountry\n            placeOfBirthCity\n            placeOfBirthState\n            placeOfBirthCountry\n            dateOfBirth\n            citizenship\n            dateOfTermination\n            placeMarriageEndedCity\n            placeMarriageEndedState\n            placeMarriageEndedCountry\n            mannerMarriageEnded\n            isCurrent\n            placeOfResidenceAddress\n            placeOfResidenceLine2\n            placeOfResidenceApt\n            placeOfResidenceSte\n            placeOfResidenceFlr\n            placeOfResidenceAptSteFlrNumbertxt\n            placeOfResidenceCity\n            placeOfResidenceState\n            placeOfResidenceCountry\n            placeOfResidenceZipCode\n            placeOfResidenceForeignProvince\n            placeOfResidencePostalCode\n            passportNumber\n            socialSecurityNumber\n            nationality\n            race\n            inTheUsYes\n            inTheUsNo\n            lastEntryCity\n            lastEntryState\n            lastEntryDate\n            i94\n            lastEntryStatus\n            expirationAuthorizedStay\n            immigrationCourtProceedingsYes\n            immigrationCourtProceedingsNo\n            aNumber\n            sexMaleCk\n            sexFemaleCk\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,firstName:t.firstName,lastName:t.lastName,middleName:t.middleName,maidenName:t.maidenName,dateMarriage:t.dateMarriage,dateOfSeparation:t.dateOfSeparation,dateOfDivorce:t.dateOfDivorce,dateOfDeath:t.dateOfDeath,placeMarriageCity:t.placeMarriageCity,placeMarriageState:t.placeMarriageState,placeDivorceCity:t.placeDivorceCity,placeDivorceState:t.placeDivorceState,notes:t.notes,placeMarriageProvince:t.placeMarriageProvince,placeMarriageCountry:t.placeMarriageCountry,placeOfBirthCity:t.placeOfBirthCity,placeOfBirthState:t.placeOfBirthState,placeOfBirthCountry:t.placeOfBirthCountry,dateOfBirth:t.dateOfBirth,citizenship:t.citizenship,dateOfTermination:t.dateOfTermination,placeMarriageEndedCity:t.placeMarriageEndedCity,placeMarriageEndedState:t.placeMarriageEndedState,placeMarriageEndedCountry:t.placeMarriageEndedCountry,mannerMarriageEnded:t.mannerMarriageEnded,isCurrent:t.isCurrent,placeOfResidenceAddress:t.placeOfResidenceAddress,placeOfResidenceLine2:t.placeOfResidenceLine2,isAptSteFloor:t.isAptSteFloor,placeOfResidenceAptSteFlrNumbertxt:t.placeOfResidenceAptSteFlrNumbertxt,placeOfResidenceCity:t.placeOfResidenceCity,placeOfResidenceState:t.placeOfResidenceState,placeOfResidenceCountry:t.placeOfResidenceCountry,placeOfResidenceZipCode:t.placeOfResidenceZipCode,placeOfResidenceForeignProvince:t.placeOfResidenceForeignProvince,placeOfResidencePostalCode:t.placeOfResidencePostalCode,passportNumber:t.passportNumber,socialSecurityNumber:t.socialSecurityNumber,nationality:t.nationality,race:t.race,inTheUsYesNo:t.inTheUsYesNo,lastEntryCity:t.lastEntryCity,lastEntryState:t.lastEntryState,lastEntryDate:t.lastEntryDate,i94:t.i94,lastEntryStatus:t.lastEntryStatus,expirationAuthorizedStay:t.expirationAuthorizedStay,immigrationCourtProceedingsYesNo:t.immigrationCourtProceedingsYesNo,aNumber:t.aNumber,sex:t.sex}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteMarriageHistory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteMarriageHistory($id: Int!) {\n          marriageHistoryDelete(id: $id) {\n            id\n            contactId\n            firstName\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getFamilyMembers=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listFamilyMembers: familyMembers(contactId: "+t.contactId+") {\n            id\n            contactId\n            firstName\n            lastName\n            middleName\n            dateOfBirth\n            placeOfBirthCity\n            placeOfBirthState\n            placeOfBirthCountry\n            placeOfResidenceCity\n            placeOfResidenceState\n            placeOfResidenceCountry\n            relationship\n            usLegalStatus\n            deceased\n            createdAt\n            updatedAt\n            sexMaleCk\n            sexFemaleCk\n            aNumber\n            maidenName\n            placeOfResidenceAddress\n            placeOfResidenceLine2\n            placeOfResidenceApt\n            placeOfResidenceSte\n            placeOfResidenceFlr\n            placeOfResidenceAptSteFlrNumbertxt\n            placeOfResidenceZipCode\n            placeOfResidenceForeignProvince\n            placeOfResidencePostalCode\n            passportNumber\n            maritalStatus\n            socialSecurityNumber\n            nationality\n            race\n            inTheUsYes\n            inTheUsNo\n            lastEntryCity\n            lastEntryState\n            lastEntryDate\n            i94\n            lastEntryStatus\n            expirationAuthorizedStay\n            immigrationCourtProceedingsYes\n            immigrationCourtProceedingsNo\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addFamilyMembers=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addFamilyMembers($contactId: Int!, $firstName: String!, $lastName: String!, $middleName: String, $dateOfBirth: String, $placeOfBirthCity: String, $placeOfBirthState: String, $placeOfBirthCountry: String, $placeOfResidenceCity: String, $placeOfResidenceState: String, $placeOfResidenceCountry: String, $relationship: String, $usLegalStatus: String, $deceased: String, $sex: String, $aNumber: String, $maidenName: String, $placeOfResidenceAddress: String, $placeOfResidenceLine2: String, $isAptSteFloor: String, $placeOfResidenceAptSteFlrNumbertxt: String, $placeOfResidenceZipCode: String, $placeOfResidenceForeignProvince: String, $placeOfResidencePostalCode: String, $passportNumber: String, $maritalStatus: String, $socialSecurityNumber: String, $nationality: String, $race: String, $inTheUsYesNo: String, $lastEntryCity: String, $lastEntryState: String, $lastEntryDate: String, $i94: String, $lastEntryStatus: String, $expirationAuthorizedStay: String, $immigrationCourtProceedingsYesNo: String) {\n          familyMembersAdd(newFamilyMember: {contactId: $contactId,firstName: $firstName,lastName: $lastName,middleName: $middleName,dateOfBirth: $dateOfBirth,placeOfBirthCity: $placeOfBirthCity,placeOfBirthState: $placeOfBirthState,placeOfBirthCountry: $placeOfBirthCountry,placeOfResidenceCity: $placeOfResidenceCity,placeOfResidenceState: $placeOfResidenceState,placeOfResidenceCountry: $placeOfResidenceCountry,relationship: $relationship,usLegalStatus: $usLegalStatus,deceased: $deceased,sex: $sex,aNumber: $aNumber,maidenName: $maidenName,placeOfResidenceAddress: $placeOfResidenceAddress,placeOfResidenceLine2: $placeOfResidenceLine2,isAptSteFloor: $isAptSteFloor,placeOfResidenceAptSteFlrNumbertxt: $placeOfResidenceAptSteFlrNumbertxt,placeOfResidenceZipCode: $placeOfResidenceZipCode,placeOfResidenceForeignProvince: $placeOfResidenceForeignProvince,placeOfResidencePostalCode: $placeOfResidencePostalCode,passportNumber: $passportNumber,maritalStatus: $maritalStatus,socialSecurityNumber: $socialSecurityNumber,nationality: $nationality,race: $race,inTheUsYesNo: $inTheUsYesNo,lastEntryCity: $lastEntryCity,lastEntryState: $lastEntryState,lastEntryDate: $lastEntryDate,i94: $i94,lastEntryStatus: $lastEntryStatus,expirationAuthorizedStay: $expirationAuthorizedStay,immigrationCourtProceedingsYesNo: $immigrationCourtProceedingsYesNo}) {\n            contactId\n            firstName\n            lastName\n            middleName\n            dateOfBirth\n            placeOfBirthCity\n            placeOfBirthState\n            placeOfBirthCountry\n            placeOfResidenceCity\n            placeOfResidenceState\n            placeOfResidenceCountry\n            relationship\n            usLegalStatus\n            deceased\n            createdAt\n            updatedAt\n            sexMaleCk\n            sexFemaleCk\n            aNumber\n            maidenName\n            placeOfResidenceAddress\n            placeOfResidenceLine2\n            placeOfResidenceApt\n            placeOfResidenceSte\n            placeOfResidenceFlr\n            placeOfResidenceAptSteFlrNumbertxt\n            placeOfResidenceZipCode\n            placeOfResidenceForeignProvince\n            placeOfResidencePostalCode\n            passportNumber\n            maritalStatus\n            socialSecurityNumber\n            nationality\n            race\n            inTheUsYes\n            inTheUsNo\n            lastEntryCity\n            lastEntryState\n            lastEntryDate\n            i94\n            lastEntryStatus\n            expirationAuthorizedStay\n            immigrationCourtProceedingsYes\n            immigrationCourtProceedingsNo\n          }\n        }\n      ",variables:{contactId:t.contactId,firstName:t.firstName,lastName:t.lastName,middleName:t.middleName,dateOfBirth:t.dateOfBirth,placeOfBirthCity:t.placeOfBirthCity,placeOfBirthState:t.placeOfBirthState,placeOfBirthCountry:t.placeOfBirthCountry,placeOfResidenceCity:t.placeOfResidenceCity,placeOfResidenceState:t.placeOfResidenceState,placeOfResidenceCountry:t.placeOfResidenceCountry,relationship:t.relationship,usLegalStatus:t.usLegalStatus,deceased:t.deceased,sex:t.sex,aNumber:t.aNumber,maidenName:t.maidenName,placeOfResidenceAddress:t.placeOfResidenceAddress,placeOfResidenceLine2:t.placeOfResidenceLine2,isAptSteFloor:t.isAptSteFloor,placeOfResidenceAptSteFlrNumbertxt:t.placeOfResidenceAptSteFlrNumbertxt,placeOfResidenceZipCode:t.placeOfResidenceZipCode,placeOfResidenceForeignProvince:t.placeOfResidenceForeignProvince,placeOfResidencePostalCode:t.placeOfResidencePostalCode,passportNumber:t.passportNumber,maritalStatus:t.maritalStatus,socialSecurityNumber:t.socialSecurityNumber,nationality:t.nationality,race:t.race,inTheUsYesNo:t.inTheUsYesNo,lastEntryCity:t.lastEntryCity,lastEntryState:t.lastEntryState,lastEntryDate:t.lastEntryDate,i94:t.i94,lastEntryStatus:t.lastEntryStatus,expirationAuthorizedStay:t.expirationAuthorizedStay,immigrationCourtProceedingsYesNo:t.immigrationCourtProceedingsYesNo}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editFamilyMembers=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editFamilyMembers($id: Int!, $contactId: Int, $firstName: String, $lastName: String, $middleName: String, $dateOfBirth: String, $placeOfBirthCity: String, $placeOfBirthState: String, $placeOfBirthCountry: String, $placeOfResidenceCity: String, $placeOfResidenceState: String, $placeOfResidenceCountry: String, $relationship: String, $usLegalStatus: String, $deceased: String, $sex: String, $aNumber: String, $maidenName: String, $placeOfResidenceAddress: String, $placeOfResidenceLine2: String, $isAptSteFloor: String, $placeOfResidenceAptSteFlrNumbertxt: String, $placeOfResidenceZipCode: String, $placeOfResidenceForeignProvince: String, $placeOfResidencePostalCode: String, $passportNumber: String, $maritalStatus: String, $socialSecurityNumber: String, $nationality: String, $race: String, $inTheUsYesNo: String, $lastEntryCity: String, $lastEntryState: String, $lastEntryDate: String, $i94: String, $lastEntryStatus: String, $expirationAuthorizedStay: String, $immigrationCourtProceedingsYesNo: String) {\n          familyMembersEdit(id: $id, editFamilyMember: {contactId: $contactId,firstName: $firstName,lastName: $lastName,middleName: $middleName,dateOfBirth: $dateOfBirth,placeOfBirthCity: $placeOfBirthCity,placeOfBirthState: $placeOfBirthState,placeOfBirthCountry: $placeOfBirthCountry,placeOfResidenceCity: $placeOfResidenceCity,placeOfResidenceState: $placeOfResidenceState,placeOfResidenceCountry: $placeOfResidenceCountry,relationship: $relationship,usLegalStatus: $usLegalStatus,deceased: $deceased,sex: $sex,aNumber: $aNumber,maidenName: $maidenName,placeOfResidenceAddress: $placeOfResidenceAddress,placeOfResidenceLine2: $placeOfResidenceLine2,isAptSteFloor: $isAptSteFloor,placeOfResidenceAptSteFlrNumbertxt: $placeOfResidenceAptSteFlrNumbertxt,placeOfResidenceZipCode: $placeOfResidenceZipCode,placeOfResidenceForeignProvince: $placeOfResidenceForeignProvince,placeOfResidencePostalCode: $placeOfResidencePostalCode,passportNumber: $passportNumber,maritalStatus: $maritalStatus,socialSecurityNumber: $socialSecurityNumber,nationality: $nationality,race: $race,inTheUsYesNo: $inTheUsYesNo,lastEntryCity: $lastEntryCity,lastEntryState: $lastEntryState,lastEntryDate: $lastEntryDate,i94: $i94,lastEntryStatus: $lastEntryStatus,expirationAuthorizedStay: $expirationAuthorizedStay,immigrationCourtProceedingsYesNo: $immigrationCourtProceedingsYesNo}) {\n            id\n            contactId\n            firstName\n            lastName\n            middleName\n            dateOfBirth\n            placeOfBirthCity\n            placeOfBirthState\n            placeOfBirthCountry\n            placeOfResidenceCity\n            placeOfResidenceState\n            placeOfResidenceCountry\n            relationship\n            usLegalStatus\n            deceased\n            createdAt\n            updatedAt\n            sexMaleCk\n            sexFemaleCk\n            aNumber\n            maidenName\n            placeOfResidenceAddress\n            placeOfResidenceLine2\n            placeOfResidenceApt\n            placeOfResidenceSte\n            placeOfResidenceFlr\n            placeOfResidenceAptSteFlrNumbertxt\n            placeOfResidenceZipCode\n            placeOfResidenceForeignProvince\n            placeOfResidencePostalCode\n            passportNumber\n            maritalStatus\n            socialSecurityNumber\n            nationality\n            race\n            inTheUsYes\n            inTheUsNo\n            lastEntryCity\n            lastEntryState\n            lastEntryDate\n            i94\n            lastEntryStatus\n            expirationAuthorizedStay\n            immigrationCourtProceedingsYes\n            immigrationCourtProceedingsNo\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,firstName:t.firstName,lastName:t.lastName,middleName:t.middleName,dateOfBirth:t.dateOfBirth,placeOfBirthCity:t.placeOfBirthCity,placeOfBirthState:t.placeOfBirthState,placeOfBirthCountry:t.placeOfBirthCountry,placeOfResidenceCity:t.placeOfResidenceCity,placeOfResidenceState:t.placeOfResidenceState,placeOfResidenceCountry:t.placeOfResidenceCountry,relationship:t.relationship,usLegalStatus:t.usLegalStatus,deceased:t.deceased,sex:t.sex,aNumber:t.aNumber,maidenName:t.maidenName,placeOfResidenceAddress:t.placeOfResidenceAddress,placeOfResidenceLine2:t.placeOfResidenceLine2,isAptSteFloor:t.isAptSteFloor,placeOfResidenceAptSteFlrNumbertxt:t.placeOfResidenceAptSteFlrNumbertxt,placeOfResidenceZipCode:t.placeOfResidenceZipCode,placeOfResidenceForeignProvince:t.placeOfResidenceForeignProvince,placeOfResidencePostalCode:t.placeOfResidencePostalCode,passportNumber:t.passportNumber,maritalStatus:t.maritalStatus,socialSecurityNumber:t.socialSecurityNumber,nationality:t.nationality,race:t.race,inTheUsYesNo:t.inTheUsYesNo,lastEntryCity:t.lastEntryCity,lastEntryState:t.lastEntryState,lastEntryDate:t.lastEntryDate,i94:t.i94,lastEntryStatus:t.lastEntryStatus,expirationAuthorizedStay:t.expirationAuthorizedStay,immigrationCourtProceedingsYesNo:t.immigrationCourtProceedingsYesNo}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteFamilyMembers=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteFamilyMembers($id: Int!) {\n          familyMembersDelete(id: $id) {\n            id\n            contactId\n            firstName\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getAdvanceParole=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          listAdvanceParole: advanceParole(contactId: "+t.contactId+") {\n            id\n            contactId\n            receiptnum\n            receiptdate\n            anum\n            validfrom\n            validuntil\n            country\n            othercountry\n            under\n            notes\n            createdAt\n            updatedAt\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addAdvanceParole=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addNewAdvanceParole($contactId: Int!, $receiptnum: String!, $receiptdate: String!, $anum: String, $validfrom: String, $validuntil: String, $country: String!, $othercountry: String, $under: String, $notes: String) {\n          advanceParoleAdd(newAdvanceParole: {contactId: $contactId, receiptnum: $receiptnum, receiptdate: $receiptdate, anum: $anum, validfrom: $validfrom, validuntil: $validuntil, country: $country, othercountry: $othercountry, under: $under, notes: $notes}) {\n            id\n            contactId\n            receiptnum\n            receiptdate\n            anum\n            validfrom\n            validuntil\n            country\n            othercountry\n            under\n            notes\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{contactId:t.contactId,receiptnum:t.receiptnum,receiptdate:t.receiptdate,anum:t.anum,validfrom:t.validfrom,validuntil:t.validuntil,country:t.country,othercountry:t.othercountry,under:t.under,notes:t.notes}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editAdvanceParole=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editAdvanceParole($id: Int!, $contactId: Int, $receiptnum: String, $receiptdate: String, $anum: String, $validfrom: String, $validuntil: String, $country: String, $othercountry: String, $under: String, $notes: String) {\n          advanceParoleEdit(id: $id, editAdvanceParole: {contactId: $contactId, receiptnum: $receiptnum, receiptdate: $receiptdate, anum: $anum, validfrom: $validfrom, validuntil: $validuntil, country: $country, othercountry: $othercountry, under: $under, notes: $notes}) {\n            id\n            contactId\n            receiptnum\n            receiptdate\n            anum\n            validfrom\n            validuntil\n            country\n            othercountry\n            under\n            notes\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{id:t.id,contactId:t.contactId,receiptnum:t.receiptnum,receiptdate:t.receiptdate,anum:t.anum,validfrom:t.validfrom,validuntil:t.validuntil,country:t.country,othercountry:t.othercountry,under:t.under,notes:t.notes}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteAdvanceParole=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteAdvanceParole($id: Int!) {\n          advanceParoleDelete(id: $id) {\n            id\n            contactId\n            receiptnum\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseForms=function(t){var e="",n={"Access-Control-Allow-Origin":"*"};return!0===t.requestClient?(e=Mt,n.authorization=t.token):(e=Nt,n["x-access-token"]=t.token),wt()({url:e,method:"post",headers:n,data:{query:'\n        query casesForm {\n          casesForms(_id: "'+t.caseFormId+'") {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            font\n            revisionDate\n            expireDate\n            properties\n            fields\n            buffer\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseFormsClient=function(t){return wt()({url:Mt,method:"post",headers:{authorization:t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query casesForm {\n          casesForms(_id: "'+t.caseFormId+'") {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            font\n            revisionDate\n            expireDate\n            properties\n            fields\n            buffer\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getTemplate=function(t){var e="",n={"Access-Control-Allow-Origin":"*"};return!0===t.requestClient?(e=Mt,n.authorization=t.token):(e=Nt,n["x-access-token"]=t.token),wt()({url:e,method:"post",headers:n,data:{query:'\n        query formTemplate {\n          templates(formIdMongo: "'+t.formId+'") {\n            _id\n            formId\n            name\n            widgetLabels\n            checkboxGroups\n            chGroups\n            pages\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateFieldCaseForm=function(t){var e="",n={"Access-Control-Allow-Origin":"*"};return!0===t.requestClient?(e=Mt,n.authorization=t.token):(e=Nt,n["x-access-token"]=t.token),wt()({url:e,method:"post",headers:n,data:{query:"\n        mutation updateField(\n          $caseFormId: String!\n          $fieldId: String!\n          $value: String!\n          $typeEdit: String!\n          $pdfField: String!\n          $model: String!\n          $reverse: Boolean!\n        ) {\n          caseFormUpdateField(\n            updateField: {\n              caseFormId: $caseFormId\n              fieldId: $fieldId\n              value: $value\n              typeEdit: $typeEdit\n              pdfField: $pdfField\n              model: $model\n              reverse: $reverse\n            }\n          ) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            font\n            revisionDate\n            expireDate\n            properties\n            fields\n            buffer\n            tenantCode\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n            doReverse\n          }\n        }\n      ",variables:{caseFormId:t.caseFormId,fieldId:t.fieldId,pdfField:t.pdfField,value:t.value,typeEdit:t.typeEdit,model:t.model,reverse:t.reverse}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateBufferCaseForm=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation updateBuffer(\n          $fields: JSON!\n        ) {\n          caseFormBuffer(\n            updateBuffer: {\n              fields: $fields\n            } \n          ) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            font\n            revisionDate\n            expireDate\n            properties\n            fields\n            buffer\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n          }\n        }\n      ",variables:{fields:t.fields}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateBufferCaseFormMasive=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation updateBuffer(\n          $fields: JSON!\n          $bulk: Boolean\n        ) {\n          caseFormBuffer(\n            updateBuffer: {\n              fields: $fields\n            },\n            bulk: $bulk\n          ) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            font\n            revisionDate\n            expireDate\n            properties\n            fields\n            buffer\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n          }\n        }\n      ",variables:{bulk:t.bulk,fields:t.fields}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateFontSizeCaseForm=function(t){var e="",n={"Access-Control-Allow-Origin":"*"};return!0===t.requestClient?(e=Mt,n.authorization=t.token):(e=Nt,n["x-access-token"]=t.token),wt()({url:e,method:"post",headers:n,data:{query:"\n        mutation updateFont($caseFormId: String! $size: Float! $type: String) {\n          caseFormFont (\n            caseFormId: $caseFormId\n            size: $size\n            type: $type\n          ) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            font\n            revisionDate\n            expireDate\n            properties\n            fields\n            buffer\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n          }\n        }\n      ",variables:{caseFormId:t.caseFormId,size:t.size,type:t.font}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.setReverseAutofill=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation setReverseEnable($caseFormId: String! $reverse: Boolean!) {\n          caseFormEnableReverse (\n            caseFormId: $caseFormId\n            reverse: $reverse\n          ) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            font\n            revisionDate\n            expireDate\n            properties\n            fields\n            buffer\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n          }\n        }\n      ",variables:{caseFormId:t.caseFormId,reverse:t.reverse}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateReverseCaseForm=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation updateReverseInformation($data: reverseAutofill! $buffer: Boolean) {\n          caseFormReverseAutofill (\n            data: $data\n            buffer: $buffer\n          ) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            font\n            revisionDate\n            expireDate\n            properties\n            fields\n            buffer\n            tenantCode\n            status\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            finishByClient\n            reverseAutofillEnable\n            doReverse\n          }\n        }\n      ",variables:{data:t.data,buffer:t.buffer}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getSharedFields=function(t){var e="",n={"Access-Control-Allow-Origin":"*"};return!0===t.requestClient?(e=Mt,n.authorization=t.token):(e=Nt,n["x-access-token"]=t.token),wt()({url:e,method:"post",headers:n,data:{query:'\n        query sharedFields {\n          casesFormsShare(caseFormId: "'+t.caseFormId+'") {\n            _id\n            caseFormId\n            caseId\n            fields\n            tenantCode\n            createdAt\n            updatedAt\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.shareCaseFormFields=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation shareCaseFormFieldsAdd($formShare: formShare!) {\n          caseFormFieldsShareAdd (\n            formShare: $formShare\n          ) {\n            _id\n            caseFormId\n            caseId\n            fields\n            tenantCode\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{formShare:t.formShare}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editShareCaseFormFields=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation shareCaseFormFieldsEdit($formShare: formShare!) {\n          caseFormFieldsShareEdit (\n            formShare: $formShare\n          ) {\n            _id\n            caseFormId\n            caseId\n            fields\n            tenantCode\n            createdAt\n            updatedAt\n          }\n        }\n      ",variables:{formShare:t.formShare}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.updateCasesFormsStatus=function(t){var e="",n={"Access-Control-Allow-Origin":"*"};return!0===t.requestClient?(e=Mt,n.authorization=t.token):(e=Nt,n["x-access-token"]=t.token),wt()({url:e,method:"post",headers:n,data:{query:"\n        mutation caseFormChangeStatus($_id: String! $status: String!) {\n          caseFormChangeStatus (\n            _id: $_id\n            status: $status\n          ) {\n            _id\n            caseId\n            formId\n            formName\n            formTitle\n            viewer_url\n            font\n            revisionDate\n            expireDate\n            properties\n            fields\n            buffer\n            tenantCode\n            sharedToClient\n            sharedToClientDate\n            checkedByStaff\n            status\n            finishByClient\n            reverseAutofillEnable\n            createdAt\n            updatedAt\n            note\n          }\n        }\n      ",variables:{_id:t._id,status:t.status}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.sendCaseForms=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation sendCaseForm($dataToSend: JSON!) {\n          sendCasesForms(dataToSend: $dataToSend) {\n            token\n            scope\n            dataFirm\n          }\n        }\n      ",variables:{dataToSend:t.data}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.saveToClio=function(t){return wt.a.create({headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*","Content-Type":"application/x-www-form-urlencoded"}}).get(It+"integrations/sendForm?partner="+t.partner+"&caseFormId="+t.caseFormId).then(function(t){return t.data}).catch(function(t){return t})},Ot.setNewOrderCaseForms=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation setNewOrder($order: Array!) {\n          caseFormOrder(order: $order) {\n            _id\n            caseId\n            formId\n            order\n          }\n        }\n      ",variables:{order:t.order}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.saveToClioPackage=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation sendCaseForm($packageId: String!) {\n          sendPackage(_id: $packageId) {\n            _id\n          }\n        }\n      ",variables:{packageId:t.packageId}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseForId=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          cases(id: "+t.caseId+") {\n            id\n            name\n            caseType {\n              practiceAreaId\n              name\n            }\n            checkList {\n              id\n              files {\n                id\n                originalName\n                name\n                size\n                caseId\n                userId\n                contactId\n                ownerId\n                mime\n                storageName\n                createdAt\n                updatedAt\n                moduleId\n                checklistId\n                uploadById\n                uploadByType\n                visibleOnClientPortal\n                tenantCode\n                file\n                numberPages\n                thumbnail\n              }\n            }\n            contact {\n              id\n              fullName\n              firstName\n              lastName\n              email\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCasesForContactId=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          cases(contactId: "+t.contactId+") {\n            id\n            name\n            caseType {\n              practiceAreaId\n              name\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.thisHappens=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query globalQuery($model: String, $id: String, $event: String){\n          thisHappens(\n            model: $model,\n            id: $id,\n            event: $event\n          ) {\n            warning\n            webHooksEnable \n            URL\n            model \n          }\n        }\n      ",variables:{model:t.model,id:String(t.id),event:t.event}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.sentToIntegrations=function(t){return wt.a.create({headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*","Content-Type":"application/x-www-form-urlencoded"}}).get(It+"integrations/"+t.actionRoute+"/"+t.item+"?id="+t.itemId+"&type="+t.type).then(function(t){return t.data}).catch(function(t){return t})},Ot.printOneNote=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n          notes(_id: "'+t.noteId+'", print:true) {\n            _id\n            notePrint\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.printAllContactNotes=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n    \n          notes(contactId: "+t.contactId+", print:true) {\n            _id\n            notePrint\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.printAllCaseNotes=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n    \n          notes(caseId: "+t.caseId+", print:true) {\n            _id\n            notePrint\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getAllActivities=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n    \n          activities {\n            _id\n            caseId\n            case {\n              name\n              caseTypeName\n            }\n            contactId\n            contact {\n              email\n              fullName\n            }\n            sourceId\n            sourceType\n            type\n            billingCategory {\n              _id\n              type\n              name\n              rate\n              billingMethod\n            }\n            billingCategoryId\n            description\n            userId\n            user {\n              id\n              firstName\n              middleName\n              lastName\n              email\n              phone\n            }\n            rate\n            nonBillableStatus\n            nonBillable\n            quantity\n            billable\n            invoiceStatus\n            createdAt\n            updatedAt\n            billId\n            discount\n            discountPercentage\n            tax\n            taxAmount\n            dateActivity\n            bill {\n              _id\n              contactId\n              caseId\n              billTotal\n              status\n              issueDate\n              dueDate\n              currency\n              ID\n              discountNote\n              invoiceNote\n              subject\n              purchaseOrder\n              discount\n              discountPercentage\n              discountAmount\n              invoiceSubTotal\n              invoiceTotal\n              tax\n              taxAmount\n              activities {\n                _id\n                contactId\n                caseId\n                dateActivity\n                quantity\n                rate\n                type\n                description\n                createdAt\n                billable\n                billId\n                discount\n                tax\n                taxAmount\n                invoiceStatus\n                discountPercentage\n                billingCategoryId\n                billingCategory {\n                  _id\n                  type\n                  name\n                  rate\n                  billingMethod\n                }\n                userId\n                user {\n                  id\n                  firstName\n                  middleName\n                  lastName\n                  email\n                  phone\n                }\n              }\n              contact {\n                id\n                firstName\n                lastName\n                middleName\n                fullName\n                email\n                address {\n                  id\n                  name\n                  address\n                  line2\n                  apt\n                  ste\n                  flr\n                  aptSteFlrNumbertxt\n                  isForeing\n                  isMailing\n                  isPrimary\n                  isCurrent\n                  liveFrom\n                  liveTo\n                  order\n                  city\n                  state\n                  country\n                  zipCode\n                  inCareOf\n                }\n              }\n              case {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n              }\n              firm\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getContactActivities=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n    \n          activities (contactId: "+t.contactId+") {\n            _id\n            caseId\n            case {\n              name\n              caseTypeName\n            }\n            contactId\n            contact {\n              email\n              fullName\n            }\n            sourceId\n            sourceType\n            type\n            billingCategory {\n              _id\n              type\n              name\n              rate\n              billingMethod\n            }\n            billingCategoryId\n            dateActivity\n            description\n            userId\n            user {\n              id\n              firstName\n              middleName\n              lastName\n              email\n              phone\n            }\n            rate\n            nonBillableStatus\n            nonBillable\n            quantity\n            billable\n            invoiceStatus\n            createdAt\n            updatedAt\n            billId\n            discount\n            discountPercentage\n            tax\n            taxAmount\n            bill {\n              _id\n              contactId\n              caseId\n              billTotal\n              status\n              issueDate\n              dueDate\n              currency\n              ID\n              discountNote\n              invoiceNote\n              subject\n              purchaseOrder\n              discount\n              discountPercentage\n              discountAmount\n              invoiceSubTotal\n              invoiceTotal\n              tax\n              taxAmount\n              activities {\n                _id\n                contactId\n                caseId\n                dateActivity\n                quantity\n                rate\n                type\n                description\n                createdAt\n                billable\n                billId\n                discount\n                tax\n                taxAmount\n                invoiceStatus\n                discountPercentage\n                billingCategoryId\n                billingCategory {\n                  _id\n                  type\n                  name\n                  rate\n                  billingMethod\n                }\n                userId\n                user {\n                  id\n                  firstName\n                  middleName\n                  lastName\n                  email\n                  phone\n                }\n              }\n              contact {\n                id\n                firstName\n                lastName\n                middleName\n                fullName\n                email\n                address {\n                  id\n                  name\n                  address\n                  line2\n                  apt\n                  ste\n                  flr\n                  aptSteFlrNumbertxt\n                  isForeing\n                  isMailing\n                  isPrimary\n                  isCurrent\n                  liveFrom\n                  liveTo\n                  order\n                  city\n                  state\n                  country\n                  zipCode\n                  inCareOf\n                }\n              }\n              case {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n              }\n              firm\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseActivities=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n    \n          activities (caseId: "+t.caseId+") {\n            _id\n            caseId\n            case {\n              name\n              caseTypeName\n            }\n            contactId\n            contact {\n              email\n              fullName\n            }\n            sourceId\n            sourceType\n            dateActivity\n            type\n            billingCategory {\n              _id\n              type\n              name\n              rate\n              billingMethod\n            }\n            billingCategoryId\n            description\n            userId\n            user {\n              id\n              firstName\n              middleName\n              lastName\n              email\n              phone\n            }\n            rate\n            nonBillableStatus\n            nonBillable\n            quantity\n            billable\n            invoiceStatus\n            createdAt\n            updatedAt\n            billId\n            discount\n            discountPercentage\n            tax\n            taxAmount\n            bill {\n              _id\n              contactId\n              caseId\n              billTotal\n              status\n              issueDate\n              dueDate\n              currency\n              ID\n              discountNote\n              invoiceNote\n              subject\n              purchaseOrder\n              discount\n              discountPercentage\n              discountAmount\n              invoiceSubTotal\n              invoiceTotal\n              tax\n              taxAmount\n              activities {\n                _id\n                contactId\n                caseId\n                dateActivity\n                quantity\n                rate\n                type\n                description\n                createdAt\n                billable\n                billId\n                discount\n                tax\n                taxAmount\n                invoiceStatus\n                discountPercentage\n                billingCategoryId\n                billingCategory {\n                  _id\n                  type\n                  name\n                  rate\n                  billingMethod\n                }\n                userId\n                user {\n                  id\n                  firstName\n                  middleName\n                  lastName\n                  email\n                  phone\n                }\n              }\n              contact {\n                id\n                firstName\n                lastName\n                middleName\n                fullName\n                email\n                address {\n                  id\n                  name\n                  address\n                  line2\n                  apt\n                  ste\n                  flr\n                  aptSteFlrNumbertxt\n                  isForeing\n                  isMailing\n                  isPrimary\n                  isCurrent\n                  liveFrom\n                  liveTo\n                  order\n                  city\n                  state\n                  country\n                  zipCode\n                  inCareOf\n                }\n              }\n              case {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n              }\n              firm\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getSourceActivities=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n    \n          activities (sourceType: "'+t.sourceType+'") {\n            _id\n            caseId\n            case {\n              name\n              caseTypeName\n            }\n            contactId\n            contact {\n              email\n              fullName\n            }\n            sourceId\n            sourceType\n            dateActivity\n            type\n            billingCategory {\n              _id\n              type\n              name\n              rate\n              billingMethod\n            }\n            billingCategoryId\n            description\n            userId\n            user {\n              id\n              firstName\n              middleName\n              lastName\n              email\n              phone\n            }\n            rate\n            nonBillableStatus\n            nonBillable\n            quantity\n            billable\n            invoiceStatus\n            createdAt\n            updatedAt\n            billId\n            discount\n            discountPercentage\n            tax\n            taxAmount\n            bill {\n              _id\n              contactId\n              caseId\n              billTotal\n              status\n              issueDate\n              dueDate\n              currency\n              ID\n              discountNote\n              invoiceNote\n              subject\n              purchaseOrder\n              discount\n              discountPercentage\n              discountAmount\n              invoiceSubTotal\n              invoiceTotal\n              tax\n              taxAmount\n              activities {\n                _id\n                contactId\n                caseId\n                dateActivity\n                quantity\n                rate\n                type\n                description\n                createdAt\n                billable\n                billId\n                discount\n                tax\n                taxAmount\n                invoiceStatus\n                discountPercentage\n                billingCategoryId\n                billingCategory {\n                  _id\n                  type\n                  name\n                  rate\n                  billingMethod\n                }\n                userId\n                user {\n                  id\n                  firstName\n                  middleName\n                  lastName\n                  email\n                  phone\n                }\n              }\n              contact {\n                id\n                firstName\n                lastName\n                middleName\n                fullName\n                email\n                address {\n                  id\n                  name\n                  address\n                  line2\n                  apt\n                  ste\n                  flr\n                  aptSteFlrNumbertxt\n                  isForeing\n                  isMailing\n                  isPrimary\n                  isCurrent\n                  liveFrom\n                  liveTo\n                  order\n                  city\n                  state\n                  country\n                  zipCode\n                  inCareOf\n                }\n              }\n              case {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n              }\n              firm\n            }\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addActivity=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation newActivity($newActivity: newActivity!) {\n          activityAdd(newActivity: $newActivity) {\n            _id\n            caseId\n            case {\n              name\n              caseTypeName\n            }\n            contactId\n            contact {\n              email\n              fullName\n            }\n            sourceId\n            sourceType\n            dateActivity\n            type\n            billingCategory {\n              _id\n              type\n              name\n              rate\n              billingMethod\n            }\n            billingCategoryId\n            description\n            userId\n            user {\n              id\n              firstName\n              middleName\n              lastName\n              email\n              phone\n            }\n            rate\n            nonBillableStatus\n            nonBillable\n            quantity\n            billable\n            invoiceStatus\n            createdAt\n            updatedAt\n            billId\n            discount\n            discountPercentage\n            tax\n            taxAmount\n            bill {\n              _id\n              contactId\n              caseId\n              billTotal\n              status\n              issueDate\n              dueDate\n              currency\n              ID\n              discountNote\n              invoiceNote\n              subject\n              purchaseOrder\n              discount\n              discountPercentage\n              discountAmount\n              invoiceSubTotal\n              invoiceTotal\n              tax\n              taxAmount\n              activities {\n                _id\n                contactId\n                caseId\n                dateActivity\n                quantity\n                rate\n                type\n                description\n                createdAt\n                billable\n                billId\n                discount\n                tax\n                taxAmount\n                invoiceStatus\n                discountPercentage\n                billingCategoryId\n                billingCategory {\n                  _id\n                  type\n                  name\n                  rate\n                  billingMethod\n                }\n                userId\n                user {\n                  id\n                  firstName\n                  middleName\n                  lastName\n                  email\n                  phone\n                }\n              }\n              contact {\n                id\n                firstName\n                lastName\n                middleName\n                fullName\n                email\n                address {\n                  id\n                  name\n                  address\n                  line2\n                  apt\n                  ste\n                  flr\n                  aptSteFlrNumbertxt\n                  isForeing\n                  isMailing\n                  isPrimary\n                  isCurrent\n                  liveFrom\n                  liveTo\n                  order\n                  city\n                  state\n                  country\n                  zipCode\n                  inCareOf\n                }\n              }\n              case {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n              }\n              firm\n            }\n          }\n        }\n      ",variables:{newActivity:t.newActivity}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editActivity=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editActivity($_id: String!, $editActivity: editActivity!) {\n          activityEdit(_id: $_id, editActivity: $editActivity) {\n            _id\n            caseId\n            case {\n              name\n              caseTypeName\n            }\n            contactId\n            contact {\n              email\n              fullName\n            }\n            sourceId\n            sourceType\n            dateActivity\n            type\n            billingCategory {\n              _id\n              type\n              name\n              rate\n              billingMethod\n            }\n            billingCategoryId\n            description\n            userId\n            user {\n              id\n              firstName\n              middleName\n              lastName\n              email\n              phone\n            }\n            rate\n            nonBillableStatus\n            nonBillable\n            quantity\n            billable\n            invoiceStatus\n            createdAt\n            updatedAt\n            billId\n            discount\n            discountPercentage\n            tax\n            taxAmount\n            bill {\n              _id\n              contactId\n              caseId\n              billTotal\n              status\n              issueDate\n              dueDate\n              currency\n              ID\n              discountNote\n              invoiceNote\n              subject\n              purchaseOrder\n              discount\n              discountPercentage\n              discountAmount\n              invoiceSubTotal\n              invoiceTotal\n              tax\n              taxAmount\n              activities {\n                _id\n                contactId\n                caseId\n                dateActivity\n                quantity\n                rate\n                type\n                description\n                createdAt\n                billable\n                billId\n                discount\n                tax\n                taxAmount\n                invoiceStatus\n                discountPercentage\n                billingCategoryId\n                billingCategory {\n                  _id\n                  type\n                  name\n                  rate\n                  billingMethod\n                }\n                userId\n                user {\n                  id\n                  firstName\n                  middleName\n                  lastName\n                  email\n                  phone\n                }\n              }\n              contact {\n                id\n                firstName\n                lastName\n                middleName\n                fullName\n                email\n                address {\n                  id\n                  name\n                  address\n                  line2\n                  apt\n                  ste\n                  flr\n                  aptSteFlrNumbertxt\n                  isForeing\n                  isMailing\n                  isPrimary\n                  isCurrent\n                  liveFrom\n                  liveTo\n                  order\n                  city\n                  state\n                  country\n                  zipCode\n                  inCareOf\n                }\n              }\n              case {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n              }\n              firm\n            }\n          }\n        }\n      ",variables:{_id:t._id,editActivity:t.editActivity}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteActivity=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteActivity($_id: String!) {\n          activityDelete(_id: $_id) {\n            _id\n            caseId\n            case {\n              name\n              caseTypeName\n            }\n            contactId\n            contact {\n              email\n              fullName\n            }\n            sourceId\n            sourceType\n            type\n            billingCategoryId\n            description\n            userId\n            rate\n            nonBillableStatus\n            nonBillable\n            quantity\n            billable\n            invoiceStatus\n            createdAt\n            updatedAt\n            billId\n            discount\n            discountPercentage\n            tax\n            taxAmount\n          }\n        }\n      ",variables:{_id:t._id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.bulkDeleteActivities=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation bulkDeleteActivities($_ids: Array!) {\n          activityDeleteBulk(_ids: $_ids ){\n            _id\n            rate\n            quantity\n          }\n        }\n      ",variables:{_ids:t._ids}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.bulkEditActivities=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation bulkEditActivities($_ids: Array!, $editBulkActivity: editBulkActivity!) {\n          activityEditBulk(\n            _ids: $_ids,\n            editBulkActivity: $editBulkActivity\n          ){\n            _id\n            caseId\n            case {\n              name\n              caseTypeName\n            }\n            contactId\n            contact {\n              email\n              fullName\n            }\n            sourceId\n            sourceType\n            type\n            billingCategory {\n              _id\n              type\n              name\n              rate\n              billingMethod\n            }\n            billingCategoryId\n            description\n            dateActivity\n            userId\n            user {\n              id\n              firstName\n              middleName\n              lastName\n              email\n              phone\n            }\n            rate\n            nonBillableStatus\n            nonBillable\n            quantity\n            billable\n            invoiceStatus\n            createdAt\n            updatedAt\n            billId\n            discount\n            discountPercentage\n            tax\n            taxAmount\n            bill {\n              _id\n              contactId\n              caseId\n              billTotal\n              status\n              issueDate\n              dueDate\n              currency\n              ID\n              discountNote\n              invoiceNote\n              subject\n              purchaseOrder\n              discount\n              discountPercentage\n              discountAmount\n              invoiceSubTotal\n              invoiceTotal\n              tax\n              taxAmount\n              activities {\n                _id\n                contactId\n                caseId\n                dateActivity\n                quantity\n                rate\n                type\n                description\n                createdAt\n                billable\n                billId\n                discount\n                tax\n                taxAmount\n                invoiceStatus\n                discountPercentage\n                billingCategoryId\n                billingCategory {\n                  _id\n                  type\n                  name\n                  rate\n                  billingMethod\n                }\n                userId\n                user {\n                  id\n                  firstName\n                  middleName\n                  lastName\n                  email\n                  phone\n                }\n              }\n              contact {\n                id\n                firstName\n                lastName\n                middleName\n                fullName\n                email\n                address {\n                  id\n                  name\n                  address\n                  line2\n                  apt\n                  ste\n                  flr\n                  aptSteFlrNumbertxt\n                  isForeing\n                  isMailing\n                  isPrimary\n                  isCurrent\n                  liveFrom\n                  liveTo\n                  order\n                  city\n                  state\n                  country\n                  zipCode\n                  inCareOf\n                }\n              }\n              case {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n              }\n              firm\n            }\n          } \n        }\n      ",variables:{_ids:t._ids,editBulkActivity:t.bulkEditData}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addEditManyActivities=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:t.query}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCategories=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          billingCategory {\n            _id\n            type\n            name\n            rate\n            billingMethod\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCategoriesForType=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:'\n        query {\n          billingCategory (type: "'+t.type+'") {\n            _id\n            type\n            name\n            rate\n            billingMethod\n          }\n        }\n      '}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addCategory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation newCategory($newBillingCategory: newBillingCategory!) {\n          billingCategoryAdd(newBillingCategory: $newBillingCategory) {\n            _id\n            type\n            name\n            rate\n            billingMethod\n          }\n        }\n      ",variables:{newBillingCategory:t.newBillingCategory}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editCategory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editCategory($_id: String!, $editBillingCategory: editBillingCategory!) {\n          billingCategoryEdit(_id: $_id, editBillingCategory: $editBillingCategory) {\n            _id\n            type\n            name\n            rate\n            billingMethod\n          }\n        }\n      ",variables:{_id:t._id,editBillingCategory:t.editBillingCategory}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteCategory=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteCategory($_id: String!) {\n          billingCategoryDelete(_id: $_id) {\n            _id\n            type\n            name\n            rate\n            billingMethod\n          }\n        }\n      ",variables:{_id:t._id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseBills=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          billsNew(caseId: "+t.caseId+") {\n            _id\n            contactId\n            caseId\n            billTotal\n            status\n            issueDate\n            dueDate\n            currency\n            ID\n            discountNote\n            invoiceNote\n            subject\n            purchaseOrder\n            discount\n            discountPercentage\n            discountAmount\n            invoiceSubTotal\n            invoiceTotal\n            tax\n            taxAmount\n            pendingPayment\n            pdfCancel\n            planId\n            accountId\n            trust\n            activities {\n              _id\n              contactId\n              caseId\n              dateActivity\n              quantity\n              rate\n              type\n              description\n              createdAt\n              billable\n              billId\n              discount\n              tax\n              taxAmount\n              invoiceStatus\n              discountPercentage\n              billingCategoryId\n              billingCategory {\n                _id\n                type\n                name\n                rate\n                billingMethod\n              }\n              userId\n              user {\n                id\n                firstName\n                middleName\n                lastName\n                email\n                phone\n              }\n            }\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n              address {\n                id\n                name\n                address\n                line2\n                apt\n                ste\n                flr\n                aptSteFlrNumbertxt\n                isForeing\n                isMailing\n                isPrimary\n                isCurrent\n                liveFrom\n                liveTo\n                order\n                city\n                state\n                country\n                zipCode\n                inCareOf\n              }\n            }\n            case {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            firm\n            billIdLexCharge\n            errorPayLexCharge\n            lexChargeChecking\n            clientPortal\n          }\n        }\n      "}}).then(function(t){return{bills:t.data.data.billsNew.sort(function(t,e){return new Date(e.issueDate)-new Date(t.issueDate)})}}).catch(function(t){return t})},Ot.getContactBills=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          billsNew(contactId: "+t.contactId+") {\n            _id\n            contactId\n            caseId\n            billTotal\n            status\n            issueDate\n            dueDate\n            currency\n            ID\n            discountNote\n            invoiceNote\n            subject\n            purchaseOrder\n            discount\n            discountPercentage\n            discountAmount\n            invoiceSubTotal\n            invoiceTotal\n            tax\n            taxAmount\n            pendingPayment\n            pdfCancel\n            planId\n            accountId\n            trust\n            activities {\n              _id\n              contactId\n              caseId\n              dateActivity\n              quantity\n              rate\n              type\n              description\n              createdAt\n              billable\n              billId\n              discount\n              tax\n              taxAmount\n              invoiceStatus\n              discountPercentage\n              billingCategoryId\n              billingCategory {\n                _id\n                type\n                name\n                rate\n                billingMethod\n              }\n              userId\n              user {\n                id\n                firstName\n                middleName\n                lastName\n                email\n                phone\n              }\n            }\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n              address {\n                id\n                name\n                address\n                line2\n                apt\n                ste\n                flr\n                aptSteFlrNumbertxt\n                isForeing\n                isMailing\n                isPrimary\n                isCurrent\n                liveFrom\n                liveTo\n                order\n                city\n                state\n                country\n                zipCode\n                inCareOf\n              }\n            }\n            case {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            firm\n            billIdLexCharge\n            errorPayLexCharge\n            lexChargeChecking\n            clientPortal\n          }\n        }\n      "}}).then(function(t){return{bills:t.data.data.billsNew.sort(function(t,e){return new Date(e.issueDate)-new Date(t.issueDate)})}}).catch(function(t){return t})},Ot.getAllBills=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          billsNew {\n            _id\n            contactId\n            caseId\n            billTotal\n            status\n            issueDate\n            dueDate\n            currency\n            ID\n            discountNote\n            invoiceNote\n            subject\n            purchaseOrder\n            discount\n            discountPercentage\n            discountAmount\n            invoiceSubTotal\n            invoiceTotal\n            tax\n            taxAmount\n            pendingPayment\n            pdfCancel\n            planId\n            accountId\n            trust\n            activities {\n              _id\n              contactId\n              caseId\n              dateActivity\n              quantity\n              rate\n              type\n              description\n              createdAt\n              billable\n              billId\n              discount\n              tax\n              taxAmount\n              invoiceStatus\n              discountPercentage\n              billingCategoryId\n              billingCategory {\n                _id\n                type\n                name\n                rate\n                billingMethod\n              }\n              userId\n              user {\n                id\n                firstName\n                middleName\n                lastName\n                email\n                phone\n              }\n            }\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n              address {\n                id\n                name\n                address\n                line2\n                apt\n                ste\n                flr\n                aptSteFlrNumbertxt\n                isForeing\n                isMailing\n                isPrimary\n                isCurrent\n                liveFrom\n                liveTo\n                order\n                city\n                state\n                country\n                zipCode\n                inCareOf\n              }\n              clientPortal\n            }\n            case {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n              clientPortal\n            }\n            firm\n            billIdLexCharge\n            errorPayLexCharge\n            lexChargeChecking\n            clientPortal\n          }\n        }\n      "}}).then(function(t){return{bills:t.data.data.billsNew.sort(function(t,e){return new Date(e.issueDate)-new Date(t.issueDate)})}}).catch(function(t){return t})},Ot.editBill=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editBill ($_id: String!, $editBill: editBill!) {\n          billEdit(\n            _id: $_id,\n            editBill: $editBill\n          ) {\n            _id\n            contactId\n            caseId\n            billTotal\n            status\n            issueDate\n            dueDate\n            currency\n            ID\n            discountNote\n            invoiceNote\n            subject\n            purchaseOrder\n            discount\n            discountPercentage\n            discountAmount\n            invoiceSubTotal\n            invoiceTotal\n            tax\n            taxAmount\n            pendingPayment\n            pdfCancel\n            planId\n            accountId\n            trust\n            activities {\n              _id\n              contactId\n              caseId\n              dateActivity\n              quantity\n              rate\n              type\n              description\n              createdAt\n              billable\n              billId\n              discount\n              tax\n              taxAmount\n              invoiceStatus\n              discountPercentage\n              billingCategoryId\n              billingCategory {\n                _id\n                type\n                name\n                rate\n                billingMethod\n              }\n              userId\n              user {\n                id\n                firstName\n                middleName\n                lastName\n                email\n                phone\n              }\n            }\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n              address {\n                id\n                name\n                address\n                line2\n                apt\n                ste\n                flr\n                aptSteFlrNumbertxt\n                isForeing\n                isMailing\n                isPrimary\n                isCurrent\n                liveFrom\n                liveTo\n                order\n                city\n                state\n                country\n                zipCode\n                inCareOf\n              }\n            }\n            case {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            firm\n            billIdLexCharge\n            errorPayLexCharge\n            lexChargeChecking\n            clientPortal\n          }\n        }\n      ",variables:{_id:t._id,editBill:t.editBill}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getAllCases=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          cases {\n            id\n            name\n            caseType {\n              id\n              name\n            }\n            user {\n              id\n              firstName\n              middleName\n              lastName\n            }\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              email\n              fullName\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.whoAmI=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          whoAmI {\n            id\n            firstName\n            middleName\n            lastName\n            email\n            phone\n            address\n            city\n            state\n            zipCode\n            country\n            tenantCode\n            lawFirmName\n            rate\n            tax\n            isAttorney\n            defaultRateAttorney\n            defaultRateParalegal\n            tenant {\n              logoUrl\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getAllActivitiesPendingForBill=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          activitiesPendingForBillsGroupContacts {\n            contactId\n            billTotalContact\n            billTotalCases\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n            }\n            cases {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            activities {\n              _id\n              caseId\n              contactId\n              sourceId\n              sourceType\n              type\n              billingCategoryId\n              description\n              userId\n              billId\n              discount\n              tax\n              taxAmount\n              discountPercentage\n              user {\n                id\n                firstName\n                middleName\n                lastName\n                email\n                phone\n                address\n                city\n                state\n                country\n                tenantCode\n              }\n              rate\n              nonBillableStatus\n              nonBillable\n              quantity\n              billable\n              invoiceStatus\n              dateActivity\n              createdAt\n              updatedAt\n              billingCategory {\n                _id\n                type\n                name\n                rate\n                billingMethod\n              }\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getContactActivitiesPendingForBill=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          activitiesPendingForBillsGroupContacts (contactId: "+t.contactId+") {\n            contactId\n            billTotalContact\n            billTotalCases\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n            }\n            cases {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            activities {\n              _id\n              caseId\n              contactId\n              sourceId\n              sourceType\n              type\n              billingCategoryId\n              description\n              userId\n              billId\n              discount\n              tax\n              taxAmount\n              discountPercentage\n              user {\n                id\n                firstName\n                middleName\n                lastName\n                email\n                phone\n                address\n                city\n                state\n                country\n                tenantCode\n              }\n              rate\n              nonBillableStatus\n              nonBillable\n              quantity\n              billable\n              invoiceStatus\n              dateActivity\n              createdAt\n              updatedAt\n              billingCategory {\n                _id\n                type\n                name\n                rate\n                billingMethod\n              }\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseActivitiesPendingForBill=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          activitiesPendingForBillsGroupCases (caseId: "+t.caseId+") {\n            contactId\n            billTotal\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n            }\n            case {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            activities {\n              _id\n              caseId\n              contactId\n              sourceId\n              sourceType\n              type\n              billingCategoryId\n              description\n              userId\n              billId\n              discount\n              tax\n              taxAmount\n              discountPercentage\n              user {\n                id\n                firstName\n                middleName\n                lastName\n                email\n                phone\n                address\n                city\n                state\n                country\n                tenantCode\n              }\n              rate\n              nonBillableStatus\n              nonBillable\n              quantity\n              billable\n              invoiceStatus\n              dateActivity\n              createdAt\n              updatedAt\n              billingCategory {\n                _id\n                type\n                name\n                rate\n                billingMethod\n              }\n            }\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n              address {\n                id\n                name\n                address\n                line2\n                apt\n                ste\n                flr\n                aptSteFlrNumbertxt\n                isForeing\n                isMailing\n                isPrimary\n                isCurrent\n                liveFrom\n                liveTo\n                order\n                city\n                state\n                country\n                zipCode\n                inCareOf\n              }\n            }\n            case {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            firm\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.generateActivitiesBill=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation generateBill($newBill: newBill!) {\n          billAdd(newBill: $newBill) {\n            _id\n            contactId\n            caseId\n            billTotal\n            status\n            issueDate\n            dueDate\n            currency\n            ID\n            discountNote\n            invoiceNote\n            subject\n            purchaseOrder\n            discount\n            discountPercentage\n            discountAmount\n            invoiceSubTotal\n            invoiceTotal\n            tax\n            taxAmount\n            pendingPayment\n            pdfCancel\n            planId\n            accountId\n            trust\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n            }\n            case {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            pdfCancel\n            activities {\n              _id\n              caseId\n              contactId\n              sourceId\n              sourceType\n              type\n              billingCategoryId\n              description\n              userId\n              billId\n              discount\n              tax\n              taxAmount\n              discountPercentage\n              user {\n                id\n                firstName\n                middleName\n                lastName\n                email\n                phone\n                address\n                city\n                state\n                country\n                tenantCode\n              }\n              rate\n              nonBillableStatus\n              nonBillable\n              quantity\n              billable\n              invoiceStatus\n              dateActivity\n              createdAt\n              updatedAt\n              billingCategory {\n                _id\n                type\n                name\n                rate\n                billingMethod\n              }\n            }\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n              address {\n                id\n                name\n                address\n                line2\n                apt\n                ste\n                flr\n                aptSteFlrNumbertxt\n                isForeing\n                isMailing\n                isPrimary\n                isCurrent\n                liveFrom\n                liveTo\n                order\n                city\n                state\n                country\n                zipCode\n                inCareOf\n              }\n            }\n            case {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            firm\n            billIdLexCharge\n            errorPayLexCharge\n            lexChargeChecking\n            clientPortal\n          }\n        }\n      ",variables:{newBill:t.newBill}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getCaseFiles=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          files(caseId: "+t.caseId+") {\n            id\n            originalName\n            name\n            size\n            caseId\n            userId\n            contactId\n            ownerId\n            mime\n            storageName\n            createdAt\n            updatedAt\n            moduleId\n            checklistId\n            uploadById\n            uploadByType\n            visibleOnClientPortal\n            tenantCode\n            file\n            numberPages\n            thumbnail\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addFile=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addFile(\n          $nameFile: String!,\n          $file: String!,\n          $caseId: Int!,\n          $contactId: Int!,\n          $checklistId: Int,\n          $uploadBy: String!\n        ){\n          fileAdd(\n            nameFile: $nameFile,\n            file: $file,\n            caseId: $caseId,\n            contactId: $contactId,\n            checklistId: $checklistId,\n            uploadBy: $uploadBy\n          ) {\n            id\n            originalName\n            name\n            size\n            caseId\n            userId\n            contactId\n            ownerId\n            mime\n            storageName\n            createdAt\n            updatedAt\n            moduleId\n            checklistId\n            uploadById\n            uploadByType\n            visibleOnClientPortal\n            tenantCode\n            file\n            numberPages\n            thumbnail\n          }\n        }\n      ",variables:{nameFile:t.nameFile,file:t.file,caseId:t.caseId,contactId:t.contactId,checklistId:t.checklistId,uploadBy:t.uploadBy}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteFile=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteFile($id: Int!) {\n          fileDelete(id: $id) {\n            id\n            originalName\n            name\n            size\n            caseId\n            userId\n            contactId\n            ownerId\n            mime\n            storageName\n            createdAt\n            updatedAt\n            moduleId\n            checklistId\n            uploadById\n            uploadByType\n            visibleOnClientPortal\n            tenantCode\n            file\n            numberPages\n            thumbnail\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.shareFile=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation shareFile($id: Int!) {\n          shareFile(id: $id) {\n            id\n            originalName\n            name\n            size\n            caseId\n            userId\n            contactId\n            ownerId\n            mime\n            storageName\n            createdAt\n            updatedAt\n            moduleId\n            checklistId\n            uploadById\n            uploadByType\n            visibleOnClientPortal\n            tenantCode\n            file\n            numberPages\n            thumbnail\n          }\n        }\n      ",variables:{id:t.id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.shareFileInClientPortal=function(t,e,n){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation shareFileInClientPortal($id: Int! $enable: Boolean!) {\n          fileEnableClientPortal(\n            id: $id,\n            enable: $enable\n          ) {\n            id\n            originalName\n            name\n            size\n            caseId\n            userId\n            contactId\n            ownerId\n            mime\n            storageName\n            createdAt\n            updatedAt\n            moduleId\n            checklistId\n            uploadById\n            uploadByType\n            visibleOnClientPortal\n            tenantCode\n            file\n            numberPages\n            thumbnail\n          }\n        }\n      ",variables:{id:e,enable:n}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getUsers=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          users {\n            id\n            firstName\n            middleName\n            lastName\n            email\n            phone\n            address\n            city\n            state\n            country\n            tenantCode\n            isAttorney\n            active\n            rate\n            defaultRateAttorney\n            defaultRateParalegal\n            tax\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getBankAccount=function(t,e){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query getBankAccount($_id: String) {\n          accounts(_id: $_id) {\n            _id\n            userId\n            type\n            swift\n            currency\n            deletedAt\n            createdAt\n            updatedAt\n            accountName\n            institution\n            openingBalance\n            accountHolder\n            accountNumber\n            transitNumber\n            domicileBranch\n            defaultAccount\n            lawPayAccount {\n              _id\n              type\n              lawPayAccount\n            }\n            lexChargeAccountId\n            balanceAccounts {\n              balancePays\n              balanceTransaction\n            }\n            transactions {\n              _id\n              type\n              between\n              sourceType\n              sourceAccount\n              sourceCase\n              destinyType\n              destinyAccount\n              destinyCase\n              amount\n              description\n              reference\n              createdAt\n              updatedAt\n              checkNumber\n              bankName\n              routingNumber\n              accountNumber\n              moneyOrderNumber\n              bill {\n                _id\n                ID\n              }\n              user {\n                id\n                firstName\n                lastName\n              }\n              sourceCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              destinyCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              sourceAccountData {\n                _id\n                type\n                accountName\n              }\n              destinyAccountData {\n                _id\n                type\n                accountName\n              }\n              lexChargePaymentId\n            }\n          }\n        }\n      ",variables:{_id:e}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getAllAccounts=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          accounts {\n            _id\n            userId\n            type\n            swift\n            currency\n            deletedAt\n            createdAt\n            updatedAt\n            accountName\n            institution\n            openingBalance\n            accountHolder\n            accountNumber\n            transitNumber\n            domicileBranch\n            defaultAccount\n            lawPayAccount {\n              _id\n              type\n              lawPayAccount\n            }\n            lexChargeAccountId\n            balanceAccounts {\n              balancePays\n              balanceTransaction\n            }\n            transactions {\n              _id\n              type\n              between\n              sourceType\n              sourceAccount\n              sourceCase\n              destinyType\n              destinyAccount\n              destinyCase\n              amount\n              description\n              reference\n              createdAt\n              updatedAt\n              checkNumber\n              bankName\n              routingNumber\n              accountNumber\n              moneyOrderNumber\n              bill {\n                _id\n                ID\n              }\n              user {\n                id\n                firstName\n                lastName\n              }\n              sourceCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              destinyCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              sourceAccountData {\n                _id\n                type\n                accountName\n              }\n              destinyAccountData {\n                _id\n                type\n                accountName\n              }\n              lexChargePaymentId\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addAccount=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addAccount($newAccounts: newAccounts!) {\n          accountsAdd(newAccounts: $newAccounts) {\n            _id\n            userId\n            type\n            swift\n            currency\n            deletedAt\n            createdAt\n            updatedAt\n            accountName\n            institution\n            openingBalance\n            accountHolder\n            accountNumber\n            transitNumber\n            domicileBranch\n            defaultAccount\n            transactions {\n              _id\n              type\n              between\n              sourceType\n              sourceAccount\n              sourceCase\n              destinyType\n              destinyAccount\n              destinyCase\n              amount\n              description\n              reference\n              createdAt\n              updatedAt\n              checkNumber\n              bankName\n              routingNumber\n              accountNumber\n              moneyOrderNumber\n              bill {\n                _id\n                ID\n              }\n              user {\n                id\n                firstName\n                lastName\n              }\n              sourceCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              destinyCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              sourceAccountData {\n                _id\n                type\n                accountName\n              }\n              destinyAccountData {\n                _id\n                type\n                accountName\n              }\n              lexChargePaymentId\n            }\n          }\n        }\n      ",variables:{newAccounts:t.account}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editAccount=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editAccount($_id: String!, $editAccounts: editAccounts!) {\n          accountsEdit(\n            _id: $_id,\n            editAccounts: $editAccounts\n          ) {\n            _id\n            userId\n            type\n            swift\n            currency\n            deletedAt\n            createdAt\n            updatedAt\n            accountName\n            institution\n            openingBalance\n            accountHolder\n            accountNumber\n            transitNumber\n            domicileBranch\n            defaultAccount\n            transactions {\n              _id\n              type\n              between\n              sourceType\n              sourceAccount\n              sourceCase\n              destinyType\n              destinyAccount\n              destinyCase\n              amount\n              description\n              reference\n              createdAt\n              updatedAt\n              checkNumber\n              bankName\n              routingNumber\n              accountNumber\n              moneyOrderNumber\n              bill {\n                _id\n                ID\n              }\n              user {\n                id\n                firstName\n                lastName\n              }\n              sourceCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              destinyCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              sourceAccountData {\n                _id\n                type\n                accountName\n              }\n              destinyAccountData {\n                _id\n                type\n                accountName\n              }\n              lexChargePaymentId\n            }\n          }\n        }\n      ",variables:{_id:t._id,editAccounts:t.account}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteAccount=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteAccount($_id: String!) {\n          accountsDelete(_id: $_id) {\n            _id\n            userId\n            type\n            swift\n            currency\n            deletedAt\n            createdAt\n            updatedAt\n            accountName\n            institution\n            openingBalance\n            accountHolder\n            accountNumber\n            transitNumber\n            domicileBranch\n            defaultAccount\n          }\n        }\n      ",variables:{_id:t._id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getAllContacts=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          contacts {\n            id\n            fullName\n            email\n            cases {\n              id\n              name\n              caseType {\n                id\n                name\n              }\n            }\n            user {\n              id\n              firstName\n              middleName\n              lastName\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.searchContact=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query searchContact($search: searchContact) {\n          getContact: contacts(search: $search) {\n            id\n            fullName\n            email\n            cases {\n              id\n              name\n              caseType {\n                id\n                name\n              }\n            }\n            user {\n              id\n              firstName\n              middleName\n              lastName\n            }\n          }\n        }\n      ",variables:{search:t.search}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getTransactions=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          transactions ("+t.type+": "+t._id+") {\n            _id\n            type\n            between\n            sourceType\n            sourceAccount\n            sourceCase\n            destinyType\n            destinyAccount\n            destinyCase\n            amount\n            description\n            reference\n            createdAt\n            updatedAt\n            billId\n            checkNumber\n            bankName\n            routingNumber\n            accountNumber\n            moneyOrderNumber\n            bill {\n              _id\n              ID\n              planId\n            }\n            user {\n              id\n              firstName\n              lastName\n            }\n            sourceCaseData {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n              contact {\n                id\n                email\n                fullName\n              }\n            }\n            destinyCaseData {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n              contact {\n                id\n                email\n                fullName\n              }\n            }\n            sourceAccountData {\n              _id\n              type\n              accountName\n            }\n            destinyAccountData {\n              _id\n              type\n              accountName\n            }\n            lexChargePaymentId\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.addTransaction=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation addTransaction($newTransaction: newTransaction!) {\n          transactionAdd(newTransaction: $newTransaction) {\n            _id\n            type\n            between\n            sourceType\n            sourceAccount\n            sourceCase\n            destinyType\n            destinyAccount\n            destinyCase\n            amount\n            description\n            reference\n            createdAt\n            updatedAt\n            billId\n            checkNumber\n            bankName\n            routingNumber\n            accountNumber\n            moneyOrderNumber\n            bill {\n              _id\n              ID\n              planId\n            }\n            user {\n              id\n              firstName\n              lastName\n            }\n            sourceCaseData {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n              contact {\n                id\n                email\n                fullName\n              }\n            }\n            destinyCaseData {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n              contact {\n                id\n                email\n                fullName\n              }\n            }\n            sourceAccountData {\n              _id\n              type\n              accountName\n            }\n            destinyAccountData {\n              _id\n              type\n              accountName\n            }\n            lexChargePaymentId\n          }\n        }\n      ",variables:{newTransaction:t.transaction}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.editTransaction=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation editTransaction($_id: String!, $editTransaction: editTransaction!) {\n          transactionEdit(\n            _id: $_id,\n            editTransaction: $editTransaction\n          ) {\n            _id\n            type\n            between\n            sourceType\n            sourceAccount\n            sourceCase\n            destinyType\n            destinyAccount\n            destinyCase\n            amount\n            description\n            reference\n            createdAt\n            updatedAt\n            billId\n            checkNumber\n            bankName\n            routingNumber\n            accountNumber\n            moneyOrderNumber\n            bill {\n              _id\n              ID\n              planId\n            }\n            user {\n              id\n              firstName\n              lastName\n            }\n            sourceCaseData {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n              contact {\n                id\n                email\n                fullName\n              }\n            }\n            destinyCaseData {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n              contact {\n                id\n                email\n                fullName\n              }\n            }\n            sourceAccountData {\n              _id\n              type\n              accountName\n            }\n            destinyAccountData {\n              _id\n              type\n              accountName\n            }\n            lexChargePaymentId\n          }\n        }\n      ",variables:{_id:t._id,editTransaction:t.transaction}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.deleteTransaction=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteTransaction($_id: String!) {\n          transactionDelete(_id: $_id) {\n            _id\n            type\n            between\n            sourceType\n            sourceAccount\n            sourceCase\n            destinyType\n            destinyAccount\n            destinyCase\n            amount\n            description\n            reference\n            createdAt\n            updatedAt\n            checkNumber\n            bankName\n            routingNumber\n            accountNumber\n            moneyOrderNumber\n            bill {\n              _id\n              ID\n              planId\n            }\n          }\n        }\n      ",variables:{_id:t._id}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getGraphIntegrations=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          integrations {\n            _id\n            name\n            enable\n            prefix\n            logoUrl\n            direction\n            webSiteUrl\n            description\n            connectUrl\n            connected\n            disconnectUrl\n            twoWaySync\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.recordPayment=function(t,e){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation recordPayment($newRecordPayment: newRecordPayment!) {\n          recordPayment(\n            newRecordPayment: $newRecordPayment\n          ) {\n            id\n            amount\n            type\n            status\n            method {\n              name\n              type\n              expYear\n              email\n              expMonth\n              number\n              address1\n              cardType\n              postalCode\n              fingerprint\n            }\n            created\n            modified\n            clientId\n            currency\n            accountId\n            cvvResult\n            avsResult\n            amountRefunded\n            autoCapture\n            authorizationCode\n            transaction {\n              _id\n              type\n              between\n              sourceType\n              sourceAccount\n              sourceCase\n              destinyType\n              destinyAccount\n              destinyCase\n              amount\n              description\n              reference\n              createdAt\n              updatedAt\n              billId\n              bill {\n                ID\n              }\n              checkNumber\n              bankName\n              routingNumber\n              accountNumber\n              moneyOrderNumber\n              user {\n                id\n                firstName\n                lastName\n              }\n              sourceCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              destinyCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              sourceAccountData {\n                _id\n                type\n                accountName\n              }\n              destinyAccountData {\n                _id\n                type\n                accountName\n              }\n            }\n            lexChargeChecking\n          }\n        }\n      ",variables:{newRecordPayment:e}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.sendExternalPay=function(t,e,n,i){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation sendExternalPay(\n          $email: String!\n          $idBill: String!\n          $typeAccount: sendLinkPayLawPayTypeAccount!\n        ) {\n          sendLinkPayLawPay(\n            email: $email\n            idBill: $idBill\n            typeAccount: $typeAccount\n          ) {\n            email\n          }\n        }\n      ",variables:{email:e,idBill:n,typeAccount:i}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.sendLexChargeExternalPay=function(t,e){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation sendExternalPay($data: externalPaymentLexcharge!) {\n          createExternalPaymentLexCharge(\n            data: $data\n          ) {\n            _id\n            billIdLexCharge\n          }\n        }\n      ",variables:{data:e}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.voidDeleteBill=function(t,e,n){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation voidDeleteBill(\n          $_id: String!\n          $pdfCancel: String!\n        ) {\n          billDelete(\n            _id: $_id\n            pdfCancel: $pdfCancel\n          ) {\n            _id\n            contactId\n            caseId\n            billTotal\n            status\n            issueDate\n            dueDate\n            currency\n            ID\n            discountNote\n            invoiceNote\n            subject\n            purchaseOrder\n            discount\n            discountPercentage\n            discountAmount\n            invoiceSubTotal\n            invoiceTotal\n            tax\n            taxAmount\n            pdfCancel\n            contact {\n              id\n              firstName\n              lastName\n              middleName\n              fullName\n              email\n              address {\n                id\n                name\n                address\n                line2\n                apt\n                ste\n                flr\n                aptSteFlrNumbertxt\n                isForeing\n                isMailing\n                isPrimary\n                isCurrent\n                liveFrom\n                liveTo\n                order\n                city\n                state\n                country\n                zipCode\n                inCareOf\n              }\n            }\n            case {\n              id\n              name\n              contactId\n              caseTypeId\n              caseTypeName\n            }\n            firm\n          }\n        }\n      ",variables:{_id:e,pdfCancel:n}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getLawPayAccounts=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          lawPayAccounts {\n            id\n            type\n            name\n            account\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getLaboratoryFuncionality=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          laboratory {\n            _id\n            funcionalityId\n            enable\n            createdAt\n            updatedAt\n            labInfo {\n              _id\n              funcionality\n              status\n              createdAt\n              updatedAt\n            }\n          }\n        }\n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.enableCaseFormClientPortal=function(t,e,n){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation caseFormClientPortal(\n          $caseFormId: String!\n          $enable: Boolean!\n        ) {\n          caseFormEnableClientPortal(\n            caseFormId: $caseFormId\n            enable: $enable\n          ) {\n            _id\n            formName\n            clientPortal\n          }\n        }\n      ",variables:{caseFormId:e,enable:n}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.enableCaseQuestionnaireClientPortal=function(t,e,n){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation caseQuestionnaireClientPortal(\n          $_id: String!\n          $enable: Boolean!\n        ) {\n          caseQuestionnaireEnableClientPortal(\n            _id: $_id\n            enable: $enable\n          ) {\n            _id\n            status\n            clientPortal\n          }\n        }\n      ",variables:{_id:e,enable:n}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.payToLexCharge=function(t,e){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation payToLexCharge($newRecordPayment: newRecordPaymentLexcharge) {\n          payInvoiceLexCharge(\n            newRecordPayment: $newRecordPayment\n          ) {\n            id\n            transaction{\n              _id\n              type\n              between\n              sourceType\n              sourceAccount\n              sourceCase\n              destinyType\n              destinyAccount\n              destinyCase\n              amount\n              description\n              reference\n              createdAt\n              updatedAt\n              billId\n              checkNumber\n              bankName\n              routingNumber\n              accountNumber\n              moneyOrderNumber\n              user {\n                id\n                firstName\n                lastName\n              }\n              sourceCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              destinyCaseData {\n                id\n                name\n                contactId\n                caseTypeId\n                caseTypeName\n                contact {\n                  id\n                  email\n                  fullName\n                }\n              }\n              sourceAccountData {\n                _id\n                type\n                accountName\n              }\n              destinyAccountData {\n                _id\n                type\n                accountName\n              }\n            }\n          }\n        }\n      ",variables:{newRecordPayment:e}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.getCalendarEvents=function(t,e){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query getCalendarEvents($dataPagination: dataPaginationEvents!) {\n          calendarEventsFilter(\n            dataPagination: $dataPagination\n          ) {\n            calendarContext\n            title\n            caseName\n            userName\n            calendarName\n            description\n          }\n        }\n      ",variables:{dataPagination:e}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.deleteExternalPayment=function(t,e){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation deleteExternalPayment($billId: String!) {\n          deleteExternalInvoiceLexCharge(billId: $billId) {\n            _id\n            ID\n            status\n            billIdLexCharge\n          }\n        }\n      ",variables:{billId:e}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.shareInvoiceClientPortal=function(t,e,n){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation shareInvoiceClientPortal(\n          $_id: String\n          $enable: Boolean!\n        ) {\n          billEnableClientPortal(\n            _id: $_id\n            enable: $enable\n          ) {\n            _id\n            clientPortal\n          }\n        }\n      ",variables:{_id:e,enable:n}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.getFoldersCase=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n      {\n        getFolders(caseId:"+t.caseId+"){\n          _id\n          folderId\n          folderName\n          creationDate\n        }\n      }      \n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.getFoldersFilesCase=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n      {\n        getFilesFlowManager(ParamsCase: {\n          caseId: "+t.caseId+",\n          folderId: "+t._id+",\n          skip: "+t.skip+",\n          size:"+t.size+",\n        }){\n          id\n          name\n          mime\n          created_at\n          folder_id\n          storage_name\n          visible_on_client_portal\n          base64Thumbnail\n          size\n          \n         }\n\n      }      \n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.CreateFolderCase=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n      mutation(\n        $caseMysqlId:Int\n        $folderName:String!\n        $folderId:String\n        ){\n        createFolder(FolderAdd:{\n          caseMysqlId: $caseMysqlId\n          folderName: $folderName\n          folderId:  $folderId\n        }){\n          _id\n          folderName\n          creationDate\n          caseMysqlId\n        }\n      }\n      ",variables:{caseMysqlId:t.caseMysqlId,folderName:t.folderName,folderId:t.folderId}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.UploadFilesImg=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n      \n      mutation UploadFiles (\n       $files:FilesMongo\n      ){\n        uploadFileToFolder( files:$files)\n      }      \n      ",variables:{files:{caseId:t.caseId,imageUrls:t.imageUrls,folderId:t.folderId,contactId:t.contactId}}}}).then(function(t){return t.data.data.uploadFileToFolder}).catch(function(t){return t})},Ot.getAllFilesCase=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n      {\n          getAllFilesByCaseId(CaseId: "+t.caseId+"){\n          id\n          original_name                   \n          folder_id\n          storage_name\n        }\n        \n\n      }      \n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.MoveOrDeleteFolderAndFile=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n      mutation MoveOrDelete (\n       $files:FDeleteOrMove\n      ){\n        deleteOrMoveFilesAndFolders( FFDeleteOrMove:$files)\n      }      \n      ",variables:{files:{typeAction:t.typeAction,folderId:t.folderId,foldersChields:t.foldersChields,filesChields:t.filesChields,dataChecked:t.dataChecked}}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.CopyPasteFileManager=function(t){return console.log("jona: ",t.dataChecked),wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n        mutation CopyPasteFile (\n         $files:FCopyAndPaste\n        ){\n          copyAndPaste( FFCopyAndPaste:$files)\n        }      \n        ",variables:{files:{folderId:t.folderId,caseId:t.caseId,contactId:t.contactId,dataChecked:t.dataChecked}}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.ShareFile=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"      \n      mutation shareFile(\n        $shareFile: shareFile,\n      ){\n        shareFileToClientPortal(shareFile: $shareFile)\n      }\n      ",variables:{shareFile:{idFile:t.idFile,isShare:t.isShare}}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.MultiShareFile=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"      \n      mutation multiShareFile(\n        $shareFile: shareMultiple\n      ){\n        shareMultipleFiles(shareMultiples:$shareFile)\n        {\n        success\n        share\n        stopShare\n      }\n      }\n      ",variables:{shareFile:{dataChecked:t.dataChecked}}}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.ModifyNameFileOrFolder=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"      \n      mutation NewName(\n        $newName:nameFolderFile\n      ){\n        modifyFileOrFolderName(nameFolderFile: $newName)\n      }\n      ",variables:{newName:{idFile:parseInt(t.idFile),idFolder:t.idFolder,name:t.name}}}}).then(function(t){return t.data.data.modifyFileOrFolderName}).catch(function(t){return t})},Ot.getCountAllFilesFolder=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n      {\n        getAmountOfFilesAndFolders(caseId: "+t.caseId+", folderId: "+t.folderId+"){\n          folders\n          files\n        }  \n      }      \n      "}}).then(function(t){return t.data.data}).catch(function(t){return t})},Ot.searchFoldersAndFilesByName=function(t){return wt()({url:Nt,method:"post",headers:{"x-access-token":t.token,"Access-Control-Allow-Origin":"*"},data:{query:"\n      {\n        searchFoldersAndFilesByName(caseId: "+t.caseId+", search: "+t.search+", folderId: "+t.folderId+"){\n          folders {\n            _id\n            folderName\n            folderId\n            creationDate\n          }\n          files {\n            id\n            mime\n            name\n            folder_id\n            visible_on_client_portal\n            size\n            storage_name\n            created_at\n          }\n        }  \n      }      \n      "}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.getClientPortal=function(t,e){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query getClientPortal(\n          $contactId: Int\n        ) {\n          clientPortal(\n            contactId: $contactId\n          ) {\n            enable\n          }\n        }\n      ",variables:{contactId:e}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.getCaseIsShared=function(t,e){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"\n        query {\n          cases(id: "+e+") {\n            id\n            clientPortal\n          }\n        }\n      "}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.getFormDataToExtension=function(t,e,n){return wt()({url:Nt,method:"post",headers:{"x-access-token":t,"Access-Control-Allow-Origin":"*"},data:{query:"query formDataToExtension($_id: String!, $type: typeFormDataToExtension!) {\n  formDataToExtension(_id: $_id, type: $type) {\n    _id\n    type\n    spouse {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    relatives {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    prevspouse {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    travel {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    personal2 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    personal1 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n      }\n    }\n    pptvisa {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    usContact {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    workeducation1 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    workeducation2 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    workeducation3 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    addressPhone {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    previousUsTravel {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    travelCompanions {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    securityandbackground4 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    securityandbackground3 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    securityandbackground2 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    securityandbackground1 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    addressphone1 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    addressphone2 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    parents {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    previousspouse {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    children {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    petitioner {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    securityandbackground5 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    securityandbackground6 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    securityandbackground7 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    securityandbackground8 {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    crewvisa {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n    ssn {\n      value\n      selector\n      pdfField\n      notification\n      label\n      children {\n        value\n        selector\n        pdfField\n        notification\n        label\n        children {\n          value\n          selector\n          pdfField\n          notification\n          label\n        }\n      }\n    }\n  }\n}\n",variables:{_id:e,type:n}}}).then(function(t){return t.data}).catch(function(t){return t})},Ot.ds160Add=(At=q()(X.a.mark(function t(e,n,i,a,o){var r;return X.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return r={url:Nt,method:"post",headers:{"x-access-token":e,"Access-Control-Allow-Origin":"*"},data:{query:"mutation ds160Add(\n  $applicationId: String!\n  $casesFormsId: ObjectID!\n  $contactId: Int!\n  $caseId: Int!\n) {\n  ds160Add(\n    newDs160: {\n      applicationId: $applicationId\n      casesFormsId: $casesFormsId\n      contactId: $contactId\n      caseId:$caseId\n    }\n  ) {\n     _id \n    caseId \n    contactId \n    updatedAt \n    deletedAt \n    casesFormsId \n    applicationId \n  }\n}",variables:{applicationId:n,casesFormsId:i,contactId:a,caseId:o}}},t.abrupt("return",wt()(r).then(function(t){return t.data}).catch(function(t){return t}));case 2:case"end":return t.stop()}},t,Et)})),function(t,e,n,i,a){return At.apply(this,arguments)}),Ot.ds160=(bt=q()(X.a.mark(function t(e,n,i,a){var o;return X.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return o={url:Nt,method:"post",headers:{"x-access-token":e,"Access-Control-Allow-Origin":"*"},data:{query:"query ds160($_id: [String], $contactId: [Int], $casesFormsId: [String]) {\n  ds160(_id: $_id, contactId: $contactId, casesFormsId: $casesFormsId) {\n    _id\n    contactId\n    updatedAt\n    casesFormsId\n    deletedAt\n    applicationId\n  }\n}",variables:{_id:n,contactId:i,casesFormsId:a}}},t.abrupt("return",wt()(o).then(function(t){return t.data}).catch(function(t){return t}));case 2:case"end":return t.stop()}},t,Et)})),function(t,e,n,i){return bt.apply(this,arguments)}),Ot.getBaseBill=(xt=q()(X.a.mark(function t(e,n){var i,a;return X.a.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return i=n._id,a={url:Nt,method:"post",headers:{"x-access-token":e,"Access-Control-Allow-Origin":"*"},data:{query:"query billPrint($_id: String) {\n                billPrint(_id: $_id, pdfBase64: true) {\n                  pdfBase64\n                  issueDate\n                  contact {\n                    firstName\n                  }\n                }\n}",variables:{_id:i}}},t.abrupt("return",wt()(a).then(function(t){return t}).catch(function(t){return t}));case 3:case"end":return t.stop()}},t,Et)})),function(t,e){return xt.apply(this,arguments)});var Tt=Ot,Lt={data:function(){return{listRemote:[],information:{},hideBtnAdd:!1,type:"",noInfo:"",apiService:""}},props:{contactId:{type:Number,default:-1},token:{type:String},list:{type:Array},viewer:{type:Boolean,default:!1}},components:{PfSpinner:r},created:function(){this.apiService=Tt},methods:{addItem:function(){var t={newItem:!0};"itemPhone"===this.type&&(t.countryAreaCode="1"),this.listRemote.push(t);var e=this.type+(this.listRemote.length-1);setTimeout(function(){var t=document.getElementById(e);t.querySelector(".boxContainer").classList.add("fadeIn"),t.scrollIntoView({behavior:"smooth",block:"center",inline:"nearest"})},100),this.hideBtnAdd=!0},deleteNewItem:function(){var t=this,e=this.type+(this.listRemote.length-2),n=this.type+(this.listRemote.length-1);null!==document.getElementById(e)&&document.getElementById(e).scrollIntoView({behavior:"smooth",block:"end",inline:"nearest"}),null!==document.getElementById(n)&&document.getElementById(n).classList.add("fadeOut"),setTimeout(function(){t.listRemote.splice(t.listRemote.length-1,1),0===t.listRemote.length?t.noInfo="No Record":t.noInfo="",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300),setTimeout(function(){t.hideBtnAdd=!1},200)},300)},addModel:function(t){var e=this,n=Y()(t.information),i=Ct()(t.information),a={token:this.token,where:{questionnaireId:this.questionnaireid,model:t.model,contactId:this.contactId,field:n},value:i};this.apiService.UpdateCaseQuestionnaire(a).then(function(n){if(void 0!==n&&n.caseQuestionnaireEdit){e.hideBtnAdd=!1;var i=n.caseQuestionnaireEdit.models[t.model].pop(),a={};Y()(i).forEach(function(t){a[t]=i[t].edit}),i=a,e.listRemote.splice(e.listRemote.length-1,1),e.listRemote.push(i),e.$emit("set-change-model",{model:t.model,list:e.listRemote}),e.setFlash(),0===e.listRemote.length?e.noInfo="No Record":e.noInfo=""}else alert("Dont send")})},deleteItem:function(t){var e=this,n=this.type+t,i=t===this.listRemote.length-1?this.type+"Add"+this.questionnaireid:this.type+(t+1);document.getElementById(n).style.opacity="0";var a=document.getElementById(n).offsetHeight;t===this.listRemote.length-1&&(a+=a),document.getElementById(i).style.marginTop=-a+"px",document.getElementById(i).classList.add("animate"),setTimeout(function(){e.listRemote.splice(t,1),document.getElementById(n).style.opacity="1",document.getElementById(i).classList.remove("animate"),document.getElementById(i).style.marginTop="0px",!0===e.listRemote[e.listRemote.length-1].newItem&&setTimeout(function(){document.querySelector(".newItem").style.opacity="1"},500),0===e.listRemote.length?e.noInfo="No Record":e.noInfo="",setTimeout(function(){null!==document.getElementById("messageNoInf"+e.type)&&document.getElementById("messageNoInf"+e.type).classList.add("fadeIn")},300)},500)},setFlash:function(){var t=this.type+(this.listRemote.length-1),e=document.getElementById(t),n=void 0;null!==e&&(n=e.querySelector(".boxContainer")).classList.add("fadeShadow"),setTimeout(function(){null!==e&&n.classList.add("flashit"),setTimeout(function(){n.classList.remove("flashit")},400)},100)}}},jt={name:"pf-addresses",mixins:[Lt],props:{previous:{type:Boolean,default:!1},questionnaireid:{type:String}},components:{PfAddress:gt,PfButton:d},created:function(){var t=this;if(this.type=!1===this.previous?"itemAddress":"itemPrevAddress",void 0===this.list&&-1!==this.contactId)this.apiService.getAddresses({token:this.token,contactId:this.contactId}).then(function(e){0!==t.listRemote.length&&void 0!==t.listRemote||(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300));var n=[];null!==e.listAddresses[0].address&&(n=e.listAddresses[0].address),n.forEach(function(e){!0===t.previous?null!==e.liveTo&&t.listRemote.push(e):null===e.liveTo&&t.listRemote.push(e)})});else if(void 0!==this.list){var e=[],n=[];setTimeout(function(){t.list.length>0?t.list.forEach(function(i){!0===t.previous?null!==i.liveTo&&void 0!==i.liveTo&&(e.push(i),t.listRemote=e):null!==i.liveTo&&void 0!==i.liveTo||(n.push(i),t.listRemote=n),0!==e.length&&0!==n.length||(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))}):(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)}},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:!0===this.previous?"previousAddresses":"addresses"})},setTypeAddress:function(t){var e=this.listRemote,n=0;e.forEach(function(i,a){"isPrimary"===t.key?(i.isPrimary="off",t.key+n!==t.id&&!0===i.newItem&&!0===document.getElementById(t.key+n).checked&&(document.getElementById(t.key+n).checked=!1)):"isMailing"===t.key?(i.isMailing="off",t.key+n!==t.id&&!0===i.newItem&&!0===document.getElementById(t.key+n).checked&&(document.getElementById(t.key+n).checked=!1)):"isForeing"===t.key&&(i.isForeing="off",t.key+n!==t.id&&!0===i.newItem&&!0===document.getElementById(t.key+n).checked&&(document.getElementById(t.key+n).checked=!1)),n++,e[a]=i}),this.listRemote=[],this.listRemote=e}}},Pt={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-address",{key:i,attrs:{information:e,indexItem:String(i),id:!1===t.previous?"itemAddress"+i:"itemPrevAddress"+i,index:i,previous:t.previous,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-address":function(e){return t.deleteItem(i)},settypeaddress:t.setTypeAddress}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid&&!1===t.previous?"itemAddressAdd"+t.questionnaireid:void 0!==t.questionnaireid&&!0===t.previous?"itemPrevAddressAdd"+t.questionnaireid:!1===t.previous?"itemAddressAdd":"itemPrevAddressAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var Ft=n("VU/8")(jt,Pt,!1,function(t){n("7V7F")},"data-v-0523b617",null).exports,Yt={name:"pf-phone",mixins:[ht],components:{PfSelect:k,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this phone?",!0===this.information.newItem&&(this.information.type="Work")},methods:{setType:function(t){this.information.type=t,this.updatePhone(""!==this.indexItem?"type-"+this.indexItem:"type-"+this.index)},deletePhone:function(){this.deleteItem({model:"phones",item:"delete-phone"}),this.isPopUp=!1},updatePhone:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editPhone(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.phoneEdit?"updated":"error",e.setFlash({el:i,action:a})}))}}},Rt={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||(t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt)&&(!0!==t.comparing||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt)?t._e():n("i",{staticClass:"far fa-times-circle arrowClose text-danger",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("phone")},mouseleave:function(e){return t.removeHover("phone")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"phoneForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"phone"+t.idComponent}},[n("div",{staticClass:"row mt-2"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"number-"+t.indexItem:"number-"+t.index,name:""!==t.indexItem?"number-"+t.indexItem:"number-"+t.index,label:"Number:",validate:{required:!0,min:10},labelStyle:!0===t.information.newItem?"color:red;":"",readonly:t.readonly,mask:"###-###-##########",type:"tel",placeholder:"999-999-9999",classElement:void 0===t.information.class?"":void 0!==t.information.class.number?t.information.class.number:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.number,fieldId:"number",type:"phones",id:""!==t.indexItem?"number-"+t.indexItem:"number-"+t.index})},change:function(e){return t.updateModel({model:"phones",field:"number",value:t.information.number,id:""!==t.indexItem?"number-"+t.indexItem:"number-"+t.index})}},model:{value:t.information.number,callback:function(e){t.$set(t.information,"number",e)},expression:"information.number"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-select",{attrs:{id:""!==t.indexItem?"typePhone"+t.indexItem:"typePhone"+t.index,field:"type",model:"phones",label:"Type:",disabled:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.type?t.information.class.type:"",options:[{name:"Work",value:"work",selected:void 0!==this.information&&"Work"===this.information.type||"work"===this.information.type},{name:"Home",value:"home",selected:void 0!==this.information&&"Home"===this.information.type||"home"===this.information.type},{name:"Mobile",value:"mobile",selected:void 0!==this.information&&"Mobile"===this.information.type||"mobile"===this.information.type},{name:"Fax",value:"fax",selected:void 0!==this.information&&"Fax"===this.information.type||"fax"===this.information.type},{name:"Pager",value:"pager",selected:void 0!==this.information&&"Pager"===this.information.type||"pager"===this.information.type},{name:"Skype",value:"skype",selected:void 0!==this.information&&"Skype"===this.information.type||"skype"===this.information.type},{name:"Other",value:"other",selected:void 0!==this.information&&"Other"===this.information.type||"other"===this.information.type}]},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.type,fieldId:"type",type:"phones",id:""!==t.indexItem?"typePhone"+t.indexItem:"typePhone"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("phoneForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this phone number?"},on:{close:function(e){t.isPopUp=!1},action:t.deletePhone}}):t._e()],1):t._e()},staticRenderFns:[]};var Ht=n("VU/8")(Yt,Rt,!1,function(t){n("2fQW"),n("XDpo"),n("WgTJ")},"data-v-35373e24",null).exports,$t=n("7+uW"),zt=function(t){return be(["text","password","search","email","tel","url","textarea","number"],t.type)},Xt=function(t){return be(["radio","checkbox"],t.type)},Vt=function(t,e){return t.getAttribute("data-vv-"+e)},qt=function(t){return"isNaN"in Number?Number.isNaN(t):"number"==typeof t&&t!=t},Wt=function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];return t.every(function(t){return null===t||void 0===t})},Ut=function(t,e){if(t instanceof RegExp&&e instanceof RegExp)return Ut(t.source,e.source)&&Ut(t.flags,e.flags);if(Array.isArray(t)&&Array.isArray(e)){if(t.length!==e.length)return!1;for(var n=0;n<t.length;n++)if(!Ut(t[n],e[n]))return!1;return!0}return ne(t)&&ne(e)?Object.keys(t).every(function(n){return Ut(t[n],e[n])})&&Object.keys(e).every(function(n){return Ut(t[n],e[n])}):!(!qt(t)||!qt(e))||t===e},Gt=function(t){return Wt(t)?null:"FORM"===t.tagName?t:Wt(t.form)?Wt(t.parentNode)?null:Gt(t.parentNode):t.form},Zt=function(t,e,n){if(void 0===n&&(n=void 0),!t||!e)return n;var i=e;return t.split(".").every(function(t){return t in i?(i=i[t],!0):(i=n,!1)}),i},Jt=function(t,e,n){return void 0===e&&(e=0),void 0===n&&(n={cancelled:!1}),0===e?t:function(){for(var a=[],o=arguments.length;o--;)a[o]=arguments[o];clearTimeout(i),(i=setTimeout(function(){i=null,n.cancelled||t.apply(void 0,a)},e))||t.apply(void 0,a)};var i},Qt=function(t,e){return e?t?("string"==typeof e&&(e=Kt(e)),le({},e,Kt(t))):Kt(e):Kt(t)},Kt=function(t){return t?ne(t)?Object.keys(t).reduce(function(e,n){var i=[];return i=!0===t[n]?[]:Array.isArray(t[n])?t[n]:ne(t[n])?t[n]:[t[n]],!1!==t[n]&&(e[n]=i),e},{}):"string"!=typeof t?(te("rules must be either a string or an object."),{}):t.split("|").reduce(function(t,e){var n=function(t){var e=[],n=t.split(":")[0];return be(t,":")&&(e=t.split(":").slice(1).join(":").split(",")),{name:n,params:e}}(e);return n.name?(t[n.name]=n.params,t):t},{}):{}},te=function(t){console.warn("[vee-validate] "+t)},ee=function(t){return new Error("[vee-validate] "+t)},ne=function(t){return null!==t&&t&&"object"==typeof t&&!Array.isArray(t)},ie=function(t){return"function"==typeof t},ae=function(t,e){return t.classList?t.classList.contains(e):!!t.className.match(new RegExp("(\\s|^)"+e+"(\\s|$)"))},oe=function(t,e,n){if(t&&e){if(!Array.isArray(e))return n?function(t,e){t.classList?t.classList.add(e):ae(t,e)||(t.className+=" "+e)}(t,e):void function(t,e){if(t.classList)t.classList.remove(e);else if(ae(t,e)){var n=new RegExp("(\\s|^)"+e+"(\\s|$)");t.className=t.className.replace(n," ")}}(t,e);e.forEach(function(e){return oe(t,e,n)})}},re=function(t){if(ie(Array.from))return Array.from(t);for(var e=[],n=t.length,i=0;i<n;i++)e.push(t[i]);return e},se=function(t){if(Array.isArray(t))return[].concat(t);var e=re(t);return xe(e)?[t]:e},le=function(t){for(var e=[],n=arguments.length-1;n-- >0;)e[n]=arguments[n+1];if(ie(Object.assign))return Object.assign.apply(Object,[t].concat(e));if(null==t)throw new TypeError("Cannot convert undefined or null to object");var i=Object(t);return e.forEach(function(t){null!=t&&Object.keys(t).forEach(function(e){i[e]=t[e]})}),i},de=0,ce="{id}",he=function(t,e){for(var n=Array.isArray(t)?t:re(t),i=0;i<n.length;i++)if(e(n[i]))return i;return-1},ue=function(t,e){var n=Array.isArray(t)?t:re(t),i=he(n,e);return-1===i?void 0:n[i]},me=function(t){if(!t)return!1;var e=t.componentOptions.tag;return/^(keep-alive|transition|transition-group)$/.test(e)},fe=function(t){if("number"==typeof t)return t;if("string"==typeof t)return parseInt(t);var e={};for(var n in t)e[n]=parseInt(t[n]);return e},pe=function(t,e){return ne(t)&&ne(e)?(Object.keys(e).forEach(function(n){var i,a;if(ne(e[n]))return t[n]||le(t,((i={})[n]={},i)),void pe(t[n],e[n]);le(t,((a={})[n]=e[n],a))}),t):t},_e=function(t,e){if(t.required&&(e=Qt("required",e)),zt(t))return"email"===t.type&&(e=Qt("email"+(t.multiple?":multiple":""),e)),t.pattern&&(e=Qt({regex:t.pattern},e)),t.maxLength>=0&&t.maxLength<524288&&(e=Qt("max:"+t.maxLength,e)),t.minLength>0&&(e=Qt("min:"+t.minLength,e)),"number"===t.type&&(e=Qt("decimal",e),""!==t.min&&(e=Qt("min_value:"+t.min,e)),""!==t.max&&(e=Qt("max_value:"+t.max,e))),e;if(function(t){return be(["date","week","month","datetime-local","time"],t.type)}(t)){var n=t.step&&Number(t.step)<60?"HH:mm:ss":"HH:mm";if("date"===t.type)return Qt("date_format:yyyy-MM-dd",e);if("datetime-local"===t.type)return Qt("date_format:yyyy-MM-ddT"+n,e);if("month"===t.type)return Qt("date_format:yyyy-MM",e);if("week"===t.type)return Qt("date_format:yyyy-[W]WW",e);if("time"===t.type)return Qt("date_format:"+n,e)}return e},Ae=function(t){return ie(Object.values)?Object.values(t):Object.keys(t).map(function(e){return t[e]})},be=function(t,e){return-1!==t.indexOf(e)},xe=function(t){return Array.isArray(t)&&0===t.length},ge=function(t,e,n){Object.defineProperty(t,e,{configurable:!1,writable:!0,value:n})},ve="en",Ce=function(t){void 0===t&&(t={}),this.container={},this.merge(t)},ye={locale:{configurable:!0}};ye.locale.get=function(){return ve},ye.locale.set=function(t){ve=t||"en"},Ce.prototype.hasLocale=function(t){return!!this.container[t]},Ce.prototype.setDateFormat=function(t,e){this.container[t]||(this.container[t]={}),this.container[t].dateFormat=e},Ce.prototype.getDateFormat=function(t){return this.container[t]&&this.container[t].dateFormat?this.container[t].dateFormat:null},Ce.prototype.getMessage=function(t,e,n){var i=null;return i=this.hasMessage(t,e)?this.container[t].messages[e]:this._getDefaultMessage(t),ie(i)?i.apply(void 0,n):i},Ce.prototype.getFieldMessage=function(t,e,n,i){if(!this.hasLocale(t))return this.getMessage(t,n,i);var a=this.container[t].custom&&this.container[t].custom[e];if(!a||!a[n])return this.getMessage(t,n,i);var o=a[n];return ie(o)?o.apply(void 0,i):o},Ce.prototype._getDefaultMessage=function(t){return this.hasMessage(t,"_default")?this.container[t].messages._default:this.container.en.messages._default},Ce.prototype.getAttribute=function(t,e,n){return void 0===n&&(n=""),this.hasAttribute(t,e)?this.container[t].attributes[e]:n},Ce.prototype.hasMessage=function(t,e){return!!(this.hasLocale(t)&&this.container[t].messages&&this.container[t].messages[e])},Ce.prototype.hasAttribute=function(t,e){return!!(this.hasLocale(t)&&this.container[t].attributes&&this.container[t].attributes[e])},Ce.prototype.merge=function(t){pe(this.container,t)},Ce.prototype.setMessage=function(t,e,n){this.hasLocale(t)||(this.container[t]={messages:{},attributes:{}}),this.container[t].messages||(this.container[t].messages={}),this.container[t].messages[e]=n},Ce.prototype.setAttribute=function(t,e,n){this.hasLocale(t)||(this.container[t]={messages:{},attributes:{}}),this.container[t].attributes[e]=n},Object.defineProperties(Ce.prototype,ye);var we={default:new Ce({en:{messages:{},attributes:{},custom:{}}})},Be="default",ke=function(){};ke._checkDriverName=function(t){if(!t)throw ee("you must provide a name to the dictionary driver")},ke.setDriver=function(t,e){void 0===e&&(e=null),this._checkDriverName(t),e&&(we[t]=e),Be=t},ke.getDriver=function(){return we[Be]};var Ee=function t(e,n){void 0===e&&(e=null),void 0===n&&(n=null),this.vmId=n||null,this.items=e&&e instanceof t?e.items:[]};Ee.prototype["function"==typeof Symbol?Symbol.iterator:"@@iterator"]=function(){var t=this,e=0;return{next:function(){return{value:t.items[e++],done:e>t.items.length}}}},Ee.prototype.add=function(t){var e;(e=this.items).push.apply(e,this._normalizeError(t))},Ee.prototype._normalizeError=function(t){var e=this;return Array.isArray(t)?t.map(function(t){return t.scope=Wt(t.scope)?null:t.scope,t.vmId=Wt(t.vmId)?e.vmId||null:t.vmId,t}):(t.scope=Wt(t.scope)?null:t.scope,t.vmId=Wt(t.vmId)?this.vmId||null:t.vmId,[t])},Ee.prototype.regenerate=function(){this.items.forEach(function(t){t.msg=ie(t.regenerate)?t.regenerate():t.msg})},Ee.prototype.update=function(t,e){var n=ue(this.items,function(e){return e.id===t});if(n){var i=this.items.indexOf(n);this.items.splice(i,1),n.scope=e.scope,this.items.push(n)}},Ee.prototype.all=function(t){var e=this;return this.items.filter(function(n){var i=!0,a=!0;return Wt(t)||(i=n.scope===t),Wt(e.vmId)||(a=n.vmId===e.vmId),a&&i}).map(function(t){return t.msg})},Ee.prototype.any=function(t){var e=this;return!!this.items.filter(function(n){var i=!0,a=!0;return Wt(t)||(i=n.scope===t),Wt(e.vmId)||(a=n.vmId===e.vmId),a&&i}).length},Ee.prototype.clear=function(t){var e=this,n=Wt(this.vmId)?function(){return!0}:function(t){return t.vmId===e.vmId},i=function(e){return e.scope===t};0===arguments.length?i=function(){return!0}:Wt(t)&&(t=null);for(var a=0;a<this.items.length;++a)n(this.items[a])&&i(this.items[a])&&(this.items.splice(a,1),--a)},Ee.prototype.collect=function(t,e,n){var i=this;void 0===n&&(n=!0);var a=!Wt(t)&&!t.includes("*"),o=function(t){var e=t.reduce(function(t,e){return Wt(i.vmId)||e.vmId===i.vmId?(t[e.field]||(t[e.field]=[]),t[e.field].push(n?e.msg:e),t):t},{});return a?Ae(e)[0]||[]:e};if(Wt(t))return o(this.items);var r=Wt(e)?String(t):e+"."+t,s=this._makeCandidateFilters(r),l=s.isPrimary,d=s.isAlt,c=this.items.reduce(function(t,e){return l(e)&&t.primary.push(e),d(e)&&t.alt.push(e),t},{primary:[],alt:[]});return o(c=c.primary.length?c.primary:c.alt)},Ee.prototype.count=function(){var t=this;return this.vmId?this.items.filter(function(e){return e.vmId===t.vmId}).length:this.items.length},Ee.prototype.firstById=function(t){var e=ue(this.items,function(e){return e.id===t});return e?e.msg:void 0},Ee.prototype.first=function(t,e){void 0===e&&(e=null);var n=Wt(e)?t:e+"."+t,i=this._match(n);return i&&i.msg},Ee.prototype.firstRule=function(t,e){var n=this.collect(t,e,!1);return n.length&&n[0].rule||void 0},Ee.prototype.has=function(t,e){return void 0===e&&(e=null),!!this.first(t,e)},Ee.prototype.firstByRule=function(t,e,n){void 0===n&&(n=null);var i=this.collect(t,n,!1).filter(function(t){return t.rule===e})[0];return i&&i.msg||void 0},Ee.prototype.firstNot=function(t,e,n){void 0===e&&(e="required"),void 0===n&&(n=null);var i=this.collect(t,n,!1).filter(function(t){return t.rule!==e})[0];return i&&i.msg||void 0},Ee.prototype.removeById=function(t){var e=function(e){return e.id===t};Array.isArray(t)&&(e=function(e){return-1!==t.indexOf(e.id)});for(var n=0;n<this.items.length;++n)e(this.items[n])&&(this.items.splice(n,1),--n)},Ee.prototype.remove=function(t,e,n){if(!Wt(t))for(var i,a=Wt(e)?String(t):e+"."+t,o=this._makeCandidateFilters(a),r=o.isPrimary,s=o.isAlt,l=function(t){return r(t)||s(t)},d=0;d<this.items.length;++d)i=this.items[d],(Wt(n)?l(i):l(i)&&i.vmId===n)&&(this.items.splice(d,1),--d)},Ee.prototype._makeCandidateFilters=function(t){var e=this,n=function(){return!0},i=function(){return!0},a=function(){return!0},o=function(){return!0},r=function(t){var e=null;if(be(t,":")&&(e=t.split(":").pop(),t=t.replace(":"+e,"")),"#"===t[0])return{id:t.slice(1),rule:e,name:null,scope:null};var n=null,i=t;if(be(t,".")){var a=t.split(".");n=a[0],i=a.slice(1).join(".")}return{id:null,scope:n,name:i,rule:e}}(t),s=r.id,l=r.rule,d=r.scope,c=r.name;if(l&&(n=function(t){return t.rule===l}),s)return{isPrimary:function(t){return n(t)&&function(t){return s===t.id}},isAlt:function(){return!1}};i=Wt(d)?function(t){return Wt(t.scope)}:function(t){return t.scope===d},Wt(c)||"*"===c||(a=function(t){return t.field===c}),Wt(this.vmId)||(o=function(t){return t.vmId===e.vmId});return{isPrimary:function(t){return o(t)&&a(t)&&n(t)&&i(t)},isAlt:function(t){return o(t)&&n(t)&&t.field===d+"."+c}}},Ee.prototype._match=function(t){if(!Wt(t)){var e=this._makeCandidateFilters(t),n=e.isPrimary,i=e.isAlt;return this.items.reduce(function(t,e,a,o){var r=a===o.length-1;return t.primary?r?t.primary:t:(n(e)&&(t.primary=e),i(e)&&(t.alt=e),r?t.primary||t.alt:t)},{})}};var Ie=le({},{locale:"en",delay:0,errorBagName:"errors",dictionary:null,fieldsBagName:"fields",classes:!1,classNames:null,events:"input",inject:!0,fastExit:!0,aria:!0,validity:!1,mode:"aggressive",useConstraintAttrs:!0,i18n:null,i18nRootKey:"validation"}),De=function(t){var e=Zt("$options.$_veeValidate",t,{});return le({},Ie,e)},Se=function(){return Ie},Ne=function(t){Ie=le({},Ie,t)};function Me(t){return t.data?t.data.model?t.data.model:!!t.data.directives&&ue(t.data.directives,function(t){return"model"===t.name}):null}function Oe(t){return Me(t)?[t]:function(t){return Array.isArray(t)?t:Array.isArray(t.children)?t.children:t.componentOptions&&Array.isArray(t.componentOptions.children)?t.componentOptions.children:[]}(t).reduce(function(t,e){var n=Oe(e);return n.length&&t.push.apply(t,n),t},[])}function Te(t){return t.componentOptions?t.componentOptions.Ctor.options.model:null}function Le(t,e,n){if(ie(t[e])){var i=t[e];t[e]=[i]}Wt(t[e])&&(t[e]=[]),t[e].push(n)}function je(t,e,n){t.componentOptions?function(t,e,n){t.componentOptions.listeners||(t.componentOptions.listeners={}),Le(t.componentOptions.listeners,e,n)}(t,e,n):function(t,e,n){Wt(t.data.on)&&(t.data.on={}),Le(t.data.on,e,n)}(t,e,n)}function Pe(t,e){return t.componentOptions?(Te(t)||{event:"input"}).event:e&&e.modifiers&&e.modifiers.lazy||"select"===t.tag?"change":t.data.attrs&&zt({type:t.data.attrs.type||"text"})?"input":"change"}function Fe(t,e){return Array.isArray(e)&&e[0]?e[0]:e||t()}var Ye=function(){};Ye.generate=function(t,e,n){var i=Ye.resolveModel(e,n),a=De(n.context);return{name:Ye.resolveName(t,n),el:t,listen:!e.modifiers.disable,bails:!!e.modifiers.bails||!0!==e.modifiers.continues&&void 0,scope:Ye.resolveScope(t,e,n),vm:n.context,expression:e.value,component:n.componentInstance,classes:a.classes,classNames:a.classNames,getter:Ye.resolveGetter(t,n,i),events:Ye.resolveEvents(t,n)||a.events,model:i,delay:Ye.resolveDelay(t,n,a),rules:Ye.resolveRules(t,e,n),immediate:!!e.modifiers.initial||!!e.modifiers.immediate,persist:!!e.modifiers.persist,validity:a.validity&&!n.componentInstance,aria:a.aria&&!n.componentInstance,initialValue:Ye.resolveInitialValue(n)}},Ye.getCtorConfig=function(t){return t.componentInstance?Zt("componentInstance.$options.$_veeValidate",t):null},Ye.resolveRules=function(t,e,n){var i="";if(e.value||e&&e.expression||(i=Vt(t,"rules")),e.value&&be(["string","object"],typeof e.value.rules)?i=e.value.rules:e.value&&(i=e.value),n.componentInstance)return i;var a=Kt(i);return Se().useConstraintAttrs?le({},_e(t,{}),a):a},Ye.resolveInitialValue=function(t){var e=t.data.model||ue(t.data.directives,function(t){return"model"===t.name});return e&&e.value},Ye.resolveDelay=function(t,e,n){var i=Vt(t,"delay"),a=n&&"delay"in n?n.delay:0;return!i&&e.componentInstance&&e.componentInstance.$attrs&&(i=e.componentInstance.$attrs["data-vv-delay"]),ne(a)?(Wt(i)||(a.input=i),fe(a)):fe(i||a)},Ye.resolveEvents=function(t,e){var n=Vt(t,"validate-on");if(!n&&e.componentInstance&&e.componentInstance.$attrs&&(n=e.componentInstance.$attrs["data-vv-validate-on"]),!n&&e.componentInstance){var i=Ye.getCtorConfig(e);n=i&&i.events}if(!n&&Se().events&&(n=Se().events),n&&e.componentInstance&&be(n,"input")){var a=(e.componentInstance.$options.model||{event:"input"}).event;if(!a)return n;n=n.replace("input",a)}return n},Ye.resolveScope=function(t,e,n){void 0===n&&(n={});var i=null;return n.componentInstance&&Wt(i)&&(i=n.componentInstance.$attrs&&n.componentInstance.$attrs["data-vv-scope"]),Wt(i)?function(t){var e=Vt(t,"scope");if(Wt(e)){var n=Gt(t);n&&(e=Vt(n,"scope"))}return Wt(e)?null:e}(t):i},Ye.resolveModel=function(t,e){if(t.arg)return{expression:t.arg};var n=Me(e);if(!n)return null;var i,a,o,r,s=!/[^\w.$]/.test(n.expression)&&(i=n.expression,a=e.context,o=a,r=null,i.split(".").reduce(function(t,e){return null==o||"object"!=typeof o?t&&!1:e in o?(o=o[e],r=null===r?e:r+"."+e,t&&!0):t&&!1},!0)),l=!(!n.modifiers||!n.modifiers.lazy);return s?{expression:n.expression,lazy:l}:{expression:null,lazy:l}},Ye.resolveName=function(t,e){var n=Vt(t,"name");if(!n&&!e.componentInstance)return t.name;if(!n&&e.componentInstance&&e.componentInstance.$attrs&&(n=e.componentInstance.$attrs["data-vv-name"]||e.componentInstance.$attrs.name),!n&&e.componentInstance){var i=Ye.getCtorConfig(e);return i&&ie(i.name)?i.name.bind(e.componentInstance)():e.componentInstance.name}return n},Ye.resolveGetter=function(t,e,n){if(n&&n.expression)return function(){return Zt(n.expression,e.context)};if(e.componentInstance){var i=Vt(t,"value-path")||e.componentInstance.$attrs&&e.componentInstance.$attrs["data-vv-value-path"];if(i)return function(){return Zt(i,e.componentInstance)};var a=Ye.getCtorConfig(e);if(a&&ie(a.value)){var o=a.value.bind(e.componentInstance);return function(){return o()}}var r=(e.componentInstance.$options.model||{prop:"value"}).prop;return function(){return e.componentInstance[r]}}switch(t.type){case"checkbox":return function(){var e=document.querySelectorAll('input[name="'+t.name+'"]');if((e=re(e).filter(function(t){return t.checked})).length)return e.map(function(t){return t.value})};case"radio":return function(){var e=document.querySelectorAll('input[name="'+t.name+'"]'),n=ue(e,function(t){return t.checked});return n&&n.value};case"file":return function(e){return re(t.files)};case"select-multiple":return function(){return re(t.options).filter(function(t){return t.selected}).map(function(t){return t.value})};default:return function(){return t&&t.value}}};var Re={},He=function(){},$e={rules:{configurable:!0}};He.add=function(t,e){var n=e.validate,i=e.options,a=e.paramNames;Re[t]={validate:n,options:i,paramNames:a}},$e.rules.get=function(){return Re},He.has=function(t){return!!Re[t]},He.isImmediate=function(t){return!(!Re[t]||!Re[t].options.immediate)},He.isRequireRule=function(t){return!(!Re[t]||!Re[t].options.computesRequired)},He.isTargetRule=function(t){return!(!Re[t]||!Re[t].options.hasTarget)},He.remove=function(t){delete Re[t]},He.getParamNames=function(t){return Re[t]&&Re[t].paramNames},He.getOptions=function(t){return Re[t]&&Re[t].options},He.getValidatorMethod=function(t){return Re[t]?Re[t].validate:null},Object.defineProperties(He,$e);var ze=function(t){return"undefined"!=typeof Event&&ie(Event)&&t instanceof Event||t&&t.srcElement},Xe=function(t){return t?"string"==typeof t?t.split("|"):t:[]},Ve=!0,qe=function(t,e,n){t.addEventListener(e,n,!!Ve&&{passive:!0})},We={targetOf:null,immediate:!1,persist:!1,scope:null,listen:!0,name:null,rules:{},vm:null,classes:!1,validity:!0,aria:!0,events:"input|blur",delay:0,classNames:{touched:"touched",untouched:"untouched",valid:"valid",invalid:"invalid",pristine:"pristine",dirty:"dirty"}},Ue=function(t){void 0===t&&(t={}),this.id=(de>=9999&&(de=0,ce=ce.replace("{id}","_{id}")),de++,ce.replace("{id}",String(de))),this.el=t.el,this.updated=!1,this.vmId=t.vmId,ge(this,"dependencies",[]),ge(this,"watchers",[]),ge(this,"events",[]),this.delay=0,this.rules={},this.forceRequired=!1,this._cacheId(t),this.classNames=le({},We.classNames),t=le({},We,t),this._delay=Wt(t.delay)?0:t.delay,this.validity=t.validity,this.aria=t.aria,this.flags=t.flags||{untouched:!0,touched:!1,dirty:!1,pristine:!0,valid:null,invalid:null,validated:!1,pending:!1,required:!1,changed:!1},ge(this,"vm",t.vm),ge(this,"componentInstance",t.component),this.ctorConfig=this.componentInstance?Zt("$options.$_veeValidate",this.componentInstance):void 0,this.update(t),this.initialValue=this.value,this.updated=!1},Ge={validator:{configurable:!0},isRequired:{configurable:!0},isDisabled:{configurable:!0},alias:{configurable:!0},value:{configurable:!0},bails:{configurable:!0},rejectsFalse:{configurable:!0}};Ge.validator.get=function(){return this.vm&&this.vm.$validator?this.vm.$validator:{validate:function(){return Promise.resolve(!0)}}},Ge.isRequired.get=function(){return!!this.rules.required||this.forceRequired},Ge.isDisabled.get=function(){return!(!this.el||!this.el.disabled)},Ge.alias.get=function(){if(this._alias)return this._alias;var t=null;return this.ctorConfig&&this.ctorConfig.alias&&(t=ie(this.ctorConfig.alias)?this.ctorConfig.alias.call(this.componentInstance):this.ctorConfig.alias),!t&&this.el&&(t=Vt(this.el,"as")),!t&&this.componentInstance?this.componentInstance.$attrs&&this.componentInstance.$attrs["data-vv-as"]:t},Ge.value.get=function(){if(ie(this.getter))return this.getter()},Ge.bails.get=function(){return this._bails},Ge.rejectsFalse.get=function(){return this.componentInstance&&this.ctorConfig?!!this.ctorConfig.rejectsFalse:!!this.el&&"checkbox"===this.el.type},Ue.prototype.matches=function(t){var e=this;return!t||(t.id?this.id===t.id:!!(Wt(t.vmId)?function(){return!0}:function(t){return t===e.vmId})(t.vmId)&&(void 0===t.name&&void 0===t.scope||(void 0===t.scope?this.name===t.name:void 0===t.name?this.scope===t.scope:t.name===this.name&&t.scope===this.scope)))},Ue.prototype._cacheId=function(t){this.el&&!t.targetOf&&(this.el._veeValidateId=this.id)},Ue.prototype.waitFor=function(t){this._waitingFor=t},Ue.prototype.isWaitingFor=function(t){return this._waitingFor===t},Ue.prototype.update=function(t){var e,n,i,a=this;if(this.targetOf=t.targetOf||null,this.immediate=t.immediate||this.immediate||!1,this.persist=t.persist||this.persist||!1,!Wt(t.scope)&&t.scope!==this.scope&&ie(this.validator.update)&&this.validator.update(this.id,{scope:t.scope}),this.scope=Wt(t.scope)?Wt(this.scope)?null:this.scope:t.scope,this.name=(Wt(t.name)?t.name:String(t.name))||this.name||null,this.rules=void 0!==t.rules?Kt(t.rules):this.rules,this._bails=void 0!==t.bails?t.bails:this._bails,this.model=t.model||this.model,this.listen=void 0!==t.listen?t.listen:this.listen,this.classes=!(!t.classes&&!this.classes)&&!this.componentInstance,this.classNames=ne(t.classNames)?pe(this.classNames,t.classNames):this.classNames,this.getter=ie(t.getter)?t.getter:this.getter,this._alias=t.alias||this._alias,this.events=t.events?Xe(t.events):this.events,this.delay=(e=this.events,n=t.delay||this.delay,i=this._delay,"number"==typeof n?e.reduce(function(t,e){return t[e]=n,t},{}):e.reduce(function(t,e){return"object"==typeof n&&e in n?(t[e]=n[e],t):"number"==typeof i?(t[e]=i,t):(t[e]=i&&i[e]||0,t)},{})),this.updateDependencies(),this.addActionListeners(),void 0!==t.rules&&(this.flags.required=this.isRequired),0===Object.keys(t.rules||{}).length&&this.updated){var o=this.flags.validated;this.validator.validate("#"+this.id).then(function(){a.flags.validated=o})}this.flags.validated&&void 0!==t.rules&&this.updated&&this.validator.validate("#"+this.id),this.updated=!0,this.addValueListeners(),this.el&&(this.updateClasses(),this.updateAriaAttrs())},Ue.prototype.reset=function(){var t=this;this._cancellationToken&&(this._cancellationToken.cancelled=!0,delete this._cancellationToken);var e={untouched:!0,touched:!1,dirty:!1,pristine:!0,valid:null,invalid:null,validated:!1,pending:!1,required:!1,changed:!1};Object.keys(this.flags).filter(function(t){return"required"!==t}).forEach(function(n){t.flags[n]=e[n]}),this.initialValue=this.value,this.flags.changed=!1,this.addValueListeners(),this.addActionListeners(),this.updateClasses(!0),this.updateAriaAttrs(),this.updateCustomValidity()},Ue.prototype.setFlags=function(t){var e=this,n={pristine:"dirty",dirty:"pristine",valid:"invalid",invalid:"valid",touched:"untouched",untouched:"touched"};Object.keys(t).forEach(function(i){e.flags[i]=t[i],n[i]&&void 0===t[n[i]]&&(e.flags[n[i]]=!t[i])}),void 0===t.untouched&&void 0===t.touched&&void 0===t.dirty&&void 0===t.pristine||this.addActionListeners(),this.updateClasses(),this.updateAriaAttrs(),this.updateCustomValidity()},Ue.prototype.updateDependencies=function(){var t=this;this.dependencies.forEach(function(t){return t.field.destroy()}),this.dependencies=[];var e=Object.keys(this.rules).reduce(function(e,n){return He.isTargetRule(n)&&e.push({selector:t.rules[n][0],name:n}),e},[]);e.length&&this.vm&&this.vm.$el&&e.forEach(function(e){var n=e.selector,i=e.name,a=t.vm.$refs[n],o=Array.isArray(a)?a[0]:a;if(o){var r={vm:t.vm,classes:t.classes,classNames:t.classNames,delay:t.delay,scope:t.scope,events:t.events.join("|"),immediate:t.immediate,targetOf:t.id};ie(o.$watch)?(r.component=o,r.el=o.$el,r.getter=Ye.resolveGetter(o.$el,o.$vnode)):(r.el=o,r.getter=Ye.resolveGetter(o,{})),t.dependencies.push({name:i,field:new Ue(r)})}})},Ue.prototype.unwatch=function(t){if(void 0===t&&(t=null),!t)return this.watchers.forEach(function(t){return t.unwatch()}),void(this.watchers=[]);this.watchers.filter(function(e){return t.test(e.tag)}).forEach(function(t){return t.unwatch()}),this.watchers=this.watchers.filter(function(e){return!t.test(e.tag)})},Ue.prototype.updateClasses=function(t){var e=this;if(void 0===t&&(t=!1),this.classes&&!this.isDisabled){var n=function(n){oe(n,e.classNames.dirty,e.flags.dirty),oe(n,e.classNames.pristine,e.flags.pristine),oe(n,e.classNames.touched,e.flags.touched),oe(n,e.classNames.untouched,e.flags.untouched),t&&(oe(n,e.classNames.valid,!1),oe(n,e.classNames.invalid,!1)),!Wt(e.flags.valid)&&e.flags.validated&&oe(n,e.classNames.valid,e.flags.valid),!Wt(e.flags.invalid)&&e.flags.validated&&oe(n,e.classNames.invalid,e.flags.invalid)};if(Xt(this.el)){var i=document.querySelectorAll('input[name="'+this.el.name+'"]');re(i).forEach(n)}else n(this.el)}},Ue.prototype.addActionListeners=function(){var t=this;if(this.unwatch(/class/),this.el){var e=function(){t.flags.touched=!0,t.flags.untouched=!1,t.classes&&(oe(t.el,t.classNames.touched,!0),oe(t.el,t.classNames.untouched,!1)),t.unwatch(/^class_blur$/)},n=zt(this.el)?"input":"change",i=function(){t.flags.dirty=!0,t.flags.pristine=!1,t.classes&&(oe(t.el,t.classNames.pristine,!1),oe(t.el,t.classNames.dirty,!0)),t.unwatch(/^class_input$/)};if(this.componentInstance&&ie(this.componentInstance.$once))return this.componentInstance.$once("input",i),this.componentInstance.$once("blur",e),this.watchers.push({tag:"class_input",unwatch:function(){t.componentInstance.$off("input",i)}}),void this.watchers.push({tag:"class_blur",unwatch:function(){t.componentInstance.$off("blur",e)}});if(this.el){qe(this.el,n,i);var a=Xt(this.el)?"change":"blur";qe(this.el,a,e),this.watchers.push({tag:"class_input",unwatch:function(){t.el.removeEventListener(n,i)}}),this.watchers.push({tag:"class_blur",unwatch:function(){t.el.removeEventListener(a,e)}})}}},Ue.prototype.checkValueChanged=function(){return(null!==this.initialValue||""!==this.value||!zt(this.el))&&this.value!==this.initialValue},Ue.prototype._determineInputEvent=function(){return this.componentInstance?this.componentInstance.$options.model&&this.componentInstance.$options.model.event||"input":this.model&&this.model.lazy?"change":zt(this.el)?"input":"change"},Ue.prototype._determineEventList=function(t){var e=this;return!this.events.length||this.componentInstance||zt(this.el)?[].concat(this.events).map(function(t){return"input"===t&&e.model&&e.model.lazy?"change":t}):this.events.map(function(e){return"input"===e?t:e})},Ue.prototype.addValueListeners=function(){var t=this;if(this.unwatch(/^input_.+/),this.listen&&this.el){var e={cancelled:!1},n=this.targetOf?function(){var e=t.validator._resolveField("#"+t.targetOf);e&&e.flags.validated&&t.validator.validate("#"+t.targetOf)}:function(){for(var n=[],i=arguments.length;i--;)n[i]=arguments[i];(0===n.length||ze(n[0]))&&(n[0]=t.value),t.flags.pending=!0,t._cancellationToken=e,t.validator.validate("#"+t.id,n[0])},i=this._determineInputEvent(),a=this._determineEventList(i);if(be(a,i)){var o=null,r=null,s=!1;if(this.model&&this.model.expression&&(o=this.vm,r=this.model.expression,s=!0),!r&&this.componentInstance&&this.componentInstance.$options.model&&(o=this.componentInstance,r=this.componentInstance.$options.model.prop||"value"),o&&r){var l=Jt(n,this.delay[i],e),d=o.$watch(r,l);this.watchers.push({tag:"input_model",unwatch:function(){t.vm.$nextTick(function(){d()})}}),s&&(a=a.filter(function(t){return t!==i}))}}a.forEach(function(i){var a=Jt(n,t.delay[i],e);t._addComponentEventListener(i,a),t._addHTMLEventListener(i,a)})}},Ue.prototype._addComponentEventListener=function(t,e){var n=this;this.componentInstance&&(this.componentInstance.$on(t,e),this.watchers.push({tag:"input_vue",unwatch:function(){n.componentInstance.$off(t,e)}}))},Ue.prototype._addHTMLEventListener=function(t,e){var n=this;if(this.el&&!this.componentInstance){var i=function(i){qe(i,t,e),n.watchers.push({tag:"input_native",unwatch:function(){i.removeEventListener(t,e)}})};if(i(this.el),Xt(this.el)){var a=document.querySelectorAll('input[name="'+this.el.name+'"]');re(a).forEach(function(t){t._veeValidateId&&t!==n.el||i(t)})}}},Ue.prototype.updateAriaAttrs=function(){var t=this;if(this.aria&&this.el&&ie(this.el.setAttribute)){var e=function(e){e.setAttribute("aria-required",t.isRequired?"true":"false"),e.setAttribute("aria-invalid",t.flags.invalid?"true":"false")};if(Xt(this.el)){var n=document.querySelectorAll('input[name="'+this.el.name+'"]');re(n).forEach(e)}else e(this.el)}},Ue.prototype.updateCustomValidity=function(){this.validity&&this.el&&ie(this.el.setCustomValidity)&&this.validator.errors&&this.el.setCustomValidity(this.flags.valid?"":this.validator.errors.firstById(this.id)||"")},Ue.prototype.destroy=function(){this._cancellationToken&&(this._cancellationToken.cancelled=!0),this.unwatch(),this.dependencies.forEach(function(t){return t.field.destroy()}),this.dependencies=[]},Object.defineProperties(Ue.prototype,Ge);var Ze=function(t){void 0===t&&(t=[]),this.items=t||[],this.itemsById=this.items.reduce(function(t,e){return t[e.id]=e,t},{})},Je={length:{configurable:!0}};Ze.prototype["function"==typeof Symbol?Symbol.iterator:"@@iterator"]=function(){var t=this,e=0;return{next:function(){return{value:t.items[e++],done:e>t.items.length}}}},Je.length.get=function(){return this.items.length},Ze.prototype.find=function(t){return ue(this.items,function(e){return e.matches(t)})},Ze.prototype.findById=function(t){return this.itemsById[t]||null},Ze.prototype.filter=function(t){return Array.isArray(t)?this.items.filter(function(e){return t.some(function(t){return e.matches(t)})}):this.items.filter(function(e){return e.matches(t)})},Ze.prototype.map=function(t){return this.items.map(t)},Ze.prototype.remove=function(t){var e=null;if(!(e=t instanceof Ue?t:this.find(t)))return null;var n=this.items.indexOf(e);return this.items.splice(n,1),delete this.itemsById[e.id],e},Ze.prototype.push=function(t){if(!(t instanceof Ue))throw ee("FieldBag only accepts instances of Field that has an id defined.");if(!t.id)throw ee("Field id must be defined.");if(this.findById(t.id))throw ee("Field with id "+t.id+" is already added.");this.items.push(t),this.itemsById[t.id]=t},Object.defineProperties(Ze.prototype,Je);var Qe=function(t,e){this.id=e._uid,this._base=t,this._paused=!1,this.errors=new Ee(t.errors,this.id)},Ke={flags:{configurable:!0},rules:{configurable:!0},fields:{configurable:!0},dictionary:{configurable:!0},locale:{configurable:!0}};Ke.flags.get=function(){var t=this;return this._base.fields.items.filter(function(e){return e.vmId===t.id}).reduce(function(t,e){return e.scope&&(t["$"+e.scope]||(t["$"+e.scope]={}),t["$"+e.scope][e.name]=e.flags),t[e.name]=e.flags,t},{})},Ke.rules.get=function(){return this._base.rules},Ke.fields.get=function(){return new Ze(this._base.fields.filter({vmId:this.id}))},Ke.dictionary.get=function(){return this._base.dictionary},Ke.locale.get=function(){return this._base.locale},Ke.locale.set=function(t){this._base.locale=t},Qe.prototype.localize=function(){for(var t,e=[],n=arguments.length;n--;)e[n]=arguments[n];return(t=this._base).localize.apply(t,e)},Qe.prototype.update=function(){for(var t,e=[],n=arguments.length;n--;)e[n]=arguments[n];return(t=this._base).update.apply(t,e)},Qe.prototype.attach=function(t){var e=le({},t,{vmId:this.id});return this._base.attach(e)},Qe.prototype.pause=function(){this._paused=!0},Qe.prototype.resume=function(){this._paused=!1},Qe.prototype.remove=function(t){return this._base.remove(t)},Qe.prototype.detach=function(t,e){return this._base.detach(t,e,this.id)},Qe.prototype.extend=function(){for(var t,e=[],n=arguments.length;n--;)e[n]=arguments[n];return(t=this._base).extend.apply(t,e)},Qe.prototype.validate=function(t,e,n){return void 0===n&&(n={}),this._paused?Promise.resolve(!0):this._base.validate(t,e,le({},{vmId:this.id},n||{}))},Qe.prototype.verify=function(){for(var t,e=[],n=arguments.length;n--;)e[n]=arguments[n];return(t=this._base).verify.apply(t,e)},Qe.prototype.validateAll=function(t,e){return void 0===e&&(e={}),this._paused?Promise.resolve(!0):this._base.validateAll(t,le({},{vmId:this.id},e||{}))},Qe.prototype.validateScopes=function(t){return void 0===t&&(t={}),this._paused?Promise.resolve(!0):this._base.validateScopes(le({},{vmId:this.id},t||{}))},Qe.prototype.destroy=function(){delete this.id,delete this._base},Qe.prototype.reset=function(t){return this._base.reset(Object.assign({},t||{},{vmId:this.id}))},Qe.prototype.flag=function(){for(var t,e=[],n=arguments.length;n--;)e[n]=arguments[n];return(t=this._base).flag.apply(t,e.concat([this.id]))},Qe.prototype._resolveField=function(){for(var t,e=[],n=arguments.length;n--;)e[n]=arguments[n];return(t=this._base)._resolveField.apply(t,e)},Object.defineProperties(Qe.prototype,Ke);var tn=null,en=function(){return tn},nn={provide:function(){return this.$validator&&!me(this.$vnode)?{$validator:this.$validator}:{}},beforeCreate:function(){if(!me(this.$vnode)&&!1!==this.$options.$__veeInject){this.$parent||Ne(this.$options.$_veeValidate||{});var t=De(this);(!this.$parent||this.$options.$_veeValidate&&/new/.test(this.$options.$_veeValidate.validator))&&(this.$validator=new Qe(en(),this));var e,n=(e=this.$options.inject,!(!ne(e)||!e.$validator));if(this.$validator||!t.inject||n||(this.$validator=new Qe(en(),this)),n||this.$validator){if(!n&&this.$validator)this.$options._base.util.defineReactive(this.$validator,"errors",this.$validator.errors);this.$options.computed||(this.$options.computed={}),this.$options.computed[t.errorBagName||"errors"]=function(){return this.$validator.errors},this.$options.computed[t.fieldsBagName||"fields"]=function(){return this.$validator.fields.items.reduce(function(t,e){return e.scope?(t["$"+e.scope]||(t["$"+e.scope]={}),t["$"+e.scope][e.name]=e.flags,t):(t[e.name]=e.flags,t)},{})}}}},beforeDestroy:function(){this.$validator&&this._uid===this.$validator.id&&this.$validator.errors.clear()}};function an(t,e){return e&&e.$validator?e.$validator.fields.findById(t._veeValidateId):null}var on={bind:function(t,e,n){var i=n.context.$validator;if(i){var a=Ye.generate(t,e,n);i.attach(a)}},inserted:function(t,e,n){var i=an(t,n.context),a=Ye.resolveScope(t,e,n);i&&a!==i.scope&&(i.update({scope:a}),i.updated=!1)},update:function(t,e,n){var i=an(t,n.context);if(!(!i||i.updated&&Ut(e.value,e.oldValue))){var a=Ye.resolveScope(t,e,n),o=Ye.resolveRules(t,e,n);i.update({scope:a,rules:o})}},unbind:function(t,e,n){var i=n.context,a=an(t,i);a&&i.$validator.detach(a)}},rn=function(t,e,n){void 0===e&&(e={fastExit:!0}),void 0===n&&(n=null),this.errors=new Ee,this.fields=new Ze,this._createFields(t),this.paused=!1,this.fastExit=!!Wt(e&&e.fastExit)||e.fastExit,this.$vee=n||{_vm:{$nextTick:function(t){return ie(t)?t():Promise.resolve()},$emit:function(){},$off:function(){}}}},sn={rules:{configurable:!0},dictionary:{configurable:!0},flags:{configurable:!0},locale:{configurable:!0}},ln={rules:{configurable:!0},dictionary:{configurable:!0},locale:{configurable:!0}};ln.rules.get=function(){return He.rules},sn.rules.get=function(){return He.rules},sn.dictionary.get=function(){return ke.getDriver()},ln.dictionary.get=function(){return ke.getDriver()},sn.flags.get=function(){return this.fields.items.reduce(function(t,e){var n;return e.scope?(t["$"+e.scope]=((n={})[e.name]=e.flags,n),t):(t[e.name]=e.flags,t)},{})},sn.locale.get=function(){return rn.locale},sn.locale.set=function(t){rn.locale=t},ln.locale.get=function(){return ke.getDriver().locale},ln.locale.set=function(t){var e=t!==ke.getDriver().locale;ke.getDriver().locale=t,e&&rn.$vee&&rn.$vee._vm&&rn.$vee._vm.$emit("localeChanged")},rn.create=function(t,e){return new rn(t,e)},rn.extend=function(t,e,n){void 0===n&&(n={}),rn._guardExtend(t,e);var i=e.options||{};rn._merge(t,{validator:e,paramNames:n&&n.paramNames||e.paramNames,options:le({hasTarget:!1,immediate:!0},i,n||{})})},rn.remove=function(t){He.remove(t)},rn.prototype.localize=function(t,e){rn.localize(t,e)},rn.localize=function(t,e){var n;if(ne(t))ke.getDriver().merge(t);else{if(e){var i=t||e.name;e=le({},e),ke.getDriver().merge(((n={})[i]=e,n))}t&&(rn.locale=t)}},rn.prototype.attach=function(t){var e=this,n={name:t.name,scope:t.scope,persist:!0},i=t.persist?this.fields.find(n):null;i&&(t.flags=i.flags,i.destroy(),this.fields.remove(i));var a=t.initialValue,o=new Ue(t);return this.fields.push(o),o.immediate?this.$vee._vm.$nextTick(function(){return e.validate("#"+o.id,a||o.value,{vmId:t.vmId})}):this._validate(o,a||o.value,{initial:!0}).then(function(t){o.flags.valid=t.valid,o.flags.invalid=!t.valid}),o},rn.prototype.flag=function(t,e,n){void 0===n&&(n=null);var i=this._resolveField(t,void 0,n);i&&e&&i.setFlags(e)},rn.prototype.detach=function(t,e,n){var i=ie(t.destroy)?t:this._resolveField(t,e,n);i&&(i.persist||(i.destroy(),this.errors.remove(i.name,i.scope,i.vmId),this.fields.remove(i)))},rn.prototype.extend=function(t,e,n){void 0===n&&(n={}),rn.extend(t,e,n)},rn.prototype.reset=function(t){var e=this;return this.$vee._vm.$nextTick().then(function(){return e.$vee._vm.$nextTick()}).then(function(){e.fields.filter(t).forEach(function(n){n.waitFor(null),n.reset(),e.errors.remove(n.name,n.scope,t&&t.vmId)})})},rn.prototype.update=function(t,e){var n=e.scope;this._resolveField("#"+t)&&this.errors.update(t,{scope:n})},rn.prototype.remove=function(t){rn.remove(t)},rn.prototype.validate=function(t,e,n){var i=this;void 0===n&&(n={});var a=n.silent,o=n.vmId;if(this.paused)return Promise.resolve(!0);if(Wt(t))return this.validateScopes({silent:a,vmId:o});if("*"===t)return this.validateAll(void 0,{silent:a,vmId:o});if(/^(.+)\.\*$/.test(t)){var r=t.match(/^(.+)\.\*$/)[1];return this.validateAll(r)}var s=this._resolveField(t);if(!s)return this._handleFieldNotFound(t);a||(s.flags.pending=!0),void 0===e&&(e=s.value);var l=this._validate(s,e);return s.waitFor(l),l.then(function(t){return!a&&s.isWaitingFor(l)&&(s.waitFor(null),i._handleValidationResults([t],o)),t.valid})},rn.prototype.pause=function(){return this.paused=!0,this},rn.prototype.resume=function(){return this.paused=!1,this},rn.prototype.validateAll=function(t,e){var n=this;void 0===e&&(e={});var i=e.silent,a=e.vmId;if(this.paused)return Promise.resolve(!0);var o=null,r=!1;return"string"==typeof t?o={scope:t,vmId:a}:ne(t)?(o=Object.keys(t).map(function(t){return{name:t,vmId:a,scope:null}}),r=!0):o=Array.isArray(t)?t.map(function(t){return"object"==typeof t?Object.assign({vmId:a},t):{name:t,vmId:a}}):{scope:null,vmId:a},Promise.all(this.fields.filter(o).map(function(e){return n._validate(e,r?t[e.name]:e.value)})).then(function(t){return i||n._handleValidationResults(t,a),t.every(function(t){return t.valid})})},rn.prototype.validateScopes=function(t){var e=this;void 0===t&&(t={});var n=t.silent,i=t.vmId;return this.paused?Promise.resolve(!0):Promise.all(this.fields.filter({vmId:i}).map(function(t){return e._validate(t,t.value)})).then(function(t){return n||e._handleValidationResults(t,i),t.every(function(t){return t.valid})})},rn.prototype.verify=function(t,e,n){void 0===n&&(n={});var i={name:n&&n.name||"{field}",rules:Kt(e),bails:Zt("bails",n,!0),forceRequired:!1,get isRequired(){return!!this.rules.required||this.forceRequired}},a=Object.keys(i.rules).filter(He.isTargetRule);return a.length&&n&&ne(n.values)&&(i.dependencies=a.map(function(t){var e=i.rules[t][0];return{name:t,field:{value:n.values[e]}}})),this._validate(i,t).then(function(t){var e=[],n={};return t.errors.forEach(function(t){e.push(t.msg),n[t.rule]=t.msg}),{valid:t.valid,errors:e,failedRules:n}})},rn.prototype.destroy=function(){this.$vee._vm.$off("localeChanged")},rn.prototype._createFields=function(t){var e=this;t&&Object.keys(t).forEach(function(n){var i=le({},{name:n,rules:t[n]});e.attach(i)})},rn.prototype._getDateFormat=function(t){var e=null;return t.date_format&&Array.isArray(t.date_format)&&(e=t.date_format[0]),e||ke.getDriver().getDateFormat(this.locale)},rn.prototype._formatErrorMessage=function(t,e,n,i){void 0===n&&(n={}),void 0===i&&(i=null);var a=this._getFieldDisplayName(t),o=this._getLocalizedParams(e,i);return ke.getDriver().getFieldMessage(this.locale,t.name,e.name,[a,o,n])},rn.prototype._convertParamObjectToArray=function(t,e){if(Array.isArray(t))return t;var n=He.getParamNames(e);return n&&ne(t)?n.reduce(function(e,n){return n in t&&e.push(t[n]),e},[]):t},rn.prototype._getLocalizedParams=function(t,e){void 0===e&&(e=null);var n=this._convertParamObjectToArray(t.params,t.name);return t.options.hasTarget&&n&&n[0]?[e||ke.getDriver().getAttribute(this.locale,n[0],n[0])].concat(n.slice(1)):n},rn.prototype._getFieldDisplayName=function(t){return t.alias||ke.getDriver().getAttribute(this.locale,t.name,t.name)},rn.prototype._convertParamArrayToObj=function(t,e){var n=He.getParamNames(e);if(!n)return t;if(ne(t)){if(n.some(function(e){return-1!==Object.keys(t).indexOf(e)}))return t;t=[t]}return t.reduce(function(t,e,i){return t[n[i]]=e,t},{})},rn.prototype._test=function(t,e,n){var i=this,a=He.getValidatorMethod(n.name),o=Array.isArray(n.params)?re(n.params):n.params;o||(o=[]);var r=null;if(!a||"function"!=typeof a)return Promise.reject(ee("No such validator '"+n.name+"' exists."));if(n.options.hasTarget&&t.dependencies){var s=ue(t.dependencies,function(t){return t.name===n.name});s&&(r=s.field.alias,o=[s.field.value].concat(o.slice(1)))}else"required"===n.name&&t.rejectsFalse&&(o=o.length?o:[!0]);if(n.options.isDate){var l=this._getDateFormat(t.rules);"date_format"!==n.name&&o.push(l)}var d=a(e,this._convertParamArrayToObj(o,n.name));return ie(d.then)?d.then(function(e){var a=!0,o={};return Array.isArray(e)?a=e.every(function(t){return ne(t)?t.valid:t}):(a=ne(e)?e.valid:e,o=e.data),{valid:a,data:d.data,errors:a?[]:[i._createFieldError(t,n,o,r)]}}):(ne(d)||(d={valid:d,data:{}}),{valid:d.valid,data:d.data,errors:d.valid?[]:[this._createFieldError(t,n,d.data,r)]})},rn._merge=function(t,e){var n=e.validator,i=e.options,a=e.paramNames,o=ie(n)?n:n.validate;n.getMessage&&ke.getDriver().setMessage(rn.locale,t,n.getMessage),He.add(t,{validate:o,options:i,paramNames:a})},rn._guardExtend=function(t,e){if(!ie(e)&&!ie(e.validate))throw ee("Extension Error: The validator '"+t+"' must be a function or have a 'validate' method.")},rn.prototype._createFieldError=function(t,e,n,i){var a=this;return{id:t.id,vmId:t.vmId,field:t.name,msg:this._formatErrorMessage(t,e,n,i),rule:e.name,scope:t.scope,regenerate:function(){return a._formatErrorMessage(t,e,n,i)}}},rn.prototype._resolveField=function(t,e,n){if("#"===t[0])return this.fields.findById(t.slice(1));if(!Wt(e))return this.fields.find({name:t,scope:e,vmId:n});if(be(t,".")){var i=t.split("."),a=i[0],o=i.slice(1),r=this.fields.find({name:o.join("."),scope:a,vmId:n});if(r)return r}return this.fields.find({name:t,scope:null,vmId:n})},rn.prototype._handleFieldNotFound=function(t,e){var n=Wt(e)?t:(Wt(e)?"":e+".")+t;return Promise.reject(ee('Validating a non-existent field: "'+n+'". Use "attach()" first.'))},rn.prototype._handleValidationResults=function(t,e){var n=this,i=t.map(function(t){return{id:t.id}});this.errors.removeById(i.map(function(t){return t.id})),t.forEach(function(t){n.errors.remove(t.field,t.scope,e)});var a=t.reduce(function(t,e){return t.push.apply(t,e.errors),t},[]);this.errors.add(a),this.fields.filter(i).forEach(function(e){var n=ue(t,function(t){return t.id===e.id});e.setFlags({pending:!1,valid:n.valid,validated:!0})})},rn.prototype._shouldSkip=function(t,e){return!1!==t.bails&&(!(!t.isDisabled||!Se().useConstraintAttrs)||!t.isRequired&&(Wt(e)||""===e||xe(e)))},rn.prototype._shouldBail=function(t){return void 0!==t.bails?t.bails:this.fastExit},rn.prototype._validate=function(t,e,n){var i=this;void 0===n&&(n={});var a=n.initial,o=Object.keys(t.rules).filter(He.isRequireRule);if(t.forceRequired=!1,o.forEach(function(n){var a=He.getOptions(n),o=i._test(t,e,{name:n,params:t.rules[n],options:a});if(ie(o.then))throw ee("Require rules cannot be async");if(!ne(o))throw ee("Require rules has to return an object (see docs)");!0===o.data.required&&(t.forceRequired=!0)}),this._shouldSkip(t,e))return Promise.resolve({valid:!0,id:t.id,field:t.name,scope:t.scope,errors:[]});var r=[],s=[],l=!1;return ie(t.checkValueChanged)&&(t.flags.changed=t.checkValueChanged()),Object.keys(t.rules).filter(function(t){return!a||!He.has(t)||He.isImmediate(t)}).some(function(n){var a=He.getOptions(n),o=i._test(t,e,{name:n,params:t.rules[n],options:a});return ie(o.then)?r.push(o):!o.valid&&i._shouldBail(t)?(s.push.apply(s,o.errors),l=!0):r.push(new Promise(function(t){return t(o)})),l}),l?Promise.resolve({valid:!1,errors:s,id:t.id,field:t.name,scope:t.scope}):Promise.all(r).then(function(e){return e.reduce(function(t,e){var n;return e.valid||(n=t.errors).push.apply(n,e.errors),t.valid=t.valid&&e.valid,t},{valid:!0,errors:s,id:t.id,field:t.name,scope:t.scope})})},Object.defineProperties(rn.prototype,sn),Object.defineProperties(rn,ln);var dn=function(t){return ne(t)?Object.keys(t).reduce(function(e,n){return e[n]=dn(t[n]),e},{}):ie(t)?t("{0}",["{1}","{2}","{3}"]):t},cn=function(t,e){this.i18n=t,this.rootKey=e},hn={locale:{configurable:!0}};hn.locale.get=function(){return this.i18n.locale},hn.locale.set=function(t){te("Cannot set locale from the validator when using vue-i18n, use i18n.locale setter instead")},cn.prototype.getDateFormat=function(t){return this.i18n.getDateTimeFormat(t||this.locale)},cn.prototype.setDateFormat=function(t,e){this.i18n.setDateTimeFormat(t||this.locale,e)},cn.prototype.getMessage=function(t,e,n){var i=this.rootKey+".messages."+e,a=n;return Array.isArray(n)&&(a=[].concat.apply([],n)),this.i18n.te(i)?this.i18n.t(i,a):this.i18n.te(i,this.i18n.fallbackLocale)?this.i18n.t(i,this.i18n.fallbackLocale,a):this.i18n.t(this.rootKey+".messages._default",a)},cn.prototype.getAttribute=function(t,e,n){void 0===n&&(n="");var i=this.rootKey+".attributes."+e;return this.i18n.te(i)?this.i18n.t(i):n},cn.prototype.getFieldMessage=function(t,e,n,i){var a=this.rootKey+".custom."+e+"."+n;return this.i18n.te(a)?this.i18n.t(a,i):this.getMessage(t,n,i)},cn.prototype.merge=function(t){var e=this;Object.keys(t).forEach(function(n){var i,a=pe({},Zt(n+"."+e.rootKey,e.i18n.messages,{})),o=pe(a,function(t){var e={};return t.messages&&(e.messages=dn(t.messages)),t.custom&&(e.custom=dn(t.custom)),t.attributes&&(e.attributes=t.attributes),Wt(t.dateFormat)||(e.dateFormat=t.dateFormat),e}(t[n]));e.i18n.mergeLocaleMessage(n,((i={})[e.rootKey]=o,i)),o.dateFormat&&e.i18n.setDateTimeFormat(n,o.dateFormat)})},cn.prototype.setMessage=function(t,e,n){var i,a;this.merge(((a={})[t]={messages:(i={},i[e]=n,i)},a))},cn.prototype.setAttribute=function(t,e,n){var i,a;this.merge(((a={})[t]={attributes:(i={},i[e]=n,i)},a))},Object.defineProperties(cn.prototype,hn);var un,mn,fn,pn={aggressive:function(){return{on:["input"]}},eager:function(t){return t.errors.length?{on:["input"]}:{on:["change","blur"]}},passive:function(){return{on:[]}},lazy:function(){return{on:["change"]}}},_n=function(t,e){var n;this.configure(t),fn=this,e&&(un=e),this._validator=(n=new rn(null,{fastExit:t&&t.fastExit},this),tn=n,n),this._initVM(this.config),this._initI18n(this.config)},An={i18nDriver:{configurable:!0},config:{configurable:!0}},bn={i18nDriver:{configurable:!0},config:{configurable:!0}};_n.setI18nDriver=function(t,e){ke.setDriver(t,e)},_n.configure=function(t){Ne(t)},_n.setMode=function(t,e){if(Ne({mode:t}),e){if(!ie(e))throw new Error("A mode implementation must be a function");pn[t]=e}},_n.use=function(t,e){return void 0===e&&(e={}),ie(t)?fn?void t({Validator:rn,ErrorBag:Ee,Rules:rn.rules},e):(mn||(mn=[]),void mn.push({plugin:t,options:e})):te("The plugin must be a callable function")},_n.install=function(t,e){un&&t===un||(un=t,fn=new _n(e),rn.$vee=fn,function(){try{var t=Object.defineProperty({},"passive",{get:function(){Ve=!0}});window.addEventListener("testPassive",null,t),window.removeEventListener("testPassive",null,t)}catch(t){Ve=!1}}(),un.mixin(nn),un.directive("validate",on),mn&&(mn.forEach(function(t){var e=t.plugin,n=t.options;_n.use(e,n)}),mn=null))},An.i18nDriver.get=function(){return ke.getDriver()},bn.i18nDriver.get=function(){return ke.getDriver()},An.config.get=function(){return Se()},bn.config.get=function(){return Se()},_n.prototype._initVM=function(t){var e=this;this._vm=new un({data:function(){return{errors:e._validator.errors,fields:e._validator.fields}}})},_n.prototype._initI18n=function(t){var e=this,n=t.dictionary,i=t.i18n,a=t.i18nRootKey,o=t.locale,r=function(){n&&e.i18nDriver.merge(n),e._validator.errors.regenerate()};i?(_n.setI18nDriver("i18n",new cn(i,a)),i._vm.$watch("locale",r)):"undefined"!=typeof window&&this._vm.$on("localeChanged",r),n&&this.i18nDriver.merge(n),o&&!i&&this._validator.localize(o)},_n.prototype.configure=function(t){Ne(t)},Object.defineProperties(_n.prototype,An),Object.defineProperties(_n,bn),_n.mixin=nn,_n.directive=on,_n.Validator=rn,_n.ErrorBag=Ee;var xn,gn={name:"en",messages:{_default:function(t){return"The "+t+" value is not valid"},after:function(t,e){var n=e[0];return"The "+t+" must be after "+(e[1]?"or equal to ":"")+n},alpha:function(t){return"The "+t+" field may only contain alphabetic characters"},alpha_dash:function(t){return"The "+t+" field may contain alpha-numeric characters as well as dashes and underscores"},alpha_num:function(t){return"The "+t+" field may only contain alpha-numeric characters"},alpha_spaces:function(t){return"The "+t+" field may only contain alphabetic characters as well as spaces"},before:function(t,e){var n=e[0];return"The "+t+" must be before "+(e[1]?"or equal to ":"")+n},between:function(t,e){return"The "+t+" field must be between "+e[0]+" and "+e[1]},confirmed:function(t){return"The "+t+" confirmation does not match"},credit_card:function(t){return"The "+t+" field is invalid"},date_between:function(t,e){return"The "+t+" must be between "+e[0]+" and "+e[1]},date_format:function(t,e){return"The "+t+" must be in the format "+e[0]},decimal:function(t,e){void 0===e&&(e=[]);var n=e[0];return void 0===n&&(n="*"),"The "+t+" field must be numeric and may contain"+(n&&"*"!==n?" "+n:"")+" decimal points"},digits:function(t,e){return"The "+t+" field must be numeric and contains exactly "+e[0]+" digits"},dimensions:function(t,e){return"The "+t+" field must be "+e[0]+" pixels by "+e[1]+" pixels"},email:function(t){return"The "+t+" field must be a valid email"},excluded:function(t){return"The "+t+" field must be a valid value"},ext:function(t){return"The "+t+" field must be a valid file"},image:function(t){return"The "+t+" field must be an image"},included:function(t){return"The "+t+" field must be a valid value"},integer:function(t){return"The "+t+" field must be an integer"},ip:function(t){return"The "+t+" field must be a valid ip address"},ip_or_fqdn:function(t){return"The "+t+" field must be a valid ip address or FQDN"},length:function(t,e){var n=e[0],i=e[1];return i?"The "+t+" length must be between "+n+" and "+i:"The "+t+" length must be "+n},max:function(t,e){return"The "+t+" field may not be greater than "+e[0]+" characters"},max_value:function(t,e){return"The "+t+" field must be "+e[0]+" or less"},mimes:function(t){return"The "+t+" field must have a valid file type"},min:function(t,e){return"The "+t+" field must be at least "+e[0]+" characters"},min_value:function(t,e){return"The "+t+" field must be "+e[0]+" or more"},numeric:function(t){return"The "+t+" field may only contain numeric characters"},regex:function(t){return"The "+t+" field format is invalid"},required:function(t){return"The "+t+" field is required"},required_if:function(t,e){return"The "+t+" field is required when the "+e[0]+" field has this value"},size:function(t,e){return"The "+t+" size must be less than "+function(t){var e=0==(t=1024*Number(t))?0:Math.floor(Math.log(t)/Math.log(1024));return 1*(t/Math.pow(1024,e)).toFixed(2)+" "+["Byte","KB","MB","GB","TB","PB","EB","ZB","YB"][e]}(e[0])},url:function(t){return"The "+t+" field is not a valid URL"}},attributes:{}};function vn(t){if(null===t||!0===t||!1===t)return NaN;var e=Number(t);return isNaN(e)?e:e<0?Math.ceil(e):Math.floor(e)}"undefined"!=typeof VeeValidate&&VeeValidate.Validator.localize(((xn={})[gn.name]=gn,xn));var Cn=6e4;function yn(t){var e=new Date(t.getTime()),n=e.getTimezoneOffset();e.setSeconds(0,0);var i=e.getTime()%Cn;return n*Cn+i}var wn=36e5,Bn=6e4,kn=2,En={dateTimeDelimeter:/[T ]/,plainTime:/:/,timeZoneDelimeter:/[Z ]/i,YY:/^(\d{2})$/,YYY:[/^([+-]\d{2})$/,/^([+-]\d{3})$/,/^([+-]\d{4})$/],YYYY:/^(\d{4})/,YYYYY:[/^([+-]\d{4})/,/^([+-]\d{5})/,/^([+-]\d{6})/],MM:/^-(\d{2})$/,DDD:/^-?(\d{3})$/,MMDD:/^-?(\d{2})-?(\d{2})$/,Www:/^-?W(\d{2})$/,WwwD:/^-?W(\d{2})-?(\d{1})$/,HH:/^(\d{2}([.,]\d*)?)$/,HHMM:/^(\d{2}):?(\d{2}([.,]\d*)?)$/,HHMMSS:/^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,timezone:/([Z+-].*)$/,timezoneZ:/^(Z)$/,timezoneHH:/^([+-])(\d{2})$/,timezoneHHMM:/^([+-])(\d{2}):?(\d{2})$/};function In(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");if(null===t)return new Date(NaN);var n=e||{},i=null==n.additionalDigits?kn:vn(n.additionalDigits);if(2!==i&&1!==i&&0!==i)throw new RangeError("additionalDigits must be 0, 1 or 2");if(t instanceof Date||"object"==typeof t&&"[object Date]"===Object.prototype.toString.call(t))return new Date(t.getTime());if("number"==typeof t||"[object Number]"===Object.prototype.toString.call(t))return new Date(t);if("string"!=typeof t&&"[object String]"!==Object.prototype.toString.call(t))return new Date(NaN);var a=function(t){var e,n={},i=t.split(En.dateTimeDelimeter);En.plainTime.test(i[0])?(n.date=null,e=i[0]):(n.date=i[0],e=i[1],En.timeZoneDelimeter.test(n.date)&&(n.date=t.split(En.timeZoneDelimeter)[0],e=t.substr(n.date.length,t.length)));if(e){var a=En.timezone.exec(e);a?(n.time=e.replace(a[1],""),n.timezone=a[1]):n.time=e}return n}(t),o=function(t,e){var n,i=En.YYY[e],a=En.YYYYY[e];if(n=En.YYYY.exec(t)||a.exec(t)){var o=n[1];return{year:parseInt(o,10),restDateString:t.slice(o.length)}}if(n=En.YY.exec(t)||i.exec(t)){var r=n[1];return{year:100*parseInt(r,10),restDateString:t.slice(r.length)}}return{year:null}}(a.date,i),r=o.year,s=function(t,e){if(null===e)return null;var n,i,a,o;if(0===t.length)return(i=new Date(0)).setUTCFullYear(e),i;if(n=En.MM.exec(t))return i=new Date(0),a=parseInt(n[1],10)-1,On(e,a)?(i.setUTCFullYear(e,a),i):new Date(NaN);if(n=En.DDD.exec(t)){i=new Date(0);var r=parseInt(n[1],10);return function(t,e){if(e<1)return!1;var n=Mn(t);if(n&&e>366)return!1;if(!n&&e>365)return!1;return!0}(e,r)?(i.setUTCFullYear(e,0,r),i):new Date(NaN)}if(n=En.MMDD.exec(t)){i=new Date(0),a=parseInt(n[1],10)-1;var s=parseInt(n[2],10);return On(e,a,s)?(i.setUTCFullYear(e,a,s),i):new Date(NaN)}if(n=En.Www.exec(t))return o=parseInt(n[1],10)-1,Tn(e,o)?Dn(e,o):new Date(NaN);if(n=En.WwwD.exec(t)){o=parseInt(n[1],10)-1;var l=parseInt(n[2],10)-1;return Tn(e,o,l)?Dn(e,o,l):new Date(NaN)}return null}(o.restDateString,r);if(isNaN(s))return new Date(NaN);if(s){var l,d=s.getTime(),c=0;if(a.time&&(c=function(t){var e,n,i;if(e=En.HH.exec(t))return Ln(n=parseFloat(e[1].replace(",",".")))?n%24*wn:NaN;if(e=En.HHMM.exec(t))return n=parseInt(e[1],10),i=parseFloat(e[2].replace(",",".")),Ln(n,i)?n%24*wn+i*Bn:NaN;if(e=En.HHMMSS.exec(t)){n=parseInt(e[1],10),i=parseInt(e[2],10);var a=parseFloat(e[3].replace(",","."));return Ln(n,i,a)?n%24*wn+i*Bn+1e3*a:NaN}return null}(a.time),isNaN(c)))return new Date(NaN);if(a.timezone){if(l=function(t){var e,n,i;if(e=En.timezoneZ.exec(t))return 0;if(e=En.timezoneHH.exec(t))return i=parseInt(e[2],10),jn()?(n=i*wn,"+"===e[1]?-n:n):NaN;if(e=En.timezoneHHMM.exec(t)){i=parseInt(e[2],10);var a=parseInt(e[3],10);return jn(i,a)?(n=i*wn+a*Bn,"+"===e[1]?-n:n):NaN}return 0}(a.timezone),isNaN(l))return new Date(NaN)}else l=yn(new Date(d+c)),l=yn(new Date(d+c+l));return new Date(d+c+l)}return new Date(NaN)}function Dn(t,e,n){e=e||0,n=n||0;var i=new Date(0);i.setUTCFullYear(t,0,4);var a=7*e+n+1-(i.getUTCDay()||7);return i.setUTCDate(i.getUTCDate()+a),i}var Sn=[31,28,31,30,31,30,31,31,30,31,30,31],Nn=[31,29,31,30,31,30,31,31,30,31,30,31];function Mn(t){return t%400==0||t%4==0&&t%100!=0}function On(t,e,n){if(e<0||e>11)return!1;if(null!=n){if(n<1)return!1;var i=Mn(t);if(i&&n>Nn[e])return!1;if(!i&&n>Sn[e])return!1}return!0}function Tn(t,e,n){return!(e<0||e>52)&&(null==n||!(n<0||n>6))}function Ln(t,e,n){return(null==t||!(t<0||t>=25))&&((null==e||!(e<0||e>=60))&&(null==n||!(n<0||n>=60)))}function jn(t,e){return null==e||!(e<0||e>59)}function Pn(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=In(t,e);return!isNaN(n)}var Fn={lessThanXSeconds:{one:"less than a second",other:"less than {{count}} seconds"},xSeconds:{one:"1 second",other:"{{count}} seconds"},halfAMinute:"half a minute",lessThanXMinutes:{one:"less than a minute",other:"less than {{count}} minutes"},xMinutes:{one:"1 minute",other:"{{count}} minutes"},aboutXHours:{one:"about 1 hour",other:"about {{count}} hours"},xHours:{one:"1 hour",other:"{{count}} hours"},xDays:{one:"1 day",other:"{{count}} days"},aboutXMonths:{one:"about 1 month",other:"about {{count}} months"},xMonths:{one:"1 month",other:"{{count}} months"},aboutXYears:{one:"about 1 year",other:"about {{count}} years"},xYears:{one:"1 year",other:"{{count}} years"},overXYears:{one:"over 1 year",other:"over {{count}} years"},almostXYears:{one:"almost 1 year",other:"almost {{count}} years"}};function Yn(t){return function(e){var n=e||{},i=n.width?String(n.width):t.defaultWidth;return t.formats[i]||t.formats[t.defaultWidth]}}var Rn={lastWeek:"'last' eeee 'at' p",yesterday:"'yesterday at' p",today:"'today at' p",tomorrow:"'tomorrow at' p",nextWeek:"eeee 'at' p",other:"P"};function Hn(t){return function(e,n){var i=n||{},a=i.width?String(i.width):t.defaultWidth;return("formatting"===(i.context?String(i.context):"standalone")&&t.formattingValues?t.formattingValues[a]||t.formattingValues[t.defaultFormattingWidth]:t.values[a]||t.values[t.defaultWidth])[t.argumentCallback?t.argumentCallback(e):e]}}function $n(t){return function(e,n){var i=String(e),a=n||{},o=a.width,r=o&&t.matchPatterns[o]||t.matchPatterns[t.defaultMatchWidth],s=i.match(r);if(!s)return null;var l,d=s[0],c=o&&t.parsePatterns[o]||t.parsePatterns[t.defaultParseWidth];return l="[object Array]"===Object.prototype.toString.call(c)?c.findIndex(function(t){return t.test(i)}):function(t,e){for(var n in t)if(t.hasOwnProperty(n)&&e(t[n]))return n}(c,function(t){return t.test(i)}),l=t.valueCallback?t.valueCallback(l):l,{value:l=a.valueCallback?a.valueCallback(l):l,rest:i.slice(d.length)}}}var zn,Xn={formatDistance:function(t,e,n){var i;return n=n||{},i="string"==typeof Fn[t]?Fn[t]:1===e?Fn[t].one:Fn[t].other.replace("{{count}}",e),n.addSuffix?n.comparison>0?"in "+i:i+" ago":i},formatLong:{date:Yn({formats:{full:"EEEE, MMMM do, y",long:"MMMM do, y",medium:"MMM d, y",short:"MM/dd/yyyy"},defaultWidth:"full"}),time:Yn({formats:{full:"h:mm:ss a zzzz",long:"h:mm:ss a z",medium:"h:mm:ss a",short:"h:mm a"},defaultWidth:"full"}),dateTime:Yn({formats:{full:"{{date}} 'at' {{time}}",long:"{{date}} 'at' {{time}}",medium:"{{date}}, {{time}}",short:"{{date}}, {{time}}"},defaultWidth:"full"})},formatRelative:function(t,e,n,i){return Rn[t]},localize:{ordinalNumber:function(t,e){var n=Number(t),i=n%100;if(i>20||i<10)switch(i%10){case 1:return n+"st";case 2:return n+"nd";case 3:return n+"rd"}return n+"th"},era:Hn({values:{narrow:["B","A"],abbreviated:["BC","AD"],wide:["Before Christ","Anno Domini"]},defaultWidth:"wide"}),quarter:Hn({values:{narrow:["1","2","3","4"],abbreviated:["Q1","Q2","Q3","Q4"],wide:["1st quarter","2nd quarter","3rd quarter","4th quarter"]},defaultWidth:"wide",argumentCallback:function(t){return Number(t)-1}}),month:Hn({values:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],abbreviated:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],wide:["January","February","March","April","May","June","July","August","September","October","November","December"]},defaultWidth:"wide"}),day:Hn({values:{narrow:["S","M","T","W","T","F","S"],short:["Su","Mo","Tu","We","Th","Fr","Sa"],abbreviated:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],wide:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},defaultWidth:"wide"}),dayPeriod:Hn({values:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"morning",afternoon:"afternoon",evening:"evening",night:"night"}},defaultWidth:"wide",formattingValues:{narrow:{am:"a",pm:"p",midnight:"mi",noon:"n",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},abbreviated:{am:"AM",pm:"PM",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"},wide:{am:"a.m.",pm:"p.m.",midnight:"midnight",noon:"noon",morning:"in the morning",afternoon:"in the afternoon",evening:"in the evening",night:"at night"}},defaulFormattingWidth:"wide"})},match:{ordinalNumber:(zn={matchPattern:/^(\d+)(th|st|nd|rd)?/i,parsePattern:/\d+/i,valueCallback:function(t){return parseInt(t,10)}},function(t,e){var n=String(t),i=e||{},a=n.match(zn.matchPattern);if(!a)return null;var o=a[0],r=n.match(zn.parsePattern);if(!r)return null;var s=zn.valueCallback?zn.valueCallback(r[0]):r[0];return{value:s=i.valueCallback?i.valueCallback(s):s,rest:n.slice(o.length)}}),era:$n({matchPatterns:{narrow:/^(b|a)/i,abbreviated:/^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,wide:/^(before christ|before common era|anno domini|common era)/i},defaultMatchWidth:"wide",parsePatterns:{any:[/^b/i,/^(a|c)/i]},defaultParseWidth:"any"}),quarter:$n({matchPatterns:{narrow:/^[1234]/i,abbreviated:/^q[1234]/i,wide:/^[1234](th|st|nd|rd)? quarter/i},defaultMatchWidth:"wide",parsePatterns:{any:[/1/i,/2/i,/3/i,/4/i]},defaultParseWidth:"any",valueCallback:function(t){return t+1}}),month:$n({matchPatterns:{narrow:/^[jfmasond]/i,abbreviated:/^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,wide:/^(january|february|march|april|may|june|july|august|september|october|november|december)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^j/i,/^f/i,/^m/i,/^a/i,/^m/i,/^j/i,/^j/i,/^a/i,/^s/i,/^o/i,/^n/i,/^d/i],any:[/^ja/i,/^f/i,/^mar/i,/^ap/i,/^may/i,/^jun/i,/^jul/i,/^au/i,/^s/i,/^o/i,/^n/i,/^d/i]},defaultParseWidth:"any"}),day:$n({matchPatterns:{narrow:/^[smtwf]/i,short:/^(su|mo|tu|we|th|fr|sa)/i,abbreviated:/^(sun|mon|tue|wed|thu|fri|sat)/i,wide:/^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i},defaultMatchWidth:"wide",parsePatterns:{narrow:[/^s/i,/^m/i,/^t/i,/^w/i,/^t/i,/^f/i,/^s/i],any:[/^su/i,/^m/i,/^tu/i,/^w/i,/^th/i,/^f/i,/^sa/i]},defaultParseWidth:"any"}),dayPeriod:$n({matchPatterns:{narrow:/^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,any:/^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i},defaultMatchWidth:"any",parsePatterns:{any:{am:/^a/i,pm:/^p/i,midnight:/^mi/i,noon:/^no/i,morning:/morning/i,afternoon:/afternoon/i,evening:/evening/i,night:/night/i}},defaultParseWidth:"any"})},options:{weekStartsOn:0,firstWeekContainsDate:1}},Vn=864e5;function qn(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=In(t,e),i=n.getUTCDay(),a=(i<1?7:0)+i-1;return n.setUTCDate(n.getUTCDate()-a),n.setUTCHours(0,0,0,0),n}function Wn(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=In(t,e),i=n.getUTCFullYear(),a=new Date(0);a.setUTCFullYear(i+1,0,4),a.setUTCHours(0,0,0,0);var o=qn(a,e),r=new Date(0);r.setUTCFullYear(i,0,4),r.setUTCHours(0,0,0,0);var s=qn(r,e);return n.getTime()>=o.getTime()?i+1:n.getTime()>=s.getTime()?i:i-1}var Un=6048e5;function Gn(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=In(t,e),i=qn(n,e).getTime()-function(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=Wn(t,e),i=new Date(0);return i.setUTCFullYear(n,0,4),i.setUTCHours(0,0,0,0),qn(i,e)}(n,e).getTime();return Math.round(i/Un)+1}function Zn(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=e||{},i=n.locale,a=i&&i.options&&i.options.weekStartsOn,o=null==a?0:vn(a),r=null==n.weekStartsOn?o:vn(n.weekStartsOn);if(!(r>=0&&r<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var s=In(t,n),l=s.getUTCDay(),d=(l<r?7:0)+l-r;return s.setUTCDate(s.getUTCDate()-d),s.setUTCHours(0,0,0,0),s}function Jn(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=In(t,e),i=n.getUTCFullYear(),a=e||{},o=a.locale,r=o&&o.options&&o.options.firstWeekContainsDate,s=null==r?1:vn(r),l=null==a.firstWeekContainsDate?s:vn(a.firstWeekContainsDate);if(!(l>=1&&l<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var d=new Date(0);d.setUTCFullYear(i+1,0,l),d.setUTCHours(0,0,0,0);var c=Zn(d,e),h=new Date(0);h.setUTCFullYear(i,0,l),h.setUTCHours(0,0,0,0);var u=Zn(h,e);return n.getTime()>=c.getTime()?i+1:n.getTime()>=u.getTime()?i:i-1}var Qn=6048e5;function Kn(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=In(t,e),i=Zn(n,e).getTime()-function(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=e||{},i=n.locale,a=i&&i.options&&i.options.firstWeekContainsDate,o=null==a?1:vn(a),r=null==n.firstWeekContainsDate?o:vn(n.firstWeekContainsDate),s=Jn(t,e),l=new Date(0);return l.setUTCFullYear(s,0,r),l.setUTCHours(0,0,0,0),Zn(l,e)}(n,e).getTime();return Math.round(i/Qn)+1}var ti="midnight",ei="noon",ni="morning",ii="afternoon",ai="evening",oi="night",ri={G:function(t,e,n){var i=t.getUTCFullYear()>0?1:0;switch(e){case"G":case"GG":case"GGG":return n.era(i,{width:"abbreviated"});case"GGGGG":return n.era(i,{width:"narrow"});case"GGGG":default:return n.era(i,{width:"wide"})}},y:function(t,e,n,i){var a=t.getUTCFullYear(),o=a>0?a:1-a;return"yy"===e?si(o%100,2):"yo"===e?n.ordinalNumber(o,{unit:"year"}):si(o,e.length)},Y:function(t,e,n,i){var a=Jn(t,i),o=a>0?a:1-a;return"YY"===e?si(o%100,2):"Yo"===e?n.ordinalNumber(o,{unit:"year"}):si(o,e.length)},R:function(t,e,n,i){return si(Wn(t,i),e.length)},u:function(t,e,n,i){return si(t.getUTCFullYear(),e.length)},Q:function(t,e,n,i){var a=Math.ceil((t.getUTCMonth()+1)/3);switch(e){case"Q":return String(a);case"QQ":return si(a,2);case"Qo":return n.ordinalNumber(a,{unit:"quarter"});case"QQQ":return n.quarter(a,{width:"abbreviated",context:"formatting"});case"QQQQQ":return n.quarter(a,{width:"narrow",context:"formatting"});case"QQQQ":default:return n.quarter(a,{width:"wide",context:"formatting"})}},q:function(t,e,n,i){var a=Math.ceil((t.getUTCMonth()+1)/3);switch(e){case"q":return String(a);case"qq":return si(a,2);case"qo":return n.ordinalNumber(a,{unit:"quarter"});case"qqq":return n.quarter(a,{width:"abbreviated",context:"standalone"});case"qqqqq":return n.quarter(a,{width:"narrow",context:"standalone"});case"qqqq":default:return n.quarter(a,{width:"wide",context:"standalone"})}},M:function(t,e,n,i){var a=t.getUTCMonth();switch(e){case"M":return String(a+1);case"MM":return si(a+1,2);case"Mo":return n.ordinalNumber(a+1,{unit:"month"});case"MMM":return n.month(a,{width:"abbreviated",context:"formatting"});case"MMMMM":return n.month(a,{width:"narrow",context:"formatting"});case"MMMM":default:return n.month(a,{width:"wide",context:"formatting"})}},L:function(t,e,n,i){var a=t.getUTCMonth();switch(e){case"L":return String(a+1);case"LL":return si(a+1,2);case"Lo":return n.ordinalNumber(a+1,{unit:"month"});case"LLL":return n.month(a,{width:"abbreviated",context:"standalone"});case"LLLLL":return n.month(a,{width:"narrow",context:"standalone"});case"LLLL":default:return n.month(a,{width:"wide",context:"standalone"})}},w:function(t,e,n,i){var a=Kn(t,i);return"wo"===e?n.ordinalNumber(a,{unit:"week"}):si(a,e.length)},I:function(t,e,n,i){var a=Gn(t,i);return"Io"===e?n.ordinalNumber(a,{unit:"week"}):si(a,e.length)},d:function(t,e,n,i){var a=t.getUTCDate();return"do"===e?n.ordinalNumber(a,{unit:"date"}):si(a,e.length)},D:function(t,e,n,i){var a=function(t,e){if(arguments.length<1)throw new TypeError("1 argument required, but only "+arguments.length+" present");var n=In(t,e),i=n.getTime();n.setUTCMonth(0,1),n.setUTCHours(0,0,0,0);var a=i-n.getTime();return Math.floor(a/Vn)+1}(t,i);return"Do"===e?n.ordinalNumber(a,{unit:"dayOfYear"}):si(a,e.length)},E:function(t,e,n,i){var a=t.getUTCDay();switch(e){case"E":case"EE":case"EEE":return n.day(a,{width:"abbreviated",context:"formatting"});case"EEEEE":return n.day(a,{width:"narrow",context:"formatting"});case"EEEEEE":return n.day(a,{width:"short",context:"formatting"});case"EEEE":default:return n.day(a,{width:"wide",context:"formatting"})}},e:function(t,e,n,i){var a=t.getUTCDay(),o=(a-i.weekStartsOn+8)%7||7;switch(e){case"e":return String(o);case"ee":return si(o,2);case"eo":return n.ordinalNumber(o,{unit:"day"});case"eee":return n.day(a,{width:"abbreviated",context:"formatting"});case"eeeee":return n.day(a,{width:"narrow",context:"formatting"});case"eeeeee":return n.day(a,{width:"short",context:"formatting"});case"eeee":default:return n.day(a,{width:"wide",context:"formatting"})}},c:function(t,e,n,i){var a=t.getUTCDay(),o=(a-i.weekStartsOn+8)%7||7;switch(e){case"c":return String(o);case"cc":return si(o,e.length);case"co":return n.ordinalNumber(o,{unit:"day"});case"ccc":return n.day(a,{width:"abbreviated",context:"standalone"});case"ccccc":return n.day(a,{width:"narrow",context:"standalone"});case"cccccc":return n.day(a,{width:"short",context:"standalone"});case"cccc":default:return n.day(a,{width:"wide",context:"standalone"})}},i:function(t,e,n,i){var a=t.getUTCDay(),o=0===a?7:a;switch(e){case"i":return String(o);case"ii":return si(o,e.length);case"io":return n.ordinalNumber(o,{unit:"day"});case"iii":return n.day(a,{width:"abbreviated",context:"formatting"});case"iiiii":return n.day(a,{width:"narrow",context:"formatting"});case"iiiiii":return n.day(a,{width:"short",context:"formatting"});case"iiii":default:return n.day(a,{width:"wide",context:"formatting"})}},a:function(t,e,n){var i=t.getUTCHours()/12>=1?"pm":"am";switch(e){case"a":case"aa":case"aaa":return n.dayPeriod(i,{width:"abbreviated",context:"formatting"});case"aaaaa":return n.dayPeriod(i,{width:"narrow",context:"formatting"});case"aaaa":default:return n.dayPeriod(i,{width:"wide",context:"formatting"})}},b:function(t,e,n){var i,a=t.getUTCHours();switch(i=12===a?ei:0===a?ti:a/12>=1?"pm":"am",e){case"b":case"bb":case"bbb":return n.dayPeriod(i,{width:"abbreviated",context:"formatting"});case"bbbbb":return n.dayPeriod(i,{width:"narrow",context:"formatting"});case"bbbb":default:return n.dayPeriod(i,{width:"wide",context:"formatting"})}},B:function(t,e,n){var i,a=t.getUTCHours();switch(i=a>=17?ai:a>=12?ii:a>=4?ni:oi,e){case"B":case"BB":case"BBB":return n.dayPeriod(i,{width:"abbreviated",context:"formatting"});case"BBBBB":return n.dayPeriod(i,{width:"narrow",context:"formatting"});case"BBBB":default:return n.dayPeriod(i,{width:"wide",context:"formatting"})}},h:function(t,e,n,i){var a=t.getUTCHours()%12;return 0===a&&(a=12),"ho"===e?n.ordinalNumber(a,{unit:"hour"}):si(a,e.length)},H:function(t,e,n,i){var a=t.getUTCHours();return"Ho"===e?n.ordinalNumber(a,{unit:"hour"}):si(a,e.length)},K:function(t,e,n,i){var a=t.getUTCHours()%12;return"Ko"===e?n.ordinalNumber(a,{unit:"hour"}):si(a,e.length)},k:function(t,e,n,i){var a=t.getUTCHours();return 0===a&&(a=24),"ko"===e?n.ordinalNumber(a,{unit:"hour"}):si(a,e.length)},m:function(t,e,n,i){var a=t.getUTCMinutes();return"mo"===e?n.ordinalNumber(a,{unit:"minute"}):si(a,e.length)},s:function(t,e,n,i){var a=t.getUTCSeconds();return"so"===e?n.ordinalNumber(a,{unit:"second"}):si(a,e.length)},S:function(t,e,n,i){var a=e.length,o=t.getUTCMilliseconds();return si(Math.floor(o*Math.pow(10,a-3)),a)},X:function(t,e,n,i){var a=(i._originalDate||t).getTimezoneOffset();if(0===a)return"Z";switch(e){case"X":return di(a);case"XXXX":case"XX":return li(a);case"XXXXX":case"XXX":default:return li(a,":")}},x:function(t,e,n,i){var a=(i._originalDate||t).getTimezoneOffset();switch(e){case"x":return di(a);case"xxxx":case"xx":return li(a);case"xxxxx":case"xxx":default:return li(a,":")}},O:function(t,e,n,i){var a=(i._originalDate||t).getTimezoneOffset();switch(e){case"O":case"OO":case"OOO":return"GMT"+ci(a,":");case"OOOO":default:return"GMT"+li(a,":")}},z:function(t,e,n,i){var a=(i._originalDate||t).getTimezoneOffset();switch(e){case"z":case"zz":case"zzz":return"GMT"+ci(a,":");case"zzzz":default:return"GMT"+li(a,":")}},t:function(t,e,n,i){var a=i._originalDate||t;return si(Math.floor(a.getTime()/1e3),e.length)},T:function(t,e,n,i){return si((i._originalDate||t).getTime(),e.length)}};function si(t,e){for(var n=t<0?"-":"",i=Math.abs(t).toString();i.length<e;)i="0"+i;return n+i}function li(t,e){var n=e||"",i=t>0?"-":"+",a=Math.abs(t);return i+si(Math.floor(a/60),2)+n+si(a%60,2)}function di(t,e){return t%60==0?(t>0?"-":"+")+si(Math.abs(t)/60,2):li(t,e)}function ci(t,e){var n=t>0?"-":"+",i=Math.abs(t),a=Math.floor(i/60),o=i%60;if(0===o)return n+String(a);var r=e||"";return n+String(a)+r+si(o,2)}function hi(t,e,n){switch(t){case"P":return e.date({width:"short"});case"PP":return e.date({width:"medium"});case"PPP":return e.date({width:"long"});case"PPPP":default:return e.date({width:"full"})}}function ui(t,e,n){switch(t){case"p":return e.time({width:"short"});case"pp":return e.time({width:"medium"});case"ppp":return e.time({width:"long"});case"pppp":default:return e.time({width:"full"})}}var mi={p:ui,P:function(t,e,n){var i,a=t.match(/(P+)(p+)?/),o=a[1],r=a[2];if(!r)return hi(t,e);switch(o){case"P":i=e.dateTime({width:"short"});break;case"PP":i=e.dateTime({width:"medium"});break;case"PPP":i=e.dateTime({width:"long"});break;case"PPPP":default:i=e.dateTime({width:"full"})}return i.replace("{{date}}",hi(o,e)).replace("{{time}}",ui(r,e))}};function fi(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");return function(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");var i=In(t,n).getTime(),a=vn(e);return new Date(i+a)}(t,-vn(e),n)}var pi=["D","DD","YY","YYYY"];function _i(t){return-1!==pi.indexOf(t)}function Ai(t){throw new RangeError("`options.awareOfUnicodeTokens` must be set to `true` to use `"+t+"` token; see: https://git.io/fxCyr")}var bi=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,xi=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,gi=/^'(.*?)'?$/,vi=/''/g;function Ci(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");var i=String(e),a=n||{},o=a.locale||Xn,r=o.options&&o.options.firstWeekContainsDate,s=null==r?1:vn(r),l=null==a.firstWeekContainsDate?s:vn(a.firstWeekContainsDate);if(!(l>=1&&l<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var d=o.options&&o.options.weekStartsOn,c=null==d?0:vn(d),h=null==a.weekStartsOn?c:vn(a.weekStartsOn);if(!(h>=0&&h<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");if(!o.localize)throw new RangeError("locale must contain localize property");if(!o.formatLong)throw new RangeError("locale must contain formatLong property");var u=In(t,a);if(!Pn(u,a))return"Invalid Date";var m=fi(u,yn(u),a),f={firstWeekContainsDate:l,weekStartsOn:h,locale:o,_originalDate:u};return i.match(xi).map(function(t){var e=t[0];return"p"===e||"P"===e?(0,mi[e])(t,o.formatLong,f):t}).join("").match(bi).map(function(t){if("''"===t)return"'";var e=t[0];if("'"===e)return t.match(gi)[1].replace(vi,"'");var n=ri[e];return n?(!a.awareOfUnicodeTokens&&_i(t)&&Ai(t),n(m,t,o.localize,f)):t}).join("")}function yi(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");var i=In(t,n),a=In(e,n);return i.getTime()>a.getTime()}function wi(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");var i=In(t,n),a=In(e,n);return i.getTime()<a.getTime()}function Bi(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");var i=In(t,n),a=In(e,n);return i.getTime()===a.getTime()}function ki(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");var i=n||{},a=i.locale,o=a&&a.options&&a.options.weekStartsOn,r=null==o?0:vn(o),s=null==i.weekStartsOn?r:vn(i.weekStartsOn);if(!(s>=0&&s<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");var l=In(t,n),d=vn(e),c=l.getUTCDay(),h=((d%7+7)%7<s?7:0)+d-c;return l.setUTCDate(l.getUTCDate()+h),l}var Ei=36e5,Ii=6e4,Di=1e3,Si={month:/^(1[0-2]|0?\d)/,date:/^(3[0-1]|[0-2]?\d)/,dayOfYear:/^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,week:/^(5[0-3]|[0-4]?\d)/,hour23h:/^(2[0-3]|[0-1]?\d)/,hour24h:/^(2[0-4]|[0-1]?\d)/,hour11h:/^(1[0-1]|0?\d)/,hour12h:/^(1[0-2]|0?\d)/,minute:/^[0-5]?\d/,second:/^[0-5]?\d/,singleDigit:/^\d/,twoDigits:/^\d{1,2}/,threeDigits:/^\d{1,3}/,fourDigits:/^\d{1,4}/,anyDigitsSigned:/^-?\d+/,singleDigitSigned:/^-?\d/,twoDigitsSigned:/^-?\d{1,2}/,threeDigitsSigned:/^-?\d{1,3}/,fourDigitsSigned:/^-?\d{1,4}/},Ni=/^([+-])(\d{2})(\d{2})?|Z/,Mi=/^([+-])(\d{2})(\d{2})|Z/,Oi=/^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,Ti=/^([+-])(\d{2}):(\d{2})|Z/,Li=/^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;function ji(t,e,n){var i=e.match(t);if(!i)return null;var a=parseInt(i[0],10);return{value:n?n(a):a,rest:e.slice(i[0].length)}}function Pi(t,e){var n=e.match(t);if(!n)return null;if("Z"===n[0])return{value:0,rest:e.slice(1)};var i="+"===n[1]?1:-1,a=n[2]?parseInt(n[2],10):0,o=n[3]?parseInt(n[3],10):0,r=n[5]?parseInt(n[5],10):0;return{value:i*(a*Ei+o*Ii+r*Di),rest:e.slice(n[0].length)}}function Fi(t,e){return ji(Si.anyDigitsSigned,t,e)}function Yi(t,e,n){switch(t){case 1:return ji(Si.singleDigit,e,n);case 2:return ji(Si.twoDigits,e,n);case 3:return ji(Si.threeDigits,e,n);case 4:return ji(Si.fourDigits,e,n);default:return ji(new RegExp("^\\d{1,"+t+"}"),e,n)}}function Ri(t,e,n){switch(t){case 1:return ji(Si.singleDigitSigned,e,n);case 2:return ji(Si.twoDigitsSigned,e,n);case 3:return ji(Si.threeDigitsSigned,e,n);case 4:return ji(Si.fourDigitsSigned,e,n);default:return ji(new RegExp("^-?\\d{1,"+t+"}"),e,n)}}function Hi(t){switch(t){case"morning":return 4;case"evening":return 17;case"pm":case"noon":case"afternoon":return 12;case"am":case"midnight":case"night":default:return 0}}function $i(t,e){var n,i=e>0,a=i?e:1-e;if(a<=50)n=t||100;else{var o=a+50;n=t+100*Math.floor(o/100)-(t>=o%100?100:0)}return i?n:1-n}var zi=[31,28,31,30,31,30,31,31,30,31,30,31],Xi=[31,29,31,30,31,30,31,31,30,31,30,31];function Vi(t){return t%400==0||t%4==0&&t%100!=0}var qi={G:{priority:140,parse:function(t,e,n,i){switch(e){case"G":case"GG":case"GGG":return n.era(t,{width:"abbreviated"})||n.era(t,{width:"narrow"});case"GGGGG":return n.era(t,{width:"narrow"});case"GGGG":default:return n.era(t,{width:"wide"})||n.era(t,{width:"abbreviated"})||n.era(t,{width:"narrow"})}},set:function(t,e,n){return t.setUTCFullYear(1===e?10:-9,0,1),t.setUTCHours(0,0,0,0),t}},y:{priority:130,parse:function(t,e,n,i){var a=function(t){return{year:t,isTwoDigitYear:"yy"===e}};switch(e){case"y":return Yi(4,t,a);case"yo":return n.ordinalNumber(t,{unit:"year",valueCallback:a});default:return Yi(e.length,t,a)}},validate:function(t,e,n){return e.isTwoDigitYear||e.year>0},set:function(t,e,n){var i=Jn(t,n);if(e.isTwoDigitYear){var a=$i(e.year,i);return t.setUTCFullYear(a,0,1),t.setUTCHours(0,0,0,0),t}var o=i>0?e.year:1-e.year;return t.setUTCFullYear(o,0,1),t.setUTCHours(0,0,0,0),t}},Y:{priority:130,parse:function(t,e,n,i){var a=function(t){return{year:t,isTwoDigitYear:"YY"===e}};switch(e){case"Y":return Yi(4,t,a);case"Yo":return n.ordinalNumber(t,{unit:"year",valueCallback:a});default:return Yi(e.length,t,a)}},validate:function(t,e,n){return e.isTwoDigitYear||e.year>0},set:function(t,e,n){var i=t.getUTCFullYear();if(e.isTwoDigitYear){var a=$i(e.year,i);return t.setUTCFullYear(a,0,n.firstWeekContainsDate),t.setUTCHours(0,0,0,0),Zn(t,n)}var o=i>0?e.year:1-e.year;return t.setUTCFullYear(o,0,n.firstWeekContainsDate),t.setUTCHours(0,0,0,0),Zn(t,n)}},R:{priority:130,parse:function(t,e,n,i){return Ri("R"===e?4:e.length,t)},set:function(t,e,n){var i=new Date(0);return i.setUTCFullYear(e,0,4),i.setUTCHours(0,0,0,0),qn(i)}},u:{priority:130,parse:function(t,e,n,i){return Ri("u"===e?4:e.length,t)},set:function(t,e,n){return t.setUTCFullYear(e,0,1),t.setUTCHours(0,0,0,0),t}},Q:{priority:120,parse:function(t,e,n,i){switch(e){case"Q":case"QQ":return Yi(e.length,t);case"Qo":return n.ordinalNumber(t,{unit:"quarter"});case"QQQ":return n.quarter(t,{width:"abbreviated",context:"formatting"})||n.quarter(t,{width:"narrow",context:"formatting"});case"QQQQQ":return n.quarter(t,{width:"narrow",context:"formatting"});case"QQQQ":default:return n.quarter(t,{width:"wide",context:"formatting"})||n.quarter(t,{width:"abbreviated",context:"formatting"})||n.quarter(t,{width:"narrow",context:"formatting"})}},validate:function(t,e,n){return e>=1&&e<=4},set:function(t,e,n){return t.setUTCMonth(3*(e-1),1),t.setUTCHours(0,0,0,0),t}},q:{priority:120,parse:function(t,e,n,i){switch(e){case"q":case"qq":return Yi(e.length,t);case"qo":return n.ordinalNumber(t,{unit:"quarter"});case"qqq":return n.quarter(t,{width:"abbreviated",context:"standalone"})||n.quarter(t,{width:"narrow",context:"standalone"});case"qqqqq":return n.quarter(t,{width:"narrow",context:"standalone"});case"qqqq":default:return n.quarter(t,{width:"wide",context:"standalone"})||n.quarter(t,{width:"abbreviated",context:"standalone"})||n.quarter(t,{width:"narrow",context:"standalone"})}},validate:function(t,e,n){return e>=1&&e<=4},set:function(t,e,n){return t.setUTCMonth(3*(e-1),1),t.setUTCHours(0,0,0,0),t}},M:{priority:110,parse:function(t,e,n,i){var a=function(t){return t-1};switch(e){case"M":return ji(Si.month,t,a);case"MM":return Yi(2,t,a);case"Mo":return n.ordinalNumber(t,{unit:"month",valueCallback:a});case"MMM":return n.month(t,{width:"abbreviated",context:"formatting"})||n.month(t,{width:"narrow",context:"formatting"});case"MMMMM":return n.month(t,{width:"narrow",context:"formatting"});case"MMMM":default:return n.month(t,{width:"wide",context:"formatting"})||n.month(t,{width:"abbreviated",context:"formatting"})||n.month(t,{width:"narrow",context:"formatting"})}},validate:function(t,e,n){return e>=0&&e<=11},set:function(t,e,n){return t.setUTCMonth(e,1),t.setUTCHours(0,0,0,0),t}},L:{priority:110,parse:function(t,e,n,i){var a=function(t){return t-1};switch(e){case"L":return ji(Si.month,t,a);case"LL":return Yi(2,t,a);case"Lo":return n.ordinalNumber(t,{unit:"month",valueCallback:a});case"LLL":return n.month(t,{width:"abbreviated",context:"standalone"})||n.month(t,{width:"narrow",context:"standalone"});case"LLLLL":return n.month(t,{width:"narrow",context:"standalone"});case"LLLL":default:return n.month(t,{width:"wide",context:"standalone"})||n.month(t,{width:"abbreviated",context:"standalone"})||n.month(t,{width:"narrow",context:"standalone"})}},validate:function(t,e,n){return e>=0&&e<=11},set:function(t,e,n){return t.setUTCMonth(e,1),t.setUTCHours(0,0,0,0),t}},w:{priority:100,parse:function(t,e,n,i){switch(e){case"w":return ji(Si.week,t);case"wo":return n.ordinalNumber(t,{unit:"week"});default:return Yi(e.length,t)}},validate:function(t,e,n){return e>=1&&e<=53},set:function(t,e,n){return Zn(function(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");var i=In(t,n),a=vn(e),o=Kn(i,n)-a;return i.setUTCDate(i.getUTCDate()-7*o),i}(t,e,n),n)}},I:{priority:100,parse:function(t,e,n,i){switch(e){case"I":return ji(Si.week,t);case"Io":return n.ordinalNumber(t,{unit:"week"});default:return Yi(e.length,t)}},validate:function(t,e,n){return e>=1&&e<=53},set:function(t,e,n){return qn(function(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");var i=In(t,n),a=vn(e),o=Gn(i,n)-a;return i.setUTCDate(i.getUTCDate()-7*o),i}(t,e,n),n)}},d:{priority:90,parse:function(t,e,n,i){switch(e){case"d":return ji(Si.date,t);case"do":return n.ordinalNumber(t,{unit:"date"});default:return Yi(e.length,t)}},validate:function(t,e,n){var i=Vi(t.getUTCFullYear()),a=t.getUTCMonth();return i?e>=1&&e<=Xi[a]:e>=1&&e<=zi[a]},set:function(t,e,n){return t.setUTCDate(e),t.setUTCHours(0,0,0,0),t}},D:{priority:90,parse:function(t,e,n,i){switch(e){case"D":case"DD":return ji(Si.dayOfYear,t);case"Do":return n.ordinalNumber(t,{unit:"date"});default:return Yi(e.length,t)}},validate:function(t,e,n){return Vi(t.getUTCFullYear())?e>=1&&e<=366:e>=1&&e<=365},set:function(t,e,n){return t.setUTCMonth(0,e),t.setUTCHours(0,0,0,0),t}},E:{priority:90,parse:function(t,e,n,i){switch(e){case"E":case"EE":case"EEE":return n.day(t,{width:"abbreviated",context:"formatting"})||n.day(t,{width:"short",context:"formatting"})||n.day(t,{width:"narrow",context:"formatting"});case"EEEEE":return n.day(t,{width:"narrow",context:"formatting"});case"EEEEEE":return n.day(t,{width:"short",context:"formatting"})||n.day(t,{width:"narrow",context:"formatting"});case"EEEE":default:return n.day(t,{width:"wide",context:"formatting"})||n.day(t,{width:"abbreviated",context:"formatting"})||n.day(t,{width:"short",context:"formatting"})||n.day(t,{width:"narrow",context:"formatting"})}},validate:function(t,e,n){return e>=0&&e<=6},set:function(t,e,n){return(t=ki(t,e,n)).setUTCHours(0,0,0,0),t}},e:{priority:90,parse:function(t,e,n,i){var a=function(t){var e=7*Math.floor((t-1)/7);return(t+i.weekStartsOn+6)%7+e};switch(e){case"e":case"ee":return Yi(e.length,t,a);case"eo":return n.ordinalNumber(t,{unit:"day",valueCallback:a});case"eee":return n.day(t,{width:"abbreviated",context:"formatting"})||n.day(t,{width:"short",context:"formatting"})||n.day(t,{width:"narrow",context:"formatting"});case"eeeee":return n.day(t,{width:"narrow",context:"formatting"});case"eeeeee":return n.day(t,{width:"short",context:"formatting"})||n.day(t,{width:"narrow",context:"formatting"});case"eeee":default:return n.day(t,{width:"wide",context:"formatting"})||n.day(t,{width:"abbreviated",context:"formatting"})||n.day(t,{width:"short",context:"formatting"})||n.day(t,{width:"narrow",context:"formatting"})}},validate:function(t,e,n){return e>=0&&e<=6},set:function(t,e,n){return(t=ki(t,e,n)).setUTCHours(0,0,0,0),t}},c:{priority:90,parse:function(t,e,n,i){var a=function(t){var e=7*Math.floor((t-1)/7);return(t+i.weekStartsOn+6)%7+e};switch(e){case"c":case"cc":return Yi(e.length,t,a);case"co":return n.ordinalNumber(t,{unit:"day",valueCallback:a});case"ccc":return n.day(t,{width:"abbreviated",context:"standalone"})||n.day(t,{width:"short",context:"standalone"})||n.day(t,{width:"narrow",context:"standalone"});case"ccccc":return n.day(t,{width:"narrow",context:"standalone"});case"cccccc":return n.day(t,{width:"short",context:"standalone"})||n.day(t,{width:"narrow",context:"standalone"});case"cccc":default:return n.day(t,{width:"wide",context:"standalone"})||n.day(t,{width:"abbreviated",context:"standalone"})||n.day(t,{width:"short",context:"standalone"})||n.day(t,{width:"narrow",context:"standalone"})}},validate:function(t,e,n){return e>=0&&e<=6},set:function(t,e,n){return(t=ki(t,e,n)).setUTCHours(0,0,0,0),t}},i:{priority:90,parse:function(t,e,n,i){var a=function(t){return 0===t?7:t};switch(e){case"i":case"ii":return Yi(e.length,t);case"io":return n.ordinalNumber(t,{unit:"day"});case"iii":return n.day(t,{width:"abbreviated",context:"formatting",valueCallback:a})||n.day(t,{width:"short",context:"formatting",valueCallback:a})||n.day(t,{width:"narrow",context:"formatting",valueCallback:a});case"iiiii":return n.day(t,{width:"narrow",context:"formatting",valueCallback:a});case"iiiiii":return n.day(t,{width:"short",context:"formatting",valueCallback:a})||n.day(t,{width:"narrow",context:"formatting",valueCallback:a});case"iiii":default:return n.day(t,{width:"wide",context:"formatting",valueCallback:a})||n.day(t,{width:"abbreviated",context:"formatting",valueCallback:a})||n.day(t,{width:"short",context:"formatting",valueCallback:a})||n.day(t,{width:"narrow",context:"formatting",valueCallback:a})}},validate:function(t,e,n){return e>=1&&e<=7},set:function(t,e,n){return(t=function(t,e,n){if(arguments.length<2)throw new TypeError("2 arguments required, but only "+arguments.length+" present");var i=vn(e);i%7==0&&(i-=7);var a=In(t,n),o=a.getUTCDay(),r=((i%7+7)%7<1?7:0)+i-o;return a.setUTCDate(a.getUTCDate()+r),a}(t,e,n)).setUTCHours(0,0,0,0),t}},a:{priority:80,parse:function(t,e,n,i){switch(e){case"a":case"aa":case"aaa":return n.dayPeriod(t,{width:"abbreviated",context:"formatting"})||n.dayPeriod(t,{width:"narrow",context:"formatting"});case"aaaaa":return n.dayPeriod(t,{width:"narrow",context:"formatting"});case"aaaa":default:return n.dayPeriod(t,{width:"wide",context:"formatting"})||n.dayPeriod(t,{width:"abbreviated",context:"formatting"})||n.dayPeriod(t,{width:"narrow",context:"formatting"})}},set:function(t,e,n){return t.setUTCHours(Hi(e),0,0,0),t}},b:{priority:80,parse:function(t,e,n,i){switch(e){case"b":case"bb":case"bbb":return n.dayPeriod(t,{width:"abbreviated",context:"formatting"})||n.dayPeriod(t,{width:"narrow",context:"formatting"});case"bbbbb":return n.dayPeriod(t,{width:"narrow",context:"formatting"});case"bbbb":default:return n.dayPeriod(t,{width:"wide",context:"formatting"})||n.dayPeriod(t,{width:"abbreviated",context:"formatting"})||n.dayPeriod(t,{width:"narrow",context:"formatting"})}},set:function(t,e,n){return t.setUTCHours(Hi(e),0,0,0),t}},B:{priority:80,parse:function(t,e,n,i){switch(e){case"B":case"BB":case"BBB":return n.dayPeriod(t,{width:"abbreviated",context:"formatting"})||n.dayPeriod(t,{width:"narrow",context:"formatting"});case"BBBBB":return n.dayPeriod(t,{width:"narrow",context:"formatting"});case"BBBB":default:return n.dayPeriod(t,{width:"wide",context:"formatting"})||n.dayPeriod(t,{width:"abbreviated",context:"formatting"})||n.dayPeriod(t,{width:"narrow",context:"formatting"})}},set:function(t,e,n){return t.setUTCHours(Hi(e),0,0,0),t}},h:{priority:70,parse:function(t,e,n,i){switch(e){case"h":return ji(Si.hour12h,t);case"ho":return n.ordinalNumber(t,{unit:"hour"});default:return Yi(e.length,t)}},validate:function(t,e,n){return e>=1&&e<=12},set:function(t,e,n){var i=t.getUTCHours()>=12;return i&&e<12?t.setUTCHours(e+12,0,0,0):i||12!==e?t.setUTCHours(e,0,0,0):t.setUTCHours(0,0,0,0),t}},H:{priority:70,parse:function(t,e,n,i){switch(e){case"H":return ji(Si.hour23h,t);case"Ho":return n.ordinalNumber(t,{unit:"hour"});default:return Yi(e.length,t)}},validate:function(t,e,n){return e>=0&&e<=23},set:function(t,e,n){return t.setUTCHours(e,0,0,0),t}},K:{priority:70,parse:function(t,e,n,i){switch(e){case"K":return ji(Si.hour11h,t);case"Ko":return n.ordinalNumber(t,{unit:"hour"});default:return Yi(e.length,t)}},validate:function(t,e,n){return e>=0&&e<=11},set:function(t,e,n){return t.getUTCHours()>=12&&e<12?t.setUTCHours(e+12,0,0,0):t.setUTCHours(e,0,0,0),t}},k:{priority:70,parse:function(t,e,n,i){switch(e){case"k":return ji(Si.hour24h,t);case"ko":return n.ordinalNumber(t,{unit:"hour"});default:return Yi(e.length,t)}},validate:function(t,e,n){return e>=1&&e<=24},set:function(t,e,n){var i=e<=24?e%24:e;return t.setUTCHours(i,0,0,0),t}},m:{priority:60,parse:function(t,e,n,i){switch(e){case"m":return ji(Si.minute,t);case"mo":return n.ordinalNumber(t,{unit:"minute"});default:return Yi(e.length,t)}},validate:function(t,e,n){return e>=0&&e<=59},set:function(t,e,n){return t.setUTCMinutes(e,0,0),t}},s:{priority:50,parse:function(t,e,n,i){switch(e){case"s":return ji(Si.second,t);case"so":return n.ordinalNumber(t,{unit:"second"});default:return Yi(e.length,t)}},validate:function(t,e,n){return e>=0&&e<=59},set:function(t,e,n){return t.setUTCSeconds(e,0),t}},S:{priority:40,parse:function(t,e,n,i){return Yi(e.length,t,function(t){return Math.floor(t*Math.pow(10,3-e.length))})},set:function(t,e,n){return t.setUTCMilliseconds(e),t}},X:{priority:20,parse:function(t,e,n,i){switch(e){case"X":return Pi(Ni,t);case"XX":return Pi(Mi,t);case"XXXX":return Pi(Oi,t);case"XXXXX":return Pi(Li,t);case"XXX":default:return Pi(Ti,t)}},set:function(t,e,n){return new Date(t.getTime()-e)}},x:{priority:20,parse:function(t,e,n,i){switch(e){case"x":return Pi(Ni,t);case"xx":return Pi(Mi,t);case"xxxx":return Pi(Oi,t);case"xxxxx":return Pi(Li,t);case"xxx":default:return Pi(Ti,t)}},set:function(t,e,n){return new Date(t.getTime()-e)}},t:{priority:10,parse:function(t,e,n,i){return Fi(t)},set:function(t,e,n){return new Date(1e3*e)}},T:{priority:10,parse:function(t,e,n,i){return Fi(t)},set:function(t,e,n){return new Date(e)}}},Wi=20,Ui=/[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,Gi=/^'(.*?)'?$/,Zi=/''/g,Ji=/\S/;function Qi(t){var e=new Date(0);return e.setFullYear(t.getUTCFullYear(),t.getUTCMonth(),t.getUTCDate()),e.setHours(t.getUTCHours(),t.getUTCMinutes(),t.getUTCSeconds(),t.getUTCMilliseconds()),e}function Ki(t,e){if("string"!=typeof t)return Pn(t)?t:null;var n=function(t,e,n,i){if(arguments.length<3)throw new TypeError("3 arguments required, but only "+arguments.length+" present");var a=String(t),o=String(e),r=i||{},s=r.locale||Xn;if(!s.match)throw new RangeError("locale must contain match property");var l=s.options&&s.options.firstWeekContainsDate,d=null==l?1:vn(l),c=null==r.firstWeekContainsDate?d:vn(r.firstWeekContainsDate);if(!(c>=1&&c<=7))throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");var h=s.options&&s.options.weekStartsOn,u=null==h?0:vn(h),m=null==r.weekStartsOn?u:vn(r.weekStartsOn);if(!(m>=0&&m<=6))throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");if(""===o)return""===a?In(n,r):new Date(NaN);var f,p={firstWeekContainsDate:c,weekStartsOn:m,locale:s},_=[{priority:Wi,set:Qi,index:0}],A=o.match(Ui);for(f=0;f<A.length;f++){var b=A[f];!r.awareOfUnicodeTokens&&_i(b)&&Ai(b);var x=b[0],g=qi[x];if(g){var v=g.parse(a,b,s.match,p);if(!v)return new Date(NaN);_.push({priority:g.priority,set:g.set,validate:g.validate,value:v.value,index:_.length}),a=v.rest}else{if("''"===b?b="'":"'"===x&&(b=b.match(Gi)[1].replace(Zi,"'")),0!==a.indexOf(b))return new Date(NaN);a=a.slice(b.length)}}if(a.length>0&&Ji.test(a))return new Date(NaN);var C=_.map(function(t){return t.priority}).sort(function(t,e){return e-t}).filter(function(t,e,n){return n.indexOf(t)===e}).map(function(t){return _.filter(function(e){return e.priority===t}).reverse()}).map(function(t){return t[0]}),y=In(n,r);if(isNaN(y))return new Date(NaN);var w=fi(y,yn(y));for(f=0;f<C.length;f++){var B=C[f];if(B.validate&&!B.validate(w,B.value,p))return new Date(NaN);w=B.set(w,B.value,p)}return w}(t,e,new Date);return Pn(n)&&Ci(n,e)===t?n:null}var ta={validate:function(t,e){void 0===e&&(e={});var n=e.targetValue,i=e.inclusion;void 0===i&&(i=!1);var a=e.format;return void 0===a&&(a=i,i=!1),t=Ki(t,a),n=Ki(n,a),!(!t||!n)&&(yi(t,n)||i&&Bi(t,n))},options:{hasTarget:!0,isDate:!0},paramNames:["targetValue","inclusion","format"]},ea={en:/^[A-Z]*$/i,cs:/^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,da:/^[A-ZÆØÅ]*$/i,de:/^[A-ZÄÖÜß]*$/i,es:/^[A-ZÁÉÍÑÓÚÜ]*$/i,fa:/^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,fr:/^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,it:/^[A-Z\xC0-\xFF]*$/i,lt:/^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,nl:/^[A-ZÉËÏÓÖÜ]*$/i,hu:/^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,pl:/^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,pt:/^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,ru:/^[А-ЯЁ]*$/i,sk:/^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,sr:/^[A-ZČĆŽŠĐ]*$/i,sv:/^[A-ZÅÄÖ]*$/i,tr:/^[A-ZÇĞİıÖŞÜ]*$/i,uk:/^[А-ЩЬЮЯЄІЇҐ]*$/i,ar:/^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,az:/^[A-ZÇƏĞİıÖŞÜ]*$/i},na={en:/^[A-Z\s]*$/i,cs:/^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,da:/^[A-ZÆØÅ\s]*$/i,de:/^[A-ZÄÖÜß\s]*$/i,es:/^[A-ZÁÉÍÑÓÚÜ\s]*$/i,fa:/^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی\s]*$/,fr:/^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,it:/^[A-Z\xC0-\xFF\s]*$/i,lt:/^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,nl:/^[A-ZÉËÏÓÖÜ\s]*$/i,hu:/^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,pl:/^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,pt:/^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,ru:/^[А-ЯЁ\s]*$/i,sk:/^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,sr:/^[A-ZČĆŽŠĐ\s]*$/i,sv:/^[A-ZÅÄÖ\s]*$/i,tr:/^[A-ZÇĞİıÖŞÜ\s]*$/i,uk:/^[А-ЩЬЮЯЄІЇҐ\s]*$/i,ar:/^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/,az:/^[A-ZÇƏĞİıÖŞÜ\s]*$/i},ia={en:/^[0-9A-Z]*$/i,cs:/^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,da:/^[0-9A-ZÆØÅ]$/i,de:/^[0-9A-ZÄÖÜß]*$/i,es:/^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,fa:/^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,fr:/^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,it:/^[0-9A-Z\xC0-\xFF]*$/i,lt:/^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,hu:/^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,nl:/^[0-9A-ZÉËÏÓÖÜ]*$/i,pl:/^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,pt:/^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,ru:/^[0-9А-ЯЁ]*$/i,sk:/^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,sr:/^[0-9A-ZČĆŽŠĐ]*$/i,sv:/^[0-9A-ZÅÄÖ]*$/i,tr:/^[0-9A-ZÇĞİıÖŞÜ]*$/i,uk:/^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,ar:/^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,az:/^[0-9A-ZÇƏĞİıÖŞÜ]*$/i},aa={en:/^[0-9A-Z_-]*$/i,cs:/^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,da:/^[0-9A-ZÆØÅ_-]*$/i,de:/^[0-9A-ZÄÖÜß_-]*$/i,es:/^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,fa:/^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی_-]*$/,fr:/^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,it:/^[0-9A-Z\xC0-\xFF_-]*$/i,lt:/^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,nl:/^[0-9A-ZÉËÏÓÖÜ_-]*$/i,hu:/^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,pl:/^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,pt:/^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,ru:/^[0-9А-ЯЁ_-]*$/i,sk:/^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,sr:/^[0-9A-ZČĆŽŠĐ_-]*$/i,sv:/^[0-9A-ZÅÄÖ_-]*$/i,tr:/^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,uk:/^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,ar:/^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/,az:/^[0-9A-ZÇƏĞİıÖŞÜ_-]*$/i},oa=function(t,e){void 0===e&&(e={});var n=e.locale;return Array.isArray(t)?t.every(function(t){return oa(t,[n])}):n?(ea[n]||ea.en).test(t):Object.keys(ea).some(function(e){return ea[e].test(t)})},ra={validate:oa,paramNames:["locale"]},sa=function(t,e){void 0===e&&(e={});var n=e.locale;return Array.isArray(t)?t.every(function(t){return sa(t,[n])}):n?(aa[n]||aa.en).test(t):Object.keys(aa).some(function(e){return aa[e].test(t)})},la={validate:sa,paramNames:["locale"]},da=function(t,e){void 0===e&&(e={});var n=e.locale;return Array.isArray(t)?t.every(function(t){return da(t,[n])}):n?(ia[n]||ia.en).test(t):Object.keys(ia).some(function(e){return ia[e].test(t)})},ca={validate:da,paramNames:["locale"]},ha=function(t,e){void 0===e&&(e={});var n=e.locale;return Array.isArray(t)?t.every(function(t){return ha(t,[n])}):n?(na[n]||na.en).test(t):Object.keys(na).some(function(e){return na[e].test(t)})},ua={validate:ha,paramNames:["locale"]},ma={validate:function(t,e){void 0===e&&(e={});var n=e.targetValue,i=e.inclusion;void 0===i&&(i=!1);var a=e.format;return void 0===a&&(a=i,i=!1),t=Ki(t,a),n=Ki(n,a),!(!t||!n)&&(wi(t,n)||i&&Bi(t,n))},options:{hasTarget:!0,isDate:!0},paramNames:["targetValue","inclusion","format"]},fa=function(t,e){void 0===e&&(e={});var n=e.min,i=e.max;return Array.isArray(t)?t.every(function(t){return fa(t,{min:n,max:i})}):Number(n)<=t&&Number(i)>=t},pa={validate:fa,paramNames:["min","max"]},_a={validate:function(t,e){var n=e.targetValue;return String(t)===String(n)},options:{hasTarget:!0},paramNames:["targetValue"]};function Aa(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}function ba(t,e){return t(e={exports:{}},e.exports),e.exports}var xa=ba(function(t,e){function n(t){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t){if(!("string"==typeof t||t instanceof String)){var e;throw e=null===t?"null":"object"===(e=n(t))&&t.constructor&&t.constructor.hasOwnProperty("name")?t.constructor.name:"a ".concat(e),new TypeError("Expected string but received ".concat(e,"."))}},t.exports=e.default,t.exports.default=e.default});Aa(xa);var ga=Aa(ba(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t){(0,i.default)(t);var e=t.replace(/[- ]+/g,"");if(!a.test(e))return!1;for(var n,o,r,s=0,l=e.length-1;l>=0;l--)n=e.substring(l,l+1),o=parseInt(n,10),s+=r&&(o*=2)>=10?o%10+1:o,r=!r;return!(s%10!=0||!e)};var n,i=(n=xa)&&n.__esModule?n:{default:n};var a=/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;t.exports=e.default,t.exports.default=e.default})),va={validate:function(t){return ga(String(t))}},Ca={validate:function(t,e){void 0===e&&(e={});var n=e.min,i=e.max,a=e.inclusivity;void 0===a&&(a="()");var o=e.format;void 0===o&&(o=a,a="()");var r=Ki(String(n),o),s=Ki(String(i),o),l=Ki(String(t),o);return!!(r&&s&&l)&&("()"===a?yi(l,r)&&wi(l,s):"(]"===a?yi(l,r)&&(Bi(l,s)||wi(l,s)):"[)"===a?wi(l,s)&&(Bi(l,r)||yi(l,r)):Bi(l,s)||Bi(l,r)||wi(l,s)&&yi(l,r))},options:{isDate:!0},paramNames:["min","max","inclusivity","format"]},ya={validate:function(t,e){return!!Ki(t,e.format)},options:{isDate:!0},paramNames:["format"]},wa=function(t,e){void 0===e&&(e={});var n=e.decimals;void 0===n&&(n="*");var i=e.separator;if(void 0===i&&(i="."),Wt(t)||""===t)return!1;if(Array.isArray(t))return t.every(function(t){return wa(t,{decimals:n,separator:i})});if(0===Number(n))return/^-?\d*$/.test(t);if(!new RegExp("^[-+]?\\d*(\\"+i+"\\d"+("*"===n?"+":"{1,"+n+"}")+")?([eE]{1}[-]?\\d+)?$").test(t))return!1;var a=parseFloat(t);return a==a},Ba={validate:wa,paramNames:["decimals","separator"]},ka=function(t,e){var n=e[0];if(Array.isArray(t))return t.every(function(t){return ka(t,[n])});var i=String(t);return/^[0-9]*$/.test(i)&&i.length===Number(n)},Ea={validate:ka},Ia=/\.(jpg|svg|jpeg|png|bmp|gif)$/i,Da={validate:function(t,e){var n=e[0],i=e[1],a=se(t).filter(function(t){return Ia.test(t.name)});return 0!==a.length&&Promise.all(a.map(function(t){return function(t,e,n){var i=window.URL||window.webkitURL;return new Promise(function(a){var o=new Image;o.onerror=function(){return a({valid:!1})},o.onload=function(){return a({valid:o.width===Number(e)&&o.height===Number(n)})},o.src=i.createObjectURL(t)})}(t,n,i)}))}},Sa=ba(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=arguments.length>1?arguments[1]:void 0;for(var n in e)void 0===t[n]&&(t[n]=e[n]);return t},t.exports=e.default,t.exports.default=e.default});Aa(Sa);var Na=ba(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e){var n,o;(0,i.default)(t),"object"===a(e)?(n=e.min||0,o=e.max):(n=arguments[1],o=arguments[2]);var r=encodeURI(t).split(/%..|./).length-1;return r>=n&&(void 0===o||r<=o)};var n,i=(n=xa)&&n.__esModule?n:{default:n};function a(t){return(a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}t.exports=e.default,t.exports.default=e.default});Aa(Na);var Ma=ba(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e){(0,n.default)(t),(e=(0,i.default)(e,o)).allow_trailing_dot&&"."===t[t.length-1]&&(t=t.substring(0,t.length-1));for(var a=t.split("."),r=0;r<a.length;r++)if(a[r].length>63)return!1;if(e.require_tld){var s=a.pop();if(!a.length||!/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(s))return!1;if(/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(s))return!1}for(var l,d=0;d<a.length;d++){if(l=a[d],e.allow_underscores&&(l=l.replace(/_/g,"")),!/^[a-z\u00a1-\uffff0-9-]+$/i.test(l))return!1;if(/[\uff01-\uff5e]/.test(l))return!1;if("-"===l[0]||"-"===l[l.length-1])return!1}return!0};var n=a(xa),i=a(Sa);function a(t){return t&&t.__esModule?t:{default:t}}var o={require_tld:!0,allow_underscores:!1,allow_trailing_dot:!1};t.exports=e.default,t.exports.default=e.default}),Oa=Aa(Ma),Ta=ba(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function t(e){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";(0,i.default)(e);n=String(n);if(!n)return t(e,4)||t(e,6);if("4"===n){if(!a.test(e))return!1;var r=e.split(".").sort(function(t,e){return t-e});return r[3]<=255}if("6"===n){var s=e.split(":"),l=!1,d=t(s[s.length-1],4),c=d?7:8;if(s.length>c)return!1;if("::"===e)return!0;"::"===e.substr(0,2)?(s.shift(),s.shift(),l=!0):"::"===e.substr(e.length-2)&&(s.pop(),s.pop(),l=!0);for(var h=0;h<s.length;++h)if(""===s[h]&&h>0&&h<s.length-1){if(l)return!1;l=!0}else if(d&&h===s.length-1);else if(!o.test(s[h]))return!1;return l?s.length>=1:s.length===c}return!1};var n,i=(n=xa)&&n.__esModule?n:{default:n};var a=/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/,o=/^[0-9A-F]{1,4}$/i;t.exports=e.default,t.exports.default=e.default}),La=Aa(Ta),ja=Aa(ba(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e){if((0,n.default)(t),(e=(0,i.default)(e,l)).require_display_name||e.allow_display_name){var s=t.match(d);if(s)t=s[1];else if(e.require_display_name)return!1}var p=t.split("@"),_=p.pop(),A=p.join("@"),b=_.toLowerCase();if(e.domain_specific_validation&&("gmail.com"===b||"googlemail.com"===b)){var x=(A=A.toLowerCase()).split("+")[0];if(!(0,a.default)(x.replace(".",""),{min:6,max:30}))return!1;for(var g=x.split("."),v=0;v<g.length;v++)if(!h.test(g[v]))return!1}if(!(0,a.default)(A,{max:64})||!(0,a.default)(_,{max:254}))return!1;if(!(0,o.default)(_,{require_tld:e.require_tld})){if(!e.allow_ip_domain)return!1;if(!(0,r.default)(_)){if(!_.startsWith("[")||!_.endsWith("]"))return!1;var C=_.substr(1,_.length-2);if(0===C.length||!(0,r.default)(C))return!1}}if('"'===A[0])return A=A.slice(1,A.length-1),e.allow_utf8_local_part?f.test(A):u.test(A);for(var y=e.allow_utf8_local_part?m:c,w=A.split("."),B=0;B<w.length;B++)if(!y.test(w[B]))return!1;return!0};var n=s(xa),i=s(Sa),a=s(Na),o=s(Ma),r=s(Ta);function s(t){return t&&t.__esModule?t:{default:t}}var l={allow_display_name:!1,require_display_name:!1,allow_utf8_local_part:!0,require_tld:!0},d=/^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i,c=/^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i,h=/^[a-z\d]+$/,u=/^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i,m=/^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i,f=/^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;t.exports=e.default,t.exports.default=e.default}));var Pa={validate:function(t,e){void 0===e&&(e={});var n=e.multiple;void 0===n&&(n=!1);var i=function(t,e){var n={};for(var i in t)Object.prototype.hasOwnProperty.call(t,i)&&-1===e.indexOf(i)&&(n[i]=t[i]);return n}(e,["multiple"]);n&&!Array.isArray(t)&&(t=String(t).split(",").map(function(t){return t.trim()}));var a=le({},i);return Array.isArray(t)?t.every(function(t){return ja(String(t),a)}):ja(String(t),a)}},Fa=function(t,e){return Array.isArray(t)?t.every(function(t){return Fa(t,e)}):re(e).some(function(e){return e==t})},Ya={validate:Fa},Ra={validate:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];return!Fa.apply(void 0,t)}},Ha={validate:function(t,e){var n=new RegExp(".("+e.join("|")+")$","i");return se(t).every(function(t){return n.test(t.name)})}},$a={validate:function(t){return(Array.isArray(t)?t:[t]).every(function(t){return/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(t.name)})}},za={validate:function(t){return Array.isArray(t)?t.every(function(t){return/^-?[0-9]+$/.test(String(t))}):/^-?[0-9]+$/.test(String(t))}},Xa={validate:function(t,e){void 0===e&&(e={});var n=e.version;return void 0===n&&(n=4),Wt(t)&&(t=""),Array.isArray(t)?t.every(function(t){return La(t,n)}):La(t,n)},paramNames:["version"]},Va={validate:function(t){return Wt(t)&&(t=""),Array.isArray(t)?t.every(function(t){return La(t,"")||Oa(t)}):La(t,"")||Oa(t)}},qa={validate:function(t,e){return void 0===e&&(e=[]),t===e[0]}},Wa={validate:function(t,e){return void 0===e&&(e=[]),t!==e[0]}},Ua={validate:function(t,e){var n=e[0],i=e[1];return void 0===i&&(i=void 0),!Wt(t)&&(n=Number(n),"number"==typeof t&&(t=String(t)),t.length||(t=re(t)),function(t,e,n){return void 0===n?t.length===e:(n=Number(n),t.length>=e&&t.length<=n)}(t,n,i))}},Ga=function(t,e){var n=e[0];return Wt(t)?n>=0:Array.isArray(t)?t.every(function(t){return Ga(t,[n])}):String(t).length<=n},Za={validate:Ga},Ja=function(t,e){var n=e[0];return!Wt(t)&&""!==t&&(Array.isArray(t)?t.length>0&&t.every(function(t){return Ja(t,[n])}):Number(t)<=n)},Qa={validate:Ja},Ka={validate:function(t,e){var n=new RegExp(e.join("|").replace("*",".+")+"$","i");return se(t).every(function(t){return n.test(t.type)})}},to=function(t,e){var n=e[0];return!Wt(t)&&(Array.isArray(t)?t.every(function(t){return to(t,[n])}):String(t).length>=n)},eo={validate:to},no=function(t,e){var n=e[0];return!Wt(t)&&""!==t&&(Array.isArray(t)?t.length>0&&t.every(function(t){return no(t,[n])}):Number(t)>=n)},io={validate:no},ao=/^[٠١٢٣٤٥٦٧٨٩]+$/,oo=/^[0-9]+$/,ro={validate:function(t){var e=function(t){var e=String(t);return oo.test(e)||ao.test(e)};return Array.isArray(t)?t.every(e):e(t)}},so=function(t,e){var n=e.expression;return"string"==typeof n&&(n=new RegExp(n)),Array.isArray(t)?t.every(function(t){return so(t,{expression:n})}):n.test(String(t))},lo={validate:so,paramNames:["expression"]},co={validate:function(t,e){void 0===e&&(e=[]);var n=e[0];return void 0===n&&(n=!1),!(Wt(t)||xe(t)||!1===t&&n||!String(t).trim().length)}},ho={validate:function(t,e){void 0===e&&(e=[]);var n=e[0],i=e.slice(1).includes(String(n).trim());if(!i)return{valid:!0,data:{required:i}};var a=xe(t)||[!1,null,void 0].includes(t);return{valid:!(a=a||!String(t).trim().length),data:{required:i}}},options:{hasTarget:!0,computesRequired:!0}},uo={validate:function(t,e){var n=e[0];if(isNaN(n))return!1;var i=1024*Number(n);return se(t).every(function(t){return t.size<=i})}},mo=Aa(ba(function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e){if((0,n.default)(t),!t||t.length>=2083||/[\s<>]/.test(t))return!1;if(0===t.indexOf("mailto:"))return!1;var r,c,h,u,m,f,p,_;if(e=(0,o.default)(e,s),p=t.split("#"),t=p.shift(),p=t.split("?"),t=p.shift(),(p=t.split("://")).length>1){if(r=p.shift().toLowerCase(),e.require_valid_protocol&&-1===e.protocols.indexOf(r))return!1}else{if(e.require_protocol)return!1;if("//"===t.substr(0,2)){if(!e.allow_protocol_relative_urls)return!1;p[0]=t.substr(2)}}if(""===(t=p.join("://")))return!1;if(p=t.split("/"),""===(t=p.shift())&&!e.require_host)return!0;if((p=t.split("@")).length>1){if(e.disallow_auth)return!1;if((c=p.shift()).indexOf(":")>=0&&c.split(":").length>2)return!1}u=p.join("@"),f=null,_=null;var A=u.match(l);A?(h="",_=A[1],f=A[2]||null):(p=u.split(":"),h=p.shift(),p.length&&(f=p.join(":")));if(null!==f&&(m=parseInt(f,10),!/^[0-9]+$/.test(f)||m<=0||m>65535))return!1;if(!((0,a.default)(h)||(0,i.default)(h,e)||_&&(0,a.default)(_,6)))return!1;if(h=h||_,e.host_whitelist&&!d(h,e.host_whitelist))return!1;if(e.host_blacklist&&d(h,e.host_blacklist))return!1;return!0};var n=r(xa),i=r(Ma),a=r(Ta),o=r(Sa);function r(t){return t&&t.__esModule?t:{default:t}}var s={protocols:["http","https","ftp"],require_tld:!0,require_protocol:!1,require_host:!0,require_valid_protocol:!0,allow_underscores:!1,allow_trailing_dot:!1,allow_protocol_relative_urls:!1},l=/^\[([^\]]+)\](?::([0-9]+))?$/;function d(t,e){for(var n=0;n<e.length;n++){var i=e[n];if(t===i||(a=i,"[object RegExp]"===Object.prototype.toString.call(a)&&i.test(t)))return!0}var a;return!1}t.exports=e.default,t.exports.default=e.default})),fo={validate:function(t,e){void 0===e&&(e={}),Wt(t)&&(t="");var n=le({},e);return Array.isArray(t)?t.every(function(t){return mo(t,n)}):mo(t,n)}},po=Object.freeze({after:ta,alpha_dash:la,alpha_num:ca,alpha_spaces:ua,alpha:ra,before:ma,between:pa,confirmed:_a,credit_card:va,date_between:Ca,date_format:ya,decimal:Ba,digits:Ea,dimensions:Da,email:Pa,ext:Ha,image:$a,included:Ya,integer:za,length:Ua,ip:Xa,ip_or_fqdn:Va,is_not:Wa,is:qa,max:Za,max_value:Qa,mimes:Ka,min:eo,min_value:io,excluded:Ra,numeric:ro,regex:lo,required:co,required_if:ho,size:uo,url:fo}),_o=function(t,e){var n={pristine:function(t,e){return t&&e},dirty:function(t,e){return t||e},touched:function(t,e){return t||e},untouched:function(t,e){return t&&e},valid:function(t,e){return t&&e},invalid:function(t,e){return t||e},pending:function(t,e){return t||e},required:function(t,e){return t||e},validated:function(t,e){return t&&e}};return Object.keys(n).reduce(function(i,a){return i[a]=n[a](t[a],e[a]),i},{})},Ao=function(t,e){return void 0===e&&(e=!0),Object.keys(t).reduce(function(n,i){if(!n)return n=le({},t[i]);var a=0===i.indexOf("$");return e&&a?_o(Ao(t[i]),n):!e&&a?n:n=_o(n,t[i])},null)},bo=null,xo=0,go={$__veeInject:!1,inject:{$_veeObserver:{from:"$_veeObserver",default:function(){return this.$vnode.context.$_veeObserver||(this.$vnode.context.$_veeObserver={refs:{},subscribe:function(t){this.refs[t.vid]=t},unsubscribe:function(t){delete this.refs[t.vid]}}),this.$vnode.context.$_veeObserver}}},props:{vid:{type:[String,Number],default:function(){return"_vee_"+ ++xo}},name:{type:String,default:null},mode:{type:[String,Function],default:function(){return Se().mode}},events:{type:Array,validate:function(){return!0},default:function(){var t=Se().events;return"string"==typeof t?t.split("|"):t}},rules:{type:[Object,String],default:null},immediate:{type:Boolean,default:!1},persist:{type:Boolean,default:!1},bails:{type:Boolean,default:function(){return Se().fastExit}},debounce:{type:Number,default:function(){return Se().delay||0}},tag:{type:String,default:"span"},slim:{type:Boolean,default:!1}},watch:{rules:{deep:!0,handler:function(t,e){this._needsValidation=!Ut(t,e)}}},data:function(){return{messages:[],value:void 0,initialized:!1,initialValue:void 0,flags:{untouched:!0,touched:!1,dirty:!1,pristine:!0,valid:null,invalid:null,validated:!1,pending:!1,required:!1,changed:!1},failedRules:{},forceRequired:!1,isDeactivated:!1,id:null}},computed:{isValid:function(){return this.flags.valid},fieldDeps:function(){var t=this,e=Kt(this.rules);return Object.keys(e).filter(He.isTargetRule).map(function(n){var i=e[n][0];return function t(e,n,i){void 0===i&&(i=!0);var a=e.$_veeObserver.refs;e._veeWatchers||(e._veeWatchers={});if(!a[n]&&i)return e.$once("hook:mounted",function(){t(e,n,!1)});!ie(e._veeWatchers[n])&&a[n]&&(e._veeWatchers[n]=a[n].$watch("value",function(){e.flags.validated&&(e._needsValidation=!0,e.validate())}))}(t,i),i})},normalizedEvents:function(){var t=this,e=Co(this).on;return Xe(e||this.events||[]).map(function(e){return"input"===e?t._inputEventName:e})},isRequired:function(){var t=Kt(this.rules),e=this.forceRequired,n=t.required||e;return this.flags.required=n,n},classes:function(){var t=this,e=Se().classNames;return Object.keys(this.flags).reduce(function(n,i){var a=e&&e[i]||i;return Wt(t.flags[i])?n:(a&&(n[a]=t.flags[i]),n)},{})}},render:function(t){var e=this;this.registerField();var n=vo(this),i=this.$scopedSlots.default;if(!ie(i))return t(this.tag,this.$slots.default);var a=i(n);return Oe(a).forEach(function(t){(function(t){var e=Me(t);this._inputEventName=this._inputEventName||Pe(t,e),yo.call(this,e);var n=wo(this),i=n.onInput,a=n.onBlur,o=n.onValidate;je(t,this._inputEventName,i),je(t,"blur",a),this.normalizedEvents.forEach(function(e){je(t,e,o)}),this.initialized=!0}).call(e,t)}),this.slim?Fe(t,a):t(this.tag,a)},beforeDestroy:function(){this.$_veeObserver.unsubscribe(this)},activated:function(){this.$_veeObserver.subscribe(this),this.isDeactivated=!1},deactivated:function(){this.$_veeObserver.unsubscribe(this),this.isDeactivated=!0},methods:{setFlags:function(t){var e=this;Object.keys(t).forEach(function(n){e.flags[n]=t[n]})},syncValue:function(t){var e=function(t){if(ze(t))return"file"===t.target.type?re(t.target.files):t.target.value;return t}(t);this.value=e,this.flags.changed=this.initialValue!==e},reset:function(){this.messages=[],this._pendingValidation=null,this.initialValue=this.value;var t={untouched:!0,touched:!1,dirty:!1,pristine:!0,valid:null,invalid:null,validated:!1,pending:!1,required:!1,changed:!1};this.setFlags(t)},validate:function(){for(var t=this,e=[],n=arguments.length;n--;)e[n]=arguments[n];return e.length>0&&this.syncValue(e[0]),this.validateSilent().then(function(e){return t.applyResult(e),e})},validateSilent:function(){var t,e,n=this;return this.setFlags({pending:!0}),bo.verify(this.value,this.rules,{name:this.name,values:(t=this,e=t.$_veeObserver.refs,t.fieldDeps.reduce(function(t,n){return e[n]?(t[n]=e[n].value,t):t},{})),bails:this.bails}).then(function(t){return n.setFlags({pending:!1}),n.isRequired||n.setFlags({valid:t.valid,invalid:!t.valid}),t})},applyResult:function(t){var e=t.errors,n=t.failedRules;this.messages=e,this.failedRules=le({},n),this.setFlags({valid:!e.length,changed:this.value!==this.initialValue,invalid:!!e.length,validated:!0})},registerField:function(){bo||(bo=en()||new rn(null,{fastExit:Se().fastExit})),function(t){Wt(t.id)&&t.id===t.vid&&(t.id=xo,xo++);var e=t.id,n=t.vid;if(t.isDeactivated||e===n&&t.$_veeObserver.refs[e])return;e!==n&&t.$_veeObserver.refs[e]===t&&t.$_veeObserver.unsubscribe({vid:e});t.$_veeObserver.subscribe(t),t.id=n}(this)}}};function vo(t){return{errors:t.messages,flags:t.flags,classes:t.classes,valid:t.isValid,failedRules:t.failedRules,reset:function(){return t.reset()},validate:function(){for(var e=[],n=arguments.length;n--;)e[n]=arguments[n];return t.validate.apply(t,e)},aria:{"aria-invalid":t.flags.invalid?"true":"false","aria-required":t.isRequired?"true":"false"}}}function Co(t){return(ie(t.mode)?t.mode:pn[t.mode])({errors:t.messages,value:t.value,flags:t.flags})}function yo(t){this.initialized||(this.initialValue=t.value);var e=function(t,e){return!(t._ignoreImmediate||!t.immediate)||t.value!==e.value||!!t._needsValidation||!t.initialized&&void 0===e.value}(this,t);this._needsValidation=!1,this.value=t.value,this._ignoreImmediate=!0,e&&this.validateSilent().then(this.immediate||this.flags.validated?this.applyResult:function(t){return t})}function wo(t){var e=t.$veeHandler,n=Co(t);return e&&t.$veeDebounce===t.debounce||(e=Jt(function(){t.$nextTick(function(){var e=t.validateSilent();t._pendingValidation=e,e.then(function(n){e===t._pendingValidation&&(t.applyResult(n),t._pendingValidation=null)})})},n.debounce||t.debounce),t.$veeHandler=e,t.$veeDebounce=t.debounce),{onInput:function(e){t.syncValue(e),t.setFlags({dirty:!0,pristine:!1})},onBlur:function(){t.setFlags({touched:!0,untouched:!1})},onValidate:e}}var Bo={pristine:"every",dirty:"some",touched:"some",untouched:"every",valid:"every",invalid:"some",pending:"some",validated:"every"};var ko=0,Eo={name:"ValidationObserver",provide:function(){return{$_veeObserver:this}},inject:{$_veeObserver:{from:"$_veeObserver",default:function(){return this.$vnode.context.$_veeObserver?this.$vnode.context.$_veeObserver:null}}},props:{tag:{type:String,default:"span"},slim:{type:Boolean,default:!1}},data:function(){return{vid:"obs_"+ko++,refs:{},observers:[],persistedStore:{}}},computed:{ctx:function(){var t=this,e={errors:{},validate:function(e){var n=t.validate(e);return{then:function(t){return n.then(function(e){return e&&ie(t)?Promise.resolve(t()):Promise.resolve(e)})}}},reset:function(){return t.reset()}};return Ae(this.refs).concat(Object.keys(this.persistedStore).map(function(e){return{vid:e,flags:t.persistedStore[e].flags,messages:t.persistedStore[e].errors}}),this.observers).reduce(function(t,e){return Object.keys(Bo).forEach(function(n){var i,a,o=e.flags||e.ctx;n in t?t[n]=(i=t[n],a=o[n],[i,a][Bo[n]](function(t){return t})):t[n]=o[n]}),t.errors[e.vid]=e.messages||Ae(e.ctx.errors).reduce(function(t,e){return t.concat(e)},[]),t},e)}},created:function(){this.$_veeObserver&&this.$_veeObserver.subscribe(this,"observer")},activated:function(){this.$_veeObserver&&this.$_veeObserver.subscribe(this,"observer")},deactivated:function(){this.$_veeObserver&&this.$_veeObserver.unsubscribe(this,"observer")},beforeDestroy:function(){this.$_veeObserver&&this.$_veeObserver.unsubscribe(this,"observer")},render:function(t){var e=this.$slots.default||this.$scopedSlots.default||[];return ie(e)&&(e=e(this.ctx)),this.slim?Fe(t,e):t(this.tag,{on:this.$listeners,attrs:this.$attrs},e)},methods:{subscribe:function(t,e){var n;void 0===e&&(e="provider"),"observer"!==e?(this.refs=Object.assign({},this.refs,((n={})[t.vid]=t,n)),t.persist&&this.persistedStore[t.vid]&&this.restoreProviderState(t)):this.observers.push(t)},unsubscribe:function(t,e){var n=t.vid;void 0===e&&(e="provider"),"provider"===e&&this.removeProvider(n);var i=he(this.observers,function(t){return t.vid===n});-1!==i&&this.observers.splice(i,1)},validate:function(t){void 0===t&&(t={silent:!1});var e=t.silent;return Promise.all(Ae(this.refs).map(function(t){return t[e?"validateSilent":"validate"]().then(function(t){return t.valid})}).concat(this.observers.map(function(t){return t.validate({silent:e})}))).then(function(t){return t.every(function(t){return t})})},reset:function(){var t=this;return Object.keys(this.persistedStore).forEach(function(e){t.$delete(t.persistedStore,e)}),Ae(this.refs).concat(this.observers).forEach(function(t){return t.reset()})},restoreProviderState:function(t){var e=this.persistedStore[t.vid];t.setFlags(e.flags),t.applyResult(e),this.$delete(this.persistedStore,t.vid)},removeProvider:function(t){var e,n=this.refs[t];n&&n.persist&&(this.persistedStore=le({},this.persistedStore,((e={})[t]={flags:n.flags,errors:n.messages,failedRules:n.failedRules},e))),this.$delete(this.refs,t)}}};Object.keys(po).forEach(function(t){rn.extend(t,po[t].validate,le({},po[t].options,{paramNames:po[t].paramNames}))}),rn.localize({en:gn});_n.version="2.2.15",_n.mapFields=function(t){if(!t)return function(){return Ao(this.$validator.flags)};var e=function(t){return Array.isArray(t)?t.reduce(function(t,e){return be(e,".")?t[e.split(".")[1]]=e:t[e]=e,t},{}):t}(t);return Object.keys(e).reduce(function(t,n){var i=e[n];return t[n]=function(){if(this.$validator.flags[i])return this.$validator.flags[i];if("*"===e[n])return Ao(this.$validator.flags,!1);if(i.indexOf(".")<=0)return{};var t=i.split("."),a=t[0],o=t.slice(1);return a=this.$validator.flags["$"+a],"*"===(o=o.join("."))&&a?Ao(a):a&&a[o]?a[o]:{}},t},{})},_n.ValidationProvider=go,_n.ValidationObserver=Eo,_n.withValidation=function(t,e){void 0===e&&(e=null);var n=ie(t)?t.options:t;n.$__veeInject=!1;var i={name:(n.name||"AnonymousHoc")+"WithValidation",props:le({},go.props),data:go.data,computed:le({},go.computed),methods:le({},go.methods),$__veeInject:!1,beforeDestroy:go.beforeDestroy,inject:go.inject};e||(e=function(t){return t});var a=n.model&&n.model.event||"input";return i.render=function(t){var i;this.registerField();var o=vo(this),r=le({},this.$listeners),s=Me(this.$vnode);this._inputEventName=this._inputEventName||Pe(this.$vnode,s),yo.call(this,s);var l=wo(this),d=l.onInput,c=l.onBlur,h=l.onValidate;Le(r,a,d),Le(r,"blur",c),this.normalizedEvents.forEach(function(t,e){Le(r,t,h)});var u,m,f=(Te(this.$vnode)||{prop:"value"}).prop,p=le({},this.$attrs,((i={})[f]=s.value,i),e(o));return t(n,{attrs:this.$attrs,props:p,on:r},(u=this.$slots,m=this.$vnode.context,Object.keys(u).reduce(function(t,e){return u[e].forEach(function(t){t.context||(u[e].context=m,t.data||(t.data={}),t.data.slot=e)}),t.concat(u[e])},[])))},i};var Io=_n;$t.a.use(Io,{classes:!0,classNames:{invalid:"is-invalid"}});var Do={name:"pf-phones",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfPhone:Ht,PfButton:d},created:function(){var t=this;this.type="itemPhone",void 0===this.list&&-1!==this.contactId?this.apiService.getPhones({token:this.token,contactId:this.contactId}).then(function(e){0!==t.listRemote.length&&void 0!==t.listRemote||(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)),null!==e.listPhones&&(t.listRemote=e.listPhones[0].phones)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"phones"})}}},So={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-phone",{key:i,attrs:{id:"itemPhone"+i,information:e,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-phone":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemPhoneAdd"+t.questionnaireid:"itemPhoneAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var No=n("VU/8")(Do,So,!1,function(t){n("f5S2"),n("IKUT")},"data-v-0ed0b590",null).exports;function Mo(t){return(Mo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Oo(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}function To(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function Lo(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{},i=Object.keys(n);"function"==typeof Object.getOwnPropertySymbols&&(i=i.concat(Object.getOwnPropertySymbols(n).filter(function(t){return Object.getOwnPropertyDescriptor(n,t).enumerable}))),i.forEach(function(e){To(t,e,n[e])})}return t}var jo=new(function(){function t(e,n,i,a){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.language=e,this.months=n,this.monthsAbbr=i,this.days=a,this.rtl=!1,this.ymd=!1,this.yearSuffix=""}var e,n,i;return e=t,(n=[{key:"language",get:function(){return this._language},set:function(t){if("string"!=typeof t)throw new TypeError("Language must be a string");this._language=t}},{key:"months",get:function(){return this._months},set:function(t){if(12!==t.length)throw new RangeError("There must be 12 months for ".concat(this.language," language"));this._months=t}},{key:"monthsAbbr",get:function(){return this._monthsAbbr},set:function(t){if(12!==t.length)throw new RangeError("There must be 12 abbreviated months for ".concat(this.language," language"));this._monthsAbbr=t}},{key:"days",get:function(){return this._days},set:function(t){if(7!==t.length)throw new RangeError("There must be 7 days for ".concat(this.language," language"));this._days=t}}])&&Oo(e.prototype,n),i&&Oo(e,i),t}())("English",["January","February","March","April","May","June","July","August","September","October","November","December"],["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]),Po={useUtc:!1,getFullYear:function(t){return this.useUtc?t.getUTCFullYear():t.getFullYear()},getMonth:function(t){return this.useUtc?t.getUTCMonth():t.getMonth()},getDate:function(t){return this.useUtc?t.getUTCDate():t.getDate()},getDay:function(t){return this.useUtc?t.getUTCDay():t.getDay()},getHours:function(t){return this.useUtc?t.getUTCHours():t.getHours()},getMinutes:function(t){return this.useUtc?t.getUTCMinutes():t.getMinutes()},setFullYear:function(t,e,n){return this.useUtc?t.setUTCFullYear(e):t.setFullYear(e)},setMonth:function(t,e,n){return this.useUtc?t.setUTCMonth(e):t.setMonth(e)},setDate:function(t,e,n){return this.useUtc?t.setUTCDate(e):t.setDate(e)},compareDates:function(t,e){var n=new Date(t.getTime()),i=new Date(e.getTime());return this.useUtc?(n.setUTCHours(0,0,0,0),i.setUTCHours(0,0,0,0)):(n.setHours(0,0,0,0),i.setHours(0,0,0,0)),n.getTime()===i.getTime()},isValidDate:function(t){return"[object Date]"===Object.prototype.toString.call(t)&&!isNaN(t.getTime())},getDayNameAbbr:function(t,e){if("object"!==Mo(t))throw TypeError("Invalid Type");return e[this.getDay(t)]},getMonthName:function(t,e){if(!e)throw Error("missing 2nd parameter Months array");if("object"===Mo(t))return e[this.getMonth(t)];if("number"==typeof t)return e[t];throw TypeError("Invalid type")},getMonthNameAbbr:function(t,e){if(!e)throw Error("missing 2nd paramter Months array");if("object"===Mo(t))return e[this.getMonth(t)];if("number"==typeof t)return e[t];throw TypeError("Invalid type")},daysInMonth:function(t,e){return/8|3|5|10/.test(e)?30:1===e?(t%4||!(t%100))&&t%400?28:29:31},getNthSuffix:function(t){switch(t){case 1:case 21:case 31:return"st";case 2:case 22:return"nd";case 3:case 23:return"rd";default:return"th"}},formatDate:function(t,e,n){n=n||jo;var i=this.getFullYear(t),a=this.getMonth(t)+1,o=this.getDate(t);return e.replace(/dd/,("0"+o).slice(-2)).replace(/d/,o).replace(/yyyy/,i).replace(/yy/,String(i).slice(2)).replace(/MMMM/,this.getMonthName(this.getMonth(t),n.months)).replace(/MMM/,this.getMonthNameAbbr(this.getMonth(t),n.monthsAbbr)).replace(/MM/,("0"+a).slice(-2)).replace(/M(?!a|ä|e)/,a).replace(/su/,this.getNthSuffix(this.getDate(t))).replace(/D(?!e|é|i)/,this.getDayNameAbbr(t,n.days))},createDateArray:function(t,e){for(var n=[];t<=e;)n.push(new Date(t)),t=this.setDate(new Date(t),this.getDate(new Date(t))+1);return n},validateDateInput:function(t){return null===t||t instanceof Date||"string"==typeof t||"number"==typeof t}},Fo=function(t){return Lo({},Po,{useUtc:t})},Yo=Lo({},Po);var Ro=function(t,e,n,i,a,o,r,s,l,d){"boolean"!=typeof r&&(l=s,s=r,r=!1);var c,h="function"==typeof n?n.options:n;if(t&&t.render&&(h.render=t.render,h.staticRenderFns=t.staticRenderFns,h._compiled=!0,a&&(h.functional=!0)),i&&(h._scopeId=i),o?(c=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),e&&e.call(this,l(t)),t&&t._registeredComponents&&t._registeredComponents.add(o)},h._ssrRegister=c):e&&(c=r?function(){e.call(this,d(this.$root.$options.shadowRoot))}:function(t){e.call(this,s(t))}),c)if(h.functional){var u=h.render;h.render=function(t,e){return c.call(e),u(t,e)}}else{var m=h.beforeCreate;h.beforeCreate=m?[].concat(m,c):[c]}return n};const Ho={props:{selectedDate:Date,resetTypedDate:[Date],format:[String,Function],translation:Object,inline:Boolean,id:String,name:String,refName:String,openDate:Date,placeholder:String,inputClass:[String,Object,Array],clearButton:Boolean,clearButtonIcon:String,calendarButton:Boolean,calendarButtonIcon:String,calendarButtonIconContent:String,disabled:Boolean,required:Boolean,typeable:Boolean,bootstrapStyling:Boolean,useUtc:Boolean},data:function(){return{input:null,typedDate:!1,utils:Fo(this.useUtc)}},computed:{formattedValue:function(){return this.selectedDate?this.typedDate?this.typedDate:"function"==typeof this.format?this.format(this.selectedDate):this.utils.formatDate(new Date(this.selectedDate),this.format,this.translation):null},computedInputClass:function(){return this.bootstrapStyling?"string"==typeof this.inputClass?[this.inputClass,"form-control"].join(" "):Lo({"form-control":!0},this.inputClass):this.inputClass}},watch:{resetTypedDate:function(){this.typedDate=!1}},methods:{showCalendar:function(){this.$emit("showCalendar")},parseTypedDate:function(t){if([27,13].includes(t.keyCode)&&this.input.blur(),this.typeable){var e=Date.parse(this.input.value);isNaN(e)||(this.typedDate=this.input.value,this.$emit("typedDate",new Date(this.typedDate)))}},inputBlurred:function(){this.typeable&&isNaN(Date.parse(this.input.value))&&(this.clearDate(),this.input.value=null,this.typedDate=null),this.$emit("closeCalendar")},clearDate:function(){this.$emit("clearDate")}},mounted:function(){this.input=this.$el.querySelector("input")}};var $o=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{class:{"input-group":t.bootstrapStyling}},[t.calendarButton?n("span",{staticClass:"vdp-datepicker__calendar-button",class:{"input-group-prepend":t.bootstrapStyling},style:{"cursor:not-allowed;":t.disabled},on:{click:t.showCalendar}},[n("span",{class:{"input-group-text":t.bootstrapStyling}},[n("i",{class:t.calendarButtonIcon},[t._v("\n        "+t._s(t.calendarButtonIconContent)+"\n        "),t.calendarButtonIcon?t._e():n("span",[t._v("…")])])])]):t._e(),t._v(" "),n("input",{ref:t.refName,class:t.computedInputClass,attrs:{type:t.inline?"hidden":"text",name:t.name,id:t.id,"open-date":t.openDate,placeholder:t.placeholder,"clear-button":t.clearButton,disabled:t.disabled,required:t.required,readonly:!t.typeable,autocomplete:"off"},domProps:{value:t.formattedValue},on:{click:t.showCalendar,keyup:t.parseTypedDate,blur:t.inputBlurred}}),t._v(" "),t.clearButton&&t.selectedDate?n("span",{staticClass:"vdp-datepicker__clear-button",class:{"input-group-append":t.bootstrapStyling},on:{click:function(e){return t.clearDate()}}},[n("span",{class:{"input-group-text":t.bootstrapStyling}},[n("i",{class:t.clearButtonIcon},[t.clearButtonIcon?t._e():n("span",[t._v("×")])])])]):t._e(),t._v(" "),t._t("afterDateInput")],2)};$o._withStripped=!0;var zo=Ro({render:$o,staticRenderFns:[]},void 0,Ho,void 0,!1,void 0,void 0,void 0);const Xo={props:{showDayView:Boolean,selectedDate:Date,pageDate:Date,pageTimestamp:Number,fullMonthName:Boolean,allowedToShowView:Function,dayCellContent:{type:Function,default:function(t){return t.date}},disabledDates:Object,highlighted:Object,calendarClass:[String,Object,Array],calendarStyle:Object,translation:Object,isRtl:Boolean,mondayFirst:Boolean,useUtc:Boolean},data:function(){return{utils:Fo(this.useUtc)}},computed:{daysOfWeek:function(){if(this.mondayFirst){var t=this.translation.days.slice();return t.push(t.shift()),t}return this.translation.days},blankDays:function(){var t=this.pageDate,e=this.useUtc?new Date(Date.UTC(t.getUTCFullYear(),t.getUTCMonth(),1)):new Date(t.getFullYear(),t.getMonth(),1,t.getHours(),t.getMinutes());return this.mondayFirst?this.utils.getDay(e)>0?this.utils.getDay(e)-1:6:this.utils.getDay(e)},days:function(){for(var t=this.pageDate,e=[],n=this.useUtc?new Date(Date.UTC(t.getUTCFullYear(),t.getUTCMonth(),1)):new Date(t.getFullYear(),t.getMonth(),1,t.getHours(),t.getMinutes()),i=this.utils.daysInMonth(this.utils.getFullYear(n),this.utils.getMonth(n)),a=0;a<i;a++)e.push({date:this.utils.getDate(n),timestamp:n.getTime(),isSelected:this.isSelectedDate(n),isDisabled:this.isDisabledDate(n),isHighlighted:this.isHighlightedDate(n),isHighlightStart:this.isHighlightStart(n),isHighlightEnd:this.isHighlightEnd(n),isToday:this.utils.compareDates(n,new Date),isWeekend:0===this.utils.getDay(n)||6===this.utils.getDay(n),isSaturday:6===this.utils.getDay(n),isSunday:0===this.utils.getDay(n)}),this.utils.setDate(n,this.utils.getDate(n)+1);return e},currMonthName:function(){var t=this.fullMonthName?this.translation.months:this.translation.monthsAbbr;return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate),t)},currYearName:function(){var t=this.translation.yearSuffix;return"".concat(this.utils.getFullYear(this.pageDate)).concat(t)},isYmd:function(){return this.translation.ymd&&!0===this.translation.ymd},isLeftNavDisabled:function(){return this.isRtl?this.isNextMonthDisabled(this.pageTimestamp):this.isPreviousMonthDisabled(this.pageTimestamp)},isRightNavDisabled:function(){return this.isRtl?this.isPreviousMonthDisabled(this.pageTimestamp):this.isNextMonthDisabled(this.pageTimestamp)}},methods:{selectDate:function(t){if(t.isDisabled)return this.$emit("selectedDisabled",t),!1;this.$emit("selectDate",t)},getPageMonth:function(){return this.utils.getMonth(this.pageDate)},showMonthCalendar:function(){this.$emit("showMonthCalendar")},changeMonth:function(t){var e=this.pageDate;this.utils.setMonth(e,this.utils.getMonth(e)+t),this.$emit("changedMonth",e)},previousMonth:function(){this.isPreviousMonthDisabled()||this.changeMonth(-1)},isPreviousMonthDisabled:function(){if(!this.disabledDates||!this.disabledDates.to)return!1;var t=this.pageDate;return this.utils.getMonth(this.disabledDates.to)>=this.utils.getMonth(t)&&this.utils.getFullYear(this.disabledDates.to)>=this.utils.getFullYear(t)},nextMonth:function(){this.isNextMonthDisabled()||this.changeMonth(1)},isNextMonthDisabled:function(){if(!this.disabledDates||!this.disabledDates.from)return!1;var t=this.pageDate;return this.utils.getMonth(this.disabledDates.from)<=this.utils.getMonth(t)&&this.utils.getFullYear(this.disabledDates.from)<=this.utils.getFullYear(t)},isSelectedDate:function(t){return this.selectedDate&&this.utils.compareDates(this.selectedDate,t)},isDisabledDate:function(t){var e=this,n=!1;return void 0!==this.disabledDates&&(void 0!==this.disabledDates.dates&&this.disabledDates.dates.forEach(function(i){if(e.utils.compareDates(t,i))return n=!0,!0}),void 0!==this.disabledDates.to&&this.disabledDates.to&&t<this.disabledDates.to&&(n=!0),void 0!==this.disabledDates.from&&this.disabledDates.from&&t>this.disabledDates.from&&(n=!0),void 0!==this.disabledDates.ranges&&this.disabledDates.ranges.forEach(function(e){if(void 0!==e.from&&e.from&&void 0!==e.to&&e.to&&t<e.to&&t>e.from)return n=!0,!0}),void 0!==this.disabledDates.days&&-1!==this.disabledDates.days.indexOf(this.utils.getDay(t))&&(n=!0),void 0!==this.disabledDates.daysOfMonth&&-1!==this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(t))&&(n=!0),"function"==typeof this.disabledDates.customPredictor&&this.disabledDates.customPredictor(t)&&(n=!0),n)},isHighlightedDate:function(t){var e=this;if((!this.highlighted||!this.highlighted.includeDisabled)&&this.isDisabledDate(t))return!1;var n=!1;return void 0!==this.highlighted&&(void 0!==this.highlighted.dates&&this.highlighted.dates.forEach(function(i){if(e.utils.compareDates(t,i))return n=!0,!0}),this.isDefined(this.highlighted.from)&&this.isDefined(this.highlighted.to)&&(n=t>=this.highlighted.from&&t<=this.highlighted.to),void 0!==this.highlighted.days&&-1!==this.highlighted.days.indexOf(this.utils.getDay(t))&&(n=!0),void 0!==this.highlighted.daysOfMonth&&-1!==this.highlighted.daysOfMonth.indexOf(this.utils.getDate(t))&&(n=!0),"function"==typeof this.highlighted.customPredictor&&this.highlighted.customPredictor(t)&&(n=!0),n)},dayClasses:function(t){return{selected:t.isSelected,disabled:t.isDisabled,highlighted:t.isHighlighted,today:t.isToday,weekend:t.isWeekend,sat:t.isSaturday,sun:t.isSunday,"highlight-start":t.isHighlightStart,"highlight-end":t.isHighlightEnd}},isHighlightStart:function(t){return this.isHighlightedDate(t)&&this.highlighted.from instanceof Date&&this.utils.getFullYear(this.highlighted.from)===this.utils.getFullYear(t)&&this.utils.getMonth(this.highlighted.from)===this.utils.getMonth(t)&&this.utils.getDate(this.highlighted.from)===this.utils.getDate(t)},isHighlightEnd:function(t){return this.isHighlightedDate(t)&&this.highlighted.to instanceof Date&&this.utils.getFullYear(this.highlighted.to)===this.utils.getFullYear(t)&&this.utils.getMonth(this.highlighted.to)===this.utils.getMonth(t)&&this.utils.getDate(this.highlighted.to)===this.utils.getDate(t)},isDefined:function(t){return void 0!==t&&t}}};var Vo=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{directives:[{name:"show",rawName:"v-show",value:t.showDayView,expression:"showDayView"}],class:[t.calendarClass,"vdp-datepicker__calendar"],style:t.calendarStyle,on:{mousedown:function(t){t.preventDefault()}}},[t._t("beforeCalendarHeader"),t._v(" "),n("header",[n("span",{staticClass:"prev",class:{disabled:t.isLeftNavDisabled},on:{click:function(e){t.isRtl?t.nextMonth():t.previousMonth()}}},[t._v("<")]),t._v(" "),n("span",{staticClass:"day__month_btn",class:t.allowedToShowView("month")?"up":"",on:{click:t.showMonthCalendar}},[t._v(t._s(t.isYmd?t.currYearName:t.currMonthName)+" "+t._s(t.isYmd?t.currMonthName:t.currYearName))]),t._v(" "),n("span",{staticClass:"next",class:{disabled:t.isRightNavDisabled},on:{click:function(e){t.isRtl?t.previousMonth():t.nextMonth()}}},[t._v(">")])]),t._v(" "),n("div",{class:t.isRtl?"flex-rtl":""},[t._l(t.daysOfWeek,function(e){return n("span",{key:e.timestamp,staticClass:"cell day-header"},[t._v(t._s(e))])}),t._v(" "),t.blankDays>0?t._l(t.blankDays,function(t){return n("span",{key:t.timestamp,staticClass:"cell day blank"})}):t._e(),t._l(t.days,function(e){return n("span",{key:e.timestamp,staticClass:"cell day",class:t.dayClasses(e),domProps:{innerHTML:t._s(t.dayCellContent(e))},on:{click:function(n){return t.selectDate(e)}}})})],2)],2)};Vo._withStripped=!0;var qo=Ro({render:Vo,staticRenderFns:[]},void 0,Xo,void 0,!1,void 0,void 0,void 0);const Wo={props:{showMonthView:Boolean,selectedDate:Date,pageDate:Date,pageTimestamp:Number,disabledDates:Object,calendarClass:[String,Object,Array],calendarStyle:Object,translation:Object,isRtl:Boolean,allowedToShowView:Function,useUtc:Boolean},data:function(){return{utils:Fo(this.useUtc)}},computed:{months:function(){for(var t=this.pageDate,e=[],n=this.useUtc?new Date(Date.UTC(t.getUTCFullYear(),0,t.getUTCDate())):new Date(t.getFullYear(),0,t.getDate(),t.getHours(),t.getMinutes()),i=0;i<12;i++)e.push({month:this.utils.getMonthName(i,this.translation.months),timestamp:n.getTime(),isSelected:this.isSelectedMonth(n),isDisabled:this.isDisabledMonth(n)}),this.utils.setMonth(n,this.utils.getMonth(n)+1);return e},pageYearName:function(){var t=this.translation.yearSuffix;return"".concat(this.utils.getFullYear(this.pageDate)).concat(t)},isLeftNavDisabled:function(){return this.isRtl?this.isNextYearDisabled(this.pageTimestamp):this.isPreviousYearDisabled(this.pageTimestamp)},isRightNavDisabled:function(){return this.isRtl?this.isPreviousYearDisabled(this.pageTimestamp):this.isNextYearDisabled(this.pageTimestamp)}},methods:{selectMonth:function(t){if(t.isDisabled)return!1;this.$emit("selectMonth",t)},changeYear:function(t){var e=this.pageDate;this.utils.setFullYear(e,this.utils.getFullYear(e)+t),this.$emit("changedYear",e)},previousYear:function(){this.isPreviousYearDisabled()||this.changeYear(-1)},isPreviousYearDisabled:function(){return!(!this.disabledDates||!this.disabledDates.to)&&this.utils.getFullYear(this.disabledDates.to)>=this.utils.getFullYear(this.pageDate)},nextYear:function(){this.isNextYearDisabled()||this.changeYear(1)},isNextYearDisabled:function(){return!(!this.disabledDates||!this.disabledDates.from)&&this.utils.getFullYear(this.disabledDates.from)<=this.utils.getFullYear(this.pageDate)},showYearCalendar:function(){this.$emit("showYearCalendar")},isSelectedMonth:function(t){return this.selectedDate&&this.utils.getFullYear(this.selectedDate)===this.utils.getFullYear(t)&&this.utils.getMonth(this.selectedDate)===this.utils.getMonth(t)},isDisabledMonth:function(t){var e=!1;return void 0!==this.disabledDates&&(void 0!==this.disabledDates.to&&this.disabledDates.to&&(this.utils.getMonth(t)<this.utils.getMonth(this.disabledDates.to)&&this.utils.getFullYear(t)<=this.utils.getFullYear(this.disabledDates.to)||this.utils.getFullYear(t)<this.utils.getFullYear(this.disabledDates.to))&&(e=!0),void 0!==this.disabledDates.from&&this.disabledDates.from&&(this.utils.getMonth(t)>this.utils.getMonth(this.disabledDates.from)&&this.utils.getFullYear(t)>=this.utils.getFullYear(this.disabledDates.from)||this.utils.getFullYear(t)>this.utils.getFullYear(this.disabledDates.from))&&(e=!0),"function"==typeof this.disabledDates.customPredictor&&this.disabledDates.customPredictor(t)&&(e=!0),e)}}};var Uo=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{directives:[{name:"show",rawName:"v-show",value:t.showMonthView,expression:"showMonthView"}],class:[t.calendarClass,"vdp-datepicker__calendar"],style:t.calendarStyle,on:{mousedown:function(t){t.preventDefault()}}},[t._t("beforeCalendarHeader"),t._v(" "),n("header",[n("span",{staticClass:"prev",class:{disabled:t.isLeftNavDisabled},on:{click:function(e){t.isRtl?t.nextYear():t.previousYear()}}},[t._v("<")]),t._v(" "),n("span",{staticClass:"month__year_btn",class:t.allowedToShowView("year")?"up":"",on:{click:t.showYearCalendar}},[t._v(t._s(t.pageYearName))]),t._v(" "),n("span",{staticClass:"next",class:{disabled:t.isRightNavDisabled},on:{click:function(e){t.isRtl?t.previousYear():t.nextYear()}}},[t._v(">")])]),t._v(" "),t._l(t.months,function(e){return n("span",{key:e.timestamp,staticClass:"cell month",class:{selected:e.isSelected,disabled:e.isDisabled},on:{click:function(n){return n.stopPropagation(),t.selectMonth(e)}}},[t._v(t._s(e.month))])})],2)};Uo._withStripped=!0;var Go=Ro({render:Uo,staticRenderFns:[]},void 0,Wo,void 0,!1,void 0,void 0,void 0);const Zo={props:{showYearView:Boolean,selectedDate:Date,pageDate:Date,pageTimestamp:Number,disabledDates:Object,highlighted:Object,calendarClass:[String,Object,Array],calendarStyle:Object,translation:Object,isRtl:Boolean,allowedToShowView:Function,useUtc:Boolean},computed:{years:function(){for(var t=this.pageDate,e=[],n=this.useUtc?new Date(Date.UTC(10*Math.floor(t.getUTCFullYear()/10),t.getUTCMonth(),t.getUTCDate())):new Date(10*Math.floor(t.getFullYear()/10),t.getMonth(),t.getDate(),t.getHours(),t.getMinutes()),i=0;i<10;i++)e.push({year:this.utils.getFullYear(n),timestamp:n.getTime(),isSelected:this.isSelectedYear(n),isDisabled:this.isDisabledYear(n)}),this.utils.setFullYear(n,this.utils.getFullYear(n)+1);return e},getPageDecade:function(){var t=10*Math.floor(this.utils.getFullYear(this.pageDate)/10),e=t+9,n=this.translation.yearSuffix;return"".concat(t," - ").concat(e).concat(n)},isLeftNavDisabled:function(){return this.isRtl?this.isNextDecadeDisabled(this.pageTimestamp):this.isPreviousDecadeDisabled(this.pageTimestamp)},isRightNavDisabled:function(){return this.isRtl?this.isPreviousDecadeDisabled(this.pageTimestamp):this.isNextDecadeDisabled(this.pageTimestamp)}},data:function(){return{utils:Fo(this.useUtc)}},methods:{selectYear:function(t){if(t.isDisabled)return!1;this.$emit("selectYear",t)},changeYear:function(t){var e=this.pageDate;this.utils.setFullYear(e,this.utils.getFullYear(e)+t),this.$emit("changedDecade",e)},previousDecade:function(){if(this.isPreviousDecadeDisabled())return!1;this.changeYear(-10)},isPreviousDecadeDisabled:function(){return!(!this.disabledDates||!this.disabledDates.to)&&this.utils.getFullYear(this.disabledDates.to)>10*Math.floor(this.utils.getFullYear(this.pageDate)/10)-1},nextDecade:function(){if(this.isNextDecadeDisabled())return!1;this.changeYear(10)},isNextDecadeDisabled:function(){return!(!this.disabledDates||!this.disabledDates.from)&&this.utils.getFullYear(this.disabledDates.from)<10*Math.ceil(this.utils.getFullYear(this.pageDate)/10)},isSelectedYear:function(t){return this.selectedDate&&this.utils.getFullYear(this.selectedDate)===this.utils.getFullYear(t)},isDisabledYear:function(t){var e=!1;return!(void 0===this.disabledDates||!this.disabledDates)&&(void 0!==this.disabledDates.to&&this.disabledDates.to&&this.utils.getFullYear(t)<this.utils.getFullYear(this.disabledDates.to)&&(e=!0),void 0!==this.disabledDates.from&&this.disabledDates.from&&this.utils.getFullYear(t)>this.utils.getFullYear(this.disabledDates.from)&&(e=!0),"function"==typeof this.disabledDates.customPredictor&&this.disabledDates.customPredictor(t)&&(e=!0),e)}}};var Jo=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{directives:[{name:"show",rawName:"v-show",value:t.showYearView,expression:"showYearView"}],class:[t.calendarClass,"vdp-datepicker__calendar"],style:t.calendarStyle,on:{mousedown:function(t){t.preventDefault()}}},[t._t("beforeCalendarHeader"),t._v(" "),n("header",[n("span",{staticClass:"prev",class:{disabled:t.isLeftNavDisabled},on:{click:function(e){t.isRtl?t.nextDecade():t.previousDecade()}}},[t._v("<")]),t._v(" "),n("span",[t._v(t._s(t.getPageDecade))]),t._v(" "),n("span",{staticClass:"next",class:{disabled:t.isRightNavDisabled},on:{click:function(e){t.isRtl?t.previousDecade():t.nextDecade()}}},[t._v(">")])]),t._v(" "),t._l(t.years,function(e){return n("span",{key:e.timestamp,staticClass:"cell year",class:{selected:e.isSelected,disabled:e.isDisabled},on:{click:function(n){return n.stopPropagation(),t.selectYear(e)}}},[t._v(t._s(e.year))])})],2)};Jo._withStripped=!0;var Qo={components:{DateInput:zo,PickerDay:qo,PickerMonth:Go,PickerYear:Ro({render:Jo,staticRenderFns:[]},void 0,Zo,void 0,!1,void 0,void 0,void 0)},props:{value:{validator:function(t){return Yo.validateDateInput(t)}},name:String,refName:String,id:String,format:{type:[String,Function],default:"dd MMM yyyy"},language:{type:Object,default:function(){return jo}},openDate:{validator:function(t){return Yo.validateDateInput(t)}},dayCellContent:Function,fullMonthName:Boolean,disabledDates:Object,highlighted:Object,placeholder:String,inline:Boolean,calendarClass:[String,Object,Array],inputClass:[String,Object,Array],wrapperClass:[String,Object,Array],mondayFirst:Boolean,clearButton:Boolean,clearButtonIcon:String,calendarButton:Boolean,calendarButtonIcon:String,calendarButtonIconContent:String,bootstrapStyling:Boolean,initialView:String,disabled:Boolean,required:Boolean,typeable:Boolean,useUtc:Boolean,minimumView:{type:String,default:"day"},maximumView:{type:String,default:"year"}},data:function(){var t=this.openDate?new Date(this.openDate):new Date,e=Fo(this.useUtc);return{pageTimestamp:e.setDate(t,1),selectedDate:null,showDayView:!1,showMonthView:!1,showYearView:!1,calendarHeight:0,resetTypedDate:new Date,utils:e}},watch:{value:function(t){this.setValue(t)},openDate:function(){this.setPageDate()},initialView:function(){this.setInitialView()}},computed:{computedInitialView:function(){return this.initialView?this.initialView:this.minimumView},pageDate:function(){return new Date(this.pageTimestamp)},translation:function(){return this.language},calendarStyle:function(){return{position:this.isInline?"static":void 0}},isOpen:function(){return this.showDayView||this.showMonthView||this.showYearView},isInline:function(){return!!this.inline},isRtl:function(){return!0===this.translation.rtl}},methods:{resetDefaultPageDate:function(){null!==this.selectedDate?this.setPageDate(this.selectedDate):this.setPageDate()},showCalendar:function(){return!this.disabled&&!this.isInline&&(this.isOpen?this.close(!0):void this.setInitialView())},setInitialView:function(){var t=this.computedInitialView;if(!this.allowedToShowView(t))throw new Error("initialView '".concat(this.initialView,"' cannot be rendered based on minimum '").concat(this.minimumView,"' and maximum '").concat(this.maximumView,"'"));switch(t){case"year":this.showYearCalendar();break;case"month":this.showMonthCalendar();break;default:this.showDayCalendar()}},allowedToShowView:function(t){var e=["day","month","year"],n=e.indexOf(this.minimumView),i=e.indexOf(this.maximumView),a=e.indexOf(t);return a>=n&&a<=i},showDayCalendar:function(){return!!this.allowedToShowView("day")&&(this.close(),this.showDayView=!0,!0)},showMonthCalendar:function(){return!!this.allowedToShowView("month")&&(this.close(),this.showMonthView=!0,!0)},showYearCalendar:function(){return!!this.allowedToShowView("year")&&(this.close(),this.showYearView=!0,!0)},setDate:function(t){var e=new Date(t);this.selectedDate=e,this.setPageDate(e),this.$emit("selected",e),this.$emit("input",e)},clearDate:function(){this.selectedDate=null,this.setPageDate(),this.$emit("selected",null),this.$emit("input",null),this.$emit("cleared")},selectDate:function(t){this.setDate(t.timestamp),this.isInline||this.close(!0),this.resetTypedDate=new Date},selectDisabledDate:function(t){this.$emit("selectedDisabled",t)},selectMonth:function(t){var e=new Date(t.timestamp);this.allowedToShowView("day")?(this.setPageDate(e),this.$emit("changedMonth",t),this.showDayCalendar()):this.selectDate(t)},selectYear:function(t){var e=new Date(t.timestamp);this.allowedToShowView("month")?(this.setPageDate(e),this.$emit("changedYear",t),this.showMonthCalendar()):this.selectDate(t)},setValue:function(t){if("string"==typeof t||"number"==typeof t){var e=new Date(t);t=isNaN(e.valueOf())?null:e}if(!t)return this.setPageDate(),void(this.selectedDate=null);this.selectedDate=t,this.setPageDate(t)},setPageDate:function(t){t||(t=this.openDate?new Date(this.openDate):new Date),this.pageTimestamp=this.utils.setDate(new Date(t),1)},handleChangedMonthFromDayPicker:function(t){this.setPageDate(t),this.$emit("changedMonth",t)},setTypedDate:function(t){this.setDate(t.getTime())},close:function(t){this.showDayView=this.showMonthView=this.showYearView=!1,this.isInline||(t&&this.$emit("closed"),document.removeEventListener("click",this.clickOutside,!1))},init:function(){this.value&&this.setValue(this.value),this.isInline&&this.setInitialView()}},mounted:function(){this.init()}},Ko="undefined"!=typeof navigator&&/msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());var tr=document.head||document.getElementsByTagName("head")[0],er={};var nr=function(t){return function(t,e){return function(t,e){var n=Ko?e.media||"default":t,i=er[n]||(er[n]={ids:new Set,styles:[]});if(!i.ids.has(t)){i.ids.add(t);var a=e.source;if(e.map&&(a+="\n/*# sourceURL="+e.map.sources[0]+" */",a+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e.map))))+" */"),i.element||(i.element=document.createElement("style"),i.element.type="text/css",e.media&&i.element.setAttribute("media",e.media),tr.appendChild(i.element)),"styleSheet"in i.element)i.styles.push(a),i.element.styleSheet.cssText=i.styles.filter(Boolean).join("\n");else{var o=i.ids.size-1,r=document.createTextNode(a),s=i.element.childNodes;s[o]&&i.element.removeChild(s[o]),s.length?i.element.insertBefore(r,s[o]):i.element.appendChild(r)}}}(t,e)}};const ir=Qo;var ar=function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"vdp-datepicker",class:[t.wrapperClass,t.isRtl?"rtl":""]},[n("date-input",{attrs:{selectedDate:t.selectedDate,resetTypedDate:t.resetTypedDate,format:t.format,translation:t.translation,inline:t.inline,id:t.id,name:t.name,refName:t.refName,openDate:t.openDate,placeholder:t.placeholder,inputClass:t.inputClass,typeable:t.typeable,clearButton:t.clearButton,clearButtonIcon:t.clearButtonIcon,calendarButton:t.calendarButton,calendarButtonIcon:t.calendarButtonIcon,calendarButtonIconContent:t.calendarButtonIconContent,disabled:t.disabled,required:t.required,bootstrapStyling:t.bootstrapStyling,"use-utc":t.useUtc},on:{showCalendar:t.showCalendar,closeCalendar:t.close,typedDate:t.setTypedDate,clearDate:t.clearDate}},[t._t("afterDateInput",null,{slot:"afterDateInput"})],2),t._v(" "),t.allowedToShowView("day")?n("picker-day",{attrs:{pageDate:t.pageDate,selectedDate:t.selectedDate,showDayView:t.showDayView,fullMonthName:t.fullMonthName,allowedToShowView:t.allowedToShowView,disabledDates:t.disabledDates,highlighted:t.highlighted,calendarClass:t.calendarClass,calendarStyle:t.calendarStyle,translation:t.translation,pageTimestamp:t.pageTimestamp,isRtl:t.isRtl,mondayFirst:t.mondayFirst,dayCellContent:t.dayCellContent,"use-utc":t.useUtc},on:{changedMonth:t.handleChangedMonthFromDayPicker,selectDate:t.selectDate,showMonthCalendar:t.showMonthCalendar,selectedDisabled:t.selectDisabledDate}},[t._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):t._e(),t._v(" "),t.allowedToShowView("month")?n("picker-month",{attrs:{pageDate:t.pageDate,selectedDate:t.selectedDate,showMonthView:t.showMonthView,allowedToShowView:t.allowedToShowView,disabledDates:t.disabledDates,calendarClass:t.calendarClass,calendarStyle:t.calendarStyle,translation:t.translation,isRtl:t.isRtl,"use-utc":t.useUtc},on:{selectMonth:t.selectMonth,showYearCalendar:t.showYearCalendar,changedYear:t.setPageDate}},[t._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):t._e(),t._v(" "),t.allowedToShowView("year")?n("picker-year",{attrs:{pageDate:t.pageDate,selectedDate:t.selectedDate,showYearView:t.showYearView,allowedToShowView:t.allowedToShowView,disabledDates:t.disabledDates,calendarClass:t.calendarClass,calendarStyle:t.calendarStyle,translation:t.translation,isRtl:t.isRtl,"use-utc":t.useUtc},on:{selectYear:t.selectYear,changedDecade:t.setPageDate}},[t._t("beforeCalendarHeader",null,{slot:"beforeCalendarHeader"})],2):t._e()],1)};ar._withStripped=!0;var or=Ro({render:ar,staticRenderFns:[]},function(t){t&&t("data-v-64ca2bb5_0",{source:".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n",map:{version:3,sources:["Datepicker.vue"],names:[],mappings:"AAAA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,eAAe;AACjB",file:"Datepicker.vue",sourcesContent:[".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n"]},media:void 0})},ir,void 0,!1,void 0,nr,void 0),rr={name:"pf-contact-names",data:function(){return{isShow:!1,messageAccordion:"Show more..."}},mixins:[ht],methods:{setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},sr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"boxContainer myRow"},[n("div",{staticClass:"row"},[t._m(0),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:1,id:""!==t.indexItem?"firstName-names"+t.indexItem:"firstName-names"+t.index,readonly:t.readonly,label:"First Name:",classElement:void 0===t.information.class?"":void 0!==t.information.class.firstName?t.information.class.firstName:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.firstName,fieldId:"firstName",type:"personal",id:""!==t.indexItem?"firstName-names"+t.indexItem:"firstName-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"firstName",value:t.information.firstName,id:""!==t.indexItem?"firstName-names"+t.indexItem:"firstName-names"+t.index})}},model:{value:t.information.firstName,callback:function(e){t.$set(t.information,"firstName",e)},expression:"information.firstName"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:2,id:""!==t.indexItem?"middleName-names"+t.indexItem:"middleName-names"+t.index,readonly:t.readonly,label:"Middle Name:",classElement:void 0===t.information.class?"":void 0!==t.information.class.middleName?t.information.class.middleName:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.middleName,fieldId:"middleName",type:"personal",id:""!==t.indexItem?"middleName-names"+t.indexItem:"middleName-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"middleName",value:t.information.middleName,id:""!==t.indexItem?"middleName-names"+t.indexItem:"middleName-names"+t.index})}},model:{value:t.information.middleName,callback:function(e){t.$set(t.information,"middleName",e)},expression:"information.middleName"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:3,id:""!==t.indexItem?"lastName-names"+t.indexItem:"lastName-names"+t.index,readonly:t.readonly,label:"Last Name(s):",classElement:void 0===t.information.class?"":void 0!==t.information.class.lastName?t.information.class.lastName:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.lastName,fieldId:"lastName",type:"personal",id:""!==t.indexItem?"lastName-names"+t.indexItem:"lastName-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"lastName",value:t.information.lastName,id:""!==t.indexItem?"lastName-names"+t.indexItem:"lastName-names"+t.index})}},model:{value:t.information.lastName,callback:function(e){t.$set(t.information,"lastName",e)},expression:"information.lastName"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[t._m(1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:4,id:""!==t.indexItem?"otherFirst1-names"+t.indexItem:"otherFirst1-names"+t.index,readonly:t.readonly,label:"First Name:",classElement:void 0===t.information.class?"":void 0!==t.information.class.otherFirst1?t.information.class.otherFirst1:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherFirst1,fieldId:"otherFirst1",type:"personal",id:""!==t.indexItem?"otherFirst1-names"+t.indexItem:"otherFirst1-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"otherFirst1",value:t.information.otherFirst1,id:""!==t.indexItem?"otherFirst1-names"+t.indexItem:"otherFirst1-names"+t.index})}},model:{value:t.information.otherFirst1,callback:function(e){t.$set(t.information,"otherFirst1",e)},expression:"information.otherFirst1"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:5,id:""!==t.indexItem?"otherMiddle1-names"+t.indexItem:"otherMiddle1-names"+t.index,readonly:t.readonly,label:"Middle Name:",classElement:void 0===t.information.class?"":void 0!==t.information.class.otherMiddle1?t.information.class.otherMiddle1:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherMiddle1,fieldId:"otherMiddle1",type:"personal",id:""!==t.indexItem?"otherMiddle1-names"+t.indexItem:"otherMiddle1-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"otherMiddle1",value:t.information.otherMiddle1,id:""!==t.indexItem?"otherMiddle1-names"+t.indexItem:"otherMiddle1-names"+t.index})}},model:{value:t.information.otherMiddle1,callback:function(e){t.$set(t.information,"otherMiddle1",e)},expression:"information.otherMiddle1"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:6,id:""!==t.indexItem?"otherLast1-names"+t.indexItem:"otherLast1-names"+t.index,readonly:t.readonly,label:"Last Name(s):",classElement:void 0===t.information.class?"":void 0!==t.information.class.otherLast1?t.information.class.otherLast1:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherLast1,fieldId:"otherLast1",type:"personal",id:""!==t.indexItem?"otherLast1-names"+t.indexItem:"otherLast1-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"otherLast1",value:t.information.otherLast1,id:""!==t.indexItem?"otherLast1-names"+t.indexItem:"otherLast1-names"+t.index})}},model:{value:t.information.otherLast1,callback:function(e){t.$set(t.information,"otherLast1",e)},expression:"information.otherLast1"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accrodionNames"+t.indexItem:"#accrodionNames"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accrodionNames"+t.indexItem:"accrodionNames"+t.index}},[n("div",{staticClass:"row"},[t._m(2),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:7,id:""!==t.indexItem?"otherFirst2-names"+t.indexItem:"otherFirst2-names"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.otherFirst2?t.information.class.otherFirst2:"",readonly:t.readonly,label:"First Name:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherFirst2,fieldId:"otherFirst2",type:"personal",id:""!==t.indexItem?"otherFirst2-names"+t.indexItem:"otherFirst2-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"otherFirst2",value:t.information.otherFirst2,id:""!==t.indexItem?"otherFirst2-names"+t.indexItem:"otherFirst2-names"+t.index})}},model:{value:t.information.otherFirst2,callback:function(e){t.$set(t.information,"otherFirst2",e)},expression:"information.otherFirst2"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:8,id:""!==t.indexItem?"otherMiddle2-names"+t.indexItem:"otherMiddle2-names"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.otherMiddle2?t.information.class.otherMiddle2:"",readonly:t.readonly,label:"Middle Name:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherMiddle2,fieldId:"otherMiddle2",type:"personal",id:""!==t.indexItem?"otherMiddle2-names"+t.indexItem:"otherMiddle2-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"otherMiddle2",value:t.information.otherMiddle2,id:""!==t.indexItem?"otherMiddle2-names"+t.indexItem:"otherMiddle2-names"+t.index})}},model:{value:t.information.otherMiddle2,callback:function(e){t.$set(t.information,"otherMiddle2",e)},expression:"information.otherMiddle2"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:9,id:""!==t.indexItem?"otherLast2-names"+t.indexItem:"otherLast2-names"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.otherLast2?t.information.class.otherLast2:"",readonly:t.readonly,label:"Last Name(s):"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherLast2,fieldId:"otherLast2",type:"personal",id:""!==t.indexItem?"otherLast2-names"+t.indexItem:"otherLast2-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"otherLast2",value:t.information.otherLast2,id:""!==t.indexItem?"otherLast2-names"+t.indexItem:"otherLast2-names"+t.index})}},model:{value:t.information.otherLast2,callback:function(e){t.$set(t.information,"otherLast2",e)},expression:"information.otherLast2"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[t._m(3),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:10,id:""!==t.indexItem?"otherFirst3-names"+t.indexItem:"otherFirst3-names"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.otherFirst3?t.information.class.otherFirst3:"",readonly:t.readonly,label:"First Name:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherFirst3,fieldId:"otherFirst3",type:"personal",id:""!==t.indexItem?"otherFirst3-names"+t.indexItem:"otherFirst3-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"otherFirst3",value:t.information.otherFirst3,id:""!==t.indexItem?"otherFirst3-names"+t.indexItem:"otherFirst3-names"+t.index})}},model:{value:t.information.otherFirst3,callback:function(e){t.$set(t.information,"otherFirst3",e)},expression:"information.otherFirst3"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:11,id:""!==t.indexItem?"otherMiddle3-names"+t.indexItem:"otherMiddle3-names"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.otherMiddle3?t.information.class.otherMiddle3:"",readonly:t.readonly,label:"Middle Name:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherMiddle3,fieldId:"otherMiddle3",type:"personal",id:""!==t.indexItem?"otherMiddle3-names"+t.indexItem:"otherMiddle3-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"otherMiddle3",value:t.information.otherMiddle3,id:""!==t.indexItem?"otherMiddle3-names"+t.indexItem:"otherMiddle3-names"+t.index})}},model:{value:t.information.otherMiddle3,callback:function(e){t.$set(t.information,"otherMiddle3",e)},expression:"information.otherMiddle3"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:12,id:""!==t.indexItem?"otherLast3-names"+t.indexItem:"otherLast3-names"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.otherLast3?t.information.class.otherLast3:"",readonly:t.readonly,label:"Last Name(s):"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherLast3,fieldId:"otherLast3",type:"personal",id:""!==t.indexItem?"otherLast3-names"+t.indexItem:"otherLast3-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"otherLast3",value:t.information.otherLast3,id:""!==t.indexItem?"otherLast3-names"+t.indexItem:"otherLast3-names"+t.index})}},model:{value:t.information.otherLast3,callback:function(e){t.$set(t.information,"otherLast3",e)},expression:"information.otherLast3"}})],1)])]),t._v(" "),n("div",{staticClass:"row"},[t._m(4),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:13,id:""!==t.indexItem?"firstNameNativeAlpha-names"+t.indexItem:"firstNameNativeAlpha-names"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.firstNameNativeAlpha?t.information.class.firstNameNativeAlpha:"",readonly:t.readonly,label:"First Name:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.firstNameNativeAlpha,fieldId:"firstNameNativeAlpha",type:"personal",id:""!==t.indexItem?"firstNameNativeAlpha-names"+t.indexItem:"firstNameNativeAlpha-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"firstNameNativeAlpha",value:t.information.firstNameNativeAlpha,id:""!==t.indexItem?"firstNameNativeAlpha-names"+t.indexItem:"firstNameNativeAlpha-names"+t.index})}},model:{value:t.information.firstNameNativeAlpha,callback:function(e){t.$set(t.information,"firstNameNativeAlpha",e)},expression:"information.firstNameNativeAlpha"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:14,id:""!==t.indexItem?"middleNameNativeAlpha-names"+t.indexItem:"middleNameNativeAlpha-names"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.middleNameNativeAlpha?t.information.class.middleNameNativeAlpha:"",readonly:t.readonly,label:"Middle Name:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.middleNameNativeAlpha,fieldId:"middleNameNativeAlpha",type:"personal",id:""!==t.indexItem?"middleNameNativeAlpha-names"+t.indexItem:"middleNameNativeAlpha-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"middleNameNativeAlpha",value:t.information.middleNameNativeAlpha,id:""!==t.indexItem?"middleNameNativeAlpha-names"+t.indexItem:"middleNameNativeAlpha-names"+t.index})}},model:{value:t.information.middleNameNativeAlpha,callback:function(e){t.$set(t.information,"middleNameNativeAlpha",e)},expression:"information.middleNameNativeAlpha"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:15,id:""!==t.indexItem?"lastNameNativeAlpha-names"+t.indexItem:"lastNameNativeAlpha-names"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.lastNameNativeAlpha?t.information.class.lastNameNativeAlpha:"",readonly:t.readonly,label:"Last Name(s):"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.lastNameNativeAlpha,fieldId:"lastNameNativeAlpha",type:"personal",id:""!==t.indexItem?"lastNameNativeAlpha-names"+t.indexItem:"lastNameNativeAlpha-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"lastNameNativeAlpha",value:t.information.lastNameNativeAlpha,id:""!==t.indexItem?"lastNameNativeAlpha-names"+t.indexItem:"lastNameNativeAlpha-names"+t.index})}},model:{value:t.information.lastNameNativeAlpha,callback:function(e){t.$set(t.information,"lastNameNativeAlpha",e)},expression:"information.lastNameNativeAlpha"}})],1)])]):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBox"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Names")])])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBoxNoBorder"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Other Name Used #1")])])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBoxNoBorder"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Other Name Used #2")])])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBoxNoBorder"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Other Name Used #3")])])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBoxNoBorder"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Name as written in native language")])])])}]};var lr=n("VU/8")(rr,sr,!1,function(t){n("ICpA")},"data-v-b58978aa",null).exports,dr={name:"pf-biographic-information",data:function(){return{countries:ft.COUNTRIES}},mixins:[ht],components:{PfRadio:P,PfSelect:k},methods:{changeRadio:function(t){var e=this;this.information[t.key]=t.type;var n=this.information;Y()(this.radioGroups).forEach(function(i){-1!==e.radioGroups[i].indexOf(t.keyThree)&&e.radioGroups[i].forEach(function(i){i!==t.keyThree?(n[i]="off",!0===e.comparing&&(n.threeValues[i].manual="off")):(n[i]="on",!0===e.comparing&&(n.threeValues[i].manual="on"))})}),this.information={},this.information=n,this.updateModel({model:"personal",field:t.key,value:t.type,id:t.id})}}},cr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"boxContainer myRow"},[n("div",{staticClass:"row"},[t._m(0),t._v(" "),n("div",{staticClass:"col-md-4"},[n("label",{attrs:{for:""}},[t._v("Sex:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sexFemale?t.information.class.sexFemale:"",readonly:t.readonly,classLabel:"mediumSize",label:"Female",name:"sexPerson"+t.indexItem,checked:"on"===t.information.sexFemale,id:""!==t.indexItem?"sexFemale"+t.indexItem:"sexFemale"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sexFemale,fieldId:"sexFemale",type:"personal",id:""!==t.indexItem?"sexFemale"+t.indexItem:"sexFemale"+t.index})},click:function(e){return t.changeRadio({type:"Female",id:""!==t.indexItem?"sexFemale"+t.indexItem:"sexFemale"+t.index,key:"sex",keyThree:"sexFemale"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sexMale?t.information.class.sexMale:"",readonly:t.readonly,classLabel:"mediumSize",label:"Male",name:"sexPerson"+t.indexItem,checked:"on"===t.information.sexMale,id:""!==t.indexItem?"sexMale"+t.indexItem:"sexMale"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sexMale,fieldId:"sexMale",type:"personal",id:""!==t.indexItem?"sexMale"+t.indexItem:"sexMale"+t.index})},click:function(e){return t.changeRadio({type:"Male",id:""!==t.indexItem?"sexMale"+t.indexItem:"sexMale"+t.index,key:"sex",keyThree:"sexMale"})}}})],1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{tabindex:1,classElement:void 0===t.information.class?"":void 0!==t.information.class.birthDate?t.information.class.birthDate:"",label:"Date of Birth (mm-dd-yyyy):",mask:"##/##/####",readonly:t.readonly,id:""!==t.indexItem?"birthDate-biographic"+t.indexItem:"birthDate-biographic"+t.index,name:""!==t.indexItem?"birthDate-biographic"+t.indexItem:"birthDate-biographic"+t.index,model:"personal",field:"birthDate"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.birthDate,fieldId:"birthDate",type:"personal",id:""!==t.indexItem?"input-birthDate-biographic"+t.indexItem:"input-birthDate-biographic"+t.index})},change:t.changeCalendar},model:{value:t.information.birthDate,callback:function(e){t.$set(t.information,"birthDate",e)},expression:"information.birthDate"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:2,classElement:void 0===t.information.class?"":void 0!==t.information.class.socialSecurityNumber?t.information.class.socialSecurityNumber:"",readonly:t.readonly,label:"Social Security Number:",mask:"###-##-####",placeholder:"999-99-9999",id:""!==t.indexItem?"socialSecurityNumber-biographic"+t.indexItem:"socialSecurityNumber-biographic"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.socialSecurityNumber,fieldId:"socialSecurityNumber",type:"personal",id:""!==t.indexItem?"socialSecurityNumber-biographic"+t.indexItem:"socialSecurityNumber-biographic"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"socialSecurityNumber",value:t.information.socialSecurityNumber,id:""!==t.indexItem?"socialSecurityNumber-biographic"+t.indexItem:"socialSecurityNumber-biographic"+t.index})}},model:{value:t.information.socialSecurityNumber,callback:function(e){t.$set(t.information,"socialSecurityNumber",e)},expression:"information.socialSecurityNumber"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:3,classElement:void 0===t.information.class?"":void 0!==t.information.class.pobCity?t.information.class.pobCity:"",readonly:t.readonly,label:"City of Birth:",id:""!==t.indexItem?"pobCity-biographic"+t.indexItem:"pobCity-biographic"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.pobCity,fieldId:"pobCity",type:"personal",id:""!==t.indexItem?"pobCity-biographic"+t.indexItem:"pobCity-biographic"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"pobCity",value:t.information.pobCity,id:""!==t.indexItem?"pobCity-biographic"+t.indexItem:"pobCity-biographic"+t.index})}},model:{value:t.information.pobCity,callback:function(e){t.$set(t.information,"pobCity",e)},expression:"information.pobCity"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:4,classElement:void 0===t.information.class?"":void 0!==t.information.class.pobState?t.information.class.pobState:"",readonly:t.readonly,label:"State of Birth:",id:""!==t.indexItem?"pobState-biographic"+t.indexItem:"pobState-biographic"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.pobState,fieldId:"pobState",type:"personal",id:""!==t.indexItem?"pobState-biographic"+t.indexItem:"pobState-biographic"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"pobState",value:t.information.pobState,id:""!==t.indexItem?"pobState-biographic"+t.indexItem:"pobState-biographic"+t.index})}},model:{value:t.information.pobState,callback:function(e){t.$set(t.information,"pobState",e)},expression:"information.pobState"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"pobCountry",id:""!==t.indexItem?"pobCountry-biographic"+t.indexItem:"pobCountry-biographic"+t.index,model:"personal",label:"Country of Birth:",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.pobCountry?"Select Country":t.information.pobCountry,options:t.countries},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.pobCountry,fieldId:"pobCountry",type:"personal",id:""!==t.indexItem?"pobCountry-biographic"+t.indexItem:"pobCountry-biographic"+t.index})},change:t.changeSelect}})],1)])]):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBox"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Biographic Information")])])])}]};var hr=n("VU/8")(dr,cr,!1,function(t){n("2cLf"),n("pXPO")},"data-v-205fbe5c",null).exports,ur={name:"pf-immigration-information",data:function(){return{countries:ft.COUNTRIES}},mixins:[ht],components:{PfSelect:k}},mr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"boxContainer myRow"},[n("div",{staticClass:"row"},[t._m(0),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:1,id:""!==t.indexItem?"alienNumber-immigra"+t.indexItem:"alienNumber-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.alienNumber?t.information.class.alienNumber:"",readonly:t.readonly,label:"USCIS Number (also known as alien number, or A#).  This can be found on a visa petition receipt notice, work permit, or residency permit.",mask:"###-###-###",placeholder:"999-999-999"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.alienNumber,fieldId:"alienNumber",type:"personal",id:""!==t.indexItem?"alienNumber-immigra"+t.indexItem:"alienNumber-immigra"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"alienNumber",value:t.information.alienNumber,id:""!==t.indexItem?"alienNumber-immigra"+t.indexItem:"alienNumber-immigra"+t.index})}},model:{value:t.information.alienNumber,callback:function(e){t.$set(t.information,"alienNumber",e)},expression:"information.alienNumber"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{tabindex:2,field:"citizenship",id:""!==t.indexItem?"citizenship-immigra"+t.indexItem:"citizenship-immigra"+t.index,model:"personal",label:"Country of Citizenship (if you have multiple countries of citizenship, please provide that to your attorney separately):",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.citizenship?"Select Country":t.information.citizenship,options:t.countries},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.citizenship,fieldId:"citizenship",type:"personal",id:""!==t.indexItem?"citizenship-immigra"+t.indexItem:"citizenship-immigra"+t.index})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{tabindex:3,id:""!==t.indexItem?"i94-immigra"+t.indexItem:"i94-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.i94?t.information.class.i94:"",readonly:t.readonly,label:"I-94 number.  This is a number which is given upon entry to the US or in other circumstances."},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.i94,fieldId:"i94",type:"personal",id:""!==t.indexItem?"i94-immigra"+t.indexItem:"i94-immigra"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"i94",value:t.information.i94,id:""!==t.indexItem?"i94-immigra"+t.indexItem:"i94-immigra"+t.index})}},model:{value:t.information.i94,callback:function(e){t.$set(t.information,"i94",e)},expression:"information.i94"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{tabindex:4,id:""!==t.indexItem?"placeOfLastEntryToUs-immigra"+t.indexItem:"placeOfLastEntryToUs-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfLastEntryToUs?t.information.class.placeOfLastEntryToUs:"",readonly:t.readonly,label:"Where did you most recently enter the United States?"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.placeOfLastEntryToUs,fieldId:"placeOfLastEntryToUs",type:"personal",id:""!==t.indexItem?"placeOfLastEntryToUs-immigra"+t.indexItem:"placeOfLastEntryToUs-immigra"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"placeOfLastEntryToUs",value:t.information.placeOfLastEntryToUs,id:""!==t.indexItem?"placeOfLastEntryToUs-immigra"+t.indexItem:"placeOfLastEntryToUs-immigra"+t.index})}},model:{value:t.information.placeOfLastEntryToUs,callback:function(e){t.$set(t.information,"placeOfLastEntryToUs",e)},expression:"information.placeOfLastEntryToUs"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-calendar",{attrs:{tabindex:5,id:""!==t.indexItem?"dateOfLastEntryToUs-immigra"+t.indexItem:"dateOfLastEntryToUs-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.dateOfLastEntryToUs?t.information.class.dateOfLastEntryToUs:"",readonly:t.readonly,label:"When did you most recently enter the United States?",mask:"##/##/####",model:"personal",field:"dateOfLastEntryToUs"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.dateOfLastEntryToUs,fieldId:"dateOfLastEntryToUs",type:"personal",id:""!==t.indexItem?"input-dateOfLastEntryToUs-immigra"+t.indexItem:"input-dateOfLastEntryToUs-immigra"+t.index})},change:t.changeCalendar},model:{value:t.information.dateOfLastEntryToUs,callback:function(e){t.$set(t.information,"dateOfLastEntryToUs",e)},expression:"information.dateOfLastEntryToUs"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{tabindex:6,id:""!==t.indexItem?"currentImmigrationStatus-immigra"+t.indexItem:"currentImmigrationStatus-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.currentImmigrationStatus?t.information.class.currentImmigrationStatus:"",readonly:t.readonly,label:"What is your current immigration status?"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.currentImmigrationStatus,fieldId:"currentImmigrationStatus",type:"personal",id:""!==t.indexItem?"currentImmigrationStatus-immigra"+t.indexItem:"currentImmigrationStatus-immigra"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"currentImmigrationStatus",value:t.information.currentImmigrationStatus,id:""!==t.indexItem?"currentImmigrationStatus-immigra"+t.indexItem:"currentImmigrationStatus-immigra"+t.index})}},model:{value:t.information.currentImmigrationStatus,callback:function(e){t.$set(t.information,"currentImmigrationStatus",e)},expression:"information.currentImmigrationStatus"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-calendar",{attrs:{tabindex:7,id:""!==t.indexItem?"crExp-immigra"+t.indexItem:"crExp-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.crExp?t.information.class.crExp:"",readonly:t.readonly,label:"If you have 'Conditional Residency' (the two-year green card), when does it expire?",mask:"##/##/####",model:"personal",field:"crExp"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.crExp,fieldId:"crExp",type:"personal",id:""!==t.indexItem?"input-crExp-immigra"+t.indexItem:"input-crExp-immigra"+t.index})},change:t.changeCalendar},model:{value:t.information.crExp,callback:function(e){t.$set(t.information,"crExp",e)},expression:"information.crExp"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{tabindex:8,id:""!==t.indexItem?"elis-immigra"+t.indexItem:"elis-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.elis?t.information.class.elis:"",readonly:t.readonly,label:"If you have an ELIS number, please enter it here:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.elis,fieldId:"elis",type:"personal",id:""!==t.indexItem?"elis-immigra"+t.indexItem:"elis-immigra"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"elis",value:t.information.elis,id:""!==t.indexItem?"elis-immigra"+t.indexItem:"elis-immigra"+t.index})}},model:{value:t.information.elis,callback:function(e){t.$set(t.information,"elis",e)},expression:"information.elis"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-calendar",{attrs:{tabindex:9,id:""!==t.indexItem?"lprExp-immigra"+t.indexItem:"lprExp-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.lprExp?t.information.class.lprExp:"",readonly:t.readonly,label:"If you are a Legal Permanent Resident, when does your residency permit expire?",mask:"##/##/####",model:"personal",field:"lprExp"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.lprExp,fieldId:"lprExp",type:"personal",id:""!==t.indexItem?"input-lprExp-immigra"+t.indexItem:"input-lprExp-immigra"+t.index})},change:t.changeCalendar},model:{value:t.information.lprExp,callback:function(e){t.$set(t.information,"lprExp",e)},expression:"information.lprExp"}})],1),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-input",{attrs:{tabindex:10,id:""!==t.indexItem?"nvcDosCaseNum-immigra"+t.indexItem:"nvcDosCaseNum-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.nvcDosCaseNum?t.information.class.nvcDosCaseNum:"",readonly:t.readonly,label:"If you have a case number with the National Visa Center (NVC) please enter it here: (for example CDJ2019123456)"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.nvcDosCaseNum,fieldId:"nvcDosCaseNum",type:"personal",id:""!==t.indexItem?"nvcDosCaseNum-immigra"+t.indexItem:"nvcDosCaseNum-immigra"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"nvcDosCaseNum",value:t.information.nvcDosCaseNum,id:""!==t.indexItem?"nvcDosCaseNum-immigra"+t.indexItem:"nvcDosCaseNum-immigra"+t.index})}},model:{value:t.information.nvcDosCaseNum,callback:function(e){t.$set(t.information,"nvcDosCaseNum",e)},expression:"information.nvcDosCaseNum"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-12"},[n("pf-calendar",{attrs:{tabindex:11,id:""!==t.indexItem?"dateAdmissionLpr-immigra"+t.indexItem:"dateAdmissionLpr-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.dateAdmissionLpr?t.information.class.dateAdmissionLpr:"",readonly:t.readonly,label:" When did you first become a Legal Permanent Resident (see the date on your Residency Permit also known as your 'Green Card' or I-551)?",mask:"##/##/####",model:"personal",field:"dateAdmissionLpr"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.dateAdmissionLpr,fieldId:"dateAdmissionLpr",type:"personal",id:""!==t.indexItem?"input-dateAdmissionLpr-immigra"+t.indexItem:"input-dateAdmissionLpr-immigra"+t.index})},change:t.changeCalendar},model:{value:t.information.dateAdmissionLpr,callback:function(e){t.$set(t.information,"dateAdmissionLpr",e)},expression:"information.dateAdmissionLpr"}})],1),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-input",{attrs:{tabindex:12,id:""!==t.indexItem?"classAdmissionLpr-immigra"+t.indexItem:"classAdmissionLpr-immigra"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.classAdmissionLpr?t.information.class.classAdmissionLpr:"",readonly:t.readonly,label:"Please enter the 'Category' code shown on your Residency Permit also known as your 'Green Card' or I-551:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.classAdmissionLpr,fieldId:"classAdmissionLpr",type:"personal",id:""!==t.indexItem?"classAdmissionLpr-immigra"+t.indexItem:"classAdmissionLpr-immigra"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"classAdmissionLpr",value:t.information.classAdmissionLpr,id:""!==t.indexItem?"classAdmissionLpr-immigra"+t.indexItem:"classAdmissionLpr-immigra"+t.index})}},model:{value:t.information.classAdmissionLpr,callback:function(e){t.$set(t.information,"classAdmissionLpr",e)},expression:"information.classAdmissionLpr"}})],1),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-input",{attrs:{tabindex:13,id:""!==t.indexItem?"certificateNaturalizationNumber-immigra"+t.indexItem:"certificateNaturalizationNumber-immigra"+t.index,readonly:t.readonly,label:"If you have a naturalization certificate, what is your naturalization certificate number?",classElement:void 0===t.information.class?"":void 0!==t.information.class.certificateNaturalizationNumber?t.information.class.certificateNaturalizationNumber:""},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.certificateNaturalizationNumber,fieldId:"certificateNaturalizationNumber",type:"personal",id:""!==t.indexItem?"certificateNaturalizationNumber-immigra"+t.indexItem:"certificateNaturalizationNumber-immigra"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"certificateNaturalizationNumber",value:t.information.certificateNaturalizationNumber,id:""!==t.indexItem?"certificateNaturalizationNumber-immigra"+t.indexItem:"certificateNaturalizationNumber-immigra"+t.index})}},model:{value:t.information.certificateNaturalizationNumber,callback:function(e){t.$set(t.information,"certificateNaturalizationNumber",e)},expression:"information.certificateNaturalizationNumber"}})],1)])]):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBox"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Immigration Information")])])])}]};var fr=n("VU/8")(ur,mr,!1,function(t){n("a9+9"),n("d7oi")},"data-v-1da58f3a",null).exports,pr={name:"pf-background-check-information",mixins:[ht],components:{PfRadio:P,PfSelect:k},methods:{changeRadio:function(t){var e=this;this.information[t.key]=t.type;var n=this.information;Y()(this.radioGroups).forEach(function(i){-1!==e.radioGroups[i].indexOf(t.keyThree)&&e.radioGroups[i].forEach(function(i){i!==t.keyThree?(n[i]="off",!0===e.comparing&&(n.threeValues[i].manual="off")):(n[i]="on",!0===e.comparing&&(n.threeValues[i].manual="on"))})}),this.information={},this.information=n,this.updateModel({model:"personal",field:t.key,value:t.type,id:t.id,keyThree:t.keyThree})}}},_r={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"boxContainer myRow"},[n("div",{staticClass:"row"},[t._m(0),t._v(" "),n("div",{staticClass:"col-md-3"},[n("div",{staticClass:"form-group"},[n("label",{staticClass:"textUnderline",attrs:{for:""}},[t._v("Ethnicity:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hisp?t.information.class.hisp:"",readonly:t.readonly,classLabel:"mediumSize",label:"Hispanic or Latino",name:"EthnicityPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hisp,id:""!==t.indexItem?"hisp"+t.indexItem:"hisp"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hisp,fieldId:"hisp",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hisp"+t.indexItem:"hisp"+t.index})},click:function(e){return t.changeRadio({type:"Hispanic",id:""!==t.indexItem?"hisp"+t.indexItem:"hisp"+t.index,key:"ethnicity",keyThree:"hisp"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.nothisp?t.information.class.nothisp:"",readonly:t.readonly,classLabel:"mediumSize",label:"Not Hispanic or Latino",name:"EthnicityPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.nothisp,id:""!==t.indexItem?"nothisp"+t.indexItem:"nothisp"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.nothisp,fieldId:"nothisp",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"nothisp"+t.indexItem:"nothisp"+t.index})},click:function(e){return t.changeRadio({type:"None",id:""!==t.indexItem?"nothisp"+t.indexItem:"nothisp"+t.index,key:"ethnicity",keyThree:"nothisp"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-3"},[n("div",{staticClass:"form-group"},[n("label",{staticClass:"textUnderline",attrs:{for:""}},[t._v("Race:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.white?t.information.class.white:"",readonly:t.readonly,classLabel:"mediumSize",label:"White",name:"RacePerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.white,id:""!==t.indexItem?"white"+t.indexItem:"white"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.white,fieldId:"white",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"white"+t.indexItem:"white"+t.index})},click:function(e){return t.changeRadio({type:"White",id:""!==t.indexItem?"white"+t.indexItem:"white"+t.index,key:"race",keyThree:"white"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.asian?t.information.class.asian:"",readonly:t.readonly,classLabel:"mediumSize",label:"Asian",name:"RacePerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.asian,id:""!==t.indexItem?"asian"+t.indexItem:"asian"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.asian,fieldId:"asian",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"asian"+t.indexItem:"asian"+t.index})},click:function(e){return t.changeRadio({type:"Asian",id:""!==t.indexItem?"asian"+t.indexItem:"asian"+t.index,key:"race",keyThree:"asian"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.black?t.information.class.black:"",readonly:t.readonly,classLabel:"mediumSize",label:"Black",name:"RacePerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.black,id:""!==t.indexItem?"black"+t.indexItem:"black"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.black,fieldId:"black",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"black"+t.indexItem:"black"+t.index})},click:function(e){return t.changeRadio({type:"Black",id:""!==t.indexItem?"black"+t.indexItem:"black"+t.index,key:"race",keyThree:"black"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.amind?t.information.class.amind:"",readonly:t.readonly,classLabel:"mediumSize",label:"American Indian or Alaska Native",name:"RacePerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.amind,id:""!==t.indexItem?"amind"+t.indexItem:"amind"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.amind,fieldId:"amind",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"amind"+t.indexItem:"amind"+t.index})},click:function(e){return t.changeRadio({type:"Amind",id:""!==t.indexItem?"amind"+t.indexItem:"amind"+t.index,key:"race",keyThree:"amind"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hawaii?t.information.class.hawaii:"",readonly:t.readonly,classLabel:"mediumSize",label:"Native Hawaiian or Other Pacific Islander",name:"RacePerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hawaii,id:""!==t.indexItem?"hawaii"+t.indexItem:"hawaii"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hawaii,fieldId:"hawaii",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hawaii"+t.indexItem:"hawaii"+t.index})},click:function(e){return t.changeRadio({type:"Hawaii",id:""!==t.indexItem?"hawaii"+t.indexItem:"hawaii"+t.index,key:"race",keyThree:"hawaii"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-3"},[n("div",{staticClass:"form-group"},[n("label",{staticClass:"textUnderline",attrs:{for:""}},[t._v("Eye Color:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.eyeBlack?t.information.class.eyeBlack:"",readonly:t.readonly,classLabel:"mediumSize",label:"Black",name:"eyeColoPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.eyeBlack,id:""!==t.indexItem?"eyeBlack"+t.indexItem:"eyeBlack"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.eyeBlack,fieldId:"eyeBlack",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"eyeBlack"+t.indexItem:"eyeBlack"+t.index})},click:function(e){return t.changeRadio({type:"Black",id:""!==t.indexItem?"eyeBlack"+t.indexItem:"eyeBlack"+t.index,key:"eyes",keyThree:"eyeBlack"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.eyeGray?t.information.class.eyeGray:"",readonly:t.readonly,classLabel:"mediumSize",label:"Gray",name:"eyeColoPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.eyeGray,id:""!==t.indexItem?"eyeGray"+t.indexItem:"eyeGray"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.eyeGray,fieldId:"eyeGray",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"eyeGray"+t.indexItem:"eyeGray"+t.index})},click:function(e){return t.changeRadio({type:"Gray",id:""!==t.indexItem?"eyeGray"+t.indexItem:"eyeGray"+t.index,key:"eyes",keyThree:"eyeGray"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.eyeMaroon?t.information.class.eyeMaroon:"",readonly:t.readonly,classLabel:"mediumSize",label:"Maroon",name:"eyeColoPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.eyeMaroon,id:""!==t.indexItem?"eyeMaroon"+t.indexItem:"eyeMaroon"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.eyeMaroon,fieldId:"eyeMaroon",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"eyeMaroon"+t.indexItem:"eyeMaroon"+t.index})},click:function(e){return t.changeRadio({type:"Maroon",id:""!==t.indexItem?"eyeMaroon"+t.indexItem:"eyeMaroon"+t.index,key:"eyes",keyThree:"eyeMaroon"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.eyeBlue?t.information.class.eyeBlue:"",readonly:t.readonly,classLabel:"mediumSize",label:"Blue",name:"eyeColoPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.eyeBlue,id:""!==t.indexItem?"eyeBlue"+t.indexItem:"eyeBlue"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.eyeBlue,fieldId:"eyeBlue",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"eyeBlue"+t.indexItem:"eyeBlue"+t.index})},click:function(e){return t.changeRadio({type:"Blue",id:""!==t.indexItem?"eyeBlue"+t.indexItem:"eyeBlue"+t.index,key:"eyes",keyThree:"eyeBlue"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.eyeGreen?t.information.class.eyeGreen:"",readonly:t.readonly,classLabel:"mediumSize",label:"Green",name:"eyeColoPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.eyeGreen,id:""!==t.indexItem?"eyeGreen"+t.indexItem:"eyeGreen"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.eyeGreen,fieldId:"eyeGreen",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"eyeGreen"+t.indexItem:"eyeGreen"+t.index})},click:function(e){return t.changeRadio({type:"Green",id:""!==t.indexItem?"eyeGreen"+t.indexItem:"eyeGreen"+t.index,key:"eyes",keyThree:"eyeGreen"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.eyePink?t.information.class.eyePink:"",readonly:t.readonly,classLabel:"mediumSize",label:"Pink",name:"eyeColoPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.eyePink,id:""!==t.indexItem?"eyePink"+t.indexItem:"eyePink"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.eyePink,fieldId:"eyePink",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"eyePink"+t.indexItem:"eyePink"+t.index})},click:function(e){return t.changeRadio({type:"Pink",id:""!==t.indexItem?"eyePink"+t.indexItem:"eyePink"+t.index,key:"eyes",keyThree:"eyePink"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.eyeBrown?t.information.class.eyeBrown:"",readonly:t.readonly,classLabel:"mediumSize",label:"Brown",name:"eyeColoPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.eyeBrown,id:""!==t.indexItem?"eyeBrown"+t.indexItem:"eyeBrown"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.eyeBrown,fieldId:"eyeBrown",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"eyeBrown"+t.indexItem:"eyeBrown"+t.index})},click:function(e){return t.changeRadio({type:"Brown",id:""!==t.indexItem?"eyeBrown"+t.indexItem:"eyeBrown"+t.index,key:"eyes",keyThree:"eyeBrown"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.eyeHazel?t.information.class.eyeHazel:"",readonly:t.readonly,classLabel:"mediumSize",label:"Hazel",name:"eyeColoPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.eyeHazel,id:""!==t.indexItem?"eyeHazel"+t.indexItem:"eyeHazel"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.eyeHazel,fieldId:"eyeHazel",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"eyeHazel"+t.indexItem:"eyeHazel"+t.index})},click:function(e){return t.changeRadio({type:"Hazel",id:""!==t.indexItem?"eyeHazel"+t.indexItem:"eyeHazel"+t.index,key:"eyes",keyThree:"eyeHazel"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.eyeUnk?t.information.class.eyeUnk:"",readonly:t.readonly,classLabel:"mediumSize",label:"Unknown/Other",name:"eyeColoPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.eyeUnk,id:""!==t.indexItem?"eyeUnk"+t.indexItem:"eyeUnk"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.eyeUnk,fieldId:"eyeUnk",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"eyeUnk"+t.indexItem:"eyeUnk"+t.index})},click:function(e){return t.changeRadio({type:"Unknow",id:""!==t.indexItem?"eyeUnk"+t.indexItem:"eyeUnk"+t.index,key:"eyes",keyThree:"eyeUnk"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-3"},[n("div",{staticClass:"form-group"},[n("label",{staticClass:"textUnderline",attrs:{for:""}},[t._v("Hair:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hairBald?t.information.class.hairBald:"",readonly:t.readonly,classLabel:"mediumSize",label:"Bald",name:"HairPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hairBald,id:""!==t.indexItem?"hairBald"+t.indexItem:"hairBald"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hairBald,fieldId:"hairBald",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hairBald"+t.indexItem:"hairBald"+t.index})},click:function(e){return t.changeRadio({type:"Bald",id:""!==t.indexItem?"hairBald"+t.indexItem:"hairBald"+t.index,key:"hair",keyThree:"hairBald"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hairBrown?t.information.class.hairBrown:"",readonly:t.readonly,classLabel:"mediumSize",label:"Brown",name:"HairPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hairBrown,id:""!==t.indexItem?"hairBrown"+t.indexItem:"hairBrown"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hairBrown,fieldId:"hairBrown",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hairBrown"+t.indexItem:"hairBrown"+t.index})},click:function(e){return t.changeRadio({type:"Brown",id:""!==t.indexItem?"hairBrown"+t.indexItem:"hairBrown"+t.index,key:"hair",keyThree:"hairBrown"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hairSandy?t.information.class.hairSandy:"",readonly:t.readonly,classLabel:"mediumSize",label:"Sandy",name:"HairPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hairSandy,id:""!==t.indexItem?"hairSandy"+t.indexItem:"hairSandy"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hairSandy,fieldId:"hairSandy",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hairSandy"+t.indexItem:"hairSandy"+t.index})},click:function(e){return t.changeRadio({type:"Sandy",id:""!==t.indexItem?"hairSandy"+t.indexItem:"hairSandy"+t.index,key:"hair",keyThree:"hairSandy"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hairBlack?t.information.class.hairBlack:"",readonly:t.readonly,classLabel:"mediumSize",label:"Black",name:"HairPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hairBlack,id:""!==t.indexItem?"hairBlack"+t.indexItem:"hairBlack"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hairBlack,fieldId:"hairBlack",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hairBlack"+t.indexItem:"hairBlack"+t.index})},click:function(e){return t.changeRadio({type:"Black",id:""!==t.indexItem?"hairBlack"+t.indexItem:"hairBlack"+t.index,key:"hair",keyThree:"hairBlack"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hairWhite?t.information.class.hairWhite:"",readonly:t.readonly,classLabel:"mediumSize",label:"White",name:"HairPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hairWhite,id:""!==t.indexItem?"hairWhite"+t.indexItem:"hairWhite"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hairWhite,fieldId:"hairWhite",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hairWhite"+t.indexItem:"hairWhite"+t.index})},click:function(e){return t.changeRadio({type:"White",id:""!==t.indexItem?"hairWhite"+t.indexItem:"hairWhite"+t.index,key:"hair",keyThree:"hairWhite"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hairBlond?t.information.class.hairBlond:"",readonly:t.readonly,classLabel:"mediumSize",label:"Blond",name:"HairPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hairBlond,id:""!==t.indexItem?"hairBlond"+t.indexItem:"hairBlond"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hairBlond,fieldId:"hairBlond",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hairBlond"+t.indexItem:"hairBlond"+t.index})},click:function(e){return t.changeRadio({type:"Blond",id:""!==t.indexItem?"hairBlond"+t.indexItem:"hairBlond"+t.index,key:"hair",keyThree:"hairBlond"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hairRed?t.information.class.hairRed:"",readonly:t.readonly,classLabel:"mediumSize",label:"Red",name:"HairPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hairRed,id:""!==t.indexItem?"hairRed"+t.indexItem:"hairRed"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hairRed,fieldId:"hairRed",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hairRed"+t.indexItem:"hairRed"+t.index})},click:function(e){return t.changeRadio({type:"Red",id:""!==t.indexItem?"hairRed"+t.indexItem:"hairRed"+t.index,key:"hair",keyThree:"hairRed"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hairUnk?t.information.class.hairUnk:"",readonly:t.readonly,classLabel:"mediumSize",label:"Unknown/Other",name:"HairPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.hairUnk,id:""!==t.indexItem?"hairUnk"+t.indexItem:"hairUnk"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.hairUnk,fieldId:"hairUnk",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"hairUnk"+t.indexItem:"hairUnk"+t.index})},click:function(e){return t.changeRadio({type:"Unknow",id:""!==t.indexItem?"hairUnk"+t.indexItem:"hairUnk"+t.index,key:"hair",keyThree:"hairUnk"})}}})],1)])])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-3"},[n("div",{staticClass:"form-group"},[n("label",{staticClass:"textUnderline",attrs:{for:""}},[t._v("US Citizen:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.uscYes?t.information.class.uscYes:"",readonly:t.readonly,classLabel:"mediumSize",label:"Yes",name:"citizenPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.uscYes,id:""!==t.indexItem?"uscYes"+t.indexItem:"uscYes"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.uscYes,fieldId:"uscYes",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"uscYes"+t.indexItem:"uscYes"+t.index})},click:function(e){return t.changeRadio({type:"yes",id:""!==t.indexItem?"uscYes"+t.indexItem:"uscYes"+t.index,key:"USCitizen",keyThree:"uscYes"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.uscNo?t.information.class.uscNo:"",readonly:t.readonly,classLabel:"mediumSize",label:"No",name:"citizenPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.uscNo,id:""!==t.indexItem?"uscNo"+t.indexItem:"uscNo"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.uscNo,fieldId:"uscNo",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"uscNo"+t.indexItem:"uscNo"+t.index})},click:function(e){return t.changeRadio({type:"no",id:""!==t.indexItem?"uscNo"+t.indexItem:"uscNo"+t.index,key:"USCitizen",keyThree:"uscNo"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-3"},[n("div",{staticClass:"form-group"},[n("label",{staticClass:"textUnderline",attrs:{for:""}},[t._v("US Legal Permanent Resident:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lprYes?t.information.class.lprYes:"",readonly:t.readonly,classLabel:"mediumSize",label:"Yes",name:"usLegalPermResidentPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.lprYes,id:""!==t.indexItem?"lprYes"+t.indexItem:"lprYes"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lprYes,fieldId:"lprYes",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"lprYes"+t.indexItem:"lprYes"+t.index})},click:function(e){return t.changeRadio({type:"yes",id:""!==t.indexItem?"lprYes"+t.indexItem:"lprYes"+t.index,key:"USLegalPermanentResident",keyThree:"lprYes"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lprNo?t.information.class.lprNo:"",readonly:t.readonly,classLabel:"mediumSize",label:"No",name:"usLegalPermResidentPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.lprNo,id:""!==t.indexItem?"lprNo"+t.indexItem:"lprNo"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lprNo,fieldId:"lprNo",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"lprNo"+t.indexItem:"lprNo"+t.index})},click:function(e){return t.changeRadio({type:"no",id:""!==t.indexItem?"lprNo"+t.indexItem:"lprNo"+t.index,key:"USLegalPermanentResident",keyThree:"lprNo"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-3"},[n("div",{staticClass:"form-group"},[n("label",{staticClass:"textUnderline",attrs:{for:""}},[t._v("US Citizen Through:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.uscNat?t.information.class.uscNat:"",readonly:t.readonly,classLabel:"mediumSize",label:"Naturalization",name:"usCitizenThroPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.uscNat,id:""!==t.indexItem?"uscNat"+t.indexItem:"uscNat"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.uscNat,fieldId:"uscNat",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"uscNat"+t.indexItem:"uscNat"+t.index})},click:function(e){return t.changeRadio({type:"Naturalization",id:""!==t.indexItem?"uscNat"+t.indexItem:"uscNat"+t.index,key:"USCitizenThrough",keyThree:"uscNat"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.uscBirth?t.information.class.uscBirth:"",readonly:t.readonly,classLabel:"mediumSize",label:"Birth",name:"usCitizenThroPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.uscBirth,id:""!==t.indexItem?"uscBirth"+t.indexItem:"uscBirth"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.uscBirth,fieldId:"uscBirth",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"uscBirth"+t.indexItem:"uscBirth"+t.index})},click:function(e){return t.changeRadio({type:"Birth",id:""!==t.indexItem?"uscBirth"+t.indexItem:"uscBirth"+t.index,key:"USCitizenThrough",keyThree:"uscBirth"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.uscParents?t.information.class.uscParents:"",readonly:t.readonly,classLabel:"mediumSize",label:"Parents",name:"usCitizenThroPerson"+t.indexItem,classComponent:["marginBotZero","w-100"],checked:"on"===t.information.uscParents,id:""!==t.indexItem?"uscParents"+t.indexItem:"uscParents"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.uscParents,fieldId:"uscParents",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"uscParents"+t.indexItem:"uscParents"+t.index})},click:function(e){return t.changeRadio({type:"Parents",id:""!==t.indexItem?"uscParents"+t.indexItem:"uscParents"+t.index,key:"USCitizenThrough",keyThree:"uscParents"})}}})],1)])])]),t._v(" "),n("hr"),t._v(" "),n("label",{staticClass:"textUnderline titlesNames",attrs:{for:""}},[t._v("Height:")]),t._v(" "),n("div",{staticClass:"row"},[n("div",{class:!0===t.comparing?"col-md-2":"col-md-1"},[n("div",{},[n("pf-select",{attrs:{tabindex:1,field:"heightFt",id:""!==t.indexItem?"heightFt"+t.indexItem:"heightFt"+t.index,model:"personal",disabled:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.heightFt?t.information.class.heightFt:"",label:"Feet:",options:[{value:"",name:""},{value:2,name:"2",selected:"2"===t.information.heightFt},{value:3,name:"3",selected:"3"===t.information.heightFt},{value:4,name:"4",selected:"4"===t.information.heightFt},{value:5,name:"5",selected:"5"===t.information.heightFt},{value:6,name:"6",selected:"6"===t.information.heightFt},{value:7,name:"7",selected:"7"===t.information.heightFt},{value:8,name:"8",selected:"8"===t.information.heightFt}]},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.heightFt,fieldId:"heightFt",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"heightFt"+t.indexItem:"heightFt"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{class:!0===t.comparing?"col-md-2":"col-md-1"},[n("div",{},[n("pf-select",{attrs:{tabindex:2,field:"heightIn",id:""!==t.indexItem?"heightIn"+t.indexItem:"heightIn"+t.index,model:"personal",disabled:t.readonly,classElement:void 0===t.information.class?"":void 0!==t.information.class.heightIn?t.information.class.heightIn:"",label:"Inches:",options:[{value:"",name:""},{value:2,name:"2",selected:"2"===t.information.heightIn},{value:3,name:"3",selected:"3"===t.information.heightIn},{value:4,name:"4",selected:"4"===t.information.heightIn},{value:5,name:"5",selected:"5"===t.information.heightIn},{value:6,name:"6",selected:"6"===t.information.heightIn},{value:7,name:"7",selected:"7"===t.information.heightIn},{value:8,name:"8",selected:"8"===t.information.heightIn},{value:9,name:"9",selected:"9"===t.information.heightIn},{value:10,name:"10",selected:"10"===t.information.heightIn},{value:11,name:"11",selected:"11"===t.information.heightIn}]},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.heightIn,fieldId:"heightIn",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"heightIn"+t.indexItem:"heightIn"+t.index})},change:t.changeSelect}})],1)])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{class:!0===t.comparing?"col-md-2":"col-md-1"},[n("pf-input",{attrs:{tabindex:3,id:""!==t.indexItem?"weightFull"+t.indexItem:"weightFull"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.weightFull?t.information.class.weightFull:"",readonly:t.readonly,label:"Weight:"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.weightFull,fieldId:"weightFull",type:"personal",index:t.uniqueIndex,id:""!==t.indexItem?"weightFull"+t.indexItem:"weightFull"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"weightFull",value:t.information.weightFull,id:""!==t.indexItem?"weightFull"+t.indexItem:"weightFull"+t.index})}},model:{value:t.information.weightFull,callback:function(e){t.$set(t.information,"weightFull",e)},expression:"information.weightFull"}})],1)])]):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBox"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Additional Information")])])])}]};var Ar=n("VU/8")(pr,_r,!1,function(t){n("TDz6"),n("Ojsq")},"data-v-091af5d8",null).exports,br={name:"pf-priority-dates",mixins:[ht],components:{PfRadio:P,PfSelect:k,PfCheckbox:x},created:function(){""===this.information.pdFamilyPetitionDate&&void 0===this.information.pdFamilyPetitionDate||(this.information.pdFamilyPetitionDate=ct()(this.information.pdFamilyPetitionDate).format("MM/DD/YYYY")),""===this.information.pdEmploymentDate&&void 0===this.information.pdEmploymentDate||(this.information.pdEmploymentDate=ct()(this.information.pdEmploymentDate).format("MM/DD/YYYY"))}},xr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"boxContainer myRow"},[n("div",{staticClass:"row"},[t._m(0),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{tabindex:1,classElement:void 0===t.information.class?"":void 0!==t.information.class.pdFamilyPetitionDate?t.information.class.pdFamilyPetitionDate:"",readonly:t.readonly,label:"Family Petition Priority Date:",id:""!==t.indexItem?"pdFamilyPetitionDate-"+t.indexItem:"pdFamilyPetitionDate-"+t.index,mask:"##/##/####",model:"personal",field:"pdFamilyPetitionDate"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.pdFamilyPetitionDate,fieldId:"pdFamilyPetitionDate",type:"personal",id:""!==t.indexItem?"input-pdFamilyPetitionDate-"+t.indexItem:"input-pdFamilyPetitionDate-"+t.index})},change:t.changeCalendar},model:{value:t.information.pdFamilyPetitionDate,callback:function(e){t.$set(t.information,"pdFamilyPetitionDate",e)},expression:"information.pdFamilyPetitionDate"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{tabindex:2,field:"pdFamilyPetitionCountry",id:""!==t.indexItem?"pdFamilyPetitionCountry"+t.indexItem:"pdFamilyPetitionCountry"+t.index,model:"personal",disabled:t.readonly,label:"Family Petition Country:",classElement:void 0===t.information.class?"":void 0!==t.information.class.pdFamilyPetitionCountry?t.information.class.pdFamilyPetitionCountry:"",options:[{value:"N/A",name:"N/A"},{value:"Mexico",name:"Mexico",selected:"Mexico"===t.information.pdFamilyPetitionCountry},{value:"China",name:"China",selected:"China"===t.information.pdFamilyPetitionCountry},{value:"India",name:"India",selected:"India"===t.information.pdFamilyPetitionCountry},{value:"Philippines",name:"Philippines",selected:"Philippines"===t.information.pdFamilyPetitionCountry},{value:"Vietnam",name:"Vietnam",selected:"Vietnam"===t.information.pdFamilyPetitionCountry},{value:"All Other Chargeability Areas",name:"All Other Chargeability Areas",selected:"All Other Chargeability Areas"===t.information.pdFamilyPetitionCountry}]},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.pdFamilyPetitionCountry,fieldId:"pdFamilyPetitionCountry",type:"personal",id:""!==t.indexItem?"pdFamilyPetitionCountry"+t.indexItem:"pdFamilyPetitionCountry"+t.index})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{tabindex:3,field:"pdFamilyPetitionCategory",id:""!==t.indexItem?"pdFamilyPetitionCategory"+t.indexItem:"pdFamilyPetitionCategory"+t.index,model:"personal",disabled:t.readonly,label:"Family Petition Category:",classElement:void 0===t.information.class?"":void 0!==t.information.class.pdFamilyPetitionCategory?t.information.class.pdFamilyPetitionCategory:"",options:[{value:"N/A",name:"N/A"},{value:"F1",name:"F1",selected:"F1"===t.information.pdFamilyPetitionCategory},{value:"F2A",name:"F2A",selected:"F2A"===t.information.pdFamilyPetitionCategory},{value:"F2B",name:"F2B",selected:"F2B"===t.information.pdFamilyPetitionCategory},{value:"F3",name:"F3",selected:"F3"===t.information.pdFamilyPetitionCategory},{value:"F4",name:"F4",selected:"F4"===t.information.pdFamilyPetitionCategory}]},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.pdFamilyPetitionCategory,fieldId:"pdFamilyPetitionCategory",type:"personal",id:""!==t.indexItem?"pdFamilyPetitionCategory"+t.indexItem:"pdFamilyPetitionCategory"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{tabindex:4,classElement:void 0===t.information.class?"":void 0!==t.information.class.pdEmploymentDate?t.information.class.pdEmploymentDate:"",readonly:t.readonly,label:"Employment Petition Priority Date:",id:""!==t.indexItem?"pdEmploymentDate-"+t.indexItem:"pdEmploymentDate-"+t.index,mask:"##/##/####",model:"personal",field:"pdEmploymentDate"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.pdEmploymentDate,fieldId:"pdEmploymentDate",type:"personal",id:""!==t.indexItem?"input-pdEmploymentDate-"+t.indexItem:"input-pdEmploymentDate-"+t.index})},change:t.changeCalendar},model:{value:t.information.pdEmploymentDate,callback:function(e){t.$set(t.information,"pdEmploymentDate",e)},expression:"information.pdEmploymentDate"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{tabindex:5,field:"pdEmploymentPetitionCountry",id:""!==t.indexItem?"pdEmploymentPetitionCountry"+t.indexItem:"pdEmploymentPetitionCountry"+t.index,model:"personal",disabled:t.readonly,label:"Employment Petition Country:",classElement:void 0===t.information.class?"":void 0!==t.information.class.pdEmploymentPetitionCountry?t.information.class.pdEmploymentPetitionCountry:"",options:[{value:"N/A",name:"N/A"},{value:"Mexico",name:"Mexico",selected:"Mexico"===t.information.pdEmploymentPetitionCountry},{value:"China",name:"China",selected:"China"===t.information.pdEmploymentPetitionCountry},{value:"India",name:"India",selected:"India"===t.information.pdEmploymentPetitionCountry},{value:"Philippines",name:"Philippines",selected:"Philippines"===t.information.pdEmploymentPetitionCountry},{value:"El Salvador, Guatemala, Honduras",name:"El Salvador, Guatemala, Honduras",selected:"El Salvador, Guatemala, Honduras"===t.information.pdEmploymentPetitionCountry},{value:"Vietnam",name:"Vietnam",selected:"Vietnam"===t.information.pdEmploymentPetitionCountry},{value:"All Other Chargeability Areas",name:"All Other Chargeability Areas",selected:"All Other Chargeability Areas"===t.information.pdEmploymentPetitionCountry}]},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.pdEmploymentPetitionCountry,fieldId:"pdEmploymentPetitionCountry",type:"personal",id:""!==t.indexItem?"pdEmploymentPetitionCountry"+t.indexItem:"pdEmploymentPetitionCountry"+t.index})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{tabindex:6,field:"pdEmploymentPetitionCategory",id:""!==t.indexItem?"pdEmploymentPetitionCategory"+t.indexItem:"pdEmploymentPetitionCategory"+t.index,model:"personal",disabled:t.readonly,label:"Employment Petition Category:",classElement:void 0===t.information.class?"":void 0!==t.information.class.pdEmploymentPetitionCategory?t.information.class.pdEmploymentPetitionCategory:"",options:[{value:"N/A",name:"N/A"},{value:"1st",name:"1st",selected:"1st"===t.information.pdEmploymentPetitionCategory},{value:"2nd",name:"2nd",selected:"2nd"===t.information.pdEmploymentPetitionCategory},{value:"3rd",name:"3rd",selected:"3rd"===t.information.pdEmploymentPetitionCategory},{value:"Other Workers",name:"Other Workers",selected:"Other Workers"===t.information.pdEmploymentPetitionCategory},{value:"4th",name:"4th",selected:"4th"===t.information.pdEmploymentPetitionCategory},{value:"Certain Religious Workers",name:"Certain Religious Workers",selected:"Certain Religious Workers"===t.information.pdEmploymentPetitionCategory},{value:"5th Non-Regional",name:"5th Non-Regional Center (C5 and T5)",selected:"5th Non-Regional"===t.information.pdEmploymentPetitionCategory}]},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.pdEmploymentPetitionCategory,fieldId:"pdEmploymentPetitionCategory",type:"personal",id:""!==t.indexItem?"pdEmploymentPetitionCategory"+t.indexItem:"pdEmploymentPetitionCategory"+t.index})},change:t.changeSelect}})],1)])]):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBox"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Visa Bulletin - Priority Dates")])])])}]};var gr=n("VU/8")(br,xr,!1,function(t){n("wP47"),n("kIwA")},"data-v-4d58d663",null).exports,vr={name:"pf-contact",mixins:[ht],data:function(){return{dpDateBirth:!1}},components:{PfRadio:P,PfSelect:k,PfCheckbox:x,DatePicker:or,PfContactNames:lr,PfBiographicInformation:hr,PfImmigrationInformation:fr,PfBackgroundCheckInformation:Ar,PfPriorityDates:gr},mounted:function(){var t=!0===this.readonly?"link11Origin":!0===this.comparing?"link11Edit":"link11",e=!0===this.readonly?"link22Origin":!0===this.comparing?"link22Edit":"link22";"on"===this.information.isCompany?(this.changeContactType("companyquestionnairePersonal"),!0===this.readonly?this.changeContactTypeOrigin("companyOrigin"):!0===this.comparing?this.changeContactTypeEdit("companyEdit"):this.changeContactType("person"),null!==document.getElementById(e)&&(document.getElementById(e).checked=!0)):(this.changeContactType("personquestionnairePersonal"),!0===this.readonly?this.changeContactTypeOrigin("personOrigin"):!0===this.comparing?this.changeContactTypeEdit("personEdit"):this.changeContactType("person"),null!==document.getElementById(t)&&(document.getElementById(t).checked=!0))},methods:{changeContactTypeOrigin:function(t){null!==document.getElementById("personOrigin")&&(document.getElementById("personOrigin").style.display="none"),null!==document.getElementById("companyOrigin")&&(document.getElementById("companyOrigin").style.display="none"),null!==document.getElementById(t)&&document.getElementById(t).setAttribute("style","display:block !important")},changeContactTypeEdit:function(t){null!==document.getElementById("personEdit")&&(document.getElementById("personEdit").style.display="none"),null!==document.getElementById("companyEdit")&&(document.getElementById("companyEdit").style.display="none"),null!==document.getElementById(t)&&document.getElementById(t).setAttribute("style","display:block !important")},changeContactType:function(t){null!==document.getElementById("person")&&(document.getElementById("person").style.display="none"),null!==document.getElementById("company")&&(document.getElementById("company").style.display="none"),null!==document.getElementById(t)&&document.getElementById(t).setAttribute("style","display:block !important")}}},Cr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[n("div",{staticClass:"boxContainer boxPersonal"},[n("form",{staticClass:"col-12 formGeneralInfor",attrs:{id:"frontendEditor"+t.indexItem}},[t._m(0),t._v(" "),!1===t.comparing&&""===t.indexItem?n("div",[n("pf-radio",{class:["marginLeft15","mb-2"],attrs:{id:"link11",name:"typeInfoGeneral",value:"person1",label:"Person"},on:{change:function(e){return t.changeContactType("person")}}}),t._v(" "),n("pf-radio",{attrs:{id:"link22",name:"typeInfoGeneral",value:"company",label:"Company"},on:{change:function(e){return t.changeContactType("company")}}})],1):t._e(),t._v(" "),n("div",{staticClass:"content",attrs:{id:!0===t.readonly?"personOrigin":!0===t.comparing?"personEdit":"person"+t.indexItem}},[void 0!==t.information&&Object.keys(t.information).length>0?n("pf-contact-names",{attrs:{information:t.information,readonly:t.readonly,apiService:t.apiService}}):t._e(),t._v(" "),void 0!==t.information&&Object.keys(t.information).length>0?n("pf-biographic-information",{attrs:{information:t.information,readonly:t.readonly}}):t._e(),t._v(" "),void 0!==t.information&&Object.keys(t.information).length>0?n("pf-immigration-information",{attrs:{information:t.information,readonly:t.readonly}}):t._e(),t._v(" "),void 0!==t.information&&Object.keys(t.information).length>0?n("pf-background-check-information",{attrs:{information:t.information,readonly:t.readonly}}):t._e(),t._v(" "),void 0!==t.information&&Object.keys(t.information).length>0?n("pf-priority-dates",{attrs:{information:t.information,readonly:t.readonly}}):t._e()],1),t._v(" "),n("div",{staticClass:"content",attrs:{id:!0===t.readonly?"companyOrigin":!0===t.comparing?"companyEdit":"company"+t.indexItem}},[n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyName?t.information.class.companyName:"",readonly:t.readonly,label:"Company Name:"},model:{value:t.information.companyName,callback:function(e){t.$set(t.information,"companyName",e)},expression:"information.companyName"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyIrsTaxId?t.information.class.companyIrsTaxId:"",readonly:t.readonly,label:"IRS Tax ID:"},model:{value:t.information.companyIrsTaxId,callback:function(e){t.$set(t.information,"companyIrsTaxId",e)},expression:"information.companyIrsTaxId"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyBusinessType?t.information.class.companyBusinessType:"",readonly:t.readonly,label:"Business Type:"},model:{value:t.information.companyBusinessType,callback:function(e){t.$set(t.information,"companyBusinessType",e)},expression:"information.companyBusinessType"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyNaics?t.information.class.companyNaics:"",readonly:t.readonly,label:"NAICS:"},model:{value:t.information.companyNaics,callback:function(e){t.$set(t.information,"companyNaics",e)},expression:"information.companyNaics"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyYearEstablished?t.information.class.companyYearEstablished:"",readonly:t.readonly,label:"Company Year Established:"},model:{value:t.information.companyYearEstablished,callback:function(e){t.$set(t.information,"companyYearEstablished",e)},expression:"information.companyYearEstablished"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyTotalNumberEmployees?t.information.class.companyTotalNumberEmployees:"",readonly:t.readonly,label:"Total Number of Employees:"},model:{value:t.information.companyTotalNumberEmployees,callback:function(e){t.$set(t.information,"companyTotalNumberEmployees",e)},expression:"information.companyTotalNumberEmployees"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyUsNumberEmployees?t.information.class.companyUsNumberEmployees:"",readonly:t.readonly,label:"Number of US Employees:"},model:{value:t.information.companyUsNumberEmployees,callback:function(e){t.$set(t.information,"companyUsNumberEmployees",e)},expression:"information.companyUsNumberEmployees"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyGrossAnnualIncome?t.information.class.companyGrossAnnualIncome:"",readonly:t.readonly,label:"Gross annual Income:"},model:{value:t.information.companyGrossAnnualIncome,callback:function(e){t.$set(t.information,"companyGrossAnnualIncome",e)},expression:"information.companyGrossAnnualIncome"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyNetAnnualIncome?t.information.class.companyNetAnnualIncome:"",readonly:t.readonly,label:"Net annual income:"},model:{value:t.information.companyNetAnnualIncome,callback:function(e){t.$set(t.information,"companyNetAnnualIncome",e)},expression:"information.companyNetAnnualIncome"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6 col-lg-3"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyDateStabilised?t.information.class.companyDateStabilised:"",readonly:t.readonly,label:"Date Established:",id:"companyDateStabilised"+t.indexItem,mask:"##/##/####"},on:{change:t.changeCalendar},model:{value:t.information.companyDateStabilised,callback:function(e){t.$set(t.information,"companyDateStabilised",e)},expression:"information.companyDateStabilised"}})],1),t._v(" "),n("div",{staticClass:"col-md-6 col-lg-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyDolEtaCaseNumber?t.information.class.companyDolEtaCaseNumber:"",readonly:t.readonly,label:"DOL/ETA Case Number:"},model:{value:t.information.companyDolEtaCaseNumber,callback:function(e){t.$set(t.information,"companyDolEtaCaseNumber",e)},expression:"information.companyDolEtaCaseNumber"}})],1),t._v(" "),n("div",{staticClass:"col-md-6 col-lg-3"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyLaborCertFilingDate?t.information.class.companyLaborCertFilingDate:"",readonly:t.readonly,label:"Labor Certification Filing Date:",id:""!==t.indexItem?"companyLaborCertFilingDate-"+t.indexItem:"companyLaborCertFilingDate-"+t.index,mask:"##/##/####"},on:{change:t.changeCalendar},model:{value:t.information.companyLaborCertFilingDate,callback:function(e){t.$set(t.information,"companyLaborCertFilingDate",e)},expression:"information.companyLaborCertFilingDate"}})],1),t._v(" "),n("div",{staticClass:"col-md-6 col-lg-3"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.companyLaborCertExpirationDate?t.information.class.companyLaborCertExpirationDate:"",readonly:t.readonly,label:"Labor Certification Expiration Date:",id:"companyLaborCertExpirationDate"+t.indexItem,mask:"##/##/####"},on:{change:t.changeCalendar},model:{value:t.information.companyLaborCertExpirationDate,callback:function(e){t.$set(t.information,"companyLaborCertExpirationDate",e)},expression:"information.companyLaborCertExpirationDate"}})],1)])])])])])},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"marginLeft15"},[e("h4",{staticClass:"w-100 mt-2",staticStyle:{"font-weight":"600 !important","font-size":"1.25rem !important"}},[this._v("General information")])])}]};var yr=n("VU/8")(vr,Cr,!1,function(t){n("0/sM"),n("dJ18")},"data-v-626ae53c",null).exports,wr={name:"pf-contacts",props:{contactid:{type:Number,default:0},token:{type:String},new:{type:Boolean,default:!1},information:{type:Object},indexItem:{}},data:function(){return{contact:{},noInfo:"",apiService:{}}},components:{PfContact:yr,PfButton:d,PfSpinner:r},created:function(){var t=this;this.apiService=Tt,0!==this.contactid&&void 0===this.information&&void 0!==this.token?this.get():void 0!==this.information?Y()(this.information).length>0?this.contact=this.information:(this.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)):!0===this.new&&(this.contact.new=!0)},methods:{get:function(){var t=this;Tt.getContact({token:this.token,contactId:this.contactid}).then(function(e){e.pdEmploymentDate=ct()(e.pdEmploymentDate).utcOffset(-60).format("MM/DD/YYYY"),e.pdFamilyPetitionDate=ct()(e.pdFamilyPetitionDate).utcOffset(-60).format("MM/DD/YYYY"),t.contact=e,setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)})}}},Br={render:function(){var t=this.$createElement,e=this._self._c||t;return e("div",[0===this.contact.length?e("div",[""===this.noInfo?e("pf-spinner",{attrs:{color:"black"}}):e("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"}},[this._v(this._s(this.noInfo))])],1):e("pf-contact",{attrs:{information:this.contact,indexItem:this.indexItem,apiService:this.apiService}})],1)},staticRenderFns:[]};var kr=n("VU/8")(wr,Br,!1,function(t){n("yudz")},"data-v-2fbaa842",null).exports,Er={name:"pf-job",data:function(){return{isShow:!1,messageAccordion:"Show more...",countries:ft.COUNTRIES}},mixins:[ht],components:{PfRadio:P,PfPopUp:$,PfSelect:k},mounted:function(){this.messageModal="Are you really sure delete this job?"},methods:{deleteJob:function(){this.deleteItem({model:"jobs",item:"delete-job"}),this.isPopUp=!1},changeCalendarJob:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateJob(t.id)}},changeRadio:function(t){this.information.isAptSteFlr=t.type,this.updateModel({model:"jobs",field:t.key,value:t.type,id:t.id})},updateJob:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editJob(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.jobEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},Ir={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("job")},mouseleave:function(e){return t.removeHover("job")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"jobForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"job"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",{staticClass:"mrTextSpace"},[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Dates of Employment":"Company and Dates of Employment"))])])]),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.company?t.information.class.company:"",readonly:t.readonly,label:"Company:",labelStyle:!0===t.information.newItem?"color:red;":"",validate:{required:!0},id:""!==t.indexItem?"companyJobp-hide"+t.indexItem:"companyJobp-hide"+t.index,name:""!==t.indexItem?"companyJobp-hide"+t.indexItem:"companyJobp-hide"+t.index},on:{change:function(e){return t.updateModel({model:"jobs",field:"company",value:t.information.company,id:""!==t.indexItem?"companyJobp-hide"+t.indexItem:"companyJobp-hide"+t.index})}},model:{value:t.information.company,callback:function(e){t.$set(t.information,"company",e)},expression:"information.company"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.begin?t.information.class.begin:"",readonly:t.readonly,label:"Begin:",id:""!==t.indexItem?"begin-jobs"+t.indexItem:"begin-jobs"+t.index,mask:"##/##/####",model:"jobs",field:"begin"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.begin,fieldId:"begin",type:"jobs",id:""!==t.indexItem?"input-begin-jobs"+t.indexItem:"input-begin-jobs"+t.index})},change:t.changeCalendar},model:{value:t.information.begin,callback:function(e){t.$set(t.information,"begin",e)},expression:"information.begin"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.end?t.information.class.end:"",readonly:t.readonly,label:"End:",id:""!==t.indexItem?"end-jobs"+t.indexItem:"end-jobs"+t.index,mask:"##/##/####",divCalendar:"marginBotZero",model:"jobs",field:"end"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.end,fieldId:"end",type:"jobs",id:""!==t.indexItem?"input-end-jobs"+t.indexItem:"input-end-jobs"+t.index})},change:t.changeCalendar},model:{value:t.information.end,callback:function(e){t.$set(t.information,"end",e)},expression:"information.end"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accrodionJobs"+t.indexItem:"#accrodionJobs"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accrodionJobs"+t.indexItem:"accrodionJobs"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.company?t.information.class.company:"",readonly:t.readonly,label:"Company:",labelStyle:!0===t.information.newItem?"color:red;":"",validate:{required:!0},id:""!==t.indexItem?"companyJob"+t.indexItem:"companyJob"+t.index,name:""!==t.indexItem?"companyJob"+t.indexItem:"companyJob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.company,fieldId:"company",type:"jobs",id:""!==t.indexItem?"companyJob"+t.indexItem:"companyJob"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"company",value:t.information.company,id:""!==t.indexItem?"companyJob"+t.indexItem:"companyJob"+t.index})}},model:{value:t.information.company,callback:function(e){t.$set(t.information,"company",e)},expression:"information.company"}})],1),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.phone?t.information.class.phone:"",readonly:t.readonly,label:"Phone:",id:""!==t.indexItem?"phoneJob"+t.indexItem:"phoneJob"+t.index,mask:"###-###-####",type:"tel",placeholder:"999-999-9999",labelStyle:!0===t.information.newItem?"color:red;":"",validate:{required:!0,min:10},name:""!==t.indexItem?"phoneJob"+t.indexItem:"phoneJob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.phone,fieldId:"phone",type:"jobs",id:""!==t.indexItem?"phoneJob"+t.indexItem:"phoneJob"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"phone",value:t.information.phone,id:""!==t.indexItem?"phoneJob"+t.indexItem:"phoneJob"+t.index})}},model:{value:t.information.phone,callback:function(e){t.$set(t.information,"phone",e)},expression:"information.phone"}})],1),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.street?t.information.class.street:"",readonly:t.readonly,label:"Street:",id:""!==t.indexItem?"streetJob"+t.indexItem:"streetJob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.street,fieldId:"street",type:"jobs",id:""!==t.indexItem?"streetJob"+t.indexItem:"streetJob"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"street",value:t.information.street,id:""!==t.indexItem?"streetJob"+t.indexItem:"streetJob"+t.index})}},model:{value:t.information.street,callback:function(e){t.$set(t.information,"street",e)},expression:"information.street"}})],1),t._v(" "),n("div",{staticClass:"col-md-3"},[n("div",{staticClass:"form-group"},[n("pf-radio",{attrs:{checked:"on"===t.information.aptCk,classElement:void 0===t.information.class?"":void 0!==t.information.class.aptCk?t.information.class.aptCk:"",readonly:t.readonly,label:"APT",id:""!==t.indexItem?"aptCk"+t.indexItem:"aptCk"+t.index,value:"apt",name:"inlineRadioOptions3"+t.indexItem,classComponent:"marginBotRem"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.aptCk,fieldId:"aptCk",type:"jobs",id:""!==t.indexItem?"aptCk"+t.indexItem:"aptCk"+t.index})},click:function(e){return t.changeRadio({type:"APT",id:""!==t.indexItem?"aptCk"+t.indexItem:"aptCk"+t.index,key:"isAptSteFlr",keyThree:"aptCk"})}}}),t._v(" "),n("pf-radio",{attrs:{checked:"on"===t.information.steCk,classElement:void 0===t.information.class?"":void 0!==t.information.class.steCk?t.information.class.steCk:"",readonly:t.readonly,label:"STE",id:""!==t.indexItem?"steCk"+t.indexItem:"steCk"+t.index,value:"ste",name:"inlineRadioOptions3"+t.indexItem,classComponent:"marginBotRem"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.steCk,fieldId:"steCk",type:"jobs",id:""!==t.indexItem?"steCk"+t.indexItem:"steCk"+t.index})},click:function(e){return t.changeRadio({type:"STE",id:""!==t.indexItem?"steCk"+t.indexItem:"steCk"+t.index,key:"isAptSteFlr",keyThree:"steCk"})}}}),t._v(" "),n("pf-radio",{attrs:{checked:"on"===t.information.floorCk,classElement:void 0===t.information.class?"":void 0!==t.information.class.floorCk?t.information.class.floorCk:"",readonly:t.readonly,label:"FLOOR",id:""!==t.indexItem?"floorCk"+t.indexItem:"floorCk"+t.index,value:"flr",name:"inlineRadioOptions3"+t.indexItem,classComponent:"marginBotRem"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.floorCk,fieldId:"floorCk",type:"jobs",id:""!==t.indexItem?"floorCk"+t.indexItem:"floorCk"+t.index})},click:function(e){return t.changeRadio({type:"FLR",id:""!==t.indexItem?"floorCk"+t.indexItem:"floorCk"+t.index,key:"isAptSteFlr",keyThree:"floorCk"})}}}),t._v(" "),n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.aptSteFlrNumbertxt?t.information.class.aptSteFlrNumbertxt:"",readonly:t.readonly,id:""!==t.indexItem?"aptSteFlrNumbertxtJob"+t.indexItem:"aptSteFlrNumbertxtJob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.aptSteFlrNumbertxt,fieldId:"aptSteFlrNumbertxt",type:"jobs",id:""!==t.indexItem?"aptSteFlrNumbertxtJob"+t.indexItem:"aptSteFlrNumbertxtJob"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"aptSteFlrNumbertxt",value:t.information.aptSteFlrNumbertxt,id:""!==t.indexItem?"aptSteFlrNumbertxtJob"+t.indexItem:"aptSteFlrNumbertxtJob"+t.index})}},model:{value:t.information.aptSteFlrNumbertxt,callback:function(e){t.$set(t.information,"aptSteFlrNumbertxt",e)},expression:"information.aptSteFlrNumbertxt"}})],1)])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.city?t.information.class.city:"",readonly:t.readonly,label:"City:",id:""!==t.indexItem?"cityJob"+t.indexItem:"cityJob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.city,fieldId:"city",type:"jobs",id:""!==t.indexItem?"cityJob"+t.indexItem:"cityJob"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"city",value:t.information.city,id:""!==t.indexItem?"cityJob"+t.indexItem:"cityJob"+t.index})}},model:{value:t.information.city,callback:function(e){t.$set(t.information,"city",e)},expression:"information.city"}})],1),t._v(" "),n("div",{staticClass:"col-md-3 col-lg-3"},[n("pf-input",{attrs:{mask:"AA",classElement:void 0===t.information.class?"":void 0!==t.information.class.state?t.information.class.state:"",readonly:t.readonly,label:"State (xx):",id:""!==t.indexItem?"stateJob"+t.indexItem:"stateJob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.state,fieldId:"state",type:"jobs",id:""!==t.indexItem?"stateJob"+t.indexItem:"stateJob"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"state",value:t.information.state,id:""!==t.indexItem?"stateJob"+t.indexItem:"stateJob"+t.index})}},model:{value:t.information.state,callback:function(e){t.$set(t.information,"state",e)},expression:"information.state"}})],1),t._v(" "),n("div",{staticClass:"col-md-3 col-lg-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.zip?t.information.class.zip:"",readonly:t.readonly,label:"Zip Code:",id:""!==t.indexItem?"zipJob"+t.indexItem:"zipJob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.zip,fieldId:"zip",type:"jobs",id:""!==t.indexItem?"zipJob"+t.indexItem:"zipJob"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"zip",value:t.information.zip,id:""!==t.indexItem?"zipJob"+t.indexItem:"zipJob"+t.index})}},model:{value:t.information.zip,callback:function(e){t.$set(t.information,"zip",e)},expression:"information.zip"}})],1),t._v(" "),n("div",{staticClass:"col-md-3 col-lg-3"},[n("pf-select",{attrs:{field:"country",id:""!==t.indexItem?"countryJob"+t.indexItem:"countryJob"+t.index,model:"jobs",label:"Country:",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.country?"Select Country":t.information.country,options:t.countries},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.country,fieldId:"country",type:"jobs",id:""!==t.indexItem?"countryJob"+t.indexItem:"countryJob"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.province?t.information.class.province:"",readonly:t.readonly,label:"Province:",id:""!==t.indexItem?"provinceJob"+t.indexItem:"provinceJob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.province,fieldId:"province",type:"jobs",id:""!==t.indexItem?"provinceJob"+t.indexItem:"provinceJob"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"province",value:t.information.province,id:""!==t.indexItem?"provinceJob"+t.indexItem:"provinceJob"+t.index})}},model:{value:t.information.province,callback:function(e){t.$set(t.information,"province",e)},expression:"information.province"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.postalCode?t.information.class.postalCode:"",readonly:t.readonly,label:"Postal Code:",id:""!==t.indexItem?"postalCodeJob"+t.indexItem:"postalCodeJob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.postalCode,fieldId:"postalCode",type:"jobs",id:""!==t.indexItem?"postalCodeJob"+t.indexItem:"postalCodeJob"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"postalCode",value:t.information.postalCode,id:""!==t.indexItem?"postalCodeJob"+t.indexItem:"postalCodeJob"+t.index})}},model:{value:t.information.postalCode,callback:function(e){t.$set(t.information,"postalCode",e)},expression:"information.postalCode"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.title?t.information.class.title:"",readonly:t.readonly,label:"Title:",id:""!==t.indexItem?"title"+t.indexItem:"title"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.title,fieldId:"title",type:"jobs",id:""!==t.indexItem?"title"+t.indexItem:"title"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"title",value:t.information.title,id:""!==t.indexItem?"title"+t.indexItem:"title"+t.index})}},model:{value:t.information.title,callback:function(e){t.$set(t.information,"title",e)},expression:"information.title"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.supervisor?t.information.class.supervisor:"",readonly:t.readonly,label:"Supervisor:",id:""!==t.indexItem?"supervisor"+t.indexItem:"supervisor"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.supervisor,fieldId:"supervisor",type:"jobs",id:""!==t.indexItem?"supervisor"+t.indexItem:"supervisor"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"supervisor",value:t.information.supervisor,id:""!==t.indexItem?"supervisor"+t.indexItem:"supervisor"+t.index})}},model:{value:t.information.supervisor,callback:function(e){t.$set(t.information,"supervisor",e)},expression:"information.supervisor"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.duties?t.information.class.duties:"",readonly:t.readonly,label:"Duties:",id:""!==t.indexItem?"duties"+t.indexItem:"duties"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.duties,fieldId:"duties",type:"jobs",id:""!==t.indexItem?"duties"+t.indexItem:"duties"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"duties",value:t.information.duties,id:""!==t.indexItem?"duties"+t.indexItem:"duties"+t.index})}},model:{value:t.information.duties,callback:function(e){t.$set(t.information,"duties",e)},expression:"information.duties"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.typeOfBusiness?t.information.class.typeOfBusiness:"",readonly:t.readonly,label:"Type of Business:",id:""!==t.indexItem?"typeOfBusiness"+t.indexItem:"typeOfBusiness"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.typeOfBusiness,fieldId:"typeOfBusiness",type:"jobs",id:""!==t.indexItem?"typeOfBusiness"+t.indexItem:"typeOfBusiness"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"typeOfBusiness",value:t.information.typeOfBusiness,id:""!==t.indexItem?"typeOfBusiness"+t.indexItem:"typeOfBusiness"+t.index})}},model:{value:t.information.typeOfBusiness,callback:function(e){t.$set(t.information,"typeOfBusiness",e)},expression:"information.typeOfBusiness"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(2)]),t._v(" "),n("div",{staticClass:"col-md-6 col-lg-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.moneyWeek?t.information.class.moneyWeek:"",readonly:t.readonly,label:"Salary / Week:",type:"number",id:""!==t.indexItem?"moneyWeek"+t.indexItem:"moneyWeek"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.moneyWeek,fieldId:"moneyWeek",type:"jobs",id:""!==t.indexItem?"moneyWeek"+t.indexItem:"moneyWeek"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"moneyWeek",value:t.information.moneyWeek,id:""!==t.indexItem?"moneyWeek"+t.indexItem:"moneyWeek"+t.index})}},model:{value:t.information.moneyWeek,callback:function(e){t.$set(t.information,"moneyWeek",e)},expression:"information.moneyWeek"}})],1),t._v(" "),n("div",{staticClass:"col-md-6 col-lg-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.moneyMonth?t.information.class.moneyMonth:"",readonly:t.readonly,label:"Salary / Month:",type:"number",id:""!==t.indexItem?"moneyMonth"+t.indexItem:"moneyMonth"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.moneyMonth,fieldId:"moneyMonth",type:"jobs",id:""!==t.indexItem?"moneyMonth"+t.indexItem:"moneyMonth"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"moneyMonth",value:t.information.moneyMonth,id:""!==t.indexItem?"moneyMonth"+t.indexItem:"moneyMonth"+t.index})}},model:{value:t.information.moneyMonth,callback:function(e){t.$set(t.information,"moneyMonth",e)},expression:"information.moneyMonth"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 col-lg-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.moneyYear?t.information.class.moneyYear:"",readonly:t.readonly,label:"Salary / Year:",type:"number",id:""!==t.indexItem?"moneyYear"+t.indexItem:"moneyYear"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.moneyYear,fieldId:"moneyYear",type:"jobs",id:""!==t.indexItem?"moneyYear"+t.indexItem:"moneyYear"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"moneyYear",value:t.information.moneyYear,id:""!==t.indexItem?"moneyYear"+t.indexItem:"moneyYear"+t.index})}},model:{value:t.information.moneyYear,callback:function(e){t.$set(t.information,"moneyYear",e)},expression:"information.moneyYear"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 col-lg-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.hoursWorkedPerWeek?t.information.class.hoursWorkedPerWeek:"",readonly:t.readonly,label:"Hours Worked Per Week:",id:""!==t.indexItem?"hoursWorkedPerWeek"+t.indexItem:"hoursWorkedPerWeek"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.hoursWorkedPerWeek,fieldId:"hoursWorkedPerWeek",type:"jobs",id:""!==t.indexItem?"hoursWorkedPerWeek"+t.indexItem:"hoursWorkedPerWeek"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"hoursWorkedPerWeek",value:t.information.hoursWorkedPerWeek,id:""!==t.indexItem?"hoursWorkedPerWeek"+t.indexItem:"hoursWorkedPerWeek"+t.index})}},model:{value:t.information.hoursWorkedPerWeek,callback:function(e){t.$set(t.information,"hoursWorkedPerWeek",e)},expression:"information.hoursWorkedPerWeek"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 col-lg-8"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.details?t.information.class.details:"",readonly:t.readonly,label:"Details:",name:"details",id:""!==t.indexItem?"details"+t.indexItem:"details"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.details,fieldId:"details",type:"jobs",id:""!==t.indexItem?"details"+t.indexItem:"details"+t.index})},change:function(e){return t.updateModel({model:"jobs",field:"details",value:t.information.details,id:""!==t.indexItem?"details"+t.indexItem:"details"+t.index})}},model:{value:t.information.details,callback:function(e){t.$set(t.information,"details",e)},expression:"information.details"}})],1)])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("jobForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this job item?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteJob}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. Company Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. Job Details")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("4. Income and Additional Details")])])}]};var Dr=n("VU/8")(Er,Ir,!1,function(t){n("z3Uu"),n("U1k/"),n("y4y1")},"data-v-8bc96722",null).exports,Sr={name:"pf-jobs",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfJob:Dr,PfButton:d},created:function(){var t=this;this.type="itemJob",void 0===this.list&&-1!==this.contactId?this.apiService.getJobs({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listJobs&&(t.listRemote=e.listJobs),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"jobs"})}}},Nr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-job",{key:i,attrs:{information:e,id:"itemJob"+i,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-job":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemJobAdd"+t.questionnaireid:"itemJobAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var Mr=n("VU/8")(Sr,Nr,!1,function(t){n("qwRx")},"data-v-0fbe5777",null).exports,Or={name:"pf-educational",data:function(){return{isShow:!1,messageAccordion:"Show more..."}},mixins:[ht],components:{PfRadio:P,PfSelect:k,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this educational history?"},methods:{deleteEducational:function(){this.deleteItem({model:"educationalHistory",item:"delete-educational"}),this.isPopUp=!1},changeCalendarEducational:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateEducational(t.id)}},changeRadio:function(t){var e=this;this.information.isAptSteFlr=t.type;var n=this.information;Y()(this.radioGroups).forEach(function(i){-1!==e.radioGroups[i].indexOf(t.keyThree)&&e.radioGroups[i].forEach(function(i){i!==t.keyThree?(n[i]="off",!0===e.comparing&&(n.threeValues[i].manual="off")):(n[i]="on",!0===e.comparing&&(n.threeValues[i].manual="on"))})}),this.information={},this.information=n,this.updateModel({model:"educationalHistory",field:t.key,value:t.type,id:t.id})},updateEducational:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editEducational(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.educationalHistoryEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},Tr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("educational")},mouseleave:function(e){return t.removeHover("educational")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"educationalForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"educational"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Dates":"School Name and Dates"))])])]),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.schoolName?t.information.class.schoolName:"",readonly:t.readonly,label:"Institution Name:",labelStyle:!0===t.information.newItem?"color:red;":"",validate:{required:!0},id:""!==t.indexItem?"schoolNamep-hide"+t.indexItem:"schoolNamep-hide"+t.index,name:""!==t.indexItem?"schoolNamep-hide"+t.indexItem:"schoolNamep-hide"+t.index},on:{change:function(e){return t.updateModel({model:"educationalHistory",field:"schoolName",value:t.information.schoolName,id:""!==t.indexItem?"schoolNamep-hide"+t.indexItem:"schoolNamep-hide"+t.index})}},model:{value:t.information.schoolName,callback:function(e){t.$set(t.information,"schoolName",e)},expression:"information.schoolName"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.begin?t.information.class.begin:"",readonly:t.readonly,label:"Begin Date:",id:""!==t.indexItem?"begin-edu"+t.indexItem:"begin-edu"+t.index,mask:"##/##/####",model:"educationalHistory",field:"begin"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.begin,fieldId:"begin",type:"educationalHistory",id:""!==t.indexItem?"input-begin-edu"+t.indexItem:"input-begin-edu"+t.index})},change:t.changeCalendar},model:{value:t.information.begin,callback:function(e){t.$set(t.information,"begin",e)},expression:"information.begin"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.end?t.information.class.end:"",readonly:t.readonly,label:"End Date:",id:""!==t.indexItem?"end-edu"+t.indexItem:"end-edu"+t.index,mask:"##/##/####",divCalendar:"marginBotZero",model:"educationalHistory",field:"end"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.end,fieldId:"end",type:"educationalHistory",id:""!==t.indexItem?"input-end-edu"+t.indexItem:"input-end-edu"+t.index})},change:t.changeCalendar},model:{value:t.information.end,callback:function(e){t.$set(t.information,"end",e)},expression:"information.end"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionEducational"+t.indexItem:"#accordionEducational"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionEducational"+t.indexItem:"accordionEducational"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.schoolName?t.information.class.schoolName:"",readonly:t.readonly,label:"Institution Name:",labelStyle:!0===t.information.newItem?"color:red;":"",validate:{required:!0},id:""!==t.indexItem?"schoolName"+t.indexItem:"schoolName"+t.index,name:""!==t.indexItem?"schoolName"+t.indexItem:"schoolName"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.schoolName,fieldId:"schoolName",type:"educationalHistory",id:""!==t.indexItem?"schoolName"+t.indexItem:"schoolName"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"schoolName",value:t.information.schoolName,id:""!==t.indexItem?"schoolName"+t.indexItem:"schoolName"+t.index})}},model:{value:t.information.schoolName,callback:function(e){t.$set(t.information,"schoolName",e)},expression:"information.schoolName"}})],1),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.graduation?t.information.class.graduation:"",readonly:t.readonly,label:"Graduation Date:",id:""!==t.indexItem?"graduation-"+t.indexItem:"graduation-"+t.index,mask:"##/##/####",model:"educationalHistory",field:"graduation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.graduation,fieldId:"graduation",type:"educationalHistory",id:""!==t.indexItem?"input-graduation-"+t.indexItem:"input-graduation-"+t.index})},change:t.changeCalendar},model:{value:t.information.graduation,callback:function(e){t.$set(t.information,"graduation",e)},expression:"information.graduation"}})],1),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.degree?t.information.class.degree:"",readonly:t.readonly,label:"Degree:",id:""!==t.indexItem?"degree"+t.indexItem:"degree"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.degree,fieldId:"degree",type:"educationalHistory",id:""!==t.indexItem?"degree"+t.indexItem:"degree"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"degree",value:t.information.degree,id:""!==t.indexItem?"degree"+t.indexItem:"degree"+t.index})}},model:{value:t.information.degree,callback:function(e){t.$set(t.information,"degree",e)},expression:"information.degree"}})],1),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.level?t.information.class.level:"",readonly:t.readonly,label:"Level:",id:""!==t.indexItem?"level"+t.indexItem:"level"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.level,fieldId:"level",type:"educationalHistory",id:""!==t.indexItem?"level"+t.indexItem:"level"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"level",value:t.information.level,id:""!==t.indexItem?"level"+t.indexItem:"level"+t.index})}},model:{value:t.information.level,callback:function(e){t.$set(t.information,"level",e)},expression:"information.level"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.phone?t.information.class.phone:"",readonly:t.readonly,mask:"###-###-####",type:"tel",placeholder:"999-999-9999",label:"Phone:",id:""!==t.indexItem?"phoneEdu"+t.indexItem:"phoneEdu"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.phone,fieldId:"phone",type:"educationalHistory",id:""!==t.indexItem?"phoneEdu"+t.indexItem:"phoneEdu"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"phone",value:t.information.phone,id:""!==t.indexItem?"phoneEdu"+t.indexItem:"phoneEdu"+t.index})}},model:{value:t.information.phone,callback:function(e){t.$set(t.information,"phone",e)},expression:"information.phone"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.street?t.information.class.street:"",readonly:t.readonly,label:"Street Address:",id:""!==t.indexItem?"streetEdu"+t.indexItem:"streetEdu"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.street,fieldId:"street",type:"educationalHistory",id:""!==t.indexItem?"streetEdu"+t.indexItem:"streetEdu"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"street",value:t.information.street,id:""!==t.indexItem?"streetEdu"+t.indexItem:"streetEdu"+t.index})}},model:{value:t.information.street,callback:function(e){t.$set(t.information,"street",e)},expression:"information.street"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.aptCk?t.information.class.aptCk:"",checked:"on"===t.information.aptCk,readonly:t.readonly,label:"APT",id:""!==t.indexItem?"aptCkEdu"+t.indexItem:"aptCkEdu"+t.index,value:"apt",name:"inlineRadioOptionsEdu"+t.indexItem,classComponent:"marginBotRem"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.aptCk,fieldId:"aptCk",type:"educationalHistory",id:""!==t.indexItem?"aptCkEdu"+t.indexItem:"aptCkEdu"+t.index})},click:function(e){return t.changeRadio({type:"APT",id:""!==t.indexItem?"aptCkEdu"+t.indexItem:"aptCkEdu"+t.index,key:"isAptSteFlr",keyThree:"aptCk"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.steCk?t.information.class.steCk:"",checked:"on"===t.information.steCk,readonly:t.readonly,label:"STE",id:""!==t.indexItem?"steCkEdu"+t.indexItem:"steCkEdu"+t.index,value:"ste",name:"inlineRadioOptionsEdu"+t.indexItem,classComponent:"marginBotRem"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.steCk,fieldId:"steCk",type:"educationalHistory",id:""!==t.indexItem?"steCkEdu"+t.indexItem:"steCkEdu"+t.index})},click:function(e){return t.changeRadio({type:"STE",id:""!==t.indexItem?"steCkEdu"+t.indexItem:"steCkEdu"+t.index,key:"isAptSteFlr",keyThree:"steCk"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.floorCk?t.information.class.floorCk:"",checked:"on"===t.information.floorCk,readonly:t.readonly,label:"FLOOR",id:""!==t.indexItem?"floorCkEdu"+t.indexItem:"floorCkEdu"+t.index,value:"flr",name:"inlineRadioOptionsEdu"+t.indexItem,classComponent:"marginBotRem"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.floorCk,fieldId:"floorCk",type:"educationalHistory",id:""!==t.indexItem?"floorCkEdu"+t.indexItem:"floorCkEdu"+t.index})},click:function(e){return t.changeRadio({type:"FLR",id:""!==t.indexItem?"floorCkEdu"+t.indexItem:"floorCkEdu"+t.index,key:"isAptSteFlr",keyThree:"floorCk"})}}}),t._v(" "),n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.aptSteFlrNumbertxt?t.information.class.aptSteFlrNumbertxt:"",readonly:t.readonly,id:""!==t.indexItem?"aptSteFlrNumbertxtEdu"+t.indexItem:"aptSteFlrNumbertxtEdu"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.aptSteFlrNumbertxt,fieldId:"aptSteFlrNumbertxt",type:"educationalHistory",id:""!==t.indexItem?"aptSteFlrNumbertxtEdu"+t.indexItem:"aptSteFlrNumbertxtEdu"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"aptSteFlrNumbertxt",value:t.information.aptSteFlrNumbertxt,id:""!==t.indexItem?"aptSteFlrNumbertxtEdu"+t.indexItem:"aptSteFlrNumbertxtEdu"+t.index})}},model:{value:t.information.aptSteFlrNumbertxt,callback:function(e){t.$set(t.information,"aptSteFlrNumbertxt",e)},expression:"information.aptSteFlrNumbertxt"}})],1)])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.city?t.information.class.city:"",readonly:t.readonly,label:"City:",id:""!==t.indexItem?"cityEdu"+t.indexItem:"cityEdu"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.city,fieldId:"city",type:"educationalHistory",id:""!==t.indexItem?"cityEdu"+t.indexItem:"cityEdu"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"city",value:t.information.city,id:""!==t.indexItem?"cityEdu"+t.indexItem:"cityEdu"+t.index})}},model:{value:t.information.city,callback:function(e){t.$set(t.information,"city",e)},expression:"information.city"}})],1),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.state?t.information.class.state:"",readonly:t.readonly,label:"State:",id:""!==t.indexItem?"stateEdu"+t.indexItem:"stateEdu"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.state,fieldId:"state",type:"educationalHistory",id:""!==t.indexItem?"stateEdu"+t.indexItem:"stateEdu"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"state",value:t.information.state,id:""!==t.indexItem?"stateEdu"+t.indexItem:"stateEdu"+t.index})}},model:{value:t.information.state,callback:function(e){t.$set(t.information,"state",e)},expression:"information.state"}})],1),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.zip?t.information.class.zip:"",readonly:t.readonly,label:"ZIP Code:",id:""!==t.indexItem?"zipEdu"+t.indexItem:"zipEdu"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.zip,fieldId:"zip",type:"educationalHistory",id:""!==t.indexItem?"zipEdu"+t.indexItem:"zipEdu"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"zip",value:t.information.zip,id:""!==t.indexItem?"zipEdu"+t.indexItem:"zipEdu"+t.index})}},model:{value:t.information.zip,callback:function(e){t.$set(t.information,"zip",e)},expression:"information.zip"}})],1),t._v(" "),n("div",{staticClass:"col-md-3"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.country?t.information.class.country:"",readonly:t.readonly,label:"Country:",id:""!==t.indexItem?"countryEdu"+t.indexItem:"countryEdu"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.country,fieldId:"country",type:"educationalHistory",id:""!==t.indexItem?"countryEdu"+t.indexItem:"countryEdu"+t.index})},change:function(e){return t.updateModel({model:"educationalHistory",field:"country",value:t.information.country,id:""!==t.indexItem?"countryEdu"+t.indexItem:"countryEdu"+t.index})}},model:{value:t.information.country,callback:function(e){t.$set(t.information,"country",e)},expression:"information.country"}})],1),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("educationalForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this educational item?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteEducational}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. School Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. School Contact Information")])])}]};var Lr=n("VU/8")(Or,Tr,!1,function(t){n("kwTz"),n("xXfZ"),n("9kVg")},"data-v-26fd3c9c",null).exports,jr={name:"pf-educational-history",props:{questionnaireid:{type:String}},components:{PfEducational:Lr,PfButton:d},mixins:[Lt],created:function(){var t=this;this.type="itemEducational",void 0===this.list&&-1!==this.contactId?this.apiService.getEducational({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listEducational&&(t.listRemote=e.listEducational),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"educationalHistory"})}}},Pr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-educational",{key:i,attrs:{id:"itemEducational"+i,information:e,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-educational":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemEducationalAdd"+t.questionnaireid:"itemEducationalAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var Fr=n("VU/8")(jr,Pr,!1,function(t){n("wS5y")},"data-v-0f74189f",null).exports,Yr={name:"pf-crime",data:function(){return{isShow:!1,messageAccordion:"Show more..."}},mixins:[ht],components:{PfCheckbox:x,PfSelect:k,PfTextArea:T,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this crime?"},methods:{deleteCrime:function(){this.deleteItem({model:"criminalHistory",item:"delete-crime"}),this.isPopUp=!1},changeCheckbox:function(t){this.information[t.key]=t.type,this.updateModel({model:"criminalHistory",field:t.key,value:t.type,id:t.id})},changeCalendarCrime:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateCriminal(t.id)}},setClassOfCrime:function(t){this.information.classOfCrime=t,this.updateCriminal(""!==this.indexItem?"classOfCrime"+this.indexItem:"classOfCrime"+this.index)},setResult:function(t){this.information.result=t,this.updateCriminal(""!==this.indexItem?"result"+this.indexItem:"result"+this.index)},updateCriminal:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editCriminal(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.criminalHistoryEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},Rr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("criminal")},mouseleave:function(e){return t.removeHover("criminal")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"criminalForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"criminal"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",{staticClass:"mrTextSpace"},[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Dates":"Statutory Name of Conviction and Dates"))])])]),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{id:""!==t.indexItem?"statutoryNameOfConvictionp"+t.indexItem:"statutoryNameOfConvictionp"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.statutoryNameOfConviction?t.information.class.statutoryNameOfConviction:"",readonly:t.readonly,label:"Statutory Name of Conviction:"},on:{change:function(e){return t.updateModel({model:"criminalHistory",field:"statutoryNameOfConviction",value:t.information.statutoryNameOfConviction,id:""!==t.indexItem?"statutoryNameOfConvictionp"+t.indexItem:"statutoryNameOfConvictionp"+t.index})}},model:{value:t.information.statutoryNameOfConviction,callback:function(e){t.$set(t.information,"statutoryNameOfConviction",e)},expression:"information.statutoryNameOfConviction"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateOfArrest?t.information.class.dateOfArrest:"",readonly:t.readonly,label:"Date of Arrest:",id:void 0!==t.index?"dateOfArrest-"+t.index:"dateOfArrest-"+t.indexItem,mask:"##/##/####",labelStyle:!0===t.information.newItem?"color:red;":"",name:void 0!==t.index?"input-dateOfArrest-"+t.index:"input-dateOfArrest-"+t.indexItem,validate:"required",model:"criminalHistory",field:"dateOfArrest"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.dateOfArrest,fieldId:"dateOfArrest",type:"criminalHistory",id:void 0!==t.index?"input-dateOfArrest-"+t.index:"input-dateOfArrest-"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.dateOfArrest,callback:function(e){t.$set(t.information,"dateOfArrest",e)},expression:"information.dateOfArrest"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateOfConvinction?t.information.class.dateOfConvinction:"",readonly:t.readonly,label:"Date of Conviction:",id:void 0!==t.index?"dateOfConvinction-"+t.index:"dateOfConvinction-"+t.indexItem,mask:"##/##/####",divCalendar:"marginBotZero",model:"criminalHistory",field:"dateOfConvinction"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.dateOfConvinction,fieldId:"dateOfConvinction",type:"criminalHistory",id:void 0!==t.index?"input-dateOfConvinction-"+t.index:"input-dateOfConvinction-"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.dateOfConvinction,callback:function(e){t.$set(t.information,"dateOfConvinction",e)},expression:"information.dateOfConvinction"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionCriminal"+t.indexItem:"#accordionCriminal"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionCriminal"+t.indexItem:"accordionCriminal"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"districtCourtName"+t.indexItem:"districtCourtName"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.districtCourtName?t.information.class.districtCourtName:"",readonly:t.readonly,label:"District Court Name:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.districtCourtName,fieldId:"districtCourtName",type:"criminalHistory",id:""!==t.indexItem?"districtCourtName"+t.indexItem:"districtCourtName"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"districtCourtName",value:t.information.districtCourtName,id:""!==t.indexItem?"districtCourtName"+t.indexItem:"districtCourtName"+t.index})}},model:{value:t.information.districtCourtName,callback:function(e){t.$set(t.information,"districtCourtName",e)},expression:"information.districtCourtName"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"courtOfConviction"+t.indexItem:"courtOfConviction"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.courtOfConviction?t.information.class.courtOfConviction:"",readonly:t.readonly,label:"Court of Conviction:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.courtOfConviction,fieldId:"courtOfConviction",type:"criminalHistory",id:""!==t.indexItem?"courtOfConviction"+t.indexItem:"courtOfConviction"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"courtOfConviction",value:t.information.courtOfConviction,id:""!==t.indexItem?"courtOfConviction"+t.indexItem:"courtOfConviction"+t.index})}},model:{value:t.information.courtOfConviction,callback:function(e){t.$set(t.information,"courtOfConviction",e)},expression:"information.courtOfConviction"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"courtOfConvictionAddress"+t.indexItem:"courtOfConvictionAddress"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.courtOfConvictionAddress?t.information.class.courtOfConvictionAddress:"",readonly:t.readonly,label:"Court of Conviction Address:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.courtOfConvictionAddress,fieldId:"courtOfConvictionAddress",type:"criminalHistory",id:""!==t.indexItem?"courtOfConvictionAddress"+t.indexItem:"courtOfConvictionAddress"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"courtOfConvictionAddress",value:t.information.courtOfConvictionAddress,id:""!==t.indexItem?"courtOfConvictionAddress"+t.indexItem:"courtOfConvictionAddress"+t.index})}},model:{value:t.information.courtOfConvictionAddress,callback:function(e){t.$set(t.information,"courtOfConvictionAddress",e)},expression:"information.courtOfConvictionAddress"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"courtOfConvictionPhone"+t.indexItem:"courtOfConvictionPhone"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.courtOfConvictionPhone?t.information.class.courtOfConvictionPhone:"",readonly:t.readonly,label:"Court of Conviction Phone:",mask:"(###) ###-####",placeholder:"(999) 999-9999"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.courtOfConvictionPhone,fieldId:"courtOfConvictionPhone",type:"criminalHistory",id:""!==t.indexItem?"courtOfConvictionPhone"+t.indexItem:"courtOfConvictionPhone"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"courtOfConvictionPhone",value:t.information.courtOfConvictionPhone,id:""!==t.indexItem?"courtOfConvictionPhone"+t.indexItem:"courtOfConvictionPhone"+t.index})}},model:{value:t.information.courtOfConvictionPhone,callback:function(e){t.$set(t.information,"courtOfConvictionPhone",e)},expression:"information.courtOfConvictionPhone"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"courtOfConvictionFax"+t.indexItem:"courtOfConvictionFax"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.courtOfConvictionFax?t.information.class.courtOfConvictionFax:"",readonly:t.readonly,label:"Court of Conviction Fax:",mask:"(###) ###-####",placeholder:"(999) 999-9999"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.courtOfConvictionFax,fieldId:"courtOfConvictionFax",type:"criminalHistory",id:""!==t.indexItem?"courtOfConvictionFax"+t.indexItem:"courtOfConvictionFax"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"courtOfConvictionFax",value:t.information.courtOfConvictionFax,id:""!==t.indexItem?"courtOfConvictionFax"+t.indexItem:"courtOfConvictionFax"+t.index})}},model:{value:t.information.courtOfConvictionFax,callback:function(e){t.$set(t.information,"courtOfConvictionFax",e)},expression:"information.courtOfConvictionFax"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"courtOfConvictionEmail"+t.indexItem:"courtOfConvictionEmail"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.courtOfConvictionEmail?t.information.class.courtOfConvictionEmail:"",readonly:t.readonly,label:"Court of Conviction Email:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.courtOfConvictionEmail,fieldId:"courtOfConvictionEmail",type:"criminalHistory",id:""!==t.indexItem?"courtOfConvictionEmail"+t.indexItem:"courtOfConvictionEmail"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"courtOfConvictionEmail",value:t.information.courtOfConvictionEmail,id:""!==t.indexItem?"courtOfConvictionEmail"+t.indexItem:"courtOfConvictionEmail"+t.index})}},model:{value:t.information.courtOfConvictionEmail,callback:function(e){t.$set(t.information,"courtOfConvictionEmail",e)},expression:"information.courtOfConvictionEmail"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"statutoryNameOfConviction"+t.indexItem:"statutoryNameOfConviction"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.statutoryNameOfConviction?t.information.class.statutoryNameOfConviction:"",readonly:t.readonly,label:"Statutory Name of Conviction:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.statutoryNameOfConviction,fieldId:"statutoryNameOfConviction",type:"criminalHistory",id:""!==t.indexItem?"statutoryNameOfConviction"+t.indexItem:"statutoryNameOfConviction"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"statutoryNameOfConviction",value:t.information.statutoryNameOfConviction,id:""!==t.indexItem?"statutoryNameOfConviction"+t.indexItem:"statutoryNameOfConviction"+t.index})}},model:{value:t.information.statutoryNameOfConviction,callback:function(e){t.$set(t.information,"statutoryNameOfConviction",e)},expression:"information.statutoryNameOfConviction"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"statutoryCitationOfConviction"+t.indexItem:"statutoryCitationOfConviction"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.statutoryCitationOfConviction?t.information.class.statutoryCitationOfConviction:"",readonly:t.readonly,label:"Statutory Citation of Conviction:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.statutoryCitationOfConviction,fieldId:"statutoryCitationOfConviction",type:"criminalHistory",id:""!==t.indexItem?"statutoryCitationOfConviction"+t.indexItem:"statutoryCitationOfConviction"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"statutoryCitationOfConviction",value:t.information.statutoryCitationOfConviction,id:""!==t.indexItem?"statutoryCitationOfConviction"+t.indexItem:"statutoryCitationOfConviction"+t.index})}},model:{value:t.information.statutoryCitationOfConviction,callback:function(e){t.$set(t.information,"statutoryCitationOfConviction",e)},expression:"information.statutoryCitationOfConviction"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"padillaWarningsReceivedAndDocumented"+t.indexItem:"padillaWarningsReceivedAndDocumented"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.padillaWarningsReceivedAndDocumented?t.information.class.padillaWarningsReceivedAndDocumented:"",readonly:t.readonly,label:"Court Case Number:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.padillaWarningsReceivedAndDocumented,fieldId:"padillaWarningsReceivedAndDocumented",type:"criminalHistory",id:""!==t.indexItem?"padillaWarningsReceivedAndDocumented"+t.indexItem:"padillaWarningsReceivedAndDocumented"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"padillaWarningsReceivedAndDocumented",value:t.information.padillaWarningsReceivedAndDocumented,id:""!==t.indexItem?"padillaWarningsReceivedAndDocumented"+t.indexItem:"padillaWarningsReceivedAndDocumented"+t.index})}},model:{value:t.information.padillaWarningsReceivedAndDocumented,callback:function(e){t.$set(t.information,"padillaWarningsReceivedAndDocumented",e)},expression:"information.padillaWarningsReceivedAndDocumented"}})],1),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-select",{attrs:{field:"classOfCrime",id:""!==t.indexItem?"classOfCrime"+t.indexItem:"classOfCrime"+t.index,model:"criminalHistory",classElement:void 0===t.information.class?"":void 0!==t.information.class.classOfCrime?t.information.class.classOfCrime:"",disabled:t.readonly,label:"Class of Crime:",options:[{name:"Misdemeanor",value:"Misdemeanor",selected:void 0!==this.information&&"Misdemeanor"===this.information.classOfCrime},{name:"Civil Infraciton",value:"Civil Infraciton",selected:void 0!==this.information&&"Civil Infraciton"===this.information.classOfCrime},{name:"Other",value:"Other",selected:void 0!==this.information&&"Other"===this.information.classOfCrime},{name:"Felony",value:"Felony",selected:void 0!==this.information&&"Felony"===this.information.classOfCrime}]},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.classOfCrime,fieldId:"classOfCrime",type:"criminalHistory",id:""!==t.indexItem?"classOfCrime"+t.indexItem:"classOfCrime"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(2)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.crimeOfMoralTurpitude?t.information.class.crimeOfMoralTurpitude:"",checked:"on"===t.information.crimeOfMoralTurpitude,readonly:t.readonly,label:"Crime of Moral Turpitude",id:void 0!==t.index?"crimeOfMoralTurpitude"+t.index:"crimeOfMoralTurpitude"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.crimeOfMoralTurpitude,fieldId:"crimeOfMoralTurpitude",type:"criminalHistory",id:void 0!==t.index?"crimeOfMoralTurpitude"+t.index:"crimeOfMoralTurpitude"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.crimeOfMoralTurpitude?"off":"on",id:void 0!==t.index?"crimeOfMoralTurpitude"+t.index:"crimeOfMoralTurpitude"+t.indexItem,key:"crimeOfMoralTurpitude"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"crimeOfMoralTurpitudeExplanation"+t.indexItem:"crimeOfMoralTurpitudeExplanation"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.crimeOfMoralTurpitudeExplanation?t.information.class.crimeOfMoralTurpitudeExplanation:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.crimeOfMoralTurpitudeExplanation,fieldId:"crimeOfMoralTurpitudeExplanation",type:"criminalHistory",id:""!==t.indexItem?"crimeOfMoralTurpitudeExplanation"+t.indexItem:"crimeOfMoralTurpitudeExplanation"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"crimeOfMoralTurpitudeExplanation",value:t.information.crimeOfMoralTurpitudeExplanation,id:""!==t.indexItem?"crimeOfMoralTurpitudeExplanation"+t.indexItem:"crimeOfMoralTurpitudeExplanation"+t.index})}},model:{value:t.information.crimeOfMoralTurpitudeExplanation,callback:function(e){t.$set(t.information,"crimeOfMoralTurpitudeExplanation",e)},expression:"information.crimeOfMoralTurpitudeExplanation"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.aggravatedFelony?t.information.class.aggravatedFelony:"",checked:"on"===t.information.aggravatedFelony,readonly:t.readonly,label:"Aggravated Felony",id:void 0!==t.index?"aggravatedFelony"+t.index:"aggravatedFelony"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.aggravatedFelony,fieldId:"aggravatedFelony",type:"criminalHistory",id:void 0!==t.index?"aggravatedFelony"+t.index:"aggravatedFelony"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.aggravatedFelony?"off":"on",id:void 0!==t.index?"aggravatedFelony"+t.index:"aggravatedFelony"+t.indexItem,key:"aggravatedFelony"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"aggravatedFelonyExplanation"+t.indexItem:"aggravatedFelonyExplanation"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.aggravatedFelonyExplanation?t.information.class.aggravatedFelonyExplanation:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.aggravatedFelonyExplanation,fieldId:"aggravatedFelonyExplanation",type:"criminalHistory",id:""!==t.indexItem?"aggravatedFelonyExplanation"+t.indexItem:"aggravatedFelonyExplanation"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"aggravatedFelonyExplanation",value:t.information.aggravatedFelonyExplanation,id:""!==t.indexItem?"aggravatedFelonyExplanation"+t.indexItem:"aggravatedFelonyExplanation"+t.index})}},model:{value:t.information.aggravatedFelonyExplanation,callback:function(e){t.$set(t.information,"aggravatedFelonyExplanation",e)},expression:"information.aggravatedFelonyExplanation"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.controlledSubstanceCrime?t.information.class.controlledSubstanceCrime:"",checked:"on"===t.information.controlledSubstanceCrime,readonly:t.readonly,label:"Controlled Substance Crime",id:void 0!==t.index?"controlledSubstanceCrime"+t.index:"controlledSubstanceCrime"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.controlledSubstanceCrime,fieldId:"controlledSubstanceCrime",type:"criminalHistory",id:void 0!==t.index?"controlledSubstanceCrime"+t.index:"controlledSubstanceCrime"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.controlledSubstanceCrime?"off":"on",id:void 0!==t.index?"controlledSubstanceCrime"+t.index:"controlledSubstanceCrime"+t.indexItem,key:"controlledSubstanceCrime"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"controlledSubstanceCrimeExplanation"+t.indexItem:"controlledSubstanceCrimeExplanation"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.controlledSubstanceCrimeExplanation?t.information.class.controlledSubstanceCrimeExplanation:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.controlledSubstanceCrimeExplanation,fieldId:"controlledSubstanceCrimeExplanation",type:"criminalHistory",id:""!==t.indexItem?"controlledSubstanceCrimeExplanation"+t.indexItem:"controlledSubstanceCrimeExplanation"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"controlledSubstanceCrimeExplanation",value:t.information.controlledSubstanceCrimeExplanation,id:""!==t.indexItem?"controlledSubstanceCrimeExplanation"+t.indexItem:"controlledSubstanceCrimeExplanation"+t.index})}},model:{value:t.information.controlledSubstanceCrimeExplanation,callback:function(e){t.$set(t.information,"controlledSubstanceCrimeExplanation",e)},expression:"information.controlledSubstanceCrimeExplanation"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.crimeOfDomesticViolence?t.information.class.crimeOfDomesticViolence:"",checked:"on"===t.information.crimeOfDomesticViolence,readonly:t.readonly,label:"Crime of Domestic Violence",id:void 0!==t.index?"crimeOfDomesticViolence"+t.index:"crimeOfDomesticViolence"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.crimeOfDomesticViolence,fieldId:"crimeOfDomesticViolence",type:"criminalHistory",id:void 0!==t.index?"crimeOfDomesticViolence"+t.index:"crimeOfDomesticViolence"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.crimeOfDomesticViolence?"off":"on",id:void 0!==t.index?"crimeOfDomesticViolence"+t.index:"crimeOfDomesticViolence"+t.indexItem,key:"crimeOfDomesticViolence"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"crimeOfDomesticViolenceExplanation"+t.indexItem:"crimeOfDomesticViolenceExplanation"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.crimeOfDomesticViolenceExplanation?t.information.class.crimeOfDomesticViolenceExplanation:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.crimeOfDomesticViolenceExplanation,fieldId:"crimeOfDomesticViolenceExplanation",type:"criminalHistory",id:""!==t.indexItem?"crimeOfDomesticViolenceExplanation"+t.indexItem:"crimeOfDomesticViolenceExplanation"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"crimeOfDomesticViolenceExplanation",value:t.information.crimeOfDomesticViolenceExplanation,id:""!==t.indexItem?"crimeOfDomesticViolenceExplanation"+t.indexItem:"crimeOfDomesticViolenceExplanation"+t.index})}},model:{value:t.information.crimeOfDomesticViolenceExplanation,callback:function(e){t.$set(t.information,"crimeOfDomesticViolenceExplanation",e)},expression:"information.crimeOfDomesticViolenceExplanation"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.violationOfPersonalProtectionOrder?t.information.class.violationOfPersonalProtectionOrder:"",checked:"on"===t.information.violationOfPersonalProtectionOrder,readonly:t.readonly,label:"Violation of Personal Protection Order",id:void 0!==t.index?"violationOfPersonalProtectionOrder"+t.index:"violationOfPersonalProtectionOrder"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.violationOfPersonalProtectionOrder,fieldId:"violationOfPersonalProtectionOrder",type:"criminalHistory",id:void 0!==t.index?"violationOfPersonalProtectionOrder"+t.index:"violationOfPersonalProtectionOrder"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.violationOfPersonalProtectionOrder?"off":"on",id:void 0!==t.index?"violationOfPersonalProtectionOrder"+t.index:"violationOfPersonalProtectionOrder"+t.indexItem,key:"violationOfPersonalProtectionOrder"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"violationOfPersonalProtectionOrderExplanation"+t.indexItem:"violationOfPersonalProtectionOrderExplanation"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.violationOfPersonalProtectionOrderExplanation?t.information.class.violationOfPersonalProtectionOrderExplanation:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.violationOfPersonalProtectionOrderExplanation,fieldId:"violationOfPersonalProtectionOrderExplanation",type:"criminalHistory",id:""!==t.indexItem?"violationOfPersonalProtectionOrderExplanation"+t.indexItem:"violationOfPersonalProtectionOrderExplanation"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"violationOfPersonalProtectionOrderExplanation",value:t.information.violationOfPersonalProtectionOrderExplanation,id:""!==t.indexItem?"violationOfPersonalProtectionOrderExplanation"+t.indexItem:"violationOfPersonalProtectionOrderExplanation"+t.index})}},model:{value:t.information.violationOfPersonalProtectionOrderExplanation,callback:function(e){t.$set(t.information,"violationOfPersonalProtectionOrderExplanation",e)},expression:"information.violationOfPersonalProtectionOrderExplanation"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-text-area",{attrs:{label:"Other Immigration Consequences",classLabel:"marginBotZero",id:""!==t.indexItem?"otherImmigrationConsequences"+t.indexItem:"otherImmigrationConsequences"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.otherImmigrationConsequences?t.information.class.otherImmigrationConsequences:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.otherImmigrationConsequences,fieldId:"otherImmigrationConsequences",type:"criminalHistory",id:""!==t.indexItem?"otherImmigrationConsequences"+t.indexItem:"otherImmigrationConsequences"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"otherImmigrationConsequences",value:t.information.otherImmigrationConsequences,id:""!==t.indexItem?"otherImmigrationConsequences"+t.indexItem:"otherImmigrationConsequences"+t.index})}},model:{value:t.information.otherImmigrationConsequences,callback:function(e){t.$set(t.information,"otherImmigrationConsequences",e)},expression:"information.otherImmigrationConsequences"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"possibleWaiver"+t.indexItem:"possibleWaiver"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.possibleWaiver?t.information.class.possibleWaiver:"",readonly:t.readonly,label:"Possible Waiver:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.possibleWaiver,fieldId:"possibleWaiver",type:"criminalHistory",id:""!==t.indexItem?"possibleWaiver"+t.indexItem:"possibleWaiver"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"possibleWaiver",value:t.information.possibleWaiver,id:""!==t.indexItem?"possibleWaiver"+t.indexItem:"possibleWaiver"+t.index})}},model:{value:t.information.possibleWaiver,callback:function(e){t.$set(t.information,"possibleWaiver",e)},expression:"information.possibleWaiver"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 ImmigrationConsiderationsPT"},[n("div",{staticClass:"form-group"},[n("div",{staticClass:"checkbox ImmigrationConsiderationsMB"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.removableOffense?t.information.class.removableOffense:"",checked:"on"===t.information.removableOffense,readonly:t.readonly,label:"Removable Offense",classComponent:"marginBotZero",id:void 0!==t.index?"removableOffense"+t.index:"removableOffense"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.removableOffense,fieldId:"removableOffense",type:"criminalHistory",id:void 0!==t.index?"removableOffense"+t.index:"removableOffense"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.removableOffense?"off":"on",id:void 0!==t.index?"removableOffense"+t.index:"removableOffense"+t.indexItem,key:"removableOffense"})}}})],1),t._v(" "),n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.inadmissibleOffense?t.information.class.inadmissibleOffense:"",checked:"on"===t.information.inadmissibleOffense,readonly:t.readonly,label:"Inadmissible Offense",classComponent:"marginBotZero",id:void 0!==t.index?"inadmissibleOffense"+t.index:"inadmissibleOffense"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.inadmissibleOffense,fieldId:"inadmissibleOffense",type:"criminalHistory",id:void 0!==t.index?"inadmissibleOffense"+t.index:"inadmissibleOffense"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.inadmissibleOffense?"off":"on",id:void 0!==t.index?"inadmissibleOffense"+t.index:"inadmissibleOffense"+t.indexItem,key:"inadmissibleOffense"})}}})],1)])])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(3)]),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-select",{attrs:{field:"result",id:""!==t.indexItem?"result"+t.indexItem:"result"+t.index,model:"criminalHistory",classElement:void 0===t.information.class?"":void 0!==t.information.class.result?t.information.class.result:"",disabled:t.readonly,label:"Result:",options:[{name:"No Contest Plea",value:"No Contest Plea",selected:void 0!==this.information&&"No Contest Plea"===this.information.result},{name:"COnviction after Trial",value:"COnviction after Trial",selected:void 0!==this.information&&"COnviction after Trial"===this.information.result},{name:"Not-Guilty After Trial",value:"Not-Guilty After Trial",selected:void 0!==this.information&&"Not-Guilty After Trial"===this.information.result},{name:"Dismissed (Nolle Pros)",value:"Dismissed (Nolle Pros)",selected:void 0!==this.information&&"Dismissed (Nolle Pros)"===this.information.result},{name:"Guilty Plea",value:"Guilty Plea",selected:void 0!==this.information&&"Guilty Plea"===this.information.result}]},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.result,fieldId:"result",type:"criminalHistory",id:""!==t.indexItem?"result"+t.indexItem:"result"+t.index})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsProbation?t.information.class.sentenceTermsProbation:"",checked:"on"===t.information.sentenceTermsProbation,readonly:t.readonly,label:"Sentence Terms: Probation",id:void 0!==t.index?"sentenceTermsProbation"+t.index:"sentenceTermsProbation"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsProbation,fieldId:"sentenceTermsProbation",type:"criminalHistory",id:void 0!==t.index?"sentenceTermsProbation"+t.index:"sentenceTermsProbation"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.sentenceTermsProbation?"off":"on",id:void 0!==t.index?"sentenceTermsProbation"+t.index:"sentenceTermsProbation"+t.indexItem,key:"sentenceTermsProbation"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"sentenceTermsProbationDetails"+t.indexItem:"sentenceTermsProbationDetails"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsProbationDetails?t.information.class.sentenceTermsProbationDetails:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsProbationDetails,fieldId:"sentenceTermsProbationDetails",type:"criminalHistory",id:""!==t.indexItem?"sentenceTermsProbationDetails"+t.indexItem:"sentenceTermsProbationDetails"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"sentenceTermsProbationDetails",value:t.information.sentenceTermsProbationDetails,id:""!==t.indexItem?"sentenceTermsProbationDetails"+t.indexItem:"sentenceTermsProbationDetails"+t.index})}},model:{value:t.information.sentenceTermsProbationDetails,callback:function(e){t.$set(t.information,"sentenceTermsProbationDetails",e)},expression:"information.sentenceTermsProbationDetails"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsFines?t.information.class.sentenceTermsFines:"",checked:"on"===t.information.sentenceTermsFines,readonly:t.readonly,label:"Sentence Terms: Fines",id:void 0!==t.index?"sentenceTermsFines"+t.index:"sentenceTermsFines"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsFines,fieldId:"sentenceTermsFines",type:"criminalHistory",id:void 0!==t.index?"sentenceTermsFines"+t.index:"sentenceTermsFines"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.sentenceTermsFines?"off":"on",id:void 0!==t.index?"sentenceTermsFines"+t.index:"sentenceTermsFines"+t.indexItem,key:"sentenceTermsFines"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"sentenceTermsFinesDetails"+t.indexItem:"sentenceTermsFinesDetails"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsFinesDetails?t.information.class.sentenceTermsFinesDetails:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsFinesDetails,fieldId:"sentenceTermsFinesDetails",type:"criminalHistory",id:""!==t.indexItem?"sentenceTermsFinesDetails"+t.indexItem:"sentenceTermsFinesDetails"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"sentenceTermsFinesDetails",value:t.information.sentenceTermsFinesDetails,id:""!==t.indexItem?"sentenceTermsFinesDetails"+t.indexItem:"sentenceTermsFinesDetails"+t.index})}},model:{value:t.information.sentenceTermsFinesDetails,callback:function(e){t.$set(t.information,"sentenceTermsFinesDetails",e)},expression:"information.sentenceTermsFinesDetails"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsCosts?t.information.class.sentenceTermsCosts:"",checked:"on"===t.information.sentenceTermsCosts,readonly:t.readonly,label:"Sentence Terms: Costs",id:void 0!==t.index?"sentenceTermsCosts"+t.index:"sentenceTermsCosts"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsCosts,fieldId:"sentenceTermsCosts",type:"criminalHistory",id:void 0!==t.index?"sentenceTermsCosts"+t.index:"sentenceTermsCosts"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.sentenceTermsCosts?"off":"on",id:void 0!==t.index?"sentenceTermsCosts"+t.index:"sentenceTermsCosts"+t.indexItem,key:"sentenceTermsCosts"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"sentenceTermsCostsDetails"+t.indexItem:"sentenceTermsCostsDetails"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsCostsDetails?t.information.class.sentenceTermsCostsDetails:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsCostsDetails,fieldId:"sentenceTermsCostsDetails",type:"criminalHistory",id:""!==t.indexItem?"sentenceTermsCostsDetails"+t.indexItem:"sentenceTermsCostsDetails"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"sentenceTermsCostsDetails",value:t.information.sentenceTermsCostsDetails,id:""!==t.indexItem?"sentenceTermsCostsDetails"+t.indexItem:"sentenceTermsCostsDetails"+t.index})}},model:{value:t.information.sentenceTermsCostsDetails,callback:function(e){t.$set(t.information,"sentenceTermsCostsDetails",e)},expression:"information.sentenceTermsCostsDetails"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsJailPrison?t.information.class.sentenceTermsJailPrison:"",checked:"on"===t.information.sentenceTermsJailPrison,readonly:t.readonly,label:"Sentence Terms: Jail/Prison",id:void 0!==t.index?"sentenceTermsJailPrison"+t.index:"sentenceTermsJailPrison"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsJailPrison,fieldId:"sentenceTermsJailPrison",type:"criminalHistory",id:void 0!==t.index?"sentenceTermsJailPrison"+t.index:"sentenceTermsJailPrison"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.sentenceTermsJailPrison?"off":"on",id:void 0!==t.index?"sentenceTermsJailPrison"+t.index:"sentenceTermsJailPrison"+t.indexItem,key:"sentenceTermsJailPrison"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"sentenceTermsJailPrisonDetails"+t.indexItem:"sentenceTermsJailPrisonDetails"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsJailPrisonDetails?t.information.class.sentenceTermsJailPrisonDetails:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsJailPrisonDetails,fieldId:"sentenceTermsJailPrisonDetails",type:"criminalHistory",id:""!==t.indexItem?"sentenceTermsJailPrisonDetails"+t.indexItem:"sentenceTermsJailPrisonDetails"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"sentenceTermsJailPrisonDetails",value:t.information.sentenceTermsJailPrisonDetails,id:""!==t.indexItem?"sentenceTermsJailPrisonDetails"+t.indexItem:"sentenceTermsJailPrisonDetails"+t.index})}},model:{value:t.information.sentenceTermsJailPrisonDetails,callback:function(e){t.$set(t.information,"sentenceTermsJailPrisonDetails",e)},expression:"information.sentenceTermsJailPrisonDetails"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsOther?t.information.class.sentenceTermsOther:"",checked:"on"===t.information.sentenceTermsOther,readonly:t.readonly,label:"Sentence Terms: Other",id:void 0!==t.index?"sentenceTermsOther"+t.index:"sentenceTermsOther"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsOther,fieldId:"sentenceTermsOther",type:"criminalHistory",id:void 0!==t.index?"sentenceTermsOther"+t.index:"sentenceTermsOther"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.sentenceTermsOther?"off":"on",id:void 0!==t.index?"sentenceTermsOther"+t.index:"sentenceTermsOther"+t.indexItem,key:"sentenceTermsOther"})}}})],1),t._v(" "),n("pf-text-area",{attrs:{id:""!==t.indexItem?"sentenceTermsOtherDetails"+t.indexItem:"sentenceTermsOtherDetails"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.sentenceTermsOtherDetails?t.information.class.sentenceTermsOtherDetails:"",readonly:t.readonly,placeholder:"Explanation"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sentenceTermsOtherDetails,fieldId:"sentenceTermsOtherDetails",type:"criminalHistory",id:""!==t.indexItem?"sentenceTermsOtherDetails"+t.indexItem:"sentenceTermsOtherDetails"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"sentenceTermsOtherDetails",value:t.information.sentenceTermsOtherDetails,id:""!==t.indexItem?"sentenceTermsOtherDetails"+t.indexItem:"sentenceTermsOtherDetails"+t.index})}},model:{value:t.information.sentenceTermsOtherDetails,callback:function(e){t.$set(t.information,"sentenceTermsOtherDetails",e)},expression:"information.sentenceTermsOtherDetails"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(4)]),t._v(" "),n("div",{staticClass:"col-md-12"},[n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.representedByAttorney?t.information.class.representedByAttorney:"",checked:"on"===t.information.representedByAttorney,readonly:t.readonly,label:"Represented by Attorney",classComponent:"marginBotZero",id:void 0!==t.index?"representedByAttorney"+t.index:"representedByAttorney"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.representedByAttorney,fieldId:"representedByAttorney",type:"criminalHistory",id:void 0!==t.index?"representedByAttorney"+t.index:"representedByAttorney"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.representedByAttorney?"off":"on",id:void 0!==t.index?"representedByAttorney"+t.index:"representedByAttorney"+t.indexItem,key:"representedByAttorney"})}}})],1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"attorneyName"+t.indexItem:"attorneyName"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.attorneyName?t.information.class.attorneyName:"",readonly:t.readonly,label:"Attorney Name:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.attorneyName,fieldId:"attorneyName",type:"criminalHistory",id:""!==t.indexItem?"attorneyName"+t.indexItem:"attorneyName"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"attorneyName",value:t.information.attorneyName,id:""!==t.indexItem?"attorneyName"+t.indexItem:"attorneyName"+t.index})}},model:{value:t.information.attorneyName,callback:function(e){t.$set(t.information,"attorneyName",e)},expression:"information.attorneyName"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"attorneyAddress"+t.indexItem:"attorneyAddress"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.attorneyAddress?t.information.class.attorneyAddress:"",readonly:t.readonly,label:"Attorney Address:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.attorneyAddress,fieldId:"attorneyAddress",type:"criminalHistory",id:""!==t.indexItem?"attorneyAddress"+t.indexItem:"attorneyAddress"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"attorneyAddress",value:t.information.attorneyAddress,id:""!==t.indexItem?"attorneyAddress"+t.indexItem:"attorneyAddress"+t.index})}},model:{value:t.information.attorneyAddress,callback:function(e){t.$set(t.information,"attorneyAddress",e)},expression:"information.attorneyAddress"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{mask:"(###) ###-####",placeholder:"(999) 999-9999",id:""!==t.indexItem?"attorneyPhone"+t.indexItem:"attorneyPhone"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.attorneyPhone?t.information.class.attorneyPhone:"",readonly:t.readonly,label:"Attorney Phone:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.attorneyPhone,fieldId:"attorneyPhone",type:"criminalHistory",id:""!==t.indexItem?"attorneyPhone"+t.indexItem:"attorneyPhone"+t.index})},change:function(e){return t.updateModel({model:"criminalHistory",field:"attorneyPhone",value:t.information.attorneyPhone,id:""!==t.indexItem?"attorneyPhone"+t.indexItem:"attorneyPhone"+t.index})}},model:{value:t.information.attorneyPhone,callback:function(e){t.$set(t.information,"attorneyPhone",e)},expression:"information.attorneyPhone"}})],1),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("criminalForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this crime?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteCrime}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. Court Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. Charge Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("4. Immigration Considerations")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("5. Result of Charges")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("6. Representing Attorney")])])}]};var Hr=n("VU/8")(Yr,Rr,!1,function(t){n("DH7i"),n("+5O3"),n("mO9U")},"data-v-31d7a0b6",null).exports,$r={name:"pf-criminal-history",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfCrime:Hr,PfButton:d},created:function(){var t=this;this.type="itemCriminal",void 0===this.list&&-1!==this.contactId?this.apiService.getCriminal({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listCriminal&&(t.listRemote=e.listCriminal),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"criminalHistory"})}}},zr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-crime",{key:i,attrs:{information:e,id:"itemCriminal"+i,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-crime":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemCriminalAdd"+t.questionnaireid:"itemCriminalAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var Xr=n("VU/8")($r,zr,!1,function(t){n("EcXd")},"data-v-a5c7b376",null).exports,Vr={name:"pf-ead",data:function(){return{isShow:!1,messageAccordion:"Show more..."}},mixins:[ht],components:{PfTextArea:T,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this EAD?"},methods:{deleteEad:function(){this.deleteItem({model:"ead",item:"delete-ead"}),this.isPopUp=!1},changeCalendarEad:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateEad(t.id)}},updateEad:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editEad(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.EADEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},qr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("ead")},mouseleave:function(e){return t.removeHover("ead")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"eadsForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"ead"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Name":"Name and Expiration Date"))])])]),t._v(" "),n("div",{class:!0===t.isShow?"col-md-6":"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.surname?t.information.class.surname:"",readonly:t.readonly,label:"Last Name as it appears on the work permit:",labelStyle:!0===t.information.newItem?"color:red;":"",validate:{required:!0},id:""!==t.indexItem?"surname"+t.indexItem:"surname"+t.index,name:""!==t.indexItem?"surname"+t.indexItem:"surname"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.surname,fieldId:"surname",type:"ead",id:""!==t.indexItem?"surname"+t.indexItem:"surname"+t.index})},change:function(e){return t.updateModel({model:"ead",field:"surname",value:t.information.surname,id:""!==t.indexItem?"surname"+t.indexItem:"surname"+t.index})}},model:{value:t.information.surname,callback:function(e){t.$set(t.information,"surname",e)},expression:"information.surname"}})],1),t._v(" "),n("div",{staticClass:"spaceShowMore",class:!0===t.isShow?"col-md-6":"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"givenname"+t.indexItem:"givenname"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.givenname?t.information.class.givenname:"",readonly:t.readonly,label:"First Name (GIven Name) as it appears on the work permit:",divInput:"marginBotZero"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.givenname,fieldId:"givenname",type:"ead",id:""!==t.indexItem?"givenname"+t.indexItem:"givenname"+t.index})},change:function(e){return t.updateModel({model:"ead",field:"givenname",value:t.information.givenname,id:""!==t.indexItem?"givenname"+t.indexItem:"givenname"+t.index})}},model:{value:t.information.givenname,callback:function(e){t.$set(t.information,"givenname",e)},expression:"information.givenname"}})],1),t._v(" "),n("div",{class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.exp?t.information.class.exp:"",readonly:t.readonly,label:"Please enter the expiration date listed on the card:",id:void 0!==t.index?"exp-ead"+t.index:"exp-ead"+t.indexItem,mask:"##/##/####",model:"ead",field:"exp"},on:{change:t.changeCalendar},model:{value:t.information.exp,callback:function(e){t.$set(t.information,"exp",e)},expression:"information.exp"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionEad"+t.indexItem:"#accordionEad"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionEad"+t.indexItem:"accordionEad"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"anum"+t.indexItem:"anum"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.anum?t.information.class.anum:"",readonly:t.readonly,label:"Please enter the USCIS number (Alien Number) shown on the work permit."},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.anum,fieldId:"anum",type:"ead",id:""!==t.indexItem?"anum"+t.indexItem:"anum"+t.index})},change:function(e){return t.updateModel({model:"ead",field:"anum",value:t.information.anum,id:""!==t.indexItem?"anum"+t.indexItem:"anum"+t.index})}},model:{value:t.information.anum,callback:function(e){t.$set(t.information,"anum",e)},expression:"information.anum"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"cat"+t.indexItem:"cat"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.cat?t.information.class.cat:"",readonly:t.readonly,label:"Please enter the category displayed on the work permit:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.cat,fieldId:"cat",type:"ead",id:""!==t.indexItem?"cat"+t.indexItem:"cat"+t.index})},change:function(e){return t.updateModel({model:"ead",field:"cat",value:t.information.cat,id:""!==t.indexItem?"cat"+t.indexItem:"cat"+t.index})}},model:{value:t.information.cat,callback:function(e){t.$set(t.information,"cat",e)},expression:"information.cat"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"cardnum"+t.indexItem:"cardnum"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.cardnum?t.information.class.cardnum:"",readonly:t.readonly,label:"Please enter the card number displayed on the work permit:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.cardnum,fieldId:"cardnum",type:"ead",id:""!==t.indexItem?"cardnum"+t.indexItem:"cardnum"+t.index})},change:function(e){return t.updateModel({model:"ead",field:"cardnum",value:t.information.cardnum,id:""!==t.indexItem?"cardnum"+t.indexItem:"cardnum"+t.index})}},model:{value:t.information.cardnum,callback:function(e){t.$set(t.information,"cardnum",e)},expression:"information.cardnum"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"cbirth"+t.indexItem:"cbirth"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.cbirth?t.information.class.cbirth:"",readonly:t.readonly,label:"Please enter the country of birth displayed on the card:"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.cbirth,fieldId:"cbirth",type:"ead",id:""!==t.indexItem?"cbirth"+t.indexItem:"cbirth"+t.index})},change:function(e){return t.updateModel({model:"ead",field:"cbirth",value:t.information.cbirth,id:""!==t.indexItem?"cbirth"+t.indexItem:"cbirth"+t.index})}},model:{value:t.information.cbirth,callback:function(e){t.$set(t.information,"cbirth",e)},expression:"information.cbirth"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dob?t.information.class.dob:"",readonly:t.readonly,label:"Please enter the date of birth displayed on the card:",id:void 0!==t.index?"dob-ead"+t.index:"dob-ead"+t.indexItem,mask:"##/##/####",model:"ead",field:"dob"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.dob,fieldId:"dob",type:"ead",id:void 0!==t.index?"input-dob-ead"+t.index:"input-dob-ead"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.dob,callback:function(e){t.$set(t.information,"dob",e)},expression:"information.dob"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(2)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.valid?t.information.class.valid:"",readonly:t.readonly,label:"Please enter the 'Valid From' date displayed on the card:",id:void 0!==t.index?"valid-ead"+t.index:"valid-ead"+t.indexItem,mask:"##/##/####",model:"ead",field:"valid"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.valid,fieldId:"valid",type:"ead",id:void 0!==t.index?"input-valid-ead"+t.index:"input-valid-ead"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.valid,callback:function(e){t.$set(t.information,"valid",e)},expression:"information.valid"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.exp?t.information.class.exp:"",readonly:t.readonly,label:"Please enter the expiration date listed on the card:",id:void 0!==t.index?"expp2-ead"+t.index:"expp2-ead"+t.indexItem,mask:"##/##/####",model:"ead",field:"exp"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.exp,fieldId:"exp",type:"ead",id:void 0!==t.index?"input-expp2-ead"+t.index:"input-expp2-ead"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.exp,callback:function(e){t.$set(t.information,"exp",e)},expression:"information.exp"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(3)]),t._v(" "),n("div",{staticClass:"col-md-5"},[n("pf-input",{attrs:{id:""!==t.indexItem?"tc"+t.indexItem:"tc"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.tc?t.information.class.tc:"",readonly:t.readonly,label:"Were there any other terms and conditions listed on this permit?"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.tc,fieldId:"tc",type:"ead",id:""!==t.indexItem?"tc"+t.indexItem:"tc"+t.index})},change:function(e){return t.updateModel({model:"ead",field:"tc",value:t.information.tc,id:""!==t.indexItem?"tc"+t.indexItem:"tc"+t.index})}},model:{value:t.information.tc,callback:function(e){t.$set(t.information,"tc",e)},expression:"information.tc"}})],1),t._v(" "),n("div",{staticClass:"col-md-7"},[n("pf-input",{attrs:{id:""!==t.indexItem?"travel"+t.indexItem:"travel"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.travel?t.information.class.travel:"",readonly:t.readonly,label:"Does this work permit indicate that travel is authorized?  If so please list details here?"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.travel,fieldId:"travel",type:"ead",id:""!==t.indexItem?"travel"+t.indexItem:"travel"+t.index})},change:function(e){return t.updateModel({model:"ead",field:"travel",value:t.information.travel,id:""!==t.indexItem?"travel"+t.indexItem:"travel"+t.index})}},model:{value:t.information.travel,callback:function(e){t.$set(t.information,"travel",e)},expression:"information.travel"}})],1),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-text-area",{attrs:{id:""!==t.indexItem?"notes"+t.indexItem:"notes"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.notes?t.information.class.notes:"",readonly:t.readonly,label:"This work permit was granted in connection with which type of application or benefit?  For example: DACA, TPS, Adjustment of Status, Cuban Adjustment Act",rows:5,cols:30},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.notes,fieldId:"notes",type:"ead",id:""!==t.indexItem?"notes"+t.indexItem:"notes"+t.index})},change:function(e){return t.updateModel({model:"ead",field:"notes",value:t.information.notes,id:""!==t.indexItem?"notes"+t.indexItem:"notes"+t.index})}},model:{value:t.information.notes,callback:function(e){t.$set(t.information,"notes",e)},expression:"information.notes"}})],1),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("eadsForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this EAD?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteEad}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. USCIS Number and Category")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. Biographic Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("4. Validity Period")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("5. Additional Information")])])}]};var Wr=n("VU/8")(Vr,qr,!1,function(t){n("qUXl"),n("wNGv"),n("R90k")},"data-v-2b3201c5",null).exports,Ur={name:"pf-eads",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfEad:Wr,PfButton:d},created:function(){var t=this;this.type="itemEads",void 0===this.list&&-1!==this.contactId?this.apiService.getEad({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listEad&&(t.listRemote=e.listEad),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"ead"})}}},Gr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-ead",{key:i,attrs:{information:e,id:"itemEads"+i,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-ead":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemEadsAdd"+t.questionnaireid:"itemEadsAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var Zr=n("VU/8")(Ur,Gr,!1,function(t){n("OyyD")},null,null).exports,Jr={name:"pf-passport",data:function(){return{isShow:!1,messageAccordion:"Show more..."}},mixins:[ht],components:{PfTextArea:T,PfSelect:k,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this passport?"},methods:{deletePassport:function(){this.deleteItem({model:"passports",item:"delete-passport"}),this.isPopUp=!1},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},Qr={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("passport")},mouseleave:function(e){return t.removeHover("passport")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"passportForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"passport"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Name":"Country and Date of Issue"))])])]),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"":"d-none"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.givenname?t.information.class.givenname:"",readonly:t.readonly,label:"Given Name:",id:""!==t.indexItem?"givenname-passport"+t.indexItem:"givenname-passport"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.givenname,fieldId:"givenname",type:"passports",id:""!==t.indexItem?"givenname-passport"+t.indexItem:"givenname-passport"+t.index})},change:function(e){return t.updateModel({model:"passports",field:"givenname",value:t.information.givenname,id:""!==t.indexItem?"givenname-passport"+t.indexItem:"givenname-passport"+t.index})}},model:{value:t.information.givenname,callback:function(e){t.$set(t.information,"givenname",e)},expression:"information.givenname"}})],1),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"":"d-none"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lastname?t.information.class.lastname:"",readonly:t.readonly,label:"Last Name(s):",id:""!==t.indexItem?"lastname"+t.indexItem:"lastname"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.lastname,fieldId:"lastname",type:"passports",id:""!==t.indexItem?"lastname"+t.indexItem:"lastname"+t.index})},change:function(e){return t.updateModel({model:"passports",field:"lastname",value:t.information.lastname,id:""!==t.indexItem?"lastname"+t.indexItem:"lastname"+t.index})}},model:{value:t.information.lastname,callback:function(e){t.$set(t.information,"lastname",e)},expression:"information.lastname"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"":"d-none"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.marriedname?t.information.class.marriedname:"",readonly:t.readonly,label:"Married Last Name:",id:""!==t.indexItem?"marriedname"+t.indexItem:"marriedname"+t.index,divInput:"marginBotZero"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.marriedname,fieldId:"marriedname",type:"passports",id:""!==t.indexItem?"marriedname"+t.indexItem:"marriedname"+t.index})},change:function(e){return t.updateModel({model:"passports",field:"marriedname",value:t.information.marriedname,id:""!==t.indexItem?"marriedname"+t.indexItem:"marriedname"+t.index})}},model:{value:t.information.marriedname,callback:function(e){t.$set(t.information,"marriedname",e)},expression:"information.marriedname"}})],1),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.country?t.information.class.country:"",readonly:t.readonly,label:"Country:",id:""!==t.indexItem?"country-passportp"+t.indexItem:"country-passportp"+t.index},on:{change:function(e){return t.updateModel({model:"passports",field:"country",value:t.information.country,id:""!==t.indexItem?"country-passportp"+t.indexItem:"country-passportp"+t.index})}},model:{value:t.information.country,callback:function(e){t.$set(t.information,"country",e)},expression:"information.country"}})],1),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.doi?t.information.class.doi:"",readonly:t.readonly,label:"Date of Issue:",id:void 0!==t.index?"doi-p"+t.index:"doi-p"+t.indexItem,mask:"##/##/####",model:"passports",field:"doi"},on:{change:t.changeCalendar},model:{value:t.information.doi,callback:function(e){t.$set(t.information,"doi",e)},expression:"information.doi"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionPassport"+t.indexItem:"#accordionPassport"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionPassport"+t.indexItem:"accordionPassport"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.country?t.information.class.country:"",readonly:t.readonly,label:"Country:",id:""!==t.indexItem?"country-passport"+t.indexItem:"country-passport"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.country,fieldId:"country",type:"passports",id:""!==t.indexItem?"country-passport"+t.indexItem:"country-passport"+t.index})},change:function(e){return t.updateModel({model:"passports",field:"country",value:t.information.country,id:""!==t.indexItem?"country-passport"+t.indexItem:"country-passport"+t.index})}},model:{value:t.information.country,callback:function(e){t.$set(t.information,"country",e)},expression:"information.country"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.poi?t.information.class.poi:"",readonly:t.readonly,label:"Place of Issuance:",id:""!==t.indexItem?"poi"+t.indexItem:"poi"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.poi,fieldId:"poi",type:"passports",id:""!==t.indexItem?"poi"+t.indexItem:"poi"+t.index})},change:function(e){return t.updateModel({model:"passports",field:"poi",value:t.information.poi,id:""!==t.indexItem?"poi"+t.indexItem:"poi"+t.index})}},model:{value:t.information.poi,callback:function(e){t.$set(t.information,"poi",e)},expression:"information.poi"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.doi?t.information.class.doi:"",readonly:t.readonly,label:"Date of Issue:",id:void 0!==t.index?"doi-"+t.index:"doi-"+t.indexItem,mask:"##/##/####",model:"passports",field:"doi"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.doi,fieldId:"doi",type:"passports",id:void 0!==t.index?"input-doi-"+t.index:"input-doi-"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.doi,callback:function(e){t.$set(t.information,"doi",e)},expression:"information.doi"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.doe?t.information.class.doe:"",readonly:t.readonly,label:"Date of Expiration:",id:void 0!==t.index?"doe-"+t.index:"doe-"+t.indexItem,mask:"##/##/####",model:"passports",field:"doe"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.doe,fieldId:"doe",type:"passports",id:void 0!==t.index?"input-doe-"+t.index:"input-doe-"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.doe,callback:function(e){t.$set(t.information,"doe",e)},expression:"information.doe"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.ppn?t.information.class.ppn:"",readonly:t.readonly,label:"Passport Number:",labelStyle:!0===t.information.newItem?"color:red;":"",validate:{required:!0},name:""!==t.indexItem?"ppn"+t.indexItem:"ppn"+t.index,id:""!==t.indexItem?"ppn"+t.indexItem:"ppn"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.ppn,fieldId:"ppn",type:"passports",id:""!==t.indexItem?"ppn"+t.indexItem:"ppn"+t.index})},change:function(e){return t.updateModel({model:"passports",field:"ppn",value:t.information.ppn,id:""!==t.indexItem?"ppn"+t.indexItem:"ppn"+t.index})}},model:{value:t.information.ppn,callback:function(e){t.$set(t.information,"ppn",e)},expression:"information.ppn"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.natid?t.information.class.natid:"",readonly:t.readonly,label:"National ID:",id:""!==t.indexItem?"natid"+t.indexItem:"natid"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.natid,fieldId:"natid",type:"passports",id:""!==t.indexItem?"natid"+t.indexItem:"natid"+t.index})},change:function(e){return t.updateModel({model:"passports",field:"natid",value:t.information.natid,id:""!==t.indexItem?"natid"+t.indexItem:"natid"+t.index})}},model:{value:t.information.natid,callback:function(e){t.$set(t.information,"natid",e)},expression:"information.natid"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dob?t.information.class.dob:"",readonly:t.readonly,label:"Date of Birth:",id:void 0!==t.index?"dob-Passport"+t.index:"dob-Passport"+t.indexItem,mask:"##/##/####",model:"passports",field:"dob"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.dob,fieldId:"dob",type:"passports",id:void 0!==t.index?"input-dob-Passport"+t.index:"input-dob-Passport"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.dob,callback:function(e){t.$set(t.information,"dob",e)},expression:"information.dob"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-select",{attrs:{id:void 0!==t.index?"sexPassport"+t.index:"sexPassport"+t.indexItem,field:"sex",classElement:void 0===t.information.class?"":void 0!==t.information.class.sex?t.information.class.sex:"",model:"passports",label:"Sex:",options:[{name:"Female",value:"Female",selected:"Female"===t.information.sex},{name:"Male",value:"Male",selected:"Male"===t.information.sex},{name:"Other",value:"Other",selected:"Other"===t.information.sex}]},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sex,fieldId:"sex",type:"passports",id:void 0!==t.index?"sexPassport"+t.index:"sexPassport"+t.indexItem})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sob?t.information.class.sob:"",readonly:t.readonly,label:"State of Birth:",id:""!==t.indexItem?"sob"+t.indexItem:"sob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sob,fieldId:"sob",type:"passports",id:""!==t.indexItem?"sob"+t.indexItem:"sob"+t.index})},change:function(e){return t.updateModel({model:"passports",field:"sob",value:t.information.sob,id:""!==t.indexItem?"sob"+t.indexItem:"sob"+t.index})}},model:{value:t.information.sob,callback:function(e){t.$set(t.information,"sob",e)},expression:"information.sob"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.cob?t.information.class.cob:"",readonly:t.readonly,label:"Country of Birth:",id:""!==t.indexItem?"cob"+t.indexItem:"cob"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.cob,fieldId:"cob",type:"passports",id:""!==t.indexItem?"cob"+t.indexItem:"cob"+t.index})},change:function(e){return t.updateModel({model:"passports",field:"cob",value:t.information.cob,id:""!==t.indexItem?"cob"+t.indexItem:"cob"+t.index})}},model:{value:t.information.cob,callback:function(e){t.$set(t.information,"cob",e)},expression:"information.cob"}})],1),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("passportForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this passport item?"},on:{close:function(e){t.isPopUp=!1},action:t.deletePassport}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. Passport information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. Biographic information")])])}]};var Kr=n("VU/8")(Jr,Qr,!1,function(t){n("XH1H"),n("4Nho"),n("Pfub")},"data-v-488344bb",null).exports,ts={name:"pf-passports",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfPassport:Kr,PfButton:d},created:function(){var t=this;this.type="itemPassports",void 0===this.list&&-1!==this.contactId?this.apiService.getPassports({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listPassports&&(t.listRemote=e.listPassports),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"passports"})}}},es={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-passport",{key:i,attrs:{information:e,id:"itemPassports"+i,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-passport":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{class:"noFade",attrs:{label:"New",id:void 0!==t.questionnaireid?"itemPassportsAdd"+t.questionnaireid:"itemPassportsAdd",classButton:"btn-success btnnNew"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var ns=n("VU/8")(ts,es,!1,function(t){n("78S2")},"data-v-692ab74a",null).exports,is={name:"pf-travel",data:function(){return{isShow:!1,messageAccordion:"Show more..."}},mixins:[ht],components:{PfRadio:P,PfTextArea:T,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this travel?"},methods:{deleteTravel:function(){this.deleteItem({model:"travelHistory",item:"delete-travel"}),this.isPopUp=!1},changeCalendarTravel:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateTravel(t.id)}},changeRadio:function(t){var e=this;this.information[t.key]=t.type;var n=this.information;Y()(this.radioGroups).forEach(function(i){-1!==e.radioGroups[i].indexOf(t.keyThree)&&e.radioGroups[i].forEach(function(i){i!==t.keyThree?(n[i]="off",!0===e.comparing&&(n.threeValues[i].manual="off")):(n[i]="on",!0===e.comparing&&(n.threeValues[i].manual="on"))})}),this.information={},this.information=n,this.updateModel({model:"travelHistory",field:t.key,value:t.type,id:t.id})},updateTravel:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editTravelHistory(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.travelHistoryEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},as={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("travel")},mouseleave:function(e){return t.removeHover("travel")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"travelForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"travel"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Dates of Travel":"Countries and Dates of Travel"))])])]),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.countries?t.information.class.countries:"",readonly:t.readonly,label:"Countries:",id:""!==t.indexItem?"countriess"+t.indexItem:"countriess"+t.index},on:{change:function(e){return t.updateModel({model:"travelHistory",field:"countries",value:t.information.countries,id:""!==t.indexItem?"countriess"+t.indexItem:"countriess"+t.index})}},model:{value:t.information.countries,callback:function(e){t.$set(t.information,"countries",e)},expression:"information.countries"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.from?t.information.class.from:"",readonly:t.readonly,label:"From Date:",id:void 0!==t.index?"from-travel"+t.index:"from-travel"+t.indexItem,name:void 0!==t.index?"input-from-travel"+t.index:"input-from-travel"+t.indexItem,validate:"required",labelStyle:!0===t.information.newItem?"color:red;":"",mask:"##/##/####",model:"travelHistory",field:"from"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.from,fieldId:"from",type:"travelHistory",id:void 0!==t.index?"input-from-travel"+t.index:"input-from-travel"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.from,callback:function(e){t.$set(t.information,"from",e)},expression:"information.from"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.to?t.information.class.to:"",readonly:t.readonly,label:"To Date:",id:void 0!==t.index?"to-travel"+t.index:"to-travel"+t.indexItem,name:void 0!==t.index?"input-to-travel"+t.index:"input-to-travel"+t.indexItem,validate:"required",labelStyle:!0===t.information.newItem?"color:red;":"",mask:"##/##/####",divCalendar:"marginBotZero",model:"travelHistory",field:"to"},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.to,fieldId:"to",type:"travelHistory",id:void 0!==t.index?"input-to-travel"+t.index:"input-to-travel"+t.indexItem})},change:t.changeCalendar},model:{value:t.information.to,callback:function(e){t.$set(t.information,"to",e)},expression:"information.to"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionTravel"+t.indexItem:"#accordionTravel"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionTravel"+t.indexItem:"accordionTravel"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dur?t.information.class.dur:"",readonly:t.readonly,label:"Duration (Days):",id:""!==t.indexItem?"dur"+t.indexItem:"dur"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.dur,fieldId:"dur",type:"travelHistory",id:""!==t.indexItem?"dur"+t.indexItem:"dur"+t.index})},change:function(e){return t.updateModel({model:"travelHistory",field:"dur",value:t.information.dur,id:""!==t.indexItem?"dur"+t.indexItem:"dur"+t.index})}},model:{value:t.information.dur,callback:function(e){t.$set(t.information,"dur",e)},expression:"information.dur"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:"durationDayTravHis"}},[t._v("Did trip last 6 months or more?")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sixMy?t.information.class.sixMy:"",checked:"on"===t.information.sixMy,readonly:t.readonly,label:"Yes",name:"diptrip"+t.indexItem,value:"yes",id:""!==t.indexItem?"sixMy-travel"+t.indexItem:"sixMy-travel"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sixMy,fieldId:"sixMy",type:"travelHistory",id:""!==t.indexItem?"sixMy-travel"+t.indexItem:"sixMy-travel"+t.index})},click:function(e){return t.changeRadio({type:"yes",id:""!==t.indexItem?"sixMy-travel"+t.indexItem:"sixMy-travel"+t.index,key:"sixMyMn",keyThree:"sixMy"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sixMn?t.information.class.sixMn:"",checked:"on"===t.information.sixMn,readonly:t.readonly,label:"No",name:"diptrip"+t.indexItem,value:"no",id:""!==t.indexItem?"sixMn-travel"+t.indexItem:"sixMn-travel"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.sixMn,fieldId:"sixMn",type:"travelHistory",id:""!==t.indexItem?"sixMn-travel"+t.indexItem:"sixMn-travel"+t.index})},click:function(e){return t.changeRadio({type:"no",id:""!==t.indexItem?"sixMn-travel"+t.indexItem:"sixMn-travel"+t.index,key:"sixMyMn",keyThree:"sixMn"})}}})],1)])])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.countries?t.information.class.countries:"",readonly:t.readonly,label:"Countries:",id:""!==t.indexItem?"countries"+t.indexItem:"countries"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.countries,fieldId:"countries",type:"travelHistory",id:""!==t.indexItem?"countries"+t.indexItem:"countries"+t.index})},change:function(e){return t.updateModel({model:"travelHistory",field:"countries",value:t.information.countries,id:""!==t.indexItem?"countries"+t.indexItem:"countries"+t.index})}},model:{value:t.information.countries,callback:function(e){t.$set(t.information,"countries",e)},expression:"information.countries"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.purpose?t.information.class.purpose:"",readonly:t.readonly,label:"Purpose of travel:",id:""!==t.indexItem?"purpose"+t.indexItem:"purpose"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.purpose,fieldId:"purpose",type:"travelHistory",id:""!==t.indexItem?"purpose"+t.indexItem:"purpose"+t.index})},change:function(e){return t.updateModel({model:"travelHistory",field:"purpose",value:t.information.purpose,id:""!==t.indexItem?"purpose"+t.indexItem:"purpose"+t.index})}},model:{value:t.information.purpose,callback:function(e){t.$set(t.information,"purpose",e)},expression:"information.purpose"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.manner?t.information.class.manner:"",readonly:t.readonly,label:"Manner of Return:",id:""!==t.indexItem?"manner"+t.indexItem:"manner"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.manner,fieldId:"manner",type:"travelHistory",id:""!==t.indexItem?"manner"+t.indexItem:"manner"+t.index})},change:function(e){return t.updateModel({model:"travelHistory",field:"manner",value:t.information.manner,id:""!==t.indexItem?"manner"+t.indexItem:"manner"+t.index})}},model:{value:t.information.manner,callback:function(e){t.$set(t.information,"manner",e)},expression:"information.manner"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.destination?t.information.class.destination:"",readonly:t.readonly,label:"Destination:",id:""!==t.indexItem?"destination"+t.indexItem:"destination"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.destination,fieldId:"destination",type:"travelHistory",id:""!==t.indexItem?"destination"+t.indexItem:"destination"+t.index})},change:function(e){return t.updateModel({model:"travelHistory",field:"destination",value:t.information.destination,id:""!==t.indexItem?"destination"+t.indexItem:"destination"+t.index})}},model:{value:t.information.destination,callback:function(e){t.$set(t.information,"destination",e)},expression:"information.destination"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:"travelAuthoTravHis"}},[t._v("Travel with authorization?")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.authYes?t.information.class.authYes:"",checked:"on"===t.information.authYes,readonly:t.readonly,label:"Yes",name:"travelautho"+t.indexItem,value:"yes",id:""!==t.indexItem?"authYes-travel"+t.indexItem:"authYes-travel"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.authYes,fieldId:"authYes",type:"travelHistory",id:""!==t.indexItem?"authYes-travel"+t.indexItem:"authYes-travel"+t.index})},click:function(e){return t.changeRadio({type:"yes",id:""!==t.indexItem?"authYes-travel"+t.indexItem:"authYes-travel"+t.index,key:"authYesNo",keyThree:"authYes"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.authNo?t.information.class.authNo:"",checked:"on"===t.information.authNo,readonly:t.readonly,label:"No",name:"travelautho"+t.indexItem,value:"no",id:""!==t.indexItem?"authNo-travel"+t.indexItem:"authNo-travel"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.authNo,fieldId:"authNo",type:"travelHistory",id:""!==t.indexItem?"authNo-travel"+t.indexItem:"authNo-travel"+t.index})},click:function(e){return t.changeRadio({type:"no",id:""!==t.indexItem?"authNo-travel"+t.indexItem:"authNo-travel"+t.index,key:"authYesNo",keyThree:"authNo"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:"inspecAdmittedTravHis"}},[t._v("Inspected and Admitted")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.inyes?t.information.class.inyes:"",checked:"on"===t.information.inyes,readonly:t.readonly,label:"Yes",name:"inspecadm"+t.indexItem,value:"yes",id:""!==t.indexItem?"inyes-travel"+t.indexItem:"inyes-travel"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.inyes,fieldId:"inyes",type:"travelHistory",id:""!==t.indexItem?"inyes-travel"+t.indexItem:"inyes-travel"+t.index})},click:function(e){return t.changeRadio({type:"yes",id:""!==t.indexItem?"inyes-travel"+t.indexItem:"inyes-travel"+t.index,key:"inYesNo",keyThree:"inyes"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.inno?t.information.class.inno:"",checked:"on"===t.information.inno,readonly:t.readonly,label:"No",name:"inspecadm"+t.indexItem,value:"no",id:""!==t.indexItem?"inno-travel"+t.indexItem:"inno-travel"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.inno,fieldId:"inno",type:"travelHistory",id:""!==t.indexItem?"inno-travel"+t.indexItem:"inno-travel"+t.index})},click:function(e){return t.changeRadio({type:"no",id:""!==t.indexItem?"inno-travel"+t.indexItem:"inno-travel"+t.index,key:"inYesNo",keyThree:"inno"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("travelForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this travel item?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteTravel}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. Duration (The date of departure and date of return are not incluided in the calculation)")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. Travel Details")])])}]};var os=n("VU/8")(is,as,!1,function(t){n("Us3w"),n("oIC6"),n("44uN")},"data-v-6b9d2da6",null).exports,rs={name:"pf-travel-history",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfTravel:os,PfButton:d},created:function(){var t=this;this.type="itemTravel",void 0===this.list&&-1!==this.contactId?this.apiService.getTravelHistory({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listTravelHistory&&(t.listRemote=e.listTravelHistory),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"travelHistory"})}}},ss={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-travel",{key:i,attrs:{information:e,id:"itemTravel"+i,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-travel":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemTravelAdd"+t.questionnaireid:"itemTravelAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var ls=n("VU/8")(rs,ss,!1,function(t){n("0U3T")},"data-v-19a248cc",null).exports,ds={name:"pf-us-entry",data:function(){return{isShow:!1,messageAccordion:"Show more..."}},mixins:[ht],components:{PfCheckbox:x,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this entry?"},methods:{deleteEntry:function(){this.deleteItem({model:"usEntries",item:"delete-entry"}),this.isPopUp=!1},changeCheckbox:function(t){this.information[t.key]=t.type,this.updateModel({model:"usEntries",field:t.key,value:t.type,id:t.id})},changeCalendarEntry:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateEntry(t.id)}},updateEntry:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editUsEntry(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.USEntryEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},cs={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("usentrie")},mouseleave:function(e){return t.removeHover("usentrie")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"entriesForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"usentrie"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Dates":"Location of Entry and Dates"))])])]),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.comparing||!0===t.information.newItem?"d-none":""},[n("pf-input",{attrs:{id:""!==t.indexItem?"locationOfEntryCityy"+t.indexItem:"locationOfEntryCityy"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.locationOfEntryCity?t.information.class.locationOfEntryCity:"",readonly:t.readonly,label:"In which city did you enter the United States?"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.locationOfEntryCity,fieldId:"locationOfEntryCity",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"locationOfEntryCityy"+t.indexItem:"locationOfEntryCityy"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"locationOfEntryCity",value:t.information.locationOfEntryCity,id:""!==t.indexItem?"locationOfEntryCityy"+t.indexItem:"locationOfEntryCityy"+t.index})}},model:{value:t.information.locationOfEntryCity,callback:function(e){t.$set(t.information,"locationOfEntryCity",e)},expression:"information.locationOfEntryCity"}})],1),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{id:""!==t.indexItem?"locationOfEntryStatee"+t.indexItem:"locationOfEntryStatee"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.locationOfEntryState?t.information.class.locationOfEntryState:"",readonly:t.readonly,label:"In which state did you enter the United States? (xx)"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.locationOfEntryState,fieldId:"locationOfEntryState",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"locationOfEntryStatee"+t.indexItem:"locationOfEntryStatee"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"locationOfEntryState",value:t.information.locationOfEntryState,id:""!==t.indexItem?"locationOfEntryStatee"+t.indexItem:"locationOfEntryStatee"+t.index})}},model:{value:t.information.locationOfEntryState,callback:function(e){t.$set(t.information,"locationOfEntryState",e)},expression:"information.locationOfEntryState"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{validate:"required",name:void 0!==t.index?"input-enterDate-"+t.index:"input-enterDate-"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",classElement:void 0===t.information.class?"":void 0!==t.information.class.enterDate?t.information.class.enterDate:"",readonly:t.readonly,label:"When did you enter the United States?",id:""!==t.indexItem?"enterDate-"+t.indexItem:"enterDate-"+t.index,mask:"##/##/####",model:"usEntries",field:"enterDate"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.enterDate,fieldId:"enterDate",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"input-enterDate-"+t.indexItem:"input-enterDate-"+t.index})},change:t.changeCalendar},model:{value:t.information.enterDate,callback:function(e){t.$set(t.information,"enterDate",e)},expression:"information.enterDate"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.departDate?t.information.class.departDate:"",readonly:t.readonly,label:"On which date did you leave the United States?",id:""!==t.indexItem?"departDate-"+t.indexItem:"departDate-"+t.index,mask:"##/##/####",divCalendar:"marginBotZero",model:"usEntries",field:"departDate"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.departDate,fieldId:"departDate",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"input-departDate-"+t.indexItem:"input-departDate-"+t.index})},change:t.changeCalendar},model:{value:t.information.departDate,callback:function(e){t.$set(t.information,"departDate",e)},expression:"information.departDate"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionUsEntries"+t.indexItem:"#accordionUsEntries"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionUsEntries"+t.indexItem:"accordionUsEntries"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group marginBotZero mb-2"},[n("label",{attrs:{for:"firsEntryUsEn"}},[t._v("First Entry Ever:")]),t._v(" "),n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{readonly:t.readonly,label:"Select this box if this is your first entry to the United States in your life.",classElement:void 0===t.information.class?"":void 0!==t.information.class.firstEntryEver?t.information.class.firstEntryEver:"",checked:"on"===t.information.firstEntryEver,id:void 0!==t.index?"firstEntryEver"+t.index:"firstEntryEver"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.firstEntryEver,fieldId:"firstEntryEver",type:"usEntries",index:t.uniqueIndex,id:void 0!==t.index?"firstEntryEver"+t.index:"firstEntryEver"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.firstEntryEver?"off":"on",id:void 0!==t.index?"firstEntryEver"+t.index:"firstEntryEver"+t.indexItem,key:"firstEntryEver"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group marginBotZero"},[n("label",{attrs:{for:"mosRecenEntryUsEn1"}},[t._v("Most Recent Entry:")]),t._v(" "),n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{readonly:t.readonly,label:"Select this box if this is your most recent entry to the United States.",classElement:void 0===t.information.class?"":void 0!==t.information.class.mostRecentEntry?t.information.class.mostRecentEntry:"",checked:"on"===t.information.mostRecentEntry,id:void 0!==t.index?"mostRecentEntry"+t.index:"mostRecentEntry"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.mostRecentEntry,fieldId:"mostRecentEntry",type:"usEntries",index:t.uniqueIndex,id:void 0!==t.index?"mostRecentEntry"+t.index:"mostRecentEntry"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.mostRecentEntry?"off":"on",id:void 0!==t.index?"mostRecentEntry"+t.index:"mostRecentEntry"+t.indexItem,key:"mostRecentEntry"})}}})],1)])])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"locationOfEntryCity"+t.indexItem:"locationOfEntryCity"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.locationOfEntryCity?t.information.class.locationOfEntryCity:"",readonly:t.readonly,label:"In which city did you enter the United States?"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.locationOfEntryCity,fieldId:"locationOfEntryCity",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"locationOfEntryCity"+t.indexItem:"locationOfEntryCity"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"locationOfEntryCity",value:t.information.locationOfEntryCity,id:""!==t.indexItem?"locationOfEntryCity"+t.indexItem:"locationOfEntryCity"+t.index})}},model:{value:t.information.locationOfEntryCity,callback:function(e){t.$set(t.information,"locationOfEntryCity",e)},expression:"information.locationOfEntryCity"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{mask:"AA",id:""!==t.indexItem?"locationOfEntryState"+t.indexItem:"locationOfEntryState"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.locationOfEntryState?t.information.class.locationOfEntryState:"",readonly:t.readonly,label:"In which state did you enter the United States? (xx)"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.locationOfEntryState,fieldId:"locationOfEntryState",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"locationOfEntryState"+t.indexItem:"locationOfEntryState"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"locationOfEntryState",value:t.information.locationOfEntryState,id:""!==t.indexItem?"locationOfEntryState"+t.indexItem:"locationOfEntryState"+t.index})}},model:{value:t.information.locationOfEntryState,callback:function(e){t.$set(t.information,"locationOfEntryState",e)},expression:"information.locationOfEntryState"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(2)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"statusAtEntry"+t.indexItem:"statusAtEntry"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.statusAtEntry?t.information.class.statusAtEntry:"",readonly:t.readonly,label:"What was your immigration status when you entered on this occasion (for example: Tourist Visa, Without Visa, ESTA, Visa Waiver)?"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.statusAtEntry,fieldId:"statusAtEntry",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"statusAtEntry"+t.indexItem:"statusAtEntry"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"statusAtEntry",value:t.information.statusAtEntry,id:""!==t.indexItem?"statusAtEntry"+t.indexItem:"statusAtEntry"+t.index})}},model:{value:t.information.statusAtEntry,callback:function(e){t.$set(t.information,"statusAtEntry",e)},expression:"information.statusAtEntry"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{id:""!==t.indexItem?"classOfAdmision"+t.indexItem:"classOfAdmision"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.classOfAdmision?t.information.class.classOfAdmision:"",readonly:t.readonly,label:"If you entered the United States legally, what classification were you given (B1, B2, H-1B, Parole, etc.)?"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.classOfAdmision,fieldId:"classOfAdmision",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"classOfAdmision"+t.indexItem:"classOfAdmision"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"classOfAdmision",value:t.information.classOfAdmision,id:""!==t.indexItem?"classOfAdmision"+t.indexItem:"classOfAdmision"+t.index})}},model:{value:t.information.classOfAdmision,callback:function(e){t.$set(t.information,"classOfAdmision",e)},expression:"information.classOfAdmision"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(3)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"i94"+t.indexItem:"i94"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.i94?t.information.class.i94:"",readonly:t.readonly,label:"Which I-94 number were you given when you entered?"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.i94,fieldId:"i94",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"i94"+t.indexItem:"i94"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"i94",value:t.information.i94,id:""!==t.indexItem?"i94"+t.indexItem:"i94"+t.index})}},model:{value:t.information.i94,callback:function(e){t.$set(t.information,"i94",e)},expression:"information.i94"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateStayExpire?t.information.class.dateStayExpire:"",readonly:t.readonly,label:"What was the expiration date for your stay (I-94 Expiration Number)?:",id:""!==t.indexItem?"dateStayExpire-"+t.indexItem:"dateStayExpire-"+t.index,mask:"##/##/####",model:"usEntries",field:"dateStayExpire"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.dateStayExpire,fieldId:"dateStayExpire",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"input-dateStayExpire-"+t.indexItem:"input-dateStayExpire-"+t.index})},change:t.changeCalendar},model:{value:t.information.dateStayExpire,callback:function(e){t.$set(t.information,"dateStayExpire",e)},expression:"information.dateStayExpire"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"passportNumber"+t.indexItem:"passportNumber"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.passportNumber?t.information.class.passportNumber:"",readonly:t.readonly,label:"What was the passport number you entered with?"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.passportNumber,fieldId:"passportNumber",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"passportNumber"+t.indexItem:"passportNumber"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"passportNumber",value:t.information.passportNumber,id:""!==t.indexItem?"passportNumber"+t.indexItem:"passportNumber"+t.index})}},model:{value:t.information.passportNumber,callback:function(e){t.$set(t.information,"passportNumber",e)},expression:"information.passportNumber"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"travelDocumentNumber"+t.indexItem:"travelDocumentNumber"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.travelDocumentNumber?t.information.class.travelDocumentNumber:"",readonly:t.readonly,label:"If you did not enter with a passport, but entered on a 'Travel Document' instead, please provide the Travel Document Number."},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.travelDocumentNumber,fieldId:"travelDocumentNumber",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"travelDocumentNumber"+t.indexItem:"travelDocumentNumber"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"travelDocumentNumber",value:t.information.travelDocumentNumber,id:""!==t.indexItem?"travelDocumentNumber"+t.indexItem:"travelDocumentNumber"+t.index})}},model:{value:t.information.travelDocumentNumber,callback:function(e){t.$set(t.information,"travelDocumentNumber",e)},expression:"information.travelDocumentNumber"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{id:""!==t.indexItem?"countryOfIssuancePassport"+t.indexItem:"countryOfIssuancePassport"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.countryOfIssuancePassport?t.information.class.countryOfIssuancePassport:"",readonly:t.readonly,label:"Which country issued the passport that you entered with?"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.countryOfIssuancePassport,fieldId:"countryOfIssuancePassport",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"countryOfIssuancePassport"+t.indexItem:"countryOfIssuancePassport"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"countryOfIssuancePassport",value:t.information.countryOfIssuancePassport,id:""!==t.indexItem?"countryOfIssuancePassport"+t.indexItem:"countryOfIssuancePassport"+t.index})}},model:{value:t.information.countryOfIssuancePassport,callback:function(e){t.$set(t.information,"countryOfIssuancePassport",e)},expression:"information.countryOfIssuancePassport"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.expirationDateTravelDocument?t.information.class.expirationDateTravelDocument:"",readonly:t.readonly,label:"If you entered on a Travel Document, what was the expiration date of that document?",id:""!==t.indexItem?"expirationDateTravelDocument-"+t.indexItem:"expirationDateTravelDocument-"+t.index,mask:"##/##/####",model:"usEntries",field:"expirationDateTravelDocument"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.expirationDateTravelDocument,fieldId:"expirationDateTravelDocument",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"input-expirationDateTravelDocument-"+t.indexItem:"input-expirationDateTravelDocument-"+t.index})},change:t.changeCalendar},model:{value:t.information.expirationDateTravelDocument,callback:function(e){t.$set(t.information,"expirationDateTravelDocument",e)},expression:"information.expirationDateTravelDocument"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(4)]),t._v(" "),n("div",{staticClass:"col-md-12"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:""}},[t._v("Did the client encounter United States Customs and Border Protection (CBP) while attempting to enter on this occasion?")]),t._v(" "),n("div",{staticClass:"custom-checkbox"},[n("pf-checkbox",{attrs:{readonly:t.readonly,label:"Yes, client was stopped by United States Customs and Border Protection (CBP) at least once.",classElement:void 0===t.information.class?"":void 0!==t.information.class.stoppedByCbp?t.information.class.stoppedByCbp:"",checked:"on"===t.information.stoppedByCbp,id:void 0!==t.index?"stoppedByCbp"+t.index:"stoppedByCbp"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.stoppedByCbp,fieldId:"stoppedByCbp",type:"usEntries",index:t.uniqueIndex,id:void 0!==t.index?"stoppedByCbp"+t.index:"stoppedByCbp"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.stoppedByCbp?"off":"on",id:void 0!==t.index?"stoppedByCbp"+t.index:"stoppedByCbp"+t.indexItem,key:"stoppedByCbp"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-12"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:""}},[t._v('Did that encounter with United States Customs and Border Protection result in a "Removal Order" or "Deportation Order"?')]),t._v(" "),n("div",{staticClass:"custom-checkbox"},[n("pf-checkbox",{attrs:{readonly:t.readonly,label:"Yes, this encounter resulted in `Removal Order` or `Deportation Order`.",classElement:void 0===t.information.class?"":void 0!==t.information.class.removal?t.information.class.removal:"",checked:"on"===t.information.removal,id:void 0!==t.index?"removal"+t.index:"removal"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.removal,fieldId:"removal",type:"usEntries",index:t.uniqueIndex,id:void 0!==t.index?"removal"+t.index:"removal"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.removal?"off":"on",id:void 0!==t.index?"removal"+t.index:"removal"+t.indexItem,key:"removal"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-12"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:""}},[t._v('Did that encounter with United States Customs and Border Protection result in a "Voluntary Return" where there was no official deportation or removal order?')]),t._v(" "),n("div",{staticClass:"custom-checkbox"},[n("pf-checkbox",{attrs:{readonly:t.readonly,label:"Yes, this encounter resulted in a `Voluntary Return`.",classElement:void 0===t.information.class?"":void 0!==t.information.class.volReturn?t.information.class.volReturn:"",checked:"on"===t.information.volReturn,id:void 0!==t.index?"volReturn"+t.index:"volReturn"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.volReturn,fieldId:"volReturn",type:"usEntries",index:t.uniqueIndex,id:void 0!==t.index?"volReturn"+t.index:"volReturn"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.volReturn?"off":"on",id:void 0!==t.index?"volReturn"+t.index:"volReturn"+t.indexItem,key:"volReturn"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-input",{attrs:{id:""!==t.indexItem?"numberOfCbpStops"+t.indexItem:"numberOfCbpStops"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.numberOfCbpStops?t.information.class.numberOfCbpStops:"",readonly:t.readonly,label:"If the result was a only a `Voluntary Return`, and if there were multiple entries on this attempt at entering the US, please indicate that number here:"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.numberOfCbpStops,fieldId:"numberOfCbpStops",type:"usEntries",index:t.uniqueIndex,id:""!==t.indexItem?"numberOfCbpStops"+t.indexItem:"numberOfCbpStops"+t.index})},change:function(e){return t.updateModel({model:"usEntries",field:"numberOfCbpStops",value:t.information.numberOfCbpStops,id:""!==t.indexItem?"numberOfCbpStops"+t.indexItem:"numberOfCbpStops"+t.index})}},model:{value:t.information.numberOfCbpStops,callback:function(e){t.$set(t.information,"numberOfCbpStops",e)},expression:"information.numberOfCbpStops"}})],1),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("entriesForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this US entry?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteEntry}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. First and/or Most Recent Entry")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. Place of Entry")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("4. Immigration Status")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("5. Document Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("6. Customs and Border Protection Encounter")])])}]};var hs=n("VU/8")(ds,cs,!1,function(t){n("wMu1"),n("+Zpa"),n("CwKP")},"data-v-5e407ef2",null).exports,us={name:"pf-us-entries",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfUsEntry:hs,PfButton:d},created:function(){var t=this;this.type="itemEntry",void 0===this.list&&-1!==this.contactId?this.apiService.getUsEntry({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listUsEntry&&(t.listRemote=e.listUsEntry),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"usEntries"})}}},ms={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-us-entry",{key:i,attrs:{information:e,id:"itemEntry"+i,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-entry":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemEntryAdd"+t.questionnaireid:"itemEntryAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var fs=n("VU/8")(us,ms,!1,function(t){n("Mm7y")},null,null).exports,ps={name:"pf-visa",data:function(){return{isShow:!1,messageAccordion:"Show more..."}},mixins:[ht],components:{PfTextArea:T,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this visa?"},methods:{deleteVisa:function(){this.deleteItem({model:"visaHistory",item:"delete-visa"}),this.isPopUp=!1},changeCalendarVisa:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateVisa(t.id)}},updateVisa:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editVisaHistory(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.visaHistoryEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},_s={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("visa")},mouseleave:function(e){return t.removeHover("visa")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"visaForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"visa"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",{staticClass:"mrTextSpace"},[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Name":"Category, Date of Issue and Date of Expiration"))])])]),t._v(" "),n("div",{staticClass:"col-md-6",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"":"d-none"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"first-visa"+t.index:"first-visa"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",classElement:void 0===t.information.class?"":void 0!==t.information.class.first?t.information.class.first:"",readonly:t.readonly,label:"First Name:",id:""!==t.indexItem?"first-visa"+t.indexItem:"first-visa"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.first,fieldId:"first",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"first-visa"+t.indexItem:"first-visa"+t.index})},change:function(e){return t.updateModel({model:"visaHistory",field:"first",value:t.information.first,id:""!==t.indexItem?"first-visa"+t.indexItem:"first-visa"+t.index})}},model:{value:t.information.first,callback:function(e){t.$set(t.information,"first",e)},expression:"information.first"}})],1),t._v(" "),n("div",{staticClass:"col-md-6 spaceShowMore",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"":"d-none"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"last-visa"+t.index:"last-visa"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",classElement:void 0===t.information.class?"":void 0!==t.information.class.last?t.information.class.last:"",readonly:t.readonly,label:"Last Name:",id:""!==t.indexItem?"last-visa"+t.indexItem:"last-visa"+t.index,divInput:"marginBotZero"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.last,fieldId:"last",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"last-visa"+t.indexItem:"last-visa"+t.index})},change:function(e){return t.updateModel({model:"visaHistory",field:"last",value:t.information.last,id:""!==t.indexItem?"last-visa"+t.indexItem:"last-visa"+t.index})}},model:{value:t.information.last,callback:function(e){t.$set(t.information,"last",e)},expression:"information.last"}})],1),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"catt-visa"+t.index:"catt-visa"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",classElement:void 0===t.information.class?"":void 0!==t.information.class.cat?t.information.class.cat:"",readonly:t.readonly,label:"Visa Category:",id:""!==t.indexItem?"catt-visa"+t.indexItem:"catt-visa"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.cat,fieldId:"cat",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"catt-visa"+t.indexItem:"catt-visa"+t.index})},change:function(e){return t.updateModel({model:"visaHistory",field:"cat",value:t.information.cat,id:""!==t.indexItem?"catt-visa"+t.indexItem:"catt-visa"+t.index})}},model:{value:t.information.cat,callback:function(e){t.$set(t.information,"cat",e)},expression:"information.cat"}})],1),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-calendar",{attrs:{id:""!==t.indexItem?"issuee-visa"+t.indexItem:"issuee-visa"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.issue?t.information.class.issue:"",readonly:t.readonly,label:"Date of Issue:",mask:"##/##/####",model:"visaHistory",field:"issue"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.issue,fieldId:"issue",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-issuee-visa"+t.indexItem:"input-issuee-visa"+t.index})},change:t.changeCalendar},model:{value:t.information.issue,callback:function(e){t.$set(t.information,"issue",e)},expression:"information.issue"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.exp?t.information.class.exp:"",readonly:t.readonly,label:"Date of Expiration:",id:""!==t.indexItem?"expp-visa"+t.indexItem:"expp-visa"+t.index,mask:"##/##/####",divCalendar:"marginBotZero",model:"visaHistory",field:"exp"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.exp,fieldId:"exp",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-expp-visa"+t.indexItem:"input-expp-visa"+t.index})},change:t.changeCalendar},model:{value:t.information.exp,callback:function(e){t.$set(t.information,"exp",e)},expression:"information.exp"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionVisa"+t.indexItem:"#accordionVisa"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionVisa"+t.indexItem:"accordionVisa"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"cat-visa"+t.index:"cat-visa"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",classElement:void 0===t.information.class?"":void 0!==t.information.class.cat?t.information.class.cat:"",readonly:t.readonly,label:"Visa Category:",id:""!==t.indexItem?"cat-visa"+t.indexItem:"cat-visa"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.cat,fieldId:"cat",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"cat-visa"+t.indexItem:"cat-visa"+t.index})},change:function(e){return t.updateModel({model:"visaHistory",field:"cat",value:t.information.cat,id:""!==t.indexItem?"cat-visa"+t.indexItem:"cat-visa"+t.index})}},model:{value:t.information.cat,callback:function(e){t.$set(t.information,"cat",e)},expression:"information.cat"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"number-visa"+t.index:"number-visa"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",classElement:void 0===t.information.class?"":void 0!==t.information.class.number?t.information.class.number:"",readonly:t.readonly,label:"Visa Number:",id:""!==t.indexItem?"number-visa"+t.indexItem:"number-visa"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.number,fieldId:"number",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"number-visa"+t.indexItem:"number-visa"+t.index})},change:function(e){return t.updateModel({model:"visaHistory",field:"number",value:t.information.number,id:""!==t.indexItem?"number-visa"+t.indexItem:"number-visa"+t.index})}},model:{value:t.information.number,callback:function(e){t.$set(t.information,"number",e)},expression:"information.number"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{id:""!==t.indexItem?"issue-visa"+t.indexItem:"issue-visa"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.issue?t.information.class.issue:"",readonly:t.readonly,label:"Date of Issue:",mask:"##/##/####",model:"visaHistory",field:"issue"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.issue,fieldId:"issue",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-issue-visa"+t.indexItem:"input-issue-visa"+t.index})},change:t.changeCalendar},model:{value:t.information.issue,callback:function(e){t.$set(t.information,"issue",e)},expression:"information.issue"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.poissue?t.information.class.poissue:"",readonly:t.readonly,label:"Place of Issuance:",id:""!==t.indexItem?"poissue-visa"+t.indexItem:"poissue-visa"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.poissue,fieldId:"poissue",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"poissue-visa"+t.indexItem:"poissue-visa"+t.index})},change:function(e){return t.updateModel({model:"visaHistory",field:"poissue",value:t.information.poissue,id:""!==t.indexItem?"poissue-visa"+t.indexItem:"poissue-visa"+t.index})}},model:{value:t.information.poissue,callback:function(e){t.$set(t.information,"poissue",e)},expression:"information.poissue"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.anumber?t.information.class.anumber:"",readonly:t.readonly,label:"USCIS/Alien Number:",id:""!==t.indexItem?"anumber-visa"+t.indexItem:"anumber-visa"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.anumber,fieldId:"anumber",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"anumber-visa"+t.indexItem:"anumber-visa"+t.index})},change:function(e){return t.updateModel({model:"visaHistory",field:"anumber",value:t.information.anumber,id:""!==t.indexItem?"anumber-visa"+t.indexItem:"anumber-visa"+t.index})}},model:{value:t.information.anumber,callback:function(e){t.$set(t.information,"anumber",e)},expression:"information.anumber"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.exp?t.information.class.exp:"",readonly:t.readonly,label:"Date of Expiration:",id:""!==t.indexItem?"exp-visa"+t.indexItem:"exp-visa"+t.index,mask:"##/##/####",model:"visaHistory",field:"exp"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.exp,fieldId:"exp",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-exp-visa"+t.indexItem:"input-exp-visa"+t.index})},change:t.changeCalendar},model:{value:t.information.exp,callback:function(e){t.$set(t.information,"exp",e)},expression:"information.exp"}})],1),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dosnum?t.information.class.dosnum:"",readonly:t.readonly,label:"DOS Case Number:",id:""!==t.indexItem?"dosnum-visa"+t.indexItem:"dosnum-visa"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.dosnum,fieldId:"dosnum",type:"visaHistory",index:t.uniqueIndex,id:""!==t.indexItem?"dosnum-visa"+t.indexItem:"dosnum-visa"+t.index})},change:function(e){return t.updateModel({model:"visaHistory",field:"dosnum",value:t.information.dosnum,id:""!==t.indexItem?"dosnum-visa"+t.indexItem:"dosnum-visa"+t.index})}},model:{value:t.information.dosnum,callback:function(e){t.$set(t.information,"dosnum",e)},expression:"information.dosnum"}})],1),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("visaForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this visa item?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteVisa}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. Visa Details")])])}]};var As=n("VU/8")(ps,_s,!1,function(t){n("9FU3"),n("rkCz"),n("THgE")},"data-v-6c9f16be",null).exports,bs={name:"pf-visa-history",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfVisa:As,PfButton:d},created:function(){var t=this;this.type="itemVisa",void 0===this.list&&-1!==this.contactId?this.apiService.getVisaHistory({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listVisaHistory&&(t.listRemote=e.listVisaHistory),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"visaHistory"})}}},xs={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-visa",{key:i,attrs:{information:e,id:"itemVisa"+i,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-visa":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemVisaAdd"+t.questionnaireid:"itemVisaAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var gs=n("VU/8")(bs,xs,!1,function(t){n("Xl0W")},null,null).exports,vs={name:"pf-marriage",data:function(){return{isShow:!1,messageAccordion:"Show more...",countries:ft.COUNTRIES}},mixins:[ht],props:{contactInformation:{type:Object}},components:{PfRadio:P,PfCheckbox:x,PfTextArea:T,PfPopUp:$,PfSelect:k},mounted:function(){this.messageModal="Are you really sure delete this marriage?"},methods:{deleteMarriage:function(){this.deleteItem({model:"marriageHistory",item:"delete-marriage"}),this.isPopUp=!1},changeRadio:function(t){var e=this;this.information[t.key]=t.type;var n=this.information;Y()(this.radioGroups).forEach(function(i){-1!==e.radioGroups[i].indexOf(t.keyThree)&&e.radioGroups[i].forEach(function(i){i!==t.keyThree?(n[i]="off",!0===e.comparing&&(n.threeValues[i].manual="off")):(n[i]="on",!0===e.comparing&&(n.threeValues[i].manual="on"))})}),this.information={},this.information=n,this.updateModel({model:"marriageHistory",field:t.key,value:t.type,id:t.id})},changeCheckbox:function(t){this.information[t.key]=t.type,this.updateModel({model:"marriageHistory",field:t.key,value:t.type,id:t.id})},changeCalendarMarriage:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateMarriage(t.id)}},updateMarriage:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editMarriageHistory(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.marriageHistoryEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},Cs={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("marriage")},mouseleave:function(e){return t.removeHover("marriage")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"marriageForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"marriage"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",{staticClass:"mrTextSpace"},[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Marital Status":"Spouse's Name and Date of Marriage"))])])]),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"firstNamee-marriage-hide"+t.index:"firstNamee-marriage-hide"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"firstNamee-marriage-hide"+t.indexItem:"firstNamee-marriage-hide"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.firstName?t.information.class.firstName:"",readonly:t.readonly,label:"Spouse's First Name:"},on:{change:function(e){return t.updateModel({model:"marriageHistory",field:"firstName",value:t.information.firstName,id:""!==t.indexItem?"firstNamee-marriage-hide"+t.indexItem:"firstNamee-marriage-hide"+t.index})}},model:{value:t.information.firstName,callback:function(e){t.$set(t.information,"firstName",e)},expression:"information.firstName"}})],1),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"lastNamee-marriage-hide"+t.index:"lastNamee-marriage-hide"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"lastNamee-marriage-hide"+t.indexItem:"lastNamee-marriage-hide"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.lastName?t.information.class.lastName:"",readonly:t.readonly,label:"Spouse's Last Name:"},on:{change:function(e){return t.updateModel({model:"marriageHistory",field:"lastName",value:t.information.lastName,id:""!==t.indexItem?"lastNamee-marriage-hide"+t.indexItem:"lastNamee-marriage-hide"+t.index})}},model:{value:t.information.lastName,callback:function(e){t.$set(t.information,"lastName",e)},expression:"information.lastName"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateMarriage?t.information.class.dateMarriage:"",readonly:t.readonly,label:"Date of Marriage:",id:""!==t.indexItem?"dateMarriagee-marriageP"+t.indexItem:"dateMarriagee-marriageP"+t.index,mask:"##/##/####",divCalendar:"marginBotZero",model:"marriageHistory",field:"dateMarriage"},on:{change:t.changeCalendar},model:{value:t.information.dateMarriage,callback:function(e){t.$set(t.information,"dateMarriage",e)},expression:"information.dateMarriage"}})],1),t._v(" "),n("div",{staticClass:"col-md-6 mb-1",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"":"d-none"},[n("div",{staticClass:"form-group marginBotZero mb-1"},[n("label",{attrs:{for:"currentSp"}},[t._v("Is this the current spouse?")]),t._v(" "),n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{readonly:t.readonly,label:"Yes, this is the current spouse.",classElement:void 0===t.information.class?"":void 0!==t.information.class.isCurrent?t.information.class.isCurrent:"",checked:"on"===t.information.isCurrent,id:void 0!==t.index?"isCurrent"+t.index:"isCurrent"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.isCurrent,fieldId:"isCurrent",type:"marriageHistory",index:t.uniqueIndex,id:void 0!==t.index?"isCurrent"+t.index:"isCurrent"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.isCurrent?"off":"on",id:void 0!==t.index?"isCurrent"+t.index:"isCurrent"+t.indexItem,key:"isCurrent"})}}})],1)])])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionMarriage"+t.indexItem:"#accordionMarriage"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionMarriage"+t.indexItem:"accordionMarriage"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"firstName-marriage"+t.index:"firstName-marriage"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"firstName-marriage"+t.indexItem:"firstName-marriage"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.firstName?t.information.class.firstName:"",readonly:t.readonly,label:"Spouse's First Name:"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.firstName,fieldId:"firstName",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"firstName-marriage"+t.indexItem:"firstName-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"firstName",value:t.information.firstName,id:""!==t.indexItem?"firstName-marriage"+t.indexItem:"firstName-marriage"+t.index})}},model:{value:t.information.firstName,callback:function(e){t.$set(t.information,"firstName",e)},expression:"information.firstName"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"lastName-marriage"+t.index:"lastName-marriage"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"lastName-marriage"+t.indexItem:"lastName-marriage"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.lastName?t.information.class.lastName:"",readonly:t.readonly,label:"Spouse's Last Name:"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastName,fieldId:"lastName",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"lastName-marriage"+t.indexItem:"lastName-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"lastName",value:t.information.lastName,id:""!==t.indexItem?"lastName-marriage"+t.indexItem:"lastName-marriage"+t.index})}},model:{value:t.information.lastName,callback:function(e){t.$set(t.information,"lastName",e)},expression:"information.lastName"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.middleName?t.information.class.middleName:"",readonly:t.readonly,label:"Spouse's Middle Name:",id:""!==t.indexItem?"middleName-marriage"+t.indexItem:"middleName-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.middleName,fieldId:"middleName",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"middleName-marriage"+t.indexItem:"middleName-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"middleName",value:t.information.middleName,id:""!==t.indexItem?"middleName-marriage"+t.indexItem:"middleName-marriage"+t.index})}},model:{value:t.information.middleName,callback:function(e){t.$set(t.information,"middleName",e)},expression:"information.middleName"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.maidenName?t.information.class.maidenName:"",readonly:t.readonly,label:"Spouse's Maiden Name:",id:""!==t.indexItem?"maidenName-marriage"+t.indexItem:"maidenName-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.maidenName,fieldId:"maidenName",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"maidenName-marriage"+t.indexItem:"maidenName-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"maidenName",value:t.information.maidenName,id:""!==t.indexItem?"maidenName-marriage"+t.indexItem:"maidenName-marriage"+t.index})}},model:{value:t.information.maidenName,callback:function(e){t.$set(t.information,"maidenName",e)},expression:"information.maidenName"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceAddress?t.information.class.placeOfResidenceAddress:"",readonly:t.readonly,label:"Address:",id:""!==t.indexItem?"placeOfResidenceAddress-marriage"+t.indexItem:"placeOfResidenceAddress-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceAddress,fieldId:"placeOfResidenceAddress",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceAddress-marriage"+t.indexItem:"placeOfResidenceAddress-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeOfResidenceAddress",value:t.information.placeOfResidenceAddress,id:""!==t.indexItem?"placeOfResidenceAddress-marriage"+t.indexItem:"placeOfResidenceAddress-marriage"+t.index})}},model:{value:t.information.placeOfResidenceAddress,callback:function(e){t.$set(t.information,"placeOfResidenceAddress",e)},expression:"information.placeOfResidenceAddress"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group"},[n("div",{staticClass:"form-check form-check-inline marginBotRem"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceApt?t.information.class.placeOfResidenceApt:"",checked:"on"===t.information.placeOfResidenceApt,readonly:t.readonly,label:"APT",value:"1",name:"aptSteFlMarHis"+t.indexItem,id:""!==t.indexItem?"placeOfResidenceApt-marriage"+t.indexItem:"placeOfResidenceApt-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceApt,fieldId:"placeOfResidenceApt",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceApt-marriage"+t.indexItem:"placeOfResidenceApt-marriage"+t.index})},click:function(e){return t.changeRadio({type:"apt",id:""!==t.indexItem?"placeOfResidenceApt-marriage"+t.indexItem:"placeOfResidenceApt-marriage"+t.index,key:"isAptSteFloor",keyThree:"placeOfResidenceApt"})}}})],1),t._v(" "),n("div",{staticClass:"form-check form-check-inline"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceSte?t.information.class.placeOfResidenceSte:"",checked:"on"===t.information.placeOfResidenceSte,readonly:t.readonly,label:"STE",value:"2",name:"aptSteFlMarHis"+t.indexItem,id:""!==t.indexItem?"placeOfResidenceSte-marriage"+t.indexItem:"placeOfResidenceSte-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceSte,fieldId:"placeOfResidenceSte",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceSte-marriage"+t.indexItem:"placeOfResidenceSte-marriage"+t.index})},click:function(e){return t.changeRadio({type:"ste",id:""!==t.indexItem?"placeOfResidenceSte-marriage"+t.indexItem:"placeOfResidenceSte-marriage"+t.index,key:"isAptSteFloor",keyThree:"placeOfResidenceSte"})}}})],1),t._v(" "),n("div",{staticClass:"form-check form-check-inline"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceFlr?t.information.class.placeOfResidenceFlr:"",checked:"on"===t.information.placeOfResidenceFlr,readonly:t.readonly,label:"FLOOR",value:"3",name:"aptSteFlMarHis"+t.indexItem,id:""!==t.indexItem?"placeOfResidenceFlr-marriage"+t.indexItem:"placeOfResidenceFlr-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceFlr,fieldId:"placeOfResidenceFlr",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceFlr-marriage"+t.indexItem:"placeOfResidenceFlr-marriage"+t.index})},click:function(e){return t.changeRadio({type:"floor",id:""!==t.indexItem?"placeOfResidenceFlr-marriage"+t.indexItem:"placeOfResidenceFlr-marriage"+t.index,key:"isAptSteFloor",keyThree:"placeOfResidenceFlr"})}}})],1),t._v(" "),n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceAptSteFlrNumbertxt?t.information.class.placeOfResidenceAptSteFlrNumbertxt:"",readonly:t.readonly,id:""!==t.indexItem?"placeOfResidenceAptSteFlrNumbertxt-marriage"+t.indexItem:"placeOfResidenceAptSteFlrNumbertxt-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceAptSteFlrNumbertxt,fieldId:"placeOfResidenceAptSteFlrNumbertxt",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceAptSteFlrNumbertxt-marriage"+t.indexItem:"placeOfResidenceAptSteFlrNumbertxt-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeOfResidenceAptSteFlrNumbertxt",value:t.information.placeOfResidenceAptSteFlrNumbertxt,id:""!==t.indexItem?"placeOfResidenceAptSteFlrNumbertxt-marriage"+t.indexItem:"placeOfResidenceAptSteFlrNumbertxt-marriage"+t.index})}},model:{value:t.information.placeOfResidenceAptSteFlrNumbertxt,callback:function(e){t.$set(t.information,"placeOfResidenceAptSteFlrNumbertxt",e)},expression:"information.placeOfResidenceAptSteFlrNumbertxt"}})],1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceCity?t.information.class.placeOfResidenceCity:"",readonly:t.readonly,label:"City:",id:""!==t.indexItem?"placeOfResidenceCity-marriage"+t.indexItem:"placeOfResidenceCity-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceCity,fieldId:"placeOfResidenceCity",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceCity-marriage"+t.indexItem:"placeOfResidenceCity-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeOfResidenceCity",value:t.information.placeOfResidenceCity,id:""!==t.indexItem?"placeOfResidenceCity-marriage"+t.indexItem:"placeOfResidenceCity-marriage"+t.index})}},model:{value:t.information.placeOfResidenceCity,callback:function(e){t.$set(t.information,"placeOfResidenceCity",e)},expression:"information.placeOfResidenceCity"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceState?t.information.class.placeOfResidenceState:"",readonly:t.readonly,label:"State:",id:""!==t.indexItem?"placeOfResidenceState-marriage"+t.indexItem:"placeOfResidenceState-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceState,fieldId:"placeOfResidenceState",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceState-marriage"+t.indexItem:"placeOfResidenceState-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeOfResidenceState",value:t.information.placeOfResidenceState,id:""!==t.indexItem?"placeOfResidenceState-marriage"+t.indexItem:"placeOfResidenceState-marriage"+t.index})}},model:{value:t.information.placeOfResidenceState,callback:function(e){t.$set(t.information,"placeOfResidenceState",e)},expression:"information.placeOfResidenceState"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceZipCode?t.information.class.placeOfResidenceZipCode:"",readonly:t.readonly,label:"Zip Code:",id:""!==t.indexItem?"placeOfResidenceZipCode-marriage"+t.indexItem:"placeOfResidenceZipCode-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceZipCode,fieldId:"placeOfResidenceZipCode",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceZipCode-marriage"+t.indexItem:"placeOfResidenceZipCode-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeOfResidenceZipCode",value:t.information.placeOfResidenceZipCode,id:""!==t.indexItem?"placeOfResidenceZipCode-marriage"+t.indexItem:"placeOfResidenceZipCode-marriage"+t.index})}},model:{value:t.information.placeOfResidenceZipCode,callback:function(e){t.$set(t.information,"placeOfResidenceZipCode",e)},expression:"information.placeOfResidenceZipCode"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"placeOfResidenceCountry",id:""!==t.indexItem?"placeOfResidenceCountry-marriage"+t.indexItem:"placeOfResidenceCountry-marriage"+t.index,model:"marriageHistory",label:"Country:",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.placeOfResidenceCountry?"Select Country":t.information.placeOfResidenceCountry,options:t.countries},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceCountry,fieldId:"placeOfResidenceCountry",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceCountry-marriage"+t.indexItem:"placeOfResidenceCountry-marriage"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceForeignProvince?t.information.class.placeOfResidenceForeignProvince:"",readonly:t.readonly,label:"Foreign Province:",id:""!==t.indexItem?"placeOfResidenceForeignProvince-marriage"+t.indexItem:"placeOfResidenceForeignProvince-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceForeignProvince,fieldId:"placeOfResidenceForeignProvince",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceForeignProvince-marriage"+t.indexItem:"placeOfResidenceForeignProvince-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeOfResidenceForeignProvince",value:t.information.placeOfResidenceForeignProvince,id:""!==t.indexItem?"placeOfResidenceForeignProvince-marriage"+t.indexItem:"placeOfResidenceForeignProvince-marriage"+t.index})}},model:{value:t.information.placeOfResidenceForeignProvince,callback:function(e){t.$set(t.information,"placeOfResidenceForeignProvince",e)},expression:"information.placeOfResidenceForeignProvince"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidencePostalCode?t.information.class.placeOfResidencePostalCode:"",readonly:t.readonly,label:"Postal Code:",id:""!==t.indexItem?"placeOfResidencePostalCode-marriage"+t.indexItem:"placeOfResidencePostalCode-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidencePostalCode,fieldId:"placeOfResidencePostalCode",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidencePostalCode-marriage"+t.indexItem:"placeOfResidencePostalCode-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeOfResidencePostalCode",value:t.information.placeOfResidencePostalCode,id:""!==t.indexItem?"placeOfResidencePostalCode-marriage"+t.indexItem:"placeOfResidencePostalCode-marriage"+t.index})}},model:{value:t.information.placeOfResidencePostalCode,callback:function(e){t.$set(t.information,"placeOfResidencePostalCode",e)},expression:"information.placeOfResidencePostalCode"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(2)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.passportNumber?t.information.class.passportNumber:"",readonly:t.readonly,label:"Passport Number:",id:""!==t.indexItem?"passportNumber-marriage"+t.indexItem:"passportNumber-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.passportNumber,fieldId:"passportNumber",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"passportNumber-marriage"+t.indexItem:"passportNumber-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"passportNumber",value:t.information.passportNumber,id:""!==t.indexItem?"passportNumber-marriage"+t.indexItem:"passportNumber-marriage"+t.index})}},model:{value:t.information.passportNumber,callback:function(e){t.$set(t.information,"passportNumber",e)},expression:"information.passportNumber"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{mask:"###-##-####",placeholder:"999-99-9999",classElement:void 0===t.information.class?"":void 0!==t.information.class.socialSecurityNumber?t.information.class.socialSecurityNumber:"",readonly:t.readonly,label:"Social Security Number:",id:""!==t.indexItem?"socialSecurityNumber-marriage"+t.indexItem:"socialSecurityNumber-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.socialSecurityNumber,fieldId:"socialSecurityNumber",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"socialSecurityNumber-marriage"+t.indexItem:"socialSecurityNumber-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"socialSecurityNumber",value:t.information.socialSecurityNumber,id:""!==t.indexItem?"socialSecurityNumber-marriage"+t.indexItem:"socialSecurityNumber-marriage"+t.index})}},model:{value:t.information.socialSecurityNumber,callback:function(e){t.$set(t.information,"socialSecurityNumber",e)},expression:"information.socialSecurityNumber"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.i94?t.information.class.i94:"",readonly:t.readonly,label:"I-94:",id:""!==t.indexItem?"i94-marriage"+t.indexItem:"i94-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.i94,fieldId:"i94",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"i94-marriage"+t.indexItem:"i94-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"i94",value:t.information.i94,id:""!==t.indexItem?"i94-marriage"+t.indexItem:"i94-marriage"+t.index})}},model:{value:t.information.i94,callback:function(e){t.$set(t.information,"i94",e)},expression:"information.i94"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"nationality",id:""!==t.indexItem?"nationality-marriage"+t.indexItem:"nationality-marriage"+t.index,model:"marriageHistory",label:"Nationality:",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.nationality?"Select Nacionality":t.information.nationality,options:t.countries},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.nationality,fieldId:"nationality",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"nationality-marriage"+t.indexItem:"nationality-marriage"+t.index})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lastEntryCity?t.information.class.lastEntryCity:"",readonly:t.readonly,label:"Place of last entry to US - City:",id:""!==t.indexItem?"lastEntryCity-marriage"+t.indexItem:"lastEntryCity-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastEntryCity,fieldId:"lastEntryCity",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"lastEntryCity-marriage"+t.indexItem:"lastEntryCity-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"lastEntryCity",value:t.information.lastEntryCity,id:""!==t.indexItem?"lastEntryCity-marriage"+t.indexItem:"lastEntryCity-marriage"+t.index})}},model:{value:t.information.lastEntryCity,callback:function(e){t.$set(t.information,"lastEntryCity",e)},expression:"information.lastEntryCity"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lastEntryState?t.information.class.lastEntryState:"",readonly:t.readonly,label:"Place of last entry to US - State:",id:""!==t.indexItem?"lastEntryState-marriage"+t.indexItem:"lastEntryState-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastEntryState,fieldId:"lastEntryState",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"lastEntryState-marriage"+t.indexItem:"lastEntryState-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"lastEntryState",value:t.information.lastEntryState,id:""!==t.indexItem?"lastEntryState-marriage"+t.indexItem:"lastEntryState-marriage"+t.index})}},model:{value:t.information.lastEntryState,callback:function(e){t.$set(t.information,"lastEntryState",e)},expression:"information.lastEntryState"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lastEntryDate?t.information.class.lastEntryDate:"",readonly:t.readonly,label:"Date of last entry to US:",id:""!==t.indexItem?"lastEntryDate-marriage"+t.indexItem:"lastEntryDate-marriage"+t.index,mask:"##/##/####",model:"marriageHistory",field:"lastEntryDate"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastEntryDate,fieldId:"lastEntryDate",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-lastEntryDate-marriage"+t.indexItem:"input-lastEntryDate-marriage"+t.index})},change:t.changeCalendar},model:{value:t.information.lastEntryDate,callback:function(e){t.$set(t.information,"lastEntryDate",e)},expression:"information.lastEntryDate"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lastEntryStatus?t.information.class.lastEntryStatus:"",readonly:t.readonly,label:"Status on last entry:",id:""!==t.indexItem?"lastEntryStatus-marriage"+t.indexItem:"lastEntryStatus-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastEntryStatus,fieldId:"lastEntryStatus",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"lastEntryStatus-marriage"+t.indexItem:"lastEntryStatus-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"lastEntryStatus",value:t.information.lastEntryStatus,id:""!==t.indexItem?"lastEntryStatus-marriage"+t.indexItem:"lastEntryStatus-marriage"+t.index})}},model:{value:t.information.lastEntryStatus,callback:function(e){t.$set(t.information,"lastEntryStatus",e)},expression:"information.lastEntryStatus"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.expirationAuthorizedStay?t.information.class.expirationAuthorizedStay:"",readonly:t.readonly,label:"Expiration of Authorized Stay:",id:""!==t.indexItem?"expirationAuthorizedStay-marriage"+t.indexItem:"expirationAuthorizedStay-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.expirationAuthorizedStay,fieldId:"expirationAuthorizedStay",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"expirationAuthorizedStay-marriage"+t.indexItem:"expirationAuthorizedStay-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"expirationAuthorizedStay",value:t.information.expirationAuthorizedStay,id:""!==t.indexItem?"expirationAuthorizedStay-marriage"+t.indexItem:"expirationAuthorizedStay-marriage"+t.index})}},model:{value:t.information.expirationAuthorizedStay,callback:function(e){t.$set(t.information,"expirationAuthorizedStay",e)},expression:"information.expirationAuthorizedStay"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.race?t.information.class.race:"",readonly:t.readonly,label:"Race:",id:""!==t.indexItem?"race-marriage"+t.indexItem:"race-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.race,fieldId:"race",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"race-marriage"+t.indexItem:"race-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"race",value:t.information.race,id:""!==t.indexItem?"race-marriage"+t.indexItem:"race-marriage"+t.index})}},model:{value:t.information.race,callback:function(e){t.$set(t.information,"race",e)},expression:"information.race"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{mask:"###-###-####",placeholder:"999-999-9999",classElement:void 0===t.information.class?"":void 0!==t.information.class.aNumber?t.information.class.aNumber:"",readonly:t.readonly,label:"Alien Number:",id:""!==t.indexItem?"aNumber-marriage"+t.indexItem:"aNumber-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.aNumber,fieldId:"aNumber",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"aNumber-marriage"+t.indexItem:"aNumber-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"aNumber",value:t.information.aNumber,id:""!==t.indexItem?"aNumber-marriage"+t.indexItem:"aNumber-marriage"+t.index})}},model:{value:t.information.aNumber,callback:function(e){t.$set(t.information,"aNumber",e)},expression:"information.aNumber"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(3)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateOfBirth?t.information.class.dateOfBirth:"",readonly:t.readonly,label:"Date Of Birth:",id:""!==t.indexItem?"dateOfBirth-marriage"+t.indexItem:"dateOfBirth-marriage"+t.index,mask:"##/##/####",model:"marriageHistory",field:"dateOfBirth"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.dateOfBirth,fieldId:"dateOfBirth",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-dateOfBirth-marriage"+t.indexItem:"input-dateOfBirth-marriage"+t.index})},change:t.changeCalendar},model:{value:t.information.dateOfBirth,callback:function(e){t.$set(t.information,"dateOfBirth",e)},expression:"information.dateOfBirth"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.citizenship?t.information.class.citizenship:"",readonly:t.readonly,label:"Citizenship:",id:""!==t.indexItem?"citizenship-marriage"+t.indexItem:"citizenship-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.citizenship,fieldId:"citizenship",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"citizenship-marriage"+t.indexItem:"citizenship-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"citizenship",value:t.information.citizenship,id:""!==t.indexItem?"citizenship-marriage"+t.indexItem:"citizenship-marriage"+t.index})}},model:{value:t.information.citizenship,callback:function(e){t.$set(t.information,"citizenship",e)},expression:"information.citizenship"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:"spoFirsNameMarHis"}},[t._v("Sex:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sexFemaleCk?t.information.class.sexFemaleCk:"",checked:"on"===t.information.sexFemaleCk,readonly:t.readonly,label:"Female",name:"sexMarHis"+t.indexItem,id:""!==t.indexItem?"sexFemaleCk-marriage"+t.indexItem:"sexFemaleCk-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.sexFemaleCk,fieldId:"sexFemaleCk",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"sexFemaleCk-marriage"+t.indexItem:"sexFemaleCk-marriage"+t.index})},click:function(e){return t.changeRadio({type:"female",id:""!==t.indexItem?"sexFemaleCk-marriage"+t.indexItem:"sexFemaleCk-marriage"+t.index,key:"sex",keyThree:"sexFemaleCk"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sexMaleCk?t.information.class.sexMaleCk:"",checked:"on"===t.information.sexMaleCk,readonly:t.readonly,label:"Male",name:"sexMarHis"+t.indexItem,id:""!==t.indexItem?"sexMaleCk-marriage"+t.indexItem:"sexMaleCk-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.sexMaleCk,fieldId:"sexMaleCk",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"sexMaleCk-marriage"+t.indexItem:"sexMaleCk-marriage"+t.index})},click:function(e){return t.changeRadio({type:"male",id:""!==t.indexItem?"sexMaleCk-marriage"+t.indexItem:"sexMaleCk-marriage"+t.index,key:"sex",keyThree:"sexMaleCk"})}}})],1)])])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfBirthCity?t.information.class.placeOfBirthCity:"",readonly:t.readonly,label:"Place Of Birth (City):",id:""!==t.indexItem?"placeOfBirthCity-marriage"+t.indexItem:"placeOfBirthCity-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfBirthCity,fieldId:"placeOfBirthCity",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfBirthCity-marriage"+t.indexItem:"placeOfBirthCity-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeOfBirthCity",value:t.information.placeOfBirthCity,id:""!==t.indexItem?"placeOfBirthCity-marriage"+t.indexItem:"placeOfBirthCity-marriage"+t.index})}},model:{value:t.information.placeOfBirthCity,callback:function(e){t.$set(t.information,"placeOfBirthCity",e)},expression:"information.placeOfBirthCity"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{mask:"AA",classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfBirthState?t.information.class.placeOfBirthState:"",readonly:t.readonly,label:"Place Of Birth (xx):",id:""!==t.indexItem?"placeOfBirthState-marriage"+t.indexItem:"placeOfBirthState-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfBirthState,fieldId:"placeOfBirthState",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfBirthState-marriage"+t.indexItem:"placeOfBirthState-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeOfBirthState",value:t.information.placeOfBirthState,id:""!==t.indexItem?"placeOfBirthState-marriage"+t.indexItem:"placeOfBirthState-marriage"+t.index})}},model:{value:t.information.placeOfBirthState,callback:function(e){t.$set(t.information,"placeOfBirthState",e)},expression:"information.placeOfBirthState"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"placeOfBirthCountry",id:""!==t.indexItem?"placeOfBirthCountry-marriage"+t.indexItem:"placeOfBirthCountry-marriage"+t.index,model:"marriageHistory",label:"Place Of Birth (Country):",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.placeOfBirthCountry?"Select Country":t.information.placeOfBirthCountry,options:t.countries},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfBirthCountry,fieldId:"placeOfBirthCountry",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfBirthCountry-marriage"+t.indexItem:"placeOfBirthCountry-marriage"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(4)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateMarriage?t.information.class.dateMarriage:"",readonly:t.readonly,label:"Date of Marriage:",id:""!==t.indexItem?"dateMarriage-marriage"+t.indexItem:"dateMarriage-marriage"+t.index,mask:"##/##/####",model:"marriageHistory",field:"dateMarriage"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.dateMarriage,fieldId:"dateMarriage",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-dateMarriage-marriage"+t.indexItem:"input-dateMarriage-marriage"+t.index})},change:t.changeCalendar},model:{value:t.information.dateMarriage,callback:function(e){t.$set(t.information,"dateMarriage",e)},expression:"information.dateMarriage"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeMarriageCity?t.information.class.placeMarriageCity:"",readonly:t.readonly,label:"Place of Marriage (City):",id:""!==t.indexItem?"placeMarriageCity-marriage"+t.indexItem:"placeMarriageCity-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeMarriageCity,fieldId:"placeMarriageCity",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeMarriageCity-marriage"+t.indexItem:"placeMarriageCity-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeMarriageCity",value:t.information.placeMarriageCity,id:""!==t.indexItem?"placeMarriageCity-marriage"+t.indexItem:"placeMarriageCity-marriage"+t.index})}},model:{value:t.information.placeMarriageCity,callback:function(e){t.$set(t.information,"placeMarriageCity",e)},expression:"information.placeMarriageCity"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{mask:"AA",classElement:void 0===t.information.class?"":void 0!==t.information.class.placeMarriageState?t.information.class.placeMarriageState:"",readonly:t.readonly,label:"Place of Marriage (xx):",id:""!==t.indexItem?"placeMarriageState-marriage"+t.indexItem:"placeMarriageState-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeMarriageState,fieldId:"placeMarriageState",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeMarriageState-marriage"+t.indexItem:"placeMarriageState-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeMarriageState",value:t.information.placeMarriageState,id:""!==t.indexItem?"placeMarriageState-marriage"+t.indexItem:"placeMarriageState-marriage"+t.index})}},model:{value:t.information.placeMarriageState,callback:function(e){t.$set(t.information,"placeMarriageState",e)},expression:"information.placeMarriageState"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeMarriageProvince?t.information.class.placeMarriageProvince:"",readonly:t.readonly,label:"Place of Marriage (Province):",id:""!==t.indexItem?"placeMarriageProvince-marriage"+t.indexItem:"placeMarriageProvince-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeMarriageProvince,fieldId:"placeMarriageProvince",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeMarriageProvince-marriage"+t.indexItem:"placeMarriageProvince-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeMarriageProvince",value:t.information.placeMarriageProvince,id:""!==t.indexItem?"placeMarriageProvince-marriage"+t.indexItem:"placeMarriageProvince-marriage"+t.index})}},model:{value:t.information.placeMarriageProvince,callback:function(e){t.$set(t.information,"placeMarriageProvince",e)},expression:"information.placeMarriageProvince"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"placeMarriageCountry",id:""!==t.indexItem?"placeMarriageCountry-marriage"+t.indexItem:"placeMarriageCountry-marriage"+t.index,model:"marriageHistory",label:"Place of Marriage (Country):",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.placeMarriageCountry?"Select Country":t.information.placeMarriageCountry,options:t.countries},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeMarriageCountry,fieldId:"placeMarriageCountry",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeMarriageCountry-marriage"+t.indexItem:"placeMarriageCountry-marriage"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(5)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateOfSeparation?t.information.class.dateOfSeparation:"",readonly:t.readonly,label:"Date of Separation:",id:""!==t.indexItem?"dateOfSeparation-marriage"+t.indexItem:"dateOfSeparation-marriage"+t.index,mask:"##/##/####",model:"marriageHistory",field:"dateOfSeparation"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.dateOfSeparation,fieldId:"dateOfSeparation",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-dateOfSeparation-marriage"+t.indexItem:"input-dateOfSeparation-marriage"+t.index})},change:t.changeCalendar},model:{value:t.information.dateOfSeparation,callback:function(e){t.$set(t.information,"dateOfSeparation",e)},expression:"information.dateOfSeparation"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateOfDivorce?t.information.class.dateOfDivorce:"",readonly:t.readonly,label:"Date of Divorce:",id:""!==t.indexItem?"dateOfDivorce-marriage"+t.indexItem:"dateOfDivorce-marriage"+t.index,mask:"##/##/####",model:"marriageHistory",field:"dateOfDivorce"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.dateOfDivorce,fieldId:"dateOfDivorce",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-dateOfDivorce-marriage"+t.indexItem:"input-dateOfDivorce-marriage"+t.index})},change:t.changeCalendar},model:{value:t.information.dateOfDivorce,callback:function(e){t.$set(t.information,"dateOfDivorce",e)},expression:"information.dateOfDivorce"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateOfDeath?t.information.class.dateOfDeath:"",readonly:t.readonly,label:"Date of Death:",id:""!==t.indexItem?"dateOfDeath-marriage"+t.indexItem:"dateOfDeath-marriage"+t.index,mask:"##/##/####",model:"marriageHistory",field:"dateOfDeath"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.dateOfDeath,fieldId:"dateOfDeath",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-dateOfDeath-marriage"+t.indexItem:"input-dateOfDeath-marriage"+t.index})},change:t.changeCalendar},model:{value:t.information.dateOfDeath,callback:function(e){t.$set(t.information,"dateOfDeath",e)},expression:"information.dateOfDeath"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeDivorceCity?t.information.class.placeDivorceCity:"",readonly:t.readonly,label:"Place of Divorce (City):",id:""!==t.indexItem?"placeDivorceCity-marriage"+t.indexItem:"placeDivorceCity-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeDivorceCity,fieldId:"placeDivorceCity",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeDivorceCity-marriage"+t.indexItem:"placeDivorceCity-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeDivorceCity",value:t.information.placeDivorceCity,id:""!==t.indexItem?"placeDivorceCity-marriage"+t.indexItem:"placeDivorceCity-marriage"+t.index})}},model:{value:t.information.placeDivorceCity,callback:function(e){t.$set(t.information,"placeDivorceCity",e)},expression:"information.placeDivorceCity"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{mask:"AA",classElement:void 0===t.information.class?"":void 0!==t.information.class.placeDivorceState?t.information.class.placeDivorceState:"",readonly:t.readonly,label:"Place of Divorce (xx):",id:""!==t.indexItem?"placeDivorceState-marriage"+t.indexItem:"placeDivorceState-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeDivorceState,fieldId:"placeDivorceState",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeDivorceState-marriage"+t.indexItem:"placeDivorceState-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeDivorceState",value:t.information.placeDivorceState,id:""!==t.indexItem?"placeDivorceState-marriage"+t.indexItem:"placeDivorceState-marriage"+t.index})}},model:{value:t.information.placeDivorceState,callback:function(e){t.$set(t.information,"placeDivorceState",e)},expression:"information.placeDivorceState"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateOfTermination?t.information.class.dateOfTermination:"",readonly:t.readonly,label:"Date of Termination:",id:""!==t.indexItem?"dateOfTermination-marriage"+t.indexItem:"dateOfTermination-marriage"+t.index,mask:"##/##/####",model:"marriageHistory",field:"dateOfTermination"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.dateOfTermination,fieldId:"dateOfTermination",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"input-dateOfTermination-marriage"+t.indexItem:"input-dateOfTermination-marriage"+t.index})},change:t.changeCalendar},model:{value:t.information.dateOfTermination,callback:function(e){t.$set(t.information,"dateOfTermination",e)},expression:"information.dateOfTermination"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeMarriageEndedCity?t.information.class.placeMarriageEndedCity:"",readonly:t.readonly,label:"Place Marriage Ended (City):",id:""!==t.indexItem?"placeMarriageEndedCity-marriage"+t.indexItem:"placeMarriageEndedCity-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeMarriageEndedCity,fieldId:"placeMarriageEndedCity",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeMarriageEndedCity-marriage"+t.indexItem:"placeMarriageEndedCity-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeMarriageEndedCity",value:t.information.placeMarriageEndedCity,id:""!==t.indexItem?"placeMarriageEndedCity-marriage"+t.indexItem:"placeMarriageEndedCity-marriage"+t.index})}},model:{value:t.information.placeMarriageEndedCity,callback:function(e){t.$set(t.information,"placeMarriageEndedCity",e)},expression:"information.placeMarriageEndedCity"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{mask:"AA",classElement:void 0===t.information.class?"":void 0!==t.information.class.placeMarriageEndedState?t.information.class.placeMarriageEndedState:"",readonly:t.readonly,label:"Place Marriage Ended (xx):",id:""!==t.indexItem?"placeMarriageEndedState-marriage"+t.indexItem:"placeMarriageEndedState-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeMarriageEndedState,fieldId:"placeMarriageEndedState",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeMarriageEndedState-marriage"+t.indexItem:"placeMarriageEndedState-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"placeMarriageEndedState",value:t.information.placeMarriageEndedState,id:""!==t.indexItem?"placeMarriageEndedState-marriage"+t.indexItem:"placeMarriageEndedState-marriage"+t.index})}},model:{value:t.information.placeMarriageEndedState,callback:function(e){t.$set(t.information,"placeMarriageEndedState",e)},expression:"information.placeMarriageEndedState"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"placeMarriageEndedCountry",id:""!==t.indexItem?"placeMarriageEndedCountry-marriage"+t.indexItem:"placeMarriageEndedCountry-marriage"+t.index,model:"marriageHistory",label:"Place Marriage Ended (Country):",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.placeMarriageEndedCountry?"Select Country":t.information.placeMarriageEndedCountry,options:t.countries},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeMarriageEndedCountry,fieldId:"placeMarriageEndedCountry",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"placeMarriageEndedCountry-marriage"+t.indexItem:"placeMarriageEndedCountry-marriage"+t.index})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.mannerMarriageEnded?t.information.class.mannerMarriageEnded:"",readonly:t.readonly,label:"Manner Marriage Ended:",id:""!==t.indexItem?"mannerMarriageEnded-marriage"+t.indexItem:"mannerMarriageEnded-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.mannerMarriageEnded,fieldId:"mannerMarriageEnded",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"mannerMarriageEnded-marriage"+t.indexItem:"mannerMarriageEnded-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"mannerMarriageEnded",value:t.information.mannerMarriageEnded,id:""!==t.indexItem?"mannerMarriageEnded-marriage"+t.indexItem:"mannerMarriageEnded-marriage"+t.index})}},model:{value:t.information.mannerMarriageEnded,callback:function(e){t.$set(t.information,"mannerMarriageEnded",e)},expression:"information.mannerMarriageEnded"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(6)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:"imigrationMarHis"}},[t._v("In immigration court proceedings:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.immigrationCourtProceedingsYes?t.information.class.immigrationCourtProceedingsYes:"",checked:"on"===t.information.immigrationCourtProceedingsYes,readonly:t.readonly,label:"Yes",name:"imigrationMarHis"+t.indexItem,id:""!==t.indexItem?"immigrationCourtProceedingsYes-marriage"+t.indexItem:"immigrationCourtProceedingsYes-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.immigrationCourtProceedingsYes,fieldId:"immigrationCourtProceedingsYes",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"immigrationCourtProceedingsYes-marriage"+t.indexItem:"immigrationCourtProceedingsYes-marriage"+t.index})},click:function(e){return t.changeRadio({type:"Yes",id:""!==t.indexItem?"immigrationCourtProceedingsYes-marriage"+t.indexItem:"immigrationCourtProceedingsYes-marriage"+t.index,key:"immigrationCourtProceedingsYesNo",keyThree:"immigrationCourtProceedingsYes"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.immigrationCourtProceedingsNo?t.information.class.immigrationCourtProceedingsNo:"",checked:"on"===t.information.immigrationCourtProceedingsNo,readonly:t.readonly,label:"No",name:"imigrationMarHis"+t.indexItem,id:""!==t.indexItem?"immigrationCourtProceedingsNo-marriage"+t.indexItem:"immigrationCourtProceedingsNo-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.immigrationCourtProceedingsNo,fieldId:"immigrationCourtProceedingsNo",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"immigrationCourtProceedingsNo-marriage"+t.indexItem:"immigrationCourtProceedingsNo-marriage"+t.index})},click:function(e){return t.changeRadio({type:"No",id:""!==t.indexItem?"immigrationCourtProceedingsNo-marriage"+t.indexItem:"immigrationCourtProceedingsNo-marriage"+t.index,key:"immigrationCourtProceedingsYesNo",keyThree:"immigrationCourtProceedingsNo"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:"personUsMarHis"}},[t._v("This person is in the US:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.inTheUsYes?t.information.class.inTheUsYes:"",checked:"on"===t.information.inTheUsYes,readonly:t.readonly,label:"Yes",name:"personUsMarHis"+t.indexItem,id:""!==t.indexItem?"inTheUsYes-marriage"+t.indexItem:"inTheUsYes-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.inTheUsYes,fieldId:"inTheUsYes",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"inTheUsYes-marriage"+t.indexItem:"inTheUsYes-marriage"+t.index})},click:function(e){return t.changeRadio({type:"Yes",id:""!==t.indexItem?"inTheUsYes-marriage"+t.indexItem:"inTheUsYes-marriage"+t.index,key:"inTheUsYesNo",keyThree:"inTheUsYes"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.inTheUsNo?t.information.class.inTheUsNo:"",checked:"on"===t.information.inTheUsNo,readonly:t.readonly,label:"No",name:"personUsMarHis"+t.indexItem,id:""!==t.indexItem?"inTheUsNo-marriage"+t.indexItem:"inTheUsNo-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.inTheUsNo,fieldId:"inTheUsNo",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"inTheUsNo-marriage"+t.indexItem:"inTheUsNo-marriage"+t.index})},click:function(e){return t.changeRadio({type:"No",id:""!==t.indexItem?"inTheUsNo-marriage"+t.indexItem:"inTheUsNo-marriage"+t.index,key:"inTheUsYesNo",keyThree:"inTheUsNo"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-12"},[n("pf-text-area",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.notes?t.information.class.notes:"",readonly:t.readonly,label:"Notes:",rows:5,cols:30,id:""!==t.indexItem?"notes-marriage"+t.indexItem:"notes-marriage"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.notes,fieldId:"notes",type:"marriageHistory",index:t.uniqueIndex,id:""!==t.indexItem?"notes-marriage"+t.indexItem:"notes-marriage"+t.index})},change:function(e){return t.updateModel({model:"marriageHistory",field:"notes",value:t.information.notes,id:""!==t.indexItem?"notes-marriage"+t.indexItem:"notes-marriage"+t.index})}},model:{value:t.information.notes,callback:function(e){t.$set(t.information,"notes",e)},expression:"information.notes"}})],1),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("marriageForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this marriage item?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteMarriage}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. Name")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. Residential / Mailing Address")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("4. Immigrantion / Civil Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("5. Biographic Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("6. Marriage Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("7. Marriage Termination Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("8. Other Details")])])}]};var ys=n("VU/8")(vs,Cs,!1,function(t){n("bz2F"),n("4EqQ"),n("s9lo")},"data-v-38d27d18",null).exports,ws={name:"pf-marriage-history",mixins:[Lt],props:{contactInformation:{type:Object},questionnaireid:{type:String}},components:{PfMarriage:ys,PfButton:d},created:function(){var t=this;this.type="itemMarriage",void 0===this.list&&-1!==this.contactId?this.apiService.getMarriageHistory({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listMarriageHistory&&(t.listRemote=e.listMarriageHistory),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"marriageHistory"})}}},Bs={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-marriage",{key:i,attrs:{information:e,id:"itemMarriage"+i,index:i,token:t.token,apiService:t.apiService,contactInformation:t.contactInformation,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-marriage":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemMarriageAdd"+t.questionnaireid:"itemMarriageAdd",contactId:t.contactId},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var ks=n("VU/8")(ws,Bs,!1,function(t){n("ksR/")},"data-v-0f1f4770",null).exports,Es={name:"pf-family-member",mixins:[ht],data:function(){return{isShow:!1,messageAccordion:"Show more...",countries:ft.COUNTRIES}},components:{PfRadio:P,PfCheckbox:x,PfSelect:k,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this family member?"},methods:{deleteMember:function(){this.deleteItem({model:"familyMembers",item:"delete-member"}),this.isPopUp=!1},setRelationship:function(t){this.information.relationship=t,this.updateMember(""!==this.indexItem?"relationship"+this.indexItem:"relationship"+this.index)},changeRadio:function(t){var e=this;this.information[t.key]=t.type;var n=this.information;Y()(this.radioGroups).forEach(function(i){-1!==e.radioGroups[i].indexOf(t.keyThree)&&e.radioGroups[i].forEach(function(i){i!==t.keyThree?(n[i]="off",!0===e.comparing&&(n.threeValues[i].manual="off")):(n[i]="on",!0===e.comparing&&(n.threeValues[i].manual="on"))})}),this.information={},this.information=n,this.updateModel({model:"familyMembers",field:t.key,value:t.type,id:t.id})},changeCheckbox:function(t){this.information[t.key]=t.type,this.updateModel({model:"familyMembers",field:t.key,value:t.type,id:t.id})},changeCalendarMember:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateMember(t.id)}},updateMember:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editFamilyMembers(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.familyMembersEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},Is={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("familymember")},mouseleave:function(e){return t.removeHover("familymember")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"familyMemberForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"familymember"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Name and Relationship":"Name and Relationship"))])])]),t._v(" "),n("div",{class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"col-md-6 col-lg-3":"col-md-4"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"firstName-family"+t.index:"firstName-family"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"firstName-family"+t.indexItem:"firstName-family"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.firstName?t.information.class.firstName:"",readonly:t.readonly,label:"First Name:"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.firstName,fieldId:"firstName",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"firstName-family"+t.indexItem:"firstName-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"firstName",value:t.information.firstName,id:""!==t.indexItem?"firstName-family"+t.indexItem:"firstName-family"+t.index})}},model:{value:t.information.firstName,callback:function(e){t.$set(t.information,"firstName",e)},expression:"information.firstName"}})],1),t._v(" "),n("div",{class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"col-md-6 col-lg-3":"col-md-4"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"lastName-family"+t.index:"lastName-family"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"lastName-family"+t.indexItem:"lastName-family"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.lastName?t.information.class.lastName:"",readonly:t.readonly,label:"Last Name:"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastName,fieldId:"lastName",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"lastName-family"+t.indexItem:"lastName-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"lastName",value:t.information.lastName,id:""!==t.indexItem?"lastName-family"+t.indexItem:"lastName-family"+t.index})}},model:{value:t.information.lastName,callback:function(e){t.$set(t.information,"lastName",e)},expression:"information.lastName"}})],1),t._v(" "),n("div",{class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"col-md-6 col-lg-3":"d-none"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.middleName?t.information.class.middleName:"",readonly:t.readonly,label:"Middle Name:",id:""!==t.indexItem?"middleName-family"+t.indexItem:"middleName-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.middleName,fieldId:"middleName",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"middleName-family"+t.indexItem:"middleName-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"middleName",value:t.information.middleName,id:""!==t.indexItem?"middleName-family"+t.indexItem:"middleName-family"+t.index})}},model:{value:t.information.middleName,callback:function(e){t.$set(t.information,"middleName",e)},expression:"information.middleName"}})],1),t._v(" "),n("div",{class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"col-md-6 col-lg-3":"d-none"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.maidenName?t.information.class.maidenName:"",readonly:t.readonly,label:"Maiden Name:",id:""!==t.indexItem?"maidenName-family"+t.indexItem:"maidenName-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.maidenName,fieldId:"maidenName",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"maidenName-family"+t.indexItem:"maidenName-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"maidenName",value:t.information.maidenName,id:""!==t.indexItem?"maidenName-family"+t.indexItem:"maidenName-family"+t.index})}},model:{value:t.information.maidenName,callback:function(e){t.$set(t.information,"maidenName",e)},expression:"information.maidenName"}})],1),t._v(" "),n("div",{staticClass:"spaceShowMore",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"col-12":"col-md-4"},[n("pf-select",{attrs:{divSelect:"marginBotZero",disabled:t.readonly,label:"Relationship:",field:"relationship",model:"familyMembers",id:""!==t.indexItem?"relationship"+t.indexItem:"relationship"+t.index,classElement:void 0===t.information.class?"select-jona":void 0!==t.information.class.relationship?t.information.class.relationship:"",options:[{name:"Other",value:"Other",selected:void 0!==this.information&&"Other"===this.information.relationship},{name:"Mother",value:"Mother",selected:void 0!==this.information&&"Mother"===this.information.relationship},{name:"Father",value:"Father",selected:void 0!==this.information&&"Father"===this.information.relationship},{name:"Spouse",value:"Spouse",selected:void 0!==this.information&&"Spouse"===this.information.relationship},{name:"Daughter",value:"Daughter",selected:void 0!==this.information&&"Daughter"===this.information.relationship},{name:"Son",value:"Son",selected:void 0!==this.information&&"Son"===this.information.relationship},{name:"Sibling",value:"Sibling",selected:void 0!==this.information&&"Sibling"===this.information.relationship},{name:"Stepmother",value:"Stepmother",selected:void 0!==this.information&&"Stepmother"===this.information.relationship},{name:"Stepfather",value:"Stepfather",selected:void 0!==this.information&&"Stepfather"===this.information.relationship},{name:"Stepson",value:"Stepson",selected:void 0!==this.information&&"Stepson"===this.information.relationship},{name:"Stepdaughter",value:"Stepdaughter",selected:void 0!==this.information&&"Stepdaughter"===this.information.relationship},{name:"Grandmother",value:"Grandmother",selected:void 0!==this.information&&"Grandmother"===this.information.relationship},{name:"Grandfather",value:"Grandfather",selected:void 0!==this.information&&"Grandfather"===this.information.relationship},{name:"Aunt",value:"Aunt",selected:void 0!==this.information&&"Aunt"===this.information.relationship},{name:"Uncle",value:"Uncle",selected:void 0!==this.information&&"Uncle"===this.information.relationship},{name:"Cousin",value:"Cousin",selected:void 0!==this.information&&"Cousin"===this.information.relationship},{name:"Niece",value:"Niece",selected:void 0!==this.information&&"Niece"===this.information.relationship},{name:"Nephew",value:"Nephew",selected:void 0!==this.information&&"Nephew"===this.information.relationship}]},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.relationship,fieldId:"relationship",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"relationship"+t.indexItem:"relationship"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionFamily"+t.indexItem:"#accordionFamily"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionFamily"+t.indexItem:"accordionFamily"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceAddress?t.information.class.placeOfResidenceAddress:"",readonly:t.readonly,label:"Address:",id:""!==t.indexItem?"placeOfResidenceAddress-family"+t.indexItem:"placeOfResidenceAddress-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceAddress,fieldId:"placeOfResidenceAddress",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceAddress-family"+t.indexItem:"placeOfResidenceAddress-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"placeOfResidenceAddress",value:t.information.placeOfResidenceAddress,id:""!==t.indexItem?"placeOfResidenceAddress-family"+t.indexItem:"placeOfResidenceAddress-family"+t.index})}},model:{value:t.information.placeOfResidenceAddress,callback:function(e){t.$set(t.information,"placeOfResidenceAddress",e)},expression:"information.placeOfResidenceAddress"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group"},[n("div",{staticClass:"form-check form-check-inline marginBotRem"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceApt?t.information.class.placeOfResidenceApt:"",checked:"on"===t.information.placeOfResidenceApt,readonly:t.readonly,value:"1",label:"APT",name:"aptSteFlFaMe"+t.indexItem,id:""!==t.indexItem?"placeOfResidenceApt-family"+t.indexItem:"placeOfResidenceApt-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceApt,fieldId:"placeOfResidenceApt",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceApt-family"+t.indexItem:"placeOfResidenceApt-family"+t.index})},click:function(e){return t.changeRadio({type:"apt",id:""!==t.indexItem?"placeOfResidenceApt-family"+t.indexItem:"placeOfResidenceApt-family"+t.index,key:"isAptSteFloor",keyThree:"placeOfResidenceApt"})}}})],1),t._v(" "),n("div",{staticClass:"form-check form-check-inline"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceSte?t.information.class.placeOfResidenceSte:"",checked:"on"===t.information.placeOfResidenceSte,readonly:t.readonly,value:"2",label:"STE",name:"aptSteFlFaMe"+t.indexItem,id:""!==t.indexItem?"placeOfResidenceSte-family"+t.indexItem:"placeOfResidenceSte-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceSte,fieldId:"placeOfResidenceSte",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceSte-family"+t.indexItem:"placeOfResidenceSte-family"+t.index})},click:function(e){return t.changeRadio({type:"ste",id:""!==t.indexItem?"placeOfResidenceSte-family"+t.indexItem:"placeOfResidenceSte-family"+t.index,key:"isAptSteFloor",keyThree:"placeOfResidenceSte"})}}})],1),t._v(" "),n("div",{staticClass:"form-check form-check-inline"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceFlr?t.information.class.placeOfResidenceFlr:"",checked:"on"===t.information.placeOfResidenceFlr,readonly:t.readonly,value:"3",label:"FLOOR",name:"aptSteFlFaMe"+t.indexItem,id:""!==t.indexItem?"placeOfResidenceFlr-family"+t.indexItem:"placeOfResidenceFlr-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceFlr,fieldId:"placeOfResidenceFlr",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceFlr-family"+t.indexItem:"placeOfResidenceFlr-family"+t.index})},click:function(e){return t.changeRadio({type:"floor",id:""!==t.indexItem?"placeOfResidenceFlr-family"+t.indexItem:"placeOfResidenceFlr-family"+t.index,key:"isAptSteFloor",keyThree:"placeOfResidenceFlr"})}}})],1),t._v(" "),n("pf-input",{attrs:{id:""!==t.indexItem?"placeOfResidenceAptSteFlrNumbertxt-family"+t.indexItem:"placeOfResidenceAptSteFlrNumbertxt-family"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceAptSteFlrNumbertxt?t.information.class.placeOfResidenceAptSteFlrNumbertxt:"",readonly:t.readonly},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceAptSteFlrNumbertxt,fieldId:"placeOfResidenceAptSteFlrNumbertxt",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceAptSteFlrNumbertxt-family"+t.indexItem:"placeOfResidenceAptSteFlrNumbertxt-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"placeOfResidenceAptSteFlrNumbertxt",value:t.information.placeOfResidenceAptSteFlrNumbertxt,id:""!==t.indexItem?"placeOfResidenceAptSteFlrNumbertxt-family"+t.indexItem:"placeOfResidenceAptSteFlrNumbertxt-family"+t.index})}},model:{value:t.information.placeOfResidenceAptSteFlrNumbertxt,callback:function(e){t.$set(t.information,"placeOfResidenceAptSteFlrNumbertxt",e)},expression:"information.placeOfResidenceAptSteFlrNumbertxt"}})],1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceCity?t.information.class.placeOfResidenceCity:"",readonly:t.readonly,label:"City:",id:""!==t.indexItem?"placeOfResidenceCity-family"+t.indexItem:"placeOfResidenceCity-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceCity,fieldId:"placeOfResidenceCity",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceCity-family"+t.indexItem:"placeOfResidenceCity-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"placeOfResidenceCity",value:t.information.placeOfResidenceCity,id:""!==t.indexItem?"placeOfResidenceCity-family"+t.indexItem:"placeOfResidenceCity-family"+t.index})}},model:{value:t.information.placeOfResidenceCity,callback:function(e){t.$set(t.information,"placeOfResidenceCity",e)},expression:"information.placeOfResidenceCity"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceState?t.information.class.placeOfResidenceState:"",readonly:t.readonly,label:"State:",id:""!==t.indexItem?"placeOfResidenceState-family"+t.indexItem:"placeOfResidenceState-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceState,fieldId:"placeOfResidenceState",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceState-family"+t.indexItem:"placeOfResidenceState-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"placeOfResidenceState",value:t.information.placeOfResidenceState,id:""!==t.indexItem?"placeOfResidenceState-family"+t.indexItem:"placeOfResidenceState-family"+t.index})}},model:{value:t.information.placeOfResidenceState,callback:function(e){t.$set(t.information,"placeOfResidenceState",e)},expression:"information.placeOfResidenceState"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"placeOfResidenceCountry",id:""!==t.indexItem?"placeOfResidenceCountry-family"+t.indexItem:"placeOfResidenceCountry-family"+t.index,model:"familyMembers",label:"Country:",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.placeOfResidenceCountry?"Select Country":t.information.placeOfResidenceCountry,options:t.countries},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceCountry,fieldId:"placeOfResidenceCountry",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceCountry-family"+t.indexItem:"placeOfResidenceCountry-family"+t.index})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceZipCode?t.information.class.placeOfResidenceZipCode:"",readonly:t.readonly,label:"Zip Code:",id:""!==t.indexItem?"placeOfResidenceZipCode-family"+t.indexItem:"placeOfResidenceZipCode-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceZipCode,fieldId:"placeOfResidenceZipCode",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceZipCode-family"+t.indexItem:"placeOfResidenceZipCode-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"placeOfResidenceZipCode",value:t.information.placeOfResidenceZipCode,id:""!==t.indexItem?"placeOfResidenceZipCode-family"+t.indexItem:"placeOfResidenceZipCode-family"+t.index})}},model:{value:t.information.placeOfResidenceZipCode,callback:function(e){t.$set(t.information,"placeOfResidenceZipCode",e)},expression:"information.placeOfResidenceZipCode"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidenceForeignProvince?t.information.class.placeOfResidenceForeignProvince:"",readonly:t.readonly,label:"Foreign Province:",id:""!==t.indexItem?"placeOfResidenceForeignProvince-family"+t.indexItem:"placeOfResidenceForeignProvince-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidenceForeignProvince,fieldId:"placeOfResidenceForeignProvince",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidenceForeignProvince-family"+t.indexItem:"placeOfResidenceForeignProvince-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"placeOfResidenceForeignProvince",value:t.information.placeOfResidenceForeignProvince,id:""!==t.indexItem?"placeOfResidenceForeignProvince-family"+t.indexItem:"placeOfResidenceForeignProvince-family"+t.index})}},model:{value:t.information.placeOfResidenceForeignProvince,callback:function(e){t.$set(t.information,"placeOfResidenceForeignProvince",e)},expression:"information.placeOfResidenceForeignProvince"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfResidencePostalCode?t.information.class.placeOfResidencePostalCode:"",readonly:t.readonly,label:"Postal Code:",id:""!==t.indexItem?"placeOfResidencePostalCode-family"+t.indexItem:"placeOfResidencePostalCode-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfResidencePostalCode,fieldId:"placeOfResidencePostalCode",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfResidencePostalCode-family"+t.indexItem:"placeOfResidencePostalCode-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"placeOfResidencePostalCode",value:t.information.placeOfResidencePostalCode,id:""!==t.indexItem?"placeOfResidencePostalCode-family"+t.indexItem:"placeOfResidencePostalCode-family"+t.index})}},model:{value:t.information.placeOfResidencePostalCode,callback:function(e){t.$set(t.information,"placeOfResidencePostalCode",e)},expression:"information.placeOfResidencePostalCode"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group marginBotZero mb-2"},[n("label",{attrs:{for:"postalCodeFaMe"}},[t._v("Is this person currently in the United States?")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.inTheUsYes?t.information.class.inTheUsYes:"",checked:"on"===t.information.inTheUsYes,readonly:t.readonly,label:"Yes",name:"postalCodeFaMe"+t.indexItem,id:""!==t.indexItem?"inTheUsYes-family"+t.indexItem:"inTheUsYes-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.inTheUsYes,fieldId:"inTheUsYes",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"inTheUsYes-family"+t.indexItem:"inTheUsYes-family"+t.index})},click:function(e){return t.changeRadio({type:"Yes",id:""!==t.indexItem?"inTheUsYes-family"+t.indexItem:"inTheUsYes-family"+t.index,key:"inTheUsYesNo",keyThree:"inTheUsYes"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.inTheUsNo?t.information.class.inTheUsNo:"",checked:"on"===t.information.inTheUsNo,readonly:t.readonly,label:"No",name:"postalCodeFaMe"+t.indexItem,id:""!==t.indexItem?"inTheUsNo-family"+t.indexItem:"inTheUsNo-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.inTheUsNo,fieldId:"inTheUsNo",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"inTheUsNo-family"+t.indexItem:"inTheUsNo-family"+t.index})},click:function(e){return t.changeRadio({type:"No",id:""!==t.indexItem?"inTheUsNo-family"+t.indexItem:"inTheUsNo-family"+t.index,key:"inTheUsYesNo",keyThree:"inTheUsNo"})}}})],1)])])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.dateOfBirth?t.information.class.dateOfBirth:"",readonly:t.readonly,label:"Date of Birth:",id:""!==t.indexItem?"dateOfBirth-FM"+t.indexItem:"dateOfBirth-FM"+t.index,mask:"##/##/####",model:"familyMembers",field:"dateOfBirth"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.dateOfBirth,fieldId:"dateOfBirth",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"dateOfBirth-FM"+t.indexItem:"dateOfBirth-FM"+t.index})},change:t.changeCalendar},model:{value:t.information.dateOfBirth,callback:function(e){t.$set(t.information,"dateOfBirth",e)},expression:"information.dateOfBirth"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfBirthCity?t.information.class.placeOfBirthCity:"",readonly:t.readonly,label:"In which city was this person born?",id:""!==t.indexItem?"placeOfBirthCity-family"+t.indexItem:"placeOfBirthCity-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfBirthCity,fieldId:"placeOfBirthCity",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfBirthCity-family"+t.indexItem:"placeOfBirthCity-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"placeOfBirthCity",value:t.information.placeOfBirthCity,id:""!==t.indexItem?"placeOfBirthCity-family"+t.indexItem:"placeOfBirthCity-family"+t.index})}},model:{value:t.information.placeOfBirthCity,callback:function(e){t.$set(t.information,"placeOfBirthCity",e)},expression:"information.placeOfBirthCity"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.placeOfBirthState?t.information.class.placeOfBirthState:"",readonly:t.readonly,label:"In which state was this person born?",id:""!==t.indexItem?"placeOfBirthState-family"+t.indexItem:"placeOfBirthState-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfBirthState,fieldId:"placeOfBirthState",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfBirthState-family"+t.indexItem:"placeOfBirthState-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"placeOfBirthState",value:t.information.placeOfBirthState,id:""!==t.indexItem?"placeOfBirthState-family"+t.indexItem:"placeOfBirthState-family"+t.index})}},model:{value:t.information.placeOfBirthState,callback:function(e){t.$set(t.information,"placeOfBirthState",e)},expression:"information.placeOfBirthState"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"placeOfBirthCountry",id:""!==t.indexItem?"placeOfBirthCountry-family"+t.indexItem:"placeOfBirthCountry-family"+t.index,model:"familyMembers",label:"In which country was this person born?",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.placeOfBirthCountry?"Select Country":t.information.placeOfBirthCountry,options:t.countries},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.placeOfBirthCountry,fieldId:"placeOfBirthCountry",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"placeOfBirthCountry-family"+t.indexItem:"placeOfBirthCountry-family"+t.index})},change:t.changeSelect}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.race?t.information.class.race:"",readonly:t.readonly,label:"Race:",id:""!==t.indexItem?"race-family"+t.indexItem:"race-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.race,fieldId:"race",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"race-family"+t.indexItem:"race-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"race",value:t.information.race,id:""!==t.indexItem?"race-family"+t.indexItem:"race-family"+t.index})}},model:{value:t.information.race,callback:function(e){t.$set(t.information,"race",e)},expression:"information.race"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-select",{attrs:{field:"nationality",id:""!==t.indexItem?"nationality-family"+t.indexItem:"nationality-family"+t.index,model:"familyMembers",label:"Nationality:",disabled:t.readonly,classElement:"select-jona",value:void 0===t.information.nationality?"Select Nationality":t.information.nationality,options:t.countries},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.nationality,fieldId:"nationality",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"nationality-family"+t.indexItem:"nationality-family"+t.index})},change:t.changeSelect}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group marginBotZero"},[n("label",{attrs:{for:"sexFaMe"}},[t._v("Sex:")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sexFemaleCk?t.information.class.sexFemaleCk:"",checked:"on"===t.information.sexFemaleCk,readonly:t.readonly,label:"Female",name:"femaleCkGroup"+t.indexItem,id:""!==t.indexItem?"sexFemaleCk-family"+t.indexItem:"sexFemaleCk-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.sexFemaleCk,fieldId:"sexFemaleCk",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"sexFemaleCk-family"+t.indexItem:"sexFemaleCk-family"+t.index})},click:function(e){return t.changeRadio({type:"female",id:""!==t.indexItem?"sexFemaleCk-family"+t.indexItem:"sexFemaleCk-family"+t.index,key:"sex",keyThree:"sexFemaleCk"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.sexMaleCk?t.information.class.sexMaleCk:"",checked:"on"===t.information.sexMaleCk,readonly:t.readonly,label:"Male",name:"femaleCkGroup"+t.indexItem,id:""!==t.indexItem?"sexMaleCk-family"+t.indexItem:"sexMaleCk-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.sexMaleCk,fieldId:"sexMaleCk",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"sexMaleCk-family"+t.indexItem:"sexMaleCk-family"+t.index})},click:function(e){return t.changeRadio({type:"male",id:""!==t.indexItem?"sexMaleCk-family"+t.indexItem:"sexMaleCk-family"+t.index,key:"sex",keyThree:"sexMaleCk"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group marginBotZero"},[n("label",{attrs:{for:"deceasedFaMe w-100"}},[t._v("Is this person deceased?")]),t._v(" "),n("div",{staticClass:"checkbox"},[n("pf-checkbox",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.deceased?t.information.class.deceased:"",checked:"on"===t.information.deceased,readonly:t.readonly,label:"Yes",id:void 0!==t.index?"deceased"+t.index:"deceased"+t.indexItem},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.deceased,fieldId:"deceased",type:"familyMembers",index:t.uniqueIndex,id:void 0!==t.index?"deceased"+t.index:"deceased"+t.indexItem})},click:function(e){return t.changeCheckbox({type:"on"===t.information.deceased?"off":"on",id:void 0!==t.index?"deceased"+t.index:"deceased"+t.indexItem,key:"deceased"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.maritalStatus?t.information.class.maritalStatus:"",readonly:t.readonly,label:"Marital Status:",id:""!==t.indexItem?"maritalStatus-family"+t.indexItem:"maritalStatus-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.maritalStatus,fieldId:"maritalStatus",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"maritalStatus-family"+t.indexItem:"maritalStatus-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"maritalStatus",value:t.information.maritalStatus,id:""!==t.indexItem?"maritalStatus-family"+t.indexItem:"maritalStatus-family"+t.index})}},model:{value:t.information.maritalStatus,callback:function(e){t.$set(t.information,"maritalStatus",e)},expression:"information.maritalStatus"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(2)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.passportNumber?t.information.class.passportNumber:"",readonly:t.readonly,label:"Passport Number:",id:""!==t.indexItem?"passportNumber-family"+t.indexItem:"passportNumber-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.passportNumber,fieldId:"passportNumber",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"passportNumber-family"+t.indexItem:"passportNumber-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"passportNumber",value:t.information.passportNumber,id:""!==t.indexItem?"passportNumber-family"+t.indexItem:"passportNumber-family"+t.index})}},model:{value:t.information.passportNumber,callback:function(e){t.$set(t.information,"passportNumber",e)},expression:"information.passportNumber"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{mask:"###-##-####",placeholder:"999-99-9999",classElement:void 0===t.information.class?"":void 0!==t.information.class.socialSecurityNumber?t.information.class.socialSecurityNumber:"",readonly:t.readonly,label:"Social Security Number:",id:""!==t.indexItem?"socialSecurityNumber-family"+t.indexItem:"socialSecurityNumber-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.socialSecurityNumber,fieldId:"socialSecurityNumber",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"socialSecurityNumber-family"+t.indexItem:"socialSecurityNumber-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"socialSecurityNumber",value:t.information.socialSecurityNumber,id:""!==t.indexItem?"socialSecurityNumber-family"+t.indexItem:"socialSecurityNumber-family"+t.index})}},model:{value:t.information.socialSecurityNumber,callback:function(e){t.$set(t.information,"socialSecurityNumber",e)},expression:"information.socialSecurityNumber"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{mask:"###-###-####",placeholder:"999-999-9999",classElement:void 0===t.information.class?"":void 0!==t.information.class.aNumber?t.information.class.aNumber:"",readonly:t.readonly,label:"USCIS Number (Alien Number or A#):",id:""!==t.indexItem?"aNumber-family"+t.indexItem:"aNumber-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.aNumber,fieldId:"aNumber",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"aNumber-family"+t.indexItem:"aNumber-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"aNumber",value:t.information.aNumber,id:""!==t.indexItem?"aNumber-family"+t.indexItem:"aNumber-family"+t.index})}},model:{value:t.information.aNumber,callback:function(e){t.$set(t.information,"aNumber",e)},expression:"information.aNumber"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.i94?t.information.class.i94:"",readonly:t.readonly,label:"I-94 Number:",id:""!==t.indexItem?"i94-family"+t.indexItem:"i94-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.i94,fieldId:"i94",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"i94-family"+t.indexItem:"i94-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"i94",value:t.information.i94,id:""!==t.indexItem?"i94-family"+t.indexItem:"i94-family"+t.index})}},model:{value:t.information.i94,callback:function(e){t.$set(t.information,"i94",e)},expression:"information.i94"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lastEntryCity?t.information.class.lastEntryCity:"",readonly:t.readonly,label:"In wihch city did this person most recently enter the United States?",id:""!==t.indexItem?"lastEntryCity-family"+t.indexItem:"lastEntryCity-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastEntryCity,fieldId:"lastEntryCity",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"lastEntryCity-family"+t.indexItem:"lastEntryCity-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"lastEntryCity",value:t.information.lastEntryCity,id:""!==t.indexItem?"lastEntryCity-family"+t.indexItem:"lastEntryCity-family"+t.index})}},model:{value:t.information.lastEntryCity,callback:function(e){t.$set(t.information,"lastEntryCity",e)},expression:"information.lastEntryCity"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lastEntryState?t.information.class.lastEntryState:"",readonly:t.readonly,label:"In which state did this person last enter the United States?",id:""!==t.indexItem?"lastEntryState-family"+t.indexItem:"lastEntryState-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastEntryState,fieldId:"lastEntryState",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"lastEntryState-family"+t.indexItem:"lastEntryState-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"lastEntryState",value:t.information.lastEntryState,id:""!==t.indexItem?"lastEntryState-family"+t.indexItem:"lastEntryState-family"+t.index})}},model:{value:t.information.lastEntryState,callback:function(e){t.$set(t.information,"lastEntryState",e)},expression:"information.lastEntryState"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lastEntryDate?t.information.class.lastEntryDate:"",readonly:t.readonly,label:"When did this person last enter the United States (if applicable)?",id:""!==t.indexItem?"lastEntryDate-FM"+t.indexItem:"lastEntryDate-FM"+t.index,mask:"##/##/####",model:"familyMembers",field:"lastEntryDate"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastEntryDate,fieldId:"lastEntryDate",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"lastEntryDate-FM"+t.indexItem:"lastEntryDate-FM"+t.index})},change:t.changeCalendar},model:{value:t.information.lastEntryDate,callback:function(e){t.$set(t.information,"lastEntryDate",e)},expression:"information.lastEntryDate"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.lastEntryStatus?t.information.class.lastEntryStatus:"",readonly:t.readonly,label:"In which status did this person enter the United States (with visa, without visa etc.)?",id:""!==t.indexItem?"lastEntryStatus-family"+t.indexItem:"lastEntryStatus-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.lastEntryStatus,fieldId:"lastEntryStatus",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"lastEntryStatus-family"+t.indexItem:"lastEntryStatus-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"lastEntryStatus",value:t.information.lastEntryStatus,id:""!==t.indexItem?"lastEntryStatus-family"+t.indexItem:"lastEntryStatus-family"+t.index})}},model:{value:t.information.lastEntryStatus,callback:function(e){t.$set(t.information,"lastEntryStatus",e)},expression:"information.lastEntryStatus"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.expirationAuthorizedStay?t.information.class.expirationAuthorizedStay:"",readonly:t.readonly,label:"If this person entered legally, when did their permission to stay in the United States expire?",id:""!==t.indexItem?"expirationAuthorizedStay-FM"+t.indexItem:"expirationAuthorizedStay-FM"+t.index,mask:"##/##/####",model:"familyMembers",field:"expirationAuthorizedStay"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.expirationAuthorizedStay,fieldId:"expirationAuthorizedStay",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"expirationAuthorizedStay-FM"+t.indexItem:"expirationAuthorizedStay-FM"+t.index})},change:t.changeCalendar},model:{value:t.information.expirationAuthorizedStay,callback:function(e){t.$set(t.information,"expirationAuthorizedStay",e)},expression:"information.expirationAuthorizedStay"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.usLegalStatus?t.information.class.usLegalStatus:"",readonly:t.readonly,label:"What is the legal status of this person in the United States (for example, United States Citizen, Resident, Visitor, None)?",id:""!==t.indexItem?"usLegalStatus-family"+t.indexItem:"usLegalStatus-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.usLegalStatus,fieldId:"usLegalStatus",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"usLegalStatus-family"+t.indexItem:"usLegalStatus-family"+t.index})},change:function(e){return t.updateModel({model:"familyMembers",field:"usLegalStatus",value:t.information.usLegalStatus,id:""!==t.indexItem?"usLegalStatus-family"+t.indexItem:"usLegalStatus-family"+t.index})}},model:{value:t.information.usLegalStatus,callback:function(e){t.$set(t.information,"usLegalStatus",e)},expression:"information.usLegalStatus"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:"inmigrationProsFaMe"}},[t._v("Does this person currently have a case with the immigration court?")]),t._v(" "),n("div",{},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.immigrationCourtProceedingsYes?t.information.class.immigrationCourtProceedingsYes:"",checked:"on"===t.information.immigrationCourtProceedingsYes,readonly:t.readonly,label:"Yes",name:"inmigrationProsFaMe"+t.indexItem,id:""!==t.indexItem?"immigrationCourtProceedingsYes-family"+t.indexItem:"immigrationCourtProceedingsYes-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.immigrationCourtProceedingsYes,fieldId:"immigrationCourtProceedingsYes",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"immigrationCourtProceedingsYes-family"+t.indexItem:"immigrationCourtProceedingsYes-family"+t.index})},click:function(e){return t.changeRadio({type:"Yes",id:""!==t.indexItem?"immigrationCourtProceedingsYes-family"+t.indexItem:"immigrationCourtProceedingsYes-family"+t.index,key:"immigrationCourtProceedingsYesNo",keyThree:"immigrationCourtProceedingsYes"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.immigrationCourtProceedingsNo?t.information.class.immigrationCourtProceedingsNo:"",checked:"on"===t.information.immigrationCourtProceedingsNo,readonly:t.readonly,label:"No",name:"inmigrationProsFaMe"+t.indexItem,id:""!==t.indexItem?"immigrationCourtProceedingsNo-family"+t.indexItem:"immigrationCourtProceedingsNo-family"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.immigrationCourtProceedingsNo,fieldId:"immigrationCourtProceedingsNo",type:"familyMembers",index:t.uniqueIndex,id:""!==t.indexItem?"immigrationCourtProceedingsNo-family"+t.indexItem:"immigrationCourtProceedingsNo-family"+t.index})},click:function(e){return t.changeRadio({type:"No",id:""!==t.indexItem?"immigrationCourtProceedingsNo-family"+t.indexItem:"immigrationCourtProceedingsNo-family"+t.index,key:"immigrationCourtProceedingsYesNo",keyThree:"immigrationCourtProceedingsNo"})}}})],1)])]),t._v(" "),n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("familyMemberForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this member?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteMember}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. Place Of Residence")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. Biographic Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("4. Documents and Entry Information")])])}]};var Ds=n("VU/8")(Es,Is,!1,function(t){n("PeZz"),n("Sx3H"),n("bAUi")},"data-v-ee88fb60",null).exports,Ss={name:"pf-family-memebers",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfFamilyMember:Ds,PfButton:d},created:function(){var t=this;this.type="itemFamilyMember",void 0===this.list&&-1!==this.contactId?this.apiService.getFamilyMembers({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listFamilyMembers&&(t.listRemote=e.listFamilyMembers),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"familyMembers"})}}},Ns={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-family-member",{key:i,attrs:{information:e,id:"itemFamilyMember"+i,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-member":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemFamilyMemberAdd"+t.questionnaireid:"itemFamilyMemberAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var Ms=n("VU/8")(Ss,Ns,!1,function(t){n("SNj9")},"data-v-7f09409e",null).exports,Os={name:"pf-advance",data:function(){return{isShow:!1,messageAccordion:"Show more..."}},mixins:[ht],components:{PfTextArea:T,PfPopUp:$},mounted:function(){this.messageModal="Are you really sure delete this advance?"},methods:{deleteAdvance:function(){var t=this;this.deleteItem({model:"advanceParole",item:"delete-advance"}),this.apiService.deleteAdvanceParole({id:this.information.id,token:this.token}).then(function(e){void 0!==e&&e.advanceParoleDelete&&t.$emit("delete-advance")}),this.isPopUp=!1},changeCalendarAdvance:function(t){if(""!==t.shortDate&&document.getElementById(t.id).classList.remove("is-invalid"),!0===this.comparing)this.$emit("change-calendar",t);else{var e=t.id.split("-")[1];this.information[e]=t.shortDate,this.updateAdvance(t.id)}},updateAdvance:function(t){var e=this;!0===this.validateField(t)&&(this.information.token=this.token,this.apiService.editAdvanceParole(this.information).then(function(n){var i=document.getElementById(t),a="";a=void 0!==n&&n.advanceParoleEdit?"updated":"error",e.setFlash({el:i,action:a})}))},setAccordion:function(){this.isShow=!this.isShow,this.messageAccordion=!0===this.isShow?"Show less...":"Show more..."}}},Ts={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return void 0!==t.information&&(null===t.information.deletedAt||void 0===t.information.deletedAt)||!0===t.comparing?n("div",[void 0!==t.information&&Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pr-0 text-right"},[!1!==t.readonly||t.information.newItem||null!==t.information.deletedAt&&void 0!==t.information.deletedAt&&""!==t.information.deletedAt?t._e():n("i",{staticClass:"far fa-times-circle arrowClose",attrs:{id:"remove"+t.idComponent},on:{mouseenter:function(e){return t.setHover("parole")},mouseleave:function(e){return t.removeHover("parole")},click:function(e){t.isPopUp=!0}}})])]):t._e(),t._v(" "),n("form",{attrs:{id:"advanceForm"+t.index}},[n("div",{staticClass:"boxContainer",class:!0===t.information.newItem?"newItem":"",style:"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("edit")?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt||void 0!==t.information.threeValues&&void 0!==t.information.threeValues.deletedAt&&!0===t.comparing&&null!==t.information.threeValues.deletedAt.edit&&void 0!==t.information.threeValues.deletedAt.edit?"z-index: 200;filter:blur(1.5px);pointer-events: none;cursor:not-allowed;background-color: #ffefef !important;border: 1px solid red !important;":"string"==typeof t.information.id&&!0===t.comparing&&-1!==t.information.id.indexOf("tmp")&&-1!==t.indexItem.indexOf("manual")?"background-color: #f8fff7 !important;border: 1px solid green !important;":"",attrs:{id:"parole"+t.idComponent}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBox",class:!0===t.information.newItem?"bgTitlesBoxNewI":!0===t.comparing&&null!==t.information.deletedAt&&void 0!==t.information.deletedAt?"backgroundTitlesBoxDeleted":""},[n("h6",{staticClass:"mrTextSpace"},[n("b",[t._v(t._s(!0===t.isShow||!0===t.information.newItem?"1. Dates of Validity":"Country to Visit and Dates of Validity"))])])]),t._v(" "),n("div",{staticClass:"col-md-4",class:!0===t.isShow||!0===t.information.newItem||!0===t.comparing?"d-none":""},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"countryy-AP-hide"+t.index:"countryy-AP-hide"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"countryy-AP-hide"+t.indexItem:"countryy-AP-hide"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.country?t.information.class.country:"",readonly:t.readonly,label:"Country to Visit:"},on:{change:function(e){return t.updateModel({model:"advanceParole",field:"country",value:t.information.country,id:""!==t.indexItem?"countryy-AP-hide"+t.indexItem:"countryy-AP-hide"+t.index})}},model:{value:t.information.country,callback:function(e){t.$set(t.information,"country",e)},expression:"information.country"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.validfrom?t.information.class.validfrom:"",readonly:t.readonly,label:"Valid From:",id:""!==t.indexItem?"validfromm-AP"+t.indexItem:"validfromm-AP"+t.index,mask:"##/##/####",model:"advanceParole",field:"validfrom"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.validfrom,fieldId:"validfrom",type:"adavnceParole",index:t.uniqueIndex,id:""!==t.indexItem?"input-validfromm-AP"+t.indexItem:"input-validfromm-AP"+t.index})},change:t.changeCalendar},model:{value:t.information.validfrom,callback:function(e){t.$set(t.information,"validfrom",e)},expression:"information.validfrom"}})],1),t._v(" "),n("div",{staticClass:"col-md-4 spaceShowMore"},[n("pf-calendar",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.validuntil?t.information.class.validuntil:"",readonly:t.readonly,label:"Valid Until (Expiration):",id:""!==t.indexItem?"validuntil-AP"+t.indexItem:"validuntil-AP"+t.index,mask:"##/##/####",divCalendar:"marginBotZero",model:"advanceParole",field:"validuntil"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.validuntil,fieldId:"validuntil",type:"adavnceParole",index:t.uniqueIndex,id:""!==t.indexItem?"input-validuntil-AP"+t.indexItem:"input-validuntil-AP"+t.index})},change:t.changeCalendar},model:{value:t.information.validuntil,callback:function(e){t.$set(t.information,"validuntil",e)},expression:"information.validuntil"}})],1)]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"d-none":"accordion"},[n("span",{staticClass:"showMore",attrs:{"data-toggle":"collapse","data-target":""!==t.indexItem?"#accordionAdvance"+t.indexItem:"#accordionAdvance"+t.index},on:{click:t.setAccordion}},[n("i",{class:!1===t.isShow?"fas fa-arrow-circle-down":"fas fa-arrow-circle-up"}),t._v(" "+t._s(t.messageAccordion))])]),t._v(" "),n("div",{class:!0===t.information.newItem||!0===t.comparing?"":"collapse",attrs:{id:""!==t.indexItem?"accordionAdvance"+t.indexItem:"accordionAdvance"+t.index}},[n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(0)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"receiptnum-AP"+t.index:"receiptnum-AP"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"receiptnum-AP"+t.indexItem:"receiptnum-AP"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.receiptnum?t.information.class.receiptnum:"",readonly:t.readonly,label:"Receipt Number:"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.receiptnum,fieldId:"receiptnum",type:"adavnceParole",index:t.uniqueIndex,id:""!==t.indexItem?"receiptnum-AP"+t.indexItem:"receiptnum-AP"+t.index})},change:function(e){return t.updateModel({model:"advanceParole",field:"receiptnum",value:t.information.receiptnum,id:""!==t.indexItem?"receiptnum-AP"+t.indexItem:"receiptnum-AP"+t.index})}},model:{value:t.information.receiptnum,callback:function(e){t.$set(t.information,"receiptnum",e)},expression:"information.receiptnum"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-calendar",{attrs:{validate:"required",name:void 0!==t.index?"input-receiptdate-AP"+t.index:"input-receiptdate-AP"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"receiptdate-AP"+t.indexItem:"receiptdate-AP"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.receiptdate?t.information.class.receiptdate:"",readonly:t.readonly,label:"Receipt Date:",mask:"##/##/####",model:"advanceParole",field:"receiptdate"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.receiptdate,fieldId:"receiptdate",type:"adavnceParole",index:t.uniqueIndex,id:""!==t.indexItem?"input-receiptdate-AP"+t.indexItem:"input-receiptdate-AP"+t.index})},change:t.changeCalendar},model:{value:t.information.receiptdate,callback:function(e){t.$set(t.information,"receiptdate",e)},expression:"information.receiptdate"}})],1),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.anum?t.information.class.anum:"",readonly:t.readonly,label:"USCIS Number (A#):",id:""!==t.indexItem?"anum-AP"+t.indexItem:"anum-AP"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.anum,fieldId:"anum",type:"adavnceParole",index:t.uniqueIndex,id:""!==t.indexItem?"anum-AP"+t.indexItem:"anum-AP"+t.index})},change:function(e){return t.updateModel({model:"advanceParole",field:"anum",value:t.information.anum,id:""!==t.indexItem?"anum-AP"+t.indexItem:"anum-AP"+t.index})}},model:{value:t.information.anum,callback:function(e){t.$set(t.information,"anum",e)},expression:"information.anum"}})],1)]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"backgroundTitlesBoxNoBorder",class:!0===t.information.newItem?"bgTitlesBoxNewINoborder":""},[t._m(1)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{validate:"required",name:void 0!==t.index?"country-AP"+t.index:"country-AP"+t.indexItem,labelStyle:!0===t.information.newItem?"color:red;":"",id:""!==t.indexItem?"country-AP"+t.indexItem:"country-AP"+t.index,classElement:void 0===t.information.class?"":void 0!==t.information.class.country?t.information.class.country:"",readonly:t.readonly,label:"Country to Visit:"},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.country,fieldId:"country",type:"adavnceParole",index:t.uniqueIndex,id:""!==t.indexItem?"country-AP"+t.indexItem:"country-AP"+t.index})},change:function(e){return t.updateModel({model:"advanceParole",field:"country",value:t.information.country,id:""!==t.indexItem?"country-AP"+t.indexItem:"country-AP"+t.index})}},model:{value:t.information.country,callback:function(e){t.$set(t.information,"country",e)},expression:"information.country"}})],1),t._v(" "),n("div",{staticClass:"col-md-6"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.othercountry?t.information.class.othercountry:"",readonly:t.readonly,label:"Other Countries to Visit:",id:""!==t.indexItem?"othercountry-AP"+t.indexItem:"othercountry-AP"+t.index},on:{context:function(e){return t.$emit("open:context",{values:t.information.threeValues.othercountry,fieldId:"othercountry",type:"adavnceParole",index:t.uniqueIndex,id:""!==t.indexItem?"othercountry-AP"+t.indexItem:"othercountry-AP"+t.index})},change:function(e){return t.updateModel({model:"advanceParole",field:"othercountry",value:t.information.othercountry,id:""!==t.indexItem?"othercountry-AP"+t.indexItem:"othercountry-AP"+t.index})}},model:{value:t.information.othercountry,callback:function(e){t.$set(t.information,"othercountry",e)},expression:"information.othercountry"}})],1)])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-12"},[!0===t.information.newItem?n("label",{staticClass:"float-left",staticStyle:{color:"red"}},[t._v(t._s(t.requiredMesssage))]):t._e(),t._v(" "),!0===t.information.newItem?n("div",{staticClass:"float-right mb-3"},[n("button",{staticClass:"btn btn-sm btn-success btnnNew",on:{click:function(e){return e.preventDefault(),t.handleSubmit("advanceForm"+t.index)}}},[t._v("Save")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger btnnCancel",on:{click:function(e){return e.preventDefault(),t.$emit("cancel-new-item")}}},[t._v("Cancel")])]):t._e()])])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:"Are you really sure you want to delete this advance?"},on:{close:function(e){t.isPopUp=!1},action:t.deleteAdvance}}):t._e()],1):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("2. Document Information")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h6",[e("b",[this._v("3. Travel Information (If Applicable)")])])}]};var Ls=n("VU/8")(Os,Ts,!1,function(t){n("abwx"),n("LGqs"),n("TaS5")},"data-v-6c48ec47",null).exports,js={name:"pf-advance-parole",mixins:[Lt],props:{questionnaireid:{type:String}},components:{PfAdvance:Ls,PfButton:d},created:function(){var t=this;this.type="itemAdvance",void 0===this.list&&-1!==this.contactId?this.apiService.getAdvanceParole({token:this.token,contactId:this.contactId}).then(function(e){void 0!==e&&e.listAdvanceParole&&(t.listRemote=e.listAdvanceParole),0===t.listRemote.length&&setTimeout(function(){t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300)},300)}):void 0!==this.list&&setTimeout(function(){t.list.length>0?t.listRemote=t.list:(t.noInfo="No Record",setTimeout(function(){null!==document.getElementById("messageNoInf"+t.type)&&document.getElementById("messageNoInf"+t.type).classList.add("fadeIn")},300))},50)},methods:{saveNewItem:function(t){delete t.newItem,this.addModel({information:t,model:"advanceParole"})}}},Ps={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[0===t.listRemote.length?n("div",{staticClass:"m-2"},[""===t.noInfo?n("pf-spinner",{attrs:{color:"black"}}):n("h4",{staticClass:"fadeOut",attrs:{id:"messageNoInf"+t.type}},[t._v(t._s(t.noInfo))])],1):t._l(t.listRemote,function(e,i){return n("pf-advance",{key:i,attrs:{information:e,id:"itemAdvance"+i,index:i,token:t.token,apiService:t.apiService,viewer:t.viewer,questionnaireid:t.questionnaireid,contactId:t.contactId},on:{"cancel-new-item":t.deleteNewItem,"save-new-item":t.saveNewItem,"delete-advance":function(e){return t.deleteItem(i)}}})}),t._v(" "),!1===t.hideBtnAdd?n("pf-button",{attrs:{label:"New",classButton:"btn-success btnnNew",id:void 0!==t.questionnaireid?"itemAdvanceAdd"+t.questionnaireid:"itemAdvanceAdd"},on:{click:t.addItem}}):t._e()],2)},staticRenderFns:[]};var Fs=n("VU/8")(js,Ps,!1,function(t){n("I+mV")},"data-v-27cad832",null).exports,Ys={name:"pf-communication",mixins:[ht]},Rs={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"boxContainer myRow"},[n("div",{staticClass:"row"},[t._m(0),t._v(" "),n("div",{staticClass:"col-md-4"},[n("pf-input",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.email?t.information.class.email:"",readonly:t.readonly,label:"Email:",type:"email",id:""!==t.indexItem?"email-names"+t.indexItem:"email-names"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.email,fieldId:"email",type:"personal",id:""!==t.indexItem?"email-names"+t.indexItem:"email-names"+t.index})},change:function(e){return t.updateModel({model:"personal",field:"email",value:t.information.email,id:""!==t.indexItem?"email-names"+t.indexItem:"email-names"+t.index})}},model:{value:t.information.email,callback:function(e){t.$set(t.information,"email",e)},expression:"information.email"}})],1)])]):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBox"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Communication")])])])}]};var Hs=n("VU/8")(Ys,Rs,!1,function(t){n("eLUB")},"data-v-c02361dc",null).exports,$s={name:"pf-marital-status",mixins:[ht],props:{index:{type:Number},indexItem:{type:String},readonly:{type:Boolean,default:!1}},components:{PfRadio:P},methods:{changeRadio:function(t){var e=this;this.information[t.key]=t.type;var n=this.information;Y()(this.radioGroups).forEach(function(i){-1!==e.radioGroups[i].indexOf(t.keyThree)&&e.radioGroups[i].forEach(function(i){i!==t.keyThree?(n[i]="off",!0===e.comparing&&(n.threeValues[i].manual="off")):(n[i]="on",!0===e.comparing&&(n.threeValues[i].manual="on"))})}),this.information={},this.information=n,this.updateModel({model:"personal",field:t.key,value:t.type,id:t.id})}}},zs={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return Object.keys(t.information).length>0||!0===t.information.new?n("div",{staticClass:"boxContainer myRow"},[n("div",{staticClass:"row"},[t._m(0),t._v(" "),n("div",{staticClass:"form-group col-md-12 mb-1"},[n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.maritalStatusMarried?t.information.class.maritalStatusMarried:"",readonly:t.readonly,classLabel:"mediumSize",label:"Married",name:"maritalStatusPerson"+t.indexItem,checked:"on"===t.information.maritalStatusMarried,id:""!==t.indexItem?"maritalStatusMarried-marital"+t.indexItem:"maritalStatusMarried-marital"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.maritalStatusMarried,fieldId:"maritalStatusMarried",type:"personal",id:""!==t.indexItem?"maritalStatusMarried-marital"+t.indexItem:"maritalStatusMarried-marital"+t.index})},click:function(e){return t.changeRadio({type:"Married",id:""!==t.indexItem?"maritalStatusMarried-marital"+t.indexItem:"maritalStatusMarried-marital"+t.index,key:"maritalStatus",keyThree:"maritalStatusMarried",model:"personal"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.maritalStatusSingle?t.information.class.maritalStatusSingle:"",readonly:t.readonly,classLabel:"mediumSize",label:"Single",name:"maritalStatusPerson"+t.indexItem,checked:"on"===t.information.maritalStatusSingle,id:""!==t.indexItem?"maritalStatusSingle-marital"+t.indexItem:"maritalStatusSingle-marital"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.maritalStatusSingle,fieldId:"maritalStatusSingle",type:"personal",id:""!==t.indexItem?"maritalStatusSingle-marital"+t.indexItem:"maritalStatusSingle-marital"+t.index})},click:function(e){return t.changeRadio({type:"Single",id:""!==t.indexItem?"maritalStatusSingle-marital"+t.indexItem:"maritalStatusSingle-marital"+t.index,key:"maritalStatus",keyThree:"maritalStatusSingle",model:"personal"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.maritalStatusDivorced?t.information.class.maritalStatusDivorced:"",readonly:t.readonly,classLabel:"mediumSize",label:"Divorced",name:"maritalStatusPerson"+t.indexItem,checked:"on"===t.information.maritalStatusDivorced,id:""!==t.indexItem?"maritalStatusDivorced-marital"+t.indexItem:"maritalStatusDivorced-marital"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.maritalStatusDivorced,fieldId:"maritalStatusDivorced",type:"personal",id:""!==t.indexItem?"maritalStatusDivorced-marital"+t.indexItem:"maritalStatusDivorced-marital"+t.index})},click:function(e){return t.changeRadio({type:"Divorced",id:""!==t.indexItem?"maritalStatusDivorced-marital"+t.indexItem:"maritalStatusDivorced-marital"+t.index,key:"maritalStatus",keyThree:"maritalStatusDivorced",model:"personal"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.maritalStatusWidow?t.information.class.maritalStatusWidow:"",readonly:t.readonly,classLabel:"mediumSize",label:"Widow",name:"maritalStatusPerson"+t.indexItem,checked:"on"===t.information.maritalStatusWidow,id:""!==t.indexItem?"maritalStatusWidow-marital"+t.indexItem:"maritalStatusWidow-marital"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.maritalStatusWidow,fieldId:"maritalStatusWidow",type:"personal",id:""!==t.indexItem?"maritalStatusWidow-marital"+t.indexItem:"maritalStatusWidow-marital"+t.index})},click:function(e){return t.changeRadio({type:"Widow",id:""!==t.indexItem?"maritalStatusWidow-marital"+t.indexItem:"maritalStatusWidow-marital"+t.index,key:"maritalStatus",keyThree:"maritalStatusWidow",model:"personal"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.maritalStatusSeparated?t.information.class.maritalStatusSeparated:"",readonly:t.readonly,classLabel:"mediumSize",label:"Separated",name:"maritalStatusPerson"+t.indexItem,checked:"on"===t.information.maritalStatusSeparated,id:""!==t.indexItem?"maritalStatusSeparated-marital"+t.indexItem:"maritalStatusSeparated-marital"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.maritalStatusSeparated,fieldId:"maritalStatusSeparated",type:"personal",id:""!==t.indexItem?"maritalStatusSeparated-marital"+t.indexItem:"maritalStatusSeparated-marital"+t.index})},click:function(e){return t.changeRadio({type:"Separated",id:""!==t.indexItem?"maritalStatusSeparated-marital"+t.indexItem:"maritalStatusSeparated-marital"+t.index,key:"maritalStatus",keyThree:"maritalStatusSeparated",model:"personal"})}}}),t._v(" "),n("pf-radio",{attrs:{classElement:void 0===t.information.class?"":void 0!==t.information.class.maritalStatusAnnulled?t.information.class.maritalStatusAnnulled:"",readonly:t.readonly,classLabel:"mediumSize",label:"Annulled",name:"maritalStatusPerson"+t.indexItem,checked:"on"===t.information.maritalStatusAnnulled,id:""!==t.indexItem?"maritalStatusAnnulled-marital"+t.indexItem:"maritalStatusAnnulled-marital"+t.index},on:{context:function(e){return t.$emit("open:context",{index:t.uniqueIndex,values:t.information.threeValues.maritalStatusAnnulled,fieldId:"maritalStatusAnnulled",type:"personal",id:""!==t.indexItem?"maritalStatusAnnulled-marital"+t.indexItem:"maritalStatusAnnulled-marital"+t.index})},click:function(e){return t.changeRadio({type:"Annulled",id:""!==t.indexItem?"maritalStatusAnnulled-marital"+t.indexItem:"maritalStatusAnnulled-marital"+t.index,key:"maritalStatus",keyThree:"maritalStatusAnnulled",model:"personal"})}}})],1)])]):t._e()},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"backgroundTitlesBox"},[e("h6",[e("b",{staticClass:"titlesContact"},[this._v("Marital Status")])])])}]};var Xs=n("VU/8")($s,zs,!1,function(t){n("ErGL")},"data-v-665854a0",null).exports,Vs=(n("R870"),{name:"pf-questionnaire-form",mixins:[ht],data:function(){return{formList:[],selectForm:{},questionnaireData:[{}],template:{},messageNoInfo:"",isSpinner:!1,isRefresh:!1,widgetLabels:{},formNames:[],questionnaireForms:{},countData:0,countForms:0,formFields:{},currentFormId:"",messageError:"",currentGroupMaxChecked:[],isWidgetVisible:!1}},components:{PfButton:d,vSelect:y.a,PfSpinner:r,PfInput:m,PfCheckbox:x,PfSelect:k,PfRadio:P,PfPhones:No},props:{forms:{type:Array},caseFormId:{type:String},token:{type:String},list:{type:Array},data:{type:Array}},watch:{caseFormId:function(t){!0===this.viewer&&(this.questionnaireData=[],this.isSpinner=!0,this.currentFormId=this.questionnaireForms[t].id,this.formFields=this.questionnaireForms[t].values,this.selectForm._id=this.currentFormId,this.getTemplates())},data:function(t){this.questionnaireData=JSON.parse(U()(t)),this.setOrderQuestionnaireData()}},created:function(){var t=this;this.data?(this.questionnaireData=JSON.parse(U()(this.data)),this.setOrderQuestionnaireData(),this.isSpinner=!1):this.viewer?this.forms&&this.forms.forEach(function(e){t.selectForm.caseFormId=e.caseFormId,t.selectForm._id=e._id,t.selectForm.name=e.name,t.formFields=e.fields,t.getQuestionnaireForm()}):Tt.graphFormList({token:this.token}).then(function(e){t.formList=e.forms})},mounted:function(){null!==document.getElementById("refreshQ")&&document.getElementById("refreshQ").classList.add("fadeIn"),setInterval(function(){null!==document.querySelector(".vs__dropdown-menu")&&(document.querySelector(".vs__dropdown-menu").style.zIndex="202")},200)},methods:{setChangeViewerModel:function(t){this.$emit("set-change-model",t),this.setFlash(t.id)},setFlash:function(t){var e="updated"===t.action?"flashitInput":"error"===t.action?"flashitInputError":"";t.el.classList.add(e),setTimeout(function(){t.el.classList.remove(e)},400)},getQuestionnaireForm:function(){if(this.isRefresh=!0,this.isSpinner=!0,this.questionnaireData=[],null===this.selectForm)return this.$emit("set-form-name","Form Name"),this.isSpinner=!1,this.isRefresh=!1,void(this.messageNoInfo="");!0===this.viewer?this.formNames.push({name:this.selectForm.name,id:this.selectForm._id+"-"+this.selectForm.caseFormId}):(this.formNames=[],this.formNames.push(this.selectForm.name)),this.questionnaireForms[this.selectForm.caseFormId]={},this.questionnaireForms[this.selectForm.caseFormId].id=this.selectForm._id,this.questionnaireForms[this.selectForm.caseFormId].values=this.formFields,this.$emit("set-form-names",this.formNames),this.messageNoInfo="",!1===this.viewer&&this.getTemplates()},getTemplates:function(){var t=this,e="";e=!0===this.viewer?"graphTemplatesCT":"graphTemplates",Tt[e]({token:this.token,formId:this.selectForm._id}).then(function(e){0===e.templates.length?(t.messageNoInfo="No Templates Information.",t.isSpinner=!1):e.templates.forEach(function(e){"default"===e.name&&(t.template=e,void 0!==e.widgetLabels&&null!==e.widgetLabels&&t.setWidgetLabels(e.widgetLabels),t.getQuestionnaire(e._id))})})},getQuestionnaire:function(t){var e=this,n="";n=!0===this.viewer?"getQuestionnaireCT":"getQuestionnaire",Tt[n]({token:this.token,templateId:t}).then(function(t){e.setQuestionnaireData(t)})},setQuestionnaireData:function(t){this.isSpinner=!1,void 0!==t.questionnaires&&null!==t.questionnaires?(t.questionnaires[0].data?this.questionnaireData=t.questionnaires[0].data:this.questionnaireData=[],t.questionnaires[0].data&&t.questionnaires[0].data.length>0?this.setOrderQuestionnaireData():this.messageNoInfo="No Questionnaire data Information."):this.messageNoInfo="Access denied"},setOrderQuestionnaireData:function(){var t=this;this.questionnaireData.forEach(function(e,n){if(!0===t.viewer){var i=e.fieldName.replace(/]_/g,"].");-1!==t.formFields.map(function(t){return t.field}).indexOf(i)&&"checkbox-group"!==e.type&&(e.valueOrigin=t.formFields[t.formFields.map(function(t){return t.field}).indexOf(i)].value.origin,e.valueEdit=t.formFields[t.formFields.map(function(t){return t.field}).indexOf(i)].value.edit,e.valueManual=t.formFields[t.formFields.map(function(t){return t.field}).indexOf(i)].value.manual)}if("checkbox-group"===e.type){if(!0===t.viewer)Y()(e.checkboxes).forEach(function(n){var i=n.replace(/]_/g,"].");-1!==t.formFields.map(function(t){return t.field}).indexOf(i)&&(e.checkboxes[n].valueOrigin=t.formFields[t.formFields.map(function(t){return t.field}).indexOf(i)].value.origin,e.checkboxes[n].valueEdit=t.formFields[t.formFields.map(function(t){return t.field}).indexOf(i)].value.edit,e.checkboxes[n].valueManual=t.formFields[t.formFields.map(function(t){return t.field}).indexOf(i)].value.manual)});var a=[];a=Ct()(e.checkboxes).sort(function(t,e){return t.tabOrder>e.tabOrder?1:-1}),e.checkboxes={},a.forEach(function(t){e.checkboxes[t.id]=t}),t.questionnaireData[n]=e}}),setTimeout(function(){t.initControlActions()},1500)},refreshQuestionnaire:function(){var t=this;this.isSpinner=!0,this.questionnaireData=[],this.messageNoInfo="",this.widgetLabels=[],setTimeout(function(){t.getQuestionnaireForm()},500)},controlTags:function(t){var e=this;if(this.isWidgetVisible=!this.isWidgetVisible,t.field||(t.field=t.id),!t.init&&Y()(t.checkboxes).length>0){var n=0;Y()(t.checkboxes).forEach(function(i){void 0===t.maxChecked&&"on"===t.checkboxes[i].valueEdit?(!0===e.viewer&&e.updateForm({value:"off",field:i,fieldType:1,formModel:t.checkboxes[i].model,caseFormId:t.caseFormId}),e.questionnaireData.forEach(function(n,a){n.fieldName===t.groupName&&(n.checkboxes[i].valueEdit="off",e.questionnaireData[a]=n)})):"on"===t.checkboxes[i].valueEdit&&n++}),t.maxChecked>1&&t.maxChecked<=n&&"on"===t.value?function(){for(var n=Y()(t.checkboxes).indexOf(t.field),i=!1;!1===i;)n+1===Y()(t.checkboxes).length?n=0:n++,"checkbox"===t.checkboxes[Y()(t.checkboxes)[n]].type&&"on"===t.checkboxes[Y()(t.checkboxes)[n]].valueEdit&&(document.getElementById(t.checkboxes[Y()(t.checkboxes)[n]].id+e.caseFormId).checked=!1,!0===e.viewer&&e.updateForm({value:"off",field:t.checkboxes[Y()(t.checkboxes)[n]].id,fieldType:1,formModel:t.checkboxes[Y()(t.checkboxes)[n]].model,caseFormId:t.caseFormId}),e.questionnaireData.forEach(function(i,a){i.fieldName===t.groupName&&(i.checkboxes[Y()(i.checkboxes)[n]].valueEdit="off",i.checkboxes[t.field].valueEdit="on",e.questionnaireData[a]=i)}),i=!0)}():this.questionnaireData.forEach(function(n,i){n.fieldName===t.groupName&&(n.checkboxes[t.field].valueEdit=t.value,e.questionnaireData[i]=n)}),!0===this.viewer&&setTimeout(function(){e.updateForm(t)},100)}else!0!==this.viewer||t.init||this.updateForm(t);var i,a=document.getElementById(t.id);t.tags&&this.validWatchers(t),void 0!==t.actions&&(t.actions.forEach(function(n){e.questionnaireData.forEach(function(i,a){void 0!==i.tags&&i.tags.forEach(function(i){if(-1!==n.tags.indexOf(i)){if(null===n.checkbox)return;null!==document.getElementById(n.checkbox.id+t.caseFormId)&&n.checkbox.id+t.caseFormId!==t.id&&(!1===document.getElementById(n.checkbox.id+t.caseFormId).checked&&"on"===n.value?"show"===n.action?e.questionnaireData[a].tagVisible=!1:"hide"===n.action&&(e.questionnaireData[a].tagVisible=!0):!1===document.getElementById(n.checkbox.id+t.caseFormId).checked&&"off"===n.value&&("show"===n.action?e.questionnaireData[a].tagVisible=!0:"hide"===n.action&&(e.questionnaireData[a].tagVisible=!1)))}}),i.checkboxes&&Y()(i.checkboxes).length>0&&Y()(i.checkboxes).forEach(function(o){var r=i.checkboxes[o];void 0!==r.tags&&r.tags.length>0&&(r.tags.forEach(function(e){if(-1!==n.tags.indexOf(e)){if(null===n.checkbox)return;n.checkbox.id+t.caseFormId!==t.id&&(null!==document.getElementById(n.checkbox.id+t.caseFormId)&&!1===document.getElementById(n.checkbox.id+t.caseFormId).checked&&"on"===n.value?"show"===n.action?r.tagVisible=!1:"hide"===n.action&&(r.tagVisible=!0):null!==document.getElementById(n.checkbox.id+t.caseFormId)&&!1===document.getElementById(n.checkbox.id+t.caseFormId).checked&&"off"===n.value&&("show"===n.action?r.tagVisible=!0:"hide"===n.action&&(r.tagVisible=!1)))}}),e.questionnaireData[a].checkboxes[o]=r)})})}),t.actions.forEach(function(n){e.questionnaireData.forEach(function(i,o){void 0!==i.tags&&i.tags.forEach(function(i){if(-1!==n.tags.indexOf(i)){if(null===n.checkbox)return;null!==a&&n.checkbox.id+t.caseFormId===t.id&&(!0===a.checked&&"on"===n.value?"show"===n.action?"on"===t.value?e.questionnaireData[o].tagVisible=!0:e.questionnaireData[o].tagVisible=!1:"hide"===n.action&&(e.questionnaireData[o].tagVisible=!1):!0===a.checked&&"off"===n.value&&("show"===n.action?e.questionnaireData[o].tagVisible=!1:"hide"===n.action&&(e.questionnaireData[o].tagVisible=!0)))}}),void 0!==i.checkboxes&&Y()(i.checkboxes).length>0&&Y()(i.checkboxes).forEach(function(r){var s=i.checkboxes[r];void 0!==s.tags&&s.tags.length>0&&(s.tags.forEach(function(e){if(-1!==n.tags.indexOf(e)){if(null===n.checkbox)return;null!==a&&n.checkbox.id+t.caseFormId===t.id&&(!0===a.checked&&"on"===n.value?"show"===n.action?s.tagVisible=!0:"hide"===n.action&&(s.tagVisible=!1):!0===a.checked&&"off"===n.value&&("show"===n.action?s.tagVisible=!1:"hide"===n.action&&(s.tagVisible=!0)))}}),e.questionnaireData[o].checkboxes[r]=s)})})}),i=this.questionnaireData,this.questionnaireData=[],this.questionnaireData=i,this.questionnaireForms[t.formName]=this.questionnaireData)},controlTagsField:function(t){var e=this;t.value=!1===document.getElementById(t.id).checked?"off":"on",!0!==this.viewer||t.init||this.updateForm(t);var n,i=document.getElementById(t.id);void 0!==t.actions&&(t.actions.forEach(function(t){e.questionnaireData.forEach(function(n,a){void 0!==n.tags&&n.tags.forEach(function(n){-1!==t.tags.indexOf(n)&&(!1===i.checked&&"on"===t.value?"show"===t.action?e.questionnaireData[a].tagVisible=!1:"hide"===t.action&&(e.questionnaireData[a].tagVisible=!0):!1===i.checked&&"off"===t.value&&("show"===t.action?e.questionnaireData[a].tagVisible=!0:"hide"===t.action&&(e.questionnaireData[a].tagVisible=!1)))})})}),t.actions.forEach(function(t){e.questionnaireData.forEach(function(n,a){void 0!==n.tags&&n.tags.forEach(function(n){-1!==t.tags.indexOf(n)&&(!0===i.checked&&"on"===t.value?"show"===t.action?e.questionnaireData[a].tagVisible=!0:"hide"===t.action&&(e.questionnaireData[a].tagVisible=!1):!0===i.checked&&"off"===t.value&&("show"===t.action?e.questionnaireData[a].tagVisible=!1:"hide"===t.action&&(e.questionnaireData[a].tagVisible=!0)))})})}),n=this.questionnaireData,this.questionnaireData=[],this.questionnaireData=n,this.questionnaireForms[t.formName]=this.questionnaireData)},controlTagsDropdown:function(t){var e=this;if(t.actions){var n=document.getElementById(t.id);if(n){this.isWidgetVisible=!this.isWidgetVisible;var i;t.actions.forEach(function(t){t.select&&e.questionnaireData.forEach(function(n,i){n.tags&&n.tags.forEach(function(n){-1!==t.tags.indexOf(n)&&(e.questionnaireData[i].tagVisible=!1)}),n.checkboxes&&Y()(n.checkboxes).length>0&&Y()(n.checkboxes).forEach(function(a){var o=n.checkboxes[a];o.tags&&o.tags.length>0&&(o.tags.forEach(function(e){-1!==t.tags.indexOf(e)&&(o.tagVisible=!1)}),e.questionnaireData[i].checkboxes[a]=o)})})}),t.actions.forEach(function(t){t.select&&e.questionnaireData.forEach(function(i,a){i.tags&&i.tags.forEach(function(i){-1!==t.tags.indexOf(i)&&t.select===n.value&&-1!==t.tags.indexOf(i)&&(e.questionnaireData[a].tagVisible=!0)}),i.checkboxes&&Y()(i.checkboxes).length>0&&Y()(i.checkboxes).forEach(function(o){var r=i.checkboxes[o];r.tags&&r.tags.length>0&&(r.tags.forEach(function(e){-1!==t.tags.indexOf(e)&&t.select===n.value&&-1!==t.tags.indexOf(e)&&(r.tagVisible=!0)}),e.questionnaireData[a].checkboxes[o]=r)})})}),i=this.questionnaireData,this.questionnaireData=[],this.questionnaireData=i,this.questionnaireForms[t.formName]=this.questionnaireData}}},validWatchers:function(t){var e=this;t.tags.forEach(function(t){var n=[];e.questionnaireData.forEach(function(i){if(i.tags&&-1!==i.tags.indexOf(t)){if(!i.checkboxes)return;var a=Y()(i.checkboxes);if(null===document.getElementById(a[0]+e.caseFormId))return;!0===document.getElementById(a[0]+e.caseFormId).checked&&n.push(i.checkboxes[a[0]].typeAb),!0===document.getElementById(a[1]+e.caseFormId).checked&&n.push(i.checkboxes[a[1]].typeAb)}});var i=-1!==n.indexOf("Yes")||-1===n.indexOf("No")&&"";e.questionnaireData.forEach(function(e){e.watchers&&e.watchers.forEach(function(n){t===n.label&&(n.value===i?e.tagVisible=!0:e.tagVisible=!1)})})})},initControlActions:function(){var t=this;this.questionnaireData.forEach(function(e){e.actionTags&&e.actionTags.length>0&&("checkbox-group"===e.type?Y()(e.checkboxes).forEach(function(n){t.controlTags({actions:e.actionTags,id:n+t.caseFormId,formName:t.formNames[t.countData],init:!0,caseFormId:t.caseFormId})}):"combobox"===e.type.toLowerCase()||"select"===e.type.toLowerCase()||"dropdown"===e.type.toLowerCase()?t.controlTagsDropdown({actions:e.actionTags,id:e.fieldName+t.caseFormId}):t.controlTagsField({actions:e.actionTags,id:e.fieldName+t.caseFormId,formName:t.formNames[t.countData],init:!0})),!0===e.abQuestion&&t.validWatchers(e)})},setWidgetLabels:function(t){var e=this;Y()(t).forEach(function(n){-1===Y()(e.widgetLabels).indexOf(n)&&(e.widgetLabels[n]=[]),e.widgetLabels[n].push(t[n].label)}),this.$emit("set-widget-labels",this.widgetLabels)},setChange:function(t){var e=this;return q()(X.a.mark(function n(){var i;return X.a.wrap(function(n){for(;;)switch(n.prev=n.next){case 0:return i=document.getElementById(t.id),t.value=i?i.value:t.data.valueEdit,e.$emit("set-change-value",t),n.next=5,e.updateForm(t);case 5:3===t.fieldType&&e.controlTagsDropdown({actions:t.data.actionTags,id:t.id});case 6:case"end":return n.stop()}},n,e)}))()}}}),qs={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[!1===t.viewer&&void 0===t.data?n("div",[!0===t.isRefresh?n("pf-button",{attrs:{styleButton:"position:absolute; right:0;",label:"↻",classButton:"btn-success btnnNew",id:"refreshQ"},on:{click:t.refreshQuestionnaire}}):t._e(),t._v(" "),t._m(0),t._v(" "),t.formList.length>0?n("v-select",{attrs:{id:"mySelect",options:t.formList,label:"name"},on:{input:t.getQuestionnaireForm},model:{value:t.selectForm,callback:function(e){t.selectForm=e},expression:"selectForm"}}):t._e()],1):t._e(),t._v(" "),!0===t.isSpinner?n("div",{staticClass:"mt-2"},[n("center",[n("h6",[t._v("Loading")])]),t._v(" "),n("pf-spinner",{attrs:{color:"black"}})],1):!1===t.isSpinner&&t.questionnaireData.length>0?n("div",{attrs:{id:"questionnaireContainer"}},t._l(t.questionnaireData,function(e,i){return n("div",{key:i},[!t.forms||void 0!==t.forms[0].prefixes&&-1===t.forms[0].prefixes.indexOf(e.prefix)||"text"!==e.type&&"Text"!==e.type||""!==e.model&&!0!==e.forceShow||!1===e.tagVisible?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":""},[n("h5",{staticClass:"ml-3 mt-4"},[t._v(t._s(e.title))]),t._v(" "),n("div",{staticClass:"row mb-4"},[n("div",{staticClass:"col-12"},[n("pf-input",{attrs:{id:e.fieldName+t.caseFormId,maxlength:e.maxCharacter},on:{change:function(n){return t.setChange({field:e.fieldName,value:e.valueEdit,id:e.fieldName+t.caseFormId,fieldType:2,formModel:e.model,caseFormId:t.caseFormId})}},model:{value:e.valueEdit,callback:function(n){t.$set(e,"valueEdit",n)},expression:"field.valueEdit"}}),t._v(" "),n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(e.desc))])],1)])]),t._v(" "),!t.forms||void 0!==t.forms[0].prefixes&&-1===t.forms[0].prefixes.indexOf(e.prefix)||"checkbox"!==e.type||""!==e.model&&!0!==e.forceShow||!1===e.tagVisible?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":""},[n("h5",{staticClass:"ml-3 mt-4"},[t._v(t._s(e.title))]),t._v(" "),n("div",{staticClass:"row"},[n("p"),n("div",{staticClass:"col-12"},[n("div",{staticClass:"radio custom-checkbox"},[n("pf-checkbox",{attrs:{id:e.fieldName+t.caseFormId,label:e.desc,checked:"on"===e.valueEdit},on:{click:function(n){return t.controlTagsField({actions:e.actionTags,id:e.fieldName+t.caseFormId,field:e.fieldName,fieldType:1,formModel:e.model,caseFormId:t.caseFormId})}}})],1)]),t._v(" "),n("p")])]),t._v(" "),!t.forms||void 0!==t.forms[0].prefixes&&-1===t.forms[0].prefixes.indexOf(e.prefix)||"combobox"!==e.type&&"Dropdown"!==e.type||""!==e.model&&!0!==e.forceShow||!1===e.tagVisible?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":""},[n("h5",{staticClass:"ml-3 mt-4"},[t._v(t._s(e.title))]),t._v(" "),n("div",{staticClass:"row mb-4"},[n("div",{staticClass:"col-12"},[n("pf-select",{attrs:{fieldType:3,formModel:e.model,id:e.fieldName+t.caseFormId,field:e.fieldName,caseFormId:t.caseFormId,options:e.values,value:e.valueEdit},on:{change:function(n){return t.setChange({field:e.fieldName,id:e.fieldName+t.caseFormId,fieldType:3,formModel:e.model,caseFormId:t.caseFormId,data:e})}}}),t._v(" "),n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(e.desc))])],1)])]),t._v(" "),!t.forms||void 0!==t.forms[0].prefixes&&-1===t.forms[0].prefixes.indexOf(e.prefix)||"checkbox-group"!==e.type||null===e.checkboxes||!1===e.tagVisible?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":""},[!0===e.abQuestion?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 text-sm-right mt-3 ml-3"},[n("span",{staticClass:"float-left mr-3",staticStyle:{"text-align":"justify","text-justify":"inter-word"}},[t._v("\n              "+t._s(e.title)+"\n            ")]),t._v(" "),n("div",{staticClass:"float-right"},[n("pf-radio",{attrs:{name:e.fieldName,classLabel:"left-radio",label:e.checkboxes[Object.keys(e.checkboxes)[0]].translations.en.label,classComponent:"classMbottom",id:Object.keys(e.checkboxes)[0]+t.caseFormId,checked:"on"===e.checkboxes[Object.keys(e.checkboxes)[0]].valueEdit},on:{click:function(n){t.controlTags({actions:e.actionTags,id:Object.keys(e.checkboxes)[0]+t.caseFormId,field:Object.keys(e.checkboxes)[0],fieldType:"text"===Object.keys(e.checkboxes)[0].type?2:"checkbox"===Object.keys(e.checkboxes)[0].type?1:"combobox"===Object.keys(e.checkboxes)[0].type?3:"datePicker"===Object.keys(e.checkboxes)[0].type?4:5,formModel:Object.keys(e.checkboxes)[0].model,checkboxes:e.checkboxes,groupName:e.fieldName,caseFormId:t.caseFormId,tags:e.tags,value:"on"===e.checkboxes[Object.keys(e.checkboxes)[0]].valueEdit?"off":"on"})}}}),t._v(" "),n("pf-radio",{attrs:{name:e.fieldName,classLabel:"left-radio",label:e.checkboxes[Object.keys(e.checkboxes)[1]].translations.en.label,classComponent:"classMbottom",id:Object.keys(e.checkboxes)[1]+t.caseFormId,checked:"on"===e.checkboxes[Object.keys(e.checkboxes)[1]].valueEdit},on:{click:function(n){t.controlTags({actions:e.actionTags,id:Object.keys(e.checkboxes)[1]+t.caseFormId,field:Object.keys(e.checkboxes)[1],fieldType:"text"===Object.keys(e.checkboxes)[1].type?2:"checkbox"===Object.keys(e.checkboxes)[1].type?1:"combobox"===Object.keys(e.checkboxes)[1].type?3:"datePicker"===Object.keys(e.checkboxes)[1].type?4:5,formModel:Object.keys(e.checkboxes)[1].model,checkboxes:e.checkboxes,groupName:e.fieldName,caseFormId:t.caseFormId,tags:e.tags,value:"on"===e.checkboxes[Object.keys(e.checkboxes)[1]].valueEdit?"off":"on"})}}})],1)])]):!t.forms||void 0!==t.forms[0].prefixes&&-1===t.forms[0].prefixes.indexOf(e.prefix)?t._e():n("div",[n("h5",{staticClass:"ml-3 mt-4"},[t._v(t._s(e.title))]),t._v(" "),t._l(e.checkboxes,function(i,a){return n("div",{key:a},[!1!==i.tagVisible?n("div",{staticClass:"row"},[n("p"),"checkbox"===i.type?n("div",{staticClass:"col-12 mb-3"},[e.maxChecked>1?n("pf-checkbox",{attrs:{classLabel:"left-radio",id:a+t.caseFormId,label:i.translations.en.label,checked:"on"===i.valueEdit},on:{click:function(n){return t.controlTags({actions:e.actionTags,id:a+t.caseFormId,field:a,fieldType:1,formModel:i.model,checkboxes:e.checkboxes,maxChecked:e.maxChecked,groupName:e.fieldName,caseFormId:t.caseFormId,value:"on"===i.valueEdit?"off":"on"})}}}):n("pf-radio",{attrs:{classLabel:"left-radio",name:e.fieldName,id:a+t.caseFormId,label:i.translations.en.label,classComponent:"classMbottom",checked:"on"===i.valueEdit},on:{click:function(n){return t.controlTags({actions:e.actionTags,id:a+t.caseFormId,field:a,fieldType:1,formModel:i.model,checkboxes:e.checkboxes,groupName:e.fieldName,caseFormId:t.caseFormId,value:"on"===i.valueEdit?"off":"on"})}}})],1):t._e(),t._v(" "),"text"===i.type?n("div",{staticClass:"col-12 mb-3"},[n("pf-input",{attrs:{classLabel:"left-radio",label:i.translations.en.label,id:a+t.caseFormId,maxlength:i.maxCharacter},on:{change:function(e){return t.setChange({field:a,value:i.valueEdit,id:a+t.caseFormId,fieldType:2,formModel:i.model,caseFormId:t.caseFormId,value:i.valueEdit})}},model:{value:i.valueEdit,callback:function(e){t.$set(i,"valueEdit",e)},expression:"fieldG.valueEdit"}}),t._v(" "),n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(i.translations.en.text))])],1):t._e(),t._v(" "),"select"===i.type?n("div",{staticClass:"col-12 mb-3"},[n("pf-select",{attrs:{fieldType:3,formModel:i.model,options:i.choiceData,id:a+t.caseFormId,field:a,caseFormId:t.caseFormId,label:i.translations.en.label,value:i.valueEdit},on:{change:t.setChange}}),t._v(" "),n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(i.translations.en.text))])],1):t._e(),t._v(" "),n("p")]):t._e()])})],2)]),t._v(" "),!t.forms||void 0!==t.forms[0].prefixes&&-1===t.forms[0].prefixes.indexOf(e.prefix)||"section"!==e.type||!1===e.tagVisible?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":""},[n("h5",{staticClass:"ml-3 mt-4"},[n("b",[t._v(t._s(e.originalValue))])]),t._v(" "),n("div",{staticClass:"row"},[n("p"),n("div",{staticClass:"col-12"},[n("label",[n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(e.desc))])])]),t._v(" "),n("p")])]),t._v(" "),!t.forms||void 0!==t.forms[0].prefixes&&-1===t.forms[0].prefixes.indexOf(e.prefix)||""!==e.model&&!0!==e.forceShow&&"checkbox-group"!==e.type||!1===e.tagVisible?t._e():n("hr")])}),0):!1===t.isSpinner?n("div",{staticClass:"ml-3"},[t._m(1),t._v(" "),n("br")]):n("div",{staticClass:"m-2"},[n("h4",[t._v(t._s(t.messageNoInfo))])])])},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("label",[e("b",[this._v("Search Form")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("h4",[e("b",[this._v("No Questionnaire Information")])])}]};var Ws=n("VU/8")(Vs,qs,!1,function(t){n("a1ra")},"data-v-72d60aab",null).exports,Us={name:"pf-questionnaire-form-comapring",mixins:[ht],data:function(){return{questionnaireData:[],template:{},messageNoInfo:"",isSpinner:!1,isRefresh:!1,widgetLabels:{},questionnaireForms:{},countData:0,formFields:[],currentFormId:"",currentInfoContext:{}}},props:{form:{type:Object},formNames:{type:Array},idForm:{type:String},infoChangeValueForm:{type:Object,default:{}}},components:{PfSpinner:r,PfInput:m,PfCheckbox:x,PfSelect:k,PfRadio:P,apiService:Tt},watch:{information:function(){this.questionnaireData=["No data"],this.isSpinner=!0,this.getTemplates()},infoChangeValueForm:function(t){var e=this;if(void 0!==t&&void 0!==t.value&&"manual"===this.indexItem){1===t.fieldType&&(this.currentInfoContext.value=t.value,setTimeout(function(){e.controlTagsContext(e.currentInfoContext)},500));var n=JSON.parse(U()(this.questionnaireData));n.forEach(function(i,a){i.fieldName===t.fieldId&&(i.valueInfo="checkbox"===i.type&&null===t.value?"off":"checkbox"===i.type&&null!==t.value?t.value:"checkbox"!==i.type&&null===t.value?"":"checkbox"!==i.type&&null!==t.value?t.value:"",i.valueManual="checkbox"===i.type&&null===t.value?"off":"checkbox"===i.type&&null!==t.value?t.value:"checkbox"!==i.type&&null===t.value?"":"checkbox"!==i.type&&null!==t.value?t.value:"",i.threeValues.manual="checkbox"===i.type&&null===t.value?"off":"checkbox"===i.type&&null!==t.value?t.value:"checkbox"!==i.type&&null===t.value?"":"checkbox"!==i.type&&null!==t.value?t.value:"",n[a]=i,e.updateForm({value:i.threeValues.manual,field:t.fieldId,fieldType:t.fieldType,formModel:t.model,caseFormId:t.caseFormId,id:t.id}),e.questionnaireData=[],e.questionnaireData=n,e.setColorContext({origin:i.threeValues.origin,manual:i.threeValues.manual,id:t.id})),"checkbox-group"===i.type&&Y()(i.checkboxes).forEach(function(o){o===t.fieldId&&(i.checkboxes[o].valueInfo=t.value,i.checkboxes[o].valueManual=t.value,i.checkboxes[o].threeValues.manual=t.value,n[a]=i,e.questionnaireData=[],e.questionnaireData=n,e.updateForm({value:i.checkboxes[o].threeValues.manual,field:t.fieldId,fieldType:t.fieldType,formModel:t.model,caseFormId:t.caseFormId,id:t.id}))})})}}},created:function(){this.isSpinner=!0,this.getTemplates()},methods:{setColorContext:function(t){var e=document.getElementById(t.id),n=document.getElementById(t.id.replace("manual","edit"));if(t.origin!==t.manual)if("radio"===e.type)e.classList.add("myInputRadUpdated"),n.classList.add("myInputRadUpdated");else if("text"===e.type||"email"===e.type||"select-one"===e.type||"tel"===e.type||"number"===e.type||"textarea"===e.type){var i=""===t.manual?"deleted-information":""===t.origin?"new-information":"updated-information";e.classList.add(i),n.classList.add(i)}else"checkbox"===e.type&&(e.classList.add("myInputUpdated"),n.classList.add("myInputUpdated"));else"radio"===e.type?(e.classList.remove("myInputRadUpdated"),n.classList.remove("myInputRadUpdated")):"text"===e.type||"email"===e.type||"select-one"===e.type||"tel"===e.type||"number"===e.type||"textarea"===e.type?(e.classList.remove("deleted-information","new-information","updated-information"),n.classList.remove("deleted-information","new-information","updated-information")):"checkbox"===e.type&&(e.classList.remove("myInputUpdated"),n.classList.remove("myInputUpdated"))},getTemplates:function(){var t=this;this.currentFormId=this.form.id+"-"+this.form.caseFormId,this.$emit("set-current-formid",this.currentFormId),this.apiService.graphTemplates({token:this.token,formId:this.form.id}).then(function(e){e.templates.forEach(function(e){"default"===e.name&&(t.template=e,void 0!==e.widgetLabels&&null!==e.widgetLabels&&t.setWidgetLabels(e.widgetLabels),t.getQuestionnaire(e._id))}),0===e.templates.length&&(t.messageNoInfo="No Templates Information.",t.isSpinner=!1)})},getQuestionnaire:function(t){var e=this;this.apiService.getQuestionnaire({token:this.token,templateId:t}).then(function(t){e.setQuestionnaireData(t)})},setQuestionnaireData:function(t){var e=this;this.isSpinner=!1,this.formFields=this.information.fields,t.questionnaires[0].data?this.questionnaireData=t.questionnaires[0].data:this.questionnaireData=[],t.questionnaires[0].data&&t.questionnaires[0].data.length>0?(this.questionnaireData.forEach(function(t,n){var i=t.fieldName.replace(/]_/g,"].");if(-1!==e.formFields.map(function(t){return t.field}).indexOf(i)&&("edit"===e.indexItem?t.valueInfo=e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.origin:"manual"===e.indexItem&&(void 0!==e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.manual&&null!==e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.manual?t.valueInfo=e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.manual:t.valueInfo=e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.edit),t.classColor=e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].classColor,t.threeValues=e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value),"checkbox-group"===t.type){Y()(t.checkboxes).forEach(function(n){var i=n.replace(/]_/g,"].");-1!==e.formFields.map(function(t){return t.field}).indexOf(i)&&("edit"===e.indexItem?t.checkboxes[n].valueInfo=e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.origin:"manual"===e.indexItem&&(null!==e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.manual&&void 0!==e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.manual?t.checkboxes[n].valueInfo=e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.manual:t.checkboxes[n].valueInfo=e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value.edit),t.checkboxes[n].classColor="myInputUpdated"===e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].classColor&&(null===t.maxChecked||t.maxChecked<2)?"myInputRadUpdated":e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].classColor,t.checkboxes[n].threeValues=e.formFields[e.formFields.map(function(t){return t.field}).indexOf(i)].value)});var a=[];a=Ct()(t.checkboxes).sort(function(t,e){return t.tabOrder>e.tabOrder?1:-1}),t.checkboxes={},a.forEach(function(e){t.checkboxes[e.id]=e}),e.questionnaireData[n]=t}}),setTimeout(function(){e.initControlActions()},1500),this.$emit("set-shortcuts")):this.messageNoInfo="No Questionnaire data Information."},setWidgetLabels:function(t){var e=this;Y()(t).forEach(function(n){-1===Y()(e.widgetLabels).indexOf(n)&&(e.widgetLabels[n]=[]),e.widgetLabels[n].push(t[n].label)}),this.$emit("set-widget-labels",this.widgetLabels)},hideFields:function(){var t=this;setTimeout(function(){t.questionnaireData.forEach(function(t,e){!1===t.tagVisible&&null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")})},1e3)},setContextMenu:function(t){this.$emit("open:context",{model:t.formModel,id:t.id,values:t.values,fieldId:t.field,type:"form",fieldType:t.fieldType,caseFormId:t.caseFormId}),t.contextMenu=!0,this.currentInfoContext=t},controlTagsContext:function(t){var e=this;t.tags&&this.validWatchers(t),"on"===t.value?document.getElementById(t.id).checked=!0:document.getElementById(t.id).checked=!1;var n=document.getElementById(t.id);t.actions.forEach(function(i){null!==i.checkbox&&i.checkbox.id===t.field&&e.questionnaireData.forEach(function(t,a){i.tags.forEach(function(o){void 0!==t.tags&&-1!==t.tags.indexOf(o)&&(!0===n.checked&&"on"===i.value&&"show"===i.action?(e.questionnaireData[a].tagVisible=!0,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.remove("d-none")):!0===n.checked&&"on"===i.value&&"hide"===i.action?(e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")):!0===n.checked&&"off"===i.value&&"show"===i.action?(e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")):!0===n.checked&&"off"===i.value&&"hide"===i.action?(e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")):!1===n.checked&&"on"===i.value&&"show"===i.action?(e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")):!1===n.checked&&"on"===i.value&&"hide"===i.action?(e.questionnaireData[a].tagVisible=!0,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.remove("d-none")):!1===n.checked&&"off"===i.value&&"hide"===i.action&&(e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none"))),"checkbox-group"===t.type&&Y()(t.checkboxes).forEach(function(r){void 0!==t.checkboxes[r].tags&&-1!==t.checkboxes[r].tags.indexOf(o)&&(!0===n.checked&&"on"===i.value&&"show"===i.action?(e.questionnaireData[a].checkboxes[r].tagVisible=!0,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.remove("d-none")):!0===n.checked&&"on"===i.value&&"hide"===i.action?(e.questionnaireData[a].checkboxes[r].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")):!0===n.checked&&"off"===i.value&&"show"===i.action?(e.questionnaireData[a].checkboxes[r].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")):!0===n.checked&&"off"===i.value&&"hide"===i.action?(e.questionnaireData[a].checkboxes[r].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")):!1===n.checked&&"on"===i.value&&"show"===i.action?(e.questionnaireData[a].checkboxes[r].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")):!1===n.checked&&"on"===i.value&&"hide"===i.action?(e.questionnaireData[a].checkboxes[r].tagVisible=!0,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.remove("d-none")):!1===n.checked&&"off"===i.value&&"hide"===i.action&&(e.questionnaireData[a].checkboxes[r].tagVisible=!1,null!==document.getElementById("edit"+t.fieldName+"contentField")&&document.getElementById("edit"+t.fieldName+"contentField").classList.add("d-none")))})})})})},controlTags:function(t){var e=this;if(!t.init&&Y()(t.checkboxes).length>0){var n=0;Y()(t.checkboxes).forEach(function(i){if(void 0===t.maxChecked&&"on"===t.checkboxes[i].valueInfo){e.updateForm({value:"off",field:i,fieldType:1,formModel:t.checkboxes[i].model,caseFormId:e.form.caseFormId,id:t.id});var a=e.questionnaireData;a.forEach(function(e,n){e.fieldName===t.groupName&&(e.checkboxes[i].valueInfo="off",e.checkboxes[i].valueManual="off",e.checkboxes[i].threeValues.manual="off",a[n]=e)}),e.questionnaireData=[],e.questionnaireData=a}else"on"===t.checkboxes[i].valueEdit&&n++}),t.maxChecked>1&&t.maxChecked<=n&&"on"===t.value?function(){for(var n=Y()(t.checkboxes).indexOf(t.field),i=!1;!1===i;)n+1===Y()(t.checkboxes).length?n=0:n++,"checkbox"===t.checkboxes[Y()(t.checkboxes)[n]].type&&"on"===t.checkboxes[Y()(t.checkboxes)[n]].valueInfo&&(document.getElementById(e.indexItem+t.checkboxes[Y()(t.checkboxes)[n]].id).checked=!1,e.updateForm({value:"off",field:t.checkboxes[Y()(t.checkboxes)[n]].id,fieldType:1,formModel:t.checkboxes[Y()(t.checkboxes)[n]].model,caseFormId:e.form.caseFormId,id:t.id}),e.questionnaireData.forEach(function(i,a){i.fieldName===t.groupName&&(i.checkboxes[Y()(i.checkboxes)[n]].valueInfo="off",i.checkboxes[Y()(i.checkboxes)[n]].valueManual="off",i.checkboxes[Y()(i.checkboxes)[n]].threeValues.manual="off",i.checkboxes[t.field].valueInfo="on",i.checkboxes[t.field].valueManual="on",i.checkboxes[t.field].threeValues.manual="on",e.questionnaireData[a]=i)}),i=!0)}():this.questionnaireData.forEach(function(n,i){n.fieldName===t.groupName&&(void 0===n.checkboxes[t.field].threeValues&&(n.checkboxes[t.field].threeValues={}),n.checkboxes[t.field].valueInfo=t.value,n.checkboxes[t.field].valueManual=t.value,n.checkboxes[t.field].threeValues.manual=t.value,e.questionnaireData[i]=n)}),setTimeout(function(){e.updateForm(t)},100)}else t.init||this.updateForm(t);var i,a=document.getElementById(t.id);t.tags&&this.validWatchers(t),void 0!==t.actions&&(t.actions.forEach(function(n){e.questionnaireData.forEach(function(i,a){void 0!==i.tags&&i.tags.forEach(function(o){if(-1!==n.tags.indexOf(o)){if(null===n.checkbox)return;if(null!==document.getElementById("manual"+n.checkbox.id)&&n.checkbox.id!==t.id.replace("manual",""))if(!1===document.getElementById("manual"+n.checkbox.id).checked&&"on"===n.value)if("show"===n.action)if(i.watchers&&i.watchers.length>0){var r=e.validWatchers(i);e.questionnaireData[a].tagVisible=r,!1===r?null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.add("d-none"):null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.remove("d-none")}else e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.add("d-none");else"hide"===n.action&&(e.questionnaireData[a].tagVisible=!0,null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.remove("d-none"));else if(!1===document.getElementById("manual"+n.checkbox.id).checked&&"off"===n.value)if("show"===n.action)e.questionnaireData[a].tagVisible=!0,null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.remove("d-none");else if("hide"===n.action)if(i.watchers&&i.watchers.length>0){var s=e.validWatchers(i);e.questionnaireData[a].tagVisible=s,!1===s?null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.add("d-none"):null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.remove("d-none")}else e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.add("d-none")}})})}),t.actions.forEach(function(n){e.questionnaireData.forEach(function(i,o){void 0!==i.tags&&i.tags.forEach(function(r){if(null!==a&&-1!==n.tags.indexOf(r)){if(null===n.checkbox)return;n.checkbox.id===t.id.replace("manual","")&&(!0===a.checked&&"on"===n.value?"show"===n.action?"on"===t.value?(e.questionnaireData[o].tagVisible=!0,null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.remove("d-none")):(e.questionnaireData[o].tagVisible=!1,null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.add("d-none")):"hide"===n.action&&(e.questionnaireData[o].tagVisible=!1,null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.add("d-none")):!0===a.checked&&"off"===n.value&&("show"===n.action?(e.questionnaireData[o].tagVisible=!1,null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.add("d-none")):"hide"===n.action&&(e.questionnaireData[o].tagVisible=!0,null!==document.getElementById("edit"+i.fieldName+"contentField")&&document.getElementById("edit"+i.fieldName+"contentField").classList.remove("d-none"))))}})})}),i=this.questionnaireData,this.questionnaireData=[],this.questionnaireData=i,this.questionnaireForms[t.formName]=this.questionnaireData)},controlTagsField:function(t){var e=this;t.value=!1===document.getElementById(t.id).checked?"off":"on",t.init||this.updateForm(t);var n,i=document.getElementById(t.id);void 0!==t.actions&&(t.actions.forEach(function(t){e.questionnaireData.forEach(function(n,a){void 0!==n.tags&&n.tags.forEach(function(o){-1!==t.tags.indexOf(o)&&(!1===i.checked&&"on"===t.value?"show"===t.action?(e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+n.fieldName+"contentField")&&document.getElementById("edit"+n.fieldName+"contentField").classList.add("d-none")):"hide"===t.action&&(e.questionnaireData[a].tagVisible=!0,null!==document.getElementById("edit"+n.fieldName+"contentField")&&document.getElementById("edit"+n.fieldName+"contentField").classList.remove("d-none")):!1===i.checked&&"off"===t.value&&("show"===t.action?(e.questionnaireData[a].tagVisible=!0,null!==document.getElementById("edit"+n.fieldName+"contentField")&&document.getElementById("edit"+n.fieldName+"contentField").classList.remove("d-none")):"hide"===t.action&&(e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+n.fieldName+"contentField")&&document.getElementById("edit"+n.fieldName+"contentField").classList.add("d-none"))))})})}),t.actions.forEach(function(t){e.questionnaireData.forEach(function(n,a){void 0!==n.tags&&n.tags.forEach(function(o){-1!==t.tags.indexOf(o)&&(!0===i.checked&&"on"===t.value?"show"===t.action?(e.questionnaireData[a].tagVisible=!0,null!==document.getElementById("edit"+n.fieldName+"contentField")&&document.getElementById("edit"+n.fieldName+"contentField").classList.remove("d-none")):"hide"===t.action&&(e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+n.fieldName+"contentField")&&document.getElementById("edit"+n.fieldName+"contentField").classList.add("d-none")):!0===i.checked&&"off"===t.value&&("show"===t.action?(e.questionnaireData[a].tagVisible=!1,null!==document.getElementById("edit"+n.fieldName+"contentField")&&document.getElementById("edit"+n.fieldName+"contentField").classList.add("d-none")):"hide"===t.action&&(e.questionnaireData[a].tagVisible=!0,null!==document.getElementById("edit"+n.fieldName+"contentField")&&document.getElementById("edit"+n.fieldName+"contentField").classList.remove("d-none"))))})})}),n=this.questionnaireData,this.questionnaireData=[],this.questionnaireData=n,this.questionnaireForms[t.formName]=this.questionnaireData)},validWatchers:function(t){var e=this;t.tags.forEach(function(t){var n=[];e.questionnaireData.forEach(function(e){if(void 0!==e.tags&&-1!==e.tags.indexOf(t)){if(void 0===e.checkboxes)return;var i=Y()(e.checkboxes);if(null===document.getElementById("manual"+i[0]))return;!0===document.getElementById("manual"+i[0]).checked&&n.push(e.checkboxes[i[0]].typeAb),!0===document.getElementById("manual"+i[1]).checked&&n.push(e.checkboxes[i[1]].typeAb)}});var i=-1!==n.indexOf("Yes")||-1===n.indexOf("No")&&"";e.questionnaireData.forEach(function(e){void 0!==e.watchers&&e.watchers.forEach(function(n){t===n.label&&(n.value===i?(e.tagVisible=!0,null!==document.getElementById("edit"+e.fieldName+"contentField")&&document.getElementById("edit"+e.fieldName+"contentField").classList.remove("d-none")):(e.tagVisible=!1,null!==document.getElementById("edit"+e.fieldName+"contentField")&&document.getElementById("edit"+e.fieldName+"contentField").classList.add("d-none")))})})})},initControlActions:function(){var t=this;this.hideFields(),this.questionnaireData.forEach(function(e){void 0!==e.actionTags&&e.actionTags.length>0&&("checkbox-group"===e.type?Y()(e.checkboxes).forEach(function(n){t.controlTags({actions:e.actionTags,id:"manual"+n,formName:t.formNames[t.countData],init:!0})}):t.controlTagsField({actions:e.actionTags,id:"manual"+e.fieldName,formName:t.formNames[t.countData],init:!0})),!0===e.abQuestion&&t.validWatchers(e)})},setContextMenuValue:function(t){this.questionnaireData.forEach(function(e){e.fieldName===t.field&&(void 0===e.threeValues&&(e.threeValues={origin:"",edit:"",manual:""}),e.threeValues.manual=t.value)})}}},Gs={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[!0===t.isSpinner?n("div",{staticClass:"mt-2"},[n("pf-spinner",{attrs:{color:"black"}})],1):t._e(),t._v(" "),!1===t.isSpinner?n("div",{staticClass:"boxContainer ml-0 mr-0"},[n("div",{staticClass:"ml-3"},[!1===t.isSpinner&&"edit"===t.indexItem&&0===Object.keys(t.questionnaireData).length?n("h4",[n("b",[t._v("No Questionnaire Information")])]):t._e()]),t._v(" "),t._l(t.questionnaireData,function(e,i){return n("div",{key:i},[void 0!==t.form.prefixes&&-1===t.form.prefixes.indexOf(e.prefix)||"text"!==e.type||""!==e.model&&!0!==e.forceShow||(!1===e.tagVisible||"manual"!==t.indexItem)&&"edit"!==t.indexItem?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":"",attrs:{id:t.indexItem+e.fieldName+"contentField"}},[n("h5",{staticClass:"ml-3 mt-4"},[t._v(t._s(e.title))]),t._v(" "),n("div",{staticClass:"row mb-4"},[n("div",{staticClass:"col-12"},[n("pf-input",{attrs:{id:t.indexItem+e.fieldName,readonly:t.readonly,classElement:void 0===e.classColor?"":e.classColor,tabindex:e.tabOrder},on:{change:function(n){return t.updateForm({field:e.fieldName,value:e.valueInfo,fieldType:2,formModel:e.model,id:t.indexItem+e.fieldName,caseFormId:t.form.caseFormId})},context:function(n){return t.$emit("open:context",{model:e.model,id:t.indexItem+e.fieldName,values:e.threeValues,fieldId:e.fieldName,type:"form",fieldType:2,caseFormId:t.form.caseFormId})}},model:{value:e.valueInfo,callback:function(n){t.$set(e,"valueInfo",n)},expression:"field.valueInfo"}}),t._v(" "),n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(e.desc))])],1)]),t._v(" "),n("hr")]),t._v(" "),void 0!==t.form.prefixes&&-1===t.form.prefixes.indexOf(e.prefix)||"checkbox"!==e.type||""!==e.model&&!0!==e.forceShow||(!1===e.tagVisible||"manual"!==t.indexItem)&&"edit"!==t.indexItem?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":"",attrs:{id:t.indexItem+e.fieldName+"contentField"}},[n("h5",{staticClass:"ml-3 mt-4"},[t._v(t._s(e.title))]),t._v(" "),n("div",{staticClass:"row"},[n("p"),n("div",{staticClass:"col-12"},[n("div",{staticClass:"radio custom-checkbox"},[n("pf-checkbox",{attrs:{id:t.indexItem+e.fieldName,label:e.desc,checked:"on"===e.valueInfo,classElement:void 0===e.classColor?"":e.classColor,readonly:t.readonly},on:{click:function(n){return t.controlTagsField({actions:e.actionTags,id:t.indexItem+e.fieldName,field:e.fieldName,fieldType:1,formModel:e.model,caseFormId:t.form.caseFormId})},context:function(n){return t.$emit("open:context",{model:e.model,id:t.indexItem+e.fieldName,values:e.threeValues,fieldId:e.fieldName,type:"form",fieldType:1,caseFormId:t.form.caseFormId})}}})],1)]),t._v(" "),n("p")]),t._v(" "),n("hr")]),t._v(" "),void 0!==t.form.prefixes&&-1===t.form.prefixes.indexOf(e.prefix)||"combobox"!==e.type||""!==e.model&&!0!==e.forceShow||(!1===e.tagVisible||"manual"!==t.indexItem)&&"edit"!==t.indexItem?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":"",attrs:{id:t.indexItem+e.fieldName+"contentField"}},[n("h5",{staticClass:"ml-3 mt-4"},[t._v(t._s(e.title))]),t._v(" "),n("div",{staticClass:"row mb-4"},[n("div",{staticClass:"col-12"},[n("pf-select",{attrs:{fieldType:3,formModel:e.model,id:t.indexItem+e.fieldName,field:e.fieldName,options:e.values,value:e.valueInfo,disabled:t.readonly,caseFormId:t.form.caseFormId,classElement:void 0===e.classColor?"":e.classColor,tabindex:e.tabOrder},on:{change:t.updateForm,context:function(n){return t.$emit("open:context",{model:e.model,id:t.indexItem+e.fieldName,values:e.threeValues,fieldId:e.fieldName,type:"form",fieldType:3,caseFormId:t.form.caseFormId})}}}),t._v(" "),n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(e.desc))])],1)]),t._v(" "),n("hr")]),t._v(" "),void 0!==t.form.prefixes&&-1===t.form.prefixes.indexOf(e.prefix)||"checkbox-group"!==e.type||null===e.checkboxes||("manual"!==t.indexItem||!1===e.tagVisible)&&"edit"!==t.indexItem?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":"",attrs:{id:t.indexItem+e.fieldName+"contentField"}},[!0===e.abQuestion?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 text-sm-right mt-3 ml-3"},[n("span",{staticClass:"float-left mr-3",staticStyle:{"text-align":"justify","text-justify":"inter-word"}},[t._v("\n              "+t._s(e.title)+"\n            ")]),t._v(" "),n("div",{staticClass:"float-right"},[n("pf-radio",{attrs:{name:t.indexItem+e.fieldName,classLabel:"left-radio",label:e.checkboxes[Object.keys(e.checkboxes)[0]].translations.en.label,classComponent:"classMbottom",id:t.indexItem+Object.keys(e.checkboxes)[0],checked:"on"===e.checkboxes[Object.keys(e.checkboxes)[0]].valueInfo,readonly:t.readonly,classElement:void 0===e.checkboxes[Object.keys(e.checkboxes)[0]].classColor?"":e.checkboxes[Object.keys(e.checkboxes)[0]].classColor},on:{click:function(n){t.controlTags({actions:e.actionTags,id:t.indexItem+Object.keys(e.checkboxes)[0],field:Object.keys(e.checkboxes)[0],fieldType:1,formModel:e.checkboxes[Object.keys(e.checkboxes)[0]].model,checkboxes:e.checkboxes,groupName:e.fieldName,caseFormId:t.form.caseFormId,isAb:!0,tags:e.tags,value:"on"===e.checkboxes[Object.keys(e.checkboxes)[0]].valueInfo?"off":"on"})},context:function(n){t.setContextMenu({actions:e.actionTags,id:t.indexItem+Object.keys(e.checkboxes)[0],field:Object.keys(e.checkboxes)[0],fieldType:1,formModel:e.checkboxes[Object.keys(e.checkboxes)[0]].model,checkboxes:e.checkboxes,groupName:e.fieldName,values:e.checkboxes[Object.keys(e.checkboxes)[0]].threeValues,caseFormId:t.form.caseFormId,isAb:!0,tags:e.tags})}}}),t._v(" "),n("pf-radio",{attrs:{name:t.indexItem+e.fieldName,classLabel:"left-radio",label:e.checkboxes[Object.keys(e.checkboxes)[1]].translations.en.label,classComponent:"classMbottom",id:t.indexItem+Object.keys(e.checkboxes)[1],checked:"on"===e.checkboxes[Object.keys(e.checkboxes)[1]].valueInfo,readonly:t.readonly,classElement:void 0===e.checkboxes[Object.keys(e.checkboxes)[1]].classColor?"":e.checkboxes[Object.keys(e.checkboxes)[1]].classColor},on:{click:function(n){t.controlTags({actions:e.actionTags,id:t.indexItem+Object.keys(e.checkboxes)[1],field:Object.keys(e.checkboxes)[1],fieldType:1,formModel:e.checkboxes[Object.keys(e.checkboxes)[1]].model,checkboxes:e.checkboxes,groupName:e.fieldName,caseFormId:t.form.caseFormId,isAb:!0,tags:e.tags,value:"on"===e.checkboxes[Object.keys(e.checkboxes)[1]].valueInfo?"off":"on"})},context:function(n){t.setContextMenu({actions:e.actionTags,id:t.indexItem+Object.keys(e.checkboxes)[1],field:Object.keys(e.checkboxes)[1],fieldType:1,formModel:e.checkboxes[Object.keys(e.checkboxes)[1]].model,checkboxes:e.checkboxes,groupName:e.fieldName,caseFormId:t.form.caseFormId,values:e.checkboxes[Object.keys(e.checkboxes)[1]].threeValues,isAb:!0,tags:e.tags})}}})],1)])]):void 0===t.form.prefixes||-1!==t.form.prefixes.indexOf(e.prefix)?n("div",[n("h5",{staticClass:"ml-3 mt-4"},[t._v(t._s(e.title))]),t._v(" "),t._l(e.checkboxes,function(i,a){return n("div",{key:a},[n("div",{staticClass:"row"},[n("p"),"checkbox"===i.type?n("div",{staticClass:"col-12 mb-3"},[e.maxChecked>1?n("pf-checkbox",{attrs:{classLabel:"left-radio",id:t.indexItem+a,label:i.translations.en.label,checked:"on"===i.valueInfo,readonly:t.readonly,classElement:void 0===i.classColor?"":i.classColor},on:{click:function(n){return t.controlTags({actions:e.actionTags,id:t.indexItem+a,field:a,fieldType:1,formModel:i.model,checkboxes:e.checkboxes,maxChecked:e.maxChecked,groupName:e.fieldName,caseFormId:t.form.caseFormId,value:"on"===i.valueInfo?"off":"on"})},context:function(n){return t.setContextMenu({actions:e.actionTags,id:t.indexItem+a,field:a,fieldType:1,formModel:i.model,checkboxes:e.checkboxes,groupName:e.fieldName,caseFormId:t.form.caseFormId,maxChecked:e.maxChecked,values:i.threeValues})}}}):n("pf-radio",{attrs:{classLabel:"left-radio",name:t.indexItem+e.fieldName,id:t.indexItem+a,label:i.translations.en.label,classComponent:"classMbottom",readonly:t.readonly,checked:"on"===i.valueInfo,classElement:void 0===i.classColor||"on"!==i.valueInfo?"":i.classColor},on:{click:function(n){return t.controlTags({actions:e.actionTags,id:t.indexItem+a,field:a,fieldType:1,formModel:i.model,checkboxes:e.checkboxes,groupName:e.fieldName,caseFormId:t.form.caseFormId,value:"on"===i.valueInfo?"off":"on"})},context:function(n){return t.setContextMenu({actions:e.actionTags,id:t.indexItem+a,field:a,fieldType:1,formModel:i.model,checkboxes:e.checkboxes,groupName:e.fieldName,caseFormId:t.form.caseFormId,values:i.threeValues})}}})],1):t._e(),t._v(" "),"text"===i.type?n("div",{staticClass:"col-12 mb-3"},[n("pf-input",{attrs:{classLabel:"left-radio",label:i.translations.en.label,id:t.indexItem+a,readonly:t.readonly,classElement:void 0===i.classColor?"":i.classColor,tabindex:i.tabOrder},on:{change:function(n){return t.updateForm({actions:e.actionTags,id:t.indexItem+a,field:a,fieldType:2,formModel:i.model,caseFormId:t.form.caseFormId,value:i.valueInfo})},context:function(e){return t.$emit("open:context",{model:i.model,id:t.indexItem+a,values:i.threeValues,fieldId:a,type:"form",fieldType:2,caseFormId:t.form.caseFormId})}},model:{value:i.valueInfo,callback:function(e){t.$set(i,"valueInfo",e)},expression:"fieldG.valueInfo"}}),t._v(" "),n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(i.translations.en.text))])],1):t._e(),t._v(" "),"select"===i.type?n("div",{staticClass:"col-12 mb-3"},[n("pf-select",{attrs:{fieldType:3,formModel:i.model,options:i.choiceData,id:t.indexItem+a,field:a,label:i.translations.en.label,disabled:t.readonly,caseFormId:t.form.caseFormId,value:i.valueInfo,classElement:void 0===i.classColor?"":i.classColor,tabindex:i.tabOrder},on:{change:t.updateForm,context:function(e){return t.$emit("open:context",{model:i.model,id:t.indexItem+a,values:i.threeValues,fieldId:a,type:"form",fieldType:3,caseFormId:t.form.caseFormId})}}}),t._v(" "),n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(i.translations.en.text))])],1):t._e(),t._v(" "),n("p")])])})],2):t._e(),t._v(" "),n("hr")]),t._v(" "),void 0!==t.form.prefixes&&-1===t.form.prefixes.indexOf(e.prefix)||"section"!==e.type||(!1===e.tagVisible||"manual"!==t.indexItem)&&"edit"!==t.indexItem?t._e():n("div",{class:1===e.indent?"indent-level1":2===e.indent?"indent-level2":3===e.indent?"indent-level3":"",attrs:{id:t.indexItem+e.fieldName+"contentField"}},[n("h5",{staticClass:"ml-3 mt-4"},[n("b",[t._v(t._s(e.originalValue))])]),t._v(" "),n("div",{staticClass:"row"},[n("p"),n("div",{staticClass:"col-12"},[n("label",[n("small",{staticClass:"form-text text-muted",attrs:{id:"emailHelp"}},[t._v(t._s(e.desc))])])]),t._v(" "),n("p")]),t._v(" "),n("hr")])])}),t._v(" "),0===Object.keys(t.questionnaireData).length&&"edit"===t.indexItem?n("div",{staticClass:"ml-4"},[n("h6",[t._v(t._s(t.messageNoInfo))])]):t._e()],2):t._e()])},staticRenderFns:[]};var Zs=n("VU/8")(Us,Gs,!1,function(t){n("0bxm")},"data-v-2243f137",null).exports,Js={data:function(){return{value:"",isShareField:!1,mask:"",classReverse:!1,classNoReverse:!1,classLabel:""}},props:{cantFields:{type:Number},position:{type:Number},fieldsShared:{type:Object},isReverse:{type:Boolean},fData:{type:Object}},computed:{style:function(){var t="position: absolute;";return t+="width: "+this.width+"px;",t+="height: "+this.height+"px;",t+="left: "+this.left+"px;",t+="top: "+this.top+"px;"},inputStyle:function(){var t="font-size:"+this.pageScale*this.fontSize+"px !important;position:absolute !important;top:0 !important;left:0 !important;height:"+this.height+"px !important; width: "+this.width+"px !important; pointer-events: auto !important;";return-1===this.fData.name.indexOf("Pounds")&&-1===this.fData.model.indexOf("weight")||(t+="width:"+(this.width+10)+"px !important;padding: 3px !important;"),!0===this.isShare?!0===this.isShareField?"checkbox"===this.type?t+"outline: 2px solid blue;":t+"border: 2px solid blue;":"checkbox"===this.type?t+"outline: 2px solid red;":t+"border: 2px solid red;":!0===this.isClient&&!1===this.readonly?"checkbox"===this.type&&-1===this.id.indexOf("newField")?t+"outline: blue solid 2px !important;":t+"border: 2px solid blue;":!0!==this.readonly?"checkbox"===this.type&&-1===this.id.indexOf("newField")?!0===this.isReverse?""!==this.model?-1===this.model.indexOf("#")&&-1===this.model.indexOf("(")&&-1===this.model.indexOf(")")&&-1===this.model.indexOf("+")&&-1===this.model.indexOf(",")&&-1===this.model.indexOf("attorney")&&-1===this.model.indexOf("verbose")&&!0!==this.fData.noReverse?t+"outline: 2px solid rgb(236, 113, 236) !important;":t+"outline: 2px solid rgb(0, 201, 29) !important;":t:""!==this.model&&void 0!==this.model?t+"outline: rgb(0, 201, 29) solid 2px !important;":t+"outline: none !important;":-1===this.id.indexOf("newField")?!0===this.isReverse?""!==this.model?-1===this.model.indexOf("#")&&-1===this.model.indexOf("(")&&-1===this.model.indexOf(")")&&-1===this.model.indexOf("+")&&-1===this.model.indexOf(",")&&-1===this.model.indexOf("attorney")&&-1===this.model.indexOf("verbose")&&!0!==this.fData.noReverse?t+"border: 2px solid rgb(236, 113, 236) !important;":t+"border: 2px solid rgb(0, 201, 29) !important;":t:""!==this.model&&void 0!==this.model?t+"border: 2px solid rgb(0, 201, 29);":t:"":"checkbox"===this.type&&-1===this.id.indexOf("newField")?!0===this.isReverse?""!==this.model?-1===this.model.indexOf("#")&&-1===this.model.indexOf("(")&&-1===this.model.indexOf(")")&&-1===this.model.indexOf("+")&&-1===this.model.indexOf(",")&&-1===this.model.indexOf("attorney")&&-1===this.model.indexOf("verbose")&&!0!==this.fData.noReverse?t+"outline: 2px solid rgb(236, 113, 236) !important;":t+"outline: 2px solid rgb(0, 201, 29) !important;":t:""!==this.model&&void 0!==this.model?t+"outline: rgb(0, 201, 29) solid 2px !important;":t+"outline: none !important;":-1===this.id.indexOf("newField")?!0===this.isReverse?""!==this.model?-1===this.model.indexOf("#")&&-1===this.model.indexOf("(")&&-1===this.model.indexOf(")")&&-1===this.model.indexOf("+")&&-1===this.model.indexOf(",")&&-1===this.model.indexOf("attorney")&&-1===this.model.indexOf("verbose")&&!0!==this.fData.noReverse?t+"border: 2px solid rgb(236, 113, 236) !important;":t+"border: 2px solid rgb(0, 201, 29) !important;":t:""!==this.model&&void 0!==this.model?t+"border: 2px solid rgb(0, 201, 29);":t:void 0},inputStyleShare:function(){if(!0===this.isShare&&-1!==this.id.indexOf("newField"))return"";var t="font-size:"+this.pageScale*this.fontSize+"px !important;position:absolute !important;top:0 !important;left:0 !important;height:"+this.height+"px !important;px !important;width:"+this.width+"px !important;pointer-events: none !important;";return!0===this.isShare?!0===this.shared?"checkbox"===this.type?t+"outline: 2px solid blue !important;":t+"border: 2px solid blue;":"checkbox"===this.type?t+"outline: 2px solid red !important;":t+"border: 2px solid red;":!0===this.isShare&&-1===this.id.indexOf("newField")?t:void 0}},watch:{shared:function(t){this.isShareField=t},fieldsShared:function(t){void 0!==t[this.id]&&!0===t[this.id].shared?this.isShareField=!0:void 0!==t[this.id]&&!1===t[this.id].shared&&(this.isShareField=!1)}},mounted:function(){1===this.tabOrder&&!0!==this.isShare&&null!==document.getElementById(this.id)&&document.getElementById(this.id).focus(),this.isShareField=this.shared,this.fieldValue.model=this.model,this.isClient?this.value=this.fieldValue.edit:this.isShare?this.value=this.fieldValue.origin:this.isSideBySide?!0===this.readonly?"checkbox"===this.type?this.value=""===this.fieldValue.origin||void 0===this.fieldValue.origin||null===this.fieldValue.origin||"off"===this.fieldValue.origin?"off":"on":this.value=this.fieldValue.origin:"checkbox"===this.type?this.value=""===this.fieldValue.edit||void 0===this.fieldValue.edit||null===this.fieldValue.edit||"off"===this.fieldValue.edit?"off":"on":this.value=this.fieldValue.edit:this.value=this.fieldValue.origin,void 0!==this.maskType&&(this.mask=this.getMask()),this.position===this.cantFields&&this.$emit("load-svg")},methods:{scrollBehindDownMenu:function(t){var e=window.scrollY,n=document.getElementById(t).getBoundingClientRect(),i=document.getElementById(t).ownerDocument.defaultView,a=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight,o=n.top+i.pageYOffset-e;Math.floor(100*o/a)>85&&window.scrollBy(0,300)},tabField:function(){this.countFields===this.tabOrder&&(this.totalPages===this.currentPage?document.getElementById("firstButton").click():document.getElementById("nextButton").click())},shareField:function(){if(!0===this.isShare&&!0===this.isEditShare){this.isShareField=!this.isShareField;var t={};t[this.id]={enable:this.isShareField,page:this.currentPage},this.$emit("share-field",{fields:t,enable:this.isShareField});var e=document.getElementById(this.id);-1!==e.style.border.indexOf("blue")?e.style.border="2px solid red":e.style.border="2px solid blue"}},getMask:function(){var t=this.maskType;return"Phone (US)"===t?"(###) ###-####":"Phone (International)"===t?"+## ### #######":"Zip Code"===t?"#####?-####":"Fax Number"===t?"+##-###-### ####":"Date"===t?"##/##/####":"Date (ISO 8601)"===t?"####/##/##":"Alien Number"===t?"###-###-###":"EIN"===t?"##-#######":"Social Security Number"===t?"###-##-####":"US Dollars"===t?"$#,###,###.##":"XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"}}},Qs={methods:{verifyCheck:function(t){return"off"===t.value?this.checkBelongFieldgroup({field:t.field,value:t.value}):"on"===t.value?"off":"on"},checkBelongFieldgroup:function(t){return void 0!==t.field.group?this.checkBelongMaxchecked({group:t.field.group,value:t.value,field:t.field}):"on"},checkBelongMaxchecked:function(t){var e=this,n=0;return Ct()(t.group.fields).forEach(function(t){!0===document.getElementById(t.id).checked&&n++}),t.group.maxChecked>1&&n<=t.group.maxChecked?"on":1===t.group.maxChecked||void 0===t.group.maxChecked?(n>1&&Ct()(t.group.fields).forEach(function(t){e.$emit("radio-change:field",t)}),"on"):"off"}}},Ks={name:"pf-form-checkbox",mixins:[Js,Qs],props:["id","model","width","height","left","top","tabOrder","type","readonly","pageScale","fontSize","colorClass","fieldValue","countFields","totalPages","currentPage","isShare","isEditShare","isClient","isSideBySide","shared"],components:{PfCheckbox:x},computed:{afterCheck:function(){return this.width/3}},methods:{saveValue:function(){this.value=this.verifyCheck({field:this.fData,value:!0===document.getElementById(this.id).checked?"off":"on"}),document.getElementById(this.id).checked="on"===this.value;var t=this.fieldValue;t.value=this.value,t.pdfField=this.id,t.model=this.model,t.type="checkbox",this.$emit("update-field-db",t)},setPseudo:function(t){this.$emit("set-pseudo",t)},setPseudoColor:function(t){this.$emit("set-pseudo:color",t)},setPseudoShareColor:function(t){this.$emit("set-pseudo-share:color",t)},setPseudoNoShareColor:function(t){this.$emit("set-pseudo-noshare:color",t)}}},tl={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[-1===t.id.indexOf("newField")?n("div",{style:t.style,on:{click:t.shareField}},[n("pf-checkbox",{attrs:{id:!0===t.readonly&&!0===t.isSideBySide?"origin"+t.id:t.id,type:"checkbox",isShare:t.isShare,styleElement:!0===t.isShare?t.inputStyleShare:t.inputStyle,readonly:t.readonly,classElement:t.colorClass,isReverse:t.isReverse,checked:"on"===t.value,tabindex:t.tabOrder,isForm:!0,isShareField:t.shared,isEditShare:t.isEditShare,uniAfter:t.afterCheck,model:t.model,isClient:t.isClient,width:t.width},on:{keyup:function(e){return t.scrollBehindDownMenu(t.id)},keytab:t.tabField,click:t.saveValue,context:function(e){return t.$emit("open:context",{top:t.top,left:t.left,fieldValue:t.fieldValue})},"set-pseudo":t.setPseudo,"set-pseudo:color":t.setPseudoColor,"set-pseudo-share:color":t.setPseudoShareColor,"set-pseudo-noshare:color":t.setPseudoNoShareColor}})],1):t._e()])},staticRenderFns:[]},el=n("VU/8")(Ks,tl,!1,null,null,null).exports,nl={name:"pf-form-radio",mixins:[Js],props:["id","model","width","height","left","top","tabOrder","type","readonly","pageScale","fontSize","colorClass","fieldValue","countFields","totalPages","currentPage","isShare","isEditShare","isClient","isSideBySide","group","shared"],components:{PfRadio:P},computed:{afterCheck:function(){return this.width/2}},methods:{saveValue:function(){var t=this,e=document.activeElement===document.getElementById(this.id);if(Y()(this.group.fields).forEach(function(e){if("checkbox"===t.group.fields[e].type){var n="";if(e===t.id&&""===n){n="on"===t.value?"off":"on",t.value=n;var i={};i.pdfField=e,i.value=n,i.model=t.group.fields[e].model,i.type="checkbox",i.changeValue=!0,t.$emit("update-field-db",i)}else if(void 0===t.fData.group.maxChecked||1===t.fData.group.maxChecked){n="off";var a={};a.pdfField=e,a.value=n,a.model=t.group.fields[e].model,a.type="checkbox",a.changeValue=!0,t.$emit("update-field-db",a)}}}),!1!==e&&this.fData.group.maxChecked>1){var n=0;document.querySelectorAll("."+this.fData.group.name).forEach(function(t){!0===t.checked&&n++});var i=n-this.fData.group.maxChecked;n>this.fData.group.maxChecked&&Y()(this.group.fields).forEach(function(e){if("checkbox"===t.group.fields[e].type&&t.group.fields[e].id!==t.id&&!0===document.getElementById(t.group.fields[e].id).checked&&i>0){i--,document.getElementById(t.group.fields[e].id).click();var n={};n.pdfField=e,n.value="off",n.model=t.group.fields[e].model,n.type="checkbox",n.changeValue=!0,t.$emit("update-field-db",n)}})}},setPseudo:function(t){this.$emit("set-pseudo",t)},setPseudoColor:function(t){this.$emit("set-pseudo:color",t)},setPseudoShareColor:function(t){this.$emit("set-pseudo-share:color",t)},setPseudoNoShareColor:function(t){this.$emit("set-pseudo-noshare:color",t)}}},il={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[-1===t.id.indexOf("newField")?n("div",{style:t.style,on:{click:t.shareField}},[n("pf-radio",{attrs:{id:!0===t.readonly&&!0===t.isSideBySide?"origin"+t.id:t.id,type:"checkbox",styleElement:!0===t.isShare?t.inputStyleShare:t.inputStyle,readonly:t.readonly,classElement:[t.colorClass,t.group.name],isReverse:t.isReverse,checked:"on"===t.value,tabindex:t.tabOrder,isForm:!0,name:!0===t.readonly?"":t.fData.group.maxChecked>1?t.group.name+"["+t.position+"]":t.group.name,isShareField:t.shared,isEditShare:t.isEditShare,uniAfter:t.afterCheck,model:t.model,isClient:t.isClient,width:t.width},on:{keyup:function(e){return t.scrollBehindDownMenu(t.id)},keytab:t.tabField,click:t.saveValue,context:function(e){return t.$emit("open:context",{top:t.top,left:t.left,fieldValue:t.fieldValue})},"set-pseudo":t.setPseudo,"set-pseudo:color":t.setPseudoColor,"set-pseudo-share:color":t.setPseudoShareColor,"set-pseudo-noshare:color":t.setPseudoNoShareColor}})],1):t._e()])},staticRenderFns:[]},al=n("VU/8")(nl,il,!1,null,null,null).exports,ol={name:"pf-form-select",mixins:[Js],props:["id","model","width","height","left","top","options","tabOrder","pageScale","fontSize","type","readonly","colorClass","fieldValue","countFields","totalPages","currentPage","isShare","isEditShare","isClient","isSideBySide","shared"],components:{PfSelect:k},methods:{saveValue:function(t){this.value=t.value,this.isClient?this.fieldValue.edit=this.value:this.isShare?this.fieldValue.origin=this.value:this.isSideBySide?!0===this.readonly?this.fieldValue.origin=this.value:this.fieldValue.edit=this.value:this.fieldValue.origin=this.value;var e=this.fieldValue;e.value=this.value,e.pdfField=this.id,e.model=this.model,this.$emit("update-field-db",e)}}},rl={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[-1===t.id.indexOf("newField")?n("div",{style:t.style,on:{click:t.shareField}},[n("pf-select",{attrs:{id:!0===t.readonly?"origin"+t.id:t.id,options:t.options,styleElement:!0===t.isShare?t.inputStyleShare+"background-color:#e9ecef !important;":t.inputStyle,disabled:t.readonly,isReverse:t.isReverse,tabindex:t.tabOrder,isForm:!0},on:{keyup:function(e){return t.scrollBehindDownMenu(t.id)},keytab:t.tabField,change:t.saveValue,context:function(e){return t.$emit("open:context",{top:t.top,left:t.left,fieldValue:t.fieldValue})},"action-full:page":function(e){return t.$emit("action-full:page")}},model:{value:t.value,callback:function(e){t.value=e},expression:"value"}})],1):t._e()])},staticRenderFns:[]},sl=n("VU/8")(ol,rl,!1,null,null,null).exports,ll={name:"pf-form-text",mixins:[Js],props:["id","model","width","height","left","top","tabOrder","maskType","pageScale","fontSize","type","readonly","colorClass","fieldValue","countFields","totalPages","currentPage","isShare","isEditShare","isClient","isSideBySide","shared"],components:{PfInput:m},methods:{saveValue:function(){this.isClient?this.fieldValue.edit=this.value:this.isShare?this.fieldValue.origin=this.value:this.isSideBySide?!0===this.readonly?this.fieldValue.origin=this.value:this.fieldValue.edit=this.value:this.fieldValue.origin=this.value;var t=this.fieldValue;t.value=this.value,t.pdfField=this.id,t.model=this.model,this.$emit("update-field-db",t)},updateFieldDb:function(t){var e=t;e.pdfField=t.id,this.$emit("update-field-db",e)}}},dl={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[-1===t.id.indexOf("newField")?n("div",{style:t.style,on:{click:t.shareField}},[n("pf-input",{attrs:{id:!0===t.readonly?"origin"+t.id:t.id,type:"text",styleElement:!0===t.isShare?t.inputStyleShare:t.inputStyle,readonly:t.readonly?t.readonly:t.isShare,classElement:t.colorClass,isReverse:t.isReverse,tabindex:t.tabOrder,isForm:!0,mask:t.mask,maxlength:""!==t.fData.maxCharacter?t.fData.maxCharacter:null,fData:t.fData,fontSize:t.fontSize},on:{"update-field-db":t.updateFieldDb,keyup:function(e){return t.scrollBehindDownMenu(t.id)},keytab:t.tabField,change:t.saveValue,context:function(e){return t.$emit("open:context",{top:t.top,left:t.left,fieldValue:t.fieldValue})}},model:{value:t.value,callback:function(e){t.value=e},expression:"value"}})],1):t._e()])},staticRenderFns:[]},cl=n("VU/8")(ll,dl,!1,null,null,null).exports,hl={name:"pf-form-text-area",mixins:[Js],props:["id","model","width","height","left","top","tabOrder","pageScale","fontSize","type","readonly","colorClass","fieldValue","countFields","totalPages","currentPage","isShare","isEditShare","isClient","isSideBySide","shared"],components:{PfTextArea:T},methods:{saveValue:function(){this.isClient?this.fieldValue.edit=this.value:this.isShare?this.fieldValue.origin=this.value:this.isSideBySide?!0===this.readonly?this.fieldValue.origin=this.value:this.fieldValue.edit=this.value:this.fieldValue.origin=this.value;var t=this.fieldValue;t.value=this.value,t.pdfField=this.id,t.model=this.model,this.$emit("update-field-db",t)}}},ul={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return-1===t.id.indexOf("newField")?n("div",{style:t.style,on:{click:t.shareField}},[n("pf-text-area",{attrs:{id:!0===t.readonly?"origin"+t.id:t.id,styleElement:!0===t.isShare?t.inputStyleShare:t.inputStyle,readonly:t.readonly?t.readonly:t.isShare,classElement:t.colorClass,isReverse:t.isReverse,tabindex:t.tabOrder,isForm:!0,draggable:!1,maxlength:""!==t.fData.maxCharacter?t.fData.maxCharacter:null,type:"textarea",fData:t.fData,fontSize:t.fontSize},on:{keyup:function(e){return t.scrollBehindDownMenu(t.id)},keytab:t.tabField,change:t.saveValue,context:function(e){return t.$emit("open:context",{top:t.top,left:t.left,fieldValue:t.fieldValue})}},model:{value:t.value,callback:function(e){t.value=e},expression:"value"}})],1):t._e()},staticRenderFns:[]},ml=n("VU/8")(hl,ul,!1,null,null,null).exports,fl={name:"pf-fields",data:function(){return{bottomPage:863,top:0,left:0,isWatchStyle:!1,pageScaleOwn:1,pagesOwn:{},pageOwn:[]}},props:{pages:{type:Object},page:{type:Array},indexPage:{type:Number},indexInf:{type:String},readonly:{type:Boolean,default:!1},colorClass:{type:Object},pageScale:{type:Number},fontSize:{type:Number},totalPages:{type:Number},isShare:{type:Boolean},isEditShare:{type:Boolean},isClient:{type:Boolean},isSideBySide:{type:Boolean},isLoadSvg:{type:Boolean},fieldsShared:{type:Object},isReverse:{type:Boolean}},computed:{setStyle:function(){var t=!0===this.readonly?document.getElementById("origin"+this.indexPage+"svg"):document.getElementById(this.indexPage+"svg");return null!==t?"top:"+t.offsetTop+"px;left:"+t.offsetLeft+"px;":""}},components:{PfFormCheckbox:el,PfFormRadio:al,PfFormSelect:sl,PfFormText:cl,PfFormTextArea:ml},watch:{pageScale:function(t){this.pageScaleOwn=t;var e=!0===this.readonly?document.getElementById("origin"+this.indexPage+"svg"):document.getElementById(this.indexPage+"svg");null!==e?(this.isWatchStyle=!0,this.top=e.offsetTop,this.left=e.offsetLeft):this.isWatchStyle=!1},isLoadSvg:function(t){this.isWatchStyle=!0;var e=!0===this.readonly?document.getElementById("origin"+this.indexPage+"svg"):document.getElementById(this.indexPage+"svg");this.top=null!==e?e.offsetTop+"px;":"",this.left=null!==e?e.offsetLeft+"px;":""}},mounted:function(){this.pageScaleOwn=this.pageScale,this.pagesOwn=this.pages,this.pageOwn=this.page},methods:{setTabOrderMultiple:function(t){var e=100*t.index;return e+=t.tabIndex},updateFieldDb:function(t){this.$emit("update-field-db",t)},openContextMenu:function(t){this.$emit("open:context",t)},shareField:function(t){this.$emit("share-field",t)},setPseudo:function(t){this.$emit("set-pseudo",t)},setPseudoColor:function(t){this.$emit("set-pseudo:color",t)},setPseudoShareColor:function(t){this.$emit("set-pseudo-share:color",t)},setPseudoNoShareColor:function(t){this.$emit("set-pseudo-noshare:color",t)},radioChangeField:function(t){var e=this,n=this.pagesOwn;this.pagesOwn={},this.pageOwn=[],Y()(n).forEach(function(i){n[i].forEach(function(a,o){if(a.id===t.id&&"checkbox"===document.getElementById(t.id).type){document.getElementById(t.id).checked=!1,!0===e.isClient?n[i][o].fieldValue.edit="off":n[i][o].fieldValue.origin="off";var r=n[i][o].fieldValue;r.value="off",r.pdfField=n[i][o].id,r.model=n[i][o].model,r.type="checkbox",e.$emit("update-field-db",r)}})}),this.pagesOwn=n,this.pageOwn=this.pagesOwn[this.indexPage]}}},pl={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticStyle:{position:"absolute"},style:!0===t.isWatchStyle?"top:"+t.top+"px;left:"+t.left+"px;":t.setStyle,attrs:{id:"pageFields"+t.indexPage}},[t._l(t.pageOwn,function(e,i){return[null===e||void 0===e.type||"checkbox"!==e.type.toLowerCase()&&"button"!==e.type.toLowerCase()?t._e():[n("pf-form-checkbox",{key:i,attrs:{id:e.id,model:!0===t.isClient?"":e.model,width:e.width*t.pageScaleOwn,height:e.height*t.pageScaleOwn,left:e.x*t.pageScaleOwn,top:e.y*t.pageScaleOwn,type:e.type,pageScale:t.pageScaleOwn,fontSize:t.fontSize,tabOrder:t.setTabOrderMultiple({index:t.indexPage,tabIndex:e.tabOrder}),readonly:!0===t.readonly?t.readonly:!1===e.shareClient,colorClass:void 0===t.colorClass?"":void 0!==t.colorClass[e.id]?t.colorClass[e.id]:"",fieldValue:e.fieldValue,countFields:t.page.length,totalPages:t.totalPages,currentPage:t.indexPage,isShare:t.isShare,isEditShare:t.isEditShare,isClient:t.isClient,isSideBySide:t.isSideBySide,shared:e.shared,cantFields:t.page.length,position:i+1,fieldsShared:t.fieldsShared,isReverse:t.isReverse,fData:e},on:{"update-field-db":t.updateFieldDb,"open:context":t.openContextMenu,"share-field":t.shareField,"load-svg":function(e){return t.$emit("load-svg")},"set-pseudo":t.setPseudo,"set-pseudo:color":t.setPseudoColor,"set-pseudo-share:color":t.setPseudoShareColor,"set-pseudo-noshare:color":t.setPseudoNoShareColor,"radio-change:field":t.radioChangeField}})],t._v(" "),null!==e&&void 0!==e.type&&"select"===e.type.toLowerCase()?[n("pf-form-select",{key:i,attrs:{id:e.id,model:!0===t.isClient?"":e.model,width:e.width*t.pageScaleOwn,height:e.height*t.pageScaleOwn,left:e.x*t.pageScaleOwn,top:e.y*t.pageScaleOwn,options:e.choiceData,tabOrder:t.setTabOrderMultiple({index:t.indexPage,tabIndex:e.tabOrder}),pageScale:t.pageScaleOwn,fontSize:t.fontSize,type:e.type,readonly:!0===t.readonly?t.readonly:!1===e.shareClient,colorClass:void 0===t.colorClass?"":void 0!==t.colorClass[e.id]?t.colorClass[e.id]:"",fieldValue:e.fieldValue,countFields:t.page.length,totalPages:t.totalPages,currentPage:t.indexPage,isShare:t.isShare,isEditShare:t.isEditShare,isClient:t.isClient,isSideBySide:t.isSideBySide,shared:e.shared,cantFields:t.page.length,position:i+1,fieldsShared:t.fieldsShared,isReverse:t.isReverse,fData:e},on:{"update-field-db":t.updateFieldDb,"open:context":t.openContextMenu,"share-field":t.shareField,"load-svg":function(e){return t.$emit("load-svg")},"action-full:page":function(e){return t.$emit("action-full:page")}}})]:t._e(),t._v(" "),null!==e&&void 0!==e.type&&"text"===e.type.toLowerCase()&&e.height<=50?[n("pf-form-text",{key:i,attrs:{id:e.id,model:!0===t.isClient?"":e.model,width:e.width*t.pageScaleOwn,height:e.height*t.pageScaleOwn,left:e.x*t.pageScaleOwn,top:e.y*t.pageScaleOwn,tabOrder:t.setTabOrderMultiple({index:t.indexPage,tabIndex:e.tabOrder}),pageScale:t.pageScaleOwn,maskType:e.maskType,fontSize:t.fontSize,type:e.type,readonly:!0===t.readonly?t.readonly:!1===e.shareClient,colorClass:void 0===t.colorClass?"":void 0!==t.colorClass[e.id]?t.colorClass[e.id]:"",fieldValue:e.fieldValue,countFields:t.page.length,totalPages:t.totalPages,currentPage:t.indexPage,isShare:t.isShare,isEditShare:t.isEditShare,isClient:t.isClient,isSideBySide:t.isSideBySide,shared:e.shared,cantFields:t.page.length,position:i+1,fieldsShared:t.fieldsShared,isReverse:t.isReverse,fData:e},on:{"update-field-db":t.updateFieldDb,"open:context":t.openContextMenu,"share-field":t.shareField,"load-svg":function(e){return t.$emit("load-svg")}}})]:t._e(),t._v(" "),null!==e&&void 0!==e.type&&"text"===e.type.toLowerCase()&&e.height>50?[n("pf-form-text-area",{key:i+"area",attrs:{id:e.id,model:!0===t.isClient?"":e.model,width:e.width*t.pageScaleOwn,height:e.height*t.pageScaleOwn,left:e.x*t.pageScaleOwn,top:e.y*t.pageScaleOwn,tabOrder:t.setTabOrderMultiple({index:t.indexPage,tabIndex:e.tabOrder}),pageScale:t.pageScaleOwn,fontSize:t.fontSize,type:e.type,readonly:!0===t.readonly?t.readonly:!1===e.shareClient,colorClass:void 0===t.colorClass?"":void 0!==t.colorClass[e.id]?t.colorClass[e.id]:"",fieldValue:e.fieldValue,countFields:t.page.length,totalPages:t.totalPages,currentPage:t.indexPage,isShare:t.isShare,isEditShare:t.isEditShare,isClient:t.isClient,isSideBySide:t.isSideBySide,shared:e.shared,cantFields:t.page.length,position:i+1,fieldsShared:t.fieldsShared,isReverse:t.isReverse,fData:e},on:{"update-field-db":t.updateFieldDb,"open:context":t.openContextMenu,"share-field":t.shareField,"load-svg":function(e){return t.$emit("load-svg")}}})]:t._e()]})],2)},staticRenderFns:[]};var _l,Al=n("VU/8")(fl,pl,!1,function(t){n("JGZ4")},null,null).exports,bl=n("IaZh"),xl={name:"pf-side-bar",data:function(){return{dbInformation:{},dbInformationComparing:{},duplex:{},tabsGeneral:{},tabsForm:{},isTabNames:!1,isTabCommunication:!1,isTabBiographic:!1,isTabAdditional:!1,isTabImmigration:!1,isTabPriority:!1,isTabAddresses:!1,isTabPreviousAddresses:!1,isTabPhones:!1,isTabJobs:!1,isTabEducational:!1,isTabCriminal:!1,isTabEads:!1,isTabPassports:!1,isTabTravel:!1,isTabUsEntries:!1,isTabVisas:!1,isTabMarriage:!1,isTabFamily:!1,isTabAdvance:!1,namesComparingBadge:0,communicationComparingBadge:0,biographicInformationComparingBadge:0,backgroundCheckInformationComparingBadge:0,immigrationInformationComparingBadge:0,priorityDatesComparingBadge:0,addressesComparingBadge:0,previousAddressesComparingBadge:0,phonesComparingBadge:0,jobsComparingBadge:0,educationalHistoryComparingBadge:0,criminalHistoryComparingBadge:0,eadComparingBadge:0,passportsComparingBadge:0,travelHistoryComparingBadge:0,usEntriesComparingBadge:0,visaHistoryComparingBadge:0,marriageHistoryComparingBadge:0,familyMembersComparingBadge:0,advanceParoleComparingBadge:0,formBadges:{},idChangeFocus:"",itemActive:"namesComparing",comparingInformation:[],titleContent:"",pathBackground:"",viewerUrl:"https://forms.primafacieapp.com/",renderFields:!1,isRightSideBar:!1,sizeBrowser:window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,scrollY:0,formNames:[],formName:"",caseFormId:"",widgetLabels:{},apiService:{},currentFieldsToShortCuts:[],informationAddresses:[],informationPreviousAddresses:[],informationPhones:[],informationJobs:[],informationEducational:[],informationCriminal:[],informationEads:[],informationPassports:[],informationTravel:[],informationUsEntries:[],informationVisa:[],informationMarriage:[],informationFamily:[],informationAdvance:[],duplexInformationQuestionnaire:{},paramsEstructureQuestionnaire:{},infoQuestionnaire:{},isChangeBadge:!1,moment:ct.a,isSpinnerInit:!0,isSpinner:!0,isPopUp:!1,typePopUp:"",messagePopUp:"",titlePopUp:"",actionPopUp:"",listContactNames:["firstName","middleName","lastName","otherFirst1","otherMiddle1","otherLast1","otherFirst2","otherMiddle2","otherLast2","otherFirst3","otherMiddle3","otherLast3","firstNameNativeAlpha","middleNameNativeAlpha","lastNameNativeAlpha"],listCommunication:["email"],listBiographic:["sexFemale","sexMale","birthDate","socialSecurityNumber","pobCity","pobState","pobCountry"],listBackgroundCheck:["hisp","nothisp","white","asian","black","amind","hawaii","eyeBlack","eyeGray","eyeMaroon","eyeBlue","eyeGreen","eyePink","eyeBrown","eyeHazel","eyeUnk","hairBald","hairBrown","hairSandy","hairBlack","hairWhite","hairBlond","hairRed","hairUnk","uscYes","uscNo","lprYes","lprNo","uscNat","uscBirth","uscParents","heightFt","heightIn","weightFull"],listImmigration:["alienNumber","citizenship","i94","placeOfLastEntryToUs","dateOfLastEntryToUs","currentImmigrationStatus","crExp","elis","lprExp","nvcDosCaseNum","dateAdmissionLpr","classAdmissionLpr","certificateNaturalizationNumber"],listPriority:["pdFamilyPetitionDate","pdFamilyPetitionCountry","pdFamilyPetitionCategory","pdEmploymentDate","pdEmploymentPetitionCountry","pdEmploymentPetitionCategory"],listPhones:["number","type","deletedAt"],listNoItems:["contactId","isCurrent","module","objectId","createdAt","updatedAt"],originEditManual:{},selectedValue:null,positionContext:{},currentFormId:"",helpTexts:{namesComparing:"Please enter your current legal name as shown on your passport and birth certificate.",communicationComparing:"Please provide an email address here.  This should be an email address you can receive important documents.  You must check this address regularly.",biographicInformationComparing:"Please enter your information here.",backgroundCheckInformationComparing:"Please enter your information here.",immigrationInformationComparing:"Please enter your immigration information here.",priorityDatesComparing:"If you have ever filed a visa petition, or if someone has filed a visa petition for you before, please enter that information here.",addressesComparing:"Please provide your current PHYSICAL address, MAILING address and a FOREIGN address, if you have one.",previousAddressesComparing:"Please see the box below, which will indicate how many of your previous addresses you should provide.",phonesComparing:"Please provide your HOME, MOBILE, WORK and FAX phone number (if you have one).",jobsComparing:"Please see the box below to know how many previous employers you should enter here.",educationalHistoryComparing:"Please see the box below to know how many previous schools or educational institutions you should list here.",criminalHistoryComparing:"Please list all arrests, convictions, court cases or interactions with the police here.  Your attorney will need as much information as possible about these things.  Please include if you were arrested by immigration.  Please include any case which was later 'dismissed.'",eadComparing:"If you have ever been issued a work permit in the United States, please enter that information here.",passportsComparing:"Please enter your current passport information here.",travelHistoryComparing:"If you are already a Legal Permanent Resident and have travelled in the last 5 years, please enter those details here.",usEntriesComparing:"Please provide information about each entry, or attempted entry into the United States here.  If you are a legal permanent resident, only include information about entries or attempted entries that occured before you were officially granted residency in the United States.",visaHistoryComparing:"If you have previously recieved any visas to the United States, please provide all of the following information here.",marriageHistoryComparing:"Please provide information about any current or prior spouses (if any).",familyMembersComparing:"Please see the box below to know which family members you should provide information on here.",advanceParoleComparing:"If you have ever been granted advance parole, please provide that information here."},counterPopUp:"",isModels:!1,isForms:!1,noShowPrev:!0,noShowNext:!1}},props:{token:{type:String,default:""},comparing:{type:Boolean,default:!1},contactid:{type:Number},viewer:{type:Boolean,default:!1},questionnaireid:{type:String},questionnaireData:{type:Object}},components:{PfPersonal:yr,PfAddress:gt,PfPhone:Ht,PfJob:Dr,PfEducational:Lr,PfCrime:Hr,PfEad:Wr,PfPassport:Kr,PfTravel:os,PfUsEntry:hs,PfVisa:As,PfMarriage:ys,PfFamilyMember:Ds,PfAdvance:Ls,PfFields:Al,PfContactNames:lr,PfCommunication:Hs,PfBiographicInformation:hr,PfImmigrationInformation:fr,PfBackgroundCheckInformation:Ar,PfPriorityDates:gr,PfAddresses:Ft,PfPhones:No,PfJobs:Mr,PfEducationalHistory:Fr,PfCriminalHistory:Xr,PfEads:Zr,PfPassports:ns,PfTravelHistory:ls,PfUsEntries:fs,PfVisaHistory:gs,PfMarriageHistory:ks,PfFamilyMembers:Ms,PfAdvanceParole:Fs,PfMaritalStatus:Xs,PfQuestionnaireForm:Ws,PfQuestionnaireFormComparing:Zs,PfButton:d,PfSpinner:r,PfPopUp:$,VueContext:bl.VueContext},created:function(){var t=this;if(this.apiService=Tt,!1===this.viewer&&void 0===this.questionnaireid)this.formNames.push("List"),this.isForms=!0,this.isModels=!0,this.getContact(),this.isTabNames=!0,this.isTabCommunication=!0,this.isTabBiographic=!0,this.isTabAdditional=!0,this.isTabImmigration=!0,this.isTabPriority=!0,this.isTabAddresses=!0,this.isTabPreviousAddresses=!0,this.isTabPhones=!0,this.isTabJobs=!0,this.isTabEducational=!0,this.isTabCriminal=!0,this.isTabEads=!0,this.isTabPassports=!0,this.isTabTravel=!0,this.isTabUsEntries=!0,this.isTabVisas=!0,this.isTabMarriage=!0,this.isTabFamily=!0,this.isTabAdvance=!0;else if(void 0===this.questionnaireData&&void 0!==this.questionnaireid){var e="";!0===this.viewer?e="getCaseQuestionnaireCT":!0===this.comparing&&(e="getCaseQuestionnaire"),Tt[e]({questionnaireId:this.questionnaireid,token:this.token}).then(function(e){if(void 0!==e.caseQuestionnaires&&null!==e.caseQuestionnaires&&""!==e.caseQuestionnaires){var n=e.caseQuestionnaires[0];void 0!==n.onlyForms&&null!==n.onlyForms||(n.onlyForms=!0),void 0!==n.onlyGeneral&&null!==n.onlyGeneral||(n.onlyGeneral=!0),!0===n.onlyForms&&(t.isForms=!0),t.setDynamicTabs(e.caseQuestionnaires[0].forms),!0===n.onlyGeneral&&(t.isModels=!0),!0===t.viewer?t.setQuestionnaireInformation(e.caseQuestionnaires[0]):!0===t.comparing&&(t.dbInformationComparing=e.caseQuestionnaires[0].models,e.caseQuestionnaires[0].forms.forEach(function(e){var n;n={id:e._id+"-"+e.caseFormId,name:e.name},t.formNames.push(n)}),t.dbInformationComparing.forms=e.caseQuestionnaires[0].forms,n.forms.length>0&&t.getWidgetLabels(),t.generateDuplex())}})}else void 0!==this.questionnaireData&&(void 0!==this.questionnaireData.onlyForms&&null!==this.questionnaireData.onlyForms||(this.questionnaireData.onlyForms=!0),void 0!==this.questionnaireData.onlyGeneral&&null!==this.questionnaireData.onlyGeneral||(this.questionnaireData.onlyGeneral=!0),this.setQuestionnaireInformation(this.questionnaireData))},mounted:function(){var t=this;document.onkeyup=function(e){!1!==this.comparing&&(e.altKey&&78===e.which&&(t.currentFieldsToShortCuts.map(function(t){return t.fieldId}).indexOf(t.idChangeFocus)+1>t.currentFieldsToShortCuts.length-1?document.getElementById("paging-next").click():t.moveToChange(t.currentFieldsToShortCuts.map(function(t){return t.fieldId}).indexOf(t.idChangeFocus)+1)),e.altKey&&80===e.which&&(0!==t.currentFieldsToShortCuts.map(function(t){return t.fieldId}).indexOf(t.idChangeFocus)&&-1!==t.currentFieldsToShortCuts.map(function(t){return t.fieldId}).indexOf(t.idChangeFocus)||document.getElementById("paging-previous").click(),t.moveToChange(t.currentFieldsToShortCuts.map(function(t){return t.fieldId}).indexOf(t.idChangeFocus)-1)))},null!==document.getElementById("messageNoInfo")&&document.getElementById("messageNoInfo").classList.add("fadeIn"),null!==document.getElementById("bodyComparing")&&(document.getElementById("bodyComparing").addEventListener("input",function(e){if(!1!==this.comparing){if("radio"===e.target.type)t.setClassComparingRadios(e);else if("checkbox"===e.target.type)t.setClassComparingCheckboxes(e);else{var n=void 0;e.target.classList.forEach(function(t){-1!==t.indexOf("information")&&(n=t)}),t.changeClassComparing({classColor:n,id:e.target.id})}t.setCurrentShortCuts()}}),document.getElementById("bodyComparing").addEventListener("change",function(e){!1!==this.comparing&&"input"!==e.target.localName&&(t.changeClassComparing({classColor:e.target.classList[2],id:e.target.id}),t.setCurrentShortCuts())}))},methods:(_l={setQuestionnaireInformation:function(t){var e=this;this.setDynamicTabs(t.forms),!0===t.onlyForms&&(this.isForms=!0),!0===t.onlyGeneral?(this.isModels=!0,this.dbInformation=t.models,Y()(this.dbInformation.personal).forEach(function(t){e.dbInformation.personal[t]=null!==e.dbInformation.personal[t]&&void 0!==e.dbInformation.personal[t]?e.dbInformation.personal[t].edit:null}),"Interpreter"!==t.roleType&&(this.dbInformation.addresses.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationAddresses.push(n)}}),this.dbInformation.previousAddresses.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationPreviousAddresses.push(n)}}),this.dbInformation.phones.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationPhones.push(n)}}),this.dbInformation.jobs.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationJobs.push(n)}}),this.dbInformation.educationalHistory.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationEducational.push(n)}}),this.dbInformation.criminalHistory.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationCriminal.push(n)}}),this.dbInformation.ead.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationEads.push(n)}}),this.dbInformation.passports.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationPassports.push(n)}}),this.dbInformation.travelHistory.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationTravel.push(n)}}),this.dbInformation.usEntries.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationUsEntries.push(n)}}),this.dbInformation.visaHistory.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationVisa.push(n)}}),this.dbInformation.marriageHistory.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationMarriage.push(n)}}),this.dbInformation.familyMembers.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationFamily.push(n)}}),this.dbInformation.advanceParole.forEach(function(t){if(void 0===t.deletedAt||null===t.deletedAt.edit||""===t.deletedAt.edit){var n={};Y()(t).forEach(function(e){n[e]=t[e].edit}),e.informationAdvance.push(n)}}))):(this.itemActive=t.forms[0]._id+"-"+t.forms[0].caseId,this.formName=t.forms[0].name),t.forms.length>0?(this.dbInformation.forms=t.forms,this.getWidgetLabels()):(this.isSpinnerInit=!1,this.isSpinner=!1)},setDynamicTabs:function(t){var e=this;t.forEach(function(t){var n="";n=!0===e.viewer?"graphTemplatesCT":"graphTemplates",Tt[n]({token:e.token,formId:t._id}).then(function(t){void 0!==t.templates&&!0===e.isModels&&e.getModels(t.templates[t.templates.map(function(t){return t.name}).indexOf("default")]),e.isSpinnerInit=!1,e.isSpinner=!1,setTimeout(function(){!1===e.isModels&&!1===e.comparing&&document.getElementById(e.questionnaireData.forms[0]._id+"-"+e.questionnaireData.forms[0].caseFormId).click()},500)})}),this.isSpinnerInit=!1,this.isSpinner=!1},getModels:function(t){var e=this;t.pages&&null!==t.pages&&Ct()(t.pages).forEach(function(t){null!==t&&(t.forEach(function(e,n){null===e&&t.splice(n,1)}),-1===t.map(function(t){return t.model}).indexOf("client_first_name")&&-1===t.map(function(t){return t.model}).indexOf("client2_first_name")&&-1===t.map(function(t){return t.model}).indexOf("client3_first_name")&&-1===t.map(function(t){return t.model}).indexOf("client4_first_name")&&-1===t.map(function(t){return t.model}).indexOf("client5_first_name")&&-1===t.map(function(t){return t.model}).indexOf("client6_first_name")&&-1===t.map(function(t){return t.model}).indexOf("client7_first_name")&&-1===t.map(function(t){return t.model}).indexOf("client8_first_name")&&-1===t.map(function(t){return t.model}).indexOf("client_middle_name")&&-1===t.map(function(t){return t.model}).indexOf("client2_middle_name")&&-1===t.map(function(t){return t.model}).indexOf("client3_middle_name")&&-1===t.map(function(t){return t.model}).indexOf("client4_middle_name")&&-1===t.map(function(t){return t.model}).indexOf("client5_middle_name")&&-1===t.map(function(t){return t.model}).indexOf("client6_middle_name")&&-1===t.map(function(t){return t.model}).indexOf("client7_middle_name")&&-1===t.map(function(t){return t.model}).indexOf("client8_middle_name")&&-1===t.map(function(t){return t.model}).indexOf("client_last_name")&&-1===t.map(function(t){return t.model}).indexOf("client2_last_name")&&-1===t.map(function(t){return t.model}).indexOf("client3_last_name")&&-1===t.map(function(t){return t.model}).indexOf("client4_last_name")&&-1===t.map(function(t){return t.model}).indexOf("client5_last_name")&&-1===t.map(function(t){return t.model}).indexOf("client6_last_name")&&-1===t.map(function(t){return t.model}).indexOf("client7_last_name")&&-1===t.map(function(t){return t.model}).indexOf("client8_last_name")&&-1===t.map(function(t){return t.model}).indexOf("client_other1_first")&&-1===t.map(function(t){return t.model}).indexOf("client2_other1_first")&&-1===t.map(function(t){return t.model}).indexOf("client3_other1_first")&&-1===t.map(function(t){return t.model}).indexOf("client4_other1_first")&&-1===t.map(function(t){return t.model}).indexOf("client5_other1_first")&&-1===t.map(function(t){return t.model}).indexOf("client6_other1_first")&&-1===t.map(function(t){return t.model}).indexOf("client7_other1_first")&&-1===t.map(function(t){return t.model}).indexOf("client8_other1_first")&&-1===t.map(function(t){return t.model}).indexOf("client_other1_middle")&&-1===t.map(function(t){return t.model}).indexOf("client2_other1_middle")&&-1===t.map(function(t){return t.model}).indexOf("client3_other1_middle")&&-1===t.map(function(t){return t.model}).indexOf("client4_other1_middle")&&-1===t.map(function(t){return t.model}).indexOf("client5_other1_middle")&&-1===t.map(function(t){return t.model}).indexOf("client6_other1_middle")&&-1===t.map(function(t){return t.model}).indexOf("client7_other1_middle")&&-1===t.map(function(t){return t.model}).indexOf("client8_other1_middle")&&-1===t.map(function(t){return t.model}).indexOf("client_other1_last")&&-1===t.map(function(t){return t.model}).indexOf("client2_other1_last")&&-1===t.map(function(t){return t.model}).indexOf("client3_other1_last")&&-1===t.map(function(t){return t.model}).indexOf("client4_other1_last")&&-1===t.map(function(t){return t.model}).indexOf("client5_other1_last")&&-1===t.map(function(t){return t.model}).indexOf("client6_other1_last")&&-1===t.map(function(t){return t.model}).indexOf("client7_other1_last")&&-1===t.map(function(t){return t.model}).indexOf("client8_other1_last")&&-1===t.map(function(t){return t.model}).indexOf("client_other2_first")&&-1===t.map(function(t){return t.model}).indexOf("client2_other2_first")&&-1===t.map(function(t){return t.model}).indexOf("client3_other2_first")&&-1===t.map(function(t){return t.model}).indexOf("client4_other2_first")&&-1===t.map(function(t){return t.model}).indexOf("client5_other2_first")&&-1===t.map(function(t){return t.model}).indexOf("client6_other2_first")&&-1===t.map(function(t){return t.model}).indexOf("client7_other2_first")&&-1===t.map(function(t){return t.model}).indexOf("client8_other2_first")&&-1===t.map(function(t){return t.model}).indexOf("client_other2_middle")&&-1===t.map(function(t){return t.model}).indexOf("client2_other2_middle")&&-1===t.map(function(t){return t.model}).indexOf("client3_other2_middle")&&-1===t.map(function(t){return t.model}).indexOf("client4_other2_middle")&&-1===t.map(function(t){return t.model}).indexOf("client5_other2_middle")&&-1===t.map(function(t){return t.model}).indexOf("client6_other2_middle")&&-1===t.map(function(t){return t.model}).indexOf("client7_other2_middle")&&-1===t.map(function(t){return t.model}).indexOf("client8_other2_middle")&&-1===t.map(function(t){return t.model}).indexOf("client_other2_last")&&-1===t.map(function(t){return t.model}).indexOf("client2_other2_last")&&-1===t.map(function(t){return t.model}).indexOf("client3_other2_last")&&-1===t.map(function(t){return t.model}).indexOf("client4_other2_last")&&-1===t.map(function(t){return t.model}).indexOf("client5_other2_last")&&-1===t.map(function(t){return t.model}).indexOf("client6_other2_last")&&-1===t.map(function(t){return t.model}).indexOf("client7_other2_last")&&-1===t.map(function(t){return t.model}).indexOf("client8_other2_last")&&-1===t.map(function(t){return t.model}).indexOf("client_other3_first")&&-1===t.map(function(t){return t.model}).indexOf("client2_other3_first")&&-1===t.map(function(t){return t.model}).indexOf("client3_other3_first")&&-1===t.map(function(t){return t.model}).indexOf("client4_other3_first")&&-1===t.map(function(t){return t.model}).indexOf("client5_other3_first")&&-1===t.map(function(t){return t.model}).indexOf("client6_other3_first")&&-1===t.map(function(t){return t.model}).indexOf("client7_other3_first")&&-1===t.map(function(t){return t.model}).indexOf("client8_other3_first")&&-1===t.map(function(t){return t.model}).indexOf("client_other3_middle")&&-1===t.map(function(t){return t.model}).indexOf("client2_other3_middle")&&-1===t.map(function(t){return t.model}).indexOf("client3_other3_middle")&&-1===t.map(function(t){return t.model}).indexOf("client4_other3_middle")&&-1===t.map(function(t){return t.model}).indexOf("client5_other3_middle")&&-1===t.map(function(t){return t.model}).indexOf("client6_other3_middle")&&-1===t.map(function(t){return t.model}).indexOf("client7_other3_middle")&&-1===t.map(function(t){return t.model}).indexOf("client8_other3_middle")&&-1===t.map(function(t){return t.model}).indexOf("client_other3_last")&&-1===t.map(function(t){return t.model}).indexOf("client2_other3_last")&&-1===t.map(function(t){return t.model}).indexOf("client3_other3_last")&&-1===t.map(function(t){return t.model}).indexOf("client4_other3_last")&&-1===t.map(function(t){return t.model}).indexOf("client5_other3_last")&&-1===t.map(function(t){return t.model}).indexOf("client6_other3_last")&&-1===t.map(function(t){return t.model}).indexOf("client7_other3_last")&&-1===t.map(function(t){return t.model}).indexOf("client8_other3_last")&&-1===t.map(function(t){return t.model}).indexOf("client_first_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client2_first_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client3_first_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client4_first_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client5_first_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client6_first_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client7_first_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client8_first_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client_middle_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client2_middle_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client3_middle_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client4_middle_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client5_middle_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client6_middle_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client7_middle_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client8_middle_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client_last_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client2_last_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client3_last_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client4_last_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client5_last_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client6_last_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client7_last_name_native")&&-1===t.map(function(t){return t.model}).indexOf("client8_last_name_native")||(e.isTabNames=!0),-1!==t.map(function(t){return t.model}).indexOf("client_email")&&(e.isTabCommunication=!0),-1!==t.map(function(t){return t.model}).indexOf("client2_email")&&(e.isTabCommunication=!0),-1!==t.map(function(t){return t.model}).indexOf("client3_email")&&(e.isTabCommunication=!0),-1!==t.map(function(t){return t.model}).indexOf("client4_email")&&(e.isTabCommunication=!0),-1!==t.map(function(t){return t.model}).indexOf("client5_email")&&(e.isTabCommunication=!0),-1!==t.map(function(t){return t.model}).indexOf("client6_email")&&(e.isTabCommunication=!0),-1!==t.map(function(t){return t.model}).indexOf("client7_email")&&(e.isTabCommunication=!0),-1!==t.map(function(t){return t.model}).indexOf("client8_email")&&(e.isTabCommunication=!0),-1===t.map(function(t){return t.model}).indexOf("client_sex_male")&&-1===t.map(function(t){return t.model}).indexOf("client2_sex_male")&&-1===t.map(function(t){return t.model}).indexOf("client3_sex_male")&&-1===t.map(function(t){return t.model}).indexOf("client4_sex_male")&&-1===t.map(function(t){return t.model}).indexOf("client5_sex_male")&&-1===t.map(function(t){return t.model}).indexOf("client6_sex_male")&&-1===t.map(function(t){return t.model}).indexOf("client7_sex_male")&&-1===t.map(function(t){return t.model}).indexOf("client8_sex_male")&&-1===t.map(function(t){return t.model}).indexOf("client_sex_female")&&-1===t.map(function(t){return t.model}).indexOf("client2_sex_female")&&-1===t.map(function(t){return t.model}).indexOf("client3_sex_female")&&-1===t.map(function(t){return t.model}).indexOf("client4_sex_female")&&-1===t.map(function(t){return t.model}).indexOf("client5_sex_female")&&-1===t.map(function(t){return t.model}).indexOf("client6_sex_female")&&-1===t.map(function(t){return t.model}).indexOf("client7_sex_female")&&-1===t.map(function(t){return t.model}).indexOf("client8_sex_female")&&-1===t.map(function(t){return t.model}).indexOf("client_pob_country")&&-1===t.map(function(t){return t.model}).indexOf("client2_pob_country")&&-1===t.map(function(t){return t.model}).indexOf("client3_pob_country")&&-1===t.map(function(t){return t.model}).indexOf("client4_pob_country")&&-1===t.map(function(t){return t.model}).indexOf("client5_pob_country")&&-1===t.map(function(t){return t.model}).indexOf("client6_pob_country")&&-1===t.map(function(t){return t.model}).indexOf("client7_pob_country")&&-1===t.map(function(t){return t.model}).indexOf("client8_pob_country")&&-1===t.map(function(t){return t.model}).indexOf("client_pob_city")&&-1===t.map(function(t){return t.model}).indexOf("client2_pob_city")&&-1===t.map(function(t){return t.model}).indexOf("client3_pob_city")&&-1===t.map(function(t){return t.model}).indexOf("client4_pob_city")&&-1===t.map(function(t){return t.model}).indexOf("client5_pob_city")&&-1===t.map(function(t){return t.model}).indexOf("client6_pob_city")&&-1===t.map(function(t){return t.model}).indexOf("client7_pob_city")&&-1===t.map(function(t){return t.model}).indexOf("client8_pob_city")&&-1===t.map(function(t){return t.model}).indexOf("client_pob_state")&&-1===t.map(function(t){return t.model}).indexOf("client2_pob_state")&&-1===t.map(function(t){return t.model}).indexOf("client3_pob_state")&&-1===t.map(function(t){return t.model}).indexOf("client4_pob_state")&&-1===t.map(function(t){return t.model}).indexOf("client5_pob_state")&&-1===t.map(function(t){return t.model}).indexOf("client6_pob_state")&&-1===t.map(function(t){return t.model}).indexOf("client7_pob_state")&&-1===t.map(function(t){return t.model}).indexOf("client8_pob_state")&&-1===t.map(function(t){return t.model}).indexOf("client_birth_date")&&-1===t.map(function(t){return t.model}).indexOf("client2_birth_date")&&-1===t.map(function(t){return t.model}).indexOf("client3_birth_date")&&-1===t.map(function(t){return t.model}).indexOf("client4_birth_date")&&-1===t.map(function(t){return t.model}).indexOf("client5_birth_date")&&-1===t.map(function(t){return t.model}).indexOf("client6_birth_date")&&-1===t.map(function(t){return t.model}).indexOf("client7_birth_date")&&-1===t.map(function(t){return t.model}).indexOf("client8_birth_date")&&-1===t.map(function(t){return t.model}).indexOf("client_social_security_number")&&-1===t.map(function(t){return t.model}).indexOf("client2_social_security_number")&&-1===t.map(function(t){return t.model}).indexOf("client3_social_security_number")&&-1===t.map(function(t){return t.model}).indexOf("client4_social_security_number")&&-1===t.map(function(t){return t.model}).indexOf("client5_social_security_number")&&-1===t.map(function(t){return t.model}).indexOf("client6_social_security_number")&&-1===t.map(function(t){return t.model}).indexOf("client7_social_security_number")&&-1===t.map(function(t){return t.model}).indexOf("client8_social_security_number")||(e.isTabBiographic=!0),-1===t.map(function(t){return t.model}).indexOf("client_alien_number")&&-1===t.map(function(t){return t.model}).indexOf("client2_alien_number")&&-1===t.map(function(t){return t.model}).indexOf("client3_alien_number")&&-1===t.map(function(t){return t.model}).indexOf("client4_alien_number")&&-1===t.map(function(t){return t.model}).indexOf("client5_alien_number")&&-1===t.map(function(t){return t.model}).indexOf("client6_alien_number")&&-1===t.map(function(t){return t.model}).indexOf("client7_alien_number")&&-1===t.map(function(t){return t.model}).indexOf("client8_alien_number")&&-1===t.map(function(t){return t.model}).indexOf("client_elis")&&-1===t.map(function(t){return t.model}).indexOf("client2_elis")&&-1===t.map(function(t){return t.model}).indexOf("client3_elis")&&-1===t.map(function(t){return t.model}).indexOf("client4_elis")&&-1===t.map(function(t){return t.model}).indexOf("client5_elis")&&-1===t.map(function(t){return t.model}).indexOf("client6_elis")&&-1===t.map(function(t){return t.model}).indexOf("client7_elis")&&-1===t.map(function(t){return t.model}).indexOf("client8_elis")&&-1===t.map(function(t){return t.model}).indexOf("client_citizenship")&&-1===t.map(function(t){return t.model}).indexOf("client2_citizenship")&&-1===t.map(function(t){return t.model}).indexOf("client3_citizenship")&&-1===t.map(function(t){return t.model}).indexOf("client4_citizenship")&&-1===t.map(function(t){return t.model}).indexOf("client5_citizenship")&&-1===t.map(function(t){return t.model}).indexOf("client6_citizenship")&&-1===t.map(function(t){return t.model}).indexOf("client7_citizenship")&&-1===t.map(function(t){return t.model}).indexOf("client8_citizenship")&&-1===t.map(function(t){return t.model}).indexOf("client_i94")&&-1===t.map(function(t){return t.model}).indexOf("client2_i94")&&-1===t.map(function(t){return t.model}).indexOf("client3_i94")&&-1===t.map(function(t){return t.model}).indexOf("client4_i94")&&-1===t.map(function(t){return t.model}).indexOf("client5_i94")&&-1===t.map(function(t){return t.model}).indexOf("client6_i94")&&-1===t.map(function(t){return t.model}).indexOf("client7_i94")&&-1===t.map(function(t){return t.model}).indexOf("client8_i94")&&-1===t.map(function(t){return t.model}).indexOf("client_place_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client2_place_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client3_place_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client4_place_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client5_place_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client6_place_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client7_place_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client8_place_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client_date_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client2_date_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client3_date_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client4_date_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client5_date_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client6_date_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client7_date_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client8_date_of_last_entry_to_us")&&-1===t.map(function(t){return t.model}).indexOf("client_certificate_naturalization_number")&&-1===t.map(function(t){return t.model}).indexOf("client2_certificate_naturalization_number")&&-1===t.map(function(t){return t.model}).indexOf("client3_certificate_naturalization_number")&&-1===t.map(function(t){return t.model}).indexOf("client4_certificate_naturalization_number")&&-1===t.map(function(t){return t.model}).indexOf("client5_certificate_naturalization_number")&&-1===t.map(function(t){return t.model}).indexOf("client6_certificate_naturalization_number")&&-1===t.map(function(t){return t.model}).indexOf("client7_certificate_naturalization_number")&&-1===t.map(function(t){return t.model}).indexOf("client8_certificate_naturalization_number")&&-1===t.map(function(t){return t.model}).indexOf("client_current_immigration_status")&&-1===t.map(function(t){return t.model}).indexOf("client2_current_immigration_status")&&-1===t.map(function(t){return t.model}).indexOf("client3_current_immigration_status")&&-1===t.map(function(t){return t.model}).indexOf("client4_current_immigration_status")&&-1===t.map(function(t){return t.model}).indexOf("client5_current_immigration_status")&&-1===t.map(function(t){return t.model}).indexOf("client6_current_immigration_status")&&-1===t.map(function(t){return t.model}).indexOf("client7_current_immigration_status")&&-1===t.map(function(t){return t.model}).indexOf("client8_current_immigration_status")&&-1===t.map(function(t){return t.model}).indexOf("client_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client2_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client3_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client4_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client5_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client6_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client7_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client8_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client2_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client3_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client4_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client5_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client6_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client7_class_admission_lpr")&&-1===t.map(function(t){return t.model}).indexOf("client8_class_admission_lpr")||(e.isTabImmigration=!0),t.map(function(t){return t.model}).forEach(function(t){void 0!==t&&((!1===e.isTabAdditional&&-1!==t.indexOf("client_bio_")||-1!==t.indexOf("client2_bio_")||-1!==t.indexOf("client3_bio_")||-1!==t.indexOf("client4_bio_")||-1!==t.indexOf("client5_bio_")||-1!==t.indexOf("client6_bio_")||-1!==t.indexOf("client7_bio_")||-1!==t.indexOf("client8_bio_"))&&(e.isTabAdditional=!0),!1!==e.isTabAddresses||-1===t.indexOf("client_address")&&-1===t.indexOf("client2_address")&&-1===t.indexOf("client3_address")&&-1===t.indexOf("client4_address")&&-1===t.indexOf("client5_address")&&-1===t.indexOf("client6_address")&&-1===t.indexOf("client7_address")&&-1===t.indexOf("client8_address")&&-1===t.indexOf("client_mailing")&&-1===t.indexOf("client2_mailing")&&-1===t.indexOf("client3_mailing")&&-1===t.indexOf("client4_mailing")&&-1===t.indexOf("client5_mailing")&&-1===t.indexOf("client6_mailing")&&-1===t.indexOf("client7_mailing")&&-1===t.indexOf("client8_mailing")&&-1===t.indexOf("client_foreign")&&-1===t.indexOf("client2_foreign")&&-1===t.indexOf("client3_foreign")&&-1===t.indexOf("client4_foreign")&&-1===t.indexOf("client5_foreign")&&-1===t.indexOf("client6_foreign")&&-1===t.indexOf("client7_foreign")&&-1===t.indexOf("client8_foreign")&&-1===t.indexOf("client_apt")&&-1===t.indexOf("client2_apt")&&-1===t.indexOf("client3_apt")&&-1===t.indexOf("client4_apt")&&-1===t.indexOf("client5_apt")&&-1===t.indexOf("client6_apt")&&-1===t.indexOf("client7_apt")&&-1===t.indexOf("client8_apt")||(e.isTabAddresses=!0),!1!==e.isTabPreviousAddresses||-1===t.indexOf("client_previous_address")&&-1===t.indexOf("client2_previous_address")&&-1===t.indexOf("client3_previous_address")&&-1===t.indexOf("client4_previous_address")&&-1===t.indexOf("client5_previous_address")&&-1===t.indexOf("client6_previous_address")&&-1===t.indexOf("client7_previous_address")&&-1===t.indexOf("client8_previous_address")||(e.isTabPreviousAddresses=!0),!1!==e.isTabPhones||-1===t.indexOf("client_phone")&&-1===t.indexOf("client2_phone")&&-1===t.indexOf("client3_phone")&&-1===t.indexOf("client4_phone")&&-1===t.indexOf("client5_phone")&&-1===t.indexOf("client6_phone")&&-1===t.indexOf("client7_phone")&&-1===t.indexOf("client8_phone")||(e.isTabPhones=!0),!1!==e.isTabJobs||-1===t.indexOf("client_job")&&-1===t.indexOf("client2_job")&&-1===t.indexOf("client3_job")&&-1===t.indexOf("client4_job")&&-1===t.indexOf("client5_job")&&-1===t.indexOf("client6_job")&&-1===t.indexOf("client7_job")&&-1===t.indexOf("client8_job")||(e.isTabJobs=!0),!1!==e.isTabEducational||-1===t.indexOf("client_educational")&&-1===t.indexOf("client2_educational")&&-1===t.indexOf("client3_educational")&&-1===t.indexOf("client4_educational")&&-1===t.indexOf("client5_educational")&&-1===t.indexOf("client6_educational")&&-1===t.indexOf("client7_educational")&&-1===t.indexOf("client8_educational")||(e.isTabEducational=!0),!1!==e.isTabCriminal||-1===t.indexOf("client_crime")&&-1===t.indexOf("client2_crime")&&-1===t.indexOf("client3_crime")&&-1===t.indexOf("client4_crime")&&-1===t.indexOf("client5_crime")&&-1===t.indexOf("client6_crime")&&-1===t.indexOf("client7_crime")&&-1===t.indexOf("client8_crime")||(e.isTabCriminal=!0),!1!==e.isTabEads||-1===t.indexOf("client_ead")&&-1===t.indexOf("client2_ead")&&-1===t.indexOf("client3_ead")&&-1===t.indexOf("client4_ead")&&-1===t.indexOf("client5_ead")&&-1===t.indexOf("client6_ead")&&-1===t.indexOf("client7_ead")&&-1===t.indexOf("client8_ead")||(e.isTabEads=!0),!1!==e.isTabPassports||-1===t.indexOf("client_passport")&&-1===t.indexOf("client2_passport")&&-1===t.indexOf("client3_passport")&&-1===t.indexOf("client4_passport")&&-1===t.indexOf("client5_passport")&&-1===t.indexOf("client6_passport")&&-1===t.indexOf("client7_passport")&&-1===t.indexOf("client8_passport")||(e.isTabPassports=!0),!1!==e.isTabTravel||-1===t.indexOf("client_travel")&&-1===t.indexOf("client2_travel")&&-1===t.indexOf("client3_travel")&&-1===t.indexOf("client4_travel")&&-1===t.indexOf("client5_travel")&&-1===t.indexOf("client6_travel")&&-1===t.indexOf("client7_travel")&&-1===t.indexOf("client8_travel")||(e.isTabTravel=!0),(!1!==e.isTabVisas&&!1!==e.isTabPriority||-1===t.indexOf("client_visa"))&&-1===t.indexOf("client2_visa")&&-1===t.indexOf("client3_visa")&&-1===t.indexOf("client4_visa")&&-1===t.indexOf("client5_visa")&&-1===t.indexOf("client6_visa")&&-1===t.indexOf("client7_visa")&&-1===t.indexOf("client8_visa")||(e.isTabPriority=!0,e.isTabVisas=!0),!1!==e.isTabMarriage||-1===t.indexOf("client_marriage")&&-1===t.indexOf("client2_marriage")&&-1===t.indexOf("client3_marriage")&&-1===t.indexOf("client4_marriage")&&-1===t.indexOf("client5_marriage")&&-1===t.indexOf("client6_marriage")&&-1===t.indexOf("client7_marriage")&&-1===t.indexOf("client8_marriage")&&-1===t.indexOf("client_marital")&&-1===t.indexOf("client2_marital")&&-1===t.indexOf("client3_marital")&&-1===t.indexOf("client4_marital")&&-1===t.indexOf("client5_marital")&&-1===t.indexOf("client6_marital")&&-1===t.indexOf("client7_marital")&&-1===t.indexOf("client8_marital")&&-1===t.indexOf("client_ex-spouse")&&-1===t.indexOf("client2_ex-spouse")&&-1===t.indexOf("client3_ex-spouse")&&-1===t.indexOf("client4_ex-spouse")&&-1===t.indexOf("client5_ex-spouse")&&-1===t.indexOf("client6_ex-spouse")&&-1===t.indexOf("client7_ex-spouse")&&-1===t.indexOf("client8_ex-spouse")||(e.isTabMarriage=!0),!1!==e.isTabUsEntries||-1===t.indexOf("client_us-entry")&&-1===t.indexOf("client2_us-entry")&&-1===t.indexOf("client3_us-entry")&&-1===t.indexOf("client4_us-entry")&&-1===t.indexOf("client5_us-entry")&&-1===t.indexOf("client6_us-entry")&&-1===t.indexOf("client7_us-entry")&&-1===t.indexOf("client8_us-entry")||(e.isTabUsEntries=!0),!1!==e.isTabFamily||-1===t.indexOf("client_family-member")&&-1===t.indexOf("client2_family-member")&&-1===t.indexOf("client3_family-member")&&-1===t.indexOf("client4_family-member")&&-1===t.indexOf("client5_family-member")&&-1===t.indexOf("client6_family-member")&&-1===t.indexOf("client7_family-member")&&-1===t.indexOf("client8_family-member")||(e.isTabFamily=!0),!1!==e.isTabAdvance||-1===t.indexOf("client_parole")&&-1===t.indexOf("client2_parole")&&-1===t.indexOf("client3_parole")&&-1===t.indexOf("client4_parole")&&-1===t.indexOf("client5_parole")&&-1===t.indexOf("client6_parole")&&-1===t.indexOf("client7_parole")&&-1===t.indexOf("client8_parole")||(e.isTabAdvance=!0))}))})},getContact:function(){var t=this;Tt.getGraphContact({token:this.token,field:"id",value:this.contactid}).then(function(e){t.dbInformation=e.getContact[0],t.dbInformation.id=t.contactId,t.dbInformation.pdEmploymentDate=ct()(t.dbInformation.pdEmploymentDate).utcOffset(-60).format("MM/DD/YYYY"),t.dbInformation.pdFamilyPetitionDate=ct()(e.pdFamilyPetitionDate).utcOffset(-60).format("MM/DD/YYYY"),t.dbInformation.rcpd="off",!0===t.comparing&&(t.dbInformationComparing.personal=[],t.dbInformationComparing.personal=e.getContact[0],t.dbInformationComparing.addresses=[],t.dbInformationComparing.addresses=e.getContact[0].address,t.dbInformationComparing.phones=[],t.dbInformationComparing.phones=e.getContact[0].phones),!0===t.comparing&&t.getForms(),t.isSpinnerInit=!1,t.isSpinner=!1})},getForms:function(){var t=this;Tt.graphForms({token:this.token}).then(function(e){e.form1&&e.form2&&(!0===t.comparing?(t.dbInformationComparing.forms=[],t.dbInformationComparing.forms.push(e.form1[0]),t.dbInformationComparing.forms.push(e.form2[0])):(t.dbInformation.forms=[],t.dbInformation.forms.push(e.form1[0]),t.dbInformation.forms.push(e.form2[0])),priorityDates),!0===t.comparing&&(t.generateDuplex(),t.setClassComparing(),t.setValueBadges(),t.changeTab(t.itemActive))})},generateDuplex:function(){var t=this;if(Y()(this.dbInformationComparing).forEach(function(e){var n="";if("forms"!==e&&"personal"!==e&&(n=e+"Comparing",t.duplex[n]=[]),"personal"===e){var i={},a={},o={threeValues:{}};Y()(t.dbInformationComparing[e]).forEach(function(n){a[n]=t.dbInformationComparing[e][n].origin,o[n]=null===t.dbInformationComparing[e][n].manual||void 0===t.dbInformationComparing[e][n].manual?t.dbInformationComparing[e][n].edit:t.dbInformationComparing[e][n].manual,o.threeValues[n]=t.dbInformationComparing[e][n]}),i.edit=a,i.manual=o,t.duplex.namesComparing=[],t.duplex.communicationComparing=[],t.duplex.biographicInformationComparing=[],t.duplex.backgroundCheckInformationComparing=[],t.duplex.immigrationInformationComparing=[],t.duplex.priorityDatesComparing=[],t.duplex.namesComparing.push(i),t.duplex.communicationComparing.push(i),t.duplex.biographicInformationComparing.push(i),t.duplex.backgroundCheckInformationComparing.push(i),t.duplex.immigrationInformationComparing.push(i),t.duplex.priorityDatesComparing.push(i)}else if("forms"===e)t.dbInformationComparing[e].forEach(function(e){n=e._id+"-"+e.caseFormId,t.duplex[n]=[],t.duplexInformationQuestionnaire[n]=[];var i={},a={},o={},r={};(i={}).id=e._id,i.name=e.name,i.caseFormId=e.caseFormId,i.prefixes=e.prefixes,t.formBadges[e._id+"-"+e.caseFormId]=0,Y()(e).forEach(function(t){o[t]=e[t],r[t]=e[t]}),a.edit=o,a.manual=r,t.duplexInformationQuestionnaire[n].push(a),t.duplex[n].push(i)});else{t.duplex[n]=[],t.dbInformationComparing[e].forEach(function(e){var i={},a={},o={};a.threeValues={},Y()(e).forEach(function(t){o[t]=e[t].origin,a[t]=null===e[t].manual||void 0===e[t].manual?e[t].edit:e[t].manual,a.threeValues[t]=e[t]}),i.edit=o,i.manual=a,t.duplex[n].push(i)})}}),this.comparingInformation=void 0!==this.duplex.namesComparing?this.duplex.namesComparing:[],!this.isModels){var e=!1;Y()(this.duplex).forEach(function(t,n){if(-1===t.indexOf("Comparing")&&!1===e){e=!0;var i=t;setTimeout(function(){document.getElementById(i).click()},500)}})}this.setClassComparing(),this.setValueBadges(),this.setCurrentShortCuts()},setClassComparing:function(){var t=this;!1!==this.comparing&&this.comparingInformation.forEach(function(e,n){void 0!==e.edit.id&&e.edit.id===e.manual.id&&(void 0!==e.manual.threeValues.deletedAt&&null!==e.manual.threeValues.deletedAt.edit||null!==e.manual.deletedAt&&void 0!==e.manual.deletedAt||(Y()(e.edit).forEach(function(t){if(e.edit[t]!==e.manual[t]){var n=""===e.manual[t]?"deleted-information":""===e.edit[t]||null===e.edit[t]?"new-information":"updated-information";void 0===e.edit.class&&(e.edit.class={}),e.edit.class[t]=n,void 0===e.manual.class&&(e.manual.class={}),e.manual.class[t]=n}else void 0===e.edit.class&&(e.edit.class={}),e.edit.class[t]="",void 0===e.manual.class&&(e.manual.class={}),e.manual.class[t]=""}),void 0!==t.infoQuestionnaire.edit&&void 0!==t.infoQuestionnaire.edit.fields&&t.infoQuestionnaire.edit.fields.forEach(function(e,n){if(void 0!==e.field){var i=null!==e.value.origin?e.value.origin:"",a=null!==e.value.manual?e.value.manual:e.value.edit;if(i!==a){var o="";o=2===e.fieldType||3===e.fieldType?""===a?"deleted-information":""===i?"new-information":"updated-information":"myInputUpdated",e.classColor=o,t.infoQuestionnaire.edit.fields[n]=e}}}),t.comparingInformation[n]=e))})},setClassComparingRadios:function(t){if(!1!==this.comparing){var e=document.getElementById(t.id),n=document.getElementById(t.id.replace("manual","edit")),i=t.name.replace("manual","edit"),a=document.getElementsByName(i),o=document.getElementsByName(t.name),r=e.checked;n.checked!==r?(a.forEach(function(t){t.classList.remove("myInputRadUpdated"),!0===t.checked&&t.classList.add("myInputRadUpdated")}),e.classList.add("myInputRadUpdated")):(a.forEach(function(t){t.classList.remove("myInputRadUpdated")}),o.forEach(function(t){t.classList.remove("myInputRadUpdated")}))}},setClassComparingCheckboxes:function(t){if(!1!==this.comparing){var e=document.getElementById(t.id),n=document.getElementById(t.id.replace("manual","edit")),i=e.checked,a=n.checked;a!==i?(!0===a&&n.classList.add("myInputUpdated"),!0===i&&e.classList.add("myInputUpdated")):(!0===a&&n.classList.remove("myInputUpdated"),!0===i&&e.classList.remove("myInputUpdated"))}},changeClassComparing:function(t){if(!1!==this.comparing){var e="",n="",i=document.getElementById(t.id.replace("manual","edit")),a=document.getElementById(t.id);"checkbox"===i.type?this.setClassComparingCheckboxes(a):"radio"===i.type?this.setClassComparingRadios(a):(e=i.value,n=a.value),i.classList.remove("deleted-information","new-information","updated-information"),a.classList.remove("deleted-information","new-information","updated-information");var o="";if(e!==n)o=""===n?"deleted-information":""===e?"new-information":"updated-information",i.classList.add(o),a.classList.add(o),e="",n="";else if(void 0!==t.classColor){i.classList.remove("deleted-information","new-information","updated-information"),a.classList.remove("deleted-information","new-information","updated-information");var r=this.itemActive+"Badge";this[r]>0&&this[r]--}}},changeCalendar:function(t){if(!1!==this.comparing){var e=document.getElementById(t.id);this.changeClassComparing({classColor:e.classList[2],id:t.id})}},changeTab:function(t){var e=this;if(this.isSpinner=!0,this.caseFormId="",null!==document.getElementById(this.itemActive)&&document.getElementById(this.itemActive).classList.remove("active"),"form"===t.type&&void 0!==t.id)this.renderFields=!1,!0===this.comparing?(this.formName=this.formNames[t.index].name,t=t.id,this.paramsEstructureQuestionnaire={},this.infoQuestionnaire={},this.paramsEstructureQuestionnaire=this.duplex[t][0],this.infoQuestionnaire=this.duplexInformationQuestionnaire[t][0],this.isSpinner=!1,this.setClassComparing()):this.formNames.length>0&&!0===this.viewer?(this.formName=this.formNames[t.index].name,this.caseFormId=t.id.split("-")[1],t=t.id,this.isSpinner=!1):(t=t.id,this.isSpinner=!1);else if(!0===this.comparing)setTimeout(function(){e.isSpinner=!1},600),this.comparingInformation=this.duplex[t],this.infoQuestionnaire={},this.setClassComparing(),this.setCurrentShortCuts();else{document.querySelectorAll(".list-group.sideBar>a.tabsSecundary").forEach(function(t){t.classList.remove("active")}),setTimeout(function(){e.isSpinner=!1},500)}this.menuTabs(),this.itemActive=t,this.setClassComparing(),null!==document.getElementById(t)&&document.getElementById(t).classList.add("active"),setTimeout(function(){null!==document.getElementById("messageNoInfo")&&document.getElementById("messageNoInfo").classList.add("fadeIn")},100);var n=document.querySelectorAll(".list-group.sideBar>a.tabsSecundary");n.forEach(function(t,i){t.classList.forEach(function(t){if("active"===t)if(-1!==e.itemActive.indexOf("Comparing"))if("namesComparing"!==e.itemActive&&(e.noShowPrev=!1),!1===e.isForms){var a=n.length;!0===e.comparing?e.noShowNext=i+1===a-1:e.noShowNext=i+1===a}else e.noShowNext=!1;else!1===e.isModels&&0===e.formNames.map(function(t){return t.id}).indexOf(e.itemActive)?e.noShowPrev=!0:e.noShowPrev=!1})})},setValueBadges:function(){var t=this;"namesComparing"!==this.itemActive&&"communicationComparing"!==this.itemActive&&"biographicInformationComparing"!==this.itemActive&&"immigrationInformationComparing"!==this.itemActive&&"backgroundCheckInformationComparing"!==this.itemActive&&"priorityDatesComparing"!==this.itemActive||(this.namesComparingBadge=0,this.communicationComparingBadge=0,this.biographicInformationComparingBadge=0,this.immigrationInformationComparingBadge=0,this.backgroundCheckInformationComparingBadge=0,this.priorityDatesComparingBadge=0),this.addressesComparingBadge=0,this.previousAddressesComparingBadge=0,this.phonesComparingBadge=0,this.jobsComparingBadge=0,this.educationalHistoryComparingBadge=0,this.criminalHistoryComparingBadge=0,this.eadComparingBadge=0,this.passportsComparingBadge=0,this.travelHistoryComparingBadge=0,this.usEntriesComparingBadge=0,this.visaHistoryComparingBadge=0,this.marriageHistoryComparingBadge=0,this.familyMembersComparingBadge=0,this.advanceParoleComparingBadge=0,Y()(this.formBadges).forEach(function(e){t.formBadges[e]=0}),this.setCurrentShortCuts(),void 0!==this.duplex.namesComparing&&Y()(this.duplex.namesComparing[0].edit).forEach(function(e){var n=t.duplex.namesComparing[0].edit[e],i=t.duplex.namesComparing[0].manual[e];n!==i&&("maritalStatusMarried"===e&&"on"===i||"maritalStatusSingle"===e&&"on"===i||"maritalStatusDivorced"===e&&"on"===i||"maritalStatusWidow"===e&&"on"===i||"maritalStatusSeparated"===e&&"on"===i||"maritalStatusAnnulled"===e&&"on"===i)&&t.marriageHistoryComparingBadge++}),this.comparingInformation.forEach(function(e,n){void 0!==e.edit&&void 0!==e.edit.id&&e.edit.id===e.manual.id&&Y()(e.edit).forEach(function(n){e.edit[n]!==e.manual[n]&&("namesComparing"!==t.itemActive&&"communicationComparing"!==t.itemActive&&"biographicInformationComparing"!==t.itemActive&&"immigrationInformationComparing"!==t.itemActive&&"backgroundCheckInformationComparing"!==t.itemActive&&"priorityDatesComparing"!==t.itemActive||(-1!==t.listContactNames.indexOf(n)&&"off"!==e.manual[n]?t.namesComparingBadge++:-1!==t.listCommunication.indexOf(n)&&"off"!==e.manual[n]?t.communicationComparingBadge++:-1!==t.listBiographic.indexOf(n)&&"off"!==e.manual[n]?t.biographicInformationComparingBadge++:-1!==t.listBackgroundCheck.indexOf(n)&&"off"!==e.manual[n]?t.backgroundCheckInformationComparingBadge++:-1!==t.listImmigration.indexOf(n)&&"off"!==e.manual[n]?t.immigrationInformationComparingBadge++:-1!==t.listPriority.indexOf(n)&&"off"!==e.manual[n]&&t.priorityDatesComparingBadge++))})}),Y()(this.duplex).forEach(function(e){t.duplex[e].forEach(function(n,i){void 0!==n.edit&&void 0!==n.edit.id&&n.edit.id===n.manual.id&&(void 0!==n.manual.threeValues.deletedAt&&null!==n.manual.threeValues.deletedAt.edit||null!==n.manual.deletedAt&&void 0!==n.manual.deletedAt?t[e+"Badge"]++:Y()(n.edit).forEach(function(i){"deletedAt"!==i&&null===n.edit[i]&&(n.edit[i]=""),"deletedAt"!==i&&null===n.manual[i]&&(n.manual[i]=""),n.edit[i]!==n.manual[i]&&"class"!==i&&("addressesComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]||"addressesComparing"===e&&"isPrimary"===i&&""!==n.edit[i]&&null!==n.edit[i]&&void 0!==n.edit[i]||"addressesComparing"===e&&"isForeign"===i&&""!==n.edit[i]&&null!==n.edit[i]&&void 0!==n.edit[i]||"addressesComparing"===e&&"isMailing"===i&&""!==n.edit[i]&&null!==n.edit[i]&&void 0!==n.edit[i]?t[e+"Badge"]++:"previousAddressesComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]||"previousAddressesComparing"===e&&"isPrimary"===i&&""!==n.edit[i]&&null!==n.edit[i]&&void 0!==n.edit[i]||"previousAddressesComparing"===e&&"isForeign"===i&&""!==n.edit[i]&&null!==n.edit[i]&&void 0!==n.edit[i]||"previousAddressesComparing"===e&&"isMailing"===i&&""!==n.edit[i]&&null!==n.edit[i]&&void 0!==n.edit[i]?t[e+"Badge"]++:-1!==t.listPhones.indexOf(i)&&"phonesComparing"===e?t[e+"Badge"]++:"jobsComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]?t[e+"Badge"]++:"educationalHistoryComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]?t[e+"Badge"]++:"criminalHistoryComparing"===e&&-1===t.listNoItems.indexOf(i)?t[e+"Badge"]++:"eadComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]?t[e+"Badge"]++:"passportsComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]?t[e+"Badge"]++:"travelHistoryComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]?t[e+"Badge"]++:"usEntriesComparing"===e&&-1===t.listNoItems.indexOf(i)?t[e+"Badge"]++:"visaHistoryComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]?t[e+"Badge"]++:"marriageHistoryComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]?t[e+"Badge"]++:"familyMembersComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]?t[e+"Badge"]++:"advanceParoleComparing"===e&&-1===t.listNoItems.indexOf(i)&&"off"!==n.manual[i]&&t[e+"Badge"]++)}))})}),Y()(this.duplexInformationQuestionnaire).forEach(function(e){t.duplexInformationQuestionnaire[e][0].edit.fields.forEach(function(n){var i=null===n.value.manual?n.value.edit:n.value.manual,a=null!==n.value.origin?n.value.origin:"";if(a!==i){if(""===a&&"off"===i||"off"===a&&""===i)return;t.formBadges[e]++}})})},returnInfoQuestionnaireForm:function(t){if(void 0!==t.caseQuestionnaireManual&&Y()(t.caseQuestionnaireManual).length>0){var e=t.caseQuestionnaireManual.forms,n=this.duplexInformationQuestionnaire,i=this.infoQuestionnaire;n[this.currentFormId][0].edit.fields=e[e.map(function(t){return t._id}).indexOf(this.currentFormId.split("-")[0])].fields,i.manual.fields=e[e.map(function(t){return t._id}).indexOf(this.currentFormId.split("-")[0])].fields,this.duplexInformationQuestionnaire={},this.infoQuestionnaire={},this.duplexInformationQuestionnaire=n,this.infoQuestionnaire=i,this.setClassComparing()}},setChangeViewerModel:function(t){"addresses"===t.model&&(this.informationAddresses=t.list),"previousAddresses"===t.model&&(this.informationPreviousAddresses=t.list),"phones"===t.model&&(this.informationPhones=t.list),"jobs"===t.model&&(this.informationJobs=t.list),"educationalHistory"===t.model&&(this.informationEducational=t.list),"criminalHistory"===t.model&&(this.informationCriminal=t.list),"ead"===t.model&&(this.informationEads=t.list),"passports"===t.model&&(this.informationPassports=t.list),"travelHistory"===t.model&&(this.informationTravel=t.list),"usEntries"===t.model&&(this.informationUsEntries=t.list),"visaHistory"===t.model&&(this.informationVisa=t.list),"marriageHistory"===t.model&&(this.informationMarriage=t.list),"familyMembers"===t.model&&(this.informationFamily=t.list),"advanceParole"===t.model&&(this.informationAdvance=t.list)},setChangeViewer:function(t){var e=t.field.replace(/]_/g,"]."),n=!1;this.dbInformation.forms.forEach(function(i){i.caseFormId===Number(t.caseFormId)&&(i.fields.forEach(function(i){i.field===e&&(n=!0,i.value.edit=t.value)}),!1===n&&i.fields.push({field:e,fieldType:t.fieldType,value:{edit:t.value}}))})},setCurrentFormId:function(t){this.currentFormId=t},moveToChange:function(t){""===this.idChangeFocus?this.idChangeFocus=this.currentFieldsToShortCuts.map(function(t){return t.fieldId})[0]:this.idChangeFocus=this.currentFieldsToShortCuts.map(function(t){return t.fieldId})[t];var e=document.getElementById(this.idChangeFocus);null!==e&&(e.scrollIntoView({behavior:"smooth",block:"center",inline:"nearest"}),setTimeout(function(){e.focus()},500))},loadSvg:function(){this.renderFields=!0},errorSvg:function(){this.renderFields=!0},menuTabs:function(){var t=this;this.isRightSideBar=!this.isRightSideBar,document.querySelectorAll(".list-group").forEach(function(e){!0===t.isRightSideBar?((window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth)<=991&&(!0===t.comparing&&document.getElementById("allContent").classList.add("d-none"),!0===t.viewer&&document.getElementById("allContentViewer").classList.add("d-none")),e.classList.remove("myHidden"),setTimeout(function(){e.classList.add("fadeInMenu")},5)):(!0===t.comparing&&document.getElementById("allContent").classList.remove("d-none"),!0===t.viewer&&document.getElementById("allContentViewer").classList.remove("d-none"),e.classList.remove("fadeInMenu"),setTimeout(function(){e.classList.add("myHidden")},500))})},pagingStatic:function(t){var e=this;document.querySelectorAll(".sideBar").forEach(function(t){t.style.position="absolute"}),this.isRightSideBar=!0;var n=document.querySelectorAll(".list-group.sideBar>a.tabsSecundary"),i=!1;n.forEach(function(a,o){!1===i&&a.classList.forEach(function(r){if("active"===r)if(i=!0,a.classList.remove(r),"next"===t?(n[o+1].classList.add(r),e.itemActive=n[o+1].attributes.id.value):"previous"===t&&(n[o-1].classList.add(r),e.itemActive=n[o-1].attributes.id.value),-1!==e.itemActive.indexOf("Comparing"))if(e.changeTab(e.itemActive),!1===e.isForms&&"next"===t){e.noShowPrev=!1;var s=n.length;!0===e.comparing?e.noShowNext=o+1===s-2:e.noShowNext=o+1===s-1}else e.noShowNext=!1;else e.changeTab({type:"form",id:e.itemActive,index:e.formNames.map(function(t){return t.id}).indexOf(e.itemActive)}),!1===e.isModels&&0===e.formNames.map(function(t){return t.id}).indexOf(e.itemActive)?e.noShowPrev=!0:e.noShowPrev=!1}),setTimeout(function(){null!==document.getElementById("messageNoInfo")&&document.getElementById("messageNoInfo").classList.add("fadeIn")},100)})},setFormNames:function(t){this.formNames=t},setWidgetLabels:function(t){this.widgetLabels=t},approveQuestionnaire:function(){this.isPopUp=!0,this.messagePopUp="Are you sure you want to take this information from the questionnaire and use it to populate the Primafacie database, and the forms for this case?",this.titlePopUp="Accept Data",this.typePopUp="confirm",this.actionPopUp="reverseAf"},setActionPopUpSideBar:function(){"reverseAf"===this.actionPopUp?this.setReverseAf():"closeWindow"===this.actionPopUp&&(this.isPopUp=!1,window.open("","_self",""),window.close())},setReverseAf:function(){var t=this;this.typePopUp="loading",this.titlePopUp="Reversing Data",this.messagePopUp="";var e={token:this.token,questionnaireIds:[this.questionnaireid],status:"Accepted and imported into case"};Tt.updateCaseQuestionnairesStatus(e).then(function(e){t.generateAddendumSections()})},setCurrentShortCuts:function(){var t=this;setTimeout(function(){if(null!==document.getElementById("allContent")){t.currentFieldsToShortCuts=[];var e=document.getElementById("allContent");e.querySelectorAll(".updated-information").forEach(function(e){-1!==e.id.indexOf("manual")&&t.currentFieldsToShortCuts.push({fieldId:e.id,order:e.tabIndex})}),e.querySelectorAll(".new-information").forEach(function(e){-1!==e.id.indexOf("manual")&&t.currentFieldsToShortCuts.push({fieldId:e.id,order:e.tabIndex})}),e.querySelectorAll(".deleted-information").forEach(function(e){-1!==e.id.indexOf("manual")&&t.currentFieldsToShortCuts.push({fieldId:e.id,order:e.tabIndex})}),t.currentFieldsToShortCuts=t.currentFieldsToShortCuts.sort(function(t,e){return t.order>e.order?1:-1})}},1e3)},setOriginEditManual:function(t){this.originEditManual.valueSelected=null,t.values=void 0!==t.values?t.values:{},this.originEditManual=t;var e=document.getElementById(this.originEditManual.id).getBoundingClientRect();this.positionContext={top:e.top+window.scrollY,left:e.left},this.$refs.menu.open()},changeInfo:function(t){this.selectedValue={},"form"===this.originEditManual.type?(this.selectedValue.value=this.originEditManual.values[t],this.selectedValue.fieldId=this.originEditManual.fieldId,this.selectedValue.fieldType=this.originEditManual.fieldType,this.selectedValue.model=this.originEditManual.model,this.selectedValue.caseFormId=this.originEditManual.caseFormId,this.selectedValue.id=this.originEditManual.id):(this.selectedValue.value=this.originEditManual.values[t],this.selectedValue.fieldId=this.originEditManual.fieldId,this.selectedValue.model=this.originEditManual.type,this.selectedValue.id=this.originEditManual.id,this.selectedValue.index=this.originEditManual.index)},setTypeAddress:function(t){var e=this.duplex;e.addressesComparing.forEach(function(n,i){"isPrimary"===t.key?n.manual.isPrimary="off":"isMailing"===t.key?n.manual.isMailing="off":"isForeing"===t.key&&(n.manual.isForeing="off"),e.addressesComparing[i]=n}),this.duplex={},this.duplex=e},getWidgetLabels:function(){var t=this,e=[];!0===this.viewer&&(e=this.dbInformation.forms),!0===this.comparing&&(e=this.dbInformationComparing.forms),e.forEach(function(e){var n="";n=!0===t.viewer?"graphTemplatesCT":"graphTemplates",Tt[n]({token:t.token,formId:e._id}).then(function(e){e.templates.length>0&&e.templates.forEach(function(e){"default"===e.name&&void 0!==e.widgetLabels&&null!==e.widgetLabels&&t.setWidgetLabels(e.widgetLabels)})})})}},p()(_l,"setWidgetLabels",function(t){var e=this;Y()(t).forEach(function(n){-1===Y()(e.widgetLabels).indexOf(n)&&(e.widgetLabels[n]=[]),-1===e.widgetLabels[n].indexOf(t[n].label)&&e.widgetLabels[n].push(t[n].label)})}),p()(_l,"generateAddendumSections",function(){var t=this;this.typePopUp="loading",this.titlePopUp="Generate Addendum Sections",this.messagePopUp="";var e=1,n=this.dbInformationComparing.forms;this.counterPopUp=e+"/"+n.length,n.forEach(function(i){Tt.generateAddendum({token:t.token,caseFormId:i.caseFormId}).then(function(i){e===n.length?t.autofillForms():(e++,t.counterPopUp=e+"/"+n.length)})})}),p()(_l,"autofillForms",function(){this.titlePopUp="The information of your contact was updated.  Please autofill any other forms to update them with the latest information.",this.counterPopUp="",this.typePopUp="info",this.actionPopUp="closeWindow"}),_l)},gl={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[!0===t.isSpinnerInit?n("div",{staticClass:"mt-5"},[n("pf-spinner",{attrs:{color:"black"}})],1):t._e(),t._v(" "),!1===t.isSpinnerInit?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 spacebar1"},[n("div",{staticClass:"toolbox-tab-container",attrs:{id:"toolbox-tab-container2"}},[n("div",{staticClass:"toolbox-tab-menu"},[n("div",{staticClass:"list-group myHidden sideBar"},[t.isModels?n("h6",{staticClass:"list-group-item text-right tabPrimary ",attrs:{href:"#"}},[n("b",[t._v("General Info")])]):t._e(),t._v(" "),!0===t.isTabNames?n("a",{staticClass:"list-group-item text-right tabsSecundary active",attrs:{href:"#",id:"namesComparing"},on:{click:function(e){return t.changeTab("namesComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.namesComparingBadge>0?"badgeRed":""},[t._v(t._s(t.namesComparingBadge))]):t._e(),t._v("\n              Names\n            ")]):t._e(),t._v(" "),!0===t.isTabCommunication?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"communicationComparing"},on:{click:function(e){return t.changeTab("communicationComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.communicationComparingBadge>0?"badgeRed":""},[t._v(t._s(t.communicationComparingBadge))]):t._e(),t._v("\n              Email\n            ")]):t._e(),t._v(" "),!0===t.isTabBiographic?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"biographicInformationComparing"},on:{click:function(e){return t.changeTab("biographicInformationComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.biographicInformationComparingBadge>0?"badgeRed":""},[t._v(t._s(t.biographicInformationComparingBadge))]):t._e(),t._v("\n              Biographic\n            ")]):t._e(),t._v(" "),!0===t.isTabAdditional?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"backgroundCheckInformationComparing"},on:{click:function(e){return t.changeTab("backgroundCheckInformationComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.backgroundCheckInformationComparingBadge>0?"badgeRed":""},[t._v(t._s(t.backgroundCheckInformationComparingBadge))]):t._e(),t._v("\n              Additional\n            ")]):t._e(),t._v(" "),!0===t.isTabImmigration?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"immigrationInformationComparing"},on:{click:function(e){return t.changeTab("immigrationInformationComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.immigrationInformationComparingBadge>0?"badgeRed":""},[t._v(t._s(t.immigrationInformationComparingBadge))]):t._e(),t._v("\n              Immigration\n            ")]):t._e(),t._v(" "),!0===t.isTabPriority?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"priorityDatesComparing"},on:{click:function(e){return t.changeTab("priorityDatesComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.priorityDatesComparingBadge>0?"badgeRed":""},[t._v(t._s(t.priorityDatesComparingBadge))]):t._e(),t._v("\n              Visa Petitions\n            ")]):t._e(),t._v(" "),!0===t.isTabAddresses?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"addressesComparing"},on:{click:function(e){return t.changeTab("addressesComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.addressesComparingBadge>0?"badgeRed":""},[t._v(t._s(t.addressesComparingBadge))]):t._e(),t._v("\n              Current Addresses\n            ")]):t._e(),t._v(" "),t.isTabPreviousAddresses?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"previousAddressesComparing"},on:{click:function(e){return t.changeTab("previousAddressesComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.previousAddressesComparingBadge>0?"badgeRed":""},[t._v(t._s(t.previousAddressesComparingBadge))]):t._e(),t._v("\n              Previous Addresses\n            ")]):t._e(),t._v(" "),!0===t.isTabPhones?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"phonesComparing"},on:{click:function(e){return t.changeTab("phonesComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.phonesComparingBadge>0?"badgeRed":""},[t._v(t._s(t.phonesComparingBadge))]):t._e(),t._v("\n              Phone Numbers\n            ")]):t._e(),t._v(" "),!0===t.isTabJobs?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"jobsComparing"},on:{click:function(e){return t.changeTab("jobsComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.jobsComparingBadge>0?"badgeRed":""},[t._v(t._s(t.jobsComparingBadge))]):t._e(),t._v("\n              Employment\n            ")]):t._e(),t._v(" "),!0===t.isTabEducational?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"educationalHistoryComparing"},on:{click:function(e){return t.changeTab("educationalHistoryComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.educationalHistoryComparingBadge>0?"badgeRed":""},[t._v(t._s(t.educationalHistoryComparingBadge))]):t._e(),t._v("\n              Education\n            ")]):t._e(),t._v(" "),!0===t.isTabCriminal?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"criminalHistoryComparing"},on:{click:function(e){return t.changeTab("criminalHistoryComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.criminalHistoryComparingBadge>0?"badgeRed":""},[t._v(t._s(t.criminalHistoryComparingBadge))]):t._e(),t._v("\n              Criminal\n            ")]):t._e(),t._v(" "),!0===t.isTabEads?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"eadComparing"},on:{click:function(e){return t.changeTab("eadComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.eadComparingBadge>0?"badgeRed":""},[t._v(t._s(t.eadComparingBadge))]):t._e(),t._v("\n              Work Permits\n            ")]):t._e(),t._v(" "),!0===t.isTabPassports?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"passportsComparing"},on:{click:function(e){return t.changeTab("passportsComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.passportsComparingBadge>0?"badgeRed":""},[t._v(t._s(t.passportsComparingBadge))]):t._e(),t._v("\n              Passports\n            ")]):t._e(),t._v(" "),!0===t.isTabTravel?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"travelHistoryComparing"},on:{click:function(e){return t.changeTab("travelHistoryComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.travelHistoryComparingBadge>0?"badgeRed":""},[t._v(t._s(t.travelHistoryComparingBadge))]):t._e(),t._v("\n              Travel\n            ")]):t._e(),t._v(" "),t.isTabUsEntries?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"usEntriesComparing"},on:{click:function(e){return t.changeTab("usEntriesComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.usEntriesComparingBadge>0?"badgeRed":""},[t._v(t._s(t.usEntriesComparingBadge))]):t._e(),t._v("\n              Entries: USA\n            ")]):t._e(),t._v(" "),!0===t.isTabVisas?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"visaHistoryComparing"},on:{click:function(e){return t.changeTab("visaHistoryComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.visaHistoryComparingBadge>0?"badgeRed":""},[t._v(t._s(t.visaHistoryComparingBadge))]):t._e(),t._v("\n              Visas\n            ")]):t._e(),t._v(" "),!0===t.isTabMarriage?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"marriageHistoryComparing"},on:{click:function(e){return t.changeTab("marriageHistoryComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.marriageHistoryComparingBadge>0?"badgeRed":""},[t._v(t._s(t.marriageHistoryComparingBadge))]):t._e(),t._v("\n              Marriage\n            ")]):t._e(),t._v(" "),!0===t.isTabFamily?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"familyMembersComparing"},on:{click:function(e){return t.changeTab("familyMembersComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.familyMembersComparingBadge>0?"badgeRed":""},[t._v(t._s(t.familyMembersComparingBadge))]):t._e(),t._v("\n              Family\n            ")]):t._e(),t._v(" "),!0===t.isTabAdvance?n("a",{staticClass:"list-group-item text-right tabsSecundary",attrs:{href:"#",id:"advanceParoleComparing"},on:{click:function(e){return t.changeTab("advanceParoleComparing")}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.advanceParoleComparingBadge>0?"badgeRed":""},[t._v(t._s(t.advanceParoleComparingBadge))]):t._e(),t._v("\n              Advance Parole\n            ")]):t._e(),t._v(" "),t.isForms?n("h6",{staticClass:"list-group-item text-right tabPrimary topPrimary",class:t.isModels?"tabForms":""},[n("b",[t._v("Forms")])]):t._e(),t._v(" "),t._l(t.formNames,function(e,i){return t.isForms?n("a",{key:i,staticClass:"list-group-item text-right tabsSecundary",class:t.questionnaireData&&0===Object.keys(t.questionnaireData.models).length&&0===i?"active":"",staticStyle:{"text-decoration":"none"},attrs:{href:"#",id:!0===t.comparing||!0===t.viewer?e.id:"searchForm"},on:{click:function(n){return t.changeTab({type:"form",id:!0===t.comparing||!0===t.viewer?e.id:"searchForm",index:!0===t.comparing||!0===t.viewer?i:"searchForm"})}}},[!0===t.comparing?n("span",{staticClass:"badge badge-success badgeP float-left",class:t.formBadges[e.id]>0?"badgeRed":""},[t._v(t._s(t.formBadges[e.id]))]):t._e(),t._v(" "),!0===t.viewer?n("span",[t._v(t._s(e.name))]):!0===t.comparing?n("span",[t._v(t._s(e.name))]):n("span",[t._v("Search Form")])]):t._e()}),t._v(" "),!0===t.comparing?n("h6",{staticClass:"list-group-item text-right tabPrimary topPrimary tabForms",staticStyle:{"background-color":"#4DCD30 !important",color:"white !important","border-top":"1px solid green","border-left":"1px solid green","border-bottom":"1px solid green"},attrs:{"data-target":"#accordionImportData","data-toggle":"collapse"}},[n("b",[t._v("Import Data")])]):t._e(),t._v(" "),!0===t.comparing?n("a",{staticClass:"collapse list-group-item text-right tabsSecundary",attrs:{id:"accordionImportData"},on:{click:t.approveQuestionnaire}},[n("span",[t._v("Reverse Autofill")])]):t._e()],2)]),t._v(" "),n("div",{staticClass:"toolbox-tab",attrs:{id:"bodyComparing"}},[n("div",{staticClass:"toolbox-tab-content myBorderSideBar active"},[n("div",{class:!1===t.comparing?"header-tab":"header-tab-comparing"},[n("div",{staticClass:"row"},[n("div",{staticClass:"col-8 text-left textHeaderMargin"},["namesComparing"===t.itemActive?n("h6",[t._v(" General Information: Names")]):t._e(),t._v(" "),"communicationComparing"===t.itemActive?n("h6",[t._v(" General Information: Communication")]):t._e(),t._v(" "),"biographicInformationComparing"===t.itemActive?n("h6",[t._v("General Information: Biographical Information")]):t._e(),t._v(" "),"immigrationInformationComparing"===t.itemActive?n("h6",[t._v("General Information: Immigration Information")]):t._e(),t._v(" "),"backgroundCheckInformationComparing"===t.itemActive?n("h6",[t._v("General Information: Additional Information")]):t._e(),t._v(" "),"priorityDatesComparing"===t.itemActive?n("h6",[t._v("General Information: Visa Petition Priority Dates")]):t._e(),t._v(" "),"addressesComparing"===t.itemActive?n("h6",[t._v("General Information: Current Addresses")]):t._e(),t._v(" "),"previousAddressesComparing"===t.itemActive?n("h6",[t._v("General Information: Previous Addresses")]):t._e(),t._v(" "),"phonesComparing"===t.itemActive?n("h6",[t._v("General Information: Phone Numbers")]):t._e(),t._v(" "),"jobsComparing"===t.itemActive?n("h6",[t._v("General Information: Employment History")]):t._e(),t._v(" "),"educationalHistoryComparing"===t.itemActive?n("h6",[t._v("General Information: Education History")]):t._e(),t._v(" "),"criminalHistoryComparing"===t.itemActive?n("h6",[t._v("General Information: Criminal History")]):t._e(),t._v(" "),"eadComparing"===t.itemActive?n("h6",[t._v("General Information: Work Permits")]):t._e(),t._v(" "),"passportsComparing"===t.itemActive?n("h6",[t._v("General Information: Passports")]):t._e(),t._v(" "),"travelHistoryComparing"===t.itemActive?n("h6",[t._v("General Information: Travel History")]):t._e(),t._v(" "),"usEntriesComparing"===t.itemActive?n("h6",[t._v("General Information: Entries to the United States")]):t._e(),t._v(" "),"visaHistoryComparing"===t.itemActive?n("h6",[t._v("General Information: Visa History")]):t._e(),t._v(" "),"marriageHistoryComparing"===t.itemActive?n("h6",[t._v("General Information: Marriage History")]):t._e(),t._v(" "),"familyMembersComparing"===t.itemActive?n("h6",[t._v("General Information: Family Members")]):t._e(),t._v(" "),"advanceParoleComparing"===t.itemActive?n("h6",[t._v("General Information: Advance Parole")]):t._e(),t._v(" "),!1===t.comparing&&-1===t.itemActive.indexOf("Comparing")?n("h6",[t._v("Forms: "+t._s(void 0!==t.formName?t.formName:""))]):!0===t.comparing&&-1===t.itemActive.indexOf("Comparing")?n("h6",[t._v("Forms: "+t._s(void 0!==t.formName?t.formName:""))]):t._e()]),t._v(" "),n("div",{staticClass:"col-4"},[n("button",{staticClass:"nav_button float-right btn-sm",attrs:{id:"menuTab"},on:{click:t.menuTabs}},[n("i",{staticClass:"fas fa-bars"})])])])]),t._v(" "),n("div",{staticClass:"mt-3"},[!0===t.isSpinner?n("pf-spinner",{attrs:{color:"black"}}):t._e()],1),t._v(" "),n("p"),!1===t.isSpinner&&!0===t.comparing?n("div",{staticClass:"row",attrs:{id:"allContent"}},[n("div",{staticClass:"col-12"},[-1!==t.itemActive.indexOf("Comparing")?n("div",{staticClass:"row rowhelpItem"},[n("div",{staticClass:"col-12 mb-3 helpItem"},[n("b",[t._v(t._s(t.helpTexts[t.itemActive]))])])]):t._e(),t._v(" "),"namesComparing"===t.itemActive?n("div",t._l(t.widgetLabels.names,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"communicationComparing"===t.itemActive?n("div",t._l(t.widgetLabels.communication,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"biographicInformationComparing"===t.itemActive?n("div",t._l(t.widgetLabels.biographicInfo,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"immigrationInformationComparing"===t.itemActive?n("div",t._l(t.widgetLabels.immigrationInfo,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"backgroundCheckInformationComparing"===t.itemActive?n("div",t._l(t.widgetLabels.additionalInfo,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"priorityDatesComparing"===t.itemActive?n("div",t._l(t.widgetLabels.priorityDates,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"addressesComparing"===t.itemActive?n("div",t._l(t.widgetLabels.addresses,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"previousAddressesComparing"===t.itemActive?n("div",t._l(t.widgetLabels.previousAddresses,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"phonesComparing"===t.itemActive?n("div",t._l(t.widgetLabels.phones,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"jobsComparing"===t.itemActive?n("div",t._l(t.widgetLabels.jobs,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"educationalHistoryComparing"===t.itemActive?n("div",t._l(t.widgetLabels.educationalHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"criminalHistoryComparing"===t.itemActive?n("div",t._l(t.widgetLabels.criminalHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"eadComparing"===t.itemActive?n("div",t._l(t.widgetLabels.eads,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"passportsComparing"===t.itemActive?n("div",t._l(t.widgetLabels.passport,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"travelHistoryComparing"===t.itemActive?n("div",t._l(t.widgetLabels.travelHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"usEntriesComparing"===t.itemActive?n("div",t._l(t.widgetLabels.usEntries,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"visaHistoryComparing"===t.itemActive?n("div",t._l(t.widgetLabels.visaHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"marriageHistoryComparing"===t.itemActive?n("div",t._l(t.widgetLabels.marriageHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"familyMembersComparing"===t.itemActive?n("div",t._l(t.widgetLabels.familyMembers,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),"advanceParoleComparing"===t.itemActive?n("div",t._l(t.widgetLabels.advanceParole,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),0):t._e(),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-6 formGeneralInfor boxLeft"},[!0===t.isModels&&t.duplex.nameduplex&&void 0!==t.duplex.nameduplex.namesComparing[0].edit&&"marriageHistoryComparing"===t.itemActive?n("pf-marital-status",{attrs:{information:t.duplex.namesComparing[0].edit,indexItem:"edit"+t.index,readonly:!0,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,uniqueIndex:t.index},on:{"change-color":t.changeClassComparing}}):t._e()],1),t._v(" "),n("div",{staticClass:"col-6 formGeneralInfor boxRight"},[!0===t.isModels&&t.duplex.nameduplex&&void 0!==t.duplex.namesComparing[0].manual&&"marriageHistoryComparing"===t.itemActive?n("pf-marital-status",{attrs:{information:t.duplex.namesComparing[0].manual,indexItem:"manual"+t.index,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,uniqueIndex:t.index,infoChangeValue:t.selectedValue,comparing:t.comparing},on:{"change-color":t.changeClassComparing,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}}):t._e()],1)]),t._v(" "),t._l(t.comparingInformation,function(e,i){return t.isModels?n("div",{key:i+"itemComparing",staticClass:"row"},[0===i?n("div",{staticClass:"col-6 formGeneralInfor boxLeft"},[n("h6",[t._v("Original Version: "+t._s(e.edit.updatedAt.split("T")[0]))])]):t._e(),t._v(" "),0===i?n("div",{staticClass:"col-6 formGeneralInfor boxRight"},[n("h6",[t._v("Client Version: "+t._s(e.manual.updatedAt===e.edit.updatedAt?t.moment().format("YYYY-MM-DD"):e.manual.updatedAt.split("T")[0]))])]):t._e(),t._v(" "),t._l(e,function(a,o){return void 0!==e.edit?n("div",{key:o+"type",staticClass:"col-6 ",class:"edit"===o?"boxLeft":"boxRight",attrs:{id:o+a.id}},["namesComparing"===t.itemActive?n("div",{attrs:{id:"namesComparingContent"}},[n("pf-contact-names",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"communicationComparing"===t.itemActive?n("div",{attrs:{id:"communicationComparingContent"}},[n("pf-communication",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"biographicInformationComparing"===t.itemActive?n("div",{attrs:{id:"biographicInformationComparingContent"}},[n("pf-biographic-information",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"immigrationInformationComparing"===t.itemActive?n("div",{attrs:{id:"immigrationInformationComparingContent"}},[n("pf-immigration-information",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"backgroundCheckInformationComparing"===t.itemActive?n("div",{attrs:{id:"backgroundCheckInformationComparingContent"}},[n("pf-background-check-information",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"priorityDatesComparing"===t.itemActive?n("div",{attrs:{id:"priorityDatesComparingContent"}},[n("pf-priority-dates",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"addressesComparing"===t.itemActive?n("div",{staticClass:"addressesComparingContent"},[n("pf-address",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual,settypeaddress:t.setTypeAddress}})],1):t._e(),t._v(" "),"previousAddressesComparing"===t.itemActive?n("div",{attrs:{id:"previousAddressesComparingContent"}},[n("pf-address",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,previous:!0,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"phonesComparing"===t.itemActive?n("div",{attrs:{id:"phonesComparingContent"}},[n("pf-phone",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"jobsComparing"===t.itemActive?n("div",{attrs:{id:"jobsComparingContent"}},[n("pf-job",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"educationalHistoryComparing"===t.itemActive?n("div",{attrs:{id:"educationalHistoryComparingContent"}},[n("pf-educational",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"criminalHistoryComparing"===t.itemActive?n("div",{attrs:{id:"criminalHistoryComparingContent"}},[n("pf-crime",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"eadComparing"===t.itemActive?n("div",{attrs:{id:"eadComparingContent"}},[n("pf-ead",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"passportsComparing"===t.itemActive?n("div",{attrs:{id:"passportsComparingContent"}},[n("pf-passport",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"travelHistoryComparing"===t.itemActive?n("div",{attrs:{id:"travelHistoryComparingContent"}},[n("pf-travel",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"usEntriesComparing"===t.itemActive?n("div",{attrs:{id:"usEntriesComparingContent"}},[n("pf-us-entry",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"visaHistoryComparing"===t.itemActive?n("div",{attrs:{id:"visaHistoryComparingContent"}},[n("pf-visa",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"marriageHistoryComparing"===t.itemActive?n("div",{attrs:{id:"marriageHistoryComparingContent"}},[n("pf-marriage",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"familyMembersComparing"===t.itemActive?n("div",{attrs:{id:"familyMembersComparingContent"}},[n("pf-family-member",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e(),t._v(" "),"advanceParoleComparing"===t.itemActive?n("div",{attrs:{id:"advanceParoleComparingContent"}},[n("pf-advance",{attrs:{information:a,readonly:"edit"===o,comparing:t.comparing,indexItem:o+i,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,infoChangeValue:t.selectedValue,uniqueIndex:i},on:{"change-color":t.changeClassComparing,"change-calendar":t.changeCalendar,"set-badges":t.setValueBadges,"open:context":t.setOriginEditManual}})],1):t._e()]):t._e()})],2):t._e()}),t._v(" "),""!==t.itemActive&&-1!==t.formNames.map(function(t){return t.id}).indexOf(t.itemActive)?n("div",{staticClass:"row"},t._l(t.infoQuestionnaire,function(e,i){return n("div",{key:i,staticClass:"col-6",class:"edit"===i?"boxLeft":"boxRight"},[n("pf-questionnaire-form-comparing",{attrs:{form:t.paramsEstructureQuestionnaire,apiService:t.apiService,information:e,token:t.token,comparing:t.comparing,readonly:"edit"===i,indexItem:i,formNames:t.formNames,idForm:t.itemActive,questionnaireid:t.questionnaireid,infoChangeValueForm:t.selectedValue},on:{"change-color":t.changeClassComparing,"set-widget-labels":t.setWidgetLabels,"set-shortcuts":t.setCurrentShortCuts,"open:context":t.setOriginEditManual,"set-badges":t.setValueBadges,"return-info-qf":t.returnInfoQuestionnaireForm,"set-current-formid":t.setCurrentFormId}})],1)}),0):0===t.comparingInformation.length?n("div",[t._v("No Record")]):t._e()],2)]):!1===t.isSpinner&&!1===t.comparing&&Object.keys(t.dbInformation).length>0?n("div",{staticClass:"pl-3 pr-3",attrs:{id:"allContentViewer"}},[-1!==t.itemActive.indexOf("Comparing")?n("div",{staticClass:"row rowhelpItem"},[n("div",{staticClass:"col-12 mb-3 helpItem"},[n("b",[t._v(t._s(t.helpTexts[t.itemActive]))])])]):t._e(),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"namesComparing"===t.itemActive,expression:"itemActive === 'namesComparing'"}]},[t._l(t.widgetLabels.names,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),!0===t.isModels?n("pf-contact-names",{attrs:{information:!0===t.viewer?t.dbInformation.personal:t.dbInformation,indexItem:"questionnairePersonal",viewer:t.viewer,apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid}}):t._e()],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"communicationComparing"===t.itemActive,expression:"itemActive === 'communicationComparing'"}]},[t._l(t.widgetLabels.communication,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),!0===t.isModels?n("pf-communication",{attrs:{information:!0===t.viewer?t.dbInformation.personal:t.dbInformation,indexItem:"questionnairePersonal",viewer:t.viewer,apiService:t.apiService,questionnaireid:t.questionnaireid,token:t.token}}):t._e()],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"biographicInformationComparing"===t.itemActive,expression:"itemActive === 'biographicInformationComparing'"}]},[t._l(t.widgetLabels.biographicInfo,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),!0===t.isModels?n("pf-biographic-information",{attrs:{information:!0===t.viewer?t.dbInformation.personal:t.dbInformation,indexItem:"questionnairePersonal",viewer:t.viewer,apiService:t.apiService,questionnaireid:t.questionnaireid,token:t.token}}):t._e()],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"immigrationInformationComparing"===t.itemActive,expression:"itemActive === 'immigrationInformationComparing'"}]},[t._l(t.widgetLabels.immigrationInfo,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),!0===t.isModels?n("pf-immigration-information",{attrs:{information:!0===t.viewer?t.dbInformation.personal:t.dbInformation,indexItem:"questionnairePersonal",viewer:t.viewer,apiService:t.apiService,questionnaireid:t.questionnaireid,token:t.token}}):t._e()],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"backgroundCheckInformationComparing"===t.itemActive,expression:"itemActive === 'backgroundCheckInformationComparing'"}]},[t._l(t.widgetLabels.additionalInfo,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),!0===t.isModels?n("pf-background-check-information",{attrs:{information:!0===t.viewer?t.dbInformation.personal:t.dbInformation,indexItem:"questionnairePersonal",viewer:t.viewer,apiService:t.apiService,questionnaireid:t.questionnaireid,token:t.token}}):t._e()],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"priorityDatesComparing"===t.itemActive,expression:"itemActive === 'priorityDatesComparing'"}]},[t._l(t.widgetLabels.priorityDates,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),!0===t.isModels?n("pf-priority-dates",{attrs:{information:!0===t.viewer?t.dbInformation.personal:t.dbInformation,indexItem:"questionnairePersonal",viewer:t.viewer,apiService:t.apiService,questionnaireid:t.questionnaireid,token:t.token}}):t._e()],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"addressesComparing"===t.itemActive,expression:"itemActive === 'addressesComparing'"}]},[t._l(t.widgetLabels.addresses,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-addresses",{attrs:{list:!0===t.viewer?t.informationAddresses:t.dbInformation.address,token:t.token,contactId:t.contactid,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"previousAddressesComparing"===t.itemActive,expression:"itemActive === 'previousAddressesComparing'"}]},[t._l(t.widgetLabels.previousAddresses,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-addresses",{attrs:{list:!0===t.viewer?t.informationPreviousAddresses:t.dbInformation.address,previous:!0,token:t.token,contactId:t.contactid,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"phonesComparing"===t.itemActive,expression:"itemActive === 'phonesComparing'"}]},[t._l(t.widgetLabels.phones,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-phones",{attrs:{list:!0===t.viewer?t.informationPhones:t.dbInformation.phones,token:t.token,contactId:t.contactid,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"jobsComparing"===t.itemActive,expression:"itemActive === 'jobsComparing'"}]},[t._l(t.widgetLabels.jobs,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-jobs",{attrs:{list:!0===t.viewer?t.informationJobs:t.dbInformation.jobs,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"educationalHistoryComparing"===t.itemActive,expression:"itemActive === 'educationalHistoryComparing'"}]},[t._l(t.widgetLabels.educationalHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-educational-history",{attrs:{list:!0===t.viewer?t.informationEducational:t.dbInformation.educationalHistory,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"criminalHistoryComparing"===t.itemActive,expression:"itemActive === 'criminalHistoryComparing'"}]},[t._l(t.widgetLabels.criminalHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-criminal-history",{attrs:{list:!0===t.viewer?t.informationCriminal:t.dbInformation.criminalHistory,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"eadComparing"===t.itemActive,expression:"itemActive === 'eadComparing'"}]},[t._l(t.widgetLabels.eads,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-eads",{attrs:{list:!0===t.viewer?t.informationEads:t.dbInformation.ead,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"passportsComparing"===t.itemActive,expression:"itemActive === 'passportsComparing'"}]},[t._l(t.widgetLabels.passport,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-passports",{attrs:{list:!0===t.viewer?t.informationPassports:t.dbInformation.passports,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"travelHistoryComparing"===t.itemActive,expression:"itemActive === 'travelHistoryComparing'"}]},[t._l(t.widgetLabels.travelHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-travel-history",{attrs:{list:!0===t.viewer?t.informationTravel:t.dbInformation.travelHistory,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"usEntriesComparing"===t.itemActive,expression:"itemActive === 'usEntriesComparing'"}]},[t._l(t.widgetLabels.usEntries,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-us-entries",{attrs:{list:!0===t.viewer?t.informationUsEntries:t.dbInformation.usEntries,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"visaHistoryComparing"===t.itemActive,expression:"itemActive === 'visaHistoryComparing'"}]},[t._l(t.widgetLabels.visaHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-visa-history",{attrs:{list:!0===t.viewer?t.informationVisa:t.dbInformation.visaHistory,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"marriageHistoryComparing"===t.itemActive,expression:"itemActive === 'marriageHistoryComparing'"}]},[t._l(t.widgetLabels.marriageHistory,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),void 0!==t.dbInformation.personal&&"marriageHistoryComparing"===t.itemActive?n("pf-marital-status",{attrs:{information:t.dbInformation.personal,indexItem:"questionnairePersonal",apiService:t.apiService,token:t.token,questionnaireid:t.questionnaireid,viewer:t.viewer}}):t._e(),t._v(" "),n("pf-marriage-history",{attrs:{list:!0===t.viewer?t.informationMarriage:t.dbInformation.marriageHistory,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"familyMembersComparing"===t.itemActive,expression:"itemActive === 'familyMembersComparing'"}]},[t._l(t.widgetLabels.familyMembers,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-family-members",{attrs:{list:!0===t.viewer?t.informationFamily:t.dbInformation.familyMembers,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:"advanceParoleComparing"===t.itemActive,expression:"itemActive === 'advanceParoleComparing'"}]},[t._l(t.widgetLabels.advanceParole,function(e,i){return n("p",{key:i},[n("b",[t._v(t._s(e))])])}),t._v(" "),n("pf-advance-parole",{attrs:{list:!0===t.viewer?t.informationAdvance:t.dbInformation.advanceParole,contactId:t.contactid,token:t.token,viewer:t.viewer,questionnaireid:t.questionnaireid},on:{"set-change-model":t.setChangeViewerModel}})],2),t._v(" "),n("pf-questionnaire-form",{directives:[{name:"show",rawName:"v-show",value:"searchForm"===t.itemActive||""!==t.itemActive&&-1!==t.formNames.map(function(t){return t.id}).indexOf(t.itemActive),expression:"itemActive === 'searchForm' || (itemActive !== '' && formNames.map(a => a.id).indexOf(itemActive) !== -1)"}],attrs:{forms:t.dbInformation.forms,token:t.token,viewer:t.viewer,caseFormId:t.caseFormId,questionnaireid:t.questionnaireid,apiService:t.apiService,list:!0===t.viewer?t.informationPhones:t.dbInformation.phones},on:{"set-form-names":t.setFormNames,"set-widget-labels":t.setWidgetLabels,"set-change-value":t.setChangeViewer,"set-change-model":t.setChangeViewerModel}})],1):t._e(),t._v(" "),n("p"),t._v(" "),n("div",{staticClass:"footer-tab"},[n("div",{staticClass:"row"},[n("div",{class:!0===t.comparing?"col-6":"col-4"},["namesComparing"!==t.itemActive&&!1===t.noShowPrev?n("button",{staticClass:"float-left btn btn-secondary btn-sm btnNext",attrs:{id:"paging-previous"},on:{click:function(e){return t.pagingStatic("previous")}}},[t._v("Previous\n                  ")]):t._e()]),t._v(" "),!1===t.comparing?n("div",{class:!1===t.comparing?"col-4 centerBtnAf":""},[n("pf-button",{attrs:{classButton:"btn-success btnnNew",id:t.questionnaireid+"home",logo:"fas fa-home",title:"Go to Home"},on:{click:function(e){return t.$emit("show-landing-page")}}})],1):t._e(),t._v(" "),n("div",{class:!0===t.comparing?"col-6":"col-4"},[t.itemActive!==this.formNames.map(function(t){return t.id})[this.formNames.map(function(t){return t.id}).length-1]&&!1===t.noShowNext?n("button",{staticClass:"float-right btn btn-secondary btn-sm btnNext",attrs:{id:"paging-next"},on:{click:function(e){return t.pagingStatic("next")}}},[t._v("Next\n                  ")]):t._e()])])])])])])])]):t._e(),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:t.titlePopUp,message:t.messagePopUp,type:t.typePopUp,counter:t.counterPopUp},on:{close:function(e){t.isPopUp=!1},action:t.setActionPopUpSideBar}}):t._e(),t._v(" "),!0===t.comparing?n("vue-context",{ref:"menu",staticStyle:{position:"absolute"},style:Object.keys(t.positionContext).length>0?"top:"+t.positionContext.top+"px;left:"+(t.positionContext.left-70)+"px;":""},[n("li",[n("a",{on:{click:function(e){return t.changeInfo("origin")}}},[t._v("Origin: "+t._s(void 0!==t.originEditManual.values&&void 0!==t.originEditManual.values.origin?t.originEditManual.values.origin:""))])]),t._v(" "),n("li",[n("a",{on:{click:function(e){return t.changeInfo("edit")}}},[t._v("Client: "+t._s(void 0!==t.originEditManual.values&&void 0!==t.originEditManual.values.edit?t.originEditManual.values.edit:""))])]),t._v(" "),n("li",[n("a",{on:{click:function(e){return t.changeInfo("manual")}}},[t._v("Attorney: "+t._s(void 0!==t.originEditManual.values&&void 0!==t.originEditManual.values.manual?t.originEditManual.values.manual:""))])])]):t._e()],1)},staticRenderFns:[]};var vl=n("VU/8")(xl,gl,!1,function(t){n("BIZ8")},"data-v-01327eb3",null).exports,Cl=n("woOf"),yl=n.n(Cl),wl={name:"pf-top-bar",data:function(){return{isActive:!1}},props:{items:{type:Array,default:[]},styleItem:{type:String,default:""}},mounted:function(){var t=this;0!==this.items.length&&(this.items.forEach(function(e){var n=document.getElementById(e.name);"active"===e.class?(t.changeItem({content:e.name}),t.isActive=!0):null!==n&&n.classList.add("d-none")}),!1===this.isActive&&this.changeItem({id:this.items[0].id?this.items[0].id:0,content:this.items[0].name}))},methods:{changeItem:function(t){var e=document.getElementById(t.id),n=document.getElementById(t.content);void 0!==t.id&&(this.items.forEach(function(t){var e=document.getElementById(t.id);null!==e&&e.classList.remove("active");var n=document.getElementById(t.name);n.classList.remove("active"),n.classList.add("d-none")}),e.classList.add("active")),null!==n&&(n.classList.remove("d-none"),n.classList.add("active"))}}},Bl={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[n("div",{staticClass:"row myRow"},[n("div",{staticClass:"toolbox-tab-menu headerModalQuestionnaire"},[n("div",{staticClass:"col-12 list-group pl-1 mt-1"},t._l(t.items,function(e,i){return n("a",{key:i,staticClass:" list-group-item text-center positionContact tabsSecundary",class:e.class,style:t.styleItem,attrs:{href:"#",id:e.id?e.id:i},on:{click:function(n){return t.changeItem({id:e.id?e.id:i,content:e.name})}}},[t._v("\n          "+t._s(e.title)+" "),n("span",{},[t.items.length>i+1?n("i",{staticClass:"fas fa-angle-right icoArrow"}):t._e()])])}),0)])])])},staticRenderFns:[]};var kl=n("VU/8")(wl,Bl,!1,function(t){n("LnJb"),n("iLGu")},"data-v-6408bcdc",null).exports,El={name:"pf-modal",props:{title:{type:String,default:"Title Modal"},btnleft:{type:String,default:""},btnright:{type:String,default:""},noFirstHr:{type:Boolean,default:!1},isAction:{type:Boolean,default:!1},isBtnRightDisabled:{type:Boolean},noLastHr:{type:Boolean,default:!1},isUbold:{type:Boolean},footerClass:{type:String},styleContainerModal:{type:String},styleModalBody:{type:String},noShowMenu:{type:Boolean,default:!1}},components:{PfSpinner:r}},Il={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("transition",{attrs:{name:"modal"}},[n("div",{staticClass:"modal-maskMain",attrs:{id:"modall"}},[n("div",{staticClass:"modal-wrapperMain"},[n("div",{staticClass:"modal-containerMain",class:!0===t.isUbold?"container-mainUbold":"",style:t.styleContainerModal},[n("div",{staticClass:"row"},[n("div",{staticClass:"myContainerMain formGeneralInfor",style:!0===t.isAction?"pointer-events: none;":""},[n("div",{staticClass:"col-12 colorHeaderModal",class:!0===t.isUbold?"headerUbold":""},[n("h5",{staticClass:"textTitleMain modal-title",class:!0===t.isUbold?"titleUbold":""},[t._v(t._s(t.title)+"\n                "),n("span",{staticClass:"closeModalMain float-right",class:!0===t.isUbold?"closeUbold":"",on:{click:function(e){return t.$emit("close")}}},[t._v("X")])])]),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 formGeneralInfor"},[n("div",{staticClass:"toolbox-tab-containerMain scroll "},[!1===t.noShowMenu?n("div",{staticClass:"toolbox-tab-menuMain headerModalMain"},[n("div",{staticClass:"col-12 list-group paddingR0"},[t._t("menu")],2)]):t._e(),t._v(" "),!1===t.noFirstHr?n("hr",{staticClass:"mrHr"}):t._e(),t._v(" "),n("div",{staticClass:"toolbox-tab col-12",style:t.styleModalBody},[t._t("body")],2),t._v(" "),!1===t.noLastHr?n("hr",{staticClass:"mrHr",class:!0===t.isUbold?"hrUboldFooter":""}):t._e(),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-12"},[n("div",{staticClass:"float-left",class:t.footerClass},[t._t("footer")],2),t._v(" "),""!==t.btnleft?n("button",{staticClass:"btn btn-sm btn-success mb-2 mt-n2",attrs:{id:"btnLeft"},on:{click:function(e){return t.$emit("click","left")}}},[t._v(t._s(t.btnleft))]):t._e(),t._v(" "),""!==t.btnright?n("button",{staticClass:"float-right btn btn-sm btn-success mb-2 mt-n2",style:!0===t.isBtnRightDisabled?"pointer-events: none":"",attrs:{id:"btnRight",disabled:t.isBtnRightDisabled},on:{click:function(e){return t.$emit("click","right")}}},[!1===t.isAction?n("span",[t._v(t._s(t.btnright))]):t._e(),t._v(" "),!0===t.isAction?n("span",[n("span",{staticClass:"spinner-border spinner-border-sm mr-1",attrs:{role:"status","aria-hidden":"true"}}),t._v("\n                          Loading...\n                        ")]):t._e()]):t._e()])])])])])])])])])])])},staticRenderFns:[]};var Dl=n("VU/8")(El,Il,!1,function(t){n("QRWa"),n("dCCA")},"data-v-6fd46207",null).exports,Sl={components:{PfCheckbox:x},methods:{setAllCheck:function(t){var e=this;"table-form"===t.classTable&&(this.formSelected=[],this.contactList=[]);var n=document.getElementById(t.id);"table-main"===t.classTable?(this.isAllCheckMain=n.checked,this.questionnairesSelected=[]):"table-form"===t.classTable?this.isAllCheckForm=n.checked:"table-contact"===t.classTable&&(this.isAllCheckContact=n.checked);var i="."+t.classTable+" tr.tr-check";document.querySelectorAll(i).forEach(function(n,i){"table-main"===t.classTable&&(!0===e.isAllCheckMain?(n.style.backgroundColor="#a8a8a878",e.setValueAllMain({value:!0,index:i})):(n.style.backgroundColor="",e.setValueAllMain({value:!1,index:i}))),"table-form"===t.classTable&&(!0===e.isAllCheckForm?(n.style.backgroundColor="#a8a8a878",e.setValueAllForms({value:!0,index:i})):(n.style.backgroundColor="",e.setValueAllForms({value:!1,index:i}))),"table-contact"===t.classTable&&(!0===e.isAllCheckContact?(n.style.backgroundColor="#a8a8a878",e.setValueAllContacts({value:!0,index:i})):(n.style.backgroundColor="",e.setValueAllContacts({value:!1,index:i})))})},changeColor:function(t){var e=document.getElementById(t.idCheck),n=document.getElementById(t.idContent);null!==e&&(!0===e.checked?null!==n&&(n.style.backgroundColor="#a8a8a878",void 0!==t.questionnaireId&&this.setValueQuestionnaire({questionnaireId:t.questionnaireId,value:!0}),void 0!==t.quizId&&this.setValueQuiz({quizId:t.quizId,value:!0}),void 0!==t.uniqueId&&this.setValueForm({uniqueId:t.uniqueId,value:!0,idCheck:t.idCheck,idContent:t.idContent}),void 0!==t.contactId&&this.setValueContact({contactId:t.contactId,value:!0})):null!==n&&(n.style.backgroundColor="",void 0!==t.questionnaireId&&this.setValueQuestionnaire({questionnaireId:t.questionnaireId,value:!1}),void 0!==t.quizId&&this.setValueQuiz({quizId:t.quizId,value:!1}),void 0!==t.uniqueId&&this.setValueForm({uniqueId:t.uniqueId,value:!1}),void 0!==t.contactId&&this.setValueContact({contactId:t.contactId,value:!1})))}}},Nl={name:"modal",data:function(){return{btnright:"",btnleft:"",isAllCheckForm:!1,isAllCheckContact:!1,items:[{name:"formList",title:"Forms",id:"formsModal"},{name:"contactList",title:"Contacts",id:"contactsModal"}],formList:[],contactList:[],formSelected:[],questionnaireInformation:[],isSpinner:!0,helpTextForm:"",isGenerate:!1}},props:{forms:{type:Array,default:[]},contacts:{type:Array,default:[]},caseId:{type:Number},apiService:{type:Object},token:{type:String}},components:{PfModal:Dl,PfTopBar:kl,PfSpinner:r},mixins:[Sl],created:function(){var t=this,e=this;document.onclick=function(t){if("i"==t.target.localName){var n="";document.querySelectorAll("a.active").forEach(function(t){n=t.id}),e.items.forEach(function(t,i){t.id===n&&e.setPositionButtons(i)})}if("a"==t.target.localName){var i=t.target.id;e.items.forEach(function(t,n){t.id===i&&e.setPositionButtons(n)})}},this.apiService.getListForQuestionnaire({token:this.token,caseId:this.caseId}).then(function(e){e.rolesAssigneds&&void 0!==e.rolesAssigneds&&(t.formList=e.rolesAssigneds,t.setAttributeList(),setTimeout(function(){null!==document.getElementById(t.items[1].id)&&(document.getElementById(t.items[1].id).style.pointerEvents="none")},500))})},methods:{setAttributeList:function(){var t=this,e=[];this.formList.forEach(function(t,n){Y()(t.contacts).forEach(function(e){Y()(t.contacts[e]).length>0&&"Interpreter"!==t.roles[e].name&&"Attorney"!==t.roles[e].name&&(t.render=!0)}),t.uniqueId=t.caseFormId+n,0!==Y()(t.contacts).length&&!0===t.render&&!0===t.enableForQuestionnaire&&e.push(t)}),this.formList=e,this.isSpinner=!1,this.formList.forEach(function(e,n){!0===e.generate&&t.changeColor({idCheck:"ch-form"+n,idContent:"tr-form"+n,formId:e.formId})}),this.contacts.forEach(function(e,n){!0===e.generate&&t.changeColor({idCheck:"ch-contact"+n,idContent:"tr-contact"+n,contactId:e.id})}),this.setPositionButtons(0)},buttonAction:function(t){var e=this;if("Generate"===this.btnright&&"right"===t)return this.setQuestionnaireInformation(),void(this.isGenerate=!0);var n=null;document.querySelectorAll("a.active").forEach(function(i){e.items.forEach(function(e,a){e.id===i.id&&(n="right"===t?a+1:"left"===t?a-1:"")})}),document.getElementById(this.items[n].id).click(),this.setPositionButtons(n)},setPositionButtons:function(t){var e=!1;if(this.formList.forEach(function(t){!0===t.generate&&(e=!0)}),1===t){this.helpText="Please choose which indiviudals you will want to gather information for.  If you need to gather information on everyone listed here, choose all of them.  If you only need to gather information from one person, choose that person.  Later, you will decide who will actually fill in this questionnaire and you can send it to them via email or text message.";var n=!1;this.contactList.forEach(function(t){t.onlyGeneral=void 0===t.onlyGeneral||t.onlyGeneral,t.onlyForms=void 0===t.onlyForms||t.onlyForms,!0===t.generate&&(n=!0)}),!1===e||!1===n?(this.btnleft="Previous",this.btnright=""):(this.btnleft="Previous",this.btnright="Generate")}else 0===t?(this.helpText="Please choose the forms which you would like to generate questionnaires for.",!1===e?(this.btnright="",this.btnleft="",null!==document.getElementById(this.items[1].id)&&(document.getElementById(this.items[1].id).style.pointerEvents="none")):(this.btnright="Next",this.btnleft="",document.getElementById(this.items[1].id).style.pointerEvents="auto")):t+1===this.items.length&&(this.btnright="",this.btnleft="")},setValueAllForms:function(t){var e=this;!1===t.value?(this.btnright="",document.getElementById(this.items[1].id).style.pointerEvents="none"):(this.btnright="Next",document.getElementById(this.items[1].id).style.pointerEvents="auto");var n=Y()(this.formList[t.index].contacts).length;0!==n&&n--,Y()(this.formList[t.index].contacts).forEach(function(i){0===Y()(e.formList[t.index].contacts[i]).length&&n--}),-1!==n?(this.formList[t.index].generate=t.value,!0===t.value?(this.formSelected.push(this.formList[t.index]),this.setQContactList(this.formList[t.index])):(this.formSelected.forEach(function(n,i){n.uniqueId===e.formList[t.index].uniqueId&&e.formSelected.splice(i,1)}),this.contactList=[],this.formSelected.forEach(function(t){e.setQContactList(t)}))):setTimeout(function(){e.changeColor({idCheck:"ch-form"+t.index,idContent:"tr-form"+t.index,uniqueId:e.formList[t.index].uniqueId})},200)},setValueForm:function(t){var e=this;!1===t.value&&(this.isAllCheckForm=!1),this.formList.forEach(function(n){var i=Y()(n.contacts).length;0!==i&&i--,n.uniqueId===t.uniqueId&&(Y()(n.contacts).forEach(function(t){0===Y()(n.contacts[t]).length&&i--}),-1!==i?(n.generate=t.value,!0===t.value?(e.formSelected.push(n),e.setQContactList(n)):(e.formSelected.forEach(function(t,i){t.uniqueId===n.uniqueId&&e.formSelected.splice(i,1)}),e.contactList=[],e.formSelected.forEach(function(t){e.setQContactList(t)}))):(void 0!==t.idCheck&&(alert("No assign contact to role."),document.getElementById(t.idCheck).checked=!1),e.changeColor({idCheck:t.idCheck,idContent:t.idContent,uniqueId:t.uniqueId})))}),this.setPositionButtons(0)},setValueAllContacts:function(t){this.setPositionButtons(1),this.contactList[t.index].generate=t.value,!1===t.value?this.btnright="":this.btnright="Generate"},setValueContact:function(t){!1===t.value&&(this.isAllCheckContact=!1),this.contactList.forEach(function(e){e.id+e.type===t.contactId&&(e.generate=t.value)}),this.setPositionButtons(1)},setQContactList:function(t){var e=this;Y()(t.contacts).forEach(function(n){if(0===e.contactList.length&&Y()(t.contacts[n]).length>0&&"Interpreter"!==t.roles[n].name&&"Attorney"!==t.roles[n].name){var i={};i.id=t.contacts[n].id,i.firstName=t.contacts[n].firstName,i.middleName=t.contacts[n].middleName,i.lastName=t.contacts[n].lastName,i.type=t.roles[n].type,i.forms={},i.forms[t.formName]={},i.forms[t.formName]._id=t.formId,i.forms[t.formName].roles=[],t.roles[n].uniqueId=t.uniqueId,t.roles[n].qId=t.caseFormId,i.forms[t.formName].roles.push(t.roles[n]),e.contactList.push(i)}else if(Y()(t.contacts[n]).length>0&&"Interpreter"!==t.roles[n].name&&"Attorney"!==t.roles[n].name)if(-1!==e.contactList.map(function(t){return t.id+t.type}).indexOf(t.contacts[n].id+t.roles[n].type))void 0===e.contactList[e.contactList.map(function(t){return t.id+t.type}).indexOf(t.contacts[n].id+t.roles[n].type)].forms[t.formName]&&(e.contactList[e.contactList.map(function(t){return t.id+t.type}).indexOf(t.contacts[n].id+t.roles[n].type)].forms[t.formName]={}),e.contactList[e.contactList.map(function(t){return t.id+t.type}).indexOf(t.contacts[n].id+t.roles[n].type)].forms[t.formName]._id=t.formId,void 0===e.contactList[e.contactList.map(function(t){return t.id+t.type}).indexOf(t.contacts[n].id+t.roles[n].type)].forms[t.formName].roles&&(e.contactList[e.contactList.map(function(t){return t.id+t.type}).indexOf(t.contacts[n].id+t.roles[n].type)].forms[t.formName].roles=[]),t.roles[n].uniqueId=t.uniqueId,t.roles[n].qId=t.caseFormId,e.contactList[e.contactList.map(function(t){return t.id+t.type}).indexOf(t.contacts[n].id+t.roles[n].type)].forms[t.formName].roles.push(t.roles[n]);else{var a={};a.id=t.contacts[n].id,a.firstName=t.contacts[n].firstName,a.middleName=t.contacts[n].middleName,a.lastName=t.contacts[n].lastName,a.type=t.roles[n].type,a.forms={},a.forms[t.formName]={},a.forms[t.formName]._id=t.formId,a.forms[t.formName].roles=[],t.roles[n].uniqueId=t.uniqueId,t.roles[n].qId=t.caseFormId,a.forms[t.formName].roles.push(t.roles[n]),e.contactList.push(a)}})},setQuestionnaireInformation:function(){var t=this,e=[];this.contactList.forEach(function(n){var i={};!0===n.generate&&(Y()(n.forms).forEach(function(t){n.forms[t].roles=n.forms[t].roles.sort(function(t,e){return t.qId>e.qId?1:-1})}),i.contactId=n.id,i.caseId=t.caseId,i.onlyGeneral=n.onlyGeneral,i.onlyForms=n.onlyForms,i.forms=[],Y()(n.forms).forEach(function(t){var e={};e.formId=n.forms[t]._id,e.roles=[],e.prefixes=[],n.forms[t].roles.forEach(function(a,o){Y()(e.roles).length>0?Y()(e.roles).forEach(function(r){a.qId===e.caseFormId?(n.forms[t].roles.length>e.roles.length&&(e.roles.push(a.name),e.prefixes.push(a.prefix)),e.caseFormId=a.qId,n.forms[t].roles.length===o+1&&i.forms.push(e)):(i.forms.push(e),(e={}).formId=n.forms[t]._id,e.roles=[],e.prefixes=[],e.roles.push(a.name),e.prefixes.push(a.prefix),e.caseFormId=a.qId,i.forms.push(e))}):(e.roles.push(a.name),e.prefixes.push(a.prefix),e.caseFormId=a.qId,1===n.forms[t].roles.length&&i.forms.push(e))})}),i.type=n.type,e.push(i))}),this.apiService.addQuestionnaires({questionnaires:e,token:this.token}).then(function(e){void 0!==e.caseQuestionnairesAdd&&null!==e.caseQuestionnairesAdd?t.$emit("addquestionnaires",e.caseQuestionnairesAdd):alert("Autofill dont exist"),setTimeout(function(){t.$emit("close")},200)})},changeGeneralInformation:function(t){this.contactList[t].onlyGeneral=!this.contactList[t].onlyGeneral,this.contactList=yl()([],this.contactList,this.contactList)},changeFormFields:function(t){this.contactList[t].onlyForms=!this.contactList[t].onlyForms,this.contactList=yl()([],this.contactList,this.contactList)}}},Ml={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("pf-modal",{attrs:{title:"Generate Questionnaire",btnright:t.formList.length>0?t.btnright:"",btnleft:t.formList.length>0?t.btnleft:"",isAction:t.isGenerate},on:{close:function(e){return t.$emit("close")},click:t.buttonAction}},[n("template",{slot:"menu"},[t.formList.length>0?n("pf-top-bar",{attrs:{items:t.items}}):t._e()],1),t._v(" "),n("template",{slot:"body"},[!0===t.isSpinner?n("pf-spinner",{attrs:{color:"black"}}):t._e(),t._v(" "),!1===t.isSpinner?n("div",{staticClass:"row rowhelpItemModal"},[n("div",{staticClass:"col-12 helpItemModal"},[n("b",[t._v(t._s(t.helpText))])])]):t._e(),t._v(" "),t.formList.length>0?n("div",{attrs:{id:"formList"}},[n("div",{staticClass:"row myRow mt-3"},[n("div",{staticClass:"col-12"},[n("table",{staticClass:"table table-hover myTable spacetd table-form table-striped"},[n("thead",[n("tr",{staticClass:"noBorderTop bgcolorhead2"},[n("th",{staticClass:"widthTableHeader",staticStyle:{"padding-top":"9px !important"}},[n("div",[n("pf-checkbox",{attrs:{id:"allForm",label:"Type",checked:t.isAllCheckForm,classLabel:"font-weight-bold"},on:{click:function(e){return t.setAllCheck({classTable:"table-form",id:"allForm"})}}})],1)]),t._v(" "),n("th",[t._v("Role")])])]),t._v(" "),n("tbody",t._l(t.formList,function(e,i){return n("tr",{key:"form"+i,staticClass:"tr-check",attrs:{id:"tr-form"+i}},[n("td",[n("div",[n("pf-checkbox",{attrs:{id:"ch-form"+i,label:e.formName,checked:e.generate},on:{change:function(n){return t.changeColor({idCheck:"ch-form"+i,idContent:"tr-form"+i,uniqueId:e.uniqueId})}}})],1)]),t._v(" "),n("td",t._l(e.contacts,function(i,a){return n("div",{key:"c"+a},[Object.keys(i).length>0&&void 0!==e.roles&&"Interpreter"!==e.roles[a].name&&"Attorney"!==e.roles[a].name?n("div",[n("b",[t._v(t._s(e.roles[a].name)+":")]),t._v(" "),Object.keys(i).length>0?n("div",{staticClass:"ml-3"},[t._v("\n                        "+t._s(i.firstName+" "+i.middleName+" "+i.lastName)+"\n                      ")]):n("div",{staticClass:"ml-3"},[t._v("\n                        None\n                      ")])]):t._e()])}),0)])}),0)])])])]):t._e(),t._v(" "),t.formList.length>0?n("div",{attrs:{id:"contactList"}},[0!==t.contactList.length?n("div",{staticClass:"row mt-3"},[n("div",{staticClass:"col-12"},[n("table",{staticClass:"table myTable table-hover spacetd table-contact table-striped"},[n("thead",[n("tr",{staticClass:"bgcolorhead2"},[n("th",{staticClass:"widthTableHeader"},[n("div",[n("pf-checkbox",{attrs:{id:"allContact",label:"Name",checked:t.isAllCheckContact,classLabel:"font-weight-bold"},on:{click:function(e){return t.setAllCheck({classTable:"table-contact",id:"allContact"})}}})],1)]),t._v(" "),n("th",[t._v("Form")]),t._v(" "),n("th",[t._v("Include in Questionnaire")])])]),t._v(" "),n("tbody",t._l(t.contactList,function(e,i){return n("tr",{key:"c"+i,staticClass:"tr-check",attrs:{id:"tr-contact"+i}},[n("td",[n("div",[n("pf-checkbox",{attrs:{id:"ch-contact"+i,label:e.firstName+" "+e.middleName+" "+e.lastName,checked:e.generate},on:{change:function(n){return t.changeColor({idCheck:"ch-contact"+i,idContent:"tr-contact"+i,contactId:e.id+e.type})}}})],1)]),t._v(" "),n("td",t._l(e.forms,function(e,i){return n("div",{key:"cf"+i},t._l(e.roles,function(e,a){return n("div",{key:a},[n("b",[t._v(t._s(e.name)+" "),n("br")]),t._v(" "),n("div",{staticClass:"ml-3"},[t._v("\n                        "+t._s(i)+"\n                      ")])])}),0)}),0),t._v(" "),n("td",[n("pf-checkbox",{attrs:{id:i+"general",label:"Basic Information",disabled:!e.onlyForms,checked:e.onlyGeneral,classLabel:"font-weight-bold"},on:{click:function(e){return t.changeGeneralInformation(i)}}}),t._v(" "),n("pf-checkbox",{attrs:{id:i+"formFields",label:"Form-Specific Questions",disabled:!e.onlyGeneral,checked:e.onlyForms,classLabel:"font-weight-bold"},on:{click:function(e){return t.changeFormFields(i)}}})],1)])}),0)])])]):n("div",{staticClass:"ml-4"},[n("label",[t._v("No contacts involved")])])]):!1===t.isSpinner&&0===t.formList.length?n("div",{staticClass:"ml-4"},[n("label",[t._v("No Forms")])]):t._e()],1)],2)},staticRenderFns:[]};var Ol=n("VU/8")(Nl,Ml,!1,function(t){n("P0jM"),n("fnBA")},"data-v-795ea1dc",null).exports;$t.a.directive("mask",it),$t.a.use(Io,{classes:!0,classNames:{invalid:"is-invalid"}});var Tl={name:"pf-send-questionnaire-modal",data:function(){return{dateToday:{},daysExpire:0,dateExpire:"",emailClient:"",emailSelected:[],ctryCode:1,smsClient:"",smsSelected:[],isShowSms:!1,isShowEmail:!1,questionnaireNote:"",isValidEmail:!1,isValidPhone:!1,listEmails:[],listPhones:[],contactsRelationed:[],isSent:!1,modelSelectEmail:"",modelSelectSms:""}},props:{questionnaires:{type:Array},token:{type:String},apiService:{type:Object}},components:{PfCalendar:lt,PfInput:m,PfCheckbox:x,PfTextArea:T,PfModal:Dl,vSelect:y.a,PfSpinner:r},watch:{emailClient:function(t){this.isValidEmail=!1;this.isValidEmail=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(t).toLowerCase())},smsClient:function(t){this.isValidPhone=!1,t.length<8||(this.isValidPhone=!0)}},created:function(){var t=ct()().add(1,"days").format("MM/DD/YYYY");this.dateToday={from:t},this.dateExpire=ct()().add(15,"days").format("MM/DD/YYYY"),this.daysExpire=1-ct()().diff(this.dateExpire,"days"),this.getEmailsPhones()},methods:{getEmailsPhones:function(){var t=this;this.questionnaires.forEach(function(e){t.apiService.getEmailsPhones({token:t.token,contactId:e.data.models.personal.id.origin}).then(function(e){void 0!==e.emailsMobilePhoneContactsRelationed&&(t.contactsRelationed=e.emailsMobilePhoneContactsRelationed),t.setEmailsPhones()})})},setEmailsPhones:function(){var t=this;this.contactsRelationed.forEach(function(e){null!==e.email&&void 0!==e.email&&""!==e.email&&-1===t.listEmails.map(function(t){return t.email}).indexOf(e.email)&&t.listEmails.push({email:e.email,contactName:e.name}),"on"===e.isMobile&&""!==e.phone&&null!==e.phone&&void 0!==e.phone&&-1===t.listPhones.map(function(t){return t.phone}).indexOf(e.phone)&&(e.phone=e.phone.replace(/-/g,""),t.listPhones.push({phone:e.phone,contactName:e.name}))})},changeDueDate:function(t){this.dateExpire=t.shortDate,this.daysExpire=1-ct()().diff(t.shortDate,"days")},showEmail:function(){this.isShowEmail=document.getElementById("checkemail").checked},showSms:function(){this.isShowSms=document.getElementById("checksms").checked},addSms:function(){-1===this.smsSelected.indexOf(this.smsClient)&&this.smsSelected.length<8&&this.smsSelected.push("("+this.ctryCode+") "+this.smsClient),this.smsClient="",this.modelSelectSms=""},changeSelectEmail:function(t){var e=this,n=t.target.value;this.emailClient=n,this.isValidEmail=!1,document.getElementById("emailSend").classList.forEach(function(t){e.isValidEmail="is-invalid"!==t})},changeSelectSms:function(t){var e=this,n=t.target.value;this.smsClient=n,this.isValidPhone=!1,document.getElementById("phoneSend").classList.forEach(function(t){e.isValidPhone="is-invalid"!==t})},addEmail:function(){!0===/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(this.emailClient).toLowerCase())&&-1===this.emailSelected.indexOf(this.emailClient)&&this.emailSelected.length<8&&this.emailSelected.push(this.emailClient),this.emailClient="",this.modelSelectEmail=""},deleteSms:function(t){this.smsSelected.splice(t,1)},deleteEmail:function(t){this.emailSelected.splice(t,1)},confirmSendQuestionnaire:function(){var t=this;if(""===this.emailSelected)alert("You can`t send questionnaire. First set an email");else if(""===this.dateExpire)alert("You can`t send questionnaire. First set due date");else{this.isSent=!0,document.getElementById("contentModal").classList.add("disableWindow"),this.smsSelected.forEach(function(e,n){e=(e=(e=(e=e.replace(/-/g,"")).replace(/\(/g,"")).replace(/\)/g,"")).replace(/ /gi,""),t.smsSelected[n]=e});var e={email:this.emailSelected,sms:this.smsSelected,questionnaireIds:this.questionnaires.map(function(t){return t.id}),expTime:this.dateExpire,note:this.questionnaireNote};this.apiService.sendCaseQuestionnaires({token:this.token,data:e}).then(function(e){if(null!==e.sendCaseQuestionnaires&&void 0!==e.sendCaseQuestionnaires){var n=[],i=e.sendCaseQuestionnaires.scope.caseQuestionnaires;if("string"!=typeof i&&void 0!==i.caseQuestionnairesIds&&null!==i.caseQuestionnairesIds){var a="";a=(n=i.caseQuestionnairesIds).length>1?"Questionnaires sent successfully.":"Questionnaire sent successfully.",t.$emit("show-pop-up",a);var o={token:t.token,questionnaireIds:n,status:"Sent to the client"};t.apiService.updateCaseQuestionnairesStatus(o).then(function(t){popupNotification.show("Questionnaire status updated","success")})}}else t.$emit("show-pop-up","Ocurred an error try again.");t.$emit("close")})}}}},Ll={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("transition",{attrs:{name:"modal"}},[n("div",{staticClass:"modal-maskMainSend"},[n("div",{staticClass:"modal-wrapperMainSend"},[n("div",{staticClass:"modal-containerMainSend"},[n("div",{staticClass:"modal-header",staticStyle:{"border-radius":"0px !important"}},[n("div",{staticClass:"col-12 pl-0 pr-0"},[n("h3",{staticStyle:{"font-size":"17px"}},[t._v("Send Questionnaire "),n("span",{staticClass:"sendClose float-right",on:{click:function(e){return t.$emit("close")}}},[t._v("X")])])])]),t._v(" "),n("div",{staticClass:"modal-body"},[n("div",{attrs:{id:"contentModal"}},[n("h6",{staticStyle:{"font-weight":"bold !important"}},[n("b",[t._v("Information")])]),t._v(" "),n("table",{staticClass:"table myTabletd table-bordered table-main table-striped"},[n("thead",[n("tr",[n("th",[t._v("Name")]),t._v(" "),n("th",[t._v("Forms")])])]),t._v(" "),n("tbody",t._l(t.questionnaires,function(e,i){return n("tr",{key:i},[n("td",[n("b",[t._v(t._s(e.contactName))])]),t._v(" "),n("td",t._l(e.forms,function(i,a){return n("span",{key:a},[t._v("\n                        "+t._s(i.name)),Object.keys(e.forms).length>a+1?n("span",[t._v(", ")]):t._e()])}),0)])}),0)]),t._v(" "),n("hr"),t._v(" "),n("h6",{staticStyle:{"font-weight":"bold !important"}},[n("b",[t._v("Due Date")])]),t._v(" "),n("pf-calendar",{attrs:{sensitiveRange:t.dateToday,id:"due-date-expire",mask:"##/##/####",name:"due-date-expire"},on:{change:t.changeDueDate},model:{value:t.dateExpire,callback:function(e){t.dateExpire=e},expression:"dateExpire"}}),t._v(" "),0!==t.daysExpire?n("label",[n("b",[t._v("Questionnaire link expires in: "+t._s(t.daysExpire)+" Days")])]):t._e(),t._v(" "),n("hr"),t._v(" "),n("h6",{staticStyle:{"font-weight":"bold !important"}},[n("b",[t._v("Note")])]),t._v(" "),n("pf-text-area",{attrs:{placeholder:"Please include any message you would like to send to your client via Email or Text Message."},model:{value:t.questionnaireNote,callback:function(e){t.questionnaireNote=e},expression:"questionnaireNote"}}),t._v(" "),n("hr"),t._v(" "),n("h6",{staticStyle:{"font-weight":"bold !important"}},[n("b",[t._v("Destination")])]),t._v(" "),n("pf-checkbox",{attrs:{id:"checkemail",label:"Email",styleLabel:"font-size: 14pt;",checked:t.isShowEmail},on:{click:t.showEmail}}),t._v(" "),t.isShowEmail?n("div",{staticClass:"row mb-2"},[n("div",{staticClass:"col-12"},[n("div",{staticClass:"input-group myInputsGroup",style:!1===t.isValidEmail?"margin-bottom: 30px;":"margin-bottom: 10px;"},[n("div",{staticClass:"select-editable"},[n("input",{directives:[{name:"model",rawName:"v-model",value:t.emailClient,expression:"emailClient"},{name:"validate",rawName:"v-validate",value:{email:!0},expression:"{ email: true }"}],attrs:{id:"emailSend",name:"emailSend",type:"email"},domProps:{value:t.emailClient},on:{input:function(e){e.target.composing||(t.emailClient=e.target.value)}}}),t._v(" "),n("select",{directives:[{name:"model",rawName:"v-model",value:t.modelSelectEmail,expression:"modelSelectEmail"}],staticClass:"custom-select styleCustomSelect",on:{change:[function(e){var n=Array.prototype.filter.call(e.target.options,function(t){return t.selected}).map(function(t){return"_value"in t?t._value:t.value});t.modelSelectEmail=e.target.multiple?n:n[0]},t.changeSelectEmail]}},[n("option",{domProps:{value:""}},[t._v("None")]),t._v(" "),t._l(t.listEmails,function(e,i){return n("option",{key:i,domProps:{value:e.email}},[t._v(t._s(e.contactName+" ( "+e.email+" )"))])})],2),t._v(" "),t.errors.first("emailSend")?n("span",{staticStyle:{position:"absolute",top:"40px","font-size":"8pt",color:"red","margin-bottom":"0px"}},[t._v("\n                        "+t._s(t.errors.first("emailSend").replace("emailSend","")))]):t._e()]),t._v(" "),!0===t.isValidEmail?n("div",{staticClass:"input-group-append"},[n("button",{staticClass:"btn btn-success",attrs:{type:"button"},on:{click:t.addEmail}},[t._v("Add")])]):t._e()])]),t._v(" "),t.emailSelected.length>0?n("div",{staticClass:"ml-3 contentEmail",staticStyle:{overflow:"auto"}},t._l(t.emailSelected,function(e,i){return n("p",{key:i,staticClass:"pContenEmail",staticStyle:{"white-space":"nowrap"}},[n("i",{staticClass:"fas fa-circle",staticStyle:{color:"rgb(51, 156, 32)","font-size":"10pt"}}),t._v(" "+t._s(e)+" "),n("span",{on:{click:function(e){return t.deleteEmail(i)}}},[n("i",{staticClass:"fa fa-times",staticStyle:{color:"red",cursor:"pointer"}})])])}),0):t._e()]):t._e(),t._v(" "),n("hr"),t._v(" "),n("pf-checkbox",{attrs:{id:"checksms",label:"SMS",styleLabel:"font-size: 14pt;",checked:t.isShowSms},on:{click:t.showSms}}),t._v(" "),t.isShowSms?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12",staticStyle:{display:"flex"}},[n("label",{staticStyle:{width:"90px"},attrs:{for:""}},[t._v("Ctry. Code")]),t._v(" "),n("label",{attrs:{for:""}},[t._v("Phone Number")])]),t._v(" "),n("div",{staticClass:"col-12",staticStyle:{display:"flex"}},[n("input",{directives:[{name:"model",rawName:"v-model",value:t.ctryCode,expression:"ctryCode"}],staticClass:"form-control",staticStyle:{width:"90px"},attrs:{type:"text"},domProps:{value:t.ctryCode},on:{input:function(e){e.target.composing||(t.ctryCode=e.target.value)}}}),t._v(" "),n("div",{staticClass:"input-group myInputsGroup",style:!1===t.isValidPhone?"margin-bottom: 30px;":"margin-bottom: 10px;"},[n("div",{staticClass:"select-editable"},[n("input",{directives:[{name:"model",rawName:"v-model",value:t.smsClient,expression:"smsClient"},{name:"validate",rawName:"v-validate",value:{min:8},expression:"{ min: 8 }"}],attrs:{id:"phoneSend",type:"text",name:"phoneSend",value:""},domProps:{value:t.smsClient},on:{input:function(e){e.target.composing||(t.smsClient=e.target.value)}}}),t._v(" "),n("select",{directives:[{name:"model",rawName:"v-model",value:t.modelSelectSms,expression:"modelSelectSms"}],staticClass:"custom-select styleCustomSelect",on:{change:[function(e){var n=Array.prototype.filter.call(e.target.options,function(t){return t.selected}).map(function(t){return"_value"in t?t._value:t.value});t.modelSelectSms=e.target.multiple?n:n[0]},t.changeSelectSms]}},[n("option",{domProps:{value:""}},[t._v("None")]),t._v(" "),t._l(t.listPhones,function(e,i){return n("option",{key:i,domProps:{value:e.phone}},[t._v(t._s(e.contactName+" ( "+e.phone+" )"))])})],2),t._v(" "),t.errors.first("phoneSend")?n("span",{staticStyle:{position:"absolute",top:"40px","font-size":"8pt",color:"red","margin-bottom":"0px"}},[t._v("\n                        "+t._s("Use country code without the +. "+t.errors.first("phoneSend").replace("phoneSend","")))]):t._e()]),t._v(" "),!0===t.isValidPhone?n("div",{staticClass:"input-group-append"},[n("button",{staticClass:"btn btn-success",attrs:{type:"button"},on:{click:t.addSms}},[t._v("Add")])]):t._e()])]),t._v(" "),t.smsSelected.length>0?n("div",{staticClass:"ml-3 contentsms",staticStyle:{overflow:"auto"}},t._l(t.smsSelected,function(e,i){return n("p",{key:i,staticClass:"pContensms",staticStyle:{"white-space":"nowrap"}},[n("i",{staticClass:"fas fa-circle",staticStyle:{color:"rgb(51, 156, 32)","font-size":"10pt"}}),t._v(" "+t._s(e)+" "),n("span",{on:{click:function(e){return t.deleteSms(i)}}},[n("i",{staticClass:"fa fa-times",staticStyle:{color:"red",cursor:"pointer"}})])])}),0):t._e()]):t._e()],1)]),t._v(" "),!0===t.isShowEmail&&t.emailSelected.length>0||!0===t.isShowSms&&t.smsSelected.length>0?n("div",{staticClass:"modal-footer"},[n("button",{staticClass:"btn btn-success",on:{click:t.confirmSendQuestionnaire}},[!1===t.isSent?n("span",[t._v("Send")]):t._e(),t._v(" "),!0===t.isSent?n("span",[n("span",{staticClass:"spinner-border spinner-border-sm mr-1",attrs:{role:"status","aria-hidden":"true"}}),t._v("\n                Loading...\n              ")]):t._e()])]):t._e()])])])])},staticRenderFns:[]};var jl=n("VU/8")(Tl,Ll,!1,function(t){n("w1e3")},null,null).exports,Pl={name:"pf-questionnaire",data:function(){return{isModal:!1,isModalSend:!1,isAllCheckMain:!1,apiService:null,caseQuestionnaires:[],questionnairesSelected:[],questionnairesToSend:[],isPopUp:!1,questionnairesToDelete:[],titlePopUp:"",messagePopUp:"",typePopUp:"",actionPopUp:"",isBulkAction:!1,isSpinner:!0,quizes:[],questionnaires:[],forms:[],contacts:[],tooltips:[],isLogo:!1}},props:{caseid:{type:Number},token:{type:String},isEnableClientPortal:{type:Boolean},isCaseShared:{type:Boolean}},mixins:[Sl],components:{PfQuestionnaireModal:Ol,PfSendQuestionnaireModal:jl,PfPopUp:$,PfSpinner:r},mounted:function(){var t=this;this.getListQuestionnaire(),this.questionnaires.forEach(function(e,n){!0===e.generate&&t.changeColor({idCheck:"ch-q-main"+n,idContent:"tr-q-main"+n,questionnaireId:e.id})}),this.quizes.forEach(function(e,n){!0===e.generate&&t.changeColor({idCheck:"ch-z-main"+n,idContent:"tr-z-main"+n,quizId:e.id})}),this.apiService=Tt},methods:{getListQuestionnaire:function(){var t=this;this.titlePopUp="",this.messagePopUp="",this.typePopUp="",this.actionPopUp="",this.isPopUp=!1,Tt.getListCaseQuestionnaires({token:this.token,caseId:this.caseid}).then(function(e){void 0!==e.caseQuestionnaires&&(t.caseQuestionnaires=e.caseQuestionnaires),t.caseQuestionnaires.forEach(function(e,n){e.updatedAt=ct()(e.updatedAt).format("MM/DD/YYYY"),t.caseQuestionnaires[n]=e;var i="";e.forms.forEach(function(t){t.roles.forEach(function(e){i=i+e+"\n  "+t.name+"\n"})}),t.tooltips.push(i)}),0===t.caseQuestionnaires.length&&(t.isBulkAction=!1),t.isSpinner=!1})},setValueAllMain:function(t){this.caseQuestionnaires.forEach(function(e){e.generate=t.value}),!0===t.value?this.questionnairesSelected.push({id:this.caseQuestionnaires[t.index]._id,contactName:this.caseQuestionnaires[t.index].models.personal.firstName.origin+" "+this.caseQuestionnaires[t.index].models.personal.middleName.origin+" "+this.caseQuestionnaires[t.index].models.personal.lastName.origin,forms:this.caseQuestionnaires[t.index].forms,contactsRelationed:this.caseQuestionnaires[t.index].contactsRelationed,data:this.caseQuestionnaires[t.index]}):this.questionnairesSelected=[],this.questionnairesSelected.length>=2?this.isBulkAction=!0:this.isBulkAction=!1,this.quizes.forEach(function(e){e.generate=t.value})},setValueQuestionnaire:function(t){var e=this;!1===t.value&&(this.isAllCheckMain=!1),this.caseQuestionnaires.forEach(function(n){n._id===t.questionnaireId&&(n.generate=t.value,!0===t.value?e.questionnairesSelected.push({id:n._id,contactName:n.models.personal.firstName.origin+" "+n.models.personal.middleName.origin+" "+n.models.personal.lastName.origin,forms:n.forms,contactsRelationed:n.contactsRelationed,data:n}):e.questionnairesSelected.splice(e.questionnairesSelected.indexOf(t.questionnaireId),1))}),this.questionnairesSelected.length>=2?this.isBulkAction=!0:this.isBulkAction=!1},setValueQuiz:function(t){!1===t.value&&(this.isAllCheckMain=!1),this.quizes.forEach(function(e){e.id===t.quizId&&(e.generate=t.value)})},showModalGenerate:function(){this.isModal=!0,this.revertBulkAction()},revertBulkAction:function(){null!==document.getElementById("allCheck")&&(!0===document.getElementById("allCheck").checked?document.getElementById("allCheck").click():(document.getElementById("allCheck").click(),document.getElementById("allCheck").click()))},setCreatedQuestionnaires:function(t){var e;t.forEach(function(e,n){e.updatedAt=ct()(Date(e.updatedAt)).format("MM/DD/YYYY"),t[n]=e}),e=this.caseQuestionnaires.concat(t),this.caseQuestionnaires=[],this.caseQuestionnaires=e},sendQuestionnaire:function(t){this.questionnairesToSend=[t],this.isModalSend=!0},sendQuestionnaires:function(){this.questionnairesToSend=this.questionnairesSelected,0===this.questionnairesToSend.length?alert("You must select questionnaires"):this.isModalSend=!0},showPopUp:function(t){this.messagePopUp=t,this.titlePopUp="",this.isLogo=!0,this.messagePopUp=t,this.typePopUp="info",this.actionPopUp="status",this.isPopUp=!0},deleteQuestionnaire:function(t){this.questionnairesToDelete.push(t.questionnaire._id),this.titlePopUp="Are you sure you want to delete this questionnaire (#"+t.numQ+").?",this.typePopUp="danger",this.actionPopUp="delete",this.isLogo=!1,this.isPopUp=!0,this.revertBulkAction()},deleteAllQuestionnaires:function(){var t=this.questionnairesSelected.length===this.caseQuestionnaires.length?"All":this.questionnairesSelected.length;this.titlePopUp="Are you sure you want to delete "+t+" questionnaires.?",this.typePopUp="danger",this.actionPopUp="deleteAll",this.isLogo=!1,this.isPopUp=!0},confirmDelete:function(){var t=this;Tt.deleteCaseQuestionnaires({token:this.token,questionnaireIds:this.questionnairesToDelete}).then(function(e){t.getListQuestionnaire(),t.titlePopUp="",t.messagePopUp="",t.typePopUp="",t.actionPopUp="",t.questionnairesToDelete=[],t.isPopUp=!1,document.getElementById("bodyTable").querySelectorAll("tr").forEach(function(t){t.style.backgroundColor=""}),t.revertBulkAction()})},setActionPopUp:function(){var t=this;"status"===this.actionPopUp?this.getListQuestionnaire():"delete"===this.actionPopUp?this.confirmDelete():"deleteAll"===this.actionPopUp&&(this.questionnairesToDelete=[],this.questionnairesSelected.forEach(function(e){t.questionnairesToDelete.push(e.id)}),this.confirmDelete(),this.isBulkAction=!1)},goToComparing:function(t){window.open(window.reviewUrl+"?token="+this.token+"&qId="+t,"comparingViewver","status=yes, toolbar=no, menubar=no, location=no, addressbar=no")},showMore:function(t){document.getElementById(t).classList.add("d-none"),-1!==t.indexOf("showmore")?document.getElementById(t.replace("showmore","showless")).classList.remove("d-none"):document.getElementById(t.replace("showless","showmore")).classList.remove("d-none")},toLandingPage:function(t){window.open(window.landingUrl+"?token="+t+"&type=attorney")},shareClientPortal:function(t){this.isEnableClientPortal?this.isCaseShared?Tt.enableCaseQuestionnaireClientPortal(this.token,t._id,!t.clientPortal).then(function(e){if(e.data.caseQuestionnaireEnableClientPortal&&null!==e.data.caseQuestionnaireEnableClientPortal){var n=e.data.caseQuestionnaireEnableClientPortal.clientPortal;t.clientPortal=n,n?popupNotification.show("Questionnaire shared successfully.","success"):popupNotification.show("Questionnaire unshared","warning")}else if(e.errors&&null!==e.errors){var i=e.errors[0].message;popupNotification.show(i,"error")}else popupNotification.show("Server error when sharing questionnaire in Client Portal.","error")}):showClientPortalPopup("You must share case in order share questionnaires."):showClientPortalPopup("You must enable the Client Portal on the contact page later share case in order share questionnaires.")}}},Fl={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[n("div",{staticClass:"row myRow"},[n("div",{staticClass:"col-12"},[!0===t.isBulkAction?n("div",{staticClass:"dropdown d-inline"},[n("button",{staticClass:"btn btn-sm btn-primary dropdown-toggle",staticStyle:{height:"unset !important"},attrs:{type:"button","data-toggle":"dropdown"}},[t._v("\n          Bulk Actions\n        ")]),t._v(" "),n("div",{staticClass:"dropdown-menu"},[n("a",{staticClass:"dropdown-item",attrs:{href:"#"},on:{click:t.sendQuestionnaires}},[t._v("Send to")]),t._v(" "),n("a",{staticClass:"dropdown-item",attrs:{href:"#"},on:{click:t.deleteAllQuestionnaires}},[t._v("Delete")])])]):t._e(),t._v(" "),!1===t.isSpinner?n("button",{staticClass:"btn-success btn btn-sm spaaceResponsiveTop d-inline",attrs:{id:"openModal",type:"button btn-sm"},on:{click:t.showModalGenerate}},[t._v("Generate Questionnaire\n      ")]):t._e()]),t._v(" "),!0===t.isSpinner?n("pf-spinner",{attrs:{color:"black"}}):!1===t.isSpinner?n("div",{staticClass:"col-12 mt-3 scrollTable"},[n("table",{staticClass:"table myTabletd table-bordered table-main table-striped"},[n("thead",[n("tr",[n("th",{staticClass:"widthchecktable",staticStyle:{"padding-top":"20px !important","padding-right":"15px !important"}},[t.caseQuestionnaires.length>0?n("pf-checkbox",{attrs:{classElement:"checktable",id:"allCheck",classComponent:["updateFormGroup","myTd"],checked:t.isAllCheckMain},on:{click:function(e){return t.setAllCheck({classTable:"table-main",id:"allCheck"})}}}):t._e()],1),t._v(" "),n("th",[t._v("No")]),t._v(" "),n("th",[t._v("Contact")]),t._v(" "),n("th",[t._v("Information")]),t._v(" "),n("th",[t._v("Last Activity")]),t._v(" "),n("th",[t._v("Status")]),t._v(" "),n("th",[t._v("Action")])])]),t._v(" "),n("tbody",{attrs:{id:"bodyTable"}},[0===t.caseQuestionnaires.length?n("tr",[n("th",{attrs:{colspan:"7"}},[n("center",[t._v('You have not generated any questionnaires yet. Please select who fills which roles for the forms and then click the "Generate Questionnaire" button to begin.')])],1)]):n("tr",[n("th",{staticClass:"bgcolorhead2",attrs:{colspan:"7"}},[t._v("Questionnaire")])]),t._v(" "),t._l(t.caseQuestionnaires,function(e,i){return n("tr",{key:"q"+i,staticClass:"tr-check",attrs:{id:"tr-q-main"+i}},[n("td",[n("pf-checkbox",{attrs:{classElement:"checktable",id:"ch-q-main"+i,classComponent:"updateFormGroup",checked:e.generate},on:{click:function(n){return t.changeColor({idCheck:"ch-q-main"+i,idContent:"tr-q-main"+i,questionnaireId:e._id})}}})],1),t._v(" "),n("td",[t._v("\n              "+t._s(i+1)+"\n            ")]),t._v(" "),n("td",[e.models&&Object.keys(e.models).length>0?n("div",[t._v("\n                "+t._s(e.models.personal.firstName.origin+" "+e.models.personal.middleName.origin+" "+e.models.personal.lastName.origin)+"\n              ")]):t._e()]),t._v(" "),n("td",[e.forms&&e.forms.length>0?n("div",[t._l(e.forms,function(i,a){return n("div",{key:"f"+a},t._l(i.roles,function(o,r){return n("div",{key:r},[0===a&&r<2?n("div",[n("b",[t._v(t._s(o)+":"),n("br")]),t._v(" "),n("div",{staticClass:"ml-3"},[t._v("\n                        "+t._s(i.name)+"\n                      ")])]):r<2&&a<2&&e.forms[a-1].roles.length<2?n("div",[n("b",[t._v(t._s(o)+":"),n("br")]),t._v(" "),n("div",{staticClass:"ml-3"},[t._v("\n                        "+t._s(i.name)+"\n                      ")])]):t._e()])}),0)}),t._v(" "),e.forms[0].roles.length>2||e.forms.length>2?n("div",[n("div",{staticClass:"accordion"},[n("span",{staticClass:"float-right",attrs:{id:i+"showmore","data-toggle":"collapse","data-target":"#roleQuestionnairesMain"+i},on:{click:function(e){return t.showMore(i+"showmore")}}},[n("h6",{staticClass:"showMoreMain",attrs:{"data-toggle":"tooltip","data-placement":"bottom",title:t.tooltips[i]}},[t._v("Show More...")])]),t._v(" "),n("span",{staticClass:"float-right d-none",attrs:{id:i+"showless","data-toggle":"collapse","data-target":"#roleQuestionnairesMain"+i},on:{click:function(e){return t.showMore(i+"showless")}}},[n("h6",{staticClass:"showMoreMain"},[t._v("Show Less...")])])]),t._v(" "),n("div",{staticClass:"collapse",attrs:{id:"roleQuestionnairesMain"+i}},t._l(e.forms,function(i,a){return n("div",{key:"faccordion"+a},t._l(i.roles,function(o,r){return n("div",{key:r},[0===a&&e.forms[0].roles.length>2&&r>1?n("div",[n("b",[t._v(t._s(o)+":"),n("br")]),t._v(" "),n("div",{staticClass:"ml-3"},[t._v("\n                            "+t._s(i.name)+"\n                          ")])]):t._e(),t._v(" "),e.forms[0].roles.length>=2&&a>=1?n("div",[n("b",[t._v(t._s(o)+":"),n("br")]),t._v(" "),n("div",{staticClass:"ml-3"},[t._v("\n                            "+t._s(i.name)+"\n                          ")])]):a>1?n("div",[n("b",[t._v(t._s(o)+":"),n("br")]),t._v(" "),n("div",{staticClass:"ml-3"},[t._v("\n                            "+t._s(i.name)+"\n                          ")])]):t._e()])}),0)}),0)]):t._e()],2):t._e()]),t._v(" "),n("td",[t._v(t._s(e.updatedAt))]),t._v(" "),n("td",[t._v(t._s("Sent to the client"===e.status?"Sent":e.status))]),t._v(" "),n("td",[n("span",["Sent to the client"===e.status||"Opened by the client"===e.status||"Opened by the attorney"===e.status?n("span",[n("a",{attrs:{href:"#"},on:{click:function(n){return t.toLandingPage(e.token.accessToken)}}},[t._v("View\n                  ")]),t._v(" |\n                ")]):t._e(),t._v(" "),"Accepted and imported into case"!==e.status?n("a",{attrs:{href:"#"},on:{click:function(n){return t.sendQuestionnaire({id:e._id,contactName:e.models.personal.firstName.origin+" "+e.models.personal.middleName.origin+" "+e.models.personal.lastName.origin,forms:e.forms,contactsRelationed:e.contactsRelationed,data:e})}}},[t._v("Send\n                ")]):t._e(),"Accepted and imported into case"!==e.status?n("span",[t._v(" | ")]):t._e(),t._v(" "),n("a",{attrs:{href:"#"},on:{click:function(n){return t.deleteQuestionnaire({questionnaire:e,numQ:i+1})}}},[t._v("Delete\n                ")]),t._v(" "),"Pending attorney review"===e.status?n("span",[t._v(" |\n                  "),n("a",{attrs:{href:"#"},on:{click:function(n){return t.goToComparing(e._id)}}},[t._v("Review")])]):t._e(),t._v(" "),n("span",[t._v(" |\n                  "),n("a",{class:e.clientPortal&&t.isEnableClientPortal&&t.isCaseShared?"textColorSuccess":"",on:{click:function(n){return t.shareClientPortal(e)}}},[n("i",{staticClass:"fas fa-universal-access"}),t._v("\n                    "+t._s(e.clientPortal&&t.isEnableClientPortal&&t.isCaseShared?"Shared":"Share in Client Portal")+"\n                  ")])])])])])}),t._v(" "),t.quizes.length>0?n("tr",[n("th",{staticClass:"bgcolorhead2",attrs:{colspan:"7"}},[t._v("Quiz")])]):t._e(),t._v(" "),t._l(t.quizes,function(e,i){return n("tr",{key:"z"+i,staticClass:"tr-check",attrs:{id:"tr-z-main"+i}},[n("td",[n("pf-checkbox",{attrs:{classElement:"checktable",id:"ch-z-main"+i,checked:e.generate,classComponent:"updateFormGroup"},on:{change:function(n){return t.changeColor({idCheck:"ch-z-main"+i,idContent:"tr-z-main"+i,quizId:e.id})}}})],1),t._v(" "),n("td",[t._v(t._s(e.id))]),t._v(" "),n("td",{attrs:{colspan:"2"}},[t._v("\n              "+t._s(e.name)+"\n            ")]),t._v(" "),n("td",[t._v(t._s(e.lastActivity))]),t._v(" "),n("td",[t._v(t._s(e.status))]),t._v(" "),n("td",[n("span",[n("a",{attrs:{href:"#"}},[t._v("Send")]),t._v(" |\n                "),n("a",{attrs:{href:"#"}},[t._v("Delete ")]),t._v(" "),"Ready to review"===e.status?n("span",[t._v("|\n                  "),n("a",{attrs:{href:"#"}},[t._v("Review")])]):t._e()])])])})],2)])]):n("div",{staticClass:"ml-3 mt-4"},[n("label",[t._v('You have not generated any questionnaires yet. Please select who fills which roles for the forms and then click the "Generate Questionnaire" button to begin.')])])],1),t._v(" "),!0===t.isModal?n("pf-questionnaire-modal",{attrs:{forms:t.forms,contacts:t.contacts,caseId:t.caseid,apiService:t.apiService,token:t.token},on:{close:function(e){t.isModal=!1},addquestionnaires:t.setCreatedQuestionnaires}}):t._e(),t._v(" "),!0===t.isModalSend?n("pf-send-questionnaire-modal",{attrs:{questionnaires:t.questionnairesToSend,token:t.token,apiService:t.apiService},on:{close:function(e){t.isModalSend=!1},"show-pop-up":t.showPopUp}}):t._e(),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:t.titlePopUp,message:t.messagePopUp,type:t.typePopUp,logo:t.isLogo},on:{close:function(e){t.isPopUp=!1},action:t.setActionPopUp}}):t._e()],1)},staticRenderFns:[]};var Yl=n("VU/8")(Pl,Fl,!1,function(t){n("9H6R")},null,null).exports,Rl=n("w/TU"),Hl=n.n(Rl),$l={name:"pf-flow",data:function(){return{drag:!1,flows:[{_id:332,caseTypeId:1,step:"Provide Checklist dsds",purpose:"Let client know what documents they will need to bring",caseId:23,priority:1,createdAt:"23-07-2019"},{_id:333,caseTypeId:1,step:"Provide Checklist cvcvcv",purpose:"Let client know what documents they will need to bring",caseId:23,priority:1,createdAt:"23-07-2019"},{_id:334,caseTypeId:1,step:"Provide Checklist rtrtrt",purpose:"Let client know what documents they will need to bring",caseId:23,priority:1,createdAt:"23-07-2019"},{_id:335,caseTypeId:1,step:"Provide Checklist jkljklj",purpose:"Let client know what documents they will need to bring",caseId:23,priority:1,createdAt:"23-07-2019"},{_id:336,caseTypeId:1,step:"Provide Checklist asasas",purpose:"Let client know what documents they will need to bring",caseId:23,priority:1,createdAt:"23-07-2019"}],isPopUp:!1,titlePopUp:"",messagePopUp:"",typePopUp:"",actionPopUp:"",indexFlowDelete:-1,newFlow:"",isModal:!1,btnRight:"",practiceAreas:[{_id:1,name:"Migration",label:"Migration"},{_id:2,name:"Michigan",label:"Michigan"}],pAreaSelected:{},caseTypes:[{_id:1,name:"I-130 Petition for Alien Relative",label:"I-130 Petition for Alien Relative",practiceArea:1},{_id:2,name:"AR-11 Update Address With USCIS",label:"AR-11 Update Address With USCIS",practiceArea:1},{_id:3,name:"I-290B - Appeal of USCIS Decision",label:"I-290B - Appeal of USCIS Decision",practiceArea:1},{_id:4,name:"Michigan - Misc.",label:"Michigan - Misc.",practiceArea:2},{_id:5,name:"California - Misc.",label:"California - Misc.",practiceArea:3},{_id:6,name:"California Family Law / Dissolution / Legal Separation and Annulment",label:"California Family Law / Dissolution / Legal Separation and Annulment",practiceArea:3}],caseTypeSelected:{},isRemoveBeforeImport:!1}},components:{PfCheckbox:x,PfButton:d,draggable:Hl.a,PfPopUp:$,PfModal:Dl,vSelect:y.a},computed:{dragOptions:function(){return{animation:200,group:"description",disabled:!1,ghostClass:"ghost"}},myFlows:{get:function(){return this.flows},set:function(t){this.flows=t}}},methods:{addFlow:function(){if(""!==this.newFlow){var t={_id:Math.random("23"),step:this.newFlow,purpose:"Let client know what documents they will need to bring",caseId:23,priority:1,createdAt:"23-07-2019"};this.flows.push(t),this.newFlow=""}},setActionPopUp:function(){"confirmDelete"===this.actionPopUp&&this.confirmDelete(),this.isPopUp=!1},deleteFlow:function(t){this.indexFlowDelete=t,this.isPopUp=!0,this.titlePopUp="Are you sure ?",this.messagePopUp="Are you sure you want to delete this case flow ?",this.typePopUp="danger",this.actionPopUp="confirmDelete"},confirmDelete:function(){this.flows.splice(this.indexFlowDelete,1)},importFlow:function(){this.isModal=!1},printFlows:function(){console.log("Print flows"),console.log(this.flows)},isOdd:function(t){if(t%2==0)return!0},closeModal:function(){this.isPopUp=!1}}},zl={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[n("div",{staticClass:"row mt-3 mb-3"},[n("div",{staticClass:"col-md-8 spaceBotton"},[n("div",{staticClass:"input-group"},[n("input",{directives:[{name:"model",rawName:"v-model",value:t.newFlow,expression:"newFlow"}],staticClass:"form-control form-control-sm",attrs:{type:"text",placeholder:"Add new flow item here"},domProps:{value:t.newFlow},on:{keyup:function(e){return!e.type.indexOf("key")&&t._k(e.keyCode,"enter",13,e.key,"Enter")?null:t.addFlow.apply(null,arguments)},input:function(e){e.target.composing||(t.newFlow=e.target.value)}}}),t._v(" "),n("div",{staticClass:"input-group-append"},[n("pf-button",{staticClass:"btn-success",attrs:{styleButton:""===t.newFlow?"pointer-events: none !important;":"",type:"button",label:"Add",id:"addFlow",isSuccess:!0},on:{click:t.addFlow}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("button",{staticClass:"btn btn-sm btn-success float-right",on:{click:function(e){t.isModal=!0}}},[t._v("Import")])])]),t._v(" "),n("hr",{staticClass:"hrFlow"}),t._v(" "),n("draggable",t._b({staticClass:"list-group",on:{start:function(e){t.drag=!0},end:function(e){t.drag=!1}},model:{value:t.myFlows,callback:function(e){t.myFlows=e},expression:"myFlows"}},"draggable",t.dragOptions,!1),[n("transition-group",{attrs:{type:"transition",name:t.drag?null:"flip-list"}},t._l(t.flows,function(e,i){return n("div",{key:e._id},[n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-10 col-lg-11 topCheck"},[n("pf-checkbox",{attrs:{id:String(e._id),label:e.step,classElement:"inputLine",classLabel:"text-justify line-through"}})],1),t._v(" "),n("div",{staticClass:"col-md-2 col-lg-1"},[n("button",{staticClass:"btn btn-sm btn-danger float-right",attrs:{type:"button"},on:{click:function(e){return t.deleteFlow(i)}}},[t._v("Delete")])])]),t._v(" "),n("hr",{staticClass:"hrFlow"})])}),0)],1),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-12"},[n("button",{staticClass:"btn btn-sm btn-success",on:{click:t.printFlows}},[t._v("Print")])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:t.titlePopUp,message:t.messagePopUp,type:t.typePopUp},on:{close:t.closeModal,action:t.setActionPopUp}}):t._e(),t._v(" "),!0===t.isModal?n("pf-modal",{attrs:{title:"Import Flow",noFirstHr:!0,btnright:null!==t.pAreaSelected&&Object.keys(t.pAreaSelected).length>0&&null!==t.caseTypeSelected&&Object.keys(t.caseTypeSelected).length>0?"Import":""},on:{close:function(e){t.isModal=!1},click:t.importFlow}},[n("template",{slot:"body"},[n("div",{staticClass:"row myRow"},[n("div",{staticClass:"col-12"},[n("div",{staticClass:"form-group"},[n("h6",[n("b",[t._v("Practice Area")])]),t._v(" "),n("v-select",{attrs:{options:t.practiceAreas},scopedSlots:t._u([{key:"option",fn:function(e){return[n("div",{staticClass:"p-2",class:{striped:!0}},[n("h5",[t._v(t._s(e.name))])])]}}],null,!1,4008954630),model:{value:t.pAreaSelected,callback:function(e){t.pAreaSelected=e},expression:"pAreaSelected"}})],1)])]),t._v(" "),n("div",{staticClass:"row myRow"},[n("div",{staticClass:"col-12"},[n("div",{staticClass:"form-group"},[n("h6",[n("b",[t._v("Case Type")])]),t._v(" "),n("v-select",{attrs:{options:t.caseTypes},scopedSlots:t._u([{key:"option",fn:function(e){return[n("div",{staticClass:"p-2",class:{striped:!0}},[n("h5",[t._v(t._s(e.name))])])]}}],null,!1,4008954630),model:{value:t.caseTypeSelected,callback:function(e){t.caseTypeSelected=e},expression:"caseTypeSelected"}})],1)])]),t._v(" "),null!==t.pAreaSelected&&Object.keys(t.pAreaSelected).length>0&&null!==t.caseTypeSelected&&Object.keys(t.caseTypeSelected).length>0?n("div",t._l(t.flows,function(e,i){return n("div",{key:i,staticClass:"ml-4 mr-4",class:{stripedDiv:t.isOdd(i)}},[n("div",{staticClass:"col-md-10 col-lg-11 topCheck pt-2 pb-2"},[n("pf-checkbox",{attrs:{id:e._id+"toImport",label:e.step,classLabel:"text-justify",styleLabel:""}})],1)])}),0):t._e()]),t._v(" "),null!==t.pAreaSelected&&Object.keys(t.pAreaSelected).length>0&&null!==t.caseTypeSelected&&Object.keys(t.caseTypeSelected).length>0?n("template",{slot:"footer"},[n("div",{staticStyle:{display:"inline-block"}},[n("pf-checkbox",{attrs:{label:"Remove current items before import.",styleLabel:"color:red;",classLabel:"text-justify",checked:t.isRemoveBeforeImport},on:{click:function(e){t.isRemoveBeforeImport=!t.isRemoveBeforeImport}}})],1)]):t._e()],2):t._e()],1)},staticRenderFns:[]};var Xl=n("VU/8")($l,zl,!1,function(t){n("HILN"),n("bE1x")},"data-v-fb0144a4",null).exports,Vl={name:"pf-checklist",data:function(){return{drag:!1,newChecklist:"",checklists:[{_id:442,caseTypeId:1,completed:0,name:"Provide Checklist dsds new check list list for check",caseId:23,createdAt:"23-07-2019",files:[]},{_id:443,caseTypeId:1,completed:0,name:"Provide Checklist money to case",caseId:23,createdAt:"23-07-2019",files:[]},{_id:444,caseTypeId:1,completed:0,name:"Provide Checklist immigrant check list order",caseId:23,createdAt:"23-07-2019",files:[]},{_id:445,caseTypeId:1,completed:0,name:"Provide Checklist trouble so attorney",caseId:23,createdAt:"23-07-2019",files:[]},{_id:446,caseTypeId:1,completed:0,name:"Provide Checklist check list new form without authorization",caseId:23,createdAt:"23-07-2019",files:[]}],isPopUp:!1,titlePopUp:"",messagePopUp:"",typePopUp:"",actionPopUp:"",indexChecklistDelete:-1,isModal:!1,btnRight:"",practiceAreas:[{_id:1,name:"Migration",label:"Migration"},{_id:2,name:"Michigan",label:"Michigan"}],pAreaSelected:{},caseTypes:[{_id:1,name:"I-130 Petition for Alien Relative",label:"I-130 Petition for Alien Relative",practiceArea:1},{_id:2,name:"AR-11 Update Address With USCIS",label:"AR-11 Update Address With USCIS",practiceArea:1},{_id:3,name:"I-290B - Appeal of USCIS Decision",label:"I-290B - Appeal of USCIS Decision",practiceArea:1},{_id:4,name:"Michigan - Misc.",label:"Michigan - Misc.",practiceArea:2},{_id:5,name:"California - Misc.",label:"California - Misc.",practiceArea:3},{_id:6,name:"California Family Law / Dissolution / Legal Separation and Annulment",label:"California Family Law / Dissolution / Legal Separation and Annulment",practiceArea:3}],caseTypeSelected:{},isRemoveBeforeImport:!1,isModalUpload:!1,dragAndDropCapable:!1,files:[],uploadPercentage:0,valueProgress:75,formDataFiles:null,currentIndexFile:null,countFilesUploaded:0,isAllUploadFiles:!1,isModalView:!1,currentIndexUploadChecklist:null,currentFilesChecklist:[],isActionUpload:!1,cantFilesUploaded:0,currentViewFiles:[]}},components:{PfCheckbox:x,PfButton:d,draggable:Hl.a,PfPopUp:$,PfModal:Dl,vSelect:y.a,PfSpinner:r},computed:{dragOptions:function(){return{animation:200,group:"description",disabled:!1,ghostClass:"ghost"}}},methods:{addChecklist:function(){if(""!==this.newChecklist){var t={_id:Math.random("23"),caseTypeId:1,completed:0,name:this.newChecklist,caseId:23,createdAt:"23-07-2019",files:[]};this.checklists.push(t),this.newChecklist=""}},setActionPopUp:function(){"confirmDelete"===this.actionPopUp&&this.confirmDelete(),"confirmSendList"===this.actionPopUp&&this.confirmSendList(),this.isPopUp=!1},deleteChecklist:function(t){this.indexChecklistDelete=t,this.isPopUp=!0,this.titlePopUp="Are you sure ?",this.messagePopUp="Are you sure you want to delete this checklist ?",this.typePopUp="danger",this.actionPopUp="confirmDelete"},confirmDelete:function(){this.checklists.splice(this.indexChecklistDelete,1)},importChecklist:function(){this.isModal=!1},sendList:function(){this.isPopUp=!0,this.titlePopUp="Are you sure ?",this.messagePopUp="Create a note from checklist ?",this.typePopUp="confirm",this.actionPopUp="confirmSendList"},confirmSendList:function(){console.log("Send to list")},exhibitDividers:function(){console.log("Exhibit dividers")},printChecklist:function(){console.log("Print checklist")},sendByEmail:function(){console.log("Send by email")},showModalUpload:function(t){var e=this;this.isModalUpload=!0,this.countFilesUploaded=0,this.isAllUploadFiles=!1,this.currentIndexUploadChecklist=t,setTimeout(function(){e.dragDropFiles(),e.verifyForUpload()},100)},isOdd:function(t){if(t%2==0)return!0},closeModal:function(){this.isPopUp=!1},dragDropFiles:function(){this.dragAndDropCapable=this.determineDragAndDropCapable(),this.dragAndDropCapable&&(["drag","dragstart","dragend","dragover","dragenter","dragleave","drop"].forEach(function(t){this.$refs.fileform.addEventListener(t,function(t){t.preventDefault(),t.stopPropagation()}.bind(this),!1)}.bind(this)),this.$refs.fileform.addEventListener("drop",function(t){for(var e=0;e<t.dataTransfer.files.length;e++)t.dataTransfer.files[e].percentage=0,this.checklists[this.currentIndexUploadChecklist].files.push(t.dataTransfer.files[e]),this.verifyForUpload(),this.isAllUploadFiles=!1}.bind(this)))},determineDragAndDropCapable:function(){var t=document.createElement("div");return("draggable"in t||"ondragstart"in t&&"ondrop"in t)&&"FormData"in window&&"FileReader"in window},uploadFiles:function(){this.isAllUploadFiles=!0,this.isActionUpload=!0,this.formDataFiles=new FormData,this.countFilesUploaded<this.checklists[this.currentIndexUploadChecklist].files.length?this.uploadFile(this.countFilesUploaded):this.isActionUpload=!1},uploadFile:function(t){var e=this,n=this;this.currentIndexFile=t,document.getElementById("progress"+t).classList.remove("d-none"),this.formDataFiles=new FormData;var i=this.checklists[this.currentIndexUploadChecklist].files[t];this.countFilesUploaded++,!0!==i.uploaded?(this.formDataFiles.append("files["+t+"]",i),this.submitFiles().then(function(t){setTimeout(function(){n.checklists[n.currentIndexUploadChecklist].files[n.currentIndexFile].uploaded=!0,document.getElementById("progress"+n.currentIndexFile).valueProgress=100,n.uploadPercentage=0,document.getElementById("progress"+n.currentIndexFile).style.background="green",document.getElementById("progress"+n.currentIndexFile).style.border="None",e.uploadFiles()},500)})):this.uploadFiles()},submitFiles:function(){return wt.a.post("/file-drag-drop",this.formDataFiles,{headers:{"Content-Type":"multipart/form-data"},onUploadProgress:function(t){this.uploadPercentage=parseInt(Math.round(100*t.loaded/t.total))}.bind(this)}).then(function(t){return t}).catch(function(t){return t})},removeFile:function(t){this.checklists[this.currentIndexUploadChecklist].files.splice(t,1)},showModalBrowse:function(){document.getElementById("browseFiles").click()},fileSelected:function(t){this.checklists[this.currentIndexUploadChecklist].files.push(t.target.files[0]),this.verifyForUpload(),this.isAllUploadFiles=!1},showModalView:function(t){this.isModalView=!0,this.currentFilesChecklist=this.checklists[t].files.filter(function(t){return!0===t.uploaded})},verifyForUpload:function(){this.cantFilesUploaded=this.checklists[this.currentIndexUploadChecklist].files.map(function(t){return t.uploaded}).filter(function(t){return void 0===t||!1===t}).length}}},ql={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[n("div",{staticClass:"row mt-3 mb-3"},[n("div",{staticClass:"col-md-6 col-lg-7 spaceBotton"},[n("div",{staticClass:"input-group"},[n("input",{directives:[{name:"model",rawName:"v-model",value:t.newChecklist,expression:"newChecklist"}],staticClass:"form-control form-control-sm",attrs:{type:"text",placeholder:"Add new flow item here"},domProps:{value:t.newChecklist},on:{keyup:function(e){return!e.type.indexOf("key")&&t._k(e.keyCode,"enter",13,e.key,"Enter")?null:t.addChecklist.apply(null,arguments)},input:function(e){e.target.composing||(t.newChecklist=e.target.value)}}}),t._v(" "),n("div",{staticClass:"input-group-append"},[n("pf-button",{staticClass:"btn-success",attrs:{styleButton:""===t.newChecklist?"pointer-events: none !important;":"",type:"button",label:"Add",id:"addChecklist",isSuccess:!0},on:{click:t.addChecklist}})],1)])]),t._v(" "),n("div",{staticClass:"col-md-6 col-lg-5"},[n("button",{staticClass:"btn btn-sm btn-success float-right ml-1 spaceBottonImport",on:{click:function(e){t.isModal=!0}}},[t._v("Import")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-success float-right ml-1 spaceBottonSendEntire",attrs:{type:"button"},on:{click:t.sendList}},[t._v("Send Entire List to a Note")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-success float-right",attrs:{type:"button"},on:{click:t.exhibitDividers}},[t._v("Exhibit Dividers")])])]),t._v(" "),n("hr",{staticClass:"hrChecklist"}),t._v(" "),n("draggable",t._b({staticClass:"list-group",on:{start:function(e){t.drag=!0},end:function(e){t.drag=!1}},model:{value:t.checklists,callback:function(e){t.checklists=e},expression:"checklists"}},"draggable",t.dragOptions,!1),[n("transition-group",{attrs:{type:"transition",name:t.drag?null:"flip-list"}},t._l(t.checklists,function(e,i){return n("div",{key:e._id},[n("div",{staticClass:"row"},[n("div",{staticClass:"col-lg-12"},[n("pf-checkbox",{attrs:{id:String(e._id),label:e.name,classElement:"inputLine",classLabel:"text-justify line-through",classUpdate:"classInline-block",classComponent:"classInline",classComponentGlobal:"classInline"}}),t._v(" "),n("div",{staticClass:"btn-group btn-group-sm float-right",attrs:{role:"group","aria-label":"Basic example"}},[n("button",{staticClass:"btn btn-warning",attrs:{type:"button"},on:{click:function(e){return t.showModalUpload(i)}}},[t._v("Upload")]),t._v(" "),n("button",{staticClass:"btn btn-secondary",attrs:{type:"button",disabled:!(e.files.filter(function(t){return!0===t.uploaded}).length>0)},on:{click:function(e){return t.showModalView(i)}}},[t._v("View")]),t._v(" "),n("button",{staticClass:"btn btn-danger",attrs:{type:"button"},on:{click:function(e){return t.deleteChecklist(i)}}},[t._v("Delete")])])],1)]),t._v(" "),n("hr",{staticClass:"hrChecklist"})])}),0)],1),t._v(" "),n("div",{staticClass:"row"},[n("div",{staticClass:"col-12"},[n("button",{staticClass:"btn btn-sm btn-success",on:{click:t.printChecklist}},[t._v("Print")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-success",on:{click:t.sendByEmail}},[t._v("Send By Email")])])]),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:t.titlePopUp,message:t.messagePopUp,type:t.typePopUp},on:{close:t.closeModal,action:t.setActionPopUp}}):t._e(),t._v(" "),!0===t.isModal?n("pf-modal",{attrs:{title:"New Form",noFirstHr:!0,btnright:null!==t.pAreaSelected&&Object.keys(t.pAreaSelected).length>0&&null!==t.caseTypeSelected&&Object.keys(t.caseTypeSelected).length>0?"Import":""},on:{close:function(e){t.isModal=!1},click:t.importChecklist}},[n("template",{slot:"body"},[n("div",{staticClass:"row myRow"},[n("div",{staticClass:"col-12"},[n("div",{staticClass:"form-group"},[n("h6",[n("b",[t._v("Practice Area")])]),t._v(" "),n("v-select",{attrs:{options:t.practiceAreas},scopedSlots:t._u([{key:"option",fn:function(e){return[n("div",{staticClass:"p-2",class:{striped:!0}},[n("h5",[t._v(t._s(e.name))])])]}}],null,!1,4008954630),model:{value:t.pAreaSelected,callback:function(e){t.pAreaSelected=e},expression:"pAreaSelected"}})],1)])]),t._v(" "),n("div",{staticClass:"row myRow"},[n("div",{staticClass:"col-12"},[n("div",{staticClass:"form-group"},[n("h6",[n("b",[t._v("Case Type")])]),t._v(" "),n("v-select",{attrs:{options:t.caseTypes},scopedSlots:t._u([{key:"option",fn:function(e){return[n("div",{staticClass:"p-2",class:{striped:!0}},[n("h5",[t._v(t._s(e.name))])])]}}],null,!1,4008954630),model:{value:t.caseTypeSelected,callback:function(e){t.caseTypeSelected=e},expression:"caseTypeSelected"}})],1)])]),t._v(" "),null!==t.pAreaSelected&&Object.keys(t.pAreaSelected).length>0&&null!==t.caseTypeSelected&&Object.keys(t.caseTypeSelected).length>0?n("div",t._l(t.checklists,function(e,i){return n("div",{key:i,staticClass:"ml-4 mr-4",class:{stripedDiv:t.isOdd(i)}},[n("div",{staticClass:"col-md-10 col-lg-11 topCheck pt-2 pb-2"},[n("pf-checkbox",{attrs:{id:String(e._id)+"toImport",label:e.name,classLabel:"text-justify",styleLabel:""}})],1)])}),0):t._e()]),t._v(" "),null!==t.pAreaSelected&&Object.keys(t.pAreaSelected).length>0&&null!==t.caseTypeSelected&&Object.keys(t.caseTypeSelected).length>0?n("template",{slot:"footer"},[n("div",{staticStyle:{display:"inline-block"}},[n("pf-checkbox",{attrs:{label:"Remove current items before import.",styleLabel:"color:red;",classLabel:"text-justify",checked:t.isRemoveBeforeImport},on:{click:function(e){t.isRemoveBeforeImport=!t.isRemoveBeforeImport}}})],1)]):t._e()],2):t._e(),t._v(" "),!0===t.isModalUpload?n("pf-modal",{attrs:{title:"Upload New Documents",noFirstHr:!0,isAction:t.isActionUpload,isBtnRightDisabled:t.isAllUploadFiles,btnright:t.cantFilesUploaded>1?"Upload All":1===t.cantFilesUploaded?"Upload":""},on:{close:function(e){t.isModalUpload=!1},click:t.uploadFiles}},[n("template",{slot:"body"},[n("div",{staticClass:"containerFileDrag",attrs:{id:"file-drag-drop"}},[n("div",{staticClass:"row"},[n("div",{staticClass:"col-12"},[n("form",{ref:"fileform",staticClass:"dropFilesHere",on:{click:t.showModalBrowse}},[n("span",{staticClass:"drop-files"},[n("b",[t._v("Drop here or click here in computer")])])])])]),t._v(" "),n("input",{staticClass:"d-none",attrs:{id:"browseFiles",type:"file",value:"Browse"},on:{change:t.fileSelected}}),t._v(" "),t._l(t.checklists[t.currentIndexUploadChecklist].files,function(e,i){return n("div",{key:i,staticClass:"row containerFileList"},[n("div",{staticClass:"col-12"},[n("div",{staticClass:"file-listing card"},[n("div",{staticClass:"iconCloseCheck",on:{click:function(e){return t.removeFile(i)}}},[n("i",{staticClass:"far fa-times-circle"})]),t._v(" "),n("p",{staticClass:"mb-0 textNameCheckList"},[n("b",[t._v("Name: ")]),t._v(" "+t._s(e.name))]),t._v(" "),n("p",{staticClass:"mb-1"},[n("b",[t._v("Size: ")]),t._v(t._s(e.size>1024e3?(e.size/1024e3).toFixed(2)+" Mb":e.size>1024?(e.size/1024).toFixed(2)+" Kb":e.size+" bytes"))]),t._v(" "),!0!==e.uploaded?n("div",{staticClass:"remove-container"}):n("div",[n("span",{staticClass:"float-right",staticStyle:{color:"green"}},[t._v("Uploaded")])]),t._v(" "),n("progress",{directives:[{name:"show",rawName:"v-show",value:!0!==e.uploaded,expression:"file.uploaded !== true"}],staticClass:"d-none",attrs:{id:"progress"+i,max:"100"},domProps:{value:t.uploadPercentage}})])])])})],2)])],2):t._e(),t._v(" "),!0===t.isModalView?n("pf-modal",{attrs:{title:"File Information",noFirstHr:!0,btnright:"Close"},on:{close:function(e){t.isModalView=!1},click:function(e){t.isModalView=!1}}},[n("template",{slot:"body"},[n("div",{staticClass:"ml-5 mr-5"},[n("table",{staticClass:"table table-bordered table-striped"},[n("thead",[n("tr",[n("th",{attrs:{scope:"col"}},[t._v("File Name")]),t._v(" "),n("th",{attrs:{scope:"col"}},[t._v("Date")]),t._v(" "),n("th",{attrs:{scope:"col"}},[t._v("Upload By")]),t._v(" "),n("th",{attrs:{scope:"col"}},[t._v("Size")]),t._v(" "),n("th",{attrs:{scope:"col"}},[t._v("Action")])])]),t._v(" "),n("tbody",t._l(t.currentFilesChecklist,function(e,i){return n("tr",{key:i},[n("td",[t._v(t._s(e.name))]),t._v(" "),n("td",[t._v(t._s(e.date))]),t._v(" "),n("td",[t._v(t._s(e.user))]),t._v(" "),n("td",[t._v(t._s(e.size>1024e3?(e.size/1024e3).toFixed(2)+" Mb":e.size>1024?(e.size/1024).toFixed(2)+" Kb":e.size+" bytes"))]),t._v(" "),n("td",[n("button",{staticClass:"btn btn-primary"},[n("i",{staticClass:"fas fa-cloud-download-alt"}),t._v(" Download")])])])}),0)])])])],2):t._e()],1)},staticRenderFns:[]};var Wl=n("VU/8")(Vl,ql,!1,function(t){n("FpGi"),n("NA7F")},"data-v-89397048",null).exports,Ul={name:"pf-login",data:function(){return{email:"",pass:"",isRemember:!1,isSpinner:!1}},props:{error:{type:Boolean}},components:{PfInput:m,PfCheckbox:x,PfSpinner:r},methods:{login:function(){this.isSpinner=!0,this.$emit("hideError"),this.$emit("submit",{email:this.email,pass:this.pass})},setRemember:function(){this.isRemember=document.getElementById("rememberMe").checked,document.cookie="rememberMe="+this.isRemember}}},Gl={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"wrapper"},[n("div",{staticClass:"vertical-align-wrap"},[n("div",{staticClass:"vertical-align-middle auth-main"},[n("div",{staticClass:"auth-box"},[t._m(0),t._v(" "),t._m(1),t._v(" "),n("div",{staticClass:"auth-right"},[t._m(2),t._v(" "),n("div",{staticClass:"card"},[t._m(3),t._v(" "),n("div",{staticClass:"body"},[n("form",{staticClass:"form-auth-small",on:{submit:function(e){return e.preventDefault(),t.login.apply(null,arguments)}}},[n("pf-input",{attrs:{placeholder:"User Name"},model:{value:t.email,callback:function(e){t.email=e},expression:"email"}}),t._v(" "),n("pf-input",{attrs:{type:"password",placeholder:"Password"},model:{value:t.pass,callback:function(e){t.pass=e},expression:"pass"}}),t._v(" "),n("div",{staticClass:"form-group mb-3"},[n("div",{staticClass:"checkbox text-left"},[n("pf-checkbox",{attrs:{label:"Remember me",id:"rememberMe",classElement:"mr-2",checked:t.isRemember},on:{click:t.setRemember}})],1)]),t._v(" "),n("div",[n("button",{staticClass:"btn btn-lg btn-primary btn-block mb-3"},[!0===t.isSpinner&&!1===t.error?n("pf-spinner"):n("div",[t._v("\n                      LOGIN\n                    ")])],1)]),t._v(" "),t.error?n("p",{staticClass:"error"},[t._v("Email or password invalid..!")]):t._e(),t._v(" "),t._m(4)],1)])])])])])])])},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"mobile-logo"},[e("a",{attrs:{href:""}},[e("img",{attrs:{src:"https://www.primafacieapp.com/static/auth/full-logo.svg",alt:"Mplify"}})])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"auth-left"},[e("div",{staticClass:"left-top"},[e("a",{attrs:{href:""}},[e("img",{attrs:{src:"https://www.primafacieapp.com/static/auth/full-logo.svg",alt:"Mplify"}}),this._v(" "),e("span")])]),this._v(" "),e("div",{staticClass:"left-slider"},[e("img",{staticClass:"img-fluid",attrs:{src:"https://www.primafacieapp.com/static/auth/img-principal.jpg",alt:""}})])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"right-top"},[e("ul",{staticClass:"list-unstyled clearfix d-flex"},[e("li",[e("a",{staticClass:"shadowLiRight",attrs:{target:"_blank",href:"https://www.primafacienow.com/"}},[e("i",{staticClass:"fa fa-home"})])]),this._v(" "),e("li",[e("a",{staticClass:"shadowLiRight",attrs:{target:"_blank",href:"https://support.primafacie.us/"}},[this._v("Help")])])])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"header"},[e("p",{staticClass:"lead"},[this._v("Log in")])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"bottom"},[e("h6",{staticClass:"helper-text mb-3"},[e("i",{staticClass:"fa fa-lock"}),this._v(" "),e("a",{attrs:{href:"#"}},[this._v(" Forgot password?")])]),this._v(" "),e("h6",[this._v("Don't have an account?  "),e("a",{attrs:{target:"_blank",href:"https://primafacie.as.me/schedule.php"}},[this._v("Request a demo.")])])])}]};var Zl=n("VU/8")(Ul,Gl,!1,function(t){n("yyob")},"data-v-d4bf850e",null).exports,Jl=["onActivate","onAddUndo","onBeforeAddUndo","onBeforeExecCommand","onBeforeGetContent","onBeforeRenderUI","onBeforeSetContent","onBeforePaste","onBlur","onChange","onClearUndos","onClick","onContextMenu","onCopy","onCut","onDblclick","onDeactivate","onDirty","onDrag","onDragDrop","onDragEnd","onDragGesture","onDragOver","onDrop","onExecCommand","onFocus","onFocusIn","onFocusOut","onGetContent","onHide","onInit","onKeyDown","onKeyPress","onKeyUp","onLoadContent","onMouseDown","onMouseEnter","onMouseLeave","onMouseMove","onMouseOut","onMouseOver","onMouseUp","onNodeChange","onObjectResizeStart","onObjectResized","onObjectSelected","onPaste","onPostProcess","onPostRender","onPreProcess","onProgressState","onRedo","onRemove","onReset","onSaveContent","onSelectionChange","onSetAttrib","onSetContent","onShow","onSubmit","onUndo","onVisualAid"],Ql=function(t){return-1!==Jl.indexOf(t)},Kl=function(t,e,n){var i=e.$props.value?e.$props.value:"",a=e.$props.initialValue?e.$props.initialValue:"";n.setContent(i||a),e.$listeners.input&&function(t,e){var n,i=t.$props.modelEvents?t.$props.modelEvents:null,a=Array.isArray(i)?i.join(" "):i;t.$watch("value",function(t,i){e&&"string"==typeof t&&t!==n&&t!==i&&(e.setContent(t),n=t)}),e.on(a||"change keyup undo redo",function(){n=e.getContent(),t.$emit("input",n)})}(e,n),function(t,e,n){Object.keys(e).filter(Ql).forEach(function(i){var a=e[i];"function"==typeof a&&("onInit"===i?a(t,n):n.on(i.substring(2),function(t){return a(t,n)}))})}(t,e.$listeners,n)},td=0,ed=function(t){var e=Date.now();return t+"_"+Math.floor(1e9*Math.random())+ ++td+String(e)},nd=function(t){return void 0===t||""===t?[]:Array.isArray(t)?t:t.split(" ")},id=n("H7xL"),ad={apiKey:String,cloudChannel:String,id:String,init:Object,initialValue:String,inline:Boolean,modelEvents:[String,Array],plugins:[String,Array],tagName:String,toolbar:[String,Array],value:String,disabled:Boolean},od=this&&this.__assign||function(){return(od=Object.assign||function(t){for(var e,n=1,i=arguments.length;n<i;n++)for(var a in e=arguments[n])Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a]);return t}).apply(this,arguments)},rd={listeners:[],scriptId:ed("tiny-script"),scriptLoaded:!1},sd=function(t){return function(){var e,n,i,a=od({},t.$props.init,{readonly:t.$props.disabled,selector:"#"+t.elementId,plugins:(e=t.$props.init&&t.$props.init.plugins,n=t.$props.plugins,nd(e).concat(nd(n))),toolbar:t.$props.toolbar||t.$props.init&&t.$props.init.toolbar,inline:t.inlineEditor,setup:function(e){t.editor=e,e.on("init",function(n){return Kl(n,t,e)}),t.$props.init&&"function"==typeof t.$props.init.setup&&t.$props.init.setup(e)}});null!==(i=t.element)&&"textarea"===i.tagName.toLowerCase()&&(t.element.style.visibility=""),Object(id.a)().init(a)}},ld={props:ad,created:function(){this.elementId=this.$props.id||ed("tiny-vue"),this.inlineEditor=this.$props.init&&this.$props.init.inline||this.$props.inline},watch:{disabled:function(){this.editor.setMode(this.disabled?"readonly":"design")}},mounted:function(){if(this.element=this.$el,null!==Object(id.a)())sd(this)();else if(this.element&&this.element.ownerDocument){var t=this.element.ownerDocument,e=this.$props.cloudChannel?this.$props.cloudChannel:"5",n=this.$props.apiKey?this.$props.apiKey:"no-api-key";!function(t,e,n,i){t.scriptLoaded?i():(t.listeners.push(i),e.getElementById(t.scriptId)||function(t,e,n,i){var a=e.createElement("script");a.type="application/javascript",a.id=t,a.addEventListener("load",i),a.src=n,e.head&&e.head.appendChild(a)}(t.scriptId,e,n,function(){t.listeners.forEach(function(t){return t()}),t.scriptLoaded=!0}))}(rd,t,"https://cdn.tiny.cloud/1/"+n+"/tinymce/"+e+"/tinymce.min.js",sd(this))}},beforeDestroy:function(){null!==Object(id.a)()&&Object(id.a)().remove(this.editor)},render:function(t){return this.inlineEditor?function(t,e,n){return t(n||"div",{attrs:{id:e}})}(t,this.elementId,this.$props.tagName):function(t,e){return t("textarea",{attrs:{id:e},style:{visibility:"hidden"}})}(t,this.elementId)}},dd={name:"pf-new-category",data:function(){return{isTimeEntryCategory:!0,name:"",rate:null,billingMethods:[{fullName:"User Default Rate",partner:"default_rate"},{fullName:"Custom Rate",partner:"custom_rate"},{fullName:"Flat Rate",partner:"flat_rate"}],currentBillingMethod:{fullName:"User Default Rate",partner:"default_rate"},isCoCounsel:!1,isNewCategory:!0,isSpinner:!1,isSaveCategory:!1}},props:{token:{type:String},data_edit:{type:Object},isExpense:{type:Boolean},isTime:{type:Boolean},isManageTime:{type:Boolean}},components:{PfInput:m,PfSelect:k,PfCalendar:lt,PfTextArea:T,PfCheckbox:x,PfRadio:P,PfButton:d,PfSpinner:r,PfModal:Dl},watch:{saveCategory:function(t){!0===t&&(null!==this.data_edit?this.editCategory():this.addCategory())}},mounted:function(){null!==this.data_edit?(this.isNewCategory=!1,this.name=this.data_edit.name,this.rate=this.formatCoinWithoutDollar(this.data_edit.rate),"time"===this.data_edit.type?(this.isTimeEntryCategory=!0,this.currentBillingMethod=this.billingMethods[this.billingMethods.map(function(t){return t.partner}).indexOf(this.data_edit.billingMethod)]):this.isTimeEntryCategory=!1):this.isTimeEntryCategory=this.isManageTime?this.isManageTime:!!this.isTime&&this.isTime},methods:{alternContentCategories:function(t){this.isTimeEntryCategory=t,this.isTimeEntryCategory?(document.getElementById("btnTimeCategory").classList.add("colorBtnActiveAcBi"),document.getElementById("btnExpenseCategory").classList.remove("colorBtnActiveAcBi")):(document.getElementById("btnTimeCategory").classList.remove("colorBtnActiveAcBi"),document.getElementById("btnExpenseCategory").classList.add("colorBtnActiveAcBi"))},setBillingMethod:function(t){this.currentBillingMethod=t},changeRate:function(){""!==this.rate&&(new RegExp("[+-]?([0-9]*[.])?[0-9]+").test(this.rate)&&!isNaN(this.rate)||(this.rate=0),this.rate=this.formatCoinWithoutDollar(this.rate))},validateFields:function(){var t=!0;return this.name&&null!==this.name&&""!==this.name?document.getElementById("nameCategory").classList.remove("is-invalid"):(document.getElementById("nameCategory").classList.add("is-invalid"),t=!1),t},saveCategory:function(){this.isSaveCategory=!0,null!==this.data_edit?this.editCategory():this.addCategory()},addCategory:function(){var t=this;if(!1===this.validateFields())return this.$emit("set-new:category",!1),void(this.isSaveCategory=!1);var e={type:!0!==this.isTimeEntryCategory&&!0!==this.isTime||this.isExpense?"expense":"time",name:this.name,rate:null!==this.rate?this.unparseFormatCoin(this.rate):0,billingMethod:this.currentBillingMethod.partner};Tt.addCategory({token:this.token,newBillingCategory:e}).then(function(e){null===e.billingCategoryAdd?(t.$emit("set-new:category",!1),popupNotification.show("Error to add category","error")):(e.billingCategoryAdd.fullName=e.billingCategoryAdd.name,t.$emit("set-new:category",e.billingCategoryAdd),popupNotification.show("Category added","success"))})},editCategory:function(){var t=this;if(!1!==this.validateFields()){this.data_edit.name=this.name,this.data_edit.rate=null!==this.rate?this.unparseFormatCoin(this.rate):null,this.billingMethod=this.currentBillingMethod.partner,"time"===this.data_edit.type&&(this.data_edit.billingMethod=this.billingMethod);var e=JSON.parse(U()(this.data_edit));delete e._id,delete e.type,delete e.fullName,delete e.rateCoin,Tt.editCategory({token:this.token,_id:this.data_edit._id,editBillingCategory:e}).then(function(e){null===e.billingCategoryEdit?(t.$emit("set-edit:category",!1),popupNotification.show("Error to edit category","error")):(e.billingCategoryEdit.fullName=e.billingCategoryEdit.name,t.$emit("set-edit:category",e.billingCategoryEdit),popupNotification.show("Category edited","success"))})}else this.$emit("set-edit:category",!1)},formatCoinWithoutDollar:function(t){return(t=new Intl.NumberFormat("en-US",{style:"currency",currency:"USD",minimumFractionDigits:2}).format(t)).replace("$","")},unparseFormatCoin:function(t){return t=(t=t.replace("$","")).replace(/,/g,""),Number(t)},closeModal:function(){this.$emit("close")}}},cd={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("pf-modal",{attrs:{title:null===t.data_edit?"New Category":"Edit Category",noFirstHr:!0,isUbold:!0,styleContainerModal:"width:40%!important;",footerClass:"float-right"},on:{close:t.closeModal}},[n("template",{slot:"body"},[n("div",{staticClass:"mb-2"},[!0===t.isSpinner?n("pf-spinner",{attrs:{color:"black"}}):t._e(),t._v(" "),n("div",{staticClass:"row myRow"},[!t.isNewCategory||t.isTime||t.isExpense?t._e():n("div",{staticClass:"col-12"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:""}},[n("b",[t._v("Category Type")])]),t._v(" "),n("div",{staticClass:"col-md-12 btn-group btn-group-sm",staticStyle:{"padding-left":"0px"},attrs:{role:"group"}},[n("pf-button",{attrs:{label:"Time Category",id:"btnTimeCategory",classButton:t.isManageTime?"btn btn-secondary btn-secondary-ubold BR-right colorBtnActiveAcBi":"btn btn-secondary btn-secondary-ubold BR-right",contentStyle:"display:inline;",noFadeOut:!0},on:{click:function(e){return t.alternContentCategories(!0)}}}),t._v(" "),n("pf-button",{attrs:{label:"Expense Category",id:"btnExpenseCategory",classButton:t.isManageTime?"btn btn-secondary btn-secondary-ubold BR-none":"btn btn-secondary btn-secondary-ubold BR-none colorBtnActiveAcBi",contentStyle:"display:inline;",noFadeOut:!0},on:{click:function(e){return t.alternContentCategories(!1)}}})],1)])]),t._v(" "),t.isTimeEntryCategory||t.isTime?n("div",{staticClass:"col-md-12 pl-0 pr-0",attrs:{id:"timeEntryCategory1"}},[n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("pf-input",{attrs:{label:"Name",labelStyle:"font-weight:bold;",isObligatory:!0,id:"nameCategory"},model:{value:t.name,callback:function(e){t.name=e},expression:"name"}})],1)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("pf-select",{attrs:{label:"Billing Method",options:t.billingMethods,labelStyle:"font-weight:bold;",value:t.currentBillingMethod,isSearchSelect:!0},on:{input:t.setBillingMethod}})],1)]),t._v(" "),"custom_rate"===t.currentBillingMethod.partner||"flat_rate"===t.currentBillingMethod.partner?n("div",{staticClass:"col-md-12"},[n("div",{staticClass:"form-group"},[n("pf-input",{attrs:{label:"Rate",textInputGroup:"$",labelStyle:"font-weight:bold;",placeholder:"0.00",id:"rateCategory"},on:{change:t.changeRate},model:{value:t.rate,callback:function(e){t.rate=e},expression:"rate"}})],1)]):t._e()])]):n("div",{staticClass:"col-md-12 pl-0 pr-0",attrs:{id:"expenseCategory1"}},[n("div",{staticClass:"row"},[n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("pf-input",{attrs:{label:"Name",labelStyle:"font-weight:bold;",isObligatory:!0,id:"nameCategory"},model:{value:t.name,callback:function(e){t.name=e},expression:"name"}})],1)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("pf-input",{attrs:{label:"Rate",textInputGroup:"$",labelStyle:"font-weight:bold;",placeholder:"0.00",id:"rateCategory"},on:{change:t.changeRate},model:{value:t.rate,callback:function(e){t.rate=e},expression:"rate"}})],1)])])])])],1)]),t._v(" "),n("template",{slot:"footer"},[n("div",{staticClass:"float-right",staticStyle:{"margin-bottom":"11px !important"}},[n("pf-button",{attrs:{label:"Save Category",id:"btnSaveCategoryActivity",classButton:"btn btn-success btn-success-ubold mb-1",contentStyle:"display:inline;",isSuccess:!0,disabled:!0===t.isSaveCategory,isAction:t.isSaveCategory},on:{click:t.saveCategory}}),t._v(" "),n("pf-button",{attrs:{label:"Cancel",id:"btnCancelActivity",classButton:"btn btn-secondary btn-secondary-ubold mb-1",contentStyle:"display:inline;",isSuccess:!0,disabled:!0===t.isSaveCategory,isAction:t.isSaveCategory},on:{click:t.closeModal}})],1)])],2)},staticRenderFns:[]};var hd=n("VU/8")(dd,cd,!1,function(t){n("bA4O"),n("/4bJ")},null,null).exports,ud={name:"pf-new-time-entry",data:function(){return{dateActivity:ct()().format("MM/DD/YYYY"),currentFirmUser:null,currentCase:null,currentCategory:null,duration:"",rate:(0).toFixed(2),description:"",isNonBillable:!1,isNewCategory:!1,saveCategory:!1,categoriesOwn:[],firmUsersOwn:[],isSpinner:!0,isSaveActivity:!1,isSaveActivityAnother:!1,iiSsSaveActivityDuplicate:!1,discount:null,discountPercentage:null,totalAmount:(0).toFixed(2)}},props:{casesList:{type:Array},categories:{type:Array},firmUsers:{type:Array},token:{type:String},contact_id:{type:Number},case_id:{type:Number},data_edit:{type:Object},source_id:{type:String},source_type:{type:String},source_description:{type:String},source_date:{type:String},duplicate_data:{type:Object},is_billed:{type:Boolean},is_new_bill:{type:Boolean}},components:{PfInput:m,PfSelect:k,PfCalendar:lt,PfTextArea:T,PfCheckbox:x,PfRadio:P,PfButton:d,PfNewCategoryModal:hd,PfModal:Dl,PfSpinner:r},watch:{rate:function(t){this.duration=this.duration.replace(/,/g,""),t=t.replace(/,/g,""),this.totalAmount=this.formatCoinWithoutDollar(Number(this.duration)*Number(t))},categories:function(t){this.categoriesOwn=JSON.parse(U()(t)),this.categoriesOwn.unshift({addNew:!0,fullName:"Add New"})}},mounted:function(){var t=this;if(this.source_id)this.description=this.source_description,this.dateActivity=ct()(this.source_date).format("MM/DD/YYYY"),this.initRequests();else{if(this.is_billed)return this.initRequests(),void(this.data_edit&&(this.duration=this.data_edit.quantity.replace("h","").replace("H","").replace("m","").replace("M",""),this.duration=this.formatCoinWithoutDollar(this.duration),this.dateActivity=this.data_edit.dateActivity&&null!==this.data_edit.dateActivity?-1!==this.data_edit.dateActivity.indexOf("T")?ct()(this.data_edit.dateActivity.split("T")[0]).format("MM/DD/YYYY"):ct()(this.data_edit.dateActivity).format("MM/DD/YYYY"):ct()().format("MM/DD/YYYY"),this.description=this.data_edit.description,this.isNonBillable=this.data_edit.nonBillableStatus,this.discount=this.data_edit.discount&&null!==this.data_edit.discount&&this.data_edit.discountPercentage&&-1!==this.data_edit.discount.indexOf("%")?this.data_edit.discount.replace("%",""):this.data_edit.discountPercentage?this.data_edit.discount:this.formatCoinWithoutDollar(this.data_edit.discount),this.discountPercentage=this.data_edit.discountPercentage));if(this.firmUsers?(this.data_edit?this.currentFirmUser=this.firmUsersOwn[this.firmUsersOwn.map(function(t){return t.id}).indexOf(this.data_edit.userId)]:this.whoAmI().then(function(e){t.currentFirmUser=e.whoAmI,t.currentFirmUser.fullName=t.currentFirmUser.firstName+" "+t.currentFirmUser.lastName,t.rate=null!==t.currentFirmUser.rate?t.formatCoinWithoutDollar(t.currentFirmUser.rate):t.currentFirmUser.isAttorney?t.formatCoinWithoutDollar(t.currentFirmUser.defaultRateAttorney):t.formatCoinWithoutDollar(t.currentFirmUser.defaultRateParalegal)}),this.firmUsersOwn=this.firmUsers):this.getUsers().then(function(e){null!==e.users?(t.firmUsersOwn=e.users,t.firmUsersOwn.forEach(function(t){t.fullName=t.firstName+" "+t.lastName})):popupNotification.show("Error, no users found","error")}),this.casesList?this.case_id&&(this.currentCase=this.casesList[this.casesList.map(function(t){return t.id}).indexOf(this.case_id)]):this.getCases().then(function(e){e.cases.forEach(function(t,n){e.cases[n].fullName=t.name+" | "+t.caseType.name}),t.casesList=e.cases,t.data_edit&&t.setInfoDataEdit()}),this.isSpinner=!1,this.data_edit&&null!==this.data_edit&&this.casesList?this.setInfoDataEdit():this.duplicate_data&&null!==this.duplicate_data&&this.casesList&&this.setInfoDuplicateData(),this.categories){this.categoriesOwn=JSON.parse(U()(this.categories));for(var e=0;e<this.categoriesOwn.length;e++)this.categoriesOwn[e].fullName=this.categoriesOwn[e].name;this.categoriesOwn.unshift({addNew:!0,fullName:"Add New"})}else this.getCategories().then(function(){t.data_edit&&t.setInfoDataEdit()})}},methods:{initRequests:function(){var t=this;this.getCase().then(function(e){null!==e.cases&&e.cases.length>0?(t.currentCase=e.cases[0],t.currentCase.fullName=t.currentCase.name+" | "+t.currentCase.caseType.name):popupNotification.show("Error, no case found","error"),t.isSpinner=!1}),this.getCategories(),this.getUsers().then(function(e){null!==e.users?(t.firmUsersOwn=e.users,t.firmUsersOwn.forEach(function(t,e){t.fullName=t.firstName+" "+t.lastName}),t.data_edit?(t.currentFirmUser=t.firmUsersOwn[t.firmUsersOwn.map(function(t){return t.id}).indexOf(t.data_edit.userId)],t.rate=t.rate=null!==t.currentFirmUser.rate?t.formatCoinWithoutDollar(t.currentFirmUser.rate):t.currentFirmUser.isAttorney?t.formatCoinWithoutDollar(t.currentFirmUser.defaultRateAttorney):t.formatCoinWithoutDollar(t.currentFirmUser.defaultRateParalegal)):t.whoAmI().then(function(e){t.currentFirmUser=e.whoAmI,t.currentFirmUser.fullName=t.currentFirmUser.firstName+" "+t.currentFirmUser.lastName,t.rate=t.rate=null!==t.currentFirmUser.rate?t.formatCoinWithoutDollar(t.currentFirmUser.rate):t.currentFirmUser.isAttorney?t.formatCoinWithoutDollar(t.currentFirmUser.defaultRateAttorney):t.formatCoinWithoutDollar(t.currentFirmUser.defaultRateParalegal)})):popupNotification.show("Error, no users found","error")})},whoAmI:function(){return Tt.whoAmI({token:this.token}).then(function(t){return t})},setInfoDataEdit:function(){"flat_rate"===this.data_edit.quantity?this.duration="1h":(this.duration=this.data_edit.quantity.replace("h","").replace("H","").replace("m","").replace("M",""),this.duration=this.formatCoinWithoutDollar(this.duration)),this.dateActivity=this.data_edit.dateActivity&&null!==this.data_edit.dateActivity?-1!==this.data_edit.dateActivity.indexOf("T")?ct()(this.data_edit.dateActivity.split("T")[0]).format("MM/DD/YYYY"):ct()(this.data_edit.dateActivity).format("MM/DD/YYYY"):ct()().format("MM/DD/YYYY"),this.currentCase=this.casesList?this.casesList[this.casesList.map(function(t){return t.id}).indexOf(this.data_edit.caseId)]:[],this.currentFirmUser=this.firmUsersOwn?this.firmUsersOwn[this.firmUsersOwn.map(function(t){return t.id}).indexOf(this.data_edit.userId)]:[],this.currentCategory=this.categories?this.categories[this.categories.map(function(t){return t._id}).indexOf(this.data_edit.billingCategoryId)]:[],this.rate=null!==this.data_edit.rate?this.formatCoinWithoutDollar(this.data_edit.rate):this.formatCoinWithoutDollar(this.currentCategory.rate),this.description=this.data_edit.description,this.isNonBillable=this.data_edit.nonBillableStatus,this.isSpinner=!1},setInfoDuplicateData:function(){this.currentCase=this.casesList[this.casesList.map(function(t){return t.id}).indexOf(this.duplicate_data.caseId)],this.duration=this.duplicate_data.quantity.replace("h","").replace("H","").replace("m","").replace("M",""),this.duration=this.formatCoinWithoutDollar(this.duration),this.dateActivity=this.duplicate_data.dateActivity&&null!==this.duplicate_data.dateActivity?-1!==this.duplicate_data.dateActivity.indexOf("T")?ct()(this.duplicate_data.dateActivity.split("T")[0]).format("MM/DD/YYYY"):ct()(this.duplicate_data.dateActivity).format("MM/DD/YYYY"):ct()().format("MM/DD/YYYY"),this.currentFirmUser=this.firmUsersOwn[this.firmUsersOwn.map(function(t){return t.id}).indexOf(this.duplicate_data.userId)],this.currentCategory=this.categories[this.categories.map(function(t){return t._id}).indexOf(this.duplicate_data.billingCategoryId)],this.rate=null!==this.duplicate_data.rate?this.formatCoinWithoutDollar(this.duplicate_data.rate):this.formatCoinWithoutDollar(this.currentCategory.rate),this.description=this.duplicate_data.description,this.isNonBillable=this.duplicate_data.nonBillableStatus,this.isSpinner=!1},getCase:function(){return Tt.getCaseForId({token:this.token,caseId:this.data_edit?this.data_edit.caseId:this.case_id}).then(function(t){return t})},getCases:function(){return Tt.getCasesForContactId({token:this.token,contactId:this.data_edit?this.data_edit.contactId:this.contact_id}).then(function(t){return t})},getCategories:function(){var t=this;return Tt.getCategoriesForType({token:this.token,type:"time"}).then(function(e){null!==e.billingCategory?(e.billingCategory.forEach(function(t){t.fullName=t.name}),t.categoriesOwn=e.billingCategory.filter(function(t){return"time"===t.type}),t.categoriesOwn.unshift({addNew:!0,fullName:"Add New"}),t.data_edit&&(t.currentCategory=t.categoriesOwn[t.categoriesOwn.map(function(t){return t._id}).indexOf(t.data_edit.billingCategoryId)],t.rate=null!==t.data_edit.rate?t.formatCoinWithoutDollar(t.data_edit.rate):t.formatCoinWithoutDollar(t.currentCategory.rate))):popupNotification.show("Error, no categories found","error")})},getUsers:function(){return Tt.getUsers({token:this.token}).then(function(t){return t})},setFirmUser:function(t){this.currentFirmUser=t,this.rate=null!==this.currentFirmUser.rate?this.formatCoinWithoutDollar(this.currentFirmUser.rate):this.currentFirmUser.isAttorney?this.formatCoinWithoutDollar(this.currentFirmUser.defaultRateAttorney):this.formatCoinWithoutDollar(this.currentFirmUser.defaultRateParalegal)},setCase:function(t){this.currentCase=t},changeRate:function(){(this.rate=this.unparseFormatCoin(this.rate),""!==this.rate)&&(new RegExp("[+-]?([0-9]*[.])?[0-9]+").test(this.rate)&&!isNaN(this.rate)||(this.rate=0),this.rate=this.formatCoinWithoutDollar(this.rate))},changeDiscount:function(){""!==this.discount&&(new RegExp("[+-]?([0-9]*[.])?[0-9]+").test(this.discount)&&!isNaN(this.discount)||(this.discount=0),this.validateDiscount()||(this.discount=0,popupNotification.show("Error: Discount has been applied producing a negative total.","error")),this.discountPercentage&&null!==this.discountPercentage||(this.discountPercentage=!1),this.discountPercentage||(this.discount=this.formatCoinWithoutDollar(this.discount)))},validateDiscount:function(){var t=Number(this.duration)*this.unparseFormatCoin(this.rate);return this.discountPercentage?t-=t*this.discount/100:t-=this.discount,!(t<0)},changeTypeDiscount:function(t){this.discountPercentage="true"===t.target.value,this.changeDiscount()},setCategory:function(t){!0===t.addNew?(this.currentCategory={},this.isNewCategory=!0):(this.currentCategory=t,this.rate=this.formatCoinWithoutDollar(t.rate))},changeDateActivity:function(t){this.dateActivity=t.shortDate},changeDuration:function(t){-1!==this.duration.indexOf(",")&&(this.duration=this.duration.replace(/,/g,"")),this.duration=isNaN(this.formatCoinWithoutDollar(this.duration))?this.formatCoinWithoutDollar(0):this.formatCoinWithoutDollar(this.duration),new RegExp("^[0-9]+(.[0-9]{1,2})?$").test(this.duration)?(this.totalAmount=this.formatCoinWithoutDollar(Number(this.duration)*Number(this.rate)),document.getElementById("txtDuration").classList.remove("is-invalid")):(this.duration=this.formatCoinWithoutDollar(0),document.getElementById("txtDuration").classList.add("is-invalid"))},changeTotalAmount:function(){this.duration=this.formatCoinWithoutDollar(1),-1!==this.totalAmount.indexOf(",")&&(this.totalAmount=this.totalAmount.replace(/,/g,"")),this.rate=this.formatCoinWithoutDollar(this.totalAmount),this.totalAmount=this.formatCoinWithoutDollar(this.totalAmount)},validateDuration:function(){if(""!==this.duration||null===document.getElementById("txtDuration")){var t=new RegExp("(^(([0-9]{1,2}))((:[0-9]{1,2})?))$|(^([0-9]{1,2})$)"),e=new RegExp("(^(([0-9]{1,2}[Hh]))((:[0-9]{1,2}[Mm])?))$|(^([0-9]{1,2}[Mm])$)"),n=new RegExp("^[0-9]+(.[0-9]{1,2})?$");t.test(this.duration)||e.test(this.duration)||n.test(this.duration)||null===document.getElementById("txtDuration")?null!==document.getElementById("txtDuration")&&document.getElementById("txtDuration").classList.remove("is-invalid"):document.getElementById("txtDuration").classList.add("is-invalid")}else document.getElementById("txtDuration").classList.remove("is-invalid")},validateFields:function(){var t=!0,e=new RegExp("[+-]?([0-9]*[.])?[0-9]+");return""===this.duration&&null!==document.getElementById("txtDuration")?this.duration="0":e.test(this.duration)||null===document.getElementById("txtDuration")?document.getElementById("txtDuration").classList.remove("is-invalid"):(document.getElementById("txtDuration").classList.add("is-invalid"),t=!1),this.dateActivity&&null!==this.dateActivity&&""!==this.dateActivity?document.getElementById("input-newTimeDate").classList.remove("is-invalid"):(document.getElementById("input-newTimeDate").classList.add("is-invalid"),t=!1),this.currentFirmUser&&null!==this.currentFirmUser&&""!==this.currentFirmUser?document.getElementById("selectTimeFirmUser").style.outline="":(document.getElementById("selectTimeFirmUser").style.outline="1px solid red",t=!1),this.currentCase&&null!==this.currentCase&&""!==this.currentCase?document.getElementById("selectTimeCase").style.outline="":(document.getElementById("selectTimeCase").style.outline="1px solid red",t=!1),this.rate&&null!==this.rate&&""!==this.rate?document.getElementById("txtTimeRate").classList.remove("is-invalid"):(document.getElementById("txtTimeRate").classList.add("is-invalid"),t=!1),t},parseDuration:function(t){if(-1!==t.indexOf(",")){var e=60*Number("0."+t.split(",")[1]);return-1!==String(e).indexOf(".")&&(e=String(e).split(".")[0]),t=t.split(",")[0]+"H:"+e+"M"}if(-1!==t.indexOf(".")){var n=60*Number("0."+t.split(".")[1]);return-1!==String(n).indexOf(".")&&(n=String(n).split(".")[0]),t=t.split(".")[0]+"H:"+n+"M"}return t+"H"},saveActivity:function(){this.isSaveActivity=!0,this.data_edit&&null!==this.data_edit?this.editActivity():this.addActivity()},addActivity:function(){var t=this;if(!1!==this.validateFields()){var e={sourceId:this.sourceId,sourceType:this.sourceType,caseId:Number(this.currentCase.id),contactId:Number(this.contact_id),type:"time",billingCategoryId:this.currentCategory&&null!==this.currentCategory?this.currentCategory._id:null,description:this.description,userId:this.currentFirmUser.id,rate:this.unparseFormatCoin(this.rate),nonBillableStatus:this.isNonBillable,quantity:""===this.duration||null===this.duration?"00h:00m":this.parseDuration(this.duration),dateActivity:this.dateActivity};this.is_billed?(e.user=this.currentFirmUser,e.billingCategory=this.currentCategory&&null!==this.currentCategory?this.currentCategory:{},e.discount=this.discount,e.quantity=this.duration,e.billable=this.duration*e.rate,e.discountPercentage=this.discountPercentage,e.tmpBillable=this.duration*e.rate,this.$emit("set-new:activity",e),setTimeout(function(){t.conditionModeSave()},100)):Tt.addActivity({token:this.token,newActivity:e}).then(function(e){t.isSaveActivity=!1,null===e.activityAdd?(t.$emit("set-new:activity",!1),popupNotification.show("Error to create activity","error")):(t.$emit("set-new:activity",e.activityAdd),t.conditionModeSave(),popupNotification.show("Activity added","success"))})}else this.isSaveActivity=!1},editActivity:function(){var t=this;if(!1!==this.validateFields())if(this.data_edit.rate=this.unparseFormatCoin(this.rate),this.data_edit.caseId=this.currentCase&&null!==this.currentCase?this.currentCase.id:null,this.data_edit.billingCategoryId=this.currentCategory&&null!==this.currentCategory?this.currentCategory._id:null,this.data_edit.description=this.description,this.data_edit.nonBillableStatus=this.isNonBillable,this.data_edit.dateActivity=this.dateActivity,this.data_edit.userId=this.currentFirmUser.id,this.is_billed)this.data_edit.quantity=this.duration,this.data_edit.discount=this.discount,this.data_edit.discountPercentage=this.discountPercentage,this.data_edit.tmpBillable=this.duration*this.data_edit.rate,this.$emit("set-edit:activity",this.data_edit),setTimeout(function(){t.conditionModeSave()},100);else{this.data_edit.quantity=this.parseDuration(this.duration);var e={billingCategoryId:this.data_edit.billingCategoryId,caseId:this.data_edit.caseId,dateActivity:this.data_edit.dateActivity,description:this.data_edit.description,discount:this.data_edit.discount,discountPercentage:this.data_edit.discountPercentage,nonBillableStatus:this.data_edit.nonBillableStatus,quantity:this.data_edit.quantity,rate:this.data_edit.rate,sourceId:this.data_edit.sourceId,sourceType:this.data_edit.sourceType,type:this.data_edit.type,userId:this.data_edit.userId};Tt.editActivity({token:this.token,_id:this.data_edit._id,editActivity:e}).then(function(e){t.isSaveActivity=!1,null===e.activityEdit?(t.$emit("set-edit:activity",!1),popupNotification.show("Error to edit activity","error")):(t.$emit("set-edit:activity",e.activityEdit),t.conditionModeSave(),popupNotification.show("Activity edited","success"))})}else this.isSaveActivity=!1},conditionModeSave:function(){!0===this.isSaveActivityAnother&&this.resetInformation(),!0===this.isSaveActivityAnother||!0===this.isSaveActivityDuplicate?(this.isSaveActivityAnother=!1,this.isSaveActivityDuplicate=!1,this.isSaveActivity=!1):this.closeModal()},saveActivityAnother:function(){this.isSaveActivity=!0,this.isSaveActivityAnother=!0,this.saveActivity()},saveActivityDuplicate:function(){this.isSaveActivity=!0,this.isSaveActivityDuplicate=!0,this.saveActivity()},resetInformation:function(){this.dateActivity=ct()().format("MM/DD/YYYY"),this.currentFirmUser=this.firmUsers[0],this.currentCase=this.case_id?this.currentCase:null,this.currentCategory=null,this.duration="",this.rate=this.formatCoinWithoutDollar(150),this.description="",this.isNonBillable=!1},setNewCategory:function(t){!1!==t&&null!==t?(this.$emit("set-new:category",t),this.currentCategory=t,this.rate=this.formatCoinWithoutDollar(t.rate),this.isNewCategory=!1,this.saveCategory=!1):this.saveCategory=!1},formatCoinWithDollar:function(t){return t&&null!==t||(t=0),t=new Intl.NumberFormat("en-US",{style:"currency",currency:"USD",minimumFractionDigits:2}).format(t)},formatCoinWithoutDollar:function(t){return t&&null!==t||(t=0),(t=new Intl.NumberFormat("en-US",{style:"currency",currency:"USD",minimumFractionDigits:2}).format(t)).replace("$","")},unparseFormatCoin:function(t){return t&&null!==t?(t=(t=t.replace("$","")).replace(/,/g,""),Number(t)):0},closeModal:function(){this.$emit("close")}}},md={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("pf-modal",{attrs:{title:t.data_edit&&null!==t.data_edit?"Edit Time Activity":"New Time Activity",noFirstHr:!0,isUbold:!0,styleContainerModal:"width:40% !important;",footerClass:"float-right"},on:{close:t.closeModal}},[n("template",{slot:"body"},[n("div",{staticClass:"mb-2"},[!0===t.isSpinner?n("pf-spinner",{attrs:{color:"black"}}):n("div",{staticClass:"row myRow"},[n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("pf-select",{attrs:{label:"Activity Category",options:t.categoriesOwn,labelStyle:"font-weight:bold;",isSearchSelect:!0,isAddNew:!0,placeholder:"Category",value:t.currentCategory},on:{input:t.setCategory}})],1)]),t._v(" "),n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("pf-select",{attrs:{label:"User",options:t.firmUsersOwn,id:"selectTimeFirmUser",labelStyle:"font-weight:bold;",isObligatory:!0,value:t.currentFirmUser,isSearchSelect:!0,placeholder:"Select User"},on:{input:t.setFirmUser}})],1)]),t._v(" "),n("div",{staticClass:"col-md-12"},[n("div",{staticClass:"form-group"},[n("pf-select",{attrs:{label:"Case",id:"selectTimeCase",options:t.casesList,labelStyle:"font-weight:bold;",isSearchSelect:!0,value:t.currentCase,disabled:!!(t.is_billed||t.source_id||t.case_id),placeholder:"Find A Case"},on:{input:t.setCase}})],1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group"},[n("pf-calendar",{attrs:{label:"Date",id:"newTimeDate",mask:"##/##/####",field:"expenseDate",labelStyle:"font-weight:bold;",validate:"required",isObligatory:!0},on:{change:t.changeDateActivity},model:{value:t.dateActivity,callback:function(e){t.dateActivity=e},expression:"dateActivity"}})],1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group"},[n("pf-input",{attrs:{label:"Rate ($)",id:"txtTimeRate",textInputGroupEnd:"/ hr",labelStyle:"font-weight:bold;",placeholder:"0.00",validate:"required",isObligatory:!0},on:{change:t.changeRate},model:{value:t.rate,callback:function(e){t.rate=e},expression:"rate"}})],1)]),t._v(" "),n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group"},[n("pf-input",{attrs:{label:"Duration In Hours",id:"txtDuration",labelStyle:"font-weight:bold;",placeholder:"Ex. 1.2"},on:{input:t.validateDuration,change:t.changeDuration},model:{value:t.duration,callback:function(e){t.duration=e},expression:"duration"}})],1)]),t._v(" "),n("div",{class:t.is_billed?"col-md-6":"col-md-8"},[n("div",{staticClass:"form-group"},[n("pf-input",{attrs:{label:"Total Amount",id:"txtTotalAmount",textInputGroup:"$",labelStyle:"font-weight:bold;",placeholder:"0.00"},on:{change:t.changeTotalAmount},model:{value:t.totalAmount,callback:function(e){t.totalAmount=e},expression:"totalAmount"}})],1)]),t._v(" "),t.is_billed?n("div",{staticClass:"col-md-6"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:""}},[n("b",[t._v("Discount")])]),t._v(" "),n("div",{staticClass:"input-group"},[n("input",{directives:[{name:"model",rawName:"v-model",value:t.discount,expression:"discount"}],staticClass:"form-control form-control-sm",attrs:{type:"text",placeholder:"Discount","aria-label":"","aria-describedby":""},domProps:{value:t.discount},on:{change:t.changeDiscount,input:function(e){e.target.composing||(t.discount=e.target.value)}}}),t._v(" "),n("div",{staticClass:"input-group-append"},[n("select",{staticClass:"custom-select custom-select-sm",on:{change:t.changeTypeDiscount}},[n("option",{domProps:{selected:!0===t.discountPercentage,value:!0}},[t._v("%")]),t._v(" "),n("option",{domProps:{selected:!0!==t.discountPercentage,value:!1}},[t._v("$")])])])])])]):n("div",{staticClass:"col-md-4"},[n("div",{staticClass:"form-group"},[n("label",{attrs:{for:""}}),t._v(" "),n("div",{staticClass:"form-check pl-0",staticStyle:{"margin-top":"13.2px"}},[n("pf-checkbox",{attrs:{label:"Non-Billable",id:"nonBillable",checked:t.isNonBillable},on:{click:function(e){t.isNonBillable=!t.isNonBillable}}})],1)])]),t._v(" "),n("div",{staticClass:"col-12"},[n("div",{staticClass:"form-group"},[n("pf-text-area",{attrs:{label:"Description",labelStyle:"font-weight:bold;",placeholder:"Enter Description Here",rows:3},model:{value:t.description,callback:function(e){t.description=e},expression:"description"}})],1)]),t._v(" "),!0===t.isNewCategory?n("pf-new-category-modal",{attrs:{saveCategory:t.saveCategory,token:t.token,isTime:!0,data_edit:null},on:{"set-new:category":t.setNewCategory,close:function(e){t.isNewCategory=!1}}}):t._e()],1)],1)]),t._v(" "),n("template",{slot:"footer"},[n("div",{staticClass:"float-right",staticStyle:{"margin-bottom":"11px !important"}},[n("pf-button",{attrs:{label:"Save",id:"btnSaveEntryExpense",classButton:"btn btn-success btn-success-ubold mb-1",contentStyle:"display:inline;",isSuccess:!0,disabled:!0===t.isSaveActivity,isAction:t.isSaveActivity},on:{click:t.saveActivity}}),t._v(" "),n("pf-button",{attrs:{label:"Save And Create Another",id:"btnSaveCreateAnotherExpense",classButton:"btn btn-secondary btn-secondary-ubold mb-1",contentStyle:"display:inline;",isSuccess:!0,disabled:!0===t.isSaveActivity,isAction:t.isSaveActivity},on:{click:t.saveActivityAnother}}),t._v(" "),n("pf-button",{attrs:{label:"Save And Clone",id:"btnSaveDuplicateExpense",classButton:"btn btn-secondary btn-secondary-ubold mb-1",contentStyle:"display:inline;",isSuccess:!0,disabled:!0===t.isSaveActivity,isAction:t.isSaveActivity},on:{click:t.saveActivityDuplicate}}),t._v(" "),n("pf-button",{attrs:{label:"Cancel",id:"btnCancelExpense",classButton:"btn btn-secondary btn-secondary-ubold mb-1",contentStyle:"display:inline;",isSuccess:!0,disabled:!0===t.isSaveActivity,isAction:t.isSaveActivity},on:{click:t.closeModal}})],1)])],2)},staticRenderFns:[]};var fd=n("VU/8")(ud,md,!1,function(t){n("LmT1")},null,null).exports,pd={name:"pf-table-grid",data:function(){return{moment:ct.a,search:null,column:null,currentSort:"",currentSortDir:"",ownRows:[],currentPage:0,from:0,limit:4,isShowLess:!0,ownPageSize:0,primaUrl:location.origin,fundsOutBalance:0,fundsInBalance:0,totalBalance:0}},props:{token:{type:String},id:{type:String},columns:{type:Array},rows:{type:Array},columndetails:{type:Array},pagesize:{type:Number},styledivtable:{type:String},is_no_filter:{type:Boolean},show_less:{type:Boolean},filterstyle:{type:String},isBalance:{type:Boolean},isAccountTransactions:{Boolean:Boolean},isEnableClientPortal:{Boolean:Boolean},isCaseShared:{Boolean:Boolean}},components:{PfCheckbox:x,PfInput:m,Editor:ld},watch:{rows:function(t){this.setPagging(t)}},filters:{formatCoin:function(t){return t&&null!==t?new Intl.NumberFormat("en-US",{style:"currency",currency:"USD",minimumFractionDigits:2}).format(t):"-"},formatDate:function(t){return t&&null!==t&&t.indexOf("T")&&(t=t.split("T")[0]),"Invalid date"!==ct()(t).format("MM/DD/YYYY")?ct()(t).format("MM/DD/YYYY"):ct()().format("MM/DD/YYYY")},formatDateDiff:function(t){t&&null!==t||(t=ct()().format("MM/DD/YYYY"));var e=-ct()().diff(ct()(t),"days");return t>ct()().format("MM/DD/YYYY")&&(e+=1),e>0?e+" Day(s)":0===e?"Today":Math.abs(e)+" Day(s) Ago"}},computed:{cols:function(){return this.ownRows.length>=1?Y()(this.ownRows[this.currentPage][0]):[]},items:function(){var t=this;if(!this.ownRows.length)return[];var e=[];return this.ownRows.forEach(function(n){e=e.concat(n.filter(function(e){var n=t.search&&t.column?[e[t.column].toLowerCase()]:Ct()(e);return(n=n.filter(function(t){return null!==t&&"string"==typeof t})).some(function(e){return!t.search||("string"==typeof e?e.toLocaleLowerCase().includes(t.search.toLowerCase()):e.toLowerCase().toString(10).includes(t.search.toLowerCase()))})}))}),this.setPagging(e),this.ownRows[this.currentPage]||(this.currentPage=0),this.ownRows[this.currentPage]?this.ownRows[this.currentPage]:this.ownRows[0]?this.ownRows[0]:[]}},mounted:function(){this.initRequest();var t=this.rows.sort(function(t,e){return new Date(e.dateActivity)-new Date(t.dueDate)});this.rows=t},methods:{initRequest:function(){var t=this;return q()(X.a.mark(function e(){return X.a.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:t.setTableInformation();case 1:case"end":return e.stop()}},e,t)}))()},setTableInformation:function(){this.ownPageSize=this.pagesize,this.rows&&this.rows.length&&this.setPagging(this.rows)},setPagging:function(t){var e=this,n=0,i=[];this.ownRows=[],this.fundsOutBalance=0,this.fundsInBalance=0,t.forEach(function(a,o){n++,i.push(a),(n===e.ownPageSize||o===t.length-1&&i.length>0)&&(e.ownRows.push(i),i=[],n=0),e.isBalance&&(e.fundsOutBalance+=a.fundsOut?a.fundsOut:0,e.fundsInBalance+=a.fundsIn?a.fundsIn:0)}),this.setFromLimitPagging()},setFromLimitPagging:function(){var t=Math.floor(this.currentPage/5);this.from=5*t,this.limit=this.from+5},mainEvent:function(t){this.$emit(t.event,t.row)},dropdownEvent:function(t){this.$emit(t.event,t.row)},showNoTr:function(t){var e=document.getElementById("noTr"+t);"none"===e.style.display?e.style.display="":e.style.display="none"},sort:function(t){t.field===this.currentSort.field&&(this.currentSortDir="asc"===this.currentSortDir?"desc":"asc"),this.currentSort=t,this.sortedRows()},sortedRows:function(){var t=this;return this.rows.sort(function(e,n){var i=1;return"desc"===t.currentSortDir&&(i=-1),e[t.currentSort.field]<n[t.currentSort.field]?-1*i:e[t.currentSort.field]>n[t.currentSort.field]?1*i:0})},setPage:function(t){this.currentPage=t},checkRow:function(t){this.$emit("check:row",t)},showSourceActivties:function(t){this.$emit("show:activities",t)},checkAllRows:function(){this.$emit("check:all-rows")},checkOneRow:function(t){this.$emit("check:one-row",t)},changeInputCoin:function(t){this.$emit("change-input-coin",t)},linkAction:function(t){this.$emit("link:action-row",t)},nextPage:function(){this.currentPage++,this.setFromLimitPagging()},previousPage:function(){this.currentPage--,this.setFromLimitPagging()},firstPage:function(){this.currentPage=0,this.setFromLimitPagging()},lastPage:function(){this.currentPage=this.ownRows.length-1,this.setFromLimitPagging()},setShowLess:function(){this.isShowLess=!this.isShowLess,this.currentPage=0,this.ownPageSize=this.isShowLess?this.pagesize:1,this.setPagging(),this.$emit("show:less",this.isShowLess)},renderHTML:function(t,e){var n=this;setTimeout(function(){null!==document.getElementById("renderHTML"+t+n.id)&&(document.getElementById("renderHTML"+t+n.id).innerHTML=e)},500)},renderDetailHTML:function(t,e){var n=this;setTimeout(function(){null!==document.getElementById("renderDetailHTML"+t+n.id)&&(document.getElementById("renderDetailHTML"+t+n.id).innerHTML=e)},500)},handleSearch:function(){this.setPagging(this.rows)},shareInClientPortal:function(t,e){t.stopPropagation(),this.$emit("client-portal:share",e)}}},_d={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"mb-2"},[n("div",{staticClass:"table-responsive",style:t.styledivtable},[t.columns&&null!==t.columns?n("table",{staticClass:"table toggle-circle mb-0 footable-loaded footable tablet breakpoint",attrs:{id:t.id}},[n("thead",[t.is_no_filter?t._e():n("tr",[n("th",{attrs:{colspan:t.columns.length}},[n("div",{staticClass:"footable-filtering-search col-3"},[n("label",{staticClass:"sr-only"},[t._v("Search")]),t._v(" "),n("div",{staticClass:"input-group",staticStyle:{left:"-25px"},style:t.filterstyle},[n("input",{directives:[{name:"model",rawName:"v-model",value:t.search,expression:"search"}],staticClass:"form-control",attrs:{type:"text",placeholder:"Search"},domProps:{value:t.search},on:{input:[function(e){e.target.composing||(t.search=e.target.value)},t.handleSearch]}}),t._v(" "),t._m(0)])]),t._v(" "),t.show_less?n("a",{staticStyle:{position:"absolute",right:"20px",top:"20px"}},[t.isShowLess?n("span",{on:{click:t.setShowLess}},[t._v("\n                                Show less\n                                "),n("i",{staticClass:"fas fa-chevron-up"})]):n("span",{on:{click:t.setShowLess}},[t._v("\n                                Show more\n                                "),n("i",{staticClass:"fas fa-chevron-down"})])]):t._e()])]),t._v(" "),n("tr",t._l(t.columns,function(e,i){return n("th",{key:i,staticClass:"footable-visible footable-first-column footable-sortable",class:"coin"===e.type?"text-right":"",style:e.style,attrs:{"data-toggle":"true"},on:{click:function(n){return t.sort(e)}}},["checkbox"===e.type?n("pf-checkbox",{attrs:{label:e.label,id:t.id+e.id},on:{click:t.checkAllRows}}):[t._v("\n                            "+t._s(e.label)+"\n                            "),n("span",{class:"desc"===t.currentSortDir&&t.currentSort.field===e.field?"fas fa-sort-alpha-down ml-1":"asc"===t.currentSortDir&&t.currentSort.field===e.field?"fas fa-sort-alpha-up ml-1":"fas fa-sort ml-1"})]],2)}),0)]),t._v(" "),t._l(t.items,function(e,i){return n("tbody",{key:i+e._id+t.id},[n("tr",{staticClass:"footable-even",style:e.styleRow,attrs:{id:"trAccordion"+e._id+t.id}},t._l(t.columns,function(i,a){return n("td",{key:a,staticClass:"footable-visible footable-last-column footable-last-visible",staticStyle:{"max-width":"160px"},style:"actions"===i.type?"display: table-cell;":i.tdStyle?i.tdStyle:"",on:{click:function(n){"actions"!==i.type&&t.columndetails&&null!==t.columndetails&&t.columndetails.length?t.showNoTr(e._id+t.id):t.$emit("select-row",e)}}},["date"===i.type?n("span",{staticClass:"footable-visible letterUbold"},[t._v("\n                            "+t._s(t._f("formatDate")(e[i.field]))+"\n                        ")]):"dateDiff"===i.type?n("span",{staticClass:"footable-visible letterUbold"},[t._v("\n                            "+t._s(t._f("formatDateDiff")(e[i.field]))+"\n                        ")]):"inputCoin"===i.type?n("span",{staticClass:"footable-visible letterUbold"},[n("pf-input",{attrs:{id:e._id?"txtInputCoinFooTable"+e._id+t.id:"txtInputCoinFooTable"+e.id+t.id,textInputGroupEnd:i.symbol,divInput:"mb-0",labelStyle:"font-weight:bold;",placeholder:"0.00"},on:{change:function(n){return t.changeInputCoin(e)}},model:{value:e[i.field],callback:function(n){t.$set(e,i.field,n)},expression:"row[column.field]"}})],1):"coin"===i.type?n("span",{staticClass:"footable-visible letterUbold float-right"},[i.condition&&-1===i.condition.value.indexOf(e[i.condition.key])?n("span",{style:i.styleField},[t._v("\n                                "+t._s(e[i.field])+"\n                            ")]):n("span",{style:i.styleField},[t._v("\n                                "+t._s(t._f("formatCoin")(e[i.field]))+"\n                            ")])]):"checkbox"===i.type?n("pf-checkbox",{attrs:{id:t.id+i.oneCheckId+e._id,checked:e.isCheck},on:{click:function(n){return t.checkOneRow(e)}}}):"link"===i.type?n("a",{attrs:{href:t.primaUrl+"/"+i.item+"/show?id="+e[i.keyId]}},[t._v("\n                            "+t._s(e[i.field])+"\n                        ")]):"linkAction"===i.type?n("a",{staticStyle:{color:"#0056b3"},on:{click:function(n){return t.linkAction(e)}}},[t._v("\n                            "+t._s(e[i.field])+"\n                        ")]):i.object?n("span",{staticClass:"footable-visible letterUbold"},[i.keyTwo&&e[i.object]?n("span",[t._v("\n                                "+t._s(e[i.object][i.keyOne]+" "+e[i.object][i.keyTwo])+"\n                            ")]):e[i.object]?n("span",[t._v("\n                                "+t._s(e[i.object][i.keyOne])+"\n                            ")]):t._e()]):"badge"===i.type?n("span",{staticClass:"badge",class:e.classBadge},[t._v("\n                            "+t._s(e[i.field])+"\n                        ")]):"badge&link"===i.type?n("span",[n("span",{staticClass:"badge",class:e.classBadge},[t._v("\n                                "+t._s(e[i.badge])+"\n                            ")]),t._v(" "),n("a",{staticStyle:{color:"#0056b3"},on:{click:function(n){return t.linkAction(e)}}},[t._v("\n                                "+t._s(e[i.link])+"\n                            ")])]):"objectList"===i.type?n("span",t._l(e[i.field],function(e,i){return n("p",{key:i},[t._v("\n                                "+t._s(e)+"\n                            ")])}),0):"color"===i.type?n("span",[n("span",{staticClass:"dot-color",style:"background-color:"+e[i.field]+";"})]):"clientPortal"===i.type?n("span",{staticClass:"badge",class:(t.isEnableClientPortal||e.contact&&e.contact.clientPortal)&&(t.isCaseShared||e.case&&e.case.clientPortal)&&e[i.field]?"badge-success":"Unpaid"!==e.status&&"Paid"!==e.status?"badge-default":"badge-primary",style:"Unpaid"!==e.status&&"Paid"!==e.status?"pointer-events: none;":"",on:{click:function(n){return t.shareInClientPortal(n,e)}}},[n("i",{staticClass:"fas fa-universal-access"}),t._v("\n                            "+t._s((t.isEnableClientPortal||e.contact&&e.contact.clientPortal)&&(t.isCaseShared||e.case&&e.case.clientPortal)&&e[i.field]?"Shared":"Share")+"\n                        ")]):"actions"===i.type?n("div",{staticClass:"btn-group"},[i.mainAction.show&&-1===i.mainAction.show.values.indexOf(e[i.mainAction.show.key])?t._e():n("button",{staticClass:"btn btn-secondary mr-0 btn-soft-dark waves-effect waves-light btn-sm",attrs:{type:"button",disabled:i.mainAction.disabled&&e[i.mainAction.disabled.key]===i.mainAction.disabled.value},on:{click:function(n){t.mainEvent({row:e,event:i.mainAction.altern&&-1!==i.mainAction.altern.values.indexOf(e[i.mainAction.altern.key])?i.mainAction.altern.event:i.mainAction.event})}}},[t._v("\n                                "+t._s(i.mainAction.altern&&-1!==i.mainAction.altern.values.indexOf(e[i.mainAction.altern.key])?i.mainAction.altern.label:i.mainAction.label)+"\n                                "),i.mainAction.classIcon?n("i",{class:i.mainAction.classIcon}):t._e()]),t._v(" "),i.mainAction.noDrop&&-1===i.mainAction.noDrop.values.indexOf(e[i.mainAction.noDrop.key])?t._e():n("button",{directives:[{name:"show",rawName:"v-show",value:i.dropdownActions,expression:"column.dropdownActions"}],staticClass:"btn btn-secondary myDropToggle dropdown-toggle dropdown-toggle-split btn-soft-dark waves-effect waves-light btn-sm",attrs:{type:"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[n("span",{staticClass:"fas fa-sort-down iconFooTable"})]),t._v(" "),i.dropdownActions?n("div",{staticClass:"dropdown-menu dropdwonMenuTableGrid"},t._l(i.dropdownActions,function(i,a){return n("span",{key:a,style:i.disabled?"cursor:not-allowed;":""},[n("a",{directives:[{name:"show",rawName:"v-show",value:!i.show||-1!==i.show.values.indexOf(e[i.show.key])||-1!==i.show.values.indexOf(e[i.show.keyAux])||"add-time"===i.event&&e.caseId,expression:"\n                                            !action.show ||\n                                            (\n                                                action.show.values.indexOf(row[action.show.key]) !== -1 ||\n                                                action.show.values.indexOf(row[action.show.keyAux]) !== -1\n                                            ) ||\n                                            (\n                                                action.event === 'add-time' &&\n                                                row.caseId\n                                            )\n                                        "}],staticClass:"dropdown-item",class:"Delete"===i.label||"Remove"===i.label?"text-danger":i.class?i.class:"Add Time"===i.label?"link-time":"",style:i.disabled?"pointer-events:none;background-color:#b5b5b5":"",on:{click:function(n){return t.dropdownEvent({row:e,event:i.event})}}},[t._v("\n                                        "+t._s(i.label)+"\n                                    ")])])}),0):t._e()]):n("div",{staticClass:"footable-visible",staticStyle:{"text-overflow":"ellipsis",overflow:"hidden","white-space":"inherit","max-height":"28px"}},["iconBoolean"===i.type?n("span",[n("i",{class:i[e[i.field]]})]):"renderHTML"===i.type?n("span",{style:i.styleField,attrs:{id:"renderHTML"+e._id+t.id}},[t._v("\n                                "+t._s(t.renderHTML(e._id,e[i.field]))+"\n                            ")]):n("span",{style:i.styleField},[e.src?n("img",{attrs:{src:e.src,width:"30px"}}):t._e(),t._v("\n                                "+t._s(e[i.field])+"\n                            ")])]),t._v(" "),i.badgeAux&&e[i.badgeAux.key]&&null!==e[i.badgeAux.key]?n("span",{staticClass:"badge",class:i.badgeAux.class},[t._v("\n                            "+t._s(i.badgeAux.label)+"\n                        ")]):t._e(),t._v(" "),i.badgeError&&e[i.badgeError.key]?n("span",{staticClass:"badge",class:i.badgeError.class},[t._v("\n                            "+t._s(i.badgeError.label)+"\n                            "),i.badgeError.icon?n("i",{class:i.badgeError.iconClass}):t._e()]):i.badgeChecking&&e[i.badgeChecking.key]&&"PAID"!==e[i.badgeChecking.key]?n("span",{staticClass:"badge",class:"PENDING"===e[i.badgeChecking.key]?"badge-default":"badge-danger"},[t._v("\n                            "+t._s(e[i.badgeChecking.key])+"\n                            "),i.badgeChecking.icon?n("i",{class:"PENDING"===e[i.badgeChecking.key]?"fas fa-hourglass-half":"fas fa-exclamation-triangle"}):t._e()]):t._e()],1)}),0),t._v(" "),n("tr",{staticClass:"footable-detail-row",staticStyle:{display:"none"},attrs:{id:"noTr"+e._id+t.id}},[n("td",{attrs:{colspan:t.columns.length}},[n("table",{staticClass:"footable-details table toggle-circle mb-0 default tablet breakpoint"},[e?n("tbody",t._l(t.columndetails,function(i,a){return n("tr",{key:a,staticClass:"footable-even2"},["errorPayLexCharge"!==i.field||"errorPayLexCharge"===i.field&&e[i.field]?n("th",[t._v("\n                                        "+t._s(i.label)+":\n                                    ")]):t._e(),t._v(" "),"textArea"===i.type?n("td",[n("textarea",{directives:[{name:"model",rawName:"v-model",value:e[i.field],expression:"row[columnDetail.field]"}],staticStyle:{"max-height":"auto"},attrs:{id:"",cols:"30",rows:"10",disabled:""},domProps:{value:e[i.field]},on:{input:function(n){n.target.composing||t.$set(e,i.field,n.target.value)}}})]):"textAreaEdit"===i.type?n("td",[n("textarea",{directives:[{name:"model",rawName:"v-model",value:e[i.field],expression:"row[columnDetail.field]"}],staticStyle:{"max-height":"auto"},attrs:{id:"",cols:"30",rows:"10"},domProps:{value:e[i.field]},on:{input:function(n){n.target.composing||t.$set(e,i.field,n.target.value)}}})]):"tinymce"===i.type?n("td",[n("editor",{staticStyle:{height:"500px"},attrs:{"api-key":"iii0lh8jpntau15yl9c5d64rnl8fuo3ixtdtjh77a375kpze",init:{plugins:"table wordcount, link",toolbar:"link"}},model:{value:e[i.field],callback:function(n){t.$set(e,i.field,n)},expression:"row[columnDetail.field]"}})],1):"link"===i.type?n("td",{staticClass:"footable-row-detail-cell footable-detail-show footable-odd"},[n("a",{attrs:{href:t.primaUrl+"/cases/show?id="+e.caseId}},[t._v(t._s(e.caseFullName))])]):"checkbox"===i.input?n("td",{staticClass:"footable-row-detail-cell footable-detail-show footable-odd"},[n("div",{staticClass:"footable-row-detail-row"},[n("div",{staticClass:"footable-row-detail-value"},[n("div",{staticClass:"checkbox checkbox-success form-check-inline"},[n("input",{attrs:{type:"checkbox",id:"inlineCheckbox2",value:"option1"},domProps:{checked:"on"===e.visibleOnClientPortal},on:{click:function(n){return t.checkRow({note:e,isVisible:"on"!==e.visibleOnClientPortal})}}}),t._v(" "),n("label",{staticStyle:{"margin-top":"-16px","margin-left":"7px"},attrs:{for:"inlineCheckbox2"}})])])])]):i.object?n("td",{staticClass:"footable-row-detail-cell footable-detail-show footable-odd"},[i.keyTwo&&e[i.object]?n("span",[t._v("\n                                            "+t._s(e[i.object][i.keyOne]+" "+e[i.object][i.keyTwo])+"\n                                        ")]):n("span",[t._v("\n                                            "+t._s(e[i.object][i.keyOne])+"\n                                        ")])]):"coin"===i.type?n("td",{staticClass:"footable-row-detail-cell footable-detail-show footable-odd"},[i.condition&&-1===i.condition.value.indexOf(e[i.condition.key])?n("span",{style:i.styleField},[t._v("\n                                            "+t._s(e[i.field])+"\n                                        ")]):n("span",{style:i.styleField},[t._v("\n                                            "+t._s(t._f("formatCoin")(e[i.field]))+"\n                                        ")])]):"renderHTML"===i.type?n("td",[n("span",{attrs:{id:"renderDetailHTML"+e._id+t.id}},[t._v("\n                                            "+t._s(t.renderDetailHTML(e._id,e[i.field]))+"\n                                        ")])]):"errorPayLexCharge"!==i.field||"errorPayLexCharge"===i.field&&e[i.field]?n("td",{staticClass:"footable-row-detail-cell footable-detail-show footable-odd"},[n("span",{class:i.class?i.class:""},[t._v("\n                                            "+t._s(e[i.field])+"\n                                        ")])]):t._e()])}),0):t._e()])])])])}),t._v(" "),t.isBalance&&(t.fundsOutBalance&&t.fundsOutBalance>0||t.fundsInBalance&&t.fundsInBalance>0)?n("tbody",[n("tr",[n("td"),t._v(" "),n("td"),t._v(" "),t.isAccountTransactions?n("td"):t._e(),t._v(" "),t.isAccountTransactions?n("td"):t._e(),t._v(" "),n("td",{staticClass:"text-right",staticStyle:{color:"#1abc9c"}},[t._v("\n                        "+t._s(t._f("formatCoin")(t.fundsInBalance))+"\n                    ")]),t._v(" "),n("td",{staticClass:"text-right text-danger"},[t._v("\n                        "+t._s(t._f("formatCoin")(t.fundsOutBalance))+"\n                    ")]),t._v(" "),n("td"),t._v(" "),n("td",{staticClass:"text-right"},[n("b",[t._v("Total:")]),t._v(" "),n("span",{style:t.fundsInBalance-t.fundsOutBalance>0?"color:#1abc9c;":"color:red;"},[t._v("\n                            "+t._s(t._f("formatCoin")(t.fundsInBalance-t.fundsOutBalance))+"\n                        ")])])])]):t._e(),t._v(" "),t.ownRows.length>1?n("tbody",[n("tr",{staticClass:"active"},[n("td",{staticClass:"footable-visible bg-white",attrs:{colspan:t.columns.length}},[n("div",{staticClass:"text-right"},[n("ul",{staticClass:"pagination pagination-rounded justify-content-end footable-pagination m-t-10 mb-0"},[n("li",{staticClass:"footable-page-arrow",style:0===t.currentPage?"pointer-events:none;":"",on:{click:t.firstPage}},[n("a",{attrs:{"data-page":"first",href:"#first"}},[t._v("«")])]),t._v(" "),n("li",{staticClass:"footable-page-arrow",style:0===t.currentPage?"pointer-events:none;":"",on:{click:t.previousPage}},[n("a",{attrs:{"data-page":"prev",href:"#prev"}},[t._v("‹")])]),t._v(" "),t._l(t.ownRows,function(e,i){return n("li",{directives:[{name:"show",rawName:"v-show",value:i>=t.from&&i<t.limit,expression:"indexPage >= from && indexPage < limit"}],key:i,staticClass:"footable-page",class:i===t.currentPage?"active":"",on:{click:function(e){t.currentPage=i}}},[n("a",{attrs:{"data-page":"0",href:"#"}},[t._v(t._s(i+1))])])}),t._v(" "),t.ownRows.length>5&&t.currentPage<t.ownRows.length-5?n("span",[t._v("...")]):t._e(),t._v(" "),n("li",{staticClass:"footable-page-arrow",style:t.currentPage===t.ownRows.length-1?"pointer-events:none;":"",on:{click:t.nextPage}},[n("a",{attrs:{"data-page":"next",href:"#next"}},[t._v("›")])]),t._v(" "),n("li",{staticClass:"footable-page-arrow",style:t.currentPage===t.ownRows.length-1?"pointer-events:none;":"",on:{click:t.lastPage}},[n("a",{attrs:{"data-page":"last",href:"#last"}},[t._v("»")])])],2),t._v(" "),n("div",{staticClass:"divider"}),t._v(" "),n("span",{staticClass:"label label-default"},[t._v(t._s(t.currentPage+1)+" of "+t._s(t.ownRows.length))])])])])]):t._e()],2):t._e()])])},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"input-group-btn"},[e("button",{staticClass:"btn btn-primary",attrs:{type:"button"}},[e("span",{staticClass:"fas fa-search"})])])}]};var Ad=n("VU/8")(pd,_d,!1,function(t){n("HSJk")},"data-v-3dc2c4ea",null).exports,bd={name:"pf-notes",data:function(){return{notes:[],isCase:!1,isModal:!1,isPopUp:!1,titlePopUp:"",messagePopUp:"",actionPopUp:"",typePopUp:"",currentNote:{},btnRight:"",deleteNoteId:"",isDown:!1,userFullName:"",cases:[{name:"None"}],caseModel:{},actionNote:!1,moment:ct.a,noteIdToPrint:null,sourceNote:null,isSource:!1,columns:[{label:"Date",field:"date",type:"date",style:"width: 130px !important;"},{label:"Created By",field:"userFullName",style:"width: 180px !important;"},{label:"Subject",field:"subject",style:"width: 400px !important;"},{label:"Detail",field:"body",type:"renderHTML",style:"width: 760px !important;"},{label:"Actions",style:"width: 115px !important;",mainAction:{label:"Edit",event:"edit"},dropdownActions:[{label:"Print",event:"print"},{label:"Add Time",event:"add-time",show:{key:"caseId",keyAux:"",values:[]}},{label:"Delete",event:"delete:row"}],type:"actions"}],columnDetails:[{label:"Detail",field:"body",type:"renderHTML"},{label:"Case",field:"caseFullName",type:"link"},{label:"Show In Client Portal",field:"isShowClientPortal",input:"checkbox"}]}},props:{token:{type:String},contactid:{type:Number},caseid:{type:Number},renderurl:{type:String}},components:p()({PfModal:Dl,Editor:ld,PfPopUp:$,vSelect:y.a,PfCalendar:lt,PfTextArea:T,PfTableGrid:Ad,PfNewTimeActivityModal:fd},"Editor",ld),created:function(){this.getNotes(),graphqlUser.enableBills||this.columns[this.columns.length-1].dropdownActions.splice(1,1)},methods:{getNotes:function(){var t=this;void 0===this.caseid?Tt.getNotesContact({token:this.token,contactId:this.contactid}).then(function(e){void 0!==e.notes&&null!==e.notes&&(t.notes=e.notes.sort(function(t,e){return new Date(e.date)-new Date(t.date)}),t.notes.forEach(function(e,n){t.notes[n].date=ct()(e.date.split("T")[0]).format("MM/DD/YYYY"),e.userFullName=e.user.firstName+" "+e.user.lastName})),t.getCases()}):void 0!==this.caseid&&Tt.getNotesCase({token:this.token,caseId:this.caseid}).then(function(e){void 0!==e.notes&&null!==e.notes&&(t.notes=e.notes.sort(function(t,e){return new Date(e.date)-new Date(t.date)}),t.notes.forEach(function(e,n){t.notes[n].date=ct()(e.date.split("T")[0]).format("MM/DD/YYYY"),e.userFullName=e.user.firstName+" "+e.user.lastName}),t.getCases())})},getCases:function(){var t=this;void 0===this.caseid?Tt.getCasesContact({token:this.token,field:"id",value:void 0!==this.contactid?this.contactid:this.notes[0].userId}).then(function(e){void 0!==e.contacts&&null!==e.contacts&&(t.userFullName=e.contacts[0].user.firstName+" "+e.contacts[0].user.lastName,t.cases=t.cases.concat(e.contacts[0].cases),t.cases.forEach(function(e,n){"None"!==e.name?t.cases[n].label=e.name+" - "+e.caseType.name:t.cases[n].label=e.name,t.notes.forEach(function(i,a){i.caseId===e.id&&(t.notes[a].caseFullName=t.cases[n].label)})}),t.notes=yl()([],t.notes,t.notes))}):this.columnDetails.splice(1,1),this.getCurrentCase()},getCurrentCase:function(){var t=this;void 0!==this.caseid&&Tt.getCaseForId({token:this.token,caseId:this.caseid}).then(function(e){t.caseModel=e.cases[0],t.caseModel.label=t.caseModel.name+" - "+t.caseModel.caseType.name})},addNote:function(){this.currentNote={date:ct()().format("MM/DD/YYYY"),contactId:this.contactid,caseId:void 0!==this.caseid?this.caseid:null,body:""},this.btnRight="Add",this.isModal=!0,void 0===this.caseid&&(this.caseModel=this.cases[0]),this.setStyleSelect()},setStyleSelect:function(){var t=document.querySelector(".vs__dropdown-toggle");null!==t&&(t.style.height="30px");var e=document.querySelector(".vs__open-indicator");null!==e&&(e.style.marginTop="8px")},initEditor:function(){setTimeout(function(){var t=document.querySelector(".tox-editor-header"),e=document.querySelector(".tox-tinymce-aux");t.style.zIndex="0",e.style.zIndex="9999"},1e3)},deleteNote:function(t){this.deleteNoteId=t._id,this.titlePopUp="Delete Note",this.messagePopUp="Are you sure you want to delete this note?",this.typePopUp="delete-official",this.isPopUp=!0,this.actionPopUp="confirmDelete"},setActionPopUp:function(){"confirmDelete"===this.actionPopUp&&this.confirmDelete()},confirmDelete:function(){var t=this;Tt.deleteNote({token:this.token,_id:this.deleteNoteId}).then(function(e){void 0!==e.noteDelete&&null!==e.noteDelete&&t.notes.forEach(function(n,i){n._id===e.noteDelete._id&&t.notes.splice(i,1)}),t.isPopUp=!1})},showEdit:function(t){var e=this;this.currentNote=JSON.parse(U()(t)),this.btnRight="Update",this.isModal=!0,this.setStyleSelect(),this.cases.forEach(function(t){e.currentNote.caseId===t.id&&(e.caseModel=t)}),0===Y()(this.caseModel).length&&(this.caseModel=this.cases[0])},insertNote:function(){var t=this;if("Add"===this.btnRight)this.actionNote=!0,Tt.addNote({token:this.token,newNote:this.currentNote}).then(function(e){void 0!==e.noteAdd&&null!==e.noteAdd&&(e.noteAdd.date=ct()(t.currentNote.date).format("MM/DD/YYYY"),t.notes=[e.noteAdd].concat(t.notes),t.notes.forEach(function(t){t.userFullName=t.user.firstName+" "+t.user.lastName}),void 0!==t.contactid?(window.apiContact&&window.apiContact.integrations.length>0&&t.sentNoteToIntegration({event:"created",itemId:e.noteAdd._id,partner:window.apiContact.integrations[0].prefix,type:void 0!==t.caseid?"matter":"contact"}),t.cases.forEach(function(e,n){t.notes.forEach(function(i,a){i.caseId===e.id&&(t.notes[a].caseFullName=t.cases[n].label)})}),t.notes=yl()([],t.notes,t.notes)):void 0!=window.isTwoWaySync&&t.sendMatterNoteToIntegration({event:"created",itemId:e.noteAdd._id})),t.currentNote={},t.actionNote=!1,t.isModal=!1});else if("Update"===this.btnRight){this.actionNote=!0;var e={body:this.currentNote.body,subject:this.currentNote.subject,date:this.currentNote.date,caseId:this.currentNote.caseId,visibleOnClientPortal:this.currentNote.visibleOnClientPortal};Tt.editNote({token:this.token,_id:this.currentNote._id,editNote:e}).then(function(e){void 0!==e.noteEdit&&null!==e.noteEdit&&(t.notes.forEach(function(n,i){n._id===e.noteEdit._id&&(e.noteEdit.date=ct()(e.noteEdit.date.split("T")[0]).format("MM/DD/YYYY"),t.notes[i]=e.noteEdit)}),t.notes.forEach(function(t){t.userFullName=t.user.firstName+" "+t.user.lastName}),void 0!==t.contactid?(window.apiContact&&window.apiContact.integrations.length>0&&t.sentNoteToIntegration({event:"updated",itemId:e.noteEdit._id,partner:window.apiContact.integrations[0].prefix,type:void 0!==t.caseid?"matter":"contact"}),t.cases.forEach(function(e,n){t.notes.forEach(function(i,a){i.caseId===e.id&&(t.notes[a].caseFullName=t.cases[n].label)})}),t.notes=yl()([],t.notes,t.notes)):void 0!=window.isTwoWaySync&&t.sendMatterNoteToIntegration({event:"updated",itemId:e.noteEdit._id})),t.currentNote={},t.actionNote=!1,t.isModal=!1})}},showHide:function(t){var e=!1;document.getElementById("iconDown"+t).classList.forEach(function(t){"d-none"===t&&(e=!0)}),!0===e?(document.getElementById("iconDown"+t).classList.remove("d-none"),document.getElementById("iconUp"+t).classList.add("d-none")):(document.getElementById("iconDown"+t).classList.add("d-none"),document.getElementById("iconUp"+t).classList.remove("d-none"))},setCase:function(t){this.caseModel=t,this.currentNote.caseId=this.caseModel.id?this.caseModel.id:null},setVisibleOnClientPortal:function(t){this.currentNote=t.note,this.currentNote.visibleOnClientPortal=!0===t.isVisible?"on":"off";var e={body:this.currentNote.body,subject:this.currentNote.subject,date:this.currentNote.date,caseId:this.currentNote.caseId,visibleOnClientPortal:this.currentNote.visibleOnClientPortal};Tt.editNote({token:this.token,_id:this.currentNote._id,editNote:e}).then(function(t){void 0!==t.noteEdit&&null!==t.noteEdit&&popupNotification.show("Note edited","success")})},changeCalendar:function(t){this.currentNote.date=t.shortDate},sentNoteToIntegration:function(t){var e=this;Tt.getGraphIntegrations({token:this.token}).then(function(n){n.integrations&&null!==n.integrations&&n.integrations.length>0&&n.integrations.forEach(function(n){if(n.prefix===t.partner&&!0===n.connected&&!0===n.twoWaySync){var i="",a="";"created"==t.event?(i="insert",a="created"):(i="update",a="updated"),Tt.sentToIntegrations({token:e.token,actionRoute:i,item:"note",itemId:t.itemId,type:t.type}).then(function(t){!0===t.success&&popupNotification.show("Note "+a+" on Integration","success")})}})})},sendMatterNoteToIntegration:function(t){var e="",n="";"created"===t.event?(e="insert",n="created"):(e="update",n="updated"),Tt.sentToIntegrations({token:this.token,actionRoute:e,item:"note",itemId:t.itemId,type:"matter"}).then(function(t){!0===t.success&&popupNotification.show("Note "+n+" on Integration","success")})},printOne:function(t){window.open(this.renderurl+"notes?token="+this.token+"&id="+t._id)},printAll:function(){void 0!==this.caseid?window.open(this.renderurl+"notes/case/?token="+this.token+"&id="+this.caseid):window.open(this.renderurl+"notes/contact/?token="+this.token+"&id="+this.contactid)},showSourceActivties:function(t){this.sourceNote=t,this.isSource=!0},getFullCaseName:function(t){var e=this.cases[this.cases.map(function(t){return t.id}).indexOf(Number(t))];return e.name+" | "+e.caseType.name},showNoTr:function(t){var e=document.getElementById("noTr"+t);"none"===e.style.display?e.style.display="":e.style.display="none"},setNewActivity:function(t){window.timeActivityInfo=t,null!==document.getElementById("triggerSendActivityContact")?document.getElementById("triggerSendActivityContact").click():null!==document.getElementById("triggerSendActivityCase")&&document.getElementById("triggerSendActivityCase").click()},setNewCategory:function(t){window.timeCategoryInfo=t,null!==document.getElementById("triggerSendCategoryContact")?document.getElementById("triggerSendCategoryContact").click():null!==document.getElementById("triggerSendCategoryCase")&&document.getElementById("triggerSendCategoryCase").click()}}},xd={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[n("div",{staticClass:"row myRow mb-3"},[n("div",{},[n("button",{staticClass:"btn btn-sm btn-success",on:{click:t.addNote}},[t._v("New\n      ")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-success",on:{click:t.printAll}},[t._v("Print All")])])]),t._v(" "),n("pf-table-grid",{attrs:{id:"table-notes",columns:t.columns,columndetails:t.columnDetails,rows:t.notes,pagesize:10,token:t.token},on:{edit:t.showEdit,print:t.printOne,"delete:row":t.deleteNote,"check:row":t.setVisibleOnClientPortal,"add-time":t.showSourceActivties}}),t._v(" "),n("pf-modal",{directives:[{name:"show",rawName:"v-show",value:!0===t.isModal,expression:"isModal === true"}],attrs:{title:"Add"===t.btnRight?"New Note":"Edit Note",noFirstHr:!0,btnright:t.btnRight,isBtnRightDisabled:!t.currentNote.subject||null===t.currentNote.subject||""===t.currentNote.subject||!t.currentNote.body||null===t.currentNote.body||""===t.currentNote.body,isAction:t.actionNote},on:{close:function(e){t.isModal=!1},click:t.insertNote}},[n("template",{slot:"body"},[n("div",{staticClass:"row myRow"},[n("div",{staticClass:"col-12"},[n("div",{staticClass:"form-group"},[n("label",[n("b",[t._v("Subject")])]),t._v(" "),n("input",{directives:[{name:"model",rawName:"v-model",value:t.currentNote.subject,expression:"currentNote.subject"}],staticClass:"form-control form-control-sm",attrs:{type:"text"},domProps:{value:t.currentNote.subject},on:{input:function(e){e.target.composing||t.$set(t.currentNote,"subject",e.target.value)}}})])]),t._v(" "),n("div",{staticClass:"col-lg-6"},[n("div",{staticClass:"form-group"},[n("label",[n("b",[t._v("Case")])]),t._v(" "),void 0===t.caseid?n("v-select",{attrs:{id:"v-select-cases",options:t.cases},on:{input:t.setCase},model:{value:t.caseModel,callback:function(e){t.caseModel=e},expression:"caseModel"}}):n("p",[t._v(t._s(t.caseModel.label))])],1)]),t._v(" "),n("div",{staticClass:"col-lg-6"},[n("div",{staticClass:"form-group"},[n("label",[n("b",[t._v("Date")])]),t._v(" "),n("pf-calendar",{attrs:{id:"dateNote",mask:"##/##/####",divCalendar:"marginBotZero",model:"dateNote",field:"dateNote"},on:{change:t.changeCalendar},model:{value:t.currentNote.date,callback:function(e){t.$set(t.currentNote,"date",e)},expression:"currentNote.date"}})],1)])]),t._v(" "),n("div",{staticClass:"row myRow"},[n("div",{staticClass:"col-12"},[n("div",{staticClass:"form-group"},[n("label",[n("b",[t._v("Detail")])]),t._v(" "),n("editor",{attrs:{"api-key":"355zh1ube83rrfmxeh2uhh3t3pfpkxjfubx3fs6mt1qz9ttw",init:{menubar:"edit view insert format table tools help",plugins:"table link",toolbar:"undo redo styleselect link bold italic alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",min_height:100,height:400,branding:!1}},model:{value:t.currentNote.body,callback:function(e){t.$set(t.currentNote,"body",e)},expression:"currentNote.body"}})],1)])])])],2),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:t.titlePopUp,message:t.messagePopUp,type:t.typePopUp},on:{close:function(e){t.isPopUp=!1},action:t.setActionPopUp}}):t._e(),t._v(" "),!0===t.isSource?n("pf-new-time-activity-modal",{attrs:{token:t.token,contact_id:t.contactid,case_id:t.sourceNote.caseId,source_id:t.sourceNote._id,source_type:"note",source_description:t.sourceNote.subject,source_date:t.sourceNote.date},on:{"set-new:activity":t.setNewActivity,"set-new:category":t.setNewCategory,close:function(e){t.isSource=!1}}}):t._e()],1)},staticRenderFns:[]};var gd=n("VU/8")(bd,xd,!1,function(t){n("DEnR")},null,null).exports,vd={name:"pf-translate",data:function(){return{isChrome:!1,isTranslated:!0}},props:{isLanding:{type:Boolean},title:{type:String},clientName:{type:String}},mounted:function(){var t=this,e=this;this.$nextTick(function(){t.googleTranslateInit()}),this.changeGoogleStyles(),document.addEventListener("DOMSubtreeModified",function(t){!1===e.isChrome?"BODY"===t.target.tagName&&window.google&&("es-US"!==t.target.parentNode.lang?e.isTranslated=!0:e.isTranslated=!1):"SPAN"===t.target.tagName&&("Select Language"===t.target.textContent?e.isTranslated=!1:e.isTranslated=!0)},!0)},methods:{googleTranslateInit:function(){var t=this,e=setInterval(function(){null!=google.translate.TranslateElement&&(clearInterval(e),t.googleTranslateElement("google_translate_element"))},1)},googleTranslateElement:function(t){new google.translate.TranslateElement({pageLanguage:"en",layout:google.translate.TranslateElement.InlineLayout.SIMPLE},t),"Chrome"===this.getCurrentBrowser().name&&(this.isChrome=!0)},getCurrentBrowser:function(){navigator.appVersion;var t=navigator.userAgent,e=navigator.appName,n=""+parseFloat(navigator.appVersion),i=parseInt(navigator.appVersion,10),a=void 0,o=void 0,r=void 0;return-1!=(o=t.indexOf("Opera"))?(e="Opera",n=t.substring(o+6),-1!=(o=t.indexOf("Version"))&&(n=t.substring(o+8))):-1!=(o=t.indexOf("MSIE"))?(e="Microsoft Internet Explorer",n=t.substring(o+5)):-1!=(o=t.indexOf("Chrome"))?(e="Chrome",n=t.substring(o+7)):-1!=(o=t.indexOf("Safari"))?(e="Safari",n=t.substring(o+7),-1!=(o=t.indexOf("Version"))&&(n=t.substring(o+8))):-1!=(o=t.indexOf("Firefox"))?(e="Firefox",n=t.substring(o+8)):(a=t.lastIndexOf(" ")+1)<(o=t.lastIndexOf("/"))&&(e=t.substring(a,o),n=t.substring(o+1),e.toLowerCase()==e.toUpperCase()&&(e=navigator.appName)),-1!=(r=n.indexOf(";"))&&(n=n.substring(0,r)),-1!=(r=n.indexOf(" "))&&(n=n.substring(0,r)),i=parseInt(""+n,10),isNaN(i)&&(n=""+parseFloat(navigator.appVersion),i=parseInt(navigator.appVersion,10)),{name:e,version:n,versionM:i,navigatorName:navigator.appName,navigatorAgent:navigator.userAgent}},getNavigatorLanguage:function(){return navigator.languages?navigator.languages[0]:navigator.language||navigator.userLanguage},resetTranslate:function(){this.isTranslated=!1;var t=document.getElementsByClassName("goog-te-banner-frame")[0];if(t)for(var e=t.contentDocument||t.contentWindow.document,n=e.getElementsByTagName("button"),i=0;i<n.length;i++){if(n[i].id.indexOf("restore")>=0)return n[i].click(),void e.getElementsByClassName("goog-close-link")[0].click()}},changeGoogleStyles:function(){var t=document.getElementsByClassName("goog-te-menu-frame");void 0!==t[0]?(window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth)<991&&setTimeout(function(){t[0].contentDocument.body.children[0].style.cssText="\n              max-width: 300px !important;\n              overflow: scroll !important;\n              box-sizing:border-box !important;\n              height:auto !important;\n            "},300):setTimeout(this.changeGoogleStyles,1e3)}}},Cd={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("nav",{staticClass:"navbar navbar-expand-lg navbar-light bg-light myNavBar",class:!1===t.isLanding?"myNavBarFill":""},[n("div",{staticClass:"navbar-brand questionnaires cc"},[t._v("\n    "+t._s(t.title)+"\n\n    "),n("a",{attrs:{href:"https://www.google.com/chrome/",target:"_blank"}},[!1===t.isChrome?n("span",{staticClass:"messageCh ml-2"},[t._v("We recommend you use Chrome")]):t._e()])]),t._v(" "),!1===t.isLanding?n("a",{staticClass:"goToLanding",on:{click:function(e){return t.$emit("go-landing-page")}}},[n("b",[t._v(t._s(t.clientName))])]):t._e(),t._v(" "),n("div",{staticClass:"selectTrans",attrs:{id:"navbarSupportedContent"}},[n("div",{attrs:{id:"google_translate_element"}},[!0===t.isTranslated?n("i",{staticClass:"fas fa-undo resetTranslate",on:{click:t.resetTranslate}}):t._e()])])])},staticRenderFns:[]};var yd=n("VU/8")(vd,Cd,!1,function(t){n("YqjV")},null,null).exports,wd={name:"pf-addendum",data:function(){return{addendums:[],isAddendumDialog:!1,isSpinner:!1,bodyAddendum:"",btnRight:"",editAddendumId:"",deleteAddendumId:"",isPopUp:!1,titlePopUp:"",messagePopUp:"",typePopUp:"",actionPopUp:"",addendumTitle:"",isAddAddendum:!1}},props:{questionnaireid:{type:String},token:{type:String},create:{type:Boolean},islist:{type:Boolean},applicationidceac:{type:Object,default:function(){return{msg:"",show:!1}}}},components:{PfModal:Dl,PfSpinner:r,PfInput:m,PfPopUp:$,Editor:ld},mounted:function(){this.getAddendums()},methods:{getAddendums:function(){var t=this;Tt.getAddendums({token:this.token,caseFormId:this.questionnaireid}).then(function(e){t.addendumsTitle=e.addendums,void 0!==e.addendums&&(e.addendums.forEach(function(e){null==e.model?(e.title=e.title,e.titleList=e.title):e.titleList="Generated  "+t.getLabelModel(e.model)+" "+e.title.substr(e.title.search("for"),e.title.length)}),t.addendums=e.addendums)})},getLabelModel:function(t){var e={address:"Current Address",previousAddress:"Previous Address",phones:"Phones",jobs:"Jobs",educational_history:"Educational History",criminal_history:"Criminal History",ead:"EAD",passports:"Passport History",travel_history:"Travel History",us_entry:"US Entry History",visa_history:"Visa History",marriage_history:"Marriage History",family_members:"Family Members",advance_parole:"Advance Parole History",familyChild:"Family Members Childs",familySibling:"Family Members Siblings",familyOther:"Family Members Others"};return t&&e[t]?e[t]:""},createAddendum:function(){this.btnRight="Create",this.bodyAddendum="",this.addendumTitle="",this.isAddendumDialog=!0},editAddendum:function(t){console.log(t),this.bodyAddendum="",this.addendumTitle="",this.editAddendumId="",this.bodyAddendum=t.body,this.editAddendumId=t._id,this.addendumTitle=t.title,this.btnRight="Update",this.isAddendumDialog=!0},insertAddendum:function(){var t=this;this.isAddAddendum=!0,"Create"===this.btnRight?Tt.addAddendum({token:this.token,body:this.bodyAddendum,title:""!==this.addendumTitle?this.addendumTitle:void 0,caseFormId:this.questionnaireid}).then(function(e){void 0!==e.addendumsAdd&&(t.getAddendums(),t.isAddendumDialog=!1,t.isAddAddendum=!1)}):Tt.editAddendum({token:this.token,addendumId:this.editAddendumId,body:this.bodyAddendum,title:""!==this.addendumTitle?this.addendumTitle:void 0}).then(function(e){void 0!==e.addendumsEdit&&(t.isAddendumDialog=!1,t.getAddendums())})},setActionPopUp:function(){"confirmDeleteAddendum"===this.actionPopUp?this.confirmDeleteAddendum():"confirmGenerateAddendum"===this.actionPopUp?this.confirmGenerateAddendum():"closeModal"===this.actionPopUp&&(this.isPopUp=!1)},deleteAddendum:function(t){this.deleteAddendumId=t,this.isPopUp=!0,this.titlePopUp="Delete Addendum",this.messagePopUp="Are you sure delete this addendum section.?",this.typePopUp="delete-official",this.actionPopUp="confirmDeleteAddendum"},confirmDeleteAddendum:function(){var t=this;Tt.deleteAddendum({token:this.token,addendumId:this.deleteAddendumId}).then(function(e){void 0!==e.addendumsDelete&&(t.getAddendums(),t.isPopUp=!1)})},generateAddendum:function(){var t=this;Tt.generateAddendum({token:this.token,caseFormId:this.questionnaireid}).then(function(e){void 0!==e.addendumsGenerate&&e.addendumsGenerate.length>0?(t.isPopUp=!1,t.getAddendums()):t.errorMessage()})},downloadAddendum:function(t){window.open(window.newRenderUrl+"addendum/get-one?token="+this.token+"&id="+t)},downloadAll:function(){window.open(window.newRenderUrl+"addendum/get-form?token="+this.token+"&id="+this.questionnaireid)},errorMessage:function(){this.isPopUp=!0,this.titlePopUp="Info",this.messagePopUp="Nothing to generate.",this.typePopUp="info",this.actionPopUp="closeModal"}}},Bd={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[!0===t.isAddendumDialog?n("pf-modal",{attrs:{title:"Add New Addendum",btnright:t.btnRight,isAction:t.isAddAddendum,noFirstHr:!0,isUbold:!0,noShowMenu:!0},on:{close:function(e){t.isAddendumDialog=!1},click:t.insertAddendum}},[n("template",{slot:"body"},[!0===t.isSpinner?n("pf-spinner",{attrs:{color:"black"}}):t._e(),t._v(" "),n("div",{staticClass:"m-2"},[n("pf-input",{attrs:{label:"Title",labelStyle:"font-weight:bold;"},model:{value:t.addendumTitle,callback:function(e){t.addendumTitle=e},expression:"addendumTitle"}}),t._v(" "),n("editor",{staticStyle:{height:"500px"},attrs:{"api-key":"355zh1ube83rrfmxeh2uhh3t3pfpkxjfubx3fs6mt1qz9ttw",init:{menubar:"edit view insert format table tools help",plugins:"table link",toolbar:"undo redo styleselect link bold italic alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",min_height:100,branding:!1}},model:{value:t.bodyAddendum,callback:function(e){t.bodyAddendum=e},expression:"bodyAddendum"}})],1)],1)],2):t._e(),t._v(" "),!0===t.create?n("a",{staticClass:"btnAdd btnAdd btn grey btn form-addendum btn-sm action-button",staticStyle:{cursor:"pointer","font-weight":"normal"},on:{click:t.createAddendum}},[n("i",{staticClass:"far fa-file-alt"}),t._v(" Add Addendum")]):t._e(),t._v(" "),!0===t.islist?n("div",{staticClass:"mt-3"},[n("div",{staticClass:"pb-1"},[t._m(0),t._v(" "),t.applicationidceac.show?n("span",{staticClass:"float-left mb-0 app-id",staticStyle:{color:"gray"}},[n("b",[t._v("ID: "+t._s(t.applicationidceac.msg))])]):t._e(),t._v(" "),n("div",{staticClass:"float-right mb-0"},[n("span",{staticStyle:{cursor:"pointer",color:"#00acc1"},on:{click:t.createAddendum}},[n("b",[t._v("Add Section")])]),t._v("\n        |\n\n        "),n("span",{staticStyle:{cursor:"pointer",color:"#00acc1"},on:{click:t.generateAddendum}},[n("b",[t._v("Generate")])]),t._v(" "),null!==t.addendums&&t.addendums.length>0?n("span",[t._v("\n          |\n          "),n("span",{staticStyle:{cursor:"pointer",color:"#00acc1"},on:{click:t.downloadAll}},[n("b",[t._v("Download")])])]):t._e()])]),t._v(" "),n("hr",{staticClass:"classHrEspecial"}),t._v(" "),n("div",{attrs:{id:null!==t.addendums&&t.addendums.length>0?"contentListAddendum"+t.questionnaireid:""}},t._l(t.addendums,function(e,i){return n("div",{key:i,staticClass:"mb-3 ml-2"},[n("span",[n("i",{staticClass:"fas fa-pencil-alt",staticStyle:{cursor:"pointer"},on:{click:function(n){return t.editAddendum(e)}}}),t._v(" "),n("i",{staticClass:"fas fa-minus-circle",staticStyle:{cursor:"pointer"},on:{click:function(n){return t.deleteAddendum(e._id)}}}),t._v(" "),n("i",{staticClass:"fas fa-download mr-2",staticStyle:{cursor:"pointer"},on:{click:function(n){return t.downloadAddendum(e._id)}}}),t._v(" "),n("h6",{staticStyle:{display:"inline"}},[t._v(t._s("Addendum: "+e.titleList))])])])}),0)]):t._e(),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:t.titlePopUp,message:t.messagePopUp,type:t.typePopUp},on:{close:function(e){t.isPopUp=!1},action:t.setActionPopUp}}):t._e()],1)},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("span",{staticClass:"float-left mb-0",staticStyle:{color:"gray"}},[e("b",[this._v("Addendum")])])}]};var kd=n("VU/8")(wd,Bd,!1,function(t){n("zuQt")},null,null).exports,Ed=n("y5BL"),Id=n.n(Ed),Dd=n("BO1k"),Sd=n.n(Dd),Nd={name:"pf-left-side-bar",data:function(){return{isHide:!1,currentPage:1}},props:{totalpages:{type:Object},viewerurl:{type:String},token:{type:String},indexpage:{type:Number}},watch:{indexpage:function(t){this.currentPage=t,this.scrollActive(this.currentPage)}},computed:{stateStyle:function(){return this.isHide?"":"left:0;"},direction:function(){return this.isHide?"right":"left"}},methods:{changePage:function(t){if(Number(t)!==this.currentPage){this.currentPage=t,this.$emit("set-index:page",Number(this.currentPage)-1);var e=document.getElementById("windowPages");if(null!==e&&null!==document.getElementById(this.currentPage+"bgsvg")){e.scrollTo(0,document.getElementById(this.currentPage+"bgsvg").offsetTop);var n=this.currentPage;this.$emit("change-page",{page:n})}this.scrollActive(this.currentPage)}},getImagePath:function(t){return this.viewerurl+"/thumbnails/"+t+".png?token="+this.token},changeStateMenu:function(){this.scrollActive(this.currentPage),this.isHide=!this.isHide,this.isHide,document.getElementById("show-hide-left").style.left="83%",this.$emit("set-state-menu",{sideLeft:!this.isHide})},scrollActive:function(t){var e=document.querySelector('[data-field="'+t+'"');if(null!==e){e.scrollIntoView({block:"center",behavior:"smooth"}),e=document.getElementById(t);var n=!0,i=!1,a=void 0;try{for(var o,r=Sd()(document.querySelectorAll(".active-thumb"));!(n=(o=r.next()).done);n=!0){o.value.classList.remove("active-thumb")}}catch(t){i=!0,a=t}finally{try{!n&&r.return&&r.return()}finally{if(i)throw a}}e.classList.add("active-thumb")}}}},Md={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{style:t.stateStyle,attrs:{id:"side-menu"}},[n("div",{attrs:{id:"pages"}},t._l(t.totalpages,function(e,i){return n("div",{key:i,staticClass:"page",attrs:{"data-field":i}},[n("img",{staticClass:"imageThumbnail",attrs:{src:t.getImagePath(i),id:i},on:{click:function(e){return t.changePage(i)}}})])}),0),t._v(" "),n("div",{staticClass:"contentArrowLeft",attrs:{id:"show-hide-left"},on:{click:t.changeStateMenu}},[n("i",{directives:[{name:"show",rawName:"v-show",value:!t.isHide,expression:"!isHide"}],staticClass:"fas fa-caret-left icontAroowRBFLeft"}),t._v(" "),n("i",{directives:[{name:"show",rawName:"v-show",value:t.isHide,expression:"isHide"}],staticClass:"fas fa-caret-right icontAroowRBFLeft"})])])},staticRenderFns:[]};var Od=n("VU/8")(Nd,Md,!1,function(t){n("GKAa")},null,null).exports,Td={name:"pf-form-page",data:function(){return{loadAllSvg:0,pageWidth:612,pageHeight:792,isLoad:!1,topContext:0,leftContext:0,isMergeContext:!1,isReverseContext:!1,isModelField:!1,isContext:!1,currentContextField:{},isSharePage:!1,fontSizePage:null,pageScaleOwn:null,mySrc:""}},props:{pages:{type:Object},viewerurl:{type:String},token:{type:String},page:{type:Array},indexpage:{type:Number},staticurl:{type:String},pagescale:{type:Number},isloadsvg:{type:Boolean},left:{type:Number},fontsize:{type:Number},isshare:{type:Boolean},iseditshare:{type:Boolean},readonly:{type:Boolean},issidebyside:{type:Boolean},isclient:{type:Boolean},allchanges:{type:Array},isreverse:{type:Boolean},indexPageSvg:{type:String},miniPoolIndex:{type:Array},miniPoolFontSize:{type:Array},miniPoolZoom:{type:Array},fieldsShared:{type:Object},topImgSvg:{type:Number},leftSydeBy:{type:Number},isReverse:{type:Boolean}},components:{PfFields:Al,PfSpinner:r,VueContext:bl.VueContext},watch:{isloadsvg:function(t){},isshare:function(t){-1!==this.miniPoolIndex.indexOf(this.indexPageSvg)&&(this.isSharePage=t,this.$emit("delete:indicepool",this.indexPageSvg))},fontsize:function(t){-1!==this.miniPoolFontSize.indexOf(this.indexPageSvg)&&(this.fontSizePage=t,this.$emit("delete:pool-font",this.indexPageSvg))},pagescale:function(t){-1!==this.miniPoolZoom.indexOf(this.indexPageSvg)&&(this.pageScaleOwn=t,this.$emit("delete:pool-zoom",this.indexPageSvg))},topImgSvg:function(t){document.getElementById(this.indexPageSvg+"svg").style.marginTop=t+"px",null!==document.getElementById("origin"+this.indexPageSvg+"svg")&&(document.getElementById("origin"+this.indexPageSvg+"svg").style.marginTop=t+"px")}},mounted:function(){this.initLoadSvg(),-1!==this.miniPoolFontSize.indexOf(this.indexPageSvg)&&(this.fontSizePage=this.fontsize,this.$emit("delete:pool-font",this.indexPageSvg)),-1!==this.miniPoolZoom.indexOf(this.indexPageSvg)&&(this.pageScaleOwn=this.pagescale,this.$emit("delete:pool-zoom",this.indexPageSvg)),this.isSharePage=this.isshare},methods:{errorSvg:function(){this.loadAllSvg++,this.isLoad=!0,this.$emit("set-load-svg")},loadSvg:function(){this.loadAllSvg++,this.isLoad=!0,this.$emit("set-load-svg")},updateFieldDb:function(t){this.$emit("update-field-db",t)},shareField:function(t){this.$emit("share-field",t)},openMenuContext:function(t){this.$emit("open:context",t)},setPseudo:function(t){this.$emit("set-pseudo",t)},setPseudoColor:function(t){this.$emit("set-pseudo:color",t)},setPseudoShareColor:function(t){this.$emit("set-pseudo-share:color",t)},setPseudoNoShareColor:function(t){this.$emit("set-pseudo-noshare:color",t)},initLoadSvg:function(){this.mySrc=this.staticurl+this.viewerurl+"/svg/"+this.indexPageSvg+".svg?token="+this.token}}},Ld={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticStyle:{position:"relative"}},[!0!==t.isLoad?n("div",{staticStyle:{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%, -50%)","z-index":"9999"}},[n("pf-spinner",{attrs:{color:"black"}})],1):t._e(),t._v(" "),n("img",{staticStyle:{border:"1px solid black","background-color":"white"},style:!0===t.issidebyside&&!0===t.readonly?"margin-left:"+t.left+"px;":!0===t.issidebyside&&!0!==t.readonly?"margin-left:"+t.leftSydeBy+"px;":"margin-left:"+t.left+"px;",attrs:{id:!0===t.readonly?"origin"+t.indexPageSvg+"svg":t.indexPageSvg+"svg",src:t.mySrc,width:t.pageWidth*t.pageScaleOwn,height:t.pageHeight*t.pageScaleOwn},on:{load:t.loadSvg,error:t.errorSvg}}),t._v(" "),!0===t.isLoad?n("div",[n("center",[n("pf-fields",{directives:[{name:"show",rawName:"v-show",value:!0===t.isloadsvg,expression:"isloadsvg === true"}],key:t.indexPageSvg,attrs:{pages:t.pages,page:t.page,indexPage:Number(t.indexPageSvg),pageScale:t.pageScaleOwn,fontSize:t.fontSizePage,totalPages:Object.keys(t.pages).length,isEditShare:t.iseditshare,readonly:t.readonly,isClient:t.isclient,isSideBySide:t.issidebyside,isLoadSvg:t.isloadsvg,isShare:t.isSharePage,fieldsShared:t.fieldsShared,isReverse:t.isReverse},on:{"update-field-db":t.updateFieldDb,"open:context":t.openMenuContext,"share-field":t.shareField,"load-svg":t.loadSvg,"set-pseudo":t.setPseudo,"set-pseudo:color":t.setPseudoColor,"set-pseudo-share:color":t.setPseudoShareColor,"set-pseudo-noshare:color":t.setPseudoNoShareColor,"action-full:page":function(e){return t.$emit("action-full:page")}}})],1)],1):t._e()])},staticRenderFns:[]};var jd=n("VU/8")(Td,Ld,!1,function(t){n("cuW7")},null,null).exports,Pd={name:"pf-form",data:function(){return{loadAllSvg:0,pageWidth:612,pageHeight:792,isLoad:!1,topContext:0,leftContext:0,isMergeContext:!1,isReverseContext:!1,isModelField:!1,isContext:!1,currentContextField:{},heightContentPage:null,topImgSvg:null}},props:{pages:{type:Object},viewerurl:{type:String},token:{type:String},page:{type:Array},indexpage:{type:Number},staticurl:{type:String},pagescale:{type:Number},isloadsvg:{type:Boolean},left:{type:Number},fontsize:{type:Number},isshare:{type:Boolean},iseditshare:{type:Boolean},readonly:{type:Boolean},issidebyside:{type:Boolean},isclient:{type:Boolean},allchanges:{type:Array},miniPoolIndex:{type:Array},miniPoolFontSize:{type:Array},miniPoolZoom:{type:Array},fieldsShared:{type:Object},minusRight:{type:Number},leftSydeBy:{type:Number},isReverse:{type:Boolean},isContextF:{type:Boolean}},components:{PfFields:Al,PfLeftSideBar:Od,PfSpinner:r,PfFormContent:jd,VueContext:bl.VueContext},watch:{isloadsvg:function(t){this.isLoad=t},pagescale:function(t){if(this.heightContentPage=(window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight)-document.getElementById("formTopBar").offsetHeight,792*t>=this.heightContentPage)this.heightContentPage=null,this.topImgSvg=0,this.$emit("set:paging");else{var e=this.heightContentPage-792*t;this.topImgSvg=e/2}},isContextF:function(t){this.isContext=t}},mounted:function(){this.heightContentPage=(window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight)-document.getElementById("formTopBar").offsetHeight,this.isContext=this.isContextF},methods:{setLoadSvg:function(t){this.$emit("set-load-svg",t)},updateFieldDb:function(t){this.$emit("update-field-db",t)},openContextMenu:function(t){this.isContext=!1,this.currentContextField=t.fieldValue,this.currentContextField.value=t.fieldValue.edit,this.topContext=t.top,this.leftContext=t.left,null!==t.fieldValue.edit&&t.fieldValue.origin!==t.fieldValue.edit&&(this.isContext=!0),this.isMergeContext=t.fieldValue.isMerge,this.isReverseContext=!(""===t.fieldValue.model||-1!==t.fieldValue.model.indexOf("#")||-1!==t.fieldValue.model.indexOf("+")||-1!==t.fieldValue.model.indexOf("(")||-1!==t.fieldValue.model.indexOf(")")||-1!==t.fieldValue.model.indexOf(",")||-1!==t.fieldValue.model.indexOf("attorney")||void 0===t.fieldValue.model||null===t.fieldValue.model||!t.fieldValue.reverse),this.isModelField=""!==t.fieldValue.model&&-1===t.fieldValue.model.indexOf("#")&&-1===t.fieldValue.model.indexOf("+")&&-1===t.fieldValue.model.indexOf("(")&&-1===t.fieldValue.model.indexOf(")")&&-1===t.fieldValue.model.indexOf(",")&&-1===t.fieldValue.model.indexOf("attorney")&&void 0!==t.fieldValue.model&&null!==t.fieldValue.model,!0!==this.issidebyside||this.readonly||!0!==this.isContext||this.$refs.menu.open(),this.$emit("set-context")},unmergeField:function(){this.currentContextField.out=!0,this.currentContextField.modify=!1,this.currentContextField.reverse=!1,this.currentContextField.isMerge=!1,this.$emit("unmerge:field",this.currentContextField)},mergeField:function(){this.currentContextField.modify=!1,this.currentContextField.isMerge=!0,this.currentContextField.out=!1,this.$emit("merge:field",this.currentContextField)},setNoReverse:function(){this.currentContextField.reverse=!1,this.currentContextField.modify=!1,this.currentContextField.out=!1,this.$emit("no-reverse:field",this.currentContextField)},setReverse:function(){this.currentContextField.reverse=!0,this.currentContextField.modify=!1,this.currentContextField.out=!1,this.$emit("reverse:field",this.currentContextField)},shareField:function(t){this.$emit("share-field",t)},deleteIndicePool:function(t){this.$emit("delete:indicepool",t)},deleteIndicePoolFontSize:function(t){this.$emit("delete:pool-font",t)},deleteIndicePoolZoom:function(t){this.$emit("delete:pool-zoom",t)},setPseudo:function(t){this.$emit("set-pseudo",t)},setPseudoColor:function(t){this.$emit("set-pseudo:color",t)},setPseudoShareColor:function(t){this.$emit("set-pseudo-share:color",t)},setPseudoNoShareColor:function(t){this.$emit("set-pseudo-noshare:color",t)}}},Fd={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[t._l(t.pages,function(e,i){return n("div",{key:i+"svg",staticClass:"form-content",style:null!==t.heightContentPage?"height:"+t.heightContentPage+"px;":"height:auto;",attrs:{id:!0===t.readonly?i+"bgsvgorigin":i+"bgsvg"}},[n("pf-form-content",{attrs:{pages:t.pages,page:e,viewerurl:t.viewerurl,token:t.token,staticurl:t.staticurl,pagescale:-1!==t.miniPoolZoom.indexOf(i)?t.pagescale:null,isloadsvg:t.isloadsvg,left:t.left,fontsize:-1!==t.miniPoolFontSize.indexOf(i)?t.fontsize:null,isshare:-1!==t.miniPoolIndex.indexOf(i)?t.isshare:null,iseditshare:t.iseditshare,isclient:t.isclient,readonly:t.readonly,issidebyside:t.issidebyside,indexpage:t.indexpage,indexPageSvg:i,miniPoolIndex:-1!==t.miniPoolIndex.indexOf(i)?t.miniPoolIndex:[],miniPoolFontSize:-1!==t.miniPoolFontSize.indexOf(i)?t.miniPoolFontSize:[],miniPoolZoom:-1!==t.miniPoolZoom.indexOf(i)?t.miniPoolZoom:[],fieldsShared:t.fieldsShared,topImgSvg:t.topImgSvg,leftSydeBy:t.leftSydeBy,isReverse:t.isReverse},on:{"set-load-svg":t.setLoadSvg,"update-field-db":t.updateFieldDb,"share-field":t.shareField,"open:context":t.openContextMenu,"delete:indicepool":t.deleteIndicePool,"delete:pool-font":t.deleteIndicePoolFontSize,"delete:pool-zoom":t.deleteIndicePoolZoom,"set-pseudo":t.setPseudo,"set-pseudo:color":t.setPseudoColor,"set-pseudo-share:color":t.setPseudoShareColor,"set-pseudo-noshare:color":t.setPseudoNoShareColor,"action-full:page":function(e){return t.$emit("action-full:page")}}})],1)}),t._v(" "),n("vue-context",{directives:[{name:"show",rawName:"v-show",value:!0===t.issidebyside&&!t.readonly&&!0===t.isContext,expression:"issidebyside === true && !readonly && isContext === true"}],ref:"menu",staticStyle:{position:"fixed"},style:"top:"+this.topContext+"px;margin-left:"+this.leftContext+"px;"},[n("center",[!0===t.isMergeContext?n("li",{staticClass:"itemContext",on:{click:t.unmergeField}},[t._v("Unmerge")]):n("li",{staticClass:"itemContext",on:{click:t.mergeField}},[t._v("Merge")]),t._v(" "),!0===t.isReverseContext&&!0===t.isMergeContext?n("li",{staticClass:"itemContext",on:{click:t.setNoReverse}},[t._v("No Reverse")]):!0===t.isModelField&&!0===t.isMergeContext?n("li",{staticClass:"itemContext",on:{click:t.setReverse}},[t._v("Reverse")]):t._e()])],1)],2)},staticRenderFns:[]};var Yd=n("VU/8")(Pd,Fd,!1,function(t){n("QfTC")},null,null).exports,Rd={name:"pf-top-bar-form",data:function(){return{numPage:1,labButton1:" First",labButton2:" Prev",labButton3:"Next ",labButton4:"Last ",sizeNormal:!0,isFirstPage:!0,isLastPage:!1,prevValZoom:0,check:!1,autoZoomValue:0,valueRange:5,isCenter:!1,valueCenter:0,dataRight:{show:!1},dataLeft:{show:!1},isReverseAF:!1,tmpPageScale:0,rangeZoom:0,valueZoom:0,isFullPage:!1,isWidthScroll:!1,lastScrollTop:0,initScroll:null,windowPages:null,isChangeZoom:!1,isShowHoverMessage:!1,showPopup:!1,titlePopup:"",typePopup:"",actionPopup:"",isReverseToData:!1,setTimeValue:null,markCompleteIds:[],isActionNA:!1}},props:{totalpages:{type:Number},indexpage:{type:Number},pagescale:{type:Number},isleft:{type:Boolean},fontsize:{type:Number},isreverse:{type:Boolean},issidebyside:{type:Boolean},isclient:{type:Boolean},isshare:{type:Boolean},isLoad:{type:Boolean},caseFormId:{type:String},token:{type:String},isShowRightBar:{type:Boolean},isNextPage:{type:Boolean},isPrevPage:{type:Boolean},isRoleAssigned:{type:Boolean},isDataImported:{type:Boolean},actionFullPage:{type:Boolean},urlRenderbot:{type:String},isNa:{type:Boolean}},components:{PfPopUp:$},computed:{firstButtons:function(){return!0===this.isFirstPage?"color:gray;pointer-events: none;":"color:black;"},lastButtons:function(){return!0===this.isLastPage?"color:gray;pointer-events: none;":"color: black;"},setValueRange:function(){if(0===this.autoZoomValue)return this.valueRange;var t=Math.floor(this.autoZoomValue/.2);return this.setValueRangeMethod(t),t}},watch:{autoZoomValue:function(t){var e=this;0!==t&&(this.$emit("hide-page-fields"),setTimeout(function(){e.setZoom(!0)},100))},indexpage:function(t){this.numPage=t+1,1===this.numPage?(this.isFirstPage=!0,this.isLastPage=!1):this.numPage===this.totalpages?(this.isFirstPage=!1,this.isLastPage=!0):(this.isFirstPage=!1,this.isLastPage=!1)},isleft:function(t){var e=this;if(!0===this.check?this.getSizeBrowser():(this.$emit("hide-page-fields"),setTimeout(function(){e.$emit("set-page-scale",{pageScale:.2*e.valueRange})},100)),!0===this.isWidthScroll){var n=document.getElementById("contentPagesForm"),i=0;i=!0===t?n.offsetWidth-3*n.offsetWidth/100:n.offsetWidth+3*n.offsetWidth/100,n.style.width=i,this.setWidthScroll()}},isLoad:function(t){!0===t&&(this.windowPages=document.getElementById("windowPages"))},isShowRightBar:function(t){!0===this.isWidthScroll&&this.setWidthScroll()},isreverse:function(t){this.isReverseAF=t,null!==document.getElementById("toggleReverse")&&(!0===t&&!0===this.isRoleAssigned?document.getElementById("toggleReverse").classList.add("active"):document.getElementById("toggleReverse").classList.remove("active"))},isNextPage:function(t){!0===t&&this.setNextPage()},isPrevPage:function(t){!0===t&&this.setPrevPage()},isDataImported:function(t){!0===t&&(this.showPopup=!1)},actionFullPage:function(t){var e=this;!0===t&&(clearTimeout(this.setTimeValue),this.setTimeValue=setTimeout(function(){e.changeZoom(Number(e.valueZoom.replace("%",""))/10)},3e3))},isNa:function(){this.isActionNA=!1}},created:function(){var t=this;window.addEventListener("resize",function(){!0===t.isFullPage&&t.setFullPage(),!0===t.isWidthScroll&&t.setWidthScroll()}),1===this.totalpages&&(this.isFirstPage=!0,this.isLastPage=!0)},mounted:function(){this.setFullPage(),this.isReverseAF=this.isreverse,null!==document.getElementById("toggleReverse")&&(!0===this.isReverseAF?document.getElementById("toggleReverse").classList.add("active"):document.getElementById("toggleReverse").classList.remove("active"))},methods:{importData:function(){this.showPopup=!0,this.titlePopup="Please confirm you would like to:",this.typePopup="import-review",this.actionPopup="confirmImportData"},setActionPopup:function(){"confirmImportData"===this.actionPopup?this.confirmImportData():"markCompleteAndSend"===this.actionPopup&&this.markCompleteAndSend()},confirmImportData:function(){this.titlePopup="Import Data",this.typePopup="loading",!0===this.isReverseToData?this.$emit("import-buffer-reverse",{allReverse:!0}):(this.$emit("import-buffer"),this.showPopup=!1)},setReverseToAllBuffer:function(){return"reverse all buffer"},selectFontSize:function(t){if(t.value===this.fontsize)return!0},setValueRangeMethod:function(t){this.valueRange=t},setFirstPage:function(){this.$emit("change-page",{page:0}),this.isFirstPage=!0,this.isLastPage=!1,this.numPage=1},setPrevPage:function(){this.$emit("set:paging"),this.isLastPage=!1;var t=void 0;if(t=this.numPage>1?Number(this.numPage)-1:1,null!==this.windowPages&&null!==document.getElementById(t+"bgsvg")){var e=e=document.getElementById(t+"bgsvg").offsetTop;this.windowPages.scrollTo(0,e),this.numPage=t,this.$emit("change-page",{page:t}),1===this.numPage&&(this.isFirstPage=!0,this.isLastPage=!1)}},setNextPage:function(){this.$emit("set:paging"),this.isFirstPage=!1;var t=Number(this.numPage)+1;if(null!==this.windowPages&&null!==document.getElementById(t+"bgsvg")){var e=document.getElementById(t+"bgsvg").offsetTop;this.windowPages.scrollTo(0,e),this.numPage=t,this.$emit("change-page",{page:t}),this.numPage===this.totalpages&&(this.isFirstPage=!1,this.isLastPage=!0)}},setLastPage:function(){this.$emit("change-page",{page:this.totalpages-1}),this.isFirstPage=!1,this.isLastPage=!0,this.numPage=this.totalpages},goToPage:function(){this.$emit("set:paging"),Number(this.numPage)===this.totalpages?(this.isFirstPage=!1,this.isLastPage=!0):1===Number(this.numPage)?(this.isFirstPage=!0,this.isLastPage=!1):Number(this.numPage)>this.totalpages?(this.isFirstPage=!1,this.isLastPage=!0,this.numPage=this.totalpages):Number(this.numPage)<1?(this.isFirstPage=!0,this.isLastPage=!1,this.numPage=1):(this.isFirstPage=!1,this.isLastPage=!1),null!==this.windowPages&&null!==document.getElementById(this.numPage+"bgsvg")&&(this.windowPages.scrollTo(0,document.getElementById(this.numPage+"bgsvg").offsetTop),this.numPage===this.totalpages&&(this.isFirstPage=!1,this.isLastPage=!0)),this.$emit("change-page",{page:this.numPage})},controlDisabledDownBarButtons:function(t){1===Number(t)?(this.firstPage=!0,this.lastPage=!1):this.totalpages===Number(t)?(this.firstPage=!1,this.lastPage=!0):(this.firstPage=!1,this.lastPage=!1)},setAutoZoom:function(){this.check=!this.check,this.check&&this.getSizeBrowser()},getSizeBrowser:function(){var t=window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth,e=50;1==this.dataRight.show&&(t-=document.getElementById("rightSideBarId").offsetWidth,e=60);!0===this.isleft&&(t-=document.getElementById("side-menu").offsetWidth,1==this.dataRight.show?e=50:e+=10);var n=void 0;n=!0===this.issidebyside?t/2e3:t/1200,n+=n*e/100,this.autoZoomValue=n},setZoom:function(t){this.check=t,t||(this.autoZoomValue=0);var e;this.valueRange=this.rangeZoom,e=.2*this.valueRange,this.tmpPageScale=e,this.tmpPageScale===e&&this.$emit("set-page-scale",{pageScale:e})},changeFontSize:function(t){this.$emit("set-font-size",{fontSize:parseFloat(t)})},handleNA:function(){this.isActionNA=!0,this.$emit("set-is-na")},menu:function(){for(var t=document.getElementsByClassName("nav_menu"),e=0;e<t.length;e++)t[e].classList.toggle("hid")},changeZoom:function(t){t<0||(this.$emit("set-change:zoom"),this.isChangeZoom=!0,this.setRangeZoom(t))},setRangeZoom:function(t){this.rangeZoom=t,this.valueZoom=(10*t).toFixed(0)+"%",this.setZoom(!1)},setFullPage:function(){this.isChangeZoom=!1,this.isFullPage=!0,this.isWidthScroll=!1,this.$emit("set-full:page");var t=(window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight)-document.getElementById("formTopBar").offsetHeight;this.setRangeZoom(t/15.84/10);for(var e=0;e<this.totalpages;e++)null!==document.getElementById(e+1+"bgsvg")&&(document.getElementById(e+1+"bgsvg").style.marginBottom="0px"),null!==document.getElementById(e+1+"bgsvgorigin")&&(document.getElementById(e+1+"bgsvgorigin").style.marginBottom="0px");null!==this.windowPages&&null!==document.getElementById(this.numPage+"bgsvg")&&this.windowPages.scrollTo(0,document.getElementById(this.numPage+"bgsvg").offsetTop)},setWidthScroll:function(){this.isWidthScroll=!0,this.isFullPage=!1,this.$emit("set-width:scroll");var t=this.windowPages.offsetWidth;this.setRangeZoom(t/12.4/10);for(var e=0;e<this.totalpages;e++)document.getElementById(e+1+"bgsvg").style.marginBottom="20px",null!==document.getElementById(e+1+"bgsvgorigin")&&(document.getElementById(e+1+"bgsvgorigin").style.marginBottom="20px");null!==document.getElementById(this.numPage+"bgsvg")&&window.scrollTo(0,document.getElementById(this.numPage+"bgsvg").offsetTop)},verifyScrollWheel:function(t){var e=window.pageYOffset||document.documentElement.scrollTop,n=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight;if(t.deltaY>0){var i=document.getElementById(this.numPage+1+"bgsvg");null!==i&&(!0===this.isChangeZoom?this.windowPages.scrollTop+n>i.offsetTop&&this.setNextPage():this.setNextPage())}else{var a=document.getElementById(this.numPage+"bgsvg");null!==a&&(!0===this.isChangeZoom?this.windowPages.scrollTop<a.offsetTop+5.5*n/100&&this.setPrevPage():this.setPrevPage())}this.lastScrollTop=e},download:function(){var t=this.urlRenderbot+"forms?token="+this.token+"&formId="+this.caseFormId+"&na="+this.isNa;this.isclient&&(t+="&client=true"),window.open(t,", 'download-prima', status=yes, toolbar=no, menubar=no, location=no, addressbar=no")},sendToAttorney:function(){this.showPopup=!0,this.titlePopup="Are you ready to send this information to the law firm?",this.typePopup="confirm",this.actionPopup="markCompleteAndSend"},markCompleteAndSend:function(){var t=this;this.markCompleteIds.push(this.caseFormId);var e={token:this.token,_id:this.markCompleteIds[0],status:"Pending attorney review",requestClient:!0};this.titlePopup="Loading...",this.typePopup="loading";try{Tt.updateCasesFormsStatus(e).then(function(){t.titlePopup="Form Information sent.",t.typePopup="info",setTimeout(function(){window.open("","_self",""),window.close()},2e3)})}catch(t){console.error(t)}}}},Hd={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"row positionBar",staticStyle:{"margin-right":"0px !important","margin-left":"0px !important"},attrs:{id:"formTopBar"}},[n("div",{staticClass:"topBarForm col-12 text-center"},[t.isclient?t._e():n("button",{staticClass:"btn btn-sm btn-toggle myToggle",attrs:{id:"toggleReverse",type:"button"},on:{mouseover:function(e){t.isShowHoverMessage=!0},mouseout:function(e){t.isShowHoverMessage=!1},click:function(e){t.isRoleAssigned&&t.$emit("set-reverse")}}},[n("div",{staticClass:"handle"}),t._v(" "),!t.isRoleAssigned&&t.isShowHoverMessage?n("div",{staticStyle:{"background-color":"black",color:"white",position:"absolute","border-radius":"3px",padding:"2px"}},[t._v("\n        To be able to use reverse autofill on this form, please assign a role and autofill the form first.\n      ")]):t._e()]),t._v(" "),n("div",{staticClass:"input-group d-inline icontFontZise"},[n("input",{staticClass:"textZoom",attrs:{type:"text",disabled:""},domProps:{value:t.fontsize}}),t._v(" "),n("div",{staticClass:"input-group-append d-inline",attrs:{"data-toggle":"tooltip",title:"Font size"}},[t._m(0),t._v(" "),n("div",{staticClass:"dropdown-menu"},[n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeFontSize(6)}}},[t._v("6")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeFontSize(7)}}},[t._v("7")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeFontSize(8)}}},[t._v("8")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeFontSize(8.5)}}},[t._v("8.5 (default)")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeFontSize(10)}}},[t._v("10")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeFontSize(15)}}},[t._v("15")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeFontSize(20)}}},[t._v("20")])])])]),t._v(" "),n("div",{staticClass:"d-inline-block payLine"}),t._v(" "),n("i",{staticClass:"fas fa-download iconDownload",attrs:{"data-toggle":"tooltip","data-placement":"bottom",title:"Download"},on:{click:t.download}}),t._v(" "),n("i",{staticClass:"far fa-arrow-alt-circle-up icontPrevious",style:t.firstButtons,attrs:{"data-toggle":"tooltip","data-placement":"bottom",title:"Show previous page",id:"prevButton"},on:{click:t.setPrevPage}}),t._v(" "),n("i",{staticClass:"far fa-arrow-alt-circle-down icontNext",style:t.lastButtons,attrs:{"data-toggle":"tooltip","data-placement":"bottom",title:"Show next page",id:"nextButton"},on:{click:t.setNextPage}}),t._v(" "),n("input",{directives:[{name:"model",rawName:"v-model",value:t.numPage,expression:"numPage"}],staticClass:"textPag",attrs:{id:"",type:"text"},domProps:{value:t.numPage},on:{change:t.goToPage,input:function(e){e.target.composing||(t.numPage=e.target.value)}}}),t._v(" "),n("span",{staticClass:"countPage"},[t._v("\n\n      / "+t._s(t.totalpages)+"\n\n    ")]),t._v(" "),n("div",{staticClass:"d-inline-block payLine"}),t._v(" "),n("i",{staticClass:"fas fa-minus-circle zoomOut",attrs:{"data-toggle":"tooltip","data-placement":"bottom",title:"Zoom out"},on:{click:function(e){return t.changeZoom(t.rangeZoom-1)}}}),t._v(" "),n("i",{staticClass:"fas fa-plus-circle zoomIn",attrs:{"data-toggle":"tooltip","data-placement":"bottom",title:"Zoom in"},on:{click:function(e){return t.changeZoom(t.rangeZoom+1)}}}),t._v(" "),n("div",{staticClass:"input-group d-inline"},[n("input",{directives:[{name:"model",rawName:"v-model",value:t.valueZoom,expression:"valueZoom"}],staticClass:"textZoom",attrs:{type:"text"},domProps:{value:t.valueZoom},on:{change:function(e){t.changeZoom(Number(t.valueZoom.replace("%",""))/10)},input:function(e){e.target.composing||(t.valueZoom=e.target.value)}}}),t._v(" "),n("div",{staticClass:"input-group-append d-inline"},[n("button",{staticClass:"btn btn-sm dropdown-toggle selectZoom ml-n1",attrs:{type:"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}}),t._v(" "),n("div",{staticClass:"dropdown-menu"},[n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(1)}}},[t._v("10%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(2)}}},[t._v("20%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(3)}}},[t._v("30%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(4)}}},[t._v("40%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(5)}}},[t._v("50%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(6)}}},[t._v("60%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(7)}}},[t._v("70%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(8)}}},[t._v("80%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(9)}}},[t._v("90%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(10)}}},[t._v("100%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(11)}}},[t._v("110%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(12)}}},[t._v("120%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(13)}}},[t._v("130%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(14)}}},[t._v("140%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(15)}}},[t._v("150%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(16)}}},[t._v("160%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(17)}}},[t._v("170%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(18)}}},[t._v("180%")]),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(19)}}},[t._v("190%")]),t._v(" "),n("div",{staticClass:"dropdown-divider",attrs:{role:"separator"}}),t._v(" "),n("a",{staticClass:"dropdown-item",on:{click:function(e){return t.changeZoom(20)}}},[t._v("Fit width")])])])]),t._v(" "),n("div",{staticClass:"input-group d-inline iconMoreTools",attrs:{"data-toggle":"tooltip","data-placement":"bottom",title:"More tools"}},[n("div",{staticClass:"input-group-append d-inline"},[t._m(1),t._v(" "),n("div",{staticClass:"dropdown-menu"},[n("a",{staticClass:"dropdown-item",style:!0===t.isWidthScroll?"background-color: rgb(228, 228, 228);":"",on:{click:t.setWidthScroll}},[t._v("\n            Fit to "),n("ins",[t._v("W")]),t._v("idth Scrolling\n          ")]),t._v(" "),n("a",{staticClass:"dropdown-item",style:!0===t.isFullPage?"background-color: rgb(228, 228, 228);":"",on:{click:t.setFullPage}},[t._v("\n            Fit "),n("ins",[t._v("O")]),t._v("ne Full Page\n          ")])])])]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-toggle myToggleNA",class:t.isNa?"active":"",style:t.isActionNA?"pointer-events:none;":"",attrs:{id:"toggleNA",type:"button"},on:{click:t.handleNA}},[n("div",{staticClass:"handle"})]),t._v(" "),!0===t.issidebyside?n("div",{staticClass:"d-inline"},[n("button",{staticClass:"btn btn-sm btn-success btnImportSend",on:{click:t.importData}},[t._v("\n        Import Data\n      ")])]):t._e(),t._v(" "),t.isclient?n("div",{staticClass:"d-inline"},[n("button",{staticClass:"btn btn-sm btn-success btnImportSend",attrs:{id:"btnSendAttorney"},on:{click:t.sendToAttorney}},[t._v("Send to Attorney")])]):t._e()]),t._v(" "),!0===t.showPopup?n("pf-pop-up",{attrs:{title:t.titlePopup,type:t.typePopup,isform:!0},on:{close:function(e){t.showPopup=!1},action:t.setActionPopup,"reverse:data":function(e){t.isReverseToData=!t.isReverseToData}}}):t._e()],1)},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("button",{staticClass:"btn btn-sm dropdown-toggle selectZoom ml-n1",attrs:{type:"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[e("i",{staticClass:"fas fa-font"})])},function(){var t=this.$createElement,e=this._self._c||t;return e("button",{staticClass:"btn btn-sm dropdown-toggle selectZoom",attrs:{type:"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[e("i",{staticClass:"fas fa-file-alt mr-1"})])}]};var $d=n("VU/8")(Rd,Hd,!1,function(t){n("p/2A")},null,null).exports,zd={name:"pf-right-bar-form",components:{PfRadio:P},data:function(){return{isShare:!1,isEdit:!1,isAllPages:!1,isHideRBar:!1,isOpenShare:!0}},props:{top:{type:Number},pages:{type:Object},currentPage:{type:String},isEditShare:{type:Boolean,default:!1},isSharedClientPortal:{type:Boolean}},watch:{isEditShare:function(t){this.isEdit=t,null!==document.getElementById("editShareToggle")&&(t?document.getElementById("editShareToggle").classList.add("active"):document.getElementById("editShareToggle").classList.remove("active")),this.disableFormFields()},isSharedClientPortal:function(t){this.isShare=t,null!==document.getElementById("toggleShareToClient")&&(t?document.getElementById("toggleShareToClient").classList.add("active"):document.getElementById("toggleShareToClient").classList.remove("active"))}},methods:{disableFormFields:function(){var t=this;Y()(this.pages).forEach(function(e){t.pages[e].forEach(function(e){t.isEdit?null!==document.getElementById(e.id)&&(document.getElementById(e.id).style.pointerEvents="auto"):null!==document.getElementById(e.id)&&(document.getElementById(e.id).style.pointerEvents="None")})})},setFieldsState:function(t){var e=this,n={};!0===this.isAllPages?Y()(this.pages).forEach(function(i){e.pages[i].forEach(function(e){null!==e&&(n[e.id]={enable:"blue"===t,page:i},n.isAllPages=!0)})}):this.pages[this.currentPage].forEach(function(i){null!==i&&(n[i.id]={enable:"blue"===t,page:e.currentPage},n.currentPage=e.currentPage)}),this.$emit("share-field",{fields:n,enable:"blue"===t})},shareForm:function(){this.$emit("set-share-form")},setMode:function(){this.$emit("set-mode-share",!this.isEdit)},hideRigthBar:function(){this.isHideRBar=!this.isHideRBar,!0===this.isHideRBar?(document.getElementById("rightBarForm").classList.remove("rightBarForm"),document.getElementById("rightBarForm").classList.add("rightBarFormHide"),document.getElementById("barState").classList.remove("contentArrowRBF"),document.getElementById("barState").classList.add("contentArrowRBFHide"),null!==document.getElementById("icontArrowBS")&&document.getElementById("icontArrowBS").classList.add("icontAroowRBFAf"),document.getElementById("contentPagesForm").classList.remove("contentFormViewerr"),document.getElementById("contentPagesForm").classList.add("contentFormViewerCloseBar"),document.getElementById("miniThumbnail")&&(document.getElementById("miniThumbnail").style.right="30px")):(document.getElementById("rightBarForm").classList.remove("rightBarFormHide"),document.getElementById("rightBarForm").classList.add("rightBarForm"),document.getElementById("barState").classList.remove("contentArrowRBFHide"),document.getElementById("barState").classList.add("contentArrowRBF"),null!==document.getElementById("icontArrowBS")&&document.getElementById("icontArrowBS").classList.remove("icontAroowRBFAf"),null!==document.getElementById("icontArrowBS")&&document.getElementById("icontArrowBS").classList.add("icontAroowRBF"),document.getElementById("contentPagesForm").classList.remove("contentFormViewerCloseBar"),document.getElementById("contentPagesForm").classList.add("contentFormViewerr"),document.getElementById("miniThumbnail")&&(document.getElementById("miniThumbnail").style.right="220px")),this.$emit("state:bar")}}},Xd={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"row"},[n("div",{staticClass:"rightBarForm",attrs:{id:"rightBarForm"}},[n("div",{directives:[{name:"show",rawName:"v-show",value:t.isHideRBar,expression:"isHideRBar"}],staticClass:"row"},[t._m(0)]),t._v(" "),n("div",{directives:[{name:"show",rawName:"v-show",value:!t.isHideRBar,expression:"!isHideRBar"}],staticClass:"col-12"},[t._m(1),t._v(" "),n("div",{staticClass:"boxSubTitleRBF",attrs:{id:"shareBar","data-toggle":"collapse","data-target":"#accrodionShareTools"},on:{click:function(e){t.isOpenShare=!t.isOpenShare}}},[n("h6",{staticClass:"subTitleRBF"},[t._m(2),t._v(" "),!0===t.isOpenShare?n("span",[n("i",{staticClass:"icontToolsRBF float-right fas fa-angle-double-up"})]):n("span",[n("i",{staticClass:"icontToolsRBF float-right fas fa-angle-double-down"})])])]),t._v(" "),n("div",{staticClass:"collapse show",attrs:{id:"accrodionShareTools"}},[n("div",{staticClass:"contentEFS"},[n("h6",{staticClass:"titleEFS"},[t._v("Enable For Sharing")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-toggle myToggleRBF",attrs:{id:"toggleShareToClient",type:"button"},on:{click:t.shareForm}},[n("div",{staticClass:"handle"})])]),t._v(" "),n("div",{staticClass:"contentClPe"},[n("h6",{staticClass:"titleClPe"},[t._v("Client Permission")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-toggle myToggleRBFEdit",style:t.isSharedClientPortal?"":"pointer-events:none;",attrs:{id:"editShareToggle",type:"button"},on:{click:t.setMode}},[n("div",{staticClass:"handle"})])]),t._v(" "),n("div",{staticClass:"contentItemsEnable",style:t.isSharedClientPortal?"":"pointer-events:none;"},[t._m(3),t._v(" "),n("button",{staticClass:"btn btn-sm btn-primary enableFields",attrs:{disabled:!t.isSharedClientPortal||!0!==t.isEdit},on:{click:function(e){return t.setFieldsState("blue")}}},[t._v("\n            Enable All Fields\n          ")]),t._v(" "),n("button",{staticClass:"btn btn-sm btn-danger desableFields",attrs:{disabled:!t.isSharedClientPortal||!0!==t.isEdit},on:{click:function(e){return t.setFieldsState("red")}}},[t._v("\n            Disable All Fields\n          ")]),t._v(" "),n("div",{staticClass:"form-group marginBotZero contentRadiosPages"},[n("div",{},[n("pf-radio",{attrs:{classElement:"",checked:!t.isAllPages,label:"This Page",name:"postalCodeFaMe",id:"Hi",disabled:!t.isSharedClientPortal||!0!==t.isEdit},on:{click:function(e){t.isAllPages=!1}}}),t._v(" "),n("pf-radio",{attrs:{classElement:"",checked:t.isAllPages,label:"All Pages.",name:"postalCodeFaMe",id:"Hi2",styleElement:"",disabled:!t.isSharedClientPortal||!0!==t.isEdit},on:{click:function(e){t.isAllPages=!0}}})],1)])])]),t._v(" "),t._m(4),t._v(" "),n("div",{staticClass:"collapse",attrs:{id:"accrodionHelpTools"}})])]),t._v(" "),n("div",{staticClass:"contentArrowRBF",attrs:{id:"barState"},on:{click:t.hideRigthBar}},[!0===t.isHideRBar?n("i",{staticClass:"fas fa-caret-left icontAroowRBFAf",attrs:{id:"icontArrowBS"}}):n("i",{staticClass:"fas fa-caret-right icontAroowRBF"})])])},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"col-12 text-center d-none"},[e("i",{staticClass:"fas fa-share-square w-100"}),this._v(" "),e("i",{staticClass:"fas fa-edit w-100"}),this._v(" "),e("i",{staticClass:"far fa-file-alt w-100"})])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"boxTitleRBF"},[e("h6",{staticClass:"titleRBF"},[e("b",[this._v("Tools")]),this._v(" "),e("i",{staticClass:"fas fa-wrench"})])])},function(){var t=this.$createElement,e=this._self._c||t;return e("b",[e("ins",[this._v("Sharing")])])},function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"titleHelptolls"},[n("h6",[t._v("Enable / Disable fields for client to modify")]),t._v(" "),n("div",{staticClass:"contenItemsHelpTools"},[n("div",{staticClass:"itemsHelpTools"},[n("h6",{staticClass:"textItemhelp"},[n("i",{staticClass:"fas fa-circle icontCircleHelp mr-1"}),t._v("\n                  Click individual fields to changes allow "),n("span",{staticClass:"text-primary"},[t._v("(blue)")]),t._v(" or prevent changes "),n("span",{staticClass:"text-danger"},[t._v("(red)")])])]),t._v(" "),n("div",{staticClass:"itemsHelpTools"},[n("h6",{staticClass:"textItemhelp"},[n("i",{staticClass:"fas fa-circle icontCircleHelp mr-1"}),t._v("\n                  Use buttons bellow to enable/disable multiple fields at once\n                ")])])])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"boxHelp d-none",attrs:{"data-toggle":"collapse","data-target":"#accrodionHelpTools"}},[e("h6",{staticClass:"subTitleHelp"},[e("b",[e("ins",[this._v("Help")])]),this._v(" "),e("span",[e("i",{staticClass:"icontToolsRBF float-right fas fa-angle-double-down"})])])])}]};var Vd=n("VU/8")(zd,Xd,!1,function(t){n("8tXo")},null,null).exports,qd={name:"pf-landing-page-questionnaires",data:function(){return{caseQuestionnairesIds:[],questionnaires:[],messageError:"",showButton:!0,clientName:"",questionnaireToFill:{},contactId:-1,isLandingPage:!0,isQuestionnaireViewer:!1,isSpinner:!0,isPopUp:!1,messagePopUp:"",titlePopUp:"",isLogo:!1,actionPopUp:"",firmInformation:{},titleHeader:"Questionnaires",markCompleteIds:[],countComplete:0,messageComplete:"This link has expired.  Please contact the law office for more help.",showExpiredMessage:!1,isTracking:!1,tenantCode:"",casesForms:[],isCasesQuestionnaires:!1,isCasesForms:!1,casesFormsIds:[],moment:null}},props:{token:{type:String},type:{type:String},urlformviewer:{type:String},questionnaireId:{type:String}},components:{PfButton:d,PfSideBar:vl,PfTranslate:yd,PfSpinner:r,PfPopUp:$},created:function(){this.moment=ct.a,this.getScope();var t=this.parseJwt(this.token);this.tenantCode=t.tenantCode},methods:{parseJwt:function(t){try{return JSON.parse(atob(t.split(".")[1]))}catch(t){return null}},getScope:function(){var t=this;Tt.getScope({token:this.token}).then(function(e){if(void 0!==e.scope&&null!==e.scope){if(void 0!==e.scope.scope.caseQuestionnaires){t.isCasesQuestionnaires=!0;var n=e.scope.scope.caseQuestionnaires;"string"!=typeof n&&void 0!==n.caseQuestionnairesIds&&null!==n.caseQuestionnairesIds&&(t.questionnaireId?t.caseQuestionnairesIds=[t.questionnaireId]:t.caseQuestionnairesIds=n.caseQuestionnairesIds,0===t.caseQuestionnairesIds.length?(t.isSpinner=!1,t.showExpiredMessage=!0):t.getQuestionnaires())}else if(void 0!==e.scope.scope.casesForms){t.isCasesForms=!0;var i=e.scope.scope.casesForms;"string"!=typeof i&&void 0!==i.casesFormsIds&&null!==i.casesFormsIds&&(t.casesFormsIds=i.casesFormsIds,0===t.casesFormsIds.length?(t.isSpinner=!1,t.showExpiredMessage=!0):t.getCasesForms())}t.firmInformation=e.scope.dataFirm[0]}else t.messageError="Scope information invalid: "+e,t.isSpinner=!1,t.showExpiredMessage=!0})},getQuestionnaires:function(){var t=this;this.caseQuestionnairesIds.forEach(function(e){Tt.getCaseQuestionnaireCT({questionnaireId:e,token:t.token}).then(function(e){if(t.isSpinner=!1,t.showExpiredMessage=!0,(void 0!==e.caseQuestionnaires||null!==e.caseQuestionnaires)&&e.caseQuestionnaires.length>0){var n=e.caseQuestionnaires[0],i=ct()(n.expireDate).format("MM/DD/YYYY"),a=ct()().format("MM/DD/YYYY");n.remainDays=1-ct()(a).diff(i,"days"),n.expireDate=ct()(n.expireDate).format("MM-DD-YYYY"),!0===n.complete&&t.countComplete++,!1===t.isTracking&&t.setTracking(n),t.isTracking=!0,t.questionnaires.push(n),t.clientName=t.questionnaires[0].models.personal.firstName.origin+" "+t.questionnaires[0].models.personal.middleName.origin+" "+t.questionnaires[0].models.personal.lastName.origin}else t.messageError="No Questionnaires for show.";setTimeout(function(){t.countComplete<t.questionnaires.length+t.casesForms.length&&(t.questionnaires.length>1||t.casesForms.length>1)?(document.getElementById("sendAttorney").classList.remove("btnnNew"),document.getElementById("sendAttorney").classList.add("disableButton")):(document.getElementById("sendAttorney").classList.remove("disableButton"),document.getElementById("sendAttorney").classList.add("btnnNew"),document.getElementById("sendAttorney").style.opacity=1,document.getElementById("sendAttorney").style.color="white")},800)})})},getCasesForms:function(){var t=this;this.casesFormsIds.forEach(function(e){Tt.getCaseFormsClient({token:t.token,caseFormId:e}).then(function(e){if(t.isSpinner=!1,t.showExpiredMessage=!0,void 0!==e.casesForms&&null!==e.casesForms&&e.casesForms.length>0){var n=e.casesForms[0],i=ct()(n.sharedToClientDate).add({days:14}).format("MM/DD/YYYY"),a=ct()().format("MM/DD/YYYY");n.remainDays=1-ct()(a).diff(i,"days"),n.expireDate=ct()(i).format("MM-DD-YYYY"),n.createdAt=ct()(n.revisionDate).format("MM-DD-YYYY"),"Access Revoked"!==n.status&&t.casesForms.push(n)}else t.messageError="No Forms for show."})})},fillQuestionnaire:function(t){this.contactId=t.models.personal.id.origin,this.questionnaireToFill=t,this.titleHeader=t.models.personal.firstName.origin+" "+t.models.personal.lastName.origin;var e={token:this.token,questionnaireIds:[t._id],status:"attorney"===this.type?"Opened by the attorney":"Opened by the client"};Tt.updateCaseQuestionnairesStatusTC(e).then(function(t){console.log(t)}),this.isLandingPage=!1,this.isQuestionnaireViewer=!0},returnLandingPage:function(){location.reload()},sendToAttorney:function(){this.isPopUp=!0,this.titlePopUp="Are you ready to send this information to the law firm?",this.typePopUp="confirm",this.actionPopUp=1===this.casesForms.length||1===this.questionnaires.length?"markCompleteAndSend":"sendQuestionnairesAttorney",this.isLogo=!1},setActionPopUp:function(){"sendQuestionnairesAttorney"===this.actionPopUp?this.sendQuestionnairesAttorney():"reloadPage"===this.actionPopUp?this.reloadPage():"confirmMarkAsComplete"===this.actionPopUp?this.confirmMarkAsComplete():"markCompleteAndSend"===this.actionPopUp&&this.markCompleteAndSend()},markCompleteAndSend:function(){!0===this.isCasesQuestionnaires?(this.markCompleteIds.push(this.questionnaires[0]._id),this.confirmMarkAsComplete()):!0===this.isCasesForms&&this.markCompleteIds.push(this.casesForms[0]._id),this.sendQuestionnairesAttorney()},sendQuestionnairesAttorney:function(){var t=this;if(!0===this.isCasesQuestionnaires){var e;e=this.questionnaires.map(function(t){return t._id});var n={token:this.token,questionnaireIds:e,status:"Pending attorney review"};Tt.updateCaseQuestionnairesStatusTC(n).then(function(e){t.questionnaires=[],t.isCasesForms=!1,t.isCasesQuestionnaires=!1,t.messageComplete="Questionnaire Information sent."})}else if(!0===this.isCasesForms){var i={token:this.token,_id:this.markCompleteIds[0],status:"Pending attorney review",requestClient:!0};Tt.updateCasesFormsStatus(i).then(function(e){t.casesForms=[],t.isCasesForms=!1,t.isCasesQuestionnaires=!1,t.messageComplete="Form Information sent."})}this.isPopUp=!1},markAsComplete:function(t){this.isPopUp=!0,this.titlePopUp="Are you sure to mark as complete this questionnaire (#"+(t.index+1)+")?",this.typePopUp="confirm",this.actionPopUp="confirmMarkAsComplete",this.isLogo=!1,this.markCompleteIds.push(t.id)},confirmMarkAsComplete:function(){var t=this;Tt.markAsCompleteCaseQuestionnaires({token:this.token,complete:!0,questionnaireIds:this.markCompleteIds}).then(function(e){if(void 0!==e.caseQuestionnaireAsComplete){t.isPopUp=!1,t.markCompleteIds=[];var n=t.questionnaires;t.countComplete=0,n.forEach(function(i,a){i._id===e.caseQuestionnaireAsComplete[0]._id&&(n[a].complete=!0),!0===n[a].complete&&t.countComplete++}),setTimeout(function(){t.countComplete<t.questionnaires.length&&t.questionnaires.length>1?(document.getElementById("sendAttorney").classList.remove("btnnNew"),document.getElementById("sendAttorney").classList.add("disableButton")):(document.getElementById("sendAttorney").classList.remove("disableButton"),document.getElementById("sendAttorney").classList.add("btnnNew"),document.getElementById("sendAttorney").style.opacity=1,document.getElementById("sendAttorney").style.color="white")},800),t.questionnaires=[],t.questionnaires=n}})},reloadPage:function(){this.isPopUp=!1,location.reload()},setTracking:function(t){window.inlineManualTracking={uid:this.tenantCode+"-"+t.caseId,email:t.models.personal.email.origin,name:t.models.personal.fullName.origin,created:Date.now(),updated:Date.now(),group:this.firmInformation.firmName}},fillForm:function(t){window.open(this.urlformviewer+"?token="+this.token+"&_id="+t+"&client=true",", '_blank', status=yes, toolbar=no, menubar=no, location=no, addressbar=no")}}},Wd={render:function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",[void 0!==t.questionnaires[0]||void 0!==t.casesForms[0]?n("pf-translate",{attrs:{isLanding:t.isLandingPage,title:"Help",clientName:t.clientName},on:{"go-landing-page":t.returnLandingPage}}):t._e(),t._v(" "),!0===t.isLandingPage?n("div",{staticStyle:{"margin-top":"3px"}},[n("div",{staticClass:"row"},[Object.keys(t.firmInformation).length>0&&!1===t.isSpinner?n("div",{staticClass:"col-md-7"},[n("div",{staticClass:"contentFirm"},[n("p",{staticClass:"firmName"},[n("b",[t._v(" "+t._s(null!==t.firmInformation.firmName&&""!==t.firmInformation.firmName?t.firmInformation.firmName:"None"))])]),t._v(" "),n("div",{staticClass:"boxcontainerForm shadowBoxFirm"},[n("p",{staticClass:"mBt"},[n("b",{staticClass:"myText"},[t._v("Case Name :")]),t._v(" "+t._s(null!==t.firmInformation.caseName&&""!==t.firmInformation.caseName?t.firmInformation.caseName:"None"))]),t._v(" "),n("p",{staticClass:"mBt"},[n("b",{staticClass:"myText2"},[t._v("Attorney Name :")]),t._v(" "+t._s(null!==t.firmInformation.attorneyName&&""!==t.firmInformation.attorneyName?t.firmInformation.attorneyName:"None")+" "),t._m(0),t._v(" "+t._s(null!==t.firmInformation.phone&&""!==t.firmInformation.phone?t.firmInformation.phone:"None")+" "),t._m(1),t._v(" "+t._s(null!==t.firmInformation.email&&""!==t.firmInformation.email?t.firmInformation.email:"None"))]),t._v(" "),n("p",{staticClass:"mBt"},[n("b",{staticClass:"myText3"},[t._v("Paralegal Name :")]),t._v(" "+t._s(null!==t.firmInformation.paralegalName&&""!==t.firmInformation.paralegalName?t.firmInformation.paralegalName:"None")+" ")])])])]):t._e(),t._v(" "),Object.keys(t.firmInformation).length>0&&!1===t.isSpinner?n("div",{staticClass:"col-md-5 order-first order-md-2 imgFirm"},[void 0!==t.firmInformation.logoFirm&&-1===t.firmInformation.logoFirm.indexOf("undefined")?n("img",{staticClass:"float-right",attrs:{src:null!==t.firmInformation.logoFirm&&""!==t.firmInformation.logoFirm?t.firmInformation.logoFirm:"",width:"125px"}}):t._e()]):t._e()]),t._v(" "),n("div",{staticClass:"scroll ml-3 mt-4 mr-3"},[!0===t.isSpinner?n("pf-spinner",{attrs:{color:"blue"}}):t._e(),t._v(" "),!0===t.isCasesQuestionnaires?n("div",[Object.keys(t.firmInformation).length>0&&!1===t.isSpinner?n("div",{staticClass:"row"},[t._m(2)]):t._e(),t._v(" "),Object.keys(t.firmInformation).length>0&&!1===t.isSpinner&&void 0!==t.questionnaires[0]?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pl-0"},[n("h5",{staticClass:"mb-0 title"},[t._v("Your questionnaire(s) must be completed by "),n("span",[n("b",{staticClass:"text-danger"},[t._v(t._s(t.questionnaires[0].expireDate))])]),t._v(" ("+t._s(t.questionnaires[0].remainDays)+") days. After that time, this link will expire and you will not have access. You will need to contact your attorney in order to recieve a new link.")])])]):t._e(),t._v(" "),Object.keys(t.firmInformation).length>0&&!1===t.isSpinner?n("hr",{staticClass:"hrLanding"}):t._e(),t._v(" "),!1===t.isSpinner&&t.questionnaires.length>0?n("div",t._l(t.questionnaires,function(e,i){return n("div",{key:i},[n("div",{staticClass:"boxContainer shadowBox"},[n("div",{staticClass:"row"},[n("div",{staticClass:"col-7"},[n("h6",{staticClass:"fileOne"},[t._v("To "),n("span",[n("b",[t._v(t._s(e.models.personal.firstName.origin+" "+e.models.personal.middleName.origin+" "+e.models.personal.lastName.origin))]),t._v(" for these "),n("a",{attrs:{href:"#","data-toggle":"collapse","data-target":"#collapse"+i,"aria-expanded":"false","aria-controls":"collapseExample"}},[t._v("forms")])])])]),t._v(" "),n("div",{staticClass:"col-5",class:t.questionnaires.length>1?"divButtons2":"divButtons"},[t.questionnaires.length>1?n("button",{staticClass:"btn btn-sm btn-success float-right ml-2 mb-1 shutter-out-horizontalCompleted",style:!0===e.complete?"pointer-events: none;":"",attrs:{disabled:!0===e.complete},on:{click:function(n){return t.markAsComplete({index:i,id:e._id})}}},[t._v("\n                    Mark as Complete\n                  ")]):t._e(),t._v(" "),n("button",{staticClass:"btn btn-sm btn-primary float-right ml-2 shutter-in-horizontalEdit",staticStyle:{width:"100px"},style:!0===e.complete?"pointer-events: none;":"",attrs:{disabled:!0===e.complete},on:{click:function(n){return t.fillQuestionnaire(e)}}},[t._v("\n                    Fill\n                  ")])]),t._v(" "),n("div",{staticClass:"col-12 itemBadge collapse",attrs:{id:"collapse"+i}},t._l(e.forms,function(e,i){return n("div",{key:"f"+i,staticClass:"d-inline"},t._l(e.roles,function(i,a){return n("div",{key:a,staticClass:"d-inline"},[n("h6",{staticClass:"cscs badge badge-secondary mr-2"},[t._v(" "+t._s(i)+" | "),n("span",[n("b",[t._v(" "+t._s(e.name)+" ")])])])])}),0)}),0)])])])}),0):t._e()]):t._e(),t._v(" "),!0===t.isCasesForms&&t.casesForms.length>0?n("div",[Object.keys(t.firmInformation).length>0&&!1===t.isSpinner?n("div",{staticClass:"row"},[t._m(3)]):t._e(),t._v(" "),Object.keys(t.firmInformation).length>0&&!1===t.isSpinner?n("div",{staticClass:"row"},[n("div",{staticClass:"col-12 pl-0"},[n("h5",{staticClass:"mb-0 title"},[t._v("Your form(s) must be completed by "),n("span",[n("b",{staticClass:"text-danger"},[t._v(t._s(t.casesForms[0].expireDate))])]),t._v(" ("+t._s(t.casesForms[0].remainDays)+") days. After that time, this link will expire and you will not have access. You will need to contact your attorney in order to recieve a new link.")])])]):t._e(),t._v(" "),Object.keys(t.firmInformation).length>0&&t.casesForms.length>0&&!1===t.isSpinner?n("hr",{staticClass:"hrLanding"}):t._e(),t._v(" "),!1===t.isSpinner&&t.casesForms.length>0?n("div",t._l(t.casesForms,function(e,i){return n("div",{key:i},[n("div",{staticClass:"boxContainer shadowBox"},[n("div",{staticClass:"row"},[n("div",{staticClass:"col-7"},[n("h6",{staticClass:"fileOne"},[n("span",[n("b",[t._v(t._s(e.formName+" "+e.formTitle)+" - ")]),t._v(" "+t._s(e.createdAt)+" "),n("a",{attrs:{href:"#","data-toggle":"collapse","data-target":"#collapseForm"+i,"aria-expanded":"false","aria-controls":"collapseExample"}},[t._v("Roles")])])])]),t._v(" "),n("div",{staticClass:"col-5",class:t.casesForms.length>1?"divButtons2":"divButtons"},[t.casesForms.length>1?n("button",{staticClass:"btn btn-sm btn-success float-right ml-2 mb-1 shutter-out-horizontalCompleted",style:"Accepted and imported into case"===e.status?"pointer-events: none;":"",attrs:{disabled:"Accepted and imported into case"===e.status},on:{click:function(n){return t.markAsComplete({index:i,id:e._id})}}},[t._v("\n                    Mark as Complete\n                  ")]):t._e(),t._v(" "),n("button",{staticClass:"btn btn-sm btn-primary float-right ml-2 shutter-in-horizontalEdit",staticStyle:{width:"100px"},style:"Accepted and imported into case"===e.status?"pointer-events: none;":"",attrs:{disabled:"Accepted and imported into case"===e.status},on:{click:function(n){return t.fillForm(e._id)}}},[t._v("\n                    Edit\n                  ")])]),t._v(" "),n("div",{staticClass:"col-12 itemBadge collapse",attrs:{id:"collapseForm"+i}},t._l(e.properties,function(e,i){return n("div",{key:"r"+i,staticClass:"d-inline"},[n("h6",{staticClass:"cscs badge badge-secondary mr-2"},[t._v(" "+t._s(e.name)+" "),t._m(4,!0)])])}),0)])])])}),0):t._e()]):!0===t.showExpiredMessage&&!1===t.isSpinner&&0===t.casesForms.length&&0===t.questionnaires.length?n("div",[n("hr",{staticClass:"mt-4 hrLanding"}),t._v(" "),n("div",{staticClass:"mt-4 col-12 text-center"},[n("h2",[t._v(t._s(t.messageComplete))])])]):t._e(),t._v(" "),Object.keys(t.firmInformation).length>0&&!1===t.isSpinner?n("hr",{staticClass:"mt-4 hrLanding"}):t._e(),t._v(" "),!1===t.isSpinner&&(t.questionnaires.length>0||t.casesForms.length>0)?n("div",{staticClass:"row float-right mb-5 mr-1",class:t.countComplete===t.questionnaires.length+t.casesForms.length?"":"disableButton"},[n("pf-button",{attrs:{label:"Send to Attorney",id:"sendAttorney",classButton:"btn btn-sm btn-success btnnNew shutter-out-horizontalCompletedA"},on:{click:t.sendToAttorney}})],1):t._e()],1)]):t._e(),t._v(" "),!0===t.isQuestionnaireViewer?n("pf-side-bar",{attrs:{token:t.token,questionnaireid:t.questionnaireToFill._id,questionnaireData:t.questionnaireToFill,viewer:!0,contactid:t.contactId},on:{"show-landing-page":t.returnLandingPage,sendtoattorney:function(e){t.isPopUp=!0}}}):t._e(),t._v(" "),!0===t.isPopUp?n("pf-pop-up",{attrs:{title:t.titlePopUp,message:t.messagePopUp,type:t.typePopUp,logo:t.isLogo},on:{close:function(e){t.isPopUp=!1},action:t.setActionPopUp}}):t._e()],1)},staticRenderFns:[function(){var t=this.$createElement,e=this._self._c||t;return e("b",{staticClass:"myText4"},[e("i",{staticClass:"fas fa-phone"})])},function(){var t=this.$createElement,e=this._self._c||t;return e("b",{staticClass:"myText5"},[e("i",{staticClass:"fas fa-envelope-square"})])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"col-12 pl-0"},[e("h3",[e("b",[this._v("Questionnnaires")])])])},function(){var t=this.$createElement,e=this._self._c||t;return e("div",{staticClass:"col-12 pl-0"},[e("h3",[e("b",[this._v("Forms")])])])},function(){var t=this.$createElement,e=this._self._c||t;return e("span",[e("b")])}]};var Ud=n("VU/8")(qd,Wd,!1,function(t){n("CfkD"),n("gOkL")},"data-v-6b29ceaa",null).exports,Gd=n("//Fk"),Zd=n.n(Gd),Jd={getCookie:function(t){for(var e=t+"=",n=decodeURIComponent(document.cookie).split(";"),i=0;i<n.length;i++){for(var a=n[i];" "===a.charAt(0);)a=a.substring(1);if(0===a.indexOf(e))return a.substring(e.length,a.length)}return""},clearUrl:function(){var t=window.location.href.split("?")[0];window.location.href=t},firstHead:function(){return new Zd.a(function(t,e){var n="";if(""===(n=""!==window.localStorage.cerberusCookie&&"undefined"!==window.localStorage.cerberusCookie&&void 0!==window.localStorage.cerberusCookie?window.localStorage.cerberusCookie:Jd.getCookie("cerberusCookie"))||"undefined"===n||void 0===n)Jd.secondHead(),t(!1);else{var i=Jd.getCookie("refreshCerberusCookie");""!==i&&"undefined"!==i&&void 0!==i||(i=window.localStorage.refreshCerberusCookie);var a=Jd.getCookie("createdAt");""!==a&&"undefined"!==a&&void 0!==a||(a=window.localStorage.createdAt);var o=Jd.getCookie("expiresIn");""!==o&&"undefined"!==o&&void 0!==o||(o=window.localStorage.expiresIn);var r=Jd.getCookie("rememberMe");""!==r&&"false"!==r&&void 0!==r||(r=window.localStorage.rememberMe),ct()(a).add(parseInt(o)-30,"seconds").diff(ct()(),"seconds")<=0&&void 0!==window.clientId?Tt.refreshTokenDb({refreshToken:i,clientId:window.clientId}).then(function(e){e.access_token?(n=e.access_token,document.cookie="cerberusCookie="+n+"; path=/",document.cookie="createdAt="+e.created_at+"; path=/",document.cookie="expiresIn="+e.expires_in+"; path=/","true"===r?(window.localStorage.refreshCerberusCookie=i,window.localStorage.cerberusCookie=n,window.localStorage.createdAt=e.created_at,window.localStorage.expiresIn=e.expires_in):(window.localStorage.removeItem("cerberusCookie"),window.localStorage.removeItem("refreshCerberusCookie"),window.localStorage.removeItem("createdAt"),window.localStorage.removeItem("expiresIn")),t(n)):(Jd.secondHead(),t(!1))}):("true"===r?(window.localStorage.refreshCerberusCookie=i,window.localStorage.cerberusCookie=n,window.localStorage.createdAt=a,window.localStorage.expiresIn=o):(window.localStorage.removeItem("cerberusCookie"),window.localStorage.removeItem("refreshCerberusCookie"),window.localStorage.removeItem("createdAt"),window.localStorage.removeItem("expiresIn")),t(n))}})},secondHead:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(t.errAxios&&t.errAxios.response&&401!==t.errAxios.response.status&&403!==t.errAxios.response.status&&(t.return=!0),!0!==t.return&&(window.localStorage.removeItem("cerberusCookie"),window.localStorage.removeItem("refreshCerberusCookie"),window.localStorage.removeItem("createdAt"),window.localStorage.removeItem("expiresIn"),window.localStorage.removeItem("rememberMe"),document.cookie="cerberusCookie=undefined; path=/",document.cookie="refreshCerberusCookie=undefined; path=/",document.cookie="rememberMe=false; path=/",document.cookie="createdAt=undefined; path=/",document.cookie="expiresIn=undefined; path=/",void 0!==window.loginURL)){var e;e="?backTo="+window.location.href;var n="";n=!0===t.logOut?window.loginURL+"logout":window.loginURL+e,document.location.href=n}},thirdHead:function(t){var e=[];return t.tag?(Y()(window.scope).forEach(function(n){t.tag===n&&(e=window.scope[n])}),e.length>0?e:(Jd.secondHead(),!1)):!!t.permission&&-1!==window.tagPermissions.indexOf(t.permission)}},Qd=Jd;n.d(e,"PfInput",function(){return m}),n.d(e,"PfCheckbox",function(){return x}),n.d(e,"PfSelect",function(){return k}),n.d(e,"PfTextArea",function(){return T}),n.d(e,"PfRadio",function(){return P}),n.d(e,"PfButton",function(){return d}),n.d(e,"PfAddresses",function(){return Ft}),n.d(e,"PfPhones",function(){return No}),n.d(e,"PfContacts",function(){return kr}),n.d(e,"PfJobs",function(){return Mr}),n.d(e,"PfEducationalHistory",function(){return Fr}),n.d(e,"PfCriminalHistory",function(){return Xr}),n.d(e,"PfEads",function(){return Zr}),n.d(e,"PfPassports",function(){return ns}),n.d(e,"PfTravelHistory",function(){return ls}),n.d(e,"PfUsEntries",function(){return fs}),n.d(e,"PfVisaHistory",function(){return gs}),n.d(e,"PfMarriageHistory",function(){return ks}),n.d(e,"PfFamilyMembers",function(){return Ms}),n.d(e,"PfAdvanceParole",function(){return Fs}),n.d(e,"PfSideBar",function(){return vl}),n.d(e,"PfQuestionnaire",function(){return Yl}),n.d(e,"PfFlow",function(){return Xl}),n.d(e,"PfChecklist",function(){return Wl}),n.d(e,"PfLogin",function(){return Zl}),n.d(e,"PfNotes",function(){return gd}),n.d(e,"PfForm",function(){return Yd}),n.d(e,"PfTopBarForm",function(){return $d}),n.d(e,"PfRightBarForm",function(){return Vd}),n.d(e,"PfLeftSideBar",function(){return Od}),n.d(e,"PfPopUp",function(){return $}),n.d(e,"PfSpinner",function(){return r}),n.d(e,"PfTopBar",function(){return kl}),n.d(e,"PfModal",function(){return Dl}),n.d(e,"PfTranslate",function(){return yd}),n.d(e,"PfLandingPage",function(){return Ud}),n.d(e,"PfAddendum",function(){return kd}),n.d(e,"global",function(){return i}),n.d(e,"itemsMixin",function(){return ht}),n.d(e,"fieldGroupsMixin",function(){return Qs}),n.d(e,"Dhx",function(){return Id.a}),n.d(e,"cerberus",function(){return Qd}),n.d(e,"Editor",function(){return ld}),n.d(e,"PfQuestionnaireForm",function(){return Ws})},NU0k:function(t,e,n){var i=n("NZra");t.exports=Array.isArray||function(t){return"Array"==i(t)}},NYST:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("en-sg",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")},week:{dow:1,doy:4}})})(n("PJh5"))},NZ8V:function(t,e,n){var i=n("FKWp"),a=n("r3+g"),o=n("B5V0"),r=n("+SdG")("IE_PROTO"),s=function(){},l=function(){var t,e=n("PY1i")("iframe"),i=o.length;for(e.style.display="none",n("+iDZ").appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),l=t.F;i--;)delete l.prototype[o[i]];return l()};t.exports=Object.create||function(t,e){var n;return null!==t?(s.prototype=i(t),n=new s,s.prototype=null,n[r]=t):n=l(),void 0===e?n:a(n,e)}},NZra:function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},Nd3h:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("eo",{months:"januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro".split("_"),monthsShort:"jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec".split("_"),weekdays:"dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato".split("_"),weekdaysShort:"dim_lun_mard_merk_ĵaŭ_ven_sab".split("_"),weekdaysMin:"di_lu_ma_me_ĵa_ve_sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"[la] D[-an de] MMMM, YYYY",LLL:"[la] D[-an de] MMMM, YYYY HH:mm",LLLL:"dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",llll:"ddd, [la] D[-an de] MMM, YYYY HH:mm"},meridiemParse:/[ap]\.t\.m/i,isPM:function(t){return"p"===t.charAt(0).toLowerCase()},meridiem:function(t,e,n){return t>11?n?"p.t.m.":"P.T.M.":n?"a.t.m.":"A.T.M."},calendar:{sameDay:"[Hodiaŭ je] LT",nextDay:"[Morgaŭ je] LT",nextWeek:"dddd[n je] LT",lastDay:"[Hieraŭ je] LT",lastWeek:"[pasintan] dddd[n je] LT",sameElse:"L"},relativeTime:{future:"post %s",past:"antaŭ %s",s:"kelkaj sekundoj",ss:"%d sekundoj",m:"unu minuto",mm:"%d minutoj",h:"unu horo",hh:"%d horoj",d:"unu tago",dd:"%d tagoj",M:"unu monato",MM:"%d monatoj",y:"unu jaro",yy:"%d jaroj"},dayOfMonthOrdinalParse:/\d{1,2}a/,ordinal:"%da",week:{dow:1,doy:7}})})(n("PJh5"))},Nlnz:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("te",{months:"జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్".split("_"),monthsShort:"జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.".split("_"),monthsParseExact:!0,weekdays:"ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం".split("_"),weekdaysShort:"ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని".split("_"),weekdaysMin:"ఆ_సో_మం_బు_గు_శు_శ".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[నేడు] LT",nextDay:"[రేపు] LT",nextWeek:"dddd, LT",lastDay:"[నిన్న] LT",lastWeek:"[గత] dddd, LT",sameElse:"L"},relativeTime:{future:"%s లో",past:"%s క్రితం",s:"కొన్ని క్షణాలు",ss:"%d సెకన్లు",m:"ఒక నిమిషం",mm:"%d నిమిషాలు",h:"ఒక గంట",hh:"%d గంటలు",d:"ఒక రోజు",dd:"%d రోజులు",M:"ఒక నెల",MM:"%d నెలలు",y:"ఒక సంవత్సరం",yy:"%d సంవత్సరాలు"},dayOfMonthOrdinalParse:/\d{1,2}వ/,ordinal:"%dవ",meridiemParse:/రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,meridiemHour:function(t,e){return 12===t&&(t=0),"రాత్రి"===e?t<4?t:t+12:"ఉదయం"===e?t:"మధ్యాహ్నం"===e?t>=10?t:t+12:"సాయంత్రం"===e?t+12:void 0},meridiem:function(t,e,n){return t<4?"రాత్రి":t<10?"ఉదయం":t<17?"మధ్యాహ్నం":t<20?"సాయంత్రం":"రాత్రి"},week:{dow:0,doy:6}})})(n("PJh5"))},Nrqz:function(t,e,n){"use strict";var i=n("Wdy1"),a=n("3HN9"),o=n("AgWD");i(i.S,"Promise",{try:function(t){var e=a.f(this),n=o(t);return(n.e?e.reject:e.resolve)(n.v),e.promise}})},Ntt2:function(t,e,n){var i=n("YjQv"),a=n("iANj"),o=n("c8Kh"),r=n("4DQ7"),s=n("GCs6").f;t.exports=function(t){var e=a.Symbol||(a.Symbol=o?{}:i.Symbol||{});"_"==t.charAt(0)||t in e||s(e,t,{value:r.f(t)})}},Nzt2:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("he",{months:"ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),monthsShort:"ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),weekdays:"ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),weekdaysShort:"א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),weekdaysMin:"א_ב_ג_ד_ה_ו_ש".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [ב]MMMM YYYY",LLL:"D [ב]MMMM YYYY HH:mm",LLLL:"dddd, D [ב]MMMM YYYY HH:mm",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY HH:mm",llll:"ddd, D MMM YYYY HH:mm"},calendar:{sameDay:"[היום ב־]LT",nextDay:"[מחר ב־]LT",nextWeek:"dddd [בשעה] LT",lastDay:"[אתמול ב־]LT",lastWeek:"[ביום] dddd [האחרון בשעה] LT",sameElse:"L"},relativeTime:{future:"בעוד %s",past:"לפני %s",s:"מספר שניות",ss:"%d שניות",m:"דקה",mm:"%d דקות",h:"שעה",hh:function(t){return 2===t?"שעתיים":t+" שעות"},d:"יום",dd:function(t){return 2===t?"יומיים":t+" ימים"},M:"חודש",MM:function(t){return 2===t?"חודשיים":t+" חודשים"},y:"שנה",yy:function(t){return 2===t?"שנתיים":t%10==0&&10!==t?t+" שנה":t+" שנים"}},meridiemParse:/אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,isPM:function(t){return/^(אחה"צ|אחרי הצהריים|בערב)$/.test(t)},meridiem:function(t,e,n){return t<5?"לפנות בוקר":t<10?"בבוקר":t<12?n?'לפנה"צ':"לפני הצהריים":t<18?n?'אחה"צ':"אחרי הצהריים":"בערב"}})})(n("PJh5"))},O82h:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-6b29ceaa] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6b29ceaa]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6b29ceaa] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6b29ceaa] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6b29ceaa] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6b29ceaa] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6b29ceaa] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6b29ceaa] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6b29ceaa] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6b29ceaa] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6b29ceaa] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6b29ceaa] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6b29ceaa] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6b29ceaa] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6b29ceaa] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6b29ceaa] {\n  margin-right: 0px;\n}\n.newItem[data-v-6b29ceaa] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6b29ceaa] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6b29ceaa] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6b29ceaa] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6b29ceaa] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6b29ceaa] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6b29ceaa] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6b29ceaa] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6b29ceaa] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6b29ceaa] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6b29ceaa]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6b29ceaa] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6b29ceaa] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6b29ceaa] {\n  color: red;\n}\n.showMore[data-v-6b29ceaa]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6b29ceaa] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6b29ceaa] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6b29ceaa] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6b29ceaa {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6b29ceaa {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6b29ceaa] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6b29ceaa 3s infinite;\n  animation: bit-data-v-6b29ceaa 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6b29ceaa] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6b29ceaa]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6b29ceaa]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6b29ceaa]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6b29ceaa]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6b29ceaa]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6b29ceaa]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-6b29ceaa] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6b29ceaa]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6b29ceaa] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6b29ceaa] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6b29ceaa] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6b29ceaa] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6b29ceaa] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6b29ceaa] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6b29ceaa] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6b29ceaa] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6b29ceaa] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6b29ceaa] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6b29ceaa] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6b29ceaa] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6b29ceaa] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6b29ceaa] {\n  margin-right: 0px;\n}\n.newItem[data-v-6b29ceaa] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6b29ceaa] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6b29ceaa] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6b29ceaa] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6b29ceaa] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6b29ceaa] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6b29ceaa] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6b29ceaa] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6b29ceaa] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6b29ceaa] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6b29ceaa]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6b29ceaa] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6b29ceaa] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6b29ceaa] {\n  color: red;\n}\n.showMore[data-v-6b29ceaa]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6b29ceaa] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6b29ceaa] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6b29ceaa] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6b29ceaa {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6b29ceaa {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6b29ceaa] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6b29ceaa 3s infinite;\n  animation: bit-data-v-6b29ceaa 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6b29ceaa] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6b29ceaa]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6b29ceaa]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6b29ceaa]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6b29ceaa]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6b29ceaa]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6b29ceaa]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},ORgI:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ja",{eras:[{since:"2019-05-01",offset:1,name:"令和",narrow:"㋿",abbr:"R"},{since:"1989-01-08",until:"2019-04-30",offset:1,name:"平成",narrow:"㍻",abbr:"H"},{since:"1926-12-25",until:"1989-01-07",offset:1,name:"昭和",narrow:"㍼",abbr:"S"},{since:"1912-07-30",until:"1926-12-24",offset:1,name:"大正",narrow:"㍽",abbr:"T"},{since:"1873-01-01",until:"1912-07-29",offset:6,name:"明治",narrow:"㍾",abbr:"M"},{since:"0001-01-01",until:"1873-12-31",offset:1,name:"西暦",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"紀元前",narrow:"BC",abbr:"BC"}],eraYearOrdinalRegex:/(元|\d+)年/,eraYearOrdinalParse:function(t,e){return"元"===e[1]?1:parseInt(e[1]||t,10)},months:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),weekdaysShort:"日_月_火_水_木_金_土".split("_"),weekdaysMin:"日_月_火_水_木_金_土".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日 dddd HH:mm",l:"YYYY/MM/DD",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日(ddd) HH:mm"},meridiemParse:/午前|午後/i,isPM:function(t){return"午後"===t},meridiem:function(t,e,n){return t<12?"午前":"午後"},calendar:{sameDay:"[今日] LT",nextDay:"[明日] LT",nextWeek:function(t){return t.week()!==this.week()?"[来週]dddd LT":"dddd LT"},lastDay:"[昨日] LT",lastWeek:function(t){return this.week()!==t.week()?"[先週]dddd LT":"dddd LT"},sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}日/,ordinal:function(t,e){switch(e){case"y":return 1===t?"元年":t+"年";case"d":case"D":case"DDD":return t+"日";default:return t}},relativeTime:{future:"%s後",past:"%s前",s:"数秒",ss:"%d秒",m:"1分",mm:"%d分",h:"1時間",hh:"%d時間",d:"1日",dd:"%d日",M:"1ヶ月",MM:"%dヶ月",y:"1年",yy:"%d年"}})})(n("PJh5"))},OSsP:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n){return t+" "+function(t,e){if(2===e)return function(t){var e={m:"v",b:"v",d:"z"};if(void 0===e[t.charAt(0)])return t;return e[t.charAt(0)]+t.substring(1)}(t);return t}({mm:"munutenn",MM:"miz",dd:"devezh"}[n],t)}var n=[/^gen/i,/^c[ʼ\']hwe/i,/^meu/i,/^ebr/i,/^mae/i,/^(mez|eve)/i,/^gou/i,/^eos/i,/^gwe/i,/^her/i,/^du/i,/^ker/i],i=/^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,a=[/^Su/i,/^Lu/i,/^Me([^r]|$)/i,/^Mer/i,/^Ya/i,/^Gw/i,/^Sa/i];t.defineLocale("br",{months:"Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split("_"),monthsShort:"Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),weekdays:"Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn".split("_"),weekdaysShort:"Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),weekdaysMin:"Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),weekdaysParse:a,fullWeekdaysParse:[/^sul/i,/^lun/i,/^meurzh/i,/^merc[ʼ\']her/i,/^yaou/i,/^gwener/i,/^sadorn/i],shortWeekdaysParse:[/^Sul/i,/^Lun/i,/^Meu/i,/^Mer/i,/^Yao/i,/^Gwe/i,/^Sad/i],minWeekdaysParse:a,monthsRegex:i,monthsShortRegex:i,monthsStrictRegex:/^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,monthsShortStrictRegex:/^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [a viz] MMMM YYYY",LLL:"D [a viz] MMMM YYYY HH:mm",LLLL:"dddd, D [a viz] MMMM YYYY HH:mm"},calendar:{sameDay:"[Hiziv da] LT",nextDay:"[Warcʼhoazh da] LT",nextWeek:"dddd [da] LT",lastDay:"[Decʼh da] LT",lastWeek:"dddd [paset da] LT",sameElse:"L"},relativeTime:{future:"a-benn %s",past:"%s ʼzo",s:"un nebeud segondennoù",ss:"%d eilenn",m:"ur vunutenn",mm:e,h:"un eur",hh:"%d eur",d:"un devezh",dd:e,M:"ur miz",MM:e,y:"ur bloaz",yy:function(t){switch(function t(e){return e>9?t(e%10):e}(t)){case 1:case 3:case 4:case 5:case 9:return t+" bloaz";default:return t+" vloaz"}}},dayOfMonthOrdinalParse:/\d{1,2}(añ|vet)/,ordinal:function(t){return t+(1===t?"añ":"vet")},week:{dow:1,doy:4},meridiemParse:/a.m.|g.m./,isPM:function(t){return"g.m."===t},meridiem:function(t,e,n){return t<12?"a.m.":"g.m."}})})(n("PJh5"))},OUMt:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),n="jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");function i(t){return t>1&&t<5}function a(t,e,n,a){var o=t+" ";switch(n){case"s":return e||a?"pár sekúnd":"pár sekundami";case"ss":return e||a?o+(i(t)?"sekundy":"sekúnd"):o+"sekundami";case"m":return e?"minúta":a?"minútu":"minútou";case"mm":return e||a?o+(i(t)?"minúty":"minút"):o+"minútami";case"h":return e?"hodina":a?"hodinu":"hodinou";case"hh":return e||a?o+(i(t)?"hodiny":"hodín"):o+"hodinami";case"d":return e||a?"deň":"dňom";case"dd":return e||a?o+(i(t)?"dni":"dní"):o+"dňami";case"M":return e||a?"mesiac":"mesiacom";case"MM":return e||a?o+(i(t)?"mesiace":"mesiacov"):o+"mesiacmi";case"y":return e||a?"rok":"rokom";case"yy":return e||a?o+(i(t)?"roky":"rokov"):o+"rokmi"}}t.defineLocale("sk",{months:e,monthsShort:n,weekdays:"nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_št_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_št_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nedeľu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo štvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[včera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulú nedeľu o] LT";case 1:case 2:return"[minulý] dddd [o] LT";case 3:return"[minulú stredu o] LT";case 4:case 5:return"[minulý] dddd [o] LT";case 6:return"[minulú sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:a,ss:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},OVPi:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("fo",{months:"januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur".split("_"),weekdaysShort:"sun_mán_týs_mik_hós_frí_ley".split("_"),weekdaysMin:"su_má_tý_mi_hó_fr_le".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D. MMMM, YYYY HH:mm"},calendar:{sameDay:"[Í dag kl.] LT",nextDay:"[Í morgin kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[Í gjár kl.] LT",lastWeek:"[síðstu] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"um %s",past:"%s síðani",s:"fá sekund",ss:"%d sekundir",m:"ein minuttur",mm:"%d minuttir",h:"ein tími",hh:"%d tímar",d:"ein dagur",dd:"%d dagar",M:"ein mánaður",MM:"%d mánaðir",y:"eitt ár",yy:"%d ár"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},Ojsq:function(t,e,n){var i=n("tQIw");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("54a2559e",i,!0,{})},OoWg:function(t,e,n){n("Ntt2")("observable")},"OuA/":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfAddresses.css",sourceRoot:""}])},OyyD:function(t,e,n){var i=n("mn8E");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("615a61d1",i,!0,{})},P0jM:function(t,e,n){var i=n("UTtd");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("5762b5fc",i,!0,{})},PJh5:function(t,e,n){(function(t){var e,i;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
i=function(){"use strict";var i,a;function o(){return i.apply(null,arguments)}function r(t){return t instanceof Array||"[object Array]"===Object.prototype.toString.call(t)}function s(t){return null!=t&&"[object Object]"===Object.prototype.toString.call(t)}function l(t,e){return Object.prototype.hasOwnProperty.call(t,e)}function d(t){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(t).length;var e;for(e in t)if(l(t,e))return!1;return!0}function c(t){return void 0===t}function h(t){return"number"==typeof t||"[object Number]"===Object.prototype.toString.call(t)}function u(t){return t instanceof Date||"[object Date]"===Object.prototype.toString.call(t)}function m(t,e){var n,i=[];for(n=0;n<t.length;++n)i.push(e(t[n],n));return i}function f(t,e){for(var n in e)l(e,n)&&(t[n]=e[n]);return l(e,"toString")&&(t.toString=e.toString),l(e,"valueOf")&&(t.valueOf=e.valueOf),t}function p(t,e,n,i){return Me(t,e,n,i,!0).utc()}function _(t){return null==t._pf&&(t._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidEra:null,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],era:null,meridiem:null,rfc2822:!1,weekdayMismatch:!1}),t._pf}function A(t){if(null==t._isValid){var e=_(t),n=a.call(e.parsedDateParts,function(t){return null!=t}),i=!isNaN(t._d.getTime())&&e.overflow<0&&!e.empty&&!e.invalidEra&&!e.invalidMonth&&!e.invalidWeekday&&!e.weekdayMismatch&&!e.nullInput&&!e.invalidFormat&&!e.userInvalidated&&(!e.meridiem||e.meridiem&&n);if(t._strict&&(i=i&&0===e.charsLeftOver&&0===e.unusedTokens.length&&void 0===e.bigHour),null!=Object.isFrozen&&Object.isFrozen(t))return i;t._isValid=i}return t._isValid}function b(t){var e=p(NaN);return null!=t?f(_(e),t):_(e).userInvalidated=!0,e}a=Array.prototype.some?Array.prototype.some:function(t){var e,n=Object(this),i=n.length>>>0;for(e=0;e<i;e++)if(e in n&&t.call(this,n[e],e,n))return!0;return!1};var x=o.momentProperties=[],g=!1;function v(t,e){var n,i,a;if(c(e._isAMomentObject)||(t._isAMomentObject=e._isAMomentObject),c(e._i)||(t._i=e._i),c(e._f)||(t._f=e._f),c(e._l)||(t._l=e._l),c(e._strict)||(t._strict=e._strict),c(e._tzm)||(t._tzm=e._tzm),c(e._isUTC)||(t._isUTC=e._isUTC),c(e._offset)||(t._offset=e._offset),c(e._pf)||(t._pf=_(e)),c(e._locale)||(t._locale=e._locale),x.length>0)for(n=0;n<x.length;n++)c(a=e[i=x[n]])||(t[i]=a);return t}function C(t){v(this,t),this._d=new Date(null!=t._d?t._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===g&&(g=!0,o.updateOffset(this),g=!1)}function y(t){return t instanceof C||null!=t&&null!=t._isAMomentObject}function w(t){!1===o.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+t)}function B(t,e){var n=!0;return f(function(){if(null!=o.deprecationHandler&&o.deprecationHandler(null,t),n){var i,a,r,s=[];for(a=0;a<arguments.length;a++){if(i="","object"==typeof arguments[a]){for(r in i+="\n["+a+"] ",arguments[0])l(arguments[0],r)&&(i+=r+": "+arguments[0][r]+", ");i=i.slice(0,-2)}else i=arguments[a];s.push(i)}w(t+"\nArguments: "+Array.prototype.slice.call(s).join("")+"\n"+(new Error).stack),n=!1}return e.apply(this,arguments)},e)}var k,E={};function I(t,e){null!=o.deprecationHandler&&o.deprecationHandler(t,e),E[t]||(w(e),E[t]=!0)}function D(t){return"undefined"!=typeof Function&&t instanceof Function||"[object Function]"===Object.prototype.toString.call(t)}function S(t,e){var n,i=f({},t);for(n in e)l(e,n)&&(s(t[n])&&s(e[n])?(i[n]={},f(i[n],t[n]),f(i[n],e[n])):null!=e[n]?i[n]=e[n]:delete i[n]);for(n in t)l(t,n)&&!l(e,n)&&s(t[n])&&(i[n]=f({},i[n]));return i}function N(t){null!=t&&this.set(t)}o.suppressDeprecationWarnings=!1,o.deprecationHandler=null,k=Object.keys?Object.keys:function(t){var e,n=[];for(e in t)l(t,e)&&n.push(e);return n};function M(t,e,n){var i=""+Math.abs(t),a=e-i.length;return(t>=0?n?"+":"":"-")+Math.pow(10,Math.max(0,a)).toString().substr(1)+i}var O=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,T=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,L={},j={};function P(t,e,n,i){var a=i;"string"==typeof i&&(a=function(){return this[i]()}),t&&(j[t]=a),e&&(j[e[0]]=function(){return M(a.apply(this,arguments),e[1],e[2])}),n&&(j[n]=function(){return this.localeData().ordinal(a.apply(this,arguments),t)})}function F(t,e){return t.isValid()?(e=Y(e,t.localeData()),L[e]=L[e]||function(t){var e,n,i,a=t.match(O);for(e=0,n=a.length;e<n;e++)j[a[e]]?a[e]=j[a[e]]:a[e]=(i=a[e]).match(/\[[\s\S]/)?i.replace(/^\[|\]$/g,""):i.replace(/\\/g,"");return function(e){var i,o="";for(i=0;i<n;i++)o+=D(a[i])?a[i].call(e,t):a[i];return o}}(e),L[e](t)):t.localeData().invalidDate()}function Y(t,e){var n=5;function i(t){return e.longDateFormat(t)||t}for(T.lastIndex=0;n>=0&&T.test(t);)t=t.replace(T,i),T.lastIndex=0,n-=1;return t}var R={};function H(t,e){var n=t.toLowerCase();R[n]=R[n+"s"]=R[e]=t}function $(t){return"string"==typeof t?R[t]||R[t.toLowerCase()]:void 0}function z(t){var e,n,i={};for(n in t)l(t,n)&&(e=$(n))&&(i[e]=t[n]);return i}var X={};function V(t,e){X[t]=e}function q(t){return t%4==0&&t%100!=0||t%400==0}function W(t){return t<0?Math.ceil(t)||0:Math.floor(t)}function U(t){var e=+t,n=0;return 0!==e&&isFinite(e)&&(n=W(e)),n}function G(t,e){return function(n){return null!=n?(J(this,t,n),o.updateOffset(this,e),this):Z(this,t)}}function Z(t,e){return t.isValid()?t._d["get"+(t._isUTC?"UTC":"")+e]():NaN}function J(t,e,n){t.isValid()&&!isNaN(n)&&("FullYear"===e&&q(t.year())&&1===t.month()&&29===t.date()?(n=U(n),t._d["set"+(t._isUTC?"UTC":"")+e](n,t.month(),Mt(n,t.month()))):t._d["set"+(t._isUTC?"UTC":"")+e](n))}var Q,K=/\d/,tt=/\d\d/,et=/\d{3}/,nt=/\d{4}/,it=/[+-]?\d{6}/,at=/\d\d?/,ot=/\d\d\d\d?/,rt=/\d\d\d\d\d\d?/,st=/\d{1,3}/,lt=/\d{1,4}/,dt=/[+-]?\d{1,6}/,ct=/\d+/,ht=/[+-]?\d+/,ut=/Z|[+-]\d\d:?\d\d/gi,mt=/Z|[+-]\d\d(?::?\d\d)?/gi,ft=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;function pt(t,e,n){Q[t]=D(e)?e:function(t,i){return t&&n?n:e}}function _t(t,e){return l(Q,t)?Q[t](e._strict,e._locale):new RegExp(At(t.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(t,e,n,i,a){return e||n||i||a})))}function At(t){return t.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}Q={};var bt={};function xt(t,e){var n,i=e;for("string"==typeof t&&(t=[t]),h(e)&&(i=function(t,n){n[e]=U(t)}),n=0;n<t.length;n++)bt[t[n]]=i}function gt(t,e){xt(t,function(t,n,i,a){i._w=i._w||{},e(t,i._w,i,a)})}function vt(t,e,n){null!=e&&l(bt,t)&&bt[t](e,n._a,n,t)}var Ct,yt=0,wt=1,Bt=2,kt=3,Et=4,It=5,Dt=6,St=7,Nt=8;function Mt(t,e){if(isNaN(t)||isNaN(e))return NaN;var n,i=(e%(n=12)+n)%n;return t+=(e-i)/12,1===i?q(t)?29:28:31-i%7%2}Ct=Array.prototype.indexOf?Array.prototype.indexOf:function(t){var e;for(e=0;e<this.length;++e)if(this[e]===t)return e;return-1},P("M",["MM",2],"Mo",function(){return this.month()+1}),P("MMM",0,0,function(t){return this.localeData().monthsShort(this,t)}),P("MMMM",0,0,function(t){return this.localeData().months(this,t)}),H("month","M"),V("month",8),pt("M",at),pt("MM",at,tt),pt("MMM",function(t,e){return e.monthsShortRegex(t)}),pt("MMMM",function(t,e){return e.monthsRegex(t)}),xt(["M","MM"],function(t,e){e[wt]=U(t)-1}),xt(["MMM","MMMM"],function(t,e,n,i){var a=n._locale.monthsParse(t,i,n._strict);null!=a?e[wt]=a:_(n).invalidMonth=t});var Ot="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),Tt="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),Lt=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,jt=ft,Pt=ft;function Ft(t,e){var n;if(!t.isValid())return t;if("string"==typeof e)if(/^\d+$/.test(e))e=U(e);else if(!h(e=t.localeData().monthsParse(e)))return t;return n=Math.min(t.date(),Mt(t.year(),e)),t._d["set"+(t._isUTC?"UTC":"")+"Month"](e,n),t}function Yt(t){return null!=t?(Ft(this,t),o.updateOffset(this,!0),this):Z(this,"Month")}function Rt(){function t(t,e){return e.length-t.length}var e,n,i=[],a=[],o=[];for(e=0;e<12;e++)n=p([2e3,e]),i.push(this.monthsShort(n,"")),a.push(this.months(n,"")),o.push(this.months(n,"")),o.push(this.monthsShort(n,""));for(i.sort(t),a.sort(t),o.sort(t),e=0;e<12;e++)i[e]=At(i[e]),a[e]=At(a[e]);for(e=0;e<24;e++)o[e]=At(o[e]);this._monthsRegex=new RegExp("^("+o.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+a.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+i.join("|")+")","i")}function Ht(t){return q(t)?366:365}P("Y",0,0,function(){var t=this.year();return t<=9999?M(t,4):"+"+t}),P(0,["YY",2],0,function(){return this.year()%100}),P(0,["YYYY",4],0,"year"),P(0,["YYYYY",5],0,"year"),P(0,["YYYYYY",6,!0],0,"year"),H("year","y"),V("year",1),pt("Y",ht),pt("YY",at,tt),pt("YYYY",lt,nt),pt("YYYYY",dt,it),pt("YYYYYY",dt,it),xt(["YYYYY","YYYYYY"],yt),xt("YYYY",function(t,e){e[yt]=2===t.length?o.parseTwoDigitYear(t):U(t)}),xt("YY",function(t,e){e[yt]=o.parseTwoDigitYear(t)}),xt("Y",function(t,e){e[yt]=parseInt(t,10)}),o.parseTwoDigitYear=function(t){return U(t)+(U(t)>68?1900:2e3)};var $t=G("FullYear",!0);function zt(t){var e,n;return t<100&&t>=0?((n=Array.prototype.slice.call(arguments))[0]=t+400,e=new Date(Date.UTC.apply(null,n)),isFinite(e.getUTCFullYear())&&e.setUTCFullYear(t)):e=new Date(Date.UTC.apply(null,arguments)),e}function Xt(t,e,n){var i=7+e-n;return-((7+zt(t,0,i).getUTCDay()-e)%7)+i-1}function Vt(t,e,n,i,a){var o,r,s=1+7*(e-1)+(7+n-i)%7+Xt(t,i,a);return s<=0?r=Ht(o=t-1)+s:s>Ht(t)?(o=t+1,r=s-Ht(t)):(o=t,r=s),{year:o,dayOfYear:r}}function qt(t,e,n){var i,a,o=Xt(t.year(),e,n),r=Math.floor((t.dayOfYear()-o-1)/7)+1;return r<1?i=r+Wt(a=t.year()-1,e,n):r>Wt(t.year(),e,n)?(i=r-Wt(t.year(),e,n),a=t.year()+1):(a=t.year(),i=r),{week:i,year:a}}function Wt(t,e,n){var i=Xt(t,e,n),a=Xt(t+1,e,n);return(Ht(t)-i+a)/7}P("w",["ww",2],"wo","week"),P("W",["WW",2],"Wo","isoWeek"),H("week","w"),H("isoWeek","W"),V("week",5),V("isoWeek",5),pt("w",at),pt("ww",at,tt),pt("W",at),pt("WW",at,tt),gt(["w","ww","W","WW"],function(t,e,n,i){e[i.substr(0,1)]=U(t)});function Ut(t,e){return t.slice(e,7).concat(t.slice(0,e))}P("d",0,"do","day"),P("dd",0,0,function(t){return this.localeData().weekdaysMin(this,t)}),P("ddd",0,0,function(t){return this.localeData().weekdaysShort(this,t)}),P("dddd",0,0,function(t){return this.localeData().weekdays(this,t)}),P("e",0,0,"weekday"),P("E",0,0,"isoWeekday"),H("day","d"),H("weekday","e"),H("isoWeekday","E"),V("day",11),V("weekday",11),V("isoWeekday",11),pt("d",at),pt("e",at),pt("E",at),pt("dd",function(t,e){return e.weekdaysMinRegex(t)}),pt("ddd",function(t,e){return e.weekdaysShortRegex(t)}),pt("dddd",function(t,e){return e.weekdaysRegex(t)}),gt(["dd","ddd","dddd"],function(t,e,n,i){var a=n._locale.weekdaysParse(t,i,n._strict);null!=a?e.d=a:_(n).invalidWeekday=t}),gt(["d","e","E"],function(t,e,n,i){e[i]=U(t)});var Gt="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),Zt="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),Jt="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),Qt=ft,Kt=ft,te=ft;function ee(){function t(t,e){return e.length-t.length}var e,n,i,a,o,r=[],s=[],l=[],d=[];for(e=0;e<7;e++)n=p([2e3,1]).day(e),i=At(this.weekdaysMin(n,"")),a=At(this.weekdaysShort(n,"")),o=At(this.weekdays(n,"")),r.push(i),s.push(a),l.push(o),d.push(i),d.push(a),d.push(o);r.sort(t),s.sort(t),l.sort(t),d.sort(t),this._weekdaysRegex=new RegExp("^("+d.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+l.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+s.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+r.join("|")+")","i")}function ne(){return this.hours()%12||12}function ie(t,e){P(t,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),e)})}function ae(t,e){return e._meridiemParse}P("H",["HH",2],0,"hour"),P("h",["hh",2],0,ne),P("k",["kk",2],0,function(){return this.hours()||24}),P("hmm",0,0,function(){return""+ne.apply(this)+M(this.minutes(),2)}),P("hmmss",0,0,function(){return""+ne.apply(this)+M(this.minutes(),2)+M(this.seconds(),2)}),P("Hmm",0,0,function(){return""+this.hours()+M(this.minutes(),2)}),P("Hmmss",0,0,function(){return""+this.hours()+M(this.minutes(),2)+M(this.seconds(),2)}),ie("a",!0),ie("A",!1),H("hour","h"),V("hour",13),pt("a",ae),pt("A",ae),pt("H",at),pt("h",at),pt("k",at),pt("HH",at,tt),pt("hh",at,tt),pt("kk",at,tt),pt("hmm",ot),pt("hmmss",rt),pt("Hmm",ot),pt("Hmmss",rt),xt(["H","HH"],kt),xt(["k","kk"],function(t,e,n){var i=U(t);e[kt]=24===i?0:i}),xt(["a","A"],function(t,e,n){n._isPm=n._locale.isPM(t),n._meridiem=t}),xt(["h","hh"],function(t,e,n){e[kt]=U(t),_(n).bigHour=!0}),xt("hmm",function(t,e,n){var i=t.length-2;e[kt]=U(t.substr(0,i)),e[Et]=U(t.substr(i)),_(n).bigHour=!0}),xt("hmmss",function(t,e,n){var i=t.length-4,a=t.length-2;e[kt]=U(t.substr(0,i)),e[Et]=U(t.substr(i,2)),e[It]=U(t.substr(a)),_(n).bigHour=!0}),xt("Hmm",function(t,e,n){var i=t.length-2;e[kt]=U(t.substr(0,i)),e[Et]=U(t.substr(i))}),xt("Hmmss",function(t,e,n){var i=t.length-4,a=t.length-2;e[kt]=U(t.substr(0,i)),e[Et]=U(t.substr(i,2)),e[It]=U(t.substr(a))});var oe=G("Hours",!0);var re,se={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",w:"a week",ww:"%d weeks",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:Ot,monthsShort:Tt,week:{dow:0,doy:6},weekdays:Gt,weekdaysMin:Jt,weekdaysShort:Zt,meridiemParse:/[ap]\.?m?\.?/i},le={},de={};function ce(t,e){var n,i=Math.min(t.length,e.length);for(n=0;n<i;n+=1)if(t[n]!==e[n])return n;return i}function he(t){return t?t.toLowerCase().replace("_","-"):t}function ue(i){var a=null;if(void 0===le[i]&&void 0!==t&&t&&t.exports)try{a=re._abbr,e,n("uslO")("./"+i),me(a)}catch(t){le[i]=null}return le[i]}function me(t,e){var n;return t&&((n=c(e)?pe(t):fe(t,e))?re=n:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+t+" not found. Did you forget to load it?")),re._abbr}function fe(t,e){if(null!==e){var n,i=se;if(e.abbr=t,null!=le[t])I("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),i=le[t]._config;else if(null!=e.parentLocale)if(null!=le[e.parentLocale])i=le[e.parentLocale]._config;else{if(null==(n=ue(e.parentLocale)))return de[e.parentLocale]||(de[e.parentLocale]=[]),de[e.parentLocale].push({name:t,config:e}),null;i=n._config}return le[t]=new N(S(i,e)),de[t]&&de[t].forEach(function(t){fe(t.name,t.config)}),me(t),le[t]}return delete le[t],null}function pe(t){var e;if(t&&t._locale&&t._locale._abbr&&(t=t._locale._abbr),!t)return re;if(!r(t)){if(e=ue(t))return e;t=[t]}return function(t){for(var e,n,i,a,o=0;o<t.length;){for(e=(a=he(t[o]).split("-")).length,n=(n=he(t[o+1]))?n.split("-"):null;e>0;){if(i=ue(a.slice(0,e).join("-")))return i;if(n&&n.length>=e&&ce(a,n)>=e-1)break;e--}o++}return re}(t)}function _e(t){var e,n=t._a;return n&&-2===_(t).overflow&&(e=n[wt]<0||n[wt]>11?wt:n[Bt]<1||n[Bt]>Mt(n[yt],n[wt])?Bt:n[kt]<0||n[kt]>24||24===n[kt]&&(0!==n[Et]||0!==n[It]||0!==n[Dt])?kt:n[Et]<0||n[Et]>59?Et:n[It]<0||n[It]>59?It:n[Dt]<0||n[Dt]>999?Dt:-1,_(t)._overflowDayOfYear&&(e<yt||e>Bt)&&(e=Bt),_(t)._overflowWeeks&&-1===e&&(e=St),_(t)._overflowWeekday&&-1===e&&(e=Nt),_(t).overflow=e),t}var Ae=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,be=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,xe=/Z|[+-]\d\d(?::?\d\d)?/,ge=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/],["YYYYMM",/\d{6}/,!1],["YYYY",/\d{4}/,!1]],ve=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Ce=/^\/?Date\((-?\d+)/i,ye=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,we={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function Be(t){var e,n,i,a,o,r,s=t._i,l=Ae.exec(s)||be.exec(s);if(l){for(_(t).iso=!0,e=0,n=ge.length;e<n;e++)if(ge[e][1].exec(l[1])){a=ge[e][0],i=!1!==ge[e][2];break}if(null==a)return void(t._isValid=!1);if(l[3]){for(e=0,n=ve.length;e<n;e++)if(ve[e][1].exec(l[3])){o=(l[2]||" ")+ve[e][0];break}if(null==o)return void(t._isValid=!1)}if(!i&&null!=o)return void(t._isValid=!1);if(l[4]){if(!xe.exec(l[4]))return void(t._isValid=!1);r="Z"}t._f=a+(o||"")+(r||""),Se(t)}else t._isValid=!1}function ke(t,e,n,i,a,o){var r=[function(t){var e=parseInt(t,10);if(e<=49)return 2e3+e;if(e<=999)return 1900+e;return e}(t),Tt.indexOf(e),parseInt(n,10),parseInt(i,10),parseInt(a,10)];return o&&r.push(parseInt(o,10)),r}function Ee(t){var e,n=ye.exec(t._i.replace(/\([^)]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,""));if(n){if(e=ke(n[4],n[3],n[2],n[5],n[6],n[7]),!function(t,e,n){return!t||Zt.indexOf(t)===new Date(e[0],e[1],e[2]).getDay()||(_(n).weekdayMismatch=!0,n._isValid=!1,!1)}(n[1],e,t))return;t._a=e,t._tzm=function(t,e,n){if(t)return we[t];if(e)return 0;var i=parseInt(n,10),a=i%100;return(i-a)/100*60+a}(n[8],n[9],n[10]),t._d=zt.apply(null,t._a),t._d.setUTCMinutes(t._d.getUTCMinutes()-t._tzm),_(t).rfc2822=!0}else t._isValid=!1}function Ie(t,e,n){return null!=t?t:null!=e?e:n}function De(t){var e,n,i,a,r,s=[];if(!t._d){for(i=function(t){var e=new Date(o.now());return t._useUTC?[e.getUTCFullYear(),e.getUTCMonth(),e.getUTCDate()]:[e.getFullYear(),e.getMonth(),e.getDate()]}(t),t._w&&null==t._a[Bt]&&null==t._a[wt]&&function(t){var e,n,i,a,o,r,s,l,d;null!=(e=t._w).GG||null!=e.W||null!=e.E?(o=1,r=4,n=Ie(e.GG,t._a[yt],qt(Oe(),1,4).year),i=Ie(e.W,1),((a=Ie(e.E,1))<1||a>7)&&(l=!0)):(o=t._locale._week.dow,r=t._locale._week.doy,d=qt(Oe(),o,r),n=Ie(e.gg,t._a[yt],d.year),i=Ie(e.w,d.week),null!=e.d?((a=e.d)<0||a>6)&&(l=!0):null!=e.e?(a=e.e+o,(e.e<0||e.e>6)&&(l=!0)):a=o);i<1||i>Wt(n,o,r)?_(t)._overflowWeeks=!0:null!=l?_(t)._overflowWeekday=!0:(s=Vt(n,i,a,o,r),t._a[yt]=s.year,t._dayOfYear=s.dayOfYear)}(t),null!=t._dayOfYear&&(r=Ie(t._a[yt],i[yt]),(t._dayOfYear>Ht(r)||0===t._dayOfYear)&&(_(t)._overflowDayOfYear=!0),n=zt(r,0,t._dayOfYear),t._a[wt]=n.getUTCMonth(),t._a[Bt]=n.getUTCDate()),e=0;e<3&&null==t._a[e];++e)t._a[e]=s[e]=i[e];for(;e<7;e++)t._a[e]=s[e]=null==t._a[e]?2===e?1:0:t._a[e];24===t._a[kt]&&0===t._a[Et]&&0===t._a[It]&&0===t._a[Dt]&&(t._nextDay=!0,t._a[kt]=0),t._d=(t._useUTC?zt:function(t,e,n,i,a,o,r){var s;return t<100&&t>=0?(s=new Date(t+400,e,n,i,a,o,r),isFinite(s.getFullYear())&&s.setFullYear(t)):s=new Date(t,e,n,i,a,o,r),s}).apply(null,s),a=t._useUTC?t._d.getUTCDay():t._d.getDay(),null!=t._tzm&&t._d.setUTCMinutes(t._d.getUTCMinutes()-t._tzm),t._nextDay&&(t._a[kt]=24),t._w&&void 0!==t._w.d&&t._w.d!==a&&(_(t).weekdayMismatch=!0)}}function Se(t){if(t._f!==o.ISO_8601)if(t._f!==o.RFC_2822){t._a=[],_(t).empty=!0;var e,n,i,a,r,s,l=""+t._i,d=l.length,c=0;for(i=Y(t._f,t._locale).match(O)||[],e=0;e<i.length;e++)a=i[e],(n=(l.match(_t(a,t))||[])[0])&&((r=l.substr(0,l.indexOf(n))).length>0&&_(t).unusedInput.push(r),l=l.slice(l.indexOf(n)+n.length),c+=n.length),j[a]?(n?_(t).empty=!1:_(t).unusedTokens.push(a),vt(a,n,t)):t._strict&&!n&&_(t).unusedTokens.push(a);_(t).charsLeftOver=d-c,l.length>0&&_(t).unusedInput.push(l),t._a[kt]<=12&&!0===_(t).bigHour&&t._a[kt]>0&&(_(t).bigHour=void 0),_(t).parsedDateParts=t._a.slice(0),_(t).meridiem=t._meridiem,t._a[kt]=function(t,e,n){var i;if(null==n)return e;return null!=t.meridiemHour?t.meridiemHour(e,n):null!=t.isPM?((i=t.isPM(n))&&e<12&&(e+=12),i||12!==e||(e=0),e):e}(t._locale,t._a[kt],t._meridiem),null!==(s=_(t).era)&&(t._a[yt]=t._locale.erasConvertYear(s,t._a[yt])),De(t),_e(t)}else Ee(t);else Be(t)}function Ne(t){var e=t._i,n=t._f;return t._locale=t._locale||pe(t._l),null===e||void 0===n&&""===e?b({nullInput:!0}):("string"==typeof e&&(t._i=e=t._locale.preparse(e)),y(e)?new C(_e(e)):(u(e)?t._d=e:r(n)?function(t){var e,n,i,a,o,r,s=!1;if(0===t._f.length)return _(t).invalidFormat=!0,void(t._d=new Date(NaN));for(a=0;a<t._f.length;a++)o=0,r=!1,e=v({},t),null!=t._useUTC&&(e._useUTC=t._useUTC),e._f=t._f[a],Se(e),A(e)&&(r=!0),o+=_(e).charsLeftOver,o+=10*_(e).unusedTokens.length,_(e).score=o,s?o<i&&(i=o,n=e):(null==i||o<i||r)&&(i=o,n=e,r&&(s=!0));f(t,n||e)}(t):n?Se(t):function(t){var e=t._i;c(e)?t._d=new Date(o.now()):u(e)?t._d=new Date(e.valueOf()):"string"==typeof e?function(t){var e=Ce.exec(t._i);null===e?(Be(t),!1===t._isValid&&(delete t._isValid,Ee(t),!1===t._isValid&&(delete t._isValid,t._strict?t._isValid=!1:o.createFromInputFallback(t)))):t._d=new Date(+e[1])}(t):r(e)?(t._a=m(e.slice(0),function(t){return parseInt(t,10)}),De(t)):s(e)?function(t){if(!t._d){var e=z(t._i),n=void 0===e.day?e.date:e.day;t._a=m([e.year,e.month,n,e.hour,e.minute,e.second,e.millisecond],function(t){return t&&parseInt(t,10)}),De(t)}}(t):h(e)?t._d=new Date(e):o.createFromInputFallback(t)}(t),A(t)||(t._d=null),t))}function Me(t,e,n,i,a){var o,l={};return!0!==e&&!1!==e||(i=e,e=void 0),!0!==n&&!1!==n||(i=n,n=void 0),(s(t)&&d(t)||r(t)&&0===t.length)&&(t=void 0),l._isAMomentObject=!0,l._useUTC=l._isUTC=a,l._l=n,l._i=t,l._f=e,l._strict=i,(o=new C(_e(Ne(l))))._nextDay&&(o.add(1,"d"),o._nextDay=void 0),o}function Oe(t,e,n,i){return Me(t,e,n,i,!1)}o.createFromInputFallback=B("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(t){t._d=new Date(t._i+(t._useUTC?" UTC":""))}),o.ISO_8601=function(){},o.RFC_2822=function(){};var Te=B("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var t=Oe.apply(null,arguments);return this.isValid()&&t.isValid()?t<this?this:t:b()}),Le=B("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var t=Oe.apply(null,arguments);return this.isValid()&&t.isValid()?t>this?this:t:b()});function je(t,e){var n,i;if(1===e.length&&r(e[0])&&(e=e[0]),!e.length)return Oe();for(n=e[0],i=1;i<e.length;++i)e[i].isValid()&&!e[i][t](n)||(n=e[i]);return n}var Pe=["year","quarter","month","week","day","hour","minute","second","millisecond"];function Fe(t){var e=z(t),n=e.year||0,i=e.quarter||0,a=e.month||0,o=e.week||e.isoWeek||0,r=e.day||0,s=e.hour||0,d=e.minute||0,c=e.second||0,h=e.millisecond||0;this._isValid=function(t){var e,n,i=!1;for(e in t)if(l(t,e)&&(-1===Ct.call(Pe,e)||null!=t[e]&&isNaN(t[e])))return!1;for(n=0;n<Pe.length;++n)if(t[Pe[n]]){if(i)return!1;parseFloat(t[Pe[n]])!==U(t[Pe[n]])&&(i=!0)}return!0}(e),this._milliseconds=+h+1e3*c+6e4*d+1e3*s*60*60,this._days=+r+7*o,this._months=+a+3*i+12*n,this._data={},this._locale=pe(),this._bubble()}function Ye(t){return t instanceof Fe}function Re(t){return t<0?-1*Math.round(-1*t):Math.round(t)}function He(t,e){P(t,0,0,function(){var t=this.utcOffset(),n="+";return t<0&&(t=-t,n="-"),n+M(~~(t/60),2)+e+M(~~t%60,2)})}He("Z",":"),He("ZZ",""),pt("Z",mt),pt("ZZ",mt),xt(["Z","ZZ"],function(t,e,n){n._useUTC=!0,n._tzm=ze(mt,t)});var $e=/([\+\-]|\d\d)/gi;function ze(t,e){var n,i,a=(e||"").match(t);return null===a?null:0===(i=60*(n=((a[a.length-1]||[])+"").match($e)||["-",0,0])[1]+U(n[2]))?0:"+"===n[0]?i:-i}function Xe(t,e){var n,i;return e._isUTC?(n=e.clone(),i=(y(t)||u(t)?t.valueOf():Oe(t).valueOf())-n.valueOf(),n._d.setTime(n._d.valueOf()+i),o.updateOffset(n,!1),n):Oe(t).local()}function Ve(t){return-Math.round(t._d.getTimezoneOffset())}function qe(){return!!this.isValid()&&(this._isUTC&&0===this._offset)}o.updateOffset=function(){};var We=/^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,Ue=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function Ge(t,e){var n,i,a,o=t,r=null;return Ye(t)?o={ms:t._milliseconds,d:t._days,M:t._months}:h(t)||!isNaN(+t)?(o={},e?o[e]=+t:o.milliseconds=+t):(r=We.exec(t))?(n="-"===r[1]?-1:1,o={y:0,d:U(r[Bt])*n,h:U(r[kt])*n,m:U(r[Et])*n,s:U(r[It])*n,ms:U(Re(1e3*r[Dt]))*n}):(r=Ue.exec(t))?(n="-"===r[1]?-1:1,o={y:Ze(r[2],n),M:Ze(r[3],n),w:Ze(r[4],n),d:Ze(r[5],n),h:Ze(r[6],n),m:Ze(r[7],n),s:Ze(r[8],n)}):null==o?o={}:"object"==typeof o&&("from"in o||"to"in o)&&(a=function(t,e){var n;if(!t.isValid()||!e.isValid())return{milliseconds:0,months:0};e=Xe(e,t),t.isBefore(e)?n=Je(t,e):((n=Je(e,t)).milliseconds=-n.milliseconds,n.months=-n.months);return n}(Oe(o.from),Oe(o.to)),(o={}).ms=a.milliseconds,o.M=a.months),i=new Fe(o),Ye(t)&&l(t,"_locale")&&(i._locale=t._locale),Ye(t)&&l(t,"_isValid")&&(i._isValid=t._isValid),i}function Ze(t,e){var n=t&&parseFloat(t.replace(",","."));return(isNaN(n)?0:n)*e}function Je(t,e){var n={};return n.months=e.month()-t.month()+12*(e.year()-t.year()),t.clone().add(n.months,"M").isAfter(e)&&--n.months,n.milliseconds=+e-+t.clone().add(n.months,"M"),n}function Qe(t,e){return function(n,i){var a;return null===i||isNaN(+i)||(I(e,"moment()."+e+"(period, number) is deprecated. Please use moment()."+e+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),a=n,n=i,i=a),Ke(this,Ge(n,i),t),this}}function Ke(t,e,n,i){var a=e._milliseconds,r=Re(e._days),s=Re(e._months);t.isValid()&&(i=null==i||i,s&&Ft(t,Z(t,"Month")+s*n),r&&J(t,"Date",Z(t,"Date")+r*n),a&&t._d.setTime(t._d.valueOf()+a*n),i&&o.updateOffset(t,r||s))}Ge.fn=Fe.prototype,Ge.invalid=function(){return Ge(NaN)};var tn=Qe(1,"add"),en=Qe(-1,"subtract");function nn(t){return"string"==typeof t||t instanceof String}function an(t){return y(t)||u(t)||nn(t)||h(t)||function(t){var e=r(t),n=!1;e&&(n=0===t.filter(function(e){return!h(e)&&nn(t)}).length);return e&&n}(t)||function(t){var e,n=s(t)&&!d(t),i=!1,a=["years","year","y","months","month","M","days","day","d","dates","date","D","hours","hour","h","minutes","minute","m","seconds","second","s","milliseconds","millisecond","ms"];for(e=0;e<a.length;e+=1)i=i||l(t,a[e]);return n&&i}(t)||null===t||void 0===t}function on(t,e){if(t.date()<e.date())return-on(e,t);var n=12*(e.year()-t.year())+(e.month()-t.month()),i=t.clone().add(n,"months");return-(n+(e-i<0?(e-i)/(i-t.clone().add(n-1,"months")):(e-i)/(t.clone().add(n+1,"months")-i)))||0}function rn(t){var e;return void 0===t?this._locale._abbr:(null!=(e=pe(t))&&(this._locale=e),this)}o.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",o.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var sn=B("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(t){return void 0===t?this.localeData():this.locale(t)});function ln(){return this._locale}var dn=1e3,cn=60*dn,hn=60*cn,un=3506328*hn;function mn(t,e){return(t%e+e)%e}function fn(t,e,n){return t<100&&t>=0?new Date(t+400,e,n)-un:new Date(t,e,n).valueOf()}function pn(t,e,n){return t<100&&t>=0?Date.UTC(t+400,e,n)-un:Date.UTC(t,e,n)}function _n(t,e){return e.erasAbbrRegex(t)}function An(){var t,e,n=[],i=[],a=[],o=[],r=this.eras();for(t=0,e=r.length;t<e;++t)i.push(At(r[t].name)),n.push(At(r[t].abbr)),a.push(At(r[t].narrow)),o.push(At(r[t].name)),o.push(At(r[t].abbr)),o.push(At(r[t].narrow));this._erasRegex=new RegExp("^("+o.join("|")+")","i"),this._erasNameRegex=new RegExp("^("+i.join("|")+")","i"),this._erasAbbrRegex=new RegExp("^("+n.join("|")+")","i"),this._erasNarrowRegex=new RegExp("^("+a.join("|")+")","i")}function bn(t,e){P(0,[t,t.length],0,e)}function xn(t,e,n,i,a){var o;return null==t?qt(this,i,a).year:(e>(o=Wt(t,i,a))&&(e=o),function(t,e,n,i,a){var o=Vt(t,e,n,i,a),r=zt(o.year,0,o.dayOfYear);return this.year(r.getUTCFullYear()),this.month(r.getUTCMonth()),this.date(r.getUTCDate()),this}.call(this,t,e,n,i,a))}P("N",0,0,"eraAbbr"),P("NN",0,0,"eraAbbr"),P("NNN",0,0,"eraAbbr"),P("NNNN",0,0,"eraName"),P("NNNNN",0,0,"eraNarrow"),P("y",["y",1],"yo","eraYear"),P("y",["yy",2],0,"eraYear"),P("y",["yyy",3],0,"eraYear"),P("y",["yyyy",4],0,"eraYear"),pt("N",_n),pt("NN",_n),pt("NNN",_n),pt("NNNN",function(t,e){return e.erasNameRegex(t)}),pt("NNNNN",function(t,e){return e.erasNarrowRegex(t)}),xt(["N","NN","NNN","NNNN","NNNNN"],function(t,e,n,i){var a=n._locale.erasParse(t,i,n._strict);a?_(n).era=a:_(n).invalidEra=t}),pt("y",ct),pt("yy",ct),pt("yyy",ct),pt("yyyy",ct),pt("yo",function(t,e){return e._eraYearOrdinalRegex||ct}),xt(["y","yy","yyy","yyyy"],yt),xt(["yo"],function(t,e,n,i){var a;n._locale._eraYearOrdinalRegex&&(a=t.match(n._locale._eraYearOrdinalRegex)),n._locale.eraYearOrdinalParse?e[yt]=n._locale.eraYearOrdinalParse(t,a):e[yt]=parseInt(t,10)}),P(0,["gg",2],0,function(){return this.weekYear()%100}),P(0,["GG",2],0,function(){return this.isoWeekYear()%100}),bn("gggg","weekYear"),bn("ggggg","weekYear"),bn("GGGG","isoWeekYear"),bn("GGGGG","isoWeekYear"),H("weekYear","gg"),H("isoWeekYear","GG"),V("weekYear",1),V("isoWeekYear",1),pt("G",ht),pt("g",ht),pt("GG",at,tt),pt("gg",at,tt),pt("GGGG",lt,nt),pt("gggg",lt,nt),pt("GGGGG",dt,it),pt("ggggg",dt,it),gt(["gggg","ggggg","GGGG","GGGGG"],function(t,e,n,i){e[i.substr(0,2)]=U(t)}),gt(["gg","GG"],function(t,e,n,i){e[i]=o.parseTwoDigitYear(t)}),P("Q",0,"Qo","quarter"),H("quarter","Q"),V("quarter",7),pt("Q",K),xt("Q",function(t,e){e[wt]=3*(U(t)-1)}),P("D",["DD",2],"Do","date"),H("date","D"),V("date",9),pt("D",at),pt("DD",at,tt),pt("Do",function(t,e){return t?e._dayOfMonthOrdinalParse||e._ordinalParse:e._dayOfMonthOrdinalParseLenient}),xt(["D","DD"],Bt),xt("Do",function(t,e){e[Bt]=U(t.match(at)[0])});var gn=G("Date",!0);P("DDD",["DDDD",3],"DDDo","dayOfYear"),H("dayOfYear","DDD"),V("dayOfYear",4),pt("DDD",st),pt("DDDD",et),xt(["DDD","DDDD"],function(t,e,n){n._dayOfYear=U(t)}),P("m",["mm",2],0,"minute"),H("minute","m"),V("minute",14),pt("m",at),pt("mm",at,tt),xt(["m","mm"],Et);var vn=G("Minutes",!1);P("s",["ss",2],0,"second"),H("second","s"),V("second",15),pt("s",at),pt("ss",at,tt),xt(["s","ss"],It);var Cn,yn,wn=G("Seconds",!1);for(P("S",0,0,function(){return~~(this.millisecond()/100)}),P(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),P(0,["SSS",3],0,"millisecond"),P(0,["SSSS",4],0,function(){return 10*this.millisecond()}),P(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),P(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),P(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),P(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),P(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),H("millisecond","ms"),V("millisecond",16),pt("S",st,K),pt("SS",st,tt),pt("SSS",st,et),Cn="SSSS";Cn.length<=9;Cn+="S")pt(Cn,ct);function Bn(t,e){e[Dt]=U(1e3*("0."+t))}for(Cn="S";Cn.length<=9;Cn+="S")xt(Cn,Bn);yn=G("Milliseconds",!1),P("z",0,0,"zoneAbbr"),P("zz",0,0,"zoneName");var kn=C.prototype;function En(t){return t}kn.add=tn,kn.calendar=function(t,e){1===arguments.length&&(arguments[0]?an(arguments[0])?(t=arguments[0],e=void 0):function(t){var e,n=s(t)&&!d(t),i=!1,a=["sameDay","nextDay","lastDay","nextWeek","lastWeek","sameElse"];for(e=0;e<a.length;e+=1)i=i||l(t,a[e]);return n&&i}(arguments[0])&&(e=arguments[0],t=void 0):(t=void 0,e=void 0));var n=t||Oe(),i=Xe(n,this).startOf("day"),a=o.calendarFormat(this,i)||"sameElse",r=e&&(D(e[a])?e[a].call(this,n):e[a]);return this.format(r||this.localeData().calendar(a,this,Oe(n)))},kn.clone=function(){return new C(this)},kn.diff=function(t,e,n){var i,a,o;if(!this.isValid())return NaN;if(!(i=Xe(t,this)).isValid())return NaN;switch(a=6e4*(i.utcOffset()-this.utcOffset()),e=$(e)){case"year":o=on(this,i)/12;break;case"month":o=on(this,i);break;case"quarter":o=on(this,i)/3;break;case"second":o=(this-i)/1e3;break;case"minute":o=(this-i)/6e4;break;case"hour":o=(this-i)/36e5;break;case"day":o=(this-i-a)/864e5;break;case"week":o=(this-i-a)/6048e5;break;default:o=this-i}return n?o:W(o)},kn.endOf=function(t){var e,n;if(void 0===(t=$(t))||"millisecond"===t||!this.isValid())return this;switch(n=this._isUTC?pn:fn,t){case"year":e=n(this.year()+1,0,1)-1;break;case"quarter":e=n(this.year(),this.month()-this.month()%3+3,1)-1;break;case"month":e=n(this.year(),this.month()+1,1)-1;break;case"week":e=n(this.year(),this.month(),this.date()-this.weekday()+7)-1;break;case"isoWeek":e=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1)+7)-1;break;case"day":case"date":e=n(this.year(),this.month(),this.date()+1)-1;break;case"hour":e=this._d.valueOf(),e+=hn-mn(e+(this._isUTC?0:this.utcOffset()*cn),hn)-1;break;case"minute":e=this._d.valueOf(),e+=cn-mn(e,cn)-1;break;case"second":e=this._d.valueOf(),e+=dn-mn(e,dn)-1}return this._d.setTime(e),o.updateOffset(this,!0),this},kn.format=function(t){t||(t=this.isUtc()?o.defaultFormatUtc:o.defaultFormat);var e=F(this,t);return this.localeData().postformat(e)},kn.from=function(t,e){return this.isValid()&&(y(t)&&t.isValid()||Oe(t).isValid())?Ge({to:this,from:t}).locale(this.locale()).humanize(!e):this.localeData().invalidDate()},kn.fromNow=function(t){return this.from(Oe(),t)},kn.to=function(t,e){return this.isValid()&&(y(t)&&t.isValid()||Oe(t).isValid())?Ge({from:this,to:t}).locale(this.locale()).humanize(!e):this.localeData().invalidDate()},kn.toNow=function(t){return this.to(Oe(),t)},kn.get=function(t){return D(this[t=$(t)])?this[t]():this},kn.invalidAt=function(){return _(this).overflow},kn.isAfter=function(t,e){var n=y(t)?t:Oe(t);return!(!this.isValid()||!n.isValid())&&("millisecond"===(e=$(e)||"millisecond")?this.valueOf()>n.valueOf():n.valueOf()<this.clone().startOf(e).valueOf())},kn.isBefore=function(t,e){var n=y(t)?t:Oe(t);return!(!this.isValid()||!n.isValid())&&("millisecond"===(e=$(e)||"millisecond")?this.valueOf()<n.valueOf():this.clone().endOf(e).valueOf()<n.valueOf())},kn.isBetween=function(t,e,n,i){var a=y(t)?t:Oe(t),o=y(e)?e:Oe(e);return!!(this.isValid()&&a.isValid()&&o.isValid())&&("("===(i=i||"()")[0]?this.isAfter(a,n):!this.isBefore(a,n))&&(")"===i[1]?this.isBefore(o,n):!this.isAfter(o,n))},kn.isSame=function(t,e){var n,i=y(t)?t:Oe(t);return!(!this.isValid()||!i.isValid())&&("millisecond"===(e=$(e)||"millisecond")?this.valueOf()===i.valueOf():(n=i.valueOf(),this.clone().startOf(e).valueOf()<=n&&n<=this.clone().endOf(e).valueOf()))},kn.isSameOrAfter=function(t,e){return this.isSame(t,e)||this.isAfter(t,e)},kn.isSameOrBefore=function(t,e){return this.isSame(t,e)||this.isBefore(t,e)},kn.isValid=function(){return A(this)},kn.lang=sn,kn.locale=rn,kn.localeData=ln,kn.max=Le,kn.min=Te,kn.parsingFlags=function(){return f({},_(this))},kn.set=function(t,e){if("object"==typeof t){var n,i=function(t){var e,n=[];for(e in t)l(t,e)&&n.push({unit:e,priority:X[e]});return n.sort(function(t,e){return t.priority-e.priority}),n}(t=z(t));for(n=0;n<i.length;n++)this[i[n].unit](t[i[n].unit])}else if(D(this[t=$(t)]))return this[t](e);return this},kn.startOf=function(t){var e,n;if(void 0===(t=$(t))||"millisecond"===t||!this.isValid())return this;switch(n=this._isUTC?pn:fn,t){case"year":e=n(this.year(),0,1);break;case"quarter":e=n(this.year(),this.month()-this.month()%3,1);break;case"month":e=n(this.year(),this.month(),1);break;case"week":e=n(this.year(),this.month(),this.date()-this.weekday());break;case"isoWeek":e=n(this.year(),this.month(),this.date()-(this.isoWeekday()-1));break;case"day":case"date":e=n(this.year(),this.month(),this.date());break;case"hour":e=this._d.valueOf(),e-=mn(e+(this._isUTC?0:this.utcOffset()*cn),hn);break;case"minute":e=this._d.valueOf(),e-=mn(e,cn);break;case"second":e=this._d.valueOf(),e-=mn(e,dn)}return this._d.setTime(e),o.updateOffset(this,!0),this},kn.subtract=en,kn.toArray=function(){var t=this;return[t.year(),t.month(),t.date(),t.hour(),t.minute(),t.second(),t.millisecond()]},kn.toObject=function(){var t=this;return{years:t.year(),months:t.month(),date:t.date(),hours:t.hours(),minutes:t.minutes(),seconds:t.seconds(),milliseconds:t.milliseconds()}},kn.toDate=function(){return new Date(this.valueOf())},kn.toISOString=function(t){if(!this.isValid())return null;var e=!0!==t,n=e?this.clone().utc():this;return n.year()<0||n.year()>9999?F(n,e?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):D(Date.prototype.toISOString)?e?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",F(n,"Z")):F(n,e?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ")},kn.inspect=function(){if(!this.isValid())return"moment.invalid(/* "+this._i+" */)";var t,e,n,i="moment",a="";return this.isLocal()||(i=0===this.utcOffset()?"moment.utc":"moment.parseZone",a="Z"),t="["+i+'("]',e=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",n=a+'[")]',this.format(t+e+"-MM-DD[T]HH:mm:ss.SSS"+n)},"undefined"!=typeof Symbol&&null!=Symbol.for&&(kn[Symbol.for("nodejs.util.inspect.custom")]=function(){return"Moment<"+this.format()+">"}),kn.toJSON=function(){return this.isValid()?this.toISOString():null},kn.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},kn.unix=function(){return Math.floor(this.valueOf()/1e3)},kn.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},kn.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},kn.eraName=function(){var t,e,n,i=this.localeData().eras();for(t=0,e=i.length;t<e;++t){if(n=this.clone().startOf("day").valueOf(),i[t].since<=n&&n<=i[t].until)return i[t].name;if(i[t].until<=n&&n<=i[t].since)return i[t].name}return""},kn.eraNarrow=function(){var t,e,n,i=this.localeData().eras();for(t=0,e=i.length;t<e;++t){if(n=this.clone().startOf("day").valueOf(),i[t].since<=n&&n<=i[t].until)return i[t].narrow;if(i[t].until<=n&&n<=i[t].since)return i[t].narrow}return""},kn.eraAbbr=function(){var t,e,n,i=this.localeData().eras();for(t=0,e=i.length;t<e;++t){if(n=this.clone().startOf("day").valueOf(),i[t].since<=n&&n<=i[t].until)return i[t].abbr;if(i[t].until<=n&&n<=i[t].since)return i[t].abbr}return""},kn.eraYear=function(){var t,e,n,i,a=this.localeData().eras();for(t=0,e=a.length;t<e;++t)if(n=a[t].since<=a[t].until?1:-1,i=this.clone().startOf("day").valueOf(),a[t].since<=i&&i<=a[t].until||a[t].until<=i&&i<=a[t].since)return(this.year()-o(a[t].since).year())*n+a[t].offset;return this.year()},kn.year=$t,kn.isLeapYear=function(){return q(this.year())},kn.weekYear=function(t){return xn.call(this,t,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)},kn.isoWeekYear=function(t){return xn.call(this,t,this.isoWeek(),this.isoWeekday(),1,4)},kn.quarter=kn.quarters=function(t){return null==t?Math.ceil((this.month()+1)/3):this.month(3*(t-1)+this.month()%3)},kn.month=Yt,kn.daysInMonth=function(){return Mt(this.year(),this.month())},kn.week=kn.weeks=function(t){var e=this.localeData().week(this);return null==t?e:this.add(7*(t-e),"d")},kn.isoWeek=kn.isoWeeks=function(t){var e=qt(this,1,4).week;return null==t?e:this.add(7*(t-e),"d")},kn.weeksInYear=function(){var t=this.localeData()._week;return Wt(this.year(),t.dow,t.doy)},kn.weeksInWeekYear=function(){var t=this.localeData()._week;return Wt(this.weekYear(),t.dow,t.doy)},kn.isoWeeksInYear=function(){return Wt(this.year(),1,4)},kn.isoWeeksInISOWeekYear=function(){return Wt(this.isoWeekYear(),1,4)},kn.date=gn,kn.day=kn.days=function(t){if(!this.isValid())return null!=t?this:NaN;var e=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=t?(t=function(t,e){return"string"!=typeof t?t:isNaN(t)?"number"==typeof(t=e.weekdaysParse(t))?t:null:parseInt(t,10)}(t,this.localeData()),this.add(t-e,"d")):e},kn.weekday=function(t){if(!this.isValid())return null!=t?this:NaN;var e=(this.day()+7-this.localeData()._week.dow)%7;return null==t?e:this.add(t-e,"d")},kn.isoWeekday=function(t){if(!this.isValid())return null!=t?this:NaN;if(null!=t){var e=function(t,e){return"string"==typeof t?e.weekdaysParse(t)%7||7:isNaN(t)?null:t}(t,this.localeData());return this.day(this.day()%7?e:e-7)}return this.day()||7},kn.dayOfYear=function(t){var e=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==t?e:this.add(t-e,"d")},kn.hour=kn.hours=oe,kn.minute=kn.minutes=vn,kn.second=kn.seconds=wn,kn.millisecond=kn.milliseconds=yn,kn.utcOffset=function(t,e,n){var i,a=this._offset||0;if(!this.isValid())return null!=t?this:NaN;if(null!=t){if("string"==typeof t){if(null===(t=ze(mt,t)))return this}else Math.abs(t)<16&&!n&&(t*=60);return!this._isUTC&&e&&(i=Ve(this)),this._offset=t,this._isUTC=!0,null!=i&&this.add(i,"m"),a!==t&&(!e||this._changeInProgress?Ke(this,Ge(t-a,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,o.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?a:Ve(this)},kn.utc=function(t){return this.utcOffset(0,t)},kn.local=function(t){return this._isUTC&&(this.utcOffset(0,t),this._isUTC=!1,t&&this.subtract(Ve(this),"m")),this},kn.parseZone=function(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if("string"==typeof this._i){var t=ze(ut,this._i);null!=t?this.utcOffset(t):this.utcOffset(0,!0)}return this},kn.hasAlignedHourOffset=function(t){return!!this.isValid()&&(t=t?Oe(t).utcOffset():0,(this.utcOffset()-t)%60==0)},kn.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},kn.isLocal=function(){return!!this.isValid()&&!this._isUTC},kn.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},kn.isUtc=qe,kn.isUTC=qe,kn.zoneAbbr=function(){return this._isUTC?"UTC":""},kn.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},kn.dates=B("dates accessor is deprecated. Use date instead.",gn),kn.months=B("months accessor is deprecated. Use month instead",Yt),kn.years=B("years accessor is deprecated. Use year instead",$t),kn.zone=B("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(t,e){return null!=t?("string"!=typeof t&&(t=-t),this.utcOffset(t,e),this):-this.utcOffset()}),kn.isDSTShifted=B("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){if(!c(this._isDSTShifted))return this._isDSTShifted;var t,e={};return v(e,this),(e=Ne(e))._a?(t=e._isUTC?p(e._a):Oe(e._a),this._isDSTShifted=this.isValid()&&function(t,e,n){var i,a=Math.min(t.length,e.length),o=Math.abs(t.length-e.length),r=0;for(i=0;i<a;i++)(n&&t[i]!==e[i]||!n&&U(t[i])!==U(e[i]))&&r++;return r+o}(e._a,t.toArray())>0):this._isDSTShifted=!1,this._isDSTShifted});var In=N.prototype;function Dn(t,e,n,i){var a=pe(),o=p().set(i,e);return a[n](o,t)}function Sn(t,e,n){if(h(t)&&(e=t,t=void 0),t=t||"",null!=e)return Dn(t,e,n,"month");var i,a=[];for(i=0;i<12;i++)a[i]=Dn(t,i,n,"month");return a}function Nn(t,e,n,i){"boolean"==typeof t?(h(e)&&(n=e,e=void 0),e=e||""):(n=e=t,t=!1,h(e)&&(n=e,e=void 0),e=e||"");var a,o=pe(),r=t?o._week.dow:0,s=[];if(null!=n)return Dn(e,(n+r)%7,i,"day");for(a=0;a<7;a++)s[a]=Dn(e,(a+r)%7,i,"day");return s}In.calendar=function(t,e,n){var i=this._calendar[t]||this._calendar.sameElse;return D(i)?i.call(e,n):i},In.longDateFormat=function(t){var e=this._longDateFormat[t],n=this._longDateFormat[t.toUpperCase()];return e||!n?e:(this._longDateFormat[t]=n.match(O).map(function(t){return"MMMM"===t||"MM"===t||"DD"===t||"dddd"===t?t.slice(1):t}).join(""),this._longDateFormat[t])},In.invalidDate=function(){return this._invalidDate},In.ordinal=function(t){return this._ordinal.replace("%d",t)},In.preparse=En,In.postformat=En,In.relativeTime=function(t,e,n,i){var a=this._relativeTime[n];return D(a)?a(t,e,n,i):a.replace(/%d/i,t)},In.pastFuture=function(t,e){var n=this._relativeTime[t>0?"future":"past"];return D(n)?n(e):n.replace(/%s/i,e)},In.set=function(t){var e,n;for(n in t)l(t,n)&&(D(e=t[n])?this[n]=e:this["_"+n]=e);this._config=t,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},In.eras=function(t,e){var n,i,a,r=this._eras||pe("en")._eras;for(n=0,i=r.length;n<i;++n){switch(typeof r[n].since){case"string":a=o(r[n].since).startOf("day"),r[n].since=a.valueOf()}switch(typeof r[n].until){case"undefined":r[n].until=1/0;break;case"string":a=o(r[n].until).startOf("day").valueOf(),r[n].until=a.valueOf()}}return r},In.erasParse=function(t,e,n){var i,a,o,r,s,l=this.eras();for(t=t.toUpperCase(),i=0,a=l.length;i<a;++i)if(o=l[i].name.toUpperCase(),r=l[i].abbr.toUpperCase(),s=l[i].narrow.toUpperCase(),n)switch(e){case"N":case"NN":case"NNN":if(r===t)return l[i];break;case"NNNN":if(o===t)return l[i];break;case"NNNNN":if(s===t)return l[i]}else if([o,r,s].indexOf(t)>=0)return l[i]},In.erasConvertYear=function(t,e){var n=t.since<=t.until?1:-1;return void 0===e?o(t.since).year():o(t.since).year()+(e-t.offset)*n},In.erasAbbrRegex=function(t){return l(this,"_erasAbbrRegex")||An.call(this),t?this._erasAbbrRegex:this._erasRegex},In.erasNameRegex=function(t){return l(this,"_erasNameRegex")||An.call(this),t?this._erasNameRegex:this._erasRegex},In.erasNarrowRegex=function(t){return l(this,"_erasNarrowRegex")||An.call(this),t?this._erasNarrowRegex:this._erasRegex},In.months=function(t,e){return t?r(this._months)?this._months[t.month()]:this._months[(this._months.isFormat||Lt).test(e)?"format":"standalone"][t.month()]:r(this._months)?this._months:this._months.standalone},In.monthsShort=function(t,e){return t?r(this._monthsShort)?this._monthsShort[t.month()]:this._monthsShort[Lt.test(e)?"format":"standalone"][t.month()]:r(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},In.monthsParse=function(t,e,n){var i,a,o;if(this._monthsParseExact)return function(t,e,n){var i,a,o,r=t.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],i=0;i<12;++i)o=p([2e3,i]),this._shortMonthsParse[i]=this.monthsShort(o,"").toLocaleLowerCase(),this._longMonthsParse[i]=this.months(o,"").toLocaleLowerCase();return n?"MMM"===e?-1!==(a=Ct.call(this._shortMonthsParse,r))?a:null:-1!==(a=Ct.call(this._longMonthsParse,r))?a:null:"MMM"===e?-1!==(a=Ct.call(this._shortMonthsParse,r))?a:-1!==(a=Ct.call(this._longMonthsParse,r))?a:null:-1!==(a=Ct.call(this._longMonthsParse,r))?a:-1!==(a=Ct.call(this._shortMonthsParse,r))?a:null}.call(this,t,e,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),i=0;i<12;i++){if(a=p([2e3,i]),n&&!this._longMonthsParse[i]&&(this._longMonthsParse[i]=new RegExp("^"+this.months(a,"").replace(".","")+"$","i"),this._shortMonthsParse[i]=new RegExp("^"+this.monthsShort(a,"").replace(".","")+"$","i")),n||this._monthsParse[i]||(o="^"+this.months(a,"")+"|^"+this.monthsShort(a,""),this._monthsParse[i]=new RegExp(o.replace(".",""),"i")),n&&"MMMM"===e&&this._longMonthsParse[i].test(t))return i;if(n&&"MMM"===e&&this._shortMonthsParse[i].test(t))return i;if(!n&&this._monthsParse[i].test(t))return i}},In.monthsRegex=function(t){return this._monthsParseExact?(l(this,"_monthsRegex")||Rt.call(this),t?this._monthsStrictRegex:this._monthsRegex):(l(this,"_monthsRegex")||(this._monthsRegex=Pt),this._monthsStrictRegex&&t?this._monthsStrictRegex:this._monthsRegex)},In.monthsShortRegex=function(t){return this._monthsParseExact?(l(this,"_monthsRegex")||Rt.call(this),t?this._monthsShortStrictRegex:this._monthsShortRegex):(l(this,"_monthsShortRegex")||(this._monthsShortRegex=jt),this._monthsShortStrictRegex&&t?this._monthsShortStrictRegex:this._monthsShortRegex)},In.week=function(t){return qt(t,this._week.dow,this._week.doy).week},In.firstDayOfYear=function(){return this._week.doy},In.firstDayOfWeek=function(){return this._week.dow},In.weekdays=function(t,e){var n=r(this._weekdays)?this._weekdays:this._weekdays[t&&!0!==t&&this._weekdays.isFormat.test(e)?"format":"standalone"];return!0===t?Ut(n,this._week.dow):t?n[t.day()]:n},In.weekdaysMin=function(t){return!0===t?Ut(this._weekdaysMin,this._week.dow):t?this._weekdaysMin[t.day()]:this._weekdaysMin},In.weekdaysShort=function(t){return!0===t?Ut(this._weekdaysShort,this._week.dow):t?this._weekdaysShort[t.day()]:this._weekdaysShort},In.weekdaysParse=function(t,e,n){var i,a,o;if(this._weekdaysParseExact)return function(t,e,n){var i,a,o,r=t.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],i=0;i<7;++i)o=p([2e3,1]).day(i),this._minWeekdaysParse[i]=this.weekdaysMin(o,"").toLocaleLowerCase(),this._shortWeekdaysParse[i]=this.weekdaysShort(o,"").toLocaleLowerCase(),this._weekdaysParse[i]=this.weekdays(o,"").toLocaleLowerCase();return n?"dddd"===e?-1!==(a=Ct.call(this._weekdaysParse,r))?a:null:"ddd"===e?-1!==(a=Ct.call(this._shortWeekdaysParse,r))?a:null:-1!==(a=Ct.call(this._minWeekdaysParse,r))?a:null:"dddd"===e?-1!==(a=Ct.call(this._weekdaysParse,r))?a:-1!==(a=Ct.call(this._shortWeekdaysParse,r))?a:-1!==(a=Ct.call(this._minWeekdaysParse,r))?a:null:"ddd"===e?-1!==(a=Ct.call(this._shortWeekdaysParse,r))?a:-1!==(a=Ct.call(this._weekdaysParse,r))?a:-1!==(a=Ct.call(this._minWeekdaysParse,r))?a:null:-1!==(a=Ct.call(this._minWeekdaysParse,r))?a:-1!==(a=Ct.call(this._weekdaysParse,r))?a:-1!==(a=Ct.call(this._shortWeekdaysParse,r))?a:null}.call(this,t,e,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),i=0;i<7;i++){if(a=p([2e3,1]).day(i),n&&!this._fullWeekdaysParse[i]&&(this._fullWeekdaysParse[i]=new RegExp("^"+this.weekdays(a,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[i]=new RegExp("^"+this.weekdaysShort(a,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[i]=new RegExp("^"+this.weekdaysMin(a,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[i]||(o="^"+this.weekdays(a,"")+"|^"+this.weekdaysShort(a,"")+"|^"+this.weekdaysMin(a,""),this._weekdaysParse[i]=new RegExp(o.replace(".",""),"i")),n&&"dddd"===e&&this._fullWeekdaysParse[i].test(t))return i;if(n&&"ddd"===e&&this._shortWeekdaysParse[i].test(t))return i;if(n&&"dd"===e&&this._minWeekdaysParse[i].test(t))return i;if(!n&&this._weekdaysParse[i].test(t))return i}},In.weekdaysRegex=function(t){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||ee.call(this),t?this._weekdaysStrictRegex:this._weekdaysRegex):(l(this,"_weekdaysRegex")||(this._weekdaysRegex=Qt),this._weekdaysStrictRegex&&t?this._weekdaysStrictRegex:this._weekdaysRegex)},In.weekdaysShortRegex=function(t){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||ee.call(this),t?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(l(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=Kt),this._weekdaysShortStrictRegex&&t?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},In.weekdaysMinRegex=function(t){return this._weekdaysParseExact?(l(this,"_weekdaysRegex")||ee.call(this),t?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(l(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=te),this._weekdaysMinStrictRegex&&t?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},In.isPM=function(t){return"p"===(t+"").toLowerCase().charAt(0)},In.meridiem=function(t,e,n){return t>11?n?"pm":"PM":n?"am":"AM"},me("en",{eras:[{since:"0001-01-01",until:1/0,offset:1,name:"Anno Domini",narrow:"AD",abbr:"AD"},{since:"0000-12-31",until:-1/0,offset:1,name:"Before Christ",narrow:"BC",abbr:"BC"}],dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(t){var e=t%10;return t+(1===U(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")}}),o.lang=B("moment.lang is deprecated. Use moment.locale instead.",me),o.langData=B("moment.langData is deprecated. Use moment.localeData instead.",pe);var Mn=Math.abs;function On(t,e,n,i){var a=Ge(e,n);return t._milliseconds+=i*a._milliseconds,t._days+=i*a._days,t._months+=i*a._months,t._bubble()}function Tn(t){return t<0?Math.floor(t):Math.ceil(t)}function Ln(t){return 4800*t/146097}function jn(t){return 146097*t/4800}function Pn(t){return function(){return this.as(t)}}var Fn=Pn("ms"),Yn=Pn("s"),Rn=Pn("m"),Hn=Pn("h"),$n=Pn("d"),zn=Pn("w"),Xn=Pn("M"),Vn=Pn("Q"),qn=Pn("y");function Wn(t){return function(){return this.isValid()?this._data[t]:NaN}}var Un=Wn("milliseconds"),Gn=Wn("seconds"),Zn=Wn("minutes"),Jn=Wn("hours"),Qn=Wn("days"),Kn=Wn("months"),ti=Wn("years");var ei=Math.round,ni={ss:44,s:45,m:45,h:22,d:26,w:null,M:11};var ii=Math.abs;function ai(t){return(t>0)-(t<0)||+t}function oi(){if(!this.isValid())return this.localeData().invalidDate();var t,e,n,i,a,o,r,s,l=ii(this._milliseconds)/1e3,d=ii(this._days),c=ii(this._months),h=this.asSeconds();return h?(e=W((t=W(l/60))/60),l%=60,t%=60,n=W(c/12),c%=12,i=l?l.toFixed(3).replace(/\.?0+$/,""):"",a=h<0?"-":"",o=ai(this._months)!==ai(h)?"-":"",r=ai(this._days)!==ai(h)?"-":"",s=ai(this._milliseconds)!==ai(h)?"-":"",a+"P"+(n?o+n+"Y":"")+(c?o+c+"M":"")+(d?r+d+"D":"")+(e||t||l?"T":"")+(e?s+e+"H":"")+(t?s+t+"M":"")+(l?s+i+"S":"")):"P0D"}var ri=Fe.prototype;return ri.isValid=function(){return this._isValid},ri.abs=function(){var t=this._data;return this._milliseconds=Mn(this._milliseconds),this._days=Mn(this._days),this._months=Mn(this._months),t.milliseconds=Mn(t.milliseconds),t.seconds=Mn(t.seconds),t.minutes=Mn(t.minutes),t.hours=Mn(t.hours),t.months=Mn(t.months),t.years=Mn(t.years),this},ri.add=function(t,e){return On(this,t,e,1)},ri.subtract=function(t,e){return On(this,t,e,-1)},ri.as=function(t){if(!this.isValid())return NaN;var e,n,i=this._milliseconds;if("month"===(t=$(t))||"quarter"===t||"year"===t)switch(e=this._days+i/864e5,n=this._months+Ln(e),t){case"month":return n;case"quarter":return n/3;case"year":return n/12}else switch(e=this._days+Math.round(jn(this._months)),t){case"week":return e/7+i/6048e5;case"day":return e+i/864e5;case"hour":return 24*e+i/36e5;case"minute":return 1440*e+i/6e4;case"second":return 86400*e+i/1e3;case"millisecond":return Math.floor(864e5*e)+i;default:throw new Error("Unknown unit "+t)}},ri.asMilliseconds=Fn,ri.asSeconds=Yn,ri.asMinutes=Rn,ri.asHours=Hn,ri.asDays=$n,ri.asWeeks=zn,ri.asMonths=Xn,ri.asQuarters=Vn,ri.asYears=qn,ri.valueOf=function(){return this.isValid()?this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*U(this._months/12):NaN},ri._bubble=function(){var t,e,n,i,a,o=this._milliseconds,r=this._days,s=this._months,l=this._data;return o>=0&&r>=0&&s>=0||o<=0&&r<=0&&s<=0||(o+=864e5*Tn(jn(s)+r),r=0,s=0),l.milliseconds=o%1e3,t=W(o/1e3),l.seconds=t%60,e=W(t/60),l.minutes=e%60,n=W(e/60),l.hours=n%24,s+=a=W(Ln(r+=W(n/24))),r-=Tn(jn(a)),i=W(s/12),s%=12,l.days=r,l.months=s,l.years=i,this},ri.clone=function(){return Ge(this)},ri.get=function(t){return t=$(t),this.isValid()?this[t+"s"]():NaN},ri.milliseconds=Un,ri.seconds=Gn,ri.minutes=Zn,ri.hours=Jn,ri.days=Qn,ri.weeks=function(){return W(this.days()/7)},ri.months=Kn,ri.years=ti,ri.humanize=function(t,e){if(!this.isValid())return this.localeData().invalidDate();var n,i,a=!1,o=ni;return"object"==typeof t&&(e=t,t=!1),"boolean"==typeof t&&(a=t),"object"==typeof e&&(o=Object.assign({},ni,e),null!=e.s&&null==e.ss&&(o.ss=e.s-1)),i=function(t,e,n,i){var a=Ge(t).abs(),o=ei(a.as("s")),r=ei(a.as("m")),s=ei(a.as("h")),l=ei(a.as("d")),d=ei(a.as("M")),c=ei(a.as("w")),h=ei(a.as("y")),u=o<=n.ss&&["s",o]||o<n.s&&["ss",o]||r<=1&&["m"]||r<n.m&&["mm",r]||s<=1&&["h"]||s<n.h&&["hh",s]||l<=1&&["d"]||l<n.d&&["dd",l];return null!=n.w&&(u=u||c<=1&&["w"]||c<n.w&&["ww",c]),(u=u||d<=1&&["M"]||d<n.M&&["MM",d]||h<=1&&["y"]||["yy",h])[2]=e,u[3]=+t>0,u[4]=i,function(t,e,n,i,a){return a.relativeTime(e||1,!!n,t,i)}.apply(null,u)}(this,!a,o,n=this.localeData()),a&&(i=n.pastFuture(+this,i)),n.postformat(i)},ri.toISOString=oi,ri.toString=oi,ri.toJSON=oi,ri.locale=rn,ri.localeData=ln,ri.toIsoString=B("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",oi),ri.lang=sn,P("X",0,0,"unix"),P("x",0,0,"valueOf"),pt("x",ht),pt("X",/[+-]?\d+(\.\d{1,3})?/),xt("X",function(t,e,n){n._d=new Date(1e3*parseFloat(t))}),xt("x",function(t,e,n){n._d=new Date(U(t))}),
//! moment.js
o.version="2.29.1",i=Oe,o.fn=kn,o.min=function(){return je("isBefore",[].slice.call(arguments,0))},o.max=function(){return je("isAfter",[].slice.call(arguments,0))},o.now=function(){return Date.now?Date.now():+new Date},o.utc=p,o.unix=function(t){return Oe(1e3*t)},o.months=function(t,e){return Sn(t,e,"months")},o.isDate=u,o.locale=me,o.invalid=b,o.duration=Ge,o.isMoment=y,o.weekdays=function(t,e,n){return Nn(t,e,n,"weekdays")},o.parseZone=function(){return Oe.apply(null,arguments).parseZone()},o.localeData=pe,o.isDuration=Ye,o.monthsShort=function(t,e){return Sn(t,e,"monthsShort")},o.weekdaysMin=function(t,e,n){return Nn(t,e,n,"weekdaysMin")},o.defineLocale=fe,o.updateLocale=function(t,e){if(null!=e){var n,i,a=se;null!=le[t]&&null!=le[t].parentLocale?le[t].set(S(le[t]._config,e)):(null!=(i=ue(t))&&(a=i._config),e=S(a,e),null==i&&(e.abbr=t),(n=new N(e)).parentLocale=le[t],le[t]=n),me(t)}else null!=le[t]&&(null!=le[t].parentLocale?(le[t]=le[t].parentLocale,t===me()&&me(t)):null!=le[t]&&delete le[t]);return le[t]},o.locales=function(){return k(le)},o.weekdaysShort=function(t,e,n){return Nn(t,e,n,"weekdaysShort")},o.normalizeUnits=$,o.relativeTimeRounding=function(t){return void 0===t?ei:"function"==typeof t&&(ei=t,!0)},o.relativeTimeThreshold=function(t,e){return void 0!==ni[t]&&(void 0===e?ni[t]:(ni[t]=e,"s"===t&&(ni.ss=e-1),!0))},o.calendarFormat=function(t,e){var n=t.diff(e,"days",!0);return n<-6?"sameElse":n<-1?"lastWeek":n<0?"lastDay":n<1?"sameDay":n<2?"nextDay":n<7?"nextWeek":"sameElse"},o.prototype=kn,o.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"GGGG-[W]WW",MONTH:"YYYY-MM"},o},t.exports=i()}).call(e,n("3IRH")(t))},PY1i:function(t,e,n){var i=n("8ANE"),a=n("YjQv").document,o=i(a)&&i(a.createElement);t.exports=function(t){return o?a.createElement(t):{}}},PbQV:function(t,e,n){var i=n("ksFB"),a=n("GhAV"),o=n("+VX5");t.exports=function(t){return function(e,n,r){var s,l=i(e),d=a(l.length),c=o(r,d);if(t&&n!=n){for(;d>c;)if((s=l[c++])!=s)return!0}else for(;d>c;c++)if((t||c in l)&&l[c]===n)return t||c||0;return!t&&-1}}},PeZz:function(t,e,n){var i=n("vAyx");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("d89bd59e",i,!0,{})},Pfub:function(t,e,n){var i=n("aYJh");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("4259c7ee",i,!0,{})},PiFy:function(t,e,n){"use strict";var i=n("fRHV");t.exports=Function.prototype.bind||i},QRWa:function(t,e,n){var i=n("19IS");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("d9f1f844",i,!0,{})},QZk1:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("en-il",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")}})})(n("PJh5"))},QbpY:function(t,e,n){var i=n("pI7q");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("573c13eb",i,!0,{})},QfTC:function(t,e,n){var i=n("S1o/");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("08ddc8e4",i,!0,{})},R870:function(t,e,n){var i=n("4tom");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("523d3abc",i,!0,{})},R90k:function(t,e,n){var i=n("ge/6");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("5dcb15a4",i,!0,{})},Re3r:function(t,e){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
t.exports=function(t){return null!=t&&null!=t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}},RnJI:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ka",{months:"იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split("_"),monthsShort:"იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),weekdays:{standalone:"კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split("_"),format:"კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს".split("_"),isFormat:/(წინა|შემდეგ)/},weekdaysShort:"კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),weekdaysMin:"კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[დღეს] LT[-ზე]",nextDay:"[ხვალ] LT[-ზე]",lastDay:"[გუშინ] LT[-ზე]",nextWeek:"[შემდეგ] dddd LT[-ზე]",lastWeek:"[წინა] dddd LT-ზე",sameElse:"L"},relativeTime:{future:function(t){return t.replace(/(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,function(t,e,n){return"ი"===n?e+"ში":e+n+"ში"})},past:function(t){return/(წამი|წუთი|საათი|დღე|თვე)/.test(t)?t.replace(/(ი|ე)$/,"ის წინ"):/წელი/.test(t)?t.replace(/წელი$/,"წლის წინ"):t},s:"რამდენიმე წამი",ss:"%d წამი",m:"წუთი",mm:"%d წუთი",h:"საათი",hh:"%d საათი",d:"დღე",dd:"%d დღე",M:"თვე",MM:"%d თვე",y:"წელი",yy:"%d წელი"},dayOfMonthOrdinalParse:/0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,ordinal:function(t){return 0===t?t:1===t?t+"-ლი":t<20||t<=100&&t%20==0||t%100==0?"მე-"+t:t+"-ე"},week:{dow:1,doy:7}})})(n("PJh5"))},"S1o/":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.form-content {\n  text-align: center;\n}\n.fade-enter-active, .fade-leave-active {\n  -webkit-transition: opacity .2s;\n  transition: opacity .2s\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {\n  opacity: 0\n}\n.itemContext {\n  cursor: pointer;\n}\n.itemContext:hover {\n  background-color: rgb(245, 214, 255);\n}","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfForm/PfForm.css"],names:[],mappings:";AACA;EACE,mBAAmB;CACpB;AACD;EACE,gCAAgC;EAChC,uBAAuB;CACxB;AACD;EACE,UAAU;CACX;AACD;EACE,gBAAgB;CACjB;AACD;EACE,qCAAqC;CACtC",file:"PfForm.css",sourcesContent:["\n.form-content {\n  text-align: center;\n}\n.fade-enter-active, .fade-leave-active {\n  -webkit-transition: opacity .2s;\n  transition: opacity .2s\n}\n.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {\n  opacity: 0\n}\n.itemContext {\n  cursor: pointer;\n}\n.itemContext:hover {\n  background-color: rgb(245, 214, 255);\n}"],sourceRoot:""}])},S4wQ:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfVisa.css",sourceRoot:""}])},SCiL:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-205fbe5c] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-205fbe5c]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-205fbe5c] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-205fbe5c] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-205fbe5c] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-205fbe5c] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-205fbe5c] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-205fbe5c] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-205fbe5c] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-205fbe5c] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-205fbe5c] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-205fbe5c] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-205fbe5c] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-205fbe5c] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-205fbe5c] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-205fbe5c] {\n  margin-right: 0px;\n}\n.newItem[data-v-205fbe5c] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-205fbe5c] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-205fbe5c] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-205fbe5c] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-205fbe5c] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-205fbe5c] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-205fbe5c] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-205fbe5c] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-205fbe5c] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-205fbe5c] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-205fbe5c]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-205fbe5c] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-205fbe5c] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-205fbe5c] {\n  color: red;\n}\n.showMore[data-v-205fbe5c]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-205fbe5c] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-205fbe5c] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-205fbe5c] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-205fbe5c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-205fbe5c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-205fbe5c] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-205fbe5c 3s infinite;\n  animation: bit-data-v-205fbe5c 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-205fbe5c] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-205fbe5c]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-205fbe5c]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-205fbe5c]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-205fbe5c]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-205fbe5c]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-205fbe5c]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-205fbe5c] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-205fbe5c]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-205fbe5c] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-205fbe5c] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-205fbe5c] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-205fbe5c] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-205fbe5c] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-205fbe5c] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-205fbe5c] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-205fbe5c] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-205fbe5c] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-205fbe5c] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-205fbe5c] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-205fbe5c] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-205fbe5c] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-205fbe5c] {\n  margin-right: 0px;\n}\n.newItem[data-v-205fbe5c] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-205fbe5c] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-205fbe5c] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-205fbe5c] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-205fbe5c] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-205fbe5c] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-205fbe5c] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-205fbe5c] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-205fbe5c] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-205fbe5c] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-205fbe5c]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-205fbe5c] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-205fbe5c] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-205fbe5c] {\n  color: red;\n}\n.showMore[data-v-205fbe5c]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-205fbe5c] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-205fbe5c] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-205fbe5c] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-205fbe5c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-205fbe5c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-205fbe5c] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-205fbe5c 3s infinite;\n  animation: bit-data-v-205fbe5c 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-205fbe5c] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-205fbe5c]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-205fbe5c]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-205fbe5c]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-205fbe5c]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-205fbe5c]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-205fbe5c]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},SFAD:function(t,e){t.exports="data:image/gif;base64,R0lGODlh3gAJAOfuAAAAAAEBAQICAgMDAwQEBAUFBQYGBgcHBwgICAkJCQoKCgsLCwwMDA0NDQ4ODg8PDxAQEBERERISEhMTExQUFBUVFRYWFhcXFxgYGBkZGRoaGhsbGxwcHB0dHR4eHh8fHyAgICEhISIiIiMjIyQkJCUlJSYmJicnJygoKCkpKSoqKisrKywsLC0tLS4uLi8vLzAwMDExMTIyMjMzMzQ0NDU1NTY2Njc3Nzg4ODk5OTo6Ojs7Ozw8PD09PT4+Pj8/P0BAQEFBQUJCQkNDQ0REREVFRUZGRkdHR0hISElJSUpKSktLS0xMTE1NTU5OTk9PT1BQUFFRUVJSUlNTU1RUVFVVVVZWVldXV1hYWFlZWVpaWltbW1xcXF1dXV5eXl9fX2BgYGFhYWJiYmNjY2RkZGVlZWZmZmdnZ2hoaGlpaWpqamtra2xsbG1tbW5ubm9vb3BwcHFxcXJycnNzc3R0dHV1dXZ2dnd3d3h4eHl5eXp6ent7e3x8fH19fX5+fn9/f4CAgIGBgYKCgoODg4SEhIWFhYaGhoeHh4iIiImJiYqKiouLi4yMjI2NjY6Ojo+Pj5CQkJGRkZKSkpOTk5SUlJWVlZaWlpeXl5iYmJmZmZqampubm5ycnJ2dnZ6enp+fn6CgoKGhoaKioqOjo6SkpKWlpaampqenp6ioqKmpqaqqqqurq6ysrK2tra6urq+vr7CwsLGxsbKysrOzs7S0tLW1tba2tre3t7i4uLm5ubq6uru7u7y8vL29vb6+vr+/v8DAwMHBwcLCwsPDw8TExMXFxcbGxsfHx8jIyMnJycrKysvLy8zMzM3Nzc7Ozs/Pz9DQ0NHR0dLS0tPT09TU1NXV1dbW1tfX19jY2NnZ2dra2tvb29zc3N3d3d7e3t/f3+Dg4OHh4eLi4uPj4+Tk5OXl5ebm5ufn5+jo6Onp6erq6uvr6+zs7O3t7f///////////////////////////////////////////////////////////////////////yH5BAEKAP8ALAAAAADeAAkAAAiCALsJHEiwoMGDCBMqXMiwYLuHECNKbEixosWLGDMy/Mexo8ePIEOKHEmypMmPtySqfHjrpMuXMGPKnEmzps2bJFOuhNgSp8+fQIMKHUpT58qeRJMqXcq06UijEZE6nUq1qlWYUNtJvcq1q9epRrd+HUu27M2UYs2qXctWZNq2cF8GBAA7"},"SL+L":function(t,e,n){var i=n("qyb3");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("667d70da",i,!0,{})},SNj9:function(t,e,n){var i=n("UQ6c");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("bc7e42f8",i,!0,{})},SWGL:function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},Sjoy:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")},week:{dow:0,doy:4}})})(n("PJh5"))},SqRC:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero {\n  margin-bottom: 0px;\n}\n.marginBotRem {\n  margin-bottom: .5rem;\n}\n.spaceradio {\n  margin-right: 0px;\n}\n.newItem {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn {\n  opacity: 1 !important;\n}\n.fadeOut {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose:hover {\n  color: f2f2f2;\n}\n.accordion {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore {\n  margin-bottom: 16px;\n}\n.showMore {\n  color: red;\n}\n.showMore:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit 3s infinite;\n  animation: bit 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label {\n  font-weight: bold !important;\n}\n.fieldObli{\n  margin-top: -1px !important;\n}\n.BR-right{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none{\n  border-radius: 0px !important;\n}\n.BR-left{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero {\n  margin-bottom: 0px;\n}\n.marginBotRem {\n  margin-bottom: .5rem;\n}\n.spaceradio {\n  margin-right: 0px;\n}\n.newItem {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn {\n  opacity: 1 !important;\n}\n.fadeOut {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose:hover {\n  color: f2f2f2;\n}\n.accordion {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore {\n  margin-bottom: 16px;\n}\n.showMore {\n  color: red;\n}\n.showMore:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit 3s infinite;\n  animation: bit 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label {\n  font-weight: bold !important;\n}\n.fieldObli{\n  margin-top: -1px !important;\n}\n.BR-right{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none{\n  border-radius: 0px !important;\n}\n.BR-left{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},St71:function(t,e,n){var i=n("FKWp"),a=n("1yV6");t.exports=n("iANj").getIterator=function(t){var e=a(t);if("function"!=typeof e)throw TypeError(t+" is not iterable!");return i(e.call(t))}},Sx3H:function(t,e,n){var i=n("hEI0");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("76883225",i,!0,{})},T1ft:function(t,e,n){var i;"undefined"!=typeof self&&self,i=function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var a=e[i]={i:i,l:!1,exports:{}};return t[i].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var a in t)n.d(i,a,function(e){return t[e]}.bind(null,a));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="/",n(n.s=8)}([function(t,e,n){var i=n(4),a=n(5),o=n(6);t.exports=function(t){return i(t)||a(t)||o()}},function(t,e){function n(e){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?t.exports=n=function(t){return typeof t}:t.exports=n=function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},n(e)}t.exports=n},function(t,e,n){},function(t,e){t.exports=function(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},function(t,e){t.exports=function(t){if(Array.isArray(t)){for(var e=0,n=new Array(t.length);e<t.length;e++)n[e]=t[e];return n}}},function(t,e){t.exports=function(t){if(Symbol.iterator in Object(t)||"[object Arguments]"===Object.prototype.toString.call(t))return Array.from(t)}},function(t,e){t.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},function(t,e,n){"use strict";var i=n(2);n.n(i).a},function(t,e,n){"use strict";n.r(e);var i=n(0),a=n.n(i),o=n(1),r=n.n(o),s=n(3),l=n.n(s),d={props:{autoscroll:{type:Boolean,default:!0}},watch:{typeAheadPointer:function(){this.autoscroll&&this.maybeAdjustScroll()}},methods:{maybeAdjustScroll:function(){var t,e=(null===(t=this.$refs.dropdownMenu)||void 0===t?void 0:t.children[this.typeAheadPointer])||!1;if(e){var n=this.getDropdownViewport(),i=e.getBoundingClientRect(),a=i.top,o=i.bottom,r=i.height;if(a<n.top)return this.$refs.dropdownMenu.scrollTop=e.offsetTop;if(o>n.bottom)return this.$refs.dropdownMenu.scrollTop=e.offsetTop-(n.height-r)}},getDropdownViewport:function(){return this.$refs.dropdownMenu?this.$refs.dropdownMenu.getBoundingClientRect():{height:0,top:0,bottom:0}}}},c={data:function(){return{typeAheadPointer:-1}},watch:{filteredOptions:function(){for(var t=0;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}}},methods:{typeAheadUp:function(){for(var t=this.typeAheadPointer-1;t>=0;t--)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadDown:function(){for(var t=this.typeAheadPointer+1;t<this.filteredOptions.length;t++)if(this.selectable(this.filteredOptions[t])){this.typeAheadPointer=t;break}},typeAheadSelect:function(){var t=this.filteredOptions[this.typeAheadPointer];t&&this.select(t)}}},h={props:{loading:{type:Boolean,default:!1}},data:function(){return{mutableLoading:!1}},watch:{search:function(){this.$emit("search",this.search,this.toggleLoading)},loading:function(t){this.mutableLoading=t}},methods:{toggleLoading:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return this.mutableLoading=null==t?!this.mutableLoading:t}}};function u(t,e,n,i,a,o,r,s){var l,d="function"==typeof t?t.options:t;if(e&&(d.render=e,d.staticRenderFns=n,d._compiled=!0),i&&(d.functional=!0),o&&(d._scopeId="data-v-"+o),r?(l=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),a&&a.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(r)},d._ssrRegister=l):a&&(l=s?function(){a.call(this,this.$root.$options.shadowRoot)}:a),l)if(d.functional){d._injectStyles=l;var c=d.render;d.render=function(t,e){return l.call(e),c(t,e)}}else{var h=d.beforeCreate;d.beforeCreate=h?[].concat(h,l):[l]}return{exports:t,options:d}}var m={Deselect:u({},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"10",height:"10"}},[e("path",{attrs:{d:"M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"}})])},[],!1,null,null,null).exports,OpenIndicator:u({},function(){var t=this.$createElement,e=this._self._c||t;return e("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"14",height:"10"}},[e("path",{attrs:{d:"M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"}})])},[],!1,null,null,null).exports},f={inserted:function(t,e,n){var i=n.context;if(i.appendToBody){var a=i.$refs.toggle.getBoundingClientRect(),o=a.height,r=a.top,s=a.left,l=a.width,d=window.scrollX||window.pageXOffset,c=window.scrollY||window.pageYOffset;t.unbindPosition=i.calculatePosition(t,i,{width:l+"px",left:d+s+"px",top:c+r+o+"px"}),document.body.appendChild(t)}},unbind:function(t,e,n){n.context.appendToBody&&(t.unbindPosition&&"function"==typeof t.unbindPosition&&t.unbindPosition(),t.parentNode&&t.parentNode.removeChild(t))}},p=0;function _(t,e){var n=Object.keys(t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(t);e&&(i=i.filter(function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable})),n.push.apply(n,i)}return n}function A(t){for(var e=1;e<arguments.length;e++){var n=null!=arguments[e]?arguments[e]:{};e%2?_(Object(n),!0).forEach(function(e){l()(t,e,n[e])}):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(n)):_(Object(n)).forEach(function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(n,e))})}return t}var b={components:A({},m),directives:{appendToBody:f},mixins:[d,c,h],props:{value:{},components:{type:Object,default:function(){return{}}},options:{type:Array,default:function(){return[]}},disabled:{type:Boolean,default:!1},clearable:{type:Boolean,default:!0},searchable:{type:Boolean,default:!0},multiple:{type:Boolean,default:!1},placeholder:{type:String,default:""},transition:{type:String,default:"vs__fade"},clearSearchOnSelect:{type:Boolean,default:!0},closeOnSelect:{type:Boolean,default:!0},label:{type:String,default:"label"},autocomplete:{type:String,default:"off"},reduce:{type:Function,default:function(t){return t}},selectable:{type:Function,default:function(t){return!0}},getOptionLabel:{type:Function,default:function(t){return"object"===r()(t)?t.hasOwnProperty(this.label)?t[this.label]:console.warn('[vue-select warn]: Label key "option.'.concat(this.label,'" does not')+" exist in options object ".concat(JSON.stringify(t),".\n")+"https://vue-select.org/api/props.html#getoptionlabel"):t}},getOptionKey:{type:Function,default:function(t){if("object"!==r()(t))return t;try{return t.hasOwnProperty("id")?t.id:function(t){var e={};return Object.keys(t).sort().forEach(function(n){e[n]=t[n]}),JSON.stringify(e)}(t)}catch(e){return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey",t,e)}}},onTab:{type:Function,default:function(){this.selectOnTab&&!this.isComposing&&this.typeAheadSelect()}},taggable:{type:Boolean,default:!1},tabindex:{type:Number,default:null},pushTags:{type:Boolean,default:!1},filterable:{type:Boolean,default:!0},filterBy:{type:Function,default:function(t,e,n){return(e||"").toLowerCase().indexOf(n.toLowerCase())>-1}},filter:{type:Function,default:function(t,e){var n=this;return t.filter(function(t){var i=n.getOptionLabel(t);return"number"==typeof i&&(i=i.toString()),n.filterBy(t,i,e)})}},createOption:{type:Function,default:function(t){return"object"===r()(this.optionList[0])?l()({},this.label,t):t}},resetOnOptionsChange:{default:!1,validator:function(t){return["function","boolean"].includes(r()(t))}},clearSearchOnBlur:{type:Function,default:function(t){var e=t.clearSearchOnSelect,n=t.multiple;return e&&!n}},noDrop:{type:Boolean,default:!1},inputId:{type:String},dir:{type:String,default:"auto"},selectOnTab:{type:Boolean,default:!1},selectOnKeyCodes:{type:Array,default:function(){return[13]}},searchInputQuerySelector:{type:String,default:"[type=search]"},mapKeydown:{type:Function,default:function(t,e){return t}},appendToBody:{type:Boolean,default:!1},calculatePosition:{type:Function,default:function(t,e,n){var i=n.width,a=n.top,o=n.left;t.style.top=a,t.style.left=o,t.style.width=i}},dropdownShouldOpen:{type:Function,default:function(t){var e=t.noDrop,n=t.open,i=t.mutableLoading;return!e&&n&&!i}}},data:function(){return{uid:++p,search:"",open:!1,isComposing:!1,pushedTags:[],_value:[]}},computed:{isTrackingValues:function(){return void 0===this.value||this.$options.propsData.hasOwnProperty("reduce")},selectedValue:function(){var t=this.value;return this.isTrackingValues&&(t=this.$data._value),t?[].concat(t):[]},optionList:function(){return this.options.concat(this.pushTags?this.pushedTags:[])},searchEl:function(){return this.$scopedSlots.search?this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector):this.$refs.search},scope:function(){var t=this,e={search:this.search,loading:this.loading,searching:this.searching,filteredOptions:this.filteredOptions};return{search:{attributes:A({disabled:this.disabled,placeholder:this.searchPlaceholder,tabindex:this.tabindex,readonly:!this.searchable,id:this.inputId,"aria-autocomplete":"list","aria-labelledby":"vs".concat(this.uid,"__combobox"),"aria-controls":"vs".concat(this.uid,"__listbox"),ref:"search",type:"search",autocomplete:this.autocomplete,value:this.search},this.dropdownOpen&&this.filteredOptions[this.typeAheadPointer]?{"aria-activedescendant":"vs".concat(this.uid,"__option-").concat(this.typeAheadPointer)}:{}),events:{compositionstart:function(){return t.isComposing=!0},compositionend:function(){return t.isComposing=!1},keydown:this.onSearchKeyDown,blur:this.onSearchBlur,focus:this.onSearchFocus,input:function(e){return t.search=e.target.value}}},spinner:{loading:this.mutableLoading},noOptions:{search:this.search,loading:this.mutableLoading,searching:this.searching},openIndicator:{attributes:{ref:"openIndicator",role:"presentation",class:"vs__open-indicator"}},listHeader:e,listFooter:e,header:A({},e,{deselect:this.deselect}),footer:A({},e,{deselect:this.deselect})}},childComponents:function(){return A({},m,{},this.components)},stateClasses:function(){return{"vs--open":this.dropdownOpen,"vs--single":!this.multiple,"vs--multiple":this.multiple,"vs--searching":this.searching&&!this.noDrop,"vs--searchable":this.searchable&&!this.noDrop,"vs--unsearchable":!this.searchable,"vs--loading":this.mutableLoading,"vs--disabled":this.disabled}},searching:function(){return!!this.search},dropdownOpen:function(){return this.dropdownShouldOpen(this)},searchPlaceholder:function(){return this.isValueEmpty&&this.placeholder?this.placeholder:void 0},filteredOptions:function(){var t=[].concat(this.optionList);if(!this.filterable&&!this.taggable)return t;var e=this.search.length?this.filter(t,this.search,this):t;if(this.taggable&&this.search.length){var n=this.createOption(this.search);this.optionExists(n)||e.unshift(n)}return e},isValueEmpty:function(){return 0===this.selectedValue.length},showClearButton:function(){return!this.multiple&&this.clearable&&!this.open&&!this.isValueEmpty}},watch:{options:function(t,e){var n=this;!this.taggable&&("function"==typeof n.resetOnOptionsChange?n.resetOnOptionsChange(t,e,n.selectedValue):n.resetOnOptionsChange)&&this.clearSelection(),this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value)},value:function(t){this.isTrackingValues&&this.setInternalValueFromOptions(t)},multiple:function(){this.clearSelection()},open:function(t){this.$emit(t?"open":"close")}},created:function(){this.mutableLoading=this.loading,void 0!==this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value),this.$on("option:created",this.pushTag)},methods:{setInternalValueFromOptions:function(t){var e=this;Array.isArray(t)?this.$data._value=t.map(function(t){return e.findOptionFromReducedValue(t)}):this.$data._value=this.findOptionFromReducedValue(t)},select:function(t){this.$emit("option:selecting",t),this.isOptionSelected(t)||(this.taggable&&!this.optionExists(t)&&this.$emit("option:created",t),this.multiple&&(t=this.selectedValue.concat(t)),this.updateValue(t),this.$emit("option:selected",t)),this.onAfterSelect(t)},deselect:function(t){var e=this;this.$emit("option:deselecting",t),this.updateValue(this.selectedValue.filter(function(n){return!e.optionComparator(n,t)})),this.$emit("option:deselected",t)},clearSelection:function(){this.updateValue(this.multiple?[]:null)},onAfterSelect:function(t){this.closeOnSelect&&(this.open=!this.open,this.searchEl.blur()),this.clearSearchOnSelect&&(this.search="")},updateValue:function(t){var e=this;void 0===this.value&&(this.$data._value=t),null!==t&&(t=Array.isArray(t)?t.map(function(t){return e.reduce(t)}):this.reduce(t)),this.$emit("input",t)},toggleDropdown:function(t){var e=t.target!==this.searchEl;e&&t.preventDefault();var n=[].concat(a()(this.$refs.deselectButtons||[]),a()([this.$refs.clearButton]||!1));void 0===this.searchEl||n.filter(Boolean).some(function(e){return e.contains(t.target)||e===t.target})?t.preventDefault():this.open&&e?this.searchEl.blur():this.disabled||(this.open=!0,this.searchEl.focus())},isOptionSelected:function(t){var e=this;return this.selectedValue.some(function(n){return e.optionComparator(n,t)})},optionComparator:function(t,e){return this.getOptionKey(t)===this.getOptionKey(e)},findOptionFromReducedValue:function(t){var e=this,n=[].concat(a()(this.options),a()(this.pushedTags)).filter(function(n){return JSON.stringify(e.reduce(n))===JSON.stringify(t)});return 1===n.length?n[0]:n.find(function(t){return e.optionComparator(t,e.$data._value)})||t},closeSearchOptions:function(){this.open=!1,this.$emit("search:blur")},maybeDeleteValue:function(){if(!this.searchEl.value.length&&this.selectedValue&&this.selectedValue.length&&this.clearable){var t=null;this.multiple&&(t=a()(this.selectedValue.slice(0,this.selectedValue.length-1))),this.updateValue(t)}},optionExists:function(t){var e=this;return this.optionList.some(function(n){return e.optionComparator(n,t)})},normalizeOptionForSlot:function(t){return"object"===r()(t)?t:l()({},this.label,t)},pushTag:function(t){this.pushedTags.push(t)},onEscape:function(){this.search.length?this.search="":this.searchEl.blur()},onSearchBlur:function(){if(!this.mousedown||this.searching){var t=this.clearSearchOnSelect,e=this.multiple;return this.clearSearchOnBlur({clearSearchOnSelect:t,multiple:e})&&(this.search=""),void this.closeSearchOptions()}this.mousedown=!1,0!==this.search.length||0!==this.options.length||this.closeSearchOptions()},onSearchFocus:function(){this.open=!0,this.$emit("search:focus")},onMousedown:function(){this.mousedown=!0},onMouseUp:function(){this.mousedown=!1},onSearchKeyDown:function(t){var e=this,n=function(t){return t.preventDefault(),!e.isComposing&&e.typeAheadSelect()},i={8:function(t){return e.maybeDeleteValue()},9:function(t){return e.onTab()},27:function(t){return e.onEscape()},38:function(t){return t.preventDefault(),e.typeAheadUp()},40:function(t){return t.preventDefault(),e.typeAheadDown()}};this.selectOnKeyCodes.forEach(function(t){return i[t]=n});var a=this.mapKeydown(i,this);if("function"==typeof a[t.keyCode])return a[t.keyCode](t)}}},x=(n(7),u(b,function(){var t=this,e=t.$createElement,n=t._self._c||e;return n("div",{staticClass:"v-select",class:t.stateClasses,attrs:{dir:t.dir}},[t._t("header",null,null,t.scope.header),t._v(" "),n("div",{ref:"toggle",staticClass:"vs__dropdown-toggle",attrs:{id:"vs"+t.uid+"__combobox",role:"combobox","aria-expanded":t.dropdownOpen.toString(),"aria-owns":"vs"+t.uid+"__listbox","aria-label":"Search for option"},on:{mousedown:function(e){return t.toggleDropdown(e)}}},[n("div",{ref:"selectedOptions",staticClass:"vs__selected-options"},[t._l(t.selectedValue,function(e){return t._t("selected-option-container",[n("span",{key:t.getOptionKey(e),staticClass:"vs__selected"},[t._t("selected-option",[t._v("\n            "+t._s(t.getOptionLabel(e))+"\n          ")],null,t.normalizeOptionForSlot(e)),t._v(" "),t.multiple?n("button",{ref:"deselectButtons",refInFor:!0,staticClass:"vs__deselect",attrs:{disabled:t.disabled,type:"button",title:"Deselect "+t.getOptionLabel(e),"aria-label":"Deselect "+t.getOptionLabel(e)},on:{click:function(n){return t.deselect(e)}}},[n(t.childComponents.Deselect,{tag:"component"})],1):t._e()],2)],{option:t.normalizeOptionForSlot(e),deselect:t.deselect,multiple:t.multiple,disabled:t.disabled})}),t._v(" "),t._t("search",[n("input",t._g(t._b({staticClass:"vs__search"},"input",t.scope.search.attributes,!1),t.scope.search.events))],null,t.scope.search)],2),t._v(" "),n("div",{ref:"actions",staticClass:"vs__actions"},[n("button",{directives:[{name:"show",rawName:"v-show",value:t.showClearButton,expression:"showClearButton"}],ref:"clearButton",staticClass:"vs__clear",attrs:{disabled:t.disabled,type:"button",title:"Clear Selected","aria-label":"Clear Selected"},on:{click:t.clearSelection}},[n(t.childComponents.Deselect,{tag:"component"})],1),t._v(" "),t._t("open-indicator",[t.noDrop?t._e():n(t.childComponents.OpenIndicator,t._b({tag:"component"},"component",t.scope.openIndicator.attributes,!1))],null,t.scope.openIndicator),t._v(" "),t._t("spinner",[n("div",{directives:[{name:"show",rawName:"v-show",value:t.mutableLoading,expression:"mutableLoading"}],staticClass:"vs__spinner"},[t._v("Loading...")])],null,t.scope.spinner)],2)]),t._v(" "),n("transition",{attrs:{name:t.transition}},[t.dropdownOpen?n("ul",{directives:[{name:"append-to-body",rawName:"v-append-to-body"}],key:"vs"+t.uid+"__listbox",ref:"dropdownMenu",staticClass:"vs__dropdown-menu",attrs:{id:"vs"+t.uid+"__listbox",role:"listbox",tabindex:"-1"},on:{mousedown:function(e){return e.preventDefault(),t.onMousedown(e)},mouseup:t.onMouseUp}},[t._t("list-header",null,null,t.scope.listHeader),t._v(" "),t._l(t.filteredOptions,function(e,i){return n("li",{key:t.getOptionKey(e),staticClass:"vs__dropdown-option",class:{"vs__dropdown-option--selected":t.isOptionSelected(e),"vs__dropdown-option--highlight":i===t.typeAheadPointer,"vs__dropdown-option--disabled":!t.selectable(e)},attrs:{id:"vs"+t.uid+"__option-"+i,role:"option","aria-selected":i===t.typeAheadPointer||null},on:{mouseover:function(n){t.selectable(e)&&(t.typeAheadPointer=i)},click:function(n){n.preventDefault(),n.stopPropagation(),t.selectable(e)&&t.select(e)}}},[t._t("option",[t._v("\n          "+t._s(t.getOptionLabel(e))+"\n        ")],null,t.normalizeOptionForSlot(e))],2)}),t._v(" "),0===t.filteredOptions.length?n("li",{staticClass:"vs__no-options"},[t._t("no-options",[t._v("Sorry, no matching options.")],null,t.scope.noOptions)],2):t._e(),t._v(" "),t._t("list-footer",null,null,t.scope.listFooter)],2):n("ul",{staticStyle:{display:"none",visibility:"hidden"},attrs:{id:"vs"+t.uid+"__listbox",role:"listbox"}})]),t._v(" "),t._t("footer",null,null,t.scope.footer)],2)},[],!1,null,null,null).exports),g={ajax:h,pointer:c,pointerScroll:d};n.d(e,"VueSelect",function(){return x}),n.d(e,"mixins",function(){return g}),e.default=x}])},t.exports=i()},TDz6:function(t,e,n){var i=n("JSOS");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("1e40fc57",i,!0,{})},THEY:function(t,e){e.f=Object.getOwnPropertySymbols},THgE:function(t,e,n){var i=n("S4wQ");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("f50abe22",i,!0,{})},TNV1:function(t,e,n){"use strict";var i=n("cGG2");t.exports=function(t,e,n){return i.forEach(n,function(n){t=n(t,e)}),t}},TO4G:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.myBtn[data-v-89397048] {\n  width: 65px;\n}\n.btnbrowseC[data-v-89397048] {\n  margin-top: .8rem !important;\n  margin-bottom: .45rem !important;\n}\n.btnUploadAll[data-v-89397048] {\n  margin-top: 5px;\n  margin-bottom: 9px;\n}\n.iconCloseCheck[data-v-89397048] {\n  position: absolute;\n  right: 5px;\n  color: red;\n  top: 0px;\n  cursor: pointer;\n}\n.hrChecklist[data-v-89397048] {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n.hrCheckPopUp[data-v-89397048] {\n  margin-top: 13px;\n  margin-bottom: 7px;\n  background-color: grey;\n  height: 2px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n.containerFileDrag[data-v-89397048] {\n  margin-top: -12px;\n}\n.containerFileList[data-v-89397048] {\n  margin-top: .7rem !important;\n  margin-bottom: .6rem !important;\n}\nform.dropFilesHere[data-v-89397048] {\n  cursor: pointer;\n  background: #e7e7e7;\n  text-align: center;\n  line-height: 60px;\n  border-radius: 5px;\n}\ndiv.file-listing[data-v-89397048] {\n  -webkit-box-shadow: 3px 3px 5px -3px rgba(0, 0, 0, 0.75);\n  box-shadow: 3px 3px 5px -3px rgba(0, 0, 0, 0.75);\n  margin: auto;\n  padding: 10px;\n  border: 2px solid rgba(0, 0, 0, 0.32);\n  background-color: #c5c5c514;\n}\ndiv.file-listing img[data-v-89397048] {\n  height: 100px;\n}\ndiv.remove-container[data-v-89397048] {\n  text-align: center;\n}\na.submit-button[data-v-89397048] {\n  display: block;\n  margin: auto;\n  text-align: center;\n  width: 200px;\n  padding: 10px;\n  text-transform: uppercase;\n  background-color: #CCC;\n  color: white;\n  font-weight: bold;\n  margin-top: 20px;\n}\nprogress[data-v-89397048] {\n  width: 95%;\n  margin: auto;\n  display: block;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  height: 3px;\n  position: absolute;\n  bottom: -20px;\n}\n#progressAll[data-v-89397048] {\n  width: 100%;\n}\n.textNameCheckList[data-v-89397048] {\n  margin-top: -1px;\n}\n.textSize[data-v-89397048] {\n  margin-top: -4px;\n}\n@media (max-width: 767px) {\n.spaceBotton[data-v-89397048] {\n    margin-bottom: .25rem !important;\n}\n}\n@media (max-width: 382px) {\n.spaceBottonSendEntire[data-v-89397048] {\n    margin-bottom: .25rem !important;\n}\n}\n@media (max-width: 272px) {\n.spaceBottonImport[data-v-89397048] {\n    margin-bottom: .25rem !important;\n}\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfChecklist/PfChecklist.css"],names:[],mappings:";AACA;EACE,YAAY;CACb;AACD;EACE,6BAA6B;EAC7B,iCAAiC;CAClC;AACD;EACE,gBAAgB;EAChB,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,SAAS;EACT,gBAAgB;CACjB;AACD;EACE,8BAA8B;EAC9B,iCAAiC;CAClC;AACD;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,6BAA6B;EAC7B,gCAAgC;CACjC;AACD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,yDAAyD;EACzD,iDAAiD;EACjD,aAAa;EACb,cAAc;EACd,sCAAsC;EACtC,4BAA4B;CAC7B;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;CACpB;AACD;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,cAAc;CACf;AACD;EACE,YAAY;CACb;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;AACA;IACI,iCAAiC;CACpC;CACA;AACD;AACA;IACI,iCAAiC;CACpC;CACA;AACD;AACA;IACI,iCAAiC;CACpC;CACA",file:"PfChecklist.css",sourcesContent:["\n.myBtn[data-v-89397048] {\n  width: 65px;\n}\n.btnbrowseC[data-v-89397048] {\n  margin-top: .8rem !important;\n  margin-bottom: .45rem !important;\n}\n.btnUploadAll[data-v-89397048] {\n  margin-top: 5px;\n  margin-bottom: 9px;\n}\n.iconCloseCheck[data-v-89397048] {\n  position: absolute;\n  right: 5px;\n  color: red;\n  top: 0px;\n  cursor: pointer;\n}\n.hrChecklist[data-v-89397048] {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n.hrCheckPopUp[data-v-89397048] {\n  margin-top: 13px;\n  margin-bottom: 7px;\n  background-color: grey;\n  height: 2px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n.containerFileDrag[data-v-89397048] {\n  margin-top: -12px;\n}\n.containerFileList[data-v-89397048] {\n  margin-top: .7rem !important;\n  margin-bottom: .6rem !important;\n}\nform.dropFilesHere[data-v-89397048] {\n  cursor: pointer;\n  background: #e7e7e7;\n  text-align: center;\n  line-height: 60px;\n  border-radius: 5px;\n}\ndiv.file-listing[data-v-89397048] {\n  -webkit-box-shadow: 3px 3px 5px -3px rgba(0, 0, 0, 0.75);\n  box-shadow: 3px 3px 5px -3px rgba(0, 0, 0, 0.75);\n  margin: auto;\n  padding: 10px;\n  border: 2px solid rgba(0, 0, 0, 0.32);\n  background-color: #c5c5c514;\n}\ndiv.file-listing img[data-v-89397048] {\n  height: 100px;\n}\ndiv.remove-container[data-v-89397048] {\n  text-align: center;\n}\na.submit-button[data-v-89397048] {\n  display: block;\n  margin: auto;\n  text-align: center;\n  width: 200px;\n  padding: 10px;\n  text-transform: uppercase;\n  background-color: #CCC;\n  color: white;\n  font-weight: bold;\n  margin-top: 20px;\n}\nprogress[data-v-89397048] {\n  width: 95%;\n  margin: auto;\n  display: block;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  height: 3px;\n  position: absolute;\n  bottom: -20px;\n}\n#progressAll[data-v-89397048] {\n  width: 100%;\n}\n.textNameCheckList[data-v-89397048] {\n  margin-top: -1px;\n}\n.textSize[data-v-89397048] {\n  margin-top: -4px;\n}\n@media (max-width: 767px) {\n.spaceBotton[data-v-89397048] {\n    margin-bottom: .25rem !important;\n}\n}\n@media (max-width: 382px) {\n.spaceBottonSendEntire[data-v-89397048] {\n    margin-bottom: .25rem !important;\n}\n}\n@media (max-width: 272px) {\n.spaceBottonImport[data-v-89397048] {\n    margin-bottom: .25rem !important;\n}\n}\n"],sourceRoot:""}])},TaS5:function(t,e,n){var i=n("IjKY");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("74b036f0",i,!0,{})},Tbn5:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.master[data-v-72d60aab] {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n.radio-inline[data-v-72d60aab] {\n  margin-top: 0;\n  margin-left: 0px !important;\n}\n.row[data-v-72d60aab] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.spaceradio[data-v-72d60aab] {\n  margin-right: 4px;\n}\n.radioabso[data-v-72d60aab] {\n  position: absolute;\n}\n.left-radio[data-v-72d60aab] {\n  padding-left: 30px;\n  line-height: 1.5;\n  margin-top: -6px;\n  padding-bottom: 10px;\n}\n.objecyesabso[data-v-72d60aab] {\n  position: absolute;\n  right: 15px;\n}\n.objecyesabso2[data-v-72d60aab] {\n  position: absolute;\n}\n.objecyesno[data-v-72d60aab] {\n  padding-right: 135px;\n}\n.objecyesno2[data-v-72d60aab] {\n  padding-left: 125px;\n  padding-right: 15px;\n}\np[data-v-72d60aab], label[data-v-72d60aab] {\n  text-align: justify;\n}\n.myindent[data-v-72d60aab] {\n  padding-left: 30px;\n  margin-bottom: 10px;\n}\n.indent-level1[data-v-72d60aab] {\n  padding-left: 5%;\n}\n.indent-level2[data-v-72d60aab] {\n  padding-left: 10%;\n}\n.indent-level3[data-v-72d60aab] {\n  padding-left: 15%;\n}\n.inputquestion[data-v-72d60aab] {\n  margin-top: -55px;\n  padding-left: 151px;\n}\ndiv.v-select > ul.vs__dropdown-menu[data-v-72d60aab] {\n  z-index: 202 !important;\n}\n.flashitInput[data-v-72d60aab] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-72d60aab] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfQuestionnaireForm/PfQuestionnaireForm.css"],names:[],mappings:";AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,aAAa;CACd;AACD;EACE,cAAc;EACd,4BAA4B;CAC7B;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;CACtB;AACD;EACE,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,oBAAoB;EACpB,oBAAoB;CACrB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,kBAAkB;EAClB,oBAAoB;CACrB;AACD;EACE,wBAAwB;CACzB;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B",file:"PfQuestionnaireForm.css",sourcesContent:["\n.master[data-v-72d60aab] {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n.radio-inline[data-v-72d60aab] {\n  margin-top: 0;\n  margin-left: 0px !important;\n}\n.row[data-v-72d60aab] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.spaceradio[data-v-72d60aab] {\n  margin-right: 4px;\n}\n.radioabso[data-v-72d60aab] {\n  position: absolute;\n}\n.left-radio[data-v-72d60aab] {\n  padding-left: 30px;\n  line-height: 1.5;\n  margin-top: -6px;\n  padding-bottom: 10px;\n}\n.objecyesabso[data-v-72d60aab] {\n  position: absolute;\n  right: 15px;\n}\n.objecyesabso2[data-v-72d60aab] {\n  position: absolute;\n}\n.objecyesno[data-v-72d60aab] {\n  padding-right: 135px;\n}\n.objecyesno2[data-v-72d60aab] {\n  padding-left: 125px;\n  padding-right: 15px;\n}\np[data-v-72d60aab], label[data-v-72d60aab] {\n  text-align: justify;\n}\n.myindent[data-v-72d60aab] {\n  padding-left: 30px;\n  margin-bottom: 10px;\n}\n.indent-level1[data-v-72d60aab] {\n  padding-left: 5%;\n}\n.indent-level2[data-v-72d60aab] {\n  padding-left: 10%;\n}\n.indent-level3[data-v-72d60aab] {\n  padding-left: 15%;\n}\n.inputquestion[data-v-72d60aab] {\n  margin-top: -55px;\n  padding-left: 151px;\n}\ndiv.v-select > ul.vs__dropdown-menu[data-v-72d60aab] {\n  z-index: 202 !important;\n}\n.flashitInput[data-v-72d60aab] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-72d60aab] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n"],sourceRoot:""}])},To0v:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ug-cn",{months:"يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),monthsShort:"يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split("_"),weekdays:"يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە".split("_"),weekdaysShort:"يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),weekdaysMin:"يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY-يىلىM-ئاينىڭD-كۈنى",LLL:"YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm",LLLL:"dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm"},meridiemParse:/يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,meridiemHour:function(t,e){return 12===t&&(t=0),"يېرىم كېچە"===e||"سەھەر"===e||"چۈشتىن بۇرۇن"===e?t:"چۈشتىن كېيىن"===e||"كەچ"===e?t+12:t>=11?t:t+12},meridiem:function(t,e,n){var i=100*t+e;return i<600?"يېرىم كېچە":i<900?"سەھەر":i<1130?"چۈشتىن بۇرۇن":i<1230?"چۈش":i<1800?"چۈشتىن كېيىن":"كەچ"},calendar:{sameDay:"[بۈگۈن سائەت] LT",nextDay:"[ئەتە سائەت] LT",nextWeek:"[كېلەركى] dddd [سائەت] LT",lastDay:"[تۆنۈگۈن] LT",lastWeek:"[ئالدىنقى] dddd [سائەت] LT",sameElse:"L"},relativeTime:{future:"%s كېيىن",past:"%s بۇرۇن",s:"نەچچە سېكونت",ss:"%d سېكونت",m:"بىر مىنۇت",mm:"%d مىنۇت",h:"بىر سائەت",hh:"%d سائەت",d:"بىر كۈن",dd:"%d كۈن",M:"بىر ئاي",MM:"%d ئاي",y:"بىر يىل",yy:"%d يىل"},dayOfMonthOrdinalParse:/\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,ordinal:function(t,e){switch(e){case"d":case"D":case"DDD":return t+"-كۈنى";case"w":case"W":return t+"-ھەپتە";default:return t}},preparse:function(t){return t.replace(/،/g,",")},postformat:function(t){return t.replace(/,/g,"،")},week:{dow:1,doy:7}})})(n("PJh5"))},Tqun:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")}})})(n("PJh5"))},"U1k/":function(t,e,n){var i=n("cEvV");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("3190f208",i,!0,{})},U5Iz:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ga",{months:["Eanáir","Feabhra","Márta","Aibreán","Bealtaine","Meitheamh","Iúil","Lúnasa","Meán Fómhair","Deireadh Fómhair","Samhain","Nollaig"],monthsShort:["Ean","Feabh","Márt","Aib","Beal","Meith","Iúil","Lún","M.F.","D.F.","Samh","Noll"],monthsParseExact:!0,weekdays:["Dé Domhnaigh","Dé Luain","Dé Máirt","Dé Céadaoin","Déardaoin","Dé hAoine","Dé Sathairn"],weekdaysShort:["Domh","Luan","Máirt","Céad","Déar","Aoine","Sath"],weekdaysMin:["Do","Lu","Má","Cé","Dé","A","Sa"],longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Inniu ag] LT",nextDay:"[Amárach ag] LT",nextWeek:"dddd [ag] LT",lastDay:"[Inné ag] LT",lastWeek:"dddd [seo caite] [ag] LT",sameElse:"L"},relativeTime:{future:"i %s",past:"%s ó shin",s:"cúpla soicind",ss:"%d soicind",m:"nóiméad",mm:"%d nóiméad",h:"uair an chloig",hh:"%d uair an chloig",d:"lá",dd:"%d lá",M:"mí",MM:"%d míonna",y:"bliain",yy:"%d bliain"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(t){return t+(1===t?"d":t%10==2?"na":"mh")},week:{dow:1,doy:4}})})(n("PJh5"))},UCqt:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero {\n  margin-bottom: 0px;\n}\n.marginBotRem {\n  margin-bottom: .5rem;\n}\n.spaceradio {\n  margin-right: 0px;\n}\n.newItem {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn {\n  opacity: 1 !important;\n}\n.fadeOut {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose:hover {\n  color: f2f2f2;\n}\n.accordion {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore {\n  margin-bottom: 16px;\n}\n.showMore {\n  color: red;\n}\n.showMore:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit 3s infinite;\n  animation: bit 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label {\n  font-weight: bold !important;\n}\n.fieldObli{\n  margin-top: -1px !important;\n}\n.BR-right{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none{\n  border-radius: 0px !important;\n}\n.BR-left{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero {\n  margin-bottom: 0px;\n}\n.marginBotRem {\n  margin-bottom: .5rem;\n}\n.spaceradio {\n  margin-right: 0px;\n}\n.newItem {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn {\n  opacity: 1 !important;\n}\n.fadeOut {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose:hover {\n  color: f2f2f2;\n}\n.accordion {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore {\n  margin-bottom: 16px;\n}\n.showMore {\n  color: red;\n}\n.showMore:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit 3s infinite;\n  animation: bit 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label {\n  font-weight: bold !important;\n}\n.fieldObli{\n  margin-top: -1px !important;\n}\n.BR-right{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none{\n  border-radius: 0px !important;\n}\n.BR-left{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},UQ6c:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfFamilyMembers.css",sourceRoot:""}])},USNP:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),i=[/^ene/i,/^feb/i,/^mar/i,/^abr/i,/^may/i,/^jun/i,/^jul/i,/^ago/i,/^sep/i,/^oct/i,/^nov/i,/^dic/i],a=/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;t.defineLocale("es-mx",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(t,i){return t?/-MMM-/.test(i)?n[t.month()]:e[t.month()]:e},monthsRegex:a,monthsShortRegex:a,monthsStrictRegex:/^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,monthsShortStrictRegex:/^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,monthsParse:i,longMonthsParse:i,shortMonthsParse:i,weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",ss:"%d segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",w:"una semana",ww:"%d semanas",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:0,doy:4},invalidDate:"Fecha inválida"})})(n("PJh5"))},UTtd:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-795ea1dc] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-795ea1dc]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-795ea1dc] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-795ea1dc] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-795ea1dc] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-795ea1dc] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-795ea1dc] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-795ea1dc] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-795ea1dc] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-795ea1dc] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-795ea1dc] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-795ea1dc] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-795ea1dc] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-795ea1dc] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-795ea1dc] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-795ea1dc] {\n  margin-right: 0px;\n}\n.newItem[data-v-795ea1dc] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-795ea1dc] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-795ea1dc] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-795ea1dc] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-795ea1dc] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-795ea1dc] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-795ea1dc] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-795ea1dc] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-795ea1dc] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-795ea1dc] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-795ea1dc]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-795ea1dc] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-795ea1dc] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-795ea1dc] {\n  color: red;\n}\n.showMore[data-v-795ea1dc]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-795ea1dc] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-795ea1dc] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-795ea1dc] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-795ea1dc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-795ea1dc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-795ea1dc] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-795ea1dc 3s infinite;\n  animation: bit-data-v-795ea1dc 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-795ea1dc] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-795ea1dc]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-795ea1dc]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-795ea1dc]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-795ea1dc]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-795ea1dc]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-795ea1dc]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-795ea1dc] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-795ea1dc]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-795ea1dc] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-795ea1dc] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-795ea1dc] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-795ea1dc] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-795ea1dc] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-795ea1dc] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-795ea1dc] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-795ea1dc] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-795ea1dc] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-795ea1dc] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-795ea1dc] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-795ea1dc] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-795ea1dc] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-795ea1dc] {\n  margin-right: 0px;\n}\n.newItem[data-v-795ea1dc] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-795ea1dc] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-795ea1dc] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-795ea1dc] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-795ea1dc] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-795ea1dc] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-795ea1dc] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-795ea1dc] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-795ea1dc] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-795ea1dc] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-795ea1dc]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-795ea1dc] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-795ea1dc] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-795ea1dc] {\n  color: red;\n}\n.showMore[data-v-795ea1dc]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-795ea1dc] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-795ea1dc] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-795ea1dc] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-795ea1dc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-795ea1dc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-795ea1dc] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-795ea1dc 3s infinite;\n  animation: bit-data-v-795ea1dc 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-795ea1dc] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-795ea1dc]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-795ea1dc]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-795ea1dc]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-795ea1dc]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-795ea1dc]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-795ea1dc]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},Us3w:function(t,e,n){var i=n("5Fck");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("3eeb28c6",i,!0,{})},UyrU:function(t,e,n){var i=n("l7Gz");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("16d1cbac",i,!0,{})},V0td:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("sq",{months:"Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split("_"),monthsShort:"Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),weekdays:"E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split("_"),weekdaysShort:"Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),weekdaysMin:"D_H_Ma_Më_E_P_Sh".split("_"),weekdaysParseExact:!0,meridiemParse:/PD|MD/,isPM:function(t){return"M"===t.charAt(0)},meridiem:function(t,e,n){return t<12?"PD":"MD"},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Sot në] LT",nextDay:"[Nesër në] LT",nextWeek:"dddd [në] LT",lastDay:"[Dje në] LT",lastWeek:"dddd [e kaluar në] LT",sameElse:"L"},relativeTime:{future:"në %s",past:"%s më parë",s:"disa sekonda",ss:"%d sekonda",m:"një minutë",mm:"%d minuta",h:"një orë",hh:"%d orë",d:"një ditë",dd:"%d ditë",M:"një muaj",MM:"%d muaj",y:"një vit",yy:"%d vite"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},V4qH:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n){var i=t+" ";switch(n){case"ss":return i+=1===t?"sekunda":2===t||3===t||4===t?"sekunde":"sekundi";case"m":return e?"jedna minuta":"jedne minute";case"mm":return i+=1===t?"minuta":2===t||3===t||4===t?"minute":"minuta";case"h":return e?"jedan sat":"jednog sata";case"hh":return i+=1===t?"sat":2===t||3===t||4===t?"sata":"sati";case"dd":return i+=1===t?"dan":"dana";case"MM":return i+=1===t?"mjesec":2===t||3===t||4===t?"mjeseca":"mjeseci";case"yy":return i+=1===t?"godina":2===t||3===t||4===t?"godine":"godina"}}t.defineLocale("hr",{months:{format:"siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split("_"),standalone:"siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_")},monthsShort:"sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"Do MMMM YYYY",LLL:"Do MMMM YYYY H:mm",LLLL:"dddd, Do MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:return"[prošlu] [nedjelju] [u] LT";case 3:return"[prošlu] [srijedu] [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:e,m:e,mm:e,h:e,hh:e,d:"dan",dd:e,M:"mjesec",MM:e,y:"godinu",yy:e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})(n("PJh5"))},VD8v:function(t,e,n){var i=n("x//u"),a=n("wXdB"),o=n("+SdG")("IE_PROTO"),r=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=a(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?r:null}},VFNX:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfPhones.css",sourceRoot:""}])},VGQH:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){var a={s:["थोडया सॅकंडांनी","थोडे सॅकंड"],ss:[t+" सॅकंडांनी",t+" सॅकंड"],m:["एका मिणटान","एक मिनूट"],mm:[t+" मिणटांनी",t+" मिणटां"],h:["एका वरान","एक वर"],hh:[t+" वरांनी",t+" वरां"],d:["एका दिसान","एक दीस"],dd:[t+" दिसांनी",t+" दीस"],M:["एका म्हयन्यान","एक म्हयनो"],MM:[t+" म्हयन्यानी",t+" म्हयने"],y:["एका वर्सान","एक वर्स"],yy:[t+" वर्सांनी",t+" वर्सां"]};return i?a[n][0]:a[n][1]}t.defineLocale("gom-deva",{months:{standalone:"जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split("_"),format:"जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या".split("_"),isFormat:/MMMM(\s)+D[oD]?/},monthsShort:"जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split("_"),monthsParseExact:!0,weekdays:"आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार".split("_"),weekdaysShort:"आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.".split("_"),weekdaysMin:"आ_सो_मं_बु_ब्रे_सु_शे".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"A h:mm [वाजतां]",LTS:"A h:mm:ss [वाजतां]",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY A h:mm [वाजतां]",LLLL:"dddd, MMMM Do, YYYY, A h:mm [वाजतां]",llll:"ddd, D MMM YYYY, A h:mm [वाजतां]"},calendar:{sameDay:"[आयज] LT",nextDay:"[फाल्यां] LT",nextWeek:"[फुडलो] dddd[,] LT",lastDay:"[काल] LT",lastWeek:"[फाटलो] dddd[,] LT",sameElse:"L"},relativeTime:{future:"%s",past:"%s आदीं",s:e,ss:e,m:e,mm:e,h:e,hh:e,d:e,dd:e,M:e,MM:e,y:e,yy:e},dayOfMonthOrdinalParse:/\d{1,2}(वेर)/,ordinal:function(t,e){switch(e){case"D":return t+"वेर";default:case"M":case"Q":case"DDD":case"d":case"w":case"W":return t}},week:{dow:0,doy:3},meridiemParse:/राती|सकाळीं|दनपारां|सांजे/,meridiemHour:function(t,e){return 12===t&&(t=0),"राती"===e?t<4?t:t+12:"सकाळीं"===e?t:"दनपारां"===e?t>12?t:t+12:"सांजे"===e?t+12:void 0},meridiem:function(t,e,n){return t<4?"राती":t<12?"सकाळीं":t<16?"दनपारां":t<20?"सांजे":"राती"}})})(n("PJh5"))},VK9h:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("fr-ch",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(t,e){switch(e){default:case"M":case"Q":case"D":case"DDD":case"d":return t+(1===t?"er":"e");case"w":case"W":return t+(1===t?"re":"e")}},week:{dow:1,doy:4}})})(n("PJh5"))},"VU/8":function(t,e){t.exports=function(t,e,n,i,a,o){var r,s=t=t||{},l=typeof t.default;"object"!==l&&"function"!==l||(r=t,s=t.default);var d,c="function"==typeof s?s.options:s;if(e&&(c.render=e.render,c.staticRenderFns=e.staticRenderFns,c._compiled=!0),n&&(c.functional=!0),a&&(c._scopeId=a),o?(d=function(t){(t=t||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(t=__VUE_SSR_CONTEXT__),i&&i.call(this,t),t&&t._registeredComponents&&t._registeredComponents.add(o)},c._ssrRegister=d):i&&(d=i),d){var h=c.functional,u=h?c.render:c.beforeCreate;h?(c._injectStyles=d,c.render=function(t,e){return d.call(e),u(t,e)}):c.beforeCreate=u?[].concat(u,d):[d]}return{esModule:r,exports:s,options:c}}},VX7B:function(t,e){t.exports="data:image/gif;base64,R0lGODlhtgAJAKEAAMzMzPPz8////8zMzCH5BAEKAAMALAAAAAC2AAkAAAJPnI+py+0PIYi02ouz3jyBMHXiSJam+Angybbuu6WCGsL2jbPyTOf+D6TseL2g8fgbEovIptOkXDKfL4D1is1qt9yu9wvOBqRkUPiMTqu5BQA7"},VdPK:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n#side-menu {\n  width: 159px;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: -132px;\n  z-index: 510;\n  padding-top: 30px;\n  overflow: hidden;\n  text-align: center;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n#font-size {\n  width: 100px;\n}\n.contentArrowLeft {\n  width: 19px;\n  height: 100%;\n  right: 149px;\n  top: 0px;\n  cursor: pointer;\n  position: absolute;\n  border-left: 1px solid silver;\n  border-right: 1px solid silver;\n  z-index: 1001;\n  background-color: #e3e2e2;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  left: 83%;\n}\n.iconClass {\n  display: block;\n  line-height: 60px;\n  font-size: 150%;\n}\n.imageThumbnail {\n  width: 80%;\n  height: auto;\n  border: 1px solid black;\n}\n.imageThumbnail:hover {\n  -webkit-box-shadow: 2px 2px 2px rgb(231, 231, 231);\n          box-shadow: 2px 2px 2px rgb(231, 231, 231);\n  cursor: pointer;\n}\n.numpagespace {\n  padding-right: 9px;\n}\n#pages {\n  background-color: #727272;\n  width: 100pt;\n  height: 100%;\n  overflow-x: none;\n  overflow-y: auto;\n  border-right: 1px solid black;\n  padding-top: 30px;\n  -webkit-box-shadow: 5px 8px 10px #2f302f;\n          box-shadow: 5px 8px 10px #2f302f;\n}\n.page {\n  position: relative;\n  margin-bottom: 15px;\n}\n.active-thumb {\n  -webkit-box-shadow: 2px 2px 2px rgb(0, 255, 30);\n          box-shadow: 2px 2px 2px rgb(0, 255, 30);\n}\n.icontAroowRBFLeft {\n  position: absolute;\n  top: 50%;\n  left: 6px;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfForm/PfLeftSideBar/PfLeftSideBar.css"],names:[],mappings:";AACA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,OAAO;EACP,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,aAAa;CACd;AACD;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,cAAc;EACd,0BAA0B;EAC1B,kCAAkC;EAClC,0BAA0B;EAC1B,UAAU;CACX;AACD;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,WAAW;EACX,aAAa;EACb,wBAAwB;CACzB;AACD;EACE,mDAAmD;UAC3C,2CAA2C;EACnD,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,gDAAgD;UACxC,wCAAwC;CACjD;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,UAAU;CACX",file:"PfLeftSideBar.css",sourcesContent:["\n#side-menu {\n  width: 159px;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  left: -132px;\n  z-index: 510;\n  padding-top: 30px;\n  overflow: hidden;\n  text-align: center;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n#font-size {\n  width: 100px;\n}\n.contentArrowLeft {\n  width: 19px;\n  height: 100%;\n  right: 149px;\n  top: 0px;\n  cursor: pointer;\n  position: absolute;\n  border-left: 1px solid silver;\n  border-right: 1px solid silver;\n  z-index: 1001;\n  background-color: #e3e2e2;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n  left: 83%;\n}\n.iconClass {\n  display: block;\n  line-height: 60px;\n  font-size: 150%;\n}\n.imageThumbnail {\n  width: 80%;\n  height: auto;\n  border: 1px solid black;\n}\n.imageThumbnail:hover {\n  -webkit-box-shadow: 2px 2px 2px rgb(231, 231, 231);\n          box-shadow: 2px 2px 2px rgb(231, 231, 231);\n  cursor: pointer;\n}\n.numpagespace {\n  padding-right: 9px;\n}\n#pages {\n  background-color: #727272;\n  width: 100pt;\n  height: 100%;\n  overflow-x: none;\n  overflow-y: auto;\n  border-right: 1px solid black;\n  padding-top: 30px;\n  -webkit-box-shadow: 5px 8px 10px #2f302f;\n          box-shadow: 5px 8px 10px #2f302f;\n}\n.page {\n  position: relative;\n  margin-bottom: 15px;\n}\n.active-thumb {\n  -webkit-box-shadow: 2px 2px 2px rgb(0, 255, 30);\n          box-shadow: 2px 2px 2px rgb(0, 255, 30);\n}\n.icontAroowRBFLeft {\n  position: absolute;\n  top: 50%;\n  left: 6px;\n}\n"],sourceRoot:""}])},Vhdj:function(t,e){t.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAMAAABstdySAAAAM1BMVEUAAAB1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXWwa0GHAAAAEHRSTlMA7bQH482imY45NC0mIayrHtnIqwAAADlJREFUCNdjAANmJk4GGEuAFcrkF2DhhbDYBBh5ICx2AUZuCItDgJGLAY2JUIDQBgV8UMMQViAsBgBj+wGCDZVExQAAAABJRU5ErkJggg=="},Vjqu:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"/* .marginBotZero {\n  margin-bottom: 0px; }\n\n.spaceradio {\n  margin-right: 0px !important; }\n\n.marginBotRem {\n  margin-bottom: .5rem; } */\n\n/* .marginRight10 {\n  margin-right: 10px; } */","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfMarriageHistory/PfMarriage/PfMarriage.css"],names:[],mappings:"AAAA;;;;;;;4BAO4B;;AAE5B;0BAC0B",file:"PfMarriage.css",sourcesContent:["/* .marginBotZero {\n  margin-bottom: 0px; }\n\n.spaceradio {\n  margin-right: 0px !important; }\n\n.marginBotRem {\n  margin-bottom: .5rem; } */\n\n/* .marginRight10 {\n  margin-right: 10px; } */"],sourceRoot:""}])},Vz2w:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("zh-cn",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"周日_周一_周二_周三_周四_周五_周六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日Ah点mm分",LLLL:"YYYY年M月D日ddddAh点mm分",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(t,e){return 12===t&&(t=0),"凌晨"===e||"早上"===e||"上午"===e?t:"下午"===e||"晚上"===e?t+12:t>=11?t:t+12},meridiem:function(t,e,n){var i=100*t+e;return i<600?"凌晨":i<900?"早上":i<1130?"上午":i<1230?"中午":i<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:function(t){return t.week()!==this.week()?"[下]dddLT":"[本]dddLT"},lastDay:"[昨天]LT",lastWeek:function(t){return this.week()!==t.week()?"[上]dddLT":"[本]dddLT"},sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|周)/,ordinal:function(t,e){switch(e){case"d":case"D":case"DDD":return t+"日";case"M":return t+"月";case"w":case"W":return t+"周";default:return t}},relativeTime:{future:"%s后",past:"%s前",s:"几秒",ss:"%d 秒",m:"1 分钟",mm:"%d 分钟",h:"1 小时",hh:"%d 小时",d:"1 天",dd:"%d 天",w:"1 周",ww:"%d 周",M:"1 个月",MM:"%d 个月",y:"1 年",yy:"%d 年"},week:{dow:1,doy:4}})})(n("PJh5"))},Vzoy:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btn-time {\n  margin-top: 10px !important;\n  padding: 5px 10px 5px 10px;\n}","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfActivities/PfNewTimeActivityModal/PfNewTimeActivityModal.css"],names:[],mappings:";AACA;EACE,4BAA4B;EAC5B,2BAA2B;CAC5B",file:"PfNewTimeActivityModal.css",sourcesContent:["\n.btn-time {\n  margin-top: 10px !important;\n  padding: 5px 10px 5px 10px;\n}"],sourceRoot:""}])},W2nU:function(t,e){var n,i,a=t.exports={};function o(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function s(t){if(n===setTimeout)return setTimeout(t,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(t){n=o}try{i="function"==typeof clearTimeout?clearTimeout:r}catch(t){i=r}}();var l,d=[],c=!1,h=-1;function u(){c&&l&&(c=!1,l.length?d=l.concat(d):h=-1,d.length&&m())}function m(){if(!c){var t=s(u);c=!0;for(var e=d.length;e;){for(l=d,d=[];++h<e;)l&&l[h].run();h=-1,e=d.length}l=null,c=!1,function(t){if(i===clearTimeout)return clearTimeout(t);if((i===r||!i)&&clearTimeout)return i=clearTimeout,clearTimeout(t);try{i(t)}catch(e){try{return i.call(null,t)}catch(e){return i.call(this,t)}}}(t)}}function f(t,e){this.fun=t,this.array=e}function p(){}a.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];d.push(new f(t,e)),1!==d.length||c||s(m)},f.prototype.run=function(){this.fun.apply(null,this.array)},a.title="browser",a.browser=!0,a.env={},a.argv=[],a.version="",a.versions={},a.on=p,a.addListener=p,a.once=p,a.off=p,a.removeListener=p,a.removeAllListeners=p,a.emit=p,a.prependListener=p,a.prependOnceListener=p,a.listeners=function(t){return[]},a.binding=function(t){throw new Error("process.binding is not supported")},a.cwd=function(){return"/"},a.chdir=function(t){throw new Error("process.chdir is not supported")},a.umask=function(){return 0}},W6Rd:function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},WER7:function(t,e,n){"use strict";var i=n("PiFy"),a=n("7ar3"),o=a("%Function.prototype.apply%"),r=a("%Function.prototype.call%"),s=a("%Reflect.apply%",!0)||i.call(r,o),l=a("%Object.getOwnPropertyDescriptor%",!0),d=a("%Object.defineProperty%",!0),c=a("%Math.max%");if(d)try{d({},"a",{value:1})}catch(t){d=null}t.exports=function(t){var e=s(i,r,arguments);l&&d&&(l(e,"length").configurable&&d(e,"length",{value:1+c(0,t.length-(arguments.length-1))}));return e};var h=function(){return s(i,o,arguments)};d?d(t.exports,"apply",{value:h}):t.exports.apply=h},WJN6:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfJobs.css",sourceRoot:""}])},WJV6:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-38d27d18] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-38d27d18]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-38d27d18] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-38d27d18] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-38d27d18] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-38d27d18] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-38d27d18] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-38d27d18] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-38d27d18] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-38d27d18] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-38d27d18] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-38d27d18] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-38d27d18] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-38d27d18] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-38d27d18] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-38d27d18] {\n  margin-right: 0px;\n}\n.newItem[data-v-38d27d18] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-38d27d18] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-38d27d18] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-38d27d18] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-38d27d18] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-38d27d18] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-38d27d18] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-38d27d18] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-38d27d18] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-38d27d18] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-38d27d18]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-38d27d18] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-38d27d18] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-38d27d18] {\n  color: red;\n}\n.showMore[data-v-38d27d18]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-38d27d18] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-38d27d18] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-38d27d18] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-38d27d18 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-38d27d18 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-38d27d18] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-38d27d18 3s infinite;\n  animation: bit-data-v-38d27d18 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-38d27d18] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-38d27d18]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-38d27d18]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-38d27d18]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-38d27d18]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-38d27d18]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-38d27d18]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-38d27d18] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-38d27d18]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-38d27d18] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-38d27d18] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-38d27d18] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-38d27d18] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-38d27d18] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-38d27d18] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-38d27d18] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-38d27d18] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-38d27d18] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-38d27d18] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-38d27d18] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-38d27d18] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-38d27d18] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-38d27d18] {\n  margin-right: 0px;\n}\n.newItem[data-v-38d27d18] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-38d27d18] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-38d27d18] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-38d27d18] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-38d27d18] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-38d27d18] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-38d27d18] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-38d27d18] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-38d27d18] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-38d27d18] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-38d27d18]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-38d27d18] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-38d27d18] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-38d27d18] {\n  color: red;\n}\n.showMore[data-v-38d27d18]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-38d27d18] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-38d27d18] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-38d27d18] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-38d27d18 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-38d27d18 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-38d27d18] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-38d27d18 3s infinite;\n  animation: bit-data-v-38d27d18 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-38d27d18] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-38d27d18]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-38d27d18]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-38d27d18]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-38d27d18]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-38d27d18]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-38d27d18]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},WLM9:function(t,e,n){var i=n("FLNZ");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("c932dcae",i,!0,{})},WMVW:function(t,e,n){var i=n("zVA3");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("675d8ae2",i,!0,{})},WQYT:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-6c48ec47] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6c48ec47]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6c48ec47] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6c48ec47] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6c48ec47] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6c48ec47] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6c48ec47] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6c48ec47] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6c48ec47] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6c48ec47] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6c48ec47] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6c48ec47] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6c48ec47] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6c48ec47] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6c48ec47] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6c48ec47] {\n  margin-right: 0px;\n}\n.newItem[data-v-6c48ec47] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6c48ec47] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6c48ec47] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6c48ec47] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6c48ec47] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6c48ec47] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6c48ec47] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6c48ec47] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6c48ec47] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6c48ec47] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6c48ec47]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6c48ec47] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6c48ec47] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6c48ec47] {\n  color: red;\n}\n.showMore[data-v-6c48ec47]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6c48ec47] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6c48ec47] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6c48ec47] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6c48ec47 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6c48ec47 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6c48ec47] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6c48ec47 3s infinite;\n  animation: bit-data-v-6c48ec47 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6c48ec47] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6c48ec47]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6c48ec47]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6c48ec47]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6c48ec47]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6c48ec47]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6c48ec47]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-6c48ec47] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6c48ec47]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6c48ec47] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6c48ec47] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6c48ec47] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6c48ec47] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6c48ec47] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6c48ec47] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6c48ec47] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6c48ec47] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6c48ec47] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6c48ec47] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6c48ec47] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6c48ec47] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6c48ec47] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6c48ec47] {\n  margin-right: 0px;\n}\n.newItem[data-v-6c48ec47] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6c48ec47] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6c48ec47] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6c48ec47] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6c48ec47] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6c48ec47] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6c48ec47] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6c48ec47] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6c48ec47] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6c48ec47] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6c48ec47]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6c48ec47] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6c48ec47] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6c48ec47] {\n  color: red;\n}\n.showMore[data-v-6c48ec47]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6c48ec47] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6c48ec47] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6c48ec47] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6c48ec47 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6c48ec47 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6c48ec47] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6c48ec47 3s infinite;\n  animation: bit-data-v-6c48ec47 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6c48ec47] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6c48ec47]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6c48ec47]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6c48ec47]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6c48ec47]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6c48ec47]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6c48ec47]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},Wdy1:function(t,e,n){var i=n("YjQv"),a=n("iANj"),o=n("3fMt"),r=n("aLzV"),s=n("x//u"),l=function(t,e,n){var d,c,h,u=t&l.F,m=t&l.G,f=t&l.S,p=t&l.P,_=t&l.B,A=t&l.W,b=m?a:a[e]||(a[e]={}),x=b.prototype,g=m?i:f?i[e]:(i[e]||{}).prototype;for(d in m&&(n=e),n)(c=!u&&g&&void 0!==g[d])&&s(b,d)||(h=c?g[d]:n[d],b[d]=m&&"function"!=typeof g[d]?n[d]:_&&c?o(h,i):A&&g[d]==h?function(t){var e=function(e,n,i){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,i)}return t.apply(this,arguments)};return e.prototype=t.prototype,e}(h):p&&"function"==typeof h?o(Function.call,h):h,p&&((b.virtual||(b.virtual={}))[d]=h,t&l.R&&x&&!x[d]&&r(x,d,h)))};l.F=1,l.G=2,l.S=4,l.P=8,l.B=16,l.W=32,l.U=64,l.R=128,t.exports=l},WgTJ:function(t,e,n){var i=n("eo2C");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("42bf79c0",i,!0,{})},"Wj3+":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfFamilyMember.css",sourceRoot:""}])},XDpo:function(t,e,n){var i=n("2zL7");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("2c4f7562",i,!0,{})},XH1H:function(t,e,n){var i=n("EtYn");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("2c30f65c",i,!0,{})},XU1s:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("uz",{months:"январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split("_"),monthsShort:"янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),weekdays:"Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба".split("_"),weekdaysShort:"Якш_Душ_Сеш_Чор_Пай_Жум_Шан".split("_"),weekdaysMin:"Як_Ду_Се_Чо_Па_Жу_Ша".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"D MMMM YYYY, dddd HH:mm"},calendar:{sameDay:"[Бугун соат] LT [да]",nextDay:"[Эртага] LT [да]",nextWeek:"dddd [куни соат] LT [да]",lastDay:"[Кеча соат] LT [да]",lastWeek:"[Утган] dddd [куни соат] LT [да]",sameElse:"L"},relativeTime:{future:"Якин %s ичида",past:"Бир неча %s олдин",s:"фурсат",ss:"%d фурсат",m:"бир дакика",mm:"%d дакика",h:"бир соат",hh:"%d соат",d:"бир кун",dd:"%d кун",M:"бир ой",MM:"%d ой",y:"бир йил",yy:"%d йил"},week:{dow:1,doy:7}})})(n("PJh5"))},XfW5:function(t,e,n){"use strict";var i=n("PiFy");t.exports=i.call(Function.call,Object.prototype.hasOwnProperty)},XgCd:function(t,e,n){"use strict";var i=String.prototype.replace,a=/%20/g,o="RFC1738",r="RFC3986";t.exports={default:r,formatters:{RFC1738:function(t){return i.call(t,a,"+")},RFC3986:function(t){return String(t)}},RFC1738:o,RFC3986:r}},Xhns:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfContacts.css",sourceRoot:""}])},XkCQ:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-6408bcdc] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6408bcdc]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6408bcdc] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6408bcdc] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6408bcdc] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6408bcdc] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6408bcdc] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6408bcdc] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6408bcdc] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6408bcdc] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6408bcdc] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6408bcdc] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6408bcdc] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6408bcdc] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6408bcdc] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6408bcdc] {\n  margin-right: 0px;\n}\n.newItem[data-v-6408bcdc] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6408bcdc] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6408bcdc] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6408bcdc] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6408bcdc] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6408bcdc] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6408bcdc] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6408bcdc] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6408bcdc] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6408bcdc] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6408bcdc]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6408bcdc] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6408bcdc] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6408bcdc] {\n  color: red;\n}\n.showMore[data-v-6408bcdc]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6408bcdc] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6408bcdc] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6408bcdc] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6408bcdc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6408bcdc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6408bcdc] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6408bcdc 3s infinite;\n  animation: bit-data-v-6408bcdc 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6408bcdc] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6408bcdc]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6408bcdc]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6408bcdc]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6408bcdc]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6408bcdc]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6408bcdc]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-6408bcdc] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6408bcdc]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6408bcdc] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6408bcdc] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6408bcdc] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6408bcdc] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6408bcdc] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6408bcdc] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6408bcdc] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6408bcdc] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6408bcdc] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6408bcdc] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6408bcdc] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6408bcdc] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6408bcdc] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6408bcdc] {\n  margin-right: 0px;\n}\n.newItem[data-v-6408bcdc] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6408bcdc] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6408bcdc] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6408bcdc] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6408bcdc] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6408bcdc] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6408bcdc] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6408bcdc] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6408bcdc] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6408bcdc] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6408bcdc]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6408bcdc] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6408bcdc] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6408bcdc] {\n  color: red;\n}\n.showMore[data-v-6408bcdc]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6408bcdc] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6408bcdc] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6408bcdc] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6408bcdc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6408bcdc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6408bcdc] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6408bcdc 3s infinite;\n  animation: bit-data-v-6408bcdc 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6408bcdc] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6408bcdc]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6408bcdc]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6408bcdc]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6408bcdc]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6408bcdc]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6408bcdc]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},Xl0W:function(t,e,n){var i=n("f7G2");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("4042f3e8",i,!0,{})},XlWM:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){var a={s:["mõne sekundi","mõni sekund","paar sekundit"],ss:[t+"sekundi",t+"sekundit"],m:["ühe minuti","üks minut"],mm:[t+" minuti",t+" minutit"],h:["ühe tunni","tund aega","üks tund"],hh:[t+" tunni",t+" tundi"],d:["ühe päeva","üks päev"],M:["kuu aja","kuu aega","üks kuu"],MM:[t+" kuu",t+" kuud"],y:["ühe aasta","aasta","üks aasta"],yy:[t+" aasta",t+" aastat"]};return e?a[n][2]?a[n][2]:a[n][1]:i?a[n][0]:a[n][1]}t.defineLocale("et",{months:"jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split("_"),monthsShort:"jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),weekdays:"pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split("_"),weekdaysShort:"P_E_T_K_N_R_L".split("_"),weekdaysMin:"P_E_T_K_N_R_L".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[Täna,] LT",nextDay:"[Homme,] LT",nextWeek:"[Järgmine] dddd LT",lastDay:"[Eile,] LT",lastWeek:"[Eelmine] dddd LT",sameElse:"L"},relativeTime:{future:"%s pärast",past:"%s tagasi",s:e,ss:e,m:e,mm:e,h:e,hh:e,d:e,dd:"%d päeva",M:e,MM:e,y:e,yy:e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},XmWM:function(t,e,n){"use strict";var i=n("KCLY"),a=n("cGG2"),o=n("fuGk"),r=n("xLtR");function s(t){this.defaults=t,this.interceptors={request:new o,response:new o}}s.prototype.request=function(t){"string"==typeof t&&(t=a.merge({url:arguments[0]},arguments[1])),(t=a.merge(i,{method:"get"},this.defaults,t)).method=t.method.toLowerCase();var e=[r,void 0],n=Promise.resolve(t);for(this.interceptors.request.forEach(function(t){e.unshift(t.fulfilled,t.rejected)}),this.interceptors.response.forEach(function(t){e.push(t.fulfilled,t.rejected)});e.length;)n=n.then(e.shift(),e.shift());return n},a.forEach(["delete","get","head","options"],function(t){s.prototype[t]=function(e,n){return this.request(a.merge(n||{},{method:t,url:e}))}}),a.forEach(["post","put","patch"],function(t){s.prototype[t]=function(e,n,i){return this.request(a.merge(i||{},{method:t,url:e,data:n}))}}),t.exports=s},XvJ3:function(t,e,n){var i=n("kxFB");(t.exports=n("FZ+f")(!0)).push([t.i,"/*\nProduct Name: dhtmlxSuite \nVersion: 5.1.0 \nEdition: Standard \nLicense: content of this file is covered by DHTMLX Commercial or enterpri. Usage outside GPL terms is prohibited. To obtain Commercial or Enterprise license contact sales@dhtmlx.com\nCopyright UAB Dinamenta http://www.dhtmlx.com\n*/\n\n/*\n\tskin detected: material\n\tinclude extra file: skins/material.less\n*/\n@-webkit-keyframes dhx_loader_rotate {\n100% {\n\t\t-webkit-transform: rotate(360deg);\n\t\t        transform: rotate(360deg);\n}\n}\n@keyframes dhx_loader_rotate {\n100% {\n\t\t-webkit-transform: rotate(360deg);\n\t\t        transform: rotate(360deg);\n}\n}\n@-webkit-keyframes dhx_loader_dash {\n0% {\n\t\tstroke-dasharray: 1, 200;\n\t\tstroke-dashoffset: 0;\n}\n50% {\n\t\tstroke-dasharray: 89, 200;\n\t\tstroke-dashoffset: -35px;\n}\n100% {\n\t\tstroke-dasharray: 89, 200;\n\t\tstroke-dashoffset: -124px;\n}\n}\n@keyframes dhx_loader_dash {\n0% {\n\t\tstroke-dasharray: 1, 200;\n\t\tstroke-dashoffset: 0;\n}\n50% {\n\t\tstroke-dasharray: 89, 200;\n\t\tstroke-dashoffset: -35px;\n}\n100% {\n\t\tstroke-dasharray: 89, 200;\n\t\tstroke-dashoffset: -124px;\n}\n}\n.dhtmlxcalendar_material {\n\tposition: absolute;\n\tdisplay: block;\n\tbackground-color: white;\n\tfont-size: 14px;\n\tfont-family: Roboto, Arial, Helvetica;\n\tcolor: #404040;\n}\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input {\n\t-webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n\t        box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n}\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_month_cont,\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_days_cont,\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_dates_cont,\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_time_cont {\n\tborder-color: white;\n}\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_time_cont {\n\tborder-top: 1px solid #dfdfdf;\n}\n.dhtmlxcalendar_material ul.dhtmlxcalendar_line {\n\tposition: relative;\n\tdisplay: block;\n\tclear: both;\n\tfont: inherit;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\tmargin-left: 12px;\n\twidth: 225px;\n}\n.dhtmlxcalendar_material ul.dhtmlxcalendar_line li {\n\tfloat: left;\n\tposition: relative;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tfont: inherit;\n\tcursor: default;\n\toverflow: hidden;\n\tmargin: 0px;\n\tpadding: 0px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tborder-width: 1px 1px 0px 1px;\n\tborder-style: solid;\n\tborder-color: #dfdfdf;\n\toverflow: hidden;\n\tfont: inherit;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr {\n\twidth: 225px;\n\theight: 31px;\n\tline-height: 31px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow {\n\tposition: absolute;\n\ttop: 0px;\n\twidth: 18px;\n\theight: 31px;\n\tcolor: inherit;\n\ttext-align: center;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left_hover {\n\tleft: 4px;\n\tbackground-image: url("+i(n("Vhdj"))+");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right,\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right_hover {\n\tright: 4px;\n\tbackground-image: url("+i(n("Y+8u"))+");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_month,\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_year {\n\tposition: relative;\n\tfont: inherit;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tborder-left: 1px solid #dfdfdf;\n\tborder-right: 1px solid #dfdfdf;\n\toverflow: hidden;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line {\n\theight: 31px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li {\n\twidth: 31px;\n\theight: 31px;\n\tline-height: 31px;\n\tmargin-left: 1px;\n\tfont-size: 12px;\n\tcolor: #9a9a9a;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first {\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_day_weekday_cell_first {\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tpadding-bottom: 8px;\n\tborder-width: 0px 1px 1px 1px;\n\tborder-style: solid;\n\tborder-color: #dfdfdf;\n\toverflow: hidden;\n\tfont: inherit;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line {\n\tmargin-top: 1px;\n\tmargin-left: 13px;\n\theight: 31px;\n\tline-height: 31px;\n\tfont: inherit;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li {\n\twidth: 31px;\n\theight: 31px;\n\tline-height: 31px;\n\tmargin-right: 1px;\n\tborder-radius: 50%;\n\toverflow: visible;\n\tfont: inherit;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n\tfont: inherit;\n\tline-height: 31px;\n\ttext-align: center;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label.dhtmlxcalendar_label_title {\n\tbackground-image: url("+i(n("+6As"))+");\n\tbackground-position: top right;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\tcolor: #a6a6a6;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend {\n\tcolor: #e6918e;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date {\n\tcolor: #a6a6a6;\n\tbackground-color: #dcdcdc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend {\n\tcolor: #e6918e;\n\tbackground-color: #dcdcdc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_dis {\n\tcolor: #c0c0c0;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_dis {\n\tcolor: #e6918e;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_holiday,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_holiday {\n\tcolor: #e6918e;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_holiday,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_holiday {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_holiday_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_hover {\n\tcolor: #a6a6a6;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_hover {\n\tcolor: #a6a6a6;\n\tbackground-color: #dcdcdc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_hover {\n\tcolor: #e6918e;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_hover {\n\tcolor: #e6918e;\n\tbackground-color: #dcdcdc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_holiday_hover,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_holiday_hover,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_holiday_hover,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month {\n\tcolor: #404040;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date {\n\tcolor: white;\n\tbackground-color: #3399cc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_dis {\n\tcolor: #c0c0c0;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_holiday {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_holiday {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_holiday_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_hover {\n\tcolor: #404040;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_hover {\n\tcolor: white;\n\tbackground-color: #3399cc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_hover {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_holiday_hover {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_holiday_hover {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\theight: 31px;\n\tborder-left: 1px solid #dfdfdf;\n\tborder-right: 1px solid #dfdfdf;\n\tborder-bottom: 1px solid #dfdfdf;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li {\n\twidth: 225px;\n\theight: 31px;\n\tline-height: 31px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_time_hdr {\n\ttext-align: left;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 42px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tposition: absolute;\n\tleft: 22px;\n\ttop: 7px;\n\twidth: 18px;\n\theight: 18px;\n\tbackground-image: url("+i(n("fvfW"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tleft: 75px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: center;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 0px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tdisplay: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr div.dhtmlxcalendar_time_img,\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours,\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_minutes,\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_colon {\n\tdisplay: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 74px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_selected_date {\n\tborder-bottom: 2px solid red;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 22px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell,\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first,\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color:  - #060606;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n\theight: 28px;\n\tline-height: 27px;\n\tmargin-top: 2px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell div {\n\tline-height: inherit;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color:  - #060606;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_cover {\n\tposition: absolute;\n\tleft: 1px;\n\tbackground-color: white;\n\topacity: 0.5;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj {\n\tposition: absolute;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_selector_obj_arrow {\n\tposition: absolute;\n\tbottom: auto;\n\ttop: 1px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 9px;\n\toverflow: hidden;\n\tbackground-image: url("+i(n("8YdS"))+");\n\tbackground-position: top center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table {\n\tborder-bottom: 1px solid #dfdfdf;\n\tborder-top: 0px solid white;\n\tbackground-color: white;\n\tmargin-top: 9px;\n\t-webkit-box-shadow: 0 2px 6px rgba(0,0,0,0.24);\n\t        box-shadow: 0 2px 6px rgba(0,0,0,0.24);\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\twidth: 24px;\n\ttext-align: center;\n\tborder-color: #dfdfdf;\n\tborder-style: solid;\n\tpadding: 0px;\n\tmargin: 0px;\n\tbackground-color: white;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left {\n\tborder-width: 1px 0px 0px 1px;\n\tbackground-image: url("+i(n("Vhdj"))+");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left.dhtmlxcalendar_selector_cell_left_hover {\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tborder-width: 1px 1px 0px 0px;\n\tbackground-image: url("+i(n("Y+8u"))+");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right.dhtmlxcalendar_selector_cell_right_hover {\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle {\n\tcursor: default;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul {\n\tdisplay: block;\n\tclear: both;\n\tbackground-color: white;\n\tborder-left: 1px solid #dfdfdf;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li {\n\tfloat: left;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder-right: 1px solid #dfdfdf;\n\tbackground-color: white;\n\tcursor: default;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tfont-size: 14px;\n\tfont-family: Roboto, Arial, Helvetica;\n\tcolor: #404040;\n\tfont-size: 0.9em;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_active,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_hover {\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 28px;\n\tborder-top: 1px solid #dfdfdf;\n\tborder-bottom: 0px solid white;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 50px;\n\theight: 28px;\n\tline-height: 28px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\ttop: auto;\n\tbottom: 1px;\n\tbackground-image: url("+i(n("mv2c"))+");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow ul.dhtmlxcalendar_selector_line {\n\theight: 28px;\n\tborder-top: 0px solid white;\n\tborder-bottom: 1px solid #dfdfdf;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table {\n\tmargin-top: 0px;\n\tmargin-bottom: 9px;\n\tborder-bottom: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 34px;\n\theight: 28px;\n\tline-height: 28px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours2,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_year div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: block;\n}\n.dhtmlxcalendar_ifr {\n\tposition: absolute;\n\toverflow: hidden;\n\tbackground-color: white;\n}\ndiv.dhtmlxcalendar_skin_detect {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: -100px;\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0px solid white;\n\twidth: 40px;\n\theight: 10px;\n\toverflow: hidden;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/dhx/calendar/skins/dhtmlxcalendar_material.css"],names:[],mappings:"AAAA;;;;;;EAME;;AAEF;;;EAGE;AACF;AACA;EACE,kCAAkC;UAC1B,0BAA0B;CACnC;CACA;AACD;AACA;EACE,kCAAkC;UAC1B,0BAA0B;CACnC;CACA;AACD;AACA;EACE,yBAAyB;EACzB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,yBAAyB;CAC1B;AACD;EACE,0BAA0B;EAC1B,0BAA0B;CAC3B;CACA;AACD;AACA;EACE,yBAAyB;EACzB,qBAAqB;CACtB;AACD;EACE,0BAA0B;EAC1B,yBAAyB;CAC1B;AACD;EACE,0BAA0B;EAC1B,0BAA0B;CAC3B;CACA;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,wBAAwB;CACxB,gBAAgB;CAChB,sCAAsC;CACtC,eAAe;CACf;AACD;CACC,6EAA6E;SACrE,qEAAqE;CAC7E;AACD;;;;CAIC,oBAAoB;CACpB;AACD;CACC,8BAA8B;CAC9B;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,YAAY;CACZ,cAAc;CACd,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,cAAc;CACd,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;CACZ,aAAa;CACb;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,8BAA8B;CAC9B,oBAAoB;CACpB,sBAAsB;CACtB,iBAAiB;CACjB,cAAc;CACd,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,mBAAmB;CACnB,SAAS;CACT,YAAY;CACZ,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,mCAAmC;CACnC,6BAA6B;CAC7B;AACD;;CAEC,UAAU;CACV,gDAAiF;CACjF;AACD;;CAEC,WAAW;CACX,gDAAkF;CAClF;AACD;;CAEC,mBAAmB;CACnB,cAAc;CACd;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,+BAA+B;CAC/B,gCAAgC;CAChC,iBAAiB;CACjB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,aAAa;CACb;AACD;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf;AACD;CACC,iBAAiB;CACjB;AACD;CACC,iBAAiB;CACjB;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,oBAAoB;CACpB,8BAA8B;CAC9B,oBAAoB;CACpB,sBAAsB;CACtB,iBAAiB;CACjB,cAAc;CACd,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,kBAAkB;CAClB,cAAc;CACd;AACD;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;CACd;AACD;CACC,mBAAmB;CACnB,YAAY;CACZ,aAAa;CACb,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB;AACD;CACC,gDAA6E;CAC7E,+BAA+B;CAC/B,6BAA6B;CAC7B;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;;CAEC,eAAe;CACf,0BAA0B;CAC1B;AACD;;CAEC,eAAe;CACf,0BAA0B;CAC1B;AACD;;CAEC,eAAe;CACf;AACD;;CAEC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B;AACD;;CAEC,eAAe;CACf,0BAA0B;CAC1B;AACD;;CAEC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,aAAa;CACb,+BAA+B;CAC/B,gCAAgC;CAChC,iCAAiC;CACjC,iBAAiB;CACjB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,iBAAiB;CACjB;AACD;CACC,kBAAkB;CAClB;AACD;CACC,mBAAmB;CACnB,WAAW;CACX,SAAS;CACT,YAAY;CACZ,aAAa;CACb,gDAA4E;CAC5E,mCAAmC;CACnC,6BAA6B;CAC7B;AACD;CACC,WAAW;CACX;AACD;CACC,mBAAmB;CACnB;AACD;CACC,iBAAiB;CACjB;AACD;;CAEC,cAAc;CACd;AACD;;;;CAIC,cAAc;CACd;AACD;CACC,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,mBAAmB;CACnB;AACD;CACC,6BAA6B;CAC7B;AACD;CACC,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,mBAAmB;CACnB;AACD;;CAEC,cAAc;CACd;AACD;;;CAGC,YAAY;CACZ;AACD;CACC,eAAe;CACf,YAAY;CACZ,eAAe;CACf,6BAA6B;CAC7B;AACD;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB;AACD;CACC,qBAAqB;CACrB;AACD;CACC,eAAe;CACf,YAAY;CACZ,eAAe;CACf,6BAA6B;CAC7B;AACD;CACC,mBAAmB;CACnB,UAAU;CACV,wBAAwB;CACxB,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,mBAAmB;CACnB;AACD;CACC,mBAAmB;CACnB,aAAa;CACb,SAAS;CACT,UAAU;CACV,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,gDAAmF;CACnF,gCAAgC;CAChC,6BAA6B;CAC7B;AACD;CACC,iCAAiC;CACjC,4BAA4B;CAC5B,wBAAwB;CACxB,gBAAgB;CAChB,+CAA+C;SACvC,uCAAuC;CAC/C;AACD;;CAEC,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;CACtB,oBAAoB;CACpB,aAAa;CACb,YAAY;CACZ,wBAAwB;CACxB,mCAAmC;CACnC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;CACC,8BAA8B;CAC9B,gDAAiF;CACjF;AACD;CACC,0BAA0B;CAC1B;AACD;CACC,8BAA8B;CAC9B,gDAAkF;CAClF;AACD;CACC,0BAA0B;CAC1B;AACD;CACC,gBAAgB;CAChB;AACD;CACC,eAAe;CACf,YAAY;CACZ,wBAAwB;CACxB,+BAA+B;CAC/B,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,YAAY;CACZ,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,aAAa;CACb,gCAAgC;CAChC,wBAAwB;CACxB,gBAAgB;CAChB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,sCAAsC;CACtC,eAAe;CACf,iBAAiB;CACjB;AACD;;CAEC,0BAA0B;CAC1B;AACD;CACC,aAAa;CACb,8BAA8B;CAC9B,+BAA+B;CAC/B;AACD;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB;AACD;;CAEC,cAAc;CACd,WAAW;CACX;AACD;;;CAGC,UAAU;CACV,YAAY;CACZ,gDAAsF;CACtF;AACD;;;CAGC,aAAa;CACb,4BAA4B;CAC5B,iCAAiC;CACjC;AACD;;;CAGC,gBAAgB;CAChB,mBAAmB;CACnB,oBAAoB;CACpB;AACD;;;CAGC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB;AACD;;;;;;CAMC,cAAc;CACd,WAAW;CACX;AACD;;;;;;;CAOC,cAAc;CACd;AACD;;;;;;;CAOC,eAAe;CACf;AACD;CACC,mBAAmB;CACnB,iBAAiB;CACjB,wBAAwB;CACxB;AACD;CACC,mBAAmB;CACnB,UAAU;CACV,YAAY;CACZ,UAAU;CACV,WAAW;CACX,wBAAwB;CACxB,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB",file:"dhtmlxcalendar_material.css",sourcesContent:['/*\nProduct Name: dhtmlxSuite \nVersion: 5.1.0 \nEdition: Standard \nLicense: content of this file is covered by DHTMLX Commercial or enterpri. Usage outside GPL terms is prohibited. To obtain Commercial or Enterprise license contact sales@dhtmlx.com\nCopyright UAB Dinamenta http://www.dhtmlx.com\n*/\n\n/*\n\tskin detected: material\n\tinclude extra file: skins/material.less\n*/\n@-webkit-keyframes dhx_loader_rotate {\n100% {\n\t\t-webkit-transform: rotate(360deg);\n\t\t        transform: rotate(360deg);\n}\n}\n@keyframes dhx_loader_rotate {\n100% {\n\t\t-webkit-transform: rotate(360deg);\n\t\t        transform: rotate(360deg);\n}\n}\n@-webkit-keyframes dhx_loader_dash {\n0% {\n\t\tstroke-dasharray: 1, 200;\n\t\tstroke-dashoffset: 0;\n}\n50% {\n\t\tstroke-dasharray: 89, 200;\n\t\tstroke-dashoffset: -35px;\n}\n100% {\n\t\tstroke-dasharray: 89, 200;\n\t\tstroke-dashoffset: -124px;\n}\n}\n@keyframes dhx_loader_dash {\n0% {\n\t\tstroke-dasharray: 1, 200;\n\t\tstroke-dashoffset: 0;\n}\n50% {\n\t\tstroke-dasharray: 89, 200;\n\t\tstroke-dashoffset: -35px;\n}\n100% {\n\t\tstroke-dasharray: 89, 200;\n\t\tstroke-dashoffset: -124px;\n}\n}\n.dhtmlxcalendar_material {\n\tposition: absolute;\n\tdisplay: block;\n\tbackground-color: white;\n\tfont-size: 14px;\n\tfont-family: Roboto, Arial, Helvetica;\n\tcolor: #404040;\n}\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input {\n\t-webkit-box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n\t        box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n}\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_month_cont,\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_days_cont,\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_dates_cont,\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_time_cont {\n\tborder-color: white;\n}\n.dhtmlxcalendar_material.dhtmlxcalendar_in_input div.dhtmlxcalendar_time_cont {\n\tborder-top: 1px solid #dfdfdf;\n}\n.dhtmlxcalendar_material ul.dhtmlxcalendar_line {\n\tposition: relative;\n\tdisplay: block;\n\tclear: both;\n\tfont: inherit;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\tmargin-left: 12px;\n\twidth: 225px;\n}\n.dhtmlxcalendar_material ul.dhtmlxcalendar_line li {\n\tfloat: left;\n\tposition: relative;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tfont: inherit;\n\tcursor: default;\n\toverflow: hidden;\n\tmargin: 0px;\n\tpadding: 0px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tborder-width: 1px 1px 0px 1px;\n\tborder-style: solid;\n\tborder-color: #dfdfdf;\n\toverflow: hidden;\n\tfont: inherit;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr {\n\twidth: 225px;\n\theight: 31px;\n\tline-height: 31px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow {\n\tposition: absolute;\n\ttop: 0px;\n\twidth: 18px;\n\theight: 31px;\n\tcolor: inherit;\n\ttext-align: center;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left_hover {\n\tleft: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_material/dhxcalendar_arrow_left.png");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right,\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right_hover {\n\tright: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_material/dhxcalendar_arrow_right.png");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_month,\n.dhtmlxcalendar_material div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_year {\n\tposition: relative;\n\tfont: inherit;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tborder-left: 1px solid #dfdfdf;\n\tborder-right: 1px solid #dfdfdf;\n\toverflow: hidden;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line {\n\theight: 31px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li {\n\twidth: 31px;\n\theight: 31px;\n\tline-height: 31px;\n\tmargin-left: 1px;\n\tfont-size: 12px;\n\tcolor: #9a9a9a;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first {\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_day_weekday_cell_first {\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tpadding-bottom: 8px;\n\tborder-width: 0px 1px 1px 1px;\n\tborder-style: solid;\n\tborder-color: #dfdfdf;\n\toverflow: hidden;\n\tfont: inherit;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line {\n\tmargin-top: 1px;\n\tmargin-left: 13px;\n\theight: 31px;\n\tline-height: 31px;\n\tfont: inherit;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li {\n\twidth: 31px;\n\theight: 31px;\n\tline-height: 31px;\n\tmargin-right: 1px;\n\tborder-radius: 50%;\n\toverflow: visible;\n\tfont: inherit;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label {\n\tposition: relative;\n\twidth: 100%;\n\theight: 100%;\n\tfont: inherit;\n\tline-height: 31px;\n\ttext-align: center;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label.dhtmlxcalendar_label_title {\n\tbackground-image: url("../imgs/dhxcalendar_material/dhxcalendar_marker.gif");\n\tbackground-position: top right;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\tcolor: #a6a6a6;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend {\n\tcolor: #e6918e;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date {\n\tcolor: #a6a6a6;\n\tbackground-color: #dcdcdc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend {\n\tcolor: #e6918e;\n\tbackground-color: #dcdcdc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_dis {\n\tcolor: #c0c0c0;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_dis {\n\tcolor: #e6918e;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_holiday,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_holiday {\n\tcolor: #e6918e;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_holiday,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_holiday {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_holiday_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_hover {\n\tcolor: #a6a6a6;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_hover {\n\tcolor: #a6a6a6;\n\tbackground-color: #dcdcdc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_hover {\n\tcolor: #e6918e;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_hover {\n\tcolor: #e6918e;\n\tbackground-color: #dcdcdc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_holiday_hover,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_weekend_holiday_hover,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_holiday_hover,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_date_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month {\n\tcolor: #404040;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date {\n\tcolor: white;\n\tbackground-color: #3399cc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_dis {\n\tcolor: #c0c0c0;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_holiday {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_holiday {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_holiday_dis,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_holiday_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #f2f2f2;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_hover {\n\tcolor: #404040;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_hover {\n\tcolor: white;\n\tbackground-color: #3399cc;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_hover {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_holiday_hover {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_month_date_weekend_holiday_hover {\n\tcolor: white;\n\tbackground-color: #ef5350;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\theight: 31px;\n\tborder-left: 1px solid #dfdfdf;\n\tborder-right: 1px solid #dfdfdf;\n\tborder-bottom: 1px solid #dfdfdf;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li {\n\twidth: 225px;\n\theight: 31px;\n\tline-height: 31px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_time_hdr {\n\ttext-align: left;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 42px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tposition: absolute;\n\tleft: 22px;\n\ttop: 7px;\n\twidth: 18px;\n\theight: 18px;\n\tbackground-image: url("../imgs/dhxcalendar_material/dhxcalendar_clock.png");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tleft: 75px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: center;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 0px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tdisplay: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr div.dhtmlxcalendar_time_img,\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours,\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_minutes,\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_colon {\n\tdisplay: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 74px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_selected_date {\n\tborder-bottom: 2px solid red;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 22px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn,\n.dhtmlxcalendar_material div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell,\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first,\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color:  - #060606;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n\theight: 28px;\n\tline-height: 27px;\n\tmargin-top: 2px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell div {\n\tline-height: inherit;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color:  - #060606;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_cover {\n\tposition: absolute;\n\tleft: 1px;\n\tbackground-color: white;\n\topacity: 0.5;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj {\n\tposition: absolute;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_selector_obj_arrow {\n\tposition: absolute;\n\tbottom: auto;\n\ttop: 1px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 9px;\n\toverflow: hidden;\n\tbackground-image: url("../imgs/dhxcalendar_material/dhxcalendar_selector_top.gif");\n\tbackground-position: top center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table {\n\tborder-bottom: 1px solid #dfdfdf;\n\tborder-top: 0px solid white;\n\tbackground-color: white;\n\tmargin-top: 9px;\n\t-webkit-box-shadow: 0 2px 6px rgba(0,0,0,0.24);\n\t        box-shadow: 0 2px 6px rgba(0,0,0,0.24);\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\twidth: 24px;\n\ttext-align: center;\n\tborder-color: #dfdfdf;\n\tborder-style: solid;\n\tpadding: 0px;\n\tmargin: 0px;\n\tbackground-color: white;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left {\n\tborder-width: 1px 0px 0px 1px;\n\tbackground-image: url("../imgs/dhxcalendar_material/dhxcalendar_arrow_left.png");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left.dhtmlxcalendar_selector_cell_left_hover {\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tborder-width: 1px 1px 0px 0px;\n\tbackground-image: url("../imgs/dhxcalendar_material/dhxcalendar_arrow_right.png");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right.dhtmlxcalendar_selector_cell_right_hover {\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle {\n\tcursor: default;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul {\n\tdisplay: block;\n\tclear: both;\n\tbackground-color: white;\n\tborder-left: 1px solid #dfdfdf;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li {\n\tfloat: left;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder-right: 1px solid #dfdfdf;\n\tbackground-color: white;\n\tcursor: default;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tfont-size: 14px;\n\tfont-family: Roboto, Arial, Helvetica;\n\tcolor: #404040;\n\tfont-size: 0.9em;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_active,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_hover {\n\tbackground-color: #ebebeb;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 28px;\n\tborder-top: 1px solid #dfdfdf;\n\tborder-bottom: 0px solid white;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 50px;\n\theight: 28px;\n\tline-height: 28px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\ttop: auto;\n\tbottom: 1px;\n\tbackground-image: url("../imgs/dhxcalendar_material/dhxcalendar_selector_bottom.gif");\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow ul.dhtmlxcalendar_selector_line {\n\theight: 28px;\n\tborder-top: 0px solid white;\n\tborder-bottom: 1px solid #dfdfdf;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table {\n\tmargin-top: 0px;\n\tmargin-bottom: 9px;\n\tborder-bottom: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 34px;\n\theight: 28px;\n\tline-height: 28px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours2,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: none;\n}\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_year div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_material div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: block;\n}\n.dhtmlxcalendar_ifr {\n\tposition: absolute;\n\toverflow: hidden;\n\tbackground-color: white;\n}\ndiv.dhtmlxcalendar_skin_detect {\n\tposition: absolute;\n\tleft: 0px;\n\ttop: -100px;\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0px solid white;\n\twidth: 40px;\n\theight: 10px;\n\toverflow: hidden;\n}\n'],sourceRoot:""}])},Xxa5:function(t,e,n){t.exports=n("1H6C")},"XzD+":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("th",{months:"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),monthsShort:"ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split("_"),monthsParseExact:!0,weekdays:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),weekdaysShort:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),weekdaysMin:"อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY เวลา H:mm",LLLL:"วันddddที่ D MMMM YYYY เวลา H:mm"},meridiemParse:/ก่อนเที่ยง|หลังเที่ยง/,isPM:function(t){return"หลังเที่ยง"===t},meridiem:function(t,e,n){return t<12?"ก่อนเที่ยง":"หลังเที่ยง"},calendar:{sameDay:"[วันนี้ เวลา] LT",nextDay:"[พรุ่งนี้ เวลา] LT",nextWeek:"dddd[หน้า เวลา] LT",lastDay:"[เมื่อวานนี้ เวลา] LT",lastWeek:"[วัน]dddd[ที่แล้ว เวลา] LT",sameElse:"L"},relativeTime:{future:"อีก %s",past:"%sที่แล้ว",s:"ไม่กี่วินาที",ss:"%d วินาที",m:"1 นาที",mm:"%d นาที",h:"1 ชั่วโมง",hh:"%d ชั่วโมง",d:"1 วัน",dd:"%d วัน",w:"1 สัปดาห์",ww:"%d สัปดาห์",M:"1 เดือน",MM:"%d เดือน",y:"1 ปี",yy:"%d ปี"}})})(n("PJh5"))},"Y+8u":function(t,e){t.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAMAAABstdySAAAAOVBMVEUAAAB1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXXovHvwAAAAEnRSTlMA7d8Iv7u3sJYyMCkiHKOiiIZ0OMDwAAAAOUlEQVQI12NgYOBiY2aAAhYhVhibl0mIHSbMwyTED2NzMwpxwNicjEKCCKYAQgFcGx/CMHQrEBYDAHCtAbWyECcBAAAAAElFTkSuQmCC"},"YBA/":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"søn_man_tir_ons_tor_fre_lør".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd [d.] D. MMMM YYYY [kl.] HH:mm"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"på dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[i] dddd[s kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"få sekunder",ss:"%d sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en måned",MM:"%d måneder",y:"et år",yy:"%d år"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},YHYu:function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAGAOMNANSNSdSOSdSOSteSUNeTT9eTUNqYVtqYV9uYV96dXeGhY+GhZOGiY////////////yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAA8ALAAAAAAGAAYAAAQVMAQhwSuDlPLeMQfSPUk5PspyPkwEADs="},YTz9:function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},YXlc:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("yo",{months:"Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀".split("_"),monthsShort:"Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀".split("_"),weekdays:"Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta".split("_"),weekdaysShort:"Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá".split("_"),weekdaysMin:"Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Ònì ni] LT",nextDay:"[Ọ̀la ni] LT",nextWeek:"dddd [Ọsẹ̀ tón'bọ] [ni] LT",lastDay:"[Àna ni] LT",lastWeek:"dddd [Ọsẹ̀ tólọ́] [ni] LT",sameElse:"L"},relativeTime:{future:"ní %s",past:"%s kọjá",s:"ìsẹjú aayá die",ss:"aayá %d",m:"ìsẹjú kan",mm:"ìsẹjú %d",h:"wákati kan",hh:"wákati %d",d:"ọjọ́ kan",dd:"ọjọ́ %d",M:"osù kan",MM:"osù %d",y:"ọdún kan",yy:"ọdún %d"},dayOfMonthOrdinalParse:/ọjọ́\s\d{1,2}/,ordinal:"ọjọ́ %d",week:{dow:1,doy:4}})})(n("PJh5"))},YjQv:function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},YqjV:function(t,e,n){var i=n("ngRd");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("5c764464",i,!0,{})},YseS:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.textTitleMain[data-v-6fd46207] {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  font-size: 18px;\n  color: white;\n}\n.closeModalMain[data-v-6fd46207]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.modal-maskMain[data-v-6fd46207] {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: table;\n  -webkit-transition: opacity .3s ease;\n  transition: opacity .3s ease;\n}\n.modal-wrapperMain[data-v-6fd46207] {\n  display: table-cell;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: auto !important;\n}\n.modal-containerMain[data-v-6fd46207] {\n  width: 65%;\n  margin: 30px auto;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  /* padding-bottom: 30px */\n}\n\n/* UBOLD CLASSES */\n.headerUbold[data-v-6fd46207]{\n  background-color: unset !important;\n  border-bottom: 1px solid #dee2e6 !important;\n}\n.container-mainUbold[data-v-6fd46207]{\n  border-radius: 0.2rem !important;\n}\n.titleUbold[data-v-6fd46207]{\n  /* margin-bottom: -4px; */\n  /* color: #343a40; */\n  font-size: 18px;\n}\n.closeUbold[data-v-6fd46207]{\n  font-size: 14px;\n  /* color: #6c757d; */\n  margin-top: 3px;\n}\n.closeUbold[data-v-6fd46207]:hover{\n  /* color: #343a40; */\n  font-weight: bold;\n}\n.hrUboldFooter[data-v-6fd46207]{\n  background-color: unset !important;\n  border-top: 1px solid #dee2e6;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  margin-bottom: 13px;\n}\n@media (max-width: 991px) {\n.modal-containerMain[data-v-6fd46207] {\n    width: 95%;\n}\n}\n.modal-enter[data-v-6fd46207] {\n  opacity: 0;\n}\n.modal-leave-active[data-v-6fd46207] {\n  opacity: 0;\n}\n.modal-enter .modal-containerMain[data-v-6fd46207],\n.modal-leave-active .modal-containerMain[data-v-6fd46207] {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n.myContainerMain[data-v-6fd46207] {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n}\ndiv.toolbox-tab-container[data-v-6fd46207] {\n  background-color: white;\n  padding: 0 !important;\n  -moz-border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n  opacity: 0.97;\n  filter: alpha(opacity=97);\n}\ndiv.toolbox-tab-menuMain div.list-group[data-v-6fd46207] {\n  margin-bottom: 0;\n}\ndiv.toolbox-tab-menuMain div.list-group > a[data-v-6fd46207] {\n  color: #000;\n}\ndiv.toolbox-tab-menuMain div.list-group > a[data-v-6fd46207]:first-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menuMain div.list-group > a[data-v-6fd46207]:last-child {\n  border-radius: 0px !important;\n  /* border: $border-1px  */\n}\ndiv.toolbox-tab-menuMain div.list-group > a.active[data-v-6fd46207],\ndiv.toolbox-tab-menuMain div.list-group > a.active .glyphicon[data-v-6fd46207],\ndiv.toolbox-tab-menuMain div.list-group > a.active .fa[data-v-6fd46207] {\n  color: black !important;\n  font-weight: bold;\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-content[data-v-6fd46207] {\n  padding-left: 0px;\n  padding-top: 0px;\n  margin-bottom: -32px;\n}\ndiv.toolbox-tab div.toolbox-tab-content[data-v-6fd46207]:not(.active) {\n  display: none;\n}\n.list-group[data-v-6fd46207] {\n  display: -webkit-inline-box;\n  -webkit-box-orient: horizontal;\n  font-size: 0.875rem;\n}\n.positionForm[data-v-6fd46207] {\n  z-index: 4 !important;\n}\n.positionContact[data-v-6fd46207] {\n  margin-left: 18px !important;\n  z-index: 3 !important;\n}\ndiv.toolbox-tab-menu div.list-group > a.positionContact.active[data-v-6fd46207] {\n  margin-left: 18px;\n}\n.headerModalMain[data-v-6fd46207] {\n  margin-top: -2px;\n  top: -2px;\n  z-index: 99;\n}\n.mrHr[data-v-6fd46207] {\n  margin-top: 5px;\n  background-color: grey;\n  height: 2px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n.mrHrUbold[data-v-6fd46207] {\n  margin-top: 5px;\n  background-color: #dee2e6;\n  height: 0.5px;\n}\n.colorHeaderModal[data-v-6fd46207] {\n  background-color: #38414a !important;\n  -webkit-box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);\n  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);\n  border-bottom: 1px solid #dee2e6 !important;\n}\n.formGeneralInfor[data-v-6fd46207] {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.paddingR0[data-v-6fd46207] {\n  padding-right: 0px !important;\n}\n.marginRightSpace[data-v-6fd46207] {\n  margin-right: -8px;\n}\n.btnLeft[data-v-6fd46207] {\n  padding: 0.15rem 0.5rem;\n  margin-bottom: 15px;\n  font-size: 12px;\n  background-color: #35aa47 !important;\n  color: white !important;\n  border-radius: 0px;\n}\n.btnLeft[data-v-6fd46207]:hover {\n  color: white;\n  background-color: #2b8b3a !important;\n}\n.btnRight[data-v-6fd46207] {\n  padding: 0.15rem 0.5rem;\n  margin-bottom: 15px;\n  font-size: 12px;\n  background-color: #35aa47 !important;\n  color: white !important;\n  border-radius: 0px;\n}\n.btnRight[data-v-6fd46207]:hover {\n  color: white;\n  background-color: #2b8b3a !important;\n}\ninput:checked + label[data-v-6fd46207] {\n  font-weight: bold;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/utils/PfModal/PfModal.css"],names:[],mappings:";AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,OAAO;EACP,SAAS;EACT,UAAU;EACV,QAAQ;EACR,4BAA4B;CAC7B;AACD;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,kDAAkD;EAClD,0CAA0C;EAC1C,iCAAiC;EACjC,yBAAyB;EACzB,0BAA0B;CAC3B;;AAED,mBAAmB;AACnB;EACE,mCAAmC;EACnC,4CAA4C;CAC7C;AACD;EACE,iCAAiC;CAClC;AACD;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;CACjB;AACD;EACE,qBAAqB;EACrB,kBAAkB;CACnB;AACD;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;AACA;IACI,WAAW;CACd;CACA;AACD;EACE,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;;EAEE,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;CACnB;AACD;EACE,wBAAwB;EACxB,sBAAsB;EACtB,wBAAwB;EACxB,oDAAoD;EACpD,iDAAiD;EACjD,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;CAC3B;AACD;EACE,iBAAiB;CAClB;AACD;EACE,YAAY;CACb;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,8BAA8B;EAC9B,0BAA0B;CAC3B;AACD;;;EAGE,wBAAwB;EACxB,kBAAkB;EAClB,8BAA8B;CAC/B;AACD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;CACtB;AACD;EACE,cAAc;CACf;AACD;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;CACrB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,6BAA6B;EAC7B,sBAAsB;CACvB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;CACf;AACD;EACE,qCAAqC;EACrC,yDAAyD;EACzD,iDAAiD;EACjD,4CAA4C;CAC7C;AACD;EACE,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;EACrC,wBAAwB;EACxB,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,qCAAqC;CACtC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,qCAAqC;EACrC,wBAAwB;EACxB,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,qCAAqC;CACtC;AACD;EACE,kBAAkB;CACnB",file:"PfModal.css",sourcesContent:["\n.textTitleMain[data-v-6fd46207] {\n  padding-top: 15px;\n  padding-bottom: 15px;\n  font-size: 18px;\n  color: white;\n}\n.closeModalMain[data-v-6fd46207]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.modal-maskMain[data-v-6fd46207] {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: table;\n  -webkit-transition: opacity .3s ease;\n  transition: opacity .3s ease;\n}\n.modal-wrapperMain[data-v-6fd46207] {\n  display: table-cell;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: auto !important;\n}\n.modal-containerMain[data-v-6fd46207] {\n  width: 65%;\n  margin: 30px auto;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  /* padding-bottom: 30px */\n}\n\n/* UBOLD CLASSES */\n.headerUbold[data-v-6fd46207]{\n  background-color: unset !important;\n  border-bottom: 1px solid #dee2e6 !important;\n}\n.container-mainUbold[data-v-6fd46207]{\n  border-radius: 0.2rem !important;\n}\n.titleUbold[data-v-6fd46207]{\n  /* margin-bottom: -4px; */\n  /* color: #343a40; */\n  font-size: 18px;\n}\n.closeUbold[data-v-6fd46207]{\n  font-size: 14px;\n  /* color: #6c757d; */\n  margin-top: 3px;\n}\n.closeUbold[data-v-6fd46207]:hover{\n  /* color: #343a40; */\n  font-weight: bold;\n}\n.hrUboldFooter[data-v-6fd46207]{\n  background-color: unset !important;\n  border-top: 1px solid #dee2e6;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  margin-bottom: 13px;\n}\n@media (max-width: 991px) {\n.modal-containerMain[data-v-6fd46207] {\n    width: 95%;\n}\n}\n.modal-enter[data-v-6fd46207] {\n  opacity: 0;\n}\n.modal-leave-active[data-v-6fd46207] {\n  opacity: 0;\n}\n.modal-enter .modal-containerMain[data-v-6fd46207],\n.modal-leave-active .modal-containerMain[data-v-6fd46207] {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n.myContainerMain[data-v-6fd46207] {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n}\ndiv.toolbox-tab-container[data-v-6fd46207] {\n  background-color: white;\n  padding: 0 !important;\n  -moz-border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n  opacity: 0.97;\n  filter: alpha(opacity=97);\n}\ndiv.toolbox-tab-menuMain div.list-group[data-v-6fd46207] {\n  margin-bottom: 0;\n}\ndiv.toolbox-tab-menuMain div.list-group > a[data-v-6fd46207] {\n  color: #000;\n}\ndiv.toolbox-tab-menuMain div.list-group > a[data-v-6fd46207]:first-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menuMain div.list-group > a[data-v-6fd46207]:last-child {\n  border-radius: 0px !important;\n  /* border: $border-1px  */\n}\ndiv.toolbox-tab-menuMain div.list-group > a.active[data-v-6fd46207],\ndiv.toolbox-tab-menuMain div.list-group > a.active .glyphicon[data-v-6fd46207],\ndiv.toolbox-tab-menuMain div.list-group > a.active .fa[data-v-6fd46207] {\n  color: black !important;\n  font-weight: bold;\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-content[data-v-6fd46207] {\n  padding-left: 0px;\n  padding-top: 0px;\n  margin-bottom: -32px;\n}\ndiv.toolbox-tab div.toolbox-tab-content[data-v-6fd46207]:not(.active) {\n  display: none;\n}\n.list-group[data-v-6fd46207] {\n  display: -webkit-inline-box;\n  -webkit-box-orient: horizontal;\n  font-size: 0.875rem;\n}\n.positionForm[data-v-6fd46207] {\n  z-index: 4 !important;\n}\n.positionContact[data-v-6fd46207] {\n  margin-left: 18px !important;\n  z-index: 3 !important;\n}\ndiv.toolbox-tab-menu div.list-group > a.positionContact.active[data-v-6fd46207] {\n  margin-left: 18px;\n}\n.headerModalMain[data-v-6fd46207] {\n  margin-top: -2px;\n  top: -2px;\n  z-index: 99;\n}\n.mrHr[data-v-6fd46207] {\n  margin-top: 5px;\n  background-color: grey;\n  height: 2px;\n  margin-left: 15px;\n  margin-right: 15px;\n}\n.mrHrUbold[data-v-6fd46207] {\n  margin-top: 5px;\n  background-color: #dee2e6;\n  height: 0.5px;\n}\n.colorHeaderModal[data-v-6fd46207] {\n  background-color: #38414a !important;\n  -webkit-box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);\n  box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15);\n  border-bottom: 1px solid #dee2e6 !important;\n}\n.formGeneralInfor[data-v-6fd46207] {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.paddingR0[data-v-6fd46207] {\n  padding-right: 0px !important;\n}\n.marginRightSpace[data-v-6fd46207] {\n  margin-right: -8px;\n}\n.btnLeft[data-v-6fd46207] {\n  padding: 0.15rem 0.5rem;\n  margin-bottom: 15px;\n  font-size: 12px;\n  background-color: #35aa47 !important;\n  color: white !important;\n  border-radius: 0px;\n}\n.btnLeft[data-v-6fd46207]:hover {\n  color: white;\n  background-color: #2b8b3a !important;\n}\n.btnRight[data-v-6fd46207] {\n  padding: 0.15rem 0.5rem;\n  margin-bottom: 15px;\n  font-size: 12px;\n  background-color: #35aa47 !important;\n  color: white !important;\n  border-radius: 0px;\n}\n.btnRight[data-v-6fd46207]:hover {\n  color: white;\n  background-color: #2b8b3a !important;\n}\ninput:checked + label[data-v-6fd46207] {\n  font-weight: bold;\n}\n"],sourceRoot:""}])},ZFGz:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("cy",{months:"Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split("_"),monthsShort:"Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),weekdays:"Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split("_"),weekdaysShort:"Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),weekdaysMin:"Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Heddiw am] LT",nextDay:"[Yfory am] LT",nextWeek:"dddd [am] LT",lastDay:"[Ddoe am] LT",lastWeek:"dddd [diwethaf am] LT",sameElse:"L"},relativeTime:{future:"mewn %s",past:"%s yn ôl",s:"ychydig eiliadau",ss:"%d eiliad",m:"munud",mm:"%d munud",h:"awr",hh:"%d awr",d:"diwrnod",dd:"%d diwrnod",M:"mis",MM:"%d mis",y:"blwyddyn",yy:"%d flynedd"},dayOfMonthOrdinalParse:/\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,ordinal:function(t){var e="";return t>20?e=40===t||50===t||60===t||80===t||100===t?"fed":"ain":t>0&&(e=["","af","il","ydd","ydd","ed","ed","ed","fed","fed","fed","eg","fed","eg","eg","fed","eg","eg","fed","eg","fed"][t]),t+e},week:{dow:1,doy:4}})})(n("PJh5"))},ZU6n:function(t,e){t.exports="data:image/gif;base64,R0lGODlhCgAMAMQUAFZWVoiIiOLi4nx8fF1dXePj41JSUqioqKCgoF9fX8TExG1tbcnJyUtLS2tra1VVVcXFxU5OTvT09FdXV/r6+gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTQgNzkuMTUxNDgxLCAyMDEzLzAzLzEzLTEyOjA5OjE1ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjY5ODdFQzFEQTkxMzExRTM5MjMyQUJCQTBBRDNBQ0ZEIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjY5ODdFQzFFQTkxMzExRTM5MjMyQUJCQTBBRDNBQ0ZEIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Njk4N0VDMUJBOTEzMTFFMzkyMzJBQkJBMEFEM0FDRkQiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6Njk4N0VDMUNBOTEzMTFFMzkyMzJBQkJBMEFEM0FDRkQiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQBAAAUACwAAAAACgAMAAAFL+AgUGRJGhEimeQERInCTvTTiCWtoyql66/Y7+eADCeEw2oYKORoC8YsuWI1WaUQADs="},ZUOV:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-2b3201c5]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-2b3201c5]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-2b3201c5]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-2b3201c5]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-2b3201c5] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-2b3201c5]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-2b3201c5] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-2b3201c5]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-2b3201c5]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-2b3201c5]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-2b3201c5]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-2b3201c5]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-2b3201c5]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-2b3201c5] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-2b3201c5]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-2b3201c5] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-2b3201c5]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-2b3201c5]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},ZUyn:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("zh-hk",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日 HH:mm",LLLL:"YYYY年M月D日dddd HH:mm",l:"YYYY/M/D",ll:"YYYY年M月D日",lll:"YYYY年M月D日 HH:mm",llll:"YYYY年M月D日dddd HH:mm"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(t,e){return 12===t&&(t=0),"凌晨"===e||"早上"===e||"上午"===e?t:"中午"===e?t>=11?t:t+12:"下午"===e||"晚上"===e?t+12:void 0},meridiem:function(t,e,n){var i=100*t+e;return i<600?"凌晨":i<900?"早上":i<1200?"上午":1200===i?"中午":i<1800?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},dayOfMonthOrdinalParse:/\d{1,2}(日|月|週)/,ordinal:function(t,e){switch(e){case"d":case"D":case"DDD":return t+"日";case"M":return t+"月";case"w":case"W":return t+"週";default:return t}},relativeTime:{future:"%s後",past:"%s前",s:"幾秒",ss:"%d 秒",m:"1 分鐘",mm:"%d 分鐘",h:"1 小時",hh:"%d 小時",d:"1 天",dd:"%d 天",M:"1 個月",MM:"%d 個月",y:"1 年",yy:"%d 年"}})})(n("PJh5"))},Zbun:function(t,e,n){var i=n("iANj"),a=i.JSON||(i.JSON={stringify:JSON.stringify});t.exports=function(t){return a.stringify.apply(a,arguments)}},ZhOs:function(t,e,n){n("rZAI"),t.exports=n("iANj").Object.keys},ZjJ6:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfJob.css",sourceRoot:""}])},ZoSI:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("pt",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split("_"),weekdaysShort:"Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),weekdaysMin:"Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY HH:mm",LLLL:"dddd, D [de] MMMM [de] YYYY HH:mm"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"segundos",ss:"%d segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",w:"uma semana",ww:"%d semanas",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})(n("PJh5"))},Zoe1:function(t,e,n){"use strict";var i=n("7ar3"),a=n("gcUb"),o=n("GybJ"),r=i("%TypeError%"),s=i("%WeakMap%",!0),l=i("%Map%",!0),d=a("WeakMap.prototype.get",!0),c=a("WeakMap.prototype.set",!0),h=a("WeakMap.prototype.has",!0),u=a("Map.prototype.get",!0),m=a("Map.prototype.set",!0),f=a("Map.prototype.has",!0),p=function(t,e){for(var n,i=t;null!==(n=i.next);i=n)if(n.key===e)return i.next=n.next,n.next=t.next,t.next=n,n};t.exports=function(){var t,e,n,i={assert:function(t){if(!i.has(t))throw new r("Side channel does not contain "+o(t))},get:function(i){if(s&&i&&("object"==typeof i||"function"==typeof i)){if(t)return d(t,i)}else if(l){if(e)return u(e,i)}else if(n)return function(t,e){var n=p(t,e);return n&&n.value}(n,i)},has:function(i){if(s&&i&&("object"==typeof i||"function"==typeof i)){if(t)return h(t,i)}else if(l){if(e)return f(e,i)}else if(n)return function(t,e){return!!p(t,e)}(n,i);return!1},set:function(i,a){s&&i&&("object"==typeof i||"function"==typeof i)?(t||(t=new s),c(t,i,a)):l?(e||(e=new l),m(e,i,a)):(n||(n={key:{},next:null}),function(t,e,n){var i=p(t,e);i?i.value=n:t.next={key:e,next:t.next,value:n}}(n,i,a))}};return i}},Zrlr:function(t,e,n){"use strict";e.__esModule=!0,e.default=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},Zzip:function(t,e,n){t.exports={default:n("BQO6"),__esModule:!0}},"a/OS":function(t,e,n){var i=n("iANj"),a=n("YjQv"),o=a["__core-js_shared__"]||(a["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n("c8Kh")?"pure":"global",copyright:"© 2020 Denis Pushkarev (zloirock.ru)"})},a1ra:function(t,e,n){var i=n("Tbn5");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("3b0602d6",i,!0,{})},"a9+9":function(t,e,n){var i=n("ttEU");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("c5ab51c4",i,!0,{})},"aG/u":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-3638aff0]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-3638aff0]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-3638aff0]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-3638aff0]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-3638aff0] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-3638aff0]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-3638aff0] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-3638aff0]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-3638aff0]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-3638aff0]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-3638aff0]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-3638aff0]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-3638aff0]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-3638aff0] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-3638aff0]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-3638aff0] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-3638aff0]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-3638aff0]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},aLzV:function(t,e,n){var i=n("GCs6"),a=n("YTz9");t.exports=n("qs+f")?function(t,e,n){return i.f(t,e,a(1,n))}:function(t,e,n){return t[e]=n,t}},aM0x:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"১",2:"২",3:"৩",4:"৪",5:"৫",6:"৬",7:"৭",8:"৮",9:"৯",0:"০"},n={"১":"1","২":"2","৩":"3","৪":"4","৫":"5","৬":"6","৭":"7","৮":"8","৯":"9","০":"0"};t.defineLocale("bn",{months:"জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),monthsShort:"জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),weekdays:"রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),weekdaysShort:"রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),weekdaysMin:"রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),longDateFormat:{LT:"A h:mm সময়",LTS:"A h:mm:ss সময়",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm সময়",LLLL:"dddd, D MMMM YYYY, A h:mm সময়"},calendar:{sameDay:"[আজ] LT",nextDay:"[আগামীকাল] LT",nextWeek:"dddd, LT",lastDay:"[গতকাল] LT",lastWeek:"[গত] dddd, LT",sameElse:"L"},relativeTime:{future:"%s পরে",past:"%s আগে",s:"কয়েক সেকেন্ড",ss:"%d সেকেন্ড",m:"এক মিনিট",mm:"%d মিনিট",h:"এক ঘন্টা",hh:"%d ঘন্টা",d:"এক দিন",dd:"%d দিন",M:"এক মাস",MM:"%d মাস",y:"এক বছর",yy:"%d বছর"},preparse:function(t){return t.replace(/[১২৩৪৫৬৭৮৯০]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/রাত|সকাল|দুপুর|বিকাল|রাত/,meridiemHour:function(t,e){return 12===t&&(t=0),"রাত"===e&&t>=4||"দুপুর"===e&&t<5||"বিকাল"===e?t+12:t},meridiem:function(t,e,n){return t<4?"রাত":t<10?"সকাল":t<17?"দুপুর":t<20?"বিকাল":"রাত"},week:{dow:0,doy:6}})})(n("PJh5"))},aYJh:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfPassport.css",sourceRoot:""}])},abPz:function(t,e,n){"use strict";var i=n("Aq0r"),a=n("beh1"),o=n("yYxz"),r=n("ksFB");t.exports=n("4dmN")(Array,"Array",function(t,e){this._t=r(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,a(1)):a(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},abwx:function(t,e,n){var i=n("cG3R");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("863c252e",i,!0,{})},aqvp:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n){var i=t+" ";switch(n){case"ss":return i+=1===t?"sekunda":2===t||3===t||4===t?"sekunde":"sekundi";case"m":return e?"jedna minuta":"jedne minute";case"mm":return i+=1===t?"minuta":2===t||3===t||4===t?"minute":"minuta";case"h":return e?"jedan sat":"jednog sata";case"hh":return i+=1===t?"sat":2===t||3===t||4===t?"sata":"sati";case"dd":return i+=1===t?"dan":"dana";case"MM":return i+=1===t?"mjesec":2===t||3===t||4===t?"mjeseca":"mjeseci";case"yy":return i+=1===t?"godina":2===t||3===t||4===t?"godine":"godina"}}t.defineLocale("bs",{months:"januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",ss:e,m:e,mm:e,h:e,hh:e,d:"dan",dd:e,M:"mjesec",MM:e,y:"godinu",yy:e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})(n("PJh5"))},b8JJ:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.myLabel[data-v-1791480a]::before {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  display: block;\n  width: 18px;\n  height: 18px;\n  border-radius: 3px !important;\n  content: "";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color:#fff;\n  border: 2px solid#98a6ad;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myCheck .myInput:checked ~ .myLabel[data-v-1791480a]::before {\n  background-color:#1abc9c;\n  border-color:#1abc9c;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myInputUpdated:checked ~ .myLabel[data-v-1791480a]::before {\n  background-color: #007bff !important;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myInputPrueba:checked ~ .myLabel[data-v-1791480a]::before {\n  border: 1px solid green !important;\n  background-color: #61bf61 !important;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myInputPrueba2:checked ~ .myLabel[data-v-1791480a]::before {\n  border: 1px solid #032ba2 !important;\n  background-color: #5aa0e9 !important;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myCheck .myLabel[data-v-1791480a]::before {\n  border-radius: 0.25rem;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myCheck .myInput:checked ~ .myLabel[data-v-1791480a]::after {\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n  content: "";\n  position: absolute;\n  top: 6px;\n  left: 7.3px;\n  display: table;\n  width: 4px;\n  height: 8px;\n  border: 2px solid#6c757d !important;\n  border-width: 0px 2px 2px 0px !important;\n  border-style: solid !important;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  border-color:#fff !important;\n}\n.myLabel[data-v-1791480a]::after {\n  position: absolute;\n  top: 0.25rem;\n  left: 0;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: "";\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 50% 50%;\n}\n.myInput[data-v-1791480a] {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n.myLabel[data-v-1791480a] {\n  margin-left: 5px;\n  cursor: pointer;\n}\n.inputLine:checked + .line-through[data-v-1791480a] {\n  color: #34bf6e !important;\n  text-decoration: line-through !important;\n}\ninput:checked + label[data-v-1791480a] {\n  font-weight: bold !important;\n}\n.classInline[data-v-1791480a] {\n  display: inline;\n}\n.classInline-block[data-v-1791480a] {\n  display: inline-block;\n  margin-top: 3px;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfCheckbox/PfCheckbox.css"],names:[],mappings:";AACA;EACE,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,qCAAqC;EACrC,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,mCAAmC;EACnC,qCAAqC;EACrC,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,uBAAuB;EACvB,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yCAAyC;EACzC,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;EACzB,6BAA6B;CAC9B;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,yBAAyB;CAC1B;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;CACZ;AACD;EACE,iBAAiB;EACjB,gBAAgB;CACjB;AACD;EACE,0BAA0B;EAC1B,yCAAyC;CAC1C;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,gBAAgB;CACjB;AACD;EACE,sBAAsB;EACtB,gBAAgB;CACjB",file:"PfCheckbox.css",sourcesContent:['\n.myLabel[data-v-1791480a]::before {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  display: block;\n  width: 18px;\n  height: 18px;\n  border-radius: 3px !important;\n  content: "";\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color:#fff;\n  border: 2px solid#98a6ad;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myCheck .myInput:checked ~ .myLabel[data-v-1791480a]::before {\n  background-color:#1abc9c;\n  border-color:#1abc9c;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myInputUpdated:checked ~ .myLabel[data-v-1791480a]::before {\n  background-color: #007bff !important;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myInputPrueba:checked ~ .myLabel[data-v-1791480a]::before {\n  border: 1px solid green !important;\n  background-color: #61bf61 !important;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myInputPrueba2:checked ~ .myLabel[data-v-1791480a]::before {\n  border: 1px solid #032ba2 !important;\n  background-color: #5aa0e9 !important;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myCheck .myLabel[data-v-1791480a]::before {\n  border-radius: 0.25rem;\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n}\n.myCheck .myInput:checked ~ .myLabel[data-v-1791480a]::after {\n  -webkit-transition: all 0.2s linear;\n  transition: all 0.2s linear;\n  content: "";\n  position: absolute;\n  top: 6px;\n  left: 7.3px;\n  display: table;\n  width: 4px;\n  height: 8px;\n  border: 2px solid#6c757d !important;\n  border-width: 0px 2px 2px 0px !important;\n  border-style: solid !important;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  border-color:#fff !important;\n}\n.myLabel[data-v-1791480a]::after {\n  position: absolute;\n  top: 0.25rem;\n  left: 0;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: "";\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 50% 50%;\n}\n.myInput[data-v-1791480a] {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n.myLabel[data-v-1791480a] {\n  margin-left: 5px;\n  cursor: pointer;\n}\n.inputLine:checked + .line-through[data-v-1791480a] {\n  color: #34bf6e !important;\n  text-decoration: line-through !important;\n}\ninput:checked + label[data-v-1791480a] {\n  font-weight: bold !important;\n}\n.classInline[data-v-1791480a] {\n  display: inline;\n}\n.classInline-block[data-v-1791480a] {\n  display: inline-block;\n  margin-top: 3px;\n}\n'],sourceRoot:""}])},bA4O:function(t,e,n){var i=n("Jneh");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("17b29e55",i,!0,{})},bAUi:function(t,e,n){var i=n("Wj3+");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("a1418df0",i,!0,{})},bE1x:function(t,e,n){var i=n("+3MK");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("6cdd6f6a",i,!0,{})},bOdI:function(t,e,n){"use strict";e.__esModule=!0;var i,a=n("C4MV"),o=(i=a)&&i.__esModule?i:{default:i};e.default=function(t,e,n){return e in t?(0,o.default)(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}},bSeU:function(t,e){e.f={}.propertyIsEnumerable},bXQP:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("fr-ca",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsParseExact:!0,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|e)/,ordinal:function(t,e){switch(e){default:case"M":case"Q":case"D":case"DDD":case"d":return t+(1===t?"er":"e");case"w":case"W":return t+(1===t?"re":"e")}}})})(n("PJh5"))},beh1:function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},bz2F:function(t,e,n){var i=n("HC5+");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("13259734",i,!0,{})},c1x4:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={words:{ss:["секунда","секунде","секунди"],m:["један минут","једне минуте"],mm:["минут","минуте","минута"],h:["један сат","једног сата"],hh:["сат","сата","сати"],dd:["дан","дана","дана"],MM:["месец","месеца","месеци"],yy:["година","године","година"]},correctGrammaticalCase:function(t,e){return 1===t?e[0]:t>=2&&t<=4?e[1]:e[2]},translate:function(t,n,i){var a=e.words[i];return 1===i.length?n?a[0]:a[1]:t+" "+e.correctGrammaticalCase(t,a)}};t.defineLocale("sr-cyrl",{months:"јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split("_"),monthsShort:"јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split("_"),monthsParseExact:!0,weekdays:"недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),weekdaysShort:"нед._пон._уто._сре._чет._пет._суб.".split("_"),weekdaysMin:"не_по_ут_ср_че_пе_су".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D. M. YYYY.",LL:"D. MMMM YYYY.",LLL:"D. MMMM YYYY. H:mm",LLLL:"dddd, D. MMMM YYYY. H:mm"},calendar:{sameDay:"[данас у] LT",nextDay:"[сутра у] LT",nextWeek:function(){switch(this.day()){case 0:return"[у] [недељу] [у] LT";case 3:return"[у] [среду] [у] LT";case 6:return"[у] [суботу] [у] LT";case 1:case 2:case 4:case 5:return"[у] dddd [у] LT"}},lastDay:"[јуче у] LT",lastWeek:function(){return["[прошле] [недеље] [у] LT","[прошлог] [понедељка] [у] LT","[прошлог] [уторка] [у] LT","[прошле] [среде] [у] LT","[прошлог] [четвртка] [у] LT","[прошлог] [петка] [у] LT","[прошле] [суботе] [у] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"за %s",past:"пре %s",s:"неколико секунди",ss:e.translate,m:e.translate,mm:e.translate,h:e.translate,hh:e.translate,d:"дан",dd:e.translate,M:"месец",MM:e.translate,y:"годину",yy:e.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})(n("PJh5"))},c8Kh:function(t,e){t.exports=!0},cDpM:function(t,e){t.exports="data:image/gif;base64,R0lGODlhtgAJAOf/AAAAAAEBAQICAgMDAwQEBAUFBQYGBgcHBwgICAkJCQoKCgsLCwwMDA0NDQ4ODg8PDxAQEBERERISEhMTExQUFBUVFRYWFhcXFxgYGBkZGRoaGhsbGxwcHB0dHR4eHh8fHyAgICEhISIiIiMjIyQkJCUlJSYmJicnJygoKCkpKSoqKisrKywsLC0tLS4uLi8vLzAwMDExMTIyMjMzMzQ0NDU1NTY2Njc3Nzg4ODk5OTo6Ojs7Ozw8PD09PT4+Pj8/P0BAQEFBQUJCQkNDQ0REREVFRUZGRkdHR0hISElJSUpKSktLS0xMTE1NTU5OTk9PT1BQUFFRUVJSUlNTU1RUVFVVVVZWVldXV1hYWFlZWVpaWltbW1xcXF1dXV5eXl9fX2BgYGFhYWJiYmNjY2RkZGVlZWZmZmdnZ2hoaGlpaWpqamtra2xsbG1tbW5ubm9vb3BwcHFxcXJycnNzc3R0dHV1dXZ2dnd3d3h4eHl5eXp6ent7e3x8fH19fX5+fn9/f4CAgIGBgYKCgoODg4SEhIWFhYaGhoeHh4iIiImJiYqKiouLi4yMjI2NjY6Ojo+Pj5CQkJGRkZKSkpOTk5SUlJWVlZaWlpeXl5iYmJmZmZqampubm5ycnJ2dnZ6enp+fn6CgoKGhoaKioqOjo6SkpKWlpaampqenp6ioqKmpqaqqqqurq6ysrK2tra6urq+vr7CwsLGxsbKysrOzs7S0tLW1tba2tre3t7i4uLm5ubq6uru7u7y8vL29vb6+vr+/v8DAwMHBwcLCwsPDw8TExMXFxcbGxsfHx8jIyMnJycrKysvLy8zMzM3Nzc7Ozs/Pz9DQ0NHR0dLS0tPT09TU1NXV1dbW1tfX19jY2NnZ2dra2tvb29zc3N3d3d7e3t/f3+Dg4OHh4eLi4uPj4+Tk5OXl5ebm5ufn5+jo6Onp6erq6uvr6+zs7O3t7e7u7u/v7/Dw8PHx8fLy8vPz8/T09PX19fb29vf39/j4+Pn5+fr6+vv7+/z8/P39/f7+/v///yH5BAEKAP8ALAAAAAC2AAkAAAh0AP8JHEiwoMGDCBMqXMiQ4a2GECNKnEixosWLGAveavcwo8ePIEOK9LixHceRKFOqXHmxpMmTLGPKnJnS5UuYNHPq3Onwps+OPIMKzWnTp0mgQ5MqDVnU6NGlMrtJnUq1qtWrWLNq3cq1qtOvXcOKHUs2a0AAOw=="},cDwS:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfFields.css",sourceRoot:""}])},cEvV:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-8bc96722] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-8bc96722]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-8bc96722] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-8bc96722] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-8bc96722] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-8bc96722] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-8bc96722] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-8bc96722] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-8bc96722] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-8bc96722] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-8bc96722] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-8bc96722] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-8bc96722] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-8bc96722] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-8bc96722] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-8bc96722] {\n  margin-right: 0px;\n}\n.newItem[data-v-8bc96722] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-8bc96722] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-8bc96722] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-8bc96722] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-8bc96722] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-8bc96722] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-8bc96722] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-8bc96722] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-8bc96722] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-8bc96722] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-8bc96722]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-8bc96722] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-8bc96722] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-8bc96722] {\n  color: red;\n}\n.showMore[data-v-8bc96722]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-8bc96722] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-8bc96722] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-8bc96722] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-8bc96722 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-8bc96722 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-8bc96722] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-8bc96722 3s infinite;\n  animation: bit-data-v-8bc96722 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-8bc96722] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-8bc96722]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-8bc96722]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-8bc96722]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-8bc96722]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-8bc96722]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-8bc96722]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-8bc96722] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-8bc96722]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-8bc96722] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-8bc96722] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-8bc96722] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-8bc96722] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-8bc96722] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-8bc96722] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-8bc96722] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-8bc96722] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-8bc96722] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-8bc96722] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-8bc96722] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-8bc96722] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-8bc96722] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-8bc96722] {\n  margin-right: 0px;\n}\n.newItem[data-v-8bc96722] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-8bc96722] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-8bc96722] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-8bc96722] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-8bc96722] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-8bc96722] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-8bc96722] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-8bc96722] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-8bc96722] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-8bc96722] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-8bc96722]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-8bc96722] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-8bc96722] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-8bc96722] {\n  color: red;\n}\n.showMore[data-v-8bc96722]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-8bc96722] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-8bc96722] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-8bc96722] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-8bc96722 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-8bc96722 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-8bc96722] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-8bc96722 3s infinite;\n  animation: bit-data-v-8bc96722 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-8bc96722] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-8bc96722]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-8bc96722]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-8bc96722]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-8bc96722]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-8bc96722]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-8bc96722]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},cG3R:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-6c48ec47]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-6c48ec47]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6c48ec47]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6c48ec47]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-6c48ec47] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-6c48ec47]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-6c48ec47] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-6c48ec47]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-6c48ec47]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-6c48ec47]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-6c48ec47]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6c48ec47]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-6c48ec47]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-6c48ec47] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-6c48ec47]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-6c48ec47] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-6c48ec47]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-6c48ec47]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},cGG2:function(t,e,n){"use strict";var i=n("JP+z"),a=n("Re3r"),o=Object.prototype.toString;function r(t){return"[object Array]"===o.call(t)}function s(t){return null!==t&&"object"==typeof t}function l(t){return"[object Function]"===o.call(t)}function d(t,e){if(null!==t&&void 0!==t)if("object"!=typeof t&&(t=[t]),r(t))for(var n=0,i=t.length;n<i;n++)e.call(null,t[n],n,t);else for(var a in t)Object.prototype.hasOwnProperty.call(t,a)&&e.call(null,t[a],a,t)}t.exports={isArray:r,isArrayBuffer:function(t){return"[object ArrayBuffer]"===o.call(t)},isBuffer:a,isFormData:function(t){return"undefined"!=typeof FormData&&t instanceof FormData},isArrayBufferView:function(t){return"undefined"!=typeof ArrayBuffer&&ArrayBuffer.isView?ArrayBuffer.isView(t):t&&t.buffer&&t.buffer instanceof ArrayBuffer},isString:function(t){return"string"==typeof t},isNumber:function(t){return"number"==typeof t},isObject:s,isUndefined:function(t){return void 0===t},isDate:function(t){return"[object Date]"===o.call(t)},isFile:function(t){return"[object File]"===o.call(t)},isBlob:function(t){return"[object Blob]"===o.call(t)},isFunction:l,isStream:function(t){return s(t)&&l(t.pipe)},isURLSearchParams:function(t){return"undefined"!=typeof URLSearchParams&&t instanceof URLSearchParams},isStandardBrowserEnv:function(){return("undefined"==typeof navigator||"ReactNative"!==navigator.product)&&"undefined"!=typeof window&&"undefined"!=typeof document},forEach:d,merge:function t(){var e={};function n(n,i){"object"==typeof e[i]&&"object"==typeof n?e[i]=t(e[i],n):e[i]=n}for(var i=0,a=arguments.length;i<a;i++)d(arguments[i],n);return e},extend:function(t,e,n){return d(e,function(e,a){t[a]=n&&"function"==typeof e?i(e,n):e}),t},trim:function(t){return t.replace(/^\s*/,"").replace(/\s*$/,"")}}},cOrP:function(t,e,n){var i=n("XvJ3");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("039ce1d1",i,!0,{})},cWxy:function(t,e,n){"use strict";var i=n("dVOP");function a(t){if("function"!=typeof t)throw new TypeError("executor must be a function.");var e;this.promise=new Promise(function(t){e=t});var n=this;t(function(t){n.reason||(n.reason=new i(t),e(n.reason))})}a.prototype.throwIfRequested=function(){if(this.reason)throw this.reason},a.source=function(){var t;return{token:new a(function(e){t=e}),cancel:t}},t.exports=a},clUQ:function(t,e,n){var i=n("UCqt");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("69b5298e",i,!0,{})},cuW7:function(t,e,n){var i=n("5pPm");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("4d0b77b6",i,!0,{})},d7oi:function(t,e,n){var i=n("gGQ7");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("1988b716",i,!0,{})},dCCA:function(t,e,n){var i=n("YseS");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("ffc5a3dc",i,!0,{})},dIwP:function(t,e,n){"use strict";t.exports=function(t){return/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t)}},dJ18:function(t,e,n){var i=n("w49j");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("fe32d7fc",i,!0,{})},dOPq:function(t,e){t.exports="data:image/gif;base64,R0lGODlhDQANAKUiAEGi5IzH7u72/Gq26a7X8+r1/LTa9HG56pTK8Lve9dTq+WCx6Eil5U6o5VWs51it58bj95DJ71as50Ch42236kim5a7Y81Sr5sjk9+fz/Ov1/Ofz+1Or5ovG7rPa9Gu26rze9Uel5P///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////yH5BAEKAD8ALAAAAAANAA0AAAZNwJ/wByqICqDh0JIJ/Dy/QMYy9GCUQwz0t1FGlN1ER7kVBkACrAKrERmUIqVBlMZClBrQGIsQdpJdWEOBBFeCGARLGWNQHVOCIG15SkEAOw=="},dURR:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ar-ma",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:1,doy:4}})})(n("PJh5"))},dVOP:function(t,e,n){"use strict";function i(t){this.message=t}i.prototype.toString=function(){return"Cancel"+(this.message?": "+this.message:"")},i.prototype.__CANCEL__=!0,t.exports=i},dudK:function(t,e,n){var i=n("3fMt"),a=n("tn1D"),o=n("yuYM"),r=n("FKWp"),s=n("GhAV"),l=n("1yV6"),d={},c={};(e=t.exports=function(t,e,n,h,u){var m,f,p,_,A=u?function(){return t}:l(t),b=i(n,h,e?2:1),x=0;if("function"!=typeof A)throw TypeError(t+" is not iterable!");if(o(A)){for(m=s(t.length);m>x;x++)if((_=e?b(r(f=t[x])[0],f[1]):b(t[x]))===d||_===c)return _}else for(p=A.call(t);!(f=p.next()).done;)if((_=a(p,b,f.value,e))===d||_===c)return _}).BREAK=d,e.RETURN=c},dyB6:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("en-nz",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")},week:{dow:1,doy:4}})})(n("PJh5"))},"e/KL":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("x-pseudo",{months:"J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér".split("_"),monthsShort:"J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc".split("_"),monthsParseExact:!0,weekdays:"S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý".split("_"),weekdaysShort:"S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát".split("_"),weekdaysMin:"S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[T~ódá~ý át] LT",nextDay:"[T~ómó~rró~w át] LT",nextWeek:"dddd [át] LT",lastDay:"[Ý~ést~érdá~ý át] LT",lastWeek:"[L~ást] dddd [át] LT",sameElse:"L"},relativeTime:{future:"í~ñ %s",past:"%s á~gó",s:"á ~féw ~sécó~ñds",ss:"%d s~écóñ~ds",m:"á ~míñ~úté",mm:"%d m~íñú~tés",h:"á~ñ hó~úr",hh:"%d h~óúrs",d:"á ~dáý",dd:"%d d~áýs",M:"á ~móñ~th",MM:"%d m~óñt~hs",y:"á ~ýéár",yy:"%d ý~éárs"},dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")},week:{dow:1,doy:4}})})(n("PJh5"))},"eBB/":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ko",{months:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),monthsShort:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),weekdays:"일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),weekdaysShort:"일_월_화_수_목_금_토".split("_"),weekdaysMin:"일_월_화_수_목_금_토".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY년 MMMM D일",LLL:"YYYY년 MMMM D일 A h:mm",LLLL:"YYYY년 MMMM D일 dddd A h:mm",l:"YYYY.MM.DD.",ll:"YYYY년 MMMM D일",lll:"YYYY년 MMMM D일 A h:mm",llll:"YYYY년 MMMM D일 dddd A h:mm"},calendar:{sameDay:"오늘 LT",nextDay:"내일 LT",nextWeek:"dddd LT",lastDay:"어제 LT",lastWeek:"지난주 dddd LT",sameElse:"L"},relativeTime:{future:"%s 후",past:"%s 전",s:"몇 초",ss:"%d초",m:"1분",mm:"%d분",h:"한 시간",hh:"%d시간",d:"하루",dd:"%d일",M:"한 달",MM:"%d달",y:"일 년",yy:"%d년"},dayOfMonthOrdinalParse:/\d{1,2}(일|월|주)/,ordinal:function(t,e){switch(e){case"d":case"D":case"DDD":return t+"일";case"M":return t+"월";case"w":case"W":return t+"주";default:return t}},meridiemParse:/오전|오후/,isPM:function(t){return"오후"===t},meridiem:function(t,e,n){return t<12?"오전":"오후"}})})(n("PJh5"))},eHwN:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"-inci",5:"-inci",8:"-inci",70:"-inci",80:"-inci",2:"-nci",7:"-nci",20:"-nci",50:"-nci",3:"-üncü",4:"-üncü",100:"-üncü",6:"-ncı",9:"-uncu",10:"-uncu",30:"-uncu",60:"-ıncı",90:"-ıncı"};t.defineLocale("az",{months:"yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split("_"),monthsShort:"yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),weekdays:"Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə".split("_"),weekdaysShort:"Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən".split("_"),weekdaysMin:"Bz_BE_ÇA_Çə_CA_Cü_Şə".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[sabah saat] LT",nextWeek:"[gələn həftə] dddd [saat] LT",lastDay:"[dünən] LT",lastWeek:"[keçən həftə] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s əvvəl",s:"bir neçə saniyə",ss:"%d saniyə",m:"bir dəqiqə",mm:"%d dəqiqə",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",M:"bir ay",MM:"%d ay",y:"bir il",yy:"%d il"},meridiemParse:/gecə|səhər|gündüz|axşam/,isPM:function(t){return/^(gündüz|axşam)$/.test(t)},meridiem:function(t,e,n){return t<4?"gecə":t<12?"səhər":t<17?"gündüz":"axşam"},dayOfMonthOrdinalParse:/\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,ordinal:function(t){if(0===t)return t+"-ıncı";var n=t%10;return t+(e[n]||e[t%100-n]||e[t>=100?100:null])},week:{dow:1,doy:7}})})(n("PJh5"))},"eI/k":function(t,e,n){var i=n("lclE");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("ccdd1e6a",i,!0,{})},eLUB:function(t,e,n){var i=n("x0nU");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("fce7317a",i,!0,{})},eWGY:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.label-default[data-v-3dc2c4ea] {\n    text-shadow: none !important;\n    font-size: 13px;\n    font-weight: 300;\n    padding: 3px 6px 3px 6px;\n    color: #fff;\n    font-family: "Open Sans", sans-serif;\n    background-color: #c6c6c6;\n    position: absolute;\n    right: 120px;\n}\n.footable-even2 th[data-v-3dc2c4ea] {\n    width: 200px !important;\n    background-color: #f3f7f9;\n}\n.footable-even2 td[data-v-3dc2c4ea] {\n    background-color: #f3f7f9;\n}\n.darkPrima .table tbody+tbody[data-v-3dc2c4ea] {\n    border-top: 1px solid #dee2e6 !important;\n}\n.dropdwonMenuTableGrid[data-v-3dc2c4ea] {\n    margin-top: -30px !important;\n    -webkit-animation: none !important;\n            animation: none !important;\n}\n.tox-tinymce-aux[data-v-3dc2c4ea] {\n    z-index: 9999 !important;\n}\n.dot-color[data-v-3dc2c4ea] {\n    height: 25px;\n    width: 25px;\n    border-radius: 50%;\n    display: inline-block;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfTableGrid/PfTableGrid.vue"],names:[],mappings:";AACA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,qCAAqC;IACrC,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;CAChB;AACD;IACI,wBAAwB;IACxB,0BAA0B;CAC7B;AACD;IACI,0BAA0B;CAC7B;AACD;IACI,yCAAyC;CAC5C;AACD;IACI,6BAA6B;IAC7B,mCAAmC;YAC3B,2BAA2B;CACtC;AACD;IACI,yBAAyB;CAC5B;AACD;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;CACzB",file:"PfTableGrid.vue",sourcesContent:['\n.label-default[data-v-3dc2c4ea] {\n    text-shadow: none !important;\n    font-size: 13px;\n    font-weight: 300;\n    padding: 3px 6px 3px 6px;\n    color: #fff;\n    font-family: "Open Sans", sans-serif;\n    background-color: #c6c6c6;\n    position: absolute;\n    right: 120px;\n}\n.footable-even2 th[data-v-3dc2c4ea] {\n    width: 200px !important;\n    background-color: #f3f7f9;\n}\n.footable-even2 td[data-v-3dc2c4ea] {\n    background-color: #f3f7f9;\n}\n.darkPrima .table tbody+tbody[data-v-3dc2c4ea] {\n    border-top: 1px solid #dee2e6 !important;\n}\n.dropdwonMenuTableGrid[data-v-3dc2c4ea] {\n    margin-top: -30px !important;\n    -webkit-animation: none !important;\n            animation: none !important;\n}\n.tox-tinymce-aux[data-v-3dc2c4ea] {\n    z-index: 9999 !important;\n}\n.dot-color[data-v-3dc2c4ea] {\n    height: 25px;\n    width: 25px;\n    border-radius: 50%;\n    display: inline-block;\n}\n'],sourceRoot:""}])},eg8w:function(t,e){t.exports=function(t,e,n){var i=void 0===n;switch(e.length){case 0:return i?t():t.call(n);case 1:return i?t(e[0]):t.call(n,e[0]);case 2:return i?t(e[0],e[1]):t.call(n,e[0],e[1]);case 3:return i?t(e[0],e[1],e[2]):t.call(n,e[0],e[1],e[2]);case 4:return i?t(e[0],e[1],e[2],e[3]):t.call(n,e[0],e[1],e[2],e[3])}return t.apply(n,e)}},eo2C:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero {\n  margin-bottom: 0px;\n}\n.marginBotRem {\n  margin-bottom: .5rem;\n}\n.spaceradio {\n  margin-right: 0px;\n}\n.newItem {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn {\n  opacity: 1 !important;\n}\n.fadeOut {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose:hover {\n  color: f2f2f2;\n}\n.accordion {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore {\n  margin-bottom: 16px;\n}\n.showMore {\n  color: red;\n}\n.showMore:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit 3s infinite;\n  animation: bit 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label {\n  font-weight: bold !important;\n}\n.fieldObli{\n  margin-top: -1px !important;\n}\n.BR-right{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none{\n  border-radius: 0px !important;\n}\n.BR-left{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero {\n  margin-bottom: 0px;\n}\n.marginBotRem {\n  margin-bottom: .5rem;\n}\n.spaceradio {\n  margin-right: 0px;\n}\n.newItem {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn {\n  opacity: 1 !important;\n}\n.fadeOut {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose:hover {\n  color: f2f2f2;\n}\n.accordion {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore {\n  margin-bottom: 16px;\n}\n.showMore {\n  color: red;\n}\n.showMore:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit 3s infinite;\n  animation: bit 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label {\n  font-weight: bold !important;\n}\n.fieldObli{\n  margin-top: -1px !important;\n}\n.BR-right{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none{\n  border-radius: 0px !important;\n}\n.BR-left{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},eok9:function(t,e){t.exports="data:image/gif;base64,R0lGODlh3gAJAIQUAKS+1Ki+0ai+0qm+0am/0Km/0aq/0Ku/z6y/z62/zq6/za+/zK+/zcnZ5sva5sza583b58/d6NHe6eTv/v///////////////////////////////////////////////yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAB8ALAAAAADeAAkAAAVjICCOZGmeaKqubDm9cCy3dG3feM5+fO//wKBwSCwafwCZ8gU4Op/QqHRKrVqvxOQS1sR6v+CweEzVLrvktHrNbg/NMbR7Tq/bofCJ/M7v++dme3+DhIVXSYKGiouMQomNkE8hADs="},etT9:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-6c9f16be] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6c9f16be]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6c9f16be] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6c9f16be] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6c9f16be] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6c9f16be] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6c9f16be] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6c9f16be] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6c9f16be] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6c9f16be] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6c9f16be] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6c9f16be] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6c9f16be] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6c9f16be] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6c9f16be] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6c9f16be] {\n  margin-right: 0px;\n}\n.newItem[data-v-6c9f16be] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6c9f16be] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6c9f16be] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6c9f16be] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6c9f16be] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6c9f16be] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6c9f16be] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6c9f16be] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6c9f16be] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6c9f16be] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6c9f16be]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6c9f16be] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6c9f16be] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6c9f16be] {\n  color: red;\n}\n.showMore[data-v-6c9f16be]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6c9f16be] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6c9f16be] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6c9f16be] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6c9f16be {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6c9f16be {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6c9f16be] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6c9f16be 3s infinite;\n  animation: bit-data-v-6c9f16be 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6c9f16be] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6c9f16be]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6c9f16be]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6c9f16be]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6c9f16be]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6c9f16be]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6c9f16be]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-6c9f16be] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-6c9f16be]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-6c9f16be] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-6c9f16be] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-6c9f16be] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-6c9f16be] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-6c9f16be] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-6c9f16be] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-6c9f16be] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-6c9f16be] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-6c9f16be] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-6c9f16be] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-6c9f16be] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-6c9f16be] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-6c9f16be] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-6c9f16be] {\n  margin-right: 0px;\n}\n.newItem[data-v-6c9f16be] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-6c9f16be] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-6c9f16be] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-6c9f16be] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-6c9f16be] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-6c9f16be] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-6c9f16be] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-6c9f16be] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-6c9f16be] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-6c9f16be] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-6c9f16be]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-6c9f16be] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-6c9f16be] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-6c9f16be] {\n  color: red;\n}\n.showMore[data-v-6c9f16be]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-6c9f16be] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-6c9f16be] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-6c9f16be] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-6c9f16be {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-6c9f16be {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-6c9f16be] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-6c9f16be 3s infinite;\n  animation: bit-data-v-6c9f16be 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-6c9f16be] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-6c9f16be]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-6c9f16be]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-6c9f16be]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-6c9f16be]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-6c9f16be]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-6c9f16be]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},exGp:function(t,e,n){"use strict";e.__esModule=!0;var i,a=n("//Fk"),o=(i=a)&&i.__esModule?i:{default:i};e.default=function(t){return function(){var e=t.apply(this,arguments);return new o.default(function(t,n){return function i(a,r){try{var s=e[a](r),l=s.value}catch(t){return void n(t)}if(!s.done)return o.default.resolve(l).then(function(t){i("next",t)},function(t){i("throw",t)});t(l)}("next")})}}},f4W3:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={words:{ss:["sekunda","sekunde","sekundi"],m:["jedan minut","jedne minute"],mm:["minut","minute","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mesec","meseca","meseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(t,e){return 1===t?e[0]:t>=2&&t<=4?e[1]:e[2]},translate:function(t,n,i){var a=e.words[i];return 1===i.length?n?a[0]:a[1]:t+" "+e.correctGrammaticalCase(t,a)}};t.defineLocale("sr",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sre._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D. M. YYYY.",LL:"D. MMMM YYYY.",LLL:"D. MMMM YYYY. H:mm",LLLL:"dddd, D. MMMM YYYY. H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",lastWeek:function(){return["[prošle] [nedelje] [u] LT","[prošlog] [ponedeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",ss:e.translate,m:e.translate,mm:e.translate,h:e.translate,hh:e.translate,d:"dan",dd:e.translate,M:"mesec",MM:e.translate,y:"godinu",yy:e.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})(n("PJh5"))},f5S2:function(t,e,n){var i=n("VFNX");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("4eeaf0dd",i,!0,{})},f7G2:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfVisaHistory.css",sourceRoot:""}])},fAdt:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.rightBarForm {\n  width: 10.2%;\n  height: 100%;\n  position: fixed;\n  background-color: #f6f6f6;\n  right: 0;\n  z-index: 1000;\n  overflow: auto;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.rightBarFormHide {\n  width: 0%;\n  height: 100%;\n  position: fixed;\n  background-color: #f6f6f6;\n  right: 0;\n  z-index: 1000;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.contentArrowRBF {\n  width: 1.1%;\n  height: 100%;\n  position: fixed;\n  background-color: #e3e2e2;\n  right: 10.2%;\n  z-index: 1001;\n  border-left: 1px solid silver;\n  border-right: 1px solid silver;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.contentArrowRBFHide {\n  right: 0;\n  width: 1%;\n  height: 100%;\n  position: fixed;\n  background-color: #e3e2e2;\n  z-index: 1001;\n  border-left: 1px solid silver;\n  border-right: 1px solid silver;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.icontAroowRBFAf {\n  position: fixed;\n  top: 50%;\n  right: 0.3%;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.contentArrowRBF:hover, .contentArrowRBFHide:hover {\n  background-color: #dddddd;\n  cursor: pointer;\n}\n.icontAroowRBF {\n  position: fixed;\n  top: 50%;\n  right: 10.5%;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.icontToolsRBF {\n  margin-top: 3px;\n  font-size: 13px !important;\n}\n.boxTitleRBF {\n  text-align: center !important;\n  margin-top: 7px;\n  border-bottom: 2px solid #c7c7c7;\n}\n.titleRBF {\n  font-size: 18px !important;\n  background-color: #80808014;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n.boxSubTitleRBF, .boxHelp {\n  padding-top: 6px;\n  border-bottom: 2px solid #c7c7c7;\n  cursor: pointer;\n}\n.boxSubTitleRBF:hover, .boxHelp:hover {\n  background-color: #80808014;\n}\n.subTitleRBF, .titleHelptolls {\n  font-size: 15px !important;\n}\n.contentEFS, .contentClPe {\n  margin-top: 12px;\n  border-bottom: 1px solid #c7c7c7;\n}\n.titleEFS, .titleClPe {\n  margin-bottom: -5px;\n}\n.contentItemsEnable {\n  margin-top: 16px;\n  border-bottom: 1px solid #c7c7c7;\n}\n.enableFields {\n  font-size: 13px !important;\n}\n.desableFields {\n  margin-top: 5px;\n  font-size: 13px !important;\n}\n.contentRadiosPages {\n  margin-top: 6px;\n  margin-bottom: 12px;\n}\n.titleHelptolls {\n  margin-top: 12px;\n}\n.contenItemsHelpTools {\n  margin-left: 8px;\n}\n.textItemhelp {\n  font-size: 14px !important;\n}\n.myToggleRBF.btn-toggle {\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 94px;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  margin-top: 14px;\n  margin-bottom: 16px;\n}\n.myToggleRBF.btn-toggle:before,\n.myToggleRBF.btn-toggle:after {\n  line-height: 1.5rem;\n  width: 4rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  -webkit-transition: opacity 0.25s;\n  transition: opacity 0.25s;\n}\n.myToggleRBF.btn-toggle:before {\n  content: \"Unshared\";\n  left: -4rem;\n}\n.myToggleRBF.btn-toggle:after {\n  content: 'Shared';\n  right: -4rem;\n  opacity: 0.5;\n}\n.myToggleRBF.btn-toggle > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleRBF.btn-toggle.active {\n  -webkit-transition: background-color 0.25s;\n  transition: background-color 0.25s;\n}\n.myToggleRBF.btn-toggle.active > .handle {\n  left: 4.47rem;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleRBF.btn-toggle.btn-sm:before {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.513rem;\n  width: 2.325rem;\n  font-size: 12px !important;\n}\n.myToggleRBF.btn-toggle.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.213rem;\n  width: 2.325rem;\n  font-size: 12px !important;\n}\n.myToggleRBF.btn-toggle.btn-sm:before {\n  text-align: right;\n}\n.myToggleRBF.btn-toggle.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.myToggleRBF.btn-toggle.btn-sm.active:before {\n  opacity: 0;\n}\n.myToggleRBF.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.myToggleRBF.btn-toggle.active {\n  background-color: #4bc54b;\n}\n.myToggleRBFEdit.btn-toggle {\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 5rem;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  margin-top: 14px;\n  margin-bottom: 16px;\n}\n.myToggleRBFEdit.btn-toggle:before,\n.myToggleRBFEdit.btn-toggle:after {\n  line-height: 1.5rem;\n  width: 4rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  -webkit-transition: opacity 0.25s;\n  transition: opacity 0.25s;\n}\n.myToggleRBFEdit.btn-toggle:before {\n  content: 'Read';\n  left: -4rem;\n}\n.myToggleRBFEdit.btn-toggle:after {\n  content: 'Edit';\n  right: -4rem;\n  opacity: 0.5;\n}\n.myToggleRBFEdit.btn-toggle > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleRBFEdit.btn-toggle.active {\n  -webkit-transition: background-color 0.25s;\n  transition: background-color 0.25s;\n}\n.myToggleRBFEdit.btn-toggle.active > .handle {\n  left: 3.65rem;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm:before {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.113rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.4125rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm:before {\n  text-align: right;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm.active:before {\n  opacity: 0;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.myToggleRBFEdit.btn-toggle.active {\n  background-color: #4bc54b;\n}\n@media (max-width: 1520px) {\n.contentArrowRBF {\n    width: 1.2%;\n}\n.icontAroowRBFAf {\n    right: 10.6%;\n}\n}\n@media (max-width: 1466px) {\n.rightBarForm {\n    width: 13.2%;\n}\n.contentArrowRBF {\n    width: 1.2%;\n    right: 13.2%;\n}\n.icontAroowRBF {\n    right: 13.5%;\n}\n}\n@media (max-width: 1380px) {\n.contentArrowRBF {\n    width: 1.3%;\n}\n}\n@media (max-width: 1100px) {\n.rightBarForm {\n    width: 16.2%;\n}\n.contentArrowRBF {\n    width: 1.4%;\n    right: 16%;\n}\n.icontAroowRBF {\n    right: 16.2%;\n}\n}\n@media (max-width: 900px) {\n.rightBarForm {\n    width: 19.2%;\n}\n.contentArrowRBF {\n    width: 1.7%;\n    right: 18.8%;\n}\n.icontAroowRBF {\n    right: 19.2%;\n}\n}\n@media (max-width: 750px) {\n.rightBarForm {\n    width: 22.8%;\n}\n.contentArrowRBF {\n    width: 2.1%;\n    right: 22.5%;\n}\n.icontAroowRBF {\n    right: 23%;\n}\n}\n@media (max-width: 600px) {\n.rightBarForm {\n    width: 26%;\n}\n.contentArrowRBF {\n    width: 2.8%;\n    right: 25.5%;\n}\n.icontAroowRBF {\n    right: 26.3%;\n}\n}\n@media (max-width: 450px) {\n.rightBarForm {\n    width: 29%;\n}\n.contentArrowRBF {\n    width: 4.2%;\n    right: 28.9%;\n}\n.icontAroowRBF {\n    right: 29.9%;\n}\n}\n@media (max-width: 300px) {\n.rightBarForm {\n    width: 30.4%;\n}\n.contentArrowRBF {\n    width: 5.5%;\n    right: 31%;\n}\n.icontAroowRBF {\n    right: 32.5%;\n}\n.icontToolsRBF {\n    display: none;\n}\n}\n@media (max-width: 1520px) {\n.contentArrowRBFHide {\n    width: 1.2%;\n}\n.icontAroowRBFAf {\n    right: 0.4%;\n}\n}\n@media (max-width: 1380px) {\n.contentArrowRBFHide {\n    width: 1.3%;\n}\n.icontAroowRBFAf {\n    right: 0.4%;\n}\n}\n@media (max-width: 1100px) {\n.contentArrowRBFHide {\n    width: 1.4%;\n}\n.icontAroowRBFAf {\n    right: 0.5%;\n}\n}\n@media (max-width: 900px) {\n.contentArrowRBFHide {\n    width: 1.7%;\n}\n.icontAroowRBFAf {\n    right: 0.5%;\n}\n}\n@media (max-width: 750px) {\n.contentArrowRBFHide {\n    width: 2.1%;\n}\n.icontAroowRBFAf {\n    right: 0.6%;\n}\n}\n@media (max-width: 600px) {\n.contentArrowRBFHide {\n    width: 2.8%;\n}\n.icontAroowRBFAf {\n    right: 0.8%;\n}\n}\n@media (max-width: 450px) {\n.contentArrowRBFHide {\n    width: 4.2%;\n}\n.icontAroowRBFAf {\n    right: 1.2%;\n}\n}\n@media (max-width: 300px) {\n.contentArrowRBFHide {\n    width: 5.5%;\n}\n.icontAroowRBFAf {\n    right: 1.8%;\n}\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfForm/PfRightBarForm/PfRightBarForm.css"],names:[],mappings:";AACA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,cAAc;EACd,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,8BAA8B;EAC9B,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0BAA0B;EAC1B,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iCAAiC;CAClC;AACD;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;CACjB;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,iBAAiB;EACjB,iCAAiC;CAClC;AACD;EACE,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,iCAAiC;CAClC;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;EACE,gBAAgB;EAChB,oBAAoB;CACrB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;CACrB;AACD;;EAEE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,oBAAoB;EACpB,YAAY;CACb;AACD;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,2CAA2C;EAC3C,mCAAmC;CACpC;AACD;EACE,cAAc;EACd,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;CACrB;AACD;;EAEE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,gBAAgB;EAChB,YAAY;CACb;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,2CAA2C;EAC3C,mCAAmC;CACpC;AACD;EACE,cAAc;EACd,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;EACE,0BAA0B;CAC3B;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,aAAa;CAChB;CACA;AACD;AACA;IACI,aAAa;CAChB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;IACI,aAAa;CAChB;CACA;AACD;AACA;IACI,YAAY;CACf;CACA;AACD;AACA;IACI,aAAa;CAChB;AACD;IACI,YAAY;IACZ,WAAW;CACd;AACD;IACI,aAAa;CAChB;CACA;AACD;AACA;IACI,aAAa;CAChB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;IACI,aAAa;CAChB;CACA;AACD;AACA;IACI,aAAa;CAChB;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;IACI,WAAW;CACd;CACA;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;IACI,aAAa;CAChB;CACA;AACD;AACA;IACI,WAAW;CACd;AACD;IACI,YAAY;IACZ,aAAa;CAChB;AACD;IACI,aAAa;CAChB;CACA;AACD;AACA;IACI,aAAa;CAChB;AACD;IACI,YAAY;IACZ,WAAW;CACd;AACD;IACI,aAAa;CAChB;AACD;IACI,cAAc;CACjB;CACA;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;CACA;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;CACA;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;CACA;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;CACA;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;CACA;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;CACA;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;CACA;AACD;AACA;IACI,YAAY;CACf;AACD;IACI,YAAY;CACf;CACA",file:"PfRightBarForm.css",sourcesContent:["\n.rightBarForm {\n  width: 10.2%;\n  height: 100%;\n  position: fixed;\n  background-color: #f6f6f6;\n  right: 0;\n  z-index: 1000;\n  overflow: auto;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.rightBarFormHide {\n  width: 0%;\n  height: 100%;\n  position: fixed;\n  background-color: #f6f6f6;\n  right: 0;\n  z-index: 1000;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.contentArrowRBF {\n  width: 1.1%;\n  height: 100%;\n  position: fixed;\n  background-color: #e3e2e2;\n  right: 10.2%;\n  z-index: 1001;\n  border-left: 1px solid silver;\n  border-right: 1px solid silver;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.contentArrowRBFHide {\n  right: 0;\n  width: 1%;\n  height: 100%;\n  position: fixed;\n  background-color: #e3e2e2;\n  z-index: 1001;\n  border-left: 1px solid silver;\n  border-right: 1px solid silver;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.icontAroowRBFAf {\n  position: fixed;\n  top: 50%;\n  right: 0.3%;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.contentArrowRBF:hover, .contentArrowRBFHide:hover {\n  background-color: #dddddd;\n  cursor: pointer;\n}\n.icontAroowRBF {\n  position: fixed;\n  top: 50%;\n  right: 10.5%;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.icontToolsRBF {\n  margin-top: 3px;\n  font-size: 13px !important;\n}\n.boxTitleRBF {\n  text-align: center !important;\n  margin-top: 7px;\n  border-bottom: 2px solid #c7c7c7;\n}\n.titleRBF {\n  font-size: 18px !important;\n  background-color: #80808014;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n.boxSubTitleRBF, .boxHelp {\n  padding-top: 6px;\n  border-bottom: 2px solid #c7c7c7;\n  cursor: pointer;\n}\n.boxSubTitleRBF:hover, .boxHelp:hover {\n  background-color: #80808014;\n}\n.subTitleRBF, .titleHelptolls {\n  font-size: 15px !important;\n}\n.contentEFS, .contentClPe {\n  margin-top: 12px;\n  border-bottom: 1px solid #c7c7c7;\n}\n.titleEFS, .titleClPe {\n  margin-bottom: -5px;\n}\n.contentItemsEnable {\n  margin-top: 16px;\n  border-bottom: 1px solid #c7c7c7;\n}\n.enableFields {\n  font-size: 13px !important;\n}\n.desableFields {\n  margin-top: 5px;\n  font-size: 13px !important;\n}\n.contentRadiosPages {\n  margin-top: 6px;\n  margin-bottom: 12px;\n}\n.titleHelptolls {\n  margin-top: 12px;\n}\n.contenItemsHelpTools {\n  margin-left: 8px;\n}\n.textItemhelp {\n  font-size: 14px !important;\n}\n.myToggleRBF.btn-toggle {\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 94px;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  margin-top: 14px;\n  margin-bottom: 16px;\n}\n.myToggleRBF.btn-toggle:before,\n.myToggleRBF.btn-toggle:after {\n  line-height: 1.5rem;\n  width: 4rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  -webkit-transition: opacity 0.25s;\n  transition: opacity 0.25s;\n}\n.myToggleRBF.btn-toggle:before {\n  content: \"Unshared\";\n  left: -4rem;\n}\n.myToggleRBF.btn-toggle:after {\n  content: 'Shared';\n  right: -4rem;\n  opacity: 0.5;\n}\n.myToggleRBF.btn-toggle > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleRBF.btn-toggle.active {\n  -webkit-transition: background-color 0.25s;\n  transition: background-color 0.25s;\n}\n.myToggleRBF.btn-toggle.active > .handle {\n  left: 4.47rem;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleRBF.btn-toggle.btn-sm:before {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.513rem;\n  width: 2.325rem;\n  font-size: 12px !important;\n}\n.myToggleRBF.btn-toggle.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.213rem;\n  width: 2.325rem;\n  font-size: 12px !important;\n}\n.myToggleRBF.btn-toggle.btn-sm:before {\n  text-align: right;\n}\n.myToggleRBF.btn-toggle.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.myToggleRBF.btn-toggle.btn-sm.active:before {\n  opacity: 0;\n}\n.myToggleRBF.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.myToggleRBF.btn-toggle.active {\n  background-color: #4bc54b;\n}\n.myToggleRBFEdit.btn-toggle {\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 5rem;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  margin-top: 14px;\n  margin-bottom: 16px;\n}\n.myToggleRBFEdit.btn-toggle:before,\n.myToggleRBFEdit.btn-toggle:after {\n  line-height: 1.5rem;\n  width: 4rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  -webkit-transition: opacity 0.25s;\n  transition: opacity 0.25s;\n}\n.myToggleRBFEdit.btn-toggle:before {\n  content: 'Read';\n  left: -4rem;\n}\n.myToggleRBFEdit.btn-toggle:after {\n  content: 'Edit';\n  right: -4rem;\n  opacity: 0.5;\n}\n.myToggleRBFEdit.btn-toggle > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleRBFEdit.btn-toggle.active {\n  -webkit-transition: background-color 0.25s;\n  transition: background-color 0.25s;\n}\n.myToggleRBFEdit.btn-toggle.active > .handle {\n  left: 3.65rem;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm:before {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.113rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.4125rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm:before {\n  text-align: right;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm.active:before {\n  opacity: 0;\n}\n.myToggleRBFEdit.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.myToggleRBFEdit.btn-toggle.active {\n  background-color: #4bc54b;\n}\n@media (max-width: 1520px) {\n.contentArrowRBF {\n    width: 1.2%;\n}\n.icontAroowRBFAf {\n    right: 10.6%;\n}\n}\n@media (max-width: 1466px) {\n.rightBarForm {\n    width: 13.2%;\n}\n.contentArrowRBF {\n    width: 1.2%;\n    right: 13.2%;\n}\n.icontAroowRBF {\n    right: 13.5%;\n}\n}\n@media (max-width: 1380px) {\n.contentArrowRBF {\n    width: 1.3%;\n}\n}\n@media (max-width: 1100px) {\n.rightBarForm {\n    width: 16.2%;\n}\n.contentArrowRBF {\n    width: 1.4%;\n    right: 16%;\n}\n.icontAroowRBF {\n    right: 16.2%;\n}\n}\n@media (max-width: 900px) {\n.rightBarForm {\n    width: 19.2%;\n}\n.contentArrowRBF {\n    width: 1.7%;\n    right: 18.8%;\n}\n.icontAroowRBF {\n    right: 19.2%;\n}\n}\n@media (max-width: 750px) {\n.rightBarForm {\n    width: 22.8%;\n}\n.contentArrowRBF {\n    width: 2.1%;\n    right: 22.5%;\n}\n.icontAroowRBF {\n    right: 23%;\n}\n}\n@media (max-width: 600px) {\n.rightBarForm {\n    width: 26%;\n}\n.contentArrowRBF {\n    width: 2.8%;\n    right: 25.5%;\n}\n.icontAroowRBF {\n    right: 26.3%;\n}\n}\n@media (max-width: 450px) {\n.rightBarForm {\n    width: 29%;\n}\n.contentArrowRBF {\n    width: 4.2%;\n    right: 28.9%;\n}\n.icontAroowRBF {\n    right: 29.9%;\n}\n}\n@media (max-width: 300px) {\n.rightBarForm {\n    width: 30.4%;\n}\n.contentArrowRBF {\n    width: 5.5%;\n    right: 31%;\n}\n.icontAroowRBF {\n    right: 32.5%;\n}\n.icontToolsRBF {\n    display: none;\n}\n}\n@media (max-width: 1520px) {\n.contentArrowRBFHide {\n    width: 1.2%;\n}\n.icontAroowRBFAf {\n    right: 0.4%;\n}\n}\n@media (max-width: 1380px) {\n.contentArrowRBFHide {\n    width: 1.3%;\n}\n.icontAroowRBFAf {\n    right: 0.4%;\n}\n}\n@media (max-width: 1100px) {\n.contentArrowRBFHide {\n    width: 1.4%;\n}\n.icontAroowRBFAf {\n    right: 0.5%;\n}\n}\n@media (max-width: 900px) {\n.contentArrowRBFHide {\n    width: 1.7%;\n}\n.icontAroowRBFAf {\n    right: 0.5%;\n}\n}\n@media (max-width: 750px) {\n.contentArrowRBFHide {\n    width: 2.1%;\n}\n.icontAroowRBFAf {\n    right: 0.6%;\n}\n}\n@media (max-width: 600px) {\n.contentArrowRBFHide {\n    width: 2.8%;\n}\n.icontAroowRBFAf {\n    right: 0.8%;\n}\n}\n@media (max-width: 450px) {\n.contentArrowRBFHide {\n    width: 4.2%;\n}\n.icontAroowRBFAf {\n    right: 1.2%;\n}\n}\n@media (max-width: 300px) {\n.contentArrowRBFHide {\n    width: 5.5%;\n}\n.icontAroowRBFAf {\n    right: 1.8%;\n}\n}\n"],sourceRoot:""}])},fRHV:function(t,e,n){"use strict";var i=Array.prototype.slice,a=Object.prototype.toString;t.exports=function(t){var e=this;if("function"!=typeof e||"[object Function]"!==a.call(e))throw new TypeError("Function.prototype.bind called on incompatible "+e);for(var n,o=i.call(arguments,1),r=Math.max(0,e.length-o.length),s=[],l=0;l<r;l++)s.push("$"+l);if(n=Function("binder","return function ("+s.join(",")+"){ return binder.apply(this,arguments); }")(function(){if(this instanceof n){var a=e.apply(this,o.concat(i.call(arguments)));return Object(a)===a?a:this}return e.apply(t,o.concat(i.call(arguments)))}),e.prototype){var d=function(){};d.prototype=e.prototype,n.prototype=new d,d.prototype=null}return n}},fVkZ:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-89397048] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-89397048]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-89397048] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-89397048] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-89397048] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-89397048] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-89397048] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-89397048] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-89397048] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-89397048] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-89397048] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-89397048] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-89397048] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-89397048] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-89397048] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-89397048] {\n  margin-right: 0px;\n}\n.newItem[data-v-89397048] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-89397048] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-89397048] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-89397048] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-89397048] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-89397048] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-89397048] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-89397048] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-89397048] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-89397048] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-89397048]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-89397048] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-89397048] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-89397048] {\n  color: red;\n}\n.showMore[data-v-89397048]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-89397048] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-89397048] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-89397048] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-89397048 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-89397048 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-89397048] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-89397048 3s infinite;\n  animation: bit-data-v-89397048 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-89397048] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-89397048]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-89397048]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-89397048]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-89397048]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-89397048]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-89397048]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-89397048] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-89397048]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-89397048] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-89397048] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-89397048] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-89397048] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-89397048] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-89397048] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-89397048] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-89397048] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-89397048] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-89397048] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-89397048] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-89397048] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-89397048] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-89397048] {\n  margin-right: 0px;\n}\n.newItem[data-v-89397048] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-89397048] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-89397048] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-89397048] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-89397048] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-89397048] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-89397048] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-89397048] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-89397048] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-89397048] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-89397048]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-89397048] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-89397048] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-89397048] {\n  color: red;\n}\n.showMore[data-v-89397048]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-89397048] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-89397048] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-89397048] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-89397048 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-89397048 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-89397048] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-89397048 3s infinite;\n  animation: bit-data-v-89397048 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-89397048] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-89397048]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-89397048]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-89397048]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-89397048]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-89397048]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-89397048]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},fW1y:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e=["جنوري","فيبروري","مارچ","اپريل","مئي","جون","جولاءِ","آگسٽ","سيپٽمبر","آڪٽوبر","نومبر","ڊسمبر"],n=["آچر","سومر","اڱارو","اربع","خميس","جمع","ڇنڇر"];t.defineLocale("sd",{months:e,monthsShort:e,weekdays:n,weekdaysShort:n,weekdaysMin:n,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd، D MMMM YYYY HH:mm"},meridiemParse:/صبح|شام/,isPM:function(t){return"شام"===t},meridiem:function(t,e,n){return t<12?"صبح":"شام"},calendar:{sameDay:"[اڄ] LT",nextDay:"[سڀاڻي] LT",nextWeek:"dddd [اڳين هفتي تي] LT",lastDay:"[ڪالهه] LT",lastWeek:"[گزريل هفتي] dddd [تي] LT",sameElse:"L"},relativeTime:{future:"%s پوء",past:"%s اڳ",s:"چند سيڪنڊ",ss:"%d سيڪنڊ",m:"هڪ منٽ",mm:"%d منٽ",h:"هڪ ڪلاڪ",hh:"%d ڪلاڪ",d:"هڪ ڏينهن",dd:"%d ڏينهن",M:"هڪ مهينو",MM:"%d مهينا",y:"هڪ سال",yy:"%d سال"},preparse:function(t){return t.replace(/،/g,",")},postformat:function(t){return t.replace(/,/g,"،")},week:{dow:1,doy:4}})})(n("PJh5"))},fZjL:function(t,e,n){t.exports={default:n("ZhOs"),__esModule:!0}},flCC:function(t,e,n){var i=n("b8JJ");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("187eb0d7",i,!0,{})},fnBA:function(t,e,n){var i=n("8rKe");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("36f009a2",i,!0,{})},fuGk:function(t,e,n){"use strict";var i=n("cGG2");function a(){this.handlers=[]}a.prototype.use=function(t,e){return this.handlers.push({fulfilled:t,rejected:e}),this.handlers.length-1},a.prototype.eject=function(t){this.handlers[t]&&(this.handlers[t]=null)},a.prototype.forEach=function(t){i.forEach(this.handlers,function(e){null!==e&&t(e)})},t.exports=a},fvfW:function(t,e){t.exports="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAATlBMVEUAAAB1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXV1dXWBtdNmAAAAGXRSTlMA+hSQMQpU4TlxLA/kw56YWnby4rWzhIAjY1nM/gAAAINJREFUGNN1kNsOxCAIRJciitra7d75/x9d0TY0MZ0HNCcDYbhdKvsYfT6BaQWpgnU6SAqATMQIIe2eMLv+c3PovgJKkJVBaSZAfZa7VgS1eWFDLL7WTcgQyVZr7Oi1pIaiNdL3gVkbj/Gq3/uj422JpgSlr/o8r2qBHJGzQGPs8Tij/mcjBScs4qM2AAAAAElFTkSuQmCC"},g7KF:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"),n="jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");t.defineLocale("fy",{months:"jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split("_"),monthsShort:function(t,i){return t?/-MMM-/.test(i)?n[t.month()]:e[t.month()]:e},monthsParseExact:!0,weekdays:"snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split("_"),weekdaysShort:"si._mo._ti._wo._to._fr._so.".split("_"),weekdaysMin:"Si_Mo_Ti_Wo_To_Fr_So".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[hjoed om] LT",nextDay:"[moarn om] LT",nextWeek:"dddd [om] LT",lastDay:"[juster om] LT",lastWeek:"[ôfrûne] dddd [om] LT",sameElse:"L"},relativeTime:{future:"oer %s",past:"%s lyn",s:"in pear sekonden",ss:"%d sekonden",m:"ien minút",mm:"%d minuten",h:"ien oere",hh:"%d oeren",d:"ien dei",dd:"%d dagen",M:"ien moanne",MM:"%d moannen",y:"ien jier",yy:"%d jierren"},dayOfMonthOrdinalParse:/\d{1,2}(ste|de)/,ordinal:function(t){return t+(1===t||8===t||t>=20?"ste":"de")},week:{dow:1,doy:4}})})(n("PJh5"))},gCWN:function(t,e){},gEQe:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"೧",2:"೨",3:"೩",4:"೪",5:"೫",6:"೬",7:"೭",8:"೮",9:"೯",0:"೦"},n={"೧":"1","೨":"2","೩":"3","೪":"4","೫":"5","೬":"6","೭":"7","೮":"8","೯":"9","೦":"0"};t.defineLocale("kn",{months:"ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್".split("_"),monthsShort:"ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ".split("_"),monthsParseExact:!0,weekdays:"ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ".split("_"),weekdaysShort:"ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ".split("_"),weekdaysMin:"ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[ಇಂದು] LT",nextDay:"[ನಾಳೆ] LT",nextWeek:"dddd, LT",lastDay:"[ನಿನ್ನೆ] LT",lastWeek:"[ಕೊನೆಯ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s ನಂತರ",past:"%s ಹಿಂದೆ",s:"ಕೆಲವು ಕ್ಷಣಗಳು",ss:"%d ಸೆಕೆಂಡುಗಳು",m:"ಒಂದು ನಿಮಿಷ",mm:"%d ನಿಮಿಷ",h:"ಒಂದು ಗಂಟೆ",hh:"%d ಗಂಟೆ",d:"ಒಂದು ದಿನ",dd:"%d ದಿನ",M:"ಒಂದು ತಿಂಗಳು",MM:"%d ತಿಂಗಳು",y:"ಒಂದು ವರ್ಷ",yy:"%d ವರ್ಷ"},preparse:function(t){return t.replace(/[೧೨೩೪೫೬೭೮೯೦]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,meridiemHour:function(t,e){return 12===t&&(t=0),"ರಾತ್ರಿ"===e?t<4?t:t+12:"ಬೆಳಿಗ್ಗೆ"===e?t:"ಮಧ್ಯಾಹ್ನ"===e?t>=10?t:t+12:"ಸಂಜೆ"===e?t+12:void 0},meridiem:function(t,e,n){return t<4?"ರಾತ್ರಿ":t<10?"ಬೆಳಿಗ್ಗೆ":t<17?"ಮಧ್ಯಾಹ್ನ":t<20?"ಸಂಜೆ":"ರಾತ್ರಿ"},dayOfMonthOrdinalParse:/\d{1,2}(ನೇ)/,ordinal:function(t){return t+"ನೇ"},week:{dow:0,doy:6}})})(n("PJh5"))},gEU3:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("mi",{months:"Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea".split("_"),monthsShort:"Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split("_"),monthsRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,monthsShortStrictRegex:/(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,weekdays:"Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei".split("_"),weekdaysShort:"Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),weekdaysMin:"Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [i] HH:mm",LLLL:"dddd, D MMMM YYYY [i] HH:mm"},calendar:{sameDay:"[i teie mahana, i] LT",nextDay:"[apopo i] LT",nextWeek:"dddd [i] LT",lastDay:"[inanahi i] LT",lastWeek:"dddd [whakamutunga i] LT",sameElse:"L"},relativeTime:{future:"i roto i %s",past:"%s i mua",s:"te hēkona ruarua",ss:"%d hēkona",m:"he meneti",mm:"%d meneti",h:"te haora",hh:"%d haora",d:"he ra",dd:"%d ra",M:"he marama",MM:"%d marama",y:"he tau",yy:"%d tau"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})(n("PJh5"))},gGQ7:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfImmigrationInformation.css",sourceRoot:""}])},gOOk:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-b58978aa] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-b58978aa]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-b58978aa] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-b58978aa] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-b58978aa] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-b58978aa] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-b58978aa] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-b58978aa] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-b58978aa] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-b58978aa] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-b58978aa] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-b58978aa] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-b58978aa] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-b58978aa] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-b58978aa] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-b58978aa] {\n  margin-right: 0px;\n}\n.newItem[data-v-b58978aa] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-b58978aa] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-b58978aa] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-b58978aa] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-b58978aa] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-b58978aa] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-b58978aa] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-b58978aa] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-b58978aa] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-b58978aa] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-b58978aa]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-b58978aa] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-b58978aa] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-b58978aa] {\n  color: red;\n}\n.showMore[data-v-b58978aa]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-b58978aa] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-b58978aa] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-b58978aa] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-b58978aa {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-b58978aa {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-b58978aa] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-b58978aa 3s infinite;\n  animation: bit-data-v-b58978aa 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-b58978aa] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-b58978aa]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-b58978aa]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-b58978aa]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-b58978aa]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-b58978aa]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-b58978aa]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-b58978aa] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-b58978aa]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-b58978aa] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-b58978aa] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-b58978aa] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-b58978aa] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-b58978aa] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-b58978aa] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-b58978aa] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-b58978aa] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-b58978aa] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-b58978aa] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-b58978aa] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-b58978aa] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-b58978aa] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-b58978aa] {\n  margin-right: 0px;\n}\n.newItem[data-v-b58978aa] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-b58978aa] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-b58978aa] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-b58978aa] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-b58978aa] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-b58978aa] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-b58978aa] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-b58978aa] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-b58978aa] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-b58978aa] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-b58978aa]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-b58978aa] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-b58978aa] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-b58978aa] {\n  color: red;\n}\n.showMore[data-v-b58978aa]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-b58978aa] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-b58978aa] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-b58978aa] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-b58978aa {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-b58978aa {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-b58978aa] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-b58978aa 3s infinite;\n  animation: bit-data-v-b58978aa 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-b58978aa] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-b58978aa]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-b58978aa]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-b58978aa]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-b58978aa]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-b58978aa]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-b58978aa]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},gOkL:function(t,e,n){var i=n("BS92");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("17dd6cc2",i,!0,{})},gRE1:function(t,e,n){t.exports={default:n("mG69"),__esModule:!0}},gUgh:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("tet",{months:"Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split("_"),monthsShort:"Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),weekdays:"Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),weekdaysShort:"Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),weekdaysMin:"Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Ohin iha] LT",nextDay:"[Aban iha] LT",nextWeek:"dddd [iha] LT",lastDay:"[Horiseik iha] LT",lastWeek:"dddd [semana kotuk] [iha] LT",sameElse:"L"},relativeTime:{future:"iha %s",past:"%s liuba",s:"segundu balun",ss:"segundu %d",m:"minutu ida",mm:"minutu %d",h:"oras ida",hh:"oras %d",d:"loron ida",dd:"loron %d",M:"fulan ida",MM:"fulan %d",y:"tinan ida",yy:"tinan %d"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")},week:{dow:1,doy:4}})})(n("PJh5"))},gcUb:function(t,e,n){"use strict";var i=n("7ar3"),a=n("WER7"),o=a(i("String.prototype.indexOf"));t.exports=function(t,e){var n=i(t,!!e);return"function"==typeof n&&o(t,".prototype.")>-1?a(n):n}},"ge/6":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfEad.css",sourceRoot:""}])},gkB7:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfPassports.css",sourceRoot:""}])},gzVG:function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAJAIABACB4s////yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAAEALAAAAAAGAAkAAAINjAOHkNv8mIJTHnpDAQA7"},hEI0:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-ee88fb60]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-ee88fb60]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-ee88fb60]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-ee88fb60]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-ee88fb60] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-ee88fb60]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-ee88fb60] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-ee88fb60]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-ee88fb60]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-ee88fb60]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-ee88fb60]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-ee88fb60]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-ee88fb60]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-ee88fb60] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-ee88fb60]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-ee88fb60] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-ee88fb60]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-ee88fb60]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},hPuz:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")},week:{dow:1,doy:4}})})(n("PJh5"))},hgbu:function(t,e,n){var i=n("a/OS")("wks"),a=n("GmwO"),o=n("YjQv").Symbol,r="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=r&&o[t]||(r?o:a)("Symbol."+t))}).store=i},hng5:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("bm",{months:"Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo".split("_"),monthsShort:"Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des".split("_"),weekdays:"Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),weekdaysShort:"Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib".split("_"),weekdaysMin:"Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"MMMM [tile] D [san] YYYY",LLL:"MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm",LLLL:"dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm"},calendar:{sameDay:"[Bi lɛrɛ] LT",nextDay:"[Sini lɛrɛ] LT",nextWeek:"dddd [don lɛrɛ] LT",lastDay:"[Kunu lɛrɛ] LT",lastWeek:"dddd [tɛmɛnen lɛrɛ] LT",sameElse:"L"},relativeTime:{future:"%s kɔnɔ",past:"a bɛ %s bɔ",s:"sanga dama dama",ss:"sekondi %d",m:"miniti kelen",mm:"miniti %d",h:"lɛrɛ kelen",hh:"lɛrɛ %d",d:"tile kelen",dd:"tile %d",M:"kalo kelen",MM:"kalo %d",y:"san kelen",yy:"san %d"},week:{dow:1,doy:4}})})(n("PJh5"))},ht0Q:function(t,e,n){var i=n("YjQv").navigator;t.exports=i&&i.userAgent||""},iANj:function(t,e){var n=t.exports={version:"2.6.12"};"number"==typeof __e&&(__e=n)},iLGu:function(t,e,n){var i=n("tP0i");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("a13d06f0",i,!0,{})},iNtv:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){var a={s:["viensas secunds","'iensas secunds"],ss:[t+" secunds",t+" secunds"],m:["'n míut","'iens míut"],mm:[t+" míuts",t+" míuts"],h:["'n þora","'iensa þora"],hh:[t+" þoras",t+" þoras"],d:["'n ziua","'iensa ziua"],dd:[t+" ziuas",t+" ziuas"],M:["'n mes","'iens mes"],MM:[t+" mesen",t+" mesen"],y:["'n ar","'iens ar"],yy:[t+" ars",t+" ars"]};return i?a[n][0]:e?a[n][0]:a[n][1]}t.defineLocale("tzl",{months:"Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar".split("_"),monthsShort:"Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec".split("_"),weekdays:"Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi".split("_"),weekdaysShort:"Súl_Lún_Mai_Már_Xhú_Vié_Sát".split("_"),weekdaysMin:"Sú_Lú_Ma_Má_Xh_Vi_Sá".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"D. MMMM [dallas] YYYY",LLL:"D. MMMM [dallas] YYYY HH.mm",LLLL:"dddd, [li] D. MMMM [dallas] YYYY HH.mm"},meridiemParse:/d\'o|d\'a/i,isPM:function(t){return"d'o"===t.toLowerCase()},meridiem:function(t,e,n){return t>11?n?"d'o":"D'O":n?"d'a":"D'A"},calendar:{sameDay:"[oxhi à] LT",nextDay:"[demà à] LT",nextWeek:"dddd [à] LT",lastDay:"[ieiri à] LT",lastWeek:"[sür el] dddd [lasteu à] LT",sameElse:"L"},relativeTime:{future:"osprei %s",past:"ja%s",s:e,ss:e,m:e,mm:e,h:e,hh:e,d:e,dd:e,M:e,MM:e,y:e,yy:e},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},ihmg:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'/*  toolbox tab */\ndiv.toolbox-tab-container[data-v-01327eb3] {\n  background-color: #a1a1a14d !important;\n  padding: 0 !important;\n  -moz-border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 1px 3px 14px -4px rgba(0, 0, 0, 0.7);\n  -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n  height: auto;\n  margin-top: 0px;\n  /* width: 91.6% */\n}\ndiv.toolbox-tab-menu div.list-group[data-v-01327eb3] {\n  margin-bottom: 0;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-01327eb3] {\n  margin-bottom: 0;\n  color: #000 !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-01327eb3]:first-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-01327eb3]:last-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3],\ndiv.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-01327eb3],\ndiv.toolbox-tab-menu div.list-group > a.active .fa[data-v-01327eb3] {\n  background-color: #4c5b72 !important;\n  color: white !important;\n  font-weight: bold !important;\n  border-radius: 0px !important;\n  border: 1px solid #4c5b72;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3]:after {\n  content: \'\';\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  margin-top: -13px;\n  border-left: 0;\n  border-bottom: 13px solid transparent;\n  border-top: 13px solid transparent;\n  border-left: 10px solid #4c5b72;\n}\ndiv.toolbox-tab-content[data-v-01327eb3] {\n  padding-left: 0px;\n  padding-top: 0px;\n  margin-bottom: -32px;\n}\ndiv.toolbox-tab div.toolbox-tab-content[data-v-01327eb3]:not(.active) {\n  display: none;\n}\n.list-group[data-v-01327eb3] {\n  position: absolute;\n  margin-left: -174px;\n  margin-top: 34px;\n  /* font = 14px */\n  font-size: 0.875rem;\n  width: 174px;\n}\n.list-group-item[data-v-01327eb3] {\n  border-radius: 0px !important;\n  cursor: pointer;\n  background-color: #f9f9f9 !important;\n  -webkit-box-shadow: 0px 3px 12px -4px rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 3px 12px -4px rgba(0, 0, 0, 0.4);\n  padding: 8px 8px 8px 0px;\n}\n.tabsSecundary[data-v-01327eb3]:hover {\n  background-color: #1d324f33 !important;\n}\n.spacebar1[data-v-01327eb3] {\n  right: 10px;\n  padding-right: 0px;\n  padding-left: 194px;\n}\n.tabPrimary[data-v-01327eb3] {\n  /* position: absolute */\n  z-index: 3;\n  border-top: 1px solid black;\n  border-left: 1px solid black;\n  border-bottom: 1px solid black;\n  background-color: #1d324f !important;\n  font-size: 0.875rem;\n  border-radius: 0 !important;\n  color: white;\n}\n.tabsSecundary[data-v-01327eb3] {\n  width: 144px;\n  margin-left: 30px;\n  padding: 3px 8px;\n  /* font 12px */\n  font-size: 0.75rem;\n  padding-left: 0px;\n}\n.header-tab[data-v-01327eb3] {\n  z-index: 201;\n  background-color: #205196;\n  padding-top: 7px;\n  color: white;\n  /* font = 20px */\n  font-size: 1.25rem;\n  top: 33px;\n  position: sticky;\n}\n.header-tab-comparing[data-v-01327eb3] {\n  z-index: 201;\n  background-color: #205196;\n  padding-top: 7px;\n  color: white;\n  /* font = 20px */\n  font-size: 1.25rem;\n  top: 0px;\n  position: sticky;\n}\n.tabForms[data-v-01327eb3] {\n  margin-top: 15px;\n}\n@media (max-width: 991px) {\n.tabsSecundary[data-v-01327eb3]:hover {\n    background-color: #bfc3c8 !important;\n}\n.myHidden[data-v-01327eb3] {\n    display: none;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease-in;\n    transition: opacity 0.3s ease-in;\n}\n.spacebar1[data-v-01327eb3] {\n    padding-left: 0px;\n    padding-right: 0px;\n    right: 0px;\n}\n.sideBar[data-v-01327eb3] {\n    right: 1px;\n    z-index: 203;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease-in;\n    transition: opacity 0.3s ease-in;\n}\n.tabForms[data-v-01327eb3] {\n    margin-top: 0px;\n}\n.list-group[data-v-01327eb3] {\n    width: 100%;\n}\n.tabsSecundary[data-v-01327eb3] {\n    border-left: 1px solid black;\n    width: 100%;\n    margin-left: 0px;\n    padding-left: 0px;\n    font-size: 1.25rem;\n    padding: 3px 0px;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-01327eb3] {\n    margin-bottom: -1px;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3]:after {\n    border-left: 0px solid #000;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3]:after {\n    content: none;\n}\ndiv.list-group a.tabsSecundary[data-v-01327eb3]:last-child {\n    border-bottom: 1px solid black;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3],\n  div.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-01327eb3],\n  div.toolbox-tab-menu div.list-group > a.active .fa[data-v-01327eb3] {\n    border-radius: 0px !important;\n}\n.list-group-item[data-v-01327eb3] {\n    border-radius: 0px !important;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.tabPrimary[data-v-01327eb3] {\n    margin-left: 0px;\n    font-size: 1.35rem;\n    width: 100%;\n}\n.nav_button[data-v-01327eb3] {\n    display: inline-block !important;\n    cursor: pointer;\n}\n.boxContainer[data-v-01327eb3] {\n    margin-left: 0px;\n    margin-right: 0px;\n    border-radius: 0px;\n    border-left: 0px;\n    border-right: 0px;\n}\n}\n@media (max-width: 552px) {\n.myNavBar[data-v-01327eb3] {\n    padding-bottom: 32px !important;\n}\n.header-tab[data-v-01327eb3] {\n    top: 64px;\n}\n}\n@media (max-width: 344px) {\n.header-tab[data-v-01327eb3] {\n    top: 64px;\n}\n}\n.badgeP[data-v-01327eb3] {\n  background-color: black;\n  margin-left: 5px;\n  margin-top: 2px;\n  padding: 0.25em 0.5em;\n}\n.badgeP[data-v-01327eb3]::active {\n  background-color: white;\n}\ndiv.toolbox-tab-menu div.list-group > a.active span.badgeP[data-v-01327eb3] {\n  background-color: white;\n  color: black;\n}\n.nav_button[data-v-01327eb3] {\n  background-color: white;\n  border-radius: 5px;\n  border: 1px solid black;\n  display: none;\n  padding: 1px 6px;\n  font-size: 0.75rem;\n  margin-right: -1px;\n  color: black !important;\n}\n.btnNext[data-v-01327eb3] {\n  margin-right: -1px;\n  background-color: #146ae3cc !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n  box-shadow: 1px 1px 3px 0px #000;\n}\n.btnNext[data-v-01327eb3]:hover {\n  margin-right: -1px;\n  background-color: #146ae3 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n  box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-letter[data-v-01327eb3] {\n  font-size: 0.675rem;\n}\n.boxContainer[data-v-01327eb3] {\n  border: 2px solid black;\n  margin-left: 15px;\n  margin-right: 15px;\n  margin-bottom: 18px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  background-color: #f9f9f9;\n}\n.boxContainerForm[data-v-01327eb3] {\n  border: 2px solid black;\n  margin-bottom: 18px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  height: 800px;\n}\n.borderBox[data-v-01327eb3] {\n  border: 2px solid black;\n  border-radius: 5px;\n}\n.boxLeft[data-v-01327eb3] {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border: none !important;\n  padding-left: 0px !important;\n  padding-right: 7.5px !important;\n}\n.boxRight[data-v-01327eb3] {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border: none !important;\n  padding-right: 0px !important;\n  padding-left: 7.5px !important;\n}\n.radio-inline[data-v-01327eb3] {\n  margin-top: 0;\n  margin-left: 0px !important;\n}\n.row[data-v-01327eb3] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.spaceradio[data-v-01327eb3] {\n  margin-right: 4px !important;\n}\n.radioabso[data-v-01327eb3] {\n  position: absolute;\n}\n.left-radio[data-v-01327eb3] {\n  padding-left: 30px;\n  line-height: 1.5;\n  margin-top: -6px;\n  padding-bottom: 10px;\n}\n.marginEnd[data-v-01327eb3] {\n  margin-bottom: 2px;\n}\n.marginBotZero[data-v-01327eb3] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-01327eb3] {\n  margin-bottom: .5rem;\n}\n.marginRight10[data-v-01327eb3] {\n  margin-right: 10px;\n}\n.paddingBottomZero[data-v-01327eb3] {\n  padding-bottom: 0px;\n}\n.ImmigrationConsiderationsPT[data-v-01327eb3] {\n  padding-top: 25px;\n}\n.ImmigrationConsiderationsMB[data-v-01327eb3] {\n  margin-bottom: -13px;\n}\n.formGeneralInfor[data-v-01327eb3] {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.marginLeft15[data-v-01327eb3] {\n  margin-left: 15px;\n}\n.textHeaderMargin[data-v-01327eb3] {\n  margin-left: -1px;\n}\n.boxHeaderMargin[data-v-01327eb3] {\n  margin-left: 1px;\n}\n.paddingR0[data-v-01327eb3] {\n  padding-right: 0px !important;\n}\n.AlignDeletd[data-v-01327eb3] {\n  margin-right: -8px;\n}\n.footer-tab[data-v-01327eb3] {\n  z-index: 201;\n  background-color: #205196;\n  padding: 5px 0px;\n  /* font = 20px */\n  font-size: 1.25rem;\n  bottom: 1px;\n  width: 100%;\n  position: sticky;\n  bottom: 0;\n}\nhr[data-v-01327eb3] {\n  border: 1px solid rgba(0, 0, 0, 0.5);\n}\n.fadeIn[data-v-01327eb3] {\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  opacity: 1 !important;\n}\n.fadeInMenu[data-v-01327eb3] {\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n  opacity: 1 !important;\n}\n.fadeOut[data-v-01327eb3] {\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n}\n.myBorderSideBar[data-v-01327eb3] {\n  border: 1px solid black;\n}\n.rowhelpItem[data-v-01327eb3] {\n  margin-right: -16px;\n  margin-left: -16px;\n  margin-top: -16px;\n}\n.helpItem[data-v-01327eb3] {\n  background-color: #f1f189 !important;\n  text-align: center;\n  font-size: 16px;\n  padding: 0.8rem !important;\n}\n.centerBtnAf[data-v-01327eb3] {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.badgeRed[data-v-01327eb3] {\n  background-color: red;\n  margin-left: 5px;\n  margin-top: 2px;\n  padding: 0.25em 0.5em;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfSideBar/PfSideBar.css"],names:[],mappings:"AAAA,kBAAkB;AAClB;EACE,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;EACxB,oDAAoD;EACpD,iDAAiD;EACjD,iDAAiD;EACjD,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,uBAAuB;CACxB;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,8BAA8B;CAC/B;AACD;;;EAGE,qCAAqC;EACrC,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;CAC3B;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,mCAAmC;EACnC,gCAAgC;CACjC;AACD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;CACtB;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;EACrC,yDAAyD;EACzD,iDAAiD;EACjD,yBAAyB;CAC1B;AACD;EACE,uCAAuC;CACxC;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,wBAAwB;EACxB,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,qCAAqC;EACrC,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;CACd;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;CACnB;AACD;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;CAClB;AACD;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;AACA;IACI,qCAAqC;CACxC;AACD;IACI,cAAc;IACd,WAAW;IACX,yCAAyC;IACzC,iCAAiC;CACpC;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;CACd;AACD;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,yCAAyC;IACzC,iCAAiC;CACpC;AACD;IACI,gBAAgB;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,4BAA4B;CAC/B;AACD;IACI,cAAc;CACjB;AACD;IACI,+BAA+B;CAClC;AACD;;;IAGI,8BAA8B;CACjC;AACD;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;IACpB,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;CACf;AACD;IACI,iCAAiC;IACjC,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;CACrB;CACA;AACD;AACA;IACI,gCAAgC;CACnC;AACD;IACI,UAAU;CACb;CACA;AACD;AACA;IACI,UAAU;CACb;CACA;AACD;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;CACvB;AACD;EACE,wBAAwB;CACzB;AACD;EACE,wBAAwB;EACxB,aAAa;CACd;AACD;EACE,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;CACzB;AACD;EACE,mBAAmB;EACnB,uCAAuC;EACvC,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,oBAAoB;CACrB;AACD;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;CAC3B;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;CACf;AACD;EACE,wBAAwB;EACxB,mBAAmB;CACpB;AACD;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;CACjC;AACD;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;CAChC;AACD;EACE,cAAc;EACd,4BAA4B;CAC7B;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,UAAU;CACX;AACD;EACE,qCAAqC;CACtC;AACD;EACE,yCAAyC;EACzC,iCAAiC;EACjC,sBAAsB;CACvB;AACD;EACE,yCAAyC;EACzC,iCAAiC;EACjC,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,wBAAwB;CACzB;AACD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;CACvB",file:"PfSideBar.css",sourcesContent:['/*  toolbox tab */\ndiv.toolbox-tab-container[data-v-01327eb3] {\n  background-color: #a1a1a14d !important;\n  padding: 0 !important;\n  -moz-border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 1px 3px 14px -4px rgba(0, 0, 0, 0.7);\n  -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n  height: auto;\n  margin-top: 0px;\n  /* width: 91.6% */\n}\ndiv.toolbox-tab-menu div.list-group[data-v-01327eb3] {\n  margin-bottom: 0;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-01327eb3] {\n  margin-bottom: 0;\n  color: #000 !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-01327eb3]:first-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-01327eb3]:last-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3],\ndiv.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-01327eb3],\ndiv.toolbox-tab-menu div.list-group > a.active .fa[data-v-01327eb3] {\n  background-color: #4c5b72 !important;\n  color: white !important;\n  font-weight: bold !important;\n  border-radius: 0px !important;\n  border: 1px solid #4c5b72;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3]:after {\n  content: \'\';\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  margin-top: -13px;\n  border-left: 0;\n  border-bottom: 13px solid transparent;\n  border-top: 13px solid transparent;\n  border-left: 10px solid #4c5b72;\n}\ndiv.toolbox-tab-content[data-v-01327eb3] {\n  padding-left: 0px;\n  padding-top: 0px;\n  margin-bottom: -32px;\n}\ndiv.toolbox-tab div.toolbox-tab-content[data-v-01327eb3]:not(.active) {\n  display: none;\n}\n.list-group[data-v-01327eb3] {\n  position: absolute;\n  margin-left: -174px;\n  margin-top: 34px;\n  /* font = 14px */\n  font-size: 0.875rem;\n  width: 174px;\n}\n.list-group-item[data-v-01327eb3] {\n  border-radius: 0px !important;\n  cursor: pointer;\n  background-color: #f9f9f9 !important;\n  -webkit-box-shadow: 0px 3px 12px -4px rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 3px 12px -4px rgba(0, 0, 0, 0.4);\n  padding: 8px 8px 8px 0px;\n}\n.tabsSecundary[data-v-01327eb3]:hover {\n  background-color: #1d324f33 !important;\n}\n.spacebar1[data-v-01327eb3] {\n  right: 10px;\n  padding-right: 0px;\n  padding-left: 194px;\n}\n.tabPrimary[data-v-01327eb3] {\n  /* position: absolute */\n  z-index: 3;\n  border-top: 1px solid black;\n  border-left: 1px solid black;\n  border-bottom: 1px solid black;\n  background-color: #1d324f !important;\n  font-size: 0.875rem;\n  border-radius: 0 !important;\n  color: white;\n}\n.tabsSecundary[data-v-01327eb3] {\n  width: 144px;\n  margin-left: 30px;\n  padding: 3px 8px;\n  /* font 12px */\n  font-size: 0.75rem;\n  padding-left: 0px;\n}\n.header-tab[data-v-01327eb3] {\n  z-index: 201;\n  background-color: #205196;\n  padding-top: 7px;\n  color: white;\n  /* font = 20px */\n  font-size: 1.25rem;\n  top: 33px;\n  position: sticky;\n}\n.header-tab-comparing[data-v-01327eb3] {\n  z-index: 201;\n  background-color: #205196;\n  padding-top: 7px;\n  color: white;\n  /* font = 20px */\n  font-size: 1.25rem;\n  top: 0px;\n  position: sticky;\n}\n.tabForms[data-v-01327eb3] {\n  margin-top: 15px;\n}\n@media (max-width: 991px) {\n.tabsSecundary[data-v-01327eb3]:hover {\n    background-color: #bfc3c8 !important;\n}\n.myHidden[data-v-01327eb3] {\n    display: none;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease-in;\n    transition: opacity 0.3s ease-in;\n}\n.spacebar1[data-v-01327eb3] {\n    padding-left: 0px;\n    padding-right: 0px;\n    right: 0px;\n}\n.sideBar[data-v-01327eb3] {\n    right: 1px;\n    z-index: 203;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease-in;\n    transition: opacity 0.3s ease-in;\n}\n.tabForms[data-v-01327eb3] {\n    margin-top: 0px;\n}\n.list-group[data-v-01327eb3] {\n    width: 100%;\n}\n.tabsSecundary[data-v-01327eb3] {\n    border-left: 1px solid black;\n    width: 100%;\n    margin-left: 0px;\n    padding-left: 0px;\n    font-size: 1.25rem;\n    padding: 3px 0px;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-01327eb3] {\n    margin-bottom: -1px;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3]:after {\n    border-left: 0px solid #000;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3]:after {\n    content: none;\n}\ndiv.list-group a.tabsSecundary[data-v-01327eb3]:last-child {\n    border-bottom: 1px solid black;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-01327eb3],\n  div.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-01327eb3],\n  div.toolbox-tab-menu div.list-group > a.active .fa[data-v-01327eb3] {\n    border-radius: 0px !important;\n}\n.list-group-item[data-v-01327eb3] {\n    border-radius: 0px !important;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.tabPrimary[data-v-01327eb3] {\n    margin-left: 0px;\n    font-size: 1.35rem;\n    width: 100%;\n}\n.nav_button[data-v-01327eb3] {\n    display: inline-block !important;\n    cursor: pointer;\n}\n.boxContainer[data-v-01327eb3] {\n    margin-left: 0px;\n    margin-right: 0px;\n    border-radius: 0px;\n    border-left: 0px;\n    border-right: 0px;\n}\n}\n@media (max-width: 552px) {\n.myNavBar[data-v-01327eb3] {\n    padding-bottom: 32px !important;\n}\n.header-tab[data-v-01327eb3] {\n    top: 64px;\n}\n}\n@media (max-width: 344px) {\n.header-tab[data-v-01327eb3] {\n    top: 64px;\n}\n}\n.badgeP[data-v-01327eb3] {\n  background-color: black;\n  margin-left: 5px;\n  margin-top: 2px;\n  padding: 0.25em 0.5em;\n}\n.badgeP[data-v-01327eb3]::active {\n  background-color: white;\n}\ndiv.toolbox-tab-menu div.list-group > a.active span.badgeP[data-v-01327eb3] {\n  background-color: white;\n  color: black;\n}\n.nav_button[data-v-01327eb3] {\n  background-color: white;\n  border-radius: 5px;\n  border: 1px solid black;\n  display: none;\n  padding: 1px 6px;\n  font-size: 0.75rem;\n  margin-right: -1px;\n  color: black !important;\n}\n.btnNext[data-v-01327eb3] {\n  margin-right: -1px;\n  background-color: #146ae3cc !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n  box-shadow: 1px 1px 3px 0px #000;\n}\n.btnNext[data-v-01327eb3]:hover {\n  margin-right: -1px;\n  background-color: #146ae3 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n  box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-letter[data-v-01327eb3] {\n  font-size: 0.675rem;\n}\n.boxContainer[data-v-01327eb3] {\n  border: 2px solid black;\n  margin-left: 15px;\n  margin-right: 15px;\n  margin-bottom: 18px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  background-color: #f9f9f9;\n}\n.boxContainerForm[data-v-01327eb3] {\n  border: 2px solid black;\n  margin-bottom: 18px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  height: 800px;\n}\n.borderBox[data-v-01327eb3] {\n  border: 2px solid black;\n  border-radius: 5px;\n}\n.boxLeft[data-v-01327eb3] {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border: none !important;\n  padding-left: 0px !important;\n  padding-right: 7.5px !important;\n}\n.boxRight[data-v-01327eb3] {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border: none !important;\n  padding-right: 0px !important;\n  padding-left: 7.5px !important;\n}\n.radio-inline[data-v-01327eb3] {\n  margin-top: 0;\n  margin-left: 0px !important;\n}\n.row[data-v-01327eb3] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.spaceradio[data-v-01327eb3] {\n  margin-right: 4px !important;\n}\n.radioabso[data-v-01327eb3] {\n  position: absolute;\n}\n.left-radio[data-v-01327eb3] {\n  padding-left: 30px;\n  line-height: 1.5;\n  margin-top: -6px;\n  padding-bottom: 10px;\n}\n.marginEnd[data-v-01327eb3] {\n  margin-bottom: 2px;\n}\n.marginBotZero[data-v-01327eb3] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-01327eb3] {\n  margin-bottom: .5rem;\n}\n.marginRight10[data-v-01327eb3] {\n  margin-right: 10px;\n}\n.paddingBottomZero[data-v-01327eb3] {\n  padding-bottom: 0px;\n}\n.ImmigrationConsiderationsPT[data-v-01327eb3] {\n  padding-top: 25px;\n}\n.ImmigrationConsiderationsMB[data-v-01327eb3] {\n  margin-bottom: -13px;\n}\n.formGeneralInfor[data-v-01327eb3] {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.marginLeft15[data-v-01327eb3] {\n  margin-left: 15px;\n}\n.textHeaderMargin[data-v-01327eb3] {\n  margin-left: -1px;\n}\n.boxHeaderMargin[data-v-01327eb3] {\n  margin-left: 1px;\n}\n.paddingR0[data-v-01327eb3] {\n  padding-right: 0px !important;\n}\n.AlignDeletd[data-v-01327eb3] {\n  margin-right: -8px;\n}\n.footer-tab[data-v-01327eb3] {\n  z-index: 201;\n  background-color: #205196;\n  padding: 5px 0px;\n  /* font = 20px */\n  font-size: 1.25rem;\n  bottom: 1px;\n  width: 100%;\n  position: sticky;\n  bottom: 0;\n}\nhr[data-v-01327eb3] {\n  border: 1px solid rgba(0, 0, 0, 0.5);\n}\n.fadeIn[data-v-01327eb3] {\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  opacity: 1 !important;\n}\n.fadeInMenu[data-v-01327eb3] {\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n  opacity: 1 !important;\n}\n.fadeOut[data-v-01327eb3] {\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n}\n.myBorderSideBar[data-v-01327eb3] {\n  border: 1px solid black;\n}\n.rowhelpItem[data-v-01327eb3] {\n  margin-right: -16px;\n  margin-left: -16px;\n  margin-top: -16px;\n}\n.helpItem[data-v-01327eb3] {\n  background-color: #f1f189 !important;\n  text-align: center;\n  font-size: 16px;\n  padding: 0.8rem !important;\n}\n.centerBtnAf[data-v-01327eb3] {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.badgeRed[data-v-01327eb3] {\n  background-color: red;\n  margin-left: 5px;\n  margin-top: 2px;\n  padding: 0.25em 0.5em;\n}\n'],sourceRoot:""}])},"j+vx":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={0:"-ші",1:"-ші",2:"-ші",3:"-ші",4:"-ші",5:"-ші",6:"-шы",7:"-ші",8:"-ші",9:"-шы",10:"-шы",20:"-шы",30:"-шы",40:"-шы",50:"-ші",60:"-шы",70:"-ші",80:"-ші",90:"-шы",100:"-ші"};t.defineLocale("kk",{months:"қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан".split("_"),monthsShort:"қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел".split("_"),weekdays:"жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі".split("_"),weekdaysShort:"жек_дүй_сей_сәр_бей_жұм_сен".split("_"),weekdaysMin:"жк_дй_сй_ср_бй_жм_сн".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Бүгін сағат] LT",nextDay:"[Ертең сағат] LT",nextWeek:"dddd [сағат] LT",lastDay:"[Кеше сағат] LT",lastWeek:"[Өткен аптаның] dddd [сағат] LT",sameElse:"L"},relativeTime:{future:"%s ішінде",past:"%s бұрын",s:"бірнеше секунд",ss:"%d секунд",m:"бір минут",mm:"%d минут",h:"бір сағат",hh:"%d сағат",d:"бір күн",dd:"%d күн",M:"бір ай",MM:"%d ай",y:"бір жыл",yy:"%d жыл"},dayOfMonthOrdinalParse:/\d{1,2}-(ші|шы)/,ordinal:function(t){return t+(e[t]||e[t%10]||e[t>=100?100:null])},week:{dow:1,doy:7}})})(n("PJh5"))},j8cJ:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ar-kw",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",ss:"%d ثانية",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:0,doy:12}})})(n("PJh5"))},jxEH:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={ss:"sekundes_sekundēm_sekunde_sekundes".split("_"),m:"minūtes_minūtēm_minūte_minūtes".split("_"),mm:"minūtes_minūtēm_minūte_minūtes".split("_"),h:"stundas_stundām_stunda_stundas".split("_"),hh:"stundas_stundām_stunda_stundas".split("_"),d:"dienas_dienām_diena_dienas".split("_"),dd:"dienas_dienām_diena_dienas".split("_"),M:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),MM:"mēneša_mēnešiem_mēnesis_mēneši".split("_"),y:"gada_gadiem_gads_gadi".split("_"),yy:"gada_gadiem_gads_gadi".split("_")};function n(t,e,n){return n?e%10==1&&e%100!=11?t[2]:t[3]:e%10==1&&e%100!=11?t[0]:t[1]}function i(t,i,a){return t+" "+n(e[a],t,i)}function a(t,i,a){return n(e[a],t,i)}t.defineLocale("lv",{months:"janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),weekdays:"svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY.",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, HH:mm",LLLL:"YYYY. [gada] D. MMMM, dddd, HH:mm"},calendar:{sameDay:"[Šodien pulksten] LT",nextDay:"[Rīt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pagājušā] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"pēc %s",past:"pirms %s",s:function(t,e){return e?"dažas sekundes":"dažām sekundēm"},ss:i,m:a,mm:i,h:a,hh:i,d:a,dd:i,M:a,MM:i,y:a,yy:i},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},"k+5o":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'üncü",4:"'üncü",100:"'üncü",6:"'ncı",9:"'uncu",10:"'uncu",30:"'uncu",60:"'ıncı",90:"'ıncı"};t.defineLocale("tr",{months:"Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),monthsShort:"Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),weekdaysMin:"Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),meridiem:function(t,e,n){return t<12?n?"öö":"ÖÖ":n?"ös":"ÖS"},meridiemParse:/öö|ÖÖ|ös|ÖS/,isPM:function(t){return"ös"===t||"ÖS"===t},longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[yarın saat] LT",nextWeek:"[gelecek] dddd [saat] LT",lastDay:"[dün] LT",lastWeek:"[geçen] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s önce",s:"birkaç saniye",ss:"%d saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",w:"bir hafta",ww:"%d hafta",M:"bir ay",MM:"%d ay",y:"bir yıl",yy:"%d yıl"},ordinal:function(t,n){switch(n){case"d":case"D":case"Do":case"DD":return t;default:if(0===t)return t+"'ıncı";var i=t%10;return t+(e[i]||e[t%100-i]||e[t>=100?100:null])}},week:{dow:1,doy:7}})})(n("PJh5"))},kAIw:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnAdd {\n  color: #333333 !important;\n  background-color: #e5e5e5 !important;\n  padding: 4px 10px 4px 10px;\n  border: none;\n  font-size: 13px;\n  line-height: 1.5;\n}\n#editorBody {\n  height: 300px;\n}\n.action-button {\n  width: 130px;\n  text-align: left !important;\n  margin: 2px;\n}\n.tox.tox-silver-sink.tox-tinymce-aux {\n  z-index: 9999;\n}\n.classHrEspecial {\n  margin-top: 16px;\n  border-top: 1px solid #000 !important;\n  margin-bottom: 5px;\n}\n.app-id {\n  width: 100% !important;\n  text-align: center;\n}\n@media (min-width: 576px) {\n.app-id {\n    width: 100% !important;\n    text-align: right;\n}\n}\n@media (min-width: 768px) {\n.app-id {\n    width: 75% !important;\n    text-align: center;\n}\n}\n@media (min-width: 992px) {\n.app-id {\n    width: 43% !important;\n    text-align: center;\n}\n}\n@media (min-width: 1200px) {\n.app-id {\n    width: 55% !important;\n    text-align: center;\n}\n}\n@media (min-width: 1400px) {\n.app-id {\n    width: 70% !important;\n    text-align: center;\n}\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfAddendum/PfAddendum.css"],names:[],mappings:";AACA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,cAAc;CACf;AACD;EACE,aAAa;EACb,4BAA4B;EAC5B,YAAY;CACb;AACD;EACE,cAAc;CACf;AACD;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;CACpB;AACD;EACE,uBAAuB;EACvB,mBAAmB;CACpB;AACD;AACA;IACI,uBAAuB;IACvB,kBAAkB;CACrB;CACA;AACD;AACA;IACI,sBAAsB;IACtB,mBAAmB;CACtB;CACA;AACD;AACA;IACI,sBAAsB;IACtB,mBAAmB;CACtB;CACA;AACD;AACA;IACI,sBAAsB;IACtB,mBAAmB;CACtB;CACA;AACD;AACA;IACI,sBAAsB;IACtB,mBAAmB;CACtB;CACA",file:"PfAddendum.css",sourcesContent:["\n.btnAdd {\n  color: #333333 !important;\n  background-color: #e5e5e5 !important;\n  padding: 4px 10px 4px 10px;\n  border: none;\n  font-size: 13px;\n  line-height: 1.5;\n}\n#editorBody {\n  height: 300px;\n}\n.action-button {\n  width: 130px;\n  text-align: left !important;\n  margin: 2px;\n}\n.tox.tox-silver-sink.tox-tinymce-aux {\n  z-index: 9999;\n}\n.classHrEspecial {\n  margin-top: 16px;\n  border-top: 1px solid #000 !important;\n  margin-bottom: 5px;\n}\n.app-id {\n  width: 100% !important;\n  text-align: center;\n}\n@media (min-width: 576px) {\n.app-id {\n    width: 100% !important;\n    text-align: right;\n}\n}\n@media (min-width: 768px) {\n.app-id {\n    width: 75% !important;\n    text-align: center;\n}\n}\n@media (min-width: 992px) {\n.app-id {\n    width: 43% !important;\n    text-align: center;\n}\n}\n@media (min-width: 1200px) {\n.app-id {\n    width: 55% !important;\n    text-align: center;\n}\n}\n@media (min-width: 1400px) {\n.app-id {\n    width: 70% !important;\n    text-align: center;\n}\n}\n"],sourceRoot:""}])},kI9l:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},i=["کانونی دووەم","شوبات","ئازار","نیسان","ئایار","حوزەیران","تەمموز","ئاب","ئەیلوول","تشرینی یەكەم","تشرینی دووەم","كانونی یەکەم"];t.defineLocale("ku",{months:i,monthsShort:i,weekdays:"یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌".split("_"),weekdaysShort:"یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌".split("_"),weekdaysMin:"ی_د_س_چ_پ_ه_ش".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},meridiemParse:/ئێواره‌|به‌یانی/,isPM:function(t){return/ئێواره‌/.test(t)},meridiem:function(t,e,n){return t<12?"به‌یانی":"ئێواره‌"},calendar:{sameDay:"[ئه‌مرۆ كاتژمێر] LT",nextDay:"[به‌یانی كاتژمێر] LT",nextWeek:"dddd [كاتژمێر] LT",lastDay:"[دوێنێ كاتژمێر] LT",lastWeek:"dddd [كاتژمێر] LT",sameElse:"L"},relativeTime:{future:"له‌ %s",past:"%s",s:"چه‌ند چركه‌یه‌ك",ss:"چركه‌ %d",m:"یه‌ك خوله‌ك",mm:"%d خوله‌ك",h:"یه‌ك كاتژمێر",hh:"%d كاتژمێر",d:"یه‌ك ڕۆژ",dd:"%d ڕۆژ",M:"یه‌ك مانگ",MM:"%d مانگ",y:"یه‌ك ساڵ",yy:"%d ساڵ"},preparse:function(t){return t.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(t){return n[t]}).replace(/،/g,",")},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]}).replace(/,/g,"،")},week:{dow:6,doy:12}})})(n("PJh5"))},kIwA:function(t,e,n){var i=n("zPlY");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("219db31b",i,!0,{})},kkvn:function(t,e,n){var i,a,o,r=n("3fMt"),s=n("eg8w"),l=n("+iDZ"),d=n("PY1i"),c=n("YjQv"),h=c.process,u=c.setImmediate,m=c.clearImmediate,f=c.MessageChannel,p=c.Dispatch,_=0,A={},b=function(){var t=+this;if(A.hasOwnProperty(t)){var e=A[t];delete A[t],e()}},x=function(t){b.call(t.data)};u&&m||(u=function(t){for(var e=[],n=1;arguments.length>n;)e.push(arguments[n++]);return A[++_]=function(){s("function"==typeof t?t:Function(t),e)},i(_),_},m=function(t){delete A[t]},"process"==n("NZra")(h)?i=function(t){h.nextTick(r(b,t,1))}:p&&p.now?i=function(t){p.now(r(b,t,1))}:f?(o=(a=new f).port2,a.port1.onmessage=x,i=r(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(i=function(t){c.postMessage(t+"","*")},c.addEventListener("message",x,!1)):i="onreadystatechange"in d("script")?function(t){l.appendChild(d("script")).onreadystatechange=function(){l.removeChild(this),b.call(t)}}:function(t){setTimeout(r(b,t,1),0)}),t.exports={set:u,clear:m}},krPU:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("tzm-latn",{months:"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),monthsShort:"innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split("_"),weekdays:"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),weekdaysShort:"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),weekdaysMin:"asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[asdkh g] LT",nextDay:"[aska g] LT",nextWeek:"dddd [g] LT",lastDay:"[assant g] LT",lastWeek:"dddd [g] LT",sameElse:"L"},relativeTime:{future:"dadkh s yan %s",past:"yan %s",s:"imik",ss:"%d imik",m:"minuḍ",mm:"%d minuḍ",h:"saɛa",hh:"%d tassaɛin",d:"ass",dd:"%d ossan",M:"ayowr",MM:"%d iyyirn",y:"asgas",yy:"%d isgasn"},week:{dow:6,doy:12}})})(n("PJh5"))},ksFB:function(t,e,n){var i=n("wiaE"),a=n("+MZ2");t.exports=function(t){return i(a(t))}},"ksR/":function(t,e,n){var i=n("Fa60");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("756ed400",i,!0,{})},kwTz:function(t,e,n){var i=n("H9AQ");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("a8b116c2",i,!0,{})},kxFB:function(t,e){t.exports=function(t){return"string"!=typeof t?t:(/^['"].*['"]$/.test(t)&&(t=t.slice(1,-1)),/["'() \t\n]/.test(t)?'"'+t.replace(/"/g,'\\"').replace(/\n/g,"\\n")+'"':t)}},l7Gz:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n/* SEARCH SELECT */\n.select-search-css {\n  display: block;\n  font-size: 10px !important;\n  /* font-family: sans-serif; */\n  /* font-weight: 700; */\n  color: #444;\n  /* line-height: 1.3; */\n  padding: 0;\n  /* width: 100%; */\n  max-width: 100%; \n  -webkit-box-sizing: border-box; \n          box-sizing: border-box;\n  margin: 0;\n  border: 1px solid #aaa;\n  -webkit-box-shadow: 0 1px 0 1px rgba(0,0,0,.04);\n          box-shadow: 0 1px 0 1px rgba(0,0,0,.04);\n  /* border-radius: .5em; */\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background-repeat: no-repeat, repeat;\n  background-position: right 0.2em top 50%, 0 0;\n  background-size: .65em auto, 100%;\n}\n.select-search-css::-ms-expand {\n  display: none;\n}\n.select-search-css:hover {\n  border-color: #888;\n}\n.select-search-css:focus {\n  border-color: #aaa;\n  -webkit-box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);\n          box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);\n  box-shadow: 0 0 0 3px -moz-mac-focusring;\n  color: #222; \n  outline: none;\n}\n.select-search-css option {\n  font-weight:normal;\n}\n.myClassVselect .select-search-css {\n  /* border: 1px solid #ced4da !important; */\n  font-size: 14px !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  color:#6c757d;\n  display: inline-table;\n  padding: 0px;\n  border: unset !important;\n}\n.myClassVselect .vs__selected {\n  color:#6c757d;\n}\n.myClassVselect .vs__dropdown-toggle {\n  /* border: unset !important; */\n  height: 30px;\n  border: 1px solid #ced4da !important;\n  overflow: auto;\n}\n.myClassVselect .vs__dropdown-menu {\n  z-index: 9999 !important;\n}\n.myClassVselect .vs__search {\n  font-size: 14px !important;\n}\n.myClassVselect .vs__search:focus{\n  font-size: 14px !important;\n}\n.fieldObli{\n  margin-top: 1px !important;\n}\n.myClassVselect .vs__actions{\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  padding: 5px 6px 0 3px  !important;\n}\n#selectAccountTransactionList svg.vs__open-indicator {\n  margin-top: 0px !important;\n}\n\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfSelect/PfSelectSearch.css"],names:[],mappings:";AACA,mBAAmB;AACnB;EACE,eAAe;EACf,2BAA2B;EAC3B,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;UACvB,uBAAuB;EAC/B,UAAU;EACV,uBAAuB;EACvB,gDAAgD;UACxC,wCAAwC;EAChD,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,qCAAqC;EACrC,8CAA8C;EAC9C,kCAAkC;CACnC;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,uDAAuD;UAC/C,+CAA+C;EACvD,yCAAyC;EACzC,YAAY;EACZ,cAAc;CACf;AACD;EACE,mBAAmB;CACpB;AACD;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,oCAAoC;UAC5B,4BAA4B;EACpC,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,yBAAyB;CAC1B;AACD;EACE,cAAc;CACf;AACD;EACE,+BAA+B;EAC/B,aAAa;EACb,qCAAqC;EACrC,eAAe;CAChB;AACD;EACE,yBAAyB;CAC1B;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,2BAA2B;CAC5B;AACD;EACE,qCAAqC;MACjC,kCAAkC;UAC9B,+BAA+B;EACvC,mCAAmC;CACpC;AACD;EACE,2BAA2B;CAC5B",file:"PfSelectSearch.css",sourcesContent:["\n/* SEARCH SELECT */\n.select-search-css {\n  display: block;\n  font-size: 10px !important;\n  /* font-family: sans-serif; */\n  /* font-weight: 700; */\n  color: #444;\n  /* line-height: 1.3; */\n  padding: 0;\n  /* width: 100%; */\n  max-width: 100%; \n  -webkit-box-sizing: border-box; \n          box-sizing: border-box;\n  margin: 0;\n  border: 1px solid #aaa;\n  -webkit-box-shadow: 0 1px 0 1px rgba(0,0,0,.04);\n          box-shadow: 0 1px 0 1px rgba(0,0,0,.04);\n  /* border-radius: .5em; */\n  -moz-appearance: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background-repeat: no-repeat, repeat;\n  background-position: right 0.2em top 50%, 0 0;\n  background-size: .65em auto, 100%;\n}\n.select-search-css::-ms-expand {\n  display: none;\n}\n.select-search-css:hover {\n  border-color: #888;\n}\n.select-search-css:focus {\n  border-color: #aaa;\n  -webkit-box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);\n          box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);\n  box-shadow: 0 0 0 3px -moz-mac-focusring;\n  color: #222; \n  outline: none;\n}\n.select-search-css option {\n  font-weight:normal;\n}\n.myClassVselect .select-search-css {\n  /* border: 1px solid #ced4da !important; */\n  font-size: 14px !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  color:#6c757d;\n  display: inline-table;\n  padding: 0px;\n  border: unset !important;\n}\n.myClassVselect .vs__selected {\n  color:#6c757d;\n}\n.myClassVselect .vs__dropdown-toggle {\n  /* border: unset !important; */\n  height: 30px;\n  border: 1px solid #ced4da !important;\n  overflow: auto;\n}\n.myClassVselect .vs__dropdown-menu {\n  z-index: 9999 !important;\n}\n.myClassVselect .vs__search {\n  font-size: 14px !important;\n}\n.myClassVselect .vs__search:focus{\n  font-size: 14px !important;\n}\n.fieldObli{\n  margin-top: 1px !important;\n}\n.myClassVselect .vs__actions{\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  padding: 5px 6px 0 3px  !important;\n}\n#selectAccountTransactionList svg.vs__open-indicator {\n  margin-top: 0px !important;\n}\n\n"],sourceRoot:""}])},l7WR:function(t,e,n){var i=n("aG/u");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("207fa0b8",i,!0,{})},lOED:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("bg",{months:"януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),monthsShort:"яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),weekdays:"неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),weekdaysShort:"нед_пон_вто_сря_чет_пет_съб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[Днес в] LT",nextDay:"[Утре в] LT",nextWeek:"dddd [в] LT",lastDay:"[Вчера в] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[Миналата] dddd [в] LT";case 1:case 2:case 4:case 5:return"[Миналия] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"след %s",past:"преди %s",s:"няколко секунди",ss:"%d секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дена",w:"седмица",ww:"%d седмици",M:"месец",MM:"%d месеца",y:"година",yy:"%d години"},dayOfMonthOrdinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(t){var e=t%10,n=t%100;return 0===t?t+"-ев":0===n?t+"-ен":n>10&&n<20?t+"-ти":1===e?t+"-ви":2===e?t+"-ри":7===e||8===e?t+"-ми":t+"-ти"},week:{dow:1,doy:7}})})(n("PJh5"))},lclE:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-0e439f4c] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-0e439f4c]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-0e439f4c] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-0e439f4c] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-0e439f4c] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-0e439f4c] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-0e439f4c] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-0e439f4c] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-0e439f4c] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-0e439f4c] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-0e439f4c] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-0e439f4c] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-0e439f4c] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-0e439f4c] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-0e439f4c] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-0e439f4c] {\n  margin-right: 0px;\n}\n.newItem[data-v-0e439f4c] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-0e439f4c] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-0e439f4c] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-0e439f4c] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-0e439f4c] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-0e439f4c] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-0e439f4c] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-0e439f4c] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-0e439f4c] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-0e439f4c] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-0e439f4c]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-0e439f4c] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-0e439f4c] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-0e439f4c] {\n  color: red;\n}\n.showMore[data-v-0e439f4c]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-0e439f4c] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-0e439f4c] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-0e439f4c] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-0e439f4c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-0e439f4c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-0e439f4c] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-0e439f4c 3s infinite;\n  animation: bit-data-v-0e439f4c 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-0e439f4c] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-0e439f4c]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-0e439f4c]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-0e439f4c]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-0e439f4c]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-0e439f4c]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-0e439f4c]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-0e439f4c] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-0e439f4c]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-0e439f4c] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-0e439f4c] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-0e439f4c] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-0e439f4c] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-0e439f4c] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-0e439f4c] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-0e439f4c] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-0e439f4c] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-0e439f4c] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-0e439f4c] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-0e439f4c] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-0e439f4c] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-0e439f4c] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-0e439f4c] {\n  margin-right: 0px;\n}\n.newItem[data-v-0e439f4c] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-0e439f4c] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-0e439f4c] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-0e439f4c] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-0e439f4c] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-0e439f4c] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-0e439f4c] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-0e439f4c] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-0e439f4c] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-0e439f4c] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-0e439f4c]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-0e439f4c] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-0e439f4c] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-0e439f4c] {\n  color: red;\n}\n.showMore[data-v-0e439f4c]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-0e439f4c] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-0e439f4c] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-0e439f4c] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-0e439f4c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-0e439f4c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-0e439f4c] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-0e439f4c 3s infinite;\n  animation: bit-data-v-0e439f4c 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-0e439f4c] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-0e439f4c]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-0e439f4c]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-0e439f4c]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-0e439f4c]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-0e439f4c]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-0e439f4c]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},loHW:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.topBarForm {\n  background-color: #f6f6f6;\n  border-top: 1px solid #e2e2e2;\n  border-bottom: 1px solid #e2e2e2;\n  padding: 6px 30px;\n}\n.positionBar {\n  position: sticky;\n  top: 0px;\n  z-index: 1000;\n}\n.payLine {\n  margin-bottom: -5px;\n  height: 21px;\n  border-left: 2px solid #c7c7c7;\n}\n.textPag {\n  width: 30px;\n  height: 18px;\n  background-color: #f6f6f6;\n  border: 0;\n  border-bottom: 2px solid #e2e2e2;\n  padding: 0px;\n  font-size: 15px;\n  color: gray;\n  margin-left: 0.9rem;\n  text-align: center;\n}\n.textZoom {\n  width: 50px;\n  height: 18px;\n  background-color: #f6f6f6;\n  border: 0;\n  border-bottom: 2px solid #e2e2e2;\n  padding: 0px;\n  font-size: 15px;\n  color: gray;\n  margin-left: 0.9rem;\n  text-align: center;\n}\n.selectZoom {\n  padding: 0;\n  border: 0;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n.myToggle.btn-toggle {\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 85px;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  margin-top: -4px;\n}\n.myToggle.btn-toggle:before,\n.myToggle.btn-toggle:after {\n  line-height: 1.5rem;\n  width: 4rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  -webkit-transition: opacity 0.25s;\n  transition: opacity 0.25s;\n}\n.myToggle.btn-toggle:before {\n  content: 'Reverse';\n  left: -4rem;\n}\n.myToggle.btn-toggle:after {\n  content: 'Reverse';\n  right: -4rem;\n  opacity: 0.5;\n}\n.myToggle.btn-toggle > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggle.btn-toggle.active {\n  -webkit-transition: background-color 0.25s;\n  transition: background-color 0.25s;\n}\n.myToggle.btn-toggle.active > .handle {\n  left: 3.95rem;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggle.btn-toggle.btn-sm:before {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.513rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggle.btn-toggle.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 0.613rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggle.btn-toggle.btn-sm:before {\n  text-align: right;\n}\n.myToggle.btn-toggle.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.myToggle.btn-toggle.btn-sm.active:before {\n  opacity: 0;\n}\n.myToggle.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.myToggle.btn-toggle.active {\n  background-color: #d68fea;\n}\n.icontFontZise {\n  cursor: pointer;\n  margin-right: 0.9rem;\n  font-size: 19px;\n}\n.iconDownload {\n  cursor: pointer;\n  margin-left: 0.9rem;\n  margin-right: 0.9rem;\n}\n.icontPrevious {\n  cursor: pointer;\n  margin-left: 0rem;\n  margin-right: 0.9rem;\n  font-size: 19px;\n}\n.icontNext {\n  cursor: pointer;\n  font-size: 19px;\n}\n.countPage {\n  font-size: 15px;\n  margin-right: 0.9rem;\n}\n.zoomOut {\n  cursor: -webkit-zoom-out;\n  cursor: zoom-out;\n  margin-left: 0.9rem;\n  margin-right: 0.9rem;\n  font-size: 19px;\n}\n.zoomIn {\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n  font-size: 19px;\n}\n.iconMoreTools {\n  font-size: 19px;\n  margin-left: 0.9rem;\n  margin-right: 0.9rem;\n}\n.btnImportSend {\n  font-size: 10px !important;\n  margin-top: -7px;\n  margin-left: 0.9rem;\n}\n.myToggleNA.btn-toggle {\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 65px;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  margin-top: -4px;\n}\n.myToggleNA.btn-toggle:before,\n.myToggleNA.btn-toggle:after {\n  line-height: 1.5rem;\n  width: 4rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  -webkit-transition: opacity 0.25s;\n  transition: opacity 0.25s;\n}\n.myToggleNA.btn-toggle:before {\n  content: 'N/A';\n  left: -4rem;\n}\n.myToggleNA.btn-toggle:after {\n  content: 'N/A';\n  right: -4rem;\n  opacity: 0.5;\n}\n.myToggleNA.btn-toggle > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleNA.btn-toggle.active {\n  -webkit-transition: background-color 0.25s;\n  transition: background-color 0.25s;\n}\n.myToggleNA.btn-toggle.active > .handle {\n  left: 2.65rem;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleNA.btn-toggle.btn-sm:before {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.013rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggleNA.btn-toggle.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 0.613rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggleNA.btn-toggle.btn-sm:before {\n  text-align: right;\n}\n.myToggleNA.btn-toggle.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.myToggleNA.btn-toggle.btn-sm.active:before {\n  opacity: 0;\n}\n.myToggleNA.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.myToggleNA.btn-toggle.active {\n  background-color: #62f89c;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfForm/PfTopBarForm/PfTopBarForm.css"],names:[],mappings:";AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,SAAS;EACT,cAAc;CACf;AACD;EACE,oBAAoB;EACpB,aAAa;EACb,+BAA+B;CAChC;AACD;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,UAAU;EACV,iCAAiC;EACjC,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,UAAU;EACV,iCAAiC;EACjC,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;CACpB;AACD;EACE,WAAW;EACX,UAAU;EACV,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,4BAA4B;EAC5B,iBAAiB;CAClB;AACD;;EAEE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,2CAA2C;EAC3C,mCAAmC;CACpC;AACD;EACE,cAAc;EACd,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;CACtB;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,qBAAqB;CACtB;AACD;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;CACjB;AACD;EACE,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;CACtB;AACD;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,4BAA4B;EAC5B,iBAAiB;CAClB;AACD;;EAEE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,UAAU;EACV,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,eAAe;EACf,YAAY;CACb;AACD;EACE,eAAe;EACf,aAAa;EACb,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,2CAA2C;EAC3C,mCAAmC;CACpC;AACD;EACE,cAAc;EACd,+BAA+B;EAC/B,uBAAuB;CACxB;AACD;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;EACE,0BAA0B;CAC3B",file:"PfTopBarForm.css",sourcesContent:["\n.topBarForm {\n  background-color: #f6f6f6;\n  border-top: 1px solid #e2e2e2;\n  border-bottom: 1px solid #e2e2e2;\n  padding: 6px 30px;\n}\n.positionBar {\n  position: sticky;\n  top: 0px;\n  z-index: 1000;\n}\n.payLine {\n  margin-bottom: -5px;\n  height: 21px;\n  border-left: 2px solid #c7c7c7;\n}\n.textPag {\n  width: 30px;\n  height: 18px;\n  background-color: #f6f6f6;\n  border: 0;\n  border-bottom: 2px solid #e2e2e2;\n  padding: 0px;\n  font-size: 15px;\n  color: gray;\n  margin-left: 0.9rem;\n  text-align: center;\n}\n.textZoom {\n  width: 50px;\n  height: 18px;\n  background-color: #f6f6f6;\n  border: 0;\n  border-bottom: 2px solid #e2e2e2;\n  padding: 0px;\n  font-size: 15px;\n  color: gray;\n  margin-left: 0.9rem;\n  text-align: center;\n}\n.selectZoom {\n  padding: 0;\n  border: 0;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n.myToggle.btn-toggle {\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 85px;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  margin-top: -4px;\n}\n.myToggle.btn-toggle:before,\n.myToggle.btn-toggle:after {\n  line-height: 1.5rem;\n  width: 4rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  -webkit-transition: opacity 0.25s;\n  transition: opacity 0.25s;\n}\n.myToggle.btn-toggle:before {\n  content: 'Reverse';\n  left: -4rem;\n}\n.myToggle.btn-toggle:after {\n  content: 'Reverse';\n  right: -4rem;\n  opacity: 0.5;\n}\n.myToggle.btn-toggle > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggle.btn-toggle.active {\n  -webkit-transition: background-color 0.25s;\n  transition: background-color 0.25s;\n}\n.myToggle.btn-toggle.active > .handle {\n  left: 3.95rem;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggle.btn-toggle.btn-sm:before {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.513rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggle.btn-toggle.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 0.613rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggle.btn-toggle.btn-sm:before {\n  text-align: right;\n}\n.myToggle.btn-toggle.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.myToggle.btn-toggle.btn-sm.active:before {\n  opacity: 0;\n}\n.myToggle.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.myToggle.btn-toggle.active {\n  background-color: #d68fea;\n}\n.icontFontZise {\n  cursor: pointer;\n  margin-right: 0.9rem;\n  font-size: 19px;\n}\n.iconDownload {\n  cursor: pointer;\n  margin-left: 0.9rem;\n  margin-right: 0.9rem;\n}\n.icontPrevious {\n  cursor: pointer;\n  margin-left: 0rem;\n  margin-right: 0.9rem;\n  font-size: 19px;\n}\n.icontNext {\n  cursor: pointer;\n  font-size: 19px;\n}\n.countPage {\n  font-size: 15px;\n  margin-right: 0.9rem;\n}\n.zoomOut {\n  cursor: -webkit-zoom-out;\n  cursor: zoom-out;\n  margin-left: 0.9rem;\n  margin-right: 0.9rem;\n  font-size: 19px;\n}\n.zoomIn {\n  cursor: -webkit-zoom-in;\n  cursor: zoom-in;\n  font-size: 19px;\n}\n.iconMoreTools {\n  font-size: 19px;\n  margin-left: 0.9rem;\n  margin-right: 0.9rem;\n}\n.btnImportSend {\n  font-size: 10px !important;\n  margin-top: -7px;\n  margin-left: 0.9rem;\n}\n.myToggleNA.btn-toggle {\n  padding: 0;\n  position: relative;\n  border: none;\n  height: 1.5rem;\n  width: 65px;\n  border-radius: 1.5rem;\n  color: #6b7381;\n  background: #bdc1c8;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  margin-top: -4px;\n}\n.myToggleNA.btn-toggle:before,\n.myToggleNA.btn-toggle:after {\n  line-height: 1.5rem;\n  width: 4rem;\n  text-align: center;\n  font-weight: 600;\n  font-size: 0.75rem;\n  letter-spacing: 2px;\n  position: absolute;\n  bottom: 0;\n  -webkit-transition: opacity 0.25s;\n  transition: opacity 0.25s;\n}\n.myToggleNA.btn-toggle:before {\n  content: 'N/A';\n  left: -4rem;\n}\n.myToggleNA.btn-toggle:after {\n  content: 'N/A';\n  right: -4rem;\n  opacity: 0.5;\n}\n.myToggleNA.btn-toggle > .handle {\n  position: absolute;\n  top: 0.1875rem;\n  left: 0.1875rem;\n  width: 1.125rem;\n  height: 1.125rem;\n  border-radius: 1.125rem;\n  background: #fff;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleNA.btn-toggle.active {\n  -webkit-transition: background-color 0.25s;\n  transition: background-color 0.25s;\n}\n.myToggleNA.btn-toggle.active > .handle {\n  left: 2.65rem;\n  -webkit-transition: left 0.25s;\n  transition: left 0.25s;\n}\n.myToggleNA.btn-toggle.btn-sm:before {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 1.013rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggleNA.btn-toggle.btn-sm:after {\n  line-height: -0.5rem;\n  color: #fff;\n  letter-spacing: 0.75px;\n  left: 0.613rem;\n  width: 2.325rem;\n  font-size: 12px;\n}\n.myToggleNA.btn-toggle.btn-sm:before {\n  text-align: right;\n}\n.myToggleNA.btn-toggle.btn-sm:after {\n  text-align: left;\n  opacity: 0;\n}\n.myToggleNA.btn-toggle.btn-sm.active:before {\n  opacity: 0;\n}\n.myToggleNA.btn-toggle.btn-sm.active:after {\n  opacity: 1;\n}\n.myToggleNA.btn-toggle.active {\n  background-color: #62f89c;\n}\n"],sourceRoot:""}])},m7yE:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");function n(t,n,i,a){var o=function(t){var n=Math.floor(t%1e3/100),i=Math.floor(t%100/10),a=t%10,o="";n>0&&(o+=e[n]+"vatlh");i>0&&(o+=(""!==o?" ":"")+e[i]+"maH");a>0&&(o+=(""!==o?" ":"")+e[a]);return""===o?"pagh":o}(t);switch(i){case"ss":return o+" lup";case"mm":return o+" tup";case"hh":return o+" rep";case"dd":return o+" jaj";case"MM":return o+" jar";case"yy":return o+" DIS"}}t.defineLocale("tlh",{months:"tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’".split("_"),monthsShort:"jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’".split("_"),monthsParseExact:!0,weekdays:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysShort:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),weekdaysMin:"lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[DaHjaj] LT",nextDay:"[wa’leS] LT",nextWeek:"LLL",lastDay:"[wa’Hu’] LT",lastWeek:"LLL",sameElse:"L"},relativeTime:{future:function(t){var e=t;return e=-1!==t.indexOf("jaj")?e.slice(0,-3)+"leS":-1!==t.indexOf("jar")?e.slice(0,-3)+"waQ":-1!==t.indexOf("DIS")?e.slice(0,-3)+"nem":e+" pIq"},past:function(t){var e=t;return e=-1!==t.indexOf("jaj")?e.slice(0,-3)+"Hu’":-1!==t.indexOf("jar")?e.slice(0,-3)+"wen":-1!==t.indexOf("DIS")?e.slice(0,-3)+"ben":e+" ret"},s:"puS lup",ss:n,m:"wa’ tup",mm:n,h:"wa’ rep",hh:n,d:"wa’ jaj",dd:n,M:"wa’ jar",MM:n,y:"wa’ DIS",yy:n},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},mG69:function(t,e,n){n("C84k"),t.exports=n("iANj").Object.values},mO9U:function(t,e,n){var i=n("F90K");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("71078aa6",i,!0,{})},mY9U:function(t,e){t.exports="data:image/gif;base64,R0lGODlhtgAJAIQAAKS+1Ki+0ai+0qm+0am/0Km/0aq/0Ku/z6y/z62/zq6/za+/zK+/zcnZ5sva5sza583b58/d6NHe6eTv/qS+1KS+1KS+1KS+1KS+1KS+1KS+1KS+1KS+1KS+1KS+1KS+1CH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAB8ALAAAAAC2AAkAAAVX4CeOZGmeaKquLAu0cCzPdG3feAlMb+7/wKDQt5vwhsikcnkrGo/MqHSadD6h1Kx267p6e9ywOGv1GsHjtDpYNp/XUoB8Tq/b7/i8fs+vu/99gYKDhHkhADs="},mgCp:function(t,e,n){"use strict";var i,a,o,r,s=n("c8Kh"),l=n("YjQv"),d=n("3fMt"),c=n("FHqv"),h=n("Wdy1"),u=n("8ANE"),m=n("SWGL"),f=n("4S0F"),p=n("dudK"),_=n("BfX3"),A=n("kkvn").set,b=n("LKnP")(),x=n("3HN9"),g=n("AgWD"),v=n("ht0Q"),C=n("qC2Z"),y=l.TypeError,w=l.process,B=w&&w.versions,k=B&&B.v8||"",E=l.Promise,I="process"==c(w),D=function(){},S=a=x.f,N=!!function(){try{var t=E.resolve(1),e=(t.constructor={})[n("hgbu")("species")]=function(t){t(D,D)};return(I||"function"==typeof PromiseRejectionEvent)&&t.then(D)instanceof e&&0!==k.indexOf("6.6")&&-1===v.indexOf("Chrome/66")}catch(t){}}(),M=function(t){var e;return!(!u(t)||"function"!=typeof(e=t.then))&&e},O=function(t,e){if(!t._n){t._n=!0;var n=t._c;b(function(){for(var i=t._v,a=1==t._s,o=0,r=function(e){var n,o,r,s=a?e.ok:e.fail,l=e.resolve,d=e.reject,c=e.domain;try{s?(a||(2==t._h&&j(t),t._h=1),!0===s?n=i:(c&&c.enter(),n=s(i),c&&(c.exit(),r=!0)),n===e.promise?d(y("Promise-chain cycle")):(o=M(n))?o.call(n,l,d):l(n)):d(i)}catch(t){c&&!r&&c.exit(),d(t)}};n.length>o;)r(n[o++]);t._c=[],t._n=!1,e&&!t._h&&T(t)})}},T=function(t){A.call(l,function(){var e,n,i,a=t._v,o=L(t);if(o&&(e=g(function(){I?w.emit("unhandledRejection",a,t):(n=l.onunhandledrejection)?n({promise:t,reason:a}):(i=l.console)&&i.error&&i.error("Unhandled promise rejection",a)}),t._h=I||L(t)?2:1),t._a=void 0,o&&e.e)throw e.v})},L=function(t){return 1!==t._h&&0===(t._a||t._c).length},j=function(t){A.call(l,function(){var e;I?w.emit("rejectionHandled",t):(e=l.onrejectionhandled)&&e({promise:t,reason:t._v})})},P=function(t){var e=this;e._d||(e._d=!0,(e=e._w||e)._v=t,e._s=2,e._a||(e._a=e._c.slice()),O(e,!0))},F=function(t){var e,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===t)throw y("Promise can't be resolved itself");(e=M(t))?b(function(){var i={_w:n,_d:!1};try{e.call(t,d(F,i,1),d(P,i,1))}catch(t){P.call(i,t)}}):(n._v=t,n._s=1,O(n,!1))}catch(t){P.call({_w:n,_d:!1},t)}}};N||(E=function(t){f(this,E,"Promise","_h"),m(t),i.call(this);try{t(d(F,this,1),d(P,this,1))}catch(t){P.call(this,t)}},(i=function(t){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1}).prototype=n("nJ75")(E.prototype,{then:function(t,e){var n=S(_(this,E));return n.ok="function"!=typeof t||t,n.fail="function"==typeof e&&e,n.domain=I?w.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&O(this,!1),n.promise},catch:function(t){return this.then(void 0,t)}}),o=function(){var t=new i;this.promise=t,this.resolve=d(F,t,1),this.reject=d(P,t,1)},x.f=S=function(t){return t===E||t===r?new o(t):a(t)}),h(h.G+h.W+h.F*!N,{Promise:E}),n("LhDF")(E,"Promise"),n("EFoD")("Promise"),r=n("iANj").Promise,h(h.S+h.F*!N,"Promise",{reject:function(t){var e=S(this);return(0,e.reject)(t),e.promise}}),h(h.S+h.F*(s||!N),"Promise",{resolve:function(t){return C(s&&this===r?E:this,t)}}),h(h.S+h.F*!(N&&n("wWcv")(function(t){E.all(t).catch(D)})),"Promise",{all:function(t){var e=this,n=S(e),i=n.resolve,a=n.reject,o=g(function(){var n=[],o=0,r=1;p(t,!1,function(t){var s=o++,l=!1;n.push(void 0),r++,e.resolve(t).then(function(t){l||(l=!0,n[s]=t,--r||i(n))},a)}),--r||i(n)});return o.e&&a(o.v),n.promise},race:function(t){var e=this,n=S(e),i=n.reject,a=g(function(){p(t,!1,function(t){e.resolve(t).then(n.resolve,i)})});return a.e&&i(a.v),n.promise}})},mn8E:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfEads.css",sourceRoot:""}])},mpzb:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.modal-maskMainSend {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: table;\n  -webkit-transition: opacity .3s ease;\n  transition: opacity .3s ease;\n}\n.modal-wrapperMainSend {\n  display: table-cell;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: auto !important;\n}\n\n/* .modal-container {\n  position: absolute;\n  top: 50px;\n  left: 50%;\n  transform: translate(-50%);\n  width: 60%;\n  margin: 0px auto;\n  background-color: #fff;\n  border-radius: 2px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);\n  transition: all .3s ease;\n  font-family: Helvetica, Arial, sans-serif;\n} */\n.modal-containerMainSend {\n  width: 45%;\n  margin: 30px auto;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  /* padding-bottom: 30px */\n}\n.modal-header h3 {\n  color: #ffffff;\n}\n.modal-body {\n  margin: 20px 0;\n  padding-bottom: 30px;\n}\n.modal-default-button {\n  float: right;\n}\n\n/*\n * The following styles are auto-applied to elements with\n * transition="modal" when their visibility is toggled\n * by Vue.js.\n *\n * You can easily play with the modal transition by editing\n * these styles.\n */\n.modal-enter {\n  opacity: 0;\n}\n.modal-leave-active {\n  opacity: 0;\n}\n.modal-enter .modal-container,\n.modal-leave-active .modal-container {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n.vs__deselect {\n  fill: red;\n}\n.sendClose{\n  cursor: pointer;\n}\n.sendClose:hover{\n  font-weight: bold;\n}\n.select-editable {\n  position:relative;\n  background-color:white;\n  width:100%;\n  height:18px;\n}\n.select-editable select {\n  position:absolute;\n  top:0px;\n  left:0px;\n  font-size:14px;\n  width:100%;\n  margin:0;\n}\n.select-editable input {\n  position:absolute;\n  top:0px;\n  left:0px;\n  width:87%;\n  height: 32px;\n  margin-left:6px;\n  margin-top:3px;\n  padding:1px;\n  font-size:14px;\n  border:none;\n  z-index: 99;\n}\n.select-editable select:focus, .select-editable input:focus {\n  outline:none;\n}\n.contentsms, .contentEmail{\n  z-index: 100\n}\n.pContensms, .pContenEmail{\n  margin-bottom: 0px;\n  font-size: 15pt;\n}\n.myInputsGroup{\n  -ms-flex-wrap: inherit !important;\n      flex-wrap: inherit !important;\n}\n@media (max-width: 767px){\n.modal-containerMainSend{\n    width: 430px;\n}\n}\n@media (max-width: 735px){\n.select-editable input {\n    width: 89%;\n}\n}\n@media (max-width: 397px){\n.select-editable input {\n    width: 83%;\n}\n}\n.disableWindow {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.styleCustomSelect{\n  border-radius: 0px 0px 0px 0px !important;\n}\n.darkPrima .select-editable select, .darkPrima .select-editable input{\n  color: #94a0ad !important;\n  background-color: #3b4651 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfSendQuestionnaireModal/PfSendQuestionnaireModal.css"],names:[],mappings:";AACA;EACE,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,qCAAqC;EACrC,6BAA6B;CAC9B;AACD;EACE,oBAAoB;EACpB,gBAAgB;EAChB,OAAO;EACP,SAAS;EACT,UAAU;EACV,QAAQ;EACR,4BAA4B;CAC7B;;AAED;;;;;;;;;;;;IAYI;AACJ;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,kDAAkD;EAClD,0CAA0C;EAC1C,iCAAiC;EACjC,yBAAyB;EACzB,0BAA0B;CAC3B;AACD;EACE,eAAe;CAChB;AACD;EACE,eAAe;EACf,qBAAqB;CACtB;AACD;EACE,aAAa;CACd;;AAED;;;;;;;GAOG;AACH;EACE,WAAW;CACZ;AACD;EACE,WAAW;CACZ;AACD;;EAEE,8BAA8B;EAC9B,sBAAsB;CACvB;AACD;EACE,UAAU;CACX;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,YAAY;CACb;AACD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,WAAW;EACX,SAAS;CACV;AACD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;CACb;AACD;EACE,aAAa;CACd;AACD;EACE,YAAY;CACb;AACD;EACE,mBAAmB;EACnB,gBAAgB;CACjB;AACD;EACE,kCAAkC;MAC9B,8BAA8B;CACnC;AACD;AACA;IACI,aAAa;CAChB;CACA;AACD;AACA;IACI,WAAW;CACd;CACA;AACD;AACA;IACI,WAAW;CACd;CACA;AACD;EACE,oBAAoB;EACpB,qBAAqB;CACtB;AACD;EACE,0CAA0C;CAC3C;AACD;EACE,0BAA0B;EAC1B,qCAAqC;CACtC",file:"PfSendQuestionnaireModal.css",sourcesContent:['\n.modal-maskMainSend {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: table;\n  -webkit-transition: opacity .3s ease;\n  transition: opacity .3s ease;\n}\n.modal-wrapperMainSend {\n  display: table-cell;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  overflow-y: auto !important;\n}\n\n/* .modal-container {\n  position: absolute;\n  top: 50px;\n  left: 50%;\n  transform: translate(-50%);\n  width: 60%;\n  margin: 0px auto;\n  background-color: #fff;\n  border-radius: 2px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);\n  transition: all .3s ease;\n  font-family: Helvetica, Arial, sans-serif;\n} */\n.modal-containerMainSend {\n  width: 45%;\n  margin: 30px auto;\n  background-color: #fff;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  /* padding-bottom: 30px */\n}\n.modal-header h3 {\n  color: #ffffff;\n}\n.modal-body {\n  margin: 20px 0;\n  padding-bottom: 30px;\n}\n.modal-default-button {\n  float: right;\n}\n\n/*\n * The following styles are auto-applied to elements with\n * transition="modal" when their visibility is toggled\n * by Vue.js.\n *\n * You can easily play with the modal transition by editing\n * these styles.\n */\n.modal-enter {\n  opacity: 0;\n}\n.modal-leave-active {\n  opacity: 0;\n}\n.modal-enter .modal-container,\n.modal-leave-active .modal-container {\n  -webkit-transform: scale(1.1);\n  transform: scale(1.1);\n}\n.vs__deselect {\n  fill: red;\n}\n.sendClose{\n  cursor: pointer;\n}\n.sendClose:hover{\n  font-weight: bold;\n}\n.select-editable {\n  position:relative;\n  background-color:white;\n  width:100%;\n  height:18px;\n}\n.select-editable select {\n  position:absolute;\n  top:0px;\n  left:0px;\n  font-size:14px;\n  width:100%;\n  margin:0;\n}\n.select-editable input {\n  position:absolute;\n  top:0px;\n  left:0px;\n  width:87%;\n  height: 32px;\n  margin-left:6px;\n  margin-top:3px;\n  padding:1px;\n  font-size:14px;\n  border:none;\n  z-index: 99;\n}\n.select-editable select:focus, .select-editable input:focus {\n  outline:none;\n}\n.contentsms, .contentEmail{\n  z-index: 100\n}\n.pContensms, .pContenEmail{\n  margin-bottom: 0px;\n  font-size: 15pt;\n}\n.myInputsGroup{\n  -ms-flex-wrap: inherit !important;\n      flex-wrap: inherit !important;\n}\n@media (max-width: 767px){\n.modal-containerMainSend{\n    width: 430px;\n}\n}\n@media (max-width: 735px){\n.select-editable input {\n    width: 89%;\n}\n}\n@media (max-width: 397px){\n.select-editable input {\n    width: 83%;\n}\n}\n.disableWindow {\n  cursor: not-allowed;\n  pointer-events: none;\n}\n.styleCustomSelect{\n  border-radius: 0px 0px 0px 0px !important;\n}\n.darkPrima .select-editable select, .darkPrima .select-editable input{\n  color: #94a0ad !important;\n  background-color: #3b4651 !important;\n}\n'],sourceRoot:""}])},mtWM:function(t,e,n){t.exports=n("tIFN")},mv2c:function(t,e){t.exports="data:image/gif;base64,R0lGODlh9AEJAPcEAMzMzN/f3/Pz8////wAAAP///////////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAAQALAAAAAD0AQkAAAivAAMIHEiwoMGDCBMqXMiwocOHECNKnEix4kIBBzJq3KhRgMWPIEOKHEmypMmEBFKqXMmypcuXMGPKnEmzps2bOHPq3MlTZgCMHDl67Em0qNGjSJMqXcq0qdOnUKNKrfkzaMcAU7Nq3cq1q9evYMOKtVk16NCxaNOqXcu2rdu3M8tehUu3rt27ePPqlXtWr9+/gAMLHnyzal/CiBMrXswY7E+sjSNLnky5MlXLmCcHBAA7"},mvHQ:function(t,e,n){t.exports={default:n("Zbun"),__esModule:!0}},mw3O:function(t,e,n){"use strict";var i=n("CwSZ"),a=n("DDCP"),o=n("XgCd");t.exports={formats:o,parse:a,stringify:i}},nE8X:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("lo",{months:"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),monthsShort:"ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split("_"),weekdays:"ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),weekdaysShort:"ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),weekdaysMin:"ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"ວັນdddd D MMMM YYYY HH:mm"},meridiemParse:/ຕອນເຊົ້າ|ຕອນແລງ/,isPM:function(t){return"ຕອນແລງ"===t},meridiem:function(t,e,n){return t<12?"ຕອນເຊົ້າ":"ຕອນແລງ"},calendar:{sameDay:"[ມື້ນີ້ເວລາ] LT",nextDay:"[ມື້ອື່ນເວລາ] LT",nextWeek:"[ວັນ]dddd[ໜ້າເວລາ] LT",lastDay:"[ມື້ວານນີ້ເວລາ] LT",lastWeek:"[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT",sameElse:"L"},relativeTime:{future:"ອີກ %s",past:"%sຜ່ານມາ",s:"ບໍ່ເທົ່າໃດວິນາທີ",ss:"%d ວິນາທີ",m:"1 ນາທີ",mm:"%d ນາທີ",h:"1 ຊົ່ວໂມງ",hh:"%d ຊົ່ວໂມງ",d:"1 ມື້",dd:"%d ມື້",M:"1 ເດືອນ",MM:"%d ເດືອນ",y:"1 ປີ",yy:"%d ປີ"},dayOfMonthOrdinalParse:/(ທີ່)\d{1,2}/,ordinal:function(t){return"ທີ່"+t}})})(n("PJh5"))},nJ75:function(t,e,n){var i=n("aLzV");t.exports=function(t,e,n){for(var a in e)n&&t[a]?t[a]=e[a]:i(t,a,e[a]);return t}},nJRY:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-4d58d663] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-4d58d663]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-4d58d663] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-4d58d663] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-4d58d663] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-4d58d663] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-4d58d663] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-4d58d663] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-4d58d663] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-4d58d663] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-4d58d663] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-4d58d663] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-4d58d663] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-4d58d663] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-4d58d663] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-4d58d663] {\n  margin-right: 0px;\n}\n.newItem[data-v-4d58d663] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-4d58d663] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-4d58d663] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-4d58d663] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-4d58d663] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-4d58d663] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-4d58d663] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-4d58d663] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-4d58d663] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-4d58d663] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-4d58d663]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-4d58d663] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-4d58d663] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-4d58d663] {\n  color: red;\n}\n.showMore[data-v-4d58d663]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-4d58d663] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-4d58d663] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-4d58d663] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-4d58d663 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-4d58d663 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-4d58d663] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-4d58d663 3s infinite;\n  animation: bit-data-v-4d58d663 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-4d58d663] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-4d58d663]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-4d58d663]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-4d58d663]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-4d58d663]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-4d58d663]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-4d58d663]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-4d58d663] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-4d58d663]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-4d58d663] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-4d58d663] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-4d58d663] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-4d58d663] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-4d58d663] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-4d58d663] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-4d58d663] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-4d58d663] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-4d58d663] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-4d58d663] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-4d58d663] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-4d58d663] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-4d58d663] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-4d58d663] {\n  margin-right: 0px;\n}\n.newItem[data-v-4d58d663] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-4d58d663] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-4d58d663] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-4d58d663] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-4d58d663] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-4d58d663] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-4d58d663] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-4d58d663] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-4d58d663] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-4d58d663] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-4d58d663]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-4d58d663] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-4d58d663] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-4d58d663] {\n  color: red;\n}\n.showMore[data-v-4d58d663]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-4d58d663] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-4d58d663] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-4d58d663] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-4d58d663 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-4d58d663 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-4d58d663] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-4d58d663 3s infinite;\n  animation: bit-data-v-4d58d663 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-4d58d663] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-4d58d663]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-4d58d663]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-4d58d663]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-4d58d663]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-4d58d663]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-4d58d663]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},nLOz:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("gd",{months:["Am Faoilleach","An Gearran","Am Màrt","An Giblean","An Cèitean","An t-Ògmhios","An t-Iuchar","An Lùnastal","An t-Sultain","An Dàmhair","An t-Samhain","An Dùbhlachd"],monthsShort:["Faoi","Gear","Màrt","Gibl","Cèit","Ògmh","Iuch","Lùn","Sult","Dàmh","Samh","Dùbh"],monthsParseExact:!0,weekdays:["Didòmhnaich","Diluain","Dimàirt","Diciadain","Diardaoin","Dihaoine","Disathairne"],weekdaysShort:["Did","Dil","Dim","Dic","Dia","Dih","Dis"],weekdaysMin:["Dò","Lu","Mà","Ci","Ar","Ha","Sa"],longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[An-diugh aig] LT",nextDay:"[A-màireach aig] LT",nextWeek:"dddd [aig] LT",lastDay:"[An-dè aig] LT",lastWeek:"dddd [seo chaidh] [aig] LT",sameElse:"L"},relativeTime:{future:"ann an %s",past:"bho chionn %s",s:"beagan diogan",ss:"%d diogan",m:"mionaid",mm:"%d mionaidean",h:"uair",hh:"%d uairean",d:"latha",dd:"%d latha",M:"mìos",MM:"%d mìosan",y:"bliadhna",yy:"%d bliadhna"},dayOfMonthOrdinalParse:/\d{1,2}(d|na|mh)/,ordinal:function(t){return t+(1===t?"d":t%10==2?"na":"mh")},week:{dow:1,doy:4}})})(n("PJh5"))},nS2h:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),n=["nolla","yhden","kahden","kolmen","neljän","viiden","kuuden",e[7],e[8],e[9]];function i(t,i,a,o){var r="";switch(a){case"s":return o?"muutaman sekunnin":"muutama sekunti";case"ss":r=o?"sekunnin":"sekuntia";break;case"m":return o?"minuutin":"minuutti";case"mm":r=o?"minuutin":"minuuttia";break;case"h":return o?"tunnin":"tunti";case"hh":r=o?"tunnin":"tuntia";break;case"d":return o?"päivän":"päivä";case"dd":r=o?"päivän":"päivää";break;case"M":return o?"kuukauden":"kuukausi";case"MM":r=o?"kuukauden":"kuukautta";break;case"y":return o?"vuoden":"vuosi";case"yy":r=o?"vuoden":"vuotta"}return r=function(t,i){return t<10?i?n[t]:e[t]:t}(t,o)+" "+r}t.defineLocale("fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] HH.mm",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] HH.mm",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] HH.mm",llll:"ddd, Do MMM YYYY, [klo] HH.mm"},calendar:{sameDay:"[tänään] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s päästä",past:"%s sitten",s:i,ss:i,m:i,mm:i,h:i,hh:i,d:i,dd:i,M:i,MM:i,y:i,yy:i},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},ngRd:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.goog-te-banner-frame.skiptranslate {\n  display: none !important;\n}\n.resetTranslate {\n  position: absolute;\n  top: 5px;\n  left: -25px;\n  cursor: pointer;\n}\nbody {\n  top: 0px !important;\n  min-height: 0 !important;\n}\n.messageCh{\n  font-size: 10pt;\n}\n.selectTrans{\n  position:absolute;\n  right: 13px;\n}\n.myNavBar{\n  position: sticky;\n  top: 0px;\n  z-index: 201;\n  width: 99.9%;\n}\n.myNavBar{\n  /* top: -9px !important; */\n  padding-bottom: 0px !important;\n  padding-top: 0px !important;\n}\n.goToLanding{\n  color: rgb(29, 50, 79);\n  cursor: pointer;\n  position: absolute;\n  left: 50%;\n  top: 46%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.goToLanding:hover{\n  text-shadow: 1px 1px 3px #9F9F9F;\n}\n@media (max-width: 767px){\n.messageCh{\n    top: 34px;\n    position: absolute;\n    left: 8px;\n    display: none;\n}\n}\n@media (max-width: 552px){\n.myNavBarFill{\n    padding-bottom: 32px !important;\n}\n.goToLanding{\n    top: 74%;\n    width: 220px;\n}\n}\n@media (max-width: 344px){\n  /* .questionnaires{\n    top: 12px;\n    position: absolute;\n  } */\n\n  /* .selectTrans{\n    top: 20px;\n  } */\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/utils/PfTranslate/PfTranslate.css"],names:[],mappings:";AACA;EACE,yBAAyB;CAC1B;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,oBAAoB;EACpB,yBAAyB;CAC1B;AACD;EACE,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,YAAY;CACb;AACD;EACE,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,aAAa;CACd;AACD;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;CAC7B;AACD;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,iCAAiC;CAClC;AACD;AACA;IACI,UAAU;IACV,mBAAmB;IACnB,UAAU;IACV,cAAc;CACjB;CACA;AACD;AACA;IACI,gCAAgC;CACnC;AACD;IACI,SAAS;IACT,aAAa;CAChB;CACA;AACD;EACE;;;MAGI;;EAEJ;;MAEI;CACL",file:"PfTranslate.css",sourcesContent:["\n.goog-te-banner-frame.skiptranslate {\n  display: none !important;\n}\n.resetTranslate {\n  position: absolute;\n  top: 5px;\n  left: -25px;\n  cursor: pointer;\n}\nbody {\n  top: 0px !important;\n  min-height: 0 !important;\n}\n.messageCh{\n  font-size: 10pt;\n}\n.selectTrans{\n  position:absolute;\n  right: 13px;\n}\n.myNavBar{\n  position: sticky;\n  top: 0px;\n  z-index: 201;\n  width: 99.9%;\n}\n.myNavBar{\n  /* top: -9px !important; */\n  padding-bottom: 0px !important;\n  padding-top: 0px !important;\n}\n.goToLanding{\n  color: rgb(29, 50, 79);\n  cursor: pointer;\n  position: absolute;\n  left: 50%;\n  top: 46%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.goToLanding:hover{\n  text-shadow: 1px 1px 3px #9F9F9F;\n}\n@media (max-width: 767px){\n.messageCh{\n    top: 34px;\n    position: absolute;\n    left: 8px;\n    display: none;\n}\n}\n@media (max-width: 552px){\n.myNavBarFill{\n    padding-bottom: 32px !important;\n}\n.goToLanding{\n    top: 74%;\n    width: 220px;\n}\n}\n@media (max-width: 344px){\n  /* .questionnaires{\n    top: 12px;\n    position: absolute;\n  } */\n\n  /* .selectTrans{\n    top: 20px;\n  } */\n}\n"],sourceRoot:""}])},npKs:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.wrapper[data-v-d4bf850e] {\n  font-family: \"Roboto\", sans-serif;\n  font-size: medium;\n}\n.error[data-v-d4bf850e] {\n  color: red;\n}\n.vertical-align-wrap[data-v-d4bf850e] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: table;\n}\n.vertical-align-middle[data-v-d4bf850e] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.auth-main[data-v-d4bf850e]::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -2;\n}\n.auth-main[data-v-d4bf850e]::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  z-index: -1;\n  background: #2b2e33;\n  -webkit-box-shadow: 5px 6px 6px 0px rgba(0, 0, 0, 0.6);\n  box-shadow: 5px 6px 6px 0px rgba(0, 0, 0, 0.6);\n}\n.auth-main .mobile-logo[data-v-d4bf850e] {\n  display: none;\n}\n.auth-main .auth-box .auth-left[data-v-d4bf850e]::before {\n  content: \"\";\n  width: 300px;\n  height: 100%;\n  background-color: #49c5b6;\n  position: absolute;\n  left: 0;\n  border-radius: 12px 0 0 12px;\n}\n.auth-main .auth-box[data-v-d4bf850e] {\n  background-color: #fff;\n  border-radius: 12px;\n  max-width: 870px;\n  width: calc(100% - 40px);\n  height: auto;\n  margin: 0 auto 0 100px;\n  position: relative;\n  /* box-shadow: 3px 3px 20px 5px rgba(0,0,0,0.05) */\n}\n.auth-main .auth-box .auth-left[data-v-d4bf850e] {\n  width: 300px;\n  position: absolute;\n  height: 100%;\n}\n.auth-main .auth-box .auth-left .left-top[data-v-d4bf850e] {\n  position: absolute;\n  top: -60px;\n  width: 100%;\n}\n.auth-main .auth-box .auth-left .left-top img[data-v-d4bf850e] {\n  width: 140px !important;\n  margin-top: -38px;\n}\n.auth-main .mobile-logo img[data-v-d4bf850e] {\n  width: 140px !important;\n  margin-top: -38px;\n}\n.auth-main .auth-box .auth-left .left-top span[data-v-d4bf850e] {\n  font-size: 24px;\n  /* font-weight: 600 */\n  line-height: 50px;\n  color: #fff;\n  text-indent: 5px;\n  letter-spacing: 2px;\n}\n.auth-main .auth-box .auth-left .left-slider[data-v-d4bf850e] {\n  height: 100%;\n  position: relative;\n  border-radius: 12px 0 0 12px;\n  overflow: hidden;\n}\n.auth-main .auth-box .auth-right[data-v-d4bf850e] {\n  padding-left: 300px;\n  position: relative;\n  border: 1px solid #2b2e33;\n  border-radius: 5px;\n}\n.auth-main .auth-box .auth-right .right-top[data-v-d4bf850e] {\n  position: absolute;\n  right: 0;\n  top: -60px;\n}\n.auth-main .auth-box .auth-right .right-top ul li a[data-v-d4bf850e] {\n  font-size: 16px;\n  line-height: 60px;\n  color: #777;\n}\n.p-l-10[data-v-d4bf850e], .auth-main .auth-box .auth-right .right-top ul li[data-v-d4bf850e], .right-sidebar .new_timeline > ul[data-v-d4bf850e], .choose-skin li span[data-v-d4bf850e] {\n  padding-left: 10px;\n}\n.p-r-5[data-v-d4bf850e], .auth-main .auth-box .auth-right .right-top ul li[data-v-d4bf850e], .wizard.vertical > .steps[data-v-d4bf850e] {\n  padding-right: 5px;\n}\n.auth-main .card[data-v-d4bf850e] {\n  /* background-color: transparent */\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 20px;\n  border-radius: 5px;\n  -webkit-box-shadow: 4px 3px 7px 0px rgba(0, 0, 0, 0.5);\n  box-shadow: 4px 3px 7px 0px rgba(0, 0, 0, 0.5);\n}\n.card[data-v-d4bf850e] {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background: #fff;\n  background-color: white;\n  border-radius: .1875rem;\n  border-color: #fff;\n  margin-bottom: 30px;\n  position: relative;\n  width: 100%;\n}\n.card .header[data-v-d4bf850e] {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #444;\n  padding: 20px;\n  position: relative;\n}\n.auth-main .auth-box .lead[data-v-d4bf850e] {\n  font-size: 18px;\n  font-weight: 600;\n}\n.auth-main .card .body[data-v-d4bf850e] {\n  max-width: 400px;\n  width: 100%;\n  margin: 0 auto;\n}\n.card .body[data-v-d4bf850e] {\n  color: #444;\n  font-weight: 400;\n  padding: 20px;\n}\n.btn[data-v-d4bf850e] {\n  font-size: 14px;\n}\n.auth-main .btn-primary[data-v-d4bf850e] {\n  background: #3eacff;\n  border-color: #3eacff;\n}\n.auth-main .auth-box .helper-text[data-v-d4bf850e] {\n  color: #222;\n}\n.auth-main .auth-box .bottom a[data-v-d4bf850e] {\n  color: #222;\n  /* text-decoration: black */\n}\n.inlineblock[data-v-d4bf850e], .card[data-v-d4bf850e], .card .header .header-dropdown li[data-v-d4bf850e], .navbar-fixed-top .navbar-brand .name[data-v-d4bf850e], .navbar-fixed-top .navbar-right .navbar-nav[data-v-d4bf850e], .navbar-fixed-top .navbar-right .navbar-nav > li[data-v-d4bf850e], .user-account .dropdown[data-v-d4bf850e], .auth-main .auth-box .auth-left .left-top span[data-v-d4bf850e], .accordion2 .accordion-thumb[data-v-d4bf850e]::before, .wizard .actions ul[data-v-d4bf850e], .choose-skin li div[data-v-d4bf850e], .choose-skin li span[data-v-d4bf850e], .info-box-2 .icon[data-v-d4bf850e], .info-box-2 .content[data-v-d4bf850e], .new_timeline .header .color-overlay .day-number[data-v-d4bf850e], .new_timeline .header .color-overlay .date-right[data-v-d4bf850e], .new_timeline li div[data-v-d4bf850e], .team-info li[data-v-d4bf850e], .dt-bootstrap4 .dt-buttons[data-v-d4bf850e], .dt-bootstrap4 .dataTables_info[data-v-d4bf850e], .dt-bootstrap4 .dt-buttons + .dataTables_filter[data-v-d4bf850e], .dt-bootstrap4 .dt-buttons + .dataTables_paginate[data-v-d4bf850e], .dt-bootstrap4 .dataTables_info + .dataTables_filter[data-v-d4bf850e], .dt-bootstrap4 .dataTables_info + .dataTables_paginate[data-v-d4bf850e], .weather .days li[data-v-d4bf850e], .weather3 .top .wrapper .temp .temp-value[data-v-d4bf850e], .weather3 .top .wrapper .temp .deg[data-v-d4bf850e], .chat-widget li.right .chat-info[data-v-d4bf850e], .chat-widget li .chat-info[data-v-d4bf850e], .stats-report .stat-item[data-v-d4bf850e], .chart.easy-pie-chart-1[data-v-d4bf850e], .c_list .c_name[data-v-d4bf850e], .right_chat .media .message[data-v-d4bf850e], .right_chat .media .status[data-v-d4bf850e], .member-card .social-links li[data-v-d4bf850e], .social_icon[data-v-d4bf850e], .fc .fc-agendaWeek-view .fc-head .fc-widget-header span[data-v-d4bf850e], .fc .fc-agendaDay-view .fc-head .fc-widget-header span[data-v-d4bf850e], .fc .fc-listWeek-view .fc-head .fc-widget-header span[data-v-d4bf850e] {\n  display: inline-block;\n}\n.align-center[data-v-d4bf850e], .navbar-nav ul.user-menu .menu-button[data-v-d4bf850e], .auth-main .card[data-v-d4bf850e], .auth-main .card .header[data-v-d4bf850e], .auth-main .auth-box .auth-left .left-top[data-v-d4bf850e], .auth-main .auth-box .form-auth-small .bottom[data-v-d4bf850e], .separator-linethrough[data-v-d4bf850e], .sparkline[data-v-d4bf850e], .page-loader-wrapper[data-v-d4bf850e], .info-box-2 .chart[data-v-d4bf850e], .top_counter .icon[data-v-d4bf850e], .profile_state[data-v-d4bf850e], .weather2 .days-list .day[data-v-d4bf850e], .weather .days li[data-v-d4bf850e], .weather3 .top[data-v-d4bf850e], .chart.easy-pie-chart-1[data-v-d4bf850e], .chart.easy-pie-chart-1 > span > img[data-v-d4bf850e], .c_list address i[data-v-d4bf850e], .member-card[data-v-d4bf850e], .w_social3 .card[data-v-d4bf850e], .social_icon[data-v-d4bf850e], .profilepage_2 .profile-header[data-v-d4bf850e], .file_manager .file .icon[data-v-d4bf850e], .pricing[data-v-d4bf850e], .pricing2[data-v-d4bf850e], .testimonials .body[data-v-d4bf850e] {\n  text-align: center;\n}\n.padding-0[data-v-d4bf850e], .card .header .header-dropdown[data-v-d4bf850e], .navbar-fixed-top[data-v-d4bf850e], .navbar-fixed-top .navbar-btn[data-v-d4bf850e], .navbar-nav ul.task[data-v-d4bf850e], .navbar-nav .user-profile[data-v-d4bf850e], .search-form[data-v-d4bf850e], .search-form .btn[data-v-d4bf850e], .auth-main .card .header[data-v-d4bf850e], .block-header .breadcrumb[data-v-d4bf850e], .accordion .card-header[data-v-d4bf850e], .accordion2[data-v-d4bf850e], .ct-legend[data-v-d4bf850e], .right-sidebar .nav-tabs + .tab-content[data-v-d4bf850e], .right-sidebar .nav-tabs[data-v-d4bf850e], .mega_menubar .links[data-v-d4bf850e], .new_timeline .header[data-v-d4bf850e], .weather3 .bottom .forecast[data-v-d4bf850e], .chat-widget[data-v-d4bf850e], .right_chat .media .status[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-basic-view > table > thead tr th.fc-agenda-gutter[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-basic-view > table > thead tr td.fc-agenda-gutter[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-agenda > table > thead tr th.fc-agenda-gutter[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-agenda > table > thead tr td.fc-agenda-gutter[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-basic-view > table > thead tr td.fc-widget-header[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-agenda > table > thead tr td.fc-widget-header[data-v-d4bf850e], .fc .fc-popover .fc-event-container[data-v-d4bf850e], .file_manager .file[data-v-d4bf850e], .pricing.body[data-v-d4bf850e], .pricing2 .body[data-v-d4bf850e], .pricing2 .pricing-plan[data-v-d4bf850e], .pricing2 .pricing-plan .pricing-features[data-v-d4bf850e] {\n  padding: 0 !important;\n}\n.m-b-0[data-v-d4bf850e], .card .header[data-v-d4bf850e], .navbar-nav ul.notifications li > a .media[data-v-d4bf850e], .navbar-nav ul.notifications li .text[data-v-d4bf850e], .navbar-nav ul.task li a .progress[data-v-d4bf850e], .navbar-nav .user-profile .drop-right h4[data-v-d4bf850e], .navbar-nav .user-profile .drop-right p[data-v-d4bf850e], .auth-main .card[data-v-d4bf850e], .auth-main .auth-box .auth-right .right-top ul[data-v-d4bf850e], .auth-main .auth-box .lead[data-v-d4bf850e], .block-header h2[data-v-d4bf850e], .block-header .breadcrumb[data-v-d4bf850e], #toast-container .toast[data-v-d4bf850e], .right-sidebar .card[data-v-d4bf850e], .right-sidebar .card ul[data-v-d4bf850e], .contact-list li .contact-name[data-v-d4bf850e], .top_counter .content .number[data-v-d4bf850e], .basic-list[data-v-d4bf850e], .weather .city h3[data-v-d4bf850e], .weather6 p[data-v-d4bf850e], .feeds_widget[data-v-d4bf850e], .c_list .fancy-checkbox[data-v-d4bf850e], .c_list .c_name[data-v-d4bf850e], .c_list address[data-v-d4bf850e], .social_media_table .table[data-v-d4bf850e], .page-calendar .event-name h6[data-v-d4bf850e], .page-calendar .event-name h4[data-v-d4bf850e], .page-calendar .event-name p[data-v-d4bf850e], .page-calendar .event-name address[data-v-d4bf850e], .folder h6[data-v-d4bf850e], .pricing[data-v-d4bf850e], .pricing h3[data-v-d4bf850e], .testimonial4 h6[data-v-d4bf850e] {\n  margin-bottom: 0px;\n}\n.m-t-5[data-v-d4bf850e], .card .header h2 small[data-v-d4bf850e], .user-account .user-photo[data-v-d4bf850e], .user-account .dropdown[data-v-d4bf850e], .auth-main .auth-box .lead[data-v-d4bf850e], .setting-list li[data-v-d4bf850e], .team-info[data-v-d4bf850e], .page-calendar .event-name address[data-v-d4bf850e] {\n  margin-top: 5px;\n}\n.m-b-5[data-v-d4bf850e], .sidebar .metismenu li.heading[data-v-d4bf850e], .form-group label[data-v-d4bf850e], .choose-skin li[data-v-d4bf850e], .weather .days li img[data-v-d4bf850e] {\n  margin-bottom: 5px;\n}\n@media (max-width: 992px) {\n.auth-main[data-v-d4bf850e]::before {\n    width: 320px;\n}\n.auth-main .auth-box[data-v-d4bf850e] {\n    margin: 0 20px;\n}\n}\n@media (max-width: 640px) {\n.auth-main .auth-box .auth-left[data-v-d4bf850e] {\n    display: none;\n}\n.auth-main .mobile-logo[data-v-d4bf850e] {\n    text-align: center;\n}\n.auth-main .mobile-logo[data-v-d4bf850e] {\n    display: block;\n    text-align: center;\n    position: absolute;\n    width: 100%;\n    top: -60px;\n}\n.auth-main[data-v-d4bf850e]::before {\n    width: 100%;\n}\n.auth-main[data-v-d4bf850e] {\n    padding-top: 70px;\n    padding-bottom: 30px;\n}\n.auth-main .auth-box .auth-right[data-v-d4bf850e] {\n    padding-left: 0;\n}\n.auth-main .auth-box .auth-right .right-top[data-v-d4bf850e] {\n    top: auto;\n    bottom: -60px;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    right: auto;\n    display: none;\n}\n.auth-main .card[data-v-d4bf850e] {\n    padding-left: 0;\n    padding-right: 0;\n}\n}\n.shadowLiRight[data-v-d4bf850e] {\n  text-shadow: 2px 3px 3px rgba(0, 0, 0, 0.4);\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfLogin/PfLogin.css"],names:[],mappings:";AACA;EACE,kCAAkC;EAClC,kBAAkB;CACnB;AACD;EACE,WAAW;CACZ;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;CAChB;AACD;EACE,oBAAoB;EACpB,uBAAuB;CACxB;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;CACb;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,uDAAuD;EACvD,+CAA+C;CAChD;AACD;EACE,cAAc;CACf;AACD;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;CAC9B;AACD;EACE,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mDAAmD;CACpD;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;CACd;AACD;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;CACb;AACD;EACE,wBAAwB;EACxB,kBAAkB;CACnB;AACD;EACE,wBAAwB;EACxB,kBAAkB;CACnB;AACD;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;CAClB;AACD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,SAAS;EACT,WAAW;CACZ;AACD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;CACb;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mCAAmC;EACnC,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,uDAAuD;EACvD,+CAA+C;CAChD;AACD;EACE,yCAAyC;EACzC,iCAAiC;EACjC,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;CACb;AACD;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,mBAAmB;CACpB;AACD;EACE,gBAAgB;EAChB,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;CAChB;AACD;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;CACf;AACD;EACE,gBAAgB;CACjB;AACD;EACE,oBAAoB;EACpB,sBAAsB;CACvB;AACD;EACE,YAAY;CACb;AACD;EACE,YAAY;EACZ,4BAA4B;CAC7B;AACD;EACE,sBAAsB;CACvB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,gBAAgB;CACjB;AACD;EACE,mBAAmB;CACpB;AACD;AACA;IACI,aAAa;CAChB;AACD;IACI,eAAe;CAClB;CACA;AACD;AACA;IACI,cAAc;CACjB;AACD;IACI,mBAAmB;CACtB;AACD;IACI,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,WAAW;CACd;AACD;IACI,YAAY;CACf;AACD;IACI,kBAAkB;IAClB,qBAAqB;CACxB;AACD;IACI,gBAAgB;CACnB;AACD;IACI,UAAU;IACV,cAAc;IACd,UAAU;IACV,oCAAoC;IACpC,4BAA4B;IAC5B,YAAY;IACZ,cAAc;CACjB;AACD;IACI,gBAAgB;IAChB,iBAAiB;CACpB;CACA;AACD;EACE,4CAA4C;CAC7C",file:"PfLogin.css",sourcesContent:["\n.wrapper[data-v-d4bf850e] {\n  font-family: \"Roboto\", sans-serif;\n  font-size: medium;\n}\n.error[data-v-d4bf850e] {\n  color: red;\n}\n.vertical-align-wrap[data-v-d4bf850e] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: table;\n}\n.vertical-align-middle[data-v-d4bf850e] {\n  display: table-cell;\n  vertical-align: middle;\n}\n.auth-main[data-v-d4bf850e]::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -2;\n}\n.auth-main[data-v-d4bf850e]::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 400px;\n  height: 100%;\n  z-index: -1;\n  background: #2b2e33;\n  -webkit-box-shadow: 5px 6px 6px 0px rgba(0, 0, 0, 0.6);\n  box-shadow: 5px 6px 6px 0px rgba(0, 0, 0, 0.6);\n}\n.auth-main .mobile-logo[data-v-d4bf850e] {\n  display: none;\n}\n.auth-main .auth-box .auth-left[data-v-d4bf850e]::before {\n  content: \"\";\n  width: 300px;\n  height: 100%;\n  background-color: #49c5b6;\n  position: absolute;\n  left: 0;\n  border-radius: 12px 0 0 12px;\n}\n.auth-main .auth-box[data-v-d4bf850e] {\n  background-color: #fff;\n  border-radius: 12px;\n  max-width: 870px;\n  width: calc(100% - 40px);\n  height: auto;\n  margin: 0 auto 0 100px;\n  position: relative;\n  /* box-shadow: 3px 3px 20px 5px rgba(0,0,0,0.05) */\n}\n.auth-main .auth-box .auth-left[data-v-d4bf850e] {\n  width: 300px;\n  position: absolute;\n  height: 100%;\n}\n.auth-main .auth-box .auth-left .left-top[data-v-d4bf850e] {\n  position: absolute;\n  top: -60px;\n  width: 100%;\n}\n.auth-main .auth-box .auth-left .left-top img[data-v-d4bf850e] {\n  width: 140px !important;\n  margin-top: -38px;\n}\n.auth-main .mobile-logo img[data-v-d4bf850e] {\n  width: 140px !important;\n  margin-top: -38px;\n}\n.auth-main .auth-box .auth-left .left-top span[data-v-d4bf850e] {\n  font-size: 24px;\n  /* font-weight: 600 */\n  line-height: 50px;\n  color: #fff;\n  text-indent: 5px;\n  letter-spacing: 2px;\n}\n.auth-main .auth-box .auth-left .left-slider[data-v-d4bf850e] {\n  height: 100%;\n  position: relative;\n  border-radius: 12px 0 0 12px;\n  overflow: hidden;\n}\n.auth-main .auth-box .auth-right[data-v-d4bf850e] {\n  padding-left: 300px;\n  position: relative;\n  border: 1px solid #2b2e33;\n  border-radius: 5px;\n}\n.auth-main .auth-box .auth-right .right-top[data-v-d4bf850e] {\n  position: absolute;\n  right: 0;\n  top: -60px;\n}\n.auth-main .auth-box .auth-right .right-top ul li a[data-v-d4bf850e] {\n  font-size: 16px;\n  line-height: 60px;\n  color: #777;\n}\n.p-l-10[data-v-d4bf850e], .auth-main .auth-box .auth-right .right-top ul li[data-v-d4bf850e], .right-sidebar .new_timeline > ul[data-v-d4bf850e], .choose-skin li span[data-v-d4bf850e] {\n  padding-left: 10px;\n}\n.p-r-5[data-v-d4bf850e], .auth-main .auth-box .auth-right .right-top ul li[data-v-d4bf850e], .wizard.vertical > .steps[data-v-d4bf850e] {\n  padding-right: 5px;\n}\n.auth-main .card[data-v-d4bf850e] {\n  /* background-color: transparent */\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 20px;\n  border-radius: 5px;\n  -webkit-box-shadow: 4px 3px 7px 0px rgba(0, 0, 0, 0.5);\n  box-shadow: 4px 3px 7px 0px rgba(0, 0, 0, 0.5);\n}\n.card[data-v-d4bf850e] {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  background: #fff;\n  background-color: white;\n  border-radius: .1875rem;\n  border-color: #fff;\n  margin-bottom: 30px;\n  position: relative;\n  width: 100%;\n}\n.card .header[data-v-d4bf850e] {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  color: #444;\n  padding: 20px;\n  position: relative;\n}\n.auth-main .auth-box .lead[data-v-d4bf850e] {\n  font-size: 18px;\n  font-weight: 600;\n}\n.auth-main .card .body[data-v-d4bf850e] {\n  max-width: 400px;\n  width: 100%;\n  margin: 0 auto;\n}\n.card .body[data-v-d4bf850e] {\n  color: #444;\n  font-weight: 400;\n  padding: 20px;\n}\n.btn[data-v-d4bf850e] {\n  font-size: 14px;\n}\n.auth-main .btn-primary[data-v-d4bf850e] {\n  background: #3eacff;\n  border-color: #3eacff;\n}\n.auth-main .auth-box .helper-text[data-v-d4bf850e] {\n  color: #222;\n}\n.auth-main .auth-box .bottom a[data-v-d4bf850e] {\n  color: #222;\n  /* text-decoration: black */\n}\n.inlineblock[data-v-d4bf850e], .card[data-v-d4bf850e], .card .header .header-dropdown li[data-v-d4bf850e], .navbar-fixed-top .navbar-brand .name[data-v-d4bf850e], .navbar-fixed-top .navbar-right .navbar-nav[data-v-d4bf850e], .navbar-fixed-top .navbar-right .navbar-nav > li[data-v-d4bf850e], .user-account .dropdown[data-v-d4bf850e], .auth-main .auth-box .auth-left .left-top span[data-v-d4bf850e], .accordion2 .accordion-thumb[data-v-d4bf850e]::before, .wizard .actions ul[data-v-d4bf850e], .choose-skin li div[data-v-d4bf850e], .choose-skin li span[data-v-d4bf850e], .info-box-2 .icon[data-v-d4bf850e], .info-box-2 .content[data-v-d4bf850e], .new_timeline .header .color-overlay .day-number[data-v-d4bf850e], .new_timeline .header .color-overlay .date-right[data-v-d4bf850e], .new_timeline li div[data-v-d4bf850e], .team-info li[data-v-d4bf850e], .dt-bootstrap4 .dt-buttons[data-v-d4bf850e], .dt-bootstrap4 .dataTables_info[data-v-d4bf850e], .dt-bootstrap4 .dt-buttons + .dataTables_filter[data-v-d4bf850e], .dt-bootstrap4 .dt-buttons + .dataTables_paginate[data-v-d4bf850e], .dt-bootstrap4 .dataTables_info + .dataTables_filter[data-v-d4bf850e], .dt-bootstrap4 .dataTables_info + .dataTables_paginate[data-v-d4bf850e], .weather .days li[data-v-d4bf850e], .weather3 .top .wrapper .temp .temp-value[data-v-d4bf850e], .weather3 .top .wrapper .temp .deg[data-v-d4bf850e], .chat-widget li.right .chat-info[data-v-d4bf850e], .chat-widget li .chat-info[data-v-d4bf850e], .stats-report .stat-item[data-v-d4bf850e], .chart.easy-pie-chart-1[data-v-d4bf850e], .c_list .c_name[data-v-d4bf850e], .right_chat .media .message[data-v-d4bf850e], .right_chat .media .status[data-v-d4bf850e], .member-card .social-links li[data-v-d4bf850e], .social_icon[data-v-d4bf850e], .fc .fc-agendaWeek-view .fc-head .fc-widget-header span[data-v-d4bf850e], .fc .fc-agendaDay-view .fc-head .fc-widget-header span[data-v-d4bf850e], .fc .fc-listWeek-view .fc-head .fc-widget-header span[data-v-d4bf850e] {\n  display: inline-block;\n}\n.align-center[data-v-d4bf850e], .navbar-nav ul.user-menu .menu-button[data-v-d4bf850e], .auth-main .card[data-v-d4bf850e], .auth-main .card .header[data-v-d4bf850e], .auth-main .auth-box .auth-left .left-top[data-v-d4bf850e], .auth-main .auth-box .form-auth-small .bottom[data-v-d4bf850e], .separator-linethrough[data-v-d4bf850e], .sparkline[data-v-d4bf850e], .page-loader-wrapper[data-v-d4bf850e], .info-box-2 .chart[data-v-d4bf850e], .top_counter .icon[data-v-d4bf850e], .profile_state[data-v-d4bf850e], .weather2 .days-list .day[data-v-d4bf850e], .weather .days li[data-v-d4bf850e], .weather3 .top[data-v-d4bf850e], .chart.easy-pie-chart-1[data-v-d4bf850e], .chart.easy-pie-chart-1 > span > img[data-v-d4bf850e], .c_list address i[data-v-d4bf850e], .member-card[data-v-d4bf850e], .w_social3 .card[data-v-d4bf850e], .social_icon[data-v-d4bf850e], .profilepage_2 .profile-header[data-v-d4bf850e], .file_manager .file .icon[data-v-d4bf850e], .pricing[data-v-d4bf850e], .pricing2[data-v-d4bf850e], .testimonials .body[data-v-d4bf850e] {\n  text-align: center;\n}\n.padding-0[data-v-d4bf850e], .card .header .header-dropdown[data-v-d4bf850e], .navbar-fixed-top[data-v-d4bf850e], .navbar-fixed-top .navbar-btn[data-v-d4bf850e], .navbar-nav ul.task[data-v-d4bf850e], .navbar-nav .user-profile[data-v-d4bf850e], .search-form[data-v-d4bf850e], .search-form .btn[data-v-d4bf850e], .auth-main .card .header[data-v-d4bf850e], .block-header .breadcrumb[data-v-d4bf850e], .accordion .card-header[data-v-d4bf850e], .accordion2[data-v-d4bf850e], .ct-legend[data-v-d4bf850e], .right-sidebar .nav-tabs + .tab-content[data-v-d4bf850e], .right-sidebar .nav-tabs[data-v-d4bf850e], .mega_menubar .links[data-v-d4bf850e], .new_timeline .header[data-v-d4bf850e], .weather3 .bottom .forecast[data-v-d4bf850e], .chat-widget[data-v-d4bf850e], .right_chat .media .status[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-basic-view > table > thead tr th.fc-agenda-gutter[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-basic-view > table > thead tr td.fc-agenda-gutter[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-agenda > table > thead tr th.fc-agenda-gutter[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-agenda > table > thead tr td.fc-agenda-gutter[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-basic-view > table > thead tr td.fc-widget-header[data-v-d4bf850e], .fc .fc-view-container .fc-view.fc-agenda > table > thead tr td.fc-widget-header[data-v-d4bf850e], .fc .fc-popover .fc-event-container[data-v-d4bf850e], .file_manager .file[data-v-d4bf850e], .pricing.body[data-v-d4bf850e], .pricing2 .body[data-v-d4bf850e], .pricing2 .pricing-plan[data-v-d4bf850e], .pricing2 .pricing-plan .pricing-features[data-v-d4bf850e] {\n  padding: 0 !important;\n}\n.m-b-0[data-v-d4bf850e], .card .header[data-v-d4bf850e], .navbar-nav ul.notifications li > a .media[data-v-d4bf850e], .navbar-nav ul.notifications li .text[data-v-d4bf850e], .navbar-nav ul.task li a .progress[data-v-d4bf850e], .navbar-nav .user-profile .drop-right h4[data-v-d4bf850e], .navbar-nav .user-profile .drop-right p[data-v-d4bf850e], .auth-main .card[data-v-d4bf850e], .auth-main .auth-box .auth-right .right-top ul[data-v-d4bf850e], .auth-main .auth-box .lead[data-v-d4bf850e], .block-header h2[data-v-d4bf850e], .block-header .breadcrumb[data-v-d4bf850e], #toast-container .toast[data-v-d4bf850e], .right-sidebar .card[data-v-d4bf850e], .right-sidebar .card ul[data-v-d4bf850e], .contact-list li .contact-name[data-v-d4bf850e], .top_counter .content .number[data-v-d4bf850e], .basic-list[data-v-d4bf850e], .weather .city h3[data-v-d4bf850e], .weather6 p[data-v-d4bf850e], .feeds_widget[data-v-d4bf850e], .c_list .fancy-checkbox[data-v-d4bf850e], .c_list .c_name[data-v-d4bf850e], .c_list address[data-v-d4bf850e], .social_media_table .table[data-v-d4bf850e], .page-calendar .event-name h6[data-v-d4bf850e], .page-calendar .event-name h4[data-v-d4bf850e], .page-calendar .event-name p[data-v-d4bf850e], .page-calendar .event-name address[data-v-d4bf850e], .folder h6[data-v-d4bf850e], .pricing[data-v-d4bf850e], .pricing h3[data-v-d4bf850e], .testimonial4 h6[data-v-d4bf850e] {\n  margin-bottom: 0px;\n}\n.m-t-5[data-v-d4bf850e], .card .header h2 small[data-v-d4bf850e], .user-account .user-photo[data-v-d4bf850e], .user-account .dropdown[data-v-d4bf850e], .auth-main .auth-box .lead[data-v-d4bf850e], .setting-list li[data-v-d4bf850e], .team-info[data-v-d4bf850e], .page-calendar .event-name address[data-v-d4bf850e] {\n  margin-top: 5px;\n}\n.m-b-5[data-v-d4bf850e], .sidebar .metismenu li.heading[data-v-d4bf850e], .form-group label[data-v-d4bf850e], .choose-skin li[data-v-d4bf850e], .weather .days li img[data-v-d4bf850e] {\n  margin-bottom: 5px;\n}\n@media (max-width: 992px) {\n.auth-main[data-v-d4bf850e]::before {\n    width: 320px;\n}\n.auth-main .auth-box[data-v-d4bf850e] {\n    margin: 0 20px;\n}\n}\n@media (max-width: 640px) {\n.auth-main .auth-box .auth-left[data-v-d4bf850e] {\n    display: none;\n}\n.auth-main .mobile-logo[data-v-d4bf850e] {\n    text-align: center;\n}\n.auth-main .mobile-logo[data-v-d4bf850e] {\n    display: block;\n    text-align: center;\n    position: absolute;\n    width: 100%;\n    top: -60px;\n}\n.auth-main[data-v-d4bf850e]::before {\n    width: 100%;\n}\n.auth-main[data-v-d4bf850e] {\n    padding-top: 70px;\n    padding-bottom: 30px;\n}\n.auth-main .auth-box .auth-right[data-v-d4bf850e] {\n    padding-left: 0;\n}\n.auth-main .auth-box .auth-right .right-top[data-v-d4bf850e] {\n    top: auto;\n    bottom: -60px;\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n    right: auto;\n    display: none;\n}\n.auth-main .card[data-v-d4bf850e] {\n    padding-left: 0;\n    padding-right: 0;\n}\n}\n.shadowLiRight[data-v-d4bf850e] {\n  text-shadow: 2px 3px 3px rgba(0, 0, 0, 0.4);\n}\n"],sourceRoot:""}])},ntHu:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n){var i,a;return"m"===n?e?"хвилина":"хвилину":"h"===n?e?"година":"годину":t+" "+(i=+t,a={ss:e?"секунда_секунди_секунд":"секунду_секунди_секунд",mm:e?"хвилина_хвилини_хвилин":"хвилину_хвилини_хвилин",hh:e?"година_години_годин":"годину_години_годин",dd:"день_дні_днів",MM:"місяць_місяці_місяців",yy:"рік_роки_років"}[n].split("_"),i%10==1&&i%100!=11?a[0]:i%10>=2&&i%10<=4&&(i%100<10||i%100>=20)?a[1]:a[2])}function n(t){return function(){return t+"о"+(11===this.hours()?"б":"")+"] LT"}}t.defineLocale("uk",{months:{format:"січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_"),standalone:"січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_")},monthsShort:"січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),weekdays:function(t,e){var n={nominative:"неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),accusative:"неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),genitive:"неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")};return!0===t?n.nominative.slice(1,7).concat(n.nominative.slice(0,1)):t?n[/(\[[ВвУу]\]) ?dddd/.test(e)?"accusative":/\[?(?:минулої|наступної)? ?\] ?dddd/.test(e)?"genitive":"nominative"][t.day()]:n.nominative},weekdaysShort:"нд_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY р.",LLL:"D MMMM YYYY р., HH:mm",LLLL:"dddd, D MMMM YYYY р., HH:mm"},calendar:{sameDay:n("[Сьогодні "),nextDay:n("[Завтра "),lastDay:n("[Вчора "),nextWeek:n("[У] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return n("[Минулої] dddd [").call(this);case 1:case 2:case 4:return n("[Минулого] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"за %s",past:"%s тому",s:"декілька секунд",ss:e,m:e,mm:e,h:"годину",hh:e,d:"день",dd:e,M:"місяць",MM:e,y:"рік",yy:e},meridiemParse:/ночі|ранку|дня|вечора/,isPM:function(t){return/^(дня|вечора)$/.test(t)},meridiem:function(t,e,n){return t<4?"ночі":t<12?"ранку":t<17?"дня":"вечора"},dayOfMonthOrdinalParse:/\d{1,2}-(й|го)/,ordinal:function(t,e){switch(e){case"M":case"d":case"DDD":case"w":case"W":return t+"-й";case"D":return t+"-го";default:return t}},week:{dow:1,doy:7}})})(n("PJh5"))},oCzW:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("mt",{months:"Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru".split("_"),monthsShort:"Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ".split("_"),weekdays:"Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt".split("_"),weekdaysShort:"Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib".split("_"),weekdaysMin:"Ħa_Tn_Tl_Er_Ħa_Ġi_Si".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd, D MMMM YYYY HH:mm"},calendar:{sameDay:"[Illum fil-]LT",nextDay:"[Għada fil-]LT",nextWeek:"dddd [fil-]LT",lastDay:"[Il-bieraħ fil-]LT",lastWeek:"dddd [li għadda] [fil-]LT",sameElse:"L"},relativeTime:{future:"f’ %s",past:"%s ilu",s:"ftit sekondi",ss:"%d sekondi",m:"minuta",mm:"%d minuti",h:"siegħa",hh:"%d siegħat",d:"ġurnata",dd:"%d ġranet",M:"xahar",MM:"%d xhur",y:"sena",yy:"%d sni"},dayOfMonthOrdinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}})})(n("PJh5"))},oIC6:function(t,e,n){var i=n("B75I");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("5837d8b9",i,!0,{})},oJlt:function(t,e,n){"use strict";var i=n("cGG2"),a=["age","authorization","content-length","content-type","etag","expires","from","host","if-modified-since","if-unmodified-since","last-modified","location","max-forwards","proxy-authorization","referer","retry-after","user-agent"];t.exports=function(t){var e,n,o,r={};return t?(i.forEach(t.split("\n"),function(t){if(o=t.indexOf(":"),e=i.trim(t.substr(0,o)).toLowerCase(),n=i.trim(t.substr(o+1)),e){if(r[e]&&a.indexOf(e)>=0)return;r[e]="set-cookie"===e?(r[e]?r[e]:[]).concat([n]):r[e]?r[e]+", "+n:n}}),r):r}},"oY0/":function(t,e,n){n("+3lO"),n("tz60"),t.exports=n("St71")},oo1B:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ml",{months:"ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ".split("_"),monthsShort:"ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.".split("_"),monthsParseExact:!0,weekdays:"ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച".split("_"),weekdaysShort:"ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി".split("_"),weekdaysMin:"ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ".split("_"),longDateFormat:{LT:"A h:mm -നു",LTS:"A h:mm:ss -നു",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm -നു",LLLL:"dddd, D MMMM YYYY, A h:mm -നു"},calendar:{sameDay:"[ഇന്ന്] LT",nextDay:"[നാളെ] LT",nextWeek:"dddd, LT",lastDay:"[ഇന്നലെ] LT",lastWeek:"[കഴിഞ്ഞ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s കഴിഞ്ഞ്",past:"%s മുൻപ്",s:"അൽപ നിമിഷങ്ങൾ",ss:"%d സെക്കൻഡ്",m:"ഒരു മിനിറ്റ്",mm:"%d മിനിറ്റ്",h:"ഒരു മണിക്കൂർ",hh:"%d മണിക്കൂർ",d:"ഒരു ദിവസം",dd:"%d ദിവസം",M:"ഒരു മാസം",MM:"%d മാസം",y:"ഒരു വർഷം",yy:"%d വർഷം"},meridiemParse:/രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,meridiemHour:function(t,e){return 12===t&&(t=0),"രാത്രി"===e&&t>=4||"ഉച്ച കഴിഞ്ഞ്"===e||"വൈകുന്നേരം"===e?t+12:t},meridiem:function(t,e,n){return t<4?"രാത്രി":t<12?"രാവിലെ":t<17?"ഉച്ച കഴിഞ്ഞ്":t<20?"വൈകുന്നേരം":"രാത്രി"}})})(n("PJh5"))},ooba:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ms",{months:"Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split("_"),monthsShort:"Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),weekdays:"Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),weekdaysShort:"Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),weekdaysMin:"Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|tengahari|petang|malam/,meridiemHour:function(t,e){return 12===t&&(t=0),"pagi"===e?t:"tengahari"===e?t>=11?t:t+12:"petang"===e||"malam"===e?t+12:void 0},meridiem:function(t,e,n){return t<11?"pagi":t<15?"tengahari":t<19?"petang":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Esok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kelmarin pukul] LT",lastWeek:"dddd [lepas pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lepas",s:"beberapa saat",ss:"%d saat",m:"seminit",mm:"%d minit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}})})(n("PJh5"))},"p/2A":function(t,e,n){var i=n("loHW");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("073a0b49",i,!0,{})},p1b6:function(t,e,n){"use strict";var i=n("cGG2");t.exports=i.isStandardBrowserEnv()?{write:function(t,e,n,a,o,r){var s=[];s.push(t+"="+encodeURIComponent(e)),i.isNumber(n)&&s.push("expires="+new Date(n).toGMTString()),i.isString(a)&&s.push("path="+a),i.isString(o)&&s.push("domain="+o),!0===r&&s.push("secure"),document.cookie=s.join("; ")},read:function(t){var e=document.cookie.match(new RegExp("(^|;\\s*)("+t+")=([^;]*)"));return e?decodeURIComponent(e[3]):null},remove:function(t){this.write(t,"",Date.now()-864e5)}}:{write:function(){},read:function(){return null},remove:function(){}}},p8xL:function(t,e,n){"use strict";var i=n("XgCd"),a=Object.prototype.hasOwnProperty,o=Array.isArray,r=function(){for(var t=[],e=0;e<256;++e)t.push("%"+((e<16?"0":"")+e.toString(16)).toUpperCase());return t}(),s=function(t,e){for(var n=e&&e.plainObjects?Object.create(null):{},i=0;i<t.length;++i)void 0!==t[i]&&(n[i]=t[i]);return n};t.exports={arrayToObject:s,assign:function(t,e){return Object.keys(e).reduce(function(t,n){return t[n]=e[n],t},t)},combine:function(t,e){return[].concat(t,e)},compact:function(t){for(var e=[{obj:{o:t},prop:"o"}],n=[],i=0;i<e.length;++i)for(var a=e[i],r=a.obj[a.prop],s=Object.keys(r),l=0;l<s.length;++l){var d=s[l],c=r[d];"object"==typeof c&&null!==c&&-1===n.indexOf(c)&&(e.push({obj:r,prop:d}),n.push(c))}return function(t){for(;t.length>1;){var e=t.pop(),n=e.obj[e.prop];if(o(n)){for(var i=[],a=0;a<n.length;++a)void 0!==n[a]&&i.push(n[a]);e.obj[e.prop]=i}}}(e),t},decode:function(t,e,n){var i=t.replace(/\+/g," ");if("iso-8859-1"===n)return i.replace(/%[0-9a-f]{2}/gi,unescape);try{return decodeURIComponent(i)}catch(t){return i}},encode:function(t,e,n,a,o){if(0===t.length)return t;var s=t;if("symbol"==typeof t?s=Symbol.prototype.toString.call(t):"string"!=typeof t&&(s=String(t)),"iso-8859-1"===n)return escape(s).replace(/%u[0-9a-f]{4}/gi,function(t){return"%26%23"+parseInt(t.slice(2),16)+"%3B"});for(var l="",d=0;d<s.length;++d){var c=s.charCodeAt(d);45===c||46===c||95===c||126===c||c>=48&&c<=57||c>=65&&c<=90||c>=97&&c<=122||o===i.RFC1738&&(40===c||41===c)?l+=s.charAt(d):c<128?l+=r[c]:c<2048?l+=r[192|c>>6]+r[128|63&c]:c<55296||c>=57344?l+=r[224|c>>12]+r[128|c>>6&63]+r[128|63&c]:(d+=1,c=65536+((1023&c)<<10|1023&s.charCodeAt(d)),l+=r[240|c>>18]+r[128|c>>12&63]+r[128|c>>6&63]+r[128|63&c])}return l},isBuffer:function(t){return!(!t||"object"!=typeof t||!(t.constructor&&t.constructor.isBuffer&&t.constructor.isBuffer(t)))},isRegExp:function(t){return"[object RegExp]"===Object.prototype.toString.call(t)},maybeMap:function(t,e){if(o(t)){for(var n=[],i=0;i<t.length;i+=1)n.push(e(t[i]));return n}return e(t)},merge:function t(e,n,i){if(!n)return e;if("object"!=typeof n){if(o(e))e.push(n);else{if(!e||"object"!=typeof e)return[e,n];(i&&(i.plainObjects||i.allowPrototypes)||!a.call(Object.prototype,n))&&(e[n]=!0)}return e}if(!e||"object"!=typeof e)return[e].concat(n);var r=e;return o(e)&&!o(n)&&(r=s(e,i)),o(e)&&o(n)?(n.forEach(function(n,o){if(a.call(e,o)){var r=e[o];r&&"object"==typeof r&&n&&"object"==typeof n?e[o]=t(r,n,i):e.push(n)}else e[o]=n}),e):Object.keys(n).reduce(function(e,o){var r=n[o];return a.call(e,o)?e[o]=t(e[o],r,i):e[o]=r,e},r)}}},pBtG:function(t,e,n){"use strict";t.exports=function(t){return!(!t||!t.__CANCEL__)}},pEGt:function(t,e,n){var i=n("DvwR"),a=n("B5V0");t.exports=Object.keys||function(t){return i(t,a)}},pFYg:function(t,e,n){"use strict";e.__esModule=!0;var i=r(n("Zzip")),a=r(n("5QVw")),o="function"==typeof a.default&&"symbol"==typeof i.default?function(t){return typeof t}:function(t){return t&&"function"==typeof a.default&&t.constructor===a.default&&t!==a.default.prototype?"symbol":typeof t};function r(t){return t&&t.__esModule?t:{default:t}}e.default="function"==typeof a.default&&"symbol"===o(i.default)?function(t){return void 0===t?"undefined":o(t)}:function(t){return t&&"function"==typeof a.default&&t.constructor===a.default&&t!==a.default.prototype?"symbol":void 0===t?"undefined":o(t)}},pI7q:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.textInputGroup[data-v-791025c1] {\n  height: 29.9px;\n}\n.fieldObli[data-v-791025c1]{\n  margin-top: -1px !important;\n}\n.classInputuHeightP[data-v-791025c1]{\n  height: calc(1.8125rem + -1px) !important;\n}","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfInput/PfInput.css"],names:[],mappings:";AACA;EACE,eAAe;CAChB;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,0CAA0C;CAC3C",file:"PfInput.css",sourcesContent:["\n.textInputGroup[data-v-791025c1] {\n  height: 29.9px;\n}\n.fieldObli[data-v-791025c1]{\n  margin-top: -1px !important;\n}\n.classInputuHeightP[data-v-791025c1]{\n  height: calc(1.8125rem + -1px) !important;\n}"],sourceRoot:""}])},pXPO:function(t,e,n){var i=n("IC4K");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("5afc28de",i,!0,{})},pfs9:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"੧",2:"੨",3:"੩",4:"੪",5:"੫",6:"੬",7:"੭",8:"੮",9:"੯",0:"੦"},n={"੧":"1","੨":"2","੩":"3","੪":"4","੫":"5","੬":"6","੭":"7","੮":"8","੯":"9","੦":"0"};t.defineLocale("pa-in",{months:"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),monthsShort:"ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split("_"),weekdays:"ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ".split("_"),weekdaysShort:"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),weekdaysMin:"ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),longDateFormat:{LT:"A h:mm ਵਜੇ",LTS:"A h:mm:ss ਵਜੇ",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm ਵਜੇ",LLLL:"dddd, D MMMM YYYY, A h:mm ਵਜੇ"},calendar:{sameDay:"[ਅਜ] LT",nextDay:"[ਕਲ] LT",nextWeek:"[ਅਗਲਾ] dddd, LT",lastDay:"[ਕਲ] LT",lastWeek:"[ਪਿਛਲੇ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s ਵਿੱਚ",past:"%s ਪਿਛਲੇ",s:"ਕੁਝ ਸਕਿੰਟ",ss:"%d ਸਕਿੰਟ",m:"ਇਕ ਮਿੰਟ",mm:"%d ਮਿੰਟ",h:"ਇੱਕ ਘੰਟਾ",hh:"%d ਘੰਟੇ",d:"ਇੱਕ ਦਿਨ",dd:"%d ਦਿਨ",M:"ਇੱਕ ਮਹੀਨਾ",MM:"%d ਮਹੀਨੇ",y:"ਇੱਕ ਸਾਲ",yy:"%d ਸਾਲ"},preparse:function(t){return t.replace(/[੧੨੩੪੫੬੭੮੯੦]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,meridiemHour:function(t,e){return 12===t&&(t=0),"ਰਾਤ"===e?t<4?t:t+12:"ਸਵੇਰ"===e?t:"ਦੁਪਹਿਰ"===e?t>=10?t:t+12:"ਸ਼ਾਮ"===e?t+12:void 0},meridiem:function(t,e,n){return t<4?"ਰਾਤ":t<10?"ਸਵੇਰ":t<17?"ਦੁਪਹਿਰ":t<20?"ਸ਼ਾਮ":"ਰਾਤ"},week:{dow:0,doy:6}})})(n("PJh5"))},pxG4:function(t,e,n){"use strict";t.exports=function(t){return function(e){return t.apply(null,e)}}},qC2Z:function(t,e,n){var i=n("FKWp"),a=n("8ANE"),o=n("3HN9");t.exports=function(t,e){if(i(t),a(e)&&e.constructor===t)return e;var n=o.f(t);return(0,n.resolve)(e),n.promise}},qM2r:function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAJAIABAAAAAP///yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAAEALAAAAAAGAAkAAAINDIIGl8vokmJxwiVfKAA7"},qRfI:function(t,e,n){"use strict";t.exports=function(t,e){return e?t.replace(/\/+$/,"")+"/"+e.replace(/^\/+/,""):t}},qUXl:function(t,e,n){var i=n("ZUOV");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("6b89c179",i,!0,{})},"qs+f":function(t,e,n){t.exports=!n("zyKz")(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},qwRx:function(t,e,n){var i=n("WJN6");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("12fc0708",i,!0,{})},qyb3:function(t,e,n){var i=n("kxFB");(t.exports=n("FZ+f")(!0)).push([t.i,"/*\nProduct Name: dhtmlxSuite \nVersion: 5.1.0 \nEdition: Standard \nLicense: content of this file is covered by DHTMLX Commercial or enterpri. Usage outside GPL terms is prohibited. To obtain Commercial or Enterprise license contact sales@dhtmlx.com\nCopyright UAB Dinamenta http://www.dhtmlx.com\n*/\n\n/*\n\tskin detected: dhx_terrace\n\tinclude extra file: skins/dhx_terrace.less\n*/\n.dhtmlxcalendar_dhx_terrace {\n\tposition: absolute;\n\tdisplay: block;\n\tbackground-color: #ffffff;\n\tfont-family: Arial, Helvetica;\n\tfont-size: 13px;\n\tcolor: #333333;\n}\n.dhtmlxcalendar_dhx_terrace.dhtmlxcalendar_in_input {\n\t-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.25);\n\t        box-shadow: 0 0 6px rgba(0,0,0,0.25);\n}\n.dhtmlxcalendar_ifr {\n\tposition: absolute;\n\toverflow: hidden;\n\tbackground-color: white;\n}\n.dhtmlxcalendar_dhx_terrace ul.dhtmlxcalendar_line {\n\tposition: relative;\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\twidth: 225px;\n\tmargin-left: 12px;\n}\n.dhtmlxcalendar_dhx_terrace ul.dhtmlxcalendar_line li {\n\tfloat: left;\n\tposition: relative;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcursor: default;\n\toverflow: hidden;\n\tmargin: 0px;\n\tpadding: 0px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tborder-top: 1px solid #cccccc;\n\tborder-left: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\tborder-top-left-radius: 3px;\n\tborder-top-right-radius: 3px;\n\toverflow: hidden;\n\tcolor: #333333;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr {\n\twidth: 225px;\n\theight: 31px;\n\tline-height: 31px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow {\n\tposition: absolute;\n\ttop: 0px;\n\twidth: 18px;\n\theight: 31px;\n\tcolor: inherit;\n\ttext-align: center;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left {\n\tleft: 4px;\n\tbackground-image: url("+i(n("0pHi"))+");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left_hover {\n\tleft: 4px;\n\tbackground-image: url("+i(n("0pHi"))+");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right {\n\tright: 4px;\n\tbackground-image: url("+i(n("ZU6n"))+");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right_hover {\n\tright: 4px;\n\tbackground-image: url("+i(n("ZU6n"))+");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_month,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_year {\n\tposition: relative;\n\tfont-weight: bold;\n\tcolor: inherit;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 74px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 22px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tborder-left: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line {\n\theight: 31px;\n\tborder-bottom: 1px solid #cccccc;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li {\n\twidth: 31px;\n\theight: 31px;\n\tline-height: 31px;\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first {\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell_first {\n\tcolor: #d43f3a;\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tpadding-bottom: 8px;\n\tborder-left: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\tborder-bottom: 1px solid #cccccc;\n\tborder-bottom-left-radius: 3px;\n\tborder-bottom-right-radius: 3px;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line {\n\tmargin-top: 1px;\n\tmargin-left: 13px;\n\theight: 31px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li {\n\tcolor: #909090;\n\tborder-radius: 3px;\n\twidth: 31px;\n\theight: 31px;\n\tline-height: 31px;\n\tmargin-right: 1px;\n\toverflow: visible;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label {\n\twidth: 100%;\n\theight: 100%;\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend {\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_dis {\n\tcolor: #c4c4c4;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_hover {\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month {\n\tcolor: #333333;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date {\n\tcolor: black;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_dis {\n\tcolor: #c4c4c4;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_hover {\n\tcolor: #333333;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_hover {\n\tcolor: #333333;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line div.dhtmlxcalendar_label.dhtmlxcalendar_label_title {\n\tbackground-image: url("+i(n("waPF"))+");\n\tbackground-position: top right;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\theight: 31px;\n\tmargin-top: -4px;\n\tborder-left: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\tborder-bottom: 1px solid #cccccc;\n\tborder-bottom-left-radius: 3px;\n\tborder-bottom-right-radius: 3px;\n\tbackground-color: #ffffff;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li {\n\twidth: 225px;\n\theight: 27px;\n\tline-height: 25px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: left;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tposition: absolute;\n\tleft: 22px;\n\ttop: 6px;\n\twidth: 13px;\n\theight: 13px;\n\tbackground-image: url("+i(n("4VBb"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 42px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tleft: 75px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 0px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr div.dhtmlxcalendar_time_img,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_minutes,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_colon {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_terrace span.dhtmlxcalendar_label_colon {\n\tpadding: 0px 4px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_cover {\n\tposition: absolute;\n\tleft: 1px;\n\tbackground-color: white;\n\topacity: 0.5;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj {\n\tposition: absolute;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_selector_obj_arrow {\n\tposition: absolute;\n\tbottom: auto;\n\ttop: 1px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 9px;\n\toverflow: hidden;\n\tbackground-image: url("+i(n("VX7B"))+");\n\tbackground-position: top center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -13px top;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -27px top;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -52px top;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table {\n\tborder-bottom: 1px solid #cccccc;\n\tborder-top: 0px solid white;\n\tbackground-color: white;\n\tmargin-top: 9px;\n\t-webkit-box-shadow: 0 0 5px rgba(0,0,0,0.25);\n\t        box-shadow: 0 0 5px rgba(0,0,0,0.25);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid #cccccc;\n\tborder-left: 1px solid #cccccc;\n\tborder-bottom: 0px solid white;\n\tborder-right: 0px solid white;\n\tpadding: 0px;\n\tmargin: 0px;\n\tbackground-color: white;\n\tbackground-image: url("+i(n("0pHi"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left.dhtmlxcalendar_selector_cell_left_hover {\n\tbackground-image: url("+i(n("0pHi"))+");\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle {\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\tborder-bottom: 0px solid white;\n\tborder-left: 0px solid white;\n\tbackground-color: white;\n\tbackground-image: url("+i(n("ZU6n"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right.dhtmlxcalendar_selector_cell_right_hover {\n\tbackground-image: url("+i(n("ZU6n"))+");\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul {\n\tdisplay: block;\n\tclear: both;\n\tbackground-color: white;\n\tborder-left: 1px solid #cccccc;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li {\n\tfloat: left;\n\tfont-family: Arial, Helvetica;\n\tfont-size: 12px;\n\tcolor: #333333;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmargin: 0px;\n\tborder-right: 1px solid #cccccc;\n\tpadding: 0px;\n\tbackground-color: white;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_active,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_hover {\n\tbackground-color: #fff3a1;\n\tcolor: black;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 24px;\n\tborder-top: 1px solid #cccccc;\n\tborder-bottom: 0px solid white;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 35px;\n\theight: 24px;\n\tline-height: 24px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\ttop: auto;\n\tbottom: 1px;\n\tbackground-image: url("+i(n("FbSQ"))+");\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 22px;\n\tborder-top: 0px solid white;\n\tborder-bottom: 1px solid #cccccc;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 24px;\n\theight: 22px;\n\tline-height: 22px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table {\n\tmargin-top: 0px;\n\tmargin-bottom: 9px;\n\tborder-top: 1px solid #cccccc;\n\tborder-bottom: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours2,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_year div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: block;\n}\n.dhtmlxcalendar_dhx_terrace span.dhtmlxcalendar_label_minutes span.dhtmlxcalendar_selected_date {\n\tborder-bottom: 2px solid red;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color: #efefef;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color: #efefef;\n}\ndiv.dhtmlxcalendar_skin_detect {\n\tposition: absolute;\n\tdisplay: block;\n\tvisibility: hidden;\n\tleft: -100px;\n\ttop: 0px;\n\twidth: 30px;\n\theight: 10px;\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder: none;\n\toverflow: hidden;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/dhx/calendar/skins/dhtmlxcalendar_dhx_terrace.css"],names:[],mappings:"AAAA;;;;;;EAME;;AAEF;;;EAGE;AACF;CACC,mBAAmB;CACnB,eAAe;CACf,0BAA0B;CAC1B,8BAA8B;CAC9B,gBAAgB;CAChB,eAAe;CACf;AACD;CACC,6CAA6C;SACrC,qCAAqC;CAC7C;AACD;CACC,mBAAmB;CACnB,iBAAiB;CACjB,wBAAwB;CACxB;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;CACZ,aAAa;CACb;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,8BAA8B;CAC9B,+BAA+B;CAC/B,gCAAgC;CAChC,4BAA4B;CAC5B,6BAA6B;CAC7B,iBAAiB;CACjB,eAAe;CACf,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,mBAAmB;CACnB,SAAS;CACT,YAAY;CACZ,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,mCAAmC;CACnC,6BAA6B;CAC7B;AACD;CACC,UAAU;CACV,gDAAgF;CAChF,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,UAAU;CACV,gDAAgF;CAChF,WAAW;CACX,6DAA6D;CAC7D;AACD;CACC,WAAW;CACX,gDAAiF;CACjF,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,WAAW;CACX,gDAAiF;CACjF,WAAW;CACX,6DAA6D;CAC7D;AACD;;CAEC,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf;AACD;;CAEC,cAAc;CACd;AACD;CACC,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,mBAAmB;CACnB;AACD;CACC,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,mBAAmB;CACnB;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,+BAA+B;CAC/B,gCAAgC;CAChC,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;CACC,aAAa;CACb,iCAAiC;CACjC;AACD;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,iBAAiB;CACjB;AACD;CACC,iBAAiB;CACjB;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf,iBAAiB;CACjB;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,oBAAoB;CACpB,+BAA+B;CAC/B,gCAAgC;CAChC,iCAAiC;CACjC,+BAA+B;CAC/B,gCAAgC;CAChC,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;CACC,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb;AACD;CACC,eAAe;CACf,mBAAmB;CACnB,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB;AACD;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB;AACD;;CAEC,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;;CAEC,eAAe;CACf;AACD;;CAEC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,gDAA0E;CAC1E,+BAA+B;CAC/B,6BAA6B;CAC7B;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,aAAa;CACb,iBAAiB;CACjB,+BAA+B;CAC/B,gCAAgC;CAChC,iCAAiC;CACjC,+BAA+B;CAC/B,gCAAgC;CAChC,0BAA0B;CAC1B,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;CACC,aAAa;CACb,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,iBAAiB;CACjB;AACD;CACC,mBAAmB;CACnB,WAAW;CACX,SAAS;CACT,YAAY;CACZ,aAAa;CACb,gDAA2E;CAC3E,mCAAmC;CACnC,6BAA6B;CAC7B;AACD;CACC,kBAAkB;CAClB;AACD;CACC,WAAW;CACX;AACD;CACC,mBAAmB;CACnB;AACD;CACC,iBAAiB;CACjB;AACD;;;;CAIC,cAAc;CACd;AACD;CACC,iBAAiB;CACjB;AACD;CACC,mBAAmB;CACnB,UAAU;CACV,wBAAwB;CACxB,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,mBAAmB;CACnB;AACD;CACC,mBAAmB;CACnB,aAAa;CACb,SAAS;CACT,UAAU;CACV,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,gDAAkF;CAClF,gCAAgC;CAChC,6BAA6B;CAC7B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,iCAAiC;CACjC,4BAA4B;CAC5B,wBAAwB;CACxB,gBAAgB;CAChB,6CAA6C;SACrC,qCAAqC;CAC7C;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,8BAA8B;CAC9B,+BAA+B;CAC/B,+BAA+B;CAC/B,8BAA8B;CAC9B,aAAa;CACb,YAAY;CACZ,wBAAwB;CACxB,gDAAgF;CAChF,mCAAmC;CACnC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;CACC,gDAAgF;CAChF;AACD;CACC,gBAAgB;CAChB;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,8BAA8B;CAC9B,gCAAgC;CAChC,+BAA+B;CAC/B,6BAA6B;CAC7B,wBAAwB;CACxB,gDAAiF;CACjF,mCAAmC;CACnC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;CACC,iDAAiF;CACjF;AACD;CACC,eAAe;CACf,YAAY;CACZ,wBAAwB;CACxB,+BAA+B;CAC/B,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,YAAY;CACZ,8BAA8B;CAC9B,gBAAgB;CAChB,eAAe;CACf,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,YAAY;CACZ,gCAAgC;CAChC,aAAa;CACb,wBAAwB;CACxB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB;AACD;;CAEC,0BAA0B;CAC1B,aAAa;CACb;AACD;;CAEC,cAAc;CACd,WAAW;CACX;AACD;CACC,aAAa;CACb,8BAA8B;CAC9B,+BAA+B;CAC/B;AACD;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB;AACD;;;CAGC,UAAU;CACV,YAAY;CACZ,iDAAqF;CACrF;AACD;;;CAGC,aAAa;CACb,4BAA4B;CAC5B,iCAAiC;CACjC;AACD;;;CAGC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB;AACD;;;;;;CAMC,cAAc;CACd,WAAW;CACX;AACD;;;CAGC,gBAAgB;CAChB,mBAAmB;CACnB,8BAA8B;CAC9B,oBAAoB;CACpB;AACD;;;;;;;CAOC,cAAc;CACd;AACD;;;;;;;CAOC,eAAe;CACf;AACD;CACC,6BAA6B;CAC7B;AACD;;CAEC,cAAc;CACd;AACD;CACC,YAAY;CACZ;AACD;CACC,YAAY;CACZ;AACD;;CAEC,YAAY;CACZ;AACD;CACC,eAAe;CACf,YAAY;CACZ,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,YAAY;CACZ,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,aAAa;CACb,SAAS;CACT,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,aAAa;CACb,aAAa;CACb,iBAAiB;CACjB",file:"dhtmlxcalendar_dhx_terrace.css",sourcesContent:['/*\nProduct Name: dhtmlxSuite \nVersion: 5.1.0 \nEdition: Standard \nLicense: content of this file is covered by DHTMLX Commercial or enterpri. Usage outside GPL terms is prohibited. To obtain Commercial or Enterprise license contact sales@dhtmlx.com\nCopyright UAB Dinamenta http://www.dhtmlx.com\n*/\n\n/*\n\tskin detected: dhx_terrace\n\tinclude extra file: skins/dhx_terrace.less\n*/\n.dhtmlxcalendar_dhx_terrace {\n\tposition: absolute;\n\tdisplay: block;\n\tbackground-color: #ffffff;\n\tfont-family: Arial, Helvetica;\n\tfont-size: 13px;\n\tcolor: #333333;\n}\n.dhtmlxcalendar_dhx_terrace.dhtmlxcalendar_in_input {\n\t-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.25);\n\t        box-shadow: 0 0 6px rgba(0,0,0,0.25);\n}\n.dhtmlxcalendar_ifr {\n\tposition: absolute;\n\toverflow: hidden;\n\tbackground-color: white;\n}\n.dhtmlxcalendar_dhx_terrace ul.dhtmlxcalendar_line {\n\tposition: relative;\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\twidth: 225px;\n\tmargin-left: 12px;\n}\n.dhtmlxcalendar_dhx_terrace ul.dhtmlxcalendar_line li {\n\tfloat: left;\n\tposition: relative;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcursor: default;\n\toverflow: hidden;\n\tmargin: 0px;\n\tpadding: 0px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tborder-top: 1px solid #cccccc;\n\tborder-left: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\tborder-top-left-radius: 3px;\n\tborder-top-right-radius: 3px;\n\toverflow: hidden;\n\tcolor: #333333;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr {\n\twidth: 225px;\n\theight: 31px;\n\tline-height: 31px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow {\n\tposition: absolute;\n\ttop: 0px;\n\twidth: 18px;\n\theight: 31px;\n\tcolor: inherit;\n\ttext-align: center;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left {\n\tleft: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_arrow_left.gif");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left_hover {\n\tleft: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_arrow_left.gif");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right {\n\tright: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_arrow_right.gif");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right_hover {\n\tright: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_arrow_right.gif");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_month,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_year {\n\tposition: relative;\n\tfont-weight: bold;\n\tcolor: inherit;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 74px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 22px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tborder-left: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line {\n\theight: 31px;\n\tborder-bottom: 1px solid #cccccc;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li {\n\twidth: 31px;\n\theight: 31px;\n\tline-height: 31px;\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first {\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell_first {\n\tcolor: #d43f3a;\n\tmargin-left: 1px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\tmargin: 0px;\n\tpadding-bottom: 8px;\n\tborder-left: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\tborder-bottom: 1px solid #cccccc;\n\tborder-bottom-left-radius: 3px;\n\tborder-bottom-right-radius: 3px;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line {\n\tmargin-top: 1px;\n\tmargin-left: 13px;\n\theight: 31px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li {\n\tcolor: #909090;\n\tborder-radius: 3px;\n\twidth: 31px;\n\theight: 31px;\n\tline-height: 31px;\n\tmargin-right: 1px;\n\toverflow: visible;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label {\n\twidth: 100%;\n\theight: 100%;\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend {\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_dis {\n\tcolor: #c4c4c4;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_hover {\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_hover,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month {\n\tcolor: #333333;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date {\n\tcolor: black;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_dis {\n\tcolor: #d43f3a;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday {\n\tcolor: #d43f3a;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_dis,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_dis {\n\tcolor: #c4c4c4;\n\tbackground-color: #ededed;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_hover {\n\tcolor: #333333;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_hover {\n\tcolor: #333333;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_hover {\n\tcolor: #d43f3a;\n\tbackground-color: #fff3a1;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line div.dhtmlxcalendar_label.dhtmlxcalendar_label_title {\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_mark.gif");\n\tbackground-position: top right;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 249px;\n\theight: 31px;\n\tmargin-top: -4px;\n\tborder-left: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\tborder-bottom: 1px solid #cccccc;\n\tborder-bottom-left-radius: 3px;\n\tborder-bottom-right-radius: 3px;\n\tbackground-color: #ffffff;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li {\n\twidth: 225px;\n\theight: 27px;\n\tline-height: 25px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: left;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tposition: absolute;\n\tleft: 22px;\n\ttop: 6px;\n\twidth: 13px;\n\theight: 13px;\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_clock.gif");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 42px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tleft: 75px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 0px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr div.dhtmlxcalendar_time_img,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_minutes,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_colon {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_terrace span.dhtmlxcalendar_label_colon {\n\tpadding: 0px 4px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_cover {\n\tposition: absolute;\n\tleft: 1px;\n\tbackground-color: white;\n\topacity: 0.5;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj {\n\tposition: absolute;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_selector_obj_arrow {\n\tposition: absolute;\n\tbottom: auto;\n\ttop: 1px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 9px;\n\toverflow: hidden;\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_selector_top.gif");\n\tbackground-position: top center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -13px top;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -27px top;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -52px top;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table {\n\tborder-bottom: 1px solid #cccccc;\n\tborder-top: 0px solid white;\n\tbackground-color: white;\n\tmargin-top: 9px;\n\t-webkit-box-shadow: 0 0 5px rgba(0,0,0,0.25);\n\t        box-shadow: 0 0 5px rgba(0,0,0,0.25);\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid #cccccc;\n\tborder-left: 1px solid #cccccc;\n\tborder-bottom: 0px solid white;\n\tborder-right: 0px solid white;\n\tpadding: 0px;\n\tmargin: 0px;\n\tbackground-color: white;\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_arrow_left.gif");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left.dhtmlxcalendar_selector_cell_left_hover {\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_arrow_left.gif");\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle {\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid #cccccc;\n\tborder-right: 1px solid #cccccc;\n\tborder-bottom: 0px solid white;\n\tborder-left: 0px solid white;\n\tbackground-color: white;\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_arrow_right.gif");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right.dhtmlxcalendar_selector_cell_right_hover {\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_arrow_right.gif");\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul {\n\tdisplay: block;\n\tclear: both;\n\tbackground-color: white;\n\tborder-left: 1px solid #cccccc;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li {\n\tfloat: left;\n\tfont-family: Arial, Helvetica;\n\tfont-size: 12px;\n\tcolor: #333333;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmargin: 0px;\n\tborder-right: 1px solid #cccccc;\n\tpadding: 0px;\n\tbackground-color: white;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_active,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_hover {\n\tbackground-color: #fff3a1;\n\tcolor: black;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 24px;\n\tborder-top: 1px solid #cccccc;\n\tborder-bottom: 0px solid white;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 35px;\n\theight: 24px;\n\tline-height: 24px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\ttop: auto;\n\tbottom: 1px;\n\tbackground-image: url("../imgs/dhxcalendar_terrace/dhxcalendar_selector_bottom.gif");\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 22px;\n\tborder-top: 0px solid white;\n\tborder-bottom: 1px solid #cccccc;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 24px;\n\theight: 22px;\n\tline-height: 22px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table {\n\tmargin-top: 0px;\n\tmargin-bottom: 9px;\n\tborder-top: 1px solid #cccccc;\n\tborder-bottom: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours2,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_year div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: block;\n}\n.dhtmlxcalendar_dhx_terrace span.dhtmlxcalendar_label_minutes span.dhtmlxcalendar_selected_date {\n\tborder-bottom: 2px solid red;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first,\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 27px;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color: #efefef;\n}\n.dhtmlxcalendar_dhx_terrace div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 27px;\n\tcolor: #3da0e3;\n\tbackground-color: #efefef;\n}\ndiv.dhtmlxcalendar_skin_detect {\n\tposition: absolute;\n\tdisplay: block;\n\tvisibility: hidden;\n\tleft: -100px;\n\ttop: 0px;\n\twidth: 30px;\n\theight: 10px;\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder: none;\n\toverflow: hidden;\n}\n'],sourceRoot:""}])},"r3+g":function(t,e,n){var i=n("GCs6"),a=n("FKWp"),o=n("pEGt");t.exports=n("qs+f")?Object.defineProperties:function(t,e){a(t);for(var n,r=o(e),s=r.length,l=0;s>l;)i.f(t,n=r[l++],e[n]);return t}},rIuo:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e=["ޖެނުއަރީ","ފެބްރުއަރީ","މާރިޗު","އޭޕްރީލު","މޭ","ޖޫން","ޖުލައި","އޯގަސްޓު","ސެޕްޓެމްބަރު","އޮކްޓޯބަރު","ނޮވެމްބަރު","ޑިސެމްބަރު"],n=["އާދިއްތަ","ހޯމަ","އަންގާރަ","ބުދަ","ބުރާސްފަތި","ހުކުރު","ހޮނިހިރު"];t.defineLocale("dv",{months:e,monthsShort:e,weekdays:n,weekdaysShort:n,weekdaysMin:"އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/M/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/މކ|މފ/,isPM:function(t){return"މފ"===t},meridiem:function(t,e,n){return t<12?"މކ":"މފ"},calendar:{sameDay:"[މިއަދު] LT",nextDay:"[މާދަމާ] LT",nextWeek:"dddd LT",lastDay:"[އިއްޔެ] LT",lastWeek:"[ފާއިތުވި] dddd LT",sameElse:"L"},relativeTime:{future:"ތެރޭގައި %s",past:"ކުރިން %s",s:"ސިކުންތުކޮޅެއް",ss:"d% ސިކުންތު",m:"މިނިޓެއް",mm:"މިނިޓު %d",h:"ގަޑިއިރެއް",hh:"ގަޑިއިރު %d",d:"ދުވަހެއް",dd:"ދުވަސް %d",M:"މަހެއް",MM:"މަސް %d",y:"އަހަރެއް",yy:"އަހަރު %d"},preparse:function(t){return t.replace(/،/g,",")},postformat:function(t){return t.replace(/,/g,"،")},week:{dow:7,doy:12}})})(n("PJh5"))},"rKx+":function(t,e,n){n("4ajQ");var i=n("iANj").Object;t.exports=function(t,e,n){return i.defineProperty(t,e,n)}},rMbQ:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("fil",{months:"Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split("_"),monthsShort:"Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),weekdays:"Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split("_"),weekdaysShort:"Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),weekdaysMin:"Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"MM/D/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY HH:mm",LLLL:"dddd, MMMM DD, YYYY HH:mm"},calendar:{sameDay:"LT [ngayong araw]",nextDay:"[Bukas ng] LT",nextWeek:"LT [sa susunod na] dddd",lastDay:"LT [kahapon]",lastWeek:"LT [noong nakaraang] dddd",sameElse:"L"},relativeTime:{future:"sa loob ng %s",past:"%s ang nakalipas",s:"ilang segundo",ss:"%d segundo",m:"isang minuto",mm:"%d minuto",h:"isang oras",hh:"%d oras",d:"isang araw",dd:"%d araw",M:"isang buwan",MM:"%d buwan",y:"isang taon",yy:"%d taon"},dayOfMonthOrdinalParse:/\d{1,2}/,ordinal:function(t){return t},week:{dow:1,doy:4}})})(n("PJh5"))},rZAI:function(t,e,n){var i=n("wXdB"),a=n("pEGt");n("30vf")("keys",function(){return function(t){return a(i(t))}})},rjj0:function(t,e,n){var i="undefined"!=typeof document;if("undefined"!=typeof DEBUG&&DEBUG&&!i)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var a=n("tTVk"),o={},r=i&&(document.head||document.getElementsByTagName("head")[0]),s=null,l=0,d=!1,c=function(){},h=null,u="data-vue-ssr-id",m="undefined"!=typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function f(t){for(var e=0;e<t.length;e++){var n=t[e],i=o[n.id];if(i){i.refs++;for(var a=0;a<i.parts.length;a++)i.parts[a](n.parts[a]);for(;a<n.parts.length;a++)i.parts.push(_(n.parts[a]));i.parts.length>n.parts.length&&(i.parts.length=n.parts.length)}else{var r=[];for(a=0;a<n.parts.length;a++)r.push(_(n.parts[a]));o[n.id]={id:n.id,refs:1,parts:r}}}}function p(){var t=document.createElement("style");return t.type="text/css",r.appendChild(t),t}function _(t){var e,n,i=document.querySelector("style["+u+'~="'+t.id+'"]');if(i){if(d)return c;i.parentNode.removeChild(i)}if(m){var a=l++;i=s||(s=p()),e=x.bind(null,i,a,!1),n=x.bind(null,i,a,!0)}else i=p(),e=function(t,e){var n=e.css,i=e.media,a=e.sourceMap;i&&t.setAttribute("media",i);h.ssrId&&t.setAttribute(u,e.id);a&&(n+="\n/*# sourceURL="+a.sources[0]+" */",n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */");if(t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}.bind(null,i),n=function(){i.parentNode.removeChild(i)};return e(t),function(i){if(i){if(i.css===t.css&&i.media===t.media&&i.sourceMap===t.sourceMap)return;e(t=i)}else n()}}t.exports=function(t,e,n,i){d=n,h=i||{};var r=a(t,e);return f(r),function(e){for(var n=[],i=0;i<r.length;i++){var s=r[i];(l=o[s.id]).refs--,n.push(l)}e?f(r=a(t,e)):r=[];for(i=0;i<n.length;i++){var l;if(0===(l=n[i]).refs){for(var d=0;d<l.parts.length;d++)l.parts[d]();delete o[l.id]}}}};var A,b=(A=[],function(t,e){return A[t]=e,A.filter(Boolean).join("\n")});function x(t,e,n,i){var a=n?"":i.css;if(t.styleSheet)t.styleSheet.cssText=b(e,a);else{var o=document.createTextNode(a),r=t.childNodes;r[e]&&t.removeChild(r[e]),r.length?t.insertBefore(o,r[e]):t.appendChild(o)}}},rjjF:function(t,e,n){var i=n("bSeU"),a=n("YTz9"),o=n("ksFB"),r=n("9MbE"),s=n("x//u"),l=n("LocR"),d=Object.getOwnPropertyDescriptor;e.f=n("qs+f")?d:function(t,e){if(t=o(t),e=r(e,!0),l)try{return d(t,e)}catch(t){}if(s(t,e))return a(!i.f.call(t,e),t[e])}},rkCz:function(t,e,n){var i=n("etT9");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("24e6653d",i,!0,{})},rtsW:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"૧",2:"૨",3:"૩",4:"૪",5:"૫",6:"૬",7:"૭",8:"૮",9:"૯",0:"૦"},n={"૧":"1","૨":"2","૩":"3","૪":"4","૫":"5","૬":"6","૭":"7","૮":"8","૯":"9","૦":"0"};t.defineLocale("gu",{months:"જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર".split("_"),monthsShort:"જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.".split("_"),monthsParseExact:!0,weekdays:"રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર".split("_"),weekdaysShort:"રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ".split("_"),weekdaysMin:"ર_સો_મં_બુ_ગુ_શુ_શ".split("_"),longDateFormat:{LT:"A h:mm વાગ્યે",LTS:"A h:mm:ss વાગ્યે",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm વાગ્યે",LLLL:"dddd, D MMMM YYYY, A h:mm વાગ્યે"},calendar:{sameDay:"[આજ] LT",nextDay:"[કાલે] LT",nextWeek:"dddd, LT",lastDay:"[ગઇકાલે] LT",lastWeek:"[પાછલા] dddd, LT",sameElse:"L"},relativeTime:{future:"%s મા",past:"%s પહેલા",s:"અમુક પળો",ss:"%d સેકંડ",m:"એક મિનિટ",mm:"%d મિનિટ",h:"એક કલાક",hh:"%d કલાક",d:"એક દિવસ",dd:"%d દિવસ",M:"એક મહિનો",MM:"%d મહિનો",y:"એક વર્ષ",yy:"%d વર્ષ"},preparse:function(t){return t.replace(/[૧૨૩૪૫૬૭૮૯૦]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/રાત|બપોર|સવાર|સાંજ/,meridiemHour:function(t,e){return 12===t&&(t=0),"રાત"===e?t<4?t:t+12:"સવાર"===e?t:"બપોર"===e?t>=10?t:t+12:"સાંજ"===e?t+12:void 0},meridiem:function(t,e,n){return t<4?"રાત":t<10?"સવાર":t<17?"બપોર":t<20?"સાંજ":"રાત"},week:{dow:0,doy:6}})})(n("PJh5"))},"s/YK":function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-3f772e7a] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-3f772e7a]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-3f772e7a] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-3f772e7a] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-3f772e7a] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-3f772e7a] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-3f772e7a] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-3f772e7a] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-3f772e7a] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-3f772e7a] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-3f772e7a] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-3f772e7a] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-3f772e7a] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-3f772e7a] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-3f772e7a] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-3f772e7a] {\n  margin-right: 0px;\n}\n.newItem[data-v-3f772e7a] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-3f772e7a] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-3f772e7a] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-3f772e7a] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-3f772e7a] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-3f772e7a] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-3f772e7a] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-3f772e7a] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-3f772e7a] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-3f772e7a] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-3f772e7a]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-3f772e7a] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-3f772e7a] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-3f772e7a] {\n  color: red;\n}\n.showMore[data-v-3f772e7a]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-3f772e7a] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-3f772e7a] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-3f772e7a] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-3f772e7a {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-3f772e7a {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-3f772e7a] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-3f772e7a 3s infinite;\n  animation: bit-data-v-3f772e7a 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-3f772e7a] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-3f772e7a]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-3f772e7a]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-3f772e7a]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-3f772e7a]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-3f772e7a]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-3f772e7a]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-3f772e7a] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-3f772e7a]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-3f772e7a] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-3f772e7a] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-3f772e7a] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-3f772e7a] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-3f772e7a] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-3f772e7a] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-3f772e7a] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-3f772e7a] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-3f772e7a] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-3f772e7a] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-3f772e7a] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-3f772e7a] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-3f772e7a] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-3f772e7a] {\n  margin-right: 0px;\n}\n.newItem[data-v-3f772e7a] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-3f772e7a] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-3f772e7a] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-3f772e7a] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-3f772e7a] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-3f772e7a] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-3f772e7a] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-3f772e7a] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-3f772e7a] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-3f772e7a] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-3f772e7a]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-3f772e7a] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-3f772e7a] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-3f772e7a] {\n  color: red;\n}\n.showMore[data-v-3f772e7a]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-3f772e7a] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-3f772e7a] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-3f772e7a] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-3f772e7a {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-3f772e7a {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-3f772e7a] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-3f772e7a 3s infinite;\n  animation: bit-data-v-3f772e7a 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-3f772e7a] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-3f772e7a]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-3f772e7a]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-3f772e7a]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-3f772e7a]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-3f772e7a]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-3f772e7a]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},s9lo:function(t,e,n){var i=n("Vjqu");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("5503ebc2",i,!0,{})},sAoL:function(t,e,n){var i=n("Ahh+");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("1c4a9572",i,!0,{})},sqLM:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("eu",{months:"urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split("_"),monthsShort:"urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split("_"),monthsParseExact:!0,weekdays:"igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split("_"),weekdaysShort:"ig._al._ar._az._og._ol._lr.".split("_"),weekdaysMin:"ig_al_ar_az_og_ol_lr".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"YYYY-MM-DD",LL:"YYYY[ko] MMMM[ren] D[a]",LLL:"YYYY[ko] MMMM[ren] D[a] HH:mm",LLLL:"dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",l:"YYYY-M-D",ll:"YYYY[ko] MMM D[a]",lll:"YYYY[ko] MMM D[a] HH:mm",llll:"ddd, YYYY[ko] MMM D[a] HH:mm"},calendar:{sameDay:"[gaur] LT[etan]",nextDay:"[bihar] LT[etan]",nextWeek:"dddd LT[etan]",lastDay:"[atzo] LT[etan]",lastWeek:"[aurreko] dddd LT[etan]",sameElse:"L"},relativeTime:{future:"%s barru",past:"duela %s",s:"segundo batzuk",ss:"%d segundo",m:"minutu bat",mm:"%d minutu",h:"ordu bat",hh:"%d ordu",d:"egun bat",dd:"%d egun",M:"hilabete bat",MM:"%d hilabete",y:"urte bat",yy:"%d urte"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})(n("PJh5"))},ssxj:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),n="led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"),i=[/^led/i,/^úno/i,/^bře/i,/^dub/i,/^kvě/i,/^(čvn|červen$|června)/i,/^(čvc|červenec|července)/i,/^srp/i,/^zář/i,/^říj/i,/^lis/i,/^pro/i],a=/^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;function o(t){return t>1&&t<5&&1!=~~(t/10)}function r(t,e,n,i){var a=t+" ";switch(n){case"s":return e||i?"pár sekund":"pár sekundami";case"ss":return e||i?a+(o(t)?"sekundy":"sekund"):a+"sekundami";case"m":return e?"minuta":i?"minutu":"minutou";case"mm":return e||i?a+(o(t)?"minuty":"minut"):a+"minutami";case"h":return e?"hodina":i?"hodinu":"hodinou";case"hh":return e||i?a+(o(t)?"hodiny":"hodin"):a+"hodinami";case"d":return e||i?"den":"dnem";case"dd":return e||i?a+(o(t)?"dny":"dní"):a+"dny";case"M":return e||i?"měsíc":"měsícem";case"MM":return e||i?a+(o(t)?"měsíce":"měsíců"):a+"měsíci";case"y":return e||i?"rok":"rokem";case"yy":return e||i?a+(o(t)?"roky":"let"):a+"lety"}}t.defineLocale("cs",{months:e,monthsShort:n,monthsRegex:a,monthsShortRegex:a,monthsStrictRegex:/^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,monthsShortStrictRegex:/^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,monthsParse:i,longMonthsParse:i,shortMonthsParse:i,weekdays:"neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),weekdaysShort:"ne_po_út_st_čt_pá_so".split("_"),weekdaysMin:"ne_po_út_st_čt_pá_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd D. MMMM YYYY H:mm",l:"D. M. YYYY"},calendar:{sameDay:"[dnes v] LT",nextDay:"[zítra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v neděli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve středu v] LT";case 4:return"[ve čtvrtek v] LT";case 5:return"[v pátek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[včera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou neděli v] LT";case 1:case 2:return"[minulé] dddd [v] LT";case 3:return"[minulou středu v] LT";case 4:case 5:return"[minulý] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"před %s",s:r,ss:r,m:r,mm:r,h:r,hh:r,d:r,dd:r,M:r,MM:r,y:r,yy:r},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},stgA:function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAJAIABACB4s////yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAAEALAAAAAAGAAkAAAINDIIGl8vokmJxwiVfKAA7"},svD2:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={words:{ss:["sekund","sekunda","sekundi"],m:["jedan minut","jednog minuta"],mm:["minut","minuta","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mjesec","mjeseca","mjeseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(t,e){return 1===t?e[0]:t>=2&&t<=4?e[1]:e[2]},translate:function(t,n,i){var a=e.words[i];return 1===i.length?n?a[0]:a[1]:t+" "+e.correctGrammaticalCase(t,a)}};t.defineLocale("me",{months:"januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split("_"),monthsShort:"jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm",LLLL:"dddd, D. MMMM YYYY H:mm"},calendar:{sameDay:"[danas u] LT",nextDay:"[sjutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",lastWeek:function(){return["[prošle] [nedjelje] [u] LT","[prošlog] [ponedjeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srijede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"][this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"nekoliko sekundi",ss:e.translate,m:e.translate,mm:e.translate,h:e.translate,hh:e.translate,d:"dan",dd:e.translate,M:"mjesec",MM:e.translate,y:"godinu",yy:e.translate},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}})})(n("PJh5"))},"t05+":function(t,e,n){var i=n("kxFB");(t.exports=n("FZ+f")(!0)).push([t.i,"/*\nProduct Name: dhtmlxSuite \nVersion: 5.1.0 \nEdition: Standard \nLicense: content of this file is covered by DHTMLX Commercial or enterpri. Usage outside GPL terms is prohibited. To obtain Commercial or Enterprise license contact sales@dhtmlx.com\nCopyright UAB Dinamenta http://www.dhtmlx.com\n*/\n\n/*\n\tskin detected: dhx_skyblue\n\tinclude extra file: skins/dhx_skyblue.less\n*/\n.dhtmlxcalendar_ifr {\n\tposition: absolute;\n\toverflow: hidden;\n\tbackground-color: white;\n}\n.dhtmlxcalendar_dhx_skyblue {\n\tposition: absolute;\n\tdisplay: block;\n\tbackground-color: white;\n\tfont-family: Tahoma, Helvetica;\n\tfont-size: 11px;\n\tcolor: black;\n}\n.dhtmlxcalendar_dhx_skyblue ul.dhtmlxcalendar_line {\n\tposition: relative;\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\twidth: 211px;\n}\n.dhtmlxcalendar_dhx_skyblue ul.dhtmlxcalendar_line li {\n\tfloat: left;\n\tposition: relative;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcursor: default;\n\toverflow: hidden;\n\tmargin: 0px;\n\tpadding: 0px;\n}\n.dhtmlxcalendar_dhx_skyblue.dhtmlxcalendar_in_input {\n\t-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.25);\n\t        box-shadow: 0 0 6px rgba(0,0,0,0.25);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 211px;\n\theight: 25px;\n\tmargin: 0px;\n\tbackground-color: #e2efff;\n\tbackground: -webkit-gradient(linear,left top, left bottom,from(#e2efff),to(#d3e7ff));\n\tbackground: linear-gradient(#e2efff,#d3e7ff);\n\tbackground: -webkit-linear-gradient(#e2efff,#d3e7ff);\n\tfilter: progid:DXImageTransform.Microsoft.Gradient(gradientType=0,startColorStr=#e2efff,endColorStr=#d3e7ff) progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n\tborder: 1px solid #a4bed4;\n\toverflow: hidden;\n\tcolor: black;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr {\n\twidth: 211px;\n\theight: 25px;\n\tline-height: 25px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow {\n\tposition: absolute;\n\ttop: 0;\n\twidth: 18px;\n\theight: 25px;\n\ttext-align: center;\n\tcolor: inherit;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left {\n\tleft: 4px;\n\tbackground-image: url("+i(n("79J4"))+");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left_hover {\n\tleft: 4px;\n\tbackground-image: url("+i(n("79J4"))+");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right {\n\tright: 4px;\n\tbackground-image: url("+i(n("qM2r"))+");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right_hover {\n\tright: 4px;\n\tbackground-image: url("+i(n("qM2r"))+");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_month,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_year {\n\tposition: relative;\n\tfont-weight: bold;\n\tcolor: #34404b;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 74px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 211px;\n\tmargin: 0px;\n\tpadding-bottom: 1px;\n\tborder-left: 1px solid #a4bed4;\n\tborder-right: 1px solid #a4bed4;\n\tborder-bottom: 1px solid #cbd9e4;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line {\n\tborder-top: 1px solid white;\n\tpadding-left: 1px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li {\n\twidth: 29px;\n\theight: 19px;\n\tline-height: 19px;\n\tmargin-right: 1px;\n\tfont-size: 9px;\n\tbackground-color: #ecf4ff;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell_first {\n\tcolor: #c66200;\n\tbackground-color: #ffe6ae;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 211px;\n\tmargin: 0px;\n\tpadding-bottom: 1px;\n\tborder-left: 1px solid #a4bed4;\n\tborder-right: 1px solid #a4bed4;\n\tborder-bottom: 1px solid #a4bed4;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line {\n\tborder-top: 1px solid white;\n\tpadding-left: 1px;\n\theight: 26px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li {\n\tcolor: #909090;\n\tbackground-color: white;\n\tborder: 1px solid white;\n\twidth: 27px;\n\theight: 24px;\n\tline-height: 23px;\n\tmargin-right: 1px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label {\n\twidth: 100%;\n\theight: 100%;\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend {\n\tborder-color: #cccccc;\n\tbackground-color: #f7f7f7;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_dis {\n\tcolor: #b2b2b2;\n\tbackground-color: #f0f0f0;\n\tborder-color: #f0f0f0;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday {\n\tcolor: red;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday {\n\tcolor: red;\n\tborder-color: #cccccc;\n\tbackground-color: #f7f7f7;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_dis {\n\tcolor: red;\n\tbackground-color: #f0f0f0;\n\tborder-color: #f0f0f0;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_hover {\n\tborder-color: #cccccc;\n\tbackground-color: #f7f7f7;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_hover {\n\tcolor: red;\n\tborder-color: #cccccc;\n\tbackground-color: #f7f7f7;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month {\n\tcolor: black;\n\tbackground-color: #ecf4ff;\n\tborder-color: #ecf4ff;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend {\n\tcolor: #c66200;\n\tbackground-color: #fff0d2;\n\tborder-color: #fff0d2;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date {\n\tcolor: black;\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend {\n\tcolor: #c66200;\n\tbackground-color: #ffdc90;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_dis {\n\tcolor: #b2b2b2;\n\tbackground-color: #f0f0f0;\n\tborder-color: #f0f0f0;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday {\n\tcolor: red;\n\tbackground-color: #ecf4ff;\n\tborder-color: #ecf4ff;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday {\n\tcolor: red;\n\tbackground-color: #fff0d2;\n\tborder-color: #fff0d2;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday {\n\tcolor: red;\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday {\n\tcolor: red;\n\tbackground-color: #ffdc90;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_dis {\n\tcolor: red;\n\tbackground-color: #f0f0f0;\n\tborder-color: #f0f0f0;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_hover {\n\tcolor: black;\n\tbackground-color: #d9eeff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_hover {\n\tcolor: #c66200;\n\tbackground-color: #ffe9bb;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_hover {\n\tcolor: black;\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_hover {\n\tcolor: #c66200;\n\tbackground-color: #ffdc90;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_hover {\n\tcolor: red;\n\tbackground-color: #d9eeff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_hover {\n\tcolor: red;\n\tbackground-color: #ffe9bb;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_hover {\n\tcolor: red;\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_hover {\n\tcolor: red;\n\tbackground-color: #ffdc90;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line div.dhtmlxcalendar_label.dhtmlxcalendar_label_title {\n\tbackground-image: url("+i(n("YHYu"))+");\n\tbackground-position: top right;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 211px;\n\theight: 25px;\n\tmargin: 0px;\n\tborder-left: 1px solid #a4bed4;\n\tborder-right: 1px solid #a4bed4;\n\tborder-bottom: 1px solid #a4bed4;\n\tbackground-color: #e2efff;\n\tbackground: -webkit-gradient(linear,left top, left bottom,from(#e2efff),to(#d3e7ff));\n\tbackground: linear-gradient(#e2efff,#d3e7ff);\n\tbackground: -webkit-linear-gradient(#e2efff,#d3e7ff);\n\tfilter: progid:DXImageTransform.Microsoft.Gradient(gradientType=0,startColorStr=#e2efff,endColorStr=#d3e7ff) progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li {\n\twidth: 211px;\n\theight: 25px;\n\tline-height: 24px;\n\tcolor: #34404b;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: left;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tposition: absolute;\n\tleft: 8px;\n\ttop: 6px;\n\twidth: 13px;\n\theight: 13px;\n\tbackground-image: url("+i(n("IXY5"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 26px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tleft: 70px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 0px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr div.dhtmlxcalendar_time_img,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_minutes,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_colon {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_skyblue span.dhtmlxcalendar_label_colon {\n\tpadding: 0px 4px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_cover {\n\tposition: absolute;\n\tleft: 1px;\n\tbackground-color: white;\n\topacity: 0.5;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj {\n\tposition: absolute;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_selector_obj_arrow {\n\tposition: absolute;\n\tbottom: auto;\n\ttop: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 9px;\n\toverflow: hidden;\n\tbackground-image: url("+i(n("mY9U"))+");\n\tbackground-position: top center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -15px top;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -57px top;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -53px top;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table {\n\tborder: 1px solid #a4bed4;\n\tbackground-color: white;\n\tborder-top: none;\n\tmargin-top: 9px;\n\t-webkit-box-shadow: 0 0 3px rgba(0,0,0,0.35);\n\t        box-shadow: 0 0 3px rgba(0,0,0,0.35);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid white;\n\tpadding: 0px;\n\tmargin: 0px;\n\tbackground-color: #ecf4ff;\n\tbackground-image: url("+i(n("79J4"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left.dhtmlxcalendar_selector_cell_left_hover {\n\tbackground-image: url("+i(n("79J4"))+");\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle {\n\tborder-top: white 1px solid;\n\tborder-width: 1px 0px 0px 0px;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid white;\n\tborder-width: 1px 0px 0px 0px;\n\tbackground-color: #ecf4ff;\n\tbackground-image: url("+i(n("qM2r"))+");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right.dhtmlxcalendar_selector_cell_right_hover {\n\tbackground-image: url("+i(n("qM2r"))+");\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul {\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px 0px 0px 1px;\n\tpadding: 0px;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li {\n\tfloat: left;\n\tfont-family: Tahoma, Helvetica;\n\tfont-size: 10px;\n\tcolor: black;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmargin: 0px 1px 0px 0px;\n\tpadding: 0px;\n\tbackground-color: #e9f3ff;\n\tborder: 1px solid #e9f3ff;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_active {\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n\tcolor: black;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_hover {\n\tbackground-color: #d9eeff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n\tborder: 0px solid white;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 22px;\n\tborder-top: none;\n\tborder-bottom: 1px solid white;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 33px;\n\theight: 20px;\n\tline-height: 19px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\ttop: auto;\n\tbottom: 0px;\n\tbackground-image: url("+i(n("eok9"))+");\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 19px;\n\tborder-top: none;\n\tborder-bottom: 1px solid white;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 21px;\n\theight: 17px;\n\tline-height: 16px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table {\n\tmargin-top: 0px;\n\tmargin-bottom: 9px;\n\tborder-top: 1px solid #a4bed4;\n\tborder-bottom: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours2,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_year div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: block;\n}\n.dhtmlxcalendar_dhx_skyblue span.dhtmlxcalendar_label_minutes span.dhtmlxcalendar_selected_date {\n\tborder-bottom: 2px solid red;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 26px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 24px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 26px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 21px;\n\tcolor: #638eb1;\n\tbackground-color: #d9eaff;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 19px;\n\tcolor: #638eb1;\n\tbackground-color: #d9eaff;\n\tborder-color: #d9eaff;\n\tfont-size: 10px;\n}\ndiv.dhtmlxcalendar_skin_detect {\n\tposition: absolute;\n\tdisplay: block;\n\tvisibility: hidden;\n\tleft: -100px;\n\ttop: 0px;\n\twidth: 10px;\n\theight: 10px;\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder: none;\n\toverflow: hidden;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/dhx/calendar/skins/dhtmlxcalendar_dhx_skyblue.css"],names:[],mappings:"AAAA;;;;;;EAME;;AAEF;;;EAGE;AACF;CACC,mBAAmB;CACnB,iBAAiB;CACjB,wBAAwB;CACxB;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,wBAAwB;CACxB,+BAA+B;CAC/B,gBAAgB;CAChB,aAAa;CACb;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,iBAAiB;CACjB,aAAa;CACb;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;CACZ,aAAa;CACb;AACD;CACC,6CAA6C;SACrC,qCAAqC;CAC7C;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,aAAa;CACb,YAAY;CACZ,0BAA0B;CAC1B,qFAAqF;CACrF,6CAA6C;CAC7C,qDAAqD;CACrD,kKAAkK;CAClK,0BAA0B;CAC1B,iBAAiB;CACjB,aAAa;CACb,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,mBAAmB;CACnB,OAAO;CACP,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,eAAe;CACf,mCAAmC;CACnC,6BAA6B;CAC7B;AACD;CACC,UAAU;CACV,gDAAgF;CAChF,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,UAAU;CACV,gDAAgF;CAChF,WAAW;CACX,6DAA6D;CAC7D;AACD;CACC,WAAW;CACX,gDAAiF;CACjF,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,WAAW;CACX,gDAAiF;CACjF,WAAW;CACX,6DAA6D;CAC7D;AACD;;CAEC,mBAAmB;CACnB,kBAAkB;CAClB,eAAe;CACf;AACD;;CAEC,cAAc;CACd;AACD;CACC,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,aAAa;CACb,mBAAmB;CACnB;AACD;;CAEC,aAAa;CACb,kBAAkB;CAClB;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,oBAAoB;CACpB,+BAA+B;CAC/B,gCAAgC;CAChC,iCAAiC;CACjC,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;CACC,4BAA4B;CAC5B,kBAAkB;CAClB;AACD;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,0BAA0B;CAC1B;AACD;;CAEC,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,YAAY;CACZ,oBAAoB;CACpB,+BAA+B;CAC/B,gCAAgC;CAChC,iCAAiC;CACjC,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,aAAa;CACb;AACD;CACC,eAAe;CACf,wBAAwB;CACxB,wBAAwB;CACxB,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB;AACD;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB;AACD;;CAEC,sBAAsB;CACtB,0BAA0B;CAC1B;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;;CAEC,WAAW;CACX;AACD;;CAEC,WAAW;CACX,sBAAsB;CACtB,0BAA0B;CAC1B;AACD;;;;CAIC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;;;;CAIC,sBAAsB;CACtB,0BAA0B;CAC1B;AACD;;;;CAIC,WAAW;CACX,sBAAsB;CACtB,0BAA0B;CAC1B;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;;;;CAIC,eAAe;CACf,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;;;;CAIC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,aAAa;CACb,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,eAAe;CACf,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,WAAW;CACX,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;CACC,gDAA0E;CAC1E,+BAA+B;CAC/B,6BAA6B;CAC7B;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,aAAa;CACb,aAAa;CACb,YAAY;CACZ,+BAA+B;CAC/B,gCAAgC;CAChC,iCAAiC;CACjC,0BAA0B;CAC1B,qFAAqF;CACrF,6CAA6C;CAC7C,qDAAqD;CACrD,kKAAkK;CAClK,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;CACjB;AACD;CACC,aAAa;CACb,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf;AACD;CACC,iBAAiB;CACjB;AACD;CACC,mBAAmB;CACnB,UAAU;CACV,SAAS;CACT,YAAY;CACZ,aAAa;CACb,gDAA2E;CAC3E,mCAAmC;CACnC,6BAA6B;CAC7B;AACD;CACC,kBAAkB;CAClB;AACD;CACC,WAAW;CACX;AACD;CACC,mBAAmB;CACnB;AACD;CACC,iBAAiB;CACjB;AACD;;;;CAIC,cAAc;CACd;AACD;CACC,iBAAiB;CACjB;AACD;CACC,mBAAmB;CACnB,UAAU;CACV,wBAAwB;CACxB,aAAa;CACb,4DAA4D;CAC5D;AACD;CACC,mBAAmB;CACnB;AACD;CACC,mBAAmB;CACnB,aAAa;CACb,SAAS;CACT,UAAU;CACV,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,gDAAkF;CAClF,gCAAgC;CAChC,6BAA6B;CAC7B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,+BAA+B;CAC/B;AACD;CACC,0BAA0B;CAC1B,wBAAwB;CACxB,iBAAiB;CACjB,gBAAgB;CAChB,6CAA6C;SACrC,qCAAqC;CAC7C;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,4BAA4B;CAC5B,aAAa;CACb,YAAY;CACZ,0BAA0B;CAC1B,gDAAgF;CAChF,mCAAmC;CACnC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;CACC,gDAAgF;CAChF;AACD;CACC,4BAA4B;CAC5B,8BAA8B;CAC9B,gBAAgB;CAChB;AACD;CACC,YAAY;CACZ,mBAAmB;CACnB,4BAA4B;CAC5B,8BAA8B;CAC9B,0BAA0B;CAC1B,gDAAiF;CACjF,mCAAmC;CACnC,6BAA6B;CAC7B,gBAAgB;CAChB;AACD;CACC,iDAAiF;CACjF;AACD;CACC,eAAe;CACf,YAAY;CACZ,wBAAwB;CACxB,aAAa;CACb,iBAAiB;CACjB,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB;AACD;CACC,YAAY;CACZ,+BAA+B;CAC/B,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,uBAAuB;CACvB,wBAAwB;CACxB,aAAa;CACb,0BAA0B;CAC1B,0BAA0B;CAC1B,0BAA0B;CAC1B,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB;AACD;CACC,0BAA0B;CAC1B,sBAAsB;CACtB,aAAa;CACb;AACD;CACC,0BAA0B;CAC1B,sBAAsB;CACtB;AACD;;CAEC,cAAc;CACd,WAAW;CACX,wBAAwB;CACxB;AACD;CACC,aAAa;CACb,iBAAiB;CACjB,+BAA+B;CAC/B;AACD;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB;AACD;;;CAGC,UAAU;CACV,YAAY;CACZ,iDAAqF;CACrF;AACD;;;CAGC,aAAa;CACb,iBAAiB;CACjB,+BAA+B;CAC/B;AACD;;;CAGC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB;AACD;;;;;;CAMC,cAAc;CACd,WAAW;CACX;AACD;;;CAGC,gBAAgB;CAChB,mBAAmB;CACnB,8BAA8B;CAC9B,oBAAoB;CACpB;AACD;;;;;;;CAOC,cAAc;CACd;AACD;;;;;;;CAOC,eAAe;CACf;AACD;CACC,6BAA6B;CAC7B;AACD;;CAEC,cAAc;CACd;AACD;CACC,YAAY;CACZ;AACD;CACC,YAAY;CACZ;AACD;;CAEC,YAAY;CACZ;AACD;CACC,eAAe;CACf,YAAY;CACZ,eAAe;CACf,0BAA0B;CAC1B;AACD;CACC,eAAe;CACf,YAAY;CACZ,eAAe;CACf,0BAA0B;CAC1B,sBAAsB;CACtB,gBAAgB;CAChB;AACD;CACC,mBAAmB;CACnB,eAAe;CACf,mBAAmB;CACnB,aAAa;CACb,SAAS;CACT,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,aAAa;CACb,aAAa;CACb,iBAAiB;CACjB",file:"dhtmlxcalendar_dhx_skyblue.css",sourcesContent:['/*\nProduct Name: dhtmlxSuite \nVersion: 5.1.0 \nEdition: Standard \nLicense: content of this file is covered by DHTMLX Commercial or enterpri. Usage outside GPL terms is prohibited. To obtain Commercial or Enterprise license contact sales@dhtmlx.com\nCopyright UAB Dinamenta http://www.dhtmlx.com\n*/\n\n/*\n\tskin detected: dhx_skyblue\n\tinclude extra file: skins/dhx_skyblue.less\n*/\n.dhtmlxcalendar_ifr {\n\tposition: absolute;\n\toverflow: hidden;\n\tbackground-color: white;\n}\n.dhtmlxcalendar_dhx_skyblue {\n\tposition: absolute;\n\tdisplay: block;\n\tbackground-color: white;\n\tfont-family: Tahoma, Helvetica;\n\tfont-size: 11px;\n\tcolor: black;\n}\n.dhtmlxcalendar_dhx_skyblue ul.dhtmlxcalendar_line {\n\tposition: relative;\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px;\n\tpadding: 0px;\n\toverflow: hidden;\n\twidth: 211px;\n}\n.dhtmlxcalendar_dhx_skyblue ul.dhtmlxcalendar_line li {\n\tfloat: left;\n\tposition: relative;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tcursor: default;\n\toverflow: hidden;\n\tmargin: 0px;\n\tpadding: 0px;\n}\n.dhtmlxcalendar_dhx_skyblue.dhtmlxcalendar_in_input {\n\t-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.25);\n\t        box-shadow: 0 0 6px rgba(0,0,0,0.25);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 211px;\n\theight: 25px;\n\tmargin: 0px;\n\tbackground-color: #e2efff;\n\tbackground: -webkit-gradient(linear,left top, left bottom,from(#e2efff),to(#d3e7ff));\n\tbackground: linear-gradient(#e2efff,#d3e7ff);\n\tbackground: -webkit-linear-gradient(#e2efff,#d3e7ff);\n\tfilter: progid:DXImageTransform.Microsoft.Gradient(gradientType=0,startColorStr=#e2efff,endColorStr=#d3e7ff) progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n\tborder: 1px solid #a4bed4;\n\toverflow: hidden;\n\tcolor: black;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr {\n\twidth: 211px;\n\theight: 25px;\n\tline-height: 25px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow {\n\tposition: absolute;\n\ttop: 0;\n\twidth: 18px;\n\theight: 25px;\n\ttext-align: center;\n\tcolor: inherit;\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left {\n\tleft: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_arrow_left.gif");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_left_hover {\n\tleft: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_arrow_left.gif");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right {\n\tright: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_arrow_right.gif");\n\topacity: 0.8;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=80);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr div.dhtmlxcalendar_month_arrow.dhtmlxcalendar_month_arrow_right_hover {\n\tright: 4px;\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_arrow_right.gif");\n\topacity: 1;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_month,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_month_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_month_hdr span.dhtmlxcalendar_month_label_year {\n\tposition: relative;\n\tfont-weight: bold;\n\tcolor: #34404b;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 74px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_today,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_clear {\n\tfloat: right;\n\tmargin-right: 8px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 211px;\n\tmargin: 0px;\n\tpadding-bottom: 1px;\n\tborder-left: 1px solid #a4bed4;\n\tborder-right: 1px solid #a4bed4;\n\tborder-bottom: 1px solid #cbd9e4;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\t-o-user-select: text;\n\tuser-select: text;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line {\n\tborder-top: 1px solid white;\n\tpadding-left: 1px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li {\n\twidth: 29px;\n\theight: 19px;\n\tline-height: 19px;\n\tmargin-right: 1px;\n\tfont-size: 9px;\n\tbackground-color: #ecf4ff;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_day_weekday_cell_first {\n\tcolor: #c66200;\n\tbackground-color: #ffe6ae;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 211px;\n\tmargin: 0px;\n\tpadding-bottom: 1px;\n\tborder-left: 1px solid #a4bed4;\n\tborder-right: 1px solid #a4bed4;\n\tborder-bottom: 1px solid #a4bed4;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line {\n\tborder-top: 1px solid white;\n\tpadding-left: 1px;\n\theight: 26px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li {\n\tcolor: #909090;\n\tbackground-color: white;\n\tborder: 1px solid white;\n\twidth: 27px;\n\theight: 24px;\n\tline-height: 23px;\n\tmargin-right: 1px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_label {\n\twidth: 100%;\n\theight: 100%;\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend {\n\tborder-color: #cccccc;\n\tbackground-color: #f7f7f7;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_dis {\n\tcolor: #b2b2b2;\n\tbackground-color: #f0f0f0;\n\tborder-color: #f0f0f0;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday {\n\tcolor: red;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday {\n\tcolor: red;\n\tborder-color: #cccccc;\n\tbackground-color: #f7f7f7;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_dis {\n\tcolor: red;\n\tbackground-color: #f0f0f0;\n\tborder-color: #f0f0f0;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_hover {\n\tborder-color: #cccccc;\n\tbackground-color: #f7f7f7;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_holiday_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_weekend_holiday_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_holiday_hover,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_date_weekend_holiday_hover {\n\tcolor: red;\n\tborder-color: #cccccc;\n\tbackground-color: #f7f7f7;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month {\n\tcolor: black;\n\tbackground-color: #ecf4ff;\n\tborder-color: #ecf4ff;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend {\n\tcolor: #c66200;\n\tbackground-color: #fff0d2;\n\tborder-color: #fff0d2;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date {\n\tcolor: black;\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend {\n\tcolor: #c66200;\n\tbackground-color: #ffdc90;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_dis {\n\tcolor: #b2b2b2;\n\tbackground-color: #f0f0f0;\n\tborder-color: #f0f0f0;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday {\n\tcolor: red;\n\tbackground-color: #ecf4ff;\n\tborder-color: #ecf4ff;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday {\n\tcolor: red;\n\tbackground-color: #fff0d2;\n\tborder-color: #fff0d2;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday {\n\tcolor: red;\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday {\n\tcolor: red;\n\tbackground-color: #ffdc90;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_dis,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_dis {\n\tcolor: red;\n\tbackground-color: #f0f0f0;\n\tborder-color: #f0f0f0;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_hover {\n\tcolor: black;\n\tbackground-color: #d9eeff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_hover {\n\tcolor: #c66200;\n\tbackground-color: #ffe9bb;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_hover {\n\tcolor: black;\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_hover {\n\tcolor: #c66200;\n\tbackground-color: #ffdc90;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_holiday_hover {\n\tcolor: red;\n\tbackground-color: #d9eeff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_weekend_holiday_hover {\n\tcolor: red;\n\tbackground-color: #ffe9bb;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_holiday_hover {\n\tcolor: red;\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_cell_month_date_weekend_holiday_hover {\n\tcolor: red;\n\tbackground-color: #ffdc90;\n\tborder-color: #ffce65;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line div.dhtmlxcalendar_label.dhtmlxcalendar_label_title {\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_mark.gif");\n\tbackground-position: top right;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 211px;\n\theight: 25px;\n\tmargin: 0px;\n\tborder-left: 1px solid #a4bed4;\n\tborder-right: 1px solid #a4bed4;\n\tborder-bottom: 1px solid #a4bed4;\n\tbackground-color: #e2efff;\n\tbackground: -webkit-gradient(linear,left top, left bottom,from(#e2efff),to(#d3e7ff));\n\tbackground: linear-gradient(#e2efff,#d3e7ff);\n\tbackground: -webkit-linear-gradient(#e2efff,#d3e7ff);\n\tfilter: progid:DXImageTransform.Microsoft.Gradient(gradientType=0,startColorStr=#e2efff,endColorStr=#d3e7ff) progid:DXImageTransform.Microsoft.Alpha(opacity=100);\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\toverflow: hidden;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li {\n\twidth: 211px;\n\theight: 25px;\n\tline-height: 24px;\n\tcolor: #34404b;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: left;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tposition: absolute;\n\tleft: 8px;\n\ttop: 6px;\n\twidth: 13px;\n\theight: 13px;\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_clock.gif");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 26px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li div.dhtmlxcalendar_time_img {\n\tleft: 70px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr {\n\ttext-align: center;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_time ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours {\n\tmargin-left: 0px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr div.dhtmlxcalendar_time_img,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_hours,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_minutes,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_time_cont.dhtmlxcalendar_mode_today ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell.dhtmlxcalendar_time_hdr span.dhtmlxcalendar_label_colon {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_skyblue span.dhtmlxcalendar_label_colon {\n\tpadding: 0px 4px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_cover {\n\tposition: absolute;\n\tleft: 1px;\n\tbackground-color: white;\n\topacity: 0.5;\n\tfilter: progid:DXImageTransform.Microsoft.Alpha(opacity=50);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj {\n\tposition: absolute;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_selector_obj_arrow {\n\tposition: absolute;\n\tbottom: auto;\n\ttop: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\theight: 9px;\n\toverflow: hidden;\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_selector_top.gif");\n\tbackground-position: top center;\n\tbackground-repeat: no-repeat;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -15px top;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -57px top;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\tbackground-position: -53px top;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table {\n\tborder: 1px solid #a4bed4;\n\tbackground-color: white;\n\tborder-top: none;\n\tmargin-top: 9px;\n\t-webkit-box-shadow: 0 0 3px rgba(0,0,0,0.35);\n\t        box-shadow: 0 0 3px rgba(0,0,0,0.35);\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid white;\n\tpadding: 0px;\n\tmargin: 0px;\n\tbackground-color: #ecf4ff;\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_arrow_left.gif");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left.dhtmlxcalendar_selector_cell_left_hover {\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_arrow_left.gif");\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle {\n\tborder-top: white 1px solid;\n\tborder-width: 1px 0px 0px 0px;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\twidth: 17px;\n\ttext-align: center;\n\tborder-top: 1px solid white;\n\tborder-width: 1px 0px 0px 0px;\n\tbackground-color: #ecf4ff;\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_arrow_right.gif");\n\tbackground-position: center center;\n\tbackground-repeat: no-repeat;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right.dhtmlxcalendar_selector_cell_right_hover {\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_arrow_right.gif");\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul {\n\tdisplay: block;\n\tclear: both;\n\tmargin: 0px 0px 0px 1px;\n\tpadding: 0px;\n\toverflow: hidden;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li {\n\tfloat: left;\n\tfont-family: Tahoma, Helvetica;\n\tfont-size: 10px;\n\tcolor: black;\n\tlist-style-type: none;\n\tlist-style-image: none;\n\ttext-align: center;\n\tvertical-align: middle;\n\tmargin: 0px 1px 0px 0px;\n\tpadding: 0px;\n\tbackground-color: #e9f3ff;\n\tborder: 1px solid #e9f3ff;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\t-o-user-select: none;\n\tuser-select: none;\n\tcursor: default;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_active {\n\tbackground-color: #b5deff;\n\tborder-color: #a1ceed;\n\tcolor: black;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul li.dhtmlxcalendar_selector_cell_hover {\n\tbackground-color: #d9eeff;\n\tborder-color: #a1ceed;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n\tborder: 0px solid white;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 22px;\n\tborder-top: none;\n\tborder-bottom: 1px solid white;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 33px;\n\theight: 20px;\n\tline-height: 19px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_selector_obj_arrow,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_selector_obj_arrow {\n\ttop: auto;\n\tbottom: 0px;\n\tbackground-image: url("../imgs/dhxcalendar_skyblue/dhxcalendar_selector_bottom.gif");\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line {\n\theight: 19px;\n\tborder-top: none;\n\tborder-bottom: 1px solid white;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_middle ul.dhtmlxcalendar_selector_line li.dhtmlxcalendar_selector_cell {\n\twidth: 21px;\n\theight: 17px;\n\tline-height: 16px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_left,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table td.dhtmlxcalendar_selector_cell_right {\n\tdisplay: none;\n\twidth: 0px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 table.dhtmlxcalendar_selector_table,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes table.dhtmlxcalendar_selector_table {\n\tmargin-top: 0px;\n\tmargin-bottom: 9px;\n\tborder-top: 1px solid #a4bed4;\n\tborder-bottom: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_hours2,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_month div.dhtmlxcalendar_area_selector_month,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_year div.dhtmlxcalendar_area_selector_year,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_hours2 div.dhtmlxcalendar_area_selector_hours,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes4,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_selector_obj.dhtmlxcalendar_selector_minutes div.dhtmlxcalendar_area_selector_minutes5 {\n\tdisplay: block;\n}\n.dhtmlxcalendar_dhx_skyblue span.dhtmlxcalendar_label_minutes span.dhtmlxcalendar_selected_date {\n\tborder-bottom: 2px solid red;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: none;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 26px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 24px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_first,\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell {\n\twidth: 26px;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_days_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 21px;\n\tcolor: #638eb1;\n\tbackground-color: #d9eaff;\n}\n.dhtmlxcalendar_dhx_skyblue div.dhtmlxcalendar_wn div.dhtmlxcalendar_dates_cont ul.dhtmlxcalendar_line li.dhtmlxcalendar_cell_wn {\n\tdisplay: block;\n\twidth: 19px;\n\tcolor: #638eb1;\n\tbackground-color: #d9eaff;\n\tborder-color: #d9eaff;\n\tfont-size: 10px;\n}\ndiv.dhtmlxcalendar_skin_detect {\n\tposition: absolute;\n\tdisplay: block;\n\tvisibility: hidden;\n\tleft: -100px;\n\ttop: 0px;\n\twidth: 10px;\n\theight: 10px;\n\tmargin: 0px;\n\tpadding: 0px;\n\tborder: none;\n\toverflow: hidden;\n}\n'],sourceRoot:""}])},t8qj:function(t,e,n){"use strict";t.exports=function(t,e,n,i,a){return t.config=e,n&&(t.code=n),t.request=i,t.response=a,t}},tIFN:function(t,e,n){"use strict";var i=n("cGG2"),a=n("JP+z"),o=n("XmWM"),r=n("KCLY");function s(t){var e=new o(t),n=a(o.prototype.request,e);return i.extend(n,o.prototype,e),i.extend(n,e),n}var l=s(r);l.Axios=o,l.create=function(t){return s(i.merge(r,t))},l.Cancel=n("dVOP"),l.CancelToken=n("cWxy"),l.isCancel=n("pBtG"),l.all=function(t){return Promise.all(t)},l.spread=n("pxG4"),t.exports=l,t.exports.default=l},tP0i:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\ndiv.toolbox-tab-menu div.list-group[data-v-6408bcdc] {\n  margin-bottom: 0;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-6408bcdc] {\n  color: #000;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-6408bcdc]:first-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-6408bcdc]:last-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-6408bcdc],\ndiv.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-6408bcdc],\ndiv.toolbox-tab-menu div.list-group > a.active .fa[data-v-6408bcdc] {\n  color: black !important;\n  font-weight: bold;\n  border-radius: 0px !important;\n}\n.list-group-item[data-v-6408bcdc]:hover, .list-group-item[data-v-6408bcdc]:focus {\n  z-index: none !important;\n}\n.list-group[data-v-6408bcdc] {\n  display: -webkit-inline-box;\n  -webkit-box-orient: horizontal;\n  font-size: 0.875rem;\n}\n.list-group-item[data-v-6408bcdc] {\n  border-radius: 0px !important;\n  border: none;\n}\n.list-group-item.active[data-v-6408bcdc] {\n  background-color: #fff;\n  border-color: #fff;\n}\n.tabsSecundary[data-v-6408bcdc] {\n  padding: 3px 8px;\n  font-size: 1rem;\n  padding-left: 0px;\n  margin-left: 15px;\n  color: gray !important;\n}\n.icoArrow[data-v-6408bcdc] {\n  line-height: 1;\n  font-size: 20px;\n  position: absolute;\n  top: 5px;\n  right: -7px;\n}\n.positionContact[data-v-6408bcdc] {\n  margin-left: 12px !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/utils/PfTopBar/PfTopBar.css"],names:[],mappings:";AACA;EACE,iBAAiB;CAClB;AACD;EACE,YAAY;CACb;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,8BAA8B;CAC/B;AACD;;;EAGE,wBAAwB;EACxB,kBAAkB;EAClB,8BAA8B;CAC/B;AACD;EACE,yBAAyB;CAC1B;AACD;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;CACrB;AACD;EACE,8BAA8B;EAC9B,aAAa;CACd;AACD;EACE,uBAAuB;EACvB,mBAAmB;CACpB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;CACxB;AACD;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,YAAY;CACb;AACD;EACE,6BAA6B;CAC9B",file:"PfTopBar.css",sourcesContent:["\ndiv.toolbox-tab-menu div.list-group[data-v-6408bcdc] {\n  margin-bottom: 0;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-6408bcdc] {\n  color: #000;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-6408bcdc]:first-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-6408bcdc]:last-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-6408bcdc],\ndiv.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-6408bcdc],\ndiv.toolbox-tab-menu div.list-group > a.active .fa[data-v-6408bcdc] {\n  color: black !important;\n  font-weight: bold;\n  border-radius: 0px !important;\n}\n.list-group-item[data-v-6408bcdc]:hover, .list-group-item[data-v-6408bcdc]:focus {\n  z-index: none !important;\n}\n.list-group[data-v-6408bcdc] {\n  display: -webkit-inline-box;\n  -webkit-box-orient: horizontal;\n  font-size: 0.875rem;\n}\n.list-group-item[data-v-6408bcdc] {\n  border-radius: 0px !important;\n  border: none;\n}\n.list-group-item.active[data-v-6408bcdc] {\n  background-color: #fff;\n  border-color: #fff;\n}\n.tabsSecundary[data-v-6408bcdc] {\n  padding: 3px 8px;\n  font-size: 1rem;\n  padding-left: 0px;\n  margin-left: 15px;\n  color: gray !important;\n}\n.icoArrow[data-v-6408bcdc] {\n  line-height: 1;\n  font-size: 20px;\n  position: absolute;\n  top: 5px;\n  right: -7px;\n}\n.positionContact[data-v-6408bcdc] {\n  margin-left: 12px !important;\n}\n"],sourceRoot:""}])},tQIw:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfBackgroundCheckInformation.css",sourceRoot:""}])},tTVk:function(t,e){t.exports=function(t,e){for(var n=[],i={},a=0;a<e.length;a++){var o=e[a],r=o[0],s={id:t+":"+a,css:o[1],media:o[2],sourceMap:o[3]};i[r]?i[r].parts.push(s):n.push(i[r]={id:r,parts:[s]})}return n}},tW76:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-26fd3c9c] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-26fd3c9c]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-26fd3c9c] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-26fd3c9c] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-26fd3c9c] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-26fd3c9c] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-26fd3c9c] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-26fd3c9c] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-26fd3c9c] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-26fd3c9c] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-26fd3c9c] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-26fd3c9c] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-26fd3c9c] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-26fd3c9c] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-26fd3c9c] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-26fd3c9c] {\n  margin-right: 0px;\n}\n.newItem[data-v-26fd3c9c] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-26fd3c9c] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-26fd3c9c] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-26fd3c9c] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-26fd3c9c] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-26fd3c9c] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-26fd3c9c] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-26fd3c9c] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-26fd3c9c] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-26fd3c9c] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-26fd3c9c]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-26fd3c9c] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-26fd3c9c] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-26fd3c9c] {\n  color: red;\n}\n.showMore[data-v-26fd3c9c]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-26fd3c9c] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-26fd3c9c] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-26fd3c9c] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-26fd3c9c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-26fd3c9c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-26fd3c9c] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-26fd3c9c 3s infinite;\n  animation: bit-data-v-26fd3c9c 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-26fd3c9c] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-26fd3c9c]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-26fd3c9c]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-26fd3c9c]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-26fd3c9c]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-26fd3c9c]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-26fd3c9c]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-26fd3c9c] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-26fd3c9c]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-26fd3c9c] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-26fd3c9c] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-26fd3c9c] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-26fd3c9c] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-26fd3c9c] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-26fd3c9c] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-26fd3c9c] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-26fd3c9c] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-26fd3c9c] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-26fd3c9c] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-26fd3c9c] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-26fd3c9c] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-26fd3c9c] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-26fd3c9c] {\n  margin-right: 0px;\n}\n.newItem[data-v-26fd3c9c] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-26fd3c9c] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-26fd3c9c] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-26fd3c9c] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-26fd3c9c] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-26fd3c9c] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-26fd3c9c] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-26fd3c9c] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-26fd3c9c] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-26fd3c9c] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-26fd3c9c]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-26fd3c9c] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-26fd3c9c] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-26fd3c9c] {\n  color: red;\n}\n.showMore[data-v-26fd3c9c]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-26fd3c9c] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-26fd3c9c] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-26fd3c9c] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-26fd3c9c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-26fd3c9c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-26fd3c9c] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-26fd3c9c 3s infinite;\n  animation: bit-data-v-26fd3c9c 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-26fd3c9c] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-26fd3c9c]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-26fd3c9c]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-26fd3c9c]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-26fd3c9c]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-26fd3c9c]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-26fd3c9c]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},tYO1:function(t,e,n){n("0/jl"),n("gCWN"),n("3ggi"),n("OoWg"),t.exports=n("iANj").Symbol},tkWw:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e=function(t){return 0===t?0:1===t?1:2===t?2:t%100>=3&&t%100<=10?3:t%100>=11?4:5},n={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},i=function(t){return function(i,a,o,r){var s=e(i),l=n[t][e(i)];return 2===s&&(l=l[a?0:1]),l.replace(/%d/i,i)}},a=["جانفي","فيفري","مارس","أفريل","ماي","جوان","جويلية","أوت","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];t.defineLocale("ar-dz",{months:a,monthsShort:a,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(t){return"م"===t},meridiem:function(t,e,n){return t<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:i("s"),ss:i("s"),m:i("m"),mm:i("m"),h:i("h"),hh:i("h"),d:i("d"),dd:i("d"),M:i("M"),MM:i("M"),y:i("y"),yy:i("y")},postformat:function(t){return t.replace(/,/g,"،")},week:{dow:0,doy:4}})})(n("PJh5"))},tn1D:function(t,e,n){var i=n("FKWp");t.exports=function(t,e,n,a){try{return a?e(i(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&i(o.call(t)),e}}},tsdW:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfCriminalHistory.css",sourceRoot:""}])},ttEU:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-1da58f3a] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-1da58f3a]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-1da58f3a] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-1da58f3a] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-1da58f3a] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-1da58f3a] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-1da58f3a] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-1da58f3a] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-1da58f3a] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-1da58f3a] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-1da58f3a] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-1da58f3a] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-1da58f3a] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-1da58f3a] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-1da58f3a] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-1da58f3a] {\n  margin-right: 0px;\n}\n.newItem[data-v-1da58f3a] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-1da58f3a] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-1da58f3a] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-1da58f3a] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-1da58f3a] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-1da58f3a] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-1da58f3a] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-1da58f3a] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-1da58f3a] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-1da58f3a] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-1da58f3a]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-1da58f3a] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-1da58f3a] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-1da58f3a] {\n  color: red;\n}\n.showMore[data-v-1da58f3a]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-1da58f3a] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-1da58f3a] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-1da58f3a] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-1da58f3a {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-1da58f3a {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-1da58f3a] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-1da58f3a 3s infinite;\n  animation: bit-data-v-1da58f3a 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-1da58f3a] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-1da58f3a]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-1da58f3a]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-1da58f3a]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-1da58f3a]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-1da58f3a]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-1da58f3a]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-1da58f3a] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-1da58f3a]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-1da58f3a] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-1da58f3a] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-1da58f3a] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-1da58f3a] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-1da58f3a] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-1da58f3a] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-1da58f3a] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-1da58f3a] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-1da58f3a] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-1da58f3a] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-1da58f3a] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-1da58f3a] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-1da58f3a] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-1da58f3a] {\n  margin-right: 0px;\n}\n.newItem[data-v-1da58f3a] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-1da58f3a] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-1da58f3a] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-1da58f3a] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-1da58f3a] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-1da58f3a] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-1da58f3a] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-1da58f3a] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-1da58f3a] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-1da58f3a] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-1da58f3a]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-1da58f3a] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-1da58f3a] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-1da58f3a] {\n  color: red;\n}\n.showMore[data-v-1da58f3a]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-1da58f3a] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-1da58f3a] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-1da58f3a] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-1da58f3a {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-1da58f3a {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-1da58f3a] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-1da58f3a 3s infinite;\n  animation: bit-data-v-1da58f3a 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-1da58f3a] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-1da58f3a]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-1da58f3a]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-1da58f3a]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-1da58f3a]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-1da58f3a]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-1da58f3a]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},tz60:function(t,e,n){"use strict";var i=n("0Lvz")(!0);n("4dmN")(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=i(e,n),this._i+=t.length,{value:t,done:!1})})},tzHd:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e=/(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,n=[/^janv/i,/^févr/i,/^mars/i,/^avr/i,/^mai/i,/^juin/i,/^juil/i,/^août/i,/^sept/i,/^oct/i,/^nov/i,/^déc/i];t.defineLocale("fr",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),monthsRegex:e,monthsShortRegex:e,monthsStrictRegex:/^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,monthsShortStrictRegex:/(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,monthsParse:n,longMonthsParse:n,shortMonthsParse:n,weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},calendar:{sameDay:"[Aujourd’hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",ss:"%d secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",w:"une semaine",ww:"%d semaines",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},dayOfMonthOrdinalParse:/\d{1,2}(er|)/,ordinal:function(t,e){switch(e){case"D":return t+(1===t?"er":"");default:case"M":case"Q":case"DDD":case"d":return t+(1===t?"er":"e");case"w":case"W":return t+(1===t?"re":"e")}},week:{dow:1,doy:4}})})(n("PJh5"))},uQcH:function(t,e,n){var i=n("qs+f"),a=n("pEGt"),o=n("ksFB"),r=n("bSeU").f;t.exports=function(t){return function(e){for(var n,s=o(e),l=a(s),d=l.length,c=0,h=[];d>c;)n=l[c++],i&&!r.call(s,n)||h.push(t?[n,s[n]]:s[n]);return h}}},uSe8:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e=["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","ستمبر","اکتوبر","نومبر","دسمبر"],n=["اتوار","پیر","منگل","بدھ","جمعرات","جمعہ","ہفتہ"];t.defineLocale("ur",{months:e,monthsShort:e,weekdays:n,weekdaysShort:n,weekdaysMin:n,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd، D MMMM YYYY HH:mm"},meridiemParse:/صبح|شام/,isPM:function(t){return"شام"===t},meridiem:function(t,e,n){return t<12?"صبح":"شام"},calendar:{sameDay:"[آج بوقت] LT",nextDay:"[کل بوقت] LT",nextWeek:"dddd [بوقت] LT",lastDay:"[گذشتہ روز بوقت] LT",lastWeek:"[گذشتہ] dddd [بوقت] LT",sameElse:"L"},relativeTime:{future:"%s بعد",past:"%s قبل",s:"چند سیکنڈ",ss:"%d سیکنڈ",m:"ایک منٹ",mm:"%d منٹ",h:"ایک گھنٹہ",hh:"%d گھنٹے",d:"ایک دن",dd:"%d دن",M:"ایک ماہ",MM:"%d ماہ",y:"ایک سال",yy:"%d سال"},preparse:function(t){return t.replace(/،/g,",")},postformat:function(t){return t.replace(/,/g,"،")},week:{dow:1,doy:4}})})(n("PJh5"))},ugSv:function(module,exports){function dhtmlDragAndDropObject(){return window.dhtmlDragAndDrop?window.dhtmlDragAndDrop:(this.lastLanding=0,this.dragNode=0,this.dragStartNode=0,this.dragStartObject=0,this.tempDOMU=null,this.tempDOMM=null,this.waitDrag=0,window.dhtmlDragAndDrop=this,this)}if(void 0===window.dhx&&(window.dhx=window.dhx4={version:"5.1.0",skin:null,skinDetect:function(t){return{10:"dhx_skyblue",20:"dhx_web",30:"dhx_terrace",40:"material"}[10*Math.floor(dhx4.readFromCss(t+"_skin_detect")/10)]||null},readFromCss:function(t,e,n){var i=document.createElement("DIV");i.className=t,null!=document.body.firstChild?document.body.insertBefore(i,document.body.firstChild):document.body.appendChild(i),"string"==typeof n&&(i.innerHTML=n);var a=i[e||"offsetWidth"];return i.parentNode.removeChild(i),i=null,a},lastId:1,newId:function(){return this.lastId++},zim:{data:{},step:5,first:function(){return 100},last:function(){var t=this.first();for(var e in this.data)t=Math.max(t,this.data[e]);return t},reserve:function(t){return this.data[t]=this.last()+this.step,this.data[t]},clear:function(t){null!=this.data[t]&&(this.data[t]=null,delete this.data[t])}},s2b:function(t){return"string"==typeof t&&(t=t.toLowerCase()),1==t||1==t||"true"==t||"1"==t||"yes"==t||"y"==t||"on"==t},s2j:function(s){var obj=null;dhx4.temp=null;try{eval("dhx4.temp="+s)}catch(t){dhx4.temp=null}return obj=dhx4.temp,dhx4.temp=null,obj},absLeft:function(t){return"string"==typeof t&&(t=document.getElementById(t)),this.getOffset(t).left},absTop:function(t){return"string"==typeof t&&(t=document.getElementById(t)),this.getOffset(t).top},_aOfs:function(t){for(var e=0,n=0;t;)e+=parseInt(t.offsetTop),n+=parseInt(t.offsetLeft),t=t.offsetParent;return{top:e,left:n}},_aOfsRect:function(t){var e=t.getBoundingClientRect(),n=document.body,i=document.documentElement,a=window.pageYOffset||i.scrollTop||n.scrollTop,o=window.pageXOffset||i.scrollLeft||n.scrollLeft,r=i.clientTop||n.clientTop||0,s=i.clientLeft||n.clientLeft||0,l=e.top+a-r,d=e.left+o-s;return{top:Math.round(l),left:Math.round(d)}},getOffset:function(t){return t.getBoundingClientRect?this._aOfsRect(t):this._aOfs(t)},_isObj:function(t){return null!=t&&"object"==typeof t&&void 0===t.length},_copyObj:function(t){if(this._isObj(t)){var e={};for(var n in t)"object"==typeof t[n]&&null!=t[n]?e[n]=this._copyObj(t[n]):e[n]=t[n]}else for(e=[],n=0;n<t.length;n++)"object"==typeof t[n]&&null!=t[n]?e[n]=this._copyObj(t[n]):e[n]=t[n];return e},screenDim:function(){var t=navigator.userAgent.indexOf("MSIE")>=0,e={};return e.left=document.body.scrollLeft,e.right=e.left+(window.innerWidth||document.body.clientWidth),e.top=Math.max((t?document.documentElement:document.getElementsByTagName("html")[0]).scrollTop,document.body.scrollTop),e.bottom=e.top+(t?Math.max(document.documentElement.clientHeight||0,document.documentElement.offsetHeight||0):window.innerHeight),e},selectTextRange:function(t,e,n){var i=(t="string"==typeof t?document.getElementById(t):t).value.length;if(e=Math.max(Math.min(e,i),0),n=Math.min(n,i),t.setSelectionRange)try{t.setSelectionRange(e,n)}catch(t){}else if(t.createTextRange){var a=t.createTextRange();a.moveStart("character",e),a.moveEnd("character",n-i);try{a.select()}catch(t){}}},transData:null,transDetect:function(){if(null==this.transData){this.transData={transProp:!1,transEv:null};var t={MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd",OTransition:"oTransitionEnd",msTransition:"transitionend",transition:"transitionend"};for(var e in t)0==this.transData.transProp&&null!=document.documentElement.style[e]&&(this.transData.transProp=e,this.transData.transEv=t[e]);t=null}return this.transData},_xmlNodeValue:function(t){for(var e="",n=0;n<t.childNodes.length;n++)e+=null!=t.childNodes[n].nodeValue?t.childNodes[n].nodeValue.toString().replace(/^[\n\r\s]{0,}/,"").replace(/[\n\r\s]{0,}$/,""):"";return e}},window.dhx4.isIE=navigator.userAgent.indexOf("MSIE")>=0||navigator.userAgent.indexOf("Trident")>=0,window.dhx4.isIE6=null==window.XMLHttpRequest&&navigator.userAgent.indexOf("MSIE")>=0,window.dhx4.isIE7=navigator.userAgent.indexOf("MSIE 7.0")>=0&&navigator.userAgent.indexOf("Trident")<0,window.dhx4.isIE8=navigator.userAgent.indexOf("MSIE 8.0")>=0&&navigator.userAgent.indexOf("Trident")>=0,window.dhx4.isIE9=navigator.userAgent.indexOf("MSIE 9.0")>=0&&navigator.userAgent.indexOf("Trident")>=0,window.dhx4.isIE10=navigator.userAgent.indexOf("MSIE 10.0")>=0&&navigator.userAgent.indexOf("Trident")>=0&&1!=window.navigator.pointerEnabled,window.dhx4.isIE11=navigator.userAgent.indexOf("Trident")>=0&&1==window.navigator.pointerEnabled,window.dhx4.isEdge=navigator.userAgent.indexOf("Edge")>=0,window.dhx4.isOpera=navigator.userAgent.indexOf("Opera")>=0,window.dhx4.isChrome=navigator.userAgent.indexOf("Chrome")>=0&&!window.dhx4.isEdge,window.dhx4.isKHTML=(navigator.userAgent.indexOf("Safari")>=0||navigator.userAgent.indexOf("Konqueror")>=0)&&!window.dhx4.isEdge,window.dhx4.isFF=navigator.userAgent.indexOf("Firefox")>=0,window.dhx4.isIPad=navigator.userAgent.search(/iPad/gi)>=0,window.dhx4.dnd={evs:{},p_en:(window.dhx4.isIE||window.dhx4.isEdge)&&(window.navigator.pointerEnabled||window.navigator.msPointerEnabled),_mTouch:function(t){return window.dhx4.isIE10&&t.pointerType==t.MSPOINTER_TYPE_MOUSE||window.dhx4.isIE11&&"mouse"==t.pointerType||window.dhx4.isEdge&&"mouse"==t.pointerType},_touchOn:function(t){null==t&&(t=document.body),t.style.touchAction=t.style.msTouchAction="",t=null},_touchOff:function(t){null==t&&(t=document.body),t.style.touchAction=t.style.msTouchAction="none",t=null}},1==window.navigator.pointerEnabled?window.dhx4.dnd.evs={start:"pointerdown",move:"pointermove",end:"pointerup"}:1==window.navigator.msPointerEnabled?window.dhx4.dnd.evs={start:"MSPointerDown",move:"MSPointerMove",end:"MSPointerUp"}:void 0!==window.addEventListener&&(window.dhx4.dnd.evs={start:"touchstart",move:"touchmove",end:"touchend"})),void 0===window.dhx4.template&&(window.dhx4.trim=function(t){return String(t).replace(/^\s{1,}/,"").replace(/\s{1,}$/,"")},window.dhx4.template=function(t,e,n){return t.replace(/#([a-z0-9_-]{1,})(\|([^#]*))?#/gi,function(){var t=arguments[1],i=window.dhx4.trim(arguments[3]),a=null,o=[e[t]];if(i.length>0){i=i.split(":");for(var r=[],s=0;s<i.length;s++)s>0&&null!=r[r.length-1].match(/\\$/)?r[r.length-1]=r[r.length-1].replace(/\\$/,"")+":"+i[s]:r.push(i[s]);a=r[0];for(s=1;s<r.length;s++)o.push(r[s])}return"string"==typeof a&&"function"==typeof window.dhx4.template[a]?window.dhx4.template[a].apply(window.dhx4.template,o):t.length>0&&void 0!==e[t]?1==n?window.dhx4.trim(e[t]):String(e[t]):""})},window.dhx4.template.date=function(t,e){return null!=t?t instanceof Date?window.dhx4.date2str(t,e):null!=(t=t.toString()).match(/^\d*$/)?window.dhx4.date2str(new Date(parseInt(t)),e):t:""},window.dhx4.template.maxlength=function(t,e){return String(t).substr(0,e)},window.dhx4.template.number_format=function(t,e,n,i){var a=window.dhx4.template._parseFmt(e,n,i);return 0==a?t:window.dhx4.template._getFmtValue(t,a)},window.dhx4.template.lowercase=function(t){return void 0!==t&&null!=t||(t=""),String(t).toLowerCase()},window.dhx4.template.uppercase=function(t){return void 0!==t&&null!=t||(t=""),String(t).toUpperCase()},window.dhx4.template._parseFmt=function(t,e,n){var i=t.match(/^([^\.\,0-9]*)([0\.\,]*)([^\.\,0-9]*)/);if(null==i||4!=i.length)return!1;var a={i_len:!1,i_sep:"string"==typeof e?e:",",d_len:!1,d_sep:"string"==typeof n?n:".",s_bef:"string"==typeof i[1]?i[1]:"",s_aft:"string"==typeof i[3]?i[3]:""},o=i[2].split(".");null!=o[1]&&(a.d_len=o[1].length);var r=o[0].split(",");return r.length>1&&(a.i_len=r[r.length-1].length),a},window.dhx4.template._getFmtValue=function(value,fmt){var r=String(value).match(/^(-)?([0-9]{1,})(\.([0-9]{1,}))?$/);if(null!=r&&5==r.length){var v0="";if(null!=r[1]&&(v0+=r[1]),v0+=fmt.s_bef,!1!==fmt.i_len){for(var i=0,v1="",q=r[2].length-1;q>=0;q--)v1=""+r[2].charAt(q)+v1,++i==fmt.i_len&&q>0&&(v1=fmt.i_sep+v1,i=0);v0+=v1}else v0+=r[2];if(!1!==fmt.d_len){for(null==r[4]&&(r[4]="");r[4].length<fmt.d_len;)r[4]+="0";eval("dhx4.temp = new RegExp(/\\d{"+fmt.d_len+"}/);");var t1=r[4].match(dhx4.temp);null!=t1&&(v0+=fmt.d_sep+t1),dhx4.temp=t1=null}return v0+=fmt.s_aft,v0}return value}),void 0===window.dhx4.dateLang&&(window.dhx4.dateLang="en",window.dhx4.dateStrings={en:{monthFullName:["January","February","March","April","May","June","July","August","September","October","November","December"],monthShortName:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayFullName:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayShortName:["Su","Mo","Tu","We","Th","Fr","Sa"]}},window.dhx4.dateFormat={en:"%Y-%m-%d"},window.dhx4.date2str=function(t,e,n){if(null!=e&&void 0!==e||(e=window.dhx4.dateFormat[window.dhx4.dateLang]),null!=n&&void 0!==n||(n=window.dhx4.dateStrings[window.dhx4.dateLang]),t instanceof Date)var i=function(t){return 1==String(t).length?"0"+String(t):t},a=String(e||window.dhx4.dateFormat).replace(/%[a-zA-Z]/g,function(e){switch(e){case"%d":return i(t.getDate());case"%j":return t.getDate();case"%D":return n.dayShortName[t.getDay()];case"%l":return n.dayFullName[t.getDay()];case"%m":return i(t.getMonth()+1);case"%n":return t.getMonth()+1;case"%M":return n.monthShortName[t.getMonth()];case"%F":return n.monthFullName[t.getMonth()];case"%y":return i(t.getYear()%100);case"%Y":return t.getFullYear();case"%g":return(t.getHours()+11)%12+1;case"%h":return i((t.getHours()+11)%12+1);case"%G":return t.getHours();case"%H":return i(t.getHours());case"%i":return i(t.getMinutes());case"%s":return i(t.getSeconds());case"%a":return t.getHours()>11?"pm":"am";case"%A":return t.getHours()>11?"PM":"AM";case"%%":return"%";case"%u":return t.getMilliseconds();case"%P":if(null!=window.dhx4.temp_calendar&&null!=window.dhx4.temp_calendar.tz)return window.dhx4.temp_calendar.tz;var a=t.getTimezoneOffset(),o=Math.abs(Math.floor(a/60)),r=Math.abs(a)-60*o;return(a>0?"-":"+")+i(o)+":"+i(r);default:return e}});return a||String(t)},window.dhx4.str2date=function(t,e,n){null!=e&&void 0!==e||(e=window.dhx4.dateFormat[window.dhx4.dateLang]),null!=n&&void 0!==n||(n=window.dhx4.dateStrings[window.dhx4.dateLang]);var i=[],a=[];e=(e=e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\\:|]/g,"\\$&")).replace(/%[a-z]/gi,function(t){switch(t){case"%d":case"%m":case"%y":case"%h":case"%H":case"%i":case"%s":return a.push(t),"(\\d{2})";case"%D":case"%l":case"%M":case"%F":return a.push(t),"([a-zéûäа-яё]{1,})";case"%j":case"%n":case"%g":case"%G":return a.push(t),"(\\d{1,2})";case"%Y":return a.push(t),"(\\d{4})";case"%a":return a.push(t),"([a|p]m)";case"%A":return a.push(t),"([A|P]M)";case"%u":return a.push(t),"(\\d{1,6})";case"%P":return a.push(t),"([+-]\\d{1,2}:\\d{1,2})"}return t});var o=new RegExp(e,"i"),r=t.match(o);if(null==r||r.length-1!=a.length)return"Invalid Date";for(var s=1;s<r.length;s++)i.push(r[s]);var l={"%y":1,"%Y":1,"%n":2,"%m":2,"%M":2,"%F":2,"%d":3,"%j":3,"%a":4,"%A":4,"%H":5,"%G":5,"%h":5,"%g":5,"%i":6,"%s":7,"%u":7,"%P":7},d={},c={};for(s=0;s<a.length;s++)if(void 0!==l[a[s]]){var h=l[a[s]];d[h]||(d[h]=[],c[h]=[]),d[h].push(i[s]),c[h].push(a[s])}i=[],a=[];for(s=1;s<=7;s++)if(null!=d[s])for(var u=0;u<d[s].length;u++)i.push(d[s][u]),a.push(c[s][u]);var m=new Date;m.setDate(1),m.setHours(0),m.setMinutes(0),m.setSeconds(0),m.setMilliseconds(0);var f=function(t,e){for(var n=0;n<e.length;n++)if(e[n].toLowerCase()==t)return n;return-1};for(s=0;s<i.length;s++)switch(a[s]){case"%d":case"%j":case"%n":case"%m":case"%Y":case"%H":case"%G":case"%i":case"%s":case"%u":isNaN(i[s])||m[{"%d":"setDate","%j":"setDate","%n":"setMonth","%m":"setMonth","%Y":"setFullYear","%H":"setHours","%G":"setHours","%i":"setMinutes","%s":"setSeconds","%u":"setMilliseconds"}[a[s]]](Number(i[s])+("%m"==a[s]||"%n"==a[s]?-1:0));break;case"%M":case"%F":var p=f(i[s].toLowerCase(),n[{"%M":"monthShortName","%F":"monthFullName"}[a[s]]]);p>=0&&m.setMonth(p);break;case"%y":if(!isNaN(i[s])){var _=Number(i[s]);m.setFullYear(_+(_>50?1900:2e3))}break;case"%g":case"%h":if(!isNaN(i[s]))(_=Number(i[s]))<=12&&_>=0&&m.setHours(_+(f("pm",i)>=0?12==_?0:12:12==_?-12:0));break;case"%P":null!=window.dhx4.temp_calendar&&(window.dhx4.temp_calendar.tz=i[s])}return m}),void 0===window.dhx4.ajax&&(window.dhx4.ajax={cache:!1,method:"get",parse:function(t){if("string"!=typeof t)return t;if(t=t.replace(/^[\s]+/,""),window.DOMParser&&!dhx4.isIE)var e=(new window.DOMParser).parseFromString(t,"text/xml");else if(window.ActiveXObject!==window.undefined){(e=new window.ActiveXObject("Microsoft.XMLDOM")).async="false",e.loadXML(t)}return e},xmltop:function(t,e,n){if((void 0===e.status||e.status<400)&&(xml=e.responseXML?e.responseXML||e:dhx4.ajax.parse(e.responseText||e),xml&&null!==xml.documentElement))try{if(!xml.getElementsByTagName("parsererror").length)return xml.getElementsByTagName(t)[0]}catch(t){}return-1!==n&&dhx4.callEvent("onLoadXMLError",["Incorrect XML",arguments[1],n]),document.createElement("DIV")},xpath:function(t,e){if(e.nodeName||(e=e.responseXML||e),!dhx4.isIE){for(var n,i=[],a=(e.ownerDocument||e).evaluate(t,e,null,XPathResult.ANY_TYPE,null);n=a.iterateNext();)i.push(n);return i}try{return e.selectNodes(t)||[]}catch(t){return[]}},query:function(t){return dhx4.ajax._call(t.method||"GET",t.url,t.data||"",t.async||!0,t.callback,null,t.headers)},get:function(t,e){return this._call("GET",t,null,!0,e)},getSync:function(t){return this._call("GET",t,null,!1)},put:function(t,e,n){return this._call("PUT",t,e,!0,n)},del:function(t,e,n){return this._call("DELETE",t,e,!0,n)},post:function(t,e,n){return 1==arguments.length?e="":2!=arguments.length||"function"!=typeof e&&"function"!=typeof window[e]?e=String(e):(n=e,e=""),this._call("POST",t,e,!0,n)},postSync:function(t,e){return e=null==e?"":String(e),this._call("POST",t,e,!1)},getLong:function(t,e){this._call("GET",t,null,!0,e,{url:t})},postLong:function(t,e,n){2!=arguments.length||"function"!=typeof e&&(window[e],0)||(n=e,e=""),this._call("POST",t,e,!0,n,{url:t,postData:e})},_call:function(t,e,n,i,a,o,r){if("object"==typeof n){var s=[];for(var l in n)s.push(l+"="+encodeURIComponent(n[l]));n=s.join("&")}var d=dhx.promise.defer(),c=window.XMLHttpRequest&&!dhx4.isIE?new XMLHttpRequest:new ActiveXObject("Microsoft.XMLHTTP"),h=null!=navigator.userAgent.match(/AppleWebKit/)&&null!=navigator.userAgent.match(/Qt/)&&null!=navigator.userAgent.match(/Safari/);if(1==i&&(c.onreadystatechange=function(){if(4==c.readyState||1==h&&3==c.readyState){if((200!=c.status||""==c.responseText)&&(d.reject(c),!dhx4.callEvent("onAjaxError",[{xmlDoc:c,filePath:e,async:i}])))return;window.setTimeout(function(){if("function"==typeof a){try{a.apply(window,[{xmlDoc:c,filePath:e,async:i}])}catch(t){d.reject(t)}d.resolve(c.responseText)}null!=o&&(void 0!==o.postData?dhx4.ajax.postLong(o.url,o.postData,a):dhx4.ajax.getLong(o.url,a)),a=null,c=null},1)}}),"GET"==t&&(e+=this._dhxr(e)),c.open(t,e,i),null!=r)for(var u in r)c.setRequestHeader(u,r[u]);else"POST"==t||"PUT"==t||"DELETE"==t?c.setRequestHeader("Content-Type","application/x-www-form-urlencoded"):"GET"==t&&(n=null);return c.setRequestHeader("X-Requested-With","XMLHttpRequest"),c.send(n),1!=i&&(4==c.readyState||1==h&&3==c.readyState)&&(200==c.status&&""!=c.responseText||dhx4.callEvent("onAjaxError",[{xmlDoc:c,filePath:e,async:i}])),d.xmlDoc=c,d.filePath=e,d.async=i,d},_dhxr:function(t,e){return 1!=this.cache?(null==t.match(/^[\?\&]$/)&&(t=t.indexOf("?")>=0?"&":"?"),void 0===e&&(e=!0),t+"dhxr"+(new Date).getTime()+(1==e?"=1":"")):""}}),void 0===window.dhx4._enableDataLoading&&(window.dhx4._enableDataLoading=function(t,e,n,i,a){if("clear"==a){for(var o in t._dhxdataload)t._dhxdataload[o]=null,delete t._dhxdataload[o];return t._loadData=null,t._dhxdataload=null,t.load=null,t.loadStruct=null,void(t=null)}if(t._dhxdataload={initObj:e,xmlToJson:n,xmlRootTag:i,onBeforeXLS:null},t._loadData=function(t,e,n){2==arguments.length&&(n=e,e=null);var i=null;if(3==arguments.length&&(n=arguments[2]),this.callEvent("onXLS",[]),"string"==typeof t){var a=t.replace(/^\s{1,}/,"").replace(/\s{1,}$/,"");if(new RegExp("^<"+this._dhxdataload.xmlRootTag).test(a.replace(/^<\?xml[^\?]*\?>\s*/,""))&&null!=(i=dhx4.ajax.parse(t))&&(i=this[this._dhxdataload.xmlToJson].apply(this,[i])),null!=i||null==a.match(/^[\s\S]*{[.\s\S]*}[\s\S]*$/)&&null==a.match(/^[\s\S]*\[[.\s\S]*\][\s\S]*$/)||(i=dhx4.s2j(a)),null==i){var o=[];if("function"==typeof this._dhxdataload.onBeforeXLS)if(null!=(a=this._dhxdataload.onBeforeXLS.apply(this,[t]))&&"object"==typeof a&&(null!=a.url&&(t=a.url),null!=a.params))for(var r in a.params)o.push(r+"="+encodeURIComponent(a.params[r]));var s=this,l=function(e){var i=null;null!=(i=(e.xmlDoc.getResponseHeader("Content-Type")||"").search(/xml/gi)>=0||null!=e.xmlDoc.responseText.replace(/^\s{1,}/,"").match(/^</)?s[s._dhxdataload.xmlToJson].apply(s,[e.xmlDoc.responseXML]):dhx4.s2j(e.xmlDoc.responseText))&&s[s._dhxdataload.initObj].apply(s,[i,t]),s.callEvent("onXLE",[]),null!=n&&("function"==typeof n?n.apply(s,[]):"function"==typeof window[n]&&window[n].apply(s,[])),l=n=null,i=e=s=null};return o=o.join("&")+("string"==typeof e?"&"+e:""),"post"==dhx4.ajax.method?dhx4.ajax.post(t,o,l):"get"==dhx4.ajax.method?dhx4.ajax.get(t+(o.length>0?(t.indexOf("?")>0?"&":"?")+o:""),l):void 0}}else i="object"==typeof t.documentElement||void 0!==t.tagName&&void 0!==t.getElementsByTagName&&t.getElementsByTagName(this._dhxdataload.xmlRootTag).length>0?this[this._dhxdataload.xmlToJson].apply(this,[t]):window.dhx4._copyObj(t);null!=i&&this[this._dhxdataload.initObj].apply(this,[i]),this.callEvent("onXLE",[]),null!=n&&("function"==typeof n?n.apply(this,[]):"function"==typeof window[n]&&window[n].apply(this,[]),n=null)},null!=a){var r={struct:"loadStruct",data:"load"};for(var o in a)1==a[o]&&(t[r[o]]=function(){return this._loadData.apply(this,arguments)})}t=null}),void 0===window.dhx4._eventable&&(window.dhx4._eventable=function(t,e){if("clear"==e)return t.detachAllEvents(),t.dhxevs=null,t.attachEvent=null,t.detachEvent=null,t.checkEvent=null,t.callEvent=null,t.detachAllEvents=null,void(t=null);t.dhxevs={data:{}},t.attachEvent=function(t,e){t=String(t).toLowerCase(),this.dhxevs.data[t]||(this.dhxevs.data[t]={});var n=window.dhx4.newId();return this.dhxevs.data[t][n]=e,n},t.detachEvent=function(t){for(var e in this.dhxevs.data){var n=0;for(var i in this.dhxevs.data[e])i==t?(this.dhxevs.data[e][i]=null,delete this.dhxevs.data[e][i]):n++;0==n&&(this.dhxevs.data[e]=null,delete this.dhxevs.data[e])}},t.checkEvent=function(t){return t=String(t).toLowerCase(),null!=this.dhxevs.data[t]},t.callEvent=function(t,e){if(t=String(t).toLowerCase(),null==this.dhxevs.data[t])return!0;var n=!0;for(var i in this.dhxevs.data[t])n=this.dhxevs.data[t][i].apply(this,e)&&n;return n},t.detachAllEvents=function(){for(var t in this.dhxevs.data){for(var e in this.dhxevs.data[t])this.dhxevs.data[t][e]=null,delete this.dhxevs.data[t][e];this.dhxevs.data[t]=null,delete this.dhxevs.data[t]}},t=null},dhx4._eventable(dhx4)),window.dhtmlxValidation||(dhtmlxValidation=function(){},dhtmlxValidation.prototype={isEmpty:function(t){return""==t},isNotEmpty:function(t){return t instanceof Array?t.length>0:""==!t},isValidBoolean:function(t){return!!t.toString().match(/^(0|1|true|false)$/)},isValidEmail:function(t){return!!t.toString().match(/(^[a-z0-9]([0-9a-z\-_\.]*)@([0-9a-z_\-\.]*)([.][a-z]{3})$)|(^[a-z]([0-9a-z_\.\-]*)@([0-9a-z_\-\.]*)(\.[a-z]{2,5})$)/i)},isValidInteger:function(t){return!!t.toString().match(/(^-?\d+$)/)},isValidNumeric:function(t){return!!t.toString().match(/(^-?\d\d*[\.|,]\d*$)|(^-?\d\d*$)|(^-?[\.|,]\d\d*$)/)},isValidAplhaNumeric:function(t){return!!t.toString().match(/^[_\-a-z0-9]+$/gi)},isValidDatetime:function(t){var e=t.toString().match(/^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/);return e&&!!(e[1]<=9999&&e[2]<=12&&e[3]<=31&&e[4]<=59&&e[5]<=59&&e[6]<=59)||!1},isValidDate:function(t){var e=t.toString().match(/^(\d{4})-(\d{2})-(\d{2})$/);return e&&!!(e[1]<=9999&&e[2]<=12&&e[3]<=31)||!1},isValidTime:function(t){var e=t.toString().match(/^(\d{1,2}):(\d{1,2}):(\d{1,2})$/);return e&&!!(e[1]<=24&&e[2]<=59&&e[3]<=59)||!1},isValidIPv4:function(t){var e=t.toString().match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);return e&&!!(e[1]<=255&&e[2]<=255&&e[3]<=255&&e[4]<=255)||!1},isValidCurrency:function(t){return!!t.toString().match(/^\$?\s?\d+?([\.,\,]?\d+)?\s?\$?$/)},isValidSSN:function(t){return!!t.toString().match(/^\d{3}\-?\d{2}\-?\d{4}$/)},isValidSIN:function(t){return!!t.toString().match(/^\d{9}$/)}},dhtmlxValidation=new dhtmlxValidation),void 0===window.dhtmlx&&(window.dhtmlx={extend:function(t,e){for(var n in e)t[n]||(t[n]=e[n]);return t},extend_api:function(t,e,n){var i=window[t];i&&(window[t]=function(t){if(t&&"object"==typeof t&&!t.tagName){var n=i.apply(this,e._init?e._init(t):arguments);for(var a in dhtmlx)e[a]&&this[e[a]](dhtmlx[a]);for(var a in t)e[a]?this[e[a]](t[a]):0===a.indexOf("on")&&this.attachEvent(a,t[a])}else n=i.apply(this,arguments);return e._patch&&e._patch(this),n||this},window[t].prototype=i.prototype,n&&dhtmlx.extend(window[t].prototype,n))},url:function(t){return-1!=t.indexOf("?")?"&":"?"}}),dhtmlDragAndDropObject.prototype.removeDraggableItem=function(t){t.onmousedown=null,t.dragStarter=null,t.dragLanding=null},dhtmlDragAndDropObject.prototype.addDraggableItem=function(t,e){t.onmousedown=this.preCreateDragCopy,t.dragStarter=e,this.addDragLanding(t,e)},dhtmlDragAndDropObject.prototype.addDragLanding=function(t,e){t.dragLanding=e},dhtmlDragAndDropObject.prototype.preCreateDragCopy=function(t){if(!t&&!window.event||2!=(t||event).button)return window.dhtmlDragAndDrop.waitDrag?(window.dhtmlDragAndDrop.waitDrag=0,document.body.onmouseup=window.dhtmlDragAndDrop.tempDOMU,document.body.onmousemove=window.dhtmlDragAndDrop.tempDOMM,!1):(window.dhtmlDragAndDrop.dragNode&&window.dhtmlDragAndDrop.stopDrag(t),window.dhtmlDragAndDrop.waitDrag=1,window.dhtmlDragAndDrop.tempDOMU=document.body.onmouseup,window.dhtmlDragAndDrop.tempDOMM=document.body.onmousemove,window.dhtmlDragAndDrop.dragStartNode=this,window.dhtmlDragAndDrop.dragStartObject=this.dragStarter,document.body.onmouseup=window.dhtmlDragAndDrop.preCreateDragCopy,document.body.onmousemove=window.dhtmlDragAndDrop.callDrag,window.dhtmlDragAndDrop.downtime=(new Date).valueOf(),!(!t||!t.preventDefault)&&(t.preventDefault(),!1))},dhtmlDragAndDropObject.prototype.callDrag=function(t){if(t||(t=window.event),dragger=window.dhtmlDragAndDrop,!((new Date).valueOf()-dragger.downtime<100)){if(!dragger.dragNode){if(!dragger.waitDrag)return dragger.stopDrag(t,!0);if(dragger.dragNode=dragger.dragStartObject._createDragNode(dragger.dragStartNode,t),!dragger.dragNode)return dragger.stopDrag();dragger.dragNode.onselectstart=function(){return!1},dragger.gldragNode=dragger.dragNode,document.body.appendChild(dragger.dragNode),document.body.onmouseup=dragger.stopDrag,dragger.waitDrag=0,dragger.dragNode.pWindow=window,dragger.initFrameRoute()}if(dragger.dragNode.parentNode!=window.document.body&&dragger.gldragNode){var e=dragger.gldragNode;dragger.gldragNode.old&&(e=dragger.gldragNode.old),e.parentNode.removeChild(e);var n=dragger.dragNode.pWindow;if(e.pWindow&&e.pWindow.dhtmlDragAndDrop.lastLanding&&e.pWindow.dhtmlDragAndDrop.lastLanding.dragLanding._dragOut(e.pWindow.dhtmlDragAndDrop.lastLanding),_isIE){var i=document.createElement("Div");i.innerHTML=dragger.dragNode.outerHTML,dragger.dragNode=i.childNodes[0]}else dragger.dragNode=dragger.dragNode.cloneNode(!0);dragger.dragNode.pWindow=window,dragger.gldragNode.old=dragger.dragNode,document.body.appendChild(dragger.dragNode),n.dhtmlDragAndDrop.dragNode=dragger.dragNode}if(dragger.dragNode.style.left=t.clientX+15+(dragger.fx?-1*dragger.fx:0)+(document.body.scrollLeft||document.documentElement.scrollLeft)+"px",dragger.dragNode.style.top=t.clientY+3+(dragger.fy?-1*dragger.fy:0)+(document.body.scrollTop||document.documentElement.scrollTop)+"px",t.srcElement)a=t.srcElement;else var a=t.target;dragger.checkLanding(a,t)}},dhtmlDragAndDropObject.prototype.calculateFramePosition=function(t){if(window.name){for(var e=parent.frames[window.name].frameElement.offsetParent,n=0,i=0;e;)n+=e.offsetLeft,i+=e.offsetTop,e=e.offsetParent;if(parent.dhtmlDragAndDrop){var a=parent.dhtmlDragAndDrop.calculateFramePosition(1);n+=1*a.split("_")[0],i+=1*a.split("_")[1]}if(t)return n+"_"+i;this.fx=n,this.fy=i}return"0_0"},dhtmlDragAndDropObject.prototype.checkLanding=function(t,e){t&&t.dragLanding?(this.lastLanding&&this.lastLanding.dragLanding._dragOut(this.lastLanding),this.lastLanding=t,this.lastLanding=this.lastLanding.dragLanding._dragIn(this.lastLanding,this.dragStartNode,e.clientX,e.clientY,e),this.lastLanding_scr=_isIE?e.srcElement:e.target):t&&"BODY"!=t.tagName?this.checkLanding(t.parentNode,e):(this.lastLanding&&this.lastLanding.dragLanding._dragOut(this.lastLanding,e.clientX,e.clientY,e),this.lastLanding=0,this._onNotFound&&this._onNotFound())},dhtmlDragAndDropObject.prototype.stopDrag=function(t,e){if(dragger=window.dhtmlDragAndDrop,!e){dragger.stopFrameRoute();var n=dragger.lastLanding;dragger.lastLanding=null,n&&n.dragLanding._drag(dragger.dragStartNode,dragger.dragStartObject,n,_isIE?event.srcElement:t.target)}dragger.lastLanding=null,dragger.dragNode&&dragger.dragNode.parentNode==document.body&&dragger.dragNode.parentNode.removeChild(dragger.dragNode),dragger.dragNode=0,dragger.gldragNode=0,dragger.fx=0,dragger.fy=0,dragger.dragStartNode=0,dragger.dragStartObject=0,document.body.onmouseup=dragger.tempDOMU,document.body.onmousemove=dragger.tempDOMM,dragger.tempDOMU=null,dragger.tempDOMM=null,dragger.waitDrag=0},dhtmlDragAndDropObject.prototype.stopFrameRoute=function(t){t&&window.dhtmlDragAndDrop.stopDrag(1,1);for(var e=0;e<window.frames.length;e++)try{window.frames[e]!=t&&window.frames[e].dhtmlDragAndDrop&&window.frames[e].dhtmlDragAndDrop.stopFrameRoute(window)}catch(t){}try{parent.dhtmlDragAndDrop&&parent!=window&&parent!=t&&parent.dhtmlDragAndDrop.stopFrameRoute(window)}catch(t){}},dhtmlDragAndDropObject.prototype.initFrameRoute=function(t,e){t&&(window.dhtmlDragAndDrop.preCreateDragCopy(),window.dhtmlDragAndDrop.dragStartNode=t.dhtmlDragAndDrop.dragStartNode,window.dhtmlDragAndDrop.dragStartObject=t.dhtmlDragAndDrop.dragStartObject,window.dhtmlDragAndDrop.dragNode=t.dhtmlDragAndDrop.dragNode,window.dhtmlDragAndDrop.gldragNode=t.dhtmlDragAndDrop.dragNode,window.document.body.onmouseup=window.dhtmlDragAndDrop.stopDrag,window.waitDrag=0,!_isIE&&e&&(!_isFF||_FFrv<1.8)&&window.dhtmlDragAndDrop.calculateFramePosition());try{parent.dhtmlDragAndDrop&&parent!=window&&parent!=t&&parent.dhtmlDragAndDrop.initFrameRoute(window)}catch(t){}for(var n=0;n<window.frames.length;n++)try{window.frames[n]!=t&&window.frames[n].dhtmlDragAndDrop&&window.frames[n].dhtmlDragAndDrop.initFrameRoute(window,!t||e?1:0)}catch(t){}},_isFF=!1,_isIE=!1,_isOpera=!1,_isKHTML=!1,_isMacOS=!1,_isChrome=!1,_FFrv=!1,_KHTMLrv=!1,_OperaRv=!1,-1!=navigator.userAgent.indexOf("Macintosh")&&(_isMacOS=!0),navigator.userAgent.toLowerCase().indexOf("chrome")>-1&&(_isChrome=!0),-1!=navigator.userAgent.indexOf("Safari")||-1!=navigator.userAgent.indexOf("Konqueror")?(_KHTMLrv=parseFloat(navigator.userAgent.substr(navigator.userAgent.indexOf("Safari")+7,5)),_KHTMLrv>525?(_isFF=!0,_FFrv=1.9):_isKHTML=!0):-1!=navigator.userAgent.indexOf("Opera")?(_isOpera=!0,_OperaRv=parseFloat(navigator.userAgent.substr(navigator.userAgent.indexOf("Opera")+6,3))):-1!=navigator.appName.indexOf("Microsoft")?(_isIE=!0,(-1!=navigator.appVersion.indexOf("MSIE 8.0")||-1!=navigator.appVersion.indexOf("MSIE 9.0")||-1!=navigator.appVersion.indexOf("MSIE 10.0")||document.documentMode>7)&&"BackCompat"!=document.compatMode&&(_isIE=8)):"Netscape"==navigator.appName&&-1!=navigator.userAgent.indexOf("Trident")?_isIE=8:(_isFF=!0,_FFrv=parseFloat(navigator.userAgent.split("rv:")[1])),void 0===window.dhtmlxEvent)function dhtmlxEvent(t,e,n){t.addEventListener?t.addEventListener(e,n,!1):t.attachEvent&&t.attachEvent("on"+e,n)}null==dhtmlxEvent.touchDelay&&(dhtmlxEvent.touchDelay=2e3),void 0===dhtmlxEvent.initTouch&&(dhtmlxEvent.initTouch=function(){var t,e,n,i;function a(){if(e){var n=document.createEvent("HTMLEvents");n.initEvent("dblclick",!0,!0),e.dispatchEvent(n),t=e=null}}dhtmlxEvent(document.body,"touchstart",function(o){e=o.touches[0].target,n=o.touches[0].clientX,i=o.touches[0].clientY,t=window.setTimeout(a,dhtmlxEvent.touchDelay)}),dhtmlxEvent(document.body,"touchmove",function(a){t&&(Math.abs(a.touches[0].clientX-n)>50||Math.abs(a.touches[0].clientY-i)>50)&&(window.clearTimeout(t),t=e=!1)}),dhtmlxEvent(document.body,"touchend",function(n){t&&(window.clearTimeout(t),t=e=!1)}),dhtmlxEvent.initTouch=function(){}}),function(t){var e="undefined"!=typeof setImmediate?setImmediate:function(t){setTimeout(t,0)};function n(t,e){this.promise=this,this.state="pending",this.val=null,this.fn=t||null,this.er=e||null,this.next=[]}n.prototype.resolve=function(t){var n=this;"pending"===n.state&&(n.val=t,n.state="resolving",e(function(){n.fire()}))},n.prototype.reject=function(t){var n=this;"pending"===n.state&&(n.val=t,n.state="rejecting",e(function(){n.fire()}))},n.prototype.then=function(t,e){var i=new n(t,e);return this.next.push(i),"resolved"===this.state&&i.resolve(this.val),"rejected"===this.state&&i.reject(this.val),i},n.prototype.fail=function(t){return this.then(null,t)},n.prototype.finish=function(t){if(this.state=t,"resolved"===this.state)for(var e=0;e<this.next.length;e++)this.next[e].resolve(this.val);if("rejected"===this.state){for(e=0;e<this.next.length;e++)this.next[e].reject(this.val);if(!this.next.length)throw this.val}},n.prototype.thennable=function(t,e,n,i,a){if("object"==typeof(a=a||this.val)&&"function"==typeof t)try{var o=0;t.call(a,function(t){0==o++&&e(t)},function(t){0==o++&&n(t)})}catch(t){n(t)}else i(a)},n.prototype.fire=function(){var t,e=this;try{t=e.val&&e.val.then}catch(t){return e.val=t,e.state="rejecting",e.fire()}e.thennable(t,function(t){e.val=t,e.state="resolving",e.fire()},function(t){e.val=t,e.state="rejecting",e.fire()},function(n){if(e.val=n,"resolving"===e.state&&"function"==typeof e.fn)try{e.val=e.fn.call(void 0,e.val)}catch(t){return e.val=t,e.finish("rejected")}if("rejecting"===e.state&&"function"==typeof e.er)try{e.val=e.er.call(void 0,e.val),e.state="resolving"}catch(t){return e.val=t,e.finish("rejected")}if(e.val===e)return e.val=TypeError(),e.finish("rejected");e.thennable(t,function(t){e.val=t,e.finish("resolved")},function(t){e.val=t,e.finish("rejected")},function(t){e.val=t,"resolving"===e.state?e.finish("resolved"):e.finish("rejected")})})},n.prototype.done=function(){if(this.state=!this.next)throw this.val;return null},n.prototype.nodeify=function(t){return"function"==typeof t?this.then(function(e){try{t(null,e)}catch(t){setImmediate(function(){throw t})}return e},function(e){try{t(e)}catch(t){setImmediate(function(){throw t})}return e}):this},n.prototype.spread=function(t,e){return this.all().then(function(e){return"function"==typeof t&&t.apply(null,e)},e)},n.prototype.all=function(){var t=this;return this.then(function(e){var i=new n;if(!(e instanceof Array))return i.reject(TypeError),i;var a=0,o=e.length;function r(){++a===o&&i.resolve(e)}for(var s=0,l=e.length;s<l;s++){var d,c=e[s];try{d=c&&c.then}catch(t){i.reject(t);break}!function(n){t.thennable(d,function(t){e[n]=t,r()},function(t){i.reject(t)},function(){r()},c)}(s)}return i})};var i={all:function(t){var e=new n(null,null);return e.resolve(t),e.all()},defer:function(){return new n(null,null)},fcall:function(){var t=new n,e=Array.apply([],arguments),i=e.shift();try{var a=i.apply(null,e);t.resolve(a)}catch(e){t.reject(e)}return t},nfcall:function(){var t=new n,e=Array.apply([],arguments),i=e.shift();try{e.push(function(e,n){return e?t.reject(e):t.resolve(n)}),i.apply(null,e)}catch(e){t.reject(e)}return t}};t.promise=i}(dhx)},ulq9:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n){var i,a;return"m"===n?e?"минута":"минуту":t+" "+(i=+t,a={ss:e?"секунда_секунды_секунд":"секунду_секунды_секунд",mm:e?"минута_минуты_минут":"минуту_минуты_минут",hh:"час_часа_часов",dd:"день_дня_дней",ww:"неделя_недели_недель",MM:"месяц_месяца_месяцев",yy:"год_года_лет"}[n].split("_"),i%10==1&&i%100!=11?a[0]:i%10>=2&&i%10<=4&&(i%100<10||i%100>=20)?a[1]:a[2])}var n=[/^янв/i,/^фев/i,/^мар/i,/^апр/i,/^ма[йя]/i,/^июн/i,/^июл/i,/^авг/i,/^сен/i,/^окт/i,/^ноя/i,/^дек/i];t.defineLocale("ru",{months:{format:"января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_"),standalone:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_")},monthsShort:{format:"янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split("_"),standalone:"янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split("_")},weekdays:{standalone:"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),format:"воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_"),isFormat:/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/},weekdaysShort:"вс_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"вс_пн_вт_ср_чт_пт_сб".split("_"),monthsParse:n,longMonthsParse:n,shortMonthsParse:n,monthsRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsShortRegex:/^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,monthsStrictRegex:/^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,monthsShortStrictRegex:/^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., H:mm",LLLL:"dddd, D MMMM YYYY г., H:mm"},calendar:{sameDay:"[Сегодня, в] LT",nextDay:"[Завтра, в] LT",lastDay:"[Вчера, в] LT",nextWeek:function(t){if(t.week()===this.week())return 2===this.day()?"[Во] dddd, [в] LT":"[В] dddd, [в] LT";switch(this.day()){case 0:return"[В следующее] dddd, [в] LT";case 1:case 2:case 4:return"[В следующий] dddd, [в] LT";case 3:case 5:case 6:return"[В следующую] dddd, [в] LT"}},lastWeek:function(t){if(t.week()===this.week())return 2===this.day()?"[Во] dddd, [в] LT":"[В] dddd, [в] LT";switch(this.day()){case 0:return"[В прошлое] dddd, [в] LT";case 1:case 2:case 4:return"[В прошлый] dddd, [в] LT";case 3:case 5:case 6:return"[В прошлую] dddd, [в] LT"}},sameElse:"L"},relativeTime:{future:"через %s",past:"%s назад",s:"несколько секунд",ss:e,m:e,mm:e,h:"час",hh:e,d:"день",dd:e,w:"неделя",ww:e,M:"месяц",MM:e,y:"год",yy:e},meridiemParse:/ночи|утра|дня|вечера/i,isPM:function(t){return/^(дня|вечера)$/.test(t)},meridiem:function(t,e,n){return t<4?"ночи":t<12?"утра":t<17?"дня":"вечера"},dayOfMonthOrdinalParse:/\d{1,2}-(й|го|я)/,ordinal:function(t,e){switch(e){case"M":case"d":case"DDD":return t+"-й";case"D":return t+"-го";case"w":case"W":return t+"-я";default:return t}},week:{dow:1,doy:4}})})(n("PJh5"))},upln:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t){return t%100==11||t%10!=1}function n(t,n,i,a){var o=t+" ";switch(i){case"s":return n||a?"nokkrar sekúndur":"nokkrum sekúndum";case"ss":return e(t)?o+(n||a?"sekúndur":"sekúndum"):o+"sekúnda";case"m":return n?"mínúta":"mínútu";case"mm":return e(t)?o+(n||a?"mínútur":"mínútum"):n?o+"mínúta":o+"mínútu";case"hh":return e(t)?o+(n||a?"klukkustundir":"klukkustundum"):o+"klukkustund";case"d":return n?"dagur":a?"dag":"degi";case"dd":return e(t)?n?o+"dagar":o+(a?"daga":"dögum"):n?o+"dagur":o+(a?"dag":"degi");case"M":return n?"mánuður":a?"mánuð":"mánuði";case"MM":return e(t)?n?o+"mánuðir":o+(a?"mánuði":"mánuðum"):n?o+"mánuður":o+(a?"mánuð":"mánuði");case"y":return n||a?"ár":"ári";case"yy":return e(t)?o+(n||a?"ár":"árum"):o+(n||a?"ár":"ári")}}t.defineLocale("is",{months:"janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),monthsShort:"jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),weekdays:"sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),weekdaysShort:"sun_mán_þri_mið_fim_fös_lau".split("_"),weekdaysMin:"Su_Má_Þr_Mi_Fi_Fö_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] H:mm",LLLL:"dddd, D. MMMM YYYY [kl.] H:mm"},calendar:{sameDay:"[í dag kl.] LT",nextDay:"[á morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[í gær kl.] LT",lastWeek:"[síðasta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s síðan",s:n,ss:n,m:n,mm:n,h:"klukkustund",hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},uslO:function(t,e,n){var i={"./af":"3CJN","./af.js":"3CJN","./ar":"3MVc","./ar-dz":"tkWw","./ar-dz.js":"tkWw","./ar-kw":"j8cJ","./ar-kw.js":"j8cJ","./ar-ly":"wPpW","./ar-ly.js":"wPpW","./ar-ma":"dURR","./ar-ma.js":"dURR","./ar-sa":"7OnE","./ar-sa.js":"7OnE","./ar-tn":"BEem","./ar-tn.js":"BEem","./ar.js":"3MVc","./az":"eHwN","./az.js":"eHwN","./be":"3hfc","./be.js":"3hfc","./bg":"lOED","./bg.js":"lOED","./bm":"hng5","./bm.js":"hng5","./bn":"aM0x","./bn-bd":"1C9R","./bn-bd.js":"1C9R","./bn.js":"aM0x","./bo":"w2Hs","./bo.js":"w2Hs","./br":"OSsP","./br.js":"OSsP","./bs":"aqvp","./bs.js":"aqvp","./ca":"wIgY","./ca.js":"wIgY","./cs":"ssxj","./cs.js":"ssxj","./cv":"N3vo","./cv.js":"N3vo","./cy":"ZFGz","./cy.js":"ZFGz","./da":"YBA/","./da.js":"YBA/","./de":"DOkx","./de-at":"8v14","./de-at.js":"8v14","./de-ch":"Frex","./de-ch.js":"Frex","./de.js":"DOkx","./dv":"rIuo","./dv.js":"rIuo","./el":"CFqe","./el.js":"CFqe","./en-au":"Sjoy","./en-au.js":"Sjoy","./en-ca":"Tqun","./en-ca.js":"Tqun","./en-gb":"hPuz","./en-gb.js":"hPuz","./en-ie":"ALEw","./en-ie.js":"ALEw","./en-il":"QZk1","./en-il.js":"QZk1","./en-in":"yJfC","./en-in.js":"yJfC","./en-nz":"dyB6","./en-nz.js":"dyB6","./en-sg":"NYST","./en-sg.js":"NYST","./eo":"Nd3h","./eo.js":"Nd3h","./es":"LT9G","./es-do":"7MHZ","./es-do.js":"7MHZ","./es-mx":"USNP","./es-mx.js":"USNP","./es-us":"INcR","./es-us.js":"INcR","./es.js":"LT9G","./et":"XlWM","./et.js":"XlWM","./eu":"sqLM","./eu.js":"sqLM","./fa":"2pmY","./fa.js":"2pmY","./fi":"nS2h","./fi.js":"nS2h","./fil":"rMbQ","./fil.js":"rMbQ","./fo":"OVPi","./fo.js":"OVPi","./fr":"tzHd","./fr-ca":"bXQP","./fr-ca.js":"bXQP","./fr-ch":"VK9h","./fr-ch.js":"VK9h","./fr.js":"tzHd","./fy":"g7KF","./fy.js":"g7KF","./ga":"U5Iz","./ga.js":"U5Iz","./gd":"nLOz","./gd.js":"nLOz","./gl":"FuaP","./gl.js":"FuaP","./gom-deva":"VGQH","./gom-deva.js":"VGQH","./gom-latn":"+27R","./gom-latn.js":"+27R","./gu":"rtsW","./gu.js":"rtsW","./he":"Nzt2","./he.js":"Nzt2","./hi":"ETHv","./hi.js":"ETHv","./hr":"V4qH","./hr.js":"V4qH","./hu":"xne+","./hu.js":"xne+","./hy-am":"GrS7","./hy-am.js":"GrS7","./id":"yRTJ","./id.js":"yRTJ","./is":"upln","./is.js":"upln","./it":"FKXc","./it-ch":"/E8D","./it-ch.js":"/E8D","./it.js":"FKXc","./ja":"ORgI","./ja.js":"ORgI","./jv":"JwiF","./jv.js":"JwiF","./ka":"RnJI","./ka.js":"RnJI","./kk":"j+vx","./kk.js":"j+vx","./km":"5j66","./km.js":"5j66","./kn":"gEQe","./kn.js":"gEQe","./ko":"eBB/","./ko.js":"eBB/","./ku":"kI9l","./ku.js":"kI9l","./ky":"6cf8","./ky.js":"6cf8","./lb":"z3hR","./lb.js":"z3hR","./lo":"nE8X","./lo.js":"nE8X","./lt":"/6P1","./lt.js":"/6P1","./lv":"jxEH","./lv.js":"jxEH","./me":"svD2","./me.js":"svD2","./mi":"gEU3","./mi.js":"gEU3","./mk":"Ab7C","./mk.js":"Ab7C","./ml":"oo1B","./ml.js":"oo1B","./mn":"CqHt","./mn.js":"CqHt","./mr":"5vPg","./mr.js":"5vPg","./ms":"ooba","./ms-my":"G++c","./ms-my.js":"G++c","./ms.js":"ooba","./mt":"oCzW","./mt.js":"oCzW","./my":"F+2e","./my.js":"F+2e","./nb":"FlzV","./nb.js":"FlzV","./ne":"/mhn","./ne.js":"/mhn","./nl":"3K28","./nl-be":"Bp2f","./nl-be.js":"Bp2f","./nl.js":"3K28","./nn":"C7av","./nn.js":"C7av","./oc-lnc":"KOFO","./oc-lnc.js":"KOFO","./pa-in":"pfs9","./pa-in.js":"pfs9","./pl":"7LV+","./pl.js":"7LV+","./pt":"ZoSI","./pt-br":"AoDM","./pt-br.js":"AoDM","./pt.js":"ZoSI","./ro":"wT5f","./ro.js":"wT5f","./ru":"ulq9","./ru.js":"ulq9","./sd":"fW1y","./sd.js":"fW1y","./se":"5Omq","./se.js":"5Omq","./si":"Lgqo","./si.js":"Lgqo","./sk":"OUMt","./sk.js":"OUMt","./sl":"2s1U","./sl.js":"2s1U","./sq":"V0td","./sq.js":"V0td","./sr":"f4W3","./sr-cyrl":"c1x4","./sr-cyrl.js":"c1x4","./sr.js":"f4W3","./ss":"7Q8x","./ss.js":"7Q8x","./sv":"Fpqq","./sv.js":"Fpqq","./sw":"DSXN","./sw.js":"DSXN","./ta":"+7/x","./ta.js":"+7/x","./te":"Nlnz","./te.js":"Nlnz","./tet":"gUgh","./tet.js":"gUgh","./tg":"5SNd","./tg.js":"5SNd","./th":"XzD+","./th.js":"XzD+","./tk":"+WRH","./tk.js":"+WRH","./tl-ph":"3LKG","./tl-ph.js":"3LKG","./tlh":"m7yE","./tlh.js":"m7yE","./tr":"k+5o","./tr.js":"k+5o","./tzl":"iNtv","./tzl.js":"iNtv","./tzm":"FRPF","./tzm-latn":"krPU","./tzm-latn.js":"krPU","./tzm.js":"FRPF","./ug-cn":"To0v","./ug-cn.js":"To0v","./uk":"ntHu","./uk.js":"ntHu","./ur":"uSe8","./ur.js":"uSe8","./uz":"XU1s","./uz-latn":"/bsm","./uz-latn.js":"/bsm","./uz.js":"XU1s","./vi":"0X8Q","./vi.js":"0X8Q","./x-pseudo":"e/KL","./x-pseudo.js":"e/KL","./yo":"YXlc","./yo.js":"YXlc","./zh-cn":"Vz2w","./zh-cn.js":"Vz2w","./zh-hk":"ZUyn","./zh-hk.js":"ZUyn","./zh-mo":"+WA1","./zh-mo.js":"+WA1","./zh-tw":"BbgG","./zh-tw.js":"BbgG"};function a(t){return n(o(t))}function o(t){var e=i[t];if(!(e+1))throw new Error("Cannot find module '"+t+"'.");return e}a.keys=function(){return Object.keys(i)},a.resolve=o,t.exports=a,a.id="uslO"},vAyx:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-ee88fb60] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-ee88fb60]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-ee88fb60] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-ee88fb60] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-ee88fb60] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-ee88fb60] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-ee88fb60] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-ee88fb60] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-ee88fb60] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-ee88fb60] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-ee88fb60] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-ee88fb60] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-ee88fb60] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-ee88fb60] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-ee88fb60] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-ee88fb60] {\n  margin-right: 0px;\n}\n.newItem[data-v-ee88fb60] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-ee88fb60] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-ee88fb60] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-ee88fb60] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-ee88fb60] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-ee88fb60] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-ee88fb60] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-ee88fb60] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-ee88fb60] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-ee88fb60] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-ee88fb60]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-ee88fb60] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-ee88fb60] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-ee88fb60] {\n  color: red;\n}\n.showMore[data-v-ee88fb60]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-ee88fb60] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-ee88fb60] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-ee88fb60] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-ee88fb60 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-ee88fb60 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-ee88fb60] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-ee88fb60 3s infinite;\n  animation: bit-data-v-ee88fb60 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-ee88fb60] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-ee88fb60]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-ee88fb60]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-ee88fb60]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-ee88fb60]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-ee88fb60]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-ee88fb60]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-ee88fb60] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-ee88fb60]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-ee88fb60] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-ee88fb60] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-ee88fb60] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-ee88fb60] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-ee88fb60] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-ee88fb60] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-ee88fb60] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-ee88fb60] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-ee88fb60] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-ee88fb60] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-ee88fb60] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-ee88fb60] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-ee88fb60] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-ee88fb60] {\n  margin-right: 0px;\n}\n.newItem[data-v-ee88fb60] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-ee88fb60] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-ee88fb60] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-ee88fb60] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-ee88fb60] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-ee88fb60] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-ee88fb60] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-ee88fb60] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-ee88fb60] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-ee88fb60] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-ee88fb60]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-ee88fb60] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-ee88fb60] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-ee88fb60] {\n  color: red;\n}\n.showMore[data-v-ee88fb60]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-ee88fb60] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-ee88fb60] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-ee88fb60] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-ee88fb60 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-ee88fb60 {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-ee88fb60] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-ee88fb60 3s infinite;\n  animation: bit-data-v-ee88fb60 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-ee88fb60] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-ee88fb60]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-ee88fb60]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-ee88fb60]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-ee88fb60]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-ee88fb60]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-ee88fb60]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},vLy8:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'/*  toolbox tab */\ndiv.toolbox-tab-container[data-v-2243f137] {\n  background-color: #a1a1a14d !important;\n  padding: 0 !important;\n  -moz-border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 1px 3px 14px -4px rgba(0, 0, 0, 0.7);\n  -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n  height: auto;\n  margin-top: 0px;\n  /* width: 91.6% */\n}\ndiv.toolbox-tab-menu div.list-group[data-v-2243f137] {\n  margin-bottom: 0;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-2243f137] {\n  margin-bottom: 0;\n  color: #000 !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-2243f137]:first-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-2243f137]:last-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137],\ndiv.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-2243f137],\ndiv.toolbox-tab-menu div.list-group > a.active .fa[data-v-2243f137] {\n  background-color: #4c5b72 !important;\n  color: white !important;\n  font-weight: bold !important;\n  border-radius: 0px !important;\n  border: 1px solid #4c5b72;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137]:after {\n  content: \'\';\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  margin-top: -13px;\n  border-left: 0;\n  border-bottom: 13px solid transparent;\n  border-top: 13px solid transparent;\n  border-left: 10px solid #4c5b72;\n}\ndiv.toolbox-tab-content[data-v-2243f137] {\n  padding-left: 0px;\n  padding-top: 0px;\n  margin-bottom: -32px;\n}\ndiv.toolbox-tab div.toolbox-tab-content[data-v-2243f137]:not(.active) {\n  display: none;\n}\n.list-group[data-v-2243f137] {\n  position: absolute;\n  margin-left: -174px;\n  margin-top: 34px;\n  /* font = 14px */\n  font-size: 0.875rem;\n  width: 174px;\n}\n.list-group-item[data-v-2243f137] {\n  border-radius: 0px !important;\n  cursor: pointer;\n  background-color: #f9f9f9 !important;\n  -webkit-box-shadow: 0px 3px 12px -4px rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 3px 12px -4px rgba(0, 0, 0, 0.4);\n  padding: 8px 8px 8px 0px;\n}\n.tabsSecundary[data-v-2243f137]:hover {\n  background-color: #1d324f33 !important;\n}\n.spacebar1[data-v-2243f137] {\n  right: 10px;\n  padding-right: 0px;\n  padding-left: 194px;\n}\n.tabPrimary[data-v-2243f137] {\n  /* position: absolute */\n  z-index: 3;\n  border-top: 1px solid black;\n  border-left: 1px solid black;\n  border-bottom: 1px solid black;\n  background-color: #1d324f !important;\n  font-size: 0.875rem;\n  border-radius: 0 !important;\n  color: white;\n}\n.tabsSecundary[data-v-2243f137] {\n  width: 144px;\n  margin-left: 30px;\n  padding: 3px 8px;\n  /* font 12px */\n  font-size: 0.75rem;\n  padding-left: 0px;\n}\n.header-tab[data-v-2243f137] {\n  z-index: 201;\n  background-color: #205196;\n  padding-top: 7px;\n  color: white;\n  /* font = 20px */\n  font-size: 1.25rem;\n  top: 33px;\n  position: sticky;\n}\n.header-tab-comparing[data-v-2243f137] {\n  z-index: 201;\n  background-color: #205196;\n  padding-top: 7px;\n  color: white;\n  /* font = 20px */\n  font-size: 1.25rem;\n  top: 0px;\n  position: sticky;\n}\n.tabForms[data-v-2243f137] {\n  margin-top: 15px;\n}\n@media (max-width: 991px) {\n.tabsSecundary[data-v-2243f137]:hover {\n    background-color: #bfc3c8 !important;\n}\n.myHidden[data-v-2243f137] {\n    display: none;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease-in;\n    transition: opacity 0.3s ease-in;\n}\n.spacebar1[data-v-2243f137] {\n    padding-left: 0px;\n    padding-right: 0px;\n    right: 0px;\n}\n.sideBar[data-v-2243f137] {\n    right: 1px;\n    z-index: 203;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease-in;\n    transition: opacity 0.3s ease-in;\n}\n.tabForms[data-v-2243f137] {\n    margin-top: 0px;\n}\n.list-group[data-v-2243f137] {\n    width: 100%;\n}\n.tabsSecundary[data-v-2243f137] {\n    border-left: 1px solid black;\n    width: 100%;\n    margin-left: 0px;\n    padding-left: 0px;\n    font-size: 1.25rem;\n    padding: 3px 0px;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-2243f137] {\n    margin-bottom: -1px;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137]:after {\n    border-left: 0px solid #000;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137]:after {\n    content: none;\n}\ndiv.list-group a.tabsSecundary[data-v-2243f137]:last-child {\n    border-bottom: 1px solid black;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137],\n  div.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-2243f137],\n  div.toolbox-tab-menu div.list-group > a.active .fa[data-v-2243f137] {\n    border-radius: 0px !important;\n}\n.list-group-item[data-v-2243f137] {\n    border-radius: 0px !important;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.tabPrimary[data-v-2243f137] {\n    margin-left: 0px;\n    font-size: 1.35rem;\n    width: 100%;\n}\n.nav_button[data-v-2243f137] {\n    display: inline-block !important;\n    cursor: pointer;\n}\n.boxContainer[data-v-2243f137] {\n    margin-left: 0px;\n    margin-right: 0px;\n    border-radius: 0px;\n    border-left: 0px;\n    border-right: 0px;\n}\n}\n@media (max-width: 552px) {\n.myNavBar[data-v-2243f137] {\n    padding-bottom: 32px !important;\n}\n.header-tab[data-v-2243f137] {\n    top: 64px;\n}\n}\n@media (max-width: 344px) {\n.header-tab[data-v-2243f137] {\n    top: 64px;\n}\n}\n.badgeP[data-v-2243f137] {\n  background-color: black;\n  margin-left: 5px;\n  margin-top: 2px;\n  padding: 0.25em 0.5em;\n}\n.badgeP[data-v-2243f137]::active {\n  background-color: white;\n}\ndiv.toolbox-tab-menu div.list-group > a.active span.badgeP[data-v-2243f137] {\n  background-color: white;\n  color: black;\n}\n.nav_button[data-v-2243f137] {\n  background-color: white;\n  border-radius: 5px;\n  border: 1px solid black;\n  display: none;\n  padding: 1px 6px;\n  font-size: 0.75rem;\n  margin-right: -1px;\n  color: black !important;\n}\n.btnNext[data-v-2243f137] {\n  margin-right: -1px;\n  background-color: #146ae3cc !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n  box-shadow: 1px 1px 3px 0px #000;\n}\n.btnNext[data-v-2243f137]:hover {\n  margin-right: -1px;\n  background-color: #146ae3 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n  box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-letter[data-v-2243f137] {\n  font-size: 0.675rem;\n}\n.boxContainer[data-v-2243f137] {\n  border: 2px solid black;\n  margin-left: 15px;\n  margin-right: 15px;\n  margin-bottom: 18px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  background-color: #f9f9f9;\n}\n.boxContainerForm[data-v-2243f137] {\n  border: 2px solid black;\n  margin-bottom: 18px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  height: 800px;\n}\n.borderBox[data-v-2243f137] {\n  border: 2px solid black;\n  border-radius: 5px;\n}\n.boxLeft[data-v-2243f137] {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border: none !important;\n  padding-left: 0px !important;\n  padding-right: 7.5px !important;\n}\n.boxRight[data-v-2243f137] {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border: none !important;\n  padding-right: 0px !important;\n  padding-left: 7.5px !important;\n}\n.radio-inline[data-v-2243f137] {\n  margin-top: 0;\n  margin-left: 0px !important;\n}\n.row[data-v-2243f137] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.spaceradio[data-v-2243f137] {\n  margin-right: 4px !important;\n}\n.radioabso[data-v-2243f137] {\n  position: absolute;\n}\n.left-radio[data-v-2243f137] {\n  padding-left: 30px;\n  line-height: 1.5;\n  margin-top: -6px;\n  padding-bottom: 10px;\n}\n.marginEnd[data-v-2243f137] {\n  margin-bottom: 2px;\n}\n.marginBotZero[data-v-2243f137] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-2243f137] {\n  margin-bottom: .5rem;\n}\n.marginRight10[data-v-2243f137] {\n  margin-right: 10px;\n}\n.paddingBottomZero[data-v-2243f137] {\n  padding-bottom: 0px;\n}\n.ImmigrationConsiderationsPT[data-v-2243f137] {\n  padding-top: 25px;\n}\n.ImmigrationConsiderationsMB[data-v-2243f137] {\n  margin-bottom: -13px;\n}\n.formGeneralInfor[data-v-2243f137] {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.marginLeft15[data-v-2243f137] {\n  margin-left: 15px;\n}\n.textHeaderMargin[data-v-2243f137] {\n  margin-left: -1px;\n}\n.boxHeaderMargin[data-v-2243f137] {\n  margin-left: 1px;\n}\n.paddingR0[data-v-2243f137] {\n  padding-right: 0px !important;\n}\n.AlignDeletd[data-v-2243f137] {\n  margin-right: -8px;\n}\n.footer-tab[data-v-2243f137] {\n  z-index: 201;\n  background-color: #205196;\n  padding: 5px 0px;\n  /* font = 20px */\n  font-size: 1.25rem;\n  bottom: 1px;\n  width: 100%;\n  position: sticky;\n  bottom: 0;\n}\nhr[data-v-2243f137] {\n  border: 1px solid rgba(0, 0, 0, 0.5);\n}\n.fadeIn[data-v-2243f137] {\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  opacity: 1 !important;\n}\n.fadeInMenu[data-v-2243f137] {\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n  opacity: 1 !important;\n}\n.fadeOut[data-v-2243f137] {\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n}\n.myBorderSideBar[data-v-2243f137] {\n  border: 1px solid black;\n}\n.rowhelpItem[data-v-2243f137] {\n  margin-right: -16px;\n  margin-left: -16px;\n  margin-top: -16px;\n}\n.helpItem[data-v-2243f137] {\n  background-color: #f1f189 !important;\n  text-align: center;\n  font-size: 16px;\n  padding: 0.8rem !important;\n}\n.centerBtnAf[data-v-2243f137] {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.badgeRed[data-v-2243f137] {\n  background-color: red;\n  margin-left: 5px;\n  margin-top: 2px;\n  padding: 0.25em 0.5em;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfSideBar/PfSideBar.css"],names:[],mappings:"AAAA,kBAAkB;AAClB;EACE,uCAAuC;EACvC,sBAAsB;EACtB,wBAAwB;EACxB,oDAAoD;EACpD,iDAAiD;EACjD,iDAAiD;EACjD,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,uBAAuB;CACxB;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,8BAA8B;CAC/B;AACD;;;EAGE,qCAAqC;EACrC,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;CAC3B;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,mCAAmC;EACnC,gCAAgC;CACjC;AACD;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;CACtB;AACD;EACE,cAAc;CACf;AACD;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;EACrC,yDAAyD;EACzD,iDAAiD;EACjD,yBAAyB;CAC1B;AACD;EACE,uCAAuC;CACxC;AACD;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;CACrB;AACD;EACE,wBAAwB;EACxB,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,qCAAqC;EACrC,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;CACd;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;CACnB;AACD;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,iBAAiB;CAClB;AACD;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;CAClB;AACD;EACE,iBAAiB;CAClB;AACD;AACA;IACI,qCAAqC;CACxC;AACD;IACI,cAAc;IACd,WAAW;IACX,yCAAyC;IACzC,iCAAiC;CACpC;AACD;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;CACd;AACD;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,yCAAyC;IACzC,iCAAiC;CACpC;AACD;IACI,gBAAgB;CACnB;AACD;IACI,YAAY;CACf;AACD;IACI,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;CACpB;AACD;IACI,oBAAoB;CACvB;AACD;IACI,4BAA4B;CAC/B;AACD;IACI,cAAc;CACjB;AACD;IACI,+BAA+B;CAClC;AACD;;;IAGI,8BAA8B;CACjC;AACD;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,uBAAuB;IACvB,oBAAoB;IACpB,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,cAAc;CACjB;AACD;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;CACf;AACD;IACI,iCAAiC;IACjC,gBAAgB;CACnB;AACD;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;CACrB;CACA;AACD;AACA;IACI,gCAAgC;CACnC;AACD;IACI,UAAU;CACb;CACA;AACD;AACA;IACI,UAAU;CACb;CACA;AACD;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;CACvB;AACD;EACE,wBAAwB;CACzB;AACD;EACE,wBAAwB;EACxB,aAAa;CACd;AACD;EACE,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;CACzB;AACD;EACE,mBAAmB;EACnB,uCAAuC;EACvC,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,oBAAoB;CACrB;AACD;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;CAC3B;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;CACf;AACD;EACE,wBAAwB;EACxB,mBAAmB;CACpB;AACD;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;CACjC;AACD;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,+BAA+B;CAChC;AACD;EACE,cAAc;EACd,4BAA4B;CAC7B;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,iBAAiB;CAClB;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,mBAAmB;CACpB;AACD;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,UAAU;CACX;AACD;EACE,qCAAqC;CACtC;AACD;EACE,yCAAyC;EACzC,iCAAiC;EACjC,sBAAsB;CACvB;AACD;EACE,yCAAyC;EACzC,iCAAiC;EACjC,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,wBAAwB;CACzB;AACD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;CAC5B;AACD;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;CACf;AACD;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;CACvB",file:"PfSideBar.css",sourcesContent:['/*  toolbox tab */\ndiv.toolbox-tab-container[data-v-2243f137] {\n  background-color: #a1a1a14d !important;\n  padding: 0 !important;\n  -moz-border-radius: 4px;\n  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  box-shadow: 1px 3px 14px -4px rgba(0, 0, 0, 0.7);\n  -moz-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  background-clip: padding-box;\n  height: auto;\n  margin-top: 0px;\n  /* width: 91.6% */\n}\ndiv.toolbox-tab-menu div.list-group[data-v-2243f137] {\n  margin-bottom: 0;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-2243f137] {\n  margin-bottom: 0;\n  color: #000 !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-2243f137]:first-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-2243f137]:last-child {\n  border-radius: 0px !important;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137],\ndiv.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-2243f137],\ndiv.toolbox-tab-menu div.list-group > a.active .fa[data-v-2243f137] {\n  background-color: #4c5b72 !important;\n  color: white !important;\n  font-weight: bold !important;\n  border-radius: 0px !important;\n  border: 1px solid #4c5b72;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137]:after {\n  content: \'\';\n  position: absolute;\n  left: 100%;\n  top: 50%;\n  margin-top: -13px;\n  border-left: 0;\n  border-bottom: 13px solid transparent;\n  border-top: 13px solid transparent;\n  border-left: 10px solid #4c5b72;\n}\ndiv.toolbox-tab-content[data-v-2243f137] {\n  padding-left: 0px;\n  padding-top: 0px;\n  margin-bottom: -32px;\n}\ndiv.toolbox-tab div.toolbox-tab-content[data-v-2243f137]:not(.active) {\n  display: none;\n}\n.list-group[data-v-2243f137] {\n  position: absolute;\n  margin-left: -174px;\n  margin-top: 34px;\n  /* font = 14px */\n  font-size: 0.875rem;\n  width: 174px;\n}\n.list-group-item[data-v-2243f137] {\n  border-radius: 0px !important;\n  cursor: pointer;\n  background-color: #f9f9f9 !important;\n  -webkit-box-shadow: 0px 3px 12px -4px rgba(0, 0, 0, 0.4);\n  box-shadow: 0px 3px 12px -4px rgba(0, 0, 0, 0.4);\n  padding: 8px 8px 8px 0px;\n}\n.tabsSecundary[data-v-2243f137]:hover {\n  background-color: #1d324f33 !important;\n}\n.spacebar1[data-v-2243f137] {\n  right: 10px;\n  padding-right: 0px;\n  padding-left: 194px;\n}\n.tabPrimary[data-v-2243f137] {\n  /* position: absolute */\n  z-index: 3;\n  border-top: 1px solid black;\n  border-left: 1px solid black;\n  border-bottom: 1px solid black;\n  background-color: #1d324f !important;\n  font-size: 0.875rem;\n  border-radius: 0 !important;\n  color: white;\n}\n.tabsSecundary[data-v-2243f137] {\n  width: 144px;\n  margin-left: 30px;\n  padding: 3px 8px;\n  /* font 12px */\n  font-size: 0.75rem;\n  padding-left: 0px;\n}\n.header-tab[data-v-2243f137] {\n  z-index: 201;\n  background-color: #205196;\n  padding-top: 7px;\n  color: white;\n  /* font = 20px */\n  font-size: 1.25rem;\n  top: 33px;\n  position: sticky;\n}\n.header-tab-comparing[data-v-2243f137] {\n  z-index: 201;\n  background-color: #205196;\n  padding-top: 7px;\n  color: white;\n  /* font = 20px */\n  font-size: 1.25rem;\n  top: 0px;\n  position: sticky;\n}\n.tabForms[data-v-2243f137] {\n  margin-top: 15px;\n}\n@media (max-width: 991px) {\n.tabsSecundary[data-v-2243f137]:hover {\n    background-color: #bfc3c8 !important;\n}\n.myHidden[data-v-2243f137] {\n    display: none;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease-in;\n    transition: opacity 0.3s ease-in;\n}\n.spacebar1[data-v-2243f137] {\n    padding-left: 0px;\n    padding-right: 0px;\n    right: 0px;\n}\n.sideBar[data-v-2243f137] {\n    right: 1px;\n    z-index: 203;\n    opacity: 0;\n    -webkit-transition: opacity 0.3s ease-in;\n    transition: opacity 0.3s ease-in;\n}\n.tabForms[data-v-2243f137] {\n    margin-top: 0px;\n}\n.list-group[data-v-2243f137] {\n    width: 100%;\n}\n.tabsSecundary[data-v-2243f137] {\n    border-left: 1px solid black;\n    width: 100%;\n    margin-left: 0px;\n    padding-left: 0px;\n    font-size: 1.25rem;\n    padding: 3px 0px;\n}\ndiv.toolbox-tab-menu div.list-group > a[data-v-2243f137] {\n    margin-bottom: -1px;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137]:after {\n    border-left: 0px solid #000;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137]:after {\n    content: none;\n}\ndiv.list-group a.tabsSecundary[data-v-2243f137]:last-child {\n    border-bottom: 1px solid black;\n}\ndiv.toolbox-tab-menu div.list-group > a.active[data-v-2243f137],\n  div.toolbox-tab-menu div.list-group > a.active .glyphicon[data-v-2243f137],\n  div.toolbox-tab-menu div.list-group > a.active .fa[data-v-2243f137] {\n    border-radius: 0px !important;\n}\n.list-group-item[data-v-2243f137] {\n    border-radius: 0px !important;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.tabPrimary[data-v-2243f137] {\n    margin-left: 0px;\n    font-size: 1.35rem;\n    width: 100%;\n}\n.nav_button[data-v-2243f137] {\n    display: inline-block !important;\n    cursor: pointer;\n}\n.boxContainer[data-v-2243f137] {\n    margin-left: 0px;\n    margin-right: 0px;\n    border-radius: 0px;\n    border-left: 0px;\n    border-right: 0px;\n}\n}\n@media (max-width: 552px) {\n.myNavBar[data-v-2243f137] {\n    padding-bottom: 32px !important;\n}\n.header-tab[data-v-2243f137] {\n    top: 64px;\n}\n}\n@media (max-width: 344px) {\n.header-tab[data-v-2243f137] {\n    top: 64px;\n}\n}\n.badgeP[data-v-2243f137] {\n  background-color: black;\n  margin-left: 5px;\n  margin-top: 2px;\n  padding: 0.25em 0.5em;\n}\n.badgeP[data-v-2243f137]::active {\n  background-color: white;\n}\ndiv.toolbox-tab-menu div.list-group > a.active span.badgeP[data-v-2243f137] {\n  background-color: white;\n  color: black;\n}\n.nav_button[data-v-2243f137] {\n  background-color: white;\n  border-radius: 5px;\n  border: 1px solid black;\n  display: none;\n  padding: 1px 6px;\n  font-size: 0.75rem;\n  margin-right: -1px;\n  color: black !important;\n}\n.btnNext[data-v-2243f137] {\n  margin-right: -1px;\n  background-color: #146ae3cc !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n  box-shadow: 1px 1px 3px 0px #000;\n}\n.btnNext[data-v-2243f137]:hover {\n  margin-right: -1px;\n  background-color: #146ae3 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n  box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-letter[data-v-2243f137] {\n  font-size: 0.675rem;\n}\n.boxContainer[data-v-2243f137] {\n  border: 2px solid black;\n  margin-left: 15px;\n  margin-right: 15px;\n  margin-bottom: 18px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  background-color: #f9f9f9;\n}\n.boxContainerForm[data-v-2243f137] {\n  border: 2px solid black;\n  margin-bottom: 18px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  height: 800px;\n}\n.borderBox[data-v-2243f137] {\n  border: 2px solid black;\n  border-radius: 5px;\n}\n.boxLeft[data-v-2243f137] {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border: none !important;\n  padding-left: 0px !important;\n  padding-right: 7.5px !important;\n}\n.boxRight[data-v-2243f137] {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n  border: none !important;\n  padding-right: 0px !important;\n  padding-left: 7.5px !important;\n}\n.radio-inline[data-v-2243f137] {\n  margin-top: 0;\n  margin-left: 0px !important;\n}\n.row[data-v-2243f137] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.spaceradio[data-v-2243f137] {\n  margin-right: 4px !important;\n}\n.radioabso[data-v-2243f137] {\n  position: absolute;\n}\n.left-radio[data-v-2243f137] {\n  padding-left: 30px;\n  line-height: 1.5;\n  margin-top: -6px;\n  padding-bottom: 10px;\n}\n.marginEnd[data-v-2243f137] {\n  margin-bottom: 2px;\n}\n.marginBotZero[data-v-2243f137] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-2243f137] {\n  margin-bottom: .5rem;\n}\n.marginRight10[data-v-2243f137] {\n  margin-right: 10px;\n}\n.paddingBottomZero[data-v-2243f137] {\n  padding-bottom: 0px;\n}\n.ImmigrationConsiderationsPT[data-v-2243f137] {\n  padding-top: 25px;\n}\n.ImmigrationConsiderationsMB[data-v-2243f137] {\n  margin-bottom: -13px;\n}\n.formGeneralInfor[data-v-2243f137] {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.marginLeft15[data-v-2243f137] {\n  margin-left: 15px;\n}\n.textHeaderMargin[data-v-2243f137] {\n  margin-left: -1px;\n}\n.boxHeaderMargin[data-v-2243f137] {\n  margin-left: 1px;\n}\n.paddingR0[data-v-2243f137] {\n  padding-right: 0px !important;\n}\n.AlignDeletd[data-v-2243f137] {\n  margin-right: -8px;\n}\n.footer-tab[data-v-2243f137] {\n  z-index: 201;\n  background-color: #205196;\n  padding: 5px 0px;\n  /* font = 20px */\n  font-size: 1.25rem;\n  bottom: 1px;\n  width: 100%;\n  position: sticky;\n  bottom: 0;\n}\nhr[data-v-2243f137] {\n  border: 1px solid rgba(0, 0, 0, 0.5);\n}\n.fadeIn[data-v-2243f137] {\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  opacity: 1 !important;\n}\n.fadeInMenu[data-v-2243f137] {\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n  opacity: 1 !important;\n}\n.fadeOut[data-v-2243f137] {\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n}\n.myBorderSideBar[data-v-2243f137] {\n  border: 1px solid black;\n}\n.rowhelpItem[data-v-2243f137] {\n  margin-right: -16px;\n  margin-left: -16px;\n  margin-top: -16px;\n}\n.helpItem[data-v-2243f137] {\n  background-color: #f1f189 !important;\n  text-align: center;\n  font-size: 16px;\n  padding: 0.8rem !important;\n}\n.centerBtnAf[data-v-2243f137] {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.badgeRed[data-v-2243f137] {\n  background-color: red;\n  margin-left: 5px;\n  margin-top: 2px;\n  padding: 0.25em 0.5em;\n}\n'],sourceRoot:""}])},vgcB:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero {\n  margin-bottom: 0px;\n}\n.marginBotRem {\n  margin-bottom: .5rem;\n}\n.spaceradio {\n  margin-right: 0px;\n}\n.newItem {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn {\n  opacity: 1 !important;\n}\n.fadeOut {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose:hover {\n  color: f2f2f2;\n}\n.accordion {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore {\n  margin-bottom: 16px;\n}\n.showMore {\n  color: red;\n}\n.showMore:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit 3s infinite;\n  animation: bit 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label {\n  font-weight: bold !important;\n}\n.fieldObli{\n  margin-top: -1px !important;\n}\n.BR-right{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none{\n  border-radius: 0px !important;\n}\n.BR-left{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,2BAA2B;EAC3B,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero {\n  margin-bottom: 0px;\n}\n.marginBotRem {\n  margin-bottom: .5rem;\n}\n.spaceradio {\n  margin-right: 0px;\n}\n.newItem {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn {\n  opacity: 1 !important;\n}\n.fadeOut {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose:hover {\n  color: f2f2f2;\n}\n.accordion {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore {\n  margin-bottom: 16px;\n}\n.showMore {\n  color: red;\n}\n.showMore:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit 3s infinite;\n  animation: bit 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label {\n  font-weight: bold !important;\n}\n.fieldObli{\n  margin-top: -1px !important;\n}\n.BR-right{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none{\n  border-radius: 0px !important;\n}\n.BR-left{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},vkJh:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfEducational.css",sourceRoot:""}])},vzRJ:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-35373e24]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-35373e24]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-35373e24]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-35373e24]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-35373e24] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-35373e24]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-35373e24] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-35373e24]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-35373e24]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-35373e24]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-35373e24]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-35373e24]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-35373e24]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-35373e24] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-35373e24]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-35373e24] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-35373e24]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-35373e24]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},"w/TU":function(t,e,n){var i;"undefined"!=typeof self&&self,i=function(t){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var a=e[i]={i:i,l:!1,exports:{}};return t[i].call(a.exports,a,a.exports,n),a.l=!0,a.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var a in t)n.d(i,a,function(e){return t[e]}.bind(null,a));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s="fb15")}({"01f9":function(t,e,n){"use strict";var i=n("2d00"),a=n("5ca1"),o=n("2aba"),r=n("32e9"),s=n("84f2"),l=n("41a0"),d=n("7f20"),c=n("38fd"),h=n("2b4c")("iterator"),u=!([].keys&&"next"in[].keys()),m=function(){return this};t.exports=function(t,e,n,f,p,_,A){l(n,e,f);var b,x,g,v=function(t){if(!u&&t in B)return B[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},C=e+" Iterator",y="values"==p,w=!1,B=t.prototype,k=B[h]||B["@@iterator"]||p&&B[p],E=k||v(p),I=p?y?v("entries"):E:void 0,D="Array"==e&&B.entries||k;if(D&&(g=c(D.call(new t)))!==Object.prototype&&g.next&&(d(g,C,!0),i||"function"==typeof g[h]||r(g,h,m)),y&&k&&"values"!==k.name&&(w=!0,E=function(){return k.call(this)}),i&&!A||!u&&!w&&B[h]||r(B,h,E),s[e]=E,s[C]=m,p)if(b={values:y?E:v("values"),keys:_?E:v("keys"),entries:I},A)for(x in b)x in B||o(B,x,b[x]);else a(a.P+a.F*(u||w),e,b);return b}},"02f4":function(t,e,n){var i=n("4588"),a=n("be13");t.exports=function(t){return function(e,n){var o,r,s=String(a(e)),l=i(n),d=s.length;return l<0||l>=d?t?"":void 0:(o=s.charCodeAt(l))<55296||o>56319||l+1===d||(r=s.charCodeAt(l+1))<56320||r>57343?t?s.charAt(l):o:t?s.slice(l,l+2):r-56320+(o-55296<<10)+65536}}},"0390":function(t,e,n){"use strict";var i=n("02f4")(!0);t.exports=function(t,e,n){return e+(n?i(t,e).length:1)}},"0bfb":function(t,e,n){"use strict";var i=n("cb7c");t.exports=function(){var t=i(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e}},"0d58":function(t,e,n){var i=n("ce10"),a=n("e11e");t.exports=Object.keys||function(t){return i(t,a)}},1495:function(t,e,n){var i=n("86cc"),a=n("cb7c"),o=n("0d58");t.exports=n("9e1e")?Object.defineProperties:function(t,e){a(t);for(var n,r=o(e),s=r.length,l=0;s>l;)i.f(t,n=r[l++],e[n]);return t}},"214f":function(t,e,n){"use strict";n("b0c5");var i=n("2aba"),a=n("32e9"),o=n("79e5"),r=n("be13"),s=n("2b4c"),l=n("520a"),d=s("species"),c=!o(function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")}),h=function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var n="ab".split(t);return 2===n.length&&"a"===n[0]&&"b"===n[1]}();t.exports=function(t,e,n){var u=s(t),m=!o(function(){var e={};return e[u]=function(){return 7},7!=""[t](e)}),f=m?!o(function(){var e=!1,n=/a/;return n.exec=function(){return e=!0,null},"split"===t&&(n.constructor={},n.constructor[d]=function(){return n}),n[u](""),!e}):void 0;if(!m||!f||"replace"===t&&!c||"split"===t&&!h){var p=/./[u],_=n(r,u,""[t],function(t,e,n,i,a){return e.exec===l?m&&!a?{done:!0,value:p.call(e,n,i)}:{done:!0,value:t.call(n,e,i)}:{done:!1}}),A=_[0],b=_[1];i(String.prototype,t,A),a(RegExp.prototype,u,2==e?function(t,e){return b.call(t,this,e)}:function(t){return b.call(t,this)})}}},"230e":function(t,e,n){var i=n("d3f4"),a=n("7726").document,o=i(a)&&i(a.createElement);t.exports=function(t){return o?a.createElement(t):{}}},"23c6":function(t,e,n){var i=n("2d95"),a=n("2b4c")("toStringTag"),o="Arguments"==i(function(){return arguments}());t.exports=function(t){var e,n,r;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),a))?n:o?i(e):"Object"==(r=i(e))&&"function"==typeof e.callee?"Arguments":r}},2621:function(t,e){e.f=Object.getOwnPropertySymbols},"2aba":function(t,e,n){var i=n("7726"),a=n("32e9"),o=n("69a8"),r=n("ca5a")("src"),s=n("fa5b"),l=(""+s).split("toString");n("8378").inspectSource=function(t){return s.call(t)},(t.exports=function(t,e,n,s){var d="function"==typeof n;d&&(o(n,"name")||a(n,"name",e)),t[e]!==n&&(d&&(o(n,r)||a(n,r,t[e]?""+t[e]:l.join(String(e)))),t===i?t[e]=n:s?t[e]?t[e]=n:a(t,e,n):(delete t[e],a(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[r]||s.call(this)})},"2aeb":function(t,e,n){var i=n("cb7c"),a=n("1495"),o=n("e11e"),r=n("613b")("IE_PROTO"),s=function(){},l=function(){var t,e=n("230e")("iframe"),i=o.length;for(e.style.display="none",n("fab2").appendChild(e),e.src="javascript:",(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),l=t.F;i--;)delete l.prototype[o[i]];return l()};t.exports=Object.create||function(t,e){var n;return null!==t?(s.prototype=i(t),n=new s,s.prototype=null,n[r]=t):n=l(),void 0===e?n:a(n,e)}},"2b4c":function(t,e,n){var i=n("5537")("wks"),a=n("ca5a"),o=n("7726").Symbol,r="function"==typeof o;(t.exports=function(t){return i[t]||(i[t]=r&&o[t]||(r?o:a)("Symbol."+t))}).store=i},"2d00":function(t,e){t.exports=!1},"2d95":function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},"2fdb":function(t,e,n){"use strict";var i=n("5ca1"),a=n("d2c8");i(i.P+i.F*n("5147")("includes"),"String",{includes:function(t){return!!~a(this,t,"includes").indexOf(t,arguments.length>1?arguments[1]:void 0)}})},"32e9":function(t,e,n){var i=n("86cc"),a=n("4630");t.exports=n("9e1e")?function(t,e,n){return i.f(t,e,a(1,n))}:function(t,e,n){return t[e]=n,t}},"38fd":function(t,e,n){var i=n("69a8"),a=n("4bf8"),o=n("613b")("IE_PROTO"),r=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=a(t),i(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?r:null}},"41a0":function(t,e,n){"use strict";var i=n("2aeb"),a=n("4630"),o=n("7f20"),r={};n("32e9")(r,n("2b4c")("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=i(r,{next:a(1,n)}),o(t,e+" Iterator")}},"456d":function(t,e,n){var i=n("4bf8"),a=n("0d58");n("5eda")("keys",function(){return function(t){return a(i(t))}})},4588:function(t,e){var n=Math.ceil,i=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?i:n)(t)}},4630:function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},"4bf8":function(t,e,n){var i=n("be13");t.exports=function(t){return Object(i(t))}},5147:function(t,e,n){var i=n("2b4c")("match");t.exports=function(t){var e=/./;try{"/./"[t](e)}catch(n){try{return e[i]=!1,!"/./"[t](e)}catch(t){}}return!0}},"520a":function(t,e,n){"use strict";var i,a,o=n("0bfb"),r=RegExp.prototype.exec,s=String.prototype.replace,l=r,d=(i=/a/,a=/b*/g,r.call(i,"a"),r.call(a,"a"),0!==i.lastIndex||0!==a.lastIndex),c=void 0!==/()??/.exec("")[1];(d||c)&&(l=function(t){var e,n,i,a,l=this;return c&&(n=new RegExp("^"+l.source+"$(?!\\s)",o.call(l))),d&&(e=l.lastIndex),i=r.call(l,t),d&&i&&(l.lastIndex=l.global?i.index+i[0].length:e),c&&i&&i.length>1&&s.call(i[0],n,function(){for(a=1;a<arguments.length-2;a++)void 0===arguments[a]&&(i[a]=void 0)}),i}),t.exports=l},"52a7":function(t,e){e.f={}.propertyIsEnumerable},5537:function(t,e,n){var i=n("8378"),a=n("7726"),o=a["__core-js_shared__"]||(a["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:i.version,mode:n("2d00")?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})},"5ca1":function(t,e,n){var i=n("7726"),a=n("8378"),o=n("32e9"),r=n("2aba"),s=n("9b43"),l=function(t,e,n){var d,c,h,u,m=t&l.F,f=t&l.G,p=t&l.S,_=t&l.P,A=t&l.B,b=f?i:p?i[e]||(i[e]={}):(i[e]||{}).prototype,x=f?a:a[e]||(a[e]={}),g=x.prototype||(x.prototype={});for(d in f&&(n=e),n)h=((c=!m&&b&&void 0!==b[d])?b:n)[d],u=A&&c?s(h,i):_&&"function"==typeof h?s(Function.call,h):h,b&&r(b,d,h,t&l.U),x[d]!=h&&o(x,d,u),_&&g[d]!=h&&(g[d]=h)};i.core=a,l.F=1,l.G=2,l.S=4,l.P=8,l.B=16,l.W=32,l.U=64,l.R=128,t.exports=l},"5eda":function(t,e,n){var i=n("5ca1"),a=n("8378"),o=n("79e5");t.exports=function(t,e){var n=(a.Object||{})[t]||Object[t],r={};r[t]=e(n),i(i.S+i.F*o(function(){n(1)}),"Object",r)}},"5f1b":function(t,e,n){"use strict";var i=n("23c6"),a=RegExp.prototype.exec;t.exports=function(t,e){var n=t.exec;if("function"==typeof n){var o=n.call(t,e);if("object"!=typeof o)throw new TypeError("RegExp exec method returned something other than an Object or null");return o}if("RegExp"!==i(t))throw new TypeError("RegExp#exec called on incompatible receiver");return a.call(t,e)}},"613b":function(t,e,n){var i=n("5537")("keys"),a=n("ca5a");t.exports=function(t){return i[t]||(i[t]=a(t))}},"626a":function(t,e,n){var i=n("2d95");t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},6762:function(t,e,n){"use strict";var i=n("5ca1"),a=n("c366")(!0);i(i.P,"Array",{includes:function(t){return a(this,t,arguments.length>1?arguments[1]:void 0)}}),n("9c6c")("includes")},6821:function(t,e,n){var i=n("626a"),a=n("be13");t.exports=function(t){return i(a(t))}},"69a8":function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},"6a99":function(t,e,n){var i=n("d3f4");t.exports=function(t,e){if(!i(t))return t;var n,a;if(e&&"function"==typeof(n=t.toString)&&!i(a=n.call(t)))return a;if("function"==typeof(n=t.valueOf)&&!i(a=n.call(t)))return a;if(!e&&"function"==typeof(n=t.toString)&&!i(a=n.call(t)))return a;throw TypeError("Can't convert object to primitive value")}},7333:function(t,e,n){"use strict";var i=n("0d58"),a=n("2621"),o=n("52a7"),r=n("4bf8"),s=n("626a"),l=Object.assign;t.exports=!l||n("79e5")(function(){var t={},e={},n=Symbol(),i="abcdefghijklmnopqrst";return t[n]=7,i.split("").forEach(function(t){e[t]=t}),7!=l({},t)[n]||Object.keys(l({},e)).join("")!=i})?function(t,e){for(var n=r(t),l=arguments.length,d=1,c=a.f,h=o.f;l>d;)for(var u,m=s(arguments[d++]),f=c?i(m).concat(c(m)):i(m),p=f.length,_=0;p>_;)h.call(m,u=f[_++])&&(n[u]=m[u]);return n}:l},7726:function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},"77f1":function(t,e,n){var i=n("4588"),a=Math.max,o=Math.min;t.exports=function(t,e){return(t=i(t))<0?a(t+e,0):o(t,e)}},"79e5":function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},"7f20":function(t,e,n){var i=n("86cc").f,a=n("69a8"),o=n("2b4c")("toStringTag");t.exports=function(t,e,n){t&&!a(t=n?t:t.prototype,o)&&i(t,o,{configurable:!0,value:e})}},8378:function(t,e){var n=t.exports={version:"2.6.5"};"number"==typeof __e&&(__e=n)},"84f2":function(t,e){t.exports={}},"86cc":function(t,e,n){var i=n("cb7c"),a=n("c69a"),o=n("6a99"),r=Object.defineProperty;e.f=n("9e1e")?Object.defineProperty:function(t,e,n){if(i(t),e=o(e,!0),i(n),a)try{return r(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},"9b43":function(t,e,n){var i=n("d8e8");t.exports=function(t,e,n){if(i(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,i){return t.call(e,n,i)};case 3:return function(n,i,a){return t.call(e,n,i,a)}}return function(){return t.apply(e,arguments)}}},"9c6c":function(t,e,n){var i=n("2b4c")("unscopables"),a=Array.prototype;void 0==a[i]&&n("32e9")(a,i,{}),t.exports=function(t){a[i][t]=!0}},"9def":function(t,e,n){var i=n("4588"),a=Math.min;t.exports=function(t){return t>0?a(i(t),9007199254740991):0}},"9e1e":function(t,e,n){t.exports=!n("79e5")(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},a352:function(e,n){e.exports=t},a481:function(t,e,n){"use strict";var i=n("cb7c"),a=n("4bf8"),o=n("9def"),r=n("4588"),s=n("0390"),l=n("5f1b"),d=Math.max,c=Math.min,h=Math.floor,u=/\$([$&`']|\d\d?|<[^>]*>)/g,m=/\$([$&`']|\d\d?)/g;n("214f")("replace",2,function(t,e,n,f){return[function(i,a){var o=t(this),r=void 0==i?void 0:i[e];return void 0!==r?r.call(i,o,a):n.call(String(o),i,a)},function(t,e){var a=f(n,t,this,e);if(a.done)return a.value;var h=i(t),u=String(this),m="function"==typeof e;m||(e=String(e));var _=h.global;if(_){var A=h.unicode;h.lastIndex=0}for(var b=[];;){var x=l(h,u);if(null===x)break;if(b.push(x),!_)break;""===String(x[0])&&(h.lastIndex=s(u,o(h.lastIndex),A))}for(var g,v="",C=0,y=0;y<b.length;y++){x=b[y];for(var w=String(x[0]),B=d(c(r(x.index),u.length),0),k=[],E=1;E<x.length;E++)k.push(void 0===(g=x[E])?g:String(g));var I=x.groups;if(m){var D=[w].concat(k,B,u);void 0!==I&&D.push(I);var S=String(e.apply(void 0,D))}else S=p(w,u,B,k,I,e);B>=C&&(v+=u.slice(C,B)+S,C=B+w.length)}return v+u.slice(C)}];function p(t,e,i,o,r,s){var l=i+t.length,d=o.length,c=m;return void 0!==r&&(r=a(r),c=u),n.call(s,c,function(n,a){var s;switch(a.charAt(0)){case"$":return"$";case"&":return t;case"`":return e.slice(0,i);case"'":return e.slice(l);case"<":s=r[a.slice(1,-1)];break;default:var c=+a;if(0===c)return n;if(c>d){var u=h(c/10);return 0===u?n:u<=d?void 0===o[u-1]?a.charAt(1):o[u-1]+a.charAt(1):n}s=o[c-1]}return void 0===s?"":s})}})},aae3:function(t,e,n){var i=n("d3f4"),a=n("2d95"),o=n("2b4c")("match");t.exports=function(t){var e;return i(t)&&(void 0!==(e=t[o])?!!e:"RegExp"==a(t))}},ac6a:function(t,e,n){for(var i=n("cadf"),a=n("0d58"),o=n("2aba"),r=n("7726"),s=n("32e9"),l=n("84f2"),d=n("2b4c"),c=d("iterator"),h=d("toStringTag"),u=l.Array,m={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},f=a(m),p=0;p<f.length;p++){var _,A=f[p],b=m[A],x=r[A],g=x&&x.prototype;if(g&&(g[c]||s(g,c,u),g[h]||s(g,h,A),l[A]=u,b))for(_ in i)g[_]||o(g,_,i[_],!0)}},b0c5:function(t,e,n){"use strict";var i=n("520a");n("5ca1")({target:"RegExp",proto:!0,forced:i!==/./.exec},{exec:i})},be13:function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},c366:function(t,e,n){var i=n("6821"),a=n("9def"),o=n("77f1");t.exports=function(t){return function(e,n,r){var s,l=i(e),d=a(l.length),c=o(r,d);if(t&&n!=n){for(;d>c;)if((s=l[c++])!=s)return!0}else for(;d>c;c++)if((t||c in l)&&l[c]===n)return t||c||0;return!t&&-1}}},c649:function(t,e,n){"use strict";(function(t){n.d(e,"c",function(){return d}),n.d(e,"a",function(){return s}),n.d(e,"b",function(){return i}),n.d(e,"d",function(){return l});n("a481");var i="undefined"!=typeof window?window.console:t.console;var a,o,r=/-(\w)/g,s=(a=function(t){return t.replace(r,function(t,e){return e?e.toUpperCase():""})},o=Object.create(null),function(t){return o[t]||(o[t]=a(t))});function l(t){null!==t.parentElement&&t.parentElement.removeChild(t)}function d(t,e,n){var i=0===n?t.children[0]:t.children[n-1].nextSibling;t.insertBefore(e,i)}}).call(this,n("c8ba"))},c69a:function(t,e,n){t.exports=!n("9e1e")&&!n("79e5")(function(){return 7!=Object.defineProperty(n("230e")("div"),"a",{get:function(){return 7}}).a})},c8ba:function(t,e){var n;n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},ca5a:function(t,e){var n=0,i=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+i).toString(36))}},cadf:function(t,e,n){"use strict";var i=n("9c6c"),a=n("d53b"),o=n("84f2"),r=n("6821");t.exports=n("01f9")(Array,"Array",function(t,e){this._t=r(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,a(1)):a(0,"keys"==e?n:"values"==e?t[n]:[n,t[n]])},"values"),o.Arguments=o.Array,i("keys"),i("values"),i("entries")},cb7c:function(t,e,n){var i=n("d3f4");t.exports=function(t){if(!i(t))throw TypeError(t+" is not an object!");return t}},ce10:function(t,e,n){var i=n("69a8"),a=n("6821"),o=n("c366")(!1),r=n("613b")("IE_PROTO");t.exports=function(t,e){var n,s=a(t),l=0,d=[];for(n in s)n!=r&&i(s,n)&&d.push(n);for(;e.length>l;)i(s,n=e[l++])&&(~o(d,n)||d.push(n));return d}},d2c8:function(t,e,n){var i=n("aae3"),a=n("be13");t.exports=function(t,e,n){if(i(e))throw TypeError("String#"+n+" doesn't accept regex!");return String(a(t))}},d3f4:function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},d53b:function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},d8e8:function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},e11e:function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},f559:function(t,e,n){"use strict";var i=n("5ca1"),a=n("9def"),o=n("d2c8"),r="".startsWith;i(i.P+i.F*n("5147")("startsWith"),"String",{startsWith:function(t){var e=o(this,t,"startsWith"),n=a(Math.min(arguments.length>1?arguments[1]:void 0,e.length)),i=String(t);return r?r.call(e,i,n):e.slice(n,n+i.length)===i}})},f6fd:function(t,e){!function(t){var e=t.getElementsByTagName("script");"currentScript"in t||Object.defineProperty(t,"currentScript",{get:function(){try{throw new Error}catch(i){var t,n=(/.*at [^\(]*\((.*):.+:.+\)$/gi.exec(i.stack)||[!1])[1];for(t in e)if(e[t].src==n||"interactive"==e[t].readyState)return e[t];return null}}})}(document)},f751:function(t,e,n){var i=n("5ca1");i(i.S+i.F,"Object",{assign:n("7333")})},fa5b:function(t,e,n){t.exports=n("5537")("native-function-to-string",Function.toString)},fab2:function(t,e,n){var i=n("7726").document;t.exports=i&&i.documentElement},fb15:function(t,e,n){"use strict";var i;(n.r(e),"undefined"!=typeof window)&&(n("f6fd"),(i=window.document.currentScript)&&(i=i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))&&(n.p=i[1]));n("f751"),n("f559"),n("ac6a"),n("cadf"),n("456d");function a(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,i=new Array(e);n<e;n++)i[n]=t[n];return i}function o(t,e){if(t){if("string"==typeof t)return a(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?a(t,e):void 0}}function r(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t)){var n=[],i=!0,a=!1,o=void 0;try{for(var r,s=t[Symbol.iterator]();!(i=(r=s.next()).done)&&(n.push(r.value),!e||n.length!==e);i=!0);}catch(t){a=!0,o=t}finally{try{i||null==s.return||s.return()}finally{if(a)throw o}}return n}}(t,e)||o(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}n("6762"),n("2fdb");function s(t){return function(t){if(Array.isArray(t))return a(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||o(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}var l=n("a352"),d=n.n(l),c=n("c649");function h(t,e){var n=this;this.$nextTick(function(){return n.$emit(t.toLowerCase(),e)})}function u(t){return["transition-group","TransitionGroup"].includes(t)}function m(t,e,n){return t[n]||(e[n]?e[n]():void 0)}var f=["Start","Add","Remove","Update","End"],p=["Choose","Unchoose","Sort","Filter","Clone"],_=["Move"].concat(f,p).map(function(t){return"on"+t}),A=null,b={name:"draggable",inheritAttrs:!1,props:{options:Object,list:{type:Array,required:!1,default:null},value:{type:Array,required:!1,default:null},noTransitionOnDrag:{type:Boolean,default:!1},clone:{type:Function,default:function(t){return t}},element:{type:String,default:"div"},tag:{type:String,default:null},move:{type:Function,default:null},componentData:{type:Object,required:!1,default:null}},data:function(){return{transitionMode:!1,noneFunctionalComponentMode:!1}},render:function(t){var e=this.$slots.default;this.transitionMode=function(t){if(!t||1!==t.length)return!1;var e=r(t,1)[0].componentOptions;return!!e&&u(e.tag)}(e);var n=function(t,e,n){var i=0,a=0,o=m(e,n,"header");o&&(i=o.length,t=t?[].concat(s(o),s(t)):s(o));var r=m(e,n,"footer");return r&&(a=r.length,t=t?[].concat(s(t),s(r)):s(r)),{children:t,headerOffset:i,footerOffset:a}}(e,this.$slots,this.$scopedSlots),i=n.children,a=n.headerOffset,o=n.footerOffset;this.headerOffset=a,this.footerOffset=o;var l=function(t,e){var n=null,i=function(t,e){n=function(t,e,n){return void 0===n?t:((t=t||{})[e]=n,t)}(n,t,e)};if(i("attrs",Object.keys(t).filter(function(t){return"id"===t||t.startsWith("data-")}).reduce(function(e,n){return e[n]=t[n],e},{})),!e)return n;var a=e.on,o=e.props,r=e.attrs;return i("on",a),i("props",o),Object.assign(n.attrs,r),n}(this.$attrs,this.componentData);return t(this.getTag(),l,i)},created:function(){null!==this.list&&null!==this.value&&c.b.error("Value and list props are mutually exclusive! Please set one or another."),"div"!==this.element&&c.b.warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props"),void 0!==this.options&&c.b.warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props")},mounted:function(){var t=this;if(this.noneFunctionalComponentMode=this.getTag().toLowerCase()!==this.$el.nodeName.toLowerCase()&&!this.getIsFunctional(),this.noneFunctionalComponentMode&&this.transitionMode)throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));var e={};f.forEach(function(n){e["on"+n]=function(t){var e=this;return function(n){null!==e.realList&&e["onDrag"+t](n),h.call(e,t,n)}}.call(t,n)}),p.forEach(function(n){e["on"+n]=h.bind(t,n)});var n=Object.keys(this.$attrs).reduce(function(e,n){return e[Object(c.a)(n)]=t.$attrs[n],e},{}),i=Object.assign({},this.options,n,e,{onMove:function(e,n){return t.onDragMove(e,n)}});!("draggable"in i)&&(i.draggable=">*"),this._sortable=new d.a(this.rootContainer,i),this.computeIndexes()},beforeDestroy:function(){void 0!==this._sortable&&this._sortable.destroy()},computed:{rootContainer:function(){return this.transitionMode?this.$el.children[0]:this.$el},realList:function(){return this.list?this.list:this.value}},watch:{options:{handler:function(t){this.updateOptions(t)},deep:!0},$attrs:{handler:function(t){this.updateOptions(t)},deep:!0},realList:function(){this.computeIndexes()}},methods:{getIsFunctional:function(){var t=this._vnode.fnOptions;return t&&t.functional},getTag:function(){return this.tag||this.element},updateOptions:function(t){for(var e in t){var n=Object(c.a)(e);-1===_.indexOf(n)&&this._sortable.option(n,t[e])}},getChildrenNodes:function(){if(this.noneFunctionalComponentMode)return this.$children[0].$slots.default;var t=this.$slots.default;return this.transitionMode?t[0].child.$slots.default:t},computeIndexes:function(){var t=this;this.$nextTick(function(){t.visibleIndexes=function(t,e,n,i){if(!t)return[];var a=t.map(function(t){return t.elm}),o=e.length-i,r=s(e).map(function(t,e){return e>=o?a.length:a.indexOf(t)});return n?r.filter(function(t){return-1!==t}):r}(t.getChildrenNodes(),t.rootContainer.children,t.transitionMode,t.footerOffset)})},getUnderlyingVm:function(t){var e=function(t,e){return t.map(function(t){return t.elm}).indexOf(e)}(this.getChildrenNodes()||[],t);return-1===e?null:{index:e,element:this.realList[e]}},getUnderlyingPotencialDraggableComponent:function(t){var e=t.__vue__;return e&&e.$options&&u(e.$options._componentTag)?e.$parent:!("realList"in e)&&1===e.$children.length&&"realList"in e.$children[0]?e.$children[0]:e},emitChanges:function(t){var e=this;this.$nextTick(function(){e.$emit("change",t)})},alterList:function(t){if(this.list)t(this.list);else{var e=s(this.value);t(e),this.$emit("input",e)}},spliceList:function(){var t=arguments,e=function(e){return e.splice.apply(e,s(t))};this.alterList(e)},updatePosition:function(t,e){var n=function(n){return n.splice(e,0,n.splice(t,1)[0])};this.alterList(n)},getRelatedContextFromMoveEvent:function(t){var e=t.to,n=t.related,i=this.getUnderlyingPotencialDraggableComponent(e);if(!i)return{component:i};var a=i.realList,o={list:a,component:i};if(e!==n&&a&&i.getUnderlyingVm){var r=i.getUnderlyingVm(n);if(r)return Object.assign(r,o)}return o},getVmIndex:function(t){var e=this.visibleIndexes,n=e.length;return t>n-1?n:e[t]},getComponent:function(){return this.$slots.default[0].componentInstance},resetTransitionData:function(t){if(this.noTransitionOnDrag&&this.transitionMode){this.getChildrenNodes()[t].data=null;var e=this.getComponent();e.children=[],e.kept=void 0}},onDragStart:function(t){this.context=this.getUnderlyingVm(t.item),t.item._underlying_vm_=this.clone(this.context.element),A=t.item},onDragAdd:function(t){var e=t.item._underlying_vm_;if(void 0!==e){Object(c.d)(t.item);var n=this.getVmIndex(t.newIndex);this.spliceList(n,0,e),this.computeIndexes();var i={element:e,newIndex:n};this.emitChanges({added:i})}},onDragRemove:function(t){if(Object(c.c)(this.rootContainer,t.item,t.oldIndex),"clone"!==t.pullMode){var e=this.context.index;this.spliceList(e,1);var n={element:this.context.element,oldIndex:e};this.resetTransitionData(e),this.emitChanges({removed:n})}else Object(c.d)(t.clone)},onDragUpdate:function(t){Object(c.d)(t.item),Object(c.c)(t.from,t.item,t.oldIndex);var e=this.context.index,n=this.getVmIndex(t.newIndex);this.updatePosition(e,n);var i={element:this.context.element,oldIndex:e,newIndex:n};this.emitChanges({moved:i})},updateProperty:function(t,e){t.hasOwnProperty(e)&&(t[e]+=this.headerOffset)},computeFutureIndex:function(t,e){if(!t.element)return 0;var n=s(e.to.children).filter(function(t){return"none"!==t.style.display}),i=n.indexOf(e.related),a=t.component.getVmIndex(i);return-1!==n.indexOf(A)||!e.willInsertAfter?a:a+1},onDragMove:function(t,e){var n=this.move;if(!n||!this.realList)return!0;var i=this.getRelatedContextFromMoveEvent(t),a=this.context,o=this.computeFutureIndex(i,t);return Object.assign(a,{futureIndex:o}),n(Object.assign({},t,{relatedContext:i,draggedContext:a}),e)},onDragEnd:function(){this.computeIndexes(),A=null}}};"undefined"!=typeof window&&"Vue"in window&&window.Vue.component("draggable",b);var x=b;e.default=x}}).default},t.exports=i(n("/dO2"))},w1e3:function(t,e,n){var i=n("mpzb");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("580c002e",i,!0,{})},w2Hs:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"༡",2:"༢",3:"༣",4:"༤",5:"༥",6:"༦",7:"༧",8:"༨",9:"༩",0:"༠"},n={"༡":"1","༢":"2","༣":"3","༤":"4","༥":"5","༦":"6","༧":"7","༨":"8","༩":"9","༠":"0"};t.defineLocale("bo",{months:"ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split("_"),monthsShort:"ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12".split("_"),monthsShortRegex:/^(ཟླ་\d{1,2})/,monthsParseExact:!0,weekdays:"གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་".split("_"),weekdaysShort:"ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),weekdaysMin:"ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན".split("_"),longDateFormat:{LT:"A h:mm",LTS:"A h:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, A h:mm",LLLL:"dddd, D MMMM YYYY, A h:mm"},calendar:{sameDay:"[དི་རིང] LT",nextDay:"[སང་ཉིན] LT",nextWeek:"[བདུན་ཕྲག་རྗེས་མ], LT",lastDay:"[ཁ་སང] LT",lastWeek:"[བདུན་ཕྲག་མཐའ་མ] dddd, LT",sameElse:"L"},relativeTime:{future:"%s ལ་",past:"%s སྔན་ལ",s:"ལམ་སང",ss:"%d སྐར་ཆ།",m:"སྐར་མ་གཅིག",mm:"%d སྐར་མ",h:"ཆུ་ཚོད་གཅིག",hh:"%d ཆུ་ཚོད",d:"ཉིན་གཅིག",dd:"%d ཉིན་",M:"ཟླ་བ་གཅིག",MM:"%d ཟླ་བ",y:"ལོ་གཅིག",yy:"%d ལོ"},preparse:function(t){return t.replace(/[༡༢༣༤༥༦༧༨༩༠]/g,function(t){return n[t]})},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]})},meridiemParse:/མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,meridiemHour:function(t,e){return 12===t&&(t=0),"མཚན་མོ"===e&&t>=4||"ཉིན་གུང"===e&&t<5||"དགོང་དག"===e?t+12:t},meridiem:function(t,e,n){return t<4?"མཚན་མོ":t<10?"ཞོགས་ཀས":t<17?"ཉིན་གུང":t<20?"དགོང་དག":"མཚན་མོ"},week:{dow:0,doy:6}})})(n("PJh5"))},w49j:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-626ae53c] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-626ae53c]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-626ae53c] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-626ae53c] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-626ae53c] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-626ae53c] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-626ae53c] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-626ae53c] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-626ae53c] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-626ae53c] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-626ae53c] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-626ae53c] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-626ae53c] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-626ae53c] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-626ae53c] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-626ae53c] {\n  margin-right: 0px;\n}\n.newItem[data-v-626ae53c] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-626ae53c] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-626ae53c] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-626ae53c] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-626ae53c] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-626ae53c] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-626ae53c] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-626ae53c] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-626ae53c] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-626ae53c] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-626ae53c]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-626ae53c] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-626ae53c] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-626ae53c] {\n  color: red;\n}\n.showMore[data-v-626ae53c]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-626ae53c] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-626ae53c] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-626ae53c] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-626ae53c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-626ae53c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-626ae53c] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-626ae53c 3s infinite;\n  animation: bit-data-v-626ae53c 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-626ae53c] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-626ae53c]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-626ae53c]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-626ae53c]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-626ae53c]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-626ae53c]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-626ae53c]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-626ae53c] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-626ae53c]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-626ae53c] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-626ae53c] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-626ae53c] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-626ae53c] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-626ae53c] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-626ae53c] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-626ae53c] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-626ae53c] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-626ae53c] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-626ae53c] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-626ae53c] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-626ae53c] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-626ae53c] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-626ae53c] {\n  margin-right: 0px;\n}\n.newItem[data-v-626ae53c] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-626ae53c] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-626ae53c] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-626ae53c] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-626ae53c] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-626ae53c] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-626ae53c] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-626ae53c] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-626ae53c] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-626ae53c] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-626ae53c]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-626ae53c] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-626ae53c] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-626ae53c] {\n  color: red;\n}\n.showMore[data-v-626ae53c]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-626ae53c] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-626ae53c] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-626ae53c] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-626ae53c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-626ae53c {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-626ae53c] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-626ae53c 3s infinite;\n  animation: bit-data-v-626ae53c 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-626ae53c] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-626ae53c]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-626ae53c]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-626ae53c]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-626ae53c]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-626ae53c]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-626ae53c]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},wIgY:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("ca",{months:{standalone:"gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),format:"de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split("_"),isFormat:/D[oD]?(\s)+MMMM/},monthsShort:"gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.".split("_"),monthsParseExact:!0,weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"dg_dl_dt_dc_dj_dv_ds".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM [de] YYYY",ll:"D MMM YYYY",LLL:"D MMMM [de] YYYY [a les] H:mm",lll:"D MMM YYYY, H:mm",LLLL:"dddd D MMMM [de] YYYY [a les] H:mm",llll:"ddd D MMM YYYY, H:mm"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[demà a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"d'aquí %s",past:"fa %s",s:"uns segons",ss:"%d segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},dayOfMonthOrdinalParse:/\d{1,2}(r|n|t|è|a)/,ordinal:function(t,e){var n=1===t?"r":2===t?"n":3===t?"r":4===t?"t":"è";return"w"!==e&&"W"!==e||(n="a"),t+n},week:{dow:1,doy:4}})})(n("PJh5"))},wMu1:function(t,e,n){var i=n("7GKi");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("79fd6cd5",i,!0,{})},wNGv:function(t,e,n){var i=n("BDVP");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("1b93a546",i,!0,{})},wP47:function(t,e,n){var i=n("nJRY");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("48197706",i,!0,{})},wPpW:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e={1:"1",2:"2",3:"3",4:"4",5:"5",6:"6",7:"7",8:"8",9:"9",0:"0"},n=function(t){return 0===t?0:1===t?1:2===t?2:t%100>=3&&t%100<=10?3:t%100>=11?4:5},i={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},a=function(t){return function(e,a,o,r){var s=n(e),l=i[t][n(e)];return 2===s&&(l=l[a?0:1]),l.replace(/%d/i,e)}},o=["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];t.defineLocale("ar-ly",{months:o,monthsShort:o,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"D/‏M/‏YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},meridiemParse:/ص|م/,isPM:function(t){return"م"===t},meridiem:function(t,e,n){return t<12?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:a("s"),ss:a("s"),m:a("m"),mm:a("m"),h:a("h"),hh:a("h"),d:a("d"),dd:a("d"),M:a("M"),MM:a("M"),y:a("y"),yy:a("y")},preparse:function(t){return t.replace(/،/g,",")},postformat:function(t){return t.replace(/\d/g,function(t){return e[t]}).replace(/,/g,"،")},week:{dow:6,doy:12}})})(n("PJh5"))},wQaC:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.btnnNew[data-v-0e439f4c]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-0e439f4c]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-0e439f4c]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-0e439f4c]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-0e439f4c] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-0e439f4c]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-0e439f4c] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-0e439f4c]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-0e439f4c]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfButton/PfButton.css"],names:[],mappings:";AACA;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,qCAAqC;EACrC,yCAAyC;UACjC,iCAAiC;CAC1C;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;CACvB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"PfButton.css",sourcesContent:["\n.btnnNew[data-v-0e439f4c]{\n  background-color: #4DCD30 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnNew[data-v-0e439f4c]:hover{\n  background-color: #2BBA37 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-0e439f4c]{\n  background-color: #EA3535 !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btnnCancel[data-v-0e439f4c]:hover{\n  background-color: #D01B1B !important;\n  -webkit-box-shadow: 1px 1px 3px 0px #000;\n          box-shadow: 1px 1px 3px 0px #000;\n}\n.btn-success-ubold[data-v-0e439f4c] {\n  color: #fff;\n  background-color: #1abc9c;\n  border-color: #1abc9c;\n}\n.btn-success-ubold[data-v-0e439f4c]:hover {\n  color: #fff;\n  background-color: #159a80;\n  border-color: #148f77;\n}\n.btn-secondary-ubold[data-v-0e439f4c] {\n  color: #fff;\n  background-color: #6c757d;\n  border-color: #6c757d;\n}\n.btn-secondary-ubold[data-v-0e439f4c]:hover {\n  color: #fff;\n  background-color: #5a6268;\n  border-color: #545b62;\n}\n.btn.btn-secondary[data-v-0e439f4c]:focus {\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n"],sourceRoot:""}])},wS5y:function(t,e,n){var i=n("6mhB");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("3608b0c5",i,!0,{})},wT5f:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n){var i=" ";return(t%100>=20||t>=100&&t%100==0)&&(i=" de "),t+i+{ss:"secunde",mm:"minute",hh:"ore",dd:"zile",ww:"săptămâni",MM:"luni",yy:"ani"}[n]}t.defineLocale("ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[mâine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s în urmă",s:"câteva secunde",ss:e,m:"un minut",mm:e,h:"o oră",hh:e,d:"o zi",dd:e,w:"o săptămână",ww:e,M:"o lună",MM:e,y:"un an",yy:e},week:{dow:1,doy:7}})})(n("PJh5"))},wWcv:function(t,e,n){var i=n("hgbu")("iterator"),a=!1;try{var o=[7][i]();o.return=function(){a=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!a)return!1;var n=!1;try{var o=[7],r=o[i]();r.next=function(){return{done:n=!0}},o[i]=function(){return r},t(o)}catch(t){}return n}},wXdB:function(t,e,n){var i=n("+MZ2");t.exports=function(t){return Object(i(t))}},waPF:function(t,e){t.exports="data:image/gif;base64,R0lGODlhBgAGAIABAFeayPr6+iH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS41LWMwMTQgNzkuMTUxNDgxLCAyMDEzLzAzLzEzLTEyOjA5OjE1ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjU4NkM5NjEyQTkzMDExRTNBMUY1QjM0QkZBODkyMEZCIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjU4NkM5NjEzQTkzMDExRTNBMUY1QjM0QkZBODkyMEZCIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NTg2Qzk2MTBBOTMwMTFFM0ExRjVCMzRCRkE4OTIwRkIiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NTg2Qzk2MTFBOTMwMTFFM0ExRjVCMzRCRkE4OTIwRkIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz4B//79/Pv6+fj39vX08/Lx8O/u7ezr6uno5+bl5OPi4eDf3t3c29rZ2NfW1dTT0tHQz87NzMvKycjHxsXEw8LBwL++vby7urm4t7a1tLOysbCvrq2sq6qpqKempaSjoqGgn56dnJuamZiXlpWUk5KRkI+OjYyLiomIh4aFhIOCgYB/fn18e3p5eHd2dXRzcnFwb25tbGtqaWhnZmVkY2JhYF9eXVxbWllYV1ZVVFNSUVBPTk1MS0pJSEdGRURDQkFAPz49PDs6OTg3NjU0MzIxMC8uLSwrKikoJyYlJCMiISAfHh0cGxoZGBcWFRQTEhEQDw4NDAsKCQgHBgUEAwIBAAAh+QQBAAABACwAAAAABgAGAAACCoQfZ5HI/gCboAAAOw=="},wfTn:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.new-information[data-v-25e46b60] {\n  border: 2px solid #00751b66 !important;\n  background-color: #00751b1a !important;\n}\n.new-information[data-v-25e46b60]:focus {\n  color: #495057;\n  background-color: #00751b1a !important;\n  border-color: #00751b66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n}\n.updated-information[data-v-25e46b60] {\n  border: 2px solid #034aff66 !important;\n  background-color: #074dff1a !important;\n}\n.updated-information[data-v-25e46b60]:focus {\n  color: #495057;\n  background-color: #074dff1a !important;\n  border-color: #034aff66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n}\n.deleted-information[data-v-25e46b60] {\n  border: 2px solid #dc354566 !important;\n  background-color: #dc35451a !important;\n}\n.deleted-information[data-v-25e46b60]:focus {\n  color: #495057;\n  background-color: #dc35451a !important;\n  border-color: #dc354566 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/comparing.css"],names:[],mappings:";AACA;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,0DAA0D;EAC1D,kDAAkD;CACnD;AACD;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,yDAAyD;EACzD,iDAAiD;CAClD;AACD;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,sDAAsD;EACtD,8CAA8C;CAC/C",file:"comparing.css",sourcesContent:["\n.new-information[data-v-25e46b60] {\n  border: 2px solid #00751b66 !important;\n  background-color: #00751b1a !important;\n}\n.new-information[data-v-25e46b60]:focus {\n  color: #495057;\n  background-color: #00751b1a !important;\n  border-color: #00751b66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n}\n.updated-information[data-v-25e46b60] {\n  border: 2px solid #034aff66 !important;\n  background-color: #074dff1a !important;\n}\n.updated-information[data-v-25e46b60]:focus {\n  color: #495057;\n  background-color: #074dff1a !important;\n  border-color: #034aff66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n}\n.deleted-information[data-v-25e46b60] {\n  border: 2px solid #dc354566 !important;\n  background-color: #dc35451a !important;\n}\n.deleted-information[data-v-25e46b60]:focus {\n  color: #495057;\n  background-color: #dc35451a !important;\n  border-color: #dc354566 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n}\n"],sourceRoot:""}])},wiaE:function(t,e,n){var i=n("NZra");t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==i(t)?t.split(""):Object(t)}},woOf:function(t,e,n){t.exports={default:n("Eif7"),__esModule:!0}},wpe0:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"/* .spaceradio {\n  margin-right: 0px !important; } */\n\n/* .marginRight10 {\n  margin-right: 10px; } */","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/components/PfTravelHistory/PfTravel/PfTravel.css"],names:[],mappings:"AAAA;oCACoC;;AAEpC;0BAC0B",file:"PfTravel.css",sourcesContent:["/* .spaceradio {\n  margin-right: 0px !important; } */\n\n/* .marginRight10 {\n  margin-right: 10px; } */"],sourceRoot:""}])},"x//u":function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},"x/31":function(t,e,n){n("gCWN"),n("tz60"),n("+3lO"),n("mgCp"),n("+GuK"),n("Nrqz"),t.exports=n("iANj").Promise},x0nU:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.btnRemove[data-v-c02361dc] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-c02361dc]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-c02361dc] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-c02361dc] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-c02361dc] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-c02361dc] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-c02361dc] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-c02361dc] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-c02361dc] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-c02361dc] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-c02361dc] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-c02361dc] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-c02361dc] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-c02361dc] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-c02361dc] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-c02361dc] {\n  margin-right: 0px;\n}\n.newItem[data-v-c02361dc] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-c02361dc] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-c02361dc] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-c02361dc] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-c02361dc] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-c02361dc] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-c02361dc] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-c02361dc] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-c02361dc] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-c02361dc] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-c02361dc]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-c02361dc] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-c02361dc] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-c02361dc] {\n  color: red;\n}\n.showMore[data-v-c02361dc]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-c02361dc] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-c02361dc] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-c02361dc] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-c02361dc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-c02361dc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-c02361dc] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-c02361dc 3s infinite;\n  animation: bit-data-v-c02361dc 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-c02361dc] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-c02361dc]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-c02361dc]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-c02361dc]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-c02361dc]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-c02361dc]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-c02361dc]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/global.css"],names:[],mappings:";AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;EACpB,wBAAwB;EACxB,oBAAoB;CACrB;AACD;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oBAAoB;CACrB;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,wBAAwB;EACxB,oBAAoB;EACpB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,0BAA0B;CAC3B;AACD;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;CACd;AACD;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;CACd;AACD;EACE,kBAAkB;EAClB,iBAAiB;CAClB;AACD;EACE,6BAA6B;EAC7B,4BAA4B;CAC7B;AACD;EACE,0BAA0B;CAC3B;AACD;EACE,qCAAqC;EACrC,+BAA+B;CAChC;AACD;EACE,qCAAqC;EACrC,aAAa;CACd;AACD;EACE,uCAAuC;EACvC,+BAA+B;CAChC;AACD;EACE,qCAAqC;CACtC;AACD;EACE,mBAAmB;CACpB;AACD;EACE,qBAAqB;CACtB;AACD;EACE,kBAAkB;CACnB;AACD;EACE,qCAAqC;EACrC,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,mBAAmB;CACpB;AACD;EACE,sBAAsB;CACvB;AACD;EACE,WAAW;EACX,yCAAyC;EACzC,iCAAiC;CAClC;AACD;EACE,uCAAuC;EACvC,wEAAwE;EACxE,gEAAgE;EAChE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,uCAAuC;EACvC,uCAAuC;EACvC,0EAA0E;EAC1E,kEAAkE;EAClE,kCAAkC;EAClC,0BAA0B;CAC3B;AACD;EACE,0DAA0D;EAC1D,kDAAkD;EAClD,gDAAgD;EAChD,wDAAwD;EACxD,gDAAgD;EAChD,wCAAwC;EACxC,6EAA6E;CAC9E;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,4CAA4C;EAC5C,oCAAoC;CACrC;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;CACjB;AACD;EACE,cAAc;CACf;AACD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;CACpB;AACD;EACE,oBAAoB;CACrB;AACD;EACE,WAAW;CACZ;AACD;EACE,kBAAkB;EAClB,gBAAgB;CACjB;AACD;EACE,kBAAkB;EAClB,kBAAkB;CACnB;AACD;EACE,sCAAsC;CACvC;AACD;AACA;IACI,mBAAmB;CACtB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;AACA;IACI,wBAAwB;IACxB,gBAAgB;CACnB;AACD;IACI,8BAA8B;IAC9B,sBAAsB;CACzB;AACD;IACI,wBAAwB;IACxB,gBAAgB;CACnB;CACA;AACD;EACE,sBAAsB;EACtB,WAAW;EACX,mDAAmD;EACnD,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;CAC1B;AACD;EACE,6BAA6B;CAC9B;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,sCAAsC;EACtC,yCAAyC;CAC1C;AACD;EACE,8BAA8B;CAC/B;AACD;EACE,qCAAqC;EACrC,wCAAwC;CACzC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC;AACD;EACE,qCAAqC;EACrC,iCAAiC;CAClC",file:"global.css",sourcesContent:['\n.btnRemove[data-v-c02361dc] {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n  padding: 0.15rem 0.2rem;\n  font-size: 0.775rem;\n}\n.btnRemove[data-v-c02361dc]:hover {\n  border-radius: 5px 5px 0px 0px;\n  border-top: 1px solid gray;\n  border-left: 1px solid gray;\n  border-right: 1px solid gray;\n  border-bottom: none;\n}\n.btnBloodClass[data-v-c02361dc] {\n  background-color: #ffefef !important;\n  border: 2px solid red !important;\n}\n.boxContainer[data-v-c02361dc] {\n  border: 2px solid black;\n  margin-bottom: 16px;\n  border-radius: 5px 5px 5px 5px;\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n  -webkit-transition: all 0.3s linear;\n  transition: all 0.3s linear;\n  background-color: #f9f9f9;\n}\n.backgroundTitlesBox[data-v-c02361dc] {\n  background-color: #146ae3cc;\n  padding-top: 6px;\n  width: 100%;\n  padding-left: 15px;\n  margin-bottom: 5px;\n  border-radius: 3px 3px 0px 0px;\n  color: white;\n}\n.backgroundTitlesBoxNoBorder[data-v-c02361dc] {\n  background-color: #d5d5d5;\n  padding-top: 6px;\n  margin-bottom: 5px;\n  width: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: black;\n}\n.row[data-v-c02361dc] {\n  margin-right: 0px;\n  margin-left: 0px;\n}\n.myRow[data-v-c02361dc] {\n  margin-right: 0px !important;\n  margin-left: 0px !important;\n}\n.dhtmlxcalendar_dhx_web.dhtmlxcalendar_in_input[data-v-c02361dc] {\n  z-index: 15000 !important;\n}\n.backgroundTitlesBoxDeleted[data-v-c02361dc] {\n  background-color: #d64e5b !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.backgroundTitlesBoxDeletedNoborder[data-v-c02361dc] {\n  background-color: #d64e5b !important;\n  color: white;\n}\n.bgTitlesBoxNewI[data-v-c02361dc] {\n  background-color: #146ae3cc !important;\n  border-radius: 3px 3px 0px 0px;\n}\n.bgTitlesBoxNewINoborder[data-v-c02361dc] {\n  background-color: #d5d5d5 !important;\n}\n.marginBotZero[data-v-c02361dc] {\n  margin-bottom: 0px;\n}\n.marginBotRem[data-v-c02361dc] {\n  margin-bottom: .5rem;\n}\n.spaceradio[data-v-c02361dc] {\n  margin-right: 0px;\n}\n.newItem[data-v-c02361dc] {\n  background-color: #f8fff7 !important;\n  border: 1px solid black;\n  -webkit-box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  box-shadow: 3px 4px 13px -1px rgba(0, 0, 0, 0.79);\n  opacity: 0;\n  -webkit-transition: opacity 0.5s ease-in;\n  transition: opacity 0.5s ease-in;\n  border-radius: 5px;\n}\n.fadeIn[data-v-c02361dc] {\n  opacity: 1 !important;\n}\n.fadeOut[data-v-c02361dc] {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s ease-in;\n  transition: opacity 0.2s ease-in;\n}\n.flashit[data-v-c02361dc] {\n  border: 1px solid #29a339e6 !important;\n  -webkit-box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  box-shadow: 0px 0px 10px 8px rgba(88, 211, 66, 0.51) !important;\n  -webkit-transition: all 0.6s ease;\n  transition: all 0.6s ease;\n}\n.flashitInput[data-v-c02361dc] {\n  border: 1px solid #29a339e6 !important;\n  background-color: #29a33933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(88, 211, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.flashitInputError[data-v-c02361dc] {\n  border: 1px solid #a32929e6 !important;\n  background-color: #ffb0a933 !important;\n  -webkit-box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  box-shadow: 0px 0px 5px 0.2rem rgba(211, 66, 66, 0.43) !important;\n  -webkit-transition: all 0.4s ease;\n  transition: all 0.4s ease;\n}\n.fadeShadow[data-v-c02361dc] {\n  -webkit-box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  box-shadow: 3px 4px 13px -4px rgba(0, 0, 0, 0.57);\n  -webkit-transition: box-shadow 0.9s ease-in-out;\n  -webkit-transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: -webkit-box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out;\n  transition: box-shadow 0.9s ease-in-out, -webkit-box-shadow 0.9s ease-in-out;\n}\n.animate[data-v-c02361dc] {\n  -webkit-transition: margin-top 0.5s ease-in;\n  transition: margin-top 0.5s ease-in;\n}\n.animateBtnAdd[data-v-c02361dc] {\n  -webkit-transition: margin-top 0.1s ease-in;\n  transition: margin-top 0.1s ease-in;\n}\n.arrowClose[data-v-c02361dc] {\n  position: absolute;\n  right: 15px;\n  top: 7px;\n  color: white;\n  font-size: 22px;\n  z-index: 50;\n  cursor: pointer;\n}\n.arrowClose[data-v-c02361dc]:hover {\n  color: f2f2f2;\n}\n.accordion[data-v-c02361dc] {\n  text-align: right;\n  margin-top: -12px;\n  margin-bottom: 3px;\n  margin-right: 15px;\n}\n.spaceShowMore[data-v-c02361dc] {\n  margin-bottom: 16px;\n}\n.showMore[data-v-c02361dc] {\n  color: red;\n}\n.showMore[data-v-c02361dc]:hover {\n  font-weight: bold;\n  cursor: pointer;\n}\n.titlesNames[data-v-c02361dc] {\n  margin-left: 13px;\n  font-weight: bold;\n}\n.textUnderline[data-v-c02361dc] {\n  text-decoration: underline !important;\n}\n@media (max-width: 413px) {\n.mrTextSpace[data-v-c02361dc] {\n    margin-right: 45px;\n}\n}\n@-webkit-keyframes bit-data-v-c02361dc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n@keyframes bit-data-v-c02361dc {\nfrom {\n    -webkit-transform: none;\n    transform: none;\n}\n50% {\n    -webkit-transform: scale(1.2);\n    transform: scale(1.2);\n}\nto {\n    -webkit-transform: none;\n    transform: none;\n}\n}\n.fa-arrow-circle-down[data-v-c02361dc] {\n  display: inline-block;\n  color: red;\n  -webkit-animation: bit-data-v-c02361dc 3s infinite;\n  animation: bit-data-v-c02361dc 3s infinite;\n  -webkit-transform-origin: center;\n  transform-origin: center;\n}\ninput:checked + label[data-v-c02361dc] {\n  font-weight: bold !important;\n}\n.fieldObli[data-v-c02361dc]{\n  margin-top: -1px !important;\n}\n.BR-right[data-v-c02361dc]{\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n.BR-none[data-v-c02361dc]{\n  border-radius: 0px !important;\n}\n.BR-left[data-v-c02361dc]{\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.colorBtnActiveAcBi[data-v-c02361dc]{\n  background-color: #5a6268 !important;\n  border-color: #545b62 !important;\n}\n.colorBtnActiveAcBiDanger[data-v-c02361dc]{\n  background-color: #a50404 !important;\n  border-color: #a50404 !important;\n}\n'],sourceRoot:""}])},xLnA:function(t,e,n){var i=n("L8tt");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("243e59aa",i,!0,{})},xLtR:function(t,e,n){"use strict";var i=n("cGG2"),a=n("TNV1"),o=n("pBtG"),r=n("KCLY"),s=n("dIwP"),l=n("qRfI");function d(t){t.cancelToken&&t.cancelToken.throwIfRequested()}t.exports=function(t){return d(t),t.baseURL&&!s(t.url)&&(t.url=l(t.baseURL,t.url)),t.headers=t.headers||{},t.data=a(t.data,t.headers,t.transformRequest),t.headers=i.merge(t.headers.common||{},t.headers[t.method]||{},t.headers||{}),i.forEach(["delete","get","head","post","put","patch","common"],function(e){delete t.headers[e]}),(t.adapter||r.adapter)(t).then(function(e){return d(t),e.data=a(e.data,e.headers,t.transformResponse),e},function(e){return o(e)||(d(t),e&&e.response&&(e.response.data=a(e.response.data,e.response.headers,t.transformResponse))),Promise.reject(e)})}},xVc6:function(t,e,n){"use strict";var i=n("qs+f"),a=n("pEGt"),o=n("THEY"),r=n("bSeU"),s=n("wXdB"),l=n("wiaE"),d=Object.assign;t.exports=!d||n("zyKz")(function(){var t={},e={},n=Symbol(),i="abcdefghijklmnopqrst";return t[n]=7,i.split("").forEach(function(t){e[t]=t}),7!=d({},t)[n]||Object.keys(d({},e)).join("")!=i})?function(t,e){for(var n=s(t),d=arguments.length,c=1,h=o.f,u=r.f;d>c;)for(var m,f=l(arguments[c++]),p=h?a(f).concat(h(f)):a(f),_=p.length,A=0;_>A;)m=p[A++],i&&!u.call(f,m)||(n[m]=f[m]);return n}:d},xXfZ:function(t,e,n){var i=n("tW76");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("60565477",i,!0,{})},"xne+":function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
var e="vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" ");function n(t,e,n,i){var a=t;switch(n){case"s":return i||e?"néhány másodperc":"néhány másodperce";case"ss":return a+(i||e)?" másodperc":" másodperce";case"m":return"egy"+(i||e?" perc":" perce");case"mm":return a+(i||e?" perc":" perce");case"h":return"egy"+(i||e?" óra":" órája");case"hh":return a+(i||e?" óra":" órája");case"d":return"egy"+(i||e?" nap":" napja");case"dd":return a+(i||e?" nap":" napja");case"M":return"egy"+(i||e?" hónap":" hónapja");case"MM":return a+(i||e?" hónap":" hónapja");case"y":return"egy"+(i||e?" év":" éve");case"yy":return a+(i||e?" év":" éve")}return""}function i(t){return(t?"":"[múlt] ")+"["+e[this.day()]+"] LT[-kor]"}t.defineLocale("hu",{months:"január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),monthsShort:"jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.".split("_"),monthsParseExact:!0,weekdays:"vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),weekdaysShort:"vas_hét_kedd_sze_csüt_pén_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"H:mm:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D. H:mm",LLLL:"YYYY. MMMM D., dddd H:mm"},meridiemParse:/de|du/i,isPM:function(t){return"u"===t.charAt(1).toLowerCase()},meridiem:function(t,e,n){return t<12?!0===n?"de":"DE":!0===n?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return i.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return i.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s múlva",past:"%s",s:n,ss:n,m:n,mm:n,h:n,hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},y4y1:function(t,e,n){var i=n("ZjJ6");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("4b8075e6",i,!0,{})},y5BL:function(module,exports){function dhtmlDragAndDropObject(){return window.dhtmlDragAndDrop?window.dhtmlDragAndDrop:(this.lastLanding=0,this.dragNode=0,this.dragStartNode=0,this.dragStartObject=0,this.tempDOMU=null,this.tempDOMM=null,this.waitDrag=0,window.dhtmlDragAndDrop=this,this)}if(void 0===window.dhx&&(window.dhx=window.dhx4={version:"5.1.0",skin:null,skinDetect:function(t){return{10:"dhx_skyblue",20:"dhx_web",30:"dhx_terrace",40:"material"}[10*Math.floor(dhx4.readFromCss(t+"_skin_detect")/10)]||null},readFromCss:function(t,e,n){var i=document.createElement("DIV");i.className=t,null!=document.body.firstChild?document.body.insertBefore(i,document.body.firstChild):document.body.appendChild(i),"string"==typeof n&&(i.innerHTML=n);var a=i[e||"offsetWidth"];return i.parentNode.removeChild(i),i=null,a},lastId:1,newId:function(){return this.lastId++},zim:{data:{},step:5,first:function(){return 100},last:function(){var t=this.first();for(var e in this.data)t=Math.max(t,this.data[e]);return t},reserve:function(t){return this.data[t]=this.last()+this.step,this.data[t]},clear:function(t){null!=this.data[t]&&(this.data[t]=null,delete this.data[t])}},s2b:function(t){return"string"==typeof t&&(t=t.toLowerCase()),1==t||1==t||"true"==t||"1"==t||"yes"==t||"y"==t||"on"==t},s2j:function(s){var obj=null;dhx4.temp=null;try{eval("dhx4.temp="+s)}catch(t){dhx4.temp=null}return obj=dhx4.temp,dhx4.temp=null,obj},absLeft:function(t){return"string"==typeof t&&(t=document.getElementById(t)),this.getOffset(t).left},absTop:function(t){return"string"==typeof t&&(t=document.getElementById(t)),this.getOffset(t).top},_aOfs:function(t){for(var e=0,n=0;t;)e+=parseInt(t.offsetTop),n+=parseInt(t.offsetLeft),t=t.offsetParent;return{top:e,left:n}},_aOfsRect:function(t){var e=t.getBoundingClientRect(),n=document.body,i=document.documentElement,a=window.pageYOffset||i.scrollTop||n.scrollTop,o=window.pageXOffset||i.scrollLeft||n.scrollLeft,r=i.clientTop||n.clientTop||0,s=i.clientLeft||n.clientLeft||0,l=e.top+a-r,d=e.left+o-s;return{top:Math.round(l),left:Math.round(d)}},getOffset:function(t){return t.getBoundingClientRect?this._aOfsRect(t):this._aOfs(t)},_isObj:function(t){return null!=t&&"object"==typeof t&&void 0===t.length},_copyObj:function(t){if(this._isObj(t)){var e={};for(var n in t)"object"==typeof t[n]&&null!=t[n]?e[n]=this._copyObj(t[n]):e[n]=t[n]}else for(e=[],n=0;n<t.length;n++)"object"==typeof t[n]&&null!=t[n]?e[n]=this._copyObj(t[n]):e[n]=t[n];return e},screenDim:function(){var t=navigator.userAgent.indexOf("MSIE")>=0,e={};return e.left=document.body.scrollLeft,e.right=e.left+(window.innerWidth||document.body.clientWidth),e.top=Math.max((t?document.documentElement:document.getElementsByTagName("html")[0]).scrollTop,document.body.scrollTop),e.bottom=e.top+(t?Math.max(document.documentElement.clientHeight||0,document.documentElement.offsetHeight||0):window.innerHeight),e},selectTextRange:function(t,e,n){var i=(t="string"==typeof t?document.getElementById(t):t).value.length;if(e=Math.max(Math.min(e,i),0),n=Math.min(n,i),t.setSelectionRange)try{t.setSelectionRange(e,n)}catch(t){}else if(t.createTextRange){var a=t.createTextRange();a.moveStart("character",e),a.moveEnd("character",n-i);try{a.select()}catch(t){}}},transData:null,transDetect:function(){if(null==this.transData){this.transData={transProp:!1,transEv:null};var t={MozTransition:"transitionend",WebkitTransition:"webkitTransitionEnd",OTransition:"oTransitionEnd",msTransition:"transitionend",transition:"transitionend"};for(var e in t)0==this.transData.transProp&&null!=document.documentElement.style[e]&&(this.transData.transProp=e,this.transData.transEv=t[e]);t=null}return this.transData},_xmlNodeValue:function(t){for(var e="",n=0;n<t.childNodes.length;n++)e+=null!=t.childNodes[n].nodeValue?t.childNodes[n].nodeValue.toString().replace(/^[\n\r\s]{0,}/,"").replace(/[\n\r\s]{0,}$/,""):"";return e}},window.dhx4.isIE=navigator.userAgent.indexOf("MSIE")>=0||navigator.userAgent.indexOf("Trident")>=0,window.dhx4.isIE6=null==window.XMLHttpRequest&&navigator.userAgent.indexOf("MSIE")>=0,window.dhx4.isIE7=navigator.userAgent.indexOf("MSIE 7.0")>=0&&navigator.userAgent.indexOf("Trident")<0,window.dhx4.isIE8=navigator.userAgent.indexOf("MSIE 8.0")>=0&&navigator.userAgent.indexOf("Trident")>=0,window.dhx4.isIE9=navigator.userAgent.indexOf("MSIE 9.0")>=0&&navigator.userAgent.indexOf("Trident")>=0,window.dhx4.isIE10=navigator.userAgent.indexOf("MSIE 10.0")>=0&&navigator.userAgent.indexOf("Trident")>=0&&1!=window.navigator.pointerEnabled,window.dhx4.isIE11=navigator.userAgent.indexOf("Trident")>=0&&1==window.navigator.pointerEnabled,window.dhx4.isEdge=navigator.userAgent.indexOf("Edge")>=0,window.dhx4.isOpera=navigator.userAgent.indexOf("Opera")>=0,window.dhx4.isChrome=navigator.userAgent.indexOf("Chrome")>=0&&!window.dhx4.isEdge,window.dhx4.isKHTML=(navigator.userAgent.indexOf("Safari")>=0||navigator.userAgent.indexOf("Konqueror")>=0)&&!window.dhx4.isEdge,window.dhx4.isFF=navigator.userAgent.indexOf("Firefox")>=0,window.dhx4.isIPad=navigator.userAgent.search(/iPad/gi)>=0,window.dhx4.dnd={evs:{},p_en:(window.dhx4.isIE||window.dhx4.isEdge)&&(window.navigator.pointerEnabled||window.navigator.msPointerEnabled),_mTouch:function(t){return window.dhx4.isIE10&&t.pointerType==t.MSPOINTER_TYPE_MOUSE||window.dhx4.isIE11&&"mouse"==t.pointerType||window.dhx4.isEdge&&"mouse"==t.pointerType},_touchOn:function(t){null==t&&(t=document.body),t.style.touchAction=t.style.msTouchAction="",t=null},_touchOff:function(t){null==t&&(t=document.body),t.style.touchAction=t.style.msTouchAction="none",t=null}},1==window.navigator.pointerEnabled?window.dhx4.dnd.evs={start:"pointerdown",move:"pointermove",end:"pointerup"}:1==window.navigator.msPointerEnabled?window.dhx4.dnd.evs={start:"MSPointerDown",move:"MSPointerMove",end:"MSPointerUp"}:void 0!==window.addEventListener&&(window.dhx4.dnd.evs={start:"touchstart",move:"touchmove",end:"touchend"})),void 0===window.dhx4.template&&(window.dhx4.trim=function(t){return String(t).replace(/^\s{1,}/,"").replace(/\s{1,}$/,"")},window.dhx4.template=function(t,e,n){return t.replace(/#([a-z0-9_-]{1,})(\|([^#]*))?#/gi,function(){var t=arguments[1],i=window.dhx4.trim(arguments[3]),a=null,o=[e[t]];if(i.length>0){i=i.split(":");for(var r=[],s=0;s<i.length;s++)s>0&&null!=r[r.length-1].match(/\\$/)?r[r.length-1]=r[r.length-1].replace(/\\$/,"")+":"+i[s]:r.push(i[s]);a=r[0];for(s=1;s<r.length;s++)o.push(r[s])}return"string"==typeof a&&"function"==typeof window.dhx4.template[a]?window.dhx4.template[a].apply(window.dhx4.template,o):t.length>0&&void 0!==e[t]?1==n?window.dhx4.trim(e[t]):String(e[t]):""})},window.dhx4.template.date=function(t,e){return null!=t?t instanceof Date?window.dhx4.date2str(t,e):null!=(t=t.toString()).match(/^\d*$/)?window.dhx4.date2str(new Date(parseInt(t)),e):t:""},window.dhx4.template.maxlength=function(t,e){return String(t).substr(0,e)},window.dhx4.template.number_format=function(t,e,n,i){var a=window.dhx4.template._parseFmt(e,n,i);return 0==a?t:window.dhx4.template._getFmtValue(t,a)},window.dhx4.template.lowercase=function(t){return void 0!==t&&null!=t||(t=""),String(t).toLowerCase()},window.dhx4.template.uppercase=function(t){return void 0!==t&&null!=t||(t=""),String(t).toUpperCase()},window.dhx4.template._parseFmt=function(t,e,n){var i=t.match(/^([^\.\,0-9]*)([0\.\,]*)([^\.\,0-9]*)/);if(null==i||4!=i.length)return!1;var a={i_len:!1,i_sep:"string"==typeof e?e:",",d_len:!1,d_sep:"string"==typeof n?n:".",s_bef:"string"==typeof i[1]?i[1]:"",s_aft:"string"==typeof i[3]?i[3]:""},o=i[2].split(".");null!=o[1]&&(a.d_len=o[1].length);var r=o[0].split(",");return r.length>1&&(a.i_len=r[r.length-1].length),a},window.dhx4.template._getFmtValue=function(value,fmt){var r=String(value).match(/^(-)?([0-9]{1,})(\.([0-9]{1,}))?$/);if(null!=r&&5==r.length){var v0="";if(null!=r[1]&&(v0+=r[1]),v0+=fmt.s_bef,!1!==fmt.i_len){for(var i=0,v1="",q=r[2].length-1;q>=0;q--)v1=""+r[2].charAt(q)+v1,++i==fmt.i_len&&q>0&&(v1=fmt.i_sep+v1,i=0);v0+=v1}else v0+=r[2];if(!1!==fmt.d_len){for(null==r[4]&&(r[4]="");r[4].length<fmt.d_len;)r[4]+="0";eval("dhx4.temp = new RegExp(/\\d{"+fmt.d_len+"}/);");var t1=r[4].match(dhx4.temp);null!=t1&&(v0+=fmt.d_sep+t1),dhx4.temp=t1=null}return v0+=fmt.s_aft,v0}return value}),void 0===window.dhx4.dateLang&&(window.dhx4.dateLang="en",window.dhx4.dateStrings={en:{monthFullName:["January","February","March","April","May","June","July","August","September","October","November","December"],monthShortName:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayFullName:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayShortName:["Su","Mo","Tu","We","Th","Fr","Sa"]}},window.dhx4.dateFormat={en:"%Y-%m-%d"},window.dhx4.date2str=function(t,e,n){if(null!=e&&void 0!==e||(e=window.dhx4.dateFormat[window.dhx4.dateLang]),null!=n&&void 0!==n||(n=window.dhx4.dateStrings[window.dhx4.dateLang]),t instanceof Date)var i=function(t){return 1==String(t).length?"0"+String(t):t},a=String(e||window.dhx4.dateFormat).replace(/%[a-zA-Z]/g,function(e){switch(e){case"%d":return i(t.getDate());case"%j":return t.getDate();case"%D":return n.dayShortName[t.getDay()];case"%l":return n.dayFullName[t.getDay()];case"%m":return i(t.getMonth()+1);case"%n":return t.getMonth()+1;case"%M":return n.monthShortName[t.getMonth()];case"%F":return n.monthFullName[t.getMonth()];case"%y":return i(t.getYear()%100);case"%Y":return t.getFullYear();case"%g":return(t.getHours()+11)%12+1;case"%h":return i((t.getHours()+11)%12+1);case"%G":return t.getHours();case"%H":return i(t.getHours());case"%i":return i(t.getMinutes());case"%s":return i(t.getSeconds());case"%a":return t.getHours()>11?"pm":"am";case"%A":return t.getHours()>11?"PM":"AM";case"%%":return"%";case"%u":return t.getMilliseconds();case"%P":if(null!=window.dhx4.temp_calendar&&null!=window.dhx4.temp_calendar.tz)return window.dhx4.temp_calendar.tz;var a=t.getTimezoneOffset(),o=Math.abs(Math.floor(a/60)),r=Math.abs(a)-60*o;return(a>0?"-":"+")+i(o)+":"+i(r);default:return e}});return a||String(t)},window.dhx4.str2date=function(t,e,n){null!=e&&void 0!==e||(e=window.dhx4.dateFormat[window.dhx4.dateLang]),null!=n&&void 0!==n||(n=window.dhx4.dateStrings[window.dhx4.dateLang]);var i=[],a=[];e=(e=e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\\:|]/g,"\\$&")).replace(/%[a-z]/gi,function(t){switch(t){case"%d":case"%m":case"%y":case"%h":case"%H":case"%i":case"%s":return a.push(t),"(\\d{2})";case"%D":case"%l":case"%M":case"%F":return a.push(t),"([a-zéûäа-яё]{1,})";case"%j":case"%n":case"%g":case"%G":return a.push(t),"(\\d{1,2})";case"%Y":return a.push(t),"(\\d{4})";case"%a":return a.push(t),"([a|p]m)";case"%A":return a.push(t),"([A|P]M)";case"%u":return a.push(t),"(\\d{1,6})";case"%P":return a.push(t),"([+-]\\d{1,2}:\\d{1,2})"}return t});var o=new RegExp(e,"i"),r=t.match(o);if(null==r||r.length-1!=a.length)return"Invalid Date";for(var s=1;s<r.length;s++)i.push(r[s]);var l={"%y":1,"%Y":1,"%n":2,"%m":2,"%M":2,"%F":2,"%d":3,"%j":3,"%a":4,"%A":4,"%H":5,"%G":5,"%h":5,"%g":5,"%i":6,"%s":7,"%u":7,"%P":7},d={},c={};for(s=0;s<a.length;s++)if(void 0!==l[a[s]]){var h=l[a[s]];d[h]||(d[h]=[],c[h]=[]),d[h].push(i[s]),c[h].push(a[s])}i=[],a=[];for(s=1;s<=7;s++)if(null!=d[s])for(var u=0;u<d[s].length;u++)i.push(d[s][u]),a.push(c[s][u]);var m=new Date;m.setDate(1),m.setHours(0),m.setMinutes(0),m.setSeconds(0),m.setMilliseconds(0);var f=function(t,e){for(var n=0;n<e.length;n++)if(e[n].toLowerCase()==t)return n;return-1};for(s=0;s<i.length;s++)switch(a[s]){case"%d":case"%j":case"%n":case"%m":case"%Y":case"%H":case"%G":case"%i":case"%s":case"%u":isNaN(i[s])||m[{"%d":"setDate","%j":"setDate","%n":"setMonth","%m":"setMonth","%Y":"setFullYear","%H":"setHours","%G":"setHours","%i":"setMinutes","%s":"setSeconds","%u":"setMilliseconds"}[a[s]]](Number(i[s])+("%m"==a[s]||"%n"==a[s]?-1:0));break;case"%M":case"%F":var p=f(i[s].toLowerCase(),n[{"%M":"monthShortName","%F":"monthFullName"}[a[s]]]);p>=0&&m.setMonth(p);break;case"%y":if(!isNaN(i[s])){var _=Number(i[s]);m.setFullYear(_+(_>50?1900:2e3))}break;case"%g":case"%h":if(!isNaN(i[s]))(_=Number(i[s]))<=12&&_>=0&&m.setHours(_+(f("pm",i)>=0?12==_?0:12:12==_?-12:0));break;case"%P":null!=window.dhx4.temp_calendar&&(window.dhx4.temp_calendar.tz=i[s])}return m}),void 0===window.dhx4.ajax&&(window.dhx4.ajax={cache:!1,method:"get",parse:function(t){if("string"!=typeof t)return t;if(t=t.replace(/^[\s]+/,""),window.DOMParser&&!dhx4.isIE)var e=(new window.DOMParser).parseFromString(t,"text/xml");else window.ActiveXObject!==window.undefined&&((e=new window.ActiveXObject("Microsoft.XMLDOM")).async="false",e.loadXML(t));return e},xmltop:function(t,e,n){if((void 0===e.status||e.status<400)&&(xml=e.responseXML?e.responseXML||e:dhx4.ajax.parse(e.responseText||e),xml&&null!==xml.documentElement))try{if(!xml.getElementsByTagName("parsererror").length)return xml.getElementsByTagName(t)[0]}catch(t){}return-1!==n&&dhx4.callEvent("onLoadXMLError",["Incorrect XML",arguments[1],n]),document.createElement("DIV")},xpath:function(t,e){if(e.nodeName||(e=e.responseXML||e),!dhx4.isIE){for(var n,i=[],a=(e.ownerDocument||e).evaluate(t,e,null,XPathResult.ANY_TYPE,null);n=a.iterateNext();)i.push(n);return i}try{return e.selectNodes(t)||[]}catch(t){return[]}},query:function(t){return dhx4.ajax._call(t.method||"GET",t.url,t.data||"",t.async||!0,t.callback,null,t.headers)},get:function(t,e){return this._call("GET",t,null,!0,e)},getSync:function(t){return this._call("GET",t,null,!1)},put:function(t,e,n){return this._call("PUT",t,e,!0,n)},del:function(t,e,n){return this._call("DELETE",t,e,!0,n)},post:function(t,e,n){return 1==arguments.length?e="":2!=arguments.length||"function"!=typeof e&&"function"!=typeof window[e]?e=String(e):(n=e,e=""),this._call("POST",t,e,!0,n)},postSync:function(t,e){return e=null==e?"":String(e),this._call("POST",t,e,!1)},getLong:function(t,e){this._call("GET",t,null,!0,e,{url:t})},postLong:function(t,e,n){2!=arguments.length||"function"!=typeof e&&(window[e],0)||(n=e,e=""),this._call("POST",t,e,!0,n,{url:t,postData:e})},_call:function(t,e,n,i,a,o,r){if("object"==typeof n){var s=[];for(var l in n)s.push(l+"="+encodeURIComponent(n[l]));n=s.join("&")}var d=dhx.promise.defer(),c=window.XMLHttpRequest&&!dhx4.isIE?new XMLHttpRequest:new ActiveXObject("Microsoft.XMLHTTP"),h=null!=navigator.userAgent.match(/AppleWebKit/)&&null!=navigator.userAgent.match(/Qt/)&&null!=navigator.userAgent.match(/Safari/);if(1==i&&(c.onreadystatechange=function(){if(4==c.readyState||1==h&&3==c.readyState){if((200!=c.status||""==c.responseText)&&(d.reject(c),!dhx4.callEvent("onAjaxError",[{xmlDoc:c,filePath:e,async:i}])))return;window.setTimeout(function(){if("function"==typeof a){try{a.apply(window,[{xmlDoc:c,filePath:e,async:i}])}catch(t){d.reject(t)}d.resolve(c.responseText)}null!=o&&(void 0!==o.postData?dhx4.ajax.postLong(o.url,o.postData,a):dhx4.ajax.getLong(o.url,a)),a=null,c=null},1)}}),"GET"==t&&(e+=this._dhxr(e)),c.open(t,e,i),null!=r)for(var u in r)c.setRequestHeader(u,r[u]);else"POST"==t||"PUT"==t||"DELETE"==t?c.setRequestHeader("Content-Type","application/x-www-form-urlencoded"):"GET"==t&&(n=null);return c.setRequestHeader("X-Requested-With","XMLHttpRequest"),c.send(n),1!=i&&(4==c.readyState||1==h&&3==c.readyState)&&(200==c.status&&""!=c.responseText||dhx4.callEvent("onAjaxError",[{xmlDoc:c,filePath:e,async:i}])),d.xmlDoc=c,d.filePath=e,d.async=i,d},_dhxr:function(t,e){return 1!=this.cache?(null==t.match(/^[\?\&]$/)&&(t=t.indexOf("?")>=0?"&":"?"),void 0===e&&(e=!0),t+"dhxr"+(new Date).getTime()+(1==e?"=1":"")):""}}),void 0===window.dhx4._enableDataLoading&&(window.dhx4._enableDataLoading=function(t,e,n,i,a){if("clear"==a){for(var o in t._dhxdataload)t._dhxdataload[o]=null,delete t._dhxdataload[o];return t._loadData=null,t._dhxdataload=null,t.load=null,t.loadStruct=null,void(t=null)}if(t._dhxdataload={initObj:e,xmlToJson:n,xmlRootTag:i,onBeforeXLS:null},t._loadData=function(t,e,n){2==arguments.length&&(n=e,e=null);var i=null;if(3==arguments.length&&(n=arguments[2]),this.callEvent("onXLS",[]),"string"==typeof t){var a=t.replace(/^\s{1,}/,"").replace(/\s{1,}$/,"");if(new RegExp("^<"+this._dhxdataload.xmlRootTag).test(a.replace(/^<\?xml[^\?]*\?>\s*/,""))&&null!=(i=dhx4.ajax.parse(t))&&(i=this[this._dhxdataload.xmlToJson].apply(this,[i])),null!=i||null==a.match(/^[\s\S]*{[.\s\S]*}[\s\S]*$/)&&null==a.match(/^[\s\S]*\[[.\s\S]*\][\s\S]*$/)||(i=dhx4.s2j(a)),null==i){var o=[];if("function"==typeof this._dhxdataload.onBeforeXLS)if(null!=(a=this._dhxdataload.onBeforeXLS.apply(this,[t]))&&"object"==typeof a&&(null!=a.url&&(t=a.url),null!=a.params))for(var r in a.params)o.push(r+"="+encodeURIComponent(a.params[r]));var s=this,l=function(e){var i=null;null!=(i=(e.xmlDoc.getResponseHeader("Content-Type")||"").search(/xml/gi)>=0||null!=e.xmlDoc.responseText.replace(/^\s{1,}/,"").match(/^</)?s[s._dhxdataload.xmlToJson].apply(s,[e.xmlDoc.responseXML]):dhx4.s2j(e.xmlDoc.responseText))&&s[s._dhxdataload.initObj].apply(s,[i,t]),s.callEvent("onXLE",[]),null!=n&&("function"==typeof n?n.apply(s,[]):"function"==typeof window[n]&&window[n].apply(s,[])),l=n=null,i=e=s=null};return o=o.join("&")+("string"==typeof e?"&"+e:""),"post"==dhx4.ajax.method?dhx4.ajax.post(t,o,l):"get"==dhx4.ajax.method?dhx4.ajax.get(t+(o.length>0?(t.indexOf("?")>0?"&":"?")+o:""),l):void 0}}else i="object"==typeof t.documentElement||void 0!==t.tagName&&void 0!==t.getElementsByTagName&&t.getElementsByTagName(this._dhxdataload.xmlRootTag).length>0?this[this._dhxdataload.xmlToJson].apply(this,[t]):window.dhx4._copyObj(t);null!=i&&this[this._dhxdataload.initObj].apply(this,[i]),this.callEvent("onXLE",[]),null!=n&&("function"==typeof n?n.apply(this,[]):"function"==typeof window[n]&&window[n].apply(this,[]),n=null)},null!=a){var r={struct:"loadStruct",data:"load"};for(var o in a)1==a[o]&&(t[r[o]]=function(){return this._loadData.apply(this,arguments)})}t=null}),void 0===window.dhx4._eventable&&(window.dhx4._eventable=function(t,e){if("clear"==e)return t.detachAllEvents(),t.dhxevs=null,t.attachEvent=null,t.detachEvent=null,t.checkEvent=null,t.callEvent=null,t.detachAllEvents=null,void(t=null);t.dhxevs={data:{}},t.attachEvent=function(t,e){t=String(t).toLowerCase(),this.dhxevs.data[t]||(this.dhxevs.data[t]={});var n=window.dhx4.newId();return this.dhxevs.data[t][n]=e,n},t.detachEvent=function(t){for(var e in this.dhxevs.data){var n=0;for(var i in this.dhxevs.data[e])i==t?(this.dhxevs.data[e][i]=null,delete this.dhxevs.data[e][i]):n++;0==n&&(this.dhxevs.data[e]=null,delete this.dhxevs.data[e])}},t.checkEvent=function(t){return t=String(t).toLowerCase(),null!=this.dhxevs.data[t]},t.callEvent=function(t,e){if(t=String(t).toLowerCase(),null==this.dhxevs.data[t])return!0;var n=!0;for(var i in this.dhxevs.data[t])n=this.dhxevs.data[t][i].apply(this,e)&&n;return n},t.detachAllEvents=function(){for(var t in this.dhxevs.data){for(var e in this.dhxevs.data[t])this.dhxevs.data[t][e]=null,delete this.dhxevs.data[t][e];this.dhxevs.data[t]=null,delete this.dhxevs.data[t]}},t=null},dhx4._eventable(dhx4)),window.dhtmlxValidation||(dhtmlxValidation=function(){},dhtmlxValidation.prototype={isEmpty:function(t){return""==t},isNotEmpty:function(t){return t instanceof Array?t.length>0:""==!t},isValidBoolean:function(t){return!!t.toString().match(/^(0|1|true|false)$/)},isValidEmail:function(t){return!!t.toString().match(/(^[a-z0-9]([0-9a-z\-_\.]*)@([0-9a-z_\-\.]*)([.][a-z]{3})$)|(^[a-z]([0-9a-z_\.\-]*)@([0-9a-z_\-\.]*)(\.[a-z]{2,5})$)/i)},isValidInteger:function(t){return!!t.toString().match(/(^-?\d+$)/)},isValidNumeric:function(t){return!!t.toString().match(/(^-?\d\d*[\.|,]\d*$)|(^-?\d\d*$)|(^-?[\.|,]\d\d*$)/)},isValidAplhaNumeric:function(t){return!!t.toString().match(/^[_\-a-z0-9]+$/gi)},isValidDatetime:function(t){var e=t.toString().match(/^(\d{4})-(\d{2})-(\d{2})\s(\d{2}):(\d{2}):(\d{2})$/);return e&&!!(e[1]<=9999&&e[2]<=12&&e[3]<=31&&e[4]<=59&&e[5]<=59&&e[6]<=59)||!1},isValidDate:function(t){var e=t.toString().match(/^(\d{4})-(\d{2})-(\d{2})$/);return e&&!!(e[1]<=9999&&e[2]<=12&&e[3]<=31)||!1},isValidTime:function(t){var e=t.toString().match(/^(\d{1,2}):(\d{1,2}):(\d{1,2})$/);return e&&!!(e[1]<=24&&e[2]<=59&&e[3]<=59)||!1},isValidIPv4:function(t){var e=t.toString().match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);return e&&!!(e[1]<=255&&e[2]<=255&&e[3]<=255&&e[4]<=255)||!1},isValidCurrency:function(t){return!!t.toString().match(/^\$?\s?\d+?([\.,\,]?\d+)?\s?\$?$/)},isValidSSN:function(t){return!!t.toString().match(/^\d{3}\-?\d{2}\-?\d{4}$/)},isValidSIN:function(t){return!!t.toString().match(/^\d{9}$/)}},dhtmlxValidation=new dhtmlxValidation),void 0===window.dhtmlx&&(window.dhtmlx={extend:function(t,e){for(var n in e)t[n]||(t[n]=e[n]);return t},extend_api:function(t,e,n){var i=window[t];i&&(window[t]=function(t){if(t&&"object"==typeof t&&!t.tagName){var n=i.apply(this,e._init?e._init(t):arguments);for(var a in dhtmlx)e[a]&&this[e[a]](dhtmlx[a]);for(var a in t)e[a]?this[e[a]](t[a]):0===a.indexOf("on")&&this.attachEvent(a,t[a])}else n=i.apply(this,arguments);return e._patch&&e._patch(this),n||this},window[t].prototype=i.prototype,n&&dhtmlx.extend(window[t].prototype,n))},url:function(t){return-1!=t.indexOf("?")?"&":"?"}}),dhtmlDragAndDropObject.prototype.removeDraggableItem=function(t){t.onmousedown=null,t.dragStarter=null,t.dragLanding=null},dhtmlDragAndDropObject.prototype.addDraggableItem=function(t,e){t.onmousedown=this.preCreateDragCopy,t.dragStarter=e,this.addDragLanding(t,e)},dhtmlDragAndDropObject.prototype.addDragLanding=function(t,e){t.dragLanding=e},dhtmlDragAndDropObject.prototype.preCreateDragCopy=function(t){if(!t&&!window.event||2!=(t||event).button)return window.dhtmlDragAndDrop.waitDrag?(window.dhtmlDragAndDrop.waitDrag=0,document.body.onmouseup=window.dhtmlDragAndDrop.tempDOMU,document.body.onmousemove=window.dhtmlDragAndDrop.tempDOMM,!1):(window.dhtmlDragAndDrop.dragNode&&window.dhtmlDragAndDrop.stopDrag(t),window.dhtmlDragAndDrop.waitDrag=1,window.dhtmlDragAndDrop.tempDOMU=document.body.onmouseup,window.dhtmlDragAndDrop.tempDOMM=document.body.onmousemove,window.dhtmlDragAndDrop.dragStartNode=this,window.dhtmlDragAndDrop.dragStartObject=this.dragStarter,document.body.onmouseup=window.dhtmlDragAndDrop.preCreateDragCopy,document.body.onmousemove=window.dhtmlDragAndDrop.callDrag,window.dhtmlDragAndDrop.downtime=(new Date).valueOf(),!(!t||!t.preventDefault)&&(t.preventDefault(),!1))},dhtmlDragAndDropObject.prototype.callDrag=function(t){if(t||(t=window.event),dragger=window.dhtmlDragAndDrop,!((new Date).valueOf()-dragger.downtime<100)){if(!dragger.dragNode){if(!dragger.waitDrag)return dragger.stopDrag(t,!0);if(dragger.dragNode=dragger.dragStartObject._createDragNode(dragger.dragStartNode,t),!dragger.dragNode)return dragger.stopDrag();dragger.dragNode.onselectstart=function(){return!1},dragger.gldragNode=dragger.dragNode,document.body.appendChild(dragger.dragNode),document.body.onmouseup=dragger.stopDrag,dragger.waitDrag=0,dragger.dragNode.pWindow=window,dragger.initFrameRoute()}if(dragger.dragNode.parentNode!=window.document.body&&dragger.gldragNode){var e=dragger.gldragNode;dragger.gldragNode.old&&(e=dragger.gldragNode.old),e.parentNode.removeChild(e);var n=dragger.dragNode.pWindow;if(e.pWindow&&e.pWindow.dhtmlDragAndDrop.lastLanding&&e.pWindow.dhtmlDragAndDrop.lastLanding.dragLanding._dragOut(e.pWindow.dhtmlDragAndDrop.lastLanding),_isIE){var i=document.createElement("Div");i.innerHTML=dragger.dragNode.outerHTML,dragger.dragNode=i.childNodes[0]}else dragger.dragNode=dragger.dragNode.cloneNode(!0);dragger.dragNode.pWindow=window,dragger.gldragNode.old=dragger.dragNode,document.body.appendChild(dragger.dragNode),n.dhtmlDragAndDrop.dragNode=dragger.dragNode}if(dragger.dragNode.style.left=t.clientX+15+(dragger.fx?-1*dragger.fx:0)+(document.body.scrollLeft||document.documentElement.scrollLeft)+"px",dragger.dragNode.style.top=t.clientY+3+(dragger.fy?-1*dragger.fy:0)+(document.body.scrollTop||document.documentElement.scrollTop)+"px",t.srcElement)a=t.srcElement;else var a=t.target;dragger.checkLanding(a,t)}},dhtmlDragAndDropObject.prototype.calculateFramePosition=function(t){if(window.name){for(var e=parent.frames[window.name].frameElement.offsetParent,n=0,i=0;e;)n+=e.offsetLeft,i+=e.offsetTop,e=e.offsetParent;if(parent.dhtmlDragAndDrop){var a=parent.dhtmlDragAndDrop.calculateFramePosition(1);n+=1*a.split("_")[0],i+=1*a.split("_")[1]}if(t)return n+"_"+i;this.fx=n,this.fy=i}return"0_0"},dhtmlDragAndDropObject.prototype.checkLanding=function(t,e){t&&t.dragLanding?(this.lastLanding&&this.lastLanding.dragLanding._dragOut(this.lastLanding),this.lastLanding=t,this.lastLanding=this.lastLanding.dragLanding._dragIn(this.lastLanding,this.dragStartNode,e.clientX,e.clientY,e),this.lastLanding_scr=_isIE?e.srcElement:e.target):t&&"BODY"!=t.tagName?this.checkLanding(t.parentNode,e):(this.lastLanding&&this.lastLanding.dragLanding._dragOut(this.lastLanding,e.clientX,e.clientY,e),this.lastLanding=0,this._onNotFound&&this._onNotFound())},dhtmlDragAndDropObject.prototype.stopDrag=function(t,e){if(dragger=window.dhtmlDragAndDrop,!e){dragger.stopFrameRoute();var n=dragger.lastLanding;dragger.lastLanding=null,n&&n.dragLanding._drag(dragger.dragStartNode,dragger.dragStartObject,n,_isIE?event.srcElement:t.target)}dragger.lastLanding=null,dragger.dragNode&&dragger.dragNode.parentNode==document.body&&dragger.dragNode.parentNode.removeChild(dragger.dragNode),dragger.dragNode=0,dragger.gldragNode=0,dragger.fx=0,dragger.fy=0,dragger.dragStartNode=0,dragger.dragStartObject=0,document.body.onmouseup=dragger.tempDOMU,document.body.onmousemove=dragger.tempDOMM,dragger.tempDOMU=null,dragger.tempDOMM=null,dragger.waitDrag=0},dhtmlDragAndDropObject.prototype.stopFrameRoute=function(t){t&&window.dhtmlDragAndDrop.stopDrag(1,1);for(var e=0;e<window.frames.length;e++)try{window.frames[e]!=t&&window.frames[e].dhtmlDragAndDrop&&window.frames[e].dhtmlDragAndDrop.stopFrameRoute(window)}catch(t){}try{parent.dhtmlDragAndDrop&&parent!=window&&parent!=t&&parent.dhtmlDragAndDrop.stopFrameRoute(window)}catch(t){}},dhtmlDragAndDropObject.prototype.initFrameRoute=function(t,e){t&&(window.dhtmlDragAndDrop.preCreateDragCopy(),window.dhtmlDragAndDrop.dragStartNode=t.dhtmlDragAndDrop.dragStartNode,window.dhtmlDragAndDrop.dragStartObject=t.dhtmlDragAndDrop.dragStartObject,window.dhtmlDragAndDrop.dragNode=t.dhtmlDragAndDrop.dragNode,window.dhtmlDragAndDrop.gldragNode=t.dhtmlDragAndDrop.dragNode,window.document.body.onmouseup=window.dhtmlDragAndDrop.stopDrag,window.waitDrag=0,!_isIE&&e&&(!_isFF||_FFrv<1.8)&&window.dhtmlDragAndDrop.calculateFramePosition());try{parent.dhtmlDragAndDrop&&parent!=window&&parent!=t&&parent.dhtmlDragAndDrop.initFrameRoute(window)}catch(t){}for(var n=0;n<window.frames.length;n++)try{window.frames[n]!=t&&window.frames[n].dhtmlDragAndDrop&&window.frames[n].dhtmlDragAndDrop.initFrameRoute(window,!t||e?1:0)}catch(t){}},_isFF=!1,_isIE=!1,_isOpera=!1,_isKHTML=!1,_isMacOS=!1,_isChrome=!1,_FFrv=!1,_KHTMLrv=!1,_OperaRv=!1,-1!=navigator.userAgent.indexOf("Macintosh")&&(_isMacOS=!0),navigator.userAgent.toLowerCase().indexOf("chrome")>-1&&(_isChrome=!0),-1!=navigator.userAgent.indexOf("Safari")||-1!=navigator.userAgent.indexOf("Konqueror")?(_KHTMLrv=parseFloat(navigator.userAgent.substr(navigator.userAgent.indexOf("Safari")+7,5)),_KHTMLrv>525?(_isFF=!0,_FFrv=1.9):_isKHTML=!0):-1!=navigator.userAgent.indexOf("Opera")?(_isOpera=!0,_OperaRv=parseFloat(navigator.userAgent.substr(navigator.userAgent.indexOf("Opera")+6,3))):-1!=navigator.appName.indexOf("Microsoft")?(_isIE=!0,(-1!=navigator.appVersion.indexOf("MSIE 8.0")||-1!=navigator.appVersion.indexOf("MSIE 9.0")||-1!=navigator.appVersion.indexOf("MSIE 10.0")||document.documentMode>7)&&"BackCompat"!=document.compatMode&&(_isIE=8)):"Netscape"==navigator.appName&&-1!=navigator.userAgent.indexOf("Trident")?_isIE=8:(_isFF=!0,_FFrv=parseFloat(navigator.userAgent.split("rv:")[1])),void 0===window.dhtmlxEvent)function dhtmlxEvent(t,e,n){t.addEventListener?t.addEventListener(e,n,!1):t.attachEvent&&t.attachEvent("on"+e,n)}var a,globalActiveDHTMLGridObject,c;function dhtmlXCellObject(t,e){this.cell=document.createElement("DIV"),this.cell.className="dhx_cell"+(e||""),this._idd=t,this._isCell=!0,this.conf={borders:!0,idx:{},css:e||"",idx_data:{cont:"dhx_cell_cont",pr1:"dhx_cell_progress_bar",pr2:"dhx_cell_progress_img",pr3:"dhx_cell_progress_svg",menu:"dhx_cell_menu",toolbar:"dhx_cell_toolbar",ribbon:"dhx_cell_ribbon",sb:"dhx_cell_statusbar",cover:"dhx_cell_cover"},ofs_nodes:{t:{},b:{}}},this.dataNodes={},this.views={};var n=document.createElement("DIV");return n.className="dhx_cell_cont"+this.conf.css,this.cell.appendChild(n),n=null,this._updateIdx=function(){for(var t in this.conf.idx)this.conf.idx[t]=null,delete this.conf.idx[t];for(var e=0;e<this.cell.childNodes.length;e++){var n=this.cell.childNodes[e].className;for(var t in this.conf.idx_data){var i=new RegExp(this.conf.idx_data[t]);null!=n.match(i)&&(this.conf.idx[t]=e)}}this.callEvent("_onIdxUpdated",[])},this._adjustAttached=function(){for(var t in this.dataNodes)null!=this.dataNodes[t]&&"function"==typeof this.dataNodes[t].setSizes&&this.dataNodes[t].setSizes();if(null!=this.dataObj&&"function"==typeof this.dataObj.setSizes){if("layout"==this.dataType&&"function"==typeof window.dhtmlXLayoutCell&&this instanceof window.dhtmlXLayoutCell&&this.dataObj._getMainInst()!=this.layout._getMainInst())return void this.dataObj.setSizes();this.dataObj.setSizes.apply(this.dataObj,arguments)}},this._setSize=function(t,e,n,i,a,o,r,s){null==this.conf.size&&(this.conf.size={}),null==s&&(s={});var l={left:"x",top:"y",width:"w",height:"h"};for(var d in this.conf.size.x=t,this.conf.size.y=e,this.conf.size.w=Math.max(n,0),this.conf.size.h=Math.max(i,0),l){var c=s[d]||d;this.cell.style[c]=this.conf.size[l[d]]+"px"}this.callEvent("_onSetSize",[]),!0!==o?this._adjustCont(a,r):this._adjustAttached(a),this._adjustProgress()},this._adjustCont=function(t,e){var n=this.cell.childNodes[this.conf.idx.cont];if("function"==typeof window.dhtmlXLayoutCell&&this instanceof window.dhtmlXLayoutCell&&1==this.conf.collapsed)return n.style.left=n.style.top="0px",n.style.width=n.style.height="200px",void(n=null);var i=0;for(var a in this.conf.ofs_nodes.t){i+="func"==(r=this.conf.ofs_nodes.t[a])?this[a]():1==r?this.cell.childNodes[this.conf.idx[a]].offsetHeight:0}var o=0;for(var a in this.conf.ofs_nodes.b){var r;o+="func"==(r=this.conf.ofs_nodes.b[a])?this[a]():1==r?this.cell.childNodes[this.conf.idx[a]].offsetHeight:0}n.style.left="0px",n.style.top=i+"px",null==this.conf.cells_cont&&(this.conf.cells_cont={},n.style.width=this.cell.offsetWidth+"px",n.style.height=Math.max(this.cell.offsetHeight-i-o,0)+"px",this.conf.cells_cont.w=parseInt(n.style.width)-n.offsetWidth,this.conf.cells_cont.h=parseInt(n.style.height)-n.offsetHeight),n.style.left="0px",n.style.top=i+"px",n.style.width=Math.max(this.cell.offsetWidth+this.conf.cells_cont.w,0)+"px",n.style.height=Math.max(this.conf.size.h-i-o+this.conf.cells_cont.h,0)+"px",n=null,this._adjustAttached(t),"expand"==e&&"editor"==this.dataType&&null!=this.dataObj&&this.dataObj._prepareContent(!0)},this._mtbUpdBorder=function(){for(var t=["menu","toolbar","ribbon"],e=0;e<t.length;e++)if(null!=this.conf.idx[t[e]]){var n=this.cell.childNodes[this.conf.idx[t[e]]],i="dhx_cell_"+t[e]+"_no_borders",a="dhx_cell_"+t[e]+"_def";n.className=n.className.replace(new RegExp(this.conf.borders?i:a),this.conf.borders?a:i),n=null}},this._resetSizeState=function(){this.conf.cells_cont=null},this.conf.view="def",this.conf.views_loaded={},this.conf.views_loaded[this.conf.view]=!0,this._viewSave=function(t){this.views[t]={borders:this.conf.borders,ofs_nodes:{t:{},b:{}},url_data:this.conf.url_data,dataType:this.dataType,dataObj:this.dataObj,cellCont:[],dataNodes:{},dataNodesCont:{}};for(var e=this.cell.childNodes[this.conf.idx.cont];e.childNodes.length>0;)this.views[t].cellCont.push(e.firstChild),e.removeChild(e.firstChild);for(var n in e=null,this.dataType=null,this.dataObj=null,this.conf.url_data=null,this.dataNodes){for(var i in this.conf.ofs_nodes)void 0!==this.conf.ofs_nodes[i][n]&&(this.views[t].ofs_nodes[i][n]=this.conf.ofs_nodes[i][n],this.conf.ofs_nodes[i][n]=null,delete this.conf.ofs_nodes[i][n]);this.views[t].dataNodesCont[n]=this.cell.childNodes[this.conf.idx[n]],this.cell.removeChild(this.cell.childNodes[this.conf.idx[n]]),this.views[t].dataNodes[n]=this.dataNodes[n],this.dataNodes[n]=null,delete this.dataNodes[n],this._updateIdx()}this.callEvent("_onViewSave",[t])},this._viewRestore=function(t){if(null!=this.views[t]){this.dataObj=this.views[t].dataObj,this.dataType=this.views[t].dataType,this.conf.url_data=this.views[t].url_data;for(var e=0;e<this.views[t].cellCont.length;e++)this.cell.childNodes[this.conf.idx.cont].appendChild(this.views[t].cellCont[e]);for(var n in this.views[t].dataNodes)this.dataNodes[n]=this.views[t].dataNodes[n],"menu"==n&&this.cell.insertBefore(this.views[t].dataNodesCont[n],this.cell.childNodes[this.conf.idx.toolbar||this.conf.idx.cont]),"toolbar"==n&&this.cell.insertBefore(this.views[t].dataNodesCont[n],this.cell.childNodes[this.conf.idx.cont]),"ribbon"==n&&this.cell.insertBefore(this.views[t].dataNodesCont[n],this.cell.childNodes[this.conf.idx.cont]),"sb"==n&&this.cell.appendChild(this.views[t].dataNodesCont[n]),this._updateIdx();for(var n in this.views[t].ofs_nodes)for(var i in this.views[t].ofs_nodes[n])this.conf.ofs_nodes[n][i]=this.views[t].ofs_nodes[n][i];this.conf.borders!=this.views[t].borders&&this[this.views[t].borders?"_showBorders":"_hideBorders"](!0),"url"==this.dataType&&null!=this.conf.url_data&&0==this.conf.url_data.ajax&&null!=this.conf.url_data.post_data&&this.reloadURL(),this.callEvent("_onViewRestore",[t]),this._viewDelete(t)}},this._viewDelete=function(t){if(null!=this.views[t]){for(var e in this.views[t].borders=null,this.views[t].ofs_nodes){for(var n in this.views[t].ofs_nodes[e])this.views[t].ofs_nodes[e][n]=null;this.views[t].ofs_nodes[e]=null}this.views[t].dataType=null,this.views[t].dataObj=null,this.views[t].url_data=null;for(var i=0;i<this.views[t].cellCont.length;i++)this.views[t].cellCont[i]=null;for(var e in this.views[t].cellCont=null,this.views[t].dataNodes)this.views[t].dataNodes[e]=null,this.views[t].dataNodesCont[e]=null;this.views[t].dataNodes=this.views[t].dataNodesCont=null,this.views[t]=null,delete this.views[t]}},window.dhx4._eventable(this),this._updateIdx(),this}function dhtmlXCellTop(t,e){if(0!=arguments.length&&void 0!==t){var n=this;if(this.dataNodes={},this.conf.ofs={t:0,b:0,l:0,r:0},this.conf.ofs_nodes={t:{},b:{}},this.conf.progress=!1,this.conf.fs_mode=!1,this.conf.fs_tm=null,this.conf.fs_resize=!1,t==document.body){if(this.conf.fs_mode=!0,this.base=t,this.base==document.body){var i={dhx_skyblue:{t:2,b:2,l:2,r:2},dhx_web:{t:8,b:8,l:8,r:8},dhx_terrace:{t:9,b:9,l:8,r:8},material:{t:9,b:9,l:8,r:8}};this.conf.ofs=null!=i[this.conf.skin]?i[this.conf.skin]:i.dhx_skyblue}}else this.base="string"==typeof t?document.getElementById(t):t;if(this.base.className+=" "+this.conf.css+"_base_"+this.conf.skin,this.cont=document.createElement("DIV"),this.cont.className=this.conf.css+"_cont",this.base.appendChild(this.cont),null!=e)this.setOffsets(e,!1);else if(null!=this.base._ofs){this.setOffsets(this.base._ofs,!1),this.base._ofs=null;try{delete this.base._ofs}catch(t){}}this._adjustCont=function(){var t=this.conf.ofs.t;for(var e in this.conf.ofs_nodes.t)t+=1==this.conf.ofs_nodes.t[e]?this.dataNodes[e].offsetHeight:0;var n=this.conf.ofs.b;for(var e in this.conf.ofs_nodes.b)n+=1==this.conf.ofs_nodes.b[e]?this.dataNodes[e].offsetHeight:0;this.cont.style.left=this.conf.ofs.l+"px",this.cont.style.width=this.base.clientWidth-this.conf.ofs.l-this.conf.ofs.r+"px",this.cont.style.top=t+"px",this.cont.style.height=this.base.clientHeight-t-n+"px"},this._setBaseSkin=function(t){this.base.className=this.base.className.replace(new RegExp(this.conf.css+"_base_"+this.conf.skin,"gi"),this.conf.css+"_base_"+t)},this._initFSResize=function(){1!=this.conf.fs_resize&&(this._doOnResizeStart=function(){window.clearTimeout(n.conf.fs_tm),n.conf.fs_tm=window.setTimeout(n._doOnResizeEnd,200)},this._doOnResizeEnd=function(){n.setSizes()},"function"==typeof window.addEventListener?window.addEventListener("resize",this._doOnResizeStart,!1):window.attachEvent("onresize",this._doOnResizeStart),this.conf.fs_resize=!0)},1==this.conf.fs_mode&&this._initFSResize(),this._unloadTop=function(){this._mtbUnload(),this.detachHeader(),this.detachFooter(),1==this.conf.fs_mode&&("function"==typeof window.addEventListener?window.removeEventListener("resize",this._doOnResizeStart,!1):window.detachEvent("onresize",this._doOnResizeStart)),this.base.removeChild(this.cont);var t=new RegExp("s{0,}"+this.conf.css+"_base_"+this.conf.skin,"gi");this.base.className=this.base.className.replace(t,""),this.cont=this.base=null,n=null},t=null}}function dhtmlXCalendarObject(t,e){this.i={};var n=null;if("string"==typeof t)var i=document.getElementById(t);else i=t;i&&"object"==typeof i&&i.tagName&&"input"!=String(i.tagName).toLowerCase()&&(n=i),i=null,"object"==typeof t&&t.length||(t=[t]);for(var a=0;a<t.length;a++)"string"==typeof t[a]&&(t[a]=document.getElementById(t[a])||null),null!=t[a]&&t[a].tagName&&"input"==String(t[a].tagName).toLowerCase()?this.i[window.dhx4.newId()]={input:t[a]}:t[a]instanceof Array||!(t[a]instanceof Object)||null==t[a].input&&null==t[a].button||(null!=t[a].input&&"string"==typeof t[a].input&&(t[a].input=document.getElementById(t[a].input)),null!=t[a].button&&"string"==typeof t[a].button&&(t[a].button=document.getElementById(t[a].button)),this.i[window.dhx4.newId()]=t[a]),t[a]=null;this.conf={skin:e||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhtmlxcalendar")||"material",zi:window.dhx4.newId(),touch:!window.dhx4.isIE,time:!0,today:!1,ws_first:!0},this.setSkin=function(t,e){(this.conf.skin!=t||e)&&(this.conf.skin=t,this.base.className="dhtmlxcalendar_"+this.conf.skin,this._ifrSize())},this.base=document.createElement("DIV"),this.base.style.display="none",this.base.appendChild(document.createElement("DIV")),null!=n?(this._hasParent=!0,n.appendChild(this.base),n=null):document.body.appendChild(this.base),this.setParent=function(t){this._hasParent&&("object"==typeof t?t.appendChild(this.base):"string"==typeof t&&document.getElementById(t).appendChild(this.base))},this.setSkin(this.conf.skin,!0),this.base.onclick=function(t){(t=t||event).preventDefault&&t.preventDefault(),t.cancelBubble=!0},this.base.onmousedown=function(){return!1},this.conf.touch&&(this.base.ontouchstart=this.base.onclick),this.loadUserLanguage=function(t){if(this.langData[t]){if(this.lang=t,this.setWeekStartDay(this.langData[this.lang].weekstart),this.setDateFormat(this.langData[this.lang].dateformat||"%Y-%m-%d"),this.msCont)for(var e=0,n=0;n<this.msCont.childNodes.length;n++)for(var i=0;i<this.msCont.childNodes[n].childNodes.length;i++)this.msCont.childNodes[n].childNodes[i].innerHTML=this.langData[this.lang].monthesSNames[e++];this.contTime.childNodes[0].childNodes[0].childNodes[5].innerHTML=this.langData[this.lang].today,this.contTime.childNodes[0].childNodes[0].childNodes[4].innerHTML=this.langData[this.lang].clear}},this.contMonth=document.createElement("DIV"),this.contMonth.className="dhtmlxcalendar_month_cont",this.contMonth.onselectstart=function(t){return(t=t||event).cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1},this.base.firstChild.appendChild(this.contMonth),(r=document.createElement("UL")).className="dhtmlxcalendar_line",this.contMonth.appendChild(r),(l=document.createElement("LI")).className="dhtmlxcalendar_cell dhtmlxcalendar_month_hdr",l.innerHTML="<div class='dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left' onmouseover='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left_hover\";' onmouseout='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left\";'></div><span></span><div class='dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right' onmouseover='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right_hover\";' onmouseout='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right\";'></div>",r.appendChild(l);var o=this;l.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;if(e.className&&0===e.className.indexOf("dhtmlxcalendar_month_arrow")){o._hideSelector();var n=e.parentNode.firstChild==e?-1:1,i=new Date(o._activeMonth);return o._drawMonth(new Date(o._activeMonth.getFullYear(),o._activeMonth.getMonth()+n,1,0,0,0,0)),void o._evOnArrowClick([i,new Date(o._activeMonth)])}return e.className&&"dhtmlxcalendar_month_label_month"==e.className?(t.cancelBubble=!0,void o._showSelector("month",Math.round(e.offsetLeft+e.offsetWidth/2),e.offsetTop+e.offsetHeight+2,"selector_month",!0)):e.className&&"dhtmlxcalendar_month_label_year"==e.className?(t.cancelBubble=!0,void o._showSelector("year",Math.round(e.offsetLeft+e.offsetWidth/2),e.offsetTop+e.offsetHeight+2,"selector_year",!0)):void o._hideSelector()},1==this.conf.touch&&(l.ontouchstart=l.onclick),this.contDays=document.createElement("DIV"),this.contDays.className="dhtmlxcalendar_days_cont",this.base.firstChild.appendChild(this.contDays),this.setWeekStartDay=function(t){0==t&&(t=7),this._wStart=Math.min(Math.max(isNaN(t)?1:t,1),7),this._drawDaysOfWeek()},this._drawDaysOfWeek=function(){if(0==this.contDays.childNodes.length)(t=document.createElement("UL")).className="dhtmlxcalendar_line",this.contDays.appendChild(t);else var t=this.contDays.firstChild;var e=this._wStart,n=this.langData[this.lang].daysSNames;n.push(String(this.langData[this.lang].daysSNames[0]).valueOf());for(var i=0;i<8;i++){if(null==t.childNodes[i]){var a=document.createElement("LI");t.appendChild(a)}else a=t.childNodes[i];0==i?(a.className="dhtmlxcalendar_cell_wn",a.innerHTML="<div class='dhtmlxcalendar_label'>"+(this.langData[this.lang].weekname||"w")+"</div>"):(a.className="dhtmlxcalendar_cell"+(e>=6?" dhtmlxcalendar_day_weekday_cell":"")+(1==i?"_first":""),a.innerHTML=n[e],++e>7&&(e=1))}null!=this._activeMonth&&this._drawMonth(this._activeMonth)},this._wStart=this.langData[this.lang].weekstart,this.setWeekStartDay(this._wStart),this.contDates=document.createElement("DIV"),this.contDates.className="dhtmlxcalendar_dates_cont",this.base.firstChild.appendChild(this.contDates),this.contDates.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;if(null!=e.parentNode&&null!=e.parentNode._date&&(e=e.parentNode),null!=e._date&&!e._css_dis){var n=o._activeDate.getHours(),i=o._activeDate.getMinutes(),a=e._date;if(o.checkEvent("onBeforeChange")&&!o.callEvent("onBeforeChange",[new Date(e._date.getFullYear(),e._date.getMonth(),e._date.getDate(),n,i)]))return;null!=o._activeDateCell&&(o._activeDateCell._css_date=!1,o._updateCellStyle(o._activeDateCell._q,o._activeDateCell._w));var r=o._activeDate.getFullYear()+"_"+o._activeDate.getMonth()!=a.getFullYear()+"_"+a.getMonth();o._nullDate=!1,o._activeDate=new Date(a.getFullYear(),a.getMonth(),a.getDate(),n,i),o._activeDateCell=e,o._activeDateCell._css_date=!0,o._activeDateCell._css_hover=!1,o._updateCellStyle(o._activeDateCell._q,o._activeDateCell._w),r&&o._drawMonth(o._activeDate),o._updateInp(),o._hasParent||("touchstart"==t.type?window.setTimeout(function(){o._hide()},400):o._hide()),o._evOnClick([new Date(o._activeDate.getTime())]),o._doOnSelectorChange(!0)}},1==this.conf.touch&&(this.contDates.ontouchstart=this.contDates.onclick),this.contDates.onmouseover=function(t){var e=(t=t||event).target||t.srcElement;if(null!=e.parentNode&&null!=e.parentNode._date&&(e=e.parentNode),null!=e._date){if(o._lastHover==e||e._css_hover)return;e._css_hover=!0,o._updateCellStyle(e._q,e._w),o._lastHover=e,o._evOnMouseOver([new Date(e._date.getFullYear(),e._date.getMonth(),e._date.getDate(),0,0,0,0),t]),e=null}},this.contDates.onmouseout=function(t){o._clearDayHover(t||event)},this._lastHover=null,this._clearDayHover=function(t){this._lastHover&&(this._lastHover._css_hover=!1,this._updateCellStyle(this._lastHover._q,this._lastHover._w),null!=t&&o._evOnMouseOut([new Date(this._lastHover._date.getFullYear(),this._lastHover._date.getMonth(),this._lastHover._date.getDate(),0,0,0,0),t]),this._lastHover=null)};for(a=0;a<6;a++){var r;(r=document.createElement("UL")).className="dhtmlxcalendar_line",this.contDates.appendChild(r);for(var s=0;s<=7;s++){(l=document.createElement("LI")).className=0==s?"dhtmlxcalendar_cell_wn":"dhtmlxcalendar_cell",r.appendChild(l)}}this.contTime=document.createElement("DIV"),this.contTime.className="dhtmlxcalendar_time_cont",this.contTime.style.display="none",this.base.firstChild.appendChild(this.contTime),this.showTime=function(){1!=this.conf.time&&(this.conf.time=!0,this._adjustTimeCont())},this.hideTime=function(){1==this.conf.time&&(this.conf.time=!1,this._adjustTimeCont())},this.showToday=function(){1!=this.conf.today&&(this.conf.today=!0,this._adjustTimeCont())},this.hideToday=function(){1==this.conf.today&&(this.conf.today=!1,this._adjustTimeCont())},this._adjustTimeCont=function(){var t="";1==this.conf.time&&(t+="_time"),1==this.conf.today&&(t+="_today"),""==t?this.contTime.style.display="none":(this.contTime.className="dhtmlxcalendar_time_cont dhtmlxcalendar_mode"+t,this.contTime.style.display=""),this._ifrSize()},this._adjustTimeCont(),(r=document.createElement("UL")).className="dhtmlxcalendar_line",this.contTime.appendChild(r);var l=document.createElement("LI");for(var d in l.className="dhtmlxcalendar_cell dhtmlxcalendar_time_hdr",l.innerHTML="<div class='dhtmlxcalendar_time_img'></div><span class='dhtmlxcalendar_label_hours'></span><span class='dhtmlxcalendar_label_colon'>:</span><span class='dhtmlxcalendar_label_minutes'></span><span class='dhtmlxcalendar_label_clear'>"+this.langData[this.lang].clear+"</span><span class='dhtmlxcalendar_label_today'>"+this.langData[this.lang].today+"</span>",r.appendChild(l),l.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;if(null!=e.tagName&&"span"==e.tagName.toLowerCase()&&1==e._par&&null!=e.parentNode&&(e=e.parentNode),e.className&&"dhtmlxcalendar_label_hours"==e.className){t.cancelBubble=!0;var n=o.contMonth.offsetHeight+o.contDays.offsetHeight+o.contDates.offsetHeight+e.offsetTop;o._showSelector("hours",Math.round(e.offsetLeft+e.offsetWidth/2),n-2,"selector_hours",!0)}else if(e.className&&"dhtmlxcalendar_label_minutes"==e.className){if(t.cancelBubble=!0,1==o._minutesInterval){var i=o.getFormatedDate("%i");e.innerHTML="<span class='dhtmlxcalendar_selected_date'>"+i.charAt(0)+"</span>"+i.charAt(1),e.firstChild._par=!0,o._selectorMode=1}n=o.contMonth.offsetHeight+o.contDays.offsetHeight+o.contDates.offsetHeight+e.offsetTop;o._showSelector("minutes",Math.round(e.offsetLeft+e.offsetWidth/2),n-2,"selector_minutes",!0)}else{if(o._hideSelector(),e.className&&"dhtmlxcalendar_label_today"==e.className){i=new Date;i=new Date(i.getFullYear(),i.getMonth(),i.getDate(),o._activeDate.getHours(),o._activeDate.getMinutes(),o._activeDate.getSeconds(),o._activeDate.getMilliseconds()),o.setDate(i),o._updateInp(),o.callEvent("onButtonClick",[i])}e.className&&"dhtmlxcalendar_label_clear"==e.className&&(o._nullDate=!0,o._drawMonth(new Date),o._updateInp(),o.callEvent("onButtonClick",[null]))}},1==this.conf.touch&&(l.ontouchstart=l.onclick),this._activeMonth=null,this._activeDate=new Date,this._activeDateCell=null,this.setDate=function(t){window.dhx4.temp_calendar={tz:null},this._nullDate=void 0===t||""===t||!t,t instanceof Date||("Invalid Date"==(t=this._strToDate(String(t||"")))?t=new Date:this.conf.tz=window.dhx4.temp_calendar.tz,window.dhx4.temp_calendar=null),null==this.conf.tz&&(this.conf.tz=window.dhx4.date2str(t,"%P"));var e=t.getTime();this._isOutOfRange(e)||(this._activeDate=new Date(e),this._drawMonth(this._nullDate?new Date:this._activeDate),this._updateVisibleHours(),this._updateVisibleMinutes())},this.getDate=function(t){if(this._nullDate)return null;var e=new Date(this._activeDate.getTime());if(t){window.dhx4.temp_calendar={tz:this.conf.tz};var n=this._dateToStr(e);return window.dhx4.temp_calendar=null,n}return e},this._drawMonth=function(t){if(t instanceof Date){isNaN(t.getFullYear())&&(t=new Date(this._activeMonth.getFullYear(),this._activeMonth.getMonth(),1,0,0,0,0)),this._activeMonth=new Date(t.getFullYear(),t.getMonth(),1,0,0,0,0),this._activeDateCell=null;var e=new Date(this._activeMonth.getTime()),n=e.getDay()-this._wStart;n<0&&(n+=7),e.setDate(e.getDate()-n);for(var i=t.getMonth(),a=new Date(this._activeDate.getFullYear(),this._activeDate.getMonth(),this._activeDate.getDate(),0,0,0,0).getTime(),o=0,r=0;r<6;r++)for(var s=this._wStart,l=0;l<=7;l++)if(0==l){var d,c=this.getWeekNumber(new Date(e.getFullYear(),e.getMonth(),e.getDate()+o,0,0,0,0));if(c>=52&&1==this.conf.ws_first&&0==this._activeMonth.getMonth())(d=this.getWeekNumber(new Date(e.getFullYear(),e.getMonth(),e.getDate()+o+7,0,0,0,0)))<c&&d>1&&(c=1);else if(c>52&&11==this._activeMonth.getMonth())1==(d=this.getWeekNumber(new Date(e.getFullYear()+1,0,1)))&&(c=1);this.contDates.childNodes[r].childNodes[l].innerHTML="<div class='dhtmlxcalendar_label'>"+c+"</div>"}else{var h=new Date(e.getFullYear(),e.getMonth(),e.getDate()+o,0,0,0,0);if(0!=h.getHours()){var u=h.getHours()>12?24-h.getHours():h.getHours();h.setTime(h.getTime()+36e5*u)}h.getDay();var m=h.getTime(),f="dhtmlxcalendar_label";null!=this._tipData[m]?(this._tipData[m].usePopup&&"function"==typeof window.dhtmlXPopup?(this.contDates.childNodes[r].childNodes[l].removeAttribute("title"),this._initTooltipPopup()):this.contDates.childNodes[r].childNodes[l].setAttribute("title",this._tipData[m].text),this._tipData[m].showIcon&&(f+=" dhtmlxcalendar_label_title")):this.contDates.childNodes[r].childNodes[l].removeAttribute("title"),this.contDates.childNodes[r].childNodes[l].innerHTML="<div class='"+f+"'>"+h.getDate()+"</div>",this.contDates.childNodes[r].childNodes[l]._date=new Date(m),this.contDates.childNodes[r].childNodes[l]._q=r,this.contDates.childNodes[r].childNodes[l]._w=l,this.contDates.childNodes[r].childNodes[l]._css_month=h.getMonth()==i,this.contDates.childNodes[r].childNodes[l]._css_date=!this._nullDate&&m==a,this.contDates.childNodes[r].childNodes[l]._css_weekend=s>=6,this.contDates.childNodes[r].childNodes[l]._css_dis=this._isOutOfRange(m),this.contDates.childNodes[r].childNodes[l]._css_holiday=1==this._holidays[m],this._updateCellStyle(r,l),m==a&&(this._activeDateCell=this.contDates.childNodes[r].childNodes[l]),++s>7&&(s=1),o++}this.contMonth.firstChild.firstChild.childNodes[1].innerHTML=this._buildMonthHdr(t)}},this._updateCellStyle=function(t,e){var n=this.contDates.childNodes[t].childNodes[e],i="dhtmlxcalendar_cell dhtmlxcalendar_cell";i+=n._css_month?"_month":"",i+=n._css_date?"_date":"",i+=n._css_weekend?"_weekend":"",i+=n._css_holiday?"_holiday":"",i+=n._css_dis?"_dis":"",i+=n._css_hover&&!n._css_dis?"_hover":"",n.className=i,n=null},this._minutesInterval=5,this._initSelector=function(t,e){if(this._selCover||(this._selCover=document.createElement("DIV"),this._selCover.className="dhtmlxcalendar_selector_cover",this.base.firstChild.appendChild(this._selCover)),this._sel||(this._sel=document.createElement("DIV"),this._sel.className="dhtmlxcalendar_selector_obj",this.base.firstChild.appendChild(this._sel),this._sel.appendChild(document.createElement("TABLE")),this._sel.firstChild.className="dhtmlxcalendar_selector_table",this._sel.firstChild.cellSpacing=0,this._sel.firstChild.cellPadding=0,this._sel.firstChild.border=0,this._sel.firstChild.appendChild(document.createElement("TBODY")),this._sel.firstChild.firstChild.appendChild(document.createElement("TR")),this._sel.firstChild.firstChild.firstChild.appendChild(document.createElement("TD")),this._sel.firstChild.firstChild.firstChild.appendChild(document.createElement("TD")),this._sel.firstChild.firstChild.firstChild.appendChild(document.createElement("TD")),this._sel.firstChild.firstChild.firstChild.childNodes[0].className="dhtmlxcalendar_selector_cell_left",this._sel.firstChild.firstChild.firstChild.childNodes[1].className="dhtmlxcalendar_selector_cell_middle",this._sel.firstChild.firstChild.firstChild.childNodes[2].className="dhtmlxcalendar_selector_cell_right",this._sel.firstChild.firstChild.firstChild.childNodes[0].innerHTML="&nbsp;",this._sel.firstChild.firstChild.firstChild.childNodes[2].innerHTML="&nbsp;",this._sel.firstChild.firstChild.firstChild.childNodes[0].onmouseover=function(){this.className="dhtmlxcalendar_selector_cell_left dhtmlxcalendar_selector_cell_left_hover"},this._sel.firstChild.firstChild.firstChild.childNodes[0].onmouseout=function(){this.className="dhtmlxcalendar_selector_cell_left"},this._sel.firstChild.firstChild.firstChild.childNodes[2].onmouseover=function(){this.className="dhtmlxcalendar_selector_cell_right dhtmlxcalendar_selector_cell_right_hover"},this._sel.firstChild.firstChild.firstChild.childNodes[2].onmouseout=function(){this.className="dhtmlxcalendar_selector_cell_right"},this._sel.onmouseover=function(t){var e=(t=t||event).target||t.srcElement;!0===e._cell&&(o._selHover!=e&&o._clearSelHover(),null!=String(e.className).match(/^\s{0,}dhtmlxcalendar_selector_cell\s{0,}$/gi)&&(e.className+=" dhtmlxcalendar_selector_cell_hover",o._selHover=e))},this._sel.onmouseout=function(){o._clearSelHover()},this._sel.firstChild.firstChild.firstChild.childNodes[0].onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0,o._scrollYears(-1)},this._sel.firstChild.firstChild.firstChild.childNodes[2].onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0,o._scrollYears(1)},1==this.conf.touch&&(this._sel.firstChild.firstChild.firstChild.childNodes[0].ontouchstart=this._sel.firstChild.firstChild.firstChild.childNodes[0].onclick,this._sel.firstChild.firstChild.firstChild.childNodes[2].ontouchstart=this._sel.firstChild.firstChild.firstChild.childNodes[2].onclick),this._sel._ta={},this._selHover=null,this._sel.appendChild(document.createElement("DIV")),this._sel.lastChild.className="dhtmlxcalendar_selector_obj_arrow"),1!=this._sel._ta[t]){if("month"==t){this._msCells={},this.msCont=document.createElement("DIV"),this.msCont.className="dhtmlxcalendar_area_"+e,this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.msCont);for(var n=0,i=0;i<4;i++){(d=document.createElement("UL")).className="dhtmlxcalendar_selector_line",this.msCont.appendChild(d);for(var a=0;a<3;a++){(c=document.createElement("LI")).innerHTML=this.langData[this.lang].monthesSNames[n],c.className="dhtmlxcalendar_selector_cell",d.appendChild(c),c._month=n,c._cell=!0,this._msCells[n++]=c}}this.msCont.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0;var e=t.target||t.srcElement;null!=e._month&&(o._hideSelector(),o._updateActiveMonth(),o._drawMonth(new Date(o._activeMonth.getFullYear(),e._month,1,0,0,0,0)),o._doOnSelectorChange())},1==this.conf.touch&&(this.msCont.ontouchstart=this.msCont.onclick)}if("year"==t){this._ysCells={},this.ysCont=document.createElement("DIV"),this.ysCont.className="dhtmlxcalendar_area_"+e,this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.ysCont);for(i=0;i<4;i++){(d=document.createElement("UL")).className="dhtmlxcalendar_selector_line",this.ysCont.appendChild(d);for(a=0;a<3;a++){(c=document.createElement("LI")).className="dhtmlxcalendar_selector_cell",c._cell=!0,d.appendChild(c)}}this.ysCont.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0;var e=t.target||t.srcElement;null!=e._year&&(o._hideSelector(),o._drawMonth(new Date(e._year,o._activeMonth.getMonth(),1,0,0,0,0)),o._doOnSelectorChange())},1==this.conf.touch&&(this.ysCont.ontouchstart=this.ysCont.onclick)}if("hours"==t){this._hsCells={},this.hsCont=document.createElement("DIV"),this.hsCont.className="dhtmlxcalendar_area_"+e,this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.hsCont);for(n=0,i=0;i<4;i++){(d=document.createElement("UL")).className="dhtmlxcalendar_selector_line",this.hsCont.appendChild(d);for(a=0;a<6;a++){(c=document.createElement("LI")).innerHTML=this._fixLength(n,2),c.className="dhtmlxcalendar_selector_cell",d.appendChild(c),c._hours=n,c._cell=!0,this._hsCells[n++]=c}}this.hsCont.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0;var e=t.target||t.srcElement;null!=e._hours&&(o._hideSelector(),o._activeDate.setHours(e._hours),o._updateActiveHours(),o._updateVisibleHours(),o._doOnSelectorChange(),o.callEvent("onTimeChange",[new Date(o._activeDate.getTime())]))},1==this.conf.touch&&(this.hsCont.ontouchstart=this.hsCont.onclick)}if("minutes"==t){var r=4,s=3,l=2;1==this._minutesInterval&&(1==this._selectorMode?(r=2,s=3,l=1):(r=2,s=5,l=1,e+="5")),10==this._minutesInterval&&(r=2),15==this._minutesInterval&&(r=1,s=4,e+="4"),this._rsCells={},this.rsCont=document.createElement("DIV"),this.rsCont.className="dhtmlxcalendar_area_"+e,this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.rsCont);for(n=0,i=0;i<r;i++){var d;(d=document.createElement("UL")).className="dhtmlxcalendar_selector_line",this.rsCont.appendChild(d);for(a=0;a<s;a++){var c;(c=document.createElement("LI")).innerHTML=l>1?this._fixLength(n,l):n,c.className="dhtmlxcalendar_selector_cell",d.appendChild(c),c._minutes=n,c._cell=!0,this._rsCells[n]=c,n+=this._minutesInterval}}this.rsCont.onclick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault(),t.cancelBubble=!0;var e=t.target||t.srcElement;if(null!=e._minutes){if(1==o._minutesInterval){var n=o.getFormatedDate("%i");if(n=1==o._selectorMode?e._minutes.toString()+n.charAt(1):n.charAt(0)+e._minutes.toString(),o._activeDate.setMinutes(Number(n)),o.callEvent("onTimeChange",[new Date(o._activeDate.getTime())]),o._hideSelector(),1==o._selectorMode)return o._updateVisibleMinutes(!0),o._selectorMode=2,o._showSelector("minutes",o._sel._x,o._sel._y,"selector_minutes",!0),void o._updateActiveMinutes();o._selectorMode=1}else o._hideSelector(),o._activeDate.setMinutes(e._minutes),o._updateActiveMinutes(),o.callEvent("onTimeChange",[new Date(o._activeDate.getTime())]);o._updateVisibleMinutes(),o._doOnSelectorChange()}},1==this.conf.touch&&(this.rsCont.ontouchstart=this.rsCont.onclick)}this._sel._ta[t]=!0}},this._showSelector=function(t,e,n,i,a){if(!0===a&&null!=this._sel&&this._isSelectorVisible()&&t==this._sel._t)this._hideSelector();else{"dhx_terrace"==this.conf.skin&&(e+=12),this._sel&&this._sel._ta[t]||this._initSelector(t,i),t!=this._sel._t&&"minutes"==this._sel._t&&1==this._minutesInterval&&(this.contTime.firstChild.firstChild.childNodes[3].innerHTML=this.getFormatedDate("%i")),this._sel._x=e,this._sel._y=n,this._sel.style.visibility="hidden",this._sel.style.display="",this._selCover.style.width=this.base.offsetWidth-2+"px",this._selCover.style.top=this.contMonth.offsetHeight+"px",this._selCover.style.height=this.contDates.offsetHeight+this.contDays.offsetHeight-1+"px",this._selCover.style.display="",this._sel._t=t,this._sel.className="dhtmlxcalendar_selector_obj dhtmlxcalendar_"+i+("hours"==t&&1==this.conf.today?"2":""),this._sel.childNodes[0].firstChild.firstChild.childNodes[0].style.display=this._sel.childNodes[0].firstChild.firstChild.childNodes[2].style.display="year"==t?"":"none";var o=Math.max(0,e-Math.round(this._sel.offsetWidth/2));o+this._sel.offsetWidth>this._sel.parentNode.offsetWidth&&(o=this._sel.parentNode.offsetWidth-this._sel.offsetWidth),this._sel.style.left=o+"px",this._sel.style.top="hours"==t||"minutes"==t?n-this._sel.offsetHeight+"px":n+"px",this._sel.childNodes[1].style.width=this._sel.childNodes[0].offsetWidth+"px",this._sel.style.visibility="visible",this._doOnSelectorShow(t)}},this._doOnSelectorShow=function(t){"month"==t&&this._updateActiveMonth(),"year"==t&&this._updateYearsList(this._activeMonth),"hours"==t&&this._updateActiveHours(),"minutes"==t&&this._updateActiveMinutes()},this._hideSelector=function(t){this._sel&&(this._sel.style.display="none",this._sel.style.visible="hidden",this._selCover.style.display="none","minutes"==this._sel._t&&1==this._minutesInterval&&(this.contTime.firstChild.firstChild.childNodes[3].innerHTML=this.getFormatedDate("%i"),this._unloadSelector("minutes")))},this._isSelectorVisible=function(){return!!this._sel&&"none"!=this._sel.style.display},this._doOnSelectorChange=function(t){this.callEvent("onChange",[new Date(this._activeMonth.getFullYear(),this._activeMonth.getMonth(),this._activeDate.getDate(),this._activeDate.getHours(),this._activeDate.getMinutes(),this._activeDate.getSeconds()),!0===t])},this._clearSelHover=function(){this._selHover&&(this._selHover.className=String(this._selHover.className.replace(/dhtmlxcalendar_selector_cell_hover/gi,"")),this._selHover=null)},this._unloadSelector=function(t){if(this._sel&&this._sel._ta[t]){if("month"==t){for(var e in this.msCont.onclick=this.msCont.ontouchstart=null,this._msActive=null,this._msCells)this._msCells[e]._cell=null,this._msCells[e]._month=null,this._msCells[e].parentNode.removeChild(this._msCells[e]),this._msCells[e]=null;for(this._msCells=null;this.msCont.childNodes.length>0;)this.msCont.removeChild(this.msCont.lastChild);this.msCont.parentNode.removeChild(this.msCont),this.msCont=null}if("year"==t){for(var e in this.ysCont.onclick=this.ysCont.ontouchstart=null,this._ysCells)this._ysCells[e]._cell=null,this._ysCells[e]._year=null,this._ysCells[e].parentNode.removeChild(this._ysCells[e]),this._ysCells[e]=null;for(this._ysCells=null;this.ysCont.childNodes.length>0;)this.ysCont.removeChild(this.ysCont.lastChild);this.ysCont.parentNode.removeChild(this.ysCont),this.ysCont=null}if("hours"==t){for(var e in this.hsCont.onclick=this.hsCont.ontouchstart=null,this._hsActive=null,this._hsCells)this._hsCells[e]._cell=null,this._hsCells[e]._hours=null,this._hsCells[e].parentNode.removeChild(this._hsCells[e]),this._hsCells[e]=null;for(this._hsCells=null;this.hsCont.childNodes.length>0;)this.hsCont.removeChild(this.hsCont.lastChild);this.hsCont.parentNode.removeChild(this.hsCont),this.hsCont=null}if("minutes"==t){for(var e in this.rsCont.onclick=this.rsCont.ontouchstart=null,this._rsActive=null,this._rsCells)this._rsCells[e]._cell=null,this._rsCells[e]._minutes=null,this._rsCells[e].parentNode.removeChild(this._rsCells[e]),this._rsCells[e]=null;for(this._rsCells=null;this.rsCont.childNodes.length>0;)this.rsCont.removeChild(this.rsCont.lastChild);this.rsCont.parentNode.removeChild(this.rsCont),this.rsCont=null}this._sel._ta[t]=null}},this.setMinutesInterval=function(t){1!=t&&5!=t&&10!=t&&15!=t||(this._minutesInterval=t,this._unloadSelector("minutes"))},this._updateActiveMonth=function(){void 0!==this._msActive&&void 0!==this._msCells[this._msActive]&&(this._msCells[this._msActive].className="dhtmlxcalendar_selector_cell"),this._msActive=this._activeMonth.getMonth(),this._msCells[this._msActive].className="dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active"},this._updateActiveYear=function(){var t=this._activeMonth.getFullYear();this._ysCells[t]&&(this._ysCells[t].className="dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active")},this._updateYearsList=function(t){for(var e in this._ysCells)this._ysCells[e]=null,delete this._ysCells[e];for(var n=12*Math.floor(t.getFullYear()/12),i=0;i<4;i++)for(var a=0;a<3;a++)this.ysCont.childNodes[i].childNodes[a].innerHTML=n,this.ysCont.childNodes[i].childNodes[a]._year=n,this.ysCont.childNodes[i].childNodes[a].className="dhtmlxcalendar_selector_cell",this._ysCells[n++]=this.ysCont.childNodes[i].childNodes[a];this._updateActiveYear()},this._scrollYears=function(t){var e=(t<0?this.ysCont.firstChild.firstChild._year:this.ysCont.lastChild.lastChild._year)+t,n=new Date(e,this._activeMonth.getMonth(),1,0,0,0,0);this._updateYearsList(n)},this._updateActiveHours=function(){void 0!==this._hsActive&&void 0!==this._hsCells[this._hsActive]&&(this._hsCells[this._hsActive].className="dhtmlxcalendar_selector_cell"),this._hsActive=this._activeDate.getHours(),this._hsCells[this._hsActive].className="dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active"},this._updateVisibleHours=function(){this.contTime.firstChild.firstChild.childNodes[1].innerHTML=this._fixLength(this._activeDate.getHours(),2)},this._updateActiveMinutes=function(){null!=this._rsActive&&void 0!==this._rsActive&&void 0!==this._rsCells[this._rsActive]&&(this._rsCells[this._rsActive].className="dhtmlxcalendar_selector_cell"),1==this._minutesInterval?this._rsActive=this.getFormatedDate("%i").toString().charAt(1==this._selectorMode?0:1):this._rsActive=this._activeDate.getMinutes(),void 0!==this._rsCells[this._rsActive]&&(this._rsCells[this._rsActive].className="dhtmlxcalendar_selector_cell dhtmlxcalendar_selector_cell_active")},this._updateVisibleMinutes=function(t){var e=this._fixLength(this._activeDate.getMinutes(),2).toString();1==t&&(e=e.charAt(0)+"<span class='dhtmlxcalendar_selected_date'>"+e.charAt(1)+"</span>"),this.contTime.firstChild.firstChild.childNodes[3].innerHTML=e,1==t&&(this.contTime.firstChild.firstChild.childNodes[3].lastChild._par=!0)},this._fixLength=function(t,e){for(;String(t).length<e;)t="0"+String(t);return t},this._dateFormat="",this._dateFormatRE=null,this.setDateFormat=function(t){var e={};if(null!=this._strToDate)for(var n in this.i)if(null!=this.i[n].input&&this.i[n].input.value.length>0){var i=this._strToDate(this.i[n].input.value,this._dateFormat||this.langData[this.lang].dateformat||"%Y-%m-%d");i instanceof Date&&(e[n]=i)}this._dateFormat=t;var a=String(this._dateFormat).replace(/%[a-zA-Z]+/g,function(t){switch(t.replace(/%/,"")){case"n":case"h":case"j":case"g":case"G":return"\\d{1,2}";case"m":case"d":case"H":case"i":case"s":case"y":return"\\d{2}";case"Y":return"\\d{4}";case"M":return"("+o.langData[o.lang].monthesSNames.join("|").toLowerCase()+"){1,}";case"F":return"("+o.langData[o.lang].monthesFNames.join("|").toLowerCase()+"){1,}";case"D":return"[a-z]{2}";case"a":case"A":return"AM|PM";case"u":return"\\d{1,6}";case"P":return"[\\+\\-]\\d{1,2}\\:\\d{1,2}"}return t});for(var n in this._dateFormatRE=new RegExp(a,"i"),e)this.i[n].input.value=this._dateToStr(e[n]);e=null},this.setDateFormat(this.langData[this.lang].dateformat||"%Y-%m-%d"),this._updateDateStr=function(t){if(this._dateFormatRE&&t.match(this._dateFormatRE)&&t!=this.getFormatedDate()){var e=this._strToDate(t);e instanceof Date&&(!this.checkEvent("onBeforeChange")||this.callEvent("onBeforeChange",[new Date(e.getFullYear(),e.getMonth(),e.getDate(),e.getHours(),e.getMinutes(),e.getSeconds())])?(this._nullDate=!1,this._activeDate=e,this._drawMonth(this._nullDate?new Date:this._activeDate),this._updateVisibleMinutes(),this._updateVisibleHours(),this._sel&&this._isSelectorVisible()&&this._doOnSelectorShow(this._sel._t),this._doOnSelectorChange(!0)):this._updateInp())}},this.showMonth=function(t){"string"==typeof t&&(t=this._strToDate(t)),t instanceof Date&&this._drawMonth(t)},this.setFormatedDate=function(t,e,n,i){var a=this._strToDate(e,t);if(i)return a;this.setDate(a)},this.getFormatedDate=function(t,e){if(!(e&&e instanceof Date)){if(this._nullDate)return"";e=new Date(this._activeDate)}return this._dateToStr(e,t)},this.getWeekNumber=function(t){if("string"==typeof t&&(t=this._strToDate(t)),!(t instanceof Date))return"Invalid Date";var e=t.getDay();0===e&&(e=7);var n=new Date(t.valueOf());n.setDate(t.getDate()+(4-e));var i=n.getFullYear(),a=Math.round((n.getTime()-new Date(i,0,1).getTime())/864e5);return 1+Math.floor(a/7)},this.showWeekNumbers=function(){this.base.firstChild.className="dhtmlxcalendar_wn"},this.hideWeekNumbers=function(){this.base.firstChild.className=""},this.show=function(t){if(t||!this._hasParent){if("string"==typeof t){var e=document.getElementById(t);if(null!=e&&void 0!==e._dhtmlxcalendar_uid&&null!=this.i[e._dhtmlxcalendar_uid])return void this._show(e._dhtmlxcalendar_uid)}if("object"!=typeof t||void 0===t._dhtmlxcalendar_uid||this.i[t._dhtmlxcalendar_uid]!=t){if(void 0===t)for(var n in this.i)t||(t=n);t&&this._show(t)}else this._show(t._dhtmlxcalendar_uid)}else this._show()},this.hide=function(){this._isVisible()&&this._hide()},this.isVisible=function(){return this._isVisible()},this._activeInp=null,this.pos="bottom",this.setPosition=function(t,e){this._px=null,this._py=null,"right"==t||"bottom"==t?this.pos=t:(this.pos="int",void 0===t||isNaN(t)||(this.base.style.left=t+"px",this._px=t),void 0===e||isNaN(e)||(this.base.style.top=e+"px",this._py=e),this._ifrSize())},this._show=function(t,e){if(!0===e&&this._activeInp==t&&this._isVisible())this._hide();else{if(this.base.style.visibility="hidden",this.base.style.display="",t){-1==this.base.className.indexOf("dhtmlxcalendar_in_input")&&(this.base.className+=" dhtmlxcalendar_in_input");var n=this.i[t].input||this.i[t].button,i=window.dhx4.screenDim(),a={top:window.dhx4.absTop(n),left:window.dhx4.absLeft(n)};if("right"==this.pos)this.base.style.left=a.left+n.offsetWidth+"px",this.base.style.top=Math.min(a.top,i.bottom-this.base.offsetHeight)+"px";else if("bottom"==this.pos){var o=a.top+n.offsetHeight+1;if(o+this.base.offsetHeight>i.bottom){var r=a.top-this.base.offsetHeight;r>=-20&&(o=r)}var s=a.left;s+this.base.offsetWidth>i.right&&(s=Math.max(0,a.left+n.offsetWidth-this.base.offsetWidth)),this.base.style.left=s+"px",this.base.style.top=o+"px"}else this.base.style.left=(this._px||0)+"px",this.base.style.top=(this._py||0)+"px";this._activeInp=t,n=null}else null!=this._px&&null!=this._py?(this.base.style.left=this._px+"px",this.base.style.top=this._py+"px"):(this.base.style.left="0px",this.base.style.top="0px");this._hideSelector(),this.base.style.visibility="visible",this.base.style.zIndex=window.dhx4.zim.reserve(this.conf.zi),this._ifrSize(),this._ifr&&(this._ifr.style.display=""),this.callEvent("onShow",[])}},this._hide=function(){null!=this._lastHover&&this._clearDayHover(),this._hideSelector(),this.base.style.display="none",window.dhx4.zim.clear(this.conf.zi),this.base.className.indexOf("dhtmlxcalendar_in_input")>=0&&(this.base.className=this.base.className.replace(/\s{0,}dhtmlxcalendar_in_input/gi,"")),this._activeInp=null,this._ifr&&(this._ifr.style.display="none"),this.callEvent("onHide",[])},this._isVisible=function(){return"none"!=this.base.style.display},this._rangeActive=!1,this._rangeFrom=null,this._rangeTo=null,this._rangeSet={},this.setInsensitiveDays=function(t){for(var e=this._extractDates(t),n=0;n<e.length;n++)this._rangeSet[new Date(e[n].getFullYear(),e[n].getMonth(),e[n].getDate(),0,0,0,0).getTime()]=!0;this._drawMonth(this._activeMonth)},this.clearInsensitiveDays=function(){this._clearRangeSet(),this._drawMonth(this._activeMonth)},this._holidays={},this.setHolidays=function(t){if(null==t)this._clearHolidays();else if(null!=t)for(var e=this._extractDates(t),n=0;n<e.length;n++)this._holidays[new Date(e[n].getFullYear(),e[n].getMonth(),e[n].getDate(),0,0,0,0).getTime()]=!0;this._drawMonth(this._activeMonth)},this._extractDates=function(t){("string"==typeof t||t instanceof Date)&&(t=[t]);for(var e=[],n=0;n<t.length;n++)if("string"==typeof t[n])for(var i=t[n].split(","),a=0;a<i.length;a++)e.push(this._strToDate(i[a]));else t[n]instanceof Date&&e.push(t[n]);return e},this._clearRange=function(){this._rangeActive=!1,this._rangeType=null,this._rangeFrom=null,this._rangeTo=null},this._clearRangeSet=function(){for(var t in this._rangeSet)this._rangeSet[t]=null,delete this._rangeSet[t]},this._clearHolidays=function(){for(var t in this._holidays)this._holidays[t]=null,delete this._holidays[t]},this._isOutOfRange=function(t){if(1==this._rangeSet[t])return!0;if(this._rangeActive){if("in"==this._rangeType&&(t<this._rangeFrom||t>this._rangeTo))return!0;if("out"==this._rangeType&&t>=this._rangeFrom&&t<=this._rangeTo)return!0;if("from"==this._rangeType&&t<this._rangeFrom)return!0;if("to"==this._rangeType&&t>this._rangeTo)return!0}var e=new Date(t);return!(!this._rangeWeek||!0!==this._rangeWeekData[e.getDay()])||(!(!this._rangeMonth||!0!==this._rangeMonthData[e.getDate()])||!(!this._rangeYear||!0!==this._rangeYearData[e.getMonth()+"_"+e.getDate()]))},this.clearSensitiveRange=function(){this._clearRange(),this._drawMonth(this._activeMonth)},this.setSensitiveRange=function(t,e,n){var i=!1;if(null!=t&&null!=e){if(t instanceof Date||(t=this._strToDate(t)),e instanceof Date||(e=this._strToDate(e)),t.getTime()>e.getTime())return;this._rangeFrom=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime(),this._rangeTo=new Date(e.getFullYear(),e.getMonth(),e.getDate(),0,0,0,0).getTime(),this._rangeActive=!0,this._rangeType="in",i=!0}i||null==t||null!=e||(t instanceof Date||(t=this._strToDate(t)),this._rangeFrom=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime(),this._rangeTo=null,!0===n&&this._rangeFrom++,this._rangeActive=!0,this._rangeType="from",i=!0),i||null!=t||null==e||(e instanceof Date||(e=this._strToDate(e)),this._rangeFrom=null,this._rangeTo=new Date(e.getFullYear(),e.getMonth(),e.getDate(),0,0,0,0).getTime(),!0===n&&this._rangeTo--,this._rangeActive=!0,this._rangeType="to",i=!0),i&&this._drawMonth(this._activeMonth)},this.setInsensitiveRange=function(t,e){if(null!=t&&null!=e){if(t instanceof Date||(t=this._strToDate(t)),e instanceof Date||(e=this._strToDate(e)),t.getTime()>e.getTime())return;return this._rangeFrom=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime(),this._rangeTo=new Date(e.getFullYear(),e.getMonth(),e.getDate(),0,0,0,0).getTime(),this._rangeActive=!0,this._rangeType="out",void this._drawMonth(this._activeMonth)}null==t||null!=e?null!=t||null==e||this.setSensitiveRange(e,null,!0):this.setSensitiveRange(null,t,!0)},this.disableDays=function(t,e){if("week"==t){for(var n in"object"!=typeof e&&void 0===e.length&&(e=[e]),this._rangeWeekData||(this._rangeWeekData={}),this._rangeWeekData)this._rangeWeekData[n]=!1,delete this._rangeWeekData[n];for(var i=0;i<e.length;i++)this._rangeWeekData[e[i]]=!0,7==e[i]&&(this._rangeWeekData[0]=!0);this._rangeWeek=!0}if("month"==t){for(var n in"object"!=typeof e&&void 0===e.length&&(e=[e]),this._rangeMonthData||(this._rangeMonthData={}),this._rangeMonthData)this._rangeMonthData[n]=!1,delete this._rangeMonthData[n];for(i=0;i<e.length;i++)this._rangeMonthData[e[i]]=!0;this._rangeMonth=!0}if("year"==t){var a=this._extractDates(e);for(var n in this._rangeYearData||(this._rangeYearData={}),this._rangeYearData)this._rangeYearData[n]=!1,delete this._rangeYearData[n];for(i=0;i<a.length;i++)this._rangeYearData[a[i].getMonth()+"_"+a[i].getDate()]=!0;this._rangeYear=!0}this._drawMonth(this._activeMonth)},this.enableDays=function(t){"week"==t&&(this._rangeWeek=!1),"month"==t&&(this._rangeMonth=!1),"year"==t&&(this._rangeYear=!1),this._drawMonth(this._activeMonth)},this._tipData={},this._tipTM=null,this._tipTMTime=400,this._tipEvs=!1,this._tipPopup=null,this._tipCellDate=null,this._tipCellDim=null,this.setTooltip=function(t,e,n,i){for(var a=this._extractDates(t),o=0;o<a.length;o++){var r=new Date(a[o].getFullYear(),a[o].getMonth(),a[o].getDate(),0,0,0,0).getTime();this._tipData[r]={text:e,showIcon:n,usePopup:i}}this._drawMonth(this._activeMonth)},this.clearTooltip=function(t){for(var e=this._extractDates(t),n=0;n<e.length;n++){var i=new Date(e[n].getFullYear(),e[n].getMonth(),e[n].getDate(),0,0,0,0).getTime();this._tipData[i]=null,delete this._tipData[i]}this._drawMonth(this._activeMonth)},this._initTooltipPopup=function(){this._tipEvs||(this.attachEvent("onMouseOver",function(t){var e=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime();null!=this._tipData[e]&&(this._tipTM&&window.clearTimeout(this._tipTM),this._tipCellDate=t,this._tipCellDim=this.getCellDimension(t),this._tipText=this._tipData[e].text,this._tipTM=window.setTimeout(this._showTooltipPopup,this._tipTMTime))}),this.attachEvent("onMouseOut",this._hideTooltipPopup),this._tipEvs=!0)},this._showTooltipPopup=function(t,e,n,i,a){o._tipPopup||(o._tipPopup=new dhtmlXPopup({mode:"top"})),o._tipPopup.attachHTML(o._tipText),o._tipPopup.show(o._tipCellDim.x,o._tipCellDim.y,o._tipCellDim.w,o._tipCellDim.h),o.callEvent("onPopupShow",[o._tipCellDate])},this._hideTooltipPopup=function(){this._tipTM&&window.clearTimeout(this._tipTM),null!=this._tipPopup&&this._tipPopup.isVisible()&&(this._tipPopup.hide(),this.callEvent("onPopupHide",[this._tipCellDate]))},this.getPopup=function(){return this._tipPopup},this.getCellDimension=function(t){if("string"==typeof t&&(t=this._strToDate(t)),!(t instanceof Date))return null;for(var e=new Date(t.getFullYear(),t.getMonth(),t.getDate(),0,0,0,0).getTime(),n=null,i=0;i<this.contDates.childNodes.length;i++)for(var a=0;a<this.contDates.childNodes[i].childNodes.length;a++){var o=this.contDates.childNodes[i].childNodes[a];null!=o._date&&o._date.getTime()==e&&(n={x:window.dhx4.absLeft(o),y:window.dhx4.absTop(o),w:o.offsetWidth,h:o.offsetHeight}),o=null}return n},this._updateFromInput=function(t){if(this._nullInInput&&0==t.value.replace(/\s/g,"").length){if(this.checkEvent("onBeforeChange")&&!this.callEvent("onBeforeChange",[null]))return void this._updateInp();this.setDate(null)}else this._updateDateStr(t.value);t=null},this._doOnClick=function(t){var e=(t=t||event).target||t.srcElement;e._dhtmlxcalendar_uid&&e._dhtmlxcalendar_uid!=o._activeInp&&o._isVisible()&&o._activeInp?o._hide():e._dhtmlxcalendar_uid&&o.i[e._dhtmlxcalendar_uid]||(o._isSelectorVisible()?o._hideSelector():!o._hasParent&&o._isVisible()&&o._hide())},this._doOnKeyDown=function(t){27!=(t=t||event).keyCode&&13!=t.keyCode||(o._isSelectorVisible()?o._hideSelector():o._isVisible()&&!o._hasParent&&o._hide())},this._doOnInpClick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;e._dhtmlxcalendar_uid&&(o._listenerEnabled||o._updateFromInput(e),o._show(e._dhtmlxcalendar_uid,!0))},this._doOnInpKeyUp=function(t){var e=(t=t||event).target||t.srcElement;13!=t.keyCode&&e._dhtmlxcalendar_uid&&(o._listenerEnabled||o._updateFromInput(e))},this._doOnBtnClick=function(t){"touchstart"==(t=t||event).type&&null!=t.preventDefault&&t.preventDefault();var e=t.target||t.srcElement;e._dhtmlxcalendar_uid&&(null!=o.i[e._dhtmlxcalendar_uid].input&&o._updateFromInput(o.i[e._dhtmlxcalendar_uid].input),o._show(e._dhtmlxcalendar_uid,!0))},this._doOnUnload=function(){o&&o.unload&&o.unload()},"function"==typeof window.addEventListener?(document.body.addEventListener("click",o._doOnClick,!1),window.addEventListener("keydown",o._doOnKeyDown,!1),window.addEventListener("unload",o._doOnUnload,!1),1==this.conf.touch&&document.body.addEventListener("touchstart",o._doOnClick,!1)):(document.body.attachEvent("onclick",o._doOnClick),document.body.attachEvent("onkeydown",o._doOnKeyDown),window.attachEvent("onunload",o._doOnUnload)),this.attachObj=function(t){var e=window.dhx4.newId();return"string"==typeof t?this.i[e]={input:document.getElementById(t)}:void 0!==t.tagName?this.i[e]={input:t}:"object"!=typeof t||null==t.input&&null==t.button||(this.i[e]={},null!=t.input&&(this.i[e].input="string"==typeof t.input?document.getElementById(t.input):t.input),null!=t.button&&(this.i[e].button="string"==typeof t.button?document.getElementById(t.button):t.button)),this._attachEventsToObject(e),e},this.detachObj=function(t){var e=null;if(null!=this.i[t]?e=t:"string"==typeof t?e=(t=document.getElementById(t))._dhtmlxcalendar_uid:void 0!==t.tagName?e=t._dhtmlxcalendar_uid:"object"!=typeof t||null==t.input&&null==t.button||(null==e&&null!=t.input&&(e=("string"==typeof t.input?document.getElementById(t.input):t.input)._dhtmlxcalendar_uid),null==e&&null!=t.button&&(e=("string"==typeof t.button?document.getElementById(t.button):t.button)._dhtmlxcalendar_uid)),null!=e&&null!=this.i[e]){for(var n in this._detachEventsFromObject(e),this.i[n])this.i[e][n]._dhtmlxcalendar_uid=null,this.i[e][n]=null,delete this.i[e][n];return this.i[e]=null,delete this.i[e],!0}return!1},this._attachEventsToObject=function(t){null!=this.i[t].button?(this.i[t].button._dhtmlxcalendar_uid=t,"function"==typeof window.addEventListener?(this.i[t].button.addEventListener("click",o._doOnBtnClick,!1),1==this.conf.touch&&this.i[t].button.addEventListener("touchstart",o._doOnBtnClick,!1)):this.i[t].button.attachEvent("onclick",o._doOnBtnClick)):null!=this.i[t].input&&(this.i[t].input._dhtmlxcalendar_uid=t,"function"==typeof window.addEventListener?(this.i[t].input.addEventListener("click",o._doOnInpClick,!1),this.i[t].input.addEventListener("keyup",o._doOnInpKeyUp,!1),1==this.conf.touch&&this.i[t].input.addEventListener("touchstart",o._doOnInpClick,!1)):(this.i[t].input.attachEvent("onclick",o._doOnInpClick),this.i[t].input.attachEvent("onkeyup",o._doOnInpKeyUp)))},this._detachEventsFromObject=function(t){null!=this.i[t].button?"function"==typeof window.addEventListener?(this.i[t].button.removeEventListener("click",o._doOnBtnClick,!1),1==this.conf.touch&&this.i[t].button.removeEventListener("touchstart",o._doOnBtnClick,!1)):this.i[t].button.detachEvent("onclick",o._doOnBtnClick):null!=this.i[t].input&&("function"==typeof window.addEventListener?(this.i[t].input.removeEventListener("click",o._doOnInpClick,!1),this.i[t].input.removeEventListener("keyup",o._doOnInpKeyUp,!1),1==this.conf.touch&&this.i[t].input.removeEventListener("touchstart",o._doOnInpClick,!1)):(this.i[t].input.detachEvent("onclick",o._doOnInpClick),this.i[t].input.detachEvent("onkeyup",o._doOnInpKeyUp)))},this._updateInp=function(){null!=this.i&&null!=this._activeInp&&null!=this.i[this._activeInp]&&null!=this.i[this._activeInp].input&&(this.i[this._activeInp].input.value=this.getFormatedDate())},this.enableListener=function(t){t&&("function"==typeof window.addEventListener?(t.addEventListener("focus",o._listenerEvFocus,!1),t.addEventListener("blur",o._listenerEvBlur,!1)):(t.attachEvent("onfocus",o._listenerEvFocus),t.attachEvent("onblur",o._listenerEvBlur)),t=null)},this.disableListener=function(t){t&&(t._f0=!1,this._tmListener&&window.clearTimeout(this._tmListener),"function"==typeof window.addEventListener?(t.removeEventListener("focus",o._listenerEvFocus,!1),t.removeEventListener("blur",o._listenerEvBlur,!1)):(t.detachEvent("onfocus",o._listenerEvFocus),t.detachEvent("onblur",o._listenerEvBlur)),t=null)},this._startListener=function(t){this._tmListener&&window.clearTimeout(this._tmListener),void 0===t._v1&&(t._v1=t.value),t._v1!=t.value&&(this._updateFromInput(t),t._v1=t.value),t._f0&&(this._tmListener=window.setTimeout(function(){o._startListener(t)},100))},this._listenerEvFocus=function(t){var e=(t=t||event).target||t.srcElement;e._f0=!0,o._startListener(e),e=null},this._listenerEvBlur=function(t){var e=(t=t||event).target||t.srcElement;e._f0=!1,e=null},this.i)this._attachEventsToObject(d);return window.dhx4._eventable(this),this._evOnArrowClick=function(t){return this.callEvent("onArrowClick",t)},this._evOnClick=function(t){return this.callEvent("onClick",t)},this._evOnMouseOut=function(t){return this.callEvent("onMouseOut",t)},this._evOnMouseOver=function(t){return this.callEvent("onMouseOver",t)},this.unload=function(){for(var t in this._activeDate=null,this._activeDateCell=null,this._activeInp=null,this._activeMonth=null,this._dateFormat=null,this._dateFormatRE=null,this._lastHover=null,this._tmListener&&window.clearTimeout(this._tmListener),this._tmListener=null,"function"==typeof window.addEventListener?(document.body.removeEventListener("click",o._doOnClick,!1),window.removeEventListener("keydown",o._doOnKeyDown,!1),window.removeEventListener("unload",o._doOnUnload,!1),1==this.conf.touch&&document.body.removeEventListener("touchstart",o._doOnClick,!1)):(document.body.detachEvent("onclick",o._doOnClick),document.body.detachEvent("onkeydown",o._doOnKeyDown),window.detachEvent("onunload",o._doOnKeyDown)),this._doOnClick=null,this._doOnKeyDown=null,this._doOnUnload=null,this.i)this.i[t]._dhtmlxcalendar_uid=null,this._detachEventsFromObject(t),this.disableListener(this.i[t].input),this.i[t]=null,delete this.i[t];for(this.i=null,this._doOnInpClick=null,this._doOnInpKeyUp=null,window.dhx4._eventable(this,"clear"),this.contMonth.onselectstart=null,this.contMonth.firstChild.firstChild.onclick=null,this.contMonth.firstChild.firstChild.ontouchstart=null,this.contMonth.firstChild.firstChild.firstChild.onmouseover=null,this.contMonth.firstChild.firstChild.firstChild.onmouseout=null,this.contMonth.firstChild.firstChild.lastChild.onmouseover=null,this.contMonth.firstChild.firstChild.lastChild.onmouseout=null;this.contMonth.firstChild.firstChild.childNodes.length>0;)this.contMonth.firstChild.firstChild.removeChild(this.contMonth.firstChild.firstChild.lastChild);for(this.contMonth.firstChild.removeChild(this.contMonth.firstChild.firstChild),this.contMonth.removeChild(this.contMonth.firstChild),this.contMonth.parentNode.removeChild(this.contMonth),this.contMonth=null;this.contDays.firstChild.childNodes.length>0;)this.contDays.firstChild.removeChild(this.contDays.firstChild.lastChild);for(this.contDays.removeChild(this.contDays.firstChild),this.contDays.parentNode.removeChild(this.contDays),this.contDays=null,this.contDates.onclick=null,this.contDates.ontouchstart=null,this.contDates.onmouseover=null,this.contDates.onmouseout=null;this.contDates.childNodes.length>0;){for(;this.contDates.lastChild.childNodes.length>0;)this.contDates.lastChild.lastChild._css_date=null,this.contDates.lastChild.lastChild._css_month=null,this.contDates.lastChild.lastChild._css_weekend=null,this.contDates.lastChild.lastChild._css_hover=null,this.contDates.lastChild.lastChild._date=null,this.contDates.lastChild.lastChild._q=null,this.contDates.lastChild.lastChild._w=null,this.contDates.lastChild.removeChild(this.contDates.lastChild.lastChild);this.contDates.removeChild(this.contDates.lastChild)}for(this.contDates.parentNode.removeChild(this.contDates),this.contDates=null,this.contTime.firstChild.firstChild.onclick=null,this.contTime.firstChild.firstChild.ontouchstart=null;this.contTime.firstChild.firstChild.childNodes.length>0;)this.contTime.firstChild.firstChild.removeChild(this.contTime.firstChild.firstChild.lastChild);if(this.contTime.firstChild.removeChild(this.contTime.firstChild.firstChild),this.contTime.removeChild(this.contTime.firstChild),this.contTime.parentNode.removeChild(this.contTime),this.contTime=null,this._lastHover=null,this._unloadSelector("month"),this._unloadSelector("year"),this._unloadSelector("hours"),this._unloadSelector("minutes"),this._selCover&&(this._selCover.parentNode.removeChild(this._selCover),this._selCover=null),this._sel){for(var t in this._sel._ta)this._sel._ta[t]=null;for(this._sel._ta=null,this._sel._t=null,this._sel.onmouseover=null,this._sel.onmouseout=null;this._sel.firstChild.firstChild.firstChild.childNodes.length>0;)this._sel.firstChild.firstChild.firstChild.lastChild.onclick=null,this._sel.firstChild.firstChild.firstChild.lastChild.onmouseover=null,this._sel.firstChild.firstChild.firstChild.lastChild.onmouseout=null,this._sel.firstChild.firstChild.firstChild.removeChild(this._sel.firstChild.firstChild.firstChild.lastChild);for(this._sel.firstChild.firstChild.removeChild(this._sel.firstChild.firstChild.firstChild),this._sel.firstChild.removeChild(this._sel.firstChild.firstChild);this._sel.childNodes.length>0;)this._sel.removeChild(this._sel.lastChild);this._sel.parentNode.removeChild(this._sel),this._sel=null}for(var t in this.base.onclick=null,this.base.onmousedown=null,this.base.ontouchstart=null,this.base.onmouseout=null,this.base.parentNode.removeChild(this.base),this.base=null,this._clearDayHover=null,this._clearSelHover=null,this._doOnSelectorChange=null,this._doOnSelectorShow=null,this._drawMonth=null,this._fixLength=null,this._ifrSize=null,this._hide=null,this._hideSelector=null,this._initSelector=null,this._isSelectorVisible=null,this._isVisible=null,this._scrollYears=null,this._show=null,this._showSelector=null,this._strToDate=null,this._updateActiveHours=null,this._updateActiveMinutes=null,this._updateActiveMonth=null,this._updateActiveYear=null,this._updateCellStyle=null,this._updateDateStr=null,this._updateVisibleHours=null,this._updateVisibleMinutes=null,this._updateYearsList=null,this.enableIframe=null,this.hide=null,this.hideTime=null,this.setDate=null,this.setDateFormat=null,this.setYearsRange=null,this.show=null,this.showTime=null,this.unload=null,null!=this._tipPopup&&(this._tipPopup.unload(),this._tipPopup=null),this)delete this[t];t=o=null},this.setDate(this._activeDate),this}function dhtmlXCombo(t,e,n,i,a){var o=this,r=null,s=null;"object"!=typeof t||t.tagName||(t=(r=t).parent,n=r.width,e=r.name,i=r.mode,s=r.skin),this.cont="string"==typeof t?document.getElementById(t):t,this.conf={skin:null,form_name:e||"dhxcombo",combo_width:(parseInt(n)||this.cont.offsetWidth||120)-(dhx4.isFF||dhx4.isIE||dhx4.isChrome||dhx4.isOpera?2:0),combo_image:!1,combo_focus:!1,opts_type:"string"==typeof i&&void 0!==this.modes[i]?i:"option",opts_count:8,opts_count_min:3,opts_width:null,item_h:null,list_zi_id:window.dhx4.newId(),allow_free_text:!0,allow_empty_value:!0,free_text_empty:!1,enabled:!0,btn_left:(window.dhx4.isIE6||window.dhx4.isIE7||window.dhx4.isIE8)&&void 0===window.addEventListener?1:0,ro_mode:!1,ro_text:"",ro_tm:null,ro_tm_time:750,img_path:"",img_def:"",img_def_dis:!0,template:{header:!0,input:"#text#",option:"#text#"},f_func:null,f_mode:!1,f_url:!1,f_cache:!1,f_cache_data:{},f_dyn:!1,f_dyn_end:!1,f_mask:"",f_ac:!0,f_ac_text:"",f_server_tm:null,f_server_last:"",f_loading:!1,s_tm:null,s_time:200,s_mode:"select",last_hover:null,last_selected:null,last_match:null,last_text:"",last_value:"",tm_hover:null,tm_confirm_blur:null,clear_click:!1,clear_blur:!1,clear_bsp:!1,clear_key:!1,i_ofs:23,sp:{dhx_skyblue:{list_ofs:1,hdr_ofs:1,scr_ofs:1},dhx_web:{list_ofs:0,hdr_ofs:1,scr_ofs:0},dhx_terrace:{list_ofs:1,hdr_ofs:1,scr_ofs:1},material:{list_ofs:0,hdr_ofs:1,scr_ofs:1}},col_w:null},this.conf.combo_image=1==this.modes[this.conf.opts_type].image,this.t={},this.base=document.createElement("DIV"),this.base.style.width=this.conf.combo_width+"px",this.base.innerHTML="<input type='text' class='dhxcombo_input' style='width:"+(this.conf.combo_width-(this.conf.i_ofs+1)-(this.conf.combo_image?this.conf.i_ofs:0))+"px;"+(this.conf.combo_image?"margin-left:"+this.conf.i_ofs+"px;":"")+"' autocomplete='off'><input type='hidden' value=''><input type='hidden' value='false'><div class='dhxcombo_select_button'><div class='dhxcombo_select_img'></div></div>"+(this.conf.combo_image?"<div class='dhxcombo_top_image'>"+this.modes[this.conf.opts_type].getTopImage(null,this.conf.enabled)+"</div>":""),this.cont.appendChild(this.base),this.list=document.createElement("DIV"),this.list._listId=window.dhx4.newId(),this.list.style.display="none",document.body.insertBefore(this.list,document.body.firstChild),this._doOnListScroll=function(){null!=o.conf.s_tm&&window.clearTimeout(o.conf.s_tm),o.conf.s_tm=window.setTimeout(o._doOnListScrollAction,o.conf.s_time)},this._doOnListScrollAction=function(){o.conf.s_tm=null,"scroll"==o.conf.s_mode&&o.list.scrollHeight-o.list.scrollTop-10<o.list.clientHeight&&o._subloadRequest()},"function"==typeof window.addEventListener?this.list.addEventListener("scroll",this._doOnListScroll,!1):this.list.attachEvent("onscroll",this._doOnListScroll),this.setSkin(s||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxcombo")||"material"),this._updateTopImage=function(t){this.conf.combo_image&&(this.base.lastChild.innerHTML=null!=t?this.t[t].obj.getTopImage(this.t[t].item,this.conf.enabled):this.modes[this.conf.opts_type].getTopImage(null,this.conf.enabled))},this._filterOpts=function(t){this.conf.f_server_tm&&window.clearTimeout(this.conf.f_server_tm);var e=String(this.base.firstChild.value).replace(new RegExp(this._fixRE(this.conf.f_ac_text)+"$","i"),"");if(this.conf.f_server_last!=e.toLowerCase()){if(null!=this.conf.f_url&&this.checkEvent("onDynXLS"))return this.conf.f_server_last=e.toLowerCase(),void this.callEvent("onDynXLS",[e]);if(null!=this.conf.f_url){if(0==e.length)return this.conf.f_server_last=e.toLowerCase(),void this.clearAll();if(1==this.conf.f_cache&&null!=this.conf.f_cache_data[e]){this.clearAll(),this.conf.f_server_last=e.toLowerCase();for(var n=0;n<this.conf.f_cache_data[e].data.length;n++)this.load(this.conf.f_cache_data[e].data[n]);this.conf.f_dyn&&(this.conf.f_dyn_end=this.conf.f_cache_data[e].dyn_end,this.conf.f_mask=this.conf.f_cache_data[e].mask),!0!==t&&(this._showList(!0),this._checkForMatch())}else this.conf.f_server_tm=window.setTimeout(function(){o.conf.f_server_last=e.toLowerCase(),o.conf.f_mask=e;var n="mask="+encodeURIComponent(e);o.conf.f_dyn&&(n+="&pos=0",o.conf.f_dyn_end=!1);var i=function(n){if(o.conf.f_cache&&(o.conf.f_cache_data[e]||(o.conf.f_cache_data[e]={data:[],dyn_end:!1,mask:e}),o.conf.f_cache_data[e].data.push(n.xmlDoc.responseXML)),o.clearAll(),o.load(n.xmlDoc.responseText),1==(o.base.offsetWidth>0&&o.base.offsetHeight>0)&&1==o.conf.enabled&&1==o.conf.combo_focus&&!0!==t){if(o.conf.f_ac&&"start"==o.conf.f_mode&&0==o.conf.clear_bsp&&null!=o.list.firstChild){var a=o.list.firstChild._optId,r=String(o.t[a].obj.getText(o.list.firstChild,!0));e==o.base.firstChild.value&&0===String(r).toLowerCase().indexOf(String(e).toLowerCase())&&(o.base.firstChild.value=r,o.conf.f_ac_text=r.substr(e.length),o._selectRange(e.length,r.length))}o._showList(!0),o._checkForMatch()}i=null};"post"==window.dhx4.ajax.method?window.dhx4.ajax.post(o.conf.f_url,n,i):"get"==window.dhx4.ajax.method&&window.dhx4.ajax.get(o.conf.f_url+(String(o.conf.f_url).indexOf("?")>=0?"&":"?")+n,i)},200)}else{this.conf.f_server_last=e.toLowerCase();var i=0==e.length||new RegExp(("start"==this.conf.f_mode?"^":"")+this._fixRE(e),"i"),a=null;for(var r in this.t){var s=!1;if(!0!==i)if(null!=this.conf.f_func){var l=this._getOption(this.t[r].item._optId,n);s=1==this.conf.f_func.apply(window,[e,l])}else{var d=this.t[r].obj.getText(this.t[r].item,!0);s=1==i.test(d)}!0===i||1==s?(this.t[r].item.style.display="",null==a&&e.length>0&&(a=String(this.t[r].obj.getText(this.t[r].item,!0)))):this.t[r].item.style.display="none"}this.conf.f_ac&&"start"==this.conf.f_mode&&0==this.conf.clear_bsp&&null!=a&&(this.conf.f_ac_text=a.replace(new RegExp("^"+e,"i"),""),this.base.firstChild.value=a,this._selectRange(this.conf.f_server_last.length,this.base.firstChild.value.length)),"between"==this.conf.f_mode&&1==this.conf.clear_bsp&&this._checkForMatch(!0),!0!==t&&(this._showList(!0),this._checkForMatch())}}else this._checkForMatch()},this._searchRO=function(t){this.conf.ro_tm&&window.clearTimeout(this.conf.ro_tm),this.conf.ro_text+=t,this._showList();for(var e=0;e<this.list.childNodes.length;e++){var n=this.list.childNodes[e]._optId;if(0===String(this.t[n].obj.getText(this.list.childNodes[e],!0)).toLowerCase().indexOf(this.conf.ro_text)){this._setSelected(n,!0,!0),this._confirmSelect("script",!1);break}}this.conf.ro_tm=window.setTimeout(function(){o.conf.ro_text=""},this.conf.ro_tm_time)},this._fixRE=function(t){return String(t).replace(/[\\\^\$\*\+\?\.\(\)\|\{\}\[\]]/gi,"\\$&")},this._initObj=function(t){void 0!==t.template&&this.setTemplate(t.template),1!=t.add&&1!=this.conf.f_loading&&this.clearAll(!1),this.addOption(t.options)},this._xmlToObj=function(t,e,n){var i={add:!1,options:[]},a=1==e?t:t.getElementsByTagName("complete");if(a.length>0){1==window.dhx4.s2b(a[0].getAttribute("add"))&&(i.add=!0);for(var o=a[0].childNodes,r=0;r<o.length;r++)if(void 0!==o[r].tagName){if("template"==String(o[r].tagName).toLowerCase()){for(var s={},l=0;l<o[r].childNodes.length;l++){if(null!=(A=o[r].childNodes[l]).tagName){var d=A.tagName;if(void 0!==this.conf.template[d]&&(s[d]=window.dhx4._xmlNodeValue(A)),"columns"==d)for(var c=0;c<A.childNodes.length;c++){var h=A.childNodes[c];if(null!=h.tagName&&"column"==h.tagName){var u={};for(var m in{width:1,css:1,header:1,option:1})null!=h.getAttribute(m)&&(u[m]=h.getAttribute(m));for(var m in{header:1,option:1}){var f=h.getElementsByTagName(m);null!=f[0]&&null!=f[0].firstChild&&(u[m]=window.dhx4._xmlNodeValue(f[0]))}null==s.columns&&(s.columns=[]),s.columns.push(u)}h=null}}A=null}this.setTemplate(s)}if("option"==String(o[r].tagName).toLowerCase()){var p=!1;p=1==e?i.options.length==n:window.dhx4.s2b(o[r].getAttribute("selected"));var _={value:o[r].getAttribute("value"),text:window.dhx4._xmlNodeValue(o[r]),selected:p,checked:window.dhx4.s2b(o[r].getAttribute("checked"))};for(var m in{img:1,img_dis:1,img_src:1,img_src_dis:1,css:1})null!=o[r].getAttribute(m)&&(_[m]=o[r].getAttribute(m));for(l=0;l<o[r].childNodes.length;l++)if(null!=o[r].childNodes[l].tagName&&"text"==String(o[r].childNodes[l].tagName).toLowerCase()){_.text={};var A=o[r].childNodes[l];for(c=0;c<A.childNodes.length;c++)null!=A.childNodes[c].tagName&&(_.text[A.childNodes[c].tagName]=window.dhx4._xmlNodeValue(A.childNodes[c]))}i.options.push(_)}}a=o=null}return i},window.dhx4._enableDataLoading(this,"_initObj","_xmlToObj","complete",{data:!0}),window.dhx4._eventable(this),this._getNearItem=function(t,e){for(var n=null;null!=t;)t=t[e<0?"previousSibling":"nextSibling"],null==n&&null!=t&&""==t.style.display&&null!=t._optId&&(n=t,t=null);return n},this.setName(this.conf.form_name),this._doOnListMouseMove=function(t){for(var e=(t=t||event).target||t.srcElement;null!=e&&e!=this;)void 0!==e._optId&&(o.conf.tm_hover&&window.clearTimeout(o.conf.tm_hover),o._setSelected(e._optId,!1,!1,!0)),e=e.parentNode;e=null},this._doOnListMouseDown=function(t){(t=t||event).cancelBubble=!0,o.conf.clear_click=!0,window.setTimeout(function(){o.base.firstChild.focus()},1)},this._doOnListMouseUp=function(t){if((t=t||event).button==o.conf.btn_left){for(var e=t.target||t.srcElement;null!=e&&e!=this;){if(void 0!==e._optId){var n=!0;"function"==typeof o.t[e._optId].obj.optionClick&&!0!==o.t[e._optId].obj.optionClick(e,t,o)&&(n=!1),n&&(o._setSelected(e._optId,null,!0),o._confirmSelect("click"))}e=e.parentNode}e=null}},this._doOnListMouseOut=function(t){o.conf.tm_hover&&window.clearTimeout(o.conf.tm_hover),o.conf.tm_hover=window.setTimeout(function(){var t=o.conf.last_match||o.conf.last_selected;null==o.conf.last_match&&null!=o.t[t]&&o.base.firstChild.value!=o.t[t].obj.getText(o.t[t].item,!0)&&(t=null),o._setSelected(t,null,!0,!0)},1)},this._doOnBaseMouseDown=function(t){if(o.conf.enabled&&(o.conf.clear_click=!0,(t=t||event).button==o.conf.btn_left)){var e=t.target||t.srcElement;if(e!=this.firstChild){window.setTimeout(function(){o.base.firstChild.focus()},1);for(var n=e;n!=this&&null!=n;)if(n==this.lastChild){if("function"==typeof o.modes[o.conf.opts_type].topImageClick){var i=o.conf.last_hover||o.conf.last_selected,a=null!=i?o.t[i].item:null;if(!0!==o.modes[o.conf.opts_type].topImageClick(a,o))return void(i=a=null)}n=null}else n=n.parentNode}o._isListVisible()?o._hideList():(e!=this.firstChild&&(o.conf.clear_blur=!0),o._showList(),o._setSelected(o.conf.last_selected,!0,!0)),e=null}},this._doOnBodyMouseDown=function(){o.conf.clear_click?o.conf.clear_click=!1:o._confirmSelect("blur")},this._doOnInputFocus=function(){o.conf.clear_blur=!1,o.conf.tm_confirm_blur&&window.clearTimeout(o.conf.tm_confirm_blur),0==o.conf.combo_focus&&(o.conf.combo_focus=!0,"material"==o.conf.skin&&null==o.base.className.match(/dhxcombo_actv/)&&(o.base.className+=" dhxcombo_actv"),o.callEvent("onFocus",[]))},this._doOnInputBlur=function(){1!=o.conf.clear_blur?(o.conf.tm_confirm_blur&&window.clearTimeout(o.conf.tm_confirm_blur),o.conf.tm_confirm_blur=window.setTimeout(function(){0==o.conf.clear_click&&(o._confirmSelect("blur"),o.conf.combo_focus=!1,"material"==o.conf.skin&&null!=o.base.className.match(/dhxcombo_actv/)&&(o.base.className=o.base.className.replace(/\s*dhxcombo_actv/gi,"")),o.callEvent("onBlur",[]))},20)):o.conf.clear_blur=!1},this._doOnInputKeyUp=function(t){if(t=t||event,0!=o.conf.f_mode)return o.conf.clear_bsp=8==t.keyCode||46==t.keyCode,void o._filterOpts();o._checkForMatch()},this._doOnInputKeyDown=function(t){38!=(t=t||event).keyCode&&40!=t.keyCode||t.ctrlKey||t.shiftKey||t.altKey||(t.preventDefault?t.preventDefault():t.returnValue=!1,t.cancelBubble=!0,o._keyOnUpDown(38==t.keyCode?-1:1)),113==t.keyCode&&(o._isListVisible()||(o._showList(),o.base.firstChild.value==o.conf.last_text?(o._setSelected(o.conf.last_selected,!0,!0),o.base.firstChild.value=o.conf.last_text,o.conf.f_server_last=o.base.firstChild.value.toLowerCase()):(o.conf.f_server_last=o.base.firstChild.value.toLowerCase(),0==o.conf.f_mode&&o._checkForMatch()))),27==t.keyCode&&(t.preventDefault?t.preventDefault():t.returnValue=!1,t.cancelBubble=!0,o._cancelSelect()),13==t.keyCode&&(t.preventDefault&&t.preventDefault(),o._confirmSelect("kbd")),1==o.conf.ro_mode&&(t.keyCode>=48&&t.keyCode<=57||t.keyCode>=65&&t.keyCode<=90)&&(o._searchRO(String.fromCharCode(t.keyCode).toLowerCase()),t.cancelBubble=!0),o.conf.clear_key=!0,o.callEvent("onKeyPressed",[t.keyCode||t.charCode])},this._doOnInputKeyPress=function(t){o.conf.clear_key?o.conf.clear_key=!1:(t=t||event,o.callEvent("onKeyPressed",[t.keyCode||t.charCode]))},this._keyOnUpDown=function(t){var e=null;if(this.conf.last_hover?e=this.t[this.conf.last_hover].item:this.conf.last_selected&&(e=this.t[this.conf.last_selected].item),(e||0!=this._getListVisibleCount())&&(null!=e&&""!=e.style.display&&(e=null),this._showList(),null!=e?this.t[e._optId].obj.isSelected(e)&&(e=this._getNearItem(e,t)):""!=(e=this.list.firstChild).style.display&&(e=this._getNearItem(e,1)),null!=e)){if(this._setSelected(e._optId,!0,!0),0==this.conf.f_mode)this.base.firstChild.value=this.t[e._optId].obj.getText(e,!0);else{var n=String(this.t[e._optId].obj.getText(e,!0));"start"==this.conf.f_mode&&1==this.conf.f_ac?0===n.toLowerCase().indexOf(this.conf.f_server_last)?(this.conf.f_ac_text=n.substring(this.conf.f_server_last.length,n.length),this.base.firstChild.value=n,this._selectRange(this.conf.f_server_last.length,this.base.firstChild.value.length)):(this.base.firstChild.value=n,this.conf.f_server_last=this.base.firstChild.value.toLowerCase(),this._selectRange(0,this.base.firstChild.value.length)):(this.base.firstChild.value=n,this.conf.f_server_last=this.base.firstChild.value.toLowerCase())}e=null}},this.conf.evs_nodes=[{node:document.body,evs:{mousedown:"_doOnBodyMouseDown"}},{node:this.base,evs:{mousedown:"_doOnBaseMouseDown"}},{node:this.base.firstChild,evs:{keyup:"_doOnInputKeyUp",keydown:"_doOnInputKeyDown",keypress:"_doOnInputKeyPress",focus:"_doOnInputFocus",blur:"_doOnInputBlur"}},{node:this.list,evs:{mousemove:"_doOnListMouseMove",mousedown:"_doOnListMouseDown",mouseup:"_doOnListMouseUp",mouseout:"_doOnListMouseOut"}}];for(var l=0;l<this.conf.evs_nodes.length;l++)for(var d in this.conf.evs_nodes[l].evs)"function"==typeof window.addEventListener?this.conf.evs_nodes[l].node.addEventListener(d,this[this.conf.evs_nodes[l].evs[d]],!1):this.conf.evs_nodes[l].node.attachEvent("on"+d,this[this.conf.evs_nodes[l].evs[d]]);return this.unload=function(){this.clearAll(),this.t=null;for(var t=0;t<this.conf.evs_nodes.length;t++){for(var e in this.conf.evs_nodes[t].evs)"function"==typeof window.addEventListener?this.conf.evs_nodes[t].node.removeEventListener(e,this[this.conf.evs_nodes[t].evs[e]],!1):this.conf.evs_nodes[t].node.detachEvent("on"+e,this[this.conf.evs_nodes[t].evs[e]]),this.conf.evs_nodes[t].evs[e]=null,delete this.conf.evs_nodes[t].evs[e];this.conf.evs_nodes[t].node=null,this.conf.evs_nodes[t].evs=null,delete this.conf.evs_nodes[t].node,delete this.conf.evs_nodes[t].evs,this.conf.evs_nodes[t]=null}for(var e in window.dhx4._eventable(this,"clear"),window.dhx4._enableDataLoading(this,null,null,null,"clear"),this._mcDetachHeader(),this.DOMelem_input=this.DOMelem_button=this.DOMlist=this.DOMelem=this.DOMParent=null,this.conf)this.conf[e]=null,delete this.conf[e];for(var e in this.conf=null,"function"==typeof window.addEventListener?this.list.removeEventListener("scroll",this._doOnListScroll,!1):this.list.detachEvent("onscroll",this._doOnListScroll),this.base.parentNode.removeChild(this.base),this.list.parentNode.removeChild(this.list),this.base=this.list=this.cont=null,this.modes=null,this)"function"==typeof this[e]&&(this[e]=null);o=null},this.DOMelem_input=this.base.firstChild,this.DOMelem_button=this.base.childNodes[this.base.childNodes.length-(this.conf.combo_image?2:1)],this.DOMlist=this.list,this.DOMelem=this.base,this.DOMParent=t,t=null,null!=r&&(null!=r.filter&&("string"==typeof r.filter?this.enableFilteringMode(!0,r.filter,window.dhx4.s2b(r.filter_cache),window.dhx4.s2b(r.filter_sub_load)):this.enableFilteringMode(!0)),null!=r.image_path&&this.setImagePath(r.image_path),null==r.default_image&&null==r.default_image_dis||this.setDefaultImage(r.default_image,r.default_image_dis),(r.items||r.options)&&this.addOption(r.items||r.options),(r.xml||r.json)&&this.load(r.xml||r.json),void 0!==r.readonly&&this.readonly(r.readonly),r=null),this}function dhtmlXComboFromSelect(t){"string"==typeof t&&(t=document.getElementById(t));var e=t.offsetWidth,n=t.getAttribute("name")||null,i=document.createElement("SPAN");t.parentNode.insertBefore(i,t);var a=new dhtmlXCombo(i,n,e,t.getAttribute("mode")||t.getAttribute("opt_type")||"option");i=null;var o=t.getAttribute("imagePath");o&&a.setImagePath(o);var r=t.getAttribute("defaultImage"),s=t.getAttribute("defaultImageDis");1==window.dhx4.s2b(s)&&(s=!0),null==r&&null==s||a.setDefaultImage(r,s);var l=a._xmlToObj([t],!0,t.selectedIndex);return l.options.length>0&&a.addOption(l.options),l=null,t.parentNode.removeChild(t),t=null,a}function dhtmlXComboExtend(t,e){for(var n in dhtmlXCombo.prototype.modes[e])void 0===dhtmlXCombo.prototype.modes[t][n]&&(dhtmlXCombo.prototype.modes[t][n]=dhtmlXCombo.prototype.modes[e][n])}function dhtmlXColorPicker(t){if(!(this instanceof window.dhtmlXColorPicker))return new dhtmlXColorPicker(t);dhx4._eventable(this);var e,n,i=this;switch(this._nodes=[],this.activeNode=null,this._inputListenerId=null,this.base=null,this._globalNode=null,this.memory=null,this.skin=null,this.conf={cp_id:dhx4.newId(),x:0,y:0,c:0,indent:2,position:"right",customColors:!1,selectedColor:null,hide:!1,hideOnSelect:!1,lang:"en",closeable:!0},this.value={red:-1,blue:-1,green:-1,hue:-1,sat:-1,lum:-1},this._initMoveSelection=function(t){return t=t||event,"function"==typeof window.addEventListener?(i._controllerNodes.colorArea.addEventListener("mousemove",i._setMoveSelection,!1),document.body.addEventListener("mouseup",i._cleanMoveSelection,!1)):(i._controllerNodes.colorArea.attachEvent("onmousemove",i._setMoveSelection),document.body.attachEvent("onmouseup",i._cleanMoveSelection)),i._setMoveSelection(t,i._controllerNodes.colorArea),!1},this._cleanMoveSelection=function(){return"function"==typeof window.removeEventListener?(i._controllerNodes.colorArea.removeEventListener("mousemove",i._setMoveSelection,!1),document.body.removeEventListener("mouseup",i._cleanMoveSelection,!1)):(i._controllerNodes.colorArea.detachEvent("onmousemove",i._setMoveSelection),document.body.detachEvent("onmouseup",i._cleanMoveSelection)),!1},this._setMoveSelection=function(t){t=t||event;var e=i._getOffsetPosition(t,i._controllerNodes.colorArea);return i._controllerNodes.fr_cover?setTimeout(function(){i._setColorAreaXY(e.x,e.y),i._setColorByXYC()},0):(i._setColorAreaXY(e.x,e.y),i._setColorByXYC()),!1},this._initMoveContrast=function(t){t=t||event,"function"==typeof window.addEventListener?(document.body.addEventListener("mousemove",i._setMoveContrast,!1),document.body.addEventListener("mouseup",i._cleanMoveContrast,!1)):(document.body.attachEvent("onmousemove",i._setMoveContrast),document.body.attachEvent("onmouseup",i._cleanMoveContrast)),i._setMoveContrast(t,i._controllerNodes.contrastArea)},this._cleanMoveContrast=function(){"function"==typeof window.removeEventListener?(document.body.removeEventListener("mousemove",i._setMoveContrast,!1),document.body.removeEventListener("mouseup",i._cleanMoveContrast,!1)):(document.body.detachEvent("onmousemove",i._setMoveContrast),document.body.detachEvent("onmouseup",i._cleanMoveContrast))},this._setMoveContrast=function(t){t=t||event;var e=i._getOffsetPosition(t,i._controllerNodes.contrastArea);i._setContrastY(e.y),i._setColorByXYC(!0)},this._doOnSelectColor=function(){var t=i.colorAIP.rgb2hex({r:i.value.red,g:i.value.green,b:i.value.blue});null!=i.activeNode&&(i.activeNode.valueCont&&(i.activeNode.valueCont.value=t),i.activeNode.valueColor&&(i.activeNode.valueColor.style.backgroundColor=t)),(i.base._dhx_remove||i.conf.hideOnSelect)&&i.hide(),i.callEvent("onSelect",[t,i.activeNode?i.activeNode.node:null])},this._doOnCancel=function(){1==i.callEvent("onCancel",[i.activeNode?i.activeNode.node:null])&&1==i.conf.closeable&&i.hide()},this._doOnFocusByInput=function(){var t=this!=window?this:event.srcElement,e=i.activeNode&&i.activeNode.valueCont&&i.activeNode.valueCont==t?i.activeNode:i._getNodeByValueCont(t);i.activeNode=e,e&&e==i.activeNode&&i._initListenerInput()},this._doOnBlurByInput=function(){var t=this!=window?this:event.srcElement,e=i.activeNode&&i.activeNode.valueCont&&i.activeNode.valueCont==t?i.activeNode:i._getNodeByValueCont(t);e&&e==i.activeNode&&i._removeListenerInput()},this._doOnClickByNode=function(t){t=t||event;var e=this!=window?this:event.srcElement;i.activeNode=i.activeNode.node!=e?i._getNodeByElement(e):i.activeNode,i.isVisible()||i.show()},this.saveColor=function(){i.memory.setValue(i.value)},this._onSelectMemoryEl=function(t){var e;for(e in i._refreshCoordinatesByHSL(t.value.hue,t.value.sat,t.value.lum),t.value)i.value[e]=t.value[e];i._refreshContrast(),i._refreshInputValues(),i._refreshColorValue()},this._doOnClickByBody=function(t){var e=!0,n=(t=t||event).target||t.srcElement;i._isBaseNode(n)&&(e=!1),e&&i.activeNode&&(i.activeNode.node==n||i.activeNode.valueCont==n)&&(e=!1),e&&i.hide()},this._doOnChangeHSL=function(){var t,e=parseInt(i._controllerNodes.hue.value),n=parseInt(i._controllerNodes.sat.value),a=parseInt(i._controllerNodes.lum.value);isNaN(e)||e>359||e<0?i._controllerNodes.hue.value=i.value.hue:i.value.hue=e,isNaN(n)||n>100||n<0?i._controllerNodes.sat.value=i.value.sat:i.value.sat=n,isNaN(a)||a>100||a<0?i._controllerNodes.lum.value=i.value.lum:i.value.lum=a,t=i.colorAIP.hsl2rgb(i.value.hue,i.value.sat/100,i.value.lum/100),i.value.red=Math.round(255*t.r),i.value.green=Math.round(255*t.g),i.value.blue=Math.round(255*t.b),i._refreshCoordinatesByHSL(i.value.hue,i.value.sat,i.value.lum),i._refreshContrast(),i._refreshInputValues(),i._refreshColorValue()},this._doOnChangeRGB=function(){var t,e=parseInt(i._controllerNodes.red.value),n=parseInt(i._controllerNodes.green.value),a=parseInt(i._controllerNodes.blue.value);isNaN(e)||e>255||e<0?i._controllerNodes.red.value=i.value.red:i.value.red=e,isNaN(n)||n>255||n<0?i._controllerNodes.green.value=i.value.green:i.value.green=n,isNaN(a)||a>255||a<0?i._controllerNodes.blue.value=i.value.blue:i.value.blue=a,t=i.colorAIP.rgb2hsl(i.value.red/255,i.value.green/255,i.value.blue/255),i.value.hue=Math.round(t.h),i.value.sat=Math.round(100*t.s),i.value.lum=Math.round(100*t.l),i._refreshCoordinatesByHSL(i.value.hue,i.value.sat,i.value.lum),i._refreshContrast(),i._refreshInputValues(),i._refreshColorValue()},this._doOnChangeHSV=function(){i._controllerNodes.hsv.value=i.setColor(i._controllerNodes.hsv.value)},this._checkType=function(t){if(!(t instanceof Array))return void 0==t?null:"string"==typeof t?"string":t.tagName&&"input"==t.tagName.toLowerCase()?"input":t.tagName&&"textarea"==t.tagName.toLowerCase()?"textarea":t.tagName?"container":"object"==typeof t?"object":void 0;switch(i._checkType(t[0])){case"string":return"array_string";case"input":case"textarea":return"array_input";case"object":return"array_object";default:return}},this._initByObject=function(t){t.parent&&t.parent.tagName?i.base=t.parent:"string"==typeof t.parent?i.base=document.getElementById(t.parent):(i.base=document.createElement("div"),i.base._dhx_remove=!0),t.color&&(i.conf.selectedColor=t.color),void 0!==t.closeable&&(this.conf.closeable=dhx4.s2b(t.closeable)),t.custom_colors&&(this._tempInitCC=function(){var e,n;if(this.initMemoryColors(),this.conf.customColors=!0,t.custom_colors instanceof Array)for(n=t.custom_colors.length,e=0;e<n;e++)this.setCustomColors(t.custom_colors[e]);this.base.parentNode&&this.showMemory(),delete this._tempInitCC}),t.hide&&(i.conf.hide=!0),t.input&&i._addNode(t.input,t.target_color,t.target_value);var e=t.skin||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxcolorpicker")||"material";i.setSkin(e),t.colors&&(i.initMemoryColors(),i.conf.customColors=!0),t.link&&i._addNode(t.link)},this.unload=function(){var t,e,a;for(this.isVisible()&&this.hide(),this.destructMemory(),e=this._nodes.length,t=0;t<e;t++){for(a in this._detachEventsFromNode(this._nodes[t]),this._nodes[t])this._nodes[t][a]=null;delete this._nodes[t]}for(a in this._nodes=null,this.base._dhx_remove?delete this.base._dhx_remove:this.base.className=this.base.className.replace(/\s?dhtmlxcp_\S*/,""),"function"==typeof window.addEventListener?(this._controllerNodes.colorArea.removeEventListener("mousedown",this._initMoveSelection,!1),this._controllerNodes.colorArea.removeEventListener("dblclick",this._doOnSelectColor,!1),this._controllerNodes.contrastArea.removeEventListener("mousedown",this._initMoveContrast,!1),this._controllerNodes.button_save.removeEventListener("click",this._doOnSelectColor,!1),this._controllerNodes.button_cancel.removeEventListener("click",this._doOnCancel,!1),this._controllerNodes.hue.removeEventListener("change",this._doOnChangeHSL,!1),this._controllerNodes.sat.removeEventListener("change",this._doOnChangeHSL,!1),this._controllerNodes.lum.removeEventListener("change",this._doOnChangeHSL,!1),this._controllerNodes.red.removeEventListener("change",this._doOnChangeRGB,!1),this._controllerNodes.green.removeEventListener("change",this._doOnChangeRGB,!1),this._controllerNodes.blue.removeEventListener("change",this._doOnChangeRGB,!1),this._controllerNodes.hsv.removeEventListener("change",this._doOnChangeHSV,!1)):(this._controllerNodes.colorArea.detachEvent("onmousedown",this._initMoveSelection),this._controllerNodes.colorArea.detachEvent("ondblclick",this._doOnSelectColor),this._controllerNodes.contrastArea.detachEvent("onmousedown",this._initMoveContrast),this._controllerNodes.button_save.detachEvent("onclick",this._doOnSelectColor),this._controllerNodes.button_cancel.detachEvent("onclick",this._doOnCancel),this._controllerNodes.hue.detachEvent("onchange",this._doOnChangeHSL),this._controllerNodes.sat.detachEvent("onchange",this._doOnChangeHSL),this._controllerNodes.lum.detachEvent("onchange",this._doOnChangeHSL),this._controllerNodes.red.detachEvent("onchange",this._doOnChangeRGB),this._controllerNodes.green.detachEvent("onchange",this._doOnChangeRGB),this._controllerNodes.blue.detachEvent("onchange",this._doOnChangeRGB),this._controllerNodes.hsv.detachEvent("onchange",this._doOnChangeHSV)),this._controllerNodes.fr_cover&&(this._controllerNodes.fr_cover.parentNode&&this._controllerNodes.fr_cover.parentNode.removeChild(this._controllerNodes.fr_cover),delete this._controllerNodes.fr_cover),dhx4.zim.clear(this.conf.cp_id),dhx4._eventable(this,"clear"),this)this[a]=null;i=null,null,n=null},this._checkType(t)){case"object":i._initByObject(t);break;case"input":case"textarea":i._initByObject({}),this._addNode(t);break;case"string":return new dhtmlXColorPicker(document.getElementById(t));case"container":i._initByObject({parent:t});break;case null:i._initByObject({});break;case"array_string":case"array_input":for(i._initByObject({}),e=t.length,a=0;a<e;a++)this._addNode(t[a]);break;case"array_object":for(i._initByObject({}),e=t.length,a=0;a<e;a++)(n=this._addNode(t[a].input,t[a].target_color,t[a].target_value).conf).customColors=void 0!=t[a].custom_colors?dhx4.s2b(t[a].custom_colors):n.customColors,n.selectedColor=void 0!=t[a].color?t[a].color:n.selectedColor}if(this.base.innerHTML="<div class='dhxcp_g_area'><div class='dhxcp_sub_area'><div class='dhxcp_g_color_area'><div class='dhxcp_color_selector'><div class='dhxcp_v_line'></div><div class='dhxcp_h_line'></div></div><div class='dhxcp_contrast_area'><div class='dhxcp_h_line'></div></div></div><div class='dhxcp_g_input_area'><div class='dhxcp_value_cont'><div class='dhxcp_value_color'></div><input type='text' class='dhxcp_value'/></div><table class='dhxcp_inputs_cont' cellpadding='0' cellspacing='0' border='0'><tr><td class='dhxcp_label_hsl'>"+this.i18n[this.conf.lang].labelHue+"</td><td class='dhxcp_input_hsl'><input type='text' class='dhxcp_input_hsl'/></td><td class='dhxcp_label_rgb'>"+this.i18n[this.conf.lang].labelRed+"</td><td class='dhxcp_input_rgb'><input type='text' class='dhxcp_input_rgb'/></td></tr><tr><td class='dhxcp_label_hsl'>"+this.i18n[this.conf.lang].labelSat+"</td><td class='dhxcp_input_hsl'><input type='text' class='dhxcp_input_hsl'/></td><td class='dhxcp_label_rgb'>"+this.i18n[this.conf.lang].labelGreen+"</td><td class='dhxcp_input_rgb'><input type='text' class='dhxcp_input_rgb'/></td></tr><tr><td class='dhxcp_label_hsl'>"+this.i18n[this.conf.lang].labelLum+"</td><td class='dhxcp_input_hsl'><input type='text' class='dhxcp_input_hsl'/></td><td class='dhxcp_label_rgb'>"+this.i18n[this.conf.lang].labelBlue+"</td><td class='dhxcp_input_rgb'><input type='text' class='dhxcp_input_rgb'/></td></tr></table></div><div class='dhxcp_g_memory_area'></div><div class='dhxcp_buttons_area'><button class='dhx_button_save'>"+this.i18n[this.conf.lang].btnSelect+"</button><button class='dhx_button_cancel'>"+this.i18n[this.conf.lang].btnCancel+"</button></div></div>",this._globalNode=this.base.firstChild,this._controllerNodes={colorArea:this._globalNode.firstChild.firstChild.firstChild,v_line:this._globalNode.firstChild.firstChild.firstChild.childNodes[0],h_line:this._globalNode.firstChild.firstChild.firstChild.childNodes[1],contrastArea:this._globalNode.firstChild.firstChild.childNodes[1],contrast_line:this._globalNode.firstChild.firstChild.childNodes[1].firstChild,color:this._globalNode.firstChild.childNodes[1].childNodes[0].firstChild,hsv:this._globalNode.firstChild.childNodes[1].childNodes[0].childNodes[1],hue:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[0].childNodes[1].firstChild,sat:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[1].childNodes[1].firstChild,lum:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[2].childNodes[1].firstChild,red:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[0].childNodes[3].firstChild,green:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[1].childNodes[3].firstChild,blue:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[2].childNodes[3].firstChild,memory_block:this._globalNode.firstChild.childNodes[2],button_save:this._globalNode.firstChild.childNodes[3].firstChild,button_cancel:this._globalNode.firstChild.childNodes[3].childNodes[1]},this._labelNodes={labelHue:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[0].firstChild,labelSat:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[1].firstChild,labelLum:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[2].firstChild,labelRed:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[0].childNodes[2],labelGreen:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[1].childNodes[2],labelBlue:this._globalNode.firstChild.childNodes[1].childNodes[1].firstChild.childNodes[2].childNodes[2],btnAddColor:null,btnSelect:this._globalNode.firstChild.childNodes[3].firstChild,btnCancel:this._globalNode.firstChild.childNodes[3].childNodes[1]},"function"==typeof this._tempInitCC&&this._tempInitCC(),"function"==typeof window.addEventListener?(this._controllerNodes.colorArea.addEventListener("mousedown",this._initMoveSelection,!1),this._controllerNodes.colorArea.addEventListener("dblclick",this._doOnSelectColor,!1),this._controllerNodes.contrastArea.addEventListener("mousedown",this._initMoveContrast,!1),this._controllerNodes.button_save.addEventListener("click",this._doOnSelectColor,!1),this._controllerNodes.button_cancel.addEventListener("click",this._doOnCancel,!1),this._controllerNodes.hue.addEventListener("change",this._doOnChangeHSL,!1),this._controllerNodes.sat.addEventListener("change",this._doOnChangeHSL,!1),this._controllerNodes.lum.addEventListener("change",this._doOnChangeHSL,!1),this._controllerNodes.red.addEventListener("change",this._doOnChangeRGB,!1),this._controllerNodes.green.addEventListener("change",this._doOnChangeRGB,!1),this._controllerNodes.blue.addEventListener("change",this._doOnChangeRGB,!1),this._controllerNodes.hsv.addEventListener("change",this._doOnChangeHSV,!1)):(this._controllerNodes.colorArea.attachEvent("onmousedown",this._initMoveSelection),this._controllerNodes.colorArea.attachEvent("ondblclick",this._doOnSelectColor),this._controllerNodes.contrastArea.attachEvent("onmousedown",this._initMoveContrast),this._controllerNodes.button_save.attachEvent("onclick",this._doOnSelectColor),this._controllerNodes.button_cancel.attachEvent("onclick",this._doOnCancel),this._controllerNodes.hue.attachEvent("onchange",this._doOnChangeHSL),this._controllerNodes.sat.attachEvent("onchange",this._doOnChangeHSL),this._controllerNodes.lum.attachEvent("onchange",this._doOnChangeHSL),this._controllerNodes.red.attachEvent("onchange",this._doOnChangeRGB),this._controllerNodes.green.attachEvent("onchange",this._doOnChangeRGB),this._controllerNodes.blue.attachEvent("onchange",this._doOnChangeRGB),this._controllerNodes.hsv.attachEvent("onchange",this._doOnChangeHSV)),this.setColor(this.conf.selectedColor||"#ffffff"),this._nodes.length)for(var a=0;a<this._nodes.length;a++)this._attachEventsToNode(this._nodes[a]);this.conf.hide&&this.hide(),"function"==typeof this._cpInitFRM&&this._cpInitFRM()}function dhtmlXSlider(t){var e=this;if(this.conf={size:null,skin:null,vertical:!1,min:0,max:99,value:0,step:1,decimals:0,margin:2,border:1,inverse:!1,disabled:!1,tooltip:!1,visible:!0,linkTo:null,range:!1,bg:null,bg_mode:"left"},this._attachedNode={},this._movingInitialValues=null,this.base=null,arguments.length>1)return new dhtmlXSlider(this._renderArgumets(arguments));if("string"==typeof t||"object"==typeof t&&t.tagName)return new dhtmlXSlider({parent:t});"string"==typeof t.parent?this.base=document.getElementById(t.parent):this.base=t.parent,this._mergeConfig(this._readAttFormNode(this.base)),this._mergeConfig(t),null==this.conf.bg&&(this.conf.bg=1==this.conf.range),1==this.conf.range&&(this.conf.value instanceof Array||(this.conf.value=[this.conf.value]),this.conf.value.length<2&&this.conf.value.push(this.conf.value[0]),this.conf.linkTo instanceof Array||(this.conf.linkTo=[this.conf.linkTo])),this._detectDecimals(),null!=this.conf.size&&void 0!==this.conf.size||(this.conf.vertical?this.conf.size=this.base.offsetHeight:this.conf.size=this.base.offsetWidth);var n=this.conf.skin||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxslider")||"material";return this.setSkin(n),this.base.innerHTML="<div class='dhxsl_container'><div class='dhxsl_track'>"+(1==this.conf.bg?"<div class='dhxsl_track_bg'></div>":"")+"</div><div class='dhxsl_runner'></div>"+(1==this.conf.range?"<div class='dhxsl_runner'></div>":"")+"</div>",this._nodes={cont:this.base.firstChild,track:this.base.firstChild.firstChild,runner:this.base.firstChild.childNodes[1],runner2:this.base.firstChild.childNodes[2]},this._nodes.cont.onmousedown=this._nodes.track.onmousedown=this._nodes.cont.onselectstart=this._nodes.track.onselectstart=function(t){return"function"==typeof(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this._r_actv=null,1==this.conf.range?this.conf.value=this._normalizeRange(this.conf.value,this.conf.min,this.conf.max):this.conf.value=this._normalize(this.conf.value,this.conf.min,this.conf.max),this._setOrient(this.conf.vertical),this.setSize(this.conf.size),this._initMover=function(t,n){if(!e.conf.disabled)return"function"==typeof(t=t||event).preventDefault&&t.preventDefault(),null!=n?e._r_actv=e._nodes[0==n?"runner":"runner2"]:(e._r_actv=t.target||t.srcElement,-1==e._r_actv.className.indexOf("dhxsl_runner")&&(e._r_actv=e._nodes.runner)),e._r_actv.className="dhxsl_runner dhxsl_runner_actv",e._movingInitialValues={},1==e.conf.range?(e._movingInitialValues.index=e._r_actv==e._nodes.runner?0:1,e._movingInitialValues.value=e.conf.value[e._movingInitialValues.index]):e._movingInitialValues.value=e.conf.value,e._movingInitialValues.coord=e._getTouchCoord(t),0==e.conf.disabled&&("function"==typeof window.addEventListener?(window.addEventListener("mousemove",e._move,!1),window.addEventListener("mouseup",e._cleanMove,!1),window.addEventListener("touchmove",e._move,!1),window.addEventListener("touchend",e._cleanMove,!1)):(document.body.attachEvent("onmousemove",e._move),document.body.attachEvent("onmouseup",e._cleanMove))),e.callEvent("onMouseDown",[e._r_actv==e._nodes.runner?0:1]),!1},this._move=function(t){if(!e.conf.disabled){"function"==typeof(t=t||event).preventDefault&&t.preventDefault();var n=e.conf.vertical?e._r_actv.offsetHeight:e._r_actv.offsetWidth,i=e.conf.max-e.conf.min,a=e._getTouchCoord(t),o=e._movingInitialValues.value+(a-e._movingInitialValues.coord)*i/(e.conf.size-n)*(e.conf.inverse?-1:1);if(1==e.conf.range){var r=[e.conf.value[0],e.conf.value[1]];0==e._movingInitialValues.index?r[0]=Math.min(r[1],o):1==e._movingInitialValues.index&&(r[1]=Math.max(r[0],o)),e.setValue(r,!0)}else e.setValue(o,!0)}},this._cleanMove=function(t){"function"==typeof window.addEventListener?(window.removeEventListener("mousemove",e._move,!1),window.removeEventListener("mouseup",e._cleanMove,!1),window.removeEventListener("touchmove",e._move,!1),window.removeEventListener("touchend",e._cleanMove,!1)):(document.body.detachEvent("onmousemove",e._move),document.body.detachEvent("onmouseup",e._cleanMove)),e._movingInitialValues=null,e._r_actv.className=e._r_actv.className.replace(/\s{0,}dhxsl_runner_actv/gi,""),e.callEvent("onSlideEnd",[e.conf.value]),e.callEvent("onMouseUp",[e._r_actv==e._nodes.runner?0:1]),e._r_actv=null},this._doOnSetValue=function(t){if(!e.conf.disabled){if(null!=e._movingInitialValues)return!1;"function"==typeof(t=t||event).preventDefault&&t.preventDefault();var n=0,i=t.target||t.srcElement;if(null!=i.className.match(/dhxsl_track_bg/)&&(n=parseInt(i.style[e.conf.vertical?"top":"left"])),null!=t.type.match(/touch/))var a=e._getTouchCoord(t)+n;else a=(e.conf.vertical?t.offsetY||t.layerY:t.offsetX||t.layerX)+n;e.conf.vertical?e._nodes.runner.offsetHeight:e._nodes.runner.offsetWidth;var o=e.conf.max-e.conf.min,r=null,s=null;return s=1==e.conf.inverse?e.conf.max-a*o/e.conf.size:a*o/e.conf.size+e.conf.min,1==e.conf.range&&(s=[0==(r=Math.abs(e.conf.value[0]-s)<=Math.abs(e.conf.value[1]-s)?0:1)?s:e.conf.value[0],1==r?s:e.conf.value[1]]),e.conf.init_index=r,e.setValue(s,!0),e.conf.init_index=null,null==e._movingInitialValues&&e._initMover(t,r),!1}},this._doOnChangeInput=function(t){var n=(t=t||event).target||t.srcElement;e.setValue(n.value)},this._doOnKeyDown=function(t){var n=(t=t||event).target||t.srcElement;13==t.keyCode&&e.setValue(n.value)},this._attachEvents(this._nodes),this.unload=function(){for(var t in dhx4._eventable(this,"clear"),this._detachNode(),this._detachEvents(this._nodes),this.base.removeChild(this._nodes.cont),this._nodes.cont.onmousedown=this._nodes.track.onmousedown=this._nodes.cont.onselectstart=this._nodes.track.onselectstart=null,delete this._nodes.cont,delete this._nodes.track,delete this._nodes.max,delete this._nodes.min,delete this._nodes.runner,this._nodes.runner2&&delete this._nodes.runner2,/\s?dhtmlxslider_\S*/.test(this.base.className)&&(this.base.className=this.base.className.replace(/\s?dhtmlxslider_\S*/,"")),this)this[t]=null;e=null},dhx4._eventable(this),this.conf.disabled&&this.disable(),this.conf.tooltip&&this.enableTooltip(),this.conf.visible||this.hide(),this.conf.linkTo&&this.linkTo(this.conf.linkTo),this}function dhtmlXPopup(t){var e=this;if(this.conf=t||{},t=null,this.mode=this.conf.mode||"bottom",this.conf.zi=window.dhx4.newId(),this.conf.context=null==this.conf.context||window.dhx4.s2b(this.conf.context),this.conf.IE6_display_fix=null!=this.conf.IE6_display_fix&&window.dhx4.s2b(this.conf.IE6_display_fix),this.conf.last_p_click=this.conf.last_body_click=null,this.p=document.createElement("DIV"),this.p.style.display="none",this.p.innerHTML="<div class='dhx_popup_area"+(window.dhx4.isIE?" dhx_popup_area_ie":"")+"'><table cellspacing='0' cellpadding='0' border='0' class='dhx_popup_table'><tbody></tbody></table></div><div class='dhx_popup_arrow dhx_popup_arrow_"+this.mode+"'></div>",document.body.appendChild(this.p),this.p.oncontextmenu=function(t){if(0==e.conf.context)return(t=t||event).returnValue=!1,!1},this.skinParams={dhx_terrace:{t0:19,t1:9,t2:19,t3:9},dhx_skyblue:{t0:12,t1:9,t2:12,t3:9},dhx_web:{t0:12,t1:9,t2:12,t3:9},material:{t0:19,t1:9,t2:19,t3:9}},this.p.ontouchstart=this.p.onclick=function(t){t=t||event;var n=null!=e.conf.last_p_click&&e.conf.last_p_click!=t.type;if(e.conf.last_p_click=t.type,1!=n){if(e._clearClick=!0,null!=e._nodeObj)return e.callEvent("onContentClick",[]),!0;for(var i=t.target||t.srcElement,a=null;i!=e.p&&null!=i;)void 0===i._idd||i._isSeparator?i=i.parentNode:(a=i._idd,i=null);i=null,null!=a&&(e.callEvent("onClick",[a]),null!=e&&null!=e.isVisible&&e.isVisible()&&!0===e.callEvent("onBeforeHide",["select",t,a])&&(t.cancelBubble=!0,e.hide()))}},this.separator="DHXSEP_"+window.dhx4.newId(),this.tpl=[],this._setTemplate=function(t){this.tpl=t.split(",")},this.show=function(t){var e=null;if(1==arguments.length){if(t){if(!this._idExists(t))return}else t=this.conf.id[0];this.conf.toolbar&&(e=this.conf.toolbar._getItemDim(t)),this.conf.ribbon&&(e=this.conf.ribbon._getItemDim(t)),this.conf.form&&(e=this.conf.form._getItemDim(t))}else 4==arguments.length&&(this._clearClick=!0,e={left:arguments[0],top:arguments[1],width:arguments[2],height:arguments[3]},t=null);e&&(this.p.style.visibility="hidden",this.p.style.display="",this._setPos(e),this.p.style.zIndex=window.dhx4.zim.reserve(this.conf.zi),this.p.style.visibility="visible",this._lastId=t,this.callEvent("onShow",[t]))},this._setPos=function(t,e){var n=t.left,i=t.top,a=t.width,o=t.height;this._posData={left:n,top:i,width:a,height:o};var r=window.dhx4.screenDim(),s=e||this.mode;void 0===e&&(e=!1);var l={top:i-this.p.offsetHeight-r.top,bottom:r.bottom-(i+o+this.p.offsetHeight),left:n-this.p.offsetWidth-r.left,right:r.right-(n+a+this.p.offsetWidth)};if(!e&&l[s]<0){var d=this._getAvailPos(s,l);if(!1!==d)return void this._setPos(t,d)}if("top"==s||"bottom"==s){var c=this.skinParams[this.conf.skin].t2,h=this.skinParams[this.conf.skin].t3,u=Math.round(this.p.offsetWidth/2),m=Math.round(this.p.lastChild.offsetWidth/2);if(n<r.left){var f=Math.min(n+a,r.left);a=n+a-f,n=f}n+a>r.right&&(a=r.right-n);var p=(v=Math.round(n+a/2))-u,_=v-c-m,A=v+m+c-this.p.offsetWidth;p<r.left-h?p=Math.min(r.left-h,_):p+this.p.offsetWidth>r.right+h&&(p=Math.max(A,r.right+h-this.p.offsetWidth)),this.p.style.left=p+"px",this.p.style.top=("top"==s?i-this.p.offsetHeight:i+o)+"px",v=v-p-m,this.p.lastChild.className="dhx_popup_arrow dhx_popup_arrow_"+s,this.p.lastChild.style.top=("top"==s?this.p.offsetHeight-this.p.lastChild.offsetHeight:0)+"px",this.p.lastChild.style.left=v+"px"}if("left"==s||"right"==s){c=this.skinParams[this.conf.skin].t0,h=this.skinParams[this.conf.skin].t1;var b=Math.round(this.p.offsetHeight/2),x=Math.round(this.p.lastChild.offsetHeight/2);if(i<r.top){var g=Math.min(i+o,r.top);o=i+o-g,i=g}i+o>r.bottom&&(o=r.bottom-i);var v,C=(v=Math.round(i+o/2))-b,y=v-c-x,w=v+x+c-this.p.offsetHeight;C<r.top-h?C=Math.min(r.top-h,y):C+this.p.offsetHeight>r.bottom+h&&(C=Math.max(w,r.bottom+h-this.p.offsetHeight)),this.p.style.left=("left"==s?n-this.p.offsetWidth:n+a)+"px",this.p.style.top=C+"px",v=v-C-x,this.p.lastChild.className="dhx_popup_arrow dhx_popup_arrow_"+s,this.p.lastChild.style.left=("left"==s?this.p.offsetWidth-this.p.lastChild.offsetWidth:0)+"px",this.p.lastChild.style.top=v+"px"}if(this._IEDisp&&null!=this._nodeId){var B=document.getElementById(this._nodeId);1==this.conf.IE6_display_fix&&(B.style.visibility="hidden"),window.setTimeout(function(){B.style.visibility="visible",B=null},1)}},this._getAvailPos=function(t,e){for(var n={top:["bottom","right","left"],bottom:["top","right","left"],left:["right","bottom","top"],right:["left","bottom","top"]},i=null,a=0;a<n[t].length;a++)null==i&&e[n[t][a]]>0&&(i=n[t][a]);if(null==i)for(var o in i="bottom",e)e[o]>e[i]&&(i=o);return i!=t&&i},this._repaint=function(){this.isVisible()&&this._setPos(this._posData)},this.clear=function(){if(this._nodeObj&&(window.dhx4.isIE&&"function"==typeof window.dhtmlXLayoutObject&&this._nodeObj instanceof window.dhtmlXLayoutObject&&(this.p.onmousedown=null),this._nodeObj.unload?this._nodeObj.unload():this._nodeObj.destruct&&this._nodeObj.destruct(),this._nodeObj=this._nodeId=null,null!=this._nodeObjEv)){for(var t=0;t<this._nodeObjEv.length;t++)this.detachEvent(this._nodeObjEv[t]);this._nodeObjEv=null}this._IEHoverInited&&this._IEHoverClear();for(var e=this.p.firstChild.firstChild.firstChild;e.childNodes.length>0;)e.removeChild(e.lastChild);e=null,this.itemData={}},this.hide=function(){if("none"!=this.p.style.display){this.p.style.display="none",window.dhx4.zim.clear(this.conf.zi);var t=this._lastId;this._lastId=null,this.callEvent("onHide",[t]),this.conf.last_p_click=this.conf.last_body_click=null}},this.isVisible=function(){return""==this.p.style.display},this.itemData={},this.getItemData=function(t){return t?this.itemData[t]?this.itemData[t]:{}:this.itemData},this.setSkin=function(t){this.conf.skin=t,this.p.className="dhx_popup_"+this.conf.skin,null!=this._nodeObj&&"function"==typeof this._nodeObj.setSkin&&this._nodeObj.setSkin(this.conf.skin),this._repaint()},this.attachList=function(t,e){this._setTemplate(t),this.clear();for(var n=this.p.firstChild.firstChild.firstChild,i=0;i<e.length;i++){var a=document.createElement("TR");if(e[i]!=this.separator){if(void 0===e[i].id||null==e[i].id)for(a._idd=window.dhx4.newId();null!=this.itemData[a._idd];)a._idd=window.dhx4.newId();else a._idd=e[i].id;this.itemData[a._idd]=e[i]}if(n.appendChild(a),e[i]==this.separator){a.className="dhx_popup_sep",a._isSeparator=!0,(r=document.createElement("TD")).className="dhx_popup_sep",r.colSpan=this.tpl.length,r.innerHTML="<div class='dhx_popup_sep'>&nbsp;</div>",a.appendChild(r),r=null}else{for(var o=0;o<this.tpl.length;o++){var r,s="dhx_popup_td";!this._IEFirstLast||1!=this.tpl.length&&0!=o&&o!=this.tpl.length-1||(1==this.tpl.length?s+=" dhx_popup_td_single":s+=0==o?" dhx_popup_td_first":" dhx_popup_td_last"),(r=document.createElement("TD")).className=s,r.innerHTML=e[i][this.tpl[o]]||"&nbsp;",a.appendChild(r),r=null}this._IEHover&&(a._IEHover=!0,this._IEHoverInited||this._IEHoverInit())}a=null}n=null,this._repaint()},this._attachNode=function(t,e){this.clear(),this._nodeId="dhxpopup_node_"+window.dhx4.newId();var n=this.p.firstChild.firstChild.firstChild,i=document.createElement("TR");i.className="dhxnode",n.appendChild(i);var a=document.createElement("TD");return a.className="dhx_popup_td",a.innerHTML="<div id='"+this._nodeId+"' style='position:relative;'></div>",e.width&&(a.firstChild.style.width=e.width+"px"),e.height&&(a.firstChild.style.height=e.height+"px"),i.appendChild(a),a=i=n=null,"function"==typeof this["_attach_init_"+t]&&(this["_attach_init_"+t](e),this._enableIEVFix()),this._repaint(),this._nodeObj},this.unload=function(){if("function"==typeof window.addEventListener?(window.removeEventListener("touchstart",this._doOnClick,!1),window.removeEventListener("click",this._doOnClick,!1),window.removeEventListener("keyup",this._doOnKeyUp,!1),window.removeEventListener("unload",this._doOnUnload,!1)):(document.body.detachEvent("onclick",this._doOnClick,!1),document.body.detachEvent("onkeyup",this._doOnKeyUp,!1),document.body.detachEvent("onunload",this._doOnUnload,!1)),window.dhx4.detachEvent(this.conf.ev_grid_click),this.clear(),null!=this.conf.toolbarEvent&&null!=this.conf.toolbar&&(null!=this.conf.toolbar.detachEvent?this.conf.toolbar.detachEvent(this.conf.toolbarEvent):this.conf.toolbar._getItemDim=null),null!=this.conf.ribbonEvent&&null!=this.conf.ribbon&&(null!=this.conf.ribbon.detachEvent?this.conf.ribbon.detachEvent(this.conf.ribbonEvent):this.conf.ribbon._getItemDim=null),null!=this.conf.slider){for(var t=0;t<this.conf.slider_events.length;t++)this.conf.slider.detachEvent(this.conf.slider_events[t]);this.conf.slider_events=null,this._sliderShow=this._sliderHide=null,this.conf.slider=null}for(var n in window.dhx4._eventable(this,"clear"),this.p.onclick=this.p.ontouchstart=this.p.oncontextmenu=null,this.p.parentNode.removeChild(this.p),this.p=null,this.conf)this.conf[n]=null;for(var n in this)this[n]=null;e=null},window.dhx4._eventable(this),this._doOnClick=function(t){t=t||event;var n=null!=e.conf.last_body_click&&e.conf.last_body_click!=t.type;if(e.conf.last_body_click=t.type,1!=n)if(1!=e._clearClick){if(null!=e.conf.form){var i;if("option"==((d=t.target||t.srcElement).tagName||"").toLowerCase()&&(d=d.parentNode),null!=d.className&&d.className.search("dhxform")>=0)null!=d.parentNode&&null!=d.parentNode.parentNode&&null!=d.parentNode.parentNode._idd&&(i=d.parentNode.parentNode._idd,"ra"==d.parentNode.parentNode._type&&(i=[d.parentNode.parentNode._group,d.parentNode.parentNode._value]));else{for(var a=!0,o=!1;a&&!o;){(s=(d.className||"").toLowerCase()).length>0&&(o="dhxform_btn"==s||s.search(/dhxeditor_inside/gi)>=0||"dhxcombo_input"==s||s.search(/dhxcombolist/gi)>=0),a=null!=(d=d.parentNode)}if(o)return}if(d=null,null!=i&&e._idExists(i))return}if("function"==typeof window.dhtmlXForm&&e._nodeObj instanceof window.dhtmlXForm){var r={},s=0,l=e._nodeObj;if(l.forEachItem(function(t){"combo"==l.getItemType(t)&&(r[l.getCombo(t).list._listId]=!0,s++)}),l=null,s>0){var d=t.target||t.srcElement;for(a=!0,o=!1;1==a&&1!=o;){(s=(d.className||"").toLowerCase()).length>0&&s.search(/^dhxcombolist/gi)>=0&&null!=d._listId&&1==r[d._listId]?(o=!0,d=null):a=null!=(d=d.parentNode)}if(1==o)return}}e.isVisible()&&!0===e.callEvent("onBeforeHide",["click",t])&&e.hide()}else e._clearClick=!1},this._doOnKeyUp=function(t){27==(t=t||event).keyCode&&e.isVisible()&&!0===e.callEvent("onBeforeHide",["esc",t])&&e.hide()},this._doOnUnload=function(){e.unload()},"function"==typeof window.addEventListener?(window.addEventListener("touchstart",this._doOnClick,!1),window.addEventListener("click",this._doOnClick,!1),window.addEventListener("keyup",this._doOnKeyUp,!1),window.addEventListener("unload",this._doOnUnload,!1)):(document.body.attachEvent("onclick",this._doOnClick,!1),document.body.attachEvent("onkeyup",this._doOnKeyUp,!1),document.body.attachEvent("onunload",this._doOnUnload,!1)),this.conf.ev_grid_click=window.dhx4.attachEvent("_onGridClick",function(t,n){e.p.contains(n.entBox)||(e._clearClick=!1,e._doOnClick(t)),n=null}),this._findGrid=function(t,e){var n=!1;return"function"==typeof window.dhtmlXTabBar&&t instanceof window.dhtmlXTabBar&&t.forEachTab(function(t){var i=t.getAttachedObject();0==n&&null!=i&&(n=n||i==e||this._findGrid(i),i=null)}),"function"==typeof window.dhtmlXForm&&t instanceof window.dhtmlXForm&&t.forEachItem(function(i){1!=n&&"container"==t.getItemType(i)&&e.entBox==t.getContainer(i)&&(n=!0)}),t=null,n},this._idExists=function(t){for(var e=!1,n=0;n<this.conf.id.length;n++)e=this.conf.id[n]instanceof Array?e||this.conf.id[n][0]==t[0]&&this.conf.id[n][1]==t[1]:e||this.conf.id[n]==t;return e},this._IEDisp=window.dhx4.isIE6||"CSS1Compat"!=document.compatMode,this._IEHover=1==window.dhx4.isIE6,this._IEHover&&(this._IEHoverInit=function(){this.p.onmouseover=function(){for(var t=event.srcElement;t!=this&&1!=t._IEHover;)t=t.parentNode;if(t._IEHover){if(e._IEHoverTM&&window.clearTimeout(e._IEHoverTM),e._lastIEHover==t)return;e._IEHoverRender(t),t=null}},this.p.onmouseout=function(){e._IEHoverTM&&window.clearTimeout(e._IEHoverTM),e._IEHoverTM=window.setTimeout(function(){e._IEHoverRender(null)},1)},this._IEHoverRender=function(t){null!=this._lastIEHover&&this._lastIEHover.className.search(/tr_hover/gi)>=0&&(this._lastIEHover.className=this._lastIEHover.className.replace(/\s{0,}tr_hover/gi,""),this._lastIEHover=null),null!=t&&t.className.search(/tr_hover/gi)<0&&(t.className+=" tr_hover",e._lastIEHover=t)},this._IEHoverInited=!0},this._IEHoverClear=function(){this.p.onmouseover=null,this.p.onmouseout=null,this._IEHoverInited=!1}),this._IEFirstLast=window.dhx4.isIE6||window.dhx4.isIE7||window.dhx4.isIE8,this._enableIEVFix=function(){if(window.dhx4.isIE6||window.dhx4.isIE7){var t=this.attachEvent("onHide",function(){document.getElementById(this._nodeId).style.visibility="hidden"}),e=this.attachEvent("onShow",function(){document.getElementById(this._nodeId).style.visibility="visible"});null==this._nodeObjEv&&(this._nodeObjEv=[]),this._nodeObjEv.push(t,e)}},"function"==typeof window.dhtmlXToolbarObject&&null!=this.conf.toolbar&&this.conf.toolbar instanceof window.dhtmlXToolbarObject&&null!=this.conf.id&&(this.conf.id instanceof Array||(this.conf.id=[this.conf.id]),this.skinParent=this.conf.toolbar.conf.skin,this._doOnToolbarClick=function(t){for(var n=0;n<e.conf.id.length;n++)t==e.conf.id[n]&&t!=e._lastId&&(e.show(t),e._clearClick=!0)},void 0===dhtmlXToolbarObject.prototype._getItemDim&&(dhtmlXToolbarObject.prototype._getItemDim=function(t){var e=this.objPull[this.idPrefix+t],n={left:window.dhx4.absLeft(e.obj),top:window.dhx4.absTop(e.obj),width:e.obj.offsetWidth+(e.arw?e.arw.offsetWidth:0),height:e.obj.offsetHeight};return e=null,n}),this.conf.toolbarEvent=this.conf.toolbar.attachEvent("onClick",this._doOnToolbarClick)),"function"==typeof window.dhtmlXRibbon&&null!=this.conf.ribbon&&this.conf.ribbon instanceof window.dhtmlXRibbon&&null!=this.conf.id&&(this.conf.id instanceof Array||(this.conf.id=[this.conf.id]),this.skinParent=this.conf.ribbon.conf.skin,this._doOnRibbonClick=function(t){for(var n=0;n<e.conf.id.length;n++)t==e.conf.id[n]&&t!=e._lastId&&(e.show(t),e._clearClick=!0)},void 0===dhtmlXRibbon.prototype._getItemDim&&(dhtmlXRibbon.prototype._getItemDim=function(t){var e=this._items[t].base,n={left:window.dhx4.absLeft(e),top:window.dhx4.absTop(e),width:e.offsetWidth,height:e.offsetHeight};return e=null,n}),this.conf.ribbonEvent=this.conf.ribbon.attachEvent("_showPopup",this._doOnRibbonClick)),"function"==typeof window.dhtmlXForm&&null!=this.conf.form&&this.conf.form instanceof window.dhtmlXForm&&null!=this.conf.id&&(this.conf.id instanceof Array||(this.conf.id=[this.conf.id]),this.conf.mode||(this.mode="right"),this.skinParent=this.conf.form.skin,void 0===dhtmlXForm.prototype._getItemDim))for(var n in dhtmlXForm.prototype._getItemDim=function(t,e){return this.doWithItem(t,"_getDim")},dhtmlXForm.prototype.items)dhtmlXForm.prototype.items[n]._getDim=function(t){var e=t;({ta:!0,pw:!0,se:!0,tp:!0,fl:!0,calendar:!0,colorpicker:1,editor:!0,container:!0})[t._type]&&(e=t.childNodes[t._ll?1:0].childNodes[0]),{ch:!0,ra:!0,btn2state:!0}[t._type]&&(e=t.childNodes[t._ll?1:0].childNodes[1]),{bt:!0,lb:!0,fs:!0}[t._type]&&(e=t.firstChild),{combo:!0}[t._type]&&(e=t._combo.DOMParent.firstChild),{image:!0}[t._type]&&(e=t.childNodes[t._ll?1:0].lastChild),{bl:!0}[t._type]&&(e=t.firstChild.firstChild.firstChild);var n={left:window.dhx4.absLeft(e),top:window.dhx4.absTop(e),width:e.offsetWidth,height:e.offsetHeight};return e=null,n};return"function"==typeof window.dhtmlXSlider&&null!=this.conf.slider&&this.conf.slider instanceof window.dhtmlXSlider&&(this.conf.mode||(this.mode="top"),this.conf.slider_tm=null,this._sliderShow=function(){e.conf.slider_tm&&window.clearTimeout(e.conf.slider_tm);var t=e.conf.slider._r_actv;if(null!=t){var n={left:window.dhx4.absLeft(t),top:window.dhx4.absTop(t),width:t.offsetWidth,height:t.offsetHeight};e.show(n.left,n.top,n.width,n.height),t=null}},this._sliderHide=function(){e.conf.slider_tm=window.setTimeout(function(){e.hide()},200)},this.conf.slider_events=[this.conf.slider.attachEvent("onMouseDown",this._sliderShow),this.conf.slider.attachEvent("onMouseUp",this._sliderHide),this.conf.slider.attachEvent("onChange",this._sliderShow)]),this.setSkin(this.skinParent||this.conf.skin||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhx_popup")||"material"),this}function dhtmlXMenuObject(t,e){var n=this;if(this.conf={skin:e||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxmenu")||"material",mode:"web",align:"left",is_touched:!1,selected:-1,last_click:-1,fixed_pos:!1,rtl:!1,icons_path:"",icons_css:!1,arrow_ff_fix:navigator.userAgent.indexOf("MSIE")>=0&&"BackCompat"==document.compatMode,live_id:window.dhx4.newId(),tags:{root:"menu",item:"item",text_ext:"itemtext",userdata:"userdata",tooltip:"tooltip",hotkey:"hotkey",href:"href"},autoload:{},hide_tm:{},top_mode:!0,top_tmtime:200,v_enabled:!1,v:{x1:null,x2:null,y1:null,y2:null},dir_toplv:"bottom",dir_sublv:"right",auto_overflow:!1,overflow_limit:0,of_utm:null,of_utime:20,of_ustep:3,of_dtm:null,of_dtime:20,of_dstep:3,of_ah:{dhx_skyblue:24,dhx_web:25,dhx_terrace:27,material:25},of_ih:{dhx_skyblue:24,dhx_web:24,dhx_terrace:24,material:30},tm_sec:400,tm_handler:null,dload:!1,dload_url:"",dload_icon:!1,dload_params:{action:"loadMenu"},dload_pid:"parentId",tl_botmarg:1,tl_rmarg:0,tl_ofsleft:1,context:!1,ctx_zoneid:!1,ctx_autoshow:!0,ctx_autohide:!0,ctx_hideall:!0,ctx_zones:{},ctx_baseid:null,selected_sub:[],opened_poly:[]},"object"==typeof t&&null!=t&&void 0===t.tagName){for(var i in null==t.icons_path&&null==t.icon_path||(this.conf.icons_path=t.icons_path||t.icon_path),null!=t.skin&&(this.conf.skin=t.skin),t.visible_area&&(this.conf.v_enabled=!0,this.conf.v={x1:t.visible_area.x1,x2:t.visible_area.x2,y1:t.visible_area.y1,y2:t.visible_area.y2}),{json:1,xml:1,items:1,top_text:1,align:1,open_mode:1,overflow:1,dynamic:1,dynamic_icon:1,context:1,onload:1,onclick:1,oncheckboxclick:1,onradioclick:1,iconset:1})null!=t[i]&&(this.conf.autoload[i]=t[i]);t=t.parent}if(null==t)this.base=document.body;else{var a="string"==typeof t?document.getElementById(t):t;null!=a?(this.base=a,this.base.id||(this.base.id="menuBaseId_"+(new Date).getTime()),this.base.className+=" dhtmlxMenu_"+this.conf.skin+"_Middle dir_left",this.base._autoSkinUpdate=!0,this.base.oncontextmenu&&(this.base._oldContextMenuHandler=this.base.oncontextmenu),this.conf.ctx_baseid=this.base,this.base.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this.base.oncontextmenu=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1}):this.base=document.body}for(var i in this.idPrefix="",this.topId="dhxWebMenuTopId",this.idPull={},this.itemPull={},this.userData={},this.radio={},this.setSkin=function(t){var e=this.conf.skin;switch(this.conf.skin=t,this.conf.skin){case"dhx_skyblue":case"dhx_web":this.conf.tl_botmarg=2,this.conf.tl_rmarg=1,this.conf.tl_ofsleft=1;break;case"dhx_terrace":case"material":this.conf.tl_botmarg=0,this.conf.tl_rmarg=0,this.conf.tl_ofsleft=0}for(var n in this.base._autoSkinUpdate&&(this.base.className=this.base.className.replace("dhtmlxMenu_"+e+"_Middle","")+" dhtmlxMenu_"+this.conf.skin+"_Middle"),this.idPull)this.idPull[n].className=String(this.idPull[n].className).replace(e,this.conf.skin)},this.setSkin(this.conf.skin),this._addSubItemToSelected=function(t,e){for(var n=!0,i=0;i<this.conf.selected_sub.length;i++)this.conf.selected_sub[i][0]==t&&this.conf.selected_sub[i][1]==e&&(n=!1);return 1==n&&this.conf.selected_sub.push(new Array(t,e)),n},this._removeSubItemFromSelected=function(t,e){for(var n=new Array,i=!1,a=0;a<this.conf.selected_sub.length;a++)this.conf.selected_sub[a][0]==t&&this.conf.selected_sub[a][1]==e?i=!0:n[n.length]=this.conf.selected_sub[a];return 1==i&&(this.conf.selected_sub=n),i},this._getSubItemToDeselectByPolygon=function(t){for(var e=new Array,n=0;n<this.conf.selected_sub.length;n++)if(this.conf.selected_sub[n][1]==t){e[e.length]=this.conf.selected_sub[n][0],e=e.concat(this._getSubItemToDeselectByPolygon(this.conf.selected_sub[n][0]));for(var i=!0,a=0;a<this.conf.opened_poly.length;a++)this.conf.opened_poly[a]==this.conf.selected_sub[n][0]&&(i=!1);1==i&&(this.conf.opened_poly[this.conf.opened_poly.length]=this.conf.selected_sub[n][0]),this.conf.selected_sub[n][0]=-1,this.conf.selected_sub[n][1]=-1}return e},this._hidePolygon=function(t){if(null!=this.idPull["polygon_"+t]){if(null!=this.idPull["polygon_"+t]._zId&&window.dhx4.zim.clear(this.idPull["polygon_"+t]._zId),void 0!==this._menuEffect&&!1!==this._menuEffect)this._hidePolygonEffect("polygon_"+t);else{if("none"==this.idPull["polygon_"+t].style.display)return;this.idPull["polygon_"+t].style.display="none",null!=this.idPull["arrowup_"+t]&&(this.idPull["arrowup_"+t].style.display="none"),null!=this.idPull["arrowdown_"+t]&&(this.idPull["arrowdown_"+t].style.display="none"),this._updateItemComplexState(t,!0,!1),window.dhx4.isIE6&&null!=this.idPull["polygon_"+t+"_ie6cover"]&&(this.idPull["polygon_"+t+"_ie6cover"].style.display="none")}(t=String(t).replace(this.idPrefix,""))==this.topId&&(t=null),this.callEvent("onHide",[t]),null!=t&&"dhx_terrace"==this.conf.skin&&this.itemPull[this.idPrefix+t].parent==this.idPrefix+this.topId&&this._improveTerraceButton(this.idPrefix+t,!0)}},this._showPolygon=function(t,e){var n=this._countVisiblePolygonItems(t);if(0!=n){var i="polygon_"+t;if(null!=this.idPull[i]&&null!=this.idPull[t]){if(this.conf.top_mode&&"web"==this.conf.mode&&!this.conf.context&&!this.idPull[t]._mouseOver&&e==this.conf.dir_toplv)return;this.conf.fixed_pos||this._autoDetectVisibleArea();var a=null,o=null;if(null==this.idPull[i]._zId&&(this.idPull[i]._zId=window.dhx4.newId()),this.idPull[i]._zInd=window.dhx4.zim.reserve(this.idPull[i]._zId),this.idPull[i].style.visibility="hidden",this.idPull[i].style.left="0px",this.idPull[i].style.top="0px",this.idPull[i].style.display="",this.idPull[i].style.zIndex=this.idPull[i]._zInd,this.conf.auto_overflow)if(this.idPull[i].childNodes[1].childNodes[0].offsetHeight>this.conf.v.y2-this.conf.v.y1){var r=Math.max(Math.floor((this.conf.v.y2-this.conf.v.y1-2*this.conf.of_ah[this.conf.skin])/this.conf.of_ih[this.conf.skin]),1);this.conf.overflow_limit=r}else this.conf.overflow_limit=0,null!=this.idPull["arrowup_"+t]&&this._removeUpArrow(String(t).replace(this.idPrefix,"")),null!=this.idPull["arrowdown_"+t]&&this._removeDownArrow(String(t).replace(this.idPrefix,""));if(this.conf.overflow_limit>0&&this.conf.overflow_limit<n&&(null==this.idPull["arrowup_"+t]&&this._addUpArrow(String(t).replace(this.idPrefix,"")),null==this.idPull["arrowdown_"+t]&&this._addDownArrow(String(t).replace(this.idPrefix,"")),(a=this.idPull["arrowup_"+t]).style.display="none",(o=this.idPull["arrowdown_"+t]).style.display="none"),this.conf.overflow_limit>0&&this.conf.overflow_limit<n?(this.idPull[i].childNodes[1].style.height=this.conf.of_ih[this.conf.skin]*this.conf.overflow_limit+"px",a.style.width=o.style.width=this.idPull[i].childNodes[1].style.width=this.idPull[i].childNodes[1].childNodes[0].offsetWidth+"px",this.idPull[i].childNodes[1].scrollTop=0,a.style.display="",a.offsetHeight,o.style.display="",o.offsetHeight):(this.idPull[i].childNodes[1].style.height="",this.idPull[i].childNodes[1].style.width=""),null!=this.itemPull[t])this.itemPull[t].parent;else if(this.conf.context)this.idPull[this.idPrefix+this.topId];var s=null!=this.idPull[t].tagName?window.dhx4.absLeft(this.idPull[t]):this.idPull[t][0],l=null!=this.idPull[t].tagName?window.dhx4.absTop(this.idPull[t]):this.idPull[t][1],d=null!=this.idPull[t].tagName?this.idPull[t].offsetWidth:0,c=null!=this.idPull[t].tagName?this.idPull[t].offsetHeight:0,h=0,u=0,m=this.idPull[i].offsetWidth,f=this.idPull[i].offsetHeight;if("bottom"==e&&(h=this.conf.rtl?s+(null!=d?d:0)-m:"right"==this.conf.align?s+d-m:s-1+(e==this.conf.dir_toplv?this.conf.tl_rmarg:0),u=l-1+c+this.conf.tl_botmarg),"right"==e&&(h=s+d-1,u=l+2),"left"==e&&(h=s-this.idPull[i].offsetWidth+2,u=l+2),"top"==e&&(h=s-1,u=l-f+2),this.conf.fixed_pos)var p=65536,_=65536;else{p=null!=this.conf.v.x2?this.conf.v.x2:0,_=null!=this.conf.v.y2?this.conf.v.y2:0;0==p&&(window.innerWidth?(p=window.innerWidth,_=window.innerHeight):(p=document.body.offsetWidth,_=document.body.scrollHeight))}if(h+m>p&&!this.conf.rtl&&(h=s-m+2),h<this.conf.v.x1&&this.conf.rtl&&(h=s+d-2),h<0&&(h=0),u+f>_&&null!=this.conf.v.y2&&(u=Math.max(l+c-f+2,this.conf.v_enabled?this.conf.v.y1+2:2),this.conf.context&&this.idPrefix+this.topId==t&&null!=o&&(u-=2),null==this.itemPull[t]||this.conf.context||this.itemPull[t].parent==this.idPrefix+this.topId&&(u-=this.base.offsetHeight)),this.idPull[i].style.left=h+"px",this.idPull[i].style.top=u+"px",void 0!==this._menuEffect&&!1!==this._menuEffect)this._showPolygonEffect(i);else if(this.idPull[i].style.visibility="",this.conf.overflow_limit>0&&this.conf.overflow_limit<n&&(this.idPull[i].childNodes[1].scrollTop=0,this._checkArrowsState(t)),window.dhx4.isIE6){var A=i+"_ie6cover";if(null==this.idPull[A]){var b=document.createElement("IFRAME");b.className="dhtmlxMenu_IE6CoverFix_"+this.conf.skin,b.frameBorder=0,b.setAttribute("src","javascript:false;"),document.body.insertBefore(b,document.body.firstChild),this.idPull[A]=b}this.idPull[A].style.left=h+"px",this.idPull[A].style.top=u+"px",this.idPull[A].style.width=this.idPull[i].offsetWidth+"px",this.idPull[A].style.height=this.idPull[i].offsetHeight+"px",this.idPull[A].style.zIndex=this.idPull[i].style.zIndex-1,this.idPull[A].style.display=""}(t=String(t).replace(this.idPrefix,""))==this.topId&&(t=null),this.callEvent("onShow",[t]),null!=t&&"dhx_terrace"==this.conf.skin&&this.itemPull[this.idPrefix+t].parent==this.idPrefix+this.topId&&this._improveTerraceButton(this.idPrefix+t,!1)}}},this._redistribSubLevelSelection=function(t,e){for(;this.conf.opened_poly.length>0;)this.conf.opened_poly.pop();var n=this._getSubItemToDeselectByPolygon(e);this._removeSubItemFromSelected(-1,-1);for(var i=0;i<n.length;i++)null!=this.idPull[n[i]]&&n[i]!=t&&"enabled"==this.itemPull[n[i]].state&&(this.idPull[n[i]].className="sub_item");for(i=0;i<this.conf.opened_poly.length;i++)this.conf.opened_poly[i]!=e&&this._hidePolygon(this.conf.opened_poly[i]);if("enabled"==this.itemPull[t].state){if(this.idPull[t].className="sub_item_selected",this.itemPull[t].complex&&this.conf.dload&&"no"==this.itemPull[t].loaded){1==this.conf.dload_icon&&this._updateLoaderIcon(t,!0),this.itemPull[t].loaded="get";var a=t.replace(this.idPrefix,"");this._dhxdataload.onBeforeXLS=function(){var t={params:{}};for(var e in t.params[this.conf.dload_pid]=a,this.conf.dload_params)t.params[e]=this.conf.dload_params[e];return t},this.loadStruct(this.conf.dload_url)}(this.itemPull[t].complex||this.conf.dload&&"yes"==this.itemPull[t].loaded)&&this.itemPull[t].complex&&null!=this.idPull["polygon_"+t]&&(this._updateItemComplexState(t,!0,!0),this._showPolygon(t,this.conf.dir_sublv)),this._addSubItemToSelected(t,e),this.conf.selected=t}},this._doOnClick=function(t,e,n){if(this.conf.last_click=t,null!=this.itemPull[this.idPrefix+t].href_link&&"enabled"==this.itemPull[this.idPrefix+t].state){var i=document.createElement("FORM"),a=String(this.itemPull[this.idPrefix+t].href_link).split("?");if(i.action=a[0],null!=a[1])for(var o=String(a[1]).split("&"),r=0;r<o.length;r++){var s=String(o[r]).split("="),l=document.createElement("INPUT");l.type="hidden",l.name=s[0]||"",l.value=s[1]||"",i.appendChild(l)}return null!=this.itemPull[this.idPrefix+t].href_target&&(i.target=this.itemPull[this.idPrefix+t].href_target),i.style.display="none",document.body.appendChild(i),i.submit(),void(null!=i&&(document.body.removeChild(i),i=null))}if("c"!=e.charAt(0)&&"d"!=e.charAt(1)&&"s"!=e.charAt(2)){if(this.checkEvent("onClick"))this.callEvent("onClick",[t,this.conf.ctx_zoneid,n]);else if("d"==e.charAt(1)||"win"==this.conf.mode&&"t"==e.charAt(2))return;this.conf.context&&this._isContextMenuVisible()&&this.conf.ctx_autohide?this._hideContextMenu():this._clearAndHide&&this._clearAndHide()}},this._doOnTouchMenu=function(t){0==this.conf.is_touched&&(this.conf.is_touched=!0,this.checkEvent("onTouch")&&this.callEvent("onTouch",[t]))},this._searchMenuNode=function(t,e){for(var n=new Array,i=0;i<e.length;i++)if("object"==typeof e[i]){5==e[i].length&&"object"!=typeof e[i][0]&&e[i][0].replace(this.idPrefix,"")==t&&0==i&&(n=e);var a=this._searchMenuNode(t,e[i]);a.length>0&&(n=a)}return n},this._getMenuNodes=function(t){var e=new Array;for(var n in this.itemPull)this.itemPull[n].parent==t&&(e[e.length]=n);return e},this._genStr=function(t){for(var e="dhxId_",n="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",i=0;i<t;i++)e+=n.charAt(Math.round(Math.random()*(n.length-1)));return e},this.getItemType=function(t){return t=this.idPrefix+t,null==this.itemPull[t]?null:this.itemPull[t].type},this.forEachItem=function(t){for(var e in this.itemPull)t(String(e).replace(this.idPrefix,""))},this._clearAndHide=function(){for(n.conf.selected=-1,n.conf.last_click=-1;n.conf.opened_poly.length>0;)n.conf.opened_poly.pop();for(var t=0;t<n.conf.selected_sub.length;t++){var e=n.conf.selected_sub[t][0];null!=n.idPull[e]&&"enabled"==n.itemPull[e].state&&("sub_item_selected"==n.idPull[e].className&&(n.idPull[e].className="sub_item"),n.idPull[e].className=="dhtmlxMenu_"+n.conf.skin+"_TopLevel_Item_Selected"&&(null!=n.itemPull[e].cssNormal?n.idPull[e].className=n.itemPull[e].cssNormal:n.idPull[e].className="dhtmlxMenu_"+n.conf.skin+"_TopLevel_Item_Normal")),n._hidePolygon(e)}n.conf.is_touched=!1,n.conf.context&&n.conf.ctx_hideall&&n._hidePolygon(n.idPrefix+n.topId)},this._showSubLevelItem=function(t,e){null!=document.getElementById("arrow_"+this.idPrefix+t)&&(document.getElementById("arrow_"+this.idPrefix+t).style.display=e?"none":""),null!=document.getElementById("image_"+this.idPrefix+t)&&(document.getElementById("image_"+this.idPrefix+t).style.display=e?"none":""),null!=document.getElementById(this.idPrefix+t)&&(document.getElementById(this.idPrefix+t).style.display=e?"":"none")},this._hideSubLevelItem=function(t){this._showSubLevelItem(t,!0)},this.idPrefix=this._genStr(12)+"_",this._bodyClick=function(t){2==(t=t||event).button||window.dhx4.isOpera&&1==t.ctrlKey||(n.conf.context?n.conf.ctx_autohide&&(!window.dhx4.isOpera||n._isContextMenuVisible()&&window.dhx4.isOpera)&&n._hideContextMenu():n._clearAndHide&&n._clearAndHide())},this._bodyContext=function(t){t=t||event;var e=String((t.srcElement||t.target).className);if(-1==e.search("dhtmlxMenu")||-1==e.search("SubLevelArea")){for(var i=!0,a=t.target||t.srcElement;null!=a;)null!=a.id&&n.isContextZone(a.id)&&(i=!1),a==document.body&&(i=!1),a=a.parentNode;i&&n.hideContextMenu()}},void 0!==window.addEventListener?(window.addEventListener("click",this._bodyClick,!1),window.addEventListener("contextmenu",this._bodyContext,!1)):(document.body.attachEvent("onclick",this._bodyClick),document.body.attachEvent("oncontextmenu",this._bodyContext)),dhx4.attachEvent("_onGridClick",this._bodyClick),this.unload=function(){window.dhx4._eventable(this,"clear"),dhtmlXMenuObject.prototype.liveInst[this.conf.live_id]=null;try{delete dhtmlXMenuObject.prototype.liveInst[this.conf.live_id]}catch(t){}if(this.conf.live_id=null,"function"==typeof window.addEventListener?(window.removeEventListener("click",this._bodyClick,!1),window.removeEventListener("contextmenu",this._bodyContext,!1)):(document.body.detachEvent("onclick",this._bodyClick),document.body.detachEvent("oncontextmenu",this._bodyContext)),this._bodyClick=null,this._bodyContext=null,this.removeItem(this.idPrefix+this.topId,!0),this.itemPull=null,this.idPull=null,this.conf.context)for(var t in this.conf.ctx_zones)this.removeContextZone(t);for(var t in null!=this.cont&&(this.cont.className="",this.cont.parentNode.removeChild(this.cont),this.cont=null),null!=this.base&&(this.conf.context||(this.base.className=""),this.conf.context||(this.base.oncontextmenu=this.base._oldContextMenuHandler||null),this.base.onselectstart=null,this.base=null),this)this[t]=null;n=null},dhtmlXMenuObject.prototype.liveInst[this.conf.live_id]=this,window.dhx4._enableDataLoading(this,"_initObj","_xmlToJson",this.conf.tags.root,{struct:!0}),window.dhx4._eventable(this),1==window.dhx4.s2b(this.conf.autoload.context)&&this.renderAsContextMenu(),"awesome"==this.conf.autoload.iconset&&(this.conf.icons_css=!0),null!=this.conf.autoload.dynamic?this.enableDynamicLoading(this.conf.autoload.dynamic,window.dhx4.s2b(this.conf.autoload.dynamic_icon)):null!=this.conf.autoload.items?this.loadStruct(this.conf.autoload.items,this.conf.autoload.onload):null!=this.conf.autoload.json?this.loadStruct(this.conf.autoload.json,this.conf.autoload.onload):null!=this.conf.autoload.xml&&this.loadStruct(this.conf.autoload.xml,this.conf.autoload.onload),{onclick:1,oncheckboxclick:1,onradioclick:1})null!=this.conf.autoload[i]&&("function"==typeof this.conf.autoload[i]?this.attachEvent(i,this.conf.autoload[i]):"function"==typeof window[this.conf.autoload[i]]&&this.attachEvent(i,window[this.conf.autoload[i]]));for(var i in null!=this.conf.autoload.top_text&&this.setTopText(this.conf.autoload.top_text),null!=this.conf.autoload.align&&this.setAlign(this.conf.autoload.align),null!=this.conf.autoload.open_mode&&this.setOpenMode(this.conf.autoload.open_mode),null!=this.conf.autoload.overflow&&this.setOverflowHeight(this.conf.autoload.overflow),this.conf.autoload)this.conf.autoload[i]=null,delete this.conf.autoload[i];return this.conf.autoload=null,this}function dhtmlXRibbon(t){var e,n,i=this;this.conf={type:"ribbon",icons_path:t&&t.icons_path?t.icons_path:"",icons_css:t&&"awesome"==t.iconsset,arrows_mode:t&&t.arrows_mode?t.arrows_mode:null,skin:"dhx_skyblue"},this._eventHandlers={},this._base=null,this._items={},this._tabbar=null,this.childIds=[],"string"==typeof t?n=t:t&&t.tagName?n=t:t&&t.parent&&(t.parent.tagName||"string"==typeof t.parent)&&(n=t.parent),this._doOnHighlight0=function(t){var e=(t=t||event).target||t.srcElement,n=i._findItemByNode(e),a=i._items[n._dhx_ribbonId];if(!a.conf.disable)return(!i.items[a.type]||"function"!=typeof i.items[a.type].mouseover||1==i.items[a.type].mouseover(a,i,t))&&void(/dhxrb_highlight0/.test(n.className)||(n.className+=" dhxrb_highlight0"))},this._doOffHighlight0=function(t){var e=(t=t||event).target||t.srcElement,n=i._findItemByNode(e),a=i._items[n._dhx_ribbonId];if(!a.conf.disable){if(i.items[a.type]&&"function"==typeof i.items[a.type].mouseout&&1!=i.items[a.type].mouseout(a,i,t))return!1;/dhxrb_highlight1/.test(n.className)&&(n.className=n.className.replace(/\s?dhxrb_highlight1/,"")),/dhxrb_highlight0/.test(n.className)&&(n.className=n.className.replace(/\s?dhxrb_highlight0/,""))}},this._doOnHighlight1=function(t){var e=(t=t||event).target||t.srcElement,n=i._findItemByNode(e),a=i._items[n._dhx_ribbonId];if(!a.conf.disable){if(i.callEvent("_showPopup",[a.id]),i.items[a.type]&&"function"==typeof i.items[a.type].mousedown&&1!=i.items[a.type].mousedown(a,i,t))return!1;/dhxrb_highlight1/.test(n.className)||(n.className+=" dhxrb_highlight1")}},this._doOffHighlight1=function(t){var e=(t=t||event).target||t.srcElement,n=i._findItemByNode(e),a=i._items[n._dhx_ribbonId];if(!a.conf.disable)return(!i.items[a.type]||"function"!=typeof i.items[a.type].mouseup||1==i.items[a.type].mouseup(a,i,t))&&void(/dhxrb_highlight1/.test(n.className)&&(n.className=n.className.replace(/\s?dhxrb_highlight1/,"")))},this._doOnClick=function(t){var e=(t=t||event).target||t.srcElement,n=i._findItemByNode(e),a=i._items[n._dhx_ribbonId];a.conf.disable||i.items[a.type]&&"function"==typeof i.items[a.type].click&&i.items[a.type].click(a,i,t)},this._doOnFocus=function(t){var e=(t=t||event).target||t.srcElement,n=i._findItemByNode(e),a=i._items[n._dhx_ribbonId];a.conf.disable||(i.callEvent("_showPopup",[a.id]),i.items[a.type]&&"function"==typeof i.items[a.type].focus&&i.items[a.type].focus(a,i,t))},this._doOnBlur=function(t){var e=(t=t||event).target||t.srcElement,n=i._findItemByNode(e),a=i._items[n._dhx_ribbonId];a.conf.disable||i.items[a.type]&&"function"==typeof i.items[a.type].blur&&i.items[a.type].blur(a,i,t)},this._doOnChange=function(t){var e=(t=t||event).target||t.srcElement,n=i._findItemByNode(e),a=i._items[n._dhx_ribbonId];a.conf.disable||i.items[a.type]&&"function"==typeof i.items[a.type].change&&i.items[a.type].change(a,i,t)},this._doOnKeydown=function(t){var e=(t=t||event).target||t.srcElement,n=i._findItemByNode(e),a=i._items[n._dhx_ribbonId];a.conf.disable||i.items[a.type]&&"function"==typeof i.items[a.type].keydown&&i.items[a.type].keydown(a,i,t)},this._tabCustomApi={enable:function(t,e){var n=null;if(1!=(e=e||!1)){n=i._items[this._idd];for(var a=0;a<n.childIds.length;a++)i.enable(n.childIds[a])}return i._tabOriginalApi.enable.apply(this,[t])},disable:function(t,e){var n=null;if(0!=e){n=i._items[this._idd];for(var a=0;a<n.childIds.length;a++)i.disable(n.childIds[a])}return i._tabOriginalApi.disable.apply(this,[t])},close:function(t){var e=i._items[this._idd];for(var n in i._removeTab(e),i._tabOriginalApi.close.apply(this,[t]),i._tabOriginalApi)this[n]=null}},this._attachEventTabbar=function(){this._tabbar.attachEvent("onSelect",function(){return i.callEvent("onSelect",arguments)}),this._tabbar.attachEvent("onTabClick",function(){return i.callEvent("onTabClick",arguments)}),this._tabbar.attachEvent("onTabClose",function(){return i.callEvent("onTabClose",arguments)})},"string"==typeof n?this._base=document.getElementById(n):n&&n.tagName?this._base=n:(this._base=document.createElement("div"),this._base._dhx_remove=!0,document.body.firstChild?document.body.insertBefore(this._base,document.body.firstChild):document.body.appendChild(this._base)),e=dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||dhx4.skinDetect("dhtmlxribbon")||"material","object"==typeof t&&t.skin&&(e=t.skin),this.setSkin(e),dhx4._eventable(this),dhx4._enableDataLoading(this,"_renderData","_xmlToJson","ribbon",{struct:!0}),this.attachEvent("_onHeightChanged",function(){this.conf.inited=!0}),this._base.className+=" dhxrb_without_tabbar",this._base.innerHTML="<div class='dhxrb_background_area'></div>",null!=t&&(t.json?this.loadStruct(t.json,t.onload):t.xml&&this.loadStruct(t.xml,t.onload),this._renderData(t)),this.unload=function(){for(var t=[],e=0;e<this.childIds.length;e++)t.push(this.childIds[e]);dhx4._enableDataLoading(this,null,null,null,"clear"),dhx4._eventable(this,"clear");for(e=0;e<t.length;e++)"tab"==this._items[t[e]].type?this.tabs(t[e]).close(!1):this.removeItem(t[e]);for(var n in this._tabbar&&(this._tabbar.unload(),this._tabbar=null),this._base.innerHTML="",this._base._dhx_remove?this._base.parentNode.removeChild(this._base):this._base.className=this._base.className.replace(/\s?(dhtmlx|dhxrb)(\S*)/gi,""),this)this[n]=null;i=null}}function dhtmlXToolbarObject(t,e){var n=this;for(this.conf={skin:e||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxtoolbar")||"material",align:"left",align_autostart:"left",icons_path:"",icons_css:!1,iconSize:18,sel_ofs_x:0,sel_ofs_y:0,xml_autoload:null,items_autoload:null,cssShadow:dhx4.isIE6||dhx4.isIE7||dhx4.isIE8?"":" dhx_toolbar_shadow"},"object"==typeof t&&null!=t&&void 0===t.tagName&&(null==t.icons_path&&null==t.icon_path||(this.conf.icons_path=t.icons_path||t.icon_path),null!=t.icons_size&&(this.conf.icons_size_autoload=t.icons_size),null!=t.iconset&&(this.conf.icons_css="awesome"==t.iconset),null!=t.json&&(this.conf.json_autoload=t.json),null!=t.xml&&(this.conf.xml_autoload=t.xml),null!=t.onload&&(this.conf.onload_autoload=t.onload),null==t.onclick&&null==t.onClick||(this.conf.auto_onclick=t.onclick||t.onClick),null!=t.items&&(this.conf.items_autoload=t.items),null!=t.skin&&(this.conf.skin=t.skin),null!=t.align&&(this.conf.align_autostart=t.align),t=t.parent),this.cont="object"!=typeof t?document.getElementById(t):t;this.cont.childNodes.length>0;)this.cont.removeChild(this.cont.childNodes[0]);return t=null,this.cont.dir="ltr",this.base=document.createElement("DIV"),this.base.className="dhxtoolbar_float_left",this.cont.appendChild(this.base),this.cont.ontouchstart=function(t){return t=t||event,"input"==String(t.target.tagName||"").toLowerCase()||(t.preventDefault?t.preventDefault():t.returnValue=!1,t.cancelBubble=!0,!1)},this.setSkin(this.conf.skin),this.objPull={},this.anyUsed=null,this._genStr=function(t){for(var e="dhxId_",n="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",i=0;i<t;i++)e+=n.charAt(Math.round(Math.random()*(n.length-1)));return e},this.rootTypes=new Array("button","buttonSelect","buttonTwoState","separator","label","slider","text","buttonInput"),this.idPrefix=this._genStr(12),window.dhx4._enableDataLoading(this,"_initObj","_xmlToJson","toolbar",{struct:!0}),window.dhx4._eventable(this),this._getObj=function(t,e){for(var n=null,i=0;i<t.childNodes.length;i++)null!=t.childNodes[i].tagName&&String(t.childNodes[i].tagName).toLowerCase()==String(e).toLowerCase()&&(n=t.childNodes[i]);return n},this._addImgObj=function(t){var e=document.createElement(1==this.conf.icons_css?"I":"IMG");return t.childNodes.length>0?t.insertBefore(e,t.childNodes[0]):t.appendChild(e),e},this._setItemImage=function(t,e,n){var i;(1==n?t.imgEn=e:t.imgDis=e,!t.state&&1==n||t.state&&0==n)||(1==this.conf.icons_css?(null==(i=this._getObj(t.obj,"i"))&&(i=this._addImgObj(t.obj)),i.className=this.conf.icons_path+e):(null==(i=this._getObj(t.obj,"img"))&&(i=this._addImgObj(t.obj)),i.src=this.conf.icons_path+e))},this._clearItemImage=function(t,e){if(1==e?t.imgEn="":t.imgDis="",!(!t.state&&1==e||t.state&&0==e)){var n=this._getObj(t.obj,this.conf.icons_css?"i":"img");null!=n&&n.parentNode.removeChild(n)}},this._setItemText=function(t,e){var n=this._getObj(t.obj,"div");null!=e&&0!=e.length?(null==n&&((n=document.createElement("DIV")).className="dhxtoolbar_text",t.obj.appendChild(n)),n.innerHTML=e):null!=n&&n.parentNode.removeChild(n)},this._getItemText=function(t){var e=this._getObj(t.obj,"div");return null!=e?e.innerHTML:""},this._enableItem=function(t){if(!t.state){t.state=!0,"buttonTwoState"==this.objPull[t.id].type&&1==this.objPull[t.id].obj.pressed?(t.obj.className="dhx_toolbar_btn dhxtoolbar_btn_pres",t.obj.renderAs="dhx_toolbar_btn dhxtoolbar_btn_over"):(t.obj.className="dhx_toolbar_btn dhxtoolbar_btn_def",t.obj.renderAs=t.obj.className),t.arw&&(t.arw.className=String(t.obj.className).replace("btn","arw"));var e=this._getObj(t.obj,this.conf.icons_css?"i":"img");""!=t.imgEn?(null==e&&(e=this._addImgObj(t.obj)),e[this.conf.icons_css?"className":"src"]=this.conf.icons_path+t.imgEn):null!=e&&e.parentNode.removeChild(e)}},this._disableItem=function(t){if(t.state){t.state=!1,t.obj.className="dhx_toolbar_btn dhxtoolbar_btn_"+("buttonTwoState"==this.objPull[t.id].type&&t.obj.pressed?"pres_":"")+"dis",t.obj.renderAs="dhx_toolbar_btn dhxtoolbar_btn_def",t.arw&&(t.arw.className=String(t.obj.className).replace("btn","arw"));var e=this._getObj(t.obj,this.conf.icons_css?"i":"img");""!=t.imgDis?(null==e&&(e=this._addImgObj(t.obj)),e[this.conf.icons_css?"className":"src"]=this.conf.icons_path+t.imgDis):null!=e&&e.parentNode.removeChild(e),null!=t.polygon&&"none"!=t.polygon.style.display&&(window.dhx4.zim.clear(t.polygon._idd),t.polygon.style.display="none",t.polygon._ie6cover&&(t.polygon._ie6cover.style.display="none"),"dhx_terrace"==this.conf.skin&&this._improveTerraceButtonSelect(t.id,!0),this.callEvent("onButtonSelectHide",[t.obj.idd])),this.anyUsed=null}},this.clearAll=function(){for(var t in this.objPull)this._removeItem(String(t).replace(this.idPrefix,""));this._spacer=null},this._doOnClick=function(t){n&&n.forEachItem&&n.forEachItem(function(t){if("buttonSelect"==n.objPull[n.idPrefix+t].type){var e=n.objPull[n.idPrefix+t];!0===e.arw._skip?e.arw._skip=!1:"none"!=e.polygon.style.display&&(e.obj.renderAs="dhx_toolbar_btn dhxtoolbar_btn_def",e.obj.className=e.obj.renderAs,e.arw.className=String(e.obj.renderAs).replace("btn","arw"),n.anyUsed=null,n.conf.touch_id=null,window.dhx4.zim.clear(e.polygon._idd),e.polygon.style.display="none",e.polygon._ie6cover&&(e.polygon._ie6cover.style.display="none"),"dhx_terrace"==n.conf.skin&&n._improveTerraceButtonSelect(e.id,!0),n.callEvent("onButtonSelectHide",[e.obj.idd]))}})},void 0!==window.addEventListener?(window.addEventListener("mousedown",this._doOnClick,!1),window.addEventListener("touchstart",this._doOnClick,!1)):document.body.attachEvent("onmousedown",this._doOnClick),null!=this.conf.icons_size_autoload&&(this.setIconSize(this.conf.icons_size_autoload),this.conf.icons_size_autoload=null),null!=this.conf.items_autoload?(this.loadStruct(this.conf.items_autoload,this.conf.onload_autoload),this.conf.items_autoload=null):null!=this.conf.json_autoload?(this.loadStruct(this.conf.json_autoload,this.conf.onload_autoload),this.conf.json_autoload=null):null!=this.conf.xml_autoload&&(this.loadStruct(this.conf.xml_autoload,this.conf.onload_autoload),this.conf.xml_autoload=null),this.conf.align_autostart!=this.conf.align&&(this.setAlign(this.conf.align_autostart),this.conf.align_autostart=null),"function"==typeof this.conf.auto_onclick?this.attachEvent("onClick",this.conf.auto_onclick):"string"==typeof this.conf.auto_onclick&&"function"==typeof window[this.conf.auto_onclick]&&this.attachEvent("onClick",window[this.conf.auto_onclick]),this}function dhtmlXEditor(t,e){var n=this;for(this.conf={content:"",contentHTML:"",resizeTM:null,resizeTMTime:100,roMode:!1,toolbar:!1,iconsPath:"",evs:["focus","blur","keydown","keyup","keypress","mouseup","mousedown","click","touchend"],iOSfix:null!=navigator.userAgent.match(/Mobile/gi)&&null!=navigator.userAgent.match(/iPad/gi)&&null!=navigator.userAgent.match(/AppleWebKit/gi),extra_css:"",font:{family:"Tahoma",size:"12px",color:"black"}},this._doOnFocusChanged=null,this._doOnAccess=null,"object"==typeof t&&null!=t&&null==t.tagName&&(e=t.skin,null!=t.content&&(this.conf.content=t.content),null!=t.contentHTML&&(this.conf.contentHTML=t.contentHTML),null!=t.iconsPath&&(this.conf.iconsPath=t.iconsPath),null!=t.extraCss&&(this.conf.extra_css=t.extraCss),null!=t.toolbar&&(this.conf.toolbar=window.dhx4.s2b(t.toolbar)),null!=t.onFocusChanged&&(this._doOnFocusChanged=t.onFocusChanged),null!=t.onAccess&&(this._doOnAccess=t.onAccess),t=t.parent),this.conf.skin=e||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxeditor")||"material","string"==typeof t&&(t=document.getElementById(t)),this.base=t,this.base.className+=" dhxeditor_"+this.conf.skin;this.base.childNodes.length>0;)this.base.removeChild(this.base.childNodes[0]);var i=window.dhx4.isIE?this.base.currentStyle.position:null!=window.getComputedStyle?window.getComputedStyle(this.base,null).getPropertyValue("position"):"";"relative"!=i&&"absolute"!=i&&(this.base.style.position="relative"),this.cell=new dhtmlXEditorCell(window.dhx4.newId(),this),this.base.appendChild(this.cell.cell),this.cBlock=document.createElement("DIV"),this.cBlock.className="dhxcont_content_blocker",this.cBlock.style.display="none",this.base.appendChild(this.cBlock),this.editor=document.createElement("IFRAME"),this.editor.className="dhxeditor_mainiframe",this.editor.frameBorder=0,window.dhx4.isOpera&&(this.editor.scrolling="yes"),this.setSizes();var a=this.editor;return void 0!==window.addEventListener?a.onload=function(){for(var t=0;t<n.conf.evs.length;t++)a.contentWindow.addEventListener(n.conf.evs[t],n._ev,!1)}:a.onreadystatechange=function(t){if(void 0!==a.readyState&&"complete"==a.readyState)try{for(var e=0;e<n.conf.evs.length;e++)a.contentWindow.document.body.attachEvent("on"+n.conf.evs[e],n._ev)}catch(t){}},this._ev=function(t){var e=(t=t||event).type;1!=n.conf.iOSfix||"touchend"!=e?(n.callEvent("onAccess",[e,t]),"function"==typeof n._doOnAccess?n._doOnAccess(e,t):"string"==typeof n._doOnAccess&&"function"==typeof window[n._doOnAccess]&&window[n._doOnAccess](e,t)):n.editor.contentWindow.focus()},this._focus=function(){window.dhx4.isIE?this.editor.contentWindow.document.body.focus():this.editor.contentWindow.focus()},this.cell.attachObject(this.editor),this.edWin=this.editor.contentWindow,this.edDoc=this.edWin.document,this._prepareContent=function(t,e){var n="";!0===t&&null!=this.getContent&&(n=this.getContent());var i=this.editor.contentWindow.document;if(i.open("text/html","replace"),window.dhx4.isOpera?i.write("<html><head>"+this.conf.extra_css+"<style> html, body { overflow:auto;-webkit-overflow-scrolling: touch; padding:0px; height:100%; margin:0px; background-color:#ffffff; "+this._fontConf()+"} </style></head><body "+(!0!==e?"contenteditable='true'":"")+" tabindex='0'></body></html>"):window.dhx4.isKHTML?i.write("<html><head>"+this.conf.extra_css+"<style> html {overflow-x: auto;-webkit-overflow-scrolling: touch; overflow-y: auto;} body { overflow: auto; overflow-y: scroll;} html,body { padding:0px; height:100%; margin:0px; background-color:#ffffff; "+this._fontConf()+"} </style></head><body "+(!0!==e?"contenteditable='true'":"")+" tabindex='0'></body></html>"):window.dhx4.isIE?i.write("<html><head>"+this.conf.extra_css+"<style> html {overflow-y: auto;} body {overflow-y: scroll;-webkit-overflow-scrolling: touch;} html,body { overflow-x: auto; padding:0px; height:100%; margin:0px; background-color: #ffffff; outline: none; "+this._fontConf()+"} </style></head><body "+(!0!==e?"contenteditable='true'":"")+" tabindex='0'></body></html>"):i.write("<html><head>"+this.conf.extra_css+"<style> html,body { overflow-x: auto; overflow-y:-webkit-overflow-scrolling: touch; scroll; padding:0px; height:100%; margin:0px; background-color:#ffffff; "+this._fontConf()+"} </style></head><body "+(!0!==e?"contenteditable='true'":"")+" tabindex='0'></body></html>"),i.close(),window.dhx4.isIE?i.contentEditable=!0!==e:i.designMode=!0!==e?"On":"Off",window.dhx4.isFF)try{i.execCommand("useCSS",!1,!0)}catch(t){}!0===t&&null!=this.setContent&&this.setContent(n)},this._prepareContent(),this._doOnResize=function(){window.clearTimeout(n.conf.resizeTM),n.conf.resizeTM=window.setTimeout(function(){n.setSizes&&n.setSizes()},n.conf.resizeTMTime)},this._runCommand=function(t,e){if(!0!==this.conf.roMode){arguments.length<2&&(e=null),window.dhx4.isIE&&this.edWin.focus();try{this.editor.contentWindow.document.execCommand(t,!1,e)}catch(t){}if(window.dhx4.isIE){this.edWin.focus();var n=this;window.setTimeout(function(){n.edWin.focus(),n=null},1)}}},this.applyBold=function(){this._runCommand("Bold")},this.applyItalic=function(){this._runCommand("Italic")},this.applyUnderscore=function(){this._runCommand("Underline")},this.clearFormatting=function(){this._runCommand("RemoveFormat");var t=this.getContent();t=t.replace(/<\/?h\d>/gi,""),this.setContent(t)},this._doOnClick=function(t){var e=t||window.event,i=e.target||e.srcElement;n._showInfo(i)},this._doOnMouseDown=function(t){var e=t||window.event,i=e.target||e.srcElement;n._showInfo(i)},this._doOnKeyUp=function(t){var e=t||window.event,i=e.keyCode,a=e.target||e.srcElement;1=={37:1,38:1,39:1,40:1,13:1}[i]&&n._showInfo(a)},this._getParentByTag=function(t,e){e=e.toLowerCase();var n=t;do{if(""==e||n.nodeName.toLowerCase()==e)return n}while(n=n.parentNode);return t},this._isStyleProperty=function(t,e,n,i){e=e.toLowerCase();var a=t;do{if(a.nodeName.toLowerCase()==e&&a.style[n]==i)return!0}while(a=a.parentNode);return!1},this._setStyleProperty=function(t,e){this.style[e]=!1;var n=this._getParentByTag(t,e);n&&n.tagName.toLowerCase()==e&&(this.style[e]=!0),"del"==e&&this._getParentByTag(t,"strike")&&"strike"==this._getParentByTag(t,"strike").tagName.toLowerCase()&&(this.style.del=!0)},this._showInfo=function(t){if((t=this._getSelectionBounds().end?this._getSelectionBounds().end:t)&&this._setStyleProperty)try{if(this.edWin.getComputedStyle){var e=401==(n=this.edWin.getComputedStyle(t,null)).getPropertyValue("font-weight")?700:n.getPropertyValue("font-weight");this.style={fontStyle:n.getPropertyValue("font-style"),fontSize:n.getPropertyValue("font-size"),textDecoration:n.getPropertyValue("text-decoration"),fontWeight:e,fontFamily:n.getPropertyValue("font-family"),textAlign:n.getPropertyValue("text-align")},window.dhx4.isKHTML&&(this.style.fontStyle=n.getPropertyValue("font-style"),this.style.vAlign=n.getPropertyValue("vertical-align"),this.style.del=this._isStyleProperty(t,"span","textDecoration","line-through"),this.style.u=this._isStyleProperty(t,"span","textDecoration","underline"))}else{var n=t.currentStyle;this.style={fontStyle:n.fontStyle,fontSize:n.fontSize,textDecoration:n.textDecoration,fontWeight:n.fontWeight,fontFamily:n.fontFamily,textAlign:n.textAlign}}this._setStyleProperty(t,"h1"),this._setStyleProperty(t,"h2"),this._setStyleProperty(t,"h3"),this._setStyleProperty(t,"h4"),window.dhx4.isKHTML||(this._setStyleProperty(t,"del"),this._setStyleProperty(t,"sub"),this._setStyleProperty(t,"sup"),this._setStyleProperty(t,"u")),this.callEvent("onFocusChanged",[this.style,n])}catch(t){return null}},this._getSelectionBounds=function(){var t,e,n,i;if(this.edWin.getSelection){var a=this.edWin.getSelection();return window.dhx4.isEdge&&0==a.rangeCount?{root:null,start:null,end:null}:(n=(t=a.getRangeAt(a.rangeCount-1)).startContainer,i=t.endContainer,e=t.commonAncestorContainer,"#text"==n.nodeName&&(e=e.parentNode),"#text"==n.nodeName&&(n=n.parentNode),"body"==n.nodeName.toLowerCase()&&(n=n.firstChild),"#text"==i.nodeName&&(i=i.parentNode),"body"==i.nodeName.toLowerCase()&&(i=i.lastChild),n==i&&(e=n),{root:e,start:n,end:i})}if(this.edWin.document.selection){if(!(t=this.edDoc.selection.createRange()).duplicate)return null;e=t.parentElement();var o=t.duplicate(),r=t.duplicate();return o.collapse(!0),r.moveToElementText(o.parentElement()),r.setEndPoint("EndToStart",o),n=o.parentElement(),o=t.duplicate(),(r=t.duplicate()).collapse(!1),o.moveToElementText(r.parentElement()),o.setEndPoint("StartToEnd",r),i=r.parentElement(),"body"==n.nodeName.toLowerCase()&&(n=n.firstChild),"body"==i.nodeName.toLowerCase()&&(i=i.lastChild),n==i&&(e=n),{root:e,start:n,end:i}}return null},this.getContent=function(){return this.edDoc.body?window.dhx4.isFF||window.dhx4.isChrome?this.editor.contentWindow.document.body.innerHTML.replace(/<\/{0,}br\/{0,}>\s{0,}$/gi,""):window.dhx4.isIE&&0==this.edDoc.body.innerText.length?"":this.edDoc.body.innerHTML:""},this.setContent=function(t){if(t=t||"",this.edDoc.body){var e=!1;if(window.dhx4.isFF){var i=navigator.userAgent.match(/Firefox\/(\d*)/);e=null!=i&&i[1]<28}e?(void 0===this.conf.ffTest&&(this.editor.contentWindow.document.body.innerHTML="",this._runCommand("InsertHTML","test"),this.conf.ffTest=this.editor.contentWindow.document.body.innerHTML.length>0),this.conf.ffTest?this.editor.contentWindow.document.body.innerHTML=t:(this.editor.contentWindow.document.body.innerHTML="",0==t.length&&(t=" "),this._runCommand("InsertHTML",t))):this.editor.contentWindow.document.body.innerHTML=t,this.callEvent("onContentSet",[])}else this.conf.firstLoadEv||(this.conf.firstLoadEv=!0,this.conf.firstLoadData=t,this._onFirstLoad=function(){n.setContent(n.conf.firstLoadData),"function"==typeof window.addEventListener?n.edWin.removeEventListener("load",n._onFirstLoad,!1):n.edWin.detachEvent("onload",n._onFirstLoad),n.conf.firstLoadData=null,n.conf.firstLoadEv=!1,n._onFirstLoad=null},"function"==typeof window.addEventListener?this.edWin.addEventListener("load",this._onFirstLoad,!1):this.edWin.attachEvent("onload",this._onFirstLoad))},this.setContentHTML=function(t){window.dhx4.ajax.get(t,function(t){null!=t.xmlDoc.responseText&&n.setContent(t.xmlDoc.responseText)})},window.dhx4._eventable(this),this.attachEvent("onFocusChanged",function(t){"function"==typeof this._doOnFocusChanged?this._doOnFocusChanged(t):"string"==typeof this._doOnFocusChanged&&"function"==typeof window[this._doOnFocusChanged]&&window[this._doOnFocusChanged](t)}),"function"==typeof window.addEventListener?(window.addEventListener("resize",this._doOnResize,!1),this.edDoc.addEventListener("click",this._doOnClick,!1),this.edDoc.addEventListener("keyup",this._doOnKeyUp,!1),window.dhx4.isOpera&&this.edDoc.addEventListener("mousedown",this._doOnMouseDown,!1)):(window.attachEvent("onresize",this._doOnResize),this.edDoc.attachEvent("onclick",this._doOnClick),this.edDoc.attachEvent("onkeyup",this._doOnKeyUp)),this.unload=function(){if("function"==typeof window.addEventListener){window.removeEventListener("resize",this._doOnResize,!1),this.edDoc.removeEventListener("click",this._doOnClick,!1),this.edDoc.removeEventListener("keyup",this._doOnKeyUp,!1),window.dhx4.isOpera&&this.edDoc.removeEventListener("mousedown",this._doOnMouseDown,!1);for(var t=0;t<n.conf.evs.length;t++)a.contentWindow.removeEventListener(n.conf.evs[t],n._ev,!1);null!=this.tb&&1==this.conf.iOSfix&&(this.tb.cont.removeEventListener("touchend",this._doOnIOSFix,!1),this._doOnIOSFix=null)}else{window.detachEvent("onresize",this._doOnResize,!1),this.edDoc.detachEvent("onclick",this._doOnClick),this.edDoc.detachEvent("onkeyup",this._doOnKeyUp);for(t=0;t<n.conf.evs.length;t++)a.contentWindow.document.body.detachEvent("on"+n.conf.evs[t],n._ev)}for(this._doOnAccess=null,this._doOnFocusChanged=null,"function"==typeof window.addEventListener?this.editor.onload=null:this.editor.onreadystatechange=null,this.editor.parentNode.removeChild(this.editor),this.editor=null,this.edDoc=null,this.edWin=null,this.cell._unload(),this.cell=null,this.tb=null,window.dhx4._eventable(this,"clear"),this.cBlock.parentNode.removeChild(this.cBlock),this.cBlock=null,this.base.className=String(this.base.className).replace(new RegExp("\\s{0,}dhxeditor_"+this.conf.skin),"");this.base.childNodes.length>0;)this.base.removeChild(this.base.childNodes[0]);this.base=null,this._doOnClick=null,this._doOnKeyUp=null,this._doOnMouseDown=null,this._ev=null,this._focus=null,this._prepareContent=null,this._doOnResize=null,this.setIconsPath=null,this.init=null,this.setSizes=null,this._runCommand=null,this.applyBold=null,this.applyItalic=null,this.applyUnderscore=null,this.clearFormatting=null,this._showInfo=null,this._getSelectionBounds=null,this.getContent=null,this.setContent=null,this.setContentHTML=null,this.setReadonly=null,this.isReadonly=null,this.unload=null,n=a=null},1==this.conf.toolbar&&"function"==typeof this.attachToolbar&&"function"==typeof window.dhtmlXToolbarObject&&(this.attachToolbar(this.conf.iconsPath),1==this.conf.iOSfix&&(this._doOnIOSFix=function(){n.editor.contentWindow.focus()},this.tb.cont.addEventListener("touchend",this._doOnIOSFix,!1))),this.setIconsPath=function(t){this.conf.iconsPath=t},this.conf.content.length>0?(this.setContent(this.conf.content),this.conf.content=""):this.conf.contentHTML.length>0&&(this.setContentHTML(this.conf.contentHTML),this.conf.contentHTML=""),this}function xmlPointer(t){this.d=t}function dhtmlXTreeObject(t,e,n,i){if(dhtmlxEvent.initTouch&&dhtmlxEvent.initTouch(),_isIE)try{document.execCommand("BackgroundImageCache",!1,!0)}catch(t){}this.parentObject="object"!=typeof t?document.getElementById(t):t,this.parentObject.style.overflow="hidden",this._itim_dg=!0,this.dlmtr=",",this.dropLower=!1,this.enableIEImageFix(!0),this.xmlstate=0,this.mytype="tree",this.smcheck=!0,this.width=e,this.height=n,this.rootId=i,this.childCalc=null,this.def_img_x="18px",this.def_img_y="18px",this.def_line_img_x="18px",this.def_line_img_y="24px",this._dragged=new Array,this._selected=new Array,this.style_pointer="pointer",this._aimgs=!0,this.htmlcA=" [",this.htmlcB="]",this.lWin=window,this.cMenu=0,this.mlitems=0,this.iconURL="",this.dadmode=0,this.slowParse=!1,this.autoScroll=!0,this.hfMode=0,this.nodeCut=new Array,this.XMLsource=0,this.XMLloadingWarning=0,this._idpull={},this._pullSize=0,this.treeLinesOn=!0,this.tscheck=!1,this.timgen=!0,this.dpcpy=!1,this._ld_id=null,this._dynDeleteBranches={},this._oie_onXLE=[],this.imPath=window.dhx_globalImgPath||"",this.checkArray=new Array("iconUncheckAll.gif","iconCheckAll.gif","iconCheckGray.gif","iconUncheckDis.gif","iconCheckDis.gif","iconCheckDis.gif"),this.radioArray=new Array("radio_off.gif","radio_on.gif","radio_on.gif","radio_off.gif","radio_on.gif","radio_on.gif"),this.lineArray=new Array("line2.gif","line3.gif","line4.gif","blank.gif","blank.gif","line1.gif"),this.minusArray=new Array("minus2.gif","minus3.gif","minus4.gif","minus.gif","minus5.gif"),this.plusArray=new Array("plus2.gif","plus3.gif","plus4.gif","plus.gif","plus5.gif"),this.imageArray=new Array("leaf.gif","folderOpen.gif","folderClosed.gif"),this.cutImg=new Array(0,0,0),this.cutImage="but_cut.gif",dhx4._eventable(this),this.dragger=new dhtmlDragAndDropObject,this.htmlNode=new dhtmlXTreeItemObject(this.rootId,"",0,this),this.htmlNode.htmlNode.childNodes[0].childNodes[0].style.display="none",this.htmlNode.htmlNode.childNodes[0].childNodes[0].childNodes[0].className="hiddenRow",this.allTree=this._createSelf(),this.allTree.appendChild(this.htmlNode.htmlNode),dhtmlx.$customScroll&&dhtmlx.CustomScroll.enable(this),_isFF&&(this.allTree.childNodes[0].width="100%",this.allTree.childNodes[0].style.overflow="hidden");var a=this;if(this.allTree.onselectstart=new Function("return false;"),_isMacOS&&(this.allTree.oncontextmenu=function(t){return a._doContClick(t||window.event,!0)}),this.allTree.onmousedown=function(t){return a._doContClick(t||window.event)},this.XMLLoader=this._parseXMLTree,_isIE&&this.preventIECashing(!0),this.selectionBar=document.createElement("DIV"),this.selectionBar.className="selectionBar",this.selectionBar.innerHTML="&nbsp;",this.selectionBar.style.display="none",this.allTree.appendChild(this.selectionBar),window.addEventListener&&window.addEventListener("unload",function(){try{a.destructor()}catch(t){}},!1),window.attachEvent&&window.attachEvent("onunload",function(){try{a.destructor()}catch(t){}}),this.setImagesPath=this.setImagePath,this.setIconsPath=this.setIconPath,this.setSkin(window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxtree")||"material"),dhtmlx.image_path){var o=dhtmlx.image_path,r=this.parentObject.className.match(/dhxtree_dhx_([a-z_]*)/i);null!=r&&null!=r[1]&&(o+="dhxtree_"+r[1]+"/"),this.setImagePath(o)}return this}function cObject(){return this}function dhtmlXTreeItemObject(t,e,n,i,a,o){return this.htmlNode="",this.acolor="",this.scolor="",this.tr=0,this.childsCount=0,this.tempDOMM=0,this.tempDOMU=0,this.dragSpan=0,this.dragMove=0,this.span=0,this.closeble=1,this.childNodes=new Array,this.userData=new cObject,this.checkstate=0,this.treeNod=i,this.label=e,this.parentObject=n,this.actionHandler=a,this.images=new Array(i.imageArray[0],i.imageArray[1],i.imageArray[2]),this.id=i._globalIdStorageAdd(t,this),this.treeNod.checkBoxOff?this.htmlNode=this.treeNod._createItem(1,this,o):this.htmlNode=this.treeNod._createItem(0,this,o),this.htmlNode.objBelong=this,this}function dhx_dragSomethingInTree(){this.lWin=window,this._createDragNode=function(t){var e=document.createElement("div");return e.style.position="absolute",e.innerHTML=t.innerHTML||t.value,e.className="dragSpanDiv",e},this._preventNsDrag=function(t){return(t||window.event).cancelBubble=!0,!(!t||!t.preventDefault)&&(t.preventDefault(),!1)},this._nonTrivialNode=function(t,e,n,i){if(this._customDrop)return this._customDrop(t,i.img.id,e.id,n?n.id:null);var a=i.img.getAttribute("image")||"",o=i.img.id||"new",r=i.img.getAttribute("text")||(_isIE?i.img.innerText:i.img.textContent);t[n?"insertNewNext":"insertNewItem"](n?n.id:e.id,o,r,"",a,a,a)}}function jsonPointer(t,e){this.d=t,this.dp=e}function dhtmlXTreeFromHTML(obj){"object"!=typeof obj&&(obj=document.getElementById(obj));for(var n=obj,id=n.id,cont="",j=0;j<obj.childNodes.length;j++)if("1"==obj.childNodes[j].nodeType){if("XMP"==obj.childNodes[j].tagName)for(var cHead=obj.childNodes[j],m=0;m<cHead.childNodes.length;m++)cont+=cHead.childNodes[m].data;else"ul"==obj.childNodes[j].tagName.toLowerCase()&&(cont=dhx_li2trees(obj.childNodes[j],new Array,0));break}obj.innerHTML="";var t=new dhtmlXTreeObject(obj,"100%","100%",0),z_all=new Array;for(b in t)z_all[b.toLowerCase()]=b;for(var atr=obj.attributes,a=0;a<atr.length;a++)if(0==atr[a].name.indexOf("set")||0==atr[a].name.indexOf("enable")){var an=atr[a].name;t[an]||(an=z_all[atr[a].name]),t[an].apply(t,atr[a].value.split(","))}if("object"==typeof cont){t.XMLloadingWarning=1;for(var i=0;i<cont.length;i++){var n=t.insertNewItem(cont[i][0],cont[i][3],cont[i][1]);cont[i][2]&&t._setCheck(n,cont[i][2])}t.XMLloadingWarning=0,t.lastLoadedXMLId=0,t._redrawFrom(t)}else t.parse("<tree id='0'>"+cont+"</tree>");window[id]=t;var oninit=obj.getAttribute("oninit");return oninit&&eval(oninit),t}function dhx_init_trees(){for(var t=document.getElementsByTagName("div"),e=0;e<t.length;e++)"dhtmlxTree"==t[e].className&&dhtmlXTreeFromHTML(t[e])}function dhx_li2trees(t,e,n){for(var i=0;i<t.childNodes.length;i++){var a=t.childNodes[i];if(1==a.nodeType&&"li"==a.tagName.toLowerCase()){for(var o="",r=null,s=a.getAttribute("checked"),l=0;l<a.childNodes.length;l++){var d=a.childNodes[l];3==d.nodeType?o+=d.data:"ul"!=d.tagName.toLowerCase()?o+=dhx_outer_html(d):r=d}e[e.length]=[n,o,s,a.id||e.length+1],r&&(e=dhx_li2trees(r,e,a.id||e.length))}}return e}function dhx_outer_html(t){if(t.outerHTML)return t.outerHTML;var e=document.createElement("DIV");return e.appendChild(t.cloneNode(!0)),e=e.innerHTML}function dhtmlXTreeView(t){var e=this;if("object"==typeof t&&null==t.tagName||(t={parent:t,clear:!0}),this.base="string"==typeof t.parent?document.getElementById(t.parent):t.parent,this.base!=document.body)for(;this.base.childNodes.length>0;)this.base.removeChild(this.base.lastChild);this.conf={skin:t.skin||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxtreeview")||"material",tree_id:window.dhx4.newId(),ofs:{w:1,h:0},adjust_base:!1,icons:this.icons["string"==typeof t.iconset&&null!=this.icons[t.iconset]&&1==this.icons[t.iconset].r?t.iconset:"tree_native"],autoload:{url:null,mode:"id"},selected:{},ud:{},idx:{sign:0,icon:1,text:2},silent:!1,is_mac:null!=navigator.platform.match(/^mac/i)&&"function"==typeof window.addEventListener,mac_cmd_key:!1},this.setSkin(this.conf.skin),this.cont=document.createElement("DIV"),this.cont.className="dhxtreeview_cont",this.base.appendChild(this.cont),this.area=document.createElement("DIV"),this.area.className="dhxtreeview_area",this.cont.appendChild(this.area),this.cont.onclick=function(t){t=t||event,e.callEvent("_onTreeClick",[t,{stop:!1}])},this.cont.ondblclick=function(t){var n=(t=t||event).target||t.srcElement;null!=n.className.match(/dhxtreeview_item_label/)&&e._openCloseItem(n.parentNode.parentNode._itemId,!0)},this.items={},this._addItem=function(t,e,n,i){var a=null!=e?this.items[e].level+1:1,o=document.createElement("DIV");if(o.className="dhxtreeview_item",o.innerHTML="<div class='dhxtreeview_item_text'></div>",null!=i&&i<0&&(n.index=0),null==e)var r=this.area;else{0==this.items[e].kids&&this._initKidsNode(e),this.items[e].kids_request=!1;r=this.items[e].item.lastChild.firstChild}null!=i&&null!=r.childNodes[i]?r.insertBefore(o,r.childNodes[i]):r.appendChild(o),r=null,o._itemId=t,o._treeId=this.conf.tree_id,1==window.dhx4.isIE&&(o.onselectstart=function(t){(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1}),this.items[t]={id:t,pId:e,treeId:this.conf.tree_id,text:n.text,item:o,level:a,kids:!1,opened:window.dhx4.s2b(n.open),userdata:window.dhx4._copyObj(n.userdata||{}),half_opened:!1},this.callEvent("_onItemRendered",[t,n]),o.firstChild.innerHTML=this._getItemHtml(t),o=null,1==window.dhx4.s2b(n.select)&&this._setSelected(t,!0),this.callEvent("_onItemInited",[t,n])},this.addItem=function(t,e,n,i){null==this.items[t]&&(null!=n&&null==this.items[n]&&(n=null),this._addItem(t,n,{text:e},i),this._callPublicEvent("onAddItem",[t,e,n,i]))},this._removeSingleItem=function(t){for(var e in 1==window.dhx4.isIE&&(this.items[t].item.onselectstart=null),this.items[t].item.parentNode.removeChild(this.items[t].item),this.items[t])this.items[t][e]=null,delete this.items[t][e];delete this.items[t],1==this.conf.selected[t]&&delete this.conf.selected[t]},this._removeItem=function(t){var e=t?this.items[t].pId:-1,n=-1;for(var i in this.items)this.items[i].pId==e&&n++,this.items[i].pId==t&&this._removeItem(i);null!=t&&this._removeSingleItem(t),e&&!n&&this._clearKidsNode(e)},this.deleteItem=function(t){null!=this.items[t]&&this._callPublicEvent("onBeforeDeleteItem",[t])&&(this._removeItem(t),this._callPublicEvent("onDeleteItem",[t]))},this.deleteChildItems=function(t){for(var e in t=t||0,this.items)this.items[e].pId==t&&this._removeItem(e);this._clearKidsNode(t)},this.clearAll=function(){this._removeItem(null),1!=this.conf.unloading&&this._fixAreaWidth()},this._initKidsNode=function(t){var e;null==this.items[t].item.lastChild.className.match(/dhxtreeview_kids_cont/)&&((e=document.createElement("DIV")).className="dhxtreeview_kids_cont",e.innerHTML="<div style='position:relative;'></div>",e.style.opacity="1",1!=this.items[t].opened&&(0!=this.conf.transProp?(e.style.height="0px",e.style.opacity="0",e.firstChild.style.display="none"):e.style.display="none"),this.items[t].item.appendChild(e)),this.items[t].kids=!0,this._iconUpdate(t),this._signUpdate(t),e=null},this._clearKidsNode=function(t){null!=this.items[t].item.lastChild.className.match(/dhxtreeview_kids_cont/)&&this.items[t].item.removeChild(this.items[t].item.lastChild),this.items[t].kids=!1,this._iconUpdate(t),this._signUpdate(t)},this.openItem=function(t,e){1!=this.items[t].opened&&(void 0===e&&(e=!0),this._openCloseItem(t,e))},this.closeItem=function(t,e){1==this.items[t].opened&&(void 0===e&&(e=!0),this._openCloseItem(t,e))},this._openCloseItem=function(t,n){if(!0===this.callEvent("_onBeforeOpen",[t]))return(1==this.items[t].kids||1==this.items[t].kids_request)&&(1==this.items[t].half_opened?(this.items[t].half_opened=!1,void this._signUpdate(t)):void(n&&0!=this.conf.transProp?(this.items[t].transEv||(this.items[t].item.lastChild.addEventListener(this.conf.transEv,this._doOnTrEnd),this.items[t].transEv=!0),1==this.items[t].opened?(this.items[t].transMode="close",this.items[t].item.lastChild.style.overflow="hidden",this.items[t].item.lastChild.style.height=this.items[t].item.lastChild.childNodes[0].offsetHeight+"px",window.setTimeout(function(){e.items[t].item.lastChild.style[e.conf.transProp]=e.conf.transValueHeight,e.items[t].item.lastChild.style.height="0px",e.items[t].item.lastChild.style.opacity="0",e.items[t].opened=!1,e._iconUpdate(t),e._signUpdate(t)},50)):(this.items[t].transMode="open",this.items[t].item.lastChild.style[this.conf.transProp]=this.conf.transValueHeight,this.items[t].item.lastChild.childNodes[0].style.display="",this.items[t].item.lastChild.style.overflow="hidden",this.items[t].item.lastChild.style.height=this.items[t].item.lastChild.childNodes[0].offsetHeight+"px",this.items[t].item.lastChild.style.opacity="1",this.items[t].opened=!0,this._iconUpdate(t),this._signUpdate(t))):(this.items[t].opened=!this.items[t].opened,this.items[t].item.lastChild.style.display=1==this.items[t].opened?"":"none",this.items[t].item.lastChild.childNodes[0].style.display=this.items[t].item.lastChild.style.display,this.items[t].item.lastChild.style.height=1==this.items[t].opened?"":"0px",this.items[t].item.lastChild.style.opacity=1==this.items[t].opened?1:0,this._iconUpdate(t),this._signUpdate(t),this._fixAreaWidth())))},this._doOnTrEnd=function(){var t=this.parentNode._itemId;e.items[t].item.lastChild.style[e.conf.transProp]="","close"==e.items[t].transMode?e.items[t].item.lastChild.childNodes[0].style.display="none":(e.items[t].item.lastChild.style.height="",e.items[t].item.lastChild.style.overflow=""),e._fixAreaWidth()},this.setSizes=function(){1==this.conf.adjust_base&&(this.base.style.width=this.base.parentNode.clientWidth-2+"px",this.base.style.height=this.base.parentNode.clientHeight-2+"px"),this.cont.style.left=this.conf.ofs.w+"px",this.cont.style.top=this.conf.ofs.h+"px",this.cont.style.width=this.base.clientWidth-2*this.conf.ofs.w+"px",this.cont.style.height=this.base.clientHeight-2*this.conf.ofs.h+"px",this._fixAreaWidth()},this._fixAreaWidth=function(t){this.area.style.width="100%",this.cont.scrollWidth!=this.cont.clientWidth&&(this.area.style.width=this.cont.scrollWidth+1+"px"),1==window.dhx4.isIE7&&!1!==t&&window.setTimeout(function(){e._fixAreaWidth(!1)},1)},this.setSizes(),dhx4._eventable(this);var n=window.dhx4.transDetect();for(var i in this.conf.transProp=n.transProp,this.conf.transEv=n.transEv,this.conf.transValueHeight="height 0.15s",n=null,1==this.conf.is_mac&&(this._macOnKey=function(t){((window.dhx4.isKHTML||window.dhx4.isChrome||window.dhx4.isOpera)&&(91==t.keyCode||93==t.keyCode)||window.dhx4.isFF&&224==t.keyCode)&&(e.conf.mac_cmd_key="keydown"==t.type)},window.addEventListener("keydown",this._macOnKey,!1),window.addEventListener("keyup",this._macOnKey,!1)),this.modules)null!=this.modules[i].init&&this[this.modules[i].init](t);return this.unload=function(){for(var t in this.conf.unloading=!0,this.cont.onclick=null,this.cont.ondblclick=null,this.clearAll(),1==this.conf.is_mac&&(window.removeEventListener("keydown",this._macOnKey,!1),window.removeEventListener("keyup",this._macOnKey,!1)),this.modules)null!=this.modules[t].unload&&this[this.modules[t].unload]();for(var t in this.area.parentNode.removeChild(this.area),this.area=null,this.cont.parentNode.removeChild(this.cont),this.cont=null,this.base.className=String(this.base.className).replace(new RegExp("s{0,}dhxtreeview_"+(this.conf.skin||"")),""),window.dhx4._eventable(this,"clear"),this)this[t]=null;e=null},null==t.items&&null==t.json&&null==t.xml||this.loadStruct(t.items||t.json||t.xml,t.onload),this}function dhtmlxArray(t){return dhtmlx.extend(t||new Array,dhtmlxArray._master)}function dhtmlXGridObject(id){if(dhtmlxEvent.initTouch&&dhtmlxEvent.initTouch(),_isIE)try{document.execCommand("BackgroundImageCache",!1,!0)}catch(t){}id?"object"==typeof id?(this.entBox=id,this.entBox.id||(this.entBox.id="cgrid2_"+this.uid())):this.entBox=document.getElementById(id):(this.entBox=document.createElement("DIV"),this.entBox.id="cgrid2_"+this.uid()),this.entBox.innerHTML="",dhx4._eventable(this);var self=this;this._RaSeCol=[],this._wcorr=0,this.fontWidth=7,this.cell=null,this.row=null,this.iconURL="",this.editor=null,this._f2kE=!0,this._dclE=!0,this.combos=new Array(0),this.defVal=new Array(0),this.rowsAr={},this.rowsBuffer=dhtmlxArray(),this.rowsCol=dhtmlxArray(),this._data_cache={},this._ecache={},this._ud_enabled=!0,this.xmlLoader=this.doLoadDetails,this._maskArr=[],this.selectedRows=dhtmlxArray(),this.UserData={},this._sizeFix=this._borderFix=0,this.entBox.className+=" gridbox",this.entBox.style.width=this.entBox.getAttribute("width")||(window.getComputedStyle?this.entBox.style.width||window.getComputedStyle(this.entBox,null).width:this.entBox.currentStyle?this.entBox.currentStyle.width:this.entBox.style.width||0)||"100%",this.entBox.style.height=this.entBox.getAttribute("height")||(window.getComputedStyle?this.entBox.style.height||window.getComputedStyle(this.entBox,null).height:this.entBox.currentStyle?this.entBox.currentStyle.height:this.entBox.style.height||0)||"100%",this.entBox.style.cursor="default",this.entBox.onselectstart=function(){return!1};var t_creator=function(t){var e=document.createElement("TABLE");return e.cellSpacing=e.cellPadding=0,e.style.cssText="width:100%;table-layout:fixed;",e.className=t.substr(2),e};return this.obj=t_creator("c_obj"),this.hdr=t_creator("c_hdr"),this.hdr.style.marginRight="20px",this.hdr.style.paddingRight="20px",this.objBox=document.createElement("DIV"),this.objBox.style.width="100%",this.objBox.style.overflow="auto",this.objBox.appendChild(this.obj),this.objBox.className="objbox",dhtmlx.$customScroll&&dhtmlx.CustomScroll.enable(this),this.hdrBox=document.createElement("DIV"),this.hdrBox.style.width="100%",this.hdrBox.style.height="25px",this.hdrBox.style.overflow="hidden",this.hdrBox.className="xhdr",this.preloadImagesAr=new Array(0),this.sortImg=document.createElement("DIV"),this.sortImg.style.display="none",this.hdrBox.appendChild(this.sortImg),this.hdrBox.appendChild(this.hdr),this.hdrBox.style.position="relative",this.entBox.appendChild(this.hdrBox),this.entBox.appendChild(this.objBox),this.entBox.grid=this,this.objBox.grid=this,this.hdrBox.grid=this,this.obj.grid=this,this.hdr.grid=this,this.cellWidthPX=[],this.cellWidthPC=[],this.cellWidthType=this.entBox.cellwidthtype||"px",this.delim=this.entBox.delimiter||",",this._csvDelim=",",this.hdrLabels=[],this.columnIds=[],this.columnColor=[],this._hrrar=[],this.cellType=dhtmlxArray(),this.cellAlign=[],this.initCellWidth=[],this.fldSort=[],this._srdh=_isIE&&"BackCompat"!=document.compatMode?22:20,this.imgURL=window.dhx_globalImgPath||"",this.isActive=!1,this.isEditable=!0,this.useImagesInHeader=!1,this.pagingOn=!1,this.rowsBufferOutSize=0,dhtmlxEvent(window,"unload",function(){try{self.destructor&&self.destructor()}catch(t){}}),this.setSkin=function(t){this._srdh=window.dhx4.readFromCss("dhxgrid_rh_"+t)+4,this.skin_name=t,this._imgURL&&this.setImagePath(this._imgURL);var e=this.entBox.className.split(" gridbox")[0];switch(this.entBox.className=e+" gridbox gridbox_"+t+(_isIE?" isIE":" isModern"),this.skin_h_correction=0,this.enableAlterCss("ev_"+t,"odd_"+t,this.isTreeGrid()),this._fixAlterCss(),t){case"dhx_terrace":case"material":this._srdh=33,this.forceDivInHeader=!0;break;case"dhx_web":case"material":this.forceDivInHeader=!0,this._srdh=31;break;case"dhx_skyblue":this.forceDivInHeader=!0}if(_isIE&&this.hdr){var n=this.hdr.parentNode;n.removeChild(this.hdr),n.appendChild(this.hdr)}this.setSizes()},_isIE&&this.preventIECaching(!0),window.dhtmlDragAndDropObject&&(this.dragger=new dhtmlDragAndDropObject),this._doOnScroll=function(t,e){this.callEvent("onScroll",[this.objBox.scrollLeft,this.objBox.scrollTop]),this.doOnScroll(t,e)},this.doOnScroll=function(t,e){var n=this.hdrBox;n._try_header_sync=!0,setTimeout(function(){n._try_header_sync=!1},2e3),this.hdrBox.scrollLeft=this.objBox.scrollLeft,this.ftr&&(this.ftr.parentNode.scrollLeft=this.objBox.scrollLeft),e||this._srnd&&(this._dLoadTimer&&window.clearTimeout(this._dLoadTimer),this._dLoadTimer=window.setTimeout(function(){self._update_srnd_view&&self._update_srnd_view()},100))},this.attachToObject=function(t){t.appendChild(this.globalBox?this.globalBox:this.entBox),this.setSizes()},this.init=function(t){if(this.isTreeGrid()&&!this._h2&&(this._h2=this._createHierarchy(),this._fake&&!this._realfake&&(this._fake._h2=this._h2),this._tgc={imgURL:null}),this._hstyles){if(this.skin_name||this.setSkin(window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxgrid")||"material"),this.editStop(),this.lastClicked=null,this.resized=null,this.fldSorted=this.r_fldSorted=null,this.cellWidthPX=[],this.cellWidthPC=[],this.hdr.rows.length>0){var e=this.xmlFileUrl;this.clearAll(!0),this.xmlFileUrl=e}for(var n=this.hdr.insertRow(0),i=0;i<this.hdrLabels.length;i++)n.appendChild(document.createElement("TH")),n.childNodes[i]._cellIndex=i,n.childNodes[i].style.height="0px";_isIE&&_isIE<8&&document.body.style.msTouchAction==this.undefined?n.style.position="absolute":n.style.height="auto",(n=this.hdr.insertRow(_isKHTML?2:1))._childIndexes=new Array;var a=0;for(i=0;i<this.hdrLabels.length;i++)n._childIndexes[i]=i-a,this.hdrLabels[i]!=this.splitSign||0==i?(n.insertCell(i-a),n.childNodes[i-a]._cellIndex=i,n.childNodes[i-a]._cellIndexS=i,this.setColumnLabel(i,this.hdrLabels[i])):(_isKHTML&&n.insertCell(i-a),n.cells[i-a-1].colSpan=(n.cells[i-a-1].colSpan||1)+1,n.childNodes[i-a-1]._cellIndex++,a++,n._childIndexes[i]=i-a);0==a&&(n._childIndexes=null),this._cCount=this.hdrLabels.length,_isIE&&window.setTimeout(function(){self.setSizes&&self.setSizes()},1),this.obj.firstChild||this.obj.appendChild(document.createElement("TBODY"));var o=this.obj.firstChild;if(!o.firstChild){o.appendChild(document.createElement("TR")),o=o.firstChild,_isIE&&_isIE<8&&document.body.style.msTouchAction==this.undefined?o.style.position="absolute":o.style.height="auto";for(i=0;i<this.hdrLabels.length;i++)o.appendChild(document.createElement("TH")),o.childNodes[i].style.height="0px"}this._c_order=null,1!=this.multiLine&&(this.obj.className+=" row20px"),this.sortImg.style.position="absolute",this.sortImg.style.display="none",this.sortImg.className="dhxgrid_sort_desc",this.sortImg.defLeft=0,this.noHeader?this.hdrBox.style.display="none":this.noHeader=!1,this._ivizcol&&this.setColHidden(),this.attachHeader(),this.attachHeader(0,0,"_aFoot"),this.setSizes(),t&&this.parseXML(),this.obj.scrollTop=0,this.dragAndDropOff&&this.dragger.addDragLanding(this.entBox,this),this._initDrF&&this._initD(),dhx4.callEvent("onGridCreated",[this])}},this.setColumnSizes=function(t){for(var e=0,n=[],i=0,a=0;a<this._cCount;a++)if("*"!=this.initCellWidth[a]||this._hrrar[a]){if("%"==this.cellWidthType){void 0===this.cellWidthPC[a]&&(this.cellWidthPC[a]=this.initCellWidth[a]);var o=t*this.cellWidthPC[a]/100||0;i>.5&&(o++,i--);i=i+o-(this.cellWidthPX[a]=Math.floor(o))}else void 0===this.cellWidthPX[a]&&(this.cellWidthPX[a]=this.initCellWidth[a]);this._hrrar[a]||(e+=1*this.cellWidthPX[a])}else this._awdth=!1,n.push(a);if(n.length){var r=Math.floor((t-e)/n.length);r<0&&(r=1);for(a=0;a<n.length;a++){var s=Math.max(this._drsclmW&&this._drsclmW[n[a]]||0,r);this.cellWidthPX[n[a]]=s,e+=s}if(t>e){var l=n[n.length-1];this.cellWidthPX[l]=this.cellWidthPX[l]+(t-e),e=t}this._setAutoResize()}return this.obj.style.width=e+"px",this.hdr.style.width=e+"px",this.ftr&&(this.ftr.style.width=e+"px"),this.chngCellWidth(),e},this.setSizes=function(){if(this.hdr.rows[0]){var t=this.quirks=_isIE&&"BackCompat"==document.compatMode,e=(this.entBox.offsetWidth-this.entBox.clientWidth)/2;if(!this.dontSetSizes)if(this.globalBox){if(!this.globalBox.clientWidth)return;var n=this.globalBox.clientWidth,i=(this.globalBox.offsetWidth-n)/2;if(this._delta_x&&!this._realfake){this.globalBox.style.width=this._delta_x,this.globalBox.style.boxSizing="border-box";var a=this.globalBox.clientWidth;this.entBox.style.width=Math.max(0,a+(t?2*i:0)-this._fake.entBox.clientWidth)+"px",a!=this._lastTimeSplitWidth&&(this._fake._correctSplit(this._fake.entBox.clientWidth),this._lastTimeSplitWidth=a)}this._delta_y&&!this._realfake&&(this.globalBox.style.height=this._delta_y,this.entBox.style.overflow=this._fake.entBox.style.overflow="hidden",this.entBox.style.height=this._fake.entBox.style.height=this.globalBox.clientHeight+(t?2*i:0)+"px")}else this._delta_x&&(this.entBox.parentNode&&"TD"==this.entBox.parentNode.tagName?(this.entBox.style.width="1px",this.entBox.style.width=parseInt(this._delta_x)*this.entBox.parentNode.clientWidth/100-2*e+"px"):this.entBox.style.width=this._delta_x),this._delta_y&&(this.entBox.style.height=this._delta_y);if(window.clearTimeout(this._sizeTime),this.entBox.offsetWidth||this.globalBox&&this.globalBox.offsetWidth){var o=this._wthB||!this.entBox.cmp&&!this._delta_x||0!=(this.skin_name||"").indexOf("dhx")&&"material"!=this.skin_name||t?0:2,r=this._wthB||!this.entBox.cmp&&!this._delta_y||0!=(this.skin_name||"").indexOf("dhx")&&"material"!=this.skin_name||t?0:2;this._sizeFix&&(o-=this._sizeFix,r-=this._sizeFix);var s=!this.parentGrid&&this.objBox.scrollHeight>this.objBox.offsetHeight,l=dhtmlx.$customScroll?0:18,d=this.entBox.clientWidth-(this.skin_h_correction||0)*(t?0:1)-o,c=this.entBox.clientWidth-(this.skin_h_correction||0)-o,h=this.entBox.clientHeight-r,u=this.setColumnSizes(c-(s?l:0)-(this._correction_x||0)),m=!this.parentGrid&&(this.objBox.scrollWidth>this.objBox.offsetWidth||"scroll"==this.objBox.style.overflowX),f=this.hdr.clientHeight,p=this.ftr?this.ftr.clientHeight:0,_=d,A=h-f-p;if(this._awdth&&this._awdth[0]&&99999==this._awdth[1]&&(m=0),this._ahgr&&(A=this._ahgrMA?this.entBox.parentNode.clientHeight-f-p:this.obj.offsetHeight+(m?l:0)+(this._correction_y||0),this._ahgrM&&(A=this._ahgrF?Math.min(this._ahgrM,A+f+p)-f-p:Math.min(this._ahgrM,A)),s&&A>=this.obj.scrollHeight+(m?l:0)&&(s=!1,this.setColumnSizes(c-(this._correction_x||0)))),this._awdth&&this._awdth[0]){"%"==this.cellWidthType&&(this.cellWidthType="px"),this._fake&&(u+=this._fake.entBox.clientWidth);_=Math.min(Math.max(u+(s?l:0),this._awdth[2]),this._awdth[1])+(this._correction_x||0);this.objBox.style.overflowX=!s&&this.objBox.scrollWidth<=_?"hidden":"auto",this._fake&&(_-=this._fake.entBox.clientWidth)}A=Math.max(0,A),this._ff_size_delta=.1==this._ff_size_delta?.2:.1,_isFF||(this._ff_size_delta=0),this.dontSetSizes||(this.entBox.style.width=Math.max(0,_+(t?2:0)*e+this._ff_size_delta)+"px",this.entBox.style.height=A+(t?2:0)*e+f+p+"px"),this.objBox.style.height=A+(t&&!s?2:0)*e+"px",this.hdrBox.style.height=f+"px",A!=h&&this.doOnScroll(0,!this._srnd);var b=this["setSizes_"+this.skin_name];b&&b.call(this),this.setSortImgPos(),f!=this.hdr.clientHeight&&this._ahgr&&this.setSizes(),this.callEvent("onSetSizes",[])}else this._sizeTime=window.setTimeout(function(){self.setSizes&&self.setSizes()},250)}},this.chngCellWidth=function(){_isOpera&&this.ftr&&(this.ftr.width=this.objBox.scrollWidth+"px");for(var t=this._cCount,e=0;e<t;e++)this.hdr.rows[0].cells[e].style.width=this.cellWidthPX[e]+"px",this.obj.rows[0].childNodes[e].style.width=this.cellWidthPX[e]+"px",this.ftr&&(this.ftr.rows[0].cells[e].style.width=this.cellWidthPX[e]+"px")},this.setDelimiter=function(t){this.delim=t},this.setInitWidthsP=function(t){this.cellWidthType="%",this.initCellWidth=t.split(this.delim.replace(/px/gi,"")),arguments[1]||this._setAutoResize()},this._setAutoResize=function(){if(!this._realfake){window;var t=this;dhtmlxEvent(window,"resize",function(){window.clearTimeout(t._resize_timer),t._setAutoResize&&(t._resize_timer=window.setTimeout(function(){t.setSizes&&t.setSizes(),t._fake&&t._fake._correctSplit()},100))}),this._setAutoResize=function(){}}},this.setInitWidths=function(t){if(this.cellWidthType="px",this.initCellWidth=t.split(this.delim),_isFF)for(var e=0;e<this.initCellWidth.length;e++)"*"!=this.initCellWidth[e]&&(this.initCellWidth[e]=parseInt(this.initCellWidth[e]))},this.enableMultiline=function(t){this.multiLine=dhx4.s2b(t)},this.enableMultiselect=function(t){this.selMultiRows=dhx4.s2b(t)},this.setImagePath=function(t){t=t.replace(/imgs\/dhxgrid_[a-z]*\/$/,"imgs/"),this._imgURL=t,this.imgURL=t+"dhxgrid_"+(this.skin_name||"dhx_skyblue").replace("dhx_","")+"/",this.iconTree=this.imgURL+"tree/"},this.setImagesPath=this.setImagePath,this.setIconPath=function(t){this.iconURL=t},this.setIconsPath=this.setIconPath,this.changeCursorState=function(t){var e=t.target||t.srcElement;if("TD"!=e.tagName&&(e=this.getFirstParentOfType(e,"TD")),e){if("TD"==e.tagName&&this._drsclmn&&!this._drsclmn[e._cellIndex])return e.style.cursor="default";var n=(t.layerX||0)+(_isIE||"DIV"!=t.target.tagName?0:e.offsetLeft);e.offsetWidth-(t.offsetX||-1*(parseInt(this.getPosition(e,this.hdrBox))-n))<(_isOpera?20:10)?e.style.cursor="E-resize":e.style.cursor="default",_isOpera&&(this.hdrBox.scrollLeft=this.objBox.scrollLeft)}},this.startColResize=function(t){this.resized&&this.stopColResize(),this.resized=null;var e=t.target||t.srcElement;"TD"!=e.tagName&&(e=this.getFirstParentOfType(e,"TD"));var n=t.clientX,i=this.hdr.offsetWidth,a=parseInt(e.offsetWidth);if("TD"==e.tagName&&"default"!=e.style.cursor){if(this._drsclmn&&!this._drsclmn[e._cellIndex])return;self._old_d_mm=document.body.onmousemove,self._old_d_mu=document.body.onmouseup,document.body.onmousemove=function(t){self&&self.doColResize(t||window.event,e,a,n,i)},document.body.onmouseup=function(){self&&self.stopColResize()}}},this.stopColResize=function(){document.body.onmousemove=self._old_d_mm||"",document.body.onmouseup=self._old_d_mu||"",this.setSizes(),this.doOnScroll(0,1),this.callEvent("onResizeEnd",[this])},this.doColResize=function(t,e,n,i,a){e.style.cursor="E-resize",this.resized=e;var o=n+(t.clientX-i);t.clientX;if(this.callEvent("onResize",[e._cellIndex,o,this])){_isIE&&(this.objBox.scrollLeft=this.hdrBox.scrollLeft);var r=!1;if(e.colSpan>1){for(var s=new Array,l=0;l<e.colSpan;l++)s[l]=Math.round(o*this.hdr.rows[0].childNodes[e._cellIndexS+l].offsetWidth/e.offsetWidth);for(l=0;l<e.colSpan;l++)r=this._setColumnSizeR(e._cellIndexS+1*l,s[l])}else r=this._setColumnSizeR(e._cellIndex,o);return this.doOnScroll(0,1),this.setSizes(),this._fake&&this._awdth&&this._fake._correctSplit(),r}},this._setColumnSizeR=function(t,e){if(!(e>(this._drsclmW&&!this._notresize&&this._drsclmW[t]||10)))return!1;if(this.obj.rows[0].childNodes[t].style.width=e+"px",this.hdr.rows[0].childNodes[t].style.width=e+"px",this.ftr&&(this.ftr.rows[0].childNodes[t].style.width=e+"px"),"px"==this.cellWidthType)this.cellWidthPX[t]=e;else{var n=parseInt(this.entBox.offsetWidth);this.objBox.scrollHeight>this.objBox.offsetHeight&&(n-=17);var i=Math.round(e/n*100);this.cellWidthPC[t]=i}"none"!=this.sortImg.style.display&&this.setSortImgPos()},this.setSortImgState=function(t,e,n,i){if(n=(n||"asc").toLowerCase(),!dhx4.s2b(t))return this.sortImg.style.display="none",this.r_fldSorted&&(this.r_fldSorted.className=""),void(this.fldSorted=this.r_fldSorted=null);this.sortImg.className="asc"==n?"dhxgrid_sort_asc":"dhxgrid_sort_desc",this.sortImg.style.display="",this.fldSorted=this.hdr.rows[0].childNodes[e];var a=this.hdr.rows[i||1];if(a){for(var o=0;o<a.childNodes.length;o++)if(a.childNodes[o]._cellIndexS==e)return this.r_fldSorted=a.childNodes[o],this.setSortImgPos();return this.setSortImgState(t,e,n,(i||1)+1)}},this.setSortImgPos=function(t,e,n,i){if(!this._hrrar||!this._hrrar[this.r_fldSorted?this.r_fldSorted._cellIndex:t]){if(this.ar_fldSorted&&(this.ar_fldSorted.className=""),!i)if(t)i=this.hdr.rows[n||0].cells[t];else var i=this.r_fldSorted;if(null!=i){var a=this.getPosition(i,this.hdrBox),o=i.offsetWidth;this.ar_fldSorted=i,i.className=this.sortImg.className+"_col",this.sortImg.style.left=Number(a[0]+o-13)+"px",this.sortImg.defLeft=parseInt(this.sortImg.style.left),this.sortImg.style.top=Number(a[1]+5)+"px",this.useImagesInHeader||e||(this.sortImg.style.display="inline"),this.sortImg.style.left=this.sortImg.defLeft+"px"}}},this.setActive=function(t){if(0==arguments.length)t=!0;1==t?(globalActiveDHTMLGridObject&&globalActiveDHTMLGridObject!=this&&(globalActiveDHTMLGridObject.editStop(),globalActiveDHTMLGridObject.callEvent("onBlur",[globalActiveDHTMLGridObject])),globalActiveDHTMLGridObject=this,this.isActive=!0):(this.isActive=!1,this.callEvent("onBlur",[this]))},this._doClick=function(t){var e=0,n=this.getFirstParentOfType(_isIE?t.srcElement:t.target,"TD");if(n&&n.parentNode&&n.parentNode.idd){if(this.markedCells){var i=0;return(t.shiftKey||t.metaKey)&&(i=1),t.ctrlKey&&(i=2),this.doMark(n,i),!0}return 0!=this.selMultiRows&&(t.shiftKey&&null!=this.row&&this.selectedRows.length&&(e=1),(t.ctrlKey||t.metaKey)&&(e=2)),this.doClick(n,!0,e,!1)}},this._doContClick=function(t){var e=this.getFirstParentOfType(_isIE?t.srcElement:t.target,"TD");if(!e||void 0===e.parentNode.idd)return this.callEvent("onEmptyClick",[t]),!0;if(2==t.button||_isMacOS&&t.ctrlKey){if(!this.callEvent("onRightClick",[e.parentNode.idd,e._cellIndex,t])){var n=function(t){return(t||event).cancelBubble=!0,!1};return(t.srcElement||t.target).oncontextmenu=n,n(t)}if(this._ctmndx){if(!this.callEvent("onBeforeContextMenu",[e.parentNode.idd,e._cellIndex,this]))return!0;if(_isIE&&(t.srcElement.oncontextmenu=function(){return event.cancelBubble=!0,!1}),this._ctmndx.showContextMenu){var i=window.document.documentElement,a=window.document.body,o=new Array(i.scrollLeft||a.scrollLeft,i.scrollTop||a.scrollTop);if(_isIE)var r=t.clientX+o[0],s=t.clientY+o[1];else r=t.pageX,s=t.pageY;this._ctmndx.showContextMenu(r-1,s-1),this.contextID=this._ctmndx.contextMenuZoneId=e.parentNode.idd+"_"+e._cellIndex,this._ctmndx._skip_hide=!0}else e.contextMenuId=e.parentNode.idd+"_"+e._cellIndex,e.contextMenu=this._ctmndx,e.a=this._ctmndx._contextStart,e.a(e,t),e.a=null;return t.cancelBubble=!0,!1}}else this._ctmndx&&(this._ctmndx.hideContextMenu?this._ctmndx.hideContextMenu():this._ctmndx._contextEnd());return!0},this.doClick=function(t,e,n,i){this.selMultiRows||(n=0);var a=this.row?this.row.idd:0;if(this.setActive(!0),n||(n=0),null!=this.cell&&(this.cell.className=this.cell.className.replace(/[ \t]*cellselected/g,"")),"TD"==t.tagName){if(this.checkEvent("onSelectStateChanged"))var o=this.getSelectedId();var r=this.row;if(1==n){var s=this.rowsCol._dhx_find(t.parentNode),l=this.rowsCol._dhx_find(this.lastClicked);if(s>l)var d=l,c=s;else d=s,c=l;for(var h=0;h<this.rowsCol.length;h++)if(h>=d&&h<=c){if(!this.rowsCol[h]||this.rowsCol[h]._sRow)return this.clearSelection(),this.doClick(t,e,0,i);if(!this.rowsCol[h].idd)continue;-1==this.rowsCol[h].className.indexOf("rowselected")&&this.callEvent("onBeforeSelect",[this.rowsCol[h].idd,a,t._cellIndex])&&(this.rowsCol[h].className+=" rowselected",this.selectedRows[this.selectedRows.length]=this.rowsCol[h])}}else if(2==n&&-1!=t.parentNode.className.indexOf("rowselected")){t.parentNode.className=t.parentNode.className.replace(/[ \t]*rowselected/g,""),this.selectedRows._dhx_removeAt(this.selectedRows._dhx_find(t.parentNode));var u=!0;i=!1}if(this.editStop(),void 0===t.parentNode.idd)return!0;if(u||t.parentNode._sRow||(this.callEvent("onBeforeSelect",[t.parentNode.idd,a,t._cellIndex])?this.getSelectedRowId()!=t.parentNode.idd?(0==n&&this.clearSelection(),this.cell=t,r==t.parentNode&&this._chRRS&&(e=!1),this.row=t.parentNode,this.row.className+=" rowselected",-1==this.selectedRows._dhx_find(this.row)&&(this.selectedRows[this.selectedRows.length]=this.row)):(this.cell=t,this.row=t.parentNode):e=!1),this.cell&&-1!=this.cell.parentNode.className.indexOf("rowselected")&&(this.cell.className=this.cell.className.replace(/[ \t]*cellselected/g,"")+" cellselected"),1!=n&&!this.row)return;this.lastClicked=t.parentNode;var m=this.row.idd,f=this.cell;if(e&&void 0!==m&&f&&!u?self.onRowSelectTime=setTimeout(function(){self.callEvent&&self.callEvent("onRowSelect",[m,f._cellIndex])},100):this.callEvent("onRowSelectRSOnly",[m]),this.checkEvent("onSelectStateChanged")){var p=this.getSelectedId();o!=p&&this.callEvent("onSelectStateChanged",[p,o])}if(u)return!1}this.isActive=!0,!1!==i&&this.cell&&this.cell.parentNode.idd&&this.moveToVisible(this.cell)},this.selectAll=function(){this.clearSelection();var t=this.rowsBuffer;this.pagingOn&&(t=this.rowsCol);for(var e=0;e<t.length;e++)this.render_row(e).className+=" rowselected";this.selectedRows=dhtmlxArray([].concat(t)),this.selectedRows.length&&(this.row=this.selectedRows[0],this.cell=this.row.cells[0]),this._fake&&!this._realfake&&this._fake.selectAll()},this.selectCell=function(t,e,n,i,a,o){if(n||(n=!1),"object"!=typeof t&&(t=this.render_row(t)),!t||-1==t)return null;if(t._childIndexes)var r=t.childNodes[t._childIndexes[e]];else r=t.childNodes[e];r||(r=t.childNodes[0]),this.markedCells?this.doMark(r,i?2:0):i?this.doClick(r,n,3,o):this.doClick(r,n,0,o),a&&this.editCell()},this.moveToVisible=function(t,e){if(this.pagingOn){var n=Math.floor(this.getRowIndex(t.parentNode.idd)/this.rowsBufferOutSize)+1;n!=this.currentPage&&this.changePage(n)}try{if(t.offsetHeight){var i=t.offsetLeft+t.offsetWidth+20,a=0;i>this.objBox.offsetWidth+this.objBox.scrollLeft?t.offsetLeft>this.objBox.scrollLeft&&(a=t.offsetLeft-(this.objBox.offsetWidth-t.offsetWidth)+5):t.offsetLeft<this.objBox.scrollLeft&&(i-=2*t.offsetWidth/3)<this.objBox.scrollLeft&&(a=t.offsetLeft-5),a&&!e&&(this.objBox.scrollLeft=a)}if(t.offsetHeight)i=t.offsetTop;else{var o=this._realfake?this._fake.rowsAr[t.parentNode.idd]:t.parentNode;i=this.rowsBuffer._dhx_find(o)*this._srdh}if(i+t.offsetHeight+38>this.objBox.offsetHeight+this.objBox.scrollTop)var r=i;else if(i<this.objBox.scrollTop)r=i-5;r&&(this.objBox.scrollTop=r)}catch(t){}},this.editCell=function(){if(!this.editor||this.cell!=this.editor.cell){if(this.editStop(),1!=this.isEditable||!this.cell)return!1;var t=this.cell;if(t.parentNode._locked)return!1;if(this.editor=this.cells4(t),null!=this.editor){if(this.editor.isDisabled())return this.editor=null,!1;0!=this.callEvent("onEditCell",[0,this.row.idd,this.cell._cellIndex])&&this.editor.edit?(this._Opera_stop=(new Date).valueOf(),t.className+=" editable",this.editor.edit(),this.callEvent("onEditCell",[1,this.row.idd,this.cell._cellIndex])):this.editor=null}}},this.editStop=function(t){if(_isOpera&&this._Opera_stop){if(1*this._Opera_stop+50>(new Date).valueOf())return;this._Opera_stop=null}if(this.editor&&null!=this.editor){if(this.editor.cell.className=this.editor.cell.className.replace("editable",""),t){var e=this.editor.val;return this.editor.detach(),this.editor.setValue(e),this.editor=null,void this.callEvent("onEditCancel",[this.row.idd,this.cell._cellIndex,e])}this.editor.detach()&&(this.cell.wasChanged=!0);var n=this.editor;if(null==n)return;this.editor=null;var i=this.callEvent("onEditCell",[2,this.row.idd,this.cell._cellIndex,n.getValue(),n.val]);"string"==typeof i||"number"==typeof i?n[n.setImage?"setLabel":"setValue"](i):i||n[n.setImage?"setLabel":"setValue"](n.val),this._ahgr&&this.multiLine&&this.setSizes()}},this._nextRowCell=function(t,e,n){return(t=this._nextRow((this._groups?this.rowsCol:this.rowsBuffer)._dhx_find(t),e))?t.childNodes[t._childIndexes?t._childIndexes[n]:n]:null},this._getNextCell=function(t,e,n){var i=(t=t||this.cell).parentNode;this._tabOrder?void 0!==(n=this._tabOrder[t._cellIndex])&&(t=n<0?this._nextRowCell(i,e,Math.abs(n)-1):i.childNodes[n]):(n=t._cellIndex+e)>=0&&n<this._cCount?(i._childIndexes&&(n=i._childIndexes[t._cellIndex]+e),t=i.childNodes[n]):t=this._nextRowCell(i,e,1==e?0:this._cCount-1);return t?"none"==t.style.display||this.smartTabOrder&&this.cells(t.parentNode.idd,t._cellIndex).isDisabled()?this._getNextCell(t,e):t:(1==e&&this.tabEnd&&(this.tabEnd.focus(),this.tabEnd.focus(),this.setActive(!1)),-1==e&&this.tabStart&&(this.tabStart.focus(),this.tabStart.focus(),this.setActive(!1)),null)},this._nextRow=function(t,e){var n=this.render_row(t+e);return n&&-1!=n?n&&"none"==n.style.display?this._nextRow(t+e,e):n:null},this.scrollPage=function(t){if(this.rowsBuffer.length){var e=this._realfake?this._fake:this,n=Math.floor((e._r_select||this.getRowIndex(this.row.idd)||0)+t*this.objBox.offsetHeight/(this._srdh||20));n<0&&(n=0),n>=this.rowsBuffer.length&&(n=this.rowsBuffer.length-1),this._srnd&&!this.rowsBuffer[n]?(this.objBox.scrollTop+=Math.floor(t*this.objBox.offsetHeight/(this._srdh||20))*(this._srdh||20),this._fake&&(this._fake.objBox.scrollTop=this.objBox.scrollTop),e._r_select=n):(this.selectCell(n,this.cell._cellIndex,!0,!1,!1,this.multiLine||this._srnd),this.multiLine||this._srnd||this._realfake||(this.objBox.scrollTop=this.getRowById(this.getRowId(n)).offsetTop,this._fake&&(this._fake.objBox.scrollTop=this.objBox.scrollTop)),e._r_select=null)}},this.doKey=function(t){if(!t)return!0;if((t.target||t.srcElement).value!==window.undefined){var e=t.target||t.srcElement;if("dhxcombo_input"!=e.className&&"dhx_tab_ignore"!=e.className&&(!e.parentNode||-1==e.parentNode.className.indexOf("editable")))return!0}if(globalActiveDHTMLGridObject&&this!=globalActiveDHTMLGridObject)return globalActiveDHTMLGridObject.doKey(t);if(0==this.isActive)return!0;if(this._htkebl)return!0;if(!this.callEvent("onKeyPress",[t.keyCode,t.ctrlKey,t.shiftKey,t]))return!1;var n="k"+t.keyCode+"_"+(t.ctrlKey?1:0)+"_"+(t.shiftKey?1:0);if(this.cell){if(this._key_events[n])return!1===this._key_events[n].call(this)||(t.preventDefault&&t.preventDefault(),t.cancelBubble=!0,!1);this._key_events.k_other&&this._key_events.k_other.call(this,t)}return!0},this.selectRow=function(t,e,n,i){"object"!=typeof t&&(t=this.render_row(t)),this.selectCell(t,0,e,n,!1,i)},this.wasDblClicked=function(t){var e=this.getFirstParentOfType(_isIE?t.srcElement:t.target,"TD");if(e){var n=e.parentNode.idd;return this.callEvent("onRowDblClicked",[n,e._cellIndex,t])}},this._onHeaderClick=function(t,e){var n=this.grid;if(e=e||n.getFirstParentOfType(_isIE?event.srcElement:t.target,"TD"),null==this.grid.resized){if(!this.grid.callEvent("onHeaderClick",[e._cellIndexS,t||window.event]))return!1;n.sortField(e._cellIndexS,!1,e)}this.grid.resized=null},this.deleteSelectedRows=function(){var t=this.selectedRows.length;if(0!=t){var e=this.selectedRows;this.selectedRows=dhtmlxArray();for(var n=t-1;n>=0;n--){var i=e[n];if(this.deleteRow(i.idd,i)){if(i==this.row)var a=n}else this.selectedRows[this.selectedRows.length]=i}if(a)try{a+1>this.rowsCol.length&&a--,this.selectCell(a,0,!0)}catch(t){this.row=null,this.cell=null}}},this.getSelectedRowId=function(){for(var t=new Array(0),e={},n=0;n<this.selectedRows.length;n++){var i=this.selectedRows[n].idd;e[i]||(t[t.length]=i,e[i]=!0)}return 0==t.length?null:t.join(this.delim)},this.getSelectedCellIndex=function(){return null!=this.cell?this.cell._cellIndex:-1},this.getColWidth=function(t){return parseInt(this.cellWidthPX[t])},this.setColWidth=function(t,e){if("*"==e)this.initCellWidth[t]="*";else{if(this._hrrar[t])return;"px"==this.cellWidthType?this.cellWidthPX[t]=parseInt(e):this.cellWidthPC[t]=parseInt(e)}this.setSizes()},this.getRowIndex=function(t){for(var e=0;e<this.rowsBuffer.length;e++)if(this.rowsBuffer[e]&&this.rowsBuffer[e].idd==t)return e;return-1},this.getRowId=function(t){return this.rowsBuffer[t]?this.rowsBuffer[t].idd:this.undefined},this.setRowId=function(t,e){this.changeRowId(this.getRowId(t),e)},this.changeRowId=function(t,e){if(t!=e){var n=this.rowsAr[t];n.idd=e,this.UserData[t]&&(this.UserData[e]=this.UserData[t],this.UserData[t]=null),this._h2&&this._h2.get[t]&&(this._h2.get[e]=this._h2.get[t],this._h2.get[e].id=e,delete this._h2.get[t]),this.rowsAr[t]=null,this.rowsAr[e]=n;for(var i=0;i<n.childNodes.length;i++)n.childNodes[i]._code&&(n.childNodes[i]._code=this._compileSCL(n.childNodes[i]._val,n.childNodes[i]));if(this._mat_links&&this._mat_links[t]){var a=this._mat_links[t];for(var o in delete this._mat_links[t],a)for(i=0;i<a[o].length;i++)this._compileSCL(a[o][i].original,a[o][i])}this.callEvent("onRowIdChange",[t,e])}},this.setColumnIds=function(t){this.columnIds=t.split(this.delim)},this.setColumnId=function(t,e){this.columnIds[t]=e},this.getColIndexById=function(t){for(var e=0;e<this.columnIds.length;e++)if(this.columnIds[e]==t)return e},this.getColumnId=function(t){return this.columnIds[t]},this.getColumnLabel=function(t,e,n,i){for(var a=(n||this.hdr).rows[(e||0)+1],o=0;o<a.cells.length;o++)if(a.cells[o]._cellIndexS==t)return i?a.cells[o].firstChild.innerHTML:_isIE?a.cells[o].innerText:a.cells[o].textContent;return""},this.getColLabel=this.getColumnLabel,this.getFooterLabel=function(t,e,n){return this.getColumnLabel(t,e,this.ftr,n)},this.setRowTextBold=function(t){var e=this.getRowById(t);e&&(e.style.fontWeight="bold")},this.setRowTextStyle=function(t,e){var n=this.getRowById(t);if(n)for(var i=0;i<n.childNodes.length;i++){var a=n.childNodes[i]._attrs.style||"";this._hrrar&&this._hrrar[i]&&(a="display:none;"),_isIE,n.childNodes[i].style.cssText=a+"width:"+n.childNodes[i].style.width+";"+e}},this.setRowColor=function(t,e){for(var n=this.getRowById(t),i=0;i<n.childNodes.length;i++)n.childNodes[i].bgColor=e},this.setCellTextStyle=function(t,e,n){var i=this.getRowById(t);if(i){var a=i.childNodes[i._childIndexes?i._childIndexes[e]:e];if(a){var o="";this._hrrar&&this._hrrar[e]&&(o="display:none;"),_isIE,a.style.cssText=o+"width:"+a.style.width+";"+n}}},this.setRowTextNormal=function(t){var e=this.getRowById(t);e&&(e.style.fontWeight="normal")},this.doesRowExist=function(t){return null!=this.getRowById(t)},this.getColumnsNum=function(){return this._cCount},this.moveRowUp=function(t){var e=this.getRowById(t);if(this.isTreeGrid())return this.moveRowUDTG(t,-1);var n=this.rowsCol._dhx_find(e);if(e.previousSibling&&0!=n){e.parentNode.insertBefore(e,e.previousSibling),this.rowsCol._dhx_swapItems(n,n-1),this.setSizes();var i=this.rowsBuffer._dhx_find(e);this.rowsBuffer._dhx_swapItems(i,i-1),this._cssEven&&this._fixAlterCss(n-1)}},this.moveRowDown=function(t){var e=this.getRowById(t);if(this.isTreeGrid())return this.moveRowUDTG(t,1);var n=this.rowsCol._dhx_find(e);if(e.nextSibling){this.rowsCol._dhx_swapItems(n,n+1),e.nextSibling.nextSibling?e.parentNode.insertBefore(e,e.nextSibling.nextSibling):e.parentNode.appendChild(e),this.setSizes();var i=this.rowsBuffer._dhx_find(e);this.rowsBuffer._dhx_swapItems(i,i+1),this._cssEven&&this._fixAlterCss(n)}},this.getCombo=function(t){return this.combos[t]||(this.combos[t]=new dhtmlXGridComboObject),this.combos[t]},this.setUserData=function(t,e,n){t||(t="gridglobaluserdata"),this.UserData[t]||(this.UserData[t]=new Hashtable),this.UserData[t].put(e,n)},this.getUserData=function(t,e){t||(t="gridglobaluserdata"),this.getRowById(t);var n=this.UserData[t];return n?n.get(e):""},this.setEditable=function(t){this.isEditable=dhx4.s2b(t)},this.selectRowById=function(t,e,n,i){i||(i=!1),this.selectCell(this.getRowById(t),0,i,e,!1,n)},this.clearSelection=function(){this.editStop();for(var t=0;t<this.selectedRows.length;t++){var e=this.rowsAr[this.selectedRows[t].idd];e&&(e.className=e.className.replace(/[ \t]*rowselected/g,""))}this.selectedRows=dhtmlxArray(),this.row=null,null!=this.cell&&(this.cell.className=this.cell.className.replace(/[ \t]*cellselected/g,""),this.cell=null),this.callEvent("onSelectionCleared",[])},this.copyRowContent=function(t,e){var n=this.getRowById(t);if(this.isTreeGrid())this._copyTreeGridRowContent(n,t,e);else for(var i=0;i<n.cells.length;i++)this.cells(e,i).setValue(this.cells(t,i).getValue());_isIE||(this.getRowById(t).cells[0].height=n.cells[0].offsetHeight)},this.setFooterLabel=function(t,e,n){return this.setColumnLabel(t,e,n,this.ftr)},this.setColumnLabel=function(t,e,n,i){var a=(i||this.hdr).rows[n||1],o=a._childIndexes?a._childIndexes[t]:t;if(a.cells[o]){if(this.useImagesInHeader){a.cells[o].style.textAlign="left",a.cells[o].innerHTML="<img src='"+e+"'>";var r=new Image;r.src=""+e.replace(/(\.[a-z]+)/,".des$1"),this.preloadImagesAr[this.preloadImagesAr.length]=r;var s=new Image;s.src=""+e.replace(/(\.[a-z]+)/,".asc$1"),this.preloadImagesAr[this.preloadImagesAr.length]=s}else{var l="<div class='hdrcell'>";if(-1!=e.indexOf("img:[")){var d=e.replace(/.*\[([^>]+)\].*/,"$1");e=e.substr(e.indexOf("]")+1,e.length),l+="<img width='18px' height='18px' align='absmiddle' src='"+d+"' hspace='2'>"}l+=e,l+="</div>",a.cells[o].innerHTML=l,this._hstyles[t]&&(a.cells[o].style.cssText=this._hstyles[t])}if(-1!=(e||"").indexOf("#")){var c=e.match(/(^|{)#([^}]+)(}|$)/);if(c){var h="_in_header_"+c[2];this[h]&&this[h](this.forceDivInHeader?a.cells[o].firstChild:a.cells[o],o,e.split(c[0]))}}}},this.setColLabel=function(t,e,n,i){return this.setColumnLabel(t,e,(n||0)+1,i)},this.clearAll=function(t){if(this.obj.rows[0]){this._h2&&(this._h2=this._createHierarchy(),this._fake&&(this._realfake?this._h2=this._fake._h2:this._fake._h2=this._h2)),this.limit=this._limitC=0,this.editStop(!0),this._dLoadTimer&&window.clearTimeout(this._dLoadTimer),this._dload&&(this.objBox.scrollTop=0,this.limit=this._limitC||0,this._initDrF=!0);this.rowsCol.length;for(var e=this.obj.rows.length-1;e>0;e--){(n=this.obj.rows[e]).parentNode.removeChild(n)}if(t){this._master_row=null,this.obj.rows[0].parentNode.removeChild(this.obj.rows[0]);for(e=this.hdr.rows.length-1;e>=0;e--){var n;(n=this.hdr.rows[e]).parentNode.removeChild(n)}this.ftr&&(this.ftr.parentNode.removeChild(this.ftr),this.ftr=null),this._aHead=this.ftr=this.cellWidth=this._aFoot=null,this.cellType=dhtmlxArray(),this._hrrar=[],this.columnIds=[],this.combos=[],this._strangeParams=[],this.defVal=[],this._ivizcol=null}this.row=null,this.cell=null,this.rowsCol=dhtmlxArray(),this.rowsAr={},this._RaSeCol=[],this.rowsBuffer=dhtmlxArray(),this.UserData=[],this.selectedRows=dhtmlxArray(),(this.pagingOn||this._srnd)&&(this.xmlFileUrl=""),this.pagingOn&&this.changePage(1),this._contextCallTimer&&window.clearTimeout(this._contextCallTimer),this._sst&&this.enableStableSorting(!0),this._fillers=this.undefined,this.setSortImgState(!1),this.setSizes(),this.callEvent("onClearAll",[])}},this.sortField=function(t,e,n){if(0==this.getRowsNum())return!1;var i=this.hdr.rows[0].cells[t];if(i&&"TH"==i.tagName&&this.fldSort.length-1>=i._cellIndex&&"na"!=this.fldSort[i._cellIndex]){var a=this.getSortingState(),o=a[0]==t&&"asc"==a[1]?"des":"asc";if(!this.callEvent("onBeforeSorting",[t,this.fldSort[t],o]))return;if(this.sortImg.className="dhxgrid_sort_"+("asc"==o?"asc":"desc"),this.useImagesInHeader){var r=this.hdr.rows[1].cells[i._cellIndex].firstChild;if(null!=this.fldSorted){var s=this.hdr.rows[1].cells[this.fldSorted._cellIndex].firstChild;s.src=s.src.replace(/(\.asc\.)|(\.des\.)/,".")}r.src=r.src.replace(/(\.[a-z]+)$/,"."+o+"$1")}this.sortRows(i._cellIndex,this.fldSort[i._cellIndex],o),this.fldSorted=i,n&&"th"!=n.tagName.toLowerCase()&&(this.r_fldSorted=n);var l=this.hdr.rows[1];(l=n.parentNode)._childIndexes?l._childIndexes[i._cellIndex]:i._cellIndex;this.setSortImgPos(!1,!1,!1,n)}},this.setCustomSorting=function(func,col){this._customSorts||(this._customSorts=new Array),this._customSorts[col]="string"==typeof func?eval(func):func,this.fldSort[col]="cus"},this.enableHeaderImages=function(t){this.useImagesInHeader=t},this.setHeader=function(t,e,n){if("object"!=typeof t)var i=this._eSplit(t);else i=[].concat(t);for(var a=new Array(0),o=new dhtmlxArray(0),r=new Array(0),s=new Array(0),l=new Array(0),d=0;d<i.length;d++)a[a.length]=Math.round(100/i.length),o[o.length]="ed",r[r.length]="left",s[s.length]="middle",l[l.length]="na";this.splitSign=e||"#cspan",this.hdrLabels=i,this.cellWidth=a,this.initCellWidth.length||this.setInitWidthsP(a.join(this.delim),!0),this.cellType=o,this.cellAlign=r,this.cellVAlign=s,this.fldSort=l,this._hstyles=n||[]},this._eSplit=function(t){if(![].push)return t.split(this.delim);var e="r"+(new Date).valueOf(),n=this.delim.replace(/([\|\+\*\^])/g,"\\$1");return(t||"").replace(RegExp(n,"g"),e).replace(RegExp("\\\\"+e,"g"),this.delim).split(e)},this.getColType=function(t){return this.cellType[t]},this.getColTypeById=function(t){return this.cellType[this.getColIndexById(t)]},this.setColTypes=function(t){this.cellType=dhtmlxArray(t.split(this.delim)),this._strangeParams=new Array;for(var e=0;e<this.cellType.length;e++){if(-1!=this.cellType[e].indexOf("[")){var n=this.cellType[e].split(/[\[\]]+/g);this.cellType[e]=n[0],this.defVal[e]=n[1],0==n[1].indexOf("=")&&(this.cellType[e]="math",this._strangeParams[e]=n[0])}window["eXcell_"+this.cellType[e]]||dhx4.callEvent("onConfigurationError",["Incorrect cell type: "+this.cellType[e],this,this.cellType[e]])}},this.setColSorting=function(t){this.fldSort=t.split(this.delim);for(var e={str:1,int:1,date:1},n=0;n<this.fldSort.length;n++)e[this.fldSort[n]]||"function"!=typeof window[this.fldSort[n]]||(this._customSorts||(this._customSorts=new Array),this._customSorts[n]=window[this.fldSort[n]],this.fldSort[n]="cus")},this.setColAlign=function(t){this.cellAlign=t.split(this.delim);for(var e=0;e<this.cellAlign.length;e++)this.cellAlign[e]=this.cellAlign[e]._dhx_trim()},this.setColVAlign=function(t){this.cellVAlign=t.split(this.delim)},this.setNoHeader=function(t){this.noHeader=dhx4.s2b(t)},this.showRow=function(t){this.getRowById(t),this._h2&&this.openItem(this._h2.get[t].parent.id);for(var e=this.getRowById(t).childNodes[0];e&&"none"==e.style.display;)e=e.nextSibling;e&&this.moveToVisible(e,!0)},this.setStyle=function(t,e,n,i){this.ssModifier=[t,e,n,n,i];for(var a=["#"+this.entBox.id+" table.hdr td","#"+this.entBox.id+" table.obj td","#"+this.entBox.id+" table.obj tr.rowselected td.cellselected","#"+this.entBox.id+" table.obj td.cellselected","#"+this.entBox.id+" table.obj tr.rowselected td"],o=0;!_isIE;){try{document.styleSheets[o].cssRules.length}catch(t){o++;continue}break}for(var r=0;r<a.length;r++)this.ssModifier[r]&&(_isIE?document.styleSheets[0].addRule(a[r],this.ssModifier[r]):document.styleSheets[o].insertRule(a[r]+" { "+this.ssModifier[r]+" }",document.styleSheets[o].cssRules.length))},this.setColumnColor=function(t){this.columnColor=t.split(this.delim)},this.enableAlterCss=function(t,e,n,i){(t||e)&&this.attachEvent("onGridReconstructed",function(){this._fixAlterCss(),this._fake&&this._fake._fixAlterCss()}),this._cssSP=n,this._cssSU=i,this._cssEven=t,this._cssUnEven=e},this._fixAlterCss=function(t){if(this._h2&&(this._cssSP||this._cssSU))return this._fixAlterCssTGR(t);if(this._cssEven||this._cssUnEven)for(var e=t=t||0,n=t;n<this.rowsCol.length;n++)if(this.rowsCol[n]&&"none"!=this.rowsCol[n].style.display){if(this.rowsCol[n]._cntr){e=1;continue}-1!=this.rowsCol[n].className.indexOf("rowselected")?this.rowsCol[n].className=e%2==1?this._cssUnEven+" rowselected "+(this.rowsCol[n]._css||""):this._cssEven+" rowselected "+(this.rowsCol[n]._css||""):this.rowsCol[n].className=e%2==1?this._cssUnEven+" "+(this.rowsCol[n]._css||""):this._cssEven+" "+(this.rowsCol[n]._css||""),e++}},this.clearChangedState=function(t){for(var e=0;e<this.rowsCol.length;e++){var n=this.rowsCol[e];if(n&&n.childNodes){for(var i=n.childNodes.length,a=0;a<i;a++)n.childNodes[a].wasChanged=!1;t&&(n._added=!1)}}},this.getChangedRows=function(t){var e=new Array;return this.forEachRow(function(n){var i=this.rowsAr[n];if("TR"==i.tagName){var a=i.childNodes.length;if(t&&i._added)e[e.length]=i.idd;else for(var o=0;o<a;o++)if(i.childNodes[o].wasChanged){e[e.length]=i.idd;break}}}),e.join(this.delim)},this._sUDa=!1,this._sAll=!1,this.setSerializationLevel=function(t,e,n,i,a,o){this._sUDa=t,this._sAll=e,this._sConfig=n,this._chAttr=i,this._onlChAttr=a,this._asCDATA=o},this.setSerializableColumns=function(t){if(t){this._srClmn=(t||"").split(",");for(var e=0;e<this._srClmn.length;e++)this._srClmn[e]=dhx4.s2b(this._srClmn[e])}else this._srClmn=null},this._serialise=function(t,e,n){this.editStop();var i=[],a="</"+this.xml.s_row+">";if(this.isTreeGrid())this._h2.forEachChildF(0,function(t){var e=this._serializeRow(this.render_row_tree(-1,t.id));return i.push(e),!!e},this,function(){i.push(a)});else for(var o=0;o<this.rowsBuffer.length;o++)if(this.rowsBuffer[o]){if(this._chAttr&&this.rowsBuffer[o]._locator)continue;var r=this._serializeRow(this.render_row(o));i.push(r),r&&i.push(a)}return[i.join("")]},this._serializeRow=function(t,e){var n=[],i=this.xml.row_attrs,a=this.xml.cell_attrs;if(n.push("<"+this.xml.s_row),n.push(" id='"+t.idd+"'"),this._sAll&&-1!=this.selectedRows._dhx_find(t)&&n.push(" selected='1'"),this._h2&&"minus"==this._h2.get[t.idd].state&&n.push(" open='1'"),i.length)for(e=0;e<i.length;e++)n.push(" "+i[e]+"='"+t._attrs[i[e]]+"'");if(n.push(">"),this._sUDa&&this.UserData[t.idd]){keysAr=this.UserData[t.idd].getKeys();for(var o=0;o<keysAr.length;o++){var r=keysAr[o];0!==r.indexOf("__")&&n.push("<userdata name='"+r+"'>"+(this._asCDATA?"<![CDATA[":"")+this.UserData[t.idd].get(r)+(this._asCDATA?"]]>":"")+"</userdata>")}}for(var s=!1,l=0;l<this._cCount;l++)if(!this._srClmn||this._srClmn[l]){var d=this.cells3(t,l);if(n.push("<cell"),a.length)for(e=0;e<a.length;e++)n.push(" "+a[e]+"='"+d.cell._attrs[a[e]]+"'");if(zxVal=d[this._agetm](),this._asCDATA&&(zxVal="<![CDATA["+zxVal+"]]>"),this._ecspn&&d.cell.colSpan&&d.cell.colSpan>1&&n.push(' colspan="'+d.cell.colSpan+'" '),this._chAttr?d.wasChanged()&&(n.push(' changed="1"'),s=!0):this._onlChAttr&&d.wasChanged()&&(s=!0),this._sAll&&"tree"==this.cellType[l]?n.push((this._h2?" image='"+this._h2.get[t.idd].image+"'":"")+">"+zxVal+"</cell>"):n.push(">"+zxVal+"</cell>"),this._ecspn&&d.cell.colSpan)for(var c=0;c<d.cell.colSpan-1;c++)n.push("<cell/>"),l++}return!this._onlChAttr||s||t._added?n.join(""):""},this._serialiseConfig=function(){for(var t="<head>",e=0;e<this.hdr.rows[0].cells.length;e++)if(!this._srClmn||this._srClmn[e]){var n=this.fldSort[e];"cus"==n&&(n=(n=this._customSorts[e].toString()).replace(/function[\ ]*/,"").replace(/\([^\f]*/,"")),t+="<column width='"+this.getColWidth(e)+"' align='"+this.cellAlign[e]+"' type='"+this.cellType[e]+"' sort='"+(n||"na")+"' color='"+(this.columnColor[e]||"")+"'"+(this.columnIds[e]?" id='"+this.columnIds[e]+"'":"")+">",this._asCDATA?t+="<![CDATA["+this.getColumnLabel(e)+"]]>":t+=this.getColumnLabel(e);var i=this.getCombo(e);if(i)for(var a=0;a<i.keys.length;a++)t+="<option value='"+i.keys[a]+"'>"+i.values[a]+"</option>";t+="</column>"}return t+"</head>"},this.serialize=function(){var t='<?xml version="1.0"?><rows>';if(this._mathSerialization?this._agetm="getMathValue":this._agetm="getValue",this._sUDa&&this.UserData.gridglobaluserdata)for(var e=this.UserData.gridglobaluserdata.getKeys(),n=0;n<e.length;n++)t+="<userdata name='"+e[n]+"'>"+this.UserData.gridglobaluserdata.get(e[n])+"</userdata>";return this._sConfig&&(t+=this._serialiseConfig()),t+=this._serialise(),t+="</rows>"},this.getPosition=function(t,e){if(!e){var n=dhx4.getOffset(t);return[n.left,n.top]}e=e||document.body;for(var i=t,a=0,o=0;i&&i!=e;)a+=i.offsetLeft-i.scrollLeft,o+=i.offsetTop-i.scrollTop,i=i.offsetParent;return e==document.body&&(_isIE?(o+=document.body.offsetTop||document.documentElement.offsetTop,a+=document.body.offsetLeft||document.documentElement.offsetLeft):_isFF||(a+=document.body.offsetLeft,o+=document.body.offsetTop)),[a,o]},this.getFirstParentOfType=function(t,e){for(;t&&t.tagName!=e&&"BODY"!=t.tagName;)t=t.parentNode;return t},this.objBox.onscroll=function(){this.grid._doOnScroll()},this.hdrBox.onscroll=function(){this._try_header_sync||(this._try_header_sync=!0,Math.abs(this.grid.objBox.scrollLeft-this.scrollLeft)>1&&(this.grid.objBox.scrollLeft=this.scrollLeft),this._try_header_sync=!1)},(!_isOpera||_OperaRv>8.5)&&(this.hdr.onmousemove=function(t){this.grid.changeCursorState(t||window.event)},this.hdr.onmousedown=function(t){return this.grid.startColResize(t||window.event)}),this.obj.onmousemove=this._drawTooltip,this.objBox.onclick=function(t){(t=t||event).cancelBubble=!0,this.firstChild.grid.setActive(!0),window.dhx4.callEvent("_onGridClick",[t,this.firstChild.grid])},this.obj.onclick=function(t){!1!==this.grid._doClick(t||window.event)&&(this.grid._sclE?this.grid.editCell(t||window.event):this.grid.editStop()),(t=t||event).cancelBubble=!0,window.dhx4.callEvent("_onGridClick",[t,this.grid])},_isMacOS?this.entBox.oncontextmenu=function(t){t.cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1;var e=this.grid;return e._realfake&&(e=e._fake),e._doContClick(t||window.event)}:(this.entBox.onmousedown=function(t){return this.grid._doContClick(t||window.event)},this.entBox.oncontextmenu=function(t){return this.grid._ctmndx&&((t||event).cancelBubble=!0),!this.grid._ctmndx}),this.obj.ondblclick=function(t){if(!this.grid.wasDblClicked(t||window.event))return!1;this.grid._dclE&&(this.grid.getFirstParentOfType(_isIE?event.srcElement:t.target,"TR")==this.grid.row&&this.grid.editCell(t||window.event));return(t||event).cancelBubble=!0,!_isOpera&&void 0},this.hdr.onclick=this._onHeaderClick,this.sortImg.onclick=function(){self._onHeaderClick.apply({grid:self},[null,self.r_fldSorted])},this.hdr.ondblclick=this._onHeaderDblClick,document.body._dhtmlxgrid_onkeydown||(dhtmlxEvent(document,"keydown",function(t){if(globalActiveDHTMLGridObject)return globalActiveDHTMLGridObject.doKey(t||window.event)}),document.body._dhtmlxgrid_onkeydown=!0),dhtmlxEvent(document.body,"click",function(){self.editStop&&self.editStop(),self.isActive&&self.setActive(!1)}),-1!=this.entBox.style.height.toString().indexOf("%")&&(this._delta_y=this.entBox.style.height),-1!=this.entBox.style.width.toString().indexOf("%")&&(this._delta_x=this.entBox.style.width),(this._delta_x||this._delta_y)&&this._setAutoResize(),this.setColHidden=this.setColumnsVisibility,this.enableCollSpan=this.enableColSpan,this.setMultiselect=this.enableMultiselect,this.setMultiLine=this.enableMultiline,this.deleteSelectedItem=this.deleteSelectedRows,this.getSelectedId=this.getSelectedRowId,this.getHeaderCol=this.getColumnLabel,this.isItemExists=this.doesRowExist,this.getColumnCount=this.getColumnsNum,this.setSelectedRow=this.selectRowById,this.setHeaderCol=this.setColumnLabel,this.preventIECashing=this.preventIECaching,this.enableAutoHeigth=this.enableAutoHeight,this.getUID=this.uid,dhtmlx.image_path&&this.setImagePath(dhtmlx.image_path),dhtmlx.skin&&this.setSkin(dhtmlx.skin),this}function dhtmlXGridCellObject(t){this.destructor=function(){return this.cell.obj=null,this.cell=null,this.grid=null,this.base=null,null},this.cell=t,this.getValue=function(){return this.cell.textContent&&"TEXTAREA"==this.cell.textContent.tagName?this.cell.textContent.value:this.cell.innerHTML._dhx_trim()},this.getMathValue=function(){return this.cell.original?this.cell.original:this.getValue()},this.getFont=function(){return arOut=new Array(3),this.cell.style.fontFamily&&(arOut[0]=this.cell.style.fontFamily),"bold"!=this.cell.style.fontWeight&&"bold"!=this.cell.parentNode.style.fontWeight||(arOut[1]="bold"),"italic"!=this.cell.style.fontStyle&&"italic"!=this.cell.parentNode.style.fontWeight||(arOut[1]+="italic"),this.cell.style.fontSize?arOut[2]=this.cell.style.fontSize:arOut[2]="",arOut.join("-")},this.getTextColor=function(){return this.cell.style.color?this.cell.style.color:"#000000"},this.getBgColor=function(){return this.cell.style.backgroundColor||"#FFFFFF"},this.getHorAlign=function(){return this.cell.style.textAlign?this.cell.style.textAlign:this.cell.style.textAlign?this.cell.style.textAlign:"left"},this.getWidth=function(){return this.cell.scrollWidth},this.setFont=function(t){fntAr=t.split("-"),this.cell.style.fontFamily=fntAr[0],this.cell.style.fontSize=fntAr[fntAr.length-1],3==fntAr.length&&(/bold/.test(fntAr[1])&&(this.cell.style.fontWeight="bold"),/italic/.test(fntAr[1])&&(this.cell.style.fontStyle="italic"),/underline/.test(fntAr[1])&&(this.cell.style.textDecoration="underline"))},this.setTextColor=function(t){this.cell.style.color=t},this.setBgColor=function(t){""==t&&(t=null),this.cell.style.background=t},this.setHorAlign=function(t){1==t.length?this.cell.style.textAlign="c"==t?"center":"l"==t?"left":"right":this.cell.style.textAlign=t},this.wasChanged=function(){return!!this.cell.wasChanged},this.isCheckbox=function(){var t=this.cell.firstChild;return!(!t||"INPUT"!=t.tagName)&&(type=t.type,"radio"==type||"checkbox"==type)},this.isChecked=function(){if(this.isCheckbox())return this.cell.firstChild.checked},this.isDisabled=function(){return this.cell._disabled},this.setChecked=function(t){this.isCheckbox()&&("true"!=t&&1!=t&&(t=!1),this.cell.firstChild.checked=t)},this.setDisabled=function(t){"true"!=t&&1!=t&&(t=!1),this.isCheckbox()&&(this.cell.firstChild.disabled=t,this.disabledF&&this.disabledF(t)),this.cell._disabled=t}}function eXcell(){this.obj=null,this.val=null,this.changeState=function(){return!1},this.edit=function(){this.val=this.getValue()},this.detach=function(){return!1},this.getPosition=function(t){for(var e=t,n=0,i=0;"BODY"!=e.tagName;)n+=e.offsetLeft,i+=e.offsetTop,e=e.offsetParent;return new Array(n,i)}}function eXcell_ed(t){t&&(this.cell=t,this.grid=this.cell.parentNode.grid),this.edit=function(){this.cell.atag=this.grid.multiLine?"TEXTAREA":"INPUT",this.val=this.getValue(),this.obj=document.createElement(this.cell.atag),this.obj.setAttribute("autocomplete","off"),this.obj.style.height=this.cell.offsetHeight-(this.grid.multiLine?9:4)+"px",this.obj.className="dhx_combo_edit",this.obj.wrap="soft",this.obj.style.textAlign=this.cell.style.textAlign,this.obj.onclick=function(t){(t||event).cancelBubble=!0},this.obj.onmousedown=function(t){(t||event).cancelBubble=!0},this.obj.value=this.val,this.cell.innerHTML="",this.cell.appendChild(this.obj),this.obj.onselectstart=function(t){return t||(t=event),t.cancelBubble=!0,!0},_isIE&&(this.obj.focus(),this.obj.blur()),this.obj.focus()},this.getValue=function(){return this.cell.firstChild&&this.cell.atag&&this.cell.firstChild.tagName==this.cell.atag?this.cell.firstChild.value:this.cell._clearCell?"":this.cell.innerHTML.toString()._dhx_trim()},this.detach=function(){return this.setValue(this.obj.value),this.val!=this.getValue()}}function eXcell_edtxt(t){t&&(this.cell=t,this.grid=this.cell.parentNode.grid),this.getValue=function(){return this.cell.firstChild&&this.cell.atag&&this.cell.firstChild.tagName==this.cell.atag?this.cell.firstChild.value:this.cell._clearCell?"":_isIE?this.cell.innerText:this.cell.textContent},this.setValue=function(t){t&&""!=t.toString()._dhx_trim()?this.cell._clearCell=!1:(t=" ",this.cell._clearCell=!0),this.setCTxtValue(t)}}function eXcell_edn(t){t&&(this.cell=t,this.grid=this.cell.parentNode.grid),this.getValue=function(){return this.cell.firstChild&&"TEXTAREA"==this.cell.firstChild.tagName?this.cell.firstChild.value:this.cell._clearCell?"":this.cell._orig_value||this.grid._aplNFb(this.cell.innerHTML.toString()._dhx_trim(),this.cell._cellIndex)},this.detach=function(){var t=this.obj.value;return this.setValue(t),this.val!=this.getValue()}}function eXcell_ch(t){t&&(this.cell=t,this.grid=this.cell.parentNode.grid),this.disabledF=function(t){this.cell.innerHTML=1==t||1==t?this.cell.innerHTML.replace("item_chk0.","item_chk0_dis.").replace("item_chk1.","item_chk1_dis."):this.cell.innerHTML.replace("item_chk0_dis.","item_chk0.").replace("item_chk1_dis.","item_chk1.")},this.changeState=function(t){!0!==t||this.grid.isActive||(null!=window.globalActiveDHTMLGridObject&&window.globalActiveDHTMLGridObject!=this.grid&&window.globalActiveDHTMLGridObject.isActive&&window.globalActiveDHTMLGridObject.setActive(!1),this.grid.setActive(!0)),!this.grid.isEditable||this.cell.parentNode._locked||this.isDisabled()||(this.grid.callEvent("onEditCell",[0,this.cell.parentNode.idd,this.cell._cellIndex])?(this.val=this.getValue(),"1"==this.val?this.setValue("0"):this.setValue("1"),this.cell.wasChanged=!0,this.grid.callEvent("onEditCell",[1,this.cell.parentNode.idd,this.cell._cellIndex]),this.grid.callEvent("onCheckbox",[this.cell.parentNode.idd,this.cell._cellIndex,"1"!=this.val]),this.grid.callEvent("onCheck",[this.cell.parentNode.idd,this.cell._cellIndex,"1"!=this.val])):this.editor=null)},this.getValue=function(){return this.cell.chstate?this.cell.chstate.toString():"0"},this.isCheckbox=function(){return!0},this.isChecked=function(){return"1"==this.getValue()},this.setChecked=function(t){this.setValue(t.toString())},this.detach=function(){return this.val!=this.getValue()},this.edit=null}function eXcell_ra(t){this.base=eXcell_ch,this.base(t),this.grid=t.parentNode.grid,this.disabledF=function(t){this.cell.innerHTML=1==t||1==t?this.cell.innerHTML.replace("radio_chk0.","radio_chk0_dis.").replace("radio_chk1.","radio_chk1_dis."):this.cell.innerHTML.replace("radio_chk0_dis.","radio_chk0.").replace("radio_chk1_dis.","radio_chk1.")},this.changeState=function(t){!1===t&&1==this.getValue()||!this.grid.isEditable||this.cell.parentNode._locked||this.isDisabled()||(0!=this.grid.callEvent("onEditCell",[0,this.cell.parentNode.idd,this.cell._cellIndex])?(this.val=this.getValue(),"1"==this.val?this.setValue("0"):this.setValue("1"),this.cell.wasChanged=!0,this.grid.callEvent("onEditCell",[1,this.cell.parentNode.idd,this.cell._cellIndex]),this.grid.callEvent("onCheckbox",[this.cell.parentNode.idd,this.cell._cellIndex,"1"!=this.val]),this.grid.callEvent("onCheck",[this.cell.parentNode.idd,this.cell._cellIndex,"1"!=this.val])):this.editor=null)},this.edit=null}function eXcell_txt(t){t&&(this.cell=t,this.grid=this.cell.parentNode.grid),this.edit=function(){this.val=this.getValue(),this.obj=document.createElement("TEXTAREA"),this.obj.className="dhx_textarea",this.obj.onclick=function(t){(t||event).cancelBubble=!0};var t=this.grid.getPosition(this.cell);if(this.obj.value=this.val,this.obj.style.display="",this.obj.style.textAlign=this.cell.style.textAlign,document.body.appendChild(this.obj),_isOpera&&(this.obj.onkeypress=function(t){if(9==t.keyCode||27==t.keyCode)return!1}),this.obj.onkeydown=function(t){var e=t||event;if(9==e.keyCode||27==e.keyCode)return globalActiveDHTMLGridObject.entBox.focus(),globalActiveDHTMLGridObject.doKey({keyCode:e.keyCode,shiftKey:e.shiftKey,srcElement:"0"}),!1},this.obj.style.left=t[0]+"px",this.obj.style.top=t[1]+this.cell.offsetHeight+"px",this.cell.offsetWidth<200)var e=200;else e=this.cell.offsetWidth;this.obj.style.width=e+16+"px",_isIE&&(this.obj.select(),this.obj.value=this.obj.value),this.obj.focus()},this.detach=function(){var t;return t=this.obj.value,this.cell._clearCell=""==t,this.setValue(t),document.body.removeChild(this.obj),this.obj=null,this.val!=this.getValue()},this.getValue=function(){return this.obj?this.obj.value:this.cell._clearCell?"":void 0!==this.cell._brval?this.cell._brval:this.grid.multiLine?this.cell._brval||this.cell.innerHTML.replace(/<br[^>]*>/gi,"\n")._dhx_trim():this.cell._brval||this.cell.innerHTML}}function eXcell_txttxt(t){t&&(this.cell=t,this.grid=this.cell.parentNode.grid),this.getValue=function(){return this.cell.firstChild&&"TEXTAREA"==this.cell.firstChild.tagName?this.cell.firstChild.value:this.cell._clearCell?"":!this.grid.multiLine&&this.cell._brval?this.cell._brval:_isIE?this.cell.innerText:this.cell.textContent},this.setValue=function(t){this.cell._brval=t,t&&""!=t.toString()._dhx_trim()?this.cell._clearCell=!1:(t=" ",this.cell._clearCell=!0),this.setCTxtValue(t)}}function eXcell_co(t){t&&(this.cell=t,this.grid=this.cell.parentNode.grid,this.combo=this.cell._combo||this.grid.getCombo(this.cell._cellIndex),this.editable=!0),this.shiftNext=function(){var t=this.list.options[this.list.selectedIndex+1];return t&&(t.selected=!0),this.obj.value=this.list.options[this.list.selectedIndex].text,!0},this.shiftPrev=function(){if(0!=this.list.selectedIndex){var t=this.list.options[this.list.selectedIndex-1];t&&(t.selected=!0),this.obj.value=this.list.options[this.list.selectedIndex].text}return!0},this.edit=function(){this.val=this.getValue(),this.text=this.getText()._dhx_trim();var t=this.grid.getPosition(this.cell);this.obj=document.createElement("TEXTAREA"),this.obj.className="dhx_combo_edit",this.obj.style.height=this.cell.offsetHeight-(this.grid.multiLine?9:4)+"px",this.obj.wrap="soft",this.obj.style.textAlign=this.cell.style.textAlign,this.obj.onclick=function(t){(t||event).cancelBubble=!0},this.obj.onmousedown=function(t){(t||event).cancelBubble=!0},this.obj.value=this.text,this.obj.onselectstart=function(t){return t||(t=event),t.cancelBubble=!0,!0};var e=this;this.obj.onkeyup=function(t){var n=(t||event).keyCode;if(38!=n&&40!=n&&9!=n)for(var i=this.readonly?String.fromCharCode(n):this.value,a=e.list.options,o=0;o<a.length;o++)if(0==a[o].text.indexOf(i))return a[o].selected=!0},this.list=document.createElement("SELECT"),this.list.className="dhx_combo_select",this.list.style.width=this.cell.offsetWidth+"px",this.list.style.left=t[0]+"px",this.list.style.top=t[1]+this.cell.offsetHeight+"px",this.list.onclick=function(t){var n=t||window.event,i=n.target||n.srcElement;"OPTION"==i.tagName&&(i=i.parentNode),e.editable=!1,e.grid.editStop(),n.cancelBubble=!0};for(var n=this.combo.getKeys(),i=!1,a=0,o=0;o<n.length;o++){var r=this.combo.get(n[o]);this.list.options[this.list.options.length]=new Option(r,n[o]),n[o]==this.val&&(a=this.list.options.length-1,i=!0)}0==i&&(this.list.options[this.list.options.length]=new Option(this.text,null===this.val?"":this.val),a=this.list.options.length-1),document.body.appendChild(this.list),this.list.size="6",this.cstate=1,this.editable?this.cell.innerHTML="":(this.obj.style.width="0px",this.obj.style.height="0px"),this.cell.appendChild(this.obj),this.list.options[a].selected=!0,this.editable&&(this.obj.focus(),this.obj.focus()),this.editable||(this.obj.style.visibility="hidden",this.obj.style.position="absolute",this.list.focus(),this.list.onkeydown=function(t){if(t=t||window.event,e.grid.setActive(!0),t.keyCode<30)return e.grid.doKey({target:e.cell,keyCode:t.keyCode,shiftKey:t.shiftKey,ctrlKey:t.ctrlKey})})},this.getValue=function(){return this.cell.combo_value==window.undefined?"":this.cell.combo_value},this.detach=function(){if(this.val!=this.getValue()&&(this.cell.wasChanged=!0),null!=this.list.parentNode)if(this.editable){var t=this.list.options[this.list.selectedIndex];if(t&&t.text==this.obj.value)this.setValue(this.list.value);else{var e=this.cell._combo||this.grid.getCombo(this.cell._cellIndex),n=e.values._dhx_find(this.obj.value);-1!=n?this.setValue(e.keys[n]):this.setValue(this.cell.combo_value=this.obj.value)}}else this.setValue(this.list.value);return this.list.parentNode&&this.list.parentNode.removeChild(this.list),this.obj.parentNode&&this.obj.parentNode.removeChild(this.obj),this.val!=this.getValue()}}function eXcell_coro(t){this.base=eXcell_co,this.base(t),this.editable=!1}function eXcell_cotxt(t){this.base=eXcell_co,this.base(t)}function eXcell_corotxt(t){this.base=eXcell_co,this.base(t),this.editable=!1}function eXcell_cp(t){try{this.cell=t,this.grid=this.cell.parentNode.grid}catch(t){}this.edit=function(){this.val=this.getValue(),this.obj=document.createElement("SPAN"),this.obj.style.border="1px solid black",this.obj.style.position="absolute";var t=this.grid.getPosition(this.cell);this.colorPanel(4,this.obj),document.body.appendChild(this.obj),this.obj.style.left=t[0]+"px",this.obj.style.zIndex=1e3,this.obj.style.top=t[1]+this.cell.offsetHeight+"px"},this.toolDNum=function(t){return 1==t.length&&(t="0"+t),t},this.colorPanel=function(t,e){var n=document.createElement("TABLE");e.appendChild(n),n.cellSpacing=0,n.editor_obj=this,n.style.cursor="default",n.onclick=function(t){var e=t||window.event,n=e.target||e.srcElement,i=n.parentNode.parentNode.parentNode.editor_obj;i&&(i.setValue(n._bg),i.grid.editStop())};for(var i=256/t,a=0;a<=256/i;a++)for(var o=n.insertRow(a),r=0;r<=256/i;r++)for(var s=0;s<=256/i;s++){R=new Number(i*a)-(0==a?0:1),G=new Number(i*r)-(0==r?0:1),B=new Number(i*s)-(0==s?0:1);var l=this.toolDNum(R.toString(16))+""+this.toolDNum(G.toString(16))+this.toolDNum(B.toString(16)),d=o.insertCell(r);d.width="10px",d.innerHTML="&nbsp;",d.title=l.toUpperCase(),d.style.backgroundColor="#"+l,d._bg="#"+l,null!=this.val&&"#"+l.toUpperCase()==this.val.toUpperCase()&&(d.style.border="2px solid white")}},this.getValue=function(){return this.cell.firstChild._bg||""},this.getRed=function(){return Number(parseInt(this.getValue().substr(1,2),16))},this.getGreen=function(){return Number(parseInt(this.getValue().substr(3,2),16))},this.getBlue=function(){return Number(parseInt(this.getValue().substr(5,2),16))},this.detach=function(){return null!=this.obj.offsetParent&&document.body.removeChild(this.obj),this.val!=this.getValue()}}function eXcell_img(t){try{this.cell=t,this.grid=this.cell.parentNode.grid}catch(t){}this.getValue=function(){if("IMG"==this.cell.firstChild.tagName)return this.cell.firstChild.src+(null!=this.cell.titFl?"^"+this.cell._brval:"");if("A"==this.cell.firstChild.tagName){var t=this.cell.firstChild.firstChild.src+(null!=this.cell.titFl?"^"+this.cell._brval:"");return t+="^"+this.cell.lnk,this.cell.trg&&(t+="^"+this.cell.trg),t}},this.isDisabled=function(){return!0}}function eXcell_icon(t){this.base=eXcell_ed,this.base(t);try{this.cell=t,this.grid=this.cell.parentNode.grid}catch(t){}this.setValue=function(t){this.cell._raw_value=t,this.setCValue('<div class="dhx_grid_icon"><i class="fa fa-'+t.toString()._dhx_trim()+'"></i></div>')},this.getValue=function(){return this.cell._raw_value},this.isDisabled=function(){return!0}}function eXcell_price(t){this.base=eXcell_ed,this.base(t),this.getValue=function(){return this.cell.childNodes.length>1?this.cell.childNodes[1].innerHTML.toString()._dhx_trim():"0"}}function eXcell_dyn(t){this.base=eXcell_ed,this.base(t),this.getValue=function(){if(!this.cell.firstChild.childNodes[1])return"";var t=this.cell.firstChild.childNodes[1].innerHTML.toString()._dhx_trim(),e=this.grid._aplNFb(t,this.cell._cellIndex);return isNaN(Number(e))?t:e}}function eXcell_ro(t){t&&(this.cell=t,this.grid=this.cell.parentNode.grid),this.edit=function(){},this.isDisabled=function(){return!0},this.getValue=function(){return this.cell._clearCell?"":this.cell.innerHTML.toString()._dhx_trim()}}function eXcell_ron(t){this.cell=t,this.grid=this.cell.parentNode.grid,this.edit=function(){},this.isDisabled=function(){return!0},this.getValue=function(){return this.cell._clearCell?"":this.cell._orig_value||this.grid._aplNFb(this.cell.innerHTML.toString()._dhx_trim(),this.cell._cellIndex).toString()}}function eXcell_rotxt(t){this.cell=t,this.grid=this.cell.parentNode.grid,this.edit=function(){},this.isDisabled=function(){return!0},this.setValue=function(t){t?this.cell._clearCell=!1:(t=" ",this.cell._clearCell=!0),this.setCTxtValue(t)},this.getValue=function(){return this.cell._clearCell?"":_isIE?this.cell.innerText:this.cell.textContent}}function dhtmlXGridComboObject(){return this.keys=new dhtmlxArray,this.values=new dhtmlxArray,this.put=function(t,e){for(var n=0;n<this.keys.length;n++)if(this.keys[n]==t)return this.values[n]=e,!0;this.values[this.values.length]=e,this.keys[this.keys.length]=t},this.get=function(t){for(var e=0;e<this.keys.length;e++)if(this.keys[e]==t)return this.values[e];return null},this.clear=function(){this.keys=new dhtmlxArray,this.values=new dhtmlxArray},this.remove=function(t){for(var e=0;e<this.keys.length;e++)if(this.keys[e]==t)return this.keys._dhx_removeAt(e),this.values._dhx_removeAt(e),!0},this.size=function(){for(var t=0,e=0;e<this.keys.length;e++)null!=this.keys[e]&&t++;return t},this.getKeys=function(){for(var t=new Array(0),e=0;e<this.keys.length;e++)null!=this.keys[e]&&(t[t.length]=this.keys[e]);return t},this.save=function(){this._save=new Array;for(var t=0;t<this.keys.length;t++)this._save[t]=[this.keys[t],this.values[t]]},this.restore=function(){if(this._save){this.keys[t]=new Array,this.values[t]=new Array;for(var t=0;t<this._save.length;t++)this.keys[t]=this._save[t][0],this.values[t]=this._save[t][1]}},this}function Hashtable(){return this.keys=new dhtmlxArray,this.values=new dhtmlxArray,this}function dragContext(t,e,n,i,a,o,r,s,l,d,c){return this.source=t||"grid",this.target=e||"grid",this.mode=n||"move",this.dropmode=i||"child",this.sid=a||0,this.tid=o,this.sobj=r||null,this.tobj=s||null,this.sExtra=l||null,this.tExtra=d||null,this.before=c||!1,this}function eXcell_stree(t){if(t){if(this.cell=t,this.grid=this.cell.parentNode.grid,!this.grid._sub_trees)return;if(this._sub=this.grid._sub_trees[t._cellIndex],!this._sub)return;this._sub=this._sub[0]}this.getValue=function(){return this.cell._val},this.setValue=function(t){this.cell._val=t,t=this._sub.getItemText(this.cell._val),this.setCValue(t||"&nbsp;",t)},this.edit=function(){this._sub.parentObject.style.display="block";var t=this.grid.getPosition(this.cell);this._sub.parentObject.style.top=t[1]+"px",this._sub.parentObject.style.left=t[0]+"px",this._sub.parentObject.style.position="absolute";var e=this.grid.editStop;this.grid.editStop=function(){},this.grid.editStop=e},this.detach=function(){if(this._sub.parentObject.style.display="none",null!=this.grid._sub_id){var t=this.cell._val;return this.setValue(this._sub.getSelectedItemId()),this.grid._sub_id=null,this.cell._val!=t}}}function eXcell_link(t){this.cell=t,this.grid=this.cell.parentNode.grid,this.isDisabled=function(){return!0},this.edit=function(){},this.getValue=function(){if(this.cell.firstChild.getAttribute){var t=this.cell.firstChild.getAttribute("target");return this.cell.firstChild.innerHTML+"^"+this.cell.firstChild.getAttribute("href")+(t?"^"+t:"")}return""},this.setValue=function(t){if("number"!=typeof t&&(!t||""==t.toString()._dhx_trim()))return this.setCValue("&nbsp;",e),this.cell._clearCell=!0;var e=t.split("^");1==e.length?e[1]="":e.length>1&&(e[1]="href='"+e[1]+"'",3==e.length?e[1]+=" target='"+e[2]+"'":e[1]+=" target='_blank'"),this.setCValue("<a "+e[1]+" onclick='(_isIE?event:arguments[0]).cancelBubble = true;'>"+e[0]+"</a>",e)}}function eXcell_grid(t){if(t){if(this.cell=t,this.grid=this.cell.parentNode.grid,!this.grid._sub_grids)return;if(this._sub=this.grid._sub_grids[t._cellIndex],!this._sub)return;this._sindex=this._sub[1],this._sub=this._sub[0]}this.getValue=function(){return this.cell.val},this.setValue=function(t){this.cell.val=t,this._sub.getRowById(t)&&(t=(t=this._sub.cells(t,this._sindex))?t.getValue():""),this.setCValue(t||"&nbsp;",t)},this.edit=function(){this.val=this.cell.val,this._sub.entBox.style.display="block";var t=this.grid.getPosition(this.cell);this._sub.entBox.style.top=t[1]+"px",this._sub.entBox.style.left=t[0]+"px",this._sub.entBox.style.position="absolute",this._sub.setSizes();var e=this.grid.editStop;this.grid.editStop=function(){},this._sub.getRowById(this.cell.val)&&this._sub.setSelectedRow(this.cell.val),this._sub.setActive(!0),this.grid.editStop=e},this.detach=function(){var t=this.cell.val;return this._sub.entBox.style.display="none",null!==this._sub.getSelectedId()&&(this.setValue(this._sub.getSelectedId()),this.grid.setActive(!0),this.cell.val!=t)}}function eXcell_dhxCalendar(t){if(t&&(this.cell=t,this.grid=this.cell.parentNode.grid,!this.grid._grid_calendarA)){var e=this.grid._grid_calendarA=new dhtmlxCalendarObject;this.grid.callEvent("onDhxCalendarCreated",[e]);var n=this.grid;e.attachEvent("onClick",function(){return this._last_operation_calendar=!0,window.setTimeout(function(){n.editStop()},1),!0});dhtmlxEvent(e.base,"click",function(t){(t||event).cancelBubble=!0}),e=null}}function eXcell_dhxCalendarA(t){if(t&&(this.cell=t,this.grid=this.cell.parentNode.grid,!this.grid._grid_calendarA)){var e=this.grid._grid_calendarA=new dhtmlxCalendarObject;this.grid.callEvent("onDhxCalendarCreated",[e]);var n=this.grid;e.attachEvent("onClick",function(){return this._last_operation_calendar=!0,window.setTimeout(function(){n.editStop()},1),!0});dhtmlxEvent(e.base,"click",function(t){(t||event).cancelBubble=!0})}}function eXcell_cntr(t){if(this.cell=t,this.grid=this.cell.parentNode.grid,!this.grid._ex_cntr_ready&&!this._realfake){this.grid._ex_cntr_ready=!0,this.grid._h2&&this.grid.attachEvent("onOpenEn",function(e){this.resetCounter(t._cellIndex)});var e=function(){var e=this;return window.setTimeout(function(){e.resetCounter&&(e._fake&&!e._realfake&&t._cellIndex<e._fake._cCount?e._fake.resetCounter(t._cellIndex):e.resetCounter(t._cellIndex))},1),!0};this.grid.attachEvent("onBeforeSorting",e),this.grid.attachEvent("onFilterEnd",e)}this.edit=function(){},this.getValue=function(){return this.cell.innerHTML},this.setValue=function(t){this.cell.style.paddingRight="2px";var e=this.cell;window.setTimeout(function(){if(e.parentNode){var t=e.parentNode.rowIndex;(e.parentNode.grid.currentPage||t<0||e.parentNode.grid._srnd)&&(t=e.parentNode.grid.rowsBuffer._dhx_find(e.parentNode)+1),t<=0||(e.innerHTML=t,e.parentNode.grid._fake&&e._cellIndex<e.parentNode.grid._fake._cCount&&e.parentNode.grid._fake.rowsAr[e.parentNode.idd]&&e.parentNode.grid._fake.cells(e.parentNode.idd,e._cellIndex).setCValue(t),e=null)}},100)}}function eXcell_acheck(t){try{this.cell=t,this.grid=this.cell.parentNode.grid,this.cell.obj=this}catch(t){}this.changeState=function(){!this.grid.isEditable||this.cell.parentNode._locked||this.isDisabled()||(0!=this.grid.callEvent("onEditCell",[0,this.cell.parentNode.idd,this.cell._cellIndex])?(this.val=this.getValue(),"1"==this.val?this.setValue("<checkbox state='false'>"):this.setValue("<checkbox state='true'>"),this.cell.wasChanged=!0,this.grid.callEvent("onEditCell",[1,this.cell.parentNode.idd,this.cell._cellIndex]),this.grid.callEvent("onCheck",[this.cell.parentNode.idd,this.cell._cellIndex,"1"!=this.val]),this.grid.callEvent("onCheckbox",[this.cell.parentNode.idd,this.cell._cellIndex,"1"!=this.val])):this.editor=null)},this.getValue=function(){try{return this.cell.chstate.toString()}catch(t){return null}},this.isCheckbox=function(){return!0},this.isChecked=function(){return"1"==this.getValue()},this.setChecked=function(t){this.setValue(t.toString())},this.detach=function(){return this.val!=this.getValue()},this.drawCurrentState=function(){return 1==this.cell.chstate?"<div  onclick='(new eXcell_acheck(this.parentNode)).changeState(); (arguments[0]||event).cancelBubble=true;'  style='cursor:pointer; font-weight:bold; text-align:center; '><span style='height:8px; width:8px; background:green; display:inline-block;'></span>&nbsp;Yes</div>":"<div  onclick='(new eXcell_acheck(this.parentNode)).changeState(); (arguments[0]||event).cancelBubble=true;' style='cursor:pointer;  text-align:center; '><span style='height:8px; width:8px; background:red; display:inline-block;'></span>&nbsp;No</div>"}}function eXcell_context(t){if(t){if(this.cell=t,this.grid=this.cell.parentNode.grid,!this.grid._sub_context)return;if(this._sub=this.grid._sub_context[t._cellIndex],!this._sub)return;this._sindex=this._sub[1],this._sub=this._sub[0]}this.getValue=function(){return _isIE?this.cell.innerText:this.cell.textContent},this.setValue=function(t){this.cell._val=t;var e=this._sub.itemPull[this._sub.idPrefix+this.cell._val];t=e?e.title:t,this.setCValue(t||"&nbsp;",t)},this.edit=function(){var t=this.grid.getPosition(this.cell);this._sub.showContextMenu(t[0]+this.cell.offsetWidth,t[1]);var e=this.grid.editStop;this.grid.editStop=function(){},this.grid.editStop=e},this.detach=function(){if(null!=this.grid._sub_id){var t=this.cell._val;return this.setValue(this.grid._sub_id),this.grid._sub_id=null,this.cell._val!=t}this._sub.hideContextMenu()}}function dhtmlXGridFromTable(obj,init){"object"!=typeof obj&&(obj=document.getElementById(obj));var w=document.createElement("DIV");w.setAttribute("width",obj.getAttribute("gridWidth")||(obj.offsetWidth?obj.offsetWidth+"px":0)||(window.getComputedStyle?window.getComputedStyle(obj,null).width:obj.currentStyle?obj.currentStyle.width:0)),w.setAttribute("height",obj.getAttribute("gridHeight")||(obj.offsetHeight?obj.offsetHeight+"px":0)||(window.getComputedStyle?window.getComputedStyle(obj,null).height:obj.currentStyle?obj.currentStyle.height:0)),w.className=obj.className,obj.className="",obj.id&&(w.id=obj.id);var mr=obj,drag=obj.getAttribute("dragAndDrop");mr.parentNode.insertBefore(w,mr);var f=mr.getAttribute("name")||"name_"+(new Date).valueOf(),windowf=new dhtmlXGridObject(w);window[f]=windowf;var acs=mr.getAttribute("onbeforeinit"),acs2=mr.getAttribute("oninit");acs&&eval(acs),windowf.setImagePath(windowf.imgURL||mr.getAttribute("imgpath")||mr.getAttribute("image_path")||"");var skin=mr.getAttribute("skin");skin&&windowf.setSkin(skin),init&&init(windowf);for(var hrow=mr.rows[0],za=[],zb="",zc="",zd="",ze="",i=0;i<hrow.cells.length;i++){za.push(hrow.cells[i].innerHTML);var width=hrow.cells[i].getAttribute("width")||hrow.cells[i].offsetWidth||(window.getComputedStyle?window.getComputedStyle(hrow.cells[i],null).width:hrow.cells[i].currentStyle?hrow.cells[i].currentStyle.width:0);zb+=(zb?",":"")+("*"==width?width:parseInt(width)),zc+=(zc?",":"")+(hrow.cells[i].getAttribute("align")||"left"),zd+=(zd?",":"")+(hrow.cells[i].getAttribute("type")||"ed"),ze+=(ze?",":"")+(hrow.cells[i].getAttribute("sort")||"str");var f_a=hrow.cells[i].getAttribute("format");f_a&&(-1!=hrow.cells[i].getAttribute("type").toLowerCase().indexOf("calendar")?windowf._dtmask=f_a:windowf.setNumberFormat(f_a,i))}windowf.setHeader(za),windowf.setInitWidths(zb),windowf.setColAlign(zc),windowf.setColTypes(zd),windowf.setColSorting(ze),"auto"==obj.getAttribute("gridHeight")&&windowf.enableAutoHeigth(!0),obj.getAttribute("multiline")&&windowf.enableMultiline(!0);var lmn=mr.getAttribute("lightnavigation");lmn&&windowf.enableLightMouseNavigation(lmn);var evr=mr.getAttribute("evenrow"),uevr=mr.getAttribute("unevenrow");return(evr||uevr)&&windowf.enableAlterCss(evr,uevr),drag&&windowf.enableDragAndDrop(!0),windowf.init(),obj.getAttribute("split")&&windowf.splitAt(obj.getAttribute("split")),windowf.callEvent("onXLS",[]),windowf._process_inner_html(mr,1),acs2&&eval(acs2),obj.parentNode&&obj.parentNode.removeChild&&obj.parentNode.removeChild(obj),windowf.callEvent("onXLE",[]),windowf}function dhtmlXForm(t,e,n){this.idef={position:"label-left",labelWidth:"auto",labelHeight:"auto",inputWidth:"auto",inputHeight:"auto",labelAlign:"left",noteWidth:"auto",offsetTop:0,offsetLeft:0,blockOffset:20},this.idef_const={offsetNested:20},this.apos_css={"label-left":"dhxform_item_label_left","label-right":"dhxform_item_label_right","label-top":"dhxform_item_label_top","label-bottom":"dhxform_item_label_bottom",absolute:"dhxform_item_absolute"},this.align_css={left:"dhxform_label_align_left",center:"dhxform_label_align_center",right:"dhxform_label_align_right"};var i=this;for(var a in this.setSkin=function(t){this.skin=t,this.cont.className="dhxform_obj_"+this.skin,this.cont.style.fontSize="material"==t?"14px":"dhx_terrace"==t?"13px":"12px",this._updateBlocks(),this.forEachItem(function(e){var n=i.getItemType(e);void 0!==i.items[n]&&"function"==typeof i.items[n].setSkin&&i.doWithItem(e,"setSkin",t)})},this.skin=n||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhx_form")||"material",this.separator=",",this.live_validate=!1,this._type="checkbox",this._rGroup="default",this._idIndex={},this._indexId=[],this.cont="object"==typeof t?t:document.getElementById(t),t._isNestedForm||(this._parentForm=!0,this.cont.style.fontSize="material"==this.skin?"14px":"dhx_terrace"==this.skin?"13px":"12px",this.cont.className="dhxform_obj_"+this.skin,this.setFontSize=function(t){this.cont.style.fontSize=t,this._updateBlocks()},this.getForm=function(){return this},this.cont.onkeypress=function(t){if(13==(t=t||event).keyCode){var e=t.target||t.srcElement;if(void 0!==e.tagName&&"textarea"==String(e.tagName).toLowerCase()&&!t.ctrlKey)return;i.callEvent("onEnter",[])}}),this.b_index=null,this.base=[],this._prepare=function(t,e){null==this.b_index?this.b_index=0:this.b_index++;var n=null,i=null;if(null!=e){e<0&&(e=0);for(var a=0,o=0;o<this.cont.childNodes.length;o++)for(var r=0;r<this.cont.childNodes[o].childNodes.length;r++)null==i&&1!=this.cont.childNodes[o].childNodes[r]._isNestedForm&&(a==e&&(n=this.cont.childNodes[o].nextSibling,i=this.cont.childNodes[o].childNodes[r]),a++)}if(this.base[this.b_index]=document.createElement("DIV"),this.base[this.b_index].className="dhxform_base",void 0!==t&&(this.base[this.b_index].style.cssText+=" margin-left:"+t+"px!important;"),null!=n?(this.cont.insertBefore(this.base[this.b_index],n),n=null):this.cont.appendChild(this.base[this.b_index]),null!=i)for(;null!=i;){var s=i;i=i.nextSibling,this.base[this.b_index].appendChild(s),s=null}},this.setSizes=function(){},this._mergeSettings=function(t){var e=-1,n={type:"settings"};for(var i in this.idef)n[i]=this.idef[i];for(var a=0;a<t.length;a++)if(void 0!==t[a]&&"settings"==t[a].type){for(var i in t[a])n[i]=t[a][i];e=a}return t[e>=0?e:t.length]=n,t},this._genStr=function(t){for(var e="dhxId_",n="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",i=0;i<t;i++)e+=n.charAt(Math.floor(Math.random()*n.length));return e},this.idPrefix="dhxForm_"+this._genStr(12)+"_",this._rId=this._parentForm?this._genStr(12)+"_":t._rId,this.objPull={},this.itemPull={},this._ic=0,this._addItem=function(t,e,n,a,o,r,s){if(this.items[t]._index&&(this.getForm()._indexId.push(e),this.getForm()._idIndex[e]={ind:this.getForm()._indexId.length-1}),t||(t=this._type),"list"==t&&null!=o&&null!=this.itemPull[this.idPrefix+o]&&"function"==typeof this.itemPull[this.idPrefix+o]._addSubListNode)var l=this.itemPull[this.idPrefix+o]._addSubListNode();else if("newcolumn"==t)l={};else{null==this.b_index&&this._prepare();var d=this.base[this.b_index],c=null;if(void 0===r||isNaN(r)||"list"==t){if("list"==t)for(var h in this.itemPull)h==this.idPrefix+e&&(c=this.itemPull[h].nextSibling,null!=this.itemPull[h]._listBase&&this.itemPull[h]._listBase.length>0&&(c=this.itemPull[h]._listBase[this.itemPull[h]._listBase.length-1]))}else{r=Math.max(parseInt(r),0)+1;for(var u=0;u<this.cont.childNodes.length;u++)for(var m=0;m<this.cont.childNodes[u].childNodes.length;m++)null==c&&1!=this.cont.childNodes[u].childNodes[m]._isNestedForm&&0==--r&&(c=this.cont.childNodes[u].childNodes[m],d=this.cont.childNodes[u])}l=document.createElement("DIV");1==s&&null!=c&&(c=c.nextSibling),null!=c?d.insertBefore(l,c):d.appendChild(l)}if(l._idd=e,l._rId=this._rId,void 0!==l.style){void 0===n.offsetLeft&&this.idef.offsetLeft>0&&(n.offsetLeft=this.idef.offsetLeft),void 0===n.offsetTop&&this.idef.offsetTop>0&&(n.offsetTop=this.idef.offsetTop);var f="";void 0!==n.offsetLeft&&(f+=" padding-left:"+n.offsetLeft+"px!important;"),void 0!==n.offsetTop&&(f+=" padding-top:"+n.offsetTop+"px!important;"),l.style.cssText+=f}if("block"==t&&isNaN(n.blockOffset)&&(n.blockOffset=this.idef.blockOffset),"list"==t){void 0===l._ofsNested&&(l._ofsNested=this.idef_const.offsetNested),null!=a&&(l._sId=a);var p=this.items[t].render(l,this.skin);return this.itemPull[this.idPrefix+e]._listObj||(this.itemPull[this.idPrefix+e]._listObj=[]),this.itemPull[this.idPrefix+e]._list||(this.itemPull[this.idPrefix+e]._list=[]),this.itemPull[this.idPrefix+e]._listBase||(this.itemPull[this.idPrefix+e]._listBase=[]),this.itemPull[this.idPrefix+e]._listObj.push(p[0]),this.itemPull[this.idPrefix+e]._list.push(p[1]),this.itemPull[this.idPrefix+e]._listBase.push(l),p[1].checkEvent=function(t){return i.checkEvent(t)},p[1].callEvent=function(t,e){return i.callEvent(t,e)},p[1].getForm=function(){return i.getForm()},p[1]._initObj(this._mergeSettings(n)),l._inBlcok&&(l.className+=" in_block"),p[1]}if("newcolumn"!=t){if("label"==t&&0==this._ic++&&(n._isTopmost=!0),n.position=this.apos_css[n.position&&this.apos_css[n.position]?n.position:this.idef.position],l.className=n.position+("string"==typeof n.className?" "+n.className:""),n.labelWidth||(n.labelWidth=this.idef.labelWidth),n.labelHeight||(n.labelHeight=this.idef.labelHeight),void 0!==n.wrap&&(n.wrap=window.dhx4.s2b(n.wrap)),n.labelAlign=this.align_css[n.labelAlign]?this.align_css[n.labelAlign]:this.align_css[this.idef.labelAlign],n.inputWidth=n.width?n.width:n.inputWidth?n.inputWidth:this.idef.inputWidth,n.inputHeight||(n.inputHeight=this.idef.inputHeight),void 0!==n.note&&(null!=n.note.length&&null!=n.note[0]&&(n.note=n.note[0]),void 0===n.note.width&&(n.note.width=this.idef.noteWidth),"auto"==n.note.width&&(n.note.width=n.inputWidth)),l.checkEvent=function(t){return i.checkEvent(t)},l.callEvent=function(t,e){return i.callEvent(t,e)},l.getForm=function(){return i.getForm()},l._autoCheck=function(t){i._autoCheck(t)},"string"==typeof n.readonly&&(n.readonly=window.dhx4.s2b(n.readonly)),"string"==typeof n.autoStart&&(n.autoStart=window.dhx4.s2b(n.autoStart)),"string"==typeof n.autoRemove&&(n.autoRemove=window.dhx4.s2b(n.autoRemove)),"string"==typeof n.titleScreen&&(n.titleScreen=window.dhx4.s2b(n.titleScreen)),"string"==typeof n.info&&(n.info=window.dhx4.s2b(n.info)),"string"==typeof n.hidden&&(n.hidden=window.dhx4.s2b(n.hidden)),"string"==typeof n.checked&&(n.checked=window.dhx4.s2b(n.checked)),void 0!==n.userdata)for(var h in n.userdata)this.getForm().setUserData(e,h,n.userdata[h]);if(n.validate&&(n.validate,"function"==typeof n.validate||"function"==typeof window[n.validate]?l._validate=[n.validate]:l._validate=String(n.validate).split(this.separator)),void 0!==n.required&&("string"==typeof n.required&&(n.required=window.dhx4.s2b(n.required)),l._required=1==n.required),l._required){l._validate||(l._validate=[]);var _=!1;for(m=0;m<l._validate.length;m++)_=_||"NotEmpty"==l._validate[m];_||l._validate.push("NotEmpty")}l._ll=n.position==this.apos_css["label-left"]||n.position==this.apos_css["label-top"],this.objPull[this.idPrefix+e]=this.items[t].render(l,n),this.itemPull[this.idPrefix+e]=l}else this._prepare(n.offset,r)},this._initObj=function(t,e){if(void 0!==t.data){var n=null;return void 0!==e&&null!=(n=e.match(/(\?|\&)id\=([a-z0-9_\-]*)/i))&&null!=n[0]&&(n=n[0].split("=")[1]),void(!0===this.callEvent("onBeforeDataLoad",[n,window.dhx4._copyObj(t.data)])&&(this.formId=n,this._last_load_data=t,this.setFormData(t.data),this.resetDataProcessor("updated")))}this._prepare();for(var i=0;i<t.length;i++)if(void 0!==t[i]&&"settings"==t[i].type)for(var a in t[i])this.idef[a]=t[i][a];for(i=0;i<t.length;i++)this._prepareItem(t[i]);this._autoCheck()},this._prepareItem=function(t,e,n){var i=null!=t&&null!=t.type?t.type:"";if(this.items[i]){t.name||(t.name=this._genStr(12));var a=t.name;null==this.objPull[this.idPrefix+a]&&"radio"!=i||(a=this._genStr(12));var o=t;o.label=o.label||"",o.value=o.value,o.checked=window.dhx4.s2b(o.checked),o.disabled=window.dhx4.s2b(o.disabled),o.name=o.name||this._genStr(12),o.options=o.options||[],o.rows=o.rows||"none",o.uid=this._genStr(12),this._addItem(i,a,o,null,null,e,n),e=null,!1===this._parentEnabled&&this._disableItem(a);for(var r=0;r<o.options.length;r++){if(null!=o.options[r].list)o.options[r].value||(o.options[r].value=this._genStr()),(s=this._addItem("list",a,o.options[r].list,o.options[r].value,null))._subSelect=!0,s._subSelectId=o.options[r].value}if(null!=t.list){t.listParent||(t.listParent=o.name);var s=this._addItem("list",a,t.list,null,t.listParent)}}},this._xmlSubItems={item:"list",option:"options",note:"note",userdata:"_userdata"},this._xmlToObject=function(t,e){if(void 0===e&&(e=!0),e){var n=t.getElementsByTagName("items");n=null!=n&&null!=n[0]?n[0]:null;var i=t.getElementsByTagName("data");i=null!=i&&null!=i[0]?i[0]:null}else n=t;var a=e?[]:{};if(null!=n)for(var o=0;o<n.childNodes.length;o++)if(void 0!==n.childNodes[o].tagName){var r=n.childNodes[o].tagName;if(null!=this._xmlSubItems[r]){var s=this._xmlSubItems[r];void 0===a[s]&&(a[s]=[]);for(var l=n.childNodes[o],d={},c=0;c<l.attributes.length;c++){var h=l.attributes[c].name,u=l.attributes[c].value;d[h]=u}"note"==s&&(d.text=l.firstChild.nodeValue),"_userdata"==s&&(d.value=null!=l.firstChild&&null!=l.firstChild.nodeValue?l.firstChild.nodeValue:"");var m=this._xmlToObject(l,!1);for(var f in m)if("_userdata"==f){d.userdata||(d.userdata={});for(c=0;c<m[f].length;c++)d.userdata[m[f][c].name]=m[f][c].value}else d[f]=m[f];l=null,e?a.push(d):a[s].push(d)}}if(null!=i){a={data:{}};for(o=0;o<i.childNodes.length;o++)if(void 0!==i.childNodes[o].tagName){var p=i.childNodes[o].tagName,_=null!=i.childNodes[o].firstChild?i.childNodes[o].firstChild.nodeValue:"";a.data[p]=_}}return a},this._autoCheck=function(t){for(var e in!0===this._locked?t=!1:void 0===t&&(t=!0),this.itemPull){var n=t&&!0!==this.itemPull[e]._udis;this[n?"_enableItem":"_disableItem"](this.itemPull[e]._idd),null!=this.getForm()._idIndex[this.itemPull[e]._idd]&&(this.getForm()._idIndex[this.itemPull[e]._idd].enabled=n);var i=n&&("boolean"!=typeof this.itemPull[e]._checked||this.itemPull[e]._checked);if(this.itemPull[e]._list)for(var a=0;a<this.itemPull[e]._list.length;a++){var o=!0;if(1==this.itemPull[e]._list[a]._subSelect){o=!1;var r=this.getItemValue(this.itemPull[e]._idd);"object"==typeof r&&"number"==typeof r.length||(r=[r]);for(var s=0;s<r.length;s++)o=r[s]==this.itemPull[e]._list[a]._subSelectId||o;this.itemPull[e]._listObj[a][o?"show":"hide"](this.itemPull[e]._listBase[a])}this.itemPull[e]._list[a]._autoCheck(i&&o)}}},this.doWithItem=function(t,e,n,i,a,o){if("object"==typeof t){var r=t[0],s=t[1],l=null;for(var d in this.itemPull){if((this.itemPull[d]._value==s||null===s)&&this.itemPull[d]._group==r)return this.objPull[d][e](this.itemPull[d],n,i,a,o);if(null!=this.itemPull[d]._list&&!l)for(var c=0;c<this.itemPull[d]._list.length;c++)l=this.itemPull[d]._list[c].doWithItem(t,e,n,i,a)}if(null!=l)return l;if("getType"==e)return this.doWithItem(t[0],"getType")}else{if(!this.itemPull[this.idPrefix+t]){l=null;for(var d in this.itemPull)if(this.itemPull[d]._list&&!l)for(c=0;c<this.itemPull[d]._list.length;c++)null==l&&(l=this.itemPull[d]._list[c].doWithItem(t,e,n,i,a,o));return l}var h=this.objPull[this.idPrefix+t];if(h&&h[e])return h[e](this.itemPull[this.idPrefix+t],n,i,a,o)}},this._removeItem=function(t,e){null!=e?t=this.doWithItem([t,e],"destruct"):this.doWithItem(t,"destruct"),this._clearItemData(t)},this._clearItemData=function(t){if(this.itemPull[this.idPrefix+t]){t=this.idPrefix+t;try{this.objPull[t]=null,this.itemPull[t]=null,delete this.objPull[t],delete this.itemPull[t]}catch(t){}}else for(var e in this.itemPull)if(this.itemPull[e]._list)for(var n=0;n<this.itemPull[e]._list.length;n++)this.itemPull[e]._list[n]._clearItemData(t)},this.isItem=function(t,e){return null!=e&&(t=[t,e]),this.doWithItem(t,"isExist")},this.getItemType=function(t,e){return t=[t,e||null],this.doWithItem(t,"getType")},this.forEachItem=function(t){for(var e in this.objPull)if("radio"==this.objPull[e].t?t(this.itemPull[e]._group,this.itemPull[e]._value):t(String(e).replace(this.idPrefix,"")),this.itemPull[e]._list)for(var n=0;n<this.itemPull[e]._list.length;n++)this.itemPull[e]._list[n].forEachItem(t)},this.setItemLabel=function(t,e,n){null!=n?t=[t,e]:n=e,this.doWithItem(t,"setText",n)},this.getItemLabel=function(t,e){return null!=e&&(t=[t,e]),this.doWithItem(t,"getText")},this._enableItem=function(t){this.doWithItem(t,"enable")},this._disableItem=function(t){this.doWithItem(t,"disable")},this._isItemEnabled=function(t){return this.doWithItem(t,"isEnabled")},this.checkItem=function(t,e){null!=e&&(t=[t,e]),this.doWithItem(t,"check"),this._autoCheck()},this.uncheckItem=function(t,e){null!=e&&(t=[t,e]),this.doWithItem(t,"unCheck"),this._autoCheck()},this.isItemChecked=function(t,e){return null!=e&&(t=[t,e]),this.doWithItem(t,"isChecked")},this.getCheckedValue=function(t){return this.doWithItem([t,null],"getChecked")},this._getRGroup=function(t,e){for(var n in this.itemPull){if(this.itemPull[n]._group==t&&(null==e||this.itemPull[n]._value==e))return this.itemPull[n]._idd;if(null!=this.itemPull[n]._list)for(var i=0;i<this.itemPull[n]._list.length;i++){var a=this.itemPull[n]._list[i]._getRGroup(t,e);if(null!=a)return a}}return null},this.setItemValue=function(t,e){return this.resetValidateCss(t,e),"radio"==this.getItemType(t)?(null!=this._getRGroup(t,e)?this.checkItem(t,e):this.uncheckItem(t,this.getCheckedValue(t)),null):this.doWithItem(t,"setValue",e)},this.getItemValue=function(t,e){return"radio"==this.getItemType(t)?this.getCheckedValue(t):this.doWithItem(t,"getValue",e)},this.updateValues=function(){this._updateValues()},this.showItem=function(t,e){null!=e&&(t=[t,e]),this.doWithItem(t,"show")},this.hideItem=function(t,e){null!=e&&(t=[t,e]),this.doWithItem(t,"hide")},this.isItemHidden=function(t,e){return null!=e&&(t=[t,e]),this.doWithItem(t,"isHidden")},this.getOptions=function(t){return this.doWithItem(t,"getOptions")},this.setItemWidth=function(t,e){this.doWithItem(t,"setWidth",e)},this.getItemWidth=function(t){return this.doWithItem(t,"getWidth")},this.setItemHeight=function(t,e){this.doWithItem(t,"setHeight",e)},this.setItemFocus=function(t,e){null!=e&&(t=[t,e]),this.doWithItem(t,"setFocus")},this._updateValues=function(){for(var t in this.itemPull)if(this.objPull[t]&&"function"==typeof this.objPull[t].updateValue&&this.objPull[t].updateValue(this.itemPull[t]),this.itemPull[t]._list)for(var e=0;e<this.itemPull[t]._list.length;e++)this.itemPull[t]._list[e]._updateValues()},this._getItemByName=function(t){for(var e in this.itemPull){if(this.itemPull[e]._idd==t)return this.itemPull[e];if(null!=this.itemPull[e]._list)for(var n=0;n<this.itemPull[e]._list.length;n++){var i=this.itemPull[e]._list[n]._getItemByName(t);if(null!=i)return i}}return null},this._resetValidateCss=function(t){t.className=t.className.replace(t._vcss,""),t._vcss=null},this.setValidateCss=function(t,e,n){var i=this._getItemByName(t);i&&(null!=i._vcss&&this._resetValidateCss(i),i._vcss="string"==typeof n?n:"validate_"+(!0===e?"ok":"error"),i.className+=" "+i._vcss)},this.resetValidateCss=function(t){for(var e in this.itemPull)if(null!=this.itemPull[e]._vcss&&this._resetValidateCss(this.itemPull[e]),null!=this.itemPull[e]._list)for(var n=0;n<this.itemPull[e]._list.length;n++)this.itemPull[e]._list[n].resetValidateCss()},this._validateLoop=function(t){for(var e in this.objPull)if(t(String(e).replace(this.idPrefix,"")),this.itemPull[e]._list)for(var n=0;n<this.itemPull[e]._list.length;n++)this.itemPull[e]._list[n]._validateLoop(t)},this.validate=function(t){if(0!=this.callEvent("onBeforeValidate",[])){var e=!0;return this._validateLoop(function(t,n){var a=i.doWithItem(t,"_validate");"boolean"!=typeof a&&(a=!0),e=a&&e},!0),this.callEvent("onAfterValidate",[e]),e}},this.validateItem=function(t,e){return void 0!==e&&(t=[t,e]),this.doWithItem(t,"_validate")},this.enableLiveValidation=function(t){this.live_validate=1==t},this.setReadonly=function(t,e){this.doWithItem(t,"setReadonly",e)},this.isReadonly=function(t){return this.doWithItem(t,"isReadonly")},this.getFirstActive=function(t){for(var e=0;e<this._indexId.length;e++){var n=!0;if(1==t){var i=this.getItemType(this._indexId[e]);dhtmlXForm.prototype.items[i].setFocus||(n=!1)}if(n&&this._idIndex[this._indexId[e]].enabled)return this._indexId[e]}return null},this.setFocusOnFirstActive=function(){var t=this.getFirstActive(!0);null!=t&&this.setItemFocus(t)},this.enableItem=function(t,e){null!=e&&(t=[t,e]),this.doWithItem(t,"userEnable"),this._autoCheck()},this.disableItem=function(t,e){null!=e&&(t=[t,e]),this.doWithItem(t,"userDisable"),this._autoCheck()},this.isItemEnabled=function(t,e){return null!=e&&(t=[t,e]),this.doWithItem(t,"isUserEnabled")},this.clear=function(){var t={};for(var e in this.formId=(new Date).valueOf(),this.resetDataProcessor("inserted"),this.itemPull){var n=this.itemPull[e]._idd;if("ch"==this.itemPull[e]._type&&this.uncheckItem(n),this.itemPull[e]._type in{ta:1,editor:1,calendar:1,pw:1,hd:1}&&this.setItemValue(n,""),"combo"==this.itemPull[e]._type){this.itemPull[e]._apiChange=!0;var i=this.getCombo(n);i.selectOption(0),i=null,this.itemPull[e]._apiChange=!1}if("se"==this.itemPull[e]._type){var a=this.getOptions(n);a.length>0&&(a[0].selected=!0)}if("ra"==this.itemPull[e]._type){var o=this.itemPull[e]._group;t[o]||(this.checkItem(o,this.doWithItem(n,"_getFirstValue")),t[o]=!0)}if(this.itemPull[e]._list)for(var r=0;r<this.itemPull[e]._list.length;r++)this.itemPull[e]._list[r].clear();this["setFormData_"+this.itemPull[e]._type]&&this["setFormData_"+this.itemPull[e]._type](n,"")}t=null,this._parentForm&&this._autoCheck(),this.resetValidateCss()},this.unload=function(){for(var t in window.dhx4._enableDataLoading(this,null,null,null,"clear"),window.dhx4._eventable(this,"clear"),this.objPull)this._removeItem(String(t).replace(this.idPrefix,""));this._ccTm&&window.clearTimeout(this._ccTm),this._formLS=null;for(var e=0;e<this.base.length;e++){for(;this.base[e].childNodes.length>0;)this.base[e].removeChild(this.base[e].childNodes[0]);this.base[e].parentNode&&this.base[e].parentNode.removeChild(this.base[e]),this.base[e]=null}for(var t in this.base=null,this.cont.onkeypress=null,this.cont.className="",this.cont=null,this)this[t]=null;i=null},this.items)this.items[a].t=a,void 0===this.items[a]._index&&(this.items[a]._index=!0),this.items[a].show||(this.items[a].show=function(t){if(t.style.display="",t._listObj)for(var e=0;e<t._listObj.length;e++)t._listObj[e].show(t._listBase[e])}),this.items[a].hide||(this.items[a].hide=function(t){if(t.style.display="none",t._listObj)for(var e=0;e<t._listObj.length;e++)t._listObj[e].hide(t._listBase[e])}),this.items[a].isHidden||(this.items[a].isHidden=function(t){return"none"==t.style.display}),this.items[a].userEnable||(this.items[a].userEnable=function(t){t._udis=!1}),this.items[a].userDisable||(this.items[a].userDisable=function(t){t._udis=!0}),this.items[a].isUserEnabled||(this.items[a].isUserEnabled=function(t){return!0!==t._udis}),this.items[a].getType||(this.items[a].getType=function(){return this.t}),this.items[a].isExist||(this.items[a].isExist=function(){return!0}),this.items[a]._validate||(this.items[a]._validate=function(t){if(!t._validate||!t._enabled)return!0;if("ch"==t._type||"ra"==t._type){var e=this.isChecked(t)?this.getValue(t):0;"ra"==t._type&&void 0===e&&(e=0)}else e=this.getValue(t);for(var n=!0,i=0;i<t._validate.length;i++){var a="is"+t._validate[i];if(null!=e&&0!=e.length||"isNotEmpty"==a||"container"==t._type){var o=dhtmlxValidation[a];"container"==t._type&&"function"==typeof o&&(o=function(){return!0}),"function"!=typeof o&&"function"==typeof t._validate[i]&&(o=t._validate[i]),"function"!=typeof o&&"function"==typeof window[t._validate[i]]&&(o=window[t._validate[i]]),n=("function"==typeof o?o(e,t._idd):new RegExp(t._validate[i]).test(e))&&n,o=null}else;}return!1!==t.callEvent("onValidate"+(n?"Success":"Error"),[t._idd,e,n])&&t.getForm().setValidateCss(t._idd,n),n});return this._locked=!1,this._doLock=function(t){var e=!0===t;this._locked!=e&&(this._locked=e,this._autoCheck(!this._locked))},this.lock=function(){this._doLock(!0)},this.unlock=function(){this._doLock(!1)},this.isLocked=function(){return this._locked},this.setNumberFormat=function(t,e,n,i){return this.doWithItem(t,"setNumberFormat",e,n,i)},window.dhx4._enableDataLoading(this,"_initObj","_xmlToObject","items",{struct:!0,data:!0}),window.dhx4._eventable(this),this.attachEvent("_onButtonClick",function(t,e){this.callEvent("onButtonClick",[t,e])}),this._updateBlocks=function(){this.forEachItem(function(t){"block"!=i.getItemType(t)&&"combo"!=i.getItemType(t)||i.doWithItem(t,"_setCss",i.skin,i.cont.style.fontSize)})},this._isObj=function(t){return null!=t&&"object"==typeof t&&void 0===t.length},this._copyObj=function(t){if(this._isObj(t)){var e={};for(var n in t)"object"==typeof t[n]&&null!=t[n]?e[n]=this._copyObj(t[n]):e[n]=t[n]}else for(e=[],n=0;n<t.length;n++)"object"==typeof t[n]&&null!=t[n]?e[n]=this._copyObj(t[n]):e[n]=t[n];return e},null!=e&&"object"==typeof e&&this._initObj(this._copyObj(e)),this._parentForm&&this._updateBlocks(),this._ccActive=!1,this._ccTm=null,this}function dhtmlXFileUploader(t,e,n,i,a,o,r,s,l){var d=this;if("string"==typeof i&&"function"==typeof this[i])this.engine=i;else{this.engine="html4";var c=null;if(void 0!==window.FormData&&void 0!==window.XMLHttpRequest&&void 0===(c=new XMLHttpRequest).upload&&(c=null),null!=c)this.engine="html5";else if(void 0!==window.swfobject||!1===c)(c=swfobject.getFlashPlayerVersion()).major>=10&&(this.engine="flash");else this._sl_v=this.getSLVersion(),this._sl_v&&(this.engine="sl");c=null}"string"==typeof t&&(t=document.getElementById(t)),this._upload_mp=void 0===l||1==l,this._upload_dnd=!0,this._swf_file_url=e||"",this._swf_upolad_url=n||"",this._swf_logs=a,this._sl_xap=o,this._sl_upload_url=r,this._sl_logs=s,this.p=document.createElement("DIV"),this.p.className+=" dhx_file_uploader",t.appendChild(this.p),this.p_files=document.createElement("DIV"),this.p_files.className="dhx_upload_files",this.p.appendChild(this.p_files),this.p_controls=document.createElement("DIV"),this.p_controls.className="dhx_upload_controls",this.p.appendChild(this.p_controls),this._files={},this._items={},this._data={},this._autoStart=!1,this._autoRemove=!1,this._titleScreen=!0,this._enabled=!0,this._uploaded_count=0,this._initToolbar=function(){for(var t in this.b_opts={info:{onclick:null},browse:{onclick:null,tooltip:"Browse"},upload:{onclick:function(){d._enabled&&(d._uploading||d._uploadStart())},tooltip:"Upload"},cancel:{onclick:function(){d._enabled&&(d._uploadStop(),d._switchButton(!1))},tooltip:"Stop"},clear:{onclick:function(){d._enabled&&d.clear()},tooltip:"Clear list"}},this.buttons={},this.b_opts){var e=document.createElement("DIV");e.innerHTML="&nbsp;",e.className="dhx_file_uploader_button button_"+t,e.onclick=this.b_opts[t].onclick,this.b_opts[t].tooltip&&(e.title=this.b_opts[t].tooltip),this.p_controls.appendChild(e),this.buttons[t]=e,e=null}this.buttons.cancel.style.display="none"},this._readableSize=function(t){for(var e=!1,n=["b","Kb","Mb","Gb","Tb","Pb","Eb"],i=0;i<n.length;i++)t>1024?t/=1024:!1===e&&(e=i);return!1===e&&(e=n.length-1),Math.round(100*t)/100+" "+n[e]},this._beforeAddFileToList=function(t,e){return!0===this.callEvent("onBeforeFileAdd",[t,e])},this._addFileToList=function(t,e,n,i,a){this._checkTitleScreen();var o=document.createElement("DIV");o._idd=t,o.className="dhx_file dhx_file_"+i,o.innerHTML="<div class='dhx_file_param dhx_file_name'>&nbsp;</div><div class='dhx_file_param dhx_file_progress'>"+a+"%</div><div class='dhx_file_param dhx_file_delete' title='Remove from list'>&nbsp;</div>",this.p_files.appendChild(o),o.childNodes[0].style.width=o.offsetWidth-127+"px",this._items[t]=o,this._updateFileNameSize(t),o.childNodes[2].onclick=function(){if(d._enabled){var t=this.parentNode._idd;d._removeFileFromQueue(t)}},this.callEvent("onFileAdd",[e])},this._removeFileFromList=function(t){this._items[t]&&(this._items[t].childNodes[2].onclick=null,this._items[t].parentNode.removeChild(this._items[t]),this._items[t]=null,delete this._items[t],this._data[t]&&(this._data[t]=null,delete this._data[t]),this._checkTitleScreen())},this._updateFileNameSize=function(t){this._items[t].childNodes[0].innerHTML=this._files[t].name+(isNaN(this._files[t].size)?"&nbsp;":" ("+this._readableSize(this._files[t].size)+")"),this._items[t].childNodes[0].title=this._files[t].name+(isNaN(this._files[t].size)?"":" ("+this._readableSize(this._files[t].size)+")")},this._updateFileInList=function(t,e,n){this._items[t]&&(this._items[t].className="dhx_file dhx_file_"+e,this._updateProgress(t,e,n),this._updateFileNameSize(t))},this._updateProgress=function(t,e,n){"uploading"==e&&n<100&&"loader"==this._progress_type?(this._items[t].childNodes[1].className="dhx_file_param dhx_file_uploading",this._items[t].childNodes[1].innerHTML="&nbsp;"):(this._items[t].childNodes[1].className="dhx_file_param dhx_file_progress",this._items[t].childNodes[1].innerHTML=n+"%"),this._updateFileNameSize(t)},this._removeFilesByState=function(t){for(var e in this._files)!0!==t&&this._files[e].state!=t||this._removeFileFromQueue(e)},this._switchButton=function(t){if(1==t)this.buttons.upload.style.display="none",this.buttons.cancel.style.display="";else{var e=this._uploaded_count;this.buttons.upload.style.display="",this.buttons.cancel.style.display="none",this._uploaded_count=0,e>0&&this.callEvent("onUploadComplete",[e])}},this._uploadStart=function(){if(this._switchButton(!0),!this._uploading)for(var t in this._files)"fail"==this._files[t].state&&(this._files[t].state="added",this._updateFileInList(t,"added",0));this._uploading=!0;var e=!1;for(var t in this._files)e||"added"!=[this._files[t].state]||(e=!0,this._files[t].state="uploading",this._updateFileInList(t,"uploading",0),this._doUploadFile(t));e||(this._uploading=!1,this._switchButton(!1))},this._onUploadSuccess=function(t,e,n,i){if(void 0!==n&&"flash"==this.engine){var a=dhx4.s2j(n.data);if(null==a||1!=a.state||null==a.name)return void this._onUploadFail(t,null!=a&&null!=a.extra?a.extra:null);e=a.name,null!=a.extra&&(i=a.extra)}this._uploaded_count++,this._data[t]={realName:this._files[t].name,serverName:e},this._files[t].state="uploaded",this._updateFileInList(t,"uploaded",100),this.callEvent("onUploadFile",[this._files[t].name,e,i]),this._autoRemove&&this._removeFileFromQueue(t),this._uploading&&this._uploadStart()},this._onUploadFail=function(t,e){this._files[t].state="fail",this._updateFileInList(t,"fail",0),this.callEvent("onUploadFail",[this._files[t].name,e]),this._uploading&&this._uploadStart()},this._onUploadAbort=function(t){this._uploading=!1,this._files[t].state="added",this._updateFileInList(t,"added",0),this.callEvent("onUploadCancel",[this._files[t].name])},this._checkTitleScreen=function(){var t=0;for(var e in this._files)t++;0==t&&this.p.className.search("dhx_file_uploader_title")<0&&this._titleScreen&&(this.p.className+=" dhx_file_uploader_title",this.buttons.info.innerHTML=this._titleText,this.buttons.info.style.width=Math.max(this.p_controls.offsetWidth-134,0)+"px"),(t>0||!this._titleScreen)&&this.p.className.search("dhx_file_uploader_title")>=0&&(this.p.className=this.p.className.replace(/dhx_file_uploader_title/g,""),this.buttons.info.innerHTML="")},this.callEvent=function(){},this.upload=function(){this._uploading||this._uploadStart()},this.setAutoStart=function(t){this._autoStart=1==t},this.setAutoRemove=function(t){this._autoRemove=1==t},this.enableTitleScreen=function(t){this._titleScreen=1==t,this._checkTitleScreen()},this.setTitleText=function(t){this._titleText=t,this.p.className.search("dhx_file_uploader_title")>=0&&(this.buttons.info.innerHTML=this._titleText)},this.setURL=function(t){this._url=t},this.setSWFURL=function(t){this._swf_upolad_url=t},this.enable=function(){this._enabled=!0,this.p_files.className="dhx_upload_files",this.p_controls.className="dhx_upload_controls"},this.disable=function(){this._enabled=!1,this.p_files.className="dhx_upload_files dhx_uploader_dis",this.p_controls.className="dhx_upload_controls dhx_uploader_dis"},this.getStatus=function(){var t=0;for(var e in this._files){if("uploaded"!=this._files[e].state)return-1;t=1}return t},this.getData=function(){return this._data},this.clear=function(){!0===this.callEvent("onBeforeClear",[])&&(this._uploading&&d._uploadStop(),d._switchButton(!1),d._removeFilesByState(!0),this.callEvent("onClear",[]))},this.unload=function(){for(var t in this._removeFilesByState(!0),this._data=null,this._files=null,this._items=null,this._unloadEngine(),this.buttons)this.buttons[t].onclick=null,this.buttons[t].parentNode.removeChild(this.buttons[t]),this.buttons[t]=null,delete this.buttons[t];for(var t in this.buttons=null,this.b_opts)this.b_opts[t].onclick=null,this.b_opts[t]=null,delete this.b_opts[t];for(var t in this.b_opts=null,this.p_controls.parentNode.removeChild(this.p_controls),this.p_files.parentNode.removeChild(this.p_files),this.p.className=this.p.className.replace(/dhx_file_uploader_title/gi,"").replace(/dhx_file_uploader/gi,""),this)this[t]=null;d=t=null};var h=new this[this.engine];for(var u in h)this[u]=h[u],h[u]=null;return u=h=t=null,this._initToolbar(),this._initEngine(),this._checkTitleScreen(),this}function dhtmlXAccordion(t,e){var n=this,i=window.dhx4.transDetect();this.conf={skin:e||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxacc")||"material",css:"dhxacc",icons_path:"",icons_css:!1,multi_mode:!1,last_opened:null,on_active_id:null,on_active_click:!1,size_changed:!0,def_height:90,total_count:0,hiden_count:0,cont_w:null},this.conf.tr={prop:i.transProp,ev:i.transEv,height_open:"height 0.2s cubic-bezier(0.25,0.1,0.25,1)",height_close:"height 0.18s cubic-bezier(0.25,0.1,0.25,1)",op_open:"opacity 0.16s ease-in",op_close:"opacity 0.2s ease-out",op_v_open:"1",op_v_close:"0.4",dnd_top:"top 0.16s"},this.ofs={m:{},s:{},def:{m:{left:0,right:0,first:0,between:8},s:{left:0,right:0,first:0,between:-1,last:0}},base:{s:{},m:{}},skin:{dhx_web:{s:{between:3},m:{between:3}},dhx_terrace:{m:{between:12,left:0,right:0}},material:{m:{between:12,left:0,right:0}}}},navigator.userAgent.indexOf("MSIE")>=0||navigator.userAgent.indexOf("Trident"),this.conf.tr.height_open=this.conf.tr.height_close;var a=null;if("object"==typeof t&&!t.tagName){for(var o in a={},t)a[o]=t[o],t[o]=null;t=a.parent,a.parent=null}if(window.dhtmlXCellTop.apply(this,[t,t._ofs]),this._adjustCont(),null!=this.base._ofs)for(var r in this.ofs.base)if(null!=this.base._ofs[r])for(var o in this.base._ofs[r])this.ofs.base[r][o]=this.base._ofs[r][o];return this._applyOffsets=function(){for(var t in this.ofs.def){var e=this.ofs.def[t],n=null!=this.ofs.skin[this.conf.skin]&&null!=this.ofs.skin[this.conf.skin][t]?this.ofs.skin[this.conf.skin][t]:null,i=null!=this.base._ofs?this.base._ofs[t]:null;for(var a in e)null!=n&&null!=n[a]?this.ofs[t][a]=n[a]:null!=i&&null!=i[a]?this.ofs[t][a]=i[a]:this.ofs[t][a]=e[a]}},this._applyOffsets(),this.t={},this.addItem=function(t,e,i,a,o){for(null==t&&(t="a"+window.dhx4.newId());null!=this.t[t];)t="a"+window.dhx4.newId();var r=new dhtmlXAccordionCell(t,this);if(r.conf.skin=this.conf.skin,r.setText(e),null!=o&&r.setIcon(o),r.cell._accId=t,r.cell.childNodes[r.conf.idx.hdr].onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},r.cell.childNodes[r.conf.idx.hdr].onclick=function(t){if((t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,null==n._dnd||1!=n._dnd.ofs){for(var e=t.target||t.srcElement,i=null;e._accId!=this&&null==i;)null!=e._accId?i=e._accId:e=e.parentNode;null!=i&&n._hdrClick(i)}},this.t[t]={cell:r},this.conf.total_count++,this.conf.multi_mode)void 0===i&&(i=!0),this.cont.appendChild(r.cell),r.conf.opened=1==i,void 0===a||null==a||"*"==a?("*"==a&&(r.conf.h_auto=!0),a=this.conf.def_height):a=Math.max(parseInt(a),30),r._setSize(this.ofs.m.left,0,this.conf.cont_w||this._getAvailItemWidth(),r.conf.opened?a:r._getHdrHeight()),r.cell.style.marginTop=(r.cell==this.cont.firstChild?this.ofs.m.first:this.ofs.m.between)+"px",1!=i&&(r.conf.size.h=a,r._adjustCell(),r.cell.className+=" dhx_cell_closed"),this._adjustOpened(),null!=this._dnd&&this._dndAttachEvent(t);else{i=null==this.conf.last_opened||window.dhx4.s2b(i);var s=this._updateCellsHeight();if(null!=this.conf.last_opened)if(i)this._closeItem(this.conf.last_opened,!1);else{var l=this.t[this.conf.last_opened].cell;l._setSize(l.conf.size.x,l.conf.size.y,l.conf.size.w,s),l=null}this.cont.appendChild(r.cell),r.conf.opened=i,r.cell.style.marginTop=String(r.cell==this.cont.firstChild?this.ofs.s.first:this.ofs.s.between)+"px",r._setSize(this.ofs.s.left,0,this.conf.cont_w||this._getAvailItemWidth(),i?s:r._getHdrHeight()),i?this.conf.last_opened=t:(r.conf.size.h=s,r._adjustCell(),r.cell.className+=" dhx_cell_closed")}return r=null,this.t[t].cell},this.removeItem=function(t){this.t[t]&&(this.conf.last_opened==t&&(this.conf.last_opened=null),this.conf.on_active_id==t&&(this.conf.on_active_id=null),null!=this._dnd&&this._dndClearCell(t),this.conf.total_count--,this.conf.multi_mode||this.t[t].cell.conf.visible||this.conf.hiden_count--,this.t[t].cell._unload(),this.t[t].cell=null,this.t[t]=null,delete this.t[t],this.conf.unloading||(this.conf.multi_mode||this._updateCellsMargin(),this.setSizes()))},this.cells=function(t){return this.t[t].cell},this.enableMultiMode=function(t,e){this.conf.multi_mode=!0,isNaN(e)||(this.conf.def_height=e),"auto"==t||"scroll"==t?(this.cont.style.overflowX="hidden",this.cont.style.overflowY=t):this.cont.style.overflow="visible"},this.forEachItem=function(t){for(var e in this.t)"function"==typeof t?t.apply(this,[this.t[e].cell]):"string"==typeof t&&"function"==typeof window[t]&&window[t].apply(this,[this.t[e].cell])},this._openItem=function(t,e){void 0===e&&(e=!0),0==this.t[t].cell.conf.opened&&(this.conf.multi_mode?this.t[t].cell._open(e):0==this.conf.tr.prop?(null!=this.conf.last_opened&&this.t[this.conf.last_opened].cell._close(!1),this.t[t].cell._open(!1),this.conf.last_opened=t):(this.conf.on_active_id=t,this.t[t].cell._open(e),null!=this.conf.last_opened&&this.t[this.conf.last_opened].cell._close(e),this.conf.last_opened=t))},this._closeItem=function(t,e){void 0===e&&(e=!0),1==this.t[t].cell.conf.opened&&(this.t[t].cell._close(e),this.conf.last_opened=null)},this._adjustOpened=function(){if(1==this.conf.multi_mode){if(null==this._openCache){var t=this._getDynData();for(var e in t)this.t[e].cell.conf.size.h=Math.max(t[e],0),this.t[e].cell.cell.style.height=Math.max(t[e],0)+"px"}else{var n=!1;for(var e in this._openCache)n=n||this._openCache[e];if(1==n)return;this._openCache=this._openId=null}var i=this._getAvailItemWidth();for(var e in this.t){var a=!0;i!=this.t[e].cell.conf.size.w||"close"!=this._openMode&&0!=this.t[e].cell.conf.opened||(a=!1),a&&this.t[e].cell._setWidth(i)}this._openMode=null}else if(null!=this.conf.last_opened){var o=this.conf.last_opened;this.t[o].cell._setSize(this.t[o].cell.conf.size.x,this.t[o].cell.conf.size.y,this.t[o].cell.conf.size.w,this.t[o].cell.conf.size.h)}},this._getDynData=function(t,e){void 0!==t&&null!=t||(t={}),void 0!==e&&null!=e||(e={});for(var n={},i=0,a=0,o=0,r=0;r<this.cont.childNodes.length;r++){var s=this.cont.childNodes[r]._accId,l=this.t[s].cell;if(1==l.conf.visible){var d=this.ofs.m[0==o?"first":"between"];if(1==t[s]||1==e[s]||1==l.conf.opened&&1==l.conf.h_auto)if(1==e[s]){var c=l._getHdrHeight();n[s]=c,a+=c+d}else 1==l.conf.h_auto?(n[s]=!0,a+=d,i++):1==t[s]&&(n[s]=l.conf.size.h,a+=l.conf.size.h+d);else a+=l.cell.offsetHeight+d;o++}l=null}if(i>0){var h=this.cont.offsetHeight-a;a=Math.floor(h/i);for(var u in n)1==n[u]&&(i>1?h-=a:a=h,n[u]=a,i--)}return n},this.setSizes=function(){if(this._adjustCont(),1==this.conf.multi_mode)this._adjustOpened();else{this.conf.cont_w=null;var t=this._updateCellsHeight();for(var e in this.t)1==this.t[e].cell.conf.visible&&(this.t[e].cell._setSize(this.ofs.s.left,0,this.conf.cont_w||this._getAvailItemWidth(),this.t[e].cell.conf.opened?t:this.t[e].cell._getHdrHeight()),1!=this.t[e].cell.conf.opened&&(this.t[e].cell.conf.size.h=t,this.t[e].cell._adjustCell()));this.conf.size_changed=!0}this.callEvent("_onSetSizes",[])},this.setSkin=function(t){for(var e in this._setBaseSkin(t),this.conf.skin=t,this.t)this.t[e].cell.conf.cells_cont=null,this.t[e].cell.conf.skin=this.conf.skin;this._applyOffsets(),this._updateCellsMargin(),this.setSizes()},this.setIconsPath=function(t){this.conf.icons_path=t},this._getAvailItemWidth=function(){var t=this.ofs[this.conf.multi_mode?"m":"s"],e=Math.max(this.cont.clientWidth-t.left-t.right,10);return this.conf.cont_w=e,t=null,e},this._updateCellsHeight=function(){if(1!=this.conf.multi_mode){var t=this.conf.total_count-this.conf.hiden_count,e=this.cont.offsetHeight-this.ofs.s.last;if(0==t)return e;for(var n=!1,i=0;i<this.cont.childNodes.length;i++)if(0==n){var a=this.cont.childNodes[i]._accId;this.t[a].cell.conf.visible&&(e-=this.t[a].cell._getHdrHeight()*(t-1),n=!0)}for(var o in e-=(t-1)*this.ofs.s.between+this.ofs.s.first,this.t)null!=this.t[o].cell.conf.size&&(this.t[o].cell.conf.size.h=e,this.t[o].cell._adjustCell());return e}},this._updateCellsMargin=function(){for(var t=0,e=0;e<this.cont.childNodes.length;e++){var n=this.cont.childNodes[e]._accId;this.t[n].cell.conf.visible&&(this.t[n].cell.cell.style.marginTop=String(this.ofs[this.conf.multi_mode?"m":"s"][0==t++?"first":"between"])+"px")}},this._hdrClick=function(t){if(this.conf.multi_mode||!this.t[t].cell.conf.opened){var e=this.t[t].cell.conf.opened;!0===this.callEvent("onBeforeActive",[t,!e])&&(this.conf.on_active_click=!0,this[e?"_closeItem":"_openItem"](t),this.conf.multi_mode&&0==this.conf.tr.prop&&this._adjustOpened())}},this.unload=function(){for(var t in this.conf.unloading=!0,this.t)this.removeItem(t);for(var t in this.t=null,"function"==typeof this._unloadDND&&this._unloadDND(),this.dhxWins&&(this.dhxWins.unload(),this.dhxWins=null),this._unloadTop(),window.dhx4._enableDataLoading(this,null,null,null,"clear"),window.dhx4._eventable(this,"clear"),this.ofs=this.conf=null,this)this[t]=null;n=null},this.setOffset=function(t){this.ofs.s.between=t,this.ofs.m.between=t,this._updateCellsMargin(),this.setSizes()},this._initObj=function(t){if(null!=t.skin&&this.setSkin(t.skin),window.dhx4.s2b(t.multi_mode)&&this.enableMultiMode(),null!=t.icons_path&&this.setIconsPath(t.icons_path),null!=t.icon_path&&this.setIconsPath(t.icon_path),null!=t.iconset&&(this.conf.icons_css="awesome"==t.iconset),null!=t.items)for(var e=0;e<t.items.length;e++)this.addItem(t.items[e].id,t.items[e].text,t.items[e].open,t.items[e].height,t.items[e].icon||t.items[e].img);1==window.dhx4.s2b(t.dnd)&&"function"==typeof this.enableDND&&this.enableDND()},this._xmlToObj=function(t){var e={items:[]},n=t.getElementsByTagName("accordion")[0];null!=n.getAttribute("skin")&&(e.skin=n.getAttribute("skin")),"multi"==n.getAttribute("mode")&&(e.multi_mode=!0),null!=n.getAttribute("multiMode")&&(e.multi_mode=window.dhx4.s2b(n.getAttribute("multiMode"))),null!=n.getAttribute("iconsPath")&&(e.icons_path=n.getAttribute("iconsPath"));for(var i=0;i<n.childNodes.length;i++){var a=n.childNodes[i];if(void 0!==a.tagName&&"cell"==String(a.tagName).toLowerCase()){var o={};null!=a.getAttribute("id")&&(o.id=a.getAttribute("id")),null!=a.getAttribute("icon")&&(o.icon=a.getAttribute("icon")),null!=a.getAttribute("height")&&(o.height=a.getAttribute("height")),null!=a.getAttribute("open")&&(o.open=window.dhx4.s2b(a.getAttribute("open"))),o.text=a.firstChild.nodeValue,e.items.push(o)}a=null}return e},window.dhx4._enableDataLoading(this,"_initObj","_xmlToObj","accordion",{struct:!0}),window.dhx4._eventable(this),this._callMainEvent=function(t,e){return this.callEvent(t,e)},this.attachEvent("onActive",function(t){null!=t&&null!=this.t[t]&&null!=this.t[t].cell.dataObj&&"editor"==this.t[t].cell.dataType&&this.t[t].cell.dataObj._prepareContent(!0),null!=t&&null!=this.t[t]&&1==this.t[t].cell.conf.opened&&this.t[t].cell._adjustProgress()}),"function"==typeof window.dhtmlXWindows&&(this.dhxWins=new dhtmlXWindows,this.dhxWins.setSkin(this.conf.skin)),null!=a&&(this._initObj(a),a=null),this}function dhtmlXAccordionCell(t,e){for(var n in dhtmlXCellObject.apply(this,[t,"_acc"]),this.acc=e,this.conf.visible=!0,this.conf.docked=!0,this.attachEvent("_onCellUnload",function(){this._trDetachEv(),this._unloadDocking(),this.acc=null,this.cell._accObj=null,this.cell.childNodes[this.conf.idx.hdr].onselectstart=null,this.cell.childNodes[this.conf.idx.hdr].onclick=null,this._initHeader=null,this._getHdrHeight=null,this._setWidth=null,this._adjustCell=null,this._open=null,this._close=null,this._isOpened=null,this._trInitEv=null,this._trAttachEv=null,this._trDetachEv=null,this._trOnEnd=null,this._onActiveCall=null,this.setText=null,this.getText=null,this.setIcon=null,this.clearIcon=null,this.show=null,this.hide=null,this.isVisible=null,this.setHeight=null,this.moveOnTop=null}),this.acc.attachEvent("onBeforeDrag",function(t){for(var e in null!=this.t[t].cell.dataObj&&"editor"==this.t[t].cell.dataType&&(null==this.conf.editor_data&&(this.conf.editor_data={}),this.conf.editor_data[t]=this.t[t].cell.dataObj.getContent()),this.t)this.t[e].cell._showCellCover();return!0}),this.acc.attachEvent("onDrop",function(t){for(var e in null!=this.t[t].cell.dataObj&&"editor"==this.t[t].cell.dataType&&(this.t[t].cell.dataObj._prepareContent(!0),null!=this.conf.editor_data&&null!=this.conf.editor_data[t]&&(this.t[t].cell.dataObj.setContent(this.conf.editor_data[t]),this.conf.editor_data[t]=null)),this.t)this.t[e].cell._hideCellCover()}),this.acc.attachEvent("_onDropCancel",function(t){for(var e in this.t)this.t[e].cell._hideCellCover()}),this.attachEvent("_onContentLoaded",function(){this.acc._callMainEvent("onContentLoaded",arguments)}),this.attachEvent("_onBeforeContentAttach",function(t){"sidebar"==t&&"dhx_skyblue"!=this.conf.skin&&this._hideBorders()}),this._initHeader(),this.conf.tr={},this.acc.conf.tr)this.conf.tr[n]=this.acc.conf.tr[n];return 0!=this.conf.tr.prop&&this.attachEvent("_onIdxUpdated",function(){this._cellSetOpacity(this.conf.opened?"open":"close",!1)}),this.open=function(t){1==window.dhx4.s2b(t)&&(this.acc.conf.on_active_click=!0),this.acc._openItem(this._idd)},this.close=function(t){1==window.dhx4.s2b(t)&&(this.acc.conf.on_active_click=!0),this.acc._closeItem(this._idd)},this._setWidth=function(t){t!=this.conf.size.w&&(this.conf.size.w=t,this.cell.style.width=t+"px"),this._adjustCell()},this._adjustCell=function(){this._adjustCont(),null!=this.dataObj&&"function"==typeof this.dataObj.setSizes&&this.dataObj.setSizes()},this._initDocking(),this}function dhtmlXLayoutObject(t,e,n){var i=null;if(null!=t&&"object"==typeof t&&void 0===t.tagName&&1!=t._isCell&&(i={},null!=t.autosize&&(i.autosize=t.autosize),null!=t.cells&&(i.cells=t.cells),null!=t.pattern&&(e=t.pattern),null!=t.skin&&(n=t.skin),null!=t.offsets&&(i.offsets=t.offsets),t=t.parent),this.cdata={},this.conf={skin:n||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxlayout")||"material",css:"dhxlayout",hh:20,autosize:"b",nextCell:{a:"b",b:"a"},inited:!1,b_size:{w:-1,h:-1}},"material"==this.conf.skin&&(this.conf.hh=window.dhx4.readFromCss("dhxlayout_base_material dhxlayout_collapsed_height")),"object"==typeof t&&1==t._isCell){var a=void 0!==i&&null!=i?i:{};return null==a.pattern&&null!=e&&(a.pattern=e),null==a.skin&&null!=n&&(a.skin=n),t.attachLayout(a)}window.dhtmlXCellTop.apply(this,[t,null==i?null:i.offsets]),this.conf.sw=this._detectSW();var o=this;this._getLayout=function(){return this},this.mainInst=null!=t._layoutMainInst?t._layoutMainInst:null,this._getMainInst=function(){return null!=this.mainInst?this.mainInst._getMainInst():this},this._init=function(t){var e="string"==typeof t?this.tplData[t]:t;for(var n in this.conf.mode=e.mode,"c"==this.conf.mode?this.cdata.a=new dhtmlXLayoutCell("a",this):(this.cdata.a=new dhtmlXLayoutCell("a",this),this.cdata.b=new dhtmlXLayoutCell("b",this)),this.cdata)this.cont.appendChild(this.cdata[n].cell),this.cdata[n].conf.init={w:.5,h:.5};if("c"!=this.conf.mode){var i=this._getMainInst();null==i.conf.sep_idx?i.conf.sep_idx=1:i.conf.sep_idx++,this.sep=new dhtmlXLayoutSepObject(this.conf.mode,i.conf.sep_idx),this.cont.appendChild(this.sep.sep),this.sep._getLayout=function(){return o._getLayout()},i=null}if(null!=e.cells)for(var n in e.cells)null!=e.cells[n].width&&(this.cdata[n].conf.init.w=e.cells[n].width),null!=e.cells[n].height&&(this.cdata[n].conf.init.h=e.cells[n].height),null!=e.cells[n].name&&(this.cdata[n].conf.name=e.cells[n].name,this.cdata[n].setText(e.cells[n].name)),null!=e.cells[n].fsize&&(this.cdata[n].conf.fsize=e.cells[n].fsize);for(var n in this.setSizes(),this.cdata)this.cdata[n].conf.init={};if(null!=e.cells)for(var n in e.cells)null!=e.cells[n].layout&&(this.cdata[n].dataNested=!0,this.cdata[n]._layoutMainInst=this,this.cdata[n].cell.className+=" dhx_cell_nested_layout",this.cdata[n].attachLayout({pattern:e.cells[n].layout}),this.cdata[n]._layoutMainInst=null)},this.setSizes=function(t,e,n,i){var a=1==this.conf.inited&&this._getMainInst()==this&&1==this.checkEvent("onResizeFinish")&&{};this._adjustCont();var o=this.cont.offsetWidth,r=this.cont.offsetHeight;if("c"==this.conf.mode){var s=0,l=0,d=o,c=r;return this.cdata.a._setSize(s,l,d,c,t,n,i),this.callEvent("_onSetSizes",[]),!a||this.conf.b_size.w==o&&this.conf.b_size.h==r||this._callMainEvent("onResizeFinish",[]),void(this.conf.b_size={w:o,h:r})}if(void 0===e){this.conf.mode;e=this.conf.autosize,this.cdata.a.conf.collapsed?e="b":this.cdata.b.conf.collapsed?e="a":"a"!=t&&"b"!=t||(e=this.conf.nextCell[t])}if("v"==this.conf.mode){if("a"==e){if(null!=this.cdata.b.conf.init.w)var h=Math.round(o*this.cdata.b.conf.init.w-this.conf.sw/2);else h=this.cdata.b.conf.size.w;var u=r;l=m=0,d=(f=o-h)-(s=0)-this.conf.sw,c=u}else{s=0,l=0;if(null!=this.cdata.a.conf.init.w)d=Math.round(o*this.cdata.a.conf.init.w-this.conf.sw/2)-s;else d=this.cdata.a.conf.size.w;c=r-l;var m=l;h=o-(f=s+d+this.conf.sw),u=c}this.cdata.a._setSize(s,l,d,c,t,n,i),this.cdata.b._setSize(f,m,h,u,t,n,i),this.sep._setSize(s+d,l,this.conf.sw,c)}else{if("a"==e){if(null!=this.cdata.b.conf.init.h)u=Math.round(r*this.cdata.b.conf.init.h-this.conf.sw/2);else u=this.cdata.b.conf.size.h;s=f=0,d=h=o-f,c=(m=r-u)-(l=0)-this.conf.sw}else{l=0,d=o-(s=0);if(null!=this.cdata.a.conf.init.h)c=Math.round(r*this.cdata.a.conf.init.h-this.conf.sw/2);else c=this.cdata.a.conf.size.h;var f=s;h=d,u=r-(m=l+c+this.conf.sw)}this.cdata.a._setSize(s,l,d,c,t,n,i),this.cdata.b._setSize(f,m,h,u,t,n,i),this.sep._setSize(s,l+c,d,this.conf.sw)}this.callEvent("_onSetSizes",[]),!a||this.conf.b_size.w==o&&this.conf.b_size.h==r||this._callMainEvent("onResizeFinish",[]),this.conf.b_size={w:o,h:r}},this._getAvailWidth=function(){for(var t=[],e=0;e<this.conf.as_cells.h.length;e++){var n=this.cells(this.conf.as_cells.h[e]),i=n.layout,a=i.conf.autosize;n.conf.collapsed&&(n=i.cdata[i.conf.nextCell[n._idd]],a=i.conf.nextCell[a]),t.push(Math.max(0,n.getWidth()-n._getMinWidth(a))),i=n=null}var o=t.length>0?Math.min.apply(window,t):0;return this.cont.offsetWidth-o},this._getAvailHeight=function(){for(var t=[],e=0;e<this.conf.as_cells.v.length;e++){var n=this.cells(this.conf.as_cells.v[e]),i=n.layout,a=i.conf.autosize;n.conf.collapsed&&(n=i.cdata[i.conf.nextCell[n._idd]],a=i.conf.nextCell[a]),t.push(Math.max(0,n.getHeight()-n._getHdrHeight()-n._getMinHeight(a))),i=n=null}var o=Math.min.apply(window,t);return this.cont.offsetHeight-o},this.setSkin=function(t){this._setBaseSkin(t),this.conf.skin=t},this.unload=function(){if(this.conf.unloading=!0,this.mainInst=null,this.parentLayout=null,null!=this.items){for(var t=0;t<this.items.length;t++)this.items[t]=null;this.items=null}for(var e in null!=this.dhxWins&&(this.dhxWins.unload(),this.dhxWins=null),null!=this.sep&&(this.sep._unload(),this.sep=null),this.cdata)this.cdata[e]._unload(),this.cdata[e]=null;for(var e in this._unloadTop(),window.dhx4._eventable(this,"clear"),this)this[e]=null;o=null},this._getWindowMinDimension=function(t){var e=o._getAvailWidth()+7+7,n=o._getAvailHeight()+7+31;return null,{w:Math.max(e,200),h:Math.max(n,140)}},window.dhx4._eventable(this),this._callMainEvent=function(t,e){return this.callEvent(t,e)},this._init(e||"3E");var r=this._availAutoSize[e];if(null!=r&&(this.conf.pattern=e,this.setAutoSize(r.h[r.h.length-1],r.v[r.v.length-1])),"function"==typeof window.dhtmlXWindows&&null==this.mainInst){var s={vp_overflow:1!=this.conf.fs_mode&&"auto"};this.dhxWins=new dhtmlXWindows(s),this.dhxWins.setSkin(this.conf.skin)}if(this.conf.inited=!0,this==this._getMainInst()){var l=0;this.items=[],this.forEachItem(function(t){o.items.push(t),t.conf.index=l++})}if(this==this._getMainInst()&&null!=i&&(null!=i.autosize&&this.setAutoSize.apply(this,i.autosize),null!=i.cells))for(var d=0;d<i.cells.length;d++){var c=i.cells[d],h=this.cells(c.id);c.width&&h.setWidth(c.width),c.height&&h.setHeight(c.height),c.text&&h.setText(c.text),c.collapsed_text&&h.setCollapsedText(c.collapsed_text),c.collapse&&h.collapse(),c.fix_size&&h.fixSize(c.fix_size[0],c.fix_size[1]),void 0!==c.header&&0==window.dhx4.s2b(c.header)&&h.hideHeader()}return i=null,this}function dhtmlXLayoutSepObject(t,e){var n=this;return this.conf={mode:t,idx:e,blocked:!1,locked:!1,btn_left:(window.dhx4.isIE6||window.dhx4.isIE7||window.dhx4.isIE8)&&void 0===window.addEventListener?1:0},window.dhx4.isIE&&navigator.userAgent.indexOf("MSIE 7.0")>=0&&navigator.userAgent.indexOf("Trident")>=0&&(this.conf.btn_left=1),this.sep=document.createElement("DIV"),this.sep.className="dhxlayout_sep",1==window.dhx4.isIE&&(this.sep.onselectstart=function(){return!1}),this.sep.className="dhxlayout_sep dhxlayout_sep_resize_"+this.conf.mode,this._setSize=function(t,e,n,i){this.sep.style.left=t+"px",this.sep.style.top=e+"px",this.sep.style.width=Math.max(n,0)+"px",this.sep.style.height=Math.max(i,0)+"px"},this._lockSep=function(t){this.conf.locked=1==t,this._blockSep()},this._setWH=function(t){var e=this._getLayout();e.conf.sw=null==t?e._detectSW():Math.max(parseInt(t)||-1,-1),e._getMainInst().setSizes(),e=null},this._blockSep=function(){var t=this._getLayout(),e=t.cdata.a.conf.collapsed||t.cdata.b.conf.collapsed||this.conf.locked;t=null,this.conf.blocked!=e&&(this.sep.className="dhxlayout_sep"+(e?"":" dhxlayout_sep_resize_"+this.conf.mode),this.conf.blocked=e)},this._beforeResize=function(t){if(!this.conf.blocked&&(null==this.conf.resize||1!=this.conf.resize.active)){if(t.type==window.dhx4.dnd.evs.start){this.sep.className+=" dhxlayout_sep_resize_actv";var e=t.pageX||t.touches[0].pageX,n=t.pageY||t.touches[0].pageY}else{if(t.button!==this.conf.btn_left)return;e=t.clientX,n=t.clientY}1==window.dhx4.dnd.p_en&&window.dhx4.dnd._touchOff();var i=this._getLayout();this.conf.resize={sx:e,sy:n,tx:t.layerX,ty:t.layerY,sep_x:parseInt(this.sep.style.left),sep_y:parseInt(this.sep.style.top),min_wa:i.cdata.a._getAvailWidth("a"),min_wb:i.cdata.b._getAvailWidth("b"),min_ha:i.cdata.a._getAvailHeight("a"),min_hb:i.cdata.b._getAvailHeight("b")},this.conf.resize.nx=this.conf.resize.sep_x,this.conf.resize.ny=this.conf.resize.sep_y,"function"==typeof window.addEventListener?(window.addEventListener("mousemove",this._doOnMouseMove,!1),window.addEventListener("mouseup",this._doOnMouseUp,!1),window.addEventListener(window.dhx4.dnd.evs.move,this._doOnMouseMove,!1),window.addEventListener(window.dhx4.dnd.evs.end,this._doOnMouseUp,!1)):(document.body.attachEvent("onmousemove",this._doOnMouseMove),document.body.attachEvent("onmouseup",this._doOnMouseUp)),i=null}},this._onResize=function(t){if(this.conf.resize.active||(this._initResizeArea(),this.conf.resize.active=!0),"v"==this.conf.mode){var e="mousemove"==t.type?t.clientX:t.pageX||t.touches[0].pageX,n=this.conf.resize.sx-e;this.conf.resize.nx=this.conf.resize.sep_x-n,this.conf.resize.nx>this.conf.resize.sep_x+this.conf.resize.min_wb?this.conf.resize.nx=this.conf.resize.sep_x+this.conf.resize.min_wb:this.conf.resize.nx<this.conf.resize.sep_x-this.conf.resize.min_wa&&(this.conf.resize.nx=this.conf.resize.sep_x-this.conf.resize.min_wa),this.r_sep.style.left=this.conf.resize.nx+"px"}else{var i="mousemove"==t.type?t.clientY:t.pageY||t.touches[0].pageY;n=this.conf.resize.sy-i;this.conf.resize.ny=this.conf.resize.sep_y-n,this.conf.resize.ny>this.conf.resize.sep_y+this.conf.resize.min_hb?this.conf.resize.ny=this.conf.resize.sep_y+this.conf.resize.min_hb:this.conf.resize.ny<this.conf.resize.sep_y-this.conf.resize.min_ha&&(this.conf.resize.ny=this.conf.resize.sep_y-this.conf.resize.min_ha),this.r_sep.style.top=this.conf.resize.ny+"px"}},this._afterResize=function(t){if("function"==typeof window.addEventListener?(window.removeEventListener("mousemove",this._doOnMouseMove,!1),window.removeEventListener("mouseup",this._doOnMouseUp,!1),window.removeEventListener(window.dhx4.dnd.evs.move,this._doOnMouseMove,!1),window.removeEventListener(window.dhx4.dnd.evs.end,this._doOnMouseUp,!1)):(document.body.detachEvent("onmousemove",this._doOnMouseMove),document.body.detachEvent("onmouseup",this._doOnMouseUp)),this.conf.resize.active){if(t.type==window.dhx4.dnd.evs.end)this.sep.className=this.sep.className.replace(/\s{0,}dhxlayout_sep_resize_actv/gi,"");else if(t.button!==this.conf.btn_left)return;var e=this._getLayout(),n=e._getMainInst(),i=1==n.checkEvent("onPanelResizeFinish")&&{};!1!==i&&n.forEachItem(function(t){i[t.conf.name]={w:t.conf.size.w,h:t.conf.size.h},t=null});var a=this.conf.resize.nx-this.conf.resize.sep_x,o=this.conf.resize.ny-this.conf.resize.sep_y;if(e.cdata.a._setSize(e.cdata.a.conf.size.x,e.cdata.a.conf.size.y,e.cdata.a.conf.size.w+a,e.cdata.a.conf.size.h+o,"a"),e.cdata.b._setSize(e.cdata.b.conf.size.x+a,e.cdata.b.conf.size.y+o,e.cdata.b.conf.size.w-a,e.cdata.b.conf.size.h-o,"b"),this._setSize(parseInt(this.r_sep.style.left),parseInt(this.r_sep.style.top),parseInt(this.r_sep.style.width),parseInt(this.r_sep.style.height)),window.dhx4.isIE){var r=this;window.setTimeout(function(){r._removeResizeArea(),r=null},1)}else this._removeResizeArea();if(!1!==i){var s=[];n.forEachItem(function(t){var e=i[t.conf.name];e.w==t.conf.size.w&&e.h==t.conf.size.h||s.push(t.conf.name),t=null}),n._callMainEvent("onPanelResizeFinish",[s])}n=e=null,this.conf.resize.active=!1,this.conf.resize=null,1==window.dhx4.dnd.p_en&&window.dhx4.dnd._touchOn()}else this.conf.resize=null},this._initResizeArea=function(){if(null==this.r_sep&&(this.r_sep=document.createElement("DIV"),this.r_sep.className="dhxlayout_resize_sep",this.r_sep.style.left=this.sep.style.left,this.r_sep.style.top=this.sep.style.top,this.r_sep.style.width=this.sep.style.width,this.r_sep.style.height=this.sep.style.height,this.sep.parentNode.appendChild(this.r_sep),window.dhx4.isIE&&(this.r_sep.onselectstart=function(){return!1})),null==this.r_area){if(this.r_area=document.createElement("DIV"),this.r_area.className="dhxlayout_resize_area",this.sep.parentNode.appendChild(this.r_area),window.dhx4.isIE&&(this.r_area.onselectstart=function(){return!1}),"v"==this.conf.mode)var t=parseInt(this.r_sep.style.left)-this.conf.resize.min_wa,e=parseInt(this.r_sep.style.top),n=this.conf.resize.min_wa+this.conf.resize.min_wb+parseInt(this.r_sep.style.width),i=parseInt(this.r_sep.style.height);else t=parseInt(this.r_sep.style.left),e=parseInt(this.r_sep.style.top)-this.conf.resize.min_ha,n=parseInt(this.r_sep.style.width),i=this.conf.resize.min_ha+this.conf.resize.min_hb+parseInt(this.r_sep.style.height);this.r_area.style.left=t+"px",this.r_area.style.top=e+"px",dhtmlXLayoutObject.prototype._confGlob.reszieCover||(dhtmlXLayoutObject.prototype._confGlob.reszieCover={},this.r_area.style.width=n+"px",this.r_area.style.height=i+"px",dhtmlXLayoutObject.prototype._confGlob.reszieCover.w=parseInt(this.r_area.style.width)-this.r_area.offsetWidth,dhtmlXLayoutObject.prototype._confGlob.reszieCover.h=parseInt(this.r_area.style.height)-this.r_area.offsetHeight),this.r_area.style.width=n+dhtmlXLayoutObject.prototype._confGlob.reszieCover.w+"px",this.r_area.style.height=i+dhtmlXLayoutObject.prototype._confGlob.reszieCover.h+"px"}document.body.className+=" dhxlayout_resize_"+this.conf.mode},this._removeResizeArea=function(){this.r_sep.onselectstart=null,this.r_sep.parentNode.removeChild(this.r_sep),this.r_sep=null,this.r_area.onselectstart=null,this.r_area.parentNode.removeChild(this.r_area),this.r_area=null,document.body.className=String(document.body.className).replace(/\s{0,}dhxlayout_resize_[vh]/gi,"")},this._doOnMouseDown=function(t){(t=t||event).preventDefault?t.preventDefault():t.cancelBubble=!0,n._beforeResize(t)},this._doOnBodyMouseDown=function(t){if(t=t||event,null!=n.conf.resize)return 1==n.conf.resize.active&&t.button!==n.conf.btn_left?(t.preventDefault&&t.preventDefault(),t.returnValue=!1,t.cancelBubble=!0,!1):void 0},this._doOnMouseMove=function(t){(t=t||event).preventDefault?t.preventDefault():t.cancelBubble=!0,n._onResize(t)},this._doOnMouseUp=function(t){"mouseup"==(t=t||event).type&&t.button!==n.conf.btn_left||n._afterResize(t)},"function"==typeof window.addEventListener?(this.sep.addEventListener("mousedown",this._doOnMouseDown,!1),this.sep.addEventListener(window.dhx4.dnd.evs.start,this._doOnMouseDown,!1),document.body.addEventListener("mousedown",this._doOnBodyMouseDown,!1),document.body.addEventListener("contextmenu",this._doOnBodyMouseDown,!1)):(this.sep.attachEvent("onmousedown",this._doOnMouseDown),document.body.attachEvent("onmousedown",this._doOnBodyMouseDown),document.body.attachEvent("oncontextmenu",this._doOnBodyMouseDown)),this._unload=function(){for(var t in"function"==typeof window.addEventListener?(this.sep.removeEventListener("mousedown",this._doOnMouseDown,!1),this.sep.removeEventListener(window.dhx4.dnd.evs.start,this._doOnMouseDown,!1),document.body.removeEventListener("mousedown",this._doOnBodyMouseDown,!1),document.body.removeEventListener("contextmenu",this._doOnBodyMouseDown,!1)):(this.sep.detachEvent("onmousedown",this._doOnMouseDown),document.body.detachEvent("onmousedown",this._doOnBodyMouseDown),document.body.detachEvent("oncontextmenu",this._doOnBodyMouseDown)),1==window.dhx4.isIE&&(this.sep.onselectstart=null),this.sep.parentNode.removeChild(this.sep),this.sep=null,this)this[t]=null;n=null},this}function dhtmlXTabBar(t,e){var n=this;this.conf={skin:window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxtabbar")||"material",css:"dhxtabbar",lastActive:null,closeButton:!1,align:"left",tabsMode:"bottom"==e?"bottom":"top",tabsContCss:"",contZone:!0,transSpeed:"0.15s",arwMode:"always",tabsOfs:1,tabsTop:0,url_demand:!1,urls:{},autoload:{},tabsWidth:{dhx_terrace:[44,14],dhx_web:[35,9],dhx_skyblue:[35,9],material:[44,14]}},"material"==this.conf.skin&&(this.conf.arwMode="auto");var i,a=navigator.userAgent;a.indexOf("Safari")>=0&&(a.indexOf("5.1.7")>=0||null!=a.match(/7[\.\d]* mobile/gi)&&null!=a.match(/AppleWebKit/gi))&&(this.conf.tabsContCss=" safari_517_fix"),null!=t&&"object"==typeof t&&void 0===t.tagName?(i=t.parent,void 0!==t.skin&&(this.conf.skin=t.skin),void 0!==t.mode&&(this.conf.tabsMode="bottom"==t.mode?"bottom":"top"),void 0!==t.align&&(this.conf.align="right"==t.align?"right":"left"),void 0!==t.close_button&&(this.conf.closeButton=window.dhx4.s2b(t.close_button)),void 0!==t.content_zone&&(this.conf.contZone=window.dhx4.s2b(t.content_zone)),void 0!==t.xml&&(this.conf.autoload.xml=t.xml),void 0!==t.json&&(this.conf.autoload.xml=t.json),void 0!==t.tabs&&(this.conf.autoload.tabs=t.tabs),void 0!==t.onload&&(this.conf.autoload.onload=t.onload),void 0!==t.arrows_mode&&(this.conf.autoload.arrows_mode=t.arrows_mode)):i=t,window.dhtmlXCellTop.apply(this,[i,t.offsets]),null!=this.base._ofs&&null!=this.base._ofs.t&&(this.conf.tabsTop=this.base._ofs.t),this.tabsMode=document.createElement("DIV"),this.tabsMode.className="dhxtabbar_tabs_"+this.conf.tabsMode,this.cont.appendChild(this.tabsMode),this.tabsArea=document.createElement("DIV"),this.tabsArea.className="dhxtabbar_tabs dhxtabbar_tabs_"+this.conf.tabsMode,this.tabsArea.innerHTML="<div class='dhxtabbar_tabs_ar_left'><div class='dhxtabbar_arrow_img'></div></div><div class='dhxtabbar_tabs_base'><div class='dhxtabbar_tabs_cont_"+this.conf.align+this.conf.tabsContCss+"'><div class='dhxtabbar_tabs_line'></div></div></div><div class='dhxtabbar_tabs_ar_right'><div class='dhxtabbar_arrow_img'></div></div>",this.tabsArea.style.top="top"==this.conf.tabsMode?this.conf.tabsTop+"px":"auto",this.tabsMode.appendChild(this.tabsArea),this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align]="0px",this.tabsArea.childNodes[0].onclick=function(){"left"==n.conf.align?n._moveTabs(1):n._moveTabs(-1)},this.tabsArea.childNodes[2].onclick=function(){"left"==n.conf.align?n._moveTabs(-1):n._moveTabs(1)},this._onTabsAreaClick=function(t){return this._callMainEvent("onTabClose",[t])},this.tabsArea.onclick=function(t){for(var e=(t=t||event).target||t.srcElement;null!=e;){if(void 0!==e._tabCloseId){if(!0!==n._onTabsAreaClick(e._tabCloseId))return;n.t[e._tabCloseId].conf.remove=!0,n._hideTab(e._tabCloseId),e=null}else void 0!==e._tabId&&(n._doOnClick(e._tabId),e=null);null!=e&&(e=e.parentNode)==this&&(e=null)}},this.tabsArea.onselectstart=function(t){(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1},this._doOnClick=function(t){this.callEvent("onTabClick",[t,this.conf.lastActive]),this.t[t].conf.enabled&&this._setTabActive(t)},this.t={},this.addTab=function(t,e,n,i,a,o){o=void 0===o?1==this.conf.closeButton:window.dhx4.s2b(o),a=window.dhx4.s2b(a);var r=document.createElement("DIV");r.className="dhxtabbar_tab",r.innerHTML="<div class='dhxtabbar_tab_text"+(o?" dhxtabbar_tab_text_close":"")+"'>"+e+"</div>"+(o?"<div class='dhxtabbar_tab_close'></div>":""),r._tabId=t,o&&(r.childNodes[1]._tabCloseId=t);var s=this.tabsArea.childNodes[1].firstChild;null!=i&&i+1>0&&i+1<s.childNodes.length?s.insertBefore(r,s.childNodes[i+1]):s.appendChild(r);var l=!1;void 0===n||null==n||"*"==n?(n=this._getLabelWidth(e,o),l=!0):n=parseInt(n),r.style.width=n+"px";var d=new dhtmlXTabBarCell(t,this);this.tabsMode.appendChild(d.cell),this.t[t]={tab:r,cell:d,conf:{text:e,visible:!0,active:!1,enabled:!0,close:o,width:n,autowidth:l}},s=d=null,a?this._setTabActive(t):this._adjustCell(t),1!=this.conf.initSeq&&"auto"==this.conf.arwMode&&this.setSizes()},this.setSizes=function(){this._adjustCont(),null==this.conf.tabsAreaOfs&&(this.tabsArea.style.width=this.cont.offsetWidth+"px",this.conf.tabsAreaOfs=parseInt(this.tabsArea.style.width)-this.tabsArea.offsetWidth),this.tabsArea.style.width=this.cont.offsetWidth+this.conf.tabsAreaOfs+"px",this._adjustCell(this.conf.lastActive),this._adjustTabs(!0),this.callEvent("_onSetSizes",[])},this._adjustCell=function(t){if(this.conf.contZone&&null!=t){var e=("top"==this.conf.tabsMode?this.tabsArea.offsetHeight:0)+this.conf.tabsTop,n=this.cont.offsetHeight-this.tabsArea.offsetHeight-this.conf.tabsTop,i=this.t[t].cell.dataType;"dhx_skyblue"!=this.conf.skin||"layout"!=i&&"tabbar"!=i&&"acc"!=i||("top"==this.conf.tabsMode&&(e-=1),n+=1),t!=this.conf.lastActive&&(e=-5e3,this.t[t].cell.cell.style.visibility="hidden",this.t[t].cell.cell.style.zIndex=0),this.t[t].cell._setSize(0,e,this.cont.offsetWidth,n)}},this.setTabsMode=function(t){this.conf.tabsMode="bottom"==t?"bottom":"top",this.tabsMode.className="dhxtabbar_tabs_"+this.conf.tabsMode,this.tabsArea.className="dhxtabbar_tabs dhxtabbar_tabs_"+this.conf.tabsMode,this.tabsArea.style.top="top"==this.conf.tabsMode?this.conf.tabsTop+"px":"auto",this.setSizes()},this._tabCss=function(t,e){var n=this.t[t].conf.active,i=!this.t[t].conf.enabled;return"dhxtabbar_tab"+(!this.t[t].conf.visible?" dhxtabbar_tab_hidden":n||i?" dhxtabbar_tab"+(n?"_actv":"")+(i?"_dis":""):"")},this._getLabelWidth=function(t,e){null==this.tabsTextTest&&(this.tabsTextTest=document.createElement("SPAN"),this.tabsTextTest.className="dhxtabbar_tabs_text_test_"+this.conf.skin),document.body.appendChild(this.tabsTextTest),this.tabsTextTest.innerHTML=t;var n=this.tabsTextTest.offsetWidth;return window.dhx4.isIE&&0==n&&(n=this.tabsTextTest.offsetWidth),n+=this.conf.tabsWidth[this.conf.skin][0],1==e&&(n+=this.conf.tabsWidth[this.conf.skin][1]),document.body.removeChild(this.tabsTextTest),n},this._adjustTabs=function(t){1!=this._checkArrows()&&1!=t||(this.tabsArea.childNodes[1].style.left=this.tabsArea.childNodes[0].offsetWidth-1+"px",this.tabsArea.childNodes[1].style.width=Math.max(0,this.tabsArea.clientWidth-this.tabsArea.childNodes[0].offsetWidth-this.tabsArea.childNodes[2].offsetWidth)+2*this.conf.tabsOfs+"px");var e=this.tabsArea.childNodes[1];if(e.offsetWidth<5)e=null;else{for(var n=parseInt(e.childNodes[0].style[this.conf.align]),i=null,a=0;a<e.childNodes[0].childNodes.length;a++){var o=e.childNodes[0].childNodes[a]._tabId;if(null!=o&&this.t[o].conf.visible){var r=this.t[o].tab.offsetWidth-this.conf.tabsOfs;this.t[o].conf.active&&(n<0||e.offsetWidth<r?i={d:1,id:o}:n+r>e.offsetWidth&&(i={d:-1,id:o})),n+=r}}null!=i?this._moveTabs(i.d,i.id):e.offsetWidth>n+1&&(e.childNodes[0].style[this.conf.align]=Math.min(0,parseInt(e.childNodes[0].style[this.conf.align])+(e.offsetWidth-n))+"px"),e=i=null}},this._moveTabs=function(t,e){for(var n=this.tabsArea.childNodes[1].childNodes[0],i=0,a=[],o=null,r=0;r<n.childNodes.length;r++){var s=n.childNodes[r]._tabId;null!=s&&this.t[s].conf.visible&&(a.push({id:s,w:this.t[s].tab.offsetWidth-this.conf.tabsOfs,ind:i}),s==e&&(o=i),i++)}var l=parseInt(this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align]),d=this.tabsArea.clientWidth-this.tabsArea.childNodes[0].offsetWidth-this.tabsArea.childNodes[2].offsetWidth+this.conf.tabsOfs,c=null,h=null;for(r=0;r<a.length;r++)a[r].x=l,null==c&&l>=0&&l+a[r].w>0&&(c=a[r]),l<d&&l+a[r].w<=d&&(h=a[r]),l+=a[r].w;if(null!=o)var u=a[o];else{u=null;t>0?null==c?a.length>0&&(u=a[a.length-1]):c.ind>0&&a.length>=c.ind&&(u=a[c.ind-1]):null==h?a.length>0&&(u=a[0]):a.length>h.ind&&(u=a[h.ind+1])}null!=u&&(n.style[this.conf.align]=t>0?l<d?Math.min(0,parseInt(n.style[this.conf.align])+(d-l))+"px":parseInt(n.style[this.conf.align])-u.x+"px":parseInt(n.style[this.conf.align])-u.x+d-u.w+"px"),n=u=a=null},this._getNextVisible=function(t,e){return this._getNearVisible(t,e,"next")},this._getPrevVisible=function(t,e){return this._getNearVisible(t,e,"previous")},this._getFirstVisible=function(){return this._getNearVisible(null,!1,"first")},this._getNearVisible=function(t,e,n){if("first"==n){var i=this.tabsArea.childNodes[1].childNodes[0].childNodes[1];n="next"}else{if(null==t||null==this.t[t])return e?this._getFirstVisible():null;i=this.t[t].tab[n+"Sibling"]}for(var a=null;null!=i&&null==a;){var o=i._tabId;null!=o&&null==a&&this.t[o].conf.visible?a=o:i=i[n+"Sibling"]}return i=null,a},this._showTab=function(t,e){if(null!=this.t[t]){if(1==this.t[t].conf.transActv){if("show"==this.t[t].conf.transMode)return}else if(1==this.t[t].conf.visible)return;!1!==this.conf.transProp?(this.t[t].conf.transActv=!0,this.t[t].conf.transMode="show",this.t[t].conf.transProp=this.conf.transProp,this.t[t].conf.transActvId=e?t:null,this.t[t].conf.transEv||(this.t[t].tab.addEventListener(this.conf.transEv,this._doOnTrEnd,!1),this.t[t].conf.transEv=!0),this.t[t].conf.visible=!0,this.t[t].tab.className=this._tabCss(t),this.t[t].tab.style[this.conf.transProp]=this.conf.transValueWidth,this.t[t].tab.style.width=this.t[t].conf.width+"px",this.t[t].tab.clientWidth>=this.t[t].conf.width&&(this.t[t].tab.style.visibility="visible")):(this.t[t].conf.visible=!0,this.t[t].tab.style.display="",e||this.t[t].conf.active?(this.t[t].conf.active=!1,this._setTabActive(t)):this._adjustTabs())}},this._hideTab=function(t,e){if(null!=this.t[t]){if(1==this.t[t].conf.transActv){if("hide"==this.t[t].conf.transMode)return}else if(1!=this.t[t].conf.visible)return;var i=!1;this.conf.lastActive==t&&(this.conf.lastActive=null,this.t[t].conf.active=!1,this.t[t].tab.className=this._tabCss(t),i=!0);var a=this._getPrevVisible(t),o=this._getNextVisible(t),r=1==i&&!1!==e?(1==e?null:e)||o||a:null;!1!==this.conf.transProp?(this.t[t].conf.transActv=!0,this.t[t].conf.transMode="hide",this.t[t].conf.transProp=this.conf.transProp,this.t[t].conf.transActvId=r,this.t[t].conf.visible=!1,this.t[t].conf.transEv||(this.t[t].tab.addEventListener(this.conf.transEv,this._doOnTrEnd,!1),this.t[t].conf.transEv=!0),this.t[t].tab.style.visibility="hidden",this.t[t].tab.className=n._tabCss(t),this.t[t].tab.style[this.conf.transProp]=this.conf.transValueWidth,this.t[t].tab.style.width="0px"):(this.t[t].tab.style.display="none",this.t[t].conf.visible=!1,this.conf.contZone&&(this.t[t].cell.cell.style.visibility="hidden",this.t[t].cell.cell.style.top="-5000px"),null!=r&&this._setTabActive(r),this._adjustTabs(),this.t[t].conf.remove&&this._removeTab(t))}},this._isTabVisible=function(t){return 1==this.t[t].conf.visible},this._doOnTrEnd=function(){var t=this._tabId;if(null!=n.t[t]){var e=n.t[t],i=e.conf.transActvId;"hide"==e.conf.transMode?e.conf.remove?n._removeTab(t):(e.tab.style[e.conf.transProp]="",n.conf.contZone&&(e.cell.cell.style.visibility="hidden",e.cell.cell.style.top="-5000px"),e.conf.transActv=!1):"show"==e.conf.transMode&&(e.tab.style[e.conf.transProp]="",e.tab.style.visibility="visible",e.conf.transMode=null,e.conf.transActv=!1),null!=i?n._setTabActive(i):n._adjustTabs(),e=null}},this.enableTabCloseButton=function(t){this.conf.closeButton=window.dhx4.s2b(t)},this.unload=function(){for(var t in this.conf.unloading=!0,this.clearAll(),this.t=null,null!=this.tabsTextTest&&(this.tabsTextTest.parentNode&&this.tabsTextTest.parentNode.removeChild(this.tabsTextTest),this.tabsTextTest=null),window.dhx4._enableDataLoading(this,null,null,null,"clear"),this.tabsArea.childNodes[0].onclick=null,this.tabsArea.childNodes[2].onclick=null,this.tabsArea.onclick=null,this.tabsArea.onselectstart=null,this.tabsArea.parentNode.removeChild(this.tabsArea),this.tabsArea=null,this.tabsMode.parentNode.removeChild(this.tabsMode),this.tabsMode=null,this._unloadTop(),window.dhx4._eventable(this,"clear"),this)this[t]=null;n=null},this.enableContentZone=function(t){this.conf.contZone=1==t},this.setSkin=function(t){for(var e in this._setBaseSkin(t),this.conf.skin=t,null!=this.tabsTextTest&&(this.tabsTextTest.className="dhxtabbar_tabs_text_test_"+this.conf.skin),this.t)this.t[e].cell._resetSizeState(),1==this.t[e].conf.autowidth&&(this.t[e].conf.width=this._getLabelWidth(this.t[e].conf.text,this.t[e].conf.close),this.t[e].conf.visible&&(this.t[e].tab.style.width=this.t[e].conf.width+"px"));this.conf.tabsAreaOfs=null,this._fixTabsOfs(),this.setSizes()},this.setAlign=function(t){(t="left"==t?"left":"right")!=this.conf.align?(!1!==this.conf.transProp&&(this.tabsArea.childNodes[1].childNodes[0].style[this.conf.transProp]=""),this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align]="",this.conf.align=t,this.tabsArea.childNodes[1].childNodes[0].className="dhxtabbar_tabs_cont_"+this.conf.align+this.conf.tabsContCss,this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align]="0px",!1!==this.conf.transProp&&(this.conf.transValuePos=this.conf.align+" "+this.conf.transSpeed,this.tabsArea.childNodes[1].childNodes[0].style[this.conf.transProp]=this.conf.transValuePos)):this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align]="0px"},this._initObj=function(t){this.conf.initSeq=!0,this.clearAll();var e=!1;if(null!=t.settings&&(null!=t.settings.skin&&this.setSkin(t.settings.skin),null!=t.settings.close_button?this.enableTabCloseButton(window.dhx4.s2b(t.settings.close_button)):null!=t.settings.closeButton&&this.enableTabCloseButton(window.dhx4.s2b(t.settings.closeButton)),null!=t.settings.align&&this.setAlign(t.settings.align),"ajax"==t.settings.hrefmode&&(e=!0),"ajax-html"==t.settings.hrefmode&&(e=!0,this.conf.url_demand=!0)),null!=t.tabs)for(var n=0;n<t.tabs.length;n++){var i=t.tabs[n];void 0===i.id&&(i.id=window.dhx4.newId()),isNaN(parseInt(i.width))?i.width=null:i.width=parseInt(i.width),this.addTab(i.id,i.text||i.label||"",i.width,i.index,window.dhx4.s2b(i.selected)||window.dhx4.s2b(i.active),i.close),null!=i.content?this.cells(i.id).attachHTMLString(i.content):null!=i.href&&(1==this.conf.url_demand?this.conf.urls[i.id]={href:i.href,ajax:e}:this.cells(i.id).attachURL(i.href,e)),void 0!==i.enabled&&0==window.dhx4.s2b(i.enabled)?this.tabs(i.id).disable():void 0!==i.disabled&&1==window.dhx4.s2b(i.disabled)&&this.tabs(i.id).disable()}this.conf.initSeq=!1,"auto"==this.conf.arwMode&&this.setSizes(),1==this.conf.url_demand&&this._loadURLOnDemand(this.conf.lastActive)},this._xmlToObj=function(t){var e={settings:{},tabs:[]},n=t.getElementsByTagName("tabbar")[0];if(null!=n){for(var i in{skin:1,align:1,closeButton:1,hrefmode:1})null!=n.getAttribute(i)&&(e.settings[i]=n.getAttribute(i));for(var a=n.getElementsByTagName("tab"),o=0;o<a.length;o++){var r={text:a[o].firstChild.nodeValue||""};for(var i in{id:1,width:1,close:1,selected:1,active:1,enabled:1,disabled:1,href:1})null!=a[o].getAttribute(i)&&(r[i]=a[o].getAttribute(i));var s=a[o].getElementsByTagName("content")[0];if(null!=s){r.content="";for(var l=0;l<s.childNodes.length;l++)r.content+=s.childNodes[l].nodeValue||""}e.tabs.push(r)}}return e},dhx4._enableDataLoading(this,"_initObj","_xmlToObj","tabbar",{struct:!0});var o=window.dhx4.transDetect();return this.conf.transProp=o.transProp,this.conf.transEv=o.transEv,this.conf.transValueWidth="width "+this.conf.transSpeed,o=null,!1!==this.conf.transProp&&(this.conf.transValuePos=this.conf.align+" "+this.conf.transSpeed,this.tabsArea.childNodes[1].childNodes[0].style[this.conf.transProp]=this.conf.transValuePos),this._callMainEvent=function(t,e){return this.callEvent(t,e)},window.dhx4._eventable(this),null!=this.conf.autoload.json?this.loadStruct(this.conf.autoload.json,this.conf.autoload.onload):null!=this.conf.autoload.xml?this.loadStruct(this.conf.autoload.xml,this.conf.autoload.onload):null!=this.conf.autoload.tabs&&this.loadStruct({tabs:this.conf.autoload.tabs},this.conf.autoload.onload),null!=this.conf.autoload.arrows_mode&&this.setArrowsMode(this.conf.autoload.arrows_mode),this._fixTabsOfs(),this.setSizes(),this}function dhtmlXTabBarInitFromHTML(){for(var z=document.getElementsByTagName("div"),i=0;i<z.length;i++)if(-1!=z[i].className.indexOf("dhtmlxTabBar")){var conf={settings:{},tabs:[]},n=z[i],id=n.id;n.className="";for(var k=new Array,j=0;j<n.childNodes.length;j++)n.childNodes[j].tagName&&"!"!=n.childNodes[j].tagName&&(k[k.length]=n.childNodes[j]);var skin=n.getAttribute("skin");null!=skin&&(conf.settings.skin=skin);var w=new dhtmlXTabBar({parent:id,mode:n.getAttribute("mode")});window[id]=w,acs=n.getAttribute("onbeforeinit"),acs&&eval(acs),align=n.getAttribute("align"),align&&(conf.settings.align=align);for(var cont={},j=0;j<k.length;j++){var m=k[j],tab={id:m.id,text:m.getAttribute("name"),width:m.getAttribute("width"),selected:m.getAttribute("selected"),active:m.getAttribute("active"),close:m.getAttribute("close")},href=m.getAttribute("href");cont[m.id]=href?{href:href}:{cont:m},conf.tabs.push(tab)}for(var a in w.loadStruct(conf),cont)cont[a].href?(w.cells(a).attachURL(cont[a].href),cont[a].href=null):(w.cells(a).attachObject(cont[a].cont),"none"==cont[a].cont.style.display&&(cont[a].cont.style.display=""),cont[a].cont=null),cont[a]=null;var selId=n.getAttribute("select");if(null!=selId)w.tabs(selId).setActive();else if(null==w.getActiveTab()){var v=w._getFirstVisible();null!=v&&w.cells(v).setActive()}acs=n.getAttribute("oninit"),acs&&eval(acs)}"function"==typeof window.addEventListener?window.removeEventListener("load",dhtmlXTabBarInitFromHTML,!1):window.detachEvent("onload",dhtmlXTabBarInitFromHTML)}function dhtmlXSideBar(t){var e=this;this.conf={skin:t.skin||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxsidebar")||"material",css:"dhxsidebar",width:t.width||200,scroll_size:12,scroll_mult:20,close_button:!1,icons_path:t.icons_path||"",selected:null,single_cell:void 0!==t.single_cell&&window.dhx4.s2b(t.single_cell),cell:null,header:window.dhx4.s2b(t.header),autohide:window.dhx4.s2b(t.autohide),animate_items:!0},this.setTemplate(t.template),window.dhtmlXCellTop.apply(this,[t.parent,null==t?null:t.offsets]),window.dhx4._eventable(this),this.conf.touch_ms=!1,this.conf.touch_start="touchstart",this.conf.touch_end="touchend",this.side=document.createElement("DIV"),this.side.className="dhxsidebar_side dhxsidebar_tpl_"+this.conf.tpl_name,this.side.innerHTML="<div class='dhxsidebar_side_items'></div>",this.cont.appendChild(this.side),this.arw=document.createElement("DIV"),this.arw.className="dhxsidebar_arrows dhxsidebar_arrows_hidden",this.arw.innerHTML="<div class='dhxsidebar_arrow dhxsidebar_arrow_left'><div class='dhxsidebar_arrow_image'></div></div><div class='dhxsidebar_arrow dhxsidebar_arrow_right'><div class='dhxsidebar_arrow_image'></div></div>",this.cont.appendChild(this.arw),1==this.conf.autohide&&(this.hideSide(),this.cont.className+=" dhxsidebar_autohide",this._doOnBodyClick=function(){1!=e.conf.clear_click?e.hideSide():e.conf.clear_click=!1},this._doOnEscDown=function(t){27==(t=t||event).keyCode&&(e.conf.clear_click=!1,e.hideSide())},"function"==typeof window.addEventListener?(window.addEventListener(this.conf.touch_start,this._doOnBodyClick,!1),window.addEventListener("click",this._doOnBodyClick,!1),window.addEventListener("keydown",this._doOnEscDown,!1)):(document.body.attachEvent("onclick",this._doOnBodyClick),document.body.attachEvent("onkeydown",this._doOnEscDown))),window.setTimeout(function(){null!=e&&null!=e.side&&(e.side.firstChild.style.top="0px")},1),this._doOnArwClick=function(t){"click"!=(t=t||event).type&&t.preventDefault&&t.preventDefault(),t.cancelBubble=!0;var n=t.target||t.srcElement;null!=n.className.match(/dhxsidebar_arrow_image/)&&(n=n.parentNode),null!=n.className.match(/dhxsidebar_arrow_left/)?e._scrollSide(-e.conf.scroll_size):null!=n.className.match(/dhxsidebar_arrow_right/)&&e._scrollSide(e.conf.scroll_size),n=null},"function"==typeof window.addEventListener?(this.arw.addEventListener(this.conf.touch_start,this._doOnArwClick,!1),this.arw.addEventListener("click",this._doOnArwClick,!1)):this.arw.attachEvent("onclick",this._doOnArwClick),this._doOnSideClick=function(t){var n=(t=t||event).target||t.srcElement,i=null,a=!1;for(e.conf.clear_click=!0,"touchstart"!=t.type&&"pointerdown"!=t.type&&"MSPointerDown"!=t.type||(t.preventDefault&&t.preventDefault(),null==this.className.match(/dhxsidebar_touch/gi)&&("touchstart"==t.type||"pointerdown"==t.type&&"touch"==t.pointerType)&&(this.className+=" dhxsidebar_touch"));null!=n&&null==i&&"pointerdown"!=t.type&&"MSPointerDown"!=t.type;)void 0!==n.className&&(null!=n.className.match(/^dhxsidebar_item/)&&void 0!==n._idd?i=n._idd:null!=n.className.match(/^dhxsidebar_bubble/)&&(a=!0,i=n.parentNode._idd)),n=n.parentNode;null!=i&&(0==a||1==a&&1==e.callEvent("onBubbleClick",[i,e.t[i].conf.bubble]))&&e._setItemActive(i,!0),n=null},"function"==typeof window.addEventListener?(this.side.addEventListener(this.conf.touch_start,this._doOnSideClick,!1),this.side.addEventListener(this.conf.touch_end,this._doOnSideClick,!1),this.side.addEventListener("mouseup",this._doOnSideClick,!1)):this.side.attachEvent("onclick",this._doOnSideClick),this.side.onmouseover=function(){this.className=this.className.replace(/\s*dhxsidebar_touch/gi,"")},this._doOnSideScroll=function(t){var n="mousewheel"==(t=t||event).type?-t.wheelDelta:t.deltaY;e._scrollSide(n/Math.abs(n)*3)},this._scrollSide=function(t){var e=parseInt(this.side.firstChild.style.top||0)-t*this.conf.scroll_mult;e+this.side.firstChild.offsetHeight<this.side.clientHeight&&(e=this.side.clientHeight-this.side.firstChild.offsetHeight),e>0&&(e=0),this.side.firstChild.style.top=e+"px"},"function"==typeof window.addEventListener?this.side.addEventListener("wheel",this._doOnSideScroll,!1):this.side.attachEvent("onmousewheel",this._doOnSideScroll),this.t={},this.s={},this._adjustCell=function(t,e){if(1==this.conf.single_cell||null!=t){var n=1==this.conf.autohide?0:this.conf.width,i=this.cont.offsetWidth-n,a=0,o=this.cont.offsetHeight;1==this.conf.single_cell?1==e&&this.conf.cell._setSize(n,a,i,o):(t!=this.conf.selected&&(a=-5e3,this.t[t].cell.cell.style.visibility="hidden",this.t[t].cell.cell.style.zIndex=0),this.t[t].cell._setSize(n,a,i,o))}};var n=window.dhx4.transDetect();return this.conf.transProp=n.transProp,this.conf.transEv=n.transEv,this.conf.transValue="all 0.1s",this._doOnTrEnd=function(t){var n=this._idd;if(null!=e.t[n]){var i=e.t[n],a=i.conf.transActvId;"hide"==i.conf.transMode?1==i.conf.remove?e._removeItem(n):(i.item.style[i.conf.transProp]="",1!=e.conf.single_cell&&(i.cell.cell.style.visibility="hidden",i.cell.cell.style.top="-5000px"),i.conf.transActv=!1):"show"==i.conf.transMode&&(i.item.style[i.conf.transProp]="",i.item.style.visibility="visible",i.conf.transMode=null,i.conf.transActv=!1),null!=a?e._setItemActive(a):e._checkHeight(),i=null}},this._initObj=function(t){this.clearAll(),null!=t.items&&this.addItem(t.items)},this._xmlToObj=function(t){var e=[],n=t.getElementsByTagName("sidebar");if(null!=n&&null!=n[0])for(var i=n[0].getElementsByTagName("item"),a=0;a<i.length;a++){for(var o={},r=0;r<i[a].attributes.length;r++)o[i[a].attributes[r].nodeName]=i[a].attributes[r].nodeValue;e.push(o)}return{items:e}},dhx4._enableDataLoading(this,"_initObj","_xmlToObj","sidebar",{struct:!0}),this.unload=function(){for(var t in this.conf.unloading=!0,"function"==typeof window.addEventListener?this.side.removeEventListener("wheel",this._doOnSideScroll,!1):this.side.detachEvent("onmousewheel",this._doOnSideScroll),1==this.conf.autohide&&("function"==typeof window.addEventListener?(window.removeEventListener("click",this._doOnBodyClick,!1),window.removeEventListener("keydown",this._doOnEscDown,!1)):(document.body.detachEvent("onclick",this._doOnBodyClick),document.body.detachEvent("onkeydown",this._doOnEscDown))),"function"==typeof this._sideCoverDetach&&this._sideCoverDetach(),this.clearAll(),this.s=this.t=null,"function"==typeof window.addEventListener?(this.arw.removeEventListener(this.conf.touch_start,this._doOnArwClick,!1),this.arw.removeEventListener("click",this._doOnArwClick,!1)):this.arw.detachEvent("onclick",this._doOnArwClick),this.arw.parentNode.removeChild(this.arw),this.arw=null,"function"==typeof window.addEventListener?(this.side.removeEventListener(this.conf.touch_start,this._doOnSideClick,!1),this.side.removeEventListener(this.conf.touch_end,this._doOnSideClick,!1),this.side.removeEventListener("click",this._doOnSideClick,!1)):this.side.detachEvent("onclick",this._doOnSideClick),this.side.onmouseover=null,this.side.parentNode.removeChild(this.side),this.side=null,this._unloadTop(),1==this.conf.single_cell&&(this.conf.cell._unload(),this.conf.cell=null),window.dhx4._eventable(this,"clear"),window.dhx4._enableDataLoading(this,null,null,null,"clear"),this)this[t]=null;e=null},1==this.conf.single_cell&&(this.conf.cell=new dhtmlXSideBarCell("master",this),this.cont.appendChild(this.conf.cell.cell),this._cells_native=this.cells,this.cells=function(t){return this.conf.cell._idd=t,this.conf.cell}),this.setSizes(),null!=t.items?this._initObj(t):null!=t.json?this.loadStruct(t.json,t.onload):null!=t.xml&&this.loadStruct(t.xml,t.onload),this}function dhtmlXCarousel(t,e,n){"string"==typeof t||"object"==typeof t&&void 0!==t.tagName?t={parent:"string"==typeof t?document.getElementById(t):t,effect:e,skin:n,delete_conf:!0}:void 0!==t&&null!=t||(t={}),this.conf={skin:t.skin||window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxcarousel")||"material",css:"dhxcarousel",items_count:0,selected:-1,item_width:Number(t.item_width)||"auto",item_height:Number(t.item_height)||"auto",ofs_item:Number(t.offset_item)||1,ofs_left:Number(t.offset_left)||0,ofs_top:Number(t.offset_top)||0,buttons:void 0===t.buttons||window.dhx4.s2b(t.buttons),drops:!1,keys:void 0===t.keys||window.dhx4.s2b(t.keys),key_data:{left:37,right:39},touch_scroll:void 0===t.touch_scroll||window.dhx4.s2b(t.touch_scroll),arw:["&#9668;","&#9658;"]},this.conf.autowidth="auto"==this.conf.item_width,this.conf.autoheight="auto"==this.conf.item_height;var i=window.dhx4.transDetect();if(this.conf.transProp=i.transProp,this.conf.transEv=i.transEv,this.conf.anim_type=t.effect||"slide",1==this.ef[this.conf.anim_type]){var a=this["_"+this.conf.anim_type+"_init"]();if(!1===a&&(this.conf.anim_type="slide",a=this["_"+this.conf.anim_type+"_init"]()),"object"==typeof a)for(var o in a)void 0===this.conf[o]&&(this.conf[o]=a[o])}this.conf.anim_f=this["_"+this.conf.anim_type+"_f"]();var r=this;if(window.dhtmlXCellTop.apply(this,[t.parent,t.offsets]),this.area=document.createElement("DIV"),this.area.className="dhxcarousel_area",this.cont.appendChild(this.area),"function"==typeof window.addEventListener&&1==r.conf.touch_scroll&&(this._doOnTouchStart=function(t){1!=window.dhx4.dnd._mTouch(t)&&1!=r.conf.animating&&(t.preventDefault&&t.preventDefault(),r.area.className+=" dhxcarousel_area_dnd",r.conf.touch_conf={t:(new Date).getTime(),dx:null,dy:null},null!=t.type.match(/^touch/)?(r.conf.touch_conf.id=t.touches[0].identifier,r.conf.touch_conf.x=t.touches[0].clientX,r.conf.touch_conf.y=t.touches[0].clientY):(r.area.style.touchAction=r.area.style.msTouchAction="none",r.conf.touch_conf.x=t.clientX,r.conf.touch_conf.y=t.clientY),window.addEventListener(window.dhx4.dnd.evs.move,r._doOnTouchMove,!1),window.addEventListener(window.dhx4.dnd.evs.end,r._doOnTouchEnd,!1))},this._doOnTouchMove=function(t){},this._doOnTouchEnd=function(t){if(null!=t.type.match(/^touch/))for(var e=0,n=0;n<t.changedTouches.length;n++)t.changedTouches[n].identifier==r.conf.touch_conf.id&&(e=r.conf.touch_conf.x-t.changedTouches[n].clientX);else e=r.conf.touch_conf.x-t.clientX;if(window.removeEventListener(window.dhx4.dnd.evs.move,r._doOnTouchMove,!1),window.removeEventListener(window.dhx4.dnd.evs.end,r._doOnTouchEnd,!1),r.area.className=r.area.className.replace(/\s*dhxcarousel_area_dnd$/,""),!(0==e||(new Date).getTime()-r.conf.touch_conf.t>400)){var i=e/Math.abs(e);r._animateStart(i)}},this.area.addEventListener(window.dhx4.dnd.evs.start,this._doOnTouchStart,!1)),this.cdata={},this.ind={},this.addCell=function(t,e){for(var n in this.conf.items_count++,-1==this.conf.selected&&(this.conf.selected=0),this.setSizes(),this._checkControls(),void 0===e||null==e?e=this.conf.items_count-1:e<0?e=0:e>this.conf.items_count-1&&(e=this.conf.items_count-1),this.cdata)this.cdata[n].index>=e&&(this.cdata[n].index++,this.ind[this.cdata[n].index]=n,this._adjustCell(n));for(null==t&&(t=String(window.dhx4.newId()));null!=this.cdata[t];)t=String(window.dhx4.newId());var i=new dhtmlXCarouselCell(t,this);return null!=this.area.childNodes[e]?this.area.insertBefore(i.cell,this.area.childNodes[e]):this.area.appendChild(i.cell),this.cdata[t]={index:e,cell:i},this.ind[e]=t,this._adjustCell(t),this._addBar(),this._setBarIndex(this.conf.selected),i=null,this[this.conf.anim_f.cell_added](t),t},this._removeCell=function(t){var e=this.cdata[t].index;if(this.cdata[t].cell._unload(),this.cdata[t].index=this.cdata[t].cell=null,this.cdata[t]=null,delete this.cdata[t],delete this.ind[e],this.conf.items_count--,1!=this.conf.unloading){this.ind={};for(var n in this.cdata)this.cdata[n].index>e&&this.cdata[n].index--,this.ind[this.cdata[n].index]=n;var i=!1;this.conf.selected>e?this.conf.selected--:this.conf.selected==e&&(this.conf.selected=Math.min(this.conf.selected,this.conf.items_count-1),i=!0),this._removeBar(!1),this._setBarIndex(this.conf.selected),1==i&&this.conf.selected>=0&&this[this.conf.anim_f.update_selected](this.ind[this.conf.selected]),this.setSizes(),this._checkControls()}},this.setSizes=function(){this._adjustCont();var t={};for(var e in this.area.style.height=this.cont.offsetHeight-this.controls.offsetHeight+"px",this.conf.width=this.conf.autowidth?this.cont.offsetWidth-2*this.conf.ofs_left:this.conf.item_width,this.conf.height=this.conf.autoheight?this.area.offsetHeight-2*this.conf.ofs_top:this.conf.item_height,this.conf.top=Math.max(0,this.conf.autoheight?this.conf.ofs_top:Math.floor((this.area.offsetHeight-this.conf.height)/2)),this.area.style.width=this[this.conf.anim_f.detect_aw]()*(this.conf.width+this.conf.ofs_item)+this.conf.ofs_item+"px",this.area.style.left=Math.round(this.cont.offsetWidth/2-this.conf.width/2-this.conf.ofs_item)+"px",this.cdata){var n={};for(var i in this.cdata[e].cell.conf.size)n[i]=this.cdata[e].cell.conf.size[i];1==this.conf.autowidth&&(n.w=this.conf.width,n.x=this[this.conf.anim_f.detect_x](e)),1==this.conf.autoheight&&(n.h=this.conf.height),t[e]=n}if(this.area.style.left=Math.round(this.cont.offsetWidth/2-this.conf.width/2-this.conf.ofs_item)-(this.conf.width+this.conf.ofs_item)*this.conf.selected+"px",this._adjustControls(),1!=this.conf.autoheight)for(var e in this.conf.top=Math.max(0,Math.floor(this.area.offsetHeight-this.conf.height)/2),t)t[e].y=this.conf.top;for(var e in t)this.cdata[e].cell._setSize(t[e].x,t[e].y,t[e].w,t[e].h);this.callEvent("_onSetSizes",[])},this._adjustCell=function(t){this.cdata[t].cell._setSize(this[this.conf.anim_f.detect_x](t),this.conf.top,this.conf.width,this.conf.height)},this._animateStart=function(t,e){this.conf.selected<=0&&t<0||this.conf.selected>=this.conf.items_count-1&&t>0||1!=this.conf.animating&&(this.conf.animating=!0,this[this.conf.anim_f.prepare](t,e))},this._animateTransEnd=function(t){r[r.conf.anim_f.end](t||event,this)},this._animateEnd=function(t){this.conf.selected=this.conf.selected+t,this._checkControls(),this._setBarIndex(this.conf.selected),this.callEvent("onSelect",[this.ind[this.conf.selected]]),this.conf.animating=!1},this._initControls(),this.setCellSize=function(t,e){this.conf.item_width=null==t?"auto":t,this.conf.item_height=null==e?"auto":e,this.setSizes()},this.setOffset=function(t,e,n){null!=t&&(this.conf.ofs_left=t),null!=e&&(this.conf.ofs_top=e),null!=n&&(this.conf.ofs_item=n),this.setSizes()},this.enableHotKeys=function(t){this.conf.keys=window.dhx4.s2b(t)},this.goFirst=function(){0!=this.conf.selected&&this._animateStart(-this.conf.selected)},this.goLast=function(){this.conf.selected!=this.conf.items_count-1&&this._animateStart(this.conf.items_count-1-this.conf.selected)},this.goNext=function(){this._animateStart(1)},this.goPrev=function(){this._animateStart(-1)},this.getActiveIndex=function(){return this.conf.selected},this.getActiveId=function(){return this.ind[this.conf.selected]},this.getActiveCell=function(){var t=this.getActiveId();return null!=t?this.cdata[t].cell:null},this.unload=function(){for(var t in this.conf.unloading=!0,"function"==typeof window.addEventListener?(window.removeEventListener("keydown",this._doOnWinKeyDown,!1),null!=this._doOnTouchStart&&this.area.removeEventListener(window.dhx4.dnd.evs.start,this._doOnTouchStart,!1)):document.body.detachEvent("onkeydown",this._doOnWinKeyDown),this.cdata)this._removeCell(t);for(var t in this.cdata[t]=null,this.area.parentNode.removeChild(this.area),this.area=null,this._unloadControls(),this._unloadTop(),window.dhx4._eventable(this,"clear"),this)this[t]=null;r=null},window.dhx4._eventable(this),this._callMainEvent=function(t,e){this.callEvent(t,e)},this.conf.ev_coverclick=this.attachEvent("_cellCoverClick",function(t){var e=t-this.conf.selected;1==Math.abs(e)&&this._animateStart(e)}),this._doOnWinKeyDown=function(t){if(t=t||event,1==r.conf.keys&&1==t.ctrlKey&&1!=t.shiftKey&&1!=t.altKey){var e=t.keyCode,n=r.conf.key_data;e!=n.left&&e!=n.right||(t.preventDefault?t.preventDefault():t.returnValue=!1,r._animateStart(e==n.left?-1:1))}},"function"==typeof window.addEventListener?window.addEventListener("keydown",this._doOnWinKeyDown,!1):document.body.attachEvent("onkeydown",this._doOnWinKeyDown),1==t.delete_conf){for(var o in t)t[o]=null;t=null}return this}function dhtmlXWindows(t){var e=this,n={};if(void 0!==t)for(var i in t)n[i]=t[i];t=null,this.conf={skin:window.dhx4.skin||("undefined"!=typeof dhtmlx?dhtmlx.skin:null)||window.dhx4.skinDetect("dhxwins")||"material",vp_pos_ofs:20,vp_custom:!1,vp_of_auto:"auto"==n.vp_overflow,vp_of_id:window.dhx4.newId(),ofs_w:null,ofs_h:null,button_last:null,dblclick_tm:300,dblclick_last:null,dblclick_id:null,dblclick_mode:"minmax",dblclick_active:!1,dblclick_ev:window.dhx4.isIE6||window.dhx4.isIE7||window.dhx4.isIE8,fr_cover:navigator.userAgent.indexOf("MSIE 6.0")>=0};var a=window.dhx4.transDetect();if(this.conf.tr={prop:a.transProp,ev:a.transEv,height_open:"height 0.2s cubic-bezier(0.25,0.1,0.25,1)",height_close:"height 0.18s cubic-bezier(0.25,0.1,0.25,1)",op_open:"opacity 0.16s ease-in",op_close:"opacity 0.2s ease-out",op_v_open:"1",op_v_close:"0.4"},n.viewport?null!=n.viewport.object?this.attachViewportTo(n.viewport.object):null!=n.viewport.left&&null!=n.viewport.top&&null!=n.viewport.width&&null!=n.viewport.height?this.setViewport(n.viewport.left,n.viewport.top,n.viewport.width,n.viewport.height,n.viewport.parent):this.attachViewportTo(document.body):this.attachViewportTo(document.body),this.w={},this.createWindow=function(t,e,n,i,a){var o={};if(1==arguments.length&&"object"==typeof t)o=t;else for(o.id=t,o.left=e,o.top=n,o.width=i,o.height=a,void 0!==o.id&&null!=o.id||(o.id=window.dhx4.newId());null!=this.w[o.id];)o.id=window.dhx4.newId();null==o.left&&(o.left=0),null==o.top&&(o.top=0),o.move=(null==o.move||0!=window.dhx4.s2b(o.move))&&(null==o.deny_move||1!=window.dhx4.s2b(o.deny_move)),o.park=(null==o.park||0!=window.dhx4.s2b(o.park))&&(null==o.deny_park||1!=window.dhx4.s2b(o.deny_park)),o.resize=(null==o.resize||0!=window.dhx4.s2b(o.resize))&&(null==o.deny_resize||1!=window.dhx4.s2b(o.deny_resize)),o.keep_in_viewport=null!=o.keep_in_viewport&&window.dhx4.s2b(o.keep_in_viewport),o.modal=null!=o.modal&&window.dhx4.s2b(o.modal),o.center=null!=o.center&&window.dhx4.s2b(o.center),o.text=null!=o.text?o.text:null!=o.caption?o.caption:"dhtmlxWindow",o.header=!(null!=o.header&&0==window.dhx4.s2b(o.header));var r=document.createElement("DIV");r.className="dhxwin_active",this.vp.appendChild(r),r._isWindow=!0,r._idd=o.id;var s=document.createElement("DIV");s.className="dhxwin_hdr",s.style.zIndex=0,s.innerHTML="<div class='dhxwin_icon'></div><div class='dhxwin_text'><div class='dhxwin_text_inside'>"+o.text+"</div></div><div class='dhxwin_btns'></div>",r.appendChild(s),s.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},s.oncontextmenu=function(t){return(t=t||event).cancelBubble=!0,!1},s._isWinHdr=!0,s.firstChild._isWinIcon=!0;var l=document.createElement("DIV");l.className="dhxwin_brd",r.appendChild(l);var d=document.createElement("DIV");d.className="dhxwin_fr_cover",d.innerHTML="<iframe class='dhxwin_fr_cover_inner' frameborder='0' border='0'></iframe><div class='dhxwin_fr_cover_inner'></div>",r.appendChild(d),this.w[o.id]={win:r,hdr:s,brd:l,fr_cover:d,b:{},conf:{z_id:window.dhx4.newId(),actv:!1,modal:!1,maxed:!1,parked:!1,sticked:!1,visible:!0,header:!0,text:o.text,keep_in_vp:o.keep_in_viewport,allow_move:o.move,allow_park:o.park,allow_resize:o.resize,max_w:null,max_h:null,min_w:80,min_h:80}};var c={help:{title:"Help",visible:!1},stick:{title:"Stick",visible:!1},park:{title:"Park",visible:!0},minmax:{title:"Min/Max",visible:!0},close:{title:"Close",visible:!0}};for(var h in c){var u=new dhtmlXWindowsButton(this,o.id,h,c[h].title,!1);0==c[h].visible&&u.hide(),s.lastChild.appendChild(u.button),this.w[o.id].b[h]=u,u=null}this._winAdjustTitle(o.id),this.w[o.id].win.style.zIndex=window.dhx4.zim.reserve(this.w[o.id].conf.z_id);var m=new dhtmlXWindowsCell(o.id,this);return this.w[o.id].win.insertBefore(m.cell,d),this.w[o.id].cell=m,"function"==typeof window.addEventListener?(this.w[o.id].win.addEventListener("mousedown",this._winOnMouseDown,!1),this.w[o.id].win.addEventListener("mouseup",this._winOnMouseDown,!1),this.conf.dblclick_ev&&this.w[o.id].win.addEventListener("dblclick",this._winOnMouseDown,!1),1==this.conf.dnd_enabled&&null!=window.dhx4.dnd.evs.start&&(this.w[o.id].win.addEventListener(window.dhx4.dnd.evs.start,this._winOnMouseDown,!1),1!=window.dhx4.dnd.p_en&&(this.w[o.id].win.addEventListener(window.dhx4.dnd.evs.start,this._winOnMouseDown,!1),this.w[o.id].win.addEventListener(window.dhx4.dnd.evs.end,this._winOnMouseDown,!1)))):(this.w[o.id].win.attachEvent("onmousedown",this._winOnMouseDown),this.w[o.id].win.attachEvent("onmouseup",this._winOnMouseDown),this.conf.dblclick_ev&&this.w[o.id].win.attachEvent("ondblclick",this._winOnMouseDown)),this._winInitFRM(o.id),this._winSetPosition(o.id,o.left,o.top),this._winSetSize(o.id,o.width,o.height),this._winMakeActive(o.id),1==o.center&&this.w[o.id].cell.center(),1==o.modal&&this.w[o.id].cell.setModal(!0),0==o.header&&this.w[o.id].cell.hideHeader(),f=r=s=l=d=m=null,this.w[o.id].cell},this._winOnMouseDown=function(t){var n=(t=t||event).target||t.srcElement,i={press_type:t.type};if("MSPointerDown"!=t.type&&"pointerdown"!=t.type){if(1==e.conf.ev_skip)return e.conf.ev_skip=!1,void(n=null);for(;null!=n&&1!=n._isWindow;)void 0!==n.className&&null==i.mode&&(void 0!==n._buttonName?(i.mode="button",i.button_name=n._buttonName):1==n._isWinHdr?i.mode="hdr":1==n._isWinIcon&&(i.mode="icon")),n=n.parentNode;null==i.mode&&(i.mode="win"),i.id=null!=n&&1==n._isWindow?n._idd:null,n=null,null!=i.id&&null!=e.w[i.id]&&e.callEvent("_winMouseDown",[t,i])}},this._winOnParkTrans=function(t){t.stopPropagation&&t.stopPropagation();var n=e.w[this._idd];"opacity"==t.propertyName&&e._winCellClearOpacity(this._idd),"height"==t.propertyName&&"park"==n.conf.tr_mode&&"park"==n.conf.tr_mode&&(n.win.style[e.conf.tr.prop]="",n.conf.parked?(n.hdr.style.zIndex=3,e._callMainEvent("onParkUp",this._idd)):(e._winAdjustCell(this._idd),e._callMainEvent("onParkDown",this._idd),n.conf.keep_in_vp&&e._winAdjustPosition(this._idd,n.conf.x,n.conf.y))),n=null},this.unload=function(){for(var t in this.conf.unloading=!0,this._dndInitModule&&this._dndUnloadModule(),this.w)this._winClose(t);for(var t in this.w=null,null!=this.cm&&"function"==typeof this._unloadContextMenu&&this._unloadContextMenu(),window.dhx4._eventable(this,"clear"),this.attachViewportTo(null),this.conf)this.conf[t]=null,delete this.conf[t];for(var t in this)this[t]=null;e=t=null},window.dhx4._eventable(this),this.attachEvent("_winMouseDown",this._winMouseDownHandler),this._dndInitModule&&this._dndInitModule(),null!=n.wins)for(var o=0;o<n.wins.length;o++){var r=n.wins[o];this.createWindow(r)}return n=null,this}function dhtmlXWindowsCell(t,e){for(var n in dhtmlXCellObject.apply(this,[t,"_wins"]),this.wins=e,this.cell._winId=t,this.conf.skin=this.wins.conf.skin,this.attachEvent("_onCellUnload",function(){this._unloadResize&&this._unloadResize(),window.dhx4._eventable(this.cell,"clear"),this.cell._winId=null,this.wins=null,this.setText=null,this.getText=null,this.allowMove=null,this.denyMove=null,this.isMovable=null,this.allowResize=null,this.denyResize=null,this.isResizable=null,this.maximize=null,this.minimize=null,this.isMaximized=null,this.setPosition=null,this.getPosition=null,this.adjustPosition=null,this.park=null,this.isParked=null,this.allowPark=null,this.denyPark=null,this.isParkable=null,this.show=null,this.hide=null,this.isHidden=null,this.stick=null,this.unstick=null,this.isSticked=null,this.setDimension=null,this.getDimension=null,this.setMinDimension=null,this.getMinDimension=null,this.setMaxDimension=null,this.getMaxDimension=null,this.keepInViewport=null,this.center=null,this.centerOnScreen=null,this.bringToTop=null,this.bringToBottom=null,this.isOnTop=null,this.isOnBottom=null,this.showHeader=null,this.hideHeader=null,this.setModal=null,this.isModal=null,this.close=null,this._adjustByCont=null,this.button=null,this.addUserButton=null,this.removeUserButton=null,i=null}),this.attachEvent("_onContentLoaded",function(){this.wins._callMainEvent("onContentLoaded",this._idd)}),this.attachEvent("_onContentMouseDown",function(t,e){this.wins.callEvent("_winMouseDown",[e,{id:t,mode:"win"}])}),this._callMainEvent=function(t,e){return this.callEvent(t,e)},this.conf.tr={},this.wins.conf.tr)this.conf.tr[n]=this.wins.conf.tr[n];this.conf.tr.prop,this._initResize&&this._initResize(),window.dhx4._eventable(this.cell);var i=this;return this.cell.attachEvent("_setCellSize",function(t,e){var n=i.wins.w[this._winId].conf.w-i.conf.size.w,a=i.wins.w[this._winId].conf.h-i.conf.size.h;i.setDimension(t+n,e+a)}),this}null==dhtmlxEvent.touchDelay&&(dhtmlxEvent.touchDelay=2e3),void 0===dhtmlxEvent.initTouch&&(dhtmlxEvent.initTouch=function(){var t,e,n,i;function a(){if(e){var n=document.createEvent("HTMLEvents");n.initEvent("dblclick",!0,!0),e.dispatchEvent(n),t=e=null}}dhtmlxEvent(document.body,"touchstart",function(o){e=o.touches[0].target,n=o.touches[0].clientX,i=o.touches[0].clientY,t=window.setTimeout(a,dhtmlxEvent.touchDelay)}),dhtmlxEvent(document.body,"touchmove",function(a){t&&(Math.abs(a.touches[0].clientX-n)>50||Math.abs(a.touches[0].clientY-i)>50)&&(window.clearTimeout(t),t=e=!1)}),dhtmlxEvent(document.body,"touchend",function(n){t&&(window.clearTimeout(t),t=e=!1)}),dhtmlxEvent.initTouch=function(){}}),function(t){var e="undefined"!=typeof setImmediate?setImmediate:function(t){setTimeout(t,0)};function n(t,e){var n=this;n.promise=n,n.state="pending",n.val=null,n.fn=t||null,n.er=e||null,n.next=[]}n.prototype.resolve=function(t){var n=this;"pending"===n.state&&(n.val=t,n.state="resolving",e(function(){n.fire()}))},n.prototype.reject=function(t){var n=this;"pending"===n.state&&(n.val=t,n.state="rejecting",e(function(){n.fire()}))},n.prototype.then=function(t,e){var i=this,a=new n(t,e);return i.next.push(a),"resolved"===i.state&&a.resolve(i.val),"rejected"===i.state&&a.reject(i.val),a},n.prototype.fail=function(t){return this.then(null,t)},n.prototype.finish=function(t){var e=this;if(e.state=t,"resolved"===e.state)for(var n=0;n<e.next.length;n++)e.next[n].resolve(e.val);if("rejected"===e.state){for(n=0;n<e.next.length;n++)e.next[n].reject(e.val);if(!e.next.length)throw e.val}},n.prototype.thennable=function(t,e,n,i,a){if("object"==typeof(a=a||this.val)&&"function"==typeof t)try{var o=0;t.call(a,function(t){0==o++&&e(t)},function(t){0==o++&&n(t)})}catch(t){n(t)}else i(a)},n.prototype.fire=function(){var t,e=this;try{t=e.val&&e.val.then}catch(t){return e.val=t,e.state="rejecting",e.fire()}e.thennable(t,function(t){e.val=t,e.state="resolving",e.fire()},function(t){e.val=t,e.state="rejecting",e.fire()},function(n){if(e.val=n,"resolving"===e.state&&"function"==typeof e.fn)try{e.val=e.fn.call(void 0,e.val)}catch(t){return e.val=t,e.finish("rejected")}if("rejecting"===e.state&&"function"==typeof e.er)try{e.val=e.er.call(void 0,e.val),e.state="resolving"}catch(t){return e.val=t,e.finish("rejected")}if(e.val===e)return e.val=TypeError(),e.finish("rejected");e.thennable(t,function(t){e.val=t,e.finish("resolved")},function(t){e.val=t,e.finish("rejected")},function(t){e.val=t,"resolving"===e.state?e.finish("resolved"):e.finish("rejected")})})},n.prototype.done=function(){if(this.state=!this.next)throw this.val;return null},n.prototype.nodeify=function(t){return"function"==typeof t?this.then(function(e){try{t(null,e)}catch(t){setImmediate(function(){throw t})}return e},function(e){try{t(e)}catch(t){setImmediate(function(){throw t})}return e}):this},n.prototype.spread=function(t,e){return this.all().then(function(e){return"function"==typeof t&&t.apply(null,e)},e)},n.prototype.all=function(){var t=this;return this.then(function(e){var i=new n;if(!(e instanceof Array))return i.reject(TypeError),i;var a=0,o=e.length;function r(){++a===o&&i.resolve(e)}for(var s=0,l=e.length;s<l;s++){var d,c=e[s];try{d=c&&c.then}catch(t){i.reject(t);break}!function(n){t.thennable(d,function(t){e[n]=t,r()},function(t){i.reject(t)},function(){r()},c)}(s)}return i})};var i={all:function(t){var e=new n(null,null);return e.resolve(t),e.all()},defer:function(){return new n(null,null)},fcall:function(){var t=new n,e=Array.apply([],arguments),i=e.shift();try{var a=i.apply(null,e);t.resolve(a)}catch(e){t.reject(e)}return t},nfcall:function(){var t=new n,e=Array.apply([],arguments),i=e.shift();try{e.push(function(e,n){return e?t.reject(e):t.resolve(n)}),i.apply(null,e)}catch(e){t.reject(e)}return t}};t.promise=i}(dhx),window.dhtmlx||(dhtmlx={}),dhtmlx.assert=function(t,e){t||dhtmlx.error(e)},dhtmlx.assert_enabled=function(){return!1},dhtmlx.assert_event=function(t,e){for(var n in t._event_check||(t._event_check={},t._event_check_size={}),e){t._event_check[n.toLowerCase()]=e[n];var i=-1;for(var a in e[n])i++;t._event_check_size[n.toLowerCase()]=i}},dhtmlx.assert_method_info=function(t,e,n,i){for(var a=[],o=0;o<i.length;o++)a.push(i[o][0]+" : "+i[o][1]+"\n   "+i[o][2].describe()+(i[o][3]?"; optional":""));return t.name+"."+e+"\n"+n+"\n Arguments:\n - "+a.join("\n - ")},dhtmlx.assert_method=function(t,e){for(var n in e)dhtmlx.assert_method_process(t,n,e[n].descr,e[n].args,e[n].min||99,e[n].skip)},dhtmlx.assert_method_process=function(t,e,n,i,a,o){var r=t[e];o||(t[e]=function(){if(arguments.length!=i.length&&arguments.length<a)dhtmlx.log("warn","Incorrect count of parameters\n"+t[e].describe()+"\n\nExpecting "+i.length+" but have only "+arguments.length);else for(var n=0;n<i.length;n++)i[n][3]||i[n][2](arguments[n])||dhtmlx.log("warn","Incorrect method call\n"+t[e].describe()+"\n\nActual value of "+(n+1)+" parameter: {"+typeof arguments[n]+"} "+arguments[n]);return r.apply(this,arguments)}),t[e].describe=function(){return dhtmlx.assert_method_info(t,e,n,i)}},dhtmlx.assert_event_call=function(t,e,n){t._event_check&&(t._event_check[e]?dhtmlx.isNotDefined(n)?dhtmlx.log("warn","Event without parameters :"+e):t._event_check_size[e]!=n.length&&dhtmlx.log("warn","Incorrect event call, expected "+t._event_check_size[e]+" parameter(s), but have "+n.length+" parameter(s), for "+e+" event"):dhtmlx.log("warn","Not expected event call :"+e))},dhtmlx.assert_event_attach=function(t,e){t._event_check&&!t._event_check[e]&&dhtmlx.log("warn","Unknown event name: "+e)},dhtmlx.assert_property=function(t,e){t._settings_check||(t._settings_check={}),dhtmlx.extend(t._settings_check,e)},dhtmlx.assert_check=function(t,e){if("object"==typeof t)for(var n in t)dhtmlx.assert_settings(n,t[n],e)},dhtmlx.assert_settings=function(t,e,n){if(n=n||this._settings_check){if(!n[t])return dhtmlx.log("warn","Unknown propery: "+t);for(var i=!1,a=0;a<n[t].length;a++){var o=n[t][a];if("string"!=typeof o&&("function"==typeof o?i=i||o(e):"object"==typeof o&&"function"==typeof o[1]&&(i=i||o[1](e))&&o[2]&&dhtmlx.assert_check(e,o[2]),i))break}i||dhtmlx.log("warn","Invalid configuration\n"+dhtmlx.assert_info(t,n)+"\nActual value: {"+typeof e+"} "+e)}},dhtmlx.assert_info=function(t,e){for(var n=e[t],i="",a=[],o=0;o<n.length;o++)"string"==typeof rule?i=n[o]:n[o].describe?a.push(n[o].describe()):n[o][1]&&n[o][1].describe&&a.push(n[o][1].describe());return"Property: "+t+", "+i+" \nExpected value: \n - "+a.join("\n - ")},dhtmlx.assert_enabled()&&(dhtmlx.assert_rule_color=function(t){return"string"==typeof t&&(0===t.indexOf("#")&&""===t.substr(1).replace(/[0-9A-F]/gi,""))},dhtmlx.assert_rule_color.describe=function(){return"{String} Value must start from # and contain hexadecimal code of color"},dhtmlx.assert_rule_template=function(t){return"function"==typeof t||"string"==typeof t},dhtmlx.assert_rule_template.describe=function(){return"{Function},{String} Value must be a function which accepts data object and return text string, or a sting with optional template markers"},dhtmlx.assert_rule_boolean=function(t){return"boolean"==typeof t},dhtmlx.assert_rule_boolean.describe=function(){return"{Boolean} true or false"},dhtmlx.assert_rule_object=function(t,e){return"object"==typeof t},dhtmlx.assert_rule_object.describe=function(){return"{Object} Configuration object"},dhtmlx.assert_rule_string=function(t){return"string"==typeof t},dhtmlx.assert_rule_string.describe=function(){return"{String} Plain string"},dhtmlx.assert_rule_htmlpt=function(t){return!!dhtmlx.toNode(t)},dhtmlx.assert_rule_htmlpt.describe=function(){return"{Object},{String} HTML node or ID of HTML Node"},dhtmlx.assert_rule_notdocumented=function(t){return!1},dhtmlx.assert_rule_notdocumented.describe=function(){return"This options wasn't documented"},dhtmlx.assert_rule_key=function(t){var e=function(e){return t[e]};return e.describe=function(){var e=[];for(var n in t)e.push(n);return"{String} can take one of next values: "+e.join(", ")},e},dhtmlx.assert_rule_dimension=function(t){return 1*t==t&&!isNaN(t)&&t>=0},dhtmlx.assert_rule_dimension.describe=function(){return"{Integer} value must be a positive number"},dhtmlx.assert_rule_number=function(t){return"number"==typeof t},dhtmlx.assert_rule_number.describe=function(){return"{Integer} value must be a number"},dhtmlx.assert_rule_function=function(t){return"function"==typeof t},dhtmlx.assert_rule_function.describe=function(){return"{Function} value must be a custom function"},dhtmlx.assert_rule_any=function(t){return!0},dhtmlx.assert_rule_any.describe=function(){return"Any value"},dhtmlx.assert_rule_mix=function(t,e){var n=function(n){return!(!t(n)&&!e(n))};return n.describe=function(){return t.describe()},n}),dhtmlx.codebase="./",dhtmlx.copy=function(t){var e=dhtmlx.copy._function;return e.prototype=t,new e},dhtmlx.copy._function=function(){},dhtmlx.extend=function(t,e){for(var n in e)t[n]=e[n];return dhtmlx.assert_enabled()&&e._assert&&(t._assert(),t._assert=null),dhtmlx.assert(t,"Invalid nesting target"),dhtmlx.assert(e,"Invalid nesting source"),e._init&&t._init(),t},dhtmlx.proto_extend=function(){for(var t=arguments,e=t[0],n=[],i=t.length-1;i>0;i--)for(var a in"function"==typeof t[i]&&(t[i]=t[i].prototype),t[i])"_init"==a?n.push(t[i][a]):e[a]||(e[a]=t[i][a]);t[0]._init&&n.push(t[0]._init),e._init=function(){for(var t=0;t<n.length;t++)n[t].apply(this,arguments)},e.base=t[1];var o=function(t){this._init(t),this._parseSettings&&this._parseSettings(t,this.defaults)};return o.prototype=e,e=t=null,o},dhtmlx.bind=function(t,e){return function(){return t.apply(e,arguments)}},dhtmlx.require=function(t){dhtmlx._modules[t]||(dhtmlx.assert(dhtmlx.ajax,"load module is required"),dhtmlx.exec(dhtmlx.ajax().sync().get(dhtmlx.codebase+t).responseText),dhtmlx._modules[t]=!0)},dhtmlx._modules={},dhtmlx.exec=function(t){window.execScript?window.execScript(t):window.eval(t)},dhtmlx.methodPush=function(t,e,n){return function(){return t[e].apply(t,arguments)}},dhtmlx.isNotDefined=function(t){return void 0===t},dhtmlx.delay=function(t,e,n,i){setTimeout(function(){var i=t.apply(e,n);return t=e=n=null,i},i||1)},dhtmlx.uid=function(){return this._seed||(this._seed=(new Date).valueOf()),this._seed++,this._seed},dhtmlx.toNode=function(t){return"string"==typeof t?document.getElementById(t):t},dhtmlx.toArray=function(t){return dhtmlx.extend(t||[],dhtmlx.PowerArray)},dhtmlx.toFunctor=function(str){return"string"==typeof str?eval(str):str},dhtmlx._events={},dhtmlx.event=function(t,e,n,i){t=dhtmlx.toNode(t);var a=dhtmlx.uid();return dhtmlx._events[a]=[t,e,n],i&&(n=dhtmlx.bind(n,i)),t.addEventListener?t.addEventListener(e,n,!1):t.attachEvent&&t.attachEvent("on"+e,n),a},dhtmlx.eventRemove=function(t){if(t){dhtmlx.assert(this._events[t],"Removing non-existing event");var e=dhtmlx._events[t];e[0].removeEventListener?e[0].removeEventListener(e[1],e[2],!1):e[0].detachEvent&&e[0].detachEvent("on"+e[1],e[2]),delete this._events[t]}},dhtmlx.log=function(t,e,n){window.console&&console.log&&(t=t.toLowerCase(),window.console[t]?window.console[t](e||"unknown error"):window.console.log(t+": "+e),n&&window.console.log(n))},dhtmlx.log_full_time=function(t){dhtmlx._start_time_log=new Date,dhtmlx.log("Info","Timing start ["+t+"]"),window.setTimeout(function(){var e=new Date;dhtmlx.log("Info","Timing end ["+t+"]:"+(e.valueOf()-dhtmlx._start_time_log.valueOf())/1e3+"s")},1)},dhtmlx.log_time=function(t){var e="_start_time_log"+t;if(dhtmlx[e]){var n=new Date;dhtmlx.log("Info","Timing end ["+t+"]:"+(n.valueOf()-dhtmlx[e].valueOf())/1e3+"s"),dhtmlx[e]=null}else dhtmlx[e]=new Date,dhtmlx.log("Info","Timing start ["+t+"]")},dhtmlx.error=function(t,e){dhtmlx.log("error",t,e)},dhtmlx.EventSystem={_init:function(){this._events={},this._handlers={},this._map={}},block:function(){this._events._block=!0},unblock:function(){this._events._block=!1},mapEvent:function(t){dhtmlx.extend(this._map,t)},callEvent:function(t,e){if(this._events._block)return!0;t=t.toLowerCase(),dhtmlx.assert_event_call(this,t,e);var n=this._events[t.toLowerCase()],i=!0;if(dhtmlx.debug&&dhtmlx.log("info","["+this.name+"] event:"+t,e),n)for(var a=0;a<n.length;a++)!1===n[a].apply(this,e||[])&&(i=!1);return this._map[t]&&!this._map[t].callEvent(t,e)&&(i=!1),i},attachEvent:function(t,e,n){t=t.toLowerCase(),dhtmlx.assert_event_attach(this,t),n=n||dhtmlx.uid(),e=dhtmlx.toFunctor(e);var i=this._events[t]||dhtmlx.toArray();return i.push(e),this._events[t]=i,this._handlers[n]={f:e,t:t},n},detachEvent:function(t){if(this._handlers[t]){var e=this._handlers[t].t,n=this._handlers[t].f;this._events[e].remove(n),delete this._handlers[t]}}},dhtmlx.PowerArray={removeAt:function(t,e){t>=0&&this.splice(t,e||1)},remove:function(t){this.removeAt(this.find(t))},insertAt:function(t,e){if(e||0===e){var n=this.splice(e,this.length-e);this[e]=t,this.push.apply(this,n)}else this.push(t)},find:function(t){for(i=0;i<this.length;i++)if(t==this[i])return i;return-1},each:function(t,e){for(var n=0;n<this.length;n++)t.call(e||this,this[n])},map:function(t,e){for(var n=0;n<this.length;n++)this[n]=t.call(e||this,this[n]);return this}},dhtmlx.env={},-1!=navigator.userAgent.indexOf("Opera")?dhtmlx._isOpera=!0:(dhtmlx._isIE=!!document.all,dhtmlx._isFF=!document.all,dhtmlx._isWebKit=-1!=navigator.userAgent.indexOf("KHTML"),-1!=navigator.appVersion.indexOf("MSIE 8.0")&&"BackCompat"!=document.compatMode&&(dhtmlx._isIE=8),-1!=navigator.appVersion.indexOf("MSIE 9.0")&&"BackCompat"!=document.compatMode&&(dhtmlx._isIE=9)),dhtmlx.env={},function(){dhtmlx.env.transform=!1,dhtmlx.env.transition=!1;for(var t={names:["transform","transition"],transform:["transform","WebkitTransform","MozTransform","oTransform","msTransform"],transition:["transition","WebkitTransition","MozTransition","oTransition"]},e=document.createElement("DIV"),n=0;n<t.names.length;n++)for(;p=t[t.names[n]].pop();)void 0!==e.style[p]&&(dhtmlx.env[t.names[n]]=!0)}(),dhtmlx.env.transform_prefix=(dhtmlx._isOpera?a="-o-":(a="",dhtmlx._isFF&&(a="-moz-"),dhtmlx._isWebKit&&(a="-webkit-")),a),dhtmlx.env.svg=document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1"),dhtmlx.zIndex={drag:1e4},dhtmlx.html={create:function(t,e,n){e=e||{};var i=document.createElement(t);for(var a in e)i.setAttribute(a,e[a]);return e.style&&(i.style.cssText=e.style),e.class&&(i.className=e.class),n&&(i.innerHTML=n),i},getValue:function(t){return(t=dhtmlx.toNode(t))?dhtmlx.isNotDefined(t.value)?t.innerHTML:t.value:""},remove:function(t){if(t instanceof Array)for(var e=0;e<t.length;e++)this.remove(t[e]);else t&&t.parentNode&&t.parentNode.removeChild(t)},insertBefore:function(t,e,n){t&&(e?e.parentNode.insertBefore(t,e):n.appendChild(t))},locate:function(t,e){for(var n=(t=t||event).target||t.srcElement;n;){if(n.getAttribute){var i=n.getAttribute(e);if(i)return i}n=n.parentNode}return null},offset:function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=document.body,i=document.documentElement,a=window.pageYOffset||i.scrollTop||n.scrollTop,o=window.pageXOffset||i.scrollLeft||n.scrollLeft,r=i.clientTop||n.clientTop||0,s=i.clientLeft||n.clientLeft||0,l=e.top+a-r,d=e.left+o-s;return{y:Math.round(l),x:Math.round(d)}}for(l=0,d=0;t;)l+=parseInt(t.offsetTop,10),d+=parseInt(t.offsetLeft,10),t=t.offsetParent;return{y:l,x:d}},pos:function(t){if((t=t||event).pageX||t.pageY)return{x:t.pageX,y:t.pageY};var e=dhtmlx._isIE&&"BackCompat"!=document.compatMode?document.documentElement:document.body;return{x:t.clientX+e.scrollLeft-e.clientLeft,y:t.clientY+e.scrollTop-e.clientTop}},preventEvent:function(t){t&&t.preventDefault&&t.preventDefault(),dhtmlx.html.stopEvent(t)},stopEvent:function(t){return(t||event).cancelBubble=!0,!1},addCss:function(t,e){t.className+=" "+e},removeCss:function(t,e){t.className=t.className.replace(RegExp(e,"g"),"")}},function(){var t=document.getElementsByTagName("SCRIPT");dhtmlx.assert(t.length,"Can't locate codebase"),t.length&&((t=(t[t.length-1].getAttribute("src")||"").split("/")).splice(t.length-1,1),dhtmlx.codebase=t.slice(0,t.length).join("/")+"/")}(),dhtmlx.ui||(dhtmlx.ui={}),dhtmlx.Destruction={_init:function(){dhtmlx.destructors.push(this)},destructor:function(t){this.destructor=function(){},this._htmlmap=null,this._htmlrows=null,this._html&&document.body.appendChild(this._html),this._html=null,this._obj&&(this._obj.innerHTML="",this._obj._htmlmap=null),this._obj=this._dataobj=null,this.data=null,this._events=this._handlers={},this.canvases=[],this.render&&(this.render=function(){})}},dhtmlx.destructors=[],dhtmlx.event(window,"unload",function(){if(dhtmlx.destructors){for(var t=0;t<dhtmlx.destructors.length;t++)dhtmlx.destructors[t].destructor(-1);dhtmlx.destructors=[]}for(var e in dhtmlx._events){var n=dhtmlx._events[e];n[0].removeEventListener?n[0].removeEventListener(n[1],n[2],!1):n[0].detachEvent&&n[0].detachEvent("on"+n[1],n[2]),delete dhtmlx._events[e]}}),dhtmlx.ajax=function(t,e,n){if(0!==arguments.length){var i=new dhtmlx.ajax;n&&(i.master=n),i.get(t,null,e)}return this.getXHR?this:new dhtmlx.ajax},dhtmlx.ajax.prototype={getXHR:function(){return dhtmlx._isIE?new ActiveXObject("Microsoft.xmlHTTP"):new XMLHttpRequest},send:function(t,e,n){var i=this.getXHR();if("function"==typeof n&&(n=[n]),"object"==typeof e){var a=[];for(var o in e){var r=e[o];null!==r&&r!==dhtmlx.undefined||(r=""),a.push(o+"="+encodeURIComponent(r))}e=a.join("&")}e&&!this.post&&(t=t+(-1!=t.indexOf("?")?"&":"?")+e,e=null),i.open(this.post?"POST":"GET",t,!this._sync),this.post&&i.setRequestHeader("Content-type","application/x-www-form-urlencoded");var s=this;return i.onreadystatechange=function(){if(!i.readyState||4==i.readyState){if(n&&s)for(var t=0;t<n.length;t++)n[t]&&n[t].call(s.master||s,i.responseText,i.responseXML,i);s.master=null,n=s=null}},i.send(e||null),i},get:function(t,e,n){return this.post=!1,this.send(t,e,n)},post:function(t,e,n){return this.post=!0,this.send(t,e,n)},sync:function(){return this._sync=!0,this}},dhtmlx.AtomDataLoader={_init:function(t){this.data={},t&&(this._settings.datatype=t.datatype||"json",this._after_init.push(this._load_when_ready))},_load_when_ready:function(){this._ready_for_data=!0,this._settings.url&&this.url_setter(this._settings.url),this._settings.data&&this.data_setter(this._settings.data)},url_setter:function(t){return this._ready_for_data?(this.load(t,this._settings.datatype),t):t},data_setter:function(t){return this._ready_for_data?(this.parse(t,this._settings.datatype),!0):t},load:function(t,e){if(this.callEvent("onXLS",[]),"string"==typeof e?(this.data.driver=dhtmlx.DataDriver[e],e=arguments[2]):this.data.driver=dhtmlx.DataDriver[this._settings.datatype||"xml"],window.dhx4)return dhx4.ajax.get(t,dhtmlx.bind(function(t){var n=t.xmlDoc,i=n.responseText,a=n.responseXML;this._onLoad&&this._onLoad.call(this,i,a,n),e&&e.call(this,i,a,n)},this));dhtmlx.ajax(t,[this._onLoad,e],this)},parse:function(t,e){this.callEvent("onXLS",[]),this.data.driver=dhtmlx.DataDriver[e||"xml"],this._onLoad(t,null)},_onLoad:function(t,e,n){var i=this.data.driver,a=i.getRecords(i.toObject(t,e))[0];this.data=i?i.getDetails(a):t,this.callEvent("onXLE",[])},_check_data_feed:function(t){if(!this._settings.dataFeed||this._ignore_feed||!t)return!0;var e=this._settings.dataFeed;return"function"==typeof e?e.call(this,t.id||t,t):(e=e+(-1==e.indexOf("?")?"?":"&")+"action=get&id="+encodeURIComponent(t.id||t),this.callEvent("onXLS",[]),dhtmlx.ajax(e,function(t,e){this._ignore_feed=!0,this.setValues(dhtmlx.DataDriver.json.toObject(t)[0]),this._ignore_feed=!1,this.callEvent("onXLE",[])},this),!1)}},dhtmlx.DataDriver={},dhtmlx.DataDriver.json={toObject:function(data){return data||(data="[]"),"string"==typeof data?(eval("dhtmlx.temp="+data),dhtmlx.temp):data},getRecords:function(t){return t&&t.data&&(t=t.data),!t||t instanceof Array?t:[t]},getDetails:function(t){return t},getInfo:function(t){return{_size:t.total_count||0,_from:t.pos||0,_key:t.dhx_security}}},dhtmlx.DataDriver.json_ext={toObject:function(data){if(data||(data="[]"),"string"==typeof data){var temp;eval("temp="+data),dhtmlx.temp=[];for(var header=temp.header,i=0;i<temp.data.length;i++){for(var item={},j=0;j<header.length;j++)void 0!==temp.data[i][j]&&(item[header[j]]=temp.data[i][j]);dhtmlx.temp.push(item)}return dhtmlx.temp}return data},getRecords:function(t){return!t||t instanceof Array?t:[t]},getDetails:function(t){return t},getInfo:function(t){return{_size:t.total_count||0,_from:t.pos||0}}},dhtmlx.DataDriver.html={toObject:function(t){if("string"==typeof t){var e=null;return-1==t.indexOf("<")&&(e=dhtmlx.toNode(t)),e||((e=document.createElement("DIV")).innerHTML=t),e.getElementsByTagName(this.tag)}return t},getRecords:function(t){return t.tagName?t.childNodes:t},getDetails:function(t){return dhtmlx.DataDriver.xml.tagToObject(t)},getInfo:function(t){return{_size:0,_from:0}},tag:"LI"},dhtmlx.DataDriver.jsarray={toObject:function(data){return"string"==typeof data?(eval("dhtmlx.temp="+data),dhtmlx.temp):data},getRecords:function(t){return t},getDetails:function(t){for(var e={},n=0;n<t.length;n++)e["data"+n]=t[n];return e},getInfo:function(t){return{_size:0,_from:0}}},dhtmlx.DataDriver.csv={toObject:function(t){return t},getRecords:function(t){return t.split(this.row)},getDetails:function(t){t=this.stringToArray(t);for(var e={},n=0;n<t.length;n++)e["data"+n]=t[n];return e},getInfo:function(t){return{_size:0,_from:0}},stringToArray:function(t){t=t.split(this.cell);for(var e=0;e<t.length;e++)t[e]=t[e].replace(/^[ \t\n\r]*(\"|)/g,"").replace(/(\"|)[ \t\n\r]*$/g,"");return t},row:"\n",cell:","},dhtmlx.DataDriver.xml={toObject:function(t,e){return e&&(e=this.checkResponse(t,e))?e:"string"==typeof t?this.fromString(t):t},getRecords:function(t){return this.xpath(t,this.records)},records:"/*/item",getDetails:function(t){return this.tagToObject(t,{})},getInfo:function(t){return{_size:t.documentElement.getAttribute("total_count")||0,_from:t.documentElement.getAttribute("pos")||0,_key:t.documentElement.getAttribute("dhx_security")}},xpath:function(t,e){if(window.XPathResult){var n=t;-1==t.nodeName.indexOf("document")&&(t=t.ownerDocument);for(var i=[],a=t.evaluate(e,n,null,XPathResult.ANY_TYPE,null),o=a.iterateNext();o;)i.push(o),o=a.iterateNext();return i}var r=!0;try{void 0===t.selectNodes&&(r=!1)}catch(t){}if(r)return t.selectNodes(e);var s=e.split("/").pop();return t.getElementsByTagName(s)},tagToObject:function(t,e){e=e||{};for(var n=!1,i=t.childNodes,a=0;a<i.length;a++)if(1==i[a].nodeType){var o=i[a].tagName;void 0!==e[o]?(e[o]instanceof Array||(e[o]=[e[o]]),e[o].push(this.tagToObject(i[a],{}))):e[i[a].tagName]=this.tagToObject(i[a],{}),n=!0}var r=t.attributes;if(r&&r.length){for(a=0;a<r.length;a++)e[r[a].name]=r[a].value;n=!0}return n?(e.value=this.nodeValue(t),e):this.nodeValue(t)},nodeValue:function(t){return t.firstChild?t.firstChild.wholeText||t.firstChild.data:""},fromString:function(t){if(window.DOMParser&&!dhtmlx._isIE)return(new DOMParser).parseFromString(t,"text/xml");if(window.ActiveXObject){var e=new ActiveXObject("Microsoft.xmlDOM");return e.loadXML(t),e}dhtmlx.error("Load from xml string is not supported")},checkResponse:function(t,e){if(e&&e.firstChild&&"parsererror"!=e.firstChild.tagName)return e;var n=this.fromString(t.replace(/^[\s]+/,""));if(n)return n;dhtmlx.error("xml can't be parsed",t)}},dhtmlx.DataLoader={_init:function(t){t=t||"",this.name="DataStore",this.data=t.datastore||new dhtmlx.DataStore,this._readyHandler=this.data.attachEvent("onStoreLoad",dhtmlx.bind(this._call_onready,this))},load:function(t,e){dhtmlx.AtomDataLoader.load.apply(this,arguments),this.data.feed||(this.data.feed=function(e,n){if(this._load_count)return this._load_count=[e,n];this._load_count=!0,this.load(t+(-1==t.indexOf("?")?"?":"&")+"posStart="+e+"&count="+n,function(){var t=this._load_count;this._load_count=!1,"object"==typeof t&&this.data.feed.apply(this,t)})})},_onLoad:function(t,e,n){this.data._parse(this.data.driver.toObject(t,e)),this.callEvent("onXLE",[]),this._readyHandler&&(this.data.detachEvent(this._readyHandler),this._readyHandler=null)},dataFeed_setter:function(t){return this.data.attachEvent("onBeforeFilter",dhtmlx.bind(function(t,e){if(this._settings.dataFeed){var n={};if(!t&&!n)return;if("function"==typeof t){if(!e)return;t(e,n)}else n={text:e};this.clearAll();var i=this._settings.dataFeed;if("function"==typeof i)return i.call(this,e,n);var a=[];for(var o in n)a.push("dhx_filter["+o+"]="+encodeURIComponent(n[o]));return this.load(i+(i.indexOf("?")<0?"?":"&")+a.join("&"),this._settings.datatype),!1}},this)),t},_call_onready:function(){if(this._settings.ready){var t=dhtmlx.toFunctor(this._settings.ready);t&&t.call&&t.apply(this,arguments)}}},dhtmlx.DataStore=function(){this.name="DataStore",dhtmlx.extend(this,dhtmlx.EventSystem),this.setDriver("xml"),this.pull={},this.order=dhtmlx.toArray()},dhtmlx.DataStore.prototype={setDriver:function(t){dhtmlx.assert(dhtmlx.DataDriver[t],"incorrect DataDriver"),this.driver=dhtmlx.DataDriver[t]},_parse:function(t){this.callEvent("onParse",[this.driver,t]),this._filter_order&&this.filter();var e=this.driver.getInfo(t);e._key&&(dhtmlx.security_key=e._key);var n=this.driver.getRecords(t),i=1*(e._from||0);0===i&&this.order[0]&&(i=this.order.length);for(var a=0,o=0;o<n.length;o++){var r=this.driver.getDetails(n[o]),s=this.id(r);this.pull[s]||(this.order[a+i]=s,a++),this.pull[s]=r,this.extraParser&&this.extraParser(r),this._scheme&&(this._scheme.$init?this._scheme.$update(r):this._scheme.$update&&this._scheme.$update(r))}for(o=0;o<e._size;o++)if(!this.order[o]){r={id:s=dhtmlx.uid(),$template:"loading"};this.pull[s]=r,this.order[o]=s}this.callEvent("onStoreLoad",[this.driver,t]),this.refresh()},id:function(t){return t.id||(t.id=dhtmlx.uid())},changeId:function(t,e){dhtmlx.assert(this.pull[t],"Can't change id, for non existing item: "+t),this.pull[e]=this.pull[t],this.pull[e].id=e,this.order[this.order.find(t)]=e,this._filter_order&&(this._filter_order[this._filter_order.find(t)]=e),this.callEvent("onIdChange",[t,e]),this._render_change_id&&this._render_change_id(t,e)},get:function(t){return this.item(t)},set:function(t,e){return this.update(t,e)},item:function(t){return this.pull[t]},update:function(t,e){if(this._scheme&&this._scheme.$update&&this._scheme.$update(e),!1===this.callEvent("onBeforeUpdate",[t,e]))return!1;this.pull[t]=e,this.refresh(t)},refresh:function(t){this._skip_refresh||(t?this.callEvent("onStoreUpdated",[t,this.pull[t],"update"]):this.callEvent("onStoreUpdated",[null,null,null]))},silent:function(t){this._skip_refresh=!0,t.call(this),this._skip_refresh=!1},getRange:function(t,e){if(t=t?this.indexById(t):this.startOffset||0,e?e=this.indexById(e):(e=Math.min(this.endOffset||1/0,this.dataCount()-1))<0&&(e=0),this.min&&(t=this.min),this.max&&(e=this.max),t>e){var n=e;e=t,t=n}return this.getIndexRange(t,e)},getIndexRange:function(t,e){e=Math.min(e||1/0,this.dataCount()-1);for(var n=dhtmlx.toArray(),i=t||0;i<=e;i++)n.push(this.item(this.order[i]));return n},dataCount:function(){return this.order.length},exists:function(t){return!!this.pull[t]},move:function(t,e){if(t<0||e<0)dhtmlx.error("DataStore::move","Incorrect indexes");else{var n=this.idByIndex(t),i=this.item(n);this.order.removeAt(t),this.order.insertAt(n,Math.min(this.order.length,e)),this.callEvent("onStoreUpdated",[n,i,"move"])}},scheme:function(t){this._scheme=t},sync:function(t,e,n){"function"!=typeof e&&(n=e,e=null),dhtmlx.debug_bind&&(this.debug_sync_master=t,dhtmlx.log("[sync] "+this.debug_bind_master.name+"@"+this.debug_bind_master._settings.id+" <= "+this.debug_sync_master.name+"@"+this.debug_sync_master._settings.id));var i=t;"DataStore"!=t.name&&(t=t.data);var a=dhtmlx.bind(function(i,a,o){("update"!=o||e)&&(i=null),i||(this.order=dhtmlx.toArray([].concat(t.order)),this._filter_order=null,this.pull=t.pull,e&&this.silent(e),this._on_sync&&this._on_sync()),dhtmlx.debug_bind&&dhtmlx.log("[sync:request] "+this.debug_sync_master.name+"@"+this.debug_sync_master._settings.id+" <= "+this.debug_bind_master.name+"@"+this.debug_bind_master._settings.id),n?n=!1:this.refresh(i)},this);t.attachEvent("onStoreUpdated",a),this.feed=function(t,e){i.loadNext(e,t)},a()},add:function(t,e){if(this._scheme){for(var n in t=t||{},this._scheme)t[n]=t[n]||this._scheme[n];this._scheme&&(this._scheme.$init?this._scheme.$update(t):this._scheme.$update&&this._scheme.$update(t))}var i=this.id(t),a=this.dataCount();if((dhtmlx.isNotDefined(e)||e<0)&&(e=a),e>a&&(dhtmlx.log("Warning","DataStore:add","Index of out of bounds"),e=Math.min(this.order.length,e)),!1===this.callEvent("onBeforeAdd",[i,t,e]))return!1;if(this.exists(i))return dhtmlx.error("Not unique ID");if(this.pull[i]=t,this.order.insertAt(i,e),this._filter_order){var o=this._filter_order.length;!e&&this.order.length&&(o=0),this._filter_order.insertAt(i,o)}return this.callEvent("onafterAdd",[i,e]),this.callEvent("onStoreUpdated",[i,t,"add"]),i},remove:function(t){if(t instanceof Array)for(var e=0;e<t.length;e++)this.remove(t[e]);else{if(!1===this.callEvent("onBeforeDelete",[t]))return!1;if(!this.exists(t))return dhtmlx.error("Not existing ID",t);var n=this.item(t);this.order.remove(t),this._filter_order&&this._filter_order.remove(t),delete this.pull[t],this.callEvent("onafterdelete",[t]),this.callEvent("onStoreUpdated",[t,n,"delete"])}},clearAll:function(){this.pull={},this.order=dhtmlx.toArray(),this.feed=null,this._filter_order=null,this.callEvent("onClearAll",[]),this.refresh()},idByIndex:function(t){return(t>=this.order.length||t<0)&&dhtmlx.log("Warning","DataStore::idByIndex Incorrect index"),this.order[t]},indexById:function(t){return this.order.find(t)},next:function(t,e){return this.order[this.indexById(t)+(e||1)]},first:function(){return this.order[0]},last:function(){return this.order[this.order.length-1]},previous:function(t,e){return this.order[this.indexById(t)-(e||1)]},sort:function(t,e,n){var i=t;"function"==typeof t?i={as:t,dir:e}:"string"==typeof t&&(i={by:t,dir:e,as:n});var a=[i.by,i.dir,i.as];if(this.callEvent("onbeforesort",a)){if(this.order.length){var o=dhtmlx.sort.create(i),r=this.getRange(this.first(),this.last());r.sort(o),this.order=r.map(function(t){return this.id(t)},this)}this.refresh(),this.callEvent("onaftersort",a)}},filter:function(t,e){if(this.callEvent("onBeforeFilter",[t,e])&&(this._filter_order&&(this.order=this._filter_order,delete this._filter_order),this.order.length)){if(t){var n=t;e=e||"","string"==typeof t&&(t=dhtmlx.Template.fromHTML(t),e=e.toString().toLowerCase(),n=function(e,n){return-1!=t(e).toLowerCase().indexOf(n)});for(var i=dhtmlx.toArray(),a=0;a<this.order.length;a++){var o=this.order[a];n(this.item(o),e)&&i.push(o)}this._filter_order=this.order,this.order=i}this.refresh(),this.callEvent("onAfterFilter",[])}},each:function(t,e){for(var n=0;n<this.order.length;n++)t.call(e||this,this.item(this.order[n]))},provideApi:function(t,e){this.debug_bind_master=t,e&&this.mapEvent({onbeforesort:t,onaftersort:t,onbeforeadd:t,onafteradd:t,onbeforedelete:t,onafterdelete:t,onbeforeupdate:t});for(var n=["get","set","sort","add","remove","exists","idByIndex","indexById","item","update","refresh","dataCount","filter","next","previous","clearAll","first","last","serialize"],i=0;i<n.length;i++)t[n[i]]=dhtmlx.methodPush(this,n[i]);dhtmlx.assert_enabled()&&this.assert_event(t)},serialize:function(){for(var t=this.order,e=[],n=0;n<t.length;n++)e.push(this.pull[t[n]]);return e}},dhtmlx.sort={create:function(t){return dhtmlx.sort.dir(t.dir,dhtmlx.sort.by(t.by,t.as))},as:{int:function(t,e){return(t*=1)>(e*=1)?1:t<e?-1:0},string_strict:function(t,e){return(t=t.toString())>(e=e.toString())?1:t<e?-1:0},string:function(t,e){return(t=t.toString().toLowerCase())>(e=e.toString().toLowerCase())?1:t<e?-1:0}},by:function(t,e){return t?("function"!=typeof e&&(e=dhtmlx.sort.as[e||"string"]),t=dhtmlx.Template.fromHTML(t),function(n,i){return e(t(n),t(i))}):e},dir:function(t,e){return"asc"==t?e:function(t,n){return-1*e(t,n)}}},dhtmlx.KeyEvents={_init:function(){dhtmlx.event(this._obj,"keypress",this._onKeyPress,this)},_onKeyPress:function(t){var e=(t=t||event).which||t.keyCode;this.callEvent(this._edit_id?"onEditKeyPress":"onKeyPress",[e,t.ctrlKey,t.shiftKey,t])}},dhtmlx.MouseEvents={_init:function(){this.on_click&&(dhtmlx.event(this._obj,"click",this._onClick,this),dhtmlx.event(this._obj,"contextmenu",this._onContext,this)),this.on_dblclick&&dhtmlx.event(this._obj,"dblclick",this._onDblClick,this),this.on_mouse_move&&(dhtmlx.event(this._obj,"mousemove",this._onMouse,this),dhtmlx.event(this._obj,dhtmlx._isIE?"mouseleave":"mouseout",this._onMouse,this))},_onClick:function(t){return this._mouseEvent(t,this.on_click,"ItemClick")},_onDblClick:function(t){return this._mouseEvent(t,this.on_dblclick,"ItemDblClick")},_onContext:function(t){var e=dhtmlx.html.locate(t,this._id);if(e&&!this.callEvent("onBeforeContextMenu",[e,t]))return dhtmlx.html.preventEvent(t)},_onMouse:function(t){dhtmlx._isIE&&(t=document.createEventObject(event)),this._mouse_move_timer&&window.clearTimeout(this._mouse_move_timer),this.callEvent("onMouseMoving",[t]),this._mouse_move_timer=window.setTimeout(dhtmlx.bind(function(){"mousemove"==t.type?this._onMouseMove(t):this._onMouseOut(t)},this),500)},_onMouseMove:function(t){this._mouseEvent(t,this.on_mouse_move,"MouseMove")||this.callEvent("onMouseOut",[t||event])},_onMouseOut:function(t){this.callEvent("onMouseOut",[t||event])},_mouseEvent:function(t,e,n){for(var i=(t=t||event).target||t.srcElement,a="",o=null,r=!1;i&&i.parentNode;){if(!r&&i.getAttribute&&(o=i.getAttribute(this._id))){if(i.getAttribute("userdata")&&this.callEvent("onLocateData",[o,i,t]),!this.callEvent("on"+n,[o,t,i]))return;r=!0}if((a=i.className)&&e[a=(a=a.split(" "))[0]||a[1]])return e[a].call(this,t,o||dhtmlx.html.locate(t,this._id),i);i=i.parentNode}return r}},dhtmlx.Settings={_init:function(){this._settings=this.config={}},define:function(t,e){return"object"==typeof t?this._parseSeetingColl(t):this._define(t,e)},_define:function(t,e){dhtmlx.assert_settings.call(this,t,e);var n=this[t+"_setter"];return this._settings[t]=n?n.call(this,e):e},_parseSeetingColl:function(t){if(t)for(var e in t)this._define(e,t[e])},_parseSettings:function(t,e){var n=dhtmlx.extend({},e);"object"!=typeof t||t.tagName||dhtmlx.extend(n,t),this._parseSeetingColl(n)},_mergeSettings:function(t,e){for(var n in e)switch(typeof t[n]){case"object":t[n]=this._mergeSettings(t[n]||{},e[n]);break;case"undefined":t[n]=e[n]}return t},_parseContainer:function(t,e,n){"object"!=typeof t||t.tagName||(t=t.container),this._obj=this.$view=dhtmlx.toNode(t),!this._obj&&n&&(this._obj=n(t)),dhtmlx.assert(this._obj,"Incorrect html container"),this._obj.className+=" "+e,this._obj.onselectstart=function(){return!1},this._dataobj=this._obj},_set_type:function(t){if("object"==typeof t)return this.type_setter(t);dhtmlx.assert(this.types,"RenderStack :: Types are not defined"),dhtmlx.assert(this.types[t],"RenderStack :: Inccorect type name",t),this.type=dhtmlx.extend({},this.types[t]),this.customize()},customize:function(t){t&&dhtmlx.extend(this.type,t),this.type._item_start=dhtmlx.Template.fromHTML(this.template_item_start(this.type)),this.type._item_end=this.template_item_end(this.type),this.render()},type_setter:function(t){return this._set_type("object"==typeof t?dhtmlx.Type.add(this,t):t),t},template_setter:function(t){return this.type_setter({template:t})},css_setter:function(t){return this._obj.className+=" "+t,t}},dhtmlx.Template={_cache:{},empty:function(){return""},setter:function(t){return dhtmlx.Template.fromHTML(t)},obj_setter:function(t){var e=dhtmlx.Template.setter(t),n=this;return function(){return e.apply(n,arguments)}},fromHTML:function(t){return"function"==typeof t?t:this._cache[t]?this._cache[t]:(t='return "'+(t=(t=(t=(t=(t=(t=(t=(t=(t=(t=(t||"").toString()).replace(/[\r\n]+/g,"\\n")).replace(/\{obj\.([^}?]+)\?([^:]*):([^}]*)\}/g,'"+(obj.$1?"$2":"$3")+"')).replace(/\{common\.([^}\(]*)\}/g,'"+common.$1+"')).replace(/\{common\.([^\}\(]*)\(\)\}/g,'"+(common.$1?common.$1(obj):"")+"')).replace(/\{obj\.([^}]*)\}/g,'"+obj.$1+"')).replace(/#([a-z0-9_]+)#/gi,'"+obj.$1+"')).replace(/\{obj\}/g,'"+obj+"')).replace(/\{-obj/g,"{obj")).replace(/\{-common/g,"{common"))+'";',this._cache[t]=Function("obj","common",t))}},dhtmlx.Type={add:function(t,e){!t.types&&t.prototype.types&&(t=t.prototype),dhtmlx.assert_enabled()&&this.assert_event(e);var n=e.name||"default";return this._template(e),this._template(e,"edit"),this._template(e,"loading"),t.types[n]=dhtmlx.extend(dhtmlx.extend({},t.types[n]||this._default),e),n},_default:{css:"default",template:function(){return""},template_edit:function(){return""},template_loading:function(){return"..."},width:150,height:80,margin:5,padding:0},_template:function(t,e){var n=t[e="template"+(e?"_"+e:"")];if(n&&"string"==typeof n){if(-1!=n.indexOf("->"))switch((n=n.split("->"))[0]){case"html":n=dhtmlx.html.getValue(n[1]).replace(/\"/g,'\\"');break;case"http":n=(new dhtmlx.ajax).sync().get(n[1],{uid:(new Date).valueOf()}).responseText}t[e]=dhtmlx.Template.fromHTML(n)}}},dhtmlx.SingleRender={_init:function(){},_toHTML:function(t){return this.type._item_start(t,this.type)+this.type.template(t,this.type)+this.type._item_end},render:function(){this.callEvent&&!this.callEvent("onBeforeRender",[this.data])||(this.data&&(this._dataobj.innerHTML=this._toHTML(this.data)),this.callEvent&&this.callEvent("onAfterRender",[]))}},dhtmlx.ui.Tooltip=function(t){this.name="Tooltip",dhtmlx.assert_enabled()&&this._assert(),"string"==typeof t&&(t={template:t}),dhtmlx.extend(this,dhtmlx.Settings),dhtmlx.extend(this,dhtmlx.SingleRender),this._parseSettings(t,{type:"default",dy:0,dx:20}),this._dataobj=this._obj=document.createElement("DIV"),this._obj.className="dhx_tooltip",dhtmlx.html.insertBefore(this._obj,document.body.firstChild)},dhtmlx.ui.Tooltip.prototype={show:function(t,e){this._disabled||(this.data!=t&&(this.data=t,this.render(t)),this._obj.style.top=e.y+this._settings.dy+"px",this._obj.style.left=e.x+this._settings.dx+"px",this._obj.style.display="block")},hide:function(){this.data=null,this._obj.style.display="none"},disable:function(){this._disabled=!0},enable:function(){this._disabled=!1},types:{default:dhtmlx.Template.fromHTML("{obj.id}")},template_item_start:dhtmlx.Template.empty,template_item_end:dhtmlx.Template.empty},dhtmlx.AutoTooltip={tooltip_setter:function(t){var e=new dhtmlx.ui.Tooltip(t);return this.attachEvent("onMouseMove",function(t,n){e.show(this.get(t),dhtmlx.html.pos(n))}),this.attachEvent("onMouseOut",function(t,n){e.hide()}),this.attachEvent("onMouseMoving",function(t,n){e.hide()}),e}},dhtmlx.compat=function(t,e){dhtmlx.compat[t]&&dhtmlx.compat[t](e)},dhtmlx.attaches||(dhtmlx.attaches={}),dhtmlx.attaches.attachAbstract=function(t,e){var n=document.createElement("DIV");n.id="CustomObject_"+dhtmlx.uid(),n.style.width="100%",n.style.height="100%",n.cmp="grid",document.body.appendChild(n),this.attachObject(n.id),e.container=n.id;var i=this.vs[this.av];i.grid=new window[t](e),i.gridId=n.id,i.gridObj=n,i.grid.setSizes=function(){this.resize?this.resize():this.render()};return this.vs[this._viewRestore()].grid},dhtmlx.attaches.attachDataView=function(t){return this.attachAbstract("dhtmlXDataView",t)},dhtmlx.attaches.attachChart=function(t){return this.attachAbstract("dhtmlXChart",t)},dhtmlx.compat.layout=function(){},dhtmlXCellObject.prototype.showView=function(t){if(this.conf.view==t)return!1;this._viewSave(this.conf.view),this._viewRestore(t),this._updateIdx(),this._adjustCont(),this.conf.view=t;var e=void 0===this.conf.views_loaded[this.conf.view];return this.conf.views_loaded[this.conf.view]=!0,e},dhtmlXCellObject.prototype.getViewName=function(){return this.conf.view},dhtmlXCellObject.prototype.unloadView=function(t){if(t==this.conf.view){var e=this.conf.unloading;return this.conf.unloading=!0,"function"==typeof this.detachMenu&&this.detachMenu(),"function"==typeof this.detachToolbar&&this.detachToolbar(),"function"==typeof this.detachRibbon&&this.detachRibbon(),this.detachStatusBar(),this._detachObject(null,!0),this.conf.unloading=e,void(this.conf.unloading||this._adjustCont(this._idd))}if(null!=this.views[t]){var n=this.views[t];for(var i in n.dataNodes)"function"==typeof n.dataNodes[i].unload&&n.dataNodes[i].unload(),n.dataNodes[i]=null,n.dataNodesCont[i]=null;"url"==n.dataType?null!=n.cellCont&&"null"!=n.cellCont[0]&&this._detachURLEvents(n.cellCont[0]):null!=n.dataObj&&("function"==typeof n.dataObj.unload?n.dataObj.unload():"function"==typeof n.dataObj.destructor&&n.dataObj.destructor(),n.dataObj=null),n=null,this._viewDelete(t),void 0!==this.conf.views_loaded[t]&&delete this.conf.views_loaded[t]}},dhtmlXCellObject.prototype.getId=function(){return this._idd},dhtmlXCellObject.prototype.progressOn=function(){if(1!=this.conf.progress){this.conf.progress=!0;var t=document.createElement("DIV");t.className=this.conf.idx_data.pr1;var e=document.createElement("DIV");"material"==this.conf.skin&&(window.dhx4.isFF||window.dhx4.isChrome||window.dhx4.isOpera||window.dhx4.isEdge)?(e.className=this.conf.idx_data.pr3,e.innerHTML='<svg class="dhx_cell_prsvg" viewBox="25 25 50 50"><circle class="dhx_cell_prcircle" cx="50" cy="50" r="20"/></svg>'):e.className=this.conf.idx_data.pr2,null!=this.conf.idx.cover?this.cell.insertBefore(e,this.cell.childNodes[this.conf.idx.cover]):this.cell.appendChild(e),this.cell.insertBefore(t,e),t=e=null,this._updateIdx(),this._adjustProgress()}},dhtmlXCellObject.prototype.progressOff=function(){if(1==this.conf.progress){for(var t in{pr3:3,pr2:2,pr1:1}){var e=this.cell.childNodes[this.conf.idx[t]];null!=e&&e.parentNode.removeChild(e),e=null}this.conf.progress=!1,this._updateIdx()}},dhtmlXCellObject.prototype._adjustProgress=function(){if(null!=this.conf.idx.pr1){this.conf.pr||(this.conf.pr={});var t=this.cell.childNodes[this.conf.idx.pr1],e=this.cell.childNodes[this.conf.idx.pr2]||this.cell.childNodes[this.conf.idx.pr3];this.conf.pr.ofs||(e.style.width=t.offsetWidth+"px",e.style.height=t.offsetHeight+"px",this.conf.pr.ofs={w:e.offsetWidth-e.clientWidth,h:e.offsetHeight-e.clientHeight}),e.style.width=t.offsetWidth-this.conf.pr.ofs.w+"px",e.style.height=t.offsetHeight-this.conf.pr.ofs.h+"px",t=e=null}},dhtmlXCellObject.prototype._showCellCover=function(){if(1!=this.conf.cover){this.conf.cover=!0;var t=document.createElement("DIV");t.className=this.conf.idx_data.cover,this.cell.appendChild(t),t=null,this._updateIdx()}},dhtmlXCellObject.prototype._hideCellCover=function(){1==this.conf.cover&&(this.cell.removeChild(this.cell.childNodes[this.conf.idx.cover]),this._updateIdx(),this.conf.cover=!1)},dhtmlXCellObject.prototype._showBorders=function(t){this.conf.borders||(this.conf.borders=!0,this.cell.childNodes[this.conf.idx.cont].className="dhx_cell_cont"+this.conf.css,this.conf.cells_cont=null,this._mtbUpdBorder(),this.callEvent("_onBorderChange",[!0]),!0!==t&&this._adjustCont(this._idd))},dhtmlXCellObject.prototype._hideBorders=function(t){this.conf.borders&&(this.conf.borders=!1,this.cell.childNodes[this.conf.idx.cont].className="dhx_cell_cont"+this.conf.css+" dhx_cell_cont_no_borders",this.conf.cells_cont=null,this._mtbUpdBorder(),this.callEvent("_onBorderChange",[!1]),!0!==t&&this._adjustCont(this._idd))},dhtmlXCellObject.prototype._getWidth=function(){return this.cell.offsetWidth},dhtmlXCellObject.prototype._getHeight=function(){return this.cell.offsetHeight},dhtmlXCellObject.prototype.showInnerScroll=function(){this.cell.childNodes[this.conf.idx.cont].style.overflow="auto"},dhtmlXCellObject.prototype._unload=function(){for(var t in this.conf.unloading=!0,this.callEvent("_onCellUnload",[]),this.progressOff(),this.unloadView(this.conf.view),this.dataNodes=null,this.cell.parentNode.removeChild(this.cell),this.cell=null,window.dhx4._eventable(this,"clear"),this.views)this.unloadView(t);for(var t in this.conf=null,this)this[t]=null},dhtmlXCellObject.prototype.attachObject=function(t,e){if(!window.dhx4.s2b(e)||"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell||(e=!1),"string"==typeof t&&(t=document.getElementById(t)),t.parentNode!=this.cell.childNodes[this.conf.idx.cont]){if(e){t.style.display="";var n=t.offsetWidth,i=t.offsetHeight}this._attachObject(t),this.dataType="obj",t.style.display="",t=null,e&&this._adjustByCont(n,i)}else t=null},dhtmlXCellObject.prototype.appendObject=function(t){"string"==typeof t&&(t=document.getElementById(t)),t.parentNode!=this.cell.childNodes[this.conf.idx.cont]?(this.conf.append_mode||(this.cell.childNodes[this.conf.idx.cont].style.overflow="auto",this.conf.append_mode=!0),this._attachObject(t,null,null,!0),this.dataType="obj",t.style.display="",t=null):t=null},dhtmlXCellObject.prototype.detachObject=function(t,e){this._detachObject(null,t,e)},dhtmlXCellObject.prototype.getAttachedStatusBar=function(){return this.dataNodes.sb},dhtmlXCellObject.prototype.getAttachedObject=function(){return"obj"==this.dataType||"url"==this.dataType||"url-ajax"==this.dataType?this.cell.childNodes[this.conf.idx.cont].firstChild:this.dataObj},dhtmlXCellObject.prototype.attachURL=function(t,e,n){1==n&&(n={});var i=void 0!==n&&0!=n&&null!=n;if(null==this.conf.url_data&&(this.conf.url_data={}),this.conf.url_data.url=t,this.conf.url_data.ajax=1==e,this.conf.url_data.post_data=1==n?{}:n||null,null!=this.conf.url_data.xml_doc){try{this.conf.url_data.xml_doc.xmlDoc.abort()}catch(t){}this.conf.url_data.xml_doc.xmlDoc=null,this.conf.url_data.xml_doc=null}if(1==e){var a=this;if(i){var o="";for(var r in n)o+="&"+encodeURIComponent(r)+"="+encodeURIComponent(n[r]);this.conf.url_data.xml_doc=dhx4.ajax.post(t,o,function(t){null!=a.attachHTMLString&&"string"==typeof t.xmlDoc.responseText&&(a.attachHTMLString("<div style='position:relative;width:100%;height:100%;overflow:auto;'>"+t.xmlDoc.responseText+"</div>"),"function"==typeof a._doOnFrameContentLoaded&&a._doOnFrameContentLoaded(),a.dataType="url-ajax"),a=t=null})}else this.conf.url_data.xml_doc=dhx4.ajax.get(t,function(t){null!=a.attachHTMLString&&"string"==typeof t.xmlDoc.responseText&&(a.attachHTMLString("<div style='position:relative;width:100%;height:100%;overflow:auto;'>"+t.xmlDoc.responseText+"</div>"),"function"==typeof a._doOnFrameContentLoaded&&a._doOnFrameContentLoaded(),a.dataType="url-ajax"),a=t=null})}else{if("url"==this.dataType)var s=this.getFrame();else(s=document.createElement("IFRAME")).frameBorder=0,s.border=0,s.style.width="100%",s.style.height="100%",s.style.position="relative",this._attachObject(s),this.dataType="url",this._attachURLEvents();if(i){var l=void 0===this.conf.url_data.post_ifr;this.conf.url_data.post_ifr=!0,l&&this._attachURLEvents(),s.src="about:blank"}else s.src=t+window.dhx4.ajax._dhxr(t);s=null}s=null},dhtmlXCellObject.prototype.reloadURL=function(){"url"!=this.dataType&&"url-ajax"!=this.dataType||null!=this.conf.url_data&&this.attachURL(this.conf.url_data.url,this.conf.url_data.ajax,this.conf.url_data.post_data)},dhtmlXCellObject.prototype.attachHTMLString=function(t){this._attachObject(null,null,t);for(var e=t.match(/<script[^>]*>[^\f]*?<\/script>/g)||[],n=0;n<e.length;n++){var i=e[n].replace(/<([\/]{0,1})script[^>]*>/gi,"");i&&(window.execScript?window.execScript(i):window.eval(i))}},dhtmlXCellObject.prototype.attachScheduler=function(t,e,n,i){i=i||window.scheduler;var a=!1;n&&((o=document.getElementById(n))&&(a=!0));if(!a){var o,r=n||'<div class="dhx_cal_tab" name="day_tab" style="right:204px;"></div><div class="dhx_cal_tab" name="week_tab" style="right:140px;"></div><div class="dhx_cal_tab" name="month_tab" style="right:76px;"></div>';(o=document.createElement("DIV")).id="dhxSchedObj_"+(new Date).getTime(),o.style.width="100%",o.style.height="100%",o.style.position="relative",o.style.overflow="hidden",o.className="dhx_cal_container",o.innerHTML='<div class="dhx_cal_navline"><div class="dhx_cal_prev_button">&nbsp;</div><div class="dhx_cal_next_button">&nbsp;</div><div class="dhx_cal_today_button"></div><div class="dhx_cal_date"></div>'+r+'</div><div class="dhx_cal_header"></div><div class="dhx_cal_data"></div>'}return this._attachObject(o),this.dataType="scheduler",this.dataObj=i,this.dataObj.setSizes=function(){this.update_view()},i.init(o.id,t,e),o=null,this.callEvent("_onContentAttach",[]),this.dataObj},dhtmlXCellObject.prototype.attachMap=function(t){var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden",this._attachObject(e),t||(t={center:new google.maps.LatLng(40.719837,-73.992348),zoom:11,mapTypeId:google.maps.MapTypeId.ROADMAP}),this.dataType="maps",this.dataObj=new google.maps.Map(e,t),this.dataObj.setSizes=function(){google.maps.event.trigger(this,"resize")},e=null,this.callEvent("_onContentAttach",[]),this.dataObj},dhtmlXCellObject.prototype._createNode_sb=function(t,e,n,i,a){if(void 0!==a)t=a;else{var o=e||{},r="string"==typeof o.text&&o.text.length>0?o.text:"&nbsp;",s="number"==typeof o.height&&o.height;(t=document.createElement("DIV")).className="dhx_cell_statusbar_def",t.innerHTML="<div class='"+(1==o.paging?"dhx_cell_statusbar_paging":"dhx_cell_statusbar_text")+"'>"+r+"</div>",0!=s&&(t.firstChild.style.height=t.firstChild.style.lineHeight=s+"px")}return null!=this.conf.idx.pr1?this.cell.insertBefore(t,this.cell.childNodes[this.conf.idx.pr1]):this.cell.appendChild(t),this.conf.ofs_nodes.b.sb=!0,this._updateIdx(),this._adjustCont(this._idd),t},dhtmlXCellObject.prototype.attachStatusBar=function(t){if(!this.dataNodes.sb)return null!=t&&1==window.dhx4.s2b(t.paging)&&(t.height=null),"dhx_skyblue"==this.conf.skin&&"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell&&(this.cell.childNodes[this.conf.idx.cont].className+=" dhx_cell_statusbar_attached"),this.dataNodes.sb=this._attachObject("sb",t),this.dataNodes.sb.setText=function(t){this.childNodes[0].innerHTML=t},this.dataNodes.sb.getText=function(){return this.childNodes[0].innerHTML},this.dataNodes.sb.onselectstart=function(t){return!1},this.dataNodes.sb},dhtmlXCellObject.prototype.detachStatusBar=function(){this.dataNodes.sb&&("dhx_skyblue"==this.conf.skin&&"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell&&(this.cell.childNodes[this.conf.idx.cont].className=this.cell.childNodes[this.conf.idx.cont].className.replace(/\s{0,}dhx_cell_statusbar_attached/,"")),this.dataNodes.sb.setText=this.dataNodes.sb.getText=this.dataNodes.sb.onselectstart=null,this.dataNodes.sb=null,delete this.dataNodes.sb,this._detachObject("sb"))},dhtmlXCellObject.prototype.showStatusBar=function(){this._mtbShowHide("sb","")},dhtmlXCellObject.prototype.hideStatusBar=function(){this._mtbShowHide("sb","none")},dhtmlXCellObject.prototype._mtbShowHide=function(t,e){this.dataNodes[t]&&(this.cell.childNodes[this.conf.idx[t]].style.display=e,this._adjustCont())},dhtmlXCellObject.prototype.getFrame=dhtmlXCellObject.prototype._getFrame=function(){return"url"!=this.dataType?null:this.cell.childNodes[this.conf.idx.cont].firstChild},dhtmlXCellObject.prototype._attachURLEvents=function(){if("url"==this.dataType){var t=this,e=this._idd,n=this.cell.childNodes[this.conf.idx.cont].firstChild;"function"!=typeof this._doOnFrameMouseDown&&(this._doOnFrameMouseDown=function(n){t.callEvent("_onContentMouseDown",[e,n||event])}),"function"==typeof window.addEventListener?n.onload=function(){try{"function"==typeof t._doOnFrameMouseDown&&this.contentWindow.document.body.addEventListener("mousedown",t._doOnFrameMouseDown,!1)}catch(t){}try{"function"==typeof t._doOnFrameContentLoaded&&t._doOnFrameContentLoaded()}catch(t){}}:n.onreadystatechange=function(e){if("complete"==this.readyState){try{"function"==typeof t._doOnFrameMouseDown&&this.contentWindow.document.body.attachEvent("onmousedown",t._doOnFrameMouseDown)}catch(t){}try{"function"==typeof t._doOnFrameContentLoaded&&t._doOnFrameContentLoaded()}catch(t){}}}}},dhtmlXCellObject.prototype._doOnFrameContentLoaded=function(){if(1==this.conf.url_data.post_ifr){var t=this.getFrame().contentWindow.document,e=t.createElement("FORM");e.method="POST",e.action=this.conf.url_data.url,t.body.appendChild(e);var n={};for(var i in 1!=window.dhx4.ajax.cache&&(n["dhxr"+(new Date).getTime()]="1"),this.conf.url_data.post_data)n[i]=this.conf.url_data.post_data[i];for(var i in n){var a=t.createElement("INPUT");a.type="hidden",a.name=i,a.value=n[i],e.appendChild(a),a=null}this.conf.url_data.post_ifr=!1,e.submit()}else this.callEvent("_onContentLoaded",[this._idd])},dhtmlXCellObject.prototype._detachURLEvents=function(t){if(null==t){if("url"!=this.dataType)return;t=this.cell.childNodes[this.conf.idx.cont].firstChild}if(t){if("function"==typeof window.addEventListener){t.onload=null;try{t.contentWindow.document.body.removeEventListener("mousedown",this._doOnFrameMouseDown,!1)}catch(t){}}else{t.onreadystatechange=null;try{t.contentWindow.document.body.detachEvent("onmousedown",this._doOnFrameMouseDown)}catch(t){}}t=null}},dhtmlXCellObject.prototype._attachObject=function(t,e,n,i,a){if("string"==typeof t&&1=={menu:1,toolbar:1,ribbon:1,sb:1}[t])return this["_createNode_"+t].apply(this,arguments);1!=i&&this._detachObject(null,!0,null),"string"==typeof n?this.cell.childNodes[this.conf.idx.cont].innerHTML=n:this.cell.childNodes[this.conf.idx.cont].appendChild(t),t=null},dhtmlXCellObject.prototype._detachObject=function(t,e,n){if(this.callEvent("_onBeforeContentDetach",[]),"menu"==t||"toolbar"==t||"ribbon"==t||"sb"==t)return(i=this.cell.childNodes[this.conf.idx[t]]).parentNode.removeChild(i),i=null,this.conf.ofs_nodes["sb"==t?"b":"t"][t]=!1,this._updateIdx(),void(this.conf.unloading||this._adjustCont(this._idd));if(1==e?n=!1:void 0===n?n=document.body:"string"==typeof n&&(n=document.getElementById(n)),!1===n){if(1==this.conf.unloading&&null!=String(this.dataType).match(/ajax/)&&null!=this.conf.url_data&&null!=this.conf.url_data.xml_doc){try{this.conf.url_data.xml_doc.xmlDoc.abort()}catch(t){}this.conf.url_data.xml_doc.xmlDoc=null,this.conf.url_data.xml_doc=null}"url"==this.dataType?this._detachURLEvents():null!=this.dataObj&&("function"==typeof this.dataObj.unload?this.dataObj.unload():"function"==typeof this.dataObj.destructor&&this.dataObj.destructor())}for(var i=this.cell.childNodes[this.conf.idx.cont];i.childNodes.length>0;)!1===n?i.removeChild(i.lastChild):(i.firstChild.style.display="none",n.appendChild(i.firstChild));this.conf.append_mode&&(i.style.overflow="",this.conf.append_mode=!1);var a="tabbar"==this.dataType;this.dataObj=null,this.dataType=null,n=i=null,1!=this.conf.unloading&&a&&(this.showHeader(!0),this._showBorders())},dhtmlXCellObject.prototype._attachFromCell=function(t){this.detachObject(!0);var e="layout";for(var n in"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell&&(e="window"),"function"==typeof window.dhtmlXWindowsCell&&t instanceof window.dhtmlXWindowsCell&&1==t.wins.w[t._idd].conf.parked&&t.wins._winCellSetOpacity(t._idd,"open",!1),"function"==typeof window.dhtmlXAccordionCell&&t instanceof window.dhtmlXAccordionCell&&0==t.conf.opened&&t._cellSetOpacity("open",!1),t.dataNodes)this._attachObject(n,null,null,null,t.cell.childNodes[t.conf.idx[n]]),this.dataNodes[n]=t.dataNodes[n],t.dataNodes[n]=null,t.conf.ofs_nodes["sb"==n?"b":"t"][n]=!1,t._updateIdx();if(this._mtbUpdBorder(),null!=t.dataType&&null!=t.dataObj){for(this.dataType=t.dataType,this.dataObj=t.dataObj;t.cell.childNodes[t.conf.idx.cont].childNodes.length>0;)this.cell.childNodes[this.conf.idx.cont].appendChild(t.cell.childNodes[t.conf.idx.cont].firstChild);t.dataType=null,t.dataObj=null,"grid"==this.dataType&&("window"==e&&"dhx_skyblue"==this.conf.skin?(this.dataObj.entBox.style.border="1px solid #a4bed4",this.dataObj._sizeFix=0):(this.dataObj.entBox.style.border="0px solid white",this.dataObj._sizeFix=2))}else for(;t.cell.childNodes[t.conf.idx.cont].childNodes.length>0;)this.cell.childNodes[this.conf.idx.cont].appendChild(t.cell.childNodes[t.conf.idx.cont].firstChild);for(var n in this.conf.view=t.conf.view,t.conf.view="def",t.views)this.views[n]=t.views[n],t.views[n]=null,delete t.views[n];t._updateIdx(),t._adjustCont(),this._updateIdx(),this._adjustCont(),1==t.conf.progress?(t.progressOff(),this.progressOn()):this.progressOff(),"window"==e&&this.wins.w[this._idd].conf.parked&&this.wins._winCellSetOpacity(this._idd,"close",!1)},dhtmlXCellTop.prototype.setOffsets=function(t,e){var n=!1;for(var i in t){var a=i.charAt(0);void 0===this.conf.ofs[a]||isNaN(t[i])||(this.conf.ofs[a]=parseInt(t[i]),n=!0)}!1!==e&&"function"==typeof this.setSizes&&1==n&&this.setSizes()},dhtmlXCellTop.prototype.attachMenu=function(t){if(null==this.dataNodes.menu)return this.dataNodes.menuObj=document.createElement("DIV"),this.dataNodes.menuObj.className="dhxcelltop_menu",this.base.insertBefore(this.dataNodes.menuObj,this.dataNodes.toolbarObj||this.dataNodes.ribbonObj||this.cont),"object"==typeof t&&null!=t||(t={}),t.skin=this.conf.skin,t.parent=this.dataNodes.menuObj,this.dataNodes.menu=new dhtmlXMenuObject(t),this.dataNodes.menuEv=this.attachEvent("_onSetSizes",function(){"none"!=this.dataNodes.menuObj.style.display&&(null==this.conf.ofs_menu&&(this.dataNodes.menuObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px",this.conf.ofs_menu={w:this.dataNodes.menuObj.offsetWidth-parseInt(this.dataNodes.menuObj.style.width)}),this.dataNodes.menuObj.style.left=this.conf.ofs.l+"px",this.dataNodes.menuObj.style.marginTop=(null!=this.dataNodes.haObj?0:this.conf.ofs.t)+"px",this.dataNodes.menuObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r-this.conf.ofs_menu.w+"px")}),this.conf.ofs_nodes.t.menuObj=!0,this.setSizes(),t.parnt=null,t=null,this.dataNodes.menu},dhtmlXCellTop.prototype.detachMenu=function(){null!=this.dataNodes.menu&&(this.dataNodes.menu.unload(),this.dataNodes.menu=null,this.dataNodes.menuObj.parentNode.removeChild(this.dataNodes.menuObj),this.dataNodes.menuObj=null,this.detachEvent(this.dataNodes.menuEv),this.dataNodes.menuEv=null,delete this.dataNodes.menu,delete this.dataNodes.menuObj,delete this.dataNodes.menuEv,this.conf.ofs_nodes.t.menuObj=!1,this.conf.unloading||this.setSizes())},dhtmlXCellTop.prototype.attachToolbar=function(t){if(null==this.dataNodes.ribbon&&null==this.dataNodes.toolbar)return this.dataNodes.toolbarObj=document.createElement("DIV"),this.dataNodes.toolbarObj.className="dhxcelltop_toolbar",this.base.insertBefore(this.dataNodes.toolbarObj,this.cont),this.dataNodes.toolbarObj.appendChild(document.createElement("DIV")),"object"==typeof t&&null!=t||(t={}),t.skin=this.conf.skin,t.parent=this.dataNodes.toolbarObj.firstChild,this.dataNodes.toolbar=new dhtmlXToolbarObject(t),this.dataNodes.toolbarEv=this.attachEvent("_onSetSizes",function(){"none"!=this.dataNodes.toolbarObj.style.display&&(this.dataNodes.toolbarObj.style.left=this.conf.ofs.l+"px",this.dataNodes.toolbarObj.style.marginTop=(null!=this.dataNodes.haObj||null!=this.dataNodes.menuObj?0:this.conf.ofs.t)+"px",this.dataNodes.toolbarObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px")}),this.dataNodes.toolbar._masterCell=this,this.dataNodes.toolbar.attachEvent("_onIconSizeChange",function(){this._masterCell.setSizes()}),this.conf.ofs_nodes.t.toolbarObj=!0,this.setSizes(),t.parnt=null,t=null,this.dataNodes.toolbar},dhtmlXCellTop.prototype.detachToolbar=function(){null!=this.dataNodes.toolbar&&(this.dataNodes.toolbar._masterCell=null,this.dataNodes.toolbar.unload(),this.dataNodes.toolbar=null,this.dataNodes.toolbarObj.parentNode.removeChild(this.dataNodes.toolbarObj),this.dataNodes.toolbarObj=null,this.detachEvent(this.dataNodes.toolbarEv),this.dataNodes.toolbarEv=null,this.conf.ofs_nodes.t.toolbarObj=!1,delete this.dataNodes.toolbar,delete this.dataNodes.toolbarObj,delete this.dataNodes.toolbarEv,this.conf.unloading||this.setSizes())},dhtmlXCellTop.prototype.attachRibbon=function(t){if(null==this.dataNodes.ribbon&&null==this.dataNodes.toolbar){this.dataNodes.ribbonObj=document.createElement("DIV"),this.dataNodes.ribbonObj.className="dhxcelltop_ribbon",this.base.insertBefore(this.dataNodes.ribbonObj,this.cont),this.dataNodes.ribbonObj.appendChild(document.createElement("DIV")),"object"==typeof t&&null!=t||(t={}),t.skin=this.conf.skin,t.parent=this.dataNodes.ribbonObj.firstChild,this.dataNodes.ribbon=new dhtmlXRibbon(t),this.dataNodes.ribbonEv=this.attachEvent("_onSetSizes",function(){"none"!=this.dataNodes.ribbonObj.style.display&&(this.dataNodes.ribbonObj.style.left=this.conf.ofs.l+"px",this.dataNodes.ribbonObj.style.marginTop=(null!=this.dataNodes.haObj||null!=this.dataNodes.menuObj?0:this.conf.ofs.t)+"px",this.dataNodes.ribbonObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px",this.dataNodes.ribbon.setSizes())}),this.conf.ofs_nodes.t.ribbonObj=!0;var e=this;return this.dataNodes.ribbon.attachEvent("_onHeightChanged",function(){e.setSizes()}),this.setSizes(),t.parnt=null,t=null,this.dataNodes.ribbon}},dhtmlXCellTop.prototype.detachRibbon=function(){null!=this.dataNodes.ribbon&&(this.dataNodes.ribbon.unload(),this.dataNodes.ribbon=null,this.dataNodes.ribbonObj.parentNode.removeChild(this.dataNodes.ribbonObj),this.dataNodes.ribbonObj=null,this.detachEvent(this.dataNodes.ribbonEv),this.dataNodes.ribbonEv=null,this.conf.ofs_nodes.t.ribbonObj=!1,delete this.dataNodes.ribbon,delete this.dataNodes.ribbonObj,delete this.dataNodes.ribbonEv,this.conf.unloading||this.setSizes())},dhtmlXCellTop.prototype.attachStatusBar=function(t){if(!this.dataNodes.sbObj)return void 0===t&&(t={}),this.dataNodes.sbObj=document.createElement("DIV"),this.dataNodes.sbObj.className="dhxcelltop_statusbar",null!=this.cont.nextSibling?this.base.insertBefore(this.dataNodes.sbObj,this.cont.nextSibling):this.base.appendChild(this.dataNodes.sbObj),this.dataNodes.sbObj.innerHTML="<div class='dhxcont_statusbar'>"+("string"==typeof t.text&&t.text.length>0?t.text:"&nbsp;")+"</div>","number"==typeof t.height&&(this.dataNodes.sbObj.firstChild.style.height=this.dataNodes.sbObj.firstChild.style.lineHeight=t.height+"px"),this.dataNodes.sbObj.setText=function(t){this.childNodes[0].innerHTML=t},this.dataNodes.sbObj.getText=function(){return this.childNodes[0].innerHTML},this.dataNodes.sbObj.onselectstart=function(t){return!1},this.dataNodes.sbEv=this.attachEvent("_onSetSizes",function(){"none"!=this.dataNodes.sbObj.style.display&&(this.dataNodes.sbObj.style.left=this.conf.ofs.l+"px",this.dataNodes.sbObj.style.bottom=(null!=this.dataNodes.faObj?this.dataNodes.faObj.offsetHeight:0)+this.conf.ofs.t+"px",this.dataNodes.sbObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px")}),this.conf.ofs_nodes.b.sbObj=!0,this.setSizes(),this.dataNodes.sbObj},dhtmlXCellTop.prototype.detachStatusBar=function(){this.dataNodes.sbObj&&(this.dataNodes.sbObj.setText=this.dataNodes.sbObj.getText=this.dataNodes.sbObj.onselectstart=null,this.dataNodes.sbObj.parentNode.removeChild(this.dataNodes.sbObj),this.dataNodes.sbObj=null,this.detachEvent(this.dataNodes.sbEv),this.dataNodes.sbEv=null,this.conf.ofs_nodes.b.sbObj=!1,delete this.dataNodes.sb,delete this.dataNodes.sbObj,delete this.dataNodes.sbEv,this.conf.unloading||this.setSizes())},dhtmlXCellTop.prototype.showMenu=function(){this._mtbShowHide("menuObj","")},dhtmlXCellTop.prototype.hideMenu=function(){this._mtbShowHide("menuObj","none")},dhtmlXCellTop.prototype.showToolbar=function(){this._mtbShowHide("toolbarObj","")},dhtmlXCellTop.prototype.hideToolbar=function(){this._mtbShowHide("toolbarObj","none")},dhtmlXCellTop.prototype.showRibbon=function(){this._mtbShowHide("ribbonObj","")},dhtmlXCellTop.prototype.hideRibbon=function(){this._mtbShowHide("ribbonObj","none")},dhtmlXCellTop.prototype.showStatusBar=function(){this._mtbShowHide("sbObj","")},dhtmlXCellTop.prototype.hideStatusBar=function(){this._mtbShowHide("sbObj","none")},dhtmlXCellTop.prototype._mtbShowHide=function(t,e){null!=this.dataNodes[t]&&(this.dataNodes[t].style.display=e,this.setSizes())},dhtmlXCellTop.prototype._mtbUnload=function(t,e){this.detachMenu(),this.detachToolbar(),this.detachStatusBar(),this.detachRibbon()},dhtmlXCellTop.prototype.getAttachedMenu=function(){return this.dataNodes.menu},dhtmlXCellTop.prototype.getAttachedToolbar=function(){return this.dataNodes.toolbar},dhtmlXCellTop.prototype.getAttachedRibbon=function(){return this.dataNodes.ribbon},dhtmlXCellTop.prototype.getAttachedStatusBar=function(){return this.dataNodes.sbObj},dhtmlXCellTop.prototype.progressOn=function(){if(!this.conf.progress){this.conf.progress=!0;var t=document.createElement("DIV");t.className="dhxcelltop_progress",this.base.appendChild(t);var e=document.createElement("DIV");if("material"==this.conf.skin&&(window.dhx4.isFF||window.dhx4.isChrome||window.dhx4.isOpera||window.dhx4.isEdge))e.className="dhxcelltop_progress_svg",e.innerHTML='<svg class="dhx_cell_prsvg" viewBox="25 25 50 50"><circle class="dhx_cell_prcircle" cx="50" cy="50" r="20"/></svg>';else(e=document.createElement("DIV")).className="dhxcelltop_progress_img";this.base.appendChild(e),t=e=null}},dhtmlXCellTop.prototype.progressOff=function(){if(this.conf.progress){for(var t={dhxcelltop_progress:!0,dhxcelltop_progress_img:!0,dhxcelltop_progress_svg:!0},e=0;e<this.base.childNodes.length;e++)void 0!==this.base.childNodes[e].className&&1==t[this.base.childNodes[e].className]&&(t[this.base.childNodes[e].className]=this.base.childNodes[e]);for(var n in t)1!=t[n]&&this.base.removeChild(t[n]),t[n]=null;this.conf.progress=!1,t=null}},dhtmlXCellTop.prototype.attachHeader=function(t,e){null==this.dataNodes.haObj&&("object"!=typeof t&&(t=document.getElementById(t)),this.dataNodes.haObj=document.createElement("DIV"),this.dataNodes.haObj.className="dhxcelltop_hdr",this.dataNodes.haObj.style.height=(e||t.offsetHeight)+"px",this.base.insertBefore(this.dataNodes.haObj,this.dataNodes.menuObj||this.dataNodes.toolbarObj||this.cont),this.dataNodes.haObj.appendChild(t),t.style.visibility="visible",t=null,this.dataNodes.haEv=this.attachEvent("_onSetSizes",function(){this.dataNodes.haObj.style.left=this.conf.ofs.l+"px",this.dataNodes.haObj.style.marginTop=this.conf.ofs.t+"px",this.dataNodes.haObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px"}),this.conf.ofs_nodes.t.haObj=!0,this.setSizes())},dhtmlXCellTop.prototype.detachHeader=function(){if(this.dataNodes.haObj){for(;this.dataNodes.haObj.childNodes.length>0;)this.dataNodes.haObj.lastChild.style.visibility="hidden",document.body.appendChild(this.dataNodes.haObj.lastChild);this.dataNodes.haObj.parentNode.removeChild(this.dataNodes.haObj),this.dataNodes.haObj=null,this.detachEvent(this.dataNodes.haEv),this.dataNodes.haEv=null,this.conf.ofs_nodes.t.haObj=!1,delete this.dataNodes.haEv,delete this.dataNodes.haObj,this.conf.unloading||this.setSizes()}},dhtmlXCellTop.prototype.attachFooter=function(t,e){if(null==this.dataNodes.faObj){"object"!=typeof t&&(t=document.getElementById(t)),this.dataNodes.faObj=document.createElement("DIV"),this.dataNodes.faObj.className="dhxcelltop_ftr",this.dataNodes.faObj.style.height=(e||t.offsetHeight)+"px";var n=this.dataNodes.sbObj||this.cont;this.base.lastChild==n?this.base.appendChild(this.dataNodes.faObj):this.base.insertBefore(this.dataNodes.faObj,n.nextSibling),this.dataNodes.faEv=this.attachEvent("_onSetSizes",function(){this.dataNodes.faObj.style.left=this.conf.ofs.l+"px",this.dataNodes.faObj.style.bottom=this.conf.ofs.b+"px",this.dataNodes.faObj.style.width=this.base.offsetWidth-this.conf.ofs.l-this.conf.ofs.r+"px"}),this.dataNodes.faObj.appendChild(t),t.style.visibility="visible",n=t=null,this.conf.ofs_nodes.b.faObj=!0,this.setSizes()}},dhtmlXCellTop.prototype.detachFooter=function(){if(this.dataNodes.faObj){for(;this.dataNodes.faObj.childNodes.length>0;)this.dataNodes.faObj.lastChild.style.visibility="hidden",document.body.appendChild(this.dataNodes.faObj.lastChild);this.dataNodes.faObj.parentNode.removeChild(this.dataNodes.faObj),this.dataNodes.faObj=null,this.detachEvent(this.dataNodes.faEv),this.dataNodes.faEv=null,this.conf.ofs_nodes.b.faObj=!1,delete this.dataNodes.faEv,delete this.dataNodes.faObj,this.conf.unloading||this.setSizes()}},dhtmlXCalendarObject.prototype.lang="en",dhtmlXCalendarObject.prototype.langData={en:{dateformat:"%Y-%m-%d",hdrformat:"%F %Y",monthesFNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthesSNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],daysFNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysSNames:["Su","Mo","Tu","We","Th","Fr","Sa"],weekstart:1,weekname:"w",today:"Today",clear:"Clear"}},dhtmlXCalendarObject.prototype._buildMonthHdr=function(t){var e=this,n=function(t){return 1==String(t).length?"0"+String(t):t},i=function(t,e){return"<span class='dhtmlxcalendar_month_label_"+t+"'>"+e+"</span>"},a=String(this.langData[this.lang].hdrformat||"%F %Y").replace(/%[a-z]/gi,function(a){switch(a){case"%m":return i("month",n(t.getMonth()+1));case"%n":return i("month",t.getMonth()+1);case"%M":return i("month",e.langData[e.lang].monthesSNames[t.getMonth()]);case"%F":return i("month",e.langData[e.lang].monthesFNames[t.getMonth()]);case"%y":return i("year",n(t.getYear()%100));case"%Y":return i("year",t.getFullYear());case"%%":return"%";default:return a}});return e=n=i=null,a},dhtmlXCalendarObject.prototype.enableIframe=function(t){1==t?this._ifr||(this._ifr=document.createElement("IFRAME"),this._ifr.frameBorder=0,this._ifr.border=0,this._ifr.setAttribute("src","javascript:false;"),this._ifr.className="dhtmlxcalendar_ifr",this._ifr.onload=function(){this.onload=null,this.contentWindow.document.open("text/html","replace"),this.contentWindow.document.write("<html><head><style>html,body{width:100%;height:100%;overflow:hidden;margin:0px;}</style></head><body</body></html>")},this.base.parentNode.insertBefore(this._ifr,this.base),this._ifrSize()):this._ifr&&(this._ifr.parentNode.removeChild(this._ifr),this._ifr=null)},dhtmlXCalendarObject.prototype._ifrSize=function(){this._ifr&&(this._ifr.style.left=this.base.style.left,this._ifr.style.top=this.base.style.top,this._ifr.style.width=this.base.offsetWidth+"px",this._ifr.style.height=this.base.offsetHeight+"px")},dhtmlxCalendarObject=dhtmlXCalendarObject,dhtmlXCalendarObject.prototype._dateStrings=function(){var t=this.langData[this.lang];return{monthFullName:t.monthesFNames,monthShortName:t.monthesSNames,dayFullName:t.daysFNames,dayShortName:t.daysSNames}},dhtmlXCalendarObject.prototype._strToDate=function(t,e){return window.dhx4.str2date(t,e||this._dateFormat,this._dateStrings())},dhtmlXCalendarObject.prototype._dateToStr=function(t,e){return window.dhx4.date2str(t,e||this._dateFormat,this._dateStrings())},window.dhtmlxDblCalendarObject=window.dhtmlXDoubleCalendarObject=window.dhtmlXDoubleCalendar=function(t){var e=this;return this.leftCalendar=new dhtmlXCalendarObject(t),this.leftCalendar.hideTime(),this.rightCalendar=new dhtmlXCalendarObject(t),this.rightCalendar.hideTime(),this.leftCalendar.attachEvent("onClick",function(t){e._updateRange("rightCalendar",t,null),e._evOnClick(["left",t])}),this.rightCalendar.attachEvent("onClick",function(t){e._updateRange("leftCalendar",null,t),e._evOnClick(["right",t])}),this.leftCalendar.attachEvent("onBeforeChange",function(t){return e._evOnBeforeChange(["left",t])}),this.rightCalendar.attachEvent("onBeforeChange",function(t){return e._evOnBeforeChange(["right",t])}),this.show=function(){this.leftCalendar.show(),this.rightCalendar.base.style.marginLeft=this.leftCalendar.base.offsetWidth-1+"px",this.rightCalendar.show()},this.hide=function(){this.leftCalendar.hide(),this.rightCalendar.hide()},this.setDateFormat=function(t){this.leftCalendar.setDateFormat(t),this.rightCalendar.setDateFormat(t)},this.setDates=function(t,e){null!=t&&this.leftCalendar.setDate(t),null!=e&&this.rightCalendar.setDate(e),this._updateRange()},this._updateRange=function(t,e,n){3==arguments.length?("leftCalendar"==t?this.leftCalendar:this.rightCalendar).setSensitiveRange(e,n):(this.leftCalendar.setSensitiveRange(null,this.rightCalendar.getDate()),this.rightCalendar.setSensitiveRange(this.leftCalendar.getDate(),null))},this.getFormatedDate=function(){return this.leftCalendar.getFormatedDate.apply(this.leftCalendar,arguments)},this.unload=function(){window.dhx4._eventable(this,"clear"),this.leftCalendar.unload(),this.rightCalendar.unload(),this.leftCalendar=this.rightCalendar=null,this._updateRange=null,this._evOnClick=null,this._evOnBeforeChange=null,this.show=null,this.hide=null,this.setDateFormat=null,this.setDates=null,this.getFormatedDate=null,this.unload=null,e=null},this._evOnClick=function(t){return this.callEvent("onClick",t)},this._evOnBeforeChange=function(t){return this.callEvent("onBeforeChange",t)},window.dhx4._eventable(this),this},dhtmlXCombo.prototype.setName=function(t){this.conf.form_name=t,this.base.childNodes[1].name=t,this.base.childNodes[2].name=t.replace(/(\[.*)?$/,"_new_value$1")},dhtmlXCombo.prototype.readonly=function(t){window.dhx4.s2b(t)?(this.base.firstChild.setAttribute("readOnly","true"),this.conf.ro_mode=!0):(this.base.firstChild.removeAttribute("readOnly"),this.conf.ro_mode=!1)},dhtmlXCombo.prototype.setPlaceholder=function(t){void 0!==t&&null!=t||(t=""),this.base.firstChild.setAttribute("placeholder",String(t))},dhtmlXCombo.prototype.setTemplate=function(t){for(var e in t)void 0!==this.conf.template[e]&&(this.conf.template[e]="header"==e?window.dhx4.s2b(t[e]):String(t[e]));for(var e in null!=t.columns?this._mcMakeTemplate(t.columns):this._mcDetachHeader(),this.t)this.t[e].obj.setText(this.t[e].item,this.t[e].item._conf.text);this._confirmSelect("template")},dhtmlXCombo.prototype.setSkin=function(t){t!=this.conf.skin&&(this.conf.skin=t,this.base.className="dhxcombo_"+this.conf.skin+(this.conf.enabled?"":" dhxcombo_disabled"),this.list.className="dhxcombolist_"+this.conf.skin+(null!=this.hdr?" dhxcombolist_multicolumn":""),null!=this.hdr&&(this.hdr.className="dhxcombolist_"+this.conf.skin+" dhxcombolist_hdr"),this.conf.i_ofs="material"==t?26:23,this._adjustBase())},dhtmlXCombo.prototype.getInput=function(){return this.base.firstChild},dhtmlXCombo.prototype.getButton=function(){return this.base.childNodes[this.base.childNodes.length-(this.conf.combo_image?2:1)]},dhtmlXCombo.prototype.getList=function(){return this.list},dhtmlXCombo.prototype.getBase=function(){return this.base},dhtmlXCombo.prototype.getParent=function(){return this.DOMParent},dhtmlXCombo.prototype.forEachOption=function(t){for(var e=0;e<this.list.childNodes.length;e++)t.apply(window,[this._getOption(this.list.childNodes[e]._optId,e)])},dhtmlXCombo.prototype.setFocus=function(){this.conf.enabled&&this.base.firstChild.focus()},dhtmlXCombo.prototype.setFontSize=function(t,e){null!=t&&(this.base.firstChild.style.fontSize=t),null!=e&&(this.list.style.fontSize=e)},dhtmlXCombo.prototype.getOption=function(t){for(var e=null,n=null,i=0;i<this.list.childNodes.length;i++)if(null==e){var a=this.list.childNodes[i]._optId;this.t[a].obj.getValue(this.t[a].item)==t&&(e=a,n=i)}return null==e?null:this._getOption(e,n)},dhtmlXCombo.prototype.getOptionByIndex=function(t){return t<0?null:null==this.list.childNodes[t]?null:this._getOption(this.list.childNodes[t]._optId,t)},dhtmlXCombo.prototype.getOptionByLabel=function(t){for(var e=null,n=null,i=0;i<this.list.childNodes.length;i++)if(null==e){var a=this.list.childNodes[i]._optId;this.t[a].obj.getText(this.t[a].item,!0)==t&&(e=a,n=i)}return null==e?null:this._getOption(e,n)},dhtmlXCombo.prototype.getSelectedIndex=function(){return this._getOptionProp(this.conf.last_selected,"index",-1)},dhtmlXCombo.prototype.getSelectedText=function(){return this._getOptionProp(this.conf.last_selected,"text","")},dhtmlXCombo.prototype.getSelectedValue=function(){return this._getOptionProp(this.conf.temp_selected||this.conf.last_selected,"value",null)},dhtmlXCombo.prototype.getActualValue=function(){return this.base.childNodes[1].value},dhtmlXCombo.prototype.getComboText=function(){return this.base.childNodes[0].value},dhtmlXCombo.prototype.getIndexByValue=function(t){var e=this.getOption(t);return null!=e?e.index:-1},dhtmlXCombo.prototype.setComboText=function(t){1==this.conf.allow_free_text&&(this.unSelectOption(),this.conf.last_text=this.base.firstChild.value=t,this.conf.f_server_last=this.base.firstChild.value.toLowerCase())},dhtmlXCombo.prototype.setComboValue=function(t){var e=this.getOption(t);null!=e?this.selectOption(e.index):(this.conf.last_value=t,this.base.childNodes[1].value=this.conf.last_value,this.base.childNodes[2].value="true")},dhtmlXCombo.prototype.selectOption=function(t,e,n){if(!(t<0||t>=this.list.childNodes.length)){var i=this.list.childNodes[t]._optId;this._setSelected(i,this._isListVisible(),!0),this._confirmSelect("script")}},dhtmlXCombo.prototype.unSelectOption=function(){null!=this.conf.last_hover&&(this.t[this.conf.last_hover].obj.setSelected(this.t[this.conf.last_hover].item,!1),this.conf.last_hover=null),this.base.firstChild.value="",0!=this.conf.f_mode&&this._filterOpts(!0),this._hideList(),this._updateTopImage(null),this._confirmSelect("script")},dhtmlXCombo.prototype.confirmValue=function(){this._confirmSelect("script")},dhtmlXCombo.prototype.enable=function(t){t=void 0===t||window.dhx4.s2b(t),this.conf.enabled!=t&&(this.conf.enabled=t,t?(this.base.className="dhxcombo_"+this.conf.skin,this.base.firstChild.removeAttribute("disabled")):(this._hideList(),this.base.className="dhxcombo_"+this.conf.skin+" dhxcombo_disabled",this.base.firstChild.setAttribute("disabled","true")),this._updateTopImage(this.conf.last_selected))},dhtmlXCombo.prototype.disable=function(t){t=void 0===t||window.dhx4.s2b(t),this.enable(!t)},dhtmlXCombo.prototype.isEnabled=function(){return 1==this.conf.enabled},dhtmlXCombo.prototype.show=function(t){t=void 0===t||window.dhx4.s2b(t),this.base.style.display=1==t?"":"none"},dhtmlXCombo.prototype.hide=function(t){void 0===t&&(t=!0),this.show(!t)},dhtmlXCombo.prototype.isVisible=function(){return""==this.base.style.display},dhtmlXCombo.prototype.setFilterHandler=function(t){"function"==typeof t?(this.conf.f_func=t,this.conf.f_mode=!0,this.conf.f_dyn=this.conf.f_cache=this.conf.f_url=null):"string"==typeof t&&"function"==typeof window[t]?(this.conf.f_func=window[t],this.conf.f_mode=!0,this.conf.f_dyn=this.conf.f_cache=this.conf.f_url=null):this.conf.f_func=null},dhtmlXCombo.prototype.enableFilteringMode=function(t,e,n,i){1==t||"between"==t?(this.conf.f_mode=1==t?"start":"between",e?(this.conf.f_url=e,this.conf.f_cache=window.dhx4.s2b(n),this.conf.f_dyn=window.dhx4.s2b(i)):(this.conf.f_url=null,this.conf.f_cache=!1,this.conf.f_dyn=!1)):(this.conf.f_mode=!1,this.conf.f_url=null,this.conf.f_cache=!1,this.conf.f_dyn=!1)},dhtmlXCombo.prototype.filter=function(t,e){for(var n=0;n<this.list.childNodes.length;n++){var i=t.apply(window,[this._getOption(this.list.childNodes[n]._optId,n)]);this.list.childNodes[n].style.display=!0===i?"":"none"}void 0!==e&&1!=e||this._showList(!0)},dhtmlXCombo.prototype.sort=function(t){for(var e=[],n=0;n<this.list.childNodes.length;n++){var i=this.list.childNodes[n]._optId;e.push([i,this._getOption(i,n)])}for("asc"==t||"desc"==t?(k=!0,e.sort(function(e,n){e=e[1].text_option.toLowerCase(),n=n[1].text_option.toLowerCase();var i="asc"==t?1:-1;return e>n?i:-1*i})):"function"!=typeof t&&"function"!=typeof window[t]||("function"==typeof window[t]&&(t=window[t]),e.sort(function(e,n){return t.apply(window,[e[1],n[1]])}));this.list.childNodes.length>0;)this.list.removeChild(this.list.lastChild);for(n=0;n<e.length;n++)this.list.appendChild(this.t[e[n][0]].item)},dhtmlXCombo.prototype.enableAutocomplete=function(t){t=void 0===t||window.dhx4.s2b(t),this.conf.f_ac=t},dhtmlXCombo.prototype.disableAutocomplete=function(t){t=void 0===t||window.dhx4.s2b(t),this.enableAutocomplete(!t)},dhtmlXCombo.prototype.allowFreeText=function(t,e){this.conf.allow_free_text=void 0===t||window.dhx4.s2b(t),this.conf.free_text_empty=void 0!==e&&window.dhx4.s2b(e)},dhtmlXCombo.prototype._checkForMatch=function(t){for(var e=window.dhx4.trim(this.base.firstChild.value).toLowerCase(),n=null,i=this.list.firstChild;null!=i;){if(""==i.style.display&&null!=i._optId)e==window.dhx4.trim(this.t[i._optId].obj.getText(i,!0)).toLowerCase()&&(n=i._optId,i=null);null!=i&&(i=i.nextSibling)}null==this.conf.last_match?null!=n?(this._setSelected(n,!0,!0),this.conf.last_match=n):"between"==this.conf.f_mode&&1!=t||(this._setSelected(null,!0,!0),this.conf.last_match=null):null!=n?n!=this.conf.last_match&&(this._setSelected(n,!0,!0),this.conf.last_match=n):(this._setSelected(null,!0,!0),this.conf.last_match=null)},dhtmlXCombo.prototype._selectRange=function(t,e){1==this.conf.combo_focus&&window.dhx4.selectTextRange(this.base.firstChild,t,e)},dhtmlXCombo.prototype.openSelect=function(){this._isListVisible()||this._showList()},dhtmlXCombo.prototype.closeAll=function(){this._hideList()},dhtmlXCombo.prototype._showList=function(t){if(0!=this._getListVisibleCount())if(this._isListVisible())this._checkListHeight();else{this.list.style.zIndex=window.dhx4.zim.reserve(this.conf.list_zi_id),null!=this.hdr&&1==this.conf.template.header&&(this.hdr.style.zIndex=Number(this.list.style.zIndex)+1),this.list.style.visibility="hidden",this.list.style.display="",null!=this.hdr&&1==this.conf.template.header&&(this.hdr.style.visibility=this.list.style.visibility,this.hdr.style.display=this.list.style.display);var e=null!=this.hdr&&1==this.conf.template.header?this.hdr.offsetHeight:0;this.list.style.width=Math.max(this.conf.opts_width||this.conf.col_w||0,this.conf.combo_width)+"px",this.list.style.top=window.dhx4.absTop(this.base)+e+this.base.offsetHeight-1+"px",this.list.style.left=window.dhx4.absLeft(this.base)+"px",null!=this.hdr&&1==this.conf.template.header&&(this.hdr.style.width=this.list.style.width,this.hdr.style.left=this.list.style.left,this.hdr.style.top=parseInt(this.list.style.top)-e+"px"),this._checkListHeight(),this.list.style.visibility="visible",null!=this.hdr&&1==this.conf.template.header&&(this.hdr.style.visibility="visible"),this.callEvent("onOpen",[])}else t&&this._isListVisible()&&this._hideList()},dhtmlXCombo.prototype._hideList=function(){this._isListVisible()&&(window.dhx4.zim.clear(this.conf.list_zi_id),this.list.style.display="none",null!=this.hdr&&1==this.conf.template.header&&(this.hdr.style.display="none"),this.conf.clear_click=!1,this.callEvent("onClose",[]))},dhtmlXCombo.prototype._isListVisible=function(){return""==this.list.style.display},dhtmlXCombo.prototype._getListVisibleCount=function(){for(var t=0,e=0;e<this.list.childNodes.length;e++)t+=""==this.list.childNodes[e].style.display?1:0;return t},dhtmlXCombo.prototype._checkListHeight=function(){if(this._isListVisible()){if(null==this.conf.item_h){for(var t=this.list.firstChild;null!=t;)""==t.style.display?(this.conf.item_h=t.offsetHeight+(null!=this.hdr?-1:0),t=null):t=t.nextSibling;t=null}var e=window.dhx4.screenDim(),n=window.dhx4.absTop(this.base),i=this.base.offsetHeight,a=null!=this.hdr&&1==this.conf.template.header?this.hdr.offsetHeight:0,o=Math.max(0,Math.floor((n-a-e.top)/this.conf.item_h)),r=Math.max(0,Math.floor((e.bottom-(n+i+a))/this.conf.item_h)),s=this._getListVisibleCount();r<Math.min(this.conf.opts_count_min,s)&&o>r&&(r=null);var l=Math.min(null==r?o:r,this.conf.opts_count,s),d=l<s?l*this.conf.item_h+"px":"",c=this.conf.sp[this.conf.skin][null!=this.hdr&&1==this.conf.template.header?"hdr_ofs":"list_ofs"];this.list.style.height=d,this.list.style.top=(null==r?n-this.list.offsetHeight+c:n+i+a-c)+"px",null!=this.hdr&&1==this.conf.template.header&&(this.hdr.style.top=(null==r?n-a-this.list.offsetHeight+c:n+i-c)+"px")}},dhtmlXCombo.prototype._scrollToItem=function(t){var e=this.t[t].item.offsetTop,n=e+this.t[t].item.offsetHeight,i=this.list.scrollTop,a=i+this.list.clientHeight;e<i?this.list.scrollTop=e+(null!=this.hdr&&1==this.conf.template.header?1:0):n>a&&(this.list.scrollTop=n-this.list.clientHeight+(null!=this.hdr&&1==this.conf.template.header?-this.conf.sp[this.conf.skin].scr_ofs:0))},dhtmlXCombo.prototype._setSelected=function(t,e,n,i){this.conf.temp_selected=null,n&&this._updateTopImage(t),null==t||this.conf.last_hover!=t?(null!=this.conf.last_hover&&(this.t[this.conf.last_hover].obj.setSelected(this.t[this.conf.last_hover].item,!1),this.conf.last_hover=null,null==t&&this.callEvent("onSelectionChange",[])),null!=t&&(this.t[t].obj.setSelected(this.t[t].item,!0),this.conf.last_hover=t,1!=i&&(this.conf.temp_selected=t,this.callEvent("onSelectionChange",[])),"select"==this.conf.s_mode&&this.t[t].item==this.t[t].item.parentNode.lastChild&&this._subloadRequest(),e&&this._scrollToItem(t))):e&&this._scrollToItem(t)},dhtmlXCombo.prototype._subloadRequest=function(){if(null!=this.conf.f_url&&1==this.conf.f_dyn&&0==this.conf.f_dyn_end){var t="mask="+encodeURIComponent(this.conf.f_mask)+"&pos="+this.list.childNodes.length,e=this,n=function(t){e.conf.f_cache&&e.conf.f_cache_data[e.conf.f_mask].data.push(t.xmlDoc.responseXML);var i=e.list.childNodes.length;e.conf.f_loading=!0,e.load(t.xmlDoc.responseXML),e.conf.f_loading=!1,i==e.list.childNodes.length&&(e.conf.f_dyn_end=!0,e.conf.f_cache&&(e.conf.f_cache_data[e.conf.f_mask].dyn_end=!0)),n=e=null};"post"==window.dhx4.ajax.method?window.dhx4.ajax.post(this.conf.f_url,t,n):"get"==window.dhx4.ajax.method&&window.dhx4.ajax.get(this.conf.f_url+(String(this.conf.f_url).indexOf("?")>=0?"&":"?")+t,n)}},dhtmlXCombo.prototype.addOption=function(t,e,n,i,a){var o=null;if(t instanceof Array){for(var r=0;r<t.length;r++)if(void 0!==t[r])if(t[r]instanceof Array)s=this._renderOption({value:t[r][0],text:t[r][1],css:t[r][2],img:t[r][3]}),null==o&&1==window.dhx4.s2b(t[r][4])&&(o=s);else{s=this._renderOption(t[r]);null==o&&1==window.dhx4.s2b(t[r].selected)&&(o=s)}}else{var s=this._renderOption({value:t,text:e,css:n,img:i});null==o&&1==window.dhx4.s2b(a)&&(o=s)}null!=o&&(this._setSelected(o,this._isListVisible(),!0),this._confirmSelect("onInit"))},dhtmlXCombo.prototype.updateOption=function(t,e,n,i){var a=this._getOptionId(t);null!=a&&(this.t[a].obj.update(this.t[a].item,{value:e,text:n,css:i}),this.conf.last_selected==a&&(this.conf.last_text=this.base.firstChild.value=this.t[a].obj.getText(this.t[a].item,!0),this.conf.f_server_last=this.base.firstChild.value.toLowerCase()))},dhtmlXCombo.prototype.deleteOption=function(t){for(var e in this.t){this.t[e].obj.getValue(this.t[e].item)==t&&this._removeOption(e)}this._isListVisible()&&this._showList(!0)},dhtmlXCombo.prototype.clearAll=function(t){for(var e in t=void 0===t||window.dhx4.s2b(t),this.t)this._removeOption(e);this.conf.tm_hover&&window.clearTimeout(this.conf.tm_hover),this.conf.last_hover=null,this.conf.last_selected=null,this.list.scrollTop=0,1==t&&this._hideList()},dhtmlXCombo.prototype._renderOption=function(t){var e=window.dhx4.newId(),n=document.createElement("DIV");n._optId=e,n._tpl=this.conf.template,void 0===t.img&&void 0!==t.img_src&&(t.img=t.img_src,delete t.img_src),void 0===t.img_dis&&void 0!==t.img_src_dis&&(t.img_dis=t.img_src_dis,delete t.img_src_dis),t.img_path=this.conf.img_path,t.img_def=this.conf.img_def,t.img_def_dis=this.conf.img_def_dis,this.list.appendChild(n);var i=this._isListVisible()&&1==window.dhx4.isFF;if(1==i){this.list.scrollTop;this.list.scrollTop-=1}return null!=this.hdr&&(t.multicol=!0),this.t[n._optId]={obj:this.modes[this.conf.opts_type].render(n,t),item:n,conf:{type:this.conf.opts_type}},n=null,1==i&&(this.list.scrollTop+=1),e},dhtmlXCombo.prototype._removeOption=function(t){this.t[t].obj.destruct(this.t[t].item),this.t[t].obj=null,this.t[t].item.parentNode.removeChild(this.t[t].item),this.t[t].item=null,this.t[t].conf=null,this.t[t]=null,delete this.t[t],this.conf.last_hover==t&&(this.conf.last_hover=null),this.conf.last_selected==t&&(this.conf.last_selected=null,this._confirmSelect("onDelete"))},dhtmlXCombo.prototype._confirmSelect=function(t,e){var n=!1;if(void 0===e&&(e=!0),this.conf.f_server_tm&&window.clearTimeout(this.conf.f_server_tm),null!=this.conf.last_hover)n=n||this.conf.last_value!=this._getOptionValue(this.conf.last_hover),this.conf.last_match=this.conf.last_selected=this.conf.last_hover,this.conf.last_value=this._getOptionValue(this.conf.last_selected),this.conf.last_text=this.base.firstChild.value=this.t[this.conf.last_selected].obj.getText(this.t[this.conf.last_selected].item,!0),this.conf.f_server_last=this.base.firstChild.value.toLowerCase(),this.base.childNodes[1].value=this.conf.last_value,this.base.childNodes[2].value="false";else if(this.conf.allow_free_text||""==this.base.firstChild.value&&this.conf.allow_empty_value)n=n||this.conf.last_text!=this.base.firstChild.value,this.conf.last_match=this.conf.last_value=this.conf.last_selected=null,this.conf.last_text=this.base.firstChild.value,this.conf.f_server_last=this.base.firstChild.value.toLowerCase(),this.base.childNodes[1].value=this.conf.last_text,this.base.childNodes[2].value="true";else if("template"!=t)return this._cancelSelect(!0),void this._updateTopImage(this.conf.last_selected);this.conf.f_ac&&"start"==this.conf.f_mode&&(this.conf.f_ac_text="","blur"!=t&&this._selectRange(this.base.firstChild.value.length,this.base.firstChild.value.length)),e&&this._hideList(),1==n&&"onInit"!=t&&"onDelete"!=t&&(this.callEvent("onSelectionChange",[]),this.callEvent("onChange",[this.conf.last_value,this.conf.last_text]))},dhtmlXCombo.prototype._cancelSelect=function(t){this._hideList(),1==t&&0==this.conf.allow_free_text&&1==this.conf.free_text_empty?(this.conf.f_server_last=this.conf.last_match=this.conf.last_value=this.conf.last_selected=null,this.base.childNodes[1].value=this.conf.last_text=this.base.firstChild.value="",this.base.childNodes[2].value="false"):this.base.firstChild.value=this.conf.last_text,0!=this.conf.f_mode&&this._filterOpts(!0)},dhtmlXCombo.prototype._getOption=function(t,e){if(!this.t[t])return null;if(void 0===e&&(e=-1),e<0)for(var n=0;n<this.list.childNodes.length;n++)e<0&&this.list.childNodes[n]._optId==t&&(e=n);var i={value:this.t[t].obj.getValue(this.t[t].item),text:this.t[t].obj.getText(this.t[t].item),text_input:this.t[t].obj.getText(this.t[t].item,!0),text_option:this.t[t].obj.getText(this.t[t].item,null,!0),css:this.t[t].obj.getCss(this.t[t].item),selected:t==this.conf.last_selected,index:e};if("function"==typeof this.t[t].obj.getExtraData){var a=this.t[t].obj.getExtraData(this.t[t].item);for(var o in a)void 0===i[o]&&(i[o]=a[o])}return i},dhtmlXCombo.prototype._getOptionProp=function(t,e,n){if(null!=t){var i=this._getOption(t);if(null!=i)return i[e]}return n},dhtmlXCombo.prototype._getOptionId=function(t){for(var e=null,n=0;n<this.list.childNodes.length;n++)if(null==e){var i=this.list.childNodes[n]._optId;t==this.t[i].obj.getValue(this.t[i].item)&&(e=i)}return e},dhtmlXCombo.prototype._getOptionValue=function(t){return this._getOptionProp(t,"value",null)},dhtmlXCombo.prototype.setSize=function(t){this.conf.combo_width=parseInt(t)-(dhx4.isFF||dhx4.isIE||dhx4.isChrome||dhx4.isOpera?2:0),this.base.style.width=Math.max(0,this.conf.combo_width)+"px",this._adjustBase(),this._isListVisible()&&(this._hideList(),this._showList())},dhtmlXCombo.prototype._adjustBase=function(){this.base.firstChild.style.width=Math.max(0,this.conf.combo_width-(this.conf.i_ofs+1)-(this.conf.combo_image?this.conf.i_ofs:0))+"px",this.base.firstChild.style.marginLeft=this.conf.combo_image?this.conf.i_ofs+"px":"0px"},dhtmlXCombo.prototype.setOptionWidth=function(t){this.conf.opts_width=parseInt(t)||null},dhtmlXCombo.prototype.setOptionIndex=function(t,e){if(!(isNaN(e)||e<0)){var n=this.getOption(t);if(null!=n&&e!=n.index){var i=this.list.childNodes[n.index];i.parentNode.removeChild(i),null!=this.list.childNodes[e]?this.list.insertBefore(i,this.list.childNodes[e]):this.list.appendChild(i),i=null}}},dhtmlXCombo.prototype.getOptionsCount=function(){return this.list.childNodes.length},dhtmlXCombo.prototype._mcMakeTemplate=function(t){var e="",n="";this.conf.col_w=0;for(var i=0;i<t.length;i++){var a=Number(parseInt(t[i].width)||50),o=t[i].css||"",r=0==i&&1==window.dhx4.isIE6?"_first":"";n+="<div class='dhxcombo_cell"+r+" "+o+"' style='width:"+a+"px;'><div class='dhxcombo_cell_text'>"+(t[i].option||"&nbsp;")+"</div></div>",e+="<div class='dhxcombo_hdrcell"+r+" "+o+"' style='width:"+a+"px;'><div class='dhxcombo_hdrcell_text'>"+(t[i].header||"&nbsp;")+"</div></div>",this.conf.col_w+=a+1}a=500;var s=document.createElement("DIV");s.style.position="absolute",s.style.top="10px",s.style.left=2*-a+"px",s.style.width=a+"px",s.style.height="50px",s.style.overflowY="scroll",s.innerHTML="<div>&nbsp;</div>",document.body.appendChild(s),this.conf.col_w+=a-s.firstChild.offsetWidth+10,s.parentNode.removeChild(s),s=null,this.conf.template.option=n,this._mcAttachHeader(e),this.list.className+=" dhxcombolist_multicolumn"},dhtmlXCombo.prototype._mcAttachHeader=function(t){null==this.hdr&&(this.hdr=document.createElement("DIV"),this.hdr.className="dhxcombolist_"+this.conf.skin+" dhxcombolist_hdr",this.hdr.style.display="none",this.list.parentNode.insertBefore(this.hdr,this.list),"function"==typeof window.addEventListener?this.hdr.addEventListener("mousedown",this._doOnListMouseDown,!1):this.hdr.attachEvent("onmousedown",this._doOnListMouseDown),"checkbox"==this.conf.opts_type&&1==this.conf.combo_image&&(this.conf.combo_image=!1,null!=this.base.lastChild.className.match(/dhxcombo_top_image/)&&this.base.removeChild(this.base.lastChild),this._adjustBase())),this.hdr.innerHTML="<div class='dhxcombo_hdrtext'>"+t+"</div>"},dhtmlXCombo.prototype._mcDetachHeader=function(){null!=this.hdr&&("function"==typeof window.addEventListener?this.hdr.removeEventListener("mousedown",this._doOnListMouseDown,!1):this.hdr.detachEvent("onmousedown",this._doOnListMouseDown),this.hdr.parentNode.removeChild(this.hdr),this.hdr=null),this.conf.col_w=null,this.conf.item_h=null},dhtmlXCombo.prototype.modes={},dhtmlXCombo.prototype.doWithItem=function(t,e,n,i){var a=t>=0&&t<this.list.childNodes.length?this.list.childNodes[t]._optId:null;if(null==a)return null;if("function"!=typeof this.t[a].obj[e])return null;for(var o=[this.t[a].item],r=2;r<arguments.length;r++)o.push(arguments[r]);return this.t[a].obj[e].apply(this.t[a].obj,o)},dhtmlXCombo.prototype.modes.option={image:!1,html:!1,option_css:"dhxcombo_option_text",render:function(t,e){return t._conf={value:e.value,css:""},t.className="dhxcombo_option",t.innerHTML="<div class='"+this.option_css+"'>&nbsp;</div>",null!=e.css&&(t.lastChild.style.cssText=e.css,t._conf.css=e.css),this.setText(t,e.text),this},destruct:function(t){t._conf=null},update:function(t,e){t._conf.value=e.value,t._conf.css=e.css,t.lastChild.style.cssText=e.css,this.setText(t,e.text)},setText:function(t,e,n){t._conf.text=e;var i="object"==typeof e?window.dhx4.template(t._tpl.option,this.replaceHtml(t._conf.text,n),!0):window.dhx4.trim(this.replaceHtml(t._conf.text,n)||"");t.lastChild.innerHTML=0==i.length?"&nbsp;":i},getText:function(t,e,n){return window.dhx4.s2b(e)&&"object"==typeof t._conf.text?window.dhx4.template(t._tpl.input,t._conf.text,!0):window.dhx4.s2b(n)&&"object"==typeof t._conf.text?window.dhx4.template(t._tpl.option,t._conf.text,!0):t._conf.text},getValue:function(t){return t._conf.value},getCss:function(t){return t._conf.css},setSelected:function(t,e){t.className="dhxcombo_option"+(e?" dhxcombo_option_selected":"")},isSelected:function(t){return String(t.className).indexOf("dhxcombo_option_selected")>=0},getExtraData:function(t){return{type:"option"}},replaceHtml:function(t,e){if(1==this.html)return t;if(void 0!==e&&null!=e||(e={}),"object"==typeof t){var n={};for(var i in t)n[i]=1==e[i]?t[i]:this.replaceHtml(t[i])}else n=(t||"").replace(/[\<\>\&\s]/g,function(t){switch(t){case"<":return"&lt;";case">":return"&gt;";case"&":return"&amp;";case" ":return"&nbsp;"}return t});return n}},dhtmlXCombo.prototype.modes.checkbox={image:!0,html:!1,image_css:"dhxcombo_checkbox dhxcombo_chbx_#state#",option_css:"dhxcombo_option_text dhxcombo_option_text_chbx",render:function(t,e){null==this.image_css_regexp&&(this.image_css_regexp=new RegExp(this.image_css.replace("#state#","\\d*"))),t._conf={value:e.value,css:"",checked:window.dhx4.s2b(e.checked)},t.className="dhxcombo_option";var n={};return 1==e.multicol?(e.text.checkbox="<div class='"+String(this.image_css).replace("#state#",t._conf.checked?"1":"0")+"'></div>&nbsp;",n.checkbox=!0,t.innerHTML="<div class='"+dhtmlXCombo.prototype.modes.option.option_css+"'></div>"):t.innerHTML="<div class='"+String(this.image_css).replace("#state#",t._conf.checked?"1":"0")+"'></div><div class='"+this.option_css+"'>&nbsp;</div>",null!=e.css&&(t.lastChild.style.cssText+=e.css,t._conf.css=e.css),this.setText(t,e.text,n),this},setChecked:function(t,e){t._conf.checked=window.dhx4.s2b(e);var n=String(this.image_css).replace("#state#",t._conf.checked?"1":"0");this._changeChbxCss(t.childNodes,n)},_changeChbxCss:function(t,e){for(var n=0;n<t.length;n++)null!=t[n].tagName&&null!=t[n].className&&null!=t[n].className.match(this.image_css_regexp)?t[n].className=e:t[n].childNodes.length>0&&this._changeChbxCss(t[n].childNodes,e)},isChecked:function(t){return 1==t._conf.checked},getExtraData:function(t){return{type:"checkbox",checked:t._conf.checked}},optionClick:function(t,e,n){for(var i=!0,a=e.target||e.srcElement;1==i&&null!=a&&a!=t&&null!=a.className;)if(null!=a.className.match(this.image_css_regexp)){var o=[t._conf.value,!t._conf.checked];!0===n.callEvent("onBeforeCheck",o)&&(this.setChecked(t,!this.isChecked(t)),n.callEvent("onCheck",o)),i=!1,o=null}else a=a.parentNode;return a=n=t=null,i},getTopImage:function(t,e){return""},topImageClick:function(t,e){return!0}},dhtmlXComboExtend("checkbox","option"),dhtmlXCombo.prototype.setChecked=function(t,e){this.doWithItem(t,"setChecked",e)},dhtmlXCombo.prototype.getChecked=function(t){for(var e=[],n=0;n<this.list.childNodes.length;n++)this.isChecked(n)&&e.push(this._getOptionProp(this.list.childNodes[n]._optId,"value",""));return e},dhtmlXCombo.prototype.isChecked=function(t){return this.doWithItem(t,"isChecked")},dhtmlXCombo.prototype.modes.image={image:!0,html:!1,image_css:"dhxcombo_image",option_css:"dhxcombo_option_text dhxcombo_option_text_image",render:function(t,e){return t._conf={value:e.value,css:""},t.className="dhxcombo_option",t.innerHTML="<div class='"+this.image_css+"'></div><div class='"+this.option_css+"'>&nbsp;</div>",null!=e.css&&(t.lastChild.style.cssText+=e.css,t._conf.css=e.css),this.setText(t,e.text),this.setImage(t,e.img,e.img_dis,e.img_path,e.img_def,e.img_def_dis),this},update:function(t,e){t._conf.value=e.value,t._conf.css=e.css,t.lastChild.style.cssText=e.css,this.setText(t,e.text),this.setImage(t,e.img,e.img_dis,e.img_path,e.img_def,e.img_def_dis)},setImage:function(t,e,n,i,a,o){e=null!=e&&e.length>0?i+e:null!=a&&a.length>0?i+a:null,n=null!=n&&n.length>0?i+n:null!=o&&o.length>0?i+o:1==o?e:null,t._conf.img=e,t._conf.img_dis=n,t.firstChild.style.backgroundImage=null!=e?"url("+e+")":"none"},getExtraData:function(t){return{type:"image"}},getTopImage:function(t,e){var n=e?"img":"img_dis";return null!=t&&null!=t._conf[n]?"<div class='"+this.image_css+"' style='background-image:url("+t._conf[n]+");'></div>":""}},dhtmlXComboExtend("image","option"),dhtmlXCombo.prototype.setDefaultImage=function(t,e){null!=t&&(this.conf.img_def=t),null!=e&&(this.conf.img_def_dis=e)},dhtmlXCombo.prototype.setImagePath=function(t){this.conf.img_path=t},dhtmlXColorPicker.prototype.linkTo=function(t,e,n){var i;return 1==arguments.length&&(e=n=t),t=t||null,n=n||null,"string"==typeof e&&(e=document.getElementById(e)),(i=this._addNode(e,t,n))&&this._attachEventsToNode(i),i},dhtmlXColorPicker.prototype._isBaseNode=function(t){return t==this.base||t.parentElement!=document.body&&(!!t.parentElement&&this._isBaseNode(t.parentElement))},dhtmlXColorPicker.prototype._hasInput=function(t){var e,n,i=!1;for(n=this._nodes.length,e=0;e<n;e++)if(this._nodes[e].valueCont==t){i=!0;break}return i},dhtmlXColorPicker.prototype._findNodesByArray=function(t){var e,n,i;for(n=t.length,e=0;e<n;e++)(i="string"==typeof t[e]?document.getElementById(t[e]):t[e])&&this._addNode(i)},dhtmlXColorPicker.prototype._addNode=function(t,e,n){var i,a,o,r;return i="string"==typeof t?document.getElementById(t):t,"string"==typeof e&&(e=document.getElementById(e)),"string"==typeof n&&(n=document.getElementById(n)),i?(dhx4.s2b(i.getAttribute("colorbox"))&&((a=document.createElement("div")).style.width=i.offsetWidth+"px",a.style.height=i.offsetHeight+"px",i.style.width=i.offsetWidth-(i.offsetHeight+8)+"px",i.parentNode.insertBefore(a,i),a.style.position="relative",o=document.createElement("div"),a.appendChild(i),a.appendChild(o),o.className="dhxcp_colorBox",i.className+=" dhxcp_colorInput",o.style.width=o.style.height=i.offsetHeight+"px"),r={node:i,valueColor:void 0!=e?e:o||i,valueCont:void 0!=n?n:i,conf:{customColors:null!=i.getAttribute("customcolors")?dhx4.s2b(i.getAttribute("customcolors")):null,selectedColor:i.getAttribute("selectedcolor")}},this._nodes.push(r),this.activeNode||(this.activeNode=r),r):null},dhtmlXColorPicker.prototype.getNode=function(t){var e=null,n=null;return void 0!=(e="string"==typeof t?document.getElementById(t):t).tagName&&(n=this._getNodeByElement(e)),n},dhtmlXColorPicker.prototype._getNodeByElement=function(t){var e,n,i=null;for(n=this._nodes.length,e=0;e<n;e++)this._nodes[e].node==t&&(i=this._nodes[e]);return i},dhtmlXColorPicker.prototype._getNodeByValueCont=function(t){var e,n,i=null;for(n=this._nodes.length,e=0;e<n;e++)this._nodes[e].valueCont&&this._nodes[e].valueCont==t&&(i=this._nodes[e]);return i},dhtmlXColorPicker.prototype.initMemoryColors=function(){var t=this;this._controllerNodes.memory_block.innerHTML="<div class='dhxcp_memory_button_cont'><button class='dhxcp_save_to_memory'><div class='dhxcp_label_bm'>"+this.i18n[this.conf.lang].btnAddColor+"</div></button></div><div class='dhxcp_memory_els_cont'><a class='dhxcp_memory_el'></a><a class='dhxcp_memory_el'></a><a class='dhxcp_memory_el'></a><a class='dhxcp_memory_el'></a><a class='dhxcp_memory_el'></a><a class='dhxcp_memory_el'></a><a class='dhxcp_memory_el'></a><a class='dhxcp_memory_el'></a></div>",this.memory=new this.Memory(this._controllerNodes.memory_block.childNodes[1]),this.memory.onSelect=this._onSelectMemoryEl,this.memory.onSave=function(e){var n=t.colorAIP.rgb2hex({r:e.red,g:e.green,b:e.blue});t.callEvent("onSaveColor",[n])};var e=this._controllerNodes.memory_block.childNodes[0].firstChild;this._labelNodes.btnAddColor=this._controllerNodes.memory_block.childNodes[0].firstChild.firstChild,"function"==typeof window.addEventListener?e.addEventListener("click",this.saveColor,!1):e.attachEvent("onclick",this.saveColor)},dhtmlXColorPicker.prototype._refreshCoordinatesByHSL=function(t,e,n){var i,a,o;i=Math.round((this.configColorArea.maxX-this.configColorArea.minX)*t/359)+this.configColorArea.minX,a=Math.round((this.configColorArea.maxY-this.configColorArea.minY)*(100-n)/100)+this.configColorArea.minY,o=Math.round((this.configColorArea.maxY-this.configColorArea.minY)*(100-e)/100)+this.configColorArea.minY,this._setColorAreaXY(i,a),this._setContrastY(o)},dhtmlXColorPicker.prototype._parseColor=function(t){if(t instanceof Array)var e={r:parseInt(t[0]),g:parseInt(t[1]),b:parseInt(t[2])};else if("string"==typeof t)if(t=t.replace(/\s/g,""),/^rgb\((\d{1,3})\,(\d{1,3})\,(\d{1,3})\)$/i.test(t)){var n=t.match(/^rgb\((\d{1,3})\,(\d{1,3})\,(\d{1,3})\)$/i);e={r:parseInt(n[1]),g:parseInt(n[2]),b:parseInt(n[3])}}else e=this.colorAIP.hex2rgb(t);return e},dhtmlXColorPicker.prototype.setColor=function(t){var e=this.colorAIP.rgb2hex({r:this.value.red,g:this.value.green,b:this.value.blue}),n=this._parseColor(t),i=n instanceof Object;if(!(i=(i=(i=i&&0<=n.r&&n.r<=255)&&0<=n.g&&n.g<=255)&&0<=n.b&&n.b<=255))return e;var a=this.colorAIP.rgb2hex({r:n.r,g:n.g,b:n.b});if(a==e)return e;this.value.red=n.r,this.value.green=n.g,this.value.blue=n.b;var o=this.colorAIP.rgb2hsl(n.r/255,n.g/255,n.b/255);return this.value.hue=Math.round(o.h),this.value.sat=Math.round(100*o.s),this.value.lum=Math.round(100*o.l),this._refreshCoordinatesByHSL(this.value.hue,this.value.sat,this.value.lum),this._refreshContrast(),this._refreshInputValues(),this._refreshColorValue(),a},dhtmlXColorPicker.prototype.getSelectedColor=function(){return[this.colorAIP.rgb2hex({r:this.value.red,g:this.value.green,b:this.value.blue}),[this.value.red,this.value.green,this.value.blue],[this.value.hue,this.value.sat,this.value.lum]]},dhtmlXColorPicker.prototype._attachEventsToNode=function(t){"function"==typeof window.addEventListener?t.node.addEventListener("click",this._doOnClickByNode,!1):t.node.attachEvent("onclick",this._doOnClickByNode),t.valueCont&&"input"==t.valueCont.tagName.toLowerCase()&&("function"==typeof window.addEventListener?(t.valueCont.addEventListener("focus",this._doOnFocusByInput,!1),t.valueCont.addEventListener("blur",this._doOnBlurByInput,!1)):(t.valueCont.attachEvent("onfocus",this._doOnFocusByInput),t.valueCont.attachEvent("onblur",this._doOnBlurByInput)))},dhtmlXColorPicker.prototype._detachEventsFromNode=function(t){"function"==typeof window.addEventListener?t.node.removeEventListener("click",this._doOnClickByNode,!1):t.node.detachEvent("onclick",this._doOnClickByNode),t.valueCont&&"input"==t.valueCont.tagName.toLowerCase()&&("function"==typeof window.addEventListener?(t.valueCont.removeEventListener("focus",this._doOnFocusByInput,!1),t.valueCont.removeEventListener("blur",this._doOnBlurByInput,!1)):(t.valueCont.detachEvent("onfocus",this._doOnFocusByInput),t.valueCont.detachEvent("onblur",this._doOnBlurByInput)))},dhtmlXColorPicker.prototype.show=function(t){var e=!1;void 0!=t&&(this.activeNode=this.getNode(t)||this.activeNode),this.activeNode&&this.activeNode.valueCont&&this.activeNode.valueCont.value&&this.setColor(this.activeNode.valueCont.value),this.activeNode?(e=null!=this.activeNode.conf.customColors?this.activeNode.conf.customColors:this.conf.customColors,this.setColor(this.activeNode.conf.selectedColor)):e=this.conf.customColors,e?this.showMemory():this.hideMemory(),this.base._dhx_remove?(this.base.firstChild.style.zIndex=dhx4.zim.reserve(this.conf.cp_id),this.base.style.visibility="hidden",document.body.firstChild?document.body.insertBefore(this.base,document.body.firstChild):document.body.appendChild(this.base),this._refreshPosition(),this.base.style.visibility="visible","function"==typeof window.addEventListener?document.body.addEventListener("mousedown",this._doOnClickByBody,!1):document.body.attachEvent("onmousedown",this._doOnClickByBody)):this.base.appendChild(this._globalNode),this._controllerNodes.fr_cover&&this.base.insertBefore(this._controllerNodes.fr_cover,this._globalNode),this.callEvent("onShow",[this.activeNode?this.activeNode.node:null])},dhtmlXColorPicker.prototype.setPosition=function(t,e){var n=null,i=parseInt(t),a=parseInt(e);isNaN(i)&&(n={right:"right",bottom:"bottom"}[t.toLowerCase()]?t:null),this.base._dhx_remove?null==n||(this.conf.position=n,this._refreshPosition(n)):isNaN(i)||isNaN(a)||(this._globalNode.style.left=i+"px",this._globalNode.style.top=a+"px",this._controllerNodes.fr_cover&&(this._controllerNodes.fr_cover.style.left=this._globalNode.style.left,this._controllerNodes.fr_cover.style.top=this._globalNode.style.top))},dhtmlXColorPicker.prototype._initListenerInput=function(){var t=this;this._inputListenerId=this._inputListenerId||setInterval(function(){t._refreshValueByInput()},70)},dhtmlXColorPicker.prototype._removeListenerInput=function(){this._inputListenerId&&(clearInterval(this._inputListenerId),this._inputListenerId=null)},dhtmlXColorPicker.prototype._refreshValueByInput=function(){var t=this.activeNode.valueCont.value,e=this.getSelectedColor()[0];this._inputListenerId&&/^#[\da-f]{6}$/i.test(t)&&t!=e&&(this.setColor(t),this.callEvent("onSelect",[t,this.activeNode.node]))},dhtmlXColorPicker.prototype._refreshPosition=function(t){if(null!=this.activeNode){var e=dhx4.absTop(this.activeNode.node),n=dhx4.absLeft(this.activeNode.node),i=dhx4.screenDim(),a=this._globalNode.offsetWidth,o=this._globalNode.offsetHeight,r=0;switch(t=t||this.conf.position){case"bottom":r=e+this.activeNode.node.offsetHeight+this.conf.indent;(s=n)+a>i.left+i.right&&(s=n+this.activeNode.node.offsetWidth-a),s<i.left&&(s=n),r+o>i.top+i.bottom&&(r=e-o-this.conf.indent),r-i.top<0&&(r=i.top+this.conf.indent),this._globalNode.style.top=r+"px",this._globalNode.style.left=s+"px";break;default:var s=n+this.activeNode.node.offsetWidth+this.conf.indent;r=e,"right"==t&&(s+a>i.left+i.right&&(s=n-a-this.conf.indent),s<i.left&&(s=n+this.activeNode.node.offsetWidth+this.conf.indent)),i.bottom-(r+o)<=0&&(r=e+this.activeNode.node.offsetHeight-o),r-i.top<0&&(r=i.top+this.conf.indent),this._globalNode.style.left=s+"px",this._globalNode.style.top=r+"px"}this._controllerNodes.fr_cover&&(this._controllerNodes.fr_cover.style.left=this._globalNode.style.left,this._controllerNodes.fr_cover.style.top=this._globalNode.style.top)}},dhtmlXColorPicker.prototype.isVisible=function(){return this.base._dhx_remove?this.base.parentNode==document.body:this._globalNode.parentNode==this.base},dhtmlXColorPicker.prototype.hide=function(){if(this.base._dhx_remove)this.base.parentNode&&(this.base.parentNode.removeChild(this.base),dhx4.zim.clear(this.conf.cp_id),"function"==typeof window.addEventListener?document.body.removeEventListener("mousedown",this._doOnClickByBody,!1):document.body.detachEvent("onmousedown",this._doOnClickByBody));else{if(0==this.isVisible())return;this.base.removeChild(this._globalNode)}this._controllerNodes.fr_cover&&this._controllerNodes.fr_cover.parentNode&&this._controllerNodes.fr_cover.parentNode.removeChild(this._controllerNodes.fr_cover),void 0!=this.callEvent&&this.callEvent("onHide",[this.activeNode?this.activeNode.node:null])},dhtmlXColorPicker.prototype.configColorArea={minX:1,maxX:209,minY:1,maxY:119},dhtmlXColorPicker.prototype._skinCollection={dhx_skyblue:!0,dhx_web:!0,dhx_terrace:!0,material:!0},dhtmlXColorPicker.prototype.i18n={en:{labelHue:"Hue",labelSat:"Sat",labelLum:"Lum",labelRed:"Red",labelGreen:"Green",labelBlue:"Blue",btnAddColor:"Save the color",btnSelect:"Select",btnCancel:"Cancel"}},dhtmlXColorPicker.prototype.loadUserLanguage=function(t){"function"==typeof this._mergeLangModules&&this._mergeLangModules(),this.conf.lang=t,this._refreshLanguage()},dhtmlXColorPicker.prototype._refreshLanguage=function(){var t,e=this.i18n[this.conf.lang];for(t in e)this._labelNodes[t]&&(this._labelNodes[t].innerHTML=e[t])},dhtmlXColorPicker.prototype._setColorAreaXY=function(t,e){var n=this.configColorArea;t=parseInt(t),n.minX>t?this.conf.x=n.minX:t>n.maxX?this.conf.x=n.maxX:isNaN(t)||(this.conf.x=t),e=parseInt(e),n.minY>e?this.conf.y=n.minY:e>n.maxY?this.conf.y=n.maxY:isNaN(e)||(this.conf.y=e),this._refreshLines()},dhtmlXColorPicker.prototype._setColorByXYC=function(t){t=t||!1,this.value.hue=Math.round(359*(this.conf.x-this.configColorArea.minX)/(this.configColorArea.maxX-this.configColorArea.minX)),this.value.lum=Math.round(100-100*(this.conf.y-this.configColorArea.minY)/(this.configColorArea.maxY-this.configColorArea.minY)),this.value.sat=Math.round(100-100*(this.conf.c-this.configColorArea.minY)/(this.configColorArea.maxY-this.configColorArea.minY));var e=this.colorAIP.hsl2rgb(this.value.hue,this.value.sat/100,this.value.lum/100);this.value.red=Math.round(255*e.r),this.value.green=Math.round(255*e.g),this.value.blue=Math.round(255*e.b),t||this._refreshContrast(),this._refreshInputValues(),this._refreshColorValue()},dhtmlXColorPicker.prototype._setContrastY=function(t){var e=this.configColorArea;t=parseInt(t),isNaN(t)||(this.conf.c=Math.min(Math.max(e.minY,t),e.maxY)),this._refreshContrastLine()},dhtmlXColorPicker.prototype._refreshInputValues=function(){this._controllerNodes.hue.value=this.value.hue,this._controllerNodes.sat.value=this.value.sat,this._controllerNodes.lum.value=this.value.lum,this._controllerNodes.red.value=this.value.red,this._controllerNodes.green.value=this.value.green,this._controllerNodes.blue.value=this.value.blue},dhtmlXColorPicker.prototype._refreshColorValue=function(){this._controllerNodes.color.style.backgroundColor="rgb("+[this.value.red,this.value.green,this.value.blue].join(", ")+")";var t=this.colorAIP.rgb2hex({r:this.value.red,g:this.value.green,b:this.value.blue});this._controllerNodes.hsv.value=t,this.callEvent("onChange",[t])},dhtmlXColorPicker.prototype._refreshContrast=function(){var t=this.colorAIP.hsl2rgb(this.value.hue,0,this.value.lum/100),e=this.colorAIP.hsl2rgb(this.value.hue,1,this.value.lum/100),n=this._checkIeVersion();if(n&&n<=9){var i=this._controllerNodes.contrastArea.firstChild;i==this._controllerNodes.contrast_line&&((i=document.createElement("div")).className+="dhxcp_ie_gradient",this._controllerNodes.contrastArea.appendChild(i),this._controllerNodes.contrastArea.appendChild(this._controllerNodes.contrast_line));var a=this.colorAIP.rgb2hex({r:Math.round(255*t.r),g:Math.round(255*t.g),b:Math.round(255*t.b)}),o=this.colorAIP.rgb2hex({r:Math.round(255*e.r),g:Math.round(255*e.g),b:Math.round(255*e.b)});i.style.filter="progid:DXImageTransform.Microsoft.gradient(startColorstr='"+o+"', endColorstr='"+a+"', GradientType=0)"}else{t=[Math.round(255*t.r),Math.round(255*t.g),Math.round(255*t.b)];var r="linear-gradient(rgb("+(e=[Math.round(255*e.r),Math.round(255*e.g),Math.round(255*e.b)]).join(",")+"), rgb("+t.join(",")+"))";1==window.dhx4.isKHTML&&null!=navigator.userAgent.match(/Windows/gi)&&(r="-webkit-"+r),this._controllerNodes.contrastArea.style.backgroundImage=r}},dhtmlXColorPicker.prototype._refreshLines=function(){this._controllerNodes.v_line.style.left=this.conf.x+"px",this._controllerNodes.h_line.style.top=this.conf.y+"px"},dhtmlXColorPicker.prototype._refreshContrastLine=function(){this._controllerNodes.contrast_line.style.top=this.conf.c+"px"},dhtmlXColorPicker.prototype._getOffsetPosition=function(t,e){var n={x:NaN,y:NaN},i=t.target||t.srcElement;return i==e?(n.x=void 0!=t.offsetX?t.offsetX:t.layerX,n.y=void 0!=t.offsetY?t.offsetY:t.layerY):i==this._controllerNodes.v_line?n.y=void 0!=t.offsetY?t.offsetY:t.layerY:n.x=void 0!=t.offsetX?t.offsetX:t.layerX,n},dhtmlXColorPicker.prototype.colorAIP={hex2rgb:function(t){var e=t.match(/^(#)([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);return null!=e?{r:parseInt("0x"+e[2]),g:parseInt("0x"+e[3]),b:parseInt("0x"+e[4])}:null},rgb2hex:function(t){var e=parseInt(t.r),n=parseInt(t.g),i=parseInt(t.b);return e=e||0,n=n||0,i=i||0,"#"+(e?e<16?"0"+e.toString(16):e.toString(16):"00")+(n?n<16?"0"+n.toString(16):n.toString(16):"00")+(i?i<16?"0"+i.toString(16):i.toString(16):"00")},rgb2hsl:function(t,e,n){var i,a,o=Math.max(t,e,n),r=Math.min(t,e,n);return a=.5*(o+r),o==r?i=0:o==t?(i=60*(e-n)/(o-r),e<n&&(i+=360)):i=o==e?60*(n-t)/(o-r)+120:60*(t-e)/(o-r)+240,{h:i,s:0==a||o==r?0:a<=.5?.5*(o-r)/a:.5*(o-r)/(1-a),l:a}},hsl2rgb:function(t,e,n){var i,a,o,r=[],s=[];a=2*n-(i=n<=.5?n*(1+e):n+e-n*e),o=t/360,r.push(o+1/3),r.push(o),r.push(o-1/3);for(var l=0;l<3;l++)r[l]<0?r[l]+=1:r[l]>1&&(r[l]-=1),r[l]<1/6?s.push(a+6*(i-a)*r[l]):r[l]<.5?s.push(i):r[l]<2/3?s.push(a+(i-a)*(2/3-r[l])*6):s.push(a);return{r:s[0],g:s[1],b:s[2]}}},dhtmlXColorPicker.prototype._checkIeVersion=function(){var t=navigator.userAgent.match(/(MSIE)\s(\d\.\d)/i);return t&&t[2]?parseInt(t[2]):null},dhtmlXColorPicker.prototype.setCustomColors=function(){var t,e,n,i,a,o;for(null==this.memory&&(this.initMemoryColors(),this.conf.customColors=!0),e=arguments.length,t=0;t<e;t++)if(arguments[t]instanceof Array)n=this._rgb2value(arguments[t][0],arguments[t][1],arguments[t][2]),this.memory.setValue(n,null,!1);else if("string"==typeof arguments[t]){if((i=arguments[t].match(/^rgb\((\d{1,3})\,(\d{1,3})\,(\d{1,3})\)$/i))instanceof Array){n=this._rgb2value(i[1],i[2],i[3]),this.memory.setValue(n,null,!1);continue}if((i=arguments[t].match(/(#[\da-f]{6})/gi))instanceof Array)for(o=i.length,a=0;a<o;a++)n=this._hex2value(i[a]),this.memory.setValue(n,null,!1)}},dhtmlXColorPicker.prototype.getCustomColors=function(){var t=[];if(null!=this.memory&&1==this.conf.customColors)for(var e=0;e<this.memory.controllers.length;e++){var n=this.memory.controllers[e].value;t.push(this.colorAIP.rgb2hex({r:n.red,g:n.green,b:n.blue}))}return t},dhtmlXColorPicker.prototype._rgb2value=function(t,e,n){var i=this.colorAIP.rgb2hsl(t/255,e/255,n/255);return{red:t,green:e,blue:n,hue:Math.round(i.h),sat:Math.round(100*i.s),lum:Math.round(100*i.l)}},dhtmlXColorPicker.prototype._hex2value=function(t){var e,n;return e=this.colorAIP.hex2rgb(t),n=this.colorAIP.rgb2hsl(e.r/255,e.g/255,e.b/255),{red:e.r,green:e.g,blue:e.b,hue:Math.round(n.h),sat:Math.round(100*n.s),lum:Math.round(100*n.l)}},dhtmlXColorPicker.prototype.showMemory=function(){null==this.memory&&this.initMemoryColors(),this._globalNode.className.match(/dhxcp_add_memory/)||(this._globalNode.className+=" dhxcp_add_memory"),this.conf.customColors=!0},dhtmlXColorPicker.prototype.hideMemory=function(){null!=this.memory&&(this._globalNode.className=this._globalNode.className.replace(/\sdhxcp_add_memory/,"")),this.conf.customColors=!1},dhtmlXColorPicker.prototype.setSkin=function(t){if(1==this._skinCollection[t]){var e="dhtmlxcp_"+(this.skin||"dummy");if(this.base.className=this.base.className.replace(new RegExp(e),""),this.base.className+=" dhtmlxcp_"+t,this.skin=t,"material"==this.skin){var n={labelHue:"H",labelSat:"S",labelLum:"L",labelRed:"R",labelGreen:"G",labelBlue:"B"};for(var i in n)this.i18n.en[i]=n[i]}null!=this.base.className.match(/dhxcp_shadow/)||dhx4.isIE6||dhx4.isIE7||dhx4.isIE8||(this.base.className+=" dhxcp_shadow")}},dhtmlXColorPicker.prototype.hideOnSelect=function(t){t=dhx4.s2b(t),this.conf.hideOnSelect=t},dhtmlXColorPicker.prototype._indexOf=function(t,e){var n,i=-1;for(n=t.length;n>=0;n--)if(t[n]==e){i=n;break}return i},dhtmlXColorPicker.prototype.destructMemory=function(){if(null!=this.memory){this.hideMemory();var t=this._controllerNodes.memory_block.childNodes[0].firstChild;this._labelNodes.btnAddColor=null,"function"==typeof window.addEventListener?t.removeEventListener("click",this.saveColor,!1):t.detachEvent("onclick",this.saveColor),this.memory.remove(),this._controllerNodes.memory_block.innerHTML="",this.memory=null}},dhtmlXColorPicker.prototype.Memory=function(t){var e=this,n=null,i={red:255,blue:255,green:255,hue:0,sat:0,lum:100};this.select=function(){var t=this!=window?this:event.srcElement,i=i||t.dhxpc_memory;null!=n&&e.unSelect(),n=i,i.domElement.className+=" dhxcp_memory_el_select","function"==typeof e.onSelect&&e.onSelect(i)},this.onSelect=null,this.onSave=null,this._createMemoryController=function(t){var n={domElement:t,value:dhx4._copyObj(i)};return t.dhxpc_memory=n,"function"==typeof window.addEventListener?t.addEventListener("click",e.select,!1):t.attachEvent("onclick",e.select),n},this._findMemoryControllers=function(t){var e,n,i=t.getElementsByTagName("a"),a=[];for(n=i.length,e=0;e<n;e++)a.push(this._createMemoryController(i[e]));return a},this.controllers=this._findMemoryControllers(t),this.unSelect=function(){n&&(n.domElement.className=n.domElement.className.replace(/\s.*$/i,"")),n=null},this.setActiveNext=function(){var t,e=null;return null==n?n=this.controllers[0]:(e=this.getIndex(n),t=this.controllers.length,this.unSelect(),n=e+1<t?this.controllers[e+1]:this.controllers[0]),n.domElement.className+=" dhxcp_memory_el_next",n},this.setValue=function(t,e,i){null==(n=e||n)&&(n=this.controllers[0]),n.value.red=t.red,n.value.blue=t.blue,n.value.green=t.green,n.value.hue=t.hue,n.value.sat=t.sat,n.value.lum=t.lum,n.domElement.style.backgroundColor="rgb("+[t.red,t.green,t.blue].join(", ")+")",this.setActiveNext(),0!=i&&"function"==typeof this.onSave&&this.onSave(t)},this.clean=function(){for(var t,e=this.controllers.length,a=0;a<e;a++)(t=this.controllers[a]).value=dhx4._copyObj(i),t.domElement.style.backgroundColor="rgb("+[i.red,i.green,i.blue].join(", ")+")";this.unSelect(),n=this.controllers[0]},this.getIndex=function(t){var e,n,i=-1;for(n=this.controllers.length,e=0;e<n;e++)if(this.controllers[e]==t){i=e;break}return i},this.remove=function(){var t,e;for(e=this.controllers.length,t=0;t<e;t++)"function"==typeof window.addEventListener?this.controllers[t].domElement.removeEventListener("click",this.select,!1):this.controllers[t].domElement.detachEvent("onclick",this.select),delete this.controllers[t].domElement.dhxpc_memory;delete this.onSelect,delete this.controllers,delete this.onSave}},window.dhx4.isIE6&&(dhtmlXColorPicker.prototype._cpInitFRM=function(){var t;this._controllerNodes.fr_cover||((t=document.createElement("IFRAME")).className="dhxcp_frm",t.border=0,t.frameBorder=0,this._controllerNodes.fr_cover=t),this.base._dhx_remove||this.base.insertBefore(t,this._globalNode)}),dhtmlXSlider.prototype._setOrient=function(t){t=t||!1,/\s?dhxsl_cont_hr/i.test(this._nodes.cont.className)&&(this._nodes.cont.className=this._nodes.cont.className.replace(/\s?dhxsl_cont_hr/i,"")),/\s?dhxsl_cont_vr/i.test(this._nodes.cont.className)&&(this._nodes.cont.className=this._nodes.cont.className.replace(/\s?dhxsl_cont_vr/i,"")),this._nodes.cont.className+=t?" dhxsl_cont_vr":" dhxsl_cont_hr"},dhtmlXSlider.prototype._getTouchCoord=function(t){var e=(null!=t.type.match(/mouse/)?"client":"page")+(1==this.conf.vertical?"Y":"X");return void 0!==t[e]&&0!=t[e]?t[e]:null!=t.touches&&null!=t.touches[0]&&t.touches[0][e]||0},dhtmlXSlider.prototype._attachEvents=function(t){"function"==typeof window.addEventListener?(t.runner.addEventListener("mousedown",this._initMover,!1),t.runner.addEventListener("touchstart",this._initMover,!1),t.cont.addEventListener("mousedown",this._doOnSetValue,!1),t.cont.addEventListener("touchstart",this._doOnSetValue,!1),t.runner2&&(t.runner2.addEventListener("mousedown",this._initMover,!1),t.runner2.addEventListener("touchstart",this._initMover,!1))):(t.runner.attachEvent("onmousedown",this._initMover),t.cont.attachEvent("onmousedown",this._doOnSetValue),t.runner2&&t.runner2.attachEvent("onmousedown",this._initMover))},dhtmlXSlider.prototype._detachEvents=function(t){"function"==typeof window.addEventListener?(t.runner.removeEventListener("mousedown",this._initMover,!1),t.runner.removeEventListener("touchstart",this._initMover,!1),t.cont.removeEventListener("mousedown",this._doOnSetValue,!1),t.cont.removeEventListener("touchstart",this._doOnSetValue,!1),t.runner2&&(t.runner2.removeEventListener("mousedown",this._initMover,!1),t.runner2.removeEventListener("touchstart",this._initMover,!1))):(t.runner.detachEvent("onmousedown",this._initMover),t.cont.detachEvent("onmousedown",this._doOnSetValue),t.runner2&&t.runner2.detachEvent("onmousedown",this._initMover))},dhtmlXSlider.prototype._mergeConfig=function(t){for(var e in t)switch(e.toLowerCase()){case"min":case"max":case"size":case"step":case"value":case"inverse":this.conf[e]=t[e];break;case"tooltip":case"visible":case"vertical":case"disabled":case"range":case"bg":this.conf[e]=dhx4.s2b(t[e]);break;case"bg_mode":this.conf[e]={left:"left",right:"right"}[t[e]]||"left";break;case"parent":continue;case"skin":this.conf[e]=1==this._skinCollection[t[e]]?t[e]:null;break;default:this.conf[e]=t[e]}},dhtmlXSlider.prototype._readAttFormNode=function(t){var e,n,i=t.attributes,a=i.length,o={};for(e=0;e<a;e++)switch((n=i[e]).name.toLowerCase()){case"size":case"min":case"max":case"value":case"step":o[n.name]=Number(n.value);break;case"skin":o[n.name]=n.value;break;case"vertical":case"disabled":case"visible":case"range":case"bg":o[n.name]=dhx4.s2b(n.value);break;case"linkto":o[n.name]=n.value;break;case"tooltip":o[n.name]=dhx4.s2b(n.value);break;case"bg_mode":o[n.name]={left:"left",right:"right"}[n.value]||"left"}return o},dhtmlXSlider.prototype._renderArgumets=function(t){var e,n,i={};for(n=t.length,e=0;e<n;e++)switch(e){case 0:i.parent=t[e];break;case 1:i.size=t[e];break;case 2:i.skin=t[e];break;case 3:i.vertical=t[e];break;case 4:i.min=t[e];break;case 5:i.max=t[e];break;case 6:i.value=t[e];break;case 7:i.step=t[e]}return i},dhtmlXSlider.prototype._skinCollection={dhx_skyblue:!0,dhx_web:!0,dhx_terrace:!0,material:!0},dhtmlXSlider.prototype._indexOf=function(t,e){var n,i=-1;for(n=t.length;n>=0;n--)if(t[n]==e){i=n;break}return i},dhtmlXSlider.prototype._refreshRunner=function(t){var e=1==this.conf.vertical?{x:"top",y:"left",ofs_w:"offsetHeight",ofs_h:"offsetWidth"}:{x:"left",y:"top",ofs_w:"offsetWidth",ofs_h:"offsetHeight"},n=this._nodes.cont[e.ofs_w]-this._nodes.runner[e.ofs_w],i=this._nodes.runner,a=this._nodes.runner2;if(null==t||0==t){var o=this._getCoord(n,this.conf.value instanceof Array?this.conf.value[0]:this.conf.value);i.style[e.x]=o+this.conf.border+"px",i.style[e.y]=Math.round((this._nodes.cont[e.ofs_h]-i[e.ofs_h])/2)+"px"}if(1==this.conf.range&&(null==t||1==t)){o=this._getCoord(n,this.conf.value[1]);a.style[e.x]=o+this.conf.border+"px",a.style[e.y]=Math.round((this._nodes.cont[e.ofs_h]-i[e.ofs_h])/2)+"px"}1==this.conf.range&&(i.style[e.x]==a.style[e.x]&&this.conf.value[1]==this.conf.max?2!=i.style.zIndex&&(i.style.zIndex=2):2==i.style.zIndex&&(i.style.zIndex=1)),i=a=null,this._refreshBG()},dhtmlXSlider.prototype._setValueByCoord=function(t){var e,n,i=dhx4.absLeft(this._nodes.cont),a=dhx4.absTop(this._nodes.cont);n=this.conf.vertical?(t.y-a-this._nodes.runner.offsetHeight/2)/(this._nodes.cont.offsetHeight-this._nodes.runner.offsetHeight):(t.x-i-this._nodes.runner.offsetWidth/2)/(this._nodes.cont.offsetWidth-this._nodes.runner.offsetWidth),e=(this.conf.max-this.conf.min)*n+this.conf.min,this.setValue(e,!0)},dhtmlXSlider.prototype._getCoord=function(t,e){var n=((this.conf.inverse?this._inverseValue(e):e)-this.conf.min)/(this.conf.max-this.conf.min);return Math.round(t*n)},dhtmlXSlider.prototype._normalize=function(t,e,n){t=Number(t),t=Math.round(t/this.conf.step)*this.conf.step;var i=Math.pow(10,this.conf.decimals);return t=Math.round(t*i)/i,t=Math.max(e,Math.min(n,t))},dhtmlXSlider.prototype._normalizeRange=function(t,e,n){return t[1]<t[0]&&(t[1]=t[0]),t[0]=this._normalize(t[0],e,Math.min(n,t[1])),t[1]=this._normalize(t[1],Math.max(e,t[0]),n),t},dhtmlXSlider.prototype._refreshBG=function(){if(1==this.conf.bg){var t=this._nodes.track.firstChild,e=this._nodes.runner,n=e.nextSibling,i=1==this.conf.vertical?{x:"top",w:"height",ofs:"offsetHeight"}:{x:"left",w:"width",ofs:"offsetWidth"};if(1==this.conf.range)t.style[i.x]=Math.floor(parseInt(e.style[i.x])+e[i.ofs]/2)+"px",t.style[i.w]=Math.max(Math.floor(parseInt(n.style[i.x])+n[i.ofs]/2)-parseInt(t.style[i.x]),0)+"px";else{var a=1==this.conf.inverse?{left:"right",right:"left"}[this.conf.bg_mode]:this.conf.bg_mode;t.style[i.x]=("left"==a?"0":Math.floor(parseInt(e.style[i.x])+e[i.ofs]/2))+"px",t.style[i.w]=("left"==a?Math.floor(parseInt(e.style[i.x])+e[i.ofs]/2):this._nodes.track[i.ofs]-parseInt(t.style[i.x]))+"px"}t=e=n=null}},dhtmlXSlider.prototype._attachNode=function(t,e){this._detachNode(e);var n=t.tagName.toLowerCase();if(n){switch(this._attachedNode["node_"+e]=t,n){case"input":case"select":"function"==typeof window.addEventListener?(t.addEventListener("change",this._doOnChangeInput,!1),t.addEventListener("keydown",this._doOnKeyDown,!1)):(t.attachEvent("onchange",this._doOnChangeInput),t.attachEvent("onkeydown",this._doOnKeyDown)),this._attachedNode.setValue=function(t,e,n){var i=t instanceof Array?t[n||0]:t;this["node_"+(n||0)].value=dhtmlXSlider.prototype._atatchedNodeFixDec(i,e)};break;default:this._attachedNode.setValue=function(t,e,n){var i=t instanceof Array?t[n||0]:t;this["node_"+(n||0)].innerHTML=dhtmlXSlider.prototype._atatchedNodeFixDec(i,e)}}this._attachedNode.setValue(this.conf.value,this.conf.decimals,e)}},dhtmlXSlider.prototype._detachNode=function(t){var e=this._attachedNode["node_"+t];if(e){switch(e.tagName){case"input":case"select":"function"==typeof window.addEventListener?(e.removeEventListener("change",this._doOnChangeInput,!1),e.removeEventListener("keydown",this._doOnChangeInput,!1)):(e.detachEvent("change",this._doOnChangeInput),e.detachEvent("keydown",this._doOnChangeInput))}delete this._attachedNode["node_"+t],delete this._attachedNode.setValue,e=null}},dhtmlXSlider.prototype._atatchedNodeFixDec=function(t,e){if(t=String(t),e>0){var n=t.match(/\.\d{1,}$/);null!=n&&(e=Math.max(e-n[0].length+1)),t+=t.indexOf(".")<0?".":"";for(var i=0;i<e;i++)t+="0"}return t},dhtmlXSlider.prototype._detectDecimals=function(){var t=this.conf.step.toString().match(/\.(\d*)$/);this.conf.decimals=null!=t?t[1].length:0},dhtmlXSlider.prototype.setSize=function(t){isNaN(t)||(this.conf.vertical?(this._nodes.cont.style.width&&delete this._nodes.cont.style.width,this._nodes.cont.style.height=t-this.conf.margin+"px"):(this._nodes.cont.style.height&&delete this._nodes.cont.style.height,this._nodes.cont.style.width=t-this.conf.margin+"px"),this._refreshRunner())},dhtmlXSlider.prototype.setSkin=function(t){t=t.toLowerCase();var e,n,i=-1,a="dhtmlxslider";if((e=this.base.className.match(/\S\w+/gi))instanceof Array){for(n in this._skinCollection){if(-1!=i)break;i=this._indexOf(e,a+"_"+n)}i=-1==i?e.length:i}else e=[],i=0;e[i]=a+"_"+t,this.base.className=e.join(" "),this.conf.skin=t,this._nodes&&this._refreshRunner()},dhtmlXSlider.prototype.setValue=function(t,e){e=e||!1;var n=null;if(1==this.conf.range?(null!=this._r_actv&&(n=this._r_actv==this._nodes.runner?0:1),t=this._normalizeRange(t,this.conf.min,this.conf.max),this.conf.value[0]!=t[0]||this.conf.value[1]!=t[1]):(t=this._normalize(t,this.conf.min,this.conf.max),this.conf.value!=t),!0&&(this.conf.value=t,this._refreshRunner(n),this._refreshTooltip(),e)){var i=[t,this];1==this.conf.range&&(null!=this._r_actv?i.push(this._r_actv==this._nodes.runner?0:1):null!=this.conf.init_index&&i.push(this.conf.init_index.valueOf())),this.callEvent("onChange",i)}"function"==typeof this._attachedNode.setValue&&(null==n&&(n=this.conf.init_index),this._attachedNode.setValue(this.conf.value,this.conf.decimals,n))},dhtmlXSlider.prototype.getValue=function(){return 1==this.conf.range?[this.conf.value[0].valueOf(),this.conf.value[1].valueOf()]:this.conf.value.valueOf()},dhtmlXSlider.prototype._inverseValue=function(t){return this.conf.max+this.conf.min-t},dhtmlXSlider.prototype.disable=function(t){if(t=0!=t){for(var e in this._nodes)if("cont"!=e){var n="runner2"==e?"runner":e;null!=this._nodes[e]&&(new RegExp("\\s?dhxsl_"+n+"_dis","i").test(this._nodes[e].className)||(this._nodes[e].className+=" dhxsl_"+n+"_dis"))}this.conf.disabled=!0}else this.enable()},dhtmlXSlider.prototype.enable=function(){var t;for(var e in this._nodes)if("cont"!=e){var n="runner2"==e?"runner":e;null!=this._nodes[e]&&(t=new RegExp("\\s?dhxsl_"+n+"_dis","i")).test(this._nodes[e].className)&&(this._nodes[e].className=this._nodes[e].className.replace(t,""))}this.conf.disabled=!1},dhtmlXSlider.prototype.isEnabled=function(){return!this.conf.disabled},dhtmlXSlider.prototype.disableTooltip=function(){this._nodes.cont.removeAttribute("title"),this.conf.tooltip=!1},dhtmlXSlider.prototype.enableTooltip=function(t){(t=void 0===t||dhx4.s2b(t))?(this.conf.tooltip=!0,this._refreshTooltip()):this.disableTooltip()},dhtmlXSlider.prototype.setMax=function(t){!isNaN(t)&&this.conf.min<t&&(this.conf.max=t,this.setValue(this.conf.value))},dhtmlXSlider.prototype.getMax=function(){return this.conf.max},dhtmlXSlider.prototype.setMin=function(t){!isNaN(t)&&this.conf.max>t&&(this.conf.min=t,this.setValue(this.conf.value))},dhtmlXSlider.prototype.getMin=function(){return this.conf.min},dhtmlXSlider.prototype.setStep=function(t){var e=this.conf.max-this.conf.min;!isNaN(t)&&t<e&&(this.conf.step=t,this._detectDecimals(),this.setValue(this.conf.value))},dhtmlXSlider.prototype.getStep=function(){return this.conf.step},dhtmlXSlider.prototype.show=function(){/\s?dhxsl_hidden/i.test(this._nodes.cont.className)&&(this._nodes.cont.className=this._nodes.cont.className.replace(/\s?dhxsl_hidden/i,"")),this.conf.visible=!0},dhtmlXSlider.prototype.hide=function(){/\s?dhxsl_hidden/i.test(this._nodes.cont.className)||(this._nodes.cont.className+=" dhxsl_hidden"),this.conf.visible=!1},dhtmlXSlider.prototype.isVisible=function(){return this.conf.visible},dhtmlXSlider.prototype.linkTo=function(t){t instanceof Array||(t=[t]);for(var e=0;e<t.length&&e<2;e++)null!=t[e]&&("string"==typeof t[e]&&(t[e]=document.getElementById(t[e])),this._attachNode(t[e],e))},dhtmlXSlider.prototype._refreshTooltip=function(){1==this.conf.tooltip&&(this.conf.value instanceof Array?this._nodes.cont.title=this.conf.value.join(", "):this._nodes.cont.title=this.conf.value)},dhtmlXSlider.prototype.getRunnerIndex=function(){return null==this._r_actv?-1:this._r_actv==this._nodes.runner?0:1},dhtmlXPopup.prototype.attachObject=function(t){return this._attachNode("object",{obj:t})},dhtmlXPopup.prototype._attach_init_object=function(t){this._nodeObj="string"==typeof t.obj?document.getElementById(t.obj):t.obj,t.obj=null,document.getElementById(this._nodeId).appendChild(this._nodeObj),this._nodeObj.style.display="",this._nodeObj.style.visibility="visible"},dhtmlXPopup.prototype.attachHTML=function(t){return this._attachNode("html",{html:t})},dhtmlXPopup.prototype._attach_init_html=function(t){document.getElementById(this._nodeId).innerHTML=t.html,this._nodeObj={text:t.html}},dhtmlXPopup.prototype.attachForm=function(t,e){return this._attachNode("form",{struct:t,width:e})},dhtmlXPopup.prototype._attach_init_form=function(t){var e=this;this._nodeObj=new dhtmlXForm(this._nodeId,t.struct),this._nodeObj.setSkin(this.conf.skin),this._nodeObj.attachEvent("_onBeforeEditorAccess",function(){e._clearClick=!0}),null!=this.conf.editorEv&&0==this.checkEvent(this.conf.editorEv)&&(this.conf.editorEv=null),null!=dhtmlXForm.prototype.items.editor&&null==this.conf.editorEv&&(this.conf.editorEv=this.attachEvent("onShow",function(){var t=dhtmlXForm.prototype.items.editor.editor;for(var e in t){for(var n=t[e].base,i=!1;null!=n;)n==this.p?(i=!0,n=null):n=n.parentNode;n=null,1==i&&(t[e].cell.conf.cells_cont=null,t[e].setSizes())}t=null,this.detachEvent(this.conf.editorEv),this.conf.editorEv=null}),null==this._nodeObjEv&&(this._nodeObjEv=[]),this._nodeObjEv.push(this.conf.editorEv))},dhtmlXPopup.prototype.attachCalendar=function(t){return this._attachNode("calendar",t||{})},dhtmlXPopup.prototype._attach_init_calendar=function(t){1==t.double?(this._nodeObj=new dhtmlXDoubleCalendarObject(this._nodeId),this._nodeObj.leftCalendar.setSkin(this.conf.skin),this._nodeObj.rightCalendar.setSkin(this.conf.skin)):(this._nodeObj=new dhtmlXCalendarObject(this._nodeId),this._nodeObj.setSkin(this.conf.skin)),this._nodeObj.show()},dhtmlXPopup.prototype.attachGrid=function(t,e){return this._attachNode("grid",{width:t||400,height:e||200})},dhtmlXPopup.prototype._attach_init_grid=function(){this._nodeObj=new dhtmlXGridObject(this._nodeId),this._nodeObj.setSkin(this.conf.skin)},dhtmlXPopup.prototype.attachTree=function(t,e,n){return this._attachNode("tree",{width:t||400,height:e||200,rootId:n||0})},dhtmlXPopup.prototype._attach_init_tree=function(t){this._nodeObj=new dhtmlXTreeObject(this._nodeId,"100%","100%",t.rootId)},dhtmlXPopup.prototype.attachLayout=function(t,e,n){return this._attachNode("layout",{width:t||400,height:e||200,pattern:n||"3L"})},dhtmlXPopup.prototype._attach_init_layout=function(t){this._nodeObj=new dhtmlXLayoutObject(this._nodeId,t.pattern,this.conf.skin)},dhtmlXPopup.prototype.attachAccordion=function(t,e,n){return this._attachNode("accordion",{width:t||400,height:e||200,conf:n||{}})},dhtmlXPopup.prototype._attach_init_accordion=function(t){t.conf.parent=this._nodeId,t.conf.skin=this.conf.skin,this._nodeObj=new dhtmlXAccordion(t.conf)},dhtmlXPopup.prototype.attachTabbar=function(t,e,n){return"string"==typeof n?n={mode:n}:"object"==typeof n&&null!=n||(n={}),this._attachNode("tabbar",{width:t||400,height:e||200,conf:n})},dhtmlXPopup.prototype._attach_init_tabbar=function(t){t.conf.parent=this._nodeId,t.conf.skin=this.conf.skin,this._nodeObj=new dhtmlXTabBar(t.conf)},dhtmlXPopup.prototype.attachSidebar=function(t,e,n){return null==n&&(n={}),this._attachNode("sidebar",{width:t||400,height:e||200,conf:n})},dhtmlXPopup.prototype._attach_init_sidebar=function(t){t.conf.parent=this._nodeId,t.conf.skin=this.conf.skin,this._nodeObj=new dhtmlXSideBar(t.conf)},dhtmlXPopup.prototype.attachEditor=function(t,e,n){return this._attachNode("editor",{width:t||400,height:e||200,conf:n||{}})},dhtmlXPopup.prototype._attach_init_editor=function(t){document.getElementById(this._nodeId).className="dhxeditor_"+this.conf.skin,t.conf.parent=this._nodeId,null==t.conf.skin&&(t.conf.skin=this.conf.skin),this._nodeObj=new dhtmlXEditor(t.conf);var e=this.attachEvent("onShow",function(){this._nodeObj instanceof window.dhtmlXEditor&&this._nodeObj.setSizes()});null==this._nodeObjEv&&(this._nodeObjEv=[]),this._nodeObjEv.push(e)},dhtmlXPopup.prototype.attachColorPicker=function(t){return"object"==typeof t&&null!=t||(t={}),this._attachNode("colorpicker",{conf:t})},dhtmlXPopup.prototype._attach_init_colorpicker=function(t){t.conf.skin=this.conf.skin,t.conf.parent=this._nodeId,this._nodeObj=new dhtmlXColorPicker(t.conf)},dhtmlXPopup.prototype.attachCarousel=function(t,e,n){return null==n&&(n={}),this._attachNode("carousel",{width:t||400,height:e||300,conf:n})},dhtmlXPopup.prototype._attach_init_carousel=function(t){t.conf.parent=this._nodeId,t.conf.skin=this.conf.skin,this._nodeObj=new dhtmlXCarousel(t.conf)},dhtmlXPopup.prototype.attachTreeView=function(t,e,n){return null==n&&(n={}),this._attachNode("treeview",{width:t||400,height:e||300,conf:n})},dhtmlXPopup.prototype._attach_init_treeview=function(t){t.conf.parent=this._nodeId,t.conf.skin=this.conf.skin,this._nodeObj=new dhtmlXTreeView(t.conf),this._nodeObj.base.className+=" dhxtreeview_with_border";var e=this.attachEvent("onShow",function(){this._nodeObj instanceof window.dhtmlXTreeView&&this._nodeObj.setSizes()});null==this._nodeObjEv&&(this._nodeObjEv=[]),this._nodeObjEv.push(e)},dhtmlXPopup.prototype.setDimension=function(t,e){if(null!=this._nodeId&&(null!=t||null!=e)){var n=document.getElementById(this._nodeId);null!=t&&(n.style.width=t+"px"),null!=e&&(n.style.height=e+"px"),this._repaint(),null!=this._nodeObj&&"function"==typeof this._nodeObj.setSizes&&this._nodeObj.setSizes(),n=null}},dhtmlXMenuObject.prototype._init=function(){1!=this._isInited&&(this.conf.dload?(this._dhxdataload.onBeforeXLS=function(){var t={params:{}};for(var e in this.conf.dload_params)t.params[e]=this.conf.dload_params[e];return t},this.loadStruct(this.conf.dload_url)):(this._initTopLevelMenu(),this._isInited=!0))},dhtmlXMenuObject.prototype._countVisiblePolygonItems=function(t){var e=0;for(var n in this.itemPull){var i=this.itemPull[n].parent,a=this.itemPull[n].type;null!=this.idPull[n]&&(i!=t||"item"!=a&&"radio"!=a&&"checkbox"!=a||"none"==this.idPull[n].style.display||e++)}return e},dhtmlXMenuObject.prototype._redefineComplexState=function(t){if(this.idPrefix+this.topId!=t&&null!=this.idPull["polygon_"+t]&&null!=this.idPull[t]){var e=this._countVisiblePolygonItems(t);e>0&&!this.itemPull[t].complex&&this._updateItemComplexState(t,!0,!1),0==e&&this.itemPull[t].complex&&this._updateItemComplexState(t,!1,!1)}},dhtmlXMenuObject.prototype._updateItemComplexState=function(t,e,n){if(this.conf.context||"TopLevel"!=this._getItemLevelType(t.replace(this.idPrefix,""))){if(null!=this.idPull[t]&&null!=this.itemPull[t]&&(this.itemPull[t].complex=e,t!=this.idPrefix+this.topId)){var i=null,a=this.idPull[t].childNodes[this.conf.rtl?0:2];if(a.childNodes[0]&&0===String(a.childNodes[0].className).search("complex_arrow")&&(i=a.childNodes[0]),this.itemPull[t].complex){if(null==i){for((i=document.createElement("DIV")).className="complex_arrow",i.id="arrow_"+t;a.childNodes.length>0;)a.removeChild(a.childNodes[0]);a.appendChild(i)}this.conf.dload&&"get"==this.itemPull[t].loaded&&this.conf.dload_icon?"complex_arrow_loading"!=i.className&&(i.className="complex_arrow_loading"):i.className="complex_arrow"}else this.itemPull[t].complex||null==i||(a.removeChild(i),null!=this.itemPull[t].hotkey_backup&&this.setHotKey&&this.setHotKey(t.replace(this.idPrefix,""),this.itemPull[t].hotkey_backup))}}else this.itemPull[t].complex=e},dhtmlXMenuObject.prototype._getItemLevelType=function(t){return this.itemPull[this.idPrefix+t].parent==this.idPrefix+this.topId?"TopLevel":"SubLevelArea"},dhtmlXMenuObject.prototype.setIconsPath=function(t){this.conf.icons_path=t},dhtmlXMenuObject.prototype._updateItemImage=function(t,e){t=this.idPrefix+t;var n=this.itemPull[t].type;if("checkbox"!=n&&"radio"!=n){var i=this.itemPull[t].parent==this.idPrefix+this.topId&&!this.conf.context,a=null;if(i)for(var o=0;o<this.idPull[t].childNodes.length;o++)(null==a&&"dhtmlxMenu_TopLevel_Item_Icon"==(this.idPull[t].childNodes[o].className||"")||"i"==(this.idPull[t].childNodes[o].tagName||"").toLowerCase())&&(a=this.idPull[t].childNodes[o]);else{try{a=this.idPull[t].childNodes[this.conf.rtl?2:0].childNodes[0]}catch(t){}(null==a||void 0===a.className||"sub_icon"!=a.className&&"i"!=a.tagName.toLowerCase())&&(a=null)}var r=this.itemPull[t]["enabled"==this.itemPull[t].state?"imgen":"imgdis"];if(r.length>0)if(null!=a)1==this.conf.icons_css?a.className=this.conf.icons_path+r:a.src=this.conf.icons_path+r;else if(i){if(1==this.conf.icons_css)(a=document.createElement("i")).className=this.conf.icons_path+r;else(a=document.createElement("IMG")).className="dhtmlxMenu_TopLevel_Item_Icon",a.src=this.conf.icons_path+r,a.border="0",a.id="image_"+t;!this.conf.rtl&&this.idPull[t].childNodes.length>0?this.idPull[t].insertBefore(a,this.idPull[t].childNodes[0]):this.idPull[t].appendChild(a)}else if(1==this.conf.icons_css){(s=this.idPull[t].childNodes[this.conf.rtl?2:0]).innerHTML="<i class='"+this.conf.icons_path+r+"'></i>"}else{(a=document.createElement("IMG")).className="sub_icon",a.src=this.conf.icons_path+r,a.border="0",a.id="image_"+t;for(var s=this.idPull[t].childNodes[this.conf.rtl?2:0];s.childNodes.length>0;)s.removeChild(s.childNodes[0]);s.appendChild(a)}else if(null!=a)if(i)a.parentNode.removeChild(a),a=null;else{var l=a.parentNode;l.removeChild(a),l.innerHTML="&nbsp;",l=a=null}}},dhtmlXMenuObject.prototype._getAllParents=function(t){var e=new Array;for(var n in this.itemPull)if(this.itemPull[n].parent==t&&(e[e.length]=this.itemPull[n].id,this.itemPull[n].complex))for(var i=this._getAllParents(this.itemPull[n].id),a=0;a<i.length;a++)e[e.length]=i[a];return e},dhtmlXMenuObject.prototype._autoDetectVisibleArea=function(){if(!this.conf.v_enabled){var t=window.dhx4.screenDim();this.conf.v.x1=t.left,this.conf.v.x2=t.right,this.conf.v.y1=t.top,this.conf.v.y2=t.bottom}},dhtmlXMenuObject.prototype.getItemPosition=function(t){t=this.idPrefix+t;var e=-1;if(null==this.itemPull[t])return e;for(var n=this.itemPull[t].parent,i=null!=this.idPull["polygon_"+n]?this.idPull["polygon_"+n].tbd:this.cont,a=0;a<i.childNodes.length;a++)i.childNodes[a]!=this.idPull["separator_"+t]&&i.childNodes[a]!=this.idPull[t]||(e=a);return e},dhtmlXMenuObject.prototype.setItemPosition=function(t,e){if(t=this.idPrefix+t,null!=this.idPull[t]){var n=this.itemPull[t].parent==this.idPrefix+this.topId,i=this.idPull[t],a=this.getItemPosition(t.replace(this.idPrefix,"")),o=this.itemPull[t].parent,r=null!=this.idPull["polygon_"+o]?this.idPull["polygon_"+o].tbd:this.cont;r.removeChild(r.childNodes[a]),e<0&&(e=0),n&&e<1&&(e=1),e<r.childNodes.length?r.insertBefore(i,r.childNodes[e]):r.appendChild(i)}},dhtmlXMenuObject.prototype.getParentId=function(t){return t=this.idPrefix+t,null==this.itemPull[t]?null:(null!=this.itemPull[t].parent?this.itemPull[t].parent:this.topId).replace(this.idPrefix,"")},dhtmlXMenuObject.prototype.hide=function(){this._clearAndHide()},dhtmlXMenuObject.prototype.clearAll=function(){this.removeItem(this.idPrefix+this.topId,!0),this._isInited=!1,this.idPrefix=this._genStr(12)+"_",this.itemPull={}},void 0===dhtmlXMenuObject.prototype.liveInst&&(dhtmlXMenuObject.prototype.liveInst={}),dhtmlXMenuObject.prototype.setIconset=function(t){this.conf.icons_css="awesome"==t},dhtmlXMenuObject.prototype._redistribTopLevelSelection=function(t,e){var n=this._getSubItemToDeselectByPolygon("parent");this._removeSubItemFromSelected(-1,-1);for(var i=0;i<n.length;i++)n[i]!=t&&this._hidePolygon(n[i]),null!=this.idPull[n[i]]&&n[i]!=t&&(this.idPull[n[i]].className=this.idPull[n[i]].className.replace(/Selected/g,"Normal"));"enabled"==this.itemPull[this.idPrefix+t].state&&(this.idPull[this.idPrefix+t].className="dhtmlxMenu_"+this.conf.skin+"_TopLevel_Item_Selected",this._addSubItemToSelected(this.idPrefix+t,"parent"),this.conf.selected="win"==this.conf.mode?-1!=this.conf.selected?t:this.conf.selected:t,this.itemPull[this.idPrefix+t].complex&&-1!=this.conf.selected&&this._showPolygon(this.idPrefix+t,this.conf.dir_toplv))},dhtmlXMenuObject.prototype._initTopLevelMenu=function(){if(this.conf.dir_toplv="bottom",this.conf.dir_sublv=this.conf.rtl?"left":"right",this.conf.context)this.idPull[this.idPrefix+this.topId]=new Array(0,0),this._addSubMenuPolygon(this.idPrefix+this.topId,this.idPrefix+this.topId);else for(var t=this._getMenuNodes(this.idPrefix+this.topId),e=0;e<t.length;e++)"item"==this.itemPull[t[e]].type&&this._renderToplevelItem(t[e],null),"separator"==this.itemPull[t[e]].type&&this._renderSeparator(t[e],null)},dhtmlXMenuObject.prototype._renderToplevelItem=function(t,e){var n=this,i=document.createElement("DIV");if(i.id=t,"enabled"==this.itemPull[t].state&&null!=this.itemPull[t].cssNormal?i.className=this.itemPull[t].cssNormal:i.className="dhtmlxMenu_"+this.conf.skin+"_TopLevel_Item_"+("enabled"==this.itemPull[t].state?"Normal":"Disabled"),""!=this.itemPull[t].title){var a=document.createElement("DIV");a.className="top_level_text",a.innerHTML=this.itemPull[t].title,i.appendChild(a)}if(this.itemPull[t].tip.length>0&&(i.title=this.itemPull[t].tip),""!=this.itemPull[t].imgen||""!=this.itemPull[t].imgdis){var o=this.itemPull[t]["enabled"==this.itemPull[t].state?"imgen":"imgdis"];if(o)if(1==this.conf.icons_css){var r=document.createElement("i");r.className=this.conf.icons_path+o,i.childNodes.length>0&&!this.conf.rtl?i.insertBefore(r,i.childNodes[0]):i.appendChild(r)}else{var s=document.createElement("IMG");s.border="0",s.id="image_"+t,s.src=this.conf.icons_path+o,s.className="dhtmlxMenu_TopLevel_Item_Icon",i.childNodes.length>0&&!this.conf.rtl?i.insertBefore(s,i.childNodes[0]):i.appendChild(s)}}i.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},i.oncontextmenu=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this.cont||(this.cont=document.createElement("DIV"),this.cont.dir="ltr",this.cont.className="right"==this.conf.align?"align_right":"align_left",this.base.appendChild(this.cont)),null!=e&&(++e<0&&(e=0),e>this.cont.childNodes.length-1&&(e=null)),null!=e?this.cont.insertBefore(i,this.cont.childNodes[e]):this.cont.appendChild(i),this.idPull[i.id]=i,this.itemPull[t].complex&&!this.conf.dload&&this._addSubMenuPolygon(this.itemPull[t].id,this.itemPull[t].id),i.onmouseover=function(){"web"==n.conf.mode&&window.clearTimeout(n.conf.tm_handler);var t=n._getSubItemToDeselectByPolygon("parent");n._removeSubItemFromSelected(-1,-1);for(var e=0;e<t.length;e++)t[e]!=this.id&&n._hidePolygon(t[e]),null!=n.idPull[t[e]]&&t[e]!=this.id&&(null!=n.itemPull[t[e]].cssNormal?n.idPull[t[e]].className=n.itemPull[t[e]].cssNormal:("sub_item_selected"==n.idPull[t[e]].className&&(n.idPull[t[e]].className="sub_item"),n.idPull[t[e]].className=n.idPull[t[e]].className.replace(/Selected/g,"Normal")));if("enabled"==n.itemPull[this.id].state){if(this.className="dhtmlxMenu_"+n.conf.skin+"_TopLevel_Item_Selected",n._addSubItemToSelected(this.id,"parent"),n.conf.selected="win"==n.conf.mode?-1!=n.conf.selected?this.id:n.conf.selected:this.id,n.conf.dload){if("no"==n.itemPull[this.id].loaded){this._dynLoadTM=(new Date).getTime(),n.itemPull[this.id].loaded="get";var i=this.id.replace(n.idPrefix,"");n._dhxdataload.onBeforeXLS=function(){var t={params:{}};for(var e in t.params[this.conf.dload_pid]=i,this.conf.dload_params)t.params[e]=this.conf.dload_params[e];return t},n.loadStruct(n.conf.dload_url)}n.conf.top_mode&&"web"==n.conf.mode&&!n.conf.context&&(this._mouseOver=!0)}if((!n.conf.dload||n.conf.dload&&(!n.itemPull[this.id].loaded||"yes"==n.itemPull[this.id].loaded))&&n.itemPull[this.id].complex&&-1!=n.conf.selected)if(n.conf.top_mode&&"web"==n.conf.mode&&!n.conf.context){this._mouseOver=!0;var a=this.id;this._menuOpenTM=window.setTimeout(function(){n._showPolygon(a,n.conf.dir_toplv)},n.conf.top_tmtime)}else n._showPolygon(this.id,n.conf.dir_toplv)}n._doOnTouchMenu(this.id.replace(n.idPrefix,""))},i.onmouseout=function(){n.itemPull[this.id].complex&&-1!=n.conf.selected||"enabled"!=n.itemPull[this.id].state||(null!=n.itemPull[this.id].cssNormal?i.className=n.itemPull[this.id].cssNormal:i.className="dhtmlxMenu_"+n.conf.skin+"_TopLevel_Item_Normal"),"web"==n.conf.mode&&(window.clearTimeout(n.conf.tm_handler),n.conf.tm_handler=window.setTimeout(function(){n._clearAndHide()},n.conf.tm_sec,"JavaScript")),n.conf.top_mode&&"web"==n.conf.mode&&!n.conf.context&&(this._mouseOver=!1,window.clearTimeout(this._menuOpenTM))},i.onclick=function(t){if("web"==n.conf.mode&&window.clearTimeout(n.conf.tm_handler),"web"==n.conf.mode||"disabled"!=n.itemPull[this.id].state){if((t=t||event).cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,"win"==n.conf.mode&&n.itemPull[this.id].complex){if(n.conf.selected==this.id){n.conf.selected=-1;var e=!1}else{n.conf.selected=this.id;e=!0}e?n._showPolygon(this.id,n.conf.dir_toplv):n._hidePolygon(this.id)}var i=n.itemPull[this.id].complex?"c":"-",a="enabled"!=n.itemPull[this.id].state?"d":"-",o={ctrl:t.ctrlKey,alt:t.altKey,shift:t.shiftKey};return n._doOnClick(this.id.replace(n.idPrefix,""),i+a+"t",o),!1}},"dhx_terrace"==this.conf.skin&&this._improveTerraceSkin()},dhtmlXMenuObject.prototype._addSubMenuPolygon=function(t,e){this._renderSublevelPolygon(t,e);var n=this._getMenuNodes(e);for(i=0;i<n.length;i++)"separator"==this.itemPull[n[i]].type?this._renderSeparator(n[i],null):this._renderSublevelItem(n[i],null);if(t==e);else;for(var i=0;i<n.length;i++)this.itemPull[n[i]].complex&&this._addSubMenuPolygon(t,this.itemPull[n[i]].id)},dhtmlXMenuObject.prototype._renderSublevelPolygon=function(t,e){var n=document.createElement("DIV");n.className="dhtmlxMenu_"+this.conf.skin+"_SubLevelArea_Polygon "+(this.conf.rtl?"dir_right":""),n.dir="ltr",n.oncontextmenu=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,t.cancelBubble=!0,!1},n.id="polygon_"+e,n.onclick=function(t){(t=t||event).cancelBubble=!0},n.style.display="none",document.body.insertBefore(n,document.body.firstChild),n.innerHTML='<div style="position:relative;"></div><div style="position: relative; overflow:hidden;"></div><div style="position:relative;"></div>';var i=document.createElement("TABLE");i.className="dhtmlxMebu_SubLevelArea_Tbl",i.cellSpacing=0,i.cellPadding=0,i.border=0;var a=document.createElement("TBODY");return i.appendChild(a),n.childNodes[1].appendChild(i),n.tbl=i,n.tbd=a,this.idPull[n.id]=n,null!=this.sxDacProc&&(this.idPull["sxDac_"+e]=new this.sxDacProc(n,n.className),window.dhx4.isIE?(this.idPull["sxDac_"+e]._setSpeed(this.dacSpeedIE),this.idPull["sxDac_"+e]._setCustomCycle(this.dacCyclesIE)):(this.idPull["sxDac_"+e]._setSpeed(this.dacSpeed),this.idPull["sxDac_"+e]._setCustomCycle(this.dacCycles))),n},dhtmlXMenuObject.prototype._renderSublevelItem=function(t,e){var n=this,i=document.createElement("TR");i.className="enabled"==this.itemPull[t].state?"sub_item":"sub_item_dis";var a=document.createElement("TD");a.className="sub_item_icon";var o=this.itemPull[t].type,r=this.itemPull[t]["enabled"==this.itemPull[t].state?"imgen":"imgdis"];if(""!=r){var s;if("checkbox"==o||"radio"==o)(s=document.createElement("DIV")).id="image_"+this.itemPull[t].id,s.className="sub_icon "+r,a.appendChild(s);if("checkbox"!=o&&"radio"!=o)if(1==this.conf.icons_css)a.innerHTML="<i class='"+this.conf.icons_path+r+"'></i>";else(s=document.createElement("IMG")).id="image_"+this.itemPull[t].id,s.className="sub_icon",s.src=this.conf.icons_path+r,a.appendChild(s)}else a.innerHTML="&nbsp;";var l=document.createElement("TD");if(l.className="sub_item_text",""!=this.itemPull[t].title){var d=document.createElement("DIV");d.className="sub_item_text",d.innerHTML=this.itemPull[t].title,l.appendChild(d)}else l.innerHTML="&nbsp;";var c=document.createElement("TD");if(c.className="sub_item_hk",this.itemPull[t].complex){var h=document.createElement("DIV");h.className="complex_arrow",h.id="arrow_"+this.itemPull[t].id,c.appendChild(h)}else if(this.itemPull[t].hotkey.length>0&&!this.itemPull[t].complex){var u=document.createElement("DIV");u.className="sub_item_hk",u.innerHTML=this.itemPull[t].hotkey,c.appendChild(u)}else c.innerHTML="&nbsp;";i.appendChild(this.conf.rtl?c:a),i.appendChild(l),i.appendChild(this.conf.rtl?a:c),i.id=this.itemPull[t].id,i.parent=this.itemPull[t].parent,this.itemPull[t].tip.length>0&&(i.title=this.itemPull[t].tip),i.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},i.onmouseover=function(t){n.conf.hide_tm[this.id]&&window.clearTimeout(n.conf.hide_tm[this.id]),"web"==n.conf.mode&&window.clearTimeout(n.conf.tm_handler),this._visible||n._redistribSubLevelSelection(this.id,this.parent),this._visible=!0},i.onmouseout=function(){"web"==n.conf.mode&&(n.conf.tm_handler&&window.clearTimeout(n.conf.tm_handler),n.conf.tm_handler=window.setTimeout(function(){n&&n._clearAndHide&&n._clearAndHide()},n.conf.tm_sec,"JavaScript"));var t=this;n.conf.hide_tm[this.id]&&window.clearTimeout(n.conf.hide_tm[this.id]),n.conf.hide_tm[this.id]=window.setTimeout(function(){t._visible=!1},50)},i.onclick=function(t){if(n.checkEvent("onClick")||!n.itemPull[this.id].complex){(t=t||event).cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,tc=n.itemPull[this.id].complex?"c":"-",td="enabled"==n.itemPull[this.id].state?"-":"d";var e={ctrl:t.ctrlKey,alt:t.altKey,shift:t.shiftKey};switch(n.itemPull[this.id].type){case"checkbox":n._checkboxOnClickHandler(this.id.replace(n.idPrefix,""),tc+td+"n",e);break;case"radio":n._radioOnClickHandler(this.id.replace(n.idPrefix,""),tc+td+"n",e);break;case"item":n._doOnClick(this.id.replace(n.idPrefix,""),tc+td+"n",e)}return!1}};var m=this.idPull["polygon_"+this.itemPull[t].parent];null!=e&&(++e<0&&(e=0),e>m.tbd.childNodes.length-1&&(e=null)),null!=e&&null!=m.tbd.childNodes[e]?m.tbd.insertBefore(i,m.tbd.childNodes[e]):m.tbd.appendChild(i),this.idPull[i.id]=i},dhtmlXMenuObject.prototype._renderSeparator=function(t,e){var n=this.conf.context?"SubLevelArea":this.itemPull[t].parent==this.idPrefix+this.topId?"TopLevel":"SubLevelArea";if("TopLevel"!=n||!this.conf.context){var i=this;if("TopLevel"!=n){var a=document.createElement("TR");a.className="sub_sep";var o=document.createElement("TD");o.colSpan="3",a.appendChild(o)}var r=document.createElement("DIV");if(r.id="separator_"+t,r.className="TopLevel"==n?"top_sep":"sub_sep",r.onselectstart=function(t){(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1},r.onclick=function(t){(t=t||event).cancelBubble=!0;var e={ctrl:t.ctrlKey,alt:t.altKey,shift:t.shiftKey};i._doOnClick(this.id.replace("separator_"+i.idPrefix,""),"--s",e)},"TopLevel"==n){if(null!=e)++e<0&&(e=0),null!=this.cont.childNodes[e]?this.cont.insertBefore(r,this.cont.childNodes[e]):this.cont.appendChild(r);else{var s=this.cont.childNodes[this.cont.childNodes.length-1];-1==String(s).search("TopLevel_Text")?this.cont.appendChild(r):this.cont.insertBefore(r,s)}this.idPull[r.id]=r}else{var l=this.idPull["polygon_"+this.itemPull[t].parent];null!=e&&(++e<0&&(e=0),e>l.tbd.childNodes.length-1&&(e=null)),null!=e&&null!=l.tbd.childNodes[e]?l.tbd.insertBefore(a,l.tbd.childNodes[e]):l.tbd.appendChild(a),o.appendChild(r),this.idPull[r.id]=a}}},dhtmlXMenuObject.prototype.addNewSeparator=function(t,e){e=this.idPrefix+(null!=e?e:this._genStr(24));var n=this.idPrefix+this.getParentId(t);this._addItemIntoGlobalStrorage(e,n,"","separator",!1,"",""),this._renderSeparator(e,this.getItemPosition(t))},dhtmlXMenuObject.prototype._initObj=function(t,e,n){t instanceof Array||(null!=(n=t.parentId)&&0!==String(n).indexOf(this.idPrefix)&&(n=this.idPrefix+String(n)),t=t.items);for(var i=0;i<t.length;i++){void 0!==t[i].id&&null!=t[i].id||(t[i].id=this._genStr(24)),null==t[i].text&&(t[i].text=""),0!==String(t[i].id).indexOf(this.idPrefix)&&(t[i].id=this.idPrefix+String(t[i].id));var a={type:"item",tip:"",hotkey:"",state:"enabled",imgen:"",imgdis:""};for(var o in a)void 0===t[i][o]&&(t[i][o]=a[o]);if(""==t[i].imgen&&null!=t[i].img&&(t[i].imgen=t[i].img),""==t[i].imgdis&&null!=t[i].img_disabled&&(t[i].imgdis=t[i].img_disabled),null==t[i].title&&null!=t[i].text&&(t[i].title=t[i].text),null!=t[i].href&&(null!=t[i].href.link&&(t[i].href_link=t[i].href.link),null!=t[i].href.target&&(t[i].href_target=t[i].href.target)),null!=t[i].userdata)for(var o in t[i].userdata)this.userData[t[i].id+"_"+o]=t[i].userdata[o];void 0!==t[i].enabled&&0==window.dhx4.s2b(t[i].enabled)?t[i].state="disabled":void 0!==t[i].disabled&&1==window.dhx4.s2b(t[i].disabled)&&(t[i].state="disabled"),void 0===t[i].parent&&(t[i].parent=null!=n?n:this.idPrefix+this.topId),"checkbox"==t[i].type&&(t[i].checked=window.dhx4.s2b(t[i].checked),t[i].imgen=t[i].imgdis="chbx_"+(t[i].checked?"1":"0")),"radio"==t[i].type&&(t[i].checked=window.dhx4.s2b(t[i].checked),t[i].imgen=t[i].imgdis="rdbt_"+(t[i].checked?"1":"0"),void 0!==t[i].group&&null!=t[i].group||(t[i].group=this._genStr(24)),null==this.radio[t[i].group]&&(this.radio[t[i].group]=[]),this.radio[t[i].group].push(t[i].id)),this.itemPull[t[i].id]=t[i],null!=t[i].items&&t[i].items.length>0?(this.itemPull[t[i].id].complex=!0,this._initObj(t[i].items,!0,t[i].id)):this.conf.dload&&1==t[i].complex&&(this.itemPull[t[i].id].loaded="no"),this.itemPull[t[i].id].items=null}if(!0!==e)if(1==this.conf.dload)if(null==n)this._initTopLevelMenu();else{if(this._addSubMenuPolygon(n,n),this.conf.selected==n){var r=this.itemPull[n].parent==this.idPrefix+this.topId,s=r&&!this.conf.context?this.conf.dir_toplv:this.conf.dir_sublv,l=!1;if(r&&this.conf.top_mode&&"web"==this.conf.mode&&!this.conf.context){var d=this.idPull[n];if(1==d._mouseOver){var c=this.conf.top_tmtime-((new Date).getTime()-d._dynLoadTM);if(c>1){var h=n,u=this;d._menuOpenTM=window.setTimeout(function(){u._showPolygon(h,s),u=h=null},c),l=!0}}}l||this._showPolygon(n,s)}this.itemPull[n].loaded="yes",1==this.conf.dload_icon&&this._updateLoaderIcon(n,!1)}else this._init()},dhtmlXMenuObject.prototype._xmlToJson=function(t,e){var n=[];if(null==e){var i=t.getElementsByTagName(this.conf.tags.root);if(null==i||null!=i&&0==i.length)return{items:[]};i=i[0]}else i=t;null!=i.getAttribute("parentId")&&(e=this.idPrefix+i.getAttribute("parentId"));for(var a=0;a<i.childNodes.length;a++)if(void 0!==i.childNodes[a].tagName&&String(i.childNodes[a].tagName).toLowerCase()==this.conf.tags.item){var o=i.childNodes[a],r={id:this.idPrefix+(o.getAttribute("id")||this._genStr(24)),title:o.getAttribute("text")||"",imgen:o.getAttribute("img")||"",imgdis:o.getAttribute("imgdis")||"",tip:"",hotkey:"",type:o.getAttribute("type")||"item"};if(null!=o.getAttribute("cssNormal")&&(r.cssNormal=o.getAttribute("cssNormal")),"checkbox"==r.type&&(r.checked=o.getAttribute("checked")),"radio"==r.type&&(r.checked=o.getAttribute("checked"),r.group=o.getAttribute("group")),r.state="enabled",null!=o.getAttribute("enabled")&&0==window.dhx4.s2b(o.getAttribute("enabled"))?r.state="disabled":null!=o.getAttribute("disabled")&&1==window.dhx4.s2b(o.getAttribute("disabled"))&&(r.state="disabled"),r.parent=null!=e?e:this.idPrefix+this.topId,this.conf.dload)r.complex=null!=o.getAttribute("complex"),r.complex&&(r.loaded="no");else{var s=this._xmlToJson(o,r.id);r.items=s.items,r.complex=r.items.length>0}for(var l=0;l<o.childNodes.length;l++)if(void 0!==o.childNodes[l].tagName){var d=String(o.childNodes[l].tagName||"").toLowerCase();if(d==this.conf.tags.userdata){var c=o.childNodes[l];null!=c.getAttribute("name")&&(this.userData[r.id+"_"+c.getAttribute("name")]=null!=c.firstChild&&null!=c.firstChild.nodeValue?c.firstChild.nodeValue:"")}d==this.conf.tags.text_ext&&(r.title=o.childNodes[l].firstChild.nodeValue),d==this.conf.tags.tooltip&&(r.tip=o.childNodes[l].firstChild.nodeValue),d==this.conf.tags.hotkey&&(r.hotkey=o.childNodes[l].firstChild.nodeValue),d==this.conf.tags.href&&"item"==r.type&&(r.href_link=o.childNodes[l].firstChild.nodeValue,null!=o.childNodes[l].getAttribute("target")&&(r.href_target=o.childNodes[l].getAttribute("target")))}n.push(r)}return o={parentId:e,items:n}},dhtmlXMenuObject.prototype.enableDynamicLoading=function(t,e){this.conf.dload=!0,this.conf.dload_url=t,this.conf.dload_sign=-1==String(this.conf.dload_url).search(/\?/)?"?":"&",this.conf.dload_icon=e,this._init()},dhtmlXMenuObject.prototype._updateLoaderIcon=function(t,e){if(null!=this.idPull[t]&&!(String(this.idPull[t].className).search("TopLevel_Item")>=0)){var n=this.conf.rtl?0:2;if(this.idPull[t].childNodes[n]&&this.idPull[t].childNodes[n].childNodes[0]){var i=this.idPull[t].childNodes[n].childNodes[0];0===String(i.className).search("complex_arrow")&&(i.className="complex_arrow"+(e?"_loading":""))}}},dhtmlXMenuObject.prototype.addNewSibling=function(t,e,n,i,a,o){var r=this.idPrefix+(null!=e?e:this._genStr(24)),s=this.idPrefix+(null!=t?this.getParentId(t):this.topId);this._addItemIntoGlobalStrorage(r,s,n,"item",i,a,o),s!=this.idPrefix+this.topId||this.conf.context?this._renderSublevelItem(r,this.getItemPosition(t)):this._renderToplevelItem(r,this.getItemPosition(t))},dhtmlXMenuObject.prototype.addNewChild=function(t,e,n,i,a,o,r){if(null==t){if(!this.conf.context)return this.addNewSibling(t,n,i,a,o,r),void(null!=e&&this.setItemPosition(n,e));t=this.topId}n=this.idPrefix+(null!=n?n:this._genStr(24)),this.setHotKey&&this.setHotKey(t,""),t=this.idPrefix+t,this._addItemIntoGlobalStrorage(n,t,i,"item",a,o,r),null==this.idPull["polygon_"+t]&&this._renderSublevelPolygon(t,t),this._renderSublevelItem(n,e-1),this._redefineComplexState(t)},dhtmlXMenuObject.prototype.removeItem=function(t,e,n){e||(t=this.idPrefix+t);var i=null;if(t!=this.idPrefix+this.topId){if(null==this.itemPull[t])return;this.idPull["polygon_"+t]&&this.idPull["polygon_"+t]._tmShow&&window.clearTimeout(this.idPull["polygon_"+t]._tmShow);var a=this.itemPull[t].type;if("separator"==a){var o=this.idPull["separator_"+t];this.itemPull[t].parent==this.idPrefix+this.topId?(o.onclick=null,o.onselectstart=null,o.id=null,o.parentNode.removeChild(o)):(o.childNodes[0].childNodes[0].onclick=null,o.childNodes[0].childNodes[0].onselectstart=null,o.childNodes[0].childNodes[0].id=null,o.childNodes[0].removeChild(o.childNodes[0].childNodes[0]),o.removeChild(o.childNodes[0]),o.parentNode.removeChild(o)),this.idPull["separator_"+t]=null,this.itemPull[t]=null,delete this.idPull["separator_"+t],delete this.itemPull[t],o=null}else{for(i=this.itemPull[t].parent,(o=this.idPull[t]).onclick=null,o.oncontextmenu=null,o.onmouseover=null,o.onmouseout=null,o.onselectstart=null,o.id=null;o.childNodes.length>0;)o.removeChild(o.childNodes[0]);o.parentNode.removeChild(o),this.idPull[t]=null,this.itemPull[t]=null,delete this.idPull[t],delete this.itemPull[t],o=null}a=null}for(var r in this.itemPull)this.itemPull[r].parent==t&&this.removeItem(r,!0,!0);var s=new Array(t);null==i||n||null!=this.idPull["polygon_"+i]&&0==this.idPull["polygon_"+i].tbd.childNodes.length&&(s.push(i),this._updateItemComplexState(i,!1,!1));for(var l=0;l<s.length;l++)if(this.idPull["polygon_"+s[l]]){var d=this.idPull["polygon_"+s[l]];if(d.onclick=null,d.oncontextmenu=null,d.tbl.removeChild(d.tbd),d.tbd=null,d.childNodes[1].removeChild(d.tbl),d.tbl=null,d.id=null,d.parentNode.removeChild(d),d=null,window.dhx4.isIE6){var c="polygon_"+s[l]+"_ie6cover";null!=this.idPull[c]&&(document.body.removeChild(this.idPull[c]),delete this.idPull[c])}null!=this.idPull["arrowup_"+t]&&this._removeArrow&&this._removeArrow("arrowup_"+t),null!=this.idPull["arrowdown_"+t]&&this._removeArrow&&this._removeArrow("arrowdown_"+t),this.idPull["polygon_"+s[l]]=null,delete this.idPull["polygon_"+s[l]]}s=null,"dhx_terrace"==this.conf.skin&&1==arguments.length&&this._improveTerraceSkin()},dhtmlXMenuObject.prototype._addItemIntoGlobalStrorage=function(t,e,n,i,a,o,r){var s={id:t,title:n,imgen:null!=o?o:"",imgdis:null!=r?r:"",type:i,state:1==a?"disabled":"enabled",parent:e,complex:!1,hotkey:"",tip:""};this.itemPull[s.id]=s},dhtmlXMenuObject.prototype.renderAsContextMenu=function(){this.conf.context=!0,1==this.base._autoSkinUpdate&&(this.base.className=this.base.className.replace("dhtmlxMenu_"+this.conf.skin+"_Middle",""),this.base._autoSkinUpdate=!1),null!=this.conf.ctx_baseid&&this.addContextZone(this.conf.ctx_baseid)},dhtmlXMenuObject.prototype.addContextZone=function(t){if(t==document.body){t="document.body."+this.idPrefix;var e=document.body}else if("string"==typeof t)e=document.getElementById(t);else e=t;var n=!1;for(var i in this.conf.ctx_zones)n=n||i==t||this.conf.ctx_zones[i]==e;if(1==n)return!1;this.conf.ctx_zones[t]=e;var a=this;window.dhx4.isOpera?(this.operaContext=function(t){a._doOnContextMenuOpera(t,a)},e.addEventListener("mouseup",this.operaContext,!1)):(null==e.oncontextmenu||e._oldContextMenuHandler||(e._oldContextMenuHandler=e.oncontextmenu),e.oncontextmenu=function(t){for(var e in dhtmlXMenuObject.prototype.liveInst)e!=a.conf.live_id&&dhtmlXMenuObject.prototype.liveInst[e].context&&dhtmlXMenuObject.prototype.liveInst[e]._hideContextMenu();return(t=t||event).cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,a._doOnContextBeforeCall(t,this),!1})},dhtmlXMenuObject.prototype._doOnContextMenuOpera=function(t,e){for(var n in dhtmlXMenuObject.prototype.liveInst)n!=e.conf.live_id&&dhtmlXMenuObject.prototype.liveInst[n].context&&dhtmlXMenuObject.prototype.liveInst[n]._hideContextMenu();return t.cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,0==t.button&&1==t.ctrlKey&&e._doOnContextBeforeCall(t,this),!1},dhtmlXMenuObject.prototype.removeContextZone=function(t){if(!this.isContextZone(t))return!1;t==document.body&&(t="document.body."+this.idPrefix);var e=this.conf.ctx_zones[t];window.dhx4.isOpera?e.removeEventListener("mouseup",this.operaContext,!1):(e.oncontextmenu=null!=e._oldContextMenuHandler?e._oldContextMenuHandler:null,e._oldContextMenuHandler=null);try{this.conf.ctx_zones[t]=null,delete this.conf.ctx_zones[t]}catch(t){}return!0},dhtmlXMenuObject.prototype.isContextZone=function(t){if(t==document.body&&null!=this.conf.ctx_zones["document.body."+this.idPrefix])return!0;var e=!1;return null!=this.conf.ctx_zones[t]&&this.conf.ctx_zones[t]==document.getElementById(t)&&(e=!0),e},dhtmlXMenuObject.prototype._isContextMenuVisible=function(){return null!=this.idPull["polygon_"+this.idPrefix+this.topId]&&""==this.idPull["polygon_"+this.idPrefix+this.topId].style.display},dhtmlXMenuObject.prototype._showContextMenu=function(t,e,n){if(this._clearAndHide(),null==this.idPull["polygon_"+this.idPrefix+this.topId])return!1;window.clearTimeout(this.conf.tm_handler),this.idPull[this.idPrefix+this.topId]=new Array(t,e),this._showPolygon(this.idPrefix+this.topId,"bottom"),this.callEvent("onContextMenu",[n])},dhtmlXMenuObject.prototype._hideContextMenu=function(){if(null==this.idPull["polygon_"+this.idPrefix+this.topId])return!1;this._clearAndHide(),this._hidePolygon(this.idPrefix+this.topId)},dhtmlXMenuObject.prototype._doOnContextBeforeCall=function(t,e){if(this.conf.ctx_zoneid=e.id,this._clearAndHide(),this._hideContextMenu(),1==window.dhx4.isChrome||1==window.dhx4.isEdge||1==window.dhx4.isOpera||1==window.dhx4.isIE11)var n=window.dhx4.absLeft(t.target)+t.offsetX,i=window.dhx4.absTop(t.target)+t.offsetY;else if(1==window.dhx4.isIE6||1==window.dhx4.isIE7||1==window.dhx4.isIE)n=window.dhx4.absLeft(t.srcElement)+t.x||0,i=window.dhx4.absTop(t.srcElement)+t.y||0;else{var a=t.srcElement||t.target,o=window.dhx4.isIE||window.dhx4.isKHTML?t.offsetX:t.layerX,r=window.dhx4.isIE||window.dhx4.isKHTML?t.offsetY:t.layerY;n=window.dhx4.absLeft(a)+o,i=window.dhx4.absTop(a)+r}this.checkEvent("onBeforeContextMenu")?this.callEvent("onBeforeContextMenu",[e.id,t])&&this.conf.ctx_autoshow&&(this._showContextMenu(n,i,e.id),this.callEvent("onAfterContextMenu",[e.id,t])):this.conf.ctx_autoshow&&(this._showContextMenu(n,i,e.id),this.callEvent("onAfterContextMenu",[e.id]))},dhtmlXMenuObject.prototype.showContextMenu=function(t,e){this._showContextMenu(t,e,!1)},dhtmlXMenuObject.prototype.hideContextMenu=function(){this._hideContextMenu()},dhtmlXMenuObject.prototype.setAutoShowMode=function(t){this.conf.ctx_autoshow=1==t},dhtmlXMenuObject.prototype.setAutoHideMode=function(t){this.conf.ctx_autohide=1==t},dhtmlXMenuObject.prototype.setContextMenuHideAllMode=function(t){this.conf.ctx_hideall=1==t},dhtmlXMenuObject.prototype.getContextMenuHideAllMode=function(){return this.conf.ctx_hideall},dhtmlXMenuObject.prototype._improveTerraceSkin=function(){for(var t in this.itemPull)if(this.itemPull[t].parent==this.idPrefix+this.topId&&null!=this.idPull[t]){var e=!1,n=!1;for(var i in this.idPull[t].parentNode.firstChild==this.idPull[t]&&(e=!0),this.idPull[t].parentNode.lastChild==this.idPull[t]&&(n=!0),this.itemPull)"separator"==this.itemPull[i].type&&this.itemPull[i].parent==this.idPrefix+this.topId&&(this.idPull[t].nextSibling==this.idPull["separator_"+i]&&(n=!0),this.idPull[t].previousSibling==this.idPull["separator_"+i]&&(e=!0));this.idPull[t].style.borderLeftWidth=e?"1px":"0px",this.idPull[t].style.borderTopLeftRadius=this.idPull[t].style.borderBottomLeftRadius=e?"3px":"0px",this.idPull[t].style.borderTopRightRadius=this.idPull[t].style.borderBottomRightRadius=n?"3px":"0px",this.idPull[t]._bl=e,this.idPull[t]._br=n}},dhtmlXMenuObject.prototype._improveTerraceButton=function(t,e){e?(this.idPull[t].style.borderBottomLeftRadius=this.idPull[t]._bl?"3px":"0px",this.idPull[t].style.borderBottomRightRadius=this.idPull[t]._br?"3px":"0px"):(this.idPull[t].style.borderBottomLeftRadius="0px",this.idPull[t].style.borderBottomRightRadius="0px")},void 0!==window.dhtmlXCellObject&&(dhtmlXCellObject.prototype._createNode_menu=function(t,e,n,i,a){return void 0!==a?t=a:((t=document.createElement("DIV")).className="dhx_cell_menu_"+(this.conf.borders?"def":"no_borders"),t.appendChild(document.createElement("DIV"))),this.cell.insertBefore(t,this.cell.childNodes[this.conf.idx.toolbar||this.conf.idx.cont]),this.conf.ofs_nodes.t.menu=!0,this._updateIdx(),t},dhtmlXCellObject.prototype.attachMenu=function(t){if(!this.dataNodes.menu)return this.callEvent("_onBeforeContentAttach",["menu"]),void 0===t&&(t={}),void 0===t.skin&&(t.skin=this.conf.skin),t.parent=this._attachObject("menu").firstChild,this.dataNodes.menu=new dhtmlXMenuObject(t),this._adjustCont(this._idd),t.parent=null,t=null,this.callEvent("_onContentAttach",[]),this.dataNodes.menu},dhtmlXCellObject.prototype.detachMenu=function(){null!=this.dataNodes.menu&&("function"==typeof this.dataNodes.menu.unload&&this.dataNodes.menu.unload(),this.dataNodes.menu=null,delete this.dataNodes.menu,this._detachObject("menu"))},dhtmlXCellObject.prototype.showMenu=function(){this._mtbShowHide("menu","")},dhtmlXCellObject.prototype.hideMenu=function(){this._mtbShowHide("menu","none")},dhtmlXCellObject.prototype.getAttachedMenu=function(){return this.dataNodes.menu}),dhtmlXMenuObject.prototype.setItemEnabled=function(t){this._changeItemState(t,"enabled",this._getItemLevelType(t))},dhtmlXMenuObject.prototype.setItemDisabled=function(t){this._changeItemState(t,"disabled",this._getItemLevelType(t))},dhtmlXMenuObject.prototype.isItemEnabled=function(t){return null!=this.itemPull[this.idPrefix+t]&&"enabled"==this.itemPull[this.idPrefix+t].state},dhtmlXMenuObject.prototype._changeItemState=function(t,e,n){var i=this.idPrefix+t;return null!=this.itemPull[i]&&null!=this.idPull[i]&&this.itemPull[i].state!=e&&(this.itemPull[i].state=e,this.itemPull[i].parent!=this.idPrefix+this.topId||this.conf.context?this.idPull[i].className="sub_item"+("enabled"==this.itemPull[i].state?"":"_dis"):this.idPull[i].className="dhtmlxMenu_"+this.conf.skin+"_TopLevel_Item_"+("enabled"==this.itemPull[i].state?"Normal":"Disabled"),this._updateItemComplexState(this.idPrefix+t,this.itemPull[this.idPrefix+t].complex,!1),this._updateItemImage(t,n),this.idPrefix+this.conf.last_click==i&&"TopLevel"!=n&&this._redistribSubLevelSelection(i,this.itemPull[i].parent),"TopLevel"==n&&this.conf.context),!1},dhtmlXMenuObject.prototype.getItemText=function(t){return null!=this.itemPull[this.idPrefix+t]?this.itemPull[this.idPrefix+t].title:""},dhtmlXMenuObject.prototype.setItemText=function(t,e){if(t=this.idPrefix+t,null!=this.itemPull[t]&&null!=this.idPull[t])if(this._clearAndHide(),this.itemPull[t].title=e,this.itemPull[t].parent!=this.idPrefix+this.topId||this.conf.context){for(n=null,i=0;i<this.idPull[t].childNodes[1].childNodes.length;i++)"sub_item_text"==String(this.idPull[t].childNodes[1].childNodes[i].className||"")&&(n=this.idPull[t].childNodes[1].childNodes[i]);""==String(this.itemPull[t].title).length||null==this.itemPull[t].title?n&&(n.parentNode.removeChild(n),n=null,this.idPull[t].childNodes[1].innerHTML="&nbsp;"):(n||((n=document.createElement("DIV")).className="sub_item_text",this.idPull[t].childNodes[1].innerHTML="",this.idPull[t].childNodes[1].appendChild(n)),n.innerHTML=this.itemPull[t].title)}else{for(var n=null,i=0;i<this.idPull[t].childNodes.length;i++)try{"top_level_text"==this.idPull[t].childNodes[i].className&&(n=this.idPull[t].childNodes[i])}catch(t){}""==String(this.itemPull[t].title).length||null==this.itemPull[t].title?null!=n&&n.parentNode.removeChild(n):(n||((n=document.createElement("DIV")).className="top_level_text",this.conf.rtl&&this.idPull[t].childNodes.length>0?this.idPull[t].insertBefore(n,this.idPull[t].childNodes[0]):this.idPull[t].appendChild(n)),n.innerHTML=this.itemPull[t].title)}},dhtmlXMenuObject.prototype.loadFromHTML=function(t,e,n){var i=this.conf.tags.item;this.conf.tags.item="div";var a="string"==typeof t?document.getElementById(t):t,o=this._xmlToJson(a,this.idPrefix+this.topId);this._initObj(o),this.conf.tags.item=i,e&&a.parentNode.removeChild(a),a=objOd=null,null!=onload&&("function"==typeof n?n():"function"==typeof window[n]&&window[n]())},dhtmlXMenuObject.prototype.hideItem=function(t){this._changeItemVisible(t,!1)},dhtmlXMenuObject.prototype.showItem=function(t){this._changeItemVisible(t,!0)},dhtmlXMenuObject.prototype.isItemHidden=function(t){var e=null;return null!=this.idPull[this.idPrefix+t]&&(e="none"==this.idPull[this.idPrefix+t].style.display),e},dhtmlXMenuObject.prototype._changeItemVisible=function(t,e){var n=this.idPrefix+t;null!=this.itemPull[n]&&("separator"==this.itemPull[n].type&&(n="separator_"+n),null!=this.idPull[n]&&(this.idPull[n].style.display=e?"":"none",this._redefineComplexState(this.itemPull[this.idPrefix+t].parent)))},dhtmlXMenuObject.prototype.setUserData=function(t,e,n){this.userData[this.idPrefix+t+"_"+e]=n},dhtmlXMenuObject.prototype.getUserData=function(t,e){return null!=this.userData[this.idPrefix+t+"_"+e]?this.userData[this.idPrefix+t+"_"+e]:null},dhtmlXMenuObject.prototype.setOpenMode=function(t){this.conf.mode="win"==t?"win":"web"},dhtmlXMenuObject.prototype.setWebModeTimeout=function(t){this.conf.tm_sec=isNaN(t)?400:t},dhtmlXMenuObject.prototype.getItemImage=function(t){var e=new Array(null,null);return t=this.idPrefix+t,"item"==this.itemPull[t].type&&(e[0]=this.itemPull[t].imgen,e[1]=this.itemPull[t].imgdis),e},dhtmlXMenuObject.prototype.setItemImage=function(t,e,n){"item"==this.itemPull[this.idPrefix+t].type&&(this.itemPull[this.idPrefix+t].imgen=e,this.itemPull[this.idPrefix+t].imgdis=n,this._updateItemImage(t,this._getItemLevelType(t)))},dhtmlXMenuObject.prototype.clearItemImage=function(t){this.setItemImage(t,"","")},dhtmlXMenuObject.prototype.setVisibleArea=function(t,e,n,i){this.conf.v_enabled=!0,this.conf.v.x1=t,this.conf.v.x2=e,this.conf.v.y1=n,this.conf.v.y2=i},dhtmlXMenuObject.prototype.setTooltip=function(t,e){t=this.idPrefix+t,null!=this.itemPull[t]&&null!=this.idPull[t]&&(this.idPull[t].title=e.length>0?e:null,this.itemPull[t].tip=e)},dhtmlXMenuObject.prototype.getTooltip=function(t){return null==this.itemPull[this.idPrefix+t]?null:this.itemPull[this.idPrefix+t].tip},dhtmlXMenuObject.prototype.setTopText=function(t){this.conf.context||(null==this._topText&&(this._topText=document.createElement("DIV"),this._topText.className="dhtmlxMenu_TopLevel_Text_"+(this.conf.rtl?"left":"left"==this.conf.align?"right":"left"),this.base.appendChild(this._topText)),this._topText.innerHTML=t)},dhtmlXMenuObject.prototype.setAlign=function(t){this.conf.align!=t&&("left"!=t&&"right"!=t||(this.conf.align=t,this.cont&&(this.cont.className="right"==this.conf.align?"align_right":"align_left"),null!=this._topText&&(this._topText.className="dhtmlxMenu_TopLevel_Text_"+("left"==this.conf.align?"right":"left"))))},dhtmlXMenuObject.prototype.setHref=function(t,e,n){null!=this.itemPull[this.idPrefix+t]&&(this.itemPull[this.idPrefix+t].href_link=e,null!=n&&(this.itemPull[this.idPrefix+t].href_target=n))},dhtmlXMenuObject.prototype.clearHref=function(t){null!=this.itemPull[this.idPrefix+t]&&(delete this.itemPull[this.idPrefix+t].href_link,delete this.itemPull[this.idPrefix+t].href_target)},dhtmlXMenuObject.prototype.getCircuit=function(t){for(var e=new Array(t);this.getParentId(t)!=this.topId;)t=this.getParentId(t),e[e.length]=t;return e.reverse()},dhtmlXMenuObject.prototype._getCheckboxState=function(t){return null==this.itemPull[this.idPrefix+t]?null:this.itemPull[this.idPrefix+t].checked},dhtmlXMenuObject.prototype._setCheckboxState=function(t,e){null!=this.itemPull[this.idPrefix+t]&&(this.itemPull[this.idPrefix+t].checked=e)},dhtmlXMenuObject.prototype._updateCheckboxImage=function(t){if(null!=this.idPull[this.idPrefix+t]){this.itemPull[this.idPrefix+t].imgen="chbx_"+(this._getCheckboxState(t)?"1":"0"),this.itemPull[this.idPrefix+t].imgdis=this.itemPull[this.idPrefix+t].imgen;try{this.idPull[this.idPrefix+t].childNodes[this.conf.rtl?2:0].childNodes[0].className="sub_icon "+this.itemPull[this.idPrefix+t].imgen}catch(t){}}},dhtmlXMenuObject.prototype._checkboxOnClickHandler=function(t,e,n){if("d"!=e.charAt(1)&&null!=this.itemPull[this.idPrefix+t]){var i=this._getCheckboxState(t);this.checkEvent("onCheckboxClick")?this.callEvent("onCheckboxClick",[t,i,this.conf.ctx_zoneid,n])&&this.setCheckboxState(t,!i):this.setCheckboxState(t,!i),this.checkEvent("onClick")&&this.callEvent("onClick",[t])}},dhtmlXMenuObject.prototype.setCheckboxState=function(t,e){this._setCheckboxState(t,e),this._updateCheckboxImage(t)},dhtmlXMenuObject.prototype.getCheckboxState=function(t){return this._getCheckboxState(t)},dhtmlXMenuObject.prototype.addCheckbox=function(t,e,n,i,a,o,r){if(this.conf.context&&e==this.topId);else{if(null==this.itemPull[this.idPrefix+e])return;if("child"==t&&"item"!=this.itemPull[this.idPrefix+e].type)return}var s="chbx_"+(o?"1":"0"),l=s;if("sibling"==t){var d=this.idPrefix+(null!=i?i:this._genStr(24)),c=this.idPrefix+this.getParentId(e);this._addItemIntoGlobalStrorage(d,c,a,"checkbox",r,s,l),this.itemPull[d].checked=o,this._renderSublevelItem(d,this.getItemPosition(e))}else{d=this.idPrefix+(null!=i?i:this._genStr(24)),c=this.idPrefix+e;this._addItemIntoGlobalStrorage(d,c,a,"checkbox",r,s,l),this.itemPull[d].checked=o,null==this.idPull["polygon_"+c]&&this._renderSublevelPolygon(c,c),this._renderSublevelItem(d,n-1),this._redefineComplexState(c)}},dhtmlXMenuObject.prototype.setHotKey=function(t,e){if(t=this.idPrefix+t,null!=this.itemPull[t]&&null!=this.idPull[t]&&(this.itemPull[t].parent!=this.idPrefix+this.topId||this.conf.context)&&!this.itemPull[t].complex){var n=this.itemPull[t].type;if("item"==n||"checkbox"==n||"radio"==n){var i=null;try{"sub_item_hk"==this.idPull[t].childNodes[this.conf.rtl?0:2].childNodes[0].className&&(i=this.idPull[t].childNodes[this.conf.rtl?0:2].childNodes[0])}catch(t){}if(0==e.length)this.itemPull[t].hotkey_backup=this.itemPull[t].hotkey,this.itemPull[t].hotkey="",null!=i&&i.parentNode.removeChild(i);else{if(this.itemPull[t].hotkey=e,this.itemPull[t].hotkey_backup=null,null==i){(i=document.createElement("DIV")).className="sub_item_hk";for(var a=this.idPull[t].childNodes[this.conf.rtl?0:2];a.childNodes.length>0;)a.removeChild(a.childNodes[0]);a.appendChild(i)}i.innerHTML=e}}}},dhtmlXMenuObject.prototype.getHotKey=function(t){return null==this.itemPull[this.idPrefix+t]?null:this.itemPull[this.idPrefix+t].hotkey},dhtmlXMenuObject.prototype._clearAllSelectedSubItemsInPolygon=function(t){for(var e=this._getSubItemToDeselectByPolygon(t),n=0;n<this.conf.opened_poly.length;n++)this.conf.opened_poly[n]!=t&&this._hidePolygon(this.conf.opened_poly[n]);for(n=0;n<e.length;n++)null!=this.idPull[e[n]]&&"enabled"==this.itemPull[e[n]].state&&(this.idPull[e[n]].className="dhtmlxMenu_"+this.conf.skin+"_SubLevelArea_Item_Normal")},dhtmlXMenuObject.prototype._checkArrowsState=function(t){var e=this.idPull["polygon_"+t].childNodes[1],n=this.idPull["arrowup_"+t],i=this.idPull["arrowdown_"+t];0==e.scrollTop?n.className="dhtmlxMenu_"+this.conf.skin+"_SubLevelArea_ArrowUp_Disabled":n.className="dhtmlxMenu_"+this.conf.skin+"_SubLevelArea_ArrowUp"+(n.over?"_Over":""),e.scrollTop+e.offsetHeight<e.scrollHeight?i.className="dhtmlxMenu_"+this.conf.skin+"_SubLevelArea_ArrowDown"+(i.over?"_Over":""):i.className="dhtmlxMenu_"+this.conf.skin+"_SubLevelArea_ArrowDown_Disabled",e=n=i=null},dhtmlXMenuObject.prototype._addUpArrow=function(t){var e=this,n=document.createElement("DIV");n.pId=this.idPrefix+t,n.id="arrowup_"+this.idPrefix+t,n.className="dhtmlxMenu_"+this.conf.skin+"_SubLevelArea_ArrowUp",n.over=!1,n.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},n.oncontextmenu=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},n.onmouseover=function(){"web"==e.conf.mode&&window.clearTimeout(e.conf.tm_handler),e._clearAllSelectedSubItemsInPolygon(this.pId),this.className!="dhtmlxMenu_"+e.conf.skin+"_SubLevelArea_ArrowUp_Disabled"&&(this.className="dhtmlxMenu_"+e.conf.skin+"_SubLevelArea_ArrowUp_Over",this.over=!0,e._canScrollUp=!0,e._doScrollUp(this.pId,!0))},n.onmouseout=function(){"web"==e.conf.mode&&(window.clearTimeout(e.conf.tm_handler),e.conf.tm_handler=window.setTimeout(function(){e._clearAndHide()},e.conf.tm_sec,"JavaScript")),this.over=!1,e._canScrollUp=!1,this.className!="dhtmlxMenu_"+e.conf.skin+"_SubLevelArea_ArrowUp_Disabled"&&(this.className="dhtmlxMenu_"+e.conf.skin+"_SubLevelArea_ArrowUp",window.clearTimeout(e.conf.of_utm))},n.onclick=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,t.cancelBubble=!0,!1};var i=this.idPull["polygon_"+this.idPrefix+t];i.childNodes[0].appendChild(n),this.idPull[n.id]=n,i=n=null},dhtmlXMenuObject.prototype._addDownArrow=function(t){var e=this,n=document.createElement("DIV");n.pId=this.idPrefix+t,n.id="arrowdown_"+this.idPrefix+t,n.className="dhtmlxMenu_"+this.conf.skin+"_SubLevelArea_ArrowDown",n.over=!1,n.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},n.oncontextmenu=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},n.onmouseover=function(){"web"==e.conf.mode&&window.clearTimeout(e.conf.tm_handler),e._clearAllSelectedSubItemsInPolygon(this.pId),this.className!="dhtmlxMenu_"+e.conf.skin+"_SubLevelArea_ArrowDown_Disabled"&&(this.className="dhtmlxMenu_"+e.conf.skin+"_SubLevelArea_ArrowDown_Over",this.over=!0,e._canScrollDown=!0,e._doScrollDown(this.pId,!0))},n.onmouseout=function(){"web"==e.conf.mode&&(window.clearTimeout(e.conf.tm_handler),e.conf.tm_handler=window.setTimeout(function(){e._clearAndHide()},e.conf.tm_sec,"JavaScript")),this.over=!1,e._canScrollDown=!1,this.className!="dhtmlxMenu_"+e.conf.skin+"_SubLevelArea_ArrowDown_Disabled"&&(this.className="dhtmlxMenu_"+e.conf.skin+"_SubLevelArea_ArrowDown",window.clearTimeout(e.conf.of_dtm))},n.onclick=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,t.cancelBubble=!0,!1};var i=this.idPull["polygon_"+this.idPrefix+t];i.childNodes[2].appendChild(n),this.idPull[n.id]=n,i=n=null},dhtmlXMenuObject.prototype._removeUpArrow=function(t){var e="arrowup_"+this.idPrefix+t;this._removeArrow(e)},dhtmlXMenuObject.prototype._removeDownArrow=function(t){var e="arrowdown_"+this.idPrefix+t;this._removeArrow(e)},dhtmlXMenuObject.prototype._removeArrow=function(t){var e=this.idPull[t];e.onselectstart=null,e.oncontextmenu=null,e.onmouseover=null,e.onmouseout=null,e.onclick=null,e.parentNode&&e.parentNode.removeChild(e),e=null,this.idPull[t]=null;try{delete this.idPull[t]}catch(t){}},dhtmlXMenuObject.prototype._isArrowExists=function(t){return null!=this.idPull["arrowup_"+t]&&null!=this.idPull["arrowdown_"+t]},dhtmlXMenuObject.prototype._doScrollUp=function(t,e){var n=this.idPull["polygon_"+t].childNodes[1];if(this._canScrollUp&&n.scrollTop>0){var i=!1,a=n.scrollTop-this.conf.of_ustep;if(a<0&&(i=!0,a=0),n.scrollTop=a,i)e=!0;else{var o=this;this.conf.of_utm=window.setTimeout(function(){o._doScrollUp(t,!1),o=null},this.conf.of_utime)}}else this._canScrollUp=!1,this._checkArrowsState(t);e&&this._checkArrowsState(t)},dhtmlXMenuObject.prototype._doScrollDown=function(t,e){var n=this.idPull["polygon_"+t].childNodes[1];if(this._canScrollDown&&n.scrollTop+n.offsetHeight<=n.scrollHeight){var i=!1,a=n.scrollTop+this.conf.of_dstep;if(a+n.offsetHeight>=n.scrollHeight&&(i=!0,a=n.scrollHeight-n.offsetHeight),n.scrollTop=a,i)e=!0;else{var o=this;this.conf.of_dtm=window.setTimeout(function(){o._doScrollDown(t,!1),o=null},this.conf.of_dtime)}}else this._canScrollDown=!1,this._checkArrowsState(t);e&&this._checkArrowsState(t)},dhtmlXMenuObject.prototype._countPolygonItems=function(t){var e=0;for(var n in this.itemPull){var i=this.itemPull[n].parent,a=this.itemPull[n].type;i!=this.idPrefix+t||"item"!=a&&"radio"!=a&&"checkbox"!=a||e++}return e},dhtmlXMenuObject.prototype.setOverflowHeight=function(t){if("auto"===t)return this.conf.overflow_limit=0,void(this.conf.auto_overflow=!0);if(!(0==this.conf.overflow_limit&&t<=0))if(this._clearAndHide(),this.conf.overflow_limit>=0&&t>0)this.conf.overflow_limit=t;else if(this.conf.overflow_limit>0&&t<=0){for(var e in this.itemPull)if(this._isArrowExists(e)){var n=String(e).replace(this.idPrefix,"");this._removeUpArrow(n),this._removeDownArrow(n),this.idPull["polygon_"+e].childNodes[1].style.height=""}this.conf.overflow_limit=0}else;},dhtmlXMenuObject.prototype._getRadioImgObj=function(t){try{var e=this.idPull[this.idPrefix+t].childNodes[this.conf.rtl?2:0].childNodes[0]}catch(t){e=null}return e},dhtmlXMenuObject.prototype._setRadioState=function(t,e){var n=this._getRadioImgObj(t);if(null!=n){var i=this.itemPull[this.idPrefix+t];i.checked=e,i.imgen="rdbt_"+(i.checked?"1":"0"),i.imgdis=i.imgen,n.className="sub_icon "+i.imgen}},dhtmlXMenuObject.prototype._radioOnClickHandler=function(t,e,n){if("d"!=e.charAt(1)&&null!=this.itemPull[this.idPrefix+t].group){var i=this.itemPull[this.idPrefix+t].group;this.checkEvent("onRadioClick")?this.callEvent("onRadioClick",[i,this.getRadioChecked(i),t,this.conf.ctx_zoneid,n])&&this.setRadioChecked(i,t):this.setRadioChecked(i,t),this.checkEvent("onClick")&&this.callEvent("onClick",[t])}},dhtmlXMenuObject.prototype.getRadioChecked=function(t){for(var e=null,n=0;n<this.radio[t].length;n++){var i=this.radio[t][n].replace(this.idPrefix,""),a=this._getRadioImgObj(i);if(null!=a)null!=a.className.match(/rdbt_1$/gi)&&(e=i)}return e},dhtmlXMenuObject.prototype.setRadioChecked=function(t,e){if(null!=this.radio[t])for(var n=0;n<this.radio[t].length;n++){var i=this.radio[t][n].replace(this.idPrefix,"");this._setRadioState(i,i==e)}},dhtmlXMenuObject.prototype.addRadioButton=function(t,e,n,i,a,o,r,s){if(this.conf.context&&e==this.topId);else{if(null==this.itemPull[this.idPrefix+e])return;if("child"==t&&"item"!=this.itemPull[this.idPrefix+e].type)return}var l=this.idPrefix+(null!=i?i:this._genStr(24)),d="rdbt_"+(r?"1":"0"),c=d;if("sibling"==t){var h=this.idPrefix+this.getParentId(e);this._addItemIntoGlobalStrorage(l,h,a,"radio",s,d,c),this._renderSublevelItem(l,this.getItemPosition(e))}else{h=this.idPrefix+e;this._addItemIntoGlobalStrorage(l,h,a,"radio",s,d,c),null==this.idPull["polygon_"+h]&&this._renderSublevelPolygon(h,h),this._renderSublevelItem(l,n-1),this._redefineComplexState(h)}var u=null!=o?o:this._genStr(24);this.itemPull[l].group=u,null==this.radio[u]&&(this.radio[u]=new Array),this.radio[u][this.radio[u].length]=l,1==r&&this.setRadioChecked(u,String(l).replace(this.idPrefix,""))},dhtmlXMenuObject.prototype.serialize=function(){return"<menu>"+this._readLevel(this.idPrefix+this.topId)+"</menu>"},dhtmlXMenuObject.prototype._readLevel=function(t){var e="";for(var n in this.itemPull)if(this.itemPull[n].parent==t){var i="",a="",o="",r=String(this.itemPull[n].id).replace(this.idPrefix,""),s="",l=""!=this.itemPull[n].title?' text="'+this.itemPull[n].title+'"':"",d="";"item"==this.itemPull[n].type&&(""!=this.itemPull[n].imgen&&(i=' img="'+this.itemPull[n].imgen+'"'),""!=this.itemPull[n].imgdis&&(a=' imgdis="'+this.itemPull[n].imgdis+'"'),""!=this.itemPull[n].hotkey&&(o="<hotkey>"+this.itemPull[n].hotkey+"</hotkey>")),"separator"==this.itemPull[n].type?s=' type="separator"':"disabled"==this.itemPull[n].state&&(d=' enabled="false"'),"checkbox"==this.itemPull[n].type&&(s=' type="checkbox"'+(this.itemPull[n].checked?' checked="true"':"")),"radio"==this.itemPull[n].type&&(s=' type="radio" group="'+this.itemPull[n].group+'" '+(this.itemPull[n].checked?' checked="true"':"")),e+="<item id='"+r+"'"+l+s+i+a+d+">",e+=o,this.itemPull[n].complex&&(e+=this._readLevel(n)),e+="</item>"}return e},dhtmlXMenuObject.prototype.enableEffect=function(t,e,n){for(var i in this._menuEffect=("opacity"==t||"slide"==t||"slide+"==t)&&t,this._pOpStyleIE=navigator.userAgent.search(/MSIE\s[678]\.0/gi)>=0,this.idPull)0===i.search(/polygon/)&&(this._pOpacityApply(i,this._pOpStyleIE?100:1),this.idPull[i].style.height="");this._pOpMax=(void 0===e?100:e)/(this._pOpStyleIE?1:100),this._pOpStyleName=this._pOpStyleIE?"filter":"opacity",this._pOpStyleValue=this._pOpStyleIE?"progid:DXImageTransform.Microsoft.Alpha(Opacity=#)":"#",this._pSlSteps=this._pOpStyleIE?10:20,this._pSlTMTimeMax=n||50},dhtmlXMenuObject.prototype._showPolygonEffect=function(t){this._pShowHide(t,!0)},dhtmlXMenuObject.prototype._hidePolygonEffect=function(t){this._pShowHide(t,!1)},dhtmlXMenuObject.prototype._pOpacityApply=function(t,e){this.idPull[t].style[this._pOpStyleName]=String(this._pOpStyleValue).replace("#",e||this.idPull[t]._op)},dhtmlXMenuObject.prototype._pShowHide=function(t,e){if(this.idPull){if(null!=this.idPull[t]._tmShow){if(this.idPull[t]._step_h>0&&1==e||this.idPull[t]._step_h<0&&0==e)return;window.clearTimeout(this.idPull[t]._tmShow),this.idPull[t]._tmShow=null,this.idPull[t]._max_h=null}if(0!=e||"hidden"!=this.idPull[t].style.visibility&&"none"!=this.idPull[t].style.display){if(1==e&&"none"==this.idPull[t].style.display&&(this.idPull[t].style.visibility="hidden",this.idPull[t].style.display=""),null==this.idPull[t]._max_h){if(this.idPull[t]._max_h=parseInt(this.idPull[t].offsetHeight),this.idPull[t]._h=1==e?0:this.idPull[t]._max_h,this.idPull[t]._step_h=Math.round(this.idPull[t]._max_h/this._pSlSteps)*(1==e?1:-1),0==this.idPull[t]._step_h)return;this.idPull[t]._step_tm=Math.round(this._pSlTMTimeMax/this._pSlSteps),"slide+"==this._menuEffect||"opacity"==this._menuEffect?(this.idPull[t].op_tm=this.idPull[t]._step_tm,this.idPull[t].op_step=this._pOpMax/this._pSlSteps*(1==e?1:-1),this._pOpStyleIE&&(this.idPull[t].op_step=Math.round(this.idPull[t].op_step)),this.idPull[t]._op=1==e?0:this._pOpMax,this._pOpacityApply(t)):(this.idPull[t]._op=this._pOpStyleIE?100:1,this._pOpacityApply(t)),0===this._menuEffect.search(/slide/)&&(this.idPull[t].style.height="0px"),this.idPull[t].style.visibility="visible"}this._pEffectSet(t,this.idPull[t]._h+this.idPull[t]._step_h)}}},dhtmlXMenuObject.prototype._pEffectSet=function(t,e){if(this.idPull)if(this.idPull[t]._tmShow&&window.clearTimeout(this.idPull[t]._tmShow),this.idPull[t]._h=Math.max(0,Math.min(e,this.idPull[t]._max_h)),0===this._menuEffect.search(/slide/)&&(this.idPull[t].style.height=this.idPull[t]._h+"px"),e+=this.idPull[t]._step_h,"slide+"!=this._menuEffect&&"opacity"!=this._menuEffect||(this.idPull[t]._op=Math.max(0,Math.min(this._pOpMax,this.idPull[t]._op+this.idPull[t].op_step)),this._pOpacityApply(t)),this.idPull[t]._step_h>0&&e<=this.idPull[t]._max_h||this.idPull[t]._step_h<0&&e>=0){var n=this;this.idPull[t]._tmShow=window.setTimeout(function(){n._pEffectSet(t,e)},this.idPull[t]._step_tm)}else 0===this._menuEffect.search(/slide/)&&(this.idPull[t].style.height=""),this.idPull[t]._step_h<0&&(this.idPull[t].style.visibility="hidden"),"slide+"!=this._menuEffect&&"opacity"!=this._menuEffect||(this.idPull[t]._op=this.idPull[t]._step_h<0?this._pOpStyleIE?100:1:this._pOpMax,this._pOpacityApply(t)),this.idPull[t]._tmShow=null,this.idPull[t]._h=null,this.idPull[t]._max_h=null,this.idPull[t]._step_tm=null},dhtmlXRibbon.prototype.setSizes=function(){null!=this._tabbar&&"function"==typeof this.setSizes&&this._tabbar.setSizes()},dhtmlXRibbon.prototype._renderData=function(t){var e=this._base.firstChild;null!=t&&(this.conf.icons_path=t.icons_path||this.conf.icons_path,this.conf.icons_css=this.conf.icons_css||"awesome"==t.iconset,t.tabs instanceof Array?(this._base.className=this._base.className.replace(/\s?dhxrb_without_tabbar/i,""),e.className="dhxrb_with_tabbar",this._tabbar=new dhtmlXTabBar(e),this._attachEventTabbar(),this._tabbar.setSkin(this.conf.skin),null!=this.conf.arrows_mode&&this._tabbar.setArrowsMode(this.conf.arrows_mode),this.childIds=this._appendTabs(t.tabs)):t.items instanceof Array&&(/\s?dhxrb_without_tabbar/i.test(this._base.className)||(this._base.className+=" dhxrb_without_tabbar"),/\s?dhxrb_background_area/i.test(e.className)&&(e.className="dhxrb_background_area"),e.innerHTML="<div class='dhxrb_g_area'></div>",this.childIds=this._appendBlocks(t.items,e.firstChild)),this.callEvent("_onHeightChanged",[]))},dhtmlXRibbon.prototype._xmlToJson=function(t){var e=t.lastChild||null,n={},i=[];return e&&"ribbon"==e.tagName&&(i=this._convertXmlNodeListIntoObject(e.childNodes)),i[0]&&i[0].type&&"block"==i[0].type.toLowerCase()?n.items=i:n.tabs=i,n},dhtmlXRibbon.prototype._convertXmlNodeListIntoObject=function(t){var e,n,i,a=[];for(n=t.length,e=0;e<n;e++)(i=this._covertXmlNodeToObject(t[e]))&&a.push(i);return a},dhtmlXRibbon.prototype._covertXmlNodeToObject=function(t){if(!t||!t.tagName||"item"!=t.tagName.toLowerCase()&&"tab"!=t.tagName.toLowerCase())return null;var e,n,i=t.attributes,a={};for(n=i.length,e=0;e<n;e++)switch(i[e].name){case"isbig":a.isbig=dhx4.s2b(i[e].value);break;case"state":a.state=dhx4.s2b(i[e].value);break;default:a[i[e].name]=i[e].value}return t.childNodes.length&&("buttonCombo"==t.getAttribute("type")||"buttonSelect"==t.getAttribute("type")?a.data=t:"tab"==t.tagName.toLowerCase()?a.items=this._convertXmlNodeListIntoObject(t.childNodes):a.list=this._convertXmlNodeListIntoObject(t.childNodes)),a},dhtmlXRibbon.prototype._appendTabs=function(t){var e,n,i,a=[];for(n=t.length,e=0;e<n;e++)i=this._addTab(t[e]),t[e].items instanceof Array&&(i.childIds=this._appendBlocks(t[e].items,i.base,i)),a.push(i.id);return a},dhtmlXRibbon.prototype._addTab=function(t){var e,n={conf:{active:!1,text:"",width:null,position:null,disable:!1},base:document.createElement("div"),type:"tab",childIds:[]};for(e in t)"items"!=e&&(n.conf[e]=t[e]);for(t.id?n.id=t.id:n.id=dhx4.newId();this._items[n.id];)n.id=dhx4.newId();return this._tabbar.addTab(n.id,n.conf.text,n.conf.width,n.conf.position,n.conf.active),n.base.className="dhxrb_g_area",n.base._dhx_ribbonId=n.id,this.tabs(n.id).attachObject(n.base),this._changeApiForTab(this.tabs(n.id)),this._items[n.id]=n,n},dhtmlXRibbon.prototype._changeApiForTab=function(t){var e;for(e in this._tabOriginalApi)this._tabOriginalApi[e]=this._tabOriginalApi[e]||t[e],t[e]=this._tabCustomApi[e]},dhtmlXRibbon.prototype._tabOriginalApi={enable:null,disable:null,close:null},dhtmlXRibbon.prototype._appendBlocks=function(t,e,n){var i,a,o,r,s,l,d=[];for(n=n||null,a=t.length,i=0;i<a;i++)if("object"==typeof t[i]&&"block"==t[i].type){if(o=this._addBlock(t[i],e),t[i].list&&t[i].list instanceof Array)for(s=(r=t[i].list).length,l=0;l<s;l++)this._addItem(o.id,null,null,r[l]);null!=n&&(o.parentId=n.id),o.conf.disable&&this.disable(o.id),d.push(o.id)}return d},dhtmlXRibbon.prototype._addBlock=function(t,e){var n,i;for(i in n={conf:{text:"",text_pos:"bottom",type:"block",mode:"cols",disable:!1},type:"block",childIds:[],base:document.createElement("div"),contForItems:document.createElement("div"),contForText:document.createElement("div")},t)"list"!=i&&"type"!=i&&"id"!=i&&(n.conf[i]=t[i]);for(t.id?n.id=t.id:n.id=dhx4.newId();this._items[n.id];)n.id=dhx4.newId();return n.base.className="dhxrb_block_base",e.appendChild(n.base),n.contForItems.className="dhxrb_block_items",n.contForText.className="dhxrb_block_label",n.base.appendChild(n.contForItems),n.conf.text&&(n.contForText.innerHTML=n.conf.text,"top"==n.conf.text_pos?n.base.insertBefore(n.contForText,n.contForItems):n.base.appendChild(n.contForText)),n.base._dhx_ribbonId=n.id,this._items[n.id]=n,n},dhtmlXRibbon.prototype._addItem=function(t,e,n,i){var a,o,r,s=this._items[t],l=null,d=this;if("newLevel"!=i.type&&!this.items[i.type])return null;if("newLevel"==i.type?this._addNewLevel(s):"group"==s.type?((a=document.createElement("div")).className="dhxrb_in_group",s.base.appendChild(a)):i.isbig?((a=document.createElement("div")).className="dhxrb_big_button",s.contForItems.appendChild(a)):(o=this._getContainerForSmallItem(s),(a=document.createElement("div")).className="rows"==s.conf.mode?"dhxrb_in_row":"dhxrb_3rows_button",o.appendChild(a)),a){for(var c in this._attachEventForItem(a),r={icons_path:i.icons_path||this.conf.icons_path,icons_css:this.conf.icons_css,skin:this.conf.skin},i)r[c]=i[c];for(r.id||(r.id=dhx4.newId());this._items[r.id];)r.id=dhx4.newId();l=this.items[r.type]&&this.items[r.type].render?this.items[r.type].render(a,r):null}return null!=l&&(this._items[l.id]=l,l.parentId=s.id,s.childIds.push(l.id),a._dhx_ribbonId=l.id,r.onclick&&"function"==typeof r.onclick&&(this._eventHandlers[l.id]=this._eventHandlers[l.id]||{},this._eventHandlers[l.id].onclick=r.onclick),l.callEvent=function(){d.callEvent.apply(d,arguments)},l._callHandler=function(){d._callHandler.apply(d,arguments)},this.items[r.type]&&"function"==typeof this.items[r.type].callAfterInit&&this.items[r.type].callAfterInit.apply(this,[l])),l},dhtmlXRibbon.prototype._callHandler=function(t,e){this._eventHandlers[t]&&this._eventHandlers[t].onclick&&this._eventHandlers[t].onclick.apply(this,e)},dhtmlXRibbon.prototype.items={},dhtmlXRibbon.prototype.items.button={render:function(t,e){var n,i;for(n in i={base:t,id:e.id,type:e.type,conf:{text:"",text_pos:e.isbig?"bottom":"right",img:null,imgdis:null,isbig:!1,disable:!1,skin:e.skin,icons_css:e.icons_css}},e)"id"!=n&&"onclick"!=n&&"type"!=n&&(i.conf[n]=e[n]);if(1==i.conf.icons_css)var a="<i class='"+i.conf.icons_path+(i.conf.img||"")+"'></i>";else a="<img class='dhxrb_image"+(i.conf.img?"'":" dhxrb_invisible'")+" src='"+(i.conf.img?i.conf.icons_path+i.conf.img:"")+"' />";return t.innerHTML=a+"<div class='dhxrb_label_button'>"+i.conf.text+"</div>","function"==typeof this.afterRender&&this.afterRender(i),i.conf.disable&&this.disable(i),i},getText:function(t){return t.conf.text},setText:function(t,e){var n=t.base.childNodes[1];t.conf.text=e,n.innerHTML=e},setImage:function(t,e){t.conf.img=e,0==t.conf.disable&&(t.base.childNodes[0][t.conf.icons_css?"className":"src"]=t.conf.icons_path+t.conf.img)},setImageDis:function(t,e){t.conf.imgdis=e,1==t.conf.disable&&(t.base.childNodes[0][t.conf.icons_css?"className":"src"]=t.conf.icons_path+t.conf.imgdis)},mousedown:function(t,e,n){return!0},click:function(t,e,n){return 0==n.button&&(e._callHandler(t.id,[t.id]),t.callEvent("onClick",[t.id]),!1)},disable:function(t){var e=t.base.childNodes[0],n=t.base.childNodes[1];return t.conf.imgdis&&(e[t.conf.icons_css?"className":"src"]=t.conf.icons_path+t.conf.imgdis,/\s?dhxrb_invisible/i.test(e.className)&&(e.className=e.className.replace(/\s?dhxrb_invisible/i,""))),/\s?dhxrb_disable_text_style/i.test(n.className)||(n.className+=" dhxrb_disable_text_style"),!0},enable:function(t){var e=t.base.childNodes[0],n=t.base.childNodes[1];return t.conf.img?e[t.conf.icons_css?"className":"src"]=t.conf.icons_path+t.conf.img:/\s?dhxrb_invisible/i.test(e.className)||(e.className+=" dhxrb_invisible"),/\s?dhxrb_disable_text_style/i.test(n.className)&&(n.className=n.className.replace(/\s?dhxrb_disable_text_style/i,"")),!0}},dhtmlXRibbon.prototype.items.buttonTwoState={click:function(t,e,n){return!1},afterRender:function(t){t.conf.state&&this.setState(t,t.conf.state)},mouseover:function(t){return/dhxrb_highlight0/.test(t.base.className)||(t.base.className+=" dhxrb_highlight0"),!1},mouseout:function(t){return/dhxrb_highlight0/.test(t.base.className)&&(t.base.className=t.base.className.replace(/\s?dhxrb_highlight0/,"")),!1},mousedown:function(t,e,n){return e._callHandler(t.id,[t.id,!t.conf.state]),this.setState(t,!t.conf.state,!0),!1},mouseup:function(t){return!1},setState:function(t,e,n){n=n||!1,(e=dhx4.s2b(e))?/dhxrb_highlight1/.test(t.base.className)||(t.base.className+=" dhxrb_highlight1"):/dhxrb_highlight1/.test(t.base.className)&&(t.base.className=t.base.className.replace(/\s?dhxrb_highlight1/,"")),t.conf.state=e,n&&t.callEvent("onStateChange",[t.id,t.conf.state])},getState:function(t){return 1==t.conf.state}},dhtmlXRibbon.prototype.items.buttonSegment={click:function(t,e,n){return!1},mousedown:function(t,e,n){return this.setState(t,e,!0),!1},callAfterInit:function(t){(t.conf.state||null==dhtmlXRibbon.prototype.items.buttonSegment._getSelectedNeighbor(t,this))&&(t.conf.state&&(t.conf.state=!1),dhtmlXRibbon.prototype.items.buttonSegment.setState(t,this,!1))},afterRender:function(){},setState:function(t,e,n){n=n||!1;var i=null;0==dhx4.s2b(t.conf.state)&&(null!=(i=this._getSelectedNeighbor(t,e))&&this._unSelect(i),/dhxrb_highlight1/.test(t.base.className)||(t.base.className+=" dhxrb_highlight1"),t.conf.state=!0,n&&(e._callHandler(t.id,[t.id,i?i.id:null]),e.callEvent("onStateChange",[t.id,i?i.id:null])))},remove:function(t,e){var n,i=dhx4.s2b(t.conf.state),a=null,o=0,r=e._items[t.parentId];if(i){for(;r.childIds[o]&&null==a;)"buttonSegment"==(n=e._items[r.childIds[o]]).type&&n!=t&&(a=n),o++;a&&this.setState(a,e)}},_unSelect:function(t){dhx4.s2b(t.conf.state)&&(/dhxrb_highlight1/.test(t.base.className)&&(t.base.className=t.base.className.replace(/\s?dhxrb_highlight1/,"")),t.conf.state=!1)},_getSelectedNeighbor:function(t,e){var n,i,a,o=e._items[t.parentId],r=null;for(i=o.childIds.length,n=0;n<i;n++)if("buttonSegment"==(a=e._items[o.childIds[n]]).type&&a.conf.state){r=a;break}return r}},dhtmlXRibbon.prototype.items.buttonSelect={itemCollection:[],_isAttachedEventInWindow:!1,afterRender:function(t){var e=t.base.childNodes[1];e.innerHTML+="<span class='dhxrb_arrow'>&nbsp;</span>",t.menu=null,this.itemCollection.push(t),this._attachEventToWindow(),e=null},setText:function(t,e){var n=t.base.childNodes[1].lastChild;t.conf.text=e,t.base.childNodes[1].innerHTML=e,t.base.childNodes[1].appendChild(n)},setOptionText:function(t,e,n){null!=t.menu?t.menu.setItemText(e,n):this._loopThroughItems(t.conf.items,e,n,!1)},getOptionText:function(t,e){return null!=t.menu?t.menu.getItemText(e):this._loopThroughItems(t.conf.items,e,null,!0)},_loopThroughItems:function(t,e,n,i){for(var a=0;a<t.length;a++){if(t[a].id==e)return 1!=i?(t[a].text=n,!0):t[a].text;if(null!=t[a].items){var o=this._loopThroughItems(t[a].items,e,n,i);if(null!=o)return o}}return null},_attachEventToWindow:function(){0==this._isAttachedEventInWindow&&("function"==typeof window.addEventListener?document.body.addEventListener("mousedown",this._hideAllMenus,!1):document.body.attachEvent("onmousedown",this._hideAllMenus),this._isAttachedEventInWindow=!0)},_detachEventFromWindow:function(){"function"==typeof window.addEventListener?document.body.removeEventListener("mousedown",this._hideAllMenus,!1):document.body.detachEvent("onmousedown",this._hideAllMenus),this._isAttachedEventInWindow=!1},_hideAllMenus:function(t){for(var e=(t=t||event).target||t.srcElement,n=!0;null!=e&&1==n;)null!=e.className&&/SubLevelArea_Polygon/i.test(e.className)?n=!1:e=e.parentNode;if(0!=n){var i=dhtmlXRibbon.prototype.items.buttonSelect.itemCollection;for(var a in i){var o=i[a];o.menu instanceof dhtmlXMenuObject&&(o._skipHiding?o._skipHiding=!1:dhtmlXRibbon.prototype.items.buttonSelect.hideMenu(o))}}},mousedown:function(t,e,n){return t._skipHiding=!0,this.showMenu(t),!1},mouseup:function(t){return!1},click:function(){},setState:function(){},showMenu:function(t){var e=dhx4.absLeft(t.base),n=dhx4.absTop(t.base)+t.base.offsetHeight;t.menu instanceof dhtmlXMenuObject?t.menu.showContextMenu(e,n):(t.menu=new dhtmlXMenuObject({parent:t.base,icons_path:t.conf.icons_path,context:!0,items:t.conf.items,skin:t.conf.skin}),t.conf.data&&(t.menu.loadStruct(t.conf.data),delete t.conf.data),t.menu.setAutoHideMode(!1),t.menu.attachEvent("onHide",function(e){null==e&&dhtmlXRibbon.prototype.items.buttonSelect._doOnHideMenu(t)}),t.menu.attachEvent("onShow",function(e){null==e&&dhtmlXRibbon.prototype.items.buttonSelect._doOnShowMenu(t)}),t.menu.attachEvent("onClick",function(e){t.callEvent("onClick",[e,t.id])}),t.base.oncontextmenu=function(){return!1},dhtmlXRibbon.prototype.items.buttonSelect.showMenu(t))},hideMenu:function(t){t.menu instanceof dhtmlXMenuObject&&t.menu.hideContextMenu()},remove:function(t){var e;t.menu instanceof dhtmlXMenuObject&&(t.menu.unload(),t.menu=null),t.base.oncontextmenu=null,-1!=(e=dhtmlXRibbon.prototype._indexOf(dhtmlXRibbon.prototype.items.buttonSelect.itemCollection,t))&&dhtmlXRibbon.prototype.items.buttonSelect.itemCollection.splice(e,1),0==dhtmlXRibbon.prototype.items.buttonSelect.itemCollection.length&&this._detachEventFromWindow()},setSkin:function(t,e){t.menu instanceof dhtmlXMenuObject&&t.menu.setSkin(e)},_doOnHideMenu:function(t){t._skipHiding?t._skipHiding=!1:/dhxrb_highlight1/.test(t.base.className)&&(t.base.className=t.base.className.replace(/\s?dhxrb_highlight1/,""))},_doOnShowMenu:function(t){/dhxrb_highlight1/.test(t.base.className)||(t.base.className+=" dhxrb_highlight1")}},dhtmlXRibbon.prototype.items.group={render:function(t,e){var n,i;for(n in i={base:t,id:e.id,type:e.type,conf:{disable:!1,skin:e.skin},childIds:[]},t.className="dhxrb_group",e)"id"!=n&&"onclick"!=n&&"type"!=n&&(i.conf[n]=e[n]);return i},callAfterInit:function(t){this._detachEventFromItem(t.base);var e,n,i,a,o=t.conf.list;for(n=o?o.length:0,e=0;e<n;e++)null!=(i=this._addItem(t.id,null,null,o[e]))&&(!(a=i.base.childNodes[1])||a.innerHTML||/\s?dhxrb_label_hide/i.test(a.className)||(a.className+=" dhxrb_label_hide"));dhtmlXRibbon.prototype.items.group.normalize(t),t.conf.disable&&this.disable(t.id),o=void 0},normalize:function(t){for(var e,n,i=t.base.children,a=i.length,o=!1,r=0,s=0;s<a;s++)if(/dhxrb_separator_group/i.test(i[s].className)||!/dhxrb_item_hide/i.test(i[s].className)){if(Math.ceil((s-r)/2)-Math.floor((s-r)/2)==0){if(/dhxrb_separator_group/i.test(i[s].className)){i[s].parentNode.removeChild(i[s]),o=!0;break}}else if(!/dhxrb_separator_group/i.test(i[s].className)){(e=document.createElement("div")).className="dhxrb_separator_groupp",t.base.insertBefore(e,i[s]),o=!0;break}}else r++;o?this.normalize(t):(n=t.base.lastChild)&&/dhxrb_separator_group/i.test(n.className)&&n.parentNode.removeChild(n)},hideChild:function(t,e){var n=dhtmlXRibbon.prototype._indexOf(t.base.children,e.base);if(0==n)n++;else{if(-1==n)return;n--}var i=t.base.children[n];i&&/dhxrb_separator_group/i.test(i.className)&&i.parentNode.removeChild(i)},showChild:function(t){this.normalize(t)}},dhtmlXRibbon.prototype.items.input={render:function(t,e){var n,i;for(n in i={base:t,id:e.id,type:e.type,conf:{text:"",text_pos:e.isbig?"bottom":"right",img:null,imgdis:null,isbig:!1,disable:!1,skin:e.skin,value:""}},e)"id"!=n&&"onclick"!=n&&"type"!=n&&(i.conf[n]=e[n]);return t.innerHTML="<input type='text' class='dhxrb_input'><div class='dhxrb_label_button'>"+i.conf.text+"</div>","function"==typeof this.afterRender&&this.afterRender(i),i.conf.disable&&this.disable(i),i.conf.width&&this.setWidth(i,i.conf.width),i.conf.value&&this.setValue(i,i.conf.value),i},callAfterInit:function(t){var e=t.base.childNodes[0];this._detachEventFromItem(t.base),this._attachEventsToInput(e)},setText:dhtmlXRibbon.prototype.items.button.setText,getText:dhtmlXRibbon.prototype.items.button.getText,change:function(t){var e=t.base.childNodes[0];t.conf.value=e.value},keydown:function(t,e,n){if(13==n.keyCode){var i=t.base.childNodes[0];t.conf.value=i.value,e.callEvent("onEnter",[t.id,t.conf.value])}},remove:function(t,e){var n=t.base.childNodes[0];e._detachEventsFromInput(n)},getValue:function(t){var e,n=t.base.childNodes[0];return e=n.value,n=void 0,e},setValue:function(t,e){t.base.childNodes[0].value=e,t.conf.value=e},setWidth:function(t,e){t.base.childNodes[0].style.width=parseInt(e)+"px"},disable:function(t){var e=t.base.childNodes[0],n=t.base.childNodes[1];return e.disabled=!0,/\s?dhxrb_disable_text_style/i.test(n.className)||(n.className+=" dhxrb_disable_text_style"),!0},enable:function(t){var e=t.base.childNodes[0],n=t.base.childNodes[1];return e.disabled=!1,/\s?dhxrb_disable_text_style/i.test(n.className)&&(n.className=n.className.replace(/\s?dhxrb_disable_text_style/i,"")),!0},getInput:function(t){return t.base.childNodes[0]}},dhtmlXRibbon.prototype.getInput=function(t){var e=this._items[t];return null==e||"input"!=e.type?null:this.items[e.type].getInput(e)},dhtmlXRibbon.prototype.items.checkbox={render:function(t,e){var n,i;for(n in i={base:t,id:e.id,type:e.type,conf:{text:"",text_pos:e.isbig?"bottom":"right",disable:!1,checked:!1}},e)"id"!=n&&"onclick"!=n&&"type"!=n&&(i.conf[n]=e[n]);return t.innerHTML="<div class='dhxrb_checkbox'></div><div class='dhxrb_label_checkbox'>"+i.conf.text+"</div>","function"==typeof this.afterRender&&this.afterRender(i),i.conf.checked&&this.check(i),i},callAfterInit:function(t){t.conf.disable&&this.disable(t.id)},setText:dhtmlXRibbon.prototype.items.button.setText,getText:dhtmlXRibbon.prototype.items.button.getText,mousedown:function(t){return!1},mouseup:function(t){return!1},click:function(t,e,n){if(0!=n.button)return!1;"checkbox"==t.type&&(t.conf.checked?this.uncheck(t,!0):this.check(t,!0))},check:function(t,e){e=e||!1,"checkbox"==t.type&&(t.conf.checked=!0,/\s?dhxrb_checked/i.test(t.base.className)||(t.base.className+=" dhxrb_checked"),e&&t.callEvent("onCheck",[t.id,t.conf.checked]))},uncheck:function(t,e){e=e||!1,"checkbox"==t.type&&(t.conf.checked=!1,/\s?dhxrb_checked/i.test(t.base.className)&&(t.base.className=t.base.className.replace(/\s?dhxrb_checked/i,"")),e&&t.callEvent("onCheck",[t.id,t.conf.checked]))},isChecked:function(t){return"checkbox"==t.type&&1==t.conf.checked},disable:function(t){return!0},enable:function(t){return!0}},dhtmlXRibbon.prototype.items.text={render:function(t,e){var n={base:t,id:e.id,type:e.type,conf:{text:""}};for(var i in e)"id"!=i&&"type"!=i&&(n.conf[i]=e[i]);return t.innerHTML="<div class='dhxrb_item_text'>"+n.conf.text+"</div>","function"==typeof this.afterRender&&this.afterRender(n),n},callAfterInit:function(t){this._detachEventFromItem(t.base)},getText:function(t){return t.conf.text},setText:function(t,e){t.conf.text=e,t.base.firstChild.innerHTML=t.conf.text}},dhtmlXRibbon.prototype.items.buttonCombo={render:function(t,e){var n,i,a={};for(n in i={base:t,id:e.id,type:e.type,conf:{text:"",text_pos:"right",width:140,skin:e.skin,callEvent:!0,mode:e.comboType,image_path:e.comboImagePath,default_image:e.comboDefaultImage,default_image_dis:e.comboDefaultImageDis}},e)"id"!=n&&"onclick"!=n&&"type"!=n&&(i.conf[n]=e[n]);for(n in i.conf)"text"!=n&&"text_pos"!=n&&"disable"!=n&&"data"!=n&&(a[n]=i.conf[n]);return i.base.className+=" dhxrb_buttoncombo_cont",i.base.innerHTML="<div class='dhxrb_buttoncombo'></div><div class='dhxrb_label_button'>"+i.conf.text+"</div>",a.parent=i.base.firstChild,i.combo=new dhtmlXCombo(a),i.combo.setSkin(a.skin),i.combo.attachEvent("onChange",function(t,e){i._callHandler(i.id,[t,e]),1==i.conf.callEvent&&i.callEvent("onSelectOption",[i.id,t,e]),i.conf.callEvent=!0}),i.conf.data&&(i.combo.load(i.conf.data),delete i.conf.data),"function"==typeof this.afterRender&&this.afterRender(i),i.conf.disable&&this.disable(i),i},callAfterInit:function(t){this._detachEventFromItem(t.base)},disable:function(t){var e=t.base.lastChild;return t.combo instanceof dhtmlXCombo&&t.combo.disable(),/\s?dhxrb_disable_text_style/i.test(e.className)||(e.className+=" dhxrb_disable_text_style"),!0},enable:function(t){var e=t.base.lastChild;return t.combo instanceof dhtmlXCombo&&t.combo.enable(),/\s?dhxrb_disable_text_style/i.test(e.className)&&(e.className=e.className.replace(/\s?dhxrb_disable_text_style/i,"")),!0},remove:function(t){t.combo instanceof dhtmlXCombo&&(t.combo.unload(),t.combo=null)},getValue:function(t){var e=null;return t.combo instanceof dhtmlXCombo&&(e=t.combo.getSelectedValue()),e},setValue:function(t,e,n){t.combo instanceof dhtmlXCombo&&(t.conf.callEvent=n,t.combo.setComboValue(e),t.conf.callEvent=!0)},setSkin:function(t,e){t.combo instanceof dhtmlXCombo&&t.combo.setSkin(e)}},dhtmlXRibbon.prototype.items.slider={render:function(t,e){var n,i,a={};for(n in i={base:t,id:e.id,type:e.type,conf:{text:"",text_pos:"right",size:150,vertical:!1,min:0,max:99,value:0,step:1,margin:10,disabled:!1,enableTooltip:!1}},e)"id"!=n&&"onclick"!=n&&"type"!=n&&(i.conf[n]=e[n]);for(n in i.conf)"text"!=n&&"text_pos"!=n&&"isbig"!=n&&(a[n]=i.conf[n]);return i.base.innerHTML="<center><div class='dhxrb_slider'></div></center><div class='dhxrb_label_button'>"+i.conf.text+"</div>",a.parent=i.base.firstChild.firstChild,i.slider=new dhtmlXSlider(a),"function"==typeof this.afterRender&&this.afterRender(i),i.conf.disable&&this.disable(i),i.slider.attachEvent("onChange",function(t){i._callHandler(i.id,[t]),i.callEvent("onValueChange",[i.id,t])}),i},callAfterInit:function(t){this._detachEventFromItem(t.base)},setSkin:function(t,e){t.slider instanceof dhtmlXSlider&&t.slider.setSkin(e)},disable:function(t){var e=t.base.childNodes[1];return t.slider instanceof dhtmlXSlider&&t.slider.disable(),/\s?dhxrb_disable_text_style/i.test(e.className)||(e.className+=" dhxrb_disable_text_style"),!0},enable:function(t){var e=t.base.childNodes[1];return t.slider instanceof dhtmlXSlider&&t.slider.enable(),/\s?dhxrb_disable_text_style/i.test(e.className)&&(e.className=e.className.replace(/\s?dhxrb_disable_text_style/i,"")),!0},remove:function(t){t.slider instanceof dhtmlXSlider&&(t.slider.unload(),t.slider=null)},getValue:function(t){var e=null;return t.slider instanceof dhtmlXSlider&&(e=t.slider.getValue()),e},setValue:function(t,e){t.slider instanceof dhtmlXSlider&&t.slider.setValue(e)}},dhtmlXRibbon.prototype.items._extends=function(t,e){var n;for(n in e)t[n]=t[n]||e[n];return t},dhtmlXRibbon.prototype._addNewLevel=function(t){var e,n;"rows"==t.conf.mode?(e=t.contForItems.lastChild)&&/dhxrb_block_rows/i.test(e.className)&&e.childNodes.length<3?((n=document.createElement("div")).className="dhxrb_block_row",e.appendChild(n)):((e=document.createElement("div")).className="dhxrb_block_rows",t.contForItems.appendChild(e),(n=document.createElement("div")).className="dhxrb_block_row",e.appendChild(n)):((n=document.createElement("div")).className="dhxrb_3rows_block",t.contForItems.appendChild(n))},dhtmlXRibbon.prototype._attachEventForItem=function(t){"function"==typeof window.addEventListener?(t.addEventListener("mouseover",this._doOnHighlight0,!1),t.addEventListener("mouseout",this._doOffHighlight0,!1),t.addEventListener("mousedown",this._doOnHighlight1,!1),t.addEventListener("mouseup",this._doOffHighlight1,!1),t.addEventListener("click",this._doOnClick,!1)):(t.attachEvent("onmouseover",this._doOnHighlight0),t.attachEvent("onmouseout",this._doOffHighlight0),t.attachEvent("onmousedown",this._doOnHighlight1),t.attachEvent("onmouseup",this._doOffHighlight1),t.attachEvent("onclick",this._doOnClick))},dhtmlXRibbon.prototype._detachEventFromItem=function(t){"function"==typeof window.addEventListener?(t.removeEventListener("mouseover",this._doOnHighlight0,!1),t.removeEventListener("mouseout",this._doOffHighlight0,!1),t.removeEventListener("mousedown",this._doOnHighlight1,!1),t.removeEventListener("mouseup",this._doOffHighlight1,!1),t.removeEventListener("click",this._doOnClick,!1)):(t.detachEvent("onmouseover",this._doOnHighlight0),t.detachEvent("onmouseout",this._doOffHighlight0),t.detachEvent("onmousedown",this._doOnHighlight1),t.detachEvent("onmouseup",this._doOffHighlight1),t.detachEvent("onclick",this._doOnClick))},dhtmlXRibbon.prototype._attachEventsToInput=function(t){"function"==typeof window.addEventListener?(t.addEventListener("focus",this._doOnFocus,!1),t.addEventListener("blur",this._doOnBlur,!1),t.addEventListener("change",this._doOnChange,!1),t.addEventListener("keydown",this._doOnKeydown,!1)):(t.attachEvent("onfocus",this._doOnFocus),t.attachEvent("onblur",this._doOnBlur),t.attachEvent("onchange",this._doOnChange),t.attachEvent("onkeydown",this._doOnKeydown))},dhtmlXRibbon.prototype._detachEventsFromInput=function(t){"function"==typeof window.addEventListener?(t.removeEventListener("focus",this._doOnFocus,!1),t.removeEventListener("blur",this._doOnBlur,!1),t.removeEventListener("change",this._doOnChange,!1),t.removeEventListener("keydown",this._doOnKeydown,!1)):(t.detachEvent("onfocus",this._doOnFocus),t.detachEvent("onblur",this._doOnBlur),t.detachEvent("onchange",this._doOnChange),t.detachEvent("onkeydown",this._doOnKeydown))},dhtmlXRibbon.prototype._getContainerForSmallItem=function(t){var e=t.contForItems.lastChild,n=null;return"rows"==t.conf.mode?e&&/\s?dhxrb_block_rows/i.test(e.className)?(n=e.lastChild)||((n=document.createElement("div")).className="dhxrb_block_row",e.appendChild(n)):((e=document.createElement("div")).className="dhxrb_block_rows",t.contForItems.appendChild(e),(n=document.createElement("div")).className="dhxrb_block_row",e.appendChild(n)):e&&/dhxrb_3rows_block/i.test(e.className)&&e.childNodes.length<3?n=e:((n=document.createElement("div")).className="dhxrb_3rows_block",t.contForItems.appendChild(n)),n},dhtmlXRibbon.prototype._findItemByNode=function(t){for(;t&&!t._dhx_ribbonId;)t=t.parentNode;return t},dhtmlXRibbon.prototype._indexOf=function(t,e){var n,i;for(i=t.length,n=0;n<i;n++)if(t[n]==e)return n;return-1},dhtmlXRibbon.prototype._removeItem=function(t){var e,n,i=this._items[t.parentId];"group"!=t.type?(delete this._items[t.id],e=t.base.parentNode,this._detachEventFromItem(t.base),e.removeChild(t.base),"block"==i.type?e!=i.contForItems&&0==e.childNodes.length&&e.parentNode.removeChild(e):"group"==i.type&&dhtmlXRibbon.prototype.items.group.normalize(i),-1!=(n=this._indexOf(i.childIds,t.id))&&i.childIds.splice(n,1),this.items[t.type]&&"function"==typeof this.items[t.type].remove&&this.items[t.type].remove(t,this)):this._removeGroup(t)},dhtmlXRibbon.prototype._removeGroup=function(t){for(var e,n=[],i=this._items[t.parentId],a=t.base.parentNode,o=0;o<t.childIds.length;o++)n.push(this._items[t.childIds[o]]);for(o=0;o<n.length;o++)this._removeItem(n[o]);delete this._items[t.id],t.base.parentNode&&a.removeChild(t.base),0==a.childNodes.length&&a.parentNode.removeChild(a),-1!=(e=this._indexOf(i.childIds,t.id))&&i.childIds.splice(e,1),this.items[t.type]&&"function"==typeof this.items[t.type].remove&&this.items[t.type].remove(t)},dhtmlXRibbon.prototype._removeBlock=function(t){for(var e,n,i=[],a=0;a<t.childIds.length;a++)i.push(this._items[t.childIds[a]]);for(a=0;a<i.length;a++)this._removeItem(i[a]);delete this._items[t.id],t.base.parentNode.removeChild(t.base),n=t.parentId?this._items[t.parentId]:this,-1!=(e=this._indexOf(n.childIds,t.id))&&n.childIds.splice(e,1)},dhtmlXRibbon.prototype._removeTab=function(t,e){for(var n,i=[],a=0;a<t.childIds.length;a++)i.push(this._items[t.childIds[a]]);for(a=0;a<i.length;a++)this._removeBlock(i[a]);delete this._items[t.id],-1!=(n=this._indexOf(this.childIds,t.id))&&this.childIds.splice(n,1)},dhtmlXRibbon.prototype._skinCollection={dhx_skyblue:!0,dhx_web:!0,dhx_terrace:!0,material:!0},dhtmlXRibbon.prototype._setSkinForItems=function(t){var e,n;for(e in this._items)(n=this._items[e]).conf.skin=t,dhtmlXRibbon.prototype.items[n.type]&&"function"==typeof dhtmlXRibbon.prototype.items[n.type].setSkin&&dhtmlXRibbon.prototype.items[n.type].setSkin(n,t);n=void 0,e=void 0},dhtmlXRibbon.prototype._setBlockText=function(t,e){t.conf.text=e,t.contForText.innerHTML=e,!e&&0!=e&&t.contForText.parentNode?t.contForText.parentNode.removeChild(t.contForText):t.contForText.parentNode||("top"==t.conf.text_pos?t.base.insertBefore(t.contForText,t.contForItems):t.base.appendChild(t.contForText))},dhtmlXRibbon.prototype.hide=function(t){var e=this._items[t];if((!this.items[e.type]||"function"!=typeof this.items[e.type].hide||1==this.items[e.type].hide(e))&&"tab"!=e.type){/\s?dhxrb_item_hide/i.test(e.base.className)||(e.base.className+=" dhxrb_item_hide");var n=this._items[e.parentId];n&&this.items[n.type]&&"function"==typeof this.items[n.type].hideChild&&this.items[n.type].hideChild(n,e)}},dhtmlXRibbon.prototype.show=function(t){var e=this._items[t];if((!this.items[e.type]||"function"!=typeof this.items[e.type].show||1==this.items[e.type].show(e))&&"tab"!=e.type){/\s?dhxrb_item_hide/i.test(e.base.className)&&(e.base.className=e.base.className.replace(/\s?dhxrb_item_hide/i,""));var n=this._items[e.parentId];n&&this.items[n.type]&&"function"==typeof this.items[n.type].showChild&&this.items[n.type].showChild(n,e)}},dhtmlXRibbon.prototype.check=function(t,e){e=dhx4.s2b(e);var n=this._items[t];n&&!n.conf.checked&&"function"==typeof this.items[n.type].check&&(this.items[n.type].check(n),e&&this.callEvent("onCheck",[n.id,n.conf.checked]))},dhtmlXRibbon.prototype.uncheck=function(t,e){e=dhx4.s2b(e);var n=this._items[t];n&&n.conf.checked&&"function"==typeof this.items[n.type].uncheck&&(this.items[n.type].uncheck(n),e&&this.callEvent("onCheck",[n.id,n.conf.checked]))},dhtmlXRibbon.prototype.isChecked=function(t){var e=this._items[t];if(e&&"function"==typeof this.items[e.type].isChecked)return this.items[e.type].isChecked(e)},dhtmlXRibbon.prototype.disable=function(t,e){var n=this._items[t];if((!this.items[n.type]||"function"!=typeof this.items[n.type].disable||1==this.items[n.type].disable(n))&&"tab"!=n.type){if("block"==n.type||"group"==n.type)for(var i=0;i<n.childIds.length;i++)this.disable(n.childIds[i]);/\s?dhxrb_item_disable/i.test(n.base.className)||(n.base.className+=" dhxrb_item_disable"),null!=n.base.className.match(/dhxrb_highlight/gi)&&("buttonTwoState"==n.type?n.base.className=n.base.className.replace(/\s*dhxrb_highlight0/gi,""):n.base.className=n.base.className.replace(/\s*dhxrb_highlight\d/gi,"")),n.conf.disable=!0}},dhtmlXRibbon.prototype.enable=function(t,e){var n=this._items[t];if((!this.items[n.type]||"function"!=typeof this.items[n.type].enable||1==this.items[n.type].enable(n))&&"tab"!=n.type){if("block"==n.type||"group"==n.type)for(q=0;q<n.childIds.length;q++)this.enable(n.childIds[q]);/\s?dhxrb_item_disable/i.test(n.base.className)&&(n.base.className=n.base.className.replace(/\s?dhxrb_item_disable/i,"")),n.conf.disable=!1}},dhtmlXRibbon.prototype.isEnabled=function(t){var e=this._items[t];return this.items[e.type]&&"function"==typeof this.items[e.type].isEnabled?this.items[e.type].isEnabled(e):"tab"==e.type?void 0:1!=e.conf.disable},dhtmlXRibbon.prototype.isVisible=function(t){var e=this._items[t];return this.items[e.type]&&"function"==typeof this.items[e.type].isVisible?this.items[e.type].isVisible(e):"tab"==e.type?void 0:!/\s?dhxrb_item_hide/i.test(e.base.className)},dhtmlXRibbon.prototype.setItemState=function(t,e,n){e=dhx4.s2b(e),n=dhx4.s2b(n);var i=this._items[t];if(i&&"function"==typeof this.items[i.type].setState)switch(i.type){case"buttonSegment":this.items[i.type].setState(i,this,n);break;default:this.items[i.type].setState(i,e,n)}},dhtmlXRibbon.prototype.getItemState=function(t){var e=this._items[t];if(e&&"function"==typeof this.items[e.type].getState)switch(e.type){case"buttonTwoState":case"buttonSegment":return this.items[e.type].getState(e)}return null},dhtmlXRibbon.prototype.setIconPath=function(t){this.conf.icons_path=t},dhtmlXRibbon.prototype.setIconset=function(t){this.conf.icons_css="awesome"==t},dhtmlXRibbon.prototype.removeItem=function(t){var e=this._items[t];if(null!=e)switch(e.type){case"tab":break;case"block":this._removeBlock(e);break;case"group":this._removeGroup(e);break;default:this._removeItem(e)}},dhtmlXRibbon.prototype.setSkin=function(t){if(t="string"==typeof t?t.toLowerCase():"",1==this._skinCollection[t]){var e,n,i=-1,a="dhtmlxribbon";if((e=this._base.className.match(/\S\w+/gi))instanceof Array){for(n in this._skinCollection){if(-1!=i)break;i=this._indexOf(e,a+"_"+n)}i=-1==i?e.length:i}else e=[],i=0;e[i]=a+"_"+t,this._base.className=e.join(" "),this.conf.skin=t,null!=this._tabbar&&this._tabbar.setSkin(t),this._setSkinForItems(t)}},dhtmlXRibbon.prototype.tabs=function(t){return this._tabbar instanceof dhtmlXTabBar?this._tabbar.tabs(t):void 0},dhtmlXRibbon.prototype.getItemType=function(t){var e=this._items[t];return e?e.type:void 0},dhtmlXRibbon.prototype.getValue=function(t){var e=this._items[t],n=void 0;return e&&this.items[e.type]&&"function"==typeof this.items[e.type].getValue&&(n=this.items[e.type].getValue(e)),n},dhtmlXRibbon.prototype.setValue=function(t,e,n){var i=this._items[t];n=!1!==n,i&&this.items[i.type]&&"function"==typeof this.items[i.type].setValue&&this.items[i.type].setValue(i,e,n)},dhtmlXRibbon.prototype.getItemText=function(t){var e=this._items[t];return e?"tab"==e.type?this.tabs(e.id).getText():"block"==e.type?this.items.button.getText(e):this.items[e.type]&&"function"==typeof this.items[e.type].getText?this.items[e.type].getText(e):null:null},dhtmlXRibbon.prototype.setItemText=function(t,e){var n=this._items[t];n&&("tab"==n.type?this.tabs(n.id).setText(e):"block"==n.type?this._setBlockText(n,e):this.items[n.type]&&"function"==typeof this.items[n.type].setText&&this.items[n.type].setText(n,e))},dhtmlXRibbon.prototype.setItemOptionText=function(t,e,n){var i=this._items[t];"buttonSelect"==i.type&&this.items[i.type].setOptionText(i,e,n)},dhtmlXRibbon.prototype.getItemOptionText=function(t,e){var n=this._items[t];return"buttonSelect"==n.type?this.items[n.type].getOptionText(n,e):null},dhtmlXRibbon.prototype.setItemImage=function(t,e){var n=this._items[t];null!=n&&null!=this.items[n.type]&&"function"==typeof this.items[n.type].setImage&&this.items[n.type].setImage(n,e)},dhtmlXRibbon.prototype.setItemImageDis=function(t,e){var n=this._items[t];null!=n&&null!=this.items[n.type]&&"function"==typeof this.items[n.type].setImageDis&&this.items[n.type].setImageDis(n,e)},dhtmlXRibbon.prototype.getCombo=function(t){var e=this._items[t];return null!=e&&"buttonCombo"==e.type?e.combo:null},function(){var t=dhtmlXRibbon.prototype.items;t.buttonTwoState=t._extends(t.buttonTwoState,t.button),t.buttonSelect=t._extends(t.buttonSelect,t.buttonTwoState),t.buttonSegment=t._extends(t.buttonSegment,t.buttonTwoState)}(),void 0!==window.dhtmlXCellObject&&(dhtmlXCellObject.prototype._createNode_ribbon=function(t,e,n,i,a){return void 0!==a?t=a:((t=document.createElement("DIV")).className="dhx_cell_ribbon_"+(this.conf.borders?"def":"no_borders"),t.appendChild(document.createElement("DIV"))),this.cell.insertBefore(t,this.cell.childNodes[this.conf.idx.cont]),this.conf.ofs_nodes.t.ribbon=!0,this._updateIdx(),this._adjustCont(this._idd),t},dhtmlXCellObject.prototype.attachRibbon=function(t){if(null==this.dataNodes.ribbon&&null==this.dataNodes.toolbar){this.callEvent("_onBeforeContentAttach",["ribbon"]),void 0===t&&(t={}),void 0===t.skin&&(t.skin=this.conf.skin),t.parent=this._attachObject("ribbon").firstChild,this.dataNodes.ribbon=new dhtmlXRibbon(t);var e=this;return this.dataNodes.ribbon.attachEvent("_onHeightChanged",function(){e._adjustCont(e._idd)}),this._adjustCont(),t.parent=null,t=null,this.callEvent("_onContentAttach",[]),this.dataNodes.ribbon}},dhtmlXCellObject.prototype.detachRibbon=function(){null!=this.dataNodes.ribbon&&("function"==typeof this.dataNodes.ribbon.unload&&this.dataNodes.ribbon.unload(),this.dataNodes.ribbon=null,delete this.dataNodes.ribbon,this._detachObject("ribbon"))},dhtmlXCellObject.prototype.showRibbon=function(){this._mtbShowHide("ribbon","")},dhtmlXCellObject.prototype.hideRibbon=function(){this._mtbShowHide("ribbon","none")},dhtmlXCellObject.prototype.getAttachedRibbon=function(){return this.dataNodes.ribbon}),dhtmlXToolbarObject.prototype.addSpacer=function(t){var e=this.idPrefix+t;if(null!=this._spacer){if(this._spacer.idd==t)return;if(this._spacer==this.objPull[e].obj.parentNode){for(var n=!0;n;){var i=this._spacer.childNodes[0].idd;this.base.appendChild(this._spacer.childNodes[0]),i!=t&&0!=this._spacer.childNodes.length||(null!=this.objPull[e].arw&&this.base.appendChild(this.objPull[e].arw),n=!1)}return this._spacer.idd=t,void this._fixSpacer()}if(this.base==this.objPull[e].obj.parentNode){n=!0;for(var a=null!=this.objPull[e].arw;n;){var o=this.base.childNodes.length-1;1==a&&this.base.childNodes[o]==this.objPull[e].arw&&(n=!1),this.base.childNodes[o].idd==t&&(n=!1),n&&(this._spacer.childNodes.length>0?this._spacer.insertBefore(this.base.childNodes[o],this._spacer.childNodes[0]):this._spacer.appendChild(this.base.childNodes[o]))}return this._spacer.idd=t,void this._fixSpacer()}}else{var r=null;for(o=0;o<this.base.childNodes.length;o++)this.base.childNodes[o]==this.objPull[this.idPrefix+t].obj&&(r=o,null!=this.objPull[this.idPrefix+t].arw&&(r=o+1));if(null!=r){for(this._spacer=document.createElement("DIV"),this._spacer.className="right"==this.conf.align?" dhxtoolbar_float_left":" dhxtoolbar_float_right",this._spacer.dir="ltr",this._spacer.idd=t;this.base.childNodes.length>r+1;)this._spacer.appendChild(this.base.childNodes[r+1]);this.cont.appendChild(this._spacer),this._fixSpacer()}}"dhx_terrace"==this.conf.skin&&this._improveTerraceSkin()},dhtmlXToolbarObject.prototype.removeSpacer=function(){if(this._spacer){for(;this._spacer.childNodes.length>0;)this.base.appendChild(this._spacer.childNodes[0]);this._spacer.parentNode.removeChild(this._spacer),this._spacer=null,"dhx_terrace"==this.conf.skin&&this._improveTerraceSkin()}},dhtmlXToolbarObject.prototype._fixSpacer=function(){if(void 0===window.addEventListener&&null!=this._spacer){this._spacer.style.borderLeft="1px solid #a4bed4";var t=this._spacer;window.setTimeout(function(){t.style.borderLeft="0px solid #a4bed4",t=null},1)}},dhtmlXToolbarObject.prototype.getType=function(t){var e=this.getParentId(t);if(null!=e){var n=null,i=this.objPull[this.idPrefix+e]._listOptions[t];return null!=i&&(n=null!=i.sep?"buttonSelectSeparator":"buttonSelectButton"),n}return null==this.objPull[this.idPrefix+t]?null:this.objPull[this.idPrefix+t].type},dhtmlXToolbarObject.prototype.getTypeExt=function(t){var e=this.getType(t);return"buttonSelectButton"==e||"buttonSelectSeparator"==e?e="buttonSelectButton"==e?"button":"separator":null},dhtmlXToolbarObject.prototype.inArray=function(t,e){for(var n=0;n<t.length;n++)if(t[n]==e)return!0;return!1},dhtmlXToolbarObject.prototype.getParentId=function(t){var e=null;for(var n in this.objPull)if(this.objPull[n]._listOptions)for(var i in this.objPull[n]._listOptions)i==t&&(e=String(n).replace(this.idPrefix,""));return e},dhtmlXToolbarObject.prototype._addItem=function(t,e){"string"==typeof t.text&&(t.text=window.dhx4.trim(t.text),0==t.text.length&&(t.text=null)),this._addItemToStorage(t,e),"dhx_terrace"==this.conf.skin&&this._improveTerraceSkin()},dhtmlXToolbarObject.prototype.addButton=function(t,e,n,i,a){this._addItem({id:t,type:"button",text:n,img:i,imgdis:a},e)},dhtmlXToolbarObject.prototype.addText=function(t,e,n){this._addItem({id:t,type:"text",text:n},e)},dhtmlXToolbarObject.prototype.addButtonSelect=function(t,e,n,i,a,o,r,s,l,d){for(var c=[],h=0;h<i.length;h++){var u={};i[h]instanceof Array?(u.id=i[h][0],u.type="obj"==i[h][1]?"button":"separator",u.text=i[h][2]||null,u.img=i[h][3]||null):i[h]instanceof Object&&null!=i[h]&&void 0!==i[h].id&&void 0!==i[h].type&&(u.id=i[h].id,u.type="obj"==i[h].type?"button":"separator",u.text=i[h].text,u.img=i[h].img),c.push(u)}this._addItem({id:t,type:"buttonSelect",text:n,img:a,imgdis:o,renderSelect:r,openAll:s,options:c,maxOpen:l,mode:d},e)},dhtmlXToolbarObject.prototype.addButtonTwoState=function(t,e,n,i,a){this._addItem({id:t,type:"buttonTwoState",img:i,imgdis:a,text:n},e)},dhtmlXToolbarObject.prototype.addSeparator=function(t,e){this._addItem({id:t,type:"separator"},e)},dhtmlXToolbarObject.prototype.addSlider=function(t,e,n,i,a,o,r,s,l){this._addItem({id:t,type:"slider",length:n,valueMin:i,valueMax:a,valueNow:o,textMin:r,textMax:s,toolTip:l},e)},dhtmlXToolbarObject.prototype.addInput=function(t,e,n,i){this._addItem({id:t,type:"buttonInput",value:n,width:i},e)},dhtmlXToolbarObject.prototype.forEachItem=function(t){for(var e in this.objPull)this.inArray(this.rootTypes,this.objPull[e].type)&&t(this.objPull[e].id.replace(this.idPrefix,""))},function(){for(var t="isVisible,enableItem,disableItem,isEnabled,setItemText,getItemText,setItemToolTip,getItemToolTip,getInput,setItemImage,setItemImageDis,clearItemImage,clearItemImageDis,setItemState,getItemState,setItemToolTipTemplate,getItemToolTipTemplate,setValue,getValue,setMinValue,getMinValue,setMaxValue,getMaxValue,setWidth,getWidth,setMaxOpen".split(","),e=[!1,"","",!1,"","","","","","","","","",!1,"","","",null,"",[null,null],"",[null,null],"",null],n=function(t,e){return function(n,i,a){return n=this.idPrefix+n,null!=this.objPull[n][t]?this.objPull[n][t].call(this.objPull[n],i,a):e}},i=0;i<t.length;i++){var a=t[i],o=e[i];dhtmlXToolbarObject.prototype[a]=n(a,o)}}(),dhtmlXToolbarObject.prototype.showItem=function(t){t=this.idPrefix+t,null!=this.objPull[t]&&null!=this.objPull[t].showItem&&(this.objPull[t].showItem(),"dhx_terrace"==this.conf.skin&&this._improveTerraceSkin())},dhtmlXToolbarObject.prototype.hideItem=function(t){t=this.idPrefix+t,null!=this.objPull[t]&&null!=this.objPull[t].hideItem&&(this.objPull[t].hideItem(),"dhx_terrace"==this.conf.skin&&this._improveTerraceSkin())},dhtmlXToolbarObject.prototype.getPosition=function(t){return this._getPosition(t)},dhtmlXToolbarObject.prototype._getPosition=function(t,e){if(null==this.objPull[this.idPrefix+t])return null;for(var n=null,i=0,a=0;a<this.base.childNodes.length;a++)null!=this.base.childNodes[a].idd&&(this.base.childNodes[a].idd==t&&(n=i),i++);if(!n&&null!=this._spacer)for(a=0;a<this._spacer.childNodes.length;a++)null!=this._spacer.childNodes[a].idd&&(this._spacer.childNodes[a].idd==t&&(n=i),i++);return n},dhtmlXToolbarObject.prototype.setPosition=function(t,e){this._setPosition(t,e)},dhtmlXToolbarObject.prototype._setPosition=function(t,e){if(null!=this.objPull[this.idPrefix+t]){var n=null;this._spacer&&(n=this._spacer.idd,this.removeSpacer()),isNaN(e)&&(e=this.base.childNodes.length),e<0&&(e=0);var i=this.objPull[this.idPrefix+t];this.base.removeChild(i.obj),i.arw&&this.base.removeChild(i.arw);var a=this._getIdByPosition(e,!0);null==a[0]?(this.base.appendChild(i.obj),i.arw&&this.base.appendChild(i.arw)):(this.base.insertBefore(i.obj,this.base.childNodes[a[1]]),i.arw&&this.base.insertBefore(i.arw,this.base.childNodes[a[1]+1])),null!=n&&this.addSpacer(n)}},dhtmlXToolbarObject.prototype._getIdByPosition=function(t,e){for(var n=null,i=0,a=0,o=0;o<this.base.childNodes.length;o++)null!=this.base.childNodes[o].idd&&null==n&&i++==t&&(n=this.base.childNodes[o].idd),null==n&&a++;return a=null==n?null:a,1==e?new Array(n,a):n},dhtmlXToolbarObject.prototype.removeItem=function(t){this._removeItem(t),"dhx_terrace"==this.conf.skin&&this._improveTerraceSkin()},dhtmlXToolbarObject.prototype._removeItem=function(t){var e=this.getType(t);t=this.idPrefix+t;var n=this.objPull[t];if(1=={button:1,buttonTwoState:1}[e]){for(var i in window.dhx4.isIE&&(n.obj.onselectstart=null),this._evs.clear.apply(n,[n.obj.evs,n.obj]),n.obj)"function"==typeof n.obj[i]&&(n.obj[i]=null);for(var i in n.obj.parentNode.removeChild(n.obj),n.obj=null,n)n[i]=null}if("buttonSelect"==e){for(var i in n._listOptions)this.removeListOption(t,i);for(var i in n._listOptions=null,n.polygon._ie6cover&&(document.body.removeChild(n.polygon._ie6cover),n.polygon._ie6cover=null),n.p_tbl.removeChild(n.p_tbody),n.polygon.removeChild(n.p_tbl),n.polygon.onselectstart=null,document.body.removeChild(n.polygon),window.dhx4.isIE&&(n.obj.onselectstart=null,n.arw.onselectstart=null),this._evs.clear.apply(n,[n.obj.evs,n.obj]),this._evs.clear.apply(n,[n.arw.evs,n.arw]),n.obj)"function"==typeof n.obj[i]&&(n.obj[i]=null);for(var i in n.obj.parentNode.removeChild(n.obj),n.obj=null,n.arw)"function"==typeof n.arw[i]&&(n.arw[i]=null);for(var i in n.arw.parentNode.removeChild(n.arw),n.arw=null,n)n[i]=null}if("buttonInput"==e&&(n.obj.childNodes[0].onkeydown=null,n.obj.removeChild(n.obj.childNodes[0]),n.obj.w=null,n.obj.idd=null,n.obj.parentNode.removeChild(n.obj),n.obj=null,n.id=null,n.type=null,n.enableItem=null,n.disableItem=null,n.isEnabled=null,n.showItem=null,n.hideItem=null,n.isVisible=null,n.setItemToolTip=null,n.getItemToolTip=null,n.setWidth=null,n.getWidth=null,n.setValue=null,n.getValue=null,n.setItemText=null,n.getItemText=null),"slider"==e){for(window.dhx4.isIPad?(document.removeEventListener("touchmove",pen._doOnMouseMoveStart,!1),document.removeEventListener("touchend",pen._doOnMouseMoveEnd,!1)):"function"==typeof window.addEventListener?(window.removeEventListener("mousemove",n.pen._doOnMouseMoveStart,!1),window.removeEventListener("mouseup",n.pen._doOnMouseMoveEnd,!1)):(document.body.detachEvent("onmousemove",n.pen._doOnMouseMoveStart),document.body.detachEvent("onmouseup",n.pen._doOnMouseMoveEnd)),n.pen.allowMove=null,n.pen.initXY=null,n.pen.maxX=null,n.pen.minX=null,n.pen.nowX=null,n.pen.newNowX=null,n.pen.valueMax=null,n.pen.valueMin=null,n.pen.valueNow=null,n.pen._definePos=null,n.pen._detectLimits=null,n.pen._doOnMouseMoveStart=null,n.pen._doOnMouseMoveEnd=null,n.pen.onmousedown=null,n.obj.removeChild(n.pen),n.pen=null,n.label.tip=null,document.body.removeChild(n.label),n.label=null,n.obj.onselectstart=null,n.obj.idd=null;n.obj.childNodes.length>0;)n.obj.removeChild(n.obj.childNodes[0]);n.obj.parentNode.removeChild(n.obj),n.obj=null,n.id=null,n.type=null,n.state=null,n.enableItem=null,n.disableItem=null,n.isEnabled=null,n.setItemToolTipTemplate=null,n.getItemToolTipTemplate=null,n.setMaxValue=null,n.setMinValue=null,n.getMaxValue=null,n.getMinValue=null,n.setValue=null,n.getValue=null,n.showItem=null,n.hideItem=null,n.isVisible=null}"separator"==e&&(n.obj.onselectstart=null,n.obj.idd=null,n.obj.parentNode.removeChild(n.obj),n.obj=null,n.id=null,n.type=null,n.showItem=null,n.hideItem=null,n.isVisible=null),"text"==e&&(n.obj.onselectstart=null,n.obj.idd=null,n.obj.parentNode.removeChild(n.obj),n.obj=null,n.id=null,n.type=null,n.showItem=null,n.hideItem=null,n.isVisible=null,n.setWidth=null,n.setItemText=null,n.getItemText=null),e=null,n=null,this.objPull[t]=null,delete this.objPull[t]},function(){for(var t="addListOption,removeListOption,showListOption,hideListOption,isListOptionVisible,enableListOption,disableListOption,isListOptionEnabled,setListOptionPosition,getListOptionPosition,setListOptionText,getListOptionText,setListOptionToolTip,getListOptionToolTip,setListOptionImage,getListOptionImage,clearListOptionImage,forEachListOption,getAllListOptions,setListOptionSelected,getListOptionSelected".split(","),e=function(t){return function(e,n,i,a,o,r){if(e=this.idPrefix+e,null!=this.objPull[e]&&"buttonSelect"==this.objPull[e].type)return this.objPull[e][t].call(this.objPull[e],n,i,a,o,r)}},n=0;n<t.length;n++){var i=t[n];dhtmlXToolbarObject.prototype[i]=e(i)}}(),dhtmlXToolbarObject.prototype._rtlParseBtn=function(t,e){return t+e},dhtmlXToolbarObject.prototype._separatorObject=function(t,e,n){return this.id=t.idPrefix+e,this.obj=document.createElement("DIV"),this.obj.className="dhx_toolbar_sep",this.obj.style.display=null!=n.hidden?"none":"",this.obj.idd=String(e),this.obj.title=n.title||"",this.obj.onselectstart=function(t){(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1},this.obj.ontouchstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,t.cancelBubble=!0,!1},t.base.appendChild(this.obj),this.showItem=function(){this.obj.style.display=""},this.hideItem=function(){this.obj.style.display="none"},this.isVisible=function(){return""==this.obj.style.display},this},dhtmlXToolbarObject.prototype._textObject=function(t,e,n){return this.id=t.idPrefix+e,this.obj=document.createElement("DIV"),this.obj.className="dhx_toolbar_text",this.obj.style.display=null!=n.hidden?"none":"",this.obj.idd=String(e),this.obj.title=n.title||"",this.obj.onselectstart=function(t){(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1},this.obj.ontouchstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,t.cancelBubble=!0,!1},this.obj.innerHTML=n.text||"",t.base.appendChild(this.obj),this.showItem=function(){this.obj.style.display=""},this.hideItem=function(){this.obj.style.display="none"},this.isVisible=function(){return""==this.obj.style.display},this.setItemText=function(t){this.obj.innerHTML=t},this.getItemText=function(){return this.obj.innerHTML},this.setWidth=function(t){this.obj.style.width=t+"px"},this.setItemToolTip=function(t){this.obj.title=t},this.getItemToolTip=function(){return this.obj.title},this},dhtmlXToolbarObject.prototype._buttonObject=function(t,e,n){this.id=t.idPrefix+e,this.state=null==n.enabled,this.imgEn=n.img||"",this.imgDis=n.imgdis||"",this.img=this.state?""!=this.imgEn?this.imgEn:"":""!=this.imgDis?this.imgDis:"",this.obj=document.createElement("DIV"),this.obj.className="dhx_toolbar_btn dhxtoolbar_btn_"+(this.state?"def":"dis"),this.obj.style.display=null!=n.hidden?"none":"",this.obj.allowClick=!1,this.obj.extAction=n.action||null,this.obj.renderAs=this.obj.className,this.obj.idd=String(e),this.obj.title=n.title||"",this.obj.pressed=!1;var i=t.conf.icons_css?"<i class='"+t.conf.icons_path+this.img+"'></i>":"<img src='"+t.conf.icons_path+this.img+"'>";this.obj.innerHTML=t._rtlParseBtn(""!=this.img?i:"",null!=n.text?"<div class='dhxtoolbar_text'>"+n.text+"</div>":""),t.base.appendChild(this.obj),window.dhx4.isIE&&(this.obj.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1});var a=this;return this._doOnMouseOver=function(t){t=t||event,0!=a.state&&1!=a.obj.pressed&&1!=a.obj.over&&(null==a.obj.className.match(/dhxtoolbar_btn_over/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_over"),a.obj.over=!0)},this._doOnMouseOut=function(t){t=t||event,0!=a.state&&(null!=a.obj.className.match(/dhxtoolbar_btn_over/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_def"),a.obj.over=a.obj.pressed=!1)},this._doOnMouseDown=function(e){if("touchstart"==(e=e||event).type){if(e.preventDefault&&e.preventDefault(),e.cancelBubble=!0,null!=t.conf.touch_id&&t.conf.touch_id!=a.id)return;t.conf.touch_id=a.id}0!=a.state&&(null==a.obj.className.match(/dhxtoolbar_btn_pres/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_pres"),a.obj.pressed=!0)},this._doOnMouseUp=function(e){"touchend"==(e=e||event).type&&(e.preventDefault&&e.preventDefault(),e.cancelBubble=!0,t.conf.touch_id==a.id&&(t.conf.touch_id=null)),0!=a.state&&0!=a.obj.pressed&&(null!=a.obj.className.match(/dhxtoolbar_btn_pres/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_"+(a.obj.over?"over":"def")),a.obj.pressed=!1,a.obj.extAction&&window.setTimeout(function(){try{a&&a.obj&&window[a.obj.extAction](a.id)}catch(t){}},1),t.callEvent("onClick",[a.obj.idd.replace(t.idPrefix,"")]))},this.obj.evs={mouseover:"_doOnMouseOver",mouseout:"_doOnMouseOut",mousedown:"_doOnMouseDown",mouseup:"_doOnMouseUp",touchstart:"_doOnMouseDown",touchend:"_doOnMouseUp"},t._evs.add.apply(this,[this.obj.evs,this.obj]),this.enableItem=function(){t._enableItem(this)},this.disableItem=function(){t._disableItem(this)},this.isEnabled=function(){return this.state},this.showItem=function(){this.obj.style.display=""},this.hideItem=function(){this.obj.style.display="none"},this.isVisible=function(){return""==this.obj.style.display},this.setItemText=function(e){t._setItemText(this,e)},this.getItemText=function(){return t._getItemText(this)},this.setItemImage=function(e){t._setItemImage(this,e,!0)},this.clearItemImage=function(){t._clearItemImage(this,!0)},this.setItemImageDis=function(e){t._setItemImage(this,e,!1)},this.clearItemImageDis=function(){t._clearItemImage(this,!1)},this.setItemToolTip=function(t){this.obj.title=t},this.getItemToolTip=function(){return this.obj.title},this},dhtmlXToolbarObject.prototype._buttonSelectObject=function(t,e,n){this.id=t.idPrefix+e,this.state=null==n.enabled||"true"==n.enabled,this.imgEn=n.img||"",this.imgDis=n.imgdis||"",this.img=this.state?""!=this.imgEn?this.imgEn:"":""!=this.imgDis?this.imgDis:"",this.mode=n.mode||"button","select"==this.mode?(this.openAll=!0,this.renderSelect=!1,n.text&&0!=n.text.length||(n.text="&nbsp;")):(this.openAll=1==window.dhx4.s2b(n.openAll),this.renderSelect=null==n.renderSelect||window.dhx4.s2b(n.renderSelect)),this.maxOpen=isNaN(n.maxOpen?n.maxOpen:"")?null:n.maxOpen,this._maxOpenTest=function(){if(!isNaN(this.maxOpen)&&!t._sbw){var e=document.createElement("DIV");e.className="dhxtoolbar_maxopen_test",document.body.appendChild(e);var n=document.createElement("DIV");n.className="dhxtoolbar_maxopen_test2",e.appendChild(n),t._sbw=e.offsetWidth-n.offsetWidth,e.removeChild(n),n=null,document.body.removeChild(e),e=null}},this._maxOpenTest(),this.obj=document.createElement("DIV"),this.obj.allowClick=!1,this.obj.extAction=n.action||null,this.obj.className="dhx_toolbar_btn dhxtoolbar_btn_"+(this.state?"def":"dis"),this.obj.style.display=null!=n.hidden?"none":"",this.obj.renderAs=this.obj.className,this.obj.onselectstart=function(t){(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1},this.obj.idd=String(e),this.obj.title=n.title||"",this.obj.pressed=!1,this.callEvent=!1;var i=t.conf.icons_css?"<i class='"+t.conf.icons_path+this.img+"'></i>":"<img src='"+t.conf.icons_path+this.img+"'>";this.obj.innerHTML=t._rtlParseBtn(""!=this.img?i:"",null!=n.text?"<div class='dhxtoolbar_text'>"+n.text+"</div>":""),t.base.appendChild(this.obj),this.arw=document.createElement("DIV"),this.arw.className="dhx_toolbar_arw dhxtoolbar_btn_"+(this.state?"def":"dis"),this.arw.style.display=this.obj.style.display,this.arw.innerHTML="<div class='arwimg'>&nbsp;</div>",this.arw.title=this.obj.title,this.arw.onselectstart=function(t){(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1},t.base.appendChild(this.arw);var a=this;if(window.dhx4.isIE&&(this.arw.onselectstart=this.obj.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1}),this._doOnMouseOver=function(e){e=e||event,0!=a.state&&1!=a.obj.over&&t.anyUsed!=a.obj.idd&&(null==a.obj.className.match(/dhxtoolbar_btn_over/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_over",a.arw.className="dhx_toolbar_arw dhxtoolbar_btn_over"),a.obj.over=!0)},this._doOnMouseOut=function(e){e=e||event,0!=a.state&&t.anyUsed!=a.obj.idd&&t.anyUsed!=a.obj.idd&&(null!=a.obj.className.match(/dhxtoolbar_btn_over/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_def",a.arw.className="dhx_toolbar_arw dhxtoolbar_btn_def"),a.obj.over=a.obj.pressed=!1)},this._doOnMouseDown=function(e){if("touchstart"==(e=e||event).type){if(e.preventDefault&&e.preventDefault(),e.cancelBubble=!0,null!=t.conf.touch_id&&t.conf.touch_id!=a.id)return;t.conf.touch_id=a.id}if(0!=a.state)if(t.anyUsed==a.obj.idd)1==a.obj.over?(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_over",a.arw.className="dhx_toolbar_arw dhxtoolbar_btn_over"):(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_def",a.arw.className="dhx_toolbar_arw dhxtoolbar_btn_def"),a._hidePoly(!0),t.anyUsed=null;else{var n=e.target||e.srcElement;1==a.openAll||n==a.arw||n.parentNode==a.arw?("touchstart"==e.type&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_over"),a.arw.className="dhx_toolbar_arw dhxtoolbar_btn_pres",a.arw._skip=!0,a._showPoly(!0),t.anyUsed=a.obj.idd):(null==a.obj.className.match(/dhxtoolbar_btn_pres/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_pres",a.arw.className="dhx_toolbar_arw dhxtoolbar_btn_pres"),a.obj.pressed=!0)}},this._doOnMouseUp=function(n){if("touchend"==(n=n||event).type){if(""==a.polygon.style.display)return;n.preventDefault&&n.preventDefault(),n.cancelBubble=!0,t.conf.touch_id==a.id&&(t.conf.touch_id=null)}if(0!=a.state&&0!=a.obj.pressed){if(null!=a.obj.className.match(/dhxtoolbar_btn_pres/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_"+(a.obj.over?"over":"def"),a.arw.className="dhx_toolbar_arw dhxtoolbar_btn_"+(a.obj.over?"over":"def")),this.extAction){var i=this;window.setTimeout(function(){try{window[i.extAction](e)}catch(t){}i=null},1)}t.callEvent("onClick",[a.obj.idd.replace(t.idPrefix,"")])}},this.arw.evs={mouseover:"_doOnMouseOver",mouseout:"_doOnMouseOut",mousedown:"_doOnMouseDown",touchstart:"_doOnMouseDown"},t._evs.add.apply(this,[this.arw.evs,this.arw]),this.obj.evs={mouseover:"_doOnMouseOver",mouseout:"_doOnMouseOut",mousedown:"_doOnMouseDown",mouseup:"_doOnMouseUp",touchstart:"_doOnMouseDown",touchend:"_doOnMouseUp"},t._evs.add.apply(this,[this.obj.evs,this.obj]),this._showPoly=function(e){if(null!=t.anyUsed&&"buttonSelect"==t.objPull[t.idPrefix+t.anyUsed].type){var n=t.objPull[t.idPrefix+t.anyUsed];"none"!=n.polygon.style.display&&(n.obj.className="dhx_toolbar_btn dhxtoolbar_btn_def",n.arw.className="dhx_toolbar_arw dhxtoolbar_btn_def",n.obj.over=!1,window.dhx4.zim.clear(n.polygon._idd),n.polygon.style.display="none",n.polygon._ie6cover&&(n.polygon._ie6cover.style.display="none"),"dhx_terrace"==t.conf.skin&&t._improveTerraceButtonSelect(n.id,!0),t.callEvent("onButtonSelectHide",[n.obj.idd]))}this.polygon.style.top="0px",this.polygon.style.visibility="hidden",this.polygon.style.zIndex=window.dhx4.zim.reserve(this.polygon._idd),this.polygon.style.display="","dhx_terrace"==t.conf.skin&&t._improveTerraceButtonSelect(this.id,!1),this._fixMaxOpenHeight(this.maxOpen||null),t._autoDetectVisibleArea();var i=window.dhx4.absTop(this.obj)+this.obj.offsetHeight+t.conf.sel_ofs_y,a=this.polygon.offsetHeight;if(i+a>t.tY2){var o=null!=this.maxOpen?Math.floor((t.tY2-i)/22):0;o>=1?this._fixMaxOpenHeight(o):(i=window.dhx4.absTop(this.obj)-a-t.conf.sel_ofs_y)<0&&(i=0)}if(this.polygon.style.top=i+"px",t.rtl)this.polygon.style.left=window.dhx4.absLeft(this.obj)+this.obj.offsetWidth-this.polygon.offsetWidth+t.conf.sel_ofs_x+"px";else{var r=document.body.scrollLeft+(window.innerWidth||document.body.clientWidth),s=window.dhx4.absLeft(this.obj)+t.conf.sel_ofs_x;s+this.polygon.offsetWidth>r&&(s=window.dhx4.absLeft(this.arw)+this.arw.offsetWidth-this.polygon.offsetWidth),this.polygon.style.left=Math.max(s,5)+"px"}this.polygon.style.visibility="visible",this.polygon._ie6cover&&(this.polygon._ie6cover.style.left=this.polygon.style.left,this.polygon._ie6cover.style.top=this.polygon.style.top,this.polygon._ie6cover.style.width=this.polygon.offsetWidth+"px",this.polygon._ie6cover.style.height=this.polygon.offsetHeight+"px",this.polygon._ie6cover.style.display=""),e&&t.callEvent("onButtonSelectShow",[this.obj.idd])},this._hidePoly=function(e){window.dhx4.zim.clear(this.polygon._idd),this.polygon.style.display="none",this.polygon._ie6cover&&(this.polygon._ie6cover.style.display="none"),"dhx_terrace"==t.conf.skin&&t._improveTerraceButtonSelect(this.id,!0),e&&t.callEvent("onButtonSelectHide",[this.obj.idd]),t.conf.touch_id=null},this.obj.iddPrefix=t.idPrefix,this._listOptions={},this._fixMaxOpenHeight=function(e){var n="auto",i=!1;if(null!==e){var o=0;for(var r in this._listOptions)o++;o>e?(this._ph=22*e,n=this._ph+"px"):i=!0}this.polygon.style.width="auto",this.polygon.style.height="auto",i||null==a.maxOpen||(this.polygon.style.width=this.p_tbl.offsetWidth+t._sbw+"px",this.polygon.style.height=n)},this._separatorButtonSelectObject=function(t,e,n){return this.obj={},this.obj.tr=document.createElement("TR"),this.obj.tr.className="tr_sep",this.obj.tr.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this.obj.td=document.createElement("TD"),this.obj.td.colSpan="2",this.obj.td.className="td_btn_sep",this.obj.td.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},isNaN(n)?n=a.p_tbody.childNodes.length+1:n<1&&(n=1),n>a.p_tbody.childNodes.length?a.p_tbody.appendChild(this.obj.tr):a.p_tbody.insertBefore(this.obj.tr,a.p_tbody.childNodes[n-1]),this.obj.tr.appendChild(this.obj.td),this.obj.sep=document.createElement("DIV"),this.obj.sep.className="btn_sep",this.obj.sep.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this.obj.td.appendChild(this.obj.sep),a._listOptions[t]=this.obj,this},this._buttonButtonSelectObject=function(e,n,i){var o=!0;void 0!==n.enabled?o=window.dhx4.s2b(n.enabled):void 0!==n.disabled&&(o=window.dhx4.s2b(n.disabled)),this.obj={},this.obj.tr=document.createElement("TR"),this.obj.tr.en=o,this.obj.tr.extAction=n.action||null,this.obj.tr._selected=null!=n.selected,this.obj.tr.className="tr_btn"+(this.obj.tr.en?this.obj.tr._selected&&a.renderSelect?" tr_btn_selected":"":" tr_btn_disabled"),this.obj.tr.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this.obj.tr.idd=String(e),isNaN(i)?i=a.p_tbody.childNodes.length+1:i<1&&(i=1),i>a.p_tbody.childNodes.length?a.p_tbody.appendChild(this.obj.tr):a.p_tbody.insertBefore(this.obj.tr,a.p_tbody.childNodes[i-1]),this.obj.td_a=document.createElement("TD"),this.obj.td_a.className="td_btn_img",this.obj.td_a.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this.obj.td_b=document.createElement("TD"),this.obj.td_b.className="td_btn_txt",this.obj.td_b.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},t.rtl?(this.obj.tr.appendChild(this.obj.td_b),this.obj.tr.appendChild(this.obj.td_a)):(this.obj.tr.appendChild(this.obj.td_a),this.obj.tr.appendChild(this.obj.td_b)),null!=n.img?(1==t.conf.icons_css?this.obj.td_a.innerHTML="<i class='"+t.conf.icons_path+n.img+"'></i>":this.obj.td_a.innerHTML="<img class='btn_sel_img' src='"+t.conf.icons_path+n.img+"' border='0'>",this.obj.tr._img=n.img):this.obj.td_a.innerHTML="&nbsp;";var r=null!=n.text?n.text:n.itemText||"";return this.obj.td_b.innerHTML="<div class='btn_sel_text'>"+r+"</div>",this.obj.tr.onmouseover=function(t){null==(t=t||event).type.match(/touch/)&&(!this.en||this._selected&&a.renderSelect||(this.className="tr_btn tr_btn_over"))},this.obj.tr.onmouseout=function(t){null==(t=t||event).type.match(/touch/)&&this.en&&(this._selected&&a.renderSelect?-1==String(this.className).search("tr_btn_selected")&&(this.className="tr_btn tr_btn_selected"):this.className="tr_btn")},this.obj.tr.ontouchstart=this.obj.tr.onmousedown=function(t){t=t||event,null==this._etype&&(this._etype=t.type)},this.obj.tr.onclick=function(e){if((e=e||event).cancelBubble=!0,this.en){if(a.setListOptionSelected(this.idd.replace(t.idPrefix,"")),a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_def",a.arw.className="dhx_toolbar_arw dhxtoolbar_btn_def",a.obj.over=!1,null!=this._etype&&null==this._etype.match(/touch/))window.dhx4.zim.clear(a.polygon._idd),a.polygon.style.display="none",a.polygon._ie6cover&&(a.polygon._ie6cover.style.display="none");else{var n=a.polygon;window.setTimeout(function(){window.dhx4.zim.clear(n._idd),n.style.display="none",n=null},500)}this._etype=null,"dhx_terrace"==t.conf.skin&&t._improveTerraceButtonSelect(a.id,!0),t.anyUsed=null,t.conf.touch_id=null,t.callEvent("onButtonSelectHide",[a.obj.idd]);var i=this.idd.replace(t.idPrefix,"");if(this.extAction)try{window[this.extAction](i)}catch(e){}t.callEvent("onClick",[i])}},a._listOptions[e]=this.obj,this},this.polygon=document.createElement("DIV"),this.polygon.dir="ltr",this.polygon.style.display="none",this.polygon.className="dhx_toolbar_poly_"+t.conf.skin+" dhxtoolbar_icons_"+t.conf.iconSize+t.conf.cssShadow,this.polygon.onselectstart=function(t){(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1},this.polygon.onmousedown=function(t){(t=t||event).cancelBubble=!0},this.polygon.style.overflowY="auto",this.polygon._idd=window.dhx4.newId(),this.polygon.ontouchstart=function(t){(t=t||event).cancelBubble=!0},this.polygon.ontouchend=function(t){(t=t||event).cancelBubble=!0},this.p_tbl=document.createElement("TABLE"),this.p_tbl.className="buttons_cont",this.p_tbl.cellSpacing="0",this.p_tbl.cellPadding="0",this.p_tbl.border="0",this.polygon.appendChild(this.p_tbl),this.p_tbody=document.createElement("TBODY"),this.p_tbl.appendChild(this.p_tbody),null!=n.options)for(var o=0;o<n.options.length;o++){var r="_"+(n.options[o].type||"")+"ButtonSelectObject";null==n.options[o].id&&(n.options[o].id=t._genStr(24)),"function"==typeof this[r]&&new this[r](n.options[o].id,n.options[o])}return document.body.appendChild(this.polygon),window.dhx4.isIE6&&(this.polygon._ie6cover=document.createElement("IFRAME"),this.polygon._ie6cover.frameBorder=0,this.polygon._ie6cover.style.position="absolute",this.polygon._ie6cover.style.border="none",this.polygon._ie6cover.style.backgroundColor="#000000",this.polygon._ie6cover.style.filter="alpha(opacity=100)",this.polygon._ie6cover.style.display="none",this.polygon._ie6cover.setAttribute("src","javascript:false;"),document.body.appendChild(this.polygon._ie6cover)),this.setWidth=function(t){this.obj.style.width=t-this.arw.offsetWidth+"px",this.polygon.style.width=this.obj.offsetWidth+this.arw.offsetWidth-2+"px",this.p_tbl.style.width=this.polygon.style.width},this.enableItem=function(){t._enableItem(this)},this.disableItem=function(){t._disableItem(this)},this.isEnabled=function(){return this.state},this.showItem=function(){this.obj.style.display="",this.arw.style.display=""},this.hideItem=function(){this.obj.style.display="none",this.arw.style.display="none"},this.isVisible=function(){return""==this.obj.style.display},this.setItemText=function(e){t._setItemText(this,e)},this.getItemText=function(){return t._getItemText(this)},this.setItemImage=function(e){t._setItemImage(this,e,!0)},this.clearItemImage=function(){t._clearItemImage(this,!0)},this.setItemImageDis=function(e){t._setItemImage(this,e,!1)},this.clearItemImageDis=function(){t._clearItemImage(this,!1)},this.setItemToolTip=function(t){this.obj.title=t,this.arw.title=t},this.getItemToolTip=function(){return this.obj.title},this.addListOption=function(t,e,n,i,a){if("button"==n||"separator"==n){var o={id:t,type:n,text:i,img:a};new this["_"+n+"ButtonSelectObject"](t,o,e)}},this.removeListOption=function(t){if(this._isListButton(t,!0)){var e=this._listOptions[t];if(null!=e.td_a&&null!=e.td_b){for(e.td_a.onselectstart=null,e.td_b.onselectstart=null;e.td_a.childNodes.length>0;)e.td_a.removeChild(e.td_a.childNodes[0]);for(;e.td_b.childNodes.length>0;)e.td_b.removeChild(e.td_b.childNodes[0]);for(e.tr.onselectstart=null,e.tr.onmouseover=null,e.tr.onmouseout=null,e.tr.onclick=null,e.tr.ontouchstart=null,e.tr.onmousedown=null;e.tr.childNodes.length>0;)e.tr.removeChild(e.tr.childNodes[0]);e.tr.parentNode.removeChild(e.tr),e.td_a=null,e.td_b=null,e.tr=null}else{for(e.sep.onselectstart=null,e.td.onselectstart=null,e.tr.onselectstart=null;e.td.childNodes.length>0;)e.td.removeChild(e.td.childNodes[0]);for(;e.tr.childNodes.length>0;)e.tr.removeChild(e.tr.childNodes[0]);e.tr.parentNode.removeChild(e.tr),e.sep=null,e.td=null,e.tr=null}e=null,this._listOptions[t]=null;try{delete this._listOptions[t]}catch(t){}}},this.showListOption=function(t){this._isListButton(t,!0)&&(this._listOptions[t].tr.style.display="")},this.hideListOption=function(t){this._isListButton(t,!0)&&(this._listOptions[t].tr.style.display="none")},this.isListOptionVisible=function(t){if(this._isListButton(t,!0))return"none"!=this._listOptions[t].tr.style.display},this.enableListOption=function(e){this._isListButton(e)&&(this._listOptions[e].tr.en=!0,this._listOptions[e].tr.className="tr_btn"+(this._listOptions[e].tr._selected&&t.renderSelect?" tr_btn_selected":""))},this.disableListOption=function(t){this._isListButton(t)&&(this._listOptions[t].tr.en=!1,this._listOptions[t].tr.className="tr_btn tr_btn_disabled")},this.isListOptionEnabled=function(t){if(this._isListButton(t))return this._listOptions[t].tr.en},this.setListOptionPosition=function(t,e){if(this._listOptions[t]&&this.getListOptionPosition(t)!=e&&!isNaN(e)){e<1&&(e=1);var n=this._listOptions[t].tr;this.p_tbody.removeChild(n),e>this.p_tbody.childNodes.length?this.p_tbody.appendChild(n):this.p_tbody.insertBefore(n,this.p_tbody.childNodes[e-1]),n=null}},this.getListOptionPosition=function(t){var e=-1;if(!this._listOptions[t])return e;for(var n=0;n<this.p_tbody.childNodes.length;n++)this.p_tbody.childNodes[n]==this._listOptions[t].tr&&(e=n+1);return e},this.setListOptionImage=function(e,n){if(this._isListButton(e)){var i=this._listOptions[e].tr.childNodes[t.rtl?1:0];i.innerHTML=t.conf.icons_css?"<i class='"+t.conf.icons_path+n+"'></i>":"<img src='"+t.conf.icons_path+n+"' class='btn_sel_img'>",i=null}},this.getListOptionImage=function(e){if(this._isListButton(e)){var n=this._listOptions[e].tr.childNodes[t.rtl?1:0],i=null;return n.childNodes.length>0&&(i=n.childNodes[0][t.conf.icons_css?"className":"src"]),n=null,i}},this.clearListOptionImage=function(e){if(this._isListButton(e)){for(var n=this._listOptions[e].tr.childNodes[t.rtl?1:0];n.childNodes.length>0;)n.removeChild(n.childNodes[0]);n.innerHTML="&nbsp;",n=null}},this.setListOptionText=function(e,n){this._isListButton(e)&&(this._listOptions[e].tr.childNodes[t.rtl?0:1].childNodes[0].innerHTML=n)},this.getListOptionText=function(e){if(this._isListButton(e))return this._listOptions[e].tr.childNodes[t.rtl?0:1].childNodes[0].innerHTML},this.setListOptionToolTip=function(t,e){this._isListButton(t)&&(this._listOptions[t].tr.title=e)},this.getListOptionToolTip=function(t){if(this._isListButton(t))return this._listOptions[t].tr.title},this.forEachListOption=function(t){for(var e in this._listOptions)t(e)},this.getAllListOptions=function(){var t=new Array;for(var e in this._listOptions)t[t.length]=e;return t},this.setListOptionSelected=function(t){for(var e in this._listOptions){var n=this._listOptions[e];null!=n.td_a&&null!=n.td_b&&n.tr.en&&(e==t?(n.tr._selected=!0,n.tr.className="tr_btn"+(this.renderSelect?" tr_btn_selected":""),"select"==this.mode&&(n.tr._img?this.setItemImage(n.tr._img):this.clearItemImage(),this.setItemText(this.getListOptionText(t)))):(n.tr._selected=!1,n.tr.className="tr_btn")),n=null}},this.getListOptionSelected=function(){var t=null;for(var e in this._listOptions)1==this._listOptions[e].tr._selected&&(t=e);return t},this._isListButton=function(t,e){return null!=this._listOptions[t]&&!(!e&&"tr_sep"==this._listOptions[t].tr.className)},this.setMaxOpen=function(t){if(this._ph=null,"number"==typeof t)return this.maxOpen=t,void this._maxOpenTest();this.maxOpen=null},n.width&&this.setWidth(n.width),"select"==this.mode&&void 0!==n.selected&&this.setListOptionSelected(n.selected),this},dhtmlXToolbarObject.prototype._buttonInputObject=function(t,e,n){this.id=t.idPrefix+e,this.obj=document.createElement("DIV"),this.obj.className="dhx_toolbar_btn dhxtoolbar_btn_def",this.obj.style.display=null!=n.hidden?"none":"",this.obj.idd=String(e),this.obj.w=null!=n.width?n.width:100,this.obj.title=null!=n.title?n.title:"",this.obj.innerHTML="<input class='dhxtoolbar_input' type='text' style='width:"+this.obj.w+"px;'"+(null!=n.value?" value='"+n.value+"'":"")+">";var i=t,a=this;return this.obj.childNodes[0].onkeydown=function(t){13==(t=t||event).keyCode&&i.callEvent("onEnter",[a.obj.idd,this.value])},t.base.appendChild(this.obj),this.enableItem=function(){this.obj.childNodes[0].disabled=!1},this.disableItem=function(){this.obj.childNodes[0].disabled=!0},this.isEnabled=function(){return!this.obj.childNodes[0].disabled},this.showItem=function(){this.obj.style.display=""},this.hideItem=function(){this.obj.style.display="none"},this.isVisible=function(){return"none"!=this.obj.style.display},this.setValue=function(t){this.obj.childNodes[0].value=t},this.getValue=function(){return this.obj.childNodes[0].value},this.setWidth=function(t){this.obj.w=t,this.obj.childNodes[0].style.width=this.obj.w+"px"},this.getWidth=function(){return this.obj.w},this.setItemToolTip=function(t){this.obj.title=t},this.getItemToolTip=function(){return this.obj.title},this.getInput=function(){return this.obj.firstChild},void 0!==n.enabled&&0==window.dhx4.s2b(n.enabled)&&this.disableItem(),this},dhtmlXToolbarObject.prototype._buttonTwoStateObject=function(t,e,n){this.id=t.idPrefix+e,this.state=null==n.enabled,this.imgEn=null!=n.img?n.img:"",this.imgDis=null!=n.imgdis?n.imgdis:"",this.img=this.state?""!=this.imgEn?this.imgEn:"":""!=this.imgDis?this.imgDis:"",this.obj=document.createElement("DIV"),this.obj.pressed=null!=n.selected,this.obj.extAction=n.action||null,this.obj.className="dhx_toolbar_btn dhxtoolbar_btn_"+(this.obj.pressed?"pres"+(this.state?"":"_dis"):this.state?"def":"dis"),this.obj.style.display=null!=n.hidden?"none":"",this.obj.renderAs=this.obj.className,this.obj.idd=String(e),this.obj.title=n.title||"",this.obj.pressed&&(this.obj.renderAs="dhx_toolbar_btn dhxtoolbar_btn_over");var i=t.conf.icons_css?"<i class='"+t.conf.icons_path+this.img+"'></i>":"<img src='"+t.conf.icons_path+this.img+"'>";this.obj.innerHTML=t._rtlParseBtn(""!=this.img?i:"",null!=n.text?"<div class='dhxtoolbar_text'>"+n.text+"</div>":""),t.base.appendChild(this.obj),window.dhx4.isIE&&(this.obj.onselectstart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1});var a=this;return this._doOnMouseOver=function(t){t=t||event,0!=a.state&&1!=a.obj.over&&(1!=a.obj.pressed&&null==a.obj.className.match(/dhxtoolbar_btn_over/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_over"),a.obj.over=!0)},this._doOnMouseOut=function(t){t=t||event,0!=a.state&&(1!=a.obj.pressed&&null!=a.obj.className.match(/dhxtoolbar_btn_over/gi)&&(a.obj.className="dhx_toolbar_btn dhxtoolbar_btn_def"),a.obj.over=!1)},this._doOnMouseDown=function(e){if("touchstart"==(e=e||event).type){if(e.preventDefault&&e.preventDefault(),e.cancelBubble=!0,null!=t.conf.touch_id&&t.conf.touch_id!=a.id)return;t.conf.touch_id=a.id}if(0!=a.state&&!0===t.callEvent("onBeforeStateChange",[a.obj.idd.replace(t.idPrefix,""),a.obj.pressed])){a.obj.pressed=!a.obj.pressed,a.obj.className="dhx_toolbar_btn "+(1==a.obj.pressed?"dhxtoolbar_btn_pres":1==a.obj.over?"dhxtoolbar_btn_over":"dhxtoolbar_btn_def");var n=a.obj.idd.replace(t.idPrefix,"");if(a.obj.extAction)try{window[a.obj.extAction](idd,a.obj.pressed)}catch(e){}t.callEvent("onStateChange",[n,a.obj.pressed])}},this._doOnMouseUp=function(e){"touchend"==(e=e||event).type&&(e.preventDefault&&e.preventDefault(),e.cancelBubble=!0,t.conf.touch_id==a.id&&(t.conf.touch_id=null))},this.obj.evs={mouseover:"_doOnMouseOver",mouseout:"_doOnMouseOut",mousedown:"_doOnMouseDown",touchstart:"_doOnMouseDown",touchend:"_doOnMouseUp"},t._evs.add.apply(this,[this.obj.evs,this.obj]),this.setItemState=function(e,n){if(this.obj.pressed!=e&&(1==e?(this.obj.pressed=!0,this.obj.className="dhx_toolbar_btn dhxtoolbar_btn_pres"+(this.state?"":"_dis")):(this.obj.pressed=!1,this.obj.className="dhx_toolbar_btn dhxtoolbar_btn_"+(this.state?"def":"dis")),1==n)){var i=this.obj.idd.replace(t.idPrefix,"");if(this.obj.extAction)try{window[this.obj.extAction](i,this.obj.pressed)}catch(t){}t.callEvent("onStateChange",[i,this.obj.pressed])}},this.getItemState=function(){return this.obj.pressed},this.enableItem=function(){t._enableItem(this)},this.disableItem=function(){t._disableItem(this)},this.isEnabled=function(){return this.state},this.showItem=function(){this.obj.style.display=""},this.hideItem=function(){this.obj.style.display="none"},this.isVisible=function(){return""==this.obj.style.display},this.setItemText=function(e){t._setItemText(this,e)},this.getItemText=function(){return t._getItemText(this)},this.setItemImage=function(e){t._setItemImage(this,e,!0)},this.clearItemImage=function(){t._clearItemImage(this,!0)},this.setItemImageDis=function(e){t._setItemImage(this,e,!1)},this.clearItemImageDis=function(){t._clearItemImage(this,!1)},this.setItemToolTip=function(t){this.obj.title=t},this.getItemToolTip=function(){return this.obj.title},this},dhtmlXToolbarObject.prototype._sliderObject=function(t,e,n){this.id=t.idPrefix+e,this.state=null==n.enabled||"true"==n.enabled,this.obj=document.createElement("DIV"),this.obj.className="dhx_toolbar_btn dhxtoolbar_btn_"+(this.state?"def":"dis"),this.obj.style.display=null!=n.hidden?"none":"",this.obj.onselectstart=function(t){(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1},this.obj.idd=String(e),this.obj.len=null!=n.length?Number(n.length):50,this.obj.innerHTML="<div class='dhxtoolbar_text'>"+(n.textMin||"")+"</div><div class='dhxtoolbar_sl_bg_l'></div><div class='dhxtoolbar_sl_bg_m' style='width:"+this.obj.len+"px;'></div><div class='dhxtoolbar_sl_bg_r'></div><div class='dhxtoolbar_text'>"+(n.textMax||"")+"</div>",t.base.appendChild(this.obj);var i=this;this.pen=document.createElement("DIV"),this.pen.className="dhxtoolbar_sl_pen",this.obj.appendChild(this.pen);var a=this.pen;this.label=document.createElement("DIV"),this.label.dir="ltr",this.label.className="dhx_toolbar_slider_label_"+t.conf.skin+(t.rtl?"_rtl":""),this.label.style.display="none",this.label.tip=n.toolTip||"%v",this.label._zi=window.dhx4.newId(),document.body.appendChild(this.label);var o=this.label;return this.pen.valueMin=null!=n.valueMin?Number(n.valueMin):0,this.pen.valueMax=null!=n.valueMax?Number(n.valueMax):100,this.pen.valueMin>this.pen.valueMax&&(this.pen.valueMin=this.pen.valueMax),this.pen.valueNow=null!=n.valueNow?Number(n.valueNow):this.pen.valueMax,this.pen.valueNow>this.pen.valueMax&&(this.pen.valueNow=this.pen.valueMax),this.pen.valueNow<this.pen.valueMin&&(this.pen.valueNow=this.pen.valueMin),this.pen._detectLimits=function(){this.minX=i.obj.childNodes[1].offsetLeft+2,this.maxX=i.obj.childNodes[3].offsetLeft-this.offsetWidth+1},this.pen._detectLimits(),this.pen._definePos=function(){this.nowX=Math.round((this.valueNow-this.valueMin)*(this.maxX-this.minX)/(this.valueMax-this.valueMin)+this.minX),this.style.left=this.nowX+"px",this.newNowX=this.nowX},this.pen._definePos(),this.pen.initXY=0,this.pen.allowMove=!1,this.pen[window.dhx4.isIPad?"ontouchstart":"onmousedown"]=function(t){0!=i.state&&(t=t||event,this.initXY=window.dhx4.isIPad?t.touches[0].clientX:t.clientX,this.newValueNow=this.valueNow,this.allowMove=!0,this.className="dhxtoolbar_sl_pen dhxtoolbar_over",""!=o.tip&&(o.style.visibility="hidden",o.style.display="",o.innerHTML=o.tip.replace("%v",this.valueNow),o.style.left=Math.round(window.dhx4.absLeft(this)+this.offsetWidth/2-o.offsetWidth/2)+"px",o.style.top=window.dhx4.absTop(this)-o.offsetHeight-3+"px",o.style.visibility="",o.style.zIndex=window.dhx4.zim.reserve(o._zi)))},this.pen._doOnMouseMoveStart=function(t){if(t=t||event,a.allowMove){var e=window.dhx4.isIPad?t.touches[0].clientX:t.clientX,n=e-a.initXY;if(!(e<window.dhx4.absLeft(a)+Math.round(a.offsetWidth/2)&&a.nowX==a.minX||e>window.dhx4.absLeft(a)+Math.round(a.offsetWidth/2)&&a.nowX==a.maxX))return a.newNowX=a.nowX+n,a.newNowX<a.minX&&(a.newNowX=a.minX),a.newNowX>a.maxX&&(a.newNowX=a.maxX),a.nowX=a.newNowX,a.style.left=a.nowX+"px",a.initXY=e,a.newValueNow=Math.round((a.valueMax-a.valueMin)*(a.newNowX-a.minX)/(a.maxX-a.minX)+a.valueMin),""!=o.tip&&(o.innerHTML=o.tip.replace(/%v/gi,a.newValueNow),o.style.left=Math.round(window.dhx4.absLeft(a)+a.offsetWidth/2-o.offsetWidth/2)+"px",o.style.top=window.dhx4.absTop(a)-o.offsetHeight-3+"px"),t.cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1}},this.pen._doOnMouseMoveEnd=function(){a.allowMove&&(a.className="dhxtoolbar_sl_pen",a.allowMove=!1,a.nowX=a.newNowX,a.valueNow=a.newValueNow,""!=o.tip&&(o.style.display="none",window.dhx4.zim.clear(o._zi)),t.callEvent("onValueChange",[i.obj.idd.replace(t.idPrefix,""),a.valueNow]))},window.dhx4.isIPad?(document.addEventListener("touchmove",a._doOnMouseMoveStart,!1),document.addEventListener("touchend",a._doOnMouseMoveEnd,!1)):void 0!==window.addEventListener?(window.addEventListener("mousemove",a._doOnMouseMoveStart,!1),window.addEventListener("mouseup",a._doOnMouseMoveEnd,!1)):(document.body.attachEvent("onmousemove",a._doOnMouseMoveStart),document.body.attachEvent("onmouseup",a._doOnMouseMoveEnd)),this.enableItem=function(){this.state||(this.state=!0,this.obj.className="dhx_toolbar_btn dhxtoolbar_btn_def")},this.disableItem=function(){this.state&&(this.state=!1,this.obj.className="dhx_toolbar_btn dhxtoolbar_btn_dis")},this.isEnabled=function(){return this.state},this.showItem=function(){this.obj.style.display=""},this.hideItem=function(){this.obj.style.display="none"},this.isVisible=function(){return""==this.obj.style.display},this.setValue=function(e,n){(e=Number(e))<this.pen.valueMin&&(e=this.pen.valueMin),e>this.pen.valueMax&&(e=this.pen.valueMax),this.pen.valueNow=e,this.pen._definePos(),1==n&&t.callEvent("onValueChange",[this.obj.idd.replace(t.idPrefix,""),this.pen.valueNow])},this.getValue=function(){return this.pen.valueNow},this.setMinValue=function(t,e){(t=Number(t))>this.pen.valueMax||(this.obj.childNodes[0].innerHTML=e,this.obj.childNodes[0].style.display=e.length>0?"":"none",this.pen.valueMin=t,this.pen.valueNow<this.pen.valueMin&&(this.pen.valueNow=this.pen.valueMin),this.pen._detectLimits(),this.pen._definePos())},this.setMaxValue=function(t,e){(t=Number(t))<this.pen.valueMin||(this.obj.childNodes[4].innerHTML=e,this.obj.childNodes[4].style.display=e.length>0?"":"none",this.pen.valueMax=t,this.pen.valueNow>this.pen.valueMax&&(this.pen.valueNow=this.pen.valueMax),this.pen._detectLimits(),this.pen._definePos())},this.getMinValue=function(){var t=this.obj.childNodes[0].innerHTML,e=this.pen.valueMin;return new Array(e,t)},this.getMaxValue=function(){var t=this.obj.childNodes[4].innerHTML,e=this.pen.valueMax;return new Array(e,t)},this.setItemToolTipTemplate=function(t){this.label.tip=t},this.getItemToolTipTemplate=function(){return this.label.tip},this},dhtmlXToolbarObject.prototype.unload=function(){for("function"==typeof window.addEventListener?(window.removeEventListener("mousedown",this._doOnClick,!1),window.removeEventListener("touchstart",this._doOnClick,!1)):document.body.detachEvent("onmousedown",this._doOnClick),this._doOnClick=null,this.clearAll(),this.objPull=null,this._xmlLoader&&(this._xmlLoader.destructor(),this._xmlLoader=null);this.base.childNodes.length>0;)this.base.removeChild(this.base.childNodes[0]);for(this.cont.removeChild(this.base),this.base=null;this.cont.childNodes.length>0;)this.cont.removeChild(this.cont.childNodes[0]);this.cont.className="",this.cont=null,window.dhx4._enableDataLoading(this,null,null,null,"clear"),window.dhx4._eventable(this,"clear"),this.tX1=null,this.tX2=null,this.tY1=null,this.tY2=null,this.anyUsed=null,this.idPrefix=null,this.rootTypes=null,this._rtl=null,this._rtlParseBtn=null,this.setRTL=null,this._sbw=null,this._getObj=null,this._addImgObj=null,this._setItemImage=null,this._clearItemImage=null,this._setItemText=null,this._getItemText=null,this._enableItem=null,this._disableItem=null,this._xmlParser=null,this._addItemToStorage=null,this._genStr=null,this._addItem=null,this._getPosition=null,this._setPosition=null,this._getIdByPosition=null,this._separatorObject=null,this._textObject=null,this._buttonObject=null,this._buttonSelectObject=null,this._buttonInputObject=null,this._buttonTwoStateObject=null,this._sliderObject=null,this._autoDetectVisibleArea=null,this._removeItem=null,this.setAlign=null,this.setSkin=null,this.setIconsPath=null,this.setIconPath=null,this.loadXML=null,this.loadXMLString=null,this.clearAll=null,this.addSpacer=null,this.removeSpacer=null,this.getType=null,this.getTypeExt=null,this.inArray=null,this.getParentId=null,this.addButton=null,this.addText=null,this.addButtonSelect=null,this.addButtonTwoState=null,this.addSeparator=null,this.addSlider=null,this.addInput=null,this.forEachItem=null,this.showItem=null,this.hideItem=null,this.isVisible=null,this.enableItem=null,this.disableItem=null,this.isEnabled=null,this.setItemText=null,this.getItemText=null,this.setItemToolTip=null,this.getItemToolTip=null,this.setItemImage=null,this.setItemImageDis=null,this.clearItemImage=null,this.clearItemImageDis=null,this.setItemState=null,this.getItemState=null,this.setItemToolTipTemplate=null,this.getItemToolTipTemplate=null,this.setValue=null,this.getValue=null,this.setMinValue=null,this.getMinValue=null,this.setMaxValue=null,this.getMaxValue=null,this.setWidth=null,this.getWidth=null,this.getPosition=null,this.setPosition=null,this.removeItem=null,this.addListOption=null,this.removeListOption=null,this.showListOption=null,this.hideListOption=null,this.isListOptionVisible=null,this.enableListOption=null,this.disableListOption=null,this.isListOptionEnabled=null,this.setListOptionPosition=null,this.getListOptionPosition=null,this.setListOptionText=null,this.getListOptionText=null,this.setListOptionToolTip=null,this.getListOptionToolTip=null,this.setListOptionImage=null,this.getListOptionImage=null,this.clearListOptionImage=null,this.forEachListOption=null,this.getAllListOptions=null,this.setListOptionSelected=null,this.getListOptionSelected=null,this.unload=null,this.setUserData=null,this.getUserData=null,this.setMaxOpen=null,this.items=null,this.conf=null},dhtmlXToolbarObject.prototype._autoDetectVisibleArea=function(){var t=window.dhx4.screenDim();this.tX1=t.left,this.tX2=t.right,this.tY1=t.top,this.tY2=t.bottom},dhtmlXToolbarObject.prototype.setIconset=function(t){this.conf.icons_css="awesome"==t},dhtmlXToolbarObject.prototype._evs={add:function(t,e){for(var n in t)"function"==typeof window.addEventListener?e.addEventListener(n,this[t[n]],!1):null==n.match(/^touch/)&&e.attachEvent("on"+n,this[t[n]]);e=t=null},clear:function(t,e){for(var n in t)"function"==typeof window.addEventListener?e.removeEventListener(n,this[t[n]],!1):null==n.match(/^touch/)&&e.detachEvent("on"+n,this[t[n]]);e=t=null}},dhtmlXToolbarObject.prototype._initObj=function(t){for(var e=0;e<t.length;e++)this._addItemToStorage(t[e]);"dhx_terrace"==this.conf.skin&&this._improveTerraceSkin()},dhtmlXToolbarObject.prototype._xmlToJson=function(t){var e=[],n=t.getElementsByTagName("toolbar");if(null!=n&&null!=n[0]){n=n[0];for(var i=function(t){for(var e=null,n=0;n<t.childNodes.length;n++)if(null==e&&"itemText"==t.childNodes[n].tagName){e=window.dhx4._xmlNodeValue(t.childNodes[n]);break}return e},a=["id","type","hidden","title","text","enabled","img","imgdis","action","openAll","renderSelect","mode","maxOpen","width","value","selected","length","textMin","textMax","toolTip","valueMin","valueMax","valueNow"],o=["id","type","enabled","disabled","action","selected","img","text"],r=0;r<n.childNodes.length;r++)if("item"==n.childNodes[r].tagName){for(var s={},l=0;l<a.length;l++){null!=(h=n.childNodes[r].getAttribute(a[l]))&&(s[a[l]]=h)}for(var d=0;d<n.childNodes[r].childNodes.length;d++){if("item"==n.childNodes[r].childNodes[d].tagName&&"buttonSelect"==s.type){var c={};for(l=0;l<o.length;l++){var h;null!=(h=n.childNodes[r].childNodes[d].getAttribute(o[l]))&&(c[o[l]]=h)}var u=n.childNodes[r].childNodes[d].getElementsByTagName("userdata");for(l=0;l<u.length;l++){c.userdata||(c.userdata={});var m={};try{m.name=u[l].getAttribute("name")}catch(t){m.name=null}try{m.value=u[l].firstChild.nodeValue}catch(t){m.value=""}null!=m.name&&(c.userdata[m.name]=m.value)}c.text=i(n.childNodes[r].childNodes[d])||c.text,null==s.options&&(s.options=[]),s.options.push(c)}if("userdata"==n.childNodes[r].childNodes[d].tagName){null==s.userdata&&(s.userdata={});c={};try{c.name=n.childNodes[r].childNodes[d].getAttribute("name")}catch(t){c.name=null}try{c.value=n.childNodes[r].childNodes[d].firstChild.nodeValue}catch(t){c.value=""}null!=c.name&&(s.userdata[c.name]=c.value)}}s.text=i(n.childNodes[r])||s.text,e.push(s)}i=null}return e},dhtmlXToolbarObject.prototype._addItemToStorage=function(t,e){var n=t.id||this._genStr(24),i=t.type||"";if("spacer"==i?this.addSpacer(this._lastId):this._lastId=n,""!=i&&null!=this["_"+i+"Object"]){if("buttonSelect"==i&&null!=t.options)for(var a=0;a<t.options.length;a++)"obj"==t.options[a].type&&(t.options[a].type="button"),"sep"==t.options[a].type&&(t.options[a].type="separator");if("slider"==i){var o={tip_template:"toolTip",value_min:"valueMin",value_max:"valueMax",value_now:"valueNow",text_min:"textMin",text_max:"textMax"};for(var r in o)null==t[o[r]]&&null!=t[r]&&(t[o[r]]=t[r])}"buttonInput"==i&&null==t.value&&null!=t.text&&(t.value=t.text),"buttonTwoState"==i&&void 0===t.selected&&void 0!==t.pressed&&window.dhx4.s2b(t.pressed)&&(t.selected=!0),void 0===t.enabled&&void 0!==t.disabled&&window.dhx4.s2b(t.disabled)&&(t.enabled=!1),null==t.imgDis&&null!=t.img_disabled&&(t.imgdis=t.img_disabled),void 0!==t.openAll&&null!=t.openAll||"dhx_terrace"!=this.conf.skin||(t.openAll=!0),this.objPull[this.idPrefix+n]=new this["_"+i+"Object"](this,n,t),this.objPull[this.idPrefix+n].type=i,this.setPosition(n,e)}if(null!=t.userdata)for(var r in t.userdata)this.setUserData(n,r,t.userdata[r]);if(null!=t.options)for(a=0;a<t.options.length;a++)if(null!=t.options[a].userdata)for(var r in t.options[a].userdata)this.setListOptionUserData(t.id,t.options[a].id,r,t.options[a].userdata[r])},dhtmlXToolbarObject.prototype.setSkin=function(t,e){for(var n in!0===e?this.cont.className=this.cont.className.replace(/dhxtoolbar_icons_\d{1,}/,"dhxtoolbar_icons_"+this.conf.iconSize):(this.conf.skin=t,"dhx_skyblue"==this.conf.skin&&(this.conf.sel_ofs_y=1),"dhx_web"==this.conf.skin&&(this.conf.sel_ofs_y=1,this.conf.sel_ofs_x=1),"dhx_terrace"==this.conf.skin&&(this.conf.sel_ofs_y=-1,this.conf.sel_ofs_x=0),"material"==this.conf.skin&&(this.conf.sel_ofs_y=-1,this.conf.sel_ofs_x=0),this.cont.className="dhx_toolbar_"+this.conf.skin+" dhxtoolbar_icons_"+this.conf.iconSize+this.conf.cssShadow),this.objPull){var i=this.objPull[n];"slider"==i.type&&(i.pen._detectLimits(),i.pen._definePos(),i.label.className="dhx_toolbar_slider_label_"+this.conf.skin),"buttonSelect"==i.type&&(i.polygon.className="dhx_toolbar_poly_"+this.conf.skin+" dhxtoolbar_icons_"+this.conf.iconSize+this.conf.cssShadow)}"dhx_terrace"==t&&this._improveTerraceSkin()},dhtmlXToolbarObject.prototype.setAlign=function(t){this.conf.align="right"==t?"right":"left",this.base.className="right"==t?"dhxtoolbar_float_right":"dhxtoolbar_float_left",this._spacer&&(this._spacer.className="right"==t?" dhxtoolbar_float_left":" dhxtoolbar_float_right")},dhtmlXToolbarObject.prototype.setIconSize=function(t){this.conf.iconSize={18:!0,24:!0,32:!0,48:!0}[t]?t:18,this.setSkin(this.conf.skin,!0),this.callEvent("_onIconSizeChange",[this.conf.iconSize])},dhtmlXToolbarObject.prototype.setIconsPath=function(t){this.conf.icons_path=t},dhtmlXToolbarObject.prototype.setUserData=function(t,e,n){t=this.idPrefix+t,null!=this.objPull[t]&&(null==this.objPull[t].userData&&(this.objPull[t].userData={}),this.objPull[t].userData[e]=n)},dhtmlXToolbarObject.prototype.getUserData=function(t,e){return t=this.idPrefix+t,null!=this.objPull[t]&&null!=this.objPull[t].userData&&this.objPull[t].userData[e]||null},dhtmlXToolbarObject.prototype._isListOptionExists=function(t,e){if(null==this.objPull[this.idPrefix+t])return!1;var n=this.objPull[this.idPrefix+t];return"buttonSelect"==n.type&&null!=n._listOptions[e]},dhtmlXToolbarObject.prototype.setListOptionUserData=function(t,e,n,i){if(this._isListOptionExists(t,e)){var a=this.objPull[this.idPrefix+t]._listOptions[e];null==a.userData&&(a.userData={}),a.userData[n]=i}},dhtmlXToolbarObject.prototype.getListOptionUserData=function(t,e,n){if(!this._isListOptionExists(t,e))return null;var i=this.objPull[this.idPrefix+t]._listOptions[e];return i.userData&&i.userData[n]?i.userData[n]:null},dhtmlXToolbarObject.prototype._improveTerraceSkin=function(){null==this.conf.terrace_radius&&(this.conf.terrace_radius="3px");var t=[],e={separator:!0,text:!0},n=[this.base];null!=this._spacer&&n.push(this._spacer);for(var i=0;i<n.length;i++){t[i]=[];for(var a=0;a<n[i].childNodes.length;a++)if(null!=n[i].childNodes[a].idd&&"none"!=n[i].childNodes[a].style.display){var o=this.idPrefix+n[i].childNodes[a].idd;null!=this.objPull[o]&&this.objPull[o].obj==n[i].childNodes[a]&&t[i].push({a:o,type:this.objPull[o].type,node:this.objPull[o]["buttonSelect"==this.objPull[o].type?"arw":"obj"]})}n[i]=null}for(i=0;i<t.length;i++)for(a=0;a<t[i].length;a++){var r=t[i][a],s=!1,l=!1;e[r.type]||((a==t[i].length-1||null!=t[i][a+1]&&e[t[i][a+1].type])&&(s=!0),(0==a||a-1>=0&&null!=t[i][a-1]&&e[t[i][a-1].type])&&(l=!0)),r.node.style.borderRightWidth=s?"1px":"0px",r.node.style.borderTopRightRadius=r.node.style.borderBottomRightRadius=s?this.conf.terrace_radius:"0px","buttonSelect"==r.type?(r.node.previousSibling.style.borderTopLeftRadius=r.node.previousSibling.style.borderBottomLeftRadius=l?this.conf.terrace_radius:"0px",r.node.previousSibling._br=s,r.node.previousSibling._bl=l):r.node.style.borderTopLeftRadius=r.node.style.borderBottomLeftRadius=l?this.conf.terrace_radius:"0px",r.node._br=s,r.node._bl=l}for(i=0;i<t.length;i++){for(a=0;a<t[i].length;a++){for(var o in t[i][a])t[i][a][o]=null;t[i][a]=null}t[i]=null}t=n=null},dhtmlXToolbarObject.prototype._improveTerraceButtonSelect=function(t,e){var n=this.objPull[t];1==e?(n.obj.style.borderBottomLeftRadius=n.obj._bl?this.conf.terrace_radius:"0px",n.arw.style.borderBottomRightRadius=n.obj._br?this.conf.terrace_radius:"0px"):(n.obj.style.borderBottomLeftRadius="0px",n.arw.style.borderBottomRightRadius="0px"),n=null},void 0!==window.dhtmlXCellObject&&(dhtmlXCellObject.prototype._createNode_toolbar=function(t,e,n,i,a){return void 0!==a?t=a:((t=document.createElement("DIV")).className="dhx_cell_toolbar_"+(this.conf.borders?"def":"no_borders"),t.appendChild(document.createElement("DIV")),t.firstChild.className="dhx_toolbar_base_18_dhx_skyblue"),this.cell.insertBefore(t,this.cell.childNodes[this.conf.idx.cont]),this.conf.ofs_nodes.t.toolbar=!0,this._updateIdx(),t},dhtmlXCellObject.prototype.attachToolbar=function(t){if(null==this.dataNodes.ribbon&&null==this.dataNodes.toolbar)return this.callEvent("_onBeforeContentAttach",["toolbar"]),void 0===t?t={}:"string"==typeof t&&(t={skin:t}),void 0===t.skin&&(t.skin=this.conf.skin),t.parent=this._attachObject("toolbar").firstChild,this.dataNodes.toolbar=new dhtmlXToolbarObject(t),this._adjustCont(this._idd),this.dataNodes.toolbar._masterCell=this,this.dataNodes.toolbar.attachEvent("_onIconSizeChange",function(){this._masterCell._adjustCont()}),t.parent=null,t=null,this.callEvent("_onContentAttach",[]),this.dataNodes.toolbar},dhtmlXCellObject.prototype.detachToolbar=function(){null!=this.dataNodes.toolbar&&(this.dataNodes.toolbar._masterCell=null,"function"==typeof this.dataNodes.toolbar.unload&&this.dataNodes.toolbar.unload(),this.dataNodes.toolbar=null,delete this.dataNodes.toolbar,this._detachObject("toolbar"))},dhtmlXCellObject.prototype.showToolbar=function(){this._mtbShowHide("toolbar","")},dhtmlXCellObject.prototype.hideToolbar=function(){this._mtbShowHide("toolbar","none")},dhtmlXCellObject.prototype.getAttachedToolbar=function(){return this.dataNodes.toolbar}),dhtmlXEditor.prototype.setSizes=function(){this.cell._setSize(0,0,this.base.clientWidth,this.base.clientHeight),null!=this.editor&&(this.editor.style.left="5px",this.editor.style.width=this.base.clientWidth-5+"px")},dhtmlXEditor.prototype.setReadonly=function(t){this.conf.roMode=!0===t,this._prepareContent(!0,this.conf.roMode),this.cBlock.style.display=this.conf.roMode?"":"none"},dhtmlXEditor.prototype.isReadonly=function(t){return this.conf.roMode||!1},dhtmlXEditor.prototype.setSkin=function(t){this.base.className=String(this.base.className).replace(new RegExp("dhxeditor_"+this.conf.skin),"dhxeditor_"+t),this.conf.skin=this.cell.conf.skin=t,this.tb&&(this.cell.detachToolbar(t),this.tb=null,this.attachToolbar()),this.setSizes()},dhtmlXEditor.prototype._fontConf=function(){if(""==this.conf.skin)var t={family:this.conf.font.family,size:this.conf.font.size,color:this.conf.font.color};else t={family:"Roboto, Arial, Helvetica",size:"14px",color:"#404040"};return window.dhx4.template("font-size: #size#; font-family: #family#; color: #color#;",t)},window.dhtmlXEditorCell=function(t,e){dhtmlXCellObject.apply(this,[t,"_editor"]);return this.editor=e,this.conf.skin=this.editor.conf.skin,this.attachEvent("_onCellUnload",function(){this._stbUnload(),this.editor=null,null}),this._stbInit(),this},dhtmlXEditorCell.prototype=new dhtmlXCellObject,dhtmlXEditorCell.prototype._stbInit=function(){var t=this,e=document.createElement("DIV");e.className="dhx_cell_stb"+(dhx4.isIE6||dhx4.isIE7||dhx4.isIE8?"":" dhx_cell_stb_shadow"),this.cell.insertBefore(e,this.cell.childNodes[this.conf.idx.cont]),e.onselectstart=function(t){return(t=t||event).cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1};var n={bold:"applyBold",italic:"applyItalic",underline:"applyUnderscore",clearformat:"clearFormatting"};for(var i in n){var a=document.createElement("A");a.href="javascript:void(0);",a.tabIndex=-1,e.appendChild(a),a.onmousedown=a.onclick=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1};var o=document.createElement("DIV");o.className="dhx_cell_stb_button btn_"+i,o._actv=i.charAt(0),o._cmd=n[i],a.appendChild(o),o.onclick=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},o.onmousedown=function(e){(e=e||event).preventDefault?e.preventDefault():e.returnValue=!1,t.editor[this._cmd](),t.editor.callEvent("onToolbarClick",[this._actv])},o=a=null}e=null,this._stbUnload=function(){var e=this.cell.childNodes[this.conf.idx.stb];for(e.onselectstart=null;e.childNodes.length>0;)e.lastChild.onmousedown=e.lastChild.onclick=null,e.lastChild.firstChild.onmousedown=e.lastChild.firstChild.onclick=null,e.lastChild.firstChild._actv=e.lastChild.firstChild._cmd=null,e.lastChild.removeChild(e.lastChild.firstChild),e.removeChild(e.lastChild);e.parentNode.removeChild(e),e=t=null,this.conf.idx_data.stb=this.conf.ofs_nodes.t._getStbHeight=null,delete this.conf.ofs_nodes.t._getStbHeight,delete this.conf.idx_data.stb,this._updateIdx()},this.conf.stb_visible=!0,this.conf.ofs_nodes.t._getStbHeight="func",this.conf.idx_data.stb="dhx_cell_stb",this._updateIdx()},dhtmlXEditorCell.prototype._stbHide=function(){this.cell.childNodes[this.conf.idx.stb].style.display="none",this.conf.stb_visible=!1},dhtmlXEditorCell.prototype._getStbHeight=function(){return 1==this.conf.stb_visible&&"material"==this.conf.skin?(null==this.conf.stb_height&&(this.conf.stb_height=window.dhx4.readFromCss("dhxeditor_material stb_height_detect","scrollHeight","<div class='dhx_cell_editor'><div class='dhx_cell_stb'></div></div>")),this.conf.stb_height):this.cell.childNodes[this.conf.idx.stb].offsetHeight},dhtmlXCellObject.prototype.attachEditor=function(t){this.callEvent("_onBeforeContentAttach",["editor"]);var e=document.createElement("DIV");if(e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden",this._attachObject(e),"object"==typeof t&&null!=t||(t={}),t.parent=e,this.dataType="editor",this.dataObj=new dhtmlXEditor(t),e=null,t.parent=null,t=null,"function"==typeof window.dhtmlXPortalCell&&this instanceof window.dhtmlXPortalCell){if(null==this.portal.conf.editor_ev){var n=this.portal.attachEvent("onBeforeDrag",function(t){return"editor"==this.cdata[t].dataType&&(this.cdata[t].conf.editor_cont=this.cdata[t].dataObj.getContent()),!0}),i=this.portal.attachEvent("onDrop",function(t){"editor"==this.cdata[t].dataType&&(this.cdata[t].dataObj.setContent(this.cdata[t].conf.editor_cont),this.cdata[t].dataObj._prepareContent(!0),this.cdata[t].conf.editor_cont=null)});this.portal.conf.editor_ev=[n,i]}this.conf.editor_ev=this.attachEvent("_onBeforeContentDetach",function(){if(this.detachEvent(this.conf.editor_ev),this.conf.editor_ev=null,this instanceof window.dhtmlXPortalCell){var t=!1;for(var e in this.portal.cdata)this.portal.cdata[e]!=this&&"editor"==this.portal.cdata[e].dataType&&(t=!0);if(0==t){for(var n=0;n<this.portal.conf.editor_ev.length;n++)this.portal.detachEvent(this.portal.conf.editor_ev[n]);this.portal.conf.editor_ev=null}}})}return this.callEvent("_onContentAttach",[]),this.dataObj},dhtmlXEditor.prototype.attachToolbar=function(t){if(null==this.tb){null!=t&&(this.conf.iconsPath=t),this.cell._stbHide(),this.tb=this.cell.attachToolbar({icons_path:this.conf.iconsPath+"/dhxeditor_"+String(this.conf.skin).replace(/^dhx_/,"")+"/",skin:this.conf.skin}),this.setSizes();var e="material"==this.conf.skin?"png":"gif";this._availFonts=new Array("Arial","Arial Narrow","Comic Sans MS","Courier","Georgia","Impact","Tahoma","Times New Roman","Verdana"),this._initFont=this._availFonts[0],this._xmlFonts="";for(var n=0;n<this._availFonts.length;n++){var i=String(this._availFonts[n]).replace(/\s/g,"_");this._xmlFonts+='<item type="button" id="applyFontFamily:'+i+'"><itemText><![CDATA[<img src="'+this.tb.imagePath+"font_"+String(i).toLowerCase()+"."+e+'" border="0" style="/*margin-top:1px;margin-bottom:1px;*/width:110px;height:16px;">]]></itemText></item>'}for(var a in this._availSizes={1:"8pt",2:"10pt",3:"12pt",4:"14pt",5:"18pt",6:"24pt",7:"36pt"},this._xmlSizes="",this._availSizes)this._xmlSizes+='<item type="button" id="applyFontSize:'+a+":"+this._availSizes[a]+'" text="'+this._availSizes[a]+'"/>';this.tbXML='<toolbar><item id="applyH1" type="buttonTwoState" img="h1.'+e+'" imgdis="h4_dis.'+e+'" title="H1"/><item id="applyH2" type="buttonTwoState" img="h2.'+e+'" imgdis="h4_dis.'+e+'" title="H2"/><item id="applyH3" type="buttonTwoState" img="h3.'+e+'" imgdis="h4_dis.'+e+'" title="H3"/><item id="applyH4" type="buttonTwoState" img="h4.'+e+'" imgdis="h4_dis.'+e+'" title="H4"/><item id="separ01" type="separator"/><item id="applyBold" type="buttonTwoState" img="bold.'+e+'" imgdis="bold_dis.'+e+'" title="Bold Text"/><item id="applyItalic" type="buttonTwoState" img="italic.'+e+'" imgdis="italic_dis.'+e+'" title="Italic Text"/><item id="applyUnderscore" type="buttonTwoState" img="underline.'+e+'" imgdis="underline_dis.'+e+'" title="Underscore Text"/><item id="applyStrikethrough" type="buttonTwoState" img="strike.'+e+'" imgdis="strike_dis.'+e+'" title="Strikethrough Text"/><item id="separ02" type="separator"/><item id="alignLeft" type="buttonTwoState" img="align_left.'+e+'" imgdis="align_left_dis.'+e+'" title="Left Alignment"/><item id="alignCenter" type="buttonTwoState" img="align_center.'+e+'" imgdis="align_center_dis.'+e+'" title="Center Alignment"/><item id="alignRight" type="buttonTwoState" img="align_right.'+e+'" imgdis="align_right_dis.'+e+'" title="Right Alignment"/><item id="alignJustify" type="buttonTwoState" img="align_justify.'+e+'" title="Justified Alignment"/><item id="separ03" type="separator"/><item id="applySub" type="buttonTwoState" img="script_sub.'+e+'" imgdis="script_sub.'+e+'" title="Subscript"/><item id="applySuper" type="buttonTwoState" img="script_super.'+e+'" imgdis="script_super_dis.'+e+'" title="Superscript"/><item id="separ04" type="separator"/><item id="createNumList" type="button" img="list_number.'+e+'" imgdis="list_number_dis.'+e+'" title="Number List"/><item id="createBulList" type="button" img="list_bullet.'+e+'" imgdis="list_bullet_dis.'+e+'" title="Bullet List"/><item id="separ05" type="separator"/><item id="increaseIndent" type="button" img="indent_inc.'+e+'" imgdis="indent_inc_dis.'+e+'" title="Increase Indent"/><item id="decreaseIndent" type="button" img="indent_dec.'+e+'" imgdis="indent_dec_dis.'+e+'" title="Decrease Indent"/><item id="separ06" type="separator"/><item id="clearFormatting" type="button" img="clear.'+e+'" title="Clear Formatting"/></toolbar>',this.tb.loadStruct(this.tbXML),this._checkAlign=function(t){this.tb.setItemState("alignCenter",!1),this.tb.setItemState("alignRight",!1),this.tb.setItemState("alignJustify",!1),this.tb.setItemState("alignLeft",!1),t&&this.tb.setItemState(t,!0)},this._checkH=function(t){this.tb.setItemState("applyH1",!1),this.tb.setItemState("applyH2",!1),this.tb.setItemState("applyH3",!1),this.tb.setItemState("applyH4",!1),t&&this.tb.setItemState(t,!0)},this._doOnFocusChanged=function(t){if(t.h1||t.h2||t.h3||t.h4)this.tb.setItemState("applyBold",!1);else{var e=-1!=String(t.fontWeight).search(/bold/i)||Number(t.fontWeight)>=700;this.tb.setItemState("applyBold",e)}var n="alignLeft";-1!=String(t.textAlign).search(/center/)&&(n="alignCenter"),-1!=String(t.textAlign).search(/right/)&&(n="alignRight"),-1!=String(t.textAlign).search(/justify/)&&(n="alignJustify"),this.tb.setItemState(n,!0),this._checkAlign(n),this.tb.setItemState("applyH1",t.h1),this.tb.setItemState("applyH2",t.h2),this.tb.setItemState("applyH3",t.h3),this.tb.setItemState("applyH4",t.h4),window._KHTMLrv&&(t.sub="sub"==t.vAlign,t.sup="super"==t.vAlign),this.tb.setItemState("applyItalic","italic"==t.fontStyle),this.tb.setItemState("applyStrikethrough",t.del),this.tb.setItemState("applySub",t.sub),this.tb.setItemState("applySuper",t.sup),this.tb.setItemState("applyUnderscore",t.u)},this._doOnToolbarClick=function(t){var e=String(t).split(":");null!=this[e[0]]&&"function"==typeof this[e[0]]&&(this[e[0]](e[1]),this.callEvent("onToolbarClick",[t]))},this._doOnStateChange=function(t,e){switch(this[t](),t){case"alignLeft":case"alignCenter":case"alignRight":case"alignJustify":this._checkAlign(t);break;case"applyH1":case"applyH2":case"applyH3":case"applyH4":this._checkH(t)}this.callEvent("onToolbarClick",[t])},this._doOnBeforeStateChange=function(t,e){return"alignLeft"!=t&&"alignCenter"!=t&&"alignRight"!=t&&"alignJustify"!=t||1!=e};var o=this;this.tb.attachEvent("onClick",function(t){o._doOnToolbarClick(t)}),this.tb.attachEvent("onStateChange",function(t,e){o._doOnStateChange(t,e)}),this.tb.attachEvent("onBeforeStateChange",function(t,e){return o._doOnBeforeStateChange(t,e)}),this.applyBold=function(){this._runCommand("Bold")},this.applyItalic=function(){this._runCommand("Italic")},this.applyUnderscore=function(){this._runCommand("Underline")},this.applyStrikethrough=function(){this._runCommand("StrikeThrough")},this.alignLeft=function(){this._runCommand("JustifyLeft")},this.alignRight=function(){this._runCommand("JustifyRight")},this.alignCenter=function(){this._runCommand("JustifyCenter")},this.alignJustify=function(){this._runCommand("JustifyFull")},this.applySub=function(){this._runCommand("Subscript")},this.applySuper=function(){this._runCommand("Superscript")},this.applyH1=function(){this._runCommand("FormatBlock","<H1>")},this.applyH2=function(){this._runCommand("FormatBlock","<H2>")},this.applyH3=function(){this._runCommand("FormatBlock","<H3>")},this.applyH4=function(){this._runCommand("FormatBlock","<H4>")},this.createNumList=function(){this._runCommand("InsertOrderedList")},this.createBulList=function(){this._runCommand("InsertUnorderedList")},this.increaseIndent=function(){this._runCommand("Indent")},this.decreaseIndent=function(){this._runCommand("Outdent")},this.clearFormatting=function(){this._runCommand("RemoveFormat"),this.tb.setItemState("applyBold",!1),this.tb.setItemState("applyItalic",!1),this.tb.setItemState("applyStrikethrough",!1),this.tb.setItemState("applySub",!1),this.tb.setItemState("applySuper",!1),this.tb.setItemState("applyUnderscore",!1);var t=this.getContent();t=t.replace(/<\/?h\d>/gi,""),this.setContent(t)}}},dhtmlx.Group={_init:function(){dhtmlx.assert(this.data,"DataStore required for grouping"),this.data.attachEvent("onStoreLoad",dhtmlx.bind(function(){this._settings.group&&this.group(this._settings.group,!1)},this)),this.attachEvent("onBeforeRender",dhtmlx.bind(function(t){this._settings.sort&&(t.block(),t.sort(this._settings.sort),t.unblock())},this)),this.data.attachEvent("onClearAll",dhtmlx.bind(function(){this.data._not_grouped_order=this.data._not_grouped_pull=null},this)),this.attachEvent("onBeforeSort",dhtmlx.bind(function(){this._settings.sort=null},this))},_init_group_data_event:function(t,e){t.attachEvent("onClearAll",dhtmlx.bind(function(){this.ungroup(!1),this.block(),this.clearAll(),this.unblock()},e))},sum:function(t,e){t=dhtmlx.Template.setter(t);var n=0;return(e=e||this.data).each(function(e){n+=1*t(e)}),n},min:function(t,e){t=dhtmlx.Template.setter(t);var n=1/0;return(e=e||this.data).each(function(e){1*t(e)<n&&(n=1*t(e))}),1*n},max:function(t,e){t=dhtmlx.Template.setter(t);var n=-1/0;return(e=e||this.data).each(function(e){1*t(e)>n&&(n=1*t(e))}),n},_split_data_by:function(t){var e=function(t,e){return(t=dhtmlx.Template.setter(t))(e[0])},n=dhtmlx.Template.setter(t.by);t.map[n]||(t.map[n]=[n,e]);var i={},a=[];for(var o in this.data.each(function(t){var e=n(t);i[e]||(a.push({id:e}),i[e]=dhtmlx.toArray()),i[e].push(t)}),t.map){var r=t.map[o][1]||e;"function"!=typeof r&&(r=this[r]);for(var s=0;s<a.length;s++)a[s][o]=r.call(this,t.map[o][0],i[a[s].id])}this.data._not_grouped_order=this.data.order,this.data._not_grouped_pull=this.data.pull,this.data.order=dhtmlx.toArray(),this.data.pull={};for(s=0;s<a.length;s++){var l=this.data.id(a[s]);this.data.pull[l]=a[s],this.data.order.push(l)}this.callEvent("onStoreUpdated",[])},group:function(t,e){this.ungroup(!1),this._split_data_by(t),!1!==e&&this.data.callEvent("onStoreUpdated",[])},ungroup:function(t){this.data._not_grouped_order&&(this.data.order=this.data._not_grouped_order,this.data.pull=this.data._not_grouped_pull,this.data._not_grouped_pull=this.data._not_grouped_order=null),!1!==t&&this.data.callEvent("onStoreUpdated",[])},group_setter:function(t){return dhtmlx.assert("object"==typeof t,"Incorrect group value"),dhtmlx.assert(t.by,"group.by is mandatory"),dhtmlx.assert(t.map,"group.map is mandatory"),t},sort_setter:function(t){return"object"!=typeof t&&(t={by:t}),this._mergeSettings(t,{as:"string",dir:"asc"}),t}},dhtmlx.Date={Locale:{month_full:["January","February","March","April","May","June","July","August","September","October","November","December"],month_short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],day_full:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],day_short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]},date_part:function(t){return t.setHours(0),t.setMinutes(0),t.setSeconds(0),t.setMilliseconds(0),t},time_part:function(t){return(t.valueOf()/1e3-60*t.getTimezoneOffset())%86400},week_start:function(t){var e=t.getDay();return this.config.start_on_monday&&(0===e?e=6:e--),this.date_part(this.add(t,-1*e,"day"))},month_start:function(t){return t.setDate(1),this.date_part(t)},year_start:function(t){return t.setMonth(0),this.month_start(t)},day_start:function(t){return this.date_part(t)},add:function(t,e,n){var i=new Date(t.valueOf());switch(n){case"day":i.setDate(i.getDate()+e);break;case"week":i.setDate(i.getDate()+7*e);break;case"month":i.setMonth(i.getMonth()+e);break;case"year":i.setYear(i.getFullYear()+e);break;case"hour":i.setHours(i.getHours()+e);break;case"minute":i.setMinutes(i.getMinutes()+e);break;default:return dhtmlx.Date["add_"+n](t,e,n)}return i},to_fixed:function(t){return t<10?"0"+t:t},copy:function(t){return new Date(t.valueOf())},date_to_str:function(t,e){return t=t.replace(/%[a-zA-Z]/g,function(t){switch(t){case"%d":return'"+dhtmlx.Date.to_fixed(date.getDate())+"';case"%m":return'"+dhtmlx.Date.to_fixed((date.getMonth()+1))+"';case"%j":return'"+date.getDate()+"';case"%n":return'"+(date.getMonth()+1)+"';case"%y":return'"+dhtmlx.Date.to_fixed(date.getFullYear()%100)+"';case"%Y":return'"+date.getFullYear()+"';case"%D":return'"+dhtmlx.Date.Locale.day_short[date.getDay()]+"';case"%l":return'"+dhtmlx.Date.Locale.day_full[date.getDay()]+"';case"%M":return'"+dhtmlx.Date.Locale.month_short[date.getMonth()]+"';case"%F":return'"+dhtmlx.Date.Locale.month_full[date.getMonth()]+"';case"%h":return'"+dhtmlx.Date.to_fixed((date.getHours()+11)%12+1)+"';case"%g":return'"+((date.getHours()+11)%12+1)+"';case"%G":return'"+date.getHours()+"';case"%H":return'"+dhtmlx.Date.to_fixed(date.getHours())+"';case"%i":return'"+dhtmlx.Date.to_fixed(date.getMinutes())+"';case"%a":return'"+(date.getHours()>11?"pm":"am")+"';case"%A":return'"+(date.getHours()>11?"PM":"AM")+"';case"%s":return'"+dhtmlx.Date.to_fixed(date.getSeconds())+"';case"%W":return'"+dhtmlx.Date.to_fixed(dhtmlx.Date.getISOWeek(date))+"';default:return t}}),e&&(t=t.replace(/date\.get/g,"date.getUTC")),new Function("date",'return "'+t+'";')},str_to_date:function(t,e){for(var n="var temp=date.split(/[^0-9a-zA-Z]+/g);",i=t.match(/%[a-zA-Z]/g),a=0;a<i.length;a++)switch(i[a]){case"%j":case"%d":n+="set[2]=temp["+a+"]||1;";break;case"%n":case"%m":n+="set[1]=(temp["+a+"]||1)-1;";break;case"%y":n+="set[0]=temp["+a+"]*1+(temp["+a+"]>50?1900:2000);";break;case"%g":case"%G":case"%h":case"%H":n+="set[3]=temp["+a+"]||0;";break;case"%i":n+="set[4]=temp["+a+"]||0;";break;case"%Y":n+="set[0]=temp["+a+"]||0;";break;case"%a":case"%A":n+="set[3]=set[3]%12+((temp["+a+"]||'').toLowerCase()=='am'?0:12);";break;case"%s":n+="set[5]=temp["+a+"]||0;"}var o="set[0],set[1],set[2],set[3],set[4],set[5]";return e&&(o=" Date.UTC("+o+")"),new Function("date","var set=[0,0,1,0,0,0]; "+n+" return new Date("+o+");")},getISOWeek:function(t){if(!t)return!1;var e=t.getDay();0===e&&(e=7);var n=new Date(t.valueOf());n.setDate(t.getDate()+(4-e));var i=n.getFullYear(),a=Math.floor((n.getTime()-new Date(i,0,1).getTime())/864e5);return 1+Math.floor(a/7)},getUTCISOWeek:function(t){return this.getISOWeek(t)}},dhtmlx.math={},dhtmlx.math._toHex=["0","1","2","3","4","5","6","7","8","9","A","B","C","D","E","F"],dhtmlx.math.toHex=function(t,e){for(t=parseInt(t,10),str="";t>0;)str=this._toHex[t%16]+str,t=Math.floor(t/16);for(;str.length<e;)str="0"+str;return str},dhtmlx.math.hexToDec=function(t){return parseInt(t,16)},dhtmlx.math.toRgb=function(t){var e,n,i,a;return"string"!=typeof t?(e=t[0],n=t[1],i=t[2]):-1!=t.indexOf("rgb")?(e=(a=t.substr(t.indexOf("(")+1,t.lastIndexOf(")")-t.indexOf("(")-1).split(","))[0],n=a[1],i=a[2]):("#"==t.substr(0,1)&&(t=t.substr(1)),e=this.hexToDec(t.substr(0,2)),n=this.hexToDec(t.substr(2,2)),i=this.hexToDec(t.substr(4,2))),e=parseInt(e,10)||0,n=parseInt(n,10)||0,i=parseInt(i,10)||0,(e<0||e>255)&&(e=0),(n<0||n>255)&&(n=0),(i<0||i>255)&&(i=0),[e,n,i]},dhtmlx.math.hsvToRgb=function(t,e,n){var i,a,o,r,s,l,d,c;switch(o=n*(1-e),r=n*(1-(a=t/60-(i=Math.floor(t/60)%6))*e),s=n*(1-(1-a)*e),l=0,d=0,c=0,i){case 0:l=n,d=s,c=o;break;case 1:l=r,d=n,c=o;break;case 2:l=o,d=n,c=s;break;case 3:l=o,d=r,c=n;break;case 4:l=s,d=o,c=n;break;case 5:l=n,d=o,c=r}return[l=Math.floor(255*l),d=Math.floor(255*d),c=Math.floor(255*c)]},dhtmlx.math.rgbToHsv=function(t,e,n){var i,a,o,r;i=t/255,a=e/255,o=n/255;var s,l=Math.min(i,a,o);return r=0,(s=Math.max(i,a,o))==l?r=0:s==i&&a>=o?r=60*(a-o)/(s-l)+0:s==i&&a<o?r=60*(a-o)/(s-l)+360:s==a?r=60*(o-i)/(s-l)+120:s==o&&(r=60*(i-a)/(s-l)+240),[r,0==s?0:1-l/s,s]},dhtmlx.presets||(dhtmlx.presets={}),dhtmlx.presets.chart={simple:{item:{borderColor:"#ffffff",color:"#2b7100",shadow:!1,borderWidth:2},line:{color:"#8ecf03",width:2}},plot:{color:"#1293f8",item:{borderColor:"#636363",borderWidth:1,color:"#ffffff",type:"r",shadow:!1},line:{color:"#1293f8",width:2}},diamond:{color:"#b64040",item:{borderColor:"#b64040",color:"#b64040",type:"d",radius:3,shadow:!0},line:{color:"#ff9000",width:2}},point:{color:"#fe5916",disableLines:!0,fill:!1,disableItems:!1,item:{color:"#feb916",borderColor:"#fe5916",radius:2,borderWidth:1,type:"r"},alpha:1},line:{line:{color:"#3399ff",width:2},item:{color:"#ffffff",borderColor:"#3399ff",radius:2,borderWidth:2,type:"d"},fill:!1,disableItems:!1,disableLines:!1,alpha:1},area:{fill:"#3399ff",line:{color:"#3399ff",width:1},disableItems:!0,alpha:.2,disableLines:!1},round:{item:{radius:3,borderColor:"#3f83ff",borderWidth:1,color:"#3f83ff",type:"r",shadow:!1,alpha:.6}},square:{item:{radius:3,borderColor:"#447900",borderWidth:2,color:"#69ba00",type:"s",shadow:!1,alpha:1}},column:{color:"RAINBOW",gradient:!1,width:45,radius:0,alpha:1,border:!0},stick:{width:5,gradient:!1,color:"#67b5c9",radius:2,alpha:1,border:!1},alpha:{color:"#b9a8f9",width:70,gradient:"falling",radius:0,alpha:.5,border:!0}},dhtmlx.ui.Map=function(t){this.name="Map",this._id="map_"+dhtmlx.uid(),this._key=t,this._map=[],this._areas=[]},dhtmlx.ui.Map.prototype={addRect:function(t,e,n){this._areas.push({index:n,points:e}),this._createMapArea(t,"RECT",e,n)},addPoly:function(t,e,n){this._createMapArea(t,"POLY",e,n)},_createMapArea:function(t,e,n,i){var a="";4==arguments.length&&(a="userdata='"+i+"'"),this._map.push("<area "+this._key+"='"+t+"' shape='"+e+"' coords='"+n.join()+"' "+a+"></area>")},addSector:function(t,e,n,i,a,o,r,s){var l=[];l.push(i),l.push(Math.floor(a*r));for(var d=e;d<n;d+=Math.PI/18)l.push(Math.floor(i+o*Math.cos(d))),l.push(Math.floor((a+o*Math.sin(d))*r));return l.push(Math.floor(i+o*Math.cos(n))),l.push(Math.floor((a+o*Math.sin(n))*r)),l.push(i),l.push(Math.floor(a*r)),this.addPoly(t,l,s)},render:function(t){var e=dhtmlx.html.create("DIV");e.style.cssText="position:absolute; width:100%; height:100%; top:0px; left:0px;",t.appendChild(e);var n=dhtmlx._isIE?"":"src='data:image/gif;base64,R0lGODlhEgASAIAAAP///////yH5BAUUAAEALAAAAAASABIAAAIPjI+py+0Po5y02ouz3pwXADs='";e.innerHTML="<map id='"+this._id+"' name='"+this._id+"'>"+this._map.join("\n")+"</map><img "+n+" class='dhx_map_img' usemap='#"+this._id+"' onmousedown='return false;'>",t._htmlmap=e,this._map=[]}},dhtmlx.chart={},dhtmlx.chart.scatter={pvt_render_scatter:function(t,e,n,i,a,o){if(!this._settings.xValue)return dhtmlx.log("warning","Undefined propery: xValue");var r=this._getLimits(),s=this._getLimits("h","xValue");a||(this.canvases.x||(this.canvases.x=new dhtmlx.ui.Canvas(this._obj,"axis_x")),this.canvases.y||(this.canvases.y=new dhtmlx.ui.Canvas(this._obj,"axis_y")),this._drawYAxis(this.canvases.y.getCanvas(),e,n,i,r.min,r.max),this._drawHXAxis(this.canvases.x.getCanvas(),e,n,i,s.min,s.max)),r={min:this._settings.yAxis.start,max:this._settings.yAxis.end},s={min:this._settings.xAxis.start,max:this._settings.xAxis.end};var l=this._getScatterParams(t,e,n,i,s,r);this._mapStart=n;for(var d=0;d<e.length;d++)this._drawScatterItem(t,o,n,i,l,s,r,e[d],a)},_getScatterParams:function(t,e,n,i,a,o){var r={};return r.totalHeight=i.y-n.y,r.totalWidth=i.x-n.x,this._calcScatterUnit(r,a.min,a.max,r.totalWidth,"X"),this._calcScatterUnit(r,o.min,o.max,r.totalHeight,"Y"),r},_drawScatterItem:function(t,e,n,i,a,o,r,s,l){var d=this._calculateScatterItemPosition(a,i,n,o,s,"X"),c=this._calculateScatterItemPosition(a,n,i,r,s,"Y");this._drawItem(t,d,c,s,this._settings.label.call(this,s),l,e)},_calculateScatterItemPosition:function(t,e,n,i,a,o){var r=this._settings["X"==o?"xValue":"value"].call(this,a),s=t["valueFactor"+o],l=(parseFloat(r||0)-i.min)*s,d=t["unit"+o],c=n[o.toLowerCase()]-("X"==o?-1:1)*Math.floor(d*l);return l<0&&(c=n[o.toLowerCase()]),r>i.max&&(c=e[o.toLowerCase()]),r<i.min&&(c=n[o.toLowerCase()]),c},_calcScatterUnit:function(t,e,n,i,a){var o=this._getRelativeValue(e,n);t["relValue"+(a=a||"")]=o[0],t["valueFactor"+a]=o[1],t["unit"+a]=t["relValue"+a]?i/t["relValue"+a]:10}},dhtmlx.chart.radar={pvt_render_radar:function(t,e,n,i,a,o){this._renderRadarChart(t,e,n,i,a,o)},_renderRadarChart:function(t,e,n,i,a,o){if(e.length){for(var r=this._getPieParameters(n,i),s=this._settings.radius?this._settings.radius:r.radius,l=this._settings.x?this._settings.x:r.x,d=this._settings.y?this._settings.y:r.y,c=[],h=0;h<e.length;h++)c.push(1);var u=this._getRatios(c,e.length);this._mapStart=n,a||this._drawRadarAxises(u,l,d,s,e),this._drawRadarData(t,u,l,d,s,e,a,o)}},_drawRadarData:function(t,e,n,i,a,o,r,s){var l,d,c,h,u,m,f,p,_,A,b,x,g,v,C,y,w,B,k;for(u=(c=this._settings).yAxis.start,m=c.yAxis.end,B=(x=(k=this._getRelativeValue(u,m))[0])?a/x:a/2,w=k[1],l=d=g=-Math.PI/2,_=[],p=0,h=0;h<o.length;h++)y?C=y:(v=c.value(o[h]),C=(parseFloat(v||0)-u)*w),A=Math.floor(B*C),v=c.value(h!=o.length-1?o[h+1]:o[0]),y=(parseFloat(v||0)-u)*w,b=Math.floor(B*y),l=d,d=h!=o.length-1?g+e[h]-1e-4:g,f=p||this._getPositionByAngle(l,n,i,A),p=this._getPositionByAngle(d,n,i,b),_.push(f);c.fill&&this._fillRadarChart(t,_,o),c.disableLines||this._strokeRadarChart(t,_,o),c.disableItems||this._drawRadarItemMarkers(t,_,o,r,s),_=null},_drawRadarItemMarkers:function(t,e,n,i,a){for(var o=0;o<e.length;o++)this._drawItem(t,e[o].x,e[o].y,n[o],this._settings.label.call(this,n),i,a)},_fillRadarChart:function(t,e,n){var i,a;t.globalAlpha=this._settings.alpha.call(this,{}),t.beginPath();for(var o=0;o<e.length;o++)t.fillStyle=this._settings.fill.call(this,n[o]),i=e[o],a=e[o+1]||e[0],o||t.moveTo(i.x,i.y),t.lineTo(a.x,a.y);t.fill(),t.globalAlpha=1},_strokeRadarChart:function(t,e,n){for(var i,a,o=0;o<e.length;o++)i=e[o],a=e[o+1]||e[0],this._drawLine(t,i.x,i.y,a.x,a.y,this._settings.line.color.call(this,n[o]),this._settings.line.width)},_drawRadarAxises:function(t,e,n,i,a){var o=this._settings.yAxis,r=this._settings.xAxis,s=o.start,l=o.end,d=o.step,c={},h=this._configYAxis;if(void 0===h.step||void 0===h.start||void 0===h.end){var u=this._getLimits();s=(c=this._calculateScale(u.min,u.max)).start,l=c.end,d=c.step,o.end=l,o.start=s}var m,f,p,_,A,b=[],x=0,g=i*d/(l-s);d<1&&(_=Math.min(this._log10(d),s<=0?0:this._log10(s)),A=Math.pow(10,-_));var v=[];this.canvases.scale||(this.canvases.scale=new dhtmlx.ui.Canvas(this._obj,"radar_scale"));var C=this.canvases.scale.getCanvas();for(m=l;m>=s;m-=d){c.fixNum&&(m=parseFloat(new Number(m).toFixed(c.fixNum))),b.push(Math.floor(x*g)+.5),A&&(m=Math.round(m*A)/A);var y=n-i+b[b.length-1];if(this.canvases.scale.renderTextAt("middle","left",e,y,o.template(m.toString()),"dhx_axis_item_y dhx_radar"),t.length<2)return void this._drawScaleSector(C,"arc",e,n,i-b[b.length-1],-Math.PI/2,3*Math.PI/2,m);var w,B=-Math.PI/2,k=B;for(f=0;f<t.length;f++)m==l&&v.push(k),w=B+t[f]-1e-4,this._drawScaleSector(C,h.lineShape||"line",e,n,i-b[b.length-1],k,w,m,f,a[m]),k=w;x++}for(m=0;m<v.length;m++)p=this._getPositionByAngle(v[m],e,n,i),r.lines.call(this,a[m],m)&&this._drawLine(C,e,n,p.x,p.y,r?r.lineColor.call(this,a[m]):"#cfcfcf",1),this._drawRadarScaleLabel(C,e,n,i,v[m],r?r.template.call(this,a[m]):"&nbsp;")},_drawScaleSector:function(t,e,n,i,a,o,r,s,l){var d,c;if(a<0)return!1;d=this._getPositionByAngle(o,n,i,a),c=this._getPositionByAngle(r,n,i,a);var h=this._settings.yAxis;h.bg&&(t.beginPath(),t.moveTo(n,i),"arc"==e?t.arc(n,i,a,o,r,!1):(t.lineTo(d.x,d.y),t.lineTo(c.x,c.y)),t.fillStyle=h.bg(s,l),t.moveTo(n,i),t.fill(),t.closePath()),h.lines.call(this,s)&&(t.lineWidth=1,t.beginPath(),"arc"==e?t.arc(n,i,a,o,r,!1):(t.moveTo(d.x,d.y),t.lineTo(c.x,c.y)),t.strokeStyle=h.lineColor.call(this,s),t.stroke())},_drawRadarScaleLabel:function(t,e,n,i,a,o){var r=this.canvases.scale.renderText(0,0,o,"dhx_axis_radar_title",1),s=r.scrollWidth,l=r.offsetHeight,d=.001,c=this._getPositionByAngle(a,e,n,i+5),h=0,u=0;(a<0||a>Math.PI)&&(u=-l),a>Math.PI/2&&(h=-s),Math.abs(a+Math.PI/2)<d||Math.abs(a-Math.PI/2)<d?h=-s/2:(Math.abs(a)<d||Math.abs(a-Math.PI)<d)&&(u=-l/2),r.style.top=c.y+u+"px",r.style.left=c.x+h+"px",r.style.width=s+"px",r.style.whiteSpace="nowrap"}},dhtmlx.chart.area={pvt_render_area:function(t,e,n,i,a,o){var r,s,l,d,c,h,u,m,f,p,_,A,b,x,g;if(h=this._calculateLineParams(t,e,n,i,a),d=(s=this._settings).eventRadius||Math.floor(h.cellWidth/2),e.length){for(u=[],p=s.offset?n.x+.5*h.cellWidth:n.x,l=0;l<e.length;l++)if(c=e[l],f=this._getPointY(c,n,i,h),b=p+h.cellWidth*l,f){if(x="object"==typeof f?f.y0:f,l&&this._settings.fixOverflow){if((m=this._getPointY(e[l-1],n,i,h)).out&&m.out==f.out)continue;_=h.cellWidth*(l-1)-.5+p,A="object"==typeof m?m.y0:m,m.out&&(g="min"==m.out?i.y:n.y,u.push([this._calcOverflowX(_,b,A,x,g),g])),f.out&&(g="min"==f.out?i.y:n.y,u.push([this._calcOverflowX(_,b,A,x,g),g]),l==e.length-1&&g==n.y&&u.push([b,n.y]))}f.out||(u.push([b,x]),o.addRect(c.id,[b-d-n.x,x-d-n.y,b+d-n.x,x+d-n.y],a)),s.yAxis||(r=s.offset||l!=e.length-1?"center":"left",this.canvases[a].renderTextAt(!1,r,b,x-s.labelOffset,s.label(c)))}u.length&&(u.push([b,i.y]),u.push([u[0][0],i.y])),t.globalAlpha=this._settings.alpha.call(this,e[0]),t.fillStyle=this._settings.color.call(this,e[0]),t.beginPath(),this._path(t,u),t.fill(),s.border&&(t.lineWidth=s.borderWidth||1,s.borderColor?t.strokeStyle=s.borderColor.call(this,e[0]):this._setBorderStyles(t,t.fillStyle),t.beginPath(),this._path(t,u),t.stroke()),t.lineWidth=1,t.globalAlpha=1}}},dhtmlx.chart.stackedArea={pvt_render_stackedArea:function(t,e,n,i,a,o){var r,s,l,d,c,h,u,m,f,p,_,A,b,x,g,v,C;if(f=this._calculateLineParams(t,e,n,i,a),u=(d=this._settings).eventRadius||Math.floor(f.cellWidth/2),e.length){p=[],b=[],_=d.offset?n.x+.5*f.cellWidth:n.x;var y=function(t,n){return a?e[t].$startY?n-i.y+e[t].$startY:0:n};for(c=0;c<e.length;c++)m=e[c],c?_+=f.cellWidth:(A=y(c,i.y),p.push([_,A])),A=y(c,this._getPointY(m,n,i,f)),b.push(isNaN(A)&&!c?e[c].$startY||i.y:A),A&&(p.push([_,A]),o.addRect(m.id,[_-u-n.x,A-u-n.y,_+u-n.x,A+u-n.y],a),d.yAxis||(d.offset,l="center",this.canvases[a].renderTextAt(!1,l,_,A-d.labelOffset,d.label(m))));if(p.push([_,y(c-1,i.y)]),a)for(c=e.length-2;c>0;c--)_-=f.cellWidth,(A=e[c].$startY)&&p.push([_,A]);for(p.push([p[0][0],p[0][1]]),t.globalAlpha=this._settings.alpha.call(this,e[0]),t.fillStyle=this._settings.color.call(this,e[0]),t.beginPath(),this._path(t,p),t.fill(),c=0;c<e.length;c++){if(!(A=b[c]))for(c==e.length-1&&(A=e[c].$startY),h=c+1;h<e.length;h++)if(b[h]){r={x:n.x,y:b[0]},s={x:n.x+f.cellWidth*h,y:b[h]},x=n.x+f.cellWidth*c,g=r,void 0,A=(C=((v=s).y-g.y)/(v.x-g.x))*x+g.y-C*g.x;break}e[c].$startY=A}}}},dhtmlx.chart.spline={pvt_render_spline:function(t,e,n,i,a,o){var r,s,l,d,c,h,u,m,f,p,_,A,b;if(c=this._calculateLineParams(t,e,n,i,a),r=this._settings,this._mapStart=n,l=[],e.length){for(m=r.offset?n.x+.5*c.cellWidth:n.x,s=0;s<e.length;s++)(_=this._getPointY(e[s],n,i,c))&&(u=s?c.cellWidth*s-.5+m:m,l.push({x:u,y:_,index:s}));for(h=this._getSplineParameters(l),s=0;s<l.length;s++){if(f=l[s].x,A=l[s].y,s<l.length-1){for(p=l[s+1].x,b=l[s+1].y,d=f;d<p;d++){var x=this._getSplineYPoint(d,f,s,h.a,h.b,h.c,h.d);x<n.y&&(x=n.y),x>i.y&&(x=i.y);var g=this._getSplineYPoint(d+1,f,s,h.a,h.b,h.c,h.d);g<n.y&&(g=n.y),g>i.y&&(g=i.y),this._drawLine(t,d,x,d+1,g,r.line.color(e[s]),r.line.width)}this._drawLine(t,p-1,this._getSplineYPoint(d,f,s,h.a,h.b,h.c,h.d),p,b,r.line.color(e[s]),r.line.width)}this._drawItem(t,f,A,e[l[s].index],r.label(e[l[s].index]),a,o)}}},_getSplineParameters:function(t){var e,n,i,a,o,r,s,l,d=[],c=[],h=t.length;for(e=0;e<h-1;e++)d[e]=t[e+1].x-t[e].x,c[e]=(t[e+1].y-t[e].y)/d[e];for(i=[],(n=[])[0]=0,n[1]=2*(d[0]+d[1]),i[0]=0,i[1]=6*(c[1]-c[0]),e=2;e<h-1;e++)n[e]=2*(d[e-1]+d[e])-d[e-1]*d[e-1]/n[e-1],i[e]=6*(c[e]-c[e-1])-d[e-1]*i[e-1]/n[e-1];for((a=[])[h-1]=a[0]=0,e=h-2;e>=1;e--)a[e]=(i[e]-d[e]*a[e+1])/n[e];for(o=[],r=[],s=[],l=[],e=0;e<h-1;e++)o[e]=t[e].y,r[e]=-d[e]*a[e+1]/6-d[e]*a[e]/3+(t[e+1].y-t[e].y)/d[e],s[e]=a[e]/2,l[e]=(a[e+1]-a[e])/(6*d[e]);return{a:o,b:r,c:s,d:l}},_getSplineYPoint:function(t,e,n,i,a,o,r){return i[n]+(t-e)*(a[n]+(t-e)*(o[n]+(t-e)*r[n]))}},dhtmlx.chart.barH={pvt_render_barH:function(t,e,n,i,a,o){var r,s,l,d,c,h,u,m,f,p,_,A,b,x,g,v,C,y,w,B,k;l=(i.y-n.y)/e.length,m=(u=this._getLimits("h")).max,f=u.min,v=i.x-n.x,k=!!this._settings.yAxis,a||this._drawHScales(t,e,n,i,f,m,l),k&&(m=parseFloat(this._settings.xAxis.end),f=parseFloat(this._settings.xAxis.start)),A=(x=this._getRelativeValue(f,m))[0],_=x[1],y=A?v/A:10,k||(g=10,y=A?(v-g)/A:10),s=parseInt(this._settings.width,10);var E=this._series.length,I=this._settings.seriesMargin,D=this._settings.seriesPadding;for(this._series&&s*E+D+(E>2?I*E:0)>l&&(s=l/E-D-(E>2?I:0)),r=(l-s*E-I*(E-1))/2,this._settings.border&&(s=parseInt(s,10),r=parseInt(r,10)),b=void 0!==this._settings.radius?parseInt(this._settings.radius,10):Math.round(s/5),p=!1,(c=this._settings.gradient)&&"function"!=typeof c?(p=c,c=!1):c&&(c=t.createLinearGradient(n.x,n.y,i.x,n.y),this._settings.gradient(c)),k||this._drawLine(t,n.x-.5,n.y,n.x-.5,i.y,"#000000",1),h=0;h<e.length;h++)if((C=parseFloat(this._settings.value(e[h]||0)))>m&&(C=m),C-=f,C*=_,w=n.x,B=n.y+r+(E>2?I*a:0)+parseInt(h*l,10)+s*a,C<0&&"auto"==this._settings.origin||this._settings.xAxis&&0===C&&!("auto"!=this._settings.origin&&this._settings.origin>f))this.canvases[a].renderTextAt("middle","right",w+10,B+s/2+r,this._settings.label(e[h]));else{C<0&&"auto"!=this._settings.origin&&this._settings.origin>f&&(C=0),k||(C+=g/y),d=c||this._settings.color.call(this,e[h]),this._settings.border&&this._drawBarHBorder(t,w,B,s,f,b,y,C,d),t.globalAlpha=this._settings.alpha.call(this,e[h]);var S=this._drawBarH(t,i,w,B,s,f,b,y,C,d,c,p);0!=p&&this._drawBarHGradient(t,w,B,s,f,b,y,C,d,p),t.globalAlpha=1,S[3]==B?(this.canvases[a].renderTextAt("middle","left",S[0]-5,S[3]+Math.floor(s/2),this._settings.label(e[h])),o.addRect(e[h].id,[S[0]-n.x,S[3]-n.y,S[2]-n.x,S[3]+s-n.y],a)):(this.canvases[a].renderTextAt("middle",!1,S[2]+5,S[1]+Math.floor(s/2),this._settings.label(e[h])),o.addRect(e[h].id,[S[0]-n.x,B-n.y,S[2]-n.x,S[3]-n.y],a))}},_setBarHPoints:function(t,e,n,i,a,o,r,s,l){var d=0;if(a>o*r){var c=(a-o*r)/a;d=-Math.asin(c)+Math.PI/2}t.moveTo(e,n+s);var h=e+o*r-a-(a?0:s);a<o*r&&t.lineTo(h,n+s);var u=n+a;a&&a>0&&t.arc(h,u,a-s,-Math.PI/2+d,0,!1);var m=n+i-a-(a?0:s),f=h+a-(a?s:0);t.lineTo(f,m),a&&a>0&&t.arc(h,m,a-s,0,Math.PI/2-d,!1);var p=n+i-s;return t.lineTo(e,p),l||t.lineTo(e,n+s),[f,p]},_drawHScales:function(t,e,n,i,a,o,r){var s=0;this._settings.xAxis&&(this.canvases.x||(this.canvases.x=new dhtmlx.ui.Canvas(this._obj)),s=this._drawHXAxis(this.canvases.x.getCanvas(),e,n,i,a,o)),this._settings.yAxis&&(this.canvases.y||(this.canvases.y=new dhtmlx.ui.Canvas(this._obj)),this._drawHYAxis(this.canvases.y.getCanvas(),e,n,i,r,s))},_drawHYAxis:function(t,e,n,i,a,o){if(this._settings.yAxis){var r,s=parseInt(o||n.x,10)-.5,l=i.y+.5,d=n.y;this._drawLine(t,s,l,s,d,this._settings.yAxis.color,1);for(var c=0;c<e.length;c++){var h="auto"!=this._settings.origin&&"barH"==this._settings.view&&parseFloat(this._settings.value(e[c]))<this._settings.origin;r=d+a/2+c*a,this.canvases.y.renderTextAt("middle",!h&&"left",h?s+5:s-5,r,this._settings.yAxis.template(e[c]),"dhx_axis_item_y",h?0:s-10),this._settings.yAxis.lines.call(this,e[c])&&this._drawLine(t,n.x,r,i.x,r,this._settings.yAxis.lineColor.call(this,e[c]),1)}this._drawLine(t,n.x+.5,d+.5,i.x,d+.5,this._settings.yAxis.lineColor.call(this,{}),1),this._setYAxisTitle(n,i)}},_drawHXAxis:function(t,e,n,i,a,o){var r,s={},l=this._settings.xAxis;if(l){var d=i.y+.5,c=n.x-.5,h=i.x-.5,u=n.x;if(this._drawLine(t,c,d,h,d,l.color,1),l.step&&(r=parseFloat(l.step)),void 0!==this._configXAxis.step&&void 0!==this._configXAxis.start&&void 0!==this._configXAxis.end||(a=(s=this._calculateScale(a,o)).start,o=s.end,r=s.step,this._settings.xAxis.end=o,this._settings.xAxis.start=a,this._settings.xAxis.step=r),0!==r){for(var m=(h-c)*r/(o-a),f=0,p=a;p<=o;p+=r){s.fixNum&&(p=parseFloat(new Number(p).toFixed(s.fixNum)));var _=Math.floor(c+f*m)+.5;p==a&&"auto"==this._settings.origin||!l.lines.call(this,p)||this._drawLine(t,_,d,_,n.y,this._settings.xAxis.lineColor.call(this,p),1),p==this._settings.origin&&(u=_+1);var A=p;if(r<1){var b=Math.min(this._log10(r),a<=0?0:this._log10(a)),x=Math.pow(10,-b);A=Math.round(p*x)/x}this.canvases.x.renderTextAt(!1,!0,_,d+2,l.template(A.toString()),"dhx_axis_item_x"),f++}return this.canvases.x.renderTextAt(!0,!1,c,i.y+this._settings.padding.bottom-3,this._settings.xAxis.title,"dhx_axis_title_x",i.x-n.x),l.lines.call(this,{})||this._drawLine(t,c,n.y-.5,h,n.y-.5,this._settings.xAxis.color,.2),u}}},_correctBarHParams:function(t,e,n,i,a,o,r){var s=e;return this._settings.yAxis&&"auto"!=this._settings.origin&&this._settings.origin>r&&(s=e+=(this._settings.origin-r)*a,(i-=this._settings.origin-r)<0&&(i*=-1,t.translate(e,n+o),t.rotate(Math.PI),e=.5,n=0),e+=.5),{value:i,x0:e,y0:n,start:s}},_drawBarH:function(t,e,n,i,a,o,r,s,l,d,c,h){var u;t.save();var m=this._correctBarHParams(t,n,i,l,s,a,o);t.fillStyle=d,t.beginPath(),s*m.value>0?(u=this._setBarHPoints(t,m.x0,m.y0,a,r,s,m.value,this._settings.border?1:0),c&&!h&&t.lineTo(e.x,m.y0+(this._settings.border?1:0))):u=[m.x0,m.y0+1],t.fill(),t.restore();var f=m.y0,p=m.y0!=i?i:u[1];return[m.y0!=i?m.start-u[0]:m.start,f,m.y0!=i?m.start:u[0],p]},_drawBarHBorder:function(t,e,n,i,a,o,r,s,l){t.save();var d=this._correctBarHParams(t,e,n,s,r,i,a);t.beginPath(),this._setBorderStyles(t,l),t.globalAlpha=.9,r*d.value>0&&this._setBarHPoints(t,d.x0,d.y0,i,o,r,d.value,t.lineWidth/2,1),t.stroke(),t.restore()},_drawBarHGradient:function(t,e,n,i,a,o,r,s,l,d){t.save();var c=this._correctBarHParams(t,e,n,s,r,i,a),h=this._setBarGradient(t,c.x0,c.y0+i,c.x0+r*c.value,c.y0,d,l,"x");t.fillStyle=h.gradient,t.beginPath(),r*c.value>0&&this._setBarHPoints(t,c.x0,c.y0+h.offset,i-2*h.offset,o,r,c.value,h.offset),t.fill(),t.globalAlpha=1,t.restore()}},dhtmlx.assert(dhtmlx.chart.barH),dhtmlx.chart.stackedBarH={pvt_render_stackedBarH:function(t,e,n,i,a,o){var r,s,l,d,c=i.x-n.x,h=!!this._settings.yAxis,u=this._getStackedLimits(e);r=u.max,s=u.min;var m=Math.floor((i.y-n.y)/e.length);a||this._drawHScales(t,e,n,i,s,r,m),h&&(r=parseFloat(this._settings.xAxis.end),s=parseFloat(this._settings.xAxis.start));var f=this._getRelativeValue(s,r);d=f[0],l=f[1];var p=d?c/d:10;if(!h){var _=10;p=d?(c-_)/d:10}var A=parseInt(this._settings.width,10);A+4>m&&(A=m-4);var b=(m-A)/2,x=!1,g=this._settings.gradient;g&&(x=!0),h||this._drawLine(t,n.x-.5,n.y,n.x-.5,i.y,"#000000",1);var v=0,C=0;for(y=0;y<this._series.length;y++)y==a&&(C=v),"stackedBarH"==this._series[y].view&&v++;for(var y=0;y<e.length;y++){C||(e[y].$startX=n.x);var w=parseFloat(this._settings.value(e[y]||0));w>r&&(w=r),w-=s,w*=l;var B=n.x,k=n.y+b+y*m;if(C?B=e[y].$startX:e[y].$startX=B,w<0||this._settings.yAxis&&0===w)this.canvases.y.renderTextAt("middle",!0,B+10,k+A/2,this._settings.label(e[y]));else{h||(w+=_/p);var E=this._settings.color.call(this,e[y]);t.globalAlpha=this._settings.alpha.call(this,e[y]),t.fillStyle=this._settings.color.call(this,e[y]),t.beginPath();var I=this._setBarHPoints(t,B,k,A,0,p,w,this._settings.border?1:0);if(g&&!x&&t.lineTo(n.x+c,k+(this._settings.border?1:0)),t.fill(),0!=x){var D=this._setBarGradient(t,B,k+A,B,k,x,E,"x");t.fillStyle=D.gradient,t.beginPath(),I=this._setBarHPoints(t,B,k,A,0,p,w,0),t.fill()}this._settings.border&&this._drawBarHBorder(t,B,k,A,s,0,p,w,E),t.globalAlpha=1,this.canvases[a].renderTextAt("middle",!0,e[y].$startX+(I[0]-e[y].$startX)/2-1,k+(I[1]-k)/2,this._settings.label(e[y])),o.addRect(e[y].id,[e[y].$startX-n.x,k-n.y,I[0]-n.x,I[1]-n.y],a),e[y].$startX=I[0]}}}},dhtmlx.chart.stackedBar={pvt_render_stackedBar:function(t,e,n,i,a,o){var r,s,l,d,c,h,u,m=this._settings,f=i.y-n.y,p=!!m.yAxis,_=!!m.xAxis,A=this._getStackedLimits(e),b=0===m.origin;if(r=A.max,s=A.min,e.length){var x=(i.x-n.x)/e.length;a||(l=this._drawScales(e,n,i,s,r,x)),p&&(r=parseFloat(m.yAxis.end),s=parseFloat(m.yAxis.start));var g=this._getRelativeValue(s,r);u=g[0],h=g[1];var v=u?f/u:10,C=parseInt(m.width,10);C+4>x&&(C=x-4);var y=Math.floor((x-C)/2),w=!!m.gradient&&m.gradient;_||this._drawLine(t,n.x,i.y+.5,i.x,i.y+.5,"#000000",1);for(var B=0;B<e.length;B++){var k=parseFloat(m.value(e[B]||0));this._logScaleCalc&&(k=this._log10(k)),d=n.x+y+B*x;var E=b&&k<0;if(a?c=E?e[B].$startYN:e[B].$startY:(c=l-1,e[B].$startY=c,b&&(E&&(c=l+1),e[B].$startYN=l+1)),k&&(a||b||(k-=s),k*=h,!(c<n.y+1)))if(m.yAxis&&0===k)this.canvases.y.renderTextAt(!0,!0,d+Math.floor(C/2),c,this._settings.label(e[B]));else{var I=this._settings.color.call(this,e[B]),D=Math.abs(c-(b?i.y+s*v:i.y))<3;t.globalAlpha=m.alpha.call(this,e[B]),t.fillStyle=t.strokeStyle=m.color.call(this,e[B]),t.beginPath();var S=c-v*k+(D?E?-1:1:0),N=this._setStakedBarPoints(t,d-(m.border?.5:0),c,C+(m.border?.5:0),S,0,n.y);if(t.fill(),t.stroke(),w){t.save();var M=this._setBarGradient(t,d,c,d+C,N[1],w,I,"y");t.fillStyle=M.gradient,t.beginPath(),N=this._setStakedBarPoints(t,d+M.offset,c,C-2*M.offset,S,m.border?1:0,n.y),t.fill(),t.restore()}m.border&&(t.save(),"string"==typeof m.border?t.strokeStyle=m.border:this._setBorderStyles(t,I),t.beginPath(),this._setStakedBarPoints(t,d-.5,parseInt(c,10)+.5,C+1,parseInt(S,10)+.5,0,n.y,D),t.stroke(),t.restore()),t.globalAlpha=1,this.canvases[a].renderTextAt(!1,!0,d+Math.floor(C/2),N[1]+(c-N[1])/2-7,this._settings.label(e[B])),o.addRect(e[B].id,[d-n.x,N[1]-n.y,N[0]-n.x,e[B][E?"$startYN":"$startY"]-n.y],a),e[B][E?"$startYN":"$startY"]=N[1]}}}},_setStakedBarPoints:function(t,e,n,i,a,o,r,s){t.moveTo(e,n),a<r&&(a=r),t.lineTo(e,a);var l=e+i,d=a;t.lineTo(l,d);var c=e+i;return t.lineTo(c,n),s||t.lineTo(e,n),[c,d]}},dhtmlx.chart.line={pvt_render_line:function(t,e,n,i,a,o){var r,s,l,d,c,h,u,m,f,p,_,A;if(d=this._calculateLineParams(t,e,n,i,a),r=this._settings,e.length){for(c=r.offset?n.x+.5*d.cellWidth:n.x,l=[],s=0;s<e.length;s++)if(A=this._getPointY(e[s],n,i,d)){if(u=s?d.cellWidth*s-.5+c:c,f="object"==typeof A?A.y0:A,s&&this._settings.fixOverflow){if((_=this._getPointY(e[s-1],n,i,d)).out&&_.out==A.out)continue;h=d.cellWidth*(s-1)-.5+c,m="object"==typeof _?_.y0:_,_.out&&(p="min"==_.out?i.y:n.y,l.push({x:this._calcOverflowX(h,u,m,f,p),y:p})),A.out&&(p="min"==A.out?i.y:n.y,l.push({x:this._calcOverflowX(h,u,m,f,p),y:p}))}A.out||l.push({x:u,y:A,index:s})}for(this._mapStart=n,s=1;s<=l.length;s++)h=l[s-1].x,m=l[s-1].y,s<l.length&&(u=l[s].x,f=l[s].y,this._drawLine(t,h,m,u,f,r.line.color.call(this,e[s-1]),r.line.width),r.line&&r.line.shadow&&(t.globalAlpha=.3,this._drawLine(t,h+2,m+r.line.width+8,u+2,f+r.line.width+8,"#eeeeee",r.line.width+3),t.globalAlpha=1)),void 0!==l[s-1].index&&this._drawItem(t,h,m,e[l[s-1].index],r.label(e[l[s-1].index]),a,o,n)}},_calcOverflowX:function(t,e,n,i,a){return t+(a-n)*(e-t)/(i-n)},_drawItem:function(t,e,n,i,a,o,r){var s=this._settings.item,l=parseInt(s.radius.call(this,i),10)||0,d=this._mapStart;if(l){if(t.save(),s.shadow){t.lineWidth=1,t.strokeStyle="#bdbdbd",t.fillStyle="#bdbdbd";for(var c=[.1,.2,.3],h=c.length-1;h>=0;h--)t.globalAlpha=c[h],t.strokeStyle="#d0d0d0",t.beginPath(),this._strokeChartItem(t,e,n+2*l/3,l+h+1,s.type),t.stroke();t.beginPath(),t.globalAlpha=.3,t.fillStyle="#bdbdbd",this._strokeChartItem(t,e,n+2*l/3,l+1,s.type),t.fill()}t.restore(),"image"==s.type&&s.src?this._drawImage(t,e-l,n-l,s.src,2*l,2*l):(t.lineWidth=s.borderWidth,t.fillStyle=s.color.call(this,i),t.strokeStyle=s.borderColor.call(this,i),t.globalAlpha=s.alpha.call(this,i),t.beginPath(),this._strokeChartItem(t,e,n,l+1,s.type),t.fill(),t.stroke(),t.globalAlpha=1)}a&&this.canvases[o].renderTextAt(!1,!0,e,n-l-this._settings.labelOffset,this._settings.label.call(this,i));var u=this._settings.eventRadius||l+1;r.addRect(i.id,[e-u-d.x,n-u-d.y,e+u-d.x,n+u-d.y],o)},_drawImage:function(t,e,n,i,a,o){var r=document.createElement("img");r.style.display="none",r.style.width=a+"px",r.style.height=o+"px",document.body.appendChild(r),r.src=i;var s=function(){t.drawImage(r,e,n)};r.complete?s():r.onload=s},_strokeChartItem:function(t,e,n,i,a){var o=[];if(e=parseInt(e,10),n=parseInt(n,10),!a||"square"!=a&&"s"!=a)if(!a||"diamond"!=a&&"d"!=a)o=!a||"triangle"!=a&&"t"!=a?[[e,n,i,0,2*Math.PI,!0]]:[[e,n-i],[e+Math.sqrt(3)*i/2,n+i/2],[e-Math.sqrt(3)*i/2,n+i/2],[e,n-i]];else{var r=t.lineWidth>1?t.lineWidth*Math.sqrt(2)/4:0;o=[[e,n-i],[e+i,n],[e,n+i],[e-i,n],[e+r,n-i-r]]}else o=[[e-(i*=Math.sqrt(2)/2)-t.lineWidth/2,n-i],[e+i,n-i],[e+i,n+i],[e-i,n+i],[e-i,n-i]];this._path(t,o)},_getPointY:function(t,e,n,i){var a=i.minValue,o=i.maxValue,r=i.unit,s=i.valueFactor,l=this._settings.value(t),d=(parseFloat(l||0)-a)*s;this._settings.yAxis||(d+=i.startValue/r);var c=n.y-r*d;return!this._settings.fixOverflow||"line"!=this._settings.view&&"area"!=this._settings.view?(l>o&&(c=e.y),(d<0||l<a)&&(c=n.y)):l>o?c={y:e.y,y0:c,out:"max"}:(d<0||l<a)&&(c={y:n.y,y0:c,out:"min"}),c},_calculateLineParams:function(t,e,n,i,a){var o,r={};r.totalHeight=i.y-n.y,r.cellWidth=(i.x-n.x)/(this._settings.offset?e.length:e.length-1);var s=!!this._settings.yAxis,l=-1!=this._settings.view.indexOf("stacked")?this._getStackedLimits(e):this._getLimits();r.maxValue=l.max,r.minValue=l.min,a||this._drawScales(e,n,i,r.minValue,r.maxValue,r.cellWidth),s&&(r.maxValue=parseFloat(this._settings.yAxis.end),r.minValue=parseFloat(this._settings.yAxis.start));var d=this._getRelativeValue(r.minValue,r.maxValue);return o=d[0],r.valueFactor=d[1],r.unit=o?r.totalHeight/o:10,r.startValue=0,s||(r.startValue=10,r.unit!=r.totalHeight&&(r.unit=o?(r.totalHeight-r.startValue)/o:10)),r}},dhtmlx.chart.bar={pvt_render_bar:function(t,e,n,i,a,o){var r,s,l,d,c,h,u,m,f,p,_,A,b,x=i.y-n.y;b=!!this._settings.yAxis,A=!!this._settings.xAxis,c=(d=this._getLimits()).max,h=d.min,s=(i.x-n.x)/e.length,a||"auto"!=this._settings.origin&&!b||this._drawScales(e,n,i,h,c,s),b&&(c=parseFloat(this._settings.yAxis.end),h=parseFloat(this._settings.yAxis.start)),u=(f=this._getRelativeValue(h,c))[0],m=f[1],_=u?x/u:u,b||"auto"!=this._settings.origin&&A||(p=10,_=u?(x-p)/u:p),!a&&"auto"!=this._settings.origin&&!b&&this._settings.origin>h&&this._drawXAxis(t,e,n,i,s,i.y-_*(this._settings.origin-h)),r=parseInt(this._settings.width,10);var g=0,v=0;for(l=0;l<this._series.length;l++)l==a&&(v=g),"bar"==this._series[l].view&&g++;var C=this._settings.seriesMargin,y=this._settings.seriesPadding;this._series&&r*g+y+(g>2?C*g:0)>s&&(r=s/g-y-(g>2?C:0));var w=(s-r*g-C*(g-1))/2;this._settings.border&&(r=parseInt(r,10),w=parseInt(w,10));var B=void 0!==this._settings.radius?parseInt(this._settings.radius,10):Math.round(r/5),k=!1,E=this._settings.gradient;for(E&&"function"!=typeof E?(k=E,E=!1):E&&(E=t.createLinearGradient(0,i.y,0,n.y),this._settings.gradient(E)),A||this._drawLine(t,n.x,i.y+.5,i.x,i.y+.5,"#000000",1),l=0;l<e.length;l++){var I=parseFloat(this._settings.value(e[l])||0);if(!isNaN(I)){I>c&&(I=c),I-=h,I*=m;var D=n.x+w+(g>2?C*v:0)+l*s+r*v,S=i.y;if(I<0||this._settings.yAxis&&0===I&&!("auto"!=this._settings.origin&&this._settings.origin>h))this.canvases[a].renderTextAt(!0,!0,D+Math.floor(r/2),S,this._settings.label(e[l]));else{b||"auto"!=this._settings.origin&&A||(I+=p/_);var N=E||this._settings.color.call(this,e[l]);t.globalAlpha=this._settings.alpha.call(this,e[l]);var M=this._drawBar(t,n,D,S,r,h,B,_,I,N,E,k);k&&this._drawBarGradient(t,D,S,r,h,B,_,I,N,k),this._settings.border&&this._drawBarBorder(t,D,S,r,h,B,_,I,N),t.globalAlpha=1,M[0]!=D?this.canvases[a].renderTextAt(!1,!0,D+Math.floor(r/2),M[1],this._settings.label(e[l])):this.canvases[a].renderTextAt(!0,!0,D+Math.floor(r/2),M[3],this._settings.label(e[l])),o.addRect(e[l].id,[D-n.x,M[3]-n.y,M[2]-n.x,M[1]-n.y],a)}}}},_correctBarParams:function(t,e,n,i,a,o,r){var s=n;return this._settings.xAxis&&"auto"!=this._settings.origin&&this._settings.origin>r&&(s=n-=(this._settings.origin-r)*a,(i-=this._settings.origin-r)<0&&(i*=-1,t.translate(e+o,n),t.rotate(Math.PI),e=0,n=0),n-=.5),{value:i,x0:e,y0:n,start:s}},_drawBar:function(t,e,n,i,a,o,r,s,l,d,c,h){var u;t.save(),t.fillStyle=d;var m=this._correctBarParams(t,n,i,l,s,a,o);u=s*m.value>0?this._setBarPoints(t,m.x0,m.y0,a,r,s,m.value,this._settings.border?1:0):[m.x0,m.y0],c&&!h&&t.lineTo(m.x0+(this._settings.border?1:0),e.y),t.fill(),t.restore();var f=m.x0,p=m.x0!=n?n+u[0]:u[0];return[f,m.x0!=n?m.start-u[1]-m.y0:m.y0,p,m.x0!=n?m.start-m.y0:u[1]]},_drawBarBorder:function(t,e,n,i,a,o,r,s,l){var d;t.save(),d=this._correctBarParams(t,e,n,s,r,i,a),this._setBorderStyles(t,l),r*d.value>0&&this._setBarPoints(t,d.x0,d.y0,i,o,r,d.value,t.lineWidth/2,1),t.stroke(),t.restore()},_drawBarGradient:function(t,e,n,i,a,o,r,s,l,d){t.save();var c=this._correctBarParams(t,e,n,s,r,i,a),h=this._setBarGradient(t,c.x0,c.y0,c.x0+i,c.y0-r*c.value+2,d,l,"y"),u=this._settings.border?1:0;t.fillStyle=h.gradient,r*c.value>0&&this._setBarPoints(t,c.x0+h.offset,c.y0,i-2*h.offset,o,r,c.value,h.offset+u),t.fill(),t.restore()},_setBarPoints:function(t,e,n,i,a,o,r,s,l){t.beginPath();var d=0;if(a>o*r){var c=(a-o*r)/a;c<=1&&c>=-1&&(d=-Math.acos(c)+Math.PI/2)}t.moveTo(e+s,n);var h=n-Math.floor(o*r)+a+(a?0:s);a<o*r&&t.lineTo(e+s,h);var u=e+a;a&&a>0&&t.arc(u,h,a-s,-Math.PI+d,-Math.PI/2,!1);var m=e+i-a-s,f=h-a+(a?s:0);t.lineTo(m,f),a&&a>0&&t.arc(m,h,a-s,-Math.PI/2,0-d,!1);var p=e+i-s;return t.lineTo(p,n),l||t.lineTo(e+s,n),[p,f]}},dhtmlx.chart.pie={pvt_render_pie:function(t,e,n,i,a,o){this._renderPie(t,e,n,i,1,o,a)},_renderPie:function(t,e,n,i,a,o,r){if(e.length){var s=this._getPieParameters(n,i),l=this._settings.radius?this._settings.radius:s.radius;if(!(l<0)){var d=this._getValues(e),c=this._getTotalValue(d),h=this._getRatios(d,c),u=this._settings.x?this._settings.x:s.x,m=this._settings.y?this._settings.y:s.y;1==a&&this._settings.shadow&&this._addShadow(t,u,m,l),m/=a;var f,p,_=-Math.PI/2,A=[];if(t.scale(1,a),this._settings.gradient){var b=1!=a?u+l/3:u,x=1!=a?m+l/3:m;this._showRadialGradient(t,u,m,l,b,x)}this._settings.labelLines&&(this._labelMargins=this._getLabelMargins(h,l));for(var g=0;g<e.length;g++)if(d[g]){t.strokeStyle=1==e.length?this._settings.color.call(this,e[g]):this._settings.lineColor.call(this,e[g]),t.beginPath(),t.moveTo(u,m),A.push(_),f=-Math.PI/2+h[g]-1e-4,t.arc(u,m,l,_,f,!1),t.lineTo(u,m);var v=this._settings.color.call(this,e[g]);t.fillStyle=v,t.fill(),this._settings.pieInnerText&&this._drawSectorLabel(u,m,5*l/6,_,f,a,this._settings.pieInnerText(e[g],c),!0),this._settings.label&&this._drawSectorLabel(u,m,l,_,f,a,this._settings.label(e[g]),0,this._labelMargins?this._labelMargins[g]:{},t),1!=a&&(this._createLowerSector(t,u,m,_,f,l,!0),t.fillStyle="#000000",t.globalAlpha=.2,this._createLowerSector(t,u,m,_,f,l,!1),t.globalAlpha=1,t.fillStyle=v),o.addSector(e[g].id,_,f,u-n.x,m-n.y/a,l,a,r),_=f}if(t.globalAlpha=.8,A.length>1)for(g=0;g<A.length;g++)p=this._getPositionByAngle(A[g],u,m,l),this._drawLine(t,u,m,p.x,p.y,this._settings.lineColor.call(this,e[g]),2);1==a&&(t.lineWidth=2,t.strokeStyle="#ffffff",t.beginPath(),t.arc(u,m,l+1,0,2*Math.PI,!1),t.stroke()),t.globalAlpha=1,t.scale(1,1/a)}}},_getLabelMargins:function(t,e){var n,i,a,o={1:[0]};for(a=1;a<t.length;a++){n=-Math.PI/2+(a>1?t[a-1]-(t[a-1]-t[a-2])/2:t[a-1]/2),i=-Math.PI/2+t[a]-(t[a]-t[a-1])/2;var r=Math.cos(i),s=Math.sin(i),l=Math.cos(n),d=Math.sin(n),c=Math.round((e+8)*Math.abs(Math.sin(i)-Math.sin(n))),h=r<0?s<0?4:3:s<0?1:2,u=l<0?d<0?4:3:d<0?1:2;o[h]||(o[h]=[]),o[h].push(u==h?c:0)}var m=[];for(var f in o){o[f].length;var p=0,_=0;if(1==f||3==f){b=f-1;for(var A=0;b>0;)o[b]&&(A+=o[b].length),b--;m[A+o[f].length-1]={y:0,x:0};for(var b=o[f].length-2;b>=0;)(p||b)&&o[f][b+1]-p<18?p+=18-o[f][b+1]:p=0,m[A+b]={y:p*(1==f?-1:1)},b--;for(var x=m.length-o[f].length;x<m.length;x++)0!=m[x].y?(_+=6,m[x].x=_):(m[x].x=0,_=0)}else{b=1;for(m.push({y:0,x:0});b<o[f].length;)o[f][b]-p<18?p+=18-o[f][b]:p=0,m.push({y:p*(4==f?-1:1)}),b++;for(x=m.length-1;x>=m.length-o[f].length;x--)0!=m[x].y?(_+=8,m[x].x=_):(_=0,m[x].x=0)}}return m},_getValues:function(t){for(var e=[],n=0;n<t.length;n++)e.push(parseFloat(this._settings.value(t[n])||0));return e},_getTotalValue:function(t){for(var e=0,n=0;n<t.length;n++)e+=t[n];return e},_getRatios:function(t,e){var n,i=[],a=0;e=e||this._getTotalValue(t);for(var o=0;o<t.length;o++)n=t[o],i[o]=2*Math.PI*(e?(n+a)/e:1/t.length),a+=n;return i},_getPieParameters:function(t,e){var n=e.x-t.x,i=e.y-t.y;return{x:t.x+n/2,y:t.y+i/2,radius:Math.min(n/2,i/2)}},_createLowerSector:function(t,e,n,i,a,o,r){if(t.lineWidth=1,i<=0&&a>=0||i>=0&&a<=Math.PI||Math.abs(i-Math.PI)>.003&&i<=Math.PI&&a>=Math.PI){i<=0&&a>=0&&(i=0,r=!1,this._drawSectorLine(t,e,n,o,i,a)),i<=Math.PI&&a>=Math.PI&&(a=Math.PI,r=!1,this._drawSectorLine(t,e,n,o,i,a));var s=(this._settings.height||Math.floor(o/4))/this._settings.cant;t.beginPath(),t.arc(e,n,o,i,a,!1),t.lineTo(e+o*Math.cos(a),n+o*Math.sin(a)+s),t.arc(e,n+s,o,a,i,!0),t.lineTo(e+o*Math.cos(i),n+o*Math.sin(i)),t.fill(),r&&t.stroke()}},_drawSectorLine:function(t,e,n,i,a,o){t.beginPath(),t.arc(e,n,i,a,o,!1),t.stroke()},_addShadow:function(t,e,n,i){t.globalAlpha=.5;for(var a=["#c4c4c4","#c6c6c6","#cacaca","#dcdcdc","#dddddd","#e0e0e0","#eeeeee","#f5f5f5","#f8f8f8"],o=a.length-1;o>-1;o--)t.beginPath(),t.fillStyle=a[o],t.arc(e+1,n+1,i+o,0,2*Math.PI,!0),t.fill();t.globalAlpha=1},_getGrayGradient:function(t){return t.addColorStop(0,"#ffffff"),t.addColorStop(.7,"#7a7a7a"),t.addColorStop(1,"#000000"),t},_showRadialGradient:function(t,e,n,i,a,o){var r;t.beginPath(),"function"!=typeof this._settings.gradient?(r=t.createRadialGradient(a,o,i/4,e,n,i),r=this._getGrayGradient(r)):r=this._settings.gradient(r),t.fillStyle=r,t.arc(e,n,i,0,2*Math.PI,!0),t.fill(),t.globalAlpha=.7},_drawSectorLabel:function(t,e,n,i,a,o,r,s,l,d){var c=this.canvases[0].renderText(0,0,r,0,1);if(c){var h=c.scrollWidth;c.style.width=h+"px",h>t&&(h=t);var u=a-i<.2?4:8;s&&(u=h/1.8);var m=i+(a-i)/2,f=n;n=s?5*n/6:n+this._settings.labelOffset,n-=(u-8)/2;var p=-u,_="right";(m>=Math.PI/2&&m<Math.PI||m<=3*Math.PI/2&&m>=Math.PI)&&(p=-h-p,_="left");var A=0;!s&&o<1&&m>0&&m<Math.PI&&(A=(this._settings.height||Math.floor(n/4))/o);var b=(e+Math.floor(n+A)*Math.sin(m))*o-8,x=t+Math.floor(n+u/2)*Math.cos(m)+p,g=a<Math.PI/2+.01,v=i<Math.PI/2;if(v&&g?x=Math.max(x,t+3):v||g?s||this._settings.labelLines||!(m>=Math.PI/2&&m<Math.PI||m<=3*Math.PI/2&&m>=Math.PI)||(x+=h/3):x=Math.min(x,t-h),this._settings.labelLines&&!s){Math.abs((Math.abs(l||0)+Math.abs(f*Math.sin(m)))/Math.sin(m));l.y&&(b+=l.y),"left"==_?x-=l.x:x+=l.x,d.beginPath(),d.strokeStyle="#555";var C=t+f*Math.cos(m),y=e+f*Math.sin(m);d.moveTo(C,y);var w=x-("left"==_?p-8:2),B=b;"left"==_&&w>C?(w=C-Math.abs(B-y+16)/Math.tan(m-Math.PI),B+=16,m<Math.PI&&(B-=8)):B+=8,d.lineTo(w,B),d.lineTo(w+("left"==_?-5:5),B),d.stroke(),b=B-8,x=w+p+("left"==_?-15:15)}c.style.top=b+"px",c.style.left=x+"px",c.style.width=h+"px",c.style.textAlign=_,c.style.whiteSpace="nowrap"}}},dhtmlx.chart.pie3D={pvt_render_pie3D:function(t,e,n,i,a,o){this._renderPie(t,e,n,i,this._settings.cant,o)}},dhtmlx.chart.donut={pvt_render_donut:function(t,e,n,i,a,o){if(e.length){this._renderPie(t,e,n,i,1,o);var r=this._settings,s=this._getPieParameters(n,i),l=r.radius?r.radius:s.radius,d=r.innerRadius&&r.innerRadius<l?r.innerRadius:l/3,c=r.x?r.x:s.x,h=r.y?r.y:s.y;t.fillStyle="#ffffff",t.beginPath(),t.arc(c,h,d,0,2*Math.PI,!0),t.fill()}}},dhtmlx.DataDriver.dhtmlxgrid={_grid_getter:"_get_cell_value",toObject:function(t){return this._grid=t,t},getRecords:function(t){return t.rowsBuffer},getDetails:function(t){for(var e={},n=0;n<this._grid.getColumnsNum();n++)e["data"+n]=this._grid[this._grid_getter](t,n);return e},getInfo:function(t){return{_size:0,_from:0}}},dhtmlx.ui.Canvas=function(t,e,n){this._canvas_labels=[],this._canvas_name=e,this._obj=t;var i=t.offsetWidth*(window.devicePixelRatio||1),a=t.offsetHeight*(window.devicePixelRatio||1);n=n||"";n+=";width:"+t.offsetWidth+"px;height:"+t.offsetHeight+"px;",this._prepareCanvas(e,n,i,a)},dhtmlx.ui.Canvas.prototype={_prepareCanvas:function(t,e,n,i){return this._canvas=dhtmlx.html.create("canvas",{width:n,height:i,canvas_id:t,style:e||""}),this._obj.appendChild(this._canvas),this._canvas.getContext||(dhtmlx._isIE?(dhtmlx.require("thirdparty/excanvas/excanvas.js"),G_vmlCanvasManager.init_(document),G_vmlCanvasManager.initElement(this._canvas)):dhtmlx.error("Canvas is not supported in the current browser")),this._canvas},getCanvas:function(t){var e=(this._canvas||this._prepareCanvas()).getContext(t||"2d");return this._dhtmlxDevicePixelRatio||(this._dhtmlxDevicePixelRatio=!0,e.scale(window.devicePixelRatio||1,window.devicePixelRatio||1)),e},_resizeCanvas:function(){if(this._canvas){var t=this._canvas.parentNode.offsetWidth,e=this._canvas.parentNode.offsetHeight;this._canvas.setAttribute("width",t*(window.devicePixelRatio||1)),this._canvas.setAttribute("height",e*(window.devicePixelRatio||1)),this._canvas.style.width=t+"px",this._canvas.style.height=e+"px",this._dhtmlxDevicePixelRatio=!1}},renderText:function(t,e,n,i,a){if(n){var o=dhtmlx.html.create("DIV",{class:"dhx_canvas_text"+(i?" "+i:""),style:"left:"+t+"px; top:"+e+"px;"},n);return this._obj.appendChild(o),this._canvas_labels.push(o),a&&(o.style.width=a+"px"),o}},renderTextAt:function(t,e,n,i,a,o,r){var s=this.renderText.call(this,n,i,a,o,r);return s&&(t&&(s.style.top="middle"==t?parseInt(i-s.offsetHeight/2,10)+"px":i-s.offsetHeight+"px"),e&&(s.style.left="left"==e?n-s.offsetWidth+"px":parseInt(n-s.offsetWidth/2,10)+"px")),s},clearCanvas:function(t){var e,n=[];for(e=0;e<this._canvas_labels.length;e++)this._obj.removeChild(this._canvas_labels[e]);if(this._canvas_labels=[],!t&&this._obj._htmlmap){for(n=this._getMapAreas();n.length;)n[0].parentNode.removeChild(n[0]),n.splice(0,1);n=null,this._obj._htmlmap.getElementsByTagName("AREA").length||(this._obj._htmlmap.parentNode.removeChild(this._obj._htmlmap),this._obj._htmlmap=null)}this.getCanvas().clearRect(0,0,this._canvas.width,this._canvas.height)},toggleCanvas:function(){this._toggleCanvas("none"==this._canvas.style.display)},showCanvas:function(){this._toggleCanvas(!0)},hideCanvas:function(){this._toggleCanvas(!1)},_toggleCanvas:function(t){var e,n;for(n=0;n<this._canvas_labels.length;n++)this._canvas_labels[n].style.display=t?"":"none";if(this._obj._htmlmap)for(e=this._getMapAreas(),n=0;n<e.length;n++)t?e[n].removeAttribute("disabled"):e[n].setAttribute("disabled","true");this._canvas.style.display=t?"":"none"},_getMapAreas:function(){var t,e,n=[];for(t=this._obj._htmlmap.getElementsByTagName("AREA"),e=0;e<t.length;e++)t[e].getAttribute("userdata")==this._canvas_name&&n.push(t[e]);return n}},dhtmlXChart=function(t){for(var e in this.name="Chart",dhtmlx.assert_enabled()&&this._assert(),dhtmlx.extend(this,dhtmlx.Settings),this._parseContainer(t,"dhx_chart"),dhtmlx.extend(this,dhtmlx.AtomDataLoader),dhtmlx.extend(this,dhtmlx.DataLoader),this.data.provideApi(this,!0),dhtmlx.extend(this,dhtmlx.EventSystem),dhtmlx.extend(this,dhtmlx.MouseEvents),dhtmlx.destructors.push(this),dhtmlx.extend(this,dhtmlx.Group),dhtmlx.extend(this,dhtmlx.AutoTooltip),dhtmlx.chart)dhtmlx.extend(this,dhtmlx.chart[e]);t.preset&&this.definePreset(t),this._parseSettings(t,this.defaults),this._series=[this._settings],this.data.attachEvent("onStoreUpdated",dhtmlx.bind(function(){this.render()},this)),this.attachEvent("onLocateData",this._switchSerie)},dhtmlXChart.prototype={_id:"dhx_area_id",on_click:{dhx_chart_legend_item:function(t,e,n){var i=n.getAttribute("series_id");if(this.callEvent("onLegendClick",[t,i,n])){var a=this._settings,o=a.legend.values,r=o&&void 0!==o[i].toggle?o[i].toggle:a.legend.toggle;void 0!==i&&this._series.length>1&&r&&(-1!=n.className.indexOf("hidden")?this.showSeries(i):this.hideSeries(i))}}},on_dblclick:{},on_mouse_move:{},destructor:function(){if(dhtmlx.Destruction.destructor.apply(this,arguments),this.canvases){for(var t in this.canvases)this.canvases[t]._obj=null,this.canvases[t]=null;this.canvases=null}this.legendObj&&(this.legendObj.innerHTML="",this.legendObj=null),this.config.tooltip&&(this.config.tooltip._obj=null,this.config.tooltip._dataobj=null)},bind:function(){dhtmlx.BaseBind.legacyBind.apply(this,arguments)},sync:function(){dhtmlx.BaseBind.legacySync.apply(this,arguments)},resize:function(){for(var t in this.canvases)this.canvases[t]._resizeCanvas();this.render()},view_setter:function(t){return dhtmlx.chart[t]||dhtmlx.error("Chart type extension is not loaded: "+t),void 0===this._settings.offset&&(this._settings.offset=!("area"==t||"stackedArea"==t)),"radar"!=t||this._settings.yAxis||this.define("yAxis",{}),"scatter"==t&&(this._settings.yAxis||this.define("yAxis",{}),this._settings.xAxis||this.define("xAxis",{})),t},clearCanvas:function(){if(this.canvases&&"object"==typeof this.canvases)for(var t in this.canvases)this.canvases[t].clearCanvas()},render:function(){var t,e,n,i,a;if(this.callEvent("onBeforeRender",[this.data])){if(this.canvases&&"object"==typeof this.canvases)for(e in this.canvases)this.canvases[e].clearCanvas();else this.canvases={};for(this._settings.legend&&(this.canvases.legend||(this.canvases.legend=new dhtmlx.ui.Canvas(this._obj,"legend")),this._drawLegend(this.data.getRange(),this._obj.offsetWidth)),t=this._getChartBounds(this._obj.offsetWidth,this._obj.offsetHeight),this._map=i=new dhtmlx.ui.Map(this._id),a=this._settings,n=this._getChartData(),e=0;e<this._series.length;e++)this._settings=this._series[e],this.canvases[e]||(this.canvases[e]=new dhtmlx.ui.Canvas(this._obj,e,"z-index:"+(2+e))),this["pvt_render_"+this._settings.view](this.canvases[e].getCanvas(),n,t.start,t.end,e,i);i.render(this._obj),this._obj.lastChild.style.zIndex=1e3,this._applyBounds(this._obj.lastChild,t),this.callEvent("onAfterRender",[]),this._settings=a}},_applyBounds:function(t,e){var n={};for(var i in n.left=e.start.x,n.top=e.start.y,n.width=e.end.x-e.start.x,n.height=e.end.y-e.start.y,n)t.style[i]=n[i]+"px"},_getChartData:function(){var t,e,n,i,a,o,r,s,l,d;if(i=this.data.getRange(),t=-1!=this._settings.view.toLowerCase().indexOf("barh")?"yAxis":"xAxis",(e=this._settings[t])&&e.units&&"object"==typeof e.units){if(s=[],void 0!==(n=e.units).start&&void 0!==n.end&&void 0!==n.next)for(r=n.start;r<=n.end;)s.push(r),r=n.next.call(this,r);else"[object Array]"===Object.prototype.toString.call(n)&&(s=n);if(o=[],s.length){for(l=e.value,d={},a=0;a<i.length;a++)d[l(i[a])]=a;for(a=0;a<s.length;a++)void 0!==d[s[a]]?(i[d[s[a]]].$unit=s[a],o.push(i[d[s[a]]])):o.push({$unit:s[a]})}return o}return i},value_setter:dhtmlx.Template.obj_setter,xValue_setter:dhtmlx.Template.obj_setter,yValue_setter:function(t){this.define("value",t)},alpha_setter:dhtmlx.Template.obj_setter,label_setter:dhtmlx.Template.obj_setter,lineColor_setter:dhtmlx.Template.obj_setter,borderColor_setter:dhtmlx.Template.obj_setter,pieInnerText_setter:dhtmlx.Template.obj_setter,gradient_setter:function(t){return"function"!=typeof t&&t&&!0===t&&(t="light"),t},colormap:{RAINBOW:function(t){var e=Math.floor(this.indexById(t.id)/this.dataCount()*1536);return 1536==e&&(e-=1),this._rainbow[Math.floor(e/256)](e%256)}},color_setter:function(t){return this.colormap[t]||dhtmlx.Template.obj_setter(t)},fill_setter:function(t){return!(!t||0==t)&&dhtmlx.Template.obj_setter(t)},definePreset:function(t){this.define("preset",t.preset),delete t.preset},preset_setter:function(t){var e,n,i;if(this.defaults=dhtmlx.extend({},this.defaults),"object"==typeof dhtmlx.presets.chart[t]){for(e in i=dhtmlx.presets.chart[t])if("object"==typeof i[e])if(this.defaults[e]&&"object"==typeof this.defaults[e])for(n in this.defaults[e]=dhtmlx.extend({},this.defaults[e]),i[e])this.defaults[e][n]=i[e][n];else this.defaults[e]=dhtmlx.extend({},i[e]);else this.defaults[e]=i[e];return t}return!1},legend_setter:function(t){return t?("object"!=typeof t&&(t={template:t}),this._mergeSettings(t,{width:150,height:18,layout:"y",align:"left",valign:"bottom",template:"",toggle:-1!=this._settings.view.toLowerCase().indexOf("stacked")?"":"hide",marker:{type:"square",width:15,height:15,radius:3},margin:4,padding:3}),t.template=dhtmlx.Template.setter(t.template),t):(this.legendObj&&(this.legendObj.innerHTML="",this.legendObj=null),!1)},defaults:{color:"RAINBOW",alpha:"1",label:!1,value:"{obj.value}",padding:{},view:"pie",lineColor:"#ffffff",cant:.5,width:30,labelWidth:100,line:{width:2,color:"#1293f8"},seriesMargin:1,seriesPadding:4,item:{radius:3,borderColor:"#636363",borderWidth:1,color:"#ffffff",alpha:1,type:"r",shadow:!1},shadow:!0,gradient:!1,border:!0,labelOffset:20,origin:"auto"},item_setter:function(t){"object"!=typeof t&&(t={color:t,borderColor:t}),this._mergeSettings(t,dhtmlx.extend({},this.defaults.item));for(var e=["alpha","borderColor","color","radius"],n=0;n<e.length;n++)t[e[n]]=dhtmlx.Template.setter(t[e[n]]);return t},line_setter:function(t){return"object"!=typeof t&&(t={color:t}),dhtmlx.extend(this.defaults.line,t),(t=dhtmlx.extend({},this.defaults.line)).color=dhtmlx.Template.setter(t.color),t},padding_setter:function(t){return"object"!=typeof t&&(t={left:t,right:t,top:t,bottom:t}),this._mergeSettings(t,{left:50,right:20,top:35,bottom:40}),t},xAxis_setter:function(t){if(!t)return!1;"object"!=typeof t&&(t={template:t}),t.value||(t.value=t.template),this._mergeSettings(t,{title:"",color:"#000000",lineColor:"#cfcfcf",template:"{obj}",value:"{obj}",lines:!0});return this._converToTemplate(["lineColor","template","lines","value"],t),this._configXAxis=dhtmlx.extend({},t),t},yAxis_setter:function(t){if(!t)return!1;this._mergeSettings(t,{title:"",color:"#000000",lineColor:"#cfcfcf",template:"{obj}",lines:!0,bg:"#ffffff"});return this._converToTemplate(["lineColor","template","lines","bg"],t),this._configYAxis=dhtmlx.extend({},t),t},_converToTemplate:function(t,e){for(var n=0;n<t.length;n++)e[t[n]]=dhtmlx.Template.setter(e[t[n]])},_drawScales:function(t,e,n,i,a,o){var r=0;return this._settings.yAxis&&(this.canvases.y||(this.canvases.y=new dhtmlx.ui.Canvas(this._obj,"axis_y")),r=this._drawYAxis(this.canvases.y.getCanvas(),t,e,n,i,a)),this._settings.xAxis&&(this.canvases.x||(this.canvases.x=new dhtmlx.ui.Canvas(this._obj,"axis_x")),this._drawXAxis(this.canvases.x.getCanvas(),t,e,n,o,r)),r},_drawXAxis:function(t,e,n,i,a,o){for(var r,s=n.x-.5,l=parseInt(o||i.y,10)+.5,d=i.x,c=!0,h=0===this._settings.origin&&"stackedBar"==this._settings.view?i.y+.5:l,u=0;u<e.length;u++){!0===this._settings.offset?r=s+a/2+u*a:(r=u==e.length-1?i.x:s+u*a,c=!!u),r=Math.ceil(r)-.5;var m="auto"!=this._settings.origin&&"bar"==this._settings.view&&parseFloat(this._settings.value(e[u]))<this._settings.origin;this._drawXAxisLabel(r,h,e[u],c,m),(this._settings.offset||u)&&this._settings.xAxis.lines.call(this,e[u])&&this._drawXAxisLine(t,r,i.y,n.y,e[u])}this.canvases.x.renderTextAt(!0,!1,s,i.y+this._settings.padding.bottom-3,this._settings.xAxis.title,"dhx_axis_title_x",i.x-n.x),this._drawLine(t,s,l,d,l,this._settings.xAxis.color,1),this._settings.xAxis.lines.call(this,{})&&this._settings.offset&&this._drawLine(t,d+.5,i.y,d+.5,n.y+.5,this._settings.xAxis.color,.2)},_drawYAxis:function(t,e,n,i,a,o){var r,s={};if(this._settings.yAxis){var l=n.x-.5,d=i.y,c=n.y,h=i.y;this._settings.yAxis.step&&(r=parseFloat(this._settings.yAxis.step)),void 0!==this._configYAxis.step&&void 0!==this._configYAxis.start&&void 0!==this._configYAxis.end||(a=(s=this._calculateScale(a,o)).start,o=s.end,r=s.step,this._settings.yAxis.end=o,this._settings.yAxis.start=a),this._setYAxisTitle(n,i),0===r&&(o=a,r=1);for(var u=o==a?d-c:(d-c)*r/(o-a),m=0,f=a;f<=o;f+=r){s.fixNum&&(f=parseFloat(new Number(f).toFixed(s.fixNum)));var p=Math.floor(d-m*u)+.5;f==a&&"auto"==this._settings.origin||!this._settings.yAxis.lines.call(this,f)||this._drawLine(t,l,p,i.x,p,this._settings.yAxis.lineColor.call(this,f),1),f==this._settings.origin&&(h=p);var _=f;if(r<1){var A=Math.min(this._log10(r),a<=0?0:this._log10(a)),b=Math.pow(10,-A);f=_=Math.round(f*b)/b}this.canvases.y.renderText(0,p-5,this._settings.yAxis.template(_.toString()),"dhx_axis_item_y",n.x-5),m++}return this._drawLine(t,l,d+1,l,c,this._settings.yAxis.color,1),h}},_setYAxisTitle:function(t,e){var n="dhx_axis_title_y"+(dhtmlx._isIE&&9!=dhtmlx._isIE?" dhx_ie_filter":""),i=this.canvases.y.renderTextAt("middle",!1,0,parseInt((e.y-t.y)/2+t.y,10),this._settings.yAxis.title,n);i&&(i.style.left=(dhtmlx.env.transform?(i.offsetHeight-i.offsetWidth)/2:0)+"px")},_calculateScale:function(t,e){var n,i,a;"auto"!=this._settings.origin&&this._settings.origin<t&&(t=this._settings.origin),n=(e-t)/8||1;var o=Math.floor(this._log10(n)),r=Math.pow(10,o),s=n/r;if(s=s>5?10:5,(n=parseInt(s,10)*r)>Math.abs(t))i=t<0?-n:0;else{var l=Math.abs(t),d=Math.floor(this._log10(l)),c=l/Math.pow(10,d);for(i=Math.ceil(10*c)/10*Math.pow(10,d)-n,l>1&&n>.1&&(i=Math.ceil(i));t<0?i<=t:i>=t;)i-=n;t<0&&(i=-i-2*n)}for(a=i;a<e;)a+=n,a=parseFloat(new Number(a).toFixed(Math.abs(o)));return{start:i,end:a,step:n,fixNum:Math.abs(o)}},_getLimits:function(t,e){var n,i,a=arguments.length&&"h"==t?this._configXAxis:this._configYAxis;if(e=e||"value",a&&void 0!==a.end&&void 0!==a.start&&a.step)n=parseFloat(a.end),i=parseFloat(a.start);else if(n=this.max(this._series[0][e]),i=a&&void 0!==a.start?parseFloat(a.start):this.min(this._series[0][e]),this._series.length>1)for(var o=1;o<this._series.length;o++){var r=this.max(this._series[o][e]),s=this.min(this._series[o][e]);r>n&&(n=r),s<i&&(i=s)}return{max:n,min:i}},_log10:function(t){return Math.floor(Math.log(t)/Math.LN10)},_drawXAxisLabel:function(t,e,n,i,a){if(this._settings.xAxis){var o=this.canvases.x.renderTextAt(a,i,t,e-(a?2:0),this._settings.xAxis.template(n));o&&(o.className+=" dhx_axis_item_x")}},_drawXAxisLine:function(t,e,n,i,a){this._settings.xAxis&&this._settings.xAxis.lines&&this._drawLine(t,e,n,e,i,this._settings.xAxis.lineColor.call(this,a),1)},_drawLine:function(t,e,n,i,a,o,r){t.strokeStyle=o,t.lineWidth=r,t.beginPath(),t.moveTo(e,n),t.lineTo(i,a),t.stroke(),t.lineWidth=1},_getRelativeValue:function(t,e){return[e!=t?e-t:t,1]},_rainbow:[function(t){return"#FF"+dhtmlx.math.toHex(t/2,2)+"00"},function(t){return"#FF"+dhtmlx.math.toHex(t/2+128,2)+"00"},function(t){return"#"+dhtmlx.math.toHex(255-t,2)+"FF00"},function(t){return"#00FF"+dhtmlx.math.toHex(t,2)},function(t){return"#00"+dhtmlx.math.toHex(255-t,2)+"FF"},function(t){return"#"+dhtmlx.math.toHex(t,2)+"00FF"}],addSeries:function(t){var e=this._settings;this._settings=dhtmlx.extend({},e),this._parseSettings(t,{}),this._series.push(this._settings),this._settings=e},_switchSerie:function(t,e,n){var i;if(this._active_serie=1==this._series.length?e.getAttribute("userdata"):this._getActiveSeries(n),this._series[this._active_serie]){for(var a=0;a<this._series.length;a++)(i=this._series[a].tooltip)&&i.disable();e.getAttribute("disabled")||(i=this._series[this._active_serie].tooltip)&&i.enable()}},_getActiveSeries:function(t){var e,n,i,a,o,r,s,l;for(n=this._map._areas,a=dhtmlx.html.offset(this._obj._htmlmap),s=(o=dhtmlx.html.pos(t)).x-a.x,l=o.y-a.y,i=0;i<n.length;i++)s<=(e=n[i].points)[2]&&s>=e[0]&&l<=e[3]&&l>=e[1]&&(r?n[i].index>r.index&&(r=n[i]):r=n[i]);return r?r.index:0},hideSeries:function(t){this.canvases[t].hideCanvas(),this._settings.legend.values&&this._settings.legend.values[t]&&(this._settings.legend.values[t].$hidden=!0),this._drawLegend()},showSeries:function(t){this.canvases[t].showCanvas(),this._settings.legend.values&&this._settings.legend.values[t]&&delete this._settings.legend.values[t].$hidden,this._drawLegend()},_changeColorSV:function(t,e,n){var i,a;return a=dhtmlx.math.toRgb(t),(i=dhtmlx.math.rgbToHsv(a[0],a[1],a[2]))[1]*=e,i[2]*=n,"rgb("+dhtmlx.math.hsvToRgb(i[0],i[1],i[2])+")"},_setBorderStyles:function(t,e){var n,i;i=dhtmlx.math.toRgb(e),(n=dhtmlx.math.rgbToHsv(i[0],i[1],i[2]))[2]/=2,e="rgb("+dhtmlx.math.hsvToRgb(n[0],n[1],n[2])+")",t.strokeStyle=e,1==t.globalAlpha&&(t.globalAlpha=.9)},_drawLegend:function(t,e){var n,i,a,o,r,s,l,d,c,h,u,m=0,f=0;if(t=t||[],e=e||this._obj.offsetWidth,d=this.canvases.legend.getCanvas(),i=this._settings.legend,l="x"!=this._settings.legend.layout?"width:"+i.width+"px":"",this.legendObj&&(this.legendObj.innerHTML="",this.legendObj.parentNode.removeChild(this.legendObj)),this.canvases.legend.clearCanvas(!0),a=dhtmlx.html.create("DIV",{class:"dhx_chart_legend",style:"left:"+m+"px; top:"+f+"px;"+l},""),i.padding&&(a.style.padding=i.padding+"px"),this.legendObj=a,this._obj.appendChild(a),r=[],i.values)for(n=0;n<i.values.length;n++)r.push(this._drawLegendText(a,i.values[n].text,void 0!==i.values[n].id?typeof i.values[n].id:n,i.values[n].$hidden));else for(n=0;n<t.length;n++)r.push(this._drawLegendText(a,i.template(t[n])));for(s=a.offsetWidth,o=a.offsetHeight,s<this._obj.offsetWidth&&("x"==i.layout&&"center"==i.align&&(m=(this._obj.offsetWidth-s)/2),"right"==i.align&&(m=this._obj.offsetWidth-s),i.margin&&"center"!=i.align&&(m+=("left"==i.align?1:-1)*i.margin)),o<this._obj.offsetHeight&&("middle"==i.valign&&"center"!=i.align&&"x"!=i.layout?f=(this._obj.offsetHeight-o)/2:"bottom"==i.valign&&(f=this._obj.offsetHeight-o),i.margin&&"middle"!=i.valign&&(f+=("top"==i.valign?1:-1)*i.margin)),a.style.left=m+"px",a.style.top=f+"px",d.save(),n=0;n<r.length;n++){u=r[n],i.values&&i.values[n].$hidden?(h=!0,c=i.values[n].disableColor?i.values[n].disableColor:"#d9d9d9"):(h=!1,c=i.values?i.values[n].color:this._settings.color.call(this,t[n]));var p="right"==i.marker.position?u.offsetWidth-i.marker.width:0;this._drawLegendMarker(d,u.offsetLeft+m+p,u.offsetTop+f,c,u.offsetHeight,h,n)}d.restore(),r=null},_drawLegendText:function(t,e,n,i){var a="",o=this._settings.legend;"x"==o.layout&&(a="float:left;");var r=o.marker.position,s=dhtmlx.html.create("DIV",{style:a+"padding-"+(r&&"right"==r?"right":"left")+":"+(10+o.marker.width)+"px",class:"dhx_chart_legend_item"+(i?" hidden":"")},e);return arguments.length>2&&s.setAttribute("series_id",n),t.appendChild(s),s},_drawLegendMarker:function(t,e,n,i,a,o,r){var s=[],l=this._settings.legend.marker,d=this._settings.legend.values,c=d&&d[r].markerType?d[r].markerType:l.type;if(i&&(t.fillStyle=i,t.strokeStyle=this._getDarkenColor(i,.75)),t.beginPath(),"round"!=c&&l.radius)if("item"==c){if(this._settings.line&&"scatter"!=this._settings.view&&!this._settings.disableLines){t.beginPath(),t.lineWidth=this._series[r].line.width,t.strokeStyle=o?i:this._series[r].line.color.call(this,{});var h=e+5,u=n+a/2;t.moveTo(h,u);p=h+l.width;t.lineTo(p,u),t.stroke()}var m=this._series[r].item,f=parseInt(m.radius.call(this,{}),10)||0;if(f){if("image"==m.type&&m.src)return void this._drawImage(t,e+5,n+l.height/2-5,m.src,2*f,2*f);t.beginPath(),o?(t.lineWidth=m.borderWidth,t.strokeStyle=i,t.fillStyle=i):(t.lineWidth=m.borderWidth,t.fillStyle=m.color.call(this,{}),t.strokeStyle=m.borderColor.call(this,{}),t.globalAlpha=m.alpha.call(this,{})),t.beginPath(),e+=l.width/2+5,n+=a/2,this._strokeChartItem(t,e,n,f+1,m.type),t.fill(),t.stroke()}t.globalAlpha=1}else t.lineWidth=1,e+=5,n+=parseInt(a/2-l.height/2,10),s=[[e+l.radius,n+l.radius,l.radius,Math.PI,3*Math.PI/2,!1],[e+l.width-l.radius,n],[e+l.width-l.radius,n+l.radius,l.radius,-Math.PI/2,0,!1],[e+l.width,n+l.height-l.radius],[e+l.width-l.radius,n+l.height-l.radius,l.radius,0,Math.PI/2,!1],[e+l.radius,n+l.height],[e+l.radius,n+l.height-l.radius,l.radius,Math.PI/2,Math.PI,!1],[e,n+l.radius]],this._path(t,s);else{t.lineWidth=l.height,t.lineCap=c,e+=t.lineWidth/2+5,n+=a/2,t.moveTo(e,n);var p=e+l.width-l.height+1;t.lineTo(p,n)}t.stroke(),t.fill()},_getDarkenColor:function(t,e){var n,i;return i=dhtmlx.math.toRgb(t),(n=dhtmlx.math.rgbToHsv(i[0],i[1],i[2]))[2]=n[2]*e,"rgb("+dhtmlx.math.hsvToRgb(n[0],n[1],n[2])+")"},_getChartBounds:function(t,e){var n,i,a,o;if(n=this._settings.padding.left,i=this._settings.padding.top,a=t-this._settings.padding.right,o=e-this._settings.padding.bottom,this._settings.legend){var r=this._settings.legend,s=this._settings.legend.width,l=this._settings.legend.height;"x"==r.layout?"center"==r.valign?"right"==r.align?a-=s:"left"==r.align&&(n+=s):"bottom"==r.valign?o-=l:i+=l:"right"==r.align?a-=s:"left"==r.align&&(n+=s)}return{start:{x:n,y:i},end:{x:a,y:o}}},_getStackedLimits:function(t){var e,n,i,a,o;if(this._settings.yAxis&&void 0!==this._settings.yAxis.end&&void 0!==this._settings.yAxis.start&&this._settings.yAxis.step)i=parseFloat(this._settings.yAxis.end),a=parseFloat(this._settings.yAxis.start);else{for(e=0;e<t.length;e++)for(t[e].$sum=0,t[e].$min=1/0,n=0;n<this._series.length;n++)o=parseFloat(this._series[n].value(t[e])||0),isNaN(o)||(-1!=this._series[n].view.toLowerCase().indexOf("stacked")&&(t[e].$sum+=o),o<t[e].$min&&(t[e].$min=o));for(i=-1/0,a=1/0,e=0;e<t.length;e++)t[e].$sum>i&&(i=t[e].$sum),t[e].$min<a&&(a=t[e].$min);a>0&&(a=0)}return{max:i,min:a}},_setBarGradient:function(t,e,n,i,a,o,r,s){var l,d,c,h,u,m;return"light"==o?(l="x"==s?t.createLinearGradient(e,n,i,n):t.createLinearGradient(e,n,e,a),m=[[0,"#FFFFFF"],[.9,r],[1,r]],d=2):"falling"==o||"rising"==o?(l="x"==s?t.createLinearGradient(e,n,i,n):t.createLinearGradient(e,n,e,a),c=dhtmlx.math.toRgb(r),(h=dhtmlx.math.rgbToHsv(c[0],c[1],c[2]))[1]*=.5,u="rgb("+dhtmlx.math.hsvToRgb(h[0],h[1],h[2])+")","falling"==o?m=[[0,u],[.7,r],[1,r]]:"rising"==o&&(m=[[0,r],[.3,r],[1,u]]),d=0):(t.globalAlpha=.37,d=0,l="x"==s?t.createLinearGradient(e,a,e,n):t.createLinearGradient(e,n,i,n),m=[[0,"#9d9d9d"],[.3,"#e8e8e8"],[.45,"#ffffff"],[.55,"#ffffff"],[.7,"#e8e8e8"],[1,"#9d9d9d"]]),this._gradient(l,m),{gradient:l,offset:d}},_getPositionByAngle:function(t,e,n,i){return t*=-1,{x:e+=Math.cos(t)*i,y:n-=Math.sin(t)*i}},_gradient:function(t,e){for(var n=0;n<e.length;n++)t.addColorStop(e[n][0],e[n][1])},_path:function(t,e){var n,i;for(n=0;n<e.length;n++)i=n?"lineTo":"moveTo",e[n].length>2&&(i="arc"),t[i].apply(t,e[n])},_circle:function(t,e,n,i){t.arc(e,n,i,2*Math.PI,!0)},_addMapRect:function(t,e,n,i,a){t.addRect(e,[n[0].x-i.x,n[0].y-i.y,n[1].x-i.x,n[1].y-i.y],a)}},dhtmlx.compat("layout"),void 0!==window.dhtmlXCellObject&&(dhtmlXCellObject.prototype.attachChart=function(t){this.callEvent("_onBeforeContentAttach",["chart"]);var e=document.createElement("DIV");return e.id="dhxChartObj_"+window.dhx4.newId(),e.style.width="100%",e.style.height="100%",document.body.appendChild(e),this._attachObject(e),t.container=e.id,this.dataType="chart",this.dataObj=new dhtmlXChart(t),this.dataObj.setSizes||(this.dataObj.setSizes=function(){this.resize?this.resize():this.render()}),this.dataObj}),dhtmlx.ui.pager=function(t){this.name="Pager",dhtmlx.assert_enabled()&&this._assert(),dhtmlx.extend(this,dhtmlx.Settings),this._parseContainer(t,"dhx_pager"),dhtmlx.extend(this,dhtmlx.EventSystem),dhtmlx.extend(this,dhtmlx.SingleRender),dhtmlx.extend(this,dhtmlx.MouseEvents),this._parseSettings(t,{size:10,page:-1,group:5,count:0,type:"default"}),this.data=this._settings,this.refresh()},dhtmlx.ui.pager.prototype={_id:"dhx_p_id",on_click:{dhx_pager_item:function(t,e){this.select(e)}},select:function(t){switch(t){case"next":t=this._settings.page+1;break;case"prev":t=this._settings.page-1;break;case"first":t=0;break;case"last":t=this._settings.limit-1}t<0&&(t=0),t>=this.data.limit&&(t=this.data.limit-1),this.callEvent("onBeforePageChange",[this._settings.page,t])&&(this.data.page=1*t,this.refresh(),this.callEvent("onAfterPageChange",[t]))},types:{default:{template:dhtmlx.Template.fromHTML("{common.pages()}"),pages:function(t){var e="";if(-1==t.page)return"";t.min=t.page-Math.round((t.group-1)/2),t.max=t.min+t.group-1,t.min<0&&(t.max+=-1*t.min,t.min=0),t.max>=t.limit&&(t.min-=Math.min(t.min,t.max-t.limit+1),t.max=t.limit-1);for(var n=t.min||0;n<=t.max;n++)e+=this.button({id:n,index:n+1,selected:n==t.page?"_selected":""});return e},page:function(t){return t.page+1},first:function(){return this.button({id:"first",index:" &lt;&lt; ",selected:""})},last:function(){return this.button({id:"last",index:" &gt;&gt; ",selected:""})},prev:function(){return this.button({id:"prev",index:"&lt;",selected:""})},next:function(){return this.button({id:"next",index:"&gt;",selected:""})},button:dhtmlx.Template.fromHTML("<div dhx_p_id='{obj.id}' class='dhx_pager_item{obj.selected}'>{obj.index}</div>")}},refresh:function(){var t=this._settings;t.limit=Math.ceil(t.count/t.size),t.limit&&t.limit!=t.old_limit&&(t.page=Math.min(t.limit-1,t.page));var e=t.page;(-1!=e&&e!=t.old_page||t.limit!=t.old_limit)&&(this.render(),this.callEvent("onRefresh",[]),t.old_limit=t.limit,t.old_page=t.page)},template_item_start:dhtmlx.Template.fromHTML("<div>"),template_item_end:dhtmlx.Template.fromHTML("</div>")},dhtmlx.DataProcessor={_dp_init:function(t){var e="_methods";t[e]=["setItemStyle","","changeId","remove"],this.attachEvent("onAfterAdd",function(e){t.setUpdated(e,!0,"inserted")}),this.data.attachEvent("onStoreLoad",dhtmlx.bind(function(t,e){t.getUserData&&t.getUserData(e,this._userdata)},this)),this.attachEvent("onBeforeDelete",function(e){if(t._silent_mode)return!0;var n=t.getState(e);return"inserted"==n?(t.setUpdated(e,!1),!0):"deleted"!=n&&("true_deleted"==n||(t.setUpdated(e,!0,"deleted"),!1))}),this.attachEvent("onAfterEditStop",function(e){t.setUpdated(e,!0,"updated")}),this.attachEvent("onBindUpdate",function(e){window.setTimeout(function(){t.setUpdated(e.id,!0,"updated")},1)}),t[e="_getRowData"]=function(t,e){var n=this.obj.data.get(t),i={};for(var a in n)0!==a.indexOf("_")&&(i[a]=n[a]);return i},t[e="_clearUpdateFlag"]=function(){},this._userdata={},t.attachEvent("insertCallback",this._dp_callback),t.attachEvent("updateCallback",this._dp_callback),t.attachEvent("deleteCallback",function(t,e){this.obj.setUserData(e,this.action_param,"true_deleted"),this.obj.remove(e)}),dhtmlx.compat("dataProcessor",t)},_dp_callback:function(t,e){this.obj.data.set(e,dhtmlx.DataDriver.xml.getDetails(t.firstChild)),this.obj.data.refresh(e)},setItemStyle:function(t,e){var n=this._locateHTML(t);n&&(n.style.cssText+=";"+e)},changeId:function(t,e){this.data.changeId(t,e),this.refresh()},setUserData:function(t,e,n){t?this.data.get(t)[e]=n:this._userdata[e]=n},getUserData:function(t,e){return t?this.data.get(t)[e]:this._userdata[e]}},dhtmlx.DataProcessor._dp_init=dhtmlx.DataProcessor._dp_init,dhtmlx.compat.dnd=function(){if(window.dhtmlDragAndDropObject){var t="_dragged",e=dhtmlDragAndDropObject.prototype.checkLanding;dhtmlDragAndDropObject.prototype.checkLanding=function(t,n,i){if(e.apply(this,arguments),!i){var a=dhtmlx.DragControl._drag_context=dhtmlx.DragControl._drag_context||{};a.from||(a.from=this.dragStartObject),dhtmlx.DragControl._checkLand(t,n,!0)}};var n=dhtmlDragAndDropObject.prototype.stopDrag;dhtmlDragAndDropObject.prototype.stopDrag=function(t,e,a){a||dhtmlx.DragControl._last&&(dhtmlx.DragControl._active=i.dragStartNode,dhtmlx.DragControl._stopDrag(t,!0)),n.apply(this,arguments)};var i=new dhtmlDragAndDropObject,a=dhtmlx.DragControl._startDrag;dhtmlx.DragControl._startDrag=function(){a.apply(this,arguments);var e=dhtmlx.DragControl._drag_context;if(e){for(var n=[],o=[],r=0;r<e.source.length;r++)n[r]={idd:e.source[r]},o.push(e.source[r]);i.dragStartNode={parentNode:{},parentObject:{idd:n,id:1==o.length?o[0]:o,treeNod:{object:e.from}}},i.dragStartNode.parentObject.treeNod[t]=n,i.dragStartObject=e.from}};var o=dhtmlx.DragControl._checkLand;dhtmlx.DragControl._checkLand=function(t,e,n){o.apply(this,arguments),this._last||n||(t=i.checkLanding(t,e,!0))};var r=dhtmlx.DragControl._stopDrag;dhtmlx.DragControl._stopDrag=function(t,e){r.apply(this,arguments),i.lastLanding&&!e&&i.stopDrag(t,!1,!0)};var s=dhtmlx.DragControl.getMaster;dhtmlx.DragControl.getMaster=function(e){var n=null;if(e&&(n=s.apply(this,arguments)),!n){for(var a=[],o=(n=i.dragStartObject)[t],r=0;r<o.length;r++)a.push(o[r].idd||o[r].id);dhtmlx.DragControl._drag_context.source=a}return n}}},dhtmlx.DataMove={_init:function(){dhtmlx.assert(this.data,"DataMove :: Component doesn't have DataStore")},copy:function(t,e,n,i){var a=this.get(t);if(a)return n&&(dhtmlx.assert(n.externalData,"DataMove :: External object doesn't support operation"),a=n.externalData(a)),(n=n||this).add(n.externalData(a,i),e);dhtmlx.log("Warning","Incorrect ID in DataMove::copy")},move:function(t,e,n,i){if(t instanceof Array)for(var a=0;a<t.length;a++){var o=(n||this).indexById(this.move(t[a],e,n,t[a]));t[a+1]&&(e=o+(this.indexById(t[a+1])<o?0:1))}else if(nid=t,e<0)dhtmlx.log("Info","DataMove::move - moving outside of bounds is ignored");else{var r=this.get(t);if(r)return n&&n!=this?(dhtmlx.assert(n.externalData,"DataMove :: External object doesn't support operation"),nid=n.add(n.externalData(r,i),e),this.remove(t)):this.data.move(this.indexById(t),e),nid;dhtmlx.log("Warning","Incorrect ID in DataMove::move")}},moveUp:function(t,e){return this.move(t,this.indexById(t)-(e||1))},moveDown:function(t,e){return this.moveUp(t,-1*(e||1))},moveTop:function(t){return this.move(t,0)},moveBottom:function(t){return this.move(t,this.data.dataCount()-1)},externalData:function(t,e){var n=dhtmlx.extend({},t);return n.id=e||dhtmlx.uid(),n.$selected=n.$template=null,n}},dhtmlx.DragControl={_drag_masters:dhtmlx.toArray(["dummy"]),addDrop:function(t,e,n){(t=dhtmlx.toNode(t)).dhx_drop=this._getCtrl(e),n&&(t.dhx_master=!0)},_getCtrl:function(t){t=t||dhtmlx.DragControl;var e=this._drag_masters.find(t);return e<0&&(e=this._drag_masters.length,this._drag_masters.push(t)),e},addDrag:function(t,e){(t=dhtmlx.toNode(t)).dhx_drag=this._getCtrl(e),dhtmlx.event(t,"mousedown",this._preStart,t)},_preStart:function(t){return dhtmlx.DragControl._active&&(dhtmlx.DragControl._preStartFalse(),dhtmlx.DragControl.destroyDrag()),dhtmlx.DragControl._active=this,dhtmlx.DragControl._start_pos={x:t.pageX,y:t.pageY},dhtmlx.DragControl._dhx_drag_mm=dhtmlx.event(document.body,"mousemove",dhtmlx.DragControl._startDrag),dhtmlx.DragControl._dhx_drag_mu=dhtmlx.event(document.body,"mouseup",dhtmlx.DragControl._preStartFalse),dhtmlx.DragControl._dhx_drag_sc=dhtmlx.event(this,"scroll",dhtmlx.DragControl._preStartFalse),t.cancelBubble=!0,!1},_preStartFalse:function(t){dhtmlx.DragControl._dhx_drag_mm=dhtmlx.eventRemove(dhtmlx.DragControl._dhx_drag_mm),dhtmlx.DragControl._dhx_drag_mu=dhtmlx.eventRemove(dhtmlx.DragControl._dhx_drag_mu),dhtmlx.DragControl._dhx_drag_sc=dhtmlx.eventRemove(dhtmlx.DragControl._dhx_drag_sc)},_startDrag:function(t){var e=t.pageX,n=t.pageY;Math.abs(e-dhtmlx.DragControl._start_pos.x)<5&&Math.abs(n-dhtmlx.DragControl._start_pos.y)<5||(dhtmlx.DragControl._preStartFalse(),dhtmlx.DragControl.createDrag(t)&&(dhtmlx.DragControl.sendSignal("start"),dhtmlx.DragControl._dhx_drag_mm=dhtmlx.event(document.body,"mousemove",dhtmlx.DragControl._moveDrag),dhtmlx.DragControl._dhx_drag_mu=dhtmlx.event(document.body,"mouseup",dhtmlx.DragControl._stopDrag),dhtmlx.DragControl._moveDrag(t)))},_stopDrag:function(t){dhtmlx.DragControl._dhx_drag_mm=dhtmlx.eventRemove(dhtmlx.DragControl._dhx_drag_mm),dhtmlx.DragControl._dhx_drag_mu=dhtmlx.eventRemove(dhtmlx.DragControl._dhx_drag_mu),dhtmlx.DragControl._last&&(dhtmlx.DragControl.onDrop(dhtmlx.DragControl._active,dhtmlx.DragControl._last,this._landing,t),dhtmlx.DragControl.onDragOut(dhtmlx.DragControl._active,dhtmlx.DragControl._last,null,t)),dhtmlx.DragControl.destroyDrag(),dhtmlx.DragControl.sendSignal("stop")},_moveDrag:function(t){var e=dhtmlx.html.pos(t);return dhtmlx.DragControl._html.style.top=e.y+dhtmlx.DragControl.top+"px",dhtmlx.DragControl._html.style.left=e.x+dhtmlx.DragControl.left+"px",dhtmlx.DragControl._skip?dhtmlx.DragControl._skip=!1:dhtmlx.DragControl._checkLand(t.srcElement||t.target,t),t.cancelBubble=!0,!1},_checkLand:function(t,e){for(;t&&"BODY"!=t.tagName;){if(t.dhx_drop)return this._last&&(this._last!=t||t.dhx_master)&&this.onDragOut(this._active,this._last,t,e),!this._last||this._last!=t||t.dhx_master?(this._last=null,this._landing=this.onDragIn(dhtmlx.DragControl._active,t,e),void(this._landing&&(this._last=t))):void 0;t=t.parentNode}this._last&&(this._last=this._landing=this.onDragOut(this._active,this._last,null,e))},sendSignal:function(t){dhtmlx.DragControl.active="start"==t},getMaster:function(t){return this._drag_masters[t.dhx_drag||t.dhx_drop]},getContext:function(t){return this._drag_context},createDrag:function(t){var e=dhtmlx.DragControl._active,n=this._drag_masters[e.dhx_drag];if(n.onDragCreate)(i=n.onDragCreate(e,t)).style.position="absolute",i.style.zIndex=dhtmlx.zIndex.drag,i.onmousemove=dhtmlx.DragControl._skip_mark;else{var i,a=dhtmlx.DragControl.onDrag(e,t);if(!a)return!1;(i=document.createElement("DIV")).innerHTML=a,i.className="dhx_drag_zone",i.onmousemove=dhtmlx.DragControl._skip_mark,document.body.appendChild(i)}return dhtmlx.DragControl._html=i,!0},_skip_mark:function(){dhtmlx.DragControl._skip=!0},destroyDrag:function(){var t=dhtmlx.DragControl._active,e=this._drag_masters[t.dhx_drag];e&&e.onDragDestroy?e.onDragDestroy(t,dhtmlx.DragControl._html):dhtmlx.html.remove(dhtmlx.DragControl._html),dhtmlx.DragControl._landing=dhtmlx.DragControl._active=dhtmlx.DragControl._last=dhtmlx.DragControl._html=null},top:5,left:5,onDragIn:function(t,e,n){var i=this._drag_masters[e.dhx_drop];return i.onDragIn&&i!=this?i.onDragIn(t,e,n):(e.className=e.className+" dhx_drop_zone",e)},onDragOut:function(t,e,n,i){var a=this._drag_masters[e.dhx_drop];return a.onDragOut&&a!=this?a.onDragOut(t,e,n,i):(e.className=e.className.replace("dhx_drop_zone",""),null)},onDrop:function(t,e,n,i){var a=this._drag_masters[e.dhx_drop];if(dhtmlx.DragControl._drag_context.from=dhtmlx.DragControl.getMaster(t),a.onDrop&&a!=this)return a.onDrop(t,e,n,i);e.appendChild(t)},onDrag:function(t,e){var n=this._drag_masters[t.dhx_drag];return n.onDrag&&n!=this?n.onDrag(t,e):(dhtmlx.DragControl._drag_context={source:t,from:t},"<div style='"+t.style.cssText+"'>"+t.innerHTML+"</div>")}},dhtmlx.DragItem={_init:function(){dhtmlx.assert(this.move,"DragItem :: Component doesn't have DataMove interface"),dhtmlx.assert(this.locate,"DragItem :: Component doesn't have RenderStack interface"),dhtmlx.assert(dhtmlx.DragControl,"DragItem :: DragControl is not included"),!this._settings||this._settings.drag?dhtmlx.DragItem._initHandlers(this):this._settings&&(this.drag_setter=function(t){return t&&(this._initHandlers(this),delete this.drag_setter),t}),this.dragMarker&&(this.attachEvent("onBeforeDragIn",this.dragMarker),this.attachEvent("onDragOut",this.dragMarker))},_initHandlers:function(t){dhtmlx.DragControl.addDrop(t._obj,t,!0),dhtmlx.DragControl.addDrag(t._obj,t)},onDragIn:function(t,e,n){var i=this.locate(n)||null,a=dhtmlx.DragControl._drag_context,o=dhtmlx.DragControl.getMaster(t),r=this._locateHTML(i)||this._obj;return r==dhtmlx.DragControl._landing?r:(a.target=i,a.to=o,this.callEvent("onBeforeDragIn",[a,n])?(dhtmlx.html.addCss(r,"dhx_drag_over"),r):(a.id=null,null))},onDragOut:function(t,e,n,i){var a=this.locate(i)||null;if(n!=this._dataobj&&(a=null),(this._locateHTML(a)||(n?dhtmlx.DragControl.getMaster(n)._obj:window.undefined))==dhtmlx.DragControl._landing)return null;var o=dhtmlx.DragControl._drag_context;return dhtmlx.html.removeCss(dhtmlx.DragControl._landing,"dhx_drag_over"),o.target=o.to=null,this.callEvent("onDragOut",[o,i]),null},onDrop:function(t,e,n,i){var a=dhtmlx.DragControl._drag_context;a.to=this,a.index=a.target?this.indexById(a.target):this.dataCount(),a.new_id=dhtmlx.uid(),this.callEvent("onBeforeDrop",[a,i])&&(a.from==a.to?this.move(a.source,a.index):a.from?a.from.move(a.source,a.index,a.to,a.new_id):dhtmlx.error("Unsopported d-n-d combination"),this.callEvent("onAfterDrop",[a,i]))},onDrag:function(t,e){var n=this.locate(e),i=[n];if(n){if(this.getSelected){var a=this.getSelected();-1!=dhtmlx.PowerArray.find.call(a,n)&&(i=a)}var o=dhtmlx.DragControl._drag_context={source:i,start:n};if(o.from=this,this.callEvent("onBeforeDrag",[o,e]))return o.html||this._toHTML(this.get(n))}return null}},dhtmlx.EditAbility={_init:function(t){this._edit_id=null,this._edit_bind=null,dhtmlx.assert(this.data,"EditAbility :: Component doesn't have DataStore"),dhtmlx.assert(this._locateHTML,"EditAbility :: Component doesn't have RenderStack"),this.attachEvent("onEditKeyPress",function(t,e,n){13!=t||n?27==t&&this.stopEdit(!0):this.stopEdit()}),this.attachEvent("onBeforeRender",function(){this.stopEdit()})},isEdit:function(){return this._edit_id},edit:function(t){if(this.stopEdit(!1,t)){if(!this.callEvent("onBeforeEditStart",[t]))return;var e=this.data.get(t);if(e.$template)return;e.$template="edit",this.data.refresh(t),this._edit_id=t,this._save_binding(t),this._edit_bind(!0,e),this.callEvent("onAfterEditStart",[t])}},stopEdit:function(t,e){if(!this._edit_id)return!0;if(this._edit_id==e)return!1;var n={};if(t?n=null:this._edit_bind(!1,n),!this.callEvent("onBeforeEditStop",[this._edit_id,n]))return!1;var i=this.data.get(this._edit_id);i.$template=null,t||this._edit_bind(!1,i);var a=this._edit_id;return this._edit_bind=this._edit_id=null,this.data.refresh(a),this.callEvent("onAfterEditStop",[a,n]),!0},_save_binding:function(t){var e=this._locateHTML(t),n="",i="",a=[];if(e){for(var o=e.getElementsByTagName("*"),r="",s=0;s<o.length;s++)1==o[s].nodeType&&(r=o[s].getAttribute("bind"))&&(n+="els["+a.length+"].value="+r+";",i+=r+"=els["+a.length+"].value;",a.push(o[s]),o[s].className+=" dhx_allow_selection",o[s].onselectstart=this._block_native);o=null}n=Function("obj","els",n),i=Function("obj","els",i),this._edit_bind=function(t,e){t?(n(e,a),a.length&&a[0].select&&a[0].select()):i(e,a)}},_block_native:function(t){return(t||event).cancelBubble=!0,!0}},dhtmlx.SelectionModel={_init:function(){this._selected=dhtmlx.toArray(),dhtmlx.assert(this.data,"SelectionModel :: Component doesn't have DataStore"),this.data.attachEvent("onStoreUpdated",dhtmlx.bind(this._data_updated,this)),this.data.attachEvent("onStoreLoad",dhtmlx.bind(this._data_loaded,this)),this.data.attachEvent("onAfterFilter",dhtmlx.bind(this._data_filtered,this)),this.data.attachEvent("onIdChange",dhtmlx.bind(this._id_changed,this))},_id_changed:function(t,e){for(var n=this._selected.length-1;n>=0;n--)this._selected[n]==t&&(this._selected[n]=e)},_data_filtered:function(){for(var t=this._selected.length-1;t>=0;t--)if(this.data.indexById(this._selected[t])<0){var e=this._selected[t],n=this.item(e);n&&delete n.$selected,this._selected.splice(t,1),this.callEvent("onSelectChange",[e])}},_data_updated:function(t,e,n){"delete"==n?this._selected.remove(t):this.data.dataCount()||this.data._filter_order||(this._selected=dhtmlx.toArray())},_data_loaded:function(){this._settings.select&&this.data.each(function(t){t.$selected&&this.select(t.id)},this)},_select_mark:function(t,e,n){return!(!n&&!this.callEvent("onBeforeSelect",[t,e]))&&(this.data.item(t).$selected=e,n?n.push(t):(e?this._selected.push(t):this._selected.remove(t),this._refresh_selection(t)),!0)},select:function(t,e,n){if(!t)return this.selectAll();if(t instanceof Array)for(var i=0;i<t.length;i++)this.select(t[i],e,n);else if(this.data.exists(t)){if(n&&this._selected.length)return this.selectAll(this._selected[this._selected.length-1],t);e||1==this._selected.length&&this._selected[0]==t||(this._silent_selection=!0,this.unselectAll(),this._silent_selection=!1),this.isSelected(t)?e&&this.unselect(t):this._select_mark(t,!0)&&this.callEvent("onAfterSelect",[t])}else dhtmlx.error("Incorrect id in select command: "+t)},unselect:function(t){if(!t)return this.unselectAll();this.isSelected(t)&&this._select_mark(t,!1)},selectAll:function(t,e){var n=[];(t||e?this.data.getRange(t||null,e||null):this.data.getRange()).each(function(t){return this.data.item(t.id).$selected||(this._selected.push(t.id),this._select_mark(t.id,!0,n)),t.id},this),this._refresh_selection(n)},unselectAll:function(){var t=[];this._selected.each(function(e){this._select_mark(e,!1,t)},this),this._selected=dhtmlx.toArray(),this._refresh_selection(t)},isSelected:function(t){return-1!=this._selected.find(t)},getSelected:function(t){switch(this._selected.length){case 0:return t?[]:"";case 1:return t?[this._selected[0]]:this._selected[0];default:return[].concat(this._selected)}},_is_mass_selection:function(t){return t.length>100||t.length>this.data.dataCount/2},_refresh_selection:function(t){if("object"!=typeof t&&(t=[t]),t.length){if(this._is_mass_selection(t))this.data.refresh();else for(var e=0;e<t.length;e++)this.render(t[e],this.data.item(t[e]),"update");this._silent_selection||this.callEvent("onSelectChange",[t])}}},dhtmlx.RenderStack={_init:function(){dhtmlx.assert(this.data,"RenderStack :: Component doesn't have DataStore"),dhtmlx.assert(dhtmlx.Template,"dhtmlx.Template :: dhtmlx.Template is not accessible"),this._html=document.createElement("DIV")},_toHTML:function(t){return dhtmlx.assert(!t.$template||this.type["template_"+t.$template],"RenderStack :: Unknown template: "+t.$template),this.callEvent("onItemRender",[t]),this.type._item_start(t,this.type)+(t.$template?this.type["template_"+t.$template]:this.type.template)(t,this.type)+this.type._item_end},_toHTMLObject:function(t){return this._html.innerHTML=this._toHTML(t),this._html.firstChild},_locateHTML:function(t){if(this._htmlmap)return this._htmlmap[t];this._htmlmap={};for(var e=this._dataobj.childNodes,n=0;n<e.length;n++){var i=e[n].getAttribute(this._id);i&&(this._htmlmap[i]=e[n])}return this._locateHTML(t)},locate:function(t){return dhtmlx.html.locate(t,this._id)},show:function(t){var e=this._locateHTML(t);e&&(this._dataobj.scrollTop=e.offsetTop-this._dataobj.offsetTop)},render:function(t,e,n,i){if(t){var a=this._locateHTML(t);switch(n){case"update":if(!a)return;var o=this._htmlmap[t]=this._toHTMLObject(e);dhtmlx.html.insertBefore(o,a),dhtmlx.html.remove(a);break;case"delete":if(!a)return;dhtmlx.html.remove(a),delete this._htmlmap[t];break;case"add":o=this._htmlmap[t]=this._toHTMLObject(e);dhtmlx.html.insertBefore(o,this._locateHTML(this.data.next(t)),this._dataobj);break;case"move":this.render(t,e,"delete"),this.render(t,e,"add");break;default:dhtmlx.error("Unknown render command: "+n)}}else this.callEvent("onBeforeRender",[this.data])&&(this._dataobj.innerHTML=this.data.getRange().map(this._toHTML,this).join(""),this._htmlmap=null);this.callEvent("onAfterRender",[])},pager_setter:function(t){this.attachEvent("onBeforeRender",function(){var t=this._settings.pager._settings;return-1!=t.page&&(this.data.min=t.page*t.size,this.data.max=(t.page+1)*t.size-1,!0)});var e=new dhtmlx.ui.pager(t),n=dhtmlx.bind(function(){this.data.refresh()},this);return e.attachEvent("onRefresh",n),this.data.attachEvent("onStoreUpdated",function(t){var n=this.dataCount();n!=e._settings.count&&(e._settings.count=n,-1==e._settings.page&&(e._settings.page=0),e.refresh())}),e},height_setter:function(t){return"auto"==t&&(this.attachEvent("onAfterRender",this._correct_height),dhtmlx.event(window,"resize",dhtmlx.bind(this._correct_height,this))),t},_correct_height:function(){this._dataobj.style.overflow="hidden",this._dataobj.style.height="1px";var t=this._dataobj.scrollHeight;if(this._dataobj.style.height=t+"px",dhtmlx._isFF){var e=this._dataobj.scrollHeight;e!=t&&(this._dataobj.style.height=e+"px")}this._obj.style.height=this._dataobj.style.height},_getDimension:function(){var t=this.type,e=(t.border||0)+2*(t.padding||0)+2*(t.margin||0);return{x:t.width+e,y:t.height+e}},x_count_setter:function(t){var e=this._getDimension(),n=dhtmlx.$customScroll?0:18;return this._dataobj.style.width=e.x*t+("auto"!=this._settings.height?n:0)+"px",t},y_count_setter:function(t){var e=this._getDimension();return this._dataobj.style.height=e.y*t+"px",t}},dhtmlx.VirtualRenderStack={_init:function(){dhtmlx.assert(this.render,"VirtualRenderStack :: Object must use RenderStack first"),this._htmlmap={},this._dataobj.style.overflowY="scroll",dhtmlx.event(this._dataobj,"scroll",dhtmlx.bind(this._render_visible_rows,this)),dhtmlx.event(window,"resize",dhtmlx.bind(function(){this.render()},this)),this.data._unrendered_area=[],this.data.getIndexRange=this._getIndexRange},_locateHTML:function(t){return this._htmlmap[t]},show:function(t){range=this._getVisibleRange();var e=this.data.indexById(t),n=Math.floor(e/range._dx)*range._y;this._dataobj.scrollTop=n},_getIndexRange:function(t,e){0!==e&&(e=Math.min(e||1/0,this.dataCount()-1));for(var n=dhtmlx.toArray(),i=t||0;i<=e;i++){var a=this.item(this.order[i]);this.order.length>i&&(a?"loading"==a.$template&&this._unrendered_area.push(this.order[i]):(this.order[i]=dhtmlx.uid(),a={id:this.order[i],$template:"loading"},this._unrendered_area.push(this.order[i])),n.push(a))}return n},render:function(t,e,n,i){if(t){var a=this._locateHTML(t);switch(n){case"update":if(!a)return;var o=this._htmlmap[t]=this._toHTMLObject(e);dhtmlx.html.insertBefore(o,a),dhtmlx.html.remove(a);break;default:this._render_delayed()}}else this.callEvent("onBeforeRender",[this.data])&&(this._htmlmap={},this._render_visible_rows(null,!0),this._wait_for_render=!1,this.callEvent("onAfterRender",[]))},_render_delayed:function(){this._wait_for_render||(this._wait_for_render=!0,window.setTimeout(dhtmlx.bind(function(){this.render()},this),1))},_create_placeholder:function(t){var e=document.createElement("DIV");return e.className="dhxdataview_placeholder",e.style.cssText="height:"+t+"px; width:100%; overflow:hidden;",e},_render_visible_rows:function(t,e){this.data._unrendered_area=[];var n=this._getVisibleRange();this._dataobj.firstChild&&!e||(this._dataobj.innerHTML="",this._dataobj.appendChild(this._create_placeholder(n._max)),this._htmlrows=[this._dataobj.firstChild]);for(var i=Math.max(n._from,0),a=this.data.max||0===this.data.max?this.data.max:1/0;i<=n._height;){for(;this._htmlrows[i]&&this._htmlrows[i]._filled&&i<=n._height;)i++;if(i>n._height)break;for(var o=i;!this._htmlrows[o];)o--;var r=this._htmlrows[o],s=i*n._dx+(this.data.min||0);if(s>a)break;var l=Math.min(s+n._dx-1,a),d=this._create_placeholder(n._y),c=this.data.getIndexRange(s,l);if(!c.length)break;d.innerHTML=c.map(this._toHTML,this).join("");for(var h=0;h<c.length;h++)this._htmlmap[this.data.idByIndex(s+h)]=d.childNodes[h];var u=parseInt(r.style.height,10),m=(i-o)*n._y,f=u-m-n._y;if(dhtmlx.html.insertBefore(d,m?r.nextSibling:r,this._dataobj),this._htmlrows[i]=d,d._filled=!0,m<=0&&f>0)r.style.height=f+"px",this._htmlrows[i+1]=r;else if(m<0?dhtmlx.html.remove(r):r.style.height=m+"px",f>0){var p=this._htmlrows[i+1]=this._create_placeholder(f);dhtmlx.html.insertBefore(p,d.nextSibling,this._dataobj)}i++}if(this.data._unrendered_area.length){var _=this.indexById(this.data._unrendered_area[0]),A=this.indexById(this.data._unrendered_area.pop())+1;if(A>_){if(!this.callEvent("onDataRequest",[_,A-_]))return!1;dhtmlx.assert(this.data.feed,"Data feed is missed"),this.data.feed.call(this,_,A-_)}}dhtmlx._isIE&&(this._getVisibleRange()._from!=n._from&&this._render_visible_rows())},_getVisibleRange:function(){dhtmlx.$customScroll;var t=this._dataobj.scrollTop,e=this._dataobj.scrollWidth,n=this._dataobj.offsetHeight,i=(this.type,this._getDimension()),a=Math.floor(e/i.x)||1,o=Math.floor(t/i.y),r=Math.ceil((n+t)/i.y)-1,s=this.data.max?this.data.max-this.data.min:this.data.dataCount();return{_from:o,_height:r,_top:t,_max:Math.ceil(s/a)*i.y,_y:i.y,_dx:a}}},dhtmlXDataView=function(t){this.name="DataView",dhtmlx.assert_enabled()&&this._assert(),dhtmlx.extend(this,dhtmlx.Settings),this._parseContainer(t,"dhx_dataview"),dhtmlx.extend(this,dhtmlx.AtomDataLoader),dhtmlx.extend(this,dhtmlx.DataLoader),dhtmlx.extend(this,dhtmlx.EventSystem),dhtmlx.extend(this,dhtmlx.RenderStack),dhtmlx.extend(this,dhtmlx.SelectionModel),dhtmlx.extend(this,dhtmlx.MouseEvents),dhtmlx.extend(this,dhtmlx.KeyEvents),dhtmlx.extend(this,dhtmlx.EditAbility),dhtmlx.extend(this,dhtmlx.DataMove),dhtmlx.extend(this,dhtmlx.DragItem),dhtmlx.extend(this,dhtmlx.DataProcessor),dhtmlx.extend(this,dhtmlx.AutoTooltip),dhtmlx.extend(this,dhtmlx.Destruction),this.data.attachEvent("onStoreUpdated",dhtmlx.bind(function(){this.render.apply(this,arguments)},this)),this._parseSettings(t,{drag:!1,edit:!1,select:"multiselect",type:"default"}),"auto"==this._settings.height||this._settings.renderAll||dhtmlx.extend(this,dhtmlx.VirtualRenderStack),this.data.provideApi(this,!0),this.config.autowidth&&(this.attachEvent("onBeforeRender",function(){this.type.width=Math.floor(this._dataobj.scrollWidth/(1*this.config.autowidth||1))-2*this.type.padding-2*this.type.margin-2*this.type.border,this.type._item_start=dhtmlx.Template.fromHTML(this.template_item_start(this.type)),this.type._item_end=this.template_item_end(this.type)}),dhtmlx.event(window,"resize",function(){this.refresh()},this)),dhtmlx.$customScroll&&dhtmlx.CustomScroll.enable(this)},dhtmlXDataView.prototype={bind:function(){dhtmlx.BaseBind.legacyBind.apply(this,arguments)},sync:function(){dhtmlx.BaseBind.legacySync.apply(this,arguments)},dragMarker:function(t,e){var n=this._locateHTML(t.target);if(this.type.drag_marker&&(this._drag_marker&&(this._drag_marker.style.backgroundImage="",this._drag_marker.style.backgroundRepeat=""),n&&(n.style.backgroundImage="url("+(dhtmlx.image_path||"")+this.type.drag_marker+")",n.style.backgroundRepeat="no-repeat",this._drag_marker=n)),n&&this._settings.auto_scroll){var i=n.offsetTop,a=n.offsetHeight,o=this._obj.scrollTop,r=this._obj.offsetHeight;i-a>=0&&i-.75*a<o?o=Math.max(i-a,0):i+a/.75>o+r&&(o+=a),this._obj.scrollTop=o}return!0},_id:"dhx_f_id",on_click:{dhx_dataview_item:function(t,e){this.stopEdit(!1,e)&&this._settings.select&&("multiselect"==this._settings.select?this.select(e,t.ctrlKey||t.metaKey,t.shiftKey):this.select(e))}},on_dblclick:{dhx_dataview_item:function(t,e){this._settings.edit&&this.edit(e)}},on_mouse_move:{},types:{default:{css:"default",template:dhtmlx.Template.fromHTML("<div style='padding:10px; white-space:nowrap; overflow:hidden;'>{obj.text}</div>"),template_edit:dhtmlx.Template.fromHTML("<div style='padding:10px; white-space:nowrap; overflow:hidden;'><textarea style='width:100%; height:100%;' bind='obj.text'></textarea></div>"),template_loading:dhtmlx.Template.fromHTML("<div style='padding:10px; white-space:nowrap; overflow:hidden;'>Loading...</div>"),width:210,height:115,margin:0,padding:10,border:1}},template_item_start:dhtmlx.Template.fromHTML("<div dhx_f_id='{-obj.id}' class='dhx_dataview_item dhx_dataview_{obj.css}_item{-obj.$selected?_selected:}' style='width:{obj.width}px; height:{obj.height}px; padding:{obj.padding}px; margin:{obj.margin}px; float:left; overflow:hidden;'>"),template_item_end:dhtmlx.Template.fromHTML("</div>")},dhtmlx.compat("layout"),void 0!==window.dhtmlXCellObject&&(dhtmlXCellObject.prototype.attachDataView=function(t){this.callEvent("_onBeforeContentAttach",["dataview"]);var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden",this._attachObject(e),void 0===t&&(t={}),e.id="DataViewObject_"+(new Date).getTime(),t.container=e.id,t.skin=this.conf.skin,this.dataType="dataview",this.dataObj=new dhtmlXDataView(t),this.dataObj.setSizes=function(){this.render()},e=null,this.callEvent("_onContentAttach",[]),this.dataObj}),dhtmlXList=function(t){this.name="List",dhtmlx.extend(this,dhtmlx.Settings),this._parseContainer(t,"dhx_list"),dhtmlx.extend(this,dhtmlx.AtomDataLoader),dhtmlx.extend(this,dhtmlx.DataLoader),dhtmlx.extend(this,dhtmlx.EventSystem),dhtmlx.extend(this,dhtmlx.RenderStack),dhtmlx.extend(this,dhtmlx.SelectionModel),dhtmlx.extend(this,dhtmlx.MouseEvents),dhtmlx.extend(this,dhtmlx.KeyEvents),dhtmlx.extend(this,dhtmlx.EditAbility),dhtmlx.extend(this,dhtmlx.DataMove),dhtmlx.extend(this,dhtmlx.DragItem),dhtmlx.extend(this,dhtmlx.DataProcessor),dhtmlx.extend(this,dhtmlx.AutoTooltip),dhtmlx.extend(this,dhtmlx.Destruction),this._getDimension=function(){var t=this.type,e=2*(t.margin||0);return{x:t.width+e,y:t.height+e}},this.data.attachEvent("onStoreUpdated",dhtmlx.bind(function(){this.render.apply(this,arguments)},this)),this._parseSettings(t,{drag:!1,edit:!1,select:"multiselect",type:"default"}),this.data.provideApi(this,!0),dhtmlx.$customScroll&&dhtmlx.CustomScroll.enable(this)},dhtmlXList.prototype={bind:function(){dhtmlx.BaseBind.legacyBind.apply(this,arguments)},sync:function(){dhtmlx.BaseBind.legacySync.apply(this,arguments)},dragMarker:function(t,e){var n=this._locateHTML(t.target);if(n&&this._settings.auto_scroll){var i=n.offsetTop,a=n.offsetHeight,o=this._obj.scrollTop,r=this._obj.offsetHeight;i-a>=0&&i-.75*a<o?o=Math.max(i-a,0):i+a/.75>o+r&&(o+=a),this._obj.scrollTop=o}return!0},_id:"dhx_f_id",on_click:{dhx_list_item:function(t,e){this.stopEdit(!1,e)&&this._settings.select&&("multiselect"==this._settings.select?this.select(e,t.ctrlKey||t.metaKey,t.shiftKey):this.select(e))}},on_dblclick:{dhx_list_item:function(t,e){this._settings.edit&&this.edit(e)}},on_mouse_move:{},types:{default:{css:"default",template:dhtmlx.Template.fromHTML("<div style='padding:10px; white-space:nowrap; overflow:hidden;'>{obj.text}</div>"),template_edit:dhtmlx.Template.fromHTML("<div style='padding:10px; white-space:nowrap; overflow:hidden;'><textarea bind='obj.text'></textarea></div>"),template_loading:dhtmlx.Template.fromHTML("<div style='padding:10px; white-space:nowrap; overflow:hidden;'>Loading...</div>"),height:50,margin:0,padding:10,border:1}},template_item_start:dhtmlx.Template.fromHTML("<div dhx_f_id='{-obj.id}' class='dhx_list_item dhx_list_{obj.css}_item{-obj.$selected?_selected:}' style='width:100%; height:{obj.height}px; padding:{obj.padding}px; margin:{obj.margin}px; overflow:hidden;'>"),template_item_end:dhtmlx.Template.fromHTML("</div>")},dhtmlx.compat("layout"),void 0!==window.dhtmlXCellObject&&(dhtmlXCellObject.prototype.attachList=function(t){this.callEvent("_onBeforeContentAttach",["list"]);var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflowX="hidden",this._attachObject(e),void 0===t&&(t={}),e.id="ListObject_"+(new Date).getTime(),t.container=e.id,t.skin=this.conf.skin,this.dataType="list",this.dataObj=new dhtmlXList(t),this.dataObj.setSizes=function(){this.render()},e=null,this.callEvent("_onContentAttach",[]),this.dataObj}),xmlPointer.prototype={text:function(){return _isFF?(new XMLSerializer).serializeToString(this.d):this.d.xml},get:function(t){return this.d.getAttribute(t)},exists:function(){return!!this.d},content:function(){return this.d.firstChild?this.d.firstChild.wholeText||this.d.firstChild.data:""},each:function(t,e,n,i){var a=this.d.childNodes,o=new xmlPointer;if(a.length)for(i=i||0;i<a.length;i++)if(a[i].tagName==t&&(o.d=a[i],-1==e.apply(n,[o,i])))return},get_all:function(){for(var t={},e=this.d.attributes,n=0;n<e.length;n++)t[e[n].name]=e[n].value;return t},sub:function(t){var e=this.d.childNodes,n=new xmlPointer;if(e.length)for(var i=0;i<e.length;i++)if(e[i].tagName==t)return n.d=e[i],n},up:function(t){return new xmlPointer(this.d.parentNode)},set:function(t,e){this.d.setAttribute(t,e)},clone:function(t){return new xmlPointer(this.d)},sub_exists:function(t){var e=this.d.childNodes;if(e.length)for(var n=0;n<e.length;n++)if(e[n].tagName==t)return!0;return!1},through:function(t,e,n,i,a){var o=this.d.childNodes;if(o.length)for(var r=0;r<o.length;r++){if(o[r].tagName==t&&null!=o[r].getAttribute(e)&&""!=o[r].getAttribute(e)&&(!n||o[r].getAttribute(e)==n)){var s=new xmlPointer(o[r]);i.apply(a,[s,r])}var l=this.d;this.d=o[r],this.through(t,e,n,i,a),this.d=l}}},dhtmlXTreeObject.prototype.setDataMode=function(t){this._datamode=t},dhtmlXTreeObject.prototype._doContClick=function(t,e){if(!e&&2!=t.button)return this._acMenu&&(this._acMenu.hideContextMenu?this._acMenu.hideContextMenu():this.cMenu._contextEnd()),!0;for(var n=_isIE?t.srcElement:t.target;n&&"BODY"!=n.tagName&&!n.parentObject;)n=n.parentNode;if(!n||!n.parentObject)return!0;var i=n.parentObject;if(this.callEvent("onRightClick",[i.id,t])||((t.srcElement||t.target).oncontextmenu=function(t){return(t||event).cancelBubble=!0,!1}),this._acMenu=i.cMenu||this.cMenu,this._acMenu){if(!this.callEvent("onBeforeContextMenu",[i.id]))return!0;if(_isMacOS||((t.srcElement||t.target).oncontextmenu=function(t){return(t||event).cancelBubble=!0,!1}),this._acMenu.showContextMenu){var a=window.document.documentElement,o=window.document.body,r=new Array(a.scrollLeft||o.scrollLeft,a.scrollTop||o.scrollTop);if(_isIE)var s=t.clientX+r[0],l=t.clientY+r[1];else s=t.pageX,l=t.pageY;this._acMenu.showContextMenu(s-1,l-1),this.contextID=i.id,t.cancelBubble=!0,this._acMenu._skip_hide=!0}else n.contextMenuId=i.id,n.contextMenu=this._acMenu,n.a=this._acMenu._contextStart,n.a(n,t),n.a=null;return!1}return!0},dhtmlXTreeObject.prototype.enableIEImageFix=function(t){t?(this._getImg=function(){var t=document.createElement("DIV");return t.innerHTML="&nbsp;",t.className="dhx_bg_img_fix",t},this._setSrc=function(t,e){t.style.backgroundImage="url("+e+")"},this._getSrc=function(t){var e=t.style.backgroundImage;return e.substr(4,e.length-5).replace(/(^")|("$)/g,"")}):(this._getImg=function(t){return document.createElement(t==this.rootId?"div":"img")},this._setSrc=function(t,e){t.src=e},this._getSrc=function(t){return t.src})},dhtmlXTreeObject.prototype.destructor=function(){for(var t in this._idpull){var e=this._idpull[t];e&&(e.parentObject=null,e.treeNod=null,e.childNodes=null,e.span=null,e.tr.nodem=null,e.tr=null,e.htmlNode.objBelong=null,e.htmlNode=null,this._idpull[t]=null)}for(var t in this.parentObject.innerHTML="",this.allTree.onselectstart=null,this.allTree.oncontextmenu=null,this.allTree.onmousedown=null,this)this[t]=null},cObject.prototype=new Object,cObject.prototype.clone=function(){function t(){}return t.prototype=this,new t},dhtmlXTreeObject.prototype._globalIdStorageAdd=function(t,e){return this._globalIdStorageFind(t,1,1)?(t=t+"_"+(new Date).valueOf(),this._globalIdStorageAdd(t,e)):(this._idpull[t]=e,this._pullSize++,t)},dhtmlXTreeObject.prototype._globalIdStorageSub=function(t){this._idpull[t]&&(this._unselectItem(this._idpull[t]),this._idpull[t]=null,this._pullSize--),this._locker&&this._locker[t]&&(this._locker[t]=!1)},dhtmlXTreeObject.prototype._globalIdStorageFind=function(t,e,n,i){var a=this._idpull[t];if(a){if(a.unParsed&&!n&&this.reParse(a,0),this._srnd&&!a.htmlNode&&this._buildSRND(a,n),i&&this._edsbpsA)for(var o=0;o<this._edsbpsA.length;o++)if(this._edsbpsA[o][2]==t)return dhx4.callEvent("ongetItemError",["Requested item still in parsing process.",t]),null;return a}return this.slowParse&&0!=t&&!e?this.preParse(t):null},dhtmlXTreeObject.prototype._getSubItemsXML=function(t){var e=[];return t.each("item",function(t){e.push(t.get("id"))},this),e.join(this.dlmtr)},dhtmlXTreeObject.prototype.enableSmartXMLParsing=function(t){this.slowParse=dhx4.s2b(t)},dhtmlXTreeObject.prototype.findXML=function(t,e,n){},dhtmlXTreeObject.prototype._getAllCheckedXML=function(t,e,n){var i=[];return 2==n&&t.through("item","checked",-1,function(t){i.push(t.get("id"))},this),1==n&&t.through("item","id",null,function(t){t.get("checked")&&-1!=t.get("checked")&&i.push(t.get("id"))},this),0==n&&t.through("item","id",null,function(t){t.get("checked")&&0!=t.get("checked")||i.push(t.get("id"))},this),i.length?e+(e?this.dlmtr:"")+i.join(this.dlmtr):e||""},dhtmlXTreeObject.prototype._setSubCheckedXML=function(t,e){var n=t?"1":"";e.through("item","id",null,function(t){t.get("disabled")&&0!=t.get("disabled")||t.set("checked",n)},this)},dhtmlXTreeObject.prototype._getAllScraggyItemsXML=function(t,e){var n=[],i=function(t){t.sub_exists("item")?t.each("item",i,this):n.push(t.get("id"))};return i(t),n.join(",")},dhtmlXTreeObject.prototype._getAllFatItemsXML=function(t,e){var n=[],i=function(t){t.sub_exists("item")&&(n.push(t.get("id")),t.each("item",i,this))};return i(t),n.join(",")},dhtmlXTreeObject.prototype._getAllSubItemsXML=function(t,e,n){e=[];return n.through("item","id",null,function(t){e.push(t.get("id"))},this),e.join(",")},dhtmlXTreeObject.prototype.reParse=function(t){this.parsCount||this.callEvent("onXLS",[this,t.id]),this.xmlstate=1;var e=t.unParsed;t.unParsed=0,this.XMLloadingWarning=1;var n=this.parsingOn,i=this.waitUpdateXML,a=this.parsedArray;this.parsedArray=new Array,this.waitUpdateXML=!1,this.parsingOn=t.id,this.parsedArray=new Array,this.setCheckList="",this._parse(e,t.id,2);for(var o=this.setCheckList.split(this.dlmtr),r=0;r<this.parsedArray.length;r++)t.htmlNode.childNodes[0].appendChild(this.parsedArray[r]);e.get("order")&&"none"!=e.get("order")&&this._reorderBranch(t,e.get("order"),!0),this.oldsmcheck=this.smcheck,this.smcheck=!1;for(var s=0;s<o.length;s++)o[s]&&this.setCheck(o[s],1);return this.smcheck=this.oldsmcheck,this.parsingOn=n,this.waitUpdateXML=i,this.parsedArray=a,this.XMLloadingWarning=0,this._redrawFrom(this,t),this._srnd&&!t._sready&&this.prepareSR(t.id),this.xmlstate=0,!0},dhtmlXTreeObject.prototype.preParse=function(t){if(!t||!this._p)return null;var e=!1;if(this._p.clone().through("item","id",t,function(t){return this._globalIdStorageFind(t.up().get("id")),e=!0},this),e){var n=this._globalIdStorageFind(t,!0,!1);n||dhx4.callEvent("ongetItemError",["The item "+t+" not operable. Seems you have non-unique|incorrect IDs in tree's XML.",t])}return n},dhtmlXTreeObject.prototype._escape=function(t){switch(this.utfesc){case"none":return t;case"utf8":return encodeURIComponent(t);default:return escape(t)}},dhtmlXTreeObject.prototype._drawNewTr=function(t,e){var n=document.createElement("tr"),i=document.createElement("td"),a=document.createElement("td");return i.appendChild(document.createTextNode(" ")),a.colSpan=3,a.appendChild(t),n.appendChild(i),n.appendChild(a),n},dhtmlXTreeObject.prototype.parse=function(t,e,n){if("string"==typeof e&&(n=e,e=null),"json"===n)return this._loadJSONObject(t,e);if("csv"===n)return this._loadCSVString(t,e);if("jsarray"===n)return this._loadJSArray(t,e);this.parsCount||this.callEvent("onXLS",[this,null]),this.xmlstate=1,this.XMLLoader({responseXML:dhx4.ajax.parse(t)},e)},dhtmlXTreeObject.prototype.loadXMLString=function(){return window.console&&window.console.info&&window.console.info("loadXMLString was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this.parse.apply(this,arguments)},dhtmlXTreeObject.prototype.load=function(t,e,n){if("string"==typeof e&&(n=e,e=null),"json"===(n=n||this._datamode))return this._loadJSON(t,e);if("csv"===n)return this._loadCSV(t,e);if("jsarray"===n)return this._loadJSArrayFile(xmlString,e);this.parsCount||this.callEvent("onXLS",[this,this._ld_id]),this._ld_id=null,this.xmlstate=1,this.XMLLoader=this._parseXMLTree;var i=this;return dhx4.ajax.get(t,function(t){i.XMLLoader(t.xmlDoc,e),i=null})},dhtmlXTreeObject.prototype.loadXML=function(){return window.console&&window.console.info&&window.console.info("loadXML was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this.load.apply(this,arguments)},dhtmlXTreeObject.prototype._attachChildNode=function(t,e,n,i,a,o,r,s,l,d,c){d&&d.parentObject&&(t=d.parentObject),0==t.XMLload&&this.XMLsource&&!this.XMLloadingWarning&&(t.XMLload=1,this._loadDynXML(t.id));var h,u=t.childsCount,m=t.childNodes;if(c&&c.tr.previousSibling&&(c.tr.previousSibling.previousSibling?d=c.tr.previousSibling.nodem:s=s.replace("TOP","")+",TOP"),d){var f,p;for(f=0;f<u;f++)if(m[f]==d){for(p=u;p!=f;p--)m[1+p]=m[p];break}u=++f}if(s)for(var _=s.split(","),A=0;A<_.length;A++)switch(_[A]){case"TOP":for(t.childsCount>0&&((d=new Object).tr=t.childNodes[0].tr.previousSibling),t._has_top=!0,f=u;f>0;f--)m[f]=m[f-1];u=0}(h=this._idpull[e])&&-1==h.span||(h=m[u]=new dhtmlXTreeItemObject(e,n,t,this,i,1),e=m[u].id,t.childsCount++),h.htmlNode||(h.label=n,h.htmlNode=this._createItem(this.checkBoxOff?1:0,h),h.htmlNode.objBelong=h),a&&(h.images[0]=a),o&&(h.images[1]=o),r&&(h.images[2]=r);var b=this._drawNewTr(h.htmlNode);if((this.XMLloadingWarning||this._hAdI)&&(h.htmlNode.parentNode.parentNode.style.display="none"),d&&d.tr&&d.tr.nextSibling?t.htmlNode.childNodes[0].insertBefore(b,d.tr.nextSibling):this.parsingOn==t.id?this.parsedArray[this.parsedArray.length]=b:t.htmlNode.childNodes[0].appendChild(b),d&&!d.span&&(d=null),this.XMLsource&&(h.XMLload=l&&0!=l?0:1),h.tr=b,b.nodem=h,0==t.itemId&&(b.childNodes[0].className="hiddenRow"),(t._r_logic||this._frbtr)&&this._setSrc(h.htmlNode.childNodes[0].childNodes[0].childNodes[1].childNodes[0],this.imPath+this.radioArray[0]),s)for(_=s.split(","),A=0;A<_.length;A++)switch(_[A]){case"SELECT":this.selectItem(e,!1);break;case"CALL":this.selectItem(e,!0);break;case"CHILD":h.XMLload=0;break;case"CHECKED":this.XMLloadingWarning?this.setCheckList+=this.dlmtr+e:this.setCheck(e,1);break;case"HCHECKED":this._setCheck(h,"unsure");break;case"OPEN":h.openMe=1}if(!this.XMLloadingWarning&&(this._getOpenState(t)<0&&!this._hAdI&&this.openItem(t.id),d&&(this._correctPlus(d),this._correctLine(d)),this._correctPlus(t),this._correctLine(t),this._correctPlus(h),t.childsCount>=2&&(this._correctPlus(m[t.childsCount-2]),this._correctLine(m[t.childsCount-2])),2!=t.childsCount&&this._correctPlus(m[0]),this.tscheck&&this._correctCheckStates(t),this._onradh))if(1==this.xmlstate){var x=this.onXLE;this.onXLE=function(t){this._onradh(e),x&&x(t)}}else this._onradh(e);return h},dhtmlXTreeObject.prototype.enableContextMenu=function(t){t&&(this.cMenu=t)},dhtmlXTreeObject.prototype.setItemContextMenu=function(t,e){for(var n=t.toString().split(this.dlmtr),i=0;i<n.length;i++){var a=this._globalIdStorageFind(n[i]);a&&(a.cMenu=e)}},dhtmlXTreeObject.prototype.insertNewItem=function(t,e,n,i,a,o,r,s,l){var d=this._globalIdStorageFind(t);if(!d)return-1;var c=this._attachChildNode(d,e,n,i,a,o,r,s,l);return this._idpull[this.rootId].XMLload||(this._idpull[this.rootId].XMLload=1),!this.XMLloadingWarning&&this.childCalc&&this._fixChildCountLabel(d),c},dhtmlXTreeObject.prototype.insertNewChild=function(t,e,n,i,a,o,r,s,l){return this.insertNewItem(t,e,n,i,a,o,r,s,l)},dhtmlXTreeObject.prototype._parseXMLTree=function(t,e){var n=new xmlPointer(dhx4.ajax.xmltop("tree",t));this._parse(n),this._p=n,e&&e.call(this,t)},dhtmlXTreeObject.prototype._parseItem=function(t,e,n,i){var a;if(!this._srnd||this._idpull[a=t.get("id")]&&this._idpull[a].span){var o=t.get_all();if("object"!=typeof this.waitUpdateXML||this.waitUpdateXML[o.id]){null!==o.text&&void 0!==o.text||(o.text=t.sub("itemtext"),o.text&&(o.text=o.text.content()));var r=[];if(o.select&&r.push("SELECT"),o.top&&r.push("TOP"),o.call&&(this.nodeAskingCall=o.id),-1==o.checked?r.push("HCHECKED"):o.checked&&r.push("CHECKED"),o.open&&r.push("OPEN"),this.waitUpdateXML)if(this._globalIdStorageFind(o.id))var s=this.updateItem(o.id,o.text,o.im0,o.im1,o.im2,o.checked,o.child);else{0==this.npl?r.push("TOP"):n=e.childNodes[this.npl];s=this._attachChildNode(e,o.id,o.text,0,o.im0,o.im1,o.im2,r.join(","),o.child,0,n);o.id=s.id,n=null}else s=this._attachChildNode(e,o.id,o.text,0,o.im0,o.im1,o.im2,r.join(","),o.child,i||0,n);if(o.tooltip&&(s.span.parentNode.parentNode.title=o.tooltip),o.style&&(s.span.style.cssText?s.span.style.cssText+=";"+o.style:s.span.setAttribute("style",s.span.getAttribute("style")+"; "+o.style)),o.radio&&(s._r_logic=!0),o.nocheckbox)s.span.parentNode.previousSibling.previousSibling.style.display="none",s.nocheckbox=!0;o.disabled&&(null!=o.checked&&this._setCheck(s,o.checked),this.disableCheckbox(s,1)),s._acc=o.child||0,this.parserExtension&&this.parserExtension._parseExtension.call(this,t,o,e?e.id:0),this.setItemColor(s,o.aCol,o.sCol),"1"==o.locked&&this.lockItem(s.id,!0,!0),(o.imwidth||o.imheight)&&this.setIconSize(o.imwidth,o.imheight,s),"0"!=o.closeable&&"1"!=o.closeable||this.setItemCloseable(s,o.closeable);var l="";o.topoffset&&this.setItemTopOffset(s,o.topoffset),this.slowParse&&"object"!=typeof this.waitUpdateXML?(!s.childsCount&&t.sub_exists("item")&&(s.unParsed=t.clone()),t.each("userdata",function(t){this.setUserData(o.id,t.get("name"),t.content())},this)):t.sub_exists("item")&&(l=this._parse(t,o.id,1)),""!=l&&(this.nodeAskingCall=l),t.each("userdata",function(e){this.setUserData(t.get("id"),e.get("name"),e.content())},this)}else this._parse(t,o.id,1)}else this._addItemSRND(e.id,a,t)},dhtmlXTreeObject.prototype._parse=function(t,e,n,i){if(this._srnd&&!this.parentObject.offsetHeight){var a=this;return window.setTimeout(function(){a._parse(t,e,n,i)},100)}if(t.exists()){if(this.skipLock=!0,!e){e=t.get("id"),this._dynDeleteBranches[e]&&(this.deleteChildItems(e),this._dynDeleteBranches[e]--,this._dynDeleteBranches[e]||delete this._dynDeleteBranches[e]);var o=t.get("dhx_security");o&&(dhtmlx.security_key=o),t.get("radio")&&(this.htmlNode._r_logic=!0),this.parsingOn=e,this.parsedArray=new Array,this.setCheckList="",this.nodeAskingCall=""}var r=this._globalIdStorageFind(e);if(!r)return dhx4.callEvent("onDataStructureError",["XML refers to not existing parent"]);if(this.parsCount=this.parsCount?this.parsCount+1:1,this.XMLloadingWarning=1,!r.childsCount||i||this._edsbps||r._has_top)s=0;else var s=0;if(this.npl=0,t.each("item",function(i,a){if(r.XMLload=1,this._parseItem(i,r,0,s),this._edsbps&&this.npl==this._edsbpsC)return this._distributedStart(t,a+1,e,n,r.childsCount),-1;this.npl++},this,i),!n){if(t.each("userdata",function(e){this.setUserData(t.get("id"),e.get("name"),e.content())},this),r.XMLload=1,this.waitUpdateXML){this.waitUpdateXML=!1;for(var l=r.childsCount-1;l>=0;l--)r.childNodes[l]._dmark&&this.deleteItem(r.childNodes[l].id)}for(this._globalIdStorageFind(this.parsingOn),l=0;l<this.parsedArray.length;l++)r.htmlNode.childNodes[0].appendChild(this.parsedArray[l]);this.parsedArray=[],this.lastLoadedXMLId=e,this.XMLloadingWarning=0;for(var d=this.setCheckList.split(this.dlmtr),c=0;c<d.length;c++)d[c]&&this.setCheck(d[c],1);this.XMLsource&&this.tscheck&&this.smcheck&&r.id!=this.rootId&&(0===r.checkstate?this._setSubChecked(0,r):1===r.checkstate&&this._setSubChecked(1,r)),this._redrawFrom(this,null,i),t.get("order")&&"none"!=t.get("order")&&this._reorderBranch(r,t.get("order"),!0),""!=this.nodeAskingCall&&this.callEvent("onClick",[this.nodeAskingCall,this.getSelectedItemId()]),this._branchUpdate&&this._branchUpdateNext(t)}if(1==this.parsCount){if(this.parsingOn=null,this._srnd&&r.id!=this.rootId&&(this.prepareSR(r.id),this.XMLsource&&this.openItem(r.id)),t.through("item","open",null,function(t){this.openItem(t.get("id"))},this),!this._edsbps||!this._edsbpsA.length){var h=this;window.setTimeout(function(){h.callEvent("onXLE",[h,e])},1),this.xmlstate=0}this.skipLock=!1}this.parsCount--;h=this;return this._edsbps&&window.setTimeout(function(){h._distributedStep(e)},this._edsbpsD),!n&&this.onXLE&&this.onXLE(this,e),this.nodeAskingCall}},dhtmlXTreeObject.prototype._branchUpdateNext=function(t){t.each("item",function(t){var e=t.get("id");this._idpull[e]&&!this._idpull[e].XMLload||(this._branchUpdate++,this.smartRefreshItem(t.get("id"),t))},this),this._branchUpdate--},dhtmlXTreeObject.prototype.checkUserData=function(t,e){if(1==t.nodeType&&"userdata"==t.tagName){var n=t.getAttribute("name");n&&t.childNodes[0]&&this.setUserData(e,n,t.childNodes[0].data)}},dhtmlXTreeObject.prototype._redrawFrom=function(t,e,n,i){if(e)a=e;else{var a=t._globalIdStorageFind(t.lastLoadedXMLId);if(t.lastLoadedXMLId=-1,!a)return 0}for(var o=0,r=n?n-1:0;r<a.childsCount;r++)if(this._branchUpdate&&1!=this._getOpenState(a)||e&&1!=i||(a.childNodes[r].htmlNode.parentNode.parentNode.style.display=""),1==a.childNodes[r].openMe&&(this._openItem(a.childNodes[r]),a.childNodes[r].openMe=0),t._redrawFrom(t,a.childNodes[r]),null!=this.childCalc){if((a.childNodes[r].unParsed||!a.childNodes[r].XMLload&&this.XMLsource)&&(a.childNodes[r]._acc?a.childNodes[r].span.innerHTML=a.childNodes[r].label+this.htmlcA+a.childNodes[r]._acc+this.htmlcB:a.childNodes[r].span.innerHTML=a.childNodes[r].label),a.childNodes[r].childNodes.length&&this.childCalc){var s;if(1==this.childCalc&&(a.childNodes[r].span.innerHTML=a.childNodes[r].label+this.htmlcA+a.childNodes[r].childsCount+this.htmlcB),2==this.childCalc)(s=a.childNodes[r].childsCount-(a.childNodes[r].pureChilds||0))&&(a.childNodes[r].span.innerHTML=a.childNodes[r].label+this.htmlcA+s+this.htmlcB),a.pureChilds?a.pureChilds++:a.pureChilds=1;if(3==this.childCalc&&(a.childNodes[r].span.innerHTML=a.childNodes[r].label+this.htmlcA+a.childNodes[r]._acc+this.htmlcB),4==this.childCalc)(s=a.childNodes[r]._acc)&&(a.childNodes[r].span.innerHTML=a.childNodes[r].label+this.htmlcA+s+this.htmlcB)}else 4==this.childCalc&&o++;o+=a.childNodes[r]._acc,3==this.childCalc&&o++}a.unParsed||!a.XMLload&&this.XMLsource||(a._acc=o),t._correctLine(a),t._correctPlus(a),this.childCalc&&!e&&t._fixChildCountLabel(a)},dhtmlXTreeObject.prototype._createSelf=function(){var t=document.createElement("div");return t.className="containerTableStyle",t.style.width=this.width,t.style.height=this.height,this.parentObject.appendChild(t),t},dhtmlXTreeObject.prototype._xcloseAll=function(t){if(!t.unParsed){if(this.rootId!=t.id){if(!t.htmlNode)return;for(var e=t.htmlNode.childNodes[0].childNodes,n=e.length,i=1;i<n;i++)e[i].style.display="none";this._correctPlus(t)}for(i=0;i<t.childsCount;i++)t.childNodes[i].childsCount&&this._xcloseAll(t.childNodes[i])}},dhtmlXTreeObject.prototype._xopenAll=function(t){this._HideShow(t,2);for(var e=0;e<t.childsCount;e++)this._xopenAll(t.childNodes[e])},dhtmlXTreeObject.prototype._correctPlus=function(t){if(t.htmlNode){var e=t.htmlNode.childNodes[0].childNodes[0].childNodes[0].lastChild,n=t.htmlNode.childNodes[0].childNodes[0].childNodes[2].childNodes[0],i=this.lineArray;if(this.XMLsource&&!t.XMLload){i=this.plusArray;if(this._setSrc(n,this.iconURL+t.images[2]),this._txtimg)return e.innerHTML="[+]"}else if(t.childsCount||t.unParsed)if(t.htmlNode.childNodes[0].childNodes[1]&&"none"!=t.htmlNode.childNodes[0].childNodes[1].style.display){if(!t.wsign)i=this.minusArray;if(this._setSrc(n,this.iconURL+t.images[1]),this._txtimg)return e.innerHTML="[-]"}else{if(!t.wsign)i=this.plusArray;if(this._setSrc(n,this.iconURL+t.images[2]),this._txtimg)return e.innerHTML="[+]"}else this._setSrc(n,this.iconURL+t.images[0]);var a=2;t.treeNod.treeLinesOn?(t.parentObject&&(a=this._getCountStatus(t.id,t.parentObject)),this._setSrc(e,this.imPath+i[a])):this._setSrc(e,this.imPath+i[3])}},dhtmlXTreeObject.prototype._correctLine=function(t){if(t.htmlNode){var e=t.parentObject;if(e)if(0!=this._getLineStatus(t.id,e)&&this.treeLinesOn)for(n=1;n<=t.childsCount&&t.htmlNode.childNodes[0].childNodes[n];n++)t.htmlNode.childNodes[0].childNodes[n].childNodes[0].style.backgroundImage="url("+this.imPath+this.lineArray[5]+")",t.htmlNode.childNodes[0].childNodes[n].childNodes[0].style.backgroundRepeat="repeat-y";else for(var n=1;n<=t.childsCount&&t.htmlNode.childNodes[0].childNodes[n];n++)t.htmlNode.childNodes[0].childNodes[n].childNodes[0].style.backgroundImage="",t.htmlNode.childNodes[0].childNodes[n].childNodes[0].style.backgroundRepeat=""}},dhtmlXTreeObject.prototype._getCountStatus=function(t,e){return e.childsCount<=1?e.id==this.rootId?4:0:e.childNodes[0].id==t?e.id==this.rootId?2:1:e.childNodes[e.childsCount-1].id==t?0:1},dhtmlXTreeObject.prototype._getLineStatus=function(t,e){return e.childNodes[e.childsCount-1].id==t?0:1},dhtmlXTreeObject.prototype._HideShow=function(t,e){if(!this._locker||this.skipLock||!this._locker[t.id]){if(this.XMLsource&&!t.XMLload){if(1==e)return;return t.XMLload=1,void this._loadDynXML(t.id)}t.unParsed&&this.reParse(t);var n=t.htmlNode.childNodes[0].childNodes,i=n.length;if(i>1){"none"==n[1].style.display&&1!=e||2==e?nodestyle="":(this.allTree.childNodes[0].border="1",this.allTree.childNodes[0].border="0",nodestyle="none");for(var a=1;a<i;a++)n[a].style.display=nodestyle}this._correctPlus(t)}},dhtmlXTreeObject.prototype._getOpenState=function(t){if(!t.htmlNode)return 0;var e=t.htmlNode.childNodes[0].childNodes;return e.length<=1?0:"none"!=e[1].style.display?1:-1},dhtmlXTreeObject.prototype.onRowClick2=function(){var t=this.parentObject.treeNod;return!!t.callEvent("onDblClick",[this.parentObject.id,t])&&(this.parentObject.closeble&&"0"!=this.parentObject.closeble?t._HideShow(this.parentObject):t._HideShow(this.parentObject,2),t.checkEvent("onOpenEnd")&&(t.xmlstate?(t._oie_onXLE.push(t.onXLE),t.onXLE=t._epnFHe):t.callEvent("onOpenEnd",[this.parentObject.id,t._getOpenState(this.parentObject)])),!1)},dhtmlXTreeObject.prototype.onRowClick=function(){var t=this.parentObject.treeNod;if(!t.callEvent("onOpenStart",[this.parentObject.id,t._getOpenState(this.parentObject)]))return 0;this.parentObject.closeble&&"0"!=this.parentObject.closeble?t._HideShow(this.parentObject):t._HideShow(this.parentObject,2),t.checkEvent("onOpenEnd")&&(t.xmlstate?(t._oie_onXLE.push(t.onXLE),t.onXLE=t._epnFHe):t.callEvent("onOpenEnd",[this.parentObject.id,t._getOpenState(this.parentObject)]))},dhtmlXTreeObject.prototype._epnFHe=function(t,e,n){e!=this.rootId&&this.callEvent("onOpenEnd",[e,t.getOpenState(e)]),t.onXLE=t._oie_onXLE.pop(),n||t._oie_onXLE.length||t.onXLE&&t.onXLE(t,e)},dhtmlXTreeObject.prototype.onRowClickDown=function(t){t=t||window.event,this.parentObject.treeNod._selectItem(this.parentObject,t)},dhtmlXTreeObject.prototype.getSelectedItemId=function(){for(var t=new Array,e=0;e<this._selected.length;e++)t[e]=this._selected[e].id;return t.join(this.dlmtr)},dhtmlXTreeObject.prototype._selectItem=function(t,e){if(this.checkEvent("onSelect")&&(this._onSSCFold=this.getSelectedItemId()),this._amsel&&e&&(e.ctrlKey||e.metaKey||e.shiftKey)||this._unselectItems(),t.i_sel&&this._amsel&&e&&(e.ctrlKey||e.metaKey))this._unselectItem(t);else if(!(t.i_sel||this._amselS&&0!=this._selected.length&&this._selected[0].parentObject!=t.parentObject))if(this._amsel&&e&&e.shiftKey&&0!=this._selected.length&&this._selected[this._selected.length-1].parentObject==t.parentObject){var n=this._getIndex(this._selected[this._selected.length-1]),i=this._getIndex(t);if(i<n){var a=n;n=i,i=a}for(var o=n;o<=i;o++)t.parentObject.childNodes[o].i_sel||this._markItem(t.parentObject.childNodes[o])}else this._markItem(t);if(this.checkEvent("onSelect")){var r=this.getSelectedItemId();r!=this._onSSCFold&&this.callEvent("onSelect",[r])}},dhtmlXTreeObject.prototype._markItem=function(t){t.scolor&&(t.span.style.color=t.scolor),t.span.className="selectedTreeRow",t.span.parentNode.parentNode.className="selectedTreeRowFull",t.i_sel=!0,this._selected[this._selected.length]=t},dhtmlXTreeObject.prototype.getIndexById=function(t){var e=this._globalIdStorageFind(t);return e?this._getIndex(e):null},dhtmlXTreeObject.prototype._getIndex=function(t){for(var e=t.parentObject,n=0;n<e.childsCount;n++)if(e.childNodes[n]==t)return n},dhtmlXTreeObject.prototype._unselectItem=function(t){if(t&&t.i_sel){t.span.className="standartTreeRow",t.span.parentNode.parentNode.className="",t.acolor&&(t.span.style.color=t.acolor),t.i_sel=!1;for(var e=0;e<this._selected.length;e++)if(!this._selected[e].i_sel){this._selected.splice(e,1);break}}},dhtmlXTreeObject.prototype._unselectItems=function(){for(var t=0;t<this._selected.length;t++){var e=this._selected[t];e.span.className="standartTreeRow",e.span.parentNode.parentNode.className="",e.acolor&&(e.span.style.color=e.acolor),e.i_sel=!1}this._selected=new Array},dhtmlXTreeObject.prototype.onRowSelect=function(t,e,n){t=t||window.event;var i=this.parentObject;e&&(i=e.parentObject);var a=i.treeNod,o=a.getSelectedItemId();t&&t.skipUnSel||a._selectItem(i,t),n||(i.actionHandler?i.actionHandler(i.id,o):a.callEvent("onClick",[i.id,o]))},dhtmlXTreeObject.prototype._correctCheckStates=function(t){if(this.tscheck&&t&&t.id!=this.rootId){var e=t.childNodes,n=0,i=0;if(0!=t.childsCount){for(var a=0;a<t.childsCount;a++)if(!e[a].dscheck)if(0==e[a].checkstate)n=1;else{if(1!=e[a].checkstate){n=1,i=1;break}i=1}n&&i?this._setCheck(t,"unsure"):n?this._setCheck(t,!1):this._setCheck(t,!0),this._correctCheckStates(t.parentObject)}}},dhtmlXTreeObject.prototype.onCheckBoxClick=function(t){if(this.treeNod.callEvent("onBeforeCheck",[this.parentObject.id,this.parentObject.checkstate]))return!!this.parentObject.dscheck||(this.treeNod.tscheck?1==this.parentObject.checkstate?this.treeNod._setSubChecked(!1,this.parentObject):this.treeNod._setSubChecked(!0,this.parentObject):1==this.parentObject.checkstate?this.treeNod._setCheck(this.parentObject,!1):this.treeNod._setCheck(this.parentObject,!0),this.treeNod._correctCheckStates(this.parentObject.parentObject),this.treeNod.callEvent("onCheck",[this.parentObject.id,this.parentObject.checkstate]))},dhtmlXTreeObject.prototype._createItem=function(t,e,n){var i=document.createElement("table");i.cellSpacing=0,i.cellPadding=0,i.border=0,this.hfMode&&(i.style.tableLayout="fixed"),i.style.margin=0,i.style.padding=0;var a=document.createElement("tbody"),o=document.createElement("tr"),r=document.createElement("td");if(r.className="standartTreeImage",this._txtimg){var s=document.createElement("div");r.appendChild(s),s.className="dhx_tree_textSign"}else{(s=this._getImg(e.id)).border="0","IMG"==s.tagName&&(s.align="absmiddle"),r.appendChild(s),s.style.padding=0,s.style.margin=0,s.style.width=this.def_line_img_x}var l=document.createElement("td"),d=this._getImg(this.cBROf?this.rootId:e.id);d.checked=0,this._setSrc(d,this.imPath+this.checkArray[0]),d.style.width="18px",d.style.height="18px",t||(l.style.display="none"),l.appendChild(d),this.cBROf||"IMG"!=d.tagName||(d.align="absmiddle"),d.onclick=this.onCheckBoxClick,d.treeNod=this,d.parentObject=e,window._KHTMLrv?l.width="16px":l.width="20px";var c=document.createElement("td");c.className="standartTreeImage";var h=this._getImg(this.timgen?e.id:this.rootId);h.onmousedown=this._preventNsDrag,h.ondragstart=this._preventNsDrag,h.border="0",this._aimgs&&(h.parentObject=e,"IMG"==h.tagName&&(h.align="absmiddle"),h.onclick=this.onRowSelect),n||this._setSrc(h,this.iconURL+this.imageArray[0]),c.appendChild(h),h.style.padding=0,h.style.margin=0,this.timgen?(c.style.width=h.style.width=this.def_img_x,h.style.height=this.def_img_y):(h.style.width="0px",h.style.height="0px",(_isOpera||window._KHTMLrv)&&(c.style.display="none"));var u=document.createElement("td");return u.className="dhxTextCell standartTreeRow",e.span=document.createElement("span"),e.span.className="standartTreeRow",this.mlitems?(e.span.style.width=this.mlitems,e.span.style.display="block"):u.noWrap=!0,dhx4.isIE8?u.style.width="99999px":window._KHTMLrv||(u.style.width="100%"),e.span.innerHTML=e.label,u.appendChild(e.span),u.parentObject=e,r.parentObject=e,u.onclick=this.onRowSelect,r.onclick=this.onRowClick,u.ondblclick=this.onRowClick2,this.ettip&&(o.title=e.label),this.dragAndDropOff&&(this._aimgs&&(this.dragger.addDraggableItem(c,this),c.parentObject=e),this.dragger.addDraggableItem(u,this)),e.span.style.paddingLeft="5px",e.span.style.paddingRight="5px",u.style.verticalAlign="",u.style.fontSize="10pt",u.style.cursor=this.style_pointer,o.appendChild(r),o.appendChild(l),o.appendChild(c),o.appendChild(u),a.appendChild(o),i.appendChild(a),(this.ehlt||this.checkEvent("onMouseIn")||this.checkEvent("onMouseOut"))&&(o.onmousemove=this._itemMouseIn,o[_isIE?"onmouseleave":"onmouseout"]=this._itemMouseOut),i},dhtmlXTreeObject.prototype.setImagePath=function(t){this.imPath=t,this.iconURL=t},dhtmlXTreeObject.prototype.setIconPath=function(t){this.iconURL=t},dhtmlXTreeObject.prototype._getLeafCount=function(t){for(var e=0,n=0;n<t.childsCount;n++)0==t.childNodes[n].childsCount&&e++;return e},dhtmlXTreeObject.prototype._getChildCounterValue=function(t){var e=this._globalIdStorageFind(t);if(!e)return 0;if(e.unParsed||!e.XMLload&&this.XMLsource)return e._acc;switch(this.childCalc){case 1:return e.childsCount;case 2:return this._getLeafCount(e);case 3:case 4:return e._acc}},dhtmlXTreeObject.prototype._fixChildCountLabel=function(t,e){if(null!=this.childCalc)if(t.unParsed||!t.XMLload&&this.XMLsource)t._acc?t.span.innerHTML=t.label+this.htmlcA+t._acc+this.htmlcB:t.span.innerHTML=t.label;else switch(this.childCalc){case 1:0!=t.childsCount?t.span.innerHTML=t.label+this.htmlcA+t.childsCount+this.htmlcB:t.span.innerHTML=t.label;break;case 2:var n=this._getLeafCount(t);t.span.innerHTML=0!=n?t.label+this.htmlcA+n+this.htmlcB:t.label;break;case 3:if(0!=t.childsCount){for(var i=0,a=0;a<t.childsCount;a++)t.childNodes[a]._acc||(t.childNodes[a]._acc=0),i+=1*t.childNodes[a]._acc;i+=1*t.childsCount,t.span.innerHTML=t.label+this.htmlcA+i+this.htmlcB,t._acc=i}else t.span.innerHTML=t.label,t._acc=0;t.parentObject&&t.parentObject!=this.htmlNode&&this._fixChildCountLabel(t.parentObject);break;case 4:if(0!=t.childsCount){for(i=0,a=0;a<t.childsCount;a++)t.childNodes[a]._acc||(t.childNodes[a]._acc=1),i+=1*t.childNodes[a]._acc;t.span.innerHTML=t.label+this.htmlcA+i+this.htmlcB,t._acc=i}else t.span.innerHTML=t.label,t._acc=1;t.parentObject&&t.parentObject!=this.htmlNode&&this._fixChildCountLabel(t.parentObject)}},dhtmlXTreeObject.prototype.setChildCalcMode=function(t){switch(t){case"child":this.childCalc=1;break;case"leafs":this.childCalc=2;break;case"childrec":this.childCalc=3;break;case"leafsrec":this.childCalc=4;break;case"disabled":this.childCalc=null;break;default:this.childCalc=4}},dhtmlXTreeObject.prototype.setChildCalcHTML=function(t,e){this.htmlcA=t,this.htmlcB=e},dhtmlXTreeObject.prototype.setOnRightClickHandler=function(t){this.attachEvent("onRightClick",t)},dhtmlXTreeObject.prototype.setOnClickHandler=function(t){this.attachEvent("onClick",t)},dhtmlXTreeObject.prototype.setOnSelectStateChange=function(t){this.attachEvent("onSelect",t)},dhtmlXTreeObject.prototype.setXMLAutoLoading=function(t){this.XMLsource=t},dhtmlXTreeObject.prototype.setOnCheckHandler=function(t){this.attachEvent("onCheck",t)},dhtmlXTreeObject.prototype.setOnOpenHandler=function(t){this.attachEvent("onOpenStart",t)},dhtmlXTreeObject.prototype.setOnOpenStartHandler=function(t){this.attachEvent("onOpenStart",t)},dhtmlXTreeObject.prototype.setOnOpenEndHandler=function(t){this.attachEvent("onOpenEnd",t)},dhtmlXTreeObject.prototype.setOnDblClickHandler=function(t){this.attachEvent("onDblClick",t)},dhtmlXTreeObject.prototype.openAllItems=function(t){var e=this._globalIdStorageFind(t);if(!e)return 0;this._xopenAll(e)},dhtmlXTreeObject.prototype.getOpenState=function(t){var e=this._globalIdStorageFind(t);return e?this._getOpenState(e):""},dhtmlXTreeObject.prototype.closeAllItems=function(t){t===window.undefined&&(t=this.rootId);var e=this._globalIdStorageFind(t);if(!e)return 0;this._xcloseAll(e),this.allTree.childNodes[0].border="1",this.allTree.childNodes[0].border="0"},dhtmlXTreeObject.prototype.setUserData=function(t,e,n){var i=this._globalIdStorageFind(t,0,!0);i&&("hint"==e&&(i.htmlNode.childNodes[0].childNodes[0].title=n),void 0===i.userData["t_"+e]&&(i._userdatalist?i._userdatalist+=","+e:i._userdatalist=e),i.userData["t_"+e]=n)},dhtmlXTreeObject.prototype.getUserData=function(t,e){var n=this._globalIdStorageFind(t,0,!0);if(n)return n.userData["t_"+e]},dhtmlXTreeObject.prototype.getItemColor=function(t){var e=this._globalIdStorageFind(t);if(!e)return 0;var n=new Object;return e.acolor&&(n.acolor=e.acolor),e.scolor&&(n.scolor=e.scolor),n},dhtmlXTreeObject.prototype.setItemColor=function(t,e,n){if(t&&t.span)var i=t;else i=this._globalIdStorageFind(t);if(!i)return 0;i.i_sel?(n||e)&&(i.span.style.color=n||e):e&&(i.span.style.color=e),n&&(i.scolor=n),e&&(i.acolor=e)},dhtmlXTreeObject.prototype.getItemText=function(t){var e=this._globalIdStorageFind(t);return e?e.htmlNode.childNodes[0].childNodes[0].childNodes[3].childNodes[0].innerHTML:0},dhtmlXTreeObject.prototype.getParentId=function(t){var e=this._globalIdStorageFind(t);return e&&e.parentObject?e.parentObject.id:""},dhtmlXTreeObject.prototype.changeItemId=function(t,e){if(t!=e){var n=this._globalIdStorageFind(t);if(!n)return 0;n.id=e,n.span.contextMenuId=e,this._idpull[e]=this._idpull[t],delete this._idpull[t]}},dhtmlXTreeObject.prototype.doCut=function(){this.nodeCut&&this.clearCut(),this.nodeCut=(new Array).concat(this._selected);for(var t=0;t<this.nodeCut.length;t++){var e=this.nodeCut[t];e._cimgs=new Array,e._cimgs[0]=e.images[0],e._cimgs[1]=e.images[1],e._cimgs[2]=e.images[2],e.images[0]=e.images[1]=e.images[2]=this.cutImage,this._correctPlus(e)}},dhtmlXTreeObject.prototype.doPaste=function(t){var e=this._globalIdStorageFind(t);if(!e)return 0;for(var n=0;n<this.nodeCut.length;n++)this._checkPNodes(e,this.nodeCut[n])||this._moveNode(this.nodeCut[n],e);this.clearCut()},dhtmlXTreeObject.prototype.clearCut=function(){for(var t=0;t<this.nodeCut.length;t++){var e=this.nodeCut[t];e.images[0]=e._cimgs[0],e.images[1]=e._cimgs[1],e.images[2]=e._cimgs[2],this._correctPlus(e)}this.nodeCut=new Array},dhtmlXTreeObject.prototype._moveNode=function(t,e){if(1==this.dadmodec){var n=e;if(this.dadmodefix<0){for(;;){if(-1==(n=this._getPrevNode(n))){n=this.htmlNode;break}if(0==n.tr||""==n.tr.style.display||!n.parentObject)break}var i=n,a=e}else{n.tr&&n.tr.nextSibling&&n.tr.nextSibling.nodem&&this._getOpenState(n)<1?n=n.tr.nextSibling.nodem:this._getOpenState(n)<1?n=this.htmlNode:-1==(n=this._getNextNode(n))&&(n=this.htmlNode);a=n,i=e}return this._getNodeLevel(i,0)>this._getNodeLevel(a,0)?this.dropLower?a.id!=this.rootId?this._moveNodeTo(t,a.parentObject,a):this._moveNodeTo(t,this.htmlNode,null):this._moveNodeTo(t,i.parentObject):this._moveNodeTo(t,a.parentObject,a)}return this._moveNodeTo(t,e)},dhtmlXTreeObject.prototype._fixNodesCollection=function(t,e){var n=0,i=t.childNodes,a=t.childsCount-1;if(e!=i[a]){for(var o=0;o<a;o++)i[o]==i[a]&&(i[o]=i[o+1],i[o+1]=i[a]);for(o=0;o<a+1;o++)if(n){var r=i[o];i[o]=n,n=r}else i[o]==e&&(n=i[o],i[o]=i[a])}},dhtmlXTreeObject.prototype._recreateBranch=function(t,e,n,i){var a="";if(n){for(l=0;l<e.childsCount&&e.childNodes[l]!=n;l++);0!=l?n=e.childNodes[l-1]:(a="TOP",n="")}var o=this._onradh;this._onradh=null;var r=this._attachChildNode(e,t.id,t.label,0,t.images[0],t.images[1],t.images[2],a,0,n);if(r._userdatalist=t._userdatalist,r.userData=t.userData.clone(),t._attrs)for(var s in r._attrs={},t._attrs)r._attrs[s]=t._attrs[s];r.XMLload=t.XMLload,o&&(this._onradh=o,this._onradh(r.id)),t.treeNod.dpcpy?t.treeNod._globalIdStorageFind(t.id):r.unParsed=t.unParsed,this._correctPlus(r);for(var l=0;l<t.childsCount;l++)this._recreateBranch(t.childNodes[l],r,0,1);return!i&&this.childCalc&&this._redrawFrom(this,e),r},dhtmlXTreeObject.prototype._moveNodeTo=function(t,e,n){if(t.treeNod._nonTrivialNode)return t.treeNod._nonTrivialNode(this,e,n,t);if(this._checkPNodes(e,t))return!1;if(e.mytype)var i=t.treeNod.lWin!=e.lWin;else i=t.treeNod.lWin!=e.treeNod.lWin;if(!this.callEvent("onDrag",[t.id,e.id,n?n.id:null,t.treeNod,e.treeNod]))return!1;0==e.XMLload&&this.XMLsource&&(e.XMLload=1,this._loadDynXML(e.id)),this.openItem(e.id);var a=t.treeNod,o=t.parentObject.childsCount,r=t.parentObject;if(i||a.dpcpy){var s=t.id;t=this._recreateBranch(t,e,n),a.dpcpy||a.deleteItem(s)}else{var l=e.childsCount,d=e.childNodes;0==l&&(e._open=!0),a._unselectItem(t),d[l]=t,t.treeNod=e.treeNod,e.childsCount++;var c=this._drawNewTr(d[l].htmlNode);n?(e.htmlNode.childNodes[0].insertBefore(c,n.tr),this._fixNodesCollection(e,n),d=e.childNodes):(e.htmlNode.childNodes[0].appendChild(c),1==this.dadmode&&this._fixNodesCollection(e,n))}if(!a.dpcpy&&!i){var h=t.tr;if(document.all&&-1!=navigator.appVersion.search(/MSIE\ 5\.0/gi)?window.setTimeout(function(){h.parentNode.removeChild(h)},250):t.parentObject.htmlNode.childNodes[0].removeChild(t.tr),n&&e==t.parentObject)r.childNodes[r.childsCount-1]=0;else for(var u=0;u<r.childsCount;u++)if(r.childNodes[u].id==t.id){r.childNodes[u]=0;break}a._compressChildList(r.childsCount,r.childNodes),r.childsCount--}if(!i&&!a.dpcpy){if(t.tr=c,c.nodem=t,t.parentObject=e,a!=e.treeNod){if(t.treeNod._registerBranch(t,a))return;this._clearStyles(t),this._redrawFrom(this,t.parentObject),this._onradh&&this._onradh(t.id)}this._correctPlus(e),this._correctLine(e),this._correctLine(t),this._correctPlus(t),n?this._correctPlus(n):e.childsCount>=2&&(this._correctPlus(d[e.childsCount-2]),this._correctLine(d[e.childsCount-2])),this._correctPlus(d[e.childsCount-1]),this.tscheck&&this._correctCheckStates(e),a.tscheck&&a._correctCheckStates(r)}return o>1&&(a._correctPlus(r.childNodes[o-2]),a._correctLine(r.childNodes[o-2])),a._correctPlus(r),a._correctLine(r),this._fixChildCountLabel(e),a._fixChildCountLabel(r),this.callEvent("onDrop",[t.id,e.id,n?n.id:null,a,e.treeNod]),t.id},dhtmlXTreeObject.prototype._clearStyles=function(t){if(t.htmlNode){var e=t.htmlNode.childNodes[0].childNodes[0].childNodes[1],n=e.nextSibling.nextSibling;t.span.innerHTML=t.label,t.i_sel=!1,t._aimgs&&this.dragger.removeDraggableItem(e.nextSibling),this.checkBoxOff?(e.childNodes[0].style.display="",e.childNodes[0].onclick=this.onCheckBoxClick,this._setSrc(e.childNodes[0],this.imPath+this.checkArray[t.checkstate])):e.style.display="none",e.childNodes[0].treeNod=this,this.dragger.removeDraggableItem(n),this.dragAndDropOff&&this.dragger.addDraggableItem(n,this),this._aimgs&&this.dragger.addDraggableItem(e.nextSibling,this),n.childNodes[0].className="standartTreeRow",n.parentNode.className="",n.onclick=this.onRowSelect,n.ondblclick=this.onRowClick2,e.previousSibling.onclick=this.onRowClick,this._correctLine(t),this._correctPlus(t);for(var i=0;i<t.childsCount;i++)this._clearStyles(t.childNodes[i])}},dhtmlXTreeObject.prototype._registerBranch=function(t,e){e&&e._globalIdStorageSub(t.id),t.id=this._globalIdStorageAdd(t.id,t),t.treeNod=this;for(var n=0;n<t.childsCount;n++)this._registerBranch(t.childNodes[n],e);return 0},dhtmlXTreeObject.prototype.enableThreeStateCheckboxes=function(t){this.tscheck=dhx4.s2b(t)},dhtmlXTreeObject.prototype.setOnMouseInHandler=function(t){this.ehlt=!0,this.attachEvent("onMouseIn",t)},dhtmlXTreeObject.prototype.setOnMouseOutHandler=function(t){this.ehlt=!0,this.attachEvent("onMouseOut",t)},dhtmlXTreeObject.prototype.enableMercyDrag=function(t){this.dpcpy=dhx4.s2b(t)},dhtmlXTreeObject.prototype.enableTreeImages=function(t){this.timgen=dhx4.s2b(t)},dhtmlXTreeObject.prototype.enableFixedMode=function(t){this.hfMode=dhx4.s2b(t)},dhtmlXTreeObject.prototype.enableCheckBoxes=function(t,e){this.checkBoxOff=dhx4.s2b(t),this.cBROf=!(this.checkBoxOff||dhx4.s2b(e))},dhtmlXTreeObject.prototype.setStdImages=function(t,e,n){this.imageArray[0]=t,this.imageArray[1]=e,this.imageArray[2]=n},dhtmlXTreeObject.prototype.enableTreeLines=function(t){this.treeLinesOn=dhx4.s2b(t)},dhtmlXTreeObject.prototype.setImageArrays=function(t,e,n,i,a,o){switch(t){case"plus":this.plusArray[0]=e,this.plusArray[1]=n,this.plusArray[2]=i,this.plusArray[3]=a,this.plusArray[4]=o;break;case"minus":this.minusArray[0]=e,this.minusArray[1]=n,this.minusArray[2]=i,this.minusArray[3]=a,this.minusArray[4]=o}},dhtmlXTreeObject.prototype.openItem=function(t){this.skipLock=!0;var e=this._globalIdStorageFind(t);return e?this._openItem(e):0},dhtmlXTreeObject.prototype._openItem=function(t){var e=this._getOpenState(t);if(e<0||this.XMLsource&&!t.XMLload){if(!this.callEvent("onOpenStart",[t.id,e]))return 0;this._HideShow(t,2),this.checkEvent("onOpenEnd")&&(this.onXLE==this._epnFHe&&this._epnFHe(this,t.id,!0),this.xmlstate&&this.XMLsource?(this._oie_onXLE.push(this.onXLE),this.onXLE=this._epnFHe):this.callEvent("onOpenEnd",[t.id,this._getOpenState(t)]))}else this._srnd&&this._HideShow(t,2);t.parentObject&&!this._skip_open_parent&&this._openItem(t.parentObject)},dhtmlXTreeObject.prototype.closeItem=function(t){if(this.rootId==t)return 0;this.skipLock=!0;var e=this._globalIdStorageFind(t);if(!e)return 0;e.closeble&&this._HideShow(e,1),this.skipLock=!1},dhtmlXTreeObject.prototype.getLevel=function(t){var e=this._globalIdStorageFind(t);return e?this._getNodeLevel(e,0):0},dhtmlXTreeObject.prototype.setItemCloseable=function(t,e){if(e=dhx4.s2b(e),t&&t.span)var n=t;else n=this._globalIdStorageFind(t);if(!n)return 0;n.closeble=e},dhtmlXTreeObject.prototype._getNodeLevel=function(t,e){return t.parentObject?this._getNodeLevel(t.parentObject,e+1):e},dhtmlXTreeObject.prototype.hasChildren=function(t){var e=this._globalIdStorageFind(t);return e?!(!this.XMLsource||e.XMLload)||e.childsCount:0},dhtmlXTreeObject.prototype._getLeafCount=function(t){for(var e=0,n=0;n<t.childsCount;n++)0==t.childNodes[n].childsCount&&e++;return e},dhtmlXTreeObject.prototype.setItemText=function(t,e,n){var i=this._globalIdStorageFind(t);if(!i)return 0;i.label=e,i.span.innerHTML=e,this.childCalc&&this._fixChildCountLabel(i),i.span.parentNode.parentNode.title=n||""},dhtmlXTreeObject.prototype.getItemTooltip=function(t){var e=this._globalIdStorageFind(t);return e&&(e.span.parentNode.parentNode._dhx_title||e.span.parentNode.parentNode.title)||""},dhtmlXTreeObject.prototype.refreshItem=function(t){t||(t=this.rootId);this._globalIdStorageFind(t);this._dynDeleteBranches[t]=(this._dynDeleteBranches[t]||0)+1,this._loadDynXML(t)},dhtmlXTreeObject.prototype.setItemImage2=function(t,e,n,i){var a=this._globalIdStorageFind(t);if(!a)return 0;a.images[1]=n,a.images[2]=i,a.images[0]=e,this._correctPlus(a)},dhtmlXTreeObject.prototype.setItemImage=function(t,e,n){var i=this._globalIdStorageFind(t);if(!i)return 0;n?(i.images[1]=e,i.images[2]=n):i.images[0]=e,this._correctPlus(i)},dhtmlXTreeObject.prototype.getSubItems=function(t){var e=this._globalIdStorageFind(t,0,1);if(!e)return 0;if(e.unParsed)return this._getSubItemsXML(e.unParsed);var n="";for(i=0;i<e.childsCount;i++)n?n+=this.dlmtr+e.childNodes[i].id:n=""+e.childNodes[i].id;return n},dhtmlXTreeObject.prototype._getAllScraggyItems=function(t){for(var e="",n=0;n<t.childsCount;n++)if(t.childNodes[n].unParsed||t.childNodes[n].childsCount>0){if(t.childNodes[n].unParsed)var i=this._getAllScraggyItemsXML(t.childNodes[n].unParsed,1);else i=this._getAllScraggyItems(t.childNodes[n]);i&&(e?e+=this.dlmtr+i:e=i)}else e?e+=this.dlmtr+t.childNodes[n].id:e=""+t.childNodes[n].id;return e},dhtmlXTreeObject.prototype._getAllFatItems=function(t){for(var e="",n=0;n<t.childsCount;n++)if(t.childNodes[n].unParsed||t.childNodes[n].childsCount>0){if(e?e+=this.dlmtr+t.childNodes[n].id:e=""+t.childNodes[n].id,t.childNodes[n].unParsed)var i=this._getAllFatItemsXML(t.childNodes[n].unParsed,1);else i=this._getAllFatItems(t.childNodes[n]);i&&(e+=this.dlmtr+i)}return e},dhtmlXTreeObject.prototype._getAllSubItems=function(t,e,n){if(n)i=n;else var i=this._globalIdStorageFind(t);if(!i)return 0;e="";for(var a=0;a<i.childsCount;a++){e?e+=this.dlmtr+i.childNodes[a].id:e=""+i.childNodes[a].id;var o=this._getAllSubItems(0,e,i.childNodes[a]);o&&(e+=this.dlmtr+o)}return i.unParsed&&(e=this._getAllSubItemsXML(t,e,i.unParsed)),e},dhtmlXTreeObject.prototype.selectItem=function(t,e,n){e=dhx4.s2b(e);var i=this._globalIdStorageFind(t);if(!i||!i.parentObject)return 0;this.XMLloadingWarning?i.parentObject.openMe=1:this._openItem(i.parentObject);var a=null;n&&((a=new Object).ctrlKey=!0,i.i_sel&&(a.skipUnSel=!0)),e?this.onRowSelect(a,i.htmlNode.childNodes[0].childNodes[0].childNodes[3],!1):this.onRowSelect(a,i.htmlNode.childNodes[0].childNodes[0].childNodes[3],!0)},dhtmlXTreeObject.prototype.getSelectedItemText=function(){for(var t=new Array,e=0;e<this._selected.length;e++)t[e]=this._selected[e].span.innerHTML;return t.join(this.dlmtr)},dhtmlXTreeObject.prototype._compressChildList=function(t,e){t--;for(var n=0;n<t;n++)0==e[n]&&(e[n]=e[n+1],e[n+1]=0)},dhtmlXTreeObject.prototype._deleteNode=function(t,e,n){if(!e||!e.parentObject)return 0;var i=0,a=0;e.tr.nextSibling&&(i=e.tr.nextSibling.nodem),e.tr.previousSibling&&(a=e.tr.previousSibling.nodem);for(var o=e.parentObject,r=o.childsCount,s=o.childNodes,l=0;l<r;l++)if(s[l].id==t){n||o.htmlNode.childNodes[0].removeChild(s[l].tr),s[l]=0;break}this._compressChildList(r,s),n||o.childsCount--,i&&(this._correctPlus(i),this._correctLine(i)),a&&(this._correctPlus(a),this._correctLine(a)),this.tscheck&&this._correctCheckStates(o),n||this._globalIdStorageRecSub(e)},dhtmlXTreeObject.prototype.setCheck=function(t,e){var n=this._globalIdStorageFind(t,0,1);n&&("unsure"===e?this._setCheck(n,e):(e=dhx4.s2b(e),this.tscheck&&this.smcheck?this._setSubChecked(e,n):this._setCheck(n,e)),this.smcheck&&this._correctCheckStates(n.parentObject))},dhtmlXTreeObject.prototype._setCheck=function(t,e){if(t){if((t.parentObject._r_logic||this._frbtr)&&e)if(this._frbtrs)this._frbtrL&&this.setCheck(this._frbtrL.id,0),this._frbtrL=t;else for(var n=0;n<t.parentObject.childsCount;n++)this._setCheck(t.parentObject.childNodes[n],0);var i=t.htmlNode.childNodes[0].childNodes[0].childNodes[1].childNodes[0];t.checkstate="unsure"==e?2:e?1:0,t.dscheck&&(t.checkstate=t.dscheck),this._setSrc(i,this.imPath+(t.parentObject._r_logic||this._frbtr?this.radioArray:this.checkArray)[t.checkstate])}},dhtmlXTreeObject.prototype.setSubChecked=function(t,e){var n=this._globalIdStorageFind(t);this._setSubChecked(e,n),this._correctCheckStates(n.parentObject)},dhtmlXTreeObject.prototype._setSubChecked=function(t,e){if(t=dhx4.s2b(t),e){if((e.parentObject._r_logic||this._frbtr)&&t)for(var n=0;n<e.parentObject.childsCount;n++)this._setSubChecked(0,e.parentObject.childNodes[n]);if(e.unParsed&&this._setSubCheckedXML(t,e.unParsed),e._r_logic||this._frbtr)this._setSubChecked(t,e.childNodes[0]);else for(n=0;n<e.childsCount;n++)this._setSubChecked(t,e.childNodes[n]);var i=e.htmlNode.childNodes[0].childNodes[0].childNodes[1].childNodes[0];e.checkstate=t?1:0,e.dscheck&&(e.checkstate=e.dscheck),this._setSrc(i,this.imPath+(e.parentObject._r_logic||this._frbtr?this.radioArray:this.checkArray)[e.checkstate])}},dhtmlXTreeObject.prototype.isItemChecked=function(t){var e=this._globalIdStorageFind(t);if(e)return e.checkstate},dhtmlXTreeObject.prototype.deleteChildItems=function(t){var e=this._globalIdStorageFind(t);if(e)for(var n=e.childsCount,i=0;i<n;i++)this._deleteNode(e.childNodes[0].id,e.childNodes[0])};function dataProcessor(t){return this.serverProcessor=t,this.action_param="!nativeeditor_status",this.object=null,this.updatedRows=[],this.autoUpdate=!0,this.updateMode="cell",this._tMode="GET",this._headers=null,this._payload=null,this.post_delim="_",this._waitMode=0,this._in_progress={},this._invalid={},this.mandatoryFields=[],this.messages=[],this.styles={updated:"font-weight:bold;",inserted:"font-weight:bold;",deleted:"text-decoration : line-through;",invalid:"background-color:FFE0E0;",invalid_cell:"border-bottom:2px solid red;",error:"color:red;",clear:"font-weight:normal;text-decoration:none;"},this.enableUTFencoding(!0),dhx4._eventable(this),this.connector_init&&(this.setTransactionMode("POST",!0),this.serverProcessor+=(-1!=this.serverProcessor.indexOf("?")?"&":"?")+"editing=true"),this}dhtmlXTreeObject.prototype.deleteItem=function(t,e){if(!this._onrdlh||this._onrdlh(t)){var n=this._deleteItem(t,e);n&&this._fixChildCountLabel(n)}this.allTree.childNodes[0].border="1",this.allTree.childNodes[0].border="0"},dhtmlXTreeObject.prototype._deleteItem=function(t,e,n){e=dhx4.s2b(e);var i=this._globalIdStorageFind(t);if(i){var a=this.getParentId(t),o=i.parentObject;return this._deleteNode(t,i,n),this._editCell&&this._editCell.id==t&&(this._editCell=null),this._correctPlus(o),this._correctLine(o),e&&a!=this.rootId&&this.selectItem(a,1),o}},dhtmlXTreeObject.prototype._globalIdStorageRecSub=function(t){for(var e=0;e<t.childsCount;e++)this._globalIdStorageRecSub(t.childNodes[e]),this._globalIdStorageSub(t.childNodes[e].id);this._globalIdStorageSub(t.id);var n=t;n.span=null,n.tr.nodem=null,n.tr=null,n.htmlNode=null},dhtmlXTreeObject.prototype.insertNewNext=function(t,e,n,i,a,o,r,s,l){var d=this._globalIdStorageFind(t);if(!d||!d.parentObject)return 0;var c=this._attachChildNode(0,e,n,i,a,o,r,s,l,d);return!this.XMLloadingWarning&&this.childCalc&&this._fixChildCountLabel(d.parentObject),c},dhtmlXTreeObject.prototype.getItemIdByIndex=function(t,e){var n=this._globalIdStorageFind(t);return!n||e>=n.childsCount?null:n.childNodes[e].id},dhtmlXTreeObject.prototype.getChildItemIdByIndex=function(t,e){var n=this._globalIdStorageFind(t);return!n||e>=n.childsCount?null:n.childNodes[e].id},dhtmlXTreeObject.prototype.setDragHandler=function(t){this.attachEvent("onDrag",t)},dhtmlXTreeObject.prototype._clearMove=function(){this._lastMark&&(this._lastMark.className=this._lastMark.className.replace(/dragAndDropRow/g,""),this._lastMark=null),this.selectionBar.style.display="none",this.allTree.className=this.allTree.className.replace(" selectionBox","")},dhtmlXTreeObject.prototype.enableDragAndDrop=function(t,e){"temporary_disabled"==t?(this.dADTempOff=!1,t=!0):this.dADTempOff=!0,this.dragAndDropOff=dhx4.s2b(t),this.dragAndDropOff&&this.dragger.addDragLanding(this.allTree,this),arguments.length>1&&(this._ddronr=!dhx4.s2b(e))},dhtmlXTreeObject.prototype._setMove=function(t,e,n){if(t.parentObject.span){var i=dhx4.absTop(t),a=dhx4.absTop(this.allTree)-this.allTree.scrollTop;if(this.dadmodec=this.dadmode,this.dadmodefix=0,2==this.dadmode){var o=n-i+(document.body.scrollTop||document.documentElement.scrollTop)-2-t.offsetHeight/2;Math.abs(o)-t.offsetHeight/6>0?(this.dadmodec=1,o<0&&(this.dadmodefix=0-t.offsetHeight)):this.dadmodec=0}if(0==this.dadmodec){var r=t.parentObject.span;r.className+=" dragAndDropRow",this._lastMark=r}else this._clearMove(),this.selectionBar.style.top=i-a+((parseInt(t.parentObject.span.parentNode.parentNode.offsetHeight)||18)-1)+this.dadmodefix+"px",this.selectionBar.style.left="5px",this.allTree.offsetWidth>20&&(this.selectionBar.style.width=this.allTree.offsetWidth-(_isFF?30:25)+"px"),this.selectionBar.style.display="";this._autoScroll(null,i,a)}},dhtmlXTreeObject.prototype._autoScroll=function(t,e,n){this.autoScroll&&(t&&(e=dhx4.absTop(t),n=dhx4.absTop(this.allTree)-this.allTree.scrollTop),e-n-parseInt(this.allTree.scrollTop)>parseInt(this.allTree.offsetHeight)-50&&(this.allTree.scrollTop=parseInt(this.allTree.scrollTop)+20),e-n<parseInt(this.allTree.scrollTop)+30&&(this.allTree.scrollTop=parseInt(this.allTree.scrollTop)-20))},dhtmlXTreeObject.prototype._createDragNode=function(t,e){if(!this.dADTempOff)return null;var n=t.parentObject;if(!this.callEvent("onBeforeDrag",[n.id,e]))return null;n.i_sel||this._selectItem(n,e),this._checkMSelectionLogic();var i=document.createElement("div"),a=new Array;if(this._itim_dg)for(var o=0;o<this._selected.length;o++)a[o]="<table cellspacing='0' cellpadding='0'><tr><td><img width='18px' height='18px' src='"+this._getSrc(this._selected[o].span.parentNode.previousSibling.childNodes[0])+"'></td><td>"+this._selected[o].span.innerHTML+"</td></tr></table>";else a=this.getSelectedItemText().split(this.dlmtr);return i.innerHTML=a.join(""),i.style.position="absolute",i.className="dragSpanDiv",this._dragged=(new Array).concat(this._selected),i},dhtmlXTreeObject.prototype._focusNode=function(t){var e=dhx4.absTop(t.htmlNode)-dhx4.absTop(this.allTree);(e>this.allTree.offsetHeight-30||e<0)&&(this.allTree.scrollTop=e+this.allTree.scrollTop)},dhtmlXTreeObject.prototype._preventNsDrag=function(t){return!(!t||!t.preventDefault)&&(t.preventDefault(),!1)},dhtmlXTreeObject.prototype._drag=function(t,e,n){this._autoOpenTimer&&clearTimeout(this._autoOpenTimer),n.parentObject||(n=this.htmlNode.htmlNode.childNodes[0].childNodes[0].childNodes[1].childNodes[0],this.dadmodec=0),this._clearMove();var i=t.parentObject.treeNod;if(i&&i._clearMove&&i._clearMove(""),!this.dragMove||this.dragMove()){if(i&&i._clearMove&&i._dragged)a=i._dragged;else var a=new Array(t.parentObject);for(var o=n.parentObject,r=0;r<a.length;r++){var s=this._moveNode(a[r],o);this.dadmodec&&!1!==s&&(o=this._globalIdStorageFind(s,!0,!0)),s&&!this._sADnD&&this.selectItem(s,0,1)}}i&&(i._dragged=new Array)},dhtmlXTreeObject.prototype._dragIn=function(t,e,n,i){if(!this.dADTempOff)return 0;var a=e.parentObject,o=t.parentObject;if(o||!this._ddronr){if(!this.callEvent("onDragIn",[a.id,o?o.id:null,a.treeNod,this]))return o&&this._autoScroll(t),0;if(o){if(null==a.childNodes)return this._setMove(t,n,i),t;for(var r=a.treeNod,s=0;s<r._dragged.length;s++)if(this._checkPNodes(o,r._dragged[s]))return this._autoScroll(t),0;if(this.selectionBar.parentNode.removeChild(this.selectionBar),o.span.parentNode.appendChild(this.selectionBar),this._setMove(t,n,i),this._getOpenState(o)<=0){var l=this;this._autoOpenId=o.id,this._autoOpenTimer=window.setTimeout(function(){l._autoOpenItem(null,l),l=null},1e3)}}else this.allTree.className+=" selectionBox";return t}},dhtmlXTreeObject.prototype._autoOpenItem=function(t,e){e.openItem(e._autoOpenId)},dhtmlXTreeObject.prototype._dragOut=function(t){this._clearMove(),this._autoOpenTimer&&clearTimeout(this._autoOpenTimer)},dhtmlXTreeObject.prototype._getNextNode=function(t,e){return!e&&t.childsCount?t.childNodes[0]:t==this.htmlNode?-1:t.tr&&t.tr.nextSibling&&t.tr.nextSibling.nodem?t.tr.nextSibling.nodem:this._getNextNode(t.parentObject,!0)},dhtmlXTreeObject.prototype._lastChild=function(t){return t.childsCount?this._lastChild(t.childNodes[t.childsCount-1]):t},dhtmlXTreeObject.prototype._getPrevNode=function(t,e){return t.tr&&t.tr.previousSibling&&t.tr.previousSibling.nodem?this._lastChild(t.tr.previousSibling.nodem):t.parentObject?t.parentObject:-1},dhtmlXTreeObject.prototype.findItem=function(t,e,n){var i=this._findNodeByLabel(t,e,n?this.htmlNode:null);return i?(this.selectItem(i.id,!0),this._focusNode(i),i.id):null},dhtmlXTreeObject.prototype.findItemIdByLabel=function(t,e,n){var i=this._findNodeByLabel(t,e,n?this.htmlNode:null);return i?i.id:null},dhtmlXTreeObject.prototype.findStrInXML=function(t,e,n){if(!t.childNodes&&t.item)return this.findStrInJSON(t,e,n);if(!t.childNodes)return!1;for(var i=0;i<t.childNodes.length;i++)if(1==t.childNodes[i].nodeType){var a=t.childNodes[i].getAttribute(e);if(a||"itemtext"!=t.childNodes[i].tagName||(a=t.childNodes[i].firstChild.data),a&&-1!=a.toLowerCase().search(n))return!0;if(this.findStrInXML(t.childNodes[i],e,n))return!0}return!1},dhtmlXTreeObject.prototype.findStrInJSON=function(t,e,n){for(var i=0;i<t.item.length;i++){var a=t.item[i].text;if(a&&-1!=a.toLowerCase().search(n))return!0;if(t.item[i].item&&this.findStrInJSON(t.item[i],e,n))return!0}return!1},dhtmlXTreeObject.prototype._findNodeByLabel=function(t,e,n){t=t.replace(new RegExp("^( )+"),"").replace(new RegExp("( )+$"),"");t=new RegExp(t.replace(/([\^\.\?\*\+\\\[\]\(\)]{1})/gi,"\\$1").replace(/ /gi,".*"),"gi"),n||(n=this._selected[0])||(n=this.htmlNode);var i=n;e?(-1==(a=this._getPrevNode(i))&&(a=this._lastChild(this.htmlNode)),a.unParsed&&this.findStrInXML(a.unParsed.d,"text",t)?(this.reParse(a),n=this._getPrevNode(i)):n=a,-1==n&&(n=this._lastChild(this.htmlNode))):(n.unParsed&&this.findStrInXML(n.unParsed.d,"text",t)&&this.reParse(n),-1==(n=this._getNextNode(i))&&(n=this.htmlNode.childNodes[0]));for(;n&&n!=i;){if(n.label&&-1!=n.label.search(t))return n;if(e){var a;-1==(a=this._getPrevNode(n))&&(a=this._lastChild(this.htmlNode)),a.unParsed&&this.findStrInXML(a.unParsed.d,"text",t)?(this.reParse(a),n=this._getPrevNode(n)):n=a,-1==n&&(n=this._lastChild(this.htmlNode))}else{if(-1==n){if(i==this.htmlNode)break;n=this.htmlNode.childNodes[0]}n.unParsed&&this.findStrInXML(n.unParsed.d,"text",t)&&this.reParse(n),-1==(n=this._getNextNode(n))&&(n=this.htmlNode)}}return null},dhtmlXTreeObject.prototype.moveItem=function(t,e,n,i){var a=this._globalIdStorageFind(t);if(!a)return 0;var o=null;switch(e){case"right":alert("Not supported yet");break;case"item_child":if(!(r=(i||this)._globalIdStorageFind(n)))return 0;o=(i||this)._moveNodeTo(a,r,0);break;case"item_sibling":if(!(r=(i||this)._globalIdStorageFind(n)))return 0;o=(i||this)._moveNodeTo(a,r.parentObject,r);break;case"item_sibling_next":var r;if(!(r=(i||this)._globalIdStorageFind(n)))return 0;o=r.tr&&r.tr.nextSibling&&r.tr.nextSibling.nodem?(i||this)._moveNodeTo(a,r.parentObject,r.tr.nextSibling.nodem):(i||this)._moveNodeTo(a,r.parentObject);break;case"left":a.parentObject.parentObject&&(o=this._moveNodeTo(a,a.parentObject.parentObject,a.parentObject));break;case"up":if(-1==(s=this._getPrevNode(a))||!s.parentObject)return null;o=this._moveNodeTo(a,s.parentObject,s);break;case"up_strict":0!=(s=this._getIndex(a))&&(o=this._moveNodeTo(a,a.parentObject,a.parentObject.childNodes[s-1]));break;case"down_strict":var s=this._getIndex(a),l=a.parentObject.childsCount-2;s==l?o=this._moveNodeTo(a,a.parentObject):s<l&&(o=this._moveNodeTo(a,a.parentObject,a.parentObject.childNodes[s+2]));break;case"down":if(-1==(s=this._getNextNode(this._lastChild(a)))||!s.parentObject)return;if(s.parentObject==a.parentObject)s=this._getNextNode(s);if(-1==s)o=this._moveNodeTo(a,a.parentObject);else{if(-1==s||!s.parentObject)return;o=this._moveNodeTo(a,s.parentObject,s)}}return _isIE&&_isIE<8&&(this.allTree.childNodes[0].border="1",this.allTree.childNodes[0].border="0"),o},dhtmlXTreeObject.prototype.setDragBehavior=function(t,e){switch(this._sADnD=!dhx4.s2b(e),t){case"child":this.dadmode=0;break;case"sibling":this.dadmode=1;break;case"complex":this.dadmode=2}},dhtmlXTreeObject.prototype._loadDynXML=function(t,e){e=e||this.XMLsource;var n=(new Date).valueOf();this._ld_id=t,"function"==this.xmlalb?e&&e(this._escape(t)):"name"==this.xmlalb?this.load(e+this._escape(t)):"xmlname"==this.xmlalb?this.load(e+this._escape(t)+".xml?uid="+n):this.load(e+dhtmlx.url(e)+"uid="+n+"&id="+this._escape(t))},dhtmlXTreeObject.prototype.enableMultiselection=function(t,e){this._amsel=dhx4.s2b(t),this._amselS=dhx4.s2b(e)},dhtmlXTreeObject.prototype._checkMSelectionLogic=function(){for(var t=new Array,e=0;e<this._selected.length;e++)for(var n=0;n<this._selected.length;n++)e!=n&&this._checkPNodes(this._selected[n],this._selected[e])&&(t[t.length]=this._selected[n]);for(e=0;e<t.length;e++)this._unselectItem(t[e])},dhtmlXTreeObject.prototype._checkPNodes=function(t,e){return!this._dcheckf&&(e==t?1:t.parentObject?this._checkPNodes(t.parentObject,e):0)},dhtmlXTreeObject.prototype.disableDropCheck=function(t){this._dcheckf=dhx4.s2b(t)},dhtmlXTreeObject.prototype.enableDistributedParsing=function(t,e,n){this._edsbps=dhx4.s2b(t),this._edsbpsA=new Array,this._edsbpsC=e||10,this._edsbpsD=n||250},dhtmlXTreeObject.prototype.getDistributedParsingState=function(){return!(!this._edsbpsA||!this._edsbpsA.length)},dhtmlXTreeObject.prototype.getItemParsingState=function(t){if(!this._globalIdStorageFind(t,!0,!0))return 0;if(this._edsbpsA)for(var e=0;e<this._edsbpsA.length;e++)if(this._edsbpsA[e][2]==t)return-1;return 1},dhtmlXTreeObject.prototype._distributedStart=function(t,e,n,i,a){this._edsbpsA||(this._edsbpsA=new Array),this._edsbpsA[this._edsbpsA.length]=[t,e,n,i,a]},dhtmlXTreeObject.prototype._distributedStep=function(t){var e=this;if(this._edsbpsA&&this._edsbpsA.length){var n=this._edsbpsA[0];this.parsedArray=new Array,this._parse(n[0],n[2],n[3],n[1]);var i=this._globalIdStorageFind(n[2]);this._redrawFrom(this,i,n[4],this._getOpenState(i));for(var a=this.setCheckList.split(this.dlmtr),o=0;o<a.length;o++)a[o]&&this.setCheck(a[o],1);this._edsbpsA=(new Array).concat(this._edsbpsA.slice(1)),this._edsbpsA.length||(window.setTimeout(function(){e.onXLE&&e.onXLE(e,t),e.callEvent("onXLE",[e,t])},1),e.xmlstate=0)}else e.XMLloadingWarning=0},dhtmlXTreeObject.prototype.enableTextSigns=function(t){this._txtimg=dhx4.s2b(t)},dhtmlXTreeObject.prototype.preventIECaching=function(t){dhx4.ajax.cache=!t},dhtmlXTreeObject.prototype.preventIECashing=dhtmlXTreeObject.prototype.preventIECaching,dhtmlXTreeObject.prototype.disableCheckbox=function(t,e){if("object"!=typeof t)var n=this._globalIdStorageFind(t,0,1);else n=t;n&&(n.dscheck=dhx4.s2b(e)?(n.checkstate||0)%3+3:n.checkstate>2?n.checkstate-3:n.checkstate,this._setCheck(n),n.dscheck<3&&(n.dscheck=!1))},dhtmlXTreeObject.prototype.smartRefreshBranch=function(t,e){this._branchUpdate=1,this.smartRefreshItem(t,e)},dhtmlXTreeObject.prototype.smartRefreshItem=function(t,e){for(var n=this._globalIdStorageFind(t),i=0;i<n.childsCount;i++)n.childNodes[i]._dmark=!0;this.waitUpdateXML=!0,e&&e.exists?this._parse(e,t):this._loadDynXML(t,e)},dhtmlXTreeObject.prototype.refreshItems=function(t,e){var n=t.toString().split(this.dlmtr);this.waitUpdateXML=new Array;for(var i=0;i<n.length;i++)this.waitUpdateXML[n[i]]=!0;this.load((e||this.XMLsource)+dhtmlx.url(e||this.XMLsource)+"ids="+this._escape(t))},dhtmlXTreeObject.prototype.updateItem=function(t,e,n,i,a,o,r){var s=this._globalIdStorageFind(t);return s.userData=new cObject,e&&(s.label=e),s.images=new Array(n||this.imageArray[0],i||this.imageArray[1],a||this.imageArray[2]),this.setItemText(t,e),o&&this._setCheck(s,!0),"1"!=r||this.hasChildren(t)||(s.XMLload=0),this._correctPlus(s),s._dmark=!1,s},dhtmlXTreeObject.prototype.setDropHandler=function(t){this.attachEvent("onDrop",t)},dhtmlXTreeObject.prototype.setOnLoadingStart=function(t){this.attachEvent("onXLS",t)},dhtmlXTreeObject.prototype.setOnLoadingEnd=function(t){this.attachEvent("onXLE",t)},dhtmlXTreeObject.prototype.setXMLAutoLoadingBehaviour=function(t){this.xmlalb=t},dhtmlXTreeObject.prototype.enableSmartCheckboxes=function(t){this.smcheck=dhx4.s2b(t)},dhtmlXTreeObject.prototype.getXMLState=function(){return 1==this.xmlstate},dhtmlXTreeObject.prototype.setItemTopOffset=function(t,e){var n,i=(n="object"!=typeof t?this._globalIdStorageFind(t):t).span.parentNode.parentNode;n.span.style.paddingBottom="1px";for(var a=0;a<i.childNodes.length;a++){if(0!=a)_isIE?(i.childNodes[a].style.height="18px",i.childNodes[a].style.paddingTop=parseInt(e)+"px"):i.childNodes[a].style.height=18+parseInt(e)+"px";else{var o=i.childNodes[a].firstChild;"DIV"!=i.childNodes[a].firstChild.tagName&&(o=document.createElement("DIV"),i.childNodes[a].insertBefore(o,i.childNodes[a].firstChild)),n.parentObject.id==this.rootId&&n.parentObject.childNodes[0]==n||!this.treeLinesOn||(i.childNodes[a].style.backgroundImage="url("+this.imPath+this.lineArray[5]+")"),o.innerHTML="&nbsp;",o.style.overflow="hidden"}o.style.verticalAlign=i.childNodes[a].style.verticalAlign="bottom",_isIE&&(this.allTree.childNodes[0].border="1",this.allTree.childNodes[0].border="0")}},dhtmlXTreeObject.prototype.setIconSize=function(t,e,n){if(n){if(n&&n.span)var i=n;else i=this._globalIdStorageFind(n);if(!i)return 0;var a=i.span.parentNode.previousSibling.childNodes[0];t&&(a.style.width=t+"px",window._KHTMLrv&&(a.parentNode.style.width=t+"px")),e&&(a.style.height=e+"px",window._KHTMLrv&&(a.parentNode.style.height=e+"px"))}else this.def_img_x=t+"px",this.def_img_y=e+"px"},dhtmlXTreeObject.prototype.getItemImage=function(t,e,n){var i=this._globalIdStorageFind(t);if(!i)return"";var a=i.images[e||0];return n&&(a=this.iconURL+a),a},dhtmlXTreeObject.prototype.enableRadioButtons=function(t,e){if(1==arguments.length)return this._frbtr=dhx4.s2b(t),void(this.checkBoxOff=this.checkBoxOff||this._frbtr);var n=this._globalIdStorageFind(t);if(!n)return"";if((e=dhx4.s2b(e))&&!n._r_logic){n._r_logic=!0;for(var i=0;i<n.childsCount;i++)this._setCheck(n.childNodes[i],n.childNodes[i].checkstate)}if(!e&&n._r_logic){n._r_logic=!1;for(i=0;i<n.childsCount;i++)this._setCheck(n.childNodes[i],n.childNodes[i].checkstate)}},dhtmlXTreeObject.prototype.enableSingleRadioMode=function(t){this._frbtrs=dhx4.s2b(t)},dhtmlXTreeObject.prototype.openOnItemAdded=function(t){this._hAdI=!dhx4.s2b(t)},dhtmlXTreeObject.prototype.openOnItemAdding=function(t){this._hAdI=!dhx4.s2b(t)},dhtmlXTreeObject.prototype.enableMultiLineItems=function(t){this.mlitems=!0===t?"100%":t},dhtmlXTreeObject.prototype.enableAutoTooltips=function(t){this.ettip=dhx4.s2b(t)},dhtmlXTreeObject.prototype.clearSelection=function(t){t?this._unselectItem(this._globalIdStorageFind(t)):this._unselectItems()},dhtmlXTreeObject.prototype.showItemSign=function(t,e){var n=this._globalIdStorageFind(t);if(!n)return 0;n.span.parentNode.previousSibling.previousSibling.previousSibling;dhx4.s2b(e)?(n.closeble=!0,n.wsign=!1):(this._openItem(n),n.closeble=!1,n.wsign=!0),this._correctPlus(n)},dhtmlXTreeObject.prototype.showItemCheckbox=function(t,e){if(!t)for(var n in this._idpull)this.showItemCheckbox(this._idpull[n],e);if("object"!=typeof t&&(t=this._globalIdStorageFind(t,0,0)),!t)return 0;t.nocheckbox=!dhx4.s2b(e),t.span.parentNode.previousSibling.previousSibling.childNodes[0].parentNode.style.display=t.nocheckbox?"none":""},dhtmlXTreeObject.prototype.setListDelimeter=function(t){this.dlmtr=t},dhtmlXTreeObject.prototype.setEscapingMode=function(t){this.utfesc=t},dhtmlXTreeObject.prototype.enableHighlighting=function(t){this.ehlt=!0,this.ehlta=dhx4.s2b(t)},dhtmlXTreeObject.prototype._itemMouseOut=function(){var t=this.childNodes[3].parentObject,e=t.treeNod;e.callEvent("onMouseOut",[t.id]),t.id==e._l_onMSI&&(e._l_onMSI=null),e.ehlta&&(t.span.className=t.span.className.replace("_lor",""))},dhtmlXTreeObject.prototype._itemMouseIn=function(){var t=this.childNodes[3].parentObject,e=t.treeNod;e._l_onMSI!=t.id&&e.callEvent("onMouseIn",[t.id]),e._l_onMSI=t.id,e.ehlta&&(t.span.className=t.span.className.replace("_lor",""),t.span.className=t.span.className.replace(/((standart|selected)TreeRow)/,"$1_lor"))},dhtmlXTreeObject.prototype.enableActiveImages=function(t){this._aimgs=dhx4.s2b(t)},dhtmlXTreeObject.prototype.focusItem=function(t){var e=this._globalIdStorageFind(t);if(!e)return 0;this._focusNode(e)},dhtmlXTreeObject.prototype.getAllSubItems=function(t){return this._getAllSubItems(t)},dhtmlXTreeObject.prototype.getAllChildless=function(){return this._getAllScraggyItems(this.htmlNode)},dhtmlXTreeObject.prototype.getAllLeafs=dhtmlXTreeObject.prototype.getAllChildless,dhtmlXTreeObject.prototype._getAllScraggyItems=function(t){for(var e="",n=0;n<t.childsCount;n++)if(t.childNodes[n].unParsed||t.childNodes[n].childsCount>0){if(t.childNodes[n].unParsed)var i=this._getAllScraggyItemsXML(t.childNodes[n].unParsed,1);else i=this._getAllScraggyItems(t.childNodes[n]);i&&(e?e+=this.dlmtr+i:e=i)}else e?e+=this.dlmtr+t.childNodes[n].id:e=""+t.childNodes[n].id;return e},dhtmlXTreeObject.prototype._getAllFatItems=function(t){for(var e="",n=0;n<t.childsCount;n++)if(t.childNodes[n].unParsed||t.childNodes[n].childsCount>0){if(e?e+=this.dlmtr+t.childNodes[n].id:e=""+t.childNodes[n].id,t.childNodes[n].unParsed)var i=this._getAllFatItemsXML(t.childNodes[n].unParsed,1);else i=this._getAllFatItems(t.childNodes[n]);i&&(e+=this.dlmtr+i)}return e},dhtmlXTreeObject.prototype.getAllItemsWithKids=function(){return this._getAllFatItems(this.htmlNode)},dhtmlXTreeObject.prototype.getAllFatItems=dhtmlXTreeObject.prototype.getAllItemsWithKids,dhtmlXTreeObject.prototype.getAllChecked=function(){return this._getAllChecked("","",1)},dhtmlXTreeObject.prototype.getAllUnchecked=function(t){return t&&(t=this._globalIdStorageFind(t)),this._getAllChecked(t,"",0)},dhtmlXTreeObject.prototype.getAllPartiallyChecked=function(){return this._getAllChecked("","",2)},dhtmlXTreeObject.prototype.getAllCheckedBranches=function(){var t=[this._getAllChecked("","",1)],e=this._getAllChecked("","",2);return e&&t.push(e),t.join(this.dlmtr)},dhtmlXTreeObject.prototype._getAllChecked=function(t,e,n){t||(t=this.htmlNode),t.checkstate==n&&(t.nocheckbox||(e?e+=this.dlmtr+t.id:e=""+t.id));for(var i=t.childsCount,a=0;a<i;a++)e=this._getAllChecked(t.childNodes[a],e,n);return t.unParsed&&(e=this._getAllCheckedXML(t.unParsed,e,n)),e||""},dhtmlXTreeObject.prototype.setItemStyle=function(t,e,n){n=n||!1;var i=this._globalIdStorageFind(t);if(!i)return 0;i.span.style.cssText?i.span.style.cssText=n?e:i.span.style.cssText+";"+e:i.span.setAttribute("style",i.span.getAttribute("style")+"; "+e)},dhtmlXTreeObject.prototype.enableImageDrag=function(t){this._itim_dg=dhx4.s2b(t)},dhtmlXTreeObject.prototype.setOnDragIn=function(t){this.attachEvent("onDragIn",t)},dhtmlXTreeObject.prototype.enableDragAndDropScrolling=function(t){this.autoScroll=dhx4.s2b(t)},dhtmlXTreeObject.prototype.setSkin=function(t){var e=this.parentObject.className.replace(/dhxtree_[^ ]*/gi,"");this.parentObject.className=e+" dhxtree_"+t,"dhx_terrace"!=t&&"dhx_web"!=t&&"material"!=t||this.enableTreeLines(!1),"material"==t&&this.setIconSize("25","25")},dhtmlx.extend_api("dhtmlXTreeObject",{_init:function(t){return[t.parent,t.width||"100%",t.height||"100%",t.root_id||0]},auto_save_selection:"enableAutoSavingSelected",auto_tooltip:"enableAutoTooltips",checkbox:"enableCheckBoxes",checkbox_3_state:"enableThreeStateCheckboxes",checkbox_smart:"enableSmartCheckboxes",context_menu:"enableContextMenu",distributed_parsing:"enableDistributedParsing",drag:"enableDragAndDrop",drag_copy:"enableMercyDrag",drag_image:"enableImageDrag",drag_scroll:"enableDragAndDropScrolling",editor:"enableItemEditor",hover:"enableHighlighting",images:"enableTreeImages",image_fix:"enableIEImageFix",image_path:"setImagePath",lines:"enableTreeLines",loading_item:"enableLoadingItem",multiline:"enableMultiLineItems",multiselect:"enableMultiselection",navigation:"enableKeyboardNavigation",radio:"enableRadioButtons",radio_single:"enableSingleRadioMode",rtl:"enableRTL",search:"enableKeySearch",smart_parsing:"enableSmartXMLParsing",smart_rendering:"enableSmartRendering",text_icons:"enableTextSigns",xml:"loadXML",skin:"setSkin"},{}),dhtmlXTreeObject.prototype._dp_init=function(t){t.attachEvent("insertCallback",function(t,e,n){var i=dhx4.ajax.xpath(".//item",t)[0].getAttribute("text");this.obj.insertNewItem(n,e,i,0,0,0,0,"CHILD")}),t.attachEvent("updateCallback",function(t,e,n){var i=dhx4.ajax.xpath(".//item",t)[0].getAttribute("text");this.obj.setItemText(e,i),this.obj.getParentId(e)!=n&&this.obj.moveItem(e,"item_child",n),this.setUpdated(e,!0,"updated")}),t.attachEvent("deleteCallback",function(t,e,n){this.obj.setUserData(e,this.action_param,"true_deleted"),this.obj.deleteItem(e,!1)}),t._methods=["setItemStyle","","changeItemId","deleteItem"],this.attachEvent("onEdit",function(e,n){return 3==e&&t.setUpdated(n,!0),!0}),this.attachEvent("onDrop",function(e,n,i,a,o){a==o&&t.setUpdated(e,!0)}),this._onrdlh=function(e){var n=t.getState(e);return"inserted"==n?(t.set_invalid(e,!1),t.setUpdated(e,!1),!0):"true_deleted"==n?(t.setUpdated(e,!1),!0):(t.setUpdated(e,!0,"deleted"),!1)},this._onradh=function(e){t.setUpdated(e,!0,"inserted")},t._getRowData=function(t){var e={},n=this.obj._globalIdStorageFind(t),i=n.parentObject,a=0;for(a=0;a<i.childsCount&&i.childNodes[a]!=n;a++);for(e.tr_id=n.id,e.tr_pid=i.id,e.tr_order=a,e.tr_text=n.span.innerHTML,i=(n._userdatalist||"").split(","),a=0;a<i.length;a++)e[i[a]]=n.userData["t_"+i[a]];return e}},void 0!==window.dhtmlXCellObject&&(dhtmlXCellObject.prototype.attachTree=function(t){this.callEvent("_onBeforeContentAttach",["tree"]);var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden",this._attachObject(e),this.dataType="tree",this.dataObj=new dhtmlXTreeObject(e,"100%","100%",t||0),this.dataObj.setSkin(this.conf.skin),this.dataObj.allTree.childNodes[0].style.marginTop="2px",this.dataObj.allTree.childNodes[0].style.marginBottom="2px",e=null,this.callEvent("_onContentAttach",[]),this.dataObj}),dhtmlXTreeObject.prototype.makeDraggable=function(t,e){"object"!=typeof t&&(t=document.getElementById(t)),dragger=new dhtmlDragAndDropObject,dropper=new dhx_dragSomethingInTree,dragger.addDraggableItem(t,dropper),t.dragLanding=null,t.ondragstart=dropper._preventNsDrag,t.onselectstart=new Function("return false;"),t.parentObject=new Object,t.parentObject.img=t,t.parentObject.treeNod=dropper,dropper._customDrop=e},dhtmlXTreeObject.prototype.makeDragable=dhtmlXTreeObject.prototype.makeDraggable,dhtmlXTreeObject.prototype.makeAllDraggable=function(t){for(var e=document.getElementsByTagName("div"),n=0;n<e.length;n++)e[n].getAttribute("dragInDhtmlXTree")&&this.makeDragable(e[n],t)},dhtmlXTreeObject.prototype.enableItemEditor=function(t){this._eItEd=dhx4.s2b(t),this._eItEdFlag||(this._edn_click_IE=!0,this._edn_dblclick=!0,this._ie_aFunc=this.aFunc,this._ie_dblclickFuncHandler=this.dblclickFuncHandler,this.setOnDblClickHandler(function(t,e){return this._edn_dblclick&&this._editItem(t,e),!0}),this.setOnClickHandler(function(t,e){return this._stopEditItem(t,e),this.ed_hist_clcik==t&&this._edn_click_IE&&this._editItem(t,e),this.ed_hist_clcik=t,!0}),this._eItEdFlag=!0)},dhtmlXTreeObject.prototype.setOnEditHandler=function(t){this.attachEvent("onEdit",t)},dhtmlXTreeObject.prototype.setEditStartAction=function(t,e){this._edn_click_IE=dhx4.s2b(t),this._edn_dblclick=dhx4.s2b(e)},dhtmlXTreeObject.prototype._stopEdit=function(t,e){if(this._editCell&&(this.dADTempOff=this.dADTempOffEd,this._editCell.id!=t)){var n=!0;e?(n=!1,this.callEvent("onEditCancel",[this._editCell.id,this._editCell._oldValue])):n=this.callEvent("onEdit",[2,this._editCell.id,this,this._editCell.span.childNodes[0].value]),!0===n?n=this._editCell.span.childNodes[0].value:!1===n&&(n=this._editCell._oldValue);var i=n!=this._editCell._oldValue;this._editCell.span.innerHTML=n,this._editCell.label=this._editCell.span.innerHTML;var a=this._editCell.i_sel?"selectedTreeRow":"standartTreeRow";this._editCell.span.className=a,this._editCell.span.parentNode.className="standartTreeRow",this._editCell.span.style.paddingRight=this._editCell.span.style.paddingLeft="5px",this._editCell.span.onclick=this._editCell.span.ondblclick=function(){};var o=this._editCell.id;this.childCalc&&this._fixChildCountLabel(this._editCell),this._editCell=null,e||this.callEvent("onEdit",[3,o,this,i]),this._enblkbrd&&(this.parentObject.lastChild.focus(),this.parentObject.lastChild.focus())}},dhtmlXTreeObject.prototype._stopEditItem=function(t,e){this._stopEdit(t)},dhtmlXTreeObject.prototype.stopEdit=function(t){this._editCell&&this._stopEdit(this._editCell.id+"_non",t)},dhtmlXTreeObject.prototype.editItem=function(t){this._editItem(t,this)},dhtmlXTreeObject.prototype._editItem=function(t,e){if(this._eItEd){this._stopEdit();var n=this._globalIdStorageFind(t);if(!n)return;var i=this.callEvent("onEdit",[0,t,this,n.span.innerHTML]);if(!0===i)i=void 0!==n.span.innerText?n.span.innerText:n.span.textContent;else if(!1===i)return;this.dADTempOffEd=this.dADTempOff,this.dADTempOff=!1,this._editCell=n,n._oldValue=i,n.span.innerHTML="<input type='text' class='intreeeditRow' />",n.span.style.paddingRight=n.span.style.paddingLeft="0px",n.span.onclick=n.span.ondblclick=function(t){(t||event).cancelBubble=!0},n.span.childNodes[0].value=i,n.span.childNodes[0].onselectstart=function(t){return(t||event).cancelBubble=!0,!0},n.span.childNodes[0].onmousedown=function(t){return(t||event).cancelBubble=!0,!0},n.span.childNodes[0].focus(),n.span.childNodes[0].focus(),n.span.onclick=function(t){return(t||event).cancelBubble=!0,!1},n.span.className="",n.span.parentNode.className="";var a=this;n.span.childNodes[0].onkeydown=function(t){t||(t=window.event),13==t.keyCode?(t.cancelBubble=!0,a._stopEdit(window.undefined)):27==t.keyCode&&a._stopEdit(window.undefined,!0),(t||event).cancelBubble=!0},this.callEvent("onEdit",[1,t,this])}},jsonPointer.prototype={text:function(){var t=function(t){for(var n=[],i=0;i<t.length;i++)n.push("{"+e(t[i])+"}");return n.join(",")},e=function(n){var i=[];for(var a in n)"object"==typeof n[a]?a.length?i.push('"'+a+'":['+t(n[a])+"]"):i.push('"'+a+'":{'+e(n[a])+"}"):i.push('"'+a+'":"'+n[a]+'"');return i.join(",")};return"{"+e(this.d)+"}"},get:function(t){return this.d[t]},exists:function(){return!!this.d},content:function(){return this.d.content},each:function(t,e,n){var i=this.d[t],a=new jsonPointer;if(i)for(var o=0;o<i.length;o++)a.d=i[o],e.apply(n,[a,o])},get_all:function(){return this.d},sub:function(t){return new jsonPointer(this.d[t],this.d)},sub_exists:function(t){return!!this.d[t]},each_x:function(t,e,n,i,a){var o=this.d[t],r=new jsonPointer(0,this.d);if(o)for(a=a||0;a<o.length;a++)if(o[a][e]&&(r.d=o[a],-1==n.apply(i,[r,a])))return},up:function(t){return new jsonPointer(this.dp,this.d)},set:function(t,e){this.d[t]=e},clone:function(t){return new jsonPointer(this.d,this.dp)},through:function(t,e,n,i,a){var o=this.d[t];if(o.length)for(var r=0;r<o.length;r++){if(null!=o[r][e]&&""!=o[r][e]&&(!n||o[r][e]==n)){var s=new jsonPointer(o[r],this.d);i.apply(a,[s,r])}var l=this.d;this.d=o[r],this.sub_exists(t)&&this.through(t,e,n,i,a),this.d=l}}},dhtmlXTreeObject.prototype.loadJSArrayFile=function(t,e){return window.console&&window.console.info&&window.console.info("loadJSArrayFile was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this._loadJSArrayFile(t,e)},dhtmlXTreeObject.prototype._loadJSArrayFile=function(file,callback){this.parsCount||this.callEvent("onXLS",[this,this._ld_id]),this._ld_id=null,this.xmlstate=1;var that=this;this.XMLLoader=function(xml,callback){eval("var z="+xml.responseText),this._loadJSArray(z),callback&&callback.call(this,xml)},dhx4.ajax.get(file,function(t){that.XMLLoader(t.xmlDoc,callback)})},dhtmlXTreeObject.prototype.loadCSV=function(t,e){return window.console&&window.console.info&&window.console.info("loadCSV was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this._loadCSV(t,e)},dhtmlXTreeObject.prototype._loadCSV=function(t,e){this.parsCount||this.callEvent("onXLS",[this,this._ld_id]),this._ld_id=null,this.xmlstate=1;var n=this;this.XMLLoader=function(t,e){this._loadCSVString(t.responseText),e&&e.call(this,t)},dhx4.ajax.get(t,function(t){n.XMLLoader(t.xmlDoc,e)})},dhtmlXTreeObject.prototype.loadJSArray=function(t,e){return window.console&&window.console.info&&window.console.info("loadJSArray was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this._loadJSArray(t,e)},dhtmlXTreeObject.prototype._loadJSArray=function(t,e){for(var n=[],i=0;i<t.length;i++)n[t[i][1]]||(n[t[i][1]]=[]),n[t[i][1]].push({id:t[i][0],text:t[i][2]});var a={id:this.rootId},o=function(t,e){if(n[t.id]){t.item=n[t.id];for(var i=0;i<t.item.length;i++)e(t.item[i],e)}};o(a,o),this._loadJSONObject(a,e)},dhtmlXTreeObject.prototype.loadCSVString=function(t,e){return window.console&&window.console.info&&window.console.info("loadCSVString was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this._loadCSVString(t,e)},dhtmlXTreeObject.prototype._loadCSVString=function(t,e){for(var n=[],i=t.split("\n"),a=0;a<i.length;a++){var o=i[a].split(",");n[o[1]]||(n[o[1]]=[]),n[o[1]].push({id:o[0],text:o[2]})}var r={id:this.rootId},s=function(t,e){if(n[t.id]){t.item=n[t.id];for(var i=0;i<t.item.length;i++)e(t.item[i],e)}};s(r,s),this._loadJSONObject(r,e)},dhtmlXTreeObject.prototype.loadJSONObject=function(t,e){return window.console&&window.console.info&&window.console.info("loadJSONObject was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this._loadJSONObject(t,e)},dhtmlXTreeObject.prototype._loadJSONObject=function(t,e){this.parsCount||this.callEvent("onXLS",[this,null]),this.xmlstate=1;var n=new jsonPointer(t);this._parse(n),this._p=n,e&&e()},dhtmlXTreeObject.prototype.loadJSON=function(t,e){return window.console&&window.console.info&&window.console.info("loadJSON was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this._loadJSON(t,e)},dhtmlXTreeObject.prototype._loadJSON=function(file,callback){this.parsCount||this.callEvent("onXLS",[this,this._ld_id]),this._ld_id=null,this.xmlstate=1;var that=this;this.XMLLoader=function(xml,callback){try{eval("var t="+xml.responseText)}catch(t){return void dhx4.callEvent("onLoadXMLerror",["Incorrect JSON",xml,this])}var p=new jsonPointer(t);this._parse(p),this._p=p,callback&&callback.call(this,xml)},dhx4.ajax.get(file,function(t){that.XMLLoader(t.xmlDoc,callback)})},dhtmlXTreeObject.prototype.serializeTreeToJSON=function(){for(var t=['{"id":"'+this.rootId+'", "item":['],e=[],n=0;n<this.htmlNode.childsCount;n++)e.push(this._serializeItemJSON(this.htmlNode.childNodes[n]));return t.push(e.join(",")),t.push("]}"),t.join("")},dhtmlXTreeObject.prototype._serializeItemJSON=function(t){var e=[];if(t.unParsed)return t.unParsed.text();if(this._selected.length)var n=this._selected[0].id;else n="";var i=t.span.innerHTML;if(i=i.replace(/\"/g,'\\"',i),this._xfullXML?e.push('{ "id":"'+t.id+'", '+(1==this._getOpenState(t)?' "open":"1", ':"")+(n==t.id?' "select":"1",':"")+' "text":"'+i+'", "im0":"'+t.images[0]+'", "im1":"'+t.images[1]+'", "im2":"'+t.images[2]+'" '+(t.acolor?', "aCol":"'+t.acolor+'" ':"")+(t.scolor?', "sCol":"'+t.scolor+'" ':"")+(1==t.checkstate?', "checked":"1" ':2==t.checkstate?', "checked":"-1"':"")+(t.closeable?', "closeable":"1" ':"")+(this.XMLsource&&0==t.XMLload?', "child":"1" ':"")):e.push('{ "id":"'+t.id+'", '+(1==this._getOpenState(t)?' "open":"1", ':"")+(n==t.id?' "select":"1",':"")+' "text":"'+i+'"'+(this.XMLsource&&0==t.XMLload?', "child":"1" ':"")),this._xuserData&&t._userdatalist){e.push(', "userdata":[');for(var a=t._userdatalist.split(","),o=[],r=0;r<a.length;r++)o.push('{ "name":"'+a[r]+'" , "content":"'+t.userData["t_"+a[r]]+'" }');e.push(o.join(",")),e.push("]")}if(t.childsCount){e.push(', "item":[');for(o=[],r=0;r<t.childsCount;r++)o.push(this._serializeItemJSON(t.childNodes[r]));e.push(o.join(",")),e.push("]\n")}return e.push("}\n"),e.join("")},window.addEventListener?window.addEventListener("load",dhx_init_trees,!1):window.attachEvent&&window.attachEvent("onload",dhx_init_trees),dhtmlXTreeView.prototype.modules={},dhtmlXTreeView.prototype.setSkin=function(t){this.base.className=String(this.base.className).replace(new RegExp("s{0,}dhxtreeview_"+(this.conf.skin||"")),"")+" dhxtreeview_"+t,this.conf.skin=t,this.conf.icon_width=dhx4.readFromCss("dhxtreeview_"+this.conf.skin+" dhxtreeview_icon_width"),this.conf.ofs="dhx_skyblue"==this.conf.skin?{w:1,h:0}:{w:0,h:0}},dhtmlXTreeView.prototype.setItemText=function(t,e){null!=this.items[t]&&(this.items[t].text=e,this.items[t].item.firstChild.childNodes[this.conf.idx.text].innerHTML=e,this._callPublicEvent("onTextChange",[t,e]))},dhtmlXTreeView.prototype.getItemText=function(t){return this.items[t].text},dhtmlXTreeView.prototype.showItem=function(t){for(var e=0,n=!1;t;){var i=this.items[t];if(!i)break;e+=i.item.offsetTop+(n?i.item.firstChild.offsetHeight:0),t=i.pId,n=!0}this.cont.scrollTop=e},dhtmlXTreeView.prototype.getParentId=function(t){return this.items[t].pId},dhtmlXTreeView.prototype.getSubItems=function(t){var e=[];for(var n in this.items)this.items[n].pId==t&&e.push(n);return e},dhtmlXTreeView.prototype._refreshItemHtml=function(t,e,n){this.items[t].item.firstChild.innerHTML=this._getItemHtml(t),1==e&&this._signUpdate(t),1==n&&this._iconUpdate(t)},dhtmlXTreeView.prototype._getItemHtml=function(t){var e=[],n=0;for(var i in this.conf.idx){var a=this["_itemHtml_"+i](t,n);!1!==a.nodeText&&(e.push(a.nodeText),n+=a.nodeIndex)}return e.join("")},dhtmlXTreeView.prototype._getIconOfs=function(t,e){return(this.items[t].level-1+e)*this.conf.icon_width},dhtmlXTreeView.prototype._itemHtml_text=function(t,e){return{nodeIndex:1,nodeText:"<div class='dhxtreeview_item_label' style='left:"+this._getIconOfs(t,e)+"px;'>"+this.items[t].text+"</div>"}},dhtmlXTreeView.prototype.setUserData=function(t,e,n){var i=this.items[t];i&&(i.userdata[e]=n)},dhtmlXTreeView.prototype.getUserData=function(t,e){var n=this.items[t];return n&&!e?n.userdata:n&&n.userdata[e]||null},dhtmlXTreeView.prototype.silent=function(t){this.conf.silent=!0,"function"==typeof t&&t.apply(window,[this]),this.conf.silent=!1},dhtmlXTreeView.prototype._callPublicEvent=function(){return 0!=this.conf.silent||this.callEvent.apply(this,arguments)},dhtmlXTreeView.prototype.refreshItem=function(t){t=t||0,this.deleteChildItems(t),this._dynLoadRequest(t)},dhtmlXTreeView.prototype.getLevel=function(t){for(var e=this.items[t],n=0;e;)n++,e=this.items[e.pId];return n},"function"==typeof window.dhtmlXCellObject&&(dhtmlXCellObject.prototype.attachTreeView=function(t){this.callEvent("_onBeforeContentAttach",["treeview"]);var e=document.createElement("DIV");e.style.position="relative",e.style.overflow="hidden",e.style.width="100%",e.style.height="100%",this._attachObject(e);var n={parent:e,skin:this.conf.skin};if(null!=t&&"object"==typeof t)for(var i in t)void 0===n[i]&&(n[i]=t[i]);return this.dataType="treeview",this.dataObj=new dhtmlXTreeView(n),"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell&&(e.className+=" dhxtreeview_with_border",this.dataObj.conf.adjust_base=!0,this.dataObj.setSizes()),n.parent=null,n=e=t=null,this.callEvent("_onContentAttach",[]),this.dataObj}),dhtmlXTreeView.prototype.modules.chbx={init:"_chbxInit"},dhtmlXTreeView.prototype.enableCheckboxes=function(t){if(t=1==t,this.conf.enable_chbx!=t)for(var e in this.conf.enable_chbx=t,this._chbxUpdIndex(),this.items)this._refreshItemHtml(e,!0,!0)},dhtmlXTreeView.prototype.getAllChecked=function(t){return this._chbxGetCheckedBranch(t,!0)},dhtmlXTreeView.prototype.getAllUnchecked=function(t){return this._chbxGetCheckedBranch(t,!1)},dhtmlXTreeView.prototype.checkItem=function(t){this._chbxSetChecked(t,!0,!0)},dhtmlXTreeView.prototype.uncheckItem=function(t){this._chbxSetChecked(t,!1,!0)},dhtmlXTreeView.prototype.isItemChecked=function(t){return null==this.items[t]?null:1==this.items[t].checked},dhtmlXTreeView.prototype.enableCheckbox=function(t){this._chbxSetEnabled(t,!0)},dhtmlXTreeView.prototype.disableCheckbox=function(t){this._chbxSetEnabled(t,!1)},dhtmlXTreeView.prototype.isCheckboxEnabled=function(t){return 1==this.items[t].chbx_enabled},dhtmlXTreeView.prototype.showCheckbox=function(t){this._chbxSetVisible(t,!0)},dhtmlXTreeView.prototype.hideCheckbox=function(t){this._chbxSetVisible(t,!1)},dhtmlXTreeView.prototype.isCheckboxVisible=function(t){return 1==this.items[t].chbx_visible},dhtmlXTreeView.prototype._chbxInit=function(t){this.enableCheckboxes(t.checkboxes),this.attachEvent("_onItemRendered",function(t,e){this.items[t].checked=window.dhx4.s2b(e.checked);var n=e.checkbox||"enabled,visible";this.items[t].chbx_enabled=null==n.match(/disabled/),this.items[t].chbx_visible=null==n.match(/hidden/)}),this.attachEvent("_onTreeClick",function(t,e){if(1==this.conf.enable_chbx){var n=t.target||t.srcElement;if("i"==n.tagName.toLowerCase()&&(n=n.parentNode),null!=(n.parentNode.className||"").match(/dhxtreeview_item_text/)&&n==n.parentNode.childNodes[this.conf.idx.chbx]){var i=n.parentNode.parentNode._itemId;1==this.items[i].chbx_enabled&&this._chbxSetChecked(i,!this.items[i].checked,!0),e.stop=!0}}}),t=null},dhtmlXTreeView.prototype._itemHtml_chbx=function(t,e){var n={nodeIndex:0,nodeText:!1};return 1==this.conf.enable_chbx&&(1==this.items[t].chbx_visible&&(n.nodeIndex=1),n.nodeText="<div class='dhxtreeview_item_icon' style='left:"+this._getIconOfs(t,e)+"px;"+(n.nodeIndex>0?"":"display:none;")+"'>"+this._chbxGenIcon(t)+"</div>"),n},dhtmlXTreeView.prototype._chbxSetChecked=function(t,e){if(1==this.conf.enable_chbx&&(e=1==e,this.items[t].checked!=e)){if(!0!==this._callPublicEvent("onBeforeCheck",[t,1==this.items[t].checked]))return;this.items[t].checked=e,this.items[t].item.childNodes[0].childNodes[this.conf.idx.chbx].innerHTML=this._chbxGenIcon(t),this._callPublicEvent("onCheck",[t,e])}},dhtmlXTreeView.prototype._chbxSetEnabled=function(t,e){this.items[t].chbx_enabled!=e&&(this.items[t].chbx_enabled=e,this.items[t].item.firstChild.childNodes[this.conf.idx.chbx].innerHTML=this._chbxGenIcon(t))},dhtmlXTreeView.prototype._chbxSetVisible=function(t,e){this.items[t].chbx_visible!=e&&(this.items[t].chbx_visible=e,this._refreshItemHtml(t,!0,!0))},dhtmlXTreeView.prototype._chbxGenIcon=function(t){var e=this.conf.icons["chbx_"+(this.items[t].chbx_enabled?"":"dis_")+(this.items[t].checked?"1":"0")];return'<i class="'+this.conf.icons.prefix+" "+e+'"></i>'},dhtmlXTreeView.prototype._chbxUpdIndex=function(){1==this.conf.enable_chbx?this.conf.idx={sign:0,chbx:1,icon:2,text:3}:this.conf.idx={sign:0,icon:1,text:2}},dhtmlXTreeView.prototype._chbxGetCheckedBranch=function(t,e){var n=[];for(var i in this.items)this.items[i].pId==t&&(this.items[i].checked==e&&n.push(i),1==this.items[i].kids&&(n=n.concat(this._chbxGetCheckedBranch(i,e))));return n},dhtmlXTreeView.prototype.modules.sign={init:"_signInit"},dhtmlXTreeView.prototype._signInit=function(){this.attachEvent("_onTreeClick",function(t,e){if(1!=e.stop){var n=t.target||t.srcElement;"i"==n.tagName.toLowerCase()&&(n=n.parentNode),null!=(n.parentNode.className||"").match(/dhxtreeview_item_text/)&&n==n.parentNode.childNodes[this.conf.idx.sign]&&(this._openCloseItem(n.parentNode.parentNode._itemId,!0),e.stop=!0)}})},dhtmlXTreeView.prototype._signUpdate=function(t){var e=this.items[t],n=e.item.childNodes[0].childNodes[this.conf.idx.sign];1==e.kids||1==e.kids_request?n.innerHTML='<i class="'+this.conf.icons.prefix+" "+this.conf.icons[e.opened||e.half_opened?"minus":"plus"]+'"></i>':n.innerHTML="",e=n=null},dhtmlXTreeView.prototype._itemHtml_sign=function(t,e){return{nodeIndex:1,nodeText:"<div class='dhxtreeview_item_icon' style='left:"+this._getIconOfs(t,e)+"px;'></div>"}},dhtmlXTreeView.prototype.modules.selection={init:"_selectionInit"},dhtmlXTreeView.prototype.selectItem=function(t){if(1==this.conf.msel){var e={};t instanceof Array||(t=[t]);for(var n=0;n<t.length;n++)e[t[n]]=!0;for(var i in this.conf.selected)1==e[i]?delete e[i]:this._setSelected(i,!1);for(var i in e)this._setSelected(i,!0)}else null==t||1==this.conf.selected[t]||t instanceof Array||0==this._clearSelection(t)&&this._setSelected(t,!0)},dhtmlXTreeView.prototype.unselectItem=function(t){if(1==this.conf.msel){t instanceof Array||(t=[t]);for(var e=0;e<t.length;e++)1==this.conf.selected[t[e]]&&this._setSelected(t[e],!1)}else null!=t&&this._setSelected(t,!1)},dhtmlXTreeView.prototype.getSelectedId=function(){var t=[];for(var e in this.conf.selected)t.push(e);return this.conf.msel?t:t[0]||null},dhtmlXTreeView.prototype.enableMultiselect=function(t){t=1==t,this.conf.msel!=t&&(this._clearSelection(),this.conf.msel=t)},dhtmlXTreeView.prototype._selectionInit=function(t){this.conf.msel=window.dhx4.s2b(t.multiselect),this.attachEvent("_onTreeClick",function(t,e){if(1!=e.stop){var n=t.target||t.srcElement;"i"==n.tagName.toLowerCase()&&(n=n.parentNode);var i=null;if(null!=n.className.match(/dhxtreeview_item_label/)?i=n.parentNode.parentNode._itemId:null!=n.className.match(/^dhxtreeview_item_text/)?i=n.parentNode._itemId:null!=n.className.match(/^dhxtreeview_item_icon/)&&(i=n.parentNode.parentNode._itemId),null!=i){var a=new Date;this._click_item!==i||a-(this._click_timer||0)>300?(this._callPublicEvent("onClick",[i]),this._click_timer=a,this._click_item=i):(this._callPublicEvent("onDblClick",[i]),this._click_item=null),1==this.conf.msel?1!=t.ctrlKey&&1!=this.conf.mac_cmd_key||0!=t.shiftKey||0!=t.altKey?0==t.ctrlKey&&0==t.shiftKey&&0==t.altKey&&0==this.conf.mac_cmd_key&&0==this._clearSelection(i)&&this._setSelected(i,!0):this._setSelected(i,!this._isSelected(i)):0==this._clearSelection(i)&&this._setSelected(i,!0)}}})},dhtmlXTreeView.prototype._setSelected=function(t,e){1==e?1!=this.conf.selected[t]&&(this.items[t].item.childNodes[0].className+=" dhxtreeview_item_text_selected",this.conf.selected[t]=!0,this._callPublicEvent("onSelect",[t,!0])):1==this.conf.selected[t]&&(this.items[t].item.childNodes[0].className=String(this.items[t].item.childNodes[0].className).replace(/\s*dhxtreeview_item_text_selected/gi,""),delete this.conf.selected[t],this._callPublicEvent("onSelect",[t,!1]))},dhtmlXTreeView.prototype._clearSelection=function(t){var e=!1;for(var n in this.conf.selected)null!=t&&n==t?e=!0:this._setSelected(n,!1);return e},dhtmlXTreeView.prototype._isSelected=function(t){return 1==this.conf.selected[t]},dhtmlXTreeView.prototype.modules.icons={init:"_iconModuleInit"},dhtmlXTreeView.prototype.setItemIcons=function(t,e){if(null==e&&null!=this.items[t].icons)delete this.items[t].icons;else if(null!=e)for(var n in null==this.items[t].icons&&(this.items[t].icons={}),e)null!=e[n]?this.items[t].icons[n]=e[n]:null==e[n]&&null!=this.items[t].icons[n]&&delete this.items[t].icons[n];this._iconUpdate(t)},dhtmlXTreeView.prototype.setIconColor=function(t,e){var n=this.items[t].item.firstChild.childNodes[this.conf.idx.icon].firstChild;null==e?null!=this.items[t].icon_color&&(delete this.items[t].icon_color,n.style.color="inherit"):this.items[t].icon_color!=e&&(this.items[t].icon_color=e,n.style.color=e),n=null},dhtmlXTreeView.prototype.setIconset=function(t){null!=this.icons[t]&&1==this.icons[t].r&&(this.conf.icons=this.icons[t])},dhtmlXTreeView.prototype._iconModuleInit=function(){this.attachEvent("_onItemRendered",function(t,e){null!=e.icons&&(this.items[t].icons=e.icons),null!=e.icon_color&&(this.items[t].icon_color=e.icon_color)})},dhtmlXTreeView.prototype._iconConf=function(t){var e=this.items[t].icons||{};for(var n in{folder_opened:1,folder_closed:1,file:1})void 0===e[n]&&(e[n]=this.conf.icons[n]);return e},dhtmlXTreeView.prototype._iconHtml=function(t,e){var n=['class="'+this.conf.icons.prefix+" "+e+'"'];return null!=this.items[t].icon_color&&n.push('style="color:'+this.items[t].icon_color+';"'),"<i "+n.join(" ")+"></i>"},dhtmlXTreeView.prototype._itemHtml_icon=function(t,e){return{nodeIndex:1,nodeText:"<div class='dhxtreeview_item_icon' style='left:"+this._getIconOfs(t,e)+"px;'>"+this._iconHtml(t,this._iconConf(t).file)+"</div>"}},dhtmlXTreeView.prototype._iconUpdate=function(t){var e=this.items[t],n=this._iconConf(t),i=1==e.kids||1==e.kids_request?n[e.opened?"folder_opened":"folder_closed"]:n.file;e.item.childNodes[0].childNodes[this.conf.idx.icon].innerHTML=this._iconHtml(t,i),e=null},dhtmlXTreeView.prototype.icons={tree_native:{r:!0,prefix:"dhxtreeview_icon",plus:"dhxtreeview_icon_plus",minus:"dhxtreeview_icon_minus",file:"dhxtreeview_icon_file",folder_opened:"dhxtreeview_icon_folder_opened",folder_closed:"dhxtreeview_icon_folder_closed",loading:"dhxtreeview_icon_loading",chbx_0:"dhxtreeview_icon_chbx_0",chbx_1:"dhxtreeview_icon_chbx_1",chbx_dis_0:"dhxtreeview_icon_chbx_dis_0",chbx_dis_1:"dhxtreeview_icon_chbx_dis_1"},font_awesome:{r:!(1==window.dhx4.isIE6||1==window.dhx4.isIE7),prefix:"fa",plus:"fa-caret-right",minus:"fa-caret-down",file:"fa-file-o",folder_opened:"fa-folder-open-o",folder_closed:"fa-folder-o",loading:"fa-refresh fa-spin",chbx_0:"fa-square-o",chbx_1:"fa-check-square-o",chbx_dis_0:"fa-square-o dhx-disabled",chbx_dis_1:"fa-check-square-o dhx-disabled"}},dhtmlXTreeView.prototype.modules.loading={init:"_loadingInit",unload:"_loadingUnload"},dhtmlXTreeView.prototype._loadingInit=function(t){window.dhx4._enableDataLoading(this,"_initObj","_xmlToObj","tree",{struct:!0}),this.conf.root_id=void 0===t.root_id||null==t.root_id?"0":t.root_id,this._dhxdataload.onBeforeXLS=function(t){return null==this.conf.autoload.url&&(this.conf.autoload.url=t),{url:t.replace(/\{id\}/gi,this.conf.root_id)}}},dhtmlXTreeView.prototype._loadingUnload=function(){window.dhx4._enableDataLoading(this,null,null,null,"clear")},dhtmlXTreeView.prototype._initObj=function(t,e,n,i){for(var a=0;a<t.length;a++){var o=t[a].id;null==o&&(o="dhxtreeview_id_"+window.dhx4.newId()),null==this.items[o]&&this._addItem(o,n,t[a]),null!=t[a].items&&this._initObj(t[a].items,null,o,!0)}1!=i&&this._fixAreaWidth()},dhtmlXTreeView.prototype._xmlToObj=function(t,e){1!=e&&(t=t.getElementsByTagName("tree")[0]);for(var n=[],i=0;i<t.childNodes.length;i++){var a=t.childNodes[i];if("item"==(a.tagName||"").toLowerCase()){for(var o={},r=0;r<a.attributes.length;r++)o[a.attributes[r].name]=a.attributes[r].value;if(a.childNodes.length>0){(e=this._xmlToObj(a,!0)).length>0&&(o.items=e);for(r=0;r<a.childNodes.length;r++){var s=(a.childNodes[r].tagName||"").toLowerCase();if(1=={icons:1,userdata:1}[s]){null==o[s]&&(o[s]={});for(var l=0;l<a.childNodes[r].attributes.length;l++){var d=a.childNodes[r].attributes[l].name;null==o[s][d]&&(o[s][d]=a.childNodes[r].attributes[l].value)}}n2=null}}n.push(o)}a=null}return n},dhtmlXTreeView.prototype.modules.dnd={init:"_dndInit",unload:"_dndUnload"},dhtmlXTreeView.prototype.enableDragAndDrop=function(t){this.conf.enable_dnd=window.dhx4.s2b(t)},dhtmlXTreeView.prototype._dndInit=function(t){var e=this;this.enableDragAndDrop(t.dnd),this.conf.dnd=null,this._dndOnMouseDown=function(t){if(1==e.conf.enable_dnd){if(void 0!==(t=t||event).button&&t.button>=2)return!1;for(var n=null,i=null,a=t.target||t.srcElement,o=window.dhx4.absLeft(a)+(void 0===t.offsetX?t.layerX:t.offsetX)-t.clientX,r=window.dhx4.absTop(a)+(void 0===t.offsetY?t.layerY:t.offsetY)-t.clientY;null!=a&&a!=e.cont;)null!=(a.className||"").match(/dhxtreeview_item/)&&null!=a._itemId?(n=a._itemId,i=a._treeId,a=null):a=a.parentNode;a=null,null!=n&&(e.conf.dnd={inited:!1,id:n,treeId:i,selected:1==e.conf.selected[n],tid:null,drop:{},x:t.clientX,y:t.clientY,ofs_x:o,ofs_y:r,zi:window.dhx4.newId(),scroll:!1,scroll_ofs:5,scroll_time:30,scroll_tm:null,kids:{},idx:{}},e._dndInitEvents())}},this._dndOnMouseMove=function(t){if(t=t||event,1!=e.conf.dnd.inited){if(!(Math.abs(e.conf.dnd.x-t.clientX)>=15||Math.abs(e.conf.dnd.y-t.clientY)>=15))return;if(!0!==e._callPublicEvent("onBeforeDrag",[e.conf.dnd.id]))return;e.conf.dnd.inited=!0,e.cont.className+=" dhxtreeview_dnd_mode",e._dndInitDraggedObj(),e._dndCollectKids(e.conf.dnd.id),e._dndCollectIndexes(e.area),0==e._clearSelection(e.conf.dnd.id)&&e._setSelected(e.conf.dnd.id,!0),e.items[e.conf.dnd.id].item.className+=" dhxtreeview_item_dragged",document.body.className+=" dhxtreeview_dnd_mode",e.conf.dnd.cont={x1:window.dhx4.absLeft(e.base),y1:window.dhx4.absTop(e.base)},e.conf.dnd.cont.x2=e.conf.dnd.cont.x1+e.base.offsetWidth,e.conf.dnd.cont.y2=e.conf.dnd.cont.y1+e.base.offsetHeight}e.conf.dnd.x=t.clientX,e.conf.dnd.y=t.clientY,e._dndAdjustDraggedObj();var n=!0;e.cont.scrollHeight>e.cont.clientHeight&&e.conf.dnd.x>=e.conf.dnd.cont.x1&&e.conf.dnd.x<=e.conf.dnd.cont.x2&&(e.cont.scrollTop>0&&e.conf.dnd.y>=e.conf.dnd.cont.y1&&e.conf.dnd.y<=e.conf.dnd.cont.y1+10?(e._dndScroll("up"),n=!1):e.cont.scrollTop+e.cont.clientHeight<e.cont.scrollHeight&&e.conf.dnd.y<=e.conf.dnd.cont.y2&&e.conf.dnd.y>=e.conf.dnd.cont.y2-10&&(e._dndScroll("down"),n=!1)),1==n&&1==e.conf.dnd.scroll&&e._dndScroll("stop");var i=t.target||t.srcElement;if(null==i.parentNode||null==(i.parentNode.className||"").match(/dhxtreeview_kids_cont/)){var a=!1,o=null,r=null;if(null!=i.className&&(null!=i.className.match(/dhxtreeview_item_[li]/)?(o=i.parentNode.parentNode._itemId,r=i.parentNode.parentNode._treeId):null!=i.className.match(/dhxtreeview_item_[t]/)&&(o=i.parentNode._itemId,r=i.parentNode._treeId)),null==o||r==e.conf.dnd.treeId){if(e.conf.dnd.id!=o&&1!=e.conf.dnd.kids[o]||(o=null),null!=o){var s=e.items[o].item.firstChild.offsetHeight,l=Math.max(Math.floor(3*Math.min(t.offsetY,s)/s),0);0==l?e.items[o].item.previousSibling==e.items[e.conf.dnd.id].item&&(l=null):1==l?e.items[e.conf.dnd.id].pId==o?l=null:1==e.items[o].kids&&e.items[o].item.lastChild.firstChild.firstChild==e.items[e.conf.dnd.id].item?l=null:e.items[o].opened:2==l&&(1==e.items[o].opened?l=null:e.items[o].item.nextSibling==e.items[e.conf.dnd.id].item&&(l=null)),l!=e.conf.dnd.ofs&&(e.conf.dnd.ofs=l,a=!0)}if(o!=e.conf.dnd.tid&&(null!=e.conf.dnd.tid&&e._dndUpdateTargetCss(e.conf.dnd.tid,!1),null!=o&&(a=!0),e.conf.dnd.tid=o),1==a){var d=!1;if(null!=l){var c={id:e.conf.dnd.id,pId:e.items[o].pId||null,index:null,idxOfs:e.items[e.conf.dnd.id].pId==e.items[o].pId&&e.conf.dnd.idx[e.conf.dnd.id]<e.conf.dnd.idx[o]?-1:0};0==l||2==l?c.index=e.conf.dnd.idx[o]+(2==l?1:0)+c.idxOfs:1==l&&(c.pId=o,c.index=null==e.items[o].item.lastChild.className.match(/dhxtreeview_kids_cont/)?0:e.items[o].item.lastChild.firstChild.childNodes.length),e.conf.dnd.drop.id==c.id&&e.conf.dnd.drop.pId==c.pId&&e.conf.dnd.drop.index==c.index||(e.conf.dnd.drop=c,!0===e._callPublicEvent("onDragOver",[e.conf.dnd.drop.id,e.conf.dnd.drop.pId,e.conf.dnd.drop.index])&&(d=!0))}1!=d&&(e.conf.dnd.ofs=l=null),e._dndUpdateTargetCss(o,d)}}}else i=null},this._dndOnMouseUp=function(t){if(!(void 0!==(t=t||event).button&&t.button>=2)){if(e._dndUnloadEvents(),e._dndUnloadDraggedObj(),1==e.conf.dnd.scroll&&e._dndScroll("stop"),null!=e.cont.className.match(/dhxtreeview_dnd_mode/gi)&&(e.cont.className=String(e.cont.className).replace(/\s*dhxtreeview_dnd_mode/gi,"")),null!=e.conf.dnd.tid&&e._dndUpdateTargetCss(e.conf.dnd.tid,!1),1==e.conf.dnd.inited&&(e.items[e.conf.dnd.id].item.className=String(e.items[e.conf.dnd.id].item.className).replace(/\s*dhxtreeview_item_dragged/gi,""),document.body.className=String(document.body.className).replace(/\s*dhxtreeview_dnd_mode/,""),null!=e.conf.dnd.tid&&null!=e.conf.dnd.ofs&&!0===e._callPublicEvent("onBeforeDrop",[e.conf.dnd.drop.id,e.conf.dnd.drop.pId,e.conf.dnd.drop.index]))){var n,i=e.items[e.conf.dnd.id],a=e.items[e.conf.dnd.tid],o=null!=i.pId?e.items[i.pId]:null;if(1==e.conf.dnd.ofs){var r=!1;0==a.kids&&(e._initKidsNode(a.id),r=!0),a.item.lastChild.firstChild.appendChild(i.item),1==r&&e._openCloseItem(a.id,!1),i.pId=a.id,n=a.level+1-i.level}else 0!=e.conf.dnd.ofs&&2!=e.conf.dnd.ofs||(0==e.conf.dnd.ofs?a.item.parentNode.insertBefore(i.item,a.item):null!=a.item.nextSibling?a.item.parentNode.insertBefore(i.item,a.item.nextSibling):a.item.parentNode.appendChild(i.item),i.pId=a.pId,n=a.level-i.level);if(0!=n)for(var s in e.conf.dnd.kids[i.id]=!0,e.conf.dnd.kids)e.items[s].level+=n,e._refreshItemHtml(s,1==e.items[s].kids,!0);null!=o&&1==o.kids&&0==o.item.lastChild.firstChild.childNodes.length&&(e._clearKidsNode(o.id),o.opened=!1),i=a=o=null,e._fixAreaWidth(),e._callPublicEvent("onDrop",[e.conf.dnd.drop.id,e.conf.dnd.drop.pId,e.conf.dnd.drop.index])}window.dhx4.zim.clear(e.conf.dnd.zi),e.conf.dnd=null}},this._dndOnContextMenu=function(t){if(1==e.conf.dnd.inited)return(t=t||event).cancelBubble=!0,t.preventDefault&&t.preventDefault(),t.returnValue=!1,!1},this._dndInitEvents=function(){"function"==typeof window.addEventListener?(window.addEventListener("mousemove",this._dndOnMouseMove,!1),window.addEventListener("mouseup",this._dndOnMouseUp,!1),window.addEventListener("contextmenu",this._dndOnContextMenu,!1)):(document.body.attachEvent("onmousemove",this._dndOnMouseMove),document.body.attachEvent("onmouseup",this._dndOnMouseUp),document.body.attachEvent("oncontextmenu",this._dndOnContextMenu))},this._dndUnloadEvents=function(){"function"==typeof window.addEventListener?(window.removeEventListener("mousemove",this._dndOnMouseMove,!1),window.removeEventListener("mouseup",this._dndOnMouseUp,!1),window.removeEventListener("contextmenu",this._dndOnContextMenu,!1)):(document.body.detachEvent("onmousemove",this._dndOnMouseMove),document.body.detachEvent("onmouseup",this._dndOnMouseUp),document.body.detachEvent("oncontextmenu",this._dndOnContextMenu))},this._dndInitDraggedObj=function(){this.conf.dnd.dragged=document.createElement("DIV"),this.conf.dnd.dragged.className="dhxtreeview_dragged_obj_"+this.conf.skin,this.conf.dnd.dragged.style.zIndex=window.dhx4.zim.reserve(this.conf.dnd.zi),document.body.appendChild(this.conf.dnd.dragged),this.conf.dnd.dragged.innerHTML=this.getItemText(this.conf.dnd.id)},this._dndAdjustDraggedObj=function(){this.conf.dnd.dragged.style.left=this.conf.dnd.x+this.conf.dnd.ofs_x+12+"px",this.conf.dnd.dragged.style.top=this.conf.dnd.y+this.conf.dnd.ofs_y+18+"px"},this._dndUnloadDraggedObj=function(){null!=this.conf.dnd.dragged&&(document.body.removeChild(this.conf.dnd.dragged),this.conf.dnd.dragged=null)},this._dndUpdateTargetCss=function(t,e){var n=this.items[t].item.childNodes[0];if(null==this.conf.dnd.ofs&&(e=!1),1==e){if(n.className=String(n.className).replace(/(\s*dhxtreeview_drop_\d)?$/i," dhxtreeview_drop_"+this.conf.dnd.ofs),null==n.nextSibling||null==n.nextSibling.className.match(/dhxtreeview_drop_preview/)){var i=document.createElement("DIV");i.className="dhxtreeview_drop_preview",i.style.left=n.lastChild.previousSibling.style.left,null==n.nextSibling?n.parentNode.appendChild(i):n.parentNode.insertBefore(i,n.nextSibling),i=null}n.nextSibling.className=String(n.nextSibling.className).replace(/(\s*dhxtreeview_drop_\d)?$/i," dhxtreeview_drop_"+this.conf.dnd.ofs)}else null!=n.className.match(/dhxtreeview_drop_\d/)&&(n.className=String(n.className).replace(/\s*dhxtreeview_drop_\d/gi,""),null!=n.nextSibling&&null!=n.nextSibling.className.match(/dhxtreeview_drop_preview/)&&n.parentNode.removeChild(n.nextSibling));n=null},this._dndCollectKids=function(t){for(var e in this.items)this.items[e].pId==t&&(this.conf.dnd.kids[e]=!0,1==this.items[e].kids&&this._dndCollectKids(e))},this._dndCollectIndexes=function(t){for(var e=0;e<t.childNodes.length;e++)this.conf.dnd.idx[t.childNodes[e]._itemId]=e,null!=t.childNodes[e].lastChild.className.match(/dhxtreeview_kids_cont/)&&this._dndCollectIndexes(t.childNodes[e].lastChild.firstChild)},this._dndScroll=function(t,n){if("stop"!=t){if(1==e.conf.dnd.scroll){if(1!=n)return}else e.conf.dnd.scroll=!0;var i=!1;"up"==t?(e.cont.scrollTop=Math.max(0,e.cont.scrollTop-e.conf.dnd.scroll_ofs),0==e.cont.scrollTop&&(i=!0)):(e.cont.scrollTop=Math.min(e.cont.scrollHeight-e.cont.clientHeight,e.cont.scrollTop+e.conf.dnd.scroll_ofs),e.cont.scrollTop+e.cont.clientHeight==e.cont.scrollHeight&&(i=!0)),1!=i&&(e.conf.dnd.scroll_tm=window.setTimeout(function(){e._dndScroll(t,!0)},e.conf.dnd.scroll_time))}else 1==e.conf.dnd.scroll&&(e.conf.dnd.scroll_tm&&window.clearTimeout(e.conf.dnd.scroll_tm),e.conf.dnd.scroll=!1)},"function"==typeof window.addEventListener?this.cont.addEventListener("mousedown",this._dndOnMouseDown,!1):this.cont.attachEvent("onmousedown",this._dndOnMouseDown),this._dndUnload=function(){"function"==typeof window.addEventListener?this.cont.removeEventListener("mousedown",this._dndOnMouseDown,!1):this.cont.detachEvent("onmousedown",this._dndOnMouseDown),e=null},t=null},dhtmlXTreeView.prototype.modules.ctx={init:"_ctxInit",unload:"_ctxUnload"},dhtmlXTreeView.prototype.enableContextMenu=function(t){this.conf.ctx=window.dhx4.s2b(t)},dhtmlXTreeView.prototype._ctxInit=function(t){var e=this;this._ctxCall=function(t){if(1==e.conf.ctx){var n=(t=t||event).target||t.srcElement;"i"==n.tagName.toLowerCase()&&(n=n.parentNode);var i=n.parentNode._itemId||n.parentNode.parentNode._itemId,a=window.dhx4.absLeft(n)+(void 0===t.offsetX?t.layerX:t.offsetX),o=window.dhx4.absTop(n)+(void 0===t.offsetY?t.layerY:t.offsetY);return null!=i&&!0!==e._callPublicEvent("onContextMenu",[i,a,o,t])?(t.preventDefault&&t.preventDefault(),t.cancelBubble=!0,t.returnValue=!1,!1):void 0}},"function"==typeof window.addEventListener?this.cont.addEventListener("contextmenu",this._ctxCall,!1):this.cont.attachEvent("oncontextmenu",this._ctxCall),this._ctxUnload=function(){"function"==typeof window.addEventListener?this.cont.removeEventListener("contextmenu",this._ctxCall,!1):this.cont.detachEvent("oncontextmenu",this._ctxCall),e=null},this.enableContextMenu(t.context_menu)},dhtmlXTreeView.prototype.modules.dynload={init:"_dynLoadInit"},dhtmlXTreeView.prototype._dynLoadInit=function(){this.attachEvent("_onItemInited",function(t,e){if(this.items[t].kids_request=window.dhx4.s2b(e.kids),1==this.items[t].kids_request&&this._initKidsNode(t),1==this.items[t].opened&&1==this.items[t].kids_request){var n=this;window.setTimeout(function(){n._dynLoadRequest(t),n=null},100)}}),this.attachEvent("_onBeforeOpen",function(t){return 1==this.items[t].opened||1!=this.items[t].kids_request||1==this._dynLoadRequest(t)||(this.items[t].half_opened=!0,this._signUpdate(t),!1)})},dhtmlXTreeView.prototype._dynLoadRequest=function(t){if("function"==typeof this.conf.autoload.mode)return this.conf.autoload.mode.apply(window,[t]),!0;if(null!=this.conf.autoload.url){this._dhxdataload.onBeforeXLS=function(e){return{url:e.replace(/\{id\}/gi,t)}};var e=this;return this.items[t].kids_loading_tm=window.setTimeout(function(){e._dynLoadUpdateIcon(t,!0),e=null},100),this.loadStruct(this.conf.autoload.url,function(){window.clearTimeout(this.items[t].kids_loading_tm),this._dynLoadUpdateIcon(t,!1),this.items[t].half_opened&&(this.items[t].half_opened=!1,this._openCloseItem(t,!0))}),this.items[t].kids_request=!1,!1}},dhtmlXTreeView.prototype._dynLoadUpdateIcon=function(t,e){this.items[t].loading=1==e,1==this.items[t].loading?this.items[t].item.childNodes[0].childNodes[this.conf.idx.icon].innerHTML="<i class='"+this.conf.icons.prefix+" "+this.conf.icons.loading+"'></i>":this._iconUpdate(t)},String.prototype._dhx_trim=function(){return this.replace(/&nbsp;/g," ").replace(/(^[ \t]*)|([ \t]*$)/g,"")},dhtmlxArray._master={_dhx_find:function(t){for(var e=0;e<this.length;e++)if(t==this[e])return e;return-1},_dhx_insertAt:function(t,e){this[this.length]=null;for(var n=this.length-1;n>=t;n--)this[n]=this[n-1];this[t]=e},_dhx_removeAt:function(t){this.splice(t,1)},_dhx_swapItems:function(t,e){var n=this[t];this[t]=this[e],this[e]=n}},dhtmlXGridObject.prototype={getRowAttribute:function(t,e){return this.getRowById(t)._attrs[e]},setRowAttribute:function(t,e,n){this.getRowById(t)._attrs[e]=n},isTreeGrid:function(){return-1!=this.cellType._dhx_find("tree")},setRowHidden:function(t,e){dhx4.s2b(e);var n=this.getRowById(t);if(n){if(""===n.expand&&this.collapseKids(n),e&&"none"!=n.style.display){n.style.display="none";var i=this.selectedRows._dhx_find(n);if(-1!=i){n.className=n.className.replace("rowselected","");for(var a=0;a<n.childNodes.length;a++)n.childNodes[a].className=n.childNodes[a].className.replace(/cellselected/g,"");this.selectedRows._dhx_removeAt(i)}this.callEvent("onGridReconstructed",[])}e||"none"!=n.style.display||(n.style.display="",this.callEvent("onGridReconstructed",[])),this.callEvent("onRowHide",[t,e]),this.setSizes()}},setColumnHidden:function(t,e){if(!this.hdr.rows.length)return this._ivizcol||(this._ivizcol=[]),this._ivizcol[t]=e;if(this.fldSorted&&this.fldSorted.cellIndex==t&&e&&(this.sortImg.style.display="none"),dhx4.s2b(e)){if(this._hrrar){if(this._hrrar[t])return}else this._hrrar=new Array;this._hrrar[t]="display:none;",this._hideShowColumn(t,"none")}else{if(!this._hrrar||!this._hrrar[t])return;this._hrrar[t]="",this._hideShowColumn(t,"")}this.fldSorted&&this.fldSorted.cellIndex==t&&!e&&(this.sortImg.style.display="inline"),this.setSortImgPos(),this.callEvent("onColumnHidden",[t,e])},isColumnHidden:function(t){return!(!this._hrrar||!this._hrrar[t])},setColumnsVisibility:function(t){if(t&&(this._ivizcol=t.split(this.delim)),this.hdr.rows.length&&this._ivizcol)for(var e=0;e<this._ivizcol.length;e++)this.setColumnHidden(e,this._ivizcol[e])},_fixHiddenRowsAll:function(t,e,n,i,a){a=a||"_cellIndex";for(var o=t.rows.length,r=0;r<o;r++){var s=t.rows[r].childNodes;if(s.length!=this._cCount){for(var l=0;l<s.length;l++)if(s[l][a]==e){s[l].style[n]=i;break}}else s[e].style[n]=i}},_hideShowColumn:function(t,e){if(this.hdr.rows[1]&&this.hdr.rows[1]._childIndexes&&this.hdr.rows[1]._childIndexes[t]!=t&&this.hdr.rows[1]._childIndexes[t],"none"==e){this.hdr.rows[0].cells[t]._oldWidth=this.hdr.rows[0].cells[t].style.width||this.initCellWidth[t]+"px",this.hdr.rows[0].cells[t]._oldWidthP=this.cellWidthPC[t],this.obj.rows[0].cells[t].style.width="0px";var n={rows:[this.obj.rows[0]]};this.forEachRow(function(t){"TR"==this.rowsAr[t].tagName&&n.rows.push(this.rowsAr[t])}),this._fixHiddenRowsAll(n,t,"display","none"),this.isTreeGrid()&&this._fixHiddenRowsAllTG(t,"none"),(_isOpera&&_OperaRv<9||_isKHTML||_isFF)&&this._fixHiddenRowsAll(this.hdr,t,"display","none","_cellIndexS"),this.ftr&&this._fixHiddenRowsAll(this.ftr.childNodes[0],t,"display","none"),this._fixHiddenRowsAll(this.hdr,t,"whiteSpace","nowrap","_cellIndexS"),this.cellWidthPX.length||this.cellWidthPC.length||(this.cellWidthPX=[].concat(this.initCellWidth)),this.cellWidthPX[t]&&(this.cellWidthPX[t]=0),this.cellWidthPC[t]&&(this.cellWidthPC[t]=0)}else if(this.hdr.rows[0].cells[t]._oldWidth){var i=this.hdr.rows[0].cells[t];(_isOpera||_isKHTML||_isFF)&&this._fixHiddenRowsAll(this.hdr,t,"display","","_cellIndexS"),this.ftr&&this._fixHiddenRowsAll(this.ftr.childNodes[0],t,"display","");n={rows:[this.obj.rows[0]]};this.forEachRow(function(t){"TR"==this.rowsAr[t].tagName&&n.rows.push(this.rowsAr[t])}),this._fixHiddenRowsAll(n,t,"display",""),this.isTreeGrid()&&this._fixHiddenRowsAllTG(t,""),this._fixHiddenRowsAll(this.hdr,t,"whiteSpace","normal","_cellIndexS"),i._oldWidthP&&(this.cellWidthPC[t]=i._oldWidthP),i._oldWidth&&(this.cellWidthPX[t]=parseInt(i._oldWidth))}!e&&this._realfake&&this.setColumnSizes(this.entBox.clientWidth),this.setSizes(),_isIE||_isFF||(this.obj.border=1,this.obj.border=0)},enableColSpan:function(t){this._ecspn=dhx4.s2b(t)},enableRowsHover:function(t,e){this._unsetRowHover(!1,!0),this._hvrCss=e,dhx4.s2b(t)?this._elmnh||(this.obj._honmousemove=this.obj.onmousemove,this.obj.onmousemove=this._setRowHover,_isIE?this.obj.onmouseleave=this._unsetRowHover:this.obj.onmouseout=this._unsetRowHover,this._elmnh=!0):this._elmnh&&(this.obj.onmousemove=this.obj._honmousemove,_isIE?this.obj.onmouseleave=null:this.obj.onmouseout=null,this._elmnh=!1)},enableEditEvents:function(t,e,n){this._sclE=dhx4.s2b(t),this._dclE=dhx4.s2b(e),this._f2kE=dhx4.s2b(n)},enableLightMouseNavigation:function(t){dhx4.s2b(t)?this._elmn||(this.entBox._onclick=this.entBox.onclick,this.entBox.onclick=function(){return!0},this.obj._onclick=this.obj.onclick,this.obj.onclick=function(t){var e=this.grid.getFirstParentOfType(t?t.target:event.srcElement,"TD");e&&(this.grid.editStop(),this.grid.doClick(e),this.grid.editCell(),(t||event).cancelBubble=!0)},this.obj._onmousemove=this.obj.onmousemove,this.obj.onmousemove=this._autoMoveSelect,this._elmn=!0):this._elmn&&(this.entBox.onclick=this.entBox._onclick,this.obj.onclick=this.obj._onclick,this.obj.onmousemove=this.obj._onmousemove,this._elmn=!1)},_unsetRowHover:function(t,e){if(that=e?this:this.grid,that._lahRw&&that._lahRw!=e){for(var n=0;n<that._lahRw.childNodes.length;n++)that._lahRw.childNodes[n].className=that._lahRw.childNodes[n].className.replace(that._hvrCss,"");that._lahRw=null}},_setRowHover:function(t){var e=this.grid.getFirstParentOfType(t?t.target:event.srcElement,"TD");if(e&&e.parentNode!=this.grid._lahRw){if(this.grid._unsetRowHover(0,e),!(e=e.parentNode).idd||"__filler__"==e.idd)return;for(var n=0;n<e.childNodes.length;n++)e.childNodes[n].className+=" "+this.grid._hvrCss;this.grid._lahRw=e}this._honmousemove(t)},_autoMoveSelect:function(t){if(!this.grid.editor){var e=this.grid.getFirstParentOfType(t?t.target:event.srcElement,"TD");e.parentNode.idd&&this.grid.doClick(e,!0,0)}this._onmousemove(t)},enableDistributedParsing:function(t,e,n){dhx4.s2b(t)?(this._ads_count=e||10,this._ads_time=n||250):this._ads_count=0},destructor:function(){if(this.editStop(!0),this._sizeTime&&(this._sizeTime=window.clearTimeout(this._sizeTime)),this.entBox.className=(this.entBox.className||"").replace(/gridbox.*/,""),this.formInputs)for(var t=0;t<this.formInputs.length;t++)this.parentForm.removeChild(this.formInputs[t]);var e;for(t=0;t<this.rowsCol.length;t++)this.rowsCol[t]&&(this.rowsCol[t].grid=null);for(t in this.rowsAr)this.rowsAr[t]&&(this.rowsAr[t]=null);this.rowsCol=new dhtmlxArray,this.rowsAr={},this.entBox.innerHTML="";var n=function(){};for(e in this.entBox.onclick=this.entBox.onmousedown=this.entBox.onbeforeactivate=this.entBox.onbeforedeactivate=this.entBox.onbeforedeactivate=this.entBox.onselectstart=n,this.setSizes=this._update_srnd_view=this.callEvent=n,this.entBox.grid=this.objBox.grid=this.hdrBox.grid=this.obj.grid=this.hdr.grid=null,this._fake&&(this.globalBox.innerHTML="",this._fake.setSizes=this._fake._update_srnd_view=this._fake.callEvent=n,this.globalBox.onclick=this.globalBox.onmousedown=this.globalBox.onbeforeactivate=this.globalBox.onbeforedeactivate=this.globalBox.onbeforedeactivate=this.globalBox.onselectstart=n),this)this[e]&&this[e].m_obj&&(this[e].m_obj=null),this[e]=null;return this==globalActiveDHTMLGridObject&&(globalActiveDHTMLGridObject=null),null},getSortingState:function(){var t=new Array;return this.fldSorted&&(t[0]=this.fldSorted._cellIndex,t[1]="dhxgrid_sort_desc"==this.sortImg.className?"des":"asc"),t},enableAutoHeight:function(t,e,n){this._ahgr=dhx4.s2b(t),this._ahgrF=dhx4.s2b(n),this._ahgrM=e||null,1==arguments.length&&(this.objBox.style.overflowY=t?"hidden":"auto"),"auto"==e&&(this._ahgrM=null,this._ahgrMA=!0,this._setAutoResize())},enableStableSorting:function(t){this._sst=dhx4.s2b(t),this.rowsCol.stablesort=function(t){for(var e=this.length-1,n=0;n<this.length-1;n++){for(var i=0;i<e;i++)if(t(this[i],this[i+1])>0){var a=this[i];this[i]=this[i+1],this[i+1]=a}e--}}},enableKeyboardSupport:function(t){this._htkebl=!dhx4.s2b(t)},enableContextMenu:function(t){this._ctmndx=t},setScrollbarWidthCorrection:function(t){},enableTooltips:function(t){this._enbTts=t.split(",");for(var e=0;e<this._enbTts.length;e++)this._enbTts[e]=dhx4.s2b(this._enbTts[e])},enableResizing:function(t){this._drsclmn=t.split(",");for(var e=0;e<this._drsclmn.length;e++)this._drsclmn[e]=dhx4.s2b(this._drsclmn[e])},setColumnMinWidth:function(t,e){2==arguments.length?(this._drsclmW||(this._drsclmW=new Array),this._drsclmW[e]=t):this._drsclmW=t.split(",")},enableCellIds:function(t){this._enbCid=dhx4.s2b(t)},lockRow:function(t,e){var n=this.getRowById(t);n&&(n._locked=dhx4.s2b(e),this.cell&&this.cell.parentNode.idd==t&&this.editStop())},_getRowArray:function(t){for(var e=new Array,n=0;n<t.childNodes.length;n++){var i=this.cells3(t,n);e[n]=i.getValue()}return e},setDateFormat:function(t,e){this._dtmask=t,this._dtmask_inc=e},setNumberFormat:function(t,e,n,i){var a=t.replace(/[^0\,\.]*/g,""),o=a.indexOf(".");o>-1&&(o=a.length-o-1);var r=a.indexOf(",");r>-1&&(r=a.length-o-2-r),"string"!=typeof n&&(n=this.i18n.decimal_separator),"string"!=typeof i&&(i=this.i18n.group_separator);var s=t.split(a)[0],l=t.split(a)[1];this._maskArr[e]=[o,r,s,l,n,i]},_aplNFb:function(t,e){var n=this._maskArr[e];if(!n)return t;var i=parseFloat(t.toString().replace(/[^0-9]*/g,""));return"-"==t.toString().substr(0,1)&&(i*=-1),n[0]>0&&(i/=Math.pow(10,n[0])),i},_aplNF:function(t,e){var n=this._maskArr[e];if(!n)return t;var i=(parseFloat(t)<0?"-":"")+n[2];if((t=((t=Math.abs(Math.round(parseFloat(t)*Math.pow(10,n[0]>0?n[0]:0))).toString()).length<n[0]?Math.pow(10,n[0]+1-t.length).toString().substr(1,n[0]+1)+t.toString():t).split("").reverse())[n[0]]=(t[n[0]]||"0")+n[4],n[1]>0)for(var a=(n[0]>0?0:1)+n[0]+n[1];a<t.length;a+=n[1])t[a]+=n[5];return i+t.reverse().join("")+n[3]},_launchCommands:function(t){for(var e=0;e<t.length;e++){for(var n=new Array,i=0;i<t[e].childNodes.length;i++)1==t[e].childNodes[i].nodeType&&(n[n.length]=t[e].childNodes[i].firstChild.data);this[t[e].getAttribute("command")].apply(this,n)}},_parseHead:function(t){var e=dhx4.ajax.xpath("./head",t);if(e.length){var n=dhx4.ajax.xpath("./column",e[0]),i=dhx4.ajax.xpath("./settings",e[0]),a="setInitWidths",o=!1;if(i[0])for(var r=0;r<i[0].childNodes.length;r++)switch(i[0].childNodes[r].tagName){case"colwidth":i[0].childNodes[r].firstChild&&"%"==i[0].childNodes[r].firstChild.data&&(a="setInitWidthsP");break;case"splitat":o=!!i[0].childNodes[r].firstChild&&i[0].childNodes[r].firstChild.data}if(this._launchCommands(dhx4.ajax.xpath("./beforeInit/call",e[0])),n.length>0){this.hdr.rows.length>0&&this.clearAll(!0);for(var s=[[],[],[],[],[],[],[],[],[]],l=["","width","type","align","sort","color","format","hidden","id"],d=["",a,"setColTypes","setColAlign","setColSorting","setColumnColor","","","setColumnIds"],c=0;c<n.length;c++){for(var h=1;h<l.length;h++)s[h].push(n[c].getAttribute(l[h]));s[0].push((n[c].firstChild?n[c].firstChild.data:"").replace(/^\s*((\s\S)*.+)\s*$/gi,"$1"))}this.setHeader(s[0]);for(c=0;c<d.length;c++)d[c]&&this[d[c]](s[c].join(this.delim));for(c=0;c<n.length;c++)if(0==this.cellType[c].indexOf("co")||"clist"==this.cellType[c]){var u=dhx4.ajax.xpath("./option",n[c]);if(u.length){var m=new Array;if("clist"==this.cellType[c]){for(h=0;h<u.length;h++)m[m.length]=u[h].firstChild?u[h].firstChild.data:"";this.registerCList(c,m)}else{var f=this.getCombo(c);for(h=0;h<u.length;h++)f.put(u[h].getAttribute("value"),u[h].firstChild?u[h].firstChild.data:"")}}}else s[6][c]&&(-1!=this.cellType[c].toLowerCase().indexOf("calendar")||"date"==this.fldSort[c]?this.setDateFormat(s[6][c]):this.setNumberFormat(s[6][c],c));this.init();var p=s[7].join(this.delim);this.setColHidden&&""!=p.replace(/,/g,"")&&this.setColHidden(p),o&&this.splitAt&&this.splitAt(o)}this._launchCommands(dhx4.ajax.xpath("./afterInit/call",e[0]))}var _=dhx4.ajax.xpath("//rows/userdata",t);if(_.length>0){this.UserData.gridglobaluserdata||(this.UserData.gridglobaluserdata=new Hashtable);for(h=0;h<_.length;h++){for(var A="",b=0;b<_[h].childNodes.length;b++)A+=_[h].childNodes[b].nodeValue;this.UserData.gridglobaluserdata.put(_[h].getAttribute("name"),A)}}},getCheckedRows:function(t){var e=new Array;return this.forEachRowA(function(n){var i=this.cells(n,t);i.changeState&&0!=i.getValue()&&e.push(n)},!0),e.join(",")},checkAll:function(){for(var t=arguments.length?arguments[0]:1,e=0;e<this.getColumnsNum();e++)"ch"==this.getColType(e)&&this.setCheckedRows(e,t)},uncheckAll:function(){this.checkAll(0)},setCheckedRows:function(t,e){this.forEachRowA(function(n){this.cells(n,t).isCheckbox()&&this.cells(n,t).setValue(e)})},_drawTooltip:function(t){var e=this.grid.getFirstParentOfType(t?t.target:event.srcElement,"TD");if(!e||this.grid.editor&&this.grid.editor.cell==e)return!0;var n=e.parentNode;if(n.idd&&"__filler__"!=n.idd){var i=t?t.target:event.srcElement;if(n.idd==window.unknown)return!0;if(!this.grid.callEvent("onMouseOver",[n.idd,e._cellIndex,t||window.event]))return!0;if(this.grid._enbTts&&!this.grid._enbTts[e._cellIndex])return i.title&&(i.title=""),!0;if(!(e._cellIndex>=this.grid._cCount)){var a=this.grid.cells3(n,e._cellIndex);if(a&&a.cell&&a.cell._attrs)return i._title&&(a.cell.title=""),a.cell._attrs.title||(i._title=!0),a&&(i.title=a.cell._attrs.title||(a.getTitle?a.getTitle():(a.getValue()||"").toString().replace(/<[^>]*>/gi,""))),!0}}},enableCellWidthCorrection:function(t){_isFF&&(this._wcorr=parseInt(t))},getAllRowIds:function(t){for(var e=[],n=0;n<this.rowsBuffer.length;n++)this.rowsBuffer[n]&&e.push(this.rowsBuffer[n].idd);return e.join(t||this.delim)},getAllItemIds:function(){return this.getAllRowIds()},setColspan:function(t,e,n){if(this._ecspn){var i=this.getRowById(t);if(i._childIndexes&&i.childNodes[i._childIndexes[e]]){var a=i._childIndexes[e],o=i.childNodes[a],r=o.colSpan;if(o.colSpan=1,r&&1!=r)for(var s=1;s<r;s++){var l=document.createElement("TD");o.nextSibling?i.insertBefore(l,o.nextSibling):i.appendChild(l),i._childIndexes[e+s]=a+s,l._cellIndex=e+s,l.style.textAlign=this.cellAlign[s],l.style.verticalAlign=this.cellVAlign[s],o=l,this.cells3(i,e+s).setValue("")}for(var d=1*e+1*r;d<i._childIndexes.length;d++)i._childIndexes[d]+=1*(r-1)}if(n&&n>1){if(i._childIndexes)a=i._childIndexes[e];else{a=e;i._childIndexes=new Array;for(d=0;d<i.childNodes.length;d++)i._childIndexes[d]=d}i.childNodes[a].colSpan=n;for(d=1;d<n;d++)i._childIndexes[i.childNodes[a+1]._cellIndex]=a,i.removeChild(i.childNodes[a+1]);for(d=1*i.childNodes[i._childIndexes[e]]._cellIndex+1*n;d<i._childIndexes.length;d++)i._childIndexes[d]-=n-1}}},preventIECaching:function(t){dhx4.ajax.cache=!t},enableColumnAutoSize:function(t){this._eCAS=dhx4.s2b(t)},_onHeaderDblClick:function(t){var e=this.grid,n=e.getFirstParentOfType(_isIE?event.srcElement:t.target,"TD");if(!e._eCAS)return!1;e.adjustColumnSize(n._cellIndexS)},adjustColumnSize:function(t,e){if(!this._hrrar||!this._hrrar[t]){this._notresize=!0;var n=0;this._setColumnSizeR(t,20);for(var i=1;i<this.hdr.rows.length;i++){var a=this.hdr.rows[i];(a=a.childNodes[a._childIndexes?a._childIndexes[t]:t])&&(!a.colSpan||a.colSpan<2)&&a._cellIndex==t&&(a.childNodes[0]&&"hdrcell"==a.childNodes[0].className&&(a=a.childNodes[0]),n=Math.max(n,a.scrollWidth))}var o=this.obj.rows.length,r=0,s=this.cellType._dhx_find("tree"),l=document.createElement("DIV");l.className="dhx_grid_adjust",l.style.cssText="width:auto;height:auto;visibility:hidden; position:absolute; top:0px; left:0px; overflow:hidden; white-space:nowrap;",document.body.appendChild(l);for(var d=1;d<o;d++){var c=this.obj.rows[d],h=t;if(this.rowsAr[c.idd]){if(c._childIndexes){if(c._childIndexes[t]==c._childIndexes[t+1])continue;h=c._childIndexes[t]}c.childNodes[h]&&c.childNodes[h]._cellIndex==t&&(l.innerHTML=c.childNodes[h].innerText||c.childNodes[h].textContent||"",r=l.offsetWidth,this._h2&&t==s&&(r+=22*this._h2.get[c.idd].level),r>n&&(n=r))}}document.body.removeChild(l),n+=20+(e||0),this._setColumnSizeR(t,n),this._notresize=!1,this.setSizes()}},detachHeader:function(t,e){var n=(e=e||this.hdr).rows[t+1];n&&n.parentNode.removeChild(n),this.setSizes()},detachFooter:function(t){this.detachHeader(t,this.ftr)},attachHeader:function(t,e,n){if("string"==typeof t&&(t=this._eSplit(t)),"string"==typeof e&&(e=e.split(this.delim)),n=n||"_aHead",this.hdr.rows.length){if(t)this._createHRow([t,e],this["_aHead"==n?"hdr":"ftr"]);else if(this[n])for(var i=0;i<this[n].length;i++)this.attachHeader.apply(this,this[n][i])}else this[n]||(this[n]=new Array),this[n][this[n].length]=[t,e,n]},_createHRow:function(t,e){if(!e){"absolute"!=this.entBox.style.position&&(this.entBox.style.position="relative"),(r=document.createElement("DIV")).className="c_ftr".substr(2),this.entBox.appendChild(r),(h=document.createElement("TABLE")).cellPadding=h.cellSpacing=0,_isIE&&8!=_isIE||(h.width="100%",h.style.paddingRight="20px"),h.style.marginRight="20px",h.style.tableLayout="fixed",r.appendChild(h),h.appendChild(document.createElement("TBODY")),this.ftr=e=h;for(var n=h.insertRow(0),i=this.hdrLabels.length<=1?t[0].length:this.hdrLabels.length,a=0;a<i;a++)n.appendChild(document.createElement("TH")),n.childNodes[a]._cellIndex=a;_isIE&&_isIE<8?n.style.position="absolute":n.style.height="auto"}var o=t[1],r=document.createElement("TR");e.rows[0].parentNode.appendChild(r);for(a=0;a<t[0].length;a++){if("#cspan"!=t[0][a])if("#rspan"==t[0][a]&&e.rows.length>1){for(var s=e.rows.length-2,l=!1,d=null;!l;){d=e.rows[s];for(var c=0;c<d.cells.length;c++)if(d.cells[c]._cellIndex==a){l=c+1;break}s--}(d=d.cells[l-1]).rowSpan=(d.rowSpan||1)+1}else{var h,u=document.createElement("TD");if(u._cellIndex=u._cellIndexS=a,this._hrrar&&this._hrrar[a]&&!_isIE&&(u.style.display="none"),"object"==typeof t[0][a])u.appendChild(t[0][a]);else if(this.forceDivInHeader?u.innerHTML="<div class='hdrcell'>"+(t[0][a]||"&nbsp;")+"</div>":u.innerHTML=t[0][a]||"&nbsp;",-1!=(t[0][a]||"").indexOf("#"))if(h=t[0][a].match(/(^|{)#([^}]+)(}|$)/)){var m="_in_header_"+h[2];this[m]&&this[m](this.forceDivInHeader?u.firstChild:u,a,t[0][a].split(h[0]))}o&&(u.style.cssText=o[a]),r.appendChild(u)}else(d=r.cells[r.cells.length-1]).colSpan=(d.colSpan||1)+1}_isKHTML&&(e._kTimer&&window.clearTimeout(e._kTimer),e._kTimer=window.setTimeout(function(){e.rows[1].style.display="none",window.setTimeout(function(){e.rows[1].style.display=""},1)},500))},attachFooter:function(t,e){this.attachHeader(t,e,"_aFoot")},setCellExcellType:function(t,e,n){this.changeCellType(this.getRowById(t),e,n)},getCellExcellType:function(t,e){var n=this.getRowById(t);return this.cells3(n,e).cell._cellType||this.cellType[e]},changeCellType:function(t,e,n){n=n||this.cellType[e];var i,a=(i=this.cells3(t,e)).getValue();i.cell._cellType=n,(i=this.cells3(t,e)).setValue(a)},setRowExcellType:function(t,e){for(var n=this.rowsAr[t],i=0;i<n.childNodes.length;i++)this.changeCellType(n,i,e)},setColumnExcellType:function(t,e){for(var n=0;n<this.rowsBuffer.length;n++)this.rowsBuffer[n]&&"TR"==this.rowsBuffer[n].tagName&&this.changeCellType(this.rowsBuffer[n],t,e);"math"==this.cellType[t]?this._strangeParams[n]=e:this.cellType[t]=e},forEachRow:function(t){for(var e in this.rowsAr)this.rowsAr[e]&&this.rowsAr[e].idd&&t.apply(this,[this.rowsAr[e].idd])},forEachRowA:function(t){for(var e=0;e<this.rowsBuffer.length;e++)this.rowsBuffer[e]&&t.call(this,this.render_row(e).idd)},forEachCell:function(t,e){var n=this.getRowById(t);if(n)for(var i=0;i<this._cCount;i++)e(this.cells3(n,i),i)},enableAutoWidth:function(t,e,n){this._awdth=[dhx4.s2b(t),parseInt(e||99999),parseInt(n||0)],1==arguments.length&&(this.objBox.style.overflowX=t?"hidden":"auto")},updateFromXML:function(t,e,n,i){void 0===e&&(e=!0),this._refresh_mode=[!0,e,n],this.load(t,i)},_refreshFromXML:function(t){this._f_rowsBuffer&&this.filterBy(0,""),reset=!1,window.eXcell_tree&&(eXcell_tree.prototype.setValueX=eXcell_tree.prototype.setValue,eXcell_tree.prototype.setValue=function(t){this.grid._h2.get[this.cell.parentNode.idd]&&this.cell.parentNode.valTag?this.setLabel(t):this.setValueX(t)});var e=this.cellType._dhx_find("tree"),n=dhx4.ajax.xmltop("rows",t),i=n.getAttribute("parent")||0,a={};this._refresh_mode[2]&&(-1!=e?this._h2.forEachChild(i,function(t){a[t.id]=!0},this):this.forEachRow(function(t){a[t]=!0}));for(var o=dhx4.ajax.xpath("//row",n),r=0;r<o.length;r++){var s=o[r],l=s.getAttribute("id");a[l]=!1;i=s.parentNode.getAttribute("id")||i;if(this.rowsAr[l]&&"TR"!=this.rowsAr[l].tagName)this._h2?this._h2.get[l].buff.data=s:this.rowsBuffer[this.getRowIndex(l)].data=s,this.rowsAr[l]=s;else if(this.rowsAr[l])this._process_xml_row(this.rowsAr[l],s,-1),this._postRowProcessing(this.rowsAr[l],!0),this._fake&&this._fake.rowsAr[l]&&this._fake._process_xml_row(this._fake.rowsAr[l],s,-1);else if(this._refresh_mode[1]){var d={idd:l,data:s,_parser:this._process_xml_row,_locator:this._get_xml_data},c=this.rowsBuffer.length;"top"==this._refresh_mode[1]?(this.rowsBuffer.unshift(d),c=0):this.rowsBuffer.push(d),this._h2?(reset=!0,this._h2.add(l,s.parentNode.getAttribute("id")||s.parentNode.getAttribute("parent")).buff=this.rowsBuffer[this.rowsBuffer.length-1]):this._srnd&&(reset=!0),this.rowsAr[l]=s,s=this.render_row(c),this._insertRowAt(s,c?-1:0)}}if(this._refresh_mode[2])for(l in a)a[l]&&this.rowsAr[l]&&this.deleteRow(l);this._refresh_mode=null,window.eXcell_tree&&(eXcell_tree.prototype.setValue=eXcell_tree.prototype.setValueX),reset&&(this._h2?this._renderSort():this.render_dataset()),this._f_rowsBuffer&&(this._f_rowsBuffer=null,this.filterByAll())},getCustomCombo:function(t,e){var n=this.cells(t,e).cell;return n._combo||(n._combo=new dhtmlXGridComboObject),n._combo},setTabOrder:function(t){var e=t.split(this.delim);this._tabOrder=[];for(var n=this._cCount||t.length,i=0;i<n;i++)e[i]={c:parseInt(e[i]),ind:i};e.sort(function(t,e){return t.c>e.c?1:-1});for(i=0;i<n;i++)e[i+1]&&void 0!==e[i].c?this._tabOrder[e[i].ind]=e[i+1].ind:this._tabOrder[e[i].ind]=-1*(e[0].ind+1)},i18n:{loading:"Loading",decimal_separator:".",group_separator:","},_key_events:{k13_1_0:function(){var t=this.rowsCol._dhx_find(this.row);this.selectCell(this.rowsCol[t+1],this.cell._cellIndex,!0)},k13_0_1:function(){var t=this.rowsCol._dhx_find(this.row);this.selectCell(this.rowsCol[t-1],this.cell._cellIndex,!0)},k13_0_0:function(){this.editStop(),this.callEvent("onEnter",[this.row?this.row.idd:null,this.cell?this.cell._cellIndex:null]),this._still_active=!0},k9_0_0:function(){if(this.editStop(),!this.callEvent("onTab",[!0]))return!0;var t=this._getNextCell(null,1);t&&(this.selectCell(t.parentNode,t._cellIndex,this.row!=t.parentNode,!1,!0),this._still_active=!0)},k9_0_1:function(){if(this.editStop(),!this.callEvent("onTab",[!1]))return!1;var t=this._getNextCell(null,-1);t&&(this.selectCell(t.parentNode,t._cellIndex,this.row!=t.parentNode,!1,!0),this._still_active=!0)},k113_0_0:function(){this._f2kE&&this.editCell()},k32_0_0:function(){var t=this.cells4(this.cell);if(!t.changeState||!1===t.changeState())return!1},k27_0_0:function(){this.editStop(!0)},k33_0_0:function(){this.pagingOn?this.changePage(this.currentPage-1):this.scrollPage(-1)},k34_0_0:function(){this.pagingOn?this.changePage(this.currentPage+1):this.scrollPage(1)},k37_0_0:function(){if(this.editor||!this.isTreeGrid())return!1;this.collapseKids(this.row)},k39_0_0:function(){if(this.editor||!this.isTreeGrid())return!1;this.expandKids(this.row)},k40_0_0:function(){var t=this._realfake?this._fake:this;if(this.editor&&this.editor.combo)this.editor.shiftNext();else{if(!this.row.idd)return;var e=Math.max(t._r_select||0,this.getRowIndex(this.row.idd)),n=this._nextRow(e,1);if(n)t._r_select=null,this.selectCell(n,this.cell._cellIndex,!0),t.pagingOn&&t.showRow(n.idd);else{if(!this.callEvent("onLastRow",[]))return!1;this._key_events.k34_0_0.apply(this,[]),this.pagingOn&&this.rowsCol[e+1]&&this.selectCell(e+1,0,!0)}}this._still_active=!0},k38_0_0:function(){var t=this._realfake?this._fake:this;if(this.editor&&this.editor.combo)this.editor.shiftPrev();else{if(!this.row.idd)return;var e=this.getRowIndex(this.row.idd)+1;if(-1==e||this.pagingOn&&1==e)this._key_events.k33_0_0.apply(this,[]);else{var n=this._nextRow(e-1,-1);this.selectCell(n,this.cell._cellIndex,!0),t.pagingOn&&n&&t.showRow(n.idd)}}this._still_active=!0}},_build_master_row:function(){for(var t=document.createElement("DIV"),e=["<table><tr>"],n=0;n<this._cCount;n++)e.push("<td></td>");e.push("</tr></table>"),t.innerHTML=e.join(""),this._master_row=t.firstChild.rows[0]},_prepareRow:function(t){this._master_row||this._build_master_row();for(var e=this._master_row.cloneNode(!0),n=0;n<e.childNodes.length;n++)e.childNodes[n]._cellIndex=n,this._enbCid&&(e.childNodes[n].id="c_"+t+"_"+n),this.dragAndDropOff&&this.dragger.addDraggableItem(e.childNodes[n],this);return e.idd=t,e.grid=this,e},_process_jsarray_row:function(t,e){t._attrs={};for(var n=0;n<t.childNodes.length;n++)t.childNodes[n]._attrs={};return this._fillRow(t,this._c_order?this._swapColumns(e):e),t},_get_jsarray_data:function(t,e){return t[e]},_process_json_row:function(t,e){return e=this._c_order?this._swapColumns(e.data):e.data,this._process_some_row(t,e)},_process_some_row:function(t,e){t._attrs={};for(var n=0;n<t.childNodes.length;n++)t.childNodes[n]._attrs={};return this._fillRow(t,e),t},_get_json_data:function(t,e){return t.data[e]},_process_js_row:function(t,e){for(var n=[],i=0;i<this.columnIds.length;i++)n[i]=e[this.columnIds[i]],n[i]||0===n[i]||(n[i]="");return this._process_some_row(t,n),t._attrs=e,t},_get_js_data:function(t,e){return t[this.columnIds[e]]},_process_csv_row:function(t,e){t._attrs={};for(var n=0;n<t.childNodes.length;n++)t.childNodes[n]._attrs={};return this._fillRow(t,this._c_order?this._swapColumns(e.split(this.csv.cell)):e.split(this.csv.cell)),t},_get_csv_data:function(t,e){return t.split(this.csv.cell)[e]},_process_store_row:function(t,e){for(var n=[],i=0;i<this.columnIds.length;i++)n[i]=e[this.columnIds[i]];for(var a=0;a<t.childNodes.length;a++)t.childNodes[a]._attrs={};t._attrs=e,this._fillRow(t,n)},_process_xml_row:function(t,e){var n=dhx4.ajax.xpath(this.xml.cell,e),i=[];if(t._attrs=this._xml_attrs(e),this._ud_enabled)for(var a=dhx4.ajax.xpath("./userdata",e),o=a.length-1;o>=0;o--){for(var r="",s=0;s<a[o].childNodes.length;s++)r+=a[o].childNodes[s].nodeValue;this.setUserData(t.idd,a[o].getAttribute("name"),r)}for(s=0;s<n.length;s++){var l=n[this._c_order?this._c_order[s]:s];if(l){var d=t._childIndexes?t._childIndexes[s]:s,c=l.getAttribute("type");t.childNodes[d]&&(c&&(t.childNodes[d]._cellType=c),t.childNodes[d]._attrs=this._xml_attrs(l)),l.getAttribute("xmlcontent")||(l=l.firstChild?l.firstChild.wholeText||l.firstChild.data:""),i.push(l)}}for(n.length;s<t.childNodes.length;s++)t.childNodes[s]._attrs={};return t.parentNode&&"row"==t.parentNode.tagName&&(t._attrs.parent=t.parentNode.getAttribute("idd")),this._fillRow(t,i),t},_get_xml_data:function(t,e){for(t=t.firstChild;;){if(!t)return"";if("cell"==t.tagName&&e--,e<0)break;t=t.nextSibling}return t.firstChild?t.firstChild.data:""},_fillRow:function(t,e){this.editor&&this.editor.parentNode&&this.editor.parentNode.idd==t.idd&&this.editStop();for(var n=0;n<t.childNodes.length;n++)if(n<e.length||this.defVal[n]){var i=t.childNodes[n]._cellIndex,a=e[i],o=this.cells4(t.childNodes[n]);!this.defVal[i]||""!=a&&void 0!==a||(a=this.defVal[i]),o&&o.setValue(a)}else t.childNodes[n].innerHTML="&nbsp;",t.childNodes[n]._clearCell=!0;return t},_postRowProcessing:function(t,e){t._attrs.class&&(t._css=t.className=t._attrs.class),t._attrs.locked&&(t._locked=!0),t._attrs.bgColor&&(t.bgColor=t._attrs.bgColor);for(var n=0,i=0;i<t.childNodes.length;i++){var a=t.childNodes[i],o=a._cellIndex,r=a._attrs.style||t._attrs.style;r&&(a.style.cssText+=";"+r),a._attrs.class&&(a.className=a._attrs.class),(r=a._attrs.align||this.cellAlign[o])&&(a.align=r),a.vAlign=a._attrs.valign||this.cellVAlign[o];var s=a._attrs.bgColor||this.columnColor[o];s&&(a.bgColor=s),a._attrs.colspan&&!e&&(this.setColspan(t.idd,i+n,a._attrs.colspan),n+=a._attrs.colspan-1),this._hrrar&&this._hrrar[o]&&!e&&(a.style.display="none")}this.callEvent("onRowCreated",[t.idd,t,null])},load:function(t,e,n){this.callEvent("onXLS",[this]),2==arguments.length&&"function"!=typeof e&&(n=e,e=null),this._last_load_type=n=n||this._last_load_type||"xml",this.xmlFileUrl||(this.xmlFileUrl=t),this._data_type=n,this.xmlLoader=this.doLoadDetails;var i=this;return this.xmlLoader=function(t){i.callEvent&&(i["_process_"+n](t.xmlDoc),i._contextCallTimer||i.callEvent("onXLE",[i,0,0,t.xmlDoc,n]),e&&(e(),e=null))},dhx4.ajax.get(t,this.xmlLoader)},loadXMLString:function(t,e){window.console&&window.console.info&&window.console.info("loadXMLString was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this.parse({responseXML:dhx4.ajax.parse(t)},e,"xml")},loadXML:function(t,e){window.console&&window.console.info&&window.console.info("loadXML was deprecated","http://docs.dhtmlx.com/migration__index.html#migrationfrom43to44"),this.load(t,e,"xml")},parse:function(t,e,n){2==arguments.length&&"function"!=typeof e&&(n=e,e=null),this._last_load_type=n=n||this._last_load_type||"xml",this._data_type=n,"xml"==n&&"string"==typeof t&&(t={responseXML:dhx4.ajax.parse(t)}),this["_process_"+n](t),this._contextCallTimer||this.callEvent("onXLE",[this,0,0,t,n]),e&&e()},xml:{top:"rows",row:"./row",cell:"./cell",s_row:"row",s_cell:"cell",row_attrs:[],cell_attrs:[]},csv:{row:"\n",cell:","},_xml_attrs:function(t){var e={};if(t.attributes.length)for(var n=0;n<t.attributes.length;n++)e[t.attributes[n].name]=t.attributes[n].value;return e},_process_xml:function(t){if(this._refresh_mode)return this._refreshFromXML(t);this._parsing=!0;var e=dhx4.ajax.xmltop(this.xml.top,t);if(e.tagName==this.xml.top){var n=e.getAttribute("dhx_security");n&&(dhtmlx.security_key=n),this._parseHead(e);var i=dhx4.ajax.xpath(this.xml.row,e),a=parseInt(e.getAttribute("pos")||0),o=parseInt(e.getAttribute("total_count")||0);if(!this.pagingOn)o=Math.min(o,32e6/this._srdh);var r=!1;if(o&&o!=this.rowsBuffer.length&&(this.rowsBuffer[o-1]||(this.rowsBuffer.length&&(r=!0),this.rowsBuffer[o-1]=null),o<this.rowsBuffer.length&&(this.rowsBuffer.splice(o,this.rowsBuffer.length-o),r=!0)),this.isTreeGrid())return this._process_tree_xml(e);for(var s=0;s<i.length;s++)if(!this.rowsBuffer[s+a]){var l=i[s].getAttribute("id")||s+a+1;this.rowsBuffer[s+a]={idd:l,data:i[s],_parser:this._process_xml_row,_locator:this._get_xml_data},this.rowsAr[l]=i[s]}if(this.callEvent("onDataReady",[]),r&&this._srnd){var d=this.objBox.scrollTop;this._reset_view(),this.objBox.scrollTop=d}else this.render_dataset();this._parsing=!1}},_process_jsarray:function(data){this._parsing=!0,data=data.responseText||data,"string"==typeof data&&(eval("dhtmlx.temp="+data+";"),data=dhtmlx.temp);for(var i=0;i<data.length;i++){var id=i+1;this.rowsBuffer.push({idd:id,data:data[i],_parser:this._process_jsarray_row,_locator:this._get_jsarray_data}),this.rowsAr[id]=data[i]}this.render_dataset(),this._parsing=!1},_process_csv:function(t){if(this._parsing=!0,t=(t=(t=t.responseText||t).replace(/\r/g,"")).split(this.csv.row),this._csvHdr){this.clearAll();var e=t.splice(0,1)[0].split(this.csv.cell);this._csvAID||e.splice(0,1),this.setHeader(e.join(this.delim)),this.init()}for(var n=0;n<t.length;n++)if(t[n]||n!=t.length-1){if(this._csvAID){var i=n+1;this.rowsBuffer.push({idd:i,data:t[n],_parser:this._process_csv_row,_locator:this._get_csv_data})}else{var a=t[n].split(this.csv.cell);i=a.splice(0,1)[0];this.rowsBuffer.push({idd:i,data:a,_parser:this._process_jsarray_row,_locator:this._get_jsarray_data})}this.rowsAr[i]=t[n]}this.render_dataset(),this._parsing=!1},_process_js:function(t){return this._process_json(t,"js")},_process_json:function(data,mode){this._parsing=!0;var data=data.responseText||data;if("string"==typeof data&&(eval("dhtmlx.temp="+data+";"),data=dhtmlx.temp),"js"==mode){data.data&&(data=data.data);for(var i=0;i<data.length;i++){var row=data[i],id=row.id||i+1;this.rowsBuffer.push({idd:id,data:row,_parser:this._process_js_row,_locator:this._get_js_data}),this.rowsAr[id]=data[i]}}else if(data.rows)for(var i=0;i<data.rows.length;i++){var id=data.rows[i].id;this.rowsBuffer.push({idd:id,data:data.rows[i],_parser:this._process_json_row,_locator:this._get_json_data}),this.rowsAr[id]=data.rows[i]}data.dhx_security&&(dhtmlx.security_key=data.dhx_security),this.callEvent("onDataReady",[]),this.render_dataset(),this._parsing=!1},render_dataset:function(t,e){if(this._srnd){if(this._fillers)return this._update_srnd_view();e=Math.min(this._get_view_size()+(this._srnd_pr||0),this.rowsBuffer.length)}this.pagingOn?(t=Math.max(t||0,(this.currentPage-1)*this.rowsBufferOutSize),e=Math.min(this.currentPage*this.rowsBufferOutSize,this.rowsBuffer.length)):(t=t||0,e=e||this.rowsBuffer.length);for(var n=t;n<e;n++){var i=this.render_row(n);if(-1==i){this.xmlFileUrl&&this.callEvent("onDynXLS",[n,this._dpref?this._dpref:e-n])&&this.load(this.xmlFileUrl+dhtmlx.url(this.xmlFileUrl)+"posStart="+n+"&count="+(this._dpref?this._dpref:e-n),this._data_type),e=n;break}if(i.parentNode&&i.parentNode.tagName||(this._insertRowAt(i,n),(i._attrs.selected||i._attrs.select)&&(this.selectRow(i,!!i._attrs.call,!0),i._attrs.selected=i._attrs.select=null)),this._ads_count&&n-t==this._ads_count){var a=this;return this._context_parsing=this._context_parsing||this._parsing,this._contextCallTimer=window.setTimeout(function(){a._contextCallTimer=null,a.render_dataset(n,e),a._contextCallTimer||(a._context_parsing?a.callEvent("onXLE",[]):a._fixAlterCss(),a._context_parsing=!1)},this._ads_time)}}if(this._ads_count&&n==e&&this.callEvent("onDistributedEnd",[]),this._srnd&&!this._fillers){var o=this.rowsBuffer.length-e;this._fillers=[],this._fake&&!this._realfake&&(this._fake._fillers=[]);for(var r=Math.round(99e4/this._srdh);o>0;){var s=_isIE||window._FFrv?Math.min(o,r):o,l=this._add_filler(e,s);l&&this._fillers.push(l),o-=s,e+=s}}this.setSizes()},render_row:function(t){if(!this.rowsBuffer[t])return-1;if(this.rowsBuffer[t]._parser){var e=this.rowsBuffer[t];if(this.rowsAr[e.idd]&&"TR"==this.rowsAr[e.idd].tagName)return this.rowsBuffer[t]=this.rowsAr[e.idd];var n=this._prepareRow(e.idd);return this.rowsBuffer[t]=n,this.rowsAr[e.idd]=n,e._parser.call(this,n,e.data),this._postRowProcessing(n),n}return this.rowsBuffer[t]},_get_cell_value:function(t,e,n){return t._locator?(this._c_order&&(e=this._c_order[e]),t._locator.call(this,t.data,e)):this.cells3(t,e)[n||"getValue"]()},sortRows:function(t,e,n){if(this.editStop(),n=(n||"asc").toLowerCase(),e=e||this.fldSort[t],t=t||0,this.isTreeGrid())this.sortTreeRows(t,e,n);else{var i={},a=this.cellType[t],o="getValue";"link"==a&&(o="getContent"),"dhxCalendar"!=a&&"dhxCalendarA"!=a||(o="getDate"),"co"!=a&&"coro"!=a||(o="getText");for(var r=0;r<this.rowsBuffer.length;r++)i[this.rowsBuffer[r].idd]=this._get_cell_value(this.rowsBuffer[r],t,o);this._sortRows(t,e,n,i)}this.callEvent("onAfterSorting",[t,e,n])},_sortCore:function(t,e,n,i,a){var o="sort";if(this._sst&&(a.stablesort=this.rowsCol.stablesort,o="stablesort"),e.length>4&&(e=window[e]),"cus"==e){var r=this._customSorts[t];a[o](function(t,e){return r(i[t.idd],i[e.idd],n,t.idd,e.idd)})}else"function"==typeof e?a[o](function(t,a){return e(i[t.idd],i[a.idd],n,t.idd,a.idd)}):"str"==e?a[o](function(t,e){return"asc"==n?i[t.idd]>i[e.idd]?1:i[t.idd]<i[e.idd]?-1:0:i[t.idd]<i[e.idd]?1:i[t.idd]>i[e.idd]?-1:0}):"int"==e?a[o](function(t,e){var a=parseFloat(i[t.idd]);a=isNaN(a)?-99999999999999:a;var o=parseFloat(i[e.idd]);return o=isNaN(o)?-99999999999999:o,"asc"==n?a-o:o-a}):"date"==e&&a[o](function(t,e){var a=Date.parse(i[t.idd])||Date.parse("01/01/1900"),o=Date.parse(i[e.idd])||Date.parse("01/01/1900");return"asc"==n?a-o:o-a})},_sortRows:function(t,e,n,i){this._sortCore(t,e,n,i,this.rowsBuffer),this._reset_view(),this.callEvent("onGridReconstructed",[])},_reset_view:function(t){if(this.obj.rows[0]){this._lahRw&&this._unsetRowHover(0,!0),this.callEvent("onResetView",[]);var e=this.obj.rows[0].parentNode,n=e.removeChild(e.childNodes[0],!0);if(_isKHTML)for(var i=e.parentNode.childNodes.length-1;i>=0;i--)"TR"==e.parentNode.childNodes[i].tagName&&e.parentNode.removeChild(e.parentNode.childNodes[i],!0);else if(_isIE)for(i=e.childNodes.length-1;i>=0;i--)e.childNodes[i].removeNode(!0);else e.innerHTML="";e.appendChild(n),this.rowsCol=dhtmlxArray(),this._sst&&this.enableStableSorting(!0),this._fillers=this.undefined,t||(_isIE&&this._srnd,this.render_dataset())}},deleteRow:function(t,e){if(e||(e=this.getRowById(t)),e){if(this.editStop(),!this._realfake&&0==this.callEvent("onBeforeRowDeleted",[t]))return!1;var n=0;if(-1==this.cellType._dhx_find("tree")||this._realfake){e.parentNode&&e.parentNode.removeChild(e);var i=this.rowsCol._dhx_find(e);-1!=i&&this.rowsCol._dhx_removeAt(i);for(var a=0;a<this.rowsBuffer.length;a++)if(this.rowsBuffer[a]&&this.rowsBuffer[a].idd==t){this.rowsBuffer._dhx_removeAt(a),i=a;break}}else n=this._h2.get[t].parent.id,this._removeTrGrRow(e);this.rowsAr[t]=null;for(a=0;a<this.selectedRows.length;a++)this.selectedRows[a].idd==t&&this.selectedRows._dhx_removeAt(a);if(this._srnd){for(a=0;a<this._fillers.length;a++){var o=this._fillers[a];o&&(o[0]>=i?this._update_fillers(a,0,-1):o[0]+o[1]>i&&this._update_fillers(a,-1,0))}this._update_srnd_view()}return this.pagingOn&&this.changePage(),this._realfake||this.callEvent("onAfterRowDeleted",[t,n]),this.callEvent("onGridReconstructed",[]),this._ahgr&&this.setSizes(),!0}},_addRow:function(t,e,n){-1!=n&&void 0!==n||(n=this.rowsBuffer.length),"string"==typeof e&&(e=e.split(this.delim));var i=this._prepareRow(t);i._attrs={};for(var a=0;a<i.childNodes.length;a++)i.childNodes[a]._attrs={};if(this.rowsAr[i.idd]=i,this._h2&&(this._h2.get[i.idd].buff=i),this._fillRow(i,e),this._postRowProcessing(i),this._skipInsert)return this._skipInsert=!1,this.rowsAr[i.idd]=i;if(this.pagingOn)return this.rowsBuffer._dhx_insertAt(n,i),this.rowsAr[i.idd]=i,i;if(this._fillers){this.rowsCol._dhx_insertAt(n,null),this.rowsBuffer._dhx_insertAt(n,i),this._fake&&this._fake.rowsCol._dhx_insertAt(n,null),this.rowsAr[i.idd]=i;for(var o=!1,r=0;r<this._fillers.length;r++){var s=this._fillers[r];if(s&&s[0]<=n&&s[0]+s[1]>=n){s[1]=s[1]+1;var l=s[2].firstChild.style.height=parseInt(s[2].firstChild.style.height)+this._srdh+"px";o=!0,this._fake&&(this._fake._fillers[r][1]++,this._fake._fillers[r][2].firstChild.style.height=l)}s&&s[0]>n&&(s[0]=s[0]+1,this._fake&&this._fake._fillers[r][0]++)}return o||this._fillers.push(this._add_filler(n,1,0==n?{parentNode:this.obj.rows[0].parentNode,nextSibling:this.rowsCol[1]}:this.rowsCol[n-1])),i}return this.rowsBuffer._dhx_insertAt(n,i),this._insertRowAt(i,n)},addRow:function(t,e,n){var i=this._addRow(t,e,n);return this.dragContext||this.callEvent("onRowAdded",[t]),this.pagingOn&&this.changePage(this.currentPage),this._srnd&&this._update_srnd_view(),i._added=!0,this._srnd&&!this._fillers&&(this._fillers=[]),this._ahgr&&this.setSizes(),this.callEvent("onGridReconstructed",[]),i},_insertRowAt:function(t,e,n){if(this.rowsAr[t.idd]=t,this._skipInsert)return this._skipInsert=!1,t;if(e<0||!e&&0!==parseInt(e)?e=this.rowsCol.length:e>this.rowsCol.length&&(e=this.rowsCol.length),this._cssEven){var i=t.className.replace(this._cssUnEven,"");(this._cssSP?this.getLevel(t.idd):e)%2==1?t.className=i+" "+this._cssUnEven+(this._cssSU?" "+this._cssUnEven+"_"+this.getLevel(t.idd):""):t.className=i+" "+this._cssEven+(this._cssSU?" "+this._cssEven+"_"+this.getLevel(t.idd):"")}return n||(e!=this.obj.rows.length-1&&this.rowsCol[e]?this.rowsCol[e].parentNode.insertBefore(t,this.rowsCol[e]):_isKHTML?this.obj.appendChild(t):this.obj.firstChild.appendChild(t)),this.rowsCol._dhx_insertAt(e,t),this.callEvent("onRowInserted",[t,e]),t},getRowById:function(t){var e=this.rowsAr[t];if(e){if("TR"!=e.tagName){for(var n=0;n<this.rowsBuffer.length;n++)if(this.rowsBuffer[n]&&this.rowsBuffer[n].idd==t)return this.render_row(n);if(this._h2)return this.render_row(null,e.idd)}return e}return null},cellById:function(t,e){return this.cells(t,e)},cells:function(t,e){if(0==arguments.length)return this.cells4(this.cell);var n=this.getRowById(t),i=n._childIndexes?n.childNodes[n._childIndexes[e]]:n.childNodes[e];return!i&&n._childIndexes&&(i=n.firstChild||{}),this.cells4(i)},cellByIndex:function(t,e){return this.cells2(t,e)},cells2:function(t,e){var n=this.render_row(t),i=n._childIndexes?n.childNodes[n._childIndexes[e]]:n.childNodes[e];return!i&&n._childIndexes&&(i=n.firstChild||{}),this.cells4(i)},cells3:function(t,e){var n=t._childIndexes?t.childNodes[t._childIndexes[e]]:t.childNodes[e];return this.cells4(n)},cells4:function(t){var e=window["eXcell_"+(t._cellType||this.cellType[t._cellIndex])];if(e)return new e(t)},cells5:function(t,e){e=e||t._cellType||this.cellType[t._cellIndex];if(!this._ecache[e]){if(window["eXcell_"+e])n=window["eXcell_"+e];else var n=eXcell_ro;this._ecache[e]=new n(t)}return this._ecache[e].cell=t,this._ecache[e]},dma:function(t){this._ecache||(this._ecache={}),t&&!this._dma?(this._dma=this.cells4,this.cells4=this.cells5):!t&&this._dma&&(this.cells4=this._dma,this._dma=null)},getRowsNum:function(){return this.rowsBuffer.length},enableEditTabOnly:function(t){arguments.length>0?this.smartTabOrder=dhx4.s2b(t):this.smartTabOrder=!0},setExternalTabOrder:function(t,e){var n=this;this.tabStart="object"==typeof t?t:document.getElementById(t);var i=this.tabStart.onkeydown;this.tabStart.onkeydown=function(t){i&&i.call(this,t);var e=t||window.event;if(9==e.keyCode&&!e.shiftKey)return e.cancelBubble=!0,n.selectCell(0,0,0,0,1),n.smartTabOrder&&n.cells2(0,0).isDisabled()&&n._key_events.k9_0_0.call(n),this.blur(),!1},_isOpera&&(this.tabStart.onkeypress=this.tabStart.onkeydown),this.tabEnd="object"==typeof e?e:document.getElementById(e);var a=this.tabEnd.onkeydown;this.tabEnd.onkeydown=this.tabEnd.onkeypress=function(t){a&&a.call(this,t);var e=t||window.event;if(9==e.keyCode&&e.shiftKey)return e.cancelBubble=!0,n.selectCell(n.getRowsNum()-1,n.getColumnCount()-1,0,0,1),n.smartTabOrder&&n.cells2(n.getRowsNum()-1,n.getColumnCount()-1).isDisabled()&&n._key_events.k9_0_1.call(n),this.blur(),!1},_isOpera&&(this.tabEnd.onkeypress=this.tabEnd.onkeydown)},uid:function(){return this._ui_seed||(this._ui_seed=(new Date).valueOf()),this._ui_seed++},setIconset:function(t){this.iconset=t},clearAndLoad:function(){if(this._last_load_request){var t=this._last_load_request.xmlDoc;if(4!=t.readyState)try{t.onreadystatechange=function(){},t.abort()}catch(t){}}var e=this._pgn_skin;this._pgn_skin=null,this.clearAll(),this._pgn_skin=e,this._last_load_request=this.load.apply(this,arguments)},getStateOfView:function(){if(this.pagingOn){var t=(this.currentPage-1)*this.rowsBufferOutSize;return[this.currentPage,t,Math.min(t+this.rowsBufferOutSize,this.rowsBuffer.length),this.rowsBuffer.length]}var e=Math.floor(this.objBox.scrollTop/this._srdh),n=Math.ceil(parseInt(this.objBox.offsetHeight)/this._srdh);if(this.multiLine){var i=this.objBox.scrollTop;for(e=0;i>=0;)i-=this.rowsCol[e]?this.rowsCol[e].offsetHeight:this._srdh,e++;for(e--,i+=this.objBox.offsetHeight,n=0;i>=0;)i-=this.rowsCol[e+n]?this.rowsCol[e+n].offsetHeight:this._srdh,n++}return[e,n,this.rowsBuffer.length]}},function(){function t(t,e){this[t]=e}function e(t,e){this[t].call(this,e)}function n(t,e){this[t].call(this,e.join(this.delim))}var i=[{name:"label",def:"&nbsp;",operation:"setHeader",type:function(t,e,n){var i=[];function a(t,e,n){i[e]||(i[e]=[]),"object"==typeof n&&(n.toString=function(){return this.text}),i[e][t]=n}for(var o=0;o<e.length;o++)if("object"==typeof e[o]&&e[o].length)for(var r=0;r<e[o].length;r++)a(o,r,e[o][r]);else a(o,0,e[o]);for(o=0;o<i.length;o++)for(r=0;r<i[0].length;r++){var s=i[o][r];if(i[o][r]=(s||"").toString()||"&nbsp;",s&&s.colspan)for(var l=1;l<s.colspan;l++)a(r+l,o,"#cspan");if(s&&s.rowspan)for(l=1;l<s.rowspan;l++)a(r,o+l,"#rspan")}for(this.setHeader(i[0]),o=1;o<i.length;o++)this.attachHeader(i[o])}},{name:"id",def:"",operation:"columnIds",type:t},{name:"width",def:"*",operation:"setInitWidths",type:n},{name:"align",def:"left",operation:"cellAlign",type:t},{name:"valign",def:"middle",operation:"cellVAlign",type:t},{name:"sort",def:"na",operation:"fldSort",type:t},{name:"type",def:"ro",operation:"setColTypes",type:n},{name:"options",def:"",operation:"",type:function(t,e){for(var n=0;n<e.length;n++)if("object"==typeof e[n]){var i=this.getCombo(n);for(var a in e[n])i.put(a,e[n][a])}}}];dhtmlx.extend_api("dhtmlXGridObject",{_init:function(t){return[t.parent]},image_path:"setImagePath",columns:"columns",rows:"rows",headers:"headers",skin:"setSkin",smart_rendering:"enableSmartRendering",css:"enableAlterCss",auto_height:"enableAutoHeight",save_hidden:"enableAutoHiddenColumnsSaving",save_cookie:"enableAutoSaving",save_size:"enableAutoSizeSaving",auto_width:"enableAutoWidth",block_selection:"enableBlockSelection",csv_id:"enableCSVAutoID",csv_header:"enableCSVHeader",cell_ids:"enableCellIds",colspan:"enableColSpan",column_move:"enableColumnMove",context_menu:"enableContextMenu",distributed:"enableDistributedParsing",drag:"enableDragAndDrop",drag_order:"enableDragOrder",tabulation:"enableEditTabOnly",header_images:"enableHeaderImages",header_menu:"enableHeaderMenu",keymap:"enableKeyboardSupport",mouse_navigation:"enableLightMouseNavigation",markers:"enableMarkedCells",math_editing:"enableMathEditing",math_serialization:"enableMathSerialization",drag_copy:"enableMercyDrag",multiline:"enableMultiline",multiselect:"enableMultiselect",save_column_order:"enableOrderSaving",hover:"enableRowsHover",rowspan:"enableRowspan",smart:"enableSmartRendering",save_sorting:"enableSortingSaving",stable_sorting:"enableStableSorting",undo:"enableUndoRedo",csv_cell:"setCSVDelimiter",date_format:"setDateFormat",drag_behavior:"setDragBehavior",editable:"setEditable",without_header:"setNoHeader",submit_changed:"submitOnlyChanged",submit_serialization:"submitSerialization",submit_selected:"submitOnlySelected",submit_id:"submitOnlyRowID",xml:"load"},{columns:function(t){for(var n=0;n<i.length;n++){for(var a=[],o=0;o<t.length;o++)a[o]=t[o][i[n].name]||i[n].def;(i[n].type||e).call(this,i[n].operation,a,t)}this.init()},rows:function(t){},headers:function(t){for(var e=0;e<t.length;e++)this.attachHeader(t[e])}})}(),dhtmlXGridObject.prototype._dp_init=function(t){t.attachEvent("insertCallback",function(t,e){this.obj._h2?this.obj.addRow(e,n,null,parent):this.obj.addRow(e,[],0);var n=this.obj.getRowById(e);n&&(this.obj._process_xml_row(n,t.firstChild),this.obj._postRowProcessing(n))}),t.attachEvent("updateCallback",function(t,e){var n=this.obj.getRowById(e);n&&(this.obj._process_xml_row(n,t.firstChild),this.obj._postRowProcessing(n))}),t.attachEvent("deleteCallback",function(t,e){this.obj.setUserData(e,this.action_param,"true_deleted"),this.obj.deleteRow(e)}),t._methods=["setRowTextStyle","setCellTextStyle","changeRowId","deleteRow"],this.attachEvent("onEditCell",function(e,n,i){if(t._columns&&!t._columns[i])return!0;var a=this.cells(n,i);return 1==e?a.isCheckbox()&&t.setUpdated(n,!0):2==e&&a.wasChanged()&&t.setUpdated(n,!0),!0}),this.attachEvent("onRowPaste",function(e){t.setUpdated(e,!0)}),this.attachEvent("onUndo",function(e){t.setUpdated(e,!0)}),this.attachEvent("onRowIdChange",function(e,n){var i=t.findRow(e);i<t.updatedRows.length&&(t.updatedRows[i]=n)}),this.attachEvent("onSelectStateChanged",function(e){return"row"==t.updateMode&&t.sendData(),!0}),this.attachEvent("onEnter",function(e,n){return"row"==t.updateMode&&t.sendData(),!0}),this.attachEvent("onBeforeRowDeleted",function(e){if(t._silent_mode||!this.rowsAr[e])return!0;if(this.dragContext&&t.dnd)return window.setTimeout(function(){t.setUpdated(e,!0)},1),!0;var n=t.getState(e);return this._h2&&this._h2.forEachChild(e,function(e){t.setUpdated(e.id,!1),t.markRow(e.id,!0,"deleted")},this),"inserted"==n?(t.set_invalid(e,!1),t.setUpdated(e,!1),!0):"deleted"!=n&&("true_deleted"==n?(t.setUpdated(e,!1),!0):(t.setUpdated(e,!0,"deleted"),!1))}),this.attachEvent("onBindUpdate",function(e,n,i){t.setUpdated(i,!0)}),this.attachEvent("onRowAdded",function(e){return!(!this.dragContext||!t.dnd)||(t.setUpdated(e,!0,"inserted"),!0)}),t._getRowData=function(t,e){var n,i={};i.gr_id=t,this.obj.isTreeGrid()&&(i.gr_pid=this.obj.getParentId(t));for(var a=this.obj.getRowById(t),o=0;o<this.obj._cCount;o++){if(this.obj._c_order)var r=this.obj._c_order[o];else r=o;var s=this.obj.cells(a.idd,o);this._changed&&!s.wasChanged()||(this._endnm?i[this.obj.getColumnId(o)]=s.getValue():i["c"+r]=s.getValue())}if(n=this.obj.UserData[t])for(var l=0;l<n.keys.length;l++)n.keys[l]&&0!=n.keys[l].indexOf("__")&&(i[n.keys[l]]=n.values[l]);if(n=this.obj.UserData.gridglobaluserdata)for(l=0;l<n.keys.length;l++)i[n.keys[l]]=n.values[l];return i},t._clearUpdateFlag=function(t){if(this.obj.getRowById(t))for(var e=0;e<this.obj._cCount;e++)this.obj.cells(t,e).cell.wasChanged=!1},t.checkBeforeUpdate=function(t){for(var e=!0,n=[],i=0;i<this.obj._cCount;i++)if(this.mandatoryFields[i]){var a=this.mandatoryFields[i].call(this.obj,this.obj.cells(t,i).getValue(),t,i);"string"==typeof a?(this.messages.push(a),e=!1):(e&=a,n[i]=!a)}return e||(this.set_invalid(t,"invalid",n),this.setUpdated(t,!1)),e}},dhx4.attachEvent("onGridCreated",function(t){if(t._con_f_used=[].concat(t._con_f_used),dhtmlXGridObject.prototype._con_f_used=[],!t._was_created_once){t._was_created_once=!0;var e=function(t){return function(t){return(t=t.replace(/(\?|\&)connector[^\f]*/g,""))+(-1!=t.indexOf("?")?"&":"?")+"connector=true"+(this.hdr.rows.length>0?"&dhx_no_header=1":"")}.call(this,t)+(this._connector_sorting||"")+(this._connector_filter||"")};t.attachEvent("onCollectValues",function(t){return!this._con_f_used[t]||"object"==typeof this._con_f_used[t]&&this._con_f_used[t]}),t.attachEvent("onDynXLS",function(){return this.xmlFileUrl&&(this.xmlFileUrl=e.call(this,this.xmlFileUrl)),!0}),t.attachEvent("onBeforeSorting",function(t,n,i){if("connector"==n){var a=this;return this.clearAndLoad(function(t,n,i){return this._connector_sorting="&dhx_sort["+n+"]="+i,e.call(this,t)}.call(this,this.xmlFileUrl,t,i),function(){a.setSortImgState(!0,t,i)}),!1}return!0}),t.attachEvent("onFilterStart",function(t,n){if(this._con_f_used.length){var i=this.getSortingState();return this.clearAndLoad(function(t,n,i){for(var a=[],o=0;o<n.length;o++)a[o]="dhx_filter["+n[o]+"]="+encodeURIComponent(i[o]);return this._connector_filter="&"+a.join("&"),e.call(this,t)}.call(this,this.xmlFileUrl,t,n)),i.length&&this.setSortImgState(!0,i[0],i[1]),!1}return!0})}}),dhtmlXGridObject.prototype._con_f_used=[],dhtmlXGridObject.prototype._in_header_connector_text_filter=function(t,e){return this._con_f_used[e]||(this._con_f_used[e]=1),this._in_header_text_filter(t,e)},dhtmlXGridObject.prototype._in_header_connector_select_filter=function(t,e){return this._con_f_used[e]||(this._con_f_used[e]=2),this._in_header_select_filter(t,e)},dhtmlXGridObject.prototype.load_connector||(dhtmlXGridObject.prototype.load_connector=dhtmlXGridObject.prototype.load,dhtmlXGridObject.prototype.load=function(t,e,n){if(!this._colls_loaded&&this.cellType){for(var i=[],a=0;a<this.cellType.length;a++)0!=this.cellType[a].indexOf("co")&&0!=this.cellType[a].indexOf("clist")&&2!=this._con_f_used[a]||i.push(a);i.length&&(arguments[0]+=(-1!=arguments[0].indexOf("?")?"&":"?")+"connector=true&dhx_colls="+i.join(","))}return this.load_connector.apply(this,arguments)},dhtmlXGridObject.prototype._parseHead_connector=dhtmlXGridObject.prototype._parseHead,dhtmlXGridObject.prototype._parseHead=function(t,e,n){if(this._parseHead_connector.apply(this,arguments),!this._colls_loaded){for(var i=dhx4.ajax.xpath("./coll_options",arguments[0]),a=0;a<i.length;a++){var o=i[a].getAttribute("for"),r=[],s=null;"combo"==this.cellType[o]?s=this.getColumnCombo(o):0==this.cellType[o].indexOf("co")&&(s=this.getCombo(o));for(var l=dhx4.ajax.xpath("./item",i[a]),d=[],c=0;c<l.length;c++){var h=l[c].getAttribute("value");if(s){var u=l[c].getAttribute("label")||h;s.addOption?d.push([h,u]):s.put(h,u),r[r.length]=u}else r[r.length]=h}d.length?s&&s.addOption(d):r.length&&!s&&this.registerCList&&this.registerCList(1*o,r),this._con_f_used[1*o]&&(this._con_f_used[1*o]=r)}this._colls_loaded=!0}}),dhtmlXGridObject.prototype.getRowData=function(t){for(var e={},n=this.getColumnsNum(),i=0;i<n;i++){var a=this.getColumnId(i);a&&(e[a]=this.cells(t,i).getValue())}return e},dhtmlXGridObject.prototype.setRowData=function(t,e){for(var n=this.getColumnsNum(),i=0;i<n;i++){var a=this.getColumnId(i);a&&e.hasOwnProperty(a)&&this.cells(t,i).setValue(e[a])}},dhtmlXGridCellObject.prototype={getAttribute:function(t){return this.cell._attrs[t]},setAttribute:function(t,e){this.cell._attrs[t]=e},getInput:function(){if(this.obj&&("INPUT"==this.obj.tagName||"TEXTAREA"==this.obj.tagName))return this.obj;var t=(this.obj||this.cell).getElementsByTagName("TEXTAREA");return t.length||(t=(this.obj||this.cell).getElementsByTagName("INPUT")),t[0]}},dhtmlXGridCellObject.prototype.setValue=function(t){"number"==typeof t||t&&""!=t.toString()._dhx_trim()?this.cell._clearCell=!1:(t="&nbsp;",this.cell._clearCell=!0),this.setCValue(t)},dhtmlXGridCellObject.prototype.getTitle=function(){return _isIE?this.cell.innerText:this.cell.textContent},dhtmlXGridCellObject.prototype.setCValue=function(t,e){this.cell.innerHTML=t,this.grid.callEvent("onCellChanged",[this.cell.parentNode.idd,this.cell._cellIndex,arguments.length>1?e:t])},dhtmlXGridCellObject.prototype.setCTxtValue=function(t){this.cell.innerHTML="",this.cell.appendChild(document.createTextNode(t)),this.grid.callEvent("onCellChanged",[this.cell.parentNode.idd,this.cell._cellIndex,t])},dhtmlXGridCellObject.prototype.setLabel=function(t){this.cell.innerHTML=t},dhtmlXGridCellObject.prototype.getMath=function(){return this._val?this.val:this.getValue()},eXcell.prototype=new dhtmlXGridCellObject,eXcell_ed.prototype=new eXcell,eXcell_edtxt.prototype=new eXcell_ed,eXcell_edn.prototype=new eXcell_ed,eXcell_edn.prototype.setValue=function(t){if(!t||""==t.toString()._dhx_trim())return this.cell._clearCell=!0,this.setCValue("&nbsp;",0);this.cell._clearCell=!1,this.cell._orig_value=t,this.setCValue(this.grid._aplNF(t,this.cell._cellIndex),t)},eXcell_ch.prototype=new eXcell,eXcell_ch.prototype.setValue=function(t){this.cell.style.verticalAlign="middle",t&&("false"!=(t=t.toString()._dhx_trim())&&"0"!=t||(t="")),t?(t="1",this.cell.chstate="1"):(t="0",this.cell.chstate="0");this.cell.setAttribute("excell","ch"),this.setCValue("<img src='"+this.grid.imgURL+"item_chk"+t+".gif' onclick='new eXcell_ch(this.parentNode).changeState(true); (arguments[0]||event).cancelBubble=true; '>",this.cell.chstate)},eXcell_ra.prototype=new eXcell_ch,eXcell_ra.prototype.setValue=function(t){if(this.cell.style.verticalAlign="middle",t&&("false"!=(t=t.toString()._dhx_trim())&&"0"!=t||(t="")),t){if(this.grid._RaSeCol||(this.grid._RaSeCol=[]),this.grid._RaSeCol[this.cell._cellIndex]){var e=this.grid._RaSeCol[this.cell._cellIndex];if(this.grid.rowsAr[e]){var n=this.grid.cells(e,this.cell._cellIndex);n.setValue("0"),this.grid.rowsAr[n.cell.parentNode.idd]&&this.grid.callEvent("onEditCell",[1,n.cell.parentNode.idd,n.cell._cellIndex])}}this.grid._RaSeCol[this.cell._cellIndex]=this.cell.parentNode.idd,t="1",this.cell.chstate="1"}else t="0",this.cell.chstate="0";this.cell.setAttribute("excell","ra"),this.setCValue("<img src='"+this.grid.imgURL+"radio_chk"+t+".gif' onclick='new eXcell_ra(this.parentNode).changeState(false);'>",this.cell.chstate)},eXcell_txt.prototype=new eXcell,eXcell_txttxt.prototype=new eXcell_txt,eXcell_txt.prototype.setValue=function(t){this.cell._brval=t,t&&""!=t.toString()._dhx_trim()?this.cell._clearCell=!1:(t="&nbsp;",this.cell._clearCell=!0),!this.grid.multiLine||this.cell._clearCell?this.setCValue(t,this.cell._brval):this.setCValue(t.replace(/\n/g,"<br/>"),t)},eXcell_co.prototype=new eXcell,eXcell_co.prototype.getText=function(){return this.cell.innerHTML},eXcell_co.prototype.setValue=function(t){if("object"==typeof t){var e=dhx4.ajax.xpath("./option",t);e.length&&(this.cell._combo=new dhtmlXGridComboObject);for(var n=0;n<e.length;n++)this.cell._combo.put(e[n].getAttribute("value"),e[n].firstChild?e[n].firstChild.data:"");t=t.firstChild.data}if(""==(t||"").toString()._dhx_trim()&&(t=null),this.cell.combo_value=t,null!==t){var i=(this.cell._combo||this.grid.getCombo(this.cell._cellIndex)).get(t);this.setCValue(null===i?t:i,t)}else this.setCValue("&nbsp;",t)},eXcell_coro.prototype=new eXcell_co,eXcell_cotxt.prototype=new eXcell_co,eXcell_cotxt.prototype.getText=function(){return _isIE?this.cell.innerText:this.cell.textContent},eXcell_cotxt.prototype.setValue=function(t){if("object"==typeof t){var e=dhx4.ajax.xpath("./option",t);e.length&&(this.cell._combo=new dhtmlXGridComboObject);for(var n=0;n<e.length;n++)this.cell._combo.put(e[n].getAttribute("value"),e[n].firstChild?e[n].firstChild.data:"");t=t.firstChild.data}""==(t||"").toString()._dhx_trim()&&(t=null),null!==t?this.setCTxtValue((this.cell._combo||this.grid.getCombo(this.cell._cellIndex)).get(t)||t,t):this.setCTxtValue(" ",t),this.cell.combo_value=t},eXcell_corotxt.prototype=new eXcell_cotxt,eXcell_cp.prototype=new eXcell,eXcell_cp.prototype.setValue=function(t){this.setCValue("<div style='width:100%;height:"+(this.grid.multiLine?"100%":23)+";background-color:"+(t||"")+";border:0px;'>&nbsp;</div>",t),this.cell.firstChild._bg=t},eXcell_img.prototype=new eXcell,eXcell_img.prototype.getTitle=function(){return this.cell._brval},eXcell_img.prototype.setValue=function(t){var e=t;if(-1!=(t||"").indexOf("^")){var n=t.split("^");t=n[0],e=this.cell._attrs.title||n[1],n.length>2&&(this.cell.lnk=n[2],n[3]&&(this.cell.trg=n[3])),this.cell.titFl="1"}this.grid.multiLine?this.setCValue("<img src='"+this.grid.iconURL+(t||"")._dhx_trim()+"' border='0'>",t):this.setCValue("<img src='"+this.grid.iconURL+(t||"")._dhx_trim()+"' border='0' style='max-height:"+(this.grid._srdh-4)+"px'>",t),this.cell.lnk&&(this.cell.innerHTML="<a href='"+this.cell.lnk+"' target='"+this.cell.trg+"'>"+this.cell.innerHTML+"</a>"),this.cell._brval=e},eXcell_icon.prototype=new eXcell_ed,eXcell_price.prototype=new eXcell_ed,eXcell_price.prototype.setValue=function(t){isNaN(parseFloat(t))&&(t=this.val||0);var e="green";t<0&&(e="red"),this.setCValue("<span>$</span><span style='padding-right:2px;color:"+e+";'>"+t+"</span>",t)},eXcell_dyn.prototype=new eXcell_ed,eXcell_dyn.prototype.getValue=function(){eXcell_ed.prototype.getValue.call(this)},eXcell_dyn.prototype.setValue=function(t){if(!t||isNaN(Number(t)))""!==t&&(t=0);else{if(t>0)var e="green",n="dyn_up.gif";else if(0==t)e="black",n="dyn_.gif";else e="red",n="dyn_down.gif";t=this.grid._aplNF(t,this.cell._cellIndex)}this.setCValue("<div class='grid_cell_dyn'><img src='"+this.grid.imgURL+n+"'><span style='color:"+e+";'>"+t+"</span></div>",t)},eXcell_ro.prototype=new eXcell,window.eXcell_hidden=function(t){t&&(this.cell=t,this.grid=this.cell.parentNode.grid),this.edit=function(){},this.isDisabled=function(){return!0},this.getValue=function(){return this.cell.val}},eXcell_hidden.prototype=new eXcell,eXcell_hidden.prototype.setValue=function(t){this.cell.val=t},eXcell_ron.prototype=new eXcell,eXcell_ron.prototype.setValue=function(t){if(0===t);else if(!t||""==t.toString()._dhx_trim())return this.setCValue("&nbsp;"),this.cell._clearCell=!0;this.cell._orig_value=t,this.cell._clearCell=!1,this.setCValue(t?this.grid._aplNF(t,this.cell._cellIndex):"0")},eXcell_rotxt.prototype=new eXcell,Hashtable.prototype=new dhtmlXGridComboObject,void 0!==window.dhtmlXCellObject&&(dhtmlXCellObject.prototype.attachGrid=function(t){this.callEvent("_onBeforeContentAttach",["grid"]);var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden",this._attachObject(e),this.dataType="grid",t&&"object"==typeof t&&!t.tagName&&(t.parent=e,e=t),this.dataObj=new dhtmlXGridObject(e),this.dataObj.setSkin(this.conf.skin),"function"==typeof window.dhtmlXTabBarCell&&this instanceof window.dhtmlXTabBarCell&&null!=navigator.userAgent.match(/7[\.\d]* mobile/gi)&&null!=navigator.userAgent.match(/AppleWebKit/gi)&&(this.dataObj.objBox.style.webkitOverflowScrolling="auto"),"material"==this.conf.skin&&"function"==typeof window.dhtmlXLayoutCell&&this instanceof window.dhtmlXLayoutCell&&(this.cell.childNodes[this.conf.idx.cont].style.overflow="hidden"),"dhx_skyblue"==this.conf.skin&&"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell?(this.dataObj.entBox.style.border="1px solid #a4bed4",this.dataObj._sizeFix=0):(this.dataObj.entBox.style.border="0px solid white",this.dataObj._sizeFix=2),e=null,this.callEvent("_onContentAttach",[]),this.dataObj}),dhtmlXGridObject.prototype.enableDragAndDrop=function(t){"temporary_disabled"==t?(this.dADTempOff=!1,t=!0):this.dADTempOff=!0,this.dragAndDropOff=dhx4.s2b(t),this._drag_validate=!0,t&&(this.objBox.ondragstart=function(t){return(t||event).cancelBubble=!0,!1})},dhtmlXGridObject.prototype.setDragBehavior=function(t){switch(this.dadmodec=this.dadmodefix=0,t){case"child":this.dadmode=0,this._sbmod=!1;break;case"sibling":this.dadmode=1,this._sbmod=!1;break;case"sibling-next":this.dadmode=1,this._sbmod=!0;break;case"complex":this.dadmode=2,this._sbmod=!1;break;case"complex-next":this.dadmode=2,this._sbmod=!0}},dhtmlXGridObject.prototype.enableDragOrder=function(t){this._dndorder=dhx4.s2b(t)},dhtmlXGridObject.prototype._checkParent=function(t,e){var n=this._h2.get[t.idd].parent;if(n.parent){for(var i=0;i<e.length;i++)if(e[i]==n.id)return!0;return this._checkParent(this.rowsAr[n.id],e)}},dhtmlXGridObject.prototype._createDragNode=function(t,e){if(this.editStop(),window.dhtmlDragAndDrop.dragNode)return null;if(!this.dADTempOff)return null;t.parentObject=new Object,t.parentObject.treeNod=this;var n=this.callEvent("onBeforeDrag",[t.parentNode.idd,t._cellIndex,e]);if(!n)return null;var i=new Array;i=(i=this.getSelectedId())&&""!=i?i.split(this.delim):[];for(var a=!1,o=0;o<i.length;o++)i[o]==t.parentNode.idd&&(a=!0);if(a||(this.selectRow(this.rowsAr[t.parentNode.idd],!1,e.ctrlKey,!1),e.ctrlKey||(i=[]),i[this.selMultiRows?i.length:0]=t.parentNode.idd),this.isTreeGrid())for(o=i.length-1;o>=0;o--)this._checkParent(this.rowsAr[i[o]],i)&&i.splice(o,1);var r=this;i.length&&this._dndorder&&i.sort(function(t,e){return r.rowsAr[t].rowIndex>r.rowsAr[e].rowIndex?1:-1});var s=this.getFirstParentOfType(_isIE?e.srcElement:e.target,"TD");s&&(this._dndExtra=s._cellIndex),this._dragged=new Array;for(o=0;o<i.length;o++)this.rowsAr[i[o]]&&(this._dragged[this._dragged.length]=this.rowsAr[i[o]],this.rowsAr[i[o]].treeNod=this);t.parentObject.parentNode=t.parentNode;var l=document.createElement("div");return l.innerHTML=!0!==n?n:this.rowToDragElement(t.parentNode.idd),l.style.position="absolute",l.className="dragSpanDiv",l},dhtmlXGridObject.prototype._createSdrgc=function(){this._sdrgc=document.createElement("DIV"),this._sdrgc.innerHTML="&nbsp;",this._sdrgc.className="gridDragLine",this.objBox.appendChild(this._sdrgc)},dragContext.prototype.valid=function(){if(this.sobj!=this.tobj)return!0;if(this.sid==this.tid)return!1;if("treeGrid"==this.target)for(var t=this.tid;t=this.tobj.getParentId(t);)if(this.sid==t)return!1;return!0},dragContext.prototype.close=function(){this.sobj=null,this.tobj=null},dragContext.prototype.copy=function(){return new dragContext(this.source,this.target,this.mode,this.dropmode,this.sid,this.tid,this.sobj,this.tobj,this.sExtra,this.tExtra,this.before)},dragContext.prototype.set=function(t,e){return this[t]=e,this},dragContext.prototype.uid=function(t,e){for(this.nid=this.sid;this.tobj.rowsAr[this.nid];)this.nid=this.nid+(new Date).valueOf();return this},dragContext.prototype.data=function(){return this.sobj==this.tobj?this.sobj._getRowArray(this.sobj.rowsAr[this.sid]):"tree"==this.source?this.tobj.treeToGridElement(this.sobj,this.sid,this.tid):this.tobj.gridToGrid(this.sid,this.sobj,this.tobj)},dragContext.prototype.attrs=function(){return"tree"==this.source?{}:this.sobj.rowsAr[this.sid]._attrs},dragContext.prototype.childs=function(){return"treeGrid"==this.source&&this.sobj._h2.get[this.sid]._xml_await?this.sobj._h2.get[this.sid].has_kids:null},dragContext.prototype.pid=function(){if(!this.tid)return 0;if(!this.tobj._h2)return 0;if("treeGrid"==this.target){if("child"==this.dropmode)return this.tid;var t=this.tobj.rowsAr[this.tid],e=this.tobj._h2.get[t.idd].parent.id;if(this.alfa&&this.tobj._sbmod&&t.nextSibling){var n=this.tobj._h2.get[t.nextSibling.idd].parent.id;if(n==this.tid)return this.tid;if(n!=e)return n}return e}},dragContext.prototype.ind=function(){if(this.tid==window.unknown)return this.tobj.rowsBuffer.length;"treeGrid"==this.target&&("child"==this.dropmode?this.tobj.openItem(this.tid):this.tobj.openItem(this.tobj.getParentId(this.tid)));var t=this.tobj.rowsBuffer._dhx_find(this.tobj.rowsAr[this.tid]);if(this.alfa&&this.tobj._sbmod&&"sibling"==this.dropmode){var e=this.tobj.rowsAr[this.tid];if(e.nextSibling&&this._h2.get[e.nextSibling.idd].parent.id==this.tid)return t+1}return t+1+("treeGrid"==this.target&&t>=0&&"minus"==this.tobj._h2.get[this.tobj.rowsBuffer[t].idd].state?this.tobj._getOpenLenght(this.tobj.rowsBuffer[t].idd,0):0)},dragContext.prototype.img=function(){return"grid"!=this.target&&this.sobj._h2?this.sobj.getItemImage(this.sid):null},dragContext.prototype.slist=function(){for(var t=new Array,e=0;e<this.sid.length;e++)t[t.length]=this.sid[e]["tree"==this.source?"id":"idd"];return t.join(",")},dhtmlXGridObject.prototype._drag=function(t,e,n,i){if(this._realfake)return this._fake._drag();this.lastLanding;this._autoOpenTimer&&window.clearTimeout(this._autoOpenTimer);var a=n.parentNode,o=t.parentObject;a.idd||(a.grid=this,this.dadmodefix=0);var r=new dragContext(0,0,0,1==a.grid.dadmode||a.grid.dadmodec?"sibling":"child");if(o&&o.childNodes)r.set("source","tree").set("sobj",o.treeNod).set("sid",r.sobj._dragged);else{if(!o)return!0;o.treeNod.isTreeGrid&&o.treeNod.isTreeGrid()&&r.set("source","treeGrid"),r.set("sobj",o.treeNod).set("sid",r.sobj._dragged)}a.grid.isTreeGrid()?r.set("target","treeGrid"):r.set("dropmode","sibling"),r.set("tobj",a.grid).set("tid",a.idd),2==r.tobj.dadmode&&1==r.tobj.dadmodec&&r.tobj.dadmodefix<0&&(r.tobj.obj.rows[1].idd!=r.tid?r.tid=a.previousSibling.idd:this._h2&&r.tid?r.before=!0:r.tid=0);var s=this.getFirstParentOfType(i,"TD");if(s&&r.set("tExtra",s._cellIndex),s&&r.set("sExtra",r.sobj._dndExtra),r.sobj.dpcpy&&r.set("mode","copy"),r.tobj._realfake&&(r.tobj=r.tobj._fake),r.sobj._realfake&&(r.sobj=r.sobj._fake),r.tobj._clearMove(),o&&o.treeNod&&o.treeNod._nonTrivialRow)o.treeNod._nonTrivialRow(this,r.tid,r.dropmode,o);else{if(r.tobj.dragContext=r,!r.tobj.callEvent("onDrag",[r.slist(),r.tid,r.sobj,r.tobj,r.sExtra,r.tExtra]))return r.tobj.dragContext=null;var l=new Array;if("object"==typeof r.sid){for(var d=r.copy(),c=0;c<r.sid.length;c++)d.set("alfa",!c).set("sid",r.sid[c]["tree"==r.source?"id":"idd"]).valid()&&(d.tobj._dragRoutine(d),"treeGrid"==d.target&&"child"==d.dropmode&&d.tobj.openItem(d.tid),l[l.length]=d.nid,d.set("dropmode","sibling").set("tid",d.nid));d.close()}else r.tobj._dragRoutine(r);r.tobj.laterLink&&r.tobj.laterLink(),r.tobj.callEvent("onDrop",[r.slist(),r.tid,l.join(","),r.sobj,r.tobj,r.sExtra,r.tExtra])}r.tobj.dragContext=null,r.close()},dhtmlXGridObject.prototype._dragRoutine=function(t){if(t.sobj==t.tobj&&"grid"==t.source&&"move"==t.mode&&!this._fake){if(t.sobj._dndProblematic)return;var e=t.sobj.rowsAr[t.sid],n=t.sobj.rowsCol._dhx_find(e);if(t.sobj.rowsCol._dhx_removeAt(t.sobj.rowsCol._dhx_find(e)),t.sobj.rowsBuffer._dhx_removeAt(t.sobj.rowsBuffer._dhx_find(e)),t.sobj.rowsBuffer._dhx_insertAt(t.ind(),e),t.tobj._fake){t.tobj._fake.rowsCol._dhx_removeAt(n);var i=t.tobj._fake.rowsAr[t.sid];i.parentNode.removeChild(i)}return t.sobj._insertRowAt(e,t.ind()-(this.pagingOn?(this.currentPage-1)*this.rowsBufferOutSize:0)),t.nid=t.sid,void t.sobj.callEvent("onGridReconstructed",[])}var a;if(this._h2&&void 0!==t.tid&&"sibling"==t.dropmode&&(this._sbmod||t.tid)?t.before?a=t.uid().tobj.addRowBefore(t.nid,t.data(),t.tid,t.img(),t.childs()):t.alfa&&this._sbmod&&this._h2.get[t.tid].childs.length?(this.openItem(t.tid),a=t.uid().tobj.addRowBefore(t.nid,t.data(),this._h2.get[t.tid].childs[0].id,t.img(),t.childs())):a=t.uid().tobj.addRowAfter(t.nid,t.data(),t.tid,t.img(),t.childs()):a=t.uid().tobj.addRow(t.nid,t.data(),t.ind(),t.pid(),t.img(),t.childs()),a._attrs=t.attrs(),"tree"==t.source){this.callEvent("onRowAdded",[t.nid]);var o=t.sobj._globalIdStorageFind(t.sid);if(o.childsCount){for(var r=t.copy().set("tid",t.nid).set("dropmode","grid"==t.target?"sibling":"child"),s=0;s<o.childsCount;s++)t.tobj._dragRoutine(r.set("sid",o.childNodes[s].id)),"move"==t.mode&&s--;r.close()}}else if(t.tobj._copyUserData(t),this.callEvent("onRowAdded",[t.nid]),"treeGrid"==t.source){t.sobj==t.tobj&&(a._xml=t.sobj.rowsAr[t.sid]._xml);var l=t.sobj._h2.get[t.sid];if(l&&l.childs.length){r=t.copy().set("tid",t.nid);"grid"==t.target?r.set("dropmode","sibling"):(r.tobj.kidsXmlFile||r.tobj.openItem(t.tid),r.set("dropmode","child"));var d=l.childs.length;if(!r.tobj.kidsXmlFile)for(s=0;s<d;s++)t.sobj.render_row_tree(null,l.childs[s].id),t.tobj._dragRoutine(r.set("sid",l.childs[s].id)),d!=l.childs.length&&(s--,d=l.childs.length);r.close()}}"move"==t.mode&&(t.sobj["tree"==t.source?"deleteItem":"deleteRow"](t.sid),t.sobj!=t.tobj||t.tobj.rowsAr[t.sid]||(t.tobj.changeRowId(t.nid,t.sid),t.nid=t.sid))},dhtmlXGridObject.prototype.gridToGrid=function(t,e,n){for(var i=new Array,a=0;a<e.hdr.rows[0].cells.length;a++)i[a]=e.cells(t,a).getValue();return i},dhtmlXGridObject.prototype.checkParentLine=function(t,e){return!!(this._h2&&e&&t)&&(t.id==e||this.checkParentLine(t.parent,e))},dhtmlXGridObject.prototype._dragIn=function(t,e,n,i){if(!this.dADTempOff)return 0;var a=this.isTreeGrid(),o=e.parentNode.idd?e.parentNode:e.parentObject;if(this._drag_validate){if(t.parentNode==e.parentNode)return 0;if(a&&this==o.grid&&this.checkParentLine(this._h2.get[t.parentNode.idd],e.parentNode.idd))return 0}if(!this.callEvent("onDragIn",[o.idd||o.id,t.parentNode.idd,o.grid||o.treeNod,t.grid||t.parentNode.grid]))return this._setMove(t,n,i,!0);if(this._setMove(t,n,i),a&&""!=t.parentNode.expand){var r=this;this._autoOpenTimer=window.setTimeout(function(){r._autoOpenItem(null,r),r=null},1e3),this._autoOpenId=t.parentNode.idd}else this._autoOpenTimer&&window.clearTimeout(this._autoOpenTimer);return t},dhtmlXGridObject.prototype._autoOpenItem=function(t,e){e.openItem(e._autoOpenId)},dhtmlXGridObject.prototype._dragOut=function(t){this._clearMove();var e=t.parentNode.parentObject?t.parentObject.id:t.parentNode.idd;this.callEvent("onDragOut",[e]),this._autoOpenTimer&&window.clearTimeout(this._autoOpenTimer)},dhtmlXGridObject.prototype._setMove=function(t,e,n,i){if(t.parentNode.idd){var a=dhx4.absTop(t),o=dhx4.absTop(this.objBox);if(a-o>parseInt(this.objBox.offsetHeight)-50&&(this.objBox.scrollTop=parseInt(this.objBox.scrollTop)+20),a-o+parseInt(this.objBox.scrollTop)<parseInt(this.objBox.scrollTop)+30&&(this.objBox.scrollTop=parseInt(this.objBox.scrollTop)-20),i)return 0;if(2==this.dadmode){var r=n-a+(document.body.scrollTop||document.documentElement.scrollTop)-2-t.offsetHeight/2;Math.abs(r)-t.offsetHeight/6>0?(this.dadmodec=1,this.dadmodefix=r<0?-1:1):this.dadmodec=0}else this.dadmodec=this.dadmode;if(this.dadmodec)this._sdrgc||this._createSdrgc(),this._sdrgc.style.display="block",this._sdrgc.style.top=a-o+parseInt(this.objBox.scrollTop)+(this.dadmodefix>=0?t.offsetHeight:0)+"px";else if(this._llSelD=t,"TR"==t.parentNode.tagName)for(var s=0;s<t.parentNode.childNodes.length;s++){(r=t.parentNode.childNodes[s])._bgCol=r.style.backgroundColor,r.style.backgroundColor="#FFCCCC"}}},dhtmlXGridObject.prototype._clearMove=function(){if(this._sdrgc&&(this._sdrgc.style.display="none"),this._llSelD&&"TR"==this._llSelD.parentNode.tagName)for(var t=this._llSelD.parentNode.childNodes,e=0;e<t.length;e++)t[e].style.backgroundColor=t[e]._bgCol;this._llSelD=null},dhtmlXGridObject.prototype.rowToDragElement=function(t){return this.cells(t,0).getValue()},dhtmlXGridObject.prototype._copyUserData=function(t){if(!t.tobj.UserData[t.nid]||t.tobj!=t.sobj){t.tobj.UserData[t.nid]=new Hashtable;var e=t.sobj.UserData[t.sid],n=t.tobj.UserData[t.nid];e&&(n.keys=n.keys.concat(e.keys),n.values=n.values.concat(e.values))}},dhtmlXGridObject.prototype.moveRow=function(t,e,n,i){switch(e){case"row_sibling":this.moveRowTo(t,n,"move","sibling",this,i);break;case"up":this.moveRowUp(t);break;case"down":this.moveRowDown(t)}},dhtmlXGridObject.prototype._nonTrivialNode=function(t,e,n,i,a){if(t.callEvent&&!a&&!t.callEvent("onDrag",[i.idd,e.id,n?n.id:null,this,t]))return!1;for(var o=i.idd,r=o;t._idpull[r];)r+=(new Date).getMilliseconds().toString();var s=this.isTreeGrid()?this.getItemImage(o):"";if(n){for(c=0;c<e.childsCount&&e.childNodes[c]!=n;c++);0!=c?n=e.childNodes[c-1]:(st="TOP",n="")}var l=t._attachChildNode(e,r,this.gridToTreeElement(t,r,o),"",s,s,s,"","",n);if(this._h2){var d=this._h2.get[o];if(d.childs.length)for(var c=0;c<d.childs.length;c++)this._nonTrivialNode(t,l,0,this.rowsAr[d.childs[c].id],1),this.dpcpy||c--}this.dpcpy||this.deleteRow(o),t.callEvent&&!a&&t.callEvent("onDrop",[r,e.id,n?n.id:null,this,t])},dhtmlXGridObject.prototype.gridToTreeElement=function(t,e,n){return this.cells(n,0).getValue()},dhtmlXGridObject.prototype.treeToGridElement=function(t,e,n){var i=new Array,a=this.cellType._dhx_find("tree");-1==a&&(a=0);for(var o=0;o<this.getColumnCount();o++)i[i.length]=o!=a?t.getUserData(e,this.getColumnId(o))||"":t.getItemText(e);return i},dhtmlXGridObject.prototype.moveRowTo=function(t,e,n,i,a,o){var r=new dragContext((a||this).isTreeGrid()?"treeGrid":"grid",(o||this).isTreeGrid()?"treeGrid":"grid",n,i||"sibling",t,e,a||this,o||this);return r.tobj._dragRoutine(r),r.close(),r.nid},dhtmlXGridObject.prototype.enableMercyDrag=function(t){this.dpcpy=dhx4.s2b(t)},dhtmlXGridObject.prototype.toPDF=function(t,e,n,i,a,o){var r={row:(this.getSelectedRowId()||"").split(this.delim),col:this.getSelectedCellIndex()};if(null===r.row||-1===r.col)r=!1;else if(r.row){for(var s=0;s<r.row.length;s++)if(r.row[s]){var l=this.cells(r.row[s],r.col).cell;l.parentNode.className=l.parentNode.className.replace(" rowselected",""),l.className=l.className.replace(" cellselected",""),r.row[s]=l}}else r=!1;var d="full_color"==(e=e||"color"),c=this;function h(t,e){return(window.getComputedStyle?window.getComputedStyle(t,null)[e]:t.currentStyle?t.currentStyle[e]:null)||""}function u(t){if(!c.rowsBuffer[t])return"";var e=c.render_row(t);if("none"==e.style.display)return"";for(var n="<row"+(c.isTreeGrid()?' level="'+c.getLevel(e.idd)+'"':"")+">",i=0;i<c._cCount;i++)if((!c._srClmn||c._srClmn[i])&&(!c._hrrar[i]||c._fake&&i<c._fake.hdrLabels.length)){var a=c.cells(e.idd,i);if(d){var o=h(a.cell,"color"),r=h(a.cell,"backgroundColor"),s=h(a.cell,"font-weight")||h(a.cell,"fontWeight"),l=h(a.cell,"font-style")||h(a.cell,"fontStyle"),u=h(a.cell,"text-align")||h(a.cell,"textAlign"),m=h(a.cell,"font-family")||h(a.cell,"fontFamily");"transparent"!=r&&"rgba(0, 0, 0, 0)"!=r||(r="rgb(255,255,255)"),n+="<cell bgColor='"+r+"' textColor='"+o+"' bold='"+s+"' italic='"+l+"' align='"+u+"' font='"+m+"'>"}else n+="<cell>";n+="<![CDATA["+(a.getContent?a.getContent():a.getTitle())+"]]></cell>"}return n+"</row>"}c._asCDATA=!0,this.target=void 0===o?' target="_blank"':o,eXcell_ch.prototype.getContent=function(){return this.getValue()},eXcell_ra.prototype.getContent=function(){return this.getValue()};var m=document.createElement("div");m.style.display="none",document.body.appendChild(m);var f="form_"+c.uid();if(m.innerHTML='<form id="'+f+'" method="post" action="'+t+'" accept-charset="utf-8"  enctype="application/x-www-form-urlencoded"'+this.target+'><input type="hidden" name="grid_xml" id="grid_xml"/> </form>',document.getElementById(f).firstChild.value=encodeURIComponent(function(t){for(var e=[],a=1;a<c.hdr.rows.length;a++){e[a]=[];for(var o=0;o<c._cCount;o++){var r=c.hdr.rows[a].childNodes[o];e[a][o]||(e[a][o]=[0,0]),r&&(e[a][r._cellIndexS]=[r.colSpan,r.rowSpan])}}var s="<rows profile='"+t+"'";for(n&&(s+=" header='"+n+"'"),i&&(s+=" footer='"+i+"'"),s+="><head>"+c._serialiseExportConfig(e).replace(/^<head/,"<columns").replace(/head>$/,"columns>"),a=2;a<c.hdr.rows.length;a++){var l=0,d=c.hdr.rows[a],h="";for(o=0;o<c._cCount;o++)if(c._srClmn&&!c._srClmn[o]||c._hrrar[o]&&(!c._fake||o>=c._fake.hdrLabels.length))l++;else{var u=e[a][o],m=u[0]&&u[0]>1?' colspan="'+u[0]+'" ':"";u[1]&&u[1]>1&&(m+=' rowspan="'+u[1]+'" ',l=-1);var f="",p=d;c._fake&&o<c._fake._cCount&&(p=c._fake.hdr.rows[a]);for(var _=0;_<p.cells.length;_++)if(p.cells[_]._cellIndexS==o){f=(f=p.cells[_].getElementsByTagName("SELECT").length?"":_isIE?p.cells[_].innerText:p.cells[_].textContent).replace(/[ \n\r\t\xA0]+/," ");break}f&&" "!=f||l++,h+="<column"+m+"><![CDATA["+f+"]]></column>"}l!=c._cCount&&(s+="\n<columns>"+h+"</columns>")}return s+="</head>\n",s+=function(){var t=["<foot>"];if(!c.ftr)return"";for(var e=1;e<c.ftr.rows.length;e++){t.push("<columns>");for(var n=c.ftr.rows[e],i=0;i<c._cCount;i++)if((!c._srClmn||c._srClmn[i])&&(!c._hrrar[i]||c._fake&&!(i>=c._fake.hdrLabels.length))){for(var a=0;a<n.cells.length;a++){var o="",r="";if(n.cells[a]._cellIndexS==i){o=(o=_isIE?n.cells[a].innerText:n.cells[a].textContent).replace(/[ \n\r\t\xA0]+/," "),n.cells[a].colSpan&&1!=n.cells[a].colSpan&&(r=" colspan='"+n.cells[a].colSpan+"' "),n.cells[a].rowSpan&&1!=n.cells[a].rowSpan&&(r=" rowspan='"+n.cells[a].rowSpan+"' ");break}}t.push("<column"+r+"><![CDATA["+o+"]]></column>")}t.push("</columns>")}return t.push("</foot>"),t.join("\n")}()}(e).replace("–","-")+function(){var t=[];if(a)for(var e=0;e<a.length;e++)t.push(u(c.getRowIndex(a[e])));else for(e=0;e<c.getRowsNum();e++)t.push(u(e));return t.join("\n")}()+"</rows>"),document.getElementById(f).submit(),m.parentNode.removeChild(m),c=null,r&&r.row.length)for(s=0;s<r.row.length;s++)r.row[s].parentNode.className+=" rowselected",1==r.row.length&&(r.row[s].className+=" cellselected");r=null},dhtmlXGridObject.prototype._serialiseExportConfig=function(t){for(var e,n="<head>",i=0;i<this.hdr.rows[0].cells.length;i++)if((!this._srClmn||this._srClmn[i])&&(!this._hrrar[i]||this._fake&&!(i>=this._fake.hdrLabels.length))){var a=this.fldSort[i];"cus"==a&&(a=(a=this._customSorts[i].toString()).replace(/function[\ ]*/,"").replace(/\([^\f]*/,""));var o=t[1][i];n+="<column "+((o[1]&&o[1]>1?' rowspan="'+o[1]+'" ':"")+(o[0]&&o[0]>1?' colspan="'+o[0]+'" ':""))+" width='"+this.getColWidth(i)+"' align='"+this.cellAlign[i]+"' type='"+this.cellType[i]+"' hidden='"+(this.isColumnHidden&&this.isColumnHidden(i)?"true":"false")+"' sort='"+(a||"na")+"' color='"+(this.columnColor[i]||"")+"'"+(this.columnIds[i]?" id='"+this.columnIds[i]+"'":"")+">",this._asCDATA?n+="<![CDATA["+this.getColumnLabel(i)+"]]>":n+=this.getColumnLabel(i);var r=this.combos[i]?this.getCombo(i):null;if(r)for(var s=0;s<r.keys.length;s++)n+="<option value='"+("string"!=typeof(e=r.keys[s])?e:e=(e=(e=(e=(e=e.replace(/&/g,"&amp;")).replace(/"/g,"&quot;")).replace(/'/g,"&apos;")).replace(/</g,"&lt;")).replace(/>/g,"&gt;"))+"'><![CDATA["+r.values[s]+"]]></option>";n+="</column>"}return n+"</head>"},window.eXcell_sub_row_grid&&(window.eXcell_sub_row_grid.prototype.getContent=function(){return""}),dhtmlXGridObject.prototype.toExcel=function(t,e,n,i,a){if(!document.getElementById("ifr")){var o=document.createElement("iframe");o.style.display="none",o.setAttribute("name","dhx_export_iframe"),o.setAttribute("src",""),o.setAttribute("id","dhx_export_iframe"),document.body.appendChild(o)}this.toPDF(t,e,n,i,a,' target="dhx_export_iframe"')},dhtmlXGridObject.prototype.filterBy=function(t,e,n){if(this.isTreeGrid())return this.filterTreeBy(t,e,n);if(this._f_rowsBuffer?n||(this.rowsBuffer=dhtmlxArray([].concat(this._f_rowsBuffer)),this._fake&&(this._fake.rowsBuffer=this.rowsBuffer)):this._f_rowsBuffer=[].concat(this.rowsBuffer),this.rowsBuffer.length){if(this.dma(!0),"object"==typeof t)for(var i=0;i<e.length;i++)this._filterA(t[i],e[i]);else this._filterA(t,e);this.dma(!1),this.pagingOn&&this.rowsBuffer.length/this.rowsBufferOutSize<this.currentPage-1&&this.changePage(0),this._reset_view(),this.callEvent("onGridReconstructed",[])}},dhtmlXGridObject.prototype._filterA=function(t,e){if(""!=e){var n=!0;if("function"==typeof e?n=!1:e=(e||"").toString().toLowerCase(),this.rowsBuffer.length)for(var i=this.rowsBuffer.length-1;i>=0;i--)(n?-1!=this._get_cell_value(this.rowsBuffer[i],t).toString().toLowerCase().indexOf(e):e.call(this,this._get_cell_value(this.rowsBuffer[i],t),this.rowsBuffer[i].idd))||this.rowsBuffer.splice(i,1)}},dhtmlXGridObject.prototype.getFilterElement=function(t){if(this.filters){for(var e=0;e<this.filters.length;e++)if(this.filters[e][1]==t)return this.filters[e][0].combo||this.filters[e][0];return null}},dhtmlXGridObject.prototype.collectValues=function(t){var e=this.dhxevs.data.oncollectvalues;if(e){var n=!0;for(var i in e){var a=e[i].call(this,t);!0!==a&&(n=a||n)}if(!0!==n)return n}if(this.isTreeGrid())return this.collectTreeValues(t);this.dma(!0),this._build_m_order(),t=this._m_order?this._m_order[t]:t;for(var o={},r=[],s=this._f_rowsBuffer||this.rowsBuffer,l=0;l<s.length;l++){var d=this._get_cell_value(s[l],t);!d||s[l]._childIndexes&&s[l]._childIndexes[t]==s[l]._childIndexes[t-1]||(o[d]=!0)}this.dma(!1);var c=this.combos[t]||(this._col_combos&&this._col_combos[t]?this._col_combos[t]:!(!this._sub_trees||!this._sub_trees[t])&&this._sub_trees[t][0]);for(var h in o)if(!0===o[h]){if(c)if(c.get&&c.get(h))h=c.get(h);else if(c.getOption&&c.getOption(h))h=c.getOption(h).text;else if(c.getItemText){var u=c.getItemText(h);(this._sub_trees[t][1]=this._sub_trees[t][1]||{})[u]=h,h=u}r.push(h)}return r.sort()},dhtmlXGridObject.prototype._build_m_order=function(){if(this._c_order){this._m_order=[];for(var t=0;t<this._c_order.length;t++)this._m_order[this._c_order[t]]=t}},dhtmlXGridObject.prototype.filterByAll=function(){var t=[],e=[];this._build_m_order();for(var n=0;n<this.filters.length;n++){var i=this._m_order?this._m_order[this.filters[n][1]]:this.filters[n][1];if(!(i>=this._cCount)){e.push(i);var a,o=this.filters[n][0].old_value=this.filters[n][0].value;this.filters[n][0]._filter&&(o=this.filters[n][0]._filter()),"function"!=typeof o&&(a=this.combos[i]||(this._col_combos&&this._col_combos[i]?this._col_combos[i]:!(!this._sub_trees||!this._sub_trees[i])&&this._sub_trees[i][1]))&&(o=a.values?-1==(i=a.values._dhx_find(o))?o:a.keys[i]:a.getOptionByLabel?a.getOptionByLabel(o)?a.getOptionByLabel(o).value:o:a[o]),t.push(o)}}this.callEvent("onFilterStart",[e,t])&&(this.filterBy(e,t),this._cssEven&&this._fixAlterCss(),this.callEvent("onFilterEnd",[this.filters]),this._f_rowsBuffer&&this.rowsBuffer.length==this._f_rowsBuffer.length&&(this._f_rowsBuffer=null))},dhtmlXGridObject.prototype.makeFilter=function(t,e,n){if(this.filters||(this.filters=[]),"object"!=typeof t&&(t=document.getElementById(t)),t){var i=this;if(t.style.width||(t.style.width="90%"),"SELECT"==t.tagName)this.filters.push([t,e]),this._loadSelectOptins(t,e),t.onchange=function(){i.filterByAll()},_isIE&&(t.style.marginTop="1px"),this.attachEvent("onEditCell",function(n,i,a){return this._build_m_order(),2==n&&this.filters&&(this._m_order?a==this._m_order[e]:a==e)&&this._loadSelectOptins(t,e),!0});else if("INPUT"==t.tagName)this.filters.push([t,e]),t.old_value=t.value="",t.onkeydown=function(){this._timer&&window.clearTimeout(this._timer),this._timer=window.setTimeout(function(){t.value!=t.old_value&&(i.filterByAll(),t.old_value=t.value)},500)};else if("DIV"==t.tagName){this.filters.push([t,e]),t.style.padding="0px",t.style.margin="0px",window.dhx_globalImgPath||(window.dhx_globalImgPath=this.imgURL);var a=new dhtmlXCombo(t,"_filter","90%");a.filterSelfA=a.filterSelf,a.filterSelf=function(){0==this.getSelectedIndex()&&this.setComboText(""),this.filterSelfA.apply(this,arguments),this.optionsArr[0].hide(!1)},a.enableFilteringMode(!0),t.combo=a,t.value="",this._loadComboOptins(t,e),a.attachEvent("onChange",function(){t.value=a.getSelectedValue(),null===t.value&&(t.value=""),i.filterByAll()})}t.parentNode&&(t.parentNode.className+=" filter"),this._filters_ready()}},dhtmlXGridObject.prototype.findCell=function(t,e,n,i){!0===(i=i||function(t,e){return-1!=e.toString().toLowerCase().indexOf(t)})&&(i=function(t,e){return e.toString().toLowerCase()==t});var a=new Array;if(t=t.toString().toLowerCase(),"number"!=typeof n&&(n=n?1:0),!this.rowsBuffer.length)return a;for(var o=e||0;o<this._cCount;o++){if(this._h2)this._h2.forEachChild(0,function(e){if(n&&a.length==n)return a;i(t,this._get_cell_value(e.buff,o))&&a.push([e.id,o])},this);else for(var r=0;r<this.rowsBuffer.length;r++)if(i(t,this._get_cell_value(this.rowsBuffer[r],o))&&(a.push([this.rowsBuffer[r].idd,o]),n&&a.length==n))return a;if(void 0!==e)return a}return a},dhtmlXGridObject.prototype.makeSearch=function(t,e,n){if("object"!=typeof t&&(t=document.getElementById(t)),t){var i=this;"INPUT"==t.tagName&&(t.onkeypress=function(){this._timer&&window.clearTimeout(this._timer),this._timer=window.setTimeout(function(){if(""!=t.value){var a=i.findCell(t.value,e,!0,n);a.length&&(i._h2&&i.openItem(a[0][0]),i.selectCell(i.getRowIndex(a[0][0]),e||0))}},500)}),t.parentNode&&(t.parentNode.className+=" filter")}},dhtmlXGridObject.prototype._loadSelectOptins=function(t,e){var n=this.collectValues(e),i=t.value;t.innerHTML="",t.options[0]=new Option("","");for(var a=this._filter_tr?this._filter_tr[e]:null,o=0;o<n.length;o++)t.options[t.options.length]=new Option(a?a(n[o]):n[o],n[o]);t.value=i},dhtmlXGridObject.prototype.setSelectFilterLabel=function(t,e){this._filter_tr||(this._filter_tr=[]),this._filter_tr[t]=e},dhtmlXGridObject.prototype._loadComboOptins=function(t,e){if(t.combo){var n=this.collectValues(e);t.combo.clearAll();for(var i=[["",""]],a=0;a<n.length;a++)i.push([n[a],n[a]]);t.combo.addOption(i)}},dhtmlXGridObject.prototype.refreshFilters=function(){if(this.filters)for(var t=0;t<this.filters.length;t++)switch(this.filters[t][0].tagName.toLowerCase()){case"input":break;case"select":this._loadSelectOptins.apply(this,this.filters[t]);break;case"div":this._loadComboOptins.apply(this,this.filters[t])}},dhtmlXGridObject.prototype._filters_ready=function(t,e){this.attachEvent("onXLE",this.refreshFilters),this.attachEvent("onSyncApply",this.refreshFilters),this.attachEvent("onRowCreated",function(t,e){if(this._f_rowsBuffer)for(var n=0;n<this._f_rowsBuffer.length;n++)if(this._f_rowsBuffer[n].idd==t)return this._f_rowsBuffer[n]=e}),this.attachEvent("onClearAll",function(){this._f_rowsBuffer=null,this.hdr.rows.length||(this.filters=[])}),this.attachEvent("onSetSizes",this._filters_resize_combo),this.attachEvent("onResize",this._filters_resize_combo),this._filters_ready=function(){}},dhtmlXGridObject.prototype._filters_resize_combo=function(){if(this.filters){for(var t=0;t<this.filters.length;t++)null!=this.filters[t][0].combo&&this.filters[t][0].combo.setSize(Math.round(90*this.filters[t][0].offsetWidth/100));return!0}},dhtmlXGridObject.prototype._in_header_text_filter=function(t,e){t.innerHTML="<input type='text'>",t.onclick=t.onmousedown=function(t){return(t||event).cancelBubble=!0,!0},t.onselectstart=function(){return event.cancelBubble=!0},this.makeFilter(t.firstChild,e)},dhtmlXGridObject.prototype._in_header_text_filter_inc=function(t,e){t.innerHTML="<input type='text'>",t.onclick=t.onmousedown=function(t){return(t||event).cancelBubble=!0,!0},t.onselectstart=function(){return event.cancelBubble=!0},this.makeFilter(t.firstChild,e),t.firstChild._filter=function(){return""==t.firstChild.value?"":function(e){return 0==e.toString().toLowerCase().indexOf(t.firstChild.value.toLowerCase())}},this._filters_ready()},dhtmlXGridObject.prototype._in_header_select_filter=function(t,e){t.innerHTML="<select></select>",t.onclick=function(t){return(t||event).cancelBubble=!0,!1},this.makeFilter(t.firstChild,e)},dhtmlXGridObject.prototype._in_header_select_filter_strict=function(t,e){t.innerHTML="<select style='width:90%; font-size:8pt; font-family:Tahoma;'></select>",t.onclick=function(t){return(t||event).cancelBubble=!0,!1},this.makeFilter(t.firstChild,e);var n=this.combos;t.firstChild._filter=function(){var i=t.firstChild.value;return i?(n[e]&&(i=n[e].keys[n[e].values._dhx_find(i)]),i=i.toLowerCase(),function(t){return t.toString().toLowerCase()==i}):""},this._filters_ready()},dhtmlXGridObject.prototype._in_header_combo_filter=function(t,e){t.innerHTML="<div style='width:100%; padding-left:2px; overflow:hidden; ' class='combo'></div>",t.onselectstart=function(){return event.cancelBubble=!0},t.onclick=t.onmousedown=function(t){return(t||event).cancelBubble=!0,!0},this.makeFilter(t.firstChild,e)},dhtmlXGridObject.prototype._search_common=function(t,e){t.innerHTML="<input type='text' style='width:90%; '>",t.onclick=t.onmousedown=function(t){return(t||event).cancelBubble=!0,!0},t.onselectstart=function(){return event.cancelBubble=!0}},dhtmlXGridObject.prototype._in_header_text_search=function(t,e,n){this._search_common(t,e),this.makeSearch(t.firstChild,e)},dhtmlXGridObject.prototype._in_header_text_search_strict=function(t,e){this._search_common(t,e),this.makeSearch(t.firstChild,e,!0)},dhtmlXGridObject.prototype._in_header_numeric_filter=function(t,e){this._in_header_text_filter.call(this,t,e),t.firstChild._filter=function(){var t,e=this.value,n="==",i=parseFloat(e.replace("=","")),a=null;return e?-1!=e.indexOf("..")?(e=e.split(".."),i=parseFloat(e[0]),a=parseFloat(e[1]),function(t){return t>=i&&t<=a}):((t=e.match(/>=|<=|>|</))&&(n=t[0],i=parseFloat(e.replace(n,""))),Function("v"," if (v "+n+" "+i+" ) return true; return false;")):""}},dhtmlXGridObject.prototype._in_header_master_checkbox=function(t,e,n){t.innerHTML=n[0]+"<input type='checkbox' />"+n[1];var i=this;t.getElementsByTagName("input")[0].onclick=function(t){i._build_m_order();var n=i._m_order?i._m_order[e]:e,a=this.checked?1:0;i.forEachRowA(function(t){var e=this.cells(t,n);e.isCheckbox()&&!e.isDisabled()&&(e.setValue(a),e.cell.wasChanged=!0),this.callEvent("onEditCell",[1,t,n,a]),this.callEvent("onCheckbox",[t,n,a]),this.callEvent("onCheck",[t,n,a])}),(t||event).cancelBubble=!0}},dhtmlXGridObject.prototype._in_header_stat_total=function(t,e,n){this._stat_in_header(t,function(){var t=0;this._build_m_order();for(var n=this._m_order?this._m_order[e]:e,i=0;i<this.rowsBuffer.length;i++){var a=parseFloat(this._get_cell_value(this.rowsBuffer[i],n));t+=isNaN(a)?0:a}return this._maskArr[n]?this._aplNF(t,n):Math.round(100*t)/100},e,n,n)},dhtmlXGridObject.prototype._in_header_stat_multi_total=function(t,e,n){var i=n[1].split(":");n[1]="";for(var a=0;a<i.length;a++)i[a]=parseInt(i[a]);for(var o=[],r=0;r<i.length;r++)o[i[r]]=!0;this._stat_in_header(t,function(){for(var t=0,n=0;n<this.rowsBuffer.length;n++){for(var a=1,o=0;o<i.length;o++)a*=parseFloat(this._get_cell_value(this.rowsBuffer[n],i[o]));t+=isNaN(a)?0:a}return this._maskArr[e]?this._aplNF(t,e):Math.round(100*t)/100},o,n,n)},dhtmlXGridObject.prototype._in_header_stat_max=function(t,e,n){this._stat_in_header(t,function(){this._build_m_order();var t=this._m_order?this._m_order[e]:e,n=-999999999;if(0==this.getRowsNum())return"&nbsp;";for(var i=0;i<this.rowsBuffer.length;i++)n=Math.max(n,parseFloat(this._get_cell_value(this.rowsBuffer[i],t)));return this._maskArr[e]?this._aplNF(n,e):n},e,n)},dhtmlXGridObject.prototype._in_header_stat_min=function(t,e,n){this._stat_in_header(t,function(){this._build_m_order();var t=this._m_order?this._m_order[e]:e,n=999999999;if(0==this.getRowsNum())return"&nbsp;";for(var i=0;i<this.rowsBuffer.length;i++)n=Math.min(n,parseFloat(this._get_cell_value(this.rowsBuffer[i],t)));return this._maskArr[e]?this._aplNF(n,e):n},e,n)},dhtmlXGridObject.prototype._in_header_stat_average=function(t,e,n){this._stat_in_header(t,function(){this._build_m_order();var t=this._m_order?this._m_order[e]:e,n=0,i=0;if(0==this.getRowsNum())return"&nbsp;";for(var a=0;a<this.rowsBuffer.length;a++){var o=parseFloat(this._get_cell_value(this.rowsBuffer[a],t));isNaN(o)||(n+=o,i++)}return this._maskArr[e]?this._aplNF(n/i,e):Math.round(n/i*100)/100},e,n)},dhtmlXGridObject.prototype._in_header_stat_count=function(t,e,n){this._stat_in_header(t,function(){return this.getRowsNum()},e,n)},dhtmlXGridObject.prototype._stat_in_header=function(t,e,n,i){var a=function(){this.dma(!0),t.innerHTML=(i[0]?i[0]:"")+e.call(this)+(i[1]?i[1]:""),this.dma(!1),this.callEvent("onStatReady",[])};this._stat_events||(this._stat_events=[],this.attachEvent("onClearAll",function(){if(!this.hdr.rows[1]){for(var t=0;t<this._stat_events.length;t++)for(var e=0;e<4;e++)this.detachEvent(this._stat_events[t][e]);this._stat_events=[]}})),this._stat_events.push([this.attachEvent("onGridReconstructed",a),this.attachEvent("onXLE",a),this.attachEvent("onFilterEnd",a),this.attachEvent("onEditCell",function(t,e,i){return 2==t&&(i==n||n&&n[i])&&a.call(this),!0})]),t.innerHTML=""},dhtmlXGridObject.prototype.loadCSVFile=function(t,e){this.load(t,e,"csv")},dhtmlXGridObject.prototype.enableCSVAutoID=function(t){this._csvAID=dhx4.s2b(t)},dhtmlXGridObject.prototype.enableCSVHeader=function(t){this._csvHdr=dhx4.s2b(t)},dhtmlXGridObject.prototype.setCSVDelimiter=function(t){this.csv.cell=t},dhtmlXGridObject.prototype._csvAID=!0,dhtmlXGridObject.prototype.loadCSVString=function(t){this.parse(t,"csv")},dhtmlXGridObject.prototype.serializeToCSV=function(t){this.editStop(),this._mathSerialization?this._agetm="getMathValue":this._strictText||t?this._agetm="getTitle":this._agetm="getValue";var e=[];if(this._csvHdr)for(var n=1;n<this.hdr.rows.length;n++){for(var i=[],a=0;a<this._cCount;a++)this._srClmn&&!this._srClmn[a]||i.push(this.getColumnLabel(a,n-1));e.push(this.csvParser.str(i,this.csv.cell,this.csv.row))}a=0;for(var o=this.rowsBuffer.length;a<o;a++){var r=this._serializeRowToCVS(null,a);""!=r&&e.push(r)}return this.csvParser.block(e,this.csv.row)},dhtmlXGridObject.prototype._serializeRowToCVS=function(t,e,n,i){var a=new Array;t||(t=this.render_row(e),this._fake&&!this._fake.rowsAr[t.idd]&&this._fake.render_row(e)),this._csvAID||(a[a.length]=t.idd),n=n||0,i=i||this._cCount;for(var o=!1,r=n;t.childNodes[n]._cellIndex>r&&n;)n--;for(var s=n;r<i&&t.childNodes[s];s++){var l=t.childNodes[s]._cellIndex;if(this._srClmn&&!this._srClmn[l]||this._serialize_visible&&this._hrrar[l])r++;else{for(var d=t.childNodes[s],c=this.cells(t.idd,l);r!=l&&(r++,a.push(""),!(r>=i)););if(r>=i)break;if(r++,c.cell?zxVal=c[this._agetm]():zxVal="",this._chAttr&&c.wasChanged()&&(o=!0),a[a.length]=null===zxVal?"":zxVal,this._ecspn&&d.colSpan&&d.colSpan>1){d=d.colSpan-1;for(var h=0;h<d;h++)a[a.length]="",r++}}}return this._onlChAttr&&!o?"":this.csvParser.str(a,this.csv.cell,this.csv.row)},dhtmlXGridObject.prototype.toClipBoard=function(t){window.clipboardData?window.clipboardData.setData("Text",t):(new Clipboard).copy(t)},dhtmlXGridObject.prototype.fromClipBoard=function(){return window.clipboardData?window.clipboardData.getData("Text"):(new Clipboard).paste()},dhtmlXGridObject.prototype.cellToClipboard=function(t,e){if(!t||!e&&0!==e){if(!this.selectedRows[0])return;t=this.selectedRows[0].idd,e=this.cell._cellIndex}var n=this.cells(t,e);this.toClipBoard(((n.getLabel?n.getLabel():n.getValue())||"").toString())},dhtmlXGridObject.prototype.updateCellFromClipboard=function(t,e){if(!t||!e){if(!this.selectedRows[0])return;t=this.selectedRows[0].idd,e=this.cell._cellIndex}var n=this.cells(t,e);n[n.setImage?"setLabel":"setValue"](this.fromClipBoard())},dhtmlXGridObject.prototype.rowToClipboard=function(t){var e="";if(this._mathSerialization?this._agetm="getMathValue":this._strictText?this._agetm="getTitle":this._agetm="getValue",this._serialize_visible=!this._fake,t)e=this._serializeRowToCVS(this.getRowById(t));else for(var n=[],i=0;i<this.selectedRows.length;i++)n[n.length]=this._serializeRowToCVS(this.selectedRows[i]),e=this.csvParser.block(n,this.csv.row);this._serialize_visible=!1,this.toClipBoard(e)},dhtmlXGridObject.prototype.updateRowFromClipboard=function(t){var e=this.fromClipBoard();if(e){if(t)var n=this.getRowById(t);else n=this.selectedRows[0];if(n){e=this.csvParser.unblock(e,this.csv.cell,this.csv.row)[0],this._csvAID||e.splice(0,1);for(var i=0;i<e.length;i++){var a=this.cells3(n,i);a[a.setImage?"setLabel":"setValue"](e[i])}}}},dhtmlXGridObject.prototype.csvParser={block:function(t,e){return t.join(e)},unblock:function(t,e,n){for(var i=(t||"").split(n),a=0;a<i.length;a++)i[a]=(i[a]||"").split(e);var o=i.length-1;return 1==i[o].length&&""==i[o][0]&&i.splice(o,1),i},str:function(t,e,n){return t.join(e)}},dhtmlXGridObject.prototype.csvExtParser={_quote:RegExp('"',"g"),_quote_esc:RegExp('""',"g"),block:function(t,e){return t.join(e)},unblock:function(t,e,n){var i=[[]],a=0;if(!t)return i;for(var o=/^[ ]*"/,r=/"[ ]*$/,s=new RegExp(".*"+n+".*$"),l=t.split(e),d=0;d<l.length;d++)if(l[d].match(o)){for(var c=l[d].replace(o,"");!l[d].match(r);)c+=l[++d];i[a].push(c.replace(r,"").replace(this._quote_esc,'"'))}else if(l[d].match(s)){var h=l[d].indexOf(n);i[a].push(l[d].substr(0,h)),i[++a]=[],l[d]=l[d].substr(h+1),d--}else(l[d]||d!=l.length-1)&&i[a].push(l[d]);var u=i.length-1;return u>0&&!i[u].length&&i.splice(u,1),i},str:function(t,e,n){for(var i=0;i<t.length;i++)t[i]='"'+t[i].replace(this._quote,'""')+'"';return t.join(e)}},dhtmlXGridObject.prototype.addRowFromClipboard=function(){var t=this.fromClipBoard();if(t)for(var e=this.csvParser.unblock(t,this.csv.cell,this.csv.row),n=0;n<e.length;n++)if(e[n]){if(!(t=e[n]).length)continue;this._csvAID?this.addRow(this.getRowsNum()+2,t):(this.rowsAr[t[0]]&&(t[0]=this.uid()),this.addRow(t[0],t.slice(1)))}},dhtmlXGridObject.prototype.gridToClipboard=function(){this.toClipBoard(this.serializeToCSV())},dhtmlXGridObject.prototype.gridFromClipboard=function(){var t=this.fromClipBoard();t&&this.loadCSVString(t)},dhtmlXGridObject.prototype.getXLS=function(t){if(!this.xslform){this.xslform=document.createElement("FORM"),this.xslform.action=(t||"")+"xls.php",this.xslform.method="post",this.xslform.target=_isIE?"_blank":"",document.body.appendChild(this.xslform);var e=document.createElement("INPUT");e.type="hidden",e.name="csv",this.xslform.appendChild(e);var n=document.createElement("INPUT");n.type="hidden",n.name="csv_header",this.xslform.appendChild(n)}var i=this.serializeToCSV();this.xslform.childNodes[0].value=i;for(var a=[],o=this._cCount,r=0;r<o;r++)a.push(this.getHeaderCol(r));a=a.join(","),this.xslform.childNodes[1].value=a,this.xslform.submit()},dhtmlXGridObject.prototype.printView=function(t,e){var n="<style>TD { font-family:Arial; text-align:center; padding-left:2px;padding-right:2px; } \n td.filter input, td.filter select { display:none; }\t\n  </style>",i=null;if(this._fake){i=[].concat(this._hrrar);for(var a=0;a<this._fake._cCount;a++)this._hrrar[a]=null}var o=document.location.port,r=document.location.hostname;n+="<base  href='"+document.location.protocol+"//"+r+(o?":"+o:"")+document.location.pathname+"'></base>",this.parentGrid||(n+=t||""),n+='<table width="100%" border="2px" cellpadding="0" cellspacing="0">';var s=Math.max(this.rowsBuffer.length,this.rowsCol.length),l=this._cCount,d=this._printWidth();n+='<tr class="header_row_1">';for(a=0;a<l;a++)if(!this._hrrar||!this._hrrar[a]){for(var c=this.hdr.rows[1].cells[this.hdr.rows[1]._childIndexes?this.hdr.rows[1]._childIndexes[parseInt(a)]:a],h=c.colSpan||1,u=c.rowSpan||1,m=1;m<h;m++)d[a]+=d[m];n+='<td rowspan="'+u+'" width="'+d[a]+'%" style="background-color:lightgrey;" colspan="'+h+'">'+this.getHeaderCol(a)+"</td>",a+=h-1}n+="</tr>";for(a=2;a<this.hdr.rows.length;a++)if(_isIE){n+="<tr style='background-color:lightgrey' class='header_row_"+a+"'>";var f=this.hdr.rows[a].childNodes;for(m=0;m<f.length;m++)this._hrrar&&this._hrrar[f[m]._cellIndex]||(n+=f[m].outerHTML);n+="</tr>"}else n+="<tr class='header_row_"+a+"' style='background-color:lightgrey'>"+(this._fake?this._fake.hdr.rows[a].innerHTML:"")+this.hdr.rows[a].innerHTML+"</tr>";for(a=0;a<s;a++)if(n+="<tr>",this.rowsCol[a]&&this.rowsCol[a]._cntr)n+=this.rowsCol[a].innerHTML.replace(/<img[^>]*>/gi,"")+"</tr>";else if(!this.rowsCol[a]||"none"!=this.rowsCol[a].style.display){var p;if(this.rowsCol[a])p=this.rowsCol[a].idd;else{if(!this.rowsBuffer[a])continue;p=this.rowsBuffer[a].idd}for(m=0;m<l;m++)if(!this._hrrar||!this._hrrar[m]){if(this.rowsAr[p]&&"TR"==this.rowsAr[p].tagName){var _=this.cells(p,m);if(_._setState)var A="";else if(_.getContent)A=_.getContent();else if(_.getImage||_.combo)A=_.cell.innerHTML;else A=_.getValue()}else A=this._get_cell_value(this.rowsBuffer[a],m);var b=this.columnColor[m]?"background-color:"+this.columnColor[m]+";":"",x=this.cellAlign[m]?"text-align:"+this.cellAlign[m]+";":"",g=_.getAttribute("colspan");n+='<td style="'+b+x+'" '+(g?'colSpan="'+g+'"':"")+">"+(""===A?"&nbsp;":A)+"</td>",g&&(m+=g-1)}if(n+="</tr>",this.rowsCol[a]&&this.rowsCol[a]._expanded){var v=this.cells4(this.rowsCol[a]._expanded.ctrl);v.getSubGrid?n+='<tr><td colspan="'+l+'">'+v.getSubGrid().printView()+"</td></tr>":n+='<tr><td colspan="'+l+'">'+this.rowsCol[a]._expanded.innerHTML+"</td></tr>"}}if(this.ftr)for(a=1;a<this.ftr.childNodes[0].rows.length;a++)n+="<tr style='background-color:lightgrey'>"+(this._fake?this._fake.ftr.childNodes[0].rows[a].innerHTML:"")+this.ftr.childNodes[0].rows[a].innerHTML+"</tr>";if(n+="</table>",this.parentGrid)return n;n+=e||"";var C=window.open("","_blank");C.document.write(n),C.document.write("<script>window.onerror=function(){return true;}<\/script>"),C.document.close(),this._fake&&(this._hrrar=i)},dhtmlXGridObject.prototype._printWidth=function(){for(var t=[],e=0,n=0;n<this._cCount;n++){var i=this.getColWidth(n);t.push(i),e+=i}var a=[],o=0;for(n=0;n<t.length;n++){var r=Math.floor(t[n]/e*100);o+=r,a.push(r)}return a[a.length-1]+=100-o,a},dhtmlXGridObject.prototype.enableBlockSelection=function(t){if(void 0===this._bs_mode){var e=this;this.obj.onmousedown=function(t){return e._bs_mode&&e._OnSelectionStart(t||event,this),!0},this._CSVRowDelimiter=this.csv.row,this.attachEvent("onResize",function(){return e._HideSelection(),!0}),this.attachEvent("onGridReconstructed",function(){return e._HideSelection(),!0}),this.attachEvent("onFilterEnd",this._HideSelection)}if(!1===t)return this._bs_mode=!1,this._HideSelection();if(this._bs_mode=!0,!window.dhx4.isIPad){var n=this._clip_area=document.createElement("textarea");n.className="dhx_tab_ignore",n.style.cssText="position:absolute; width:1px; height:1px; overflow:hidden; color:transparent; background-color:transparent; bottom:1px; right:1px; border:none;",n.onkeydown=function(t){86==(t=t||event).keyCode&&(t.ctrlKey||t.metaKey)&&e.pasteBlockFromClipboard()},document.body.insertBefore(this._clip_area,document.body.firstChild),dhtmlxEvent(this.entBox,"click",function(){!e.editor&&e._clip_area&&e._clip_area.select()})}},dhtmlXGridObject.prototype.forceLabelSelection=function(t){this._strictText=dhx4.s2b(t)},dhtmlXGridObject.prototype.selectBlock=function(t,e,n,i){e=this.getRowIndex(e),i=this.getRowIndex(i),this._CreateSelection(e,t),this._selectionArea=this._RedrawSelectionPos(this.cells2(e,t).cell,this.cells2(i,n).cell),this._ShowSelection()},dhtmlXGridObject.prototype._OnSelectionStart=function(t,e){var n=this;if(2!=t.button){var i=t.srcElement||t.target;if(this.editor){if(i.tagName&&("INPUT"==i.tagName||"TEXTAREA"==i.tagName))return;this.editStop()}n.setActive(!0);var a=this.getPosition(this.obj),o=t.clientX-a[0]+(document.body.scrollLeft||(document.documentElement?document.documentElement.scrollLeft:0)),r=t.clientY-a[1]+(document.body.scrollTop||(document.documentElement?document.documentElement.scrollTop:0));if(this._CreateSelection(o-4,r-4),i==this._selectionObj)this._HideSelection(),this._startSelectionCell=null;else{for(;i&&(!i.tagName||"td"!=i.tagName.toLowerCase());)i=i.parentNode;this._startSelectionCell=i}if(this._startSelectionCell&&!this.callEvent("onBeforeBlockSelected",[this._startSelectionCell.parentNode.idd,this._startSelectionCell._cellIndex]))return this._startSelectionCell=null;this.obj.onmousedown=null,this.obj[_isIE?"onmouseleave":"onmouseout"]=function(t){n._blsTimer&&window.clearTimeout(n._blsTimer)},this.obj.onmmold=this.obj.onmousemove,this._init_pos=[o,r],this._selectionObj.onmousemove=this.obj.onmousemove=function(e){(e=e||t).preventDefault?e.preventDefault():e.returnValue=!1,n._OnSelectionMove(e)},this._oldDMP=document.body.onmouseup,document.body.onmouseup=function(e){return e=e||t,n._OnSelectionStop(e,this),!0},this.callEvent("onBeforeBlockSelection",[]),document.body.onselectstart=function(){return!1}}},dhtmlXGridObject.prototype._getCellByPos=function(t,e){t=t,this._fake&&(t+=this._fake.objBox.scrollWidth),e=e;for(var n=0,i=0;i<this.obj.rows.length;i++)if((e-=this.obj.rows[i].offsetHeight)<=0){n=this.obj.rows[i];break}if(!n||!n.idd)return null;for(i=0;i<this._cCount;i++)if((t-=this.getColWidth(i))<=0)for(;;){if(!n._childIndexes||n._childIndexes[i+1]!=n._childIndexes[i])return this.cells(n.idd,i).cell;n=n.previousSibling}return null},dhtmlXGridObject.prototype._OnSelectionMove=function(t){var e=this;this._ShowSelection();var n=this.getPosition(this.obj),i=t.clientX-n[0]+(document.body.scrollLeft||(document.documentElement?document.documentElement.scrollLeft:0)),a=t.clientY-n[1]+(document.body.scrollTop||(document.documentElement?document.documentElement.scrollTop:0));if(Math.abs(this._init_pos[0]-i)<5&&Math.abs(this._init_pos[1]-a)<5)return this._HideSelection();var o=this._endSelectionCell;if(null==this._startSelectionCell)this._endSelectionCell=this._startSelectionCell=this.getFirstParentOfType(t.srcElement||t.target,"TD");else if(t.srcElement||t.target)if("dhtmlxGrid_selection"==(t.srcElement||t.target).className)this._endSelectionCell=this._getCellByPos(i,a)||this._endSelectionCell;else{var r=this.getFirstParentOfType(t.srcElement||t.target,"TD");r.parentNode.idd&&(this._endSelectionCell=r)}this._endSelectionCell&&(this.callEvent("onBeforeBlockSelected",[this._endSelectionCell.parentNode.idd,this._endSelectionCell._cellIndex])||(this._endSelectionCell=o));var s=this.objBox.scrollLeft+this.objBox.clientWidth,l=this.objBox.scrollTop+this.objBox.clientHeight,d=this.objBox.scrollLeft,c=this.objBox.scrollTop,h=!1;if(this._blsTimer&&window.clearTimeout(this._blsTimer),i+20>=s?(this.objBox.scrollLeft=this.objBox.scrollLeft+20,h=!0):i-20<d&&(this.objBox.scrollLeft=this.objBox.scrollLeft-20,h=!0),a+20>=l&&!this._realfake?(this.objBox.scrollTop=this.objBox.scrollTop+20,h=!0):a-20<c&&!this._realfake&&(this.objBox.scrollTop=this.objBox.scrollTop-20,h=!0),this._selectionArea=this._RedrawSelectionPos(this._startSelectionCell,this._endSelectionCell),h){var u=t.clientX,m=t.clientY;this._blsTimer=window.setTimeout(function(){e._OnSelectionMove({clientX:u,clientY:m})},100)}},dhtmlXGridObject.prototype._OnSelectionStop=function(t){var e=this;if(this._blsTimer&&window.clearTimeout(this._blsTimer),this.obj.onmousedown=function(n){return e._bs_mode&&e._OnSelectionStart(n||t,this),!0},this.obj.onmousemove=this.obj.onmmold||null,this._selectionObj.onmousemove=null,document.body.onmouseup=this._oldDMP||null,parseInt(this._selectionObj.style.width)<2&&parseInt(this._selectionObj.style.height)<2)this._HideSelection();else{var n=this.getFirstParentOfType(t.srcElement||t.target,"TD");for(n&&n.parentNode.idd||(n=this._endSelectionCell);n&&(!n.tagName||"td"!=n.tagName.toLowerCase());)n=n.parentNode;if(!n)return this._HideSelection();this._stopSelectionCell=n,this._selectionArea=this._RedrawSelectionPos(this._startSelectionCell,this._stopSelectionCell),this.callEvent("onBlockSelected",[])}document.body.onselectstart=function(){}},dhtmlXGridObject.prototype._RedrawSelectionPos=function(t,e){if(t.parentNode.grid!=e.parentNode.grid)return this._selectionArea;var n={};n.LeftTopCol=t._cellIndex,n.LeftTopRow=this.getRowIndex(t.parentNode.idd),n.RightBottomCol=e._cellIndex,n.RightBottomRow=this.getRowIndex(e.parentNode.idd);var i=t.offsetWidth,a=t.offsetHeight;t=this.getPosition(t,this.obj);var o=e.offsetWidth,r=e.offsetHeight;if(e=this.getPosition(e,this.obj),t[0]<e[0])var s=t[0],l=e[0]+o;else{var d=n.RightBottomCol;n.RightBottomCol=n.LeftTopCol,n.LeftTopCol=d;s=e[0],l=t[0]+i}if(t[1]<e[1])var c=t[1],h=e[1]+r;else{d=n.RightBottomRow;n.RightBottomRow=n.LeftTopRow,n.LeftTopRow=d;c=e[1],h=t[1]+a}var u=l-s,m=h-c;return this._selectionObj.style.left=s+"px",this._selectionObj.style.top=c+"px",this._selectionObj.style.width=u+"px",this._selectionObj.style.height=m+"px",n},dhtmlXGridObject.prototype._CreateSelection=function(t,e){if(null==this._selectionObj){var n=document.createElement("div");n.style.position="absolute",n.style.display="none",n.className="dhtmlxGrid_selection",this._selectionObj=n,this._selectionObj.onmousedown=function(t){if(2==(t=t||event).button||_isMacOS&&t.ctrlKey)return this.parentNode.grid.callEvent("onBlockRightClick",["BLOCK",t])},this._selectionObj.oncontextmenu=function(t){return(t||event).cancelBubble=!0,!1},this.objBox.appendChild(this._selectionObj)}this._selectionObj.style.width="0px",this._selectionObj.style.height="0px",this._selectionObj.style.left=t+"px",this._selectionObj.style.top=e+"px",this._selectionObj.startX=t,this._selectionObj.startY=e},dhtmlXGridObject.prototype._ShowSelection=function(){this._selectionObj&&(this._selectionObj.style.display="")},dhtmlXGridObject.prototype._HideSelection=function(){this._selectionObj&&(this._selectionObj.style.display="none"),this._selectionArea=null,this._clip_area&&(this._clip_area.value="",this._clip_area.blur())},dhtmlXGridObject.prototype.copyBlockToClipboard=function(){if(this._clip_area&&null!=this._selectionArea){var t=new Array;this._mathSerialization?this._agetm="getMathValue":this._strictText?this._agetm="getTitle":this._agetm="getValue",this._serialize_visible=!0;for(var e=this._selectionArea.LeftTopRow;e<=this._selectionArea.RightBottomRow;e++){var n=this._serializeRowToCVS(this.rowsBuffer[e],null,this._selectionArea.LeftTopCol,this._selectionArea.RightBottomCol+1);this._csvAID?t[t.length]=n:t[t.length]=n.substr(n.indexOf(this.csv.cell)+1)}t=t.join(this._CSVRowDelimiter),this._clip_area.value=t,this._clip_area.select(),this._serialize_visible=!1}},dhtmlXGridObject.prototype.pasteBlockFromClipboard=function(){if(this._clip_area){this._clip_area.select();var t=this;window.setTimeout(function(){t._pasteBlockFromClipboard(),t=null},1)}},dhtmlXGridObject.prototype._pasteBlockFromClipboard=function(){var t=this._clip_area.value;if(t){if(null!=this._selectionArea)var e=this._selectionArea.LeftTopRow,n=this._selectionArea.LeftTopCol;else{if(null==this.cell||this.editor)return!1;e=this.getRowIndex(this.cell.parentNode.idd),n=this.cell._cellIndex}var i=e+(t=this.csvParser.unblock(t,this.csv.cell,this.csv.row)).length,a=n+t[0].length;a>this._cCount&&(a=this._cCount);for(var o=0,r=e;r<i;r++){var s=this.render_row(r);if(-1!=s){for(var l=0,d=n;d<a;d++)if(!this._hrrar[d]||this._fake){var c=this.cells3(s,d);if(c.isDisabled())l++;else{if(this._onEditUndoRedo&&this._onEditUndoRedo(2,s.idd,d,t[o][l],c.getValue()),c.combo){for(var h=c.combo.values,u=0;u<h.length;u++)if(t[o][l]==h[u]){c.setValue(c.combo.keys[u]),h=null;break}null!=h&&c.editable?c.setValue(t[o][l++]):l++}else c[c.setImage?"setLabel":"setValue"](t[o][l++]);c.cell.wasChanged=!0}}else a=Math.min(a+1,this._cCount);this.callEvent("onRowPaste",[s.idd]),o++}}}},dhtmlXGridObject.prototype.getSelectedBlock=function(){return this._selectionArea?this._selectionArea:null!==this.getSelectedRowId()?{LeftTopRow:this.getSelectedRowId(),LeftTopCol:this.getSelectedCellIndex(),RightBottomRow:this.getSelectedRowId(),RightBottomCol:this.getSelectedCellIndex()}:null},dhtmlXGridObject.prototype.enableSmartRendering=function(t,e,n){arguments.length>2&&(e&&!this.rowsBuffer[e-1]&&(this.rowsBuffer[e-1]=0),e=n),this._srnd=dhx4.s2b(t),this._srdh=this._srdh||20,this._dpref=e||0},dhtmlXGridObject.prototype.enablePreRendering=function(t){this._srnd_pr=parseInt(t||50)},dhtmlXGridObject.prototype.forceFullLoading=function(t,e){for(var n=0;n<this.rowsBuffer.length;n++)if(!this.rowsBuffer[n]){var i=t||this.rowsBuffer.length-n;if(this.callEvent("onDynXLS",[n,i])){var a=this;this.load(this.xmlFileUrl+dhtmlx.url(this.xmlFileUrl)+"posStart="+n+"&count="+i,function(){window.setTimeout(function(){a.forceFullLoading(t,e)},100)},this._data_type)}return}e&&e.call(this)},dhtmlXGridObject.prototype.setAwaitedRowHeight=function(t){this._srdh=parseInt(t)},dhtmlXGridObject.prototype._get_view_size=function(){return Math.floor(parseInt(this.entBox.offsetHeight)/this._srdh)+2},dhtmlXGridObject.prototype._add_filler=function(t,e,n,i){if(!e)return null;var a=this._prepareRow("__filler__");a.firstChild.style.width="1px",a.firstChild.style.borderWidth=a.firstChild.style.padding=a.firstChild.style.margin="0px";for(var o=1;o<a.childNodes.length;o++)a.childNodes[o].style.display="none";return a.firstChild.style.height=e*this._srdh+"px",(n=n||this.rowsCol[t])&&n.nextSibling?n.parentNode.insertBefore(a,n.nextSibling):_isKHTML?this.obj.appendChild(a):this.obj.rows[0].parentNode.appendChild(a),this.callEvent("onAddFiller",[t,e,a,n,i]),[t,e,a]},dhtmlXGridObject.prototype._update_srnd_view=function(){var t=Math.floor(this.objBox.scrollTop/this._srdh),e=t+this._get_view_size();if(this.multiLine){var n=this.objBox.scrollTop;for(t=0;n>0;)n-=this.rowsCol[t]?this.rowsCol[t].offsetHeight:this._srdh,t++;e=t+this._get_view_size(),t>0&&t--}(e+=this._srnd_pr||0)>this.rowsBuffer.length&&(e=this.rowsBuffer.length);for(var i=t;i<e;i++)if(!this.rowsCol[i]){if(-1==this._add_from_buffer(i)){if(this.xmlFileUrl){if(this._dpref&&this.rowsBuffer[e-1]){this._dpref&&this._dpref;var a=Math.max(0,Math.min(i,e-this._dpref));this._current_load=[a,e-a]}else this._current_load=[i,this._dpref?this._dpref:e-i];this.callEvent("onDynXLS",this._current_load)&&this.load(this.xmlFileUrl+dhtmlx.url(this.xmlFileUrl)+"posStart="+this._current_load[0]+"&count="+this._current_load[1],this._data_type)}return}this._tgle&&(this._updateLine(this._h2.get[this.rowsBuffer[i].idd],this.rowsBuffer[i]),this._updateParentLine(this._h2.get[this.rowsBuffer[i].idd],this.rowsBuffer[i])),i&&i==(this._realfake?this._fake:this)._r_select&&this.selectCell(i,this.cell?this.cell._cellIndex:0,!0)}this._fake&&!this._realfake&&this.multiLine&&(this._fake.objBox.scrollTop=this.objBox.scrollTop)},dhtmlXGridObject.prototype._add_from_buffer=function(t){var e=this.render_row(t);if(-1==e)return-1;if((e._attrs.selected||e._attrs.select)&&(this.selectRow(e,!1,!0),e._attrs.selected=e._attrs.select=null),this._cssSP){if(this._h2){var n=this._h2.get[e.idd];e.className+=" "+(n.level%2?this._cssUnEven+" "+this._cssUnEven:this._cssEven+" "+this._cssEven)+"_"+n.level+(this.rowsAr[n.id]._css||"")}}else this._cssEven&&t%2==0?e.className=this._cssEven+(-1!=e.className.indexOf("rowselected")?" rowselected ":" ")+(e._css||""):this._cssUnEven&&t%2==1&&(e.className=this._cssUnEven+(-1!=e.className.indexOf("rowselected")?" rowselected ":" ")+(e._css||""));for(var i=0;i<this._fillers.length;i++){var a=this._fillers[i];if(a&&a[0]<=t&&a[0]+a[1]>t){var o=t-a[0];return void(0==o?(this._insert_before(t,e,a[2]),this._update_fillers(i,-1,1)):o==a[1]-1?(this._insert_after(t,e,a[2]),this._update_fillers(i,-1,0)):(this._fillers.push(this._add_filler(t+1,a[1]-o-1,a[2],1)),this._insert_after(t,e,a[2]),this._update_fillers(i,-a[1]+o,0)))}}},dhtmlXGridObject.prototype._update_fillers=function(t,e,n){var i=this._fillers[t];i[1]=i[1]+e,i[0]=i[0]+n,i[1]?(i[2].firstChild.style.height=parseFloat(i[2].firstChild.style.height)+e*this._srdh+"px",this.callEvent("onUpdateFiller",[i[2]])):(this.callEvent("onRemoveFiller",[i[2]]),i[2].parentNode.removeChild(i[2]),this._fillers.splice(t,1))},dhtmlXGridObject.prototype._insert_before=function(t,e,n){n.parentNode.insertBefore(e,n),this.rowsCol[t]=e,this.callEvent("onRowInserted",[e,null,n,"before"])},dhtmlXGridObject.prototype._insert_after=function(t,e,n){n.nextSibling?n.parentNode.insertBefore(e,n.nextSibling):n.parentNode.appendChild(e),this.rowsCol[t]=e,this.callEvent("onRowInserted",[e,null,n,"after"])},void 0!==window.dhtmlxValidation&&(dhtmlxValidation.trackInput=function(t,e,n,i){dhtmlxEvent(t,"keyup",function(a){dhtmlxValidation._timer&&(window.clearTimeout(dhtmlxValidation._timer),dhtmlxValidation._timer=null),dhtmlxValidation._timer=window.setTimeout(function(){dhtmlxValidation.checkInput(t,e)?(t.className=t.className.replace(/[ ]*dhtmlx_live_validation_error/g,""),i&&i(t,t.value,e)):n&&!n(t,t.value,e)||(t.className+=" dhtmlx_live_validation_error")},250)})},dhtmlxValidation.checkInput=function(t,e){return dhtmlxValidation.checkValue(t.value,e)},dhtmlxValidation.checkValue=function(t,e){"string"==typeof e&&(e=e.split(","));for(var n=!0,i=0;i<e.length;i++)this["is"+e[i]]?n=n&&this["is"+e[i]](t):alert("Incorrect validation rule: "+e[i]);return n}),dhtmlXGridObject.prototype.enableValidation=function(t,e){t=dhx4.s2b(t),this._validators=!!t&&{data:[]},arguments.length>1&&(this._validators._live=e),this._validators._event||(this._validators._event=this.attachEvent("onEditCell",this.validationEvent))},dhtmlXGridObject.prototype.setColValidators=function(t){this._validators||this.enableValidation(!0),"string"==typeof t&&(t=t.split(this.delim)),this._validators.data=t},dhtmlXGridObject.prototype.validationEvent=function(t,e,n,i,a){var o=this._validators;if(!o)return!0;var r=o.data[n]||this.cells(e,n).getAttribute("validate")||"";if(1==t&&r){var s=this.editor||(this._fake||{}).editor;if(!s)return!0;if(s.cell.className=s.cell.className.replace(/[ ]*dhtmlx_validation_error/g,""),o._live){var l=this;dhtmlxValidation.trackInput(s.getInput(),r,function(t,i,a){return l.callEvent("onLiveValidationError",[e,n,i,t,a])},function(t,i,a){return l.callEvent("onLiveValidationCorrect",[e,n,i,t,a])})}}return 2==t&&this.validateCell(e,n,r,i),!0},dhtmlXGridObject.prototype.validateCell=function(t,e,n,i){if(n=n||this._validators.data[e]||this.cells(t,e).getAttribute("validate"),i=i||this.cells(t,e).getValue(),n){var a=this.cells(t,e).cell,o=!0;"string"==typeof n&&(n=n.split(this.delim));for(var r=0;r<n.length;r++)dhtmlxValidation.checkValue(i,n[r])||(this.callEvent("onValidationError",[t,e,i,n[r]])&&(a.className+=" dhtmlx_validation_error"),o=!1);return o&&(this.callEvent("onValidationCorrect",[t,e,i,n]),a.className=a.className.replace(/[ ]*dhtmlx_validation_error/g,"")),o}},eXcell_stree.prototype=new eXcell,dhtmlXGridObject.prototype.setSubTree=function(t,e){this._sub_trees||(this._sub_trees=[]),this._sub_trees[e]=[t],t.parentObject.style.display="none";var n=this;t.parentObject.onclick=function(t){return(t||window.event).cancelBubble=!0,!1},t.ev_onDblClick=null,t.attachEvent("onDblClick",function(t){return n._sub_id=t,n.editStop(),!0}),t._chRRS=!0},eXcell_link.prototype=new eXcell,eXcell_link.prototype.getTitle=function(){var t=this.cell.firstChild;return t&&t.tagName?t.getAttribute("href"):""},eXcell_link.prototype.getContent=function(){var t=this.cell.firstChild;return t&&t.tagName?t.innerHTML:""},eXcell_grid.prototype=new eXcell,dhtmlXGridObject.prototype.setSubGrid=function(t,e,n){this._sub_grids||(this._sub_grids=[]),this._sub_grids[e]=[t,n],t.entBox.style.display="none";var i=this;t.entBox.onclick=function(t){return(t||window.event).cancelBubble=!0,!1},t.attachEvent("onRowSelect",function(t){return i.editStop(),!0}),t._chRRS=!1},eXcell_dhxCalendar.prototype=new eXcell,eXcell_dhxCalendar.prototype.edit=function(){var t=this.grid.getPosition(this.cell);this.grid._grid_calendarA._show(!1,!1);var e=0;e=!window.innerHeight||t[1]+this.grid._grid_calendarA.base.offsetHeight+this.cell.offsetHeight<window.innerHeight?t[1]+this.cell.offsetHeight:t[1]-this.grid._grid_calendarA.base.offsetHeight;var n=t[0];window.innerWidth&&n+this.grid._grid_calendarA.base.clientWidth+this.cell.offsetWidth>window.innerWidth&&(n=window.innerWidth-this.grid._grid_calendarA.base.clientWidth),this.grid._grid_calendarA.setPosition(n,e),this.grid._grid_calendarA._last_operation_calendar=!1,this.grid.callEvent("onCalendarShow",[this.grid._grid_calendarA,this.cell.parentNode.idd,this.cell._cellIndex]),this.cell._cediton=!0,this.val=this.cell.val,this._val=this.cell.innerHTML;var i=this.grid._grid_calendarA.draw;this.grid._grid_calendarA.draw=function(){},this.grid._grid_calendarA.setDateFormat(this.grid._dtmask||"%d/%m/%Y"),this.grid._grid_calendarA.setDate(this.val||new Date),this.grid._grid_calendarA.draw=i},eXcell_dhxCalendar.prototype.getDate=function(){return this.cell.val?this.cell.val:null},eXcell_dhxCalendar.prototype.getValue=function(){return this.cell._clearCell?"":this.grid._dtmask_inc&&this.cell.val?this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask_inc,this.cell.val).toString():this.cell.innerHTML.toString()._dhx_trim()},eXcell_dhxCalendar.prototype.detach=function(){if(this.grid._grid_calendarA&&(this.grid._grid_calendarA.hide(),this.cell._cediton)){if(this.cell._cediton=!1,this.grid._grid_calendarA._last_operation_calendar){var t=this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask||"%d/%m/%Y"),e=this.grid._grid_calendarA.getDate();this.cell.val=new Date(e),this.setCValue(t,e),this.cell._clearCell=!t;var n=this.val;return this.val=this._val,this.cell.val.valueOf()!=(n||"").valueOf()}return!1}},eXcell_dhxCalendar.prototype.setValue=function(t){if(t&&"object"==typeof t)return this.cell.val=t,this.cell._clearCell=!1,void this.setCValue(this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask||"%d/%m/%Y",t).toString(),this.cell.val);t&&""!=t.toString()._dhx_trim()?(this.cell._clearCell=!1,this.cell.val=new Date(this.grid._grid_calendarA.setFormatedDate(this.grid._dtmask_inc||this.grid._dtmask||"%d/%m/%Y",t.toString(),null,!0)),this.grid._dtmask_inc&&(t=this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask||"%d/%m/%Y",this.cell.val))):(t="&nbsp",this.cell._clearCell=!0,this.cell.val=""),"NaN"==this.cell.val||"Invalid Date"==this.cell.val?(this.cell._clearCell=!0,this.cell.val=new Date,this.setCValue("&nbsp;",0)):this.setCValue((t||"").toString(),this.cell.val)},eXcell_dhxCalendarA.prototype=new eXcell,eXcell_dhxCalendarA.prototype.edit=function(){var t=this.grid.getPosition(this.cell);this.grid._grid_calendarA._show(!1,!1),this.grid._grid_calendarA.setPosition(1*t[0]+this.cell.offsetWidth,1*t[1]),this.grid.callEvent("onCalendarShow",[this.grid._grid_calendarA,this.cell.parentNode.idd,this.cell._cellIndex]),this.grid._grid_calendarA._last_operation_calendar=!1,this.cell._cediton=!0,this.val=this.cell.val,this._val=this.cell.innerHTML;var e=this.grid._grid_calendarA.draw;this.grid._grid_calendarA.draw=function(){},this.grid._grid_calendarA.setDateFormat(this.grid._dtmask||"%d/%m/%Y"),this.grid._grid_calendarA.setDate(this.val),this.grid._grid_calendarA.draw=e,this.cell.atag=!this.grid.multiLine&&(_isKHTML||_isMacOS||_isFF)?"INPUT":"TEXTAREA",this.obj=document.createElement(this.cell.atag),this.obj.style.height=this.cell.offsetHeight-4+"px",this.obj.className="dhx_combo_edit",this.obj.wrap="soft",this.obj.style.textAlign=this.cell.align,this.obj.onclick=function(t){(t||event).cancelBubble=!0},this.obj.onmousedown=function(t){(t||event).cancelBubble=!0},this.obj.value=this.getValue(),this.cell.innerHTML="",this.cell.appendChild(this.obj),window.dhx4.isIE&&(this.obj.style.overflow="visible",this.grid.multiLine&&this.obj.offsetHeight>=18&&this.obj.offsetHeight<40&&(this.obj.style.height="36px",this.obj.style.overflow="scroll")),this.obj.onselectstart=function(t){return t||(t=event),t.cancelBubble=!0,!0},this.obj.focus(),this.obj.focus()},eXcell_dhxCalendarA.prototype.getDate=function(){return this.cell.val?this.cell.val:null},eXcell_dhxCalendarA.prototype.getValue=function(){return this.cell._clearCell?"":this.grid._dtmask_inc&&this.cell.val?this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask_inc,this.cell.val).toString():this.cell.innerHTML.toString()._dhx_trim()},eXcell_dhxCalendarA.prototype.detach=function(){if(this.grid._grid_calendarA&&(this.grid._grid_calendarA.hide(),this.cell._cediton)){if(this.cell._cediton=!1,this.grid._grid_calendarA._last_operation_calendar){this.grid._grid_calendarA._last_operation_calendar=!1;var t=this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask||"%d/%m/%Y"),e=this.grid._grid_calendarA.getDate();this.cell.val=new Date(e),this.setCValue(t,e),this.cell._clearCell=!t;var n=this.val;return this.val=this._val,this.cell.val.valueOf()!=(n||"").valueOf()}this.setValue(this.obj.value);n=this.val;return this.val=this._val,this.cell.val.valueOf()!=(n||"").valueOf()}},eXcell_dhxCalendarA.prototype.setValue=function(t){if(t&&"object"==typeof t)return this.cell.val=t,this.cell._clearCell=!1,void this.setCValue(this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask||"%d/%m/%Y",t).toString(),this.cell.val);t&&""!=t.toString()._dhx_trim()?(this.cell._clearCell=!1,this.cell.val=new Date(this.grid._grid_calendarA.setFormatedDate(this.grid._dtmask_inc||this.grid._dtmask||"%d/%m/%Y",t.toString(),null,!0)),this.grid._dtmask_inc&&(t=this.grid._grid_calendarA.getFormatedDate(this.grid._dtmask||"%d/%m/%Y",this.cell.val))):(t="&nbsp",this.cell._clearCell=!0,this.cell.val=""),"NaN"==this.cell.val||"Invalid Date"==this.cell.val?(this.cell.val=new Date,this.cell._clearCell=!0,this.setCValue("&nbsp;",0)):this.setCValue((t||"").toString(),this.cell.val)},dhtmlXGridObject.prototype.resetCounter=function(t){this._fake&&!this._realfake&&t<this._fake._cCount&&this._fake.resetCounter(t,this.currentPage);var e=arguments[0]||0;for(this.currentPage&&(e=(this.currentPage-1)*this.rowsBufferOutSize),e=0;e<this.rowsBuffer.length;e++)this.rowsBuffer[e]&&"TR"==this.rowsBuffer[e].tagName&&this.rowsAr[this.rowsBuffer[e].idd]&&(this.rowsAr[this.rowsBuffer[e].idd].childNodes[t].innerHTML=e+1)},eXcell_cntr.prototype=new eXcell,eXcell_acheck.prototype=new eXcell,eXcell_acheck.prototype.setValue=function(t){-1!=(t=(t||"").toString()).indexOf("1")||-1!=t.indexOf("true")?(t="1",this.cell.chstate="1"):(t="0",this.cell.chstate="0");this.setCValue(this.drawCurrentState(),this.cell.chstate)},eXcell_context.prototype=new eXcell,dhtmlXGridObject.prototype.setSubContext=function(t,e,n){var i=this;t.attachEvent("onClick",function(e,n){return i._sub_id=e,i.editStop(),t.hideContextMenu(),!0}),this._sub_context||(this._sub_context=[]),this._sub_context[e]=[t,n],t.hideContextMenu()},dhtmlXGridObject.prototype._process_json_row=function(t,e){t._attrs=e;for(var n=0;n<t.childNodes.length;n++)t.childNodes[n]._attrs={};if(e.userdata)for(var i in e.userdata)this.setUserData(t.idd,i,e.userdata[i]);e=this._c_order?this._swapColumns(e.data):e.data;for(var a=0;a<e.length;a++)"object"==typeof e[a]&&null!=e[a]&&(t.childNodes[a]._attrs=e[a],e[a].type&&(t.childNodes[a]._cellType=e[a].type),e[a]=e[a].value);return this._fillRow(t,e),t},dhtmlXGridObject.prototype._process_js_row=function(t,e){t._attrs=e;for(var n=0;n<t.childNodes.length;n++)t.childNodes[n]._attrs={};if(e.userdata)for(var i in e.userdata)this.setUserData(t.idd,i,e.userdata[i]);for(var a=[],o=0;o<this.columnIds.length;o++)a[o]=e[this.columnIds[o]],"object"==typeof a[o]&&null!=a[o]&&(t.childNodes[o]._attrs=a[o],a[o].type&&(t.childNodes[o]._cellType=a[o].type),a[o]=a[o].value),a[o]||0===a[o]||(a[o]="");return this._fillRow(t,a),t},dhtmlXGridObject.prototype.updateFromJSON=function(t,e,n,i){void 0===e&&(e=!0),this._refresh_mode=[!0,e,n],this.load(t,i,"json")},dhtmlXGridObject.prototype._refreshFromJSON=function(t){this._f_rowsBuffer&&this.filterBy(0,""),reset=!1,window.eXcell_tree&&(eXcell_tree.prototype.setValueX=eXcell_tree.prototype.setValue,eXcell_tree.prototype.setValue=function(t){this.grid._h2.get[this.cell.parentNode.idd]&&this.cell.parentNode.valTag?this.setLabel(t):this.setValueX(t)});var e=this.cellType._dhx_find("tree"),n=t.parent||0,i={};this._refresh_mode[2]&&(-1!=e?this._h2.forEachChild(n,function(t){i[t.id]=!0},this):this.forEachRow(function(t){i[t]=!0}));for(var a=t.rows,o=0;o<a.length;o++){var r=a[o],s=r.id;if(i[s]=!1,this.rowsAr[s]&&"TR"!=this.rowsAr[s].tagName)this._h2?this._h2.get[s].buff.data=r:this.rowsBuffer[this.getRowIndex(s)].data=r,this.rowsAr[s]=r;else if(this.rowsAr[s])this._process_json_row(this.rowsAr[s],r,-1),this._postRowProcessing(this.rowsAr[s],!0);else if(this._refresh_mode[1]){var l={idd:s,data:r,_parser:this._process_json_row,_locator:this._get_json_data},d=this.rowsBuffer.length;"top"==this._refresh_mode[1]?(this.rowsBuffer.unshift(l),d=0):this.rowsBuffer.push(l),this._h2&&(reset=!0,this._h2.add(s,n).buff=this.rowsBuffer[this.rowsBuffer.length-1]),this.rowsAr[s]=r,r=this.render_row(d),this._insertRowAt(r,d?-1:0)}}if(this._refresh_mode[2])for(s in i)i[s]&&this.rowsAr[s]&&this.deleteRow(s);this._refresh_mode=null,window.eXcell_tree&&(eXcell_tree.prototype.setValue=eXcell_tree.prototype.setValueX),reset&&this._renderSort(),this._f_rowsBuffer&&(this._f_rowsBuffer=null,this.filterByAll())},dhtmlXGridObject.prototype._process_js=function(t){return this._process_json(t,"js")},dhtmlXGridObject.prototype._parseOptionsJson=function(t){if(t.coll_options){for(var e in t.coll_options){var n=t.coll_options[e],i=this.getColIndexById(e);if("combo"==this.cellType[i])(a=this.getColumnCombo(i)).addOption(n);else if(0==this.cellType[i].indexOf("co"))for(var a=this.getCombo(i),o=0;o<n.length;o++)a.put(n[o].value,n[o].label)}this._colls_loaded=!0}},dhtmlXGridObject.prototype._parseHeadJson=function(t){if(t.head&&t.head.length){var e=t.head,n=t.settings,i="setInitWidths",a=!1;n&&"%"==n.colwidth&&(i="setInitWidthsP"),n&&"%"==n.splitat&&(a=n.splitat),this.hdr.rows.length>0&&this.clearAll(!0);for(var o=[[],[],[],[],[],[],[]],r=["value","width","type","align","sort","hidden","id"],s=["",i,"setColTypes","setColAlign","setColSorting","","setColumnIds"],l=0;l<e.length;l++)for(var d=0;d<r.length;d++)o[d].push(e[l][r[d]]);this.setHeader(o[0]);for(l=0;l<s.length;l++)s[l]&&this[s[l]](o[l].join(this.delim));for(l=0;l<e.length;l++){var c=e[l].options;if(e[l].options)if("clist"==this.cellType[l])this.registerCList(l,c);else{var h=this.getCombo(l);for(d=0;d<c.length;d++)h.put(c[d].id,c[d].value)}}this.init();var u=o[5].join(this.delim);this.setColHidden&&""!=u.replace(/,/g,"")&&this.setColHidden(u),a&&this.splitAt&&this.splitAt(a)}},dhtmlXGridObject.prototype._process_json=function(data,mode){this._parsing=!0;try{var data=data.responseText||data;"string"==typeof data&&(eval("dhtmlx.temp="+data+";"),data=dhtmlx.temp)}catch(t){dhx4.callEvent("onLoadXMLError",["Incorrect JSON",data.xmlDoc||data,this]),data={rows:[]}}if(this._refresh_mode)return this._refreshFromJSON(data);data.head&&this._parseHeadJson(data),this._parseOptionsJson(data);var cr=parseInt(data.pos||0),total=parseInt(data.total_count||0),reset=!1;total&&(this.rowsBuffer[total-1]||(this.rowsBuffer.length&&(reset=!0),this.rowsBuffer[total-1]=null),total<this.rowsBuffer.length&&(this.rowsBuffer.splice(total,this.rowsBuffer.length-total),reset=!0));var userdata="js"===mode?data.userdata:data;for(var key in userdata)"js"!==mode&&"rows"==key||this.setUserData("",key,userdata[key]);if("js"==mode&&data.collections)for(var colkey in data.collections){var index=this.getColIndexById(colkey),colrecs=data.collections[colkey];if(index!==window.undefined)if("clist"==this.cellType[index]){colplaindata=[];for(var j=0;j<colrecs.length;j++)colplaindata.push(colrecs[j].label);this.registerCList(index,colplaindata)}else for(var combo=this.getCombo(index),j=0;j<colrecs.length;j++)combo.put(colrecs[j].value,colrecs[j].label)}if(this.isTreeGrid())return this._process_tree_json(data,null,null,mode);if("js"==mode){data.data&&(data=data.data);for(var i=0;i<data.length;i++)if(!this.rowsBuffer[i+cr]){var row=data[i],id=row.id||i+1;this.rowsBuffer[i+cr]={idd:id,data:row,_parser:this._process_js_row,_locator:this._get_js_data},this.rowsAr[id]=data[i]}}else for(var i=0;i<data.rows.length;i++)if(!this.rowsBuffer[i+cr]){var id=data.rows[i].id;this.rowsBuffer[i+cr]={idd:id,data:data.rows[i],_parser:this._process_json_row,_locator:this._get_json_data},this.rowsAr[id]=data.rows[i]}if(this.callEvent("onDataReady",[]),reset&&this._srnd){var h=this.objBox.scrollTop;this._reset_view(),this.objBox.scrollTop=h}else this.render_dataset();this._parsing=!1},dhtmlXGridObject.prototype._get_json_data=function(t,e){var n=t.data[e];return"object"==typeof n?n?n.value:"":n},dhtmlXGridObject.prototype._process_tree_json=function(t,e,n,i){this._parsing=!0;var a=!1;if(e||(this.render_row=this.render_row_tree,a=!0,"0"==(n=(e=t).parent||0)&&(n=0),this._h2||(this._h2=this._createHierarchy()),this._fake&&(this._fake._h2=this._h2)),"js"==i){e.data&&!n&&(t=e.data),e.rows&&(e=e.rows);for(var o=0;o<e.length;o++){var r=e[o].id;(s=this._h2.add(r,n)).buff={idd:r,data:e[o],_parser:this._process_js_row,_locator:this._get_js_data},e[o].open&&(s.state="minus"),this.rowsAr[r]=s.buff,this._process_tree_json(e[o],e[o],r,i)}}else if(e.rows)for(o=0;o<e.rows.length;o++){var s;r=e.rows[o].id;(s=this._h2.add(r,n)).buff={idd:r,data:e.rows[o],_parser:this._process_json_row,_locator:this._get_json_data},e.rows[o].open&&(s.state="minus"),this.rowsAr[r]=s.buff,this._process_tree_json(e.rows[o],e.rows[o],r,i)}a&&(0!=n&&this._h2.change(n,"state","minus"),this._updateTGRState(this._h2.get[n]),this._h2_to_buff(),this.callEvent("onDataReady",[]),0!=n&&(this._srnd||this.pagingOn)?this._renderSort():this.render_dataset(),!1===this._slowParse&&this.forEachRow(function(t){this.render_row_tree(0,t)}),this._parsing=!1,0==n||this._srnd||this.callEvent("onOpenEnd",[n,1]))},dhtmlXGridObject.prototype._process_html=function(t){if(t.tagName&&"TABLE"==t.tagName)return this._process_inner_html(t,0);var e=document.createElement("DIV");e.innerHTML=t.xmlDoc.responseText;var n=e.getElementsByTagName("TABLE")[0];this._process_inner_html(n,0)},dhtmlXGridObject.prototype._process_inner_html=function(t,e){for(var n=t.rows.length,i=e;i<n;i++){var a=t.rows[i].getAttribute("id")||i;this.rowsBuffer.push({idd:a,data:t.rows[i],_parser:this._process_html_row,_locator:this._get_html_data})}this.render_dataset(),this.setSizes()},dhtmlXGridObject.prototype._process_html_row=function(t,e){var n=e.getElementsByTagName("TD"),i=[];t._attrs=this._xml_attrs(e);for(var a=0;a<n.length;a++){var o=n[a],r=o.getAttribute("type");if(t.childNodes[a]&&(r&&(t.childNodes[a]._cellType=r),t.childNodes[a]._attrs=this._xml_attrs(n[a])),o.firstChild?i.push(o.innerHTML):i.push(""),o.colSpan>1){t.childNodes[a]._attrs.colspan=o.colSpan;for(var s=1;s<o.colSpan;s++)i.push("")}}for(n.length;a<t.childNodes.length;a++)t.childNodes[a]._attrs={};return this._fillRow(t,this._c_order?this._swapColumns(i):i),t},dhtmlXGridObject.prototype._get_html_data=function(t,e){for(t=t.firstChild;;){if(!t)return"";if("TD"==t.tagName&&e--,e<0)break;t=t.nextSibling}return t.firstChild?t.firstChild.data:""},dhtmlxEvent(window,"load",function(){for(var t=document.getElementsByTagName("table"),e=0;e<t.length;e++)"dhtmlxGrid"==t[e].className&&dhtmlXGridFromTable(t[e])}),dhtmlXForm.prototype.getInput=function(t){return this.doWithItem(t,"getInput")},dhtmlXForm.prototype.getSelect=function(t){return this.doWithItem(t,"getSelect")},dhtmlXForm.prototype.items={},dhtmlXForm.prototype.items.checkbox={getInput:function(t){return t.getElementsByTagName("INPUT")[0]},render:function(t,e){t._type="ch",t._enabled=!0,t._checked=!1,t._value=void 0===e.value?null:String(e.value),t._ro=1==e.readonly,!1!==e._autoInputWidth&&(e.inputWidth=14),this.doAddLabel(t,e),this.doAddInput(t,e,"INPUT","TEXT",!0,!0,"dhxform_textarea"),t.childNodes[t._ll?1:0].className+=" dhxform_img_node";var n=document.createElement("DIV");return n.className="dhxform_img chbx0",t.appendChild(n),isNaN(e.inputLeft)||(t.childNodes[t._ll?1:0].style.left=parseInt(e.inputLeft)+"px"),isNaN(e.inputTop)||(t.childNodes[t._ll?1:0].style.top=parseInt(e.inputTop)+"px"),t.childNodes[t._ll?1:0].appendChild(n),t.childNodes[t._ll?1:0].firstChild.value=String(e.value),t._updateImgNode=function(t,e){var n=t.childNodes[t._ll?1:0].lastChild;n.className=(e?"dhxform_actv_c":"dhxform_img")+" "+(t._checked?"chbx1":"chbx0"),t=n=null},t._doOnFocus=function(t){t.getForm().callEvent("onFocus",[t._idd])},t._doOnBlur=function(t){t.getForm().callEvent("onBlur",[t._idd])},t._doOnKeyUpDown=function(t,e){this.callEvent(t,[this.childNodes[this._ll?0:1].childNodes[0],e,this._idd])},1==e.checked&&this.check(t),1==e.hidden&&this.hide(t),1==e.disabled&&this.userDisable(t),this.doAttachEvents(t),this},destruct:function(t){t._doOnFocus=t._doOnBlur=t._updateImgNode=null,this.doUnloadNestedLists(t),this.doDestruct(t)},doAddLabel:function(t,e){var n=document.createElement("DIV");n.className="dhxform_label "+e.labelAlign,1==e.wrap&&(n.style.whiteSpace="normal"),t._ll?t.insertBefore(n,t.firstChild):t.appendChild(n),void 0!==e.tooltip&&(n.title=e.tooltip),n.innerHTML="<div class='dhxform_label_nav_link' onfocus='if(this.parentNode.parentNode._updateImgNode)this.parentNode.parentNode._updateImgNode(this.parentNode.parentNode,true);this.parentNode.parentNode._doOnFocus(this.parentNode.parentNode);' onblur='if(this.parentNode.parentNode._updateImgNode)this.parentNode.parentNode._updateImgNode(this.parentNode.parentNode,false);this.parentNode.parentNode._doOnBlur(this.parentNode.parentNode);' onkeypress='var e=event||window.arguments[0];if(e.keyCode==32||e.charCode==32){e.cancelBubble=true;if(e.preventDefault)e.preventDefault();else e.returnValue=false;_dhxForm_doClick(this,\"mousedown\");return false;}' onkeyup='var e=event||window.arguments[0];this.parentNode.parentNode._doOnKeyUpDown(\"onKeyUp\",e);' onkeydown='var e=event||window.arguments[0];this.parentNode.parentNode._doOnKeyUpDown(\"onKeyDown\",e);' "+(window.dhx4.isIPad?"ontouchstart='var e=event;e.preventDefault();_dhxForm_doClick(this,\"mousedown\");' ":"")+"role='link' tabindex='0'>"+e.label+(e.info?"<span class='dhxform_info'>[?]</span>":"")+(t._required?"<span class='dhxform_item_required'>*</span>":"")+"</div>",isNaN(e.labelWidth)||(n.firstChild.style.width=parseInt(e.labelWidth)+"px"),isNaN(e.labelHeight)||(n.firstChild.style.height=parseInt(e.labelHeight)+"px"),isNaN(e.labelLeft)||(n.style.left=parseInt(e.labelLeft)+"px"),isNaN(e.labelTop)||(n.style.top=parseInt(e.labelTop)+"px")},doAddInput:function(t,e,n,i,a,o,r){var s=document.createElement("DIV");s.className="dhxform_control",t._ll?t.appendChild(s):t.insertBefore(s,t.firstChild);var l=document.createElement(n);l.className=r,l.name=t._idd,l._idd=t._idd,l.id=e.uid,"string"==typeof i&&(l.type=i),"INPUT"!=n&&"TEXTAREA"!=n||(l.onkeyup=function(e){e=e||event,t.callEvent("onKeyUp",[this,e,this._idd])},l.onkeydown=function(e){e=e||event,t.callEvent("onKeyDown",[this,e,this._idd])}),"SELECT"==n&&"select"==e.type&&"material"==t.getForm().skin&&(window.dhx4.isOpera||window.dhx4.isChrome?l.className+=" dhxform_arrow_fix_webkit":window.dhx4.isEdge?l.className+=" dhxform_arrow_fix_edge":window.dhx4.isFF&&(l.className+=" dhxform_fix_ff")),s.appendChild(l),a&&(isNaN(e.inputLeft)||(s.style.left=parseInt(e.inputLeft)+"px"),isNaN(e.inputTop)||(s.style.top=parseInt(e.inputTop)+"px"));var d="",c=!1;o&&(isNaN(e.inputWidth)||(d+="width:"+parseInt(e.inputWidth)+"px;",c=!0),isNaN(e.inputHeight)||(d+="height:"+parseInt(e.inputHeight)+"px;")),"string"==typeof e.style&&(d+=e.style),l.style.cssText=d,e.maxLength&&l.setAttribute("maxLength",e.maxLength),e.connector&&l.setAttribute("connector",e.connector);var h=null!=dhtmlXForm.prototype.items[this.t]&&1==dhtmlXForm.prototype.items[this.t]._dimFix;if(c&&(1=={input:1,password:1,select:1,multiselect:1,calendar:1,colorpicker:1}[this.t]||h)&&(null==dhtmlXForm.prototype.items[this.t]._dim&&(dhtmlXForm.prototype.items[this.t]._dim=t.getForm()._checkDim(s,l)),l.style.width=parseInt(l.style.width)-dhtmlXForm.prototype.items[this.t]._dim+"px"),"object"==typeof e.note){var u=document.createElement("DIV");u.className="dhxform_note",u.style.width=(isNaN(e.note.width)?l.offsetWidth:parseInt(e.note.width))+"px",u._w=e.note.width,u.innerHTML=e.note.text,s.appendChild(u),u=null}e.readonly&&this.setReadonly(t,!0),1==e.disabled&&this.userDisable(t),1==e.hidden&&"combo"!=this.t&&this.hide(t)},doUnloadNestedLists:function(t){if(t._list){for(var e=0;e<t._list.length;e++)t._list[e].unload(),t._list[e]=null,t._listObj[e]=null,t._listBase[e].parentNode.removeChild(t._listBase[e]),t._listBase[e]=null;t._list=null,t._listObj=null,t._listBase=null}},doDestruct:function(t){for(t.callEvent=null,t.checkEvent=null,t.getForm=null,t._autoCheck=null,t._checked=null,t._enabled=null,t._idd=null,t._type=null,t._value=null,t._group=null,t.onselectstart=null,t.childNodes[t._ll?1:0].onmousedown=null,t.childNodes[t._ll?1:0].ontouchstart=null,t.childNodes[t._ll?0:1].onmousedown=null,t.childNodes[t._ll?0:1].ontouchstart=null,t.childNodes[t._ll?0:1].childNodes[0].onfocus=null,t.childNodes[t._ll?0:1].childNodes[0].onblur=null,t.childNodes[t._ll?0:1].childNodes[0].onkeypress=null,t.childNodes[t._ll?0:1].childNodes[0].onkeyup=null,t.childNodes[t._ll?0:1].childNodes[0].onkeydown=null,t.childNodes[t._ll?0:1].childNodes[0].onmousedown=null,t.childNodes[t._ll?0:1].childNodes[0].ontouchstart=null,t.childNodes[t._ll?0:1].removeChild(t.childNodes[t._ll?0:1].childNodes[0]);t.childNodes.length>0;)t.removeChild(t.childNodes[0]);t.parentNode.removeChild(t),t=null},doAttachEvents:function(t){var e=this;t.childNodes[t._ll?1:0][window.dhx4.isIPad?"ontouchstart":"onmousedown"]=function(t){(t=t||event).preventDefault&&t.preventDefault();var n=t.target||t.srcElement;if(!this.parentNode._enabled||this.parentNode._ro||void 0!==n.className&&"dhxform_note"==n.className)return t.cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1;e.doClick(this.parentNode)},t.childNodes[t._ll?0:1].childNodes[0][window.dhx4.isIPad?"ontouchstart":"onmousedown"]=function(t){if((t=t||event).preventDefault&&t.preventDefault(),!this.parentNode.parentNode._enabled)return t.cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1;var n=t.target||t.srcElement;if(void 0!==n.className&&"dhxform_info"==n.className)return this.parentNode.parentNode.callEvent("onInfo",[this.parentNode.parentNode._idd,t]),t.cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1;e.doClick(this.parentNode.parentNode)}},doClick:function(t){t.childNodes[t._ll?0:1].childNodes[0].focus(),t._enabled&&!t._ro&&(t.checkEvent("onBeforeChange")&&!0!==t.callEvent("onBeforeChange",[t._idd,t._value,t._checked])||(this.setChecked(t,!t._checked),t._autoCheck(),t.callEvent("onChange",[t._idd,t._value,t._checked])))},doCheckValue:function(t){t._checked&&t._enabled?(t.childNodes[t._ll?1:0].firstChild.name=String(t._idd),t.childNodes[t._ll?1:0].firstChild.value=this.getValue(t)):(t.childNodes[t._ll?1:0].firstChild.name="",t.childNodes[t._ll?1:0].firstChild.value="")},setChecked:function(t,e){t._checked=!0===e,t.childNodes[t._ll?1:0].lastChild.className=t.childNodes[t._ll?1:0].lastChild.className.replace(/chbx[0-1]{1}/gi,"")+(t._checked?" chbx1":" chbx0"),this.doCheckValue(t)},check:function(t){this.setChecked(t,!0)},unCheck:function(t){this.setChecked(t,!1)},isChecked:function(t){return t._checked},enable:function(t){String(t.className).search("disabled")>=0&&(t.className=String(t.className).replace(/disabled/gi,"")),t._enabled=!0,t.childNodes[t._ll?0:1].childNodes[0].tabIndex=0,t.childNodes[t._ll?0:1].childNodes[0].removeAttribute("disabled"),this.doCheckValue(t)},disable:function(t){String(t.className).search("disabled")<0&&(t.className+=" disabled"),t._enabled=!1,null!=t._updateImgNode&&t._updateImgNode(t,!1),t.childNodes[t._ll?0:1].childNodes[0].tabIndex=-1,t.childNodes[t._ll?0:1].childNodes[0].setAttribute("disabled","true"),this.doCheckValue(t)},isEnabled:function(t){return t._enabled},setText:function(t,e){t.childNodes[t._ll?0:1].childNodes[0].innerHTML=e+(t._required?"<span class='dhxform_item_required'>*</span>":"")},getText:function(t){return t.childNodes[t._ll?0:1].childNodes[0].innerHTML.replace(/<span class=\"dhxform_item_required\">[^<]*<\/span>/g,"")},setValue:function(t,e){this.setChecked(t,!0===e||1==parseInt(e)||"true"==e||t._value===e)},getValue:function(t,e){return"realvalue"==e?t._value:void 0===t._value||null==t._value?t._checked?1:0:t._value},setReadonly:function(t,e){t._ro=!0===e},isReadonly:function(t){return t._ro},setFocus:function(t){t.childNodes[t._ll?0:1].childNodes[0].focus()}},dhtmlXForm.prototype.items.radio={input:{},r:{},firstValue:{},render:function(t,e,n){t._type="ra",t._enabled=!0,t._checked=!1,t._group=e.name,t._value=e.value,t._uid=n,t._ro=1==e.readonly,t._rName=t._rId+t._group,this.r[t._idd]=t,e.inputWidth=14,this.doAddLabel(t,e),this.doAddInput(t,e,"INPUT","TEXT",!0,!0,"dhxform_textarea"),t.childNodes[t._ll?1:0].className+=" dhxform_img_node";var i=document.createElement("DIV");if(i.className="dhxform_img rdbt0",t.appendChild(i),isNaN(e.inputLeft)||(t.childNodes[t._ll?1:0].style.left=parseInt(e.inputLeft)+"px"),isNaN(e.inputTop)||(t.childNodes[t._ll?1:0].style.top=parseInt(e.inputTop)+"px"),t.childNodes[t._ll?1:0].appendChild(i),t.childNodes[t._ll?1:0].firstChild.name="",t.childNodes[t._ll?1:0].firstChild.value="",t._updateImgNode=function(t,e){var n=t.childNodes[t._ll?1:0].lastChild;n.className=(e?"dhxform_actv_r":"dhxform_img")+" "+(t._checked?"rdbt1":"rdbt0"),t=n=null},t._doOnFocus=function(t){t.getForm().callEvent("onFocus",[t._group,t._value])},t._doOnBlur=function(t){t.getForm().callEvent("onBlur",[t._group,t._value])},t._doOnKeyUpDown=function(t,e){this.callEvent(t,[this.childNodes[this._ll?0:1].childNodes[0],e,this._group,this._value])},null==this.input[t._rName]){var a=document.createElement("INPUT");a.type="HIDDEN",a.name=e.name,a.firstValue=t._value,t.appendChild(a),this.input[t._rName]=a}return this.firstValue[t._rName]||(this.firstValue[t._rName]=e.value),1==e.checked&&this.check(t),1==e.hidden&&this.hide(t),1==e.disabled&&this.userDisable(t),this.doAttachEvents(t),this},destruct:function(t,e){if(t.lastChild==this.input[t._rName]){var n=!1;for(var i in this.r)n||this.r[i]._group!=t._group||this.r[i]._idd==t._idd||(this.r[i].appendChild(this.input[t._rName]),n=!0);n||(this.input[t._rName].parentNode.removeChild(this.input[t._rName]),this.input[t._rName]=null,this.firstValue[t._rName]=null)}this.r[t._idd]=null,delete this.r[t._idd],t._doOnFocus=t._doOnBlur=t._updateImgNode=null,this.doUnloadNestedLists(t),this.doDestruct(t);var a=t._idd;return t=null,a},doClick:function(t){if(t.childNodes[t._ll?0:1].childNodes[0].focus(),t._enabled&&!t._checked&&!t._ro){var e=[t._group,t._value,!0];t.checkEvent("onBeforeChange")&&!0!==t.callEvent("onBeforeChange",e)||(this.setChecked(t,!0),t.getForm()._autoCheck(),t.callEvent("onChange",e))}},doCheckValue:function(t){var e=null;for(var n in this.r)this.r[n]._checked&&this.r[n]._group==t._group&&this.r[n]._rId==t._rId&&(e=this.r[n]._value);null!=e&&this.r[n]._enabled?(this.input[t._rName].name=String(t._group),this.input[t._rName].value=e):(this.input[t._rName].name="",this.input[t._rName].value=""),this.input[t._rName]._value=e},setChecked:function(t,e){for(var n in e=!0===e,this.r)if(this.r[n]._group==t._group&&this.r[n]._rId==t._rId){var i=!1;if(this.r[n]._idd==t._idd?this.r[n]._checked!=e&&(this.r[n]._checked=e,i=!0):this.r[n]._checked&&(this.r[n]._checked=!1,i=!0),i){var a=this.r[n].childNodes[this.r[n]._ll?1:0].childNodes[1];a.className=a.className.replace(/rdbt[0-1]{1}/gi,"")+(this.r[n]._checked?" rdbt1":" rdbt0"),a=null}}this.doCheckValue(t)},getChecked:function(t){return this.input[t._rName]._value},_getFirstValue:function(t){return this.firstValue[t._rName]},_getId:function(t){return t._idd},setValue:function(t,e){}},function(){for(var t in{doAddLabel:1,doAddInput:1,doDestruct:1,doUnloadNestedLists:1,doAttachEvents:1,check:1,unCheck:1,isChecked:1,enable:1,disable:1,isEnabled:1,setText:1,getText:1,getValue:1,setReadonly:1,isReadonly:1,setFocus:1})dhtmlXForm.prototype.items.radio[t]=dhtmlXForm.prototype.items.checkbox[t]}(),dhtmlXForm.prototype.items.select={render:function(t,e){return t._type="se",t._enabled=!0,t._value=null,t._newValue=null,this.doAddLabel(t,e),this.doAddInput(t,e,"SELECT",null,!0,!0,"dhxform_select"),this.doAttachEvents(t),this.doLoadOpts(t,e),null!=e.connector&&this.doLoadOptsConnector(t,e.connector),void 0!==e.value&&null!=e.value&&this.setValue(t,e.value),this},destruct:function(t){for(this.doUnloadNestedLists(t),t.callEvent=null,t.checkEvent=null,t.getForm=null,t._autoCheck=null,t._enabled=null,t._idd=null,t._type=null,t._value=null,t._newValue=null,t.onselectstart=null,t.childNodes[t._ll?1:0].childNodes[0].onclick=null,t.childNodes[t._ll?1:0].childNodes[0].onkeydown=null,t.childNodes[t._ll?1:0].childNodes[0].onchange=null,t.childNodes[t._ll?1:0].childNodes[0].onfocus=null,t.childNodes[t._ll?1:0].childNodes[0].onblur=null,t.childNodes[t._ll?1:0].childNodes[0].onkeyup=null,t.childNodes[t._ll?1:0].removeChild(t.childNodes[t._ll?1:0].childNodes[0]);t.childNodes.length>0;)t.removeChild(t.childNodes[0]);t.parentNode.removeChild(t),t=null},doAddLabel:function(t,e){var n=document.createElement("DIV");n.className="dhxform_label "+e.labelAlign,n.innerHTML="<label for='"+e.uid+"'>"+e.label+(e.info?"<span class='dhxform_info'>[?]</span>":"")+(t._required?"<span class='dhxform_item_required'>*</span>":"")+"</label>",1==e.wrap&&(n.style.whiteSpace="normal"),void 0!==e.tooltip&&(n.title=e.tooltip),t.appendChild(n),void 0!==e.label&&null!=e.label&&0!=e.label.length||(n.style.display="none"),isNaN(e.labelWidth)||(n.style.width=parseInt(e.labelWidth)+"px"),isNaN(e.labelHeight)||(n.style.height=parseInt(e.labelHeight)+"px"),isNaN(e.labelLeft)||(n.style.left=parseInt(e.labelLeft)+"px"),isNaN(e.labelTop)||(n.style.top=parseInt(e.labelTop)+"px"),e.info&&(n.onclick=function(t){var e=(t=t||event).target||t.srcElement;if(void 0!==e.className&&"dhxform_info"==e.className)return this.parentNode.callEvent("onInfo",[this.parentNode._idd,t]),t.cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1})},doAttachEvents:function(t){var e=t.childNodes[t._ll?1:0].childNodes[0],n=this;e.onclick=function(){n.doOnChange(this)},e.onkeydown=function(t){t=t||event,n.doOnChange(this),this.parentNode.parentNode.callEvent("onKeyDown",[this,t,this.parentNode.parentNode._idd])},e.onchange=function(){n.doOnChange(this)},e.onkeyup=function(t){t=t||event,this.parentNode.parentNode.callEvent("onKeyUp",[this,t,this.parentNode.parentNode._idd])},e=null,this.doAttachChangeLS(t)},doAttachChangeLS:function(t){var e=t.childNodes[t._ll?1:0].childNodes[0];e.onfocus=function(){var t=this.parentNode.parentNode;t.getForm()._ccActivate(t._idd,this,t.getForm().getItemValue(t._idd,!0)),t.getForm().callEvent("onFocus",[t._idd]),t=null},e.onblur=function(){var t=this.parentNode.parentNode;t.getForm()._ccDeactivate(t._idd),t.getForm().callEvent("onBlur",[t._idd]),t=null},e=null},doValidate:function(t){t.getForm().live_validate&&this._validate(t)},doLoadOpts:function(t,e,n){for(var i=t.childNodes[t._ll?1:0].childNodes[0],a=e.options,o=!1,r=0;r<a.length;r++){var s=a[r].text||a[r].label;s&&void 0!==s||(s="");var l=new Option(s,a[r].value);"string"==typeof a[r].img_src&&l.setAttribute("img_src",a[r].img_src),i.options.add(l),void 0!==a[r].selected&&1==window.dhx4.s2b(a[r].selected)&&(l.selected=!0,t._value=a[r].value,o=!0),void 0!==a[r].checked&&1==window.dhx4.s2b(a[r].checked)&&l.setAttribute("checked","1"),void 0!==a[r].img&&l.setAttribute("img",a[r].img),void 0!==a[r].img_dis&&l.setAttribute("img_dis",a[r].img_dis),void 0!==a[r].css&&l.setAttribute("css",a[r].css)}!o&&i.selectedIndex>=0&&(t._value=i.options[i.selectedIndex].value),!0===n&&t.callEvent("onOptionsLoaded",[t._idd]),this._checkNoteWidth(t)},doLoadOptsConnector:function(t,e){var n=this;t._connector_working=!0,window.dhx4.ajax.get(e,function(e){var i=e.xmlDoc.responseText;if(0===i.indexOf("{")){var a=JSON.parse(i);n.doLoadOpts(t,a,!0)}else{if(null==(e=e.xmlDoc.responseXML))return;var o=e.getElementsByTagName("data");if(null==o||null==o[0])return;o=o[0];for(var r=[],s=0;s<o.childNodes.length;s++)if(void 0!==o.childNodes[s].tagName&&"item"==String(o.childNodes[s].tagName).toLowerCase()){var l=o.childNodes[s];r.push({label:l.getAttribute("label"),value:l.getAttribute("value"),selected:null!=l.getAttribute("selected")}),l=null}n.doLoadOpts(t,{options:r},!0)}t._connector_working=!1,null!=t._connector_value&&(n.setValue(t,t._connector_value),t._connector_value=null),n=t=null})},doOnChange:function(t){var e=t.parentNode.parentNode;if(e._newValue=t.selectedIndex>=0?t.options[t.selectedIndex].value:null,e._newValue!=e._value){if(e.checkEvent("onBeforeChange")&&!0!==e.callEvent("onBeforeChange",[e._idd,e._value,e._newValue])){for(var n=0;n<t.options.length;n++)t.options[n].value==e._value&&(t.options[n].selected=!0);return}e._value=e._newValue,e.callEvent("onChange",[e._idd,e._value]),"se"==e._type&&e.getForm().live_validate&&this._validate(e)}e._autoCheck()},setText:function(t,e){e||(e=""),t.childNodes[t._ll?0:1].childNodes[0].innerHTML=e+(t._required?"<span class='dhxform_item_required'>*</span>":""),t.childNodes[t._ll?0:1].style.display=0==e.length||null==e?"none":""},getText:function(t){return t.childNodes[t._ll?0:1].childNodes[0].innerHTML.replace(/<span class=\"dhxform_item_required\">[^<]*<\/span>/g,"")},enable:function(t){String(t.className).search("disabled")>=0&&(t.className=String(t.className).replace(/disabled/gi,"")),t._enabled=!0,t.childNodes[t._ll?1:0].childNodes[0].removeAttribute("disabled")},disable:function(t){String(t.className).search("disabled")<0&&(t.className+=" disabled"),t._enabled=!1,t.childNodes[t._ll?1:0].childNodes[0].setAttribute("disabled",!0)},getOptions:function(t){return t.childNodes[t._ll?1:0].childNodes[0].options},setValue:function(t,e){if(t._connector_working)t._connector_value=e;else{for(var n=this.getOptions(t),i=0;i<n.length;i++)n[i].value==e&&(n[i].selected=!0,t._value=n[i].value);null!=t._list&&t._list.length>0&&t.getForm()._autoCheck(),t.getForm()._ccReload(t._idd,t._value)}},getValue:function(t){for(var e=-1,n=this.getOptions(t),i=0;i<n.length;i++)n[i].selected&&(e=n[i].value);return e},setWidth:function(t,e){t.childNodes[t._ll?1:0].childNodes[0].style.width=e+"px"},getSelect:function(t){return t.childNodes[t._ll?1:0].childNodes[0]},setFocus:function(t){t.childNodes[t._ll?1:0].childNodes[0].focus()},_checkNoteWidth:function(t){var e;null!=t.childNodes[t._ll?1:0].childNodes[1]&&null!=(e=t.childNodes[t._ll?1:0].childNodes[1]).className&&e.className.search(/dhxform_note/gi)>=0&&"auto"==e._w&&(e.style.width=t.childNodes[t._ll?1:0].childNodes[0].offsetWidth+"px"),e=null}},function(){for(var t in{doAddInput:1,doUnloadNestedLists:1,isEnabled:1})dhtmlXForm.prototype.items.select[t]=dhtmlXForm.prototype.items.checkbox[t]}(),dhtmlXForm.prototype.items.multiselect={doLoadOpts:function(t,e,n){var i=t.childNodes[t._ll?1:0].childNodes[0];i.multiple=!0,isNaN(e.size)||(i.size=Number(e.size)),t._value=[],t._newValue=[];for(var a=e.options,o=0;o<a.length;o++){var r=new Option(a[o].text||a[o].label,a[o].value);i.options.add(r),1!=a[o].selected&&"true"!=a[o].selected||(r.selected=!0,t._value.push(a[o].value))}!0===n&&t.callEvent("onOptionsLoaded",[t._idd]),this._checkNoteWidth(t)},doAttachEvents:function(t){var e=t.childNodes[t._ll?1:0].childNodes[0],n=this;e.onfocus=function(){n.doOnChange(this);var t=this.parentNode.parentNode;t.getForm().callEvent("onFocus",[t._idd]),t=null},e.onblur=function(){n.doOnChange(this);var t=this.parentNode.parentNode;t.getForm().callEvent("onBlur",[t._idd]),t=null},e.onclick=function(){n.doOnChange(this);var t=this.parentNode.parentNode;t._autoCheck(),t=null}},doOnChange:function(t){var e=t.parentNode.parentNode;e._newValue=[];for(var n=0;n<t.options.length;n++)t.options[n].selected&&e._newValue.push(t.options[n].value);if(e._value.sort().toString()!=e._newValue.sort().toString()){if(e.checkEvent("onBeforeChange")&&!0!==e.callEvent("onBeforeChange",[e._idd,e._value,e._newValue])){var i={};for(n=0;n<e._value.length;n++)i[e._value[n]]=!0;for(n=0;n<t.options.length;n++)t.options[n].selected=1==i[t.options[n].value];return void(i=null)}e._value=[];for(n=0;n<e._newValue.length;n++)e._value.push(e._newValue[n]);e.callEvent("onChange",[e._idd,e._value])}e._autoCheck()},setValue:function(t,e){var n={};"string"==typeof e&&(e=e.split(",")),"object"!=typeof e&&(e=[e]);for(var i=0;i<e.length;i++)n[e[i]]=!0;var a=this.getOptions(t);for(i=0;i<a.length;i++)a[i].selected=1==n[a[i].value];t._autoCheck()},getValue:function(t){for(var e=[],n=this.getOptions(t),i=0;i<n.length;i++)n[i].selected&&e.push(n[i].value);return e}},function(){for(var t in dhtmlXForm.prototype.items.select)dhtmlXForm.prototype.items.multiselect[t]||(dhtmlXForm.prototype.items.multiselect[t]=dhtmlXForm.prototype.items.select[t])}(),dhtmlXForm.prototype.items.input={render:function(t,e){var n=!isNaN(e.rows);if(t._type="ta",t._enabled=!0,this.doAddLabel(t,e),this.doAddInput(t,e,n?"TEXTAREA":"INPUT",n?null:"TEXT",!0,!0,"dhxform_textarea"),this.doAttachEvents(t),n&&(t.childNodes[t._ll?1:0].childNodes[0].rows=Number(e.rows)+(window.dhx4.isIE6?1:0)),void 0!==e.numberFormat){var i,a=null,o=null;"string"!=typeof e.numberFormat?(i=e.numberFormat[0],a=e.numberFormat[1]||null,o=e.numberFormat[2]||null):(i=e.numberFormat,"string"==typeof e.groupSep&&(a=e.groupSep),"string"==typeof e.decSep&&(o=e.decSep)),this.setNumberFormat(t,i,a,o,!1)}return this.setValue(t,e.value),this},doAttachEvents:function(t){var e=t.childNodes[t._ll?1:0].childNodes[0];if(void 0!==e.tagName&&1=={input:1,textarea:1,select:1}[e.tagName.toLowerCase()]){var n=this;e.onfocus=function(){var t=this.parentNode.parentNode;null!=t._df&&(this.value=t._value||""),t.getForm()._ccActivate(t._idd,this,this.value),t.getForm().callEvent("onFocus",[t._idd]),t=null},e.onblur=function(){var t=this.parentNode.parentNode;t.getForm()._ccDeactivate(t._idd),n.updateValue(t,!0),t.getForm().live_validate&&n._validate(t),t.getForm().callEvent("onBlur",[t._idd]),t=null}}e=null},updateValue:function(t,e){var n=t.childNodes[t._ll?1:0].childNodes[0].value,i=t.getForm(),a=1==i._ccActive&&null!=i._formLS&&null!=i._formLS[t._idd];if(i=null,(a||null==t._df||n!=window.dhx4.template._getFmtValue(t._value,t._df))&&(e||null==t._df||t._value!=n||n!=window.dhx4.template._getFmtValue(n,t._df))){if(t._value!=n)return t.checkEvent("onBeforeChange")&&!0!==t.callEvent("onBeforeChange",[t._idd,t._value,n])?void(null!=t._df?this.setValue(t,t._value):t.childNodes[t._ll?1:0].childNodes[0].value=t._value):(null!=t._df&&e?this.setValue(t,n):t._value=n,void t.callEvent("onChange",[t._idd,n]));null!=t._df&&e&&this.setValue(t,t._value)}},setValue:function(t,e){t._value=void 0!==e&&null!=e?e:"";var n=String(t._value)||"",i=t.childNodes[t._ll?1:0].childNodes[0];null!=t._df&&(n=window.dhx4.template._getFmtValue(n,t._df)),i.value!=n&&(i.value=n,t.getForm()._ccReload(t._idd,n)),i=null},getValue:function(t){var e=t.getForm();return e._formLS&&null!=e._formLS[t._idd]&&this.updateValue(t),e=null,void 0!==t._value&&null!=t._value?t._value:""},setReadonly:function(t,e){t._ro=!0===e,t._ro?t.childNodes[t._ll?1:0].childNodes[0].setAttribute("readOnly","true"):t.childNodes[t._ll?1:0].childNodes[0].removeAttribute("readOnly")},isReadonly:function(t){return t._ro||(t._ro=!1),t._ro},getInput:function(t){return t.childNodes[t._ll?1:0].childNodes[0]},setNumberFormat:function(t,e,n,i,a){if("boolean"!=typeof a&&(a=!0),""==e)return t._df=null,a&&this.setValue(t,t._value),!0;if("string"==typeof e){var o=window.dhx4.template._parseFmt(e,n,i);return 0!=o&&(t._df=o,a&&this.setValue(t,t._value),!0)}}},function(){for(var t in{doAddLabel:1,doAddInput:1,destruct:1,doUnloadNestedLists:1,setText:1,getText:1,enable:1,disable:1,isEnabled:1,setWidth:1,setFocus:1})dhtmlXForm.prototype.items.input[t]=dhtmlXForm.prototype.items.select[t]}(),dhtmlXForm.prototype.items.password={render:function(t,e){return t._type="pw",t._enabled=!0,this.doAddLabel(t,e),this.doAddInput(t,e,"INPUT","PASSWORD",!0,!0,"dhxform_textarea"),this.doAttachEvents(t),this.setValue(t,e.value),this}},function(){for(var t in{doAddLabel:1,doAddInput:1,doAttachEvents:1,destruct:1,doUnloadNestedLists:1,setText:1,getText:1,setValue:1,getValue:1,updateValue:1,enable:1,disable:1,isEnabled:1,setWidth:1,setReadonly:1,isReadonly:1,setFocus:1,getInput:1})dhtmlXForm.prototype.items.password[t]=dhtmlXForm.prototype.items.input[t]}(),dhtmlXForm.prototype.items.file={render:function(t,e){t._type="fl",t._enabled=!0,this.doAddLabel(t,e),this.doAddInput(t,e,"INPUT","FILE",!0,!1,"dhxform_textarea");var n=t.childNodes[t._ll?1:0].childNodes[0],i=this;return n.onfocus=function(){var t=this.parentNode.parentNode;t.getForm().callEvent("onFocus",[t._idd]),t=null},n.onblur=function(){var t=this.parentNode.parentNode;t.getForm().live_validate&&i._validate(t),t.getForm().callEvent("onBlur",[t._idd]),t=null},n=null,t.childNodes[t._ll?1:0].childNodes[0].onchange=function(){t.callEvent("onChange",[t._idd,this.value])},this},setValue:function(){},getValue:function(t){return t.childNodes[t._ll?1:0].childNodes[0].value}},function(){for(var t in{doAddLabel:1,doAddInput:1,destruct:1,doUnloadNestedLists:1,setText:1,getText:1,getInput:1,enable:1,disable:1,isEnabled:1,setWidth:1})dhtmlXForm.prototype.items.file[t]=dhtmlXForm.prototype.items.input[t]}(),dhtmlXForm.prototype.items.label={_index:!1,render:function(t,e){t._type="lb",t._enabled=!0,t._checked=!0;var n=document.createElement("DIV");return n.className="dhxform_txt_label2"+(e._isTopmost?" topmost":""),n.innerHTML=e.label,t.appendChild(n),1==e.hidden&&this.hide(t),1==e.disabled&&this.userDisable(t),isNaN(e.labelWidth)||(n.style.width=parseInt(e.labelWidth)+"px"),isNaN(e.labelHeight)||(n.style.height=parseInt(e.labelHeight)+"px"),isNaN(e.labelLeft)||(n.style.left=parseInt(e.labelLeft)+"px"),isNaN(e.labelTop)||(n.style.top=parseInt(e.labelTop)+"px"),this},destruct:function(t){this.doUnloadNestedLists(t),t._autoCheck=null,t._enabled=null,t._type=null,t.callEvent=null,t.checkEvent=null,t.getForm=null,t.onselectstart=null,t.parentNode.removeChild(t),t=null},enable:function(t){String(t.className).search("disabled")>=0&&(t.className=String(t.className).replace(/disabled/gi,"")),t._enabled=!0},disable:function(t){String(t.className).search("disabled")<0&&(t.className+=" disabled"),t._enabled=!1},setText:function(t,e){t.firstChild.innerHTML=e},getText:function(t){return t.firstChild.innerHTML}},function(){for(var t in{doUnloadNestedLists:1,isEnabled:1})dhtmlXForm.prototype.items.label[t]=dhtmlXForm.prototype.items.checkbox[t]}(),dhtmlXForm.prototype.items.button={render:function(t,e){if(t._type="bt",t._enabled=!0,t._name=e.name,t.className=String(t.className).replace("item_label_top","item_label_left").replace("item_label_right","item_label_left"),t._doOnKeyUpDown=function(t,e){this.callEvent(t,[this.childNodes[0].childNodes[0],e,this._idd])},t.innerHTML='<div class="dhxform_btn" role="link" tabindex="0" dir="ltr"><div class="dhxform_btn_txt">'+e.value+'</div><div class="dhxform_btn_filler" disabled="true"></div></div>',!isNaN(e.width)){var n=Math.max(e.width,10);null==dhtmlXForm.prototype.items[this.t]._dim&&(t.firstChild.style.width=n+"px",dhtmlXForm.prototype.items[this.t]._dim=t.getForm()._checkDim(t,t.firstChild)),t.firstChild.style.width=n-dhtmlXForm.prototype.items[this.t]._dim+"px",t.firstChild.firstChild.className+=" dhxform_btn_txt_autowidth"}return isNaN(e.inputLeft)||(t.childNodes[0].style.left=parseInt(e.inputLeft)+"px"),isNaN(e.inputTop)||(t.childNodes[0].style.top=parseInt(e.inputTop)+"px"),1==e.hidden&&this.hide(t),1==e.disabled&&this.userDisable(t),void 0!==e.tooltip&&(t.firstChild.title=e.tooltip),t.onselectstart=function(t){return(t=t||event).cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1},t.firstChild.onselectstart=function(t){return(t=t||event).cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,!1},t.firstChild.onkeypress=function(t){if((32==(t=t||event).keyCode||32==t.charCode||13==t.keyCode||13==t.charCode)&&!this.parentNode._busy)return this.parentNode._busy=!0,t.cancelBubble=!0,t.preventDefault?t.preventDefault():t.returnValue=!1,_dhxForm_doClick(this.childNodes[0],["mousedown","mouseup"]),!1},t.firstChild.onfocus=function(){this.parentNode._doOnFocus(this.parentNode)},t.firstChild.onblur=function(){_dhxForm_doClick(this.childNodes[0],"mouseout"),this.parentNode._doOnBlur(this.parentNode)},t.firstChild.onkeyup=function(t){this.parentNode._doOnKeyUpDown("onKeyUp",t||event)},t.firstChild.onkeydown=function(t){this.parentNode._doOnKeyUpDown("onKeyDown",t||event)},t.firstChild.onmouseover=function(){var t=this.parentNode;t._enabled&&(this._isOver=!0,this.className="dhxform_btn dhxform_btn_over",t=null)},t.firstChild.onmouseout=function(){var t=this.parentNode;t._enabled&&(this.className="dhxform_btn",this._allowClick=!1,this._pressed=!1,this._isOver=!1,t=null)},t.firstChild.ontouchstart=t.firstChild.onmousedown=function(t){if("touchstart"==(t=t||event).type&&t.preventDefault&&t.preventDefault(),!(t.button>=2||this._pressed)){var e=this.parentNode;e._enabled&&(this.className="dhxform_btn dhxform_btn_pressed",this._allowClick=!0,this._pressed=!0,e=null)}},t.firstChild.ontouchend=t.firstChild.onmouseup=function(t){if(!((t=t||event).button>=2)&&this._pressed){var e=this.parentNode;e._enabled&&(e._busy=!1,this.className="dhxform_btn"+(this._isOver?" dhxform_btn_over":""),this._pressed&&this._allowClick&&e.callEvent("_onButtonClick",[e._name,e._cmd]),this._allowClick=!1,this._pressed=!1,e=null)}},t._doOnFocus=function(t){t.getForm().callEvent("onFocus",[t._idd])},t._doOnBlur=function(t){t.getForm().callEvent("onBlur",[t._idd])},this},destruct:function(t){for(this.doUnloadNestedLists(t),t.callEvent=null,t.checkEvent=null,t.getForm=null,t._autoCheck=null,t._type=null,t._enabled=null,t._cmd=null,t._name=null,t._doOnFocus=null,t._doOnBlur=null,t._doOnKeyUpDown=null,t.onselectstart=null,t.firstChild.onselectstart=null,t.firstChild.onkeypress=null,t.firstChild.ontouchstart=null,t.firstChild.ontouchend=null,t.firstChild.onfocus=null,t.firstChild.onblur=null,t.firstChild.onkeyup=null,t.firstChild.onkeydown=null,t.firstChild.onmouseover=null,t.firstChild.onmouseout=null,t.firstChild.onmousedown=null,t.firstChild.onmouseup=null;t.childNodes.length>0;)t.removeChild(t.childNodes[0]);t.parentNode.removeChild(t),t=null},enable:function(t){String(t.className).search("disabled")>=0&&(t.className=String(t.className).replace(/disabled/gi,"")),t._enabled=!0,t.childNodes[0].removeAttribute("disabled"),t.childNodes[0].setAttribute("role","link"),t.childNodes[0].setAttribute("tabIndex","0")},disable:function(t){String(t.className).search("disabled")<0&&(t.className+=" disabled"),t._enabled=!1,t.childNodes[0].setAttribute("disabled","true"),t.childNodes[0].removeAttribute("role"),t.childNodes[0].removeAttribute("tabIndex")},setText:function(t,e){t.childNodes[0].childNodes[0].innerHTML=e},getText:function(t){return t.childNodes[0].childNodes[0].innerHTML},setFocus:function(t){t.childNodes[0].focus()}},function(){for(var t in{doUnloadNestedLists:1,isEnabled:1})dhtmlXForm.prototype.items.button[t]=dhtmlXForm.prototype.items.checkbox[t]}(),dhtmlXForm.prototype.items.hidden={_index:!1,render:function(t,e){t.style.display="none",t._name=e.name,t._type="hd",t._enabled=!0;var n=document.createElement("INPUT");return n.type="HIDDEN",n.name=e.name,n.value=e.value||"",t.appendChild(n),this},destruct:function(t){for(this.doUnloadNestedLists(t);t.childNodes.length>0;)t.removeChild(t.childNodes[0]);t._autoCheck=null,t._name=null,t._type=null,t._enabled=null,t.onselectstart=null,t.callEvent=null,t.checkEvent=null,t.getForm=null,t.parentNode.removeChild(t),t=null},enable:function(t){t._enabled=!0,t.childNodes[0].setAttribute("name",t._name)},disable:function(t){t._enabled=!1,t.childNodes[0].removeAttribute("name")},show:function(){},hide:function(){},isHidden:function(){return!0},setValue:function(t,e){t.childNodes[0].value=e},getValue:function(t){return t.childNodes[0].value},getInput:function(t){return t.childNodes[0]}},function(){for(var t in{doUnloadNestedLists:1,isEnabled:1})dhtmlXForm.prototype.items.hidden[t]=dhtmlXForm.prototype.items.checkbox[t]}(),dhtmlXForm.prototype.items.list={_index:!1,render:function(t,e){return t._type="list",t._enabled=!0,t._isNestedForm=!0,t.style.paddingLeft=t._ofsNested+"px",t.className="dhxform_base_nested"+(t._custom_css||""),[this,new dhtmlXForm(t,null,e)]},destruct:function(t){}},dhtmlXForm.prototype.items.fieldset={_index:!1,render:function(t,e){t._type="fs",parseInt(e.inputWidth),t._width=e.width,t._enabled=!0,t._checked=!0,t.className="fs_"+e.position+("string"==typeof e.className?" "+e.className:"");var n=document.createElement("FIELDSET");n.className="dhxform_fs";var i=String(e.labelAlign).replace("align_","");if(n.innerHTML="<legend class='fs_legend' align='"+i+"' style='text-align:"+i+"'>"+e.label+"</legend>",t.appendChild(n),isNaN(e.inputLeft)||(n.style.left=parseInt(e.inputLeft)+"px"),isNaN(e.inputTop)||(n.style.top=parseInt(e.inputTop)+"px"),"auto"!=e.inputWidth&&!isNaN(e.inputWidth)){n.style.width=parseInt(e.inputWidth)+"px";var a=parseInt(n.style.width);n.offsetWidth>a&&(n.style.width=a+(a-n.offsetWidth)+"px")}return t._addSubListNode=function(){var t=document.createElement("DIV");return t._custom_css=" dhxform_fs_nested",this.childNodes[0].appendChild(t),t},1==e.hidden&&this.hide(t),1==e.disabled&&this.userDisable(t),this},destruct:function(t){for(this.doUnloadNestedLists(t),t._checked=null,t._enabled=null,t._idd=null,t._type=null,t._width=null,t.onselectstart=null,t._addSubListNode=null,t._autoCheck=null,t.callEvent=null,t.checkEvent=null,t.getForm=null;t.childNodes.length>0;)t.removeChild(t.childNodes[0]);t.parentNode.removeChild(t),t=null},setText:function(t,e){t.childNodes[0].childNodes[0].innerHTML=e},getText:function(t){return t.childNodes[0].childNodes[0].innerHTML},enable:function(t){t._enabled=!0,String(t.className).search("disabled")>=0&&(t.className=String(t.className).replace(/disabled/gi,""))},disable:function(t){t._enabled=!1,String(t.className).search("disabled")<0&&(t.className+=" disabled")},setWidth:function(t,e){t.childNodes[0].style.width=e+"px",t._width=e},getWidth:function(t){return t._width}},function(){for(var t in{doUnloadNestedLists:1,isEnabled:1})dhtmlXForm.prototype.items.fieldset[t]=dhtmlXForm.prototype.items.checkbox[t]}(),dhtmlXForm.prototype.items.block={_index:!1,render:function(t,e){t._type="bl",t._width=e.width,t._enabled=!0,t._checked=!0,t.className="block_"+e.position+("string"==typeof e.className?" "+e.className:"");var n=document.createElement("DIV");return n.className="dhxform_obj_"+t.getForm().skin+" dhxform_block",n.style.fontSize=t.getForm().cont.style.fontSize,e.style&&(n.style.cssText=e.style),void 0!==e.id&&(n.id=e.id),t.appendChild(n),isNaN(e.inputLeft)||(n.style.left=parseInt(e.inputLeft)+"px"),isNaN(e.inputTop)||(n.style.top=parseInt(e.inputTop)+"px"),"auto"!=e.inputWidth&&(isNaN(e.inputWidth)||(n.style.width=parseInt(e.inputWidth)+"px")),isNaN(e.blockOffset)||(t._ofsNested=e.blockOffset),t._addSubListNode=function(){var t=document.createElement("DIV");return t._inBlcok=!0,void 0!==this._ofsNested&&(t._ofsNested=this._ofsNested),this.childNodes[0].appendChild(t),t},1==e.hidden&&this.hide(t),1==e.disabled&&this.userDisable(t),this},_setCss:function(t,e,n){t.firstChild.className="dhxform_obj_"+e+" dhxform_block",t.firstChild.style.fontSize=n}},function(){for(var t in{enable:1,disable:1,isEnabled:1,setWidth:1,getWidth:1,doUnloadNestedLists:1,destruct:1})dhtmlXForm.prototype.items.block[t]=dhtmlXForm.prototype.items.fieldset[t]}(),dhtmlXForm.prototype.items.newcolumn={_index:!1},dhtmlXForm.prototype.items.template={render:function(t,e){isNaN(e.rows);return t._type="tp",t._enabled=!0,null!=e.format&&("function"==typeof e.format?t.format=e.format:"string"==typeof e.format&&"function"==typeof window[e.format]&&(t.format=window[e.format])),null==t.format&&(t.format=function(t,e){return e}),this.doAddLabel(t,e),this.doAddInput(t,e,"DIV",null,!0,!0,"dhxform_item_template"),this.setValue(t,e.value||""),this},destruct:function(t){t.format=null,this.d2(t),t=null},setValue:function(t,e){t._value=e,t.childNodes[t._ll?1:0].childNodes[0].innerHTML=t.format(t._idd,t._value)},getValue:function(t){return t._value},enable:function(t){String(t.className).search("disabled")>=0&&(t.className=String(t.className).replace(/disabled/gi,"")),t._enabled=!0},disable:function(t){String(t.className).search("disabled")<0&&(t.className+=" disabled"),t._enabled=!1}},function(){for(var t in dhtmlXForm.prototype.items.template.d2=dhtmlXForm.prototype.items.input.destruct,{doAddLabel:1,doAddInput:1,doUnloadNestedLists:1,setText:1,getText:1,isEnabled:1,setWidth:1})dhtmlXForm.prototype.items.template[t]=dhtmlXForm.prototype.items.select[t]}(),dhtmlXForm.prototype._ulToObject=function(t,e){for(var n=[],i=0;i<t.childNodes.length;i++){if("li"==String(t.childNodes[i].tagName||"").toLowerCase()){for(var a={},o=t.childNodes[i],r=0;r<e.length;r++)null!=o.getAttribute(e[r])&&(a[String(e[r]).replace("ftype","type")]=o.getAttribute(e[r]));if(!a.label)try{a.label=o.firstChild.nodeValue}catch(t){}var s=o.getElementsByTagName("UL");null!=s[0]&&(a["select"==a.type?"options":"list"]=dhtmlXForm.prototype._ulToObject(s[0],e));for(r=0;r<o.childNodes.length;r++)"userdata"==String(o.childNodes[r].tagName||"").toLowerCase()&&(a.userdata||(a.userdata={}),a.userdata[o.childNodes[r].getAttribute("name")]=o.childNodes[r].firstChild.nodeValue);n[n.length]=a}if("div"==String(t.childNodes[i].tagName||"").toLowerCase()){a={type:"label"};try{a.label=t.childNodes[i].firstChild.nodeValue}catch(t){}n[n.length]=a}}return n},dhtmlXForm.prototype.setUserData=function(t,e,n,i){if(void 0!==i){var a=this.doWithItem([t,e],"_getId");null!=a&&(t=a,e=n,n=i)}this._userdata||(this._userdata={}),this._userdata[t]=this._userdata[t]||{},this._userdata[t][e]=n},dhtmlXForm.prototype.getUserData=function(t,e,n){if(void 0!==n){var i=this.doWithItem([t,e],"_getId");null!=i&&(t=i,e=n)}return null!=this._userdata&&void 0!==this._userdata[t]&&void 0!==this._userdata[t][e]?this._userdata[t][e]:""},dhtmlXForm.prototype.setRTL=function(t){this._rtl=!0===t,this._rtl?String(this.cont).search(/dhxform_rtl/gi)<0&&(this.cont.className+=" dhxform_rtl"):String(this.cont).search(/dhxform_rtl/gi)>=0&&(this.cont.className=String(this.cont.className).replace(/dhxform_rtl/gi,""))},_dhxForm_doClick=function(t,e){if("object"==typeof e){var n=e[1];e=e[0]}var i;document.createEvent?((i=document.createEvent("MouseEvents")).initEvent(e,!0,!1),t.dispatchEvent(i)):document.createEventObject&&((i=document.createEventObject()).button=1,t.fireEvent("on"+e,i));n&&window.setTimeout(function(){_dhxForm_doClick(t,n)},100)},dhtmlXForm.prototype.setFormData=function(t){for(var e in t){var n=this.getItemType(e);switch(n){case"checkbox":this[1==t[e]||1==parseInt(t[e])||"true"==t[e]||t[e]==this.getItemValue(e,"realvalue")?"checkItem":"uncheckItem"](e);break;case"radio":this.checkItem(e,t[e]);break;case"input":case"textarea":case"password":case"select":case"multiselect":case"hidden":case"template":case"combo":case"calendar":case"colorpicker":case"editor":this.setItemValue(e,t[e]);break;default:this["setFormData_"+n]?this["setFormData_"+n](e,t[e]):(this.hId||(this.hId=this._genStr(12)),this.setUserData(this.hId,e,t[e]))}}},dhtmlXForm.prototype.getFormData=function(t,e){var n={};for(var i in this.itemPull){var a=this.itemPull[i]._idd,o=this.itemPull[i]._type;if("ch"==o&&(n[a]=this.isItemChecked(a)?this.getItemValue(a):0),"ra"!=o||n[this.itemPull[i]._group]||(n[this.itemPull[i]._group]=this.getCheckedValue(this.itemPull[i]._group)),o in{se:1,ta:1,pw:1,hd:1,tp:1,fl:1,calendar:1,combo:1,editor:1,colorpicker:1}&&(n[a]=this.getItemValue(a,t)),this["getFormData_"+o]&&(n[a]=this["getFormData_"+o](a)),"up"==o){var r=this.getItemValue(a);for(var s in r)n[s]=r[s]}if(this.itemPull[i]._list)for(var l=0;l<this.itemPull[i]._list.length;l++){var d=this.itemPull[i]._list[l].getFormData(t,e);for(var c in d)n[c]=d[c]}}if(!e&&this.hId&&this._userdata[this.hId])for(var i in this._userdata[this.hId])n[i]||(n[i]=this._userdata[this.hId][i]);return n},dhtmlXForm.prototype.adjustParentSize=function(){for(var t=0,e=-1,n=0;n<this.base.length;n++)t+=this.base[n].firstChild.offsetWidth,this.base[n].offsetHeight>e&&(e=this.base[n].offsetHeight);var i=!1;try{if(i=1==this.cont.parentNode.parentNode.parentNode.parentNode._isCell)var a=this.cont.parentNode.parentNode.parentNode.parentNode}catch(t){}if(i&&void 0!==a)return t>0&&a.setWidth(t+10),e>0&&a.setHeight(e+a.firstChild.firstChild.offsetHeight+5),void(i=a=null);try{if(1==this.cont.parentNode.parentNode.parentNode._isWindow){var o=this.cont.parentNode.parentNode;"function"==typeof o.callEvent&&(this.cont.style.display="none",o.callEvent("_setCellSize",[t+15,e+15]),this.cont.style.display="")}}catch(t){}},dhtmlXForm.prototype.reset=function(){this.callEvent("onBeforeReset",[this.formId,this.getFormData()])&&(this._last_load_data&&this.setFormData(this._last_load_data),this.callEvent("onAfterReset",[this.formId]))},dhtmlXForm.prototype.send=function(t,e,n,i){if("function"==typeof e?(n=e,e="post"):e="get"==e?"get":"post",!0===i||this.validate()){var a=this.getFormData(!0),o=[];for(var r in a)o.push(r+"="+encodeURIComponent(a[r]));var s=function(t){n&&n.call(this,t,t.xmlDoc.responseText)};"get"==e?window.dhx4.ajax.get(t+(-1==t.indexOf("?")?"?":"&")+o.join("&"),s):window.dhx4.ajax.post(t,o.join("&"),s)}},dhtmlXForm.prototype.save=function(t,e){},dhtmlXForm.prototype.dummy=function(){},dhtmlXForm.prototype._changeFormId=function(t,e){this.formId=e},dhtmlXForm.prototype._dp_init=function(t){t._methods=["dummy","dummy","_changeFormId","dummy"],t._getRowData=function(t,e){var n=this.obj.getFormData(!0);return n[this.action_param]=this.obj.getUserData(t,this.action_param),n},t._clearUpdateFlag=function(){},t.attachEvent("onAfterUpdate",function(t,e,n,i){return"inserted"!=e&&"updated"!=e&&"error"!=e&&"invalid"!=e||this.obj.resetDataProcessor("updated"),"inserted"!=e&&"updated"!=e||(this.obj._last_load_data=this.obj.getFormData(!0)),this.obj.callEvent("onAfterSave",[this.obj.formId,i]),!0}),t.autoUpdate=!1,t.setTransactionMode("POST",!0),this.dp=t,this.formId=(new Date).valueOf(),this.resetDataProcessor("inserted"),this.save=function(){this.callEvent("onBeforeSave",[this.formId,this.getFormData()])&&this.validate()&&t.sendData()}},dhtmlXForm.prototype.resetDataProcessor=function(t){this.dp&&(this.dp.updatedRows=[],this.dp._in_progress=[],this.dp.setUpdated(this.formId,!0,t))},dhtmlXForm.prototype._ccActivate=function(t,e,n){this._formLS||(this._formLS={}),this._formLS[t]||(this._formLS[t]={input:e,value:n}),this._ccActive||(this._ccActive=!0,this._ccDo()),e=null},dhtmlXForm.prototype._ccDeactivate=function(t){this._ccTm&&window.clearTimeout(this._ccTm),this._ccActive=!1,null!=this._formLS&&null!=this._formLS[t]&&(this._formLS[t].input=null,this._formLS[t]=null,delete this._formLS[t])},dhtmlXForm.prototype._ccDo=function(){for(var t in this._ccTm&&window.clearTimeout(this._ccTm),this._formLS){var e=this._formLS[t].input;if("select"==String(e.tagName).toLowerCase()){var n="";e.selectedIndex>=0&&e.selectedIndex<e.options.length&&(n=e.options[e.selectedIndex].value)}else n=e.value;n!=this._formLS[t].value&&(this._formLS[t].value=n,this.callEvent("onInputChange",[e._idd,n,this])),e=null}if(this._ccActive){var i=this;this._ccTm=window.setTimeout(function(){i._ccDo(),i=null},100)}},dhtmlXForm.prototype._ccReload=function(t,e){this._formLS&&this._formLS[t]&&(this._formLS[t].value=e)},dhtmlXForm.prototype._checkDim=function(t,e){var n=document.createElement("DIV");n.className="dhxform_obj_"+this.skin,n.style.cssText+=1==dhx4.isIE6?"visibility:hidden;":"position:absolute;left:-2000px;top:-1000px;",document.body.appendChild(n);var i=t.parentNode,a=t.nextSibling;n.appendChild(t);var o=parseInt(e.style.width),r=(dhx4.isFF||dhx4.isIE||dhx4.isChrome||dhx4.isOpera?e.offsetWidth:e.clientWidth)-o;return null!=a?i.insertBefore(t,a):i.appendChild(t),n.parentNode.removeChild(n),i=a=n=t=e=null,r},c=["ftype","name","value","label","check","checked","disabled","text","rows","select","selected","width","style","className","labelWidth","labelHeight","labelLeft","labelTop","inputWidth","inputHeight","inputLeft","inputTop","position","size"],dhtmlXForm.prototype.loadStructHTML=function(t){t="string"==typeof t?document.getElementById(t):t,this.loadStruct(this._ulToObject(t,c))},dhtmlXForm.prototype._autoload=function(){for(var t=document.getElementsByTagName("UL"),e=[],n=0;n<t.length;n++)if("dhtmlxForm"==t[n].className){var i=document.createElement("DIV");e[e.length]={nodeUL:t[n],nodeForm:i,data:dhtmlXForm.prototype._ulToObject(t[n],c),name:t[n].getAttribute("name")||null}}for(n=0;n<e.length;n++){e[n].nodeUL.parentNode.insertBefore(e[n].nodeForm,e[n].nodeUL);var a=new dhtmlXForm(e[n].nodeForm,e[n].data);null!==e[n].name&&(window[e[n].name]=a);var o=e[n].nodeUL.getAttribute("oninit")||null;e[n].nodeUL.parentNode.removeChild(e[n].nodeUL),e[n].nodeUL=null,e[n].nodeForm=null,e[n].data=null,e[n]=null,o&&("function"==typeof o?o():"function"==typeof window[o]&&window[o]())}"function"==typeof window.addEventListener?window.removeEventListener("load",dhtmlXForm.prototype._autoload,!1):window.detachEvent("onload",dhtmlXForm.prototype._autoload)},"function"==typeof window.addEventListener?window.addEventListener("load",dhtmlXForm.prototype._autoload,!1):window.attachEvent("onload",dhtmlXForm.prototype._autoload),void 0!==window.dhtmlXCellObject&&(dhtmlXCellObject.prototype.attachForm=function(t){this.callEvent("_onBeforeContentAttach",["form"]);var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",window.dhtmlx&&dhtmlx.$customScroll?dhtmlx.CustomScroll.enable(e):e.style.overflow="auto",this._attachObject(e),this.dataType="form",this.dataObj=new dhtmlXForm(e,t,this.conf.skin),e=null,this.callEvent("_onContentAttach",[]),this.dataObj}),dhtmlXForm.prototype.items.combo={render:function(t,e){t._type="combo",t._enabled=!0,t._value=null,t._newValue=null;var n=t.getForm().skin;void 0!==e.inputWidth&&"material"==n&&null!=String(e.inputWidth).match(/^\d*$/)&&(e.inputWidth=parseInt(e.inputWidth)+2),this.doAddLabel(t,e),this.doAddInput(t,e,"SELECT",null,!0,!0,"dhxform_select"),this.doAttachEvents(t),this.doLoadOpts(t,e),t.onselectstart=function(t){return!0},t.childNodes[t._ll?1:0].childNodes[0].setAttribute("mode",e.comboType||""),e.comboImagePath&&t.childNodes[t._ll?1:0].childNodes[0].setAttribute("imagePath",e.comboImagePath),e.comboDefaultImage&&t.childNodes[t._ll?1:0].childNodes[0].setAttribute("defaultImage",e.comboDefaultImage),e.comboDefaultImageDis&&t.childNodes[t._ll?1:0].childNodes[0].setAttribute("defaultImageDis",e.comboDefaultImageDis),t._combo=new dhtmlXComboFromSelect(t.childNodes[t._ll?1:0].childNodes[0]),t._combo.setSkin(n),t._combo._currentComboValue=t._combo.getSelectedValue(),t._combo.getInput().id=e.uid,"material"==n&&(t._combo.list.className+=" dhxform_obj_"+n);var i=this;return t._combo.attachEvent("onChange",function(){i.doOnChange(this)}),e.connector&&this.doLoadOptsConnector(t,e.connector),e.filtering?t._combo.enableFilteringMode(!0):e.serverFiltering&&t._combo.enableFilteringMode(!0,e.serverFiltering,e.filterCache,e.filterSubLoad),1==e.readonly&&this.setReadonly(t,!0),1==e.hidden&&this.hide(t),e.style&&(t._combo.DOMelem_input.style.cssText+=e.style),t._combo.attachEvent("onFocus",function(){var t=this.cont.parentNode.parentNode,e=t.getForm();("dhx_terrace"==e.skin||"material"==e.skin)&&this.cont.className.search(/combo_in_focus/)<0&&(this.cont.className+=" combo_in_focus"),e.callEvent("onFocus",[t._idd]),e=t=null}),t._combo.attachEvent("onBlur",function(){var t=this.cont.parentNode.parentNode,e=t.getForm();("dhx_terrace"==e.skin||"material"==e.skin)&&this.cont.className.search(/combo_in_focus/)>=0&&(this.cont.className=this.cont.className.replace(/\s{0,}combo_in_focus/gi,"")),e.callEvent("onBlur",[t._idd]),e=t=null}),this},destruct:function(t){t.childNodes[t._ll?1:0].childNodes[0].onchange=null,t._combo._currentComboValue=null,t._combo.unload(),t._combo=null,t._apiChange=null,this.d2(t),t=null},doAttachEvents:function(t){var e=this;t.childNodes[t._ll?1:0].childNodes[0].onchange=function(){e.doOnChange(this),e.doValidate(this.DOMParent.parentNode.parentNode)}},doValidate:function(t){t.getForm().hot_validate&&this._validate(t)},doOnChange:function(t){var e=t.base.parentNode.parentNode.parentNode;if(!e._apiChange){if(t._newComboValue=t.getSelectedValue(),t._newComboValue!=t._currentComboValue){if(e.checkEvent("onBeforeChange")&&!0!==e.callEvent("onBeforeChange",[e._idd,t._currentComboValue,t._newComboValue]))return window.setTimeout(function(){t.setComboValue(t._currentComboValue)},1),!1;t._currentComboValue=t._newComboValue,e.callEvent("onChange",[e._idd,t._currentComboValue])}e._autoCheck()}},doLoadOptsConnector:function(t,e){var n=this,i=t;t._connector_working=!0,t._apiChange=!0,t._combo.load(e,function(){i.callEvent("onOptionsLoaded",[i._idd]),i._connector_working=!1,null!=i._connector_value&&(n.setValue(i,i._connector_value),i._connector_value=null),i._apiChange=!1,n=i=null})},enable:function(t){String(t.className).search("disabled")>=0&&(t.className=String(t.className).replace(/disabled/gi,"")),t._enabled=!0,t._combo.enable()},disable:function(t){String(t.className).search("disabled")<0&&(t.className+=" disabled"),t._enabled=!1,t._combo.disable()},getCombo:function(t){return t._combo},setValue:function(t,e){t._connector_working?t._connector_value=e:(t._apiChange=!0,t._combo.setComboValue(e),t._combo._currentComboValue=t._combo.getActualValue(),t._apiChange=!1)},getValue:function(t){return t._combo.getActualValue()},setWidth:function(t,e){t.childNodes[t._ll?1:0].childNodes[0].style.width=e+"px"},setReadonly:function(t,e){t._combo&&(t._combo_ro=e,t._combo.readonly(t._combo_ro))},isReadonly:function(t,e){return t._combo_ro||!1},setFocus:function(t){t._enabled&&t._combo.setFocus()},_setCss:function(t,e,n){t._combo.setFontSize(n,n)}},function(){for(var t in{doAddLabel:1,doAddInput:1,doLoadOpts:1,doUnloadNestedLists:1,setText:1,getText:1,isEnabled:1,_checkNoteWidth:1})dhtmlXForm.prototype.items.combo[t]=dhtmlXForm.prototype.items.select[t]}(),dhtmlXForm.prototype.items.combo.d2=dhtmlXForm.prototype.items.select.destruct,dhtmlXForm.prototype.getCombo=function(t){return this.doWithItem(t,"getCombo")},dhtmlXForm.prototype.items.calendar={render:function(t,e){var n=this;t._type="calendar",t._enabled=!0;var i=navigator.userAgent,a=i.indexOf("MSIE 6.0")>=0||i.indexOf("MSIE 7.0")>=0||i.indexOf("MSIE 8.0")>=0;this.doAddLabel(t,e),this.doAddInput(t,e,"INPUT","TEXT",!0,!0,"dhxform_textarea calendar"),this.doAttachChangeLS(t),a&&(t.childNodes[t._ll?1:0].childNodes[0].onfocus2=t.childNodes[t._ll?1:0].childNodes[0].onfocus,t.childNodes[t._ll?1:0].childNodes[0].onfocus=function(){1!=this._skipOnFocus?this.onfocus2.apply(this,arguments):this._skipOnFocus=!1}),t.childNodes[t._ll?1:0].childNodes[0]._idd=t._idd,t.childNodes[t._ll?1:0].childNodes[0].onblur=function(){var t=this.parentNode.parentNode;if(t._c.base._formMouseDown)return t._c.base._formMouseDown=!1,this._skipOnFocus=!0,this.focus(),this.value=this.value,t=null,!0;var e=t.getForm();e._ccDeactivate(t._idd),n.checkEnteredValue(this.parentNode.parentNode),e.live_validate&&n._validate(t),e.callEvent("onBlur",[t._idd]),t._c.isVisible()||(t._tempValue=null),e=t=null},t._f=e.dateFormat||null,t._f0=e.serverDateFormat||t._f;var o=t.getForm();return t._c=new dhtmlXCalendarObject(t.childNodes[t._ll?1:0].childNodes[0],e.skin||o.skin||"dhx_skyblue"),t._c._nullInInput=!0,t._c.enableListener(t.childNodes[t._ll?1:0].childNodes[0]),null!=t._f&&t._c.setDateFormat(t._f),window.dhx4.s2b(e.enableTime)||t._c.hideTime(),window.dhx4.s2b(e.enableTodayButton)&&t._c.showToday(),window.dhx4.s2b(e.showWeekNumbers)&&t._c.showWeekNumbers(),isNaN(e.weekStart)||t._c.setWeekStartDay(e.weekStart),void 0!==e.calendarPosition&&t._c.setPosition(e.calendarPosition),null!=e.minutesInterval&&t._c.setMinutesInterval(e.minutesInterval),t._c._itemIdd=t._idd,t._c.attachEvent("onBeforeChange",function(e){if(t._value!=e){if(t.checkEvent("onBeforeChange")&&!0!==t.callEvent("onBeforeChange",[t._idd,t._value,e]))return!1;t._tempValue=t._value=e,n.setValue(t,e,!1),t.callEvent("onChange",[this._itemIdd,t._value])}return!0}),t._c.attachEvent("onClick",function(){t._tempValue=null}),t._c.attachEvent("onHide",function(){t._tempValue=null}),a&&(t._c.base.onmousedown=function(){return this._formMouseDown=!0,!1}),this.setValue(t,e.value),o=null,this},getCalendar:function(t){return t._c},setSkin:function(t,e){t._c.setSkin(e)},setValue:function(t,e,n){e&&null!=e&&void 0!==e&&""!=e?(t._value=e instanceof Date?e:t._c._strToDate(e,t._f0||t._c._dateFormat),t.childNodes[t._ll?1:0].childNodes[0].value=t._c._dateToStr(t._value,t._f||t._c._dateFormat)):(t._value=null,t.childNodes[t._ll?1:0].childNodes[0].value=""),!1!==n&&t._c.setDate(t._value)},getValue:function(t,e){var n=t._tempValue||t._c.getDate();return!0===e&&null==n?"":!0===e?t._c._dateToStr(n,t._f0||t._c._dateFormat):n},setDateFormat:function(t,e,n){t._f=e,t._f0=n||t._f,t._c.setDateFormat(t._f),this.setValue(t,this.getValue(t))},destruct:function(t){t._c.disableListener(t.childNodes[t._ll?1:0].childNodes[0]),t._c.unload(),t._c=null;try{delete t._c}catch(t){}t._f=null;try{delete t._f}catch(t){}t._f0=null;try{delete t._f0}catch(t){}t.childNodes[t._ll?1:0].childNodes[0]._idd=null,t.childNodes[t._ll?1:0].childNodes[0].onblur=null,this.d2(t),t=null},checkEnteredValue:function(t){this.setValue(t,t._c.getDate())}},function(){for(var t in{doAddLabel:1,doAddInput:1,doUnloadNestedLists:1,setText:1,getText:1,enable:1,disable:1,isEnabled:1,setWidth:1,setReadonly:1,isReadonly:1,setFocus:1,getInput:1})dhtmlXForm.prototype.items.calendar[t]=dhtmlXForm.prototype.items.input[t]}(),dhtmlXForm.prototype.items.calendar.doAttachChangeLS=dhtmlXForm.prototype.items.select.doAttachChangeLS,dhtmlXForm.prototype.items.calendar.d2=dhtmlXForm.prototype.items.input.destruct,dhtmlXForm.prototype.getCalendar=function(t){return this.doWithItem(t,"getCalendar")},dhtmlXForm.prototype.setCalendarDateFormat=function(t,e,n){this.doWithItem(t,"setDateFormat",e,n)},dhtmlXForm.prototype.items.btn2state={setChecked:function(t,e){t._checked=!0===e,t.childNodes[t._ll?1:0].lastChild.className="dhxform_img "+t._cssName+"_"+(t._checked?"1":"0"),this.doCheckValue(t)}},function(){for(var t in dhtmlXForm.prototype.items.checkbox)dhtmlXForm.prototype.items.btn2state[t]||(dhtmlXForm.prototype.items.btn2state[t]=dhtmlXForm.prototype.items.checkbox[t])}(),dhtmlXForm.prototype.items.btn2state.render2=dhtmlXForm.prototype.items.btn2state.render,dhtmlXForm.prototype.items.btn2state.render=function(t,e){return e._autoInputWidth=!1,this.render2(t,e),t._type="btn2state",t._cssName=void 0===e.cssName?"btn2state":e.cssName,t._updateImgNode=function(){},t._doOnFocus=function(){t.getForm().callEvent("onFocus",[t._idd])},t._doOnBlur=function(){t.getForm().callEvent("onBlur",[t._idd])},t._doOnKeyUpDown=function(t,e,n){this.callEvent(t,[this.childNodes[this._ll?0:1].childNodes[0],e,this._idd])},this.setChecked(t,t._checked),this},dhtmlXForm.prototype.setFormData_btn2state=function(t,e){this[1==e||1==parseInt(e)||"true"==e||e==this.getItemValue(t)?"checkItem":"uncheckItem"](t)},dhtmlXForm.prototype.getFormData_btn2state=function(t){return this.isItemChecked(t)?this.getItemValue(t):0},dhtmlXForm.prototype.items.colorpicker={colorpicker:{},render:function(t,e){var n=this;t._type="colorpicker",t._enabled=!0,this.doAddLabel(t,e),this.doAddInput(t,e,"INPUT","TEXT",!0,!0,"dhxform_textarea"),t._value=e.value||"",t.childNodes[t._ll?1:0].childNodes[0].value=t._value;var i={input:t.childNodes[t._ll?1:0].childNodes[0],custom_colors:1==window.dhx4.s2b(e.enableCustomColors),skin:t.getForm().skin};return this.colorpicker[t._idd]=new dhtmlXColorPicker(i),this.colorpicker[t._idd]._nodes[0].valueColor=null,this.colorpicker[t._idd].base.className+=" dhtmlxcp_in_form",void 0!==e.customColors&&this.colorpicker[t._idd].setCustomColors(e.customColors),"string"==typeof e.cpPosition&&this.colorpicker[t._idd].setPosition(e.cpPosition),this.colorpicker[t._idd].attachEvent("onSelect",function(e){if(t._value!=e){if(t.checkEvent("onBeforeChange")&&!0!==t.callEvent("onBeforeChange",[t._idd,t._value,e]))return void(t.childNodes[t._ll?1:0].childNodes[0].value=t._value);t._value=e,n.setValue(t,e),t.callEvent("onChange",[t._idd,t._value])}}),this.colorpicker[t._idd].attachEvent("onHide",function(e){var n=t.childNodes[t._ll?1:0].childNodes[0];n.value!=t._value&&(n.value=t._value),n=null}),t.childNodes[t._ll?1:0].childNodes[0]._idd=t._idd,this},getColorPicker:function(t){return this.colorpicker[t._idd]},destruct:function(t){this.colorpicker[t._idd].unload&&this.colorpicker[t._idd].unload(),this.colorpicker[t._idd]=null;try{delete this.colorpicker[t._idd]}catch(t){}t.childNodes[t._ll?1:0].childNodes[0]._idd=null,this.d2(t),t=null},setSkin:function(t,e){this.colorpicker[t._idd].setSkin(e)}},function(){for(var t in{doAddLabel:1,doAddInput:1,doUnloadNestedLists:1,setText:1,getText:1,enable:1,disable:1,isEnabled:1,setWidth:1,setReadonly:1,isReadonly:1,setValue:1,getValue:1,updateValue:1,setFocus:1,getInput:1})dhtmlXForm.prototype.items.colorpicker[t]=dhtmlXForm.prototype.items.input[t]}(),dhtmlXForm.prototype.items.colorpicker.d2=dhtmlXForm.prototype.items.input.destruct,dhtmlXForm.prototype.getColorPicker=function(t){return this.doWithItem(t,"getColorPicker")},dhtmlXForm.prototype.items.container={render:function(t,e){return t._type="container",t._enabled=!0,this.doAddLabel(t,e),this.doAddInput(t,e,"DIV",null,!0,!0,"dhxform_container"),this},getContainer:function(t){return t.childNodes[t._ll?1:0].childNodes[0]},enable:function(t){t._enabled=!0,String(t.className).search("disabled")>=0&&(t.className=String(t.className).replace(/disabled/gi,"")),t.callEvent("onEnable",[t._idd])},disable:function(t){t._enabled=!1,String(t.className).search("disabled")<0&&(t.className+=" disabled"),t.callEvent("onDisable",[t._idd])},doAttachEvents:function(){},setValue:function(){},getValue:function(){return null}},dhtmlXForm.prototype.getContainer=function(t){return this.doWithItem(t,"getContainer")},function(){for(var t in dhtmlXForm.prototype.items.input)dhtmlXForm.prototype.items.container[t]||(dhtmlXForm.prototype.items.container[t]=dhtmlXForm.prototype.items.input[t])}(),dhtmlXForm.prototype.items.editor={editor:{},render:function(t,e){isNaN(e.rows);t._type="editor",t._enabled=!0,t._editor_id=t.getForm().idPrefix+t._idd,this.doAddLabel(t,e),this.doAddInput(t,e,"DIV",null,!0,!0,"dhxform_item_template"),t._value=e.value||"";var n=this;return this.editor[t._editor_id]=new dhtmlXEditor({parent:t.childNodes[t._ll?1:0].childNodes[0],content:t._value,iconsPath:e.iconsPath,toolbar:e.toolbar,skin:t.getForm().skin}),this.editor[t._editor_id].attachEvent("onAccess",function(e,i){var a;(t.callEvent("_onBeforeEditorAccess",[]),_dhxForm_doClick(document.body,"click"),"blur"==e)?(n.doOnBlur(t,this),t.callEvent("onBlur",[t._idd]),1=={dhx_terrace:1,material:1}[t.getForm().skin]&&(a=t.childNodes[t._ll?1:0].className).indexOf("dhxeditor_focus")>=0&&(t.childNodes[t._ll?1:0].className=a.replace(/\s{0,}dhxeditor_focus/gi,""))):(t.callEvent("onEditorAccess",[t._idd,e,i,this,t.getForm()]),t.callEvent("onFocus",[t._idd]),1=={dhx_terrace:1,material:1}[t.getForm().skin]&&-1==(a=t.childNodes[t._ll?1:0].className).indexOf("dhxeditor_focus")&&(t.childNodes[t._ll?1:0].className+=" dhxeditor_focus"))}),this.editor[t._editor_id].attachEvent("onToolbarClick",function(e){t.callEvent("onEditorToolbarClick",[t._idd,e,this,t.getForm()])}),e.readonly&&this.setReadonly(t,!0),t.childNodes[t._ll?0:1].childNodes[0].removeAttribute("for"),t.childNodes[t._ll?0:1].childNodes[0].onclick=function(){n.editor[t._editor_id]._focus()},this},doOnBlur:function(t,e){var n=e.getContent();if(t._value!=n){if(t.checkEvent("onBeforeChange")&&!0!==t.callEvent("onBeforeChange",[t._idd,t._value,n]))return void e.setContent(t._value);t._value=n,t.callEvent("onChange",[t._idd,n])}},setValue:function(t,e){t._value!=e&&(t._value=e,this.editor[t._editor_id].setContent(t._value))},getValue:function(t){return t._value=this.editor[t._editor_id].getContent(),t._value},enable:function(t){1!=this.isEnabled(t)&&(this.editor[t._editor_id].setReadonly(!1),this.doEn(t))},disable:function(t){1==this.isEnabled(t)&&(this.editor[t._editor_id].setReadonly(!0),this.doDis(t))},setReadonly:function(t,e){this.editor[t._editor_id].setReadonly(e)},getEditor:function(t){return this.editor[t._editor_id]||null},destruct:function(t){t.childNodes[t._ll?0:1].childNodes[0].onclick=null,this.editor[t._editor_id].unload(),this.editor[t._editor_id]=null,this.d2(t),t=null},setFocus:function(t){this.editor[t._editor_id]._focus()}},function(){for(var t in{doAddLabel:1,doAddInput:1,doUnloadNestedLists:1,setText:1,getText:1,setWidth:1,isEnabled:1})dhtmlXForm.prototype.items.editor[t]=dhtmlXForm.prototype.items.template[t]}(),dhtmlXForm.prototype.items.editor.d2=dhtmlXForm.prototype.items.select.destruct,dhtmlXForm.prototype.items.editor.doEn=dhtmlXForm.prototype.items.select.enable,dhtmlXForm.prototype.items.editor.doDis=dhtmlXForm.prototype.items.select.disable,dhtmlXForm.prototype.getEditor=function(t){return this.doWithItem(t,"getEditor")},dhtmlXForm.prototype.items.image={_dimFix:!0,render:function(t,e){t._type="image",t._enabled=!0,t._fr_name="dhxform_image_"+window.dhx4.newId(),t._url=void 0===e.url||null==e.url?"":e.url,"auto"==e.inputWidth&&(e.inputWidth=120),"auto"==e.inputHeight&&(e.inputHeight=e.inputWidth),this.doAddLabel(t,e),this.doAddInput(t,e,"DIV",null,!0,!0,"dhxform_image");var n=t.childNodes[t._ll?1:0].childNodes[0];n.style.height=parseInt(n.style.height)-dhtmlXForm.prototype.items[this.t]._dim+"px";var i=void 0!==e.imageWidth?parseInt(e.imageWidth):e.inputWidth,a=void 0!==e.imageHeight?parseInt(e.imageHeight):e.inputHeight;"auto"==a&&(a=i),t._dim={mw:e.inputWidth-this._dim,mh:e.inputHeight-this._dim,w:i,h:a},n.innerHTML="<img class='dhxform_image_img' border='0' style='visibility:hidden;'><iframe name='"+t._fr_name+"' style='position: absolute; width:0px; height:0px; top:-10px; left:-10px;' frameBorder='0' border='0'></iframe><div class='dhxform_image_wrap'><form action='"+t._url+"' method='POST' enctype='multipart/form-data' target='"+t._fr_name+"' class='dhxform_image_form'><input type='hidden' name='action' value='uploadImage'><input type='hidden' name='itemId' value='"+t._idd+"'><input type='file' name='file' class='dhxform_image_input'></form>",this.adjustImage(t),n.childNodes[2].firstChild.lastChild.onchange=function(){t._is_uploading=!0,this.parentNode.submit(),this.parentNode.parentNode.className="dhxform_image_wrap dhxform_image_in_progress",this.value=""};var o=this;return window.navigator.userAgent.indexOf("MSIE")>=0?n.childNodes[1].onreadystatechange=function(){"complete"==this.readyState&&o.doOnUpload(t)}:n.childNodes[1].onload=function(){o.doOnUpload(t)},this._moreClear=function(){o=null},this.setValue(t,e.value||""),n=null,this},destruct:function(t){var e=t.childNodes[t._ll?1:0].childNodes[0];e.childNodes[2].firstChild.lastChild.onchange=null,e.childNodes[1].onreadystatechange=null,e.childNodes[1].onload=null,this._moreClear(),this.d2(t),t=null},doAttachEvents:function(){},setValue:function(t,e){t._value=null==e?"":e;var n=t._url+(t._url.indexOf("?")>=0?"&":"?")+"action=loadImage&itemId="+encodeURIComponent(t._idd)+"&itemValue="+encodeURIComponent(t._value)+window.dhx4.ajax._dhxr("&"),i=t.childNodes[t._ll?1:0].childNodes[0].firstChild;if("img"==i.nextSibling.tagName.toLowerCase())i.nextSibling.src=n;else{var a=document.createElement("IMG");a.className="dhxform_image_img",a.style.visibility="hidden",a.onload=function(){this.style.visibility="visible",this.parentNode.removeChild(this.nextSibling),this.onload=this.onerror=null},a.onerror=function(){this.onload.apply(this,arguments),this.style.visibility="hidden"},i.parentNode.insertBefore(a,i),a.src=n,a=null,this.adjustImage(t)}i=null},getValue:function(t){return t._value},doOnUpload:function(t){if(1==t._is_uploading){var e=t.childNodes[t._ll?1:0].childNodes[0].lastChild.previousSibling,n=dhx4.s2j(e.contentWindow.document.body.innerHTML);"object"==typeof n&&null!=n&&1==n.state&&n.itemId==t._idd?(this.setValue(t,n.itemValue,!0),t.getForm().callEvent("onImageUploadSuccess",[n.itemId,n.itemValue,n.extra])):t.getForm().callEvent("onImageUploadFail",[t._idd,n?n.extra:null]),n=e=null,window.setTimeout(function(){t.childNodes[t._ll?1:0].childNodes[0].lastChild.className="dhxform_image_wrap",t._is_uploading=!1},50)}},adjustImage:function(t){var e=t.childNodes[t._ll?1:0].childNodes[0].firstChild,n=Math.min(t._dim.mw,t._dim.w),i=Math.min(t._dim.mh,t._dim.h);e.style.width=n+"px",e.style.height=i+"px",e.style.marginLeft=Math.max(0,Math.round(t._dim.mw/2-n/2))+"px",e.style.marginTop=Math.max(0,Math.round(t._dim.mh/2-i/2))+"px",e=t=null}},function(){for(var t in dhtmlXForm.prototype.items.input)dhtmlXForm.prototype.items.image[t]||(dhtmlXForm.prototype.items.image[t]=dhtmlXForm.prototype.items.input[t])}(),dhtmlXForm.prototype.items.image.d2=dhtmlXForm.prototype.items.input.destruct,dhtmlXForm.prototype.setFormData_image=function(t,e){this.setItemValue(t,e)},dhtmlXForm.prototype.getFormData_image=function(t){return this.getItemValue(t)},dhtmlXForm.prototype.items.upload={render:function(t,e){t._type="up",t._enabled=!0,t._checked=!0,t.className=e.position+("string"==typeof e.className?" "+e.className:"");var n=document.createElement("DIV");return t.appendChild(n),isNaN(e.inputLeft)||(t.style.left=parseInt(e.inputLeft)+"px"),isNaN(e.inputTop)||(t.style.top=parseInt(e.inputTop)+"px"),"auto"!=e.inputWidth&&(isNaN(e.inputWidth)||(n.style.width=parseInt(e.inputWidth)+"px")),t._uploader=new dhtmlXFileUploader(n,e.swfPath||"",e.swfUrl||"",e.mode||null,e.swfLogs,e.slXap||"",e.slUrl||"",e.slLogs||"",e.multiple),t._uploader.setURL(e.url||""),t._uploader.callEvent=t.callEvent,void 0!==e.autoStart&&t._uploader.setAutoStart(e.autoStart),void 0!==e.autoRemove&&t._uploader.setAutoRemove(e.autoRemove),void 0!==e.titleScreen&&t._uploader.enableTitleScreen(e.titleScreen),void 0!==e.titleText&&t._uploader.setTitleText(e.titleText),1==e.hidden&&this.hide(t),1==e.disabled&&this.userDisable(t),"auto"!=e.inputHeight&&NaN!=parseInt(e.inputHeight)&&(t._uploader.p_files.style.height=parseInt(e.inputHeight)+"px"),this},destruct:function(t){for(this.doUnloadNestedLists(t),t._uploader.callEvent=function(){return!0},t._uploader.unload(),t._uploader.callEvent=null,t._uploader=null,t._checked=null,t._enabled=null,t._idd=null,t._type=null,t.onselectstart=null,t._autoCheck=null,t.callEvent=null,t.checkEvent=null,t.getForm=null;t.childNodes.length>0;)t.removeChild(t.childNodes[0]);t.parentNode.removeChild(t),t=null},setText:function(t,e){},getText:function(t){},enable:function(t){t._enabled=!0,String(t.className).search("disabled")>=0&&(t.className=String(t.className).replace(/disabled/gi,"")),t._uploader.enable()},disable:function(t){t._enabled=!1,String(t.className).search("disabled")<0&&(t.className+=" disabled"),t._uploader.disable()},setWidth:function(t,e){t.childNodes[0].style.width=e+"px",t._width=e},getWidth:function(t){return t._width||parseInt(t.childNodes[0].style.width)},setValue:function(t){t._uploader.clear()},getValue:function(t){var e=t._uploader.getData(),n={},i=0;for(var a in e)n[t._idd+"_r_"+i]=e[a].realName,n[t._idd+"_s_"+i]=e[a].serverName,i++;return n[t._idd+"_count"]=i,n},getUploader:function(t){return t._uploader},getStatus:function(t){return t._uploader.getStatus()}},function(){for(var t in{doUnloadNestedLists:1,isEnabled:1})dhtmlXForm.prototype.items.upload[t]=dhtmlXForm.prototype.items.checkbox[t]}(),dhtmlXForm.prototype.setFormData_upload=function(t){this.doWithItem(t,"setValue")},dhtmlXForm.prototype.getUploader=function(t){return this.doWithItem(t,"getUploader")},dhtmlXForm.prototype.getUploaderStatus=function(t){return this.doWithItem(t,"getStatus")},dhtmlXFileUploader.prototype.html5=function(){},dhtmlXFileUploader.prototype.html5.prototype={_initEngine:function(){var t=this;this.buttons.browse.onclick=function(){t._enabled&&t.f.click()},this._progress_type="percentage";var e=window.navigator.userAgent;null!=e.match(/Windows/gi)&&null!=e.match(/AppleWebKit/gi)&&null!=e.match(/Safari/gi)&&(e.match(/Version\/5\.1\.5/gi)&&(this._upload_mp=!1),e.match(/Version\/5\.1[^\.\d{1,}]/gi)&&(this._upload_dnd=!1),e.match(/Version\/5\.1\.1/gi)&&(this._upload_mp=!1,this._upload_dnd=!1),e.match(/Version\/5\.1\.2/gi)&&(this._upload_dnd=!1),e.match(/Version\/5\.1\.7/gi)&&(this._upload_mp=!1)),this._addFileInput(),this._upload_dnd?(this.p.ondragenter=function(t){t.dataTransfer&&(t.stopPropagation(),t.preventDefault())},this.p.ondragover=function(t){t.dataTransfer&&(t.stopPropagation(),t.preventDefault())},this.p.ondrop=function(e){e.dataTransfer&&(e.stopPropagation(),e.preventDefault(),t._enabled&&t._parseFilesInInput(e.dataTransfer.files))},this._titleText="Drag-n-Drop files here or<br>click to select files for upload."):this._titleText="Click to select files for upload."},_addFileInput:function(){null!=this.f&&(this.f.onchange=null,this.f.parentNode.removeChild(this.f),this.f=null);var t=this;this.f=document.createElement("INPUT"),this.f.type="file",this._upload_mp&&(this.f.multiple="1"),this.f.className="dhx_uploader_input",this.p_controls.appendChild(this.f),this.f.onchange=function(){t._parseFilesInInput(this.files),window.dhx4.isOpera?t._addFileInput():this.value=""}},_doUploadFile:function(t){var e=this;this._loader||(this._loader=new XMLHttpRequest,this._loader.upload.onprogress=function(t){"uploading"==e._files[this._idd].state&&e._updateFileInList(this._idd,"uploading",Math.round(100*t.loaded/t.total))},this._loader.onload=function(t){var n=dhx4.s2j(this.responseText);"object"==typeof n&&null!=n&&void 0!==n.state&&1==n.state?(e._onUploadSuccess(this.upload._idd,n.name,null,n.extra),n=null):e._onUploadFail(this.upload._idd,null!=n&&null!=n.extra?n.extra:null)},this._loader.onerror=function(t){e._onUploadFail(this.upload._idd)},this._loader.onabort=function(t){e._onUploadAbort(this.upload._idd)}),this._loader.upload._idd=t;var n=new FormData;n.append("file",this._files[t].file),this.callEvent("onBeforeFileUpload",["html5",this.loader,n])&&(this._loader.open("POST",this._url+(String(this._url).indexOf("?")<0?"?":"&")+"mode=html5"+window.dhx4.ajax._dhxr("&"),!0),this._loader.setRequestHeader("X-Requested-With","XMLHttpRequest"),this._loader.send(n))},_uploadStop:function(){this._uploading&&this._loader&&this._loader.abort()},_parseFilesInInput:function(t){for(var e=0;e<t.length;e++)this._addFileToQueue(t[e])},_addFileToQueue:function(t){if(this._beforeAddFileToList(t.name,t.size)){var e=t._idd||window.dhx4.newId();this._files[e]={file:t,name:t.name,size:t.size,state:"added"},this._addFileToList(e,t.name,t.size,"added",0),this._autoStart&&!this._uploading&&this._uploadStart(!0)}},_removeFileFromQueue:function(t){if(this._files[t]){var e=this._files[t].name,n=null!=this._data&&null!=this._data[t]?this._data[t].serverName:null;if(!0===this.callEvent("onBeforeFileRemove",[e,n])){var i=!1;this._uploading&&t==this._loader.upload._idd&&"uploading"==this._files[t].state&&(this._uploadStop(),i=!0),this._files[t].file=null,this._files[t].name=null,this._files[t].size=null,this._files[t].state=null,this._files[t]=null,delete this._files[t],this._removeFileFromList(t),this.callEvent("onFileRemove",[e,n]),i&&this._uploadStart()}}},_unloadEngine:function(){this.buttons.browse.onclick=null,this.f.onchange=null,this.f.parentNode.removeChild(this.f),this.f=null,this.p.ondragenter=null,this.p.ondragover=null,this.p.ondrop=null,this._loader&&(this._loader.upload.onprogress=null,this._loader.onload=null,this._loader.onerror=null,this._loader.onabort=null,this._loader.upload._idd=null,this._loader=null),this._initEngine=null,this._doUploadFile=null,this._uploadStop=null,this._parseFilesInInput=null,this._addFileToQueue=null,this._removeFileFromQueue=null,this._unloadEngine=null}},dhtmlXFileUploader.prototype.html4=function(){},dhtmlXFileUploader.prototype.html4.prototype={_initEngine:function(){this._addForm(),this._progress_type="loader",this._titleText="Click button<br>to select files for upload."},_addForm:function(){var t=this,e=window.dhx4.newId();this.k||(this.k=document.createElement("DIV"),this.k.className="dhx_file_form_cont",this.buttons.browse.appendChild(this.k),this.fr_name="dhx_file_"+window.dhx4.newId(),this.k.innerHTML='<iframe name="'+this.fr_name+'" style="height:0px;width:0px;" frameBorder="0"></iframe>',this.fr=this.k.firstChild,window.navigator.userAgent.indexOf("MSIE")>=0?this.fr.onreadystatechange=function(){"complete"==this.readyState&&t._onLoad()}:this.fr.onload=function(){t._onLoad()});var n=document.createElement("DIV");n.innerHTML="<form method='POST' enctype='multipart/form-data' target='"+this.fr_name+"' class='dhx_file_form' name='dhx_file_form_"+window.dhx4.newId()+"'><input type='hidden' name='mode' value='html4'><input type='hidden' name='uid' value='"+e+"'><input type='file' name='file' class='dhx_file_input'></form>",this.k.appendChild(n),n.firstChild.lastChild._idd=e,n.firstChild.lastChild.onchange=function(){t._beforeAddFileToList(this.value,null)&&(t._addFileToQueue(this),this.onchange=null,this.parentNode.parentNode.style.display="none",t._addForm())},n=null},_onLoad:function(){if(this._uploading){var t=dhx4.s2j(this.fr.contentWindow.document.body.innerHTML);if("object"==typeof t&&null!=t&&void 0!==t.state){if("cancelled"==t.state)return this._onUploadAbort(this.fr._idd),void(t=null);if(1==t.state)return void 0===t.size||isNaN(t.size)||(this._files[this.fr._idd].size=t.size),this._onUploadSuccess(this.fr._idd,t.name,null,t.extra),void(t=null)}this._onUploadFail(this.fr._idd,null!=t&&null!=t.extra?t.extra:null)}},_addFileToQueue:function(t){var e=t.value.match(/[^\\\/]*$/g);e=null!=e[0]?e[0]:t.value,this._files[t._idd]={name:e,form:t.parentNode,node:t.parentNode.parentNode,input:t,state:"added"},this._addFileToList(t._idd,t.value,!1,"added",0),this._autoStart&&!this._uploading&&this._uploadStart(!0)},_removeFileFromQueue:function(t){var e=this._files[t].name,n=null!=this._data&&null!=this._data[t]?this._data[t].serverName:null;!0===this.callEvent("onBeforeFileRemove",[e,n])&&(this._files[t].input.onchange=null,this._files[t].form.removeChild(this._files[t].input),this._files[t].node.removeChild(this._files[t].form),this._files[t].node.parentNode.removeChild(this._files[t].node),this._files[t].input=null,this._files[t].name=null,this._files[t].form=null,this._files[t].node=null,this._files[t].size=null,this._files[t].state=null,this._files[t]=null,delete this._files[t],this._removeFileFromList(t),this.callEvent("onFileRemove",[e,n]))},_doUploadFile:function(t){this.fr._idd=t,this._files[t].form.action=this._url,this._files[t].form.submit()},_uploadStop:function(){this._uploading&&(this.fr.contentWindow.location.href=this._url+(this._url.indexOf("?")<0?"?":"&")+"mode=html4&action=cancel"+window.dhx4.ajax._dhxr("&"))},_unloadEngine:function(){this.k&&(this.fr_name=null,this.fr.onreadystatechange=null,this.fr.onload=null,this.fr.parentNode.removeChild(this.fr),this.fr=null,this.k.firstChild.firstChild.lastChild.onchange=null,this.k.parentNode.removeChild(this.k),this.k=null),this._initEngine=null,this._addForm=null,this._onLoad=null,this._addFileToQueue=null,this._removeFileFromQueue=null,this._doUploadFile=null,this._uploadStop=null,this._unloadEngine=null}},dhtmlXFileUploader.prototype.flash=function(){},dhtmlXFileUploader.prototype.flash.prototype={_initEngine:function(){null==window.dhtmlXSWFObjectsPull&&(window.dhtmlXSWFObjectsPull={items:{},callEvent:function(t,e,n){return window.dhtmlXSWFObjectsPull.items[t].uploader[e].apply(window.dhtmlXSWFObjectsPull.items[t].uploader,n)}});this._swf_obj_id="dhtmlXFileUploaderSWFObject_"+window.dhx4.newId(),this._swf_file_url=this._swf_file_url+window.dhx4.ajax._dhxr(this._swf_file_url),this.buttons.browse.innerHTML="<div id='"+this._swf_obj_id+"' style='width:100%;height:100%;'></div>",swfobject.embedSWF(this._swf_file_url,this._swf_obj_id,"100%","100%","9",null,{ID:this._swf_obj_id,enableLogs:this._swf_logs},{wmode:"transparent"});var t=swfobject.getFlashPlayerVersion();this._titleText="Engine successfuly inited<br>Flash Player: "+t.major+"."+t.minor+"."+t.release,this._progress_type="percentage",window.dhtmlXSWFObjectsPull.items[this._swf_obj_id]={id:this._swf_obj_id,uploader:this}},_beforeAddFileToQueue:function(t,e){return!0===this.callEvent("onBeforeFileAdd",[t,e])},_addFileToQueue:function(t,e,n){if(window.dhx4.isIE){var i=document.createElement("INPUT");i.type="TEXT",i.style.position="absolute",i.style.left="0px",i.style.top=window.dhx4.absTop(this.buttons.browse)+"px",i.style.width="10px",document.body.appendChild(i),i.focus(),document.body.removeChild(i),i=null}this._files[t]={name:e,size:n,state:"added"},this._addFileToList(t,e,n,"added",0),this._autoStart&&!this._uploading&&this._uploadStart(!0)},_removeFileFromQueue:function(t){if(this._files[t]){var e=this._files[t].name,n=null!=this._data&&null!=this._data[t]?this._data[t].serverName:null;if(!0===this.callEvent("onBeforeFileRemove",[e,n])){var i=!1;this._uploading&&"uploading"==this._files[t].state&&(this._uploadStop(),i=!0),swfobject.getObjectById(this._swf_obj_id).removeFileById(t),this._files[t].name=null,this._files[t].size=null,this._files[t].state=null,this._files[t]=null,delete this._files[t],this._removeFileFromList(t),this.callEvent("onFileRemove",[e,n]),i&&this._uploadStart()}}},_doUploadFile:function(t){swfobject.getObjectById(this._swf_obj_id).upload(t,this._swf_upolad_url)},_uploadStop:function(t){for(var e in this._files)"uploading"==this._files[e].state&&swfobject.getObjectById(this._swf_obj_id).uploadStop(e)},_unloadEngine:function(){window.dhtmlXSWFObjectsPull.items[this._swf_obj_id]&&(window.dhtmlXSWFObjectsPull.items[this._swf_obj_id].id=null,window.dhtmlXSWFObjectsPull.items[this._swf_obj_id].uploader=null,window.dhtmlXSWFObjectsPull.items[this._swf_obj_id]=null,delete window.dhtmlXSWFObjectsPull.items[this._swf_obj_id]),this._swf_obj_id=null,this._initEngine=null,this._addFileToQueue=null,this._removeFileFromQueue=null,this._doUploadFile=null,this._uploadStop=null,this._unloadEngine=null}},dhtmlXFileUploader.prototype.sl=function(){},dhtmlXFileUploader.prototype.sl.prototype={_initEngine:function(){void 0===this._sl_v&&(this._sl_v=this.getSLVersion()),window.dhtmlXFileUploaderSLObjects||(window.dhtmlXFileUploaderSLObjects={items:{},callEvent:function(t,e,n){window.dhtmlXFileUploaderSLObjects.items[t].uploader[e].apply(window.dhtmlXFileUploaderSLObjects.items[t].uploader,n)}}),this._sl_obj_id="dhtmlXFileUploaderSLObject_"+window.dhx4.newId(),0!=this._sl_v?(this._titleText="Engine successfuly inited<br>Silverlight version: "+this._sl_v[0]+"."+this._sl_v[1],this.buttons.browse.innerHTML='<div style="width:100%;height:100%;"><object data="data:application/x-silverlight-2," type="application/x-silverlight-2" width="100%" height="100%" id="'+this._sl_obj_id+'"><param name="source" value="'+this._sl_xap+'"/><param name="background" value="Transparent"/><param name="windowless" value="true"/><param name="initParams" value="SLID='+this._sl_obj_id+",LOGS="+this._sl_logs+'"/><param name="minRuntimeVersion" value="5.0"/></object></div>'):(this._titleText="Silverlight plugin not found<br>or version less than 4.0",this.buttons.browse.style.cursor="wait",this.buttons.browse.title=""),this._progress_type="percentage",window.dhtmlXFileUploaderSLObjects.items[this._sl_obj_id]={id:this._sl_obj_id,uploader:this}},_addFileToQueue:function(t,e,n){this._files[t]={name:e,size:n,state:"added"},this._addFileToList(t,e,n,"added",0),this._autoStart&&!this._uploading&&this._uploadStart(!0)},_removeFileFromQueue:function(t){if(this._files[t]){var e=!1;this._uploading&&"uploading"==this._files[t].state&&(this._uploadStop(),e=!0),document.getElementById([this._sl_obj_id]).Content.a.removeFileById(t),this._files[t].name=null,this._files[t].size=null,this._files[t].state=null,this._files[t]=null,delete this._files[t],this._removeFileFromList(t),e&&this._uploadStart()}},_doUploadFile:function(t){var e=this._sl_upload_url.split("?");e=null!=e[1]?"&"+e[1]:"",document.getElementById(this._sl_obj_id).Content.a.upload(t,this._sl_upload_url,e+"&mode=sl"+window.dhx4.ajax._dhxr("&"))},_uploadStop:function(t){for(var e in this._uploading=!1,this._files)"uploading"==this._files[e].state&&document.getElementById(this._sl_obj_id).Content.a.uploadStop(e)},_unloadEngine:function(){window.dhtmlXFileUploaderSLObjects.items[this._sl_obj_id]&&(window.dhtmlXFileUploaderSLObjects.items[this._sl_obj_id].id=null,window.dhtmlXFileUploaderSLObjects.items[this._sl_obj_id].uploader=null,window.dhtmlXFileUploaderSLObjects.items[this._sl_obj_id]=null,delete window.dhtmlXFileUploaderSLObjects.items[this._sl_obj_id]),this._sl_obj_id=null,this._initEngine=null,this._addFileToQueue=null,this._removeFileFromQueue=null,this._doUploadFile=null,this._uploadStop=null,this._unloadEngine=null}},dhtmlXFileUploader.prototype.setSLURL=function(t){this._sl_upload_url=t},dhtmlXFileUploader.prototype.getSLVersion=function(){var t=!1;if(window.dhx4.isIE)try{var e=new ActiveXObject("AgControl.AgControl");if(null!=e)for(var n=4,i=0;e.isVersionSupported([n,i].join("."));)t=[n,i],++i>9&&(n++,i=0);e=null}catch(t){}else null!=navigator.plugins["Silverlight Plug-In"]&&(t=navigator.plugins["Silverlight Plug-In"].description.split("."));return t},dhtmlXForm.prototype.saveBackup=function(){return this._backup||(this._backup={},this._backupId=(new Date).getTime()),this._backup[++this._backupId]=this.getFormData(),this._backupId},dhtmlXForm.prototype.restoreBackup=function(t){null!=this._backup&&null!=this._backup[t]&&this.setFormData(this._backup[t])},dhtmlXForm.prototype.clearBackup=function(t){null!=this._backup&&null!=this._backup[t]&&(this._backup[t]=null,delete this._backup[t])},dhtmlXForm.prototype.addItem=function(t,e,n,i){var a=null;t instanceof Array&&(a=t[1],t=t[0]);var o=null;if(null!=t&&null!=(o=this._getParentForm(t,a)))return null==o.item._list?(e.listParent||(e.listParent=o.item._idd),o.form._addItem("list",o.item._idd,[e],null,o.item._idd,n,i)):o.item._list[0].addItem(null,e,n,i),o.form=o.item=null,o=null,void this._autoCheck();this._prepareItem(e,n,i),this._autoCheck()},dhtmlXForm.prototype.removeItem=function(t,e){this._removeItem(t,e)},dhtmlXForm.prototype.removeColumn=function(t,e,n,i){var a=null;if(t instanceof Array&&(a=t[1],t=t[0]),null==t)if(e=Math.min(Math.max(e,0),this.cont.childNodes.length-1),1==this.cont.childNodes.length)1==n&&this._removeItemsInColumn(this.cont.childNodes[e]);else{if(1==n)this._removeItemsInColumn(this.cont.childNodes[e]);else{var o;if(i)(o=e+1)>this.cont.childNodes.length-1&&(o=e-1);else(o=e-1)<0&&(o=e+1);for(;this.cont.childNodes[e].childNodes.length>0;)this.cont.childNodes[o].appendChild(this.cont.childNodes[e].childNodes[0])}for(var r=[],s=0;s<this.base.length;s++)this.cont.childNodes[e]!=this.base[s]&&r.push(this.base[s]);this.base=r,this.cont.removeChild(this.cont.childNodes[e]),this.b_index--,r=null}else{var l=this._getParentForm(t,a);null!=l&&(null!=l.item._list&&null!=l.item._list[0]&&l.item._list[0].removeColumn(null,e,n,i),l.form=l.item=null,l=null)}},dhtmlXForm.prototype.getColumnNode=function(t,e){var n=null,i=null;if(t instanceof Array&&(i=t[1],t=t[0]),null!=t){var a=this._getParentForm(t,i);return null!=a&&(null!=a.item._list&&null!=a.item._list[0]&&null==n&&(n=a.item._list[0].getColumnNode(null,e)),a.form=a.item=null,a=null),n}return e<0||e>this.cont.childNodes.length-1?null:this.cont.childNodes[e]},dhtmlXForm.prototype._removeItemsInColumn=function(t){for(var e=[],n=0;n<t.childNodes.length;n++){var i=t.childNodes[n];null!=i._idd&&null!=i._type&&e.push([i._idd,"ra"==i._type?i._value:null]),i=null}for(n=0;n<e.length;n++)this.removeItem(e[n][0],e[n][1])},dhtmlXForm.prototype._getParentForm=function(t,e){if(null!=this.itemPull[this.idPrefix+t])return{form:this,item:this.itemPull[this.idPrefix+t]};for(var n in this.itemPull)if("ra"==this.itemPull[n]._type&&this.itemPull[n]._group==t&&this.itemPull[n]._value==e)return{form:this,item:this.itemPull[n]};var i=null;for(var n in this.itemPull)if(!i&&null!=this.itemPull[n]._list)for(var a=0;a<this.itemPull[n]._list.length;a++)i||(i=this.itemPull[n]._list[a]._getParentForm(t,e));return i},function(){for(var t in dhtmlXForm.prototype.items)dhtmlXForm.prototype.items[t]._getItemNode||(dhtmlXForm.prototype.items[t]._getItemNode=function(t){return t})}(),dhtmlXForm.prototype._getItemNode=function(t,e){return null!=e&&(t=[t,e]),this.doWithItem(t,"_getItemNode")},dhtmlXForm.prototype.setRequired=function(t,e,n){void 0===n?n=e:t=[t,e];var i=this._getItemNode(t);if(i){if(n=window.dhx4.s2b(n),i._required=1==n,i._required){i._validate||(i._validate=[]);for(var a=!1,o=0;o<i._validate.length;o++)a="NotEmpty"==i._validate[o]||a;if(a||i._validate.push("NotEmpty"),!((s=i.childNodes[i._ll?0:1].childNodes[0]).lastChild&&s.lastChild.className&&s.lastChild.className.search(/required/)>=0)){var r=document.createElement("SPAN");r.className="dhxform_item_required",r.innerHTML="*",s.appendChild(r),r=s=null}}else{if(null!=i._validate){a=i._validate;i._validate=[];for(o=0;o<a.length;o++)"NotEmpty"!=a[o]&&i._validate.push(a[o]);0==i._validate.length&&(i._validate=null)}var s;(s=i.childNodes[i._ll?0:1].childNodes[0]).lastChild&&s.lastChild.className&&s.lastChild.className.search(/required/)>=0&&(s.removeChild(s.lastChild),s=null)}this._resetValidateCss(i),i=null}},dhtmlXForm.prototype.setNote=function(t,e,n){void 0===n?n=e:t=[t,e];var i=this._getItemNode(t);if(i){var a=this._getNoteNode(i);a||(n.width||(n.width=i.childNodes[i._ll?1:0].childNodes[0].offsetWidth),(a=document.createElement("DIV")).className="dhxform_note",!{ch:1,ra:1}[i._type]?i.childNodes[i._ll?1:0].appendChild(a):i.childNodes[i._ll?1:0].insertBefore(a,i.childNodes[i._ll?1:0].lastChild)),a.innerHTML=n.text,null!=n.width&&(a.style.width=n.width+"px",a._w=n.width),a=null}},dhtmlXForm.prototype.clearNote=function(t,e){void 0!==e&&(t=[t,e]);var n=this._getItemNode(t);if(n){var i=this._getNoteNode(n);null!=i&&(i.parentNode.removeChild(i),i=null)}},dhtmlXForm.prototype._getNoteNode=function(t){for(var e=null,n=0;n<t.childNodes[t._ll?1:0].childNodes.length;n++)String(t.childNodes[t._ll?1:0].childNodes[n].className).search(/dhxform_note/)>=0&&(e=t.childNodes[t._ll?1:0].childNodes[n]);return t=null,e},dhtmlXForm.prototype.setValidation=function(t,e,n){"undefined"==typeof note?n=e:t=[t,e];var i=this._getItemNode(t);if(i){if(null!=i._validate)for(var a=0;a<i._validate.length;a++)i._validate[a]=null;if(i._validate=[],"function"==typeof n||"function"==typeof window[n]?i._validate=[n]:i._validate=String(n).split(this.separator),i._required){var o=!1;for(a=0;a<i._validate.length;a++)o="NotEmpty"==i._validate[a]||o;o||i._validate.push("NotEmpty")}i=null}},dhtmlXForm.prototype.clearValidation=function(t,e){void 0!==e&&(t=[t,e]);var n=this._getItemNode(t);if(n){if(null!=n._validate)for(var i=0;i<n._validate.length;i++)n._validate[i]=null;n._validate=n._required?["NotEmpty"]:null,n=null}},dhtmlXForm.prototype.reloadOptions=function(t,e){var n=this.getItemType(t);if({select:1,multiselect:1,combo:1}[n]){if("select"==n||"multiselect"==n){for(var i=this.getOptions(t);i.length>0;)i.remove(0);i.length=0,i=null,"string"==typeof e?this.doWithItem(t,"doLoadOptsConnector",e):e instanceof Array&&this.doWithItem(t,"doLoadOpts",{options:e})}if("combo"==n){var a=this.getCombo(t);if(a.clearAll(),a.setComboValue(""),"string"==typeof e)this.doWithItem(t,"doLoadOptsConnector",e);else if(e instanceof Array){for(var o=null,r=0;r<e.length;r++)window.dhx4.s2b(e[r].selected)&&(o=e[r].value);a.addOption(e),null!=o&&this.setItemValue(t,o),a=null}}}},dhtmlXForm.prototype.setTooltip=function(t,e,n){void 0===n?n=e:t=[t,e];var i=this._getItemNode(t);if(i){var a=null;if(1==i.childNodes.length)a=i.childNodes[0];else for(var o=0;o<i.childNodes.length;o++)null!=i.childNodes[o].className&&i.childNodes[o].className.search("dhxform_label")>=0&&(a=i.childNodes[o]);null!=a&&(null==n||0==n.length?a.removeAttribute("title"):a.title=n),a=null}},dhtmlXAccordion.prototype=new dhtmlXCellTop,dhtmlXAccordion.prototype.setIconset=function(t){this.conf.icons_css="awesome"==t},dhtmlXAccordionCell.prototype=new dhtmlXCellObject,dhtmlXAccordionCell.prototype._initHeader=function(){var t=document.createElement("DIV");t.className="dhx_cell_hdr",t.innerHTML="<div class='dhx_cell_hdr_text'></div><div class='dhx_cell_hdr_arrow'></div>",this.cell.insertBefore(t,this.cell.childNodes[this.conf.idx.cont]),t=null,this.conf.ofs_nodes.t._getHdrHeight="func",this.conf.hdr={visible:!0},this.conf.idx_data.hdr="dhx_cell_hdr",this._updateIdx()},dhtmlXAccordionCell.prototype._getHdrHeight=function(){var t=this.cell.childNodes[this.conf.idx.hdr],e=t.offsetHeight||t.offsetHeight;return t=null,e},dhtmlXAccordionCell.prototype.showHeader=function(){1!=this.conf.hdr.visible&&(this.conf.hdr.visible=!0,this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_hdr",this._adjustCont(this._idd))},dhtmlXAccordionCell.prototype.hideHeader=function(){1==this.conf.hdr.visible&&(this.conf.hdr.visible=!1,this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_hdr dhx_cell_hdr_hidden",this._adjustCont(this._idd))},dhtmlXAccordionCell.prototype.isHeaderVisible=function(){return 1==this.conf.hdr.visible},dhtmlXAccordionCell.prototype.setText=function(t){this.conf.text=t;var e=this.cell.childNodes[this.conf.idx.hdr];e.childNodes["dhx_cell_hdr_icon"==e.firstChild.className?1:0].innerHTML="<span>"+t+"</span>",e=null},dhtmlXAccordionCell.prototype.getText=function(){return this.conf.text},dhtmlXAccordionCell.prototype.setIcon=function(t){var e=this.cell.childNodes[this.conf.idx.hdr];if(1==this.acc.conf.icons_css){if("i"!=(e.firstChild.tagName||"").toLowerCase()){e.firstChild.className+=" dhx_cell_hdr_icon";var n=document.createElement("I");e.insertBefore(n,e.firstChild),n=null}e.firstChild.className=t}else{if("dhx_cell_hdr_icon"!=e.firstChild.className){e.firstChild.className+=" dhx_cell_hdr_icon";var i=document.createElement("IMG");i.className="dhx_cell_hdr_icon",e.insertBefore(i,e.firstChild),i=null}e.firstChild.src=this.acc.conf.icons_path+t}e=null},dhtmlXAccordionCell.prototype.clearIcon=function(){var t=this.cell.childNodes[this.conf.idx.hdr];"dhx_cell_hdr_icon"!=t.firstChild.className&&"i"!=(t.firstChild.tagName||"").toLowerCase()||(t.removeChild(t.firstChild),t.firstChild.className=String(t.firstChild.className).replace(/\s{1,}dhx_cell_hdr_icon/gi,"")),t=null},dhtmlXAccordionCell.prototype._open=function(t){var e={};if(this.acc.conf.multi_mode){var n={};n[this._idd]=!0,e=this.acc._getDynData(n),this.acc._openId=this._idd,this.acc._openCache={},this.acc._openMode="open"}else e[this._idd]=this.conf.size.h;for(var i in e){null!=this.acc._openCache&&(this.acc._openCache[i]=!0);var a=this.acc.t[i].cell;a.cell.className=String(a.cell.className).replace(/\s{1,}dhx_cell_closed/gi,""),a.conf.opened=!0,a._trInitEv("open",t),a.conf.size.h=e[i],a.cell.style.height=a.conf.size.h+"px",a=null}0==this.conf.tr.prop&&(this.acc._openId=this.acc._openCache=this.acc._openMode=null,this._onActiveCall(!0))},dhtmlXAccordionCell.prototype._close=function(t){var e={};if(this.acc.conf.multi_mode){var n={};n[this._idd]=!0,e=this.acc._getDynData(null,n),this.acc._openId=this._idd,this.acc._openCache={},this.acc._openMode="close"}else e[this._idd]=this._getHdrHeight();for(var i in e){var a=this.acc.t[i].cell;null!=this.acc._openCache&&(this.acc._openCache[i]=!0),i==this._idd?(a.cell.className+=" dhx_cell_closed",a.conf.opened=!1,a._trInitEv("close",t)):(a.conf.size.h=e[i],a._adjustCell(),a._trInitEv("open",t)),a.cell.style.height=e[i]+"px",a=null}0==this.conf.tr.prop&&(this.acc._openId=this.acc._openCache=this.acc._openMode=null,this._onActiveCall(!1))},dhtmlXAccordionCell.prototype.isOpened=function(){return 1==this.conf.opened},dhtmlXAccordionCell.prototype._trInitEv=function(t,e){0!=this.conf.tr.prop&&(this._trAttachEv(),this.cell._accObj||(this.cell._accObj=this.acc),e&&(this.cell.style[this.conf.tr.prop]=this.conf.tr["height_"+t]),this._cellSetOpacity(t,e))},dhtmlXAccordionCell.prototype._trAttachEv=function(){this.conf.tr.ev_attached||(this.cell._trProp=this.conf.tr.prop,this.cell.addEventListener(this.conf.tr.ev,this._trOnEnd,!1),this.conf.tr.ev_attached=!0)},dhtmlXAccordionCell.prototype._trDetachEv=function(){this.conf.tr.ev_attached&&(this.cell.addEventListener(this.conf.tr.ev,this._trOnEnd,!1),this.conf.tr.ev_attached=!1)},dhtmlXAccordionCell.prototype._trOnEnd=function(t){t.stopPropagation&&t.stopPropagation(),"height"==t.propertyName&&null!=this._accObj&&(this.style[this._trProp]="",this._accObj.conf.multi_mode&&(null!=this._accObj._openCache&&(this._accObj._openCache[this._accId]=!1),this._accObj._adjustOpened()),1==this._accObj.conf.on_active_click&&(this._accObj.conf.multi_mode?(this._accObj._callMainEvent("onActive",[this._accId,this._accObj.t[this._accId].cell.conf.opened]),this._accObj.conf.on_active_click=!1):(null!=this._accObj.conf.on_active_id&&this._accObj._callMainEvent("onActive",[this._accObj.conf.on_active_id,!0]),this._accObj.conf.on_active_id=null,this._accObj.conf.on_active_click=!1)),this._accObj=null)},dhtmlXAccordionCell.prototype._cellSetOpacity=function(t,e){for(var n in this.conf.idx)1!={hdr:!0,pr1:!0,pr2:!0,cover:!0}[n]&&(e&&(this.cell.childNodes[this.conf.idx[n]].style[this.conf.tr.prop]=this.conf.tr["op_"+t]),this.cell.childNodes[this.conf.idx[n]].style.opacity=this.conf.tr["op_v_"+t])},dhtmlXAccordionCell.prototype._onActiveCall=function(t){0!=this.acc.conf.on_active_click&&(1==this.acc.conf.multi_mode?(this.acc._callMainEvent("onActive",[this._idd,this.conf.opened]),this.acc.conf.on_active_click=!1):1==t&&(this.acc._callMainEvent("onActive",[this._idd,!0]),this.acc.conf.on_active_click=!1))},dhtmlXAccordionCell.prototype.show=function(){this.conf.visible||(0!=this.conf.docked?(this.cell.style.display="",this.conf.visible=!0,this.acc.conf.multi_mode||(this.acc.conf.hiden_count--,this.acc._updateCellsHeight(),this.acc._updateCellsMargin()),this.acc.conf.size_changed?(this.acc.setSizes(),this.acc.conf.size_changed=!1):this.acc._adjustOpened()):this.dock())},dhtmlXAccordionCell.prototype.hide=function(){this.conf.visible&&(!this.acc.conf.multi_mode&&this.conf.opened&&(this._close(!1),this.acc.conf.last_opened=null),this.cell.style.display="none",this.conf.visible=!1,this.acc.conf.multi_mode||(this.acc.conf.hiden_count++,this.acc._updateCellsHeight(),this.acc._updateCellsMargin()),this.acc._adjustOpened())},dhtmlXAccordionCell.prototype.isVisible=function(){return 1==this.conf.visible},dhtmlXAccordionCell.prototype.setHeight=function(t){this.acc.conf.multi_mode&&("*"==t?this.conf.h_auto=!0:(this.conf.h_auto=!1,this.conf.size.h=t),this.conf.opened&&("*"!=t&&(this.cell.style.height=t+"px"),this.acc._adjustOpened()))},dhtmlXAccordionCell.prototype.moveOnTop=function(){this.cell.parentNode.firstChild!=this.cell&&(this.cell.parentNode.insertBefore(this.cell,this.cell.parentNode.firstChild),this.acc._updateCellsMargin())},dhtmlXAccordionCell.prototype._initDocking=function(){var t=this;this.dock=function(){if(null!=this.acc.dhxWins&&1!=this.conf.docked){var t=this.acc.dhxWins.window(this._idd);t.close(),this._attachFromCell(t),this.conf.docked=!0,this.show(),this.conf.dock_opened&&this.open(),t=null,this.acc._callMainEvent("onDock",[this._idd])}},this.undock=function(t,e,n,i){if(null!=this.acc.dhxWins&&0!=this.conf.docked){var a;if(this.conf.dock_opened=this.conf.opened,null!=this.acc.dhxWins.window(this._idd))(a=this.acc.dhxWins.window(this._idd)).show();else null==t&&(t=20),null==e&&(e=20),null==n&&(n=320),null==i&&(i=200),(a=this.acc.dhxWins.createWindow(this._idd,t,e,n,i)).button("close").hide(),a.addUserButton("dock",99,"Dock"),a.button("dock").show(),a.button("dock").attachEvent("onClick",this._doOnDockClick),a.setText(this.getText()),a.attachEvent("onClose",this._doOnDockWinClose);this.conf.docked=!1,this.hide(),a._attachFromCell(this),a=null,this.acc._callMainEvent("onUnDock",[this._idd])}},this._doOnDockClick=function(){t.dock()},this._doOnDockWinClose=function(t){return t.hide(),!1},this._unloadDocking=function(){t=null}},dhtmlXCellObject.prototype.attachAccordion=function(t){this.callEvent("_onBeforeContentAttach",["acc"]);var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",this._attachObject(e),void 0===t&&(t={}),void 0===t.skin&&(t.skin=this.conf.skin),t.parent=e,"function"==typeof window.dhtmlXAccordionCell&&this instanceof window.dhtmlXAccordionCell&&("material"==this.conf.skin?e._ofs={t:-1,r:-1,b:-1,l:-1}:e._ofs={s:{first:-1},m:{first:4}}),"function"==typeof window.dhtmlXTabBarCell&&this instanceof window.dhtmlXTabBarCell&&("dhx_skyblue"!=this.conf.skin&&"material"!=this.conf.skin||(e._ofs={t:-1,r:-1,b:-1,l:-1})),"function"==typeof window.dhtmlXSideBarCell&&this instanceof window.dhtmlXSideBarCell&&("dhx_web"==this.conf.skin?(e._ofs={},1!=this.sidebar.conf.autohide&&(e._ofs.l=2),1==this.sidebar.conf.header&&(e._ofs.t=3)):(e._ofs={l:-1},"dhx_terrace"==this.conf.skin&&(1==this.sidebar.conf.autohide&&(e._ofs.l=0),1==this.sidebar.conf.header&&(e._ofs.t=-1)))),"function"==typeof window.dhtmlXCarouselCell&&this instanceof window.dhtmlXCarouselCell&&this._hideBorders(),this.dataType="acc",this.dataObj=new dhtmlXAccordion(t),t.parent=null,e=t=null,this.callEvent("_onContentAttach",[]),this.dataObj},dhtmlXAccordion.prototype.enableDND=function(){if(0!=this.conf.multi_mode&&null==this._dnd){var t=this;for(var e in this._dnd={tr_count:0,tr_items:{}},this._dndAttachEvent=function(t){var e=this.t[t].cell;1!=e.conf.dnd_inited&&("function"==typeof window.addEventListener?e.cell.childNodes[e.conf.idx.hdr].addEventListener("mousedown",this._dndOnMouseDown,!1):e.cell.childNodes[e.conf.idx.hdr].attachEvent("onmousedown",this._dndOnMouseDown),e.conf.dnd_inited=!0),e=null},this._dndDetachEvent=function(t){var e=this.t[t].cell;1==e.conf.dnd_inited&&("function"==typeof window.addEventListener?e.cell.childNodes[e.conf.idx.hdr].removeEventListener("mousedown",this._dndOnMouseDown,!1):e.cell.childNodes[e.conf.idx.hdr].detachEvent("onmousedown",this._dndOnMouseDown),e.conf.dnd_inited=!1),e=null},this._dndOnMouseDown=function(e){(e=e||event).preventDefault&&e.preventDefault();for(var n=e.target||e.srcElement;null!=n&&n.parentNode!=t.cont;)n=n.parentNode;null!=n&&t._dndDragStart(e,n),n=null},this._dndDragStart=function(t,e){if(1!=this._dnd.tr_waiting){for(var n=-1,i=0;i<e.parentNode.childNodes.length;i++)e.parentNode.childNodes[i]==e&&(n=i);if(!0===this.callEvent("onBeforeDrag",[e._accId,n])){"function"==typeof window.addEventListener?(document.body.addEventListener("mousemove",this._dndOnMouseMove,!1),document.body.addEventListener("mouseup",this._dndOnMouseUp,!1)):(document.body.attachEvent("onmousemove",this._dndOnMouseMove,!1),document.body.attachEvent("onmouseup",this._dndOnMouseUp,!1)),this._dnd.dragObj=e,this._dnd.dy=t.clientY;var a=0;for(i=0;i<this._dnd.dragObj.parentNode.childNodes.length;i++)this._dnd.dragObj.parentNode.childNodes[i]._ind=i,this._dnd.dragObj.parentNode.childNodes[i]==this._dnd.dragObj?(this._dnd.dragObj._k0=a,i>0&&(this._dnd.dragObj._k0+=this.ofs.m.between-this.ofs.m.first),a=0):a+=this._dnd.dragObj.parentNode.childNodes[i].offsetHeight+parseInt(this._dnd.dragObj.parentNode.childNodes[i].style.marginTop);this._dnd.dragObj._k1=a,this._dnd.h=this._dnd.dragObj.offsetHeight,this._dnd.ofs=!1}}},this._dndDoDrag=function(t){if(this._dnd.dragObj&&1!=this._dnd.tr_waiting){var e=t.clientY-this._dnd.dy;0==this._dnd.ofs&&Math.abs(e)>5&&(this._dnd.dragObj.className+=" acc_cell_dragged",this._dnd.ofs=!0),e<0?e<-this._dnd.dragObj._k0&&(e=-this._dnd.dragObj._k0):e>this._dnd.dragObj._k1&&(e=this._dnd.dragObj._k1),this._dnd.dragObj.style.top=e+"px";for(var n=t.clientY-this._dnd.dy,i=0,a=0,o=this._dnd.dragObj._ind+1;o<=this._dnd.dragObj.parentNode.lastChild._ind;o++){n>i+2*(s=this._dnd.dragObj.parentNode.childNodes[o].offsetHeight)/3&&a++,i+=s}var r=this._dnd.dragObj.nextSibling;for(o=0;null!=r;)++o<=a&&null!=r?r._ontop||(r._tm&&window.clearTimeout(r._tm),this._dndAnim(r,!1,parseInt(r.style.top||0),-this._dnd.h-this.ofs.m.between),r._ontop=!0):r._ontop&&(r._tm&&window.clearTimeout(r._tm),this._dndAnim(r,!0,parseInt(r.style.top||0),0),r._ontop=!1),r=r.nextSibling;for(n=this._dnd.dy-t.clientY,i=0,a=0,o=this._dnd.dragObj._ind-1;o>=this._dnd.dragObj.parentNode.firstChild._ind;o--){var s;n>i+2*(s=this._dnd.dragObj.parentNode.childNodes[o].offsetHeight)/3&&a++,i+=s}for(r=this._dnd.dragObj.previousSibling,o=0;null!=r;)++o<=a&&null!=r?r._onbottom||(r._tm&&window.clearTimeout(r._tm),this._dndAnim(r,!0,parseInt(r.style.top||0),this._dnd.h+this.ofs.m.between),r._onbottom=!0):r._onbottom&&(r._tm&&window.clearTimeout(r._tm),this._dndAnim(r,!1,parseInt(r.style.top),0),r._onbottom=!1),r=r.previousSibling}},this._dndDragStop=function(t,e){if(e);else if(this._dnd.tr_count>0)return void(this._dnd.tr_waiting=!0);if(this._dnd.dragObj){this._dnd.dragObj.className=String(this._dnd.dragObj.className).replace(/\s{0,}acc_cell_dragged/gi,""),this._dnd.dragObj.style.top="0px";for(var n=!1,i=0;i<this._dnd.dragObj.parentNode.childNodes.length;i++){var a=this._dnd.dragObj.parentNode.childNodes[i];a!=this._dnd.dragObj&&(a._tm&&window.clearTimeout(a._tm),a.style.top="0px",a._ontop&&(null!=a.nextSibling&&1!=a.nextSibling._ontop||!a.nextSibling)&&(n=a.nextSibling||null),a._onbottom&&(null!=a.previousSibling&&1!=a.previousSibling._onbottom||!a.previousSibling)&&(n=a)),a=null}for(i=0;i<this._dnd.dragObj.parentNode.childNodes.length;i++)this._dnd.dragObj.parentNode.childNodes[i]._ontop=null,this._dnd.dragObj.parentNode.childNodes[i]._onbottom=null;!1!==n&&(null==n?this._dnd.dragObj.parentNode.appendChild(this._dnd.dragObj):this._dnd.dragObj.parentNode.insertBefore(this._dnd.dragObj,n));var o=this._dnd.dragObj._accId,r=this._dnd.dragObj._ind,s=r;for(i=0;i<this._dnd.dragObj.parentNode.childNodes.length;i++)this._dnd.dragObj.parentNode.childNodes[i]==this._dnd.dragObj&&(s=i);this._dnd.dragObj=null,this._dnd.tr_waiting=!1,this._updateCellsMargin(),r!=s?(this.setSizes(),this.callEvent("onDrop",[o,r,s])):this.callEvent("_onDropCancel",[o]),"function"==typeof window.addEventListener?(document.body.removeEventListener("mousemove",this._dndOnMouseMove,!1),document.body.removeEventListener("mouseup",this._dndOnMouseUp,!1)):(document.body.detachEvent("onmousemove",this._dndOnMouseMove,!1),document.body.detachEvent("onmouseup",this._dndOnMouseUp,!1))}},this._dndAnim=function(e,n,i,a){if(0!=this.conf.tr.prop)return e._dnd_ev||(e._dnd_ev=!0,e._dnd_tr_prop=this.conf.tr.prop,e.addEventListener(this.conf.tr.ev,this._dndOnTrEnd,!1)),1!=this._dnd.tr_items[e._accId]&&(this._dnd.tr_items[e._accId]=!0,this._dnd.tr_count++),e.style[this.conf.tr.prop]=this.conf.tr.dnd_top,void(e.style.top=a+"px");var o=!1;n?(i+=5)>=a&&(i=a,o=!0):(i-=5)<=a&&(i=a,o=!0),e.style.top=i+"px",e._tm&&window.clearTimeout(e._tm),e._tm=o?null:window.setTimeout(function(){t._dndAnim(e,n,i,a)},5)},this._dndOnTrEnd=function(e){e.stopPropagation&&e.stopPropagation(),"top"==e.propertyName&&(1==t._dnd.tr_items[this._accId]&&(t._dnd.tr_count--,t._dnd.tr_items[this._accId]=!1),this.style[this._dnd_tr_prop]="",0==t._dnd.tr_count&&1==t._dnd.tr_waiting&&t._dndDragStop(null,!0))},this._dndOnMouseMove=function(e){t._dndDoDrag(e||event)},this._dndOnMouseUp=function(e){t._dndDragStop(e||event)},this._dndClearCell=function(t){this.t[t].cell.cell._dnd_ev&&this.t[t].cell.cell.addEventListener(this.conf.tr.ev,this._dndOnTrEnd,!1),this._dndDetachEvent(t)},this._unloadDND=function(){for(var e in this)0==String(e).indexOf("_dnd")&&"function"==typeof this[e]&&(this[e]=null);this._dnd=null,t=null},this.t)this._dndAttachEvent(e)}},dhtmlXLayoutObject.prototype=new dhtmlXCellTop,dhtmlXLayoutObject.prototype.cells=function(t){for(var e in this.cdata){if(this.cdata[e].conf.name==t)return this.cdata[e];if("layout"==this.cdata[e].dataType&&1==this.cdata[e].dataNested&&null!=this.cdata[e].dataObj){var n=this.cdata[e].dataObj.cells(t);if(null!=n)return n}}return null},dhtmlXLayoutObject.prototype.forEachItem=function(t,e){if("function"==typeof t){for(var n in void 0===e&&(e=this),this.cdata)void 0!==this.cdata[n].conf.name&&t.apply(e,[this.cdata[n]]),"layout"==this.cdata[n].dataType&&1==this.cdata[n].dataNested&&null!=this.cdata[n].dataObj&&this.cdata[n].dataObj.forEachItem(t,e);e=null}},dhtmlXLayoutObject.prototype._forEachSep=function(t,e){if("function"==typeof t){for(var n in void 0===e&&(e=this),null!=this.sep&&t.apply(e,[this.sep]),this.cdata)"layout"==this.cdata[n].dataType&&1==this.cdata[n].dataNested&&null!=this.cdata[n].dataObj&&this.cdata[n].dataObj._forEachSep(t,e);e=null}},dhtmlXLayoutObject.prototype._detectSW=function(){return null==this._confGlob.sw&&(this._confGlob.sw={}),null==this._confGlob.sw[this.conf.skin]&&(this._confGlob.sw[this.conf.skin]=window.dhx4.readFromCss("dhxlayout_sep_sw_"+this.conf.skin)),this._confGlob.sw[this.conf.skin]},dhtmlXLayoutObject.prototype._confGlob={},dhtmlXLayoutObject.prototype.listPatterns=function(){var t=[];for(var e in this.tplData)t.push(e);return t},dhtmlXLayoutObject.prototype.listAutoSizes=function(){return[null!=this.conf.as_cells?this.conf.as_cells.h.join(";"):"",null!=this.conf.as_cells?this.conf.as_cells.v.join(";"):"",this._availAutoSize[this.conf.pattern].h,this._availAutoSize[this.conf.pattern].v]},dhtmlXLayoutObject.prototype._getCellsNames=function(t){var e={};if(null!=this.cdata[t].conf.name&&(e[this.cdata[t].conf.name]=!0),"layout"==this.cdata[t].dataType&&null!=this.cdata[t].dataObj&&this.cdata[t].dataObj.mainInst==this){var n=this.cdata[t].dataObj._getCellsNames("a"),i=this.cdata[t].dataObj._getCellsNames("b");for(var a in n)e[a]=n[a];for(var a in i)e[a]=i[a]}return e},dhtmlXLayoutObject.prototype.setAutoSize=function(t,e,n){if(!0!==n){var i=this.listAutoSizes();if(i[0]==t&&i[1]==e)return;for(var a=!1,o=!1,r=0;r<i[2].length;r++)a=a||i[2][r]==t;for(r=0;r<i[3].length;r++)o=o||i[3][r]==e;if(!a||!o)return}this.conf.as_cells={h:t.split(";"),v:e.split(";")};var s="v"==this.conf.mode?"h":"v";for(var l in this.cdata){var d=this._getCellsNames(l),c=!1;for(r=0;r<this.conf.as_cells[s].length;r++)c=c||d[this.conf.as_cells[s][r]];c&&(this.conf.autosize=l),"layout"==this.cdata[l].dataType&&null!=this.cdata[l].dataObj&&this.cdata[l].dataObj.setAutoSize(t,e,!0)}},dhtmlXLayoutObject.prototype.tplData={"1C":{mode:"c",cells:{a:{name:"a"}}},"2E":{mode:"h",cells:{a:{name:"a",fsize:{v:1}},b:{name:"b",fsize:{v:1}}}},"2U":{mode:"v",cells:{a:{name:"a",fsize:{h:1}},b:{name:"b",fsize:{h:1}}}},"3E":{mode:"h",cells:{a:{name:"a",height:1/3,fsize:{v:1}},b:{layout:{mode:"h",cells:{a:{name:"b",fsize:{v:[1,2]}},b:{name:"c",fsize:{v:2}}}}}}},"3W":{mode:"v",cells:{a:{name:"a",width:1/3,fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{name:"b",fsize:{h:[1,2]}},b:{name:"c",fsize:{h:2}}}}}}},"3J":{mode:"v",cells:{a:{layout:{mode:"h",cells:{a:{name:"a",fsize:{h:1,v:2}},b:{name:"c",fsize:{h:1,v:2}}}}},b:{name:"b",fsize:{h:1}}}},"3L":{mode:"v",cells:{a:{name:"a",fsize:{h:1}},b:{layout:{mode:"h",cells:{a:{name:"b",fsize:{h:1,v:2}},b:{name:"c",fsize:{h:1,v:2}}}}}}},"3T":{mode:"h",cells:{a:{name:"a",fsize:{v:1}},b:{layout:{mode:"v",cells:{a:{name:"b",fsize:{h:2,v:1}},b:{name:"c",fsize:{h:2,v:1}}}}}}},"3U":{mode:"h",cells:{a:{layout:{mode:"v",cells:{a:{name:"a",fsize:{h:2,v:1}},b:{name:"b",fsize:{h:2,v:1}}}}},b:{name:"c",fsize:{v:1}}}},"4H":{mode:"v",cells:{a:{name:"a",width:1/3,fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{layout:{mode:"h",cells:{a:{name:"b",fsize:{h:[1,2],v:3}},b:{name:"c",fsize:{h:[1,2],v:3}}}}},b:{name:"d",fsize:{h:2}}}}}}},"4I":{mode:"h",cells:{a:{name:"a",height:1/3,fsize:{v:1}},b:{layout:{mode:"h",cells:{a:{layout:{mode:"v",cells:{a:{name:"b",fsize:{h:3,v:[1,2]}},b:{name:"c",fsize:{h:3,v:[1,2]}}}}},b:{name:"d",fsize:{v:2}}}}}}},"4T":{mode:"h",cells:{a:{name:"a",fsize:{v:1}},b:{layout:{mode:"v",cells:{a:{name:"b",width:1/3,fsize:{h:2,v:1}},b:{layout:{mode:"v",cells:{a:{name:"c",fsize:{h:[2,3],v:1}},b:{name:"d",fsize:{h:3,v:1}}}}}}}}}},"4U":{mode:"h",cells:{a:{layout:{mode:"v",cells:{a:{name:"a",width:1/3,fsize:{h:2,v:1}},b:{layout:{mode:"v",cells:{a:{name:"b",fsize:{h:[2,3],v:1}},b:{name:"c",fsize:{h:3,v:1}}}}}}}},b:{name:"d",fsize:{v:1}}}},"4E":{mode:"h",cells:{a:{name:"a",height:.25,fsize:{v:1}},b:{layout:{mode:"h",cells:{a:{name:"b",height:1/3,fsize:{v:[1,2]}},b:{layout:{mode:"h",cells:{a:{name:"c",fsize:{v:[2,3]}},b:{name:"d",fsize:{v:3}}}}}}}}}},"4W":{mode:"v",cells:{a:{name:"a",width:.25,fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{name:"b",width:1/3,fsize:{h:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"c",fsize:{h:[2,3]}},b:{name:"d",fsize:{h:3}}}}}}}}}},"4A":{mode:"v",cells:{a:{width:1/3,layout:{mode:"h",cells:{a:{name:"a",fsize:{h:1,v:2}},b:{name:"b",fsize:{h:1,v:2}}}}},b:{layout:{mode:"v",cells:{a:{name:"c",fsize:{h:[1,3]}},b:{name:"d",fsize:{h:3}}}}}}},"4L":{mode:"v",cells:{a:{name:"a",width:1/3,fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{name:"b",fsize:{h:[1,2]}},b:{layout:{mode:"h",cells:{a:{name:"c",fsize:{h:2,v:3}},b:{name:"d",fsize:{h:2,v:3}}}}}}}}}},"4J":{mode:"h",cells:{a:{name:"a",height:1/3,fsize:{v:1}},b:{layout:{mode:"h",cells:{a:{name:"b",fsize:{v:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"c",fsize:{h:3,v:2}},b:{name:"d",fsize:{h:3,v:2}}}}}}}}}},"4F":{mode:"h",cells:{a:{height:1/3,layout:{mode:"v",cells:{a:{name:"a",fsize:{h:2,v:1}},b:{name:"b",fsize:{h:2,v:1}}}}},b:{layout:{mode:"h",cells:{a:{name:"c",fsize:{v:[1,3]}},b:{name:"d",fsize:{v:3}}}}}}},"4G":{mode:"v",cells:{a:{layout:{mode:"h",cells:{a:{name:"a",height:1/3,fsize:{h:1,v:2}},b:{layout:{mode:"h",cells:{a:{name:"b",fsize:{h:1,v:[2,3]}},b:{name:"c",fsize:{h:1,v:3}}}}}}}},b:{name:"d",fsize:{h:1}}}},"4C":{mode:"v",cells:{a:{name:"a",fsize:{h:1}},b:{layout:{mode:"h",cells:{a:{name:"b",height:1/3,fsize:{h:1,v:2}},b:{layout:{mode:"h",cells:{a:{name:"c",fsize:{h:1,v:[2,3]}},b:{name:"d",fsize:{h:1,v:3}}}}}}}}}},"5H":{mode:"v",cells:{a:{width:1/3,name:"a",fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{layout:{mode:"h",cells:{a:{name:"b",height:1/3,fsize:{h:[1,2],v:3}},b:{layout:{mode:"h",cells:{a:{name:"c",fsize:{h:[1,2],v:[3,4]}},b:{name:"d",fsize:{h:[1,2],v:4}}}}}}}},b:{name:"e",fsize:{h:2}}}}}}},"5I":{mode:"h",cells:{a:{height:1/3,name:"a",fsize:{v:1}},b:{layout:{mode:"h",cells:{a:{layout:{mode:"v",cells:{a:{name:"b",width:1/3,fsize:{h:3,v:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"c",fsize:{h:[3,4],v:[1,2]}},b:{name:"d",fsize:{h:4,v:[1,2]}}}}}}}},b:{name:"e",fsize:{v:2}}}}}}},"5U":{mode:"h",cells:{a:{layout:{mode:"v",cells:{a:{name:"a",width:.25,fsize:{h:2,v:1}},b:{layout:{mode:"v",cells:{a:{name:"b",width:1/3,fsize:{h:[2,3],v:1}},b:{layout:{mode:"v",cells:{a:{name:"c",fsize:{h:[3,4],v:1}},b:{name:"d",fsize:{h:4,v:1}}}}}}}}}}},b:{name:"e",fsize:{v:1}}}},"5E":{mode:"h",cells:{a:{name:"a",height:.2,fsize:{v:1}},b:{layout:{mode:"h",cells:{a:{name:"b",height:.25,fsize:{v:[1,2]}},b:{layout:{mode:"h",cells:{a:{name:"c",height:1/3,fsize:{v:[2,3]}},b:{layout:{mode:"h",cells:{a:{name:"d",fsize:{v:[3,4]}},b:{name:"e",fsize:{v:4}}}}}}}}}}}}},"5W":{mode:"v",cells:{a:{name:"a",width:.2,fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{name:"b",width:.25,fsize:{h:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"c",width:1/3,fsize:{h:[2,3]}},b:{layout:{mode:"v",cells:{a:{name:"d",fsize:{h:[3,4]}},b:{name:"e",fsize:{h:4}}}}}}}}}}}}},"5K":{mode:"v",cells:{a:{layout:{mode:"h",cells:{a:{name:"a",height:1/3,fsize:{h:1,v:2}},b:{layout:{mode:"h",cells:{a:{name:"b",fsize:{h:1,v:[2,3]}},b:{name:"c",fsize:{h:1,v:3}}}}}}}},b:{layout:{mode:"h",cells:{a:{name:"d",fsize:{h:1,v:4}},b:{name:"e",fsize:{h:1,v:4}}}}}}},"5S":{mode:"v",cells:{a:{layout:{mode:"h",cells:{a:{name:"a",fsize:{h:1,v:2}},b:{name:"b",fsize:{h:1,v:2}}}}},b:{layout:{mode:"h",cells:{a:{name:"c",height:1/3,fsize:{h:1,v:3}},b:{layout:{mode:"h",cells:{a:{name:"d",fsize:{h:1,v:[3,2]}},b:{name:"e",fsize:{h:1,v:4}}}}}}}}}},"5G":{mode:"v",cells:{a:{width:1/3,layout:{mode:"h",cells:{a:{name:"a",height:1/3,fsize:{h:1,v:2}},b:{layout:{mode:"h",cells:{a:{name:"b",fsize:{h:1,v:[2,3]}},b:{name:"c",fsize:{h:1,v:3}}}}}}}},b:{layout:{mode:"v",cells:{a:{name:"d",fsize:{h:[1,4]}},b:{name:"e",fsize:{h:4}}}}}}},"5C":{mode:"v",cells:{a:{width:2/3,layout:{mode:"v",cells:{a:{name:"a",fsize:{h:2}},b:{name:"b",fsize:{h:[2,1]}}}}},b:{layout:{mode:"h",cells:{a:{name:"c",height:1/3,fsize:{h:1,v:3}},b:{layout:{mode:"h",cells:{a:{name:"d",fsize:{h:1,v:[3,4]}},b:{name:"e",fsize:{h:1,v:4}}}}}}}}}},"6H":{mode:"v",cells:{a:{width:1/3,name:"a",fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{layout:{mode:"h",cells:{a:{name:"b",height:.25,fsize:{h:[1,2],v:3}},b:{layout:{mode:"h",cells:{a:{name:"c",height:1/3,fsize:{h:[1,2],v:[3,4]}},b:{layout:{mode:"h",cells:{a:{name:"d",fsize:{h:[1,2],v:[4,5]}},b:{name:"e",fsize:{h:[1,2],v:5}}}}}}}}}}},b:{name:"f",fsize:{h:2}}}}}}},"6I":{mode:"h",cells:{a:{height:1/3,name:"a",fsize:{v:1}},b:{layout:{mode:"h",cells:{a:{layout:{mode:"v",cells:{a:{name:"b",width:.25,fsize:{h:3,v:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"c",width:1/3,fsize:{h:[3,4],v:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"d",fsize:{h:[4,5],v:[1,2]}},b:{name:"e",fsize:{h:5,v:[1,2]}}}}}}}}}}},b:{name:"f",fsize:{v:2}}}}}}},"6A":{mode:"v",cells:{a:{layout:{mode:"h",cells:{a:{name:"a",height:.2,fsize:{h:1,v:2}},b:{layout:{mode:"h",cells:{a:{name:"b",height:.25,fsize:{h:1,v:[2,3]}},b:{layout:{mode:"h",cells:{a:{name:"c",height:1/3,fsize:{h:1,v:[3,4]}},b:{layout:{mode:"h",cells:{a:{name:"d",fsize:{h:1,v:[4,5]}},b:{name:"e",fsize:{h:1,v:5}}}}}}}}}}}}}},b:{name:"f",fsize:{h:1}}}},"6C":{mode:"v",cells:{a:{name:"a",fsize:{h:1}},b:{layout:{mode:"h",cells:{a:{name:"b",height:.2,fsize:{h:1,v:2}},b:{layout:{mode:"h",cells:{a:{name:"c",height:.25,fsize:{h:1,v:[2,3]}},b:{layout:{mode:"h",cells:{a:{name:"d",height:1/3,fsize:{h:1,v:[3,4]}},b:{layout:{mode:"h",cells:{a:{name:"e",fsize:{h:1,v:[4,5]}},b:{name:"f",fsize:{h:1,v:5}}}}}}}}}}}}}}}},"6J":{mode:"v",cells:{a:{width:1/3,layout:{mode:"h",cells:{a:{name:"a",height:.25,fsize:{h:1,v:2}},b:{layout:{mode:"h",cells:{a:{name:"b",height:1/3,fsize:{h:1,v:[2,3]}},b:{layout:{mode:"h",cells:{a:{name:"c",fsize:{h:1,v:[3,4]}},b:{name:"d",fsize:{h:1,v:4}}}}}}}}}}},b:{layout:{mode:"v",cells:{a:{name:"e",fsize:{h:[1,5]}},b:{name:"f",fsize:{h:5}}}}}}},"6E":{mode:"v",cells:{a:{name:"a",width:1/3,fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{name:"b",fsize:{h:[1,2]}},b:{layout:{mode:"h",cells:{a:{name:"c",height:.25,fsize:{h:2,v:3}},b:{layout:{mode:"h",cells:{a:{name:"d",height:1/3,fsize:{h:2,v:[3,4]}},b:{layout:{mode:"h",cells:{a:{name:"e",fsize:{h:2,v:[4,5]}},b:{name:"f",fsize:{h:2,v:5}}}}}}}}}}}}}}}},"6W":{mode:"v",cells:{a:{name:"a",width:1/6,fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{name:"b",width:.2,fsize:{h:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"c",width:.25,fsize:{h:[2,3]}},b:{layout:{mode:"v",cells:{a:{name:"d",width:1/3,fsize:{h:[3,4]}},b:{layout:{mode:"v",cells:{a:{name:"e",fsize:{h:[4,5]}},b:{name:"f",fsize:{h:5}}}}}}}}}}}}}}}},"7H":{mode:"v",cells:{a:{name:"a",width:1/3,fsize:{h:1}},b:{layout:{mode:"v",cells:{a:{layout:{mode:"h",cells:{a:{name:"b",height:.2,fsize:{h:[1,2],v:3}},b:{layout:{mode:"h",cells:{a:{name:"c",height:.25,fsize:{h:[1,2],v:[3,4]}},b:{layout:{mode:"h",cells:{a:{name:"d",height:1/3,fsize:{h:[1,2],v:[4,5]}},b:{layout:{mode:"h",cells:{a:{name:"e",fsize:{h:[1,2],v:[5,6]}},b:{name:"f",fsize:{h:[1,2],v:6}}}}}}}}}}}}}},b:{name:"g",fsize:{h:2}}}}}}},"7I":{mode:"h",cells:{a:{name:"a",height:1/3,fsize:{v:1}},b:{layout:{mode:"h",cells:{a:{layout:{mode:"v",cells:{a:{name:"b",width:.2,fsize:{h:3,v:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"c",width:.25,fsize:{h:[3,4],v:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"d",width:1/3,fsize:{h:[4,5],v:[1,2]}},b:{layout:{mode:"v",cells:{a:{name:"e",fsize:{h:[5,6],v:[1,2]}},b:{name:"f",fsize:{h:6,v:[1,2]}}}}}}}}}}}}}},b:{name:"g",fsize:{v:2}}}}}}}},dhtmlXLayoutObject.prototype._availAutoSize={"1C":{h:["a"],v:["a"]},"2E":{h:["a;b"],v:["a","b"]},"2U":{h:["a","b"],v:["a;b"]},"3E":{h:["a;b;c"],v:["a","b","c"]},"3W":{h:["a","b","c"],v:["a;b;c"]},"3J":{h:["a;c","b"],v:["a;b","b;c"]},"3L":{h:["a","b;c"],v:["a;b","a;c"]},"3T":{h:["a;b","a;c"],v:["a","b;c"]},"3U":{h:["a;c","b;c"],v:["a;b","c"]},"4H":{h:["a","b;c","d"],v:["a;b;d","a;c;d"]},"4I":{h:["a;b;d","a;c;d"],v:["a","b;c","d"]},"4T":{h:["a;b","a;c","a;d"],v:["a","b;c;d"]},"4U":{h:["a;d","b;d","c;d"],v:["a;b;c","d"]},"4E":{h:["a;b;c;d"],v:["a","b","c","d"]},"4W":{h:["a","b","c","d"],v:["a;b;c;d"]},"4A":{h:["a;b","c","d"],v:["a;c;d","b;c;d"]},"4L":{h:["a","b","c;d"],v:["a;b;c","a;b;d"]},"4J":{h:["a;b;c","a;b;d"],v:["a","b","c;d"]},"4F":{h:["a;c;d","b;c;d"],v:["a;b","c","d"]},"4G":{h:["a;b;c","d"],v:["a;d","b;d","c;d"]},"4C":{h:["a","b;c;d"],v:["a;b","a;c","a;d"]},"5H":{h:["a","b;c;d","e"],v:["a;b;e","a;c;e","a;d;e"]},"5I":{h:["a;b;e","a;c;e","a;d;e"],v:["a","b;c;d","e"]},"5U":{h:["a;e","b;e","c;e","d;e"],v:["a;b;c;d","e"]},"5E":{h:["a;b;c;d;e"],v:["a","b","c","d","e"]},"5W":{h:["a","b","c","d","e"],v:["a;b;c;d;e"]},"5K":{h:["a;b;c","d;e"],v:["a;d","b;d","c;d","a;e","b;e","c;e"]},"5S":{h:["a;b","c;d;e"],v:["a;c","a;d","a;e","b;c","b;d","b;e"]},"5G":{h:["a;b;c","d","e"],v:["a;d;e","b;d;e","c;d;e"]},"5C":{h:["a","b","c;d;e"],v:["a;b;c","a;b;d","a;b;e"]},"6H":{h:["a","b;c;d;e","f"],v:["a;b;f","a;c;f","a;d;f","a;e;f"]},"6I":{h:["a;b;f","a;c;f","a;d;f","a;e;f"],v:["a","b;c;d;e","f"]},"6A":{h:["a;b;c;d;e","f"],v:["a;f","b;f","c;f","d;f","e;f"]},"6C":{h:["a","b;c;d;e;f"],v:["a;b","a;c","a;d","a;e","a;f"]},"6J":{h:["a;b;c;d","e","f"],v:["a;e;f","b;e;f","c;e;f","d;e;f"]},"6E":{h:["a","b","c;d;e;f"],v:["a;b;c","a;b;d","a;b;e","a;b;f"]},"6W":{h:["a","b","c","d","e","f"],v:["a;b;c;d;e;f"]},"7H":{h:["a","b;c;d;e;f","g"],v:["a;b;g","a;c;g","a;d;g","a;e;g","a;f;g"]},"7I":{h:["a;b;g","a;c;g","a;d;g","a;e;g","a;f;g"],v:["a","b;c;d;e;f","g"]}},dhtmlXLayoutObject.prototype.setSeparatorSize=function(t,e){if("number"!=typeof t){for(var n in this.cdata){if("layout"==this.cdata[n].dataType&&1==this.cdata[n].dataNested&&null!=this.cdata[n].dataObj&&null!=(t=this.cdata[n].dataObj.setSeparatorSize(t,e)).sep)return t;if("a"==n&&null!=this.sep&&(t.current++,t.index==t.current))return{sep:this.sep}}return t}var i=this.setSeparatorSize({index:t,current:-1},e);null!=i.sep&&i.sep._setWH(e)},window.dhtmlXLayoutCell=function(t,e){dhtmlXCellObject.apply(this,[t,"_layout"]);var n=this;if(this.layout=e,this.conf.skin=this.layout.conf.skin,this.conf.mode=this.layout.conf.mode,this.conf.collapsed=!1,this.conf.fixed={w:!1,h:!1},this.conf.docked=!0,"material"==this.conf.skin?(this.conf.min_width=42,this.conf.min_height=26):(this.conf.min_width=26,this.conf.min_height=26),this.attachEvent("_onCellUnload",function(){this.cell.childNodes[this.conf.idx.hdr].ondblclick=null,"c"!=this.conf.mode&&(this.cell.childNodes[this.conf.idx.hdr].lastChild.onclick=null),this._unloadDocking(),this.layout=null,n=null}),this._hdrInit(),this.cell.childNodes[this.conf.idx.hdr].ondblclick=function(){var t=n.layout._getMainInst();t._callMainEvent("onDblClick",[n.conf.name]),t=null},this.attachEvent("_onContentLoaded",function(){var t=this.layout._getMainInst();t._callMainEvent("onContentLoaded",[this.conf.name]),t=null}),"c"!=this.conf.mode){var i=document.createElement("DIV");i.title=this.i18n.expand,i.className="dhxlayout_arrow dhxlayout_arrow_"+this.conf.mode+this._idd,this.cell.childNodes[this.conf.idx.hdr].appendChild(i),i.onclick=function(t){n.conf.collapsed?n.expand():n.collapse()},i=null}return this.attachEvent("_onBeforeContentAttach",function(t){"tabbar"!=t&&"layout"!=t&&"acc"!=t||this._hideBorders(),"sidebar"==t&&"dhx_skyblue"!=this.conf.skin&&"dhx_terrace"!=this.conf.skin&&(this._hideBorders(),this.showHeader())}),this._initDocking(),this},dhtmlXLayoutCell.prototype=new dhtmlXCellObject,dhtmlXLayoutCell.prototype.i18n={expand:"Expand / Collapse"},dhtmlXLayoutCell.prototype.getId=function(){return this.conf.name},dhtmlXLayoutCell.prototype._initDocking=function(){var t=this;this.dock=function(){var t=this.layout._getMainInst();if(null==t.dhxWins||this.conf.docked)t=null;else{var e=t.dhxWins.window(this.conf.name);e.close(),this._attachFromCell(e),this.conf.docked=!0,this.conf.dock_collapsed||this.expand(),t._callMainEvent("onDock",[this.conf.name]),t=e=null}},this.undock=function(t,e,n,i){var a=this.layout._getMainInst();if(null!=a.dhxWins&&0!=this.conf.docked){var o;if(this.conf.dock_collapsed=this.conf.collapsed,this.conf.collapsed||this.collapse(),null!=a.dhxWins.window(this.conf.name))(o=a.dhxWins.window(this.conf.name)).show();else null==t&&(t=20),null==e&&(e=20),null==n&&(n=320),null==i&&(i=200),(o=a.dhxWins.createWindow(this.conf.name,t,e,n,i)).button("close").hide(),o.addUserButton("dock",99,"Dock"),o.button("dock").show(),o.button("dock").attachEvent("onClick",this._doOnDockClick),o.setText(this.getText()),o.attachEvent("onClose",this._doOnDockWinClose);this.conf.docked=!1,o._attachFromCell(this),a._callMainEvent("onUnDock",[this.conf.name]),a=o=null}else a=null},this._doOnDockClick=function(){t.dock()},this._doOnDockWinClose=function(t){return t.hide(),!1},this._unloadDocking=function(){t=null}},dhtmlXLayoutCell.prototype._hdrInit=function(){var t="";window.dhx4.isIE?-1!=navigator.userAgent.indexOf("MSIE 9.0")?t=" dhx_cell_hdr_text_ie9":window.dhx4.isIE8?t=" dhx_cell_hdr_text_ie8":window.dhx4.isIE7?t=" dhx_cell_hdr_text_ie7":window.dhx4.isIE6&&(t=" dhx_cell_hdr_text_ie6"):(window.dhx4.isChrome||window.dhx4.isKHTML)&&(t=" dhx_cell_hdr_text_chrome");var e=document.createElement("DIV");e.className="dhx_cell_hdr",e.innerHTML="<div class='dhx_cell_hdr_text"+t+"'></div>",this.cell.insertBefore(e,this.cell.childNodes[this.conf.idx.cont]),e=null,this.conf.ofs_nodes.t._getHdrHeight="func",this.conf.hdr={visible:!0},this.conf.idx_data.hdr="dhx_cell_hdr",this._updateIdx(),this.attachEvent("_onSetSize",this._hdrOnSetSize),this.attachEvent("_onBorderChange",this._hdrOnBorderChange),this.attachEvent("_onViewSave",this._hdrOnViewSave),this.attachEvent("_onViewRestore",this._hdrOnViewRestore)},dhtmlXLayoutCell.prototype.showHeader=function(t){this.conf.hdr.visible||this.conf.collapsed||this.conf.hdr.w_saved>this._getAvailWidth()||this.conf.hdr.h_saved>this._getAvailHeight()||(this.conf.hdr.w_saved=this.conf.hdr.h_saved=null,this.conf.hdr.visible=!0,this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_hdr",!0!==t&&this._adjustCont(this._idd))},dhtmlXLayoutCell.prototype.hideHeader=function(t){this.conf.hdr.visible&&!this.conf.collapsed&&(this.conf.hdr.w_saved=this._getMinWidth(this._idd),this.conf.hdr.h_saved=this._getMinHeight(this._idd),this.conf.hdr.visible=!1,this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_hdr dhx_cell_hdr_hidden",this._hdrUpdBorder(),this._mtbUpdBorder(),!0!==t&&this._adjustCont(this._idd))},dhtmlXLayoutCell.prototype.isHeaderVisible=function(){return 1==this.conf.hdr.visible},dhtmlXLayoutCell.prototype.showArrow=function(){this.cell.childNodes[this.conf.idx.hdr].childNodes[1].style.display=""},dhtmlXLayoutCell.prototype.hideArrow=function(){this.cell.childNodes[this.conf.idx.hdr].childNodes[1].style.display="none"},dhtmlXLayoutCell.prototype.isArrowVisible=function(){return""==this.cell.childNodes[this.conf.idx.hdr].childNodes[1].style.display},dhtmlXLayoutCell.prototype.setText=function(t){this.conf.hdr.text=t,this._hdrUpdText()},dhtmlXLayoutCell.prototype.getText=function(){return this.conf.hdr.text},dhtmlXLayoutCell.prototype.setCollapsedText=function(t){this.conf.hdr.text_collapsed=t,this._hdrUpdText()},dhtmlXLayoutCell.prototype.getCollapsedText=function(){return null!=this.conf.hdr.text_collapsed?this.conf.hdr.text_collapsed:this.conf.hdr.text},dhtmlXLayoutCell.prototype._hdrUpdText=function(){var t=1==this.conf.collapsed&&null!=this.conf.hdr.text_collapsed?this.conf.hdr.text_collapsed:this.conf.hdr.text;this.cell.childNodes[this.conf.idx.hdr].firstChild.innerHTML="<span>"+t+"</span>"},dhtmlXLayoutCell.prototype._hdrUpdBorder=function(){1==this.conf.borders?this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_hdr"+(this.conf.hdr.visible?"":" dhx_cell_hdr_hidden"):this.conf.hdr.visible||(this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_hdr dhx_cell_hdr_hidden_no_borders")},dhtmlXLayoutCell.prototype._hdrOnSetSize=function(){this.conf.collapsed&&"v"==this.conf.mode&&this._fitHdr()},dhtmlXLayoutCell.prototype._hdrOnBorderChange=function(){this.hideHeader(!0),this._hdrUpdBorder()},dhtmlXLayoutCell.prototype._hdrOnViewSave=function(t){this.views[t].hdr_vis=this.conf.hdr.visible},dhtmlXLayoutCell.prototype._hdrOnViewRestore=function(t){this.conf.hdr.visible!=this.views[t].hdr_vis&&this[this.views[t].hdr_vis?"showHeader":"hideHeader"](!0),this.views[t].hdr_vis=null,delete this.views[t].hdr_vis},dhtmlXLayoutCell.prototype._getHdrHeight=function(t){return this.conf.collapsed&&"v"==this.conf.mode&&!0!==t?27:this.cell.childNodes[this.conf.idx.hdr].offsetHeight},dhtmlXLayoutCell.prototype._fitHdr=function(){var t=this.cell.childNodes[this.conf.idx.hdr];if(1==this.conf.collapsed){void 0===dhtmlXLayoutObject.prototype._confGlob.hdrColH&&(t.style.height=this.cell.offsetHeight+"px",dhtmlXLayoutObject.prototype._confGlob.hdrColH=parseInt(t.style.height)-this._getHdrHeight(!0));var e=this.cell.offsetHeight+dhtmlXLayoutObject.prototype._confGlob.hdrColH;t.style.height=e+"px",t.firstChild.style.width=e-39+"px"}else t.firstChild.style.width=t.style.height=null;t=null},dhtmlXLayoutCell.prototype.expand=function(t){if(!this.conf.collapsed)return!0;var e=this.layout;if("v"==this.conf.mode){var n=t?e.conf.hh:e.cdata[e.conf.nextCell[this._idd]]._getMinWidth(this._idd),i=e.cont.offsetWidth-e.conf.sw;if(n+this.conf.size.w_avl>i)return e=null,!1}else{var a=t?e.conf.hh:e.cdata[e.conf.nextCell[this._idd]]._getMinHeight(this._idd)+e.cdata[e.conf.nextCell[this._idd]]._getHdrHeight(),o=e.cont.offsetHeight-e.conf.sw;if(a+this.conf.size.h_avl>o)return e=null,!1}if(0!=this.conf.docked){0==this.conf.hdr.visible&&(this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_hdr dhx_cell_hdr_hidden",this._hdrUpdBorder()),this.cell.className=String(this.cell.className).replace(/\s{0,}dhxlayout_collapsed_[hv]/gi,""),this.conf.collapsed=!1,"v"==this.conf.mode?(this.conf.size.w=Math.min(i-n,this.conf.size.w_saved),this.conf.size.w_saved=this.conf.size.w_avl=null):(this.conf.size.h=Math.min(o-a,this.conf.size.h_saved),this.conf.size.h_saved=this.conf.size.h_avl=null),"v"==this.conf.mode&&this._fitHdr(),e.setSizes(e.conf.nextCell[this._idd],e.conf.nextCell[this._idd],1==t,"expand"),e.sep._blockSep(),e=null,this._hdrUpdText();var r=this.layout._getMainInst();return r._callMainEvent("onExpand",[this.conf.name]),r=null,!0}this.dock()},dhtmlXLayoutCell.prototype.collapse=function(){if(this.conf.collapsed)return!1;var t=this.layout;if(0==t.cdata[t.conf.nextCell[this._idd]].expand(!0))return!1;"v"==this.conf.mode?(this.conf.size.w_saved=this.conf.size.w,this.conf.size.w_avl=this._getMinWidth(this._idd)):(this.conf.size.h_saved=this.conf.size.h,this.conf.size.h_avl=this._getMinHeight(this._idd)+this._getHdrHeight()),0==this.conf.hdr.visible&&(this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_hdr"),this.cell.className+=" dhxlayout_collapsed_"+this.conf.mode,this.conf.collapsed=!0,"v"==this.conf.mode?this.conf.size.w=t.conf.hh:this.conf.size.h=this._getHdrHeight(),t.setSizes(t.conf.nextCell[this._idd],t.conf.nextCell[this._idd],!1,"collapse"),t.sep._blockSep(),t=null,this._hdrUpdText();var e=this.layout._getMainInst();return e._callMainEvent("onCollapse",[this.conf.name]),e=null,!0},dhtmlXLayoutCell.prototype.isCollapsed=function(){return 1==this.conf.collapsed},dhtmlXLayoutCell.prototype.setMinWidth=function(t){this.conf.min_width=parseInt(t)||0},dhtmlXLayoutCell.prototype.setMinHeight=function(t){this.conf.min_height=parseInt(t)||0},dhtmlXLayoutCell.prototype._getMinWidth=function(t){if("layout"==this.dataType&&null!=this.dataObj){if(this.layout._getMainInst()!=this.dataObj._getMainInst())return this.dataObj._getAvailWidth();if("1C"==this.dataObj.conf.pattern)return Math.max(this.conf.min_width,this.dataObj.cdata.a._getMinWidth(t));if("v"==this.dataObj.conf.mode){var e=t||this._idd;return this.dataObj.cdata[e].conf.collapsed&&(e=this.dataObj.conf.nextCell[e]),Math.max(this.conf.min_width,this.dataObj.cdata[e]._getMinWidth(t)+this.dataObj.cdata[this.dataObj.conf.nextCell[e]]._getWidth()+this.dataObj.conf.sw)}return Math.max(this.conf.min_width,this.dataObj.cdata.a._getMinWidth(t),this.dataObj.cdata.b._getMinWidth(t))}return Math.max(this.conf.min_width,1)},dhtmlXLayoutCell.prototype._getMinHeight=function(t){var e=0;if(null!=this.conf.idx.menu&&(e+=this.cell.childNodes[this.conf.idx.menu].offsetHeight),"layout"==this.dataType&&null!=this.dataObj){if(this.layout._getMainInst()!=this.dataObj._getMainInst())return this.dataObj._getAvailHeight();if("1C"==this.dataObj.conf.pattern)return Math.max(this.conf.min_height,this.dataObj.cdata.a._getMinHeight(t));if("h"==this.dataObj.conf.mode){var n=t;return this.dataObj.cdata[n].conf.collapsed&&(n=this.dataObj.conf.nextCell[n]),Math.max(this.conf.min_height,this.dataObj.cdata[n]._getMinHeight(t)+this.dataObj.cdata[n]._getHdrHeight()+this.dataObj.cdata[this.dataObj.conf.nextCell[n]]._getHeight()+this.dataObj.conf.sw)}return Math.max(this.conf.min_height,this.dataObj.cdata.a._getMinHeight(t)+this.dataObj.cdata.a._getHdrHeight(),this.dataObj.cdata.b._getMinHeight(t)+this.dataObj.cdata.b._getHdrHeight())}return Math.max(this.conf.min_height,e)},dhtmlXLayoutCell.prototype._getAvailWidth=function(t){if("layout"==this.dataType&&null!=this.dataObj){if("1C"==this.dataObj.conf.pattern)return this.dataObj.cdata.a._getAvailWidth(t);if("v"==this.dataObj.conf.mode){var e=1==this.dataObj.cdata.a.conf.collapsed,n=1==this.dataObj.cdata.b.conf.collapsed;return"a"==t?this.dataObj.cdata[n?"a":"b"]._getAvailWidth(t):this.dataObj.cdata[e?"b":"a"]._getAvailWidth(t)}return Math.min(this.dataObj.cdata.a._getAvailWidth(t),this.dataObj.cdata.b._getAvailWidth(t))}return this.cell.offsetWidth-this._getMinWidth()},dhtmlXLayoutCell.prototype._getAvailHeight=function(t){if("layout"==this.dataType&&null!=this.dataObj){if("1C"==this.dataObj.conf.pattern)return this.dataObj.cdata.a._getAvailHeight(t);if("h"==this.dataObj.conf.mode){var e=1==this.dataObj.cdata.a.conf.collapsed,n=1==this.dataObj.cdata.b.conf.collapsed;return"a"==t?this.dataObj.cdata[n?"a":"b"]._getAvailHeight(t):this.dataObj.cdata[e?"b":"a"]._getAvailHeight(t)}return Math.min(this.dataObj.cdata.a._getAvailHeight(t),this.dataObj.cdata.b._getAvailHeight(t))}var i=this._getHdrHeight();return"v"==this.conf.mode&&this.conf.collapsed&&(i=this.conf.hh),this.cell.offsetHeight-i-this._getMinHeight()},dhtmlXLayoutCell.prototype.setWidth=function(t){if("v"==this.conf.mode){if(this.conf.collapsed)return;if((o=(i=this.layout).cdata[i.conf.nextCell[this._idd]]).conf.collapsed)return t=t+i.conf.sw+o._getWidth(),void(a=i=o=null);var e=this._getMinWidth(this._idd),n=i.cont.offsetWidth-o._getMinWidth(this._idd)-i.conf.sw;t=Math.max(e,Math.min(t,n)),this.conf.size.w=t,i.setSizes(o._idd,o._idd),i=o=null}else{if(null==this.layout||null==this.layout.parentLayout)return;var i,a=this.layout.parentLayout,o=(i=this.layout).cdata[i.conf.nextCell[this._idd]];for(var r in a.cdata)a.cdata[r].dataObj==i&&a.cdata[r].setWidth(t);a=i=null}},dhtmlXLayoutCell.prototype.setHeight=function(t){if("h"==this.conf.mode){if(this.conf.collapsed)return;if((r=(a=this.layout).cdata[a.conf.nextCell[this._idd]]).conf.collapsed){if(t=t+a.conf.sw+r._getHeight(),null!=(o=null!=this.layout&&null!=this.layout.parentLayout?this.layout.parentLayout:null))for(var e in o.cdata)o.cdata[e].dataObj==a&&o.cdata[e].setHeight(t);return void(o=a=r=null)}var n=this._getMinHeight(this._idd)+this._getHdrHeight(),i=a.cont.offsetHeight-r._getMinHeight(this._idd)-r._getHdrHeight()-a.conf.sw;t=Math.max(n,Math.min(t,i)),this.conf.size.h=t,a.setSizes(r._idd,r._idd),a=r=null}else{if(null==this.layout||null==this.layout.parentLayout)return;var a,o=this.layout.parentLayout,r=(a=this.layout).cdata[a.conf.nextCell[this._idd]];for(var e in o.cdata)o.cdata[e].dataObj==a&&o.cdata[e].setHeight(t);o=a=null}},dhtmlXLayoutCell.prototype.getWidth=function(){return this.conf.size.w},dhtmlXLayoutCell.prototype.getHeight=function(){return this.conf.size.h},dhtmlXLayoutCell.prototype.fixSize=function(t,e){this.conf.fixed.w=window.dhx4.s2b(t),this.conf.fixed.h=window.dhx4.s2b(e);var n=this.layout._getMainInst(),i={};n.forEachItem(function(t){if(null!=t.conf.fsize){t.getId();var e={h:1==t.conf.fixed.w,v:1==t.conf.fixed.h};for(var n in e)if(1==e[n]&&null!=t.conf.fsize[n]){t.conf.fsize[n]instanceof Array||(t.conf.fsize[n]=[t.conf.fsize[n]]);for(var a=0;a<t.conf.fsize[n].length;a++)i[t.conf.fsize[n][a]]=!0}}t=null}),n._forEachSep(function(t){t._lockSep(1==i[t.conf.idx]),t=null}),n=null},dhtmlXCellObject.prototype.attachLayout=function(t){this.callEvent("_onBeforeContentAttach",["layout"]);var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden",this._attachObject(e),void 0!==this._layoutMainInst&&(e._layoutMainInst=this._layoutMainInst),"function"==typeof window.dhtmlXLayoutCell&&this instanceof window.dhtmlXLayoutCell&&(e._isParentCell=!0,"material"==this.conf.skin&&null==String(this.cell.className).match(/dhx_cell_nested_layout/)&&(this.cell.className+=" dhx_cell_nested_layout")),"function"==typeof window.dhtmlXAccordionCell&&this instanceof window.dhtmlXAccordionCell&&("material"==this.conf.skin?e._ofs={t:14,r:14,b:14,l:14}:e._ofs={t:-1,r:-1,l:-1,b:-1}),"function"==typeof window.dhtmlXTabBarCell&&this instanceof window.dhtmlXTabBarCell&&("dhx_skyblue"==this.conf.skin&&(e._ofs={t:-1,r:-1,b:-1,l:-1}),"material"==this.conf.skin&&(e._ofs={t:8,r:8,b:8,l:8})),"function"==typeof window.dhtmlXSideBarCell&&this instanceof window.dhtmlXSideBarCell&&("dhx_web"==this.conf.skin?(e._ofs={l:8},1==this.sidebar.conf.autohide&&(e._ofs.l=0),1==this.sidebar.conf.header&&(e._ofs.t=9)):"dhx_terrace"==this.conf.skin?(e._ofs={l:11},1==this.sidebar.conf.autohide&&(e._ofs.l=0),1==this.sidebar.conf.header&&(e._ofs.t=10)):e._ofs={l:-1}),"function"==typeof window.dhtmlXCarouselCell&&this instanceof window.dhtmlXCarouselCell&&this._hideBorders(),"function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell&&"material"==this.conf.skin&&(e._ofs={t:14,r:14,b:14,l:14}),"string"==typeof t&&(t={pattern:t}),void 0===t.skin&&(t.skin=this.conf.skin),t.parent=e,this.dataType="layout",this.dataObj=new dhtmlXLayoutObject(t),this instanceof window.dhtmlXLayoutCell&&(this.dataObj.parentLayout=this.layout),e._layoutMainInst=null,t.parent=null,e=t=null,this.callEvent("_onContentAttach",[]),this.dataObj},dhtmlXTabBar.prototype=new dhtmlXCellTop,dhtmlXTabBar.prototype._fixTabsOfs=function(){this.conf.tabsOfs={dhx_skyblue:1,dhx_web:0,dhx_terrace:1,material:0}[this.conf.skin]},dhtmlXTabBar.prototype.cells=dhtmlXTabBar.prototype.tabs=function(t){return this.t[t]?this.t[t].cell:null},dhtmlXTabBar.prototype.getAllTabs=function(){var t=[];for(var e in this.t)t.push(e);return t},dhtmlXTabBar.prototype._setTabActive=function(t,e){this.t[t]&&!this.t[t].conf.active&&(void 0===e&&(e=!0),1==e&&!0!==this.callEvent("onSelect",[t,this.conf.lastActive])||(this.setTabInActive(),this.t[t].conf.active=!0,this.conf.contZone&&(this.t[t].cell.cell.style.visibility="visible",this.t[t].cell.cell.style.top="0px",this.t[t].cell.cell.style.zIndex=1),this.t[t].tab.className=this._tabCss(t),this.conf.lastActive=t,this.setSizes(),1==this.conf.url_demand&&this._loadURLOnDemand(t)))},dhtmlXTabBar.prototype.setTabInActive=function(){null!=this.conf.lastActive&&this.t[this.conf.lastActive]&&(this.t[this.conf.lastActive].conf.active=!1,this.conf.contZone&&(this.t[this.conf.lastActive].cell.cell.style.visibility="hidden",this.t[this.conf.lastActive].cell.cell.style.top="-5000px",this.t[this.conf.lastActive].cell.cell.style.zIndex=0),this.t[this.conf.lastActive].tab.className=this._tabCss(this.conf.lastActive),this.conf.lastActive=null)},dhtmlXTabBar.prototype._isTabActive=function(t){return t==this.conf.lastActive&&null!=this.conf.lastActive},dhtmlXTabBar.prototype.getActiveTab=function(){return this.conf.lastActive},dhtmlXTabBar.prototype.goToNextTab=function(){var t=this._getNextVisible(this.conf.lastActive,!0);null!=t&&this._setTabActive(t)},dhtmlXTabBar.prototype.goToPrevTab=function(){var t=this._getPrevVisible(this.conf.lastActive,!0);null!=t&&this._setTabActive(t)},dhtmlXTabBar.prototype._enableTab=function(t,e){this.t[t]&&!this.t[t].conf.enabled&&(this.t[t].conf.enabled=!0,this.t[t].tab.className=this._tabCss(t),1==e&&this._setTabActive(t))},dhtmlXTabBar.prototype._disableTab=function(t,e){this.t[t]&&this.t[t].conf.enabled&&(this.t[t].conf.enabled=!1,this.t[t].tab.className=this._tabCss(t),!1!==e&&this.conf.lastActive==t&&(1==e&&(e=this._getNextVisible(t)||this._getPrevVisible(t)),this._setTabActive(e)))},dhtmlXTabBar.prototype._isTabEnabled=function(t){return null!=this.t[t]&&1==this.t[t].conf.enabled},dhtmlXTabBar.prototype._setTabText=function(t,e,n){if(this.t[t]){var i=!1;void 0!==n&&null!=n||(n=this._getLabelWidth(e,this.t[t].conf.close),i=!0),this.t[t].tab.style.width=n+"px",this.t[t].tab.childNodes[0].innerHTML=e,this.t[t].conf.text=e,this.t[t].conf.width=n,this.t[t].conf.autowidth=i}},dhtmlXTabBar.prototype._getTabText=function(t){return this.t[t]?this.t[t].conf.text:null},dhtmlXTabBar.prototype._removeTab=function(t,e,n){if(this.t[t]){if(1!=n&&1!=this.t[t].conf.remove)return this.t[t].conf.remove=!0,void this._hideTab(t,e);void 0===e&&(e=!0);var i=this._getNextVisible(t),a=this._getPrevVisible(t);for(var o in 1==this.t[t].conf.transEv&&(this.t[t].tab.removeEventListener(this.conf.transEv,this._doOnTrEnd,!1),this.t[t].conf.transEv=!1),this.t[t].conf)this.t[t].conf[o]=null;if(this.t[t].conf=null,delete this.t[t].conf,this.t[t].cell._unload(),this.t[t].cell=null,this.t[t].tab.parentNode.removeChild(this.t[t].tab),this.t[t].tab=null,this.t[t]=null,delete this.t[t],this.conf.urls[t]=null,delete this.conf.urls[t],this.conf.lastActive==t){if(this.conf.lastActive=null,0!=e){var r=1==e?i||a||this._getFirstVisible():e;null!=r&&this._setTabActive(r)}}else 1!=n&&this._adjustTabs()}},dhtmlXTabBar.prototype.clearAll=function(){for(var t in this.t)this._removeTab(t,!1,!0);this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align]="0px"},dhtmlXTabBar.prototype.moveTab=function(t,e){if(this.t[t]&&!(e<0)){e+=1;var n=this.tabsArea.childNodes[1].firstChild;n.childNodes[e]!=this.t[t].tab&&(n.removeChild(this.t[t].tab),e>=n.childNodes.length?n.appendChild(this.t[t].tab):n.insertBefore(this.t[t].tab,n.childNodes[e])),n=null}},dhtmlXTabBar.prototype._getIndex=function(t){for(var e=-1,n=this.tabsArea.childNodes[1].firstChild,i=1;i<n.childNodes.length;i++)n.childNodes[i]._tabId==t&&(e=i-1);return n=null,e},dhtmlXTabBar.prototype.getNumberOfTabs=function(t){var e=0;for(var n in this.t)e+=1!=t?1:1==this.t[n].conf.visible?1:0;return e},dhtmlXTabBar.prototype.forEachCell=dhtmlXTabBar.prototype.forEachTab=function(t){for(var e in this.t)t.apply(window,[this.t[e].cell])},dhtmlXTabBar.prototype.enableAutoReSize=function(){this._initFSResize()},dhtmlXTabBar.prototype.setArrowsMode=function(t){null!=(t={auto:"auto",always:"always"}[String(t)])&&t!=this.conf.mode&&(this.conf.arwMode=t,"always"==t&&(this.tabsArea.childNodes[0].className="dhxtabbar_tabs_ar_left",this.tabsArea.childNodes[2].className="dhxtabbar_tabs_ar_right"),this.setSizes())},dhtmlXTabBar.prototype._checkArrows=function(){var t=!1;if("auto"==this.conf.arwMode){var e=0;for(var n in this.t)e+=this.t[n].tab.offsetWidth;var i=this.tabsArea.childNodes[0],a=this.tabsArea.childNodes[2];e>this.cont.offsetWidth?i.className.search(/dhxtabbar_tabs_ar_hidden/)>=0&&(i.className=i.className.replace(/\s{0,}dhxtabbar_tabs_ar_hidden/,""),a.className=a.className.replace(/\s{0,}dhxtabbar_tabs_ar_hidden/,""),t=!0):i.className.search(/dhxtabbar_tabs_ar_hidden/)<1&&(i.className+=" dhxtabbar_tabs_ar_hidden",a.className+=" dhxtabbar_tabs_ar_hidden",t=!0),i=a=null}return t},dhtmlXTabBar.prototype._loadURLOnDemand=function(t){null!=t&&null!=this.conf.urls[t]&&(this.cells(t).attachURL(this.conf.urls[t].href,this.conf.urls[t].ajax),this.conf.urls[t]=null)},window.dhtmlXTabBarCell=function(t,e){for(var n in dhtmlXCellObject.apply(this,[t,"_tabbar"]),this.tabbar=e,this.conf.skin=this.tabbar.conf.skin,this.conf.tabbar_funcs={show:"_showTab",hide:"_hideTab",isVisible:"_isTabVisible",enable:"_enableTab",disable:"_disableTab",isEnabled:"_isTabEnabled",getIndex:"_getIndex",getText:"_getTabText",setText:"_setTabText",setActive:"_setTabActive",isActive:"_isTabActive",close:"_removeTab"},this._tabbarCall=function(t){return function(){for(var e=[this._idd],n=0;n<arguments.length;n++)e.push(arguments[n]);return this.tabbar[t].apply(this.tabbar,e)}},this.conf.tabbar_funcs)"function"!=typeof this[n]&&(this[n]=this._tabbarCall(this.conf.tabbar_funcs[n]));this.attachEvent("_onCellUnload",function(){for(var t in this.tabbar=null,this.conf.tabbar_funcs)this[t]=null,this.conf.tabbar_funcs[t]=null;this.conf.tabbar_funcs=null}),this.attachEvent("_onContentLoaded",function(){this.tabbar._callMainEvent("onContentLoaded",arguments),this.tabbar._callMainEvent("onTabContentLoaded",arguments)}),this.attachEvent("_onContentAttach",function(){this.tabbar._adjustCell(this.tabbar.conf.lastActive)}),this.attachEvent("_onBeforeContentAttach",function(t){"sidebar"==t&&"dhx_skyblue"!=this.conf.skin&&this._hideBorders()})},window.dhtmlXTabBarCell.prototype=new dhtmlXCellObject,dhtmlXCellObject.prototype.attachTabbar=function(t){this.callEvent("_onBeforeContentAttach",["tabbar"]),"string"==typeof t?t={mode:t}:"object"==typeof t&&null!=t||(t={});var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden","function"==typeof window.dhtmlXAccordionCell&&this instanceof window.dhtmlXAccordionCell&&("material"==this.conf.skin?e._ofs={t:-1,r:-1,b:-1,l:-1}:e._ofs={t:-1}),"function"==typeof window.dhtmlXTabBarCell&&this instanceof window.dhtmlXTabBarCell&&("dhx_skyblue"==this.conf.skin&&(e._ofs={t:-1,r:-1,b:-1,l:-1}),"material"==this.conf.skin&&(e._ofs={t:8,r:8,b:8,l:8})),"function"==typeof window.dhtmlXSideBarCell&&this instanceof window.dhtmlXSideBarCell&&(e._ofs={l:-1},"dhx_web"==this.conf.skin&&1==this.sidebar.conf.autohide&&(e._ofs.l=0),"dhx_terrace"==this.conf.skin&&(1==this.sidebar.conf.autohide&&(e._ofs.l=0),1==this.sidebar.conf.header&&(e._ofs.t=-1))),"function"==typeof window.dhtmlXCarouselCell&&this instanceof window.dhtmlXCarouselCell&&this._hideBorders(),this._attachObject(e),t.skin=this.conf.skin,t.parent=e,this.dataType="tabbar",this.dataObj=new dhtmlXTabBar(t),t.parent=e=null,t=null,this.callEvent("_onContentAttach",[]),this.dataObj},"function"==typeof window.addEventListener?window.addEventListener("load",dhtmlXTabBarInitFromHTML,!1):window.attachEvent("onload",dhtmlXTabBarInitFromHTML),dhtmlXSideBar.prototype=new dhtmlXCellTop,dhtmlXSideBar.prototype._addItem=function(t){var e,n=void 0!==t.id?t.id:window.dhx4.newId();if("separator"==t.type)return(e=document.createElement("DIV")).className="dhxsidebar_sep",this.side.firstChild.appendChild(e),this.s[n]={sep:e},void(e=null);if(t.icons_path=this.conf.icons_path,(e=document.createElement("DIV")).className="dhxsidebar_item",e.innerHTML=window.dhx4.template(this.conf.tpl_str,t),e._idd=n,this.side.firstChild.appendChild(e),e.ondragstart=function(){return!1},1==this.conf.single_cell)var i=this.conf.cell;else{i=new dhtmlXSideBarCell(n,this);this.cont.appendChild(i.cell)}this.t[n]={item:e,cell:i,init:t,conf:{selected:!1,visible:!0,close:close}},void 0!==t.bubble&&this._setItemBubble(n,t.bubble),1==this.conf.header&&i.setHeaderText(window.dhx4.template(this.tpl_header,t)),i=e=null,1==window.dhx4.s2b(t.selected)?this._setItemActive(n):this._adjustCell(n),this._checkHeight()},dhtmlXSideBar.prototype.addItem=function(t){t instanceof Array||(t=[t]);for(var e=0;e<t.length;e++)this._addItem(t[e])},dhtmlXSideBar.prototype.items=dhtmlXSideBar.prototype.cells=function(t){return 1==this.conf.single_cell?this.conf.cell:null!=this.t[t]?this.t[t].cell:null},dhtmlXSideBar.prototype.forEachCell=dhtmlXSideBar.prototype.forEachItem=function(t){if(1!=this.conf.single_cell)for(var e in this.t)"function"==typeof t?t.apply(window,[this.t[e].cell]):"string"==typeof t&&"function"==typeof window[t]&&window[t].apply(window,[this.t[e].cell]);else"function"==typeof t?t.apply(window,[this.conf.cell]):"string"==typeof t&&"function"==typeof window[t]&&window[t].apply(window,[this.conf.cell])},dhtmlXSideBar.prototype.getAllItems=function(){var t=[];for(var e in this.t)t.push(e);return t},dhtmlXSideBar.prototype.getNumberOfItems=function(){return this.getAllItems().length},dhtmlXSideBar.prototype.clearAll=function(){for(var t in this.t)this._removeItem(t,!1,!0);for(var t in this.s)this.removeSep(t)},dhtmlXSideBar.prototype.setSizes=function(){this._adjustCont(),this._adjustSide(),this._checkHeight(),this._adjustCell(this.conf.selected,!0),this.callEvent("_onSetSizes",[])},dhtmlXSideBar.prototype.setSideWidth=function(t){this.conf.width=t,this.setSizes()},dhtmlXSideBar.prototype._adjustSide=function(){null==this.conf.side_ofs&&(this.conf.side_ofs={},this.side.style.width=this.conf.width+"px",this.side.style.height=this.side.parentNode.offsetHeight+"px",this.conf.side_ofs.w=this.side.offsetWidth-parseInt(this.side.style.width),this.conf.side_ofs.h=this.side.offsetHeight-parseInt(this.side.style.height)),this.side.style.width=this.conf.width-this.conf.side_ofs.w+"px",this.side.style.height=this.side.parentNode.offsetHeight-this.arw.offsetHeight-this.conf.side_ofs.h+"px",this.arw.style.width=this.side.style.width,this._scrollSide(0)},dhtmlXSideBar.prototype._checkHeight=function(){var t=null!=this.arw.className.match(/dhxsidebar_arrows_hidden/);null==this.conf.side_hfix&&(this.conf.side_hfix=this.side.offsetHeight-this.side.clientHeight),this.side.firstChild.offsetHeight>this.side.parentNode.clientHeight-this.conf.side_hfix?1==t&&(this.arw.className="dhxsidebar_arrows",this._adjustSide()):0==t&&(this.arw.className="dhxsidebar_arrows dhxsidebar_arrows_hidden",this.side.firstChild.style.top="0px",this._adjustSide())},dhtmlXSideBar.prototype.removeSep=function(t){if(null!=this.s[t]){this.side.firstChild.removeChild(this.s[t].sep),this.s[t].sep=null,this.s[t]=null;try{delete this.s[t]}catch(t){}}},dhtmlXSideBar.prototype.showSide=function(){if(1==this.conf.autohide){if(null==this.sideCover&&this._sideCoverAttach(),1==this.conf.animate_items){var t=function(t,e,n){window.setTimeout(function(){t.style[n]="transform 0.3s",t.style.transform="translate(0px,0px)",t=null},e)};if(!1!==this.conf.transProp){var e=100;for(var n in this.t)this.t[n].item.style[this.conf.transProp]="",this.t[n].item.style.transform="translate(-"+(this.conf.width+20)+"px,0px)",t(this.t[n].item,e+=50,this.conf.transProp)}}var i=this;window.setTimeout(function(){i.arw.style.left=i.side.style.left="0px",i.sideCover.className="dhxsidebar_side_cover dhxsidebar_side_cover_actv",i=null},50)}},dhtmlXSideBar.prototype.hideSide=function(t){1==this.conf.autohide&&(this.arw.style.left=this.side.style.left=-this.conf.width-10+"px",null!=this.sideCover&&(!1!==this.conf.transProp?this.sideCover.className="dhxsidebar_side_cover":this._sideCoverDetach()))},dhtmlXSideBar.prototype._sideCoverAttach=function(){var t=this;this.sideCover=document.createElement("DIV"),this.sideCover.className="dhxsidebar_side_cover",null!=this.arw.nextSibling?this.cont.insertBefore(this.sideCover,this.arw.nextSibling):this.cont.appendChild(this.sideCover),this._sideCoverOnTrEnd=function(){null==this.className.match(/dhxsidebar_side_cover_actv/)&&t._sideCoverDetach()},this._sideCoverDetach=function(){null!=this.sideCover&&(!1!==this.conf.transProp&&this.sideCover.removeEventListener(this.conf.transEv,this._sideCoverOnTrEnd,!1),this.sideCover.parentNode.removeChild(this.sideCover),this.sideCover=null,t=null)},!1!==this.conf.transProp&&this.sideCover.addEventListener(this.conf.transEv,this._sideCoverOnTrEnd,!1)},dhtmlXSideBar.prototype._setItemActive=function(t,e){if(this.conf.selected!=t){if(void 0===e&&(e=!1),1!=e||!0===this.callEvent("onBeforeSelect",[t,this.conf.selected])){var n=null;null!=this.conf.selected&&(n=this.conf.selected,this._setItemInactive(this.conf.selected)),null!=this.t[t]?(this.conf.selected=t,this.t[t].selected=!0,this.t[t].item.className+=" dhxsidebar_item_selected",1!=this.conf.single_cell&&(this.t[t].cell.cell.style.visibility="visible",this.t[t].cell.cell.style.top="0px",this.t[t].cell.cell.style.zIndex=1)):this.conf.selected=null,this._adjustCell(t),1==e&&this.callEvent("onSelect",[t,n]),1==this.conf.autohide&&this.hideSide()}}else 1==this.conf.autohide&&this.hideSide()},dhtmlXSideBar.prototype._setItemInactive=function(t){null!=this.t[t]&&(this.t[t].selected=!1,this.t[t].item.className=this.t[t].item.className.replace(/\s{0,}dhxsidebar_item_selected/gi,""),1!=this.conf.single_cell&&(this.t[t].cell.cell.style.visibility="hidden",this.t[t].cell.cell.style.top="-5000px",this.t[t].cell.cell.style.zIndex=0))},dhtmlXSideBar.prototype._isItemActive=function(t){return this.conf.selected==t},dhtmlXSideBar.prototype._getNextVisible=function(t,e){return this._getNearVisible(t,e,"next")},dhtmlXSideBar.prototype._getPrevVisible=function(t,e){return this._getNearVisible(t,e,"previous")},dhtmlXSideBar.prototype._getFirstVisible=function(){return this._getNearVisible(null,!1,"first")},dhtmlXSideBar.prototype._getNearVisible=function(t,e,n){if("first"==n){var i=this.side.firstChild.firstChild;n="next"}else{if(null==t||null==this.t[t])return e?this._getFirstVisible():null;i=this.t[t].item[n+"Sibling"]}for(var a=null;null!=i&&null==a;){var o=i._idd;null!=o&&null==a&&this.t[o].conf.visible?a=o:i=i[n+"Sibling"]}return i=null,a},dhtmlXSideBar.prototype.goToNextItem=function(t){var e=this._getNextVisible(this.conf.selected,!0);null!=e&&this._setItemActive(e,t)},dhtmlXSideBar.prototype.goToPrevItem=function(t){var e=this._getPrevVisible(this.conf.selected,!0);null!=e&&this._setItemActive(e,t)},dhtmlXSideBar.prototype.getActiveItem=function(){return this.conf.selected},dhtmlXSideBar.prototype.setTemplate=function(t,e){for(var n in this.conf.tpl_name=null!=t&&null!=this.templates[t]?t:"details",this.conf.tpl_str=this.templates[this.conf.tpl_name],null!=e&&(this.conf.icons_path=e),this.t)this.t[n].init.icons_path=this.conf.icons_path,this.t[n].item.innerHTML=window.dhx4.template(this.conf.tpl_str,this.t[n].init);null!=this.side&&(this.side.className="dhxsidebar_side dhxsidebar_tpl_"+this.conf.tpl_name),null!=this._scrollSide&&(this._scrollSide(0),this._checkHeight())},dhtmlXSideBar.prototype.templates={details:"<img class='dhxsidebar_item_icon' src='#icons_path##icon#' border='0'><div class='dhxsidebar_item_text'>#text#</div>",tiles:"<img class='dhxsidebar_item_icon' src='#icons_path##icon#' border='0'><div class='dhxsidebar_item_text'>#text#</div>",icons:"<img class='dhxsidebar_item_icon' src='#icons_path##icon#' border='0'>",icons_text:"<div class='dhxsidebar_item_icon'><img class='dhxsidebar_item_icon' src='#icons_path##icon#' border='0'></div><div class='dhxsidebar_item_text'>#text#</div>",text:"<div class='dhxsidebar_item_text'>#text#</div>"},dhtmlXSideBar.prototype.tpl_bubble="<div class='dhxsidebar_bubble'>#value#</div>",dhtmlXSideBar.prototype.tpl_header="#text#",window.dhtmlXSideBarCell=function(t,e){dhtmlXCellObject.apply(this,[t,"_sidebar"]);var n=this;for(var i in this.sidebar=e,this.conf.skin=this.sidebar.conf.skin,this.conf.sidebar_funcs={show:"_showItem",hide:"_hideItem",isVisible:"_isItemVisible",setActive:"_setItemActive",isActive:"_isItemActive",setText:"_setItemText",getText:"_getItemText",remove:"_removeItem",setBubble:"_setItemBubble",getBubble:"_getItemBubble",clearBubble:"_clearItemBubble"},this._sidebarCall=function(t){return function(){for(var e=[this._idd],n=0;n<arguments.length;n++)e.push(arguments[n]);return this.sidebar[t].apply(this.sidebar,e)}},this.conf.sidebar_funcs)"function"!=typeof this[i]&&(this[i]=this._sidebarCall(this.conf.sidebar_funcs[i]));1==this.sidebar.conf.header&&(this._initHeader(),this.cell.childNodes[this.conf.idx.hdr].onclick=function(t){var e=(t=t||event).target||t.srcElement;null!=e.className.match(/dhx_cell_sidebar_hdr_icon/gi)&&(n.sidebar.conf.clear_click=!0,n.sidebar.showSide()),e=null}),this.attachEvent("_onCellUnload",function(){for(var t in null!=this.conf.idx.hdr&&(this.cell.childNodes[this.conf.idx.hdr].onclick=null),this.sidebar=null,this.conf.sidebar_funcs)this[t]=this.conf.sidebar_funcs[t]=null;this.conf.sidebar_funcs=null,n=null}),this.attachEvent("_onContentLoaded",function(){this.sidebar.callEvent("onContentLoaded",arguments)}),this.attachEvent("_onBeforeContentAttach",function(t){"tabbar"!=t&&"layout"!=t&&"acc"!=t||this._hideBorders(),"sidebar"==t&&"dhx_skyblue"!=this.conf.skin&&this._hideBorders(),"dhx_web"!=this.conf.skin&&"dhx_terrace"!=this.conf.skin||"menu"!=t&&"toolbar"!=t&&"ribbon"!=t||null==this.cell.className.match(/dhx_cell_cont_no_top/gi)&&(this.cell.className+=" dhx_cell_cont_no_top")})},dhtmlXSideBarCell.prototype=new dhtmlXCellObject,dhtmlXSideBar.prototype._setItemText=function(t,e){if(null!=this.t[t]){for(var n in e)this.t[t].init[n]=e[n];this.t[t].init.icons_path=this.conf.icons_path,this.t[t].item.innerHTML=window.dhx4.template(this.conf.tpl_str,this.t[t].init),null!=this.t[t].conf.bubble&&(this.t[t].item.innerHTML+=window.dhx4.template(this.tpl_bubble,{value:this.t[t].conf.bubble})),1==this.conf.header&&this.t[t].cell.setHeaderText(window.dhx4.template(this.tpl_header,this.t[t].init))}},dhtmlXSideBar.prototype._getItemText=function(t){var e={};if(null!=this.t[t])for(var n in this.t[t].init)e[n]=this.t[t].init[n];return e},dhtmlXSideBar.prototype._removeItem=function(t,e,n){if(null!=this.t[t]){if(1!=n&&1!=this.t[t].conf.remove)return this.t[t].conf.remove=!0,void this._hideItem(t,e);void 0===e&&(e=!0);var i=this._getNextVisible(t),a=this._getPrevVisible(t);for(var o in 1==this.t[t].conf.transEv&&(this.t[t].item.removeEventListener(this.conf.transEv,this._doOnTrEnd),this.t[t].conf.transEv=!1),1!=this.conf.single_cell&&(this.t[t].cell._unload(),this.t[t].cell=null),this.t[t].item.ondragstart=null,this.t[t].item.parentNode.removeChild(this.t[t].item),this.t[t].item=null,this.t[t])this.t[t][o]=null;this.t[t]=null;try{delete this.t[t]}catch(t){}if(this.conf.selected==t&&0!=e)this.conf.selected=null,null!=(e=1==e?i||a||this._getFirstVisible():e)&&this._setItemActive(e);else 1!=n&&this._checkHeight()}},dhtmlXSideBar.prototype._showItem=function(t,e){null!=this.t[t]&&1!=this.t[t].conf.visible&&1!=this.t[t].conf.transActv&&(!1!==this.conf.transProp?(this.t[t].conf.transActv=!0,this.t[t].conf.transMode="show",this.t[t].conf.transProp=this.conf.transProp,this.t[t].conf.transActvId=e?t:null,1!=this.t[t].conf.transEv&&(this.t[t].item.addEventListener(this.conf.transEv,this._doOnTrEnd),this.t[t].conf.transEv=!0),this.t[t].conf.visible=!0,this.t[t].item.style[this.conf.transProp]=this.conf.transValue,this.t[t].item.className="dhxsidebar_item"):(this.t[t].conf.visible=!0,this.t[t].item.style.display="",1==e?this._setItemActive(t):this._checkHeight()))},dhtmlXSideBar.prototype._hideItem=function(t,e){if(null!=this.t[t]&&1==this.t[t].conf.visible&&1!=this.t[t].conf.transActv){var n=!1;this.conf.selected==t&&(this.conf.selected=null,this.t[t].conf.active=!1,this.t[t].item.className="dhxsidebar_item",n=!0);var i=this._getPrevVisible(t),a=this._getNextVisible(t);e=n&&!1!==e?(1==e?null:e)||a||i:null;!1!==this.conf.transProp?(this.t[t].conf.transActv=!0,this.t[t].conf.transMode="hide",this.t[t].conf.transProp=this.conf.transProp,this.t[t].conf.transActvId=e,this.t[t].conf.visible=!1,1!=this.t[t].conf.transEv&&(this.t[t].item.addEventListener(this.conf.transEv,this._doOnTrEnd),this.t[t].conf.transEv=!0),this.t[t].item.style[this.conf.transProp]=this.conf.transValue,this.t[t].item.className="dhxsidebar_item dhxsidebar_item_hidden"):(this.t[t].item.style.display="none",this.t[t].conf.visible=!1,1!=this.conf.single_cell&&(this.t[t].cell.cell.style.visibility="hidden",this.t[t].cell.cell.style.top="-5000px"),null!=e&&this._setItemActive(e),this._checkHeight(),1==this.t[t].conf.remove&&this._removeItem(t))}},dhtmlXSideBar.prototype._isItemVisible=function(t){return 1==this.t[t].conf.visible},dhtmlXSideBar.prototype._setItemBubble=function(t,e){null!=this.t[t]&&(this.t[t].item.innerHTML=window.dhx4.template(this.conf.tpl_str,this.t[t].init)+window.dhx4.template(this.tpl_bubble,{value:String(e)}),this.t[t].conf.bubble=e)},dhtmlXSideBar.prototype._getItemBubble=function(t){return null==this.t[t]?null:"undefuned"==typeof this.t[t].conf.bubble?null:this.t[t].conf.bubble},dhtmlXSideBar.prototype._clearItemBubble=function(t){null!=this.t[t]&&(this.t[t].item.innerHTML=window.dhx4.template(this.conf.tpl_str,this.t[t].init),this.t[t].conf.bubble=null)},dhtmlXCellObject.prototype.attachSidebar=function(t){this.callEvent("_onBeforeContentAttach",["sidebar"]),null==t&&(t={});var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden","function"==typeof window.dhtmlXWindowsCell&&this instanceof window.dhtmlXWindowsCell||("dhx_skyblue"==this.conf.skin&&(e._ofs={t:-1,r:-1,b:-1,l:-1}),"dhx_web"==this.conf.skin&&("function"==typeof window.dhtmlXSideBarCell&&this instanceof window.dhtmlXSideBarCell&&(e._ofs={l:8}),"function"==typeof window.dhtmlXLayoutCell&&this instanceof window.dhtmlXLayoutCell&&(e._ofs={t:2}),"function"==typeof window.dhtmlXTabBarCell&&this instanceof window.dhtmlXTabBarCell&&(e._ofs={t:8}),"function"==typeof window.dhtmlXAccordionCell&&this instanceof window.dhtmlXAccordionCell&&(e._ofs={t:2})),"dhx_terrace"==this.conf.skin&&("function"==typeof window.dhtmlXSideBarCell&&this instanceof window.dhtmlXSideBarCell&&(e._ofs={l:-1}),"function"==typeof window.dhtmlXLayoutCell&&this instanceof window.dhtmlXLayoutCell&&(e._ofs={t:-1,r:-1,b:-1,l:-1}),"function"==typeof window.dhtmlXTabBarCell&&this instanceof window.dhtmlXTabBarCell&&(e._ofs={t:-1}),"function"==typeof window.dhtmlXAccordionCell&&this instanceof window.dhtmlXAccordionCell&&(e._ofs={t:-1,r:-1,b:-1,l:-1})),"material"==this.conf.skin&&("function"==typeof window.dhtmlXAccordionCell&&this instanceof window.dhtmlXAccordionCell&&(e._ofs={t:-1,r:-1,b:-1,l:-1}),"function"==typeof window.dhtmlXTabBarCell&&this instanceof window.dhtmlXTabBarCell&&(e._ofs={t:-1,r:-1,b:-1,l:-1}),"function"==typeof window.dhtmlXSideBarCell&&this instanceof window.dhtmlXSideBarCell&&(e._ofs={l:-1}))),this._attachObject(e),t.skin=this.conf.skin,t.parent=e,this.dataType="sidebar",this.dataObj=new dhtmlXSideBar(t),t.parent=e=null,t=null,this.callEvent("_onContentAttach",[]),this.dataObj},dhtmlXSideBarCell.prototype._initHeader=function(){var t=document.createElement("DIV");t.className="dhx_cell_sidebar_hdr",t.innerHTML=(1==this.sidebar.conf.autohide?"<div class='dhx_cell_sidebar_hdr_icon'></div>":"")+"<div class='dhx_cell_sidebar_hdr_text"+(1==this.sidebar.conf.autohide?" dhx_cell_sidebar_hdr_text_icon":"")+"'></div>",this.cell.insertBefore(t,this.cell.childNodes[this.conf.idx.cont]),t=null,this.conf.ofs_nodes.t._getHdrHeight="func",this.conf.hdr={visible:!0},this.conf.idx_data.hdr="dhx_cell_sidebar_hdr",this._updateIdx()},dhtmlXSideBarCell.prototype._getHdrHeight=function(){return this.cell.childNodes[this.conf.idx.hdr].offsetHeight},dhtmlXSideBarCell.prototype.showHeader=function(){1!=this.conf.hdr.visible&&(this.conf.hdr.visible=!0,this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_sidebar_hdr",this._adjustCont(this._idd))},dhtmlXSideBarCell.prototype.hideHeader=function(){1==this.conf.hdr.visible&&(this.conf.hdr.visible=!1,this.cell.childNodes[this.conf.idx.hdr].className="dhx_cell_sidebar_hdr dhx_cell_sidebar_hdr_hidden",this._adjustCont(this._idd))},dhtmlXSideBarCell.prototype.isHeaderVisible=function(){return 1==this.conf.hdr.visible},dhtmlXSideBarCell.prototype.setHeaderText=function(t){this.conf.text=t;var e=this.cell.childNodes[this.conf.idx.hdr];e.childNodes["dhx_cell_sidebar_hdr_icon"==e.firstChild.className?1:0].innerHTML="<span>"+t+"</span>",e=null},dhtmlXSideBarCell.prototype.getHeaderText=function(){return this.conf.text},dhtmlXCarousel.prototype=new dhtmlXCellTop,dhtmlXCarousel.prototype.ef={},dhtmlXCarousel.prototype.cells=function(t){return this.cdata[t].cell},dhtmlXCarousel.prototype.forEachCell=function(t){for(var e in this.cdata)"function"==typeof t?t.apply(window,[this.cdata[e].cell]):"string"==typeof t&&"function"==typeof window[t]&&window[t].apply(window,[this.cdata[e].cell])},dhtmlXCarousel.prototype._initControls=function(){var t=this,e="material"==this.conf.skin?["",""]:this.conf.arw;this.controls=document.createElement("DIV"),this.controls.className="dhx_carousel_controls",this.controls.innerHTML="<div class='dhx_carousel_bars'></div><div class='dhx_carousel_btn dhx_carousel_btn_prev'>"+e[0]+"</div><div class='dhx_carousel_btn dhx_carousel_btn_next'>"+e[1]+"</div>",this.cont.appendChild(this.controls),this._doOnControlClick=function(e){if(1!=t.conf.clear_click){if(e=e||event,null!=window.dhx4.dnd.evs.start&&"click"!=e.type&&1!=t.conf.clear_click){if(1==window.dhx4.dnd._mTouch(e))return;t.conf.clear_click=!0}var n=e.target||e.srcElement,i=null;if(null!=n.className)if(null!=n.className.match(/btn_prev/))i=-1;else if(null!=n.className.match(/btn_next/))i=1;else if(null!=n.className.match(/dhx_carousel_onebar/)&&null==n.className.match(/dhx_carousel_baractv/))for(var a=0;a<n.parentNode.childNodes.length;a++)n.parentNode.childNodes[a]==n&&(i=a-t.conf.selected);null!=i&&t._animateStart(i),n=null}else t.conf.clear_click=!1},"function"==typeof window.addEventListener?(this.controls.addEventListener("click",this._doOnControlClick,!1),null!=window.dhx4.dnd.evs.start&&this.controls.addEventListener(window.dhx4.dnd.evs.start,this._doOnControlClick,!1)):(this.controls.attachEvent("onclick",this._doOnControlClick),(window.dhx4.isIE6||window.dhx4.isIE7||window.dhx4.isIE8)&&(this.controls.onselectstart=function(t){return(t=t||event).preventDefault&&t.preventDefault(),t.returnValue=!1,!1})),this.showControls=function(){this.controls.style.display="",this.setSizes()},this.hideControls=function(){this.controls.style.display="none",this.setSizes()},this._checkControls=function(){this.controls.childNodes[1].className="dhx_carousel_btn dhx_carousel_btn_prev"+(this.conf.selected<=0?"_dis":""),this.controls.childNodes[2].className="dhx_carousel_btn dhx_carousel_btn_next"+(this.conf.selected>=this.conf.items_count-1||0==this.conf.items_count?"_dis":"")},this._adjustControls=function(){this.controls.firstChild.style.left=Math.round(this.cont.offsetWidth/2-this.controls.firstChild.offsetWidth/2)+"px"},this._addBar=function(){var t=document.createElement("DIV");t.className="dhx_carousel_onebar",t.innerHTML="<div class='dhx_carousel_barcore'>&nbsp;</div>",this.controls.firstChild.appendChild(t),t=null,this._adjustControls()},this._removeBar=function(t){var e=this.controls.firstChild.lastChild;null!=e&&(e.parentNode.removeChild(e),e=null,!1!==t&&this._adjustControls())},this._setBarIndex=function(t){for(var e=0;e<this.controls.firstChild.childNodes.length;e++)this.controls.firstChild.childNodes[e].className="dhx_carousel_onebar"+(e==t?" dhx_carousel_baractv":"")},this._unloadControls=function(){for("function"==typeof window.addEventListener?(this.controls.removeEventListener("click",this._doOnControlClick,!1),null!=window.dhx4.dnd.evs.start&&this.controls.removeEventListener(window.dhx4.dnd.evs.start,this._doOnControlClick,!1)):(this.controls.detachEvent("onclick",this._doOnControlClick),(window.dhx4.isIE6||window.dhx4.isIE7||window.dhx4.isIE8)&&(this.controls.onselectstart=null));this.controls.firstChild.childNodes.length>0;)this._removeBar(!1);this.cont.removeChild(this.controls),this.controls=null,t=null},1!=this.conf.buttons&&this.hideControls(),this._checkControls()},window.dhtmlXCarouselCell=function(t,e){dhtmlXCellObject.apply(this,[t,"_carousel"]);var n=this;return this.carousel=e,this.conf.skin=this.carousel.conf.skin,this.attachEvent("_onCellUnload",function(){this.carousel=null,n=null}),this.attachEvent("_onContentLoaded",function(){this.carousel._callMainEvent("onContentLoaded",[this._idd])}),this._showCover=function(){if(1!=this.conf.cover){this._showCellCover();var t=this.cell.childNodes[this.conf.idx.cover];t.onclick=function(){n.carousel._callMainEvent("_cellCoverClick",[n._idd])},t=null}},this._hideCover=function(){1==this.conf.cover&&(this.cell.childNodes[this.conf.idx.cover].onclick=null,this._hideCellCover())},this},dhtmlXCarouselCell.prototype=new dhtmlXCellObject,dhtmlXCarouselCell.prototype.getId=function(){return this._idd},dhtmlXCarouselCell.prototype.getIndex=function(){return this.carousel.cdata[this._idd].index},dhtmlXCarouselCell.prototype.setActive=function(){var t=this.getIndex()-this.carousel.conf.selected;0!=t&&this.carousel._animateStart(t)},dhtmlXCarouselCell.prototype.remove=function(){this.carousel._removeCell(this._idd)},dhtmlXCellObject.prototype.attachCarousel=function(t){this.callEvent("_onBeforeContentAttach",["carousel"]);var e=document.createElement("DIV");return e.style.width="100%",e.style.height="100%",e.style.position="relative",e.style.overflow="hidden",this._attachObject(e),"function"==typeof window.dhtmlXSideBarCell&&this instanceof window.dhtmlXSideBarCell&&"dhx_terrace"==this.conf.skin&&(e._ofs={t:-1,r:-1,b:-1,l:-1}),void 0!==t&&null!=t||(t={}),void 0===t.skin&&(t.skin=this.conf.skin),t.parent=e,this.dataType="carousel",this.dataObj=new dhtmlXCarousel(t),t.parent=null,e=t=null,this.callEvent("_onContentAttach",[]),this.dataObj},dhtmlXCarousel.prototype.ef.slide=!0,dhtmlXCarousel.prototype.ef.slide_conf={anim_step:25,anim_timeout:10,anim_slide:"left 0.3s"},dhtmlXCarousel.prototype.ef.slide_f={prepare:"_slide_prepare",start:"_slide_start",end:"_slide_end",update_selected:"_slide_update_selected",detect_x:"_slide_detect_x",detect_aw:"_slide_detect_area_width",cell_added:"_slide_cell_added"},dhtmlXCarousel.prototype._slide_init=function(){return this.ef.slide_conf},dhtmlXCarousel.prototype._slide_f=function(){return this.ef.slide_f},dhtmlXCarousel.prototype._slide_prepare=function(t,e){var n=this.conf.anim_step,i=this.conf.width+this.conf.ofs_item;0==e&&(n=i+1),this.area._init=parseInt(this.area.style.left);var a=this.ind[this.conf.selected+t];this._slide_update_selected(a),!1!==this.conf.transProp&&0!=e?(1!=this.conf.transEvInit&&(this.area.addEventListener(this.conf.transEv,this._animateTransEnd,!1),this.conf.transEvInit=!0),this.conf.current_dir=t,this.area.style[this.conf.transProp]=this.conf.anim_slide,this.area.style.left=this.area._init+i*-t+"px"):this._slide_start(n,0,i,t)},dhtmlXCarousel.prototype._slide_start=function(t,e,n,i){var a=!1;if((e+=t)>=n&&(e=n,a=!0),this.area.style.left=this.area._init+e*-i+"px",1!=a){var o=this;window.setTimeout(function(){o._slide_start(t,e,n,i),o=null},this.conf.anim_timeout)}else this.cdata[this.ind[this.conf.selected]].cell._showCover(),this._animateEnd(i)},dhtmlXCarousel.prototype._slide_end=function(t,e){t.type==this.conf.transEv&&e==this.area&&(this.area.style[this.conf.transProp]="",1==this.conf.transEvInit&&(this.area.removeEventListener(this.conf.transEv,this._animateTransEnd,!1),this.conf.transEvInit=!1),this.cdata[this.ind[this.conf.selected]].cell._showCover(),this._animateEnd(this.conf.current_dir))},dhtmlXCarousel.prototype._slide_update_selected=function(t){this.cdata[t].cell._hideCover()},dhtmlXCarousel.prototype._slide_detect_x=function(t){return this.cdata[t].index*(this.conf.width+this.conf.ofs_item)+this.conf.ofs_item},dhtmlXCarousel.prototype._slide_cell_added=function(t){this.conf.selected!=this.cdata[t].index&&this.cdata[t].cell._showCover(),this.cdata[t].index<=this.conf.selected&&this.conf.items_count>1&&this._animateStart(1,!1)},dhtmlXCarousel.prototype._slide_detect_area_width=function(){return this.conf.items_count},dhtmlXCarousel.prototype.ef.flip=!0,dhtmlXCarousel.prototype.ef.flip_conf={anim_flip:"transform 0.3s ease-out",anim_flip_ang:-87,anim_flip_trstyle:"transform"},dhtmlXCarousel.prototype.ef.flip_f={prepare:"_flip_prepare",start:"_flip_start",end:"_flip_end",update_selected:"_flip_update_selected",detect_x:"_flip_detect_x",detect_aw:"_flip_detect_area_width",cell_added:"_flip_cell_added"},dhtmlXCarousel.prototype._flip_init=function(){var t=0!=this.conf.transProp&&this.ef.flip_conf;return!1!==t&&1==window.dhx4.isKHTML&&null==t.anim_flip.match("webkit")&&(t.anim_flip=t.anim_flip.replace(/transform/,"-webkit-transform"),t.anim_flip_trstyle="webkitTransform"),t},dhtmlXCarousel.prototype._flip_f=function(){return this.ef.flip_f},dhtmlXCarousel.prototype._flip_prepare=function(t){this.conf.flip_data={fromIndex:this.conf.selected,toIndex:this.conf.selected+t,mode:0,dir:t},this._flip_start()},dhtmlXCarousel.prototype._flip_start=function(){var t=this.cdata[this.ind[0==this.conf.flip_data.mode?this.conf.flip_data.fromIndex:this.conf.flip_data.toIndex]].cell;null==this.area.className.match(/dhxcarousel_area_flip/)&&(this.area.className+=" dhxcarousel_area_flip"),1!=t.conf.tr_ev&&(t.cell.addEventListener(this.conf.transEv,this._animateTransEnd,!1),t.conf.tr_ev=!0),0==this.conf.flip_data.mode?t.cell.style[this.conf.anim_flip_trstyle]="rotateY("+String(this.conf.flip_data.dir>0?this.conf.anim_flip_ang:-this.conf.anim_flip_ang)+"deg)":(t.cell.style.visibility="visible",t.cell.style[this.conf.anim_flip_trstyle]="rotateY(0deg)"),t.cell.style[this.conf.transProp]=this.conf.anim_flip,t=null},dhtmlXCarousel.prototype._flip_end=function(t,e){if(t.type==this.conf.transEv){var n=this.cdata[this.ind[0==this.conf.flip_data.mode?this.conf.flip_data.fromIndex:this.conf.flip_data.toIndex]].cell;if(e==n.cell)if(n.cell.removeEventListener(this.conf.transEv,this._animateTransEnd,!1),n.conf.tr_ev=!1,0==this.conf.flip_data.mode)n.cell.style[this.conf.transProp]="",n.cell.style.visibility="hidden",this.conf.flip_data.mode=1,this._flip_start();else{for(var i=this.conf.flip_data.dir,a=Math.min(this.conf.flip_data.fromIndex,this.conf.flip_data.toIndex)+1,o=Math.max(this.conf.flip_data.fromIndex,this.conf.flip_data.toIndex)-1,r=a;r<=o;r++)this.cdata[this.ind[r]].cell.cell.style[this.conf.anim_flip_trstyle]="rotateY("+String(this.conf.anim_flip_ang*i/Math.abs(i))+"deg)";null!=this.area.className.match(/dhxcarousel_area_flip/)&&(this.area.className=String(this.area.className).replace(/\s{0,}dhxcarousel_area_flip/gi,"")),this.conf.flip_data=null,n.cell.style[this.conf.transProp]="",this._animateEnd(i)}n=null}},dhtmlXCarousel.prototype._flip_update_selected=function(t){},dhtmlXCarousel.prototype._flip_detect_x=function(t){return 0*(this.conf.width+this.conf.ofs_item)+this.conf.ofs_item},dhtmlXCarousel.prototype._flip_cell_added=function(t){this.conf.selected!=this.cdata[t].index?(this.cdata[t].cell.cell.style[this.conf.anim_flip_trstyle]="rotateY("+String(this.cdata[t].index<this.conf.selected?this.conf.anim_flip_ang:-this.conf.anim_flip_ang)+"deg)",this.cdata[t].cell.cell.style.visibility="hidden"):this.cdata[t].cell.cell.style[this.conf.anim_flip_trstyle]="rotateY(0deg)"},dhtmlXCarousel.prototype._flip_detect_area_width=function(){return 1},dhtmlXCarousel.prototype.ef.cards=!0,dhtmlXCarousel.prototype.ef.cards_conf={anim_cards:"left 0.3s"},dhtmlXCarousel.prototype.ef.cards_f={prepare:"_cards_prepare",start:"_cards_start",end:"_cards_end",update_selected:"_cards_update_selected",detect_x:"_cards_detect_x",detect_aw:"_cards_detect_area_width",cell_added:"_cards_cell_added"},dhtmlXCarousel.prototype._cards_init=function(){return 0!=this.conf.transProp&&this.ef.cards_conf},dhtmlXCarousel.prototype._cards_f=function(){return this.ef.cards_f},dhtmlXCarousel.prototype._cards_prepare=function(t,e){if(t>0){var n=this.ind[this.conf.selected+t],i=this.cdata[n].cell;this._cards_update_selected(n),1!=i.conf.transEvInit&&(i.cell.addEventListener(this.conf.transEv,this._animateTransEnd,!1),i.conf.transEvInit=!0),this.conf.current_id=n,this.conf.current_dir=t,i.cell.style[this.conf.transProp]=this.conf.anim_cards,i.cell.style.left=this._cards_detect_x(n,0)+"px",i=null}else{this._cards_adjust_middle(this.conf.selected+t+1,this.conf.selected-1,1);n=this.ind[this.conf.selected];(i=this.cdata[n].cell)._hideCover(),1!=i.conf.transEvInit&&(i.cell.addEventListener(this.conf.transEv,this._animateTransEnd,!1),i.conf.transEvInit=!0),this.conf.current_id=n,this.conf.current_dir=t,this.cdata[this.ind[this.conf.selected+t]].cell._hideCover(),i.cell.style[this.conf.transProp]=this.conf.anim_cards,i.cell.style.left=this._cards_detect_x(n,1)+"px",i=null}},dhtmlXCarousel.prototype._cards_start=function(t,e,n,i){},dhtmlXCarousel.prototype._cards_end=function(t,e){if(t.type==this.conf.transEv&&null!=this.conf.current_id&&e==this.cdata[this.conf.current_id].cell.cell){var n=this.cdata[this.conf.current_id].cell;n.cell.style[this.conf.transProp]="",1!=n.conf.transEvInit&&(n.cell.removeEventListener(this.conf.transEv,this._animateTransEnd,!1),n.conf.transEvInit=!1),this.conf.current_id=null,this.conf.current_dir>0&&this._cards_adjust_middle(this.conf.selected+1,this.conf.selected+this.conf.current_dir-1,0),this.cdata[this.ind[this.conf.selected]].cell._showCover(),this._animateEnd(this.conf.current_dir)}},dhtmlXCarousel.prototype._cards_update_selected=function(t){this.cdata[t].cell._hideCover()},dhtmlXCarousel.prototype._cards_adjust_middle=function(t,e,n){for(var i=t;i<=e;i++){var a=this.ind[i],o=this.cdata[a].cell;o.conf.size.x=this._cards_detect_x(a,n),o.cell.style.left=o.conf.size.x+"px",o=null}},dhtmlXCarousel.prototype._cards_detect_x=function(t,e){return void 0!==e&&null!=e||(e=this.cdata[t].index<=this.conf.selected?0:1),e*(this.conf.width+this.conf.ofs_left+this.conf.ofs_item)+this.conf.ofs_item},dhtmlXCarousel.prototype._cards_cell_added=function(t){this.cdata[t].cell.conf.size.x=this._cards_detect_x(t),this.cdata[t].cell.cell.style.left=this.cdata[t].cell.conf.size.x+"px",this.conf.selected!=this.cdata[t].index&&this.cdata[t].cell._showCover()},dhtmlXCarousel.prototype._cards_detect_area_width=function(){return 2},dhtmlXWindows.prototype.forEachWindow=function(t){for(var e in this.w)t.apply(window,[this.w[e].cell])},dhtmlXWindows.prototype.window=function(t){return null!=this.w[t]?this.w[t].cell:null},dhtmlXWindows.prototype.isWindow=function(t){return null!=this.w[t]},dhtmlXWindows.prototype.findByText=function(t){var e=[];for(var n in this.w)this.w[n].cell.getText().indexOf(String(t))>=0&&e.push(this.w[n]);return e},dhtmlXWindows.prototype.setSkin=function(t){if(t!=this.conf.skin){for(var e in null!=this.vp&&(this.vp.className=String(this.vp.className).replace("dhxwins_vp_"+this.conf.skin," dhxwins_vp_"+t)),this.w)this.w[e].cell._resetSizeState(),this._winAdjustCell(e),this._winAdjustTitle(e);this.conf.skin=t}},dhtmlXWindows.prototype.getBottommostWindow=function(){return this._getTopBottomWin(!1)},dhtmlXWindows.prototype.getTopmostWindow=function(){return this._getTopBottomWin(!0)},dhtmlXWindows.prototype._getTopBottomWin=function(t){var e=null;for(var n in this.w)if(this.w[n].conf.visible){var i=!1;null!=e&&(i=e.z>this.w[n].win.style.zIndex,t&&(i=!i)),(null==e||i)&&(e={win:this.w[n].cell,z:this.w[n].win.style.zIndex})}return e?e.win:null},dhtmlXWindows.prototype._winMakeActive=function(t,e){if(null==t||!0===e||1!=this.w[t].conf.actv){for(var n=[],i={},a=0;a<this._zOrder.length;a++){var o=this._zOrder[a].name,r=this._zOrder[a].value,s=[];for(var l in this.w){var d=this.w[l];null==i[l]&&d.conf[o]===r&&1==d.conf.visible&&t!=l&&(window.dhx4.zim.clear(d.conf.z_id),s.push([l,Number(d.win.style.zIndex)]),i[l]=!0),d=null}if(s.sort(function(t,e){return t[1]<e[1]?1:-1}),null!=t&&this.w[t].conf[o]===r&&null==i[t])window.dhx4.zim.clear(this.w[t].conf.z_id),s=[[t,Number(this.w[t].win.style.zIndex)]].concat(s),i[t]=!0;n=n.concat(s)}for(a=n.length-1;a>=0;a--){l=n[a][0];if((d=this.w[l]).win.style.zIndex=window.dhx4.zim.reserve(d.conf.z_id),d.conf.modal&&null!=this.mcover)for(var c in this.mcover)this.mcover[c].style.zIndex=d.win.style.zIndex;this._winAdjustFRMZIndex(l),null==t&&0==a&&(t=l),d.conf.actv=t==l,d.win.className=d.conf.actv?"dhxwin_active":"dhxwin_inactive",d=null}null!=t&&this.conf.last_active!=t&&this._callMainEvent("onFocus",t),this.conf.last_active=t}},dhtmlXWindows.prototype._zOrder=[{name:"modal",value:!0},{name:"sticked",value:!0},{name:"sticked",value:!1}],dhtmlXWindows.prototype._vpPull={},dhtmlXWindows.prototype._vpOf={},dhtmlXWindows.prototype._vpPullAdd=function(){if(null!=this.vp){var t=null;for(var e in this._vpPull)this._vpPull[e].vp==this.vp&&(this._vpPull[e].count++,t=e);null==t&&(this._vpPull[window.dhx4.newId()]={vp:this.vp,count:1}),this.vp==document.body&&1==this.conf.vp_of_auto&&this._vpOfInit(),this._vpOfUpd()}},dhtmlXWindows.prototype._vpPullRemove=function(){if(null==this.vp)return 0;var t=0;for(var e in this._vpPull)this._vpPull[e].vp==this.vp&&0==(t=--this._vpPull[e].count)&&(this._vpPull[e].vp=null,this._vpPull[e].count=null,delete this._vpPull[e]);return this._vpOfClear(),t},dhtmlXWindows.prototype._vpOfInit=function(){this._vpOf[this.conf.vp_of_id]=!0},dhtmlXWindows.prototype._vpOfClear=function(){this._vpOf[this.conf.vp_of_id]=!1,delete this._vpOf[this.conf.vp_of_id],this._vpOfUpd()},dhtmlXWindows.prototype._vpOfUpd=function(){var t=!1;for(var e in this._vpOf)t=t||this._vpOf[e];1==t?null==document.body.className.match(/dhxwins_vp_auto/)&&(document.body.className+=" dhxwins_vp_auto"):null!=document.body.className.match(/dhxwins_vp_auto/)&&(document.body.className=String(document.body.className).replace(/\s{0,}dhxwins_vp_auto/gi,""))},dhtmlXWindows.prototype.attachViewportTo=function(t){var e=this._vpPullRemove();if(this.conf.vp_custom){for(;this.vp.childNodes.length>0;)this.vp.removeChild(this.vp.lastChild);this.vp.parentNode.removeChild(this.vp),this.vp=null}else null!=this.vp&&0==e&&(this.vp.className=String(this.vp.className).replace(new RegExp("\\s{1,}dhxwins_vp_"+this.conf.skin),""));if(null==t)this.vp=null;else{this.vp="string"==typeof t?document.getElementById(t):t;var n="dhxwins_vp_"+this.conf.skin;for(var i in this.vp.className.indexOf(n)<0&&(this.vp.className+=" "+n),t=null,this.w)this.vp.appendChild(this.w[i].win);this.conf.vp_custom=!1}this.vp==document.body&&(document.body.style.position="static"),this._vpPullAdd()},dhtmlXWindows.prototype.setViewport=function(t,e,n,i,a){var o=document.createElement("DIV");o.style.position="absolute",o.style.left=t+"px",o.style.top=e+"px",o.style.width=n+"px",o.style.height=i+"px",void 0===a||null==a?a=document.body:"string"==typeof a&&(a=document.getElementById(a)),a.appendChild(o),this.attachViewportTo(o),this.conf.vp_custom=!0,a=o=null},dhtmlXWindows.prototype._winSetPosition=function(t,e,n){var i=this.w[t];i.conf.maxed&&(i.conf.lastMX+=e-i.conf.x,i.conf.lastMY+=n-i.conf.y),i.conf.x=e,i.conf.y=n,i.win.style.left=i.conf.x+"px",i.win.style.top=i.conf.y+"px",this._winAdjustFRMPosition(t),i=null},dhtmlXWindows.prototype._winAdjustPosition=function(t,e,n){var i=this.w[t];void 0===e&&(e=i.conf.x),void 0===n&&(n=i.conf.y);var a=i.conf.keep_in_vp?0:-i.conf.w+this.conf.vp_pos_ofs,o=i.conf.keep_in_vp?this.vp.clientWidth-i.conf.w:this.vp.clientWidth-this.conf.vp_pos_ofs;e<a?e=a:e>o&&(e=o);var r=i.conf.keep_in_vp?this.vp.clientHeight-i.conf.h:this.vp.clientHeight-this.conf.vp_pos_ofs;n<0?n=0:n>r&&(n=r),e==i.conf.x&&n==i.conf.y||this._winSetPosition(t,e,n),i=null},dhtmlXWindows.prototype._winSetSize=function(t,e,n,i,a){var o=this.w[t],r=null!=e?e:o.conf.w,s=null!=n?n:o.conf.h;null==this.conf.ofs_w&&(o.win.style.width=r+"px",o.win.style.height=s+"px",this.conf.ofs_w=o.win.offsetWidth-r,this.conf.ofs_h=o.win.offsetHeight-s),null!=o.conf.min_w&&r<o.conf.min_w&&(r=o.conf.min_w),null!=o.conf.max_w&&r>o.conf.max_w&&(r=o.conf.max_w),!o.conf.parked&&null!=o.conf.min_h&&s<o.conf.min_h&&(s=o.conf.min_h),null!=o.conf.max_h&&s>o.conf.max_h&&(s=o.conf.max_h),o.conf.keep_in_vp&&(r>this.vp.clientWidth&&(r=this.vp.clientWidth),s>this.vp.clientHeight&&(s=this.vp.clientHeight)),o.win.style.width=r-this.conf.ofs_w+"px",o.win.style.height=s-this.conf.ofs_h+"px",o.conf.w=r,o.conf.h=s,this._winAdjustFRMSize(t),a&&this._winAdjustPosition(t,o.conf.x,o.conf.y),o.conf.parked||1==i||this._winAdjustCell(t),o=null},dhtmlXWindows.prototype._winMinmax=function(t,e){if((void 0===e||this.w[t].conf.maxed!=e)&&0!=this.w[t].conf.allow_resize){var n=this.w[t];if(n.conf.parked&&this._winPark(t,!1),n.conf.maxed)this._winSetSize(t,n.conf.lastMW,n.conf.lastMH),this._winAdjustPosition(t,n.conf.lastMX,n.conf.lastMY),n.conf.maxed=!1;else{var i=0,a=0;null!=n.conf.max_w&&(i=n.conf.x+Math.round(n.conf.w-n.conf.max_w)/2),null!=n.conf.max_h&&(a=Math.max(n.conf.y+Math.round(n.conf.h-n.conf.max_h)/2,0)),n.conf.lastMX=n.conf.x,n.conf.lastMY=n.conf.y,n.conf.lastMW=n.conf.w,n.conf.lastMH=n.conf.h,this._winSetSize(t,this.vp.clientWidth,this.vp.clientHeight),this._winAdjustPosition(t,i,a),n.conf.maxed=!0}n.b.minmax.setCss(n.conf.maxed?"minmaxed":"minmax"),n.conf.maxed?this._callMainEvent("onMaximize",t):this._callMainEvent("onMinimize",t),this._callMainEvent("onResizeFinish",t),n=null}},dhtmlXWindows.prototype._winShow=function(t,e){1!=this.w[t].conf.visible&&(this.w[t].win.style.display="",this.w[t].conf.visible=!0,1!=e&&null!=this.conf.last_active||this._winMakeActive(t,!0),this._callMainEvent("onShow",t))},dhtmlXWindows.prototype._winHide=function(t,e){0!=this.w[t].conf.visible&&(this.w[t].win.style.display="none",this.w[t].conf.visible=!1,this.w[t].conf.actv&&(this.w[t].conf.actv=!1,this.w[t].win.className="dhxwin_inactive",this._winMakeActive(null,!0)),this._callMainEvent("onHide",t))},dhtmlXWindows.prototype._winPark=function(t,e){if(0!=this.w[t].conf.allow_park&&0!=this.w[t].conf.header){var n=this.w[t];1==e&&!1!==this.conf.tr.prop&&(n.win.style[this.conf.tr.prop]=this.conf.tr[n.conf.parked?"height_open":"height_close"],n.conf.tr_ev||(n.win.addEventListener(this.conf.tr.ev,this._winOnParkTrans,!1),n.conf.tr_ev=!0)),n.conf.parked?(n.hdr.className=String(n.hdr.className).replace(/\s{1,}dhxwin_hdr_parked/gi,""),n.hdr.style.zIndex=0,n.conf.parked=!1,n.conf.tr_mode="park",this._winCellSetOpacity(t,"open",e),this._winSetSize(t,n.conf.w,n.conf.lastPH,1==e&&!1!==this.conf.tr.prop),1==e&&!1!==this.conf.tr.prop||(this._callMainEvent("onParkDown",t),n.conf.keep_in_vp&&this._winAdjustPosition(t,n.conf.x,n.conf.y)),1==window.dhx4.isIE8&&0==this.conf.tr.prop&&null!=n.cell.cell.className.match(/dhxwin_parked/)&&(n.cell.cell.className=n.cell.cell.className.replace(/\s{0,}dhxwin_parked/gi,""))):(n.conf.lastPH=n.conf.h,n.hdr.className+=" dhxwin_hdr_parked",0!=e&&0!=this.conf.tr.prop||(n.hdr.style.zIndex=3),n.conf.parked=!0,n.conf.tr_mode="park",this._winCellSetOpacity(t,"close",e),this._winSetSize(t,n.conf.w,n.hdr.offsetHeight+this.conf.ofs_h,1==e&&!1!==this.conf.tr.prop),1==e&&!1!==this.conf.tr.prop||this._callMainEvent("onParkUp",t),1==window.dhx4.isIE8&&0==this.conf.tr.prop&&null==n.cell.cell.className.match(/dhxwin_parked/)&&(n.cell.cell.className+=" dhxwin_parked")),n=null}},dhtmlXWindows.prototype._winCellSetOpacity=function(t,e,n,i){var a=this.w[t].cell;for(var o in a.conf.idx)1!={pr1:!0,pr2:!0}[o]&&(1==n&&0!=this.conf.tr.prop&&(a.cell.childNodes[a.conf.idx[o]].style[this.conf.tr.prop]=this.conf.tr["op_"+e]),a.cell.childNodes[a.conf.idx[o]].style.opacity=this.conf.tr["op_v_"+e]);a=null},dhtmlXWindows.prototype._winCellClearOpacity=function(t){var e=this.w[t].cell;for(var n in e.conf.idx)1!={pr1:!0,pr2:!0}[n]&&0!=this.conf.tr.prop&&(e.cell.childNodes[e.conf.idx[n]].style[this.conf.tr.prop]="");e=null},dhtmlXWindows.prototype._winStick=function(t,e){void 0!==e&&this.w[t].conf.sticked==e||(this.w[t].conf.sticked=!this.w[t].conf.sticked,this.w[t].b.stick.setCss(this.w[t].conf.sticked?"sticked":"stick"),this._winMakeActive(this.conf.last_active,!0),this.w[t].conf.sticked?this._callMainEvent("onStick",t):this._callMainEvent("onUnStick",t))},dhtmlXWindows.prototype._winClose=function(t){if(!0===this._callMainEvent("onClose",t)||1==this.conf.unloading){var e=this.w[t];for(var n in e.conf.fs_mode&&e.cell.setToFullScreen(!1),e.conf.modal&&this._winSetModal(t,!1),window.dhx4.zim.clear(e.conf.z_id),null!=this.cm&&null!=this.cm.icon[t]&&this._detachContextMenu("icon",t,null),"function"==typeof window.addEventListener?(e.win.removeEventListener("mousedown",this._winOnMouseDown,!1),e.win.removeEventListener("mouseup",this._winOnMouseDown,!1),this.conf.dblclick_ev&&e.win.removeEventListener("dblclick",this._winOnMouseDown,!1),1==this.conf.dnd_enabled&&null!=window.dhx4.dnd.evs.start&&(e.win.removeEventListener(window.dhx4.dnd.evs.start,this._winOnMouseDown,!1),1!=window.dhx4.dnd.p_en&&(e.win.removeEventListener(window.dhx4.dnd.evs.start,this._winOnMouseDown,!1),e.win.removeEventListener(window.dhx4.dnd.evs.end,this._winOnMouseDown,!1)))):(e.win.detachEvent("onmousedown",this._winOnMouseDown),e.win.detachEvent("onmouseup",this._winOnMouseDown),this.conf.dblclick_ev&&e.win.attachEvent("ondblclick",this._winOnMouseDown)),e.b)this._winRemoveButton(t,n,!0);for(var n in e.b=null,e.cell._unload(),e.cell=null,e.brd.parentNode.removeChild(e.brd),e.brd=null,null!=e.fr_cover&&(e.fr_cover.parentNode.removeChild(e.fr_cover),e.fr_cover=null),null!=e.fr_m_cover&&(e.fr_m_cover.parentNode.removeChild(e.fr_m_cover),e.fr_m_cover=null),e.hdr._isWinHdr=!0,e.hdr.firstChild._isWinIcon=!0,e.hdr.onselectstart=null,e.hdr.parentNode.removeChild(e.hdr),e.hdr=null,e.conf)e.conf[n]=null,delete e.conf[n];e.conf=null,e.win._idd=null,e.win._isWindow=null,e.win.parentNode.removeChild(e.win),e.win=null,e=null,this.w[t]=null,delete this.w[t],this.conf.unloading||this._winMakeActive(null,!0)}},dhtmlXWindows.prototype._winSetModal=function(t,e,n){if(this.w[t].conf.modal!=e){void 0===n&&(n=!0);var i=this.w[t];if(1==e&&0==i.conf.modal){if(null!=this.conf.last_modal&&this._winSetModal(this.conf.last_modal,!1,!1),null==this.mcover){var a=document.createElement("DIV");a.className="dhxwins_mcover",this.vp.insertBefore(a,i.fr_m_cover||i.win),this.mcover={d:a},this.conf.fr_cover&&(this.mcover.f=document.createElement("IFRAME"),this.mcover.f.className="dhxwins_mcover",this.mcover.f.border=0,this.mcover.f.frameBorder=0,this.vp.insertBefore(this.mcover.f,a)),a=null}else this.mcover.d.nextSibling!=(i.fr_m_cover||i.win)&&(this.vp.insertBefore(this.mcover.d,i.fr_m_cover||i.win),null!=this.mcover.f&&this.vp.insertBefore(this.mcover.f,this.mcover.d));i.conf.modal=!0,this.conf.last_modal=t,this._winMakeActive(t,!0)}else if(0==e&&1==i.conf.modal&&(i.conf.modal=!1,this.conf.last_modal=null,n&&null!=this.mcover)){for(var o in this.mcover)this.vp.removeChild(this.mcover[o]),this.mcover[o]=null;this.mcover=null}i=null}},dhtmlXWindows.prototype._winMouseDownHandler=function(t,e){var n=t.target||t.srcElement;if(!(t.button>=2)){if("button"==e.mode)if("mousedown"==e.press_type)this.conf.button_last=e.button_name;else if(("mouseup"==e.press_type&&e.button_name==this.conf.button_last||"MSPointerDown"==e.press_type||"pointerdown"==e.press_type)&&(this.conf.button_last=null,!0!==this._winButtonClick(e.id,e.button_name,t)))return;if(("pointerdown"==e.press_type||"mousedown"==e.press_type||"dblclick"==e.press_type)&&"hdr"==e.mode){if(this.conf.dblclick_active=!1,1==this.conf.dblclick_ev)"dblclick"==e.press_type&&(this.conf.dblclick_active=!0);else if(null==this.conf.dblclick_last)this.conf.dblclick_last=(new Date).getTime(),this.dblclick_id=e.id;else{n=(new Date).getTime();this.conf.dblclick_last+this.conf.dblclick_tm>n&&this.dblclick_id==e.id?(this.conf.dblclick_active=!0,this.conf.dblclick_last=null,this.dblclick_id=null):(this.conf.dblclick_last=n,this.dblclick_id=e.id)}if(this.conf.dblclick_active)return void this._winDoHeaderDblClick(e.id)}"mousedown"!=e.press_type&&e.press_type!=window.dhx4.dnd.evs.start||this._winMakeActive(e.id),e.press_type}},dhtmlXWindows.prototype._winDoHeaderDblClick=function(t){"minmax"!=this.conf.dblclick_mode?"park"!=this.conf.dblclick_mode?"function"!=typeof this.conf.dblclick_mode?"function"!=typeof window[this.conf.dblclick_mode]||window[this.conf.dblclick_mode].apply(window,[t]):this.conf.dblclick_mode.apply(window,[t]):this._winPark(t,!0):this._winMinmax(t)},dhtmlXWindows.prototype._winAdjustCell=function(t){var e=this.w[t];if("material"==this.conf.skin)var n=0,i=e.conf.header?e.hdr.offsetHeight:1,a=e.win.clientWidth,o=e.win.clientHeight-i;else n=1,i=e.conf.header?e.hdr.offsetHeight:1,a=e.win.clientWidth-2,o=e.win.clientHeight-i-1;e.brd.style.left=n+"px",e.brd.style.top=i+"px",null==e.conf.brd&&(e.brd.style.width=a+"px",e.brd.style.height=o+"px",e.conf.brd={w:a-e.brd.offsetWidth,h:o-e.brd.offsetHeight}),e.brd.style.width=a+e.conf.brd.w+"px",e.brd.style.height=o+e.conf.brd.h+"px";var r=5;"material"==this.conf.skin&&(r=1);var s=1+r,l=e.conf.header?i:i+r,d=e.brd.clientWidth,c=e.brd.clientHeight;e.cell._setSize(s,l,d,c),e.fr_cover.style.left=s+"px",e.fr_cover.style.top=l+"px",e.fr_cover.style.width=d+"px",e.fr_cover.style.height=c+"px",e=null},dhtmlXWindows.prototype._winAdjustTitle=function(t){var e=this.w[t].hdr.childNodes[0],n=this.w[t].hdr.childNodes[1],i=this.w[t].hdr.childNodes[2],a="material"==this.conf.skin?7:0;n.style.paddingLeft=e.offsetWidth+12+a+"px",n.style.paddingRight=i.offsetWidth+10+a+"px",n=i=e=null},dhtmlXWindows.prototype._callMainEvent=function(t,e){var n=this.w[e];if(n.cell.checkEvent(t))var i=n.cell._callMainEvent(t,[n.cell]);else i=this.callEvent(t,[n.cell]);return n=null,i},dhtmlXWindows.prototype._winInitFRM=function(t){if(1==this.conf.fr_cover){var e=this.w[t],n=document.createElement("IFRAME");n.className="dhxwin_main_fr_cover",n.border=0,n.frameBorder=0,n.style.zIndex=e.win.style.zIndex,e.win.parentNode.insertBefore(n,e.win),e.fr_m_cover=n,n=null}},dhtmlXWindows.prototype._winAdjustFRMSize=function(t){var e=this.w[t];null!=e.fr_m_cover&&(e.fr_m_cover.style.width=e.conf.w+"px",e.fr_m_cover.style.height=e.conf.h+"px"),e=null},dhtmlXWindows.prototype._winAdjustFRMPosition=function(t){var e=this.w[t];null!=e.fr_m_cover&&(e.fr_m_cover.style.left=e.win.style.left,e.fr_m_cover.style.top=e.win.style.top),e=null},dhtmlXWindows.prototype._winAdjustFRMZIndex=function(t){var e=this.w[t];null!=e.fr_m_cover&&(e.fr_m_cover.style.zIndex=e.win.style.zIndex),e=null},dhtmlXWindowsCell.prototype=new dhtmlXCellObject,dhtmlXWindowsCell.prototype.setText=function(t){this.wins.w[this._idd].conf.text=t,this.wins.w[this._idd].hdr.childNodes[1].firstChild.innerHTML=t},dhtmlXWindowsCell.prototype.getText=function(){return this.wins.w[this._idd].conf.text},dhtmlXWindowsCell.prototype.allowMove=function(){this.wins.w[this._idd].conf.allow_move=!0},dhtmlXWindowsCell.prototype.denyMove=function(){this.wins.w[this._idd].conf.allow_move=!1},dhtmlXWindowsCell.prototype.isMovable=function(){return 1==this.wins.w[this._idd].conf.allow_move},dhtmlXWindowsCell.prototype.allowResize=function(){this.wins.w[this._idd].conf.allow_resize=!0,this.wins.w[this._idd].b.minmax.enable()},dhtmlXWindowsCell.prototype.denyResize=function(){this.wins.w[this._idd].conf.allow_resize=!1,this.wins.w[this._idd].b.minmax.disable()},dhtmlXWindowsCell.prototype.isResizable=function(){return 1==this.wins.w[this._idd].conf.allow_resize},dhtmlXWindowsCell.prototype.maximize=function(){this.wins._winMinmax(this._idd,!0)},dhtmlXWindowsCell.prototype.minimize=function(){this.wins._winMinmax(this._idd,!1)};dhtmlXWindowsCell.prototype.isMaximized=function(){return 1==this.wins.w[this._idd].conf.maxed},dhtmlXWindowsCell.prototype.setPosition=function(t,e){this.wins._winSetPosition(this._idd,t,e)},dhtmlXWindowsCell.prototype.getPosition=function(){var t=this.wins.w[this._idd],e=[t.conf.x,t.conf.y];return t=null,e},dhtmlXWindowsCell.prototype.adjustPosition=function(){this.wins._winAdjustPosition(this._idd)},dhtmlXWindowsCell.prototype.park=function(){this.wins._winPark(this._idd,!0)},dhtmlXWindowsCell.prototype.isParked=function(){return 1==this.wins.w[this._idd].conf.parked},dhtmlXWindowsCell.prototype.allowPark=function(){this.wins.w[this._idd].conf.allow_park=!0,this.wins.w[this._idd].b.park.enable()},dhtmlXWindowsCell.prototype.denyPark=function(){this.wins.w[this._idd].conf.allow_park=!1,this.wins.w[this._idd].b.park.disable()},dhtmlXWindowsCell.prototype.isParkable=function(){return 1==this.wins.w[this._idd].conf.allow_park},dhtmlXWindowsCell.prototype.show=function(t){this.wins._winShow(this._idd,window.dhx4.s2b(t))},dhtmlXWindowsCell.prototype.hide=function(){this.wins._winHide(this._idd)},dhtmlXWindowsCell.prototype.isHidden=function(){return 1!=this.wins.w[this._idd].conf.visible},dhtmlXWindowsCell.prototype.stick=function(){this.wins._winStick(this._idd,!0)},dhtmlXWindowsCell.prototype.unstick=function(){this.wins._winStick(this._idd,!1)},dhtmlXWindowsCell.prototype.isSticked=function(){return 1==this.wins.w[this._idd].conf.sticked},dhtmlXWindowsCell.prototype.setDimension=function(t,e){var n=this.wins.w[this._idd];n.conf.parked&&this.wins._winPark(this._idd,!1),n.conf.maxed?(null!=t&&(n.conf.lastMW=t),null!=e&&(n.conf.lastMH=e),this.wins._winMinmax(this._idd)):this.wins._winSetSize(this._idd,t,e,!1,!0),n=null},dhtmlXWindowsCell.prototype.getDimension=function(){var t=this.wins.w[this._idd],e=[t.conf.w,t.conf.h];return t=null,e},dhtmlXWindowsCell.prototype.setMinDimension=function(t,e){var n=this.wins.w[this._idd];n.conf.min_w=t,n.conf.min_h=e,this.wins._winSetSize(this._idd,n.conf.w,n.conf.h),n=null},dhtmlXWindowsCell.prototype.getMinDimension=function(){var t=this.wins.w[this._idd],e=[t.conf.min_w,t.conf.min_h];return t=null,e},dhtmlXWindowsCell.prototype.setMaxDimension=function(t,e){var n=this.wins.w[this._idd];n.conf.max_w=t,n.conf.max_h=e,this.wins._winSetSize(this._idd,n.conf.w,n.conf.h),n=null},dhtmlXWindowsCell.prototype.getMaxDimension=function(){var t=this.wins.w[this._idd],e=[t.conf.max_w,t.conf.max_h];return t=null,e},dhtmlXWindowsCell.prototype.keepInViewport=function(t){this.wins.w[this._idd].conf.keep_in_vp=window.dhx4.s2b(t)},dhtmlXWindowsCell.prototype.center=function(){var t=this.wins.vp,e=this.wins.w[this._idd],n=Math.round((t.clientWidth-e.conf.w)/2),i=Math.round((t.clientHeight-e.conf.h)/2);this.wins._winSetPosition(this._idd,n,i),t=e=null},dhtmlXWindowsCell.prototype.centerOnScreen=function(){for(var t=this.wins.w[this._idd],e=window.dhx4.screenDim(),n=window.dhx4.absLeft(this.wins.vp),i=window.dhx4.absTop(this.wins.vp),a=this.wins.vp.parentNode;null!=a;)a.scrollLeft&&(n-=a.scrollLeft),a.scrollTop&&(i-=a.scrollTop),a=a.parentNode;var o=Math.round((e.right-e.left-t.conf.w)/2),r=Math.round((e.bottom-e.top-t.conf.h)/2);this.wins._winAdjustPosition(this._idd,o-n,r-i),d=t=null},dhtmlXWindowsCell.prototype.bringToTop=function(){this.wins._winMakeActive(this._idd,!0)},dhtmlXWindowsCell.prototype.bringToBottom=function(){var t=this.wins.w[this._idd].conf.actv?null:this.wins.conf.last_active;window.dhx4.zim.clear(this.wins.w[this._idd].conf.z_id),this.wins.w[this._idd].win.style.zIndex=0,this.wins._winMakeActive(t,!0)},dhtmlXWindowsCell.prototype.isOnTop=function(){return 1==this.wins.w[this._idd].conf.actv},dhtmlXWindowsCell.prototype.isOnBottom=function(){var t={id:null,z:1/0};for(var e in this.wins.w)this.wins.w[e].conf.visible&&this.wins.w[e].win.style.zIndex<t.z&&(t.id=e,t.z=this.wins.w[e].win.style.zIndex);return t.id==this._idd},dhtmlXWindowsCell.prototype.showHeader=function(){var t=this.wins.w[this._idd];0==t.conf.header&&(t.hdr.className=String(t.hdr.className).replace(/\s{0,}dhxwin_hdr_hidden/gi,""),t.brd.className=String(t.brd.className).replace(/\s{0,}dhxwin_hdr_hidden/gi,""),this.conf.cells_cont=null,t.conf.brd=null,t.conf.header=!0,this.wins._winAdjustCell(this._idd)),t=null},dhtmlXWindowsCell.prototype.hideHeader=function(){var t=this.wins.w[this._idd];1==t.conf.header&&(t.conf.parked&&this.wins._winPark(this._idd,!1),t.hdr.className+=" dhxwin_hdr_hidden",t.brd.className+=" dhxwin_hdr_hidden",this.conf.cells_cont=null,t.conf.brd=null,t.conf.header=!1,this.wins._winAdjustCell(this._idd)),t=null},dhtmlXWindowsCell.prototype.setModal=function(t){this.wins._winSetModal(this._idd,window.dhx4.s2b(t))},dhtmlXWindowsCell.prototype.isModal=function(){return 1==this.wins.w[this._idd].conf.modal},dhtmlXWindowsCell.prototype._adjustByCont=function(t,e){t+=this.wins.w[this._idd].conf.w-this.conf.size.w,e+=this.wins.w[this._idd].conf.h-this.conf.size.h,this.wins._winSetSize(this._idd,t,e)},dhtmlXWindowsCell.prototype.close=function(){this.wins._winClose(this._idd)},dhtmlXWindowsCell.prototype.setIconCss=function(t){this.wins.w[this._idd].hdr.firstChild.className="dhxwin_icon "+t,this.wins._winAdjustTitle(this._idd)},dhtmlXWindowsCell.prototype.setToFullScreen=function(t){t=window.dhx4.s2b(t);var e=this.wins.w[this._idd];e.conf.fs_mode!=t?(null==this.wins.fsn&&(this.wins.fsn=document.createElement("DIV"),this.wins.fsn.className=this.wins.vp.className+" dhxwins_vp_fs",document.body.appendChild(this.wins.fsn)),t?(this.wins.fsn.appendChild(e.win),this.maximize(),this.hideHeader()):(this.wins.vp.appendChild(e.win),this.minimize(),this.showHeader(),0==this.wins.fsn.childNodes.length&&(this.wins.fsn.parentNode.removeChild(this.wins.fsn),this.wins.fsn=null)),e.conf.fs_mode=t,e=null):e=null},dhtmlXWindowsCell.prototype.button=function(t){return"minmax1"!=t&&"minmax2"!=t||(t="minmax"),this.wins.w[this._idd].b[t]},dhtmlXWindowsCell.prototype.addUserButton=function(t,e,n){var i=new dhtmlXWindowsButton(this.wins,this._idd,t,n,!0),a=null,o=this.wins.w[this._idd].hdr.lastChild;isNaN(e)?e=0:e<0&&(e=0),null!=o.childNodes[e]&&(a=o.childNodes[e]),null!=a?o.insertBefore(i.button,a):o.appendChild(i.button),this.wins.w[this._idd].b[t]=i,i=a=o=null,this.wins._winAdjustTitle(this._idd)},dhtmlXWindowsCell.prototype.removeUserButton=function(t){null!=this.wins.w[this._idd].b[t]&&1==this.wins.w[this._idd].b[t].conf.custom&&this.wins._winRemoveButton(this._idd,t)},window.dhtmlXWindowsButton=function(t,e,n,i,a){return this.conf={wins:t,winId:e,name:n,enabled:!0,visible:!0,custom:!0},this.button=document.createElement("DIV"),this.button._buttonName=n,this.button.title=i,this.enable=function(){this.conf.enabled=!0,this.setCss(this.conf.css)},this.disable=function(){this.conf.enabled=!1,this.setCss(this.conf.css)},this.isEnabled=function(){return 1==this.conf.enabled},this.show=function(){this.button.style.display="",this.conf.visible=!0,this.conf.wins._winAdjustTitle(this.conf.winId)},this.hide=function(){this.button.style.display="none",this.conf.visible=!1,this.conf.wins._winAdjustTitle(this.conf.winId)},this.isHidden=function(){return 0==this.conf.visible},this.setCss=function(t){this.conf.css=t;var e=this.conf.enabled?"":"_dis";this.button.className="dhxwin_button"+e+" dhxwin_button_"+this.conf.css+e},this._doOnClick=function(t){return this.callEvent("onClick",[this.conf.wins.w[this.conf.winId].cell,this])},this.unload=function(t){dhx4._eventable(this,"clear"),this.button._buttonName=null,this.button.parentNode.removeChild(this.button),null!=this.conf.wins.cm&&null!=this.conf.wins.cm.button[this.conf.winId]&&null!=this.conf.wins.cm.button[this.conf.winId][this.conf.name]&&this.conf.wins._detachContextMenu("button",this.conf.winId,this.conf.name),this.button=null,this.enable=null,this.disable=null,this.isEnabled=null,this.show=null,this.hide=null,this.isHidden=null,this.setCss=null,this.unload=null,1!=t&&this.conf.wins._winAdjustTitle(this.conf.winId),this.conf.wins=null,this.conf.winId=null,this.conf=null},this.setCss(n),dhx4._eventable(this),this},dhtmlXWindows.prototype._winButtonClick=function(t,e,n){return!this.w[t].b[e].isEnabled()||(!0===this.w[t].b[e]._doOnClick()?("help"==e&&this._callMainEvent("onHelp",t),"park"==e&&this._winPark(t,!0),"minmax"==e&&this._winMinmax(t),"stick"==e?(this._winStick(t),!1):"close"!=e||(this._winClose(t),!1)):void 0)},dhtmlXWindows.prototype._winRemoveButton=function(t,e,n){this.w[t].b[e].unload(n),this.w[t].b[e]=null,delete this.w[t].b[e]},dhtmlXWindows.prototype._dndInitModule=function(){var t=this;this.conf.dnd_enabled=!0,this.conf.dnd_tm=null,this.conf.dnd_time=0,this._dndOnMouseDown=function(e,n){if(!t.conf.dblclick_active&&(e.preventDefault?e.preventDefault():e.returnValue=!1,!0===t._callMainEvent("onBeforeMoveStart",n))){t.conf.dnd={id:n,x:t._dndPos(e,"X"),y:t._dndPos(e,"Y"),ready:!0,css:!1,css_touch:!1,css_vp:!1,tr:null,mode:"def",moved:!1,prevent:!1},t.w[n].conf.keep_in_vp?(t.conf.dnd.minX=0,t.conf.dnd.maxX=t.vp.clientWidth-t.w[n].conf.w,t.conf.dnd.minY=0,t.conf.dnd.maxY=t.vp.clientHeight-t.w[n].conf.h):(t.conf.dnd.minX=-t.w[n].conf.w+t.conf.vp_pos_ofs,t.conf.dnd.maxX=t.vp.clientWidth-t.conf.vp_pos_ofs,t.conf.dnd.minY=0,t.conf.dnd.maxY=t.vp.clientHeight-t.conf.vp_pos_ofs);for(var i=["MozTransform","WebkitTransform","OTransform","msTransform","transform"],a=0;a<i.length;a++)null!=document.documentElement.style[i[a]]&&null==t.conf.dnd.tr&&(t.conf.dnd.tr=i[a],t.conf.dnd.mode="tr");"tr"==t.conf.dnd.mode&&(t.w[n].win.style[t.conf.dnd.tr]="translate(0px,0px)",null!=t.w[n].fr_m_cover&&(t.w[n].fr_m_cover.style[t.conf.dnd.tr]=t.w[n].win.style[t.conf.dnd.tr])),0==window.dhx4.dnd._mTouch(e)&&e.type==window.dhx4.dnd.evs.start?(0==t.conf.dnd.css_touch&&(t.w[n].win.className+=" dhxwin_dnd_touch",t.conf.dnd.css_touch=!0),0==t.conf.dnd.css_vp&&(t.vp.className+=" dhxwins_vp_dnd",t.conf.dnd.css_vp=!0)):t._dndInitEvents()}},this._dndOnMouseMove=function(e){e=e||event;var n=t.conf.dnd,i=t._dndPos(e,"X")-n.x,a=t._dndPos(e,"Y")-n.y;if(e.type==window.dhx4.dnd.evs.move&&1!=n.moved&&(Math.abs(i)>20||Math.abs(a)>20))return null!=t.conf.dnd_tm&&(window.clearTimeout(t.conf.dnd_tm),t.conf.dnd_tm=null),void window.removeEventListener(window.dhx4.dnd.evs.start,t._dndOnMouseMove,!1);if(1==n.ready){var o=t.w[n.id];e.preventDefault?e.preventDefault():e.returnValue=!1,1!=n.css&&(0==n.css_touch&&(o.win.className+=" dhxwin_dnd"),o.fr_cover.className+=" dhxwin_fr_cover_dnd",n.css=!0),1!=n.css_vp&&(t.vp.className+=" dhxwins_vp_dnd",n.css_vp=!0),n.newX=o.conf.x+i,n.newY=o.conf.y+a,"tr"==n.mode?(n.newX=Math.min(Math.max(n.newX,n.minX),n.maxX),i=n.newX-o.conf.x,n.newY=Math.min(Math.max(n.newY,n.minY),n.maxY),a=n.newY-o.conf.y,o.win.style[n.tr]="translate("+i+"px,"+a+"px)",null!=o.fr_m_cover&&(o.fr_m_cover.style[n.tr]=o.win.style[n.tr])):(n.newX<n.minX||n.newX>n.maxX?n.newX=Math.min(Math.max(n.newX,n.minX),n.maxX):n.x=t._dndPos(e,"X"),n.newY<n.minY||n.newY>n.maxY?n.newY=Math.min(Math.max(n.newY,n.minY),n.maxY):n.y=t._dndPos(e,"Y"),t._winSetPosition(n.id,n.newX,n.newY)),n.moved=!0,o=n=null}},this._dndOnMouseUp=function(e){if(e=e||event,t._dndUnloadEvents(),null!=t.conf.dnd&&null!=t.conf.dnd.id){var n=t.conf.dnd,i=t.w[n.id];null!=n.newX&&"tr"==n.mode&&(t._winSetPosition(n.id,n.newX,n.newY),i.win.style[n.tr]="translate(0px,0px)",null!=i.fr_m_cover&&(i.fr_m_cover.style[n.tr]=i.win.style[n.tr])),1==n.css&&(0==n.css_touch&&(i.win.className=String(i.win.className).replace(/\s{0,}dhxwin_dnd/gi,"")),i.fr_cover.className=String(i.fr_cover.className).replace(/\s{0,}dhxwin_fr_cover_dnd/gi,"")),1==n.css_touch&&(i.win.className=String(i.win.className).replace(/\s{0,}dhxwin_dnd_touch/gi,"")),1==n.css_vp&&(t.vp.className=String(t.vp.className).replace(/\s{0,}dhxwins_vp_dnd/gi,"")),1==n.moved?t._callMainEvent("onMoveFinish",n.id):t._callMainEvent("onMoveCancel",n.id),i=n=t.conf.dnd=null}1==window.dhx4.dnd.p_en&&e.type==window.dhx4.dnd.evs.end&&(window.dhx4.dnd._touchOn(),window.removeEventListener(window.dhx4.dnd.evs.end,t._dndOnMouseUp,!1),window.removeEventListener(window.dhx4.dnd.evs.move,t._dndOnMouseMove,!1),null!=t.conf.dnd_tm&&window.clearTimeout(t.conf.dnd_tm),t.conf.dnd_tm=null)},this._dndOnSelectStart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this._dndInitEvents=function(){"function"==typeof window.addEventListener?(window.addEventListener("mousemove",this._dndOnMouseMove,!1),window.addEventListener("mouseup",this._dndOnMouseUp,!1),window.addEventListener("selectstart",this._dndOnSelectStart,!1)):(document.body.attachEvent("onmousemove",this._dndOnMouseMove),document.body.attachEvent("onmouseup",this._dndOnMouseUp),document.body.attachEvent("onselectstart",this._dndOnSelectStart))},this._dndUnloadEvents=function(){"function"==typeof window.addEventListener?(window.removeEventListener("mousemove",this._dndOnMouseMove,!1),window.removeEventListener("mouseup",this._dndOnMouseUp,!1),window.removeEventListener("selectstart",this._dndOnSelectStart,!1)):(document.body.detachEvent("onmousemove",this._dndOnMouseMove),document.body.detachEvent("onmouseup",this._dndOnMouseUp),document.body.detachEvent("onselectstart",this._dndOnSelectStart))},this._dndUnloadModule=function(){this.detachEvent(this.conf.dnd_evid),this.conf.dnd_evid=null,this._dndOnMouseDown=null,this._dndOnMouseMove=null,this._dndOnMouseUp=null,this._dndOnSelectStart=null,this._dndInitEvents=null,this._dndUnloadEvents=null,this._dndInitModule=null,this._dndUnloadModule=null,t=null},this._dndPos=function(t,e){var n=t[this.conf.dnd_ev_prefix+e];return null!=n&&0!=n||null==t.touches||(n=t.touches[0][this.conf.dnd_ev_prefix+e]),n},this.conf.dnd_evid=this.attachEvent("_winMouseDown",function(e,n){if(null!=this.w[n.id]&&1==this.w[n.id].conf.allow_move&&!(void 0!==e.button&&e.button>=2)){if(e.type==window.dhx4.dnd.evs.start){if("hdr"==n.mode){if(this.w[n.id].conf.maxed&&null==this.w[n.id].conf.max_w&&null==this.w[n.id].conf.max_h)return;this.conf.dnd_ev_prefix="page",this.conf.dnd={x:this._dndPos(e,"X"),y:this._dndPos(e,"Y")},this.conf.dnd_time<1?this._dndOnMouseDown(e,n.id):(null!=this.conf.dnd_tm&&window.clearTimeout(this.conf.dnd_tm),this.conf.dnd_tm=window.setTimeout(function(){t._dndOnMouseDown(e,n.id)},this.conf.dnd_time)),1==window.dhx4.dnd.p_en&&(window.dhx4.dnd._touchOff(),window.addEventListener(window.dhx4.dnd.evs.end,this._dndOnMouseUp,!1)),window.addEventListener(window.dhx4.dnd.evs.move,this._dndOnMouseMove,!1)}return!1}if(e.type==window.dhx4.dnd.evs.end)return null!=this.conf.dnd_tm&&(window.clearTimeout(this.conf.dnd_tm),this.conf.dnd_tm=null),this._dndOnMouseUp(e),window.removeEventListener(window.dhx4.dnd.evs.move,this._dndOnMouseMove,!1),!1;if(this.conf.dnd_ev_prefix="client","hdr"==n.mode&&"mousedown"==e.type&&(!this.w[n.id].conf.maxed||null!=this.w[n.id].conf.max_w||null!=this.w[n.id].conf.max_h))return e.preventDefault?e.preventDefault():e.returnValue=!1,this._dndOnMouseDown(e,n.id),!1}})},dhtmlXWindowsCell.prototype._initResize=function(){var t=this,e=navigator.userAgent;this.conf.resize={b_width:6,c_type:e.indexOf("MSIE 10.0")>0||e.indexOf("MSIE 9.0")>0||e.indexOf("MSIE 8.0")>0||e.indexOf("MSIE 7.0")>0||e.indexOf("MSIE 6.0")>0,btn_left:(window.dhx4.isIE6||window.dhx4.isIE7||window.dhx4.isIE8)&&void 0===window.addEventListener?1:0},this._rOnCellMouseMove=function(e){if(1==t.wins.conf.resize_actv||0==t.wins.w[t._idd].conf.allow_resize||1==t.conf.progress||1==t.wins.w[t._idd].conf.maxed||1==t.wins.w[t._idd].conf.fs_mode){var n=t.wins.w[t._idd].brd;return"default"!=n.style.cursor&&(n.style.cursor="default"),void(n=null)}e=e||event;var i=t.wins.w[t._idd].brd,a=t.conf.resize,o=0==t.wins.w[t._idd].conf.header,r=e.clientX,s=e.clientY;r+=document.documentElement.scrollLeft||document.body.scrollLeft||0,s+=document.documentElement.scrollTop||document.body.scrollTop||0;var l=window.dhx4.absLeft(i),d=window.dhx4.absTop(i),c="";r<=l+a.b_width?c="w":r>=l+i.offsetWidth-a.b_width&&(c="e"),s>=d+i.offsetHeight-a.b_width?c="s"+c:o&&s<=d+a.b_width&&(c="n"+c),""==c&&(c=!1),a.mode!=c&&(a.mode=c,i.style.cursor=0==c?"default":c+"-resize"),i=a=null},this._rOnCellMouseDown=function(e){if((void 0===(e=e||event).button||e.button==t.conf.resize.btn_left)&&0!=t.conf.resize.mode&&1!=t.conf.progress&&0!=t.wins.w[t._idd].conf.allow_resize&&1!=t.wins.w[t._idd].conf.fs_mode&&(e.preventDefault?e.preventDefault():e.returnValue=!1,!0===t.wins._callMainEvent("onBeforeResizeStart",t._idd))){var n=t.wins.w[t._idd],i=t.conf.resize;if(t.wins.conf.resize_actv=!0,i.min_w=n.conf.min_w,i.min_h=n.conf.min_h,i.max_w=n.conf.max_w||1/0,i.max_h=n.conf.max_h||1/0,"layout"==n.cell.dataType&&null!=n.cell.dataObj&&"function"==typeof n.cell.dataObj._getWindowMinDimension){var a=n.cell.dataObj._getWindowMinDimension(n.cell);i.min_w=Math.max(a.w,i.min_w),i.min_h=Math.max(a.h,i.min_h)}i.vp_l=t.wins.conf.vp_pos_ofs,i.vp_r=t.wins.vp.clientWidth-t.wins.conf.vp_pos_ofs,i.vp_b=t.wins.vp.clientHeight-t.wins.conf.vp_pos_ofs,i.x=e.clientX,i.y=e.clientY,"function"==typeof window.addEventListener?(window.addEventListener("mousemove",t._rOnWinMouseMove,!1),window.addEventListener("mouseup",t._rOnWinMouseUp,!1),window.addEventListener("selectstart",t._rOnSelectStart,!1)):(document.body.attachEvent("onmousemove",t._rOnWinMouseMove),document.body.attachEvent("onmouseup",t._rOnWinMouseUp),document.body.attachEvent("onselectstart",t._rOnSelectStart)),i.resized=!1,i.vp_cursor=t.wins.vp.style.cursor,t.wins.vp.style.cursor=i.mode+"-resize",n=i=null}},this._rOnCellContextMenu=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this._rOnWinMouseMove=function(e){e=e||event;var n=t.wins.w[t._idd],i=t.conf.resize;i.resized||(n.fr_cover.className+=" dhxwin_fr_cover_resize",i.resized=!0);var a=e.clientX-i.x,o=e.clientY-i.y;i.mode.indexOf("e")>=0?(i.rw=Math.min(Math.max(n.conf.w+a,i.min_w),i.max_w),i.rx=null,n.conf.x+i.rw<i.vp_l?i.rw=i.vp_l-n.conf.x:n.conf.x+i.rw>t.wins.vp.clientWidth&&(i.rw=t.wins.vp.clientWidth-n.conf.x)):i.mode.indexOf("w")>=0&&(i.rw=Math.min(Math.max(n.conf.w-a,i.min_w),i.max_w),i.rx=n.conf.x+n.conf.w-i.rw,i.rx<0?(i.rw=i.rw+i.rx,i.rx=0):i.rx>i.vp_r&&(i.rw=i.rw-i.vp_r,i.rx=i.vp_r)),i.mode.indexOf("s")>=0?(i.rh=Math.min(Math.max(n.conf.h+o,i.min_h),i.max_h),i.ry=null,n.conf.y+i.rh>t.wins.vp.clientHeight&&(i.rh=t.wins.vp.clientHeight-n.conf.y)):i.mode.indexOf("n")>=0&&(i.rh=Math.min(Math.max(n.conf.h-o,i.min_h),i.max_h),i.ry=n.conf.y+n.conf.h-i.rh,i.ry<0?(i.rh=i.rh+i.ry,i.ry=0):i.ry>i.vp_b&&(i.rh=i.rh-i.vp_b,i.ry=i.vp_b)),t._rAdjustSizer(),n=i=null},this._rOnWinMouseUp=function(){var e=t.conf.resize,n=t.wins.w[t._idd];t.wins.conf.resize_actv=!1,t.wins.vp.style.cursor=e.vp_cursor,n.fr_cover.className=String(n.fr_cover.className).replace(/\s{0,}dhxwin_fr_cover_resize/gi,""),e.resized&&(t.wins._winSetSize(t._idd,e.rw,e.rh),null==e.rx&&(e.rx=n.conf.x),null==e.ry&&(e.ry=n.conf.y),e.rx==n.conf.x&&e.ry==n.conf.y||t.wins._winSetPosition(t._idd,e.rx,e.ry)),null!=e.obj&&(e.obj.parentNode.removeChild(e.obj),e.obj=null),null!=e.objFR&&(e.objFR.parentNode.removeChild(e.objFR),e.objFR=null),"function"==typeof window.addEventListener?(window.removeEventListener("mousemove",t._rOnWinMouseMove,!1),window.removeEventListener("mouseup",t._rOnWinMouseUp,!1),window.removeEventListener("selectstart",t._rOnSelectStart,!1)):(document.body.detachEvent("onmousemove",t._rOnWinMouseMove),document.body.detachEvent("onmouseup",t._rOnWinMouseUp),document.body.detachEvent("onselectstart",t._rOnSelectStart)),1==e.resized?("layout"==t.dataType&&null!=t.dataObj&&t.dataObj.callEvent("onResize",[]),t.wins._callMainEvent("onResizeFinish",t._idd)):t.wins._callMainEvent("onResizeCancel",t._idd),e.mode="",n=e=null},this._rOnSelectStart=function(t){return(t=t||event).preventDefault?t.preventDefault():t.returnValue=!1,!1},this._rInitSizer=function(){var e=t.conf.resize,n=t.wins.w[t._idd];e.obj=document.createElement("DIV"),e.obj.className="dhxwin_resize",e.obj.style.zIndex=n.win.style.zIndex,e.obj.style.cursor=e.mode+"-resize",t.wins.vp.appendChild(e.obj),1==t.wins.conf.fr_cover&&(e.objFR=document.createElement("IFRAME"),e.objFR.className="dhxwin_resize_fr_cover",e.objFR.style.zIndex=e.obj.style.zIndex,t.wins.vp.insertBefore(e.objFR,e.obj)),e.rx=n.conf.x,e.ry=n.conf.y,e.rw=n.conf.w,e.rh=n.conf.h,e=null},this._rAdjustSizer=function(){var e=t.conf.resize;e.obj||this._rInitSizer(),e.obj.style.width=e.rw+"px",e.obj.style.height=e.rh+"px",null!=e.rx&&(e.obj.style.left=e.rx+"px"),null!=e.ry&&(e.obj.style.top=e.ry+"px"),null!=e.objFR&&(e.objFR.style.width=e.obj.style.width,e.objFR.style.height=e.obj.style.height,null!=e.rx&&(e.objFR.style.left=e.obj.style.left),null!=e.ry&&(e.objFR.style.top=e.obj.style.top)),e=null},"function"==typeof window.addEventListener?(this.wins.w[this._idd].brd.addEventListener("mousemove",this._rOnCellMouseMove,!1),this.wins.w[this._idd].brd.addEventListener("mousedown",this._rOnCellMouseDown,!1),this.wins.w[this._idd].brd.addEventListener("contextmenu",this._rOnCellContextMenu,!1)):(this.wins.w[this._idd].brd.attachEvent("onmousemove",this._rOnCellMouseMove),this.wins.w[this._idd].brd.attachEvent("onmousedown",this._rOnCellMouseDown),this.wins.w[this._idd].brd.attachEvent("oncontextmenu",this._rOnCellContextMenu)),this._unloadResize=function(){"function"==typeof window.addEventListener?(this.wins.w[this._idd].brd.removeEventListener("mousemove",this._rOnCellMouseMove,!1),this.wins.w[this._idd].brd.removeEventListener("mousedown",this._rOnCellMouseDown,!1),this.wins.w[this._idd].brd.removeEventListener("contextmenu",this._rOnCellContextMenu,!1)):(this.wins.w[this._idd].brd.detachEvent("onmousemove",this._rOnCellMouseMove),this.wins.w[this._idd].brd.detachEvent("onmousedown",this._rOnCellMouseDown),this.wins.w[this._idd].brd.detachEvent("oncontextmenu",this._rOnCellContextMenu)),this._initResize=null,this._rOnCellMouseMove=null,this._rOnCellMouseDown=null,this._rOnWinMouseMove=null,this._rOnWinMouseUp=null,this._rOnSelectStart=null,this._rInitSizer=null,this._rAdjustSizer=null,this._unloadResize=null,this.conf.resize=null,t=null}},dhtmlXWindows.prototype.attachContextMenu=function(t){return this._renderContextMenu("icon",null,null,t)},dhtmlXWindows.prototype.getContextMenu=function(){return null!=this.cm&&null!=this.cm.global?this.cm.global:null},dhtmlXWindows.prototype.detachContextMenu=function(){this._detachContextMenu("icon",null,null)},dhtmlXWindowsCell.prototype.attachContextMenu=function(t){return this.wins._renderContextMenu("icon",this._idd,null,t)},dhtmlXWindowsCell.prototype.getContextMenu=function(){return null!=this.wins.cm&&null!=this.wins.cm.icon[this._idd]?this.wins.cm.icon[this._idd]:null},dhtmlXWindowsCell.prototype.detachContextMenu=function(){this.wins._detachContextMenu("icon",this._idd,null)},dhtmlXWindowsButton.prototype.attachContextMenu=function(t){return this.conf.wins._renderContextMenu("button",this.conf.winId,this.conf.name,t)},dhtmlXWindowsButton.prototype.getContextMenu=function(){return null==this.conf.wins.cm||null==this.conf.wins.cm.button[this.conf.winId]?null:null!=this.conf.wins.cm.button[this.conf.winId][this.conf.name]?this.conf.wins.cm.button[this.conf.winId][this.conf.name]:null},dhtmlXWindowsButton.prototype.detachContextMenu=function(){this.conf.wins._detachContextMenu("button",this.conf.winId,this.conf.name)},dhtmlXWindows.prototype._renderContextMenu=function(t,e,n,i){var a=this,o=!1;if(null==this.cm&&(this.cm={global:null,icon:{},button:{}},o=!0),null==e){if(null!=this.cm.global)return}else if("icon"==t){if(null!=this.cm.icon[e])return}else if("button"==t&&null!=this.cm.button[e]&&null!=this.cm.button[e][n])return;null==i&&(i={}),i.parent=null,i.context=!0;var r=new dhtmlXMenuObject(i);return r.setAutoHideMode(!1),r.attachEvent("onShow",function(){this.conf.wins_menu_open=!0}),r.attachEvent("onHide",function(){this.conf.wins_menu_open=!1,a.conf.opened_menu=null}),null==e?this.cm.global=r:"icon"==t?this.cm.icon[e]=r:"button"==t&&(null==this.cm.button[e]&&(this.cm.button[e]={}),this.cm.button[e][n]=r),o&&(this._showContextMenu=function(t,e){if(!(t.button>=2)){if("icon"==e.mode&&null!=e.id&&"mousedown"==e.press_type){if(null==(i=this.cm.icon[e.id]||this.cm.global))return;t.cancelBubble=!0;var n=this.w[e.id].hdr.firstChild;i.conf.wins_menu_open&&this.conf.opened_menu==e.id?i.hideContextMenu():(this._hideContextMenu(),i.showContextMenu(window.dhx4.absLeft(n),window.dhx4.absTop(n)+n.offsetHeight),this.conf.opened_menu=e.id),i=n=null}if("button"==e.mode&&null!=e.id&&"mousedown"==e.press_type){if(null==this.cm.button[e.id]||null==this.cm.button[e.id][e.button_name])return;t.cancelBubble=!0,this.conf.button_last=null;var i=this.cm.button[e.id][e.button_name],a=this.w[e.id].b[e.button_name].button;i.conf.wins_menu_open&&this.conf.opened_menu==e.id?i.hideContextMenu():(this._hideContextMenu(),i.showContextMenu(window.dhx4.absLeft(a),window.dhx4.absTop(a)+a.offsetHeight),this.conf.opened_menu=e.id),i=a=null}}},this._hideContextMenu=function(t){if(null!=t){if("keydown"==(t=t||event).type&&27!=t.keyCode)return;for(var e=t.target||t.srcElement,n=!0;null!=e&&1==n;)null!=e.className&&e.className.search(/SubLevelArea_Polygon/)>=0?n=!1:e=e.parentNode}if(n||null==t){for(var i in null!=a.cm.global&&a.cm.global.hideContextMenu(),a.cm.icon)null!=a.cm.icon[i]&&a.cm.icon[i].hideContextMenu();for(var i in a.cm.button)for(var o in a.cm.button[i])null!=a.cm.button[i][o]&&a.cm.button[i][o].hideContextMenu()}},this._detachContextMenu=function(t,e,n){null!=this.cm&&(null==e?null!=this.cm.global&&(this.cm.global.unload(),this.cm.global=null):"icon"==t?null!=this.cm.icon[e]&&(this.cm.icon[e].unload(),this.cm.icon[e]=null):"button"==t&&null!=this.cm.button[e]&&null!=this.cm.button[e][n]&&(this.cm.button[e][n].unload(),this.cm.button[e][n]=null))},this.attachEvent("_winMouseDown",this._showContextMenu),"function"==typeof window.addEventListener?(window.addEventListener("mousedown",this._hideContextMenu,!1),window.addEventListener("keydown",this._hideContextMenu,!1)):(document.body.attachEvent("onmousedown",this._hideContextMenu),document.body.attachEvent("onkeydown",this._hideContextMenu)),this._unloadContextMenu=function(){this._detachContextMenu("icon",null,null),this.cm=null,"function"==typeof window.addEventListener?(window.removeEventListener("mousedown",this._hideContextMenu,!1),window.removeEventListener("keydown",this._hideContextMenu,!1)):(document.body.detachEvent("onmousedown",this._hideContextMenu),document.body.detachEvent("onkeydown",this._hideContextMenu)),a=null}),r},window.dhtmlx||(window.dhtmlx={}),function(){var t=null;function e(e,n){var a=e.callback;i(!1),e.box.parentNode.removeChild(e.box),t=e.box=null,a&&a(n)}function n(n){if(t){var i=(n=n||event).which||event.keyCode;return dhtmlx.message.keyboard&&(13!=i&&32!=i||e(t,!0),27==i&&e(t,!1)),n.preventDefault&&n.preventDefault(),!(n.cancelBubble=!0)}}function i(t){i.cover||(i.cover=document.createElement("DIV"),i.cover.onkeydown=n,i.cover.className="dhx_modal_cover",document.body.appendChild(i.cover));document.body.scrollHeight;i.cover.style.display=t?"inline-block":"none"}function a(t,e){return"<div class='dhtmlx_popup_button' result='"+e+"' ><div>"+t+"</div></div>"}function o(o,r,s){var l=o.tagName?o:function(n,i,o){var r=document.createElement("DIV");r.className=" dhtmlx_modal_box dhtmlx-"+n.type,r.setAttribute("dhxbox",1);var s="";if(n.width&&(r.style.width=n.width),n.height&&(r.style.height=n.height),n.title&&(s+='<div class="dhtmlx_popup_title">'+n.title+"</div>"),s+='<div class="dhtmlx_popup_text"><span>'+(n.content?"":n.text)+'</span></div><div  class="dhtmlx_popup_controls">',i&&(s+=a(n.ok||"OK",!0)),o&&(s+=a(n.cancel||"Cancel",!1)),n.buttons)for(var l=0;l<n.buttons.length;l++)s+=a(n.buttons[l],l);if(s+="</div>",r.innerHTML=s,n.content){var d=n.content;"string"==typeof d&&(d=document.getElementById(d)),"none"==d.style.display&&(d.style.display=""),r.childNodes[n.title?1:0].appendChild(d)}return r.onclick=function(t){var i=(t=t||event).target||t.srcElement;if(i.className||(i=i.parentNode),"dhtmlx_popup_button"==i.className){var a=i.getAttribute("result");e(n,a="true"==a||"false"!=a&&a)}},n.box=r,(i||o)&&(t=n),r}(o,r,s);o.hidden||i(!0),document.body.appendChild(l);var d=o.left||Math.abs(Math.floor(((window.innerWidth||document.documentElement.offsetWidth)-l.offsetWidth)/2)),c=o.top||Math.abs(Math.floor(((window.innerHeight||document.documentElement.offsetHeight)-l.offsetHeight)/2));return"top"==o.position?l.style.top="-3px":l.style.top=c+"px",l.style.left=d+"px",l.onkeydown=n,l.focus(),o.hidden&&dhtmlx.modalbox.hide(l),l}function r(t){return o(t,!0,!1)}function s(t){return o(t,!0,!0)}function l(t){return o(t)}function d(t,e,n){return"object"!=typeof t&&("function"==typeof e&&(n=e,e=""),t={text:t,type:e,callback:n}),t}document.attachEvent?document.attachEvent("onkeydown",n):document.addEventListener("keydown",n,!0),dhtmlx.alert=function(){var t=d.apply(this,arguments);return t.type=t.type||"confirm",r(t)},dhtmlx.confirm=function(){var t=d.apply(this,arguments);return t.type=t.type||"alert",s(t)},dhtmlx.modalbox=function(){var t=d.apply(this,arguments);return t.type=t.type||"alert",l(t)},dhtmlx.modalbox.hide=function(e){for(;e&&e.getAttribute&&!e.getAttribute("dhxbox");)e=e.parentNode;e&&(e.parentNode.removeChild(e),i(!1),t=null)};var c=dhtmlx.message=function(t,e,n,i){switch((t=function(t,e,n,i){return"object"==typeof t&&t||(t={text:t,type:e,expire:n,id:i}),t.id=t.id||c.uid(),t.expire=t.expire||c.expire,t}.apply(this,arguments)).type=t.type||"info",t.type.split("-")[0]){case"alert":return r(t);case"confirm":return s(t);case"modalbox":return l(t);default:return function(t){c.area||(c.area=document.createElement("DIV"),c.area.className="dhtmlx_message_area",c.area.style[c.position]="15px",document.body.appendChild(c.area)),c.hide(t.id);var e=document.createElement("DIV");return e.innerHTML="<div>"+t.text+"</div>",e.className="dhtmlx-info dhtmlx-"+t.type,e.onclick=function(){t&&c.hide(t.id),t=null},"bottom"==c.position&&c.area.firstChild?c.area.insertBefore(e,c.area.firstChild):c.area.appendChild(e),t.expire>0&&(c.timers[t.id]=window.setTimeout(function(){c.hide(t.id)},t.expire)),c.pull[t.id]=e,e=null,t.id}(t)}};c.seed=(new Date).valueOf(),c.uid=function(){return c.seed++},c.expire=4e3,c.keyboard=!0,c.position="top",c.pull={},c.timers={},c.hideAll=function(){for(var t in c.pull)c.hide(t)},c.hide=function(t){var e=c.pull[t];e&&e.parentNode&&(window.setTimeout(function(){e.parentNode.removeChild(e),e=null},2e3),e.className+=" hidden",c.timers[t]&&window.clearTimeout(c.timers[t]),delete c.pull[t])}}(),function(){var dhx={},temp,_cache,newlines,quotes;dhx.assert=function(t,e){t||dhx.assert_error(e)},dhx.assert_error=function(message){dhx.log("error",message),dhx.message&&"string"==typeof message&&dhx.message({type:"debug",text:message,expire:-1}),!1!==dhx.debug&&eval("debugger;")},dhx.assert_core_ready=function(){window.dhx_on_core_ready&&dhx_on_core_ready()},dhx.codebase="./",dhx.name="Core",dhx.clone=function(t){var e=dhx.clone._function;return e.prototype=t,new e},dhx.clone._function=function(){},dhx.extend=function(t,e,n){if(dhx.assert(t,"Invalid mixing target"),dhx.assert(e,"Invalid mixing source"),t._dhx_proto_wait)return dhx.PowerArray.insertAt.call(t._dhx_proto_wait,e,1),t;for(var i in e)t[i]&&!n||(t[i]=e[i]);return e.defaults&&dhx.extend(t.defaults,e.defaults),e.$init&&e.$init.call(t),t},dhx.copy=function(t){if(dhx.assert(t,"Invalid mixing target"),arguments.length>1){var e=arguments[0];t=arguments[1]}else e=dhx.isArray(t)?[]:{};for(var n in t)t[n]&&"object"==typeof t[n]&&!dhx.isDate(t[n])?(e[n]=dhx.isArray(t[n])?[]:{},dhx.copy(e[n],t[n])):e[n]=t[n];return e},dhx.single=function(t){var e=null;return function(n){return e||(e=new t({})),e._reinit&&e._reinit.apply(e,arguments),e}},dhx.protoUI=function(){dhx.debug_proto&&dhx.log("UI registered: "+arguments[0].name);var t=arguments[0].name,e=function(n){if(!e)return dhx.ui[t].prototype;var i=e._dhx_proto_wait;if(i){for(var a=[i[0]],o=1;o<i.length;o++)a[o]=i[o],a[o]._dhx_proto_wait&&(a[o]=a[o].call(dhx,a[o].name)),a[o].prototype&&a[o].prototype.name&&(dhx.ui[a[o].prototype.name]=a[o]);if(dhx.ui[t]=dhx.proto.apply(dhx,a),e._dhx_type_wait)for(o=0;o<e._dhx_type_wait.length;o++)dhx.Type(dhx.ui[t],e._dhx_type_wait[o]);e=i=null}return this!=dhx?new dhx.ui[t](n):dhx.ui[t]};return e._dhx_proto_wait=Array.prototype.slice.call(arguments,0),dhx.ui[t]=e},dhx.proto=function(){dhx.debug_proto&&dhx.log("Proto chain:"+arguments[0].name+"["+arguments.length+"]");var t=arguments,e=t[0],n=!!e.$init,i=[];dhx.assert(e,"Invalid mixing target");for(var a=t.length-1;a>0;a--){if(dhx.assert(t[a],"Invalid mixing source"),"function"==typeof t[a]&&(t[a]=t[a].prototype),t[a].$init&&i.push(t[a].$init),t[a].defaults){var o=t[a].defaults;for(var r in e.defaults||(e.defaults={}),o)dhx.isUndefined(e.defaults[r])&&(e.defaults[r]=o[r])}if(t[a].type&&e.type)for(var r in t[a].type)e.type[r]||(e.type[r]=t[a].type[r]);for(var s in t[a])e[s]||(e[s]=t[a][s])}n&&i.push(e.$init),e.$init=function(){for(var t=0;t<i.length;t++)i[t].apply(this,arguments)};var l=function(t){this.$ready=[],dhx.assert(this.$init,"object without init method"),this.$init(t),this._parseSettings&&this._parseSettings(t,this.defaults);for(var e=0;e<this.$ready.length;e++)this.$ready[e].call(this)};return l.prototype=e,e=t=null,l},dhx.bind=function(t,e){return function(){return t.apply(e,arguments)}},dhx.require=function(t,e,n){if("string"==typeof t){if(!0!==dhx._modules[t]){if(".css"==t.substr(-4)){var i=dhx.html.create("LINK",{type:"text/css",rel:"stylesheet",href:dhx.codebase+t});return document.head.appendChild(i),void(e&&e.call(n||window))}arguments[4];e?dhx._modules[t]?dhx._modules[t].push([e,n]):(dhx._modules[t]=[[e,n]],dhx.ajax(dhx.codebase+t,function(e){dhx.exec(e);var n=dhx._modules[t];dhx._modules[t]=!0;for(var i=0;i<n.length;i++)n[i][0].call(n[i][1]||window,!i)})):(dhx.exec(dhx.ajax().sync().get(dhx.codebase+t).responseText),dhx._modules[t]=!0)}}else{var a=t.length||0,o=e;if(a)(e=function(){if(!a)return o.apply(this,arguments);a--,dhx.require(t[t.length-a-1],e,n)})();else{for(var r in t)a++;for(var r in e=function(){0===--a&&o.apply(this,arguments)},t)dhx.require(r,e,n)}}},dhx._modules={},dhx.exec=function(t){window.execScript?window.execScript(t):window.eval(t)},dhx.wrap=function(t,e){return t?function(){var n=t.apply(this,arguments);return e.apply(this,arguments),n}:e},dhx.isUndefined=function(t){return void 0===t},dhx.delay=function(t,e,n,i){return window.setTimeout(function(){var i=t.apply(e,n||[]);return t=e=n=null,i},i||1)},dhx.uid=function(){return this._seed||(this._seed=(new Date).valueOf()),this._seed++,this._seed},dhx.toNode=function(t){return"string"==typeof t?document.getElementById(t):t},dhx.toArray=function(t){return dhx.extend(t||[],dhx.PowerArray,!0)},dhx.toFunctor=function(str){return"string"==typeof str?eval(str):str},dhx.isArray=function(t){return Array.isArray?Array.isArray(t):"[object Array]"===Object.prototype.toString.call(t)},dhx.isDate=function(t){return t instanceof Date},dhx._events={},dhx.event=function(t,e,n,i){t=dhx.toNode(t);var a=dhx.uid();return i&&(n=dhx.bind(n,i)),dhx._events[a]=[t,e,n],t.addEventListener?t.addEventListener(e,n,!1):t.attachEvent&&t.attachEvent("on"+e,n),a},dhx.eventRemove=function(t){if(t){dhx.assert(this._events[t],"Removing non-existing event");var e=dhx._events[t];e[0].removeEventListener?e[0].removeEventListener(e[1],e[2],!1):e[0].detachEvent&&e[0].detachEvent("on"+e[1],e[2]),delete this._events[t]}},dhx.log=function(t,e,n){1==arguments.length&&(e=t,t="log"),window.console&&console.log&&(t=t.toLowerCase(),window.console[t]?window.console[t](e||"unknown error"):window.console.log(t+": "+e),n&&window.console.log(n))},dhx.log_full_time=function(t){dhx._start_time_log=new Date,dhx.log("Timing start ["+t+"]"),window.setTimeout(function(){var e=new Date;dhx.log("Timing end ["+t+"]:"+(e.valueOf()-dhx._start_time_log.valueOf())/1e3+"s")},1)},dhx.log_time=function(t){var e="_start_time_log"+t;if(dhx[e]){var n=new Date;dhx.log("Info","Timing end ["+t+"]:"+(n.valueOf()-dhx[e].valueOf())/1e3+"s"),dhx[e]=null}else dhx[e]=new Date,dhx.log("Info","Timing start ["+t+"]")},dhx.debug_code=function(t){t.call(dhx)},dhx.EventSystem={$init:function(){this._evs_events||(this._evs_events={},this._evs_handlers={},this._evs_map={})},blockEvent:function(){this._evs_events._block=!0},unblockEvent:function(){this._evs_events._block=!1},mapEvent:function(t){dhx.extend(this._evs_map,t,!0)},on_setter:function(t){if(t)for(var e in t)"function"==typeof t[e]&&this.attachEvent(e,t[e])},callEvent:function(t,e){if(this._evs_events._block)return!0;t=t.toLowerCase();var n=this._evs_events[t.toLowerCase()],i=!0;if(dhx.debug&&dhx.log("info","["+this.name+"] event:"+t,e),n)for(var a=0;a<n.length;a++)!1===n[a].apply(this,e||[])&&(i=!1);return this._evs_map[t]&&!this._evs_map[t].callEvent(t,e)&&(i=!1),i},attachEvent:function(t,e,n){dhx.assert(e,"Invalid event handler for "+t),t=t.toLowerCase(),n=n||dhx.uid(),e=dhx.toFunctor(e);var i=this._evs_events[t]||dhx.toArray();return i.push(e),this._evs_events[t]=i,this._evs_handlers[n]={f:e,t:t},n},detachEvent:function(t){if(this._evs_handlers[t]){var e=this._evs_handlers[t].t,n=this._evs_handlers[t].f;this._evs_events[e].remove(n),delete this._evs_handlers[t]}},hasEvent:function(t){return t=t.toLowerCase(),!!this._evs_events[t]}},dhx.extend(dhx,dhx.EventSystem),dhx.PowerArray={removeAt:function(t,e){t>=0&&this.splice(t,e||1)},remove:function(t){this.removeAt(this.find(t))},insertAt:function(t,e){if(e||0===e){var n=this.splice(e,this.length-e);this[e]=t,this.push.apply(this,n)}else this.push(t)},find:function(t){for(var e=0;e<this.length;e++)if(t==this[e])return e;return-1},each:function(t,e){for(var n=0;n<this.length;n++)t.call(e||this,this[n])},map:function(t,e){for(var n=0;n<this.length;n++)this[n]=t.call(e||this,this[n]);return this},filter:function(t,e){for(var n=0;n<this.length;n++)t.call(e||this,this[n])||(this.splice(n,1),n--);return this}},dhx.env={},function(){-1!=navigator.userAgent.indexOf("Mobile")&&(dhx.env.mobile=!0),(dhx.env.mobile||-1!=navigator.userAgent.indexOf("iPad")||-1!=navigator.userAgent.indexOf("Android"))&&(dhx.env.touch=!0),-1!=navigator.userAgent.indexOf("Opera")?dhx.env.isOpera=!0:(dhx.env.isIE=!!document.all,dhx.env.isFF=!document.all,dhx.env.isWebKit=-1!=navigator.userAgent.indexOf("KHTML"),dhx.env.isSafari=dhx.env.isWebKit&&-1!=navigator.userAgent.indexOf("Mac")),-1!=navigator.userAgent.toLowerCase().indexOf("android")&&(dhx.env.isAndroid=!0),dhx.env.transform=!1,dhx.env.transition=!1;for(var t={names:["transform","transition"],transform:["transform","WebkitTransform","MozTransform","OTransform","msTransform"],transition:["transition","WebkitTransition","MozTransition","OTransition","msTransition"]},e=document.createElement("DIV"),n=0;n<t.names.length;n++)for(var i=t[t.names[n]],a=0;a<i.length;a++)if(void 0!==e.style[i[a]]){dhx.env[t.names[n]]=i[a];break}e.style[dhx.env.transform]="translate3d(0,0,0)",dhx.env.translate=e.style[dhx.env.transform]?"translate3d":"translate";var o="",r=!1;dhx.env.isOpera&&(o="-o-",r="O"),dhx.env.isFF&&(o="-Moz-"),dhx.env.isWebKit&&(o="-webkit-"),dhx.env.isIE&&(o="-ms-"),dhx.env.transformCSSPrefix=o,dhx.env.transformPrefix=r||dhx.env.transformCSSPrefix.replace(/-/gi,""),dhx.env.transitionEnd="-Moz-"==dhx.env.transformCSSPrefix?"transitionend":dhx.env.transformPrefix+"TransitionEnd"}(),dhx.env.svg=document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1"),dhx.html={_native_on_selectstart:0,denySelect:function(){dhx._native_on_selectstart||(dhx._native_on_selectstart=document.onselectstart),document.onselectstart=dhx.html.stopEvent},allowSelect:function(){0!==dhx._native_on_selectstart&&(document.onselectstart=dhx._native_on_selectstart||null),dhx._native_on_selectstart=0},index:function(t){for(var e=0;t=t.previousSibling;)e++;return e},_style_cache:{},createCss:function(t){var e="";for(var n in t)e+=n+":"+t[n]+";";var i=this._style_cache[e];return i||(i="s"+dhx.uid(),this.addStyle("."+i+"{"+e+"}"),this._style_cache[e]=i),i},addStyle:function(t){var e=document.createElement("style");e.setAttribute("type","text/css"),e.setAttribute("media","screen"),e.styleSheet?e.styleSheet.cssText=t:e.appendChild(document.createTextNode(t)),document.getElementsByTagName("head")[0].appendChild(e)},create:function(t,e,n){e=e||{};var i=document.createElement(t);for(var a in e)i.setAttribute(a,e[a]);return e.style&&(i.style.cssText=e.style),e.class&&(i.className=e.class),n&&(i.innerHTML=n),i},getValue:function(t){return(t=dhx.toNode(t))?dhx.isUndefined(t.value)?t.innerHTML:t.value:""},remove:function(t){if(t instanceof Array)for(var e=0;e<t.length;e++)this.remove(t[e]);else t&&t.parentNode&&t.parentNode.removeChild(t)},insertBefore:function(t,e,n){t&&(e&&e.parentNode?e.parentNode.insertBefore(t,e):n.appendChild(t))},locate:function(t,e){if(t.tagName)var n=t;else n=(t=t||event).target||t.srcElement;for(;n;){if(n.getAttribute){var i=n.getAttribute(e);if(i)return i}n=n.parentNode}return null},offset:function(t){if(t.getBoundingClientRect){var e=t.getBoundingClientRect(),n=document.body,i=document.documentElement,a=window.pageYOffset||i.scrollTop||n.scrollTop,o=window.pageXOffset||i.scrollLeft||n.scrollLeft,r=i.clientTop||n.clientTop||0,s=i.clientLeft||n.clientLeft||0,l=e.top+a-r,d=e.left+o-s;return{y:Math.round(l),x:Math.round(d)}}for(l=0,d=0;t;)l+=parseInt(t.offsetTop,10),d+=parseInt(t.offsetLeft,10),t=t.offsetParent;return{y:l,x:d}},posRelative:function(t){return t=t||event,dhx.isUndefined(t.offsetX)?{x:t.layerX,y:t.layerY}:{x:t.offsetX,y:t.offsetY}},pos:function(t){if((t=t||event).pageX||t.pageY)return{x:t.pageX,y:t.pageY};var e=dhx.env.isIE&&"BackCompat"!=document.compatMode?document.documentElement:document.body;return{x:t.clientX+e.scrollLeft-e.clientLeft,y:t.clientY+e.scrollTop-e.clientTop}},preventEvent:function(t){return t&&t.preventDefault&&t.preventDefault(),dhx.html.stopEvent(t)},stopEvent:function(t){return(t||event).cancelBubble=!0,!1},addCss:function(t,e){t.className+=" "+e},removeCss:function(t,e){t.className=t.className.replace(RegExp(" "+e,"g"),"")}},dhx.ready=function(t){this._ready?t.call():this._ready_code.push(t)},dhx._ready_code=[],temp=document.getElementsByTagName("SCRIPT"),dhx.assert(temp.length,"Can't locate codebase"),temp.length&&((temp=(temp[temp.length-1].getAttribute("src")||"").split("/")).splice(temp.length-1,1),dhx.codebase=temp.slice(0,temp.length).join("/")+"/"),dhx.event(window,"load",function(){dhx4.callEvent("onReady",[]),dhx.delay(function(){dhx._ready=!0;for(var t=0;t<dhx._ready_code.length;t++)dhx._ready_code[t].call();dhx._ready_code=[]})}),dhx.locale=dhx.locale||{},dhx.assert_core_ready(),dhx.ready(function(){dhx.event(document.body,"click",function(t){dhx4.callEvent("onClick",[t||event])})}),_cache={},newlines=new RegExp("(\\r\\n|\\n)","g"),quotes=new RegExp('(\\")',"g"),dhx.Template=function(t){if("function"==typeof t)return t;if(_cache[t])return _cache[t];if(-1!=(t=(t||"").toString()).indexOf("->"))switch((t=t.split("->"))[0]){case"html":t=dhx.html.getValue(t[1])}t=(t=(t=(t=(t=(t=(t=(t=(t=(t||"").toString()).replace(newlines,"\\n")).replace(quotes,'\\"')).replace(/\{obj\.([^}?]+)\?([^:]*):([^}]*)\}/g,'"+(obj.$1?"$2":"$3")+"')).replace(/\{common\.([^}\(]*)\}/g,"\"+(common.$1||'')+\"")).replace(/\{common\.([^\}\(]*)\(\)\}/g,'"+(common.$1?common.$1.apply(this, arguments):"")+"')).replace(/\{obj\.([^}]*)\}/g,'"+(obj.$1)+"')).replace("{obj}",'"+obj+"')).replace(/#([^#'";, ]+)#/gi,'"+(obj.$1)+"');try{_cache[t]=Function("obj","common",'return "'+t+'";')}catch(e){dhx.assert_error("Invalid template:"+t)}return _cache[t]},dhx.Template.empty=function(){return""},dhx.Template.bind=function(t){return dhx.bind(dhx.Template(t),this)},dhx.Type=function(t,e){if(t._dhx_proto_wait)return t._dhx_type_wait||(t._dhx_type_wait=[]),void t._dhx_type_wait.push(e);"function"==typeof t&&(t=t.prototype),t.types||(t.types={default:t.type},t.type.name="default");var n=e.name,i=t.type;for(var a in n&&(i=t.types[n]=dhx.clone(e.baseType?t.types[e.baseType]:t.type)),e)0===a.indexOf("template")?i[a]=dhx.Template(e[a]):i[a]=e[a];return n},dhx.Settings={$init:function(){this._settings=this.config={}},define:function(t,e){return"object"==typeof t?this._parseSeetingColl(t):this._define(t,e)},_define:function(t,e){var n=this[t+"_setter"];return this._settings[t]=n?n.call(this,e,t):e},_parseSeetingColl:function(t){if(t)for(var e in t)this._define(e,t[e])},_parseSettings:function(t,e){var n={};e&&(n=dhx.extend(n,e)),"object"!=typeof t||t.tagName||dhx.extend(n,t,!0),this._parseSeetingColl(n)},_mergeSettings:function(t,e){for(var n in e)switch(typeof t[n]){case"object":t[n]=this._mergeSettings(t[n]||{},e[n]);break;case"undefined":t[n]=e[n]}return t},debug_freid_c_id:!0,debug_freid_a_name:!0},dhx.ajax=function(t,e,n){if(0!==arguments.length){var i=new dhx.ajax;return n&&(i.master=n),i.get(t,null,e)}return this.getXHR?this:new dhx.ajax},dhx.ajax.count=0,dhx.ajax.prototype={master:null,getXHR:function(){return dhx.env.isIE?new ActiveXObject("Microsoft.xmlHTTP"):new XMLHttpRequest},send:function(t,e,n){var i=this.getXHR();if(dhx.isArray(n)||(n=[n]),"object"==typeof e){var a=[];for(var o in e){var r=e[o];null!==r&&r!==dhx.undefined||(r=""),a.push(o+"="+encodeURIComponent(r))}e=a.join("&")}e&&"GET"===this.request&&(t=t+(-1!=t.indexOf("?")?"&":"?")+e,e=null),i.open(this.request,t,!this._sync),"POST"===this.request&&i.setRequestHeader("Content-type","application/x-www-form-urlencoded");var s=this;return i.onreadystatechange=function(){if(!i.readyState||4==i.readyState){if(dhx.debug_time&&dhx.log_full_time("data_loading"),dhx.ajax.count++,n&&s)for(var t=0;t<n.length;t++)if(n[t]){var e=n[t].success||n[t];(i.status>=400||!i.status&&!i.responseText)&&(e=n[t].error),e&&e.call(s.master||s,i.responseText,i.responseXML,i)}s&&(s.master=null),n=s=null}},i.send(e||null),i},get:function(t,e,n){return 2==arguments.length&&(n=e,e=null),this.request="GET",this.send(t,e,n)},post:function(t,e,n){return this.request="POST",this.send(t,e,n)},put:function(t,e,n){return this.request="PUT",this.send(t,e,n)},del:function(t,e,n){return this.request="DELETE",this.send(t,e,n)},sync:function(){return this._sync=!0,this},bind:function(t){return this.master=t,this}},dhx.send=function(t,e,n,i){var a=dhx.html.create("FORM",{target:i||"_self",action:t,method:n||"POST"},"");for(var o in e){var r=dhx.html.create("INPUT",{type:"hidden",name:o,value:e[o]},"");a.appendChild(r)}a.style.display="none",document.body.appendChild(a),a.submit(),document.body.removeChild(a)},dhx.AtomDataLoader={$init:function(t){this.data={},t&&(this._settings.datatype=t.datatype||"json",this.$ready.push(this._load_when_ready))},_load_when_ready:function(){this._ready_for_data=!0,this._settings.url&&this.url_setter(this._settings.url),this._settings.data&&this.data_setter(this._settings.data)},url_setter:function(t){return this._ready_for_data?(this.load(t,this._settings.datatype),t):t},data_setter:function(t){return this._ready_for_data?(this.parse(t,this._settings.datatype),!0):t},debug_freid_c_datatype:!0,debug_freid_c_dataFeed:!0,load:function(t,e){if(!t.$proxy){this.callEvent("onXLS",[]),"string"==typeof e?(this.data.driver=dhx.DataDriver[e],e=arguments[2]):this.data.driver||(this.data.driver=dhx.DataDriver.json);var n=[{success:this._onLoad,error:this._onLoadError}];return e&&(dhx.isArray(e)?n.push.apply(n,e):n.push(e)),dhx.ajax(t,n,this)}t.load(this,"string"==typeof e?e:"json")},parse:function(t,e){this.callEvent("onXLS",[]),this.data.driver=dhx.DataDriver[e||"json"],this._onLoad(t,null)},_onLoad:function(t,e,n,i){var a=this.data.driver,o=a.toObject(t,e);if(o){var r=a.getRecords(o)[0];this.data=a?a.getDetails(r):t}else this._onLoadError(t,e,n);this.callEvent("onXLE",[])},_onLoadError:function(t,e,n){this.callEvent("onXLE",[]),this.callEvent("onLoadError",arguments),dhx4.callEvent("onLoadError",[t,e,n,this])},_check_data_feed:function(t){if(!this._settings.dataFeed||this._ignore_feed||!t)return!0;var e=this._settings.dataFeed;return"function"==typeof e?e.call(this,t.id||t,t):(e=e+(-1==e.indexOf("?")?"?":"&")+"action=get&id="+encodeURIComponent(t.id||t),this.callEvent("onXLS",[]),dhx.ajax(e,function(t,e,n){this._ignore_feed=!0;var i=dhx.DataDriver.toObject(t,e);i?this.setValues(i.getDetails(i.getRecords()[0])):this._onLoadError(t,e,n),this._ignore_feed=!1,this.callEvent("onXLE",[])},this),!1)}},dhx.DataDriver={},dhx.DataDriver.json={toObject:function(data){if(data||(data="[]"),"string"==typeof data){try{eval("dhx.temp="+data)}catch(t){return dhx.assert_error(t),null}data=dhx.temp}if(data.data){var t=data.data.config={};for(var key in data)"data"!=key&&(t[key]=data[key]);data=data.data}return data},getRecords:function(t){return t&&!dhx.isArray(t)?[t]:t},getDetails:function(t){return"string"==typeof t?{id:dhx.uid(),value:t}:t},getInfo:function(t){var e=t.config;return e?{_size:e.total_count||0,_from:e.pos||0,_parent:e.parent||0,_config:e.config,_key:e.dhx_security}:{}},child:"data"},dhx.DataDriver.html={toObject:function(t){if("string"==typeof t){var e=null;return-1==t.indexOf("<")&&(e=dhx.toNode(t)),e||((e=document.createElement("DIV")).innerHTML=t),e.getElementsByTagName(this.tag)}return t},getRecords:function(t){for(var e=[],n=0;n<t.childNodes.length;n++){var i=t.childNodes[n];1==i.nodeType&&e.push(i)}return e},getDetails:function(t){return dhx.DataDriver.xml.tagToObject(t)},getInfo:function(t){return{_size:0,_from:0}},tag:"LI"},dhx.DataDriver.jsarray={toObject:function(data){return"string"==typeof data?(eval("dhx.temp="+data),dhx.temp):data},getRecords:function(t){return t},getDetails:function(t){for(var e={},n=0;n<t.length;n++)e["data"+n]=t[n];return e},getInfo:function(t){return{_size:0,_from:0}}},dhx.DataDriver.csv={toObject:function(t){return t},getRecords:function(t){return t.split(this.row)},getDetails:function(t){t=this.stringToArray(t);for(var e={},n=0;n<t.length;n++)e["data"+n]=t[n];return e},getInfo:function(t){return{_size:0,_from:0}},stringToArray:function(t){t=t.split(this.cell);for(var e=0;e<t.length;e++)t[e]=t[e].replace(/^[ \t\n\r]*(\"|)/g,"").replace(/(\"|)[ \t\n\r]*$/g,"");return t},row:"\n",cell:","},dhx.DataDriver.xml={_isValidXML:function(t){return t&&t.documentElement?t.getElementsByTagName("parsererror").length?null:t:null},toObject:function(t,e){if(this._isValidXML(n))return n;if("string"==typeof t)var n=this.fromString(t.replace(/^[\s]+/,""));else n=t;return this._isValidXML(n)?n:null},getRecords:function(t){return this.xpath(t,this.records)},records:"/*/item",child:"item",config:"/*/config",getDetails:function(t){return this.tagToObject(t,{})},getInfo:function(t){var e=this.xpath(t,this.config);return e=e.length?this.assignTypes(this.tagToObject(e[0],{})):null,{_size:t.documentElement.getAttribute("total_count")||0,_from:t.documentElement.getAttribute("pos")||0,_parent:t.documentElement.getAttribute("parent")||0,_config:e,_key:t.documentElement.getAttribute("dhx_security")||null}},xpath:function(t,e){if(window.XPathResult){var n=t;-1==t.nodeName.indexOf("document")&&(t=t.ownerDocument);for(var i=[],a=t.evaluate(e,n,null,XPathResult.ANY_TYPE,null),o=a.iterateNext();o;)i.push(o),o=a.iterateNext();return i}var r=!0;try{void 0===t.selectNodes&&(r=!1)}catch(t){}if(r)return t.selectNodes(e);var s=e.split("/").pop();return t.getElementsByTagName(s)},assignTypes:function(t){for(var e in t){var n=t[e];if("object"==typeof n)this.assignTypes(n);else if("string"==typeof n){if(""===n)continue;"true"==n?t[e]=!0:"false"==n?t[e]=!1:n==1*n&&(t[e]=1*t[e])}}return t},tagToObject:function(t,e){e=e||{};var n=!1,i=t.attributes;if(i&&i.length){for(var a=0;a<i.length;a++)e[i[a].name]=i[a].value;n=!0}var o=t.childNodes;for(a=0;a<o.length;a++)if(1==o[a].nodeType){var r=o[a].tagName;void 0!==e[r]?(dhx.isArray(e[r])||(e[r]=[e[r]]),e[r].push(this.tagToObject(o[a],{}))):e[o[a].tagName]=this.tagToObject(o[a],{}),n=!0}return n?(e.value=e.value||this.nodeValue(t),e):this.nodeValue(t)},nodeValue:function(t){return t.firstChild?t.firstChild.data:""},fromString:function(t){try{if(window.DOMParser)return(new DOMParser).parseFromString(t,"text/xml");if(window.ActiveXObject){var e=new ActiveXObject("Microsoft.xmlDOM");return e.loadXML(t),e}}catch(t){return dhx.assert_error(t),null}dhx.assert_error("Load from xml string is not supported")}},dhx.DataLoader=dhx.proto({$init:function(t){t=t||"",this._ajax_queue=dhx.toArray(),this.data=new dhx.DataStore,this.data.attachEvent("onClearAll",dhx.bind(this._call_onclearall,this)),this.data.attachEvent("onServerConfig",dhx.bind(this._call_on_config,this)),this.data.feed=this._feed},_feed:function(t,e,n){if(this._load_count)return this._load_count=[t,e,n];this._load_count=!0,this._feed_last=[t,e],this._feed_common.call(this,t,e,n)},_feed_common:function(t,e,n){var i=this.data.url;t<0&&(t=0),this.load(i+(-1==i.indexOf("?")?"?":"&")+(this.dataCount()?"continue=true&":"")+"start="+t+"&count="+e,[this._feed_callback,n])},_feed_callback:function(){var t=this._load_count,e=this._feed_last;this._load_count=!1,"object"!=typeof t||t[0]==e[0]&&t[1]==e[1]||this.data.feed.apply(this,t)},load:function(t,e){var n=dhx.AtomDataLoader.load.apply(this,arguments);this._ajax_queue.push(n),this.data.url||(this.data.url=t)},loadNext:function(t,e,n,i,a){if(this._settings.datathrottle&&!a)return this._throttle_request&&window.clearTimeout(this._throttle_request),void(this._throttle_request=dhx.delay(function(){this.loadNext(t,e,n,i,!0)},this,0,this._settings.datathrottle));e||0===e||(e=this.dataCount()),this.data.url=this.data.url||i,this.callEvent("onDataRequest",[e,t,n,i])&&this.data.url&&this.data.feed.call(this,e,t,n)},_maybe_loading_already:function(t,e){var n=this._feed_last;return!!(this._load_count&&n&&n[0]<=e&&n[1]+n[0]>=t+e)},_onLoad:function(t,e,n){this._ajax_queue.remove(n);var i=this.data.driver.toObject(t,e);if(!i)return this._onLoadError(t,e,n);this.data._parse(i),this._call_onready(),this.callEvent("onXLE",[])},removeMissed_setter:function(t){return this.data._removeMissed=t},scheme_setter:function(t){this.data.scheme(t)},dataFeed_setter:function(t){return this.data.attachEvent("onBeforeFilter",dhx.bind(function(t,e){if(this._settings.dataFeed){var n={};if(!t&&!e)return;if("function"==typeof t){if(!e)return;t(e,n)}else n={text:e};this.clearAll();var i=this._settings.dataFeed,a=[];if("function"==typeof i)return i.call(this,e,n);for(var o in n)a.push("dhx_filter["+o+"]="+encodeURIComponent(n[o]));return this.load(i+(i.indexOf("?")<0?"?":"&")+a.join("&"),this._settings.datatype),!1}},this)),t},debug_freid_c_ready:!0,debug_freid_c_datathrottle:!0,_call_onready:function(){if(this._settings.ready&&!this._ready_was_used){var t=dhx.toFunctor(this._settings.ready);t&&dhx.delay(t,this,arguments),this._ready_was_used=!0}},_call_onclearall:function(){for(var t=0;t<this._ajax_queue.length;t++)this._ajax_queue[t].abort();this._ajax_queue=dhx.toArray()},_call_on_config:function(t){this._parseSeetingColl(t)}},dhx.AtomDataLoader),dhx.DataStore=function(){this.name="DataStore",dhx.extend(this,dhx.EventSystem),this.setDriver("json"),this.pull={},this.order=dhx.toArray(),this._marks={}},dhx.DataStore.prototype={setDriver:function(t){dhx.assert(dhx.DataDriver[t],"incorrect DataDriver"),this.driver=dhx.DataDriver[t]},_parse:function(t,e){this.callEvent("onParse",[this.driver,t]),this._filter_order&&this.filter();var n=this.driver.getInfo(t);n._key&&(dhx.securityKey=n._key),n._config&&this.callEvent("onServerConfig",[n._config]);var i=this.driver.getRecords(t);this._inner_parse(n,i),this._scheme_group&&this._group_processing&&this._group_processing(this._scheme_group),this._scheme_sort&&(this.blockEvent(),this.sort(this._scheme_sort),this.unblockEvent()),this.callEvent("onStoreLoad",[this.driver,t]),this.refresh()},_inner_parse:function(t,e){var n=1*(t._from||0),i=!0,a=!1;if(0===n&&this.order[0]){if(this._removeMissed){a={};for(var o=0;o<this.order.length;o++)a[this.order[o]]=!0}i=!1,n=this.order.length}var r=0;for(o=0;o<e.length;o++){var s=this.driver.getDetails(e[o]),l=this.id(s);this.pull[l]?i&&this.order[r+n]&&r++:(this.order[r+n]=l,r++),this.pull[l]?(dhx.extend(this.pull[l],s,!0),this._scheme_update&&this._scheme_update(this.pull[l]),a&&delete a[l]):(this.pull[l]=s,this._scheme_init&&this._scheme_init(s))}if(a){for(var d in this.blockEvent(),a)this.remove(d);this.unblockEvent()}this.order[t._size-1]||(this.order[t._size-1]=dhx.undefined)},id:function(t){return t.id||(t.id=dhx.uid())},changeId:function(t,e){this.pull[t]&&(this.pull[e]=this.pull[t]),this.pull[e].id=e,this.order[this.order.find(t)]=e,this._filter_order&&(this._filter_order[this._filter_order.find(t)]=e),this._marks[t]&&(this._marks[e]=this._marks[t],delete this._marks[t]),this.callEvent("onIdChange",[t,e]),this._render_change_id&&this._render_change_id(t,e),delete this.pull[t]},item:function(t){return this.pull[t]},update:function(t,e){if(dhx.isUndefined(e)&&(e=this.item(t)),this._scheme_update&&this._scheme_update(e),!1===this.callEvent("onBeforeUpdate",[t,e]))return!1;this.pull[t]=e,this.callEvent("onStoreUpdated",[t,e,"update"])},refresh:function(t){this._skip_refresh||(t?this.callEvent("onStoreUpdated",[t,this.pull[t],"paint"]):this.callEvent("onStoreUpdated",[null,null,null]))},silent:function(t,e){this._skip_refresh=!0,t.call(e||this),this._skip_refresh=!1},getRange:function(t,e){if(t=t?this.indexById(t):this.$min||this.startOffset||0,e?e=this.indexById(e):(e=Math.min(this.$max||this.endOffset||1/0,this.dataCount()-1))<0&&(e=0),t>e){var n=e;e=t,t=n}return this.getIndexRange(t,e)},getIndexRange:function(t,e){e=Math.min(e||1/0,this.dataCount()-1);for(var n=dhx.toArray(),i=t||0;i<=e;i++)n.push(this.item(this.order[i]));return n},dataCount:function(){return this.order.length},exists:function(t){return!!this.pull[t]},move:function(t,e){dhx.assert(t>=0&&e>=0,"DataStore::move","Incorrect indexes");var n=this.idByIndex(t),i=this.item(n);this.order.removeAt(t),this.order.insertAt(n,Math.min(this.order.length,e)),this.callEvent("onStoreUpdated",[n,i,"move"])},scheme:function(t){for(var e in this._scheme={},this._scheme_init=t.$init,this._scheme_update=t.$update,this._scheme_serialize=t.$serialize,this._scheme_group=t.$group,this._scheme_sort=t.$sort,t)"$"!=e.substr(0,1)&&(this._scheme[e]=t[e])},sync:function(t,e,n){"string"==typeof t&&(t=$$("source")),"function"!=typeof e&&(n=e,e=null),dhx.debug_bind&&(this.debug_sync_master=t,dhx.log("[sync] "+this.debug_bind_master.name+"@"+this.debug_bind_master._settings.id+" <= "+this.debug_sync_master.name+"@"+this.debug_sync_master._settings.id)),this._backbone_source=!1,"DataStore"!=t.name&&(t.data&&"DataStore"==t.data.name?t=t.data:this._backbone_source=!0);var i=dhx.bind(function(i,a,o){if(this._backbone_source){if(!i)return;if(0===i.indexOf("change"))return"change"==i?(this.pull[a.id]=a.attributes,void this.refresh(a.id)):void 0;"reset"==i&&(o=a),this.order=[],this.pull={},this._filter_order=null;for(var r=0;r<o.models.length;r++){var s=o.models[r].id;this.order.push(s),this.pull[s]=o.models[r].attributes}}else this._filter_order=null,this.order=dhx.toArray([].concat(t.order)),this.pull=t.pull;e&&this.silent(e),this._on_sync&&this._on_sync(),dhx.debug_bind&&dhx.log("[sync:request] "+this.debug_sync_master.name+"@"+this.debug_sync_master._settings.id+" <= "+this.debug_bind_master.name+"@"+this.debug_bind_master._settings.id),this.callEvent("onSyncApply",[]),n?n=!1:this.refresh()},this);this._backbone_source?t.bind("all",i):this._sync_events=[t.attachEvent("onStoreUpdated",i),t.attachEvent("onIdChange",dhx.bind(function(t,e){this.changeId(t,e)},this))],i()},add:function(t,e){if(this._scheme)for(var n in this._scheme)dhx.isUndefined(t[n])&&(t[n]=this._scheme[n]);this._scheme_init&&this._scheme_init(t);var i=this.id(t),a=arguments[2]||this.order,o=a.length;if((dhx.isUndefined(e)||e<0)&&(e=o),e>o&&(dhx.log("Warning","DataStore:add","Index of out of bounds"),e=Math.min(a.length,e)),!1===this.callEvent("onBeforeAdd",[i,t,e]))return!1;if(dhx.assert(!this.exists(i),"Not unique ID"),this.pull[i]=t,a.insertAt(i,e),this._filter_order){var r=this._filter_order.length;!e&&this.order.length&&(r=0),this._filter_order.insertAt(i,r)}return this.callEvent("onAfterAdd",[i,e]),this.callEvent("onStoreUpdated",[i,t,"add"]),i},remove:function(t){if(dhx.isArray(t))for(var e=0;e<t.length;e++)this.remove(t[e]);else{if(!1===this.callEvent("onBeforeDelete",[t]))return!1;dhx.assert(this.exists(t),"Not existing ID in remove command"+t);var n=this.item(t);this.order.remove(t),this._filter_order&&this._filter_order.remove(t),delete this.pull[t],this._marks[t]&&delete this._marks[t],this.callEvent("onAfterDelete",[t]),this.callEvent("onStoreUpdated",[t,n,"delete"])}},clearAll:function(){this.pull={},this.order=dhx.toArray(),this._filter_order=this.url=null,this.callEvent("onClearAll",[]),this.refresh()},idByIndex:function(t){return(t>=this.order.length||t<0)&&dhx.log("Warning","DataStore::idByIndex Incorrect index"),this.order[t]},indexById:function(t){var e=this.order.find(t);return this.pull[t]||dhx.log("Warning","DataStore::indexById Non-existing ID: "+t),e},next:function(t,e){return this.order[this.indexById(t)+(e||1)]},first:function(){return this.order[0]},last:function(){return this.order[this.order.length-1]},previous:function(t,e){return this.order[this.indexById(t)-(e||1)]},sort:function(t,e,n){var i=t;"function"==typeof t?i={as:t,dir:e}:"string"==typeof t&&(i={by:t.replace(/#/g,""),dir:e,as:n});var a=[i.by,i.dir,i.as];this.callEvent("onBeforeSort",a)&&(this._sort_core(i),this.refresh(),this.callEvent("onAfterSort",a))},_sort_core:function(t){if(this.order.length){var e=this._sort._create(t),n=this.getRange(this.first(),this.last());n.sort(e),this.order=n.map(function(t){return dhx.assert(t,"Client sorting can't be used with dynamic loading"),this.id(t)},this)}},_filter_reset:function(t){this._filter_order&&!t&&(this.order=this._filter_order,delete this._filter_order)},_filter_core:function(t,e,n){for(var i=dhx.toArray(),a=0;a<this.order.length;a++){var o=this.order[a];t(this.item(o),e)&&i.push(o)}n&&this._filter_order||(this._filter_order=this.order),this.order=i},filter:function(t,e,n){if(this.callEvent("onBeforeFilter",[t,e])&&(this._filter_reset(n),this.order.length)){if(t){var i=t;e=e||"","string"==typeof t&&(t=t.replace(/#/g,""),"function"==typeof e?i=function(n){return e(n[t])}:(e=e.toString().toLowerCase(),i=function(e,n){return dhx.assert(e,"Client side filtering can't be used with dynamic loading"),-1!=(e[t]||"").toString().toLowerCase().indexOf(n)})),this._filter_core(i,e,n,this._filterMode)}this.refresh(),this.callEvent("onAfterFilter",[])}},each:function(t,e){for(var n=0;n<this.order.length;n++)t.call(e||this,this.item(this.order[n]))},_methodPush:function(t,e){return function(){return t[e].apply(t,arguments)}},addMark:function(t,e,n,i){var a=this._marks[t]||{};return this._marks[t]=a,a[e]||(a[e]=i||!0,n&&(this.item(t).$css=(this.item(t).$css||"")+" "+e,this.refresh(t))),a[e]},removeMark:function(t,e,n){var i=this._marks[t];if(i&&i[e]&&delete i[e],n){var a=this.item(t).$css;a&&(this.item(t).$css=a.replace(e,""),this.refresh(t))}},hasMark:function(t,e){var n=this._marks[t];return n&&n[e]},provideApi:function(t,e){this.debug_bind_master=t,e&&this.mapEvent({onbeforesort:t,onaftersort:t,onbeforeadd:t,onafteradd:t,onbeforedelete:t,onafterdelete:t,onbeforeupdate:t});for(var n=["sort","add","remove","exists","idByIndex","indexById","item","update","refresh","dataCount","filter","next","previous","clearAll","first","last","serialize","sync","addMark","removeMark","hasMark"],i=0;i<n.length;i++)t[n[i]]=this._methodPush(this,n[i])},serialize:function(){for(var t=this.order,e=[],n=0;n<t.length;n++){var i=this.pull[t[n]];this._scheme_serialize&&!1===(i=this._scheme_serialize(i))||e.push(i)}return e},_sort:{_create:function(t){return this._dir(t.dir,this._by(t.by,t.as))},_as:{date:function(t,e){return(t-=0)>(e-=0)?1:t<e?-1:0},int:function(t,e){return(t*=1)>(e*=1)?1:t<e?-1:0},string_strict:function(t,e){return(t=t.toString())>(e=e.toString())?1:t<e?-1:0},string:function(t,e){return e?t?(t=t.toString().toLowerCase())>(e=e.toString().toLowerCase())?1:t<e?-1:0:-1:1}},_by:function(t,e){return t?("function"!=typeof e&&(e=this._as[e||"string"]),dhx.assert(e,"Invalid sorting method"),function(n,i){return e(n[t],i[t])}):e},_dir:function(t,e){return"asc"!=t&&t?function(t,n){return-1*e(t,n)}:e}}},dhx.BaseBind={debug_freid_ignore:{id:!0},bind:function(t,e,n){if("string"==typeof t&&(t=dhx.ui.get(t)),t._initBindSource&&t._initBindSource(),this._initBindSource&&this._initBindSource(),t.getBindData||dhx.extend(t,dhx.BindSource),!this._bind_ready){var i=this.render;if(this.filter){var a=this._settings.id;this.data._on_sync=function(){t._bind_updated[a]=!1}}this.render=function(){if(!this._in_bind_processing){this._in_bind_processing=!0;var t=this.callEvent("onBindRequest");return this._in_bind_processing=!1,i.apply(this,!1===t?arguments:[])}},(this.getValue||this.getValues)&&(this.save=function(){this.validate&&!this.validate()||t.setBindData(this.getValue?this.getValue:this.getValues(),this._settings.id)}),this._bind_ready=!0}t.addBind(this._settings.id,e,n),dhx.debug_bind&&dhx.log("[bind] "+this.name+"@"+this._settings.id+" <= "+t.name+"@"+t._settings.id);var o=this._settings.id;this.attachEvent(this.touchable?"onAfterRender":"onBindRequest",function(){return t.getBindData(o)}),!this._settings.dataFeed&&this.loadNext&&this.data.attachEvent("onStoreLoad",function(){t._bind_updated[o]=!1}),this.isVisible(this._settings.id)&&this.refresh()},unbind:function(t){return this._unbind(t)},_unbind:function(t){t.removeBind(this._settings.id);var e=this._sync_events||(this.data?this.data._sync_events:0);if(e&&t.data)for(var n=0;n<e.length;n++)t.data.detachEvent(e[n])}},dhx.BindSource={$init:function(){this._bind_hash={},this._bind_updated={},this._ignore_binds={},this._bind_specific_rules(this)},saveBatch:function(t){this._do_not_update_binds=!0,t.call(this),this._do_not_update_binds=!1,this._update_binds()},setBindData:function(t,e){if(e&&(this._ignore_binds[e]=!0),dhx.debug_bind&&dhx.log("[bind:save] "+this.name+"@"+this._settings.id+" <= @"+e),this.setValue)this.setValue(t);else if(this.setValues)this.setValues(t);else{var n=this.getCursor();n&&(t=dhx.extend(this.item(n),t,!0),this.update(n,t))}this.callEvent("onBindUpdate",[t,e,n]),this.save&&this.save(),e&&(this._ignore_binds[e]=!1)},getBindData:function(t,e){if(this._bind_updated[t])return!1;var n=dhx.ui.get(t);n.isVisible(n._settings.id)&&(this._bind_updated[t]=!0,dhx.debug_bind&&dhx.log("[bind:request] "+this.name+"@"+this._settings.id+" => "+n.name+"@"+n._settings.id),this._bind_update(n,this._bind_hash[t][0],this._bind_hash[t][1]),e&&n.filter&&n.refresh())},addBind:function(t,e,n){this._bind_hash[t]=[e,n]},removeBind:function(t){delete this._bind_hash[t],delete this._bind_updated[t],delete this._ignore_binds[t]},_bind_specific_rules:function(t){t.filter?dhx.extend(this,dhx.CollectionBind):t.setValue?dhx.extend(this,dhx.ValueBind):dhx.extend(this,dhx.RecordBind)},_update_binds:function(){if(!this._do_not_update_binds)for(var t in this._bind_hash)this._ignore_binds[t]||(this._bind_updated[t]=!1,this.getBindData(t,!0))},_bind_update_common:function(t,e,n){t.setValue?t.setValue(n?n[e]:n):t.filter?t.data.silent(function(){this.filter(e,n)}):!n&&t.clear?t.clear():t._check_data_feed(n)&&t.setValues(dhx.clone(n)),t.callEvent("onBindApply",[n,e,this])}},dhx.DataValue=dhx.proto({name:"DataValue",isVisible:function(){return!0},$init:function(t){this.data=t;var e=t&&t.id?t.id:dhx.uid();this._settings={id:e},dhx.ui.views[e]=this},setValue:function(t){this.data=t,this.callEvent("onChange",[t])},getValue:function(){return this.data},refresh:function(){this.callEvent("onBindRequest")}},dhx.EventSystem,dhx.BaseBind),dhx.DataRecord=dhx.proto({name:"DataRecord",isVisible:function(){return!0},$init:function(t){this.data=t||{};var e=t&&t.id?t.id:dhx.uid();this._settings={id:e},dhx.ui.views[e]=this},getValues:function(){return this.data},setValues:function(t){this.data=t,this.callEvent("onChange",[t])},refresh:function(){this.callEvent("onBindRequest")}},dhx.EventSystem,dhx.BaseBind,dhx.AtomDataLoader,dhx.Settings),dhx.DataCollection=dhx.proto({name:"DataCollection",isVisible:function(){return!!(this.data.order.length||this.data._filter_order||this._settings.dataFeed)},$init:function(t){this.data.provideApi(this,!0);var e=t&&t.id?t.id:dhx.uid();this._settings.id=e,dhx.ui.views[e]=this,this.data.attachEvent("onStoreLoad",dhx.bind(function(){this.callEvent("onBindRequest",[])},this))},refresh:function(){this.callEvent("onBindRequest",[])}},dhx.DataLoader,dhx.EventSystem,dhx.BaseBind,dhx.Settings),dhx.ValueBind={$init:function(){this.attachEvent("onChange",this._update_binds)},_bind_update:function(t,e,n){var i=this.getValue()||"";if(n&&(i=n(i)),t.setValue)t.setValue(i);else if(t.filter)t.data.silent(function(){this.filter(e,i)});else{var a={};a[e]=i,t._check_data_feed(i)&&t.setValues(a)}t.callEvent("onBindApply",[i,e,this])}},dhx.RecordBind={$init:function(){this.attachEvent("onChange",this._update_binds)},_bind_update:function(t,e){var n=this.getValues()||null;this._bind_update_common(t,e,n)}},dhx.CollectionBind={$init:function(){this._cursor=null,this.attachEvent("onSelectChange",function(t){var e=this.getSelected();this.setCursor(e?e.id||e:null)}),this.attachEvent("onAfterCursorChange",this._update_binds),this.data.attachEvent("onStoreUpdated",dhx.bind(function(t,e,n){t&&t==this.getCursor()&&"paint"!=n&&this._update_binds()},this)),this.data.attachEvent("onClearAll",dhx.bind(function(){this._cursor=null},this)),this.data.attachEvent("onIdChange",dhx.bind(function(t,e){this._cursor==t&&(this._cursor=e)},this))},setCursor:function(t){t==this._cursor||null!==t&&!this.item(t)||(this.callEvent("onBeforeCursorChange",[this._cursor]),this._cursor=t,this.callEvent("onAfterCursorChange",[t]))},getCursor:function(){return this._cursor},_bind_update:function(t,e){var n=this.item(this.getCursor())||this._settings.defaultData||null;this._bind_update_common(t,e,n)}},dhx.ui||(dhx.ui={}),dhx.ui.views||(dhx.ui.views={},dhx.ui.get=function(t){return t._settings?t:dhx.ui.views[t]}),window.dhtmlx&&(dhtmlx.BaseBind=dhx.BaseBind),dhtmlXDataStore=function(t){var e=new dhx.DataCollection(t);return e._dp_init=function(t){var e="_methods";t[e]=["dummy","dummy","changeId","dummy"],this.data._old_names={add:"inserted",update:"updated",delete:"deleted"},this.data.attachEvent("onStoreUpdated",function(e,n,i){e&&!t._silent&&t.setUpdated(e,!0,this._old_names[i])}),t[e="_getRowData"]=function(t,e){var n=this.obj.data.item(t),i={id:t};if(i[this.action_param]=this.obj.getUserData(t),n)for(var a in n)i[a]=n[a];return i},this.changeId=function(e,n){this.data.changeId(e,n),t._silent=!0,this.data.callEvent("onStoreUpdated",[n,this.item(n),"update"]),t._silent=!1},t[e="_clearUpdateFlag"]=function(){},this._userdata={}},e.dummy=function(){},e.setUserData=function(t,e,n){this._userdata[t]=n},e.getUserData=function(t,e){return this._userdata[t]},e.dataFeed=function(t){this.define("dataFeed",t)},dhx.extend(e,dhx.BindSource),e},window.dhtmlXDataView&&(dhtmlXDataView.prototype._initBindSource=function(){this.isVisible=function(){return!!(this.data.order.length||this.data._filter_order||this._settings.dataFeed)};this._settings=this._settings||this._settings,this._settings.id||(this._settings.id=dhx.uid()),this.unbind=dhx.BaseBind.unbind,this.unsync=dhx.BaseBind.unsync,dhx.ui.views[this._settings.id]=this}),window.dhtmlXChart&&(dhtmlXChart.prototype._initBindSource=function(){this.isVisible=function(){return!!(this.data.order.length||this.data._filtered_state||this._settings.dataFeed)};this._settings=this._settings||this._settings,this._settings.id||(this._settings.id=dhx.uid()),this.unbind=dhx.BaseBind.unbind,this.unsync=dhx.BaseBind.unsync,dhx.ui.views[this._settings.id]=this}),dhx.BaseBind.unsync=function(t){return dhx.BaseBind._unbind.call(this,t)},dhx.BaseBind.unbind=function(t){return dhx.BaseBind._unbind.call(this,t)},dhx.BaseBind.legacyBind=function(){return dhx.BaseBind.bind.apply(this,arguments)},dhx.BaseBind.legacySync=function(t,e){return this._initBindSource&&this._initBindSource(),t._initBindSource&&t._initBindSource(),this.attachEvent("onAfterEditStop",function(t){return this.save(t),!0}),this.attachEvent("onDataRequest",function(e,n){for(var i=e;i<e+n;i++)if(!t.data.order[i])return t.loadNext(n,e),!1}),this.save=function(e){e||(e=this.getCursor());var n=this.item(e),i=t.item(e);for(var a in n)0!==a.indexOf("$")&&(i[a]=n[a]);t.refresh(e)},t&&"DataCollection"==t.name?t.data.sync.apply(this.data,arguments):this.data.sync.apply(this.data,arguments)},window.dhtmlXForm&&(dhtmlXForm.prototype.bind=function(t){dhx.BaseBind.bind.apply(this,arguments),t.getBindData(this._settings.id)},dhtmlXForm.prototype.unbind=function(t){dhx.BaseBind._unbind.call(this,t)},dhtmlXForm.prototype._initBindSource=function(){dhx.isUndefined(this._settings)&&(this._settings={id:dhx.uid(),dataFeed:this._server_feed},dhx.ui.views[this._settings.id]=this)},dhtmlXForm.prototype._check_data_feed=function(t){if(!this._settings.dataFeed||this._ignore_feed||!t)return!0;var e=this._settings.dataFeed;return"function"==typeof e?e.call(this,t.id||t,t):(e=e+(-1==e.indexOf("?")?"?":"&")+"action=get&id="+encodeURIComponent(t.id||t),this.load(e),!1)},dhtmlXForm.prototype.setValues=dhtmlXForm.prototype.setFormData,dhtmlXForm.prototype.getValues=function(){return this.getFormData(!1,!0)},dhtmlXForm.prototype.dataFeed=function(t){this._settings?this._settings.dataFeed=t:this._server_feed=t},dhtmlXForm.prototype.refresh=dhtmlXForm.prototype.isVisible=function(t){return!0}),window.scheduler&&(window.Scheduler||(window.Scheduler={}),Scheduler.$syncFactory=function(t){t.sync=function(e,n){this._initBindSource&&this._initBindSource(),e._initBindSource&&e._initBindSource();var i=function(i){t.clearAll();for(var a=e.data.order,o=e.data.pull,r=[],s=0;s<a.length;s++)n&&n.copy?r[s]=dhx.clone(o[a[s]]):r[s]=o[a[s]];t._process_loading(r),t.callEvent("onSyncApply",[])};this.save=function(t){t||(t=this.getCursor());var n=this.item(t),i=e.item(t);this.callEvent("onStoreSave",[t,n,i])&&(dhx.extend(e.item(t),n,!0),e.update(t))},this.item=function(t){return this.getEvent(t)},this._sync_events=[e.data.attachEvent("onStoreUpdated",function(t,e,n){i.call(this)}),e.data.attachEvent("onIdChange",function(e,n){t.changeEventId(e,n)})],this.attachEvent("onEventChanged",function(t){this.save(t)}),this.attachEvent("onEventAdded",function(t,n){e.data.pull[t]||e.add(n)}),this.attachEvent("onEventDeleted",function(t){e.data.pull[t]&&e.remove(t)}),i()},t.unsync=function(t){dhx.BaseBind._unbind.call(this,t)},t._initBindSource=function(){this._settings||(this._settings={id:dhx.uid()})}},Scheduler.$syncFactory(window.scheduler)),window.dhtmlXCombo&&(dhtmlXCombo.prototype.bind=function(){dhx.BaseBind.bind.apply(this,arguments)},dhtmlXCombo.prototype.unbind=function(t){dhx.BaseBind._unbind.call(this,t)},dhtmlXCombo.prototype.unsync=function(t){dhx.BaseBind._unbind.call(this,t)},dhtmlXCombo.prototype.dataFeed=function(t){this._settings?this._settings.dataFeed=t:this._server_feed=t},dhtmlXCombo.prototype.sync=function(t,e){this._initBindSource&&this._initBindSource(),t._initBindSource&&t._initBindSource();var n=this,i=function(t){n.clearAll(),n.addOption(this.serialize()),n.callEvent("onSyncApply",[])};this._sync_events=[t.data.attachEvent("onStoreUpdated",function(t,e,n){i.call(this)}),t.data.attachEvent("onIdChange",function(t,e){n.changeOptionId(t,e)})],i.call(t)},dhtmlXCombo.prototype._initBindSource=function(){dhx.isUndefined(this._settings)&&(this._settings={id:dhx.uid(),dataFeed:this._server_feed},dhx.ui.views[this._settings.id]=this,this.data={silent:dhx.bind(function(t){t.call(this)},this)},dhx4._eventable(this.data),this.attachEvent("onChange",function(){this.callEvent("onSelectChange",[this.getSelectedValue()])}),this.attachEvent("onXLE",function(){this.callEvent("onBindRequest",[])}))},dhtmlXCombo.prototype.item=function(t){return this.getOption(t)},dhtmlXCombo.prototype.getSelected=function(){return this.getSelectedValue()},dhtmlXCombo.prototype.isVisible=function(){return!(!this.optionsArr.length&&!this._settings.dataFeed)},dhtmlXCombo.prototype.refresh=function(){this.render(!0)}),window.dhtmlXGridObject&&(dhtmlXGridObject.prototype.bind=function(t,e,n){dhx.BaseBind.bind.apply(this,arguments)},dhtmlXGridObject.prototype.unbind=function(t){dhx.BaseBind._unbind.call(this,t)},dhtmlXGridObject.prototype.unsync=function(t){dhx.BaseBind._unbind.call(this,t)},dhtmlXGridObject.prototype.dataFeed=function(t){this._settings?this._settings.dataFeed=t:this._server_feed=t},dhtmlXGridObject.prototype.sync=function(t,e){this._initBindSource&&this._initBindSource(),t._initBindSource&&t._initBindSource();var n=this;e&&e.filter&&(n.attachEvent("onFilterStart",function(e,i){return(!n._con_f_used||!n._con_f_used.length)&&(t.data.silent(function(){t.filter();for(var a=0;a<e.length;a++)if(""!=i[a]){var o=n.getColumnId(e[a]);t.filter("#"+o+"#",i[a],0!=a)}}),t.refresh(),!1)}),n.collectValues=function(e){var n=this.getColumnId(e);return function(t){var e=[],n={};return this.data.each(function(i){var a=i[t];n[a]||(n[a]=!0,e.push(a))}),e.sort(),e}.call(t,n)}),this.save=function(e){e||(e=this.getCursor()),dhx.extend(t.item(e),this.item(e),!0),t.update(e)};var i=function(t){var e=n.getCursor?n.getCursor():null,i=0;n._legacy_ignore_next?(i=n._legacy_ignore_next,n._legacy_ignore_next=!1):n.clearAll();var a=this.dataCount();if(a){n._parsing=!0;for(var o=i;o<a;o++){var r=this.order[o];r&&(i&&n.rowsBuffer[o]||(n.rowsBuffer[o]={idd:r,data:this.pull[r]},n.rowsBuffer[o]._parser=n._process_store_row,n.rowsBuffer[o]._locator=n._get_store_data,n.rowsAr[r]=this.pull[r]))}n.rowsBuffer[a-1]||(n.rowsBuffer[a-1]=dhtmlx.undefined,n.xmlFileUrl=n.xmlFileUrl||this.url),n.pagingOn?n.changePage():n._srnd&&n._fillers?n._update_srnd_view():(n.render_dataset(),n.callEvent("onXLE",[])),n._parsing=!1}e&&n.setCursor&&n.setCursor(n.rowsAr[e]?e:null),n.callEvent("onSyncApply",[])};this._sync_events=[t.data.attachEvent("onStoreUpdated",function(t,e,a){"delete"==a?(n.deleteRow(t),n.data.callEvent("onStoreUpdated",[t,e,a])):"update"==a?(n.callEvent("onSyncUpdate",[e,a]),n.update(t,e),n.data.callEvent("onStoreUpdated",[t,e,a])):"add"==a?(n.callEvent("onSyncUpdate",[e,a]),n.add(t,e,this.indexById(t)),n.data.callEvent("onStoreUpdated",[t,e,a])):i.call(this)}),t.data.attachEvent("onStoreLoad",function(e,i){n.xmlFileUrl=t.data.url,n._legacy_ignore_next=e.getInfo(i)._from}),t.data.attachEvent("onIdChange",function(t,e){n.changeRowId(t,e)})],n.attachEvent("onDynXLS",function(e,a){for(var o=e;o<e+a;o++)if(!t.data.order[o])return t.loadNext(a,e),!1;n._legacy_ignore_next=e,i.call(t.data)}),i.call(t.data),n.attachEvent("onEditCell",function(t,e,n,i,a){return 2==t&&i!=a&&this.save(e),!0}),n.attachEvent("onClearAll",function(){this._f_rowsBuffer=null}),e&&e.sort&&n.attachEvent("onBeforeSorting",function(e,i,a){if("connector"==i)return!1;var o=this.getColumnId(e);return t.sort("#"+o+"#","asc"==a?"asc":"desc","int"==i?i:"string"),n.setSortImgState(!0,e,a),!1}),e&&e.select&&n.attachEvent("onRowSelect",function(e){t.setCursor(e)}),n.clearAndLoad=function(e){t.clearAll(),t.load(e)}},dhtmlXGridObject.prototype._initBindSource=function(){if(dhx.isUndefined(this._settings)){this._settings={id:dhx.uid(),dataFeed:this._server_feed},dhx.ui.views[this._settings.id]=this,this.data={silent:dhx.bind(function(t){t.call(this)},this)},dhx4._eventable(this.data);for(var t=0;t<this._cCount;t++)this.columnIds[t]||(this.columnIds[t]="cell"+t);this.attachEvent("onSelectStateChanged",function(t){this.callEvent("onSelectChange",[t])}),this.attachEvent("onSelectionCleared",function(){this.callEvent("onSelectChange",[null])}),this.attachEvent("onEditCell",function(t,e){return 2===t&&this.getCursor&&e&&e==this.getCursor()&&this._update_binds(),!0}),this.attachEvent("onXLE",function(){this.callEvent("onBindRequest",[])})}},dhtmlXGridObject.prototype.item=function(t){if(null===t)return null;var e=this.getRowById(t);if(!e)return null;var n=dhx.copy(e._attrs);n.id=t;for(var i=this.getColumnsNum(),a=0;a<i;a++)n[this.columnIds[a]]=this.cells(t,a).getValue();return n},dhtmlXGridObject.prototype.update=function(t,e){for(var n=0;n<this.columnIds.length;n++){var i=this.columnIds[n];dhx.isUndefined(e[i])||this.cells(t,n).setValue(e[i])}var a=this.getRowById(t)._attrs;for(var i in e)a[i]=e[i];this.callEvent("onBindUpdate",[e,null,t])},dhtmlXGridObject.prototype.add=function(t,e,n){for(var i=[],a=0;a<this.columnIds.length;a++){var o=this.columnIds[a];i[a]=dhx.isUndefined(e[o])?"":e[o]}this.addRow(t,i,n);this.getRowById(t)._attrs=dhx.copy(e)},dhtmlXGridObject.prototype.getSelected=function(){return this.getSelectedRowId()},dhtmlXGridObject.prototype.isVisible=function(){return!!(this.rowsBuffer.length||this._f_rowsBuffer||this._settings.dataFeed)},dhtmlXGridObject.prototype.refresh=function(){this.render_dataset()},dhtmlXGridObject.prototype.filter=function(t,e){if(this._settings.dataFeed){var n={};if(!t&&!e)return;if("function"==typeof t){if(!e)return;t(e,n)}else dhx.isUndefined(t)?n=e:n[t]=e;this.clearAll();var i=this._settings.dataFeed;if("function"==typeof i)return i.call(this,e,n);var a=[];for(var o in n)a.push("dhx_filter["+o+"]="+encodeURIComponent(n[o]));return this.load(i+(i.indexOf("?")<0?"?":"&")+a.join("&")),!1}if(null===e)return this.filterBy(0,function(){return!1});this.filterBy(0,function(n,i){return t.call(this,i,e)})}),window.dhtmlXTreeObject&&(dhtmlXTreeObject.prototype.bind=function(){dhx.BaseBind.bind.apply(this,arguments)},dhtmlXTreeObject.prototype.unbind=function(t){dhx.BaseBind._unbind.call(this,t)},dhtmlXTreeObject.prototype.dataFeed=function(t){this._settings?this._settings.dataFeed=t:this._server_feed=t},dhtmlXTreeObject.prototype._initBindSource=function(){dhx.isUndefined(this._settings)&&(this._settings={id:dhx.uid(),dataFeed:this._server_feed},dhx.ui.views[this._settings.id]=this,this.data={silent:dhx.bind(function(t){t.call(this)},this)},dhx4._eventable(this.data),this.attachEvent("onSelect",function(t){this.callEvent("onSelectChange",[t])}),this.attachEvent("onEdit",function(t,e){return 2===t&&e&&e==this.getCursor()&&this._update_binds(),!0}))},dhtmlXTreeObject.prototype.item=function(t){return null===t?null:{id:t,text:this.getItemText(t)}},dhtmlXTreeObject.prototype.getSelected=function(){return this.getSelectedItemId()},dhtmlXTreeObject.prototype.isVisible=function(){return!0},dhtmlXTreeObject.prototype.refresh=function(){},dhtmlXTreeObject.prototype.filter=function(t,e){if(this._settings.dataFeed){var n={};if(!t&&!e)return;if("function"==typeof t){if(!e)return;t(e,n)}else dhx.isUndefined(t)?n=e:n[t]=e;this.deleteChildItems(0);var i=this._settings.dataFeed;if("function"==typeof i)return i.call(this,[data.id||data,data]);var a=[];for(var o in n)a.push("dhx_filter["+o+"]="+encodeURIComponent(n[o]));return this.loadXML(i+(i.indexOf("?")<0?"?":"&")+a.join("&")),!1}},dhtmlXTreeObject.prototype.update=function(t,e){dhx.isUndefined(e.text)||this.setItemText(t,e.text)})}(),dataProcessor.prototype={url:function(t){return-1!=t.indexOf("?")?"&":"?"},setTransactionMode:function(t,e){"object"==typeof t?(this._tMode=t.mode||this._tMode,this._headers=this._headers||t.headers,this._payload=this._payload||t.payload):(this._tMode=t,this._tSend=e),"REST"==this._tMode&&(this._tSend=!1,this._endnm=!0),"JSON"==this._tMode&&(this._tSend=!1,this._endnm=!0,this._headers=this._headers||{},this._headers["Content-type"]="application/json")},escape:function(t){return this._utf?encodeURIComponent(t):escape(t)},enableUTFencoding:function(t){this._utf=dhx4.s2b(t)},setDataColumns:function(t){this._columns="string"==typeof t?t.split(","):t},getSyncState:function(){return!this.updatedRows.length},enableDataNames:function(t){this._endnm=dhx4.s2b(t)},enablePartialDataSend:function(t){this._changed=dhx4.s2b(t)},setUpdateMode:function(t,e){this.autoUpdate="cell"==t,this.updateMode=t,this.dnd=e},ignore:function(t,e){this._silent_mode=!0,t.call(e||window),this._silent_mode=!1},setUpdated:function(t,e,n){if(this._log("item "+t+" "+(e?"marked":"unmarked")+" ["+(n||"updated")+"]"),!this._silent_mode){var i=this.findRow(t);n=n||"updated";var a=this.obj.getUserData(t,this.action_param);a&&"updated"==n&&(n=a),e?(this.set_invalid(t,!1),this.updatedRows[i]=t,this.obj.setUserData(t,this.action_param,n),this._in_progress[t]&&(this._in_progress[t]="wait")):this.is_invalid(t)||(this.updatedRows.splice(i,1),this.obj.setUserData(t,this.action_param,"")),e||this._clearUpdateFlag(t),this.markRow(t,e,n),e&&this.autoUpdate&&this.sendData(t)}},_clearUpdateFlag:function(t){},markRow:function(t,e,n){var i="",a=this.is_invalid(t);if(a&&(i=this.styles[a],e=!0),this.callEvent("onRowMark",[t,e,n,a])&&(i=this.styles[e?n:"clear"]+i,this.obj[this._methods[0]](t,i),a&&a.details)){i+=this.styles[a+"_cell"];for(var o=0;o<a.details.length;o++)a.details[o]&&this.obj[this._methods[1]](t,o,i)}},getState:function(t){return this.obj.getUserData(t,this.action_param)},is_invalid:function(t){return this._invalid[t]},set_invalid:function(t,e,n){n&&(e={value:e,details:n,toString:function(){return this.value.toString()}}),this._invalid[t]=e},checkBeforeUpdate:function(t){return!0},sendData:function(t){if(t&&this._log("Sending: "+t),!this._waitMode||"tree"!=this.obj.mytype&&!this.obj._h2){if(this.obj.editStop&&this.obj.editStop(),void 0===t||this._tSend)return this.sendAllData();if(this._in_progress[t])return!1;if(this.messages=[],"deleted"!==this.getState(t)&&!this.checkBeforeUpdate(t)&&this.callEvent("onValidationError",[t,this.messages]))return!1;this._beforeSendData(this._getRowData(t),t)}},_beforeSendData:function(t,e){if(!this.callEvent("onBeforeUpdate",[e,this.getState(e),t]))return!1;this._sendData(t,e)},serialize:function(t,e){if("string"==typeof t)return t;if(void 0!==e)return this.serialize_one(t,"");var n=[],i=[];for(var a in t)t.hasOwnProperty(a)&&(n.push(this.serialize_one(t[a],a+this.post_delim)),i.push(a));return n.push("ids="+this.escape(i.join(","))),window.dhtmlx&&dhtmlx.security_key&&n.push("dhx_security="+dhtmlx.security_key),n.join("&")},serialize_one:function(t,e){if("string"==typeof t)return t;var n=[];for(var i in t)if(t.hasOwnProperty(i)){if(("id"==i||i==this.action_param)&&"REST"==this._tMode)continue;n.push(this.escape((e||"")+i)+"="+this.escape(t[i]))}return n.join("&")},_applyPayload:function(t){if(this._payload)for(var e in this._payload)t=t+(-1===t.indexOf("?")?"?":"&")+this.escape(e)+"="+this.escape(this._payload[e]);return t},_sendData:function(t,e){if(this._log("url: "+this.serverProcessor),this._log(t),t){if(!this.callEvent("onBeforeDataSending",e?[e,this.getState(e),t]:[null,null,t]))return!1;e&&(this._in_progress[e]=(new Date).valueOf());var n=this,i=function(i){var a=[];if(e)a.push(e);else if(t)for(var o in t)a.push(o);return n.afterUpdate(n,i,a)},a=this.serverProcessor+(this._user?this.url(this.serverProcessor)+["dhx_user="+this._user,"dhx_version="+this.obj.getUserData(0,"version")].join("&"):""),o=this._applyPayload(a);if("GET"==this._tMode)dhx4.ajax.query({url:o+(-1!=o.indexOf("?")?"&":"?")+this.serialize(t,e),method:"GET",headers:this._headers,callback:i});else if("POST"==this._tMode)dhx4.ajax.query({url:o,method:"POST",headers:this._headers,callback:i,data:this.serialize(t,e)});else if("JSON"==this._tMode){var r=t[this.action_param],s={};for(var l in t)s[l]=t[l];delete s[this.action_param],delete s.id,delete s.gr_id,dhx4.ajax.query({url:o,method:"POST",headers:this._headers,callback:i,data:JSON.stringify({id:e,action:r,data:s})})}else if("REST"==this._tMode){var d=this.getState(e),c=a.replace(/(\&|\?)editing\=true/,""),h=c.split("?");h[1]&&(h[1]="?"+h[1]);s="";var u="post";"inserted"==d?s=this.serialize(t,e):"deleted"==d?(u="DELETE",c=h[0]+e+(h[1]||"")):(u="PUT",s=this.serialize(t,e),c=h[0]+e+(h[1]||"")),this._applyPayload(c),dhx4.ajax.query({url:c,method:u,headers:this._headers,data:s,callback:i})}this._waitMode++}},sendAllData:function(){if(this._log("Sending all updated items"),this.updatedRows.length){this.messages=[];for(var t=!0,e=0;e<this.updatedRows.length;e++)"deleted"!==this.getState(this.updatedRows[e])&&(t&=this.checkBeforeUpdate(this.updatedRows[e]));if(!t&&!this.callEvent("onValidationError",["",this.messages]))return!1;if(this._tSend)this._sendData(this._getAllData());else for(e=0;e<this.updatedRows.length;e++)if(!this._in_progress[this.updatedRows[e]]){if(this.is_invalid(this.updatedRows[e]))continue;if(this._beforeSendData(this._getRowData(this.updatedRows[e]),this.updatedRows[e]),this._waitMode&&("tree"==this.obj.mytype||this.obj._h2))return}}},_getAllData:function(t){for(var e={},n=!1,i=0;i<this.updatedRows.length;i++){var a=this.updatedRows[i];this._in_progress[a]||this.is_invalid(a)||this.callEvent("onBeforeUpdate",[a,this.getState(a),this._getRowData(a)])&&(e[a]=this._getRowData(a,a+this.post_delim),n=!0,this._in_progress[a]=(new Date).valueOf())}return n?e:null},setVerificator:function(t,e){this.mandatoryFields[t]=e||function(t){return""!==t}},clearVerificator:function(t){this.mandatoryFields[t]=!1},findRow:function(t){var e=0;for(e=0;e<this.updatedRows.length&&t!=this.updatedRows[e];e++);return e},defineAction:function(t,e){this._uActions||(this._uActions=[]),this._uActions[t]=e},afterUpdateCallback:function(t,e,n,i){this._log("Action: "+n+" SID:"+t+" TID:"+e,i);var a=t,o="error"!=n&&"invalid"!=n;if(o||this.set_invalid(t,n),this._uActions&&this._uActions[n]&&!this._uActions[n](i))return delete this._in_progress[a];"wait"!=this._in_progress[a]&&this.setUpdated(t,!1);var r=t;switch(n){case"inserted":case"insert":e!=t&&(this.obj[this._methods[2]](t,e),t=e);break;case"delete":case"deleted":return this.obj.setUserData(t,this.action_param,"true_deleted"),this.obj[this._methods[3]](t),delete this._in_progress[a],this.callEvent("onAfterUpdate",[t,n,e,i])}"wait"!=this._in_progress[a]?(o&&this.obj.setUserData(t,this.action_param,""),delete this._in_progress[a]):(delete this._in_progress[a],this.setUpdated(e,!0,this.obj.getUserData(t,this.action_param))),this.callEvent("onAfterUpdate",[r,n,e,i])},enableDebug:function(){this._debug=!0},_log:function(){this._debug&&window.console&&window.console.info&&window.console.info.apply(window.console,arguments)},afterUpdate:function(t,e,n){if(this._log("Server response received"),window.JSON)try{var i=JSON.parse(e.xmlDoc.responseText),a=i.action||this.getState(n)||"updated",o=i.sid||n[0],r=i.tid||n[0];return t.afterUpdateCallback(o,r,a,i),void t.finalizeUpdate()}catch(t){}var s=dhx4.ajax.xmltop("data",e.xmlDoc);if(!s||"DIV"==s.tagName)return this.cleanUpdate(n);var l=dhx4.ajax.xpath("//data/action",s);if(!l.length)return this.cleanUpdate(n);for(var d=0;d<l.length;d++){var c=l[d];a=c.getAttribute("type"),o=c.getAttribute("sid"),r=c.getAttribute("tid");t.afterUpdateCallback(o,r,a,c)}t.finalizeUpdate()},cleanUpdate:function(t){if(t)for(var e=0;e<t.length;e++)delete this._in_progress[t[e]]},finalizeUpdate:function(){this._waitMode&&this._waitMode--,("tree"==this.obj.mytype||this.obj._h2)&&this.updatedRows.length&&this.sendData(),this.callEvent("onAfterUpdateFinish",[]),this.updatedRows.length||this.callEvent("onFullSync",[])},init:function(t){this.obj=t,t._dp_init&&t._dp_init(this),this.connector_init&&(t._dataprocessor=this)},setOnAfterUpdate:function(t){this.attachEvent("onAfterUpdate",t)},setOnBeforeUpdateHandler:function(t){this.attachEvent("onBeforeDataSending",t)},setAutoUpdate:function(t,e){t=t||2e3,this._user=e||(new Date).valueOf(),this._need_update=!1,this._update_busy=!1,this.attachEvent("onAfterUpdate",function(t,e,n,i){this.afterAutoUpdate(t,e,n,i)}),this.attachEvent("onFullSync",function(){this.fullSync()});var n=this;window.setInterval(function(){n.loadUpdate()},t)},afterAutoUpdate:function(t,e,n,i){return"collision"!=e||(this._need_update=!0,!1)},fullSync:function(){return 1==this._need_update&&(this._need_update=!1,this.loadUpdate()),!0},getUpdates:function(t,e){if(this._update_busy)return!1;this._update_busy=!0,dhx4.ajax.get(t,e)},_v:function(t){return t.firstChild?t.firstChild.nodeValue:""},_a:function(t){for(var e=[],n=0;n<t.length;n++)e[n]=this._v(t[n]);return e},loadUpdate:function(){var t=this,e=this.obj.getUserData(0,"version"),n=this.serverProcessor+this.url(this.serverProcessor)+["dhx_user="+this._user,"dhx_version="+e].join("&");n=n.replace("editing=true&",""),this.getUpdates(n,function(e){var n=dhx4.ajax.xmltop("updates",e.xmlDoc),i=dhx4.ajax.xpath("//userdata",n);t.obj.setUserData(0,"version",t._v(i[0]));var a=dhx4.ajax.xpath("//update",n);if(a.length){t._silent_mode=!0;for(var o=0;o<a.length;o++){var r=a[o].getAttribute("status"),s=a[o].getAttribute("id"),l=a[o].getAttribute("parent");switch(r){case"inserted":t.callEvent("insertCallback",[a[o],s,l]);break;case"updated":t.callEvent("updateCallback",[a[o],s,l]);break;case"deleted":t.callEvent("deleteCallback",[a[o],s,l])}}t._silent_mode=!1}t._update_busy=!1,t=null})}},window.dataProcessor&&!dataProcessor.prototype.init_original&&(dataProcessor.prototype.connector_init=!0)},y8Jd:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"\n.new-information {\n  border: 2px solid #00751b66 !important;\n  background-color: #00751b1a !important;\n}\n.new-information:focus {\n  color: #495057;\n  background-color: #00751b1a !important;\n  border-color: #00751b66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n}\n.updated-information {\n  border: 2px solid #034aff66 !important;\n  background-color: #074dff1a !important;\n}\n.updated-information:focus {\n  color: #495057;\n  background-color: #074dff1a !important;\n  border-color: #034aff66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n}\n.deleted-information {\n  border: 2px solid #dc354566 !important;\n  background-color: #dc35451a !important;\n}\n.deleted-information:focus {\n  color: #495057;\n  background-color: #dc35451a !important;\n  border-color: #dc354566 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n}\n","",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/assets/css/comparing.css"],names:[],mappings:";AACA;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,0DAA0D;EAC1D,kDAAkD;CACnD;AACD;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,yDAAyD;EACzD,iDAAiD;CAClD;AACD;EACE,uCAAuC;EACvC,uCAAuC;CACxC;AACD;EACE,eAAe;EACf,uCAAuC;EACvC,mCAAmC;EACnC,WAAW;EACX,sDAAsD;EACtD,8CAA8C;CAC/C",file:"comparing.css",sourcesContent:["\n.new-information {\n  border: 2px solid #00751b66 !important;\n  background-color: #00751b1a !important;\n}\n.new-information:focus {\n  color: #495057;\n  background-color: #00751b1a !important;\n  border-color: #00751b66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(128, 154, 101, 0.3);\n}\n.updated-information {\n  border: 2px solid #034aff66 !important;\n  background-color: #074dff1a !important;\n}\n.updated-information:focus {\n  color: #495057;\n  background-color: #074dff1a !important;\n  border-color: #034aff66 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(41, 126, 217, 0.3);\n}\n.deleted-information {\n  border: 2px solid #dc354566 !important;\n  background-color: #dc35451a !important;\n}\n.deleted-information:focus {\n  color: #495057;\n  background-color: #dc35451a !important;\n  border-color: #dc354566 !important;\n  outline: 0;\n  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n  box-shadow: 0 0 0 0.2rem rgba(255, 0, 0, 0.3);\n}\n"],sourceRoot:""}])},yJfC:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("en-in",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY h:mm A",LLLL:"dddd, D MMMM YYYY h:mm A"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},dayOfMonthOrdinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(t){var e=t%10;return t+(1==~~(t%100/10)?"th":1===e?"st":2===e?"nd":3===e?"rd":"th")},week:{dow:0,doy:6}})})(n("PJh5"))},yRTJ:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
t.defineLocale("id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] HH.mm",LLLL:"dddd, D MMMM YYYY [pukul] HH.mm"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(t,e){return 12===t&&(t=0),"pagi"===e?t:"siang"===e?t>=11?t:t+12:"sore"===e||"malam"===e?t+12:void 0},meridiem:function(t,e,n){return t<11?"pagi":t<15?"siang":t<19?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",ss:"%d detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:0,doy:6}})})(n("PJh5"))},yYxz:function(t,e){t.exports={}},yuYM:function(t,e,n){var i=n("yYxz"),a=n("hgbu")("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(i.Array===t||o[a]===t)}},yudz:function(t,e,n){var i=n("Xhns");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("c7b5e41c",i,!0,{})},yyob:function(t,e,n){var i=n("npKs");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("379904be",i,!0,{})},z3Uu:function(t,e,n){var i=n("KbHb");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("77fd7b8c",i,!0,{})},z3hR:function(t,e,n){(function(t){"use strict";
//! moment.js locale configuration
function e(t,e,n,i){var a={m:["eng Minutt","enger Minutt"],h:["eng Stonn","enger Stonn"],d:["een Dag","engem Dag"],M:["ee Mount","engem Mount"],y:["ee Joer","engem Joer"]};return e?a[n][0]:a[n][1]}function n(t){if(t=parseInt(t,10),isNaN(t))return!1;if(t<0)return!0;if(t<10)return 4<=t&&t<=7;if(t<100){var e=t%10;return n(0===e?t/10:e)}if(t<1e4){for(;t>=10;)t/=10;return n(t)}return n(t/=1e3)}t.defineLocale("lb",{months:"Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),monthsParseExact:!0,weekdays:"Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split("_"),weekdaysShort:"So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mé_Dë_Më_Do_Fr_Sa".split("_"),weekdaysParseExact:!0,longDateFormat:{LT:"H:mm [Auer]",LTS:"H:mm:ss [Auer]",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY H:mm [Auer]",LLLL:"dddd, D. MMMM YYYY H:mm [Auer]"},calendar:{sameDay:"[Haut um] LT",sameElse:"L",nextDay:"[Muer um] LT",nextWeek:"dddd [um] LT",lastDay:"[Gëschter um] LT",lastWeek:function(){switch(this.day()){case 2:case 4:return"[Leschten] dddd [um] LT";default:return"[Leschte] dddd [um] LT"}}},relativeTime:{future:function(t){return n(t.substr(0,t.indexOf(" ")))?"a "+t:"an "+t},past:function(t){return n(t.substr(0,t.indexOf(" ")))?"viru "+t:"virun "+t},s:"e puer Sekonnen",ss:"%d Sekonnen",m:e,mm:"%d Minutten",h:e,hh:"%d Stonnen",d:e,dd:"%d Deeg",M:e,MM:"%d Méint",y:e,yy:"%d Joer"},dayOfMonthOrdinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}})})(n("PJh5"))},zPlY:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,"","",{version:3,sources:[],names:[],mappings:"",file:"PfPriorityDates.css",sourceRoot:""}])},zVA3:function(t,e,n){(t.exports=n("FZ+f")(!0)).push([t.i,'\n.master[data-v-3f772e7a] {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n.login[data-v-3f772e7a] {\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n}\n.marginTop[data-v-3f772e7a] {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n.textTitle[data-v-3f772e7a] {\n  margin-top: 10px;\n  font-weight: bold;\n  font-size: 1.5rem !important;\n}\n.btn-close[data-v-3f772e7a] {\n  cursor: pointer;\n  color: black;\n  position: absolute;\n  right: -37px;\n  top: -35px;\n}\n\n/* Modal css */\n.modal-mask[data-v-3f772e7a] {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-transition: opacity .3s ease;\n  transition: opacity .3s ease;\n  bottom: 0;\n  right: 0;\n}\n.modal-container[data-v-3f772e7a] {\n  width: 30%;\n  margin: 0px auto;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  font-family: "Open Sans", sans-serif;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n@media (max-width: 991px) {\n.modal-container[data-v-3f772e7a] {\n    width: 35%;\n}\n}\n@media (max-width: 676px) {\n.modal-container[data-v-3f772e7a] {\n    /* width: 45% */\n    width: 265px;\n}\n}\n.modal-header h3[data-v-3f772e7a] {\n  margin-top: 0;\n  border-bottom: none !important;\n}\n.modal-body[data-v-3f772e7a] {\n  margin: 5px;\n}\n.modal-footer[data-v-3f772e7a] {\n  border-top: none !important;\n}\n.modal-default-button[data-v-3f772e7a] {\n  float: right;\n}\n.modal-enter[data-v-3f772e7a] {\n  opacity: 0;\n}\n.modal-leave-active[data-v-3f772e7a] {\n  opacity: 0;\n}\n',"",{version:3,sources:["/home/jonathanwick/projects/BrevortRiverStudios/vue-core/src/utils/PfPopUp/PfPopUp.css"],names:[],mappings:";AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;CACpB;AACD;EACE,qCAAqC;EACrC,kBAAkB;CACnB;AACD;EACE,iBAAiB;EACjB,oBAAoB;CACrB;AACD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;CAC9B;AACD;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;CACZ;;AAED,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;EACd,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,6BAA6B;EAC7B,UAAU;EACV,SAAS;CACV;AACD;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;EAClD,0CAA0C;EAC1C,iCAAiC;EACjC,yBAAyB;EACzB,qCAAqC;EACrC,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,SAAS;EACT,oCAAoC;EACpC,4BAA4B;CAC7B;AACD;AACA;IACI,WAAW;CACd;CACA;AACD;AACA;IACI,gBAAgB;IAChB,aAAa;CAChB;CACA;AACD;EACE,cAAc;EACd,+BAA+B;CAChC;AACD;EACE,YAAY;CACb;AACD;EACE,4BAA4B;CAC7B;AACD;EACE,aAAa;CACd;AACD;EACE,WAAW;CACZ;AACD;EACE,WAAW;CACZ",file:"PfPopUp.css",sourcesContent:['\n.master[data-v-3f772e7a] {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n.login[data-v-3f772e7a] {\n  font-family: "Open Sans", sans-serif;\n  font-size: medium;\n}\n.marginTop[data-v-3f772e7a] {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n.textTitle[data-v-3f772e7a] {\n  margin-top: 10px;\n  font-weight: bold;\n  font-size: 1.5rem !important;\n}\n.btn-close[data-v-3f772e7a] {\n  cursor: pointer;\n  color: black;\n  position: absolute;\n  right: -37px;\n  top: -35px;\n}\n\n/* Modal css */\n.modal-mask[data-v-3f772e7a] {\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  -webkit-transition: opacity .3s ease;\n  transition: opacity .3s ease;\n  bottom: 0;\n  right: 0;\n}\n.modal-container[data-v-3f772e7a] {\n  width: 30%;\n  margin: 0px auto;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 2px;\n  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);\n  -webkit-transition: all .3s ease;\n  transition: all .3s ease;\n  font-family: "Open Sans", sans-serif;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n@media (max-width: 991px) {\n.modal-container[data-v-3f772e7a] {\n    width: 35%;\n}\n}\n@media (max-width: 676px) {\n.modal-container[data-v-3f772e7a] {\n    /* width: 45% */\n    width: 265px;\n}\n}\n.modal-header h3[data-v-3f772e7a] {\n  margin-top: 0;\n  border-bottom: none !important;\n}\n.modal-body[data-v-3f772e7a] {\n  margin: 5px;\n}\n.modal-footer[data-v-3f772e7a] {\n  border-top: none !important;\n}\n.modal-default-button[data-v-3f772e7a] {\n  float: right;\n}\n.modal-enter[data-v-3f772e7a] {\n  opacity: 0;\n}\n.modal-leave-active[data-v-3f772e7a] {\n  opacity: 0;\n}\n'],sourceRoot:""}])},zVSE:function(t,e,n){var i=n("y8Jd");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("7f92e3b3",i,!0,{})},zuQt:function(t,e,n){var i=n("kAIw");"string"==typeof i&&(i=[[t.i,i,""]]),i.locals&&(t.exports=i.locals);n("rjj0")("4fe12c18",i,!0,{})},zyKz:function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}}})});
//# sourceMappingURL=vue-core.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "JP+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "JaR3":
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__("N1es")
exports.sha1 = __webpack_require__("KQ4j")
exports.sha224 = __webpack_require__("lXn8")
exports.sha256 = __webpack_require__("zvjZ")
exports.sha384 = __webpack_require__("aY2F")
exports.sha512 = __webpack_require__("C015")


/***/ }),

/***/ "JmWi":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__("A1Hb")('Set');


/***/ }),

/***/ "JyN8":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("Wdy1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("xVc6") });


/***/ }),

/***/ "K6ED":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("KIR5"), __esModule: true };

/***/ }),

/***/ "K6ZP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column, ascending) {
  var multiIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var sort = this.defaultSort;
  var multiSort = this.userMultiSorting[this.currentlySorting.column] ? this.userMultiSorting[this.currentlySorting.column] : this.opts.multiSorting[this.currentlySorting.column];
  var asc = this.currentlySorting.ascending;
  var self = this;
  return function (a, b) {
    var aVal = self._getValue(a, column) || '';
    var bVal = self._getValue(b, column) || '';
    var dir = ascending ? 1 : -1;
    var secondaryAsc;
    if (typeof aVal === 'string') aVal = aVal.toLowerCase();
    if (typeof bVal === 'string') bVal = bVal.toLowerCase();

    if (aVal === bVal && multiSort && multiSort[multiIndex + 1]) {
      var sortData = multiSort[multiIndex + 1];

      if (typeof sortData.ascending !== 'undefined') {
        secondaryAsc = sortData.ascending;
      } else {
        secondaryAsc = sortData.matchDir ? asc : !asc;
      }

      return sort(sortData.column, secondaryAsc, multiIndex + 1)(a, b);
    }

    return aVal > bVal ? dir : -dir;
  };
};

/***/ }),

/***/ "KCLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("cGG2");
var normalizeHeaderName = __webpack_require__("5VQ+");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("7GwW");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("7GwW");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "KCUl":
/***/ (function(module, exports, __webpack_require__) {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = __webpack_require__("yASt").Buffer
var BN = __webpack_require__("geuY")
var EC = __webpack_require__("lZ6o").ec
var parseKeys = __webpack_require__("jkjm")
var curves = __webpack_require__("QDfD")

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [1]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = Buffer.from(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = Buffer.from(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify


/***/ }),

/***/ "KDHK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asn1 = exports;

asn1.bignum = __webpack_require__("hgsc");

asn1.define = __webpack_require__("kJAH").define;
asn1.base = __webpack_require__("3UtB");
asn1.constants = __webpack_require__("TnCn");
asn1.decoders = __webpack_require__("iLJX");
asn1.encoders = __webpack_require__("SAez");

/***/ }),

/***/ "KIR5":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("ounN");
var $Object = __webpack_require__("iANj").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ "KQ4j":
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__("LC74")
var Hash = __webpack_require__("CzQx")
var Buffer = __webpack_require__("X3l8").Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),

/***/ "KeN/":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("yASt").Buffer
var createHash = __webpack_require__("BVsN")
var stream = __webpack_require__("bfTY")
var inherits = __webpack_require__("LC74")
var sign = __webpack_require__("pn+s")
var verify = __webpack_require__("KCUl")

var algorithms = __webpack_require__("ejIc")
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = Buffer.from(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = Buffer.from(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = Buffer.from(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}


/***/ }),

/***/ "L/6W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (row, index, event) {
  var data;
  var id = this.opts.uniqueKey;

  if (this.source == 'client' && typeof row[id] !== 'undefined') {
    data = this.tableData.filter(function (r) {
      return row[id] === r[id];
    })[0];
  } else {
    data = row;
  }

  this.dispatch('row-click', {
    row: data,
    index: index,
    event: event
  });
};

/***/ }),

/***/ "LC74":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ "LGuY":
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "LKnP":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var macrotask = __webpack_require__("kkvn").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("NZra")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "LYGd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__("EuP9").Buffer
var inherits = __webpack_require__("LC74")
var HashBase = __webpack_require__("yDvu")

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),

/***/ "LbEw":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(10).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "LhDF":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("GCs6").f;
var has = __webpack_require__("x//u");
var TAG = __webpack_require__("hgbu")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "LocR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("qs+f") && !__webpack_require__("zyKz")(function () {
  return Object.defineProperty(__webpack_require__("PY1i")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "MCxa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  if (!this.opts.orderBy) return;
  this.orderBy.column = this.opts.orderBy.column;
  this.orderBy.ascending = this.opts.orderBy.hasOwnProperty('ascending') ? this.opts.orderBy.ascending : true;
};

/***/ }),

/***/ "MICi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("OVZ9"), __esModule: true };

/***/ }),

/***/ "Maik":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var columns = Object.keys(this.opts.listColumns);
  var res = {};
  columns.forEach(function (column) {
    res[column] = {};
    this.opts.listColumns[column].forEach(function (item) {
      res[column][item.id] = item.text;
    });
  }.bind(this));
  return res;
};

/***/ }),

/***/ "Mf+e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h) {
  var _this = this;

  return function () {
    if (_this.count > 0 && _this.opts.pagination.dropdown) {
      var perPage = parseInt(_this.limit);
      var from = (_this.Page - 1) * perPage + 1;
      var to = _this.Page == _this.totalPages ? _this.count : from + perPage - 1;

      var parts = _this.opts.texts.count.split('|');

      var i = Math.min(_this.count == 1 ? 2 : _this.totalPages == 1 ? 1 : 0, parts.length - 1);
      var count = parts[i].replace('{count}', _this.count).replace('{from}', from).replace('{to}', to);
      return h("div", {
        "class": "VuePagination"
      }, [h("p", {
        "class": "VuePagination__count"
      }, [count])]);
    }

    return '';
  };
};

/***/ }),

/***/ "Midf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _config = __webpack_require__("Afcx");

var _config2 = _interopRequireDefault(_config);

var _merge = __webpack_require__("40O2");

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var template = __webpack_require__("eQ3/");
var bus = __webpack_require__("hdr4");


module.exports = {
  render: template.call(undefined),
  props: {
    for: {
      type: String,
      required: false
    },
    records: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 25
    },
    vuex: {
      type: Boolean
    },
    options: {
      type: Object
    }
  },
  created: function created() {

    if (!this.vuex) return;

    if (!this.for) {
      throw new Error('vue-pagination-2: The "for" prop is required when using vuex');
    }

    var name = this.for;

    if (this.$store.state[name]) return;

    this.$store.registerModule(this.for, {
      state: {
        page: 1
      },
      mutations: _defineProperty({}, name + '/PAGINATE', function undefined(state, page) {
        state.page = page;
      })
    });
  },
  data: function data() {
    return {
      Page: 1,
      firstPage: 1
    };
  },
  computed: {
    opts: function opts() {
      return (0, _merge2.default)((0, _config2.default)(), this.options);
    },
    Theme: function Theme() {

      if (_typeof(this.opts.theme) === 'object') {
        return this.opts.theme;
      }

      var themes = {
        bootstrap3: __webpack_require__("STbB"),
        bootstrap4: __webpack_require__("OYZs"),
        bulma: __webpack_require__("CM7m")
      };

      if (_typeof(themes[this.opts.theme]) === undefined) {
        throw 'vue-pagination-2: the theme ' + this.opts.theme + ' does not exist';
      }

      return themes[this.opts.theme];
    },
    page: function page() {
      return this.vuex ? this.$store.state[this.for].page : this.Page;
    },

    pages: function pages() {
      if (!this.records) return [];

      return range(this.paginationStart, this.pagesInCurrentChunk);
    },
    totalPages: function totalPages() {
      return this.records ? Math.ceil(this.records / this.perPage) : 1;
    },
    totalChunks: function totalChunks() {
      return Math.ceil(this.totalPages / this.opts.chunk);
    },
    currentChunk: function currentChunk() {
      return Math.ceil(this.page / this.opts.chunk);
    },
    paginationStart: function paginationStart() {

      if (this.opts.chunksNavigation === 'scroll') {
        var page =  this.Page - this.opts.chunk + 1;
        return page > 0 ? page : 1;
      }

      return (this.currentChunk - 1) * this.opts.chunk + 1;
    },
    pagesInCurrentChunk: function pagesInCurrentChunk() {
      return this.paginationStart + this.opts.chunk <= this.totalPages ? this.opts.chunk : this.totalPages - this.paginationStart + 1;
    },
    count: function count() {

      if (/{page}/.test(this.opts.texts.count)) {

        if (this.totalPages <= 1) return '';

        return this.opts.texts.count.replace('{page}', this.page).replace('{pages}', this.totalPages);
      }

      var parts = this.opts.texts.count.split('|');
      var from = (this.page - 1) * this.perPage + 1;
      var to = this.page == this.totalPages ? this.records : from + this.perPage - 1;
      var i = Math.min(this.records == 1 ? 2 : this.totalPages == 1 ? 1 : 0, parts.length - 1);

      return parts[i].replace('{count}', this.formatNumber(this.records)).replace('{from}', this.formatNumber(from)).replace('{to}', this.formatNumber(to));
    }
  },
  methods: {
    setPage: function setPage(page) {
      if (this.allowedPage(page)) {
        this.paginate(page);
      }
    },
    paginate: function paginate(page) {
      if (this.vuex) {
        this.$store.commit(this.for + '/PAGINATE', page);
      } else {
        this.Page = page;
      }

      this.$emit('paginate', page);

      if (this.for) {
        bus.$emit('vue-pagination::' + this.for, page);
      }
    },

    next: function next() {
      var page = this.page + 1;
      if (this.opts.chunksNavigation === 'scroll' && this.allowedPage(page) && !this.inDisplay(page)) {
        this.firstPage++;
      }
      return this.setPage(page);
    },
    prev: function prev() {
      var page = this.page - 1;

      if (this.opts.chunksNavigation === 'scroll' && this.allowedPage(page) && !this.inDisplay(page)) {
        this.firstPage--;
      }

      return this.setPage(page);
    },
    inDisplay: function inDisplay(page) {

      var start = this.firstPage;
      var end = start + this.opts.chunk - 1;

      return page >= start && page <= end;
    },

    nextChunk: function nextChunk() {
      return this.setChunk(1);
    },
    prevChunk: function prevChunk() {
      return this.setChunk(-1);
    },
    setChunk: function setChunk(direction) {
      this.setPage((this.currentChunk - 1 + direction) * this.opts.chunk + 1);
    },
    allowedPage: function allowedPage(page) {
      return page >= 1 && page <= this.totalPages;
    },
    allowedChunk: function allowedChunk(direction) {
      return direction == 1 && this.currentChunk < this.totalChunks || direction == -1 && this.currentChunk > 1;
    },
    allowedPageClass: function allowedPageClass(direction) {
      return this.allowedPage(direction) ? '' : this.Theme.disabled;
    },
    allowedChunkClass: function allowedChunkClass(direction) {
      return this.allowedChunk(direction) ? '' : this.Theme.disabled;
    },
    activeClass: function activeClass(page) {
      return this.page == page ? this.Theme.active : '';
    },
    formatNumber: function formatNumber(num) {

      if (!this.opts.format) return num;

      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  beforeDestroy: function beforeDestroy() {
    bus.$off();
    bus.$destroy();
  }
};

function range(start, count) {
  return Array.apply(0, Array(count)).map(function (element, index) {
    return index + start;
  });
}


/***/ }),

/***/ "Ml+W":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer

module.exports = function (thing, encoding, name) {
  if (Buffer.isBuffer(thing)) {
    return thing
  } else if (typeof thing === 'string') {
    return Buffer.from(thing, encoding)
  } else if (ArrayBuffer.isView(thing)) {
    return Buffer.from(thing.buffer)
  } else {
    throw new TypeError(name + ' must be a string, a Buffer, a typed array or a DataView')
  }
}


/***/ }),

/***/ "Mnw5":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__("A1Hb")('Map');


/***/ }),

/***/ "N1es":
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__("LC74")
var Hash = __webpack_require__("CzQx")
var Buffer = __webpack_require__("X3l8").Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),

/***/ "NCTB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__("bMQ9");
exports.sha224 = __webpack_require__("fWB8");
exports.sha256 = __webpack_require__("Q48P");
exports.sha384 = __webpack_require__("EH7o");
exports.sha512 = __webpack_require__("8/0b");


/***/ }),

/***/ "NMED":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("YP8Q");

var utils = __webpack_require__("TkWM");
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),

/***/ "NMac":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("8ANE");
var anObject = __webpack_require__("FKWp");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("3fMt")(Function.call, __webpack_require__("rjjF").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "NU0k":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("NZra");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "NUKO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (rowId, e) {
  if (e) e.stopPropagation();

  if (this.openChildRows.includes(rowId)) {
    var index = this.openChildRows.indexOf(rowId);
    this.openChildRows.splice(index, 1);
  } else {
    this.openChildRows.push(rowId);
  }
};

/***/ }),

/***/ "NYxO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v2.5.0
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.5.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),

/***/ "NZ8V":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("FKWp");
var dPs = __webpack_require__("r3+g");
var enumBugKeys = __webpack_require__("B5V0");
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("PY1i")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("+iDZ").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "NZra":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "Nrqz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__("Wdy1");
var newPromiseCapability = __webpack_require__("3HN9");
var perform = __webpack_require__("AgWD");

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),

/***/ "Ntt2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var LIBRARY = __webpack_require__("c8Kh");
var wksExt = __webpack_require__("4DQ7");
var defineProperty = __webpack_require__("GCs6").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "O+gO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("ejIc")


/***/ }),

/***/ "O2XB":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("zECv");
module.exports = __webpack_require__("iANj").Object.freeze;


/***/ }),

/***/ "O70t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    beforeFilters: this.$slots.beforeFilters ? this.$slots.beforeFilters : '',
    afterFilters: this.$slots.afterFilters ? this.$slots.afterFilters : '',
    prependHead: this.$slots.prependHead ? this.$slots.prependHead : '',
    beforeBody: this.$slots.beforeBody ? this.$slots.beforeBody : '',
    prependBody: this.$slots.prependBody ? this.$slots.prependBody : '',
    appendBody: this.$slots.appendBody ? this.$slots.appendBody : '',
    afterBody: this.$slots.afterBody ? this.$slots.afterBody : '',
    beforeFilter: this.$slots.beforeFilter ? this.$slots.beforeFilter : '',
    afterFilter: this.$slots.afterFilter ? this.$slots.afterFilter : '',
    afterFilterWrapper: this.$slots.afterFilterWrapper ? this.$slots.afterFilterWrapper : '',
    beforeSearch: this.$slots.beforeSearch ? this.$slots.beforeSearch : '',
    beforeLimit: this.$slots.beforeLimit ? this.$slots.beforeLimit : '',
    afterLimit: this.$slots.afterLimit ? this.$slots.afterLimit : '',
    beforeTable: this.$slots.beforeTable ? this.$slots.beforeTable : '',
    afterTable: this.$slots.afterTable ? this.$slots.afterTable : ''
  };
};

/***/ }),

/***/ "OFd3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value, h) {
  if (typeof value !== 'string') return '';
  var derivedHeadingTooltip = '';
  if (!this.opts.headingsTooltips.hasOwnProperty(value)) return derivedHeadingTooltip;

  if (typeof this.opts.headingsTooltips[value] === 'function') {
    if (h) return this.opts.headingsTooltips[value].call(this.$parent, h);
    return derivedHeadingTooltip;
  }

  return this.opts.headingsTooltips[value];
};

/***/ }),

/***/ "OVZ9":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("cwJI");
module.exports = __webpack_require__("iANj").Number.isNaN;


/***/ }),

/***/ "OYZs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    nav: '',
    count: '',
    wrapper: '',
    list: 'pagination',
    item: 'page-item',
    link: 'page-link',
    next: '',
    prev: '',
    active: 'active',
    disabled: 'disabled'
};

/***/ }),

/***/ "OoWg":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("Ntt2")('observable');


/***/ }),

/***/ "OvRC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("AFOY"), __esModule: true };

/***/ }),

/***/ "P3z2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  this.displayColumnsDropdown = !this.displayColumnsDropdown;
};

/***/ }),

/***/ "PBMQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__("euKu");
var Writable = __webpack_require__("/+iU");
__webpack_require__("LC74")(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "PBsE":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__("3fzc")
var primes = __webpack_require__("4Vh3")

var DH = __webpack_require__("Ztz7")

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "PJba":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (response) {
  if (typeof axios !== 'undefined') return response.data;
  return response;
};

/***/ }),

/***/ "PY1i":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
var document = __webpack_require__("YjQv").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "PbQV":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("ksFB");
var toLength = __webpack_require__("GhAV");
var toAbsoluteIndex = __webpack_require__("+VX5");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "PcVv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).



var ERR_STREAM_PREMATURE_CLOSE = __webpack_require__("WrlE").codes.ERR_STREAM_PREMATURE_CLOSE;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    callback.apply(this, args);
  };
}
function noop() {}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function eos(stream, opts, callback) {
  if (typeof opts === 'function') return eos(stream, null, opts);
  if (!opts) opts = {};
  callback = once(callback || noop);
  var readable = opts.readable || opts.readable !== false && stream.readable;
  var writable = opts.writable || opts.writable !== false && stream.writable;
  var onlegacyfinish = function onlegacyfinish() {
    if (!stream.writable) onfinish();
  };
  var writableEnded = stream._writableState && stream._writableState.finished;
  var onfinish = function onfinish() {
    writable = false;
    writableEnded = true;
    if (!readable) callback.call(stream);
  };
  var readableEnded = stream._readableState && stream._readableState.endEmitted;
  var onend = function onend() {
    readable = false;
    readableEnded = true;
    if (!writable) callback.call(stream);
  };
  var onerror = function onerror(err) {
    callback.call(stream, err);
  };
  var onclose = function onclose() {
    var err;
    if (readable && !readableEnded) {
      if (!stream._readableState || !stream._readableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
    if (writable && !writableEnded) {
      if (!stream._writableState || !stream._writableState.ended) err = new ERR_STREAM_PREMATURE_CLOSE();
      return callback.call(stream, err);
    }
  };
  var onrequest = function onrequest() {
    stream.req.on('finish', onfinish);
  };
  if (isRequest(stream)) {
    stream.on('complete', onfinish);
    stream.on('abort', onclose);
    if (stream.req) onrequest();else stream.on('request', onrequest);
  } else if (writable && !stream._writableState) {
    // legacy streams
    stream.on('end', onlegacyfinish);
    stream.on('close', onlegacyfinish);
  }
  stream.on('end', onend);
  stream.on('finish', onfinish);
  if (opts.error !== false) stream.on('error', onerror);
  stream.on('close', onclose);
  return function () {
    stream.removeListener('complete', onfinish);
    stream.removeListener('abort', onclose);
    stream.removeListener('request', onrequest);
    if (stream.req) stream.req.removeListener('finish', onfinish);
    stream.removeListener('end', onlegacyfinish);
    stream.removeListener('close', onlegacyfinish);
    stream.removeListener('finish', onfinish);
    stream.removeListener('end', onend);
    stream.removeListener('error', onerror);
    stream.removeListener('close', onclose);
  };
}
module.exports = eos;

/***/ }),

/***/ "Pf15":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__("kiBT");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),

/***/ "PhfM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
};
/*</replacement>*/

module.exports = Duplex;
var Readable = __webpack_require__("CVWE");
var Writable = __webpack_require__("uDof");
__webpack_require__("LC74")(Duplex, Readable);
{
  // Allow the keys array to be GC'ed.
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}
function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);
  Readable.call(this, options);
  Writable.call(this, options);
  this.allowHalfOpen = true;
  if (options) {
    if (options.readable === false) this.readable = false;
    if (options.writable === false) this.writable = false;
    if (options.allowHalfOpen === false) {
      this.allowHalfOpen = false;
      this.once('end', onend);
    }
  }
}
Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});
Object.defineProperty(Duplex.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
Object.defineProperty(Duplex.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});

// the no-half-open enforcer
function onend() {
  // If the writable side ended, then we're ok.
  if (this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(onEndNT, this);
}
function onEndNT(self) {
  self.end();
}
Object.defineProperty(Duplex.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "PiFy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__("fRHV");

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ "PrYL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var ascending = this.orderBy.ascending;
  this.currentlySorting = {
    column: column,
    ascending: ascending
  };
  if (typeof this.opts.customSorting[column] == 'undefined') return this.defaultSort(column, ascending);
  return this.opts.customSorting[column](ascending);
};

/***/ }),

/***/ "Pwwa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.listColumns.hasOwnProperty(column);
};

/***/ }),

/***/ "Q48P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var common = __webpack_require__("YSDb");
var shaCommon = __webpack_require__("3nYK");
var assert = __webpack_require__("08Lv");

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ "Q51I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;
var _require$codes = __webpack_require__("WrlE").codes,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_TRANSFORM_ALREADY_TRANSFORMING = _require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING,
  ERR_TRANSFORM_WITH_LENGTH_0 = _require$codes.ERR_TRANSFORM_WITH_LENGTH_0;
var Duplex = __webpack_require__("PBMQ");
__webpack_require__("LC74")(Transform, Duplex);
function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;
  var cb = ts.writecb;
  if (cb === null) {
    return this.emit('error', new ERR_MULTIPLE_CALLBACK());
  }
  ts.writechunk = null;
  ts.writecb = null;
  if (data != null)
    // single equals check for both `null` and `undefined`
    this.push(data);
  cb(er);
  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}
function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);
  Duplex.call(this, options);
  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;
  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;
    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}
function prefinish() {
  var _this = this;
  if (typeof this._flush === 'function' && !this._readableState.destroyed) {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}
Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;
  if (ts.writechunk !== null && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};
Transform.prototype._destroy = function (err, cb) {
  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
  });
};
function done(stream, er, data) {
  if (er) return stream.emit('error', er);
  if (data != null)
    // single equals check for both `null` and `undefined`
    stream.push(data);

  // TODO(BridgeAR): Write a test for these two error cases
  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new ERR_TRANSFORM_WITH_LENGTH_0();
  if (stream._transformState.transforming) throw new ERR_TRANSFORM_ALREADY_TRANSFORMING();
  return stream.push(null);
}

/***/ }),

/***/ "RP0y":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("EdxU");
var $Object = __webpack_require__("iANj").Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),

/***/ "RPbb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _merge = _interopRequireDefault(__webpack_require__("40O2"));

var _data2 = _interopRequireDefault(__webpack_require__("jOvE"));

var _vuex = _interopRequireDefault(__webpack_require__("3C96"));

var _normal = _interopRequireDefault(__webpack_require__("uUUu"));

var _table = _interopRequireDefault(__webpack_require__("YcM/"));

var _vuePagination = __webpack_require__("aDKb");

var _resizeableColumns = _interopRequireDefault(__webpack_require__("iwc9"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _data = __webpack_require__("SESp");

var _created = __webpack_require__("WeAp");

var templateCompiler = __webpack_require__("2dp2");

exports.install = function (Vue, globalOptions, useVuex) {
  var theme = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "bootstrap3";
  var template = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "default";
  var state = useVuex ? (0, _vuex["default"])("server") : (0, _normal["default"])();

  var server = _merge["default"].recursive(true, (0, _table["default"])(), {
    name: "server-table",
    components: {
      Pagination: _vuePagination.Pagination
    },
    render: templateCompiler.call(this, template, theme),
    props: {
      columns: {
        type: Array,
        required: true
      },
      url: {
        type: String
      },
      name: {
        type: String,
        required: false
      },
      options: {
        type: Object,
        required: false,
        "default": function _default() {
          return {};
        }
      }
    },
    created: function created() {
      if (!this.opts.requestFunction && !this.url) {
        throw 'vue-tables-2: you must provide either a "url" prop or a custom request function. Aborting';
      }

      _created(this);

      if (!this.vuex) {
        this.query = this.initQuery();
        this.initOrderBy();
        this.customQueries = this.initCustomFilters();
      }

      if (this.opts.sendInitialRequest) {
        this.loadState();
        this.getData(true).then(function (response) {
          if (typeof response === 'undefined') return;
          this.setData(response);
          this.loading = false;

          if (this.hasDateFilters()) {
            setTimeout(function () {
              this.initDateFilters();
            }.bind(this), 0);
          }
        }.bind(this));
      }
    },
    mounted: function mounted() {
      this._setFiltersDOM(this.query);

      if (this.opts.resizableColumns) {
        var removeResizableListeners = (0, _resizeableColumns["default"])(this.$el.querySelector("table"), this.hasChildRow, this.opts.childRowTogglerFirst, this.opts.resizableColumns);
        this.$once('hook:beforeDestroy', removeResizableListeners);
      }

      this._setColumnsDropdownCloseListener();

      if (this.vuex) return;
      this.registerServerFilters();
      if (this.options.initialPage) this.setPage(this.options.initialPage, true);
    },
    data: function data() {
      return _merge["default"].recursive(_data(), {
        source: "server",
        loading: true,
        lastKeyStrokeAt: false,
        globalOptions: globalOptions
      }, (0, _data2["default"])(useVuex, "server", this.options.initialPage));
    },
    methods: {
      refresh: __webpack_require__("f1cp"),
      getData: __webpack_require__("RTXL"),
      setData: __webpack_require__("HUgc"),
      serverSearch: __webpack_require__("2OQD"),
      registerServerFilters: __webpack_require__("kDG8"),
      loadState: function loadState() {
        var _this = this;

        if (!this.opts.saveState) return;

        if (!this.storage.getItem(this.stateKey)) {
          this.initState();
          this.activeState = true;
          return;
        }

        var state = JSON.parse(this.storage.getItem(this.stateKey));

        if (this.vuex) {
          this.commit("SET_STATE", {
            query: state.query,
            customQueries: state.customQueries,
            page: state.page,
            limit: state.perPage,
            orderBy: state.orderBy
          });
        } else {
          this.page = state.page;
          this.query = state.query;
          this.customQueries = state.customQueries;
          this.limit = state.perPage;
          this.orderBy = state.orderBy;
        }

        if (!this.opts.pagination.dropdown && this.$refs.pagination) {
          setTimeout(function () {
            _this.$refs.pagination.Page = state.page;
          }, 0);
        }

        if (this.opts.filterable) {
          setTimeout(function () {
            _this._setFiltersDOM(state.query);
          }, 0);
        }

        this.activeState = true;
      }
    },
    watch: {
      url: function url() {
        this.refresh();
      }
    },
    computed: {
      totalPages: __webpack_require__("eg2Q"),
      filteredQuery: __webpack_require__("uUKu"),
      hasMultiSort: function hasMultiSort() {
        return this.opts.serverMultiSorting;
      }
    }
  }, state);

  Vue.component("v-server-table", server);
  return server;
};

/***/ }),

/***/ "RTXL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var merge = __webpack_require__("40O2");

module.exports = function (promiseOnly) {
  var _data;

  var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var emitLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var keys = this.opts.requestKeys;
  var data = (_data = {}, _defineProperty(_data, keys.query, this.filteredQuery), _defineProperty(_data, keys.limit, this.limit), _defineProperty(_data, keys.ascending, this.orderBy.ascending ? 1 : 0), _defineProperty(_data, keys.page, this.page), _defineProperty(_data, keys.byColumn, this.opts.filterByColumn ? 1 : 0), _data);
  if (this.orderBy.hasOwnProperty('column') && this.orderBy.column) data[keys.orderBy] = this.orderBy.column;
  data = merge(data, this.opts.params, this.customQueries, additionalData);

  if (this.hasMultiSort && this.orderBy.column && this.userMultiSorting[this.orderBy.column]) {
    data.multiSort = this.userMultiSorting[this.orderBy.column];
  }

  data = this.opts.requestAdapter(data);

  if (emitLoading) {
    this.dispatch('loading', data);
  }

  var promise = this.sendRequest(data);
  if (promiseOnly) return promise;
  return promise.then(function (response) {
    if (typeof response !== 'undefined') {
      this.loading = false;
      return this.setData(response);
    } else {
      return false;
    }
  }.bind(this));
};

/***/ }),

/***/ "RWUN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (text, replacements) {
  if (!this.opts.texts) return '';
  var text = this.opts.texts[text];
  if (replacements) for (var key in replacements) {
    // console.log(key)
    text = text.replace('{' + key + '}', replacements[key]);
  }
  return text;
};

/***/ }),

/***/ "Rf8U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(o){return typeof o}:function(o){return o&&"function"==typeof Symbol&&o.constructor===Symbol&&o!==Symbol.prototype?"symbol":typeof o};!function(){function o(e,t){if(!o.installed){if(o.installed=!0,!t)return void console.error("You have to install axios");e.axios=t,Object.defineProperties(e.prototype,{axios:{get:function(){return t}},$http:{get:function(){return t}}})}}"object"==( false?"undefined":_typeof(exports))?module.exports=o: true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return o}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):window.Vue&&window.axios&&Vue.use(o,window.axios)}();

/***/ }),

/***/ "RirO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vuePagination = __webpack_require__("aDKb");

var _vuex = _interopRequireDefault(__webpack_require__("3C96"));

var _normal = _interopRequireDefault(__webpack_require__("uUUu"));

var _merge = _interopRequireDefault(__webpack_require__("40O2"));

var _table = _interopRequireDefault(__webpack_require__("YcM/"));

var _data2 = _interopRequireDefault(__webpack_require__("jOvE"));

var _resizeableColumns = _interopRequireDefault(__webpack_require__("iwc9"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _data = __webpack_require__("SESp");

var _created = __webpack_require__("WeAp");

var templateCompiler = __webpack_require__("2dp2");

exports.install = function (Vue, globalOptions, useVuex) {
  var theme = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "bootstrap3";
  var template = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "default";

  var client = _merge["default"].recursive(true, (0, _table["default"])(), {
    name: "client-table",
    components: {
      Pagination: _vuePagination.Pagination
    },
    render: templateCompiler.call(this, template, theme),
    props: {
      columns: {
        type: Array,
        required: true
      },
      data: {
        type: Array,
        required: true
      },
      name: {
        type: String,
        required: false
      },
      options: {
        type: Object,
        required: false,
        "default": function _default() {
          return {};
        }
      }
    },
    created: function created() {
      _created(this);

      if (this.opts.toMomentFormat) this.transformDateStringsToMoment();

      if (!this.vuex) {
        this.initOrderBy();
        this.query = this.initQuery();
        this.customQueries = this.initCustomFilters();
      }
    },
    mounted: function mounted() {
      this._setFiltersDOM(this.query);

      if (this.opts.resizableColumns) {
        var removeResizableListeners = (0, _resizeableColumns["default"])(this.$el.querySelector("table"), this.hasChildRow, this.opts.childRowTogglerFirst, this.opts.resizableColumns);
        this.$once('hook:beforeDestroy', removeResizableListeners);
      }

      this._setColumnsDropdownCloseListener();

      if (!this.vuex) {
        this.registerClientFilters();
        if (this.options.initialPage) this.setPage(this.options.initialPage);
      }

      if (this.opts.groupBy && !this.opts.orderBy) {
        this.orderBy.column = this.opts.groupBy;
      }

      this.loadState();

      if (this.hasDateFilters()) {
        this.initDateFilters();
      }
    },
    model: {
      prop: "data"
    },
    data: function data() {
      return _merge["default"].recursive(_data(), {
        source: "client",
        globalOptions: globalOptions,
        currentlySorting: {},
        time: Date.now()
      }, (0, _data2["default"])(useVuex, "client", this.options.initialPage));
    },
    computed: {
      q: __webpack_require__("IQ8V"),
      customQ: __webpack_require__("9Urd"),
      totalPages: __webpack_require__("eg2Q"),
      filteredData: __webpack_require__("pecZ"),
      hasMultiSort: function hasMultiSort() {
        return this.opts.clientMultiSorting;
      }
    },
    methods: {
      transformDateStringsToMoment: __webpack_require__("3vT9"),
      registerClientFilters: __webpack_require__("uKUB"),
      search: __webpack_require__("D1/s"),
      defaultSort: __webpack_require__("K6ZP"),
      getGroupSlot: __webpack_require__("UeD3"),
      toggleGroup: function toggleGroup(group, e) {
        e.stopPropagation();
        var i = this.collapsedGroups.indexOf(group);

        if (i >= 0) {
          this.collapsedGroups.splice(i, 1);
        } else {
          this.collapsedGroups.push(group);
        }
      },
      groupToggleIcon: function groupToggleIcon(group) {
        var cls = this.opts.sortIcon.base + " ";
        cls += this.collapsedGroups.indexOf(group) > -1 ? this.opts.sortIcon.down : this.opts.sortIcon.up;
        return cls;
      },
      loadState: function loadState() {
        if (!this.opts.saveState) return;

        if (!this.storage.getItem(this.stateKey)) {
          this.initState();
          this.activeState = true;
          return;
        }

        var state = JSON.parse(this.storage.getItem(this.stateKey));
        if (this.opts.filterable) this.setFilter(state.query);
        this.setOrder(state.orderBy.column, state.orderBy.ascending);

        if (this.vuex) {
          this.commit("SET_LIMIT", state.perPage);
        } else {
          this.limit = state.perPage;
        }

        this.setPage(state.page);
        this.activeState = true;

        if (state.userControlsColumns) {
          this.userColumnsDisplay = state.userColumnsDisplay;
          this.userControlsColumns = state.userControlsColumns;
        } // TODO: Custom Queries

      }
    }
  });

  var state = useVuex ? (0, _vuex["default"])() : (0, _normal["default"])();
  client = _merge["default"].recursive(client, state);
  Vue.component("v-client-table", client);
  return client;
};

/***/ }),

/***/ "Rt1F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__("ypnx");
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__("sOR5");
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("vzCy").EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("UcPO");
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__("X3l8").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__("jOgh"));
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(13);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__("+HRN");
var destroyImpl = __webpack_require__("x0Ha");
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__("DsFX");

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("X4X3").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__("DsFX");

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("X4X3").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, { hasUnpiped: false });
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "RzOE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("TkWM");
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),

/***/ "SAez":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encoders = exports;

encoders.der = __webpack_require__("ps4E");
encoders.pem = __webpack_require__("VqvS");

/***/ }),

/***/ "SDM6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("DsFX");


/***/ }),

/***/ "SESp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    id: makeId(),
    allFilteredData: [],
    openChildRows: [],
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : null,
    userMultiSorting: {},
    editing: []
  };
};

function makeId() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

/***/ }),

/***/ "SQ9R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data) {
  if (typeof this.opts.requestFunction === 'function') {
    return this.opts.requestFunction.call(this, data);
  }

  if (typeof axios !== 'undefined') return axios.get(this.url, {
    params: data
  })["catch"](function (e) {
    this.dispatch('error', e);
  }.bind(this));
  if (typeof this.$http !== 'undefined') return this.$http.get(this.url, {
    params: data
  }).then(function (data) {
    return data.json();
  }.bind(this), function (e) {
    this.dispatch('error', e);
  }.bind(this));
  if (typeof $ != 'undefined') return $.getJSON(this.url, data).fail(function (e) {
    this.dispatch('error', e);
  }.bind(this));
  throw "vue-tables: No supported ajax library was found. (jQuery, axios or vue-resource). To use a different library you can write your own request function (see the `requestFunction` option)";
};

/***/ }),

/***/ "STbB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    nav: '',
    count: '',
    wrapper: '',
    list: 'pagination',
    item: 'page-item',
    link: 'page-link',
    next: '',
    prev: '',
    active: 'active',
    disabled: 'disabled'
};

/***/ }),

/***/ "SWGL":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "SjlN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (obj) {
  // null and undefined are "empty"
  if (obj == null) return true; // Assume if it has a length property with a non-zero value
  // that that property is correct.

  if (obj.length > 0) return false;
  if (obj.length === 0) return true; // Otherwise, does it have any properties of its own?

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
  }

  return true;
};

/***/ }),

/***/ "SsjP":
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__("H2Pp")
var Buffer = __webpack_require__("X3l8").Buffer
var incr32 = __webpack_require__("4sPJ")

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),

/***/ "St71":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("FKWp");
var get = __webpack_require__("1yV6");
module.exports = __webpack_require__("iANj").getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ "T1ft":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptors__ = __webpack_require__("jJmG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__("K6ED");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_symbols__ = __webpack_require__("8hRR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol_to_string_tag__ = __webpack_require__("a1FJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol_to_string_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol_to_string_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_symbol_iterator__ = __webpack_require__("Zzip");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol__ = __webpack_require__("5QVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_is_iterable__ = __webpack_require__("us/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_is_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_is_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_define_property__ = __webpack_require__("C4MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof__);













!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(exports)) && "object" == ( false ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(module)) ? module.exports = t() : "function" == typeof define && __webpack_require__("nErl") ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(exports)) ? exports.VueSelect = t() : e.VueSelect = t();
}("undefined" != typeof self ? self : this, function () {
  return function () {
    var e = { 646: function _(e) {
        e.exports = function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = new Array(e.length); t < e.length; t++) {
              n[t] = e[t];
            }return n;
          }
        };
      }, 713: function _(e) {
        e.exports = function (e, t, n) {
          return t in e ? __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_define_property___default()(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
        };
      }, 860: function _(e) {
        e.exports = function (e) {
          if (__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_is_iterable___default()(Object(e)) || "[object Arguments]" === Object.prototype.toString.call(e)) return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_array_from___default()(e);
        };
      }, 206: function _(e) {
        e.exports = function () {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        };
      }, 319: function _(e, t, n) {
        var o = n(646),
            i = n(860),
            s = n(206);e.exports = function (e) {
          return o(e) || i(e) || s();
        };
      }, 8: function _(e) {
        function t(n) {
          return "function" == typeof __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol___default.a && "symbol" == __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_symbol_iterator___default.a) ? e.exports = t = function t(e) {
            return typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(e);
          } : e.exports = t = function t(e) {
            return e && "function" == typeof __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol___default.a && e.constructor === __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol___default.a && e !== __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_12_babel_runtime_helpers_typeof___default()(e);
          }, t(n);
        }e.exports = t;
      } },
        t = {};function n(o) {
      var i = t[o];if (void 0 !== i) return i.exports;var s = t[o] = { exports: {} };return e[o](s, s.exports, n), s.exports;
    }n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return n.d(t, { a: t }), t;
    }, n.d = function (e, t) {
      for (var o in t) {
        n.o(t, o) && !n.o(e, o) && __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_define_property___default()(e, o, { enumerable: !0, get: t[o] });
      }
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_symbol___default.a && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol_to_string_tag___default.a && __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_define_property___default()(e, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_symbol_to_string_tag___default.a, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
    };var o = {};return function () {
      "use strict";
      n.r(o), n.d(o, { VueSelect: function VueSelect() {
          return m;
        }, default: function _default() {
          return O;
        }, mixins: function mixins() {
          return _;
        } });var e = n(319),
          t = n.n(e),
          i = n(8),
          s = n.n(i),
          r = n(713),
          a = n.n(r);var l = { props: { autoscroll: { type: Boolean, default: !0 } }, watch: { typeAheadPointer: function typeAheadPointer() {
            this.autoscroll && this.maybeAdjustScroll();
          }, open: function open(e) {
            var t = this;this.autoscroll && e && this.$nextTick(function () {
              return t.maybeAdjustScroll();
            });
          } }, methods: { maybeAdjustScroll: function maybeAdjustScroll() {
            var e,
                t = (null === (e = this.$refs.dropdownMenu) || void 0 === e ? void 0 : e.children[this.typeAheadPointer]) || !1;if (t) {
              var n = this.getDropdownViewport(),
                  o = t.getBoundingClientRect(),
                  i = o.top,
                  s = o.bottom,
                  r = o.height;if (i < n.top) return this.$refs.dropdownMenu.scrollTop = t.offsetTop;if (s > n.bottom) return this.$refs.dropdownMenu.scrollTop = t.offsetTop - (n.height - r);
            }
          }, getDropdownViewport: function getDropdownViewport() {
            return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : { height: 0, top: 0, bottom: 0 };
          } } },
          c = { data: function data() {
          return { typeAheadPointer: -1 };
        }, watch: { filteredOptions: function filteredOptions() {
            for (var e = 0; e < this.filteredOptions.length; e++) {
              if (this.selectable(this.filteredOptions[e])) {
                this.typeAheadPointer = e;break;
              }
            }
          }, open: function open(e) {
            e && this.typeAheadToLastSelected();
          }, selectedValue: function selectedValue() {
            this.open && this.typeAheadToLastSelected();
          } }, methods: { typeAheadUp: function typeAheadUp() {
            for (var e = this.typeAheadPointer - 1; e >= 0; e--) {
              if (this.selectable(this.filteredOptions[e])) {
                this.typeAheadPointer = e;break;
              }
            }
          }, typeAheadDown: function typeAheadDown() {
            for (var e = this.typeAheadPointer + 1; e < this.filteredOptions.length; e++) {
              if (this.selectable(this.filteredOptions[e])) {
                this.typeAheadPointer = e;break;
              }
            }
          }, typeAheadSelect: function typeAheadSelect() {
            var e = this.filteredOptions[this.typeAheadPointer];e && this.selectable(e) && this.select(e);
          }, typeAheadToLastSelected: function typeAheadToLastSelected() {
            var e = 0 !== this.selectedValue.length ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;-1 !== e && (this.typeAheadPointer = e);
          } } },
          u = { props: { loading: { type: Boolean, default: !1 } }, data: function data() {
          return { mutableLoading: !1 };
        }, watch: { search: function search() {
            this.$emit("search", this.search, this.toggleLoading);
          }, loading: function loading(e) {
            this.mutableLoading = e;
          } }, methods: { toggleLoading: function toggleLoading() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;return this.mutableLoading = null == e ? !this.mutableLoading : e;
          } } };function p(e, t, n, o, i, s, r, a) {
        var l,
            c = "function" == typeof e ? e.options : e;if (t && (c.render = t, c.staticRenderFns = n, c._compiled = !0), o && (c.functional = !0), s && (c._scopeId = "data-v-" + s), r ? (l = function l(e) {
          (e = e || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__), i && i.call(this, e), e && e._registeredComponents && e._registeredComponents.add(r);
        }, c._ssrRegister = l) : i && (l = a ? function () {
          i.call(this, (c.functional ? this.parent : this).$root.$options.shadowRoot);
        } : i), l) if (c.functional) {
          c._injectStyles = l;var u = c.render;c.render = function (e, t) {
            return l.call(t), u(e, t);
          };
        } else {
          var p = c.beforeCreate;c.beforeCreate = p ? [].concat(p, l) : [l];
        }return { exports: e, options: c };
      }var h = { Deselect: p({}, function () {
          var e = this.$createElement,
              t = this._self._c || e;return t("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "10", height: "10" } }, [t("path", { attrs: { d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z" } })]);
        }, [], !1, null, null, null).exports, OpenIndicator: p({}, function () {
          var e = this.$createElement,
              t = this._self._c || e;return t("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg", width: "14", height: "10" } }, [t("path", { attrs: { d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z" } })]);
        }, [], !1, null, null, null).exports },
          d = { inserted: function inserted(e, t, n) {
          var o = n.context;if (o.appendToBody) {
            var i = o.$refs.toggle.getBoundingClientRect(),
                s = i.height,
                r = i.top,
                a = i.left,
                l = i.width,
                c = window.scrollX || window.pageXOffset,
                u = window.scrollY || window.pageYOffset;e.unbindPosition = o.calculatePosition(e, o, { width: l + "px", left: c + a + "px", top: u + r + s + "px" }), document.body.appendChild(e);
          }
        }, unbind: function unbind(e, t, n) {
          n.context.appendToBody && (e.unbindPosition && "function" == typeof e.unbindPosition && e.unbindPosition(), e.parentNode && e.parentNode.removeChild(e));
        } };var f = function f(e) {
        var t = {};return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(e).sort().forEach(function (n) {
          t[n] = e[n];
        }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(t);
      };var y = 0;var g = function g() {
        return ++y;
      };function b(e, t) {
        var n = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(e);if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_symbols___default.a) {
          var o = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_symbols___default()(e);t && (o = o.filter(function (t) {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(e, t).enumerable;
          })), n.push.apply(n, o);
        }return n;
      }function v(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};t % 2 ? b(Object(n), !0).forEach(function (t) {
            a()(e, t, n[t]);
          }) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptors___default.a ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_properties___default()(e, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptors___default()(n)) : b(Object(n)).forEach(function (t) {
            __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_define_property___default()(e, t, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_own_property_descriptor___default()(n, t));
          });
        }return e;
      }var m = p({ components: v({}, h), directives: { appendToBody: d }, mixins: [l, c, u], props: { value: {}, components: { type: Object, default: function _default() {
              return {};
            } }, options: { type: Array, default: function _default() {
              return [];
            } }, disabled: { type: Boolean, default: !1 }, clearable: { type: Boolean, default: !0 }, deselectFromDropdown: { type: Boolean, default: !1 }, searchable: { type: Boolean, default: !0 }, multiple: { type: Boolean, default: !1 }, placeholder: { type: String, default: "" }, transition: { type: String, default: "vs__fade" }, clearSearchOnSelect: { type: Boolean, default: !0 }, closeOnSelect: { type: Boolean, default: !0 }, label: { type: String, default: "label" }, autocomplete: { type: String, default: "off" }, reduce: { type: Function, default: function _default(e) {
              return e;
            } }, selectable: { type: Function, default: function _default(e) {
              return !0;
            } }, getOptionLabel: { type: Function, default: function _default(e) {
              return "object" === s()(e) ? e.hasOwnProperty(this.label) ? e[this.label] : console.warn('[vue-select warn]: Label key "option.'.concat(this.label, '" does not') + " exist in options object ".concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(e), ".\n") + "https://vue-select.org/api/props.html#getoptionlabel") : e;
            } }, getOptionKey: { type: Function, default: function _default(e) {
              if ("object" !== s()(e)) return e;try {
                return e.hasOwnProperty("id") ? e.id : f(e);
              } catch (t) {
                return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey", e, t);
              }
            } }, onTab: { type: Function, default: function _default() {
              this.selectOnTab && !this.isComposing && this.typeAheadSelect();
            } }, taggable: { type: Boolean, default: !1 }, tabindex: { type: Number, default: null }, pushTags: { type: Boolean, default: !1 }, filterable: { type: Boolean, default: !0 }, filterBy: { type: Function, default: function _default(e, t, n) {
              return (t || "").toLocaleLowerCase().indexOf(n.toLocaleLowerCase()) > -1;
            } }, filter: { type: Function, default: function _default(e, t) {
              var n = this;return e.filter(function (e) {
                var o = n.getOptionLabel(e);return "number" == typeof o && (o = o.toString()), n.filterBy(e, o, t);
              });
            } }, createOption: { type: Function, default: function _default(e) {
              return "object" === s()(this.optionList[0]) ? a()({}, this.label, e) : e;
            } }, resetOnOptionsChange: { default: !1, validator: function validator(e) {
              return ["function", "boolean"].includes(s()(e));
            } }, clearSearchOnBlur: { type: Function, default: function _default(e) {
              var t = e.clearSearchOnSelect,
                  n = e.multiple;return t && !n;
            } }, noDrop: { type: Boolean, default: !1 }, inputId: { type: String }, dir: { type: String, default: "auto" }, selectOnTab: { type: Boolean, default: !1 }, selectOnKeyCodes: { type: Array, default: function _default() {
              return [13];
            } }, searchInputQuerySelector: { type: String, default: "[type=search]" }, mapKeydown: { type: Function, default: function _default(e, t) {
              return e;
            } }, appendToBody: { type: Boolean, default: !1 }, calculatePosition: { type: Function, default: function _default(e, t, n) {
              var o = n.width,
                  i = n.top,
                  s = n.left;e.style.top = i, e.style.left = s, e.style.width = o;
            } }, dropdownShouldOpen: { type: Function, default: function _default(e) {
              var t = e.noDrop,
                  n = e.open,
                  o = e.mutableLoading;return !t && n && !o;
            } }, uid: { type: [String, Number], default: function _default() {
              return g();
            } } }, data: function data() {
          return { search: "", open: !1, isComposing: !1, pushedTags: [], _value: [] };
        }, computed: { isTrackingValues: function isTrackingValues() {
            return void 0 === this.value || this.$options.propsData.hasOwnProperty("reduce");
          }, selectedValue: function selectedValue() {
            var e = this.value;return this.isTrackingValues && (e = this.$data._value), null != e && "" !== e ? [].concat(e) : [];
          }, optionList: function optionList() {
            return this.options.concat(this.pushTags ? this.pushedTags : []);
          }, searchEl: function searchEl() {
            return this.$scopedSlots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
          }, scope: function scope() {
            var e = this,
                t = { search: this.search, loading: this.loading, searching: this.searching, filteredOptions: this.filteredOptions };return { search: { attributes: v({ disabled: this.disabled, placeholder: this.searchPlaceholder, tabindex: this.tabindex, readonly: !this.searchable, id: this.inputId, "aria-autocomplete": "list", "aria-labelledby": "vs".concat(this.uid, "__combobox"), "aria-controls": "vs".concat(this.uid, "__listbox"), ref: "search", type: "search", autocomplete: this.autocomplete, value: this.search }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? { "aria-activedescendant": "vs".concat(this.uid, "__option-").concat(this.typeAheadPointer) } : {}), events: { compositionstart: function compositionstart() {
                    return e.isComposing = !0;
                  }, compositionend: function compositionend() {
                    return e.isComposing = !1;
                  }, keydown: this.onSearchKeyDown, keypress: this.onSearchKeyPress, blur: this.onSearchBlur, focus: this.onSearchFocus, input: function input(t) {
                    return e.search = t.target.value;
                  } } }, spinner: { loading: this.mutableLoading }, noOptions: { search: this.search, loading: this.mutableLoading, searching: this.searching }, openIndicator: { attributes: { ref: "openIndicator", role: "presentation", class: "vs__open-indicator" } }, listHeader: t, listFooter: t, header: v({}, t, { deselect: this.deselect }), footer: v({}, t, { deselect: this.deselect }) };
          }, childComponents: function childComponents() {
            return v({}, h, {}, this.components);
          }, stateClasses: function stateClasses() {
            return { "vs--open": this.dropdownOpen, "vs--single": !this.multiple, "vs--multiple": this.multiple, "vs--searching": this.searching && !this.noDrop, "vs--searchable": this.searchable && !this.noDrop, "vs--unsearchable": !this.searchable, "vs--loading": this.mutableLoading, "vs--disabled": this.disabled };
          }, searching: function searching() {
            return !!this.search;
          }, dropdownOpen: function dropdownOpen() {
            return this.dropdownShouldOpen(this);
          }, searchPlaceholder: function searchPlaceholder() {
            return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
          }, filteredOptions: function filteredOptions() {
            var e = [].concat(this.optionList);if (!this.filterable && !this.taggable) return e;var t = this.search.length ? this.filter(e, this.search, this) : e;if (this.taggable && this.search.length) {
              var n = this.createOption(this.search);this.optionExists(n) || t.unshift(n);
            }return t;
          }, isValueEmpty: function isValueEmpty() {
            return 0 === this.selectedValue.length;
          }, showClearButton: function showClearButton() {
            return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
          } }, watch: { options: function options(e, t) {
            var n = this;!this.taggable && ("function" == typeof n.resetOnOptionsChange ? n.resetOnOptionsChange(e, t, n.selectedValue) : n.resetOnOptionsChange) && this.clearSelection(), this.value && this.isTrackingValues && this.setInternalValueFromOptions(this.value);
          }, value: { immediate: !0, handler: function handler(e) {
              this.isTrackingValues && this.setInternalValueFromOptions(e);
            } }, multiple: function multiple() {
            this.clearSelection();
          }, open: function open(e) {
            this.$emit(e ? "open" : "close");
          }, search: function search(e) {
            e.length && (this.open = !0);
          } }, created: function created() {
          this.mutableLoading = this.loading, this.$on("option:created", this.pushTag);
        }, methods: { setInternalValueFromOptions: function setInternalValueFromOptions(e) {
            var t = this;Array.isArray(e) ? this.$data._value = e.map(function (e) {
              return t.findOptionFromReducedValue(e);
            }) : this.$data._value = this.findOptionFromReducedValue(e);
          }, select: function select(e) {
            this.$emit("option:selecting", e), this.isOptionSelected(e) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(e) : (this.taggable && !this.optionExists(e) && this.$emit("option:created", e), this.multiple && (e = this.selectedValue.concat(e)), this.updateValue(e), this.$emit("option:selected", e)), this.onAfterSelect(e);
          }, deselect: function deselect(e) {
            var t = this;this.$emit("option:deselecting", e), this.updateValue(this.selectedValue.filter(function (n) {
              return !t.optionComparator(n, e);
            })), this.$emit("option:deselected", e);
          }, clearSelection: function clearSelection() {
            this.updateValue(this.multiple ? [] : null);
          }, onAfterSelect: function onAfterSelect(e) {
            var t = this;this.closeOnSelect && (this.open = !this.open), this.clearSearchOnSelect && (this.search = ""), this.noDrop && this.multiple && this.$nextTick(function () {
              return t.$refs.search.focus();
            });
          }, updateValue: function updateValue(e) {
            var t = this;void 0 === this.value && (this.$data._value = e), null !== e && (e = Array.isArray(e) ? e.map(function (e) {
              return t.reduce(e);
            }) : this.reduce(e)), this.$emit("input", e);
          }, toggleDropdown: function toggleDropdown(e) {
            var n = e.target !== this.searchEl;n && e.preventDefault();var o = [].concat(t()(this.$refs.deselectButtons || []), t()([this.$refs.clearButton] || 0));void 0 === this.searchEl || o.filter(Boolean).some(function (t) {
              return t.contains(e.target) || t === e.target;
            }) ? e.preventDefault() : this.open && n ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
          }, isOptionSelected: function isOptionSelected(e) {
            var t = this;return this.selectedValue.some(function (n) {
              return t.optionComparator(n, e);
            });
          }, isOptionDeselectable: function isOptionDeselectable(e) {
            return this.isOptionSelected(e) && this.deselectFromDropdown;
          }, optionComparator: function optionComparator(e, t) {
            return this.getOptionKey(e) === this.getOptionKey(t);
          }, findOptionFromReducedValue: function findOptionFromReducedValue(e) {
            var n = this,
                o = [].concat(t()(this.options), t()(this.pushedTags)).filter(function (t) {
              return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(n.reduce(t)) === __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(e);
            });return 1 === o.length ? o[0] : o.find(function (e) {
              return n.optionComparator(e, n.$data._value);
            }) || e;
          }, closeSearchOptions: function closeSearchOptions() {
            this.open = !1, this.$emit("search:blur");
          }, maybeDeleteValue: function maybeDeleteValue() {
            if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
              var e = null;this.multiple && (e = t()(this.selectedValue.slice(0, this.selectedValue.length - 1))), this.updateValue(e);
            }
          }, optionExists: function optionExists(e) {
            var t = this;return this.optionList.some(function (n) {
              return t.optionComparator(n, e);
            });
          }, normalizeOptionForSlot: function normalizeOptionForSlot(e) {
            return "object" === s()(e) ? e : a()({}, this.label, e);
          }, pushTag: function pushTag(e) {
            this.pushedTags.push(e);
          }, onEscape: function onEscape() {
            this.search.length ? this.search = "" : this.open = !1;
          }, onSearchBlur: function onSearchBlur() {
            if (!this.mousedown || this.searching) {
              var e = this.clearSearchOnSelect,
                  t = this.multiple;return this.clearSearchOnBlur({ clearSearchOnSelect: e, multiple: t }) && (this.search = ""), void this.closeSearchOptions();
            }this.mousedown = !1, 0 !== this.search.length || 0 !== this.options.length || this.closeSearchOptions();
          }, onSearchFocus: function onSearchFocus() {
            this.open = !0, this.$emit("search:focus");
          }, onMousedown: function onMousedown() {
            this.mousedown = !0;
          }, onMouseUp: function onMouseUp() {
            this.mousedown = !1;
          }, onSearchKeyDown: function onSearchKeyDown(e) {
            var t = this,
                n = function n(e) {
              return e.preventDefault(), !t.isComposing && t.typeAheadSelect();
            },
                o = { 8: function _(e) {
                return t.maybeDeleteValue();
              }, 9: function _(e) {
                return t.onTab();
              }, 27: function _(e) {
                return t.onEscape();
              }, 38: function _(e) {
                if (e.preventDefault(), t.open) return t.typeAheadUp();t.open = !0;
              }, 40: function _(e) {
                if (e.preventDefault(), t.open) return t.typeAheadDown();t.open = !0;
              } };this.selectOnKeyCodes.forEach(function (e) {
              return o[e] = n;
            });var i = this.mapKeydown(o, this);if ("function" == typeof i[e.keyCode]) return i[e.keyCode](e);
          }, onSearchKeyPress: function onSearchKeyPress(e) {
            this.open || 32 !== e.keyCode || (e.preventDefault(), this.open = !0);
          } } }, function () {
        var e = this,
            t = e.$createElement,
            n = e._self._c || t;return n("div", { staticClass: "v-select", class: e.stateClasses, attrs: { dir: e.dir } }, [e._t("header", null, null, e.scope.header), e._v(" "), n("div", { ref: "toggle", staticClass: "vs__dropdown-toggle", attrs: { id: "vs" + e.uid + "__combobox", role: "combobox", "aria-expanded": e.dropdownOpen.toString(), "aria-owns": "vs" + e.uid + "__listbox", "aria-label": "Search for option" }, on: { mousedown: function mousedown(t) {
              return e.toggleDropdown(t);
            } } }, [n("div", { ref: "selectedOptions", staticClass: "vs__selected-options" }, [e._l(e.selectedValue, function (t) {
          return e._t("selected-option-container", [n("span", { key: e.getOptionKey(t), staticClass: "vs__selected" }, [e._t("selected-option", [e._v("\n            " + e._s(e.getOptionLabel(t)) + "\n          ")], null, e.normalizeOptionForSlot(t)), e._v(" "), e.multiple ? n("button", { ref: "deselectButtons", refInFor: !0, staticClass: "vs__deselect", attrs: { disabled: e.disabled, type: "button", title: "Deselect " + e.getOptionLabel(t), "aria-label": "Deselect " + e.getOptionLabel(t) }, on: { click: function click(n) {
                return e.deselect(t);
              } } }, [n(e.childComponents.Deselect, { tag: "component" })], 1) : e._e()], 2)], { option: e.normalizeOptionForSlot(t), deselect: e.deselect, multiple: e.multiple, disabled: e.disabled });
        }), e._v(" "), e._t("search", [n("input", e._g(e._b({ staticClass: "vs__search" }, "input", e.scope.search.attributes, !1), e.scope.search.events))], null, e.scope.search)], 2), e._v(" "), n("div", { ref: "actions", staticClass: "vs__actions" }, [n("button", { directives: [{ name: "show", rawName: "v-show", value: e.showClearButton, expression: "showClearButton" }], ref: "clearButton", staticClass: "vs__clear", attrs: { disabled: e.disabled, type: "button", title: "Clear Selected", "aria-label": "Clear Selected" }, on: { click: e.clearSelection } }, [n(e.childComponents.Deselect, { tag: "component" })], 1), e._v(" "), e._t("open-indicator", [e.noDrop ? e._e() : n(e.childComponents.OpenIndicator, e._b({ tag: "component" }, "component", e.scope.openIndicator.attributes, !1))], null, e.scope.openIndicator), e._v(" "), e._t("spinner", [n("div", { directives: [{ name: "show", rawName: "v-show", value: e.mutableLoading, expression: "mutableLoading" }], staticClass: "vs__spinner" }, [e._v("Loading...")])], null, e.scope.spinner)], 2)]), e._v(" "), n("transition", { attrs: { name: e.transition } }, [e.dropdownOpen ? n("ul", { directives: [{ name: "append-to-body", rawName: "v-append-to-body" }], key: "vs" + e.uid + "__listbox", ref: "dropdownMenu", staticClass: "vs__dropdown-menu", attrs: { id: "vs" + e.uid + "__listbox", role: "listbox", tabindex: "-1" }, on: { mousedown: function mousedown(t) {
              return t.preventDefault(), e.onMousedown(t);
            }, mouseup: e.onMouseUp } }, [e._t("list-header", null, null, e.scope.listHeader), e._v(" "), e._l(e.filteredOptions, function (t, o) {
          return n("li", { key: e.getOptionKey(t), staticClass: "vs__dropdown-option", class: { "vs__dropdown-option--deselect": e.isOptionDeselectable(t) && o === e.typeAheadPointer, "vs__dropdown-option--selected": e.isOptionSelected(t), "vs__dropdown-option--highlight": o === e.typeAheadPointer, "vs__dropdown-option--disabled": !e.selectable(t) }, attrs: { id: "vs" + e.uid + "__option-" + o, role: "option", "aria-selected": o === e.typeAheadPointer || null }, on: { mouseover: function mouseover(n) {
                e.selectable(t) && (e.typeAheadPointer = o);
              }, click: function click(n) {
                n.preventDefault(), n.stopPropagation(), e.selectable(t) && e.select(t);
              } } }, [e._t("option", [e._v("\n          " + e._s(e.getOptionLabel(t)) + "\n        ")], null, e.normalizeOptionForSlot(t))], 2);
        }), e._v(" "), 0 === e.filteredOptions.length ? n("li", { staticClass: "vs__no-options" }, [e._t("no-options", [e._v("\n          Sorry, no matching options.\n        ")], null, e.scope.noOptions)], 2) : e._e(), e._v(" "), e._t("list-footer", null, null, e.scope.listFooter)], 2) : n("ul", { staticStyle: { display: "none", visibility: "hidden" }, attrs: { id: "vs" + e.uid + "__listbox", role: "listbox" } })]), e._v(" "), e._t("footer", null, null, e.scope.footer)], 2);
      }, [], !1, null, null, null).exports,
          _ = { ajax: u, pointer: c, pointerScroll: l },
          O = m;
    }(), o;
  }();
});
//# sourceMappingURL=vue-select.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "THEY":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "TNV1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "TYuA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column, ascending) {
  this.orderBy.column = column;
  this.orderBy.ascending = ascending;
  this.updateState('orderBy', {
    column: column,
    ascending: ascending
  });

  if (this.source == 'server') {
    this.getData();
  }
};

/***/ }),

/***/ "TkWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__("YP8Q");
var minAssert = __webpack_require__("08Lv");
var minUtils = __webpack_require__("tpuU");

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  naf.fill(0);

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (var i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),

/***/ "Tkxy":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gCWN");
module.exports = __webpack_require__("4DQ7").f('toStringTag');


/***/ }),

/***/ "TnCn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(map).forEach(function (key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key) key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__("C1C2");

/***/ }),

/***/ "TtgO":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gCWN");
__webpack_require__("+3lO");
__webpack_require__("5Fj8");
__webpack_require__("1I8z");
__webpack_require__("EqE1");
module.exports = __webpack_require__("iANj").WeakMap;


/***/ }),

/***/ "U6yG":
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),

/***/ "UBa7":
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),

/***/ "UPHp":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),

/***/ "UZwE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (e) {
  this.limit = _typeof(e) === 'object' ? e.target.value : e;
  this.updateState('perPage', this.limit);
  this.dispatch('limit', parseInt(this.limit));
  this.setPage(1);
};

/***/ }),

/***/ "UcPO":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("vzCy").EventEmitter;


/***/ }),

/***/ "UeD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
  if (this.$scopedSlots && this.$scopedSlots['__group_meta']) {
    var data = this.opts.groupMeta.find(function (val) {
      return val.value === value;
    });
    if (!data) return '';
    return this.$scopedSlots['__group_meta'](data);
  }

  return '';
};

/***/ }),

/***/ "Uy0O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__("GCs6");
var createDesc = __webpack_require__("YTz9");

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ "V19p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var customQueries = {};
  var init = this.opts.initFilters;
  var key;
  this.opts.customFilters.forEach(function (filter) {
    key = this.source == 'client' ? filter.name : filter;
    customQueries[key] = init.hasOwnProperty(key) ? init[key] : '';
  }.bind(this));
  return customQueries;
};

/***/ }),

/***/ "V8zm":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("dK5q");
module.exports = __webpack_require__("iANj").Object.getPrototypeOf;


/***/ }),

/***/ "VD8v":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("x//u");
var toObject = __webpack_require__("wXdB");
var IE_PROTO = __webpack_require__("+SdG")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "VI/i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__("rOku")
exports.createHash = exports.Hash = __webpack_require__("BVsN")
exports.createHmac = exports.Hmac = __webpack_require__("ARY+")

var algos = __webpack_require__("O+gO")
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__("/vd3")
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__("VKDQ")

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__("PBsE")

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__("KeN/")

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__("gw8B")

var publicEncrypt = __webpack_require__("9P96")

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__("4R/o")

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),

/***/ "VKDQ":
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__("IRek")
var aes = __webpack_require__("tXf9")
var aesModes = __webpack_require__("BCiZ")
var desModes = __webpack_require__("UBa7")
var ebtk = __webpack_require__("Cgw8")

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "VLty":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  listColumnsObject: __webpack_require__("Maik"),
  allColumns: __webpack_require__("W7X5"),
  templatesKeys: __webpack_require__("5Bi6"),
  opts: __webpack_require__("uX6Q"),
  tableData: __webpack_require__("gm4B"),
  storage: __webpack_require__("ZBwx"),
  filterableColumns: __webpack_require__("o06D"),
  datepickerColumns: __webpack_require__("wCqX"),
  hasChildRow: __webpack_require__("vWnj"),
  colspan: __webpack_require__("ufPk"),
  hasGenericFilter: __webpack_require__("zUbF"),
  stateKey: function stateKey() {
    var key = this.name ? this.name : this.id;
    return 'vuetables_' + key;
  },
  Page: function Page() {
    return this.page;
  }
};

/***/ }),

/***/ "VU/8":
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "VqvS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__("LC74");

var DEREncoder = __webpack_require__("ps4E");

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = ['-----BEGIN ' + options.label + '-----'];
  for (var i = 0; i < p.length; i += 64) {
    out.push(p.slice(i, i + 64));
  }out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};

/***/ }),

/***/ "VtkY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (row, column) {
  if (column.indexOf('.') === -1) return row[column];
  var p = column.split('.');
  var value = row[p[0]];
  if (!value) return '';

  for (var i = 1; i < p.length; i++) {
    value = value[p[i]]; // If the nested structure doesn't exist return an empty string

    if (typeof value === 'undefined') return '';
  }

  return value;
};

/***/ }),

/***/ "W1rN":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.ClipboardJS=e():t.ClipboardJS=e()}(this,function(){return n={686:function(t,e,n){"use strict";n.d(e,{default:function(){return b}});var e=n(279),i=n.n(e),e=n(370),u=n.n(e),e=n(817),r=n.n(e);function c(t){try{return document.execCommand(t)}catch(t){return}}var a=function(t){t=r()(t);return c("cut"),t};function o(t,e){var n,o,t=(n=t,o="rtl"===document.documentElement.getAttribute("dir"),(t=document.createElement("textarea")).style.fontSize="12pt",t.style.border="0",t.style.padding="0",t.style.margin="0",t.style.position="absolute",t.style[o?"right":"left"]="-9999px",o=window.pageYOffset||document.documentElement.scrollTop,t.style.top="".concat(o,"px"),t.setAttribute("readonly",""),t.value=n,t);return e.container.appendChild(t),e=r()(t),c("copy"),t.remove(),e}var f=function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{container:document.body},n="";return"string"==typeof t?n=o(t,e):t instanceof HTMLInputElement&&!["text","search","url","tel","password"].includes(null==t?void 0:t.type)?n=o(t.value,e):(n=r()(t),c("copy")),n};function l(t){return(l="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}var s=function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},e=t.action,n=void 0===e?"copy":e,o=t.container,e=t.target,t=t.text;if("copy"!==n&&"cut"!==n)throw new Error('Invalid "action" value, use either "copy" or "cut"');if(void 0!==e){if(!e||"object"!==l(e)||1!==e.nodeType)throw new Error('Invalid "target" value, use a valid Element');if("copy"===n&&e.hasAttribute("disabled"))throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');if("cut"===n&&(e.hasAttribute("readonly")||e.hasAttribute("disabled")))throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes')}return t?f(t,{container:o}):e?"cut"===n?a(e):f(e,{container:o}):void 0};function p(t){return(p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function d(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function y(t,e){return(y=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function h(n){var o=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=v(n);return t=o?(t=v(this).constructor,Reflect.construct(e,arguments,t)):e.apply(this,arguments),e=this,!(t=t)||"object"!==p(t)&&"function"!=typeof t?function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(e):t}}function v(t){return(v=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function m(t,e){t="data-clipboard-".concat(t);if(e.hasAttribute(t))return e.getAttribute(t)}var b=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&y(t,e)}(r,i());var t,e,n,o=h(r);function r(t,e){var n;return function(t){if(!(t instanceof r))throw new TypeError("Cannot call a class as a function")}(this),(n=o.call(this)).resolveOptions(e),n.listenClick(t),n}return t=r,n=[{key:"copy",value:function(t){var e=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{container:document.body};return f(t,e)}},{key:"cut",value:function(t){return a(t)}},{key:"isSupported",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:["copy","cut"],t="string"==typeof t?[t]:t,e=!!document.queryCommandSupported;return t.forEach(function(t){e=e&&!!document.queryCommandSupported(t)}),e}}],(e=[{key:"resolveOptions",value:function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{};this.action="function"==typeof t.action?t.action:this.defaultAction,this.target="function"==typeof t.target?t.target:this.defaultTarget,this.text="function"==typeof t.text?t.text:this.defaultText,this.container="object"===p(t.container)?t.container:document.body}},{key:"listenClick",value:function(t){var e=this;this.listener=u()(t,"click",function(t){return e.onClick(t)})}},{key:"onClick",value:function(t){var e=t.delegateTarget||t.currentTarget,n=this.action(e)||"copy",t=s({action:n,container:this.container,target:this.target(e),text:this.text(e)});this.emit(t?"success":"error",{action:n,text:t,trigger:e,clearSelection:function(){e&&e.focus(),window.getSelection().removeAllRanges()}})}},{key:"defaultAction",value:function(t){return m("action",t)}},{key:"defaultTarget",value:function(t){t=m("target",t);if(t)return document.querySelector(t)}},{key:"defaultText",value:function(t){return m("text",t)}},{key:"destroy",value:function(){this.listener.destroy()}}])&&d(t.prototype,e),n&&d(t,n),r}()},828:function(t){var e;"undefined"==typeof Element||Element.prototype.matches||((e=Element.prototype).matches=e.matchesSelector||e.mozMatchesSelector||e.msMatchesSelector||e.oMatchesSelector||e.webkitMatchesSelector),t.exports=function(t,e){for(;t&&9!==t.nodeType;){if("function"==typeof t.matches&&t.matches(e))return t;t=t.parentNode}}},438:function(t,e,n){var u=n(828);function i(t,e,n,o,r){var i=function(e,n,t,o){return function(t){t.delegateTarget=u(t.target,n),t.delegateTarget&&o.call(e,t)}}.apply(this,arguments);return t.addEventListener(n,i,r),{destroy:function(){t.removeEventListener(n,i,r)}}}t.exports=function(t,e,n,o,r){return"function"==typeof t.addEventListener?i.apply(null,arguments):"function"==typeof n?i.bind(null,document).apply(null,arguments):("string"==typeof t&&(t=document.querySelectorAll(t)),Array.prototype.map.call(t,function(t){return i(t,e,n,o,r)}))}},879:function(t,n){n.node=function(t){return void 0!==t&&t instanceof HTMLElement&&1===t.nodeType},n.nodeList=function(t){var e=Object.prototype.toString.call(t);return void 0!==t&&("[object NodeList]"===e||"[object HTMLCollection]"===e)&&"length"in t&&(0===t.length||n.node(t[0]))},n.string=function(t){return"string"==typeof t||t instanceof String},n.fn=function(t){return"[object Function]"===Object.prototype.toString.call(t)}},370:function(t,e,n){var f=n(879),l=n(438);t.exports=function(t,e,n){if(!t&&!e&&!n)throw new Error("Missing required arguments");if(!f.string(e))throw new TypeError("Second argument must be a String");if(!f.fn(n))throw new TypeError("Third argument must be a Function");if(f.node(t))return c=e,a=n,(u=t).addEventListener(c,a),{destroy:function(){u.removeEventListener(c,a)}};if(f.nodeList(t))return o=t,r=e,i=n,Array.prototype.forEach.call(o,function(t){t.addEventListener(r,i)}),{destroy:function(){Array.prototype.forEach.call(o,function(t){t.removeEventListener(r,i)})}};if(f.string(t))return t=t,e=e,n=n,l(document.body,t,e,n);throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");var o,r,i,u,c,a}},817:function(t){t.exports=function(t){var e,n="SELECT"===t.nodeName?(t.focus(),t.value):"INPUT"===t.nodeName||"TEXTAREA"===t.nodeName?((e=t.hasAttribute("readonly"))||t.setAttribute("readonly",""),t.select(),t.setSelectionRange(0,t.value.length),e||t.removeAttribute("readonly"),t.value):(t.hasAttribute("contenteditable")&&t.focus(),n=window.getSelection(),(e=document.createRange()).selectNodeContents(t),n.removeAllRanges(),n.addRange(e),n.toString());return n}},279:function(t){function e(){}e.prototype={on:function(t,e,n){var o=this.e||(this.e={});return(o[t]||(o[t]=[])).push({fn:e,ctx:n}),this},once:function(t,e,n){var o=this;function r(){o.off(t,r),e.apply(n,arguments)}return r._=e,this.on(t,r,n)},emit:function(t){for(var e=[].slice.call(arguments,1),n=((this.e||(this.e={}))[t]||[]).slice(),o=0,r=n.length;o<r;o++)n[o].fn.apply(n[o].ctx,e);return this},off:function(t,e){var n=this.e||(this.e={}),o=n[t],r=[];if(o&&e)for(var i=0,u=o.length;i<u;i++)o[i].fn!==e&&o[i].fn._!==e&&r.push(o[i]);return r.length?n[t]=r:delete n[t],this}},t.exports=e,t.exports.TinyEmitter=e}},r={},o.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return o.d(e,{a:e}),e},o.d=function(t,e){for(var n in e)o.o(e,n)&&!o.o(t,n)&&Object.defineProperty(t,n,{enumerable:!0,get:e[n]})},o.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},o(686).default;function o(t){if(r[t])return r[t].exports;var e=r[t]={exports:{}};return n[t](e,e.exports,o),e.exports}var n,r});

/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "W2zL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__("EuP9"),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__(4),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ "W52Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    framework: 'bootstrap3',
    table: 'table table-striped table-bordered table-hover',
    row: 'row',
    column: 'col-md-12',
    label: '',
    input: 'form-control',
    select: 'form-control',
    field: 'form-group',
    inline: 'form-inline',
    right: 'pull-right',
    left: 'pull-left',
    center: 'text-center',
    contentCenter: '',
    small: '',
    nomargin: '',
    groupTr: 'info',
    button: 'btn btn-secondary',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-toggle',
      menu: 'dropdown-menu',
      content: '',
      item: '',
      caret: 'caret'
    },
    pagination: {
      nav: '',
      count: '',
      wrapper: '',
      list: 'pagination',
      item: 'page-item',
      link: 'page-link',
      next: '',
      prev: '',
      active: 'active',
      disabled: 'disabled'
    }
  };
};

/***/ }),

/***/ "W6Rd":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "W7X5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var _this = this;

  var display = this.columnsDisplay; // default - return all columns

  if (!display && !this.userControlsColumns) {
    return this.Columns.filter(function (col) {
      return _this._shouldShowColumnOnInit(col);
    });
  } // user toggled columns - return user selected columns


  if (this.userControlsColumns) {
    return this.columns.filter(function (column) {
      return _this.userColumnsDisplay.includes(column);
    });
  }

  if (this.opts.ssr) return this.Columns; // developer defined columns display

  return this.Columns.filter(function (column) {
    if (!_this._shouldShowColumnOnInit(column)) {
      return false;
    }

    if (!display[column]) return true;
    var range = display[column];
    var operator = range[2];
    var inRange = (!range[0] || _this.windowWidth >= range[0]) && (!range[1] || _this.windowWidth < range[1]);
    return operator == 'not' ? !inRange : inRange;
  });
};

/***/ }),

/***/ "WER7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("PiFy");
var GetIntrinsic = __webpack_require__("7ar3");

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),

/***/ "Wdy1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var core = __webpack_require__("iANj");
var ctx = __webpack_require__("3fMt");
var hide = __webpack_require__("aLzV");
var has = __webpack_require__("x//u");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "WeAp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var is_empty = __webpack_require__("SjlN");

var registerVuexModule = __webpack_require__("xuei");

module.exports = function (self) {
  if (self.vuex) {
    registerVuexModule(self);
  } else {
    self.limit = self.opts.perPage;
  }

  if (is_empty(self.opts.columnsDisplay) || typeof window === 'undefined') return;
  self.columnsDisplay = getColumnsDisplay(self.opts.columnsDisplay);
  window.addEventListener('resize', function () {
    self.windowWidth = window.innerWidth;
  }.bind(self));
};

function getColumnsDisplay(columnsDisplay) {
  var res = {};
  var range;
  var device;
  var operator;

  for (var column in columnsDisplay) {
    operator = getOperator(columnsDisplay[column]);

    try {
      device = getDevice(columnsDisplay[column]);
      range = getRange(device, operator);
      res[column] = range.concat([operator]);
    } catch (err) {
      console.warn('Unknown device ' + device);
    }
  }

  return res;
}

function getRange(device, operator) {
  var devices = {
    desktop: [1024, null],
    tablet: [480, 1024],
    mobile: [0, 480],
    tabletL: [768, 1024],
    tabletP: [480, 768],
    mobileL: [320, 480],
    mobileP: [0, 320]
  };

  switch (operator) {
    case 'min':
      return [devices[device][0], null];

    case 'max':
      return [0, devices[device][1]];

    default:
      return devices[device];
  }
}

function getOperator(val) {
  var pieces = val.split('_');
  if (['not', 'min', 'max'].indexOf(pieces[0]) > -1) return pieces[0];
  return false;
}

function getDevice(val) {
  var pieces = val.split('_');
  return pieces.length > 1 ? pieces[1] : pieces[0];
}

/***/ }),

/***/ "WrlE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var codes = {};

function createErrorType(code, message, Base) {
  if (!Base) {
    Base = Error;
  }

  function getMessage(arg1, arg2, arg3) {
    if (typeof message === 'string') {
      return message;
    } else {
      return message(arg1, arg2, arg3);
    }
  }

  var NodeError =
  /*#__PURE__*/
  function (_Base) {
    _inheritsLoose(NodeError, _Base);

    function NodeError(arg1, arg2, arg3) {
      return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
    }

    return NodeError;
  }(Base);

  NodeError.prototype.name = Base.name;
  NodeError.prototype.code = code;
  codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js


function oneOf(expected, thing) {
  if (Array.isArray(expected)) {
    var len = expected.length;
    expected = expected.map(function (i) {
      return String(i);
    });

    if (len > 2) {
      return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
    } else if (len === 2) {
      return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
    } else {
      return "of ".concat(thing, " ").concat(expected[0]);
    }
  } else {
    return "of ".concat(thing, " ").concat(String(expected));
  }
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith


function startsWith(str, search, pos) {
  return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith


function endsWith(str, search, this_len) {
  if (this_len === undefined || this_len > str.length) {
    this_len = str.length;
  }

  return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes


function includes(str, search, start) {
  if (typeof start !== 'number') {
    start = 0;
  }

  if (start + search.length > str.length) {
    return false;
  } else {
    return str.indexOf(search, start) !== -1;
  }
}

createErrorType('ERR_INVALID_OPT_VALUE', function (name, value) {
  return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
createErrorType('ERR_INVALID_ARG_TYPE', function (name, expected, actual) {
  // determiner: 'must be' or 'must not be'
  var determiner;

  if (typeof expected === 'string' && startsWith(expected, 'not ')) {
    determiner = 'must not be';
    expected = expected.replace(/^not /, '');
  } else {
    determiner = 'must be';
  }

  var msg;

  if (endsWith(name, ' argument')) {
    // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  } else {
    var type = includes(name, '.') ? 'property' : 'argument';
    msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat(oneOf(expected, 'type'));
  }

  msg += ". Received type ".concat(typeof actual);
  return msg;
}, TypeError);
createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function (name) {
  return 'The ' + name + ' method is not implemented';
});
createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
createErrorType('ERR_STREAM_DESTROYED', function (name) {
  return 'Cannot call ' + name + ' after a stream was destroyed';
});
createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
createErrorType('ERR_UNKNOWN_ENCODING', function (arg) {
  return 'Unknown encoding: ' + arg;
}, TypeError);
createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
module.exports.codes = codes;


/***/ }),

/***/ "X+g4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("1h2p"), __esModule: true };

/***/ }),

/***/ "X+jS":
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__("2m2c");
var gOPS = __webpack_require__("THEY");
var anObject = __webpack_require__("FKWp");
var Reflect = __webpack_require__("YjQv").Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),

/***/ "X3l8":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("EuP9")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "X4X3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__("X3l8").Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "XFB5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("TtgO"), __esModule: true };

/***/ }),

/***/ "XfW5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("PiFy");

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ "XgCd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ "XmWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("KCLY");
var utils = __webpack_require__("cGG2");
var InterceptorManager = __webpack_require__("fuGk");
var dispatchRequest = __webpack_require__("xLtR");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "XpKz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var validMoment = __webpack_require__("xd7m");

module.exports = function (value, dateFormat) {
  if (!validMoment(value)) return value;
  return value.format(dateFormat);
};

/***/ }),

/***/ "Xxa5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("1H6C");


/***/ }),

/***/ "YMM6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__("eaCm");
var validate = __webpack_require__("fTPD");
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__("1jZ2")(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ "YP8Q":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(7).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "YQyn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("LC74")
var Buffer = __webpack_require__("X3l8").Buffer

var Base = __webpack_require__("z+8S")

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),

/***/ "YSDb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var assert = __webpack_require__("08Lv");

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),

/***/ "YTz9":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "YcM/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var methods = __webpack_require__("unUJ");

var computed = __webpack_require__("VLty");

var beforeDestroy = __webpack_require__("xhre");

function _default() {
  return {
    methods: methods,
    computed: computed,
    beforeDestroy: beforeDestroy
  };
}

/***/ }),

/***/ "YePo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");
var inherits = __webpack_require__("LC74");

var Cipher = __webpack_require__("AWjC");
var DES = __webpack_require__("Icsf");

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),

/***/ "YjQv":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "Yy+Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var _this = this;

  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!this.opts.childRow || typeof this.opts.childRow === 'function') {
    throw new Error('vue-tables-2: Child row undefined or not a component');
  }

  var Rows = rows ? this.openChildRows.filter(function (row) {
    return rows.includes(row);
  }) : this.openChildRows;
  if (!Rows.length) return [];
  var components = this.$children.filter(function (child) {
    return child.$options.name === 'ChildRow' && Rows.includes(child.data[_this.opts.uniqueKey]);
  });
  return components;
};

/***/ }),

/***/ "Z7yx":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "ZBoF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data, customFilters, customQueries) {
  var passing;
  return data.filter(function (row) {
    passing = true;
    customFilters.forEach(function (filter) {
      var value = customQueries[filter.name];
      if (value && !filter.callback(row, value)) passing = false;
    });
    return passing;
  });
};

/***/ }),

/***/ "ZBwx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  if (typeof localStorage === 'undefined') return {};
  return this.opts.storage === 'local' ? localStorage : sessionStorage;
};

/***/ }),

/***/ "ZEc8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = __webpack_require__("EuP9"),
  Buffer = _require.Buffer;
var _require2 = __webpack_require__(9),
  inspect = _require2.inspect;
var custom = inspect && inspect.custom || 'inspect';
function copyBuffer(src, target, offset) {
  Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/function () {
  function BufferList() {
    _classCallCheck(this, BufferList);
    this.head = null;
    this.tail = null;
    this.length = 0;
  }
  _createClass(BufferList, [{
    key: "push",
    value: function push(v) {
      var entry = {
        data: v,
        next: null
      };
      if (this.length > 0) this.tail.next = entry;else this.head = entry;
      this.tail = entry;
      ++this.length;
    }
  }, {
    key: "unshift",
    value: function unshift(v) {
      var entry = {
        data: v,
        next: this.head
      };
      if (this.length === 0) this.tail = entry;
      this.head = entry;
      ++this.length;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this.length === 0) return;
      var ret = this.head.data;
      if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
      --this.length;
      return ret;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.head = this.tail = null;
      this.length = 0;
    }
  }, {
    key: "join",
    value: function join(s) {
      if (this.length === 0) return '';
      var p = this.head;
      var ret = '' + p.data;
      while (p = p.next) ret += s + p.data;
      return ret;
    }
  }, {
    key: "concat",
    value: function concat(n) {
      if (this.length === 0) return Buffer.alloc(0);
      var ret = Buffer.allocUnsafe(n >>> 0);
      var p = this.head;
      var i = 0;
      while (p) {
        copyBuffer(p.data, ret, i);
        i += p.data.length;
        p = p.next;
      }
      return ret;
    }

    // Consumes a specified amount of bytes or characters from the buffered data.
  }, {
    key: "consume",
    value: function consume(n, hasStrings) {
      var ret;
      if (n < this.head.data.length) {
        // `slice` is the same for buffers and strings.
        ret = this.head.data.slice(0, n);
        this.head.data = this.head.data.slice(n);
      } else if (n === this.head.data.length) {
        // First chunk is a perfect match.
        ret = this.shift();
      } else {
        // Result spans more than one buffer.
        ret = hasStrings ? this._getString(n) : this._getBuffer(n);
      }
      return ret;
    }
  }, {
    key: "first",
    value: function first() {
      return this.head.data;
    }

    // Consumes a specified amount of characters from the buffered data.
  }, {
    key: "_getString",
    value: function _getString(n) {
      var p = this.head;
      var c = 1;
      var ret = p.data;
      n -= ret.length;
      while (p = p.next) {
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
          if (nb === str.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = str.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Consumes a specified amount of bytes from the buffered data.
  }, {
    key: "_getBuffer",
    value: function _getBuffer(n) {
      var ret = Buffer.allocUnsafe(n);
      var p = this.head;
      var c = 1;
      p.data.copy(ret);
      n -= p.data.length;
      while (p = p.next) {
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
          if (nb === buf.length) {
            ++c;
            if (p.next) this.head = p.next;else this.head = this.tail = null;
          } else {
            this.head = p;
            p.data = buf.slice(nb);
          }
          break;
        }
        ++c;
      }
      this.length -= c;
      return ret;
    }

    // Make sure the linked list only shows the minimal necessary information.
  }, {
    key: custom,
    value: function value(_, options) {
      return inspect(this, _objectSpread(_objectSpread({}, options), {}, {
        // Only inspect one level.
        depth: 0,
        // It should not recurse.
        customInspect: false
      }));
    }
  }]);
  return BufferList;
}();

/***/ }),

/***/ "ZZjE":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*!
 * validate.js 0.12.0
 *
 * (c) 2013-2017 Nicklas Ansman, 2013 Wrapp
 * Validate.js may be freely distributed under the MIT license.
 * For all details and documentation:
 * http://validatejs.org/
 */

(function(exports, module, define) {
  "use strict";

  // The main function that calls the validators specified by the constraints.
  // The options are the following:
  //   - format (string) - An option that controls how the returned value is formatted
  //     * flat - Returns a flat array of just the error messages
  //     * grouped - Returns the messages grouped by attribute (default)
  //     * detailed - Returns an array of the raw validation data
  //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
  //
  // Please note that the options are also passed to each validator.
  var validate = function(attributes, constraints, options) {
    options = v.extend({}, v.options, options);

    var results = v.runValidations(attributes, constraints, options)
      , attr
      , validator;

    if (results.some(function(r) { return v.isPromise(r.error); })) {
      throw new Error("Use validate.async if you want support for promises");
    }
    return validate.processValidationResults(results, options);
  };

  var v = validate;

  // Copies over attributes from one or more sources to a single destination.
  // Very much similar to underscore's extend.
  // The first argument is the target object and the remaining arguments will be
  // used as sources.
  v.extend = function(obj) {
    [].slice.call(arguments, 1).forEach(function(source) {
      for (var attr in source) {
        obj[attr] = source[attr];
      }
    });
    return obj;
  };

  v.extend(validate, {
    // This is the version of the library as a semver.
    // The toString function will allow it to be coerced into a string
    version: {
      major: 0,
      minor: 12,
      patch: 0,
      metadata: null,
      toString: function() {
        var version = v.format("%{major}.%{minor}.%{patch}", v.version);
        if (!v.isEmpty(v.version.metadata)) {
          version += "+" + v.version.metadata;
        }
        return version;
      }
    },

    // Below is the dependencies that are used in validate.js

    // The constructor of the Promise implementation.
    // If you are using Q.js, RSVP or any other A+ compatible implementation
    // override this attribute to be the constructor of that promise.
    // Since jQuery promises aren't A+ compatible they won't work.
    Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,

    EMPTY_STRING_REGEXP: /^\s*$/,

    // Runs the validators specified by the constraints object.
    // Will return an array of the format:
    //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
    runValidations: function(attributes, constraints, options) {
      var results = []
        , attr
        , validatorName
        , value
        , validators
        , validator
        , validatorOptions
        , error;

      if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
        attributes = v.collectFormValues(attributes);
      }

      // Loops through each constraints, finds the correct validator and run it.
      for (attr in constraints) {
        value = v.getDeepObjectValue(attributes, attr);
        // This allows the constraints for an attribute to be a function.
        // The function will be called with the value, attribute name, the complete dict of
        // attributes as well as the options and constraints passed in.
        // This is useful when you want to have different
        // validations depending on the attribute value.
        validators = v.result(constraints[attr], value, attributes, attr, options, constraints);

        for (validatorName in validators) {
          validator = v.validators[validatorName];

          if (!validator) {
            error = v.format("Unknown validator %{name}", {name: validatorName});
            throw new Error(error);
          }

          validatorOptions = validators[validatorName];
          // This allows the options to be a function. The function will be
          // called with the value, attribute name, the complete dict of
          // attributes as well as the options and constraints passed in.
          // This is useful when you want to have different
          // validations depending on the attribute value.
          validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
          if (!validatorOptions) {
            continue;
          }
          results.push({
            attribute: attr,
            value: value,
            validator: validatorName,
            globalOptions: options,
            attributes: attributes,
            options: validatorOptions,
            error: validator.call(validator,
                value,
                validatorOptions,
                attr,
                attributes,
                options)
          });
        }
      }

      return results;
    },

    // Takes the output from runValidations and converts it to the correct
    // output format.
    processValidationResults: function(errors, options) {
      errors = v.pruneEmptyErrors(errors, options);
      errors = v.expandMultipleErrors(errors, options);
      errors = v.convertErrorMessages(errors, options);

      var format = options.format || "grouped";

      if (typeof v.formatters[format] === 'function') {
        errors = v.formatters[format](errors);
      } else {
        throw new Error(v.format("Unknown format %{format}", options));
      }

      return v.isEmpty(errors) ? undefined : errors;
    },

    // Runs the validations with support for promises.
    // This function will return a promise that is settled when all the
    // validation promises have been completed.
    // It can be called even if no validations returned a promise.
    async: function(attributes, constraints, options) {
      options = v.extend({}, v.async.options, options);

      var WrapErrors = options.wrapErrors || function(errors) {
        return errors;
      };

      // Removes unknown attributes
      if (options.cleanAttributes !== false) {
        attributes = v.cleanAttributes(attributes, constraints);
      }

      var results = v.runValidations(attributes, constraints, options);

      return new v.Promise(function(resolve, reject) {
        v.waitForResults(results).then(function() {
          var errors = v.processValidationResults(results, options);
          if (errors) {
            reject(new WrapErrors(errors, options, attributes, constraints));
          } else {
            resolve(attributes);
          }
        }, function(err) {
          reject(err);
        });
      });
    },

    single: function(value, constraints, options) {
      options = v.extend({}, v.single.options, options, {
        format: "flat",
        fullMessages: false
      });
      return v({single: value}, {single: constraints}, options);
    },

    // Returns a promise that is resolved when all promises in the results array
    // are settled. The promise returned from this function is always resolved,
    // never rejected.
    // This function modifies the input argument, it replaces the promises
    // with the value returned from the promise.
    waitForResults: function(results) {
      // Create a sequence of all the results starting with a resolved promise.
      return results.reduce(function(memo, result) {
        // If this result isn't a promise skip it in the sequence.
        if (!v.isPromise(result.error)) {
          return memo;
        }

        return memo.then(function() {
          return result.error.then(function(error) {
            result.error = error || null;
          });
        });
      }, new v.Promise(function(r) { r(); })); // A resolved promise
    },

    // If the given argument is a call: function the and: function return the value
    // otherwise just return the value. Additional arguments will be passed as
    // arguments to the function.
    // Example:
    // ```
    // result('foo') // 'foo'
    // result(Math.max, 1, 2) // 2
    // ```
    result: function(value) {
      var args = [].slice.call(arguments, 1);
      if (typeof value === 'function') {
        value = value.apply(null, args);
      }
      return value;
    },

    // Checks if the value is a number. This function does not consider NaN a
    // number like many other `isNumber` functions do.
    isNumber: function(value) {
      return typeof value === 'number' && !isNaN(value);
    },

    // Returns false if the object is not a function
    isFunction: function(value) {
      return typeof value === 'function';
    },

    // A simple check to verify that the value is an integer. Uses `isNumber`
    // and a simple modulo check.
    isInteger: function(value) {
      return v.isNumber(value) && value % 1 === 0;
    },

    // Checks if the value is a boolean
    isBoolean: function(value) {
      return typeof value === 'boolean';
    },

    // Uses the `Object` function to check if the given argument is an object.
    isObject: function(obj) {
      return obj === Object(obj);
    },

    // Simply checks if the object is an instance of a date
    isDate: function(obj) {
      return obj instanceof Date;
    },

    // Returns false if the object is `null` of `undefined`
    isDefined: function(obj) {
      return obj !== null && obj !== undefined;
    },

    // Checks if the given argument is a promise. Anything with a `then`
    // function is considered a promise.
    isPromise: function(p) {
      return !!p && v.isFunction(p.then);
    },

    isJqueryElement: function(o) {
      return o && v.isString(o.jquery);
    },

    isDomElement: function(o) {
      if (!o) {
        return false;
      }

      if (!o.querySelectorAll || !o.querySelector) {
        return false;
      }

      if (v.isObject(document) && o === document) {
        return true;
      }

      // http://stackoverflow.com/a/384380/699304
      /* istanbul ignore else */
      if (typeof HTMLElement === "object") {
        return o instanceof HTMLElement;
      } else {
        return o &&
          typeof o === "object" &&
          o !== null &&
          o.nodeType === 1 &&
          typeof o.nodeName === "string";
      }
    },

    isEmpty: function(value) {
      var attr;

      // Null and undefined are empty
      if (!v.isDefined(value)) {
        return true;
      }

      // functions are non empty
      if (v.isFunction(value)) {
        return false;
      }

      // Whitespace only strings are empty
      if (v.isString(value)) {
        return v.EMPTY_STRING_REGEXP.test(value);
      }

      // For arrays we use the length property
      if (v.isArray(value)) {
        return value.length === 0;
      }

      // Dates have no attributes but aren't empty
      if (v.isDate(value)) {
        return false;
      }

      // If we find at least one property we consider it non empty
      if (v.isObject(value)) {
        for (attr in value) {
          return false;
        }
        return true;
      }

      return false;
    },

    // Formats the specified strings with the given values like so:
    // ```
    // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
    // ```
    // If you want to write %{...} without having it replaced simply
    // prefix it with % like this `Foo: %%{foo}` and it will be returned
    // as `"Foo: %{foo}"`
    format: v.extend(function(str, vals) {
      if (!v.isString(str)) {
        return str;
      }
      return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
        if (m1 === '%') {
          return "%{" + m2 + "}";
        } else {
          return String(vals[m2]);
        }
      });
    }, {
      // Finds %{key} style patterns in the given string
      FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
    }),

    // "Prettifies" the given string.
    // Prettifying means replacing [.\_-] with spaces as well as splitting
    // camel case words.
    prettify: function(str) {
      if (v.isNumber(str)) {
        // If there are more than 2 decimals round it to two
        if ((str * 100) % 1 === 0) {
          return "" + str;
        } else {
          return parseFloat(Math.round(str * 100) / 100).toFixed(2);
        }
      }

      if (v.isArray(str)) {
        return str.map(function(s) { return v.prettify(s); }).join(", ");
      }

      if (v.isObject(str)) {
        return str.toString();
      }

      // Ensure the string is actually a string
      str = "" + str;

      return str
        // Splits keys separated by periods
        .replace(/([^\s])\.([^\s])/g, '$1 $2')
        // Removes backslashes
        .replace(/\\+/g, '')
        // Replaces - and - with space
        .replace(/[_-]/g, ' ')
        // Splits camel cased words
        .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
          return "" + m1 + " " + m2.toLowerCase();
        })
        .toLowerCase();
    },

    stringifyValue: function(value, options) {
      var prettify = options && options.prettify || v.prettify;
      return prettify(value);
    },

    isString: function(value) {
      return typeof value === 'string';
    },

    isArray: function(value) {
      return {}.toString.call(value) === '[object Array]';
    },

    // Checks if the object is a hash, which is equivalent to an object that
    // is neither an array nor a function.
    isHash: function(value) {
      return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
    },

    contains: function(obj, value) {
      if (!v.isDefined(obj)) {
        return false;
      }
      if (v.isArray(obj)) {
        return obj.indexOf(value) !== -1;
      }
      return value in obj;
    },

    unique: function(array) {
      if (!v.isArray(array)) {
        return array;
      }
      return array.filter(function(el, index, array) {
        return array.indexOf(el) == index;
      });
    },

    forEachKeyInKeypath: function(object, keypath, callback) {
      if (!v.isString(keypath)) {
        return undefined;
      }

      var key = ""
        , i
        , escape = false;

      for (i = 0; i < keypath.length; ++i) {
        switch (keypath[i]) {
          case '.':
            if (escape) {
              escape = false;
              key += '.';
            } else {
              object = callback(object, key, false);
              key = "";
            }
            break;

          case '\\':
            if (escape) {
              escape = false;
              key += '\\';
            } else {
              escape = true;
            }
            break;

          default:
            escape = false;
            key += keypath[i];
            break;
        }
      }

      return callback(object, key, true);
    },

    getDeepObjectValue: function(obj, keypath) {
      if (!v.isObject(obj)) {
        return undefined;
      }

      return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
        if (v.isObject(obj)) {
          return obj[key];
        }
      });
    },

    // This returns an object with all the values of the form.
    // It uses the input name as key and the value as value
    // So for example this:
    // <input type="text" name="email" value="foo@bar.com" />
    // would return:
    // {email: "foo@bar.com"}
    collectFormValues: function(form, options) {
      var values = {}
        , i
        , j
        , input
        , inputs
        , option
        , value;

      if (v.isJqueryElement(form)) {
        form = form[0];
      }

      if (!form) {
        return values;
      }

      options = options || {};

      inputs = form.querySelectorAll("input[name], textarea[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);

        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        name = input.name.replace(/\./g, "\\\\.");
        value = v.sanitizeFormValue(input.value, options);
        if (input.type === "number") {
          value = value ? +value : null;
        } else if (input.type === "checkbox") {
          if (input.attributes.value) {
            if (!input.checked) {
              value = values[name] || null;
            }
          } else {
            value = input.checked;
          }
        } else if (input.type === "radio") {
          if (!input.checked) {
            value = values[name] || null;
          }
        }
        values[name] = value;
      }

      inputs = form.querySelectorAll("select[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);
        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        if (input.multiple) {
          value = [];
          for (j in input.options) {
            option = input.options[j];
             if (option && option.selected) {
              value.push(v.sanitizeFormValue(option.value, options));
            }
          }
        } else {
          var _val = typeof input.options[input.selectedIndex] !== 'undefined' ? input.options[input.selectedIndex].value : '';
          value = v.sanitizeFormValue(_val, options);
        }
        values[input.name] = value;
      }

      return values;
    },

    sanitizeFormValue: function(value, options) {
      if (options.trim && v.isString(value)) {
        value = value.trim();
      }

      if (options.nullify !== false && value === "") {
        return null;
      }
      return value;
    },

    capitalize: function(str) {
      if (!v.isString(str)) {
        return str;
      }
      return str[0].toUpperCase() + str.slice(1);
    },

    // Remove all errors who's error attribute is empty (null or undefined)
    pruneEmptyErrors: function(errors) {
      return errors.filter(function(error) {
        return !v.isEmpty(error.error);
      });
    },

    // In
    // [{error: ["err1", "err2"], ...}]
    // Out
    // [{error: "err1", ...}, {error: "err2", ...}]
    //
    // All attributes in an error with multiple messages are duplicated
    // when expanding the errors.
    expandMultipleErrors: function(errors) {
      var ret = [];
      errors.forEach(function(error) {
        // Removes errors without a message
        if (v.isArray(error.error)) {
          error.error.forEach(function(msg) {
            ret.push(v.extend({}, error, {error: msg}));
          });
        } else {
          ret.push(error);
        }
      });
      return ret;
    },

    // Converts the error mesages by prepending the attribute name unless the
    // message is prefixed by ^
    convertErrorMessages: function(errors, options) {
      options = options || {};

      var ret = []
        , prettify = options.prettify || v.prettify;
      errors.forEach(function(errorInfo) {
        var error = v.result(errorInfo.error,
            errorInfo.value,
            errorInfo.attribute,
            errorInfo.options,
            errorInfo.attributes,
            errorInfo.globalOptions);

        if (!v.isString(error)) {
          ret.push(errorInfo);
          return;
        }

        if (error[0] === '^') {
          error = error.slice(1);
        } else if (options.fullMessages !== false) {
          error = v.capitalize(prettify(errorInfo.attribute)) + " " + error;
        }
        error = error.replace(/\\\^/g, "^");
        error = v.format(error, {
          value: v.stringifyValue(errorInfo.value, options)
        });
        ret.push(v.extend({}, errorInfo, {error: error}));
      });
      return ret;
    },

    // In:
    // [{attribute: "<attributeName>", ...}]
    // Out:
    // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
    groupErrorsByAttribute: function(errors) {
      var ret = {};
      errors.forEach(function(error) {
        var list = ret[error.attribute];
        if (list) {
          list.push(error);
        } else {
          ret[error.attribute] = [error];
        }
      });
      return ret;
    },

    // In:
    // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
    // Out:
    // ["<message 1>", "<message 2>"]
    flattenErrorsToArray: function(errors) {
      return errors
        .map(function(error) { return error.error; })
        .filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
    },

    cleanAttributes: function(attributes, whitelist) {
      function whitelistCreator(obj, key, last) {
        if (v.isObject(obj[key])) {
          return obj[key];
        }
        return (obj[key] = last ? true : {});
      }

      function buildObjectWhitelist(whitelist) {
        var ow = {}
          , lastObject
          , attr;
        for (attr in whitelist) {
          if (!whitelist[attr]) {
            continue;
          }
          v.forEachKeyInKeypath(ow, attr, whitelistCreator);
        }
        return ow;
      }

      function cleanRecursive(attributes, whitelist) {
        if (!v.isObject(attributes)) {
          return attributes;
        }

        var ret = v.extend({}, attributes)
          , w
          , attribute;

        for (attribute in attributes) {
          w = whitelist[attribute];

          if (v.isObject(w)) {
            ret[attribute] = cleanRecursive(ret[attribute], w);
          } else if (!w) {
            delete ret[attribute];
          }
        }
        return ret;
      }

      if (!v.isObject(whitelist) || !v.isObject(attributes)) {
        return {};
      }

      whitelist = buildObjectWhitelist(whitelist);
      return cleanRecursive(attributes, whitelist);
    },

    exposeModule: function(validate, root, exports, module, define) {
      if (exports) {
        if (module && module.exports) {
          exports = module.exports = validate;
        }
        exports.validate = validate;
      } else {
        root.validate = validate;
        if (validate.isFunction(define) && define.amd) {
          define([], function () { return validate; });
        }
      }
    },

    warn: function(msg) {
      if (typeof console !== "undefined" && console.warn) {
        console.warn("[validate.js] " + msg);
      }
    },

    error: function(msg) {
      if (typeof console !== "undefined" && console.error) {
        console.error("[validate.js] " + msg);
      }
    }
  });

  validate.validators = {
    // Presence validates that the value isn't empty
    presence: function(value, options) {
      options = v.extend({}, this.options, options);
      if (options.allowEmpty !== false ? !v.isDefined(value) : v.isEmpty(value)) {
        return options.message || this.message || "can't be blank";
      }
    },
    length: function(value, options, attribute) {
      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var is = options.is
        , maximum = options.maximum
        , minimum = options.minimum
        , tokenizer = options.tokenizer || function(val) { return val; }
        , err
        , errors = [];

      value = tokenizer(value);
      var length = value.length;
      if(!v.isNumber(length)) {
        v.error(v.format("Attribute %{attr} has a non numeric value for `length`", {attr: attribute}));
        return options.message || this.notValid || "has an incorrect length";
      }

      // Is checks
      if (v.isNumber(is) && length !== is) {
        err = options.wrongLength ||
          this.wrongLength ||
          "is the wrong length (should be %{count} characters)";
        errors.push(v.format(err, {count: is}));
      }

      if (v.isNumber(minimum) && length < minimum) {
        err = options.tooShort ||
          this.tooShort ||
          "is too short (minimum is %{count} characters)";
        errors.push(v.format(err, {count: minimum}));
      }

      if (v.isNumber(maximum) && length > maximum) {
        err = options.tooLong ||
          this.tooLong ||
          "is too long (maximum is %{count} characters)";
        errors.push(v.format(err, {count: maximum}));
      }

      if (errors.length > 0) {
        return options.message || errors;
      }
    },
    numericality: function(value, options, attribute, attributes, globalOptions) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var errors = []
        , name
        , count
        , checks = {
            greaterThan:          function(v, c) { return v > c; },
            greaterThanOrEqualTo: function(v, c) { return v >= c; },
            equalTo:              function(v, c) { return v === c; },
            lessThan:             function(v, c) { return v < c; },
            lessThanOrEqualTo:    function(v, c) { return v <= c; },
            divisibleBy:          function(v, c) { return v % c === 0; }
          }
        , prettify = options.prettify ||
          (globalOptions && globalOptions.prettify) ||
          v.prettify;

      // Strict will check that it is a valid looking number
      if (v.isString(value) && options.strict) {
        var pattern = "^-?(0|[1-9]\\d*)";
        if (!options.onlyInteger) {
          pattern += "(\\.\\d+)?";
        }
        pattern += "$";

        if (!(new RegExp(pattern).test(value))) {
          return options.message ||
            options.notValid ||
            this.notValid ||
            this.message ||
            "must be a valid number";
        }
      }

      // Coerce the value to a number unless we're being strict.
      if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) {
        value = +value;
      }

      // If it's not a number we shouldn't continue since it will compare it.
      if (!v.isNumber(value)) {
        return options.message ||
          options.notValid ||
          this.notValid ||
          this.message ||
          "is not a number";
      }

      // Same logic as above, sort of. Don't bother with comparisons if this
      // doesn't pass.
      if (options.onlyInteger && !v.isInteger(value)) {
        return options.message ||
          options.notInteger ||
          this.notInteger ||
          this.message ||
          "must be an integer";
      }

      for (name in checks) {
        count = options[name];
        if (v.isNumber(count) && !checks[name](value, count)) {
          // This picks the default message if specified
          // For example the greaterThan check uses the message from
          // this.notGreaterThan so we capitalize the name and prepend "not"
          var key = "not" + v.capitalize(name);
          var msg = options[key] ||
            this[key] ||
            this.message ||
            "must be %{type} %{count}";

          errors.push(v.format(msg, {
            count: count,
            type: prettify(name)
          }));
        }
      }

      if (options.odd && value % 2 !== 1) {
        errors.push(options.notOdd ||
            this.notOdd ||
            this.message ||
            "must be odd");
      }
      if (options.even && value % 2 !== 0) {
        errors.push(options.notEven ||
            this.notEven ||
            this.message ||
            "must be even");
      }

      if (errors.length) {
        return options.message || errors;
      }
    },
    datetime: v.extend(function(value, options) {
      if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
        throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
      }

      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var err
        , errors = []
        , earliest = options.earliest ? this.parse(options.earliest, options) : NaN
        , latest = options.latest ? this.parse(options.latest, options) : NaN;

      value = this.parse(value, options);

      // 86400000 is the number of milliseconds in a day, this is used to remove
      // the time from the date
      if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
        err = options.notValid ||
          options.message ||
          this.notValid ||
          "must be a valid date";
        return v.format(err, {value: arguments[0]});
      }

      if (!isNaN(earliest) && value < earliest) {
        err = options.tooEarly ||
          options.message ||
          this.tooEarly ||
          "must be no earlier than %{date}";
        err = v.format(err, {
          value: this.format(value, options),
          date: this.format(earliest, options)
        });
        errors.push(err);
      }

      if (!isNaN(latest) && value > latest) {
        err = options.tooLate ||
          options.message ||
          this.tooLate ||
          "must be no later than %{date}";
        err = v.format(err, {
          date: this.format(latest, options),
          value: this.format(value, options)
        });
        errors.push(err);
      }

      if (errors.length) {
        return v.unique(errors);
      }
    }, {
      parse: null,
      format: null
    }),
    date: function(value, options) {
      options = v.extend({}, options, {dateOnly: true});
      return v.validators.datetime.call(v.validators.datetime, value, options);
    },
    format: function(value, options) {
      if (v.isString(options) || (options instanceof RegExp)) {
        options = {pattern: options};
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is invalid"
        , pattern = options.pattern
        , match;

      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }

      if (v.isString(pattern)) {
        pattern = new RegExp(options.pattern, options.flags);
      }
      match = pattern.exec(value);
      if (!match || match[0].length != value.length) {
        return message;
      }
    },
    inclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (v.contains(options.within, value)) {
        return;
      }
      var message = options.message ||
        this.message ||
        "^%{value} is not included in the list";
      return v.format(message, {value: value});
    },
    exclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (!v.contains(options.within, value)) {
        return;
      }
      var message = options.message || this.message || "^%{value} is restricted";
      return v.format(message, {value: value});
    },
    email: v.extend(function(value, options) {
      options = v.extend({}, this.options, options);
      var message = options.message || this.message || "is not a valid email";
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }
      if (!this.PATTERN.exec(value)) {
        return message;
      }
    }, {
      PATTERN: /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
    }),
    equality: function(value, options, attribute, attributes, globalOptions) {
      if (!v.isDefined(value)) {
        return;
      }

      if (v.isString(options)) {
        options = {attribute: options};
      }
      options = v.extend({}, this.options, options);
      var message = options.message ||
        this.message ||
        "is not equal to %{attribute}";

      if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
        throw new Error("The attribute must be a non empty string");
      }

      var otherValue = v.getDeepObjectValue(attributes, options.attribute)
        , comparator = options.comparator || function(v1, v2) {
          return v1 === v2;
        }
        , prettify = options.prettify ||
          (globalOptions && globalOptions.prettify) ||
          v.prettify;

      if (!comparator(value, otherValue, options, attribute, attributes)) {
        return v.format(message, {attribute: prettify(options.attribute)});
      }
    },

    // A URL validator that is used to validate URLs with the ability to
    // restrict schemes and some domains.
    url: function(value, options) {
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is not a valid url"
        , schemes = options.schemes || this.schemes || ['http', 'https']
        , allowLocal = options.allowLocal || this.allowLocal || false;

      if (!v.isString(value)) {
        return message;
      }

      // https://gist.github.com/dperini/729294
      var regex =
        "^" +
        // protocol identifier
        "(?:(?:" + schemes.join("|") + ")://)" +
        // user:pass authentication
        "(?:\\S+(?::\\S*)?@)?" +
        "(?:";

      var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";

      if (allowLocal) {
        tld += "?";
      } else {
        regex +=
          // IP address exclusion
          // private & local networks
          "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
          "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
          "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
      }

      regex +=
          // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broacast addresses
          // (first & last IP address of each class)
          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
          "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
          "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
        "|" +
          // host name
          "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
          // domain name
          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
          tld +
        ")" +
        // port number
        "(?::\\d{2,5})?" +
        // resource path
        "(?:[/?#]\\S*)?" +
      "$";

      var PATTERN = new RegExp(regex, 'i');
      if (!PATTERN.exec(value)) {
        return message;
      }
    }
  };

  validate.formatters = {
    detailed: function(errors) {return errors;},
    flat: v.flattenErrorsToArray,
    grouped: function(errors) {
      var attr;

      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = v.flattenErrorsToArray(errors[attr]);
      }
      return errors;
    },
    constraint: function(errors) {
      var attr;
      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = errors[attr].map(function(result) {
          return result.validator;
        }).sort();
      }
      return errors;
    }
  };

  validate.exposeModule(validate, this, exports, module, __webpack_require__("LGuY"));
}).call(this,
         true ? /* istanbul ignore next */ exports : null,
         true ? /* istanbul ignore next */ module : null,
        __webpack_require__("LGuY"));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "Zbun":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("iANj");
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ "ZhOs":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("rZAI");
module.exports = __webpack_require__("iANj").Object.keys;


/***/ }),

/***/ "Zoe1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("7ar3");
var callBound = __webpack_require__("gcUb");
var inspect = __webpack_require__("GybJ");

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

module.exports = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};


/***/ }),

/***/ "Zq1s":
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__("EXeW")
var RIPEMD160 = __webpack_require__("LYGd")
var sha = __webpack_require__("JaR3")
var Buffer = __webpack_require__("X3l8").Buffer

var checkParameters = __webpack_require__("2JY6")
var defaultEncoding = __webpack_require__("35aj")
var toBuffer = __webpack_require__("Ml+W")

var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(iterations, keylen)
  password = toBuffer(password, defaultEncoding, 'Password')
  salt = toBuffer(salt, defaultEncoding, 'Salt')

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),

/***/ "Zrlr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ "Ztz7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__("s83z");
var MillerRabin = __webpack_require__("aK3A");
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__("3fzc");
var randomBytes = __webpack_require__("rOku");
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "Zx67":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("V8zm"), __esModule: true };

/***/ }),

/***/ "Zzip":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BQO6"), __esModule: true };

/***/ }),

/***/ "a/OS":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("iANj");
var global = __webpack_require__("YjQv");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("c8Kh") ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "a1FJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Tkxy"), __esModule: true };

/***/ }),

/***/ "aDKb":
/***/ (function(module, exports, __webpack_require__) {

var Pagination = __webpack_require__("Midf");
var PaginationEvent = __webpack_require__("hdr4");

module.exports = {
  Pagination:Pagination,
  PaginationEvent:PaginationEvent
}


/***/ }),

/***/ "aK3A":
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__("LbEw");
var brorand = __webpack_require__("txgm");

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),

/***/ "aL0I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (page) {
  if (this.vuex) return;
  this.setPage(page);
  this.dispatch('pagination', page);
};

/***/ }),

/***/ "aLzV":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("GCs6");
var createDesc = __webpack_require__("YTz9");
module.exports = __webpack_require__("qs+f") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "aY2F":
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__("LC74")
var SHA512 = __webpack_require__("C015")
var Hash = __webpack_require__("CzQx")
var Buffer = __webpack_require__("X3l8").Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),

/***/ "aYMa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).



var eos;
function once(callback) {
  var called = false;
  return function () {
    if (called) return;
    called = true;
    callback.apply(void 0, arguments);
  };
}
var _require$codes = __webpack_require__("3U89").codes,
  ERR_MISSING_ARGS = _require$codes.ERR_MISSING_ARGS,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED;
function noop(err) {
  // Rethrow the error if it exists to avoid swallowing it
  if (err) throw err;
}
function isRequest(stream) {
  return stream.setHeader && typeof stream.abort === 'function';
}
function destroyer(stream, reading, writing, callback) {
  callback = once(callback);
  var closed = false;
  stream.on('close', function () {
    closed = true;
  });
  if (eos === undefined) eos = __webpack_require__("DvOT");
  eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    if (err) return callback(err);
    closed = true;
    callback();
  });
  var destroyed = false;
  return function (err) {
    if (closed) return;
    if (destroyed) return;
    destroyed = true;

    // request.destroy just do .end - .abort is what we want
    if (isRequest(stream)) return stream.abort();
    if (typeof stream.destroy === 'function') return stream.destroy();
    callback(err || new ERR_STREAM_DESTROYED('pipe'));
  };
}
function call(fn) {
  fn();
}
function pipe(from, to) {
  return from.pipe(to);
}
function popCallback(streams) {
  if (!streams.length) return noop;
  if (typeof streams[streams.length - 1] !== 'function') return noop;
  return streams.pop();
}
function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }
  var callback = popCallback(streams);
  if (Array.isArray(streams[0])) streams = streams[0];
  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }
  var error;
  var destroys = streams.map(function (stream, i) {
    var reading = i < streams.length - 1;
    var writing = i > 0;
    return destroyer(stream, reading, writing, function (err) {
      if (!error) error = err;
      if (err) destroys.forEach(call);
      if (reading) return;
      destroys.forEach(call);
      callback(error);
    });
  });
  return streams.reduce(pipe);
}
module.exports = pipeline;

/***/ }),

/***/ "abPz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("Aq0r");
var step = __webpack_require__("beh1");
var Iterators = __webpack_require__("yYxz");
var toIObject = __webpack_require__("ksFB");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("4dmN")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "acwh":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("sFQN");
module.exports = __webpack_require__("iANj").Math.imul;


/***/ }),

/***/ "ahRw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  if (!this.opts.filterable) return false;
  return typeof this.opts.filterable == 'boolean' && this.opts.filterable || this.opts.filterable.indexOf(column) > -1;
};

/***/ }),

/***/ "bMQ9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var common = __webpack_require__("YSDb");
var shaCommon = __webpack_require__("3nYK");

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),

/***/ "bOdI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "bSQl":
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__("BCiZ")
var AuthCipher = __webpack_require__("/y0r")
var Buffer = __webpack_require__("X3l8").Buffer
var StreamCipher = __webpack_require__("6hW9")
var Transform = __webpack_require__("z+8S")
var aes = __webpack_require__("BEbT")
var ebtk = __webpack_require__("Cgw8")
var inherits = __webpack_require__("LC74")

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),

/***/ "bSeU":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "beh1":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "bfKe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var userMultiSort = Object.keys(this.userMultiSorting);
  if (!userMultiSort.length || this.orderBy.column === column) return this.orderBy.column === column;
  return !!this.userMultiSorting[userMultiSort[0]].filter(function (col) {
    return col.column == column;
  }).length;
};

/***/ }),

/***/ "bfTY":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("euKu");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("/+iU");
exports.Duplex = __webpack_require__("PBMQ");
exports.Transform = __webpack_require__("Q51I");
exports.PassThrough = __webpack_require__("w2Cf");
exports.finished = __webpack_require__("PcVv");
exports.pipeline = __webpack_require__("Ep4u");


/***/ }),

/***/ "bgbN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return !this.opts.descOrderColumns.includes(column);
};

/***/ }),

/***/ "bhre":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  if (this.opts.visibleColumns) {
    return this.opts.visibleColumns.includes(column);
  }

  if (this.opts.hiddenColumns) {
    return !this.opts.hiddenColumns.includes(column);
  }

  return true;
};

/***/ }),

/***/ "bu1O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return this.userColumnsDisplay.length === 1 && this.userColumnsDisplay[0] === column;
};

/***/ }),

/***/ "c/Tr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("fRJi"), __esModule: true };

/***/ }),

/***/ "c5AH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__("Wdy1");

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ "c8Kh":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "cGG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("JP+z");
var isBuffer = __webpack_require__("1Yoh");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "cKOs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _babelHelperVueJsxMergeProps = _interopRequireDefault(__webpack_require__("nvbp"));

var _clone = _interopRequireDefault(__webpack_require__("jNuQ"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (h) {
  var _this = this;

  return function (classes) {
    var data;

    if (_this.source === 'client') {
      data = _this.filteredData;

      if (!data.length && _this.source === 'client' && _this.page !== 1) {
        // data was dynamically removed go to last page
        _this.setPage(_this.totalPages ? _this.totalPages : 1);
      }
    } else {
      data = _this.tableData;
    }

    if (data.length === 0) {
      var colspan = _this.allColumns.length;
      if (_this.hasChildRow && _this.opts.showChildRowToggler) colspan++;
      return h("tr", {
        "class": "VueTables__no-results"
      }, [h("td", {
        "class": "text-center",
        attrs: {
          tabindex: "0",
          colspan: _this.colspan
        }
      }, [_this.display(_this.loading ? 'loading' : 'noResults')])]);
    }

    var rows = [];
    var columns;
    var rowKey = _this.opts.uniqueKey;
    var rowAttributes;
    var rowClass;
    var recordCount = (_this.Page - 1) * _this.limit;
    var currentGroup;
    var groupSlot;
    var groupValue;
    var groupByContent;
    data.map(function (row, index) {
      if (_this.opts.groupBy && _this.source === 'client' && row[_this.opts.groupBy] !== currentGroup) {
        groupSlot = _this.getGroupSlot(row[_this.opts.groupBy]);
        groupValue = row[_this.opts.groupBy];
        groupByContent = _this.opts.toggleGroups ? h("button", {
          "class": classes.button,
          on: {
            "click": _this.toggleGroup.bind(_this, groupValue)
          }
        }, [groupValue, h("span", {
          "class": _this.groupToggleIcon(groupValue)
        })]) : groupValue;
        rows.push(h("tr", {
          "class": classes.groupTr,
          on: {
            "click": _this._toggleGroupDirection.bind(_this)
          }
        }, [h("td", {
          attrs: {
            colspan: _this.colspan
          }
        }, [groupByContent, groupSlot])]));
        currentGroup = row[_this.opts.groupBy];
      }

      if (_this.opts.toggleGroups && _this.collapsedGroups.includes(currentGroup)) {
        return;
      }

      index = recordCount + index + 1;
      columns = [];
      var update;
      var isEditing;
      var setEditing;
      var revertValue;

      if (_this.hasChildRow && _this.opts.showChildRowToggler) {
        var childRowToggler = h("td", {
          attrs: {
            tabindex: "0"
          },
          on: {
            "keypress": function keypress(e) {
              if (e.key === 'Enter') {
                _this.toggleChildRow.bind(_this, row[rowKey])();
              }
            },
            "click": _this.toggleChildRow.bind(_this, row[rowKey])
          }
        }, [h("span", {
          "class": "VueTables__child-row-toggler " + _this.childRowTogglerClass(row[rowKey])
        })]);
        if (_this.opts.childRowTogglerFirst) columns.push(childRowToggler);
      }

      _this.allColumns.map(function (column) {
        var rowTemplate = _this.$scopedSlots && _this.$scopedSlots[column];

        if (rowTemplate) {
          var rowTemplateData = {
            row: row,
            column: column,
            index: index
          };
        }

        if (_this.opts.editableColumns.includes(column)) {
          rowTemplateData.update = updateValue(row, column).bind(_this);
          rowTemplateData.isEditing = editing(row, column).bind(_this);
          rowTemplateData.setEditing = setEdit(row, column).bind(_this);
          rowTemplateData.revertValue = revertVal(row, column).bind(_this);
        }

        columns.push(h("td", {
          "class": "".concat(_this.columnClass(column), " ").concat(_this._cellClasses(column, row)).trim(),
          attrs: {
            tabindex: "0"
          }
        }, [rowTemplate ? rowTemplate(rowTemplateData) : _this.render(row, column, index, h)]));
      });

      if (_this.hasChildRow && !_this.opts.childRowTogglerFirst && _this.opts.showChildRowToggler) columns.push(childRowToggler);
      rowClass = _this.opts.rowClassCallback ? _this.opts.rowClassCallback(row) : '';
      rowAttributes = _this.opts.rowAttributesCallback ? _this.opts.rowAttributesCallback(row) : {};
      rows.push(h("tr", (0, _babelHelperVueJsxMergeProps["default"])([{
        attrs: rowAttributes
      }, {
        "class": "VueTables__row ".concat(rowClass),
        on: {
          "click": _this.rowWasClicked.bind(_this, row, index)
        }
      }]), [columns, " "]));
      rows.push(_this.hasChildRow && _this.openChildRows.includes(row[rowKey]) ? h("tr", {
        "class": "VueTables__child-row ".concat(rowClass)
      }, [h("td", {
        attrs: {
          colspan: _this.colspan,
          tabindex: "0"
        }
      }, [_this._getChildRowTemplate(h, row, index)])]) : h());
    });
    return rows;
  };
};

function setEdit(row, column) {
  return function (editing) {
    var _this2 = this;

    if (editing) {
      this.editing.push({
        id: row[this.opts.uniqueKey],
        column: column,
        originalValue: row[column]
      });
    } else {
      this.editing = this.editing.filter(function (e) {
        return e.id !== row[_this2.opts.uniqueKey];
      });
    }
  };
}

function editing(row, column) {
  return function () {
    var _this3 = this;

    return this.editing.find(function (e) {
      return e.id === row[_this3.opts.uniqueKey] && e.column === column;
    });
  };
}

function revertVal(row, column) {
  return function () {
    var _this4 = this;

    var origVal = this.editing.find(function (e) {
      return e.id === row[_this4.opts.uniqueKey];
    }).originalValue;
    row[column] = origVal;
  };
}

function updateValue(row, column) {
  return function (e) {
    var _this5 = this;

    var oldVal = row[column];
    row[column] = getValue(e);
    var data = (0, _clone["default"])(this.data).map(function (r) {
      if (r[_this5.opts.uniqueKey] === row[_this5.opts.uniqueKey]) {
        return row;
      }

      return r;
    });
    this.$emit('input', data);
    this.$emit('update', {
      row: row,
      column: column,
      oldVal: oldVal,
      newVal: row[column]
    });
  };
}

function getValue(val) {
  if (val.target) {
    return val.target.type === 'checkbox' ? val.target.checked : val.target.value;
  }

  return val;
}

/***/ }),

/***/ "cSWu":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("Rt1F");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("7dSG");
exports.Duplex = __webpack_require__("DsFX");
exports.Transform = __webpack_require__("D1Va");
exports.PassThrough = __webpack_require__("f48b");


/***/ }),

/***/ "cWxy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("dVOP");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "cmXL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var cls = this.opts.sortIcon.base + ' ';
  if (!this.sortable(column)) return;

  if (this.opts.sortIcon.is && !this._currentlySorted(column)) {
    cls += this.opts.sortIcon.is + ' ';
  }

  if (this.hasMultiSort && this.orderBy.column && this.userMultiSorting[this.orderBy.column]) {
    var col = this.userMultiSorting[this.orderBy.column].filter(function (c) {
      return c.column === column;
    })[0];
    if (col) cls += col.ascending ? this.opts.sortIcon.up : this.opts.sortIcon.down;
  }

  if (column == this.orderBy.column) {
    cls += this.orderBy.ascending == 1 ? this.opts.sortIcon.up : this.opts.sortIcon.down;
  }

  return cls;
};

/***/ }),

/***/ "cwJI":
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__("Wdy1");

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),

/***/ "d1oy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h, selectClass) {
  var _this = this;

  return function (column) {
    var options = [];
    var selected;
    var search = _this.source == 'client' ? _this.search.bind(_this, _this.data) : _this.serverSearch.bind(_this);

    var displayable = _this.opts.listColumns[column].filter(function (item) {
      return !item.hide;
    });

    displayable.map(function (option) {
      selected = option.id == _this.query[column] && _this.query[column] !== '';
      options.push(h("option", {
        domProps: {
          "value": option.id,
          "selected": selected
        }
      }, [option.text]));
    });
    return h("div", {
      "class": "VueTables__list-filter",
      attrs: {
        id: 'VueTables__' + column + '-filter'
      }
    }, [h("select", {
      "class": selectClass,
      on: {
        "change": search
      },
      attrs: {
        name: _this._getColumnName(column)
      },
      domProps: {
        "value": _this.query[column]
      }
    }, [h("option", {
      attrs: {
        value: ""
      }
    }, [_this.display('defaultOption', {
      column: _this.opts.headings[column] ? _this.opts.headings[column] : column
    })]), options])]);
  };
};

/***/ }),

/***/ "dA1D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (obj) {
  var count = 0;

  for (var prop in obj) {
    var isDateRange = _typeof(obj[prop]) == 'object';
    if (isDateRange || obj[prop] && (!isNaN(obj[prop]) || obj[prop].trim())) count++;
  }

  return count;
};

/***/ }),

/***/ "dCRq":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("CVWE");
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__("uDof");
exports.Duplex = __webpack_require__("PhfM");
exports.Transform = __webpack_require__("/OYm");
exports.PassThrough = __webpack_require__("rIDh");
exports.finished = __webpack_require__("DvOT");
exports.pipeline = __webpack_require__("aYMa");


/***/ }),

/***/ "dIwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "dK5q":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("wXdB");
var $getPrototypeOf = __webpack_require__("VD8v");

__webpack_require__("30vf")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "dVOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "do0D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  if (typeof this.opts.initFilters[column] !== 'undefined') {
    return this.opts.initFilters[column];
  }

  if (typeof this.query[column] !== 'undefined' && this.query[column].start) {
    return {
      start: moment(this.query[column].start, 'YYYY-MM-DD HH:mm:ss'),
      end: moment(this.query[column].end, 'YYYY-MM-DD HH:mm:ss')
    };
  }

  return false;
};

/***/ }),

/***/ "dudK":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("3fMt");
var call = __webpack_require__("tn1D");
var isArrayIter = __webpack_require__("yuYM");
var anObject = __webpack_require__("FKWp");
var toLength = __webpack_require__("GhAV");
var getIterFn = __webpack_require__("1yV6");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "e7x4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_define_properties__ = __webpack_require__("HSQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_weak_map__ = __webpack_require__("XFB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof__);


















/*!
* sweetalert2 v11.7.12
* Released under the MIT License.
*/
(function (global, factory) {
  (typeof exports === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && __webpack_require__("nErl") ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Sweetalert2 = factory());
})(this, function () {
  'use strict';

  var RESTORE_FOCUS_TIMEOUT = 100;

  /** @type {GlobalState} */
  var globalState = {};
  var focusPreviousActiveElement = function focusPreviousActiveElement() {
    if (globalState.previousActiveElement instanceof HTMLElement) {
      globalState.previousActiveElement.focus();
      globalState.previousActiveElement = null;
    } else if (document.body) {
      document.body.focus();
    }
  };

  /**
   * Restore previous active (focused) element
   *
   * @param {boolean} returnFocus
   * @returns {Promise<void>}
   */
  var restoreActiveElement = function restoreActiveElement(returnFocus) {
    return new __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a(function (resolve) {
      if (!returnFocus) {
        return resolve();
      }
      var x = window.scrollX;
      var y = window.scrollY;
      globalState.restoreFocusTimeout = setTimeout(function () {
        focusPreviousActiveElement();
        resolve();
      }, RESTORE_FOCUS_TIMEOUT); // issues/900

      window.scrollTo(x, y);
    });
  };

  /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */

  var privateProps = {
    promise: new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_weak_map___default.a(),
    innerParams: new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_weak_map___default.a(),
    domCache: new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_weak_map___default.a()
  };

  var swalPrefix = 'swal2-';

  /**
   * @typedef
   * { | 'container'
   *   | 'shown'
   *   | 'height-auto'
   *   | 'iosfix'
   *   | 'popup'
   *   | 'modal'
   *   | 'no-backdrop'
   *   | 'no-transition'
   *   | 'toast'
   *   | 'toast-shown'
   *   | 'show'
   *   | 'hide'
   *   | 'close'
   *   | 'title'
   *   | 'html-container'
   *   | 'actions'
   *   | 'confirm'
   *   | 'deny'
   *   | 'cancel'
   *   | 'default-outline'
   *   | 'footer'
   *   | 'icon'
   *   | 'icon-content'
   *   | 'image'
   *   | 'input'
   *   | 'file'
   *   | 'range'
   *   | 'select'
   *   | 'radio'
   *   | 'checkbox'
   *   | 'label'
   *   | 'textarea'
   *   | 'inputerror'
   *   | 'input-label'
   *   | 'validation-message'
   *   | 'progress-steps'
   *   | 'active-progress-step'
   *   | 'progress-step'
   *   | 'progress-step-line'
   *   | 'loader'
   *   | 'loading'
   *   | 'styled'
   *   | 'top'
   *   | 'top-start'
   *   | 'top-end'
   *   | 'top-left'
   *   | 'top-right'
   *   | 'center'
   *   | 'center-start'
   *   | 'center-end'
   *   | 'center-left'
   *   | 'center-right'
   *   | 'bottom'
   *   | 'bottom-start'
   *   | 'bottom-end'
   *   | 'bottom-left'
   *   | 'bottom-right'
   *   | 'grow-row'
   *   | 'grow-column'
   *   | 'grow-fullscreen'
   *   | 'rtl'
   *   | 'timer-progress-bar'
   *   | 'timer-progress-bar-container'
   *   | 'scrollbar-measure'
   *   | 'icon-success'
   *   | 'icon-warning'
   *   | 'icon-info'
   *   | 'icon-question'
   *   | 'icon-error'
   * } SwalClass
   * @typedef {Record<SwalClass, string>} SwalClasses
   */

  /**
   * @typedef {'success' | 'warning' | 'info' | 'question' | 'error'} SwalIcon
   * @typedef {Record<SwalIcon, string>} SwalIcons
   */

  /** @type {SwalClass[]} */
  var classNames = ['container', 'shown', 'height-auto', 'iosfix', 'popup', 'modal', 'no-backdrop', 'no-transition', 'toast', 'toast-shown', 'show', 'hide', 'close', 'title', 'html-container', 'actions', 'confirm', 'deny', 'cancel', 'default-outline', 'footer', 'icon', 'icon-content', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'label', 'textarea', 'inputerror', 'input-label', 'validation-message', 'progress-steps', 'active-progress-step', 'progress-step', 'progress-step-line', 'loader', 'loading', 'styled', 'top', 'top-start', 'top-end', 'top-left', 'top-right', 'center', 'center-start', 'center-end', 'center-left', 'center-right', 'bottom', 'bottom-start', 'bottom-end', 'bottom-left', 'bottom-right', 'grow-row', 'grow-column', 'grow-fullscreen', 'rtl', 'timer-progress-bar', 'timer-progress-bar-container', 'scrollbar-measure', 'icon-success', 'icon-warning', 'icon-info', 'icon-question', 'icon-error'];
  var swalClasses = classNames.reduce(function (acc, className) {
    acc[className] = swalPrefix + className;
    return acc;
  }, /** @type {SwalClasses} */{});

  /** @type {SwalIcon[]} */
  var icons = ['success', 'warning', 'info', 'question', 'error'];
  var iconTypes = icons.reduce(function (acc, icon) {
    acc[icon] = swalPrefix + icon;
    return acc;
  }, /** @type {SwalIcons} */{});

  var consolePrefix = 'SweetAlert2:';

  /**
   * Capitalize the first letter of a string
   *
   * @param {string} str
   * @returns {string}
   */
  var capitalizeFirstLetter = function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  /**
   * Standardize console warnings
   *
   * @param {string | string[]} message
   */
  var warn = function warn(message) {
    console.warn(consolePrefix + ' ' + ((typeof message === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(message)) === 'object' ? message.join(' ') : message));
  };

  /**
   * Standardize console errors
   *
   * @param {string} message
   */
  var error = function error(message) {
    console.error(consolePrefix + ' ' + message);
  };

  /**
   * Private global state for `warnOnce`
   *
   * @type {string[]}
   * @private
   */
  var previousWarnOnceMessages = [];

  /**
   * Show a console warning, but only if it hasn't already been shown
   *
   * @param {string} message
   */
  var warnOnce = function warnOnce(message) {
    if (!previousWarnOnceMessages.includes(message)) {
      previousWarnOnceMessages.push(message);
      warn(message);
    }
  };

  /**
   * Show a one-time console warning about deprecated params/methods
   *
   * @param {string} deprecatedParam
   * @param {string} useInstead
   */
  var warnAboutDeprecation = function warnAboutDeprecation(deprecatedParam, useInstead) {
    warnOnce('"' + deprecatedParam + '" is deprecated and will be removed in the next major release. Please use "' + useInstead + '" instead.');
  };

  /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   *
   * @param {Function | any} arg
   * @returns {any}
   */
  var callIfFunction = function callIfFunction(arg) {
    return typeof arg === 'function' ? arg() : arg;
  };

  /**
   * @param {any} arg
   * @returns {boolean}
   */
  var hasToPromiseFn = function hasToPromiseFn(arg) {
    return arg && typeof arg.toPromise === 'function';
  };

  /**
   * @param {any} arg
   * @returns {Promise<any>}
   */
  var asPromise = function asPromise(arg) {
    return hasToPromiseFn(arg) ? arg.toPromise() : __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a.resolve(arg);
  };

  /**
   * @param {any} arg
   * @returns {boolean}
   */
  var isPromise = function isPromise(arg) {
    return arg && __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a.resolve(arg) === arg;
  };

  /**
   * Gets the popup container which contains the backdrop and the popup itself.
   *
   * @returns {HTMLElement | null}
   */
  var getContainer = function getContainer() {
    return document.body.querySelector('.' + swalClasses.container);
  };

  /**
   * @param {string} selectorString
   * @returns {HTMLElement | null}
   */
  var elementBySelector = function elementBySelector(selectorString) {
    var container = getContainer();
    return container ? container.querySelector(selectorString) : null;
  };

  /**
   * @param {string} className
   * @returns {HTMLElement | null}
   */
  var elementByClass = function elementByClass(className) {
    return elementBySelector('.' + className);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getPopup = function getPopup() {
    return elementByClass(swalClasses.popup);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getIcon = function getIcon() {
    return elementByClass(swalClasses.icon);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getIconContent = function getIconContent() {
    return elementByClass(swalClasses['icon-content']);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getTitle = function getTitle() {
    return elementByClass(swalClasses.title);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getHtmlContainer = function getHtmlContainer() {
    return elementByClass(swalClasses['html-container']);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getImage = function getImage() {
    return elementByClass(swalClasses.image);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getProgressSteps = function getProgressSteps() {
    return elementByClass(swalClasses['progress-steps']);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getValidationMessage = function getValidationMessage() {
    return elementByClass(swalClasses['validation-message']);
  };

  /**
   * @returns {HTMLButtonElement | null}
   */
  var getConfirmButton = function getConfirmButton() {
    return (/** @type {HTMLButtonElement} */elementBySelector('.' + swalClasses.actions + ' .' + swalClasses.confirm)
    );
  };

  /**
   * @returns {HTMLButtonElement | null}
   */
  var getCancelButton = function getCancelButton() {
    return (/** @type {HTMLButtonElement} */elementBySelector('.' + swalClasses.actions + ' .' + swalClasses.cancel)
    );
  };

  /**
   * @returns {HTMLButtonElement | null}
   */
  var getDenyButton = function getDenyButton() {
    return (/** @type {HTMLButtonElement} */elementBySelector('.' + swalClasses.actions + ' .' + swalClasses.deny)
    );
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getInputLabel = function getInputLabel() {
    return elementByClass(swalClasses['input-label']);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getLoader = function getLoader() {
    return elementBySelector('.' + swalClasses.loader);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getActions = function getActions() {
    return elementByClass(swalClasses.actions);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getFooter = function getFooter() {
    return elementByClass(swalClasses.footer);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getTimerProgressBar = function getTimerProgressBar() {
    return elementByClass(swalClasses['timer-progress-bar']);
  };

  /**
   * @returns {HTMLElement | null}
   */
  var getCloseButton = function getCloseButton() {
    return elementByClass(swalClasses.close);
  };

  // https://github.com/jkup/focusable/blob/master/index.js
  var focusable = '\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex="0"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n';
  /**
   * @returns {HTMLElement[]}
   */
  var getFocusableElements = function getFocusableElements() {
    /** @type {NodeListOf<HTMLElement>} */
    var focusableElementsWithTabindex = getPopup().querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
    var focusableElementsWithTabindexSorted = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(focusableElementsWithTabindex)
    // sort according to tabindex
    .sort(function (a, b) {
      var tabindexA = parseInt(a.getAttribute('tabindex'));
      var tabindexB = parseInt(b.getAttribute('tabindex'));
      if (tabindexA > tabindexB) {
        return 1;
      } else if (tabindexA < tabindexB) {
        return -1;
      }
      return 0;
    });

    /** @type {NodeListOf<HTMLElement>} */
    var otherFocusableElements = getPopup().querySelectorAll(focusable);
    var otherFocusableElementsFiltered = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(otherFocusableElements).filter(function (el) {
      return el.getAttribute('tabindex') !== '-1';
    });
    return [].concat(__WEBPACK_IMPORTED_MODULE_13_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_12_babel_runtime_core_js_set___default.a(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered)))).filter(function (el) {
      return isVisible$1(el);
    });
  };

  /**
   * @returns {boolean}
   */
  var isModal = function isModal() {
    return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses['toast-shown']) && !hasClass(document.body, swalClasses['no-backdrop']);
  };

  /**
   * @returns {boolean}
   */
  var isToast = function isToast() {
    return getPopup() && hasClass(getPopup(), swalClasses.toast);
  };

  /**
   * @returns {boolean}
   */
  var isLoading = function isLoading() {
    return getPopup().hasAttribute('data-loading');
  };

  /**
   * Securely set innerHTML of an element
   * https://github.com/sweetalert2/sweetalert2/issues/1926
   *
   * @param {HTMLElement} elem
   * @param {string} html
   */
  var setInnerHtml = function setInnerHtml(elem, html) {
    elem.textContent = '';
    if (html) {
      var parser = new DOMParser();
      var parsed = parser.parseFromString(html, 'text/html');
      __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(parsed.querySelector('head').childNodes).forEach(function (child) {
        elem.appendChild(child);
      });
      __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(parsed.querySelector('body').childNodes).forEach(function (child) {
        if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) {
          elem.appendChild(child.cloneNode(true)); // https://github.com/sweetalert2/sweetalert2/issues/2507
        } else {
          elem.appendChild(child);
        }
      });
    }
  };

  /**
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {boolean}
   */
  var hasClass = function hasClass(elem, className) {
    if (!className) {
      return false;
    }
    var classList = className.split(/\s+/);
    for (var i = 0; i < classList.length; i++) {
      if (!elem.classList.contains(classList[i])) {
        return false;
      }
    }
    return true;
  };

  /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   */
  var removeCustomClasses = function removeCustomClasses(elem, params) {
    __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(elem.classList).forEach(function (className) {
      if (!__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default()(swalClasses).includes(className) && !__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default()(iconTypes).includes(className) && !__WEBPACK_IMPORTED_MODULE_11_babel_runtime_core_js_object_values___default()(params.showClass).includes(className)) {
        elem.classList.remove(className);
      }
    });
  };

  /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   * @param {string} className
   */
  var applyCustomClass = function applyCustomClass(elem, params, className) {
    removeCustomClasses(elem, params);
    if (params.customClass && params.customClass[className]) {
      if (typeof params.customClass[className] !== 'string' && !params.customClass[className].forEach) {
        warn('Invalid type of customClass.' + className + '! Expected string or iterable object, got "' + __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(params.customClass[className]) + '"');
        return;
      }
      addClass(elem, params.customClass[className]);
    }
  };

  /**
   * @param {HTMLElement} popup
   * @param {import('./renderers/renderInput').InputClass} inputClass
   * @returns {HTMLInputElement | null}
   */
  var getInput$1 = function getInput$1(popup, inputClass) {
    if (!inputClass) {
      return null;
    }
    switch (inputClass) {
      case 'select':
      case 'textarea':
      case 'file':
        return popup.querySelector('.' + swalClasses.popup + ' > .' + swalClasses[inputClass]);
      case 'checkbox':
        return popup.querySelector('.' + swalClasses.popup + ' > .' + swalClasses.checkbox + ' input');
      case 'radio':
        return popup.querySelector('.' + swalClasses.popup + ' > .' + swalClasses.radio + ' input:checked') || popup.querySelector('.' + swalClasses.popup + ' > .' + swalClasses.radio + ' input:first-child');
      case 'range':
        return popup.querySelector('.' + swalClasses.popup + ' > .' + swalClasses.range + ' input');
      default:
        return popup.querySelector('.' + swalClasses.popup + ' > .' + swalClasses.input);
    }
  };

  /**
   * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} input
   */
  var focusInput = function focusInput(input) {
    input.focus();

    // place cursor at end of text in text input
    if (input.type !== 'file') {
      // http://stackoverflow.com/a/2345915
      var val = input.value;
      input.value = '';
      input.value = val;
    }
  };

  /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[]} classList
   * @param {boolean} condition
   */
  var toggleClass = function toggleClass(target, classList, condition) {
    if (!target || !classList) {
      return;
    }
    if (typeof classList === 'string') {
      classList = classList.split(/\s+/).filter(Boolean);
    }
    classList.forEach(function (className) {
      if (Array.isArray(target)) {
        target.forEach(function (elem) {
          condition ? elem.classList.add(className) : elem.classList.remove(className);
        });
      } else {
        condition ? target.classList.add(className) : target.classList.remove(className);
      }
    });
  };

  /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[]} classList
   */
  var addClass = function addClass(target, classList) {
    toggleClass(target, classList, true);
  };

  /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[]} classList
   */
  var removeClass = function removeClass(target, classList) {
    toggleClass(target, classList, false);
  };

  /**
   * Get direct child of an element by class name
   *
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {HTMLElement | undefined}
   */
  var getDirectChildByClass = function getDirectChildByClass(elem, className) {
    var children = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(elem.children);
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child instanceof HTMLElement && hasClass(child, className)) {
        return child;
      }
    }
  };

  /**
   * @param {HTMLElement} elem
   * @param {string} property
   * @param {*} value
   */
  var applyNumericalStyle = function applyNumericalStyle(elem, property, value) {
    if (value === '' + parseInt(value)) {
      value = parseInt(value);
    }
    if (value || parseInt(value) === 0) {
      elem.style[property] = typeof value === 'number' ? value + 'px' : value;
    } else {
      elem.style.removeProperty(property);
    }
  };

  /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */
  var show = function show(elem) {
    var display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
    elem && (elem.style.display = display);
  };

  /**
   * @param {HTMLElement | null} elem
   */
  var hide = function hide(elem) {
    elem && (elem.style.display = 'none');
  };

  /**
   * @param {HTMLElement} parent
   * @param {string} selector
   * @param {string} property
   * @param {string} value
   */
  var setStyle = function setStyle(parent, selector, property, value) {
    /** @type {HTMLElement} */
    var el = parent.querySelector(selector);
    if (el) {
      el.style[property] = value;
    }
  };

  /**
   * @param {HTMLElement} elem
   * @param {any} condition
   * @param {string} display
   */
  var toggle = function toggle(elem, condition) {
    var display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'flex';
    condition ? show(elem, display) : hide(elem);
  };

  /**
   * borrowed from jquery $(elem).is(':visible') implementation
   *
   * @param {HTMLElement} elem
   * @returns {boolean}
   */
  var isVisible$1 = function isVisible$1(elem) {
    return !!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
  };

  /**
   * @returns {boolean}
   */
  var allButtonsAreHidden = function allButtonsAreHidden() {
    return !isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
  };

  /**
   * @param {HTMLElement} elem
   * @returns {boolean}
   */
  var isScrollable = function isScrollable(elem) {
    return !!(elem.scrollHeight > elem.clientHeight);
  };

  /**
   * borrowed from https://stackoverflow.com/a/46352119
   *
   * @param {HTMLElement} elem
   * @returns {boolean}
   */
  var hasCssAnimation = function hasCssAnimation(elem) {
    var style = window.getComputedStyle(elem);
    var animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
    var transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
    return animDuration > 0 || transDuration > 0;
  };

  /**
   * @param {number} timer
   * @param {boolean} reset
   */
  var animateTimerProgressBar = function animateTimerProgressBar(timer) {
    var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var timerProgressBar = getTimerProgressBar();
    if (isVisible$1(timerProgressBar)) {
      if (reset) {
        timerProgressBar.style.transition = 'none';
        timerProgressBar.style.width = '100%';
      }
      setTimeout(function () {
        timerProgressBar.style.transition = 'width ' + timer / 1000 + 's linear';
        timerProgressBar.style.width = '0%';
      }, 10);
    }
  };
  var stopTimerProgressBar = function stopTimerProgressBar() {
    var timerProgressBar = getTimerProgressBar();
    var timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
    timerProgressBar.style.removeProperty('transition');
    timerProgressBar.style.width = '100%';
    var timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
    var timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
    timerProgressBar.style.width = timerProgressBarPercent + '%';
  };

  /**
   * Detect Node env
   *
   * @returns {boolean}
   */
  var isNodeEnv = function isNodeEnv() {
    return typeof window === 'undefined' || typeof document === 'undefined';
  };

  var sweetHTML = ('\n <div aria-labelledby="' + swalClasses.title + '" aria-describedby="' + swalClasses['html-container'] + '" class="' + swalClasses.popup + '" tabindex="-1">\n   <button type="button" class="' + swalClasses.close + '"></button>\n   <ul class="' + swalClasses['progress-steps'] + '"></ul>\n   <div class="' + swalClasses.icon + '"></div>\n   <img class="' + swalClasses.image + '" />\n   <h2 class="' + swalClasses.title + '" id="' + swalClasses.title + '"></h2>\n   <div class="' + swalClasses['html-container'] + '" id="' + swalClasses['html-container'] + '"></div>\n   <input class="' + swalClasses.input + '" />\n   <input type="file" class="' + swalClasses.file + '" />\n   <div class="' + swalClasses.range + '">\n     <input type="range" />\n     <output></output>\n   </div>\n   <select class="' + swalClasses.select + '"></select>\n   <div class="' + swalClasses.radio + '"></div>\n   <label for="' + swalClasses.checkbox + '" class="' + swalClasses.checkbox + '">\n     <input type="checkbox" />\n     <span class="' + swalClasses.label + '"></span>\n   </label>\n   <textarea class="' + swalClasses.textarea + '"></textarea>\n   <div class="' + swalClasses['validation-message'] + '" id="' + swalClasses['validation-message'] + '"></div>\n   <div class="' + swalClasses.actions + '">\n     <div class="' + swalClasses.loader + '"></div>\n     <button type="button" class="' + swalClasses.confirm + '"></button>\n     <button type="button" class="' + swalClasses.deny + '"></button>\n     <button type="button" class="' + swalClasses.cancel + '"></button>\n   </div>\n   <div class="' + swalClasses.footer + '"></div>\n   <div class="' + swalClasses['timer-progress-bar-container'] + '">\n     <div class="' + swalClasses['timer-progress-bar'] + '"></div>\n   </div>\n </div>\n').replace(/(^|\n)\s*/g, '');

  /**
   * @returns {boolean}
   */
  var resetOldContainer = function resetOldContainer() {
    var oldContainer = getContainer();
    if (!oldContainer) {
      return false;
    }
    oldContainer.remove();
    removeClass([document.documentElement, document.body], [swalClasses['no-backdrop'], swalClasses['toast-shown'], swalClasses['has-column']]);
    return true;
  };
  var resetValidationMessage$1 = function resetValidationMessage$1() {
    globalState.currentInstance.resetValidationMessage();
  };
  var addInputChangeListeners = function addInputChangeListeners() {
    var popup = getPopup();
    var input = getDirectChildByClass(popup, swalClasses.input);
    var file = getDirectChildByClass(popup, swalClasses.file);
    /** @type {HTMLInputElement} */
    var range = popup.querySelector('.' + swalClasses.range + ' input');
    /** @type {HTMLOutputElement} */
    var rangeOutput = popup.querySelector('.' + swalClasses.range + ' output');
    var select = getDirectChildByClass(popup, swalClasses.select);
    /** @type {HTMLInputElement} */
    var checkbox = popup.querySelector('.' + swalClasses.checkbox + ' input');
    var textarea = getDirectChildByClass(popup, swalClasses.textarea);
    input.oninput = resetValidationMessage$1;
    file.onchange = resetValidationMessage$1;
    select.onchange = resetValidationMessage$1;
    checkbox.onchange = resetValidationMessage$1;
    textarea.oninput = resetValidationMessage$1;
    range.oninput = function () {
      resetValidationMessage$1();
      rangeOutput.value = range.value;
    };
    range.onchange = function () {
      resetValidationMessage$1();
      rangeOutput.value = range.value;
    };
  };

  /**
   * @param {string | HTMLElement} target
   * @returns {HTMLElement}
   */
  var getTarget = function getTarget(target) {
    return typeof target === 'string' ? document.querySelector(target) : target;
  };

  /**
   * @param {SweetAlertOptions} params
   */
  var setupAccessibility = function setupAccessibility(params) {
    var popup = getPopup();
    popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
    popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
    if (!params.toast) {
      popup.setAttribute('aria-modal', 'true');
    }
  };

  /**
   * @param {HTMLElement} targetElement
   */
  var setupRTL = function setupRTL(targetElement) {
    if (window.getComputedStyle(targetElement).direction === 'rtl') {
      addClass(getContainer(), swalClasses.rtl);
    }
  };

  /**
   * Add modal + backdrop + no-war message for Russians to DOM
   *
   * @param {SweetAlertOptions} params
   */
  var init = function init(params) {
    // Clean up the old popup container if it exists
    var oldContainerExisted = resetOldContainer();

    /* istanbul ignore if */
    if (isNodeEnv()) {
      error('SweetAlert2 requires document to initialize');
      return;
    }
    var container = document.createElement('div');
    container.className = swalClasses.container;
    if (oldContainerExisted) {
      addClass(container, swalClasses['no-transition']);
    }
    setInnerHtml(container, sweetHTML);
    var targetElement = getTarget(params.target);
    targetElement.appendChild(container);
    setupAccessibility(params);
    setupRTL(targetElement);
    addInputChangeListeners();
  };

  /**
   * @param {HTMLElement | object | string} param
   * @param {HTMLElement} target
   */
  var parseHtmlToContainer = function parseHtmlToContainer(param, target) {
    // DOM element
    if (param instanceof HTMLElement) {
      target.appendChild(param);
    }

    // Object
    else if ((typeof param === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(param)) === 'object') {
        handleObject(param, target);
      }

      // Plain string
      else if (param) {
          setInnerHtml(target, param);
        }
  };

  /**
   * @param {object} param
   * @param {HTMLElement} target
   */
  var handleObject = function handleObject(param, target) {
    // JQuery element(s)
    if (param.jquery) {
      handleJqueryElem(target, param);
    }

    // For other objects use their string representation
    else {
        setInnerHtml(target, param.toString());
      }
  };

  /**
   * @param {HTMLElement} target
   * @param {HTMLElement} elem
   */
  var handleJqueryElem = function handleJqueryElem(target, elem) {
    target.textContent = '';
    if (0 in elem) {
      for (var i = 0; i in elem; i++) {
        target.appendChild(elem[i].cloneNode(true));
      }
    } else {
      target.appendChild(elem.cloneNode(true));
    }
  };

  /**
   * @returns {'webkitAnimationEnd' | 'animationend' | false}
   */
  var animationEndEvent = function () {
    // Prevent run in Node env
    /* istanbul ignore if */
    if (isNodeEnv()) {
      return false;
    }
    var testEl = document.createElement('div');
    var transEndEventNames = {
      WebkitAnimation: 'webkitAnimationEnd',
      // Chrome, Safari and Opera
      animation: 'animationend' // Standard syntax
    };

    for (var i in transEndEventNames) {
      if (Object.prototype.hasOwnProperty.call(transEndEventNames, i) && typeof testEl.style[i] !== 'undefined') {
        return transEndEventNames[i];
      }
    }
    return false;
  }();

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderActions = function renderActions(instance, params) {
    var actions = getActions();
    var loader = getLoader();

    // Actions (buttons) wrapper
    if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) {
      hide(actions);
    } else {
      show(actions);
    }

    // Custom class
    applyCustomClass(actions, params, 'actions');

    // Render all the buttons
    renderButtons(actions, loader, params);

    // Loader
    setInnerHtml(loader, params.loaderHtml);
    applyCustomClass(loader, params, 'loader');
  };

  /**
   * @param {HTMLElement} actions
   * @param {HTMLElement} loader
   * @param {SweetAlertOptions} params
   */
  function renderButtons(actions, loader, params) {
    var confirmButton = getConfirmButton();
    var denyButton = getDenyButton();
    var cancelButton = getCancelButton();

    // Render buttons
    renderButton(confirmButton, 'confirm', params);
    renderButton(denyButton, 'deny', params);
    renderButton(cancelButton, 'cancel', params);
    handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
    if (params.reverseButtons) {
      if (params.toast) {
        actions.insertBefore(cancelButton, confirmButton);
        actions.insertBefore(denyButton, confirmButton);
      } else {
        actions.insertBefore(cancelButton, loader);
        actions.insertBefore(denyButton, loader);
        actions.insertBefore(confirmButton, loader);
      }
    }
  }

  /**
   * @param {HTMLElement} confirmButton
   * @param {HTMLElement} denyButton
   * @param {HTMLElement} cancelButton
   * @param {SweetAlertOptions} params
   */
  function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
    if (!params.buttonsStyling) {
      removeClass([confirmButton, denyButton, cancelButton], swalClasses.styled);
      return;
    }
    addClass([confirmButton, denyButton, cancelButton], swalClasses.styled);

    // Buttons background colors
    if (params.confirmButtonColor) {
      confirmButton.style.backgroundColor = params.confirmButtonColor;
      addClass(confirmButton, swalClasses['default-outline']);
    }
    if (params.denyButtonColor) {
      denyButton.style.backgroundColor = params.denyButtonColor;
      addClass(denyButton, swalClasses['default-outline']);
    }
    if (params.cancelButtonColor) {
      cancelButton.style.backgroundColor = params.cancelButtonColor;
      addClass(cancelButton, swalClasses['default-outline']);
    }
  }

  /**
   * @param {HTMLElement} button
   * @param {'confirm' | 'deny' | 'cancel'} buttonType
   * @param {SweetAlertOptions} params
   */
  function renderButton(button, buttonType, params) {
    toggle(button, params['show' + capitalizeFirstLetter(buttonType) + 'Button'], 'inline-block');
    setInnerHtml(button, params[buttonType + 'ButtonText']); // Set caption text
    button.setAttribute('aria-label', params[buttonType + 'ButtonAriaLabel']); // ARIA label

    // Add buttons custom classes
    button.className = swalClasses[buttonType];
    applyCustomClass(button, params, buttonType + 'Button');
    addClass(button, params[buttonType + 'ButtonClass']);
  }

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderCloseButton = function renderCloseButton(instance, params) {
    var closeButton = getCloseButton();
    if (!closeButton) {
      return;
    }
    setInnerHtml(closeButton, params.closeButtonHtml || '');

    // Custom class
    applyCustomClass(closeButton, params, 'closeButton');
    toggle(closeButton, params.showCloseButton);
    closeButton.setAttribute('aria-label', params.closeButtonAriaLabel || '');
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderContainer = function renderContainer(instance, params) {
    var container = getContainer();
    if (!container) {
      return;
    }
    handleBackdropParam(container, params.backdrop);
    handlePositionParam(container, params.position);
    handleGrowParam(container, params.grow);

    // Custom class
    applyCustomClass(container, params, 'container');
  };

  /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['backdrop']} backdrop
   */
  function handleBackdropParam(container, backdrop) {
    if (typeof backdrop === 'string') {
      container.style.background = backdrop;
    } else if (!backdrop) {
      addClass([document.documentElement, document.body], swalClasses['no-backdrop']);
    }
  }

  /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['position']} position
   */
  function handlePositionParam(container, position) {
    if (position in swalClasses) {
      addClass(container, swalClasses[position]);
    } else {
      warn('The "position" parameter is not valid, defaulting to "center"');
      addClass(container, swalClasses.center);
    }
  }

  /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['grow']} grow
   */
  function handleGrowParam(container, grow) {
    if (grow && typeof grow === 'string') {
      var growClass = 'grow-' + grow;
      if (growClass in swalClasses) {
        addClass(container, swalClasses[growClass]);
      }
    }
  }

  /// <reference path="../../../../sweetalert2.d.ts"/>


  /** @type {InputClass[]} */
  var inputClasses = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderInput = function renderInput(instance, params) {
    var popup = getPopup();
    var innerParams = privateProps.innerParams.get(instance);
    var rerender = !innerParams || params.input !== innerParams.input;
    inputClasses.forEach(function (inputClass) {
      var inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);

      // set attributes
      setAttributes(inputClass, params.inputAttributes);

      // set class
      inputContainer.className = swalClasses[inputClass];
      if (rerender) {
        hide(inputContainer);
      }
    });
    if (params.input) {
      if (rerender) {
        showInput(params);
      }
      // set custom class
      setCustomClass(params);
    }
  };

  /**
   * @param {SweetAlertOptions} params
   */
  var showInput = function showInput(params) {
    if (!renderInputType[params.input]) {
      error('Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "' + params.input + '"');
      return;
    }
    var inputContainer = getInputContainer(params.input);
    var input = renderInputType[params.input](inputContainer, params);
    show(inputContainer);

    // input autofocus
    if (params.inputAutoFocus) {
      setTimeout(function () {
        focusInput(input);
      });
    }
  };

  /**
   * @param {HTMLInputElement} input
   */
  var removeAttributes = function removeAttributes(input) {
    for (var i = 0; i < input.attributes.length; i++) {
      var attrName = input.attributes[i].name;
      if (!['type', 'value', 'style'].includes(attrName)) {
        input.removeAttribute(attrName);
      }
    }
  };

  /**
   * @param {InputClass} inputClass
   * @param {SweetAlertOptions['inputAttributes']} inputAttributes
   */
  var setAttributes = function setAttributes(inputClass, inputAttributes) {
    var input = getInput$1(getPopup(), inputClass);
    if (!input) {
      return;
    }
    removeAttributes(input);
    for (var attr in inputAttributes) {
      input.setAttribute(attr, inputAttributes[attr]);
    }
  };

  /**
   * @param {SweetAlertOptions} params
   */
  var setCustomClass = function setCustomClass(params) {
    var inputContainer = getInputContainer(params.input);
    if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(params.customClass) === 'object') {
      addClass(inputContainer, params.customClass.input);
    }
  };

  /**
   * @param {HTMLInputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions} params
   */
  var setInputPlaceholder = function setInputPlaceholder(input, params) {
    if (!input.placeholder || params.inputPlaceholder) {
      input.placeholder = params.inputPlaceholder;
    }
  };

  /**
   * @param {Input} input
   * @param {Input} prependTo
   * @param {SweetAlertOptions} params
   */
  var setInputLabel = function setInputLabel(input, prependTo, params) {
    if (params.inputLabel) {
      input.id = swalClasses.input;
      var label = document.createElement('label');
      var labelClass = swalClasses['input-label'];
      label.setAttribute('for', input.id);
      label.className = labelClass;
      if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(params.customClass) === 'object') {
        addClass(label, params.customClass.inputLabel);
      }
      label.innerText = params.inputLabel;
      prependTo.insertAdjacentElement('beforebegin', label);
    }
  };

  /**
   * @param {SweetAlertOptions['input']} inputType
   * @returns {HTMLElement}
   */
  var getInputContainer = function getInputContainer(inputType) {
    return getDirectChildByClass(getPopup(), swalClasses[inputType] || swalClasses.input);
  };

  /**
   * @param {HTMLInputElement | HTMLOutputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions['inputValue']} inputValue
   */
  var checkAndSetInputValue = function checkAndSetInputValue(input, inputValue) {
    if (['string', 'number'].includes(typeof inputValue === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(inputValue))) {
      input.value = '' + inputValue;
    } else if (!isPromise(inputValue)) {
      warn('Unexpected type of inputValue! Expected "string", "number" or "Promise", got "' + (typeof inputValue === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(inputValue)) + '"');
    }
  };

  /** @type {Record<string, (input: Input | HTMLElement, params: SweetAlertOptions) => Input>} */
  var renderInputType = {};

  /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */
  renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = function (input, params) {
    checkAndSetInputValue(input, params.inputValue);
    setInputLabel(input, input, params);
    setInputPlaceholder(input, params);
    input.type = params.input;
    return input;
  };

  /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */
  renderInputType.file = function (input, params) {
    setInputLabel(input, input, params);
    setInputPlaceholder(input, params);
    return input;
  };

  /**
   * @param {HTMLInputElement} range
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */
  renderInputType.range = function (range, params) {
    var rangeInput = range.querySelector('input');
    var rangeOutput = range.querySelector('output');
    checkAndSetInputValue(rangeInput, params.inputValue);
    rangeInput.type = params.input;
    checkAndSetInputValue(rangeOutput, params.inputValue);
    setInputLabel(rangeInput, range, params);
    return range;
  };

  /**
   * @param {HTMLSelectElement} select
   * @param {SweetAlertOptions} params
   * @returns {HTMLSelectElement}
   */
  renderInputType.select = function (select, params) {
    select.textContent = '';
    if (params.inputPlaceholder) {
      var placeholder = document.createElement('option');
      setInnerHtml(placeholder, params.inputPlaceholder);
      placeholder.value = '';
      placeholder.disabled = true;
      placeholder.selected = true;
      select.appendChild(placeholder);
    }
    setInputLabel(select, select, params);
    return select;
  };

  /**
   * @param {HTMLInputElement} radio
   * @returns {HTMLInputElement}
   */
  renderInputType.radio = function (radio) {
    radio.textContent = '';
    return radio;
  };

  /**
   * @param {HTMLLabelElement} checkboxContainer
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */
  renderInputType.checkbox = function (checkboxContainer, params) {
    var checkbox = getInput$1(getPopup(), 'checkbox');
    checkbox.value = '1';
    checkbox.id = swalClasses.checkbox;
    checkbox.checked = Boolean(params.inputValue);
    var label = checkboxContainer.querySelector('span');
    setInnerHtml(label, params.inputPlaceholder);
    return checkbox;
  };

  /**
   * @param {HTMLTextAreaElement} textarea
   * @param {SweetAlertOptions} params
   * @returns {HTMLTextAreaElement}
   */
  renderInputType.textarea = function (textarea, params) {
    checkAndSetInputValue(textarea, params.inputValue);
    setInputPlaceholder(textarea, params);
    setInputLabel(textarea, textarea, params);

    /**
     * @param {HTMLElement} el
     * @returns {number}
     */
    var getMargin = function getMargin(el) {
      return parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
    };

    // https://github.com/sweetalert2/sweetalert2/issues/2291
    setTimeout(function () {
      // https://github.com/sweetalert2/sweetalert2/issues/1699
      if ('MutationObserver' in window) {
        var initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
        var textareaResizeHandler = function textareaResizeHandler() {
          var textareaWidth = textarea.offsetWidth + getMargin(textarea);
          if (textareaWidth > initialPopupWidth) {
            getPopup().style.width = textareaWidth + 'px';
          } else {
            getPopup().style.width = null;
          }
        };
        new MutationObserver(textareaResizeHandler).observe(textarea, {
          attributes: true,
          attributeFilter: ['style']
        });
      }
    });
    return textarea;
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderContent = function renderContent(instance, params) {
    var htmlContainer = getHtmlContainer();
    if (!htmlContainer) {
      return;
    }
    applyCustomClass(htmlContainer, params, 'htmlContainer');

    // Content as HTML
    if (params.html) {
      parseHtmlToContainer(params.html, htmlContainer);
      show(htmlContainer, 'block');
    }

    // Content as plain text
    else if (params.text) {
        htmlContainer.textContent = params.text;
        show(htmlContainer, 'block');
      }

      // No content
      else {
          hide(htmlContainer);
        }
    renderInput(instance, params);
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderFooter = function renderFooter(instance, params) {
    var footer = getFooter();
    if (!footer) {
      return;
    }
    toggle(footer, params.footer);
    if (params.footer) {
      parseHtmlToContainer(params.footer, footer);
    }

    // Custom class
    applyCustomClass(footer, params, 'footer');
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderIcon = function renderIcon(instance, params) {
    var innerParams = privateProps.innerParams.get(instance);
    var icon = getIcon();

    // if the given icon already rendered, apply the styling without re-rendering the icon
    if (innerParams && params.icon === innerParams.icon) {
      // Custom or default content
      setContent(icon, params);
      applyStyles(icon, params);
      return;
    }
    if (!params.icon && !params.iconHtml) {
      hide(icon);
      return;
    }
    if (params.icon && __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(iconTypes).indexOf(params.icon) === -1) {
      error('Unknown icon! Expected "success", "error", "warning", "info" or "question", got "' + params.icon + '"');
      hide(icon);
      return;
    }
    show(icon);

    // Custom or default content
    setContent(icon, params);
    applyStyles(icon, params);

    // Animate icon
    addClass(icon, params.showClass.icon);
  };

  /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */
  var applyStyles = function applyStyles(icon, params) {
    for (var iconType in iconTypes) {
      if (params.icon !== iconType) {
        removeClass(icon, iconTypes[iconType]);
      }
    }
    addClass(icon, iconTypes[params.icon]);

    // Icon color
    setColor(icon, params);

    // Success icon background color
    adjustSuccessIconBackgroundColor();

    // Custom class
    applyCustomClass(icon, params, 'icon');
  };

  // Adjust success icon background color to match the popup background color
  var adjustSuccessIconBackgroundColor = function adjustSuccessIconBackgroundColor() {
    var popup = getPopup();
    var popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
    /** @type {NodeListOf<HTMLElement>} */
    var successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
    for (var i = 0; i < successIconParts.length; i++) {
      successIconParts[i].style.backgroundColor = popupBackgroundColor;
    }
  };
  var successIconHtml = '\n  <div class="swal2-success-circular-line-left"></div>\n  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n  <div class="swal2-success-circular-line-right"></div>\n';
  var errorIconHtml = '\n  <span class="swal2-x-mark">\n    <span class="swal2-x-mark-line-left"></span>\n    <span class="swal2-x-mark-line-right"></span>\n  </span>\n';

  /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */
  var setContent = function setContent(icon, params) {
    var oldContent = icon.innerHTML;
    var newContent = void 0;
    if (params.iconHtml) {
      newContent = iconContent(params.iconHtml);
    } else if (params.icon === 'success') {
      newContent = successIconHtml;
      oldContent = oldContent.replace(/ style=".*?"/g, ''); // undo adjustSuccessIconBackgroundColor()
    } else if (params.icon === 'error') {
      newContent = errorIconHtml;
    } else {
      var defaultIconHtml = {
        question: '?',
        warning: '!',
        info: 'i'
      };
      newContent = iconContent(defaultIconHtml[params.icon]);
    }
    if (oldContent.trim() !== newContent.trim()) {
      setInnerHtml(icon, newContent);
    }
  };

  /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */
  var setColor = function setColor(icon, params) {
    if (!params.iconColor) {
      return;
    }
    icon.style.color = params.iconColor;
    icon.style.borderColor = params.iconColor;
    var _arr = ['.swal2-success-line-tip', '.swal2-success-line-long', '.swal2-x-mark-line-left', '.swal2-x-mark-line-right'];
    for (var _i = 0; _i < _arr.length; _i++) {
      var sel = _arr[_i];
      setStyle(icon, sel, 'backgroundColor', params.iconColor);
    }
    setStyle(icon, '.swal2-success-ring', 'borderColor', params.iconColor);
  };

  /**
   * @param {string} content
   * @returns {string}
   */
  var iconContent = function iconContent(content) {
    return '<div class="' + swalClasses['icon-content'] + '">' + content + '</div>';
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderImage = function renderImage(instance, params) {
    var image = getImage();
    if (!image) {
      return;
    }
    if (!params.imageUrl) {
      hide(image);
      return;
    }
    show(image, '');

    // Src, alt
    image.setAttribute('src', params.imageUrl);
    image.setAttribute('alt', params.imageAlt || '');

    // Width, height
    applyNumericalStyle(image, 'width', params.imageWidth);
    applyNumericalStyle(image, 'height', params.imageHeight);

    // Class
    image.className = swalClasses.image;
    applyCustomClass(image, params, 'image');
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderPopup = function renderPopup(instance, params) {
    var container = getContainer();
    var popup = getPopup();
    if (!container || !popup) {
      return;
    }

    // Width
    // https://github.com/sweetalert2/sweetalert2/issues/2170
    if (params.toast) {
      applyNumericalStyle(container, 'width', params.width);
      popup.style.width = '100%';
      var loader = getLoader();
      loader && popup.insertBefore(loader, getIcon());
    } else {
      applyNumericalStyle(popup, 'width', params.width);
    }

    // Padding
    applyNumericalStyle(popup, 'padding', params.padding);

    // Color
    if (params.color) {
      popup.style.color = params.color;
    }

    // Background
    if (params.background) {
      popup.style.background = params.background;
    }
    hide(getValidationMessage());

    // Classes
    addClasses$1(popup, params);
  };

  /**
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */
  var addClasses$1 = function addClasses$1(popup, params) {
    var showClass = params.showClass || {};
    // Default Class + showClass when updating Swal.update({})
    popup.className = swalClasses.popup + ' ' + (isVisible$1(popup) ? showClass.popup : '');
    if (params.toast) {
      addClass([document.documentElement, document.body], swalClasses['toast-shown']);
      addClass(popup, swalClasses.toast);
    } else {
      addClass(popup, swalClasses.modal);
    }

    // Custom class
    applyCustomClass(popup, params, 'popup');
    if (typeof params.customClass === 'string') {
      addClass(popup, params.customClass);
    }

    // Icon class (#1842)
    if (params.icon) {
      addClass(popup, swalClasses['icon-' + params.icon]);
    }
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderProgressSteps = function renderProgressSteps(instance, params) {
    var progressStepsContainer = getProgressSteps();
    if (!progressStepsContainer) {
      return;
    }
    var progressSteps = params.progressSteps,
        currentProgressStep = params.currentProgressStep;

    if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
      hide(progressStepsContainer);
      return;
    }
    show(progressStepsContainer);
    progressStepsContainer.textContent = '';
    if (currentProgressStep >= progressSteps.length) {
      warn('Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
    }
    progressSteps.forEach(function (step, index) {
      var stepEl = createStepElement(step);
      progressStepsContainer.appendChild(stepEl);
      if (index === currentProgressStep) {
        addClass(stepEl, swalClasses['active-progress-step']);
      }
      if (index !== progressSteps.length - 1) {
        var lineEl = createLineElement(params);
        progressStepsContainer.appendChild(lineEl);
      }
    });
  };

  /**
   * @param {string} step
   * @returns {HTMLLIElement}
   */
  var createStepElement = function createStepElement(step) {
    var stepEl = document.createElement('li');
    addClass(stepEl, swalClasses['progress-step']);
    setInnerHtml(stepEl, step);
    return stepEl;
  };

  /**
   * @param {SweetAlertOptions} params
   * @returns {HTMLLIElement}
   */
  var createLineElement = function createLineElement(params) {
    var lineEl = document.createElement('li');
    addClass(lineEl, swalClasses['progress-step-line']);
    if (params.progressStepsDistance) {
      applyNumericalStyle(lineEl, 'width', params.progressStepsDistance);
    }
    return lineEl;
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var renderTitle = function renderTitle(instance, params) {
    var title = getTitle();
    if (!title) {
      return;
    }
    toggle(title, params.title || params.titleText, 'block');
    if (params.title) {
      parseHtmlToContainer(params.title, title);
    }
    if (params.titleText) {
      title.innerText = params.titleText;
    }

    // Custom class
    applyCustomClass(title, params, 'title');
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var render = function render(instance, params) {
    renderPopup(instance, params);
    renderContainer(instance, params);
    renderProgressSteps(instance, params);
    renderIcon(instance, params);
    renderImage(instance, params);
    renderTitle(instance, params);
    renderCloseButton(instance, params);
    renderContent(instance, params);
    renderActions(instance, params);
    renderFooter(instance, params);
    var popup = getPopup();
    if (typeof params.didRender === 'function' && popup) {
      params.didRender(popup);
    }
  };

  /*
   * Global function to determine if SweetAlert2 popup is shown
   */
  var isVisible = function isVisible() {
    return isVisible$1(getPopup());
  };

  /*
   * Global function to click 'Confirm' button
   */
  var clickConfirm = function clickConfirm() {
    return getConfirmButton() && getConfirmButton().click();
  };

  /*
   * Global function to click 'Deny' button
   */
  var clickDeny = function clickDeny() {
    return getDenyButton() && getDenyButton().click();
  };

  /*
   * Global function to click 'Cancel' button
   */
  var clickCancel = function clickCancel() {
    return getCancelButton() && getCancelButton().click();
  };

  /** @typedef {'cancel' | 'backdrop' | 'close' | 'esc' | 'timer'} DismissReason */

  /** @type {Record<DismissReason, DismissReason>} */
  var DismissReason = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_freeze___default()({
    cancel: 'cancel',
    backdrop: 'backdrop',
    close: 'close',
    esc: 'esc',
    timer: 'timer'
  });

  /**
   * @param {GlobalState} globalState
   */
  var removeKeydownHandler = function removeKeydownHandler(globalState) {
    if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
      globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = false;
    }
  };

  /**
   * @param {SweetAlert} instance
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {*} dismissWith
   */
  var addKeydownHandler = function addKeydownHandler(instance, globalState, innerParams, dismissWith) {
    removeKeydownHandler(globalState);
    if (!innerParams.toast) {
      globalState.keydownHandler = function (e) {
        return keydownHandler(instance, e, dismissWith);
      };
      globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
      globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
      globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
        capture: globalState.keydownListenerCapture
      });
      globalState.keydownHandlerAdded = true;
    }
  };

  /**
   * @param {number} index
   * @param {number} increment
   */
  var setFocus = function setFocus(index, increment) {
    var focusableElements = getFocusableElements();
    // search for visible elements and select the next possible match
    if (focusableElements.length) {
      index = index + increment;

      // rollover to first item
      if (index === focusableElements.length) {
        index = 0;

        // go to last item
      } else if (index === -1) {
        index = focusableElements.length - 1;
      }
      focusableElements[index].focus();
      return;
    }
    // no visible focusable elements, focus the popup
    getPopup().focus();
  };
  var arrowKeysNextButton = ['ArrowRight', 'ArrowDown'];
  var arrowKeysPreviousButton = ['ArrowLeft', 'ArrowUp'];

  /**
   * @param {SweetAlert} instance
   * @param {KeyboardEvent} event
   * @param {Function} dismissWith
   */
  var keydownHandler = function keydownHandler(instance, event, dismissWith) {
    var innerParams = privateProps.innerParams.get(instance);
    if (!innerParams) {
      return; // This instance has already been destroyed
    }

    // Ignore keydown during IME composition
    // https://developer.mozilla.org/en-US/docs/Web/API/Document/keydown_event#ignoring_keydown_during_ime_composition
    // https://github.com/sweetalert2/sweetalert2/issues/720
    // https://github.com/sweetalert2/sweetalert2/issues/2406
    if (event.isComposing || event.keyCode === 229) {
      return;
    }
    if (innerParams.stopKeydownPropagation) {
      event.stopPropagation();
    }

    // ENTER
    if (event.key === 'Enter') {
      handleEnter(instance, event, innerParams);
    }

    // TAB
    else if (event.key === 'Tab') {
        handleTab(event);
      }

      // ARROWS - switch focus between buttons
      else if ([].concat(arrowKeysNextButton, arrowKeysPreviousButton).includes(event.key)) {
          handleArrows(event.key);
        }

        // ESC
        else if (event.key === 'Escape') {
            handleEsc(event, innerParams, dismissWith);
          }
  };

  /**
   * @param {SweetAlert} instance
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   */
  var handleEnter = function handleEnter(instance, event, innerParams) {
    // https://github.com/sweetalert2/sweetalert2/issues/2386
    if (!callIfFunction(innerParams.allowEnterKey)) {
      return;
    }
    if (event.target && instance.getInput() && event.target instanceof HTMLElement && event.target.outerHTML === instance.getInput().outerHTML) {
      if (['textarea', 'file'].includes(innerParams.input)) {
        return; // do not submit
      }

      clickConfirm();
      event.preventDefault();
    }
  };

  /**
   * @param {KeyboardEvent} event
   */
  var handleTab = function handleTab(event) {
    var targetElement = event.target;
    var focusableElements = getFocusableElements();
    var btnIndex = -1;
    for (var i = 0; i < focusableElements.length; i++) {
      if (targetElement === focusableElements[i]) {
        btnIndex = i;
        break;
      }
    }

    // Cycle to the next button
    if (!event.shiftKey) {
      setFocus(btnIndex, 1);
    }

    // Cycle to the prev button
    else {
        setFocus(btnIndex, -1);
      }
    event.stopPropagation();
    event.preventDefault();
  };

  /**
   * @param {string} key
   */
  var handleArrows = function handleArrows(key) {
    var confirmButton = getConfirmButton();
    var denyButton = getDenyButton();
    var cancelButton = getCancelButton();
    /** @type HTMLElement[] */
    var buttons = [confirmButton, denyButton, cancelButton];
    if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) {
      return;
    }
    var sibling = arrowKeysNextButton.includes(key) ? 'nextElementSibling' : 'previousElementSibling';
    var buttonToFocus = document.activeElement;
    for (var i = 0; i < getActions().children.length; i++) {
      buttonToFocus = buttonToFocus[sibling];
      if (!buttonToFocus) {
        return;
      }
      if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) {
        break;
      }
    }
    if (buttonToFocus instanceof HTMLButtonElement) {
      buttonToFocus.focus();
    }
  };

  /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */
  var handleEsc = function handleEsc(event, innerParams, dismissWith) {
    if (callIfFunction(innerParams.allowEscapeKey)) {
      event.preventDefault();
      dismissWith(DismissReason.esc);
    }
  };

  /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */

  var privateMethods = {
    swalPromiseResolve: new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_weak_map___default.a(),
    swalPromiseReject: new __WEBPACK_IMPORTED_MODULE_15_babel_runtime_core_js_weak_map___default.a()
  };

  // From https://developer.paciellogroup.com/blog/2018/06/the-current-state-of-modal-dialog-accessibility/
  // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
  // elements not within the active modal dialog will not be surfaced if a user opens a screen
  // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.

  var setAriaHidden = function setAriaHidden() {
    var bodyChildren = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(document.body.children);
    bodyChildren.forEach(function (el) {
      if (el === getContainer() || el.contains(getContainer())) {
        return;
      }
      if (el.hasAttribute('aria-hidden')) {
        el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden') || '');
      }
      el.setAttribute('aria-hidden', 'true');
    });
  };
  var unsetAriaHidden = function unsetAriaHidden() {
    var bodyChildren = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(document.body.children);
    bodyChildren.forEach(function (el) {
      if (el.hasAttribute('data-previous-aria-hidden')) {
        el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden') || '');
        el.removeAttribute('data-previous-aria-hidden');
      } else {
        el.removeAttribute('aria-hidden');
      }
    });
  };

  /* istanbul ignore file */

  // Fix iOS scrolling http://stackoverflow.com/q/39626302

  var iOSfix = function iOSfix() {
    var iOS =
    // @ts-ignore
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
      var offset = document.body.scrollTop;
      document.body.style.top = offset * -1 + 'px';
      addClass(document.body, swalClasses.iosfix);
      lockBodyScroll();
      addBottomPaddingForTallPopups();
    }
  };

  /**
   * https://github.com/sweetalert2/sweetalert2/issues/1948
   */
  var addBottomPaddingForTallPopups = function addBottomPaddingForTallPopups() {
    var ua = navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    var iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
    if (iOSSafari) {
      var bottomPanelHeight = 44;
      if (getPopup().scrollHeight > window.innerHeight - bottomPanelHeight) {
        getContainer().style.paddingBottom = bottomPanelHeight + 'px';
      }
    }
  };

  /**
   * https://github.com/sweetalert2/sweetalert2/issues/1246
   */
  var lockBodyScroll = function lockBodyScroll() {
    var container = getContainer();
    var preventTouchMove = void 0;
    /**
     * @param {TouchEvent} event
     */
    container.ontouchstart = function (event) {
      preventTouchMove = shouldPreventTouchMove(event);
    };
    /**
     * @param {TouchEvent} event
     */
    container.ontouchmove = function (event) {
      if (preventTouchMove) {
        event.preventDefault();
        event.stopPropagation();
      }
    };
  };

  /**
   * @param {TouchEvent} event
   * @returns {boolean}
   */
  var shouldPreventTouchMove = function shouldPreventTouchMove(event) {
    var target = event.target;
    var container = getContainer();
    if (isStylus(event) || isZoom(event)) {
      return false;
    }
    if (target === container) {
      return true;
    }
    if (!isScrollable(container) && target instanceof HTMLElement && target.tagName !== 'INPUT' &&
    // #1603
    target.tagName !== 'TEXTAREA' &&
    // #2266
    !(isScrollable(getHtmlContainer()) &&
    // #1944
    getHtmlContainer().contains(target))) {
      return true;
    }
    return false;
  };

  /**
   * https://github.com/sweetalert2/sweetalert2/issues/1786
   *
   * @param {*} event
   * @returns {boolean}
   */
  var isStylus = function isStylus(event) {
    return event.touches && event.touches.length && event.touches[0].touchType === 'stylus';
  };

  /**
   * https://github.com/sweetalert2/sweetalert2/issues/1891
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */
  var isZoom = function isZoom(event) {
    return event.touches && event.touches.length > 1;
  };
  var undoIOSfix = function undoIOSfix() {
    if (hasClass(document.body, swalClasses.iosfix)) {
      var offset = parseInt(document.body.style.top, 10);
      removeClass(document.body, swalClasses.iosfix);
      document.body.style.top = '';
      document.body.scrollTop = offset * -1;
    }
  };

  /**
   * Measure scrollbar width for padding body during modal show/hide
   * https://github.com/twbs/bootstrap/blob/master/js/src/modal.js
   *
   * @returns {number}
   */
  var measureScrollbar = function measureScrollbar() {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = swalClasses['scrollbar-measure'];
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  };

  /**
   * Remember state in cases where opening and handling a modal will fiddle with it.
   * @type {number | null}
   */
  var previousBodyPadding = null;
  var fixScrollbar = function fixScrollbar() {
    // for queues, do not do this more than once
    if (previousBodyPadding !== null) {
      return;
    }
    // if the body has overflow
    if (document.body.scrollHeight > window.innerHeight) {
      // add padding so the content doesn't shift after removal of scrollbar
      previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
      document.body.style.paddingRight = previousBodyPadding + measureScrollbar() + 'px';
    }
  };
  var undoScrollbar = function undoScrollbar() {
    if (previousBodyPadding !== null) {
      document.body.style.paddingRight = previousBodyPadding + 'px';
      previousBodyPadding = null;
    }
  };

  /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */
  function removePopupAndResetState(instance, container, returnFocus, didClose) {
    if (isToast()) {
      triggerDidCloseAndDispose(instance, didClose);
    } else {
      restoreActiveElement(returnFocus).then(function () {
        return triggerDidCloseAndDispose(instance, didClose);
      });
      removeKeydownHandler(globalState);
    }
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // workaround for #2088
    // for some reason removing the container in Safari will scroll the document to bottom
    if (isSafari) {
      container.setAttribute('style', 'display:none !important');
      container.removeAttribute('class');
      container.innerHTML = '';
    } else {
      container.remove();
    }
    if (isModal()) {
      undoScrollbar();
      undoIOSfix();
      unsetAriaHidden();
    }
    removeBodyClasses();
  }

  /**
   * Remove SweetAlert2 classes from body
   */
  function removeBodyClasses() {
    removeClass([document.documentElement, document.body], [swalClasses.shown, swalClasses['height-auto'], swalClasses['no-backdrop'], swalClasses['toast-shown']]);
  }

  /**
   * Instance method to close sweetAlert
   *
   * @param {any} resolveValue
   */
  function close(resolveValue) {
    resolveValue = prepareResolveValue(resolveValue);
    var swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
    var didClose = triggerClosePopup(this);
    if (this.isAwaitingPromise) {
      // A swal awaiting for a promise (after a click on Confirm or Deny) cannot be dismissed anymore #2335
      if (!resolveValue.isDismissed) {
        handleAwaitingPromise(this);
        swalPromiseResolve(resolveValue);
      }
    } else if (didClose) {
      // Resolve Swal promise
      swalPromiseResolve(resolveValue);
    }
  }
  var triggerClosePopup = function triggerClosePopup(instance) {
    var popup = getPopup();
    if (!popup) {
      return false;
    }
    var innerParams = privateProps.innerParams.get(instance);
    if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) {
      return false;
    }
    removeClass(popup, innerParams.showClass.popup);
    addClass(popup, innerParams.hideClass.popup);
    var backdrop = getContainer();
    removeClass(backdrop, innerParams.showClass.backdrop);
    addClass(backdrop, innerParams.hideClass.backdrop);
    handlePopupAnimation(instance, popup, innerParams);
    return true;
  };

  /**
   * @param {any} error
   */
  function rejectPromise(error) {
    var rejectPromise = privateMethods.swalPromiseReject.get(this);
    handleAwaitingPromise(this);
    if (rejectPromise) {
      // Reject Swal promise
      rejectPromise(error);
    }
  }

  /**
   * @param {SweetAlert} instance
   */
  var handleAwaitingPromise = function handleAwaitingPromise(instance) {
    if (instance.isAwaitingPromise) {
      delete instance.isAwaitingPromise;
      // The instance might have been previously partly destroyed, we must resume the destroy process in this case #2335
      if (!privateProps.innerParams.get(instance)) {
        instance._destroy();
      }
    }
  };

  /**
   * @param {any} resolveValue
   * @returns {SweetAlertResult}
   */
  var prepareResolveValue = function prepareResolveValue(resolveValue) {
    // When user calls Swal.close()
    if (typeof resolveValue === 'undefined') {
      return {
        isConfirmed: false,
        isDenied: false,
        isDismissed: true
      };
    }
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({
      isConfirmed: false,
      isDenied: false,
      isDismissed: false
    }, resolveValue);
  };

  /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} innerParams
   */
  var handlePopupAnimation = function handlePopupAnimation(instance, popup, innerParams) {
    var container = getContainer();
    // If animation is supported, animate
    var animationIsSupported = animationEndEvent && hasCssAnimation(popup);
    if (typeof innerParams.willClose === 'function') {
      innerParams.willClose(popup);
    }
    if (animationIsSupported) {
      animatePopup(instance, popup, container, innerParams.returnFocus, innerParams.didClose);
    } else {
      // Otherwise, remove immediately
      removePopupAndResetState(instance, container, innerParams.returnFocus, innerParams.didClose);
    }
  };

  /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */
  var animatePopup = function animatePopup(instance, popup, container, returnFocus, didClose) {
    globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
    popup.addEventListener(animationEndEvent, function (e) {
      if (e.target === popup) {
        globalState.swalCloseEventFinishedCallback();
        delete globalState.swalCloseEventFinishedCallback;
      }
    });
  };

  /**
   * @param {SweetAlert} instance
   * @param {Function} didClose
   */
  var triggerDidCloseAndDispose = function triggerDidCloseAndDispose(instance, didClose) {
    setTimeout(function () {
      if (typeof didClose === 'function') {
        didClose.bind(instance.params)();
      }
      // instance might have been destroyed already
      if (instance._destroy) {
        instance._destroy();
      }
    });
  };

  /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   *
   * @param {HTMLButtonElement} [buttonToReplace]
   */
  var showLoading = function showLoading(buttonToReplace) {
    var popup = getPopup();
    if (!popup) {
      new Swal(); // eslint-disable-line no-new
    }

    popup = getPopup();
    var loader = getLoader();
    if (isToast()) {
      hide(getIcon());
    } else {
      replaceButton(popup, buttonToReplace);
    }
    show(loader);
    popup.setAttribute('data-loading', 'true');
    popup.setAttribute('aria-busy', 'true');
    popup.focus();
  };

  /**
   * @param {HTMLElement} popup
   * @param {HTMLButtonElement} [buttonToReplace]
   */
  var replaceButton = function replaceButton(popup, buttonToReplace) {
    var actions = getActions();
    var loader = getLoader();
    if (!buttonToReplace && isVisible$1(getConfirmButton())) {
      buttonToReplace = getConfirmButton();
    }
    show(actions);
    if (buttonToReplace) {
      hide(buttonToReplace);
      loader.setAttribute('data-button-to-replace', buttonToReplace.className);
    }
    loader.parentNode.insertBefore(loader, buttonToReplace);
    addClass([popup, actions], swalClasses.loading);
  };

  /**
   * @typedef { string | number | boolean } InputValue
   */

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var handleInputOptionsAndValue = function handleInputOptionsAndValue(instance, params) {
    if (params.input === 'select' || params.input === 'radio') {
      handleInputOptions(instance, params);
    } else if (['text', 'email', 'number', 'tel', 'textarea'].includes(params.input) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
      showLoading(getConfirmButton());
      handleInputValue(instance, params);
    }
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} innerParams
   * @returns {string | number | File | FileList | null}
   */
  var getInputValue = function getInputValue(instance, innerParams) {
    var input = instance.getInput();
    if (!input) {
      return null;
    }
    switch (innerParams.input) {
      case 'checkbox':
        return getCheckboxValue(input);
      case 'radio':
        return getRadioValue(input);
      case 'file':
        return getFileValue(input);
      default:
        return innerParams.inputAutoTrim ? input.value.trim() : input.value;
    }
  };

  /**
   * @param {HTMLInputElement} input
   * @returns {number}
   */
  var getCheckboxValue = function getCheckboxValue(input) {
    return input.checked ? 1 : 0;
  };

  /**
   * @param {HTMLInputElement} input
   * @returns {string | null}
   */
  var getRadioValue = function getRadioValue(input) {
    return input.checked ? input.value : null;
  };

  /**
   * @param {HTMLInputElement} input
   * @returns {FileList | File | null}
   */
  var getFileValue = function getFileValue(input) {
    return input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var handleInputOptions = function handleInputOptions(instance, params) {
    var popup = getPopup();
    /**
     * @param {Record<string, any>} inputOptions
     */
    var processInputOptions = function processInputOptions(inputOptions) {
      populateInputOptions[params.input](popup, formatInputOptions(inputOptions), params);
    };
    if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
      showLoading(getConfirmButton());
      asPromise(params.inputOptions).then(function (inputOptions) {
        instance.hideLoading();
        processInputOptions(inputOptions);
      });
    } else if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(params.inputOptions) === 'object') {
      processInputOptions(params.inputOptions);
    } else {
      error('Unexpected type of inputOptions! Expected object, Map or Promise, got ' + __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(params.inputOptions));
    }
  };

  /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */
  var handleInputValue = function handleInputValue(instance, params) {
    var input = instance.getInput();
    hide(input);
    asPromise(params.inputValue).then(function (inputValue) {
      input.value = params.input === 'number' ? '' + (parseFloat(inputValue) || 0) : '' + inputValue;
      show(input);
      input.focus();
      instance.hideLoading();
    }).catch(function (err) {
      error('Error in inputValue promise: ' + err);
      input.value = '';
      show(input);
      input.focus();
      instance.hideLoading();
    });
  };
  var populateInputOptions = {
    /**
     * @param {HTMLElement} popup
     * @param {Record<string, any>} inputOptions
     * @param {SweetAlertOptions} params
     */
    select: function select(popup, inputOptions, params) {
      var select = getDirectChildByClass(popup, swalClasses.select);
      /**
       * @param {HTMLElement} parent
       * @param {string} optionLabel
       * @param {string} optionValue
       */
      var renderOption = function renderOption(parent, optionLabel, optionValue) {
        var option = document.createElement('option');
        option.value = optionValue;
        setInnerHtml(option, optionLabel);
        option.selected = isSelected(optionValue, params.inputValue);
        parent.appendChild(option);
      };
      inputOptions.forEach(function (inputOption) {
        var optionValue = inputOption[0];
        var optionLabel = inputOption[1];
        // <optgroup> spec:
        // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
        // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
        // check whether this is a <optgroup>
        if (Array.isArray(optionLabel)) {
          // if it is an array, then it is an <optgroup>
          var optgroup = document.createElement('optgroup');
          optgroup.label = optionValue;
          optgroup.disabled = false; // not configurable for now
          select.appendChild(optgroup);
          optionLabel.forEach(function (o) {
            return renderOption(optgroup, o[1], o[0]);
          });
        } else {
          // case of <option>
          renderOption(select, optionLabel, optionValue);
        }
      });
      select.focus();
    },
    /**
     * @param {HTMLElement} popup
     * @param {Record<string, any>} inputOptions
     * @param {SweetAlertOptions} params
     */
    radio: function radio(popup, inputOptions, params) {
      var radio = getDirectChildByClass(popup, swalClasses.radio);
      inputOptions.forEach(function (inputOption) {
        var radioValue = inputOption[0];
        var radioLabel = inputOption[1];
        var radioInput = document.createElement('input');
        var radioLabelElement = document.createElement('label');
        radioInput.type = 'radio';
        radioInput.name = swalClasses.radio;
        radioInput.value = radioValue;
        if (isSelected(radioValue, params.inputValue)) {
          radioInput.checked = true;
        }
        var label = document.createElement('span');
        setInnerHtml(label, radioLabel);
        label.className = swalClasses.label;
        radioLabelElement.appendChild(radioInput);
        radioLabelElement.appendChild(label);
        radio.appendChild(radioLabelElement);
      });
      var radios = radio.querySelectorAll('input');
      if (radios.length) {
        radios[0].focus();
      }
    }
  };

  /**
   * Converts `inputOptions` into an array of `[value, label]`s
   *
   * @param {Record<string, any>} inputOptions
   * @returns {Array<Array<string>>}
   */
  var formatInputOptions = function formatInputOptions(inputOptions) {
    var result = [];
    if (typeof __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a !== 'undefined' && inputOptions instanceof __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_map___default.a) {
      inputOptions.forEach(function (value, key) {
        var valueFormatted = value;
        if ((typeof valueFormatted === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(valueFormatted)) === 'object') {
          // case of <optgroup>
          valueFormatted = formatInputOptions(valueFormatted);
        }
        result.push([key, valueFormatted]);
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(inputOptions).forEach(function (key) {
        var valueFormatted = inputOptions[key];
        if ((typeof valueFormatted === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(valueFormatted)) === 'object') {
          // case of <optgroup>
          valueFormatted = formatInputOptions(valueFormatted);
        }
        result.push([key, valueFormatted]);
      });
    }
    return result;
  };

  /**
   * @param {string} optionValue
   * @param {InputValue | Promise<InputValue> | { toPromise: () => InputValue }} inputValue
   * @returns {boolean}
   */
  var isSelected = function isSelected(optionValue, inputValue) {
    return inputValue && inputValue.toString() === optionValue.toString();
  };

  /**
   * @param {SweetAlert} instance
   */
  var handleConfirmButtonClick = function handleConfirmButtonClick(instance) {
    var innerParams = privateProps.innerParams.get(instance);
    instance.disableButtons();
    if (innerParams.input) {
      handleConfirmOrDenyWithInput(instance, 'confirm');
    } else {
      confirm(instance, true);
    }
  };

  /**
   * @param {SweetAlert} instance
   */
  var handleDenyButtonClick = function handleDenyButtonClick(instance) {
    var innerParams = privateProps.innerParams.get(instance);
    instance.disableButtons();
    if (innerParams.returnInputValueOnDeny) {
      handleConfirmOrDenyWithInput(instance, 'deny');
    } else {
      deny(instance, false);
    }
  };

  /**
   * @param {SweetAlert} instance
   * @param {Function} dismissWith
   */
  var handleCancelButtonClick = function handleCancelButtonClick(instance, dismissWith) {
    instance.disableButtons();
    dismissWith(DismissReason.cancel);
  };

  /**
   * @param {SweetAlert} instance
   * @param {'confirm' | 'deny'} type
   */
  var handleConfirmOrDenyWithInput = function handleConfirmOrDenyWithInput(instance, type) {
    var innerParams = privateProps.innerParams.get(instance);
    if (!innerParams.input) {
      error('The "input" parameter is needed to be set when using returnInputValueOn' + capitalizeFirstLetter(type));
      return;
    }
    var inputValue = getInputValue(instance, innerParams);
    if (innerParams.inputValidator) {
      handleInputValidator(instance, inputValue, type);
    } else if (!instance.getInput().checkValidity()) {
      instance.enableButtons();
      instance.showValidationMessage(innerParams.validationMessage);
    } else if (type === 'deny') {
      deny(instance, inputValue);
    } else {
      confirm(instance, inputValue);
    }
  };

  /**
   * @param {SweetAlert} instance
   * @param {string | number | File | FileList | null} inputValue
   * @param {'confirm' | 'deny'} type
   */
  var handleInputValidator = function handleInputValidator(instance, inputValue, type) {
    var innerParams = privateProps.innerParams.get(instance);
    instance.disableInput();
    var validationPromise = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a.resolve().then(function () {
      return asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage));
    });
    validationPromise.then(function (validationMessage) {
      instance.enableButtons();
      instance.enableInput();
      if (validationMessage) {
        instance.showValidationMessage(validationMessage);
      } else if (type === 'deny') {
        deny(instance, inputValue);
      } else {
        confirm(instance, inputValue);
      }
    });
  };

  /**
   * @param {SweetAlert} instance
   * @param {any} value
   */
  var deny = function deny(instance, value) {
    var innerParams = privateProps.innerParams.get(instance || undefined);
    if (innerParams.showLoaderOnDeny) {
      showLoading(getDenyButton());
    }
    if (innerParams.preDeny) {
      instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preDeny's promise is received
      var preDenyPromise = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        return asPromise(innerParams.preDeny(value, innerParams.validationMessage));
      });
      preDenyPromise.then(function (preDenyValue) {
        if (preDenyValue === false) {
          instance.hideLoading();
          handleAwaitingPromise(instance);
        } else {
          instance.close({
            isDenied: true,
            value: typeof preDenyValue === 'undefined' ? value : preDenyValue
          });
        }
      }).catch(function (error) {
        return rejectWith(instance || undefined, error);
      });
    } else {
      instance.close({
        isDenied: true,
        value: value
      });
    }
  };

  /**
   * @param {SweetAlert} instance
   * @param {any} value
   */
  var succeedWith = function succeedWith(instance, value) {
    instance.close({
      isConfirmed: true,
      value: value
    });
  };

  /**
   *
   * @param {SweetAlert} instance
   * @param {string} error
   */
  var rejectWith = function rejectWith(instance, error) {
    instance.rejectPromise(error);
  };

  /**
   *
   * @param {SweetAlert} instance
   * @param {any} value
   */
  var confirm = function confirm(instance, value) {
    var innerParams = privateProps.innerParams.get(instance || undefined);
    if (innerParams.showLoaderOnConfirm) {
      showLoading();
    }
    if (innerParams.preConfirm) {
      instance.resetValidationMessage();
      instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preConfirm's promise is received
      var preConfirmPromise = __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        return asPromise(innerParams.preConfirm(value, innerParams.validationMessage));
      });
      preConfirmPromise.then(function (preConfirmValue) {
        if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
          instance.hideLoading();
          handleAwaitingPromise(instance);
        } else {
          succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
        }
      }).catch(function (error) {
        return rejectWith(instance || undefined, error);
      });
    } else {
      succeedWith(instance, value);
    }
  };

  /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   */
  function hideLoading() {
    // do nothing if popup is closed
    var innerParams = privateProps.innerParams.get(this);
    if (!innerParams) {
      return;
    }
    var domCache = privateProps.domCache.get(this);
    hide(domCache.loader);
    if (isToast()) {
      if (innerParams.icon) {
        show(getIcon());
      }
    } else {
      showRelatedButton(domCache);
    }
    removeClass([domCache.popup, domCache.actions], swalClasses.loading);
    domCache.popup.removeAttribute('aria-busy');
    domCache.popup.removeAttribute('data-loading');
    domCache.confirmButton.disabled = false;
    domCache.denyButton.disabled = false;
    domCache.cancelButton.disabled = false;
  }
  var showRelatedButton = function showRelatedButton(domCache) {
    var buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute('data-button-to-replace'));
    if (buttonToReplace.length) {
      show(buttonToReplace[0], 'inline-block');
    } else if (allButtonsAreHidden()) {
      hide(domCache.actions);
    }
  };

  /**
   * Gets the input DOM node, this method works with input parameter.
   *
   * @returns {HTMLInputElement | null}
   */
  function getInput() {
    var innerParams = privateProps.innerParams.get(this);
    var domCache = privateProps.domCache.get(this);
    if (!domCache) {
      return null;
    }
    return getInput$1(domCache.popup, innerParams.input);
  }

  /**
   * @param {SweetAlert} instance
   * @param {string[]} buttons
   * @param {boolean} disabled
   */
  function setButtonsDisabled(instance, buttons, disabled) {
    var domCache = privateProps.domCache.get(instance);
    buttons.forEach(function (button) {
      domCache[button].disabled = disabled;
    });
  }

  /**
   * @param {HTMLInputElement} input
   * @param {boolean} disabled
   */
  function setInputDisabled(input, disabled) {
    if (!input) {
      return;
    }
    if (input.type === 'radio') {
      var radiosContainer = input.parentNode.parentNode;
      var radios = radiosContainer.querySelectorAll('input');
      for (var i = 0; i < radios.length; i++) {
        radios[i].disabled = disabled;
      }
    } else {
      input.disabled = disabled;
    }
  }

  /**
   * Enable all the buttons
   */
  function enableButtons() {
    setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], false);
  }

  /**
   * Disable all the buttons
   */
  function disableButtons() {
    setButtonsDisabled(this, ['confirmButton', 'denyButton', 'cancelButton'], true);
  }

  /**
   * Enable the input field
   */
  function enableInput() {
    setInputDisabled(this.getInput(), false);
  }

  /**
   * Disable the input field
   */
  function disableInput() {
    setInputDisabled(this.getInput(), true);
  }

  /**
   * Show block with validation message
   *
   * @param {string} error
   */
  function showValidationMessage(error) {
    var domCache = privateProps.domCache.get(this);
    var params = privateProps.innerParams.get(this);
    setInnerHtml(domCache.validationMessage, error);
    domCache.validationMessage.className = swalClasses['validation-message'];
    if (params.customClass && params.customClass.validationMessage) {
      addClass(domCache.validationMessage, params.customClass.validationMessage);
    }
    show(domCache.validationMessage);
    var input = this.getInput();
    if (input) {
      input.setAttribute('aria-invalid', true);
      input.setAttribute('aria-describedby', swalClasses['validation-message']);
      focusInput(input);
      addClass(input, swalClasses.inputerror);
    }
  }

  /**
   * Hide block with validation message
   */
  function resetValidationMessage() {
    var domCache = privateProps.domCache.get(this);
    if (domCache.validationMessage) {
      hide(domCache.validationMessage);
    }
    var input = this.getInput();
    if (input) {
      input.removeAttribute('aria-invalid');
      input.removeAttribute('aria-describedby');
      removeClass(input, swalClasses.inputerror);
    }
  }

  var defaultParams = {
    title: '',
    titleText: '',
    text: '',
    html: '',
    footer: '',
    icon: undefined,
    iconColor: undefined,
    iconHtml: undefined,
    template: undefined,
    toast: false,
    showClass: {
      popup: 'swal2-show',
      backdrop: 'swal2-backdrop-show',
      icon: 'swal2-icon-show'
    },
    hideClass: {
      popup: 'swal2-hide',
      backdrop: 'swal2-backdrop-hide',
      icon: 'swal2-icon-hide'
    },
    customClass: {},
    target: 'body',
    color: undefined,
    backdrop: true,
    heightAuto: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    allowEnterKey: true,
    stopKeydownPropagation: true,
    keydownListenerCapture: false,
    showConfirmButton: true,
    showDenyButton: false,
    showCancelButton: false,
    preConfirm: undefined,
    preDeny: undefined,
    confirmButtonText: 'OK',
    confirmButtonAriaLabel: '',
    confirmButtonColor: undefined,
    denyButtonText: 'No',
    denyButtonAriaLabel: '',
    denyButtonColor: undefined,
    cancelButtonText: 'Cancel',
    cancelButtonAriaLabel: '',
    cancelButtonColor: undefined,
    buttonsStyling: true,
    reverseButtons: false,
    focusConfirm: true,
    focusDeny: false,
    focusCancel: false,
    returnFocus: true,
    showCloseButton: false,
    closeButtonHtml: '&times;',
    closeButtonAriaLabel: 'Close this dialog',
    loaderHtml: '',
    showLoaderOnConfirm: false,
    showLoaderOnDeny: false,
    imageUrl: undefined,
    imageWidth: undefined,
    imageHeight: undefined,
    imageAlt: '',
    timer: undefined,
    timerProgressBar: false,
    width: undefined,
    padding: undefined,
    background: undefined,
    input: undefined,
    inputPlaceholder: '',
    inputLabel: '',
    inputValue: '',
    inputOptions: {},
    inputAutoFocus: true,
    inputAutoTrim: true,
    inputAttributes: {},
    inputValidator: undefined,
    returnInputValueOnDeny: false,
    validationMessage: undefined,
    grow: false,
    position: 'center',
    progressSteps: [],
    currentProgressStep: undefined,
    progressStepsDistance: undefined,
    willOpen: undefined,
    didOpen: undefined,
    didRender: undefined,
    willClose: undefined,
    didClose: undefined,
    didDestroy: undefined,
    scrollbarPadding: true
  };
  var updatableParams = ['allowEscapeKey', 'allowOutsideClick', 'background', 'buttonsStyling', 'cancelButtonAriaLabel', 'cancelButtonColor', 'cancelButtonText', 'closeButtonAriaLabel', 'closeButtonHtml', 'color', 'confirmButtonAriaLabel', 'confirmButtonColor', 'confirmButtonText', 'currentProgressStep', 'customClass', 'denyButtonAriaLabel', 'denyButtonColor', 'denyButtonText', 'didClose', 'didDestroy', 'footer', 'hideClass', 'html', 'icon', 'iconColor', 'iconHtml', 'imageAlt', 'imageHeight', 'imageUrl', 'imageWidth', 'preConfirm', 'preDeny', 'progressSteps', 'returnFocus', 'reverseButtons', 'showCancelButton', 'showCloseButton', 'showConfirmButton', 'showDenyButton', 'text', 'title', 'titleText', 'willClose'];

  /** @type {Record<string, string>} */
  var deprecatedParams = {};
  var toastIncompatibleParams = ['allowOutsideClick', 'allowEnterKey', 'backdrop', 'focusConfirm', 'focusDeny', 'focusCancel', 'returnFocus', 'heightAuto', 'keydownListenerCapture'];

  /**
   * Is valid parameter
   *
   * @param {string} paramName
   * @returns {boolean}
   */
  var isValidParameter = function isValidParameter(paramName) {
    return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
  };

  /**
   * Is valid parameter for Swal.update() method
   *
   * @param {string} paramName
   * @returns {boolean}
   */
  var isUpdatableParameter = function isUpdatableParameter(paramName) {
    return updatableParams.indexOf(paramName) !== -1;
  };

  /**
   * Is deprecated parameter
   *
   * @param {string} paramName
   * @returns {string | undefined}
   */
  var isDeprecatedParameter = function isDeprecatedParameter(paramName) {
    return deprecatedParams[paramName];
  };

  /**
   * @param {string} param
   */
  var checkIfParamIsValid = function checkIfParamIsValid(param) {
    if (!isValidParameter(param)) {
      warn('Unknown parameter "' + param + '"');
    }
  };

  /**
   * @param {string} param
   */
  var checkIfToastParamIsValid = function checkIfToastParamIsValid(param) {
    if (toastIncompatibleParams.includes(param)) {
      warn('The parameter "' + param + '" is incompatible with toasts');
    }
  };

  /**
   * @param {string} param
   */
  var checkIfParamIsDeprecated = function checkIfParamIsDeprecated(param) {
    var isDeprecated = isDeprecatedParameter(param);
    if (isDeprecated) {
      warnAboutDeprecation(param, isDeprecated);
    }
  };

  /**
   * Show relevant warnings for given params
   *
   * @param {SweetAlertOptions} params
   */
  var showWarningsForParams = function showWarningsForParams(params) {
    if (params.backdrop === false && params.allowOutsideClick) {
      warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
    }
    for (var param in params) {
      checkIfParamIsValid(param);
      if (params.toast) {
        checkIfToastParamIsValid(param);
      }
      checkIfParamIsDeprecated(param);
    }
  };

  /**
   * Updates popup parameters.
   *
   * @param {SweetAlertOptions} params
   */
  function update(params) {
    var popup = getPopup();
    var innerParams = privateProps.innerParams.get(this);
    if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
      warn('You\'re trying to update the closed or closing popup, that won\'t work. Use the update() method in preConfirm parameter or show a new popup.');
      return;
    }
    var validUpdatableParams = filterValidParams(params);
    var updatedParams = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, innerParams, validUpdatableParams);
    render(this, updatedParams);
    privateProps.innerParams.set(this, updatedParams);
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_define_properties___default()(this, {
      params: {
        value: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, this.params, params),
        writable: false,
        enumerable: true
      }
    });
  }

  /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */
  var filterValidParams = function filterValidParams(params) {
    var validUpdatableParams = {};
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(params).forEach(function (param) {
      if (isUpdatableParameter(param)) {
        validUpdatableParams[param] = params[param];
      } else {
        warn('Invalid parameter to update: ' + param);
      }
    });
    return validUpdatableParams;
  };

  /**
   * Dispose the current SweetAlert2 instance
   */
  function _destroy() {
    var domCache = privateProps.domCache.get(this);
    var innerParams = privateProps.innerParams.get(this);
    if (!innerParams) {
      disposeWeakMaps(this); // The WeakMaps might have been partly destroyed, we must recall it to dispose any remaining WeakMaps #2335
      return; // This instance has already been destroyed
    }

    // Check if there is another Swal closing
    if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
      globalState.swalCloseEventFinishedCallback();
      delete globalState.swalCloseEventFinishedCallback;
    }
    if (typeof innerParams.didDestroy === 'function') {
      innerParams.didDestroy();
    }
    disposeSwal(this);
  }

  /**
   * @param {SweetAlert} instance
   */
  var disposeSwal = function disposeSwal(instance) {
    disposeWeakMaps(instance);
    // Unset this.params so GC will dispose it (#1569)
    delete instance.params;
    // Unset globalState props so GC will dispose globalState (#1569)
    delete globalState.keydownHandler;
    delete globalState.keydownTarget;
    // Unset currentInstance
    delete globalState.currentInstance;
  };

  /**
   * @param {SweetAlert} instance
   */
  var disposeWeakMaps = function disposeWeakMaps(instance) {
    // If the current instance is awaiting a promise result, we keep the privateMethods to call them once the promise result is retrieved #2335
    if (instance.isAwaitingPromise) {
      unsetWeakMaps(privateProps, instance);
      instance.isAwaitingPromise = true;
    } else {
      unsetWeakMaps(privateMethods, instance);
      unsetWeakMaps(privateProps, instance);
      delete instance.isAwaitingPromise;
      // Unset instance methods
      delete instance.disableButtons;
      delete instance.enableButtons;
      delete instance.getInput;
      delete instance.disableInput;
      delete instance.enableInput;
      delete instance.hideLoading;
      delete instance.disableLoading;
      delete instance.showValidationMessage;
      delete instance.resetValidationMessage;
      delete instance.close;
      delete instance.closePopup;
      delete instance.closeModal;
      delete instance.closeToast;
      delete instance.rejectPromise;
      delete instance.update;
      delete instance._destroy;
    }
  };

  /**
   * @param {object} obj
   * @param {SweetAlert} instance
   */
  var unsetWeakMaps = function unsetWeakMaps(obj, instance) {
    for (var i in obj) {
      obj[i].delete(instance);
    }
  };

  var instanceMethods = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_freeze___default()({
    __proto__: null,
    _destroy: _destroy,
    close: close,
    closeModal: close,
    closePopup: close,
    closeToast: close,
    disableButtons: disableButtons,
    disableInput: disableInput,
    disableLoading: hideLoading,
    enableButtons: enableButtons,
    enableInput: enableInput,
    getInput: getInput,
    handleAwaitingPromise: handleAwaitingPromise,
    hideLoading: hideLoading,
    rejectPromise: rejectPromise,
    resetValidationMessage: resetValidationMessage,
    showValidationMessage: showValidationMessage,
    update: update
  });

  var handlePopupClick = function handlePopupClick(instance, domCache, dismissWith) {
    var innerParams = privateProps.innerParams.get(instance);
    if (innerParams.toast) {
      handleToastClick(instance, domCache, dismissWith);
    } else {
      // Ignore click events that had mousedown on the popup but mouseup on the container
      // This can happen when the user drags a slider
      handleModalMousedown(domCache);

      // Ignore click events that had mousedown on the container but mouseup on the popup
      handleContainerMousedown(domCache);
      handleModalClick(instance, domCache, dismissWith);
    }
  };
  var handleToastClick = function handleToastClick(instance, domCache, dismissWith) {
    // Closing toast by internal click
    domCache.popup.onclick = function () {
      var innerParams = privateProps.innerParams.get(instance);
      if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) {
        return;
      }
      dismissWith(DismissReason.close);
    };
  };

  /**
   * @param {*} innerParams
   * @returns {boolean}
   */
  var isAnyButtonShown = function isAnyButtonShown(innerParams) {
    return innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton;
  };
  var ignoreOutsideClick = false;
  var handleModalMousedown = function handleModalMousedown(domCache) {
    domCache.popup.onmousedown = function () {
      domCache.container.onmouseup = function (e) {
        domCache.container.onmouseup = undefined;
        // We only check if the mouseup target is the container because usually it doesn't
        // have any other direct children aside of the popup
        if (e.target === domCache.container) {
          ignoreOutsideClick = true;
        }
      };
    };
  };
  var handleContainerMousedown = function handleContainerMousedown(domCache) {
    domCache.container.onmousedown = function () {
      domCache.popup.onmouseup = function (e) {
        domCache.popup.onmouseup = undefined;
        // We also need to check if the mouseup target is a child of the popup
        if (e.target === domCache.popup || domCache.popup.contains(e.target)) {
          ignoreOutsideClick = true;
        }
      };
    };
  };
  var handleModalClick = function handleModalClick(instance, domCache, dismissWith) {
    domCache.container.onclick = function (e) {
      var innerParams = privateProps.innerParams.get(instance);
      if (ignoreOutsideClick) {
        ignoreOutsideClick = false;
        return;
      }
      if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) {
        dismissWith(DismissReason.backdrop);
      }
    };
  };

  var isJqueryElement = function isJqueryElement(elem) {
    return (typeof elem === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(elem)) === 'object' && elem.jquery;
  };
  var isElement = function isElement(elem) {
    return elem instanceof Element || isJqueryElement(elem);
  };
  var argsToParams = function argsToParams(args) {
    var params = {};
    if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(args[0]) === 'object' && !isElement(args[0])) {
      __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()(params, args[0]);
    } else {
      ['title', 'html', 'icon'].forEach(function (name, index) {
        var arg = args[index];
        if (typeof arg === 'string' || isElement(arg)) {
          params[name] = arg;
        } else if (arg !== undefined) {
          error('Unexpected type of ' + name + '! Expected "string" or "Element", got ' + (typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(arg)));
        }
      });
    }
    return params;
  };

  /**
   * Main method to create a new SweetAlert2 popup
   *
   * @param  {...SweetAlertOptions} args
   * @returns {Promise<SweetAlertResult>}
   */
  function fire() {
    var Swal = this; // eslint-disable-line @typescript-eslint/no-this-alias
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return new (Function.prototype.bind.apply(Swal, [null].concat(args)))();
  }

  /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlert}
   */
  function mixin(mixinParams) {
    var MixinSwal = function (_ref) {
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(MixinSwal, _ref);

      function MixinSwal() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MixinSwal);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MixinSwal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MixinSwal)).apply(this, arguments));
      }

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MixinSwal, [{
        key: '_main',
        value: function _main(params, priorityMixinParams) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(MixinSwal.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MixinSwal.prototype), '_main', this).call(this, params, __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, mixinParams, priorityMixinParams));
        }
      }]);

      return MixinSwal;
    }(this);
    // @ts-ignore


    return MixinSwal;
  }

  /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   *
   * @returns {number | undefined}
   */
  var getTimerLeft = function getTimerLeft() {
    return globalState.timeout && globalState.timeout.getTimerLeft();
  };

  /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */
  var stopTimer = function stopTimer() {
    if (globalState.timeout) {
      stopTimerProgressBar();
      return globalState.timeout.stop();
    }
  };

  /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */
  var resumeTimer = function resumeTimer() {
    if (globalState.timeout) {
      var remaining = globalState.timeout.start();
      animateTimerProgressBar(remaining);
      return remaining;
    }
  };

  /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */
  var toggleTimer = function toggleTimer() {
    var timer = globalState.timeout;
    return timer && (timer.running ? stopTimer() : resumeTimer());
  };

  /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @param {number} n
   * @returns {number | undefined}
   */
  var increaseTimer = function increaseTimer(n) {
    if (globalState.timeout) {
      var remaining = globalState.timeout.increase(n);
      animateTimerProgressBar(remaining, true);
      return remaining;
    }
  };

  /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   *
   * @returns {boolean}
   */
  var isTimerRunning = function isTimerRunning() {
    return !!(globalState.timeout && globalState.timeout.isRunning());
  };

  var bodyClickListenerAdded = false;
  var clickHandlers = {};

  /**
   * @param {string} attr
   */
  function bindClickHandler() {
    var attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-swal-template';
    clickHandlers[attr] = this;
    if (!bodyClickListenerAdded) {
      document.body.addEventListener('click', bodyClickListener);
      bodyClickListenerAdded = true;
    }
  }
  var bodyClickListener = function bodyClickListener(event) {
    for (var el = event.target; el && el !== document; el = el.parentNode) {
      for (var attr in clickHandlers) {
        var template = el.getAttribute(attr);
        if (template) {
          clickHandlers[attr].fire({
            template: template
          });
          return;
        }
      }
    }
  };

  var staticMethods = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_freeze___default()({
    __proto__: null,
    argsToParams: argsToParams,
    bindClickHandler: bindClickHandler,
    clickCancel: clickCancel,
    clickConfirm: clickConfirm,
    clickDeny: clickDeny,
    enableLoading: showLoading,
    fire: fire,
    getActions: getActions,
    getCancelButton: getCancelButton,
    getCloseButton: getCloseButton,
    getConfirmButton: getConfirmButton,
    getContainer: getContainer,
    getDenyButton: getDenyButton,
    getFocusableElements: getFocusableElements,
    getFooter: getFooter,
    getHtmlContainer: getHtmlContainer,
    getIcon: getIcon,
    getIconContent: getIconContent,
    getImage: getImage,
    getInputLabel: getInputLabel,
    getLoader: getLoader,
    getPopup: getPopup,
    getProgressSteps: getProgressSteps,
    getTimerLeft: getTimerLeft,
    getTimerProgressBar: getTimerProgressBar,
    getTitle: getTitle,
    getValidationMessage: getValidationMessage,
    increaseTimer: increaseTimer,
    isDeprecatedParameter: isDeprecatedParameter,
    isLoading: isLoading,
    isTimerRunning: isTimerRunning,
    isUpdatableParameter: isUpdatableParameter,
    isValidParameter: isValidParameter,
    isVisible: isVisible,
    mixin: mixin,
    resumeTimer: resumeTimer,
    showLoading: showLoading,
    stopTimer: stopTimer,
    toggleTimer: toggleTimer
  });

  var Timer = function () {
    /**
     * @param {Function} callback
     * @param {number} delay
     */
    function Timer(callback, delay) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Timer);

      this.callback = callback;
      this.remaining = delay;
      this.running = false;
      this.start();
    }

    /**
     * @returns {number}
     */


    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Timer, [{
      key: 'start',
      value: function start() {
        if (!this.running) {
          this.running = true;
          this.started = new Date();
          this.id = setTimeout(this.callback, this.remaining);
        }
        return this.remaining;
      }

      /**
       * @returns {number}
       */

    }, {
      key: 'stop',
      value: function stop() {
        if (this.started && this.running) {
          this.running = false;
          clearTimeout(this.id);
          this.remaining -= new Date().getTime() - this.started.getTime();
        }
        return this.remaining;
      }

      /**
       * @param {number} n
       * @returns {number}
       */

    }, {
      key: 'increase',
      value: function increase(n) {
        var running = this.running;
        if (running) {
          this.stop();
        }
        this.remaining += n;
        if (running) {
          this.start();
        }
        return this.remaining;
      }

      /**
       * @returns {number}
       */

    }, {
      key: 'getTimerLeft',
      value: function getTimerLeft() {
        if (this.running) {
          this.stop();
          this.start();
        }
        return this.remaining;
      }

      /**
       * @returns {boolean}
       */

    }, {
      key: 'isRunning',
      value: function isRunning() {
        return this.running;
      }
    }]);

    return Timer;
  }();

  var swalStringParams = ['swal-title', 'swal-html', 'swal-footer'];

  /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */
  var getTemplateParams = function getTemplateParams(params) {
    /** @type {HTMLTemplateElement} */
    var template = typeof params.template === 'string' ? document.querySelector(params.template) : params.template;
    if (!template) {
      return {};
    }
    /** @type {DocumentFragment} */
    var templateContent = template.content;
    showWarningsForElements(templateContent);
    var result = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
    return result;
  };

  /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */
  var getSwalParams = function getSwalParams(templateContent) {
    var result = {};
    /** @type {HTMLElement[]} */
    var swalParams = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(templateContent.querySelectorAll('swal-param'));
    swalParams.forEach(function (param) {
      showWarningsForAttributes(param, ['name', 'value']);
      var paramName = param.getAttribute('name');
      var value = param.getAttribute('value');
      if (typeof defaultParams[paramName] === 'boolean') {
        result[paramName] = value !== 'false';
      } else if (__WEBPACK_IMPORTED_MODULE_17_babel_runtime_helpers_typeof___default()(defaultParams[paramName]) === 'object') {
        result[paramName] = JSON.parse(value);
      } else {
        result[paramName] = value;
      }
    });
    return result;
  };

  /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */
  var getSwalFunctionParams = function getSwalFunctionParams(templateContent) {
    var result = {};
    /** @type {HTMLElement[]} */
    var swalFunctions = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(templateContent.querySelectorAll('swal-function-param'));
    swalFunctions.forEach(function (param) {
      var paramName = param.getAttribute('name');
      var value = param.getAttribute('value');
      result[paramName] = new Function('return ' + value)();
    });
    return result;
  };

  /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */
  var getSwalButtons = function getSwalButtons(templateContent) {
    var result = {};
    /** @type {HTMLElement[]} */
    var swalButtons = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(templateContent.querySelectorAll('swal-button'));
    swalButtons.forEach(function (button) {
      showWarningsForAttributes(button, ['type', 'color', 'aria-label']);
      var type = button.getAttribute('type');
      result[type + 'ButtonText'] = button.innerHTML;
      result['show' + capitalizeFirstLetter(type) + 'Button'] = true;
      if (button.hasAttribute('color')) {
        result[type + 'ButtonColor'] = button.getAttribute('color');
      }
      if (button.hasAttribute('aria-label')) {
        result[type + 'ButtonAriaLabel'] = button.getAttribute('aria-label');
      }
    });
    return result;
  };

  /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */
  var getSwalImage = function getSwalImage(templateContent) {
    var result = {};
    /** @type {HTMLElement} */
    var image = templateContent.querySelector('swal-image');
    if (image) {
      showWarningsForAttributes(image, ['src', 'width', 'height', 'alt']);
      if (image.hasAttribute('src')) {
        result.imageUrl = image.getAttribute('src');
      }
      if (image.hasAttribute('width')) {
        result.imageWidth = image.getAttribute('width');
      }
      if (image.hasAttribute('height')) {
        result.imageHeight = image.getAttribute('height');
      }
      if (image.hasAttribute('alt')) {
        result.imageAlt = image.getAttribute('alt');
      }
    }
    return result;
  };

  /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */
  var getSwalIcon = function getSwalIcon(templateContent) {
    var result = {};
    /** @type {HTMLElement} */
    var icon = templateContent.querySelector('swal-icon');
    if (icon) {
      showWarningsForAttributes(icon, ['type', 'color']);
      if (icon.hasAttribute('type')) {
        /** @type {SweetAlertIcon} */
        // @ts-ignore
        result.icon = icon.getAttribute('type');
      }
      if (icon.hasAttribute('color')) {
        result.iconColor = icon.getAttribute('color');
      }
      result.iconHtml = icon.innerHTML;
    }
    return result;
  };

  /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */
  var getSwalInput = function getSwalInput(templateContent) {
    var result = {};
    /** @type {HTMLElement} */
    var input = templateContent.querySelector('swal-input');
    if (input) {
      showWarningsForAttributes(input, ['type', 'label', 'placeholder', 'value']);
      /** @type {SweetAlertInput} */
      // @ts-ignore
      result.input = input.getAttribute('type') || 'text';
      if (input.hasAttribute('label')) {
        result.inputLabel = input.getAttribute('label');
      }
      if (input.hasAttribute('placeholder')) {
        result.inputPlaceholder = input.getAttribute('placeholder');
      }
      if (input.hasAttribute('value')) {
        result.inputValue = input.getAttribute('value');
      }
    }
    /** @type {HTMLElement[]} */
    var inputOptions = __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(templateContent.querySelectorAll('swal-input-option'));
    if (inputOptions.length) {
      result.inputOptions = {};
      inputOptions.forEach(function (option) {
        showWarningsForAttributes(option, ['value']);
        var optionValue = option.getAttribute('value');
        var optionName = option.innerHTML;
        result.inputOptions[optionValue] = optionName;
      });
    }
    return result;
  };

  /**
   * @param {DocumentFragment} templateContent
   * @param {string[]} paramNames
   * @returns {SweetAlertOptions}
   */
  var getSwalStringParams = function getSwalStringParams(templateContent, paramNames) {
    var result = {};
    for (var i in paramNames) {
      var paramName = paramNames[i];
      /** @type {HTMLElement} */
      var tag = templateContent.querySelector(paramName);
      if (tag) {
        showWarningsForAttributes(tag, []);
        result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
      }
    }
    return result;
  };

  /**
   * @param {DocumentFragment} templateContent
   */
  var showWarningsForElements = function showWarningsForElements(templateContent) {
    var allowedElements = swalStringParams.concat(['swal-param', 'swal-function-param', 'swal-button', 'swal-image', 'swal-icon', 'swal-input', 'swal-input-option']);
    __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(templateContent.children).forEach(function (el) {
      var tagName = el.tagName.toLowerCase();
      if (!allowedElements.includes(tagName)) {
        warn('Unrecognized element <' + tagName + '>');
      }
    });
  };

  /**
   * @param {HTMLElement} el
   * @param {string[]} allowedAttributes
   */
  var showWarningsForAttributes = function showWarningsForAttributes(el, allowedAttributes) {
    __WEBPACK_IMPORTED_MODULE_14_babel_runtime_core_js_array_from___default()(el.attributes).forEach(function (attribute) {
      if (allowedAttributes.indexOf(attribute.name) === -1) {
        warn(['Unrecognized attribute "' + attribute.name + '" on <' + el.tagName.toLowerCase() + '>.', '' + (allowedAttributes.length ? 'Allowed attributes are: ' + allowedAttributes.join(', ') : 'To set the value, use HTML within the element.')]);
      }
    });
  };

  var SHOW_CLASS_TIMEOUT = 10;

  /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param {SweetAlertOptions} params
   */
  var openPopup = function openPopup(params) {
    var container = getContainer();
    var popup = getPopup();
    if (typeof params.willOpen === 'function') {
      params.willOpen(popup);
    }
    var bodyStyles = window.getComputedStyle(document.body);
    var initialBodyOverflow = bodyStyles.overflowY;
    addClasses(container, popup, params);

    // scrolling is 'hidden' until animation is done, after that 'auto'
    setTimeout(function () {
      setScrollingVisibility(container, popup);
    }, SHOW_CLASS_TIMEOUT);
    if (isModal()) {
      fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
      setAriaHidden();
    }
    if (!isToast() && !globalState.previousActiveElement) {
      globalState.previousActiveElement = document.activeElement;
    }
    if (typeof params.didOpen === 'function') {
      setTimeout(function () {
        return params.didOpen(popup);
      });
    }
    removeClass(container, swalClasses['no-transition']);
  };

  /**
   * @param {AnimationEvent} event
   */
  var swalOpenAnimationFinished = function swalOpenAnimationFinished(event) {
    var popup = getPopup();
    if (event.target !== popup) {
      return;
    }
    var container = getContainer();
    popup.removeEventListener(animationEndEvent, swalOpenAnimationFinished);
    container.style.overflowY = 'auto';
  };

  /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   */
  var setScrollingVisibility = function setScrollingVisibility(container, popup) {
    if (animationEndEvent && hasCssAnimation(popup)) {
      container.style.overflowY = 'hidden';
      popup.addEventListener(animationEndEvent, swalOpenAnimationFinished);
    } else {
      container.style.overflowY = 'auto';
    }
  };

  /**
   * @param {HTMLElement} container
   * @param {boolean} scrollbarPadding
   * @param {string} initialBodyOverflow
   */
  var fixScrollContainer = function fixScrollContainer(container, scrollbarPadding, initialBodyOverflow) {
    iOSfix();
    if (scrollbarPadding && initialBodyOverflow !== 'hidden') {
      fixScrollbar();
    }

    // sweetalert2/issues/1247
    setTimeout(function () {
      container.scrollTop = 0;
    });
  };

  /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */
  var addClasses = function addClasses(container, popup, params) {
    addClass(container, params.showClass.backdrop);
    // this workaround with opacity is needed for https://github.com/sweetalert2/sweetalert2/issues/2059
    popup.style.setProperty('opacity', '0', 'important');
    show(popup, 'grid');
    setTimeout(function () {
      // Animate popup right after showing it
      addClass(popup, params.showClass.popup);
      // and remove the opacity workaround
      popup.style.removeProperty('opacity');
    }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062

    addClass([document.documentElement, document.body], swalClasses.shown);
    if (params.heightAuto && params.backdrop && !params.toast) {
      addClass([document.documentElement, document.body], swalClasses['height-auto']);
    }
  };

  var defaultInputValidators = {
    /**
     * @param {string} string
     * @param {string} validationMessage
     * @returns {Promise<void | string>}
     */
    email: function email(string, validationMessage) {
      return (/^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(string) ? __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a.resolve(validationMessage || 'Invalid email address')
      );
    },
    /**
     * @param {string} string
     * @param {string} validationMessage
     * @returns {Promise<void | string>}
     */
    url: function url(string, validationMessage) {
      // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
      return (/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a.resolve() : __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a.resolve(validationMessage || 'Invalid URL')
      );
    }
  };

  /**
   * @param {SweetAlertOptions} params
   */
  function setDefaultInputValidators(params) {
    // Use default `inputValidator` for supported input types if not provided
    if (!params.inputValidator) {
      __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(defaultInputValidators).forEach(function (key) {
        if (params.input === key) {
          params.inputValidator = defaultInputValidators[key];
        }
      });
    }
  }

  /**
   * @param {SweetAlertOptions} params
   */
  function validateCustomTargetElement(params) {
    // Determine if the custom target element is valid
    if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
      warn('Target parameter is not valid, defaulting to "body"');
      params.target = 'body';
    }
  }

  /**
   * Set type, text and actions on popup
   *
   * @param {SweetAlertOptions} params
   */
  function setParameters(params) {
    setDefaultInputValidators(params);

    // showLoaderOnConfirm && preConfirm
    if (params.showLoaderOnConfirm && !params.preConfirm) {
      warn('showLoaderOnConfirm is set to true, but preConfirm is not defined.\n' + 'showLoaderOnConfirm should be used together with preConfirm, see usage example:\n' + 'https://sweetalert2.github.io/#ajax-request');
    }
    validateCustomTargetElement(params);

    // Replace newlines with <br> in title
    if (typeof params.title === 'string') {
      params.title = params.title.split('\n').join('<br />');
    }
    init(params);
  }

  /** @type {SweetAlert} */
  var currentInstance = void 0;

  var SweetAlert = function () {
    /**
     * @param {...any} args
     * @this {SweetAlert}
     */
    function SweetAlert() {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SweetAlert);

      // Prevent run in Node env
      if (typeof window === 'undefined') {
        return;
      }
      currentInstance = this;

      // @ts-ignore
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var outerParams = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_freeze___default()(this.constructor.argsToParams(args));

      /** @type {Readonly<SweetAlertOptions>} */
      this.params = outerParams;

      /** @type {boolean} */
      this.isAwaitingPromise = false;
      var promise = currentInstance._main(currentInstance.params);
      privateProps.promise.set(this, promise);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SweetAlert, [{
      key: '_main',
      value: function _main(userParams) {
        var mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        showWarningsForParams(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, mixinParams, userParams));
        if (globalState.currentInstance) {
          globalState.currentInstance._destroy();
          if (isModal()) {
            unsetAriaHidden();
          }
        }
        globalState.currentInstance = currentInstance;
        var innerParams = prepareParams(userParams, mixinParams);
        setParameters(innerParams);
        __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_object_freeze___default()(innerParams);

        // clear the previous timer
        if (globalState.timeout) {
          globalState.timeout.stop();
          delete globalState.timeout;
        }

        // clear the restore focus timeout
        clearTimeout(globalState.restoreFocusTimeout);
        var domCache = populateDomCache(currentInstance);
        render(currentInstance, innerParams);
        privateProps.innerParams.set(currentInstance, innerParams);
        return swalPromise(currentInstance, domCache, innerParams);
      }

      // `catch` cannot be the name of a module export, so we define our thenable methods here instead

    }, {
      key: 'then',
      value: function then(onFulfilled) {
        var promise = privateProps.promise.get(this);
        return promise.then(onFulfilled);
      }
    }, {
      key: 'finally',
      value: function _finally(onFinally) {
        var promise = privateProps.promise.get(this);
        return promise.finally(onFinally);
      }
    }]);

    return SweetAlert;
  }();

  /**
   * @param {SweetAlert} instance
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {Promise}
   */


  var swalPromise = function swalPromise(instance, domCache, innerParams) {
    return new __WEBPACK_IMPORTED_MODULE_16_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      // functions to handle all closings/dismissals
      /**
       * @param {DismissReason} dismiss
       */
      var dismissWith = function dismissWith(dismiss) {
        instance.close({
          isDismissed: true,
          dismiss: dismiss
        });
      };
      privateMethods.swalPromiseResolve.set(instance, resolve);
      privateMethods.swalPromiseReject.set(instance, reject);
      domCache.confirmButton.onclick = function () {
        handleConfirmButtonClick(instance);
      };
      domCache.denyButton.onclick = function () {
        handleDenyButtonClick(instance);
      };
      domCache.cancelButton.onclick = function () {
        handleCancelButtonClick(instance, dismissWith);
      };
      domCache.closeButton.onclick = function () {
        dismissWith(DismissReason.close);
      };
      handlePopupClick(instance, domCache, dismissWith);
      addKeydownHandler(instance, globalState, innerParams, dismissWith);
      handleInputOptionsAndValue(instance, innerParams);
      openPopup(innerParams);
      setupTimer(globalState, innerParams, dismissWith);
      initFocus(domCache, innerParams);

      // Scroll container to top on open (#1247, #1946)
      setTimeout(function () {
        domCache.container.scrollTop = 0;
      });
    });
  };

  /**
   * @param {SweetAlertOptions} userParams
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlertOptions}
   */
  var prepareParams = function prepareParams(userParams, mixinParams) {
    var templateParams = getTemplateParams(userParams);
    var params = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131
    params.showClass = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, defaultParams.showClass, params.showClass);
    params.hideClass = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()({}, defaultParams.hideClass, params.hideClass);
    return params;
  };

  /**
   * @param {SweetAlert} instance
   * @returns {DomCache}
   */
  var populateDomCache = function populateDomCache(instance) {
    var domCache = {
      popup: getPopup(),
      container: getContainer(),
      actions: getActions(),
      confirmButton: getConfirmButton(),
      denyButton: getDenyButton(),
      cancelButton: getCancelButton(),
      loader: getLoader(),
      closeButton: getCloseButton(),
      validationMessage: getValidationMessage(),
      progressSteps: getProgressSteps()
    };
    privateProps.domCache.set(instance, domCache);
    return domCache;
  };

  /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */
  var setupTimer = function setupTimer(globalState, innerParams, dismissWith) {
    var timerProgressBar = getTimerProgressBar();
    hide(timerProgressBar);
    if (innerParams.timer) {
      globalState.timeout = new Timer(function () {
        dismissWith('timer');
        delete globalState.timeout;
      }, innerParams.timer);
      if (innerParams.timerProgressBar) {
        show(timerProgressBar);
        applyCustomClass(timerProgressBar, innerParams, 'timerProgressBar');
        setTimeout(function () {
          if (globalState.timeout && globalState.timeout.running) {
            // timer can be already stopped or unset at this point
            animateTimerProgressBar(innerParams.timer);
          }
        });
      }
    }
  };

  /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   */
  var initFocus = function initFocus(domCache, innerParams) {
    if (innerParams.toast) {
      return;
    }
    if (!callIfFunction(innerParams.allowEnterKey)) {
      blurActiveElement();
      return;
    }
    if (!focusButton(domCache, innerParams)) {
      setFocus(-1, 1);
    }
  };

  /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */
  var focusButton = function focusButton(domCache, innerParams) {
    if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
      domCache.denyButton.focus();
      return true;
    }
    if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
      domCache.cancelButton.focus();
      return true;
    }
    if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
      domCache.confirmButton.focus();
      return true;
    }
    return false;
  };
  var blurActiveElement = function blurActiveElement() {
    if (document.activeElement instanceof HTMLElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }
  };

  // Dear russian users visiting russian sites. Let's have fun.
  if (typeof window !== 'undefined' && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|by|xn--p1ai)$/)) {
    var now = new Date();
    var initiationDate = localStorage.getItem('swal-initiation');
    if (!initiationDate) {
      localStorage.setItem('swal-initiation', '' + now);
    } else if ((now.getTime() - Date.parse(initiationDate)) / (1000 * 60 * 60 * 24) > 3) {
      setTimeout(function () {
        document.body.style.pointerEvents = 'none';
        var ukrainianAnthem = document.createElement('audio');
        ukrainianAnthem.src = 'https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3';
        ukrainianAnthem.loop = true;
        document.body.appendChild(ukrainianAnthem);
        setTimeout(function () {
          ukrainianAnthem.play().catch(function () {
            // ignore
          });
        }, 2500);
      }, 500);
    }
  }

  // Assign instance methods from src/instanceMethods/*.js to prototype
  SweetAlert.prototype.disableButtons = disableButtons;
  SweetAlert.prototype.enableButtons = enableButtons;
  SweetAlert.prototype.getInput = getInput;
  SweetAlert.prototype.disableInput = disableInput;
  SweetAlert.prototype.enableInput = enableInput;
  SweetAlert.prototype.hideLoading = hideLoading;
  SweetAlert.prototype.disableLoading = hideLoading;
  SweetAlert.prototype.showValidationMessage = showValidationMessage;
  SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
  SweetAlert.prototype.close = close;
  SweetAlert.prototype.closePopup = close;
  SweetAlert.prototype.closeModal = close;
  SweetAlert.prototype.closeToast = close;
  SweetAlert.prototype.rejectPromise = rejectPromise;
  SweetAlert.prototype.update = update;
  SweetAlert.prototype._destroy = _destroy;

  // Assign static methods from src/staticMethods/*.js to constructor
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_object_assign___default()(SweetAlert, staticMethods);

  // Proxy to instance methods to constructor, for now, for backwards compatibility
  __WEBPACK_IMPORTED_MODULE_10_babel_runtime_core_js_object_keys___default()(instanceMethods).forEach(function (key) {
    /**
     * @param {...any} args
     * @returns {any | undefined}
     */
    SweetAlert[key] = function () {
      if (currentInstance && currentInstance[key]) {
        var _currentInstance;

        return (_currentInstance = currentInstance)[key].apply(_currentInstance, arguments);
      }
      return null;
    };
  });
  SweetAlert.DismissReason = DismissReason;
  SweetAlert.version = '11.7.12';

  var Swal = SweetAlert;
  // @ts-ignore
  Swal.default = Swal;

  return Swal;
});
if (typeof this !== 'undefined' && this.Sweetalert2) {
  this.swal = this.sweetAlert = this.Swal = this.SweetAlert = this.Sweetalert2;
}
"undefined" != typeof document && function (e, t) {
  var n = e.createElement("style");if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);else try {
    n.innerHTML = t;
  } catch (e) {
    n.innerText = t;
  }
}(document, ".swal2-popup.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;background:#fff;box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-popup.swal2-toast>*{grid-column:2}.swal2-popup.swal2-toast .swal2-title{margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-loading{justify-content:center}.swal2-popup.swal2-toast .swal2-input{height:2em;margin:.5em;font-size:1em}.swal2-popup.swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-popup.swal2-toast .swal2-html-container{margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-html-container:empty{padding:0}.swal2-popup.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-popup.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-popup.swal2-toast .swal2-styled{margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{animation:swal2-toast-hide .1s forwards}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:\"top-start     top            top-end\" \"center-start  center         center-end\" \"bottom-start  bottom-center  bottom-end\";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:rgba(0,0,0,.4)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;align-self:start;justify-self:center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;align-self:start;justify-self:end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;align-self:center;justify-self:center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;align-self:center;justify-self:end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;justify-self:center;align-self:end}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;align-self:end;justify-self:end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:32em;max-width:100%;padding:0 0 1.25em;border:none;border-radius:5px;background:#fff;color:#545454;font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:.8em 1em 0;color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled).swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#7066e0;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled).swal2-confirm:focus{box-shadow:0 0 0 3px rgba(112,102,224,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-deny{border:0;border-radius:.25em;background:initial;background-color:#dc3741;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled).swal2-deny:focus{box-shadow:0 0 0 3px rgba(220,55,65,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#6e7881;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled).swal2-cancel:focus{box-shadow:0 0 0 3px rgba(110,120,129,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-default-outline:focus{box-shadow:0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-styled):focus{outline:none}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){justify-content:center;margin:1em 0 0;padding:1em 1em 0;border-top:1px solid #eee;color:inherit;font-size:1em}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:rgba(0,0,0,.2)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em}div:where(.swal2-container) button:where(.swal2-close){z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:color .1s,box-shadow .1s;border:none;border-radius:5px;background:rgba(0,0,0,0);color:#ccc;font-family:monospace;font-size:2.5em;cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:none;background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus{outline:none;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) .swal2-html-container{z-index:1;justify-content:center;margin:1em 1.6em .3em;padding:0;overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:rgba(0,0,0,0);box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:1px solid #b4dbed;outline:none;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:#fff}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:rgba(0,0,0,0);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:#fff;color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:0.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#facea8;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#9de0f6;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#c9dae1;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;transform:rotate(45deg);border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:swal2-show .3s}.swal2-hide{animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-show{0%{transform:scale(0.7)}45%{transform:scale(1.05)}80%{transform:scale(0.95)}100%{transform:scale(1)}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(0.5);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static !important}}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}");
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "e9ss":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bus = _interopRequireDefault(__webpack_require__("jlkA"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ClientTable = __webpack_require__("RirO");

var ServerTable = __webpack_require__("RPbb");

module.exports = {
  ClientTable: ClientTable,
  ServerTable: ServerTable,
  Event: _bus["default"]
};

/***/ }),

/***/ "eAa1":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("3fMt");
var IObject = __webpack_require__("wiaE");
var toObject = __webpack_require__("wXdB");
var toLength = __webpack_require__("GhAV");
var asc = __webpack_require__("s2sY");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "eCz2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__("LC74")
var HashBase = __webpack_require__("yDvu")
var Buffer = __webpack_require__("X3l8").Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),

/***/ "eQ3/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {

  return function (h) {

    var theme = this.Theme;
    var prevChunk = '';
    var nextChunk = '';
    var firstPage = '';
    var lastPage = '';
    var items = this.pages.map(function (page) {

      return h(
        'li',
        { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + this.activeClass(page),
          on: {
            'click': this.setPage.bind(this, page)
          }
        },
        [h(
          'a',
          { 'class': theme.link + ' ' + this.activeClass(page),
            attrs: { href: 'javascript:void(0)',
              role: 'button' }
          },
          [page]
        )]
      );
    }.bind(this));

    if (this.opts.edgeNavigation && this.totalChunks > 1) {
      firstPage = h(
        'li',
        { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + (this.page === 1 ? theme.disabled : '') + ' VuePagination__pagination-item-prev-chunk',
          on: {
            'click': this.setPage.bind(this, 1)
          }
        },
        [h(
          'a',
          { 'class': theme.link,
            attrs: { href: 'javascript:void(0);',
              disabled: this.page === 1 }
          },
          [this.opts.texts.first]
        )]
      );

      lastPage = h(
        'li',
        { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + (this.page === this.totalPages ? theme.disabled : '') + ' VuePagination__pagination-item-prev-chunk',
          on: {
            'click': this.setPage.bind(this, this.totalPages)
          }
        },
        [h(
          'a',
          { 'class': theme.link,
            attrs: { href: 'javascript:void(0);',
              disabled: this.page === this.totalPages }
          },
          [this.opts.texts.last]
        )]
      );
    }

    if (this.opts.chunksNavigation === 'fixed') {

      prevChunk = h(
        'li',
        { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.prev + ' VuePagination__pagination-item-prev-chunk ' + this.allowedChunkClass(-1),
          on: {
            'click': this.setChunk.bind(this, -1)
          }
        },
        [h(
          'a',
          { 'class': theme.link,
            attrs: { href: 'javascript:void(0);',
              disabled: !!this.allowedChunkClass(-1) }
          },
          ['<<']
        )]
      );

      nextChunk = h(
        'li',
        { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.next + ' VuePagination__pagination-item-next-chunk ' + this.allowedChunkClass(1),
          on: {
            'click': this.setChunk.bind(this, 1)
          }
        },
        [h(
          'a',
          { 'class': theme.link,
            attrs: { href: 'javascript:void(0);',
              disabled: !!this.allowedChunkClass(1) }
          },
          ['>>']
        )]
      );
    }

    return h(
      'div',
      { 'class': 'VuePagination ' + theme.wrapper },
      [h(
        'nav',
        { 'class': '' + theme.nav },
        [h(
          'ul',
          {
            directives: [{
              name: 'show',
              value: this.totalPages > 1
            }],

            'class': theme.list + ' VuePagination__pagination' },
          [firstPage, prevChunk, h(
            'li',
            { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.prev + ' VuePagination__pagination-item-prev-page ' + this.allowedPageClass(this.page - 1),
              on: {
                'click': this.prev.bind(this)
              }
            },
            [h(
              'a',
              { 'class': theme.link,
                attrs: { href: 'javascript:void(0);',
                  disabled: !!this.allowedPageClass(this.page - 1)
                }
              },
              ['<']
            )]
          ), items, h(
            'li',
            { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.next + ' VuePagination__pagination-item-next-page ' + this.allowedPageClass(this.page + 1),
              on: {
                'click': this.next.bind(this)
              }
            },
            [h(
              'a',
              { 'class': theme.link,
                attrs: { href: 'javascript:void(0);',
                  disabled: !!this.allowedPageClass(this.page + 1)
                }
              },
              ['>']
            )]
          ), nextChunk, lastPage]
        ), h(
          'p',
          {
            directives: [{
              name: 'show',
              value: parseInt(this.records)
            }],

            'class': 'VuePagination__count ' + theme.count },
          [this.count]
        )]
      )]
    );
  };
};

/***/ }),

/***/ "eaCm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__("GCs6").f;
var create = __webpack_require__("NZ8V");
var redefineAll = __webpack_require__("nJ75");
var ctx = __webpack_require__("3fMt");
var anInstance = __webpack_require__("4S0F");
var forOf = __webpack_require__("dudK");
var $iterDefine = __webpack_require__("4dmN");
var step = __webpack_require__("beh1");
var setSpecies = __webpack_require__("EFoD");
var DESCRIPTORS = __webpack_require__("qs+f");
var fastKey = __webpack_require__("+zJ9").fastKey;
var validate = __webpack_require__("fTPD");
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ "eg2Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return Math.ceil(this.count / this.limit);
};

/***/ }),

/***/ "eg8w":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "euHq":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gCWN");
__webpack_require__("tz60");
__webpack_require__("+3lO");
__webpack_require__("2kY9");
__webpack_require__("oUpx");
__webpack_require__("txMS");
__webpack_require__("Mnw5");
module.exports = __webpack_require__("iANj").Map;


/***/ }),

/***/ "euKu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



module.exports = Readable;

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__("vzCy").EventEmitter;
var EElistenerCount = function EElistenerCount(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("xXuq");
/*</replacement>*/

var Buffer = __webpack_require__("EuP9").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*<replacement>*/
var debugUtil = __webpack_require__(3);
var debug;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function debug() {};
}
/*</replacement>*/

var BufferList = __webpack_require__("W2zL");
var destroyImpl = __webpack_require__("EzfO");
var _require = __webpack_require__("hBHd"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__("WrlE").codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_STREAM_PUSH_AFTER_EOF = _require$codes.ERR_STREAM_PUSH_AFTER_EOF,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_STREAM_UNSHIFT_AFTER_END_EVENT = _require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;

// Lazy loaded to improve the startup performance.
var StringDecoder;
var createReadableStreamAsyncIterator;
var from;
__webpack_require__("LC74")(Readable, Stream);
var errorOrDestroy = destroyImpl.errorOrDestroy;
var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}
function ReadableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("PBMQ");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  this.highWaterMark = getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;
  this.paused = true;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'end' (and potentially 'finish')
  this.autoDestroy = !!options.autoDestroy;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;
  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__("X4X3").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}
function Readable(options) {
  Duplex = Duplex || __webpack_require__("PBMQ");
  if (!(this instanceof Readable)) return new Readable(options);

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the ReadableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  this._readableState = new ReadableState(options, this, isDuplex);

  // legacy
  this.readable = true;
  if (options) {
    if (typeof options.read === 'function') this._read = options.read;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }
  Stream.call(this);
}
Object.defineProperty(Readable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});
Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;
  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }
  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};
function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  debug('readableAddChunk', chunk);
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      errorOrDestroy(stream, er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }
      if (addToFront) {
        if (state.endEmitted) errorOrDestroy(stream, new ERR_STREAM_UNSHIFT_AFTER_END_EVENT());else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        errorOrDestroy(stream, new ERR_STREAM_PUSH_AFTER_EOF());
      } else if (state.destroyed) {
        return false;
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
      maybeReadMore(stream, state);
    }
  }

  // We can push more data if we are below the highWaterMark.
  // Also, if we have no data yet, we can stand some more bytes.
  // This is to work around cases where hwm=0, such as the repl.
  return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    state.awaitDrain = 0;
    stream.emit('data', chunk);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}
function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer', 'Uint8Array'], chunk);
  }
  return er;
}
Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__("X4X3").StringDecoder;
  var decoder = new StringDecoder(enc);
  this._readableState.decoder = decoder;
  // If setEncoding(null), decoder.encoding equals utf8
  this._readableState.encoding = this._readableState.decoder.encoding;

  // Iterate over current buffer to convert already stored Buffers:
  var p = this._readableState.buffer.head;
  var content = '';
  while (p !== null) {
    content += decoder.write(p.data);
    p = p.next;
  }
  this._readableState.buffer.clear();
  if (content !== '') this._readableState.buffer.push(content);
  this._readableState.length = content.length;
  return this;
};

// Don't raise the hwm > 1GB
var MAX_HWM = 0x40000000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;
  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }
  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }
  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;
  if (ret === null) {
    state.needReadable = state.length <= state.highWaterMark;
    n = 0;
  } else {
    state.length -= n;
    state.awaitDrain = 0;
  }
  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }
  if (ret !== null) this.emit('data', ret);
  return ret;
};
function onEofChunk(stream, state) {
  debug('onEofChunk');
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;
  if (state.sync) {
    // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    emitReadable(stream);
  } else {
    // emit 'readable' now to make sure it gets picked up.
    state.needReadable = false;
    if (!state.emittedReadable) {
      state.emittedReadable = true;
      emitReadable_(stream);
    }
  }
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  debug('emitReadable', state.needReadable, state.emittedReadable);
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    process.nextTick(emitReadable_, stream);
  }
}
function emitReadable_(stream) {
  var state = stream._readableState;
  debug('emitReadable_', state.destroyed, state.length, state.ended);
  if (!state.destroyed && (state.length || state.ended)) {
    stream.emit('readable');
    state.emittedReadable = false;
  }

  // The stream needs another readable event if
  // 1. It is not flowing, as the flow mechanism will take
  //    care of it.
  // 2. It is not ended.
  // 3. It is below the highWaterMark, so we can schedule
  //    another readable later.
  state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(maybeReadMore_, stream, state);
  }
}
function maybeReadMore_(stream, state) {
  // Attempt to read more data if we should.
  //
  // The conditions for reading more data are (one of):
  // - Not enough data buffered (state.length < state.highWaterMark). The loop
  //   is responsible for filling the buffer with enough data if such data
  //   is available. If highWaterMark is 0 and we are not in the flowing mode
  //   we should _not_ attempt to buffer any extra data. We'll get more data
  //   when the stream consumer calls read() instead.
  // - No data in the buffer, and the stream is in flowing mode. In this mode
  //   the loop below is responsible for ensuring read() is called. Failing to
  //   call read here would abort the flow and there's no other mechanism for
  //   continuing the flow if the stream consumer has just subscribed to the
  //   'data' event.
  //
  // In addition to the above conditions to keep reading data, the following
  // conditions prevent the data from being read:
  // - The stream has ended (state.ended).
  // - There is already a pending 'read' operation (state.reading). This is a
  //   case where the the stream has called the implementation defined _read()
  //   method, but they are processing the call asynchronously and have _not_
  //   called push() with new data. In this case we skip performing more
  //   read()s. The execution ends in this method again after the _read() ends
  //   up calling push() with more data.
  while (!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)) {
    var len = state.length;
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  errorOrDestroy(this, new ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;
  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) process.nextTick(endFn);else src.once('end', endFn);
  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }
  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);
  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);
    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    debug('dest.write', ret);
    if (ret === false) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', state.awaitDrain);
        state.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) errorOrDestroy(dest, er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);
  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }
  return dest;
};
function pipeOnDrain(src) {
  return function pipeOnDrainFunctionResult() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}
Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = {
    hasUnpiped: false
  };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;
    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    for (var i = 0; i < len; i++) dests[i].emit('unpipe', this, {
      hasUnpiped: false
    });
    return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;
  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];
  dest.emit('unpipe', this, unpipeInfo);
  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);
  var state = this._readableState;
  if (ev === 'data') {
    // update readableListening so that resume() may be a no-op
    // a few lines down. This is needed to support once('readable').
    state.readableListening = this.listenerCount('readable') > 0;

    // Try start flowing on next tick if stream isn't explicitly paused
    if (state.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.flowing = false;
      state.emittedReadable = false;
      debug('on readable', state.length, state.reading);
      if (state.length) {
        emitReadable(this);
      } else if (!state.reading) {
        process.nextTick(nReadingNextTick, this);
      }
    }
  }
  return res;
};
Readable.prototype.addListener = Readable.prototype.on;
Readable.prototype.removeListener = function (ev, fn) {
  var res = Stream.prototype.removeListener.call(this, ev, fn);
  if (ev === 'readable') {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
Readable.prototype.removeAllListeners = function (ev) {
  var res = Stream.prototype.removeAllListeners.apply(this, arguments);
  if (ev === 'readable' || ev === undefined) {
    // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    process.nextTick(updateReadableListening, this);
  }
  return res;
};
function updateReadableListening(self) {
  var state = self._readableState;
  state.readableListening = self.listenerCount('readable') > 0;
  if (state.resumeScheduled && !state.paused) {
    // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;

    // crude way to check if we should resume
  } else if (self.listenerCount('data') > 0) {
    self.resume();
  }
}
function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    // we flow only if there is no one listening
    // for readable, but we still have to call
    // resume()
    state.flowing = !state.readableListening;
    resume(this, state);
  }
  state.paused = false;
  return this;
};
function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(resume_, stream, state);
  }
}
function resume_(stream, state) {
  debug('resume', state.reading);
  if (!state.reading) {
    stream.read(0);
  }
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}
Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (this._readableState.flowing !== false) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  this._readableState.paused = true;
  return this;
};
function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null);
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;
  var state = this._readableState;
  var paused = false;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }
    _this.push(null);
  });
  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };
  return this;
};
if (typeof Symbol === 'function') {
  Readable.prototype[Symbol.asyncIterator] = function () {
    if (createReadableStreamAsyncIterator === undefined) {
      createReadableStreamAsyncIterator = __webpack_require__("kxE3");
    }
    return createReadableStreamAsyncIterator(this);
  };
}
Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.highWaterMark;
  }
});
Object.defineProperty(Readable.prototype, 'readableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState && this._readableState.buffer;
  }
});
Object.defineProperty(Readable.prototype, 'readableFlowing', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.flowing;
  },
  set: function set(state) {
    if (this._readableState) {
      this._readableState.flowing = state;
    }
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;
Object.defineProperty(Readable.prototype, 'readableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._readableState.length;
  }
});

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;
  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.first();else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = state.buffer.consume(n, state.decoder);
  }
  return ret;
}
function endReadable(stream) {
  var state = stream._readableState;
  debug('endReadable', state.endEmitted);
  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(endReadableNT, state, stream);
  }
}
function endReadableNT(state, stream) {
  debug('endReadableNT', state.endEmitted, state.length);

  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
    if (state.autoDestroy) {
      // In case of duplex streams we need a way to detect
      // if the writable side is ready for autoDestroy as well
      var wState = stream._writableState;
      if (!wState || wState.autoDestroy && wState.finished) {
        stream.destroy();
      }
    }
  }
}
if (typeof Symbol === 'function') {
  Readable.from = function (iterable, opts) {
    if (from === undefined) {
      from = __webpack_require__("xWCr");
    }
    return from(Readable, iterable, opts);
  };
}
function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "ewJk":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(5).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "exGp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ "f1Eh":
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "f1cp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  this.serverSearch();
};

/***/ }),

/***/ "f48b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__("D1Va");

/*<replacement>*/
var util = Object.create(__webpack_require__("jOgh"));
util.inherits = __webpack_require__("LC74");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "fC7K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * vue-bus v1.2.1
 * https://github.com/yangmingshan/vue-bus
 * @license MIT
 */
function VueBus(Vue) {
  var bus = new Vue();

  Object.defineProperties(bus, {
    on: {
      get: function get() {
        return this.$on.bind(this)
      }
    },
    once: {
      get: function get() {
        return this.$once.bind(this)
      }
    },
    off: {
      get: function get() {
        return this.$off.bind(this)
      }
    },
    emit: {
      get: function get() {
        return this.$emit.bind(this)
      }
    }
  });

  Object.defineProperty(Vue, 'bus', {
    get: function get() {
      return bus
    }
  });

  Object.defineProperty(Vue.prototype, '$bus', {
    get: function get() {
      return bus
    }
  });
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueBus);
}

/* harmony default export */ __webpack_exports__["a"] = (VueBus);


/***/ }),

/***/ "fRHV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ "fRJi":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("tz60");
__webpack_require__("9uBv");
module.exports = __webpack_require__("iANj").Array.from;


/***/ }),

/***/ "fTPD":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ "fWB8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("1lLf");
var SHA256 = __webpack_require__("Q48P");

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),

/***/ "fZjL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("ZhOs"), __esModule: true };

/***/ }),

/***/ "fuGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "fum+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var debounce = __webpack_require__("HhAh");

module.exports = function (h, inputClass) {
  var _this = this;

  var search = this.source == 'client' ? this.search.bind(this, this.data) : this.serverSearch.bind(this);

  if (this.opts.debounce) {
    var debouncedSearch = debounce(search, this.opts.debounce);

    var onKeyUp = function onKeyUp(e) {
      if (e.keyCode === 9) return;

      if (e.keyCode === 13) {
        debouncedSearch.clear();
        search.apply(void 0, arguments);
      } else {
        debouncedSearch.apply(void 0, arguments);
      }
    };
  }

  return function (column) {
    return h("input", {
      on: {
        "keyup": _this.opts.debounce ? onKeyUp : search
      },
      "class": inputClass,
      attrs: {
        name: _this._getColumnName(column),
        type: "text",
        placeholder: _this.display('filterBy', {
          column: _this.getHeading(column)
        }),
        autocomplete: "off"
      }
    });
  };
};

/***/ }),

/***/ "fxuI":
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__("jkjm")
var mgf = __webpack_require__("Cua8")
var xor = __webpack_require__("zOO0")
var BN = __webpack_require__("2Ejg")
var crt = __webpack_require__("jSRM")
var createHash = __webpack_require__("BVsN")
var withPublic = __webpack_require__("5QAX")
var Buffer = __webpack_require__("X3l8").Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),

/***/ "gCWN":
/***/ (function(module, exports) {



/***/ }),

/***/ "gRE1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("mG69"), __esModule: true };

/***/ }),

/***/ "gcUb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__("7ar3");

var callBind = __webpack_require__("WER7");

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),

/***/ "geuY":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(1).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this._strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // '0' - '9'
    if (c >= 48 && c <= 57) {
      return c - 48;
    // 'A' - 'F'
    } else if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    } else {
      assert(false, 'Invalid character in ' + string);
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this._strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var b = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        b = c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        b = c - 17 + 0xa;

      // '0' - '9'
      } else {
        b = c;
      }
      assert(c >= 0 && b < mul, 'Invalid character');
      r += b;
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this._strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  function move (dest, src) {
    dest.words = src.words;
    dest.length = src.length;
    dest.negative = src.negative;
    dest.red = src.red;
  }

  BN.prototype._move = function _move (dest) {
    move(dest, this);
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype._strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  // Check Symbol.for because not everywhere where Symbol defined
  // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
  if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') {
    try {
      BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
      BN.prototype.inspect = inspect;
    }
  } else {
    BN.prototype.inspect = inspect;
  }

  function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  }

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modrn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16, 2);
  };

  if (Buffer) {
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      return this.toArrayLike(Buffer, endian, length);
    };
  }

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  var allocate = function allocate (ArrayType, size) {
    if (ArrayType.allocUnsafe) {
      return ArrayType.allocUnsafe(size);
    }
    return new ArrayType(size);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    this._strip();

    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    var res = allocate(ArrayType, reqLength);
    var postfix = endian === 'le' ? 'LE' : 'BE';
    this['_toArrayLike' + postfix](res, byteLength);
    return res;
  };

  BN.prototype._toArrayLikeLE = function _toArrayLikeLE (res, byteLength) {
    var position = 0;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position++] = word & 0xff;
      if (position < res.length) {
        res[position++] = (word >> 8) & 0xff;
      }
      if (position < res.length) {
        res[position++] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position < res.length) {
          res[position++] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position < res.length) {
      res[position++] = carry;

      while (position < res.length) {
        res[position++] = 0;
      }
    }
  };

  BN.prototype._toArrayLikeBE = function _toArrayLikeBE (res, byteLength) {
    var position = res.length - 1;
    var carry = 0;

    for (var i = 0, shift = 0; i < this.length; i++) {
      var word = (this.words[i] << shift) | carry;

      res[position--] = word & 0xff;
      if (position >= 0) {
        res[position--] = (word >> 8) & 0xff;
      }
      if (position >= 0) {
        res[position--] = (word >> 16) & 0xff;
      }

      if (shift === 6) {
        if (position >= 0) {
          res[position--] = (word >> 24) & 0xff;
        }
        carry = 0;
        shift = 0;
      } else {
        carry = word >>> 24;
        shift += 2;
      }
    }

    if (position >= 0) {
      res[position--] = carry;

      while (position >= 0) {
        res[position--] = 0;
      }
    }
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] >>> wbit) & 0x01;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this._strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this._strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this._strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this._strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this._strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this._strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out._strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out._strip();
  }

  function jumboMulTo (self, num, out) {
    // Temporary disable, see https://github.com/indutny/bn.js/issues/211
    // var fftm = new FFTM();
    // return fftm.mulp(self, num, out);
    return bigMulTo(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out._strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this._strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this._strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this._strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) <= num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this._strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this._strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this._strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q._strip();
    }
    a._strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modrn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modrn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || (r2 === 1 && cmp === 0)) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modrn = function modrn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return isNegNum ? -acc : acc;
  };

  // WARNING: DEPRECATED
  BN.prototype.modn = function modn (num) {
    return this.modrn(num);
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    var isNegNum = num < 0;
    if (isNegNum) num = -num;

    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    this._strip();
    return isNegNum ? this.ineg() : this;
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this._strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is a BN v4 instance
        r.strip();
      } else {
        // r is a BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);

    move(a, a.umod(this.m)._forceRed(this));
    return a;
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "gm4B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.data;
};

/***/ }),

/***/ "gw8B":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__("lZ6o")
var BN = __webpack_require__("ewJk")

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "hBHd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = __webpack_require__("WrlE").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ "hQ80":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__("3PYz");
var curve = __webpack_require__("tRuz");
var utils = __webpack_require__("TkWM");

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = __webpack_require__("9bI3");
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});


/***/ }),

/***/ "hdr4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bus = new _vue2.default();

module.exports = bus;

/***/ }),

/***/ "hgbu":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("a/OS")('wks');
var uid = __webpack_require__("GmwO");
var Symbol = __webpack_require__("YjQv").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "hgsc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul__ = __webpack_require__("qajy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_clz32__ = __webpack_require__("X+g4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);



(function (module, exports) {
  'use strict';

  // Utils

  function assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function TempCtor() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN(number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if ((typeof module === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(module)) === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(0).Buffer;
    }
  } catch (e) {}

  BN.isBN = function isBN(num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && (typeof num === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(num)) === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max(left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min(left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init(number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if ((typeof number === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(number)) === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber(number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [number & 0x3ffffff];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [number & 0x3ffffff, number / 0x4000000 & 0x3ffffff];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [number & 0x3ffffff, number / 0x4000000 & 0x3ffffff, 1];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray(number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [0];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
        this.words[j] |= w << off & 0x3ffffff;
        this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
        this.words[j] |= w << off & 0x3ffffff;
        this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits(string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
      // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
      // '0' - '9'
    } else {
      return c - 48 & 0xf;
    }
  }

  function parseHexByte(string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex(number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase(str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

        // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

        // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase(number, base, start) {
    // Initialize as zero
    this.words = [0];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = limbPow / base | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy(dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone() {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand(size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip() {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign() {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect() {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*
   var zeros = [];
  var groupSizes = [];
  var groupBases = [];
   var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }
   */

  var zeros = ['', '0', '00', '000', '0000', '00000', '000000', '0000000', '00000000', '000000000', '0000000000', '00000000000', '000000000000', '0000000000000', '00000000000000', '000000000000000', '0000000000000000', '00000000000000000', '000000000000000000', '0000000000000000000', '00000000000000000000', '000000000000000000000', '0000000000000000000000', '00000000000000000000000', '000000000000000000000000', '0000000000000000000000000'];

  var groupSizes = [0, 0, 25, 16, 12, 11, 10, 9, 8, 8, 7, 7, 7, 7, 6, 6, 6, 6, 6, 6, 6, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5];

  var groupBases = [0, 0, 33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216, 43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625, 16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632, 6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149, 24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176];

  BN.prototype.toString = function toString(base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = ((w << off | carry) & 0xffffff).toString(16);
        carry = w >>> 24 - off & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber() {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + this.words[1] * 0x4000000;
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return this.negative !== 0 ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON() {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer(endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray(endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_clz32___default.a) {
    BN.prototype._countBits = function _countBits(w) {
      return 32 - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_math_clz32___default()(w);
    };
  } else {
    BN.prototype._countBits = function _countBits(w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits(w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength() {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray(num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = bit / 26 | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits() {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength() {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos(width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos(width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg() {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg() {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg() {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor(num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior(num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or(num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor(num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand(num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand(num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and(num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand(num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor(num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor(num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor(num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor(num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn(width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn(width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn(bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = bit / 26 | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | 1 << wbit;
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd(num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

      // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
      // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add(num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub(num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

      // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub(num) {
    return this.clone().isub(num);
  };

  function smallMulTo(self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = self.length + num.length | 0;
    out.length = len;
    len = len - 1 | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = r / 0x4000000 | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += r / 0x4000000 | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo(self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh0);
    var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh0);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl1) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh1) | 0;
    var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh0);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl1) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh1) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl2) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh2) | 0;
    var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh0);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl1) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh1) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl2) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh2) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl3) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh3) | 0;
    var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh0);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl1) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh1) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl2) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh2) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl3) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh3) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl4) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh4) | 0;
    var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh0);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl1) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh1) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl2) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh2) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl3) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh3) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl4) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh4) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl5) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh5) | 0;
    var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh0);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl1) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh1) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl2) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh2) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl3) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh3) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl4) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh4) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl5) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh5) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl6) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh6) | 0;
    var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh0);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl1) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh1) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl2) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh2) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl3) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh3) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl4) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh4) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl5) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh5) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl6) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh6) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl7) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh7) | 0;
    var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh0);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl1) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh1) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl2) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh2) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl3) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh3) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl4) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh4) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl5) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh5) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl6) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh6) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl7) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh7) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl8) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh8) | 0;
    var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl0);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh0);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl0) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh0);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh1) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl1) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh1) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl2) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh2) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl3) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh3) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl4) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh4) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl5) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh5) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl6) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh6) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl7) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh7) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl8) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh8) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bl9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al0, bh9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bl9) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah0, bh9) | 0;
    var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl1);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh1);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl1) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh1);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh2) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl2) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh2) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl3) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh3) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl4) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh4) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl5) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh5) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl6) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh6) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl7) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh7) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl8) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh8) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bl9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al1, bh9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bl9) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah1, bh9) | 0;
    var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl2);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh2);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl2) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh2);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh3) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl3) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh3) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl4) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh4) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl5) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh5) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl6) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh6) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl7) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh7) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl8) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh8) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bl9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al2, bh9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bl9) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah2, bh9) | 0;
    var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl3);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh3);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl3) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh3);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh4) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl4) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh4) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl5) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh5) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl6) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh6) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl7) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh7) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl8) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh8) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bl9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al3, bh9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bl9) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah3, bh9) | 0;
    var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl4);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh4);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl4) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh4);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh5) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl5) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh5) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl6) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh6) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl7) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh7) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl8) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh8) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bl9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al4, bh9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bl9) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah4, bh9) | 0;
    var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl5);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh5);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl5) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh5);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh6) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl6) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh6) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl7) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh7) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl8) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh8) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bl9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al5, bh9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bl9) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah5, bh9) | 0;
    var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl6);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh6);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl6) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh6);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh7) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl7) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh7) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl8) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh8) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bl9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al6, bh9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bl9) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah6, bh9) | 0;
    var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl7);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh7);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl7) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh7);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh8) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl8) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh8) | 0;
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bl9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al7, bh9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bl9) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah7, bh9) | 0;
    var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl8);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh8);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl8) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh8);
    lo = lo + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bl9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al8, bh9) | 0;
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bl9) | 0;
    hi = hi + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah8, bh9) | 0;
    var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bl9);
    mid = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(al9, bh9);
    mid = mid + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bl9) | 0;
    hi = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default()(ah9, bh9);
    var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
    c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_imul___default.a) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo(self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = ncarry + (r / 0x4000000 | 0) | 0;
        lo = lo + rword | 0;
        rword = lo & 0x3ffffff;
        ncarry = ncarry + (lo >>> 26) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo(self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo(num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM(x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT(N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin(x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << l - i - 1;
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b(ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff;carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff;carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub(N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp(x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul(num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf(num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul(num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln(num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += w / 0x4000000 | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln(num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr() {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr() {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow(num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln(bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = (this.words[i] | 0) - newCarry << r;
        this.words[i] = c | carry;
        carry = newCarry >>> 26 - r;
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln(bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn(bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - hint % 26) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = carry << 26 - r | word >>> r;
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn(bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln(bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln(bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn(bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn(bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn(bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn(bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn(bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn(num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn(num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn(num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn(num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn(num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs() {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs() {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - (right / 0x4000000 | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv(num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min(qj / bhi | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod(num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div(num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod(num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod(num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound(num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn(num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn(num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = w / num | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn(num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd(p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1) {}
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1) {}
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp(p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1) {}
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1) {}
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd(num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm(num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven() {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd() {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln(num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn(bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero() {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn(num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp(num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp(num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn(num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt(num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten(num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte(num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn(num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt(num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten(num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte(num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn(num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq(num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red(num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed(ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed() {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed(ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed(ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd(num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd(num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub(num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub(num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl(num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul(num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul(num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr() {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr() {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt() {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm() {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg() {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow(num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime(name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp() {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce(num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split(input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK(num) {
    return num.imul(this.k);
  };

  function K256() {
    MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split(input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK(num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + (lo / 0x4000000 | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224() {
    MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192() {
    MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519() {
    // 2 ^ 255 - 19
    MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK(num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime(name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red(m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1(a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2(a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red, 'red works only with red numbers');
  };

  Red.prototype.imod = function imod(a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg(a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add(a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd(a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub(a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub(a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl(a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul(a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul(a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr(a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr(a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt(a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm(a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow(a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = word >> j & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo(num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom(num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont(num) {
    return new Mont(num);
  };

  function Mont(m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - this.shift % 26;
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo(num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom(num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul(a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul(a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm(a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "hkfz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("YP8Q");
var utils = __webpack_require__("TkWM");
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength),
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),

/***/ "ht0Q":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("YjQv");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "i8M6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  if (this.opts.filterByColumn) {
    var query = {};

    for (var key in this.query) {
      query[key] = '';
    }
  } else {
    var query = '';
  }

  this.setFilter(query);
};

/***/ }),

/***/ "iANj":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "iLJX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var decoders = exports;

decoders.der = __webpack_require__("reGU");
decoders.pem = __webpack_require__("vWx2");

/***/ }),

/***/ "iNQt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),

/***/ "iP15":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "iTY7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);



var inherits = __webpack_require__("LC74");
var Reporter = __webpack_require__("16On").Reporter;
var Buffer = __webpack_require__("Hwfm").Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
  if (data instanceof DecoderBuffer) {
    return true;
  }

  // Or accept compatible API
  var isCompatible = (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) === 'object' && Buffer.isBuffer(data.base) && data.constructor.name === 'DecoderBuffer' && typeof data.offset === 'number' && typeof data.length === 'number' && typeof data.save === 'function' && typeof data.restore === 'function' && typeof data.isEmpty === 'function' && typeof data.readUInt8 === 'function' && typeof data.skip === 'function' && typeof data.raw === 'function';

  return isCompatible;
};

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);else return this.error(fail || 'DecoderBuffer overrun');
};

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
};

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
};

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function (item) {
      if (!EncoderBuffer.isEncoderBuffer(item)) item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)));
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
  if (data instanceof EncoderBuffer) {
    return true;
  }

  // Or accept compatible API
  var isCompatible = (typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(data)) === 'object' && data.constructor.name === 'EncoderBuffer' && typeof data.length === 'number' && typeof data.join === 'function';

  return isCompatible;
};

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out) out = Buffer.alloc(this.length);
  if (!offset) offset = 0;

  if (this.length === 0) return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function (item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number') out[offset] = this.value;else if (typeof this.value === 'string') out.write(this.value, offset);else if (Buffer.isBuffer(this.value)) this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};

/***/ }),

/***/ "ic+9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h) {
  var _this = this;

  var perpageValues = [];
  this.opts.perPageValues.every(function (value) {
    var isLastEntry = value >= _this.count;
    var selected = _this.limit == value || isLastEntry && _this.limit > value;
    perpageValues.push(h("option", {
      domProps: {
        "value": value,
        "selected": selected
      }
    }, [value]));
    return !isLastEntry;
  });
  return perpageValues;
};

/***/ }),

/***/ "ifoU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("euHq"), __esModule: true };

/***/ }),

/***/ "igji":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (secondaryCol) {
  var primaryCol = this.orderBy.column;
  var primaryAsc = this.orderBy.ascending;
  if (!this.userMultiSorting[primaryCol]) this.userMultiSorting[primaryCol] = [];
  var multi = this.userMultiSorting[primaryCol];

  if (primaryCol === secondaryCol) {
    if (!multi.length || primaryAsc) {
      // primary is the only sorted column or is ascending
      this.orderBy.ascending = !this.orderBy.ascending;
    } else {
      // remove primary column and make secondary primary
      this.orderBy = multi.shift();
      this.userMultiSorting = {};
      this.userMultiSorting[this.orderBy.column] = multi;
    }
  } else {
    var secondary = multi.filter(function (col) {
      return col.column == secondaryCol;
    })[0];

    if (secondary) {
      if (!secondary.ascending) {
        // remove sort
        this.userMultiSorting[primaryCol] = multi.filter(function (col) {
          return col.column != secondaryCol;
        });
        if (!this.userMultiSorting[primaryCol].length) this.userMultiSorting = {};
      } else {
        // change direction
        secondary.ascending = !secondary.ascending;
      }
    } else {
      // add sort
      multi.push({
        column: secondaryCol,
        ascending: true
      });
    }
  } // force re-compilation of the filteredData computed property


  this.time = Date.now();
  this.dispatch('sorted', getMultiSortData(this.orderBy, this.userMultiSorting));
};

function getMultiSortData(main, secondary) {
  var cols = [JSON.parse(JSON.stringify(main))];
  cols = cols.concat(secondary[main.column]);
  return cols;
}

;

/***/ }),

/***/ "iqpV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ERR_INVALID_OPT_VALUE = __webpack_require__("3U89").codes.ERR_INVALID_OPT_VALUE;
function highWaterMarkFrom(options, isDuplex, duplexKey) {
  return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function getHighWaterMark(state, options, duplexKey, isDuplex) {
  var hwm = highWaterMarkFrom(options, isDuplex, duplexKey);
  if (hwm != null) {
    if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
      var name = isDuplex ? duplexKey : 'highWaterMark';
      throw new ERR_INVALID_OPT_VALUE(name, hwm);
    }
    return Math.floor(hwm);
  }

  // Default value
  return state.objectMode ? 16 : 16 * 1024;
}
module.exports = {
  getHighWaterMark: getHighWaterMark
};

/***/ }),

/***/ "iwc9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (table, hasChildRow, isChildRowTogglerFirst, resizeableColumns) {
  var row = table.getElementsByTagName("tr")[0],
      cols = row ? Array.from(row.children) : undefined;
  if (!cols) return;

  if (_typeof(resizeableColumns) === 'object') {
    cols = cols.filter(function (col) {
      return resizeableColumns.includes(col.id.split('--')[1]);
    });
  }

  table.style.overflow = "hidden";
  var tableHeight = table.offsetHeight;
  var i = hasChildRow && isChildRowTogglerFirst ? 1 : 0;
  var till = hasChildRow && !isChildRowTogglerFirst ? cols.length - 2 : cols.length;
  var documentListeners = [];

  for (; i < till; i++) {
    var div = createDiv(tableHeight);
    div.className = "resize-handle";
    cols[i].appendChild(div);
    cols[i].style.position = "relative";
    setListeners(div);
  }

  function setListeners(div) {
    var pageX, curCol, nxtCol, curColWidth, nxtColWidth;
    div.addEventListener("mousedown", function (e) {
      e.preventDefault();
      e.stopPropagation();
      curCol = e.target.parentElement;
      nxtCol = curCol.nextElementSibling;
      pageX = e.pageX;
      var padding = paddingDiff(curCol);
      curColWidth = curCol.offsetWidth - padding;
      if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding;
    }); // div.addEventListener("mouseover", function(e) {
    //   e.target.style.borderRight = "2px solid #0000ff";
    // });

    div.addEventListener("mouseout", function (e) {
      e.target.style.borderRight = "";
    });

    function onMouseMove(e) {
      if (curCol) {
        var diffX = e.pageX - pageX;
        if (nxtCol) nxtCol.style.width = nxtColWidth - diffX + "px";
        curCol.style.width = curColWidth + diffX + "px";
      }
    }

    function onMouseUp(e) {
      if (e.target.nodeName === 'INPUT') return;
      e.preventDefault();
      e.stopPropagation();
      curCol = undefined;
      nxtCol = undefined;
      pageX = undefined;
      nxtColWidth = undefined;
      curColWidth = undefined;
    }

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
    documentListeners.push({
      event: "mousemove",
      handler: onMouseMove
    }, {
      event: "mouseup",
      handler: onMouseUp
    });
  }

  function createDiv(height) {
    var div = document.createElement("div");
    div.style.top = 0;
    div.style.right = 0;
    div.style.width = "5px";
    div.style.position = "absolute";
    div.style.cursor = "col-resize";
    div.style.userSelect = "none";
    div.style.height = height + "px";
    return div;
  }

  function paddingDiff(col) {
    if (getStyleVal(col, "box-sizing") == "border-box") {
      return 0;
    }

    var padLeft = getStyleVal(col, "padding-left");
    var padRight = getStyleVal(col, "padding-right");
    return parseInt(padLeft) + parseInt(padRight);
  }

  function getStyleVal(elm, css) {
    return window.getComputedStyle(elm, null).getPropertyValue(css);
  }

  function removeDocumentListeners() {
    documentListeners.forEach(function (listener) {
      document.removeEventListener(listener.event, listener.handler);
    });
  }

  return removeDocumentListeners;
};

/***/ }),

/***/ "jJmG":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("mEA3"), __esModule: true };

/***/ }),

/***/ "jNuQ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "jOgh":
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("EuP9").Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


/***/ }),

/***/ "jOvE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(__webpack_require__("40O2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(useVuex, source) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var data = {
    vuex: true,
    activeState: false,
    userColumnsDisplay: [],
    userControlsColumns: false,
    displayColumnsDropdown: false,
    collapsedGroups: []
  };
  if (useVuex) return data;
  data = (0, _merge["default"])(data, {
    vuex: false,
    count: 0,
    customQueries: {},
    query: null,
    page: page,
    limit: 10,
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : null,
    orderBy: {
      column: false,
      ascending: true
    }
  });
  if (source == 'server') data.data = [];
  return data;
}

/***/ }),

/***/ "jSRM":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__("geuY")
var randomBytes = __webpack_require__("rOku")

function blind (priv) {
  var r = getr(priv)
  var blinder = r.toRed(BN.mont(priv.modulus)).redPow(new BN(priv.publicExponent)).fromRed()
  return { blinder: blinder, unblinder: r.invm(priv.modulus) }
}

function getr (priv) {
  var len = priv.modulus.byteLength()
  var r
  do {
    r = new BN(randomBytes(len))
  } while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))
  return r
}

function crt (msg, priv) {
  var blinds = blind(priv)
  var len = priv.modulus.byteLength()
  var blinded = new BN(msg).mul(blinds.blinder).umod(priv.modulus)
  var c1 = blinded.toRed(BN.mont(priv.prime1))
  var c2 = blinded.toRed(BN.mont(priv.prime2))
  var qinv = priv.coefficient
  var p = priv.prime1
  var q = priv.prime2
  var m1 = c1.redPow(priv.exponent1).fromRed()
  var m2 = c2.redPow(priv.exponent2).fromRed()
  var h = m1.isub(m2).imul(qinv).umod(p).imul(q)
  return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike(Buffer, 'be', len)
}
crt.getr = getr

module.exports = crt

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "jerF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  return 'vf__' + column.split('.').join('@@@');
};

/***/ }),

/***/ "jgO3":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("8ANE");
var isArray = __webpack_require__("NU0k");
var SPECIES = __webpack_require__("hgbu")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "jkjm":
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__("19bf")
var aesid = __webpack_require__("8YCc")
var fixProc = __webpack_require__("7VT+")
var ciphers = __webpack_require__("tXf9")
var compat = __webpack_require__("/vd3")
var Buffer = __webpack_require__("X3l8").Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      // throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),

/***/ "jlkA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vue = _interopRequireDefault(__webpack_require__("7+uW"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var bus = new _vue["default"]();
var _default = bus;
exports["default"] = _default;

/***/ }),

/***/ "k2Sm":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),

/***/ "k4z0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var debounce = __webpack_require__("HhAh");

module.exports = function (h) {
  var _this = this;

  return function (selectClass, id) {
    var pages = [];
    var selected;

    for (var pag = 1; pag <= _this.totalPages; pag++) {
      var selected = _this.page == pag;
      pages.push(h("option", {
        domProps: {
          "value": pag,
          "selected": selected
        }
      }, [pag]));
    }

    return h("select", {
      "class": "".concat(selectClass, " dropdown-pagination"),
      directives: [{
        name: "show",
        value: _this.totalPages > 1
      }],
      attrs: {
        name: "page",
        id: id
      },
      ref: "page",
      domProps: {
        "value": _this.page
      },
      on: {
        "change": _this.setPage.bind(_this, null, false)
      }
    }, [pages]);
  };
};

/***/ }),

/***/ "kAit":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (colName, ev) {
  if (!this.sortable(colName)) return;

  if (ev && ev.shiftKey && this.orderBy.column && this.hasMultiSort) {
    this.setUserMultiSort(colName);
  } else {
    this.userMultiSorting = {};
    this.orderBy.ascending = colName == this.orderBy.column ? !this.orderBy.ascending : this._initialOrderAscending(colName);
    this.orderBy.column = colName;
    this.updateState('orderBy', this.orderBy);
    this.dispatch('sorted', JSON.parse(JSON.stringify(this.orderBy)));
  }

  if (this.source == 'server') {
    this.getData();
  }
};

/***/ }),

/***/ "kDG8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bus = _interopRequireDefault(__webpack_require__("jlkA"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function () {
  var event = 'vue-tables';
  if (this.name) event += '.' + this.name;
  this.opts.customFilters.forEach(function (filter) {
    _bus["default"].$off("".concat(event, ".filter::").concat(filter));

    _bus["default"].$on("".concat(event, ".filter::").concat(filter), function (value) {
      this.customQueries[filter] = value;
      this.updateState('customQueries', this.customQueries);
      this.refresh();
    }.bind(this));
  }.bind(this));
};

/***/ }),

/***/ "kGpW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var dropdownWrapper = __webpack_require__("0i9N");

var dropdownItemWrapper = __webpack_require__("HTMB");

module.exports = function (h) {
  var _this = this;

  return function (classes) {
    var cols = _this.columns.map(function (column) {
      return dropdownItemWrapper(h, classes, h("a", {
        "class": classes.dropdown.item,
        attrs: {
          href: "#"
        },
        on: {
          "click": function click() {
            return _this.toggleColumn(column);
          }
        }
      }, [h("input", {
        attrs: {
          type: "checkbox",
          disabled: _this._onlyColumn(column)
        },
        domProps: {
          "value": column,
          "checked": _this.allColumns.includes(column)
        }
      }), _this.getHeading(column)]));
    });

    return h("div", {
      ref: "columnsdropdown",
      "class": "".concat(classes.dropdown.container, " ").concat(classes.right, " VueTables__columns-dropdown")
    }, [h("button", {
      attrs: {
        type: "button"
      },
      "class": "".concat(classes.button, " ").concat(classes.dropdown.trigger),
      on: {
        "click": _this._toggleColumnsDropdown.bind(_this)
      }
    }, [_this.display('columns'), h("span", {
      "class": "".concat(classes.icon, " ").concat(classes.small)
    }, [h("i", {
      "class": classes.dropdown.caret
    })])]), dropdownWrapper.call(_this, h, classes, cols)]);
  };
};

/***/ }),

/***/ "kJAH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var encoders = __webpack_require__("SAez");
var decoders = __webpack_require__("iLJX");
var inherits = __webpack_require__("LC74");

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
}

Entity.prototype._createNamed = function createNamed(Base) {
  var name = this.name;

  function Generated(entity) {
    this._initNamed(entity, name);
  }
  inherits(Generated, Base);
  Generated.prototype._initNamed = function _initNamed(entity, name) {
    Base.call(this, entity, name);
  };

  return new Generated(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed(decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed(encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};

/***/ }),

/***/ "kiBT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("BzqH"), __esModule: true };

/***/ }),

/***/ "kkvn":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("3fMt");
var invoke = __webpack_require__("eg8w");
var html = __webpack_require__("+iDZ");
var cel = __webpack_require__("PY1i");
var global = __webpack_require__("YjQv");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("NZra")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "ksFB":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("wiaE");
var defined = __webpack_require__("+MZ2");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "kxE3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var _Object$setPrototypeO;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var finished = __webpack_require__("PcVv");
var kLastResolve = Symbol('lastResolve');
var kLastReject = Symbol('lastReject');
var kError = Symbol('error');
var kEnded = Symbol('ended');
var kLastPromise = Symbol('lastPromise');
var kHandlePromise = Symbol('handlePromise');
var kStream = Symbol('stream');
function createIterResult(value, done) {
  return {
    value: value,
    done: done
  };
}
function readAndResolve(iter) {
  var resolve = iter[kLastResolve];
  if (resolve !== null) {
    var data = iter[kStream].read();
    // we defer if data is null
    // we can be expecting either 'end' or
    // 'error'
    if (data !== null) {
      iter[kLastPromise] = null;
      iter[kLastResolve] = null;
      iter[kLastReject] = null;
      resolve(createIterResult(data, false));
    }
  }
}
function onReadable(iter) {
  // we wait for the next tick, because it might
  // emit an error with process.nextTick
  process.nextTick(readAndResolve, iter);
}
function wrapForNext(lastPromise, iter) {
  return function (resolve, reject) {
    lastPromise.then(function () {
      if (iter[kEnded]) {
        resolve(createIterResult(undefined, true));
        return;
      }
      iter[kHandlePromise](resolve, reject);
    }, reject);
  };
}
var AsyncIteratorPrototype = Object.getPrototypeOf(function () {});
var ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf((_Object$setPrototypeO = {
  get stream() {
    return this[kStream];
  },
  next: function next() {
    var _this = this;
    // if we have detected an error in the meanwhile
    // reject straight away
    var error = this[kError];
    if (error !== null) {
      return Promise.reject(error);
    }
    if (this[kEnded]) {
      return Promise.resolve(createIterResult(undefined, true));
    }
    if (this[kStream].destroyed) {
      // We need to defer via nextTick because if .destroy(err) is
      // called, the error will be emitted via nextTick, and
      // we cannot guarantee that there is no error lingering around
      // waiting to be emitted.
      return new Promise(function (resolve, reject) {
        process.nextTick(function () {
          if (_this[kError]) {
            reject(_this[kError]);
          } else {
            resolve(createIterResult(undefined, true));
          }
        });
      });
    }

    // if we have multiple next() calls
    // we will wait for the previous Promise to finish
    // this logic is optimized to support for await loops,
    // where next() is only called once at a time
    var lastPromise = this[kLastPromise];
    var promise;
    if (lastPromise) {
      promise = new Promise(wrapForNext(lastPromise, this));
    } else {
      // fast path needed to support multiple this.push()
      // without triggering the next() queue
      var data = this[kStream].read();
      if (data !== null) {
        return Promise.resolve(createIterResult(data, false));
      }
      promise = new Promise(this[kHandlePromise]);
    }
    this[kLastPromise] = promise;
    return promise;
  }
}, _defineProperty(_Object$setPrototypeO, Symbol.asyncIterator, function () {
  return this;
}), _defineProperty(_Object$setPrototypeO, "return", function _return() {
  var _this2 = this;
  // destroy(err, cb) is a private API
  // we can guarantee we have that here, because we control the
  // Readable class this is attached to
  return new Promise(function (resolve, reject) {
    _this2[kStream].destroy(null, function (err) {
      if (err) {
        reject(err);
        return;
      }
      resolve(createIterResult(undefined, true));
    });
  });
}), _Object$setPrototypeO), AsyncIteratorPrototype);
var createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
  var _Object$create;
  var iterator = Object.create(ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, _defineProperty(_Object$create, kStream, {
    value: stream,
    writable: true
  }), _defineProperty(_Object$create, kLastResolve, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kLastReject, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kError, {
    value: null,
    writable: true
  }), _defineProperty(_Object$create, kEnded, {
    value: stream._readableState.endEmitted,
    writable: true
  }), _defineProperty(_Object$create, kHandlePromise, {
    value: function value(resolve, reject) {
      var data = iterator[kStream].read();
      if (data) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        resolve(createIterResult(data, false));
      } else {
        iterator[kLastResolve] = resolve;
        iterator[kLastReject] = reject;
      }
    },
    writable: true
  }), _Object$create));
  iterator[kLastPromise] = null;
  finished(stream, function (err) {
    if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
      var reject = iterator[kLastReject];
      // reject if we are waiting for data in the Promise
      // returned by next() and store the error
      if (reject !== null) {
        iterator[kLastPromise] = null;
        iterator[kLastResolve] = null;
        iterator[kLastReject] = null;
        reject(err);
      }
      iterator[kError] = err;
      return;
    }
    var resolve = iterator[kLastResolve];
    if (resolve !== null) {
      iterator[kLastPromise] = null;
      iterator[kLastResolve] = null;
      iterator[kLastReject] = null;
      resolve(createIterResult(undefined, true));
    }
    iterator[kEnded] = true;
  });
  stream.on('readable', onReadable.bind(null, iterator));
  return iterator;
};
module.exports = createReadableStreamAsyncIterator;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "kxFB":
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),

/***/ "l3mU":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+3lO");
__webpack_require__("tz60");
module.exports = __webpack_require__("Dl99");


/***/ }),

/***/ "l9cS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h) {
  var _this = this;

  return function (right) {
    var that = _this;

    var sortControl = __webpack_require__("2Wyf")(h, right);

    var headings = [];
    if (_this.hasChildRow && _this.opts.childRowTogglerFirst && _this.opts.showChildRowToggler) headings.push(h("th"));

    _this.allColumns.map(function (column) {
      headings.push(h("th", {
        on: {
          "keypress": function keypress(e) {
            if (e.key === "Enter") {
              that.orderByColumn.bind(that, column, e)();
            }
          },
          "click": function click(e) {
            if (e.target.className !== "resize-handle") {
              that.orderByColumn.bind(that, column, e)();
            }
          }
        },
        attrs: {
          id: "VueTables_th--".concat(column),
          tabindex: "0"
        },
        "class": this.sortableClass(column)
      }, [h("span", {
        "class": "VueTables__heading",
        attrs: {
          title: this.getHeadingTooltip(column, h)
        }
      }, [this.getHeading(column, h)]), sortControl.call(this, column)]));
    }.bind(_this));

    if (_this.hasChildRow && !_this.opts.childRowTogglerFirst && _this.opts.showChildRowToggler) headings.push(h("th"));
    return headings;
  };
};

/***/ }),

/***/ "lHA8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("+2NB"), __esModule: true };

/***/ }),

/***/ "lQBd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__("KDHK")

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),

/***/ "lUSU":
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__("H2Pp")

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),

/***/ "lXn8":
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("LC74")
var Sha256 = __webpack_require__("zvjZ")
var Hash = __webpack_require__("CzQx")
var Buffer = __webpack_require__("X3l8").Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),

/***/ "lZ6o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__("KYqO").version;
elliptic.utils = __webpack_require__("TkWM");
elliptic.rand = __webpack_require__("txgm");
elliptic.curve = __webpack_require__("tRuz");
elliptic.curves = __webpack_require__("hQ80");

// Protocols
elliptic.ec = __webpack_require__("F11g");
elliptic.eddsa = __webpack_require__("+e0g");


/***/ }),

/***/ "lm4Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column, row) {
  if (!this.opts.cellClasses[column]) return '';
  return this.opts.cellClasses[column].filter(function (item) {
    return item.condition(row);
  }).map(function (item) {
    return item["class"];
  }).join(' ');
};

/***/ }),

/***/ "mEA3":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("BdLN");
module.exports = __webpack_require__("iANj").Object.getOwnPropertyDescriptors;


/***/ }),

/***/ "mG69":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("C84k");
module.exports = __webpack_require__("iANj").Object.values;


/***/ }),

/***/ "mgCp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("c8Kh");
var global = __webpack_require__("YjQv");
var ctx = __webpack_require__("3fMt");
var classof = __webpack_require__("FHqv");
var $export = __webpack_require__("Wdy1");
var isObject = __webpack_require__("8ANE");
var aFunction = __webpack_require__("SWGL");
var anInstance = __webpack_require__("4S0F");
var forOf = __webpack_require__("dudK");
var speciesConstructor = __webpack_require__("BfX3");
var task = __webpack_require__("kkvn").set;
var microtask = __webpack_require__("LKnP")();
var newPromiseCapabilityModule = __webpack_require__("3HN9");
var perform = __webpack_require__("AgWD");
var userAgent = __webpack_require__("ht0Q");
var promiseResolve = __webpack_require__("qC2Z");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("hgbu")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("nJ75")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("LhDF")($Promise, PROMISE);
__webpack_require__("EFoD")(PROMISE);
Wrapper = __webpack_require__("iANj")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("wWcv")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "mtWM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("tIFN");

/***/ }),

/***/ "mvHQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Zbun"), __esModule: true };

/***/ }),

/***/ "mw3O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__("CwSZ");
var parse = __webpack_require__("DDCP");
var formats = __webpack_require__("XgCd");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "mypn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "nErl":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "nJ75":
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__("aLzV");
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),

/***/ "nVNB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    framework: 'bulma',
    table: 'table is-bordered is-striped is-hoverable is-fullwidth',
    row: 'columns',
    column: 'column is-12',
    label: 'label',
    input: 'input',
    select: 'select',
    field: 'field',
    inline: 'is-horizontal',
    right: 'is-pulled-right',
    left: 'is-pulled-left',
    center: 'has-text-centered',
    contentCenter: 'is-centered',
    icon: 'icon',
    small: 'is-small',
    nomargin: 'marginless',
    button: 'button',
    groupTr: 'is-selected',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-trigger',
      menu: 'dropdown-menu',
      content: 'dropdown-content',
      item: 'dropdown-item',
      caret: 'fa fa-angle-down'
    },
    pagination: {
      nav: '',
      count: '',
      wrapper: 'pagination',
      list: 'pagination-list',
      item: '',
      link: 'pagination-link',
      next: '',
      prev: '',
      active: 'is-current',
      disabled: ''
    }
  };
};

/***/ }),

/***/ "nclR":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("Wdy1");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("NMac").set });


/***/ }),

/***/ "nvbp":
/***/ (function(module, exports) {

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/

module.exports = function mergeJSXProps (objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp
    for (key in b) {
      aa = a[key]
      bb = b[key]
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa
            a[key] = aa = {}
            aa[temp] = true
          }
          if (typeof bb === 'string') {
            temp = bb
            b[key] = bb = {}
            bb[temp] = true
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb)
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb)
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey]
          }
        }
      } else {
        a[key] = b[key]
      }
    }
    return a
  }, {})
}

function mergeFn (a, b) {
  return function () {
    a && a.apply(this, arguments)
    b && b.apply(this, arguments)
  }
}


/***/ }),

/***/ "nyV4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__("08Lv");
var inherits = __webpack_require__("LC74");

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),

/***/ "o06D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.opts.filterable && this.opts.filterable.length ? this.opts.filterable : this.Columns;
};

/***/ }),

/***/ "oJlt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "oNTk":
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("EuP9")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "oUpx":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__("Wdy1");

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__("9h1I")('Map') });


/***/ }),

/***/ "oY0/":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+3lO");
__webpack_require__("tz60");
module.exports = __webpack_require__("St71");


/***/ }),

/***/ "ounN":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("ksFB");
var $getOwnPropertyDescriptor = __webpack_require__("rjjF").f;

__webpack_require__("30vf")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "p1b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "p642":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (query) {
  var el;

  if (this.opts.filterByColumn) {
    for (var column in query) {
      var columnName = this._getColumnName(column);

      if (this.isDateFilter(column)) {
        if (query[column] && _typeof(query[column]) === 'object') {
          var start = typeof query[column].start === 'string' ? moment(query[column].start, 'YYYY-MM-DD') : query[column].start;
          var end = typeof query[column].end === 'string' ? moment(query[column].end, 'YYYY-MM-DD') : query[column].end;

          this._setDatepickerText(column, start, end);
        } else {
          $(this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter").html("<span class='VueTables__filter-placeholder'>" + this.display('filterBy', {
            column: this.getHeading(column)
          }) + "</span>");
        }

        continue;
      }

      el = this.$el.querySelector("[name='".concat(columnName, "']"));

      if (el) {
        el.value = query[column];
      } else if (this.columns.indexOf(column) === -1) {
        console.error("vue-tables-2: Error in setting filter value. Column '".concat(column, "' does not exist."));
      }
    }
  } else {
    var el = this.$el.querySelector('.VueTables__search__input');
    if (el) el.value = query;
  }
};

/***/ }),

/***/ "p8xL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__("XgCd");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        /* eslint operator-linebreak: [2, "before"] */
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ "pBtG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "pEGt":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("DvwR");
var enumBugKeys = __webpack_require__("B5V0");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "pFYg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__("Zzip");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__("5QVw");

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),

/***/ "pS+P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("YP8Q");
var inherits = __webpack_require__("LC74");
var Base = __webpack_require__("B6Bn");

var utils = __webpack_require__("TkWM");

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),

/***/ "pecZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var clone = __webpack_require__("jNuQ");

module.exports = {
  get: function get() {
    var data = clone(this.tableData);
    var column = this.orderBy.column;
    data = this.search(data);

    if (column) {
      // dummy var to force compilation
      if (this.time) this.time = this.time;
      data = this.opts.sortingAlgorithm.call(this, data, column);
    } else if (this.opts.groupBy) {
      data = this.opts.sortingAlgorithm.call(this, data, this.opts.groupBy);
    }

    if (this.vuex) {
      if (this.count != data.length) this.commit('SET_COUNT', data.length);
    } else {
      this.count = data.length;
    }

    var offset = (this.page - 1) * this.limit;
    this.allFilteredData = JSON.parse(JSON.stringify(data));
    data = data.splice(offset, this.limit);
    return this.applyFilters(data);
  },
  set: function set(val) {
    console.log(val);
  }
};

/***/ }),

/***/ "pkEt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value, column, h) {
  var query = this.opts.filterByColumn ? this.query[column] : this.query;
  if (!query) return value;
  query = new RegExp("(" + escapeRegex(query) + ")", "i");
  return h("span", {
    "class": 'VueTables__highlight'
  }, matches(value, query, h));
};

function matches(value, query, h) {
  var pieces = String(value).split(query);
  return pieces.map(function (piece) {
    if (query.test(piece)) {
      return h("b", {}, piece);
    }

    return piece;
  });
}

function escapeRegex(s) {
  return typeof s === 'string' ? s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') : s;
}

;

/***/ }),

/***/ "pn+s":
/***/ (function(module, exports, __webpack_require__) {

// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var Buffer = __webpack_require__("yASt").Buffer
var createHmac = __webpack_require__("ARY+")
var crt = __webpack_require__("jSRM")
var EC = __webpack_require__("lZ6o").ec
var BN = __webpack_require__("geuY")
var parseKeys = __webpack_require__("jkjm")
var curves = __webpack_require__("QDfD")

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [0, 1]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return Buffer.from(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [0].concat(r)
  if (s[0] & 0x80) s = [0].concat(s)

  var total = r.length + s.length + 4
  var res = [0x30, total, 0x02, r.length]
  res = res.concat(r, [0x02, s.length], s)
  return Buffer.from(res)
}

function getKey (x, q, hash, algo) {
  x = Buffer.from(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - x.length)
    x = Buffer.concat([zeros, x])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = Buffer.alloc(hlen)
  v.fill(1)
  var k = Buffer.alloc(hlen)
  k = createHmac(algo, k).update(v).update(Buffer.from([0])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(Buffer.from([1])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = Buffer.from(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = Buffer.alloc(q.byteLength() - out.length)
    out = Buffer.concat([zeros, out])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = Buffer.alloc(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([t, kv.v])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(Buffer.from([0])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey


/***/ }),

/***/ "ps4E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



var inherits = __webpack_require__("LC74");
var Buffer = __webpack_require__("Hwfm").Buffer;
var Node = __webpack_require__("vugd");

// Import DER constants
var der = __webpack_require__("C1C2");

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var _header = Buffer.alloc(2);
    _header[0] = encodedTag;
    _header[1] = content.length;
    return this._createEncoderBuffer([_header, content]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8) {
    lenOctets++;
  }var header = Buffer.alloc(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var _i = 1 + lenOctets, j = content.length; j > 0; _i--, j >>= 8) {
    header[_i] = j & 0xff;
  }return this._createEncoderBuffer([header, content]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([str.unused | 0, str.data]);
  } else if (tag === 'bmpstr') {
    var buf = Buffer.alloc(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' + 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' + 'only latin upper and lower case letters, ' + 'digits, space, apostrophe, left and rigth ' + 'parenthesis, plus sign, comma, hyphen, ' + 'dot, slash, colon, equal sign, ' + 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values) return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s.]+/g);
    for (var i = 0; i < id.length; i++) {
      id[i] |= 0;
    }
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var _i2 = 0; _i2 < id.length; _i2++) {
      id[_i2] |= 0;
    }
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' + 'got: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(id));
  }

  if (!relative) {
    if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var _i3 = 0; _i3 < id.length; _i3++) {
    var ident = id[_i3];
    for (size++; ident >= 0x80; ident >>= 7) {
      size++;
    }
  }

  var objid = Buffer.alloc(size);
  var offset = objid.length - 1;
  for (var _i4 = id.length - 1; _i4 >= 0; _i4--) {
    var _ident = id[_i4];
    objid[offset--] = _ident & 0x7f;
    while ((_ident >>= 7) > 0) {
      objid[offset--] = 0x80 | _ident & 0x7f;
    }
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10) return '0' + num;else return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str = void 0;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [two(date.getUTCFullYear()), two(date.getUTCMonth() + 1), two(date.getUTCDate()), two(date.getUTCHours()), two(date.getUTCMinutes()), two(date.getUTCSeconds()), 'Z'].join('');
  } else if (tag === 'utctime') {
    str = [two(date.getUTCFullYear() % 100), two(date.getUTCMonth() + 1), two(date.getUTCDate()), two(date.getUTCHours()), two(date.getUTCMinutes()), two(date.getUTCSeconds()), 'Z'].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values) return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = Buffer.from(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var _size = num.length;
    if (num.length === 0) _size++;

    var _out = Buffer.alloc(_size);
    num.copy(_out);
    if (num.length === 0) _out[0] = 0;
    return this._createEncoderBuffer(_out);
  }

  if (num < 0x80) return this._createEncoderBuffer(num);

  if (num < 0x100) return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8) {
    size++;
  }var out = new Array(size);
  for (var _i5 = out.length - 1; _i5 >= 0; _i5--) {
    out[_i5] = num & 0xff;
    num >>= 8;
  }
  if (out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(Buffer.from(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function') entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i = void 0;
  if (state['default'] === null) return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length) return false;

  for (i = 0; i < data.length; i++) {
    if (data[i] !== state.defaultBuffer[i]) return false;
  }return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res = void 0;

  if (tag === 'seqof') tag = 'seq';else if (tag === 'setof') tag = 'set';

  if (der.tagByName.hasOwnProperty(tag)) res = der.tagByName[tag];else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;else return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive) res |= 0x20;

  res |= der.tagClassByName[cls || 'universal'] << 6;

  return res;
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "pxG4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "qC2Z":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("FKWp");
var isObject = __webpack_require__("8ANE");
var newPromiseCapability = __webpack_require__("3HN9");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "qOYl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("vzCy").EventEmitter;


/***/ }),

/***/ "qRfI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "qajy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("acwh"), __esModule: true };

/***/ }),

/***/ "qmw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var intersect = function intersect(first) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return rest.reduce(function (accum, current) {
    return accum.filter(function (x) {
      return current.indexOf(x) !== -1;
    });
  }, first);
};

/* harmony default export */ __webpack_exports__["default"] = (intersect);


/***/ }),

/***/ "qs+f":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("zyKz")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "r3+g":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("GCs6");
var anObject = __webpack_require__("FKWp");
var getKeys = __webpack_require__("pEGt");

module.exports = __webpack_require__("qs+f") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "r9kI":
/***/ (function(module, exports) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ "rIDh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__("/OYm");
__webpack_require__("LC74")(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "rKx+":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4ajQ");
var $Object = __webpack_require__("iANj").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "rOku":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__("X3l8").Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "rZAI":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("wXdB");
var $keys = __webpack_require__("pEGt");

__webpack_require__("30vf")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "reGU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__("LC74");

var bignum = __webpack_require__("hgsc");
var DecoderBuffer = __webpack_require__("iTY7").DecoderBuffer;
var Node = __webpack_require__("vugd");

// Import DER constants
var der = __webpack_require__("C1C2");

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
}
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!DecoderBuffer.isDecoderBuffer(data)) {
    data = new DecoderBuffer(data, options);
  }

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  Node.call(this, 'der', parent);
}
inherits(DERNode, Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty()) return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag)) return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag)) return decodedTag;

  var len = derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len)) return len;

  if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res)) return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  for (;;) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag)) return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len)) return len;

    var res = void 0;
    if (tag.primitive || len !== null) res = buffer.skip(len);else res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res)) return res;

    if (tag.tagStr === 'end') break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd)) return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd) break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused)) return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' + 'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' + 'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result = void 0;
  var identifiers = [];
  var ident = 0;
  var subident = 0;
  while (!buffer.isEmpty()) {
    subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80) identifiers.push(ident);

  var first = identifiers[0] / 40 | 0;
  var second = identifiers[0] % 40;

  if (relative) result = identifiers;else result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined) tmp = values[result.join('.')];
    if (tmp !== undefined) result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();

  var year = void 0;
  var mon = void 0;
  var day = void 0;
  var hour = void 0;
  var min = void 0;
  var sec = void 0;
  if (tag === 'gentime') {
    year = str.slice(0, 4) | 0;
    mon = str.slice(4, 6) | 0;
    day = str.slice(6, 8) | 0;
    hour = str.slice(8, 10) | 0;
    min = str.slice(10, 12) | 0;
    sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    year = str.slice(0, 2) | 0;
    mon = str.slice(2, 4) | 0;
    day = str.slice(4, 6) | 0;
    hour = str.slice(6, 8) | 0;
    min = str.slice(8, 10) | 0;
    sec = str.slice(10, 12) | 0;
    if (year < 70) year = 2000 + year;else year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull() {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res)) return res;else return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values) res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function') entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag)) return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct)) return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len)) return len;

  // Indefinite form
  if (!primitive && len === 0x80) return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4) return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j)) return j;
    len |= j;
  }

  return len;
}

/***/ }),

/***/ "rjj0":
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__("tTVk")

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "rjjF":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("bSeU");
var createDesc = __webpack_require__("YTz9");
var toIObject = __webpack_require__("ksFB");
var toPrimitive = __webpack_require__("9MbE");
var has = __webpack_require__("x//u");
var IE8_DOM_DEFINE = __webpack_require__("LocR");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("qs+f") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "rp/e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return {
    framework: 'bootstrap4',
    table: 'table table-striped table-bordered table-hover',
    row: 'row',
    column: 'col-md-12',
    label: '',
    input: 'form-control',
    select: 'form-control',
    field: 'form-group',
    inline: 'form-inline',
    right: 'float-right',
    left: 'float-left',
    center: 'text-center',
    contentCenter: 'justify-content-center',
    nomargin: 'm-0',
    groupTr: 'table-info',
    small: '',
    button: 'btn btn-secondary',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-toggle',
      menu: 'dropdown-menu',
      content: '',
      item: 'dropdown-item',
      caret: 'caret'
    },
    pagination: {
      nav: '',
      count: '',
      wrapper: '',
      list: 'pagination',
      item: 'page-item',
      link: 'page-link',
      next: '',
      prev: '',
      active: 'active',
      disabled: 'disabled'
    }
  };
};

/***/ }),

/***/ "s2sY":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("jgO3");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "s4AF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column) {
  var _this = this;

  if (!this.userControlsColumns) {
    this.userColumnsDisplay = JSON.parse(JSON.stringify(this.allColumns));
    this.userControlsColumns = true;
  }

  if (this.userColumnsDisplay.includes(column)) {
    // can't have no columns
    if (this.userColumnsDisplay.length === 1) return;
    var index = this.userColumnsDisplay.indexOf(column);
    this.userColumnsDisplay.splice(index, 1);
  } else {
    this.userColumnsDisplay.push(column);
  }

  this.updateState('userControlsColumns', true);
  this.updateState('userColumnsDisplay', this.userColumnsDisplay);
  this.$nextTick(function () {
    _this._setFiltersDOM(_this.query);
  });
};

/***/ }),

/***/ "s6FM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (h, row, index) {
  // scoped slot
  if (this.$scopedSlots.child_row) return this.$scopedSlots.child_row({
    row: row,
    index: index
  });
  var childRow = this.opts.childRow; // function

  if (typeof childRow === 'function') return childRow.apply(this, [h, row]); // component

  return h(childRow, {
    attrs: {
      data: row
    }
  });
};

/***/ }),

/***/ "s83z":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(6).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module)))

/***/ }),

/***/ "sFQN":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__("Wdy1");
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__("zyKz")(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),

/***/ "sOR5":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "sbXZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/***/ }),

/***/ "sycf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (row, column, index, h) {
  var value = this._getValue(row, column);

  if (this.templatesKeys.indexOf(column) == -1) {
    if (typeof value === 'undefined' || !this.opts.highlightMatches || this.filterableColumns.indexOf(column) === -1) {
      return value;
    }

    return this.highlightMatch(value, column, h);
  }

  var template = this.opts.templates[column];
  template = typeof template == 'function' ? template.apply(this.$root, [h, row, index, column]) : h(template, {
    attrs: {
      data: row,
      column: column,
      index: index
    }
  });
  return template;
};

/***/ }),

/***/ "szDu":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0/jl");
module.exports = __webpack_require__("iANj").Object.getOwnPropertySymbols;


/***/ }),

/***/ "t8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "tIFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var bind = __webpack_require__("JP+z");
var Axios = __webpack_require__("XmWM");
var defaults = __webpack_require__("KCLY");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("dVOP");
axios.CancelToken = __webpack_require__("cWxy");
axios.isCancel = __webpack_require__("pBtG");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("pxG4");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "tRuz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__("B6Bn");
curve.short = __webpack_require__("wrMp");
curve.mont = __webpack_require__("pS+P");
curve.edwards = __webpack_require__("24Y6");


/***/ }),

/***/ "tTVk":
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ "tXf9":
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__("bSQl")
var deciphers = __webpack_require__("+jDU")
var modes = __webpack_require__("6ZSt")

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),

/***/ "tYO1":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0/jl");
__webpack_require__("gCWN");
__webpack_require__("3ggi");
__webpack_require__("OoWg");
module.exports = __webpack_require__("iANj").Symbol;


/***/ }),

/***/ "thJu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "thjQ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.swal=e():t.swal=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=8)}([function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o="swal-button";e.CLASS_NAMES={MODAL:"swal-modal",OVERLAY:"swal-overlay",SHOW_MODAL:"swal-overlay--show-modal",MODAL_TITLE:"swal-title",MODAL_TEXT:"swal-text",ICON:"swal-icon",ICON_CUSTOM:"swal-icon--custom",CONTENT:"swal-content",FOOTER:"swal-footer",BUTTON_CONTAINER:"swal-button-container",BUTTON:o,CONFIRM_BUTTON:o+"--confirm",CANCEL_BUTTON:o+"--cancel",DANGER_BUTTON:o+"--danger",BUTTON_LOADING:o+"--loading",BUTTON_LOADER:o+"__loader"},e.default=e.CLASS_NAMES},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.getNode=function(t){var e="."+t;return document.querySelector(e)},e.stringToNode=function(t){var e=document.createElement("div");return e.innerHTML=t.trim(),e.firstChild},e.insertAfter=function(t,e){var n=e.nextSibling;e.parentNode.insertBefore(t,n)},e.removeNode=function(t){t.parentElement.removeChild(t)},e.throwErr=function(t){throw t=t.replace(/ +(?= )/g,""),"SweetAlert: "+(t=t.trim())},e.isPlainObject=function(t){if("[object Object]"!==Object.prototype.toString.call(t))return!1;var e=Object.getPrototypeOf(t);return null===e||e===Object.prototype},e.ordinalSuffixOf=function(t){var e=t%10,n=t%100;return 1===e&&11!==n?t+"st":2===e&&12!==n?t+"nd":3===e&&13!==n?t+"rd":t+"th"}},function(t,e,n){"use strict";function o(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}Object.defineProperty(e,"__esModule",{value:!0}),o(n(25));var r=n(26);e.overlayMarkup=r.default,o(n(27)),o(n(28)),o(n(29));var i=n(0),a=i.default.MODAL_TITLE,s=i.default.MODAL_TEXT,c=i.default.ICON,l=i.default.FOOTER;e.iconMarkup='\n  <div class="'+c+'"></div>',e.titleMarkup='\n  <div class="'+a+'"></div>\n',e.textMarkup='\n  <div class="'+s+'"></div>',e.footerMarkup='\n  <div class="'+l+'"></div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1);e.CONFIRM_KEY="confirm",e.CANCEL_KEY="cancel";var r={visible:!0,text:null,value:null,className:"",closeModal:!0},i=Object.assign({},r,{visible:!1,text:"Cancel",value:null}),a=Object.assign({},r,{text:"OK",value:!0});e.defaultButtonList={cancel:i,confirm:a};var s=function(t){switch(t){case e.CONFIRM_KEY:return a;case e.CANCEL_KEY:return i;default:var n=t.charAt(0).toUpperCase()+t.slice(1);return Object.assign({},r,{text:n,value:t})}},c=function(t,e){var n=s(t);return!0===e?Object.assign({},n,{visible:!0}):"string"==typeof e?Object.assign({},n,{visible:!0,text:e}):o.isPlainObject(e)?Object.assign({visible:!0},n,e):Object.assign({},n,{visible:!1})},l=function(t){for(var e={},n=0,o=Object.keys(t);n<o.length;n++){var r=o[n],a=t[r],s=c(r,a);e[r]=s}return e.cancel||(e.cancel=i),e},u=function(t){var n={};switch(t.length){case 1:n[e.CANCEL_KEY]=Object.assign({},i,{visible:!1});break;case 2:n[e.CANCEL_KEY]=c(e.CANCEL_KEY,t[0]),n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t[1]);break;default:o.throwErr("Invalid number of 'buttons' in array ("+t.length+").\n      If you want more than 2 buttons, you need to use an object!")}return n};e.getButtonListOpts=function(t){var n=e.defaultButtonList;return"string"==typeof t?n[e.CONFIRM_KEY]=c(e.CONFIRM_KEY,t):Array.isArray(t)?n=u(t):o.isPlainObject(t)?n=l(t):!0===t?n=u([!0,!0]):!1===t?n=u([!1,!1]):void 0===t&&(n=e.defaultButtonList),n}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=n(0),a=i.default.MODAL,s=i.default.OVERLAY,c=n(30),l=n(31),u=n(32),f=n(33);e.injectElIntoModal=function(t){var e=o.getNode(a),n=o.stringToNode(t);return e.appendChild(n),n};var d=function(t){t.className=a,t.textContent=""},p=function(t,e){d(t);var n=e.className;n&&t.classList.add(n)};e.initModalContent=function(t){var e=o.getNode(a);p(e,t),c.default(t.icon),l.initTitle(t.title),l.initText(t.text),f.default(t.content),u.default(t.buttons,t.dangerMode)};var m=function(){var t=o.getNode(s),e=o.stringToNode(r.modalMarkup);t.appendChild(e)};e.default=m},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r={isOpen:!1,promise:null,actions:{},timer:null},i=Object.assign({},r);e.resetState=function(){i=Object.assign({},r)},e.setActionValue=function(t){if("string"==typeof t)return a(o.CONFIRM_KEY,t);for(var e in t)a(e,t[e])};var a=function(t,e){i.actions[t]||(i.actions[t]={}),Object.assign(i.actions[t],{value:e})};e.setActionOptionsFor=function(t,e){var n=(void 0===e?{}:e).closeModal,o=void 0===n||n;Object.assign(i.actions[t],{closeModal:o})},e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(0),a=i.default.OVERLAY,s=i.default.SHOW_MODAL,c=i.default.BUTTON,l=i.default.BUTTON_LOADING,u=n(5);e.openModal=function(){o.getNode(a).classList.add(s),u.default.isOpen=!0};var f=function(){o.getNode(a).classList.remove(s),u.default.isOpen=!1};e.onAction=function(t){void 0===t&&(t=r.CANCEL_KEY);var e=u.default.actions[t],n=e.value;if(!1===e.closeModal){var i=c+"--"+t;o.getNode(i).classList.add(l)}else f();u.default.promise.resolve(n)},e.getState=function(){var t=Object.assign({},u.default);return delete t.promise,delete t.timer,t},e.stopLoading=function(){for(var t=document.querySelectorAll("."+c),e=0;e<t.length;e++){t[e].classList.remove(l)}}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){(function(e){t.exports=e.sweetAlert=n(9)}).call(e,n(7))},function(t,e,n){(function(e){t.exports=e.swal=n(10)}).call(e,n(7))},function(t,e,n){"undefined"!=typeof window&&n(11),n(16);var o=n(23).default;t.exports=o},function(t,e,n){var o=n(12);"string"==typeof o&&(o=[[t.i,o,""]]);var r={insertAt:"top"};r.transform=void 0;n(14)(o,r);o.locals&&(t.exports=o.locals)},function(t,e,n){e=t.exports=n(13)(void 0),e.push([t.i,'.swal-icon--error{border-color:#f27474;-webkit-animation:animateErrorIcon .5s;animation:animateErrorIcon .5s}.swal-icon--error__x-mark{position:relative;display:block;-webkit-animation:animateXMark .5s;animation:animateXMark .5s}.swal-icon--error__line{position:absolute;height:5px;width:47px;background-color:#f27474;display:block;top:37px;border-radius:2px}.swal-icon--error__line--left{-webkit-transform:rotate(45deg);transform:rotate(45deg);left:17px}.swal-icon--error__line--right{-webkit-transform:rotate(-45deg);transform:rotate(-45deg);right:16px}@-webkit-keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@keyframes animateErrorIcon{0%{-webkit-transform:rotateX(100deg);transform:rotateX(100deg);opacity:0}to{-webkit-transform:rotateX(0deg);transform:rotateX(0deg);opacity:1}}@-webkit-keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}@keyframes animateXMark{0%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}50%{-webkit-transform:scale(.4);transform:scale(.4);margin-top:26px;opacity:0}80%{-webkit-transform:scale(1.15);transform:scale(1.15);margin-top:-6px}to{-webkit-transform:scale(1);transform:scale(1);margin-top:0;opacity:1}}.swal-icon--warning{border-color:#f8bb86;-webkit-animation:pulseWarning .75s infinite alternate;animation:pulseWarning .75s infinite alternate}.swal-icon--warning__body{width:5px;height:47px;top:10px;border-radius:2px;margin-left:-2px}.swal-icon--warning__body,.swal-icon--warning__dot{position:absolute;left:50%;background-color:#f8bb86}.swal-icon--warning__dot{width:7px;height:7px;border-radius:50%;margin-left:-4px;bottom:-11px}@-webkit-keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}@keyframes pulseWarning{0%{border-color:#f8d486}to{border-color:#f8bb86}}.swal-icon--success{border-color:#a5dc86}.swal-icon--success:after,.swal-icon--success:before{content:"";border-radius:50%;position:absolute;width:60px;height:120px;background:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.swal-icon--success:before{border-radius:120px 0 0 120px;top:-7px;left:-33px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:60px 60px;transform-origin:60px 60px}.swal-icon--success:after{border-radius:0 120px 120px 0;top:-11px;left:30px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-transform-origin:0 60px;transform-origin:0 60px;-webkit-animation:rotatePlaceholder 4.25s ease-in;animation:rotatePlaceholder 4.25s ease-in}.swal-icon--success__ring{width:80px;height:80px;border:4px solid hsla(98,55%,69%,.2);border-radius:50%;box-sizing:content-box;position:absolute;left:-4px;top:-4px;z-index:2}.swal-icon--success__hide-corners{width:5px;height:90px;background-color:#fff;padding:1px;position:absolute;left:28px;top:8px;z-index:1;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.swal-icon--success__line{height:5px;background-color:#a5dc86;display:block;border-radius:2px;position:absolute;z-index:2}.swal-icon--success__line--tip{width:25px;left:14px;top:46px;-webkit-transform:rotate(45deg);transform:rotate(45deg);-webkit-animation:animateSuccessTip .75s;animation:animateSuccessTip .75s}.swal-icon--success__line--long{width:47px;right:8px;top:38px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg);-webkit-animation:animateSuccessLong .75s;animation:animateSuccessLong .75s}@-webkit-keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@keyframes rotatePlaceholder{0%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}5%{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}12%{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}to{-webkit-transform:rotate(-405deg);transform:rotate(-405deg)}}@-webkit-keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@keyframes animateSuccessTip{0%{width:0;left:1px;top:19px}54%{width:0;left:1px;top:19px}70%{width:50px;left:-8px;top:37px}84%{width:17px;left:21px;top:48px}to{width:25px;left:14px;top:45px}}@-webkit-keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}@keyframes animateSuccessLong{0%{width:0;right:46px;top:54px}65%{width:0;right:46px;top:54px}84%{width:55px;right:0;top:35px}to{width:47px;right:8px;top:38px}}.swal-icon--info{border-color:#c9dae1}.swal-icon--info:before{width:5px;height:29px;bottom:17px;border-radius:2px;margin-left:-2px}.swal-icon--info:after,.swal-icon--info:before{content:"";position:absolute;left:50%;background-color:#c9dae1}.swal-icon--info:after{width:7px;height:7px;border-radius:50%;margin-left:-3px;top:19px}.swal-icon{width:80px;height:80px;border-width:4px;border-style:solid;border-radius:50%;padding:0;position:relative;box-sizing:content-box;margin:20px auto}.swal-icon:first-child{margin-top:32px}.swal-icon--custom{width:auto;height:auto;max-width:100%;border:none;border-radius:0}.swal-icon img{max-width:100%;max-height:100%}.swal-title{color:rgba(0,0,0,.65);font-weight:600;text-transform:none;position:relative;display:block;padding:13px 16px;font-size:27px;line-height:normal;text-align:center;margin-bottom:0}.swal-title:first-child{margin-top:26px}.swal-title:not(:first-child){padding-bottom:0}.swal-title:not(:last-child){margin-bottom:13px}.swal-text{font-size:16px;position:relative;float:none;line-height:normal;vertical-align:top;text-align:left;display:inline-block;margin:0;padding:0 10px;font-weight:400;color:rgba(0,0,0,.64);max-width:calc(100% - 20px);overflow-wrap:break-word;box-sizing:border-box}.swal-text:first-child{margin-top:45px}.swal-text:last-child{margin-bottom:45px}.swal-footer{text-align:right;padding-top:13px;margin-top:13px;padding:13px 16px;border-radius:inherit;border-top-left-radius:0;border-top-right-radius:0}.swal-button-container{margin:5px;display:inline-block;position:relative}.swal-button{background-color:#7cd1f9;color:#fff;border:none;box-shadow:none;border-radius:5px;font-weight:600;font-size:14px;padding:10px 24px;margin:0;cursor:pointer}.swal-button:not([disabled]):hover{background-color:#78cbf2}.swal-button:active{background-color:#70bce0}.swal-button:focus{outline:none;box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(43,114,165,.29)}.swal-button[disabled]{opacity:.5;cursor:default}.swal-button::-moz-focus-inner{border:0}.swal-button--cancel{color:#555;background-color:#efefef}.swal-button--cancel:not([disabled]):hover{background-color:#e8e8e8}.swal-button--cancel:active{background-color:#d7d7d7}.swal-button--cancel:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(116,136,150,.29)}.swal-button--danger{background-color:#e64942}.swal-button--danger:not([disabled]):hover{background-color:#df4740}.swal-button--danger:active{background-color:#cf423b}.swal-button--danger:focus{box-shadow:0 0 0 1px #fff,0 0 0 3px rgba(165,43,43,.29)}.swal-content{padding:0 20px;margin-top:20px;font-size:medium}.swal-content:last-child{margin-bottom:20px}.swal-content__input,.swal-content__textarea{-webkit-appearance:none;background-color:#fff;border:none;font-size:14px;display:block;box-sizing:border-box;width:100%;border:1px solid rgba(0,0,0,.14);padding:10px 13px;border-radius:2px;transition:border-color .2s}.swal-content__input:focus,.swal-content__textarea:focus{outline:none;border-color:#6db8ff}.swal-content__textarea{resize:vertical}.swal-button--loading{color:transparent}.swal-button--loading~.swal-button__loader{opacity:1}.swal-button__loader{position:absolute;height:auto;width:43px;z-index:2;left:50%;top:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);text-align:center;pointer-events:none;opacity:0}.swal-button__loader div{display:inline-block;float:none;vertical-align:baseline;width:9px;height:9px;padding:0;border:none;margin:2px;opacity:.4;border-radius:7px;background-color:hsla(0,0%,100%,.9);transition:background .2s;-webkit-animation:swal-loading-anim 1s infinite;animation:swal-loading-anim 1s infinite}.swal-button__loader div:nth-child(3n+2){-webkit-animation-delay:.15s;animation-delay:.15s}.swal-button__loader div:nth-child(3n+3){-webkit-animation-delay:.3s;animation-delay:.3s}@-webkit-keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}@keyframes swal-loading-anim{0%{opacity:.4}20%{opacity:.4}50%{opacity:1}to{opacity:.4}}.swal-overlay{position:fixed;top:0;bottom:0;left:0;right:0;text-align:center;font-size:0;overflow-y:auto;background-color:rgba(0,0,0,.4);z-index:10000;pointer-events:none;opacity:0;transition:opacity .3s}.swal-overlay:before{content:" ";display:inline-block;vertical-align:middle;height:100%}.swal-overlay--show-modal{opacity:1;pointer-events:auto}.swal-overlay--show-modal .swal-modal{opacity:1;pointer-events:auto;box-sizing:border-box;-webkit-animation:showSweetAlert .3s;animation:showSweetAlert .3s;will-change:transform}.swal-modal{width:478px;opacity:0;pointer-events:none;background-color:#fff;text-align:center;border-radius:5px;position:static;margin:20px auto;display:inline-block;vertical-align:middle;-webkit-transform:scale(1);transform:scale(1);-webkit-transform-origin:50% 50%;transform-origin:50% 50%;z-index:10001;transition:opacity .2s,-webkit-transform .3s;transition:transform .3s,opacity .2s;transition:transform .3s,opacity .2s,-webkit-transform .3s}@media (max-width:500px){.swal-modal{width:calc(100% - 20px)}}@-webkit-keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes showSweetAlert{0%{-webkit-transform:scale(1);transform:scale(1)}1%{-webkit-transform:scale(.5);transform:scale(.5)}45%{-webkit-transform:scale(1.05);transform:scale(1.05)}80%{-webkit-transform:scale(.95);transform:scale(.95)}to{-webkit-transform:scale(1);transform:scale(1)}}',""])},function(t,e){function n(t,e){var n=t[1]||"",r=t[3];if(!r)return n;if(e&&"function"==typeof btoa){var i=o(r);return[n].concat(r.sources.map(function(t){return"/*# sourceURL="+r.sourceRoot+t+" */"})).concat([i]).join("\n")}return[n].join("\n")}function o(t){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(t))))+" */"}t.exports=function(t){var e=[];return e.toString=function(){return this.map(function(e){var o=n(e,t);return e[2]?"@media "+e[2]+"{"+o+"}":o}).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var o={},r=0;r<this.length;r++){var i=this[r][0];"number"==typeof i&&(o[i]=!0)}for(r=0;r<t.length;r++){var a=t[r];"number"==typeof a[0]&&o[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),e.push(a))}},e}},function(t,e,n){function o(t,e){for(var n=0;n<t.length;n++){var o=t[n],r=m[o.id];if(r){r.refs++;for(var i=0;i<r.parts.length;i++)r.parts[i](o.parts[i]);for(;i<o.parts.length;i++)r.parts.push(u(o.parts[i],e))}else{for(var a=[],i=0;i<o.parts.length;i++)a.push(u(o.parts[i],e));m[o.id]={id:o.id,refs:1,parts:a}}}}function r(t,e){for(var n=[],o={},r=0;r<t.length;r++){var i=t[r],a=e.base?i[0]+e.base:i[0],s=i[1],c=i[2],l=i[3],u={css:s,media:c,sourceMap:l};o[a]?o[a].parts.push(u):n.push(o[a]={id:a,parts:[u]})}return n}function i(t,e){var n=v(t.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var o=w[w.length-1];if("top"===t.insertAt)o?o.nextSibling?n.insertBefore(e,o.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),w.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){if(null===t.parentNode)return!1;t.parentNode.removeChild(t);var e=w.indexOf(t);e>=0&&w.splice(e,1)}function s(t){var e=document.createElement("style");return t.attrs.type="text/css",l(e,t.attrs),i(t,e),e}function c(t){var e=document.createElement("link");return t.attrs.type="text/css",t.attrs.rel="stylesheet",l(e,t.attrs),i(t,e),e}function l(t,e){Object.keys(e).forEach(function(n){t.setAttribute(n,e[n])})}function u(t,e){var n,o,r,i;if(e.transform&&t.css){if(!(i=e.transform(t.css)))return function(){};t.css=i}if(e.singleton){var l=h++;n=g||(g=s(e)),o=f.bind(null,n,l,!1),r=f.bind(null,n,l,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=c(e),o=p.bind(null,n,e),r=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(e),o=d.bind(null,n),r=function(){a(n)});return o(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;o(t=e)}else r()}}function f(t,e,n,o){var r=n?"":o.css;if(t.styleSheet)t.styleSheet.cssText=x(e,r);else{var i=document.createTextNode(r),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}function d(t,e){var n=e.css,o=e.media;if(o&&t.setAttribute("media",o),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function p(t,e,n){var o=n.css,r=n.sourceMap,i=void 0===e.convertToAbsoluteUrls&&r;(e.convertToAbsoluteUrls||i)&&(o=y(o)),r&&(o+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var a=new Blob([o],{type:"text/css"}),s=t.href;t.href=URL.createObjectURL(a),s&&URL.revokeObjectURL(s)}var m={},b=function(t){var e;return function(){return void 0===e&&(e=t.apply(this,arguments)),e}}(function(){return window&&document&&document.all&&!window.atob}),v=function(t){var e={};return function(n){return void 0===e[n]&&(e[n]=t.call(this,n)),e[n]}}(function(t){return document.querySelector(t)}),g=null,h=0,w=[],y=n(15);t.exports=function(t,e){if("undefined"!=typeof DEBUG&&DEBUG&&"object"!=typeof document)throw new Error("The style-loader cannot be used in a non-browser environment");e=e||{},e.attrs="object"==typeof e.attrs?e.attrs:{},e.singleton||(e.singleton=b()),e.insertInto||(e.insertInto="head"),e.insertAt||(e.insertAt="bottom");var n=r(t,e);return o(n,e),function(t){for(var i=[],a=0;a<n.length;a++){var s=n[a],c=m[s.id];c.refs--,i.push(c)}if(t){o(r(t,e),e)}for(var a=0;a<i.length;a++){var c=i[a];if(0===c.refs){for(var l=0;l<c.parts.length;l++)c.parts[l]();delete m[c.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e){t.exports=function(t){var e="undefined"!=typeof window&&window.location;if(!e)throw new Error("fixUrls requires window.location");if(!t||"string"!=typeof t)return t;var n=e.protocol+"//"+e.host,o=n+e.pathname.replace(/\/[^\/]*$/,"/");return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(t,e){var r=e.trim().replace(/^"(.*)"$/,function(t,e){return e}).replace(/^'(.*)'$/,function(t,e){return e});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(r))return t;var i;return i=0===r.indexOf("//")?r:0===r.indexOf("/")?n+r:o+r.replace(/^\.\//,""),"url("+JSON.stringify(i)+")"})}},function(t,e,n){var o=n(17);"undefined"==typeof window||window.Promise||(window.Promise=o),n(21),String.prototype.includes||(String.prototype.includes=function(t,e){"use strict";return"number"!=typeof e&&(e=0),!(e+t.length>this.length)&&-1!==this.indexOf(t,e)}),Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(t,e){if(null==this)throw new TypeError('"this" is null or not defined');var n=Object(this),o=n.length>>>0;if(0===o)return!1;for(var r=0|e,i=Math.max(r>=0?r:o-Math.abs(r),0);i<o;){if(function(t,e){return t===e||"number"==typeof t&&"number"==typeof e&&isNaN(t)&&isNaN(e)}(n[i],t))return!0;i++}return!1}}),"undefined"!=typeof window&&function(t){t.forEach(function(t){t.hasOwnProperty("remove")||Object.defineProperty(t,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){this.parentNode.removeChild(this)}})})}([Element.prototype,CharacterData.prototype,DocumentType.prototype])},function(t,e,n){(function(e){!function(n){function o(){}function r(t,e){return function(){t.apply(e,arguments)}}function i(t){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],f(t,this)}function a(t,e){for(;3===t._state;)t=t._value;if(0===t._state)return void t._deferreds.push(e);t._handled=!0,i._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null===n)return void(1===t._state?s:c)(e.promise,t._value);var o;try{o=n(t._value)}catch(t){return void c(e.promise,t)}s(e.promise,o)})}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof i)return t._state=3,t._value=e,void l(t);if("function"==typeof n)return void f(r(n,e),t)}t._state=1,t._value=e,l(t)}catch(e){c(t,e)}}function c(t,e){t._state=2,t._value=e,l(t)}function l(t){2===t._state&&0===t._deferreds.length&&i._immediateFn(function(){t._handled||i._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}function f(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,c(e,t))})}catch(t){if(n)return;n=!0,c(e,t)}}var d=setTimeout;i.prototype.catch=function(t){return this.then(null,t)},i.prototype.then=function(t,e){var n=new this.constructor(o);return a(this,new u(t,e,n)),n},i.all=function(t){var e=Array.prototype.slice.call(t);return new i(function(t,n){function o(i,a){try{if(a&&("object"==typeof a||"function"==typeof a)){var s=a.then;if("function"==typeof s)return void s.call(a,function(t){o(i,t)},n)}e[i]=a,0==--r&&t(e)}catch(t){n(t)}}if(0===e.length)return t([]);for(var r=e.length,i=0;i<e.length;i++)o(i,e[i])})},i.resolve=function(t){return t&&"object"==typeof t&&t.constructor===i?t:new i(function(e){e(t)})},i.reject=function(t){return new i(function(e,n){n(t)})},i.race=function(t){return new i(function(e,n){for(var o=0,r=t.length;o<r;o++)t[o].then(e,n)})},i._immediateFn="function"==typeof e&&function(t){e(t)}||function(t){d(t,0)},i._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},i._setImmediateFn=function(t){i._immediateFn=t},i._setUnhandledRejectionFn=function(t){i._unhandledRejectionFn=t},void 0!==t&&t.exports?t.exports=i:n.Promise||(n.Promise=i)}(this)}).call(e,n(18).setImmediate)},function(t,e,n){function o(t,e){this._id=t,this._clearFn=e}var r=Function.prototype.apply;e.setTimeout=function(){return new o(r.call(setTimeout,window,arguments),clearTimeout)},e.setInterval=function(){return new o(r.call(setInterval,window,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(window,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(19),e.setImmediate=setImmediate,e.clearImmediate=clearImmediate},function(t,e,n){(function(t,e){!function(t,n){"use strict";function o(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var o={callback:t,args:e};return l[c]=o,s(c),c++}function r(t){delete l[t]}function i(t){var e=t.callback,o=t.args;switch(o.length){case 0:e();break;case 1:e(o[0]);break;case 2:e(o[0],o[1]);break;case 3:e(o[0],o[1],o[2]);break;default:e.apply(n,o)}}function a(t){if(u)setTimeout(a,0,t);else{var e=l[t];if(e){u=!0;try{i(e)}finally{r(t),u=!1}}}}if(!t.setImmediate){var s,c=1,l={},u=!1,f=t.document,d=Object.getPrototypeOf&&Object.getPrototypeOf(t);d=d&&d.setTimeout?d:t,"[object process]"==={}.toString.call(t.process)?function(){s=function(t){e.nextTick(function(){a(t)})}}():function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?function(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&a(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),s=function(n){t.postMessage(e+n,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){a(t.data)},s=function(e){t.port2.postMessage(e)}}():f&&"onreadystatechange"in f.createElement("script")?function(){var t=f.documentElement;s=function(e){var n=f.createElement("script");n.onreadystatechange=function(){a(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():function(){s=function(t){setTimeout(a,0,t)}}(),d.setImmediate=o,d.clearImmediate=r}}("undefined"==typeof self?void 0===t?this:t:self)}).call(e,n(7),n(20))},function(t,e){function n(){throw new Error("setTimeout has not been defined")}function o(){throw new Error("clearTimeout has not been defined")}function r(t){if(u===setTimeout)return setTimeout(t,0);if((u===n||!u)&&setTimeout)return u=setTimeout,setTimeout(t,0);try{return u(t,0)}catch(e){try{return u.call(null,t,0)}catch(e){return u.call(this,t,0)}}}function i(t){if(f===clearTimeout)return clearTimeout(t);if((f===o||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(t);try{return f(t)}catch(e){try{return f.call(null,t)}catch(e){return f.call(this,t)}}}function a(){b&&p&&(b=!1,p.length?m=p.concat(m):v=-1,m.length&&s())}function s(){if(!b){var t=r(a);b=!0;for(var e=m.length;e;){for(p=m,m=[];++v<e;)p&&p[v].run();v=-1,e=m.length}p=null,b=!1,i(t)}}function c(t,e){this.fun=t,this.array=e}function l(){}var u,f,d=t.exports={};!function(){try{u="function"==typeof setTimeout?setTimeout:n}catch(t){u=n}try{f="function"==typeof clearTimeout?clearTimeout:o}catch(t){f=o}}();var p,m=[],b=!1,v=-1;d.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];m.push(new c(t,e)),1!==m.length||b||r(s)},c.prototype.run=function(){this.fun.apply(null,this.array)},d.title="browser",d.browser=!0,d.env={},d.argv=[],d.version="",d.versions={},d.on=l,d.addListener=l,d.once=l,d.off=l,d.removeListener=l,d.removeAllListeners=l,d.emit=l,d.prependListener=l,d.prependOnceListener=l,d.listeners=function(t){return[]},d.binding=function(t){throw new Error("process.binding is not supported")},d.cwd=function(){return"/"},d.chdir=function(t){throw new Error("process.chdir is not supported")},d.umask=function(){return 0}},function(t,e,n){"use strict";n(22).polyfill()},function(t,e,n){"use strict";function o(t,e){if(void 0===t||null===t)throw new TypeError("Cannot convert first argument to object");for(var n=Object(t),o=1;o<arguments.length;o++){var r=arguments[o];if(void 0!==r&&null!==r)for(var i=Object.keys(Object(r)),a=0,s=i.length;a<s;a++){var c=i[a],l=Object.getOwnPropertyDescriptor(r,c);void 0!==l&&l.enumerable&&(n[c]=r[c])}}return n}function r(){Object.assign||Object.defineProperty(Object,"assign",{enumerable:!1,configurable:!0,writable:!0,value:o})}t.exports={assign:o,polyfill:r}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(24),r=n(6),i=n(5),a=n(36),s=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];if("undefined"!=typeof window){var n=a.getOpts.apply(void 0,t);return new Promise(function(t,e){i.default.promise={resolve:t,reject:e},o.default(n),setTimeout(function(){r.openModal()})})}};s.close=r.onAction,s.getState=r.getState,s.setActionValue=i.setActionValue,s.stopLoading=r.stopLoading,s.setDefaults=a.setDefaults,e.default=s},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(0),i=r.default.MODAL,a=n(4),s=n(34),c=n(35),l=n(1);e.init=function(t){o.getNode(i)||(document.body||l.throwErr("You can only use SweetAlert AFTER the DOM has loaded!"),s.default(),a.default()),a.initModalContent(t),c.default(t)},e.default=e.init},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.MODAL;e.modalMarkup='\n  <div class="'+r+'" role="dialog" aria-modal="true"></div>',e.default=e.modalMarkup},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.OVERLAY,i='<div \n    class="'+r+'"\n    tabIndex="-1">\n  </div>';e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.ICON;e.errorIconMarkup=function(){var t=r+"--error",e=t+"__line";return'\n    <div class="'+t+'__x-mark">\n      <span class="'+e+" "+e+'--left"></span>\n      <span class="'+e+" "+e+'--right"></span>\n    </div>\n  '},e.warningIconMarkup=function(){var t=r+"--warning";return'\n    <span class="'+t+'__body">\n      <span class="'+t+'__dot"></span>\n    </span>\n  '},e.successIconMarkup=function(){var t=r+"--success";return'\n    <span class="'+t+"__line "+t+'__line--long"></span>\n    <span class="'+t+"__line "+t+'__line--tip"></span>\n\n    <div class="'+t+'__ring"></div>\n    <div class="'+t+'__hide-corners"></div>\n  '}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.CONTENT;e.contentMarkup='\n  <div class="'+r+'">\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(0),r=o.default.BUTTON_CONTAINER,i=o.default.BUTTON,a=o.default.BUTTON_LOADER;e.buttonMarkup='\n  <div class="'+r+'">\n\n    <button\n      class="'+i+'"\n    ></button>\n\n    <div class="'+a+'">\n      <div></div>\n      <div></div>\n      <div></div>\n    </div>\n\n  </div>\n'},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(4),r=n(2),i=n(0),a=i.default.ICON,s=i.default.ICON_CUSTOM,c=["error","warning","success","info"],l={error:r.errorIconMarkup(),warning:r.warningIconMarkup(),success:r.successIconMarkup()},u=function(t,e){var n=a+"--"+t;e.classList.add(n);var o=l[t];o&&(e.innerHTML=o)},f=function(t,e){e.classList.add(s);var n=document.createElement("img");n.src=t,e.appendChild(n)},d=function(t){if(t){var e=o.injectElIntoModal(r.iconMarkup);c.includes(t)?u(t,e):f(t,e)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(2),r=n(4),i=function(t){navigator.userAgent.includes("AppleWebKit")&&(t.style.display="none",t.offsetHeight,t.style.display="")};e.initTitle=function(t){if(t){var e=r.injectElIntoModal(o.titleMarkup);e.textContent=t,i(e)}},e.initText=function(t){if(t){var e=document.createDocumentFragment();t.split("\n").forEach(function(t,n,o){e.appendChild(document.createTextNode(t)),n<o.length-1&&e.appendChild(document.createElement("br"))});var n=r.injectElIntoModal(o.textMarkup);n.appendChild(e),i(n)}}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(4),i=n(0),a=i.default.BUTTON,s=i.default.DANGER_BUTTON,c=n(3),l=n(2),u=n(6),f=n(5),d=function(t,e,n){var r=e.text,i=e.value,d=e.className,p=e.closeModal,m=o.stringToNode(l.buttonMarkup),b=m.querySelector("."+a),v=a+"--"+t;if(b.classList.add(v),d){(Array.isArray(d)?d:d.split(" ")).filter(function(t){return t.length>0}).forEach(function(t){b.classList.add(t)})}n&&t===c.CONFIRM_KEY&&b.classList.add(s),b.textContent=r;var g={};return g[t]=i,f.setActionValue(g),f.setActionOptionsFor(t,{closeModal:p}),b.addEventListener("click",function(){return u.onAction(t)}),m},p=function(t,e){var n=r.injectElIntoModal(l.footerMarkup);for(var o in t){var i=t[o],a=d(o,i,e);i.visible&&n.appendChild(a)}0===n.children.length&&n.remove()};e.default=p},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(3),r=n(4),i=n(2),a=n(5),s=n(6),c=n(0),l=c.default.CONTENT,u=function(t){t.addEventListener("input",function(t){var e=t.target,n=e.value;a.setActionValue(n)}),t.addEventListener("keyup",function(t){if("Enter"===t.key)return s.onAction(o.CONFIRM_KEY)}),setTimeout(function(){t.focus(),a.setActionValue("")},0)},f=function(t,e,n){var o=document.createElement(e),r=l+"__"+e;o.classList.add(r);for(var i in n){var a=n[i];o[i]=a}"input"===e&&u(o),t.appendChild(o)},d=function(t){if(t){var e=r.injectElIntoModal(i.contentMarkup),n=t.element,o=t.attributes;"string"==typeof n?f(e,n,o):e.appendChild(n)}};e.default=d},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(2),i=function(){var t=o.stringToNode(r.overlayMarkup);document.body.appendChild(t)};e.default=i},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(5),r=n(6),i=n(1),a=n(3),s=n(0),c=s.default.MODAL,l=s.default.BUTTON,u=s.default.OVERLAY,f=function(t){t.preventDefault(),v()},d=function(t){t.preventDefault(),g()},p=function(t){if(o.default.isOpen)switch(t.key){case"Escape":return r.onAction(a.CANCEL_KEY)}},m=function(t){if(o.default.isOpen)switch(t.key){case"Tab":return f(t)}},b=function(t){if(o.default.isOpen)return"Tab"===t.key&&t.shiftKey?d(t):void 0},v=function(){var t=i.getNode(l);t&&(t.tabIndex=0,t.focus())},g=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l),n=e.length-1,o=e[n];o&&o.focus()},h=function(t){t[t.length-1].addEventListener("keydown",m)},w=function(t){t[0].addEventListener("keydown",b)},y=function(){var t=i.getNode(c),e=t.querySelectorAll("."+l);e.length&&(h(e),w(e))},x=function(t){if(i.getNode(u)===t.target)return r.onAction(a.CANCEL_KEY)},_=function(t){var e=i.getNode(u);e.removeEventListener("click",x),t&&e.addEventListener("click",x)},k=function(t){o.default.timer&&clearTimeout(o.default.timer),t&&(o.default.timer=window.setTimeout(function(){return r.onAction(a.CANCEL_KEY)},t))},O=function(t){t.closeOnEsc?document.addEventListener("keyup",p):document.removeEventListener("keyup",p),t.dangerMode?v():g(),y(),_(t.closeOnClickOutside),k(t.timer)};e.default=O},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r=n(3),i=n(37),a=n(38),s={title:null,text:null,icon:null,buttons:r.defaultButtonList,content:null,className:null,closeOnClickOutside:!0,closeOnEsc:!0,dangerMode:!1,timer:null},c=Object.assign({},s);e.setDefaults=function(t){c=Object.assign({},s,t)};var l=function(t){var e=t&&t.button,n=t&&t.buttons;return void 0!==e&&void 0!==n&&o.throwErr("Cannot set both 'button' and 'buttons' options!"),void 0!==e?{confirm:e}:n},u=function(t){return o.ordinalSuffixOf(t+1)},f=function(t,e){o.throwErr(u(e)+" argument ('"+t+"') is invalid")},d=function(t,e){var n=t+1,r=e[n];o.isPlainObject(r)||void 0===r||o.throwErr("Expected "+u(n)+" argument ('"+r+"') to be a plain object")},p=function(t,e){var n=t+1,r=e[n];void 0!==r&&o.throwErr("Unexpected "+u(n)+" argument ("+r+")")},m=function(t,e,n,r){var i=typeof e,a="string"===i,s=e instanceof Element;if(a){if(0===n)return{text:e};if(1===n)return{text:e,title:r[0]};if(2===n)return d(n,r),{icon:e};f(e,n)}else{if(s&&0===n)return d(n,r),{content:e};if(o.isPlainObject(e))return p(n,r),e;f(e,n)}};e.getOpts=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];var n={};t.forEach(function(e,o){var r=m(0,e,o,t);Object.assign(n,r)});var o=l(n);n.buttons=r.getButtonListOpts(o),delete n.button,n.content=i.getContentOpts(n.content);var u=Object.assign({},s,c,n);return Object.keys(u).forEach(function(t){a.DEPRECATED_OPTS[t]&&a.logDeprecation(t)}),u}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var o=n(1),r={element:"input",attributes:{placeholder:""}};e.getContentOpts=function(t){var e={};return o.isPlainObject(t)?Object.assign(e,t):t instanceof Element?{element:t}:"input"===t?r:null}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.logDeprecation=function(t){var n=e.DEPRECATED_OPTS[t],o=n.onlyRename,r=n.replacement,i=n.subOption,a=n.link,s=o?"renamed":"deprecated",c='SweetAlert warning: "'+t+'" option has been '+s+".";if(r){c+=" Please use"+(i?' "'+i+'" in ':" ")+'"'+r+'" instead.'}var l="https://sweetalert.js.org";c+=a?" More details: "+l+a:" More details: "+l+"/guides/#upgrading-from-1x",console.warn(c)},e.DEPRECATED_OPTS={type:{replacement:"icon",link:"/docs/#icon"},imageUrl:{replacement:"icon",link:"/docs/#icon"},customClass:{replacement:"className",onlyRename:!0,link:"/docs/#classname"},imageSize:{},showCancelButton:{replacement:"buttons",link:"/docs/#buttons"},showConfirmButton:{replacement:"button",link:"/docs/#button"},confirmButtonText:{replacement:"button",link:"/docs/#button"},confirmButtonColor:{},cancelButtonText:{replacement:"buttons",link:"/docs/#buttons"},closeOnConfirm:{replacement:"button",subOption:"closeModal",link:"/docs/#button"},closeOnCancel:{replacement:"buttons",subOption:"closeModal",link:"/docs/#buttons"},showLoaderOnConfirm:{replacement:"buttons"},animation:{},inputType:{replacement:"content",link:"/docs/#content"},inputValue:{replacement:"content",link:"/docs/#content"},inputPlaceholder:{replacement:"content",link:"/docs/#content"},html:{replacement:"content",link:"/docs/#content"},allowEscapeKey:{replacement:"closeOnEsc",onlyRename:!0,link:"/docs/#closeonesc"},allowClickOutside:{replacement:"closeOnClickOutside",onlyRename:!0,link:"/docs/#closeonclickoutside"}}}])});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("162o").setImmediate, __webpack_require__("162o").clearImmediate))

/***/ }),

/***/ "tn1D":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("FKWp");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "tpuU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),

/***/ "tqR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (column, start, end) {
  var dateFormat = this.dateFormat(column);
  var el = typeof column === 'string' ? $(this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter") : column;
  el.text(start.format(dateFormat) + " - " + end.format(dateFormat));
};

/***/ }),

/***/ "txMS":
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__("c5AH")('Map');


/***/ }),

/***/ "txgm":
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(2);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),

/***/ "tz60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("0Lvz")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("4dmN")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "u2KI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("O2XB"), __esModule: true };

/***/ }),

/***/ "uDof":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;
  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__("iP15")
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__("qOYl");
/*</replacement>*/

var Buffer = __webpack_require__("EuP9").Buffer;
var OurUint8Array = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
var destroyImpl = __webpack_require__("0IYo");
var _require = __webpack_require__("iqpV"),
  getHighWaterMark = _require.getHighWaterMark;
var _require$codes = __webpack_require__("3U89").codes,
  ERR_INVALID_ARG_TYPE = _require$codes.ERR_INVALID_ARG_TYPE,
  ERR_METHOD_NOT_IMPLEMENTED = _require$codes.ERR_METHOD_NOT_IMPLEMENTED,
  ERR_MULTIPLE_CALLBACK = _require$codes.ERR_MULTIPLE_CALLBACK,
  ERR_STREAM_CANNOT_PIPE = _require$codes.ERR_STREAM_CANNOT_PIPE,
  ERR_STREAM_DESTROYED = _require$codes.ERR_STREAM_DESTROYED,
  ERR_STREAM_NULL_VALUES = _require$codes.ERR_STREAM_NULL_VALUES,
  ERR_STREAM_WRITE_AFTER_END = _require$codes.ERR_STREAM_WRITE_AFTER_END,
  ERR_UNKNOWN_ENCODING = _require$codes.ERR_UNKNOWN_ENCODING;
var errorOrDestroy = destroyImpl.errorOrDestroy;
__webpack_require__("LC74")(Writable, Stream);
function nop() {}
function WritableState(options, stream, isDuplex) {
  Duplex = Duplex || __webpack_require__("PhfM");
  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream,
  // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
  if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;
  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  this.highWaterMark = getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;
  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // Should close be emitted on destroy. Defaults to true.
  this.emitClose = options.emitClose !== false;

  // Should .destroy() be called after 'finish' (and potentially 'end')
  this.autoDestroy = !!options.autoDestroy;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}
WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};
(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function writableStateBufferGetter() {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function value(object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;
      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function realHasInstance(object) {
    return object instanceof this;
  };
}
function Writable(options) {
  Duplex = Duplex || __webpack_require__("PhfM");

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.

  // Checking for a Stream.Duplex instance is faster here instead of inside
  // the WritableState constructor, at least with V8 6.5
  var isDuplex = this instanceof Duplex;
  if (!isDuplex && !realHasInstance.call(Writable, this)) return new Writable(options);
  this._writableState = new WritableState(options, this, isDuplex);

  // legacy.
  this.writable = true;
  if (options) {
    if (typeof options.write === 'function') this._write = options.write;
    if (typeof options.writev === 'function') this._writev = options.writev;
    if (typeof options.destroy === 'function') this._destroy = options.destroy;
    if (typeof options.final === 'function') this._final = options.final;
  }
  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  errorOrDestroy(this, new ERR_STREAM_CANNOT_PIPE());
};
function writeAfterEnd(stream, cb) {
  var er = new ERR_STREAM_WRITE_AFTER_END();
  // TODO: defer error events consistently everywhere, not just the cb
  errorOrDestroy(stream, er);
  process.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var er;
  if (chunk === null) {
    er = new ERR_STREAM_NULL_VALUES();
  } else if (typeof chunk !== 'string' && !state.objectMode) {
    er = new ERR_INVALID_ARG_TYPE('chunk', ['string', 'Buffer'], chunk);
  }
  if (er) {
    errorOrDestroy(stream, er);
    process.nextTick(cb, er);
    return false;
  }
  return true;
}
Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);
  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }
  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
  if (typeof cb !== 'function') cb = nop;
  if (state.ending) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }
  return ret;
};
Writable.prototype.cork = function () {
  this._writableState.corked++;
};
Writable.prototype.uncork = function () {
  var state = this._writableState;
  if (state.corked) {
    state.corked--;
    if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};
Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new ERR_UNKNOWN_ENCODING(encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};
Object.defineProperty(Writable.prototype, 'writableBuffer', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState && this._writableState.getBuffer();
  }
});
function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}
Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;
  state.length += len;
  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;
  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }
  return ret;
}
function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (state.destroyed) state.onwrite(new ERR_STREAM_DESTROYED('write'));else if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}
function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    process.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    process.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    errorOrDestroy(stream, er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}
function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}
function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;
  if (typeof cb !== 'function') throw new ERR_MULTIPLE_CALLBACK();
  onwriteStateUpdate(state);
  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state) || stream.destroyed;
    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }
    if (sync) {
      process.nextTick(afterWrite, stream, state, finished, cb);
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}
function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;
  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;
    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;
    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;
      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }
    if (entry === null) state.lastBufferedRequest = null;
  }
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}
Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
Writable.prototype._writev = null;
Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;
  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }
  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending) endWritable(this, state, cb);
  return this;
};
Object.defineProperty(Writable.prototype, 'writableLength', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    return this._writableState.length;
  }
});
function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      errorOrDestroy(stream, err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function' && !state.destroyed) {
      state.pendingcb++;
      state.finalCalled = true;
      process.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}
function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
      if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well
        var rState = stream._readableState;
        if (!rState || rState.autoDestroy && rState.endEmitted) {
          stream.destroy();
        }
      }
    }
  }
  return need;
}
function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) process.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}
function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }

  // reuse the free corkReq.
  state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty(Writable.prototype, 'destroyed', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function get() {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function set(value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});
Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "uKUB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bus = _interopRequireDefault(__webpack_require__("jlkA"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function () {
  var _this = this;

  var event = 'vue-tables';
  if (this.name) event += '.' + this.name;
  this.opts.customFilters.forEach(function (filter) {
    _bus["default"].$off("".concat(event, ".filter::").concat(filter.name));

    _bus["default"].$on("".concat(event, ".filter::").concat(filter.name), function (value) {
      _this.customQueries[filter.name] = value;

      _this.updateState('customQueries', _this.customQueries);
    });
  });
};

/***/ }),

/***/ "uQcH":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("qs+f");
var getKeys = __webpack_require__("pEGt");
var toIObject = __webpack_require__("ksFB");
var isEnum = __webpack_require__("bSeU").f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),

/***/ "uUKu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function () {
  if (_typeof(this.query) !== 'object' || this.opts.sendEmptyFilters) {
    return this.query;
  }

  var result = {};

  for (var key in this.query) {
    if (this.query[key] !== '' && this.filterable(key)) {
      result[key] = this.query[key];
    }
  }

  return result;
};

/***/ }),

/***/ "uUUu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    computed: {
      Columns: function Columns() {
        return this.columns;
      }
    }
  };
}

/***/ }),

/***/ "uX6Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var defaults = __webpack_require__("8p3e")();

  return this.initOptions(defaults, this.globalOptions, this.options);
};

/***/ }),

/***/ "ufPk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.hasChildRow ? this.allColumns.length + 1 : this.allColumns.length;
};

/***/ }),

/***/ "ujcs":
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "unUJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  initQuery: __webpack_require__("Fla3"),
  resetQuery: __webpack_require__("i8M6"),
  initCustomFilters: __webpack_require__("V19p"),
  initOptions: __webpack_require__("94zm"),
  sortableClass: __webpack_require__("GX0J"),
  sortableChevronClass: __webpack_require__("cmXL"),
  display: __webpack_require__("RWUN"),
  orderByColumn: __webpack_require__("kAit"),
  getHeading: __webpack_require__("HWUO"),
  getHeadingTooltip: __webpack_require__("OFd3"),
  sortable: __webpack_require__("/PoJ"),
  serverSearch: __webpack_require__("2OQD"),
  initOrderBy: __webpack_require__("MCxa"),
  initDateFilters: __webpack_require__("zOyH"),
  setFilter: __webpack_require__("F9i8"),
  setPage: __webpack_require__("wxv5"),
  setOrder: __webpack_require__("TYuA"),
  initPagination: __webpack_require__("DEJF"),
  filterable: __webpack_require__("ahRw"),
  isTextFilter: __webpack_require__("0BLp"),
  isDateFilter: __webpack_require__("7LGX"),
  isListFilter: __webpack_require__("Pwwa"),
  highlightMatch: __webpack_require__("pkEt"),
  formatDate: __webpack_require__("XpKz"),
  hasDateFilters: __webpack_require__("D0f9"),
  applyFilters: __webpack_require__("yFbY"),
  optionText: __webpack_require__("6TSN"),
  render: __webpack_require__("sycf"),
  rowWasClicked: __webpack_require__("L/6W"),
  setLimit: __webpack_require__("UZwE"),
  getOpenChildRows: __webpack_require__("Yy+Q"),
  dispatch: __webpack_require__("4mbZ"),
  toggleChildRow: __webpack_require__("NUKO"),
  childRowTogglerClass: __webpack_require__("Gwf5"),
  sendRequest: __webpack_require__("SQ9R"),
  getResponseData: __webpack_require__("PJba"),
  getSortFn: __webpack_require__("PrYL"),
  initState: __webpack_require__("BwU2"),
  updateState: __webpack_require__("C301"),
  columnClass: __webpack_require__("3nlR"),
  getName: __webpack_require__("/jav"),
  toggleColumn: __webpack_require__("s4AF"),
  setUserMultiSort: __webpack_require__("igji"),
  _cellClasses: __webpack_require__("lm4Y"),
  _setFiltersDOM: __webpack_require__("p642"),
  _currentlySorted: __webpack_require__("bfKe"),
  _getChildRowTemplate: __webpack_require__("s6FM"),
  _toggleColumnsDropdown: __webpack_require__("P3z2"),
  _onlyColumn: __webpack_require__("bu1O"),
  _onPagination: __webpack_require__("aL0I"),
  _toggleGroupDirection: __webpack_require__("Er1F"),
  _getInitialDateRange: __webpack_require__("do0D"),
  _setDatepickerText: __webpack_require__("tqR9"),
  _initialOrderAscending: __webpack_require__("bgbN"),
  dateFormat: __webpack_require__("/j9d"),
  _setColumnsDropdownCloseListener: __webpack_require__("wVHq"),
  _getValue: __webpack_require__("VtkY"),
  _getColumnName: __webpack_require__("jerF"),
  _shouldShowColumnOnInit: __webpack_require__("bhre")
};

/***/ }),

/***/ "us/S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("l3mU"), __esModule: true };

/***/ }),

/***/ "vWnj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  return this.opts.childRow || this.$scopedSlots.child_row;
};

/***/ }),

/***/ "vWx2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__("LC74");
var Buffer = __webpack_require__("Hwfm").Buffer;

var DERDecoder = __webpack_require__("reGU");

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
}
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null) continue;

    if (match[2] !== label) continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN') break;
      start = i;
    } else {
      if (match[1] !== 'END') break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9+/=]+/gi, '');

  var input = Buffer.from(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};

/***/ }),

/***/ "vlDJ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, process, setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 Copyright (c) 2012 Nevins Bartolomeo <nevins.bartolomeo@gmail.com>
 Copyright (c) 2012 Shane Girish <shaneGirish@gmail.com>
 Copyright (c) 2014 Daniel Wirtz <dcode@dcode.io>

 Redistribution and use in source and binary forms, with or without
 modification, are permitted provided that the following conditions
 are met:
 1. Redistributions of source code must retain the above copyright
 notice, this list of conditions and the following disclaimer.
 2. Redistributions in binary form must reproduce the above copyright
 notice, this list of conditions and the following disclaimer in the
 documentation and/or other materials provided with the distribution.
 3. The name of the author may not be used to endorse or promote products
 derived from this software without specific prior written permission.

 THIS SOFTWARE IS PROVIDED BY THE AUTHOR ``AS IS'' AND ANY EXPRESS OR
 IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES
 OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY DIRECT, INDIRECT,
 INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @license bcrypt.js (c) 2013 Daniel Wirtz <dcode@dcode.io>
 * Released under the Apache License, Version 2.0
 * see: https://github.com/dcodeIO/bcrypt.js for details
 */
(function(global, factory) {

    /* AMD */ if (true)
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    /* CommonJS */ else if (typeof require === 'function' && typeof module === "object" && module && module["exports"])
        module["exports"] = factory();
    /* Global */ else
        (global["dcodeIO"] = global["dcodeIO"] || {})["bcrypt"] = factory();

}(this, function() {
    "use strict";

    /**
     * bcrypt namespace.
     * @type {Object.<string,*>}
     */
    var bcrypt = {};

    /**
     * The random implementation to use as a fallback.
     * @type {?function(number):!Array.<number>}
     * @inner
     */
    var randomFallback = null;

    /**
     * Generates cryptographically secure random bytes.
     * @function
     * @param {number} len Bytes length
     * @returns {!Array.<number>} Random bytes
     * @throws {Error} If no random implementation is available
     * @inner
     */
    function random(len) {
        /* node */ if (typeof module !== 'undefined' && module && module['exports'])
            try {
                return __webpack_require__("VI/i")['randomBytes'](len);
            } catch (e) {}
        /* WCA */ try {
            var a; (self['crypto']||self['msCrypto'])['getRandomValues'](a = new Uint32Array(len));
            return Array.prototype.slice.call(a);
        } catch (e) {}
        /* fallback */ if (!randomFallback)
            throw Error("Neither WebCryptoAPI nor a crypto module is available. Use bcrypt.setRandomFallback to set an alternative");
        return randomFallback(len);
    }

    // Test if any secure randomness source is available
    var randomAvailable = false;
    try {
        random(1);
        randomAvailable = true;
    } catch (e) {}

    // Default fallback, if any
    randomFallback = null;
    /**
     * Sets the pseudo random number generator to use as a fallback if neither node's `crypto` module nor the Web Crypto
     *  API is available. Please note: It is highly important that the PRNG used is cryptographically secure and that it
     *  is seeded properly!
     * @param {?function(number):!Array.<number>} random Function taking the number of bytes to generate as its
     *  sole argument, returning the corresponding array of cryptographically secure random byte values.
     * @see http://nodejs.org/api/crypto.html
     * @see http://www.w3.org/TR/WebCryptoAPI/
     */
    bcrypt.setRandomFallback = function(random) {
        randomFallback = random;
    };

    /**
     * Synchronously generates a salt.
     * @param {number=} rounds Number of rounds to use, defaults to 10 if omitted
     * @param {number=} seed_length Not supported.
     * @returns {string} Resulting salt
     * @throws {Error} If a random fallback is required but not set
     * @expose
     */
    bcrypt.genSaltSync = function(rounds, seed_length) {
        rounds = rounds || GENSALT_DEFAULT_LOG2_ROUNDS;
        if (typeof rounds !== 'number')
            throw Error("Illegal arguments: "+(typeof rounds)+", "+(typeof seed_length));
        if (rounds < 4)
            rounds = 4;
        else if (rounds > 31)
            rounds = 31;
        var salt = [];
        salt.push("$2a$");
        if (rounds < 10)
            salt.push("0");
        salt.push(rounds.toString());
        salt.push('$');
        salt.push(base64_encode(random(BCRYPT_SALT_LEN), BCRYPT_SALT_LEN)); // May throw
        return salt.join('');
    };

    /**
     * Asynchronously generates a salt.
     * @param {(number|function(Error, string=))=} rounds Number of rounds to use, defaults to 10 if omitted
     * @param {(number|function(Error, string=))=} seed_length Not supported.
     * @param {function(Error, string=)=} callback Callback receiving the error, if any, and the resulting salt
     * @returns {!Promise} If `callback` has been omitted
     * @throws {Error} If `callback` is present but not a function
     * @expose
     */
    bcrypt.genSalt = function(rounds, seed_length, callback) {
        if (typeof seed_length === 'function')
            callback = seed_length,
            seed_length = undefined; // Not supported.
        if (typeof rounds === 'function')
            callback = rounds,
            rounds = undefined;
        if (typeof rounds === 'undefined')
            rounds = GENSALT_DEFAULT_LOG2_ROUNDS;
        else if (typeof rounds !== 'number')
            throw Error("illegal arguments: "+(typeof rounds));

        function _async(callback) {
            nextTick(function() { // Pretty thin, but salting is fast enough
                try {
                    callback(null, bcrypt.genSaltSync(rounds));
                } catch (err) {
                    callback(err);
                }
            });
        }

        if (callback) {
            if (typeof callback !== 'function')
                throw Error("Illegal callback: "+typeof(callback));
            _async(callback);
        } else
            return new Promise(function(resolve, reject) {
                _async(function(err, res) {
                    if (err) {
                        reject(err);
                        return;
                    }
                    resolve(res);
                });
            });
    };

    /**
     * Synchronously generates a hash for the given string.
     * @param {string} s String to hash
     * @param {(number|string)=} salt Salt length to generate or salt to use, default to 10
     * @returns {string} Resulting hash
     * @expose
     */
    bcrypt.hashSync = function(s, salt) {
        if (typeof salt === 'undefined')
            salt = GENSALT_DEFAULT_LOG2_ROUNDS;
        if (typeof salt === 'number')
            salt = bcrypt.genSaltSync(salt);
        if (typeof s !== 'string' || typeof salt !== 'string')
            throw Error("Illegal arguments: "+(typeof s)+', '+(typeof salt));
        return _hash(s, salt);
    };

    /**
     * Asynchronously generates a hash for the given string.
     * @param {string} s String to hash
     * @param {number|string} salt Salt length to generate or salt to use
     * @param {function(Error, string=)=} callback Callback receiving the error, if any, and the resulting hash
     * @param {function(number)=} progressCallback Callback successively called with the percentage of rounds completed
     *  (0.0 - 1.0), maximally once per `MAX_EXECUTION_TIME = 100` ms.
     * @returns {!Promise} If `callback` has been omitted
     * @throws {Error} If `callback` is present but not a function
     * @expose
     */
    bcrypt.hash = function(s, salt, callback, progressCallback) {

        function _async(callback) {
            if (typeof s === 'string' && typeof salt === 'number')
                bcrypt.genSalt(salt, function(err, salt) {
                    _hash(s, salt, callback, progressCallback);
                });
            else if (typeof s === 'string' && typeof salt === 'string')
                _hash(s, salt, callback, progressCallback);
            else
                nextTick(callback.bind(this, Error("Illegal arguments: "+(typeof s)+', '+(typeof salt))));
        }

        if (callback) {
            if (typeof callback !== 'function')
                throw Error("Illegal callback: "+typeof(callback));
            _async(callback);
        } else
            return new Promise(function(resolve, reject) {
                _async(function(err, res) {
                    if (err) {
                        reject(err);
                        return;
                    }
                    resolve(res);
                });
            });
    };

    /**
     * Compares two strings of the same length in constant time.
     * @param {string} known Must be of the correct length
     * @param {string} unknown Must be the same length as `known`
     * @returns {boolean}
     * @inner
     */
    function safeStringCompare(known, unknown) {
        var right = 0,
            wrong = 0;
        for (var i=0, k=known.length; i<k; ++i) {
            if (known.charCodeAt(i) === unknown.charCodeAt(i))
                ++right;
            else
                ++wrong;
        }
        // Prevent removal of unused variables (never true, actually)
        if (right < 0)
            return false;
        return wrong === 0;
    }

    /**
     * Synchronously tests a string against a hash.
     * @param {string} s String to compare
     * @param {string} hash Hash to test against
     * @returns {boolean} true if matching, otherwise false
     * @throws {Error} If an argument is illegal
     * @expose
     */
    bcrypt.compareSync = function(s, hash) {
        if (typeof s !== "string" || typeof hash !== "string")
            throw Error("Illegal arguments: "+(typeof s)+', '+(typeof hash));
        if (hash.length !== 60)
            return false;
        return safeStringCompare(bcrypt.hashSync(s, hash.substr(0, hash.length-31)), hash);
    };

    /**
     * Asynchronously compares the given data against the given hash.
     * @param {string} s Data to compare
     * @param {string} hash Data to be compared to
     * @param {function(Error, boolean)=} callback Callback receiving the error, if any, otherwise the result
     * @param {function(number)=} progressCallback Callback successively called with the percentage of rounds completed
     *  (0.0 - 1.0), maximally once per `MAX_EXECUTION_TIME = 100` ms.
     * @returns {!Promise} If `callback` has been omitted
     * @throws {Error} If `callback` is present but not a function
     * @expose
     */
    bcrypt.compare = function(s, hash, callback, progressCallback) {

        function _async(callback) {
            if (typeof s !== "string" || typeof hash !== "string") {
                nextTick(callback.bind(this, Error("Illegal arguments: "+(typeof s)+', '+(typeof hash))));
                return;
            }
            if (hash.length !== 60) {
                nextTick(callback.bind(this, null, false));
                return;
            }
            bcrypt.hash(s, hash.substr(0, 29), function(err, comp) {
                if (err)
                    callback(err);
                else
                    callback(null, safeStringCompare(comp, hash));
            }, progressCallback);
        }

        if (callback) {
            if (typeof callback !== 'function')
                throw Error("Illegal callback: "+typeof(callback));
            _async(callback);
        } else
            return new Promise(function(resolve, reject) {
                _async(function(err, res) {
                    if (err) {
                        reject(err);
                        return;
                    }
                    resolve(res);
                });
            });
    };

    /**
     * Gets the number of rounds used to encrypt the specified hash.
     * @param {string} hash Hash to extract the used number of rounds from
     * @returns {number} Number of rounds used
     * @throws {Error} If `hash` is not a string
     * @expose
     */
    bcrypt.getRounds = function(hash) {
        if (typeof hash !== "string")
            throw Error("Illegal arguments: "+(typeof hash));
        return parseInt(hash.split("$")[2], 10);
    };

    /**
     * Gets the salt portion from a hash. Does not validate the hash.
     * @param {string} hash Hash to extract the salt from
     * @returns {string} Extracted salt part
     * @throws {Error} If `hash` is not a string or otherwise invalid
     * @expose
     */
    bcrypt.getSalt = function(hash) {
        if (typeof hash !== 'string')
            throw Error("Illegal arguments: "+(typeof hash));
        if (hash.length !== 60)
            throw Error("Illegal hash length: "+hash.length+" != 60");
        return hash.substring(0, 29);
    };

    /**
     * Continues with the callback on the next tick.
     * @function
     * @param {function(...[*])} callback Callback to execute
     * @inner
     */
    var nextTick = typeof process !== 'undefined' && process && typeof process.nextTick === 'function'
        ? (typeof setImmediate === 'function' ? setImmediate : process.nextTick)
        : setTimeout;

    /**
     * Converts a JavaScript string to UTF8 bytes.
     * @param {string} str String
     * @returns {!Array.<number>} UTF8 bytes
     * @inner
     */
    function stringToBytes(str) {
        var out = [],
            i = 0;
        utfx.encodeUTF16toUTF8(function() {
            if (i >= str.length) return null;
            return str.charCodeAt(i++);
        }, function(b) {
            out.push(b);
        });
        return out;
    }

    // A base64 implementation for the bcrypt algorithm. This is partly non-standard.

    /**
     * bcrypt's own non-standard base64 dictionary.
     * @type {!Array.<string>}
     * @const
     * @inner
     **/
    var BASE64_CODE = "./ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split('');

    /**
     * @type {!Array.<number>}
     * @const
     * @inner
     **/
    var BASE64_INDEX = [-1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
        -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 0,
        1, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, -1, -1, -1, -1, -1, -1,
        -1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23, 24, 25, 26, 27, -1, -1, -1, -1, -1, -1, 28, 29, 30,
        31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47,
        48, 49, 50, 51, 52, 53, -1, -1, -1, -1, -1];

    /**
     * @type {!function(...number):string}
     * @inner
     */
    var stringFromCharCode = String.fromCharCode;

    /**
     * Encodes a byte array to base64 with up to len bytes of input.
     * @param {!Array.<number>} b Byte array
     * @param {number} len Maximum input length
     * @returns {string}
     * @inner
     */
    function base64_encode(b, len) {
        var off = 0,
            rs = [],
            c1, c2;
        if (len <= 0 || len > b.length)
            throw Error("Illegal len: "+len);
        while (off < len) {
            c1 = b[off++] & 0xff;
            rs.push(BASE64_CODE[(c1 >> 2) & 0x3f]);
            c1 = (c1 & 0x03) << 4;
            if (off >= len) {
                rs.push(BASE64_CODE[c1 & 0x3f]);
                break;
            }
            c2 = b[off++] & 0xff;
            c1 |= (c2 >> 4) & 0x0f;
            rs.push(BASE64_CODE[c1 & 0x3f]);
            c1 = (c2 & 0x0f) << 2;
            if (off >= len) {
                rs.push(BASE64_CODE[c1 & 0x3f]);
                break;
            }
            c2 = b[off++] & 0xff;
            c1 |= (c2 >> 6) & 0x03;
            rs.push(BASE64_CODE[c1 & 0x3f]);
            rs.push(BASE64_CODE[c2 & 0x3f]);
        }
        return rs.join('');
    }

    /**
     * Decodes a base64 encoded string to up to len bytes of output.
     * @param {string} s String to decode
     * @param {number} len Maximum output length
     * @returns {!Array.<number>}
     * @inner
     */
    function base64_decode(s, len) {
        var off = 0,
            slen = s.length,
            olen = 0,
            rs = [],
            c1, c2, c3, c4, o, code;
        if (len <= 0)
            throw Error("Illegal len: "+len);
        while (off < slen - 1 && olen < len) {
            code = s.charCodeAt(off++);
            c1 = code < BASE64_INDEX.length ? BASE64_INDEX[code] : -1;
            code = s.charCodeAt(off++);
            c2 = code < BASE64_INDEX.length ? BASE64_INDEX[code] : -1;
            if (c1 == -1 || c2 == -1)
                break;
            o = (c1 << 2) >>> 0;
            o |= (c2 & 0x30) >> 4;
            rs.push(stringFromCharCode(o));
            if (++olen >= len || off >= slen)
                break;
            code = s.charCodeAt(off++);
            c3 = code < BASE64_INDEX.length ? BASE64_INDEX[code] : -1;
            if (c3 == -1)
                break;
            o = ((c2 & 0x0f) << 4) >>> 0;
            o |= (c3 & 0x3c) >> 2;
            rs.push(stringFromCharCode(o));
            if (++olen >= len || off >= slen)
                break;
            code = s.charCodeAt(off++);
            c4 = code < BASE64_INDEX.length ? BASE64_INDEX[code] : -1;
            o = ((c3 & 0x03) << 6) >>> 0;
            o |= c4;
            rs.push(stringFromCharCode(o));
            ++olen;
        }
        var res = [];
        for (off = 0; off<olen; off++)
            res.push(rs[off].charCodeAt(0));
        return res;
    }

    /**
     * utfx-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
     * Released under the Apache License, Version 2.0
     * see: https://github.com/dcodeIO/utfx for details
     */
    var utfx = function() {
        "use strict";

        /**
         * utfx namespace.
         * @inner
         * @type {!Object.<string,*>}
         */
        var utfx = {};

        /**
         * Maximum valid code point.
         * @type {number}
         * @const
         */
        utfx.MAX_CODEPOINT = 0x10FFFF;

        /**
         * Encodes UTF8 code points to UTF8 bytes.
         * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
         *  respectively `null` if there are no more code points left or a single numeric code point.
         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte
         */
        utfx.encodeUTF8 = function(src, dst) {
            var cp = null;
            if (typeof src === 'number')
                cp = src,
                src = function() { return null; };
            while (cp !== null || (cp = src()) !== null) {
                if (cp < 0x80)
                    dst(cp&0x7F);
                else if (cp < 0x800)
                    dst(((cp>>6)&0x1F)|0xC0),
                    dst((cp&0x3F)|0x80);
                else if (cp < 0x10000)
                    dst(((cp>>12)&0x0F)|0xE0),
                    dst(((cp>>6)&0x3F)|0x80),
                    dst((cp&0x3F)|0x80);
                else
                    dst(((cp>>18)&0x07)|0xF0),
                    dst(((cp>>12)&0x3F)|0x80),
                    dst(((cp>>6)&0x3F)|0x80),
                    dst((cp&0x3F)|0x80);
                cp = null;
            }
        };

        /**
         * Decodes UTF8 bytes to UTF8 code points.
         * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
         *  are no more bytes left.
         * @param {!function(number)} dst Code points destination as a function successively called with each decoded code point.
         * @throws {RangeError} If a starting byte is invalid in UTF8
         * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the
         *  remaining bytes.
         */
        utfx.decodeUTF8 = function(src, dst) {
            var a, b, c, d, fail = function(b) {
                b = b.slice(0, b.indexOf(null));
                var err = Error(b.toString());
                err.name = "TruncatedError";
                err['bytes'] = b;
                throw err;
            };
            while ((a = src()) !== null) {
                if ((a&0x80) === 0)
                    dst(a);
                else if ((a&0xE0) === 0xC0)
                    ((b = src()) === null) && fail([a, b]),
                    dst(((a&0x1F)<<6) | (b&0x3F));
                else if ((a&0xF0) === 0xE0)
                    ((b=src()) === null || (c=src()) === null) && fail([a, b, c]),
                    dst(((a&0x0F)<<12) | ((b&0x3F)<<6) | (c&0x3F));
                else if ((a&0xF8) === 0xF0)
                    ((b=src()) === null || (c=src()) === null || (d=src()) === null) && fail([a, b, c ,d]),
                    dst(((a&0x07)<<18) | ((b&0x3F)<<12) | ((c&0x3F)<<6) | (d&0x3F));
                else throw RangeError("Illegal starting byte: "+a);
            }
        };

        /**
         * Converts UTF16 characters to UTF8 code points.
         * @param {!function():number|null} src Characters source as a function returning the next char code respectively
         *  `null` if there are no more characters left.
         * @param {!function(number)} dst Code points destination as a function successively called with each converted code
         *  point.
         */
        utfx.UTF16toUTF8 = function(src, dst) {
            var c1, c2 = null;
            while (true) {
                if ((c1 = c2 !== null ? c2 : src()) === null)
                    break;
                if (c1 >= 0xD800 && c1 <= 0xDFFF) {
                    if ((c2 = src()) !== null) {
                        if (c2 >= 0xDC00 && c2 <= 0xDFFF) {
                            dst((c1-0xD800)*0x400+c2-0xDC00+0x10000);
                            c2 = null; continue;
                        }
                    }
                }
                dst(c1);
            }
            if (c2 !== null) dst(c2);
        };

        /**
         * Converts UTF8 code points to UTF16 characters.
         * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
         *  respectively `null` if there are no more code points left or a single numeric code point.
         * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
         * @throws {RangeError} If a code point is out of range
         */
        utfx.UTF8toUTF16 = function(src, dst) {
            var cp = null;
            if (typeof src === 'number')
                cp = src, src = function() { return null; };
            while (cp !== null || (cp = src()) !== null) {
                if (cp <= 0xFFFF)
                    dst(cp);
                else
                    cp -= 0x10000,
                    dst((cp>>10)+0xD800),
                    dst((cp%0x400)+0xDC00);
                cp = null;
            }
        };

        /**
         * Converts and encodes UTF16 characters to UTF8 bytes.
         * @param {!function():number|null} src Characters source as a function returning the next char code respectively `null`
         *  if there are no more characters left.
         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
         */
        utfx.encodeUTF16toUTF8 = function(src, dst) {
            utfx.UTF16toUTF8(src, function(cp) {
                utfx.encodeUTF8(cp, dst);
            });
        };

        /**
         * Decodes and converts UTF8 bytes to UTF16 characters.
         * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
         *  are no more bytes left.
         * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
         * @throws {RangeError} If a starting byte is invalid in UTF8
         * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the remaining bytes.
         */
        utfx.decodeUTF8toUTF16 = function(src, dst) {
            utfx.decodeUTF8(src, function(cp) {
                utfx.UTF8toUTF16(cp, dst);
            });
        };

        /**
         * Calculates the byte length of an UTF8 code point.
         * @param {number} cp UTF8 code point
         * @returns {number} Byte length
         */
        utfx.calculateCodePoint = function(cp) {
            return (cp < 0x80) ? 1 : (cp < 0x800) ? 2 : (cp < 0x10000) ? 3 : 4;
        };

        /**
         * Calculates the number of UTF8 bytes required to store UTF8 code points.
         * @param {(!function():number|null)} src Code points source as a function returning the next code point respectively
         *  `null` if there are no more code points left.
         * @returns {number} The number of UTF8 bytes required
         */
        utfx.calculateUTF8 = function(src) {
            var cp, l=0;
            while ((cp = src()) !== null)
                l += utfx.calculateCodePoint(cp);
            return l;
        };

        /**
         * Calculates the number of UTF8 code points respectively UTF8 bytes required to store UTF16 char codes.
         * @param {(!function():number|null)} src Characters source as a function returning the next char code respectively
         *  `null` if there are no more characters left.
         * @returns {!Array.<number>} The number of UTF8 code points at index 0 and the number of UTF8 bytes required at index 1.
         */
        utfx.calculateUTF16asUTF8 = function(src) {
            var n=0, l=0;
            utfx.UTF16toUTF8(src, function(cp) {
                ++n; l += utfx.calculateCodePoint(cp);
            });
            return [n,l];
        };

        return utfx;
    }();

    Date.now = Date.now || function() { return +new Date; };

    /**
     * @type {number}
     * @const
     * @inner
     */
    var BCRYPT_SALT_LEN = 16;

    /**
     * @type {number}
     * @const
     * @inner
     */
    var GENSALT_DEFAULT_LOG2_ROUNDS = 10;

    /**
     * @type {number}
     * @const
     * @inner
     */
    var BLOWFISH_NUM_ROUNDS = 16;

    /**
     * @type {number}
     * @const
     * @inner
     */
    var MAX_EXECUTION_TIME = 100;

    /**
     * @type {Array.<number>}
     * @const
     * @inner
     */
    var P_ORIG = [
        0x243f6a88, 0x85a308d3, 0x13198a2e, 0x03707344, 0xa4093822,
        0x299f31d0, 0x082efa98, 0xec4e6c89, 0x452821e6, 0x38d01377,
        0xbe5466cf, 0x34e90c6c, 0xc0ac29b7, 0xc97c50dd, 0x3f84d5b5,
        0xb5470917, 0x9216d5d9, 0x8979fb1b
    ];

    /**
     * @type {Array.<number>}
     * @const
     * @inner
     */
    var S_ORIG = [
        0xd1310ba6, 0x98dfb5ac, 0x2ffd72db, 0xd01adfb7, 0xb8e1afed,
        0x6a267e96, 0xba7c9045, 0xf12c7f99, 0x24a19947, 0xb3916cf7,
        0x0801f2e2, 0x858efc16, 0x636920d8, 0x71574e69, 0xa458fea3,
        0xf4933d7e, 0x0d95748f, 0x728eb658, 0x718bcd58, 0x82154aee,
        0x7b54a41d, 0xc25a59b5, 0x9c30d539, 0x2af26013, 0xc5d1b023,
        0x286085f0, 0xca417918, 0xb8db38ef, 0x8e79dcb0, 0x603a180e,
        0x6c9e0e8b, 0xb01e8a3e, 0xd71577c1, 0xbd314b27, 0x78af2fda,
        0x55605c60, 0xe65525f3, 0xaa55ab94, 0x57489862, 0x63e81440,
        0x55ca396a, 0x2aab10b6, 0xb4cc5c34, 0x1141e8ce, 0xa15486af,
        0x7c72e993, 0xb3ee1411, 0x636fbc2a, 0x2ba9c55d, 0x741831f6,
        0xce5c3e16, 0x9b87931e, 0xafd6ba33, 0x6c24cf5c, 0x7a325381,
        0x28958677, 0x3b8f4898, 0x6b4bb9af, 0xc4bfe81b, 0x66282193,
        0x61d809cc, 0xfb21a991, 0x487cac60, 0x5dec8032, 0xef845d5d,
        0xe98575b1, 0xdc262302, 0xeb651b88, 0x23893e81, 0xd396acc5,
        0x0f6d6ff3, 0x83f44239, 0x2e0b4482, 0xa4842004, 0x69c8f04a,
        0x9e1f9b5e, 0x21c66842, 0xf6e96c9a, 0x670c9c61, 0xabd388f0,
        0x6a51a0d2, 0xd8542f68, 0x960fa728, 0xab5133a3, 0x6eef0b6c,
        0x137a3be4, 0xba3bf050, 0x7efb2a98, 0xa1f1651d, 0x39af0176,
        0x66ca593e, 0x82430e88, 0x8cee8619, 0x456f9fb4, 0x7d84a5c3,
        0x3b8b5ebe, 0xe06f75d8, 0x85c12073, 0x401a449f, 0x56c16aa6,
        0x4ed3aa62, 0x363f7706, 0x1bfedf72, 0x429b023d, 0x37d0d724,
        0xd00a1248, 0xdb0fead3, 0x49f1c09b, 0x075372c9, 0x80991b7b,
        0x25d479d8, 0xf6e8def7, 0xe3fe501a, 0xb6794c3b, 0x976ce0bd,
        0x04c006ba, 0xc1a94fb6, 0x409f60c4, 0x5e5c9ec2, 0x196a2463,
        0x68fb6faf, 0x3e6c53b5, 0x1339b2eb, 0x3b52ec6f, 0x6dfc511f,
        0x9b30952c, 0xcc814544, 0xaf5ebd09, 0xbee3d004, 0xde334afd,
        0x660f2807, 0x192e4bb3, 0xc0cba857, 0x45c8740f, 0xd20b5f39,
        0xb9d3fbdb, 0x5579c0bd, 0x1a60320a, 0xd6a100c6, 0x402c7279,
        0x679f25fe, 0xfb1fa3cc, 0x8ea5e9f8, 0xdb3222f8, 0x3c7516df,
        0xfd616b15, 0x2f501ec8, 0xad0552ab, 0x323db5fa, 0xfd238760,
        0x53317b48, 0x3e00df82, 0x9e5c57bb, 0xca6f8ca0, 0x1a87562e,
        0xdf1769db, 0xd542a8f6, 0x287effc3, 0xac6732c6, 0x8c4f5573,
        0x695b27b0, 0xbbca58c8, 0xe1ffa35d, 0xb8f011a0, 0x10fa3d98,
        0xfd2183b8, 0x4afcb56c, 0x2dd1d35b, 0x9a53e479, 0xb6f84565,
        0xd28e49bc, 0x4bfb9790, 0xe1ddf2da, 0xa4cb7e33, 0x62fb1341,
        0xcee4c6e8, 0xef20cada, 0x36774c01, 0xd07e9efe, 0x2bf11fb4,
        0x95dbda4d, 0xae909198, 0xeaad8e71, 0x6b93d5a0, 0xd08ed1d0,
        0xafc725e0, 0x8e3c5b2f, 0x8e7594b7, 0x8ff6e2fb, 0xf2122b64,
        0x8888b812, 0x900df01c, 0x4fad5ea0, 0x688fc31c, 0xd1cff191,
        0xb3a8c1ad, 0x2f2f2218, 0xbe0e1777, 0xea752dfe, 0x8b021fa1,
        0xe5a0cc0f, 0xb56f74e8, 0x18acf3d6, 0xce89e299, 0xb4a84fe0,
        0xfd13e0b7, 0x7cc43b81, 0xd2ada8d9, 0x165fa266, 0x80957705,
        0x93cc7314, 0x211a1477, 0xe6ad2065, 0x77b5fa86, 0xc75442f5,
        0xfb9d35cf, 0xebcdaf0c, 0x7b3e89a0, 0xd6411bd3, 0xae1e7e49,
        0x00250e2d, 0x2071b35e, 0x226800bb, 0x57b8e0af, 0x2464369b,
        0xf009b91e, 0x5563911d, 0x59dfa6aa, 0x78c14389, 0xd95a537f,
        0x207d5ba2, 0x02e5b9c5, 0x83260376, 0x6295cfa9, 0x11c81968,
        0x4e734a41, 0xb3472dca, 0x7b14a94a, 0x1b510052, 0x9a532915,
        0xd60f573f, 0xbc9bc6e4, 0x2b60a476, 0x81e67400, 0x08ba6fb5,
        0x571be91f, 0xf296ec6b, 0x2a0dd915, 0xb6636521, 0xe7b9f9b6,
        0xff34052e, 0xc5855664, 0x53b02d5d, 0xa99f8fa1, 0x08ba4799,
        0x6e85076a, 0x4b7a70e9, 0xb5b32944, 0xdb75092e, 0xc4192623,
        0xad6ea6b0, 0x49a7df7d, 0x9cee60b8, 0x8fedb266, 0xecaa8c71,
        0x699a17ff, 0x5664526c, 0xc2b19ee1, 0x193602a5, 0x75094c29,
        0xa0591340, 0xe4183a3e, 0x3f54989a, 0x5b429d65, 0x6b8fe4d6,
        0x99f73fd6, 0xa1d29c07, 0xefe830f5, 0x4d2d38e6, 0xf0255dc1,
        0x4cdd2086, 0x8470eb26, 0x6382e9c6, 0x021ecc5e, 0x09686b3f,
        0x3ebaefc9, 0x3c971814, 0x6b6a70a1, 0x687f3584, 0x52a0e286,
        0xb79c5305, 0xaa500737, 0x3e07841c, 0x7fdeae5c, 0x8e7d44ec,
        0x5716f2b8, 0xb03ada37, 0xf0500c0d, 0xf01c1f04, 0x0200b3ff,
        0xae0cf51a, 0x3cb574b2, 0x25837a58, 0xdc0921bd, 0xd19113f9,
        0x7ca92ff6, 0x94324773, 0x22f54701, 0x3ae5e581, 0x37c2dadc,
        0xc8b57634, 0x9af3dda7, 0xa9446146, 0x0fd0030e, 0xecc8c73e,
        0xa4751e41, 0xe238cd99, 0x3bea0e2f, 0x3280bba1, 0x183eb331,
        0x4e548b38, 0x4f6db908, 0x6f420d03, 0xf60a04bf, 0x2cb81290,
        0x24977c79, 0x5679b072, 0xbcaf89af, 0xde9a771f, 0xd9930810,
        0xb38bae12, 0xdccf3f2e, 0x5512721f, 0x2e6b7124, 0x501adde6,
        0x9f84cd87, 0x7a584718, 0x7408da17, 0xbc9f9abc, 0xe94b7d8c,
        0xec7aec3a, 0xdb851dfa, 0x63094366, 0xc464c3d2, 0xef1c1847,
        0x3215d908, 0xdd433b37, 0x24c2ba16, 0x12a14d43, 0x2a65c451,
        0x50940002, 0x133ae4dd, 0x71dff89e, 0x10314e55, 0x81ac77d6,
        0x5f11199b, 0x043556f1, 0xd7a3c76b, 0x3c11183b, 0x5924a509,
        0xf28fe6ed, 0x97f1fbfa, 0x9ebabf2c, 0x1e153c6e, 0x86e34570,
        0xeae96fb1, 0x860e5e0a, 0x5a3e2ab3, 0x771fe71c, 0x4e3d06fa,
        0x2965dcb9, 0x99e71d0f, 0x803e89d6, 0x5266c825, 0x2e4cc978,
        0x9c10b36a, 0xc6150eba, 0x94e2ea78, 0xa5fc3c53, 0x1e0a2df4,
        0xf2f74ea7, 0x361d2b3d, 0x1939260f, 0x19c27960, 0x5223a708,
        0xf71312b6, 0xebadfe6e, 0xeac31f66, 0xe3bc4595, 0xa67bc883,
        0xb17f37d1, 0x018cff28, 0xc332ddef, 0xbe6c5aa5, 0x65582185,
        0x68ab9802, 0xeecea50f, 0xdb2f953b, 0x2aef7dad, 0x5b6e2f84,
        0x1521b628, 0x29076170, 0xecdd4775, 0x619f1510, 0x13cca830,
        0xeb61bd96, 0x0334fe1e, 0xaa0363cf, 0xb5735c90, 0x4c70a239,
        0xd59e9e0b, 0xcbaade14, 0xeecc86bc, 0x60622ca7, 0x9cab5cab,
        0xb2f3846e, 0x648b1eaf, 0x19bdf0ca, 0xa02369b9, 0x655abb50,
        0x40685a32, 0x3c2ab4b3, 0x319ee9d5, 0xc021b8f7, 0x9b540b19,
        0x875fa099, 0x95f7997e, 0x623d7da8, 0xf837889a, 0x97e32d77,
        0x11ed935f, 0x16681281, 0x0e358829, 0xc7e61fd6, 0x96dedfa1,
        0x7858ba99, 0x57f584a5, 0x1b227263, 0x9b83c3ff, 0x1ac24696,
        0xcdb30aeb, 0x532e3054, 0x8fd948e4, 0x6dbc3128, 0x58ebf2ef,
        0x34c6ffea, 0xfe28ed61, 0xee7c3c73, 0x5d4a14d9, 0xe864b7e3,
        0x42105d14, 0x203e13e0, 0x45eee2b6, 0xa3aaabea, 0xdb6c4f15,
        0xfacb4fd0, 0xc742f442, 0xef6abbb5, 0x654f3b1d, 0x41cd2105,
        0xd81e799e, 0x86854dc7, 0xe44b476a, 0x3d816250, 0xcf62a1f2,
        0x5b8d2646, 0xfc8883a0, 0xc1c7b6a3, 0x7f1524c3, 0x69cb7492,
        0x47848a0b, 0x5692b285, 0x095bbf00, 0xad19489d, 0x1462b174,
        0x23820e00, 0x58428d2a, 0x0c55f5ea, 0x1dadf43e, 0x233f7061,
        0x3372f092, 0x8d937e41, 0xd65fecf1, 0x6c223bdb, 0x7cde3759,
        0xcbee7460, 0x4085f2a7, 0xce77326e, 0xa6078084, 0x19f8509e,
        0xe8efd855, 0x61d99735, 0xa969a7aa, 0xc50c06c2, 0x5a04abfc,
        0x800bcadc, 0x9e447a2e, 0xc3453484, 0xfdd56705, 0x0e1e9ec9,
        0xdb73dbd3, 0x105588cd, 0x675fda79, 0xe3674340, 0xc5c43465,
        0x713e38d8, 0x3d28f89e, 0xf16dff20, 0x153e21e7, 0x8fb03d4a,
        0xe6e39f2b, 0xdb83adf7, 0xe93d5a68, 0x948140f7, 0xf64c261c,
        0x94692934, 0x411520f7, 0x7602d4f7, 0xbcf46b2e, 0xd4a20068,
        0xd4082471, 0x3320f46a, 0x43b7d4b7, 0x500061af, 0x1e39f62e,
        0x97244546, 0x14214f74, 0xbf8b8840, 0x4d95fc1d, 0x96b591af,
        0x70f4ddd3, 0x66a02f45, 0xbfbc09ec, 0x03bd9785, 0x7fac6dd0,
        0x31cb8504, 0x96eb27b3, 0x55fd3941, 0xda2547e6, 0xabca0a9a,
        0x28507825, 0x530429f4, 0x0a2c86da, 0xe9b66dfb, 0x68dc1462,
        0xd7486900, 0x680ec0a4, 0x27a18dee, 0x4f3ffea2, 0xe887ad8c,
        0xb58ce006, 0x7af4d6b6, 0xaace1e7c, 0xd3375fec, 0xce78a399,
        0x406b2a42, 0x20fe9e35, 0xd9f385b9, 0xee39d7ab, 0x3b124e8b,
        0x1dc9faf7, 0x4b6d1856, 0x26a36631, 0xeae397b2, 0x3a6efa74,
        0xdd5b4332, 0x6841e7f7, 0xca7820fb, 0xfb0af54e, 0xd8feb397,
        0x454056ac, 0xba489527, 0x55533a3a, 0x20838d87, 0xfe6ba9b7,
        0xd096954b, 0x55a867bc, 0xa1159a58, 0xcca92963, 0x99e1db33,
        0xa62a4a56, 0x3f3125f9, 0x5ef47e1c, 0x9029317c, 0xfdf8e802,
        0x04272f70, 0x80bb155c, 0x05282ce3, 0x95c11548, 0xe4c66d22,
        0x48c1133f, 0xc70f86dc, 0x07f9c9ee, 0x41041f0f, 0x404779a4,
        0x5d886e17, 0x325f51eb, 0xd59bc0d1, 0xf2bcc18f, 0x41113564,
        0x257b7834, 0x602a9c60, 0xdff8e8a3, 0x1f636c1b, 0x0e12b4c2,
        0x02e1329e, 0xaf664fd1, 0xcad18115, 0x6b2395e0, 0x333e92e1,
        0x3b240b62, 0xeebeb922, 0x85b2a20e, 0xe6ba0d99, 0xde720c8c,
        0x2da2f728, 0xd0127845, 0x95b794fd, 0x647d0862, 0xe7ccf5f0,
        0x5449a36f, 0x877d48fa, 0xc39dfd27, 0xf33e8d1e, 0x0a476341,
        0x992eff74, 0x3a6f6eab, 0xf4f8fd37, 0xa812dc60, 0xa1ebddf8,
        0x991be14c, 0xdb6e6b0d, 0xc67b5510, 0x6d672c37, 0x2765d43b,
        0xdcd0e804, 0xf1290dc7, 0xcc00ffa3, 0xb5390f92, 0x690fed0b,
        0x667b9ffb, 0xcedb7d9c, 0xa091cf0b, 0xd9155ea3, 0xbb132f88,
        0x515bad24, 0x7b9479bf, 0x763bd6eb, 0x37392eb3, 0xcc115979,
        0x8026e297, 0xf42e312d, 0x6842ada7, 0xc66a2b3b, 0x12754ccc,
        0x782ef11c, 0x6a124237, 0xb79251e7, 0x06a1bbe6, 0x4bfb6350,
        0x1a6b1018, 0x11caedfa, 0x3d25bdd8, 0xe2e1c3c9, 0x44421659,
        0x0a121386, 0xd90cec6e, 0xd5abea2a, 0x64af674e, 0xda86a85f,
        0xbebfe988, 0x64e4c3fe, 0x9dbc8057, 0xf0f7c086, 0x60787bf8,
        0x6003604d, 0xd1fd8346, 0xf6381fb0, 0x7745ae04, 0xd736fccc,
        0x83426b33, 0xf01eab71, 0xb0804187, 0x3c005e5f, 0x77a057be,
        0xbde8ae24, 0x55464299, 0xbf582e61, 0x4e58f48f, 0xf2ddfda2,
        0xf474ef38, 0x8789bdc2, 0x5366f9c3, 0xc8b38e74, 0xb475f255,
        0x46fcd9b9, 0x7aeb2661, 0x8b1ddf84, 0x846a0e79, 0x915f95e2,
        0x466e598e, 0x20b45770, 0x8cd55591, 0xc902de4c, 0xb90bace1,
        0xbb8205d0, 0x11a86248, 0x7574a99e, 0xb77f19b6, 0xe0a9dc09,
        0x662d09a1, 0xc4324633, 0xe85a1f02, 0x09f0be8c, 0x4a99a025,
        0x1d6efe10, 0x1ab93d1d, 0x0ba5a4df, 0xa186f20f, 0x2868f169,
        0xdcb7da83, 0x573906fe, 0xa1e2ce9b, 0x4fcd7f52, 0x50115e01,
        0xa70683fa, 0xa002b5c4, 0x0de6d027, 0x9af88c27, 0x773f8641,
        0xc3604c06, 0x61a806b5, 0xf0177a28, 0xc0f586e0, 0x006058aa,
        0x30dc7d62, 0x11e69ed7, 0x2338ea63, 0x53c2dd94, 0xc2c21634,
        0xbbcbee56, 0x90bcb6de, 0xebfc7da1, 0xce591d76, 0x6f05e409,
        0x4b7c0188, 0x39720a3d, 0x7c927c24, 0x86e3725f, 0x724d9db9,
        0x1ac15bb4, 0xd39eb8fc, 0xed545578, 0x08fca5b5, 0xd83d7cd3,
        0x4dad0fc4, 0x1e50ef5e, 0xb161e6f8, 0xa28514d9, 0x6c51133c,
        0x6fd5c7e7, 0x56e14ec4, 0x362abfce, 0xddc6c837, 0xd79a3234,
        0x92638212, 0x670efa8e, 0x406000e0, 0x3a39ce37, 0xd3faf5cf,
        0xabc27737, 0x5ac52d1b, 0x5cb0679e, 0x4fa33742, 0xd3822740,
        0x99bc9bbe, 0xd5118e9d, 0xbf0f7315, 0xd62d1c7e, 0xc700c47b,
        0xb78c1b6b, 0x21a19045, 0xb26eb1be, 0x6a366eb4, 0x5748ab2f,
        0xbc946e79, 0xc6a376d2, 0x6549c2c8, 0x530ff8ee, 0x468dde7d,
        0xd5730a1d, 0x4cd04dc6, 0x2939bbdb, 0xa9ba4650, 0xac9526e8,
        0xbe5ee304, 0xa1fad5f0, 0x6a2d519a, 0x63ef8ce2, 0x9a86ee22,
        0xc089c2b8, 0x43242ef6, 0xa51e03aa, 0x9cf2d0a4, 0x83c061ba,
        0x9be96a4d, 0x8fe51550, 0xba645bd6, 0x2826a2f9, 0xa73a3ae1,
        0x4ba99586, 0xef5562e9, 0xc72fefd3, 0xf752f7da, 0x3f046f69,
        0x77fa0a59, 0x80e4a915, 0x87b08601, 0x9b09e6ad, 0x3b3ee593,
        0xe990fd5a, 0x9e34d797, 0x2cf0b7d9, 0x022b8b51, 0x96d5ac3a,
        0x017da67d, 0xd1cf3ed6, 0x7c7d2d28, 0x1f9f25cf, 0xadf2b89b,
        0x5ad6b472, 0x5a88f54c, 0xe029ac71, 0xe019a5e6, 0x47b0acfd,
        0xed93fa9b, 0xe8d3c48d, 0x283b57cc, 0xf8d56629, 0x79132e28,
        0x785f0191, 0xed756055, 0xf7960e44, 0xe3d35e8c, 0x15056dd4,
        0x88f46dba, 0x03a16125, 0x0564f0bd, 0xc3eb9e15, 0x3c9057a2,
        0x97271aec, 0xa93a072a, 0x1b3f6d9b, 0x1e6321f5, 0xf59c66fb,
        0x26dcf319, 0x7533d928, 0xb155fdf5, 0x03563482, 0x8aba3cbb,
        0x28517711, 0xc20ad9f8, 0xabcc5167, 0xccad925f, 0x4de81751,
        0x3830dc8e, 0x379d5862, 0x9320f991, 0xea7a90c2, 0xfb3e7bce,
        0x5121ce64, 0x774fbe32, 0xa8b6e37e, 0xc3293d46, 0x48de5369,
        0x6413e680, 0xa2ae0810, 0xdd6db224, 0x69852dfd, 0x09072166,
        0xb39a460a, 0x6445c0dd, 0x586cdecf, 0x1c20c8ae, 0x5bbef7dd,
        0x1b588d40, 0xccd2017f, 0x6bb4e3bb, 0xdda26a7e, 0x3a59ff45,
        0x3e350a44, 0xbcb4cdd5, 0x72eacea8, 0xfa6484bb, 0x8d6612ae,
        0xbf3c6f47, 0xd29be463, 0x542f5d9e, 0xaec2771b, 0xf64e6370,
        0x740e0d8d, 0xe75b1357, 0xf8721671, 0xaf537d5d, 0x4040cb08,
        0x4eb4e2cc, 0x34d2466a, 0x0115af84, 0xe1b00428, 0x95983a1d,
        0x06b89fb4, 0xce6ea048, 0x6f3f3b82, 0x3520ab82, 0x011a1d4b,
        0x277227f8, 0x611560b1, 0xe7933fdc, 0xbb3a792b, 0x344525bd,
        0xa08839e1, 0x51ce794b, 0x2f32c9b7, 0xa01fbac9, 0xe01cc87e,
        0xbcc7d1f6, 0xcf0111c3, 0xa1e8aac7, 0x1a908749, 0xd44fbd9a,
        0xd0dadecb, 0xd50ada38, 0x0339c32a, 0xc6913667, 0x8df9317c,
        0xe0b12b4f, 0xf79e59b7, 0x43f5bb3a, 0xf2d519ff, 0x27d9459c,
        0xbf97222c, 0x15e6fc2a, 0x0f91fc71, 0x9b941525, 0xfae59361,
        0xceb69ceb, 0xc2a86459, 0x12baa8d1, 0xb6c1075e, 0xe3056a0c,
        0x10d25065, 0xcb03a442, 0xe0ec6e0e, 0x1698db3b, 0x4c98a0be,
        0x3278e964, 0x9f1f9532, 0xe0d392df, 0xd3a0342b, 0x8971f21e,
        0x1b0a7441, 0x4ba3348c, 0xc5be7120, 0xc37632d8, 0xdf359f8d,
        0x9b992f2e, 0xe60b6f47, 0x0fe3f11d, 0xe54cda54, 0x1edad891,
        0xce6279cf, 0xcd3e7e6f, 0x1618b166, 0xfd2c1d05, 0x848fd2c5,
        0xf6fb2299, 0xf523f357, 0xa6327623, 0x93a83531, 0x56cccd02,
        0xacf08162, 0x5a75ebb5, 0x6e163697, 0x88d273cc, 0xde966292,
        0x81b949d0, 0x4c50901b, 0x71c65614, 0xe6c6c7bd, 0x327a140a,
        0x45e1d006, 0xc3f27b9a, 0xc9aa53fd, 0x62a80f00, 0xbb25bfe2,
        0x35bdd2f6, 0x71126905, 0xb2040222, 0xb6cbcf7c, 0xcd769c2b,
        0x53113ec0, 0x1640e3d3, 0x38abbd60, 0x2547adf0, 0xba38209c,
        0xf746ce76, 0x77afa1c5, 0x20756060, 0x85cbfe4e, 0x8ae88dd8,
        0x7aaaf9b0, 0x4cf9aa7e, 0x1948c25c, 0x02fb8a8c, 0x01c36ae4,
        0xd6ebe1f9, 0x90d4f869, 0xa65cdea0, 0x3f09252d, 0xc208e69f,
        0xb74e6132, 0xce77e25b, 0x578fdfe3, 0x3ac372e6
    ];

    /**
     * @type {Array.<number>}
     * @const
     * @inner
     */
    var C_ORIG = [
        0x4f727068, 0x65616e42, 0x65686f6c, 0x64657253, 0x63727944,
        0x6f756274
    ];

    /**
     * @param {Array.<number>} lr
     * @param {number} off
     * @param {Array.<number>} P
     * @param {Array.<number>} S
     * @returns {Array.<number>}
     * @inner
     */
    function _encipher(lr, off, P, S) { // This is our bottleneck: 1714/1905 ticks / 90% - see profile.txt
        var n,
            l = lr[off],
            r = lr[off + 1];

        l ^= P[0];

        /*
        for (var i=0, k=BLOWFISH_NUM_ROUNDS-2; i<=k;)
            // Feistel substitution on left word
            n  = S[l >>> 24],
            n += S[0x100 | ((l >> 16) & 0xff)],
            n ^= S[0x200 | ((l >> 8) & 0xff)],
            n += S[0x300 | (l & 0xff)],
            r ^= n ^ P[++i],
            // Feistel substitution on right word
            n  = S[r >>> 24],
            n += S[0x100 | ((r >> 16) & 0xff)],
            n ^= S[0x200 | ((r >> 8) & 0xff)],
            n += S[0x300 | (r & 0xff)],
            l ^= n ^ P[++i];
        */

        //The following is an unrolled version of the above loop.
        //Iteration 0
        n  = S[l >>> 24];
        n += S[0x100 | ((l >> 16) & 0xff)];
        n ^= S[0x200 | ((l >> 8) & 0xff)];
        n += S[0x300 | (l & 0xff)];
        r ^= n ^ P[1];
        n  = S[r >>> 24];
        n += S[0x100 | ((r >> 16) & 0xff)];
        n ^= S[0x200 | ((r >> 8) & 0xff)];
        n += S[0x300 | (r & 0xff)];
        l ^= n ^ P[2];
        //Iteration 1
        n  = S[l >>> 24];
        n += S[0x100 | ((l >> 16) & 0xff)];
        n ^= S[0x200 | ((l >> 8) & 0xff)];
        n += S[0x300 | (l & 0xff)];
        r ^= n ^ P[3];
        n  = S[r >>> 24];
        n += S[0x100 | ((r >> 16) & 0xff)];
        n ^= S[0x200 | ((r >> 8) & 0xff)];
        n += S[0x300 | (r & 0xff)];
        l ^= n ^ P[4];
        //Iteration 2
        n  = S[l >>> 24];
        n += S[0x100 | ((l >> 16) & 0xff)];
        n ^= S[0x200 | ((l >> 8) & 0xff)];
        n += S[0x300 | (l & 0xff)];
        r ^= n ^ P[5];
        n  = S[r >>> 24];
        n += S[0x100 | ((r >> 16) & 0xff)];
        n ^= S[0x200 | ((r >> 8) & 0xff)];
        n += S[0x300 | (r & 0xff)];
        l ^= n ^ P[6];
        //Iteration 3
        n  = S[l >>> 24];
        n += S[0x100 | ((l >> 16) & 0xff)];
        n ^= S[0x200 | ((l >> 8) & 0xff)];
        n += S[0x300 | (l & 0xff)];
        r ^= n ^ P[7];
        n  = S[r >>> 24];
        n += S[0x100 | ((r >> 16) & 0xff)];
        n ^= S[0x200 | ((r >> 8) & 0xff)];
        n += S[0x300 | (r & 0xff)];
        l ^= n ^ P[8];
        //Iteration 4
        n  = S[l >>> 24];
        n += S[0x100 | ((l >> 16) & 0xff)];
        n ^= S[0x200 | ((l >> 8) & 0xff)];
        n += S[0x300 | (l & 0xff)];
        r ^= n ^ P[9];
        n  = S[r >>> 24];
        n += S[0x100 | ((r >> 16) & 0xff)];
        n ^= S[0x200 | ((r >> 8) & 0xff)];
        n += S[0x300 | (r & 0xff)];
        l ^= n ^ P[10];
        //Iteration 5
        n  = S[l >>> 24];
        n += S[0x100 | ((l >> 16) & 0xff)];
        n ^= S[0x200 | ((l >> 8) & 0xff)];
        n += S[0x300 | (l & 0xff)];
        r ^= n ^ P[11];
        n  = S[r >>> 24];
        n += S[0x100 | ((r >> 16) & 0xff)];
        n ^= S[0x200 | ((r >> 8) & 0xff)];
        n += S[0x300 | (r & 0xff)];
        l ^= n ^ P[12];
        //Iteration 6
        n  = S[l >>> 24];
        n += S[0x100 | ((l >> 16) & 0xff)];
        n ^= S[0x200 | ((l >> 8) & 0xff)];
        n += S[0x300 | (l & 0xff)];
        r ^= n ^ P[13];
        n  = S[r >>> 24];
        n += S[0x100 | ((r >> 16) & 0xff)];
        n ^= S[0x200 | ((r >> 8) & 0xff)];
        n += S[0x300 | (r & 0xff)];
        l ^= n ^ P[14];
        //Iteration 7
        n  = S[l >>> 24];
        n += S[0x100 | ((l >> 16) & 0xff)];
        n ^= S[0x200 | ((l >> 8) & 0xff)];
        n += S[0x300 | (l & 0xff)];
        r ^= n ^ P[15];
        n  = S[r >>> 24];
        n += S[0x100 | ((r >> 16) & 0xff)];
        n ^= S[0x200 | ((r >> 8) & 0xff)];
        n += S[0x300 | (r & 0xff)];
        l ^= n ^ P[16];

        lr[off] = r ^ P[BLOWFISH_NUM_ROUNDS + 1];
        lr[off + 1] = l;
        return lr;
    }

    /**
     * @param {Array.<number>} data
     * @param {number} offp
     * @returns {{key: number, offp: number}}
     * @inner
     */
    function _streamtoword(data, offp) {
        for (var i = 0, word = 0; i < 4; ++i)
            word = (word << 8) | (data[offp] & 0xff),
            offp = (offp + 1) % data.length;
        return { key: word, offp: offp };
    }

    /**
     * @param {Array.<number>} key
     * @param {Array.<number>} P
     * @param {Array.<number>} S
     * @inner
     */
    function _key(key, P, S) {
        var offset = 0,
            lr = [0, 0],
            plen = P.length,
            slen = S.length,
            sw;
        for (var i = 0; i < plen; i++)
            sw = _streamtoword(key, offset),
            offset = sw.offp,
            P[i] = P[i] ^ sw.key;
        for (i = 0; i < plen; i += 2)
            lr = _encipher(lr, 0, P, S),
            P[i] = lr[0],
            P[i + 1] = lr[1];
        for (i = 0; i < slen; i += 2)
            lr = _encipher(lr, 0, P, S),
            S[i] = lr[0],
            S[i + 1] = lr[1];
    }

    /**
     * Expensive key schedule Blowfish.
     * @param {Array.<number>} data
     * @param {Array.<number>} key
     * @param {Array.<number>} P
     * @param {Array.<number>} S
     * @inner
     */
    function _ekskey(data, key, P, S) {
        var offp = 0,
            lr = [0, 0],
            plen = P.length,
            slen = S.length,
            sw;
        for (var i = 0; i < plen; i++)
            sw = _streamtoword(key, offp),
            offp = sw.offp,
            P[i] = P[i] ^ sw.key;
        offp = 0;
        for (i = 0; i < plen; i += 2)
            sw = _streamtoword(data, offp),
            offp = sw.offp,
            lr[0] ^= sw.key,
            sw = _streamtoword(data, offp),
            offp = sw.offp,
            lr[1] ^= sw.key,
            lr = _encipher(lr, 0, P, S),
            P[i] = lr[0],
            P[i + 1] = lr[1];
        for (i = 0; i < slen; i += 2)
            sw = _streamtoword(data, offp),
            offp = sw.offp,
            lr[0] ^= sw.key,
            sw = _streamtoword(data, offp),
            offp = sw.offp,
            lr[1] ^= sw.key,
            lr = _encipher(lr, 0, P, S),
            S[i] = lr[0],
            S[i + 1] = lr[1];
    }

    /**
     * Internaly crypts a string.
     * @param {Array.<number>} b Bytes to crypt
     * @param {Array.<number>} salt Salt bytes to use
     * @param {number} rounds Number of rounds
     * @param {function(Error, Array.<number>=)=} callback Callback receiving the error, if any, and the resulting bytes. If
     *  omitted, the operation will be performed synchronously.
     *  @param {function(number)=} progressCallback Callback called with the current progress
     * @returns {!Array.<number>|undefined} Resulting bytes if callback has been omitted, otherwise `undefined`
     * @inner
     */
    function _crypt(b, salt, rounds, callback, progressCallback) {
        var cdata = C_ORIG.slice(),
            clen = cdata.length,
            err;

        // Validate
        if (rounds < 4 || rounds > 31) {
            err = Error("Illegal number of rounds (4-31): "+rounds);
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            } else
                throw err;
        }
        if (salt.length !== BCRYPT_SALT_LEN) {
            err =Error("Illegal salt length: "+salt.length+" != "+BCRYPT_SALT_LEN);
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            } else
                throw err;
        }
        rounds = (1 << rounds) >>> 0;

        var P, S, i = 0, j;

        //Use typed arrays when available - huge speedup!
        if (Int32Array) {
            P = new Int32Array(P_ORIG);
            S = new Int32Array(S_ORIG);
        } else {
            P = P_ORIG.slice();
            S = S_ORIG.slice();
        }

        _ekskey(salt, b, P, S);

        /**
         * Calcualtes the next round.
         * @returns {Array.<number>|undefined} Resulting array if callback has been omitted, otherwise `undefined`
         * @inner
         */
        function next() {
            if (progressCallback)
                progressCallback(i / rounds);
            if (i < rounds) {
                var start = Date.now();
                for (; i < rounds;) {
                    i = i + 1;
                    _key(b, P, S);
                    _key(salt, P, S);
                    if (Date.now() - start > MAX_EXECUTION_TIME)
                        break;
                }
            } else {
                for (i = 0; i < 64; i++)
                    for (j = 0; j < (clen >> 1); j++)
                        _encipher(cdata, j << 1, P, S);
                var ret = [];
                for (i = 0; i < clen; i++)
                    ret.push(((cdata[i] >> 24) & 0xff) >>> 0),
                    ret.push(((cdata[i] >> 16) & 0xff) >>> 0),
                    ret.push(((cdata[i] >> 8) & 0xff) >>> 0),
                    ret.push((cdata[i] & 0xff) >>> 0);
                if (callback) {
                    callback(null, ret);
                    return;
                } else
                    return ret;
            }
            if (callback)
                nextTick(next);
        }

        // Async
        if (typeof callback !== 'undefined') {
            next();

            // Sync
        } else {
            var res;
            while (true)
                if (typeof(res = next()) !== 'undefined')
                    return res || [];
        }
    }

    /**
     * Internally hashes a string.
     * @param {string} s String to hash
     * @param {?string} salt Salt to use, actually never null
     * @param {function(Error, string=)=} callback Callback receiving the error, if any, and the resulting hash. If omitted,
     *  hashing is perormed synchronously.
     *  @param {function(number)=} progressCallback Callback called with the current progress
     * @returns {string|undefined} Resulting hash if callback has been omitted, otherwise `undefined`
     * @inner
     */
    function _hash(s, salt, callback, progressCallback) {
        var err;
        if (typeof s !== 'string' || typeof salt !== 'string') {
            err = Error("Invalid string / salt: Not a string");
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            }
            else
                throw err;
        }

        // Validate the salt
        var minor, offset;
        if (salt.charAt(0) !== '$' || salt.charAt(1) !== '2') {
            err = Error("Invalid salt version: "+salt.substring(0,2));
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            }
            else
                throw err;
        }
        if (salt.charAt(2) === '$')
            minor = String.fromCharCode(0),
            offset = 3;
        else {
            minor = salt.charAt(2);
            if ((minor !== 'a' && minor !== 'b' && minor !== 'y') || salt.charAt(3) !== '$') {
                err = Error("Invalid salt revision: "+salt.substring(2,4));
                if (callback) {
                    nextTick(callback.bind(this, err));
                    return;
                } else
                    throw err;
            }
            offset = 4;
        }

        // Extract number of rounds
        if (salt.charAt(offset + 2) > '$') {
            err = Error("Missing salt rounds");
            if (callback) {
                nextTick(callback.bind(this, err));
                return;
            } else
                throw err;
        }
        var r1 = parseInt(salt.substring(offset, offset + 1), 10) * 10,
            r2 = parseInt(salt.substring(offset + 1, offset + 2), 10),
            rounds = r1 + r2,
            real_salt = salt.substring(offset + 3, offset + 25);
        s += minor >= 'a' ? "\x00" : "";

        var passwordb = stringToBytes(s),
            saltb = base64_decode(real_salt, BCRYPT_SALT_LEN);

        /**
         * Finishes hashing.
         * @param {Array.<number>} bytes Byte array
         * @returns {string}
         * @inner
         */
        function finish(bytes) {
            var res = [];
            res.push("$2");
            if (minor >= 'a')
                res.push(minor);
            res.push("$");
            if (rounds < 10)
                res.push("0");
            res.push(rounds.toString());
            res.push("$");
            res.push(base64_encode(saltb, saltb.length));
            res.push(base64_encode(bytes, C_ORIG.length * 4 - 1));
            return res.join('');
        }

        // Sync
        if (typeof callback == 'undefined')
            return finish(_crypt(passwordb, saltb, rounds));

        // Async
        else {
            _crypt(passwordb, saltb, rounds, function(err, bytes) {
                if (err)
                    callback(err, null);
                else
                    callback(null, finish(bytes));
            }, progressCallback);
        }
    }

    /**
     * Encodes a byte array to base64 with up to len bytes of input, using the custom bcrypt alphabet.
     * @function
     * @param {!Array.<number>} b Byte array
     * @param {number} len Maximum input length
     * @returns {string}
     * @expose
     */
    bcrypt.encodeBase64 = base64_encode;

    /**
     * Decodes a base64 encoded string to up to len bytes of output, using the custom bcrypt alphabet.
     * @function
     * @param {string} s String to decode
     * @param {number} len Maximum output length
     * @returns {!Array.<number>}
     * @expose
     */
    bcrypt.decodeBase64 = base64_decode;

    return bcrypt;
}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("3IRH")(module), __webpack_require__("W2nU"), __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "vugd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);





var Reporter = __webpack_require__("16On").Reporter;
var EncoderBuffer = __webpack_require__("iTY7").EncoderBuffer;
var DecoderBuffer = __webpack_require__("iTY7").DecoderBuffer;
var assert = __webpack_require__("08Lv");

// Supported tags
var tags = ['seq', 'seqof', 'set', 'setof', 'objid', 'bool', 'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc', 'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str', 'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'];

// Public methods list
var methods = ['key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice', 'any', 'contains'].concat(tags);

// Overrided methods list
var overrided = ['_peekTag', '_decodeTag', '_use', '_decodeStr', '_decodeObjid', '_decodeTime', '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList', '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime', '_encodeNull', '_encodeInt', '_encodeBool'];

function Node(enc, parent, name) {
  var state = {};
  this._baseState = state;

  state.name = name;
  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = ['enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice', 'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit', 'implicit', 'contains'];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function (prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function (method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function (child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function (arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function (arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function (child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function (arg) {
      if ((typeof arg === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(arg)) !== 'object' || arg.constructor !== Object) return arg;

      var res = {};
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(arg).forEach(function (key) {
        if (key == (key | 0)) key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function (method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function (tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0) this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null) prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null) tag = state.explicit;else if (state.implicit !== null) tag = state.implicit;else if (state.tag !== null) tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null) this._decodeGeneric(state.tag, input, options);else this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present)) return present;
    }
  }

  // Push object on stack
  var prevObj = void 0;
  if (state.obj && present) prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit)) return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      var _save = void 0;
      if (state.any) _save = input.save();
      var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
      if (input.isError(body)) return body;

      if (state.any) result = input.raw(_save);else input = body;
    }

    if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any) {
      // no-op
    } else if (state.choice === null) {
      result = this._decodeGeneric(state.tag, input, options);
    } else {
      result = this._decodeChoice(input, options);
    }

    if (input.isError(result)) return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present) result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);else if (prevKey !== null) input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set') return null;
  if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);else if (tag === 'objid') return this._decodeObjid(input, null, null, options);else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);else if (tag === 'null_') return this._decodeNull(input, options);else if (tag === 'bool') return this._decodeBool(input, options);else if (tag === 'objDesc') return this._decodeStr(input, tag, options);else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.choice).some(function (key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value)) return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match) return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data) return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined) return;

  if (this._skipDefault(result, reporter, parent)) return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null) return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null) data = state['default'];else return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function (child) {
      if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);

      if (child._baseState.key === null) return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if ((typeof data === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(data)) !== 'object') return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function (child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function (item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null) reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(false, data.type + ' not found in ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag)) return this._encodeStr(data, tag);else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);else if (tag === 'objid') return this._encodeObjid(data, null, null);else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);else if (tag === 'null_') return this._encodeNull();else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);else if (tag === 'bool') return this._encodeBool(data);else if (tag === 'objDesc') return this._encodeStr(data, tag);else throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return (/^[0-9 ]*$/.test(str)
  );
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return (/^[A-Za-z0-9 '()+,-./:=?]*$/.test(str)
  );
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("f1Eh")(module)))

/***/ }),

/***/ "vzCy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ "w2Cf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;
var Transform = __webpack_require__("Q51I");
__webpack_require__("LC74")(PassThrough, Transform);
function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);
  Transform.call(this, options);
}
PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),

/***/ "wCqX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var intersect = __webpack_require__("qmw1")["default"];

module.exports = function () {
  if (this.opts.filterable === true) {
    return this.opts.dateColumns;
  }

  if (this.opts.filterable === false) {
    return [];
  }

  return intersect(this.opts.filterable, this.opts.dateColumns);
};

/***/ }),

/***/ "wVHq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  var _this = this;

  if (this.opts.columnsDropdown) {
    var stopProp = function stopProp(e) {
      return e.stopPropagation();
    };

    var handler = function handler() {
      if (_this.displayColumnsDropdown) {
        _this.displayColumnsDropdown = false;
      }
    };

    this.$refs.columnsdropdown.addEventListener('click', stopProp);
    document.addEventListener('click', handler);
    this.$once('hook:beforeDestroy', function () {
      document.removeEventListener('click', handler);

      _this.$refs.columnsdropdown.removeEventListener('click', stopProp);
    });
  }
};

/***/ }),

/***/ "wWcv":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("hgbu")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "wXdB":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("+MZ2");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "wiaE":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("NZra");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "woOf":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("Eif7"), __esModule: true };

/***/ }),

/***/ "wrMp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("TkWM");
var BN = __webpack_require__("YP8Q");
var inherits = __webpack_require__("LC74");
var Base = __webpack_require__("B6Bn");

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),

/***/ "wvfG":
/***/ (function(module, exports, __webpack_require__) {

var Clipboard = __webpack_require__("W1rN") // FIXME: workaround for browserify

var VueClipboardConfig = {
  autoSetContainer: false,
  appendToBody: true // This fixes IE, see #50
}

var VueClipboard = {
  install: function (Vue) {
    var globalPrototype = Vue.version.slice(0, 2) === '3.' ? Vue.config.globalProperties : Vue.prototype
    globalPrototype.$clipboardConfig = VueClipboardConfig
    globalPrototype.$copyText = function (text, container) {
      return new Promise(function (resolve, reject) {
        var fakeElement = document.createElement('button')
        var clipboard = new Clipboard(fakeElement, {
          text: function () { return text },
          action: function () { return 'copy' },
          container: typeof container === 'object' ? container : document.body
        })
        clipboard.on('success', function (e) {
          clipboard.destroy()
          resolve(e)
        })
        clipboard.on('error', function (e) {
          clipboard.destroy()
          reject(e)
        })
        if (VueClipboardConfig.appendToBody) document.body.appendChild(fakeElement)
        fakeElement.click()
        if (VueClipboardConfig.appendToBody) document.body.removeChild(fakeElement)
      })
    }

    Vue.directive('clipboard', {
      bind: function (el, binding, vnode) {
        if (binding.arg === 'success') {
          el._vClipboard_success = binding.value
        } else if (binding.arg === 'error') {
          el._vClipboard_error = binding.value
        } else {
          var clipboard = new Clipboard(el, {
            text: function () { return binding.value },
            action: function () { return binding.arg === 'cut' ? 'cut' : 'copy' },
            container: VueClipboardConfig.autoSetContainer ? el : undefined
          })
          clipboard.on('success', function (e) {
            var callback = el._vClipboard_success
            callback && callback(e)
          })
          clipboard.on('error', function (e) {
            var callback = el._vClipboard_error
            callback && callback(e)
          })
          el._vClipboard = clipboard
        }
      },
      update: function (el, binding) {
        if (binding.arg === 'success') {
          el._vClipboard_success = binding.value
        } else if (binding.arg === 'error') {
          el._vClipboard_error = binding.value
        } else {
          el._vClipboard.text = function () { return binding.value }
          el._vClipboard.action = function () { return binding.arg === 'cut' ? 'cut' : 'copy' }
        }
      },
      unbind: function (el, binding) {
        // FIXME: investigate why $element._vClipboard was missing
        if (!el._vClipboard) return
        if (binding.arg === 'success') {
          delete el._vClipboard_success
        } else if (binding.arg === 'error') {
          delete el._vClipboard_error
        } else {
          el._vClipboard.destroy()
          delete el._vClipboard
        }
      }
    })
  },
  config: VueClipboardConfig
}

if (true) {
  module.exports = VueClipboard
} else if (typeof define === 'function' && define.amd) {
  define([], function () {
    return VueClipboard
  })
}


/***/ }),

/***/ "wxAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "wxv5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (page, preventRequest) {
  page = page ? page : this.$refs.page.value;
  if (!this.opts.pagination.dropdown) this.$refs.pagination.Page = page;
  this.page = page;
  this.updateState('page', page);
  if (this.source == 'server' && !preventRequest) this.getData();
};

/***/ }),

/***/ "x//u":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "x/31":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("gCWN");
__webpack_require__("tz60");
__webpack_require__("+3lO");
__webpack_require__("mgCp");
__webpack_require__("+GuK");
__webpack_require__("Nrqz");
module.exports = __webpack_require__("iANj").Promise;


/***/ }),

/***/ "x0Ha":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__("ypnx");
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err) {
      if (!this._writableState) {
        pna.nextTick(emitErrorNT, this, err);
      } else if (!this._writableState.errorEmitted) {
        this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, this, err);
      }
    }

    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      if (!_this._writableState) {
        pna.nextTick(emitErrorNT, _this, err);
      } else if (!_this._writableState.errorEmitted) {
        _this._writableState.errorEmitted = true;
        pna.nextTick(emitErrorNT, _this, err);
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finalCalled = false;
    this._writableState.prefinished = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),

/***/ "xLtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var transformData = __webpack_require__("TNV1");
var isCancel = __webpack_require__("pBtG");
var defaults = __webpack_require__("KCLY");
var isAbsoluteURL = __webpack_require__("dIwP");
var combineURLs = __webpack_require__("qRfI");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "xVc6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("qs+f");
var getKeys = __webpack_require__("pEGt");
var gOPS = __webpack_require__("THEY");
var pIE = __webpack_require__("bSeU");
var toObject = __webpack_require__("wXdB");
var IObject = __webpack_require__("wiaE");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("zyKz")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "xWCr":
/***/ (function(module, exports) {

module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};


/***/ }),

/***/ "xXuq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("vzCy").EventEmitter;


/***/ }),

/***/ "xZ+b":
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__("Wdy1");

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),

/***/ "xag9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(__webpack_require__("40O2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(self) {
  var state = {
    page: self.opts.initialPage ? self.opts.initialPage : 1,
    limit: self.opts.perPage,
    count: self.source == 'server' ? 0 : self.data.length,
    columns: self.columns,
    data: self.source == 'client' ? self.data : [],
    query: self.initQuery(),
    customQueries: self.initCustomFilters(),
    sortBy: self.opts.orderBy && self.opts.orderBy.column ? self.opts.orderBy.column : false,
    ascending: self.opts.orderBy && self.opts.orderBy.hasOwnProperty('ascending') ? self.opts.orderBy.ascending : true
  };

  if (typeof self.$store.state[self.name] !== 'undefined') {
    return (0, _merge["default"])(true, self.$store.state[self.name], state);
  }

  return state;
}

/***/ }),

/***/ "xd7m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (val) {
  return val && typeof val.isValid == 'function' && val.isValid();
};

/***/ }),

/***/ "xhre":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _bus = _interopRequireDefault(__webpack_require__("jlkA"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function () {
  var _this = this;

  var el;

  if (this.opts.destroyEventBus) {
    _bus["default"].$off();

    _bus["default"].$destroy();
  }

  if (this.vuex && !this.opts.preserveState) {
    this.$store.unregisterModule(this.name);
  }

  if (this.opts.filterByColumn) {
    this.datepickerColumns.forEach(function (column) {
      el = $(_this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter").data('daterangepicker');
      if (el) el.remove();
    });
  }
};

/***/ }),

/***/ "xuei":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _state = _interopRequireDefault(__webpack_require__("xag9"));

var _mutations = _interopRequireDefault(__webpack_require__("DY0S"));

var _merge = _interopRequireDefault(__webpack_require__("40O2"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (self) {
  var Module = {
    state: (0, _state["default"])(self),
    mutations: (0, _mutations["default"])(self)
  };

  if (self.$store && self.$store.state && self.$store.state[self.name]) {
    Module.state = _merge["default"].recursive(Module.state, self.$store.state[self.name]);
    self.$store.unregisterModule(self.name);
  }

  self.$store.registerModule(self.name, Module);
};

/***/ }),

/***/ "yASt":
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__("EuP9")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "yDvu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__("oNTk").Buffer
var Transform = __webpack_require__("dCRq").Transform
var inherits = __webpack_require__("LC74")

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),

/***/ "yEsh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__("K6ED");

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),

/***/ "yFbY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (data) {
  var _this = this;

  try {
    return data.map(function (row) {
      for (var column in row) {
        if (_this.source === 'client') row[column] = _this.formatDate(row[column], _this.dateFormat(column));

        if (_this.isListFilter(column) && !_this.opts.templates[column] && !_this.$scopedSlots[column]) {
          row[column] = _this.optionText(row[column], column);
        }
      }

      return row;
    });
  } catch (e) {
    console.error("vue-tables-2: non-iterable data property. Expected array, got ".concat(_typeof(data), ". Make sure that your response conforms to the expected format, or use the 'responseAdapter' option to match the currently returned format"));
    console.error('Data equals', data);
    throw new Error();
  }
};

/***/ }),

/***/ "yMmo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__("YP8Q");
var utils = __webpack_require__("TkWM");
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature) {
  return this.ec.verify(msg, signature, this);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),

/***/ "yYxz":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "ypnx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "yuYM":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("yYxz");
var ITERATOR = __webpack_require__("hgbu")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "z+8S":
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__("X3l8").Buffer
var Transform = __webpack_require__("9DG0").Transform
var StringDecoder = __webpack_require__("X4X3").StringDecoder
var inherits = __webpack_require__("LC74")

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),

/***/ "zECv":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__("8ANE");
var meta = __webpack_require__("+zJ9").onFreeze;

__webpack_require__("30vf")('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),

/***/ "zOO0":
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),

/***/ "zOyH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var merge = __webpack_require__("40O2");

module.exports = function () {
  if (typeof $ === 'undefined' || typeof $(this.$el).daterangepicker === 'undefined') {
    console.error('Date filters require jquery and daterangepicker');
    return;
  }

  var el;
  var that = this;
  var query = this.vuex ? JSON.parse(JSON.stringify(this.query)) : this.query;
  var columnOptions;
  var dpOptions;

  var search = function search(query, e) {
    return that.source == 'client' ? that.search(that.data, e) : that.serverSearch(query, e);
  };

  var datepickerOptions = merge.recursive(this.opts.datepickerOptions, {
    autoUpdateInput: false,
    singleDatePicker: false
  });
  that.datepickerColumns.forEach(function (column) {
    var range = that._getInitialDateRange(column);

    if (range) {
      that._setDatepickerText(column, range.start, range.end);

      range = {
        startDate: range.start,
        endDate: range.end
      };
    } else {
      range = {};
    }

    el = $(that.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter");
    columnOptions = typeof that.opts.datepickerPerColumnOptions[column] !== 'undefined' ? that.opts.datepickerPerColumnOptions[column] : {};
    columnOptions = merge.recursive(columnOptions, {
      locale: {
        format: that.dateFormat(column)
      }
    });
    dpOptions = merge(true, datepickerOptions);

    if (columnOptions.ranges === false) {
      dpOptions.ranges = {};
    }

    el.daterangepicker(merge.recursive(dpOptions, columnOptions, range));
    el.on('apply.daterangepicker', function (ev, picker) {
      query[column] = {
        start: picker.startDate.format('YYYY-MM-DD HH:mm:ss'),
        end: picker.endDate.format('YYYY-MM-DD HH:mm:ss')
      };
      if (!that.vuex) that.query = query;

      that._setDatepickerText(column, picker.startDate, picker.endDate);

      that.updateState('query', query);
      search(query, {
        target: {
          name: that._getColumnName(column),
          value: query[column]
        }
      });
    });
    el.on('cancel.daterangepicker', function (ev, picker) {
      query[column] = '';
      if (!that.vuex) that.query = query;
      picker.setStartDate(moment());
      picker.setEndDate(moment());
      that.updateState('query', query);
      $(this).html("<span class='VueTables__filter-placeholder'>" + that.display('filterBy', {
        column: that.getHeading(column)
      }) + "</span>");
      search(query, {
        target: {
          name: that._getColumnName(column),
          value: query[column]
        }
      });
    });
  });
};

/***/ }),

/***/ "zUbF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function () {
  return !this.opts.filterByColumn && (typeof this.opts.filterable === 'boolean' && this.opts.filterable || _typeof(this.opts.filterable) === 'object' && this.opts.filterable.length);
};

/***/ }),

/***/ "zvjZ":
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__("LC74")
var Hash = __webpack_require__("CzQx")
var Buffer = __webpack_require__("X3l8").Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),

/***/ "zwoO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),

/***/ "zyKz":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ })

});


// WEBPACK FOOTER //
// static/js/vendor.cc72f5fbc5cd8bdadaab.js